/**
 *
 * @param {*} array - The array that you want extract the index that references the element
 * @param {*} attr - The attr that identify the element
 * @param {*} value - The value of attr passed
 */

function findIndexByAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
            return i;
        }
    }
    return -1;
}

function getDomain(window) {
    if (window.location.hostname.includes('showkase.online')) {
        return '312782249584097';
    } else if (window.location.hostname.includes('localhost')) {
        return '312782249584097';
    }
     else {
        return '1927510520841177';
    }
}

function formatMoney(value, currencySymbol, c, d, t) {
    var n = value,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0,
        cs = currencySymbol || '';
    return cs + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

function getAllColorsToSearch() {
    return ['Amarelo', 'Azul', 'Bege', 'Bordô', 'Branco', 'Cinza', 'Dourado', 'Laranja', 'Lilás', 'Marrom', 'Prata', 'Preto', 'Rosa', 'Rose', 'Roxo', 'Salmão', 'Turquesa', 'Verde', 'Vermelho', 'Vinho',  'Violeta'];
}

function getAllColors() {
    return ['Amarelo', 'Azul', 'Azul Claro', 'Azul Escuro', 'Azul Marinho', 'Bege', 'Bordô', 'Branco', 'Cinza', 'Cinza Claro', 'Cinza Escuro', 'Dourado', 'Laranja', 'Lilás', 'Marrom', 'Marrom Claro', 'Prata', 'Preto', 'Rosa', 'Rosa Claro', 'Rosa Escuro', 'Rose', 'Roxo', 'Salmão', 'Turquesa', 'Verde', 'Verde Claro', 'Verde Escuro', 'Verde Musgo', 'Vermelho', 'Vinho'];
}

function getAllSizes() {
    var numberSizes = [];
    for(var i = 1; i <= 16; i++) {
        numberSizes.push(i.toString());
    }

    for(var j = 32; j <= 52; j+=2) {
        numberSizes.push(j.toString());
    }

    var literalSizes = ['U', 'PP', 'P', 'M', 'G', 'GG', 'XGG'];
    return numberSizes.concat(literalSizes);
}

function getClassicSizes() {
    return ['PP', 'P', 'P-M', 'M', 'G', 'GG', 'XG', 'U']
}

function getJuvenileChildSizes() {
    return ['RN', 'BB','1', '2','3', '4', '5', '6', '8', '10', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21',
        '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33'];
}

function getShortSizes() {
    return ['34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '46', '48', '50', '52', '54', '56'];
}

function getPlusSizes() {
    return ['G1','G2','G3','G4','G5','G+', 'XGGi', 'GI', 'M2', 'MI', 'P2', 'PI', 'XGG', 'XGI', 'EXG', 'EXX', 'GGI', 'XGGI', 'XP', '58', '60', '62', '68'];
}

function getOtherSizes() {
    return ['14-16', '15-18', '16-20', '17-18', '19-20', '19-22', '21-22', '21-25', '22-23', '22-25', '22-27', '23-24',
        '23-27', '24-25', '25-26', '26-30', '26-27', '26-29', '27-28', '28-31', '28-33', '29-30', '30-33', '31-32',
        '31-35', '32-35', '33-34', '34-36', '34-37', '34-39', '35-36', '35-39', '37-38', '37-39', '38-42', '39-40',
        '39-44', '40-44', '41-42', '42-45', '43-44'];
}

function getCurrencyListConfiguration() {
    return {
        LIBRA: {
            prefix: '£ ',
            centsSeparator: '.',
            thousandsSeparator: ',',
            key: 'LIBRA',
            text: 'Libra',
            decimalQuant: 2,
            mask: '#,##0.00',
            placeHolder: '0.00'
        },
        REAL: {
            prefix: 'R$ ',
            centsSeparator: ',',
            thousandsSeparator: '.',
            key: 'REAL',
            text: 'Real',
            decimalQuant: 2,
            mask: '#.##0,00',
            placeHolder: '0,00'
        },
        EURO: {
            prefix: '€ ',
            centsSeparator: ',',
            thousandsSeparator: '.',
            key: 'EURO',
            text: 'Euro',
            decimalQuant: 2,
            mask: '#.##0,00',
            placeHolder: '0,00'
        },
        DOLLAR: {
            prefix: '$ ',
            centsSeparator: '.',
            thousandsSeparator: ',',
            key: 'DOLLAR',
            text: 'Dólar',
            decimalQuant: 2,
            mask: '#,##0.00',
            placeHolder: '0.00'
        },
        NOVO_SOL_PERUANO: {
            prefix: 'S/ ',
            centsSeparator: '.',
            thousandsSeparator: ',',
            key: 'NOVO_SOL_PERUANO',
            text: 'Nuevo Sol',
            decimalQuant: 2,
            mask: '#,##0.00',
            placeHolder: '0.00'
        },
        DINAR_KUWAITIANO: {
            prefix: 'د.ك ',
            centsSeparator: '.',
            thousandsSeparator: ',',
            key: 'DINAR_KUWAITIANO',
            text: 'Dinar kuwaitiano',
            decimalQuant: 2,
            mask: '#,##0.00',
            placeHolder: '0.00'
        },
        DIRHAM_DOS_EMIRADOS_ARABES_UNIDOS: {
            prefix: 'د.إ ',
            centsSeparator: '.',
            thousandsSeparator: ',',
            key: 'DIRHAM_DOS_EMIRADOS_ARABES_UNIDOS',
            text: 'Dirham dos Emirados Árabes Unidos',
            decimalQuant: 2,
            mask: '#,##0.00',
            placeHolder: '0.00'
        },
        PESO_MEXICANO: {
            prefix: 'Mex$ ',
            centsSeparator: '.',
            thousandsSeparator: ',',
            key: 'PESO_MEXICANO',
            text: 'Peso Mexicano',
            decimalQuant: 2,
            mask: '#,##0.00',
            placeHolder: '0.00'
        },
        PESO_DOMINICANO: {
            prefix: 'RD$ ',
            centsSeparator: '.',
            thousandsSeparator: ',',
            key: 'PESO_DOMINICANO',
            text: 'Peso Dominicano',
            decimalQuant: 2,
            mask: '#,##0.00',
            placeHolder: '0.00'
        },
        PESO_FILIPINO: {
            prefix: '₱ ',
            centsSeparator: '.',
            thousandsSeparator: ',',
            key: 'PESO_FILIPINO',
            text: 'Peso filipino',
            decimalQuant: 2,
            mask: '#,##0.00',
            placeHolder: '0.00'
        }
    };
}

/**
 *
 * @param {*} array - The array that you want extract the element
 * @param {*} attr - The attr that identify the element
 * @param {*} value - The value of attr passed
 */
function findElementByAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
            return array[i];
        }
    }
    return null;
}

function detectar_mobile() {
    var check = false; //wrapper no check
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

function getDomainNameSufix(window, storeType) {
    var host = window.location.hostname;

    if (window.location.hostname.includes('.com.br')) {
        return /(\w+)(?=.com)/gm.exec(host)[0] + '.com.br';
    } else if (window.location.hostname.includes('.com')) {
        return /(\w+)(?=.com)/gm.exec(host)[0] + '.com';
    } else if (window.location.hostname.includes('.shop')) {
        return /(\w+)(?=.shop)/gm.exec(host)[0] + '.shop';
    } else if (window.location.hostname.includes('.digital')) {
        return /(\w+)(?=.digital)/gm.exec(host)[0] + '.digital';
	} else if (window.location.hostname.includes('.online')) {
        return /(\w+)(?=.online)/gm.exec(host)[0] + '.online';
	}
}

function sortAlphaNumIds(elem1, elem2) {
    if (elem1.id === elem2.id) {
        return 0;
    } else if (elem1.id < elem2.id) {
        return 1;
    } else {
        return -1;
    }
}

function sortAlphaNumElements(elem1, elem2) {
    if (elem1 === elem2) {
        return 0;
    } else if (elem1 < elem2) {
        return 1;
    } else {
        return -1;
    }
}

function sortDescFlyerByPurchaseValue(elem1, elem2) {
    if (elem1.purchaseValue === elem2.purchaseValue) {
        return 0;
    } else if (elem1.purchaseValue < elem2.purchaseValue) {
        return 1;
    } else {
        return -1;
    }
}

function removeElementFromArrayByAttr(array, attr, attrValue){
    var index = findIndexByAttr(array, attr, attrValue);
    if (index > -1){
        return array.splice(index, 1);
    }

    return array;
}


function getBanksBrasil() {
    return [
        {
            "code": "001",
            "pagarme": true,
            "label": "Banco do Brasil S.A."
        },
        {
            "code": "003",
            "label": "Banco da Amazônia S.A."
        },
        {
            "code": "004",
            "label": "Banco do Nordeste do Brasil S.A."
        },
        {
            "code": "007",
            "label": "Banco Nacional de Desenvolvimento Econômico e Social BNDES"
        },
        {
            "code": "010",
            "label": "Credicoamo Crédito Rural Cooperativa"
        },
        {
            "code": "011",
            "label": "Credit Suisse Hedging-Griffo Corretora de Valores S.A."
        },
        {
            "code": "012",
            "label": "Banco Inbursa S.A."
        },
        {
            "code": "014",
            "label": "Natixis Brasil S.A. Banco Múltiplo"
        },
        {
            "code": "015",
            "label": "UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A."
        },
        {
            "code": "016",
            "label": "Coop de Créd. Mútuo dos Despachantes de Trânsito de SC e Rio Grande do Sul"
        },
        {
            "code": "017",
            "label": "BNY Mellon Banco S.A."
        },
        {
            "code": "018",
            "label": "Banco Tricury S.A."
        },
        {
            "code": "021",
            "label": "Banestes S.A. Banco do Estado do Espírito Santo"
        },
        {
            "code": "024",
            "label": "Banco Bandepe S.A."
        },
        {
            "code": "025",
            "label": "Banco Alfa S.A."
        },
        {
            "code": "029",
            "label": "Banco Itaú Consignado S.A."
        },
        {
            "code": "033",
            "pagarme": true,
            "label": "Banco Santander (Brasil) S. A."
        },
        {
            "code": "036",
            "label": "Banco Bradesco BBI S.A."
        },
        {
            "code": "037",
            "label": "Banco do Estado do Pará S.A."
        },
        {
            "code": "040",
            "label": "Banco Cargill S.A."
        },
        {
            "code": "041",
            "label": "Banco do Estado do Rio Grande do Sul S.A."
        },
        {
            "code": "047",
            "label": "Banco do Estado de Sergipe S.A."
        },
        {
            "code": "060",
            "label": "Confidence Corretora de Câmbio S.A."
        },
        {
            "code": "062",
            "label": "Hipercard Banco Múltiplo S.A."
        },
        {
            "code": "063",
            "label": "Banco Bradescard S.A."
        },
        {
            "code": "064",
            "label": "Goldman Sachs do Brasil  Banco Múltiplo S. A."
        },
        {
            "code": "065",
            "label": "Banco AndBank (Brasil) S.A."
        },
        {
            "code": "066",
            "label": "Banco Morgan Stanley S. A."
        },
        {
            "code": "069",
            "label": "Banco Crefisa S.A."
        },
        {
            "code": "070",
            "label": "Banco de Brasília S.A."
        },
        {
            "code": "074",
            "label": "Banco J. Safra S.A."
        },
        {
            "code": "075",
            "label": "Banco ABN Amro S.A."
        },
        {
            "code": "076",
            "label": "Banco KDB do Brasil S.A."
        },
        {
            "code": "077",
            "pagarme": true,
            "label": "Banco Inter S.A."
        },
        {
            "code": "078",
            "label": "Haitong Banco de Investimento do Brasil S.A."
        },
        {
            "code": "079",
            "label": "Banco Original do Agronegócio S.A."
        },
        {
            "code": "080",
            "label": "BT Corretora de Câmbio Ltda."
        },
        {
            "code": "081",
            "label": "BBN Banco Brasileiro de Negocios S.A."
        },
        {
            "code": "082",
            "label": "Banco Topazio S.A."
        },
        {
            "code": "083",
            "label": "Banco da China Brasil S.A."
        },
        {
            "code": "084",
            "label": "Uniprime Norte do Paraná - Cooperativa de Crédito Ltda."
        },
        {
            "code": "085",
            "label": "Cooperativa Central de Crédito Urbano - Cecred"
        },
        {
            "code": "088",
            "label": "Banco Random SA"
        },
        {
            "code": "089",
            "label": "Cooperativa de Crédito Rural da Região da Mogiana"
        },
        {
            "code": "091",
            "label": "Central de Cooperativas de Economia e Crédito Mútuo do Est RS - Unicred"
        },
        {
            "code": "092",
            "label": "BRK S.A. Crédito, Financiamento e Investimento"
        },
        {
            "code": "093",
            "label": "Pólocred Sociedade de Crédito ao Microempreendedor e à Empresa de Pequeno Porte"
        },
        {
            "code": "094",
            "label": "Banco Finaxis S.A."
        },
        {
            "code": "095",
            "label": "Banco Confidence de Câmbio S.A."
        },
        {
            "code": "096",
            "label": "Banco BMFBovespa de Serviços de Liquidação e Custódia S/A"
        },
        {
            "code": "097",
            "label": "Cooperativa Central de Crédito Noroeste Brasileiro Ltda - CentralCredi"
        },
        {
            "code": "098",
            "label": "Credialiança Cooperativa de Crédito Rural"
        },
        {
            "code": "099",
            "label": "Uniprime Central – Central Interestadual de Cooperativas de Crédito Ltda."
        },
        {
            "code": "100",
            "label": "Planner Corretora de Valores S.A."
        },
        {
            "code": "101",
            "label": "Renascença Distribuidora de Títulos e Valores Mobiliários Ltda."
        },
        {
            "code": "102",
            "label": "XP Investimentos Corretora de Câmbio Títulos e Valores Mobiliários S.A."
        },
        {
            "code": "104",
            "pagarme": true,
            "label": "Caixa Econômica Federal"
        },
        {
            "code": "105",
            "label": "Lecca Crédito, Financiamento e Investimento S/A"
        },
        {
            "code": "107",
            "label": "Banco Bocom BBM S.A."
        },
        {
            "code": "111",
            "label": "Oliveira Trust Distribuidora de Títulos e Valores Mobiliários S.A."
        },
        {
            "code": "113",
            "label": "Magliano S.A. Corretora de Cambio e Valores Mobiliarios"
        },
        {
            "code": "117",
            "label": "Advanced Corretora de Câmbio Ltda."
        },
        {
            "code": "118",
            "label": "Standard Chartered Bank (Brasil) S.A. Banco de Investimento"
        },
        {
            "code": "119",
            "label": "Banco Western Union do Brasil S.A."
        },
        {
            "code": "120",
            "label": "Banco Rodobens SA"
        },
        {
            "code": "121",
            "label": "Banco Agibank S.A."
        },
        {
            "code": "122",
            "label": "Banco Bradesco BERJ S.A."
        },
        {
            "code": "124",
            "label": "Banco Woori Bank do Brasil S.A."
        },
        {
            "code": "125",
            "label": "Brasil Plural S.A. Banco Múltiplo"
        },
        {
            "code": "126",
            "label": "BR Partners Banco de Investimento S.A."
        },
        {
            "code": "127",
            "label": "Codepe Corretora de Valores e Câmbio S.A."
        },
        {
            "code": "128",
            "label": "MS Bank S.A. Banco de Câmbio"
        },
        {
            "code": "129",
            "label": "UBS Brasil Banco de Investimento S.A."
        },
        {
            "code": "130",
            "label": "Caruana S.A. Sociedade de Crédito, Financiamento e Investimento"
        },
        {
            "code": "131",
            "label": "Tullett Prebon Brasil Corretora de Valores e Câmbio Ltda."
        },
        {
            "code": "132",
            "label": "ICBC do Brasil Banco Múltiplo S.A."
        },
        {
            "code": "133",
            "label": "Confederação Nacional das Cooperativas Centrais de Crédito e Economia Familiar e"
        },
        {
            "code": "134",
            "label": "BGC Liquidez Distribuidora de Títulos e Valores Mobiliários Ltda."
        },
        {
            "code": "135",
            "label": "Gradual Corretora de Câmbio, Títulos e Valores Mobiliários S.A."
        },
        {
            "code": "136",
            "label": "Confederação Nacional das Cooperativas Centrais Unicred Ltda – Unicred do Brasil"
        },
        {
            "code": "137",
            "label": "Multimoney Corretora de Câmbio Ltda"
        },
        {
            "code": "138",
            "label": "Get Money Corretora de Câmbio S.A."
        },
        {
            "code": "139",
            "label": "Intesa Sanpaolo Brasil S.A. - Banco Múltiplo"
        },
        {
            "code": "140",
            "label": "Easynvest - Título Corretora de Valores SA"
        },
        {
            "code": "141",
            "label": "Master BI SA"
        },
        {
            "code": "142",
            "label": "Broker Brasil Corretora de Câmbio Ltda."
        },
        {
            "code": "143",
            "label": "Treviso Corretora de Câmbio S.A."
        },
        {
            "code": "144",
            "label": "Bexs Banco de Câmbio S.A."
        },
        {
            "code": "145",
            "label": "Levycam - Corretora de Câmbio e Valores Ltda."
        },
        {
            "code": "146",
            "label": "Guitta Corretora de Câmbio Ltda."
        },
        {
            "code": "149",
            "label": "Facta Financeira S.A. - Crédito Financiamento e Investimento"
        },
        {
            "code": "157",
            "label": "ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda."
        },
        {
            "code": "159",
            "label": "Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor"
        },
        {
            "code": "163",
            "label": "Commerzbank Brasil S.A. - Banco Múltiplo"
        },
        {
            "code": "169",
            "label": "Banco Olé Bonsucesso Consignado S.A."
        },
        {
            "code": "172",
            "label": "Albatross Corretora de Câmbio e Valores S.A"
        },
        {
            "code": "173",
            "label": "BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A."
        },
        {
            "code": "174",
            "label": "Pernambucanas Financiadora S.A. Crédito, Financiamento e Investimento"
        },
        {
            "code": "177",
            "label": "Guide Investimentos S.A. Corretora de Valores"
        },
        {
            "code": "180",
            "label": "CM Capital Markets Corretora de Câmbio, Títulos e Valores Mobiliários Ltda."
        },
        {
            "code": "182",
            "label": "Dacasa Financeira S/A - Sociedade de Crédito, Financiamento e Investimento"
        },
        {
            "code": "183",
            "label": "Socred S.A. - Sociedade de Crédito ao Microempreendedor"
        },
        {
            "code": "184",
            "label": "Banco Itaú BBA S.A."
        },
        {
            "code": "188",
            "label": "Ativa Investimentos S.A. Corretora de Títulos Câmbio e Valores"
        },
        {
            "code": "189",
            "label": "HS Financeira S/A Crédito, Financiamento e Investimentos"
        },
        {
            "code": "190",
            "label": "Cooperativa de Economia e Crédito Mútuo dos Servidores Públicos Estaduais do Rio"
        },
        {
            "code": "191",
            "label": "Nova Futura Corretora de Títulos e Valores Mobiliários Ltda."
        },
        {
            "code": "194",
            "label": "Parmetal Distribuidora de Títulos e Valores Mobiliários Ltda."
        },
        {
            "code": "195",
            "label": "Valor SCD S.A."
        },
        {
            "code": "196",
            "label": "Fair Corretora de Câmbio S.A."
        },
        {
            "code": "197",
            "pagarme": true,
            "label": "Stone Pagamentos S.A."
        },
        {
            "code": "204",
            "label": "Banco Bradesco Cartões S.A."
        },
        {
            "code": "208",
            "pagarme": true,
            "label": "Banco BTG Pactual S.A."
        },
        {
            "code": "212",
            "label": "Banco Original S.A."
        },
        {
            "code": "213",
            "label": "Banco Arbi S.A."
        },
        {
            "code": "217",
            "label": "Banco John Deere S.A."
        },
        {
            "code": "218",
            "label": "Banco BS2 S.A."
        },
        {
            "code": "222",
            "label": "Banco Credit Agrícole Brasil S.A."
        },
        {
            "code": "224",
            "label": "Banco Fibra S.A."
        },
        {
            "code": "233",
            "label": "Banco Cifra S.A."
        },
        {
            "code": "237",
            "pagarme": true,
            "label": "Banco Bradesco S.A."
        },
        {
            "code": "241",
            "label": "Banco Clássico S.A."
        },
        {
            "code": "243",
            "label": "Banco Máxima S.A."
        },
        {
            "code": "246",
            "label": "Banco ABC Brasil S.A."
        },
        {
            "code": "249",
            "label": "Banco Investcred Unibanco S.A."
        },
        {
            "code": "250",
            "label": "BCV - Banco de Crédito e Varejo S/A"
        },
        {
            "code": "253",
            "label": "Bexs Corretora de Câmbio S/A"
        },
        {
            "code": "254",
            "label": "Parana Banco S. A."
        },
        {
            "code": "259",
            "label": "Moneycorp BCO de Cambio S.A."
        },
        {
            "code": "260",
            "pagarme": true,
            "label": "Nu Pagamentos S.A."
        },
        {
            "code": "265",
            "label": "Banco Fator S.A."
        },
        {
            "code": "266",
            "label": "Banco Cédula S.A."
        },
        {
            "code": "268",
            "label": "Barigui Companhia Hipotecária"
        },
        {
            "code": "269",
            "label": "HSBC Brasil S.A. Banco de Investimento"
        },
        {
            "code": "271",
            "label": "IB Corretora de Câmbio, Títulos e Valores Mobiliários Ltda."
        },
        {
            "code": "272",
            "label": "AGK CC S.A."
        },
        {
            "code": "273",
            "label": "CCR de São Miguel do Oeste"
        },
        {
            "code": "274",
            "label": "BMP SCMEPP LTDA"
        },
        {
            "code": "276",
            "label": "BCO SENFF S.A."
        },
        {
            "code": "278",
            "label": "Genial Investimentos CVM S.A."
        },
        {
            "code": "279",
            "label": "COOP de Primavera do Leste"
        },
        {
            "code": "280",
            "label": "Will Financeira SACFI"
        },
        {
            "code": "281",
            "label": "CCR COOPAVEL"
        },
        {
            "code": "283",
            "label": "RB Investimentos DTVM LTDA"
        },
        {
            "code": "285",
            "label": "Frente CC S.A."
        },
        {
            "code": "288",
            "label": "Carol DTVM LTDA"
        },
        {
            "code": "289",
            "label": "EFX CC LTDA"
        },
        {
            "code": "290",
            "label": "PAGSEGURO Internet IP S.A."
        },
        {
            "code": "292",
            "label": "Galapagos DTVM S.A."
        },
        {
            "code": "293",
            "label": "Lastro RDV DTVM LTDA"
        },
        {
            "code": "296",
            "label": "OZ Corretora de Cambio S.A."
        },
        {
            "code": "298",
            "label": "VIPS CC LTDA"
        },
        {
            "code": "299",
            "label": "BCO AFINZ S.A. - BM"
        },
        {
            "code": "300",
            "label": "Banco de la Nacion Argentina"
        },
        {
            "code": "301",
            "label": "DOCK IP S.A."
        },
        {
            "code": "305",
            "label": "Fourtrade Cor de Cambio LTDA"
        },
        {
            "code": "306",
            "label": "Portopar DTVM LTDA"
        },
        {
            "code": "307",
            "label": "Terra Investimentos DTVM"
        },
        {
            "code": "309",
            "label": "Cambionet CC LTDA"
        },
        {
            "code": "310",
            "label": "VORTX DTVM LTDA"
        },
        {
            "code": "312",
            "label": "HSCM SCMEPP LTDA"
        },
        {
            "code": "318",
            "label": "Banco BMG S.A."
        },
        {
            "code": "319",
            "label": "OM DTVM LTDA"
        },
        {
            "code": "320",
            "label": "China Construction Bank (Brasil) Banco Múltiplo S/A"
        },
        {
            "code": "321",
            "label": "Crefaz SCMEPP LTDA"
        },
        {
            "code": "322",
            "label": "CCR de Abelardo Luz"
        },
        {
            "code": "323",
            "label": "Mercado Pago IP LTDA"
        },
        {
            "code": "324",
            "label": "Cartos SCD S.A."
        },
        {
            "code": "325",
            "label": "ORAMA DTVM S.A."
        },
        {
            "code": "326",
            "label": "Parati - CFI S.A."
        },
        {
            "code": "328",
            "label": "CECM Fabric Calçados Sapiranga"
        },
        {
            "code": "329",
            "label": "QI SCD S.A."
        },
        {
            "code": "330",
            "label": "Banco Bari S.A."
        },
        {
            "code": "331",
            "label": "Fram Capital DTVM S.A."
        },
        {
            "code": "332",
            "label": "Acesso Soluções de Pagamento S.A. - IP"
        },
        {
            "code": "334",
            "label": "Banco Besa S.A."
        },
        {
            "code": "335",
            "label": "Banco Digio"
        },
        {
            "code": "336",
            "pagarme": true,
            "label": "Banco C6"
        },
        {
            "code": "340",
            "label": "Superdigital IP S.A."
        },
        {
            "code": "341",
            "pagarme": true,
            "label": "Itaú Unibanco  S.A."
        },
        {
            "code": "342",
            "label": "Creditas SCD"
        },
        {
            "code": "343",
            "label": "FFA SCMEPP LTDA"
        },
        {
            "code": "348",
            "label": "BCO XP S.A."
        },
        {
            "code": "349",
            "label": "AL5 S.A. CFI"
        },
        {
            "code": "350",
            "label": "Crehnor Laranjeiras"
        },
        {
            "code": "352",
            "label": "Toro CTVM S.A."
        },
        {
            "code": "355",
            "label": "Otimo SCD S.A."
        },
        {
            "code": "358",
            "label": "Midway S.A. - SCFI"
        },
        {
            "code": "359",
            "label": "Zema CFI S.A."
        },
        {
            "code": "360",
            "label": "Trinus Capital DTVM"
        },
        {
            "code": "362",
            "label": "CIELO IP S.A."
        },
        {
            "code": "363",
            "label": "Singulare CTVM S.A."
        },
        {
            "code": "364",
            "label": "EFI S.A. - IP"
        },
        {
            "code": "365",
            "label": "SIMPAUL"
        },
        {
            "code": "366",
            "label": "Banco Société Générale Brasil S.A."
        },
        {
            "code": "367",
            "label": "BCO Societe Generale Brasil"
        },
        {
            "code": "368",
            "label": "Vitreo DTVM S.A."
        },
        {
            "code": "370",
            "label": "Banco Mizuho do Brasil S.A."
        },
        {
            "code": "371",
            "label": "Warren CVMC LTDA"
        },
        {
            "code": "373",
            "label": "UPP SEP S.A."
        },
        {
            "code": "374",
            "label": "Realize CFI S.A."
        },
        {
            "code": "376",
            "label": "Banco J. P. Morgan S. A."
        },
        {
            "code": "377",
            "label": "BMS SCD S.A."
        },
        {
            "code": "378",
            "label": "BCO Brasileiro de Crédito S.A."
        },
        {
            "code": "379",
            "label": "CECM Cooperforte"
        },
        {
            "code": "380",
            "label": "PicPay"
        },
        {
            "code": "381",
            "label": "BCO Mercedes Benz S.A."
        },
        {
            "code": "382",
            "label": "Fiducia SCMEPP LTDA"
        },
        {
            "code": "383",
            "label": "Ebanx IP LTDA"
        },
        {
            "code": "384",
            "label": "Global SCM LTDA"
        },
        {
            "code": "385",
            "label": "CECM dos Trabport da GVitor"
        },
        {
            "code": "386",
            "label": "Nu Financeira S.A. CFI"
        },
        {
            "code": "387",
            "label": "BCO Toyota do Brasil S.A."
        },
        {
            "code": "389",
            "label": "Banco Mercantil do Brasil S.A."
        },
        {
            "code": "390",
            "label": "BCO GM S.A."
        },
        {
            "code": "391",
            "label": "CCR de Ibiam"
        },
        {
            "code": "393",
            "label": "BCO Bradesco Financ. S.A."
        },
        {
            "code": "394",
            "label": "Banco Bradesco Financiamentos S.A."
        },
        {
            "code": "395",
            "label": "F D Gold DTVM LTDA"
        },
        {
            "code": "396",
            "label": "HUB IP S.A."
        },
        {
            "code": "397",
            "label": "Listo SCD S.A."
        },
        {
            "code": "398",
            "label": "Ideal CTVM S.A."
        },
        {
            "code": "399",
            "label": "Kirton Bank S.A. - Banco Múltiplo"
        },
        {
            "code": "400",
            "label": "COOP Creditag"
        },
        {
            "code": "401",
            "label": "IUGU IP S.A."
        },
        {
            "code": "402",
            "label": "Cobuccio S.A. SCFI"
        },
        {
            "code": "403",
            "label": "CORA SCD S.A."
        },
        {
            "code": "404",
            "label": "SUMUP SCD S.A."
        },
        {
            "code": "406",
            "label": "Accredito SCD S.A."
        },
        {
            "code": "407",
            "label": "Indigo Investimentos DTVM LTDA"
        },
        {
            "code": "408",
            "label": "Bonuspago SCD S.A."
        },
        {
            "code": "410",
            "label": "Planner Sociedade de Credito Direto"
        },
        {
            "code": "412",
            "label": "Banco Capital S. A."
        },
        {
            "code": "413",
            "label": "BCO BV S.A."
        },
        {
            "code": "414",
            "label": "LEND SCD S.A."
        },
        {
            "code": "416",
            "label": "Lamara SCD S.A."
        },
        {
            "code": "418",
            "label": "Zipdin SCD S.A."
        },
        {
            "code": "419",
            "label": "Numbrs SCD S.A."
        },
        {
            "code": "421",
            "label": "CC Lar Credi"
        },
        {
            "code": "422",
            "pagarme": true,
            "label": "Banco Safra S.A"
        },
        {
            "code": "426",
            "label": "Neon Financeira CFI S.A"
        },
        {
            "code": "427",
            "label": "CRED-UFES"
        },
        {
            "code": "428",
            "label": "Credsystem SCD S.A."
        },
        {
            "code": "429",
            "label": "Crediare CFI S.A."
        },
        {
            "code": "430",
            "label": "CCR Seara"
        },
        {
            "code": "433",
            "label": "BR-Capital DTVM S.A."
        },
        {
            "code": "435",
            "label": "Delcred SCD S.A."
        },
        {
            "code": "438",
            "label": "Trustee DTVM LTDA."
        },
        {
            "code": "439",
            "label": "ID CTVM"
        },
        {
            "code": "440",
            "label": "Credibrf Coop"
        },
        {
            "code": "443",
            "label": "Credihome SCD"
        },
        {
            "code": "444",
            "label": "Trinus SCD S.A."
        },
        {
            "code": "445",
            "label": "Platae CFI"
        },
        {
            "code": "447",
            "label": "Mirae Asset CCTVM LTDA"
        },
        {
            "code": "448",
            "label": "Hermera DTVM LTDA"
        },
        {
            "code": "449",
            "label": "DM"
        },
        {
            "code": "450",
            "label": "Fitbank IP"
        },
        {
            "code": "451",
            "label": "J17 - SCD S.A."
        },
        {
            "code": "452",
            "label": "Credifit SCD S.A."
        },
        {
            "code": "454",
            "label": "Merito DTVM LTDA"
        },
        {
            "code": "455",
            "label": "Fenix DTVM LTDA"
        },
        {
            "code": "456",
            "label": "Banco MUFG Brasil S.A."
        },
        {
            "code": "457",
            "label": "UY3 SCD S.A."
        },
        {
            "code": "458",
            "label": "Hedge Investiments DTVM LTDA"
        },
        {
            "code": "460",
            "label": "Unavanti SCD S.A."
        },
        {
            "code": "461",
            "label": "Asaas IP S.A."
        },
        {
            "code": "462",
            "label": "Stark SCD S.A."
        },
        {
            "code": "463",
            "label": "Azumi DTVM"
        },
        {
            "code": "464",
            "label": "Banco Sumitomo Mitsui Brasileiro S.A."
        },
        {
            "code": "465",
            "label": "Capital Consig SCD S.A."
        },
        {
            "code": "467",
            "label": "Master S.A. CCTVM"
        },
        {
            "code": "468",
            "label": "Portoseg S.A. CFI"
        },
        {
            "code": "469",
            "label": "Picpay Invest"
        },
        {
            "code": "470",
            "label": "CDC SCD S.A."
        },
        {
            "code": "471",
            "label": "CECM Serv Punl Pinhao"
        },
        {
            "code": "473",
            "label": "Banco Caixa Geral - Brasil S.A."
        },
        {
            "code": "475",
            "label": "BCO Yamaha Motor S.A."
        },
        {
            "code": "477",
            "label": "Citibank N.A."
        },
        {
            "code": "478",
            "label": "Gazincred S.A. SCFI"
        },
        {
            "code": "479",
            "label": "Banco ItauBank S.A."
        },
        {
            "code": "481",
            "label": "Superlogica SCD S.A."
        },
        {
            "code": "482",
            "label": "SBCash SCD"
        },
        {
            "code": "484",
            "label": "MAF DTVM S.A."
        },
        {
            "code": "487",
            "label": "Deutsche Bank S.A. - Banco Alemão"
        },
        {
            "code": "488",
            "label": "JPMorgan Chase Bank, National Association"
        },
        {
            "code": "492",
            "label": "ING Bank N.V."
        },
        {
            "code": "494",
            "label": "Banco de La Republica Oriental del Uruguay"
        },
        {
            "code": "495",
            "label": "Banco de La Provincia de Buenos Aires"
        },
        {
            "code": "505",
            "label": "Banco Credit Suisse (Brasil) S.A."
        },
        {
            "code": "506",
            "label": "RJI"
        },
        {
            "code": "507",
            "label": "SCFI EFI S.A."
        },
        {
            "code": "508",
            "label": "Avenue Securities DTVM LTDA"
        },
        { "label": "CELCOIN IP SA", "code": "509" },
        { "label": "FFCRED SCD SA", "code": "510" },
        { "label": "MAGNUM SCD", "code": "511" },
        { "label": "FINVEST DTVM", "code": "512" },
        { "label": "ATF CREDIT SCD SA", "code": "513" },
        { "label": "EXIM CC LTDA", "code": "514" },
        { "label": "QISTA SA CFI", "code": "516" },
        { "label": "MERCADO CREDITO SCFI SA", "code": "518" },
        { "label": "LIONS TRUST DTVM", "code": "519" },
        { "label": "SOMAPAY SCD SA", "code": "520" },
        { "label": "PEAK SEP SA", "code": "521" },
        { "label": "RED SCD SA", "code": "522" },
        { "label": "HR DIGITAL SCD", "code": "523" },
        { "label": "WNT CAPITAL DTVM", "code": "524" },
        { "label": "INTERCAM CC LTDA", "code": "525" },
        { "label": "MONETARIE SCD", "code": "526" },
        { "label": "ATICCA SCD SA", "code": "527" },
        { "label": "REAG DTVM SA", "code": "528" },
        { "label": "PINBANK IP", "code": "529" },
        { "label": "SER FINANCE SCD SA", "code": "530" },
        { "label": "BMP SCD SA", "code": "531" },
        { "label": "EAGLE SCD SA", "code": "532" },
        { "label": "M18 IP SA", "code": "533" },
        { "label": "EWALLY IP SA", "code": "534" },
        { "label": "OPEA SCD", "code": "535" },
        { "label": "NEON PAGAMENTOS SA IP", "code": "536" },
        { "label": "MICROCASH SCMEPP LTDA", "code": "537" },
        { "label": "SUDACRED SCMEPP LTDA", "code": "538" },
        { "label": "SANTINVEST SA CFI", "code": "539" },
        { "label": "FACILICRED SCM LTDA", "code": "540" },
        { "label": "FDO GARANTIDOR CRÉDITOS", "code": "541" },
        { "label": "CLOUDWALK IP LTDA", "code": "542" },
        { "label": "COOPCRECE", "code": "543" },
        { "label": "MULTICRED SCD SA", "code": "544" },
        {
            "code": "545",
            "label": "Senso Corretora de Câmbio e Valores Mobiliários S.A."
        },
        { "code": "546", "label": "U4C INSTITUICAO DE PAGAMENTO SA" },
        { "code": "547", "label": "BNK DIGITAL SCD SA" },
        { "code": "548", "label": "RPW SA SCFI" },
        { "code": "549", "label": "INTRA DTVM" },
        { "code": "550", "label": "BEETELLER" },
        { "code": "552", "label": "UZZIPAY IP SA" },
        { "code": "553", "label": "PERCAPITAL SCD SA" },
        { "code": "554", "label": "STONEX BANCO DE CAMBIO SA" },
        { "code": "555", "label": "PAN CFI" },
        { "code": "556", "label": "PROSEFTUR" },
        { "code": "557", "label": "PAGPRIME IP" },
        { "code": "558", "label": "QI DTVM LTDA" },
        { "code": "559", "label": "KANASTRA SCD" },
        { "code": "560", "label": "MAG IP LTDA" },
        { "code": "561", "label": "PAY4FUN IP SA" },
        { "code": "562", "label": "AZIMUT BRASIL DTVM LTDA" },
        { "code": "563", "label": "PROTEGE PAY CASH IP SA" },
        { "code": "565", "label": "AGORA CTVM SA" },
        { "code": "566", "label": "FLAGSHIP IP LTDA" },
        { "code": "567", "label": "CREDITAQUI FINANCEIRA SA - CFI" },
        { "code": "568", "label": "BRCONDOS SCD SA" },
        { "code": "569", "label": "CONTA PRONTA IP" },
        { "code": "572", "label": "ALL IN CRED SCD SA" },
        { "code": "577", "label": "AF DESENVOLVE SP SA" },
        { "code": "579", "label": "QUADRA SCD" },
        { "code": "580", "label": "CCCPOUPINV SUL E SUDESTE CENTRAL SICREDI SULSUDESTE" },
        { "code": "582", "label": "CCC POUP INV DE MS GO DF E TO" },
        { "code": "583", "label": "CCC POUP INV DO CENTRO NORTE DO BRASIL" },
        { "code": "584", "label": "CCC POUP E INV DOS ESTADOS DO PR SP E RJ" },
        { "code": "586", "label": "Z1 IP LTDA" },
        { "code": "588", "label": "PROVER PROMOCAO DE VENDAS IP LTDA" },
        { "code": "590", "label": "REPASSES FINANCEIROS E SOLUCOES TECNOLOGICAS IP SA" },
        { "code": "594", "label": "EMBRACRED SA SCD" },
        { "code": "597", "label": "ISSUER IP LTDA" },
        { "code": "600", "label": "BCO LUSO BRASILEIRO S.A." },
        {
            "code": "600",
            "label": "Banco Luso Brasileiro S.A."
        },
        {
            "code": "604",
            "label": "Banco Industrial do Brasil S.A."
        },
        {
            "code": "610",
            "label": "Banco VR S.A."
        },
        {
            "code": "611",
            "label": "Banco Paulista S.A."
        },
        {
            "code": "612",
            "label": "Banco Guanabara S.A."
        },
        {
            "code": "613",
            "label": "Omni Banco S.A."
        },
        {
            "code": "623",
            "label": "Banco Pan S.A."
        },
        {
            "code": "626",
            "label": "Banco Ficsa S. A."
        },
        {
            "code": "630",
            "label": "Banco Intercap S.A."
        },
        {
            "code": "633",
            "label": "Banco Rendimento S.A."
        },
        {
            "code": "634",
            "label": "Banco Triângulo S.A."
        },
        {
            "code": "637",
            "label": "Banco Sofisa S. A."
        },
        {
            "code": "641",
            "label": "Banco Alvorada S.A."
        },
        {
            "code": "643",
            "label": "Banco Pine S.A."
        },
        {
            "code": "652",
            "label": "Itaú Unibanco Holding S.A."
        },
        {
            "code": "653",
            "label": "Banco Indusval S. A."
        },
        {
            "code": "654",
            "label": "Banco A. J. Renner S.A."
        },
        {
            "code": "655",
            "label": "Banco Votorantim S.A."
        },
        {
            "code": "707",
            "label": "Banco Daycoval S.A."
        },
        {
            "code": "712",
            "label": "Banco Ourinvest S.A."
        },
        {
            "code": "719",
            "label": "Banif - Bco Internacional do Funchal (Brasil) S.A."
        },
        {
            "code": "720",
            "label": "BCO RNX S.A."
        },
        {
            "code": "735",
            "label": "Banco Neon S.A."
        },
        {
            "code": "739",
            "label": "Banco Cetelem S.A."
        },
        {
            "code": "741",
            "label": "Banco Ribeirão Preto S.A."
        },
        {
            "code": "743",
            "label": "Banco Semear S.A."
        },
        {
            "code": "745",
            "label": "Banco Citibank S.A."
        },
        {
            "code": "746",
            "label": "Banco Modal S.A."
        },
        {
            "code": "747",
            "label": "Banco Rabobank International Brasil S.A."
        },
        {
            "code": "748",
            "label": "Banco Cooperativo Sicredi S. A."
        },
        {
            "code": "751",
            "label": "Scotiabank Brasil S.A. Banco Múltiplo"
        },
        {
            "code": "752",
            "label": "Banco BNP Paribas Brasil S.A."
        },
        {
            "code": "753",
            "label": "Novo Banco Continental S.A. - Banco Múltiplo"
        },
        {
            "code": "754",
            "label": "Banco Sistema S.A."
        },
        {
            "code": "755",
            "label": "Bank of America Merrill Lynch Banco Múltiplo S.A."
        },
        {
            "code": "756",
            "label": "Banco Cooperativo do Brasil S/A - Bancoob"
        },
        {
            "code": "757",
            "label": "Banco Keb Hana do Brasil S. A."
        }
    ]
}

function getAllStates() {
    return [
        { uf : 'AC', name: 'Acre' },
        { uf : 'AL', name: 'Alagoas' },
        { uf : 'AP', name: 'Amapá' },
        { uf : 'AM', name: 'Amazonas' },
        { uf : 'BA', name: 'Bahia' },
        { uf : 'CE', name: 'Ceará' },
        { uf : 'DF', name: 'Distrito Federal' },
        { uf : 'ES', name: 'Espírito Santo' },
        { uf : 'GO', name: 'Goías' },
        { uf : 'MA', name: 'Maranhão' },
        { uf : 'MT', name: 'Mato Grosso' },
        { uf : 'MS', name: 'Mato Grosso do Sul' },
        { uf : 'MG', name: 'Minas Gerais' },
        { uf : 'PA', name: 'Pará' },
        { uf : 'PB', name: 'Paraíba' },
        { uf : 'PR', name: 'Paraná' },
        { uf : 'PE', name: 'Pernambuco' },
        { uf : 'PI', name: 'Piauí' },
        { uf : 'RJ', name: 'Rio de Janeiro' },
        { uf : 'RN', name: 'Rio Grande do Norte' },
        { uf : 'RS', name: 'Rio Grande do Sul' },
        { uf : 'RO', name: 'Rondônia' },
        { uf : 'RR', name: 'Roraíma' },
        { uf : 'SC', name: 'Santa Catarina' },
        { uf : 'SP', name: 'São Paulo' },
        { uf : 'SE', name: 'Sergipe' },
        { uf : 'TO', name: 'Tocantins' }
    ];
}

/**
 * Sort a list by attribute
 */
function sortListByStrAttribute(list, attribute) {
    return list.sort(function(a, b) {
        if (a[attribute].toLowerCase() < b[attribute].toLowerCase()) {
            return -1;
        }
        if (a[attribute].toLowerCase() > b[attribute].toLowerCase()) {
            return 1;
        }
        return 0;
    });
}

function isNullOrUndefined(object) {
    return object === null || object === undefined;
}

function isNullEmptyOrUndefined(object) {
    return object === null || object === undefined || object.length === 0;
}

(function() {
    'use strict';

    angular
        .module('showcaseApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.popover',
            'ui.bootstrap.pagination',
            'ui.router',
            'infinite-scroll',
            'ui.grid',
            'ui.grid.pagination',
            'ui.grid.exporter',
            'ui.grid.edit',
            'ui.grid.rowEdit',
            'ui.grid.cellNav',
            'ui.grid.saveState',
            'ui.grid.expandable',
            'ui.grid.autoResize',
            'ngImgCrop',
            'daterangepicker',
            'angularUtils.directives.uiBreadcrumbs',
            'uiGmapgoogle-maps',
            'ui.mask',
            'toastr',
            'ngCpfCnpj',
            'angular-ladda',
            'ui.bootstrap.datetimepicker',
            'betsol.intlTelInput',
            'ngFitText',
            'ui.select',
            'ngSanitize',
            'ngMaterial',
            'angularMoment',
            'star-rating',
            'satellizer',
            'chart.js',
            'angular.morris',
            'oitozero.ngSweetAlert',
            'ngMessages',
            'ngTagsInput',
            'ui.sortable',
			'ngCsv',
            'angucomplete-alt',
            'ui.tree',
            'color.picker',
            'ui.utils.masks'
        ]).constant('_', window._)
        .run(facebookConfig)
        .run(loadGoogleAPIClient)
        .run(run)

    run.$inject = ['$localStorage', 'stateHandler', 'StoreService', 'translationHandler', '$rootScope', '$state', '$translate', 'uiDatetimePickerConfig', '$translatePartialLoader', 'Principal', '$window', 'amMoment'];
    facebookConfig.$inject = ['$rootScope', 'FacebookFactory'];

    function run($localStorage, stateHandler, StoreService, translationHandler, $rootScope, $state, $translate, uiDatetimePickerConfig, $translatePartialLoader, Principal, $window, amMoment) {
        $rootScope.loading = true;
		$rootScope.$state = $state;
        $rootScope._ = window._;

        var DOMAIN = document.URL.split('.')[1];
        
        StoreService.getCssHub(DOMAIN).then(function(response) {
                if (response){
                   	$rootScope.hubStyle = response;
					document.documentElement.style.setProperty('--main-color', response.data.mainColor);
            		document.documentElement.style.setProperty('--main-color-light', response.data.mainColorLight);
            		document.documentElement.style.setProperty('--main-color-dark', response.data.mainColorDark);
            		$rootScope.mainColor = response.mainColor;
					$rootScope.loading = false;
					$rootScope.bucket = response.data.bucketString;
                }

            }).catch(function(e) {
			  document.location.reload(true);
			});
        if (!$rootScope.title) {
            $rootScope.title = DOMAIN.charAt(0).toUpperCase() + DOMAIN.slice(1);
        }
        $rootScope.urlImage = DOMAIN;
        $rootScope.hubNameUpper = DOMAIN.charAt(0).toUpperCase() + DOMAIN.slice(1);
        $rootScope.currentYear = new Date().getFullYear();
        stateHandler.initialize();
        translationHandler.initialize();

        $rootScope.$on('$countMessages', function (ev, next, current) {
            $window.document.title = '(' + next + ') ' + DOMAIN.charAt(0).toUpperCase() + DOMAIN.slice(1);
        });

        $rootScope.$on('$translateChangeSuccess', function(ev, next, current) {
            amMoment.changeLocale($translate.use());
            $translatePartialLoader.addPart('calendar');
            uiDatetimePickerConfig.buttonBar.close.text = $translate.instant('calendar.buttons.close');
            uiDatetimePickerConfig.buttonBar.now.text = $translate.instant('calendar.buttons.now');
            uiDatetimePickerConfig.buttonBar.now.show = false;
            uiDatetimePickerConfig.buttonBar.date.text = $translate.instant('calendar.buttons.date');
            uiDatetimePickerConfig.buttonBar.time.text = $translate.instant('calendar.buttons.time');
            uiDatetimePickerConfig.buttonBar.clear.text = $translate.instant('calendar.buttons.clear');
            uiDatetimePickerConfig.buttonBar.today.text = $translate.instant('calendar.buttons.today');
        });

        $rootScope.$on('$stateChangeSuccess', function(ev, toState, toParams, fromState) {

            if (!Principal.isAuthenticated()) {
                var browserLanguage = $window.navigator.language || $window.navigator.userLanguage;
                browserLanguage = browserLanguage.toLowerCase();

                if (browserLanguage.startsWith('en')) {
                    browserLanguage = 'en';
                }

                if (browserLanguage.startsWith('es')) {
                    browserLanguage = 'es';
                }

                if (browserLanguage.startsWith('pt')) {
                    browserLanguage = 'pt-br';
                }

                amMoment.changeLocale(browserLanguage);

                var languagesAccepted = ["pt-br", "en", "es"];
                if (languagesAccepted.indexOf(browserLanguage) === '-1') {
                    $translate.use('en');
                } else {
                    $translate.use(browserLanguage);
                }
            }
        });

        var localStoreChanged = $rootScope.$watch(function(localStorage) {
            return $localStorage.defaultStore ? $localStorage.defaultStore.storeId : null;
        }, function(newValue, oldValue) {
            if (newValue) {
                $rootScope.$emit('local-storage-changed');
            }
        });

        var whenLogout = $rootScope.$watch(function(localStorage) {
            return $localStorage.defaultStore;
        }, function(newValue, oldValue) {
            if (!newValue) {
                $rootScope.$emit('user-logged-out');
            }
        });

    }

    function facebookConfig(FacebookFactory) {
        console.log('Running FB conf');

        var fbConnectUrl = window.location.protocol + '//connect.facebook.net/pt_BR/sdk.js';

        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = fbConnectUrl;
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        window.fbAsyncInit = function() {
            FB.init({
                appId: '1927510520841177', // App ID  - PROD
                //appId: '312782249584097', // App ID  - HOMOLOG
                status: true, // check login status
                version: 'v17.0',
                cookie: true, // enable cookies to allow the server to access the session
                xfbml: true // parse XFBML
            });

        };
    }

    function loadGoogleAPIClient() {
        // Load the API client and auth2 library
        gapi.load('auth2', initGoogleAPI);
    }

    function initGoogleAPI() {
        gapi.auth2.init({
            apiKey: 'AIzaSyA1Lq1zqXv5pPd5DL-y10EuBZ_LyCLsB2E', // Put this in a way to get
            clientId: '711607015396-v345970tftnkv9tqkiqu2v15ra6t0jo2.apps.googleusercontent.com', // Put this in a way to get
            scope: 'https://www.googleapis.com/auth/plus.business.manage'
            // prompt: 'consent'
        });
    }

})();


(function(){
    'use strict'

    angular.module('showcaseApp')
    .factory('StoreInfoFactory', StoreInfoFactory);

    /** @ngInject */
    function StoreInfoFactory($localStorage){

        var factory = {
            getStoreId: getStoreId
        }

        function getStoreId(){
            return $localStorage.defaultStore.storeId;
        }

        return factory;
    }
})();
(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('first', {
                url: '/first',
                abstract: true,
                templateUrl: "app/store/components/common/content.html",
                data: {
                    authorities: ['STORE_CREATE'],
                    specialClass: "md-skin fixed-nav fixed-sidebar",
                    mainFlexClass: "app-wrap"
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                    }]
                }
            })

            .state('form', {
                parent: 'first',
                abstract: true,
                views: {
                    'content@first': {
                        templateUrl: 'app/store/components/content-form.html',
                        controller: 'FormFirstStoreController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    authorities: ['STORE_CREATE'],
                    pageTitle: 'store-info.pageTitle'
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store-management');
                        return $translate.refresh();
                    }]

                }
            })

            .state('store-info', {
                parent: 'form',
                url: '/store-info',
                data: {
                    pageTitle: 'first.pageTitle'
                },
                views: {
                    'form-info@form': {
                        templateUrl: 'app/store/form.store.info.html'
                    },
                    'form-views@form': {
                        templateUrl: 'app/store/form.store.info.view.html',
                        controller: 'FormStoreInfoController',
                        controllerAs: 'vm'
                    }
                }
            })

            .state('store-point', {
                parent: 'form',
                url: '/store-point',
                data: {
                    pageTitle: 'store-point.pageTitle'
                },
                views: {
                    'form-info@form': {
                        templateUrl: 'app/store/form.store.point.info.html'
                    },
                    'form-views@form': {
                        templateUrl: 'app/store/form.store.point.view.html',
                        controller: 'FormStorePointController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .value('formStepsStates', values());


    function values() {
        return [
            {uiSref: 'store-info', valid: false},
            {uiSref: 'store-point', valid: false}
        ]
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FormStorePointController', FormStorePointController);

    /** @ngInject */
    function FormStorePointController($rootScope, $scope, $uibModal, CheckCEPService, GoogleMapsService) {


        var vm = this;

        const ICON_INACTIVE = 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/pointactive.png';

        vm.store = $scope.store;

        vm.formInvalid = false;

        vm.mainMap = {center: { latitude: 0, longitude: 0 }, zoom: 2, control: {}, bounds: {}, markers: $scope.markers};

        getLocation();

        vm.options= {
            fullscreenControl: false
        };
        
        vm.mainMap.window = {
            model: {},
            show: false,
            options: {
                pixelOffset: {width: -1, height: -20}
            },
            closeClick: function() {
                this.show = false;
            }
        }
        vm.mainMap.markerEvents = {
            click: function(marker, eventName, model, args) {
                vm.mainMap.window.model = model;
                vm.mainMap.window.show = true;
            }
        }


        vm.addSalesPoint = function() {
            $uibModal.open({
                templateUrl: 'app/admin/store-management/store-management-newsalespoint.html',
                controller: 'AddSalesPointManagementController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    pointlocation: function() {
                        return $scope.parameter;
                    },
                    pointparent: function() {
                        return $scope.$parent.vm;
                    }
                }
            });
        }

        $scope.$on('salesPointUpdated', function(event, data) {
            vm.mainMap.window.show = false;
            var markerUpdated;
            vm.mainMap.markers.forEach(function (marker) {
                if(marker.id === data.id) {
                    markerUpdated = marker;
                }
            });
            vm.mainMap.markers[vm.mainMap.markers.indexOf(markerUpdated)] = data;
        });

        $scope.$on('salesPointRemoved', function(event, data) {
            vm.mainMap.markers.splice(vm.mainMap.markers.indexOf(data), 1);
            vm.mainMap.window.show = false;
        });

        $scope.$on('salesPointCreated', function(event, data) {
            data.id =  $scope.maker.actualMarker;
            data.options = {icon: ICON_INACTIVE};
            vm.mainMap.markers.push(data);
             $scope.maker.actualMarker++;
            vm.mainMap.window.show = false;
        });


        function getLocationSuccFn(position) {
            vm.mainMap.center.latitude = position.coords.latitude;
            vm.mainMap.center.longitude = position.coords.longitude;
            vm.mainMap.control.refresh({latitude: vm.mainMap.center.latitude, longitude: vm.mainMap.center.longitude});
        }

        function getLocation() {
            if(navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(getLocationSuccFn, function (error) {}, {timeout: 1000});
            }
        }

        vm.checkCEP = function() {
             if (vm.salespoint.pointlocation.postalCode && vm.salespoint.pointlocation.postalCode.length === 8) {
                 CheckCEPService.getAddress(vm.salespoint.pointlocation.postalCode).then(function(response) {
                     if (response.data){
                     vm.salespoint.pointlocation.country = "BRASIL";
                     vm.salespoint.pointlocation.city = response.data.location.name;
                     vm.salespoint.pointlocation.state = response.data.location.uf;
                     vm.salespoint.pointlocation.address = response.data.name;
                     vm.salespoint.pointlocation.neighborhood = response.data.district.name; 
                     vm.refreshMapWithAddress();
                     }
                 });
             }
         }
 
         vm.refreshMapWithAddress = function() {
             if (vm.salespoint.pointlocation){
                 GoogleMapsService.getAddress((vm.salespoint.pointlocation.number + ", " + vm.salespoint.pointlocation.address + ", " + vm.salespoint.pointlocation.neighborhood + ", " + vm.salespoint.pointlocation.city + ", " + vm.salespoint.pointlocation.state + ", " + vm.salespoint.pointlocation.country).replace(/undefined/g, '').replace(/null/g, '')).then(function(data) {
                     vm.salespoint.latitude = data.geometry.location.lat();
                     vm.salespoint.longitude = data.geometry.location.lng();
                 });
             }
         }
         
         function loadCountrysAndStates() {
             CheckCEPService.listStates().then(function (response) {
                 vm.states = response.data;
             });
             CheckCEPService.listCountrys().then(function (response) {
                 vm.countrys = response.data;
             });
             vm.salespoint = {
                "pointlocation" : {
                    "contactPhone" : $scope.store.contactPhone,
                    "name": $scope.store.name
                }
             }
         }

        $rootScope.$on('form-invalid-sales-point', function () {
            vm.formInvalid = true;
        });

        $rootScope.$on('get-sales-point', function () {
            $rootScope.salespoint = vm.salespoint;
        });
        
         loadCountrysAndStates();
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FormStoreLogoController', FormStoreLogoController);

    /** @ngInject */
    function FormStoreLogoController($scope) {

        var vm = this;
        vm.store = $scope.store;

        vm.imageSize = 500;
        vm.store.image = '';

        vm.openInput = function(evt) {
            document.getElementById('fileInput').click();
        }
        
        var handleFileSelect = function(evt) {
            var file = evt.currentTarget.files[0];
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function($scope){
                    $scope.logo.imageUpload = evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        };

        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FormStoreInfoController', FormStoreInfoController);

    /** @ngInject */
    function FormStoreInfoController($scope, CategoryService, $translate, HubService, StoreTypeService, Principal) {

        var vm = this;
        vm.store = $scope.store;
        vm.storeTypes = [];
        vm.storeTypeDefault;

        loadAll();


        Principal.identity().then(function(account) {
            if (vm.store.email == null || vm.store.email == "") vm.store.email = account.email; 
            if (vm.store.contactPhone == null || vm.store.contactPhone == "") vm.store.contactPhone = account.phone; 
        });

        function loadAll() {
            CategoryService.listCategories($translate.use()).then(function(response) {
                vm.categories = response.data;
            });
            StoreTypeService.getAllStoreTypesByToken().then(function(response) {
                vm.storeTypes = response;
                if (vm.store && !vm.store.storeType) {
                vm.storeTypeDefault = vm.storeTypes.find(function (type) {
                    return type.name == 'Loja Própria';         
                  });
                  vm.store.storeType = vm.storeTypeDefault.id.toString();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FormFirstStoreController', FormFirstStoreController);

    /** @ngInject */

    function FormFirstStoreController($rootScope, $scope, formStepsStates, $state, StoreService, $q, $translate, toastr, Auth, $window, $sessionStorage) {

        resetStateForm();

        $scope.store = {};

        $scope.logo = {
            imageUpload: '',
            imageChanged: false
        };

        $scope.maker = {
            actualMarker: 0
        };
        $scope.markers = [];

        $scope.submitted = false;

        $scope.updateInfoAndLogoStateStep = updateInfoAndLogoStateStep;
        $scope.fillNickname = fillNickname;

        $scope.domainSufix = '.' + getDomainNameSufix($window);

        $scope.isMobile = detectar_mobile();

        var storeDefaultImg = 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/' +$rootScope.urlImage+ '/defaultImageCreateShowkase.png';

        function fillNickname(form) {
            form.nickname.$setTouched(); 
            if($scope.store.name) {
                var nameStore = $scope.store.name;
                nameStore = nameStore.replace(/[ÀÁÂÃÄÅàáâãäå]/g,"a");
                nameStore = nameStore.replace(/[ÈÉÊËèéêë]/g,"e");
                nameStore = nameStore.replace(/[ÍÌÎíìî]/g,"i");
                nameStore = nameStore.replace(/[çÇ]/g,"c");
                nameStore = nameStore.replace(/[^a-z0-9]/gi,'')
                $scope.store.nickname = nameStore.toLowerCase();
            } else {
                $scope.store.nickname = ''
            }
            this.updateInfoAndLogoStateStep(form.$valid);
            this.verifyNicknameIsAvailable(form);
        }

        function updateInfoAndLogoStateStep(value) {
            var stepIndex = _.findIndex(formStepsStates, function (o) {
                return o.uiSref === $state.current.name;
            });
            formStepsStates[stepIndex].valid = value;
            formStepsStates[stepIndex + 1].valid = value;
        }

        function resetStateForm() {
            angular.forEach(formStepsStates, function (state) {
                state.valid = false;
            });
        }

        $scope.verifyNicknameIsAvailable = function (form) {
            if ($scope.store.nickname) {
                StoreService.verifyIfNicknameAvailable($scope.store.nickname).then(function (result) {
                    if (!result.data) {
                        form.nickname.$setValidity('nicknameIsUnavailable', false);
                    } else {
                        form.nickname.$setValidity('nicknameIsUnavailable', true);
                    }
                }, function (error) {
                    form.nickname.$setValidity('nicknameIsUnavailable', false);
                });
            } else {
                form.nickname.$setValidity('nicknameIsUnavailable', true);
            }
        }

        $scope.$watch('store.nickname', function (newVal, oldVal) {
            if (newVal && newVal.length >= 20) {
                $scope.store.nickname = oldVal;
            }
        });

        $scope.verifyCnpjIsAvailable = function (form) {
            if ($scope.store.cnpj) {
                form.cnpj.$setValidity('cnpjInvalid', true);
                StoreService.verifyIfCnpjIsAvailable($scope.store.cnpj).then(function (result) {
                    if (!result.data) {
                        form.cnpj.$setValidity('cnpjIsUnavailable', false);
                    } else {
                        form.cnpj.$setValidity('cnpjIsUnavailable', true);
                    }
                }, function (error) {
                    form.cnpj.$setValidity('cnpjIsUnavailable', false);
                });
            } else {
                form.cnpj.$setValidity('cnpjIsUnavailable', true);
            }
        }

        function toDataURL(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        }

        function dataURItoBlob(dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataURI.split(',')[1]);
            }
            else {
                byteString = unescape(dataURI.split(',')[1]);
            }

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {
                type: mimeString
            });

        }

        $scope.goToStorePoint = function (form) {
            if (form.storeInfoForm.$invalid) {
                form.storeInfoForm.$submitted = true;
                return;
            }
            $state.go('store-point');
        };

        $scope.saveStore = function (form) {
            if (form.$invalid) {
                form.salesPointForm.$submitted = true;
                $rootScope.$emit('form-invalid-sales-point');
                return;
            }
            
            if (!$scope.store.image) {
                toDataURL(storeDefaultImg, function (dataUrl) {
                    $scope.store.image = dataURItoBlob(dataUrl);
                    save();
                });
            } else {
                $scope.store.image = $scope.store.image.type != 'image/png' ? dataURItoBlob(dataUrl) : $scope.store.image;
                save();
            }
        }

        function save() {
            $rootScope.$emit('get-sales-point');

            $scope.isSaving = true;
            $scope.store.logo = $scope.logo.imageChanged ? $scope.store.image : '';
            $scope.store.cnpj = $scope.store.cnpj === "" ? null : $scope.store.cnpj;
            $scope.store.points = [];

            $scope.store.contactWhatsApp = ($scope.store.contactWhatsApp) ? $scope.store.contactWhatsApp : $scope.store.contactPhone;
            
            if ($sessionStorage.clientHub) {
                $scope.store.hubToken = $sessionStorage.clientHub;
            }

            $scope.store.hub
            var point = {
                "name": $rootScope.salespoint.pointlocation.name,
                "contactPhone": $rootScope.salespoint.pointlocation.contactPhone,
                "postalCode": $rootScope.salespoint.pointlocation.postalCode,
                "country": $rootScope.salespoint.pointlocation.country,
                "city": $rootScope.salespoint.pointlocation.city,
                "state": $rootScope.salespoint.pointlocation.state,
                "address": $rootScope.salespoint.pointlocation.address,
                "neighborhood": $rootScope.salespoint.pointlocation.neighborhood,
                "number": $rootScope.salespoint.pointlocation.number,
                "coordinate": {
                    "latitude": $rootScope.salespoint.latitude,
                    "longitude": $rootScope.salespoint.longitude
                },
                "mainPoint": true
            }
            $scope.store.points.push(point);

            $q.all($scope.store.points).then(function () {

                StoreService.saveStoreImage($scope.store.image).then(function (response, error) {
                    $scope.store.image = '';
                    $scope.store.logo = '';
                    $scope.store.addImageFileDTO = response.data;
                    StoreService.addStore($scope.store).then(function (data) {
                        Auth.changeSession(data.id).then(
                            function () {
                                $scope.isSaving = false;
                                toastr.success($translate.instant('store-management.messages.create.success'));
                                $state.transitionTo('home', {}, {
                                    reload: true,
                                    inherit: false,
                                    notify: true
                                });
                            });
                    }, function (data) {
                        $scope.isSaving = false;
                        toastr.error($translate.instant('store-management.messages.create.error'));
                    });
                });
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .service('SocialMediaService', SocialMediaService);

    SocialMediaService.$inject = ['SocialMediaFactory', '$localStorage', 'Upload'];

    function SocialMediaService(SocialMediaFactory, $localStorage, Upload) {

        var service = {
            isFacebookConnected: isFacebookConnected,
            connectWithFacebook: connectWithFacebook,
            doAFacebookPost: doAFacebookPost,
            facebookDisconnect: facebookDisconnect,
            connectWithInstagram: connectWithInstagram,
            isInstagramConnected: isInstagramConnected,
            doAInstagramPost: doAInstagramPost,
            instagramDisconnect: instagramDisconnect
        };

        return service;

        function isFacebookConnected() {
            return SocialMediaFactory.isFacebookConnected().$promise;
        }

        function facebookDisconnect() { 
            return SocialMediaFactory.facebookDisconnect().$promise;
        }

        function connectWithFacebook(connectVMDTO) {
            return SocialMediaFactory.connectWithFacebook(connectVMDTO).$promise;
        }

        function doAFacebookPost(postDTO, onSuccess, onError) {
            return SocialMediaFactory.doAFacebookPost(postDTO, onSuccess, onError).$promise;
        }

        function doAInstagramPost(postDTO, onSuccess, onError) {
            return SocialMediaFactory.doAInstagramPost(postDTO, onSuccess, onError).$promise;
        }

        function connectWithInstagram(connectVMDTO) {
            return SocialMediaFactory.connectWithInstagram(connectVMDTO).$promise;
        }

        function isInstagramConnected() {
            return SocialMediaFactory.isInstagramConnected().$promise;
        }

        function instagramDisconnect() { 
            return SocialMediaFactory.instagramDisconnect().$promise;
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('SocialMediaFactory', SocialMediaFactory);

    SocialMediaFactory.$inject = ['$resource'];

    function SocialMediaFactory($resource) {
        var resourceUrl = '';
        return $resource(resourceUrl, {}, {
            'isFacebookConnected': {
                method: 'GET',
                url: 'admin/api/auth/facebook/isconnected',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'connectWithFacebook': {
                method: 'POST',
                url: 'admin/api/auth/facebook/connect',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'doAFacebookPost': {
                method: 'POST',
                url: 'admin/api/social/facebook/post',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'facebookDisconnect': {
                method: 'GET',
                url: 'admin/api/auth/facebook/disconnect',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'connectWithInstagram': {
                method: 'POST',
                url: 'admin/api/auth/instagram/connect',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'isInstagramConnected': {
                method: 'GET',
                url: 'admin/api/auth/instagram/isconnected',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'doAInstagramPost': {
                method: 'POST',
                url: 'admin/api/social/instagram/post',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'instagramDisconnect': {
                method: 'POST',
                url: 'admin/api/auth/instagram/disconnect',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    function stateConfig($stateProvider) {
        $stateProvider
            .state('social-medias', {
                parent: 'admin',
                url: '/social-medias',
                data: {
                    authorities: ['STORE_READ_CUSTOMER', 'SOCIAL_MEDIA_POST'],
                    pageTitle: 'socialMedia.title',
                    // specialClass: "md-skin fixed-nav mini-navbar"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/social-media/social-media.html',
                        controller: 'SocialMediaController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('social-media');
                        $translatePartialLoader.addPart('integrations');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],

                    facebookConnected: function (SocialMediaService) {

                        function onSuccessIsFacebookConnect(response) {

                            var result = {};

                            if (response.data && response.data.accessToken) {
                                result = {

                                    facebookConnected: true,
                                    facebookDataConnected: response.data,

                                };

                                if (response.data.pages && response.data.pages[0]) {
                                    result.postDTO = {
                                        pageId: response.data.pages[0].pageId
                                    };
                                }

                                return result;

                            } else if (!response.data) {
                                result.facebookConnected = false;
                                result.facebookSelected = false;

                                return result;
                            }
                        }

                        function onErrorIsFacebookConnect(error){
                            var result = {
                                facebookConnected: false,
                                facebookSelected: false,
                            }

                            return result;
                        }

                        return SocialMediaService.isFacebookConnected().then(onSuccessIsFacebookConnect, onErrorIsFacebookConnect);

                    },
                    instagramConnected: function (SocialMediaService) {

                        function onSuccessIsInstagramConnect(response) {
                            if (response.data) {
                                return {
                                    instagramConnected: true,
                                    instagramAccountConnected: response.data
                                }
                            }
                            return {
                                instagramConnected: false
                            }
                        }

                        function onErrorIsInstagramConnect(error){
                            return {
                                instagramConnected: false
                            }
                        }

                        return SocialMediaService.isInstagramConnected().then(onSuccessIsInstagramConnect, onErrorIsInstagramConnect);

                    }
                }
            });
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('SocialMediaController', SocialMediaController);

    function SocialMediaController($scope, moment, FlyersService, FlyersCurrencyValue, $translate, SocialMediaService,
        toastr, Upload, $auth, SelectOfferModalService, facebookConnected, ModalFactory, InstagramLoginModalService, instagramConnected, $localStorage, FBAuthModalFactory) {

        var vm = this;

        var format = 'L LT';
        vm.isSaving = false;

        vm.postDTOForm = {};
        vm.facebookDataConnected = facebookConnected.facebookDataConnected || undefined;

        vm.postDTO = facebookConnected.postDTO || {};
        vm.postDTO.sendImmediately = true;
        vm.postDTO.picture = null;
        vm.postDTO.schedule = null;
        vm.postDTO.message = "";
        vm.postDTO.pageSelected = vm.facebookDataConnected ? angular.toJson(vm.facebookDataConnected.pages[0]) : undefined;

        vm.isToSchedule = false;
        vm.isToNow = true;

        vm.facebookConnected = facebookConnected.facebookConnected || false;
        vm.facebookSelected = facebookConnected.facebookSelected || false;

        vm.flyerId = undefined;

        vm.image = undefined;

        vm.firstTry = true;

        vm.init = init;

        vm.instagramConnected = instagramConnected.instagramConnected || false;
        vm.instagramAccountConnected = instagramConnected.instagramAccountConnected ? instagramConnected.instagramAccountConnected.username : null;
        vm.instagramSelected = false;

        function onSuccessPost(response) {
            toastr.success($translate.instant('socialMedia.success.successPost'));
            vm.isSaving = false;
            vm.postDTO = {};
            vm.postDTO.sendImmediately = true;
            vm.postDTO.picture = null;
            vm.postDTO.schedule = null;
            vm.postDTO.message = "";
        }

        function onErrorPost(response) {
            toastr.error($translate.instant('socialMedia.error.errorPost'));
            vm.isSaving = false;
            if (vm.facebookSelected) {
                vm.isFacebookConnected();
            } else if (vm.instagramSelected) {
                vm.isInstagramConnected();
            }

        }

        function onSuccessFacebookConnect(response) {
                vm.isFacebookConnected();
                toastr.success($translate.instant('socialMedia.success.successFacebookConnect'));
        }

        function onErrorFacebookConnect(error){
            if (error.data) {
                if (error.data.headers['x-adminapp-alert'] == 'noPagesFound'){
                    ModalFactory.openSimpleModal(
                        $translate.instant('socialMedia.error.noPagesFoundTitle'),
                        $translate.instant('socialMedia.error.noPagesFoundMessage'),
                        $translate.instant('socialMedia.error.noPagesFoundConfirmText'),
                        null,
                        vm.facebookDisconnect).then(null, function (result){
                            // If backdrop click, disconnect facebook;
                            vm.facebookDisconnect();
                        });
                }
            }
        }

        function onSuccessIsFacebookConnect(response) {
            if (response.data && response.data.accessToken) {
                vm.facebookConnected = true;
                vm.facebookDataConnected = response.data;
                if (response.data.pages && response.data.pages[0]){
                    vm.postDTO.pageId = response.data.pages[0].pageId;
                    vm.postDTO.pageSelected = angular.toJson(response.data.pages[0]);
                }
            } else {
                if (!vm.firstTry) {
                    vm.facebookConnected = false;
                    toastr.warning($translate.instant('socialMedia.error.facebookSessionExpired'));
                    vm.facebookSelected = false;
                    $('#button_facebook').css("background-color", "grey");
                }

            }

            vm.connectOrSelectFacebook(true);
        }


        function onSuccessFacebookDisconnect(response) {
            if (response.data) {
                vm.facebookConnected = false;
                vm.facebookSelected = false;
            } else {
                toastr.warning($translate.instant('socialMedia.error.cannotLoggout'));
            }

        }

        vm.openSelectionFlyers = function () {
            SelectOfferModalService.selectOffers(true, 'selectOfferModal.singleSelectionTitle').result.then(function (flyer) {
                if (flyer) {
                    vm.flyerId = flyer.id;
                    vm.postDTO.message = flyer.description;
                    vm.getImageFlyer();
                }
            });
        }

        vm.changePage = function () {
            if (!vm.postDTO.pageSelected) return;
            vm.postDTO.page = angular.fromJson(vm.postDTO.pageSelected);
            vm.postDTO.facebookPageId = vm.postDTO.page.pageId;
        }


        vm.doPost = function () {
            if (!vm.isInvalidForm()) {
                vm.isSaving = true;
                if (vm.postDTO.schedule && !checkStartDateHasPassed()) {
                    toastr.error($translate.instant('socialMedia.error.startDateHasPassed'));
                    vm.isSaving = false;
                    return;
                }
                if (vm.postDTO.schedule) {
                    if (moment(vm.postDTO.schedule, "DD/MM/YYYY hh:mm")._isValid) {
                        vm.postDTO.schedule = moment(vm.postDTO.schedule, "DD/MM/YYYY hh:mm");
                    } else if (moment(vm.postDTO.schedule, "MM/DD/YYYY hh:mm")._isValid){
                        var date = moment(vm.postDTO.schedule, "MM/DD/YYYY hh:mm A");
                        vm.postDTO.schedule = date;
                    }
                }
                if (vm.facebookSelected) {
                    SocialMediaService.doAFacebookPost(vm.postDTO, onSuccessPost, onErrorPost);
                } else {
                    vm.postDTO.post_type = 'feed';
                    SocialMediaService.doAInstagramPost(vm.postDTO, onSuccessPost, onErrorPost);
                }
            }
        }

        vm.getImageFlyer = function () {
            //TODO: Here it will be done a get to image if the flyer will be selected and no image uploaded!
            if (vm.flyerId) {
                FlyersService.getLinkImageFlyerAsString(vm.flyerId).then(function (response) {
                    vm.image = undefined;
                    vm.postDTO.picture = response.data;
                });
            }
        }

        function dataURItoBlob(dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {
                type: mimeString
            });
        }

        vm.facebookDisconnect = function(){
            SocialMediaService.facebookDisconnect().then(onSuccessFacebookDisconnect);
        }

        vm.selectedImage = function (file) {
            if (file) {
                Upload.base64DataUrl(file).then(function (url) {
                    vm.postDTO.picture = url;
                });
            }
        }

        vm.isFacebookConnected = function () {
            SocialMediaService.isFacebookConnected().then(onSuccessIsFacebookConnect);
        }

        function loadAll() {
            loadFlyers();
            vm.connectOrSelectFacebook(true);
            vm.connectOrSelectInstagram(true);
            vm.firstTry = false;
        }

        vm.excludeImageUploaded = function () {
            vm.image = undefined;
            vm.postDTO.picture = undefined;
        }

        vm.isInvalidForm = function () {
            vm.changePage();
            if (!vm.postDTO.message ||
                (!vm.facebookSelected && !vm.instagramSelected) ||
                (!vm.postDTO.picture && !vm.image) ||
                (vm.isToSchedule && !vm.postDTO.schedule) ||
                (vm.isToNow && !vm.postDTO.sendImmediately) ||
                (vm.facebookSelected && !vm.postDTO.page)) {
                return true;
            }
            return false;
        }

        function init() {

            dateTimePicker();
        }

        vm.toNow = function () {
            if (vm.isToNow) {
                vm.isToSchedule = false;
                vm.postDTO.sendImmediately = true;
            } else if (!vm.isToSchedule) {
                vm.isToNow = true;
            }

            vm.postDTO.schedule = undefined;
        }


        vm.toSchedule = function () {
            if (vm.isToSchedule) {
                vm.isToNow = false;
                vm.postDTO.sendImmediately = false;
            } else if (!vm.isToNow) {
                vm.isToSchedule = true;
            }
        }

        vm.connect = function (provider) {
            return $auth.authenticate(provider);
        }

        vm.connectOrSelectFacebook = function (toSelect) {
            if (vm.facebookConnected) {
                if (vm.facebookSelected) {
                    vm.facebookSelected = false;
                    $('#button_facebook').css("background-color", "grey");
                } else {
                    vm.facebookSelected = true;
                    vm.instagramSelected = false;
                    $('#button_facebook').css("background-color", "#4267b2");
                }
            } else if (!toSelect) {
                FBAuthModalFactory.connect(false).then(onSuccessFacebookConnect, onErrorFacebookConnect);
                // TODO: Aqui vai connectar o facebook e deixar selecionado
            }
        }

        function checkStartDateHasPassed() {
            if (!vm.postDTO.schedule) return false;
            return moment(vm.postDTO.schedule, format).isAfter(moment());
        }

        function dateTimePicker() {

            vm.scheduleOptions = {
                format: format,
                sideBySide: true,
                ignoreReadonly: true,
                locale: moment.locale(),
                allowInputToggle: true,
                useCurrent: false,
                defaultDate: vm.postDTO.schedule ? moment(vm.postDTO.schedule) : false,
                widgetPositioning: {
                    horizontal: 'auto',
                    vertical: 'top'
                }
            };

            angular.element('#schedulePicker').datetimepicker(vm.scheduleOptions).on('dp.change', function (ev) {
                angular.element('#schedulePicker').data("DateTimePicker").minDate(checkStartDateHasPassed() ? moment() : vm.postDTO.schedule);
                if (ev.date) {
                    vm.postDTO.schedule = ev.date.format(format);
                    $scope.$apply(function () {
                        vm.postDTOForm.schedule.$setValidity('minDate', true);
                    });
                } else {
                    vm.postDTO.schedule = undefined;
                }
            });

            vm.postDTO.schedule = vm.postDTO.schedule ? moment(vm.postDTO.schedule).format(format) : null;

            angular.element('#schedulePicker').data("DateTimePicker").minDate(checkStartDateHasPassed() ? moment() : vm.postDTO.schedule);

        }

        function loadFlyers() {

            FlyersService.listAllFlyers().then(onSuccess);

            function onSuccess(response) {
                vm.flyersFiltered = response;
            }
        }

        vm.getFlyerCurrency = function (currency) {
            return FlyersCurrencyValue[currency];
        }

        vm.toggleSelection = function toggleSelection(flyerId) {
            // Cannot have more than one, so follow the implementation
            if (vm.flyerId) {
                vm.flyerId = undefined;
                vm.postDTO.picture = undefined;
            } else {
                vm.flyerId = undefined;
                vm.getImageFlyer();
            }

        }

        function onSuccessIsInstagramConnect(response) {
            vm.instagramConnected = true;
        }

        function onErrorIsInstagramConnect(error) {
            if (error.status === 403) {
                vm.instagramConnected = vm.instagramSelected = false;
                toastr.warning($translate.instant('socialMedia.error.instagramSessionExpired'));
            } else {
                toastr.warning($translate.instant('socialMedia.error.errorInstagramConnect.connection'));
            }
        }

        vm.isInstagramConnected = function () {
            SocialMediaService.isInstagramConnected().then(onSuccessIsInstagramConnect, onErrorIsInstagramConnect);
        }

        vm.connectOrSelectInstagram = function (toSelect) {
            if (vm.instagramConnected) {
                if (vm.instagramSelected) {
                    vm.instagramSelected = false;
                } else {
                    vm.instagramSelected = true;
                    vm.facebookSelected = false;
                    vm.isToSchedule = false;
                    vm.isToNow = true;
                }
            } else if (!toSelect) {
                InstagramLoginModalService.openLoginModal(true, 'Instagram').result.then(function (result) {
                    if (result && result.data) {
                        vm.instagramConnected = true;
                        vm.instagramAccountConnected = result.data.username;
                        toastr.success($translate.instant('socialMedia.success.successInstagramConnect'));
                    } else {
                        toastr.warning($translate.instant('socialMedia.error.errorInstagramConnect.connection'));
                    }
                });
                }
        }

        function onSuccessInstagramDisconnect(response) {
            if (response.data) {
                vm.instagramConnected = false;
                vm.instagramSelected = false;
                vm.instagramAccountConnected = null;
            } else {
                toastr.warning($translate.instant('socialMedia.error.cannotLoggout'));
            }
        }

        function onErrorInstagramDisconnect() {
            toastr.warning($translate.instant('socialMedia.error.cannotLoggout'));
        }

        vm.instagramDisconnect = function () {
            SocialMediaService.instagramDisconnect().then(onSuccessInstagramDisconnect, onErrorInstagramDisconnect);
        }

        loadAll();

    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .service('UserService', UserService);

    UserService.$inject = ['UserFactory'];

    function UserService(UserFactory) {
        var service = {
                getUsers: getUsers,
                getUser: getUser,
                createUser: createUser,
                addUser: addUser,
                deleteUser: deleteUser,
                updateUser: updateUser,
                listUsers: listUsers,
                listUsersByStoreId: listUsersByStoreId,
                findByEmail: findByEmail,
                listUserGenders: listUserGenders,
                listUserGendersToSelectComponent: listUserGendersToSelectComponent,
                getUsersSellers: getUsersSellers

        };

        return service;

        function getUser(userInfo) {
            return UserFactory.get(userInfo).$promise;
        }

        function getUsers() {
            return UserFactory.query({}).$promise;
        }

        function getUsersSellers(params) {
            return UserFactory.listUserSellers(params).$promise;
        }

        function createUser(user) {
            return UserFactory.save(user).$promise;
        }

        function addUser(email, phone, profileId, storeId){
            return UserFactory.addUser({
                email: email,
                phone: phone,
                profileId: profileId,
                storeId: storeId
            }).$promise;
        }

        function updateUser(user) {
            return UserFactory.update(user).$promise;
        }

        function deleteUser(userInfo) {
            return UserFactory.delete(userInfo).$promise;
        }

        function listUsers(pageable) {
            return UserFactory.get(pageable).$promise;
        }

        function listUsersByStoreId(pageable, userStoreId, params) {
            pageable.storeId = userStoreId;
            return UserFactory.listByParams(pageable, params).$promise;
        }
        
        function findByEmail(email) {
        	return UserFactory.findByEmail(email).$promise;
        }
        
        function listUserGenders() {
        	return UserFactory.listUserGenders().$promise;
        }

        function listUserGendersToSelectComponent() {
            return UserFactory.listUserGendersToSelectComponent().$promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('UserFactory', UserFactory);

    UserFactory.$inject = ['$resource'];

    function UserFactory ($resource) {
        return $resource('api/users/:login', {}, {
            'query': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'listByParams': {
                method: 'POST',
                url: '/api/users/list',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'addUser':{
                method: 'POST',
                url: '/api/users/add',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.headers = headers();
                    return response;
                }
            },
            'save': { 
            	method:'POST', 
            	transformResponse: function (data, headers) {
                    var response = {};
                    if(data) {
                    	response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'findByEmail': {
                method: 'GET',
                isArray: false,
                url: '/api/users/by-email/:email',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'listUserGenders': {
            	method: 'GET',
                isArray: true,
            	url: '/api/users/genders',
            	transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUserGendersToSelectComponent': {
                method: 'GET',
                url: '/api/users/genders/select-component',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUserSellers': {
            	method: 'GET',
            	url: '/api/users/list-all/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('MoipPlansFactory', MoipPlansFactory);

    MoipPlansFactory.$inject = ['$resource'];

    function MoipPlansFactory($resource) {
        var resourceUrl =  'api/signatures';

        return $resource(resourceUrl, {}, {
            'getSubscriber': {
                method: 'GET',
                url: resourceUrl + '/subscriber/:code',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getPlans': {
                method: 'GET',
                url: 'api/plan/list',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'createSubscriberFree': {
                method: 'GET',
                url: resourceUrl + '/subscription/free',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateSubscriber': {
                method: 'PUT',
                url: resourceUrl + '/subscriber',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'createSubscriber': {
                method: 'POST',
                url: resourceUrl + '/subscriber',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateSubscriberCard': {
                method: 'PUT',
                url: resourceUrl + '/subscriber/card',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'validateCoupon': {
                method: 'GET',
                url: resourceUrl + '/coupon/:coupon',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getPlanByCode': {
                method: 'GET',
                url: resourceUrl + '/plans/:code',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'isBilletOverdue': {
                method: 'GET',
                url: resourceUrl + '/subscription/is-actual-billet-overdue',
                transformResponse: function (data, headers){
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'generateBillet': {
                method: 'GET',
                url: resourceUrl + '/subscription/generate-billet',
                transformResponse: function (data, headers){
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'resetBillet': {
                method: 'GET',
                url: resourceUrl + '/subscription/reset-billet',
                transformResponse: function (data, headers){
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateSubscriptionGiftCard': {
                method: 'PUT',
                url: resourceUrl + '/subscription/updateGiftCard',
                transformResponse: function (data, headers){
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            }

        });
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('uiGridBuilder', uiGridBuilder);

    uiGridBuilder.$inject = ['$translate'];

    function uiGridBuilder($translate) {
        return {

            withDefaultOptions: function() {
                this.columnDefs = [];
                this.actions = undefined;
                this.enablePaginationControls = false,
                this.showGridFooter = false;
                this.showHeader = true;
                this.enablePaging = true;
                this.enableColumnMenus = true;
                this.useExternalPagination = true;
                this.useExternalSorting = true;
                this.paginationPageSize = 10;
                this.maxPagesPagination = 4;
                return this;
            },

            withHeader: function(showHeader) {
                this.showHeader = showHeader;
                return this;
            },

            withInitialSort: function(columnName, ascendent) {
                this.initialSort = {};
                this.initialSort.columnName = columnName;
                this.initialSort.direction = 'asc';
                if ((ascendent !== undefined) && (ascendent !== null) && (ascendent == false)) {
                    this.initialSort.direction = 'desc';
                }
                return this;
            },

            withColumns: function(columnDefs) {
                // for (var i = 0; i < columnDefs.length; i++) {
                //     this.columnDefs.push({field: columnDefs[i].field, displayName: $translate.instant(columnDefs[i].displayName)});
                // }
                this.columnDefs = columnDefs;
                return this;
            },

            withActionColumn: function(columnWidth) {
                this.showActionColumn = true;
                this.actionColumnWidth = columnWidth;
                return this;
            },

            addActionToActionColumn: function(name, methodName, icon, linkClasses, visibilityExpression, disabledExpression) {
                if (this.actions === undefined) {
                    this.actions = [];
                }
                this.actions.push(new UiGridAction(name, methodName, icon, linkClasses, visibilityExpression, disabledExpression));
                return this;
            },

            conditionallyAddActionToActionColumn: function(canAdd, name, methodName, icon, linkClasses, visibilityExpression, disabledExpression) {
                if (canAdd) {
                    return this.addActionToActionColumn(name, methodName, icon, linkClasses, visibilityExpression, disabledExpression);
                }
                return this;
            },

            build: function(searchMethodName) {
                var options = {};
                options.searchMethodName = searchMethodName;
                options.showGridFooter = this.showGridFooter;
                options.showHeader = this.showHeader;
                options.enablePaging = this.enablePaging;
                options.useExternalPagination = this.useExternalPagination;
                options.useExternalSorting = this.useExternalSorting;
                options.enableColumnMenus = this.enableColumnMenus;
                options.totalItems = 0;
                options.paginationPageSizes = this.paginationPageSizes;
                options.paginationPageSize = this.paginationPageSize;
                options.enablePaginationControls = this.enablePaginationControls;
                options.columnDefs = this.columnDefs;
                options.$initialSort = this.initialSort;
                options.maxPagesPagination = this.maxPagesPagination;
                options.enableFiltering = this.enableFiltering;
                options.paginationOptions = {
                    pageNumber: 1,
                    pageSize: this.paginationPageSize,
                    sort: null
                };

                // Action Column
                if ((this.showActionColumn) && (this.actions !== undefined) && (this.actions.length > 0)) {
                    var actionColDef = {
                        displayName: 'Actions',
                        name: 'actions',
                        enableSorting: false,
                        cellClass: 'text-center',
                    };
                    actionColDef.width = this.actionColumnWidth;
                    if (this.actions !== undefined) {
                        var actionColumnTemplate = '';
                        for (var i = 0; i < this.actions.length; i++) {
                            var action = this.actions[i];
                            var ngIf = '';
                            var ngDisabled = '';
                            if (action.visibilityExpression !== undefined) {
                                ngIf = ' ng-if="' + action.visibilityExpression + '"';
                            }
                            if (action.disabledExpression !== undefined) {
                                ngDisabled = ' ng-disabled="' + action.disabledExpression + '"';
                            }
                            actionColumnTemplate +=
                                '<a title="' + action.name + '"'
                                + ngIf
                                + ngDisabled
                                + ' ng-click="grid.appScope.' + action.methodName + '(row.entity);"'
                                + ' class="btn btn-link btn-sm ' + action.linkClasses + '">'
                                + '<i class="' + action.icon + '"></i></a>';
                        }
                        actionColDef.cellTemplate = '<div class="ui-grid-action-cell-contents">' + actionColumnTemplate + '</div>';
                    }
                    options.columnDefs.push(actionColDef);
                }

                options.getPageAndSortOptions = function() {
                    return new Pageable(this.paginationOptions.pageNumber - 1,
                        this.paginationOptions.pageSize, this.paginationOptions.sort);
                }

                options.getArrayPagination = function(callback) {
                     refreshPagination(this, this.gridApiTable, this.maxPagesPagination, function (arrayPagination) {
                         callback(arrayPagination);
                     });
                }

                options.update = function(content, total) {
                    this.data = content;
                    this.totalItems = total;
                }

                options.changeColumns = function(columns) {
                    options.columnDefs = columns;
                }

                options.onRegisterApi = function(gridApi) {
                    options.gridApiTable = gridApi;
                    gridApi.grid.appScope.$gridApi = gridApi;

                    gridApi.core.on.sortChanged(gridApi.grid.appScope, function(grid, sortColumns) {
                        var sort = [];
                        for (var i = 0; i < sortColumns.length; i++) {
                            sort.push(new Sort(sortColumns[i].field, sortColumns[i].sort.direction));
                        }
                        grid.options.paginationOptions.sort = sort;
                        gridApi.grid.appScope[options.searchMethodName]();
                    });
                    gridApi.pagination.on.paginationChanged(gridApi.grid.appScope, function (newPage, pageSize) {
                        gridApi.grid.options.paginationOptions.pageNumber = newPage;
                        gridApi.grid.options.paginationOptions.pageSize = pageSize;
                        gridApi.grid.appScope[options.searchMethodName]();
                    });
                    gridApi.core.on.rowsRendered(gridApi.grid.appScope, function(gridApi) {
                        if (gridApi.initialized === undefined) {
                            gridApi.initialized = true;
                            var initialSort = gridApi.grid.options.$initialSort;
                            if (initialSort !== undefined) {
                                var column = gridApi.grid.getColumn(initialSort.columnName);
                                if (column != null) {
                                    gridApi.grid.sortColumn(column, initialSort.direction);
                                } else {
                                    gridApi.grid.appScope[options.searchMethodName]();
                                }
                            } else {
                                gridApi.grid.appScope[options.searchMethodName]();
                            }
                        }
                    });
                }

                options.getApiGridTable = function() {
                    return this.gridApiTable;
                };

                options.setPaginationPageSizes = function(sizes) {
                    options.paginationPageSizes = sizes;
                };

                return options;
            }
        }
    }

    function Sort(field, direction) {
        this.field = field;
        if ((direction == 'asc') || (direction == 'desc')) {
            this.direction = direction;
        } else {
            this.direction = 'asc';
        }
    }

    function Pageable(pageNumber, pageSize, sort) {
        if ((pageNumber !== undefined) && (pageNumber !== null)) {
            this.pageNumber = pageNumber;
        } else {
            this.pageNumber = 0;
        }

        if ((pageSize !== undefined) && (pageSize !== null)) {
            this.pageSize = pageSize;
        } else {
            this.pageSize = 10;
        }

        this.sort = sort;

        this.getQueryString = function() {
            var result = '?size=' + this.pageSize;
            result += '&page=' + this.pageNumber;
            if ((this.sort !== null) && (this.sort !== undefined)) {
                for (var i = 0; i < this.sort.length; i++) {
                    result += '&sort=' + this.sort[i].field + ',' + this.sort[i].direction;
                }
            }
            return result;
        }

        this.getPageAbleObj =  function() {
            var PageAbleObj = {
                size: this.pageSize,
                page: this.pageNumber,
                sort: []
            }

            if ((this.sort !== null) && (this.sort !== undefined)) {
                for (var i = 0; i < this.sort.length; i++) {
                    PageAbleObj.sort.push(this.sort[i].field + ',' + this.sort[i].direction);
                }
            }
            return PageAbleObj;
        }
    }

    function refreshPagination(gridTableOptions, gridTableApi, maxPages, callback) {
        var totalPages = gridTableApi.pagination.getTotalPages();
        var actualPage = gridTableApi.pagination.getPage();
        if (totalPages > maxPages) {
            calcPagination(gridTableApi, maxPages, function (qtdLeft, qtdRight) {
                var arrayPagination = createArrayPagination(actualPage, qtdLeft, qtdRight);
                callback(arrayPagination);
            });
        } else {
            callback(createArray(totalPages));
        }
    }

    function calcPagination(gridTableApi, maxPages, callback) {
        var totalPages = gridTableApi.pagination.getTotalPages();
        var actualPage = gridTableApi.pagination.getPage();
        var halfMaxPages = maxPages/2;
        var qtdLeft = 0, qtdRight = 0
        var calcPageLeft = actualPage - halfMaxPages;
        var calcPageRight = actualPage + halfMaxPages;
        if (actualPage > 1) {
                qtdLeft = (actualPage - halfMaxPages) >= 1 ? halfMaxPages : actualPage - 1;
                qtdLeft = qtdLeft === 0 ? 1 : qtdLeft;
            }
            if (actualPage < totalPages) {
                if (calcPageRight >= totalPages) {
                    qtdRight = totalPages - calcPageRight;
                    if (qtdRight <= 0) {
                        qtdRight = totalPages - actualPage;
                    }
                } else {
                    qtdRight = maxPages;
                }
                if (qtdLeft >= 1 && (qtdRight > qtdLeft)) {
                    qtdRight -= qtdLeft;
                }
            }
        qtdLeft = qtdLeft > qtdRight ? maxPages - qtdRight : qtdLeft;
        callback(qtdLeft, qtdRight);
    }

    function createArrayPagination(actualPage, qtdLeft, qtdRight) {
        var arrayPagination = [];
        if (qtdLeft > 0) {
            for (var x = actualPage - qtdLeft; x < actualPage; x++) {
                arrayPagination.push(x);
            }
        }
        arrayPagination.push(actualPage);
        if (qtdRight > 0) {
            for (var y = actualPage + 1; y < (actualPage + qtdRight + 1); y++) {
                arrayPagination.push(y);
            }
        }
        return arrayPagination;
    }


    function createArray(range, divisor) {
            if(!divisor)divisor = 0;
            if (divisor!=0) {
                range = range/divisor;
            }
            var values = [];
            var iteratorNumber = 0;
            for (var i = 0; i < range; i++) {
              iteratorNumber = divisor!=0 ? i*divisor : i+1;
              values.push(iteratorNumber);
            }
            return values;
    };

    function UiGridAction(name, methodName, icon, linkClasses, visibilityExpression, disabledExpression) {
        this.name = name;
        this.methodName = methodName;
        this.icon = icon;
        this.linkClasses = linkClasses;
        this.visibilityExpression = visibilityExpression;
        this.disabledExpression = disabledExpression;
    }


})();

'use strict';

/**
 * @ngdoc function
 * @name kscFinaluserApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the kscFinaluserApp
 */
angular.module('showcaseApp')
    .service('TimeService', function() {
        return {
            calcTimeDifference: calcTimeDifference
        }

        function calcTimeDifference(expirationDate) {
            var now = new Date();
            var expiration = new Date(expirationDate);
            var ms = moment(expiration, "DD/MM/YYYY HH:mm:ss").diff(moment(now, "DD/MM/YYYY HH:mm:ss"));
            var d = moment.duration(ms);
            return (d.days() + "d " + d.minutes() + "m " + d.seconds() + "s");
        }

    });

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('RemoveCouponModalController', RemoveCouponModalController);

        RemoveCouponModalController.$inject = ['$scope', '$uibModal', '$uibModalInstance', 'toastr'];

    function RemoveCouponModalController($scope, $uibModal, $uibModalInstance, toastr) {
        var vm = this;

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.closeModal = function() {
            $uibModalInstance.dismiss();
        }

    }

})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("RemoveModalFactory", RemoveModalFactory);


    /** @ngInject */
    function RemoveModalFactory($uibModal) {

        var factory = {
            deleteItem: deleteItem,
            deleteCoupon: deleteCoupon
        };

        return factory;


        function deleteItem(itens) {
            return $uibModal.open({
                templateUrl: 'app/services/global/remove/remove.modal.html',
                controller: 'RemoveModalController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    itens: function() {
                        return itens;
                    }
                }
            }).result;
        }

        function deleteCoupon() {
            return $uibModal.open({
                templateUrl: 'app/services/global/remove/remove-coupon.modal.html',
                controller: 'RemoveCouponModalController',
                controllerAs: 'vm',
                size: 'md'
            }).result;
        }


    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('RemoveModalController', RemoveModalController);

    RemoveModalController.$inject = ['$scope', '$uibModal', '$uibModalInstance', 'toastr', 'itens'];

    function RemoveModalController($scope, $uibModal, $uibModalInstance, toastr, itens) {
        var vm = this;
        vm.itens = itens;

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.closeModal = function() {
            $uibModalInstance.dismiss();
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('WarningMessageModalController', WarningMessageModalController);

    function WarningMessageModalController($uibModalInstance, modalTitle, modalMessage, smallText, warningText,
                                          buttonConfirmText, buttonCancelText, buttonConfirmAction, buttonCancelAction) {
        var vm = this;

        vm.modalTitle = modalTitle;
        vm.modalMessage = modalMessage;
        vm.smallText = smallText;
        vm.warningText = warningText;
        vm.buttonConfirmText = buttonConfirmText;
        vm.buttonCancelText = buttonCancelText;
        vm.buttonConfirmAction = action;

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.closeModal = function() {
            if (buttonCancelAction) {
                buttonCancelAction();
            }
            $uibModalInstance.dismiss(true);
        }

        function action(){
            buttonConfirmAction();
            vm.confirm();
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("ModalFactory", ModalFactory);

    /** @ngInject */
    function ModalFactory($uibModal) {
        var factory = {
            openModal: openModal,
            openSimpleModal: openSimpleModal,
            openWarningModal: openWarningModal,
            openSelectGMBAccountAndCategoryModal: openSelectGMBAccountAndCategoryModal,
            openWhatsappQRCodeModal: openWhatsappQRCodeModal,
            openWhatsappConfirmModal: openWhatsappConfirmModal,
            openWhatsappResumeQrCodeModal: openWhatsappResumeQrCodeModal,
            openDetailInvoice: openDetailInvoice,
            openDiscountModal: openDiscountModal,
            openSyncWithHubModal: openSyncWithHubModal
        };
        return factory;

        function openModal(modalTitle, modalMessage, modalSubMessage, buttonMessage, buttonBodyMessage,
            buttonOk, buttonAction, withHeader, withFooter, centralIcon, interactiveTranslate,
            functionTranslate, interactiveFunction, imageStyle, imageCentralIcon, fontSizeMessage, closeAfterAction) {
            $uibModal.open({
                templateUrl: 'app/services/global/message/message.modal.html',
                controller: 'MessageModalController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {

                    modalTitle: function () {
                        return modalTitle;
                    },
                    modalMessage: function () {
                        return modalMessage;
                    },
                    modalSubMessage: function () {
                        return modalSubMessage;
                    },
                    buttonMessage: function () {
                        return buttonMessage;
                    },
                    buttonBodyMessage: function () {
                        return buttonBodyMessage;
                    },
                    buttonOk: function () {
                        return buttonOk;
                    },
                    buttonAction: function () {
                        return buttonAction;
                    },
                    withHeader: function () {
                        return withHeader;
                    },
                    withFooter: function () {
                        return withFooter;
                    },
                    centralIcon: function () {
                        return centralIcon;
                    },
                    functionTranslate: function () {
                        return functionTranslate;
                    },
                    interactiveTranslate: function () {
                        return interactiveTranslate;
                    },
                    interactiveFunction: function () {
                        return interactiveFunction;
                    },
                    imageStyle: function () {
                        return imageStyle;
                    },
                    imageCentralIcon: function () {
                        return imageCentralIcon;
                    },
                    fontSizeMessage: function () {
                        return fontSizeMessage;
                    },
                    closeAfterAction: function () {
                        return closeAfterAction;
                    }

                }
            }).result;
        }

        function openSimpleModal(modalTitle, modalMessage, buttonConfirmText, buttonCancelText, buttonConfirmAction) {
            return $uibModal.open({
                templateUrl: 'app/services/global/message/message.modal.simple.html',
                controller: 'MessageModalSimpleController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {

                    modalTitle: function () {
                        return modalTitle;
                    },
                    modalMessage: function () {
                        return modalMessage;
                    },
                    buttonConfirmText: function () {
                        return buttonConfirmText;
                    },
                    buttonCancelText: function () {
                        return buttonCancelText;
                    },
                    buttonConfirmAction: function () {
                        return buttonConfirmAction;
                    }

                }
            }).result;
        }

        function openWarningModal(modalTitle, modalMessage, smallText, warningText, buttonConfirmText, buttonCancelText, buttonConfirmAction, buttonCancelAction) {
            return $uibModal.open({
                templateUrl: 'app/services/global/message/warning-modal.html',
                controller: 'WarningMessageModalController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {

                    modalTitle: function () {
                        return modalTitle;
                    },
                    modalMessage: function () {
                        return modalMessage;
                    },
                    smallText: function () {
                        return smallText
                    },
                    warningText: function () {
                        return warningText
                    },
                    buttonConfirmText: function () {
                        return buttonConfirmText;
                    },
                    buttonCancelText: function () {
                        return buttonCancelText;
                    },
                    buttonConfirmAction: function () {
                        return buttonConfirmAction;
                    },
                    buttonCancelAction: function () {
                        return buttonCancelAction;
                    }
                }
            }).result;
        }

        function openSelectGMBAccountAndCategoryModal(googleAccounts) {
            return $uibModal.open({
                templateUrl: 'app/integrations/google-my-business/gmb-select-gmb-configurations-modal.html',
                controller: 'SelectGMBConfigurationsController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {

                    googleAccounts: function(){
                        return googleAccounts;
                    }

                }
            }).result;
        }

        function openWhatsappQRCodeModal(biWhatsappConfiguration) {
            return $uibModal.open({
                templateUrl: 'app/integrations/whatsapp/whatsapp-qrcode-viewer.html',
                controller: 'WhatsappQrCodeController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {

                    biWhatsappConfiguration: function() {
                        return biWhatsappConfiguration;
                    }

                }
            }).result;
        }

        function openWhatsappResumeQrCodeModal(resume) {
            return $uibModal.open({
                templateUrl: 'app/integrations/whatsapp/whatsapp-resume-detail.html',
                controller: 'WhatsappResumeQrCodeController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {

                    resume: function() {
                        return resume;
                    }

                }
            }).result;
        }

        function openWhatsappConfirmModal(messagesInfo) {
            return $uibModal.open({
                templateUrl: 'app/integrations/whatsapp/whatsapp-job-modal.html',
                controller: 'WhatsappConfirmationModalController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {

                    messagesInfo: function() {
                        return messagesInfo;
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('integrations');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }
            }).result;
        }

        function openDetailInvoice(data, userProfile) {
            return $uibModal.open({
                templateUrl: 'app/admin/invoices/invoice-modal-detail.html',
                controller: 'InvoiceModalDetailController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    invoice: function() {
                        return data;
                    },
                    userProfile: function() {
                        return userProfile;
                    }
                }
            }).result;
        }

        function openDiscountModal(modalTitle, modalSubtitle, inputLabel, inputFooter, buttonConfirmText, buttonCancelText, buttonConfirmAction) {
            return $uibModal.open({
                templateUrl: 'app/admin/flyers/apply-discount-modal/apply-discount.modal.html',
                controller: 'ApplyDiscountModalController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {

                    modalTitle: function () {
                        return modalTitle;
                    },
                    modalSubtitle: function () {
                        return modalSubtitle;
                    },
                    inputLabel: function () {
                        return inputLabel;
                    },
                    inputFooter: function () {
                        return inputFooter;
                    },
                    buttonConfirmText: function () {
                        return buttonConfirmText;
                    },
                    buttonCancelText: function () {
                        return buttonCancelText;
                    },
                    buttonConfirmAction: function () {
                        return buttonConfirmAction;
                    }

                }
            }).result;
        }

        function openSyncWithHubModal(modalTitle, modalMessage, smallText, warningText, checkBoxes, buttonConfirmText, buttonCancelText, buttonConfirmAction) {
            return $uibModal.open({
                templateUrl: 'app/admin/flyers/sync-with-hub-modal/sync-with-hub.html',
                controller: 'SyncWithHubModalController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    modalTitle: function () {
                        return modalTitle;
                    },
                    modalMessage: function () {
                        return modalMessage;
                    },
                    smallText: function () {
                        return smallText
                    },
                    warningText: function () {
                        return warningText
                    },
                    checkBoxes: function () {
                        return checkBoxes
                    },
                    buttonConfirmText: function () {
                        return buttonConfirmText;
                    },
                    buttonCancelText: function () {
                        return buttonCancelText;
                    },
                    buttonConfirmAction: function () {
                        return buttonConfirmAction;
                    }

                }
            }).result;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('MessageModalSimpleController', MessageModalSimpleController);

    function MessageModalSimpleController($uibModalInstance, modalTitle, modalMessage, 
                                    buttonConfirmText, buttonCancelText, buttonConfirmAction) {
        var vm = this;

        vm.modalTitle = modalTitle;
        vm.modalMessage = modalMessage;
        vm.buttonConfirmText = buttonConfirmText;
        vm.buttonCancelText = buttonCancelText;
        vm.buttonConfirmAction = action;

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.closeModal = function() {
            $uibModalInstance.dismiss(true);
        }

        function action(){
            buttonConfirmAction();
            vm.confirm();
        }




        

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('MessageModalController', MessageModalController);

    function MessageModalController($uibModalInstance, modalTitle, modalMessage, 
                                    modalSubMessage, buttonMessage, withHeader, withFooter,
                                    buttonBodyMessage, buttonOk, buttonAction, centralIcon, interactiveTranslate, 
                                    functionTranslate, interactiveFunction, imageStyle, imageCentralIcon, fontSizeMessage, closeAfterAction, $rootScope) {
        var vm = this;

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.closeModal = function() {
            $uibModalInstance.dismiss();
        }

        vm.functionWaiter = true;

        function callback() {
            vm.functionWaiter = false;
        }

        $rootScope.$on('waiting-generates-tabloid', function(ev, next, current) {
            vm.functionWaiter = true;
        });

        $rootScope.$on('finish-generate-tabloid', function(ev, next, current) {
            vm.functionWaiter = false;
        });

        $rootScope.$on('waiting-generate-poster', function(ev, next, current) {
            vm.functionWaiter = true;
        });

        $rootScope.$on('finish-generate-poster', function(ev, next, current) {
            vm.functionWaiter = false;
        });

        vm.modalTitle = modalTitle;

        vm.fontSizeMessage = fontSizeMessage;
        
        vm.buttonMessage = buttonMessage;
        vm.buttonBodyMessage = buttonBodyMessage;
        vm.buttonOk = buttonOk;

        vm.modalMessage = modalMessage;
        vm.modalSubMessage = modalSubMessage;

        vm.withFooter = withFooter;
        vm.withHeader = withHeader;

        vm.doAction = buttonAction == 'close' ? vm.closeModal : function () {
            buttonAction();
            if (closeAfterAction) 
                vm.closeModal();
        };

        vm.centralIcon = centralIcon;

        vm.interactiveTranslate = interactiveTranslate;

        vm.functionTranslate = functionTranslate;

        vm.imageCentralIcon = imageCentralIcon;

        vm.imageStyle = imageStyle;

        vm.interactiveFunction = interactiveFunction ? function(){
            vm.functionWaiter = true;
            interactiveFunction(callback);
        } : undefined;

    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('GoogleMapsAddressFactory', GoogleMapsAddressFactory);

    GoogleMapsAddressFactory.$inject = ['$resource', '$http', '$q'];

    function GoogleMapsAddressFactory($resource, $http, $q) {
        return {
            getAddress: getAddress,
            getAddressByCoordinates: getAddressByCoordinates
        }

        function getAddress(userAddress) {
            var deferred = $q.defer();
            var geocoder = new google.maps.Geocoder();
            var geocoderRequest = { address: userAddress };
            geocoder.geocode(geocoderRequest, function(results, status){
                deferred.resolve(results[0]);
            });
            return deferred.promise;
        }

        function getAddressByCoordinates(markerLatLong) {
            var deferred = $q.defer();
            var geocoder = new google.maps.Geocoder();
            var geocoderRequest = { location: markerLatLong };
            geocoder.geocode(geocoderRequest, function(results, status){
                deferred.resolve(results[0]);
            });
            return deferred.promise;
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('GoogleMapsService', GoogleMapsService);

    GoogleMapsService.$inject = ['GoogleMapsAddressFactory'];

    function GoogleMapsService(GoogleMapsAddressFactory) {
        var service = {
                getAddress: getAddress,
                getAddressByCoordinates: getAddressByCoordinates
        };

        return service;

        function getAddress(pointAddress) {
            return GoogleMapsAddressFactory.getAddress(pointAddress);
        }

        function getAddressByCoordinates(lat, lng) {
            return GoogleMapsAddressFactory.getAddressByCoordinates({lat: parseFloat(lat), lng: parseFloat(lng)});
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("ConfirmActionModalFactory", ConfirmActionModalFactory);


    /** @ngInject */
    function ConfirmActionModalFactory($uibModal) {

        var factory = {
            confirmAction: confirmAction
        };

        return factory;

        function confirmAction() {
            return $uibModal.open({
                templateUrl: 'app/services/global/confirm-action/confirm-action.modal.html',
                controller: 'ConfirmActionModalController',
                controllerAs: 'vm',
                size: 'md'
            }).result;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ConfirmActionModalController', ConfirmActionModalController);

    ConfirmActionModalController.$inject = ['$scope', '$uibModal', '$uibModalInstance'];

    function ConfirmActionModalController($scope, $uibModal, $uibModalInstance) {
        var vm = this;

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.closeModal = function() {
            $uibModalInstance.dismiss();
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('CheckCEPStateFactory', CheckCEPStateFactory);

    CheckCEPStateFactory.$inject = ['$resource'];

    function CheckCEPStateFactory($resource) {
        var resourceUrl =  'zipcode/api/state';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('CheckCEPCountryFactory', CheckCEPCountryFactory);

    CheckCEPCountryFactory.$inject = ['$resource'];

    function CheckCEPCountryFactory($resource) {
        var resourceUrl =  'zipcode/api/country';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('CheckCEPService', CheckCEPService);

    CheckCEPService.$inject = ['CheckCEPFactory', 'CheckCEPStateFactory', 'CheckCEPCountryFactory'];

    function CheckCEPService(CheckCEPFactory, CheckCEPStateFactory, CheckCEPCountryFactory, $localStorage) {
        var service = {
                getAddress: getAddress,
                listCountrys: listCountrys,
                listStates: listStates
        };

        return service;

        function getAddress(cepAddress) {
            return CheckCEPFactory.get({cep: cepAddress}).$promise;
        }

        function listCountrys() {
            return CheckCEPCountryFactory.get().$promise;
        }

        function listStates() {
            return CheckCEPStateFactory.get().$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('CheckCEPFactory', CheckCEPFactory);

    CheckCEPFactory.$inject = ['$resource'];

    function CheckCEPFactory($resource) {
        var resourceUrl =  'zipcode/api/address/:cep';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    var response = {};
                    response.headers = headers();
                    try {
                        response.data = angular.fromJson(data);
                        return response
                    } catch (err){
                        return response;
                    }
                }
            }
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("ChangeStateModalFactory", ChangeStateModalFactory);


    /** @ngInject */
    function ChangeStateModalFactory($uibModal) {

        var factory = {
            update: update
        };

        return factory;

        function update(entity) {
            return $uibModal.open({
                templateUrl: 'app/services/global/change-state/change-state.modal.html',
                controller: 'ChangeStateModalController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function() {
                        return entity;
                    }
                }
            }).result;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ChangeStateModalController', ChangeStateModalController);

        ChangeStateModalController.$inject = ['$scope', '$uibModal', '$uibModalInstance', 'toastr', 'entity'];

    function ChangeStateModalController($scope, $uibModal, $uibModalInstance, toastr, entity) {
        var vm = this;
        vm.entity = entity;

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.closeModal = function() {
            $uibModalInstance.close(false);
        }

    }

})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("BlockPlanModalFactory", BlockPlanModalFactory);


    /** @ngInject */
    function BlockPlanModalFactory($uibModal) {

        var factory = {
            choosePlan: choosePlan
        };

        return factory;

        function choosePlan(entity) {
            return $uibModal.open({
                templateUrl: 'app/services/global/block-plan/block-plan.modal.html',
                controller: 'BlockPlanModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                keyboard : false,
                resolve: {
                    entity: function() {
                        return entity;
                    }
                }
            }).result;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('BlockPlanModalController', BlockPlanModalController);

        BlockPlanModalController.$inject = ['$uibModalInstance', '$state'];

    function BlockPlanModalController($uibModalInstance, $state) {
        var vm = this;

        vm.goToPlan = function() {
            $state.go('checkoutInner');
            $uibModalInstance.close(true);
        }

        vm.closeModal = function() {
            $state.go('home');
            $uibModalInstance.close(false);
        }

    }

})();

(function() {
	'use strict';

	angular.module('showcaseApp').service('BankDataService', BankDataService);

	BankDataService.$inject = [ 'BankDataFactory' ];

	function BankDataService(BankDataFactory) {
		var service = {
			getBanks : getBanks
		};

		return service;

		function getBanks() {
			var banks = BankDataFactory.getBanks().$promise;
			return banks;
		}

	}
})();

(function() {
	'use strict';

	angular.module('showcaseApp').factory('BankDataFactory', BankDataFactory);

	BankDataFactory.$inject = [ '$resource' ];

	function BankDataFactory($resource) {
		return $resource('api/bank-data/:id', {}, {
			'create' : {
				method : 'POST',
				transformResponse : function(data, headers) {
					var response = {};
					if (data) {
						response.data = angular.fromJson(data);
					}
					response.headers = headers();
					return response;
				}
			},
			'update' : {
				method : 'PUT'
			},
			'getBanks' : {
				method : 'GET',
				isArray : true,
				url : 'api/account/get_banks',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			}
		});
	}
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', '$localStorage', 'StoreFactoryAdmin', '$rootScope', '$location', 'CheckoutService'];

    function Principal($q, Account, $localStorage, StoreFactoryAdmin, $rootScope, $location, CheckoutService) {
        var _identity = undefined,
            _authenticated = false;
        var userPlanName = '';

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            hasPlan: hasPlan,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            storeOwnerHasMoipAccount: storeOwnerHasMoipAccount,
            disconnectFromPaymentGatewayWirecard: disconnectFromPaymentGatewayWirecard,
            isAvaliableUsername: isAvaliableUsername,
            isAvaliableEmail: isAvaliableEmail,
            savePushNotificationId: savePushNotificationId,
            isStoreOwner: isStoreOwner,
			forceLogout: forceLogout
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function() {
                return false;
            });
        }

        function hasPlan(plans) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                if ((_id.remainingTime && _id.remainingTime > 0) ||
                    plans.indexOf(userPlanName) !== -1) {
                    return true;
                }
            }, function() {
                return false;
            });
        }

        function storeOwnerHasMoipAccount() {
            return Account.storeOwnerHasMoipAccount().$promise;
        }

        function isStoreOwner() {
            return StoreFactoryAdmin.isStoreOwner().$promise;
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                if (account && account.data) {
                    _identity = account.data;
                    _authenticated = true;
                    $localStorage.userId = _identity.id;
                    $localStorage.defaultStore = _identity.userProfiles[0];
                    $localStorage.profiles = account.userProfiles;
                    $localStorage.profileAuthorities = account.data.authorities;

                    $localStorage.userIsExpired = account.isExpired;
                    $localStorage.statusPaymentSignature = account.statusPaymentSignature;
                    $localStorage.isExpired = account.isExpired;
                    $localStorage.isMoipPlanStarter = account.data.isMoipPlanStarter;
                    $localStorage.isMoipPlanFree = account.data.isMoipPlanFree;
                    var currentEnv = $location.absUrl().split('.')[1];
                    CheckoutService.getPlans(currentEnv).then(function(result) {
                        result.data.forEach(function(plan) {
                            if (plan.id == _identity.planId) {
                                userPlanName = plan.name.toUpperCase();
                            }
                        })
                        deferred.resolve(_identity);
                    }, function (error) {
                        deferred.resolve(error);
                    });
                } else {
                    deferred.resolve(_identity);
                }
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }


        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function isAvaliableUsername(username) {
            return Account.isAvaliableUsername(username).$promise;
        }

        function isAvaliableEmail(email) {
            return Account.isAvaliableEmail(email).$promise;
        }
        function savePushNotificationId(pushNotificationId) {
            return Account.savePushNotificationId(pushNotificationId).$promise;
        }
        function disconnectFromPaymentGatewayWirecard() {
            return Account.disconnectFromPaymentGatewayWirecard().$promise;
        }
		function forceLogout(){
			return Account.forceLogout().$promise;
		}
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('hasPlan', hasPlan);

    hasPlan.$inject = ['Principal'];

    function hasPlan(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasPlan.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasPlan(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'AuthServerSessionProvider', 'Account', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'toastr'];

    function Auth($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, AuthServerSessionProvider, Account, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, toastr) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            loginAuthCode: loginAuthCode,
            generateNewCode: generateNewCode,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            changeSession: changeSession,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            acceptedTerm: acceptedTerm
        };

        return service;

        function activateAccount(key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function(response) {
                    return cb(response);
                },
                function(err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();

                // // an authenticated user can't access to login and register pages
                // if ((isAuthenticated && $rootScope.toState.name === 'main-login') || (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth'))) {
                //     $state.go('home');
                // }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                // if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                //     var previousState = getPreviousState();
                //     resetPreviousState();
                //     $state.go(previousState.name, previousState.params);
                // }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    } else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        //storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        // $state.go('accessdenied').then(function() {
                        //     LoginService.open();
                        // });
                        service.logout();
                        $state.go('main-login');
                    }
                }
            }
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function() {
                return cb();
            }, function(err) {
                return cb(err);
            }).$promise;
        }

        function createAccount(account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function() {
                    return cb(account);
                },
                function(err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function(err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                if (data && data.data.tokenTwoFactorAuth) {
                    deferred.resolve(data);
                } else {
                    Principal.identity(true).then(function(account) {
                        deferred.resolve(data);
                    });
                    return cb();
                }
            }

            return deferred.promise;
        }

        function loginAuthCode(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();
            AuthServerProvider.loginWithCode(credentials)
                .then(loginThen)
                .catch(function(err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                 return cb();
            }

            return deferred.promise;
        }

        function generateNewCode(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.generateNewCode(credentials)
                .then(codeThen)
                .catch(function(err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function codeThen(data) {
                if (data) {
                    deferred.resolve(data);
                } else {
                    return cb();
                }
            }

            return deferred.promise;
        }

        function changeSession(storeId, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerSessionProvider.changeSession(storeId)
                .then(changeThen)
                .catch(function(err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function changeThen(data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function() {
                return cb();
            }, function(err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save({
                mail: mail
            }, function() {
                return cb();
            }, function(err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount(account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function() {
                    return cb(account);
                },
                function(err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function acceptedTerm(newStatus) {
            return Account.updateTerm(newStatus).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = {
                "name": previousStateName,
                "params": previousStateParams
            };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('AuthServerSessionProvider', AuthServerSessionProvider);

    AuthServerSessionProvider.$inject = ['$http', '$localStorage', '$sessionStorage'];

    function AuthServerSessionProvider ($http, $localStorage, $sessionStorage) {
        var service = {
            changeSession: changeSession,
            storeAuthenticationToken: storeAuthenticationToken
        };

        return service;

        function changeSession (storeId) {
            var data = {
                storeId: storeId
            };

            return $http.post('api/change-session', data).success(changeSessionSuccess);

            function changeSessionSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, true);
                    return jwt;
                }
            }
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithCode: loginWithCode,
            loginWithToken: loginWithToken,
            generateNewCode: generateNewCode,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                usernameOrEmail: credentials.usernameOrEmail,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (!data.tokenTwoFactorAuth && angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }
        
        function loginWithCode (credentials) {
            var data = {
                token: credentials.token,
                code: credentials.code
            };
            return $http.post('api/authenticate/code', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, true);
                    return jwt;
                }
            }
        }

        function generateNewCode (credentials) {
            
            var data = {
                token: credentials.token,
                code: credentials.code
            };
            return $http.post('api/authenticate/code-new', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                return data;
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            $localStorage.$reset();
            $sessionStorage.$reset();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account($resource) {
        var service = $resource('api/account', {}, {
            'get': {
                method: 'GET',
                params: {},
                isArray: false,
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            'isAvaliableUsername': {
                method: 'POST',
                params: {},
                isArray: false,
                url: 'api/account/is-avaliable-username',
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            'savePushNotificationId': {
                method: 'POST',
                params: {},
                isArray: false,
                url: 'api/account/save-push-notification-id',
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            'getGatewayWirecardPaymentLinks': {
                method: 'GET',
                isArray: false,
                url: 'api/gateway/get-payment-gateway-links',
                interceptor: {
                    response: function(response) {
                        return response.data;
                    }
                }
            },
            'isAvaliableEmail': {
                method: 'POST',
                params: {},
                isArray: false,
                url: 'api/account/is-avaliable-email',
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            'storeOwnerHasMoipAccount': {
                method: 'GET',
                params: {},
                isArray: false,
                url: 'api/account/te',
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            'setCodeAndSaveAccessToken': {
                method: 'GET',
                isArray: false,
                url: 'api/account/gateway-payment/receive-code/:code',
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            'disconnectFromPaymentGatewayWirecard': {
                method: 'GET',
                isArray: false,
                url: 'api/account/gateway-payment/disconnect',
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            'updateTerm': {
                method: 'POST',
                url: 'api/account/accepted-term'
            },
            'setRecipient': {
                method: 'POST',
                params: {},
                isArray: false,
                url: '/api/owner/:ownerId/recipient',
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            'updateRecipient': {
                method: 'PUT',
                params: {},
                isArray: false,
                url: '/api/owner/:ownerId/recipient',
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            'getRecipient': {
                method: 'GET',
                isArray: false,
                url: '/api/owner/:ownerId/recipient',
                 interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            'getBalance': {
                method: 'GET',
                params: {},
                isArray: false,
                url: '/api/owner/:ownerId/recipient/:recipientId/balance',
                 interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            'setCheckoutMethod': {
                method: 'PUT',
                params: {},
                isArray: false,
                url: 'api/account/checkout-method',
                transformResponse: function(data, headers) {
                    var response = {};
                    response.headers = headers();
                    try{
                        response.data = data;
                        return response
                    }catch (err){
                        return response;
                    }
                }
            },
            'forceLogout': {
                method: 'POST',
                params: {},
                isArray: false,
                url: 'api/account/forceLogout',
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            },
            'getOwnerKeys': {
                method: 'GET',
                url: '/flyer/api/payment/owner/keys/:storeId',
                transformResponse: function(data, headers) {
                    var response = {};
                    if(data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }

        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('NavigationController', NavigationController);

    function NavigationController($state, Auth, Principal, ProfileService, LoginService, $rootScope, $localStorage, StoreService, $window) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        vm.settingsAccount = null;
        vm.hubId = $localStorage.defaultStore.hubId;
        vm.isHubShowkase = false;
        vm.redirectUrl = undefined;

        setTimeout(function () {
            vm.storeCategory = $localStorage.defaultStore.category;
        }, 1000);

        if (window.location.host.includes('showkase')) {
            vm.isHubShowkase = true;
        }

        Principal.identity().then(function (account) {
            if (account) {
                vm.settingsAccount = angular.copy(account);
                loadStore();
                vm.userProfile = vm.settingsAccount.userProfiles[0];
				vm.isMoipPlanStarter = account.isMoipPlanStarter;
				vm.isMoipPlanFree = 	account.isMoipPlanFree;
            }
        });

        vm.disableOverflow = function () {
            event.stopPropagation();
        }

        vm.openMenu = function() {
            if(!angular.element('body').hasClass('body-small')){
                angular.element('body').addClass('fixed-sidebar');
                angular.element('body').removeClass('mini-navbar');
            }

        }
        vm.closeMenu = function() {
            if(!angular.element('body').hasClass('body-small')){
                angular.element('body').removeClass('fixed-sidebar');
                angular.element('body').addClass('mini-navbar');
            }
        }

        vm.redirectTo = function (page, sellerId) {
            var params = {
                sellerId: sellerId,
                page: "1",
                sort: "id,asc",
                type: undefined
            }

            $state.go(page, params);
        }

        vm.enableOverflow = function () {}

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('main-login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        $rootScope.$on('settings-updated', function () {
            Principal.identity().then(function (account) {
                if (account) {
                    vm.settingsAccount = angular.copy(account);
                    vm.userProfile = vm.settingsAccount.userProfiles[0];
                    loadStore();
                }
            });
        });

        function loadStore() {
            StoreService.getStore($localStorage.defaultStore.storeId, vm.settingsAccount.id).then(function(response) {
                $localStorage.defaultStore.storeType = response.data.storeType;
                $localStorage.defaultStore.defaultFilter = response.data.defaultFilter;
                vm.redirectUrl = response.data.redirectURL;
                vm.store = response.data;
                setStoreLogo();
            });
        }

        vm.getShowcaseURL = function() {
            if (vm.redirectUrl) {
                $window.open($window.location.protocol + '//' + vm.redirectUrl, '_blank');
            } else if (!$localStorage.defaultStore.storeNickname) {
                StoreService.getStore($localStorage.defaultStore.storeId, vm.settingsAccount ? vm.settingsAccount.id : null).then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    $localStorage.defaultStore.storeType = response.data.storeType;
                    vm.store = response.data;
                    setStoreLogo();
                    $window.open($window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType), '_blank');
                });
            } else {
                $window.open($window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType), '_blank');
            }

        }

        function setStoreLogo() {
            vm.store.logo = vm.store.logo ? vm.store.logo.replace('%25s', 'logo') : '/content/images/profile_small.png';
            $localStorage.defaultStore.performanceDashboard = vm.store.performanceDashboard;
            $localStorage.defaultStore.chatPerformanceDashboard = vm.store.chatPerformanceDashboard;
            $localStorage.defaultStore.sellerPerformanceDashboard = vm.store.sellerPerformanceDashboard;
            if (vm.settingsAccount && vm.settingsAccount.id) {
                $localStorage.defaultStore.sellerIndividualPerformanceDashboard = vm.store.sellerIndividualPerformanceDashboard;
            }
            $localStorage.defaultStore.abandonedCartDashboard = vm.store.abandonedCartDashboard;
            $localStorage.defaultStore.crmDashboard = vm.store.crmDashboard;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('TopNavbarController', TopNavbarController);

    TopNavbarController.$inject = ['$localStorage', '$state', 'Auth', 'StoreService', '$rootScope', 'Principal', '$scope', '$translate',
        '$uibModal', 'Constants', 'NotificationService', 'WsService', 'SettingsService', 'ChatService', 'ErpsSettingsService'];

    function TopNavbarController($localStorage, $state, Auth, StoreService, $rootScope, Principal, $scope, $translate, 
        $uibModal, Constants, NotificationService, WsService, SettingsService, ChatService, ErpsSettingsService) {

        var storeChangeSuccess = $scope.$on('storeChangeSuccess', storeChangeSuccessHandler);
        var NOTIFICATION_AUDIO_FILE = "../../assets/audio/notification_sound.mp3"

        var vm = this;

        vm.logout = logout;
        vm.changeSession = changeSession;
        vm.changeState = changeState;
        vm.hub = $localStorage.hub;

        vm.myStoresLoading = false;
        vm.notificationsCount = 0;
        vm.messagesCount = 0;
        vm.configuration = null;
        vm.whatsappSupportMessage = null;

        $rootScope.$on("UpdateNotificationCount", function(){
            $scope.parentmethod();
        });

        $scope.parentmethod = function() {
            getNotificationsInfo();
        }

        $rootScope.$on("settings-updated", function() {
            SettingsService.getRegister($localStorage.userId, $localStorage.defaultStore.storeId).then(function (data) {
                vm.systemNotificationsSound = data['soundNotification'];
            });
        });

        init();

        function init() {
            loadAccount();
            loadErpConfiguration();
        }

        function loadAccount() {
            Principal.identity().then(function(account) {
                if (account){
                    vm.account = angular.copy(account);
                    
                    updateDistance();
                    if (vm.account.userProfiles){
                        vm.userProfile = vm.account.userProfiles[0];
                        vm.isAdminAccount = vm.account.userProfiles[0].storeId == $rootScope.ADMIN_SYSTEM_ID;
                    }
                    if (!vm.isAdminAccount) {
                        getMyStores();
                        getStoreInfo();
                    }
                    getNotificationsInfo();
                    subscribeButtonHandler();
                }
            });
        }

        function loadErpConfiguration() {
            if ($localStorage.defaultStore) {
                ErpsSettingsService.getERPConfigurationByStoreId($localStorage.defaultStore.storeId)
                    .then(function (response) {
                        if (response.data && response.data.id) {
                            vm.configuration = response.data;
                            updateDistance();
                        }
                    });
            }
        }

        vm.getWhatsappIntegrationMessage = function() {
            var storeName = vm.store.name;
            var erpName = vm.getErpName();
            var message = $translate.instant('global.top-navbar.message.warning.whatsapp-support-message',
                { storeName: storeName, erpName: erpName });
            return 'https://api.whatsapp.com/send?phone=+558398931539&text='.concat(message);
        }

        vm.getTrialWarningMessage = function() {
            return $translate.instant('global.top-navbar.message.warning.trial',
                { remainingTime: vm.account.remainingTime });
        }
        
        vm.getIntegrationTokenFailedWarningMessage = function() {
            var erpName = vm.getErpName();
            return $translate.instant('global.top-navbar.message.warning.integration-token-failed',
                { erpName: erpName });
        }

        vm.getIntegrationUnexpectedWarningMessage = function() {
            var erpName = vm.getErpName();
            return $translate.instant('global.top-navbar.message.warning.integration-unexpected-failed',
                { erpName: erpName });
        }

        function playAudio() {
            var audio = new Audio();
            audio.src = NOTIFICATION_AUDIO_FILE;
            audio.load();
            audio.play();
        }

        function subscribeOnNotification(message) {
            getNotificationsInfo();
            playAudio();
        }

        function updateNotifications(message) {
            getNotificationsInfo();
        }

		vm.giftCardCheckout = function (){
			/*PlanModalFactory.choosePlan().then(function() {
            });*/
 			return $uibModal.open({
                templateUrl: 'app/account/checkout/gift-card/gift-card-checkout.html',
                controller: 'GiftCardCheckoutController',
                controllerAs: 'vm',
                size: 'lg',
                keyboard : false
            }).result;
		}

        function getNotificationsInfo() {
            NotificationService.getNotificationInfo(
                $localStorage.defaultStore.storeId,
                vm.account.id
            ).then(function (data) {
                vm.notificationsCount = data.notificationsCount;
                vm.messagesCount = data.messagesCount;
            });
        }

        function getStoreInfo() {
            if ($localStorage.defaultStore){
                StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
                    vm.store = response.data;
                    $localStorage.defaultStore.category = vm.store.categoryKey;
                    if(!vm.account.acceptedTerm) {
                        vm.account.acceptedTerm = true;
                        vm.checkedTermOfUse(vm.store.storeType);
                        subscribeButtonHandler();
                    }
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                });

                WsService.getInfo().then(function (result) {
                    vm.wsToken = result.token;

                    ChatService.connectWS(function () {
                        ChatService.subscribeOnNewNotifications($localStorage.defaultStore.storeId, subscribeOnNotification);
                        ChatService.subscribeOnNewNotifications(vm.account.id, subscribeOnNotification);
                        ChatService.subscribeOnUpdateNotifications($localStorage.defaultStore.storeId, updateNotifications);
                    });
                });
            }

        }

        function updateDistance()  {
            var cct = document.getElementById('cct');
            var breadcrumb = document.getElementById('breadcrumb');
            var navMenu = document.getElementById('nav-menu');
            if (vm.isTrial(vm.account) || vm.isIntegrationFailed(vm.configuration)) {
                if(cct) {
                    cct.style.marginTop = "85px"
                }
                if(breadcrumb) {
                    breadcrumb.style.marginTop = "35px"
                }
                if(navMenu) {
                    navMenu.style.marginTop = "35px"
                }
            }
        }

        function logout() {
            var failedAudioMessages = $localStorage.failedMessages
            Auth.logout();
            $state.go('main-login');
            $localStorage.failedMessages = failedAudioMessages
        }

        function getMyStores() {
            vm.myStoresLoading = true;
            StoreService.getMyStores().then(function(response) {
                vm.myStores = response.data;
                vm.myStoresLoading = false;
            });
        }

        function changeSession(storeId) {
            Auth.changeSession(storeId).then(
                function() {
                    $state.transitionTo('home', {}, {
                        reload: true,
                        inherit: false,
                        notify: true
                    });

                    if (Auth.getPreviousState()) {
                        var previousState = Auth.getPreviousState();
                        Auth.resetPreviousState();
                        $state.go(previousState.name, previousState.params);
                    }
                });
        }

        function storeChangeSuccessHandler() {
            getMyStores();
            getStoreInfo();
        }

        function changeState(state) {
            $state.go(state);
        }

        function subscribeButtonHandler() {
            // Prevent the user from clicking the subscribe button multiple times.
            Notification.requestPermission().then(function (result) {
                if (result === 'denied') {
                    return;
                }
                navigator.serviceWorker.getRegistration().then( function (registration) {
                    if (registration) {
                        registration.pushManager.getSubscription().then(function (subscribed) {
                            registration.pushManager.subscribe({
                                userVisibleOnly: true,
                                applicationServerKey: urlB64ToUint8Array('BF3vlHug3aBrL9pvwdHtLiOXi-AbBoZ_e-W5H_VMFoM8NwFV7vuRXz4jb2FJ6tcYSNJJqQqkfFgjkUn8jsAA7FA')
                            }).then(function (subscription) {
                                const subscriptionJSON = JSON.parse(JSON.stringify(subscription));
                                SettingsService.registerToReceiveNotifications(subscriptionJSON.endpoint,
                                    subscriptionJSON.keys.auth, subscriptionJSON.keys.p256dh, $localStorage.userId, $localStorage.defaultStore.storeId).then(function (data) {
                                    vm.registerId = data.id;
                                    vm.webNotifications = true;
                                });
                            });
                        });
                    } else {
                        vm.webNotifications = false;
                    }
                });
            });

        }

        function urlB64ToUint8Array(base64String) {
            const padding = '='.repeat((4 - base64String.length % 4) % 4);
            const base64 = (base64String + padding)
                .replace(/\-/g, '+')
                .replace(/_/g, '/');
            const rawData = window.atob(base64);
            const outputArray = new Uint8Array(rawData.length);
            for (var i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        }

        $rootScope.$on('user-logged-out', function () {
            $state.go($state.current, {}, {reload: true});
        });

        SettingsService.getRegister($localStorage.userId, $localStorage.defaultStore.storeId).then(function (data) {
            vm.systemNotificationsSound = data['soundNotification'];
        });

        vm.checkedTermOfUse = function (storeType) {
            $uibModal.open({
                templateUrl: 'app/admin/term-of-use/term-of-use.html',
                controller: 'TermOfUseController',
                controllerAs: 'vm',
                scope: $scope,
                keyboard: false,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    storeType: function() {
                        return storeType;
                    }
                }
            });
        }

        vm.openNotificationsModal = function () {
            vm.notificationsModal = $uibModal.open({
                templateUrl: 'app/admin/notification/modal/notificationList.html',
                controller: 'NotificationListController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false
            }).closed.then(function (response) {
                getNotificationsInfo();
            });
        }

        vm.openChecklistModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/admin/checklist/checklist.html',
                controller: 'ChecklistController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false
            }).result.then(function (response) {
                if (response) {
                    alert(response);
                }
            });
        }

        vm.isTrial = function(account) {
            return !isNullOrUndefined(account) && !isNullOrUndefined(account.remainingTime)
                && account.remainingTime > 0 && account.remainingTime <= 7;
        }

        vm.isIntegrationFailed = function() {
            return !isNullOrUndefined(vm.configuration) && !isNullOrUndefined(vm.configuration.id)
                && (vm.configuration.status == 'FAILED' || vm.configuration.status == 'INVALID_TOKEN');
        }

        vm.getErpName = function() {
            if (!isNullOrUndefined(vm.configuration) && !isNullOrUndefined(vm.configuration.partnerId)) {
                switch (vm.configuration.partnerId) {
                    case Constants.ErpPartnerId.VAREJO_ONLINE:
                        return "Varejo Online";
                    case Constants.ErpPartnerId.NEXAAS:
                        return "Nexaas";
                    case Constants.ErpPartnerId.BLING:
                        return "Bling";
                    default:
                        return "";
                }
            } else {
                return "";
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('getSupportContact', {
                url: '/get-support-contact',
                data: {
                    authorities: []
                },
                templateUrl: 'app/layouts/error/get-support-contact.html',
                controller: 'CheckoutController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                url: '/app/accessdenied',
                data: {
                    authorities: []
                },
                templateUrl: 'app/layouts/error/accessdenied.html',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .controller(
            'WhatsappResumeQrCodeController',
            WhatsappResumeQrCodeController
        );

    function WhatsappResumeQrCodeController(
        $uibModalInstance,
        resume,
        $translate,
        BusinessIntegrationService,
        $localStorage,
        $scope,
        $rootScope
    ) {
        var WHATSAPP_FETCH_INTERVAL = 3000;
        var vm = this;
        vm.resume = resume;
        vm.whatsappConf = null;
        vm.isWhatsappTabLoading = false;
        vm.isSending = false;

        function whatsappGetConfigurationCallback(response) {
            vm.whatsappModalConf = response.data;
            if (vm.whatsappModalConf && vm.whatsappModalConf.whatsappQRCode) {
                vm.isLoading = false;
                vm.isRefreshing = false;
            }
            if (
                vm.whatsappModalConf &&
                vm.whatsappModalConf.whatsappConnected
            ) {
                clearInterval($rootScope.fetchQrCodeInterval);
                $uibModalInstance.close('connected');
            } else if (
                vm.whatsappModalConf &&
                vm.whatsappModalConf.whatsappWaitTooLong
            ) {
                $uibModalInstance.close('expired');
                clearInterval($rootScope.fetchQrCodeInterval);
            }

            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }

        function loadModal() {
            vm.isLoading = true;
            initiateLoginMode();

            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }
        loadModal();

        function initiateLoginMode() {
            vm.isLoading = true;
            if (
                !vm.whatsappModalConf ||
                !vm.whatsappModalConf.whatsappConnected
            ) {
                BusinessIntegrationService.initiateWhatsappSync(
                    $localStorage.defaultStore
                        ? $localStorage.defaultStore.storeId || ''
                        : '',
                    'LOGIN_MODE',
                    function() {
                        fetchQrCode();
                        $rootScope.fetchQrCodeInterval = setInterval(
                            fetchQrCode,
                            WHATSAPP_FETCH_INTERVAL
                        );
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    },
                    function() {
                        toastr.error(
                            $translate.instant(
                                'integrations.whatsapp.messages.errorInitiateWhatsappLoginMode'
                            )
                        );
                        vm.isRefreshing = false;
                        vm.isLoading = false;
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    }
                );
            }
        }

        function fetchQrCode() {
            // Geeting initial configuration
            BusinessIntegrationService.getConfiguration(
                $localStorage.defaultStore
                    ? $localStorage.defaultStore.storeId || ''
                    : '',
                'WHATSAPP',
                whatsappGetConfigurationCallback,
                whatsappGetConfigurationErrorCallback
            );
        }

        function refreshWhatsappQrCode() {
            vm.isRefreshing = true;
            vm.isLoading = true;
            clearInterval($rootScope.fetchQrCodeInterval);
            BusinessIntegrationService.clearWhatsappData(
                $localStorage.defaultStore
                    ? $localStorage.defaultStore.storeId || ''
                    : '',
                function() {
                    initiateLoginMode();
                },
                function() {
                    initiateLoginMode();
                }
            );
        }

        function whatsappGetConfigurationErrorCallback() {
            toastr.error(
                $translate.instant(
                    'integrations.whatsapp.messages.errorGetConfiguration'
                )
            );
            clearInterval($rootScope.fetchQrCodeInterval);
            vm.isLoading = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('WhatsappQrCodeController', WhatsappQrCodeController);

    function WhatsappQrCodeController(
        $uibModalInstance,
        biWhatsappConfiguration,
        $localStorage,
        BusinessIntegrationService,
        $scope,
        toastr,
        $rootScope,
        CustomerService,
        ModalFactory,
        $translate,
        StoreInfoFactory,
        Upload
    ) {
        // 3 seconds of interval to fetch a new qrcode
        var WHATSAPP_FETCH_INTERVAL = 3000;

        var vm = this;

        $rootScope.fetchQrCodeInterval = null;

        vm.isLoading = true;
        vm.isRefreshing = false;

        vm.currentStep = 0;
        vm.totalOfSteps = 3;

        // 20 seconds in milliseconds
        vm.SPEND_TIME_PER_PHONE = 20000;

        vm.whatsappConf = null;
        vm.isWhatsappTabLoading = false;
        vm.isSending = false;
        vm.loadingCustomers = false;
        vm.selectedCustomers = [];
        vm.unselectedCustomers = [];
        vm.customers = [];

        vm.currentPage = 1;
        vm.numPerPage = 5;
        vm.maxSize = 5;
        vm.totalCustomers = 0;

        vm.wappDTO = {};
        vm.wappDTO.phones = [];
        vm.wappDTO.excludedPhones = [];
        vm.wappDTO.isAllCustomers = false;

        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.filter = {};

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        // Functions
        vm.selectCustomer = selectCustomer;
        vm.changePageCustomer = changePageCustomer;
        vm.sendMessage = sendMessage;
        vm.createNewClient = createNewClient;

        vm.whatsappModalConf = biWhatsappConfiguration;

        // Functions
        vm.refreshWhatsappQrCode = refreshWhatsappQrCode;
        vm.closeModal = closeModal;

        vm.showClientForm = showClientForm;
        vm.cancelCustomer = cancelCustomer;
        vm.searchByFilter = searchByFilter;

        vm.isClietFormVisible = false;

        function closeModal(method) {
            $uibModalInstance.dismiss(method);
        }

        function closeModalSuccessfully(method) {
            $uibModalInstance.close(method);
        }

        function whatsappGetConfigurationCallback(response) {
            vm.whatsappModalConf = response.data;
            if (vm.whatsappModalConf && vm.whatsappModalConf.whatsappQRCode) {
                vm.isLoading = false;
                vm.isRefreshing = false;
            }
            if (
                vm.whatsappModalConf &&
                vm.whatsappModalConf.whatsappConnected
            ) {
                clearInterval($rootScope.fetchQrCodeInterval);
                vm.next();
            } else if (
                vm.whatsappModalConf &&
                vm.whatsappModalConf.whatsappWaitTooLong
            ) {
                clearInterval($rootScope.fetchQrCodeInterval);
            }

            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }

        function whatsappGetConfigurationErrorCallback() {
            toastr.error(
                $translate.instant(
                    'integrations.whatsapp.messages.errorGetConfiguration'
                )
            );
            clearInterval($rootScope.fetchQrCodeInterval);
            vm.isLoading = false;
        }

        function sendMessage() {
            vm.isSending = true;
            if (vm.uploadFileDTO) {
                vm.wappDTO.file = vm.uploadFileDTO;
            }
            if (
                !vm.wappDTO.isAllCustomers &&
                vm.selectedCustomers &&
                vm.selectedCustomers.length < 1
            ) {
                toastr.error(
                    $translate.instant(
                        'integrations.whatsapp.messages.noSelectedNumbers'
                    )
                );
                vm.isSending = false;
            } else if (!vm.wappDTO.message || vm.wappDTO.message == '') {
                toastr.error(
                    $translate.instant(
                        'integrations.whatsapp.messages.noMessage'
                    )
                );
                vm.isSending = false;
            } else if (
                !vm.wappDTO.campaingName ||
                vm.wappDTO.campaingName == ''
            ) {
                toastr.error(
                    $translate.instant(
                        'integrations.whatsapp.messages.noCampaingName'
                    )
                );
                vm.isSending = false;
            } else {
                createAndSendANewWhatsappJob(saveWhatsappJob);
            }
        }

        function searchByFilter() {
            vm.currentPage = 1;
            vm.paginationOptions.page = 0;
            listCustomers(vm.paginationOptions, vm.filter, true);
        }

        function createAndSendANewWhatsappJob(callback) {
            vm.wappDTO.storeId = $localStorage.defaultStore
                ? $localStorage.defaultStore.storeId || ''
                : '';
            vm.selectedCustomers.forEach(function(cus) {
                vm.wappDTO.phones.push(cus.phone);
            });
            if (callback) callback();
        }

        function saveWhatsappJobCallback() {
            ModalFactory.openWhatsappConfirmModal();
            clearData();

            closeModalSuccessfully(vm.whatsappModalConf);
            vm.isSending = false;
        }

        function createNewClient() {
            vm.isSaving = true;
            vm.customer.storeId = StoreInfoFactory.getStoreId();
            CustomerService.create(vm.customer).then(onSuccess, onError);

            function onSuccess() {
                vm.isSaving = false;
                vm.customer = {};
                listCustomers(vm.paginationOptions, vm.filter);
            }

            function onError(error) {
                vm.isSaving = false;
                if (error.data.headers['x-adminapp-params']) {
                    toastr.error(
                        $translate.instant(
                            error.data.headers['x-adminapp-params']
                                .concat('.')
                                .concat(error.data.headers['x-adminapp-error'])
                        )
                    );
                } else {
                    toastr.error(
                        $translate.instant('global.messages.somethingWrong')
                    );
                }
            }
        }

        function cancelCustomer() {
            vm.customer = {};
            showClientForm();
        }

        function saveWhatsappJobErrorCallback() {
            toastr.error(
                $translate.instant(
                    'integrations.whatsapp.messages.errorWhatsappJobSave'
                )
            );
            vm.isSending = false;
            clearData();
            closeModal();
        }

        function saveWhatsappJob(callback) {
            var wappDTO = vm.wappDTO;
            BusinessIntegrationService.createWhatsappJob(
                wappDTO,
                saveWhatsappJobCallback,
                saveWhatsappJobErrorCallback
            );
            if (callback) callback();
        }

        function fetchQrCode() {
            // Geeting initial configuration
            BusinessIntegrationService.getConfiguration(
                $localStorage.defaultStore
                    ? $localStorage.defaultStore.storeId || ''
                    : '',
                'WHATSAPP',
                whatsappGetConfigurationCallback,
                whatsappGetConfigurationErrorCallback
            );
        }

        function loadModal() {
            vm.isLoading = true;
            initiateLoginMode();

            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }

        function showClientForm() {
            vm.isClietFormVisible = !vm.isClietFormVisible;
        }

        function initiateLoginMode() {
            vm.isLoading = true;
            if (
                !vm.whatsappModalConf ||
                !vm.whatsappModalConf.whatsappConnected
            ) {
                BusinessIntegrationService.initiateWhatsappSync(
                    $localStorage.defaultStore
                        ? $localStorage.defaultStore.storeId || ''
                        : '',
                    'LOGIN_MODE',
                    function() {
                        fetchQrCode();
                        $rootScope.fetchQrCodeInterval = setInterval(
                            fetchQrCode,
                            WHATSAPP_FETCH_INTERVAL
                        );
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    },
                    function() {
                        toastr.error(
                            $translate.instant(
                                'integrations.whatsapp.messages.errorInitiateWhatsappLoginMode'
                            )
                        );
                        vm.isRefreshing = false;
                        vm.isLoading = false;
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    }
                );
            }
        }

        function clearData() {
            vm.selectedCustomers = [];
            vm.unselectedCustomers = [];
            vm.wappDTO = {};
            vm.wappDTO.phones = [];
            vm.wappDTO.excludedPhones = [];
            vm.wappDTO.isAllCustomers = false;

            vm.customers.forEach(function(element) {
                element.selected = false;
            });
        }

        function changePageCustomer() {
            var begin = (vm.currentPage - 1) * vm.numPerPage,
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            vm.customers = listCustomers(vm.paginationOptions, vm.filter);
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;
        }
        // List the customer using pagination
        function listCustomers(pagination, filter) {
            vm.loadingCustomers = true;
            CustomerService.list(pagination, filter).then(
                function(result) {
                    vm.totalCustomers = result.headers['x-total-count'];
                    vm.customers = result.data.slice();

                    // Sync all the new customers with selected customers
                    syncCustomerSelectedWithCustomers(
                        vm.customers,
                        vm.selectedCustomers
                    );
                },
                function(error) {
                    vm.loadingCustomers = false;
                }
            );
        }

        function refreshWhatsappQrCode() {
            vm.isRefreshing = true;
            vm.isLoading = true;
            clearInterval($rootScope.fetchQrCodeInterval);
            BusinessIntegrationService.clearWhatsappData(
                $localStorage.defaultStore
                    ? $localStorage.defaultStore.storeId || ''
                    : '',
                function() {
                    initiateLoginMode();
                },
                function() {
                    initiateLoginMode();
                }
            );
        }

        // Select or unselect the customer
        function selectCustomer(customer) {
            // Switch the customer selected variable
            // Here the customers must be unselected if the all customers option is true
            // otherwise, if customers is unselected by user and all customers option is true
            // then we have to add the customer to excludedCustomers list in wappDTO
            customer.selected = !customer.selected;

            // If customer is selected and allCustomer is true, so we don't need to insert customer into selectedCustomers list
            if (customer.selected && !vm.wappDTO.isAllCustomers) {
                var isPresent =
                    findIndexByAttr(vm.selectedCustomers, 'id', customer.id) >
                    -1;
                if (!isPresent) vm.selectedCustomers.push(customer);
            } else if (!customer.selected && vm.wappDTO.isAllCustomers) {
                vm.unselectedCustomers.push(customer);
            } else {
                removeElementFromArrayByAttr(
                    vm.selectedCustomers,
                    'id',
                    customer.id
                );
            }
        }
        vm.selectAllCustomers = function() {
            if (vm.wappDTO.isAllCustomers) {
                clearAllSelections();
            } else {
                vm.wappDTO.isAllCustomers = true;
                vm.selectedCustomers = [];
                vm.unselectedCustomers = [];
                vm.customers.forEach(function(elem) {
                    if (!elem.selected) {
                        selectCustomer(elem);
                    }
                });
            }
        };

        function loadWhatsapp() {
            vm.isWhatsappTabLoading = true;
            BusinessIntegrationService.getConfiguration(
                $localStorage.defaultStore
                    ? $localStorage.defaultStore.storeId || ''
                    : '',
                'WHATSAPP',
                whatsappGetConfigurationCallback,
                whatsappGetConfigurationErrorCallback
            );

            listCustomers(vm.paginationOptions, vm.filter);
        }

        loadWhatsapp();

        function clearAllSelections() {
            vm.wappDTO.isAllCustomers = false;
            vm.selectedCustomers = [];
            vm.unselectedCustomers = [];
            clearPageSelections();
        }

        function clearPageSelections() {
            vm.customers.forEach(function(elem) {
                if (elem.selected) {
                    selectCustomer(elem);
                }
            });
        }

        loadModal();

        // Sync the page with all previous selected customers
        function syncCustomerSelectedWithCustomers(
            customers,
            selectedCustomers
        ) {
            // If all customers is selected is only to turn selected variable to true in each customer
            if (vm.wappDTO.isAllCustomers) {
                customers.forEach(function(element) {
                    // Verify if customer is in unselected list
                    var isPresent =
                        findIndexByAttr(
                            vm.unselectedCustomers,
                            'id',
                            element.id
                        ) > -1;
                    if (!isPresent) {
                        // Here we turn selected variable to true or false;
                        selectCustomer(element);
                    }
                });
            } else {
                selectedCustomers.forEach(function(elm) {
                    var targetIndex = findIndexByAttr(customers, 'id', elm.id);
                    if (targetIndex > -1) {
                        customers[targetIndex].selected = true;
                    }
                });
            }

            vm.loadingCustomers = false;
        }

        vm.excludeImageUploaded = function() {
            vm.imageUpload = null;
            vm.uploadFileDTO = null;
        }

        vm.uploadFile = function(file, errFiles) {
            vm.imageUpload = file;
            vm.errFiles = errFiles && errFiles[0];

            if (file) {
                vm.isUploading = true;

                file.upload = Upload.upload({
                    url: 'admin/api/upload-whatsapp-media',
                    data: {
                        file: file
                    }
                });

                file.upload.then(
                    function(response) {
                        if (response.data) {
                            vm.uploadFileDTO = response.data;
                            vm.allStatusOk = true;

                            vm.isUploading = false;

                        } else {
                            vm.imageUpload = null;
                            toastr.warning(
                                $translate.instant(
                                    'integrations.whatsapp.qrCodeWa.stepTwo.fileUploadTryAgain'
                                )
                            );
                            vm.isUploading = false;
                        }
                    },
                    function(response) {
                        vm.isUploading = false;
                        vm.imageUpload = null;
                        toastr.error(
                            $translate.instant(
                                'integrations.whatsapp.qrCodeWa.stepTwo.fileUploadError'
                            )
                        );
                    }
                );
            }
        };

        vm.next = function() {
            vm.currentStep < vm.totalOfSteps
                ? (vm.currentStep = vm.currentStep + 1)
                : '';
        };

        vm.previous = function() {
            if (vm.currentStep === 1) {
                vm.selectedBusiness = null;
            }
            if (vm.currentStep === 2) {
                vm.selectedBusinessPage = null;
            }
            vm.currentStep !== 0 ? (vm.currentStep = vm.currentStep - 1) : '';
        };

        vm.nextDisabled = function() {
            switch (vm.currentStep) {
                case 0:
                    return (
                        !vm.whatsappModalConf ||
                        !vm.whatsappModalConf.whatsappConnected
                    );
                case 1:
                    return vm.wappDTO.message && vm.wappDTO.campaingName
                        ? false
                        : true;
                case 2:
                    return vm.selectedCustomers.length ||
                        vm.wappDTO.isAllCustomers
                        ? false
                        : true;
                default:
                    return false;
            }
        };
        vm.previousDisabled = function() {
            switch (vm.currentStep) {
                case 0:
                    return false;
                case 1:
                    return !vm.whatsappModalConf.whatsappConnected;
                case 2:
                    return true;
                default:
                    return false;
            }
        };
    }
})();

(function () {
  'use strict';
  angular
      .module('showcaseApp')
      .controller('WhatsappConfirmationModalController', WhatsappConfirmationModalController);

  function WhatsappConfirmationModalController($uibModalInstance) {

      var vm = this;

      // FUNCTIONS
      vm.closeModalSuccessfully = closeModalSuccessfully;

      function closeModalSuccessfully(){
          $uibModalInstance.close();
      }


  }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    function stateConfig($stateProvider) {
        $stateProvider
            .state('social-integrations', {
                parent: 'admin',
                url: '/social-integrations',
                data: {
                    authorities: ['STORE_READ_CUSTOMER', 'SOCIAL_MEDIA_POST'],
                    pageTitle: 'integrations.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/integrations/integrations.html',
                        controller: 'BusinessIntegrationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('integrations');
                        $translatePartialLoader.addPart('checkout');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('social-media');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('customers');
                        return $translate.refresh();
                    }],
                }
            });
    }
})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("InstaStepsModalFactory", InstaStepsModalFactory);


    /** @ngInject */
    function InstaStepsModalFactory($uibModal) {

        var factory = {
            update: update
        };

        return factory;

        function update(entity) {
            return $uibModal.open({
                templateUrl: 'app/integrations/instagram-business/steps-modal/insta-steps.modal.html',
                controller: 'InstaModalController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    entity: function() {
                        return entity;
                    }
                }
            }).result;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('InstaModalController', InstaModalController);

        InstaModalController.$inject = ['$uibModalInstance', '$timeout',
        '$localStorage', 'FacebookService', 'ShowcasesService', '$translate',
        '$state', 'toastr', '$q', '$scope', 'BusinessIntegrationService', '$window'
    ];

    function InstaModalController($uibModalInstance, $timeout,
        $localStorage, FacebookService, ShowcasesService, $translate,
         $state, toastr, $q, $scope, BusinessIntegrationService, $window) {
        var vm = this;
        vm.catalogName = "";
        vm.project = {};
        vm.project.total = 0;
        vm.selectedCity;
        vm.checkout = {};
        vm.facebook = {
            catalogGenerated: false,
            catalog: {
                id: ''
            },
            feed: {
                id: ''
            },
            connected: false
        };
        vm.isBussy = false;
        vm.userBusinesses = [];
        vm.user = {};
        vm.currentStep = 0;
        vm.totalOfSteps = 4;
        vm.selectedBusiness;
        vm.selectedBusinessPage;
        vm.showcase = null;
        vm.searchText = null;

        vm.confirm = function () {
            $uibModalInstance.close(true);
        };

        vm.closeModal = function () {
            $uibModalInstance.close(false);
        };

        vm.fbLogin = function () {
            vm.processing = true;
            FacebookService.login().then(updateStatus);
        };

        vm.fbLogout = function () {
            FacebookService.logout().then(updateStatus);
        };

        vm.checkFbStatus = function () {
            vm.processing = true;
            FacebookService.status().then(updateStatus);
        };

        vm.generateCatalog = function () {
            vm.isBussy = true;

            FacebookService.createCatalog(vm.selectedBusiness.id, vm.catalogName)
                .then(function (result) {
                    vm.facebook.catalog.id = result.id;
                    return FacebookService.addFeed(vm.facebook.catalog.id, $localStorage.defaultStore.storeNickname)
                }).then(function (result) {
                    vm.isBussy = false;
                    vm.facebook.feed.id = result.id;
                }).catch(function (err) {
                    toastr.error(err)
                    vm.catalogName = '';
                    vm.isBussy = false
                });
        };

        vm.loadUserData = function () {
            vm.processing = true;
            if (vm.facebook.connected) {
                FacebookService.me().then(function (data) {
                    vm.user = data;
                    vm.processing = false;
                });
            }
        };

        vm.loadShowcases = function () {
            vm.processing = true;
            ShowcasesService.getPublishedShowcaseByStoreId().then(
                onSuccess,
                onError
            );

            function onSuccess(res) {
                vm.showcase = res.data;
                vm.processing = false;
            }

            function onError(response) {
                vm.processing = false;
                vm.busy = false;

                if (response.headers('X-flyerApp-alert') == 'userHasNoStore') {
                    toastr.error(
                        $translate.instant('showcases.messages.errors.noStore')
                    );
                }
            }
        };
        vm.loadShowcases();

        vm.goToShowcases = function () {
            $state.go('showcases');
            $uibModalInstance.close(true);
        };

        vm.loadBusiness = function () {
            vm.selectedBusiness = null;
            vm.processing = true;
            FacebookService.business().then(function (res) {
                vm.processing = false;
                vm.userBusinesses = res.data;
            });
        };

        vm.loadBusinessPages = function () {
            vm.selectedBusinessPage = null;
            vm.processing = true;
            FacebookService.businessPages(vm.selectedBusiness.id).then(function (res) {
                vm.userBusinessesPages = res.data;
                vm.processing = false;
            });
        };

        vm.querySearch = function (query) {
            vm.deferred = $q.defer();
            FacebookService.searchCity(query)
                .then(function (res) {
                    vm.deferred.resolve(res)
                });
            return vm.deferred.promise;
        }

        function validateExpirationDate() {
            return Moip.Validator.isExpiryDateValid(vm.expirationDate.substring(0,2), vm.expirationDate.substring(2,4));
        }

        function encryptCreditCardData() {


            var encryptCreditCard = new Moip.CreditCard({
                number: vm.checkout.cardNumber,
                cvc: vm.checkout.cvc,
                expMonth: vm.expirationDate.substring(0,2),
                expYear: vm.expirationDate.substring(2,4),
                pubKey: vm.keys.encryption
            });

            if (encryptCreditCard.isValid()) {
                vm.checkout.hash = encryptCreditCard.hash();

                return true;
            }

            return false;
        }

        /**
         * On Init
         */
        $timeout(function () {
            vm.checkFbStatus();
            BusinessIntegrationService.getOwnerKeys($localStorage.defaultStore.storeId).then(function (response) {
                vm.keys = response.data;
            });
        }, 500);

        /**
         * Pagination control section
         */
        vm.currentStep

        vm.next = function () {
            vm.currentStep < vm.totalOfSteps ?
                (vm.currentStep = vm.currentStep + 1) :
                '';
        };

        vm.previous = function () {
            if (vm.currentStep === 1) {
                vm.selectedBusiness = null;
            }
            if (vm.currentStep === 2) {
                vm.selectedBusinessPage = null;
            }
            vm.currentStep !== 0 ? (vm.currentStep = vm.currentStep - 1) : '';
        };

        vm.modalTitle = function () {
            switch (vm.currentStep) {
                case 0:
                    return {title: $translate.instant("integrations.instagramBusiness.modal.step1.title"), subTitle: $translate.instant("integrations.instagramBusiness.modal.step1.subTitle")} ;
                case 1:
                    return {title: $translate.instant("integrations.instagramBusiness.modal.step2.title"), subTitle: $translate.instant("integrations.instagramBusiness.modal.step2.subTitle")};
                case 2:
                    return {title: $translate.instant("integrations.instagramBusiness.modal.step3.title"), subTitle: $translate.instant("integrations.instagramBusiness.modal.step3.subTitle")};
                case 3:
                    return {title: $translate.instant("integrations.instagramBusiness.modal.step4.title"), subTitle: $translate.instant("integrations.instagramBusiness.modal.step4.subTitle")};
                default:
                    return false;
            }
        };
        vm.nextDisabled = function () {
            switch (vm.currentStep) {
                case 0:
                    return false;
                case 1:
                    return vm.facebook.connected && vm.selectedBusiness ? false : true;
                case 2:
                    return vm.facebook.catalog.id ? false : true;
                case 3:
                    return false;
                default:
                    return false;
            }
        };

        vm.previousDisabled = function () {
            switch (vm.currentStep) {
                case 3:
                    return vm.facebook.catalog.id ? true : false;
                case 4:
                    return vm.campaingResult ? true : false;
                case 5:
                    return true;

                default:
                    return false;
            }
        };

        $scope.$watch('vm.project.days', function (newValue, oldValue) {
            vm.project.total = vm.project.value > 0 ? vm.project.value * vm.project.days : 0;
        });
        $scope.$watch('vm.project.value', function (newValue, oldValue) {
            vm.project.total = vm.project.value > 0 ? vm.project.value * vm.project.days : 0;
        });

        vm.getFormattedPrice = function (price) {
            price = price.toString();
            return price.substring(0, price.length - 2) + ',' + price.substring(price.length - 2, price.length);
        }

        function updateStatus(response) {
            if (response.status === 'connected') {
                vm.facebook.connected = true;
                vm.facebook.data = response;
                vm.loadBusiness();
                vm.loadUserData();
            } else {
                vm.facebook.connected = false;
                vm.userBusinesses = [];
                vm.facebook.data = {};
            }
            vm.processing = false;
        }

        vm.verifyExpirationDate = function () {
            if (vm.expirationDate && vm.expirationDate.length == 4) {
                vm.invalidExpirationDate = !Moip.Validator.isExpiryDateValid(vm.expirationDate.substring(0, 2), vm.expirationDate.substring(2, 4));
            }
        }

        vm.verifyCardNumber = function () {
            vm.invalidCardNumber = !Moip.Validator.isValid(vm.checkout.cardNumber);
            vm.brandCard = Moip.Validator.cardType(vm.checkout.cardNumber) ? Moip.Validator.cardType(vm.checkout.cardNumber).brand : null;
        }

        vm.lockCreateCampaign = function () {

            if ( !vm.checkout.cpf ) {
                return status = true;
            }

            if ( (!vm.checkedCreditCard && !vm.checkedBoleto) ) {
                return status = true;
            }

            if ( vm.checkedCreditCard && (vm.paymentForm.$invalid || vm.invalidCardNumber) ) {
                return status = true;
            }

            return false;


        }

        vm.finishPurchase = function () {
            vm.isBuying = true;

            // Commons things to do
            vm.checkout.catalogId = vm.facebook.catalog.id;
            vm.checkout.feedId = vm.facebook.feed.id;
            vm.checkout.cityKey = vm.selectedCity.key;
            vm.checkout.businessId = vm.selectedBusiness.id;
            vm.checkout.pageId =  vm.selectedBusinessPage.id;
            vm.checkout.catalogName = vm.catalogName;
            vm.checkout.storeName = $localStorage.defaultStore.storeNickname;
            vm.checkout.campaignValue = vm.project.total;
            vm.checkout.campaignDailyValue = vm.project.value;
            vm.checkout.campaignDays = vm.project.days;
            vm.checkout.token = vm.facebook.data.authResponse.accessToken;
 			var url = window.location.host;
			vm.checkout.storeUrl = url.replace("admin", vm.checkout.storeName);
//            if ((window.location.host.indexOf("showkase") !== -1) === true) {
//                vm.checkout.storeUrl = 'https://' + vm.checkout.storeName + '.showkase.com.br'
//            } else {
//                vm.checkout.storeUrl = 'https://' + vm.checkout.storeName + '.showkase.online'
//            }

            if (vm.checkedCreditCard) {
                vm.checkout.payment = 'CREDIT_CARD';
                // Verify and does all checks
                if (validateExpirationDate()) {
                    var hashIsValid = encryptCreditCardData();
                    if (hashIsValid) {
                        BusinessIntegrationService.createCampaign(vm.checkout)
                            .then(success, error)
                            .catch(function (err) {
                                error(err);
                            });
                    } else {
                        toastr.error($translate.instant('integration.rent.error.cardDataInvalid'));
                        vm.isBuying = false;
                    }
                } else {
                    toastr.error($translate.instant('flyers.rent.error.expirationDateInvalid'));
                    vm.isBuying = false;
                }

            } else if (vm.checkedBoleto) {
                vm.checkout.payment = 'BOLETO';
                BusinessIntegrationService.createCampaign(vm.checkout)
                    .then(success, error)
                    .catch(function (err) {
                        error(err);
                    });
            }

        }

        function success(result) {
            vm.campaingResult = result.data;
            vm.isBuying = false;
            $window.open(vm.campaingResult.redirectHrefBoleto + '/print');
        }

        function error(result) {
            toastr.error($translate.instant('integrations.facebookBusiness.errors.createCampain'));
        }


    }
})();

/**
 * Google My Business service
 * author: Odravison Amaral (odravison.amaral@dce.ufpb.br)
 * 2019
 */

(function() {
	'use strict';

	angular.module('showcaseApp').service('GMBService', GMBService);

	GMBService.$inject = [ 'GMBFactory' , 'BusinessIntegrationFactory'];

	function GMBService(GMBFactory, BusinessIntegrationFactory) {
		var service = {
			authorize : authorize,
			signOut: signOut,
			receiveCode: receiveCode,
			getConfiguration: getConfiguration,
			selectAccount: selectAccount,
			getGMBCategoriesList: getGMBCategoriesList,
			getGMBLocationList: getGMBLocationList,
			selectGMBLocation: selectGMBLocation,
            getGMBInsights: getGMBInsights,
            getGMBQuestions: getGMBQuestions
		};

		return service;

		function authorize(callbackOfflineAccess, callbackOfflineAccessError) {
			return GMBFactory.authorize(callbackOfflineAccess, callbackOfflineAccessError);
		}

		function signOut(params, callback, errorCallback) {
			BusinessIntegrationFactory.disconnectByType(params, {}).$promise.then(callback, errorCallback);
			return GMBFactory.signOut();
		}

		function receiveCode (params, token, callback, errorCallback) {
			BusinessIntegrationFactory.receiveCode(params, token).$promise.then(callback, errorCallback);
		}

		function selectAccount (params, body, callback, errorCallback) {
			BusinessIntegrationFactory.selectAccount(params, body).$promise.then(callback, errorCallback);
		}

		function selectGMBLocation (params, body, callback, errorCallback) {
			BusinessIntegrationFactory.selectGMBLocation(params, body).$promise.then(callback, errorCallback);
		}

		function getGMBCategoriesList (body, callback, errorCallback) {
			return BusinessIntegrationFactory.getGMBCategoriesList(body).$promise;
		}

		function getGMBLocationList (params, callback, errorCallback) {
			BusinessIntegrationFactory.getGMBLocationList(params).$promise.then(callback, errorCallback);
		}

		function getConfiguration (params, callback, errorCallback) {
			BusinessIntegrationFactory.getConfiguration(params).$promise.then(callback, errorCallback);
		}

        function getGMBInsights(params, callback, errorCallback) {
            return BusinessIntegrationFactory.getGMBInsights(params).$promise.then(callback, errorCallback);
        }

        function getGMBQuestions(params, callback, errorCallback) {
            return BusinessIntegrationFactory.getGMBQuestions(params).$promise.then(callback, errorCallback);
        }

	}
})();

/**
 * Google My Business factory
 * author: Odravison Amaral (odravison.amaral@dce.ufpb.br)
 * 2019
 */

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('GMBFactory', GMBFactory);

    GMBFactory.$inject = ['$q'];

    function GMBFactory($q) {
        return {
            authorize: function (callbackOfflineAccess, callbackOfflineAccessError) {
                return gapi.auth2.getAuthInstance().grantOfflineAccess()
                .then(callbackOfflineAccess)
                .catch(callbackOfflineAccessError);
            },
            signOut: function () {
                return gapi.auth2.getAuthInstance().signOut();
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('SelectGMBConfigurationsController', SelectGMBConfigurationsController);

    function SelectGMBConfigurationsController(googleAccounts, $uibModalInstance, $localStorage, GMBService, toastr, $translate, moment) {

        var vm = this;

        vm.step = 0;

        // Pre data
        var MIN_SEARCH_TERM_NUMBER_CHAR = 4;

        vm.googleAccounts = googleAccounts;

        vm.processing = false;

        // Functions
        vm.closeModal = closeModal;

        vm.isToSelectCategory = isToSelectCategory;

        vm.selectAccount = selectAccount;

        vm.verifyConditions = verifyConditions;

        vm.nextStep = nextStep;

        vm.backStep = backStep;

        vm.selectLocation = selectLocation;

        vm.doBackwardAction = doBackwardAction;

        vm.createANewLocation = createANewLocation;

        vm.searchCategory = searchCategory;

        // Objects
        vm.selectedAccount = undefined;

        vm.selectedLocation = undefined;

        vm.selectedCategory = undefined;

        // Object Fetched
        vm.gmbLocations = undefined;

        vm.gmbCategories = undefined;

        function nextStep() {
            if (vm.step == 2) {
                // lastStep, justDoAction;
                doAction();
            } else if (verifyConditions(vm.step)) {
                // doAction before stepFoward
                doAction();
            }
        }

        function backStep() {
            vm.step--;
        }

        function isToSelectCategory() {
            return vm.selectedLocation == null;
        }

        function verifyConditions() {
            // Account's step
            if (vm.step == 0) {
                return !vm.processing && vm.selectedAccount != null;
            }
            // Location's step
            else if (vm.step == 1) {
                // Always true, because could be a new location
                return !vm.processing && true;
            }
            // Category's step
            else if (vm.step == 2) {
                return !vm.processing && (vm.selectedCategory != null && !vm.selectedLocation);
            }

            return false;

        }

        function selectAccount(account) {
            vm.selectedAccount = account;
        }

        function selectLocation(location) {
            vm.selectedLocation = location;
        }

        function closeModal(method) {
            console.log(method);
            $uibModalInstance.dismiss(method);
        }

        function closeModalSuccessfully(method){
            console.log(method);
            $uibModalInstance.close(method);
        }

        function doBackwardAction() {
            if (vm.step > 0) {
                backStep();
            } else {
                closeModal();
            }
        }

        function selectAccountErrorCallback(error) {
            toastr.error($translate.instant('integrations.googleMyBusiness.modalSelectConfigurations.accounts.messages.errorSelectAccount'));
        }

        function getLocationListSuccessCallback(response) {
            if (response.data) {
                vm.selectedLocation = undefined;
                vm.gmbLocations = response.data;
                if (vm.gmbLocations.length == 0){
                    vm.processing = false;
                    nextStep();
                }
            }
            vm.processing = false;
        }

        function getLocationListErrorCallback(error) {
            toastr.error($translate.instant('integrations.googleMyBusiness.modalSelectConfigurations.accounts.messages.errorGetLocation'));
        }

        function createANewLocation() {
            vm.selectedLocation = undefined;
        }

        function selectAccountSuccessCallback(response) {
            if (response.data = 'OK') {
                vm.processing = true;
                GMBService.getGMBLocationList({
                    storeId: ($localStorage.defaultStore ? ($localStorage.defaultStore.storeId || '') : '')
                }, getLocationListSuccessCallback, getLocationListErrorCallback);
            }
        }

        function selectGMBLocationErrorCallback(error) {
            vm.processing = false;
            closeModal(vm.selectedLocation ? 'errorSelectLocation' : 'errorCreateNewLocation');
        }

        function selectGMBLocationSuccessCallback(response) {
            vm.processing = false;
            closeModalSuccessfully(vm.selectedLocation ? 'successAssociated' : 'successCreated');
        }

        function searchCategory() {
            var promise = GMBService.getGMBCategoriesList({
                storeId: ($localStorage.defaultStore ? ($localStorage.defaultStore.storeId || '') : ''),
                languageCode: "pt", //moment.locale() + "",
                searchTerm: vm.searchTerm,
                regionCode: (moment.locale() == "pt-br" ? "BR" : (moment.locale() == "es" ? "ES" : "US"))
            });

            return promise.then(function (response) {
                return response.data;
            })
        }

        function doAction() {
            if (vm.step == 0 && vm.selectedAccount) {
                vm.processing = true;
                GMBService.selectAccount({
                    storeId: ($localStorage.defaultStore ? ($localStorage.defaultStore.storeId || '') : '')
                }, {
                    googleAccountTarget: vm.selectedAccount.name
                }, selectAccountSuccessCallback, selectAccountErrorCallback);

                vm.step++;
            } else if (vm.step == 1) {
                vm.processing = true;
                // If selected a location, there's no need to select category
                if (vm.selectedLocation) {
                    GMBService.selectGMBLocation({
                        storeId: ($localStorage.defaultStore ? ($localStorage.defaultStore.storeId || '') : '')
                    }, {
                        googleLocationTarget: vm.selectedLocation.name
                    }, selectGMBLocationSuccessCallback, selectGMBLocationErrorCallback);
                } else {
                    vm.step++;
                    vm.processing = false;
                }



            } else if (vm.step == 2) {
                vm.processing = true;
                if (vm.selectedCategory && !vm.selectedLocation) {
                    // If a new location option has selected, then we just need to send the category as parameter
                    GMBService.selectGMBLocation({
                        storeId: ($localStorage.defaultStore ? ($localStorage.defaultStore.storeId || '') : '')
                    }, {
                        selectedCategory: vm.selectedCategory
                    }, selectGMBLocationSuccessCallback, selectGMBLocationErrorCallback);
                }


            }
        }

        function preSelects(){
            if (vm.googleAccounts.length == 1){
                vm.selectedAccount = vm.googleAccounts[0];
                vm.nextStep();
            }
        }

        preSelects();

    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .service('FacebookService', FacebookService);

    FacebookService.$inject = ['FacebookFactory'];

    function FacebookService(FacebookFactory) {

        return {
            me: me,
            login: login,
            logout: logout,
            status: status,
            addFeed: addFeed,
            getPage: getPage,
            business: business,
            getBusiness: getBusiness,
            addPayment: addPayment,
            adAccounts: adAccounts,
            searchCity: searchCity,
            businessPages: businessPages,
            createCatalog: createCatalog,
            createAdAccount: createAdAccount,
            instagramAccounts: instagramAccounts
        }

        function me() {
            return FacebookFactory.me();
        }

        function login() {
            return FacebookFactory.login();
        }

        function addPayment(id) {
            return FacebookFactory.addPayment();
        }

        function logout() {
            return FacebookFactory.logout();
        }

        function status() {
            return FacebookFactory.status();
        }

        function addFeed(catalogId, feedUrl) {
            return FacebookFactory.addFeed(catalogId, feedUrl);
        }

        function business(nextPage) {
            return FacebookFactory.business(nextPage);
        }

        function getBusiness(token, id) {
            return FacebookFactory.getBusiness(token, id);
        }

        function getPage(token, id) {
            return FacebookFactory.getPage(token, id);
        }

        function searchCity(query, token) {
            return FacebookFactory.searchCity(query, token);
        }

        function businessPages(businessId) {
            return FacebookFactory.businessPages(businessId);
        }

        function adAccounts(businessId) {
            return FacebookFactory.adAccounts(businessId);
        }

        function createAdAccount(businessId, token) {
            return FacebookFactory.createAdAccount(businessId, token);
        }

        function createCatalog(businessId, catalogData) {
            return FacebookFactory.createCatalog(businessId, catalogData);
        }

        function instagramAccounts(businessId) {
            return FacebookFactory.instagramAccounts(businessId);
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('FacebookFactory', FacebookFactory);

    FacebookFactory.$inject = ['$q' ];

    function FacebookFactory($q) {
        var path = window.location.hostname.includes('showkase.online') ? 'http://admin.showkase.online/' : 'http://admin.showkase.com.br/';
        return {
            login: function () {
                var deferred = $q.defer();
                FB.login(function (response) {
                    if (response.status === 'connected') {
                        deferred.resolve(response);
                    } else {
                        deferred.reject('Error occured');
                    }
                }, {
                    scope: 'email,business_management,ads_management,pages_show_list,catalog_management,instagram_manage_insights,instagram_basic,read_insights,pages_messaging,instagram_manage_messages, pages_manage_metadata, ads_read, pages_read_engagement',
                    auth_type: 'reauthorize',
                    enable_profile_selector: true,
                    return_scopes: true
                });
                return deferred.promise;
            },
            addPayment: function (id) {
                var deferred = $q.defer();
                FB.ui(function (response) {
                    if (response.status === 'connected') {
                        deferred.resolve(response);
                    } else {
                        deferred.reject('Error occured');
                    }
                }, {
                    account_id: id,
                    display: 'popup',
                    method: 'ads_payment'
                });
                return deferred.promise;
            },
            status: function () {
                var deferred = $q.defer();
                FB.getLoginStatus(function (response) {
                    if (response.status === 'connected') {
                        // var uid = response.authResponse.userID;
                        deferred.resolve(response);
                    } else if (response.status === 'authorization_expired') {
                        deferred.reject('Token Expirado');
                    } else if (response.status === 'not_authorized') {
                        deferred.reject('Não autorizado');
                    } else {
                        deferred.reject('Erro Desconhecido');
                    }
                });
                return deferred.promise;
            },
            business: function (nextPage) {
                var deferred = $q.defer();
                // var nextPage = nextPage ? '&after=' + nextPage : '';
                FB.api('/me/businesses?limit=100', {
                    after: nextPage,
                    fields: 'name, profile_picture_uri, id'
                }, function (response) {
                    if (response.error) {
                        return deferred.reject(response.error);
                    }
                    deferred.resolve(response);
                });
                return deferred.promise;
            },
            getBusiness: function (token, id) {
                var deferred = $q.defer();
                FB.api(id, {
                    access_token: token,
                    fields: 'name, profile_picture_uri'
                }, function (response) {
                    if (response.error) {
                        return deferred.reject(response.error)
                    }
                    deferred.resolve(response);
                });
                return deferred.promise;
            },
            getPage: function (token, id) {
                var deferred = $q.defer();
                FB.api(id, {
                    access_token: token,
                    fields: 'page_token,access_token,picture{url},name'
                }, function (response) {
                    if (response.error) {
                        return deferred.reject(response.error)
                    }
                    deferred.resolve(response);
                });
                return deferred.promise;
            },
            getInsagram: function (token, id) {
                var deferred = $q.defer();
                FB.api(id, {
                    access_token: token,
                    fields: 'name, profile_picture_uri'
                }, function (response) {
                    if (response.error) {
                        return deferred.reject(response.error)
                    }
                    deferred.resolve(response);
                });
                return deferred.promise;
            },
            businessPages: function (businessId) {
                var deferred = $q.defer();
                FB.api('/' + businessId + '/owned_pages', {
                    fields: 'id, cover, name, instagram_business_account{id,name,username,profile_picture_url}'
                }, function (response) {
                    deferred.resolve(response);
                });
                return deferred.promise;
            },
            instagramAccounts: function (businessId) {
                var deferred = $q.defer();
                FB.api('/' + businessId + '/instagram_business_accounts', {
                    fields: 'id,username,profile_picture_url'
                }, function (response) {
                    deferred.resolve(response);
                });
                return deferred.promise;
            },
            adAccounts: function (businessId) {
                var deferred = $q.defer();
                FB.api('/' + businessId + '/owned_ad_accounts', {
                    fields: 'business_name,balance,name,owner,currency,funding_source,funding_source_details,created_time,account_status,account_id'
                }, function (response) {
                    deferred.resolve(response);
                });
                return deferred.promise;
            },
            searchCity: function (query, token) {
                var deferred = $q.defer();
                FB.api('/search?location_types=["city"]&type=adgeolocation&q=' + query, {access_token: token },
                function (response) {
                    deferred.resolve(response.data);
                });
                return deferred.promise;
            },
            createCatalog: function (businessId, catalogName) {
                var deferred = $q.defer();
                FB.api('/' + businessId + '/owned_product_catalogs', 'POST', {
                    name: catalogName
                }, function (response) {
                    if (response && response.id) {
                        deferred.resolve(response);
                    } else {
                        deferred.reject('Não autorizado, possivelmente você  não tem permissão para criar um catálogo nessa conta.');
                    }
                });
                return deferred.promise;
            },
            createAdAccount: function (businessId, token) {
                var deferred = $q.defer();
                FB.api('/' + businessId + '/adaccount'+ '?access_token='+ token, 'POST', {
                    name: "Showkase - Ad Account" + '_' + moment().format("DD-MM-YYYY_HH:MM"),
                    end_advertiser: "UNFOUND",
                    media_agency: "UNFOUND",
                    timezone_id: 25,
                    currency: "BRL",
                    partner: "NONE",
                    access_token: token
                }, function (response) {
                    if (response && response.id) {
                        deferred.resolve(response);
                    } else {
                        deferred.reject('Erro ao criar conta.');
                    }
                });
                return deferred.promise;
            },
            addFeed: function (catalogId, feedUrl) {
                var deferred = $q.defer();
                FB.api('/' + catalogId + '/product_feeds', 'POST', {
                    name: 'showkase_catalog',
                    default_currency: 'BRL',
                    schedule: {
                        interval: 'HOURLY',
                        url: path+"flyer/api/showcase/rss?domain=" + feedUrl,
                        interval_count: 1
                    }
                }, function (response) {
                    console.log('addFeed: ', response);
                    if (response && response.id) {
                        deferred.resolve(response);
                    } else {
                        deferred.reject('Não autorizado');
                    }
                });
                return deferred.promise;
            },
            me: function () {
                var deferred = $q.defer();
                FB.api('/me', {
                    fields: 'id, first_name, last_name, picture'
                }, function (response) {
                    if (response.status === 'connected') {
                        deferred.resolve(response);
                    } else {
                        deferred.reject('Error occured');
                    }
                });
                return deferred.promise;
            },
            logout: function () {
                var deferred = $q.defer();
                FB.logout(function (response) {
                    deferred.resolve(response);
                });
                return deferred.promise;
            }
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("FBCampaignModalFactory", FBCampaignModalFactory);


    /** @ngInject */
    function FBCampaignModalFactory($uibModal) {

        var factory = {
            update: update
        };

        return factory;

        function update(data) {
            return $uibModal.open({
                templateUrl: 'app/integrations/facebook-business/campaign-modal/fb-campaign.modal.html',
                controller: 'FBCampaignModalController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    data: function() {
                        return data;
                    }
                }
            }).result;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FBCampaignModalController', FBCampaignModalController);

        FBCampaignModalController.$inject = ['$uibModalInstance', '$timeout',
        '$localStorage', 'FacebookService', 'ShowcasesService', '$translate',
        '$state', 'toastr', '$q', '$scope', 'BusinessIntegrationService', 'data'
    ];

    function FBCampaignModalController($uibModalInstance, $timeout,
        $localStorage, FacebookService, ShowcasesService, $translate,
         $state, toastr, $q, $scope, BusinessIntegrationService, data) {
        var vm = this;
        vm.catalogName = "";
        vm.project = {};
        vm.project.campaignType = 'cpm_message';
        vm.project.total = 0;
        vm.selectedCity;
        vm.checkout = {};
        vm.facebook = {
            catalogGenerated: false,
            catalog: {
                id: ''
            },
            feed: {
                id: ''
            },
            connected: false
        };
        vm.isBussy = false;
        vm.userBusinesses = [];
        vm.userInstagramAccounts = [];
        vm.user = {};
        vm.currentStep = 0;
        vm.totalOfSteps = 2;
        vm.selectedBusiness;
        vm.selectedAdAccount;
        vm.selectedInstagram;
        vm.selectedBusinessPage;
        vm.facebookData = data;

        vm.showcase = null;
        vm.searchText = null;

        vm.confirm = function () {
            $uibModalInstance.close(true);
        };

        vm.closeModal = function () {
            $uibModalInstance.close(false);
        };

        vm.fbLogin = function () {
            vm.processing = true;
            FacebookService.login().then(updateStatus);
        };

        vm.fbLogout = function () {
            FacebookService.logout().then(updateStatus);
        };

        vm.checkFbStatus = function () {
            vm.processing = true;
            FacebookService.status()
            .then(updateStatus)
            .catch(function(err){
            }).finally(function(err){
                vm.processing = false;
            });
        };

        vm.loadUserData = function () {
            vm.processing = true;
            if (vm.facebook.connected) {
                FacebookService.me().then(function (data) {
                    vm.user = data;
                    vm.processing = false;
                })
            }
        };

        vm.loadShowcases = function () {
            vm.processing = true;
            ShowcasesService.getPublishedShowcaseByStoreId().then(
                onSuccess,
                onError
            );

            function onSuccess(res) {
                vm.showcase = res.data;
                console.log('vm.facebookData:', vm.facebookData)
                vm.processing = false;
            }

            function onError(response) {
                vm.processing = false;
                vm.busy = false;
                console.log('vm.facebookData:', vm.facebookData)
                if (response.headers('X-flyerApp-alert') == 'userHasNoStore') {
                    toastr.error(
                        $translate.instant('showcases.messages.errors.noStore')
                    );
                }
            }
        };

        vm.loadShowcases();

        vm.goToShowcases = function () {
            $state.go('showcases');
            $uibModalInstance.close(true);
        };

        vm.loadBusiness = function () {
            vm.selectedBusiness = null;
            vm.processing = true;
            FacebookService.business().then(function (res) {
                vm.userBusinesses = res.data;
            }).catch(function(err) {
                console.log("ERR::", err);
            }).finally(function(){
                vm.processing = false;
            });
        };

        vm.loadBusinessInsta = function () {
            vm.userInstagramAccounts = null;
            vm.processing = true;
            FacebookService.instagramAccounts(vm.selectedBusiness.id).then(function (res) {
                vm.userInstagramAccounts = res.data;
                vm.processing = false;
            }).catch(function(err) {
                console.log("ERR::", err);
            }).finally(function(){
                vm.processing = false;
            });
        };

        vm.querySearch = function (query) {
            vm.deferred = $q.defer();
            FacebookService.searchCity(query, vm.facebookData.accessToken)
                .then(function (res) {
                    vm.deferred.resolve(res)
                });
            return vm.deferred.promise;
        }

        /**
         * On Init
         */
        $timeout(function () {
            vm.checkFbStatus();
        }, 500);

        vm.next = function () {

            if (vm.currentStep === 0) {
                console.log("FINAL")
                vm.loadPreviewInfo();

            }
            vm.currentStep < vm.totalOfSteps ?
                (vm.currentStep = vm.currentStep + 1) : '';
        };

        vm.previous = function () {
            vm.currentStep !== 0 ? (vm.currentStep = vm.currentStep - 1) : '';
        };

        vm.nextDisabled = function () {
            switch (vm.currentStep) {
                case 0:
                    return (vm.selectedCity && vm.project.value && vm.project.days && !vm.project.value < 3 && !vm.project.days < 8) ? false : true;
                case 1:
                    return false;
                default:
                    return false;
            }
        };

        vm.previousDisabled = function () {
            switch (vm.currentStep) {
                case 2:
                    return vm.facebook.catalog.id ? true : false;
                case 3:
                    return vm.campaingResult ? true : false;
                case 4:
                    return true;

                default:
                    return false;
            }
        };

        $scope.$watch('vm.project.days', function (newValue, oldValue) {
            vm.project.total = vm.project.value > 0 ? vm.project.value * vm.project.days : 0;
        });
        $scope.$watch('vm.project.value', function (newValue, oldValue) {
            vm.project.total = vm.project.value > 0 ? vm.project.value * vm.project.days : 0;
        });

        vm.getFormattedPrice = function (price) {
            price = price.toString();
            return price.substring(0, price.length - 2) + ',' + price.substring(price.length - 2, price.length);
        }

        function updateStatus(response) {
            if (response.status === 'connected') {
                vm.facebook.connected = true;
                vm.facebook.data = response;
                vm.loadBusiness();
                vm.loadUserData();
            } else {
                vm.facebook.connected = false;
                vm.userBusinesses = [];
                vm.facebook.data = {};
            }

        }
        vm.lockCreateCampaign = function () {

            if ( !vm.selectedCity || !vm.project.value || !vm.project.days || !vm.project.total || !vm.project.campaignType) {
                return status = true;
            }

            return false;
        }

        vm.modalTitle = function () {
            switch (vm.currentStep) {
                case 0:
                    return {title: 'Configure sua campanha', subTitle: 'Insira as informações que serão usadas na sua campanha'};
                case 1:
                    return {title: 'Confirme as informações', subTitle: 'Revise as informações antes de seguir com pagamento'};
                default:
                    return false;
            }
        };

        vm.loadBusinessPages = function () {
            vm.selectedBusinessPage = null;
            vm.processing = true;
            FacebookService.getPage(vm.selectedBusiness.id).then(function (res) {
                vm.selectedBusinessPage = res;
                vm.processing = false;
            }).catch(function(err) {
                console.log("ERR::", err);
            }).finally(function(){
                vm.processing = false;
            });
        };

        vm.loadPreviewInfo = function() {
            vm.processing = true;
            FacebookService.getBusiness(vm.facebookData.accessToken, vm.facebookData.business.businessId).then(function (res) {
                vm.selectedBusiness = res;
            }).catch(function(err) {
                console.log("ERR::", err);
            }).finally(function(){
                vm.processing = false;
            });

            FacebookService.getPage(vm.facebookData.accessToken, vm.facebookData.page.pageId).then(function (res) {
                vm.selectedBusinessPage = res;
                vm.processing = false;
            }).catch(function(err) {
                console.log("ERR::", err);
            }).finally(function(){
                vm.processing = false;
            });
        }

        vm.createCampaign = function () {
            vm.isBuying = true;

            // Commons things to do
            vm.checkout.catalogId = vm.facebook.catalog.id;
            vm.checkout.feedId = vm.facebook.feed.id;
            vm.checkout.cityKey = vm.selectedCity.key;
            vm.checkout.businessId = vm.selectedBusiness.id;
            vm.checkout.pageId = vm.selectedBusinessPage.id;
            vm.checkout.catalogName = vm.catalogName;
            vm.checkout.storeName = $localStorage.defaultStore.storeNickname;
            vm.checkout.campaignValue = vm.project.total;
            vm.checkout.campaignDailyValue = vm.project.value;
            vm.checkout.campaignDays = vm.project.days;
            vm.checkout.campaignType = vm.project.campaignType;
            vm.checkout.token = vm.facebookData.accessToken;

			var url = window.location.host;
			vm.checkout.storeUrl = url.replace("admin", vm.checkout.storeName);

            BusinessIntegrationService.createCampaign(vm.checkout)
                    .then(success, error)
                    .catch(function (err) {
                        error(err);
                    });
        }

        function success(result) {
            vm.campaingResult = result.data;
            vm.isBuying = false;
            vm.closeModal();
        }

        function error(result) {
            vm.isBuying = false;
            if (result.data && result.data.headers && result.data.headers["x-flyerapp-alert"]) {
                toastr.error(result.data.headers["x-flyerapp-alert"]);
            } else {
                toastr.error($translate.instant('integrations.facebookBusiness.errors.createCampain'));
            }
        }

        vm.loadAdAcconunts = function () {
            vm.selectedAdAccount = null;
            vm.processing = true;
            FacebookService.adAccounts(vm.selectedBusiness.id).then(function (res) {
                vm.userAdAccounts = res.data;
                vm.processing = false;
            });
        };

        vm.createAdAccount = function () {
            vm.processing = true;
            FacebookService.createAdAccount(vm.selectedBusiness.id).then(function (res) {
                vm.processing = false;
                vm.loadAdAcconunts();
            }).catch(function(err) {
                vm.processing = false;
                toastr.error($translate.instant('integrations.facebookBusiness.errors.createCampain'));
            });
        };

        vm.addPaymentMethod = function() {
            FB.ui(
                {
                    account_id: vm.selectedAdAccount.account_id,
                    display: 'popup',
                    method: 'ads_payment',
                },   // callback
                function(response) {
                    if (response && !response.error_message) {
                        toastr.success("Adicionado com sucesso!");
                    } else {
                        toastr.error("Erro ao adicionar meio de pagamento!");
                    }
              });
        }

    }
})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("CampaignInsightsModalFactory", CampaignInsightsModalFactory);


    /** @ngInject */
    function CampaignInsightsModalFactory($uibModal) {

        var factory = {
            connect: connect
        };

        return factory;

        function connect(campaignId) {
            return $uibModal.open({
                templateUrl: 'app/integrations/facebook-business/campaign-insights-modal/campaign-insights.modal.html',
                controller: 'CampaignInsightsModalController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    data: function() {
                        return campaignId;
                    }
                }
            }).result;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('CampaignInsightsModalController', CampaignInsightsModalController);

    CampaignInsightsModalController.$inject = [
        '$uibModalInstance', '$translate', 'BusinessIntegrationService', 'data'
    ];

    function CampaignInsightsModalController($uibModalInstance, $translate, BusinessIntegrationService, data) {

        var vm = this;
        vm.campaignId = data;

        vm.confirm = function () {
            $uibModalInstance.close(true);
        };

        vm.closeModal = function () {
            $uibModalInstance.close(false);
        };

        var barChartAxes = [{
            gridLines: {
                display: false
            },
            ticks: {
                min: 0,
                max: this.max,
                callback: function (value) {
                    if (Number.isInteger(value)) {
                        var percentage = value / vm.campaignInsights.impressions * 100;
                        return percentage > 100 ? '100%' : percentage.toFixed(0) + '%';
                    }
                    return value;
                },
            },
        }];

        var chartTooltip = {
            callbacks: {
                label: function (tooltipItem, data) {
                    var value = data.datasets[0].data[tooltipItem.index];
                    return vm.getRateValue(value, vm.campaignInsights.impressions);
                }
            }
        }

        vm.barChartOptions = {
            maintainAspectRatio: false,
            tooltips: chartTooltip,
            scales: {
                xAxes: barChartAxes,
                yAxes: barChartAxes,
            }
        }

        vm.optionsPie = {
            legend: { display: true },
            maintainAspectRatio: false,
            responsive: true,
            tooltips: chartTooltip,
        }

        function getCampaignInsights(campaignId) {
            vm.processing = true;
            BusinessIntegrationService.getFbCampaignInsights(campaignId)
                .then(function (response) {
                    if (response.data) {
                        vm.campaignInsights = response.data;
                        vm.campaignInsights.frequency = vm.campaignInsights.frequency.toFixed(2);
                        setAudienceAgeData();
                        setAudienceGenderData();
                        setAudienceRegionData();
                        setAudiencPlatformData();
                    }
                    vm.processing = false;
                }).catch(function (err) {
                    console.log(err)
                    vm.processing = false;
                })
        }

        function setChartData(data) {
            var labels = [];
            var values = [];
            try {
                data.forEach(function (item) {
                    labels.push(item.name)
                    values.push(item.value);
                });
            } catch (error) {
                console.log(error);
            }
            return { labels: labels, values: values };
        }

        function setAudienceAgeData() {
            var data = setChartData(vm.campaignInsights.age);
            vm.audienceAgeLabels = data.labels;
            vm.audienceAgeValues = data.values;
        }

        function setAudienceGenderData() {
            var data = setChartData(vm.campaignInsights.gender);
            vm.audienceGenderLabels = data.labels.map(function (label) {
                return $translate.instant('integrations.facebookBusiness.insights.' + label)
            });
            vm.audienceGenderValues = data.values;
        }

        function setAudienceRegionData() {
            var data = setChartData(vm.campaignInsights.region);
            vm.audienceRegionLabels = data.labels;
            vm.audienceRegionValues = data.values;
        }

        function setAudiencPlatformData() {
            var data = setChartData(vm.campaignInsights.devicePlatform);
            vm.audiencePlatformLabels = data.labels.map(function (label) {
                return $translate.instant('integrations.facebookBusiness.insights.' + label)
            });
            vm.audiencePlatformValues = data.values;
        }

        vm.getRateValue = function (value, total) {
            total = total === undefined ? 1 : total;
            return value > 0 ? ((value / total) * 100).toFixed(2) + '%' : '0%';
        }

        vm.getCostValue = function (value) {
            return value.toFixed(2);
        }

        getCampaignInsights(vm.campaignId);
    }
})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("FBAuthModalFactory", FBAuthModalFactory);


    /** @ngInject */
    function FBAuthModalFactory($uibModal) {

        var factory = {
            connect: connect
        };

        return factory;

        function connect(isCommunication) {
            return $uibModal.open({
                templateUrl: 'app/integrations/facebook-business/auth-modal/fb-auth.modal.html',
                controller: 'FBAuthModalController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    isCommunication: function() {
                        return isCommunication;
                    }
                }
            }).result;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FBAuthModalController', FBAuthModalController);

        FBAuthModalController.$inject = ['$uibModalInstance', '$timeout', 'FacebookService', '$translate',
        'toastr', '$q', 'ChatCommerceService', 'MessengerService', '$scope', 'isCommunication'
    ];

    function FBAuthModalController($uibModalInstance, $timeout, FacebookService, $translate,
        toastr, $q, ChatCommerceService, MessengerService, $scope, isCommunication) {

        var vm = this;

        var SOURCE_MESSENGER = 'MESSENGER';

        vm.isCommunication = isCommunication;
        vm.selectedCity;
        vm.facebook = {
            catalogGenerated: false,
            instagram: {
                id: ''
            },
            business: {
                id: ''
            },
            feed: {
                id: ''
            },
            page: {
                id: ''
            },
            paymentAccount: {
                id: ''
            },
            connected: false
        };
        vm.isBussy = false;
        vm.userBusinesses = [];
        vm.userInstagramAccounts = [];
        vm.user = {};
        vm.currentStep = 0;
        vm.totalOfSteps = 5;
        vm.selectedBusiness;
        vm.selectedAdAccount;
        vm.selectedInstagram;
        vm.selectedBusinessPage;
        vm.searchText = null;

        vm.syncProgress = 0;

        vm.progressInterval;

        vm.confirm = function () {
            $uibModalInstance.close(true);
        };

        vm.closeModal = function () {
            $uibModalInstance.close(false);
        };

        vm.fbLogin = function () {
            vm.processing = true;
            FacebookService.login().then(updateStatus);
        };

        vm.fbLogout = function () {
            FacebookService.logout().then(updateStatus);
        };

        vm.checkFbStatus = function () {
            // TODO
        };

        vm.loadUserData = function () {
            vm.processing = true;
            if (vm.facebook.connected) {
                FacebookService.me().then(function (data) {
                    vm.user = data;
                    vm.processing = false;
                })
            }
        };

        function updateStatus(response) {
            // vm.processing = false;
            if (response.status === 'connected') {
                vm.facebook.connected = true;
                vm.facebook.data = response;
                vm.loadBusiness();
                vm.loadUserData();

                if (!vm.selectedInstagram) return;

                vm.connectData = {
                    accessToken: vm.facebook.data.authResponse.accessToken,
                    igBusinessAccount: { igAccountId: vm.selectedInstagram.id, name: vm.selectedInstagram.username },
                    businessId: vm.selectedBusiness.id,
                    pageId: vm.selectedBusinessPage.id,
                    adsAccount: vm.selectedAdAccount ? vm.selectedAdAccount.id : ''
                }

                MessengerService.makeMessengerCredentials(vm.connectData).then(function(result) {
                    console.log('Messenger connected automatic');
                }).catch(function(error) {

                });
            } else {
                vm.facebook.connected = false;
                vm.userBusinesses = [];
                vm.facebook.data = {};
            }

        }

        vm.loadBusiness = function (token) {
            vm.selectedBusiness = null;
            vm.processing = true;
            FacebookService.business(token).then(function (res) {
                 if (res.data && res.data.length > 0) { 
                    vm.userBusinesses = vm.userBusinesses.concat(res.data);
                 }
                if (res.paging && res.paging.next) {
                    vm.loadBusiness(res.paging.cursors.after);
                } 
            }).catch(function(err) {
                console.log("ERR::", err);
            }).finally(function(){
                vm.processing = false;
            });
        };

        vm.loadBusinessPages = function () {
            vm.selectedBusinessPage = null;
            vm.processing = true;
            FacebookService.businessPages(vm.selectedBusiness.id).then(function (res) {
                vm.userBusinessesPages = res.data;
                vm.processing = false;
            }).catch(function(err) {
                console.log("ERR::", err);
            }).finally(function(){
                vm.processing = false;
            });
        };

        vm.loadBusinessInsta = function () {
            vm.userInstagramAccounts = [];
            if (vm.selectedBusinessPage.instagram_business_account) {
                vm.userInstagramAccounts.push(vm.selectedBusinessPage.instagram_business_account);
            }
        };

        vm.querySearch = function (query) {

            vm.deferred = $q.defer();
            FacebookService.searchCity(query)
                .then(function (res) {
                    vm.deferred.resolve(res)
                });
            return vm.deferred.promise;
        }

        /**
         * On Init
         */
        $timeout(function () {
            vm.checkFbStatus();
        }, 500);

        vm.next = function () {
            vm.currentStep < vm.totalOfSteps ?
                (vm.currentStep = vm.currentStep + 1) : '';

        };

        vm.previous = function () {
            if (vm.currentStep === 1) {
                vm.selectedBusiness = null;
            }
            if (vm.currentStep === 2) {
                vm.selectedBusinessPage = null;
            }
            vm.currentStep !== 0 ? (vm.currentStep = vm.currentStep - 1) : '';
        };

        vm.nextDisabled = function () {
            switch (vm.currentStep) {
                case 0:
                    return vm.facebook.connected && vm.selectedBusiness ? false : true;
                case 1:
                    return vm.selectedBusinessPage ? false : true;
                case 2:
                    return vm.selectedInstagram ? false : true;
                case 3:
                    return false;
                default:
                    return false;
            }
        };

        vm.previousDisabled = function () {
            switch (vm.currentStep) {
                case 2:
                    return vm.facebook.catalog.id ? true : false;
                case 3:
                    return vm.campaingResult ? true : false;
                case 4:
                    return true;

                default:
                    return false;
            }
        };

        vm.modalTitle = function () {
            switch (vm.currentStep) {
                case 0:
                    return {title: 'Selecione seu negócio', subTitle: 'Aqui você seleciona seu negócio do Facebook'} ;
                case 1:
                    return {title: 'Selecione sua página', subTitle: 'Aqui você seleciona a página na qual seu anúncio será vinculado'};
                case 2:
                    return {title: 'Selecione o instagram', subTitle: 'Aqui você seleciona sua conta do instagram'} ;
                case 3:
                    return {title: 'Selecione sua conta de anúncios', subTitle: 'Essa conta precisa ter um meio de pagamento ativo'};
                default:
                    return false;
            }
        };

        vm.connectFacebook = function () {
            vm.isBuying = true;

            vm.connectData = {
                accessToken: vm.facebook.data.authResponse.accessToken,
                igBusinessAccount: { igAccountId: vm.selectedInstagram.id, name: vm.selectedInstagram.username },
                businessId: vm.selectedBusiness.id,
                pageId: vm.selectedBusinessPage.id,
                adsAccount: vm.selectedAdAccount ? vm.selectedAdAccount.id : ''
            }

            vm.progressInterval = setInterval(function () {
                if (vm.syncProgress === 100) {
                    clearInterval(vm.progressInterval);
                    return;
                }
                vm.syncProgress = vm.syncProgress + 5;
                $scope.$apply();
            }, 1000);

            ChatCommerceService.connectToChat({
                facebookAccountData: vm.connectData,
                chatPlatform: SOURCE_MESSENGER
            }).then(onSuccessFacebookConnect, onErrorFacebookConnect);

        }

        function onSuccessFacebookConnect(response) {
            if (response.facebookAccountData && response.facebookAccountData.accessToken) {
                vm.syncProgress = 100;
                clearInterval(vm.progressInterval);
                setTimeout(function () {
                    vm.isBuying = false;
                    $uibModalInstance.close(true);
                    toastr.success($translate.instant('socialMedia.success.successFacebookConnect'));
                }, 1000);
            }
        }

        function onErrorFacebookConnect(error) {
            vm.isBuying = false;
            vm.syncProgress = 0;
            clearInterval(vm.progressInterval);
            if (error.data) {
                if (error.data.headers['x-adminapp-alert'] == 'noPagesFound'){
                    ModalFactory.openSimpleModal(
                        $translate.instant('socialMedia.error.noPagesFoundTitle'),
                        $translate.instant('socialMedia.error.noPagesFoundMessage'),
                        $translate.instant('socialMedia.error.noPagesFoundConfirmText'),
                        null,
                        vm.facebookDisconnect).then(null, function (result){});
                }
            }
        }

        vm.loadAdAcconunts = function () {
            vm.selectedAdAccount = null;
            vm.processing = true;
            FacebookService.adAccounts(vm.selectedBusiness.id).then(function (res) {
                vm.userAdAccounts = res.data;
                // if (vm.userAdAccounts && !vm.userAdAccounts.length) {
                //     vm.createAdAccount();
                // }
                vm.processing = false;
            }, function() {
                vm.processing = false;

            });
        };

        vm.createAdAccount = function () {
            vm.processing = true;
             FacebookService.createAdAccount(vm.selectedBusiness.id, vm.facebook.data.authResponse.accessToken).then(function (res) {
                vm.processing = false;
                vm.loadAdAcconunts();
            }).catch(function(err) {
                vm.processing = false;
                toastr.error($translate.instant('integrations.facebookBusiness.errors.createCampain'));
            });
        };

        vm.addPaymentMethod = function() {
            FB.ui(
                {
                    account_id: vm.selectedAdAccount.account_id,
                    display: 'popup',
                    method: 'ads_payment',
                },   // callback
                function(response) {
                    if (response && !response.error_message) {
                        vm.loadAdAcconunts();
                        toastr.success("Adicionado com sucesso!");
                    } else {
                        toastr.error("Erro ao adicionar meio de pagamento!");
                    }
              });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .service('BusinessIntegrationService', BusinessIntegrationService);

    BusinessIntegrationService.$inject = ['BusinessIntegrationFactory'];

    function BusinessIntegrationService(BusinessIntegrationFactory) {

        var service = {
            getOwnerKeys: getOwnerKeys,
            createCampaign: createCampaign,
            getFbCampaingns: getFbCampaingns,
            getConfiguration: getConfiguration,
            createWhatsappJob: createWhatsappJob,
            resumeWhatsappJob: resumeWhatsappJob,
            existsWhatsappJob: existsWhatsappJob,
            clearWhatsappData: clearWhatsappData,
            getWhatsappResumes: getWhatsappResumes,
            disconnectWhatsapp: disconnectWhatsapp,
            facebookIsConnected: facebookIsConnected,
            initiateWhatsappSync: initiateWhatsappSync,
            getIgInsights: getIgInsights,
            getFbInsights: getFbInsights,
            getFbCampaignInsights: getFbCampaignInsights,
        };

        return service;

        function getOwnerKeys(storeId) {
            return BusinessIntegrationFactory.getOwnerKeys({
                storeId: storeId
            }).$promise;
        }
        function createCampaign(campaign) {
            return BusinessIntegrationFactory.createCampaign(campaign).$promise;
        }

        function getConfiguration(storeId, type, callback, errorCallback) {
            BusinessIntegrationFactory.getConfiguration({storeId: storeId, type: type, timestamp: new Date().getTime()}).$promise.then(callback, errorCallback);
        }

        function disconnectWhatsapp(storeId, callback, errorCallback){
            BusinessIntegrationFactory.disconnectByType({storeId: storeId, type: 'WHATSAPP'}, {}).$promise.then(callback, errorCallback);
        }

        function initiateWhatsappSync(storeId, mode, callback, errorCallback) {
            BusinessIntegrationFactory.initiateWhatsappSync({storeId: storeId, operation: mode}).$promise.then(callback, errorCallback);
        }

        function createWhatsappJob(whatsappDTO, callback, errorCallback) {
            BusinessIntegrationFactory.createWhatsappJob(whatsappDTO).$promise.then(callback, errorCallback);
        }

        function clearWhatsappData(storeId, callback, errorCallback) {
            BusinessIntegrationFactory.clearWhatsappData({storeId: storeId}).$promise.then(callback, errorCallback);
        }

        function getWhatsappResumes(storeId, pagination, filter, callback, errorCallback){
            BusinessIntegrationFactory.getWhatsappResumes({storeId: storeId, timestamp: new Date().getTime(), page: pagination.page, size: pagination.size}, filter).$promise.then(callback, errorCallback);
        }

        function getFbCampaingns(pagination, filter) {
            return BusinessIntegrationFactory.getFbCampaingns({timestamp: new Date().getTime(), page: pagination.page, size: pagination.size, filter: filter}).$promise;
        }

        function resumeWhatsappJob(token){
            return BusinessIntegrationFactory.resumeWhatsAppJob({token: token}).$promise;
        }

        function facebookIsConnected(){
            return BusinessIntegrationFactory.facebookIsConnected().$promise;
        }

        function existsWhatsappJob(storeId){
            return BusinessIntegrationFactory.existsWhatsappJob({storeId: storeId}).$promise;
        }

        function getIgInsights(startDate, endDate){
            return BusinessIntegrationFactory.getIgInsights({start: startDate, end: endDate}).$promise;
        }

        function getFbInsights(startDate, endDate){
            return BusinessIntegrationFactory.getFbInsights({start: startDate, end: endDate}).$promise;
        }

        function getFbCampaignInsights(campaignId){
            return BusinessIntegrationFactory.getFbCampaignInsights({campaignId: campaignId}).$promise;
        }

    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('BusinessIntegrationFactory', BusinessIntegrationFactory);

    BusinessIntegrationFactory.$inject = ['$resource'];

    function BusinessIntegrationFactory($resource) {
        var resourceUrl =  'flyer/api/flyer/:flyerId';

        return $resource(resourceUrl, {}, {
            'getOwnerKeys': {
                method: 'GET',
                url: '/flyer/api/payment/owner/keys/:storeId',
                transformResponse: function(data, headers) {
                    var response = {};
                    if(data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
              },
            'createCampaign': {
                method: 'POST',
                url: '/flyer/api/facebookBusiness/campaign',
                transformResponse: function(data, headers) {
                    var response = {};
                    if(data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
              },
            'facebookIsConnected': {
                method: 'GET',
                url: '/admin/api/store/facebook',
                transformResponse: function(data, headers) {
                    var response = {};
                    if(data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
              },
              'receiveCode': {
                method: 'POST',
                url: '/admin/api/business-integration/google-my-business/receive-code/:storeId',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'selectAccount': {
                method: 'POST',
                url: '/admin/api/business-integration/google-my-business/select-account/:storeId',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'selectGMBLocation': {
                method: 'POST',
                url: '/admin/api/business-integration/google-my-business/select-location/:storeId',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getGMBCategoriesList': {
                method: 'POST',
                url: '/admin/api/business-integration/google-my-business/get-categories',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getGMBLocationList': {
                method: 'GET',
                url: '/admin/api/business-integration/google-my-business/get-location/:storeId',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getConfiguration': {
                method: 'GET',
                url: '/admin/api/business-integration/get-configuration/:storeId/:type',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'disconnectByType': {
                method: 'POST',
                url: '/admin/api/business-integration/disconnect/:storeId/:type',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'initiateWhatsappSync': {
                method: 'POST',
                url: '/admin/api/business-integration/whatsapp/initiate-sync',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'createWhatsappJob': {
                method: 'POST',
                url: '/admin/api/business-integration/whatsapp/create-job',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'clearWhatsappData': {
                method: 'POST',
                url: '/admin/api/business-integration/whatsapp/clear',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getWhatsappResumes': {
                method: 'POST',
                url: '/admin/api/business-integration/whatsapp-job/all/:storeId',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getFbCampaingns': {
                method: 'GET',
                url: '/flyer/api/facebookBusiness/list',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'resumeWhatsAppJob': {
                method: 'GET',
                url: '/admin/api/business-integration/whatsapp/resume-job/:token',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },

            'existsWhatsappJob': {
                method: 'GET',
                url: '/admin/api/business-integration/whatsapp/first/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getGMBInsights': {
                method: 'GET',
                url: '/admin/api/business-integration/google-my-business/insights/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getGMBQuestions': {
                method: 'GET',
                url: '/admin/api/business-integration/google-my-business/questions/:reportId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getIgInsights': {
                method: 'GET',
                url: '/admin/api/social/instagram/insights?start=:start&end=:end',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getFbInsights': {
                method: 'GET',
                url: '/admin/api/social/facebook/insights?start=:start&end=:end',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getFbCampaignInsights': {
                method: 'GET',
                url: '/flyer/api/facebookBusiness/campaign/:campaignId/insights',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('BusinessIntegrationController', BusinessIntegrationController);

    function BusinessIntegrationController(FacebookService, $timeout, FBAuthModalFactory,
        InstaStepsModalFactory, GMBService, $scope, $localStorage, toastr, $translate, FBCampaignModalFactory,
        SocialMediaService, ModalFactory, BusinessIntegrationService, CustomerService, $rootScope, CampaignInsightsModalFactory) {

        var vm = this;

        vm.tabSelected = 'instagramBusiness';
        vm.facebook = {};
        vm.isLoadingGMB = false;
        vm.isLoadingFB = false;

        vm.filterFbCampaigns = {};
        vm.currentPageFbCampaigns = 1;
        vm.numPerPageFbCampaigns = 10;
        vm.endRegistryFbCampaigns = vm.numPerPageFbCampaigns;
        vm.maxSizeFbCampaign = 5;
        vm.paginationOptionsFbCampaigns = {
            page: vm.currentPageFbCampaigns - 1,
            size: vm.numPerPageFbCampaigns,
            sort: null
        };
        vm.totalFBCampaigns = 0;

        vm.startRegistryFbCampaigns = 1;

        vm.gmbInsights = {};
        vm.totalGMBQuestions = 0;
        vm.gmbQuestions = [];
        vm.loadingGMBQuestions = false;

        vm.currentPageGMB = 1;
        vm.numPerPageGMB = 5;
        vm.maxSizeGMB = 5;
        vm.startRegistryGMB = 1;
        vm.endRegistryGMB = vm.numPerPageGMB;
        vm.paginationOptionsGMB = {
            page: vm.currentPageGMB - 1,
            size: vm.numPerPageGMB,
            sort: 'DESC'
        };

        function loadFacebookCampaigns(pagination, filter) {
            vm.loadingFacebookCamps = true;

            BusinessIntegrationService.getFbCampaingns(pagination, filter)
                .then(function (data) {
                    vm.totalFBCampaigns = data.headers['x-total-count'];
                    vm.facebookCampaigns = data.data.slice();
                    vm.loadingFacebookCamps = false;
                }).catch(function (err) {
                    vm.loadingFacebookCamps = false;
                })
        }

        vm.changePageFacebookCampaign = function () {

            var beginFacebookCampaign = ((vm.currentPageFbCampaigns - 1) * vm.numPerPageFbCampaigns),
                endFbCampaigns = beginFacebookCampaign + vm.numPerPageFbCampaigns;

            vm.paginationOptionsFbCampaigns.page = vm.currentPageFbCampaigns - 1;

            loadFacebookCampaigns(vm.paginationOptionsFbCampaigns, vm.filter);
            vm.startRegistryFbCampaigns = beginFacebookCampaign + 1;
            vm.endRegistryFbCampaigns = endFbCampaigns;

        }
        vm.changePageFacebookCampaign();
        vm.fbLogin = function () {
            FacebookService.login().then(updateStatus);
        };

        vm.fbLogout = function () {
            FacebookService.logout().then(updateStatus);
        };

        vm.changeTab = function (tab) {
            vm.tabSelected = tab;
            if (tab == 'instagramBusiness') {
                vm.checkFbStatus();
            } else if (tab == 'googleBusiness') {
                loadGMB();
            } else if (tab == 'whatsapp') {
                loadWhatsapp();
            } else if (tab == 'facebook') {
                vm.checkFbStatus();
            } else if (tab == 'facebookBusiness') {
                vm.checkFbStatus();
                loadFacebookCampaigns(vm.paginationOptionsFbCampaigns, vm.filter);
            }
        };

        vm.checkFbStatus = function () {
            vm.isLoadingFB = true;
            SocialMediaService.isFacebookConnected().then(updateStatus, function (err) {
                vm.isLoadingFB = false;
            });
        }

        vm.facebookDisconnect = function () {
            vm.isLoadingFB = true;
            SocialMediaService.facebookDisconnect().then(onSuccessFacebookDisconnect, function (err) {
                vm.isLoadingFB = false;
            });
        }

        function onSuccessFacebookDisconnect(response) {
            vm.isLoadingFB = false;
            if (response.data) {
                vm.facebook.connected = false;
                vm.igAccountConnected = false;
                toastr.success($translate.instant('socialMedia.success.successFacebookDisconnect'));
            } else {
                toastr.warning($translate.instant('socialMedia.error.cannotLoggout'));
            }
        }

        vm.isFistLoadSocialContent = false;

        vm.facebookAuth = function () {
            vm.isFistLoadSocialContent = false;
            FBAuthModalFactory.connect(false).then(function (data) {
                vm.isFistLoadSocialContent = true;
                if (data) {
                    vm.checkFbStatus();
                }
            });
        }

        vm.createCampain = function () {
            FBCampaignModalFactory.update(vm.facebook.data).then(function () {
                loadFacebookCampaigns(vm.paginationOptionsFbCampaigns, vm.filter);
            });
        }

        vm.createCatalog = function () {
            InstaStepsModalFactory.update().then(function () {
                loadFacebookCampaigns(vm.paginationOptionsFbCampaigns, vm.filter);
            });
        }

        /**
         * On Init
         */
        $timeout(function () {
            // vm.checkFbStatus();
        }, 500);


        function updateStatus(response) {
            vm.isLoadingFB = false;
            var result = response.data;
            if (result && result.accessToken && result.page) {
                vm.facebook.connected = true;
                vm.facebook.data = result;
                if (vm.tabSelected == 'instagramBusiness') {
                    updateIgStatus(result);
                }
                if (vm.tabSelected == 'facebook') {
                    getFbInsights();
                }
            } else {
                vm.facebook.connected = false;
                vm.facebook.data = {};
            }
        }

        vm.getCampaignInsights = function (campaign) {
            CampaignInsightsModalFactory.connect(campaign.id);
        }


        /**
         * GOOGLE MY BUSINESS CONTROLLER DATA
         */

        // Variables
        vm.isLoadingGMB = false;

        // This variable is to this controller know if the user just open this page
        vm.justArrive = true;

        vm.isGoogleMyBusinessConnected = false;
        vm.authorizeGMB = authorizeGMB;
        vm.signOutGMB = signOutGMB;
        vm.GMBConfiguration = null;

        function chooseAccounts() {
            vm.isLoadingGMB = true;
            vm.isGoogleMyBusinessConnected = false;
            if (vm.GMBConfiguration && (!vm.GMBConfiguration.googleAccountTarget || !vm.GMBConfiguration.googleLocationTarget)) {
                ModalFactory.openSelectGMBAccountAndCategoryModal(vm.GMBConfiguration.accounts)
                    .then(function (response) {
                        if (response) {
                            toastr.success($translate.instant('integrations.googleMyBusiness.modalSelectConfigurations.locations.messages.' + response));
                        }
                        getGMBInsights();
                    }, function (error) {
                        console.log("it's necessary to select an account");
                        if (error && error != 'backdrop click') {
                            toastr.error($translate.instant('integrations.googleMyBusiness.modalSelectConfigurations.locations.messages.' + error));
                        }
                        errorSelectAccount();
                        vm.isLoadingGMB = false;
                    });
            }
        }

        function getGMBInsights() {
            vm.isLoadingGMB = true;
            vm.isGoogleMyBusinessConnected = false;
            GMBService.getGMBInsights(
                { storeId: $localStorage.defaultStore.storeId },
                function (response) {
                    vm.gmbInsights = response.data;
                    vm.isLoadingGMB = false;
                    vm.isGoogleMyBusinessConnected = true;
                    getGMBQuestions(vm.gmbInsights.id, vm.paginationOptionsGMB)
                },
                function () {
                    vm.isLoadingGMB = false;
                    vm.isGoogleMyBusinessConnected = false;
                }
            )
        }

        function getGMBQuestions(reportId, pagination) {
            vm.loadingGMBQuestions = true;
            var params = pagination;
            params.reportId = reportId
            GMBService.getGMBQuestions(params, null).then(function (result) {
                vm.totalGMBQuestions = parseInt(result.headers['x-total-count']);
                vm.gmbQuestions = result.data.slice();
                vm.loadingGMBQuestions = false;
            }, function (error) {
                vm.loadingGMBQuestions = false;
            });
        }

        vm.changePageGMB = function () {
            var begin = ((vm.currentPageGMB - 1) * vm.numPerPageGMB),
                end = begin + vm.numPerPageGMB;
            vm.paginationOptionsGMB.page = vm.currentPageGMB - 1;

            getGMBQuestions(vm.gmbInsights.id, vm.paginationOptionsGMB);
            vm.startRegistryGMB = begin + 1;
            vm.endRegistryGMB = end;
        }

        function errorSelectAccount() {
            signOutGMB();
        }

        function successReceiveCodeCallback(response) {
            vm.isGoogleMyBusinessConnected = true;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
            if (response.data && response.data.accounts && response.data.accounts.length > 0) {
                toastr.success($translate.instant('integrations.googleMyBusiness.messages.successConnected'));
                vm.GMBConfiguration = response.data;
                chooseAccounts();
            } else {
                vm.isLoadingGMB = false;
            }

        }

        function errorReceiveCodeCallback() {
            vm.isGoogleMyBusinessConnected = false;
            vm.isLoadingGMB = false;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
            toastr.error($translate.instant('integrations.googleMyBusiness.messages.errorConnected'));
        }

        function callbackLoginError() {
            vm.isLoadingGMB = false;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }

        function callbackLogin(response) {
            /**
             * 1. verify if the user logged already has an access_token
             * 2. If not, add the new access_token to the user
             */
            GMBService.receiveCode({
                storeId: ($localStorage.defaultStore ? ($localStorage.defaultStore.storeId || '') : '')
            }, response.code, successReceiveCodeCallback, errorReceiveCodeCallback);

            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }

        function authorizeGMB() {
            vm.isLoadingGMB = true;
            GMBService.authorize(callbackLogin, callbackLoginError);
        }

        function erroSignOut() {
            vm.isGoogleMyBusinessConnected = true;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }

        function successSignOut() {
            vm.isGoogleMyBusinessConnected = false;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }

        function signOutGMB() {
            GMBService.signOut({
                storeId: ($localStorage.defaultStore ? ($localStorage.defaultStore.storeId || '') : ''),
                type: 'GOOGLE_MY_BUSINESS'
            }, successSignOut, erroSignOut);
        }

        function getInitialConfigurationCallback(response) {
            vm.GMBConfiguration = response ? response.data : null;
            vm.isGoogleMyBusinessConnected = (vm.GMBConfiguration && vm.GMBConfiguration.connected);
            if (vm.isGoogleMyBusinessConnected) {
                getGMBInsights();
            } else {
                vm.isLoadingGMB = false;
            }
        }

        function getInitialConfigurationErrorCallback(error) {
            vm.isGoogleMyBusinessConnected = (vm.GMBConfiguration && vm.GMBConfiguration.connected);
            vm.isLoadingGMB = false;
        }

        function getInitialConfiguration() {
            vm.isLoadingGMB = true;
            GMBService.getConfiguration({
                storeId: ($localStorage.defaultStore ? ($localStorage.defaultStore.storeId || '') : ''),
                type: 'GOOGLE_MY_BUSINESS'
            }, getInitialConfigurationCallback, getInitialConfigurationErrorCallback);
        }

        function loadGMB() {
            vm.isLoadingGMB = true;
            getInitialConfiguration();
        }

        /**
         *  WHATSAPP INTEGRATION CONTROLLER DATA
         */

        // 20 seconds in milliseconds
        vm.SPEND_TIME_PER_PHONE = 20000;
        vm.WHATSAPPRESUME_FETCH_INTERVAL = 2000;

        vm.whatsappConf = null;
        vm.isWhatsappTabLoading = false;
        vm.loadingWhatsappJobResumes = true;
        vm.isSending = false;
        vm.loadingCustomers = false;
        vm.selectedCustomers = [];
        vm.unselectedCustomers = [];
        vm.customers = [];
        vm.whatsappJobResumes = [];

        vm.thereIsWhatsappJob = false;

        vm.wappDTO = {};
        vm.wappDTO.phones = [];
        vm.wappDTO.excludedPhones = [];
        vm.wappDTO.isAllCustomers = false;


        // Customer pagination configuration
        vm.filter = {};
        vm.currentPage = 1;
        vm.numPerPage = 5;
        vm.maxSize = 5;
        vm.totalCustomers = 0;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;
        vm.isRetrying = false;


        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        // WhatsappJob Pagination configuration
        vm.filterWhatsappJob = {};
        vm.currentPageWhatsappJob = 1;
        vm.numPerPageWhatsappJob = 10;
        vm.maxSizeWhatsappJob = 5;
        vm.startRegistryWhatsappJob = 1;
        vm.endRegistryWhatsappJob = vm.numPerPageWhatsappJob;
        vm.totalWhatsappJob = 0;

        vm.paginationOptionsWhatsappJob = {
            page: vm.currentPageWhatsappJob - 1,
            size: vm.numPerPageWhatsappJob,
            sort: null
        };

        // Functions
        vm.selectCustomer = selectCustomer;
        vm.changePageCustomer = changePageCustomer;
        vm.changePageWhatsappJob = changePageWhatsappJob;
        vm.selectAllCustomers = selectAllCustomers;
        vm.existsWhatsappJob = existsWhatsappJob;

        vm.reconectWhatsapp = function () {
            vm.getQrCode();
        }
        vm.openWhatsappCampaingModal = function () {
            ModalFactory.openWhatsappQRCodeModal(vm.whatsappConf).then(successQrCodeModalCallback, errorQrCodeModalCallback);
        }

        function successQrCodeModalCallback(response) {
            clearInterval($rootScope.fetchQrCodeInterval);
            loadWhatsapp();
        }

        function errorQrCodeModalCallback(response) {
            clearInterval($rootScope.fetchQrCodeInterval);
            loadWhatsapp();
        }

        function clearPageSelections() {
            vm.customers.forEach(function (elem) {
                if (elem.selected) {
                    selectCustomer(elem);
                }
            });
        }

        function selectAllCustomers() {
            if (vm.wappDTO.isAllCustomers) {
                clearAllSelections();
            } else {
                vm.wappDTO.isAllCustomers = true;
                vm.selectedCustomers = [];
                vm.unselectedCustomers = [];
                vm.customers.forEach(function (elem) {
                    if (!elem.selected) {
                        selectCustomer(elem);
                    }
                });
            }

        }

        function clearAllSelections() {
            vm.wappDTO.isAllCustomers = false;
            vm.selectedCustomers = [];
            vm.unselectedCustomers = [];
            clearPageSelections();
        }

        function whatsappGetConfigurationCallback(response) {
            vm.whatsappConf = response.data;
            vm.isWhatsappTabLoading = false;
        }

        function whatsappGetConfigurationErrorCallback() {
            toastr.error($translate.instant('integrations.whatsapp.messages.errorGetConfiguration'));
        }


        function loadWhatsapp() {
            vm.isWhatsappTabLoading = true;
            BusinessIntegrationService.getConfiguration(($localStorage.defaultStore ? ($localStorage.defaultStore.storeId || '') : ''),
                'WHATSAPP',
                whatsappGetConfigurationCallback,
                whatsappGetConfigurationErrorCallback);

            listCustomers(vm.paginationOptions, vm.filter);
            loadWhatsappJobResumes(vm.paginationOptionsWhatsappJob, vm.filterWhatsappJob);
            vm.existsWhatsappJob();
        }

        vm.orderByBirthdayWeek = function () {
            vm.orderedByBirthdayWeek = !vm.orderedByBirthdayWeek;

            vm.filter.orderedByBirthdayWeek = vm.orderedByBirthdayWeek;
            vm.currentPage = 1;
            vm.paginationOptions.page = 0;
            listCustomers(vm.paginationOptions, vm.filter);

        }

        // Select or unselect the customer
        function selectCustomer(customer) {

            // Switch the customer selected variable
            // Here the customers must be unselected if the all customers option is true
            // otherwise, if customers is unselected by user and all customers option is true
            // then we have to add the customer to excludedCustomers list in wappDTO
            customer.selected = !customer.selected;

            // If customer is selected and allCustomer is true, so we don't need to insert customer into selectedCustomers list
            if (customer.selected && !vm.wappDTO.isAllCustomers) {
                var isPresent = (findIndexByAttr(vm.selectedCustomers, 'id', customer.id) > -1);
                if (!isPresent) vm.selectedCustomers.push(customer);
            } else if (!customer.selected && vm.wappDTO.isAllCustomers) {
                vm.unselectedCustomers.push(customer);
            } else {
                removeElementFromArrayByAttr(vm.selectedCustomers, 'id', customer.id);
            }
        }


        // Sync the page with all previous selected customers
        function syncCustomerSelectedWithCustomers(customers, selectedCustomers) {

            // If all customers is selected is only to turn selected variable to true in each customer
            if (vm.wappDTO.isAllCustomers) {
                customers.forEach(function (element) {
                    // Verify if customer is in unselected list
                    var isPresent = (findIndexByAttr(vm.unselectedCustomers, 'id', element.id) > -1);
                    if (!isPresent) {
                        // Here we turn selected variable to true or false;
                        selectCustomer(element);
                    }
                });
            } else {
                selectedCustomers.forEach(function (elm) {
                    var targetIndex = findIndexByAttr(customers, 'id', elm.id);
                    if (targetIndex > -1) {
                        customers[targetIndex].selected = true;
                    }
                });
            }

            vm.loadingCustomers = false;

        }


        // List the customer using pagination
        function listCustomers(pagination, filter) {
            vm.loadingCustomers = true;
            CustomerService.list(pagination, filter).then(function (result) {
                vm.totalCustomers = result.headers['x-total-count'];
                vm.customers = result.data.slice();

                // Sync all the new customers with selected customers
                syncCustomerSelectedWithCustomers(vm.customers, vm.selectedCustomers);
            }, function (error) {
                vm.loadingCustomers = false;
            });
        }

        function changePageCustomer() {

            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            vm.customers = listCustomers(vm.paginationOptions, vm.filter);
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;

        }

        function changePageWhatsappJob() {

            var beginWhatsappJob = ((vm.currentPageWhatsappJob - 1) * vm.numPerPageWhatsappJob),
                endWhatsappJob = beginWhatsappJob + vm.numPerPageWhatsappJob;

            vm.paginationOptionsWhatsappJob.page = vm.currentPageWhatsappJob - 1;

            loadWhatsappJobResumes(vm.paginationOptionsWhatsappJob, vm.filter);
            vm.startRegistryWhatsappJob = beginWhatsappJob + 1;
            vm.endRegistryWhatsappJob = endWhatsappJob;

        }

        function whatsappGetResumesCallback(response) {
            vm.totalWhatsappJob = response.headers['x-total-count'];
            vm.whatsappJobResumes = response.data.slice();
            vm.loadingWhatsappJobResumes = false;
        }

        function whatsappGetResumesErrorCallback(error) {
            toastr.error($translate.instant('integrations.whatsapp.messages.errorGetResumesWhatsappJob'));
            vm.loadingWhatsappJobResumes = false;
        }

        function loadWhatsappJobResumes(pagination, filter) {
            vm.loadingWhatsappJobResumes = true;
            BusinessIntegrationService.getWhatsappResumes(($localStorage.defaultStore ? ($localStorage.defaultStore.storeId || '') : ''),
                pagination, filter, whatsappGetResumesCallback, whatsappGetResumesErrorCallback);
        }

        function existsWhatsappJobCallbak(response) {
            vm.thereIsWhatsappJob = response.data;
        }

        function existsWhatsappJob() {
            BusinessIntegrationService.existsWhatsappJob(($localStorage.defaultStore ? ($localStorage.defaultStore.storeId || '') : '')).then(existsWhatsappJobCallbak);
        }

        vm.getToolTip = function (resume) {
            var totalPendding = resume.targets.length - (resume.totalMessagesFailed + resume.totalMessagesSent);
            var tooltip = $translate.instant('integrations.whatsapp.messages.percentageInfo', {
                total: resume.targets.length,
                failed: resume.totalMessagesFailed,
                sent: resume.totalMessagesSent,
                pending: totalPendding
            });
            return tooltip;
        }

        vm.getSentPercentage = function (resume) {
            return (resume.totalMessagesSent / resume.targets.length) * 100;
        }

        vm.getFailedPercentage = function (resume) {
            return (resume.totalMessagesFailed / resume.targets.length) * 100;
        }

        vm.getTotalPercentage = function (resume) {
            var total = ((resume.totalMessagesFailed + resume.totalMessagesSent) / resume.targets.length);
            return (total * 100).toFixed(2);
        }

        vm.getPendingPercentage = function (resume) {
            var totalProcessed = resume.totalMessagesFailed + resume.totalMessagesSent;
            return ((resume.targets.length - totalProcessed) / resume.targets.length) * 100;
        }

        vm.getResumeFBStatusClass = function (resume) {
            //TODO REFACTOR
            return 'badge badge-finished';
            if (resume.status == 'PAID') return 'badge badge-finished';
            else if (resume.status == 'WAITING_PAYMENT') return 'badge badge-warning';
            else if (resume.status == 'FAILED') return 'badge badge-danger';
            else if (resume.status == 'NOT_PAID') return 'badge badge-danger';
            else if (resume.status == 'PROCESSING') return 'badge badge-success';
        }

        vm.getResumeStatusClass = function (resume) {
            if (resume.status == 'DONE') return 'badge badge-finished';
            else if (resume.status == 'PENDING') return 'badge badge-warning';
            else if (resume.status == 'FAILED') return 'badge badge-danger';
            else if (resume.status == 'PROCESSING') return 'badge badge-success';
        }
        vm.printBillet = function (data) {
            var win = window.open(data.redirectHrefBoleto + '/print', '_blank');
            win.focus();
        }

        vm.detailWhatsappJob = function (resume) {

        }

        vm.resumeWhatsappJob = function (resume) {
            vm.selectedResume = resume;
            vm.isRetrying = true;
            BusinessIntegrationService.resumeWhatsappJob(resume.token)
                .then(function (data) {
                    toastr.success(
                        $translate.instant('integrations.whatsapp.messages.successRetried')
                    );
                    vm.filterWhatsappJob.campaingName = resume.campaingName;
                    loadWhatsappJobResumes(vm.paginationOptionsWhatsappJob, vm.filterWhatsappJob);
                    vm.isRetrying = false;
                })
                .catch(function (error) {
                    vm.isRetrying = false;
                    if (error.data.headers["x-adminapp-params"] === 'notLoggedIn') {
                        ModalFactory.openWhatsappResumeQrCodeModal().then(function (mResp) {
                            if (mResp === 'connected') {
                                toastr.success($translate.instant('integrations.whatsapp.messages.successRetried'));
                                BusinessIntegrationService.resumeWhatsappJob(resume.token);
                            }
                            if (mResp === 'expired') {
                                toastr.error($translate.instant('integrations.whatsapp.messages.errorRetried'));
                            }
                        }).catch(function (err) {
                            toastr.error($translate.instant('integrations.whatsapp.messages.errorRetried'));
                        });
                    }
                })
        }

        vm.removeWhatsappJob = function (resume) {

        }

        $scope.$on('refreshListCustomer', function (env) {
            listCustomers(vm.paginationOptions, vm.filter);
        });

        $scope.$on('refreshListWhatsappJob', function (env) {
            loadWhatsappJobResumes(vm.paginationOptionsWhatsappJob, vm.filterWhatsappJob);
        });

        vm.searchWaJobsByFilter = function () {
            vm.paginationOptionsWhatsappJob = {
                page: 0,
                size: vm.numPerPageWhatsappJob,
                sort: null
            };
            loadWhatsappJobResumes(vm.paginationOptionsWhatsappJob, vm.filterWhatsappJob);
        };

        // TODO: Better ot implement a refresh button
        // loadWhatsappJobResumes();
        // $rootScope.fetchWhatsappJobResumes = setInterval(
        //     loadWhatsappJobResumes,
        //     vm.WHATSAPPRESUME_FETCH_INTERVAL
        // );


        /**
         * INSIGHTS BUSINESS CONTROLLER DATA
         */

        // Variables
        vm.isLoadingIg = false;
        vm.igAccountMediaInsightsList = [];
        vm.igAccountInsights = {};
        vm.igAccountMediaInsights = {};
        vm.lineChartOptions = {
            maintainAspectRatio: false,
            responsive: true,
            scales: {
                xAxes: [{
                    ticks: {
                        display: false
                    }
                }],
                yAxes: [
                    {
                      type: 'linear',
                      display: true,
                      position: 'left'
                    }
                ]
            }
        }

        vm.barChartOptions = {
            maintainAspectRatio: false,
            responsive: true
        }

        vm.isLoadingFBInsights = false;
        vm.fbAccountInsights = {};
        vm.fbAccountMediaInsightsList = [];

        vm.dateRange = {
            startDate: moment().subtract(30, "days"),
            endDate: moment()
        };

        vm.audienceAgeLabels = ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'];

        var dateFormat = "DD-MM-YYYY";

        vm.dateRangeOptions = {
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Aplicar",
                fromLabel: "From",
                format: dateFormat,
                toLabel: "To",
                cancelLabel: 'Cancelar',
                customRangeLabel: 'Personalizado'
            },
            ranges: {
                'Ontem': [moment().subtract(1, 'days'), moment()],
                'Últimos 7 dias': [moment().subtract(7, 'days'), moment()],
                'Últimos 30 dias': [moment().subtract(30, 'days'), moment()],
                'Último ano': [moment().subtract(1, 'year'), moment()]
            },
            eventHandlers: {
                'apply.daterangepicker': function (ev, picker) {
                    getIgInsights();
                    getFbInsights();
                }
            }
        };

        angular.element("#insigthsDateRange").on("click", function(event){
            event.preventDefault();
            angular.element("#dateRangeInput").data("daterangepicker").show()
        });

        function updateIgStatus(result) {
            if (result.business && result.business.igBusinessAccount) {
                vm.igAccountConnected = true;
                vm.igAccountData = result.business.igBusinessAccount;

                getIgInsights();
            } else {
                vm.igAccountConnected = false;
                vm.igAccountData = {};
            }
        }

        function getIgInsights() {
            clearData();
            vm.isLoadingIg = true;
            if (vm.dateRange.endDate) {
                vm.dateRange.endDate = vm.dateRange.endDate.add(1, 'minutes');
            }
            BusinessIntegrationService.getIgInsights(vm.dateRange.startDate, vm.dateRange.endDate)
                .then(function (response) {
                    vm.igAccountMediaInsightsList = response.data;
                    if (vm.igAccountMediaInsightsList.length > 0) {
                        vm.igAccountInsights = vm.igAccountMediaInsightsList[0];
                        vm.igAccountMediaInsights = vm.igAccountInsights.igMediaAccountInsights;
                        setData();
                    }
                    vm.isLoadingIg = false;
                }).catch(function (err) {
                    vm.isLoadingIg = false;
                    console.log(err)
                })
        }

        function getFbInsights() {
            // clearData(); TODO
            vm.isLoadingFBInsights = true;
            BusinessIntegrationService.getFbInsights(vm.dateRange.startDate, vm.dateRange.endDate)
                .then(function (response) {
                    vm.fbAccountMediaInsightsList = response.data;
                    if (vm.fbAccountMediaInsightsList.length > 0) {
                        vm.fbAccountInsights = vm.fbAccountMediaInsightsList[0];
                        setData();
                    }
                    vm.isLoadingFBInsights = false;
                }).catch(function (err) {
                    vm.isLoadingFBInsights = false;
                    console.log(err)
                })
        }

        vm.getFormattedValue = function (value) {
            return value < 1000 ? value : (value / 1000).toFixed(0) + 'k';
        }

        vm.igHasContent = function () {
            if (vm.igAccountInsights && vm.igAccountInsights.followersCount) {
                    return true
            }
            return false;

        }

        function getRate(value, divisor) {
            return (value > 0 && divisor > 0) ? ((value / divisor) * 100).toFixed(2) + '%' : '0%';
        }

        function setAudienceAgeData() {
            try {
                if (vm.igAccountInsights.audienceGenderAge) {

                    var audienceGenderAge = JSON.parse(vm.igAccountInsights.audienceGenderAge);
                    var totalByAge;

                    vm.audienceAgeLabels.forEach(function (label) {
                        totalByAge = 0;
                        Object.keys(audienceGenderAge).forEach(function (key) {
                            if (key.includes(label)) {
                                totalByAge += audienceGenderAge[key];
                            }
                        });
                        vm.audienceAgeData.push(totalByAge);
                    })
                }
            } catch (error) {
                console.log(error);
            }
        }
        function setFbAudienceAgeData() {
            try {
                if (vm.fbAccountInsights.audienceGenderAge) {

                    var audienceGenderAge = JSON.parse(vm.fbAccountInsights.audienceGenderAge);
                    var totalByAge;

                    vm.audienceAgeLabels.forEach(function (label) {
                        totalByAge = 0;
                        Object.keys(audienceGenderAge).forEach(function (key) {
                            if (key.includes(label)) {
                                totalByAge += audienceGenderAge[key];
                            }
                        });
                        vm.fbAudienceAgeData.push(totalByAge);
                    })
                }
            } catch (error) {
                console.log(error);
            }
        }

        function getGenderValue(gender, data) {
            var total = 0;
            var totalByGender = 0;
            try {
                var audienceGenderAge = JSON.parse(data);
                Object.keys(audienceGenderAge).forEach(function (key) {
                    total += audienceGenderAge[key];
                    if (key.includes(gender)) {
                        totalByGender += audienceGenderAge[key];
                    }
                })
            } catch (error) {
                console.log(error);
            }
            return getRate(totalByGender, total);
        }

        function setAudienceLocationData() {
            try {
                if (vm.igAccountInsights.audienceCity) {
                    var audienceCity = JSON.parse(vm.igAccountInsights.audienceCity);
                    var audienceCityMapOrdered = new Map(Object.entries(audienceCity).sort(function (a, b){return b[1] - a[1];}));
                    var audienceCityNames = Array.from(audienceCityMapOrdered.keys());
                    var audienceCityValues = Array.from(audienceCityMapOrdered.values());

                    vm.audienceLocationLabels = audienceCityNames.slice(0, 6);
                    vm.audienceLocationData = audienceCityValues.slice(0, 6);
                }
            } catch (error) {
                console.log(error);
            }
        }

        function setFbAudienceLocationData() {
            try {
                if (vm.fbAccountInsights.audienceCity) {
                    var audienceCity = JSON.parse(vm.fbAccountInsights.audienceCity);
                    var audienceCityMapOrdered = new Map(Object.entries(audienceCity).sort(function (a, b){return b[1] - a[1];}));
                    var audienceCityNames = Array.from(audienceCityMapOrdered.keys());
                    var audienceCityValues = Array.from(audienceCityMapOrdered.values());
                    vm.fbAudienceLocationLabels = audienceCityNames.slice(0, 6);
                    vm.fbAudienceLocationData = audienceCityValues.slice(0, 6);
                }

            } catch (error) {
                console.log(error);
            }
        }

        function setAudienceGenderData() {
            if (vm.igAccountInsights.audienceGenderAge) {
                vm.followersFemale = getGenderValue('F', vm.igAccountInsights.audienceGenderAge);
                vm.followersMale = getGenderValue('M', vm.igAccountInsights.audienceGenderAge);
            }
            if (vm.fbAccountInsights.audienceGenderAge) {
                vm.fbFollowersFemale = getGenderValue('F', vm.fbAccountInsights.audienceGenderAge);
                vm.fbFollowersMale = getGenderValue('M', vm.fbAccountInsights.audienceGenderAge);
            }
        }

        function setEngagement() {
            vm.igAccountMediaInsights.storyEngagement = vm.igAccountMediaInsights.replies + vm.igAccountMediaInsights.tapsBack;
            vm.igAccountMediaInsights.postEngagementRate = getRate(vm.igAccountMediaInsights.postEngagement, vm.igAccountMediaInsights.postReach);
            vm.igAccountMediaInsights.storyEngagementRate = getRate(vm.igAccountMediaInsights.storyEngagement, vm.igAccountMediaInsights.storyReach);
        }

        function setFollowersData() {
            var igFollowers = getFollowersData(vm.igAccountInsights.follows);
            vm.followersLabels = igFollowers.followersLabels;
            vm.followersData = igFollowers.followersData;
        }

        function setFbFollowersData() {
            var fbFollowers = getFollowersData(vm.fbAccountInsights.follows);
            vm.fbFollowersLabels = fbFollowers.followersLabels;
            vm.fbFollowersData = fbFollowers.followersData;
        }

        function getFollowersData(data) {
            var startDate = new Date(vm.dateRange.startDate);
            var endDate = new Date(vm.dateRange.endDate)
            var followersLabels = [];
            var followersData = [];
            try {
                if (data) {
                    data.forEach(function (item) {
                        var date = new Date(item.timestamp);
                        if (date <= endDate && date >= startDate) {
                            var formattedDate = moment(date).format(dateFormat);
                            var total = item.followersCount;
                            var itemIndex = followersLabels.indexOf(formattedDate); // check if date has already been added
                            if (itemIndex >= 0) {
                                followersData[itemIndex] = total; // replace value
                            } else {
                                followersLabels.push(formattedDate);
                                followersData.push(total);
                            }
                        }
                    });
                }
            } catch (error) {
                console.log(error);
            }
            return {
                followersLabels: followersLabels,
                followersData: followersData
            }
        }

        function setData() {
            setEngagement();
            setAudienceAgeData();
            setAudienceGenderData();
            setAudienceLocationData();
            setFollowersData();
            setFbAudienceLocationData();
            setFbAudienceAgeData()
            setFbFollowersData();
        }

        function clearData() {
            vm.audienceAgeData = [];
            vm.fbAudienceAgeData = [];
            vm.followersData = [];
            vm.fbFollowersData = [];
            vm.audienceLocationData = [];
            vm.fbAudienceLocationData = [];
            vm.followersFemale = vm.followersMale = vm.fbFollowersFemale = vm.fbFollowersMale = 0;
        }

        clearData();

    }
})();

/**
 * INSPINIA - Responsive Admin Theme
 * 2.7
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout, $interval) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 69 + "px");
  }

  angular.element(window).bind("load resize scroll", function() {
      fix_height();
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  var fixHeightInterval = setInterval(function () {
      var element = angular.element('#page-wrapper');
      if (angular.copy(element.length) > 0) {
          fix_height();
          clearInterval(fixHeightInterval);
      }
  }, 1000);

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('showcaseApp')
    .directive('sideNavigation',sideNavigation)
    .directive('minimalizaSidebar', minimalizaSidebar)
    .directive('landingScrollspy', landingScrollspy)
    .directive('numbersOnly', numbersOnly)
    .directive('alphanumericOnly', alphanumericOnly)
    .directive('lettersOnly', lettersOnly)
    .directive('pageTitle', pageTitle)
    .directive('resizable', resizable)
    .directive('slimScroll', slimScroll)
    .directive('fullScroll', fullScroll)
    .directive('backImg', backImg)
    .directive('imgSrc', imgSrc)
    .directive('uppercase', uppercase);

function numbersOnly() {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(new RegExp(/[^\d]/g), '');

                    if(attr.exclude){
                        transformedInput = transformedInput.replace(attr.exclude, '')
                    }

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
}


function alphanumericOnly() {
    return {
        require: 'ngModel',
        link: function(scope, element, attr, ngModelCtrl) {
            element.bind('keydown', function(e) {
                if (e.which === 32) {
                    e.preventDefault();
                }
            });

            function fromUser(text) {
                if(text) {
                    var transformedInput = text.replace(/[^a-zA-Z0-9]/g, '');

                    if(attr.exclude){
                        transformedInput = transformedInput.replace(attr.exclude, '')
                    }

                    if(transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
}

function lettersOnly() {
    return {
        require: 'ngModel',
        link: function(scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if(text) {
                    var transformedInput = text.replace(/[^a-zA-Z]/g, '');

                    if(transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
}

function resizable() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            function makeResizable(element){
                if (element && jQuery(element).length){
                    var $el = jQuery(element);
                    var elHeight = $el.outerHeight();
                    var elWidth = $el.outerWidth();

                    var $wrapper = $el.parent();

                    var starterData = {
                        size: {
                            width: $wrapper.width(),
                            height: $wrapper.height()
                        }
                    }
                    var scale = Math.min(
                        starterData.size.width / $el.outerWidth(),
                        starterData.size.height / $el.outerHeight()
                    );
                    if (scale > 1){
                        scale = 1;
                    }
                    var elMarginBottom = (scale * elHeight) - starterData.size.height ;
                    $el.css({
                        transform: "translate3d(-50%, 0, 0) " + "scale(" + scale + ")",
                        'margin-bottom': elMarginBottom
                    });
                }
            }
            jQuery(document).ready(function() {
                makeResizable('#very-specific-design');
            });

            jQuery(window).resize(function() {
                makeResizable('#very-specific-design');
            });
        }
    };
}

function pageTitle($timeout) {
    return {
        link: function(scope, element) {
            var listener = function(event, toState, toParams, fromState, fromParams) {
                // Default title - load on Dashboard 1
                var title = 'KAZTOR | Showcase';
                // Create your own title pattern
                if (toState.data && toState.data.pageTitle) title = 'Showcase | ' + toState.data.pageTitle;
                $timeout(function() {
                    element.text(title);
                });
            };
            $rootScope.$on('$stateChangeStart', listener);
        }
    }
}

function landingScrollspy() {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.scrollspy({
                target: '.navbar-fixed-top',
                offset: 80
            });
        }
    }
}

function minimalizaSidebar($timeout, $window) {
    return {
        restrict: 'A',
        template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
        controller: function($scope) {

            $scope.minimalize = function() {
                // angular.element('body').toggleClass('mini-navbar');
                if(angular.element('body').hasClass('body-small') && !angular.element('body').hasClass('mini-navbar')){
                    angular.element('body').addClass('mini-navbar');
                } else if (angular.element('body').hasClass('mini-navbar')) {
                    angular.element('body').removeClass('mini-navbar');
                    angular.element('body').addClass('fixed-sidebar');
                } else {
                    angular.element('body').addClass('mini-navbar');
                    angular.element('body').removeClass('fixed-sidebar');
                };
                if (angular.element('#list-order-ul').hasClass("in")) {

                    angular.element('#list-order-ul').removeClass("in")
                    angular.element('#list-order-li').removeClass("active")
                }
                if (angular.element('#list-reports-ul').hasClass("in")) {

                    angular.element('#list-reports-ul').removeClass("in")
                    angular.element('#list-reports-li').removeClass("active")
                }

                if(!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                    // Hide menu in order to smoothly turn on when maximize menu
                    // angular.element('#side-menu').hide();
                    // angular.element('#side-menu').attr('style', 'overflow: hidden; width: auto;');
                    // For smoothly turn on menu
                    $timeout(function() {
                        angular.element('#side-menu').fadeIn(400);
                    }, 200);
                } else {
                    // Remove all inline style from jquery fadeIn function to
                    // reset menu state
                    angular.element('#side-menu').removeAttr('style');
                }

                $(document).ready(function() {

                    $(".slimScrollShowkaseMenu").slimScroll({
                        height: $window.innerHeight
                    });
                    $(".slimScrollDiv").slimScroll({
                        height: $window.innerHeight
                    });
                });

            };
            // $scope.minimalize();
        }
    };
}

function sideNavigation($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element) {
            // Call metsi to build when user signup
            scope.$watch('authentication.user', function() {
                $timeout(function() {
                    element.metisMenu();
                });
            });

            // Colapse menu in mobile mode after click on element
            var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
            menuElement.click(function(){
                if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                }
            });

            // Enable initial fixed sidebar
            // if (angular.element("body").hasClass('fixed-sidebar')) {
                var sidebar = element.parent();
                sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                });
            // }
        }
    };
}

function slimScroll(){
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.slimScroll({
                height: attrs.maxHeight || '100%',
                railOpacity: 0.9
            });


        }
    };
}

/**
 * fullScroll - Directive for slimScroll with 100%
 */
function fullScroll($timeout){
    return {
        restrict: 'A',
        link: function(scope, element) {
            $timeout(function(){
                element.slimscroll({
                    height: '100%',
                    railOpacity: 0.9
                });

            });
        }
    };
}

var flyerDefaultImg = 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/showkase/no-image.jpeg';

function backImg() {
    return function (scope, element, attrs) {
        var url = attrs.backImg;
        var image = new Image();
        image.src = url;
        image.onload = function () {
            // Image loaded - set the background image to it
            element.css("background-image", "url(" + url + ")");
        };
        image.onerror = function () {
            // Image failed to load - use default
            element.css("background-image", "url(" + flyerDefaultImg + ")");
        };
    };
}

function imgSrc() {
    return function (scope, element, attrs) {
        var url = attrs.imgSrc;
        var image = new Image();
        image.src = url;
        image.onload = function () {
            // Image loaded - set the src image to it
            element.attr('src', url);
        };
        image.onerror = function () {
            // Image failed to load - use default
            element.attr('src', flyerDefaultImg);
        };
    };
}

function uppercase() {
    return {
        require: 'ngModel',
        link: function(scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                console.log(text);
                if (text) {
                    var transformedInput = text.toUpperCase();;
                    console.log(transformedInput);
                    if(transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
}

/**
 * INSPINIA - Responsive Admin Theme
 *
 * Main controller.js file
 * Define controllers with data used in Inspinia theme
 *
 *
 * Functions (controllers)
 *  - MainCtrl
 *  - dashboardFlotOne
 *  - dashboardFlotTwo
 *  - dashboardFlotFive
 *  - dashboardMap
 *  - flotChartCtrl
 *  - rickshawChartCtrl
 *  - sparklineChartCtrl
 *  - widgetFlotChart
 *  - modalDemoCtrl
 *  - ionSlider
 *  - wizardCtrl
 *  - CalendarCtrl
 *  - chartJsCtrl
 *  - GoogleMaps
 *  - ngGridCtrl
 *  - codeEditorCtrl
 *  - nestableCtrl
 *  - notifyCtrl
 *  - translateCtrl
 *  - imageCrop
 *  - diff
 *  - idleTimer
 *  - liveFavicon
 *  - formValidation
 *  - agileBoard
 *  - draggablePanels
 *  - chartistCtrl
 *  - metricsCtrl
 *  - sweetAlertCtrl
 *  - selectCtrl
 *  - toastrCtrl
 *  - loadingCtrl
 *  - datatablesCtrl
 *  - truncateCtrl
 *  - touchspinCtrl
 *  - tourCtrl
 *  - jstreeCtrl
 *  - datamapsCtrl
 *  - pdfCtrl
 *  - passwordMeterCtrl
 *
 *
 */

/**
 * MainCtrl - controller
 * Contains several global data used in different view
 *
 */
function MainCtrl($http) {

    /**
     * countries - Used as duallistbox in form advanced view
     */

    this.countries = [
        {
            name: 'Amsterdam'
        },
        {
            name: 'Washington'
        },
        {
            name: 'Sydney'
        },
        {
            name: 'Cairo'
        },
        {
            name: 'Beijing'
        }];

    this.getLocation = function (val) {
        return $http.get('//maps.googleapis.com/maps/api/geocode/json', {
            params: {
                address: val,
                sensor: false
            }
        }).then(function (response) {
            return response.data.results.map(function (item) {
                return item.formatted_address;
            });
        });
    };

    /**
     * daterange - Used as initial model for data range picker in Advanced form view
     */
    this.daterange = {
        startDate: null,
        endDate: null
    };

    /**
     * slideInterval - Interval for bootstrap Carousel, in milliseconds:
     */
    this.slideInterval = 5000;

    /**
     * tags - Used as advanced forms view in input tag control
     */

    this.tags = [
        {
            text: 'Amsterdam'
        },
        {
            text: 'Washington'
        },
        {
            text: 'Sydney'
        },
        {
            text: 'Cairo'
        },
        {
            text: 'Beijing'
        }
    ];

    /**
     * states - Data used in Advanced Form view for Chosen plugin
     */
    this.states = [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'Florida',
        'Georgia',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
    ];

    /**
     * check's - Few variables for checkbox input used in iCheck plugin. Only for demo purpose
     */
    this.checkOne = true;
    this.checkTwo = true;
    this.checkThree = true;
    this.checkFour = true;

    /**
     * knobs - Few variables for knob plugin used in Advanced Plugins view
     */
    this.knobOne = 75;
    this.knobTwo = 25;
    this.knobThree = 50;

    /**
     * Variables used for Ui Elements view
     */
    this.bigTotalItems = 175;
    this.bigCurrentPage = 1;
    this.maxSize = 5;
    this.singleModel = false;
    this.radioModel = 'Middle';
    this.checkModel = {
        left: false,
        middle: true,
        right: false
    };

    /**
     * groups - used for Collapse panels in Tabs and Panels view
     */
    this.groups = [
        {
            title: 'Dynamic Group Header - 1',
            content: 'Dynamic Group Body - 1'
        },
        {
            title: 'Dynamic Group Header - 2',
            content: 'Dynamic Group Body - 2'
        }
    ];

    /**
     * alerts - used for dynamic alerts in Notifications and Tooltips view
     */
    this.alerts = [
        {
            type: 'danger',
            msg: 'Oh snap! Change a few things up and try submitting again.'
        },
        {
            type: 'success',
            msg: 'Well done! You successfully read this important alert message.'
        },
        {
            type: 'info',
            msg: 'OK, You are done a great job man.'
        }
    ];

    /**
     * addAlert, closeAlert  - used to manage alerts in Notifications and Tooltips view
     */
    this.addAlert = function () {
        this.alerts.push({
            msg: 'Another alert!'
        });
    };

    this.closeAlert = function (index) {
        this.alerts.splice(index, 1);
    };

    /**
     * randomStacked - used for progress bar (stacked type) in Badges adn Labels view
     */
    this.randomStacked = function () {
        this.stacked = [];
        var types = ['success', 'info', 'warning', 'danger'];

        for (var i = 0, n = Math.floor((Math.random() * 4) + 1); i < n; i++) {
            var index = Math.floor((Math.random() * 4));
            this.stacked.push({
                value: Math.floor((Math.random() * 30) + 1),
                type: types[index]
            });
        }
    };
    /**
     * initial run for random stacked value
     */
    this.randomStacked();

    /**
     * summernoteText - used for Summernote plugin
     */
    this.summernoteText = ['<h3>Hello Jonathan! </h3>',
    '<p>dummy text of the printing and typesetting industry. <strong>Lorem Ipsum has been the dustrys</strong> standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more',
        'recently with</p>'].join('');

    /**
     * General variables for Peity Charts
     * used in many view so this is in Main controller
     */
    this.BarChart = {
        data: [5, 3, 9, 6, 5, 9, 7, 3, 5, 2, 4, 7, 3, 2, 7, 9, 6, 4, 5, 7, 3, 2, 1, 0, 9, 5, 6, 8, 3, 2, 1],
        options: {
            fill: ["#1ab394", "#d7d7d7"],
            width: 100
        }
    };

    this.BarChart2 = {
        data: [5, 3, 9, 6, 5, 9, 7, 3, 5, 2],
        options: {
            fill: ["#1ab394", "#d7d7d7"]
        }
    };

    this.BarChart3 = {
        data: [5, 3, 2, -1, -3, -2, 2, 3, 5, 2],
        options: {
            fill: ["#1ab394", "#d7d7d7"]
        }
    };

    this.LineChart = {
        data: [5, 9, 7, 3, 5, 2, 5, 3, 9, 6, 5, 9, 4, 7, 3, 2, 9, 8, 7, 4, 5, 1, 2, 9, 5, 4, 7],
        options: {
            fill: '#1ab394',
            stroke: '#169c81',
            width: 64
        }
    };

    this.LineChart2 = {
        data: [3, 2, 9, 8, 47, 4, 5, 1, 2, 9, 5, 4, 7],
        options: {
            fill: '#1ab394',
            stroke: '#169c81',
            width: 64
        }
    };

    this.LineChart3 = {
        data: [5, 3, 2, -1, -3, -2, 2, 3, 5, 2],
        options: {
            fill: '#1ab394',
            stroke: '#169c81',
            width: 64
        }
    };

    this.LineChart4 = {
        data: [5, 3, 9, 6, 5, 9, 7, 3, 5, 2],
        options: {
            fill: '#1ab394',
            stroke: '#169c81',
            width: 64
        }
    };

    this.PieChart = {
        data: [1, 5],
        options: {
            fill: ["#1ab394", "#d7d7d7"]
        }
    };

    this.PieChart2 = {
        data: [226, 360],
        options: {
            fill: ["#1ab394", "#d7d7d7"]
        }
    };
    this.PieChart3 = {
        data: [0.52, 1.561],
        options: {
            fill: ["#1ab394", "#d7d7d7"]
        }
    };
    this.PieChart4 = {
        data: [1, 4],
        options: {
            fill: ["#1ab394", "#d7d7d7"]
        }
    };
    this.PieChart5 = {
        data: [226, 134],
        options: {
            fill: ["#1ab394", "#d7d7d7"]
        }
    };
    this.PieChart6 = {
        data: [0.52, 1.041],
        options: {
            fill: ["#1ab394", "#d7d7d7"]
        }
    };
};


/**
 * dashboardFlotOne - simple controller for data
 * for Flot chart in Dashboard view
 */
function dashboardFlotOne() {

    var data1 = [
        [0, 4],
        [1, 8],
        [2, 5],
        [3, 10],
        [4, 4],
        [5, 16],
        [6, 5],
        [7, 11],
        [8, 6],
        [9, 11],
        [10, 30],
        [11, 10],
        [12, 13],
        [13, 4],
        [14, 3],
        [15, 3],
        [16, 6]
    ];
    var data2 = [
        [0, 1],
        [1, 0],
        [2, 2],
        [3, 0],
        [4, 1],
        [5, 3],
        [6, 1],
        [7, 5],
        [8, 2],
        [9, 3],
        [10, 2],
        [11, 1],
        [12, 0],
        [13, 2],
        [14, 8],
        [15, 0],
        [16, 0]
    ];

    var options = {
        series: {
            lines: {
                show: false,
                fill: true
            },
            splines: {
                show: true,
                tension: 0.4,
                lineWidth: 1,
                fill: 0.4
            },
            points: {
                radius: 0,
                show: true
            },
            shadowSize: 2,
            grow: {
                stepMode: "linear",
                stepDirection: "up",
                steps: 80
            }
        },
        grow: {
            stepMode: "linear",
            stepDirection: "up",
            steps: 80
        },
        grid: {
            hoverable: true,
            clickable: true,
            tickColor: "#d5d5d5",
            borderWidth: 1,
            color: '#d5d5d5'
        },
        colors: ["#1ab394", "#1C84C6"],
        xaxis: {},
        yaxis: {
            ticks: 4
        },
        tooltip: false
    };

    /**
     * Definition of variables
     * Flot chart
     */
    this.flotData = [data1, data2];
    this.flotOptions = options;
}

/**
 * dashboardFlotTwo - simple controller for data
 * for Flot chart in Dashboard view
 */
function dashboardFlotTwo() {

    var data1 = [
        [gd(2012, 1, 1), 7],
        [gd(2012, 1, 2), 6],
        [gd(2012, 1, 3), 4],
        [gd(2012, 1, 4), 8],
        [gd(2012, 1, 5), 9],
        [gd(2012, 1, 6), 7],
        [gd(2012, 1, 7), 5],
        [gd(2012, 1, 8), 4],
        [gd(2012, 1, 9), 7],
        [gd(2012, 1, 10), 8],
        [gd(2012, 1, 11), 9],
        [gd(2012, 1, 12), 6],
        [gd(2012, 1, 13), 4],
        [gd(2012, 1, 14), 5],
        [gd(2012, 1, 15), 11],
        [gd(2012, 1, 16), 8],
        [gd(2012, 1, 17), 8],
        [gd(2012, 1, 18), 11],
        [gd(2012, 1, 19), 11],
        [gd(2012, 1, 20), 6],
        [gd(2012, 1, 21), 6],
        [gd(2012, 1, 22), 8],
        [gd(2012, 1, 23), 11],
        [gd(2012, 1, 24), 13],
        [gd(2012, 1, 25), 7],
        [gd(2012, 1, 26), 9],
        [gd(2012, 1, 27), 9],
        [gd(2012, 1, 28), 8],
        [gd(2012, 1, 29), 5],
        [gd(2012, 1, 30), 8],
        [gd(2012, 1, 31), 25]
    ];

    var data2 = [
        [gd(2012, 1, 1), 800],
        [gd(2012, 1, 2), 500],
        [gd(2012, 1, 3), 600],
        [gd(2012, 1, 4), 700],
        [gd(2012, 1, 5), 500],
        [gd(2012, 1, 6), 456],
        [gd(2012, 1, 7), 800],
        [gd(2012, 1, 8), 589],
        [gd(2012, 1, 9), 467],
        [gd(2012, 1, 10), 876],
        [gd(2012, 1, 11), 689],
        [gd(2012, 1, 12), 700],
        [gd(2012, 1, 13), 500],
        [gd(2012, 1, 14), 600],
        [gd(2012, 1, 15), 700],
        [gd(2012, 1, 16), 786],
        [gd(2012, 1, 17), 345],
        [gd(2012, 1, 18), 888],
        [gd(2012, 1, 19), 888],
        [gd(2012, 1, 20), 888],
        [gd(2012, 1, 21), 987],
        [gd(2012, 1, 22), 444],
        [gd(2012, 1, 23), 999],
        [gd(2012, 1, 24), 567],
        [gd(2012, 1, 25), 786],
        [gd(2012, 1, 26), 666],
        [gd(2012, 1, 27), 888],
        [gd(2012, 1, 28), 900],
        [gd(2012, 1, 29), 178],
        [gd(2012, 1, 30), 555],
        [gd(2012, 1, 31), 993]
    ];


    var dataset = [
        {
            label: "Number of orders",
            grow: {
                stepMode: "linear"
            },
            data: data2,
            color: "#1ab394",
            bars: {
                show: true,
                align: "center",
                barWidth: 24 * 60 * 60 * 600,
                lineWidth: 0
            }

        },
        {
            label: "Payments",
            grow: {
                stepMode: "linear"
            },
            data: data1,
            yaxis: 2,
            color: "#1C84C6",
            lines: {
                lineWidth: 1,
                show: true,
                fill: true,
                fillColor: {
                    colors: [
                        {
                            opacity: 0.2
                        },
                        {
                            opacity: 0.2
                        }
                    ]
                }
            }
        }
    ];


    var options = {
        grid: {
            hoverable: true,
            clickable: true,
            tickColor: "#d5d5d5",
            borderWidth: 0,
            color: '#d5d5d5'
        },
        colors: ["#1ab394", "#464f88"],
        tooltip: true,
        xaxis: {
            mode: "time",
            tickSize: [3, "day"],
            tickLength: 0,
            axisLabel: "Date",
            axisLabelUseCanvas: true,
            axisLabelFontSizePixels: 12,
            axisLabelFontFamily: 'Arial',
            axisLabelPadding: 10,
            color: "#d5d5d5"
        },
        yaxes: [
            {
                position: "left",
                max: 1070,
                color: "#d5d5d5",
                axisLabelUseCanvas: true,
                axisLabelFontSizePixels: 12,
                axisLabelFontFamily: 'Arial',
                axisLabelPadding: 3
            },
            {
                position: "right",
                color: "#d5d5d5",
                axisLabelUseCanvas: true,
                axisLabelFontSizePixels: 12,
                axisLabelFontFamily: ' Arial',
                axisLabelPadding: 67
            }
        ],
        legend: {
            noColumns: 1,
            labelBoxBorderColor: "#d5d5d5",
            position: "nw"
        }

    };

    function gd(year, month, day) {
        return new Date(year, month - 1, day).getTime();
    }

    /**
     * Definition of variables
     * Flot chart
     */
    this.flotData = dataset;
    this.flotOptions = options;
}

/**
 * dashboardFlotFive - simple controller for data
 * for Flot chart in Dashboard view
 */
function dashboardFive() {

    var data1 = [
        [0, 4], [1, 8], [2, 5], [3, 10], [4, 4], [5, 16], [6, 5], [7, 11], [8, 6], [9, 11], [10, 20], [11, 10], [12, 13], [13, 4], [14, 7], [15, 8], [16, 12]
    ];
    var data2 = [
        [0, 0], [1, 2], [2, 7], [3, 4], [4, 11], [5, 4], [6, 2], [7, 5], [8, 11], [9, 5], [10, 4], [11, 1], [12, 5], [13, 2], [14, 5], [15, 2], [16, 0]
    ];

    var options = {
        series: {
            lines: {
                show: false,
                fill: true
            },
            splines: {
                show: true,
                tension: 0.4,
                lineWidth: 1,
                fill: 0.4
            },
            points: {
                radius: 0,
                show: true
            },
            shadowSize: 2
        },
        grid: {
            hoverable: true,
            clickable: true,

            borderWidth: 2,
            color: 'transparent'
        },
        colors: ["#1ab394", "#1C84C6"],
        xaxis: {},
        yaxis: {},
        tooltip: false
    };

    /**
     * Definition of variables
     * Flot chart
     */
    this.flotData = [data1, data2];
    this.flotOptions = options;


    var sparkline1Data = [34, 43, 43, 35, 44, 32, 44, 52];
    var sparkline1Options = {
        type: 'line',
        width: '100%',
        height: '50',
        lineColor: '#1ab394',
        fillColor: "transparent"
    };

    var sparkline2Data = [32, 11, 25, 37, 41, 32, 34, 42];
    var sparkline2Options = {
        type: 'line',
        width: '100%',
        height: '50',
        lineColor: '#1ab394',
        fillColor: "transparent"
    };

    this.sparkline1 = sparkline1Data;
    this.sparkline1Options = sparkline1Options;
    this.sparkline2 = sparkline2Data;
    this.sparkline2Options = sparkline2Options;

}


/**
 * dashboardMap - data for Map plugin
 * used in Dashboard 2 view
 */

function dashboardMap() {
    var data = {
        "US": 298,
        "SA": 200,
        "DE": 220,
        "FR": 540,
        "CN": 120,
        "AU": 760,
        "BR": 550,
        "IN": 200,
        "GB": 120
    };

    this.data = data;
}

/**
 * flotChartCtrl - Controller for data for All flot chart
 * used in Flot chart view
 */

function flotChartCtrl() {

    /**
     * Bar Chart Options
     */
    var barOptions = {
        series: {
            bars: {
                show: true,
                barWidth: 0.6,
                fill: true,
                fillColor: {
                    colors: [
                        {
                            opacity: 0.8
                        },
                        {
                            opacity: 0.8
                        }
                    ]
                }
            }
        },
        xaxis: {
            tickDecimals: 0
        },
        colors: ["#1ab394"],
        grid: {
            color: "#999999",
            hoverable: true,
            clickable: true,
            tickColor: "#D4D4D4",
            borderWidth: 0
        },
        legend: {
            show: false
        },
        tooltip: true,
        tooltipOpts: {
            content: "x: %x, y: %y"
        }
    };

    /**
     * Bar Chart data
     */
    var chartData = [
        {
            label: "bar",
            data: [
                [1, 34],
                [2, 25],
                [3, 19],
                [4, 34],
                [5, 32],
                [6, 44]
            ]
        }
    ];

    /**
     * Pie Chart Data
     */
    var pieData = [
        {
            label: "Sales 1",
            data: 21,
            color: "#d3d3d3"
        },
        {
            label: "Sales 2",
            data: 3,
            color: "#bababa"
        },
        {
            label: "Sales 3",
            data: 15,
            color: "#79d2c0"
        },
        {
            label: "Sales 4",
            data: 52,
            color: "#1ab394"
        }
    ];

    /**
     * Pie Chart Options
     */
    var pieOptions = {
        series: {
            pie: {
                show: true
            }
        },
        grid: {
            hoverable: true
        },
        tooltip: true,
        tooltipOpts: {
            content: "%p.0%, %s", // show percentages, rounding to 2 decimal places
            shifts: {
                x: 20,
                y: 0
            },
            defaultTheme: false
        }
    };

    /**
     * Line Chart Options
     */
    var lineOptions = {
        series: {
            lines: {
                show: true,
                lineWidth: 2,
                fill: true,
                fillColor: {
                    colors: [
                        {
                            opacity: 0.0
                        },
                        {
                            opacity: 0.0
                        }
                    ]
                }
            }
        },
        xaxis: {
            tickDecimals: 0
        },
        colors: ["#1ab394"],
        grid: {
            color: "#999999",
            hoverable: true,
            clickable: true,
            tickColor: "#D4D4D4",
            borderWidth: 0
        },
        legend: {
            show: false
        },
        tooltip: true,
        tooltipOpts: {
            content: "x: %x, y: %y"
        }
    };

    /**
     * Line Chart Data
     */
    var lineAreaData = [
        {
            label: "line",
            data: [
                [1, 34],
                [2, 22],
                [3, 19],
                [4, 12],
                [5, 32],
                [6, 54],
                [7, 23],
                [8, 57],
                [9, 12],
                [10, 24],
                [11, 44],
                [12, 64],
                [13, 21]
            ]
        }
    ];

    /**
     * Line Area Chart Options
     */
    var lineAreaOptions = {
        series: {
            lines: {
                show: true,
                lineWidth: 2,
                fill: true,
                fillColor: {
                    colors: [
                        {
                            opacity: 0.7
                        },
                        {
                            opacity: 0.5
                        }
                    ]
                }
            }
        },
        xaxis: {
            tickDecimals: 0
        },
        colors: ["#1ab394"],
        grid: {
            color: "#999999",
            hoverable: true,
            clickable: true,
            tickColor: "#D4D4D4",
            borderWidth: 0
        },
        legend: {
            show: false
        },
        tooltip: true,
        tooltipOpts: {
            content: "x: %x, y: %y"
        }
    };

    /**
     * Data for Multi line chart
     */
    var oilprices = [[1167692400000, 61.05], [1167778800000, 58.32], [1167865200000, 57.35], [1167951600000, 56.31], [1168210800000, 55.55], [1168297200000, 55.64], [1168383600000, 54.02], [1168470000000, 51.88], [1168556400000, 52.99], [1168815600000, 52.99], [1168902000000, 51.21], [1168988400000, 52.24], [1169074800000, 50.48], [1169161200000, 51.99], [1169420400000, 51.13], [1169506800000, 55.04], [1169593200000, 55.37], [1169679600000, 54.23], [1169766000000, 55.42], [1170025200000, 54.01], [1170111600000, 56.97], [1170198000000, 58.14], [1170284400000, 58.14], [1170370800000, 59.02], [1170630000000, 58.74], [1170716400000, 58.88], [1170802800000, 57.71], [1170889200000, 59.71], [1170975600000, 59.89], [1171234800000, 57.81], [1171321200000, 59.06], [1171407600000, 58.00], [1171494000000, 57.99], [1171580400000, 59.39], [1171839600000, 59.39], [1171926000000, 58.07], [1172012400000, 60.07], [1172098800000, 61.14], [1172444400000, 61.39], [1172530800000, 61.46], [1172617200000, 61.79], [1172703600000, 62.00], [1172790000000, 60.07], [1173135600000, 60.69], [1173222000000, 61.82], [1173308400000, 60.05], [1173654000000, 58.91], [1173740400000, 57.93], [1173826800000, 58.16], [1173913200000, 57.55], [1173999600000, 57.11], [1174258800000, 56.59], [1174345200000, 59.61], [1174518000000, 61.69], [1174604400000, 62.28], [1174860000000, 62.91], [1174946400000, 62.93], [1175032800000, 64.03], [1175119200000, 66.03], [1175205600000, 65.87], [1175464800000, 64.64], [1175637600000, 64.38], [1175724000000, 64.28], [1175810400000, 64.28], [1176069600000, 61.51], [1176156000000, 61.89], [1176242400000, 62.01], [1176328800000, 63.85], [1176415200000, 63.63], [1176674400000, 63.61], [1176760800000, 63.10], [1176847200000, 63.13], [1176933600000, 61.83], [1177020000000, 63.38], [1177279200000, 64.58], [1177452000000, 65.84], [1177538400000, 65.06], [1177624800000, 66.46], [1177884000000, 64.40], [1178056800000, 63.68], [1178143200000, 63.19], [1178229600000, 61.93], [1178488800000, 61.47], [1178575200000, 61.55], [1178748000000, 61.81], [1178834400000, 62.37], [1179093600000, 62.46], [1179180000000, 63.17], [1179266400000, 62.55], [1179352800000, 64.94], [1179698400000, 66.27], [1179784800000, 65.50], [1179871200000, 65.77], [1179957600000, 64.18], [1180044000000, 65.20], [1180389600000, 63.15], [1180476000000, 63.49], [1180562400000, 65.08], [1180908000000, 66.30], [1180994400000, 65.96], [1181167200000, 66.93], [1181253600000, 65.98], [1181599200000, 65.35], [1181685600000, 66.26], [1181858400000, 68.00], [1182117600000, 69.09], [1182204000000, 69.10], [1182290400000, 68.19], [1182376800000, 68.19], [1182463200000, 69.14], [1182722400000, 68.19], [1182808800000, 67.77], [1182895200000, 68.97], [1182981600000, 69.57], [1183068000000, 70.68], [1183327200000, 71.09], [1183413600000, 70.92], [1183586400000, 71.81], [1183672800000, 72.81], [1183932000000, 72.19], [1184018400000, 72.56], [1184191200000, 72.50], [1184277600000, 74.15], [1184623200000, 75.05], [1184796000000, 75.92], [1184882400000, 75.57], [1185141600000, 74.89], [1185228000000, 73.56], [1185314400000, 75.57], [1185400800000, 74.95], [1185487200000, 76.83], [1185832800000, 78.21], [1185919200000, 76.53], [1186005600000, 76.86], [1186092000000, 76.00], [1186437600000, 71.59], [1186696800000, 71.47], [1186956000000, 71.62], [1187042400000, 71.00], [1187301600000, 71.98], [1187560800000, 71.12], [1187647200000, 69.47], [1187733600000, 69.26], [1187820000000, 69.83], [1187906400000, 71.09], [1188165600000, 71.73], [1188338400000, 73.36], [1188511200000, 74.04], [1188856800000, 76.30], [1189116000000, 77.49], [1189461600000, 78.23], [1189548000000, 79.91], [1189634400000, 80.09], [1189720800000, 79.10], [1189980000000, 80.57], [1190066400000, 81.93], [1190239200000, 83.32], [1190325600000, 81.62], [1190584800000, 80.95], [1190671200000, 79.53], [1190757600000, 80.30], [1190844000000, 82.88], [1190930400000, 81.66], [1191189600000, 80.24], [1191276000000, 80.05], [1191362400000, 79.94], [1191448800000, 81.44], [1191535200000, 81.22], [1191794400000, 79.02], [1191880800000, 80.26], [1191967200000, 80.30], [1192053600000, 83.08], [1192140000000, 83.69], [1192399200000, 86.13], [1192485600000, 87.61], [1192572000000, 87.40], [1192658400000, 89.47], [1192744800000, 88.60], [1193004000000, 87.56], [1193090400000, 87.56], [1193176800000, 87.10], [1193263200000, 91.86], [1193612400000, 93.53], [1193698800000, 94.53], [1193871600000, 95.93], [1194217200000, 93.98], [1194303600000, 96.37], [1194476400000, 95.46], [1194562800000, 96.32], [1195081200000, 93.43], [1195167600000, 95.10], [1195426800000, 94.64], [1195513200000, 95.10], [1196031600000, 97.70], [1196118000000, 94.42], [1196204400000, 90.62], [1196290800000, 91.01], [1196377200000, 88.71], [1196636400000, 88.32], [1196809200000, 90.23], [1196982000000, 88.28], [1197241200000, 87.86], [1197327600000, 90.02], [1197414000000, 92.25], [1197586800000, 90.63], [1197846000000, 90.63], [1197932400000, 90.49], [1198018800000, 91.24], [1198105200000, 91.06], [1198191600000, 90.49], [1198710000000, 96.62], [1198796400000, 96.00], [1199142000000, 99.62], [1199314800000, 99.18], [1199401200000, 95.09], [1199660400000, 96.33], [1199833200000, 95.67], [1200351600000, 91.90], [1200438000000, 90.84], [1200524400000, 90.13], [1200610800000, 90.57], [1200956400000, 89.21], [1201042800000, 86.99], [1201129200000, 89.85], [1201474800000, 90.99], [1201561200000, 91.64], [1201647600000, 92.33], [1201734000000, 91.75], [1202079600000, 90.02], [1202166000000, 88.41], [1202252400000, 87.14], [1202338800000, 88.11], [1202425200000, 91.77], [1202770800000, 92.78], [1202857200000, 93.27], [1202943600000, 95.46], [1203030000000, 95.46], [1203289200000, 101.74], [1203462000000, 98.81], [1203894000000, 100.88], [1204066800000, 99.64], [1204153200000, 102.59], [1204239600000, 101.84], [1204498800000, 99.52], [1204585200000, 99.52], [1204671600000, 104.52], [1204758000000, 105.47], [1204844400000, 105.15], [1205103600000, 108.75], [1205276400000, 109.92], [1205362800000, 110.33], [1205449200000, 110.21], [1205708400000, 105.68], [1205967600000, 101.84], [1206313200000, 100.86], [1206399600000, 101.22], [1206486000000, 105.90], [1206572400000, 107.58], [1206658800000, 105.62], [1206914400000, 101.58], [1207000800000, 100.98], [1207173600000, 103.83], [1207260000000, 106.23], [1207605600000, 108.50], [1207778400000, 110.11], [1207864800000, 110.14], [1208210400000, 113.79], [1208296800000, 114.93], [1208383200000, 114.86], [1208728800000, 117.48], [1208815200000, 118.30], [1208988000000, 116.06], [1209074400000, 118.52], [1209333600000, 118.75], [1209420000000, 113.46], [1209592800000, 112.52], [1210024800000, 121.84], [1210111200000, 123.53], [1210197600000, 123.69], [1210543200000, 124.23], [1210629600000, 125.80], [1210716000000, 126.29], [1211148000000, 127.05], [1211320800000, 129.07], [1211493600000, 132.19], [1211839200000, 128.85], [1212357600000, 127.76], [1212703200000, 138.54], [1212962400000, 136.80], [1213135200000, 136.38], [1213308000000, 134.86], [1213653600000, 134.01], [1213740000000, 136.68], [1213912800000, 135.65], [1214172000000, 134.62], [1214258400000, 134.62], [1214344800000, 134.62], [1214431200000, 139.64], [1214517600000, 140.21], [1214776800000, 140.00], [1214863200000, 140.97], [1214949600000, 143.57], [1215036000000, 145.29], [1215381600000, 141.37], [1215468000000, 136.04], [1215727200000, 146.40], [1215986400000, 145.18], [1216072800000, 138.74], [1216159200000, 134.60], [1216245600000, 129.29], [1216332000000, 130.65], [1216677600000, 127.95], [1216850400000, 127.95], [1217282400000, 122.19], [1217455200000, 124.08], [1217541600000, 125.10], [1217800800000, 121.41], [1217887200000, 119.17], [1217973600000, 118.58], [1218060000000, 120.02], [1218405600000, 114.45], [1218492000000, 113.01], [1218578400000, 116.00], [1218751200000, 113.77], [1219010400000, 112.87], [1219096800000, 114.53], [1219269600000, 114.98], [1219356000000, 114.98], [1219701600000, 116.27], [1219788000000, 118.15], [1219874400000, 115.59], [1219960800000, 115.46], [1220306400000, 109.71], [1220392800000, 109.35], [1220565600000, 106.23], [1220824800000, 106.34]];
    var exchangerates = [[1167606000000, 0.7580], [1167692400000, 0.7580], [1167778800000, 0.75470], [1167865200000, 0.75490], [1167951600000, 0.76130], [1168038000000, 0.76550], [1168124400000, 0.76930], [1168210800000, 0.76940], [1168297200000, 0.76880], [1168383600000, 0.76780], [1168470000000, 0.77080], [1168556400000, 0.77270], [1168642800000, 0.77490], [1168729200000, 0.77410], [1168815600000, 0.77410], [1168902000000, 0.77320], [1168988400000, 0.77270], [1169074800000, 0.77370], [1169161200000, 0.77240], [1169247600000, 0.77120], [1169334000000, 0.7720], [1169420400000, 0.77210], [1169506800000, 0.77170], [1169593200000, 0.77040], [1169679600000, 0.7690], [1169766000000, 0.77110], [1169852400000, 0.7740], [1169938800000, 0.77450], [1170025200000, 0.77450], [1170111600000, 0.7740], [1170198000000, 0.77160], [1170284400000, 0.77130], [1170370800000, 0.76780], [1170457200000, 0.76880], [1170543600000, 0.77180], [1170630000000, 0.77180], [1170716400000, 0.77280], [1170802800000, 0.77290], [1170889200000, 0.76980], [1170975600000, 0.76850], [1171062000000, 0.76810], [1171148400000, 0.7690], [1171234800000, 0.7690], [1171321200000, 0.76980], [1171407600000, 0.76990], [1171494000000, 0.76510], [1171580400000, 0.76130], [1171666800000, 0.76160], [1171753200000, 0.76140], [1171839600000, 0.76140], [1171926000000, 0.76070], [1172012400000, 0.76020], [1172098800000, 0.76110], [1172185200000, 0.76220], [1172271600000, 0.76150], [1172358000000, 0.75980], [1172444400000, 0.75980], [1172530800000, 0.75920], [1172617200000, 0.75730], [1172703600000, 0.75660], [1172790000000, 0.75670], [1172876400000, 0.75910], [1172962800000, 0.75820], [1173049200000, 0.75850], [1173135600000, 0.76130], [1173222000000, 0.76310], [1173308400000, 0.76150], [1173394800000, 0.760], [1173481200000, 0.76130], [1173567600000, 0.76270], [1173654000000, 0.76270], [1173740400000, 0.76080], [1173826800000, 0.75830], [1173913200000, 0.75750], [1173999600000, 0.75620], [1174086000000, 0.7520], [1174172400000, 0.75120], [1174258800000, 0.75120], [1174345200000, 0.75170], [1174431600000, 0.7520], [1174518000000, 0.75110], [1174604400000, 0.7480], [1174690800000, 0.75090], [1174777200000, 0.75310], [1174860000000, 0.75310], [1174946400000, 0.75270], [1175032800000, 0.74980], [1175119200000, 0.74930], [1175205600000, 0.75040], [1175292000000, 0.750], [1175378400000, 0.74910], [1175464800000, 0.74910], [1175551200000, 0.74850], [1175637600000, 0.74840], [1175724000000, 0.74920], [1175810400000, 0.74710], [1175896800000, 0.74590], [1175983200000, 0.74770], [1176069600000, 0.74770], [1176156000000, 0.74830], [1176242400000, 0.74580], [1176328800000, 0.74480], [1176415200000, 0.7430], [1176501600000, 0.73990], [1176588000000, 0.73950], [1176674400000, 0.73950], [1176760800000, 0.73780], [1176847200000, 0.73820], [1176933600000, 0.73620], [1177020000000, 0.73550], [1177106400000, 0.73480], [1177192800000, 0.73610], [1177279200000, 0.73610], [1177365600000, 0.73650], [1177452000000, 0.73620], [1177538400000, 0.73310], [1177624800000, 0.73390], [1177711200000, 0.73440], [1177797600000, 0.73270], [1177884000000, 0.73270], [1177970400000, 0.73360], [1178056800000, 0.73330], [1178143200000, 0.73590], [1178229600000, 0.73590], [1178316000000, 0.73720], [1178402400000, 0.7360], [1178488800000, 0.7360], [1178575200000, 0.7350], [1178661600000, 0.73650], [1178748000000, 0.73840], [1178834400000, 0.73950], [1178920800000, 0.74130], [1179007200000, 0.73970], [1179093600000, 0.73960], [1179180000000, 0.73850], [1179266400000, 0.73780], [1179352800000, 0.73660], [1179439200000, 0.740], [1179525600000, 0.74110], [1179612000000, 0.74060], [1179698400000, 0.74050], [1179784800000, 0.74140], [1179871200000, 0.74310], [1179957600000, 0.74310], [1180044000000, 0.74380], [1180130400000, 0.74430], [1180216800000, 0.74430], [1180303200000, 0.74430], [1180389600000, 0.74340], [1180476000000, 0.74290], [1180562400000, 0.74420], [1180648800000, 0.7440], [1180735200000, 0.74390], [1180821600000, 0.74370], [1180908000000, 0.74370], [1180994400000, 0.74290], [1181080800000, 0.74030], [1181167200000, 0.73990], [1181253600000, 0.74180], [1181340000000, 0.74680], [1181426400000, 0.7480], [1181512800000, 0.7480], [1181599200000, 0.7490], [1181685600000, 0.74940], [1181772000000, 0.75220], [1181858400000, 0.75150], [1181944800000, 0.75020], [1182031200000, 0.74720], [1182117600000, 0.74720], [1182204000000, 0.74620], [1182290400000, 0.74550], [1182376800000, 0.74490], [1182463200000, 0.74670], [1182549600000, 0.74580], [1182636000000, 0.74270], [1182722400000, 0.74270], [1182808800000, 0.7430], [1182895200000, 0.74290], [1182981600000, 0.7440], [1183068000000, 0.7430], [1183154400000, 0.74220], [1183240800000, 0.73880], [1183327200000, 0.73880], [1183413600000, 0.73690], [1183500000000, 0.73450], [1183586400000, 0.73450], [1183672800000, 0.73450], [1183759200000, 0.73520], [1183845600000, 0.73410], [1183932000000, 0.73410], [1184018400000, 0.7340], [1184104800000, 0.73240], [1184191200000, 0.72720], [1184277600000, 0.72640], [1184364000000, 0.72550], [1184450400000, 0.72580], [1184536800000, 0.72580], [1184623200000, 0.72560], [1184709600000, 0.72570], [1184796000000, 0.72470], [1184882400000, 0.72430], [1184968800000, 0.72440], [1185055200000, 0.72350], [1185141600000, 0.72350], [1185228000000, 0.72350], [1185314400000, 0.72350], [1185400800000, 0.72620], [1185487200000, 0.72880], [1185573600000, 0.73010], [1185660000000, 0.73370], [1185746400000, 0.73370], [1185832800000, 0.73240], [1185919200000, 0.72970], [1186005600000, 0.73170], [1186092000000, 0.73150], [1186178400000, 0.72880], [1186264800000, 0.72630], [1186351200000, 0.72630], [1186437600000, 0.72420], [1186524000000, 0.72530], [1186610400000, 0.72640], [1186696800000, 0.7270], [1186783200000, 0.73120], [1186869600000, 0.73050], [1186956000000, 0.73050], [1187042400000, 0.73180], [1187128800000, 0.73580], [1187215200000, 0.74090], [1187301600000, 0.74540], [1187388000000, 0.74370], [1187474400000, 0.74240], [1187560800000, 0.74240], [1187647200000, 0.74150], [1187733600000, 0.74190], [1187820000000, 0.74140], [1187906400000, 0.73770], [1187992800000, 0.73550], [1188079200000, 0.73150], [1188165600000, 0.73150], [1188252000000, 0.7320], [1188338400000, 0.73320], [1188424800000, 0.73460], [1188511200000, 0.73280], [1188597600000, 0.73230], [1188684000000, 0.7340], [1188770400000, 0.7340], [1188856800000, 0.73360], [1188943200000, 0.73510], [1189029600000, 0.73460], [1189116000000, 0.73210], [1189202400000, 0.72940], [1189288800000, 0.72660], [1189375200000, 0.72660], [1189461600000, 0.72540], [1189548000000, 0.72420], [1189634400000, 0.72130], [1189720800000, 0.71970], [1189807200000, 0.72090], [1189893600000, 0.7210], [1189980000000, 0.7210], [1190066400000, 0.7210], [1190152800000, 0.72090], [1190239200000, 0.71590], [1190325600000, 0.71330], [1190412000000, 0.71050], [1190498400000, 0.70990], [1190584800000, 0.70990], [1190671200000, 0.70930], [1190757600000, 0.70930], [1190844000000, 0.70760], [1190930400000, 0.7070], [1191016800000, 0.70490], [1191103200000, 0.70120], [1191189600000, 0.70110], [1191276000000, 0.70190], [1191362400000, 0.70460], [1191448800000, 0.70630], [1191535200000, 0.70890], [1191621600000, 0.70770], [1191708000000, 0.70770], [1191794400000, 0.70770], [1191880800000, 0.70910], [1191967200000, 0.71180], [1192053600000, 0.70790], [1192140000000, 0.70530], [1192226400000, 0.7050], [1192312800000, 0.70550], [1192399200000, 0.70550], [1192485600000, 0.70450], [1192572000000, 0.70510], [1192658400000, 0.70510], [1192744800000, 0.70170], [1192831200000, 0.70], [1192917600000, 0.69950], [1193004000000, 0.69940], [1193090400000, 0.70140], [1193176800000, 0.70360], [1193263200000, 0.70210], [1193349600000, 0.70020], [1193436000000, 0.69670], [1193522400000, 0.6950], [1193612400000, 0.6950], [1193698800000, 0.69390], [1193785200000, 0.6940], [1193871600000, 0.69220], [1193958000000, 0.69190], [1194044400000, 0.69140], [1194130800000, 0.68940], [1194217200000, 0.68910], [1194303600000, 0.69040], [1194390000000, 0.6890], [1194476400000, 0.68340], [1194562800000, 0.68230], [1194649200000, 0.68070], [1194735600000, 0.68150], [1194822000000, 0.68150], [1194908400000, 0.68470], [1194994800000, 0.68590], [1195081200000, 0.68220], [1195167600000, 0.68270], [1195254000000, 0.68370], [1195340400000, 0.68230], [1195426800000, 0.68220], [1195513200000, 0.68220], [1195599600000, 0.67920], [1195686000000, 0.67460], [1195772400000, 0.67350], [1195858800000, 0.67310], [1195945200000, 0.67420], [1196031600000, 0.67440], [1196118000000, 0.67390], [1196204400000, 0.67310], [1196290800000, 0.67610], [1196377200000, 0.67610], [1196463600000, 0.67850], [1196550000000, 0.68180], [1196636400000, 0.68360], [1196722800000, 0.68230], [1196809200000, 0.68050], [1196895600000, 0.67930], [1196982000000, 0.68490], [1197068400000, 0.68330], [1197154800000, 0.68250], [1197241200000, 0.68250], [1197327600000, 0.68160], [1197414000000, 0.67990], [1197500400000, 0.68130], [1197586800000, 0.68090], [1197673200000, 0.68680], [1197759600000, 0.69330], [1197846000000, 0.69330], [1197932400000, 0.69450], [1198018800000, 0.69440], [1198105200000, 0.69460], [1198191600000, 0.69640], [1198278000000, 0.69650], [1198364400000, 0.69560], [1198450800000, 0.69560], [1198537200000, 0.6950], [1198623600000, 0.69480], [1198710000000, 0.69280], [1198796400000, 0.68870], [1198882800000, 0.68240], [1198969200000, 0.67940], [1199055600000, 0.67940], [1199142000000, 0.68030], [1199228400000, 0.68550], [1199314800000, 0.68240], [1199401200000, 0.67910], [1199487600000, 0.67830], [1199574000000, 0.67850], [1199660400000, 0.67850], [1199746800000, 0.67970], [1199833200000, 0.680], [1199919600000, 0.68030], [1200006000000, 0.68050], [1200092400000, 0.6760], [1200178800000, 0.6770], [1200265200000, 0.6770], [1200351600000, 0.67360], [1200438000000, 0.67260], [1200524400000, 0.67640], [1200610800000, 0.68210], [1200697200000, 0.68310], [1200783600000, 0.68420], [1200870000000, 0.68420], [1200956400000, 0.68870], [1201042800000, 0.69030], [1201129200000, 0.68480], [1201215600000, 0.68240], [1201302000000, 0.67880], [1201388400000, 0.68140], [1201474800000, 0.68140], [1201561200000, 0.67970], [1201647600000, 0.67690], [1201734000000, 0.67650], [1201820400000, 0.67330], [1201906800000, 0.67290], [1201993200000, 0.67580], [1202079600000, 0.67580], [1202166000000, 0.6750], [1202252400000, 0.6780], [1202338800000, 0.68330], [1202425200000, 0.68560], [1202511600000, 0.69030], [1202598000000, 0.68960], [1202684400000, 0.68960], [1202770800000, 0.68820], [1202857200000, 0.68790], [1202943600000, 0.68620], [1203030000000, 0.68520], [1203116400000, 0.68230], [1203202800000, 0.68130], [1203289200000, 0.68130], [1203375600000, 0.68220], [1203462000000, 0.68020], [1203548400000, 0.68020], [1203634800000, 0.67840], [1203721200000, 0.67480], [1203807600000, 0.67470], [1203894000000, 0.67470], [1203980400000, 0.67480], [1204066800000, 0.67330], [1204153200000, 0.6650], [1204239600000, 0.66110], [1204326000000, 0.65830], [1204412400000, 0.6590], [1204498800000, 0.6590], [1204585200000, 0.65810], [1204671600000, 0.65780], [1204758000000, 0.65740], [1204844400000, 0.65320], [1204930800000, 0.65020], [1205017200000, 0.65140], [1205103600000, 0.65140], [1205190000000, 0.65070], [1205276400000, 0.6510], [1205362800000, 0.64890], [1205449200000, 0.64240], [1205535600000, 0.64060], [1205622000000, 0.63820], [1205708400000, 0.63820], [1205794800000, 0.63410], [1205881200000, 0.63440], [1205967600000, 0.63780], [1206054000000, 0.64390], [1206140400000, 0.64780], [1206226800000, 0.64810], [1206313200000, 0.64810], [1206399600000, 0.64940], [1206486000000, 0.64380], [1206572400000, 0.63770], [1206658800000, 0.63290], [1206745200000, 0.63360], [1206831600000, 0.63330], [1206914400000, 0.63330], [1207000800000, 0.6330], [1207087200000, 0.63710], [1207173600000, 0.64030], [1207260000000, 0.63960], [1207346400000, 0.63640], [1207432800000, 0.63560], [1207519200000, 0.63560], [1207605600000, 0.63680], [1207692000000, 0.63570], [1207778400000, 0.63540], [1207864800000, 0.6320], [1207951200000, 0.63320], [1208037600000, 0.63280], [1208124000000, 0.63310], [1208210400000, 0.63420], [1208296800000, 0.63210], [1208383200000, 0.63020], [1208469600000, 0.62780], [1208556000000, 0.63080], [1208642400000, 0.63240], [1208728800000, 0.63240], [1208815200000, 0.63070], [1208901600000, 0.62770], [1208988000000, 0.62690], [1209074400000, 0.63350], [1209160800000, 0.63920], [1209247200000, 0.640], [1209333600000, 0.64010], [1209420000000, 0.63960], [1209506400000, 0.64070], [1209592800000, 0.64230], [1209679200000, 0.64290], [1209765600000, 0.64720], [1209852000000, 0.64850], [1209938400000, 0.64860], [1210024800000, 0.64670], [1210111200000, 0.64440], [1210197600000, 0.64670], [1210284000000, 0.65090], [1210370400000, 0.64780], [1210456800000, 0.64610], [1210543200000, 0.64610], [1210629600000, 0.64680], [1210716000000, 0.64490], [1210802400000, 0.6470], [1210888800000, 0.64610], [1210975200000, 0.64520], [1211061600000, 0.64220], [1211148000000, 0.64220], [1211234400000, 0.64250], [1211320800000, 0.64140], [1211407200000, 0.63660], [1211493600000, 0.63460], [1211580000000, 0.6350], [1211666400000, 0.63460], [1211752800000, 0.63460], [1211839200000, 0.63430], [1211925600000, 0.63460], [1212012000000, 0.63790], [1212098400000, 0.64160], [1212184800000, 0.64420], [1212271200000, 0.64310], [1212357600000, 0.64310], [1212444000000, 0.64350], [1212530400000, 0.6440], [1212616800000, 0.64730], [1212703200000, 0.64690], [1212789600000, 0.63860], [1212876000000, 0.63560], [1212962400000, 0.6340], [1213048800000, 0.63460], [1213135200000, 0.6430], [1213221600000, 0.64520], [1213308000000, 0.64670], [1213394400000, 0.65060], [1213480800000, 0.65040], [1213567200000, 0.65030], [1213653600000, 0.64810], [1213740000000, 0.64510], [1213826400000, 0.6450], [1213912800000, 0.64410], [1213999200000, 0.64140], [1214085600000, 0.64090], [1214172000000, 0.64090], [1214258400000, 0.64280], [1214344800000, 0.64310], [1214431200000, 0.64180], [1214517600000, 0.63710], [1214604000000, 0.63490], [1214690400000, 0.63330], [1214776800000, 0.63340], [1214863200000, 0.63380], [1214949600000, 0.63420], [1215036000000, 0.6320], [1215122400000, 0.63180], [1215208800000, 0.6370], [1215295200000, 0.63680], [1215381600000, 0.63680], [1215468000000, 0.63830], [1215554400000, 0.63710], [1215640800000, 0.63710], [1215727200000, 0.63550], [1215813600000, 0.6320], [1215900000000, 0.62770], [1215986400000, 0.62760], [1216072800000, 0.62910], [1216159200000, 0.62740], [1216245600000, 0.62930], [1216332000000, 0.63110], [1216418400000, 0.6310], [1216504800000, 0.63120], [1216591200000, 0.63120], [1216677600000, 0.63040], [1216764000000, 0.62940], [1216850400000, 0.63480], [1216936800000, 0.63780], [1217023200000, 0.63680], [1217109600000, 0.63680], [1217196000000, 0.63680], [1217282400000, 0.6360], [1217368800000, 0.6370], [1217455200000, 0.64180], [1217541600000, 0.64110], [1217628000000, 0.64350], [1217714400000, 0.64270], [1217800800000, 0.64270], [1217887200000, 0.64190], [1217973600000, 0.64460], [1218060000000, 0.64680], [1218146400000, 0.64870], [1218232800000, 0.65940], [1218319200000, 0.66660], [1218405600000, 0.66660], [1218492000000, 0.66780], [1218578400000, 0.67120], [1218664800000, 0.67050], [1218751200000, 0.67180], [1218837600000, 0.67840], [1218924000000, 0.68110], [1219010400000, 0.68110], [1219096800000, 0.67940], [1219183200000, 0.68040], [1219269600000, 0.67810], [1219356000000, 0.67560], [1219442400000, 0.67350], [1219528800000, 0.67630], [1219615200000, 0.67620], [1219701600000, 0.67770], [1219788000000, 0.68150], [1219874400000, 0.68020], [1219960800000, 0.6780], [1220047200000, 0.67960], [1220133600000, 0.68170], [1220220000000, 0.68170], [1220306400000, 0.68320], [1220392800000, 0.68770], [1220479200000, 0.69120], [1220565600000, 0.69140], [1220652000000, 0.70090], [1220738400000, 0.70120], [1220824800000, 0.7010], [1220911200000, 0.70050]];

    function euroFormatter(v, axis) {
        return v.toFixed(axis.tickDecimals) + "€";
    }
    var position = 'right';

    /**
     * multiData - data for multi line chart
     */
    var multiData = [
        {
            data: oilprices,
            label: "Oil price ($)"
        },
        {
            data: exchangerates,
            label: "USD/EUR exchange rate",
            yaxis: 2
        }
    ];

    /**
     * multiOptions - options for multi chart
     */
    var multiOptions = {
        xaxes: [
            {
                mode: 'time'
            }
        ],
        yaxes: [
            {
                min: 0
            },
            {
                // align if we are to the right
                alignTicksWithAxis: position == "right" ? 1 : null,
                position: position,
                tickFormatter: euroFormatter
            }
        ],
        legend: {
            position: 'sw'
        },
        colors: ["#1ab394"],
        grid: {
            color: "#999999",
            hoverable: true,
            clickable: true,
            tickColor: "#D4D4D4",
            borderWidth: 0

        },
        tooltip: true,
        tooltipOpts: {
            content: "%s for %x was %y",
            xDateFormat: "%y-%0m-%0d",
            onHover: function (flotItem, $tooltipEl) {}
        }

    };

    /**
     * Definition of variables
     * Flot chart
     */
    this.flotChartData = chartData;
    this.flotBarOptions = barOptions;
    this.flotLineOptions = lineOptions;
    this.flotPieData = pieData;
    this.flotPieOptions = pieOptions;
    this.flotLineAreaData = lineAreaData;
    this.flotLineAreaOptions = lineAreaOptions;
    this.flotMultiData = multiData;
    this.flotMultiOptions = multiOptions;
}

/**
 * rickshawChartCtrl - Controller for data for all Rickshaw chart
 * used in Rickshaw chart view
 */
function rickshawChartCtrl() {

    /**
     * Data for simple chart
     */
    var simpleChartSeries = [
        {
            color: '#1ab394',
            data: [
                {
                    x: 0,
                    y: 40
                },
                {
                    x: 1,
                    y: 49
                },
                {
                    x: 2,
                    y: 38
                },
                {
                    x: 3,
                    y: 30
                },
                {
                    x: 4,
                    y: 32
                }
            ]
        }
    ];
    /**
     * Options for simple chart
     */
    var simpleChartOptions = {
        renderer: 'area'
    };

    /**
     * Data for Multi Area chart
     */
    var multiAreaChartSeries = [
        {
            data: [
                {
                    x: 0,
                    y: 40
                },
                {
                    x: 1,
                    y: 49
                },
                {
                    x: 2,
                    y: 38
                },
                {
                    x: 3,
                    y: 20
                },
                {
                    x: 4,
                    y: 16
                }
            ],
            color: '#1ab394',
            stroke: '#17997f'
        },
        {
            data: [
                {
                    x: 0,
                    y: 22
                },
                {
                    x: 1,
                    y: 25
                },
                {
                    x: 2,
                    y: 38
                },
                {
                    x: 3,
                    y: 44
                },
                {
                    x: 4,
                    y: 46
                }
            ],
            color: '#eeeeee',
            stroke: '#d7d7d7'
        }
    ];

    /**
     * Options for Multi chart
     */
    var multiAreaChartOptions = {
        renderer: 'area',
        stroke: true
    };

    /**
     * Options for one line chart
     */
    var oneLineChartOptions = {
        renderer: 'line'
    };

    /**
     * Data for one line chart
     */
    var oneLineChartSeries = [
        {
            data: [
                {
                    x: 0,
                    y: 40
                },
                {
                    x: 1,
                    y: 49
                },
                {
                    x: 2,
                    y: 38
                },
                {
                    x: 3,
                    y: 30
                },
                {
                    x: 4,
                    y: 32
                }
            ],
            color: '#1ab394'
        }
    ];

    /**
     * Options for Multi line chart
     */
    var multiLineChartOptions = {
        renderer: 'line'
    };

    /**
     * Data for Multi line chart
     */
    var multiLineChartSeries = [
        {
            data: [
                {
                    x: 0,
                    y: 40
                },
                {
                    x: 1,
                    y: 49
                },
                {
                    x: 2,
                    y: 38
                },
                {
                    x: 3,
                    y: 30
                },
                {
                    x: 4,
                    y: 32
                }
            ],
            color: '#1ab394'
        },
        {
            data: [
                {
                    x: 0,
                    y: 20
                },
                {
                    x: 1,
                    y: 24
                },
                {
                    x: 2,
                    y: 19
                },
                {
                    x: 3,
                    y: 15
                },
                {
                    x: 4,
                    y: 16
                }
            ],
            color: '#d7d7d7'
        }
    ];

    /**
     * Options for Bars chart
     */
    var barsChartOptions = {
        renderer: 'bar'
    };

    /**
     * Data for Bars chart
     */
    var barsChartSeries = [
        {
            data: [
                {
                    x: 0,
                    y: 40
                },
                {
                    x: 1,
                    y: 49
                },
                {
                    x: 2,
                    y: 38
                },
                {
                    x: 3,
                    y: 30
                },
                {
                    x: 4,
                    y: 32
                }
            ],
            color: '#1ab394'
        }
    ];

    /**
     * Options for Stacked chart
     */
    var stackedChartOptions = {
        renderer: 'bar'
    };

    /**
     * Data for Stacked chart
     */
    var stackedChartSeries = [
        {
            data: [
                {
                    x: 0,
                    y: 40
                },
                {
                    x: 1,
                    y: 49
                },
                {
                    x: 2,
                    y: 38
                },
                {
                    x: 3,
                    y: 30
                },
                {
                    x: 4,
                    y: 32
                }
            ],
            color: '#1ab394'
        },
        {
            data: [
                {
                    x: 0,
                    y: 20
                },
                {
                    x: 1,
                    y: 24
                },
                {
                    x: 2,
                    y: 19
                },
                {
                    x: 3,
                    y: 15
                },
                {
                    x: 4,
                    y: 16
                }
            ],
            color: '#d7d7d7'
        }
    ];

    /**
     * Options for Scatterplot chart
     */
    var scatterplotChartOptions = {
        renderer: 'scatterplot',
        stroke: true,
        padding: {
            top: 0.05,
            left: 0.05,
            right: 0.05
        }
    }

    /**
     * Data for Scatterplot chart
     */
    var scatterplotChartSeries = [
        {
            data: [
                {
                    x: 0,
                    y: 15
                },
                {
                    x: 1,
                    y: 18
                },
                {
                    x: 2,
                    y: 10
                },
                {
                    x: 3,
                    y: 12
                },
                {
                    x: 4,
                    y: 15
                },
                {
                    x: 5,
                    y: 24
                },
                {
                    x: 6,
                    y: 28
                },
                {
                    x: 7,
                    y: 31
                },
                {
                    x: 8,
                    y: 22
                },
                {
                    x: 9,
                    y: 18
                },
                {
                    x: 10,
                    y: 16
                }
            ],
            color: '#1ab394'
        }
    ]

    /**
     * Definition all variables
     * Rickshaw chart
     */
    this.simpleSeries = simpleChartSeries;
    this.simpleOptions = simpleChartOptions;
    this.multiAreaOptions = multiAreaChartOptions;
    this.multiAreaSeries = multiAreaChartSeries;
    this.oneLineOptions = oneLineChartOptions;
    this.oneLineSeries = oneLineChartSeries;
    this.multiLineOptions = multiLineChartOptions;
    this.multiLineSeries = multiLineChartSeries;
    this.barsOptions = barsChartOptions;
    this.barsSeries = barsChartSeries;
    this.stackedOptions = stackedChartOptions;
    this.stackedSeries = stackedChartSeries;
    this.scatterplotOptions = scatterplotChartOptions;
    this.scatterplotSeries = scatterplotChartSeries;

}

/**
 * sparklineChartCtrl - Controller for data for all Sparkline chart
 * used in Sparkline chart view
 */
function sparklineChartCtrl() {

    /**
     * Inline chart
     */
    var inlineData = [34, 43, 43, 35, 44, 32, 44, 52, 25];
    var inlineOptions = {
        type: 'line',
        lineColor: '#17997f',
        fillColor: '#1ab394'
    };

    /**
     * Bar chart
     */
    var barSmallData = [5, 6, 7, 2, 0, -4, -2, 4];
    var barSmallOptions = {
        type: 'bar',
        barColor: '#1ab394',
        negBarColor: '#c6c6c6'
    };

    /**
     * Pie chart
     */
    var smallPieData = [1, 1, 2];
    var smallPieOptions = {
        type: 'pie',
        sliceColors: ['#1ab394', '#b3b3b3', '#e4f0fb']
    };

    /**
     * Long line chart
     */
    var longLineData = [34, 43, 43, 35, 44, 32, 15, 22, 46, 33, 86, 54, 73, 53, 12, 53, 23, 65, 23, 63, 53, 42, 34, 56, 76, 15, 54, 23, 44];
    var longLineOptions = {
        type: 'line',
        lineColor: '#17997f',
        fillColor: '#ffffff'
    };

    /**
     * Tristate chart
     */
    var tristateData = [1, 1, 0, 1, -1, -1, 1, -1, 0, 0, 1, 1];
    var tristateOptions = {
        type: 'tristate',
        posBarColor: '#1ab394',
        negBarColor: '#bfbfbf'
    };

    /**
     * Discrate chart
     */
    var discreteData = [4, 6, 7, 7, 4, 3, 2, 1, 4, 4, 5, 6, 3, 4, 5, 8, 7, 6, 9, 3, 2, 4, 1, 5, 6, 4, 3, 7, ];
    var discreteOptions = {
        type: 'discrete',
        lineColor: '#1ab394'
    };

    /**
     * Pie chart
     */
    var pieCustomData = [52, 12, 44];
    var pieCustomOptions = {
        type: 'pie',
        height: '150px',
        sliceColors: ['#1ab394', '#b3b3b3', '#e4f0fb']
    };

    /**
     * Bar chart
     */
    var barCustomData = [5, 6, 7, 2, 0, 4, 2, 4, 5, 7, 2, 4, 12, 14, 4, 2, 14, 12, 7];
    var barCustomOptions = {
        type: 'bar',
        barWidth: 8,
        height: '150px',
        barColor: '#1ab394',
        negBarColor: '#c6c6c6'
    };

    /**
     * Line chart
     */
    var lineCustomData = [34, 43, 43, 35, 44, 32, 15, 22, 46, 33, 86, 54, 73, 53, 12, 53, 23, 65, 23, 63, 53, 42, 34, 56, 76, 15, 54, 23, 44];
    var lineCustomOptions = {
        type: 'line',
        lineWidth: 1,
        height: '150px',
        lineColor: '#17997f',
        fillColor: '#ffffff'
    };


    /**
     * Definition of variables
     * Flot chart
     */
    this.inlineData = inlineData;
    this.inlineOptions = inlineOptions;
    this.barSmallData = barSmallData;
    this.barSmallOptions = barSmallOptions;
    this.pieSmallData = smallPieData;
    this.pieSmallOptions = smallPieOptions;
    this.discreteData = discreteData;
    this.discreteOptions = discreteOptions;
    this.longLineData = longLineData;
    this.longLineOptions = longLineOptions;
    this.tristateData = tristateData;
    this.tristateOptions = tristateOptions;
    this.pieCustomData = pieCustomData;
    this.pieCustomOptions = pieCustomOptions;
    this.barCustomData = barCustomData;
    this.barCustomOptions = barCustomOptions;
    this.lineCustomData = lineCustomData;
    this.lineCustomOptions = lineCustomOptions;
}


/**
 * widgetFlotChart - Data for Flot chart
 * used in Widget view
 */
function widgetFlotChart() {


    /**
     * Flot chart data and options
     */
    var d1 = [[1262304000000, 6], [1264982400000, 3057], [1267401600000, 20434], [1270080000000, 31982], [1272672000000, 26602], [1275350400000, 27826], [1277942400000, 24302], [1280620800000, 24237], [1283299200000, 21004], [1285891200000, 12144], [1288569600000, 10577], [1291161600000, 10295]];
    var d2 = [[1262304000000, 5], [1264982400000, 200], [1267401600000, 1605], [1270080000000, 6129], [1272672000000, 11643], [1275350400000, 19055], [1277942400000, 30062], [1280620800000, 39197], [1283299200000, 37000], [1285891200000, 27000], [1288569600000, 21000], [1291161600000, 17000]];

    var flotChartData1 = [
        {
            label: "Data 1",
            data: d1,
            color: '#17a084'
        },
        {
            label: "Data 2",
            data: d2,
            color: '#127e68'
        }
    ];

    var flotChartOptions1 = {
        xaxis: {
            tickDecimals: 0
        },
        series: {
            lines: {
                show: true,
                fill: true,
                fillColor: {
                    colors: [{
                        opacity: 1
                    }, {
                        opacity: 1
                    }]
                }
            },
            points: {
                width: 0.1,
                show: false
            }
        },
        grid: {
            show: false,
            borderWidth: 0
        },
        legend: {
            show: false
        }
    };

    var flotChartData2 = [
        {
            label: "Data 1",
            data: d1,
            color: '#19a0a1'
        }
    ];

    var flotChartOptions2 = {
        xaxis: {
            tickDecimals: 0
        },
        series: {
            lines: {
                show: true,
                fill: true,
                fillColor: {
                    colors: [{
                        opacity: 1
                    }, {
                        opacity: 1
                    }]
                }
            },
            points: {
                width: 0.1,
                show: false
            }
        },
        grid: {
            show: false,
            borderWidth: 0
        },
        legend: {
            show: false
        }
    };

    var flotChartData3 = [
        {
            label: "Data 1",
            data: d1,
            color: '#fbbe7b'
        },
        {
            label: "Data 2",
            data: d2,
            color: '#f8ac59'
        }
    ];

    var flotChartOptions3 = {
        xaxis: {
            tickDecimals: 0
        },
        series: {
            lines: {
                show: true,
                fill: true,
                fillColor: {
                    colors: [{
                        opacity: 1
                    }, {
                        opacity: 1
                    }]
                }
            },
            points: {
                width: 0.1,
                show: false
            }
        },
        grid: {
            show: false,
            borderWidth: 0
        },
        legend: {
            show: false
        }
    };

    /**
     * Definition of variables
     * Flot chart
     */

    this.flotChartData1 = flotChartData1;
    this.flotChartOptions1 = flotChartOptions1;
    this.flotChartData2 = flotChartData2;
    this.flotChartOptions2 = flotChartOptions2;
    this.flotChartData3 = flotChartData3;
    this.flotChartOptions3 = flotChartOptions3;


}

/**
 * modalDemoCtrl - Controller used to run modal view
 * used in Basic form view
 */
function modalDemoCtrl($scope, $uibModal) {

    $scope.open = function () {

        var modalInstance = $uibModal.open({
            templateUrl: 'views/modal_example.html',
            controller: 'ModalInstanceCtrl'
        });
    };

    $scope.open1 = function () {
        var modalInstance = $uibModal.open({
            templateUrl: 'views/modal_example1.html',
            controller: 'ModalInstanceCtrl'
        });
    };

    $scope.open2 = function () {
        var modalInstance = $uibModal.open({
            templateUrl: 'views/modal_example2.html',
            controller: 'ModalInstanceCtrl',
            windowClass: "animated fadeIn"
        });
    };

    $scope.open3 = function (size) {
        var modalInstance = $uibModal.open({
            templateUrl: 'views/modal_example3.html',
            size: size,
            controller: 'ModalInstanceCtrl'
        });
    };

    $scope.open4 = function () {
        var modalInstance = $uibModal.open({
            templateUrl: 'views/modal_example2.html',
            controller: 'ModalInstanceCtrl',
            windowClass: "animated flipInY"
        });
    };
};

function ModalInstanceCtrl($scope, $uibModalInstance) {

    $scope.ok = function () {
        $uibModalInstance.close();
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };


    $scope.states = [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'Florida',
        'Georgia',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
    ];

};

/**
 * ionSlider - Controller for data for Ion Slider plugin
 * used in Advanced plugin view
 */
function ionSlider() {
    this.ionSliderOptions1 = {
        min: 0,
        max: 5000,
        type: 'double',
        prefix: "$",
        maxPostfix: "+",
        prettify: false,
        hasGrid: true
    };
    this.ionSliderOptions2 = {
        min: 0,
        max: 10,
        type: 'single',
        step: 0.1,
        postfix: " carats",
        prettify: false,
        hasGrid: true
    };
    this.ionSliderOptions3 = {
        min: -50,
        max: 50,
        from: 0,
        postfix: "°",
        prettify: false,
        hasGrid: true
    };
    this.ionSliderOptions4 = {
        values: [
            "January", "February", "March",
            "April", "May", "June",
            "July", "August", "September",
            "October", "November", "December"
        ],
        type: 'single',
        hasGrid: true
    };
    this.ionSliderOptions5 = {
        min: 10000,
        max: 100000,
        step: 100,
        postfix: " km",
        from: 55000,
        hideMinMax: true,
        hideFromTo: false
    };
}

/**
 * wizardCtrl - Controller for wizard functions
 * used in Wizard view
 */
function wizardCtrl($scope, $rootScope) {
    // All data will be store in this object
    $scope.formData = {};

    // After process wizard
    $scope.processForm = function () {
        alert('Wizard completed');
    };

}


/**
 * CalendarCtrl - Controller for Calendar
 * Store data events for calendar
 */
function CalendarCtrl($scope) {

    var date = new Date();
    var d = date.getDate();
    var m = date.getMonth();
    var y = date.getFullYear();

    // Events
    $scope.events = [
        {
            title: 'All Day Event',
            start: new Date(y, m, 1)
        },
        {
            title: 'Long Event',
            start: new Date(y, m, d - 5),
            end: new Date(y, m, d - 2)
        },
        {
            id: 999,
            title: 'Repeating Event',
            start: new Date(y, m, d - 3, 16, 0),
            allDay: false
        },
        {
            id: 999,
            title: 'Repeating Event',
            start: new Date(y, m, d + 4, 16, 0),
            allDay: false
        },
        {
            title: 'Birthday Party',
            start: new Date(y, m, d + 1, 19, 0),
            end: new Date(y, m, d + 1, 22, 30),
            allDay: false
        },
        {
            title: 'Click for Google',
            start: new Date(y, m, 28),
            end: new Date(y, m, 29),
            url: 'http://google.com/'
        }
    ];


    /* message on eventClick */
    $scope.alertOnEventClick = function (event, allDay, jsEvent, view) {
        $scope.alertMessage = (event.title + ': Clicked ');
    };
    /* message on Drop */
    $scope.alertOnDrop = function (event, dayDelta, minuteDelta, allDay, revertFunc, jsEvent, ui, view) {
        $scope.alertMessage = (event.title + ': Droped to make dayDelta ' + dayDelta);
    };
    /* message on Resize */
    $scope.alertOnResize = function (event, dayDelta, minuteDelta, revertFunc, jsEvent, ui, view) {
        $scope.alertMessage = (event.title + ': Resized to make dayDelta ' + minuteDelta);
    };

    /* config object */
    $scope.uiConfig = {
        calendar: {
            height: 450,
            editable: true,
            header: {
                left: 'prev,next',
                center: 'title',
                right: 'month,agendaWeek,agendaDay'
            },
            eventClick: $scope.alertOnEventClick,
            eventDrop: $scope.alertOnDrop,
            eventResize: $scope.alertOnResize
        }
    };

    /* Event sources array */
    $scope.eventSources = [$scope.events];
}

/**
 * chartJsCtrl - Controller for data for ChartJs plugin
 * used in Chart.js view
 */
function chartJsCtrl() {

    /**
     * Data for Polar chart
     */
    this.polarData = [
        {
            value: 300,
            color: "#a3e1d4",
            highlight: "#1ab394",
            label: "App"
        },
        {
            value: 140,
            color: "#dedede",
            highlight: "#1ab394",
            label: "Software"
        },
        {
            value: 200,
            color: "#A4CEE8",
            highlight: "#1ab394",
            label: "Laptop"
        }
    ];

    /**
     * Options for Polar chart
     */
    this.polarOptions = {
        scaleShowLabelBackdrop: true,
        scaleBackdropColor: "rgba(255,255,255,0.75)",
        scaleBeginAtZero: true,
        scaleBackdropPaddingY: 1,
        scaleBackdropPaddingX: 1,
        scaleShowLine: true,
        segmentShowStroke: true,
        segmentStrokeColor: "#fff",
        segmentStrokeWidth: 2,
        animationSteps: 100,
        animationEasing: "easeOutBounce",
        animateRotate: true,
        animateScale: false
    };

    /**
     * Data for Doughnut chart
     */
    this.doughnutData = [
        {
            value: 300,
            color: "#a3e1d4",
            highlight: "#1ab394",
            label: "App"
        },
        {
            value: 50,
            color: "#dedede",
            highlight: "#1ab394",
            label: "Software"
        },
        {
            value: 100,
            color: "#A4CEE8",
            highlight: "#1ab394",
            label: "Laptop"
        }
    ];

    /**
     * Options for Doughnut chart
     */
    this.doughnutOptions = {
        segmentShowStroke: true,
        segmentStrokeColor: "#fff",
        segmentStrokeWidth: 2,
        percentageInnerCutout: 45, // This is 0 for Pie charts
        animationSteps: 100,
        animationEasing: "easeOutBounce",
        animateRotate: true,
        animateScale: false
    };

    /**
     * Data for Line chart
     */
    this.lineData = {
        labels: ["January", "February", "March", "April", "May", "June", "July"],
        datasets: [
            {
                label: "Example dataset",
                fillColor: "rgba(220,220,220,0.5)",
                strokeColor: "rgba(220,220,220,1)",
                pointColor: "rgba(220,220,220,1)",
                pointStrokeColor: "#fff",
                pointHighlightFill: "#fff",
                pointHighlightStroke: "rgba(220,220,220,1)",
                data: [65, 59, 80, 81, 56, 55, 40]
            },
            {
                label: "Example dataset",
                fillColor: "rgba(26,179,148,0.5)",
                strokeColor: "rgba(26,179,148,0.7)",
                pointColor: "rgba(26,179,148,1)",
                pointStrokeColor: "#fff",
                pointHighlightFill: "#fff",
                pointHighlightStroke: "rgba(26,179,148,1)",
                data: [28, 48, 40, 19, 86, 27, 90]
            }
        ]
    };

    this.lineDataDashboard4 = {
        labels: ["January", "February", "March", "April", "May", "June", "July"],
        datasets: [
            {
                label: "Example dataset",
                fillColor: "rgba(220,220,220,0.5)",
                strokeColor: "rgba(220,220,220,1)",
                pointColor: "rgba(220,220,220,1)",
                pointStrokeColor: "#fff",
                pointHighlightFill: "#fff",
                pointHighlightStroke: "rgba(220,220,220,1)",
                data: [65, 59, 40, 51, 36, 25, 40]
            },
            {
                label: "Example dataset",
                fillColor: "rgba(26,179,148,0.5)",
                strokeColor: "rgba(26,179,148,0.7)",
                pointColor: "rgba(26,179,148,1)",
                pointStrokeColor: "#fff",
                pointHighlightFill: "#fff",
                pointHighlightStroke: "rgba(26,179,148,1)",
                data: [48, 48, 60, 39, 56, 37, 30]
            }
        ]
    };

    /**
     * Options for Line chart
     */
    this.lineOptions = {
        scaleShowGridLines: true,
        scaleGridLineColor: "rgba(0,0,0,.05)",
        scaleGridLineWidth: 1,
        bezierCurve: true,
        bezierCurveTension: 0.4,
        pointDot: true,
        pointDotRadius: 4,
        pointDotStrokeWidth: 1,
        pointHitDetectionRadius: 20,
        datasetStroke: true,
        datasetStrokeWidth: 2,
        datasetFill: true
    };

    /**
     * Options for Bar chart
     */
    this.barOptions = {
        scaleBeginAtZero: true,
        scaleShowGridLines: true,
        scaleGridLineColor: "rgba(0,0,0,.05)",
        scaleGridLineWidth: 1,
        barShowStroke: true,
        barStrokeWidth: 2,
        barValueSpacing: 5,
        barDatasetSpacing: 1
    };

    /**
     * Data for Bar chart
     */
    this.barData = {
        labels: ["January", "February", "March", "April", "May", "June", "July"],
        datasets: [
            {
                label: "My First dataset",
                fillColor: "rgba(220,220,220,0.5)",
                strokeColor: "rgba(220,220,220,0.8)",
                highlightFill: "rgba(220,220,220,0.75)",
                highlightStroke: "rgba(220,220,220,1)",
                data: [65, 59, 80, 81, 56, 55, 40]
            },
            {
                label: "My Second dataset",
                fillColor: "rgba(26,179,148,0.5)",
                strokeColor: "rgba(26,179,148,0.8)",
                highlightFill: "rgba(26,179,148,0.75)",
                highlightStroke: "rgba(26,179,148,1)",
                data: [28, 48, 40, 19, 86, 27, 90]
            }
        ]
    };

    /**
     * Data for Radar chart
     */
    this.radarData = {
        labels: ["Eating", "Drinking", "Sleeping", "Designing", "Coding", "Cycling", "Running"],
        datasets: [
            {
                label: "My First dataset",
                fillColor: "rgba(220,220,220,0.2)",
                strokeColor: "rgba(220,220,220,1)",
                pointColor: "rgba(220,220,220,1)",
                pointStrokeColor: "#fff",
                pointHighlightFill: "#fff",
                pointHighlightStroke: "rgba(220,220,220,1)",
                data: [65, 59, 90, 81, 56, 55, 40]
            },
            {
                label: "My Second dataset",
                fillColor: "rgba(26,179,148,0.2)",
                strokeColor: "rgba(26,179,148,1)",
                pointColor: "rgba(26,179,148,1)",
                pointStrokeColor: "#fff",
                pointHighlightFill: "#fff",
                pointHighlightStroke: "rgba(151,187,205,1)",
                data: [28, 48, 40, 19, 96, 27, 100]
            }
        ]
    };

    /**
     * Options for Radar chart
     */
    this.radarOptions = {
        scaleShowLine: true,
        angleShowLineOut: true,
        scaleShowLabels: false,
        scaleBeginAtZero: true,
        angleLineColor: "rgba(0,0,0,.1)",
        angleLineWidth: 1,
        pointLabelFontFamily: "'Arial'",
        pointLabelFontStyle: "normal",
        pointLabelFontSize: 10,
        pointLabelFontColor: "#666",
        pointDot: true,
        pointDotRadius: 3,
        pointDotStrokeWidth: 1,
        pointHitDetectionRadius: 20,
        datasetStroke: true,
        datasetStrokeWidth: 2,
        datasetFill: true
    };


};

/**
 * GoogleMaps - Controller for data google maps
 */
function GoogleMaps($scope) {
    $scope.mapOptions = {
        zoom: 11,
        center: new google.maps.LatLng(40.6700, -73.9400),
        // Style for Google Maps
        styles: [{
            "featureType": "water",
            "stylers": [{
                "saturation": 43
            }, {
                "lightness": -11
            }, {
                "hue": "#0088ff"
            }]
        }, {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [{
                "hue": "#ff0000"
            }, {
                "saturation": -100
            }, {
                "lightness": 99
            }]
        }, {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [{
                "color": "#808080"
            }, {
                "lightness": 54
            }]
        }, {
            "featureType": "landscape.man_made",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#ece2d9"
            }]
        }, {
            "featureType": "poi.park",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#ccdca1"
            }]
        }, {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#767676"
            }]
        }, {
            "featureType": "road",
            "elementType": "labels.text.stroke",
            "stylers": [{
                "color": "#ffffff"
            }]
        }, {
            "featureType": "poi",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "landscape.natural",
            "elementType": "geometry.fill",
            "stylers": [{
                "visibility": "on"
            }, {
                "color": "#b8cb93"
            }]
        }, {
            "featureType": "poi.park",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "poi.sports_complex",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "poi.medical",
            "stylers": [{
                "visibility": "on"
            }]
        }, {
            "featureType": "poi.business",
            "stylers": [{
                "visibility": "simplified"
            }]
        }],
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    $scope.mapOptions2 = {
        zoom: 11,
        center: new google.maps.LatLng(40.6700, -73.9400),
        // Style for Google Maps
        styles: [{
            "featureType": "all",
            "elementType": "all",
            "stylers": [{
                "invert_lightness": true
            }, {
                "saturation": 10
            }, {
                "lightness": 30
            }, {
                "gamma": 0.5
            }, {
                "hue": "#435158"
            }]
        }],
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    $scope.mapOptions3 = {
        center: new google.maps.LatLng(36.964645, -122.01523),
        zoom: 18,
        // Style for Google Maps
        MapTypeId: google.maps.MapTypeId.SATELLITE,
        styles: [{
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{
                "color": "#fffffa"
            }]
        }, {
            "featureType": "water",
            "stylers": [{
                "lightness": 50
            }]
        }, {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "transit",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [{
                "lightness": 40
            }]
        }],
        mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    $scope.mapOptions4 = {
        zoom: 11,
        center: new google.maps.LatLng(40.6700, -73.9400),
        // Style for Google Maps
        styles: [{
            "stylers": [{
                "hue": "#18a689"
            }, {
                "visibility": "on"
            }, {
                "invert_lightness": true
            }, {
                "saturation": 40
            }, {
                "lightness": 10
            }]
        }],
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };
}

/**
 * nestableCtrl - Controller for nestable list
 */
function nestableCtrl($scope) {
    $scope.remove = function (scope) {
        scope.remove();
    };
    $scope.toggle = function (scope) {
        scope.toggle();
    };
    $scope.moveLastToTheBeginning = function () {
        var a = $scope.data.pop();
        $scope.data.splice(0, 0, a);
    };
    $scope.newSubItem = function (scope) {
        var nodeData = scope.$modelValue;
        nodeData.nodes.push({
            id: nodeData.id * 10 + nodeData.nodes.length,
            title: nodeData.title + '.' + (nodeData.nodes.length + 1),
            nodes: []
        });
    };
    $scope.collapseAll = function () {
        $scope.$broadcast('collapseAll');
    };
    $scope.expandAll = function () {
        $scope.$broadcast('expandAll');
    };
    $scope.data = [{
        "id": 1,
        "title": "node1",
        "nodes": [
            {
                "id": 11,
                "title": "node1.1",
                "nodes": [
                    {
                        "id": 111,
                        "title": "node1.1.1",
                        "nodes": []
                    }
                ]
            },
            {
                "id": 12,
                "title": "node1.2",
                "nodes": []
            }
        ]
    }, {
        "id": 2,
        "title": "node2",
        "nodes": [
            {
                "id": 21,
                "title": "node2.1",
                "nodes": []
            },
            {
                "id": 22,
                "title": "node2.2",
                "nodes": []
            }
        ]
    }, {
        "id": 3,
        "title": "node3",
        "nodes": [
            {
                "id": 31,
                "title": "node3.1",
                "nodes": []
            }
        ]
    }];
}

/**
 * codeEditorCtrl - Controller for code editor - Code Mirror
 */
function codeEditorCtrl($scope) {
    $scope.editorOptions = {
        lineNumbers: true,
        matchBrackets: true,
        styleActiveLine: true,
        theme: "ambiance"
    };

    $scope.editorOptions2 = {
        lineNumbers: true,
        matchBrackets: true,
        styleActiveLine: true
    };

}

/**
 * ngGridCtrl - Controller for code ngGrid
 */
function ngGridCtrl($scope) {
    $scope.ngData = [
        {
            Name: "Moroni",
            Age: 50,
            Position: 'PR Menager',
            Status: 'active',
            Date: '12.12.2014'
        },
        {
            Name: "Teancum",
            Age: 43,
            Position: 'CEO/CFO',
            Status: 'deactive',
            Date: '10.10.2014'
        },
        {
            Name: "Jacob",
            Age: 27,
            Position: 'UI Designer',
            Status: 'active',
            Date: '09.11.2013'
        },
        {
            Name: "Nephi",
            Age: 29,
            Position: 'Java programmer',
            Status: 'deactive',
            Date: '22.10.2014'
        },
        {
            Name: "Joseph",
            Age: 22,
            Position: 'Marketing manager',
            Status: 'active',
            Date: '24.08.2013'
        },
        {
            Name: "Monica",
            Age: 43,
            Position: 'President',
            Status: 'active',
            Date: '11.12.2014'
        },
        {
            Name: "Arnold",
            Age: 12,
            Position: 'CEO',
            Status: 'active',
            Date: '07.10.2013'
        },
        {
            Name: "Mark",
            Age: 54,
            Position: 'Analyst',
            Status: 'deactive',
            Date: '03.03.2014'
        },
        {
            Name: "Amelia",
            Age: 33,
            Position: 'Sales manager',
            Status: 'deactive',
            Date: '26.09.2013'
        },
        {
            Name: "Jesica",
            Age: 41,
            Position: 'Ruby programmer',
            Status: 'active',
            Date: '22.12.2013'
        },
        {
            Name: "John",
            Age: 48,
            Position: 'Marketing manager',
            Status: 'deactive',
            Date: '09.10.2014'
        },
        {
            Name: "Berg",
            Age: 19,
            Position: 'UI/UX Designer',
            Status: 'active',
            Date: '12.11.2013'
        }
    ];

    $scope.ngOptions = {
        data: 'ngData'
    };
    $scope.ngOptions2 = {
        data: 'ngData',
        showGroupPanel: true,
        jqueryUIDraggable: true
    };
}


/**
 * notifyCtrl - Controller angular notify
 */
function notifyCtrl($scope, notify) {
    $scope.msg = 'Hello! This is a sample message!';
    $scope.demo = function () {
        notify({
            message: $scope.msg,
            classes: $scope.classes,
            templateUrl: $scope.template
        });
    };
    $scope.closeAll = function () {
        notify.closeAll();
    };

    $scope.inspiniaTemplate = 'views/common/notify.html';
    $scope.inspiniaDemo1 = function () {
        notify({
            message: 'Info - This is a Inspinia info notification',
            classes: 'alert-info',
            templateUrl: $scope.inspiniaTemplate
        });
    }
    $scope.inspiniaDemo2 = function () {
        notify({
            message: 'Success - This is a Inspinia success notification',
            classes: 'alert-success',
            templateUrl: $scope.inspiniaTemplate
        });
    }
    $scope.inspiniaDemo3 = function () {
        notify({
            message: 'Warning - This is a Inspinia warning notification',
            classes: 'alert-warning',
            templateUrl: $scope.inspiniaTemplate
        });
    }
    $scope.inspiniaDemo4 = function () {
        notify({
            message: 'Danger - This is a Inspinia danger notification',
            classes: 'alert-danger',
            templateUrl: $scope.inspiniaTemplate
        });
    }
}

/**
 * translateCtrl - Controller for translate
 */
function translateCtrl($translate, $scope) {
    $scope.changeLanguage = function (langKey) {
        $translate.use(langKey);
        $scope.language = langKey;
    };
}

/**
 * imageCrop - Controller for image crop functionality
 */
function imageCrop($scope) {

    $scope.dupa = "dasdasdas";

    $scope.myImage = 'data:image/jpeg;base64,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';
    $scope.myCroppedImage = '';

    var handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        var reader = new FileReader();
        reader.onload = function (evt) {
            $scope.$apply(function ($scope) {
                $scope.myImage = evt.target.result;
            });
        };
        reader.readAsDataURL(file);
    };
    angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
}


/**
 * diff - Controller for diff function
 */
function diff($scope) {
    $scope.oldText = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only centuries, but also the leap into electronic typesetting.';
    $scope.newText = 'Lorem Ipsum is simply typesetting dummy text of the printing and has been the industry\'s typesetting. Lorem Ipsum has been the industry\'s standard dummy text ever the 1500s, when an printer took a galley of type and simply it to make a type. It has survived not only five centuries, but survived not also the leap into electronic typesetting.';

    $scope.oldText1 = 'Lorem Ipsum is simply printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text eve';
    $scope.newText1 = 'Ting dummy text of the printing and has been the industry\'s typesetting. Lorem Ipsum has been the industry\'s';
}

/**
 * idleTimer - Controller for Idle Timer
 */
function idleTimer($scope, Idle, notify) {

    // Custm alter
    $scope.customAlert = false;

    // Start watching idle
    Idle.watch();

    // Config notify behavior
    notify.config({
        duration: '5000'
    });

    // function you want to fire when the user goes idle
    $scope.$on('IdleStart', function () {
        notify({
            message: 'Idle time - You can call any function after idle timeout.',
            classes: 'alert-warning',
            templateUrl: 'views/common/notify.html'
        });
        $scope.customAlert = true;

    });

    // function you want to fire when the user becomes active again
    $scope.$on('IdleEnd', function () {
        notify({
            message: 'You are back, Great that you decided to move a mouse.',
            classes: 'alert-success',
            templateUrl: 'views/common/notify.html'
        });
        $scope.customAlert = false;
    });

}


/**
 * liveFavicon - Controller for live favicon
 */
function liveFavicon($scope) {

    $scope.example1 = function () {
        Tinycon.setBubble(1);
        Tinycon.setOptions({
            background: '#f03d25'
        });
    }

    $scope.example2 = function () {
        Tinycon.setBubble(1000);
        Tinycon.setOptions({
            background: '#f03d25'
        });
    }

    $scope.example3 = function () {
        Tinycon.setBubble('In');
        Tinycon.setOptions({
            background: '#f03d25'
        });
    }

    $scope.example4 = function () {
        Tinycon.setOptions({
            background: '#e0913b'
        });
        Tinycon.setBubble(8);
    }

}

/**
 * formValidation - Controller for validation example
 */
function formValidation($scope) {

    $scope.signupForm = function () {
        if ($scope.signup_form.$valid) {
            // Submit as normal
        } else {
            $scope.signup_form.submitted = true;
        }
    }

    $scope.signupForm2 = function () {
        if ($scope.signup_form.$valid) {
            // Submit as normal
        }
    }

};

/**
 * agileBoard - Controller for agile Board view
 */
function agileBoard($scope) {


    $scope.todoList = [
        {
            content: 'Simply dummy text of the printing and typesetting industry.',
            date: '12.10.2015',
            statusClass: 'warning',
            tagName: 'Mark'
        },
        {
            content: 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default.',
            date: '05.04.2015',
            statusClass: 'success',
            tagName: 'Tag'
        },
        {
            content: 'Sometimes by accident, sometimes on purpose (injected humour and the like).',
            date: '16.11.2015',
            statusClass: 'info',
            tagName: 'Mark'
        },
        {
            content: 'All the Lorem Ipsum generators',
            date: '06.10.2015',
            statusClass: 'danger',
            tagName: 'Tag'
        },
        {
            content: 'Which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.',
            date: '09.12.2015',
            statusClass: 'warning',
            tagName: 'Mark'
        },
        {
            content: 'Packages and web page editors now use Lorem Ipsum as',
            date: '08.04.2015',
            statusClass: 'warning',
            tagName: 'Mark'
        },
        {
            content: 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default.',
            date: '05.04.2015',
            statusClass: 'success',
            tagName: 'Tag'
        },
        {
            content: 'Sometimes by accident, sometimes on purpose (injected humour and the like).',
            date: '16.11.2015',
            statusClass: 'info',
            tagName: 'Tag'
        }
    ];
    $scope.inProgressList = [
        {
            content: 'Quisque venenatis ante in porta suscipit.',
            date: '12.10.2015',
            statusClass: 'success',
            tagName: 'Mark'
        },
        {
            content: ' Phasellus sit amet tortor sed enim mollis accumsan in consequat orci.',
            date: '05.04.2015',
            statusClass: 'success',
            tagName: 'Tag'
        },
        {
            content: 'Nunc sed arcu at ligula faucibus tempus ac id felis. Vestibulum et nulla quis turpis sagittis fringilla.',
            date: '16.11.2015',
            statusClass: 'warning',
            tagName: 'Mark'
        },
        {
            content: 'Ut porttitor augue non sapien mollis accumsan. Nulla non elit eget lacus elementum viverra.',
            date: '09.12.2015',
            statusClass: 'warning',
            tagName: 'Tag'
        },
        {
            content: 'Packages and web page editors now use Lorem Ipsum as',
            date: '08.04.2015',
            statusClass: 'info',
            tagName: 'Tag'
        },
        {
            content: 'Quisque lacinia tellus et odio ornare maximus.',
            date: '05.04.2015',
            statusClass: 'success',
            tagName: 'Mark'
        },
        {
            content: 'Enim mollis accumsan in consequat orci.',
            date: '11.04.2015',
            statusClass: 'danger',
            tagName: 'Tag'
        }
    ];
    $scope.completedList = [
        {
            content: 'Sometimes by accident, sometimes on purpose (injected humour and the like).',
            date: '16.11.2015',
            statusClass: 'info',
            tagName: 'Mark'
        },
        {
            content: 'Ut porttitor augue non sapien mollis accumsan. Nulla non elit eget lacus elementum viverra.',
            date: '09.12.2015',
            statusClass: 'warning',
            tagName: 'Tag'
        },
        {
            content: 'Which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.',
            date: '09.12.2015',
            statusClass: 'warning',
            tagName: 'Tag'
        },
        {
            content: 'Packages and web page editors now use Lorem Ipsum as',
            date: '08.04.2015',
            statusClass: 'warning',
            tagName: 'Tag'
        },
        {
            content: 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default.',
            date: '05.04.2015',
            statusClass: 'success',
            tagName: 'Mark'
        },
        {
            content: 'Sometimes by accident, sometimes on purpose (injected humour and the like).',
            date: '16.11.2015',
            statusClass: 'info',
            tagName: 'Tag'
        },
        {
            content: 'Simply dummy text of the printing and typesetting industry.',
            date: '12.10.2015',
            statusClass: 'warning',
            tagName: 'Mark'
        },
        {
            content: 'Many desktop publishing packages and web page editors now use Lorem Ipsum as their default.',
            date: '05.04.2015',
            statusClass: 'success',
            tagName: 'Mark'
        }
    ];

    $scope.sortableOptions = {
        connectWith: ".connectList"
    };

}

/**
 * draggablePanels - Controller for draggable panels example
 */
function draggablePanels($scope) {

    $scope.sortableOptions = {
        connectWith: ".connectPanels",
        handler: ".ibox-title"
    };

}

/**
 * chartistCtrl - Controller for Chartist library
 */
function chartistCtrl() {

    this.lineData = {
        labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        series: [
            [12, 9, 7, 8, 5],
            [2, 1, 3.5, 7, 3],
            [1, 3, 4, 5, 6]
        ]
    }

    this.lineOptions = {
        fullWidth: true,
        chartPadding: {
            right: 40
        }
    }

    var times = function (n) {
        return Array.apply(null, new Array(n));
    };

    var prepareData = times(26).map(Math.random).reduce(function (data, rnd, index) {
        data.labels.push(index + 1);
        data.series.forEach(function (series) {
            series.push(Math.random() * 100)
        });

        return data;
    }, {
        labels: [],
        series: times(4).map(function () {
            return new Array()
        })
    });

    this.scatterData = prepareData;

    this.scatterOptions = {
        showLine: false,
        axisX: {
            labelInterpolationFnc: function (value, index) {
                return index % 13 === 0 ? 'W' + value : null;
            }
        }
    }

    this.stackedData = {
        labels: ['Q1', 'Q2', 'Q3', 'Q4'],
        series: [
            [800000, 1200000, 1400000, 1300000],
            [200000, 400000, 500000, 300000],
            [100000, 200000, 400000, 600000]
        ]
    }
    this.stackedOptions = {
        stackBars: true,
        axisY: {
            labelInterpolationFnc: function (value) {
                return (value / 1000) + 'k';
            }
        }
    }

    this.horizontalData = {
        labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        series: [
            [5, 4, 3, 7, 5, 10, 3],
            [3, 2, 9, 5, 4, 6, 4]
        ]
    }

    this.horizontalOptions = {
        seriesBarDistance: 10,
        reverseData: true,
        horizontalBars: true,
        axisY: {
            offset: 70
        }
    }

    var prepareData = {
        series: [5, 3, 4]
    }

    this.pieData = prepareData

    var sum = function (a, b) {
        return a + b
    };

    this.pieOptions = {
        labelInterpolationFnc: function (value) {
            return Math.round(value / prepareData.series.reduce(sum) * 100) + '%';
        }
    }

    this.gaugeData = {
        series: [20, 10, 30, 40]
    }

    this.gaugeOptions = {
        donut: true,
        donutWidth: 60,
        startAngle: 270,
        total: 200,
        showLabel: false
    }

}

/**
 * metricsCtrl - Controller for data for all Sparkline chart
 * used in Metrics view
 */
function metricsCtrl() {


    this.demo1Data = [34, 43, 43, 35, 44, 32, 44, 52];
    this.demo1Options = {
        type: 'line',
        width: '100%',
        height: '60',
        lineColor: '#1ab394',
        fillColor: "#ffffff"
    };

    this.demo2Data = [24, 43, 43, 55, 44, 62, 44, 72];
    this.demo2Options = {
        type: 'line',
        width: '100%',
        height: '60',
        lineColor: '#1ab394',
        fillColor: "#ffffff"
    };

    this.demo3Data = [74, 43, 23, 55, 54, 32, 24, 12];
    this.demo3Options = {
        type: 'line',
        width: '100%',
        height: '60',
        lineColor: '#ed5565',
        fillColor: "#ffffff"
    };

    this.demo4Data = [24, 43, 33, 55, 64, 72, 44, 22];
    this.demo4Options = {
        type: 'line',
        width: '100%',
        height: '60',
        lineColor: '#ed5565',
        fillColor: "#ffffff"
    };

    this.demo5Data = [1, 4];
    this.demo5Options = {
        type: 'pie',
        height: '140',
        sliceColors: ['#1ab394', '#F5F5F5']
    };

    this.demo6Data = [5, 3];
    this.demo6Options = {
        type: 'pie',
        height: '140',
        sliceColors: ['#1ab394', '#F5F5F5']
    };

    this.demo7Data = [2, 2];
    this.demo7Options = {
        type: 'pie',
        height: '140',
        sliceColors: ['#ed5565', '#F5F5F5']
    };

    this.demo8Data = [2, 3];
    this.demo8Options = {
        type: 'pie',
        height: '140',
        sliceColors: ['#ed5565', '#F5F5F5']
    };

}



/**
 * sweetAlertCtrl - Function for Sweet alerts
 */
function sweetAlertCtrl($scope, SweetAlert) {


    $scope.demo1 = function () {
        SweetAlert.swal({
            title: "Welcome in Alerts",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
        });
    }

    $scope.demo2 = function () {
        SweetAlert.swal({
            title: "Good job!",
            text: "You clicked the button!",
            type: "success"
        });
    }

    $scope.demo3 = function () {
        SweetAlert.swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this imaginary file!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, delete it!",
                closeOnConfirm: false,
                closeOnCancel: false
            },
            function () {
                SweetAlert.swal("Ok!");
            });
    }

    $scope.demo4 = function () {
        SweetAlert.swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this imaginary file!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No, cancel plx!",
                closeOnConfirm: false,
                closeOnCancel: false
            },
            function (isConfirm) {
                if (isConfirm) {
                    SweetAlert.swal("Deleted!", "Your imaginary file has been deleted.", "success");
                } else {
                    SweetAlert.swal("Cancelled", "Your imaginary file is safe :)", "error");
                }
            });
    }

}

function selectCtrl($scope) {

    $scope.person = {};
    $scope.people = [
        {
            name: 'Adam',
            email: 'adam@email.com',
            age: 12,
            country: 'United States'
        },
        {
            name: 'Amalie',
            email: 'amalie@email.com',
            age: 12,
            country: 'Argentina'
        },
        {
            name: 'Estefanía',
            email: 'estefania@email.com',
            age: 21,
            country: 'Argentina'
        },
        {
            name: 'Adrian',
            email: 'adrian@email.com',
            age: 21,
            country: 'Ecuador'
        },
        {
            name: 'Wladimir',
            email: 'wladimir@email.com',
            age: 30,
            country: 'Ecuador'
        },
        {
            name: 'Samantha',
            email: 'samantha@email.com',
            age: 30,
            country: 'United States'
        },
        {
            name: 'Nicole',
            email: 'nicole@email.com',
            age: 43,
            country: 'Colombia'
        },
        {
            name: 'Natasha',
            email: 'natasha@email.com',
            age: 54,
            country: 'Ecuador'
        },
        {
            name: 'Michael',
            email: 'michael@email.com',
            age: 15,
            country: 'Colombia'
        },
        {
            name: 'Nicolás',
            email: 'nicolas@email.com',
            age: 43,
            country: 'Colombia'
        }
    ];

    $scope.option = {};
    $scope.options = [
        {
            number: '1',
            text: 'Option 1'
        },
        {
            number: '2',
            text: 'Option 2'
        },
        {
            number: '3',
            text: 'Option 3'
        },
        {
            number: '4',
            text: 'Option 4'
        },
        {
            number: '5',
            text: 'Option 5'
        },
        {
            number: '6',
            text: 'Option 6'
        }
    ];

    $scope.availableColors = ['Red', 'Green', 'Blue', 'Yellow', 'Magenta', 'Maroon', 'Umbra', 'Turquoise'];

    $scope.multipleDemo = {};
    $scope.multipleDemo.colors = ['Blue', 'Red'];

}



function toastrCtrl($scope, toaster) {

    $scope.demo1 = function () {
        toaster.success({
            body: "Hi, welcome to Inspinia. This is example of Toastr notification box."
        });
    };

    $scope.demo2 = function () {
        toaster.warning({
            title: "Title example",
            body: "This is example of Toastr notification box."
        });
    };

    $scope.demo3 = function () {
        toaster.pop({
            type: 'info',
            title: 'Title example',
            body: 'This is example of Toastr notification box.',
            showCloseButton: true

        });
    };

    $scope.demo4 = function () {
        toaster.pop({
            type: 'error',
            title: 'Title example',
            body: 'This is example of Toastr notification box.',
            showCloseButton: true,
            timeout: 600
        });
    };

}

function loadingCtrl($scope, $timeout) {


    $scope.runLoading = function () {
        // start loading
        $scope.loading = true;

        $timeout(function () {
            // Simulate some service
            $scope.loading = false;
        }, 2000)
    };


    // Demo purpose actions
    $scope.runLoading1 = function () {
        // start loading
        $scope.loading1 = true;

        $timeout(function () {
            // Simulate some service
            $scope.loading1 = false;
        }, 2000)
    };
    $scope.runLoading2 = function () {
        // start loading
        $scope.loading2 = true;

        $timeout(function () {
            // Simulate some service
            $scope.loading2 = false;
        }, 2000)
    };
    $scope.runLoading3 = function () {
        // start loading
        $scope.loading3 = true;

        $timeout(function () {
            // Simulate some service
            $scope.loading3 = false;
        }, 2000)
    };
    $scope.runLoading4 = function () {
        // start loading
        $scope.loading4 = true;

        $timeout(function () {
            // Simulate some service
            $scope.loading4 = false;
        }, 2000)
    };
    $scope.runLoading5 = function () {
        // start loading
        $scope.loading5 = true;

        $timeout(function () {
            // Simulate some service
            $scope.loading5 = false;
        }, 2000)
    };
    $scope.runLoading6 = function () {
        // start loading
        $scope.loading6 = true;

        $timeout(function () {
            // Simulate some service
            $scope.loading6 = false;
        }, 2000)
    };
    $scope.runLoading7 = function () {
        // start loading
        $scope.loading7 = true;

        $timeout(function () {
            // Simulate some service
            $scope.loading7 = false;
        }, 2000)
    };
    $scope.runLoading8 = function () {
        // start loading
        $scope.loading8 = true;

        $timeout(function () {
            // Simulate some service
            $scope.loading8 = false;
        }, 2000)
    };
    $scope.runLoading9 = function () {
        // start loading
        $scope.loading9 = true;

        $timeout(function () {
            // Simulate some service
            $scope.loading9 = false;
        }, 2000)
    };
    $scope.runLoading10 = function () {
        // start loading
        $scope.loading10 = true;

        $timeout(function () {
            // Simulate some service
            $scope.loading10 = false;
        }, 2000)
    };
    $scope.runLoading11 = function () {
        // start loading
        $timeout(function () {
            $scope.loading11 = 0.1;
        }, 500);
        $timeout(function () {
            $scope.loading11 += 0.2;
        }, 1000);
        $timeout(function () {
            $scope.loading11 += 0.3;
        }, 1500);
        $timeout(function () {
            $scope.loading11 = false;
        }, 2000);

    };
    $scope.runLoading12 = function () {
        // start loading
        $timeout(function () {
            $scope.loading12 = 0.1;
        }, 500);
        $timeout(function () {
            $scope.loading12 += 0.2;
        }, 1000);
        $timeout(function () {
            $scope.loading12 += 0.3;
        }, 1500);
        $timeout(function () {
            $scope.loading12 = false;
        }, 2000);

    };

    $scope.runLoadingDemo = function () {
        // start loading
        $scope.loadingDemo = true;

        $timeout(function () {
            // Simulate some service
            $scope.loadingDemo = false;
        }, 2000)
    };


}


function datatablesCtrl($scope, DTOptionsBuilder) {

    $scope.dtOptions = DTOptionsBuilder.newOptions()
        .withDOM('<"html5buttons"B>lTfgitp')
        .withButtons([
            {
                extend: 'copy'
            },
            {
                extend: 'csv'
            },
            {
                extend: 'excel',
                title: 'ExampleFile'
            },
            {
                extend: 'pdf',
                title: 'ExampleFile'
            },

            {
                extend: 'print',
                customize: function (win) {
                    $(win.document.body).addClass('white-bg');
                    $(win.document.body).css('font-size', '10px');

                    $(win.document.body).find('table')
                        .addClass('compact')
                        .css('font-size', 'inherit');
                }
            }
        ]);

    /**
     * persons - Data used in Tables view for Data Tables plugin
     */
    $scope.persons = [
        {
            id: '1',
            firstName: 'Monica',
            lastName: 'Smith'
        },
        {
            id: '2',
            firstName: 'Sandra',
            lastName: 'Jackson'
        },
        {
            id: '3',
            firstName: 'John',
            lastName: 'Underwood'
        },
        {
            id: '4',
            firstName: 'Chris',
            lastName: 'Johnatan'
        },
        {
            id: '5',
            firstName: 'Kim',
            lastName: 'Rosowski'
        }
    ];

}

function truncateCtrl($scope) {

    $scope.truncateOptions = {
        watch: 'window'
    };

    $scope.truncateOptions2 = {
        watch: 'window',
        ellipsis: ' ///...'
    };

    $scope.truncateOptions3 = {
        watch: 'window',
        wrap: 'letter'
    }

}

function touchspinCtrl($scope) {

    $scope.inputteresxcs = 55;
    $scope.spinOption1 = {
        min: 0,
        max: 100,
        step: 0.1,
        decimals: 2,
        boostat: 5,
        maxboostedstep: 10,
    };

    $scope.spinOption2 = {
        verticalbuttons: true
    }

    $scope.spinOption3 = {
        postfix: '%'
    }

    $scope.spinOption4 = {
        postfix: "a button",
        postfix_extraclass: "btn btn-default"
    }

}

function tourCtrl($scope) {

    $scope.preparebody = function (tour) {
        $('body').addClass('tour-open')
    };

    $scope.clearbody = function (tour) {
        $('body').removeClass('tour-close')
    }

}

function jstreeCtrl($scope) {

    $scope.treeConfig = {
        'plugins': ['types', 'dnd'],
        'types': {
            'default': {
                'icon': 'fa fa-folder'
            },
            'html': {
                'icon': 'fa fa-file-code-o'
            },
            'svg': {
                'icon': 'fa fa-file-picture-o'
            },
            'css': {
                'icon': 'fa fa-file-code-o'
            },
            'img': {
                'icon': 'fa fa-file-image-o'
            },
            'js': {
                'icon': 'fa fa-file-text-o'
            }

        }
    };

    $scope.treeData = [
        {
            "id": "ajson1",
            "parent": "#",
            "text": "Admin theme",
            "state": {
                "opened": true
            },
            "__uiNodeId": 1
        }, {
            "id": "ajson2",
            "parent": "ajson1",
            "text": "css",
            "state": {
                "opened": true
            },
            "__uiNodeId": 2
        }, {
            "id": "ajson3",
            "parent": "ajson2",
            "text": "animate.css",
            "state": {
                "opened": true
            },
            "type": "css",
            "__uiNodeId": 3
        },
        {
            "id": "ajson4",
            "parent": "ajson2",
            "text": "bootstrap.css",
            "state": {
                "opened": true
            },
            "type": "css",
            "__uiNodeId": 4
        },
        {
            "id": "ajson5",
            "parent": "ajson2",
            "text": "style.css",
            "state": {
                "opened": true
            },
            "type": "css",
            "__uiNodeId": 5
        },
        {
            "id": "ajson6",
            "parent": "ajson1",
            "text": "fonts",
            "state": {
                "opened": false
            },
            "__uiNodeId": 6
        },
        {
            "id": "ajson9",
            "parent": "ajson6",
            "text": "glyphicons-halflings-regular.eot",
            "state": {
                "opened": true
            },
            "type": "img",
            "__uiNodeId": 9
        },
        {
            "id": "ajson10",
            "parent": "ajson6",
            "text": "glyphicons-halflings-regular.svg",
            "state": {
                "opened": true
            },
            "type": "svg",
            "__uiNodeId": 10
        },
        {
            "id": "ajson11",
            "parent": "ajson6",
            "text": "glyphicons-halflings-regular.ttf",
            "state": {
                "opened": true
            },
            "type": "img",
            "__uiNodeId": 11
        },
        {
            "id": "ajson12",
            "parent": "ajson6",
            "text": "glyphicons-halflings-regular.woff",
            "state": {
                "opened": true
            },
            "type": "img",
            "__uiNodeId": 12
        },
        {
            "id": "ajson7",
            "parent": "ajson1",
            "text": "img",
            "state": {
                "opened": true
            },
            "__uiNodeId": 7
        },
        {
            "id": "ajson13",
            "parent": "ajson7",
            "text": "profile_small.jpg",
            "state": {
                "opened": true
            },
            "type": "img",
            "__uiNodeId": 13
        },
        {
            "id": "ajson14",
            "parent": "ajson7",
            "text": "angular_logo.png",
            "state": {
                "opened": true
            },
            "type": "img",
            "__uiNodeId": 14
        },
        {
            "id": "ajson15",
            "parent": "ajson7",
            "text": "html_logo.png",
            "state": {
                "opened": true
            },
            "li_attr": {
                "class": "text-navy"
            },
            "type": "img",
            "__uiNodeId": 15
        },
        {
            "id": "ajson16",
            "parent": "ajson7",
            "text": "mvc_logo.png",
            "state": {
                "opened": true
            },
            "li_attr": {
                "class": "text-navy"
            },
            "type": "img",
            "__uiNodeId": 16
        },
        {
            "id": "ajson8",
            "parent": "ajson1",
            "text": "js",
            "state": {
                "opened": true
            },
            "__uiNodeId": 8
        },
        {
            "id": "ajson17",
            "parent": "ajson8",
            "text": "inspinia.js",
            "state": {
                "opened": true
            },
            "type": "js",
            "__uiNodeId": 17
        },
        {
            "id": "ajson18",
            "parent": "ajson8",
            "text": "bootstrap.js",
            "state": {
                "opened": true
            },
            "type": "js",
            "__uiNodeId": 18
        },
        {
            "id": "ajson19",
            "parent": "ajson8",
            "text": "jquery-2.1.1.js",
            "state": {
                "opened": true
            },
            "type": "js",
            "__uiNodeId": 19
        },
        {
            "id": "ajson20",
            "parent": "ajson8",
            "text": "jquery-ui.custom.min.js",
            "state": {
                "opened": true
            },
            "type": "js",
            "__uiNodeId": 20
        },
        {
            "id": "ajson21",
            "parent": "ajson1",
            "text": "affix.html",
            "type": "html",
            "__uiNodeId": 21
        },
        {
            "id": "ajson22",
            "parent": "ajson1",
            "text": "dashboard.html",
            "type": "html",
            "__uiNodeId": 22
        },
        {
            "id": "ajson23",
            "parent": "ajson1",
            "text": "buttons.html",
            "type": "html",
            "__uiNodeId": 23
        },
        {
            "id": "ajson24",
            "parent": "ajson1",
            "text": "calendar.html",
            "type": "html",
            "__uiNodeId": 24
        },
        {
            "id": "ajson25",
            "parent": "ajson1",
            "text": "contacts.html",
            "type": "html",
            "__uiNodeId": 25
        },
        {
            "id": "ajson26",
            "parent": "ajson1",
            "text": "css_animation.html",
            "type": "html",
            "__uiNodeId": 26
        },
        {
            "id": "ajson27",
            "parent": "ajson1",
            "text": "flot_chart.html",
            "type": "html",
            "__uiNodeId": 27
        },
        {
            "id": "ajson28",
            "parent": "ajson1",
            "text": "google_maps.html",
            "type": "html",
            "__uiNodeId": 28
        },
        {
            "id": "ajson29",
            "parent": "ajson1",
            "text": "icons.html",
            "type": "html",
            "__uiNodeId": 29
        },
        {
            "id": "ajson30",
            "parent": "ajson1",
            "text": "invoice.html",
            "type": "html",
            "__uiNodeId": 30
        },
        {
            "id": "ajson31",
            "parent": "ajson1",
            "text": "login.html",
            "type": "html",
            "__uiNodeId": 31
        }
    ]

}

function datamapsCtrl($scope) {

    $scope.mapObject1 = {
        scope: 'world',
        responsive: true,
        fills: {
            defaultFill: "#DBDAD6"
        },
        geographyConfig: {
            highlightFillColor: '#1C977A',
            highlightBorderWidth: 0,
        },
    }

    $scope.mapObject2 = {
        scope: 'world',
        responsive: true,
        fills: {
            defaultFill: "#DBDAD6",
            active: "#2BA587"
        },
        geographyConfig: {
            highlightFillColor: '#1C977A',
            highlightBorderWidth: 0,
        },
        data: {
            USA: {
                fillKey: "active"
            },
            RUS: {
                fillKey: "active"
            },
            DEU: {
                fillKey: "active"
            },
            BRA: {
                fillKey: "active"
            }
        }
    }

    $scope.mapObject3 = {
        responsive: true,
        scope: 'usa',
        fills: {
            defaultFill: "#DBDAD6",
            active: "#2BA587"
        },
        geographyConfig: {
            highlightFillColor: '#1C977A',
            highlightBorderWidth: 0
        },
        data: {
            NE: {
                fillKey: "active"
            },
            CA: {
                fillKey: "active"
            },
            NY: {
                fillKey: "active"
            },
        }
    }

    $scope.mapObject4 = {
        scope: 'world',
        responsive: true,
        fills: {
            defaultFill: "#F2F2F0",
            active: "#DBDAD6",
            usa: "#269479"
        },
        geographyConfig: {
            highlightFillColor: '#1C977A',
            highlightBorderWidth: 0
        },
        data: {
            USA: {
                fillKey: "usa"
            },
            RUS: {
                fillKey: "active"
            },
            DEU: {
                fillKey: "active"
            },
            POL: {
                fillKey: "active"
            },
            JAP: {
                fillKey: "active"
            },
            AUS: {
                fillKey: "active"
            },
            BRA: {
                fillKey: "active"
            }
        }
    };

    $scope.mapPlugins = {
        arc: {}
    };

    $scope.mapPluginData = {
        arc: [
            {
                origin: 'USA',
                destination: 'RUS'
            },
            {
                origin: 'USA',
                destination: 'DEU'
            },
            {
                origin: 'USA',
                destination: 'POL'
            },
            {
                origin: 'USA',
                destination: 'JAP'
            },
            {
                origin: 'USA',
                destination: 'AUS'
            },
            {
                origin: 'USA',
                destination: 'BRA'
            }
        ]
    }



}

function pdfCtrl($scope) {
    $scope.pdfUrl = './pdf/example.pdf';
    $scope.httpHeaders = {
        Authorization: 'Bearer some-aleatory-token'
    };
}

function passwordMeterCtrl($scope) {

    var options1 = {};
    options1.ui = {
        container: "#pwd-container1",
        showVerdictsInsideProgressBar: true,
        viewports: {
            progress: ".pwstrength_viewport_progress"
        }
    };
    options1.common = {
        debug: false,
    };
    $scope.option1 = options1;

    var options2 = {};
    options2.ui = {
        container: "#pwd-container2",
        showStatus: true,
        showProgressBar: false,
        viewports: {
            verdict: ".pwstrength_viewport_verdict"
        }
    };
    $scope.option2 = options2;

    var options3 = {};
    options3.ui = {
        container: "#pwd-container3",
        showVerdictsInsideProgressBar: true,
        viewports: {
            progress: ".pwstrength_viewport_progress2"
        }
    };
    options3.common = {
        debug: true,
        usernameField: "#username"
    };
    $scope.option3 = options3;

    var options4 = {};
    options4.ui = {
        container: "#pwd-container4",
        viewports: {
            progress: ".pwstrength_viewport_progress4",
            verdict: ".pwstrength_viewport_verdict4"
        }
    };
    options4.common = {
        zxcvbn: true,
        zxcvbnTerms: ['samurai', 'shogun', 'bushido', 'daisho', 'seppuku'],
        userInputs: ['#year', '#familyname']
    };
    $scope.option4 = options4;



}

/**
 *
 * Pass all functions into module
 */
angular
    .module('showcaseApp')
    .controller('MainCtrl', MainCtrl)
    .controller('dashboardFlotOne', dashboardFlotOne)
    .controller('dashboardFlotTwo', dashboardFlotTwo)
    .controller('dashboardFive', dashboardFive)
    .controller('dashboardMap', dashboardMap)
    .controller('flotChartCtrl', flotChartCtrl)
    .controller('rickshawChartCtrl', rickshawChartCtrl)
    .controller('sparklineChartCtrl', sparklineChartCtrl)
    .controller('widgetFlotChart', widgetFlotChart)
    .controller('modalDemoCtrl', modalDemoCtrl)
    .controller('ionSlider', ionSlider)
    .controller('wizardCtrl', wizardCtrl)
    .controller('CalendarCtrl', CalendarCtrl)
    .controller('chartJsCtrl', chartJsCtrl)
    .controller('GoogleMaps', GoogleMaps)
    .controller('ngGridCtrl', ngGridCtrl)
    .controller('codeEditorCtrl', codeEditorCtrl)
    .controller('nestableCtrl', nestableCtrl)
    .controller('notifyCtrl', notifyCtrl)
    .controller('translateCtrl', translateCtrl)
    .controller('imageCrop', imageCrop)
    .controller('diff', diff)
    .controller('idleTimer', idleTimer)
    .controller('liveFavicon', liveFavicon)
    .controller('formValidation', formValidation)
    .controller('agileBoard', agileBoard)
    .controller('draggablePanels', draggablePanels)
    .controller('chartistCtrl', chartistCtrl)
    .controller('metricsCtrl', metricsCtrl)
    .controller('sweetAlertCtrl', sweetAlertCtrl)
    .controller('selectCtrl', selectCtrl)
    .controller('toastrCtrl', toastrCtrl)
    .controller('loadingCtrl', loadingCtrl)
    .controller('datatablesCtrl', datatablesCtrl)
    .controller('truncateCtrl', truncateCtrl)
    .controller('touchspinCtrl', touchspinCtrl)
    .controller('tourCtrl', tourCtrl)
    .controller('jstreeCtrl', jstreeCtrl)
    .controller('datamapsCtrl', datamapsCtrl)
    .controller('pdfCtrl', pdfCtrl)
    .controller('passwordMeterCtrl', passwordMeterCtrl);
(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/home',
            data: {
                authorities: ['SYSTEM_USER'],
                pageTitle: 'home.pageTitle'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('showcases');
                    $translatePartialLoader.addPart('checklist');
                    return $translate.refresh();
                }],
                data: function($q, $state, $timeout, $localStorage) {
                    var deferred = $q.defer();

                    $timeout(function() {
                      if ($localStorage.defaultStore && !$localStorage.defaultStore.storeId) {
                        $state.go('store-info');
                        deferred.reject();
                      } else {
                        deferred.resolve();
                      }
                    }, 10);

                    return deferred.promise;
                  }
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .service('HomeService', HomeService);

    HomeService.$inject = ['HomeFactory'];

    function HomeService(HomeFactory) {

        var service = {
            getReport: getReport,
            getStoreInfo: getStoreInfo,
        };

        return service;

        function getReport(storeId) {
            return HomeFactory.getReport({"storeId": storeId}).$promise;
        }

        function getStoreInfo(storeId) {
            return HomeFactory.getStoreInfo({"storeId": storeId}).$promise;
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('HomeFactory', HomeFactory);

    HomeFactory.$inject = ['$resource'];

    function HomeFactory($resource) {
        var resourceUrl = 'admin/api/home';

        return $resource(resourceUrl, {}, {
            'getReport': {
                method: 'GET',
                url: resourceUrl + '/report/store/:storeId',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getStoreInfo': {
                method: 'GET',
                url: resourceUrl + '/store-info/store/:storeId',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$window', '$rootScope', '$scope', '$translate', '$localStorage', '$sce', 'toastr', 'Principal',
        'StoreService', 'HubService', 'HomeService','SatisfactionSurveyService', '$timeout', 'Account',
    ];

    function HomeController($window, $rootScope, $scope, $translate, $localStorage, $sce, toastr, Principal,
        StoreService, HubService, HomeService, SatisfactionSurveyService, $timeout, Account) {
        var vm = this;
        vm.store = $localStorage.defaultStore;
        vm.loading = true;

		init();

		function init() {
			getAccount();
		}

		function getAccount() {
            Principal.identity(false).then(function (account) {
                vm.account = account;
				vm.userProfile = vm.account.userProfiles[0];

				getData();

				$timeout(function(){
					if ($window.OneSignal) {
						$window.OneSignal.push(function() {
							OneSignal.Notifications.addEventListener("permissionChange", eventListener);
							$window.OneSignal.Notifications.requestPermission();
						});
					}
				}, 4000);

                if (vm.account.isHubAdmin) {
                    HubService.getHubByOwner(vm.account.id).then(function (result) {
                        vm.hub = result;
                        $localStorage.hub = vm.hub;
                    });
                }else{
	 				HubService.getHubByStoreId(account.userProfiles[0].storeId).then(function (result) {
	                    vm.hub = result;
	                    $localStorage.hub = vm.hub;
	                });
				}
                if (account.userProfiles) {
                    if ($rootScope.ADMIN_SYSTEM_ID != account.userProfiles[0].storeId) {
                        getPendencies(account.userProfiles[0].storeId)
                    }
                }
                $translate.use(vm.account.langKey);

				if (vm.account.acceptedTerm) {
					showModalSatisfaction();
				}
            });
        }

		function getData() {
			if (vm.userProfile.profileId == 7) {
				vm.videos = [
		            {
		                title: $translate.instant('home.ambassador.steps.step1.title'),
		                subtitle: $translate.instant('home.ambassador.steps.step1.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/showkase/home-step-customer.png',
		                url: 'https://www.youtube.com/embed/o99fHp7ADCIaaa'
		            },
		            {
		                title: $translate.instant('home.ambassador.steps.step2.title'),
		                subtitle: $translate.instant('home.ambassador.steps.step2.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/showkase/home-step-flyer.png',
		                url: 'https://www.youtube.com/embed/QYANOySV4qMaaa'
		            },
		            {
		                title: $translate.instant('home.ambassador.steps.step3.title'),
		                subtitle: $translate.instant('home.ambassador.steps.step3.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/showkase/icone-links.png',
		                url: 'https://www.youtube.com/embed/fKx6QMgFyagaaa'
		            },
					{
		                title: $translate.instant('home.ambassador.steps.step4.title'),
		                subtitle: $translate.instant('home.ambassador.steps.step4.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/showkase/home-step-payment.png',
		                url: 'https://www.youtube.com/embed/fKx6QMgFyagaaa'
		            }
		        ];
			} else if (vm.store.hubId != 4) {
				vm.videos = [
		            {
		                title: $translate.instant('home.steps.step1.title'),
		                subtitle: $translate.instant('home.steps.step1.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/home-step-setting.png',
		                url: 'https://www.youtube.com/embed/o99fHp7ADCI',
		                actionText: $translate.instant('home.steps.step1.box-subtitle'),
		                actions: [
		                    {
		                        label: $translate.instant('home.steps.step1.button1'),
		                        url: 'store-detail({fromStep: true})'
		                    }
		                ]
		            },
		            {
		                title: $translate.instant('home.steps.step2.title'),
		                subtitle: $translate.instant('home.steps.step2.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/home-step-flyer.png',
		                url: 'https://www.youtube.com/embed/QYANOySV4qM',
		                actionText: $translate.instant('home.steps.step2.box-subtitle'),
		                actions: [
		                    {
		                        label: $translate.instant('home.steps.step2.button1'),
		                        url: 'flyers.new'
		                    }
		                ]
		            },
		            {
		                title: $translate.instant('home.steps.step3.title'),
		                subtitle: $translate.instant('home.steps.step3.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/home-step-showcase.png',
		                url: 'https://www.youtube.com/embed/fKx6QMgFyag',
		                actionText: $translate.instant('home.steps.step3.box-subtitle'),
		                actions: [
		                    {
		                        label: $translate.instant('home.steps.step3.button1'),
		                        url: 'showcases.new'
		                    }
		                ]
		            },
		            {
		                title: $translate.instant('home.steps.step4.title'),
		                subtitle: $translate.instant('home.steps.step4.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/icone-links.png',
		                links: true,
		                titleRight: $translate.instant('home.steps.step4.box-title'),
		                subtitleRight: $translate.instant('home.steps.step4.box-subtitle'),
		                actionLabel: $translate.instant('home.steps.step4.button2'),
						link: $translate.instant('home.steps.step4.button1')
		            },
		            {
		                title: $translate.instant('home.steps.step5.title'),
		                subtitle: $translate.instant('home.steps.step5.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/home-step-payment.png',
		                url: 'https://www.youtube.com/embed/k4hz3OcxDXY',
		                actionText: $translate.instant('home.steps.step5.box-subtitle'),
		                actions: [
		                    {
		                        label: $translate.instant('home.steps.step5.button1'),
		                        url: 'payment-settings'
		                    },
		                    {
		                        label: $translate.instant('home.steps.step5.button2'),
		                        url: 'shipping-settings'
		                    }
		                ]
		            },
		            {
		                title: $translate.instant('home.steps.step6.title'),
		                subtitle: $translate.instant('home.steps.step6.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/home-step-customer.png',
		                url: 'https://www.youtube.com/embed/bsvxhhLWB5Qaa',
		                actionText: $translate.instant('home.steps.step6.box-subtitle'),
		                actions: [
		                    {
		                        label: $translate.instant('home.steps.step6.button1'),
		                        url: 'customers'
		                    },
		                    {
		                        label: $translate.instant('home.steps.step6.button2'),
		                        url: 'invoices'
		                    }
		                ]
		            },
		            {
		                title: $translate.instant('home.steps.step7.title'),
		                subtitle: $translate.instant('home.steps.step7.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/home-step-social-network.png',
		                url: 'https://www.youtube.com/embed/GAX2koyUuc',
		                actionText: $translate.instant('home.steps.step7.box-subtitle'),
		                actions: [
		                    {
		                        label: $translate.instant('home.steps.step7.button1'),
		                        url: 'social-integrations'
		                    }
		                ]
		            }
		        ];
			} else {
			    vm.videos =  [
					{
		                title: $translate.instant('home.steps.step1.title'),
		                subtitle: $translate.instant('home.steps.step1.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/home-step-setting.png',
		                url: 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/dupay/step_01_dupay.png',
		                actionText: $translate.instant('home.steps.step1.box-subtitle'),
		                actions: [
		                    {
		                        label: $translate.instant('home.steps.step1.button1'),
		                        url: 'store-detail({fromStep: true})'
		                    }
		                ]
		            },
					{
		                title: $translate.instant('home.steps.step2.title'),
		                subtitle: $translate.instant('home.steps.step2.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/home-step-flyer.png',
		                url: 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/dupay/step_02_dupay.png',
		                actionText: $translate.instant('home.steps.step2.box-subtitle'),
		                actions: [
		                    {
		                        label: $translate.instant('home.steps.step2.button1'),
		                        url: 'flyers.new'
		                    }
		                ]
		            },
					{
		                title: $translate.instant('home.steps.step3.title'),
		                subtitle: $translate.instant('home.steps.step3.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/home-step-showcase.png',
		                url: 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/dupay/step_03_dupay.png',
		                actionText: $translate.instant('home.steps.step3.box-subtitle'),
		                actions: [
		                    {
		                        label: $translate.instant('home.steps.step3.button1'),
		                        url: 'showcases.new'
		                    }
		                ]
		            },
		            {
		                title: $translate.instant('home.steps.step4.title'),
		                subtitle: $translate.instant('home.steps.step4.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/icone-links.png',
		                links: true,
		                titleRight: $translate.instant('home.steps.step4.box-title'),
		                subtitleRight: $translate.instant('home.steps.step4.box-subtitle'),
		                actionLabel: $translate.instant('home.steps.step4.button2'),
						link: $translate.instant('home.steps.step4.button1')
		            },
		            {
		                title: $translate.instant('home.steps.step5.title'),
		                subtitle: $translate.instant('home.steps.step5.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/home-step-payment.png',
		                url: 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/dupay/step_05_dupay.png',
		                actionText: $translate.instant('home.steps.step5.box-subtitle'),
		                actions: [
		                    {
		                        label: $translate.instant('home.steps.step5.button1'),
		                        url: 'payment-settings'
		                    },
		                    {
		                        label: $translate.instant('home.steps.step5.button2'),
		                        url: 'shipping-settings'
		                    }
		                ]
		            },
					{
		                title: $translate.instant('home.steps.step6.title'),
		                subtitle: $translate.instant('home.steps.step6.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/home-step-customer.png',
		                url: 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/dupay/step_06_dupay.png',
		                actionText: $translate.instant('home.steps.step6.box-subtitle'),
		                actions: [
		                    {
		                        label: $translate.instant('home.steps.step6.button1'),
		                        url: 'customers'
		                    },
		                    {
		                        label: $translate.instant('home.steps.step6.button2'),
		                        url: 'invoices'
		                    }
		                ]
		            },
					{
		                title: $translate.instant('home.steps.step7.title'),
		                subtitle: $translate.instant('home.steps.step7.subtitle'),
		                imagePath: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/home-step-social-network.png',
		                url: 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/dupay/step_07_dupay.png',
		                actionText: $translate.instant('home.steps.step7.box-subtitle'),
		                actions: [
		                    {
		                        label: $translate.instant('home.steps.step7.button1'),
		                        url: 'social-integrations'
		                    }
		                ]
		            }
		        ];
			}
		}

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

		function eventListener(event) {
			if (event) {
				if($window.OneSignal && $window.OneSignal.User && $window.OneSignal.User._currentUser ) {
					Principal.savePushNotificationId($window.OneSignal.User._currentUser.onesignalId).then(function (response) {
						// TODO: Some code
					});
				}
			}
		}

        function showModalSatisfaction() {
            SatisfactionSurveyService.checkIfStoreNew(vm.account.userProfiles[0].storeId).then(function (response) {
                if (!response.data) {
                    SatisfactionSurveyService.checkIfNotExpiredEvaluation(vm.account.userProfiles[0].storeId, vm.account.id).then(function (response) {
                        if (!response.data) {
                            SatisfactionSurveyService.rateStore().then(function () {});
                        }
                    });
                }
            });
        }


        function getPendencies(storeId) {
            HomeService.getStoreInfo(storeId).then(function (response) {
                vm.storePendencies = response.data;
                if (vm.storePendencies.hasPublishedShowcase) {
                    getReport(vm.account.userProfiles[0].storeId)
                } else {
                    vm.loading = false;
                }
                selectCurrentVideo();
            }).catch(function () {
                vm.loading = false;
            })
        }

        function getReport(storeId) {
            vm.loading = true;
            HomeService.getReport(storeId).then(function (response) {
                vm.report = response.data;
                vm.loading = false;
            }).catch(function () {
                vm.loading = false;
            })
        }

        function selectCurrentVideo() {
			getData();
			if (vm.userProfile.profileId == 7) {
				vm.video = vm.videos[0];
				vm.videoStep = 0;
			} else {
				if (!vm.storePendencies.filledStoreInfo) {
					vm.video = vm.videos[0];
					vm.videoStep = 0;
				} else if (!vm.storePendencies.hasFlyer) {
					vm.video = vm.videos[1];
					vm.videoStep = 1;
				} else if (!vm.storePendencies.hasPublishedShowcase) {
					vm.video = vm.videos[2];
					vm.videoStep = 2;
				} else if (!vm.storePendencies.hasPaymentGateway || !vm.storePendencies.hasShippingGateway) {
					vm.video = vm.videos[4];
					vm.videoStep = 4;
				} else {
					vm.video = vm.videos[5];
					vm.videoStep = 5;
				}
			}
        }

        vm.changeStep = function (step) {
			getData();
            vm.videoStep += step;
            vm.video = vm.videos[vm.videoStep];
        }

        vm.getTrustedUrl = function (url) {
            return $sce.trustAsResourceUrl(url);
        }

        vm.getShowcaseURL = function() {
            if (!$localStorage.defaultStore.storeNickname) {
                getStoreInfo().then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    $localStorage.defaultStore.storeType = response.data.storeType;
                    vm.store = response.data;
                    return ('https://' + $localStorage.defaultStore.storeNickname.toLowerCase() + '.' + getDomainNameSufix($window, vm.store.storeType) + '/links');
                });
            } else {
               return ('https://' + $localStorage.defaultStore.storeNickname.toLowerCase() + '.' + getDomainNameSufix($window, vm.store.storeType) + '/links');
            }

        }

        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId);
        }

        getStoreInfo().then(function(response) {
            $localStorage.defaultStore.storeType = response.data.storeType;
            vm.store = response.data;
        });

		vm.showTotalSales = function () {
			var jcMotosIds = [2078, 2079];
			var profileIds = [2, 4, 9];

			if (!$localStorage.defaultStore || !$localStorage.defaultStore.storeId) {
				return false;
			}

			if (jcMotosIds.includes($localStorage.defaultStore.storeId)) {
				return profileIds.includes($localStorage.defaultStore.profileId);
			} else {
				return true;
			}
		}

        vm.copyLink =  function () {
            var text = vm.getShowcaseURL();
            var msgSuccess = "Link copiado com sucesso";

            if (window.clipboardData && window.clipboardData.setData) {
                toastr.success(msgSuccess);
                return clipboardData.setData("Text", text);

            } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                var textarea = document.createElement("textarea");
                textarea.textContent = text;
                textarea.style.position = "fixed";
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    toastr.success(msgSuccess);
                    return document.execCommand("copy");
                } catch (ex) {
                    return false;
                } finally {
                    document.body.removeChild(textarea);
                }
            }
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('TeamService', TeamService);

        TeamService.$inject = ['TeamFactory', '$localStorage'];

    function TeamService(TeamFactory, $localStorage) {
        var service = {
                get: get,
                list: list,
                create: create,
                update: update,
                remove: remove
        };

        return service;

        function get(id) {
            return TeamFactory.get({id: id}).$promise;
        }

        function list(params) {
            return TeamFactory.list(params).$promise;
        }

        function create(team) {
            return TeamFactory.create(team).$promise;
        }

        function update(id, team) {
            team.id = id;
            return TeamFactory.update({id: id}, team).$promise;
        }

        function remove(id) {
            return TeamFactory.remove({id: id}, {}).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('TeamFactory', TeamFactory);

        TeamFactory.$inject = ['$resource'];

    function TeamFactory($resource) {

        var resourceUrl =  'api/team';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                url: 'api/team/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'list': {
                method: 'GET',
                url: '/api/team/list',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'create': { 
                method:'POST',
                url: '/api/team',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                } 
            },
            'update': { 
                method:'PUT',
                url: '/api/team/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                } 
            },
            'remove': { 
                method:'DELETE',
                url: '/api/team/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                } 
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ProfileDetailController', ProfileDetailController);

    ProfileDetailController.$inject = ['$timeout', '$translate', '$localStorage', '$state', '$scope', '$stateParams', 'UserProfileService', 'AuthorityService', 'toastr'];

    function ProfileDetailController($timeout, $translate, $localStorage, $state, $scope, $stateParams, UserProfileService, AuthorityService, toastr) {

        var vm = this;
        vm.authoritiesCheck = [];
        vm.authoritiesWithHierarchy = [];
        vm.isSaving = false;
        vm.profileTypes = ["ADMIN_PROFILE", "CUSTOMER_PROFILE", "STORE_PROFILE"];
        vm.isNewProfile = false;
		vm.profileId = $localStorage.defaultStore.profileId;
        vm.profile = {
            'profileOwner': $stateParams.storeId || $localStorage.defaultStore.storeId
        };

        loadAll();

        function loadAll() {
            if ($stateParams.id) {
                UserProfileService.getProfile($stateParams.id, vm.profile['profileOwner']).then(function(response) {
                    vm.profile = response.data;
                }).then(function(data) {
                    loadAuthorities();
                });
            } else {
                vm.isNewProfile = true;
                loadAuthorities();
            }
            checkIfUserIsAdmin();
        }


        function loadAuthorities() {
            AuthorityService.getAllWithHierarchy(vm.profile['profileOwner']).then(function(authorities) {
                vm.authoritiesWithHierarchy = authorities;
                if (!vm.isNewProfile) {
                    var profileAuthoritie = [];
                    for (var authoritie in authorities) {
                        if (vm.profile.authorities.indexOf(authorities[authoritie].authority) != '-1') {
                            vm.authoritiesCheck.push(true);
                        } else {
                            vm.authoritiesCheck.push(false);
                        }
                    }
                }
                var storeReadIndex = findIndexByAttr(vm.authoritiesWithHierarchy, 'authority', 'STORE_READ');
                if (storeReadIndex != -1){
                    vm.authoritiesCheck[storeReadIndex] = true;
                }
            });
        }

        vm.isAuthorityDependenciesChecked = function (index){
            if (vm.authoritiesWithHierarchy[index].authority != "STORE_READ"){
                if (vm.authoritiesCheck[index]){
                    // Verify if is a child authority and check him parent.
                    for (var indexDependency in vm.authoritiesWithHierarchy[index].dependencies){
                        var indexParentAuthority = findIndexByAttr(vm.authoritiesWithHierarchy, 'authority', vm.authoritiesWithHierarchy[index].dependencies[indexDependency]);
                        if (indexParentAuthority != -1){
                            vm.authoritiesCheck[indexParentAuthority] = true;
                        }
                    }
                    
                } else {
                    // If unchecked, verify if is a parent authority and if has some child authority checked 
                    for (var indexChild in vm.authoritiesWithHierarchy){
                        if (vm.authoritiesWithHierarchy[indexChild].dependencies != null && vm.authoritiesWithHierarchy[indexChild].dependencies.includes(vm.authoritiesWithHierarchy[index].authority)){
                            vm.authoritiesCheck[indexChild] = false;
                        }
                    }
                }
            }
        }

        function checkIfUserIsAdmin() {
            if (vm.profile.profileOwner == '0') {
                vm.profile.type = 'ADMIN_PROFILE';
            } else {
                vm.profile.type = 'STORE_PROFILE';
            }
        }

        vm.save = function() {
            vm.isSaving = true;
            vm.profile.authorities = [];

            for (var authoritie in vm.authoritiesCheck) {
                if (vm.authoritiesCheck[authoritie]) {
                    vm.profile.authorities.push(vm.authoritiesWithHierarchy[authoritie].authority);
                }
            }

            if (!vm.isNewProfile) {
                UserProfileService.updateProfile(vm.profile).then(function(data, error) {
                    toastr.success($translate.instant('showcaseApp.profile.messages.update.success'));
                    $state.go('^');
                }, function(data) {
                    toastr.error($translate.instant('showcaseApp.profile.messages.update.error'));
                });
                vm.isSaving = false;
            } else {
                UserProfileService.createProfile(vm.profile).then(function(data, error) {
                    toastr.success($translate.instant('showcaseApp.profile.messages.create.success'));
                    $state.go('^');
                }, function(data) {
                    toastr.error($translate.instant('showcaseApp.profile.messages.create.error'));
                });
                vm.isSaving = false;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ProfileManagementController', ProfileManagementController);

    ProfileManagementController.$inject = ['$scope', '$state', 'uiGridBuilder', 'uiGridConstants', 'UserProfileService', '$translate', '$localStorage'];

    function ProfileManagementController ($scope, $state, uiGridBuilder, uiGridConstants, UserProfileService, $translate, $localStorage) {
        var vm = this;
        vm.startRegistry = 0;
        vm.endRegistry = 0;
        vm.tableDivisor = 5;
        vm.filterFields = {};
        vm.pagesSize = [];
        vm.defaultSearchIndex = 0;
        vm.columnDefs = getColumnDefs();
        vm.checkIsFirstPage = false;
        vm.checkIsLastPage = false;

        loadAll();

        function loadAll() {
            vm.gridTableOptions = getGridOptions();
        }

        function getColumnDefs() {
            return [
                { field: 'name', displayName: 'showcaseApp.profile.name', headerCellFilter: 'translate' }
            ];
        }

        function getGridOptions() {
            return uiGridBuilder.withDefaultOptions()
                .withActionColumn(100)
                .addActionToActionColumn("edit", "vm.getEditPage", "fa fa-edit", "text-primary", true)
                .addActionToActionColumn("delete", "vm.getDeletePage", "fa fa-trash", "text-primary", true)
                .withColumns(vm.columnDefs).build('search');
        }

        $scope.search = function () {
            var params = null;
            var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();
            UserProfileService.listProfiles(pageable, $localStorage.defaultStore.storeId, vm.filterFields).then(function (response) {
                vm.totalItems = response.headers['x-total-count'];
                vm.gridTableOptions.virtualizationThreshold = response.data.length;
                vm.gridTableOptions.update(response.data, vm.totalItems);
                vm.gridTableOptions.getArrayPagination(function (arrayPagination) {
                    vm.arrayPagination = arrayPagination;
                });
                refreshDataInfos();
                vm.checkIsLastPage = vm.gridTableApi.pagination.getPage() === vm.gridTableApi.pagination.getTotalPages();
                vm.checkIsFirstPage = vm.gridTableApi.pagination.getPage() === 1;
                vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
            });
        }

        function createArray(range, divisor) {
            if(!divisor)divisor = 0;
            if (divisor!=0) {
                range = range/divisor;
            }
            var values = [];
            var iteratorNumber = 0;
            for (var i = 0; i < range; i++) {
              iteratorNumber = divisor!=0 ? i*divisor : i+1;
              values.push(iteratorNumber);
            }
            return values;
        };

        function refreshDataInfos(){
            vm.gridTableApi = vm.gridTableOptions.getApiGridTable();
            vm.startRegistry = (vm.gridTableApi.pagination.getPage() * vm.gridTableOptions.paginationPageSize) - vm.gridTableOptions.paginationPageSize;
            vm.endCalc = vm.gridTableOptions.paginationPageSize * vm.gridTableApi.pagination.getPage();
            vm.endRegistry = vm.endCalc > vm.totalItems ? vm.totalItems : vm.endCalc;
        };

        vm.getEditPage = function(row) {
            $state.go('profile-detail', {storeId: $localStorage.defaultStore.storeId, id:row.id});
        }

        vm.getDeletePage = function(row) {
            $state.go('profile-management.delete', {id:row.id});
        }

        vm.changePageSize = function(pageSize) {
            vm.gridTableOptions.paginationPageSize = pageSize;
        };

        vm.filterField = function(valueFilter, fieldTOFilter) {
            vm.gridTableApi.grid.getColumn(fieldTOFilter).filters[0].term = valueFilter;
            vm.gridTableOptions.enableFiltering = true;
            vm.gridTableApi.grid.refresh();
        };

        vm.reloadProfiles = function() {
            $scope.search();
        }

        vm.stopPropagation = function(event) {
            event.stopPropagation();
        };

        vm.changeColumnView = function($index) {
            vm.gridTableOptions.columnDefs[$index].visible = !(vm.gridTableOptions.columnDefs[$index].visible || vm.gridTableOptions.columnDefs[$index].visible === undefined);
            vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
        };

        vm.exporterTable = function(type) {
            if (type === 'pdf') {
                vm.gridTableApi.exporter.pdfExport('visible', 'visible');
            } else if (type === 'csv') {
                vm.gridTableApi.exporter.csvExport('visible', 'visible');
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profile-management', {
            parent: 'entity',
            url: '/profile-management',
            data: {
                authorities: ['ADMIN_MANAGE_SYSTEM'],
                pageTitle: 'showcaseApp.profile.home.title'
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            views: {
                'content@app': {
                    templateUrl: 'app/entities/profile/profile-management.html',
                    controller: 'ProfileManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('profile-detail', {
            parent: 'profile-management',
            url: '/profile/{id}',
            data: {
                authorities: ['STORE_READ_PROFILE', 'STORE_CREATE_PROFILE'],
                pageTitle: 'showcaseApp.profile.detail.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/entities/profile/profile-management-detail.html',
                    controller: 'ProfileDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                'storeId': {
                    value: null
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profile');
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profile-management',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('profile-management.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['STORE_READ_PROFILE', 'STORE_UPDATE_PROFILE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-management-dialog.html',
                    controller: 'ProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile-management.new', {
            parent: 'profile-management',
            url: '/new',
            data: {
                authorities: ['STORE_CREATE_PROFILE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-management-dialog.html',
                    controller: 'ProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {

                    }
                }).result.then(function() {
                    $state.go('profile-management', null, { reload: 'profile-management' });
                }, function() {
                    $state.go('profile-management');
                });
            }]
        })
        .state('profile-delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['STORE_READ_PROFILE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-management-delete-dialog.html',
                    controller: 'ProfileManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                    }
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('UserProfileService', UserProfileService);

    UserProfileService.$inject = ['UserProfileFactory', '$localStorage'];

    function UserProfileService(UserProfileFactory, $localStorage) {
        var service = {
                getProfiles: getProfiles,
                getProfile: getProfile,
                createProfile: createProfile,
                updateProfile: updateProfile,
                deleteProfile: deleteProfile,
                listProfiles: listProfiles
        };

        return service;

        function getProfile(profileId, storeId) {
            return UserProfileFactory.get({id: profileId, owner: storeId}).$promise;
        }

        function getProfiles(storeId) {
            return UserProfileFactory.listByParams({owner: storeId}, {}).$promise;
        }

        function createProfile(profile) {
            return UserProfileFactory.save(profile).$promise;
        }

        function updateProfile(profile) {
            return UserProfileFactory.update(profile).$promise;
        }

        function deleteProfile(profileId, storeId) {
            return UserProfileFactory.delete({id: profileId, owner: storeId}, {}).$promise;
        }

        function listProfiles(pageable, storeId, params) {
            pageable.owner = storeId;
            return UserProfileFactory.listByParams(pageable, params).$promise;
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('UserProfileFactory', UserProfileFactory);

    UserProfileFactory.$inject = ['$resource'];

    function UserProfileFactory ($resource) {

        var resourceUrl =  'api/profile/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'listByParams': {
                method: 'POST',
                url: '/api/profile/list',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'update': { method:'PUT' },
            'delete': { method:'DELETE' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('authority', {
            parent: 'entity',
            url: '/authority',
            data: {
                authorities: ['USER_ADMIN'],
                pageTitle: 'showcaseApp.authority.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/authority/authorities.html',
                    controller: 'AuthorityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('authority');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('authority-detail', {
            parent: 'authority',
            url: '/authority/{id}',
            data: {
                authorities: ['USER_ADMIN'],
                pageTitle: 'showcaseApp.authority.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/authority/authority-detail.html',
                    controller: 'AuthorityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('authority');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Authority', function($stateParams, Authority) {
                    return Authority.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'authority',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('authority-detail.edit', {
            parent: 'authority-detail',
            url: '/detail/edit',
            data: {
                authorities: ['USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/authority/authority-dialog.html',
                    controller: 'AuthorityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Authority', function(Authority) {
                            return Authority.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('authority.new', {
            parent: 'authority',
            url: '/new',
            data: {
                authorities: ['USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/authority/authority-dialog.html',
                    controller: 'AuthorityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('authority', null, { reload: 'authority' });
                }, function() {
                    $state.go('authority');
                });
            }]
        })
        .state('authority.edit', {
            parent: 'authority',
            url: '/{id}/edit',
            data: {
                authorities: ['USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/authority/authority-dialog.html',
                    controller: 'AuthorityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Authority', function(Authority) {
                            return Authority.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('authority', null, { reload: 'authority' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('authority.delete', {
            parent: 'authority',
            url: '/{id}/delete',
            data: {
                authorities: ['USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/authority/authority-delete-dialog.html',
                    controller: 'AuthorityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Authority', function(Authority) {
                            return Authority.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('authority', null, { reload: 'authority' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('AuthorityService', AuthorityService);

    AuthorityService.$inject = ['AuthorityFactory'];

    function AuthorityService(AuthorityFactory) {
        var service = {
                getAuthorities: getAuthorities,
                getAllWithHierarchy: getAllWithHierarchy
        };

        return service;

        function getAuthorities(storeId) {
            return AuthorityFactory.query({storeId: storeId}).$promise;
        }

        function getAllWithHierarchy(storeId) {
            return AuthorityFactory.getAllWithHierarchy({storeId: storeId}).$promise;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('AuthorityFactory', AuthorityFactory);

    AuthorityFactory.$inject = ['$resource'];

    function AuthorityFactory ($resource) {
        var resourceUrl                 =   'api/authority/:id';
        var resourceGetAllWithHierarchy =   'api/authority-with-hierarchy'

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllWithHierarchy': { 
                method:'GET',
                url: resourceGetAllWithHierarchy,
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .filter('randomSrc', function () {
            return function (input) {
                if (input)
                    return input + '&r=' + Math.round(Math.random() * 999999);
            }
        });
})();

(function(){
    'use strict';

    angular
        .module('showcaseApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('showcaseApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();


(function () {
  'use strict';

  angular
  .module('showcaseApp')
  .directive('price', [function () {
      return {
          require: 'ngModel',
          link: function (scope, element, attrs, ngModel) {
              attrs.$set('ngTrim', "false");

              var formatter = function(str, isNum) {
                  str = String( Number(str || 0) / (isNum?1:100) );
                  str = (str=='0'?'0.0':str).split('.');
                  str[1] = str[1] || '0';
                  return str[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, ('$1' + attrs.priceThousandSeparator ) ) + attrs.priceDecimalSeparator + (str[1].length==1?str[1]+'0':str[1]);
              }
              var updateView = function(val) {
                if (attrs.priceActivated != 'true') return '';
                  scope.$applyAsync(function () {
                      ngModel.$setViewValue(val || '');
                      ngModel.$render();
                  });
              }
              var parseNumber = function(val) {
                if (attrs.priceActivated != 'true') return '';
                  var modelString = formatter(ngModel.$modelValue, true);
                  var sign = {
                      pos: /[+]/.test(val),
                      neg: /[-]/.test(val)
                  }
                  sign.has = sign.pos || sign.neg;
                  sign.both = sign.pos && sign.neg;

                  if (!val || sign.has && val.length==1 || ngModel.$modelValue && Number(val)===0) {
                      var newVal = (!val || ngModel.$modelValue && Number()===0?'':val);
                      if (ngModel.$modelValue !== newVal)
                          updateView(newVal);

                      return '';
                  }
                  else {
                      var valString = String(val || '');
                      var newSign = (sign.both && ngModel.$modelValue>=0 || !sign.both && sign.neg?'-':'');
                      var newVal = valString.replace(/[^0-9]/g,'');
                      var viewVal = newSign + formatter(angular.copy(newVal));

                      if (modelString !== valString)
                          updateView(viewVal);

                      return (Number(newSign + newVal) / 100) || 0;
                  }
              }
              var formatNumber = function(val) {
                if (attrs.priceActivated != 'true') return '';
                if (val) {
                    var str = String(val).split('.');
                    str[1] = str[1] || '0';
                    val = str[0] + '.' + (str[1].length==1?str[1]+'0':str[1]);
                }
                return parseNumber(val);
              }

              var onCurrencyChange = function(){
                // TODO: Angular 1.5.11 doesn't have this method.
                // TODO: this method exists only since 1.6.7
                // ngModel.$processModelValue();
              }

              var watch = scope.$watch(attrs.priceCurrencyType, onCurrencyChange);

              ngModel.$parsers.push(parseNumber);
              ngModel.$formatters.push(formatNumber);
          }
      };
    }]);

  })();

(function() {
  'use strict';

  angular
      .module('showcaseApp')
      .filter('cpfCnpj', cpfCnpj);
  function cpfCnpj() {
      return cpfCnpj;

      function cpfCnpj (value) {
          if (value !== null) {
            if (value.length <= 11) {
              value=value.replace(/(\d{3})(\d)/,"$1.$2");
              value=value.replace(/(\d{3})(\d)/,"$1.$2");
              value=value.replace(/(\d{3})(\d{1,2})$/,"$1-$2");
            } else {
              value=value.replace(/^(\d{2})(\d)/,"$1.$2")
              value=value.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3");
              value=value.replace(/\.(\d{3})(\d)/,".$1/$2");
              value=value.replace(/(\d{4})(\d)/,"$1-$2");
            }
          }
          return value;
      }
  }
})();
(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

/**
 * uiBreadcrumbs automatic breadcrumbs directive for AngularJS & Angular ui-router.
 *
 * https://github.com/michaelbromley/angularUtils/tree/master/src/directives/uiBreadcrumbs
 *
 * Copyright 2014 Michael Bromley <michael@michaelbromley.co.uk>
 */


(function() {

    /**
     * Config
     */
    var moduleName = 'angularUtils.directives.uiBreadcrumbs';
    var templateUrl = 'app/components/util/breadcrumb/uiBreadcrumbs.tpl.html';

    /**
     * Module
     */
    var module;
    try {
        module = angular.module(moduleName);
    } catch(err) {
        // named module does not exist, so create one
        module = angular.module(moduleName, ['ui.router']);
    }

    module.directive('uiBreadcrumbs', ['$interpolate', '$state', function($interpolate, $state) {
            return {
                restrict: 'E',
                templateUrl: function(elem, attrs) {
                    return attrs.templateUrl || templateUrl;
                },
                scope: {
                    displaynameProperty: '@',
                    abstractProxyProperty: '@?'
                },
                link: function(scope) {
                    scope.breadcrumbs = [];
                    scope.current = $state.current.data.pageTitle;
                    if ($state.$current.name !== '') {
                        updateBreadcrumbsArray();
                    }
                    scope.$on('$stateChangeSuccess', function() {
                        scope.current = $state.current.data.pageTitle;
                        updateBreadcrumbsArray();
                    });

                    /**
                     * Start with the current state and traverse up the path to build the
                     * array of breadcrumbs that can be used in an ng-repeat in the template.
                     */
                    function updateBreadcrumbsArray() {
                        var workingState;
                        var displayName;
                        var breadcrumbs = [];
                        var currentState = $state.$current;

                        while(currentState && currentState.name !== '') {
                            workingState = getWorkingState(currentState);
                            if (workingState) {
                                displayName = getDisplayName(workingState);

                                if (displayName !== false && !stateAlreadyInBreadcrumbs(workingState, breadcrumbs)) {
                                    breadcrumbs.push({
                                        displayName: displayName,
                                        route: workingState.name
                                    });
                                }
                            }
                            currentState = currentState.parent;
                        }

                        if ($state.$current.name != 'home') {
                            breadcrumbs.push({displayName: 'global.menu.home', route: 'home'});
                        }

                        breadcrumbs.reverse();
                        scope.breadcrumbs = breadcrumbs;
                    }

                    /**
                     * Get the state to put in the breadcrumbs array, taking into account that if the current state is abstract,
                     * we need to either substitute it with the state named in the `scope.abstractProxyProperty` property, or
                     * set it to `false` which means this breadcrumb level will be skipped entirely.
                     * @param currentState
                     * @returns {*}
                     */
                    function getWorkingState(currentState) {
                        var proxyStateName;
                        var workingState = currentState;
                        if (currentState.abstract === true) {
                            if (typeof scope.abstractProxyProperty !== 'undefined') {
                                proxyStateName = getObjectValue(scope.abstractProxyProperty, currentState);
                                if (proxyStateName) {
                                    workingState = angular.copy($state.get(proxyStateName));
                                    if (workingState) {
                                        workingState.locals = currentState.locals;
                                    }
                                } else {
                                    workingState = false;
                                }
                            } else {
                                workingState = false;
                            }
                        }
                        return workingState;
                    }

                    /**
                     * Resolve the displayName of the specified state. Take the property specified by the `displayname-property`
                     * attribute and look up the corresponding property on the state's config object. The specified string can be interpolated against any resolved
                     * properties on the state config object, by using the usual {{ }} syntax.
                     * @param currentState
                     * @returns {*}
                     */
                    function getDisplayName(currentState) {
                        var interpolationContext;
                        var propertyReference;
                        var displayName;

                        if (!scope.displaynameProperty) {
                            // if the displayname-property attribute was not specified, default to the state's name
                            return currentState.name;
                        }
                        propertyReference = getObjectValue(scope.displaynameProperty, currentState);

                        if (propertyReference === false) {
                            return false;
                        } else if (typeof propertyReference === 'undefined') {
                            return currentState.name;
                        } else {
                            // use the $interpolate service to handle any bindings in the propertyReference string.
                            interpolationContext =  (typeof currentState.locals !== 'undefined') ? currentState.locals.globals : currentState;
                            displayName = $interpolate(propertyReference)(interpolationContext);
                            return displayName;
                        }
                    }

                    /**
                     * Given a string of the type 'object.property.property', traverse the given context (eg the current $state object) and return the
                     * value found at that path.
                     *
                     * @param objectPath
                     * @param context
                     * @returns {*}
                     */
                    function getObjectValue(objectPath, context) {
                        var i;
                        var propertyArray = objectPath.split('.');
                        var propertyReference = context;

                        for (i = 0; i < propertyArray.length; i ++) {
                            if (angular.isDefined(propertyReference[propertyArray[i]])) {
                                propertyReference = propertyReference[propertyArray[i]];
                            } else {
                                // if the specified property was not found, default to the state's name
                                return undefined;
                            }
                        }
                        return propertyReference;
                    }

                    /**
                     * Check whether the current `state` has already appeared in the current breadcrumbs array. This check is necessary
                     * when using abstract states that might specify a proxy that is already there in the breadcrumbs.
                     * @param state
                     * @param breadcrumbs
                     * @returns {boolean}
                     */
                    function stateAlreadyInBreadcrumbs(state, breadcrumbs) {
                        var i;
                        var alreadyUsed = false;
                        for(i = 0; i < breadcrumbs.length; i++) {
                            if (breadcrumbs[i].route === state.name) {
                                alreadyUsed = true;
                            }
                        }
                        return alreadyUsed;
                    }
                }
            };
        }]);
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('showcaseApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('backImg', BackImgDirective);

    function BackImgDirective() {
        return function(scope, element, attrs) {
            var url = attrs.backImg;
            var random = new Date().getTime();
            url = url + "?ts=" + random;
            element.css({
                'background-image': 'url(' + url + ')',
                'background-size': 'cover'
            });
        };
    }
})();

(function () {
    'use strict';

    angular.module('showcaseApp').factory('SelectOfferModalService', SelectOfferModalService);

    function SelectOfferModalService($uibModal, FlyersService, $q) {
        var selectOffers = function selectOffers(singleSelection, title) {
            return $uibModal.open({
                templateUrl: 'app/components/modal/select-offer/select-offer-modal.html',
                controller: 'SelectOfferModalController',
                controllerAs: 'vm',
                size: 'md',
                windowClass: 'open-modal-in-forward',
                resolve: {
                    translatePartialLoader: ['$translate',
                        '$translatePartialLoader',
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('select-offer-modal');
                            return $translate.refresh();
                        }
                    ],
                    singleSelection: function () {
                        return singleSelection;
                    },
                    title: function () {
                        return title;
                    }
                }
            });
        };

        return {
            selectOffers: selectOffers
        }
    }
})();

(function() {
	'use strict';

    angular.module('showcaseApp')
        .controller('SelectOfferModalController', SelectOfferModalController);

	function SelectOfferModalController($uibModalInstance, $stateParams, title, singleSelection, FlyersCurrencyValue, FlyersService) {
		var vm = this;

		vm.confirm = confirm;
        vm.cancel = cancel;
        
		vm.selectedFlyer = undefined;
		vm.error = false;

		vm.offers = [];
		vm.busy = false;
		vm.hasNextPage = true;
		vm.page = 0;
		vm.pageable = {
			page: vm.page,
			size: 10
		};
		vm.title = title;
		vm.singleSelection = singleSelection;

		vm.toggleSelection = function toggleSelection(flyer) {
			vm.selectedFlyer = flyer;
		}
		
		function loadlAll(){
			vm.loadlFlyers(0);
		}

		vm.loadlFlyers = function (page) {
			vm.busy = true;
			vm.page = page;
			vm.pageable.page = page;
			FlyersService.listFlyersPageToModal(vm.pageable).then(function (response, headers) {
				for (var i = 0; i < response.data.content.length; i++) {
					vm.offers.push(response.data.content[i]);
				}
				
				
				vm.hasNextPage = (response.data.totalElements > vm.offers.length);
				vm.busy = false;
			}, function (error) {
				vm.error = true;
				vm.busy = false;
			});
		}

		vm.getFlyerCurrency = function (currency) {
            return FlyersCurrencyValue[currency];
        }

		vm.stopPropagation = function(event) {
			event.stopPropagation();
		};

		function cancel() {
			$uibModalInstance.dismiss('close');
		}

		function confirm() {
			$uibModalInstance.close(vm.selectedFlyer);
		}

		loadlAll();

	}
})();

(function() {
    'use strict';

    angular.module('showcaseApp').factory('InstagramLoginModalService', InstagramLoginModalService);

    function InstagramLoginModalService($uibModal) {
        var openLoginModal = function openLoginModal() {
            return $uibModal.open({
                templateUrl: 'app/components/modal/instagram-login/instagram-login-modal.html',
                controller: 'InstagramLoginModalController',
                controllerAs: 'vm',
                size: 'md',
                windowClass: 'open-modal-in-forward'
            });
        };

        return {
            openLoginModal: openLoginModal
        }
    }
})();
(function () {
    'use strict';

    angular.module('showcaseApp')
        .controller('InstagramLoginModalController', InstagramLoginModalController);

    function InstagramLoginModalController($uibModalInstance, SocialMediaService) {
        var vm = this;

        var vm = this;
        vm.login = login;
        vm.cancel = cancel;

        vm.isAuthenticating
        vm.authenticationError = false;
        vm.confirmAccessRequired = false;
        vm.usernameOrEmail = null;
        vm.password = null;

        function login(event) {
            vm.isAuthenticating = true;
            vm.authenticationError = false;
            vm.confirmAccessRequired = false
            var credentials = {
                username: vm.usernameOrEmail,
                password: vm.password
            };
            event.preventDefault();
            SocialMediaService.connectWithInstagram(credentials).then(function (data) {
                vm.isAuthenticating = false;
                $uibModalInstance.close(data);
            }).catch(function (error) {
                vm.isAuthenticating = false;
                var errorString = JSON.stringify(error);
                if (error.status === -1 || error.status === 500) {
                    $uibModalInstance.close();
                } else if (errorString.includes('challenge')) {
                    vm.confirmAccessRequired = true;
                } else {
                    vm.authenticationError = true;
                }
                
            });
        }

        function cancel() {
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('main-login', {
            url: '/',
            templateUrl: 'app/components/login/main-login/main-login.html',
            controller: 'MainLoginController',
            controllerAs: 'vm',
            data: {
                authorities: [],
                pageTitle: 'Login to Kaztor',
                specialClass: 'main-login',
                mainFlexClass: 'special-height'
            },
            params: {
                'email': null,
                'password': null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .directive("moveNextOnMaxlength", function() {
            return {
                restrict: "A",
                link: function($scope, element) {
                    element.on("input", function(e) {
                        if(element.val().length == element.attr("maxlength")) {
                            var $nextElement = element.next();
                            if($nextElement.length) {
                                $nextElement[0].focus();
                            }
                        }
                    });
                    element.on("keydown keypress", function(event) {
                        if (event.which === 8 || event.which === 46) {
                          if (element.val().length == 0) {
                               var $prevElement = element.prev();
                               if ($prevElement.length) {
                                   $prevElement[0].focus();
                               } 
                          }
                        }
                    });
                }
            }
        })
        .controller('MainLoginController', MainLoginController);
        

    MainLoginController.$inject = ['$rootScope', '$state', '$timeout', '$localStorage', 'Auth', '$location', '$stateParams', '$scope' ];

    function MainLoginController($rootScope, $state, $timeout, $localStorage, Auth, $location, $stateParams, $scope) {
        var vm = this;

        vm.authenticationError = false;
        vm.accountExpiredError = false;
        vm.credentials = {};
        vm.login = login;
        vm.loginWithCode = loginWithCode;
        vm.backToLogin = backToLogin;
        vm.resendCode = resendCode;
        vm.password = null;
        vm.rememberMe = true;
        vm.usernameOrEmail = null;
        vm.isAuthenticating = false;
        vm.isHubShowkase = false;
        vm.hasTwoFactorAuth = false;
        vm.code1 = '';
        vm.code2 = '';
        vm.code3 = '';
        vm.code4 = '';
        vm.code5 = '';
        vm.code6 = '';
        vm.twoFactorAuthData = {
            code: null,
            token: ''
        };
        vm.authEmail = '';

        vm.isToValidateCupom = '';

        if (window.location.search.includes('cpm')) {
            var queryString = window.location.search;
            vm.isToValidateCupom = queryString.substr(queryString.indexOf("=") + 1);
        }

        if (window.location.host.includes('showkase')) {
            vm.isHubShowkase = true;
        }

        angular.element('body').removeClass('mini-navbar');
        $timeout(function () {
            angular.element('#usernameOrEmail').focus();
            localStorage.removeItem('satellizer_token');
        });

        vm.applyValue = function (event) {
            window.navigator.clipboard
                .readText()
                .then(function(clipText){
                    if (clipText) {
                        $scope.$apply(function() {
                            vm.code1 = isNaN(clipText[0]) ? null : +clipText[0];
                            vm.code2 = isNaN(clipText[1]) ? null : +clipText[1];
                            vm.code3 = isNaN(clipText[2]) ? null : +clipText[2];
                            vm.code4 = isNaN(clipText[3]) ? null : +clipText[3];
                            vm.code5 = isNaN(clipText[4]) ? null : +clipText[4];
                            vm.code6 = isNaN(clipText[5]) ? null : +clipText[5];
                        });
                    }
                });
        }

        function login() {
            if (hasStateParams() || vm.loginForm.$valid) {
                vm.isAuthenticating = true;
                vm.authenticationError = false;
                vm.accountExpiredError = false;
                $timeout(function () {
                    Auth.login({
                        usernameOrEmail: vm.usernameOrEmail,
                        password: vm.password,
                        rememberMe: vm.rememberMe
                    }).then(function (data) {
                        vm.isAuthenticating = false;
                        vm.authenticationError = false;
                        vm.accountExpiredError = false;

                        if (data && data.data.tokenTwoFactorAuth) {
                            vm.hasTwoFactorAuth = true;
                            vm.authEmail = data.data.email;
                            vm.twoFactorAuthData.token = data.data.id_token;
                        } else {
                            processAuthentication();
                        }
                    }).catch(function (error) {
                        vm.isAuthenticating = false;
                        var accountExpiredCode = '25';
                        if (error.headers('statuscode') && error.headers('statuscode') === accountExpiredCode) {
                            vm.accountExpiredError = true;
                            $state.go('checkoutInner');
                            return;
                        } else {
                            vm.authenticationError = true;
                        }
                    });
                }, 500);
            }
        }

        function loginWithCode() {
            if (vm.twoAuthForm.$valid) {
                vm.isAuthenticating = true;
                vm.authenticationError = false;
                vm.accountExpiredError = false;

                var code = vm.code1 + '' + vm.code2 + '' + vm.code3 + '' + vm.code4 + '' + vm.code5 + '' + vm.code6;

                $timeout(function () {
                    Auth.loginAuthCode({
                        token: vm.twoFactorAuthData.token,
                        code: code,
                    }).then(function (data) {
                        vm.isAuthenticating = false;
                        vm.authenticationError = false;
                        vm.accountExpiredError = false;
                        processAuthentication();
                    }).catch(function (error) {
                        vm.isAuthenticating = false;
                        var accountExpiredCode = '25';
                        if (error.headers('statuscode') && error.headers('statuscode') === accountExpiredCode) {
                            vm.accountExpiredError = true;
                            $state.go('checkoutInner');
                            return;
                        } else {
                            vm.authenticationError = true;
                        }
                    });
                }, 500);
            }
        }

        function resendCode() { 
            vm.isAuthenticating = true;
            Auth.generateNewCode({
                token: vm.twoFactorAuthData.token,
                code: '000000'
            }).then(function (data) {
                vm.isAuthenticating = false;
                clearCode();
            }).catch(function (error) {
                vm.isAuthenticating = false;
                vm.authenticationError = true;
            });
        }

        function backToLogin() {
            vm.hasTwoFactorAuth = false;
            clearCode();
        }

        function clearCode() {
            vm.code1 = null;
            vm.code2 = null;
            vm.code3 = null;
            vm.code4 = null;
            vm.code5 = null;
            vm.code6 = null;
            vm.authEmail = '';
        }

        function processAuthentication() {
            $rootScope.$broadcast('authenticationSuccess');
            if (isUserHasStores()) {
                if (vm.isToValidateCupom) {
                    $state.go('redeem-coupons', {cupom: vm.isToValidateCupom});
                } else {
                    $state.go('home');
                }
            } else {
                $state.go('store-info');
            }
            if (Auth.getPreviousState()) {
                var previousState = Auth.getPreviousState();
                Auth.resetPreviousState();
                $state.go(previousState.name, previousState.params);
            }
        }

        function isUserHasStores() {
            if ($localStorage.defaultStore) {
                vm.defaultStore = $localStorage.defaultStore.storeId;
                return vm.defaultStore != null;
            }
            
            return null;
        }


        function hasStateParams(){
            return $stateParams.email != undefined && $stateParams.password != undefined;
        }


        function loadParams() {
            vm.usernameOrEmail = $stateParams.email;
            vm.password = $stateParams.password;
            login();
        }

        if(hasStateParams()) loadParams();
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function (error) {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function(languages) {
            vm.languages = languages;
        });

        function changeLanguage(languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'pt-br',
            'en',
            'es'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('paginationConstants', {
            'itemsPerPage': 50,
            'sortOptions': {
                "pt-br": [
                    {id: 1, label: "A-Z", value: "name", direction: 'asc'},
                    {id: 2, label: "Z-A", value: "name", direction: 'desc'},
                    {id: 3, label: "Maior preço", value: "value", direction: 'desc'},
                    {id: 4, label: "Menor preço", value: "value", direction: 'asc'},
                    {id: 5, label: "Publicados", value: "published", direction: 'desc'},
                    {id: 6, label: "Recém atualizados", value: "lastModifiedDate", direction: 'desc'},
                    {id: 7, label: "Lançamento", value: "isLaunch", direction: 'desc'},
                    {id: 8, label: "Últimas peças", value: "isBasic", direction: 'desc'},
                    {id: 9, label: "Maior desconto", value: "discountValue", direction: 'desc'},
                    {id: 10, label: "Mais vendidos", value: "bestSellers", direction: 'desc'},
                    {id: 11, label: "Sem estoque", value: "inventory", direction: 'asc'}
                ],
                "es": [
                    {id: 1, label: "A-Z", value: "name", direction: 'asc'},
                    {id: 2, label: "Z-A", value: "name", direction: 'desc'},
                    {id: 3, label: "Precio más alto", value: "value", direction: 'desc'},
                    {id: 4, label: "Precio más bajo", value: "value", direction: 'asc'},
                    {id: 5, label: "Publicados", value: "published", direction: 'desc'},
                    {id: 6, label: "Recién actualizado", value: "lastModifiedDate", direction: 'desc'},
                    {id: 7, label: "Launch", value: "isLaunch", direction: 'desc'},
                    {id: 8, label: "Últimas piezas", value: "isBasic", direction: 'desc'},
                    {id: 9, label: "Mayor descuento", value: "discountValue", direction: 'desc'},
                    {id: 10, label: "Más vendidos", value: "bestSellers", direction: 'desc'},
                    {id: 11, label: "Agotado", value: "inventory", direction: 'asc'}
                ],
                "en": [
                    {id: 1, label: "A-Z", value: "name", direction: 'asc'},
                    {id: 2, label: "Z-A", value: "name", direction: 'desc'},
                    {id: 3, label: "Highest price", value: "value", direction: 'desc'},
                    {id: 4, label: "Lowest price", value: "value", direction: 'asc'},
                    {id: 5, label: "Publicados", value: "published", direction: 'desc'},
                    {id: 6, label: "Just updated", value: "lastModifiedDate", direction: 'desc'},
                    {id: 7, label: "Launch", value: "isLaunch", direction: 'desc'},
                    {id: 8, label: "Latest pieces", value: "isBasic", direction: 'desc'},
                    {id: 9, label: "Biggest discount", value: "discountValue", direction: 'desc'},
                    {id: 10, label: "Best Sellers", value: "bestSellers", direction: 'desc'},
                    {id: 11, label: "Out of stock", value: "inventory", direction: 'asc'}
                ]
            },
            'defaultSortOption': 5
        });
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .value('AppConfig', {
            MOIP_API_BASE_URL: "https://sandbox.moip.com.br/assinaturas",
            MOIP_ENCODE_64: 'Basic MzJNSzk2SURIWU1IQ0ZHM0VIUTNMT0ZZQVlGOVBTS0Y6RVRBUkw2QlNYRVVHWUhaRVFJU0U2UVdZNTBQM1JGTk5WWlRaNThFTQ=='
        });
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
            '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
            '</div>' +
            '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('showcaseApp')
        .component('kscError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', '$rootScope', '$translate', 'toastr'];

    function jhiAlertErrorController($scope, $rootScope, $translate, toastr) {
        var vm = this;

        var cleanHttpErrorListener = $rootScope.$on('showcaseApp.httpError', function(event, httpResponse) {
            var i;
            event.stopPropagation();
            var headers = Object.keys(httpResponse.headers()).filter(function(header) {
                return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var statusKey = httpResponse.headers(headers[1]).statuskey;
            toastr.error($translate.instant('error.' + statusKey));
        });

        $scope.$on('$destroy', function() {
            if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
            '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
            '</div>' +
            '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('showcaseApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', '$rootScope', '$translate', 'toastr'];

    function jhiAlertErrorController($scope, $rootScope, $translate, toastr) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert(message, key, data) {
            key = key ? key : message;
            toastr.error("", $translate.instant(key));
        }

        var cleanHttpErrorListener = $rootScope.$on('showcaseApp.httpError', function(event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
                // connection refused, server not reachable
                case 0:
                    addErrorAlert('Server not reachable', 'error.server.not.reachable');
                    break;

                case 400:
                    var headers = Object.keys(httpResponse.headers()).filter(function(header) {
                        return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                    }).sort();
                    var errorHeader = httpResponse.headers(headers[0]);
                    var entityKey = httpResponse.headers(headers[1]);
                    if (errorHeader) {
                        var entityName = $translate.instant('global.menu.entities.' + entityKey);
                        addErrorAlert(errorHeader, errorHeader, {
                            entityName: entityName
                        });
                    } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                        for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                            var fieldError = httpResponse.data.fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                            var fieldName = $translate.instant('showcaseApp.' + fieldError.objectName + '.' + convertedField);
                            addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {
                                fieldName: fieldName
                            });
                        }
                    } else if (httpResponse.data && httpResponse.data.message) {
                        addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                    } else {
                        addErrorAlert(httpResponse.data);
                    }
                    break;

                case 404:
                    addErrorAlert('Not found', 'error.url.not.found');
                    break;

                default:
                    if (httpResponse.data && httpResponse.data.message) {
                        addErrorAlert(httpResponse.data.message);
                    } else {
                        addErrorAlert(angular.toJson(httpResponse));
                    }
            }
        });

        $scope.$on('$destroy', function() {
            if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('showcaseApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('showcaseApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$localStorage', '$sessionStorage'];

    function authInterceptor ($localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token && !config.headers.isWatiRequest) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                if ($rootScope.urlImage && $state.current.name !== 'communication') {
                    var firstLetter = $rootScope.urlImage.substr(0, 1);
                    $window.document.title =  firstLetter.toUpperCase() +  $rootScope.urlImage.substr(1);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('stateHandler', stateHandler);

    function stateHandler($rootScope, $state, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION, formStepsStates, ADMIN_SYSTEM_ID, $localStorage, AuthServerProvider) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;
            $rootScope.ADMIN_SYSTEM_ID = ADMIN_SYSTEM_ID;


            // var statesLocked = ['customers', 'social-medias', 'consumers', 'engagements', 'poster-create-new', 'store-rating', 'social-integrations'];
            // var statesLockedPlanStarter = ['customers', 'social-medias', 'bag', 'poster-create-new', 'tabTacebookBusiness' ];
            // var statesLockedPlanFree = ['consumers', 'engagements', 'store-rating', 'store-performance','store-file-manager', 'customers', 'social-medias', 'social-integrations','payment-settings', 'admin-reports', 'bag', 'poster-create-new' ];

            const Plan = {
                ESSENTIAL: {
                    planId: 10,
                    lockedFeatures: ['checklist', 'notifications', 'communication', 'customers', 'consumers', 'bag', 'erps-settings', 'marketing-settings']
                },
                SHOWKASE: {
                    planId: 11,
                    lockedFeatures: ['checklist', 'notifications', 'communication', 'customers', 'consumers', 'marketing-settings']
                },
                IMPULSE: {
                    planId: 12,
                    lockedFeatures: ['checklist', 'notifications', 'communication', 'marketing-settings']
                },
                SCALA: {
                    planId: 13,
                    lockedFeatures: []
                }
            };

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                var loggedAccount;

                var openRouteList = [
                    'direct-register',
                    'main-register',
                    'requestReset',
                    'finishReset',
                    'activate'
                ];

                var copyAccount = function (account) {
                    if (account) {
                        return {
                            activated: account.activated,
                            hasMoipPlan: account.hasMoipPlan,
                            statusPaymentSignature: account.statusPaymentSignature,
                            isExpired: account.isExpired,
                            isFree: account.isFree,
                            planId: account.planId,
                            remainingTime: account.remainingTime
                        };
                    }

                    return null;
                };

                function getLoggedAccount(callback) {
                    Principal.identity().then(function (account) {
                        loggedAccount = copyAccount(account);
                        callback();
                    }, function (err) {
                        console.log(err);
                        callback();
                    });
                }

                function verifyIfIsExpiredAndGoToCheckoutPage() {
                    Principal.identity().then(function (account) {
                        loggedAccount = copyAccount(account);
                        if (loggedAccount) {
                            if (loggedAccount.isExpired) {
                                if (!loggedAccount.isFree) {
                                    event.preventDefault();
                                    $state.go('checkoutInner');
                                }
                            }
                        }
                    });
                }

				function verifyForceLogout(){
					Principal.forceLogout().then(function (response) {
						if (response.data){
				            Auth.logout();
				            $state.go('main-login');
						}
	                });
				}

                if (toState.name != 'main-login' && !openRouteList.includes(toState.name) && !$localStorage.authenticationToken) {
                    event.preventDefault();
                    $state.go('main-login');
                }

                if (toState.name != 'main-login' && toState.name != 'checkoutInner' && toState.name != 'checkout-result') {
					verifyForceLogout();
                    verifyIfIsExpiredAndGoToCheckoutPage();
                }

                if ($localStorage.authenticationToken && toState.name === 'main-login') {
                    Principal.identity().then(function (account) {
                        loggedAccount = copyAccount(account);
                        console.log(account);
                        if (loggedAccount && loggedAccount.isExpired && !loggedAccount.isFree) {
                            event.preventDefault();
                            $state.go('checkoutInner');
                        } else {
                            event.preventDefault();
                            $state.go('home');
                        }
                    }, function (err) {
                        console.log(err);
                    });

                }

                function isTrial(account) {
                    return !isNullOrUndefined(account) && !isNullOrUndefined(account.remainingTime)
                        && account.remainingTime > 0 && account.remainingTime <= 7;
                }

                function isFeatureLockedByPlan() {
                    if (isNullOrUndefined(loggedAccount) || isNullOrUndefined(loggedAccount["planId"])) {
                        return !isTrial(loggedAccount);
                    }

                    var isFeatureLocked = true;

                    switch (loggedAccount.planId) {
                        case Plan.ESSENTIAL.planId:
                            isFeatureLocked = isFeatureLocked && Plan.ESSENTIAL.lockedFeatures.indexOf(toState.name) > -1
                            break;
                        case Plan.SHOWKASE.planId:
                            isFeatureLocked = isFeatureLocked && Plan.SHOWKASE.lockedFeatures.indexOf(toState.name) > -1
                            break;
                        case Plan.IMPULSE.planId:
                            isFeatureLocked = isFeatureLocked && Plan.IMPULSE.lockedFeatures.indexOf(toState.name) > -1
                            break;
                        case Plan.SCALA.planId:
                            isFeatureLocked = isFeatureLocked && Plan.SCALA.lockedFeatures.indexOf(toState.name) > -1
                            break;
                        default:
                            isFeatureLocked = true;
                    }

                    return isFeatureLocked && !isTrial(loggedAccount);
                }

                function processAllStateData() {
                    $localStorage.isLocked = isFeatureLockedByPlan();

					// if ($localStorage.isMoipPlanFree){
					// 	if (loggedAccount
	                //         && statesLockedPlanFree.indexOf(toState.name) > -1
	                //         && $localStorage.defaultStore.storeId !== ADMIN_SYSTEM_ID) {
	                //         $localStorage.isLocked = true;
	                //     } else {
	                //         $localStorage.isLocked = false;
	                //     }
					// }else if ($localStorage.isMoipPlanStarter){
					// 	if (loggedAccount
	                //         && statesLockedPlanStarter.indexOf(toState.name) > -1
	                //         && $localStorage.defaultStore.storeId !== ADMIN_SYSTEM_ID) {
	                //         $localStorage.isLocked = true;
	                //     } else {
	                //         $localStorage.isLocked = false;
	                //     }
					// }else{
	                //     if (loggedAccount
	                //         && statesLocked.indexOf(toState.name) > -1
	                //         && $localStorage.defaultStore.storeId !== ADMIN_SYSTEM_ID
	                //         && loggedAccount.isFree) {
	                //         $localStorage.isLocked = true;
	                //     } else {
	                //         $localStorage.isLocked = false;
	                //     }
					// }
                    if (loggedAccount && !loggedAccount.isExpired) {
                        if (toState.name === 'main-login') {
                            if (AuthServerProvider.getToken()) {
                                event.preventDefault();
                                $state.go('home');
                            }
                        }

                        if (toState.name === 'store-info' || toState.parent === "form") {
                            if ((AuthServerProvider.getToken()) && $localStorage.defaultStore.storeId !== null && $localStorage.defaultStore.storeId !== ADMIN_SYSTEM_ID) {
                                event.preventDefault();
                            }
                        }
                        if ((toState.name != 'checkoutInner' ||
                                toState.name != 'checkout-result' ||
                                toState.name !== 'main-login' ||
                                toState.name !== 'direct-register' ||
                                toState.name !== 'main-register' ||
                                toState !== 'requestReset' ||
                                toState !== 'finishReset' ||
                                toState.name !== 'activate') && toState.name !== 'store-info' && toState.parent !== "form") {
                            if (AuthServerProvider.getToken()) {
                                if ($localStorage.defaultStore.storeId == null && $localStorage.defaultStore.storeId !== ADMIN_SYSTEM_ID) {
                                    event.preventDefault();
                                    $state.go('store-info');
                                }
                            }
                        }

                        // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                        if (toState.external) {
                            event.preventDefault();
                            $window.open(toState.url, '_self');
                        }

                        if (Principal.isIdentityResolved()) {
                            Auth.authorize();
                        }

                        if (toState.parent === "form") {
                            if ((fromState.name === "" || fromState.name == null) && toState.name !== "store-info") {
                                event.preventDefault();
                                $state.go('store-info');
                            }

                            var canGoToStep = false;
                            // only go to next if previous is valid
                            var toStateIndex = _.findIndex(formStepsStates, function (formStepState) {
                                return formStepState.uiSref === toState.name;
                            });

                            if (toStateIndex === 0) {
                                canGoToStep = true;
                            } else {
                                canGoToStep = formStepsStates[toStateIndex - 1].valid;
                            }

                            // Stop state changing if the previous state is invalid
                            if (!canGoToStep) {
                                // Abort going to step
                                event.preventDefault();
                            }
                        }
                    }
                }

                getLoggedAccount(processAllStateData);

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title';

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "pt-br"');
                $cookies.putObject(name, 'pt-br');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('pt-br');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(angulartoastrConfig);

    angulartoastrConfig.$inject = ['toastrConfig'];


    function angulartoastrConfig(toastrConfig) {
        angular.extend(toastrConfig, {
            autoDismiss: true,
            timeOut: 5000,
            preventOpenDuplicates: true
        });
    }
})();

(function () {
    'use strict';
    
    angular.module('showcaseApp')
        .config(function($mdAriaProvider) {
            // Globally disables all ARIA warnings.
            $mdAriaProvider.disableWarnings();
        });
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, $urlMatcherFactoryProvider) {
 
        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';
  
    angular
      .module('showcaseApp')
      .config(html5ModeConfig);
  
    html5ModeConfig.$inject = ['$locationProvider'];
  
    function html5ModeConfig($locationProvider) {
      $locationProvider.html5Mode({ enabled: true, requireBase: true });
    }
  })();
(function () {
    'use strict';

    angular.module('showcaseApp')
    .config(function($authProvider) {

    $authProvider.facebook({
      clientId: getDomain(window),
      responseType: 'token',
      url: '/auth/facebook',
      authorizationEndpoint: 'https://www.facebook.com/v18.0/dialog/oauth',
      scope: ['email', 'user_likes', 'pages_manage_posts',
      'business_management', 'ads_management', 'pages_show_list', 'catalog_management', 'read_insights', 'ads_read',
      'instagram_manage_insights', 'instagram_manage_comments', 'instagram_basic', 'instagram_content_publish', 'pages_messaging' ],
    });

  });

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function () {
    'use strict';

    angular.module('showcaseApp')
        .config(function (ChartJsProvider) {
            var mainColor = getComputedStyle(document.documentElement).getPropertyValue('--main-color');
            ChartJsProvider.setOptions('Bar', {
                colors: [mainColor]
            });
        });
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig)
        .config(intlTelInputConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('app', {
                url: '/app',
                abstract: true,
                controller: function($scope, $localStorage, $state, BlockPlanModalFactory) {
                    $scope.$watch(function() {
                        return $localStorage.isLocked && $localStorage.userId;
                    }, function() {
                        if ($localStorage.userId && $localStorage.isLocked) {
                            BlockPlanModalFactory.choosePlan().then(function() {
                                $localStorage.isLocked = false;
                            });
                        }
                    }, true);

                    $scope.goToAsign = function() {
                        $state.go('checkoutInner');
                    }
                },
                templateUrl: "app/inspinia/components/common/content.html",
                data: {
                    specialClass: "fixed-sidebar md-skin fixed-nav pace-done pace-done pace-done"
                },
                resolve: {
                    authorize: ['Auth',
                    function (Auth) {
                            return Auth.authorize();
                    }
                ],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('checklist');
                }]
                }
            });
    }

    function intlTelInputConfig(intlTelInputOptions){
        angular.extend(intlTelInputOptions, {
            // preferredCountries: [navigator.language.split("-").pop(-1)],
            preferredCountries: ["br"],
            autoPlaceholder: true,
            // initial country
            initialCountry: "auto",
            // geoIp lookup function
            geoIpLookup: function(success, failure) {
                $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
                    var countryCode = (resp && resp.country) ? resp.country : "br";"" +
                    success(countryCode);
                });
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .constant('DOMAIN', "showkase.com.br")
        .constant('Constants', {
            ErpPartnerId: {
                VAREJO_ONLINE: 8,
                NEXAAS: 9,
                BLING: 10,
                SETA: 11,
                SOFTCOM: 12
            }
        });
        //showkase.com.br:  1927510520841177
        //tukluc.com: 106102010234151
        //showkase.online: 361048703918081
        //ShowkaseTeste: 1069039666583627

})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('showcaseApp')
        .constant('VERSION', "2.55.17")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('ADMIN_SYSTEM_ID', 0)
;
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('wati-settings', {
                parent: 'admin',
                url: '/wati-settings',
                data: {
                    authorities: [],
                    pageTitle: 'Configuração Whatsapp'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/wati/wati.html',
                        controller: 'WatiController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('store-management');
                        return $translate.refresh();
                    }]

                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('WatiService', WatiService);

    WatiService.$inject = ['WatiFactory', '$localStorage', 'WatiConstants', '$http'];

    function WatiService(WatiFactory, $localStorage, WatiConstants, $http) {

        var service = {
            create: create,
            findConfigByCurrentStore: findConfigByCurrentStore,
            getConfigByCurrentStore: getConfigByCurrentStore,
            deleteConfigByStoreId: deleteConfigByStoreId,
            update: update,
            sendMessage: sendMessage,
            findMessagesByNumber: findMessagesByNumber,
            findConversations: findConversations,
            findFileByName: findFileByName,
            findAudioFileByName: findAudioFileByName,
            findStickers: findStickers,
            makeUriToShowImageByWati: makeUriToShowImageByWati,
            makeUriToShowVideoByWati: makeUriToShowVideoByWati,
            replaceWatiToken: replaceWatiToken,
            searchTemplateMessages: searchTemplateMessages,
            searchTemplateMessagesByText: searchTemplateMessagesByText,
            getTemplateMessages: getTemplateMessages,
            sendTemplateMessage: sendTemplateMessage,
            findContact: findContact,
            sendMultipleMessages: sendMultipleMessages,
            uploadByChunk: uploadByChunk,
            getWATICredits: getWATICredits
        };

        return service;

        function create(model) {
            return WatiFactory.create(model).$promise;
        }

        function getConfigByCurrentStore() {
            return WatiFactory.findConfigByCurrentStore().$promise;
        }

        function findConfigByCurrentStore(onSuccess, onError) {
            return WatiFactory.findConfigByCurrentStore(onSuccess, onError);
        }

        function deleteConfigByStoreId(params) {
            return WatiFactory.deleteConfigByStoreId({id: params}).$promise;
        }

        function update(model) {
            return WatiFactory.update(model).$promise;
        }

        function sendMessage(message) {
            return WatiFactory.sendMessage(message).$promise;
        }

        function sendMultipleMessages(messagesList) {
            return WatiFactory.sendMultipleMessages(messagesList).$promise;
        }

        function findMessagesByNumber(params) {
            return WatiFactory.findMessagesByNumber(params).$promise;
        }

        function findConversations(filter) {
            return WatiFactory.findConversations(filter).$promise;
        }

        function findFileByName(params) {
            return WatiFactory.findFileByName(params).$promise;
        }

        function findAudioFileByName(params) {
            return WatiFactory.findAudioFileByName(params).$promise;
        }

        function findStickers(params) {
            return WatiFactory.findStickers(params).$promise;
        }

        function makeUriToShowImageByWati(watiUri, fileName, watiToken) {
            if (fileName.includes('/data')) fileName = fileName.replace('/data', 'data');
            return WatiConstants.TEMPLATE_URI_TO_SHOW_MEDIA_BY_WATI.replace('{watiUri}', watiUri).replace('{fileName}', fileName).replace('{watiToken}', replaceWatiToken(watiToken));
        }

        function makeUriToShowVideoByWati(watiUri, fileName, watiToken) {
            return WatiConstants.TEMPLATE_URI_TO_SHOW_MEDIA_BY_WATI
                .replace('{watiUri}', watiUri)
                .replace('{fileName}', fileName)
                .replace('{watiToken}', replaceWatiToken(watiToken));
        }

        function replaceWatiToken(token) {
            return token.substr(7);
        }

        function searchTemplateMessages(pageSize, pageNumber) {
            return WatiFactory.searchTemplateMessages({pageSize: pageSize, pageNumber: pageNumber}).$promise;
        }

        function getTemplateMessages() {
            return WatiFactory.getTemplateMessages().$promise;
        }

        function sendTemplateMessage(template_name, params, whatsappNumber) {
            return WatiFactory.sendTemplateMessage({template_name: template_name, parameters: params, broadcast_name: 'sk_brod_' + template_name, number: whatsappNumber}).$promise;
        }

        function findContact(id) {
            return WatiFactory.findContact({id: id}).$promise;
        }

        function uploadByChunk(data) {
            return WatiFactory.uploadByChunk(data).$promise;
        }

        function searchTemplateMessagesByText(text) {
            return WatiFactory.searchTemplateMessagesByText({ searchString: text }).$promise;
        }

        function getWATICredits() {
            return WatiFactory.getWATICredits().$promise;
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('WatiFactory', WatiFactory);

        WatiFactory.$inject = ['$resource'];

    function WatiFactory($resource) {
        var resourceWati =  'admin/api/wati';
        var resourceConfigByStore =  resourceWati + '/config/store';
        var resourceSendMessage =  resourceWati + '/send-message';
        var resourceSendAudioMessage =  resourceWati + '/send-message/audio';
        var resourceSendMultipleMessages =  resourceWati + '/send-multiple-messages';
        var resourceFindMessagesByNumber =  resourceWati + '/messages';
        var resourceFindConversations =  resourceWati + '/conversations';
        var resourceFindFileByName =  resourceWati + '/file';
        var resourceFindStickers = resourceWati + '/stickers';
        var resourceSearchTemplateMessages =  resourceWati + '/template-messages';
        var resourceSearchTemplateMessagesByText = resourceWati + '/search-template-messages';
        var resourceGetTemplateMessages =  resourceWati + '/get-template-messages';
        var resourceSendTemplateMessage =  resourceWati + '/send-template-message';
        var resourceFindContactByConversationId =  resourceWati + '/contact';
        var resourceDeleteConfigByStore = resourceWati + '/:id';
        var resourceUploadByChunk = resourceWati + '/uploadChunk/:isLastChunk';
        var resourceGetWATICredits = resourceWati + '/getWATICredits';

        return $resource(resourceWati, {}, {
            'sendMessage': {
                method: 'POST',
                url: resourceSendMessage
            },
            'sendAudioMessage': {
                method: 'POST',
                headers: {'Content-Type': undefined},
                url: resourceSendAudioMessage
            },
            'sendMultipleMessages': {
                method: 'POST',
                url: resourceSendMultipleMessages
            },
            'findContact': {
                method: 'GET',
                url: resourceFindContactByConversationId
            },
            'getWATICredits': {
                method: 'GET',
                url: resourceGetWATICredits
            },
            'uploadByChunk': {
                method: 'POST',
                url: resourceUploadByChunk
            },
            'sendTemplateMessage': {
                method: 'POST',
                url: resourceSendTemplateMessage
            },
            'findConfigByCurrentStore': {
                method: 'GET',
                url: resourceConfigByStore,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deleteConfigByStoreId':{
                method: 'DELETE',
                url: resourceDeleteConfigByStore,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'create': {
                method: 'POST',
                url: resourceWati
            },
            'update': {
                method:'PUT',
                url: resourceConfigByStore,
                cache: false,
                timeout: 20000,
                transformResponse: function (data, headers) {
                    if(data){
                        var response = {};
                        response.data = angular.fromJson(data);
                        response.headers = headers();
                        return response;
                    }
                }},
            'findMessagesByNumber': {
                method: 'GET',
                url: resourceFindMessagesByNumber,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'findConversations': {
                method: 'GET',
                url: resourceFindConversations,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'findFileByName': {
                method: 'GET',
                url: resourceFindFileByName,
                responseType: 'blob',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'findAudioFileByName': {
                method: 'GET',
                url: 'admin/api/wati/file/audio',
                headers: { 'Accept': '*/*', 'Content-Type': 'audio/wav' },
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },

            'findStickers': {
                method: 'GET',
                url: resourceFindStickers,transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'searchTemplateMessagesByText': {
                method: 'POST',
                url: resourceSearchTemplateMessagesByText,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                        response.data = angular.fromJson(response.data.result);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'searchTemplateMessages': {
                method: 'GET',
                url: resourceSearchTemplateMessages,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                        response.data = angular.fromJson(response.data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getTemplateMessages': {
                method: 'GET',
                url: resourceGetTemplateMessages,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                        response.data = angular.fromJson(response.data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('WatiController', WatiController)
        .directive('copyToClipboard', function () {
            return {
                restrict: 'A',
                link: function (scope, elem, attrs) {
                    elem.click(function () {
                        if (attrs.copyToClipboard) {
                            var $temp_input = $("<input>");
                            $("body").append($temp_input);
                            $temp_input.val(attrs.copyToClipboard).select();
                            document.execCommand("copy");
                            $temp_input.remove();
                        }
                    });
                }
            };
        });

    /** @ngInject */
    function WatiController(   $window, $state, RemoveModalFactory, $localStorage, $translate, StoreService,
                                    ShowcasesService, toastr, ModalFactory, paginationConstants, DOMAIN, $rootScope, WatiService) {

        var vm = this;

        vm.webhook = document.location.protocol + '//admin.' + document.location.hostname.split('.').slice(1).join('.') + '/admin/api/wati/hook?accessToken=' + $localStorage.authenticationToken;

        vm.watiAccountData = {};

        vm.init = function() {
            WatiService.findConfigByCurrentStore(function(response) {
                if(response.data && response.data.id) {
                    vm.watiAccountData = response.data;
                    vm.callbackRequest = updateSetting;
                } else {
                    vm.callbackRequest = saveSetting;
                }
            }, function(error) {
                console.log(error)
            });
        }


        vm.init();

        vm.saveOrUpdate = function() {
            if(!vm.watiAccountData.id) {
                saveSetting();
                return;
            }
            updateSetting();
        }

        var saveSetting = function() {
            if(!validateSetting()) return;

            vm.isSaving = true;


            vm.watiAccountData.accessToken = token;

            WatiService.create(makeBodyToRequest()).then(function(response) {
                vm.isSaving = false;
                toastr.success("Configuração criada com sucesso");
            });
        }

        var updateSetting = function() {
            if(!validateSetting()) return;

            WatiService.update(makeBodyToRequest()).then(function(response) {
                vm.isSaving = false;
                toastr.success("Configuração atualizada com sucesso");
            });
        }

        var validateSetting = function() {
            if (vm.watiAccountDataForm.$invalid) {
                toastr.warning("Campos obrigatórios não foram preenchidos");
                return false;
            }
            return true;
        }

        var makeBodyToRequest = function() {
            vm.isSaving = true;

            return angular.copy(vm.watiAccountData);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('WatiConstants', {
            TEMPLATE_URI_TO_SHOW_MEDIA_BY_WATI: '{watiUri}/api/file/showFile?fileName={fileName}&token={watiToken}',
            TEMPLATE_URI_TO_UPLOAD_CHUNK: '{watiUri}/api/v1/conversations/whatsapp/uploadChunk{isLastChunk}'
        });
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$scope', '$uibModalInstance', 'UserService', 'JhiLanguageService', 'UserProfileService', 'storeId', 'store' ,'user', 'toastr', '$translate', 'ADMIN_SYSTEM_ID', 'moment'];

    function UserManagementDialogController ($scope, $uibModalInstance, UserService, JhiLanguageService, UserProfileService, storeId, store, user, toastr, $translate, ADMIN_SYSTEM_ID, moment) {
        var format = 'L';
        var vm = this;

        vm.maskLocale = '99/99/9999';
        
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.users = findUserByEmail;
        vm.userDescription = userDescription;
        vm.storeId = storeId;
        vm.store = store;
        vm.user = user ? user.data : {};
        if (user){
            vm.user.dateOfBirth = moment(vm.user.dateOfBirth).format(format);
        }
        vm.paste = paste;
        vm.isSaving = false;
        vm.getGenderKey = getGenderKey;
        vm.initDateTimePicker = dateTimePicker;
        

        vm.hasProfileSupport = hasProfileSupport;

        loadAll();

        function loadAll() {
            JhiLanguageService.getAll().then(function (languages) {
                vm.languages = languages;
            });
            if(vm.user && vm.storeId !== ADMIN_SYSTEM_ID){
                loadUserProfiles();                
            }
            loadUserGenders();
            dateTimePicker();
        }

        function loadUserProfiles() {
            UserProfileService.getProfiles(vm.storeId).then(function (response) {
                vm.profiles = response.data;
            });
        }
        
        function loadUserGenders() {
        	UserService.listUserGendersToSelectComponent().then(function (genders) {
                vm.genders = genders;
            });
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $scope.$emit('userUpdated', result);
            toastr.success($translate.instant(result.headers['x-showcaseapp-alertkey']));
            $uibModalInstance.close(result);
        }
        
        function onUpdateSuccess (result) {
            vm.isSaving = false;
            $scope.$emit('userUpdated', result);
            toastr.success($translate.instant('userManagement.updated'));
            $uibModalInstance.close(result);
        }

        function onSaveError (error) {
            vm.isSaving = false;
            toastr.error($translate.instant(error.data.headers['x-showcaseapp-params'].concat(".").concat(error.data.headers['x-showcaseapp-error'])));
        }

        function save (form) {
            if(form.$valid){
                vm.isSaving = true;

                var userToSave = angular.copy(vm.user);
                userToSave.dateOfBirth = moment(vm.user.dateOfBirth, format).toDate();
                userToSave.domain = vm.store.nickname;
                if (userToSave.id && !vm.registeredUser) {
                    UserService.updateUser(userToSave).then(function (result) {
                        onUpdateSuccess(result);
                    }, function (error) {
                        onSaveError(error);
                    });
                } else {
                    // Se o perfil não for de administrador
                    if (vm.storeId != 0) {
                        if(!angular.isUndefined(userToSave.userProfiles[0])) {
                            var profileId =  userToSave.userProfiles[0].profileId;
                            if(vm.registeredUser){
                                UserService.addUser(userToSave.email, userToSave.phone ,profileId, vm.storeId).then(function (result) {
                                    onSaveSuccess(result);
                                }, function (error) {
                                    onSaveError(error);
                                });
                            }else {
                                userToSave.userProfiles = [];
                                userToSave.userProfiles.push({profileId: profileId, storeId: vm.storeId, isDefault: !vm.registeredUser});
                                UserService.createUser(userToSave).then(function (result) {
                                    onSaveSuccess(result);
                                }, function (error) {
                                    onSaveError(error);
                                });
                            }
                        }
                    } else {
                        if(angular.isUndefined(userToSave.userProfiles)){
                            userToSave.userProfiles = [];
                        }
                        // Perfil de administrador
                        if (userToSave.profileType === "1") {
                            userToSave.userProfiles.push({profileId: 1, storeId: 0, isDefault: true});
                        } else {
                            // Perfil de Store Manager
                            userToSave.userProfiles.push({profileId: 2});
                        }
                        UserService.createUser(userToSave).then(function (result) {
                            onSaveSuccess(result);
                        }, function (error) {
                            onSaveError(error);
                        });
                    }
                }
            }
        }
        
        $scope.$watch('vm.user.email', function(user) {
        	if(angular.isObject(user)) {
                vm.user = user;
                vm.user.dateOfBirth = moment(user.dateOfBirth).format(format);
                vm.registeredUser = true;
            }
        	else if(angular.isUndefined(user)) {
                $scope.editForm.$setPristine();
        	    // vm.user.id = null;
            	vm.registeredUser = false;
            }
        });
        
        function findUserByEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        	var mailIsValid = re.test(email);
            if(mailIsValid && vm.storeId != ADMIN_SYSTEM_ID) {
            	return UserService.findByEmail({
            		email : email
                }).then(function(response) {
                    if (response.data) {
                    	return response.data;
                    }
                    return [];
                });
            } else {
                return [];
            }
        };
        
        function userDescription(user) {
        	if (angular.isObject(user)) {
                return user.email + ' - ' + user.firstName + ' ' + user.lastName;
            }
        }
        
        function paste(e){
            e.preventDefault();
            toastr.warning($translate.instant('userManagement.enterEmail'));
            return false;
        }

        function getGenderKey(value) {
            return "userManagement".concat(".").concat(value);
        }

        function hasProfileSupport(user){
            if(user.userProfiles) {
                if(user.id && vm.storeId !== ADMIN_SYSTEM_ID){
                    //Profile id from server
                    var profileId = 9;
                    return user.userProfiles[0].profileId === profileId;     
                   }
            }
            return false;

        }

        function dateTimePicker() {
            vm.dateOfBirthOptions = {
                format: format,
                sideBySide: true,
                ignoreReadonly: true,
                locale: moment.locale(),
                allowInputToggle: true,
                showClear: true,
                widgetPositioning: {
                    horizontal: 'auto',
                    vertical: 'bottom'
                },
                maxDate: moment()
            };

            angular.element('#dateOfBirth').datetimepicker(vm.dateOfBirthOptions).on('dp.change', function(ev) {
                if (ev.date) {
                    $scope.$apply(function() {
                        vm.user.dateOfBirth = ev.date.format(format);
                    });
                } else {
                    $scope.$apply(function() {
                        vm.user.dateOfBirth = undefined;
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management',
            data: {
                authorities: ['ADMIN_MANAGE_SYSTEM'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }
        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['STORE_READ_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['STORE_READ_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/user/{login}',
            data: {
                authorities: ['STORE_READ_USER'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['$scope', '$state', 'uiGridConstants', 'uiGridBuilder', 'UserService', '$localStorage', '$uibModal'];

    function UserManagementController($scope, $state, uiGridConstants, uiGridBuilder, UserService, $localStorage, $uibModal) {
        var vm = this;
        vm.arrayPagination = [];
        vm.startRegistry = 0;
        vm.endRegistry = 0;
        vm.tableDivisor = 5;
        vm.filterFields = {};
        vm.defaultSearchIndex = 0;
        vm.checkIsFirstPage = false;
        vm.checkIsLastPage = false;
        vm.columnDefs = getColumnDefs();

        loadAll();

        function loadAll() {
            vm.gridTableOptions = getGridOptions();
        }

        function getColumnDefs() {
            return [{
                    field: 'login',
                    displayName: 'userManagement.login',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'firstName',
                    displayName: 'userManagement.firstName',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'lastName',
                    displayName: 'userManagement.lastName',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'email',
                    displayName: 'userManagement.email',
                    headerCellFilter: 'translate',
                    width: '25%'
                },
                {
                    field: 'profileName',
                    displayName: 'userManagement.profileName',
                    headerCellFilter: 'translate',
                    cellTemplate: '<span ng-repeat=\"profile in row.entity.userProfiles\" class=\"label label-info\">{{ profile.profileName }}</span>'
                }
            ];
        }

        function getGridOptions() {
            return uiGridBuilder.withDefaultOptions()
                .withActionColumn(100)
                .addActionToActionColumn("edit", "vm.getEditPage", "fa fa-edit", "text-primary", true)
                .addActionToActionColumn("delete", "vm.getDeletePage", "fa fa-trash", "text-primary", true)
                .withColumns(vm.columnDefs).build('search');
        }

        $scope.search = function() {
            var params = null;
            var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();
            UserService.listUsersByStoreId(pageable, $localStorage.defaultStore.storeId, vm.filterFields).then(function(response) {
                vm.totalItems = response.headers['x-total-count'];
                vm.gridTableOptions.virtualizationThreshold = response.data.length;
                vm.gridTableOptions.update(response.data, vm.totalItems);
                vm.gridTableOptions.getArrayPagination(function(arrayPagination) {
                    vm.arrayPagination = arrayPagination;
                });
                refreshDataInfos();
                vm.checkIsLastPage = vm.gridTableApi.pagination.getPage() === vm.gridTableApi.pagination.getTotalPages();
                vm.checkIsFirstPage = vm.gridTableApi.pagination.getPage() === 1;
                vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
            });
        }

        function createArray(range, divisor) {
            if(!divisor)divisor = 0;
            if (divisor != 0) {
                range = range / divisor;
            }
            var values = [];
            var iteratorNumber = 0;
            for (var i = 0; i < range; i++) {
                iteratorNumber = divisor != 0 ? i * divisor : i + 1;
                values.push(iteratorNumber);
            }
            return values;
        };

        function refreshDataInfos() {
            vm.gridTableApi = vm.gridTableOptions.getApiGridTable();
            vm.startRegistry = (vm.gridTableApi.pagination.getPage() * vm.gridTableOptions.paginationPageSize) - vm.gridTableOptions.paginationPageSize;
            vm.endCalc = vm.gridTableOptions.paginationPageSize * vm.gridTableApi.pagination.getPage();
            vm.endRegistry = vm.endCalc > vm.totalItems ? vm.totalItems : vm.endCalc;
        };

        vm.changePageSize = function(pageSize) {
            vm.gridTableOptions.paginationPageSize = pageSize;
        };

        vm.reloadUsers = function() {
            $scope.search();
        }

        vm.stopPropagation = function(event) {
            event.stopPropagation();
        };

        vm.changeColumnView = function($index) {
            vm.gridTableOptions.columnDefs[$index].visible = !(vm.gridTableOptions.columnDefs[$index].visible || vm.gridTableOptions.columnDefs[$index].visible === undefined);
            vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
        };

        vm.exporterTable = function(type) {
            if (type === 'pdf') {
                vm.gridTableApi.exporter.pdfExport('visible', 'visible');
            } else if (type === 'csv') {
                vm.gridTableApi.exporter.csvExport('visible', 'visible');
            }
        };

        vm.addUser = function() {
            $uibModal.open({
                templateUrl: 'app/admin/user-management/user-management-dialog.html',
                controller: 'UserManagementDialogController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    user: function() {
                        return undefined;
                    },
                    storeId: function() {
                        return $localStorage.defaultStore.storeId;
                    }
                }
            });
        }

        vm.getEditPage = function(row) {
            $uibModal.open({
                templateUrl: 'app/admin/user-management/user-management-dialog.html',
                controller: 'UserManagementDialogController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    storeId: function() {
                        return $localStorage.defaultStore.storeId;
                    },
                    user: function(UserService) {
                        return UserService.getUser({login:row.login, storeId: $localStorage.defaultStore.storeId});
                    }
                }
            });
        }

        vm.getDeletePage = function(row) {
            $uibModal.open({
                templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                controller: 'UserManagementDeleteController',
                controllerAs: 'vm',
                scope: $scope,
                size: 'md',
                resolve: {
                    storeId: function() {
                        return $localStorage.defaultStore.storeId;
                    },
                    userLogin: function() {
                        return row.login;
                    }
                }
            });
        }

        $scope.$on('userUpdated', function(event, data) {
            $scope.search();
        });

        $scope.$on('$localeChangeSuccess', function(e, locale) {
            vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
            vm.gridTableApi.grid.refresh();
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('TermOfUseController', TermOfUseController);

    function TermOfUseController($uibModalInstance, Auth, storeType, $localStorage) {
        var vm = this;
        vm.disableButtonSave = disableButtonSave;
        vm.acceptTermsMarkersChecked = false;
        vm.storeType = storeType;
        vm.hub = $localStorage.hub;

        function disableButtonSave() {
            return !vm.acceptTermsMarkersChecked;
        }

        vm.close = function () {
            $uibModalInstance.close();
        }

        vm.save = function () {
            var NEWSTATUS = true;
            Auth.acceptedTerm(NEWSTATUS)
                .then(function () {
                    vm.close();
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('TeamManagementDialogController', TeamManagementDialogController);

        TeamManagementDialogController.$inject = ['$scope', '$uibModalInstance', 'TeamService', 'UserService', 'storeId','team', 'toastr', '$translate'];

    function TeamManagementDialogController($scope, $uibModalInstance, TeamService, UserService, storeId, team, toastr, $translate) {
        var format = 'L';
        var vm = this;

        vm.maskLocale = '99/99/9999';
        
        vm.clear = clear;
        vm.save = save;
        vm.storeId = storeId;
        vm.team = team ? team : {};
        vm.isSaving = false;
        vm.users = [];
        vm.usersSelected = team && team.users ? team.users : [];

        loadAll();

        function loadAll() {
            loadUsers();
        }

        function loadUsers() {
            var pageable = {
                size: 100,
                page: 0
            };
            var params = {
                login: "",
                firstName: "",
                lastName: "",
                email: "",
                all: true
            };

            UserService.listUsersByStoreId(pageable, vm.storeId, params).then(function(response) {
                if (response.data) {
                    vm.users = response.data;
                }
            });
        }

        vm.isUserSelected = function(user) {
            return vm.usersSelected.indexOf(user.id) >= 0;
        }

        vm.selectUnselectUser = function(user) {
            var index = vm.usersSelected.indexOf(user.id);
            if (index >= 0) {
                vm.usersSelected.splice(index, 1);
            } else {
                vm.usersSelected.push(user.id)
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $scope.$emit('userUpdated', result);
            toastr.success($translate.instant('team-management.created'));
            $uibModalInstance.close(result);
        }
        
        function onUpdateSuccess(result) {
            vm.isSaving = false;
            $scope.$emit('userUpdated', result);
            toastr.success($translate.instant('team-management.updated'));
            $uibModalInstance.close(result);
        }

        function onSaveError (error) {
            vm.isSaving = false;
            if (error.data && error.data.data && error.data.data == "TEAM_NAME_DUPLICATED") {
                toastr.error($translate.instant('team-management.error.duplicatedName', { name: vm.team.name }));
            } else {
                toastr.error($translate.instant('team-management.error.save'));
            }
        }

        function save (form) {
            if (form && form.$invalid && form.teamName && form.teamName.$error && form.teamName.$error.required) {
                return;
            } else if (form && form.$invalid && form.teamName && form.teamName.$error.maxlength && form.teamName.$error.maxlength) {
                return;
            } else if (!vm.usersSelected || vm.usersSelected.length == 0) {
                toastr.error($translate.instant('team-management.error.userListEmpty'));
                return;
            }

            if(form.$valid){
                vm.isSaving = true;

                var teamToSave = angular.copy(vm.team);
                teamToSave.storeId = vm.storeId;
                teamToSave.users = vm.usersSelected;
                if (teamToSave.id) {
                    TeamService.update(teamToSave.id, teamToSave).then(function (result) {
                        onUpdateSuccess(result);
                    }, function (error) {
                        onSaveError(error);
                    });
                } else {
                    TeamService.create(teamToSave).then(function (result) {
                        onSaveSuccess(result);
                    }, function (error) {
                        console.log(error);
                        onSaveError(error);
                    });
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('team-management', {
            parent: 'entity',
            url: '/team-management',
            data: {
                authorities: ['ADMIN_MANAGE_SYSTEM'],
                pageTitle: 'showcaseApp.team.home.title'
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/team-management/team-management.html',
                    controller: 'TeamManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('team-management');
                    $translatePartialLoader.addPart('profile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('team-management.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['STORE_READ_PROFILE', 'STORE_UPDATE_PROFILE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/team-management/team-management-dialog.html',
                    controller: 'TeamDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('team-management.new', {
            parent: 'team-management',
            url: '/new',
            data: {
                authorities: ['STORE_CREATE_PROFILE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/team-management/team-management-dialog.html',
                    controller: 'TeamDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {

                    }
                }).result.then(function() {
                    $state.go('team-management', null, { reload: 'team-management' });
                }, function() {
                    $state.go('team-management');
                });
            }]
        })
        .state('team-delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['STORE_READ_PROFILE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/team-management/team-management-delete-dialog.html',
                    controller: 'TeamManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                    }
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('TeamManagementController', TeamManagementController);

    TeamManagementController.$inject = ['$scope', '$state', 'uiGridConstants', 'uiGridBuilder', 'TeamService', '$localStorage', '$uibModal'];

    function TeamManagementController($scope, $state, uiGridConstants, uiGridBuilder, TeamService, $localStorage, $uibModal) {
        var vm = this;
        vm.arrayPagination = [];
        vm.startRegistry = 0;
        vm.endRegistry = 0;
        vm.tableDivisor = 5;
        vm.filterFields = {};
        vm.defaultSearchIndex = 0;
        vm.checkIsFirstPage = false;
        vm.checkIsLastPage = false;
        vm.columnDefs = getColumnDefs();
        vm.searchTeamName = undefined;

        loadAll();

        function loadAll() {
            vm.gridTableOptions = getGridOptions();
        }

        function getColumnDefs() {
            return [{
                    field: 'Name',
                    displayName: 'team-management.name',
                    headerCellFilter: 'translate'
                }
            ];
        }

        function getGridOptions() {
            return uiGridBuilder.withDefaultOptions()
                .withActionColumn(100)
                .addActionToActionColumn("edit", "vm.getEditPage", "fa fa-edit", "text-primary", true)
                .addActionToActionColumn("delete", "vm.getDeletePage", "fa fa-trash", "text-primary", true)
                .withColumns(vm.columnDefs).build('search');
        }

        $scope.search = function() {
            var params = {
                "name": vm.searchTeamName,
                "storeId": $localStorage.defaultStore.storeId,
                "isEnabled": true
            }
            var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();

            TeamService.list(params, pageable).then(function(response) {
                if (response.data) {
                    vm.totalItems = response.data.totalElements;
                    vm.gridTableOptions.virtualizationThreshold = response.data.totalElements;
                    vm.gridTableOptions.update(response.data.content, vm.totalItems);
                    
                    vm.gridTableOptions.getArrayPagination(function(arrayPagination) {
                        vm.arrayPagination = arrayPagination;
                    });
                    refreshDataInfos();
                    vm.checkIsLastPage = vm.gridTableApi.pagination.getPage() === vm.gridTableApi.pagination.getTotalPages();
                    vm.checkIsFirstPage = vm.gridTableApi.pagination.getPage() === 1;
                    vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
                }
            });
        }

        function createArray(range, divisor) {
            if(!divisor)divisor = 0;
            if (divisor != 0) {
                range = range / divisor;
            }
            var values = [];
            var iteratorNumber = 0;
            for (var i = 0; i < range; i++) {
                iteratorNumber = divisor != 0 ? i * divisor : i + 1;
                values.push(iteratorNumber);
            }
            return values;
        };

        function refreshDataInfos() {
            vm.gridTableApi = vm.gridTableOptions.getApiGridTable();
            vm.startRegistry = (vm.gridTableApi.pagination.getPage() * vm.gridTableOptions.paginationPageSize) - vm.gridTableOptions.paginationPageSize;
            vm.endCalc = vm.gridTableOptions.paginationPageSize * vm.gridTableApi.pagination.getPage();
            vm.endRegistry = vm.endCalc > vm.totalItems ? vm.totalItems : vm.endCalc;
        };

        vm.filterField = function(valueFilter, fieldTOFilter) {
            vm.gridTableApi.grid.getColumn(fieldTOFilter).filters[0].term = valueFilter;
            vm.gridTableOptions.enableFiltering = true;
            vm.gridTableApi.grid.refresh();
        };

        vm.changePageSize = function(pageSize) {
            vm.gridTableOptions.paginationPageSize = pageSize;
        };

        vm.reloadTeams = function() {
            $scope.search();
        }

        vm.stopPropagation = function(event) {
            event.stopPropagation();
        };

        vm.changeColumnView = function($index) {
            vm.gridTableOptions.columnDefs[$index].visible = !(vm.gridTableOptions.columnDefs[$index].visible || vm.gridTableOptions.columnDefs[$index].visible === undefined);
            vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
        };

        vm.exporterTable = function(type) {
            if (type === 'pdf') {
                vm.gridTableApi.exporter.pdfExport('visible', 'visible');
            } else if (type === 'csv') {
                vm.gridTableApi.exporter.csvExport('visible', 'visible');
            }
        };

        vm.addTeam = function() {
            $uibModal.open({
                templateUrl: 'app/admin/user-management/team-management-dialog.html',
                controller: 'TeamManagementDialogController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    team: function() {
                        return undefined;
                    },
                    storeId: function() {
                        return $localStorage.defaultStore.storeId;
                    }
                }
            });
        }

        vm.getEditPage = function(row) {
            $uibModal.open({
                templateUrl: 'app/admin/user-management/team-management-dialog.html',
                controller: 'TeamManagementDialogController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    storeId: function() {
                        return $localStorage.defaultStore.storeId;
                    },
                    team: function() {
                        return row;
                    }
                }
            });
        }

        vm.getDeletePage = function(row) {
            $uibModal.open({
                templateUrl: 'app/admin/user-management/team-management-delete-dialog.html',
                controller: 'TeamManagementDeleteController',
                controllerAs: 'vm',
                scope: $scope,
                size: 'md',
                resolve: {
                    storeId: function() {
                        return $localStorage.defaultStore.storeId;
                    },
                    userLogin: function() {
                        return row;
                    }
                }
            });
        }

        $scope.$on('userUpdated', function(event, data) {
            $scope.search();
        });

        $scope.$on('$localeChangeSuccess', function(e, locale) {
            vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
            vm.gridTableApi.grid.refresh();
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('AddSalesPointManagementController', AddSalesPointManagementController);

    AddSalesPointManagementController.$inject = ['$scope', 'StoreService', 'CheckCEPService', 'GoogleMapsService', 'pointlocation', '$uibModalInstance'];

    function AddSalesPointManagementController($scope, StoreService, CheckCEPService, GoogleMapsService, pointlocation, $uibModalInstance) {
        var vm = this;

        const ICON_ACTIVE = 'content/images/pointinactive.png';

        vm.countrys = {};
        vm.states = {};
        vm.salespoint = pointlocation;
        vm.options= {
            fullscreenControl: false
        };
        vm.mainMap = {
            center: {
                latitude: (vm.salespoint != undefined ? vm.salespoint.latitude : 45),
                longitude: (vm.salespoint != undefined ? vm.salespoint.longitude : -73)
            },
            zoom: 10,
            control: {}
        };
        vm.mainMap.bounds = {};
        vm.mainMap.markers = [vm.salespoint];
        vm.mainMap.markerOptions = {
            draggable: true,
            icon: ICON_ACTIVE
        };
        vm.isNewSalesPoint = false;
        vm.mainMap.markerEvents = {
            dragend: function(marker, eventName, model) {
                vm.refreshMapWithCoordinates(marker.position.lat(), marker.position.lng());
            }
        }

        loadCountrysAndStates();
        checkIsNewSalesPoint();
        loadParams();


        function loadCountrysAndStates() {
            CheckCEPService.listStates().then(function(response) {
                vm.states = response.data;
            });
            CheckCEPService.listCountrys().then(function(response) {
                vm.countrys = response.data;
            });
            vm.showMap = true;
        }

        function checkIsNewSalesPoint() {
            if (vm.salespoint === undefined) {
                getLocation();
                vm.isNewSalesPoint = true;
                vm.salespoint = {
                    id: 2
                };
            }
        }

        vm.checkCEP = function() {
            if (vm.salespoint.pointlocation.postalCode && vm.salespoint.pointlocation.postalCode.length === 8) {
                CheckCEPService.getAddress(vm.salespoint.pointlocation.postalCode).then(function(response) {
                    if (response.data){
                    vm.salespoint.pointlocation.country = "BRASIL";
                    vm.salespoint.pointlocation.city = response.data.location.name;
                    vm.salespoint.pointlocation.state = response.data.location.uf;
                    vm.salespoint.pointlocation.address = response.data.name;
                    vm.salespoint.pointlocation.neighborhood = response.data.district.name;
                    vm.refreshMapWithAddress();
                    }
                    
                });
            }

        }

        vm.updatePointLocation = function() {
            vm.salesPointFormSubmitted = true;
            if (!vm.salesPointForm.$invalid) {
                var newPoint = vm.salespoint.pointlocation;
                newPoint.coordinate = {
                    latitude: "",
                    longitude: ""
                };
                newPoint.coordinate.latitude = vm.salespoint.latitude;
                newPoint.coordinate.longitude = vm.salespoint.longitude;
                if (vm.isNewSalesPoint) {
                    $scope.$emit('salesPointCreated', vm.salespoint);
                    $uibModalInstance.close(vm.salespoint);
                } else {
                    vm.isSaving = false;
                    StoreService.updateSalesPoint(newPoint).then(function(data, error) {
                        vm.isSaving = true;
                        $uibModalInstance.close(vm.salespoint);
                    });
                    $scope.$emit('salesPointUpdated', vm.salespoint);
                    $uibModalInstance.close(vm.salespoint);
                }
            }
        }

        vm.closeModal = function() {
            $uibModalInstance.close();
        }

        vm.refreshMapWithCoordinates = function(lat, long) {
            GoogleMapsService.getAddressByCoordinates(lat, long).then(function(data) {
                var location = data.address_components;
                vm.salespoint.pointlocation.country = location[6].long_name.toUpperCase();
                vm.salespoint.pointlocation.city = location[3].long_name;
                vm.salespoint.pointlocation.state = location[5].short_name;
                vm.salespoint.pointlocation.address = location[1].long_name;
                vm.salespoint.pointlocation.neighborhood = location[2].long_name;
            });
        }

        vm.refreshMapWithAddress = function() {
            if (vm.salespoint.pointlocation){
                GoogleMapsService.getAddress((vm.salespoint.pointlocation.number + ", " + vm.salespoint.pointlocation.address + ", " + vm.salespoint.pointlocation.neighborhood + ", " + vm.salespoint.pointlocation.city + ", " + vm.salespoint.pointlocation.state + ", " + vm.salespoint.pointlocation.country).replace(/undefined/g, '').replace(/null/g, '')).then(function(data) {
                    vm.salespoint.latitude = data.geometry.location.lat();
                    vm.salespoint.longitude = data.geometry.location.lng();
                    vm.mainMap.center.latitude = vm.salespoint.latitude;
                    vm.mainMap.center.longitude = vm.salespoint.longitude;
                });
            }
        }


        function getLocationSuccFn(position) {
            vm.mainMap.center.latitude = position.coords.latitude;
            vm.mainMap.center.longitude = position.coords.longitude;
            vm.mainMap.control.refresh({
                latitude: vm.mainMap.center.latitude,
                longitude: vm.mainMap.center.longitude
            });
        }

        function getLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(getLocationSuccFn, function(error) {}, {
                    timeout: 3000
                });
            }
        }

        function loadParams() {
            if ($scope.store){
                vm.salespoint.pointlocation = {name: $scope.store.name};
                vm.salespoint.pointlocation.contactPhone = $scope.store.contactPhone;            
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('StoreManagementNewController', StoreManagementNewController);

    StoreManagementNewController.$inject = ['$translate', '$scope', '$timeout', '$state', '$rootScope', 'StoreService', 'CategoryService', 'CheckCEPService', 'GoogleMapsService', '$q', 'toastr', '$window'];

    function StoreManagementNewController($translate, $scope, $timeout, $state, $rootScope, StoreService, CategoryService, CheckCEPService, GoogleMapsService, $q, toastr, $window) {
        var vm = this;

        const ICON_ACTIVE = 'content/images/pointinactive.png';
        const ICON_INACTIVE = 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/pointactive.png';

        vm.imageUpload = '';
        vm.domainSufix = '.' + getDomainNameSufix($window);
        vm.imageSize = 500;
        vm.imageCroppedActive = false;
        vm.imageChanged = false;
        vm.options= {
            fullscreenControl: false
        };
        vm.store = {
            image: '',
            location: {}
        };
        vm.categories = [];
        vm.showMap = false;
        vm.mainMap = {
            center: {
                latitude: 0,
                longitude: 0
            },
            zoom: 10
        };
        vm.mainMap.controls = {};
        vm.mainMap.bounds = {};
        vm.mainMap.markers = [];
        vm.lastMapKey = 0;
        vm.actualMarkerIndex = 0;
        vm.markerOptions = {};
        vm.mapLoaded = true;
        vm.markerWindow = {
            window: {}
        };
        vm.actualTab = 0;
        vm.tabsState = [{
            active: true
        }, {
            active: false
        }, {
            active: false
        }];
        vm.isSaving = false;
        vm.mainMap.window = {
            model: {},
            show: false,
            options: {
                pixelOffset: {
                    width: -1,
                    height: -20
                }
            },
            closeClick: function() {
                this.show = false;
            }
        }
        vm.mainMap.markerEvents = {
            dragend: function(marker, eventName, model) {
                vm.refreshMapWithCoordinates(marker.position.lat(), marker.position.lng());
            },
            click: function(marker, eventName, model, args) {
                if (model.options.isAdded) {
                    vm.mainMap.window.model = model;
                    vm.mainMap.window.show = true;
                }
            }
        }

        vm.initMap = function() {
            vm.showMap = true;
        }

        vm.firstZoom = true;

        $scope.$watch('vm.mainMap.zoom', function(newVal) {
            if (newVal > 16 && vm.firstZoom) {
                vm.mainMap.zoom = 16;
                vm.firstZoom = false;
            }
        });

        loadCategories();
        loadCountrysAndStates();

        function loadCountrysAndStates() {
            CheckCEPService.listStates().then(function(response) {
                vm.states = response.data;
            });
            CheckCEPService.listCountrys().then(function(response) {
                vm.countrys = response.data;
            });
            if (!vm.haveDefaultPoint) {
                vm.store.location.mainPoint = true;
            }
            navigator.geolocation.getCurrentPosition(function(position) {
                vm.mainMap.center.latitude = position.coords.latitude;
                vm.mainMap.center.longitude = position.coords.longitude;
            });
        }

        function loadCategories() {
            CategoryService.listCategories($translate.use()).then(function(response) {
                vm.categories = response.data;
            });
        }

        $scope.$on('salesPointUpdated', function(event, data) {
            vm.mainMap.window.show = false;
            var marker = vm.mainMap.markers.some(function(marker) {
                return marker.id === data.id;
            });
            vm.mainMap.markers[vm.mainMap.markers.indexOf(marker)] = data;
        });

        $scope.$on('salesPointRemoved', function(event, data) {
            if (vm.mainMap.markers.length > 1) {
                vm.mainMap.markers.splice(vm.mainMap.markers.indexOf(data), 1);
                vm.mainMap.window.show = false;
            } else {
                toastr.error($translate.instant('store-management.messages.remove.minSalesPoints'));
            }
        });

        $rootScope.$on('$translateChangeSuccess', function() {
            loadCategories();
        });

        vm.openInput = function(evt) {
            document.getElementById('fileInput').click();
        }

        vm.createStore = function(store) {
            StoreService.createStore(vm.store).then(function(data) {
                onSaveSuccess();
            });
        }

        function dataURItoBlob(dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {
                type: mimeString
            });
        }

        vm.checkCEP = function() {
            if (vm.store.location.postalCode) {
                if (vm.store.location.postalCode.length === 8) {
                    CheckCEPService.getAddress(vm.store.location.postalCode).then(function(response) {
                        var location = response.data;
                        vm.store.location.country = "BRASIL";
                        vm.store.location.city = location.location.name;
                        vm.store.location.state = location.location.uf;
                        vm.store.location.address = location.name;
                        vm.store.location.neighborhood = location.district.name;
                        vm.refreshMapWithAddress();
                    });
                }
            }
        }

        vm.refreshMapWithAddress = function(address) {
            // Checking and delete all pin marker if some information of address are empty
            if (   !vm.store.location.address 
                || !vm.store.location.neighborhood 
                || !vm.store.location.city 
                || !vm.store.location.state 
                || !vm.store.location.country){
                vm.mainMap.markers = [];
            } else {
                GoogleMapsService.getAddress((vm.store.location.number + ", " + vm.store.location.address + ", " + vm.store.location.neighborhood + ", " + vm.store.location.city + ", " + vm.store.location.state + ", " + vm.store.location.country).replace(/undefined/g, '')).then(function(data) {
                    vm.lastMapKey++;
                    if (vm.mainMap.markers.length === vm.actualMarkerIndex + 1) {
                        vm.mainMap.markers[vm.actualMarkerIndex].latitude = data.geometry.location.lat();
                        vm.mainMap.markers[vm.actualMarkerIndex].longitude = data.geometry.location.lng();
                    } else {
                        vm.mainMap.markers.push({
                            latitude: data.geometry.location.lat(),
                            longitude: data.geometry.location.lng(),
                            id: vm.lastMapKey,
                            options: {
                                draggable: true,
                                icon: ICON_ACTIVE,
                                isAdded: false
                            }
                        });
                    }
                    vm.mainMap.zoom = 15;
                });
            }
            
        }

        vm.setMarkerAsAdded = function() {
            vm.mainMap.markers[vm.actualMarkerIndex].pointlocation = {
                name: vm.store.location.name,
                address: vm.store.location.address,
                city: vm.store.location.city,
                country: vm.store.location.country,
                state: vm.store.location.state,
                contactPhone: vm.store.location.contactPhone,
                postalCode: vm.store.location.postalCode,
                number: vm.store.location.number,
                neighborhood: vm.store.location.neighborhood
            };
            vm.mainMap.markers[vm.actualMarkerIndex].options.icon = ICON_INACTIVE;
            vm.mainMap.markers[vm.actualMarkerIndex].options.draggable = false;
            vm.mainMap.markers[vm.actualMarkerIndex].options.isAdded = true
            vm.store.location = {
                address: "",
                city: "",
                country: "",
                neighborhood: "",
                state: "",
                number: "",
                postalCode: "",
                name: ""
            };
            vm.actualMarkerIndex++;
            vm.locationStoreForm.$setPristine();
            vm.locationStoreForm.$setUntouched();
            toastr.success($translate.instant('store-management.messages.salespoint.create.success'));
        }

        vm.refreshMapWithCoordinates = function(lat, long) {
            GoogleMapsService.getAddressByCoordinates(lat, long).then(function(data) {
                var location = data.address_components;
                vm.store.location.country = location[6].long_name.toUpperCase();
                vm.store.location.city = location[3].long_name;
                vm.store.location.state = location[5].short_name;
                vm.store.location.address = location[1].long_name;
                vm.store.location.neighborhood = location[2].long_name;
                vm.store.location.number = location[0].long_name;
            });
        };

        var handleFileSelect = function(evt) {
            var file = evt.currentTarget.files[0];
            var reader = new FileReader();
            reader.onload = function(evt) {
                $scope.$apply(function($scope) {
                    vm.imageUpload = evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        };

        vm.initTabLogoNewStore = function () {
            angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
        };

        vm.activeImageCrop = function() {
            vm.imageCroppedActive = false;
            vm.imageCroppedActive = true;
        };

        vm.saveStore = function() {
            vm.saveSubmit = true;
            if (!vm.actualMarkerIndex <= 0) {
                vm.store.points = [];
                var point = {};
                vm.mainMap.markers.forEach(function(marker) {
                    point = marker.pointlocation;
                    point.coordinate = {
                        latitude: "",
                        longitude: ""
                    };
                    point.coordinate.latitude = marker.latitude;
                    point.coordinate.longitude = marker.longitude;
                    vm.store.points.push(point);
                });
                // Define o CNPJ como null caso ele n�o tenha sido realmente informado para evitar erro de valida��o no back-end
                vm.store.cnpj = vm.store.cnpj ? vm.store.cnpj : null;
                $q.all(vm.store.points).then(function(data) {
                    vm.store.logo = vm.imageChanged ? vm.store.image : '';
                    vm.isSaving = true;
                    StoreService.saveStoreImage(dataURItoBlob(vm.store.logo)).then(function (response, error) {
                      vm.store.addImageFileDTO = response.data;
                      vm.store.logo = '', vm.store.image = '';
                      StoreService.addStore(vm.store).then(function(data, error) {
                          vm.isSaving = false;
                          $state.go('store-management');
                          $rootScope.$broadcast('storeChangeSuccess');
                          toastr.success($translate.instant('store-management.messages.create.success'));
                      }, function(data) {
                          vm.isSaving = false;
                          toastr.error($translate.instant('store-management.messages.create.error'));
                      });
                    });
                });
            }
        }

        vm.verifyNicknameIsAvailable = function(form) {
            if (vm.store.nickname) {
                StoreService.verifyIfNicknameAvailable(vm.store.nickname).then(function(result) {
                    if (!result.data) {
                        form.nickname.$setValidity('nicknameIsUnavailable', false);
                    } else {
                        form.nickname.$setValidity('nicknameIsUnavailable', true);
                    }
                }, function(error) {
                    form.nickname.$setValidity('nicknameIsUnavailable', false);
                });
            } else {
                form.nickname.$setValidity('nicknameIsUnavailable', true);
            }
        }

        vm.changeToTab = function(tab) {
            if (tab === 2) {
              if (!vm.store.image) {
                toastr.error($translate.instant('store-management.messages.create.imageError'));
              } else {
                $timeout(function() {
                    vm.showMap = true;
                }, 150);
                getLocation();
                vm.tabsState[tab].active = true;
                vm.actualTab = tab;
              }
            }
            if (tab === 1) {
                vm.imageCroppedActive = true;
                vm.storesInfoSubmitted = true;
                if (!vm.storeInfosForm.$invalid) {
                    vm.tabsState[tab].active = true;
                    vm.actualTab = tab;
                }
            } else {
                vm.imageCroppedActive = false;
            }
        }

        vm.checkIfIsFlyersPage = function() {
            return (vm.currentState === 'flyers-detail');
        }

        function getLocationSuccFn(position) {
            vm.mainMap.center.latitude = position.coords.latitude;
            vm.mainMap.center.longitude = position.coords.longitude;
            vm.mainMap.controls.refresh({
                latitude: vm.mainMap.center.latitude,
                longitude: vm.mainMap.center.longitude
            });
        }

        function getLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(getLocationSuccFn, function(error) {}, {
                    timeout: 1000
                });
            }
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('StoreMarkerController', StoreMarkerController);

    StoreMarkerController.$inject = ['$uibModal', '$scope', '$state'];

    function StoreMarkerController($uibModal, $scope, $state) {
        var vm = this;

        vm.currentState = $state.current.name;

        vm.addSalesPoint = function() {
            $uibModal.open({
                templateUrl: 'app/admin/store-management/store-management-newsalespoint.html',
                controller: 'AddSalesPointManagementController',
                controllerAs: 'vm',
                backdrop: 'static',
                scope: $scope,
                size: 'lg',
                resolve: {
                    pointlocation: function() {
                        return angular.copy($scope.parameter);
                    }
                }
            }).result.then(function(data) {
                if (data) {
                    $scope.parameter = data;
                }
            });
        }

        vm.checkIfIsFlyersPage = function() {
            return (vm.currentState === 'flyers-detail');
        }

        vm.removeSalesPoint = function() {
            $scope.$emit('salesPointRemoved', $scope.parameter);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('StoreManagementEditImageController', StoreManagementEditImageController);

    StoreManagementEditImageController.$inject = ['$rootScope', '$scope', 'StoreService', '$uibModalInstance', 'store', 'toastr', '$translate'];

    function StoreManagementEditImageController($rootScope, $scope, StoreService, $uibModalInstance, store, toastr, $translate) {
        var vm = this;
        vm.store = store;

        vm.imageUpload = '';
        vm.croppedImage = '';
        vm.imageSize = 500;
        vm.imageCroppedActive = false;

        var handleFileSelect = function(evt) {
           var file = evt.currentTarget.files[0];
           var reader = new FileReader();
           reader.onload = function (evt) {
             $scope.$apply(function($scope){
               vm.imageUpload = evt.target.result;
               vm.imageCroppedActive = true;
             });
           };
           reader.readAsDataURL(file);
        };

       vm.openInput = function(evt) {
           document.getElementById('fileInput').click();
       }

       vm.closeModal = function() {
           $uibModalStack.dismissAll();
       }

       vm.save = function() {
           if(!vm.croppedImage) {
            toastr.error($translate.instant('store-management.messages.update.missing-img'));
           } else {
             vm.isSaving = true;
             StoreService.saveStoreImage(dataURItoBlob(vm.croppedImage)).then(function (response, error) {
              vm.store.addImageFileDTO = response.data;
               StoreService.updateStore(vm.store).then(function (data) {
                   $rootScope.$broadcast('storeChangeSuccess');
                   vm.isSaving = false;
                   $uibModalInstance.close(data);
               });
             });
           }
       }

       vm.closeModal = function() {
           $uibModalInstance.close();
       }

       vm.initModal = function() {
            angular.element(document.querySelector('#fileInput')).on('change',handleFileSelect);
            // vm.imageUpload = vm.store.logo;
       }

       function dataURItoBlob(dataURI) {
           // convert base64/URLEncoded data component to raw binary data held in a string
           var byteString;
           if (dataURI.split(',')[0].indexOf('base64') >= 0)
               byteString = atob(dataURI.split(',')[1]);
           else
               byteString = unescape(dataURI.split(',')[1]);

           // separate out the mime component
           var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

           // write the bytes of the string to a typed array
           var ia = new Uint8Array(byteString.length);
           for (var i = 0; i < byteString.length; i++) {
               ia[i] = byteString.charCodeAt(i);
           }

           return new Blob([ia], {
               type: mimeString
           });
       }

    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('StoreManagementEditController', StoreManagementEditController);

    StoreManagementEditController.$inject = ['$scope', '$rootScope', '$translate', 'StoreService', '$uibModalInstance', 'CategoryService', 'store', 'toastr', '$window', 'isStep'];

    function StoreManagementEditController($scope, $rootScope, $translate, StoreService, $uibModalInstance, CategoryService, store, toastr, $window, isStep) {

        var vm = this;
        vm.store = store;
        console.log(vm.store);
        vm.store.originNickname = vm.store.nickname;
        vm.isSaving = false;
        vm.imageUpload = '';
        vm.croppedImage = '';
        vm.imageSize = 800;
        vm.imageCroppedActive = false;
        vm.domainSufix = undefined;
        vm.currencyList = getCurrencyListConfiguration();

        vm.isMobile = detectar_mobile();

        vm.imagesErrors = {
            fileInputPublicLogo: false,
            fileInputFavicon: false,
            fileInputLogo: false
        };

        if (vm.store.social == null) {
            vm.store.social = { whatsApp: vm.store.contactPhone };
        }

        // if (!vm.store.currency) {
        //     vm.store.currency = 'REAL';
        // }

        // holds the number of installment to be applied
        vm.installment = [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

        vm.publicLogoImage = null;
        vm.faviconImage = null;
        vm.logoImage = null;
        vm.idSelectInput = '';
        vm.widthImage = null;
        vm.heightImage = null;

        loadAll();

        function loadAll() {
            CategoryService.listCategories($translate.use()).then(function (response) {
                vm.categories = response.data;
                if (isStep) {
                    vm.tab = 1;
                }
            });
            vm.domainSufix = '.' + getDomainNameSufix($window, vm.store.storeType);

            instanceImages();
        }

        function instanceImages() {
            var srcImagePublicLogo = vm.store.publicLogo;
            if (srcImagePublicLogo && srcImagePublicLogo.split(',')[0].indexOf('base64') == -1) {
                vm.publicLogoImage = vm.store.publicLogo + '?dummy=' + new Date().getTime();
            }

            var srcImageFavicon = vm.store.favicon;
            if (srcImageFavicon && srcImageFavicon.split(',')[0].indexOf('base64') == -1) {
                vm.faviconImage = vm.store.favicon + '?dummy=' + new Date().getTime();
            }

            var srcImageLogo = vm.store.storeLogo;
            if (srcImageLogo && srcImageLogo.split(',')[0].indexOf('base64') == -1) {
                vm.logoImage = vm.store.storeLogo + '?dummy=' + new Date().getTime();
            }
        }

        vm.checkInstallmentNoFee = function () {
            vm.store.installment < vm.store.installmentNoFee ? vm.store.installmentNoFee = 0 : '';
        };

        vm.allowInstallmentListner = function () {
            if (!vm.allowInstallment) {
                vm.store.installmentNoFee = 0;
                vm.store.installment = 0
            }
        };

        function savePublicLogo() {
            if (vm.publicLogoImage && vm.publicLogoImage != vm.store.publicLogo) {
                StoreService.saveStoreImage(dataURItoBlob(vm.publicLogoImage)).then(function (response, error) {
                    vm.store.publicLogoImage = response.data;
                });
            } else if (!vm.publicLogoImage) {
                vm.store.publicLogo = null;
            }
        }

        function saveLogo() {
            if (vm.logoImage && vm.logoImage !== vm.store.logo) {
                StoreService.saveStoreImage(dataURItoBlob(vm.logoImage)).then(function (response, error) {
                    vm.store.addImageFileDTO = response.data;
                });
            } else if (!vm.logoImage) {
                vm.store.logo = null;
            }
        }

        function saveFavicon() {
            if (vm.faviconImage && vm.faviconImage !== vm.store.favicon) {
                StoreService.saveStoreImage(dataURItoBlob(vm.faviconImage)).then(function (response, error) {
                    vm.store.faviconImageFileDTO = response.data;
                });
            } else if (!vm.faviconImage) {
                vm.store.favicon = null;
            }
        }

        function dataURItoBlob(dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {
                type: mimeString
            });
        }

        vm.save = function () {
            if (!vm.storeEditForm.$invalid) {
                var category = vm.categories.filter(function (category) {
                    return category.key === vm.store.categoryKey;
                });
                vm.store.categoryId = category[0].id;
                vm.isSaving = true;
                vm.store.cnpj = (angular.isDefined(vm.store.cnpj) && vm.store.cnpj !== "") ? vm.store.cnpj : undefined;
                if (vm.store.seo) {
                    vm.store.seo.title = vm.store.seo.title === "" ? undefined : vm.store.seo.title;
                    vm.store.seo.description = vm.store.seo.description === "" ? undefined : vm.store.seo.description;
                }
                var storeToSave = angular.copy(vm.store);

                if (storeToSave.social) {
                    storeToSave.social.instagram = splitAbsoluteUrl("instagram.com/", storeToSave.social.instagram);
                    storeToSave.social.facebook = splitAbsoluteUrl("facebook.com/", storeToSave.social.facebook);
                    storeToSave.social.twitter = splitAbsoluteUrl("twitter.com/", storeToSave.social.twitter);
                    storeToSave.social.tiktok = splitAbsoluteUrl("tiktok.com/@", storeToSave.social.tiktok);
                }

                StoreService.updateStore(storeToSave).then(function (data) {
                    vm.store = data;
                    $rootScope.$broadcast('storeChangeSuccess');
                    toastr.success($translate.instant('store-management.messages.update.success'));
                    vm.isSaving = false;
                    $uibModalInstance.close(data);
                }, function (error) {
                    vm.isSaving = false;
                    toastr.error($translate.instant('store-management.messages.update.error'));
                });
            }
        }

        function splitAbsoluteUrl(url, value) {
            if (value) {
                if (value.includes(url)) {
                    return value.split(url)[1];
                }
            }
            return value;
        }

        $scope.$watch('vm.store.nickname', function (newVal, oldVal) {
            if (newVal && newVal.length >= 20) {
                vm.store.nickname = oldVal;
            }
        });

        vm.closeModal = function () {
            $uibModalInstance.close();
        }

        vm.openInput = function (evt, id, width, height) {
            vm.idSelectInput = id;
            vm.widthImage = Number(width);
            vm.heightImage = Number(height);
            document.getElementById(id).click();
            angular.element(document.querySelector('#' + id)).on('change', validateImageWidth);
        }

        var validateImageWidth = function (event) {
            var input = document.getElementById(vm.idSelectInput);

            if (input.files && input.files[0]) {

                var imagem = new Image();
                imagem.src = window.URL.createObjectURL(input.files[0]);

                imagem.onload = function () {
                    if (this.width != vm.widthImage || this.height != vm.heightImage) {
                        input = null
                        toastr.error($translate.instant('store-management.tab.imageError'));
                        vm.imagesErrors[vm.idSelectInput] = true;
                    } else {
                        vm.imagesErrors[vm.idSelectInput] = false;
                        handleFileSelect(event);
                    }
                };
            }
        };

        var handleFileSelect = function (event) {
            var file = event.target.files[0];
            if (file) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    var img = document.createElement("img");
                    img.onload = function (evt) {
                        var canvas = document.createElement("canvas");
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);

                        var MAX_WIDTH = vm.widthImage;
                        var MAX_HEIGHT = vm.heightImage;
                        canvas.width = MAX_WIDTH;
                        canvas.height = MAX_HEIGHT;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0, MAX_WIDTH, MAX_HEIGHT);

                        var dataurl = canvas.toDataURL(file.type);

                        if (vm.idSelectInput === 'fileInputPublicLogo') {
                            vm.publicLogoImage = dataurl;
                            savePublicLogo();
                        } else if (vm.idSelectInput === 'fileInputFavicon') {
                            vm.faviconImage = dataurl;
                            saveFavicon();
                        } else if (vm.idSelectInput === 'fileInputLogo') {
                            vm.logoImage = dataurl;
                            saveLogo();
                        }

                        var output = document.getElementById('img' + vm.idSelectInput);
                        output.src = dataurl;
                    }
                    img.src = reader.result;

                };
                reader.readAsDataURL(file);
            }
        };

        vm.verifyNicknameIsAvailable = function (form) {
            if (vm.store.nickname && (vm.store.nickname != vm.store.originNickname)) {
                StoreService.verifyIfNicknameAvailable(vm.store.nickname).then(function (result) {
                    if (!result.data) {
                        form.nickname.$setValidity('nicknameIsUnavailable', false);
                    } else {
                        form.nickname.$setValidity('nicknameIsUnavailable', true);
                    }
                }, function (error) {
                    form.nickname.$setValidity('nicknameIsUnavailable', false);
                });
            } else {
                form.nickname.$setValidity('nicknameIsUnavailable', true);
            }
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('StoreManagementDetailController', StoreManagementDetailController)
        .directive('onErrorSrc', function () {
            return {
                link: function (scope, element, attrs) {
                    element.bind('error', function () {
                        if (attrs.src != attrs.onErrorSrc) {
                            attrs.$set('src', attrs.onErrorSrc);
                        }
                    });
                }
            }
        });

    StoreManagementDetailController.$inject = ['$scope', '$rootScope', '$localStorage', 'FlyersService', '$state', 
        '$timeout', 'uiGridConstants', 'uiGridBuilder', '$translate', '$stateParams', 'StoreService', '$uibModal', '$q', 
        'CategoryService', 'UserService', 'UserProfileService', 'toastr', 'RemoveModalFactory', 'TeamService', 'ModalFactory'];

    function StoreManagementDetailController($scope, $rootScope, $localStorage, FlyersService, $state, 
        $timeout, uiGridConstants, uiGridBuilder, $translate, $stateParams, StoreService, $uibModal, $q, 
        CategoryService, UserService, UserProfileService, toastr, RemoveModalFactory, TeamService, ModalFactory) {
        var vm = this;

        vm.mainMap = {
            center: {
                latitude: 0,
                longitude: 0
            },
            zoom: 1
        };
        vm.mainMap.controls = {};
        vm.mainMap.bounds = {};
        vm.mainMap.markers = [];
        vm.options= {
            fullscreenControl: false
        };
        vm.mainMap.window = {
            model: {},
            show: false,
            options: {
                pixelOffset: {
                    width: -1,
                    height: -20
                }
            },
            closeClick: function() {
                this.show = false;
            }
        };
        vm.usersTable = false;
        vm.profilesTable = false;
        vm.mainMap.markerEvents = {
            click: function(marker, eventName, model, args) {
                $uibModal.open({
                    templateUrl: 'app/admin/store-management/store-management-newsalespoint.html',
                    controller: 'AddSalesPointManagementController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    scope: $scope,
                    size: 'lg',
                    resolve: {
                        pointlocation: function() {
                            return angular.copy(model);
                        }
                    }
                }).result.then(function(data) {
                    if (data) {
                        // $scope.parameter = data;
                    }
                });
                vm.mainMap.window.model = model;
                vm.mainMap.window.show = true;
            }
        };

        vm.tabType = "Users";
        vm.isLoading = true;
        vm.showMap = false;
        vm.showTable = false;
        vm.defaultSearchIndex = 0;
        vm.tableDivisor = 5;
        vm.columnDefs = getColumnDefsUsers();
        vm.filterFields = {};

        loadAll();

        const ICON_ACTIVE = 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/pointactive.png';

        function loadAll() {
            StoreService.getStore($stateParams.id).then(function(response) {
                vm.store = response.data;
                vm.store.image = vm.loadStoreImage(vm.store.storeLogo);
                vm.imagePath = "/admin/api/" + vm.store.id + "/store";
                getCategoryName();
                loadNumberOfFlyers();
                convertToMarkers(vm.store.points);
                vm.gridTableOptions = getGridOptions();
                vm.usersTable = true;
                vm.isLoading = false;

                if ($stateParams.fromStep) {
                    vm.getEditStorePage(true)
                }
            });
        }

        function convertToMarkers(points) {
            console.log('convertToMarkers>>> ', points);
            vm.store.points.forEach(function(point) {
            
                vm.mainMap.markers.push({
                    pointlocation: {
                        name: point.name,
                        country: point.country,
                        state: point.state,
                        neighborhood: point.neighborhood,
                        number: point.number,
                        address: point.address,
                        city: point.city,
                        id: point.id,
                        mainPoint: point.mainPoint,
                        postalCode: point.postalCode,
                        contactPhone: point.contactPhone,
                        storeId: vm.store.id
                    },
                    latitude: point.coordinate.latitude,
                    longitude: point.coordinate.longitude,
                    id: point.id,
                    options: {
                        icon: ICON_ACTIVE
                    }
                });
            });
            $timeout(function() {
                vm.showMap = true;
            }, 2000);
        }

        vm.reloadUsers = function() {
            $scope.search();
        }

        $scope.search = function() {
            if (vm.tabType === "Users") {
                vm.changeTableToUsers();
            } else if (vm.tabType === "Profiles") {
                vm.changeTableToProfile();
            } else if (vm.tabType === "Teams") {
                vm.changeTableToTeam();
            }
        }

        $scope.$on('salesPointUpdated', function(event, salesPoint) {
            updateSalesPoint(salesPoint);

        });

        $scope.$on('salesPointCreated', function(event, salesPoint) {
            createSalesPoint(salesPoint);
        });

        $scope.$on('salesPointRemoved', function(event, salesPoint) {
            if (vm.mainMap.markers.length > 1) {
                RemoveModalFactory.deleteItem(1).then(function() {
                    StoreService.deleteSalesPoint(salesPoint.id).then(function() {
                        vm.mainMap.markers.splice(vm.mainMap.markers.indexOf(salesPoint), 1);
                        vm.mainMap.window.show = false;
                    });
                });
            } else {
                toastr.error($translate.instant('store-management.messages.remove.minSalesPoints'));
            }
        });


        $scope.$on('userUpdated', function(event, data) {
            $scope.search();
        });

        vm.firstZoom = true;

        $scope.$watch('vm.mainMap.zoom', function(newVal) {
            if (newVal > 16 && vm.firstZoom) {
                vm.mainMap.zoom = 16;
                vm.firstZoom = false;
            }
        });

        vm.loadStoreImage = function(image) {
          var random = new Date().getTime();
          return (image + '?r=' + random);
        }

        vm.addSalesPoint = function() {
            $uibModal.open({
                templateUrl: 'app/admin/store-management/store-management-newsalespoint.html',
                controller: 'AddSalesPointManagementController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    pointlocation: function() {
                        return $scope.parameter;
                    },
                    pointparent: function() {
                        return $scope.$parent.vm;
                    }
                }
            });
        }

        function findAndReplaceUpdatedSalePoint(sp){
            var found = false;

            for (var i = 0; i < vm.mainMap.markers.length; i++){
                if (vm.mainMap.markers[i].id == sp.id){
                    vm.mainMap.markers[i] = sp;
                    found = true;
                }
                if (found){
                    return;
                }
            }

            vm.mainMap.markers.push(sp);
        }

        function createSalesPoint(point) {
            var newPoint = point.pointlocation;
            newPoint.storeId = vm.store.id;
            newPoint.coordinate = {
                latitude: "",
                longitude: ""
            };
            newPoint.coordinate.latitude = point.latitude;
            newPoint.coordinate.longitude = point.longitude;
            StoreService.createSalesPoint(newPoint).then(function(data) {
                vm.mainMap.window.show = false;
                point.options = {
                    icon: ICON_ACTIVE
                };
                point.pointlocation.id = data.id;
                point.id = data.id;
                vm.mainMap.markers.push(point);
                toastr.success($translate.instant('store-management.messages.salespoint.create.success'));
            }, function(data) {
                toastr.success($translate.instant('store-management.messages.salespoint.create.error'));
            });
        }

        function updateSalesPoint(point) {
            var newPoint = point.pointlocation;
            newPoint.storeId = vm.store.id;
            newPoint.coordinate = {
                latitude: "",
                longitude: ""
            };
            newPoint.coordinate.latitude = point.latitude;
            newPoint.coordinate.longitude = point.longitude;
            StoreService.updateSalesPoint(newPoint).then(function(data, error) {
                vm.mainMap.window.show = false;
                findAndReplaceUpdatedSalePoint(point);
                toastr.success($translate.instant('store-management.messages.salespoint.update.success'));
            }, function(data) {
                toastr.error($translate.instant('store-management.messages.salespoint.update.error'));
            });
        }

        function updateStore() {
            vm.store.points = [];
            var point = {};
            vm.mainMap.markers.forEach(function(marker) {
                point = marker.pointlocation;
                point.coordinate = {
                    latitude: "",
                    longitude: ""
                };
                point.coordinate.latitude = marker.latitude;
                point.coordinate.longitude = marker.longitude;
                vm.store.points.push(point);
            });
            $q.all(vm.store.points).then(function(data) {
                StoreService.updateStore(vm.store).then(function(data, error) {
                    toastr.success($translate.instant('store-management.messages.update.success'));
                }, function(data) {
                    toastr.error($translate.instant('store-management.messages.update.error'));
                });
            });
        }

        $rootScope.$on('$translateChangeSuccess', function() {
            getCategoryName();
        });

        function getCategoryName() {
            if (vm.store && vm.store.categoryKey ) {
                CategoryService.getCategoryTitleByKey(vm.store.categoryKey, $translate.use()).then(function(response) {
                    vm.store.categoryName = response.data;
                });
            }
        }

        function loadNumberOfFlyers() {
            FlyersService.getNumberOfFlyers(vm.store.id, $translate.use()).then(function(response) {
                vm.store.numberOfFlyers = response.data;
            });
        }

        function getColumnDefsUsers() {
            var testCellTemplate = '';
            return [{
                    field: 'login',
                    displayName: 'userManagement.login',
                    headerCellFilter: 'translate',
                    filtered: false
                },
                {
                    field: 'firstName',
                    displayName: 'userManagement.firstName',
                    headerCellFilter: 'translate',
                    filtered: false
                },
                {
                    field: 'lastName',
                    displayName: 'userManagement.lastName',
                    headerCellFilter: 'translate',
                    filtered: false
                },
                {
                    field: 'email',
                    displayName: 'userManagement.email',
                    headerCellFilter: 'translate',
                    width: '25%',
                    filtered: false
                },
                {
                    field: 'profileName',
                    displayName: 'userManagement.profileName',
                    headerCellFilter: 'translate',
                    cellTemplate: '<span ng-repeat=\"profile in row.entity.userProfiles\" class=\"label label-info\">{{ profile.profileName }}</span>'
                }
            ];
        }

        function getColumnDefsProfiles() {
            return [{
                field: 'name',
                displayName: 'showcaseApp.profile.name',
                headerCellFilter: 'translate'
            }];
        }

        function getColumnDefsTeams() {
            return [{
                field: 'name',
                displayName: 'showcaseApp.team.name',
                headerCellFilter: 'translate'
            }];
        }

        function getGridOptions() {
            return uiGridBuilder.withDefaultOptions()
                .withActionColumn(100)
                .addActionToActionColumn(
                    $translate.instant('store-management.tooltip.edit'), 
                    "vm.getEditPage", 
                    "fa fa-edit", 
                    "text-primary", 
                    true, 
                    "row.entity.disabledAction"
                )
                .addActionToActionColumn(
                    $translate.instant('store-management.tooltip.delete'), 
                    "vm.getDeletePage", 
                    "fa fa-trash", 
                    "text-primary", 
                    "grid.appScope.vm.isDeleteActionEnabled(row.entity)", 
                    "row.entity.disabledAction"
                )
                .withColumns(vm.columnDefs).build('search');
        }

        function refreshDataInfos() {
            vm.gridTableApi = vm.gridTableOptions.getApiGridTable();
            vm.startRegistry = (vm.gridTableApi.pagination.getPage() * vm.gridTableOptions.paginationPageSize) - vm.gridTableOptions.paginationPageSize;
            vm.endCalc = vm.gridTableOptions.paginationPageSize * vm.gridTableApi.pagination.getPage();
            vm.endRegistry = vm.endCalc > vm.totalItems ? vm.totalItems : vm.endCalc;
        }

        vm.addTeamStore = function() {
            $uibModal.open({
                templateUrl: 'app/admin/team-management/team-management-dialog.html',
                controller: 'TeamManagementDialogController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    team: function() {
                        return undefined;
                    },
                    storeId: function() {
                        return vm.store.id;
                    }
                }
            });
        }
        
        vm.addUserStore = function() {
            $uibModal.open({
                templateUrl: 'app/admin/user-management/user-management-dialog.html',
                controller: 'UserManagementDialogController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    user: function() {
                        return undefined;
                    },
                    storeId: function() {
                        return vm.store.id;
                    },
                    store: function() {
                        return angular.copy(vm.store);
                    },
                }
            });
        }

        vm.getEditPage = function(row) {
            if (vm.tabType === "Users") {
                vm.getEditPageUsers(row);
            } else if (vm.tabType === "Profiles") {
                vm.getEditPageProfiles(row);
            } else if (vm.tabType === "Teams") {
                vm.getEditPageTeam(row);
            }
        }

        vm.getDeletePage = function(row) {
            if (vm.tabType === "Users") {
                vm.getDeletePageUsers(row);
            } else if (vm.tabType === "Profiles") {
                vm.getDeletePageProfiles(row);
            } else if (vm.tabType === "Teams") {
                vm.getDeletePageTeam(row);
            }
        }

        vm.isDeleteActionEnabled = function(row) {
            if (vm.tabType === "Teams") {
                return row.type !== 'DEFAULT'
            } else {
                return true;
            }
        }

        vm.getEditPageUsers = function(row) {
            $uibModal.open({
                templateUrl: 'app/admin/user-management/user-management-dialog.html',
                controller: 'UserManagementDialogController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    storeId: function(){
                        return vm.store.id;
                    },
                    store: function() {
                        return angular.copy(vm.store);
                    },
                    user: function(UserService) {
                        return UserService.getUser({login:row.login, storeId: vm.store.id});
                    }
                }
            });
        }

        vm.getEditPageTeam = function(row) {
            $uibModal.open({
                templateUrl: 'app/admin/team-management/team-management-dialog.html',
                controller: 'TeamManagementDialogController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    storeId: function(){
                        return vm.store.id;
                    },
                    team: function() {
                        return row;
                    }
                }
            });
        }

        vm.getDeletePageTeam = function(team) {
            var remove = function() {
                TeamService.remove(team.id).then(function () {
                    toastr.success($translate.instant('team-management.deleted'));
                    $scope.$emit('userUpdated');
                });
            };
            ModalFactory.openWarningModal($translate.instant('team-management.delete-modal.title'),
                        $translate.instant('team-management.delete-modal.subtitle', { team: team.name }),
                        $translate.instant('team-management.delete-modal.small-text'),
                        null,
                        $translate.instant('team-management.delete-modal.confirm-button'),
                        $translate.instant('team-management.delete-modal.cancel-button'),
                        remove
                    );
        }

        vm.getDeletePageUsers = function(user) {
            var remove = function() {
                UserService.deleteUser({login: user.login, storeId: vm.store.id}).then(function (data) {
                    toastr.success($translate.instant('userManagement.deleted'));
                    $scope.$emit('userUpdated', data);
                });
            };
            ModalFactory.openWarningModal($translate.instant('userManagement.delete-modal.title'),
                        $translate.instant('userManagement.delete-modal.subtitle', { login: user.login }),
                        $translate.instant('userManagement.delete-modal.small-text'),
                        null,
                        $translate.instant('userManagement.delete-modal.confirm-button'),
                        $translate.instant('userManagement.delete-modal.cancel-button'),
                        remove
                    );
        }

        vm.getEditPageProfiles = function(row) {
            if(!row.disabledAction){
                $state.go('store-profile-detail', {
                    storeId: vm.store.id,
                    id: row.id
                });
            }
        }

        vm.getDeletePageProfiles = function(profile) {
            if(!profile.disabledAction){
                var remove = function() {
                    UserProfileService.deleteProfile(profile.id, vm.store.id).then(function(data) {
                        toastr.success($translate.instant('showcaseApp.profile.messages.remove.success'));
                        $scope.$emit('userUpdated', data);
                    }, function() {
                        toastr.error($translate.instant('showcaseApp.profile.messages.remove.error'));
                    });
                };
                ModalFactory.openWarningModal($translate.instant('showcaseApp.profile.delete-modal.title'),
                            $translate.instant('showcaseApp.profile.delete-modal.subtitle', { name: profile.name }),
                            $translate.instant('showcaseApp.profile.delete-modal.small-text'),
                            null,
                            $translate.instant('showcaseApp.profile.delete-modal.confirm-button'),
                            $translate.instant('showcaseApp.profile.delete-modal.cancel-button'),
                            remove
                        );
            }
        }

        vm.getEditStorePage = function(isStep) {
            $uibModal.open({
                templateUrl: 'app/admin/store-management/store-management-edit.html',
                controller: 'StoreManagementEditController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    store: function() {
                        return angular.copy(vm.store);
                    },
                    isStep: isStep
                }
            }).result.then(function(data) {
                if (data) {
                    vm.store = data;
                    loadNumberOfFlyers();
                }
            });
        }

        vm.getEditStoreImagePage = function() {

            $uibModal.open({
                templateUrl: 'app/admin/store-management/store-management-edit-image.html',
                controller: 'StoreManagementEditImageController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    store: function() {
                        return angular.copy(vm.store);
                    }
                }
            }).result.then(function(data) {
                vm.store.image = null;
                if (data) {
                    vm.store = data;
                    toastr.success($translate.instant('store-management.messages.update.success'));
                    $timeout(function() {
                        vm.store.image = vm.loadStoreImage(vm.store.storeLogo);
                    }, 4000);
                    loadNumberOfFlyers();
                }
            });
        }

        vm.changeTab = function(type) {
            if (type === "Users") {
                vm.columnDefs = getColumnDefsUsers();
                vm.usersTable = true;
                vm.profilesTable = false;
                vm.teamsTable = false;
            } else if (type === "Profiles") {
                vm.columnDefs = getColumnDefsProfiles();
                vm.usersTable = false;
                vm.profilesTable = true;
                vm.teamsTable = false;
            } else if (type === "Teams") {
                vm.columnDefs = getColumnDefsTeams();
                vm.usersTable = false;
                vm.profilesTable = false;
                vm.teamsTable = true;
            }
            vm.tabType = type;
            vm.gridTableOptions = getGridOptions();
        }

        vm.changeTableToProfile = function() {
            var params = null;
            var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();
            pageable.size = pageable.size + 1;
            UserProfileService.listProfiles(pageable, $localStorage.defaultStore.storeId, vm.filterFields).then(function(response) {
                response.data = angular.forEach(response.data, function(value) {
                    return value.disabledAction = vm.tabType === "Profiles" ? (value.profileOwner === null && $localStorage.defaultStore.storeId !== 0 ? true: false) : false
                });
                vm.totalItems = response.headers['x-total-count'];
                vm.gridTableOptions.virtualizationThreshold = response.data.length;
                vm.gridTableOptions.update(response.data, vm.totalItems);
                vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
                refreshDataInfos();
            });
        }

        vm.changeTableToTeam = function() {
            var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();
            var params = {
                name: vm.filterFields && vm.filterFields.name && vm.filterFields.name.length > 0 ? vm.filterFields.name : null,
                storeId: $localStorage.defaultStore.storeId,
                isEnabled: true,
                size: pageable.size + 1,
                page: pageable.page
            }

            TeamService.list(params, pageable).then(function(response) {
                if (response.data) {
                    vm.totalItems = response.data.totalElements;
                    vm.gridTableOptions.virtualizationThreshold = response.data.totalElements;
                    vm.gridTableOptions.update(response.data.content, vm.totalItems);
                    vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
                    refreshDataInfos();
                }
            });
        }

        vm.changePageSize = function(pageSize) {
            vm.gridTableOptions.paginationPageSize = pageSize;
            $scope.search();
        };


        vm.changeTableToUsers = function() {
            var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();
            pageable.size = pageable.size + 1;
            UserService.listUsersByStoreId(pageable, vm.store.id, vm.filterFields).then(function(response) {
                vm.totalItems = response.headers['x-total-count'];
                vm.gridTableOptions.virtualizationThreshold = response.data.length;
                vm.gridTableOptions.update(response.data, vm.totalItems);
                vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
                refreshDataInfos();
            });
        }

        vm.changeTableToTeams = function() {
            var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();
            var params = {
                name: vm.filterFields && vm.filterFields.name && vm.filterFields.name.length > 0 ? vm.filterFields.name : null,
                storeId: $localStorage.defaultStore.storeId,
                isEnabled: true,
                size: pageable.size + 1,
                page: pageable.page
            }
            TeamService.list(params, pageable).then(function(response) {
                if (response.data) {
                    vm.totalItems = response.data.totalElements;
                    vm.gridTableOptions.virtualizationThreshold = response.data.totalElements;
                    vm.gridTableOptions.update(response.data.content, vm.totalItems);
                    vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
                    refreshDataInfos();
                }
            });
        }

        function createArray(range, divisor) {
            if (!divisor) divisor = 0;
            if (divisor != 0) {
                range = range / divisor;
            }
            var values = [];
            var iteratorNumber = 0;
            for (var i = 0; i < range; i++) {
                iteratorNumber = divisor != 0 ? i * divisor : i + 1;
                values.push(iteratorNumber);
            }
            return values;
        };

        vm.changeColumnView = function($index) {
            vm.gridTableOptions.columnDefs[$index].visible = !(vm.gridTableOptions.columnDefs[$index].visible || vm.gridTableOptions.columnDefs[$index].visible === undefined);
            vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
        };

        vm.changeColumnFilter = function($index) {
            if (vm.gridTableOptions.columnDefs[$index].filtered) {
                vm.gridTableOptions.columnDefs[$index].filtered = false;
                vm.gridTableOptions.columnDefs[$index].headerCellClass = '';
            } else {
                vm.gridTableOptions.columnDefs[$index].filtered = true;
                vm.gridTableOptions.columnDefs[$index].headerCellClass = 'ui-grid-bgcolor';
            }
            vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
        };

        vm.checkColumnFilter = function(attr, $index) {
            if (attr.length >= 1 && !vm.gridTableOptions.columnDefs[$index].filtered) {
                vm.changeColumnFilter($index);
            }
            if (attr.length <= 0 && vm.gridTableOptions.columnDefs[$index].filtered) {
                vm.changeColumnFilter($index);
            }
            vm.reloadUsers();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('store-management', {
                parent: 'admin',
                url: '/store-management',
                data: {
                    authorities: ['STORE_READ'],
                    pageTitle: 'store-management.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/store-management/store-management.html',
                        controller: 'StoreManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('settings');
                        return $translate.refresh();
                    }]

                }
            })
            .state('store-management-detail', {
                parent: 'store-management',
                url: '/store/{id:int}',
                data: {
                    authorities: ['STORE_READ', 'ADMIN_MANAGE_SYSTEM'],
                    pageTitle: 'store-management.detail.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/store-management/store-management-detail.html',
                        controller: 'StoreManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    storeId: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('profile');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('user-management');
                        $translatePartialLoader.addPart('team-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('store-detail', {
                parent: 'store-management',
                url: '^/store/detail',
                data: {
                    authorities: ['STORE_READ'],
                    pageTitle: 'store-management.detail.title'
                },
                params: {
                    fromStep: null
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/store-management/store-management-detail.html',
                        controller: 'StoreManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('user-management');
                        $translatePartialLoader.addPart('profile');
                        $translatePartialLoader.addPart('team-management');
                        return $translate.refresh();
                    }],
                    stateParams: ['$stateParams', '$localStorage', function($stateParams, $localStorage) {
                        $stateParams.id = $localStorage.defaultStore.storeId;
                        return $stateParams;
                    }]
                }
            })
            .state('store-management.addsalespoint', {
                url: '/newsalespoint',
                data: {
                    pageTitle: 'store-management.new.title',
                    authorities: ['STORE_UPDATE']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/store-management/store-management-newsalespoint.html',
                        controller: 'AddSalesPointManagementController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {}
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store-management');
                        return $translate.refresh();
                    }]

                }
            })
            .state('store-management.new', {
                url: '/new',
                data: {
                    pageTitle: 'store-management.new.title',
                    authorities: ['STORE_CREATE']
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/store-management/store-management-new.html',
                        controller: 'StoreManagementNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('store-profile-detail', {
                parent: 'store-detail',
                url: '^/perfil/{id}',
                data: {
                    authorities: ['STORE_READ_PROFILE'],
                    pageTitle: 'showcaseApp.profile.detail.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/entities/profile/profile-management-detail.html',
                        controller: 'ProfileDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    'storeId': {
                        value: null
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('profile');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'profile-management',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('StoreManagementController', StoreManagementController);

    function StoreManagementController($localStorage, Auth, $q, $translate, $rootScope, $state,
                                       StoreService, CategoryService, FlyersService, toastr,
                                       RemoveModalFactory, paginationConstants, $timeout, $scope) {
        var vm = this;
        vm.searchFilter = {};
        vm.displayTypeList = ["Cards", "Table"];
        vm.displayTypeListCheck = [];
        vm.selectedStoreList = [];
        vm.storesDataFiltered = [];
        vm.storesData = [];
        vm.categories = [];
        vm.storesToRemove = 0;
        vm.loadingArray = ["1", "2", "3", "4"];
        vm.isLoading = true;
        vm.changeSession = changeSession;

        vm.page = 0;
        vm.itemsPerPage = paginationConstants.itemsPerPage - 30;
        vm.hasNextPage = false;
        vm.busy = false;
        loadAll();

        vm.checkType = function(type) {
            vm.createArray("displayType", vm.displayTypeList.length, false);
            vm.displayTypeListCheck[vm.displayTypeList.indexOf(type)] = true;
            vm.displayType = type;
        }

        vm.checkDisplayType = function(type) {
            return (vm.displayType === type);
        }

        vm.isEven = function(number) {
            return (number % 2 == 0);
        };

        vm.changeType = function() {
            vm.displayType = vm.displayType === 'Cards' ? 'Table' : 'Cards';
        };


        vm.checkStoresToRemove = function() {
            vm.storesToRemove = 0;
            vm.storesDataFiltered.forEach(function(store) {
                if (store.checked) {
                    vm.storesToRemove++;
                }
            });
        }

        vm.removeStores = function() {
            if (vm.storesToRemove >= 1) {
                RemoveModalFactory.deleteItem(vm.storesToRemove).then(function(data) {
                    var storeIdList = [];
                    for (var i = 0; i < vm.storesDataFiltered.length; i++) {
                        if (vm.storesDataFiltered[i].checked) {
                            storeIdList.push(vm.storesDataFiltered[i].id);
                        }
                    }
                    $q.all(storeIdList).then(function(data) {
                        StoreService.deleteStores(data).then(function(data) {
                                if (($localStorage.defaultStore.storeId != data.newStoreIdDefault) && (data.newStoreIdDefault != null)) {
                                    Auth.changeSession(data.newStoreIdDefault).then(
                                        function() {
                                            $state.transitionTo('home', {}, {
                                                reload: true,
                                                inherit: false,
                                                notify: true
                                            });
                                        });
                                } else if (data.newStoreIdDefault == null) {
                                    $localStorage.defaultStore.storeId = data.newStoreIdDefault;
                                    toastr.info($translate.instant('store-management.messages.remove.default'));
                                    $state.go('store-info');
                                } else {
                                    $rootScope.$broadcast('storeChangeSuccess');
                                    toastr.success($translate.instant('store-management.messages.remove.success'));
                                    vm.storesToRemove = 0;
                                    vm.storesData = [];
                                    loadStores();
                                }
                            },
                            function() {
                                toastr.error($translate.instant('store-management.messages.remove.error'));
                            });
                    });
                });
            } else {
                toastr.error($translate.instant('store-management.messages.remove.noItens'));
            }
        }

        vm.stopPropagation = function(event) {
            event.stopPropagation();
        };

        vm.createArray = function(type, number, value, array) {
            if (type === "displayType") {
                vm.displayTypeListCheck = [];
                for (var i = 0; i < number; i++) {
                    vm.displayTypeListCheck.push(value);
                }
            }
        }

        vm.reloadStores = function(page, reset) {
            if(reset) {
                vm.page = 0;
                vm.storesData = [];
            }else {
                vm.page = page;
            }
            loadStores();
        }

        vm.reset = function reset() {
            vm.page = 0;
            vm.flyersFiltered = [];
        };

        vm.storeDetailsPage = function(storeId) {
            $state.go('store-management-detail', {
                id: storeId
            });
        }

        vm.checkStoreClickAction = function(storeId) {
            if ($localStorage.defaultStore.storeId == 0) {
                vm.storeDetailsPage(storeId);
            } else {
                vm.changeSession(storeId)
            }
        }

        vm.loadStoreImage = function(store) {
            store.image = undefined;
            $timeout(function() {
                vm.getImageFromUrl(store);
            }, 1000);
        }

        vm.getImageFromUrl = function (store) {
            var xhr = new XMLHttpRequest();

            xhr.onreadystatechange = function (oEvent) {
                if (xhr.readyState === 4) {
                    if (xhr.status !== 200) {
                        store.image = "content/images/defaultShowcaseImage.png";
                        $scope.$apply();
                    } else if (xhr.status === 200) {
                        var random = new Date().getTime();
                        store.image = (store.storeLogo + '?r=' + random);
                    }
                }
            }

            xhr.open('GET', store.storeLogo);
            xhr.responseType = 'blob';

            try {
                xhr.send()
            } catch (error) {
                console.log(error)
            }
        }

        function changeSession(storeId) {
            Auth.changeSession(storeId).then(
                function() {
                    $state.transitionTo('home', {}, {
                        reload: true,
                        inherit: false,
                        notify: true
                    });

                    // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                    // since login is successful, go to stored previousState and clear previousState
                    if (Auth.getPreviousState()) {
                        var previousState = Auth.getPreviousState();
                        Auth.resetPreviousState();
                        $state.go(previousState.name, previousState.params);
                    }
                });
        }

        function loadAll() {
            loadStores();
            loadCategories();
        }

        function loadCategories() {
            CategoryService.listCategories($translate.use()).then(function(response) {
                vm.categories = response.data;
            });
        }

        function loadCategoriesName(data) {
            data.forEach(function(store) {
                CategoryService.getCategoryTitleByKey(store.categoryKey, $translate.use()).then(function(response) {
                    store.categoryName = response.data;
                });
            });
        }

        function loadNumberOfFlyers(data) {
            data.forEach(function(store) {
                FlyersService.getNumberOfFlyers(store.id, $translate.use()).then(function(response) {
                    store.numberOfFlyers = response.data;
                });
            });
        }


        function loadStores() {
            if(vm.busy) return;
            vm.busy = true;

            var pageable = {
                page: vm.page,
                size: vm.itemsPerPage
            };
            StoreService.listStores(vm.searchFilter, pageable, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.hasNextPage = headers('X-Has-Next-Page') === "true";
                var newStores = [];
                for (var i = 0; i < data.length; i++) {
                    vm.loadStoreImage(data[i]);
                    vm.storesData.push(data[i]);
                    newStores.push(data[i]);
                }
                vm.storesDataFiltered = vm.storesData;
                $q.all(newStores).then(function() {
                    vm.displayType = vm.storesDataFiltered.length > 1 ? 'Cards' : 'Table';
                    loadCategoriesName(newStores);
                    loadNumberOfFlyers(newStores);
                    vm.isLoading = false;
                });

                vm.busy = false;
            }

            function onError() {
                vm.busy = false;
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('StoreService', StoreService);

    StoreService.$inject = ['StoreFactoryAdmin', 'StoreFactoryGateway', 'SalesPointFactory', 'Upload'];

    function StoreService(StoreFactoryAdmin, StoreFactoryGateway, SalesPointFactory, Upload) {
        var service = {
            addStore: addStore,
            updateStore: updateStore,
            authorizeShipping: authorizeShipping,
            authorizeBling: authorizeBling,
            deleteStore: deleteStore,
            deleteStores: deleteStores,
            setStoreNotSample: setStoreNotSample,
            getStore: getStore,
            getSalesPoints: getSalesPoints,
            listStores: listStores,
            listHubStores: listHubStores,
            createSalesPoint: createSalesPoint,
            updateSalesPoint: updateSalesPoint,
            deleteSalesPoint: deleteSalesPoint,
            getMyStores: getMyStores,
            getMyAllStores: getMyAllStores,
            checkShippingConnected: checkShippingConnected,
            saveStoreImage: saveStoreImage,
            verifyIfNicknameAvailable: verifyIfNicknameAvailable,
            verifyIfCnpjIsAvailable: verifyIfCnpjIsAvailable,
            saveBankInfo: saveBankInfo,
            getPicPayConfiguration: getPicPayConfiguration,
			getDupayConfiguration: getDupayConfiguration,
            getTBanksConfiguration: getTBanksConfiguration,
            savePicPayConfiguration: savePicPayConfiguration,
			saveDupayConfiguration: saveDupayConfiguration,
            saveTBanksConfiguration: saveTBanksConfiguration,
            verifyTBanksConfirmationToken: verifyTBanksConfirmationToken,
            resendTBanksConfirmationToken: resendTBanksConfirmationToken,
            isStoreOwner: isStoreOwner,
            saveRedirectDomains: saveRedirectDomains,
            saveStoreAnalytics: saveStoreAnalytics,
            getSteps: getSteps,
            listStoresByCurrentHub: listStoresByCurrentHub,
            countStoresByCurrentHubAndStoreType: countStoresByCurrentHubAndStoreType,
			getCssHub: getCssHub,
			getOwnerCategoryCurrentStore: getOwnerCategoryCurrentStore,
			updateDefaultFilter: updateDefaultFilter,
            getPaymentSettings: getPaymentSettings,
            updateToBeAgreedValue: updateToBeAgreedValue,
            updateRedirectToSellerValue: updateRedirectToSellerValue
        };

        return service;

        function getStore(storeId, sellerId) {
            return StoreFactoryAdmin.get({
                id: storeId,
                sellerId: sellerId
            }).$promise;
        }

        function getMyStores() {
            return StoreFactoryGateway.getMyStores().$promise;
        }

        function getMyAllStores() {
            return StoreFactoryGateway.getMyAllStores().$promise;
        }

        function saveRedirectDomains(stores) {
            return StoreFactoryGateway.saveRedirectDomains(stores).$promise;
        }

        function saveStoreAnalytics(stores) {
            return StoreFactoryGateway.saveStoreAnalytics(stores).$promise;
        }

        function addStore(store) {
            return StoreFactoryGateway.save(store).$promise;
        }

        function updateStore(store) {
            return StoreFactoryAdmin.update(store).$promise;
        }

        function deleteStore(storeId) {
            return StoreFactoryAdmin.delete({
                id: storeId
            }).$promise;
        }

        function deleteStores(storeIds) {
            return StoreFactoryGateway.deletebyids({
                storeIds: storeIds
            }).$promise;
        }

        function listStores(params, pageable, onSuccess, onError) {
            return StoreFactoryGateway.listAll(pageable, params, onSuccess, onError);
        }

        function listHubStores(params, pageable, onSuccess, onError) {
            return StoreFactoryGateway.listAll(pageable, params, onSuccess, onError);
        }

        function listStoresByCurrentHub(params, pageable, onSuccess, onError) {
            return StoreFactoryAdmin.listAllStoreByHub(pageable, params, onSuccess, onError);
        }

        function createSalesPoint(salesPoint) {
            return SalesPointFactory.save(salesPoint).$promise;
        }

        function updateSalesPoint(salesPoint) {
            return SalesPointFactory.update(salesPoint).$promise;
        }

        function deleteSalesPoint(salesPointId) {
            return SalesPointFactory.delete({
                id: salesPointId
            }).$promise;
        }

        function getSalesPoints(store) {
            return SalesPointFactory.get({
                storeId: store
            }).$promise;
        }

        function verifyIfNicknameAvailable(nickname) {
            return StoreFactoryAdmin.isNicknameAvailable({
                nickname: nickname
            }).$promise
        }

        function verifyIfCnpjIsAvailable(cnpj) {
            return StoreFactoryAdmin.isCnpjAvailable({
                cnpj: cnpj
            }).$promise
        }

        function saveStoreImage(image) {
            return Upload.upload({
                url: 'zuul/admin/api/upload',
                data: {
                    file: image
                }
            });
        }

        function saveBankInfo(storeId, bankInfoDTO) {
            return StoreFactoryAdmin.saveBankInfo({
                storeId: storeId
            }, bankInfoDTO).$promise;
        }

        function getPicPayConfiguration(storeId) {
            return StoreFactoryAdmin.getPicPayConfiguration({
                storeId: storeId
            }).$promise;
        }

        function getDupayConfiguration(storeId) {
            return StoreFactoryAdmin.getDupayConfiguration({
                storeId: storeId
            }).$promise;
        }

        function getPaymentSettings(storeId) {
            return StoreFactoryAdmin.getPaymentSettings({
                storeId: storeId
            }).$promise;
        }

        function updateToBeAgreedValue(storeId, value) {
            return StoreFactoryAdmin.updateToBeAgreedValue({'storeId': storeId}, value).$promise;
        }

        function updateRedirectToSellerValue(storeId, value) {
            return StoreFactoryAdmin.updateRedirectToSellerValue({'storeId': storeId}, value).$promise;
        }

        function getTBanksConfiguration(storeId) {
            return StoreFactoryAdmin.getTBanksConfiguration({
                storeId: storeId
            }).$promise;
        }

        function savePicPayConfiguration(picPayConfigurationDTO) {
            return StoreFactoryAdmin.savePicPayConfiguration(picPayConfigurationDTO).$promise;
        }

        function saveDupayConfiguration(dupayConfigurationDTO) {
            return StoreFactoryAdmin.saveDupayConfiguration(dupayConfigurationDTO).$promise;
        }

        function saveTBanksConfiguration(tBanksConfigurationDTO) {
            return StoreFactoryAdmin.saveTBanksConfiguration(tBanksConfigurationDTO).$promise;
        }

        function verifyTBanksConfirmationToken(tBanksConfirmationTokenDTO) {
            return StoreFactoryAdmin.verifyTBanksConfirmationToken(tBanksConfirmationTokenDTO).$promise;
        }

        function resendTBanksConfirmationToken() {
            return StoreFactoryAdmin.resendTBanksConfirmationToken().$promise;
        }

        function isStoreOwner() {
            return StoreFactoryAdmin.isStoreOwner().$promise;
        }

        function getSteps() {
            return StoreFactoryAdmin.getStepsData().$promise;
        }

        function setStoreNotSample(store) {
            return StoreFactoryAdmin.setStoreNotSample(store, {}).$promise;
        }

        function countStoresByCurrentHubAndStoreType(storeTypeId) {
            return StoreFactoryAdmin.countStoresByCurrentHubAndStoreType({
                storeTypeId: storeTypeId
            }).$promise;
        }

        function checkShippingConnected(storeName) {
            return StoreFactoryAdmin.checkShippingConnected({
                store: storeName
            }).$promise;
        }

        function authorizeShipping() {
            return StoreFactoryAdmin.authorizeShipping().$promise;
        }

        function authorizeBling() {
            return StoreFactoryAdmin.authorizeBling().$promise;
        }

        function getCssHub(hubName) {
            return StoreFactoryAdmin.cssHub({
                name: hubName
            }).$promise;
        }

		function getOwnerCategoryCurrentStore() {
			return StoreFactoryAdmin.getOwnerCategoryCurrentStore().$promise;
		}

        function updateDefaultFilter(defaultFilter) {
			return StoreFactoryAdmin.updateDefaultFilter(defaultFilter).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('StoreFactoryGateway', StoreFactoryGateway);

    StoreFactoryGateway.$inject = ['$resource'];

    function StoreFactoryGateway($resource) {
        var resourceUrl =  'api/store/:id';
        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'deletebyids': {
                method: 'POST',
                url: '/api/store/deletebyids'
            },
            'listAll': {
                method: 'POST',
                url: '/api/store/list',
                isArray: true
            },
            'saveRedirectDomains': {
                method: 'POST',
                url: '/admin/api/store/save-url-domains',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'saveStoreAnalytics': {
                method: 'POST',
                url: '/admin/api/store/save-store-analytics',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getMyStores': {
                url: '/api/store/my',
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getMyAllStores': {
                url: '/admin/api/store/list-all',
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'update': { method:'PUT' },
            'delete': { method:'DELETE' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('StoreFactoryAdmin', StoreFactoryAdmin);

    StoreFactoryAdmin.$inject = ['$resource'];

    function StoreFactoryAdmin($resource) {
        var resourceUrl = 'admin/api/store/:id';

        return $resource(resourceUrl, {}, {
            'countStoresByCurrentHubAndStoreType': {
                method: 'GET',
                isArray: false,
                url: 'admin/api/store/count/current-hub/store-type'
            },
            'listAllStoreByHub': {
                method: 'GET',
                isArray: true,
                url: 'admin/api/store/store-and-sales-by-hub/current-hub'
            },
            'query': {
                method: 'GET',
                isArray: false,
                transformResponse: function(data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'deletebyids': {
                method: 'POST',
                url: '/admin/api/store/deletebyids'
            },
            'listAll': {
                method: 'POST',
                url: '/admin/api/store/list',
                transformResponse: function(data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'saveBankInfo': {
                method: 'POST',
                url: '/admin/api/store/save-bank-info',
                transformResponse: function(data, headers) {
                    var response = {};
                    if (angular.isObject(data)) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getPicPayConfiguration': {
                method: 'GET',
                url: '/admin/api/payment-configuration/:storeId',
                transformResponse: function(data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getDupayConfiguration': {
                method: 'GET',
                url: '/admin/api/dupayPaymentConfiguration/payment-configuration/:storeId',
                transformResponse: function(data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getPaymentSettings': {
                method: 'GET',
                url: '/admin/api/payment-settings/:storeId',
                transformResponse: function(data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateToBeAgreedValue': {
                method:'POST',
                isArray: false,
                url: 'admin/api/payment-settings/:storeId/updateToBeAgreed'
            },
            'updateRedirectToSellerValue': {
                method:'POST',
                isArray: false,
                url: 'admin/api/payment-settings/:storeId/updateRedirectToSeller'
            },
            'savePicPayConfiguration': {
                method: 'POST',
                url: '/admin/api/payment-configuration',
                transformResponse: function(data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'saveDupayConfiguration': {
                method: 'POST',
                url: '/admin/api/dupayPaymentConfiguration/payment-configuration',
                transformResponse: function(data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getTBanksConfiguration': {
                method: 'GET',
                url: '/admin/api/tBanksPaymentConfiguration/payment-configuration/:storeId',
                transformResponse: function(data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'saveTBanksConfiguration': {
                method: 'POST',
                url: '/admin/api/tBanksPaymentConfiguration/payment-configuration',
                transformResponse: function(data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'verifyTBanksConfirmationToken': {
                method: 'POST',
                url: '/admin/api/tBanksPaymentConfiguration/payment-configuration/verify-token',
                transformResponse: function(data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'resendTBanksConfirmationToken': {
                method: 'POST',
                url: '/admin/api/tBanksPaymentConfiguration/payment-configuration/resend-token',
                transformResponse: function(data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function(data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'isCnpjAvailable': {
                method: 'GET',
                url: "/admin/api/store/is-cnpj-available",
                transformResponse: function(data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'authorizeShipping': {
                method: 'GET',
                headers: {
                    'Accept': '*/*'
                },
                url: "/admin/api/shipping/authorize",
                transformResponse: function(data, headers) {

                    if (headers() && headers().location) {
                        window.location.href = headers().location
                    }
                    var response = {};
                    response.headers = headers();
                    return data;
                }
            },
            'authorizeBling': {
                method: 'GET',
                headers: {
                    'Accept': '*/*'
                },
                url: "/admin/api/bling/authorize",
                transformResponse: function(data, headers) {

                    if (headers() && headers().location) {
                        window.location.href = headers().location
                    }
                    var response = {};
                    response.headers = headers();
                    return data;
                }
            },
            'checkShippingConnected': {
                method: 'GET',
                headers: {
                    'Accept': '*/*'
                },
                url: "/admin/api/shipping/isConnected",
                // transformResponse: function (data, headers) {

                //     var response = {};
                //     response.headers = headers();
                //     return data;
                // }
            },
            'isNicknameAvailable': {
                method: 'GET',
                url: "/admin/api/store/isNicknameAvailable",
                transformResponse: function(data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'isStoreOwner': {
                method: 'GET',
                url: "/admin/api/store/is-store-owner",
                transformResponse: function(data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getStepsData': {
                url: 'admin/api/store/getStoreStepByStep',
                method: 'GET',
                transformResponse: function(data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'setStoreNotSample': {
                method: 'PUT',
                url: '/admin/api/store/store-sample/:id',
                transformResponse: function(data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE'
            },
            'cssHub': {
                url: 'admin/api/cssHub/:name',
                method: 'GET',
                transformResponse: function(data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
			'getOwnerCategoryCurrentStore': {
                url: 'admin/api/category/owner/current-store',
                method: 'GET',
                transformResponse: function(data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'updateDefaultFilter': {
                url: 'admin/api/store/default-filter',
                method: 'PUT',
                transformResponse: function(data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('SalesPointFactory', SalesPointFactory);

    SalesPointFactory.$inject = ['$resource'];

    function SalesPointFactory($resource) {
        var resourceUrl =  'admin/api/sales-point/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'update': { method:'PUT' },
            'delete': { method:'DELETE' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ShowcasesFlyersController', ShowcasesFlyersController);

    ShowcasesFlyersController.$inject = ['$state', '$stateParams', '$q', 'paginationConstants', '$translate', 'FlyersService', 'FlyerCategoryService', 'FlyersCurrencyValue', 'ShowcasesService', 'toastr', 'BrandService', '$localStorage', '$uibModal', 'StoreService'];

    function ShowcasesFlyersController($state, $stateParams, $q, paginationConstants, $translate, FlyersService, FlyerCategoryService, FlyersCurrencyValue, ShowcasesService, toastr, BrandService, $localStorage, $uibModal, StoreService) {
        var vm = this;

        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.maxSize = 5;
        vm.totalFlyers = 0;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage
        };

        vm.listFilter = {
            activated: null,
            hasInventory: true,
            text: ''
        };

        vm.sortOptions = paginationConstants.sortOptions[$translate.use().toLowerCase()];
        vm.selectedSortByOption = "";

        vm.onSelectedSortOption = function () {
            vm.page = 0;
            vm.currentPage = 1;
            vm.paginationOptions = {
                page: vm.currentPage - 1,
                size: vm.numPerPage
            };

            vm.listFilter.sortBy = vm.selectedSortByOption.value;
            vm.listFilter.sortDirection = vm.selectedSortByOption.direction;

            loadFlyers();
        }

        vm.loadFlyers = function (page, reset) {
            loadFlyers();
        };

        vm.isOpenCalendarStart = false;
        vm.isOpenCalendarExpire = false;

        vm.inactiveArray = [];

        vm.flyersFiltered = [];
        vm.page = 0;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.hasNextPage = false;
        vm.busy = false;

        vm.brands = [];
        vm.brandGroups = {};
        vm.selectedAll = false;
        vm.sizes = [];
        vm.colors = [];
        vm.numberFilterSelected = 0;

        loadAll();

        function loadAll() {
            vm.isLoading = true;

            FlyerCategoryService.listCategoriesByCurrentStore($translate.use(), $localStorage.defaultStore.storeId).then(function(response) {
                vm.categories = response.data;
            });

            ShowcasesService.getShowcase($stateParams.showcaseId, $stateParams.ownerId).then(function(data) {
                vm.showcase = data;
                loadTemplate();
                vm.listFilter.storeId = vm.showcase.ownerId;
                BrandService.getBrandsByCurrentStore().then(function(response) {
                    vm.brands = response.data;
                    vm.listFilter.brand = response.data[0].name;
                    loadFlyers();
                });
            });

            FlyersService.getAllFiltersFlyer().then(function (response) {
                vm.colors = response.data.colors;
                vm.sizes = response.data.sizes;
            });
        }

        function loadTemplate() {
            ShowcasesService.getTemplate(vm.showcase.showcaseTemplateId).then(function(response) {
                vm.maxFlyersPerShowcase =  response.quantityOfRows * (12/response.row.items[0].size);;
            });
        }

        vm.reset = function reset() {
            vm.page = 0;
            vm.flyersFiltered = [];
        };

        vm.changePage = function () {
            var begin = ((vm.currentPage - 1) * vm.numPerPage),
            end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            loadFlyers();
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;
        };

        function loadFlyers() {
            if(vm.busy) return;
            vm.busy = true;

            if (!vm.listFilter.colors || !(vm.listFilter.colors.length > 0)) {
                delete vm.listFilter.colors
            }

            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("launch")) {
                vm.listFilter.launch = true;
            } else {
                delete vm.listFilter.launch;
            }

            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("basic")) {
                vm.listFilter.basic = true;
            } else {
                delete vm.listFilter.basic;
            }

            if (!vm.listFilter.colors || !(vm.listFilter.colors.length > 0)) {
                delete vm.listFilter.colors
            }

            if (!vm.listFilter.sizes || !(vm.listFilter.sizes.length > 0)) {
                delete vm.listFilter.sizes
            }

            if (!vm.listFilter.genders || !(vm.listFilter.genders.length > 0)) {
                delete vm.listFilter.genders
            }

            if (vm.numberFilterSelected === 0 && vm.listFilter.brand && vm.listFilter.brand !== '' && vm.listFilter.text === '') {
                vm.listFilter.brands = [vm.listFilter.brand]
            } else if (!vm.filters.brands || !(vm.filters.brands.length > 0)) {
                delete vm.listFilter.brands
            }

            if (vm.numberFilterSelected === 0 && vm.listFilter.categoryKey && vm.listFilter.categoryKey !== '' && vm.listFilter.text === '') {
                vm.listFilter.categoryKeys = [vm.listFilter.categoryKey]
            } else if (vm.filters.categories.length > 0) {
                vm.listFilter.categoryKey = vm.listFilter.categoryKeys[0]
            } else {
                delete vm.listFilter.categoryKeys
            }

            FlyersService.listFlyersPage(vm.paginationOptions, vm.listFilter, onSuccess, onError);

            function onSuccess(response, headers) {
                var data = response.data.content;
                vm.busy = false;
                vm.totalFlyers = headers('X-Total-Count');
                vm.flyersFiltered = data.length <= 0 ? [] : data;

                for (var i = 0; i < data.length; i++) {
                    vm.getCategoryName(data[i]);
                }
                vm.isLoading = false;
                reduceFlyersToMap();
                refreshInactiveBoxArray();

                vm.makeBrandGroups();
                vm.refreshFlyersSelected();
            }

            vm.makeBrandGroups = function() {
                vm.brandGroups = {};
                vm.showcase.flyers.forEach(function(flyer) {
                    if(flyer.brand){
                        vm.brandGroups[flyer.brand] = vm.brandGroups[flyer.brand] ? vm.brandGroups[flyer.brand] + 1 : 1;
                    }
                });
            }

            function onError() {
                vm.busy = false;
                toastr.error($translate.instant('flyers.messages.load.error'));
            }
        }

        function refreshInactiveBoxArray(number) {
            vm.flyersStatus = [];
            var qtdActive = vm.showcase.flyers.length;
            for (var i = 0; i < vm.maxFlyersPerShowcase; i++) {
                if (qtdActive >= 1) {
                    vm.flyersStatus.push({
                        status: true
                    });
                } else {
                    vm.flyersStatus.push({
                        status: false
                    });
                }
                qtdActive--;
            }
        }

        function reduceFlyersToMap() {
            var index = 0;
            vm.flyersMap = vm.showcase.flyers.reduce(function(map, flyer) {
                map[flyer.id] = {
                    name: flyer.name,
                    pos: index
                };
                index++;
                return map;
            }, {})
        }

        vm.getCountSelectedByBrand = function(brand) {
            return vm.brandGroups[brand];
        };

        vm.tabClick = function(brand){
            vm.loadingTab = true;

            // Changes the type to the new type Clicked
            vm.listFilter.brand = brand.name;

            // Erases the offer list
            vm.flyersFiltered = [];

            // Turn to 0 the page to give right page on pageable
            vm.page = 0;

            // loadOffers
            loadFlyers();

        };

        vm.changeFlyerSelected = function(flyer) {
            if (vm.flyersMap) {
                if (vm.flyersMap[flyer.id]) {
                    vm.showcase.flyers.splice(vm.flyersMap[flyer.id].pos, 1);
                    reduceFlyersToMap();
                } else {
                    flyer.position = vm.showcase.flyers.length + 1;
                    vm.showcase.flyers.splice(0, 0, flyer);
                    reduceFlyersToMap();
                }
            } else {
                vm.showcase.flyers.splice(0, 0, flyer);
                reduceFlyersToMap();
            }
            refreshInactiveBoxArray();
            vm.refreshFlyersSelected()
        };

        vm.refreshFlyersSelected = function() {
            vm.makeBrandGroups();
        };

        vm.getCategoryName = function(flyer) {
            var category = _.find(vm.categories, function(el) {return el.key === flyer.categoryKey});
            if (category) {
                flyer.category = category.title;
            }
        };

        vm.getFlyerCurrency = function(currency) {
            return FlyersCurrencyValue[currency];
        };

        vm.checkFlyerIsSelected = function(flyer) {
            if (vm.flyersMap) {
                return angular.isDefined(vm.flyersMap[flyer.id]);
            }
        };

        vm.hasActiveFilter = function() {
            return ((vm.numberFilterSelected && vm.numberFilterSelected > 0) || (vm.listFilter.text && vm.listFilter.text !== ''));
        };

        vm.stopPropagation = function(event) {
            event.stopPropagation();
        };

        function checkIsListAll() {
            vm.flyersFiltered = [];
            if (!vm.filters.inactive && !vm.filters.active) {
                vm.listFilter.status = null;
            }
            loadFlyers();

        }

        vm.changeStatusFilterToActive = function() {
            if (vm.filters.active) {
                vm.filters.inactive = false;
                vm.listFilter.status = "ACTIVATED";
            }
            checkIsListAll();
        };

        vm.changeStatusFilterToInactive = function() {
            if (vm.filters.inactive) {
                vm.filters.active = false;
                vm.listFilter.status = "DEACTIVATED";
            }
            checkIsListAll();
        }

        vm.openCalendarStart = function(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenCalendarStart = true;
        };

        vm.openCalendarExpire = function(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenCalendarExpire = true;
        };

        vm.saveShowcase = function(isRedirectToShowcaseScreen) {
            var flyersPosition = [];
            vm.showcase.flyers.forEach(function (flyer) {
                flyersPosition.push({
                    flyerId: flyer.id,
                    position: flyer.position
                });
            });
            vm.showcase.flyers = flyersPosition;
            $q.all(vm.showcase.flyers).then(function(data) {
                ShowcasesService.updateShowcase(vm.showcase).then(function(data) {
                    if (isRedirectToShowcaseScreen) {
                        $state.go('showcases.edit', {
                            showcaseId: data.id
                        });
                    }
                });
            });
        }

        function getDefaultFilter() {
            setTimeout(function() {
                //load default filter
                vm.flyersFiltered = [];
                delete vm.listFilter.categoryKey;
                delete vm.listFilter.categoryKeys;
                delete vm.listFilter.brand;
                delete vm.listFilter.brands;
                loadAll();
            }, 1000);
        }

        vm.filters = {
            categories: [],
            brands: [],
            colors: [],
            sizes: [],
            genders: [],
            configurations: [],
            hasInventory : true
        };

        vm.openFiltersModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/admin/flyers/modal-filter-flyer/flyer-filter-modal.html',
                controller: 'FiltersFlyersController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    options: function () {
                        return {
                            categories: vm.categories,
                            brands: vm.brands,
                            colors: vm.colors,
                            sizes: vm.sizes,
                            canChangeView: false
                        }
                    },
                    filters: function () {
                        return vm.filters
                    },
                    list: function () {
                        return vm.listFilter
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    vm.numberFilterSelected = response.totalFilters;

                    vm.filters = response.selectedFilters;
                    if (response.totalFilters === 0) {
                        delete vm.listFilter.categoryKey;
                        delete vm.listFilter.categoryKeys;
                        vm.listFilter.brands = [vm.listFilter.brand];
                    } else
                        vm.listFilter = response.listFilter;
                    loadFlyers();
                }
            });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ShowcasesDetailController', ShowcasesDetailController);

    /** @ngInject */
    function ShowcasesDetailController($state, $timeout, $stateParams, $filter, $q, $window, $localStorage,
        StoreService, $scope, $translate, FlyersService, FlyerCategoryService, FlyersCurrencyValue,
        ShowcasesService, toastr, Principal, UserInteractModalFactory, ModalFactory, DOMAIN, $rootScope, $uibModal) {

        var vm = this;
        var userInteractModal;
        var storeId = $localStorage.defaultStore.storeId;
        var mainColor = getComputedStyle(document.documentElement).getPropertyValue('--main-color');
        vm.showcaseId = $stateParams.showcaseId;
        var DEFAULT_TYPE = "SALE";
        vm.backgroundColorAux = '';
        vm.banners = [];
        vm.haveBanners = false;
        vm.isMobile = detectar_mobile();

        vm.isPrinting = false;

        var DEFAULT_IMAGE = "https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/showkase/capa-loading-image-s3.png";

        vm.showcase = {
            'backgroundColor': false,
            flyers: [],
            ownerId: null,
            hasCover: false,
            userInteract: "SALE"
        };

        $scope.options = {
            format: 'hex',
            case: 'upper'
        }

        vm.listFilter = {
            storeId: storeId,
            activated: null,
            type: null
        };

        vm.openShowcaseModalType = openShowcaseModalType;

        vm.imageSize = 800;

		function loadCanvaAPI(c,a,n){
			var w=c.createElement(a),s=c.getElementsByTagName(a)[0];
			w.src=n;s.parentNode.insertBefore(w,s);
		}

		loadCanvaAPI (document,'script','https://sdk.canva.com/designbutton/v2/api.js');

        vm.storeOwnerHasMoipAccount = false;
        storeOwnerHasMoipAccount();
        vm.dynamicPopover = {
            templateUrl: 'userInteractPopoverTemplate.html',
        };
        vm.coverEdit = true;
        vm.templateIsLoading = true;
        vm.showcases = [1, 2, 3, 4, 5, 6, 7, 8];
        vm.templates = [];
        vm.flyersToLoad = 1;
        vm.isSaving = false;
		vm.saveImageCover = true;
        vm.isSavingPreview = false;

        loadAll();

        vm.openInputColor = function() {
            document.getElementsByClassName('pcr-button')[0].click();
        }

        vm.goToSettings = function () {
            $state.go('settings');
        }

        vm.openColorModal = function () {
            $uibModal.open({
                templateUrl: 'app/admin/showcases/select-colors-modal/select-colors-modal.html',
                controller: 'SelectColorsModalConstroller',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    colors: function () {
                        return {
                            backgroundColor: vm.showcase.backgroundColor,
                            headerBackgroundColor: vm.showcase.headerBackgroundColor,
                            iconColor: vm.showcase.headerIconColor
                        }
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    vm.showcase.backgroundColor = response.backgroundColor;
                    vm.showcase.headerBackgroundColor = response.headerBackgroundColor;
                    vm.showcase.headerIconColor = response.iconColor;
                    document.getElementsByClassName('icon-ksc-colorselection')[0].style.color = response.backgroundColor;
                }
            });
        }

        function loadAll() {
            vm.templateId = 1; // Chose the first template as default
            ShowcasesService.getTemplates().then(function (response) {
                vm.templates = response;
            });
            FlyerCategoryService.listCategories($translate.use()).then(function(response) {
                vm.categories = response.data;
            });
            if (vm.showcaseId) {
                loadShowcase();
            } else {
                vm.showcase.ownerId = storeId;
                vm.showcase.backgroundColor = mainColor;
                vm.showcase.headerBackgroundColor = mainColor;
                vm.backgroundColorAux = mainColor;
                vm.showcase.showcaseTemplateId = vm.templateId;
                vm.templateIsLoading = false;
            }
        }

        function loadShowcase() {
            return ShowcasesService.getShowcase(vm.showcaseId).then(function (response) {
                vm.showcase = response;
                vm.backgroundColorAux = vm.showcase.backgroundColor;
                vm.showcase.userInteract = vm.originalUserInteract ? vm.originalUserInteract: vm.showcase.userInteract;

                if(vm.showcase.banners != null && vm.showcase.banners.length > 0) {
                    vm.banners = vm.showcase.banners;
                    vm.haveBanners = true;
                    vm.showcase.banners.forEach(function(banner, i) {
                        vm.banners[i].image = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].cover;

                        if (vm.banners[i].coverMobile) {
                            vm.banners[i].imageMobile = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].coverMobile;
                        }
                    })
                } else if (vm.showcase.hasCover && vm.showcase.coverUrl !== '') {
                    checkImage(function (url) {
                        vm.banners.push({'id': 1, 'image': url, 'name': '', 'link': ''});
                        loadCarousel();
                    });
                    vm.haveBanners = true;
                }

                loadCarousel();
                loadShowcasesFlyers();
            });
        }

        function checkImage(callback) {
            var image = new Image();
            image.onload = function () {
                if (this.width > 0) {
                    callback(vm.showcase.coverUrl);
                }
            }
            image.onerror = function () {
                callback(DEFAULT_IMAGE);
            }
            image.src = vm.showcase.coverUrl;
        }

        vm.checkFlyerIsSelected = function (id) {
            if (vm.flyersMap) {
                return angular.isDefined(vm.flyersMap[id]);
            }
        };

        vm.changeFlyerSelected = function (flyer) {
            if (vm.flyersMap) {
                if (vm.flyersMap[flyer.id]) {
                    vm.showcase.flyers.splice(vm.flyersMap[flyer.id].pos, 1);
                    loadShowcasesFlyers();
                } else {
                    vm.showcase.flyers.splice(0, 0, flyer);
                    loadShowcasesFlyers();
                }
            } else {
                vm.showcase.flyers.splice(0, 0, flyer);
                loadShowcasesFlyers();
            }
        };

        vm.changeTemplate = function (templateId) {
            vm.templateIsLoading = true;
            vm.templateId = templateId;
            loadTemplate().then(function () {
                vm.showcase.showcaseTemplateId = templateId;
            });
        };


        vm.getImageSrc = function (templateId) {
            return 'content/images/templates/' + templateId + '.png';
        };


        function succesPrint(res) {

            var saveByteArray = (function() {
                return function(data, name, mimeType) {
                    var blob = new Blob(data, {
                        type: mimeType
                    });
                    var url = window.URL.createObjectURL(blob);
                    var element = angular.element('<a/>');
                    element.attr({
                        href: url,
                        target: '_blank',
                        download: name
                    });
                    if(document.createEvent) {
                        var ev = document.createEvent("MouseEvent");
                        ev.initMouseEvent("click", true /* bubble */, true /* cancelable */, window, null, 0, 0, 0, 0, /* coordinates */
                        false, false, false, false,
                        /*
                         * modifier keys
                         */
                        0 /* left */, null);
                        element[0].dispatchEvent(ev);
                    } else {
                        element[0].fireEvent("onclick");
                    }
                    setTimeout(function() {
                        document.body.removeChild;
                        window.URL.revokeObjectURL(url);
                    }, 200);
                };
            }());
            if (res.headers["content-disposition"]){
                var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                var mimeType = res.headers["content-type"];
                filename = filename.replace(/['"]/g, '');
                saveByteArray([res.data], filename, mimeType);
            } else {
                toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
            }

            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
        }

        function errorPrint(response) {
            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
            toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));

        }

        vm.generateTabloid = function(){
            vm.saveFlyer(false, function () {
                if (!vm.showcase.hasCover) {
                    toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                    vm.isSaving = false;
                } else if (vm.showcase.flyers.length < 1) {
                    toastr.error($translate.instant('showcases.messages.errors.blankFlyers'));
                } else if (!vm.showcase.name) {
                    toastr.error($translate.instant('showcases.messages.errors.blankName'));
                } else {
                    vm.isPrinting = true;
                    buildMessageGeneratedTabloid();
                    $rootScope.$emit('waiting-generates-tabloid');
                    ShowcasesService.generateTabloid({
                        showcaseId: Number(vm.showcase.id) || undefined,
                        storeId: ( storeId ? storeId + "" : undefined) || undefined,
                        flyers: vm.showcase.flyers.map(function (flyer) {
                            return flyer.id;
                        })
                    }).then(succesPrint, errorPrint);
                }
            });
        }


        function loadShowcasesFlyers() {
            if (vm.showcase.flyers) {
                vm.flyerId = 0;
                if (vm.showcase.showcaseTemplateId) {
                    vm.templateId = vm.showcase.showcaseTemplateId;
                }
                vm.showcase.flyers.forEach(function (flyer) {
                    vm.getCategoryName(flyer);
                    var random = new Date().getTime();
                    flyer.imagePath = '/flyer/api/' + flyer.id + '/picture?type=large&ts=' + random;
                });
            }
            loadTemplate();
        }


        function loadTemplate() {
            return ShowcasesService.getTemplate(vm.templateId).then(function (response) {
                vm.template = response;
                vm.templateIsLoading = false;
            });
        }

        function openShowcaseModalType() {
            userInteractModal = UserInteractModalFactory.selectUserInterectType(storeId, vm.showcase.userInteract);
            userInteractModal.result.then(function (userInteract) {

                vm.originalUserInteract = angular.copy(vm.showcase.userInteract);
                vm.showcase.userInteract = userInteract;

                vm.listFilter.type = vm.showcase.userInteract;
                if (!(vm.originalUserInteract && vm.originalUserInteract === vm.showcase.userInteract)) {
                    vm.flyersInfo = null;
                    vm.flyersFiltered = [];
                    vm.flyersMap = undefined;
                    vm.showcase.flyers = [];
                    loadShowcasesFlyers();
                }
            });
        }

        function setShowcaseTypeDefault() {
            vm.showcase.userInteract = DEFAULT_TYPE;
            vm.listFilter.type = vm.showcase.userInteract;
        }

        vm.getShowcasesFlyer = function () {
            vm.saveFlyer(true);
        }

        vm.goToFlyerByShowkase = function() {
            if (vm.showcase && vm.showcase.id) {
                vm.preSaveFlyer(true);
            } else {
                vm.saveFlyer(true);
            }
        }

        vm.saveFlyerPreview = function (isRedirectToFlyersScreen, callback) {
            vm.showcase.showcaseTemplateId = vm.templateId;
            if (vm.showcase.flyers.length >= 1 && vm.showcase.name) {
                vm.isSaving = true;
                vm.showcase.cover = "";
                vm.saveCover(function () {
                    if (vm.showcase.addImageFileDTO.length > 0) {
                        var flyers = angular.copy(vm.showcase.flyers);
                        var flyersPosition = [];
                        vm.showcase.flyers.forEach(function (flyer) {
                            flyersPosition.push({
                                    flyerId: flyer.id,
                                    position: flyer.position
                                });
                        });
                        vm.showcase.flyers = flyersPosition;
                        $q.all(vm.showcase.flyers).then(function (data) {
                            if (vm.showcaseId) {
                                ShowcasesService.updateShowcase(vm.showcase).then(function (data) {
                                    if (isRedirectToFlyersScreen) {
                                        $state.go('showcases-flyers', {
                                            showcaseId: data.id
                                        });
                                    } else {
                                        toastr.success($translate.instant('showcases.messages.update.success'));
                                        vm.isSaving = false;
                                    }
                                    if (callback) {
                                        callback(true);
                                    }
                                    vm.showcase.flyers = flyers;
                                    vm.isSavingPreview = false;
                                }, function (data) {
                                    toastr.error($translate.instant('showcases.messages.update.error'));
                                    vm.isSavingPreview = false;
                                    vm.isSaving = false;
                                });
                            } else {
                                ShowcasesService.saveShowcase(vm.showcase).then(function (data) {
                                    vm.showcase = data;
                                    toastr.success($translate.instant('showcases.messages.create.success'));
                                    vm.isSavingPreview = false;
                                    if (callback) {
                                        callback(true);
                                    }
                                    vm.showcase.flyers = flyers;
                                }, function (data) {
                                    toastr.error($translate.instant('showcases.messages.create.error'));
                                    vm.isSavingPreview = false;
                                });
                            }
                        });
                    } else if (!vm.showcase.cover) {
                        toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                    }
                });
            } else if (vm.showcase.flyers.length < 1) {
                toastr.error($translate.instant('showcases.messages.errors.blankFlyers'));
            } else if (!vm.showcase.name) {
                toastr.error($translate.instant('showcases.messages.errors.blankName'));
            }
        }

        vm.preSaveFlyer = function(isToRedirect) {
            if (vm.showcase && vm.showcase.id) {
                return ShowcasesService.getShowcase(vm.showcase.id, vm.showcase.ownerId).then(
                    function(response) {
                        vm._showcase = response;

                        var isAfter = moment(vm._showcase.updatedAt).isAfter(moment(vm.showcase.updatedAt)); // true

                        if (isAfter) {
                            ModalFactory.openSimpleModal(
                                "ATENÇÃO!",
                                "Identificamos alterações recentes na vitrine que você está prestes a alterar, deseja realmente confirmar suas alterações e descartar a versão anteriormente criada?",
                                "Confirmar",
                                "Cancelar",
                                function() {
                                    return vm.saveFlyer(isToRedirect);
                                }
                            );
                        } else {
                            vm.saveFlyer(isToRedirect);
                        }
                    }
                );
            } else {
                vm.saveFlyer(isToRedirect);
            }
        };


        vm.saveFlyer = function (isRedirectToFlyersScreen, callback, isSaving) {
            vm.showcase.showcaseTemplateId = vm.templateId;
            vm.isSaving = angular.isUndefined(isSaving) ? true : isSaving;
            vm.showcase.cover = "";
            vm.saveCover(function () {
                var flyers = angular.copy(vm.showcase.flyers);
                var flyersPosition = [];
                vm.showcase.flyers.forEach(function (flyer, index) {
                    flyersPosition.push({
                        flyerId: flyer.id,
                        position: index + 1
                    });
                });
                vm.showcase.flyers = flyersPosition;
                var banners = angular.copy(vm.showcase.addImageFileDTO);
                vm.showcase.addImageFileDTO.forEach(function (banner, index) {
                    banners[index].nameFile = vm.banners[index].name;
                    banners[index].action = vm.banners[index].link;
                });
                vm.showcase.addImageFileDTO = banners;

                $q.all(vm.showcase.flyers).then(function (data) {
                    if (vm.showcaseId) {
                        ShowcasesService.updateShowcase(vm.showcase).then(function (data) {
                            vm.showcase = data;
                            vm.banners = vm.showcase.banners;
                            vm.showcase.banners.forEach(function(banner, i) {
                                vm.banners[i].image = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].cover;

                                if (vm.banners[i].coverMobile) {
                                    vm.banners[i].imageMobile = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].coverMobile;
                                }
                            })

                            if (isRedirectToFlyersScreen) {
                                $state.go('showcases-flyers', {
                                    showcaseId: data.id,
                                    ownerId: data.ownerId
                                });
                            } else {
                                toastr.success($translate.instant('showcases.messages.update.success'));
                                vm.isSaving = false;
                                // Follow the instruction of Jackson, when saves the showcase the state doesn't need to be changed
                                // $state.go('showcases');
                            }
                            if (callback) {
                                callback(true);
                            }
                            vm.showcase.flyers = flyers;

                        }, function (data) {
                            if (isRedirectToFlyersScreen) {
                                toastr.error($translate.instant('showcases.messages.update.error'));
                                vm.isSaving = false;
                            }
                        });
                    } else {
                        ShowcasesService.saveShowcase(vm.showcase).then(function (data) {
                            vm.isSaving = false;
                            vm.showcase = data;
                            if (isRedirectToFlyersScreen) {
                                $state.go('showcases-flyers', {
                                    showcaseId: data.id,
                                    ownerId: data.ownerId
                                });
                            } else {
                                toastr.success($translate.instant('showcases.messages.create.success'));
                                // Follow the instruction of Jackson, when saves the showcase the state doesn't need to be changed
                                // $state.go('showcases');
                            }
                            if (callback) {
                                callback(true);
                                vm.isSaving = false;
                            }
                            vm.showcase.flyers = flyers;
                        }, function (data) {
                            vm.isSaving = false;
                            if (isRedirectToFlyersScreen) {
                                toastr.error($translate.instant('showcases.messages.create.error'));
                            }
                        });
                    }
                });
            });
        }

        vm.setBackgroundColor = function (color) {
            vm.showcase.backgroundColor = color;
        }

        vm.getCategoryName = function (flyer) {
            var category = _.find(vm.categories, function(el) {return el.key === flyer.categoryKey});
            if (category) {
                flyer.category = category.title;
            }
        }

        vm.getFlyerCurrency = function (currency) {
            return FlyersCurrencyValue[currency];
        }

        vm.loadFlyer = function () {
            vm.flyerId++;
            vm.flyersToLoad--;
        }

        vm.checkIfShowcasePublished = function () {
            if (vm.showcase.published) {
                return true;
            } else {
                return false;
            }
        }

        vm.getBackgroundImg = function (flyerId) {
            return ('\'/flyer/api/' + flyerId + '/picture\'');
        }

        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId);
        }

        getStoreInfo().then(function(response) {
            $localStorage.defaultStore.storeType = response.data.storeType;
            vm.store = response.data;
        });

        function showMessagePublishShowcase() {
            if (!$localStorage.defaultStore.storeNickname){
                getStoreInfo().then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    $localStorage.defaultStore.storeType = response.data.storeType;
                    vm.store = response.data;
                    buildMessagePublishShowcase();
                });
            } else {
                buildMessagePublishShowcase();
            }
        }

        function buildMessagePublishShowcase() {
            ModalFactory.openModal(null,
                $translate.instant('showcases.messages.publish.successTitle', {
                showcaseType: $translate.instant('global.showcaseTypes.' + vm.showcase.userInteract) }),
                $translate.instant('showcases.messages.publish.successSubtitle', {
                    url: 'http://' + $localStorage.defaultStore.storeNickname.toLowerCase() + "." + getDomainNameSufix($window, vm.store.storeType) }),
                null, $translate.instant('showcases.messages.publish.goToShowcase'),
                'OK', function(){$window.open('http://' + $localStorage.defaultStore.storeNickname.toLowerCase() + "." + getDomainNameSufix($window, vm.store.storeType), '_blank');},
                null, null, 'icon-ksc-showcasepublished');
        }

        function buildMessageGeneratedTabloid() {
            ModalFactory.openModal(null,
                'showcases.messages.tabloid.readyTabloid',
                null, null, 'OK', null, 'close',null, null, null,
                'showcases.messages.tabloid.ifNotDownloaded', 'showcases.messages.tabloid.clickHere',
            function(callback){
                ShowcasesService.generateTabloid({
                    showcaseId: Number(vm.showcase.id) || undefined,
                    storeId: ( storeId ? storeId + "" : undefined) || undefined,
                    flyers: vm.showcase.flyers.map(function (flyer) {
                        return flyer.id;
                    })
                }).then(function(res) {
                    var saveByteArray = (function() {
                        return function(data, name, mimeType) {
                            var blob = new Blob(data, {
                                type: mimeType
                            });
                            var url = window.URL.createObjectURL(blob);
                            var element = angular.element('<a/>');
                            element.attr({
                                href: url,
                                target: '_blank',
                                download: name
                            });
                            if(document.createEvent) {
                                var ev = document.createEvent("MouseEvent");
                                ev.initMouseEvent("click", true /* bubble */, true /* cancelable */, window, null, 0, 0, 0, 0, /* coordinates */
                                false, false, false, false,
                                /*
                                 * modifier keys
                                 */
                                0 /* left */, null);
                                element[0].dispatchEvent(ev);
                            } else {
                                element[0].fireEvent("onclick");
                            }
                            setTimeout(function() {
                                document.body.removeChild;
                                window.URL.revokeObjectURL(url);
                            }, 200);
                        };
                    }());
                    if (res.headers["content-disposition"]){
                        var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                        var mimeType = res.headers["content-type"];
                        filename = filename.replace(/['"]/g, '');
                        saveByteArray([res.data], filename, mimeType);
                    } else {
                        toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
                    }
                    vm.isPrinting = false;
                    callback();
                }, function(response) {
                    vm.isPrinting = false;
                    callback();
                });
            }, 'width: 143px; height: 170px;', 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/download-tabloide.png');
        }

        function storeOwnerHasMoipAccount() {
            Principal.storeOwnerHasMoipAccount().then(function (responseMoipAccount) {
                vm.storeOwnerHasMoipAccount = responseMoipAccount.data != null && responseMoipAccount.data.moipLogin != null;
            });
        }

        vm.openModalConfirmCatalogChange = function(showcaseId) {
            ModalFactory.openModal(null,
                $translate.instant('showcases.messages.publish.msgModal'),
                null,
                null, $translate.instant('showcases.home.buttons.publishShowcase'),
                $translate.instant('showcases.home.buttons.no'), function(){
                    vm.publishShowcase(showcaseId);
                },
                null, null, 'icon-warning', null, null, null, null, null, {'font-size': '1.6em'}, true);
        }

        vm.publishShowcase = function () {
            vm.isPublishing = true;
            if (!vm.showcase.hasCover && vm.coverEdit) {
                toastr.warning($translate.instant('showcases.messages.errors.blankCover'));
                vm.isSaving = false;
                vm.isPublishing = false;
            } else if (vm.showcase.flyers.length < 1 && !vm.showcase.customHtml) {
                toastr.warning($translate.instant('showcases.messages.errors.blankFlyersAndNullCustomHtml'));
                vm.isPublishing = false;
                vm.isSaving = false;
            } else if (!vm.showcase.name) {
                toastr.warning($translate.instant('showcases.messages.errors.blankName'));
                vm.isPublishing = false;
                vm.isSaving = false;
            } else {
                vm.saveFlyer(false, function () {
                    ShowcasesService.publishShowcase(vm.showcase.id).then(function(data) {
                        vm.isPublishing = false;
                        showMessagePublishShowcase();
                        $state.go('showcases');
                    }, function(data) {
                        if (data.headers("errorKey")){
                            toastr.error($translate.instant('showcases.messages.publish.errors.' + data.headers("errorKey")));
                        } else {
                            toastr.error($translate.instant('showcases.messages.publish.errors.genericError'));
                        }

                        vm.isPublishing = false;
                    });
                });
            }
        }

        vm.openInput = function (evt) {
            document.getElementById('fileInput').click();
        }

        vm.getPreviewURL = function (showcase) {
            if (showcase.id) {
                vm.openPreviewURL();
            } else {
                if (vm.saveFlyerPreview(false, function (data) {
                        if (data) {
                            $timeout(function (data) {
                                vm.openPreviewURL();
                            }, 1000);
                        }
                    }));
            }
        };

        vm.openPreviewURL = function () {
            $window.open('http://' + $localStorage.defaultStore.storeNickname + '.showkase.com.br/preview/' + vm.showcase.id, '_blank');
        };

        function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {
                type: mimeString
            });
        }

        vm.saveCover = function (callback) {
            vm.showcase.addImageFileDTO = [];

            if(vm.banners && (vm.banners.length === 0 ||  (vm.banners.length === 1 && vm.banners[0].image.indexOf(DEFAULT_IMAGE) != -1) )) {
                vm.loadingImage = false;
                if (callback) {
                    callback();
                }
            } else {
                var arr = Array.from(Array(vm.banners.length).keys());
                var aux = [];

                var index = 0;
                var orderNumber = 0;
                var blob = dataURItoBlob(vm.banners[index].image);
                var mobileImage = vm.banners[index].imageMobile;
                saveFlyerMultiImage(blob, arr, aux, index, orderNumber, mobileImage, callback);
            }
        }

        function saveFlyerMultiImage(blob, arr, aux, i, orderNumber, hasMobileImage, callback) {
            if (i === vm.banners.length) return;

            hasMobileImage = vm.banners[i].imageMobile;
            blob = dataURItoBlob(vm.banners[i].image);

            FlyersService.saveFlyerMultiImage(blob, i).then(function (response) {
                $timeout(function () {
                    if (response.data) {
                        aux.push('');
                        vm.showcase.hasCover = true;
                        if (hasMobileImage) {
                            var blobImageMobile = dataURItoBlob(vm.banners[i].imageMobile);
                            orderNumber = orderNumber + 1;
                            FlyersService.saveFlyerMultiImage(blobImageMobile, orderNumber).then(function (responseMobile) {
                                if (responseMobile) {
                                    response.data.mobileImageFile = responseMobile.data;
                                    arr[response.data.orderNumber] = response.data;
                                    if (aux.length === vm.banners.length) {
                                        vm.showcase.addImageFileDTO = arr;
                                        callback();
                                    }
                                    i = i + 1;
                                    saveFlyerMultiImage(blob, arr, aux, i, orderNumber, hasMobileImage, callback);
                                }
                            });
                        } else {
                            response.data.hasMobileImage = false;
                            arr[response.data.orderNumber] = response.data;
                            orderNumber = orderNumber + 1;
                            if (aux.length === vm.banners.length) {
                                vm.showcase.addImageFileDTO = arr;
                                callback();
                            }
                            i = i + 1;
                            saveFlyerMultiImage(blob, arr, aux, i, orderNumber, hasMobileImage, callback);
                        }
                    } else {
                        toastr.error($translate.instant('flyers.messages.create.error'));
                    }
                    vm.loadingImage = false;
                });
            }, function (response) {
                toastr.error($translate.instant('flyers.messages.create.image.uploadError'));
                vm.loadingImage = false;
            });
        }

		window.onDesignPublishCallback = function (data) {
		  var exportUrl = data.exportUrl;
		  var designId = data.designId;
		  loadImageToCroppieByURLCanvas(exportUrl);
		  //sendDataViaAjax (exportUrl, designId);
		}

        function openBannersModal() {
            vm.openAddBannersModal();
        }

        function removeBanner(index) {
            var carousel = document.getElementById("carousel");

            vm.banners.splice(index, 1);
            if (vm.banners.length === 0) {
                vm.haveBanners = false;
                vm.showcase.hasCover = false;
                vm.coverEdit = true;

                while(carousel.firstChild) {
                    carousel.removeChild(carousel.firstChild);
                }

                $scope.$apply();
            } else {
                loadCarousel();
            }
        }

        function loadCarousel() {
            var carousel = document.getElementById("carousel");

            while(carousel.firstChild) {
                carousel.removeChild(carousel.firstChild);
            }

            var counter = vm.banners.length;
            if(counter > 0) {
                carousel.style.display = 'block';
                var reversedBanners = vm.banners.slice().reverse();
                reversedBanners.forEach(function (banner) {
                    var name = banner.name;
                    if (name.length > 20) {
                        name = name.slice(0, 20).concat('...');
                    } else if (name.length == 0) {
                        name = "[SEM NOME]"
                    }

                    var srcImage = vm.isMobile
                        ? (banner.imageMobile ? banner.imageMobile : banner.image)
                        : banner.image;
                    if (srcImage.split(',')[0].indexOf('base64') == -1) {
                        srcImage += '?dummy=' + new Date().getTime();
                    }
                    carousel.insertAdjacentHTML(
                        "afterbegin",
                            ' <div class="carousel__item" style=" height: 100%; width: 100%;"> ' +
                        '<img id="img" style=" width: 100%; object-fit: cover; max-height: 100%;" src="' + srcImage + '"  alt="">  ' +
                        '<div style="width: 100%; position: absolute; bottom: 0; left: 0; text-align: center;" class="hidden-xs hidden-sm"> ' +
                        '<div class="carousel__title col-md-5">' + counter + 'º Banner <span class="carrousel__banner__name"> - ' + name + ' </span> ' +
                        '<span class="fa fa-edit" style="z-index: 10; color: #5b5b5b !important;"> </span> ' +
                        '<span class="fa fa-trash" style="z-index: 10; color: #5b5b5b !important; margin-left: 8px"> </span> </div> </div> </img> </div> '
                        );
                    counter--;
                    });

                var items = carousel.querySelectorAll(".carousel__item");


                var buttonsHtml = Array.from(items, function () {
                    return '<span class="carousel__button"></span>';
                });

                carousel.insertAdjacentHTML(
                    "beforeend",
                    ' <div class="carousel__nav">' + buttonsHtml.join("") + ' </div> ' );

                var carouselButtons = carousel.querySelectorAll(".carousel__button");
                carouselButtons.forEach(function (button, i) {
                        button.addEventListener("click", function() {
                            // un-select all the items
                            items.forEach(function (item) {
                                item.classList.remove("carousel__item--selected")
                                });
                            carouselButtons.forEach(function (button) {
                                button.classList.remove("carousel__button--selected")
                                });

                            items[i].classList.add("carousel__item--selected");
                            button.classList.add("carousel__button--selected");
                            vm.selectedBanner = i;
                        });
                    });

                // Select the first item on page load
                items[0].classList.add("carousel__item--selected");
                carouselButtons[0].classList.add("carousel__button--selected");

                // ARROW BUTTONS
                if (reversedBanners.length > 1) {
                    carousel.insertAdjacentHTML(
                        "beforeend",
                        ' <div class="backward_button arrow_buttons col-md-1"> <i class="fa fa-chevron-left carousel_arrows"></i> </div> ' );

                    carousel.insertAdjacentHTML(
                        "beforeend",
                        ' <div class="forward_button arrow_buttons col-md-1" style="margin-left: 91%"> <i class="fa fa-chevron-right carousel_arrows"></i> </div> ' );

                    var backwardButton = carousel.querySelectorAll(".backward_button");
                    backwardButton.forEach(function (button, i) {
                        button.addEventListener("click", function (){
                            // un-select all the items
                            items.forEach(function (item) {
                                    item.classList.remove("carousel__item--selected")
                                });
                            carouselButtons.forEach(function (button) {
                                    button.classList.remove("carousel__button--selected")
                                });

                            var index = vm.selectedBanner -= 1;
                            if (index < 0) {
                                index = 0;
                            }
                            vm.selectedBanner = index;
                            items[index].classList.add("carousel__item--selected");
                            carouselButtons[index].classList.add("carousel__button--selected");
                        });
                    });

                    var forwardButton = carousel.querySelectorAll(".forward_button");
                    forwardButton.forEach(function (button, i) {
                        button.addEventListener("click", function () {
                            // un-select all the items
                            items.forEach(function (item) {
                                item.classList.remove("carousel__item--selected")
                            });
                            carouselButtons.forEach(function (button){
                                button.classList.remove("carousel__button--selected")
                            });

                            var index = vm.selectedBanner += 1;
                            if (index > reversedBanners.length - 1) {
                                index = reversedBanners.length - 1;
                            }
                            vm.selectedBanner = index;
                            items[index].classList.add("carousel__item--selected");
                            carouselButtons[index].classList.add("carousel__button--selected");
                        });
                    });
                }


                vm.selectedBanner = 0;

                // BUTTON ACTIONS
                var editButtons = carousel.querySelectorAll(".fa-edit");
                editButtons.forEach(function (button, i) {
                    button.addEventListener("click", function() {
                        openBannersModal();
                    });
                });

                var trashButtons = carousel.querySelectorAll(".fa-trash");
                trashButtons.forEach(function (button, i) {
                    button.addEventListener("click", function(){
                        removeBanner(i);
                    });
                });

                }
        }


		$scope.$on("$destroy", function () {
            if (!angular.isUndefined(userInteractModal)) {
                userInteractModal.close();
            }
        });

        vm.openAddBannersModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/admin/showcases/banner-modal/banners_modal.html',
                controller: 'BannersModalController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    banners: function () {
                        return vm.banners
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    vm.banners = response.banners;
                    vm.haveBanners = true;
                    vm.showcase.hasCover = true;
                    loadCarousel();
                }
            });
        }

        vm.openAddCustomHtmlModal = function () {
            $uibModal.open({
                templateUrl: 'app/admin/showcases/custom-html-modal/custom-html-modal.html',
                controller: 'CustomHtmlModalController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    customHtml: function () {
                        return vm.showcase.customHtml
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    vm.showcase.customHtml = response.customHtml;
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('showcases', {
                parent: 'admin',
                url: '/showcases',
                data: {
                    authorities: ['STORE_READ_SHOWCASE'],
                    pageTitle: 'showcases.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/showcases/showcases.html',
                        controller: 'ShowcasesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('bag');
                        return $translate.refresh();
                    }]

                }
            })
            .state('showcases.new', {
                parent: 'showcases',
                url: '/new',
                data: {
                    authorities: ['STORE_CREATE_SHOWCASE'],
                    pageTitle: 'showcases.detail.title',
                    specialClass: "md-skin fixed-nav"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/showcases/showcases-detail.html',
                        controller: 'ShowcasesDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]

                }
            })
            .state('showcases.edit', {
                parent: 'showcases',
                url: '/{showcaseId}',
                data: {
                    authorities: ['STORE_UPDATE_SHOWCASE'],
                    pageTitle: 'showcases.detail.title',
                    specialClass: "md-skin fixed-nav"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/showcases/showcases-detail.html',
                        controller: 'ShowcasesDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]

                }
            })
            .state('showcases-flyers', {
                parent: 'showcases',
                url: '/flyers/{showcaseId}',
                data: {
                    authorities: ['STORE_READ_FLYER', 'STORE_CREATE_SHOWCASE', 'STORE_UPDATE_SHOWCASE'],
                    pageTitle: 'showcases.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/showcases/showcases-flyers.html',
                        controller: 'ShowcasesFlyersController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    flyersId: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]

                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('ShowcasesService', ShowcasesService);

    ShowcasesService.$inject = ['ShowcasesFactory', '$localStorage', 'Upload'];

    function ShowcasesService(ShowcasesFactory, $localStorage, Upload) {

        var service = {
            getTemplates: getTemplates,
            getTemplate: getTemplate,
            listShowcases: listShowcases,
            listBagsFiltersValues: listBagsFiltersValues,
            getShowcase: getShowcase,
            saveShowcase: saveShowcase,
            updateShowcase: updateShowcase,
            getPublishedShowcaseByStoreId: getPublishedShowcaseByStoreId,
            deleteShowcases: deleteShowcases,
            publishShowcase: publishShowcase,
            getNumberOfVisualization: getNumberOfVisualization,
            generateTabloid: generateTabloid,
            saveBag: saveBag,
            findFlyerByFilterBag: findFlyerByFilterBag,
            getNumberOfFlyers: getNumberOfFlyers,
            getAllFlyerIdsFromShowcasesPublished: getAllFlyerIdsFromShowcasesPublished,
            deletePublishedFlyer: deletePublishedFlyer,
            deletePublishedFlyers: deletePublishedFlyers,
            addPublishedFlyer: addPublishedFlyer,
            addPublishedFlyers: addPublishedFlyers,
            isFlyerPublished: isFlyerPublished,
            createBagByRecommendation: createBagByRecommendation
        };

        return service;

        function saveBag(bag) {
            return ShowcasesFactory.saveBag(bag).$promise;
        }

        function findFlyerByFilterBag(pageable, bag) {
            return ShowcasesFactory.findFlyerByFilterBag(pageable, bag).$promise;
        }

        function saveShowcase(showcase) {
            return ShowcasesFactory.save(showcase).$promise;
        }

        function updateShowcase(showcase) {
            return ShowcasesFactory.update(showcase).$promise;
        }

        function getTemplate(templateId) {
            return ShowcasesFactory.getTemplate({
                templateId: templateId
            }).$promise;
        }

        function getTemplates() {
            return ShowcasesFactory.getTemplates().$promise;
        }

        function listShowcases(showcase, pageable, onSuccess, onError) {
            return ShowcasesFactory.listAll(pageable, showcase, onSuccess, onError);
        }

        function listBagsFiltersValues(showcase, onSuccess, onError) {
            return ShowcasesFactory.listBagsFiltersValues(showcase, onSuccess, onError);
        }

        function getShowcase(id, ownerId) {
            return ShowcasesFactory.get({
                id: id,
                ownerId: ownerId
            }).$promise;
        }

        function getAllFlyerIdsFromShowcasesPublished() {
            return ShowcasesFactory.getAllFlyerIdsFromShowcasesPublished().$promise;
        }

        function publishShowcase(showcaseId) {
            return ShowcasesFactory.publish({
                id: showcaseId
            }, {}).$promise;
        }
        function getPublishedShowcaseByStoreId() {
            return ShowcasesFactory.getPublishedShowcaseByStoreId().$promise;
        }

        function deleteShowcases(showcaseIds) {
            return ShowcasesFactory.deletebyids({
                showcaseIds: showcaseIds
            }).$promise;
        }

        function getNumberOfVisualization(id) {
            return ShowcasesFactory.getNumberOfVisualization(id).$promise;
        }

        function getNumberOfFlyers(id) {
            return ShowcasesFactory.getNumberOfFlyers({id: id}).$promise;
        }

        function generateTabloid(dto){
            return ShowcasesFactory.generateTabloid(dto).$promise;
        }

        function addPublishedFlyer(id){
            return ShowcasesFactory.getPublishedFlyer({id: id}).$promise;
        }

        function addPublishedFlyers(flyersId){
            return ShowcasesFactory.getPublishedFlyers(flyersId).$promise;
        }

        function deletePublishedFlyer(id){
            return ShowcasesFactory.deletePublishedFlyer({id: id}).$promise;
        }

        function deletePublishedFlyers(flyersId){
            return ShowcasesFactory.deletePublishedFlyers(flyersId).$promise;
        }

        function isFlyerPublished(id){
            return ShowcasesFactory.isFlyerPublished({id: id}).$promise;
        }

        function createBagByRecommendation(showkase) {
            return ShowcasesFactory.createBagByRecommendation(showkase).$promise;
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ShowcasesFactory', ShowcasesFactory);

    ShowcasesFactory.$inject = ['$resource'];

    function ShowcasesFactory($resource) {
        var resourceUrl = 'flyer/api/showcase/:id';

        return $resource(resourceUrl, {}, {
            'saveBag':  {
                method: 'POST',
                isArray: false,
                url: 'flyer/api/showcase/bag'
            },
            'findFlyerByFilterBag': {
                method: 'POST',
                isArray: false,
                url: 'flyer/api/showcase/bag/flyers/filter'
            },
            'get': {},
            'getTemplates': {
                method: 'GET',
                isArray: true,
                url: 'flyer/api/showcase-template'
            },
            'getAllFlyerIdsFromShowcasesPublished': {
                method: 'GET',
                isArray: true,
                url: 'flyer/api/flyer/listall/publish'
            },
            'getTemplate': {
                url: 'flyer/api/showcase-template/:templateId'
            },
            'listAll': {
                method: 'POST',
                url: 'flyer/api/showcase/list',
                isArray: true
            },
            'listBagsFiltersValues': {
                method: 'POST',
                url: 'flyer/api/showcase/bag/filter/values'
            },
            'update': {
                method: 'PUT'
            },
            'deletebyids': {
                method: 'POST',
                url: '/flyer/api/showcase/deleteByIds'
            },
            'publish': {
                method: 'PUT',
                url: '/flyer/api/showcase/:id/publishe'
            },
            'getNumberOfVisualization': {
                method: 'POST',
                url: '/flyer/api/showcase/numberOfVisualizations',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getNumberOfFlyers': {
                method: 'GET',
                url: '/flyer/api/showcase/bag/:id/numberOfFlyers',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getPublishedShowcaseByStoreId': {
                method: 'GET',
                url: '/flyer/api/showcase/store/published',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.headers = headers();
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'generateTabloid': {
                method: 'POST',
                url: '/flyer/api/showcase-tabloid/generate-tabloid',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getPublishedFlyer': {
                method: 'GET',
                url: 'flyer/api/showcase/published/flyer/:id',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getPublishedFlyers': {
                method: 'POST',
                url: 'flyer/api/showcase/published/publish-flyers',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'deletePublishedFlyer': {
                method: 'DELETE',
                url: 'flyer/api/showcase/published/flyer/:id',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'deletePublishedFlyers': {
                method: 'POST',
                url: 'flyer/api/showcase/published/unpublish-flyers',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'isFlyerPublished': {
                method: 'GET',
                url: 'flyer/api/showcase/flyer/:id/published',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'createBagByRecommendation':  {
                method: 'POST',
                isArray: false,
                url: 'flyer/api/showcase/bag-by-recommendation'
            },

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ShowcasesController', ShowcasesController);


    /** @ngInject */
    function ShowcasesController(   $window, $state, RemoveModalFactory, $localStorage, $translate, StoreService,
                                    ShowcasesService, toastr, ModalFactory, paginationConstants, DOMAIN, $rootScope) {

        var vm = this;

        var hasCover = false;

        vm.listFilter = {
            ownerId: $localStorage.defaultStore.storeId,
            rowsForPage: "20"
        };

        vm.dateRangeOptions = {
            opens: 'right',
            drops: 'down',
            locale: {
                applyLabel: $translate.instant('bag.filters.apply'),
                fromLabel: "From",
                format: "DD/MM/YYYY",
                toLabel: "To",
                cancelLabel: $translate.instant('bag.form.buttons.cancel'),
                customRangeLabel: $translate.instant('global.form.period')
            },
            ranges: {
            },
            eventHandlers: {
                'apply.daterangepicker': function (ev, picker) {
                    if(vm.dateRange.startDate === undefined || vm.dateRange.endDate === undefined) {
                        vm.dateRange = {startDate: moment().startOf("day"), endDate: moment().endOf("day")}
                    }
                    vm.listFilter.startDate = vm.dateRange.startDate;
                    vm.listFilter.endDate = vm.dateRange.endDate;
                    vm.loadShowcases(null, true);
                }
            }
        };

        vm.dateRange = '';

        vm.hasntStoreYet = !$localStorage.defaultStore.storeId;

        vm.isPublishing = false;

        vm.isAllSelected = false;
        vm.showcases = [];
        vm.showcasesToRemove = [];
        vm.userHasShowcases = false;

        vm.numPerPage = parseInt(vm.listFilter.rowsForPage);
        vm.currentPage = 1;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;
        vm.totalBags = 0;
        vm.maxSize = 5;

        vm.store = $localStorage.defaultStore;

        vm.page = 0;
        vm.hasNextPage = false;
        vm.busy = false;
        var SHOWCASE_PUBLISHED = "RELEASED";

        loadAll();
        fillRanges();

        /**
         * Load all values
         */
        function loadAll() {
            vm.isLoading = true;
            loadShowcases();
        }


        /**
         * Loads showcases by page and reset
         * @param page
         *  Page of the list
         * @param reset
         *  If true, reset displayed values
         */
        vm.loadShowcases = function (page, reset) {
            if(reset) {
                vm.resetPage();
            }else vm.page = page;

            loadShowcases();
        }

        /**
         * Refresh the page of bags exhibition
         */
        vm.refreshPage = function () {
            vm.page = vm.currentPage - 1;

            loadShowcases();
            vm.onPageChanged();
        }

        /**
         * Callback to refresh page view when page is changed.
         */
        vm.onPageChanged = function () {
            vm.deselectAllShowcases();

            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.startRegistry = begin + 1;
            vm.endRegistry = end;
        }

        /**
         * Resets the pagination
         */
        vm.resetPage = function () {
            vm.currentPage = 1;
            vm.refreshPage();
        }

        /**
         * Changes by select box the current quantity of bags to be shown for each page and resets the pagination
         */
        vm.changePagination = function() {
            vm.numPerPage = parseInt(vm.listFilter.rowsForPage);
            vm.resetPage();
        };

        /**
         * Loads all the showcases with filters
         */
        function loadShowcases() {
            if(vm.busy) return;
            vm.busy = true;


            var pageable = {
                page: vm.page,
                size: vm.numPerPage
            };

            if (vm.listFilter.ownerId){

                vm.listFilter.isPrimary = true;

                /**
                 * If the user hasn't a store, this script below cannot be executed
                 */

                ShowcasesService.listShowcases(vm.listFilter, pageable, onSuccess, onError);

                function onSuccess(data, headers) {
                    vm.hasNextPage = headers('X-Has-Next-Page') === "true";
                    vm.totalBags = parseInt(headers('X-Total-Count'));
                    vm.showcases = []
                    for (var i = 0; i < data.length; i++) {
                        vm.showcases.push(data[i]);
                    }
                    vm.isLoading = false;
                    if (vm.showcases.length >= 1) {
                        vm.userHasShowcases = true;
                    }
                    vm.showcases.forEach(function(showcase) {
                        ShowcasesService.getNumberOfVisualization(showcase.id).then(function(response) {
                            showcase.numberOfVisualizations = response.data;
                        });
                    });
                    vm.busy = false;
                }

                function onError(response) {
                    vm.isLoading = false;
                    vm.busy = false;

                    if (response.headers('X-flyerApp-alert') == 'userHasNoStore'){
                        toastr.error($translate.instant('showcases.messages.errors.noStore'));
                    }
                }

            } else {
                vm.hasntStoreYet = true;
                vm.busy = false;
                vm.isLoading = false;
            }


        }

        /**
         * Fill dateRangeOptions variable with translated keys and respective date values
         */
        function fillRanges() {
            vm.dateRangeOptions.ranges[$translate.instant('global.form.today')] = [moment(), moment()]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.yesterday')] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.last7Days')] = [moment().subtract(6, 'days'), moment()]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.last15Days')] = [moment().subtract(14, 'days'), moment()]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.last30Days')] = [moment().subtract(29, 'days'), moment()]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.last60Days')] = [moment().subtract(59, 'days'), moment()]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.last90Days')] = [moment().subtract(99, 'days'), moment()]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.lastYear')] = [moment().subtract(1, 'year'), moment()]
        }

        vm.getEditPage = function(showcaseId) {
            $state.go('showcases.edit', {
                showcaseId: showcaseId
            });
        }


        vm.updateShowcasesToRemove = function(showcaseId) {
            if (vm.showcasesToRemove.indexOf(showcaseId) != '-1') {
                vm.showcasesToRemove.splice(vm.showcasesToRemove.indexOf(showcaseId), 1);
            } else {
                vm.showcasesToRemove.push(showcaseId);
            }
        }

        vm.checkIfShowcaseSelected = function(showcaseId) {
            if (vm.showcasesToRemove.indexOf(showcaseId) != '-1') {
                return true;
            } else {
                return false;
            }
        }

        vm.checkIsNotLoading = function() {
            return !vm.isLoading;
        }

        vm.checkIfShowcasePublished = function(showcaseStatus) {
            if (showcaseStatus) {
                return true;
            } else {
                return false;
            }
        }

        vm.openModalConfirmCatalogChange = function(showcaseId) {
            ModalFactory.openModal(null,
                $translate.instant('showcases.messages.publish.msgModal'),
                null,
                null, $translate.instant('showcases.home.buttons.publishShowcase'),
                $translate.instant('showcases.home.buttons.no'), function(){
                    vm.publishShowcase(showcaseId);
                },
                null, null, 'icon-warning', null, null, null, null, null, {'font-size': '1.6em'}, true);
        }

        vm.publishShowcase = function(showcaseId) {
            var showcase = undefined;
            ShowcasesService.getShowcase(showcaseId).then(function (response) {
                showcase = response;
                if (!showcase || !showcase.id){
                    toastr.error($translate.instant('showcases.messages.publish.error'));
                }
                else if (!showcase.hasCover) {
                    toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                    vm.isSaving = false;
                } else if (showcase.flyers.length < 1) {
                    toastr.error($translate.instant('showcases.messages.errors.blankFlyers'));
                } else if (!showcase.name) {
                    toastr.error($translate.instant('showcases.messages.errors.blankName'));
                } else {
                    vm.isPublishing = true;
                    ShowcasesService.publishShowcase(showcaseId).then(function(data) {
                        toastr.success($translate.instant('showcases.messages.publish.success'));
                        vm.isPublishing = false;

                        ModalFactory.openModal(null,
                            $translate.instant('showcases.messages.publish.successTitle', {
                            showcaseType: $translate.instant('global.showcaseTypes.' + showcase.userInteract) }),
                            $translate.instant('showcases.messages.publish.successSubtitle', {
                                url: 'http://' + $localStorage.defaultStore.storeNickname.toLowerCase() + "." + getDomainNameSufix($window, vm.store.storeType) }),
                            null, $translate.instant('showcases.messages.publish.goToShowcase'),
                            'OK', function(){$window.open('http://' + $localStorage.defaultStore.storeNickname.toLowerCase() + "." + getDomainNameSufix($window, vm.store.storeType), '_blank')},
                            null, null, 'icon-ksc-showcasepublished');

                        $state.reload();
                    }, function(data) {
                        vm.isPublishing = false;
                        toastr.error($translate.instant('showcases.messages.publish.error'));
                    });
                }
            }, function (data) {

                if (data.headers("errorKey")){
                    toastr.error($translate.instant('showcases.messages.publish.errors.' + data.headers("errorKey")));
                } else {
                    toastr.error($translate.instant('showcases.messages.publish.errors.genericError'));
                }

                vm.isPublishing = false;
            });

        }

        vm.getPreviewURL = function(showcaseId) {
            if (!$localStorage.defaultStore.storeNickname){
                getStoreInfo().then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    $localStorage.defaultStore.storeType = response.data.storeType;
                    vm.store = response.data;
                    $window.open($window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/preview/' + showcaseId, '_blank');
                });
            } else {
                $window.open($window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/preview/' + showcaseId, '_blank');
            }

        }

        vm.getShowcaseURL = function() {
            if (!$localStorage.defaultStore.storeNickname) {
                getStoreInfo().then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    $localStorage.defaultStore.storeType = response.data.storeType;
                    vm.store = response.data;
                    $window.open($window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType), '_blank');
                });
            } else {
                $window.open($window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType), '_blank');
            }

        }

        vm.openDatePicker = function () {
            document.getElementById('dateRangeInput').click()
        }

        vm.generateTabloid = function(showkase) {
            ShowcasesService.getShowcase(showkase.id).then(function (response) {
                showkase = response;
                if (!showkase.hasCover) {
                    toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                    vm.isSaving = false;
                } else if (showkase.flyers.length < 1) {
                    toastr.error($translate.instant('showcases.messages.errors.blankFlyers'));
                } else if (!showkase.name) {
                    toastr.error($translate.instant('showcases.messages.errors.blankName'));
                } else {
                    vm.isPrinting = true;
                    buildMessageGeneratedTabloid(showkase);
                    $rootScope.$emit('waiting-generates-tabloid');
                    ShowcasesService.generateTabloid({
                        showcaseId: Number(showkase.id) || undefined,
                        storeId: ( $localStorage.defaultStore ? $localStorage.defaultStore.storeId + "" : undefined) || undefined,
                        flyers: []
                    }).then(succesPrint, errorPrint);
                }
            })
        }

        function buildMessageGeneratedTabloid(showkase) {
            ModalFactory.openModal(null,
                'showcases.messages.tabloid.readyTabloid',
                null, null, 'OK', null, 'close',null, null, null,
                'showcases.messages.tabloid.ifNotDownloaded', 'showcases.messages.tabloid.clickHere',
            function(callback){
                ShowcasesService.generateTabloid({
                    showcaseId: Number(showkase.id) || undefined,
                    storeId: ( $localStorage.defaultStore ? $localStorage.defaultStore.storeId + "" : undefined) || undefined,
                    flyers: []
                }).then(succesPrint, errorPrint);
            }, 'width: 143px; height: 170px;', 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/download-tabloide.png');
        }

        function succesPrint(res) {

            var saveByteArray = (function() {
                return function(data, name, mimeType) {
                    var blob = new Blob(data, {
                        type: mimeType
                    });
                    var url = window.URL.createObjectURL(blob);
                    var element = angular.element('<a/>');
                    element.attr({
                        href: url,
                        target: '_blank',
                        download: name
                    });
                    if(document.createEvent) {
                        var ev = document.createEvent("MouseEvent");
                        ev.initMouseEvent("click", true /* bubble */, true /* cancelable */, window, null, 0, 0, 0, 0, /* coordinates */
                        false, false, false, false,
                        /*
                         * modifier keys
                         */
                        0 /* left */, null);
                        element[0].dispatchEvent(ev);
                    } else {
                        element[0].fireEvent("onclick");
                    }
                    setTimeout(function() {
                        document.body.removeChild;
                        window.URL.revokeObjectURL(url);
                    }, 200);
                };
            }());
            if (res.headers["content-disposition"]){
                var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                var mimeType = res.headers["content-type"];
                filename = filename.replace(/['"]/g, '');
                saveByteArray([res.data], filename, mimeType);
            } else {
                toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
            }

            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
        }

        function errorPrint(response) {
            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
            toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
        }

        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId);
        }

        getStoreInfo().then(function(response) {
            $localStorage.defaultStore.storeType = response.data.storeType;
            vm.store = response.data;
        });

        /**
         * Verify if all showcases are selected
         * @returns {*|boolean} True if all showcases are selected
         */
        vm.isShowAllSelected = function () {
            vm.isAllSelected = vm.showcases.length > 0 && vm.showcasesToRemove.length === vm.showcases.length;
            return vm.isAllSelected;
        }

        /**
         * Select or deselect all showcases.
         * If all showcases are selected, deselect all the showcases
         * If not all showcases are selected, then selects all the showcases
         */
        vm.changeSelectionOfAllShowcases = function () {
            if (vm.isAllSelected) {
                vm.deselectAllShowcases();
            } else {
                vm.selectAllShowcases();
            }

        }

        /**
         * Select all showcases
         */
        vm.selectAllShowcases = function () {
            var showcasesToRemoveTemp = [];
            for (var i = 0; i < vm.showcases.length; i++) {
                showcasesToRemoveTemp.push(vm.showcases[i].id)
            }
            vm.showcasesToRemove = showcasesToRemoveTemp;
            vm.isAllSelected = true;
        }

        /**
         * Deselect all showcases
         */
        vm.deselectAllShowcases = function () {
            vm.showcasesToRemove = [];
            vm.isAllSelected = false;
        }

        /**
         * Removes from database the selected showcases
         */
        vm.removeShowcases = function() {
            if (vm.showcasesToRemove.length >= 1) {
                RemoveModalFactory.deleteItem(vm.showcasesToRemove.length).then(function(data) {
                    ShowcasesService.deleteShowcases(vm.showcasesToRemove).then(function(data) {
                        toastr.success($translate.instant('showcases.messages.remove.success'));
                        vm.showcases = [];
                        vm.showcasesToRemove = [];
                        loadShowcases();
                    }, function(data) {
                        toastr.error($translate.instant('showcases.messages.remove.error'));
                    });
                });
            } else {
                toastr.error($translate.instant('showcases.messages.remove.noItens'));
            }
        }

        vm.getImageSrc = function (showcaseId) {
            return "content/images/templates/"+ showcaseId +".png"
        }

    }

})();

(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .controller('SelectColorsModalConstroller', SelectColorsModalConstroller);

    /** @ngInject */
    function SelectColorsModalConstroller($uibModalInstance, $scope, colors) {

        var vm = this;
        vm.colorForm = colors;

        setTimeout(function () {
            loadBackgroundColorPicker();
            loadHeaderBackgroundColorPicker();
            loadIconColorPicker();
        });

        function loadBackgroundColorPicker() {
            var backgroundColorContent = document.querySelector('.background-color-picker');
            var backgroundDiv = document.createElement('div');
            backgroundColorContent.appendChild(backgroundDiv);

            vm.backgroundPickr = Pickr.create({
                el: backgroundDiv,
                theme: 'monolith',
                default: vm.colorForm.backgroundColor,
                swatches: ['#F44336', '#9C27B0', '#3F51B5',
                    '#03A9F4', '#009688', '#4CAF50', '#FFEB3B',
                    '#000000', '#3E3E3E', '#787878', '#A0A0A0',
                    '#AAAAAA', '#DEDEDE', '#FFFFFF'],
                components: {
                    opacity: false,
                    hue: true,
                    preview: true,
                    interaction: {
                        input: true,
                        save: true
                    }
                },
                i18n: {
                    'btn:save': 'Alterar',
                }
            });

            vm.backgroundPickr.on('save', function (color, instance) {
                vm.colorForm.backgroundColor = angular.copy(color.toHEXA().toString());
                $scope.$apply();
                vm.backgroundPickr.hide();
            });
        }

        function loadHeaderBackgroundColorPicker() {
            var backgroundColorContent = document.querySelector('.header-color-picker');
            var backgroundDiv = document.createElement('div');
            backgroundColorContent.appendChild(backgroundDiv);

            vm.headerPickr = Pickr.create({
                el: '.header-color-picker',
                theme: 'monolith',
                default: vm.colorForm.headerBackgroundColor ? vm.colorForm.headerBackgroundColor : vm.colorForm.backgroundColor,
                swatches: ['#F44336', '#9C27B0', '#3F51B5',
                    '#03A9F4', '#009688', '#4CAF50', '#FFEB3B',
                    '#000000', '#3E3E3E', '#787878', '#A0A0A0',
                    '#AAAAAA', '#DEDEDE', '#FFFFFF'],
                components: {
                    opacity: false,
                    hue: true,
                    preview: true,
                    interaction: {
                        input: true,
                        save: true
                    }
                },
                i18n: {
                    'btn:save': 'Alterar',
                }
            });

            vm.headerPickr.on('save', function (color, instance) {
                vm.colorForm.headerBackgroundColor = angular.copy(color.toHEXA().toString());
                $scope.$apply();
                vm.headerPickr.hide();
            });
        }

        function loadIconColorPicker() {
            var backgroundColorContent = document.querySelector('.icon-color-picker');
            var backgroundDiv = document.createElement('div');
            backgroundColorContent.appendChild(backgroundDiv);

            vm.iconColorPickr = Pickr.create({
                el: '.icon-color-picker',
                theme: 'monolith',
                default: vm.colorForm.iconColor ? vm.colorForm.iconColor : '#FFFFFF',
                swatches: ['#F44336', '#9C27B0', '#3F51B5',
                    '#03A9F4', '#009688', '#4CAF50', '#FFEB3B',
                    '#000000', '#3E3E3E', '#787878', '#A0A0A0',
                    '#AAAAAA', '#DEDEDE', '#FFFFFF'],
                components: {
                    opacity: false,
                    hue: true,
                    preview: true,
                    interaction: {
                        input: true,
                        save: true
                    }
                },
                i18n: {
                    'btn:save': 'Alterar',
                }
            });

            vm.iconColorPickr.on('save', function (color, instance) {
                vm.colorForm.iconColor = angular.copy(color.toHEXA().toString());
                $scope.$apply();
                vm.iconColorPickr.hide();
            });
        }

        vm.closeModal = function () {
            $uibModalInstance.close();
        }

        vm.save = function() {
            $uibModalInstance.close(vm.colorForm);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('UserInteractModalFactory', UserInteractModalFactory);

    /** @ngInject */
    function UserInteractModalFactory($uibModal) {

        var factory = {
            selectUserInterectType: selectUserInterectType
        }

        return factory;

        function selectUserInterectType(storeId, selectedType, backUrl) {
            return showUserInterectModal(storeId, selectedType, backUrl);
        }

        function showUserInterectModal(storeId, selectedType, backUrl) {
            return $uibModal.open({
                templateUrl: "app/admin/showcases/modal/_modal_user_interact.html",
                size: 'lg',
                backdrop: 'static',
                keyboard : false,
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                controller: "UserInteractModalConstroller",
                controllerAs: "vm",
                resolve: {
                    storeId: function () {
                        return storeId;
                    },
                    selectedType: function() {
                        return angular.copy(selectedType);
                    },
                    isStoreOwner: function(Principal) {
                        return Principal.isStoreOwner();
                    },
                    storeOwnerHasMoipAccount: function(Principal, StoreService, $q) {
                        var deferred = $q.defer();

                        Principal.storeOwnerHasMoipAccount().then(function (responseMoipAccount) {
                            deferred.resolve(responseMoipAccount.data != null
                                                && responseMoipAccount.data.moipLogin != null);
                        },function(){
                            deferred.resolve(false);
                        });

                        return deferred.promise;
                    },
                    backUrl: function () {
                        return backUrl ? backUrl : 'showcases';
                    }
                }
            });
        }
    }
})();

(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .controller('UserInteractModalConstroller', UserInteractModalConstroller);

    /** @ngInject */
    function UserInteractModalConstroller($uibModalInstance, storeId, StoreService, storeOwnerHasMoipAccount, selectedType,
                                          $state, isStoreOwner, backUrl) {

        var vm = this;

        vm.selectedType = angular.isUndefined(selectedType) ? undefined : selectedType;
        vm.intentionType = vm.selectedType

        vm.selectIntentionType = selectIntentionType;
        vm.goToSettings = goToSettings;
        vm.goToDetail = goToDetail;
        vm.goBack = goBack;
        vm.cancel = cancel;
        vm.next = next;
        vm.isStoreOwner = isStoreOwner.data;
        vm.storeOwnerHasMoipAccount = storeOwnerHasMoipAccount;


        if (storeId) {
            StoreService.getStore(storeId).then(function (response) {
                vm.store = response.data;
            });
        }

        function selectIntentionType(type) {
            vm.intentionType = type;
        }

        function next() {
            $uibModalInstance.close(vm.intentionType);
        }

        function cancel() {
            $uibModalInstance.close(vm.selectedType);
        }

        function goBack() {
            $state.go(backUrl);
        }

        function goToSettings() {
            $state.go('payment-settings', {tab: 2});
        }

        function goToDetail() {
            $state.go('store-detail');
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('CustomHtmlModalController', CustomHtmlModalController);

    CustomHtmlModalController.$inject = ['$uibModalInstance', 'customHtml'];

    function CustomHtmlModalController($uibModalInstance, customHtml) {

        var vm = this;
        vm.customHtml = customHtml;

        vm.closeModal = function () {
            $uibModalInstance.close();
        }

        vm.save = function () {
            $uibModalInstance.close({ customHtml: vm.customHtml });
        }

        vm.clear = function () {
            vm.customHtml = null;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('BannersModalController', BannersModalController);

    BannersModalController.$inject = ['$uibModalInstance', '$translate', '$localStorage', 'toastr', 'banners'];

    var BANNER_LINK_MAX_SIZE = 1000;

    function BannersModalController($uibModalInstance, $translate, $localStorage, toastr, banners) {

        var vm = this;
        vm.banners = angular.copy(banners);

        vm.DEFAULT_IMAGE = 'content/images/1-image-default-banner.png';

        function loadAll() {
            if (vm.banners.length === 0) {
                vm.addNewBanner();
            } else {
                vm.banners.forEach(function (banner) {
                    var srcImage = banner.image;
                    if (srcImage.split(',')[0].indexOf('base64') == -1) {
                        banner.image = banner.image + '?dummy=' + new Date().getTime();
                    }

                    if (banner.imageMobile && banner.imageMobile.split(',')[0].indexOf('base64') == -1) {
                        banner.imageMobile = banner.imageMobile + '?dummy=' + new Date().getTime();
                    } else if (!banner.imageMobile){
                        banner.imageMobile = vm.DEFAULT_IMAGE;
                    }
                });
            }
        }

        vm.addNewBanner = function () {
            vm.banners.push({
                'id': vm.banners.length + 1,
                'image': vm.DEFAULT_IMAGE,
                'imageMobile': vm.DEFAULT_IMAGE,
                'name': '',
                'link': ''
            });
            waitForElementToDisplay(vm.banners.length,function(){document.getElementById(vm.banners.length).scrollIntoView();},100,9000);
        }

        function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
            var startTimeInMs = Date.now();
            (function loopSearch() {
                if (document.getElementById(selector) != null) {
                    callback();
                    return;
                }
                else {
                    setTimeout(function () {
                        if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                            return;
                        loopSearch();
                    }, checkFrequencyInMs);
                }
            })();
        }

        vm.removeBanner = function (index) {
            vm.banners.splice(index, 1);
            if (vm.banners.length === 0) {
                vm.addNewBanner();
            }
        }

        vm.closeModal = function(response) {
            $uibModalInstance.close(response);
        }

        vm.closeDropDown = function () {
            $("md-backdrop").trigger('click');
        }

        vm.applyBanners = function () {
            var error = false;
            vm.banners.forEach(function(banner, i) {
                if (banner.image.indexOf(vm.DEFAULT_IMAGE) != -1) {
                    toastr.error($translate.instant('showcases.detail.banner.error.bannerWithoutImage'));
                    error = true;
                } else if (banner.link && banner.link.length > BANNER_LINK_MAX_SIZE){
                    toastr.error($translate.instant('showcases.detail.banner.error.bannerLinkExceedingSizeLimit'));
                    error = true;
                } else if (banner.image.includes("?dummy=")) {
                    banner.image = banner.image.split("?dummy=")[0];
                }

                if (banner.imageMobile.indexOf(vm.DEFAULT_IMAGE) != -1) {
                    banner.imageMobile = null;
                } else if (banner.imageMobile.includes("?dummy=")) {
                    banner.imageMobile = banner.imageMobile.split("?dummy=")[0];
                } else if (banner.imageMobile.includes('base64')) {
                    banner.coverMobile = null;
                }
            });

            if (!error) {
                vm.closeModal({banners: vm.banners});
            }
        }

        vm.selectImg = function(index) {
            vm.index = index;
            vm.imageType = 'image';
            angular.element(document.getElementById('fileInput' + index)).on('change', handleFileSelect);
            document.getElementById('fileInput' + index).click();
        }

        vm.selectImgMobile = function(index) {
            vm.index = index;
            vm.imageType = 'imageMobile';
            angular.element(document.getElementById('fileInputMobile' + index)).on('change', handleFileSelect);
            document.getElementById('fileInputMobile' + index).click();
        }

        var handleFileSelect = function(event) {
            var file = event.target.files[0];
            if (file) {
                var reader = new FileReader();
                reader.onload = function(e) {
                    var img = document.createElement("img");
                    img.onload = function() {
                        var canvas = document.createElement("canvas");
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);

                        var MAX_WIDTH = 1800;
                        var MAX_HEIGHT = 640;

                        if (vm.imageType === 'imageMobile') {
                            MAX_WIDTH = 650;
                            MAX_HEIGHT = 640;
                        }

                        canvas.width = MAX_WIDTH;
                        canvas.height = MAX_HEIGHT;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0, MAX_WIDTH, MAX_HEIGHT);

                        var dataurl = canvas.toDataURL(file.type);
                        vm.banners[vm.index][vm.imageType] = dataurl;

                        var outputId = vm.imageType === 'imageMobile' ? 'imgMobile' : 'img';

                        var output = document.getElementById(outputId + vm.index);
                        output.src = dataurl;
                    }
                    img.src = reader.result;

                };
                reader.readAsDataURL(file);
            }
        };

        loadAll();
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('WsService', WsService);

    WsService.$inject = ['WsFactory'];

    function WsService(WsFactory) {

        var service = {
            getInfo: getInfo
        };

        return service;

        function getInfo() {
            return WsFactory.get().$promise;
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('WsFactory', WsFactory);

    WsFactory.$inject = ['$resource'];

    function WsFactory($resource) {
        var resourceUrl = 'admin/api/ws/info';

        return $resource(resourceUrl, {}, {});
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('payment-settings', {
                parent: 'admin',
                url: '/settings/payments',
                data: {
                    authorities: ['STORE_MENU_SETTINGS_PAYMENTS'],
                    pageTitle: "settings.store.payments.title",
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/settings/payments/payment-settings.html',
                        controller: 'PaymentSettingsController as vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settings');
                        return $translate.refresh();
                    }]
                }
            }).state('shipping-settings', {
                parent: 'admin',
                url: '/settings/shippings',
                data: {
                    authorities: ['STORE_MENU_SETTINGS_SHIPPING'],
                    pageTitle: "settings.shipping.menuTitle",
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/settings/shippings/shipping-settings.html',
                        controller: 'ShippingSettingsController as vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settings');
                        return $translate.refresh();
                    }]
                }
            }).state('erps-settings', {
                parent: 'admin',
                url: '/settings/erps',
                data: {
                    authorities: ['STORE_MENU_SETTINGS'],
                    pageTitle: "global.menu.admin.erp",
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/settings/erps/erps-settings.html',
                        controller: 'ErpsSettingsController as vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settings');
                        return $translate.refresh();
                    }]
                }
            })
            .state('marketing-settings', {
                parent: 'admin',
                url: '/settings/marketing',
                data: {
                    authorities: ['SEND_MESSAGE_TO_WATI', 'SEND_MESSAGE_TO_FACEBOOK'],
                    pageTitle: "global.menu.admin.marketing-settings",
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/settings/marketing/marketing-settings.html',
                        controller: 'MarketingSettingsController as vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settings');
                        return $translate.refresh();
                    }]
                }
            })
            .state('communication-settings', {
                parent: 'admin',
                url: '/settings/communication',
                data: {
                    authorities: ['SEND_MESSAGE_TO_WATI', 'SEND_MESSAGE_TO_FACEBOOK'],
                    pageTitle: "global.menu.admin.communication-settings",
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/settings/communication/communication-settings.html',
                        controller: 'CommunicationSettingsController as vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settings');
                        return $translate.refresh();
                    }]
                }
            })
            .state('showcase-settings', {
                parent: 'admin',
                url: '/settings/showcase',
                data: {
                    authorities: ['STORE_MENU_SETTINGS_PAYMENTS'],
                    pageTitle: "global.menu.admin.showcase",
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/settings/showcase/showcase.html',
                        controller: 'ShowcaseSettingsController as vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settings');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('ShowcaseSettingsService', ShowcaseSettingsService);

        ShowcaseSettingsService.$inject = ['ShowcaseSettingsFactory'];

    function ShowcaseSettingsService(ShowcaseSettingsFactory) {

        var service = {
            getByStoreId: getByStoreId,
            update: update
        };

        return service;

        function getByStoreId(storeId) {
            return ShowcaseSettingsFactory.getByStoreId({ storeId: storeId }).$promise;
        }

        function update(storeId, settings) {
            return ShowcaseSettingsFactory.update({ storeId: storeId }, settings).$promise;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ShowcaseSettingsFactory', ShowcaseSettingsFactory);

        ShowcaseSettingsFactory.$inject = ['$resource'];

        function ShowcaseSettingsFactory($resource) {
            var resourceUrl = '/admin/api/showcase-settings';

            return $resource(resourceUrl, {}, {
                'getByStoreId': {
                    method: 'GET',
                    url: resourceUrl + '/:storeId',
                    transformResponse: function (data, headers) {
                        var response = {};
                        if (data) {
                            response.data = angular.fromJson(data);
                        }
                        response.headers = headers();
                        return response;
                    }
                },
                'update': {
                    method: 'PUT',
                    url: resourceUrl + '/:storeId',
                    transformResponse: function (data, headers) {
                        var response = {};
                        if (data) {
                            response.data = angular.fromJson(data);
                        }
                        response.headers = headers();
                        return response;
                    }
                }
            });
        }
})();

(function () {
    'user strict'

    angular
        .module('showcaseApp')
        .controller('ShowcaseSettingsController', ShowcaseSettingsController);

    function ShowcaseSettingsController(toastr, $state, $localStorage, $translate, Constants,
                                    ModalFactory, StoreService, ShowcaseSettingsService) {

        var vm = this;

        vm.isMobile = detectar_mobile();
        vm.store = $localStorage.defaultStore;
        vm.showcaseSettings = undefined;
        
        init();

        function init() {
            loadSettigns();
        }

        function loadSettigns() {
            ShowcaseSettingsService.getByStoreId($localStorage.defaultStore.storeId).then(function (result) {
                console.log(result.data);
                if (result.data) {
                    vm.showcaseSettings = result.data;
                }
            })
        }

        vm.updateSettings = function() {
            console.log(vm.showcaseSettings);
            ModalFactory.openWarningModal(
                null,
                $translate.instant('settings.showcase.general.save-modal.title'),
                $translate.instant('settings.showcase.general.save-modal.small-text'),
                $translate.instant('settings.showcase.general.save-modal.warning-text'),
                $translate.instant('entity.action.continue'),
                $translate.instant('entity.action.cancel'),
                function () {
                    vm.isSaving = true;
                    ShowcaseSettingsService.update($localStorage.defaultStore.storeId, vm.showcaseSettings).then(function (result) {
                        console.log(result.data);
                        if (result.data) {
                            vm.showcaseSettings = result.data;
                        }
                        toastr.success($translate.instant('settings.showcase.general.messages.success'));
                    }).catch(function (err) {
                        vm.isSaving = false;
                        toastr.error($translate.instant('settings.showcase.general.messages.error'));
                    });
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('ShippingService', ShippingService);

        ShippingService.$inject = ['ShippingSettingsFactory'];

    function ShippingService(ShippingSettingsFactory) {

        var service = {
            disconnectFromShippingGateway: disconnectFromShippingGateway,
            addCustomShipping: addCustomShipping,
            getCustomShipping: getCustomShipping,
            updateCustomShipping: updateCustomShipping,
            getCustomShippingList: getCustomShippingList,
            getCustomShippingById: getCustomShippingById,
            deleteCustomShipping: deleteCustomShipping
        };

        return service;

        function disconnectFromShippingGateway(storeName) {
            return ShippingSettingsFactory.diconnect({store: storeName}).$promise
        }

        function addCustomShipping(customShipping) {
            return ShippingSettingsFactory.saveCustomShipping(customShipping).$promise;
        }

        function getCustomShipping(storeId) {
            return ShippingSettingsFactory.getCustomShipping({storeId: storeId}).$promise;
        }

        function updateCustomShipping(customShipping) {
            return ShippingSettingsFactory.updateCustomShipping({customShippingId: customShipping.id}, customShipping).$promise;
        }

        function getCustomShippingList(storeId) {
            return ShippingSettingsFactory.getCustomShippingList({storeId: storeId}).$promise;
        }

        function getCustomShippingById(id) {
            return ShippingSettingsFactory.getCustomShippingById({id: id}).$promise;
        }

        function deleteCustomShipping(id) {
            return ShippingSettingsFactory.deleteCustomShipping({ id: id }).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ShippingSettingsFactory', ShippingSettingsFactory);

    ShippingSettingsFactory.$inject = ['$resource'];

    function ShippingSettingsFactory($resource) {
        var resourceUrl = 'flyer/api/flyer/:flyerId';

        return $resource(resourceUrl, {}, {
            'diconnect': {
                method: 'DELETE',
                headers: { 'Accept': '*/*' },
                url: "/admin/api/shipping/diconnect",
                // transformResponse: function (data, headers) {

                //     var response = {};
                //     response.headers = headers();
                //     return data;
                // }
            },'saveCustomShipping': {
                method: 'POST',
                url: '/admin/api/customShipping',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },'getCustomShipping': {
                method: 'GET',
                url: '/admin/api/customShipping/store/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },'getCustomShippingById': {
                method: 'GET',
                url: '/admin/api/customShipping/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getCustomShippingList': {
                method: 'GET',
                url: '/admin/api/customShipping/list/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateCustomShipping': {
                method: 'PUT',
                url: '/admin/api/customShipping/:customShippingId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deleteCustomShipping': {
                method: 'DELETE',
                url: '/admin/api/customShipping/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();

(function() {
    'user strict'

    angular
        .module('showcaseApp')
        .controller('ShippingSettingsController', ShippingSettingsController);

    //** NgInject */
    function ShippingSettingsController(toastr,  StoreService, $timeout, $localStorage,
        $translate, ModalFactory, ShippingService, $location, RemoveModalFactory) {
        var vm = this;
        vm.linksWirecard = {};
        vm.moipInfo = {};
        vm.hasShipping = false;
        vm.store = $localStorage.defaultStore;
        vm.loading = false;
        vm.serviceUrl = "";
		vm.islocked = $localStorage.isMoipPlanFree;
        vm.customShipping = null;
        vm.customShippingList = [];
        vm.isActive = true;
        vm.isSaving = false;
        vm.isViewForm = false;
        var queryParams = $location.search();
        vm.currencyPrefix = getCurrencyListConfiguration()['REAL'];

        init();

        function init() {
            loadStoreData();
            loadCustomShippingList(vm.store.storeId);
            
            if (queryParams.error) {
                switch (queryParams.error) {
                    case 'MELHOR_ENVIO_NOT_SEND_CODE':
                        toastr.error($translate.instant('settings.shipping.error.MELHOR_ENVIO_NOT_SEND_CODE'));
                        break;
                    case 'MELHOR_ENVIO_NOT_SEND_TOKEN':
                        toastr.error($translate.instant('settings.shipping.error.MELHOR_ENVIO_NOT_SEND_TOKEN'));
                        break;
                    case 'MELHOR_ENVIO_CNPJ_INVALID':
                        toastr.error($translate.instant('settings.shipping.error.MELHOR_ENVIO_CNPJ_INVALID'));
                        break;
                    case 'MELHOR_ENVIO_CNPJ_DIFFERENT':
                        toastr.error($translate.instant('settings.shipping.error.MELHOR_ENVIO_CNPJ_DIFFERENT'));
                        break;
                    case 'UNAVAILABLE':
                        toastr.error($translate.instant('settings.shipping.error.UNAVAILABLE'));
                        break;
                    case 'NONE':
                        toastr.success($translate.instant('settings.shipping.successConnected'));
                        break;
                    default:
                        toastr.error($translate.instant('settings.shipping.error.UNAVAILABLE'));
                        break;
                }
            }
        }

        function actualyDisconnect() {
            vm.loading = true;
            ShippingService.disconnectFromShippingGateway(vm.store.storeId).then(function(response) {
                vm.checkIfIsConnected()
            });
        }

        vm.disconect = function () {
            ModalFactory.openSimpleModal(
                $translate.instant('settings.shipping.sureDisconnectTitle'),
                $translate.instant('settings.shipping.sureDisconnectQuestion'),
                $translate.instant('settings.shipping.yes'),
                $translate.instant('settings.shipping.no'),
                actualyDisconnect);
        }

        vm.checkIfIsConnected = function () {
            vm.loading = true;
            StoreService.checkShippingConnected(vm.store.storeId).then(function(response) {
                vm.loading = false
                if (response){
                    vm.hasShipping = response.hasShipping;
                    vm.serviceUrl = response.serviceUrl;
                }

            })
        }

		vm.openModal = function(){
			$localStorage.isLocked = true;
		}

        vm.authShipping = function() {
            vm.loading = true;
            StoreService.authorizeShipping().then(function(response) {
                // vm.checkIfIsConnected()
            }, function(){
                vm.loading = false;
            });
        }

        vm.checkIfIsConnected();

        vm.createUpdateCustomShipping = function() {
            if (vm.customShipping.id) {
                updateCustomShipping();
            } else {
                saveCustomShipping();
            }
        }

        vm.disableCustomShipping = function (customShipping) {
            ShippingService.updateCustomShipping(customShipping).then(
                function (response) {
                    vm.isSaving = false;
                    vm.error = null;
                    vm.success = 'OK';
                    if (vm.customShipping) {
                        vm.customShipping.isActive = customShipping.isActive
                    }
                    vm.customShipping.isActive = customShipping.isActive;
                    toastr.success($translate.instant('settings.custom-shipping.messages.update'));
                },
                function (err) {
                    vm.isSaving = false;
                    vm.success = null;
                    toastr.error(
                        $translate.instant('settings.store.messages.error.fail')
                    );
                }
            );
        }

        function removeEmptyZipcodes() {
            if (vm.customShipping.zipCodes && vm.customShipping.zipCodes.length > 0) {

                _.remove(vm.customShipping.zipCodes, function (zipcode) {
                    return (!zipcode.initialZipCode && !zipcode.finalZipCode)
                        || (zipcode.initialZipCode === '' && zipcode.finalZipCode === '')
                });
            }
        }

        function saveCustomShipping() {
            vm.isSaving = true;
            vm.customShipping.isActive = true;
            vm.customShipping.storeId = vm.store.storeId;
            if (!vm.customShipping.isActiveTotalWeight) {
                vm.customShipping.isActiveTotalWeight = false;
                vm.customShipping.totalWeight = 0;
            }
            if (!vm.customShipping.isActiveTotalPurchase) {
                vm.customShipping.isActiveTotalPurchase = false;
                vm.customShipping.totalPurchase = 0;
            }

            removeEmptyZipcodes();

            ShippingService.addCustomShipping(vm.customShipping).then(
                function (response) {
                    vm.isSaving = false;
                    vm.error = null;
                    vm.success = 'OK';
                    processResponse('settings.custom-shipping.messages.insert');
                },
                function (err) {
                    vm.isSaving = false;
                    vm.success = null;
                    vm.error = err;
                    processResponse();
                }
            );
        };

        function updateCustomShipping() {
            vm.isSaving = true;
            vm.customShipping.storeId = vm.store.storeId;
            if (!vm.customShipping.isActiveTotalWeight) {
                vm.customShipping.totalWeight = 0;
            }
            if (!vm.customShipping.isActiveTotalPurchase) {
                vm.customShipping.totalPurchase = 0;
            }

            removeEmptyZipcodes();

            ShippingService.updateCustomShipping(vm.customShipping).then(
                function (response) {
                    vm.isSaving = false;
                    vm.error = null;
                    vm.success = 'OK';
                    processResponse('settings.custom-shipping.messages.update');
                },
                function (err) {
                    vm.isSaving = false;
                    vm.success = null;
                    vm.error = err;
                    processResponse();
                }
            );
        };

        function processResponse(message) {
            if (vm.error) {
                if (vm.error && vm.error.data && vm.error.data.headers.statuskey === 'customShippingAlreadyExists'){
                    toastr.error($translate.instant('settings.custom-shipping.already-exists'));
                } else {
                    toastr.error($translate.instant('settings.store.messages.error.fail'));
                }
                vm.error = undefined;
            } else if (vm.success && vm.success == 'OK') {
                vm.isViewForm = false;
                vm.success = undefined;
                toastr.success($translate.instant(message));
                loadCustomShippingList(vm.store.storeId);
            }
        }

        function loadCustomShippingList(storeId) {
            ShippingService.getCustomShippingList(storeId)
                .then(function (response) {
                    vm.customShippingList = response.data
                    if (!vm.customShippingList.length) {
                        vm.isViewForm = true;
                        vm.customShipping = null;
                    }
                });
        }

        function loadStoreData() {
            vm.loading = true;
            StoreService.getStore(vm.store.storeId).then(function(response) {
                vm.loading = false
                if (response){
                    vm.fullStore = response.data;
                    loadCurrencyPrefix(response.data);
                }
            })
        }

        function loadCurrencyPrefix(store) {
            var key = store.currency ? store.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            vm.currencyPrefix = config.prefix;
        }

        vm.updateStoreData = function () {
            vm.loading = true;
            StoreService.updateStore(vm.fullStore).then(function(response) {
                vm.loading = false
                if (response){
                    toastr.success($translate.instant('settings.clique-retire.success'));
                    vm.fullStore = response;
                } else {
                    toastr.success($translate.instant('settings.clique-retire.fail'));
                }
            })
        }

        vm.addZipCode = function () {
            if (vm.customShipping && vm.customShipping.zipCodes) {
                vm.customShipping.zipCodes.push({ initialZipCode: null, finalZipCode: null });
            } else if( vm.customShipping) {
                vm.customShipping.zipCodes = [{ initialZipCode: null, finalZipCode: null }];
            } else {
                vm.customShipping = {zipCodes: [{ initialZipCode: null, finalZipCode: null }]};
            }
        }

        vm.removeZipCode = function (index) {
            if (vm.customShipping.isActive) {
                if (vm.customShipping.zipCodes.length > 1) {
                    vm.customShipping.zipCodes.splice(index, 1);
                } else {
                    vm.customShipping.zipCodes = [{ initialZipCode: null, finalZipCode: null }];
                }
            }
        }

        vm.createCustomShipping = function() {
            vm.isViewForm = true;
            vm.customShippingForm.$setPristine();
            vm.customShipping = {isActive: true};
            vm.customShipping.zipCodes = [{ initialZipCode: null, finalZipCode: null}];
        }

        vm.getCustomShippingById = function (id) {
            ShippingService.getCustomShippingById(id)
                .then(function (response) {
                    vm.isViewForm = true;
                    vm.customShipping = response.data
                    if (!vm.customShipping.zipCodes || !vm.customShipping.zipCodes.length) {
                        vm.customShipping.zipCodes = [{ initialZipCode: null, finalZipCode: null }];
                    }

                    $timeout(function () {
                        vm.goToEndPage();
                    }, 100);
                });

        }

        vm.goToEndPage = function(){
            var scrollingElement = (document.scrollingElement || document.body);
            scrollingElement.scrollTop = scrollingElement.scrollHeight;
        }

        vm.transformPrice = function (price) {
            var decimals = 2;
            var decpoint = ',';
            var thousand = '.';
            var n = Math.abs(price).toFixed(decimals).split('.');
            n[0] = n[0].split('').reverse().map(function (c, i, a){
                return  i > 0 && i < a.length && i % 3 == 0 ? c + thousand : c
            }).reverse().join('');
            var final = (Math.sign(price) < 0 ? '-' : '') + n.join(decpoint);
            return final;
        }

        vm.deleteCustomShipping = function (id) {
            RemoveModalFactory.deleteItem(1).then(function (data) {
                ShippingService.deleteCustomShipping(id).then(function (data) {
                    vm.error = null;
                    vm.success = 'OK';
                    processResponse('settings.custom-shipping.messages.delete');
                },
                function (err) {
                    vm.isSaving = false;
                    vm.success = null;
                    vm.error = 'ERROR';
                    processResponse();
                });
            });
          }

    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('PaymentSetupService', PaymentSetupService);

    PaymentSetupService.$inject = ['PaymentSetupFactory'];

    function PaymentSetupService(PaymentSetupFactory) {

        var service = {
            getByStoreId: getByStoreId,
            activateDeactivate: activateDeactivate,
            getProfessionalOccupations: getProfessionalOccupations,
            disconnect: disconnect
        };

        return service;

        function getByStoreId(storeId) {
            return PaymentSetupFactory.getByStoreId({ storeId: storeId }).$promise;
        }

        function activateDeactivate(id, storeId, dto) {
            return PaymentSetupFactory.activateDeactivate({ id: id, storeId: storeId }, dto).$promise;
        }

        function disconnect(id, storeId, paymentGateway) {
            return PaymentSetupFactory.disconnect({ id: id, storeId: storeId, paymentGateway: paymentGateway }).$promise;
        }

        function getProfessionalOccupations() {
            return [
                'OUTROS',
                'Administrador',
                'Advogado',
                'Agente de Segurança',
                'Agente de Turismo',
                'Agricultor',
                'Analista de Marketing',
                'Analista de Sistemas',
                'Animador',
                'Arquiteto',
                'Artista Plástico',
                'Assistente Social',
                'Ator',
                'Auditor',
                'Biólogo',
                'Bartender',
                'Bibliotecário',
                'Bombeiro',
                'Chef de Cozinha',
                'Cientista de Dados',
                'Cinegrafista',
                'Comissário de Bordo',
                'Consultor',
                'Contador',
                'Coreógrafo',
                'Corretor de Imóveis',
                'Corretor de Seguros',
                'Costureiro',
                'Dentista',
                'Designer',
                'Desenvolvedor de Jogos',
                'Diretor de Cinema',
                'Economista',
                'Editor de Vídeo',
                'Eletricista',
                'Encanador',
                'Enfermeiro',
                'Engenheiro Civil',
                'Engenheiro Elétrico',
                'Engenheiro Mecânico',
                'Engenheiro de Software',
                'Enólogo',
                'Estatístico',
                'Estilista',
                'Farmacêutico',
                'Fisioterapeuta',
                'Físico',
                'Fotógrafo',
                'Garçom',
                'Geógrafo',
                'Geólogo',
                'Gestor de Projetos',
                'Gestor de Recursos Humanos',
                'Historiador',
                'Instrutor de Autoescola',
                'Jornalista',
                'Locutor',
                'Maquiador',
                'Marceneiro',
                'Massoterapeuta',
                'Matemático',
                'Mecânico de Automóveis',
                'Médico',
                'Meteorologista',
                'Militar',
                'Motorista',
                'Motorista de Ônibus',
                'Músico',
                'Nutricionista',
                'Oceanógrafo',
                'Operador de Telemarketing',
                'Padeiro',
                'Pedagogo',
                'Pedreiro',
                'Personal Trainer',
                'Pescador',
                'Piloto de Avião',
                'Policial',
                'Produtor Musical',
                'Programador',
                'Psicólogo',
                'Publicitário',
                'Químico',
                'Radialista',
                'Recepcionista',
                'Serralheiro',
                'Silvicultor',
                'Sociólogo',
                'Sommelier',
                'Tapeceiro',
                'Taxista',
                'Tecnólogo em Gestão Ambiental',
                'Técnico em Eletrônica',
                'Técnico em Enfermagem',
                'Técnico em Informática',
                'Tradutor',
                'Urbanista',
                'Veterinário',
                'Vidraceiro',
                'Zootecnista']
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('PaymentSetupFactory', PaymentSetupFactory);

        PaymentSetupFactory.$inject = ['$resource'];

    function PaymentSetupFactory($resource) {
        var resourceUrl = 'admin/api/payment-setup';

        return $resource(resourceUrl, {}, {
            'getByStoreId': {
                method: 'GET',
                url: resourceUrl + '/store/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'activateDeactivate': {
                method: 'PUT',
                url: resourceUrl + '/:id/store/:storeId/activate-deactivate',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'disconnect': {
                method: 'DELETE',
                url: resourceUrl + '/:id/store/:storeId/disconnect/:paymentGateway',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('PaymentSettings', PaymentSettings);

    PaymentSettings.$inject = ['Account', 'PaymentSettingsFactory'];

    function PaymentSettings(Account, PaymentSettingsFactory) {

        var service = {
            getGatewayWirecardPaymentLinks: getGatewayWirecardPaymentLinks,
            setCodeAndSaveAccessToken: setCodeAndSaveAccessToken,
            disconnectFromPaymentGatewayWirecard: disconnectFromPaymentGatewayWirecard,
            getInstallmenstsByStore: getInstallmenstsByStore,
            addInstallmensts: addInstallmensts,
            setRecipient: setRecipient,
            updateRecipient: updateRecipient,
            getRecipient: getRecipient,
            getOwnerKeys: getOwnerKeys,
            getBalance: getBalance,
            setCheckoutMethod: setCheckoutMethod
        };

        return service;

        function getGatewayWirecardPaymentLinks() {
            return Account.getGatewayWirecardPaymentLinks().$promise;
        }

        function setCodeAndSaveAccessToken(code) {
            return Account.setCodeAndSaveAccessToken({
                code: code
            }).$promise
        }

        function disconnectFromPaymentGatewayWirecard() {
            return Account.disconnectFromPaymentGatewayWirecard().$promise
        }

        function getInstallmenstsByStore() {
            return PaymentSettingsFactory.getInstallmenstsByStore().$promise;
        }

        function addInstallmensts(addInstallmensts) {
            return PaymentSettingsFactory.saveInstallments(addInstallmensts).$promise;
        }
        function setRecipient(pagarmeForm, storeId) {
            return Account.setRecipient({ ownerId : storeId}, pagarmeForm).$promise
        }

        function updateRecipient(pagarmeForm, storeId) {
            return Account.updateRecipient({ ownerId : storeId}, pagarmeForm).$promise
        }

        function getRecipient(storeId) {
            return Account.getRecipient({ ownerId : storeId}).$promise
        }

        function getBalance(storeId, recipientId) {
            return Account.getBalance({ ownerId : storeId, recipientId: recipientId}).$promise
        }

        function setCheckoutMethod(storeId, checkoutMethod) {
            return Account.setCheckoutMethod({ ownerId : storeId, paymentMethod: checkoutMethod}).$promise
        }

        function getOwnerKeys(storeId) {
            return Account.getOwnerKeys({storeId: storeId}).$promise;
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('PaymentSettingsFactory', PaymentSettingsFactory);

    PaymentSettingsFactory.$inject = ['$resource'];

    function PaymentSettingsFactory($resource) {
        var resourceUrl = 'flyer/api/flyer/:flyerId';

        return $resource(resourceUrl, {}, {
            'getInstallmenstsByStore': {
                method: 'GET',
                url: '/admin/api/installment',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'saveInstallments': {
                method: 'POST',
                url: '/admin/api/installment',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();

(function () {
    'user strict'

    angular
        .module('showcaseApp')
        .controller('PaymentSettingsController', PaymentSettingsController);

    //** NgInject */
    function PaymentSettingsController(toastr, PaymentSettings, StoreService, PaymentDiscountService, $uibModal, $localStorage, $translate,
        $location, $timeout, ModalFactory, Principal, $window, $scope, PaymentSetupService, PagarMeService) {

		var vm = this;
        var userId = $localStorage.userId;
        var storeAccountId = undefined;
		vm.linksWirecard = {};
        vm.store = $localStorage.defaultStore;
        vm.linksWirecard = {};
        vm.moipInfo = {};
        vm.picPaySettings = {};
        vm.pagarmeBalance = {};
        vm.tBanksSettings = {};
        vm.isSaving = false;
        vm.pagarme = {};
        vm.pagarme.bankAccount = {};
        vm.pagarme.registerInformation = {};
        vm.pagarme.registerInformation.address = {};
        vm.pagarme.registerInformation.managingPartners = [];
        vm.pagarme.registerInformation.type = 'individual';
        vm.pagarme.bankAccount.holderType = 'individual';
        vm.pagarme.transferEnable = true;
        vm.pagarme.transferInterval = 'MONTHLY'
        vm.pagarme.transferDay = 1;
        vm.checkoutMethod = 'NONE';
        vm.transferDays = []
        vm.banks = getBanksBrasil();
        vm.installment = [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        vm.openModalDisconnectWirecard = openModalDisconnectWirecard;
        vm.openModalDisconnectPagarMe = openModalDisconnectPagarMe;
        vm.tBanksConfirmationToken = { tokenCode: "" };
        vm.transferDaysTest = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];
        vm.transferDays = [
            { value: 1, label: '1' },
            { value: 2, label: '2' },
            { value: 3, label: '3' },
            { value: 4, label: '4' },
            { value: 5, label: '5' },
            { value: 6, label: '6' },
            { value: 7, label: '7' },
            { value: 8, label: '8' },
            { value: 9, label: '9' },
            { value: 10, label: '10' },
            { value: 11, label: '11' },
            { value: 12, label: '12' },
            { value: 13, label: '13' },
            { value: 14, label: '14' },
            { value: 15, label: '15' },
            { value: 16, label: '16' },
            { value: 17, label: '17' },
            { value: 18, label: '18' },
            { value: 19, label: '19' },
            { value: 20, label: '20' },
            { value: 21, label: '21' },
            { value: 22, label: '22' },
            { value: 23, label: '23' },
            { value: 24, label: '24' },
            { value: 25, label: '25' },
            { value: 26, label: '26' },
            { value: 27, label: '27' },
            { value: 28, label: '28' },
            { value: 29, label: '29' },
            { value: 30, label: '30' },
            { value: 31, label: '31' },
        ];
        vm.paymentSettings = {
            'toBeAgreed': false,
            'redirectToSellerWhatsapp': false
        };
        vm.haveIntegrationWithPayments = false;
        vm.hasPicPayPayment = false;
        vm.hasToBeAgreedPayment = false;
        vm.hasWirecardPayment = false;
        vm.hasPagarmePayment = false;
        vm.isCreditCardEnabled = false;
        vm.isBoletoEnabled = false;
        vm.hasTBanksPayment = false;
        vm.pixPaymentDiscountList = [];
        vm.currencyPrefix = getCurrencyListConfiguration()['REAL'];
        vm.currency = 'REAL';
        vm.occupations = PaymentSetupService.getProfessionalOccupations();
        vm.pagarMeIntegrationType = 'SHOWKASE_PAY';

        init();

        function init() {
            loadStoreData();
            loadAll();
            if ($location.search().code) {
                PaymentSettings.setCodeAndSaveAccessToken($location.search().code || " ").then(function  (response) {
                    $timeout(function  () {
                        toastr.success($translate.instant('settings.shipping.successConnected'));
                    }, 500);

                    if (response.data) {
                        vm.moipInfo = response.data;
                    }

                    $location.url($location.path());
                }, function  (response) {
                    toastr.error($translate.instant('settings.shipping.failureToConnect'));
                    $location.url($location.path());
                });
            }
            loginWithPagarMeHubCallback();
        }

        function loginWithPagarMeHubCallback() {
            vm.loading = true;
            var authCode = $location.search().authorization_code;
            if (authCode) {
                PagarMeService.authenticate($localStorage.defaultStore.storeId, authCode).then(
                    function(response) {
                        toastr.success($translate.instant('settings.store.payments.tabs.pagarMe.successConnected'));
                        loadAll();
                        vm.loading = false;
                    },
                    function(error) { 
                        vm.loading = false; 
                        toastr.error($translate.instant('settings.store.payments.tabs.pagarMe.failureToConnect'));
                    }
                );
            }
        }

        function loadAll() {
            loadSetup();
        }

        function loadStoreData() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
                if (response){
                    loadCurrencyPrefix(response.data);
                    storeAccountId = response.data.ownerId;
                }
            })
        }

        function loadCurrencyPrefix(store) {
            var key = store.currency ? store.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            vm.currencyPrefix = config.prefix;
            vm.currency = key;
        }

        function loadPicPay(picPayData) {
            if (picPayData) {
                vm.picPaySettings = picPayData;
                vm.haveIntegrationWithPayments = true;
                vm.hasPicPayPayment = !isNullEmptyOrUndefined(vm.picPaySettings.picPayToken)
                    && !isNullEmptyOrUndefined(vm.picPaySettings.sellerToken)
                    && !isNullOrUndefined(vm.picPaySettings.id);
            }
        }

        function loadPaymentSettings(settingsData) {
            if (settingsData) {
                vm.paymentSettings = settingsData;
                vm.haveIntegrationWithPayments = vm.paymentSettings.toBeAgreed
                vm.hasToBeAgreedPayment = vm.paymentSettings.toBeAgreed;
            }
        }

        function loadPagarMeRecipient(pagarMeData) {
            if (pagarMeData && pagarMeData.recipient) {
                vm.pagarme = pagarMeData.recipient;
                vm.pagarmeBalance = pagarMeData.balance;
                vm.pagarmeEncryptToken = pagarMeData.encryptToken;
                vm.hasPagarmePayment = true;
                // vm.isCreditCardEnabled = vm.pagarme.isCreditCardEnabled;
                // vm.isBoletoEnabled = vm.pagarme.isBoletoEnabled;
                vm.keyCheckoutMethod = 'PAGAR_ME';
                vm.checkoutMethod = 'PAGAR_ME';
            } else {
                vm.pagarme.registerInformation.type = 'individual';
                vm.pagarme.bankAccount.holderType = 'individual';
                vm.pagarme.transferDay = 1;
            }
        }

        function loadPagarMeAccount(pagarMeAccount) {
            if (pagarMeAccount) {
                vm.pagarMeAccount = pagarMeAccount;
                vm.isCreditCardEnabled = vm.pagarMeAccount.isCreditCardEnabled;
                vm.isBoletoEnabled = vm.pagarMeAccount.isBoletoEnabled;
                vm.pagarMeIntegrationType = vm.pagarMeAccount.apiVersion;
            } else {
                vm.pagarMeAccount = {
                    apiVersion: 'SHOWKASE_PAY'
                }
            }
        }

        function loadInstallments(installmentData) {
            vm.installments = installmentData;
        }

        function loadTBanks(tbanksData) {
            if (tbanksData) {
                vm.tBanksSettings = tbanksData;
                if (!vm.haveIntegrationWithPayments) {
                    vm.haveIntegrationWithPayments = vm.tBanksSettings.status || vm.tBanksSettings.status != 'Rejeitada' || vm.tBanksSettings.status != 'Criada';
                }

                if (!vm.hasTBanksPayment) {
                    vm.hasTBanksPayment = vm.tBanksSettings.status || vm.tBanksSettings.status != 'Rejeitada' || vm.tBanksSettings.status != 'Criada';
                }
            } else {
                vm.hasTBanksPayment = false;
                StoreService.getStore($localStorage.defaultStore.storeId).then(function (response) {
                    if (response) {
                        vm.tBanksSettings.companyName = response.data.name;
                        vm.tBanksSettings.companyDocument = response.data.cnpj;
                    }
                });
            }
        }

        function loadPaymentDiscount(paymentConditionDiscountData) {
            if (paymentConditionDiscountData && paymentConditionDiscountData.length > 0) {
                vm.pixPaymentDiscountList = paymentConditionDiscountData.filter(function(item) { return item.paymentCondition == "PIX" });
            } else {
                vm.pixPaymentDiscountList = [];
            }
        }

        function loadSetup() {
            PaymentSetupService.getByStoreId($localStorage.defaultStore.storeId).then(function(response) {
                if (response && response.data) {
                    loadPicPay(response.data.picPayData);
                    loadPaymentSettings(response.data.settingsData);
                    loadPagarMeRecipient(response.data.pagarMeData);
                    loadPagarMeAccount(response.data.pagarMeAccountData);
                    loadInstallments(response.data.installmentData);
                    loadTBanks(response.data.tbanksData);
                    loadPaymentDiscount(response.data.paymentConditionDiscountData);
                }
            });
        }

        vm.authorizePagarMe = function() {
            vm.loading = true;
            PagarMeService.authorize($localStorage.defaultStore.storeId).then(
                function(response) {},
                function(){ vm.loading = false; }
            );
        }

        vm.updateBankAccountType = function() {
            if (vm.pagarme.registerInformation.type === 'corporation') {
                vm.pagarme.bankAccount.holderType = 'COMPANY';
            } else {
                vm.pagarme.bankAccount.holderType = 'INDIVIDUAL';
            }
        }

        vm.updateRedirectToSellerHandler = function () {
            vm.loading = true;
            StoreService.updateRedirectToSellerValue(vm.paymentSettings.id, vm.paymentSettings.redirectToSellerWhatsapp)
            .then(function(response) {
                vm.loading = false
                if (response) {
                    toastr.success($translate.instant('settings.clique-retire.success'));
                } else {
                    toastr.success($translate.instant('settings.clique-retire.fail'));
                    vm.paymentSettings.redirectToSellerWhatsapp = !vm.paymentSettings.redirectToSellerWhatsapp;
                }
            })
        }

        vm.updateToBeAgreedHandler = function () {
            var creditCard = vm.pagarme && vm.pagarme.isCreditCardEnabled;
            var boleto = vm.pagarme && vm.pagarme.isBoletoEnabled;
            var picpay = vm.picPaySettings && vm.picPaySettings.isEnabled;
            var pix = vm.tBanksSettings && vm.tBanksSettings.isEnabled;
            var toBeAgreed = vm.paymentSettings && vm.paymentSettings.toBeAgreed;
            var activePayments = [creditCard, boleto, picpay, pix, toBeAgreed].filter(function(x) { return x; }).length;
            if (activePayments == 0) {
                toastr.error($translate.instant('settings.store.payments.tabs.toBeAgreed.onlyPaymentForm'));
                vm.paymentSettings.toBeAgreed = !vm.paymentSettings.toBeAgreed;
                return;
            }

            vm.loading = true;
            StoreService.updateToBeAgreedValue(vm.paymentSettings.id, vm.paymentSettings.toBeAgreed).then(function(response) {
                vm.loading = false
                if (response) {
                    toastr.success($translate.instant('settings.clique-retire.success'));
                } else {
                    toastr.success($translate.instant('settings.clique-retire.fail'));
                    vm.paymentSettings.toBeAgreed = !vm.paymentSettings.toBeAgreed;
                }
                vm.hasToBeAgreedPayment = vm.paymentSettings.toBeAgreed;
            })
        }

        vm.savePicPaySettings = function savePicPaySettings() {
            vm.picPaySettings.storeId = $localStorage.defaultStore.storeId;
            StoreService.savePicPayConfiguration(vm.picPaySettings).then(function  (response) {
                toastr.success($translate.instant('settings.store.messages.success'));
                loadSetup();
            }, function (data) {
                toastr.error($translate.instant('settings.store.messages.error.fail'));
                vm.hasPicPayPayment = false;
            });

        }

        vm.saveTBanksSettings = function saveTBanksSettings() {
            if (vm.hasTBanksPayment
                && !vm.hasToBeAgreedPayment
                && !vm.hasPicPayPayment
                && !vm.hasWirecardPayment
                && !vm.hasPagarmePayment
            ) {
                toastr.error($translate.instant('settings.store.payments.tabs.pix.onlyPaymentForm'));
                return;
            }

            vm.tBanksSettings.storeId = vm.store.storeId;
            vm.isSaving = true;
            StoreService.saveTBanksConfiguration(vm.tBanksSettings).then(function  (response) {
                if (response) {
                    vm.tBanksSettings = response.data;
                }
                vm.isSaving = false;
                vm.hasTBanksPayment = true;
                toastr.success($translate.instant('settings.store.payments.tabs.pix.successConnected'));
                window.scrollTo({ top: 0, behavior: 'smooth' });
                loadSetup();
            }, function (error) {
                vm.isSaving = false;
                vm.hasTBanksPayment = false;
                if (error && error.data && error.data.headers.statuskey){
                    toastr.error($translate.instant('settings.store.payments.tabs.pix.' + error.data.headers.statuskey));
                } else {
                    toastr.error($translate.instant('settings.store.payments.tabs.pix.failureToConnect'));
                }
            });
        }

        vm.verifyTBanksConfirmationToken = function verifyTBanksConfirmationToken() {
            vm.isSaving = true;
            StoreService.verifyTBanksConfirmationToken(vm.tBanksConfirmationToken).then(function () {
                vm.isSaving = false;
                toastr.success($translate.instant('settings.store.payments.tabs.pix.successToVerifyToken'));
                loadSetup();
            }, function (error) {
                vm.isSaving = false;
                toastr.error($translate.instant('settings.store.payments.tabs.pix.failureToVerifyToken'));
            });
        }

        vm.resendTBanksConfirmationToken = function resendTBanksConfirmationToken() {
            vm.isSaving = true;
            StoreService.resendTBanksConfirmationToken().then(function () {
                vm.isSaving = false;
                toastr.success($translate.instant('settings.store.payments.tabs.pix.successToResendToken'));
            }, function (data) {
                vm.isSaving = false;
                toastr.error($translate.instant('settings.store.payments.tabs.pix.failureToResendToken'));
            });
        }

        vm.openPaymentDiscountFormModal = function (paymentCondition, paymentDiscount) {
            vm.paymentDiscountFormModal = $uibModal.open({
                templateUrl: 'app/admin/settings/payments/component/payment-discount-form-modal.html',
                controller: 'PaymentDiscountFormModalController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    paymentCondition: function () {
                        return paymentCondition;
                    },
                    paymentDiscount: function () {
                        return paymentDiscount;
                    },
                    currency: function () {
                        return vm.currency;
                    }
                },
            }).result.then(function (response) {
                loadSetup();
            });
        }

        vm.activateDeactivatePayment = function(id, paymentCondition, paymentDiscount) {
            var creditCard = vm.pagarme && vm.pagarme.isCreditCardEnabled;
            var boleto = vm.pagarme && vm.pagarme.isBoletoEnabled;
            var picpay = vm.picPaySettings && vm.picPaySettings.isEnabled;
            var pix = vm.tBanksSettings && vm.tBanksSettings.isEnabled;
            var toBeAgreed = vm.paymentSettings && vm.paymentSettings.toBeAgreed;
            var activePayments = [creditCard, boleto, picpay, pix, toBeAgreed].filter(function(x) { return x; }).length;
            if (activePayments == 0) {
                toastr.error($translate.instant('settings.store.payments.messages.activate-deactivate-one-payment-error'));
                loadSetup();
                return;
            }

            var dto = {
                paymentCondition: paymentCondition,
                enabled: paymentDiscount.isEnabled,
                boletoEnabled: paymentDiscount.isBoletoEnabled,
                creditCardEnabled: paymentDiscount.isCreditCardEnabled
            }

            PaymentSetupService.activateDeactivate(id, vm.store.storeId, dto)
                .then(
                    function(response) {
                        processActivateDeactivateResponse(true, dto);
                        loadSetup();
                    },
                    function(err) {
                        processActivateDeactivateResponse(false, dto);
                        console.log(err);
                    }
                );
        }

        vm.disablePaymentDiscount = function(paymentDiscount) {
            PaymentDiscountService.update(paymentDiscount.id, paymentDiscount)
                .then(
                    function(response) {
                        if (paymentDiscount.isEnabled) {
                            toastr.success($translate.instant('settings.store.payments.payment-discount.messages.activate-success'));
                        } else {
                            toastr.success($translate.instant('settings.store.payments.payment-discount.messages.deactivate-success'));
                        }
                        loadSetup();
                    },
                    function(err) {
                        toastr.error($translate.instant('settings.store.payments.payment-discount.messages.activate-deactivate-success'));
                    }
                );
        }

        vm.deletePaymentDiscount = function(paymentDiscount) {
            PaymentDiscountService.remove(paymentDiscount.id)
                .then(
                    function(response) {
                        toastr.success($translate.instant('settings.store.payments.payment-discount.messages.delete-success'));
                        loadSetup();
                    },
                    function(err) {
                        toastr.error($translate.instant('settings.store.payments.payment-discount.messages.delete-error'));
                    }
                );
        }

        vm.copiedToClipboard = function() {
            toastr.success($translate.instant('settings.erps.bling.instructions.copied'));
        }

        function actualyDisconnect() { // REMOVER
			Principal.disconnectFromPaymentGatewayWirecard().then(function(response) {
				if (response.data == 'OK') {
					vm.moipInfo = {};
				}
			});
		}

        PaymentSettings.getGatewayWirecardPaymentLinks().then(function (links) {
            if (links) {
                vm.linksWirecard = links;
            }
        });

        function openModalDisconnectWirecard() {
            ModalFactory.openSimpleModal(
                $translate.instant('settings.store.payments.tabs.wirecard.sureDisconnectTitle'),
                $translate.instant('settings.store.payments.tabs.wirecard.sureDisconnectQuestion'),
                $translate.instant('settings.store.payments.tabs.wirecard.yes'),
                $translate.instant('settings.store.payments.tabs.wirecard.no'),
                disconnectWirecard);
        }

        function openModalDisconnectPagarMe() {
            ModalFactory.openWarningModal(null,
                $translate.instant('settings.store.payments.tabs.pagarMe.sureDisconnectTitle'),
                $translate.instant('settings.store.payments.tabs.pagarMe.sureDisconnectQuestion'),
                null,
                $translate.instant('settings.store.payments.tabs.pagarMe.yes'),
                $translate.instant('settings.store.payments.tabs.pagarMe.no'),
                disconnectPagarme
            );
        }

        function openModalChangeToPagarMe() {
            ModalFactory.openWarningModal(null,
                $translate.instant('settings.store.payments.changePayment.toPagarMe.sureDisconnectTitle'),
                $translate.instant('settings.store.payments.changePayment.toPagarMe.message'),
                null,
                $translate.instant('settings.store.payments.changePayment.toPagarMe.yes'),
                $translate.instant('settings.store.payments.changePayment.toPagarMe.no'),
                disconnectWiredAndSaveMethodPagarMe
            );
        }

        function openModalChangeToWirecard() {
            ModalFactory.openSimpleModal(
                $translate.instant('settings.store.payments.changePayment.toWirecard.sureDisconnectTitle'),
                $translate.instant('settings.store.payments.changePayment.toWirecard.message'),
                $translate.instant('settings.store.payments.changePayment.toWirecard.yes'),
                $translate.instant('settings.store.payments.changePayment.toWirecard.no'),
                disconnectPagarMeAndSaveMethodWired);
        }

        function disconnectWirecard() {
            if (vm.hasWirecardPayment
                && !vm.hasPagarmePayment
                && !vm.hasToBeAgreedPayment
                && !vm.hasPicPayPayment
                && !vm.hasTBanksPayment
            ) {
                toastr.error($translate.instant('settings.store.payments.tabs.wirecard.onlyPaymentForm'));
                return;
            }

            Principal.disconnectFromPaymentGatewayWirecard().then(function (response) {
                if (response.data == 'OK') {
                    vm.moipInfo = {};
                    vm.hasWirecardPayment = false;
                }
            });
        }

        function disconnectPagarme() {
            if (vm.hasPagarmePayment
                && !vm.hasWirecardPayment
                && !vm.hasToBeAgreedPayment
                && !vm.hasPicPayPayment
                && !vm.hasTBanksPayment
            ) {
                toastr.error($translate.instant('settings.store.payments.tabs.pagarme.onlyPaymentForm'));
                return;
            }

            PaymentSettings.setCheckoutMethod(userId, 'NONE').then(function (response) {
                vm.checkoutMethod = 'NONE';
                vm.keyCheckoutMethod = 'NONE';
                vm.pagarme = {};
                vm.hasPagarmePayment = false;
                vm.isCreditCardEnabled = false;
                vm.isBoletoEnabled = false;
            });
        }

        function hasMoipAccount() {
            return (Object.keys(vm.moipInfo).length !== 0);
        }


        vm.addInstallment = function () {
            vm.installments.push({
              allowInstallment: true,
              installment: undefined,
              installmentNoFee: undefined,
              minimumValue: undefined,
              storeId: vm.store.storeId
            });
        }

        vm.removeInstallment = function (index) {
            if (vm.installments.length > 1) {
              vm.installments.splice(index, 1);
            } else {
              vm.installments = [{ allowInstallment: null, installment: null, installmentNoFee: null, minimumValue: null }];
            }
        }

        vm.saveInstallment = function () {
            PaymentSettings.addInstallmensts(vm.installments).then(
              function (response) {
                vm.isSaving = false;
                vm.error = null;
                vm.success = 'OK';
                processResponse('settings.store.payments.tabs.installment.messages.update');
              },
              function (err) {
                vm.isSaving = false;
                vm.success = null;
                vm.error = err;
                processResponse('settings.store.payments.tabs.installment.messages.fail');
              }
            );
        };

        function processResponse(message) {
            if (vm.error) {
              toastr.error($translate.instant(message));
              vm.error = undefined;
            } else if (vm.success && vm.success == 'OK') {
              vm.success = undefined;
              toastr.success($translate.instant(message));
            }
        }

        vm.saveMethodPagarMe = function () {
            if (vm.pagarmeForm.$invalid) {
                toastr.warning("Verifique os campos invalidos")
                angular.forEach(vm.pagarmeForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    });
                });
                return;
            }

            if (hasMoipAccount()) {
                openModalChangeToPagarMe();
            } else {
                saveOrEditMethodPagarMe()
            }
        };

        vm.connecttWirecard = function () {
            if (vm.keyCheckoutMethod === "PAGAR_ME") {
                openModalChangeToWirecard();
            } else {
                disconnectPagarMeAndSaveMethodWired();
            }
        }

        vm.copiedToClipboard = function() {
            toastr.success($translate.instant('settings.store.payments.tabs.pix.copied'));
        }

        vm.getPixKey = function() {
            return vm.tBanksSettings.transactionKey;
        }

        vm.openDisconnectPicPayModal = function() {
            ModalFactory.openWarningModal(null,
                $translate.instant('settings.store.payments.tabs.picpay.sureDisconnectTitle'),
                $translate.instant('settings.store.payments.tabs.picpay.sureDisconnectQuestion'),
                null,
                $translate.instant('settings.store.payments.tabs.picpay.yes'),
                $translate.instant('settings.store.payments.tabs.picpay.no'),
                disconnectPicPay
            );
        }

        function disconnectPicPay() {
            if (vm.hasPicPayPayment
                && !vm.hasToBeAgreedPayment
                && !vm.hasWirecardPayment
                && !vm.hasPagarmePayment
                && !vm.hasTBanksPayment
            ) {
                toastr.error($translate.instant('settings.store.payments.tabs.picpay.onlyPaymentForm'));
                return;
            }

            vm.picPaySettings.picPayToken = '';
            vm.picPaySettings.sellerToken = '';

            vm.savePicPaySettings();
        }

        vm.openDisconnectTBanksModal = function() {
            ModalFactory.openWarningModal(null,
                $translate.instant('settings.store.payments.tabs.pix.sureDisconnectTitle'),
                $translate.instant('settings.store.payments.tabs.pix.sureDisconnectQuestion'),
                null,
                $translate.instant('settings.store.payments.tabs.pix.yes'),
                $translate.instant('settings.store.payments.tabs.pix.no'),
                disconnectTBanks
            );
        }

        function disconnectTBanks() {
            PaymentSetupService.disconnect(vm.tBanksSettings.id, $localStorage.defaultStore.storeId, 'T_BANKS').then(
                function (response) {
                    vm.error = null;
                    vm.success = 'OK';
                    processResponse('settings.store.payments.tabs.pix.successDisconnectMessage');
                },
                function (err) {
                    vm.success = null;
                    vm.error = err;
                    processResponse('settings.store.payments.tabs.pix.errorDisconnectMessage');
                }
              );
        }

        function disconnectWiredAndSaveMethodPagarMe() {
            Principal.disconnectFromPaymentGatewayWirecard().then(function (response) {
                if (response.data == 'OK') {
                    vm.moipInfo = {};
                    saveOrEditMethodPagarMe();
                }
            });
        }

        function disconnectPagarMeAndSaveMethodWired() {
            disconnectPagarme();
            $window.open(vm.linksWirecard.connectAccountLink, '_blank');
        }

        function saveOrEditMethodPagarMe() {
            vm.pagarme.transferEnabled = true;
            vm.pagarme.bankAccount.holderDocument = vm.pagarme.registerInformation.documentNumber;

            if (vm.pagarme.id && vm.pagarme.recipientId) {
                PagarMeService.updateRecipient(vm.pagarme.id, vm.pagarme).then(function (response) {
                    vm.pagarme = response.data;
                    vm.hasPagarmePayment = true;
                    // vm.isCreditCardEnabled = vm.pagarme.isCreditCardEnabled;
                    // vm.isBoletoEnabled = vm.pagarme.isBoletoEnabled;
                    toastr.success("Dados salvos com sucesso");
                }).catch(function (response) {
                    vm.hasPagarmePayment = false;
                    vm.isCreditCardEnabled = false;
                    vm.isBoletoEnabled = false;
                    toastr.error("Verifique os campos e tente novamente");
                });
            } else {
                PagarMeService.createRecipient(storeAccountId, vm.pagarme).then(function (response) {
                    vm.pagarme = response.data;
                    vm.hasPagarmePayment = true;
                    // vm.isCreditCardEnabled = vm.pagarme.isCreditCardEnabled;
                    // vm.isBoletoEnabled = vm.pagarme.isBoletoEnabled;
                    vm.checkoutMethod = "PAGAR_ME";
                    vm.keyCheckoutMethod = "PAGAR_ME";
                    toastr.success("Dados salvos com sucesso");
                }).catch(function (response) {
                    toastr.error("Verifique os campos e tente novamente");
                });
            }
        }

        function processActivateDeactivateResponse(isSuccess, activateDeactivate) {
            var messageId = undefined;
            switch (activateDeactivate.paymentCondition) {
                case 'PIX':
                    if (!isSuccess) {
                        messageId = 'settings.store.payments.tabs.pix.activated-deactivated-error';
                        break;
                    }

                    if (activateDeactivate.enabled) {
                        messageId = 'settings.store.payments.tabs.pix.activated-success';
                    } else {
                        messageId = 'settings.store.payments.tabs.pix.deactivated-success';
                    }
                    break;
                case 'CREDIT_CARD':
                    if (!isSuccess) {
                        messageId = 'settings.store.payments.tabs.pagarMe.activated-deactivated-error-credit-card';
                        break;
                    }

                    if (activateDeactivate.creditCardEnabled) {
                        messageId = 'settings.store.payments.tabs.pagarMe.activated-success-credit-card';
                    } else {
                        messageId = 'settings.store.payments.tabs.pagarMe.deactivated-success-credit-card';
                    }
                    break;
                case 'BOLETO':
                    if (!isSuccess) {
                        messageId = 'settings.store.payments.tabs.pagarMe.activated-deactivated-error-boleto';
                        break;
                    }

                    if (activateDeactivate.boletoEnabled) {
                        messageId = 'settings.store.payments.tabs.pagarMe.activated-success-boleto';
                    } else {
                        messageId = 'settings.store.payments.tabs.pagarMe.deactivated-success-boleto';
                    }
                    break;
                case 'PIC_PAY':
                    if (!isSuccess) {
                        messageId = 'settings.store.payments.tabs.pagarMe.activated-deactivated-error';
                        break;
                    }

                    if (activateDeactivate.enabled) {
                        messageId = 'settings.store.payments.tabs.picpay.activated-success';
                    } else {
                        messageId = 'settings.store.payments.tabs.picpay.deactivated-success';
                    }
                    break;
            }

            if (!messageId) {
                return;
            }

            if (isSuccess) {
                toastr.success($translate.instant(messageId));
            } else {
                toastr.error($translate.instant(messageId));
            }
        }

        vm.disabledCnpj = function () {
            return (vm.pagarme.id !== undefined && vm.pagarme.registerInformation.type.toLowerCase() === 'individual');
        }

        vm.disabledCpf = function () {
            return (vm.pagarme.id !== undefined && vm.pagarme.registerInformation.type.toLowerCase() === 'corporation');
        }

        vm.changeMethodPaymant = function (method) {
            vm.checkoutMethod = method;
        }

        vm.removeManagingPartner = function (partnerIndex, partner) {
            if (vm.pagarme && vm.pagarme.registerInformation && vm.pagarme.registerInformation.managingPartners) {
                vm.pagarme.registerInformation.managingPartners = vm.pagarme.registerInformation.managingPartners
                    .filter(function(item, index) { return partnerIndex !== index });
            }
        }

        vm.updateManagingPartner = function (partnerIndex, partner) {
            vm.managingPartnerModal = $uibModal.open({
                templateUrl: 'app/admin/settings/payments/pagarme/modal/add-managing-partner-modal.html',
                controller: 'AddManagingPartnerController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    partner: function () {
                        return partner;
                    },
                    partnerIndex: function() {
                        return partnerIndex;
                    }
                },
            }).result.then(function (response) {
                if (response.data) {
                    vm.pagarme.registerInformation.managingPartners[response.data.partnerIndex] = response.data.partner;
                }

            });
        }

        vm.openManagingPartnerModal = function () {
            vm.managingPartnerModal = $uibModal.open({
                templateUrl: 'app/admin/settings/payments/pagarme/modal/add-managing-partner-modal.html',
                controller: 'AddManagingPartnerController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    partner: function () {
                        return undefined;
                    },
                    partnerIndex: function() {
                        return undefined;
                    }
                },
            }).result.then(function (response) {
                if (response.data) {
                    if (!vm.pagarme.registerInformation.managingPartners) {
                        vm.pagarme.registerInformation.managingPartners = [];
                    }

                    vm.pagarme.registerInformation.managingPartners.push(response.data.partner);
                }

            });
        }

        angular.element(function () {
            $timeout(function() {
                initAutocomplete();
            }, 2000);
        });

        function initAutocomplete() {
            // Crie o campo de entrada para o autocomplete
            var input = document.getElementById('autocomplete');
            // Inicialize o autocomplete passando o campo de entrada e configurando os tipos de lugares que deseja sugerir
            var autocomplete = new google.maps.places.Autocomplete(input, {
              types: ['geocode'], // Pode alterar para ['(regions)'] para sugerir áreas mais amplas
              componentRestrictions: { country: 'br' } // Restringe as sugestões ao Brasil
            });

            // Adicione um listener para lidar com o evento de seleção
            autocomplete.addListener('place_changed', function() {
                var place = autocomplete.getPlace();

              if (!place.geometry) {
                // Se o usuário inseriu um lugar que não existe, exiba uma mensagem
                console.log("Nenhuma informação disponível para o local inserido: '" + place.name + "'");
                return;
              }

              // Faça algo com o resultado selecionado
              populateAddressFields(place);
            });
          }


        function populateAddressFields(result) {
            if (!vm.pagarme.registerInformation.address) {
                vm.pagarme.registerInformation.address = {};
            }
            var addressComponents = result.address_components;
            for (var i = 0; i < addressComponents.length; i++) {
              var component = addressComponents[i];
              var types = component.types;
              for (var j = 0; j < types.length; j++) {
                var type = types[j];
                if (type === "route") {
                    vm.pagarme.registerInformation.address.street = component.long_name;
                } else if (type === "sublocality_level_1" || type === "locality") {
                    vm.pagarme.registerInformation.address.neighborhood = component.long_name;
                } else if (type === "administrative_area_level_2") {
                    vm.pagarme.registerInformation.address.city = component.long_name;
                } else if (type === "administrative_area_level_1") {
                    vm.pagarme.registerInformation.address.state = component.short_name;
                } else if (type === "country") {
                    vm.pagarme.registerInformation.address.country = component.short_name;
                } else if (type === "postal_code") {
                    vm.pagarme.registerInformation.address.zipcode = component.long_name;
                } else if (type === "street_number") {
                    vm.pagarme.registerInformation.address.streetNumber = component.long_name;
                }
              }
            }
            $scope.$apply();
          }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('PaymentDiscountService', PaymentDiscountService);

    PaymentDiscountService.$inject = ['PaymentDiscountFactory'];

    function PaymentDiscountService(PaymentDiscountFactory) {

        var service = {
            getById: getById,
            getByStoreId: getByStoreId,
            create: create,
            update: update,
            remove: remove
        };

        return service;

        function getById(id) {
            return PaymentDiscountFactory.getById({id: id}).$promise;
        }

        function getByStoreId(storeId) {
            return PaymentDiscountFactory.getByStoreId({storeId: storeId}).$promise;
        }

        function create(paymentDiscount) {
            return PaymentDiscountFactory.create(paymentDiscount).$promise;
        }

        function update(id, paymentDiscount) {
            return PaymentDiscountFactory.update({id: id}, paymentDiscount).$promise;
        }

        function remove(id) {
            return PaymentDiscountFactory.remove({id: id}).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('PaymentDiscountFactory', PaymentDiscountFactory);

        PaymentDiscountFactory.$inject = ['$resource'];

    function PaymentDiscountFactory($resource) {
        var resourceUrl = 'admin/api/payment-condition-discount';

        return $resource(resourceUrl, {}, {
            'getById': {
                method: 'GET',
                url: resourceUrl + '/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getByStoreId': {
                method: 'GET',
                url: resourceUrl + '/store/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'create': {
                method: 'POST',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'update': {
                method: 'PUT',
                url: resourceUrl + '/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'remove': {
                method: 'DELETE',
                url: resourceUrl + '/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('PagarMeService', PagarMeService);

        PagarMeService.$inject = ['PagarMeFactory'];

    function PagarMeService(PagarMeFactory) {

        var service = {
            getRecipient: getRecipient,
            createRecipient: createRecipient,
            updateRecipient: updateRecipient,
            authorize: authorize,
            authenticate: authenticate
        };

        return service;

        function authorize(storeId) {
            return PagarMeFactory.authorize({storeId: storeId}).$promise;
        }

        function authenticate(storeId, authCode) {
            return PagarMeFactory.authenticate({storeId: storeId, authCode: authCode}).$promise;
        }

        function getRecipient(managerUserId) {
            return PagarMeFactory.getRecipient({managerUserId: managerUserId}).$promise;
        }

        function createRecipient(managerUserId, recipient) {
            return PagarMeFactory.createRecipient({managerUserId: managerUserId}, recipient).$promise;
        }

        function updateRecipient(id, recipient) {
            return PagarMeFactory.updateRecipient({id: id}, recipient).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('PagarMeFactory', PagarMeFactory);

    PagarMeFactory.$inject = ['$resource'];

    function PagarMeFactory($resource) {
        var resourceUrl = 'api/pagarme/v4';

        return $resource(resourceUrl, {}, {
            'authorize': {
                method: 'GET',
                url: 'admin/api/pagar-me/:storeId/authorize',
                transformResponse: function (data, headers) {
                    if (headers() && headers().location) {
                        window.location.href = headers().location
                    }
                    var response = {};
                    response.headers = headers();
                    return data;
                }
            },
            'authenticate': {
                method: 'GET',
                url: 'admin/api/pagar-me/:storeId/authenticate/:authCode',
                transformResponse: function (data, headers) {
                    if (headers() && headers().location) {
                        window.location.href = headers().location
                    }
                    var response = {};
                    response.headers = headers();
                    return data;
                }
            },
            'getRecipient': {
                method: 'GET',
                url: resourceUrl + '/user/:managerUserId/recipient',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'createRecipient': {
                method: 'POST',
                params: {},
                isArray: false,
                url: resourceUrl + '/user/:managerUserId/recipient',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateRecipient': {
                method: 'PUT',
                params: {},
                isArray: false,
                url: resourceUrl + '/:id/recipient',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('AddManagingPartnerController', AddManagingPartnerController);

    function AddManagingPartnerController(partnerIndex, partner, $scope, $translate, $uibModalInstance, $timeout, toastr, PaymentSetupService) {

        var vm = this;
    
        vm.isNew = !partner;
        vm.occupations = PaymentSetupService.getProfessionalOccupations();
        vm.partner = partner ? partner : {};
        vm.partnerIndex = partnerIndex;
        if  (!partner) {
            vm.partner.address = {};
        }

        vm.height = window.innerHeight;
        
        function setDynamicDivHeight() {
            vm.height = window.innerHeight;
        }

        window.addEventListener('load', setDynamicDivHeight);
        window.addEventListener('resize', setDynamicDivHeight);

        init();

        function init() {
        }

        vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		}

        vm.addPartner = function () {
            var data = {
                partner: vm.partner,
                partnerIndex: vm.partnerIndex
            }
            $uibModalInstance.close({ data: data });
        }

        angular.element(function () {
            $timeout(function(){
                initAutocomplete();
            }, 2000);
        });

        function initAutocomplete() {
            // Crie o campo de entrada para o autocomplete
            var input = document.getElementById('autocomplete');
            // Inicialize o autocomplete passando o campo de entrada e configurando os tipos de lugares que deseja sugerir
            var autocomplete = new google.maps.places.Autocomplete(input, {
              types: ['geocode'], // Pode alterar para ['(regions)'] para sugerir áreas mais amplas
              componentRestrictions: { country: 'br' } // Restringe as sugestões ao Brasil
            });
          

            // Adicione um listener para lidar com o evento de seleção
            autocomplete.addListener('place_changed', function() {
                var place = autocomplete.getPlace();
                
                if (!place.geometry) {
                    // Se o usuário inseriu um lugar que não existe, exiba uma mensagem
                    console.log("Nenhuma informação disponível para o local inserido: '" + place.name + "'");
                    return;
                }
          
                // Faça algo com o resultado selecionado
                populateAddressFields(place);
            });
          }
          

        function populateAddressFields(result) {
            var addressComponents = result.address_components;
            for (var i = 0; i < addressComponents.length; i++) {
              var component = addressComponents[i];
              var types = component.types;
              for (var j = 0; j < types.length; j++) {
                var type = types[j];
                if (type === "route") {
                    vm.partner.address.street = component.long_name;
                } else if (type === "sublocality_level_1" || type === "locality") {
                    vm.partner.address.neighborhood = component.long_name;
                } else if (type === "administrative_area_level_2") {
                    vm.partner.address.city = component.long_name;
                } else if (type === "administrative_area_level_1") {
                    vm.partner.address.state = component.short_name;
                } else if (type === "country") {
                    vm.partner.address.country = component.long_name;
                } else if (type === "postal_code") {
                    vm.partner.address.zipcode = component.long_name;
                } else if (type === "street_number") {
                    vm.partner.address.streetNumber = component.long_name;
                }
              }
            }
            $scope.$apply();
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('PaymentDiscountFormModalController', PaymentDiscountFormModalController);

    function PaymentDiscountFormModalController(paymentCondition, paymentDiscount, currency, $rootScope, $localStorage, $translate, $uibModalInstance, $location, toastr, 
        UserService, StoreService, PaymentDiscountService) {

        var vm = this;
        vm.currency = currency;
        vm.currencyConfigurations = getCurrencyListConfiguration();
        vm.configutaionsPrice = vm.currencyConfigurations[currency];
        vm.discountTypeList = [
            { name: $translate.instant('global.form.discount-type.fixed-value'), key: "DISCOUNT_VALUE" },
            { name: $translate.instant('global.form.discount-type.percentage'), key: "PERCENTAGE" }
        ];
        vm.paymentDiscount = paymentDiscount ? paymentDiscount : {
            paymentCondition: paymentCondition,
            minValue: 0,
            discountValue: 0,
            discountType: "DISCOUNT_VALUE",
            isEnabled: true,
            storeId: $localStorage.defaultStore.storeId
        };
        vm.regexForValueZero = '([1-9]{1}[0-9]{0,2})(\.[0-9]{3})*\,[0-9]{2}|[0-9]{0,3}(\.[0-9]{3})*\,([0-9][1-9]|[1-9][0-9])';
        vm.discountTypes = [
            { name: $translate.instant('global.form.discount-type.percentage'), key: "PERCENTAGE" },
            { name: $translate.instant('global.form.discount-type.fixed-value'), key: "DISCOUNT_VALUE" }
        ];

        vm.height = window.innerHeight;
        
        function setDynamicDivHeight() {
            vm.height = window.innerHeight;
        }

        window.addEventListener('load', setDynamicDivHeight);
        window.addEventListener('resize', setDynamicDivHeight);

        StoreService.getStore($localStorage.defaultStore.storeId).then(function (response) {
            vm.store = response.data;
            vm.storeCategory = response.data.categoryKey;
        });

        init();

        function init() {
            vm.selectedDiscountType = vm.paymentDiscount && vm.paymentDiscount.discountType && vm.paymentDiscount.discountType == 'DISCOUNT_VALUE'
                ? { name: $translate.instant('global.form.discount-type.fixed-value'), key: "DISCOUNT_VALUE" }
                : { name: $translate.instant('global.form.discount-type.percentage'), key: "PERCENTAGE" };
        }

        vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		}

        vm.save = function () {
            vm.formPaymentDiscount.$submitted = true;
            // if (!vm.selectedBankAccount || !vm.selectedBankAccount.codigo) {
            //     toastr.error($translate.instant('settings.erps.online-retail.modal.order.message.error-bank-account-required'));
            //     return;
            // }

            // if (!vm.selectedSeller || !vm.selectedSeller.id) {
            //     toastr.error($translate.instant('settings.erps.online-retail.modal.order.message.error-default-seller-required'));
            //     return;
            // }

            if (vm.formPaymentDiscount.$invalid) {
                return;
            }
            
            vm.paymentDiscount.discountType = vm.selectedDiscountType.key;

            console.log(vm.paymentDiscount);
            console.log(vm.formPaymentDiscount);

            if (vm.paymentDiscount.id) {
                PaymentDiscountService.update(vm.paymentDiscount.id, vm.paymentDiscount)
                    .then(
                        function(response) {
                            console.log(response);
                            toastr.success($translate.instant('settings.store.payments.payment-discount.messages.update-success'));
                            $uibModalInstance.close({ data: vm.paymentDiscount });
                        },
                        function(err) {
                            console.log(err);
                            toastr.error($translate.instant('settings.store.payments.payment-discount.messages.update-error'));
                        }
                    );
            } else {
                PaymentDiscountService.create(vm.paymentDiscount)
                    .then(
                        function(response) {
                            console.log(response);
                            toastr.success($translate.instant('settings.store.payments.payment-discount.messages.create-success'));
                            $uibModalInstance.close({ data: vm.paymentDiscount });
                        },
                        function(err) {
                            console.log(err);
                            toastr.error($translate.instant('settings.store.payments.payment-discount.messages.create-error'));
                        }
                    );
            }

            
            
            
            // $uibModalInstance.close({ data: vm.paymentDiscount });
        }
    }

})();

(function () {
    'user strict'

    angular
        .module('showcaseApp')
        .controller('MarketingSettingsController', MarketingSettingsController);

    function MarketingSettingsController(toastr, $state, $localStorage, $translate, Constants,
                                    ModalFactory, StoreService, ConfirmActionModalFactory, WatiService,
                                         AbandonedCartNotificationService) {

        var vm = this;

        vm.notifyTimes = notifyTimes();
        vm.isMobile = detectar_mobile();

        vm.store = $localStorage.defaultStore;
        vm.form = {
            notifyTime: {
                code: "1",
                time: 15,
                unity: 'MINUTES'
            },
            template: null,
            discountCoupon: null
        };
        vm.templates = [];
        vm.loadingTemplates = true;
        vm.notifications = [];
        vm.templateHasCoupon = false;
        vm.isSaving = false;
        vm.activeForm = false;

        vm.WATICredits = undefined;
        vm.isWATIConnected = false;

        init();

        function init() {
            getTemplates();
            getNotifications();
            setNotifyTimeLabel();
            getStoreInfo();
            getWATIConnection();
            getWATICredits();
        }

        function getWATIConnection() {
            WatiService.getConfigByCurrentStore().then(function (result) {
                getWATICredits();
                if (result.data.id) {
                    vm.isWATIConnected = true;
                } else {
                    vm.isWATIConnected = false;
                }
            })
        }

        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId).then(function (response) {
                vm.store = response.data;
                setBuyWATICreditsMessage();
                setConnectWATIMessage();
            });
        }

        function getWATICredits() {
            WatiService.getWATICredits().then(function (result) {
                if (result && result.creditCustomer) {
                    vm.WATICredits = result.creditCustomer.credit;
                }
            });
        }

        vm.selectTemplate = function () {
            if (vm.form.template && vm.form.template.customParams) {
                var findCouponParam = vm.form.template.customParams.find(function (param) {
                    return param.paramName === 'discount_code';
                });
                vm.templateHasCoupon = !!findCouponParam;
            }
        }

        vm.openCreateNotificationForm = function () {
            vm.activeForm = !vm.activeForm;
            scrollToBottom();
        }

        vm.cancelForm = function() {
            vm.activeForm = false;
            refreshNotifications();
        }

        function setNotifyTimeLabel() {
            vm.notifyTimes.forEach(function (item) {
               item.label = getNotifyOptionLabel(item);
            });
        }

        function getNotifyOptionLabel(item) {
            return item.time + ' ' + $translate.instant('settings.marketing.abandoned-cart.form.' + item.unity.toLowerCase());
        }

        function getTemplates() {
            WatiService.searchTemplateMessagesByText('ca_').then(function (result) {
                if (result && result.data) {
                    vm.loadingTemplates = false;
                    vm.templates = result.data.items;
                    vm.form.template = vm.templates[0];
                    vm.selectTemplate();
                }
            }).catch(function (err) {
                vm.loadingTemplates = false;
            });
        }

        function getNotifications() {
            AbandonedCartNotificationService.findAllNotifications().then(function (result) {
                vm.notifications = _.sortBy(result.data, ['id']);
                vm.notifications.forEach(function (notification) {
                    setTimeAndUnity(notification);
                });
            });
        }

        vm.getNotificationById = function(id) {
            AbandonedCartNotificationService.findNotificationById(id).then(function (result) {
                vm.form = result.data;
                vm.form.template = vm.templates.find(function (template) {
                    return template.id === vm.form.templateId;
                });

                vm.form.notifyTime = vm.notifyTimes.find(function (notifyTime) {
                    return String(notifyTime.code) === vm.form.notifyTimeCode;
                });

                vm.selectTemplate();
                vm.activeForm = true;
                scrollToBottom();
            });
        }

        vm.createUpdateAbandonedCartNotifier = function () {
            if (vm.form.id){
                updateAbandonedCartNotifier();
            } else {
                createAbandonedCartNotifier();
            }
        }

        function createAbandonedCartNotifier() {
            var body = {
                isEnabled: true,
                templateId: vm.form.template.id,
                notifyTimeCode: vm.form.notifyTime.code,
                discountCoupon: vm.form.discountCoupon
            }
            ModalFactory.openWarningModal(
                null,
                $translate.instant('settings.marketing.abandoned-cart.create-modal.title'),
                $translate.instant('settings.marketing.abandoned-cart.create-modal.small-text'),
                $translate.instant('settings.marketing.abandoned-cart.create-modal.warning-text'),
                $translate.instant('entity.action.continue'),
                $translate.instant('entity.action.cancel'),
                function () {
                    AbandonedCartNotificationService.saveNotification(body).then(function (result) {
                        var newNotification = result.data;
                        setTimeAndUnity(newNotification);
                        vm.notifications.push(newNotification);
                        refreshNotifications();
                        toastr.success($translate.instant('settings.marketing.abandoned-cart.success-to-create'));
                    }).catch(function (err) {
                        vm.isSaving = false;
                        toastr.error($translate.instant('settings.marketing.abandoned-cart.failed-to-create'));
                    });
                }
            );
        }

        vm.disableNotification = function (notification) {
            var body = {
                id: notification.id,
                isEnabled: notification.isEnabled,
                templateId: notification.templateId,
                notifyTimeCode: notification.notifyTimeCode,
                discountCoupon: notification.discountCoupon
            }
            var action = notification.isEnabled ? 'active' : 'disable';

            ModalFactory.openWarningModal(
                null,
                $translate.instant('settings.marketing.abandoned-cart.' + action + '-modal.title'),
                $translate.instant('settings.marketing.abandoned-cart.' + action + '-modal.small-text'),
                $translate.instant('settings.marketing.abandoned-cart.' + action + '-modal.warning-text'),
                $translate.instant('entity.action.continue'),
                $translate.instant('entity.action.cancel'),
                function () {
                    vm.isSaving = true;
                    AbandonedCartNotificationService.editNotification(notification.id, body)
                        .then(function (result) {
                            vm.isSaving = false;
                            toastr.success($translate.instant('settings.marketing.abandoned-cart.success-to-' + action));
                        })
                        .catch(function (err) {
                            vm.isSaving = false;
                            notification.isEnabled = !notification.isEnabled;
                            toastr.error($translate.instant('settings.marketing.abandoned-cart.failed-to-' + action));
                        });
                },
                function () {
                    notification.isEnabled = !notification.isEnabled;
                }
            );
        }

        function updateAbandonedCartNotifier() {
            var body = {
                id: vm.form.id,
                isEnabled: vm.form.isEnabled,
                templateId: vm.form.template.id,
                notifyTimeCode: vm.form.notifyTime.code,
                discountCoupon: vm.form.discountCoupon
            }

            ModalFactory.openWarningModal(
                null,
                $translate.instant('settings.marketing.abandoned-cart.update-modal.title'),
                $translate.instant('settings.marketing.abandoned-cart.update-modal.small-text'),
                $translate.instant('settings.marketing.abandoned-cart.update-modal.warning-text'),
                $translate.instant('entity.action.continue'),
                $translate.instant('entity.action.cancel'),
                function () {
                    vm.isSaving = true;
                    AbandonedCartNotificationService.editNotification(vm.form.id, body).then(function (result) {
                        var newNotification = result.data;
                        setTimeAndUnity(newNotification);
                        var index = _.findIndex(vm.notifications, {id: newNotification.id});
                        vm.notifications.splice(index, 1, newNotification);
                        refreshNotifications();
                        toastr.success($translate.instant('settings.marketing.abandoned-cart.success-to-update'));
                    }).catch(function (err) {
                        vm.isSaving = false;
                        toastr.error($translate.instant('settings.marketing.abandoned-cart.failed-to-update'));
                    });
                }
            );
        }

        function refreshNotifications() {
            vm.isSaving = false;
            vm.activeForm = false;
            vm.form = {
                notifyTime: {
                    code: "1",
                    time: 15,
                    unity: 'MINUTES'
                },
                template: vm.templates[0],
                discountCoupon: null
            };
            vm.notifications = _.sortBy(vm.notifications, ['id']);
            vm.selectTemplate();
        }

        function setTimeAndUnity(notification) {
            var notifyItemInfo = _.find(vm.notifyTimes, function (notifyTime) {
                return notification.notifyTimeCode === String(notifyTime.code);
            });

            notification.time = notifyItemInfo.time;
            notification.unity = $translate.instant('settings.marketing.abandoned-cart.form.' + notifyItemInfo.unity.toLowerCase());
        }

        vm.deleteNotification = function (id) {
            ModalFactory.openWarningModal(
                null,
                $translate.instant('settings.marketing.abandoned-cart.delete-modal.title'),
                $translate.instant('settings.marketing.abandoned-cart.delete-modal.small-text'),
                $translate.instant('settings.marketing.abandoned-cart.delete-modal.warning-text'),
                $translate.instant('entity.action.continue'),
                $translate.instant('entity.action.cancel'),
                function () {
                    AbandonedCartNotificationService.removeNotification(id).then(function (result) {
                        getNotifications();
                        toastr.success($translate.instant('settings.marketing.abandoned-cart.success-to-remove'));
                    }).catch(function (err) {
                        toastr.error($translate.instant('settings.marketing.abandoned-cart.failed-to-remove'));
                    });
                }
            );
        }

        function scrollToBottom() {
            setTimeout(function() {
                var element = document.getElementById('abandoned-cart-form');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
        }

        function setBuyWATICreditsMessage() {
            var storeName = vm.store.name;
            var message = $translate.instant('settings.marketing.abandoned-cart.buy-credits-message',
                { storeName: storeName });
            vm.buyWATICreditsMessage = 'https://api.whatsapp.com/send?phone=+558398931539&text='.concat(message);
        }

        function setConnectWATIMessage() {
            var storeName = vm.store.name;
            var message = $translate.instant('settings.marketing.abandoned-cart.connect-wati-request',
                { storeName: storeName });
            vm.connectWATIMessage = 'https://api.whatsapp.com/send?phone=+558398931539&text='.concat(message);
        }
    }
})();

function notifyTimes() {
    return [
        {
            code: 1,
            time: 15,
            unity: 'MINUTES'
        },
        {
            code: 2,
            time: 30,
            unity: 'MINUTES'
        },
        {
            code: 3,
            time: 60,
            unity: 'MINUTES'
        },
        {
            code: 4,
            time: 2,
            unity: 'HOURS'
        },
        {
            code: 5,
            time: 5,
            unity: 'HOURS'
        },
        {
            code: 6,
            time: 12,
            unity: 'HOURS'
        },
        {
            code: 7,
            time: 1,
            unity: 'DAY'
        },
        {
            code: 8,
            time: 3,
            unity: 'DAYS'
        },
        {
            code: 9,
            time: 5,
            unity: 'DAYS'
        }
    ];
}

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('AbandonedCartNotificationService', AbandonedCartNotificationService);

    AbandonedCartNotificationService.$inject = ['AbandonedCartNotificationFactory'];

    function AbandonedCartNotificationService(AbandonedCartNotificationFactory) {

        var service = {
            saveNotification: saveNotification,
            findAllNotifications: findAllNotifications,
            findNotificationById: findNotificationById,
            editNotification: editNotification,
            removeNotification: removeNotification
        };

        return service;

        function saveNotification(body) {
            return AbandonedCartNotificationFactory.saveNotification(body).$promise;
        }

        function findAllNotifications() {
            return AbandonedCartNotificationFactory.findAllNotifications().$promise;
        }

        function findNotificationById(notificationId) {
            return AbandonedCartNotificationFactory.findNotificationById({"notificationId": notificationId}).$promise;
        }

        function editNotification(notificationId, body) {
            return AbandonedCartNotificationFactory.editNotification({"notificationId": notificationId}, body).$promise;
        }

        function removeNotification(notificationId) {
            return AbandonedCartNotificationFactory.removeNotification({"notificationId": notificationId}).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('AbandonedCartNotificationFactory', AbandonedCartNotificationFactory);

    AbandonedCartNotificationFactory.$inject = ['$resource'];

    function AbandonedCartNotificationFactory($resource) {
        var resourceUrl = 'admin/api/abandoned-cart-notify';
        var createNotificationResourceUrl = resourceUrl + '/create';
        var getNotificationsResourceUrl = resourceUrl + '/list';
        var getNotificationByIdResourceUrl = resourceUrl + '/find/:notificationId'
        var editNotificationResourceUrl = resourceUrl + '/edit/:notificationId'
        var removeNotificationResourceUrl = resourceUrl + '/remove/:notificationId'


        return $resource(resourceUrl, {}, {
            'saveNotification': {
                method: 'POST',
                url: createNotificationResourceUrl,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'findAllNotifications': {
                method: 'GET',
                url: getNotificationsResourceUrl,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'findNotificationById': {
                method: 'GET',
                url: getNotificationByIdResourceUrl,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'removeNotification': {
                method: 'DELETE',
                url: removeNotificationResourceUrl,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'editNotification': {
                method: 'PUT',
                url: editNotificationResourceUrl,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('OnlineRetailOrderConfigController', OnlineRetailOrderConfigController);

    function OnlineRetailOrderConfigController(config, showkaseUsers, onlineRetailUsers, bankAccounts, $rootScope, $localStorage, $translate, $uibModalInstance, $location, toastr, 
        UserService, StoreService) {

        var vm = this;

        vm.selectedBankAccount = undefined;
        vm.selectedSeller = undefined;
        vm.selectedShowkaseUser = undefined;
        vm.selectedOnlineRetailUser = undefined;
        vm.userLinks = [];
        vm.userLinksView = [];
        vm.showkaseUsers = showkaseUsers ? showkaseUsers : [];
        vm.onlineRetailUsers = onlineRetailUsers ? onlineRetailUsers : [];
        vm.bankAccounts = bankAccounts;
        vm.config = config;


        vm.height = window.innerHeight;
        
        function setDynamicDivHeight() {
            vm.height = window.innerHeight;
        }

        window.addEventListener('load', setDynamicDivHeight);
        window.addEventListener('resize', setDynamicDivHeight);

        StoreService.getStore($localStorage.defaultStore.storeId).then(function (response) {
            vm.store = response.data;
            vm.storeCategory = response.data.categoryKey;
        });

        init();

        function init() {
            console.log(vm.config);
            loadConfig();
            loadUserLinks();
        }

        function loadConfig() {
            if (vm.config) {
                selectBankAcount(vm.config.accountCode);
                selectDefaultSeller(vm.config.sellerCode);
            }
        }

        function selectBankAcount(code) {
            if (code && vm.bankAccounts) {
                var filtered = vm.bankAccounts.filter(function(account) { return account.codigo == code; });
                vm.selectedBankAccount = filtered && filtered.length > 0 ? filtered[0] : undefined;
            }
        }

        function selectDefaultSeller(sellerId) {
            if (sellerId && vm.onlineRetailUsers) {
                var filtered = vm.onlineRetailUsers.filter(function(seller) { return seller.id == sellerId; });
                vm.selectedSeller = filtered && filtered.length > 0 ? filtered[0] : undefined;
            }
        }

        function loadUserLinks() {
            if (vm.config && vm.config.userLinks) {
                console.log(vm.showkaseUsers);
                console.log(vm.onlineRetailUsers);
                vm.userLinks = vm.config.userLinks.map(function(link) {
                    var shkUser = getUserById(link.userId, vm.showkaseUsers);
                    var orUser = getUserById(link.erpUserId, vm.onlineRetailUsers);
                    if (shkUser && orUser) {
                        return {
                            showkaseId: shkUser.id,
                            showkaseName: shkUser.fullName,
                            onlineRetailId: orUser.id,
                            onlineRetailName: orUser.nome
                        };
                    }

                    return null;
                }).filter(function(item) { return item !== null });
                vm.userLinksView = getUserLinksView();
                console.log(vm.userLinksView);
            }
        }

        function getUserLinksView() {
            return vm.userLinks.map(function(link) {
                var shkUser = getUserById(link.showkaseId, vm.showkaseUsers);
                var orUser = getUserById(link.onlineRetailId, vm.onlineRetailUsers);
                if (shkUser && orUser) {
                    return {
                        showkaseId: shkUser.id,
                        showkaseName: shkUser.fullName,
                        onlineRetailId: orUser.id,
                        onlineRetailName: orUser.nome
                    };
                }

                return null;
            }).filter(function(item) { return item !== null });
        }

        
        vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		}

        vm.linkUsers = function() {
            if (!vm.selectedShowkaseUser || !vm.selectedOnlineRetailUser) {
                toastr.error($translate.instant('settings.erps.online-retail.modal.order.message.error-link-users'));
                return;
            }

            if (containsShowkaseUser(vm.selectedShowkaseUser.id)) {
                toastr.error($translate.instant('settings.erps.online-retail.modal.order.message.error-link-user-in-use'));
                return;
            }

            var link = {
                showkaseId: vm.selectedShowkaseUser.id,
                showkaseName: vm.selectedShowkaseUser.fullName,
                onlineRetailId: vm.selectedOnlineRetailUser.id,
                onlineRetailName: vm.selectedOnlineRetailUser.nome
            }
            vm.userLinks.push(link);
            vm.selectedShowkaseUser = undefined;
            vm.selectedOnlineRetailUser = undefined;
            vm.userLinksView = getUserLinksView();
        }

        vm.deleteLink = function(link) {
            if (link && vm.userLinks && vm.userLinks.length > 0) {
                var index = vm.userLinks.map(function(item) { return item.showkaseId; }).indexOf(link.showkaseId);
                vm.userLinks.splice(index, 1);
                vm.userLinksView = getUserLinksView();
            }
        }

        function containsShowkaseUser(showkaseId) {
            if (showkaseId && vm.userLinks && vm.userLinks.length > 0) {
                var index = vm.userLinks.map(function(item) { return item.showkaseId; }).indexOf(showkaseId);
                return index >= 0;
            }

            return false;
        }

        function getUserById(id, entityList) {
            if (entityList) {
                var filtered = entityList.filter(function(item) { return item.id === id });
                return filtered && filtered.length > 0 ? filtered[0] : undefined;
            }
            
            return undefined;
        }

        function userLinkMapper() {
            return vm.userLinks.map(function(link) {
                return {
                    userId: link.showkaseId,
                    erpUserId: link.onlineRetailId,
                    isEnabled: true
                };  
            });
        }

        vm.save = function () {
            if (!vm.selectedBankAccount || !vm.selectedBankAccount.codigo) {
                toastr.error($translate.instant('settings.erps.online-retail.modal.order.message.error-bank-account-required'));
                return;
            }

            if (!vm.selectedSeller || !vm.selectedSeller.id) {
                toastr.error($translate.instant('settings.erps.online-retail.modal.order.message.error-default-seller-required'));
                return;
            }
            
            vm.config.userLinksView = getUserLinksView(); 
            vm.config.userLinks = userLinkMapper();            
            vm.config.accountCode = vm.selectedBankAccount.codigo;
            vm.config.sellerCode = vm.selectedSeller.id;
            vm.config.selectedSeller = vm.selectedSeller;
            vm.config.selectedBankAccount = vm.selectedBankAccount;

            console.log(vm.config);

            $uibModalInstance.close({ data: vm.config });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('OnlineRetailService', OnlineRetailService);

    OnlineRetailService.$inject = ['OnlineRetailFactory'];

    function OnlineRetailService(OnlineRetailFactory) {

        var service = {
            getPriceTables: getPriceTables,
            getEntities: getEntities,
            getBankAccounts: getBankAccounts,
            getSellers: getSellers,
            reprocessOnlineRetail: reprocessOnlineRetail,
            getCategoryLevelList: getCategoryLevelList,
            syncProductsByStoreAndFlyerIds: syncProductsByStoreAndFlyerIds
        };

        return service;

        function getPriceTables(token, entities) {
            return OnlineRetailFactory.getPriceTables({ token: token, entities: entities }).$promise;
        }

        function getEntities(token) {
            return OnlineRetailFactory.getEntities({ token: token }).$promise;
        }

        function getBankAccounts(token, entityIds) {
            return OnlineRetailFactory.getBankAccounts({ token: token, entityIds: entityIds }).$promise;
        }

        function getSellers(token) {
            return OnlineRetailFactory.getSellers({ token: token }).$promise;
        }

        function getCategoryLevelList(token) {
            return OnlineRetailFactory.getCategoryLevelList({ token: token }).$promise;
        }

        function reprocessOnlineRetail(id) {
            return OnlineRetailFactory.reprocessOnlineRetail({ id: id }, {}).$promise;
        }

        function syncProductsByStoreAndFlyerIds(storeId, flyerIds) {
            return OnlineRetailFactory.syncProductsByStoreAndFlyerIds({ storeId: storeId }, flyerIds).$promise;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('OnlineRetailFactory', OnlineRetailFactory);

    OnlineRetailFactory.$inject = ['$resource'];

    function OnlineRetailFactory($resource) {
        var flyerResourceUrl = 'flyer/api/online-retail';
        var adminResourceUrl = 'admin/api/erp-configuration';

        return $resource(adminResourceUrl, {}, {
            'getPriceTables': {
                method: 'GET',
                url: adminResourceUrl + '/price-tables/:token',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }, 
            'getEntities': {
                method: 'GET',
                url: adminResourceUrl + '/entities/:token',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getBankAccounts': {
                method: 'GET',
                url: adminResourceUrl + '/bank-accounts/:token',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getSellers': {
                method: 'GET',
                url: adminResourceUrl + '/sellers/:token',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getCategoryLevelList': {
                method: 'GET',
                url: adminResourceUrl + '/category-level/:token',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'reprocess': {
                method: 'PUT',
                url: adminResourceUrl + '/reprocess/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'syncProductsByStoreAndFlyerIds': {
                method: 'POST',
                url: flyerResourceUrl + '/sync-products/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('NexaasService', NexaasService);

    NexaasService.$inject = ['NexaasFactory'];

    function NexaasService(NexaasFactory) {

        var service = {
            syncProductsByStoreAndFlyerIds: syncProductsByStoreAndFlyerIds
        };

        return service;

        function syncProductsByStoreAndFlyerIds(storeId, flyerIds) {
            return NexaasFactory.syncProductsByStoreAndFlyerIds({ storeId: storeId }, flyerIds).$promise;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('NexaasFactory', NexaasFactory);

    NexaasFactory.$inject = ['$resource'];

    function NexaasFactory($resource) {
        var resourceUrl = 'flyer/api/integration/nexass';

        return $resource(resourceUrl, {}, {
            'syncProductsByStoreAndFlyerIds': {
                method: 'POST',
                url: resourceUrl + '/sync-products/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('ErpsSettingsService', ErpsSettingsService);

    ErpsSettingsService.$inject = ['ErpsSettingsFactory'];

    function ErpsSettingsService(ErpsSettingsFactory) {

        var service = {
            createERPConfiguration: createERPConfiguration,
            updateERPConfiguration: updateERPConfiguration,
            getERPConfigurationByStoreIdAndPartnerId: getERPConfigurationByStoreIdAndPartnerId,
            getERPConfigurationByStoreId: getERPConfigurationByStoreId,
            getNexaasOrganizationsByToken: getNexaasOrganizationsByToken,
            getNexaasOrganizationStocks: getNexaasOrganizationStocks,
            startNexaasSynchronization: startNexaasSynchronization,
            deleteErpConfiguration: deleteErpConfiguration,
            createERPConfigurationForSoftcom: createERPConfigurationForSoftcom
        };

        return service;

        function createERPConfiguration(erpConfiguration) {
            return ErpsSettingsFactory.createERPConfiguration(erpConfiguration).$promise;
        }

        function updateERPConfiguration(erpConfiguration) {
            return ErpsSettingsFactory.updateERPConfiguration({ erpConfigurationId: erpConfiguration.id }, erpConfiguration).$promise;
        }

        function getERPConfigurationByStoreIdAndPartnerId(storeId, partnerId) {
            return ErpsSettingsFactory.getERPConfigurationByStoreIdAndPartnerId({ storeId: storeId, partnerId: partnerId }).$promise;
        }

        function getERPConfigurationByStoreId(storeId) {
            return ErpsSettingsFactory.getERPConfigurationByStoreId({ storeId: storeId }).$promise;
        }

        function getNexaasOrganizationsByToken(token) {
            return ErpsSettingsFactory.getNexaasOrganizationsByToken({ token: token }).$promise;
        }

        function getNexaasOrganizationStocks(token, organizationId) {
            return ErpsSettingsFactory.getNexaasOrganizationStocks({ token: token, organizationId: organizationId }).$promise;
        }

        function startNexaasSynchronization(storeId) {
            return ErpsSettingsFactory.startNexaasSynchronization(storeId).$promise;
        }

        function deleteErpConfiguration(id) {
            return ErpsSettingsFactory.deleteErpConfiguration({ id: id }).$promise;
        }

        function createERPConfigurationForSoftcom(storeId) {
            return ErpsSettingsFactory.createERPConfigurationForSoftcom({storeId: storeId}).$promise;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ErpsSettingsFactory', ErpsSettingsFactory);

    ErpsSettingsFactory.$inject = ['$resource'];

    function ErpsSettingsFactory($resource) {
        var resourceUrl = 'admin/api/erp-configuration';

        return $resource(resourceUrl, {storeId: '@storeId'}, {
            'createERPConfiguration': {
                method: 'POST',
                url: resourceUrl,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getERPConfigurationByStoreIdAndPartnerId': {
                method: 'GET',
                url: resourceUrl + '/store/:storeId/partner/:partnerId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getERPConfigurationByStoreId': {
                method: 'GET',
                url: resourceUrl + '/store/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateERPConfiguration': {
                method: 'PUT',
                url: resourceUrl + '/:erpConfigurationId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }, 'getPriceTablesByToken': {
                method: 'GET',
                url: resourceUrl + '/price-tables/:token',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }, 'getEntitiesByToken': {
                method: 'GET',
                url: resourceUrl + '/entities/:token',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }, 'getNexaasOrganizationsByToken': {
                method: 'GET',
                url: resourceUrl + '/organizations/:token',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }, 'getNexaasOrganizationStocks': {
                method: 'GET',
                url: resourceUrl + '/stocks/nexaas/:token',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'startNexaasSynchronization': {
                method: 'POST',
                url: 'flyer/api/integration/nexaas/synchronize',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'reprocessOnlineRetail': {
                method: 'PUT',
                url: resourceUrl + '/reprocess/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deleteErpConfiguration': {
                method: 'DELETE',
                url: resourceUrl + '/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'createERPConfigurationForSoftcom': {
                method: 'POST',
                url: resourceUrl + '/softcom/create',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
        });
    }
})();

(function () {
    'user strict'

    angular
        .module('showcaseApp')
        .controller('ErpsSettingsController', ErpsSettingsController);

    //** NgInject */
    function ErpsSettingsController(toastr, $state, $localStorage, $translate, $location, $uibModal, Constants,
                ModalFactory, StoreService, ErpsSettingsService, OnlineRetailService, FlyersService, BlingService, 
                ConfirmActionModalFactory, UserService) {

        var vm = this;

        vm.store = $localStorage.defaultStore;
        vm.currentStore = null;
        vm.loading = false;
        vm.isSaving = false;
        vm.isViewForm = false;
        vm.isMobile = detectar_mobile();

        // Varejo Online
        vm.isLoadingPriceTable = false;
        vm.onlineRetail = null;
        vm.priceTable;
        vm.priceTableList = [];
        vm.promotionalPriceTable;
        vm.promotionalPriceTableList = [{
            "nome": "Nenhum"
        }];
        vm.selectedEntity;
        vm.entities = [];
        vm.entitiesList = [];
        vm.userLinksView = [];
        vm.showkaseUsers = [];
        vm.syncName = false;
        vm.syncDescription = false;
        vm.syncImage = false;
        vm.syncCategory = false;
        vm.syncBrand = false;
        vm.syncTags = false;
        vm.roundPrice = false;
        vm.onlyEcommerce = true;
        vm.inventoryThreshold = false;

        vm.selectedBankAccount = undefined;
        vm.selectedCategoryLevel = undefined;
        vm.bankAccounts = [];
        // Nexaas
        vm.nexaas = null;
        vm.nexaasOrganization = null;
        vm.nexaasOrganizationList = [];
        vm.nexaasStock;
        vm.nexaasStockList = [];
        vm.nexaasSaleChannel;
        vm.nexaasSaleChannelList = [];
        vm.nexaasPriceTable;
        vm.nexaasPriceTableList = [];

        // Bling
        vm.bling = null;

        toastr.options = {
            timeOut: 8000,
        };
        
        init();

        function init() {
            loadStoreData();
            getSoftcomByStore(vm.store.storeId);
            getOnlineRetailByStore(vm.store.storeId);
            getNexaasByStore(vm.store.storeId);
            getBlingByStore(vm.store.storeId);
            processBlingResponse();
        }

        vm.createUpdateOnlineRetail = function () {
            if (vm.onlineRetail.id) {
                ModalFactory.openWarningModal($translate.instant('settings.erps.online-retail.messages.price-modal.title'),
                    $translate.instant('settings.erps.online-retail.messages.price-modal.title'),
                    $translate.instant('settings.erps.online-retail.messages.price-modal.small-text'),
                    null,
                    $translate.instant('settings.erps.online-retail.messages.price-modal.confirm-button'),
                    $translate.instant('settings.erps.online-retail.messages.price-modal.cancel'),
                    updateOnlineRetail
                );
            } else {
                if ((vm.nexaas && vm.nexaas.id) || (vm.bling && vm.bling.id)) {
                    openModalChangePartner(createOnlineRetail);
                } else {
                    createOnlineRetail();
                }
            }
        }

        vm.confirmReprocess = function() {
            ConfirmActionModalFactory.confirmAction().then(function(data) {
                reprocessData()
            });
        }

        vm.getBlingOrderCallbackUrl = function() {
            return $location.protocol() + "://" + $location.host() + "/flyer/api/integration/bling/order/" + vm.store.storeId;
        }

        vm.getBlingStockCallbackUrl = function() {
            return $location.protocol() + "://" + $location.host() + "/flyer/api/integration/bling/stock/" + vm.store.storeId;
        }

        vm.copiedToClipboard = function() {
            toastr.success($translate.instant('settings.erps.bling.instructions.copied'));
        }

        function loadStoreData() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
                vm.currentStore = response.data;
            });
        }

        function reprocessData() {
            if (vm.onlineRetail.id) {
                vm.isSaving = true;
                ErpsSettingsService.reprocessOnlineRetail(vm.onlineRetail.id).then(
                    function (response) {
                        vm.isSaving = false;
                        vm.error = null;
                        vm.success = 'OK';
                        vm.onlineRetail.lastIntegrationDate = null;
                        vm.onlineRetail.integrationStartedAt = null;
                        vm.onlineRetail.status = 'NEW';
                        processResponse('settings.erps.online-retail.messages.reprocess');
                    },
                    function (err) {
                        vm.isSaving = false;
                        vm.success = null;
                        vm.error = err;
                        processResponse();
                    }
                );
            } else {
                processResponse();
            }
        }

        function createOnlineRetail() {
            vm.isSaving = true;
            vm.onlineRetail.storeId = vm.store.storeId;
            vm.onlineRetail.priceTableId = vm.priceTable.id;
            vm.onlineRetail.priceTableName = vm.priceTable.nome;
            if (vm.promotionalPriceTable && vm.promotionalPriceTable.id && vm.promotionalPriceTable.nome) {
                vm.onlineRetail.promotionalPriceTableId = vm.promotionalPriceTable.id;
                vm.onlineRetail.promotionalPriceTableName = vm.promotionalPriceTable.nome;
            }
            vm.onlineRetail.partnerId = Constants.ErpPartnerId.VAREJO_ONLINE;
            vm.onlineRetail.entities = vm.selectedEntity && vm.selectedEntity.id ? [vm.selectedEntity.id] : [];
            if (vm.selectedBankAccount && vm.selectedBankAccount.codigo) {
                vm.onlineRetail.accountCode = vm.selectedBankAccount.codigo;
            }
            if (vm.selectedSeller && vm.selectedSeller.id) {
                vm.onlineRetail.sellerCode = vm.selectedSeller.id;
            }
            mapOnlineRetailProductSettings();

            ErpsSettingsService.createERPConfiguration(vm.onlineRetail).then(
                function (response) {
                    vm.isSaving = false;
                    vm.error = null;
                    vm.success = 'OK';
                    processResponse('settings.erps.online-retail.messages.success');

                    $state.reload();
                },
                function (err) {
                    vm.isSaving = false;
                    vm.success = null;
                    vm.error = err;
                    processResponse();
                }
            );
        };

        function updateOnlineRetail() {
            vm.isSaving = true;
            vm.onlineRetail.storeId = vm.store.storeId;
            vm.onlineRetail.entities = vm.selectedEntity && vm.selectedEntity.id ? [vm.selectedEntity.id] : [];
            vm.onlineRetail.priceTableId = vm.priceTable.id;
            vm.onlineRetail.priceTableName = vm.priceTable.nome;
            if (vm.promotionalPriceTable && vm.promotionalPriceTable.id && vm.promotionalPriceTable.nome) {
                vm.onlineRetail.promotionalPriceTableId = vm.promotionalPriceTable.id;
                vm.onlineRetail.promotionalPriceTableName = vm.promotionalPriceTable.nome;
            } else {
                vm.onlineRetail.promotionalPriceTableId = null;
                vm.onlineRetail.promotionalPriceTableName = null;
            }
            if (vm.selectedBankAccount && vm.selectedBankAccount.codigo) {
                vm.onlineRetail.accountCode = vm.selectedBankAccount.codigo;
            }
            if (vm.selectedSeller && vm.selectedSeller.id) {
                vm.onlineRetail.sellerCode = vm.selectedSeller.id;
            }
            mapOnlineRetailProductSettings();

            ErpsSettingsService.updateERPConfiguration(vm.onlineRetail).then(
                function (response) {
                    if (!vm.onlineRetail.promotionalPriceTableId) {
                        FlyersService.clearFlyersDiscountedValue()
                            .then(function (resp) {
                                console.log(resp);
                            });
                    }
                    vm.isSaving = false;
                    vm.error = null;
                    vm.success = 'OK';
                    processResponse('settings.erps.online-retail.messages.success');
                },
                function (err) {
                    vm.isSaving = false;
                    vm.success = null;
                    vm.error = err;
                    processResponse();
                }
            );
        };

        vm.createUpdateNexaas = function () {
            if (!vm.isSaving) {
                if (vm.nexaas.id) {
                    if (vm.nexaasStock.id !== vm.nexaas.stockId
                        || vm.nexaasSaleChannel.id !== vm.nexaas.saleChannelId
                        || vm.nexaasPriceTable.id !== vm.nexaas.priceTableId) {
                        openModalChangeNexaas();
                    } else {
                        updateNexaas();
                    }
                } else {
                    if ((vm.onlineRetail && vm.onlineRetail.id) || (vm.bling && vm.bling.id)) {
                        openModalChangePartner(createNexaas);
                    } else {
                        createNexaas();
                    }
                }
            }
        }

        function createNexaas() {
            vm.isSaving = true;
            vm.nexaas.storeId = vm.store.storeId;
            vm.nexaas.partnerId = Constants.ErpPartnerId.NEXAAS;
            vm.nexaas.entities = [vm.nexaasOrganization.id];
            vm.nexaas.stockId = vm.nexaasStock.id;
            vm.nexaas.saleChannelId = vm.nexaasSaleChannel.id;
            vm.nexaas.priceTableId = vm.nexaasPriceTable.id;
            vm.nexaas.priceTableName = vm.nexaasPriceTable.name;

            ErpsSettingsService.createERPConfiguration(vm.nexaas).then(
                function (response) {
                    vm.isSaving = false;
                    vm.error = null;
                    vm.success = 'OK';
                    processResponse('settings.erps.nexaas.messages.success');

                    ErpsSettingsService.startNexaasSynchronization(vm.store.storeId);

                    $state.reload();
                },
                function (err) {
                    vm.isSaving = false;
                    vm.success = null;
                    vm.error = err;
                    processResponse();
                }
            );
        };

        function updateNexaas(synchronize) {
            vm.isSaving = true;
            vm.nexaas.storeId = vm.store.storeId;
            vm.nexaas.entities = [vm.nexaasOrganization.id];
            vm.nexaas.stockId = vm.nexaasStock.id;
            vm.nexaas.saleChannelId = vm.nexaasSaleChannel.id;
            vm.nexaas.priceTableId = vm.nexaasPriceTable.id;
            vm.nexaas.priceTableName = vm.nexaasPriceTable.name;

            ErpsSettingsService.updateERPConfiguration(vm.nexaas).then(
                function (response) {
                    vm.isSaving = false;
                    vm.error = null;
                    vm.success = 'OK';
                    processResponse('settings.erps.nexaas.messages.success');

                    if (synchronize) {
                        ErpsSettingsService.startNexaasSynchronization(vm.store.storeId);
                    }
                },
                function (err) {
                    vm.isSaving = false;
                    vm.success = null;
                    vm.error = err;
                    processResponse();
                }
            );
        };

        vm.updateBling = function() {
            vm.isSaving = true;
            if (vm.bling.blingStoreId) {
                vm.bling.entities = [];
                vm.bling.entities.push(Number(vm.bling.blingStoreId));
            }

            mapBlingProductSettings();
            
            ErpsSettingsService.updateERPConfiguration(vm.bling).then(
                function (response) {
                    vm.isSaving = false;
                    vm.error = null;
                    vm.success = 'OK';
                    processResponse('settings.erps.bling.messages.success');
                },
                function (err) {
                    vm.isSaving = false;
                    vm.success = null;
                    vm.error = err;
                    processResponse();
                }
            );
        };

        vm.createSoftcom = function () {
            if (!vm.isSaving) {
                ErpsSettingsService.createERPConfigurationForSoftcom(vm.store.storeId).then(
                    function (response) {
                        vm.isViewForm = true;
                        vm.softcom = response.data;
                    });
            }
        }

        function getSoftcomByStore(storeId) {
            ErpsSettingsService.getERPConfigurationByStoreIdAndPartnerId(storeId, Constants.ErpPartnerId.SOFTCOM).then(
                function (response) {
                    vm.isViewForm = true;
                    vm.softcom = response.data;
                });
        }

        function getOnlineRetailByStore(storeId) {
            ErpsSettingsService.getERPConfigurationByStoreIdAndPartnerId(storeId, Constants.ErpPartnerId.VAREJO_ONLINE).then(
                function (response) {
                    vm.isViewForm = true;
                    vm.onlineRetail = response.data;
                    if (vm.onlineRetail && vm.onlineRetail.id) {
                        vm.priceTable = {};
                        vm.priceTable.id = vm.onlineRetail.priceTableId;
                        vm.priceTable.nome = vm.onlineRetail.priceTableName;
                        vm.promotionalPriceTable = {};
                        vm.promotionalPriceTable.id = vm.onlineRetail.promotionalPriceTableId;
                        vm.promotionalPriceTable.nome = vm.onlineRetail.promotionalPriceTableName;
                        vm.entities = vm.onlineRetail.entities;
                        loadOnlineRetailProductSettings(response.data);
                        getEntitiesByToken();
                        vm.getOnlineRetailBankAccounts();
                        vm.getOnlineRetailSellers();
                    }
                });
        }

        function selectCategoryLevel(key) {
            if (key && vm.categoryLevelList) {
                var filtered = vm.categoryLevelList.filter(function(category) { return category.nome == key; });
                vm.selectedCategoryLevel = filtered && filtered.length > 0 ? filtered[0] : undefined;
            }
        }

        function selectBrandLevel(key) {
            if (key && vm.categoryLevelList) {
                var filtered = vm.categoryLevelList.filter(function(category) { return category.nome == key; });
                vm.selectedBrandLevel = filtered && filtered.length > 0 ? filtered[0] : undefined;
            }
        }

        function getNexaasByStore(storeId) {
            ErpsSettingsService.getERPConfigurationByStoreIdAndPartnerId(storeId, Constants.ErpPartnerId.NEXAAS).then(
                function (response) {
                    vm.isViewForm = true;
                    vm.nexaas = response.data;
                    if (vm.nexaas && vm.nexaas.id) {
                        vm.nexaasOrganization = vm.nexaas.entities.length ? vm.nexaas.entities[0] : null;
                        getOrganizationsByToken();
                    }
                });
        }

        function getBlingByStore(storeId) {
            ErpsSettingsService.getERPConfigurationByStoreIdAndPartnerId(storeId, Constants.ErpPartnerId.BLING).then(
                function (response) {
                    if (response && response.data) {
                        vm.isViewForm = true;
                        vm.bling = response.data;
                        loadBlingProductSettings(response.data);
                        if (vm.bling && vm.bling.entities && vm.bling.entities.length) {
                            vm.bling.blingStoreId = vm.bling.entities[0];
                        }
                    }
                });
        }

        vm.changePriceTable = function () {
            vm.promotionalPriceTableList = [{
                "nome": "Nenhum"
            }];

            var selectedPromotionalPriceTable = null;

            vm.priceTableList.filter(function (elem) { return elem.id != vm.priceTable.id })
                .forEach(function (elem) {
                    vm.promotionalPriceTableList.push(elem);
                });

            if (vm.promotionalPriceTable && vm.promotionalPriceTable.id && vm.priceTableList.length) {
                vm.promotionalPriceTableList
                    .forEach(function (elem) {
                        if (elem.id == vm.promotionalPriceTable.id) {
                            selectedPromotionalPriceTable = elem;
                        }
                    });
            }

            if (selectedPromotionalPriceTable) {
                vm.promotionalPriceTable = selectedPromotionalPriceTable;
            }
        }

        vm.getPriceTablesByToken = function () {
            if (vm.onlineRetail && vm.onlineRetail.token && vm.onlineRetail.token != "") {
                vm.isLoadingPriceTable = true;
                var entities = vm.selectedEntity && vm.selectedEntity.id ? [vm.selectedEntity.id] : [];
                OnlineRetailService.getPriceTables(vm.onlineRetail.token, entities).then(
                    function (response) {
                        vm.isViewForm = true;
                        vm.isLoadingPriceTable = false;
                        vm.priceTableList = [];

                        if (response.data && response.data.length) {
                            vm.priceTableList = response.data.filter(function (elem) { return !elem.excluido });
                        }

                        if (vm.priceTable && vm.priceTable.id && vm.priceTableList.length) {
                            vm.priceTableList
                                .forEach(function (elem) {
                                    if (elem.id == vm.priceTable.id) {
                                        vm.priceTable = elem;
                                    }
                                });

                            vm.priceTableList.filter(function (elem) { return elem.id != vm.priceTable.id })
                                .forEach(function (elem) {
                                    vm.promotionalPriceTableList.push(elem);
                                });
                        }

                        if (vm.promotionalPriceTable && vm.promotionalPriceTable.id && vm.priceTableList.length) {
                            vm.promotionalPriceTableList
                                .forEach(function (elem) {
                                    if (elem.id == vm.promotionalPriceTable.id) {
                                        vm.promotionalPriceTable = elem;
                                    }
                                });
                        }
                    },
                    function (err) {
                        vm.isSaving = false;
                        vm.isLoadingPriceTable = false;
                        vm.success = null;
                        vm.error = err;
                        vm.priceTableList = [];
                        vm.promotionalPriceTableList = [];
                        processResponse();
                    });
            } else {
                vm.priceTable = null;
                vm.promotionalPriceTable = null;
                vm.isLoadingPriceTable = false;
            }
        }

        function getEntitiesByToken() {
            if (vm.onlineRetail && vm.onlineRetail.token && vm.onlineRetail.token != "") {
                OnlineRetailService.getEntities(vm.onlineRetail.token).then(
                    function (response) {
                        vm.isViewForm = true;
                        vm.entitiesList = response.data;
                        mappingEntitiesToObject(vm.entitiesList);
                        vm.getPriceTablesByToken();
                        vm.getOnlineRetailBankAccounts();
                        vm.getOnlineRetailSellers();
                        vm.getOnlineRetailCategoryLevelList();
                    },
                    function (err) {
                        vm.isSaving = false;
                        vm.success = null;
                        vm.error = err;
                        vm.entitiesList = [];
                        processResponse();
                    });
            } else {
                vm.entities = [];
            }
        }

        function getOrganizationsByToken() {
            if (vm.nexaas && vm.nexaas.token && vm.nexaas.token != "") {
                ErpsSettingsService.getNexaasOrganizationsByToken(vm.nexaas.token).then(
                    function (response) {
                        vm.isViewForm = true;
                        vm.nexaasOrganizationList = response.data;
                        mappingOrganizationsToObject();
                    },
                    function (err) {
                        vm.isSaving = false;
                        vm.success = null;
                        vm.error = err;
                        vm.nexaasOrganizationList = [];
                        processResponse();
                    });
            } else {
                vm.nexaasOrganization = null;
            }
        }

        vm.getAllEntitiesByToken = function () {
            if (vm.onlineRetail && vm.onlineRetail.token && vm.onlineRetail.token != "") {
                OnlineRetailService.getEntities(vm.onlineRetail.token).then(
                    function (response) {
                        vm.isViewForm = true;
                        vm.entitiesList = response.data;
                    },
                    function (err) {
                        vm.isSaving = false;
                        vm.success = null;
                        vm.error = err;
                        vm.entitiesList = [];
                        processResponse();
                    });
            } else {
                vm.entities = [];
            }
        }

        vm.getOnlineRetailBankAccounts = function () {
            if (vm.onlineRetail && vm.onlineRetail.token && vm.onlineRetail.token != "") {
                var entityIds = vm.selectedEntity && vm.selectedEntity.id ? [vm.selectedEntity.id] : [];
                OnlineRetailService.getBankAccounts(vm.onlineRetail.token, entityIds).then(
                    function (response) {
                        vm.isViewForm = true;
                        if (response && response.data) {
                            vm.bankAccounts = response.data.filter(function(account) {
                                return account.tipoContaContabil === "SUBCONTA";
                            });
                            selectBankAcount(vm.onlineRetail.accountCode);
                        } else {
                            vm.bankAccounts = [];
                        }
                    },
                    function (err) {
                        vm.isSaving = false;
                        vm.success = null;
                        vm.error = err;
                        vm.bankAccounts = [];
                    });
            } else {
                vm.bankAccounts = [];
            }
        }

        vm.getOnlineRetailSellers = function () {
            if (vm.onlineRetail && vm.onlineRetail.token && vm.onlineRetail.token != "") {
                OnlineRetailService.getSellers(vm.onlineRetail.token).then(
                    function (response) {
                        vm.isViewForm = true;
                        if (response && response.data) {
                            vm.sellers = response.data.filter(function(seller) {
                                return seller.ativo && seller.permiteVender
                            });
                            selectSeller(vm.onlineRetail.sellerCode);
                        } else {
                            vm.sellers = [];
                        }
                        getShowkaseUsers();
                    },
                    function (err) {
                        vm.isSaving = false;
                        vm.success = null;
                        vm.error = err;
                        vm.sellers = [];
                        processResponse();
                    });
            } else {
                vm.sellers = [];
            }
        }

        vm.getOnlineRetailCategoryLevelList = function() {
            if (vm.onlineRetail && vm.onlineRetail.token && vm.onlineRetail.token != "") {
                OnlineRetailService.getCategoryLevelList(vm.onlineRetail.token).then(
                    function (response) {
                        vm.isViewForm = true;
                        if (response && response.data) {
                            vm.categoryLevelList = response.data;
                            selectCategoryLevel(vm.onlineRetail ? vm.onlineRetail.baseCategoryKey : null);
                            selectBrandLevel(vm.onlineRetail ? vm.onlineRetail.baseBrandKey : null);
                        } else {
                            vm.categoryLevelList = [];
                        }
                    },
                    function (err) {
                        vm.isSaving = false;
                        vm.success = null;
                        vm.error = err;
                        vm.categoryLevelList = [];
                    });
            } else {
                vm.categoryLevelList = [];
            }
        }

        function selectBankAcount(code) {
            if (code && vm.bankAccounts) {
                var filtered = vm.bankAccounts.filter(function(account) { return account.codigo == code; });
                vm.selectedBankAccount = filtered && filtered.length > 0 ? filtered[0] : undefined;
            }
        }

        function selectSeller(sellerId) {
            if (sellerId && vm.sellers) {
                var filtered = vm.sellers.filter(function(seller) { return seller.id == sellerId; });
                vm.selectedSeller = filtered && filtered.length > 0 ? filtered[0] : undefined;
            }
        }

        vm.getAllOrganizationsByToken = function () {
            if (vm.nexaas && vm.nexaas.token && vm.nexaas.token != "") {
                vm.isSaving = true;
                ErpsSettingsService.getNexaasOrganizationsByToken(vm.nexaas.token).then(
                    function (response) {
                        vm.isViewForm = true;
                        vm.nexaasOrganizationList = response.data;
                        vm.isSaving = false;
                    },
                    function (err) {
                        vm.isSaving = false;
                        vm.success = null;
                        vm.error = err;

                        vm.nexaasOrganization = null;
                        vm.nexaasOrganizationList = [];

                        vm.nexaasStock = null;
                        vm.nexaasSaleChannel = null;
                        vm.nexaasPriceTable = null;
                        processResponse();
                    });
            } else {
                vm.nexaasOrganization = null;
            }
        }

        vm.getNexaasOrganizationStocksByToken = function () {
            vm.nexaasStock = null;
            vm.nexaasStockList = [];
            vm.nexaasSaleChannel = null;
            vm.nexaasSaleChannelList = [];
            vm.nexaasPriceTable = null;
            vm.nexaasPriceTableList = [];

            if (vm.nexaas && vm.nexaas.token && vm.nexaas.token != "") {
                ErpsSettingsService.getNexaasOrganizationStocks(vm.nexaas.token, vm.nexaasOrganization.id).then(
                    function (response) {
                        vm.isViewForm = true;
                        vm.nexaasStockList = response.data;

                        if (vm.nexaas.stockId && vm.nexaasStockList.length) {
                            vm.nexaasStockList.forEach(function (stock) {
                                if (stock.id == vm.nexaas.stockId) {
                                    vm.nexaasStock = stock;
                                    vm.getNexaasSaleChannels();
                                }
                            })
                        }
                    },
                    function (err) {
                        vm.isSaving = false;
                        vm.success = null;
                        vm.error = err;
                        processResponse();
                    });
            }
        }

        vm.getNexaasSaleChannels = function () {
            vm.nexaasSaleChannel = null;
            vm.nexaasSaleChannelList = [];
            vm.nexaasPriceTable = null;
            vm.nexaasPriceTableList = [];

            vm.nexaasStockList.forEach(function (stock) {
                if (vm.nexaasStock.id === stock.id) {
                    vm.nexaasSaleChannelList = stock.sale_channels;

                    if (vm.nexaas.saleChannelId && vm.nexaasSaleChannelList.length) {
                        vm.nexaasSaleChannelList.forEach(function (elem) {
                            if (elem.id == vm.nexaas.saleChannelId) {
                                vm.nexaasSaleChannel = elem;
                                vm.getNexaasPriceTables();
                            }
                        })
                    }
                }
            });
        }

        vm.getNexaasPriceTables = function () {
            vm.nexaasPriceTable = null;
            vm.nexaasPriceTableList = [];

            vm.nexaasSaleChannelList.forEach(function (saleChannel) {
                if (vm.nexaasSaleChannel.id === saleChannel.id) {
                    vm.nexaasPriceTableList = saleChannel.price_tables;

                    if (vm.nexaas.priceTableId && vm.nexaasPriceTableList.length) {
                        vm.nexaasPriceTableList.forEach(function (elem) {
                            if (elem.id == vm.nexaas.priceTableId) {
                                vm.nexaasPriceTable = elem;
                            }
                        })
                    }
                }
            });
        }

        vm.closeDropDown = function () {
            $("md-backdrop").trigger('click');
        }

        vm.authBling = function() {
            if (vm.currentStore !== null && (vm.currentStore.cnpj === null || vm.currentStore.cnpj.length == 0)) {
                openCnpjModal();
            } else if ((vm.nexaas && vm.nexaas.id) || (vm.onlineRetail && vm.onlineRetail.id)) {
                openModalChangePartner(disconnectPartnerAndAuthorizeBling);
            } else {
                authorizeBling();
            }
        }

        vm.reconnectBling = function() {
            disconnectBling(authorizeBling);
        }

        vm.refreshBlingToken = function() {
            BlingService.refreshToken(vm.currentStore.id).then(
                function (response) {
                    if (response && response.data) {
                        vm.bling = response.data;
                    }
                    vm.loading = false;
                    $state.reload();
                }, function () {
                    vm.loading = false;
                    disconnectBling();
                    toastr.error($translate.instant('settings.erps.bling.messages.refresh-token-error'));
                }
            );
        }

        function openCnpjModal() {
            ModalFactory.openWarningModal(null,
                $translate.instant('settings.erps.bling.cnpjWarningTitle'),
                $translate.instant('settings.erps.bling.cnpjWarningQuestion'),
                null,
                $translate.instant('settings.erps.bling.cnpjButton'),
                $translate.instant('settings.erps.bling.no'),
                goToEditStoreScreen
            );
        }

        function goToEditStoreScreen() {
            $state.go('store-detail', { id: vm.currentStore.id, fromStep: true });
        }

        vm.openDisconnectBlingModal = function() {
            ModalFactory.openWarningModal(null,
                $translate.instant('settings.erps.bling.sureDisconnectTitle'),
                $translate.instant('settings.erps.bling.sureDisconnectQuestion'),
                null,
                $translate.instant('settings.erps.bling.yes'),
                $translate.instant('settings.erps.bling.no'),
                disconnectBling
            );
        }

        vm.openDisconnectSoftcomModal = function() {
            ModalFactory.openWarningModal(null,
                $translate.instant('settings.erps.softcom.sureDisconnectTitle'),
                $translate.instant('settings.erps.softcom.sureDisconnectQuestion'),
                null,
                $translate.instant('settings.erps.softcom.yes'),
                $translate.instant('settings.erps.softcom.no'),
                disconnectSoftcom
            );
        }

        vm.openDisconnectNexaasModal = function() {
            ModalFactory.openWarningModal(null,
                $translate.instant('settings.erps.nexaas.sureDisconnectTitle'),
                $translate.instant('settings.erps.nexaas.sureDisconnectQuestion'),
                null,
                $translate.instant('settings.erps.nexaas.yes'),
                $translate.instant('settings.erps.nexaas.no'),
                disconnectNexaas
            );
        }

        vm.openDisconnectOnlineRetailModal = function() {
            ModalFactory.openWarningModal(null,
                $translate.instant('settings.erps.online-retail.sureDisconnectTitle'),
                $translate.instant('settings.erps.online-retail.sureDisconnectQuestion'),
                null,
                $translate.instant('settings.erps.online-retail.yes'),
                $translate.instant('settings.erps.online-retail.no'),
                disconnectOnlineRetail
            );
        }

        vm.openOnlineRetailOrderConfigModal = function () {
            vm.onlineRetailOrderConfigModal = $uibModal.open({
                templateUrl: 'app/admin/settings/erps/online-retail/modal/online-retail-order-config.html',
                controller: 'OnlineRetailOrderConfigController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    config: function () {
                        return vm.onlineRetail;
                    },
                    showkaseUsers: function() {
                        return vm.showkaseUsers;
                    },
                    onlineRetailUsers: function () {
                        return vm.sellers;
                    },
                    bankAccounts: function () {
                        return vm.bankAccounts;
                    }
                },
            }).result.then(function (response) {
                if (response.data) {
                    if (response.data.userLinksView) {
                        vm.userLinksView = response.data.userLinksView;
                    }
                    if (response.data.userLinks) {
                        vm.onlineRetail.userLinks = response.data.userLinks;
                    }
                    vm.onlineRetail.accountCode = response.data.accountCode;
                    vm.onlineRetail.sellerCode = response.data.sellerCode;
                    vm.selectedSeller = response.data.selectedSeller;
                    vm.selectedBankAccount = response.data.selectedBankAccount;
                }
                 
            });
        }

        vm.openOnlineRetailProductConfigModal = function () {
            vm.onlineRetailOrderConfigModal = $uibModal.open({
                templateUrl: 'app/admin/settings/erps/online-retail/modal/online-retail-product-config.html',
                controller: 'OnlineRetailProductConfigController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    config: function () {
                        return vm.onlineRetail;
                    },
                    categoryLevelList: function () {
                        return vm.categoryLevelList;
                    }
                },
            }).result.then(function (response) {
                if (response.data) {
                    loadOnlineRetailProductSettings(response.data);
                }
            });
        }

        function disconnectPartnerAndAuthorizeBling() {
            if (vm.nexaas && vm.nexaas.id) {
                disconnectNexaas(authorizeBling);
            } else if (vm.onlineRetail && vm.onlineRetail.id) {
                disconnectOnlineRetail(authorizeBling);
            }
        }

        function authorizeBling() {
            vm.loading = true;
            StoreService.authorizeBling().then(
                function(response) {},
                function(){ vm.loading = false; }
            );
        }

        function disconnectSoftcom() {
            vm.loading = true;
            ErpsSettingsService.deleteErpConfiguration(vm.softcom.id).then(
                function (response) {
                    if (response) {
                        vm.softcom = null;
                    }
                    vm.loading = false;
                    $state.reload();
                }, function () {
                    vm.loading = false;
                    toastr.error($translate.instant('settings.erps.softcom.messages.disconnect-partner-error'));
                }
            );
        }

        function disconnectBling(callback) {
            vm.loading = true;
            ErpsSettingsService.deleteErpConfiguration(vm.bling.id).then(
                function (response) {
                    if (response) {
                        vm.bling = null;
                        if (callback) {
                            callback();
                        }
                    }
                    vm.loading = false;
                    $state.reload();
                }, function () {
                    vm.loading = false;
                    toastr.error($translate.instant('settings.erps.bling.messages.disconnect-partner-error'));
                }
            );
        }

        function disconnectNexaas(callback) {
            vm.loading = true;
            ErpsSettingsService.deleteErpConfiguration(vm.nexaas.id).then(
                function (response) {
                    if (response) {
                        vm.nexaas = null;
                        if (callback) {
                            callback();
                        }
                    }
                    vm.loading = false;
                    $state.reload();
                }, function () {
                    vm.loading = false;
                    toastr.error($translate.instant('settings.erps.nexaas.messages.disconnect-partner-error'));
                }
            );
        }

        function disconnectOnlineRetail(callback) {
            vm.loading = true;
            ErpsSettingsService.deleteErpConfiguration(vm.onlineRetail.id).then(
                function (response) {
                    if (response) {
                        vm.onlineRetail = null;
                        if (callback) {
                            callback();
                        }
                    }
                    vm.loading = false;
                    $state.reload();
                }, function () {
                    vm.loading = false;
                    toastr.error($translate.instant('settings.erps.nexaas.messages.disconnect-partner-error'));
                }
            );
        }

        function mappingEntitiesToObject(voEntityList) {
            if (vm.entities && voEntityList) {
                vm.entities.forEach(function (entityId) {
                    voEntityList.forEach(function (entity) {
                        if (entityId === entity.id) {
                            vm.selectedEntity = entity;
                        }
                    })
                })
            }
        }

        function mappingOrganizationsToObject() {
            if (vm.nexaasOrganization && vm.nexaasOrganizationList.length) {
                vm.nexaasOrganizationList.forEach(function (organization) {
                    if (organization.id === vm.nexaasOrganization) {
                        vm.nexaasOrganization = { id: organization.id, name: organization.name };
                    }
                })
            }
        }

        function processResponse(message) {
            if (vm.error) {
                if (vm.error && vm.error.data && vm.error.data.headers.statuskey === 'cannotGetPriceTable') {
                    toastr.error($translate.instant('settings.erps.online-retail.messages.error-price-table'), toastr.options);
                } else if (vm.error && vm.error.data && vm.error.data.headers.statuskey === 'cannotGetEntities') {
                    toastr.error($translate.instant('settings.erps.online-retail.messages.error-entities'), toastr.options);
                } else if (vm.error && vm.error.data && vm.error.data.headers.statuskey === 'cannotGetOrganizationsOnNexaas') {
                    toastr.error($translate.instant('settings.erps.nexaas.messages.error-organizations'));
                } else if (vm.error && vm.error.data && vm.error.data.headers.statuskey === 'cannotGetBankAccounts') {
                    toastr.error($translate.instant('settings.erps.online-retail.messages.error-bank-accounts'), toastr.options);
                } else {
                    toastr.error($translate.instant('settings.store.messages.error.fail'));
                }
                vm.error = undefined;
            } else if (vm.success && vm.success == 'OK') {
                vm.isViewForm = false;
                vm.success = undefined;
                toastr.success($translate.instant(message));
            }
        }

        function openModalChangeNexaas() {
            ModalFactory.openWarningModal(null,
                $translate.instant('settings.erps.nexaas.messages.sureChangeDataTitle'),
                $translate.instant('settings.erps.nexaas.messages.sureChangeDataQuestion'),
                null,
                $translate.instant('settings.erps.nexaas.yes'),
                $translate.instant('settings.erps.nexaas.no'),
                function () {
                    updateNexaas(true);
                }
            );
        }

        function openModalChangePartner(callback) {
            ModalFactory.openWarningModal(null,
                $translate.instant('settings.erps.nexaas.messages.sureChangeDataTitle'),
                $translate.instant('settings.erps.nexaas.messages.sureChangePartnerQuestion'),
                null,
                $translate.instant('settings.erps.nexaas.yes'),
                $translate.instant('settings.erps.nexaas.no'),
                function () {
                    callback();
                }
            );
        }

        function processBlingResponse() {
            var queryParams = $location.search();

            if (queryParams.error) {
                switch (queryParams.error) {
                    case 'BLING_NOT_SEND_CODE':
                        toastr.error($translate.instant('settings.erps.bling.error.BLING_NOT_SEND_CODE'));
                        break;
                    case 'BLING_NOT_SEND_TOKEN':
                        toastr.error($translate.instant('settings.erps.bling.error.BLING_NOT_SEND_TOKEN'));
                        break;
                    case 'BLING_CNPJ_INVALID':
                        toastr.error($translate.instant('settings.erps.bling.error.BLING_CNPJ_INVALID'));
                        break;
                    case 'BLING_CNPJ_DIFFERENT':
                        toastr.error($translate.instant('settings.erps.bling.error.BLING_CNPJ_DIFFERENT'));
                        break;
                    case 'UNAVAILABLE':
                        toastr.error($translate.instant('settings.erps.bling.error.UNAVAILABLE'));
                        break;
                    case 'NONE':
                        toastr.success($translate.instant('settings.erps.bling.successConnected'));
                        break;
                    default:
                        toastr.error($translate.instant('settings.erps.bling.error.UNAVAILABLE'));
                        break;
                }
            }
        }

        function getShowkaseUsers() {
            UserService.getUsersSellers({ storeId: $localStorage.defaultStore.storeId }).then(function (response) {
                vm.showkaseUsers = response.data;
                loadUserLinks();
            });
        }

        function loadUserLinks() {
            if (vm.onlineRetail && vm.onlineRetail.userLinks) {
                vm.userLinksView = vm.onlineRetail.userLinks.map(function(link) {
                    var shkUser = getUserById(link.userId, vm.showkaseUsers);
                    var orUser = getUserById(link.erpUserId, vm.sellers);
                    if (shkUser && orUser) {
                        return {
                            showkaseId: shkUser.id,
                            showkaseName: shkUser.fullName,
                            onlineRetailId: orUser.id,
                            onlineRetailName: orUser.nome
                        };
                    }

                    return null;
                }).filter(function(item) { return item !== null });
            }
        }

        function getUserById(id, entityList) {
            if (entityList) {
                var filtered = entityList.filter(function(item) { return item.id === id });
                return filtered && filtered.length > 0 ? filtered[0] : undefined;
            }
            
            return undefined;
        }

        function mapOnlineRetailProductSettings() {
            var ignoredSyncParams = [];
            if (!vm.syncName) {
                ignoredSyncParams.push("SYNC_PARAM_NAME")
            }
            if (!vm.syncDescription) {
                ignoredSyncParams.push("SYNC_PARAM_DESCRIPTION")
            }
            if (!vm.syncImage) {
                ignoredSyncParams.push("SYNC_PARAM_IMAGE")
            }
            if (!vm.syncCategory) {
                ignoredSyncParams.push("SYNC_PARAM_CATEGORY")
            }
            if (!vm.syncBrand) {
                ignoredSyncParams.push("SYNC_PARAM_BRAND")
            }
            if (!vm.syncTags) {
                ignoredSyncParams.push("SYNC_PARAM_TAGS")
            }
            
            vm.onlineRetail.onlyEcommerce = vm.onlyEcommerce;
            vm.onlineRetail.ignoredSyncParams = ignoredSyncParams;
            vm.onlineRetail.baseCategoryKey = vm.selectedCategoryLevel ? vm.selectedCategoryLevel.nome : null;  
            vm.onlineRetail.baseBrandKey = vm.selectedBrandLevel ? vm.selectedBrandLevel.nome : null;  
        }

        function mapBlingProductSettings() {
            var ignoredSyncParams = [];
            ignoredSyncParams.push("SYNC_PARAM_IMAGE");
            ignoredSyncParams.push("SYNC_PARAM_TAGS");

            if (!vm.bling.syncName) {
                ignoredSyncParams.push("SYNC_PARAM_NAME")
            }
            if (!vm.bling.syncDescription) {
                ignoredSyncParams.push("SYNC_PARAM_DESCRIPTION")
            }
            if (!vm.bling.syncCategory) {
                ignoredSyncParams.push("SYNC_PARAM_CATEGORY")
            }
            if (!vm.bling.syncBrand) {
                ignoredSyncParams.push("SYNC_PARAM_BRAND")
            }
            vm.bling.ignoredSyncParams = ignoredSyncParams;
            vm.bling.transactionIdOnPartner = vm.bling.linkNumber ? "NUMBER" : "NUMBER_VIRTUAL_STORE";    
        }

        function loadOnlineRetailProductSettings(data) {
            vm.onlineRetail.ignoredSyncParams = data.ignoredSyncParams ? data.ignoredSyncParams : [];
            vm.onlineRetail.roundPrice = data.roundPrice;
            vm.onlineRetail.baseCategoryKey = data.baseCategoryKey;
            vm.onlineRetail.baseBrandKey = data.baseBrandKey;
            vm.syncName = !data.ignoredSyncParams.includes("SYNC_PARAM_NAME");
            vm.syncDescription = !data.ignoredSyncParams.includes("SYNC_PARAM_DESCRIPTION");
            vm.syncImage = !data.ignoredSyncParams.includes("SYNC_PARAM_IMAGE");
            vm.syncCategory = !data.ignoredSyncParams.includes("SYNC_PARAM_CATEGORY");
            vm.syncBrand = !data.ignoredSyncParams.includes("SYNC_PARAM_BRAND");
            vm.syncTags = !data.ignoredSyncParams.includes("SYNC_PARAM_TAGS");
            vm.roundPrice = data.roundPrice;
            vm.onlyEcommerce = data.onlyEcommerce;
            vm.inventoryThreshold = data.inventoryThreshold != null && data.inventoryThreshold != undefined;
        }

        function loadBlingProductSettings(data) {
            vm.bling.ignoredSyncParams = data.ignoredSyncParams ? data.ignoredSyncParams : [];
            vm.bling.syncName = !data.ignoredSyncParams.includes("SYNC_PARAM_NAME");
            vm.bling.syncDescription = !data.ignoredSyncParams.includes("SYNC_PARAM_DESCRIPTION");
            vm.bling.syncCategory = !data.ignoredSyncParams.includes("SYNC_PARAM_CATEGORY");
            vm.bling.syncBrand = !data.ignoredSyncParams.includes("SYNC_PARAM_BRAND");
            vm.bling.linkNumber = data.transactionIdOnPartner === "NUMBER";   
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('BlingService', BlingService);

    BlingService.$inject = ['BlingFactory'];

    function BlingService(BlingFactory) {

        var service = {
            syncProductsByStoreAndFlyerIds: syncProductsByStoreAndFlyerIds,
            refreshToken: refreshToken
        };

        return service;

        function syncProductsByStoreAndFlyerIds(storeId, flyerIds) {
            return BlingFactory.syncProductsByStoreAndFlyerIds({ storeId: storeId }, flyerIds).$promise;
        }

        function refreshToken(storeId) {
            return BlingFactory.refreshToken({ storeId: storeId }).$promise;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('BlingFactory', BlingFactory);

    BlingFactory.$inject = ['$resource'];

    function BlingFactory($resource) {
        var resourceUrl = 'flyer/api/integration/bling';

        return $resource(resourceUrl, {}, {
            'syncProductsByStoreAndFlyerIds': {
                method: 'POST',
                url: resourceUrl + '/sync-products/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'refreshToken': {
                method: 'POST',
                url: 'admin/api/bling/refresh-token/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();

(function () {
    'user strict'

    angular
        .module('showcaseApp')
        .controller('CommunicationSettingsController', CommunicationSettingsController);

    function CommunicationSettingsController(toastr, $state, $localStorage, $translate, Constants,
                                    ModalFactory, StoreService, ConfirmActionModalFactory, WatiService,
                                         ChatAssignmentRuleService, TeamService) {

        var vm = this;

        vm.notifyTimes = notifyTimes();
        vm.isMobile = detectar_mobile();

        vm.store = $localStorage.defaultStore;
        vm.form = {};
        vm.templates = [];
        vm.loadingTemplates = true;
        vm.notifications = [];
        vm.templateHasCoupon = false;
        vm.isSaving = false;
        vm.activeForm = false;

        vm.WATICredits;
        vm.isWATIConnected = false;

        init();

        function init() {
            loadRules();
            loadTeams();
        }

        function loadRules() {
            ChatAssignmentRuleService.list($localStorage.defaultStore.storeId).then(function (response) {
                console.log(response.data);
                if (response.data) {
                    vm.rules = response.data;
                }
            });
        }

        function loadTeams() {
            var params = {
                "storeId": $localStorage.defaultStore.storeId,
                "isEnabled": true
            }
            
            TeamService.list(params, {}).then(function(response) {
                console.log(response.data.content);
                if (response.data && response.data.content) {
                    vm.teams = response.data.content;
                }
            });
        }

        function getWATIConnection() {
            WatiService.getConfigByCurrentStore().then(function (result) {
                if (result.data.id) {
                    vm.isWATIConnected = true;
                } else {
                    vm.isWATIConnected = false;
                }
            })
        }

        vm.selectTeam = function () {
            console.log(vm.form);
        }

        vm.openCreateRuleForm = function () {
            vm.activeForm = !vm.activeForm;
            scrollToBottom();
        }

        vm.cancelForm = function() {
            vm.activeForm = false;
        }


        vm.getRuleById = function(id) {
            ChatAssignmentRuleService.get(id, $localStorage.defaultStore.storeId).then(function (result) {
                console.log(result.data);
                if (result.data) {
                    vm.form = result.data;
                    vm.form.team = vm.teams.find(function (team) {
                        return team.id === result.data.teamId;
                    });
                }
                
                vm.activeForm = true;
                scrollToBottom();
            });
        }

        vm.createUpdateRule = function () {
            if (vm.form.id){
                updateRule();
            } else {
                createRule();
            }
        }

        function createRule() {
            var body = {
                isEnabled: true,
                teamId: vm.form.team.id,
                storeId: $localStorage.defaultStore.storeId,
                name: vm.form.name,
                keyword: vm.form.keyword
            }
            ModalFactory.openWarningModal(
                null,
                $translate.instant('settings.communication.chat-assignment-rule.create-modal.title'),
                $translate.instant('settings.communication.chat-assignment-rule.create-modal.small-text'),
                $translate.instant('settings.communication.chat-assignment-rule.create-modal.warning-text'),
                $translate.instant('entity.action.continue'),
                $translate.instant('entity.action.cancel'),
                function () {
                    vm.isSaving = true;
                    ChatAssignmentRuleService.save(body).then(function (result) {
                        console.log(result.data);
                        vm.isSaving = false
                        if (result.data) {
                            vm.rules.push(result.data);
                        }
                        loadRules();
                        vm.form = {}
                        vm.activeForm = false;
                        vm.ruleForm.$setPristine();
                        toastr.success($translate.instant('settings.communication.chat-assignment-rule.success-to-create'));
                    }).catch(function (error) {
                        vm.isSaving = false;
                        if (error.data && error.data.data && error.data.data == "CHAT_ASSIGNMENT_RULE_NAME_OR_KEYWORD_DUPLICATED") {
                            toastr.error($translate.instant(
                                'settings.communication.chat-assignment-rule.failed-to-create-duplicated', 
                                {
                                    name: vm.form.name,
                                    keyword: vm.form.keyword 
                                })
                            );
                        } else {
                            toastr.error($translate.instant('settings.communication.chat-assignment-rule.failed-to-create'));
                        }
                    });
                }
            );
        }

        vm.disableRule = function (rule) {
            var body = {
                id: rule.id,
                isEnabled: rule.isEnabled,
                teamId: rule.teamId,
                storeId: rule.storeId,
                name: rule.name,
                keyword: rule.keyword
            }
            var action = rule.isEnabled ? 'active' : 'disable';

            ModalFactory.openWarningModal(
                null,
                $translate.instant('settings.communication.chat-assignment-rule.' + action + '-modal.title'),
                $translate.instant('settings.communication.chat-assignment-rule.' + action + '-modal.small-text'),
                $translate.instant('settings.communication.chat-assignment-rule.' + action + '-modal.warning-text'),
                $translate.instant('entity.action.continue'),
                $translate.instant('entity.action.cancel'),
                function () {
                    vm.isSaving = true;
                    ChatAssignmentRuleService.update(rule.id, body)
                        .then(function (result) {
                            console.log(result)
                            vm.isSaving = false;
                            vm.form = {}
                            toastr.success($translate.instant('settings.communication.chat-assignment-rule.success-to-' + action));
                        })
                        .catch(function (err) {
                            vm.isSaving = false;
                            notification.isEnabled = !notification.isEnabled;
                            toastr.error($translate.instant('settings.communication.chat-assignment-rule.failed-to-' + action));
                        });
                },
                function () {
                    rule.isEnabled = !rule.isEnabled;
                }
            );
        }

        function updateRule() {
            var body = {
                id: vm.form.id,
                isEnabled: vm.form.isEnabled,
                teamId: vm.form.team.id,
                storeId: $localStorage.defaultStore.storeId,
                name: vm.form.name,
                keyword: vm.form.keyword
            }

            ModalFactory.openWarningModal(
                null,
                $translate.instant('settings.communication.chat-assignment-rule.update-modal.title'),
                $translate.instant('settings.communication.chat-assignment-rule.update-modal.small-text'),
                $translate.instant('settings.communication.chat-assignment-rule.update-modal.warning-text'),
                $translate.instant('entity.action.continue'),
                $translate.instant('entity.action.cancel'),
                function () {
                    vm.isSaving = true;
                    ChatAssignmentRuleService.update(vm.form.id, body).then(function (result) {
                        vm.isSaving = false;
                        console.log(result.data)
                        var newRule = result.data;
                        var index = _.findIndex(vm.rules, {id: newRule.id});
                        vm.rules.splice(index, 1, newRule);
                        loadRules();
                        vm.form = {}
                        vm.activeForm = false;
                        toastr.success($translate.instant('settings.communication.chat-assignment-rule.success-to-update'));
                    }).catch(function (error) {
                        vm.isSaving = false;
                        if (error.data && error.data.data && error.data.data == "CHAT_ASSIGNMENT_RULE_NAME_OR_KEYWORD_DUPLICATED") {
                            toastr.error($translate.instant(
                                'settings.communication.chat-assignment-rule.failed-to-create-duplicated', 
                                {
                                    name: vm.form.name,
                                    keyword: vm.form.keyword 
                                })
                            );
                        } else {
                            toastr.error($translate.instant('settings.communication.chat-assignment-rule.failed-to-update'));
                        }
                    });
                }
            );
        }

        vm.deleteRule = function (id) {
            ModalFactory.openWarningModal(
                null,
                $translate.instant('settings.communication.chat-assignment-rule.delete-modal.title'),
                $translate.instant('settings.communication.chat-assignment-rule.delete-modal.small-text'),
                $translate.instant('settings.communication.chat-assignment-rule.delete-modal.warning-text'),
                $translate.instant('entity.action.continue'),
                $translate.instant('entity.action.cancel'),
                function () {
                    vm.isSaving = true;
                    ChatAssignmentRuleService.remove(id, $localStorage.defaultStore.storeId).then(function (result) {
                        loadRules();
                        vm.isSaving = false;
                        toastr.success($translate.instant('settings.communication.chat-assignment-rule.success-to-remove'));
                    }).catch(function (err) {
                        vm.isSaving = false;
                        toastr.error($translate.instant('settings.communication.chat-assignment-rule.failed-to-remove'));
                    });
                }
            );
        }

        function scrollToBottom() {
            setTimeout(function() {
                var element = document.getElementById('abandoned-cart-form');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('ChatAssignmentRuleService', ChatAssignmentRuleService);

        ChatAssignmentRuleService.$inject = ['ChatAssignmentRuleFactory'];

    function ChatAssignmentRuleService(ChatAssignmentRuleFactory) {

        var service = {
            save: save,
            get: get,
            list: list,
            update: update,
            remove: remove
        };

        return service;

        function save(body) {
            return ChatAssignmentRuleFactory.save(body).$promise;
        }

        function list(storeId) {
            return ChatAssignmentRuleFactory.list({storeId: storeId}).$promise;
        }

        function get(id, storeId) {
            return ChatAssignmentRuleFactory.get({id: id, storeId: storeId}).$promise;
        }

        function update(id, body) {
            return ChatAssignmentRuleFactory.update({id: id}, body).$promise;
        }

        function remove(id, storeId) {
            return ChatAssignmentRuleFactory.remove({id: id, storeId: storeId}).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ChatAssignmentRuleFactory', ChatAssignmentRuleFactory);

        ChatAssignmentRuleFactory.$inject = ['$resource'];

    function ChatAssignmentRuleFactory($resource) {
        var resourceUrl = 'admin/api/chat-assignment-rule';

        return $resource(resourceUrl, {}, {
            'save': {
                method: 'POST',
                url: resourceUrl,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'list': {
                method: 'GET',
                url: resourceUrl + '/list',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'get': {
                method: 'GET',
                url: resourceUrl + '/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'remove': {
                method: 'DELETE',
                url: resourceUrl + '/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'update': {
                method: 'PUT',
                url: resourceUrl + '/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('showcaseApp').factory('SatisfactionSurveyService', SatisfactionSurveyService);

    SatisfactionSurveyService.$inject = ['SatisfactionSurveyFactory', '$uibModal'];

    function SatisfactionSurveyService(SatisfactionSurveyFactory, $uibModal) {
        var service = {
            sendSatisfactionSurvey: sendSatisfactionSurvey,
            rateStore: rateStore,
            checkIfNotExpiredEvaluation: checkIfNotExpiredEvaluation,
            checkIfStoreNew: checkIfStoreNew

        };

        return service;

        function rateStore() {
            return $uibModal.open({
                templateUrl: 'app/admin/satisfaction-survey/satisfaction-survey.html',
                controller: 'SatisfactionSurveyController',
                controllerAs: 'vm',
                size: 'lg',
                windowClass: 'open-modal-in-forward',
                backdrop: 'static',
            }).result;
        };

        function sendSatisfactionSurvey(satisfactionSurvey) {
            return SatisfactionSurveyFactory.sendSatisfactionSurvey(satisfactionSurvey).$promise;
        }

        function checkIfNotExpiredEvaluation(storeId, userId) {
            return SatisfactionSurveyFactory.checkIfNotExpiredEvaluation({ "storeId": storeId, "userId": userId }).$promise;
        }
        function checkIfStoreNew(storeId) {
            return SatisfactionSurveyFactory.checkIfStoreNew({ "storeId": storeId }).$promise;
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('SatisfactionSurveyFactory', SatisfactionSurveyFactory);

    SatisfactionSurveyFactory.$inject = ['$resource'];

    function SatisfactionSurveyFactory($resource) {
        var resourceUrl = 'admin/api';

        return $resource(resourceUrl, {}, {
            
            'sendSatisfactionSurvey': {
                method: 'POST',
                url: '/admin/api/satisfactionSurvey',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'checkIfNotExpiredEvaluation': {
                method: 'GET',
                url: '/admin/api/check-expired-evaluation/:storeId/:userId',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }

            },
            'checkIfStoreNew': {
                method: 'GET',
                url: '/admin/api/check-if-store-new/:storeId',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }

            }
        });
    }
})();

(function () {
	'use strict';

	angular.module('showcaseApp')
		.controller('SatisfactionSurveyController', SatisfactionSurveyController);

	SatisfactionSurveyController.$inject = ['$uibModalInstance', '$localStorage', 'SatisfactionSurveyService', 'toastr', '$translate'];

	function SatisfactionSurveyController($uibModalInstance, $localStorage, SatisfactionSurveyService, toastr, $translate) {
		var vm = this;

		vm.showObservation = false;

		vm.subtitle = ''

		vm.satisfactionSurvey = { note: 0 };
		vm.notes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

		if ($localStorage.hub.id == 4){
			vm.nameHub = $localStorage.hub.name.replaceAll("Hub ", "");
		}else{
			vm.nameHub = "Showkase";
		}
		
		vm.setNote = function (note) {
			if(vm.satisfactionSurvey.note === note){
				vm.satisfactionSurvey.note = 0;
				vm.showObservation = false;
				return;
			}
			vm.satisfactionSurvey.note = note;
			vm.satisfactionSurvey.storeId = $localStorage.defaultStore.storeId;
			vm.satisfactionSurvey.userId = $localStorage.userId;

			if(vm.satisfactionSurvey.note < 10) {
				vm.subtitle = 'showcases.satisfaction-survey.subtitle'
			} else {
				vm.subtitle = 'showcases.satisfaction-survey.second-subtitle'
			}
			vm.showObservation = true;
		}

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		}

		vm.confirm = function () {
			SatisfactionSurveyService.sendSatisfactionSurvey(vm.satisfactionSurvey).then(function (data) {
			  toastr.success($translate.instant('showcases.satisfaction-survey.message-success'));
			  $uibModalInstance.close(true);
			}, function (data) {
			  toastr.error($translate.instant('showcases.satisfaction-survey.message-error'));
			});
		  }


	}
})();

(function () {
    'user strict'

    angular
        .module('showcaseApp')
        .controller('UserEngagementsController', UserEngagementsController);

    //** NgInject */
    function UserEngagementsController($stateParams, UserEngagementService, $translate, FlyerCategoryService) {

        var vm = this;
        var from = $stateParams.from;

        vm.loadingUserInfo = false;
        vm.loadingUserCategoryStatistics = false;
        vm.loadingUserOfferEngagements = false;

        vm.userId = $stateParams.id;
        
        vm.currentPage = 1;
        vm.numPerPage = 5;
        vm.maxSize = 5;
        vm.totalElements = 0;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        init();

        function init() {
            loadUserDetails();
            loadUserCategoryStatistics();
            loadUserOfferEngagements();
        }

        function loadUserDetails() {
            vm.loadingUserInfo = true;
            UserEngagementService.getUserInfo(vm.userId).then(function (result) {
                vm.user = result;
                vm.loadingUserInfo = false;
            }, function (err) {
                vm.loadingUserInfo = false;
            });
        }

        vm.changePage = function () {
            
            vm.paginationOptions.page = vm.currentPage - 1;

            loadUserOfferEngagements();
        }

        function getCategoryName(flyer) {
            FlyerCategoryService.getCategoryTitleByKey(flyer.categoryKey, $translate.use()).then(function(response) {
                flyer.category = response.data;
            });
        }

        function loadUserCategoryStatistics() {
            vm.loadingUserCategoryStatistics = true;
            UserEngagementService.getUserCategoryStatistics(vm.userId, from).then(function (result) {
                vm.categoryStatistics = result.mostLikedCategories;
                vm.totalBrand = result.total;
                vm.loadingUserCategoryStatistics = false;
            }, function (err) {
                vm.loadingUserCategoryStatistics = false;
            });
        }

        function loadUserOfferEngagements() {
            vm.loadingUserOfferEngagements = true;
            UserEngagementService.getUserOfferEngagements(vm.userId, from, vm.paginationOptions).then(function (result) {
                vm.offers = result.content;
                angular.forEach(vm.offers, function(offer) {
                    getCategoryName(offer.flyer);
                });

                vm.totalElements = result.totalElements;
                vm.startElement = (result.number * result.size) + 1;
                vm.ofQuantityElements = (result.number * result.size) + result.numberOfElements;

                vm.loadingUserOfferEngagements = false;
            }, function (err) {
                vm.loadingUserOfferEngagements = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .service('UserEngagementService', UserEngagementService);

    //** NgInject */
    function UserEngagementService(UserEngagementFactory) {

        var service = {
            getUserInfo: getUserInfo,
            getUserCategoryStatistics: getUserCategoryStatistics,
            getUserOfferEngagements: getUserOfferEngagements
        };

        return service;

        function getUserInfo(userId) {
            return UserEngagementFactory.getUserInfo({id: userId}).$promise;
        }

        function getUserCategoryStatistics(userId, from) {
            return UserEngagementFactory.getUserCategoryStatistics({from: from}, {id: userId}).$promise;
        }

        function getUserOfferEngagements(userId, from, options) {
            options.from = from;
            return UserEngagementFactory.getUserOfferEngagements(options, {id: userId}).$promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('UserEngagementFactory', UserEngagementFactory);

    //** NgInject */
    function UserEngagementFactory ($resource) {

        return $resource('', {}, {
            'getUserInfo': {
                method: 'GET',
                url: '/api/users/:id/info',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getUserCategoryStatistics': {
                method: 'GET',
                url: '/flyer/api/report/engagement/users/:id/category-statistics',
                params: {
                    id: '@id'
                },
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getUserOfferEngagements': {
                method: 'GET',
                url: '/flyer/api/report/engagement/users/:id/offers',
                params: {
                    id: '@id'
                },
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use-strict'

    angular
        .module('showcaseApp')
        .controller('ConsumerSaleReportController', ConsumerSaleReportController);

    //** NgInject */
    function ConsumerSaleReportController(SaleReportService, $filter, $translate, $localStorage) {

        var QTD_OF_USERS_KEY = "quantityOfUsers";
        var WEEK_KEY = "week";

        var vm = this;
        vm.genderData = [];

        var storeId = $localStorage.defaultStore.storeId;

        vm.fullScreenMode = false;
        vm.fullscreen = fullscreen;

        // Relatório de quantidade de clientes cadastrados
        vm.colors = ['#45b7cd', '#ff6384', '#ff8e72'];

        vm.labels = [];

        vm.numberOfUsersData = [];

        vm.datasetOverride = [{
            label: "Número de clientes",
            borderWidth: 3,
            hoverBackgroundColor: "rgba(255,99,132,0.4)",
            hoverBorderColor: "rgba(255,99,132,1)",
            type: 'line'
        }];

        vm.chartOptions = {
            scales: {
                xAxes: [{
                    display: true
                }],
                yAxes: [{
                    display: true,
                    ticks: {
                        min: 0,
                        stepSize: 1,
                        suggestedMax: 10
                    }
                }]
            }
        };

        function getMaxOfArray(numArray) {
            return Math.max.apply(null, numArray);
        }

        loadAllDatas();

        function loadAllDatas() {
            listUsersRegisteredByGenderWithSaleGeneratedByStore();
            listMostLikedCategories();
            listUsersPerformMoreSalesTransactions();
            listUsersFirstInteraction();
        }

        function listUsersRegisteredByGenderWithSaleGeneratedByStore() {
            vm.loadingUsersRegisteredByGender = true;
            // Percentage of customers that generate contact by gender
            SaleReportService.listUsersRegisteredByGenderWithSaleGeneratedByStore(storeId).then(function(genderData) {
                vm.genderData = genderData;
                if (genderData.length >= 2) {
                    vm.genderData = genderData;
                } else {
                    createListGenders(genderData);
                }
            }).finally(function() {
                vm.loadingUsersRegisteredByGender = false;
            });
        }

        function listMostLikedCategories() {
            vm.loadingMostLikedCategories = true;

            SaleReportService.listMostLikedCategories(storeId, $translate.use()).then(function(data) {
                vm.categoryData = data.mostLikedCategories;
                vm.totalBrand = data.total;
            }).finally(function() {
                vm.loadingMostLikedCategories = false;
            });
        }

        function listUsersPerformMoreSalesTransactions() {
            vm.loadingListUsersPerformMoreSalesTransactions = true;

            SaleReportService.listUsersPerformMoreSalesTransactions(storeId).then(function(saleTransactionData) {
                vm.saleTransactionData = saleTransactionData;
            }).finally(function() {
                vm.loadingListUsersPerformMoreSalesTransactions = false;
            });
        }

        function listUsersFirstInteraction() {
            vm.loadingListUserFirstInteraction = true;
            SaleReportService.listUsersFirstInteraction(storeId).then(function(data) {
                if (data.length > 0) {
                    buildChartData(data);
                } else {
                    vm.numberOfUsersData.push([0]);
                }
            }).finally(function() {
                vm.loadingListUserFirstInteraction = false;
            });
        }

        function buildChartData(data) {
            var qtdOfUsers = [];
            var myDate = new Date();
            var myWeek = $filter('date')(myDate, 'ww');

            for (var i = 0; i < data.length; i++) {
                if ((data[i][WEEK_KEY] - myWeek) === 0) {
                    vm.labels.push($filter("translate")('reports.tabs.sale.numberUsers.label.week.current'));
                } else {
                    vm.labels.push($filter("translate")('reports.tabs.sale.numberUsers.label.week.past', {
                        value: myWeek - data[i][WEEK_KEY]
                    }));
                }

                qtdOfUsers.push(data[i][QTD_OF_USERS_KEY]);
            }
            vm.numberOfUsersData.push(qtdOfUsers);
            vm.chartOptions.scales.yAxes[0].ticks.suggestedMax = getMaxOfArray(vm.numberOfUsersData[0]) + 3;
        }

        function createListGenders(genderData) {
            var hasMale = false;
            var hasFemale = false;

            for (var i = 0; i < genderData.length; i++) {
                if (genderData[i].gender == 'male') {
                    hasMale = true;
                } else if (genderData[i].gender == 'female') {
                    hasFemale = true;
                }
            }

            if (!hasMale) {
                vm.genderData.push({
                    gender: 'male',
                    percentage: 0
                });
            }

            if (!hasFemale) {
                vm.genderData.push({
                    gender: 'female',
                    percentage: 0
                });
            }
        }

        // Function for full screen
        function fullscreen() {
            vm.fullScreenMode = !vm.fullScreenMode;

            var screen = angular.element('#reportDashboard');
            var button = angular.element('i.fa-expand');
            $('body').toggleClass('fullscreen-ibox-mode');
            if (vm.fullScreenMode) {
                var button = angular.element('i.fa-expand');
                button.toggleClass('fa-expand').toggleClass('fa-compress');
                screen.addClass('height-fullscreen');
            } else {
                var button = angular.element('i.fa-compress');
                button.toggleClass('fa-compress').toggleClass('fa-expand');
                screen.removeClass('height-fullscreen')
            }
            screen.toggleClass('ibox fullscreen');
            setTimeout(function() {
                $(window).trigger('resize');
            }, 100);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ConsumerCouponReportController', ConsumerCouponReportController);

    //** NgInject */
    function ConsumerCouponReportController(ReportService, $filter, $translate, $localStorage) {

        var QTD_OF_USERS_KEY = "quantityOfUsers";
        var WEEK_KEY = "week";

        var vm = this;
        vm.genderData = [];

        var storeId = $localStorage.defaultStore.storeId;

        vm.fullScreenMode = false;
        vm.fullscreen = fullscreen;

        // Relatório de quantidade de clientes cadastrados
        vm.colors = ['#45b7cd', '#ff6384', '#ff8e72'];

        vm.labels = [];

        vm.numberOfUsersData = [];

        vm.datasetOverride = [{
            label: "Número de clientes",
            borderWidth: 3,
            hoverBackgroundColor: "rgba(255,99,132,0.4)",
            hoverBorderColor: "rgba(255,99,132,1)",
            type: 'line'
        }];

        vm.chartOptions = {
            scales: {
                xAxes: [{
                    display: true
                }],
                yAxes: [{
                    display: true,
                    ticks: {
                        min: 0,
                        stepSize: 1,
                        suggestedMax: 10
                    }
                }]
            }
        };

        function getMaxOfArray(numArray) {
            return Math.max.apply(null, numArray);
        }

        loadAllDatas();


        function loadAllDatas() {
            listUsersRegisteredWithCouponGeneratedByStore();
            listMostLikedCategories();
            listUsersFirstInteraction();
            listUsersGenerateMoreCoupons();
            listUsersWithMoreCouponsRedeemed();
        }

        function listUsersRegisteredWithCouponGeneratedByStore() {
            vm.loadingUsersRegisteredByGender = true;
            // Percentage of customers that generate coupons by gender
            ReportService.listUsersRegisteredByGenderWithCouponGeneratedByStore(storeId).then(function(genderData) {
                vm.genderData = genderData;
                if (genderData.length >= 2) {
                    vm.genderData = genderData;
                } else {
                    createListGenders(genderData);
                }
            }).finally(function() {
                vm.loadingUsersRegisteredByGender = false;
            });
        }

        function listMostLikedCategories() {
            vm.loadingMostLikedCategories = true;

            ReportService.listMostLikedCategories(storeId, $translate.use()).then(function(data) {
                vm.categoryData = data.mostLikedCategories;
                vm.totalBrand = data.total;
            }).finally(function() {
                vm.loadingMostLikedCategories = false;
            });
        }

        function listUsersFirstInteraction() {
            vm.loadingListUserFirstInteraction = true;
            ReportService.listUsersFirstInteraction(storeId).then(function(data) {
                if (data.length > 0) {
                    buildChartData(data);
                } else {
                    vm.numberOfUsersData.push([0]);
                }
            }).finally(function() {
                vm.loadingListUserFirstInteraction = false;
            });
        }

        function listUsersGenerateMoreCoupons() {
            vm.loadingListUsersGenerateMoreCoupons = true;

            ReportService.listUsersGenerateMoreCoupons(storeId).then(function(couponGeneratorData) {
                vm.couponGeneratorData = couponGeneratorData;
            }).finally(function() {
                vm.loadingListUsersGenerateMoreCoupons = false;
            });
        }

        function listUsersWithMoreCouponsRedeemed() {
            vm.loadingListUsersWithMoreCouponsRedeemed = true;

            ReportService.listUsersWithMoreCouponsRedeemed(storeId).then(function(moreActiveData) {
                vm.moreActiveData = moreActiveData;
            }).finally(function() {
                vm.loadingListUsersWithMoreCouponsRedeemed = false;
            });
        }

        function buildChartData(data) {
            var qtdOfUsers = [];
            var myDate = new Date();
            var myWeek = $filter('date')(myDate, 'ww');

            for (var i = 0; i < data.length; i++) {
                if ((data[i][WEEK_KEY] - myWeek) === 0) {
                    vm.labels.push($filter("translate")('reports.tabs.coupon.numberUsers.label.week.current'));
                } else {
                    vm.labels.push($filter("translate")('reports.tabs.coupon.numberUsers.label.week.past', {
                        value: myWeek - data[i][WEEK_KEY]
                    }));
                }

                qtdOfUsers.push(data[i][QTD_OF_USERS_KEY]);
            }
            vm.numberOfUsersData.push(qtdOfUsers);
            vm.chartOptions.scales.yAxes[0].ticks.suggestedMax = getMaxOfArray(vm.numberOfUsersData[0]) + 3;
        }

        function createListGenders(genderData) {
            var hasMale = false;
            var hasFemale = false;

            for (var i = 0; i < genderData.length; i++) {
                if (genderData[i].gender == 'male') {
                    hasMale = true;
                } else if (genderData[i].gender == 'female') {
                    hasFemale = true;
                }
            }

            if (!hasMale) {
                vm.genderData.push({
                    gender: 'male',
                    percentage: 0
                });
            }

            if (!hasFemale) {
                vm.genderData.push({
                    gender: 'female',
                    percentage: 0
                });
            }
        }

        // Function for full screen
        function fullscreen() {
            vm.fullScreenMode = !vm.fullScreenMode;

            var screen = angular.element('#reportDashboard');
            var button = angular.element('i.fa-expand');
            $('body').toggleClass('fullscreen-ibox-mode');
            if (vm.fullScreenMode) {
                var button = angular.element('i.fa-expand');
                button.toggleClass('fa-expand').toggleClass('fa-compress');
                screen.addClass('height-fullscreen');
            } else {
                var button = angular.element('i.fa-compress');
                button.toggleClass('fa-compress').toggleClass('fa-expand');
                screen.removeClass('height-fullscreen')
            }
            screen.toggleClass('ibox fullscreen');
            setTimeout(function() {
                $(window).trigger('resize');
            }, 100);
        }
    }
})();

(function () {
    'use-strict'

    angular
        .module('showcaseApp')
        .controller('ConsumerContactReportController', ConsumerContactReportController);

    //** NgInject */
    function ConsumerContactReportController(ContactReportService, $filter, $translate, $localStorage) {
        var QTD_OF_USERS_KEY = "quantityOfUsers";
        var WEEK_KEY = "week";

        var vm = this;
        vm.genderData = [];

        var storeId = $localStorage.defaultStore.storeId;

        vm.fullScreenMode = false;
        vm.fullscreen = fullscreen;

        // Relatório de quantidade de clientes cadastrados 
        vm.colors = ['#45b7cd', '#ff6384', '#ff8e72'];

        vm.labels = [];

        vm.numberOfUsersData = [];

        vm.datasetOverride = [{
            label: "Número de clientes",
            borderWidth: 3,
            hoverBackgroundColor: "rgba(255,99,132,0.4)",
            hoverBorderColor: "rgba(255,99,132,1)",
            type: 'line'
        }];

        vm.chartOptions = {
            scales: {
                xAxes: [{
                    display: true
                }],
                yAxes: [{
                    display: true,
                    ticks: {
                        min: 0,
                        stepSize: 1,
                        suggestedMax: 10
                    }
                }]
            }
        };

        function getMaxOfArray(numArray) {
            return Math.max.apply(null, numArray);
        }

        loadAllDatas();


        function loadAllDatas() {
            listUsersRegisteredWithContactGeneratedByStore();
            listMostLikedCategories();
            listUsersFirstInteraction();
            listUsersGenerateMoreContact();
        }

        function listUsersRegisteredWithContactGeneratedByStore() {
            vm.loadingUsersRegisteredByGender = true;
            // Percentage of customers that generate contact by gender
            ContactReportService.listUsersRegisteredByGenderWithContactGeneratedByStore(storeId).then(function (genderData) {
                vm.genderData = genderData;
                if (genderData.length >= 2) {
                    vm.genderData = genderData;
                } else {
                    createListGenders(genderData);
                }
            }).finally(function () {
                vm.loadingUsersRegisteredByGender = false;
            });
        }

        function listMostLikedCategories() {
            vm.loadingMostLikedCategories = true;

            ContactReportService.listMostLikedCategories(storeId, $translate.use()).then(function (data) {
                vm.categoryData = data.mostLikedCategories;
                vm.totalBrand = data.total;
            }).finally(function () {
                vm.loadingMostLikedCategories = false;
            });
        }

        function listUsersFirstInteraction() {
            vm.loadingListUserFirstInteraction = true;
            ContactReportService.listUsersFirstInteraction(storeId).then(function (data) {
                if (data.length > 0) {
                    buildChartData(data);
                } else {
                    vm.numberOfUsersData.push([0]);
                }
            }).finally(function () {
                vm.loadingListUserFirstInteraction = false;
            });
        }

        function listUsersGenerateMoreContact() {
            vm.loadingListUsersGenerateMoreContact = true;

            ContactReportService.listUsersGenerateMoreContact(storeId).then(function (contactGeneratorData) {
                vm.contactGeneratorData = contactGeneratorData;
            }).finally(function () {
                vm.loadingListUsersGenerateMoreContact = false;
            });
        }

        function buildChartData(data) {
            var qtdOfUsers = [];
            var myDate = new Date();
            var myWeek = $filter('date')(myDate, 'ww');

            for (var i = 0; i < data.length; i++) {
                if ((data[i][WEEK_KEY] - myWeek) === 0) {
                    vm.labels.push($filter("translate")('reports.tabs.contact.numberUsers.label.week.current'));
                } else {
                    vm.labels.push($filter("translate")('reports.tabs.contact.numberUsers.label.week.past', {
                        value: myWeek - data[i][WEEK_KEY]
                    }));
                }

                qtdOfUsers.push(data[i][QTD_OF_USERS_KEY]);
            }
            vm.numberOfUsersData.push(qtdOfUsers);
            vm.chartOptions.scales.yAxes[0].ticks.suggestedMax = getMaxOfArray(vm.numberOfUsersData[0]) + 3;
        }

        function createListGenders(genderData) {
            var hasMale = false;
            var hasFemale = false;

            for (var i = 0; i < genderData.length; i++) {
                if (genderData[i].gender == 'male') {
                    hasMale = true;
                } else if (genderData[i].gender == 'female') {
                    hasFemale = true;
                }
            }

            if (!hasMale) {
                vm.genderData.push({
                    gender: 'male',
                    percentage: 0
                });
            }

            if (!hasFemale) {
                vm.genderData.push({
                    gender: 'female',
                    percentage: 0
                });
            }
        }

        // Function for full screen
        function fullscreen() {
            vm.fullScreenMode = !vm.fullScreenMode;

            var screen = angular.element('#reportDashboard');
            var button = angular.element('i.fa-expand');
            $('body').toggleClass('fullscreen-ibox-mode');
            if (vm.fullScreenMode) {
                var button = angular.element('i.fa-expand');
                button.toggleClass('fa-expand').toggleClass('fa-compress');
                screen.addClass('height-fullscreen');
            } else {
                var button = angular.element('i.fa-compress');
                button.toggleClass('fa-compress').toggleClass('fa-expand');
                screen.removeClass('height-fullscreen')
            }
            screen.toggleClass('ibox fullscreen');
            setTimeout(function () {
                $(window).trigger('resize');
            }, 100);
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    function stateConfig($stateProvider) {
        $stateProvider
            .state('store-rating', {
                parent: 'admin',
                url: '/reports/store-rating',
                data: {
                    pageTitle: "storeRating.title",
                    // specialClass: "md-skin fixed-nav"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/reports/store-rating/store-rating.html',
                        controller: 'StoreRatingController as vm'
                    }
                },
                resolve: {
                    userXP: function (StoreRatingService, $q) {
                        var deferred = $q.defer();

                        StoreRatingService.getUserXP().then(function (response) {
                            deferred.resolve(response.data);
                        }, function (error) {
                            deferred.resolve(null);
                        });

                        return deferred.promise;
                    },
                    storeQualify: function (StoreRatingService, $q) {

                        var deferred = $q.defer();

                        StoreRatingService.getStoreQualify().then(function (response) {
                            deferred.resolve(response.data);
                        }, function (error) {
                            deferred.resolve(null);
                        });

                        return deferred.promise;

                    },
                    staticStoreData: function (StoreRatingService, $q) {

                        var deferred = $q.defer();

                        StoreRatingService.getStaticStoreData().then(function (response) {
                            deferred.resolve(response.data);
                        }, function (error) {
                            deferred.resolve(null);
                        });

                        return deferred.promise;

                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store-rating');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });

    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .service('StoreRatingService', StoreRatingService);

    function StoreRatingService(StoreRatingFactory) {

        var service = {
            getUserXP: getUserXP,
            getStoreQualify: getStoreQualify,
            getStaticStoreData: getStaticStoreData
        };

        return service;

        function getUserXP() {
            return StoreRatingFactory.getUserXP().$promise;
        }

        function getStoreQualify() {
            return StoreRatingFactory.getStoreQualify().$promise;
        }

        function getStaticStoreData() {
            return StoreRatingFactory.getStaticStoreData().$promise;
        }
    }


})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('StoreRatingFactory', StoreRatingFactory);

    function StoreRatingFactory($resource) {
        var resourceUrl = '/admin/api/rate';
        var resourceGetUserXP = resourceUrl + '/user-xp-results';
        var resourceGetStaticStoreData = resourceUrl + '/static-store-data-result';
        var resourceGetStoreQualify = resourceUrl + '/store-qualify-result';

        return $resource(resourceUrl, {}, {
        	'getUserXP': {
            	method: 'GET',
            	url: resourceGetUserXP,
            	transformResponse: function (data, headers) {
                    var response = {};
                    
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();

                    return response;
                }
            },
            'getStaticStoreData': {
            	method: 'GET',
            	url: resourceGetStaticStoreData,
            	transformResponse: function (data, headers) {
                    var response = {};
                    
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();

                    return response;
                }
            },
            'getStoreQualify': {
            	method: 'GET',
            	url: resourceGetStoreQualify,
            	transformResponse: function (data, headers) {
                    var response = {};
                    
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();

                    return response;
                }
            }
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('StoreRatingController', StoreRatingController);

    function StoreRatingController(storeQualify, staticStoreData, userXP, $translate, $timeout) {

        var vm = this;

        vm.showkaseColors = {
            backgroundColor: "rgba(30,9,81,0.8)",
            borderColor: "rgba(153,0,0,1)",
            pointBackgroundColor: "rgba(153,0,0,1)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "rgba(30,9,81,0.8)",
            pointHoverBorderColor: "rgba(153,0,0,1)"
        }

        vm.storeQualify = storeQualify || undefined;
        vm.staticStoreData = staticStoreData || undefined;
        vm.userXP = userXP || undefined;
        vm.amountOfOpnions = 0;

        function loadAll(){
            $timeout(function() {
                window.dispatchEvent(new Event('resize'));
            }, 500);
        }

        vm.barChartOptions = {
            tooltips: {
                callbacks: {
                    title: function(tooltipItem, data) {
                        var title = "";
    
                        if (tooltipItem[0] && tooltipItem[0].xLabel) {
                            title = $translate.instant('storeRating.userXP.noteTitle') + tooltipItem[0].xLabel;
                        }
                        return title;
                    }
                }
            },
            scales: {
                yAxes: [{
                    ticks: {
                        // min: 0,
                        // max: 100,
                        // stepSize: 10,
                        beginAtZero: true,
                        callback: function (value) {
                            return value + "%";
                        }
                    },
                    scaleLabel: {
                        display: true,
                        labelString: $translate.instant('storeRating.userXP.answerPercentage')
                    }
                }],
                xAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: $translate.instant('storeRating.userXP.answerTitle')
                    }
                }]
            }
        }

        if (vm.storeQualify && vm.storeQualify.rateAvg > 0 ){
            vm.amountOfOpnions = 0;
            vm.storeQualify.storeQualifyRatingOptions = [{
                color: '#25d02a',
                allQuantity: 0,
                icon: 'fa fa-star',
                prefixValue: 5,
                percentage: '0%'
            },
            {
                color: '#25ec2b',
                allQuantity: 0,
                icon: 'fa fa-star',
                prefixValue: 4,
                percentage: '0%'
            },
            {
                color: '#edfb1e',
                allQuantity: 0,
                icon: 'fa fa-star',
                prefixValue: 3,
                percentage: '0%'
            },
            {
                color: '#ffb123',
                allQuantity: 0,
                icon: 'fa fa-star',
                prefixValue: 2,
                percentage: '0%'
            },
            {
                color: '#f73f3f',
                allQuantity: 0,
                icon: 'fa fa-star',
                prefixValue: 1,
                percentage: '0%'
            }
        ];

            vm.storeQualify.rating.forEach(function(element) {
                var listable = findElementByAttr(vm.storeQualify.storeQualifyRatingOptions, 'prefixValue', element.rate);
                if (listable) {
                    vm.amountOfOpnions += element.quantity;
                    listable.allQuantity  = element.quantity;
                    listable.percentage = element.ratePercentage + '%';
                }
            });
        }
        


        vm.showUpRecommendation = [
            {
                label: $translate.instant('storeRating.userXP.recommends') + "",
                value: vm.userXP ? vm.userXP.recommendationResult.recommends : 0
            },
            {
                label: $translate.instant('storeRating.userXP.notRecommends') + "",
                value: vm.userXP ? vm.userXP.recommendationResult.notRecommends : 0
            }
            
        ];

        vm.uxpTabs = [{
                name: 'storeRating.userXP.courtesy',
                active: true,
                data: vm.userXP ? vm.userXP.courtesyResult : undefined
            },
            {
                name: 'storeRating.userXP.fastness',
                active: false,
                data: vm.userXP ? vm.userXP.fastnessResult : undefined
            },
            {
                name: 'storeRating.userXP.productQuality',
                active: false,
                data: vm.userXP ? vm.userXP.productQualityResult : undefined
            },
            {
                name: 'storeRating.userXP.livedExperience',
                active: false,
                data: vm.userXP ? vm.userXP.livedExperienceResult : undefined
            }
        ];

        vm.selectTab = function (tab) {
            var tabSelected = findElementByAttr(vm.uxpTabs, 'active', true);
            if (tabSelected) tabSelected.active = false;
            if (tab) tab.active = true;
        }

        loadAll();

    }
})();

(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .service('SaleReportService', SaleReportService);

    //** NgInject */
    function SaleReportService(SaleReportFactory) {

        var service = {
            listUsersRegisteredByGenderWithSaleGeneratedByStore: listUsersRegisteredByGenderWithSaleGeneratedByStore,
            listMostLikedCategories: listMostLikedCategories,
            listUsersPerformMoreSalesTransactions: listUsersPerformMoreSalesTransactions,
            listUsersFirstInteraction: listUsersFirstInteraction
        };

        return service;

        function listUsersRegisteredByGenderWithSaleGeneratedByStore(storeId) {
            return SaleReportFactory.listUsersRegisteredByGenderWithSaleGeneratedByStore(storeId).$promise;
        }

        function listMostLikedCategories(storeId, langKey) {
            return SaleReportFactory.listMostLikedCategories({
                storeId: storeId,
                langKey: langKey
            }).$promise;
        }

        function listUsersPerformMoreSalesTransactions(storeId) {
            return SaleReportFactory.listUsersPerformMoreSalesTransactions(storeId).$promise;
        }

        function listUsersFirstInteraction(storeId) {
            return SaleReportFactory.listUsersFirstInteraction(storeId).$promise;
        }
    }


})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('SaleReportFactory', SaleReportFactory);

    //** NgInject */
    function SaleReportFactory($resource) {
        var resourceUrl = '';

        return $resource(resourceUrl, {}, {

            'listUsersRegisteredByGenderWithSaleGeneratedByStore': {
                method: 'POST',
                isArray: true,
                url: '/api/transaction/sale/report/users-by-gender',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listMostLikedCategories': {
                method: 'POST',
                url: '/flyer/api/transaction/sale/report/most-liked-categories',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersPerformMoreSalesTransactions': {
                method: 'POST',
                isArray: true,
                url: '/api/transaction/sale/report/users-perform-more-sales-transactions',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersFirstInteraction': {
                method: 'POST',
                isArray: true,
                url: 'flyer/api/transaction/sale/report/users-first-interaction',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

        });
    }

})();

(function () {
    'user strict'

    angular
        .module('showcaseApp')
        .controller('ReportsDashboardController', ReportsDashboardController);

    //** NgInject */
    function ReportsDashboardController($timeout) {

        var vm = this;
        vm.onTabSelected = onTabSelected;

        function onTabSelected(tab) {
            vm.selectedTab = tab;
        }
        
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reports', {
                parent: 'admin',
                url: '/reports',
                abstract: true,
                data: {
                    authorities: ['STORE_MANAGE_REPORT'],
                    pageTitle: "Report"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/reports/reports-dashboard.html',
                        controller: 'ReportsDashboardController as vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        return $translate.refresh();
                    }]
                }
            })
            .state('consumers', {
                parent: 'reports',
                url: '/consumers',
                data: {
                    pageTitle: "reports.public-consumer.page-title",
                    // specialClass: "md-skin fixed-nav mini-navbar"
                },
                views: {
                    'coupon-view': {
                        templateUrl: 'app/admin/reports/tabs/coupon.html',
                        controller: 'ConsumerCouponReportController as vm'
                    },
                    'contact-view': {
                        templateUrl: 'app/admin/reports/tabs/contact.html',
                        controller: 'ConsumerContactReportController as vm'
                    },
                    'sale-view': {
                        templateUrl: 'app/admin/reports/tabs/sale.html',
                        controller: 'ConsumerSaleReportController as vm'
                    }
                }
            })
            .state('engagements', {
                parent: 'admin',
                url: '/reports/engaged-users',
                data: {
                    authorities: ['STORE_MANAGE_REPORT'],
                    pageTitle: "reports.engagement.page-title",
                    // specialClass: "md-skin fixed-nav mini-navbar"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/reports/engagement.html',
                        controller: 'EngagementController as vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        return $translate.refresh();
                    }]
                }
            })
            .state('follow-up', {
                parent: 'admin',
                url: '/reports/follow-up',
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/reports/follow-up-dashboard.html'
                    }
                },
                data: {
                    pageTitle: "reports.follow-up.title",
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        return $translate.refresh();
                    }]
                }
            })
            .state('engagements-user', {
                parent: 'engagements',
                url: '/user/:id/engagements?{from:string}',
                data: {
                    authorities: ['STORE_MANAGE_REPORT'],
                    pageTitle: "reports.engagement.user.page-title",
                    // specialClass: "md-skin fixed-nav mini-navbar"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/reports/user/user.engagements.html',
                        controller: 'UserEngagementsController as vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        return $translate.refresh();
                    }]
                }
            })
            .state('store-performance', {
                parent: 'admin',
                url: '/reports/store-performance',
                views: {
                    'content@app': {
                        controller: 'PerformanceController as vm',
                        templateUrl: 'app/admin/reports/performance/performance.html'
                    }
                },
                data: {
                    pageTitle: "global.menu.admin.store-performance"
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('chat-performance', {
                parent: 'admin',
                url: '/reports/chat-performance?{report:string}',
                views: {
                    'content@app': {
                        controller: 'PerformanceController as vm',
                        templateUrl: 'app/admin/reports/performance/performance.html'
                    }
                },
                data: {
                    pageTitle: "global.menu.admin.chat-performance"
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('seller-performance', {
                parent: 'admin',
                url: '/reports/seller-performance?{report:string}',
                views: {
                    'content@app': {
                        controller: 'PerformanceController as vm',
                        templateUrl: 'app/admin/reports/performance/performance.html'
                    }
                },
                data: {
                    pageTitle: "global.menu.admin.seller-performance"
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('seller-individual-performance', {
                parent: 'admin',
                url: '/reports/seller-individual-performance?{report:string}',
                views: {
                    'content@app': {
                        controller: 'PerformanceController as vm',
                        templateUrl: 'app/admin/reports/performance/performance.html'
                    }
                },
                data: {
                    pageTitle: "global.menu.admin.seller-individual-performance"
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('abandoned-cart-dashboard', {
                parent: 'admin',
                url: '/reports/abandoned-cart-dashboard?{report:string}',
                views: {
                    'content@app': {
                        controller: 'PerformanceController as vm',
                        templateUrl: 'app/admin/reports/performance/performance.html'
                    }
                },
                data: {
                    pageTitle: "global.menu.admin.abandoned-cart-dashboard"
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('virtual-bag-performance', {
                parent: 'admin',
                url: '/reports/virtual-bag-performance?{report:string}',
                views: {
                    'content@app': {
                        controller: 'PerformanceController as vm',
                        templateUrl: 'app/admin/reports/performance/performance.html'
                    }
                },
                data: {
                    pageTitle: "global.menu.admin.virtual-bag-performance"
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('crm-dashboard', {
                parent: 'admin',
                url: '/reports/crm-dashboard?{report:string}',
                views: {
                    'content@app': {
                        controller: 'PerformanceController as vm',
                        templateUrl: 'app/admin/reports/performance/performance.html'
                    }
                },
                data: {
                    pageTitle: "global.menu.admin.crm-dashboard"
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('hub-performance', {
                parent: 'admin',
                url: '/reports/hub-performance?{report:string}',
                views: {
                    'content@app': {
                        controller: 'PerformanceController as vm',
                        templateUrl: 'app/admin/reports/performance/performance.html'
                    }
                },
                data: {
                    pageTitle: "global.menu.admin.hub-performance"
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('hub-malwee-painel-multibrand', {
                parent: 'admin',
                url: '/reports/hub-painel-multibrand?{report:string}',
                views: {
                    'content@app': {
                        controller: 'PerformanceController as vm',
                        templateUrl: 'app/admin/reports/performance/performance.html'
                    }
                },
                data: {
                    pageTitle: "global.menu.admin.hub-malwee-painel-multibrand"
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('hub-subscriptions', {
                parent: 'admin',
                url: '/reports/hub-subscriptions?{report:string}',
                views: {
                    'content@app': {
                        controller: 'PerformanceController as vm',
                        templateUrl: 'app/admin/reports/performance/performance.html'
                    }
                },
                data: {
                    pageTitle: "global.menu.admin.hub-subscriptions"
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });;

    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('ReportService', ReportService);

    ReportService.$inject = ['ReportFactory'];

    function ReportService(ReportFactory) {

        var service = {
            listUsersRegisteredByGenderWithCouponGeneratedByStore: listUsersRegisteredByGenderWithCouponGeneratedByStore,
        	listMostLikedCategories: listMostLikedCategories,
            listUsersGenerateMoreCoupons: listUsersGenerateMoreCoupons,
            listUsersWithMoreCouponsRedeemed: listUsersWithMoreCouponsRedeemed,
            listUsersFirstInteraction: listUsersFirstInteraction
        };
        
        return service;
        
        function listUsersRegisteredByGenderWithCouponGeneratedByStore(storeId) {
            return ReportFactory.listUsersRegisteredByGenderWithCouponGeneratedByStore(storeId).$promise;
        }
        
        function listMostLikedCategories(storeId, langKey) {
            return ReportFactory.listMostLikedCategories({storeId: storeId, langKey: langKey}).$promise;
        }
        
        function listUsersGenerateMoreCoupons(storeId) {
            return ReportFactory.listUsersGenerateMoreCoupons(storeId).$promise;
        }
        
        function listUsersWithMoreCouponsRedeemed(storeId) {
            return ReportFactory.listUsersWithMoreCouponsRedeemed(storeId).$promise;
        }

        function listUsersFirstInteraction(storeId) {
            return ReportFactory.listUsersFirstInteraction(storeId).$promise;
        }

    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ReportFactory', ReportFactory);

    ReportFactory.$inject = ['$resource'];

    function ReportFactory($resource) {
        var resourceUrl = '';

        return $resource(resourceUrl, {}, {

            'listUsersRegisteredByGenderWithCouponGeneratedByStore': {
                method: 'POST',
                isArray: true,
                url: '/api/report/users-by-gender',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listMostLikedCategories': {
                method: 'POST',
                url: '/flyer/api/report/coupon/most-liked-categories',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersGenerateMoreCoupons': {
                method: 'POST',
                isArray: true,
                url: '/api/report/users-generate-more-coupons',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersWithMoreCouponsRedeemed': {
                method: 'POST',
                isArray: true,
                url: '/api/report/users-with-more-coupons-redeemed',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersFirstInteraction': {
                method: 'POST',
                isArray: true,
                url: '/flyer/api/report/coupon/users-first-interaction',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

        });
    }
})();

(function () {
    'user strict'

    angular
        .module('showcaseApp')
        .controller('PerformanceController', PerformanceController);

    //** NgInject */
    function PerformanceController($scope, $localStorage, $sce, $state) {

        var vm = this;

        vm.loading = true;

        window.setTimeout(function () {
            if ($state.params.report === 'hub-performance') {
                vm.dashboard = $sce.trustAsResourceUrl($localStorage.hub.performanceDashboard);
            } else if ($state.params.report === 'subscriptions') {
                vm.dashboard = $sce.trustAsResourceUrl($localStorage.hub.subscriptionsDashboard);
            } else if ($state.params.report === 'malwee-panel-multibrand') {
                vm.dashboard = $sce.trustAsResourceUrl($localStorage.hub.malweePanelMultibrandDashboard);
            } else if ($state.params.report === 'chat-performance') {
                vm.dashboard = $sce.trustAsResourceUrl($localStorage.defaultStore.chatPerformanceDashboard);
            } else if ($state.params.report === 'seller-performance') {
                vm.dashboard = $sce.trustAsResourceUrl($localStorage.defaultStore.sellerPerformanceDashboard);
            } else if ($state.params.report === 'seller-individual-performance') {
                vm.dashboard = $sce.trustAsResourceUrl($localStorage.defaultStore.sellerIndividualPerformanceDashboard);
            } else if ($state.params.report === 'abandoned-cart') {
                vm.dashboard = $sce.trustAsResourceUrl($localStorage.defaultStore.abandonedCartDashboard);
            } else if ($state.params.report === 'virtual-bag') {
                vm.dashboard = $sce.trustAsResourceUrl($localStorage.defaultStore.currentBagReport);
            } else if ($state.params.report === 'crm') {
                vm.dashboard = $sce.trustAsResourceUrl($localStorage.defaultStore.crmDashboard);
            } else {
                vm.dashboard = $sce.trustAsResourceUrl($localStorage.defaultStore.performanceDashboard);
            }
			vm.loading = false;

            $scope.$apply(vm.loading);
            $scope.$apply(vm.dashboard);

        }, 1500)
    }
})();

(function() {
    'use strict'


    angular
        .module('showcaseApp')
        .service('EngagementService', EngagementService);

    //** NgInject */
    function EngagementService(EngagementFactory) {

        var service = {
            listUsersFromCoupons: listUsersFromCoupons,
            listUsersFromContact: listUsersFromContact,
            listUsersFromSale: listUsersFromSale
        };

        return service;

        function listUsersFromCoupons(storeId, flyersIds) {
            return EngagementFactory.listUsersFromCoupons({
                storeId: storeId
            }, {
                flyersIds: flyersIds
            }).$promise;
        }

        function listUsersFromContact(storeId, flyersIds) {
            return EngagementFactory.listUsersFromContact({
                storeId: storeId
            }, {
                flyersIds: flyersIds
            }).$promise;
        }

        function listUsersFromSale(storeId, flyersIds) {
            return EngagementFactory.listUsersFromSale({
                storeId: storeId
            }, {
                flyersIds: flyersIds
            }).$promise;
        }
    }


})();

(function() {
    'use strict'

    'use strict';
    angular
        .module('showcaseApp')
        .factory('EngagementFactory', EngagementFactory);

    //** NgInject */
    function EngagementFactory($resource) {
        var resourceUrl = '';

        return $resource(resourceUrl, {}, {

            'listUsersFromCoupons': {
                method: 'POST',
                isArray: true,
                url: '/flyer/api/report/engagement/bycoupon',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersFromContact': {
                method: 'POST',
                isArray: true,
                url: '/flyer/api/report/engagement/bycontact',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersFromSale': {
                method: 'POST',
                isArray: true,
                url: '/flyer/api/report/engagement/bysale',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

})();

(function() {
    'user strict'

    angular
        .module('showcaseApp')
        .controller('EngagementController', EngagementController);

    //** NgInject */
    function EngagementController(EngagementService, $localStorage, FlyersService, FlyersCurrencyValue, $translate) {

        var vm = this;
        vm.storeId = $localStorage.defaultStore.storeId;
        vm.flyersIds = [];
        init();

        function init() {
            loadFlyers();
            loadUsersWithEngagementsFromCoupons();
            loadUsersWithEngagementsFromContacts();
            loadUsersWithEngagementsFromSales();
        }

        function loadUsersWithEngagementsFromCoupons() {
            vm.loadingUsersFromCoupons = true;
            EngagementService.listUsersFromCoupons(vm.storeId, vm.flyersIds).then(function(result) {
                vm.listUsersFromCoupon = result;
                vm.loadingUsersFromCoupons = false;
            }).catch(function() {
                vm.loadingUsersFromCoupons = false;
            });
        }

        function loadUsersWithEngagementsFromContacts() {
            vm.loadingUsersFromContact = true;
            EngagementService.listUsersFromContact(vm.storeId, vm.flyersIds).then(function(result) {
                vm.listUsersFromContact = result;
                vm.loadingUsersFromContact = false;
            }).catch(function() {
                vm.loadingUsersFromContact = false;
            });
        }

        function loadUsersWithEngagementsFromSales() {
            vm.loadingUsersFromContact = true;
            EngagementService.listUsersFromSale(vm.storeId, vm.flyersIds).then(function(result) {
                vm.listUsersFromSale = result;
                vm.loadingUsersFromSale = false;
            }).catch(function() {
                vm.loadingUsersFromSale = false;
            });
        }

        function loadFlyers() {

            FlyersService.listAllFlyers().then(onSuccess);

            function onSuccess(response) {
                vm.flyersFiltered = response;
            }
        }

        vm.toggleSelection = function toggleSelection(flyerId) {
            var idx = vm.flyersIds.indexOf(flyerId);

            loadUsersWithEngagementsFromCoupons();
            loadUsersWithEngagementsFromContacts();
            loadUsersWithEngagementsFromSales();

            // Is currently selected
            if (idx > -1) {
                vm.flyersIds.splice(idx, 1);
            }

            // Is newly selected
            else {
                vm.flyersIds.push(flyerId);
            }
        }

        vm.getFlyerCurrency = function(currency) {
            return FlyersCurrencyValue[currency];
        }

        vm.getGender = function(value) {
            if (value === "messages.gender.male") return $translate.instant('reports.engagement.message.gender.male')
            else return $translate.instant('reports.engagement.message.gender.female')
        }

        // Workaround to fix navigation sidebar
        // $(document).ready(function() {
        //     if (!document.getElementsByClassName('slimScrollDiv').length){
        //         setTimeout(function () {
        //             document.getElementsByClassName('slimScrollDiv')[0].setAttribute('style', 'position: relative; width: auto; height: 690px;');
        //         }, 1000);
        //     }
        //     else {
        //         document.getElementsByClassName('slimScrollDiv').setAttribute('style', 'position: relative; width: auto; height: 690px;');
        //     }

        //     if (!document.getElementById('side-menu').length){
        //         setTimeout(function () {
        //             document.getElementById('side-menu').setAttribute('style', 'height: 690px; width: auto;');
        //         }, 500);
        //     } else {

        //     }

        // });
    }
})();

(function () {
    'use strict'


    angular
        .module('showcaseApp')
        .service('ContactReportService', ContactReportService);

    //** NgInject */
    function ContactReportService(ContactReportFactory) {

        var service = {
            listUsersRegisteredByGenderWithContactGeneratedByStore: listUsersRegisteredByGenderWithContactGeneratedByStore,
            listMostLikedCategories: listMostLikedCategories,
            listUsersGenerateMoreContact: listUsersGenerateMoreContact,
            listUsersFirstInteraction: listUsersFirstInteraction
        };

        return service;

        function listUsersRegisteredByGenderWithContactGeneratedByStore(storeId) {
            return ContactReportFactory.listUsersRegisteredByGenderWithContactGeneratedByStore(storeId).$promise;
        }

        function listMostLikedCategories(storeId, langKey) {
            return ContactReportFactory.listMostLikedCategories({
                storeId: storeId,
                langKey: langKey
            }).$promise;
        }

        function listUsersGenerateMoreContact(storeId) {
            return ContactReportFactory.listUsersGenerateMoreContact(storeId).$promise;
        }

        function listUsersFirstInteraction(storeId) {
            return ContactReportFactory.listUsersFirstInteraction(storeId).$promise;
        }
    }


})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ContactReportFactory', ContactReportFactory);

    //** NgInject */
    function ContactReportFactory($resource) {
        var resourceUrl = '';

        return $resource(resourceUrl, {}, {

            'listUsersRegisteredByGenderWithContactGeneratedByStore': {
                method: 'POST',
                isArray: true,
                url: '/flyer/api/contact/report/users-by-gender',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listMostLikedCategories': {
                method: 'POST',
                url: '/flyer/api/contact/report/most-liked-categories',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersGenerateMoreContact': {
                method: 'POST',
                isArray: true,
                url: '/flyer/api/contact/report/users-generate-more-contacts',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersFirstInteraction': {
                method: 'POST',
                isArray: true,
                url: '/flyer/api/contact/report/users-first-interaction',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

        });
    }

})();

(function () {
    'user strict'

    angular
        .module('showcaseApp')
        .controller('ConsumersController', ConsumersController);

    //** NgInject */
    function ConsumersController() {

        var vm = this;
        vm.onTabSelected = onTabSelected;

        function onTabSelected(tab) {
            vm.selectedTab = tab;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rent-invoices', {
            parent: 'admin',
            url: '/rent-invoices',
            data: {
                authorities: ['UPDATE_TRANSACTION_STATUS'],
                pageTitle: 'rent.home.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/rent-invoices/rent.html',
                    controller: 'RentInvoicesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                type: null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rent-invoice');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('RentInvoicesService', RentInvoicesService);

        RentInvoicesService.$inject = ['RentInvoicesFactory', '$localStorage', 'Upload'];

    function RentInvoicesService(RentInvoicesFactory) {

        var service = {
            listAll: listAll,
            updateStatus: updateStatus,
        };

        return service;

        function listAll() {
            return RentInvoicesFactory.listAll().$promise;
        }

        function updateStatus(transation) {
            return RentInvoicesFactory.updateStatus({id: transation.transaction_id, status: transation.status}).$promise;
        }
    }

})();

(function() {
    'use strict';
    angular
    .module('showcaseApp')
    .filter('rentStatusFilter', function($translate) {

        return function(value) {
            var newValue;

            switch (value) {
                case 'WAITING_PAYMENT':
                    newValue = $translate.instant('rent.states.waiting-payment');
                    break;
                case 'PAID':
                    newValue = $translate.instant('rent.states.paid');
                    break;
                case 'CANCELLED':
                    newValue = $translate.instant('rent.states.cancelled');
                    break;
                case 'ACCEPTED':
                    newValue = $translate.instant('rent.states.accepted');
                    break;
                case 'REFUSED':
                    newValue = $translate.instant('rent.states.refused');
                    break;
                case 'ARCHIVED':
                    newValue = $translate.instant('rent.states.archived');
                    break;
                case 'REVERTED':
                    newValue = $translate.instant('rent.states.reverted');
                    break;
                default:
                    break;
            }
            return newValue;
        }
    })
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('RentInvoicesFactory', RentInvoicesFactory);

        RentInvoicesFactory.$inject = ['$resource'];

    function RentInvoicesFactory($resource) {
        var resourceUrl =  'flyer/api/transaction/list?type=RENT';

        return $resource(resourceUrl, {id: '@id'}, {
            'listAll': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateStatus': {
                method: 'PUT',
                url: 'flyer/api/transaction/:id/rent/update-status',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('RentInvoicesController', RentInvoicesController);

    function RentInvoicesController(RentInvoicesService, ChangeStateModalFactory, toastr, $translate) {
        var vm = this;

        vm.flyersFiltered = [];

        vm.isSaving = false;

        vm.startDate = {
            startDate: null,
            endDate: null
        };

        vm.currentPage = 1;
        vm.numPerPage = 10;
        vm.maxSize = 5;
        vm.totalCustomers = 0;

        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        vm.gridOptions = {
            expandableRowTemplate:
                '<div ui-grid="row.entity.subGridOptions" style="height:150px;"></div>',
            showExpandAllButton: false,
            multiSelect:false ,
            enableRowSelection: true,
            enablePaginationControls: false,
            paginationPageSize: vm.numPerPage,
            onDblClickExpand: false,
            enableSelectAll: false,
            enableColumnMenus: false,
            enableExpandableRowHeader: false,
            enableFiltering: true,
            rowTemplate:'<div ng-click="grid.appScope.fnOne(row)" ng-repeat="col in colContainer.renderedColumns track by col.colDef.name" class="kct-class ui-grid-cell mx-auto" ui-grid-cell></div>',
            expandableRowScope: {
                subGridVariable: 'subGridScopeVariable'
            }
        };

        var linkCellTemplate =
              '<span ng-if="row.entity[col.field] === \'CANCELLED\'" ng-click="alert(row, col)" class="label label-info cancelled" >{{ row.entity[col.field] | rentStatusFilter }}</span>'
            + '<span ng-if="row.entity[col.field] === \'PAID\'" class="label label-info paid" >{{ row.entity[col.field] | rentStatusFilter }}</span>'
            + '<span ng-if="row.entity[col.field] === \'ARCHIVED\'" class="label label-info archived" >{{ row.entity[col.field] | rentStatusFilter }}</span>'
            + '<span ng-if="row.entity[col.field] === \'ACCEPTED\'" class="label label-info accepted" >{{ row.entity[col.field] | rentStatusFilter }}</span>'
            + '<span ng-if="row.entity[col.field] === \'REFUSED\'" class="label label-info refused" >{{ row.entity[col.field] | rentStatusFilter }}</span>'
            + '<span ng-if="row.entity[col.field] == \'WAITING_PAYMENT\'" class="label label-info waiting_payment" >{{ row.entity[col.field] | rentStatusFilter }}</span>';

        vm.gridOptions.columnDefs = [
            {
                name: 'Actions',
                displayName: '',
                width: '1%',
                headerCellClass: 'header-noborder',
                cellClass: 'noborder',
                onDblClickExpand: false,
                enableCellEdit: false,
                enableFiltering: false,
                enableColumnMenu: false,
                cellTemplate:
                    ' <div  class="ui-grid-cell-contents"> \
                                <i \
                                ng-class="{ \'ui-grid-icon-right-dir\' : !row.isExpanded, \'ui-grid-icon-down-dir\' : row.isExpanded }" \
                                ng-click="grid.api.expandable.toggleRowExpansion(row.entity)"> \
                                </i> \
                            </div>',
                enableSorting: false
            },
            {
                name: 'Order Id',
                field: 'transaction_id',
                cellClass: 'noborder',
                width: '10%',
                enableFiltering: false,
                headerCellClass: 'header-noborder',
                displayName: 'rent.home.table.id',
                headerCellFilter: 'translate',
                onDblClickExpand: false,
                enableCellEdit: false
            },
            {
                name: 'Customer',
                field: 'customer',
                cellClass: 'noborder',
                enableFiltering: false,
                headerCellClass: 'header-noborder',
                displayName: 'rent.home.table.customer',
                headerCellFilter: 'translate',
                onDblClickExpand: false,
                enableCellEdit: false
            },
            {
                name: 'Amount',
                field: 'totalCost',
                headerCellClass: 'header-noborder',
                cellClass: 'noborder',
                enableFiltering: false,
                displayName: 'rent.home.table.total',
                headerCellFilter: 'translate',
                cellFilter: 'currency',
                type: 'number',
                onDblClickExpand: false,
                enableCellEdit: false
            },
            {
                name: 'Date',
                field: 'dateTransaction',
                enableFiltering: false,
                cellClass: 'noborder',
                headerCellClass: 'header-noborder',
                displayName: 'rent.home.table.date',
                headerCellFilter: 'translate',
                cellFilter: 'date:"dd/MM/yyyy"',
                onDblClickExpand: false,
                enableCellEdit: false
            },
            {
                name: 'Status',
                field: 'status',
                cellClass: 'noborder',
                enableFiltering: false,
                onDblClickExpand: false,
                headerCellClass: 'header-noborder',
                enableCellEdit: false,
                cellFilter: 'statusFilter',
                displayName: 'rent.home.table.status',
                headerCellFilter: 'translate',
                cellTemplate: linkCellTemplate
            },
            {
                name: 'Recommended action',
                cellClass: 'noborder',
                width: '25%',
                enableFiltering: false,
                onDblClickExpand: false,
                headerCellClass: 'header-noborder',
                enableCellEdit: false,
                displayName: 'rent.home.table.recommended-action',
                headerCellFilter: 'translate',
                cellTemplate: 'app/admin/rent-invoices/rent-row-detail.html'
            },
        ];



        function loadSubRowData(data) {
            for (var i = 0; i < data.length; i++) {
                data[i].subGridOptions = {
                    enableColumnMenus: false,
                    enableExpandableRowHeader: false,
                    columnDefs: [
                        {
                            name: 'Product',
                            headerCellClass: 'header-noborder',
                            field: 'flyerName',
                            cellClass: 'noborder',
                            displayName: 'rent.home.subTable.product',
                            headerCellFilter: 'translate'
                        },
                        {
                            name: 'Inicio',
                            field: 'initialRent',
                            headerCellClass: 'header-noborder',
                            cellClass: 'noborder',
                            cellFilter: 'date:"dd/MM/yyyy"',
                            displayName: 'rent.home.subTable.initialRent',
                            headerCellFilter: 'translate'
                        },
                        {
                            name: 'Fim',
                            field: 'finalRent',
                            cellClass: 'noborder',
                            headerCellClass: 'header-noborder',
                            cellFilter: 'date:"dd/MM/yyyy"',
                            displayName: 'rent.home.subTable.finalRent',
                            headerCellFilter: 'translate'
                        },
                        {
                            name: 'Quantity',
                            headerCellClass: 'header-noborder',
                            displayName: 'rent.home.subTable.quantity',
                            cellClass: 'noborder',
                            headerCellFilter: 'translate',
                            field: 'quantity'
                        }
                    ],
                    data: data[i].products
                };
            }
        }
        loadInvoices();
        function loadInvoices() {
            RentInvoicesService.listAll().then(function(result) {
                var data = result.data;
                var list = [];
                if (data && data.length) {
                    list = _.chain(result.data)
                        .groupBy('transaction.id')
                        .toPairs()
                        .map(function(pair) {
                            return _.zipObject(['transaction_id', 'data'], pair);
                        })
                        .value();
                    vm.gridData = parseResult(list);

                    vm.gridOptions.data = vm.gridData;
                    vm.totalCustomers = vm.gridData.length;
                    loadSubRowData(vm.gridData);
                }
            });
        }

        vm.updateStatus = function(row, status) {
            row.entity.status = status;
            vm.isSaving = true;

            RentInvoicesService.updateStatus(row.entity).then(function(result) {
                loadInvoices();
                toastr.success($translate.instant('rent.home.messages.saveSuccess'));
                vm.isSaving = false;
            }).catch(function(err) {
                toastr.error($translate.instant('rent.home.messages.noItens'));
                vm.isSaving = false;
            });
        }

        vm.changePage = function () {
            vm.gridApi.pagination.seek(vm.currentPage)
            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            vm.startRegistry = begin + 1;
            vm.endRegistry = end;

        }

        function parseResult(list) {
            var resultList = [];
            for (var i = 0; i < list.length; i++) {
                var current = {
                    transaction_id: list[i].transaction_id
                };
                current.products = [];
                for (var ind = 0; ind < list[i].data.length; ind++) {
                    current.products.push({
                        flyerName: list[i].data[ind].flyerName,
                        initialRent: list[i].data[ind].transaction.initialRent,
                        finalRent: list[i].data[ind].transaction.finalRent,
                        quantity: list[i].data[ind].quantity
                    });
                    current.customer =
                        list[i].data[ind].transaction.customer.fullName;
                    current.totalCost = list[i].data[ind].transaction.totalCost;
                    current.dateTransaction =
                        list[i].data[ind].transaction.dateTransaction;
                    current.status = list[i].data[ind].transaction.status;
                }
                resultList.push(current);
            }
            return resultList;
        }

        vm.gridOptions.onRegisterApi = function(gridApi) {
            vm.gridApi = gridApi;
        };

        vm.filter = function() {
            vm.gridApi.grid.refresh();
        };

        vm.state = {};

        vm.saveState = function() {
            vm.state = vm.gridApi.saveState.save();
        };

        vm.filterClient = function() {
            vm.state = vm.gridApi.saveState.save();
            vm.state.columns[2].filters[0] = { term: vm.clientFilter || '*' };
            vm.gridApi.saveState.restore(vm, vm.state);
        };

        vm.filterId = function() {
            vm.state = vm.gridApi.saveState.save();
            vm.state.columns[1].filters[0] = { term: vm.idFilter || '*' };
            vm.gridApi.saveState.restore(vm, vm.state);
        };

        vm.filterValue = function() {
            vm.state = vm.gridApi.saveState.save();
            vm.state.columns[3].filters[0] = { term: vm.valueFilter || '*' };
            vm.gridApi.saveState.restore(vm, vm.state);
        };

        vm.filterState = function() {
            vm.state = vm.gridApi.saveState.save();
            vm.state.columns[5].filters[0] = { term: vm.stateFilter || '*' };
            vm.gridApi.saveState.restore(vm, vm.state);
        };

        vm.declineOrders = function() {

            if (!vm.gridApi.selection.getSelectedCount()) {
                return toastr.error($translate.instant('rent.home.messages.noItens'));
            }

            var entity = vm.gridApi.selection.getSelectedGridRows()[0].entity;
            entity.status = "REFUSED";
            ChangeStateModalFactory.update().then(function(data) {
                if (data) {
                    RentInvoicesService.updateStatus(entity).then(function(result) {
                        loadInvoices();
                        toastr.success($translate.instant('rent.home.messages.saveSuccess'));
                        vm.gridApi.selection.clearSelectedRows()
                        vm.isSaving = false;
                    }).catch(function(err) {
                        toastr.error($translate.instant('rent.home.messages.noItens'));
                        vm.isSaving = false;
                    });
                }
            }).catch(function(err) {

            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('redeem-coupons', {
                parent: 'admin',
                url: '/redeem-coupons',
                data: {
                    authorities: ['STORE_REDEEM_COUPON'],
                    pageTitle: 'redeem-coupons.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/redeem-coupons/redeem-coupons.html',
                        controller: 'RedeemCouponsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    cupom: null,
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('redeem-coupons');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]

                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('RedeemCouponsService', RedeemCouponsService);

    RedeemCouponsService.$inject = ['RedeemCouponsFactory'];

    function RedeemCouponsService(RedeemCouponsFactory) {

        return {
            redeemCoupon: redeemCoupon,
            validateCoupon: validateCoupon
        }

        function redeemCoupon(dynamicCode, redeemSalesPointId) {
            return RedeemCouponsFactory.redeem({
                dynamicCode: dynamicCode,
                redeemSalesPointId: redeemSalesPointId
            }).$promise;
        }

        function validateCoupon(dynamicCode, salesPointId) {
            return RedeemCouponsFactory.validate({
                dynamicCode: dynamicCode,
                salesPointId: salesPointId
            }).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('RedeemCouponsFactory', RedeemCouponsFactory);

    RedeemCouponsFactory.$inject = ['$resource'];

    function RedeemCouponsFactory($resource) {
        var resourceUrl = '';

        return $resource(
            resourceUrl
        , {}, {
            'redeem': {
                method: 'POST',
                url: 'flyer/api/coupon/redeem',
                transformResponse: [function(data) {
                    return data;
                }]
            },
            'validate': {
                method: 'POST',
                url: 'flyer/api/coupon/validate'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('RedeemCouponsController', RedeemCouponsController);

    RedeemCouponsController.$inject = ['TimeService', '$localStorage', '$translate', 'RedeemCouponsService', 'StoreService', 'FlyersCurrencyValue',
    'toastr', '$stateParams', '$location'];

    function RedeemCouponsController(TimeService, $localStorage, $translate, RedeemCouponsService, StoreService, FlyersCurrencyValue,
        toastr, $stateParams, $location) {

        var vm = this;

        vm.coupon = {};

        vm.salesPoints = [];

        vm.storeId = $localStorage.defaultStore.storeId;

        vm.redeemed = false;

        if ( ($stateParams && $stateParams.cupom) || $location.search().cpm) {
            vm.codeCoupon = $stateParams.cupom || $location.search().cpm;
            $location.url($location.path());
        }

        loadAll();

        vm.checkRedeemed = function() {
            if (vm.redeemed) {
                vm.flyer = null;
                vm.redeemed = false;
            }
        }

        vm.validateCoupon = function() {
            RedeemCouponsService.validateCoupon(vm.codeCoupon, vm.salesPointId).then(function(data) {
                vm.couponCode = vm.codeCoupon;
                vm.flyer = data.flyer;
                vm.redeemed = false;
            }, function(error) {
                toastr.error($translate.instant('redeem-coupons.home.messages.error'.concat(".").concat(error.headers()['statuskey'])));
            });
        }

        vm.redeemCoupon = function() {
            RedeemCouponsService.redeemCoupon(vm.couponCode, vm.salesPointId).then(function(data) {
                vm.redeemed = true;
                vm.coupon = {};
                vm.codeCoupon = "";
                vm.salesPointId = "";
            });
        }


        vm.getImagePath = function(flyerId) {
            return ('/flyer/api/' + flyerId + '/picture');
        }

        vm.getFlyerCurrency = function(currency) {
            return FlyersCurrencyValue[currency];
        }

        vm.calcTimeDifference = function(expirationDate) {
            return TimeService.calcTimeDifference(expirationDate);
        }

        vm.getExpirationDate = function(expirationDate) {
            return new Date(expirationDate).toLocaleDateString();
        }

        function loadAll() {
            StoreService.getSalesPoints(vm.storeId).then(function(response) {
                vm.salesPoints = response.data;
                vm.salesPointId = vm.salesPoints[0] ? vm.salesPoints[0].id + '' : '';
             });
        }

    }

})();

(function () {
    'use strict';

    angular.module('showcaseApp').factory('NotificationService', NotificationService);
    NotificationService.$inject = ['NotificationFactory', '$uibModal'];

    function NotificationService(NotificationFactory) {
        var service = {
            getNotificationsListByStoreAndReadIsFalse: getNotificationsListByStoreAndReadIsFalse,
            readNotification: readNotification,
            getNotificationInfo: getNotificationInfo,
            updateNotificationsAsReadByStoreIdAndConversationId: updateNotificationsAsReadByStoreIdAndConversationId
        };

        return service;

        function getNotificationsListByStoreAndReadIsFalse(id, pagination) {
            var params = {'storeId': id, 'page': pagination.page, 'size': pagination.limit};
            return NotificationFactory
                .getNotificationsListByStoreAndReadIsFalse(params).$promise;
        }

        function readNotification(id) {
            return NotificationFactory.readNotification({'id': id}, {}).$promise;
        }

        function updateNotificationsAsReadByStoreIdAndConversationId(storeId, conversationId) {
            var params = {'storeId': storeId, 'conversationId': conversationId};
            return NotificationFactory.updateNotificationsAsReadByStoreIdAndConversationId(params, {}).$promise;
        }

        function getNotificationInfo(storeId, accountId) {
            var params = {'storeId': storeId, 'accountId': accountId};
            return NotificationFactory.getNotificationInfo(params, {}).$promise;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('NotificationFactory', ChecklistFactory);

    ChecklistFactory.$inject = ['$resource'];
    function ChecklistFactory($resource) {
        var resourceUrl = 'admin/api/activity';
        return $resource(resourceUrl, {}, {
            'getNotificationsListByStoreAndReadIsFalse': {
                method: 'GET',
                url: 'admin/api/notifications/list/store/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'readNotification': {
                method: 'PUT',
                isArray: false,
                url: 'admin/api/notifications/read/:id'
            },
            'updateNotificationsAsReadByStoreIdAndConversationId': {
                method: 'PUT',
                isArray: true,
                url: 'admin/api/notifications/store/:storeId/read/:conversationId'
            },
            'getNotificationInfo': {
                method: 'GET',
                isArray: false,
                url: 'admin/api/notifications/store/:storeId/account/:accountId/info'
            }
        });

    }

})();

(function () {
    'use strict';
    angular.module('showcaseApp')
        .controller('NotificationListController', NotificationListController);

    NotificationListController.$inject = ['$uibModalInstance', '$state', '$localStorage', 'toastr', '$translate', 'Principal', 'SettingsService', 'NotificationService'];

    function NotificationListController($uibModalInstance, $state, $localStorage, toastr, $translate, Principal, SettingsService, NotificationService) {

        var vm = this;

        vm.goToMessage = goToMessage;
        vm.readNotifications = readNotifications;
        vm.notifications = [];
        vm.loading = true;
        vm.pagination = {
            page: 0,
            limit: 20
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.nextPage = function () {
            if (vm.hasNext) {
                vm.pagination.page++;
                getNotificationsInfo(false);
            }
        }

        function getAccount() {
            Principal.identity(false).then(function (account) {
                vm.account = account;
                $translate.use(vm.account.langKey);
            });
        }

        function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
            var startTimeInMs = Date.now();
            (function loopSearch() {
                if (document.getElementById(selector) != null) {
                    callback();
                    return;
                } else {
                    setTimeout(function () {
                        if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                            return;
                        loopSearch();
                    }, checkFrequencyInMs);
                }
            })();
        }

        function getNotificationsInfo(hook) {
            vm.systemNotificationsSound = true;
            SettingsService.getRegister($localStorage.userId, $localStorage.defaultStore.storeId).then(function (data) {
                vm.systemNotificationsSound = data['soundNotification'];
            });

            NotificationService.getNotificationsListByStoreAndReadIsFalse(
                $localStorage.defaultStore.storeId,
                vm.pagination
            ).then(function (result) {
                vm.hasNext = !result.data.last;
                result.data.content.forEach(function (item) {
                    if ((item.accountId == null || item.accountId == vm.account.id)) {
                        if(item.type == 'CHANGE_ATTENDANT') {
                            item.message = $translate.instant('notifications.messages.change-attendant') + item.title;
                        }

                        switch (item.origin) {
                            case 'WATI':
                                item.image = '/content/images/icon-whatsapp.png';
                                item.origin = 'WHATSAPP';
                                break;
                            case 'MESSENGER':
                                item.image = '/content/images/icon-messenger.png';
                                break;
                            case 'INSTAGRAM':
                                item.image = '/content/images/icon-instagram.png';
                                break;
                            default:
                                item.image = '/content/images/notification-badge.png';
                                break;
                        }

                        var date = new Date(item.updatedAt);
                        var today = new Date();
                        var diff = Math.abs(today - date);
                        var minutes_diff  = Math.floor((diff/1000)/60);

                        if (minutes_diff < 1) {
                            item.updatedAt = $translate.instant('notifications.messages.now')
                        } else if (minutes_diff == 1) {
                            item.updatedAt = $translate.instant('notifications.messages.pre-time') + '1 ' + $translate.instant('notifications.messages.minute');
                        } else if (minutes_diff < 6) {
                            item.updatedAt = $translate.instant('notifications.messages.pre-time') + minutes_diff + ' ' + $translate.instant('notifications.messages.minutes');
                        } else if (today.getDate() - date.getDate() == 0) {
                            item.updatedAt = ("0" + date.getHours()).slice(-2) + ':' + ("0" + date.getMinutes()).slice(-2);
                        } else if (today.getDate() - date.getDate() == 1) {
                            item.updatedAt = $translate.instant('notifications.messages.yesterday') +
                                ("0" + date.getHours()).slice(-2) + ':' + ("0" + date.getMinutes()).slice(-2);
                        } else {
                            item.updatedAt = date.toLocaleDateString("pt-br");
                        }

                        vm.notifications.push(item);
                    }
                });

                vm.loading = false;
            });
        }

        function goToMessage(notification) {
            vm.readNotifications(notification);
            $state.go('communication', {}, {reload: true});
            $localStorage.redirectNotificationData = {
                conversationId: notification.chatId,
                chatPlatform: notification.origin
            };
            vm.cancel();
        }

        function readNotifications(notification) {
            if (!notification.read) {
                NotificationService.readNotification(notification.id).then(function (data) {
                });
            }
        }

        function loadAll() {
            getAccount();

            waitForElementToDisplay("modalContent",function() {
                var acc = document.getElementById("modalContent");
                acc.style.height = screen.height - 100 + 'px';
            });

            vm.notifications = [];
            getNotificationsInfo(false);
        }

        loadAll();
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ADMIN_MANAGE_SYSTEM'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('MessengerService', MessengerService);

    MessengerService.$inject = ['MessengerFactory', '$resource'];

    function MessengerService(MessengerFactory, $resource) {

        var service = {
            sendMessage: sendMessage,
            sendCarousel: sendCarousel,
            makeMessengerCredentials: makeMessengerCredentials,
            getFbProfileById: getFbProfileById,
            findConversations: findConversations,
            findMessages: findMessages,
            sendMedia: sendMedia,
            findAttachmentResource: findAttachmentResource,
            findAttachment: findAttachment 
        };

        return service;

        function sendMessage(text, recipientId, type) {
            var body = {
                recipient: {
                    id: recipientId
                },
                message: {
                    text: text
                },
                type: type ? type : "TEXT"
               };
            return MessengerFactory.sendMessage(body).$promise;
        }

        function sendMedia(body) {
            return MessengerFactory.sendMessage(body).$promise;
        }

        function sendCarousel(flyers, recipientId) {
            var body = {
                recipient: {
                    id: recipientId
                },
                flyers: flyers,
                type: "TEMPLATE"
            };
            return MessengerFactory.sendMessage(body).$promise;
        }

        function makeMessengerCredentials(body) {
            MessengerFactory.makeMessengerCredentials({id: body.id}, body);
        }

        function getFbProfileById(id) {
            return MessengerFactory.getFbProfileById({id: id}).$promise;
        }

        function findConversations(pageId, plataform, cursor) {
            return MessengerFactory.findConversations({pageId: pageId, plataform: plataform, cursor: cursor}).$promise;
        }

        function findMessages(threadId, cursor) {
            return MessengerFactory.findMessages({threadId: threadId, cursor: cursor}).$promise;
        }

        function findAttachmentResource(id) {
            return MessengerFactory.findAttachment({id: id}).$promise;
        }

        function findAttachment(resource) {
            return $resource(resource, {}, {
                'find': {method: 'GET'}
            });
        }

    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('MessengerFactory', MessengerFactory);

        MessengerFactory.$inject = ['$resource'];

    function MessengerFactory($resource) {
        var resourceFacebook =  '/admin/api/facebook';
        var resourceSendMessage =  resourceFacebook + '/send-message';
        var resourceMakeCredentials =  resourceFacebook + '/:id';
        var resourceGetProfile =  resourceFacebook + '/profile';
        var resourceFindConversations =  resourceFacebook + '/conversations';
        var resourceFindMessages =  resourceFacebook + '/messages';
        var resourceFindAttachment =  resourceFacebook + '/attachment';

        return $resource(resourceFacebook, {}, {
            'sendMessage': {
                method: 'POST',
                url: resourceSendMessage
            },
            'makeMessengerCredentials': {
                method: 'POST',
                url: resourceMakeCredentials
            },
            'getFbProfileById': {
                method: 'GET',
                url: resourceGetProfile
            },
            'findAttachment': {
                method: 'GET',
                url: resourceFindAttachment
            },
            'findConversations': {
                method: 'GET',
                url: resourceFindConversations
            },
            'findMessages': {
                method: 'GET',
                url: resourceFindMessages
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ADMIN_MANAGE_SYSTEM'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

    (function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('RefundMagicModalController', RefundMagicModalController);

        RefundMagicModalController.$inject = ['invoice', 'InvoicesService', '$uibModalInstance', '$translate', 'toastr'];

    function RefundMagicModalController(invoice, InvoicesService, $uibModalInstance, $translate, toastr) {
        var vm = this;
        vm.currentStep = 1;
        vm.invoice = invoice;
        vm.refundValue = vm.invoice.totalCost + (vm.invoice.shippingValue ? vm.invoice.shippingValue : 0);

        vm.getDocumentType = function () {
            return vm.invoice.cpf.length === 11 ? 'CPF' : 'CNPJ';
        }

        vm.isRefundValueEqualToTotal = function() {
            if (!vm.refundValue) { return false; }
            if (typeof vm.refundValue !== 'number') { return false; }
            return vm.refundValue > 0 && vm.refundValue == (vm.invoice.totalCost + vm.getShippingValue());
        }

        vm.getShippingValue = function() {
            return vm.invoice.shippingValue ? vm.invoice.shippingValue : 0;
        }

        vm.refundTransaction = function() {
            InvoicesService.refundInvoice(vm.invoice.id, vm.refundValue).then(function(result) {
                console.log(result);
                toastr.success($translate.instant('invoice.refund.message.success.save'));
                $uibModalInstance.close();
            }).catch(function(err) {
                console.log(err);
                toastr.error($translate.instant('invoice.refund.message.error.save'));
            });
        }

        vm.closeModal = function(url) {
            $uibModalInstance.close(url);
        }

        vm.nextStep = function() {
            switch(vm.currentStep) {
                case 1:
                    vm.currentStep = vm.currentStep + 1;
                    break;
                case 2:
                    vm.currentStep = vm.currentStep + 1;
                    break;
            }
        }

        vm.backStep = function() {
            switch(vm.currentStep) {
                case 1:
                     vm.closeModal();
                     return;
                default:
                    vm.currentStep = vm.currentStep - 1;
                    break;
            }

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        var resolve = {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('invoice');
                $translatePartialLoader.addPart('global');
                $translatePartialLoader.addPart('customers');
                return $translate.refresh();
            }]
        }

        $stateProvider
            .state('invoices', {
                parent: 'admin',
                url: '/invoices',
                data: {
                    authorities: ['STORE_READ_FLYER'],
                    pageTitle: 'invoice.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/invoices/invoices.html',
                        controller: 'InvoicesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    type: null,
                    sellerId: undefined
                },
                resolve: resolve
            })
            .state('invoices.new', {
                url: '/new',
                data: {
                    authorities: ['STORE_READ_FLYER'],
                    pageTitle: 'invoice.new.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/invoices/invoice-new.html',
                        controller: 'InvoiceNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: resolve
            })



    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('InvoicesService', InvoicesService);

        InvoicesService.$inject = ['InvoicesFactory', '$localStorage', 'Upload'];

    function InvoicesService(InvoicesFactory) {

        var service = {
            listAll: listAll,
            updateStatus: updateStatus,
            list: list,
            updateTransactionStatus: updateTransactionStatus,
            getTransactionOrders: getTransactionOrders,
            createInvoice: createInvoice,
            refundInvoice: refundInvoice,
            calculateDiscount: calculateDiscount
        };

        return service;

        function listAll() {
            return InvoicesFactory.listAll().$promise;
        }

        function updateStatus(transation) {
            return InvoicesFactory.updateStatus({id: transation.transaction_id, status: transation.status}).$promise;
        }

        function updateTransactionStatus(transationId, status) {
            return InvoicesFactory.updateStatus({id: transationId, status: status}).$promise;
        }

        function list(pageable, customerFilter) {
            return InvoicesFactory.list(pageable, customerFilter).$promise;
        }

        function getTransactionOrders(transactionId) {
            return InvoicesFactory.getTransactionOrders({transactionId: transactionId}).$promise;
        }

        function createInvoice(invoice) {
            return InvoicesFactory.createInvoice(invoice).$promise;
        }

        function refundInvoice(transactionId, amount) {
            return InvoicesFactory.refundInvoice({id: transactionId, amount: amount}).$promise;
        }

        function calculateDiscount(invoice) {
            return InvoicesFactory.calculateDiscount(invoice).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
    .module('showcaseApp')
    .filter('statusFilter', function($translate) {

        return function (value) {
            var newValue;

            switch (value) {
                case 'WAITING_PAYMENT':
                    newValue = $translate.instant('invoice.states.waiting');
                    break;
                case 'PAID':
                    newValue = $translate.instant('invoice.states.paid');
                    break;
                case 'CANCELLED':
                    newValue = $translate.instant('invoice.states.cancelled');
                    break;
                case 'WAITING_CONFIRMATION':
                		newValue = $translate.instant('invoice.states.waitingConfirmation');
                	break;
                case 'CONFIRMED':
                	newValue = $translate.instant('invoice.states.confirmed');
                	break;
                case 'SEPARATING':
                		newValue = $translate.instant('invoice.states.separating');
                	break;
                case 'AVAILABLE_TO_DELIVERY':
                		newValue = $translate.instant('invoice.states.availableToDelivery');
                	break;
                case 'DELIVERED':
                	newValue = $translate.instant('invoice.states.delivered');
                	break;
                case 'NOT_PAID':
                    newValue = $translate.instant('invoice.states.cancelled');
                    break;
                case 'REVERTED':
                    newValue = $translate.instant('invoice.states.reverted');
                    break;
                default:
                    break;
            }
            return newValue;
        }
    });
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('InvoicesFactory', InvoicesFactory);

    InvoicesFactory.$inject = ['$resource'];

    function InvoicesFactory($resource) {
        var resourceUrl =  'flyer/api/transaction/list?type=SALE';

        return $resource(resourceUrl, {id: '@id'}, {
            'listAll': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateStatus': {
                method: 'PUT',
                url: 'flyer/api/transaction/:id/update-status',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'list': {
                method: 'POST',
                url: 'flyer/api/transaction/list',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getTransactionOrders': {
                method: 'GET',
                url: 'flyer/api/transaction/orders/:transactionId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'createInvoice': {
                method: 'POST',
                url: 'flyer/api/invoice',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    } else {
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'refundInvoice': {
                method: 'POST',
                url: 'flyer/api/transaction/:id/refund',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'calculateDiscount': {
                method: 'POST',
                url: 'flyer/api/invoice/calculate-discount',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else {
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('InvoicesController', InvoicesController);

    function InvoicesController($translate, $localStorage, $uibModal, $stateParams, Principal, InvoicesService, StoreService, toastr, ModalFactory) {
        var vm = this;

        vm.flyersFiltered = [];
        vm.sellerId = $stateParams.sellerId ? $stateParams.sellerId : undefined;

        vm.startDate = {
            startDate: null,
            endDate: null
        };

        vm.currentPage = 1;
        vm.numPerPage = 10;
        vm.maxSize = 5;
        vm.totalCustomers = 0;
        vm.currencyPrefix = 'R$';

        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        vm.invoiceList = [];

        vm.filter = {
            transactionType: "SALE"
        };
        vm.account = undefined;
        vm.userProfile = undefined;

        init();

        function init() {
            Principal.identity().then(function (account) {
                if (account) {
                    vm.account = angular.copy(account);
                    vm.userProfile = vm.account.userProfiles[0];
                    loadInvoiceList(vm.paginationOptions, vm.filter);
                }
            });
            
        }

        function loadInvoiceList(pagination, filter) {
            vm.loadingInvoices = true;
            if (vm.userProfile.profileId == 7) {
                vm.filter.sellerId = vm.account.id;
            }
            InvoicesService.list(pagination, filter).then(function (result) {
                if (result.data) {
                    vm.invoiceList = result.data.content;
                    vm.invoiceList.forEach(function (transaction){
                        transaction.currencyPrefix = getCurrencyPrefix(transaction);
                    });
                    vm.totalInvoices = result.data.totalElements;
                    vm.loadingInvoices = false;
                }
            }, function (error) {
                vm.loadingInvoices = false;
            });
        }

        function getCurrencyPrefix(transaction) {
            var key = transaction.currency ? transaction.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            return config.prefix;
        }

        vm.openModalDetail = function(invoice) {
            ModalFactory.openDetailInvoice(invoice, vm.userProfile).then(function (result) {
                if (result && result.invoice) {
                    vm.openRefundModal(result.invoice);
                } else {
                    loadInvoiceList(vm.paginationOptions, vm.filter);
                }
            });
        }

        vm.openRefundModal = function (data) {
            vm.magicModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/invoices/refund/refund-magic-modal.html',
                controller: 'RefundMagicModalController',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                controllerAs: 'vm',
                resolve: {
                    invoice: function () {
                        return data
                    }
                },
                keyboard: false
            }).result.then(function (response) {
                loadInvoiceList(vm.paginationOptions, vm.filter);
            });
        };

        vm.changePage = function () {
            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            vm.customers = loadInvoiceList(vm.paginationOptions, vm.filter);
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;

        }

        vm.updateStatus = function(invoice, status) {
            vm.isSaving = true;
            InvoicesService.updateTransactionStatus(invoice.id, status).then(function(result) {
                toastr.success($translate.instant('invoice.home.messages.saveSuccess'));
                invoice.status = status;
                vm.isSaving = false;
            }).catch(function(err) {
                toastr.error($translate.instant('invoice.home.messages.noItens'));
                vm.isSaving = false;
            });
        }


        vm.filterInvoices = function() {
            vm.filter.status = vm.filter.status == "" ? null : vm.filter.status
            vm.currentPage = 1;
            vm.paginationOptions.page = 0;
            loadInvoiceList(vm.paginationOptions, vm.filter);
        };

        vm.maskPrice = function (value, currencyKey) {
            var currencyConfiguration = getCurrencyListConfiguration()[currencyKey];
            return formatMoney(value, currencyConfiguration.prefix, currencyConfiguration.decimalQuant, currencyConfiguration.centsSeparator, currencyConfiguration.thousandsSeparator);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('InvoiceNewController', InvoiceNewController);

    function InvoiceNewController($q, UserService, StoreInfoFactory, $localStorage, toastr, $translate, $state, $uibModal,
                                  InvoicesService, CheckCEPService, StoreService, DiscountCouponService) {

        var vm = this;
        vm.store = $localStorage.defaultStore;
        vm.currencyPrefix = getCurrencyListConfiguration()['REAL'].prefix;
        vm.isBrl = true;

        vm.randomTime = new Date().getTime();

        vm.height = window.innerHeight;
        vm.states = getAllStates();

        function setDynamicDivHeight() {
            vm.height = window.innerHeight;
        }

        window.addEventListener('load', setDynamicDivHeight);
        window.addEventListener('resize', setDynamicDivHeight);

        // Auxiliaries for sellers entities
        vm.querySearchSellers = querySearchSellers;
        vm.selectedSellerChange = selectedSellerChange;

        vm.invoice = {
            storeId: StoreInfoFactory.getStoreId(),
            shippingOption: 'PICK_UP_IN_STORE',
            paymentMethod: 'DIRECT_SALE',
            paymentCondition: 'MONEY',
            shippingValue: 0,
            customer: {},
            items: [],
            currency: 'REAL'
        }

        vm.selectedCoupon = undefined;
        vm.purchaseValue = 0;

        init();

        function init() {
            loadStore();
            getUsersSellers();
        }

        function loadCurrencyPrefix(store) {
            vm.invoice.currency = store.currency ? store.currency : 'REAL';
            var config = getCurrencyListConfiguration()[vm.invoice.currency];
            vm.currencyPrefix = config.prefix;
        }

        function loadStore() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function (response) {
                if (response && response.data) {
                    vm.store = response.data;
                    vm.storeCategory = response.data.categoryKey;
                    vm.isBrl = response.data.langKey == 'pt-br';
                    loadCurrencyPrefix(vm.store)
                }
            });
        }

        function getUsersSellers() {
            UserService.getUsersSellers({ storeId: vm.invoice.storeId }).then(function (response) {
                vm.sellers = response.data;
                vm.searchTextSeller = ''
                vm.selectedSeller = _.find(vm.sellers, function (user) {
                    return user.id === $localStorage.userId;
                });
            });
        }

        function querySearchSellers(query) {
            var results = query ? vm.sellers.filter(createFilterFor(query)) : vm.sellers;
            var defer = $q.defer();
            defer.resolve(results);
            return defer.promise;
        }

        function createFilterFor(query) {
            var lowercaseQuery = query.toLowerCase();

            return function filterFn(seller) {
                return seller.firstName.toLowerCase().indexOf(lowercaseQuery) >= 0
                    || seller.lastName && seller.lastName.toLowerCase().indexOf(lowercaseQuery) >= 0;
            };
        }

        function selectedSellerChange(seller) {
            if (seller) {
                vm.invoice.sellerId = seller.id;
                vm.invoice.sellerName = seller.fullName;
                vm.selectedSeller = seller;
            } else {
                vm.invoice.sellerId = null;
                vm.invoice.sellerName = null;
                vm.selectedSeller = null;
            }
        }

        vm.getTreatedName = function (item) {
            if (item.fullName.length > 20) {
                var treatedlastName = ' ';
                item.lastName.split(' ').forEach(function (lastName) {
                    treatedlastName = treatedlastName.concat(lastName[0]).concat('. ');
                });
                var treatedName = item.firstName + treatedlastName

                return treatedName.toLowerCase().trim().split(' ').map(function (word) {
                    return word[0].toUpperCase() + word.substring(1);
                }).join(" ");
            }

            return item.fullName.toLowerCase().trim().split(' ').map(function (word) {
                return word[0].toUpperCase() + word.substring(1);
            }).join(" ");
        }

        vm.selectedProduct = function (item) {
            if (!item.originalObject.details) {
                for (var i = 0; i < vm.invoice.items.length; i++) {
                    var object = vm.invoice.items[i];
                    if (item.originalObject.id === object.flyer.id) {
                        toastr.warning($translate.instant('invoice.new.messages.product-already-exists'));
                        return;
                    }
                }
            } else if (!item.originalObject.details && item.originalObject.inventory === 0) {
                toastr.warning($translate.instant('invoice.new.messages.product-without-inventory'));
                return;
            }

            vm.invoice.items.push({
                flyer: item.originalObject,
                quantity: 1,
                detail: null
            });
            vm.calculatePrice();
        }

        vm.selectedDiscountCoupon = function (item) {
            if (item && item.originalObject && item.originalObject.code) {
                if (!isDiscountCouponValid(item.originalObject)) {
                    toastr.warning($translate.instant('invoice.new.messages.invalid-discount-coupon'));
                    return;
                }
                vm.invoice.discountCoupon = item.originalObject.code;
                vm.selectedCoupon = item.originalObject;
            } else {
                vm.invoice.discountCoupon = undefined;
                vm.selectedCoupon = undefined;
            }
            vm.calculatePrice();
        }

        function isDiscountCouponValid(item) {
            return item && (!item.hasUsageLimit || !item.couponAvailable || item.couponsAvailable > 0);
        }

        vm.deleteProduct = function (index) {
            vm.invoice.items.splice(index, 1);
            vm.calculatePrice();
        }

        vm.duplicateProduct = function (product) {
            if (!product.details || product.details.length === 0) {
                toastr.warning($translate.instant('invoice.new.messages.product-cant-be-duplicated'));
                return;
            }

            vm.invoice.items.push({
                flyer: product,
                quantity: 1,
                detail: null
            });
        }

        vm.requestParams = function (query) {
            return {
                page: 0,
                size: 10,
                storeId: StoreInfoFactory.getStoreId(),
                search: query
            }
        }

        vm.requestDiscountCouponParams = function (query) {
            return {
                page: 0,
                size: 10,
                name: query,
                code: query,
                enabled: true
            }
        }

        vm.selectedCustomer = function (item) {
            if (item && item.originalObject) {
                vm.invoice.customer = item.originalObject;
            }
        }

        vm.filterSizes = function (details) {
            return details.filter(function (detail) {
                return detail.inventory == null || detail.inventory > 0;
            })
        }

        vm.changeCustomer = function (value) {
            if (vm.invoice.customer && vm.invoice.customer.id) {
                vm.invoice.customer = {
                    fullName: value
                };
            } else if (!vm.invoice.customer.id) {
                vm.invoice.customer.fullName = value;
            }
        }

        vm.updatePurchaseValue = function() {
            vm.purchaseValue = vm.invoice.subTotal + vm.invoice.shippingValue - (vm.invoice.discount ? vm.invoice.discount : 0);
            if (!vm.invoice.subTotal || vm.invoice.subTotal < 0 || !vm.purchaseValue || vm.purchaseValue < 0) {
                vm.purchaseValue = 0;
            }
        }

        vm.calculatePrice = function () {
            if (vm.invoice.items) {
                InvoicesService.calculateDiscount(vm.invoice)
                .then(function (response) {
                    if (response.data) {
                        vm.invoice.discount = response.data;
                    } else {
                        vm.invoice.discount = undefined;
                    }
                    vm.updatePurchaseValue();
                }, function (err) {
                    vm.invoice.discount = undefined;
                    vm.updatePurchaseValue();
                });
                var subTotal = 0;
                angular.forEach(vm.invoice.items, function (item) {
                    if (item.flyer.details && item.flyer.details.length) {
                        if (item.detail) {
                            subTotal += item.quantity * (item.detail.discountedValue ? item.detail.discountedValue : item.detail.purchaseValue);
                        }
                    } else {
                        subTotal += item.quantity * (item.flyer.discountedValue ? item.flyer.discountedValue : item.flyer.purchaseValue);
                    }
                })
                vm.invoice.subTotal = subTotal;
                if (!vm.invoice.shippingValue) {
                    vm.invoice.shippingValue = 0;
                }
                vm.invoice.total = subTotal;
                vm.updatePurchaseValue();
            }
        }

        vm.changeQuantity = function (item, value) {
            verifyQuantityMessage(item, item.quantity + value);
            if (item.quantity + value <= 0) {
                return;
            }

            if (item.flyer.inventory && (item.quantity + value) <= item.flyer.inventory) {
                item.quantity += value;
            }

            if (item.detail && item.detail.inventory) {
                if ((item.quantity + value) <= item.detail.inventory) {
                    item.quantity += value;
                }
            } else if (item.detail && item.detail.inventory == null) {
                item.quantity += value;
            }

            if (item.detail == null && item.flyer.inventory == null && (item.flyer.details && item.flyer.details.length == 0)) {
                item.quantity += value;
            }

            vm.calculatePrice();
        }

        vm.onChangeQuantity = function (item) {
            verifyQuantityMessage(item, item.quantity);
            if (item.quantity < 0) {
                item.quantity = 0;
            } else if (item.detail && (item.quantity === undefined || item.quantity > item.detail.inventory)) {
                item.quantity = item.detail.inventory;
            } else if (!item.detail && item.flyer.inventory && item.flyer.inventory !== 0
                && (item.quantity === undefined || item.quantity > item.flyer.inventory)) {
                item.quantity = item.flyer.inventory;
            }

            vm.calculatePrice();
        }

        vm.save = function () {
            if (hasInvalidItem() || checkInvalidCustomer()) {
                return;
            }

            var request = parseRequest();
            InvoicesService.createInvoice(request)
                .then(function () {
                    toastr.success($translate.instant('invoice.new.messages.invoice-created'));
                    $state.go('invoices')
                })
                .catch(function (err) {
                    toastr.error($translate.instant('invoice.new.messages.error-to-created'));
                });
        }

        vm.checkCEP = function () {
            if (vm.invoice.shippingOption === 'RECEIVE_AT_HOME' && vm.invoice.customer.zipcode && vm.invoice.customer.zipcode.length === 8) {
                CheckCEPService.getAddress(vm.invoice.customer.zipcode).then(function (response) {
                    if (response.data) {
                        vm.invoice.customer.address = response.data.name;
                        vm.invoice.customer.district = response.data.district.name;
                        vm.invoice.customer.city = response.data.location.name;
                        vm.invoice.customer.state = response.data.location.uf;
                    }
                });
            } else {
                vm.invoice.customer.state = null;
            }
        }

        vm.checkIfVariationAlreadyExists = function (item, index) {
            for (var i = 0; i < vm.invoice.items.length; i++) {
                var object = vm.invoice.items[i];
                if (item.flyer.id === object.flyer.id && item.detail.size === object.detail.size && i !== index) {
                    toastr.warning($translate.instant('invoice.new.messages.product-variation-already-exists'));
                    item.detail = undefined;
                    return;
                }
            }
        }

        function verifyQuantityMessage(item, value) {
            if (item.detail && (value === undefined || value > item.detail.inventory)) {
                toastr.warning($translate.instant('invoice.new.messages.limit-amount-reached'));
            } else if (!item.detail && item.flyer.inventory && item.flyer.inventory !== 0
                && (value === undefined || value > item.flyer.inventory)) {
                toastr.warning($translate.instant('invoice.new.messages.limit-amount-reached'));
            }
        }

        function parseRequest() {
            var request = angular.copy(vm.invoice);
            request.customer.phoneNumber = request.customer.phone;
            if (vm.invoice.shippingOption === 'RECEIVE_AT_HOME') {
                request.customer.street = request.customer.address;
                request.customer.streetNumber = request.customer.addressNumber;
                request.customer.zipCode = request.customer.zipcode;
            }

            return request;
        }

        function hasInvalidItem() {
            if (!vm.invoice.items || !vm.invoice.items.length) {
                toastr.warning($translate.instant('invoice.new.messages.select-a-product'));
                return true;
            }

            for (var i = 0; i < vm.invoice.items.length; i++) {
                var item = vm.invoice.items[i];
                if (item.flyer.details && item.flyer.details.length && !item.detail) {
                    toastr.warning($translate.instant('invoice.new.messages.has-product-without-size'));
                    return true;
                }

                if (!item.quantity) {
                    toastr.warning($translate.instant('invoice.new.messages.has-product-without-quantity'));
                    return true;
                }
            }

            return false;
        }

        function checkInvalidCustomer() {
            if (!vm.invoice.customer.id && (!vm.invoice.customer.fullName)) {
                toastr.warning($translate.instant('invoice.new.messages.invalid-customer-full-name'));
                return true;
            }
            
            if (vm.store.hasErp && (!vm.invoice.customer.customerIdentity)) {
                toastr.warning($translate.instant('invoice.new.messages.invalid-customer-document'));
                return true;
            }

            if (!vm.invoice.customer.id && (!vm.invoice.customer.phone)) {
                toastr.warning($translate.instant('invoice.new.messages.invalid-customer-phone'));
                return true;
            }

            if (vm.invoice.shippingOption === 'RECEIVE_AT_HOME' &&
                (!vm.invoice.customer.address || !vm.invoice.customer.zipcode
                    || !vm.invoice.customer.addressNumber || !vm.invoice.customer.district
                    || !vm.invoice.customer.city || !vm.invoice.customer.state)) {
                toastr.warning($translate.instant('invoice.new.messages.invalid-customer-address'));
                return true;
            }

            return false;
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('InvoiceModalDetailController', InvoiceModalDetailController);

    function InvoiceModalDetailController(invoice, userProfile, InvoicesService, $uibModalInstance, toastr, $translate, $localStorage, StoreService) {

        var vm = this;

        init();

        function init() {
            vm.invoice = invoice;
            vm.userProfile = userProfile;
            vm.orders = [];
            vm.discounts = [];
            vm.subTotal = 0;
            vm.discount = 0;
            vm.hasDiscount = false;
            vm.isBrl = false;
            loadStore();
            loadDiscount();
            loadTransactionOrderList(vm.invoice.id)
        }

        function loadDiscount() {
            if (vm.invoice && vm.invoice.discounts) {
                vm.discounts = vm.invoice.discounts.filter(function(item) {
                    return item.discountValueType != 'FREE_SHIPPING';
                });
                vm.discount = vm.invoice.discounts.filter(function(item) {
                        return item.discountValueType != 'FREE_SHIPPING';
                    })
                    .map(function(item) {
                        return item.calculatedDiscountValue;
                    })
                    .reduce(function(a, b) { return a + b},  0);
                vm.hasDiscount = vm.invoice.discounts.filter(function(item) {
                    return item.discountValueType != 'FREE_SHIPPING';
                }).length > 0;
            }
        }

        function loadStore() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
                vm.storeCategory = response.data.categoryKey;
                vm.isBrl = response.data.langKey == 'pt-br';
            });
        }

        function loadTransactionOrderList(transactionId) {
            InvoicesService.getTransactionOrders(transactionId).then(function (result) {
                if (result.data) {
                    for (var i = 0; i < result.data.length; i++) {
                        var order = result.data[i];
                        order.size = order.size ? order.size : 'Padrão';
                        order.size = order.size.toUpperCase() === 'DEFAULT' ? 'Padrão' : order.size;
                        vm.orders.push(order);

                        if(order.discountedValue) {
                            vm.subTotal += (order.discountedValue * order.quantity);
                        } else {
                            vm.subTotal += (order.purchaseValue * order.quantity);
                        }
                    }
                }
            }, function (error) {
                vm.orders = [];
            });
        }

        vm.getPhoneNumber = function (phone) {
            return phone.includes('null') ? phone.split('null')[1] : phone.includes('+') ? phone.split('+')[1] : phone;
        }

        vm.getShippingValue = function() {
            return vm.invoice.shippingValue ? vm.invoice.shippingValue : 0;
        }

        vm.getDocumentType = function () {
            if (!vm.invoice.cpf) {
                return 'CPF';
            }

            return vm.invoice.cpf.length === 11 ? 'CPF' : 'CNPJ';
        }

        vm.printInvoice = function() {
            var idContainer = 'invoice-detail-modal';

            var container = document.getElementById(idContainer).innerHTML,
            screenPrint = window.open('', '_blank', 'width=600,height=600');
            screenPrint.document.write('<!DOCTYPE html>\
            <head>\
                <link rel="stylesheet" type="text/css" href="/content/css/vendor.css" />\
                <link href="https://fonts.googleapis.com/css?family=Roboto:400,300,500,700|Montserrat|Cabin" rel="stylesheet">\
                <link rel="stylesheet" type="text/css" href="/content/css/main.css" />\
                <style>\
                    #btn-actions {display:none;}\
                    @media print {\
                        .text-navy {\
                            color: #2F0E7F !important;\
                            -webkit-print-color-adjust: exact;\
                        }\
                    }\
                    h5, h4, p, table, th, address {\
                        font-size: 12px;\
                    }\
                    .printable-table {\
                        max-height: none !important;\
                    }\
                </style>\
            </head>\
            <body>' + container + '</body>\
            <script>\
                window.print();\
            </script>\
            </html>');
        }

        vm.cancelInvoice = function() {
            vm.isSaving = true;
            InvoicesService.updateTransactionStatus(vm.invoice.id, 'CANCELLED').then(function(result) {
                toastr.success($translate.instant('invoice.home.messages.saveSuccess'));
                vm.isSaving = false;
                $uibModalInstance.close();
            }).catch(function(err) {
                toastr.error($translate.instant('invoice.home.messages.noItens'));
                vm.isSaving = false;
            });
        }

        vm.close = function() {
            $uibModalInstance.close();
        }

        vm.openRefundModal = function() {
            $uibModalInstance.close({ openRefundModal: true, invoice: invoice });
        }

        vm.maskPrice = function (value, currencyKey) {
            var currencyConfiguration = getCurrencyListConfiguration()[currencyKey];
            return formatMoney(value, currencyConfiguration.prefix, currencyConfiguration.decimalQuant, currencyConfiguration.centsSeparator, currencyConfiguration.thousandsSeparator);
        }
    }
  })();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ChatInvoiceNewController', ChatInvoiceNewController);

    function ChatInvoiceNewController(currentCustomer, cartProducts, $q, UserService, StoreInfoFactory, 
        $localStorage, toastr, $translate, $uibModalInstance, $filter, $location, $rootScope,
        InvoicesService, CheckCEPService, StoreService, FlyersService) {

        var vm = this;

        vm.randomTime = new Date().getTime();
        vm.currentCustomer = currentCustomer;
        vm.isBrl = true;

        vm.height = window.innerHeight;
        vm.states = getAllStates();

        function setDynamicDivHeight() {
            vm.height = window.innerHeight;
        }

        window.addEventListener('load', setDynamicDivHeight);
        window.addEventListener('resize', setDynamicDivHeight);

        StoreService.getStore($localStorage.defaultStore.storeId).then(function (response) {
            vm.store = response.data;
            vm.storeCategory = response.data.categoryKey;
        });

        // Auxiliaries for sellers entities
        vm.querySearchSellers = querySearchSellers;
        vm.selectedSellerChange = selectedSellerChange;

        vm.invoice = {
            storeId: StoreInfoFactory.getStoreId(),
            shippingOption: 'PICK_UP_IN_STORE',
            paymentMethod: 'DIRECT_SALE',
            paymentCondition: 'MONEY',
            shippingValue: 0,
            customer: vm.currentCustomer ? vm.currentCustomer : {},
            items: []
        }

        vm.selectedCoupon = undefined;
        vm.purchaseValue = 0;
        vm.currencyPrefix = getCurrencyListConfiguration()['REAL']

        init();

        function init() {
            loadStore();
            getUsersSellers();
            loadCartProducts();
        }

        function loadCurrencyPrefix(store) {
            vm.invoice.currency = store.currency ? store.currency : 'REAL';
            var config = getCurrencyListConfiguration()[vm.invoice.currency];
            vm.currencyPrefix = config.prefix;
        }

        function loadStore() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function (response) {
                if (response && response.data) {
                    vm.store = response.data;
                    vm.storeCategory = response.data.categoryKey;
                    vm.isBrl = response.data.langKey == 'pt-br';
                    loadCurrencyPrefix(vm.store)
                }
            });
        }

        function loadCartProducts() {
            if (!cartProducts || cartProducts.length == 0) {
                return;
            }

            var flyerIds = cartProducts.map(function (product) {
                return getProductIdFromCart(product); 
            });

            FlyersService.findFlyersByIds(flyerIds).then(function (response) {
                if (response && response.data && response.data.length > 0) {
                    cartProducts.forEach(function(product) {
                        var flyerId = product.productRetailerId;
                        if (flyerId.includes('_')) {
                            var parts = flyerId.split('_');
                            var id = parts[0];
                            var size = parts[1];
                            var flyer = getFlyerById(response.data, id);
                            var detail = getDetailBySize(flyer, size);
                            if (flyer) {
                                selectedProductFromFlyer(flyer, detail, product.quantity);
                            }
                        } else {
                            var flyer = getFlyerById(response.data, flyerId);
                            if (flyer) {
                                selectedProductFromFlyer(flyer, null, product.quantity);
                            }
                        }
                    });
                    if (vm.invoice.items.length != cartProducts.length) {
                        toastr.warning($translate.instant('communication.modal-new-order.messages.some-products-not-found'));
                    }
                } else {
                    toastr.warning($translate.instant('communication.modal-new-order.messages.products-not-found'));
                }
            });
        }

        function getProductIdFromCart(product) {
            var id = product.productRetailerId;
            if (id.includes('_')) {
                var parts = id.split('_');
                return parts[0];
            }

            return id; 
        }

        function getFlyerById(flyers, flyerId) {
            if (!flyers || flyers.length == 0 || !flyerId) {
                return null;
            }

            var selecteds = flyers.filter(function (flyer) {
                return flyer.id === flyerId; 
            });

            return selecteds && selecteds.length > 0 ? selecteds[0] : null;
        }

        function getDetailBySize(flyer, size) {
            if (!flyer || !size || !flyer.details || flyer.details.length == 0) {
                return null;
            }

            var selecteds = flyer.details.filter(function (detail) {
                return detail.size === size;
            });
            
            return selecteds && selecteds.length > 0 ? selecteds[0] : null;
        }

        function getUsersSellers() {
            UserService.getUsersSellers({ storeId: vm.invoice.storeId }).then(function (response) {
                vm.sellers = response.data;
                vm.searchTextSeller = ''
                vm.selectedSeller = _.find(vm.sellers, function (user) {
                    return user.id === $localStorage.userId;
                });
            });
        }

        function querySearchSellers(query) {
            var results = query ? vm.sellers.filter(createFilterFor(query)) : vm.sellers;
            var defer = $q.defer();
            defer.resolve(results);
            return defer.promise;
        }

        function createFilterFor(query) {
            var lowercaseQuery = query.toLowerCase();

            return function filterFn(seller) {
                return seller.firstName.toLowerCase().indexOf(lowercaseQuery) >= 0
                    || seller.lastName && seller.lastName.toLowerCase().indexOf(lowercaseQuery) >= 0;
            };
        }

        function selectedSellerChange(seller) {
            if (seller) {
                vm.invoice.sellerId = seller.id;
                vm.invoice.sellerName = seller.fullName;
                vm.selectedSeller = seller;
            } else {
                vm.invoice.sellerId = null;
                vm.invoice.sellerName = null;
                vm.selectedSeller = null;
            }
        }

        vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		}

        vm.getTreatedName = function (item) {
            if (item.fullName.length > 20) {
                var treatedlastName = ' ';
                item.lastName.split(' ').forEach(function (lastName) {
                    treatedlastName = treatedlastName.concat(lastName[0]).concat('. ');
                });
                var treatedName = item.firstName + treatedlastName

                return treatedName.toLowerCase().trim().split(' ').map(function (word) {
                    return word[0].toUpperCase() + word.substring(1);
                }).join(" ");
            }

            return item.fullName.toLowerCase().trim().split(' ').map(function (word) {
                return word[0].toUpperCase() + word.substring(1);
            }).join(" ");
        }

        vm.selectedProduct = function (item) {
            selectedProductFromFlyer(item.originalObject, null, 1);
        }

        vm.selectedDiscountCoupon = function (item) {
            if (item && item.originalObject && item.originalObject.code) {
                if (!isDiscountCouponValid(item.originalObject)) {
                    toastr.warning($translate.instant('communication.modal-new-order.messages.invalid-discount-coupon'));
                    return;
                }
                vm.invoice.discountCoupon = item.originalObject.code;
                vm.selectedCoupon = item.originalObject;
            } else {
                vm.invoice.discountCoupon = undefined;
                vm.selectedCoupon = undefined;
            }
            vm.calculatePrice();
        }

        function isDiscountCouponValid(item) {
            return item && (!item.hasUsageLimit || !item.couponAvailable || item.couponsAvailable > 0);
        }

        vm.deleteProduct = function (index) {
            vm.invoice.items.splice(index, 1);
            vm.calculatePrice();
        }

        vm.duplicateProduct = function (product) {
            if (!product.details || product.details.length === 0) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.product-cant-be-duplicated'));
                return;
            }

            vm.invoice.items.push({
                flyer: product,
                quantity: 1,
                detail: null
            });
        }

        vm.requestParams = function (query) {
            return {
                page: 0,
                size: 10,
                storeId: StoreInfoFactory.getStoreId(),
                search: query
            }
        }

        vm.requestDiscountCouponParams = function (query) {
            return {
                page: 0,
                size: 10,
                name: query,
                code: query,
                enabled: true
            }
        }

        vm.selectedCustomer = function (item) {
            if (item) {
                vm.invoice.customer = item.originalObject;
            }
        }

        vm.filterSizes = function (details) {
            return details.filter(function (detail) {
                return detail.inventory == null || detail.inventory > 0;
            })
        }

        vm.changeCustomer = function (value) {
            if (vm.invoice.customer && vm.invoice.customer.id) {
                vm.invoice.customer = {
                    fullName: value
                };
            } else if (!vm.invoice.customer.id) {
                vm.invoice.customer.fullName = value;
            }
        }

        vm.updatePurchaseValue = function() {
            vm.purchaseValue = vm.invoice.subTotal + vm.invoice.shippingValue - (vm.invoice.discount ? vm.invoice.discount : 0);
            if (!vm.invoice.subTotal || vm.invoice.subTotal < 0 || !vm.purchaseValue || vm.purchaseValue < 0) {
                vm.purchaseValue = 0;
            }
        }

        vm.getItemSubtotal = function(item) {
            var subTotal = 0;
            if (item.flyer.details && item.flyer.details.length) {
                if (item.detail) {
                    subTotal += item.quantity * (item.detail.discountedValue ? item.detail.discountedValue : item.detail.purchaseValue);
                }
            } else {
                subTotal += item.quantity * (item.flyer.discountedValue ? item.flyer.discountedValue : item.flyer.purchaseValue);
            }

            return subTotal;
        }

        vm.getItemPrice = function(item) {
            if (item.flyer.details && item.flyer.details.length) {
                if (item.detail) {
                    return item.detail.discountedValue ? item.detail.discountedValue : item.detail.purchaseValue;
                }
            } else {
                return item.flyer.discountedValue ? item.flyer.discountedValue : item.flyer.purchaseValue;
            }

            return 0;
        }

        vm.calculatePrice = function () {
            if (vm.invoice.items) {
                InvoicesService.calculateDiscount(vm.invoice)
                .then(function (response) {
                    if (response.data) {
                        vm.invoice.discount = response.data;
                    } else {
                        vm.invoice.discount = undefined;
                    }
                    vm.updatePurchaseValue();
                }, function (err) {
                    vm.invoice.discount = undefined;
                    vm.updatePurchaseValue();
                });
                var subTotal = 0;
                angular.forEach(vm.invoice.items, function (item) {
                    if (item.flyer.details && item.flyer.details.length) {
                        if (item.detail) {
                            subTotal += item.quantity * (item.detail.discountedValue ? item.detail.discountedValue : item.detail.purchaseValue);
                        }
                    } else {
                        subTotal += item.quantity * (item.flyer.discountedValue ? item.flyer.discountedValue : item.flyer.purchaseValue);
                    }
                })
                vm.invoice.subTotal = subTotal;
                if (!vm.invoice.shippingValue) {
                    vm.invoice.shippingValue = 0;
                }
                vm.invoice.total = subTotal;
                vm.updatePurchaseValue();
            }
        }

        vm.changeQuantity = function (item, value) {
            verifyQuantityMessage(item, item.quantity + value);
            if (item.quantity + value <= 0) {
                return;
            }

            if (item.flyer.inventory && (item.quantity + value) <= item.flyer.inventory) {
                item.quantity += value;
            }

            if (item.detail && item.detail.inventory) {
                if ((item.quantity + value) <= item.detail.inventory) {
                    item.quantity += value;
                }
            } else if (item.detail && item.detail.inventory == null) {
                item.quantity += value;
            }

            if (item.detail == null && item.flyer.inventory == null && (item.flyer.details && item.flyer.details.length == 0)) {
                item.quantity += value;
            }

            vm.calculatePrice();
        }

        vm.getProductCount = function (item) {
            if (!vm.invoice.items) {
                return 0;
            }
            
            var count = 0;
            
            angular.forEach(vm.invoice.items, function (item) {
                if (item.flyer.details && item.flyer.details.length) {
                    if (item.detail) {
                        count += item.quantity;
                    }
                } else {
                    count += item.quantity;
                }
            })

            return count;
        }

        vm.onChangeQuantity = function (item) {
            verifyQuantityMessage(item, item.quantity);
            if (item.quantity < 0) {
                item.quantity = 0;
            } else if (item.detail && (item.quantity === undefined || item.quantity > item.detail.inventory)) {
                item.quantity = item.detail.inventory;
            } else if (!item.detail && item.flyer.inventory && item.flyer.inventory !== 0
                && (item.quantity === undefined || item.quantity > item.flyer.inventory)) {
                item.quantity = item.flyer.inventory;
            }

            vm.calculatePrice();
        }

        vm.save = function () {
            if (hasInvalidItem() || checkInvalidCustomer()) {
                return;
            }

            var request = parseRequest();
            InvoicesService.createInvoice(request)
                .then(function (response) {
                    if (response && response.data) {
                        vm.transactionId = response.data.id; 
                    }
                    toastr.success($translate.instant('communication.modal-new-order.messages.invoice-created'));
                    $uibModalInstance.close({message: transactionToWhatsAppMessage()});
                })
                .catch(function (err) {
                    toastr.error($translate.instant('communication.modal-new-order.messages.error-to-created'));
                });
        }

        vm.checkCEP = function () {
            if (vm.invoice.shippingOption === 'RECEIVE_AT_HOME' && vm.invoice.customer.zipcode && vm.invoice.customer.zipcode.length === 8) {
                CheckCEPService.getAddress(vm.invoice.customer.zipcode).then(function (response) {
                    if (response.data) {
                        vm.invoice.customer.address = response.data.name;
                        vm.invoice.customer.district = response.data.district.name;
                        vm.invoice.customer.city = response.data.location.name;
                        vm.invoice.customer.state = response.data.location.uf;
                    }
                });
            } else {
                vm.invoice.customer.state = null;
            }
        }

        vm.checkIfVariationAlreadyExists = function (item, index) {
            console.log(item);
            for (var i = 0; i < vm.invoice.items.length; i++) {
                var object = vm.invoice.items[i];
                if (item.flyer.id === object.flyer.id && item.detail.size === object.detail.size && i !== index) {
                    toastr.warning($translate.instant('communication.modal-new-order.messages.product-variation-already-exists'));
                    item.detail = undefined;
                    return;
                }
            }
        }

        function selectedProductFromFlyer(flyer, detail, quantity) {
            if (!flyer.details) {
                for (var i = 0; i < vm.invoice.items.length; i++) {
                    var object = vm.invoice.items[i];
                    if (flyer.id === object.flyer.id) {
                        toastr.warning($translate.instant('communication.modal-new-order.messages.product-already-exists'));
                        return;
                    }
                }
            } else if (!flyer.details && flyer.inventory === 0) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.product-without-inventory'));
                return;
            }

            vm.invoice.items.push({
                flyer: flyer,
                quantity: quantity,
                detail: detail
            });
            vm.calculatePrice();
        }

        function verifyQuantityMessage(item, value) {
            if (item.flyer.details && item.flyer.details.length > 0 && !item.detail) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.select-variation'));
            } else if (item.detail && item.detail.inventory && item.detail.inventory !== 0 && (value === undefined || value > item.detail.inventory)) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.limit-amount-reached'));
            } else if (!item.detail && item.flyer.inventory && item.flyer.inventory !== 0
                && (value === undefined || value > item.flyer.inventory)) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.limit-amount-reached'));
            }
        }

        function parseRequest() {
            var request = angular.copy(vm.invoice);
            request.customer.phoneNumber = request.customer.phone;
            if (vm.invoice.shippingOption === 'RECEIVE_AT_HOME') {
                request.customer.street = request.customer.address;
                request.customer.streetNumber = request.customer.addressNumber;
                request.customer.zipCode = request.customer.zipcode;
            }

            return request;
        }

        function hasInvalidItem() {
            if (!vm.invoice.items || !vm.invoice.items.length) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.select-a-product'));
                return true;
            }

            for (var i = 0; i < vm.invoice.items.length; i++) {
                var item = vm.invoice.items[i];
                if (item.flyer.details && item.flyer.details.length && !item.detail) {
                    toastr.warning($translate.instant('communication.modal-new-order.messages.has-product-without-size'));
                    return true;
                }

                if (!item.quantity) {
                    toastr.warning($translate.instant('communication.modal-new-order.messages.has-product-without-quantity'));
                    return true;
                }
            }

            return false;
        }

        function checkInvalidCustomer() {
            if (!vm.invoice.customer.id && (!vm.invoice.customer.fullName)) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.invalid-customer-full-name'));
                return true;
            }

            if (!vm.invoice.customer.id && (!vm.invoice.customer.phone)) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.invalid-customer-phone'));
                return true;
            }

            if (vm.invoice.shippingOption === 'RECEIVE_AT_HOME' &&
                (!vm.invoice.customer.address || !vm.invoice.customer.zipcode
                    || !vm.invoice.customer.addressNumber || !vm.invoice.customer.district
                    || !vm.invoice.customer.city || !vm.invoice.customer.state)) {
                toastr.warning($translate.instant('communication.modal-new-order.messages.invalid-customer-address'));
                return true;
            }

            return false;
        }

        function transactionToWhatsAppMessage() {
            var orderNumber = vm.transactionId;
            var payment = vm.invoice.paymentCondition == 'MONEY' ? 'Dinheiro/Pix' : 'Cartão';
            var today = new moment().format("DD/MM/YYYY");
            var todayHour = new moment().format("HH:mm:ss");
            var totalPurchase = vm.currencyPrefix + $filter('number')(vm.purchaseValue, 2);
            var products = '';

            for (var i = 0; i < vm.invoice.items.length; i++) {
                var item = vm.invoice.items[i];
                var purchasePrice = $filter('number')(vm.getItemPrice(item), 2);
                var totalPurchasePrice =  $filter('number')(vm.getItemSubtotal(item), 2);
                
                var color = item.color ? " " + item.color : '';
                var size = '';
                if (item.detail && item.detail.size && item.detail.size != 'DEFAULT') {
                    size = " " + item.detail.size;
                }
                var productReference = item.flyer.productReference ? ' - ' + item.flyer.productReference : '';

                products += "▪ " + item.flyer.name + productReference + color + size + "\n   " + item.quantity + " x " + purchasePrice.replace(/\./g, 'D').replace(/,/g, '.').replace(/D/g, ',') + " = *" + totalPurchasePrice.replace(/\./g, 'D').replace(/,/g, '.').replace(/D/g, ',') + "*\n \n";
            }

            var complement = '';
            if (vm.invoice.complement) {
                complement = vm.invoice.complement + ', ';
            }
            var shippingAdress = vm.invoice.customer.address + ', ' + vm.invoice.customer.addressNumber + ', ' + complement + vm.invoice.customer.district + ', ' + vm.invoice.customer.city + ', ' + vm.invoice.customer.state + ', ' + vm.invoice.customer.zipcode;
            var frete = '';
            
            if (vm.invoice.shippingOption == 'PICK_UP_IN_STORE') {
                shippingAdress = 'Retirar na Loja';
            } else if (vm.invoice.shippingValue && vm.invoice.shippingValue > 0) {
                frete = "*Frete:* " + vm.currencyPrefix + " " + vm.invoice.shippingValue + "\n"
            } else if (vm.selectedCoupon.discountType === "FREE_SHIPPING") {
                frete = "*Frete:* Grátis \n"
            } else {
                frete = "*Frete:* A combinar \n"
            }
            
            var subtotal = vm.currencyPrefix + $filter('number')(vm.invoice.subTotal, 2);
            var discount = vm.currencyPrefix + $filter('number')(vm.invoice.discount || 0, 2);
            var whatsAppMessage = '\
🔔 *NOVO PEDIDO - ' + orderNumber + '* \n' + ' \
*Loja:* ' + vm.store.name + '\n \
*Vendedor:* ' + vm.invoice.sellerName + '\n \
........................................................ \n \
👤 *Cliente:* ' + vm.invoice.customer.fullName + ' \n \
📞 *WhatsApp:* ' + (vm.invoice.customer.phone || '-') + ' \n \
........................................................ \n \
🏷 *Produtos* \n\n \
\
' + products + '\n \
\
' + frete + ' \
\
*Subtotal*: ' + subtotal.replace(/D/g, ',') + ' \n \
\
*Desconto*: ' + discount.replace(/D/g, ',') + ' \n \
\
*Total*: ' + totalPurchase.replace(/D/g, ',') + ' \n \
........................................................ \n \
🛵 *Entrega:* ' + shippingAdress + ' \n \
........................................................ \n \
💳 *Forma de pagamento:* ' + payment + ' \n \
 ....................................................... \n \
💬 *Observações:* ' + (vm.invoice.notes || '') + ' \n \
........................................................ \n\n \
\
📆 *' + today + '* às 🕟 *' + todayHour + '*';

            return whatsAppMessage;

        }

    }

})();

(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .controller('StoreTypeModalConstroller', StoreTypeModalConstroller);

    /** @ngInject */
    function StoreTypeModalConstroller(storeType, $uibModalInstance, $scope, HubService, toastr, $translate, moment) {
        var format = 'L';

        var vm = this;


        vm.storeType = storeType || {};
        vm.cancel = cancel;
        vm.init = init;
        vm.save = save;

        function init() {

        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (vm.formAddEditCustomer.$valid) {
                vm.isSaving = true;
                var customerToSave = angular.copy(vm.customer);
                customerToSave.birthdate = customerToSave.birthdate ? moment.utc(customerToSave.birthdate, format).toDate() : undefined;
                customerToSave.storeId = StoreInfoFactory.getStoreId();
                customerToSave.cpf = customerToSave.cpf === "" ? undefined : customerToSave.cpf;

                if (vm.customer.id) {
                    CustomerService.update(customerToSave).then(onSuccess, onError);
                } else {
                    CustomerService.create(customerToSave).then(onSuccess, onError);
                }

                function onSuccess(result) {
                    vm.isSaving = false;
                    $uibModalInstance.close(result);
                }

                function onError(error) {
                    vm.isSaving = false;
                    if (error.data.headers["x-adminapp-params"]) {
                        toastr.error($translate.instant(error.data.headers["x-adminapp-params"].concat(".").concat(error.data.headers["x-adminapp-error"])));
                    } else {
                        toastr.error($translate.instant("global.messages.somethingWrong"));
                    }
                }
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('StoreTypeController', StoreTypeController);

    /** @ngInject */
    function StoreTypeController($rootScope, $scope, HubService, HubModalFactory, toastr, $translate) {

        var vm = this;
        vm.filter = {};
        vm.storeTypes = [];

        vm.originalOrder = [];

        vm.currentPage = 1;
        vm.numPerPage = 10;
        vm.maxSize = 5;
        vm.totalCustomers = 0;

        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        vm.orderedByBirthdayWeek = false;

        vm.showModalAddStoreType = showModalAddStoreType;
        vm.selectStoreType = selectStoreType;

        vm.filterChange = filterChange;

        init();

        function init() {
            listStoreTypes(vm.paginationOptions, vm.filter, true);
        }

        function listStoreTypes() {
            vm.loadingStoreTypes = true;
            HubService.getStoreTypes().then(function (result) {
                vm.storeTypes = result;
                vm.loadingStoreTypes = false;
            }, function (error) {
                vm.loadingStoreTypes = false;
            });
        }

        function showModalAddStoreType() {
            HubModalFactory.addStoreType().then(function (result) {
                toastr.success($translate.instant(result.headers["x-adminapp-alert"]));
                listStoreTypes(vm.paginationOptions, {}, true);
            });
        }

        function selectStoreType(storeType) {

            console.log('StoreType:::', angular.copy(storeType));

            // $rootScope.$broadcast('selectedCustomer', angular.copy(customer));
        }

        function filterChange() {
            vm.currentPage = 1;
            vm.paginationOptions.page = 0;
            listStoreTypes(vm.paginationOptions, vm.filter, true);
        }

        $scope.$on('refreshListCustomer', function (env) {
            listStoreTypes(vm.paginationOptions, vm.filter, false);
        });

        $scope.$on('deletedCustomer', function (env) {
            listStoreTypes(vm.paginationOptions, vm.filter, true);
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('StoreTypeService', StoreTypeService);

    StoreTypeService.$inject = ['StoreTypeFactory'];

    function StoreTypeService(StoreTypeFactory) {
        var service = {
            getAllStoreTypesByOwner: getAllStoreTypesByOwner,
            getAllStoreTypesByToken: getAllStoreTypesByToken
        };

        return service;

        function getAllStoreTypesByOwner() {
            return StoreTypeFactory.getAllStoreTypesByOwner().$promise;
        }

        function getAllStoreTypesByToken(token) {
            return StoreTypeFactory.getAllStoreTypesByToken(token).$promise;
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('StoreTypeFactory', StoreTypeFactory);

        StoreTypeFactory.$inject = ['$resource'];

    function StoreTypeFactory($resource) {
        var resourceUrl =  'admin/api/storetype';

        return $resource(resourceUrl, {}, {
            'getAllStoreTypesByToken': {
                method: 'GET',
                isArray: true,
                url: 'admin/api/storetype/list/by-token'
            },
            'getAllStoreTypesByOwner': {
                method: 'GET',
                isArray: false,
                url: 'admin/api/storetype/list/by-owner',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubShowcasesFlyersController', HubShowcasesFlyersController);

    HubShowcasesFlyersController.$inject = ['$state', '$stateParams', '$q', 'paginationConstants', '$translate',
        'HubFlyersService', 'FlyerCategoryService', 'FlyersCurrencyValue', 'HubShowcasesService', 'toastr', 'BrandService', '$localStorage'];

    function HubShowcasesFlyersController($state, $stateParams, $q, paginationConstants, $translate, HubFlyersService,
                                          FlyerCategoryService, FlyersCurrencyValue, HubShowcasesService, toastr, BrandService, $localStorage) {
        var vm = this;

        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.maxSize = 5;
        vm.totalFlyers = 0;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage
        };

        vm.listFilter = {
            activated: null
        };

        vm.loadFlyers = function (page, reset) {
            loadFlyers();
        };

        vm.inactiveArray = [];

        vm.flyersFiltered = [];
        vm.page = 0;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.hasNextPage = false;
        vm.busy = false;

        vm.brands = [];
        vm.brandGroups = {};
        vm.selectedAll = false;
        vm.sizes = getAllSizes();
        vm.colors = getAllColorsToSearch();
        vm.flyersTypes = [];

        getFlyersTypes();
        loadAll();

        function loadAll() {
            vm.isLoading = true;

            FlyerCategoryService.listCategoriesByCurrentStore($translate.use(), $localStorage.defaultStore.storeId).then(function(response) {
                vm.categories = response.data;
            });

            HubShowcasesService.getShowcase($stateParams.showcaseId, $stateParams.ownerId).then(function(data) {
                vm.showcase = data;
                vm.listFilter.hub = vm.showcase.ownerId;
                BrandService.getBrandsByCurrentStore().then(function(response) {
                    vm.brands = response.data;
                    vm.listFilter.brand = response.data[0].name;
                    loadFlyers();
                });
            });
        }


        vm.reset = function reset() {
            vm.page = 0;
            vm.flyersFiltered = [];
        };

        vm.changePage = function () {
            var begin = ((vm.currentPage - 1) * vm.numPerPage),
            end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            loadFlyers();
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;
        };

        function loadFlyers() {
            if(vm.busy) return;
            vm.busy = true;

            vm.listFilter.type = vm.showcase.userInteract;

            if (!vm.listFilter.color ) {
                delete vm.listFilter.color
            }

            if (!vm.listFilter.categoryKey) {
                delete vm.listFilter.categoryKey
            }

            HubFlyersService.listFlyersFiltered(vm.paginationOptions, vm.listFilter, onSuccess, onError);

            function onSuccess(response, headers) {
                var data = response.data.content;
                vm.busy = false;
                vm.totalFlyers = headers('X-Total-Count');
                vm.flyersFiltered = data.length <= 0 ? [] : data;

                for (var i = 0; i < data.length; i++) {
                    vm.getCategoryName(data[i]);
                }
                vm.isLoading = false;
                reduceFlyersToMap();
                refreshInactiveBoxArray();

                vm.makeBrandGroups();
                vm.refreshFlyersSelected();
            }

            vm.makeBrandGroups = function() {
                vm.brandGroups = {};
                vm.showcase.flyers.forEach(function(flyer) {
                    if(flyer.brand){
                        vm.brandGroups[flyer.brand] = vm.brandGroups[flyer.brand] ? vm.brandGroups[flyer.brand] + 1 : 1;
                    }
                });
            }

            function onError() {
                vm.busy = false;
                toastr.error($translate.instant('flyers.messages.load.error'));
            }
        }

        function refreshInactiveBoxArray(number) {
            vm.flyersStatus = [];
            var qtdActive = vm.showcase.flyers.length;
            for (var i = 0; i < vm.maxFlyersPerShowcase; i++) {
                if (qtdActive >= 1) {
                    vm.flyersStatus.push({
                        status: true
                    });
                } else {
                    vm.flyersStatus.push({
                        status: false
                    });
                }
                qtdActive--;
            }
        }

        function reduceFlyersToMap() {
            var index = 0;
            vm.flyersMap = vm.showcase.flyers.reduce(function(map, flyer) {
                map[flyer.id] = {
                    name: flyer.name,
                    pos: index
                };
                index++;
                return map;
            }, {})
        }

        function getFlyersTypes() {
            HubFlyersService.getFlyerTypes().then(function (response) {
                var removeRent = response.data.map(function(item) { return item.code; }).indexOf('RENT');
                response.data.splice(removeRent, 1);
                var removeContact = response.data.map(function(item) { return item.code; }).indexOf('CONTACT');
                response.data.splice(removeContact, 1);
                vm.flyersTypes = response.data;
            });
        }

        vm.getCountSelectedByBrand = function(brand) {
            return vm.brandGroups[brand];
        };

        vm.tabClick = function(brand){
            vm.loadingTab = true;
            vm.listFilter.brand = brand.name;
            vm.flyersFiltered = [];
            vm.page = 0;
            loadFlyers();
        };

        vm.changeFlyerSelected = function(flyer) {
            if (vm.flyersMap) {
                if (vm.flyersMap[flyer.id]) {
                    vm.showcase.flyers.splice(vm.flyersMap[flyer.id].pos, 1);
                    reduceFlyersToMap();
                } else {
                    flyer.position = vm.showcase.flyers.length + 1;
                    vm.showcase.flyers.splice(0, 0, flyer);
                    reduceFlyersToMap();
                }
            } else {
                vm.showcase.flyers.splice(0, 0, flyer);
                reduceFlyersToMap();
            }
            refreshInactiveBoxArray();
            vm.refreshFlyersSelected()
        };

        vm.refreshFlyersSelected = function() {
            vm.makeBrandGroups();
        };

        vm.getCategoryName = function(flyer) {
            var category = _.find(vm.categories, function(el) {return el.key === flyer.categoryKey});
            if (category) {
                flyer.category = category.title;
            }
        };

        vm.getFlyerCurrency = function(currency) {
            return FlyersCurrencyValue[currency];
        };

        vm.checkFlyerIsSelected = function(flyer) {
            if (vm.flyersMap) {
                return angular.isDefined(vm.flyersMap[flyer.id]);
            }
        };

        vm.hasActiveFilter = function() {
            return vm.listFilter && (vm.listFilter.categoryKey || vm.listFilter.color || vm.listFilter.size
                || vm.listFilter.gender);
        };

        vm.stopPropagation = function(event) {
            event.stopPropagation();
        };

        function checkIsListAll() {
            vm.flyersFiltered = [];
            if (!vm.filters.inactive && !vm.filters.active) {
                vm.listFilter.status = null;
            }
            loadFlyers();

        }

        vm.changeStatusFilterToActive = function() {
            if (vm.filters.active) {
                vm.filters.inactive = false;
                vm.listFilter.status = "ACTIVATED";
            }
            checkIsListAll();
        };

        vm.changeStatusFilterToInactive = function() {
            if (vm.filters.inactive) {
                vm.filters.active = false;
                vm.listFilter.status = "DEACTIVATED";
            }
            checkIsListAll();
        }

        vm.saveShowcase = function(isRedirectToShowcaseScreen) {
            var flyersPosition = [];
            vm.showcase.flyers.forEach(function (flyer) {
                flyersPosition.push({
                    flyerId: flyer.id,
                    position: flyer.position
                });
            });
            vm.showcase.flyers = flyersPosition;
            $q.all(vm.showcase.flyers).then(function() {
                HubShowcasesService.updateShowcase(vm.showcase).then(function(data) {
                    if (isRedirectToShowcaseScreen) {
                        $state.go('hub-showcases.edit', {
                            showcaseId: data.id
                        });
                    }
                });
            });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubShowcasesDetailController', HubShowcasesDetailController);

    /** @ngInject */
    function HubShowcasesDetailController($state, $timeout, $stateParams, $q, $window, $localStorage,
                                          $scope, $translate, FlyersService, FlyersCurrencyValue, HubFlyersService,
                                          HubShowcasesService, toastr, UserInteractModalFactory, ModalFactory) {

        var vm = this;
        var userInteractModal;
        var ownerId = $localStorage.hub.id;
        var mainColor = getComputedStyle(document.documentElement).getPropertyValue('--main-color');
        vm.showcaseId = $stateParams.showcaseId;

        vm.showcase = {
            backgroundColor: false,
            flyers: [],
            ownerId: null,
            hasCover: false,
            userInteract: "SALE"
        };

        vm.listFilter = {
            storeId: ownerId,
            activated: null,
            type: null
        };


        vm.openShowcaseModalType = openShowcaseModalType;

        vm.imageSize = 800;
        vm.coverEdit = true;
        vm.isSaving = false;
        vm.showcaseColors = [
            [{
                color: "#201E1E",
                border: 0
            }, {
                color: "#363231",
                border: 0
            }, {
                color: "#4B4544",
                border: 0
            }, {
                color: "#870200",
                border: 0
            }, {
                color: "#05a19c",
                border: 0
            }, {
                color: "#37003C",
                border: 0
            }, {
                color: "#5A1846",
                border: 0
            }, {
                color: "#910D3F",
                border: 0
            }, {
                color: "#C70039",
                border: 0
            }, {
                color: "#263545",
                border: 0
            }],
            [{
                color: "#002A4A",
                border: 0
            }, {
                color: "#01201B",
                border: 0
            }, {
                color: "#015146",
                border: 0
            }, {
                color: "#1A5B28",
                border: 0
            }, {
                color: "#277B25",
                border: 0
            }, {
                color: "#331908",
                border: 0
            }, {
                color: "#D35400",
                border: 0
            }, {
                color: "#DF7F05",
                border: 0
            }, {
                color: "#2F0E7F",
                border: 0
            }]
        ];

        loadAll();

        vm.goToSettings = function () {
            $state.go('settings');
        }

        function loadAll() {
            if (vm.showcaseId) {
                loadShowcase();
            } else {
                vm.showcase.ownerId = ownerId;
                vm.showcase.backgroundColor = mainColor;
            }
        }

        function loadShowcase() {
            return HubShowcasesService.getShowcase(vm.showcaseId, ownerId).then(function (response) {
                vm.showcase = response;
                vm.showcase.userInteract = vm.originalUserInteract ? vm.originalUserInteract : vm.showcase.userInteract;
                if (vm.showcase.hasCover) {
                    createCroppieStatic();
                    loadImageToCroppieByURL();
                }
                loadShowcasesFlyers();
            });
        }

        vm.checkFlyerIsSelected = function (id) {
            if (vm.flyersMap) {
                return angular.isDefined(vm.flyersMap[id]);
            }
        };

        vm.changeFlyerSelected = function (flyer) {
            if (vm.flyersMap) {
                if (vm.flyersMap[flyer.id]) {
                    vm.showcase.flyers.splice(vm.flyersMap[flyer.id].pos, 1);
                    loadShowcasesFlyers();
                } else {
                    vm.showcase.flyers.splice(0, 0, flyer);
                    loadShowcasesFlyers();
                }
            } else {
                vm.showcase.flyers.splice(0, 0, flyer);
                loadShowcasesFlyers();
            }
        };

        function loadShowcasesFlyers() {
            if (vm.showcase.flyers) {
                vm.flyerId = 0;
                vm.showcase.flyers.forEach(function (flyer) {
                    vm.getCategoryName(flyer);
                    var random = new Date().getTime();
                    flyer.imagePath = '/flyer/api/' + flyer.id + '/hub-picture?type=large&ts=' + random;
                });
            }
        }

        function openShowcaseModalType() {
            userInteractModal = UserInteractModalFactory.selectUserInterectType(null, vm.showcase.userInteract, 'hub-showcases');
            userInteractModal.result.then(function (userInteract) {

                vm.originalUserInteract = angular.copy(vm.showcase.userInteract);
                vm.showcase.userInteract = userInteract;

                vm.listFilter.type = vm.showcase.userInteract;
                if (!(vm.originalUserInteract && vm.originalUserInteract === vm.showcase.userInteract)) {
                    vm.flyersInfo = null;
                    vm.flyersFiltered = [];
                    vm.flyersMap = undefined;
                    vm.showcase.flyers = [];
                    loadShowcasesFlyers();
                }
            });
        }

        vm.getShowcasesFlyer = function () {
            vm.saveFlyer(true);
        }

        vm.goToFlyerByShowcase = function () {
            if (vm.showcase && vm.showcase.id) {
                vm.preSaveFlyer(true);
            } else {
                vm.saveFlyer(true);
            }
        }

        vm.preSaveFlyer = function (isToRedirect) {
            if (vm.showcase && vm.showcase.id) {
                return HubShowcasesService.getShowcase(vm.showcase.id, ownerId).then(
                    function (response) {
                        vm._showcase = response;

                        var isAfter = moment(vm._showcase.updatedAt).isAfter(moment(vm.showcase.updatedAt)); // true

                        if (isAfter) {
                            ModalFactory.openSimpleModal(
                                "ATENÇÃO!",
                                "Identificamos alterações recentes na vitrine que você está prestes a alterar, deseja realmente confirmar suas alterações e descartar a versão anteriormente criada?",
                                "Confirmar",
                                "Cancelar",
                                function () {
                                    return vm.saveFlyer(isToRedirect);
                                }
                            );
                        } else {
                            vm.saveFlyer(isToRedirect);
                        }
                    }
                );
            } else {
                vm.saveFlyer();
            }
        };

        vm.saveFlyer = function (isRedirectToFlyersScreen, callback, isSaving) {
            vm.isSaving = angular.isUndefined(isSaving) ? true : isSaving;
            vm.showcase.cover = "";
            vm.saveCover(function () {
                var flyers = angular.copy(vm.showcase.flyers);
                var flyersPosition = [];
                vm.showcase.flyers.forEach(function (flyer, index) {
                    flyersPosition.push({
                        flyerId: flyer.id,
                        position: index + 1
                    });
                });
                vm.showcase.flyers = flyersPosition;
                $q.all(vm.showcase.flyers).then(function (data) {
                    if (vm.showcaseId) {
                        HubShowcasesService.updateShowcase(vm.showcase).then(function (data) {
                            vm.showcase = data;

                            if (isRedirectToFlyersScreen) {
                                $state.go('hub-showcases-flyers', {
                                    showcaseId: data.id,
                                    ownerId: data.ownerId
                                });
                            } else {
                                toastr.success($translate.instant('showcases.messages.update.success'));
                                vm.isSaving = false;
                                // Follow the instruction of Jackson, when saves the showcase the state doesn't need to be changed
                                // $state.go('showcases');
                            }
                            if (callback) {
                                callback(true);
                            }
                            vm.showcase.flyers = flyers;

                        }, function (data) {
                            if (isRedirectToFlyersScreen) {
                                toastr.error($translate.instant('showcases.messages.update.error'));
                                vm.isSaving = false;
                            }
                        });
                    } else {
                        HubShowcasesService.saveShowcase(vm.showcase).then(function (data) {
                            vm.isSaving = false;
                            vm.showcase = data;
                            if (isRedirectToFlyersScreen) {
                                $state.go('hub-showcases-flyers', {
                                    showcaseId: data.id,
                                    ownerId: data.ownerId
                                });
                            } else {
                                toastr.success($translate.instant('showcases.messages.create.success'));
                                // Follow the instruction of Jackson, when saves the showcase the state doesn't need to be changed
                                // $state.go('showcases');
                            }
                            if (callback) {
                                callback(true);
                                vm.isSaving = false;
                            }
                            vm.showcase.flyers = flyers;
                        }, function (data) {
                            vm.isSaving = false;
                            if (isRedirectToFlyersScreen) {
                                toastr.error($translate.instant('showcases.messages.create.error'));
                            }
                        });
                    }
                });
            });
        }

        vm.setBackgroundColor = function (color) {
            vm.showcase.backgroundColor = color;
        }

        vm.getCategoryName = function (flyer) {
            var category = _.find(vm.categories, function (el) {
                return el.key === flyer.categoryKey
            });
            if (category) {
                flyer.category = category.title;
            }
        }

        vm.getFlyerCurrency = function (currency) {
            return FlyersCurrencyValue[currency];
        }

        vm.getBackgroundImg = function (flyerId) {
            return ('\'/flyer/api/' + flyerId + '/picture\'');
        }

        vm.openModalConfirmCatalogChange = function (showcaseId) {
            ModalFactory.openModal(null,
                $translate.instant('showcases.messages.publish.msgModal'),
                null,
                null, $translate.instant('showcases.home.buttons.publishShowcase'),
                $translate.instant('showcases.home.buttons.no'), function () {
                    vm.publishShowcase(showcaseId);
                },
                null, null, 'icon-warning', null, null, null, null, null, {'font-size': '1.6em'}, true);
        }

        vm.openInput = function (evt) {
            document.getElementById('fileInput').click();
        }

        function createCroppie() {
            if (!vm.basic) {
                var cover = document.getElementById('cover_image_id');
                cover.setAttribute('crossOrigin', 'anonymous');
                vm.basic = new Croppie(cover, {
                    viewport: {
                        width: '100%',
                        height: parseInt(window.innerHeight * 0.38)
                    },
                    boundary: {
                        width: '100%',
                        height: parseInt(window.innerHeight * 0.38)
                    },
                    showZoomer: false,
                    enableResize: false,
                    enableOrientation: true
                });
            }
        }

        function createCroppieStatic() {
            if (!vm.basic) {
                var cover = document.getElementById('cover_image_id');
                cover.setAttribute('crossOrigin', 'anonymous');
                vm.basic = new Croppie(cover, {
                    viewport: {
                        width: '100%',
                        height: parseInt(window.innerHeight * 0.38)
                    },
                    boundary: {
                        width: '100%',
                        height: parseInt(window.innerHeight * 0.38)
                    },
                    showZoomer: false,
                    enableResize: false,
                    enableOrientation: false,
					mouseWheelZoom: false
                });
            }
        }

        function loadImageToCroppieByURLCanvas(canvasURL) {
            var urlRefresh = canvasURL;
            vm.basic.bind({
                crossOrigin: "anonymous",
                url: urlRefresh
            });
            vm.coverEdit = false;
			vm.saveImageCover = true;
        }

        function loadImageToCroppieByURL() {
            var urlRefresh = '/flyer/api/'+ vm.showcaseId +'/hubCover?type=x_large&t=' + new Date().getTime();
            vm.basic.bind({
                crossOrigin: "anonymous",
                url: urlRefresh
            });
            vm.coverEdit = false;
			vm.saveImageCover = false;
        }

        function loadImageToCroppieByBase64(showcaseImage) {
            vm.basic.bind({
                crossOrigin: "anonymous",
                url: showcaseImage
            });
            vm.coverEdit = false;
			vm.saveImageCover = true;
	    }

        var handleFileSelect = function (evt) {

            createCroppie();

            var file = evt.currentTarget.files[0];
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    vm.imageUpload = evt.target.result;
                    loadImageToCroppieByBase64(evt.target.result);
                });
            };
            reader.readAsDataURL(file);
        };


        vm.initShowcase = function () {
            angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
        };

        vm.saveCover = function (callback) {
            if (!vm.coverEdit && vm.saveImageCover) {
                vm.basic.result({type: 'blob', size:'original', quality: 1}).then(function (blob) {
                    FlyersService.saveFlyerImage(blob).then(function (response) {
                        $timeout(function () {
                            vm.showcase.addImageFileDTO = response.data;
                            if (vm.showcase.addImageFileDTO) {
                                vm.showcase.hasCover = true;
                                callback();
                            } else {
                                toastr.error($translate.instant('flyers.messages.create.error'));
                            }
                            vm.loadingImage = false;
                        });
                    }, function (response) {
                        toastr.error($translate.instant('flyers.messages.create.image.uploadError'));
                        vm.loadingImage = false;
                    });
                });
            } else {
                if (callback) {
                    callback();
                }
            }
        }

        $scope.$on("$destroy", function () {
            if (!angular.isUndefined(userInteractModal)) {
                userInteractModal.close();
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hub-showcases', {
                parent: 'admin',
                url: '/hub-showcases',
                data: {
                    authorities: ['ADMIN_HUB'],
                    pageTitle: 'showcases.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/showcases/hub-showcases.html',
                        controller: 'HubShowcasesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('store-management');
                        return $translate.refresh();
                    }]

                }
            })
            .state('hub-showcases.new', {
                parent: 'hub-showcases',
                url: '/new',
                data: {
                    authorities: ['ADMIN_HUB'],
                    pageTitle: 'showcases.detail.title',
                    specialClass: "md-skin fixed-nav"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/showcases/hub-showcases-detail.html',
                        controller: 'HubShowcasesDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]

                }
            })
            .state('hub-showcases.edit', {
                parent: 'hub-showcases',
                url: '/{showcaseId}',
                data: {
                    authorities: ['ADMIN_HUB'],
                    pageTitle: 'showcases.detail.title',
                    specialClass: "md-skin fixed-nav"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/showcases/hub-showcases-detail.html',
                        controller: 'HubShowcasesDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]

                }
            })
            .state('hub-showcases-flyers', {
                parent: 'hub-showcases',
                url: '/{showcaseId}/flyers',
                data: {
                    authorities: ['ADMIN_HUB'],
                    pageTitle: 'showcases.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/showcases/hub-showcases-flyers.html',
                        controller: 'HubShowcasesFlyersController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    flyersId: null,
                    ownerId: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]

                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('HubShowcasesService', HubShowcasesService);

    HubShowcasesService.$inject = ['HubShowcasesFactory'];

    function HubShowcasesService(HubShowcasesFactory) {

        var service = {
            listShowcases: listShowcases,
            getShowcase: getShowcase,
            saveShowcase: saveShowcase,
            updateShowcase: updateShowcase,
            deleteShowcases: deleteShowcases,
        };

        return service;

        function saveShowcase(showcase) {
            return HubShowcasesFactory.save(showcase).$promise;
        }

        function updateShowcase(showcase) {
            return HubShowcasesFactory.update(showcase).$promise;
        }

        function listShowcases(filter) {
            return HubShowcasesFactory.listAll(filter).$promise;
        }

        function getShowcase(id, ownerId) {
            return HubShowcasesFactory.get({
                id: id,
                ownerId: ownerId
            }).$promise;
        }

        function deleteShowcases(showcaseIds) {
            return HubShowcasesFactory.deletebyids({
                showcaseIds: showcaseIds
            }).$promise;
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('HubShowcasesFactory', HubShowcasesFactory);

    HubShowcasesFactory.$inject = ['$resource'];

    function HubShowcasesFactory($resource) {
        var resourceUrl = 'flyer/api/hub-showcase/:id';

        return $resource(resourceUrl, {}, {
            'get': {},
            'listAll': {
                method: 'POST',
                url: 'flyer/api/hub-showcase/list',
                transformResponse: transformResponse
            },
            'update': {
                method: 'PUT'
            },
            'deletebyids': {
                method: 'POST',
                url: '/flyer/api/hub-showcase/deleteByIds'
            }
        });

        function transformResponse(data, headers) {
            var response = {};
            response.data = angular.fromJson(data);
            response.headers = headers();
            return response;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubShowcasesController', HubShowcasesController);


    /** @ngInject */
    function HubShowcasesController($window, $state, RemoveModalFactory, $localStorage, $translate, StoreService,
                                 HubShowcasesService, toastr) {

        var vm = this;

        vm.listFilter = {
            ownerId: $localStorage.hub.id,
            name: ''
        };

        vm.hasntStoreYet = !$localStorage.hub.id;

        vm.isPublishing = false;

        vm.showcases = [];
        vm.showcasesToRemove = [];
        vm.userHasShowcases = false;

        vm.store = $localStorage.defaultStore;

        vm.loadShowcases = function() {
            if (vm.listFilter.ownerId) {
                vm.isLoading = true;
                HubShowcasesService.listShowcases(vm.listFilter)
                    .then(function (result) {
                        vm.showcases = result.data;
                        vm.isLoading = false;
                        vm.userHasShowcases = vm.showcases.length >= 1
                    }, function () {
                        vm.isLoading = false;
                    });
            } else {
                vm.hasntStoreYet = true;
                vm.isLoading = false;
            }
        }

        vm.loadShowcases();

        vm.getEditPage = function (showcaseId) {
            $state.go('hub-showcases.edit', {
                showcaseId: showcaseId
            });
        }

        vm.updateShowcasesToRemove = function (showcaseId) {
            if (vm.showcasesToRemove.indexOf(showcaseId) !== -1) {
                vm.showcasesToRemove.splice(vm.showcasesToRemove.indexOf(showcaseId), 1);
            } else {
                vm.showcasesToRemove.push(showcaseId);
            }
        }

        vm.checkIfShowcaseSelected = function (showcaseId) {
            return vm.showcasesToRemove.indexOf(showcaseId) > -1;
        }

        vm.removeShowcases = function () {
            if (vm.showcasesToRemove.length >= 1) {
                RemoveModalFactory.deleteItem(vm.showcasesToRemove.length).then(function (data) {
                    HubShowcasesService.deleteShowcases(vm.showcasesToRemove).then(function (data) {
                        toastr.success($translate.instant('showcases.messages.remove.success'));
                        vm.showcasesToRemove = [];
                        vm.listFilter.name = '';
                        vm.loadShowcases();
                    }, function () {
                        toastr.error($translate.instant('showcases.messages.remove.error'));
                    });
                });
            } else {
                toastr.error($translate.instant('showcases.messages.remove.noItens'));
            }
        }

        vm.getImageSrc = function (showcaseId) {
            return "content/images/templates/" + showcaseId + ".png"
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hub-management', {
                parent: 'admin',
                url: '/hub-management',
                data: {
                    authorities: ['STORE_READ'],
                    pageTitle: 'global.hub.stores-hub'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/hub-management.html',
                        controller: 'HubManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('settings');
                        return $translate.refresh();
                    }]
                }
            })
            .state('store-type', {
                parent: 'hub-management',
                url: '/store-type',
                data: {
                    authorities: ['STORE_READ', 'ADMIN_MANAGE_SYSTEM'],
                    pageTitle: 'store-management.detail.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/store-type/store-type-list.html',
                        controller: 'StoreTypeController',
                        controllerAs: 'vm'
                    }
                },
                // params: {
                //     storeId: null
                // },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('profile');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
            // .state('store-detail', {
            //     parent: 'store-management',
            //     url: '^/store/detail',
            //     data: {
            //         authorities: ['STORE_READ'],
            //         pageTitle: 'store-management.detail.title'
            //     },
            //     params: {
            //         fromStep: null
            //     },
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/admin/store-management/store-management-detail.html',
            //             controller: 'StoreManagementDetailController',
            //             controllerAs: 'vm'
            //         }
            //     },
            //     resolve: {
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('store-management');
            //             $translatePartialLoader.addPart('user-management');
            //             $translatePartialLoader.addPart('profile');
            //             return $translate.refresh();
            //         }],
            //         stateParams: ['$stateParams', '$localStorage', function($stateParams, $localStorage) {
            //             $stateParams.id = $localStorage.defaultStore.storeId;
            //             return $stateParams;
            //         }]
            //     }
            // })
            // .state('store-management.addsalespoint', {
            //     url: '/newsalespoint',
            //     data: {
            //         pageTitle: 'store-management.new.title',
            //         authorities: ['STORE_UPDATE']
            //     },
            //     onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            //         $uibModal.open({
            //             templateUrl: 'app/admin/store-management/store-management-newsalespoint.html',
            //             controller: 'AddSalesPointManagementController',
            //             controllerAs: 'vm',
            //             backdrop: 'static',
            //             size: 'md',
            //             resolve: {}
            //         });
            //     }],
            //     resolve: {
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('store-management');
            //             return $translate.refresh();
            //         }]

            //     }
            // })
            // .state('store-management.new', {
            //     url: '/new',
            //     data: {
            //         pageTitle: 'store-management.new.title',
            //         authorities: ['STORE_CREATE']
            //     },
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/admin/store-management/store-management-new.html',
            //             controller: 'StoreManagementNewController',
            //             controllerAs: 'vm'
            //         }
            //     },
            //     resolve: {
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('store-management');
            //             $translatePartialLoader.addPart('global');
            //             return $translate.refresh();
            //         }]
            //     }
            // })
            // .state('store-profile-detail', {
            //     parent: 'store-detail',
            //     url: '^/perfil/{id}',
            //     data: {
            //         authorities: ['STORE_READ_PROFILE'],
            //         pageTitle: 'showcaseApp.profile.detail.title'
            //     },
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/entities/profile/profile-management-detail.html',
            //             controller: 'ProfileDetailController',
            //             controllerAs: 'vm'
            //         }
            //     },
            //     params: {
            //         'storeId': {
            //             value: null
            //         }
            //     },
            //     resolve: {
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('profile');
            //             return $translate.refresh();
            //         }],
            //         previousState: ["$state", function($state) {
            //             var currentStateData = {
            //                 name: $state.current.name || 'profile-management',
            //                 params: $state.params,
            //                 url: $state.href($state.current.name, $state.params)
            //             };
            //             return currentStateData;
            //         }]
            //     }
            // });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubManagementController', HubManagementController);

    function HubManagementController($localStorage, Auth, $q, $translate,  $state, CategoryService, FlyersService, HubService,
        paginationConstants, $timeout, Principal, $location) {
        var vm = this;
        vm.searchFilter = {};
        vm.displayTypeList = ["Cards", "Table"];
        vm.displayTypeListCheck = [];
        vm.selectedStoreList = [];
        vm.storesDataFiltered = [];
        vm.storesData = [];
        vm.categories = [];
        vm.storesToRemove = 0;
        vm.loadingArray = ["1", "2", "3", "4"];
        vm.isLoading = true;
        vm.changeSession = changeSession;
        vm.hub;
        vm.page = 0;
        vm.itemsPerPage = paginationConstants.itemsPerPage - 10;
        vm.hasNextPage = false;
        vm.busy = false;
        loadAll();

        vm.checkType = function(type) {
            vm.createArray("displayType", vm.displayTypeList.length, false);
            vm.displayTypeListCheck[vm.displayTypeList.indexOf(type)] = true;
            vm.displayType = type;
        }

        vm.checkDisplayType = function(type) {
            return (vm.displayType === type);
        }

        vm.isEven = function(number) {
            return (number % 2 == 0);
        };

        vm.changeType = function() {
            vm.displayType = vm.displayType === 'Cards' ? 'Table' : 'Cards';
        };

        vm.stopPropagation = function(event) {
            event.stopPropagation();
        };

        vm.createArray = function(type, number, value, array) {
            if (type === "displayType") {
                vm.displayTypeListCheck = [];
                for (var i = 0; i < number; i++) {
                    vm.displayTypeListCheck.push(value);
                }
            }
        }

        vm.reloadStores = function(page, reset) {
            if(reset) {
                vm.page = 0;
                vm.storesData = [];
            }else {
                vm.page = page;
            }
            loadStores();
        }

        vm.reset = function reset() {
            vm.page = 0;
            vm.flyersFiltered = [];
        };

        vm.storeDetailsPage = function(storeId) {
            $state.go('store-management-detail', {
                id: storeId
            });
        }

        vm.checkStoreClickAction = function(storeId) {
            if ($localStorage.defaultStore.storeId == 0) {
                vm.storeDetailsPage(storeId);
            } else {
                vm.changeSession(storeId)
            }
        }

        vm.loadStoreImage = function(store) {
            var random = new Date().getTime();
            store.image = undefined;
            $timeout(function() {
                store.image = (store.storeLogo + '?r=' + random);
            }, 1000);
        }

        function changeSession(storeId) {
            Auth.changeSession(storeId).then(
                function() {
                    $state.transitionTo('home', {}, {
                        reload: true,
                        inherit: false,
                        notify: true
                    });

                    // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                    // since login is successful, go to stored previousState and clear previousState
                    if (Auth.getPreviousState()) {
                        var previousState = Auth.getPreviousState();
                        Auth.resetPreviousState();
                        $state.go(previousState.name, previousState.params);
                    }
                });
        }

        function loadAll() {
            loadStores();
            loadCategories();
            loadHub();
        }

        function loadHub() {
            vm.hub = $localStorage.hub;
        }

        function loadCategories() {
            CategoryService.listCategories($translate.use()).then(function(response) {
                vm.categories = response.data;
            });
        }

        function loadCategoriesName() {
            vm.storesDataFiltered.forEach(function(store) {
                CategoryService.getCategoryTitleByKey(store.categoryKey, $translate.use()).then(function(response) {
                    store.categoryName = response.data;
                });
            });
        }

        function loadNumberOfFlyers() {
            vm.storesDataFiltered.forEach(function(store) {
                FlyersService.getNumberOfFlyers(store.id, $translate.use()).then(function(response) {
                    store.numberOfFlyers = response.data;
                });
            });
        }


        function loadStores() {
            if(vm.busy) return;
            vm.busy = true;
            vm.searchFilter.hub = true;
            var pageable = {
                page: vm.page,
                size: vm.itemsPerPage,
                name: vm.searchFilter.name
            };

            HubService.getStores(pageable, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.hasNextPage = headers('X-Has-Next-Page') === "true";
                for (var i = 0; i < data.length; i++) {
                    if ($localStorage.userId != data[i].ownerId) {
                        vm.loadStoreImage(data[i]);
                        vm.storesData.push(data[i]);
                    }
                }
                vm.storesDataFiltered = vm.storesData;
                $q.all(vm.storesDataFiltered).then(function() {
                    vm.displayType = vm.storesDataFiltered.length > 1 ? 'Cards' : 'Table';
                    loadCategoriesName();
                    loadNumberOfFlyers();
                    vm.isLoading = false;
                });

                vm.busy = false;
            }

            function onError() {
                vm.busy = false;
            }
        }

        vm.getHubSharedLink = function () {
            return $location.protocol() + '://' + $location.host() + '/direct-register\?' + 'client='+vm.hub.token;;
        }

        vm.share = function () {
            var text_to_share = vm.getHubSharedLink();

            // create temp element
            var copyElement = document.createElement("span");
            copyElement.appendChild(document.createTextNode(text_to_share));
            copyElement.id = 'tempCopyToClipboard';
            angular.element(document.body.append(copyElement));

            // select the text
            var range = document.createRange();
            range.selectNode(copyElement);
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);

            // copy & cleanup
            document.execCommand('copy');
            window.getSelection().removeAllRanges();
            copyElement.remove();
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('HubService', HubService);

    HubService.$inject = ['HubFactory'];

    function HubService(HubFactory) {
        var service = {
            getStores: getStores,
            getStoreTypes: getStoreTypes,
            getHubByOwner: getHubByOwner,
            migrateFlyersToStores: migrateFlyersToStores,
            migrateFlyersToStoresByStoreType: migrateFlyersToStoresByStoreType,
			getHubByStoreId: getHubByStoreId
        };

        return service;

        function getStores(params,  pageable, onSuccess, onError) {
            return HubFactory.getStores(params, pageable, onSuccess, onError);
        }

        function getStoreTypes() {
            return HubFactory.getStoreTypes().$promise;
        }

        function getHubByOwner(id) {
            return HubFactory.getHubByOwner({id: id}).$promise;
        }

        function migrateFlyersToStores(ids, stores) {
            return HubFactory.migrateFlyersToStores({flyerIds: ids, stores: stores}).$promise;
        }

        function migrateFlyersToStoresByStoreType(ids, storeTypeId) {
            return HubFactory.migrateFlyersToStores({flyerIds: ids, storeTypeId: storeTypeId}).$promise;
        }

        function getHubByStoreId(id) {
            return HubFactory.getHubByStoreId({id: id}).$promise;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('HubModalFactory', HubModalFactory);

    /** @ngInject */
    function HubModalFactory($uibModal) {

        var factory = {
            addStoreType: addStoreType,
            editStoreType: editStoreType,
            deleteStoreType: deleteStoreType
        }

        return factory;

        function addStoreType() {
            return showAddEditStoreType();
        }

        function editStoreType(storeType) {
            return showAddEditStoreType(storeType);
        }

        function deleteStoreType(customer) {
            //TODO
        }

        function showAddEditStoreType(storeType) {
            return $uibModal.open({
                templateUrl: "app/admin/hub-management/modal-add-edit-store-type.html",
                size: 'lg',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                resolve: {
                    customer: function () {
                        return angular.copy(storeType);
                    }
                },
                controller: "StoreTypeModalConstroller",
                controllerAs: "vm"
            }).result;
        }

        function showDeleteModal(fullName) {
            return $uibModal.open({
                templateUrl: "app/admin/customer/_modal_delete_customer.html",
                size: 'md',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                resolve: {
                    fullName: function () {
                        return fullName;
                    }
                },
                controller: function ($uibModalInstance, fullName) {
                    var vm = this;
                    vm.fullName = fullName;
                    vm.cancel = cancel;
                    vm.ok = ok;

                    function cancel() {
                        $uibModalInstance.dismiss('cancel');
                    }

                    function ok() {
                        $uibModalInstance.close(true);
                    }
                },
                controllerAs: "vm"
            }).result;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('HubFactory', HubFactory);

    HubFactory.$inject = ['$resource'];

    function HubFactory($resource) {
        var resourceUrl =  'api/hub';
        return $resource(resourceUrl, {}, {
            'migrateFlyersToStores': {
                method: 'POST',
                url: 'flyer/api/hub-flyer/migrate'
            },
            'query': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getHubByOwner': {
                method: 'GET',
                url: 'admin/api/hub/owner/:id',
                transformResponse: function (data, headers) {
                    return  angular.fromJson(data);
                }
            },
            'deletebyids': {
                method: 'POST',
                url: '/api/store/deletebyids'
            },
            'getStores': {
                method: 'GET',
                url: 'admin/api/hub/stores',
                isArray: true
            },
            'getStoreTypes': {
                method: 'GET',
                url: 'admin/api/storetype/list',
                isArray: true
            },
            'saveRedirectDomains': {
                method: 'POST',
                url: '/admin/api/store/save-url-domains',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'saveStoreAnalytics': {
                method: 'POST',
                url: '/admin/api/store/save-store-analytics',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getMyStores': {
                url: '/api/store/my',
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getMyAllStores': {
                url: '/admin/api/store/list-all',
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'update': { method:'PUT' },
            'delete': { method:'DELETE' },
            'getHubByStoreId': {
                method: 'GET',
                url: 'admin/api/hub/store/:id',
                transformResponse: function (data, headers) {
                    return  angular.fromJson(data);
                }
            }
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("HubFlyerImportController", HubFlyerImportController);

    /** @ngInject */
    function HubFlyerImportController($scope, Upload, toastr, $translate, HubFlyersService, $localStorage, $interval, $window) {
        var vm = this;

        vm.file = null;
        vm.isLoading = false;
        vm.isUploading = false;
        vm.flyerAttributes = [
            "ean",
            "productReference",
            "name",
            "description",
            "gender",
            "brand",
            "category",
            "color",
            "size",
            "productPrice",
            "promotionalPrice",
            "qttPerPerson",
            "inventory",
            "height",
            "width",
            "length",
            "weight",
            "measureList",
            "imageUrl1",
            "imageUrl2",
            "imageUrl3",
            "imageUrl4",
            "demoVideo"
        ];

        vm.hubId = $localStorage.hub.id;

        vm.currentStep = 1;

        vm.gotoStep = function(step) {
            if (((step === 2 || step === 3) && !vm.file) || vm.isUploading) {
                return;
            }
            if (step === 3) {
                if (!requiredFieldsHaveBeenSelected()) {
                    return;
                }
                getPreview();
            }
            vm.currentStep = step;
        };

        vm.loadFile = function (file, errFiles) {
            vm.file = file;
            vm.errFiles = errFiles && errFiles[0];
            vm.isLoading = true;
            vm.importResult = null;
            vm.errorSummary = null;

            if (vm.errFiles) {
                vm.isLoading = false;
                if (errFiles[0].$error == "pattern") {
                    toastr.error($translate.instant("flyers.import.error.invalidType"));
                    return;
                }
            }

            if (file) {
                vm.currentStep = 2;

                var fileReader = new FileReader();
                fileReader.onload = function() {
                    this.arrayBuffer = fileReader.result;
                    var data = new Uint8Array(this.arrayBuffer);
                    var arr = new Array();
                    for (var i = 0; i != data.length; ++i)
                        arr[i] = String.fromCharCode(data[i]);
                    var bstr = arr.join("");
                    var workbook = XLSX.read(bstr, {
                        type: "binary", sheetRows: 4
                    });
                    var first_sheet_name = workbook.SheetNames[0];
                    var worksheet = workbook.Sheets[first_sheet_name];

                    vm.headers = getHeaderRow(worksheet);

                    var sheetsList = workbook.SheetNames;
                    vm.sheetData = XLSX.utils.sheet_to_json(
                        workbook.Sheets[sheetsList[0]],
                        {
                            header: 1,
                            defval: "",
                            blankrows: true
                        }
                    );

                    vm.isLoading = false;

                    $scope.$apply();
                };
                fileReader.readAsArrayBuffer(file);
            } else {
                vm.isLoading = false;
            }
        };

        function getHeaderRow(sheet) {
            var headers = [];
            var range = XLSX.utils.decode_range(sheet["!ref"]);
            var C,
                R = range.s.r; /* start in the first row */
            /* walk every column in the range */
            for (C = range.s.c; C <= range.e.c; ++C) {
                var cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]; /* find the cell in the first row */
                var hdr = "UNKNOWN " + C; // <-- replace with your desired default
                if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);

                headers.push({ column: numToSSColumn(C + 1), key: hdr, value: "NULL" });
            }
            return headers;
        }

        vm.uploadFile = function () {
            if (vm.file) {
                vm.isUploading = true;

                vm.file.upload = Upload.upload({
                    url: 'flyer/api/hub-flyer/hub/' + vm.hubId + '/import-flyers-from-table?headers=' + getHeadersStringList(),
                    data: {
                        file: vm.file
                    }
                });

                vm.file.upload.then(function (response) {
                    if (response.data) {
                        var interval = $interval(function () {
                            HubFlyersService.flyersImportStatus(response.data.id)
                                .then(function (response) {
                                    var data = JSON.parse(response.data)
                                    if (data.status === 'FINISHED') {
                                        $interval.cancel(interval);
                                        vm.isUploading = false;
                                        toastr.success($translate.instant('flyers.import.statusSuccessfulDescription'));
                                        vm.currentStep = 1;
                                        vm.file = null;
                                    } else if (data.status === 'IN_PROGRESS') {
                                        $interval.cancel(interval);
                                        vm.isUploading = false;
                                        toastr.success($translate.instant('flyers.import.successfullyImport'));
                                        vm.currentStep = 1;
                                        vm.file = null;
                                    } else if (data.status === 'FAILED') {
                                        $interval.cancel(interval);
                                        errorOnFileUploadOrSaveImport('flyers.import.error.errorOnSaveImport');
                                        vm.importResult = data;

                                        getErrorSummary();
                                    }
                                }, function (data) {
                                    $interval.cancel(interval);
                                    errorOnFileUploadOrSaveImport('flyers.import.error.errorOnSaveImport');
                                })
                                .catch(function (err) {
                                    $interval.cancel(interval);
                                    errorOnFileUploadOrSaveImport('flyers.import.error.errorOnSaveImport');
                                });
                        }, 5000);

                    } else {
                        errorOnFileUploadOrSaveImport('flyers.import.error.errorOnUploadFile');
                    }

                }, function (response) {
                    errorOnFileUploadOrSaveImport('flyers.import.error.errorOnUploadFile');
                });
            }
        }

        vm.cancel = function () {
            vm.file = null;
        }

        function errorOnFileUploadOrSaveImport(error) {
            toastr.error($translate.instant(error));
            vm.isUploading = false;
        }

        function getHeadersList() {
            return vm.headers.map(function (item) {
                return item.value;
            });
        }

        function getHeadersStringList() {
            return getHeadersList().join();
        }

        vm.getXlsxResult = function () {
            var fileExt = '.xlsx';
            var fileName = vm.importResult.id + fileExt;
            var header = vm.flyerAttributes.concat(["errors"]);

            var details = JSON.parse(JSON.stringify(vm.importResult.details));

            if (!details) {
                return;    
            }

            // translate errors
            details.forEach(function (product) {
                var errors = product.errors.map(function (error) {
                    return $translate.instant('flyers.import.error.' + error);
                }).join(' | ');
                product.errors = errors;
            });

            var workbook = XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(details, { header: header });

            var range = XLSX.utils.decode_range(worksheet['!ref']);

            // translate header
            for (var C = range.s.c; C <= range.e.c; ++C) {
                var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
                if (!worksheet[address]) continue;
                worksheet[address].v = $translate.instant('flyers.import.column.' + worksheet[address].v);
            }

            var wscols = [];
            for (var i = 0; i < header.length; i++) {  // columns length added
                wscols.push({ wch: 15 })
            }
            wscols[wscols.length - 1] = { wch: 80 };
            worksheet["!cols"] = wscols;

            XLSX.utils.book_append_sheet(workbook, worksheet, 'tab1');
            XLSX.writeFile(workbook, fileName, { compression: true });
        }

        vm.changeHeaderValue = function(header) {
            vm.errorSummary = null;
            if (header.value === '') {
                header.value = 'NULL';
            } else {
                vm.headers.forEach(function (item) {
                    if (header.key !== item.key && header.value === item.value) {
                        header.value = 'NULL';
                        toastr.warning($translate.instant('flyers.import.error.repeatedColumn'));
                    } 
                });
            }
        }

        function numToSSColumn(num) {
            var s = '', t;

            while (num > 0) {
                t = (num - 1) % 26;
                s = String.fromCharCode(65 + t) + s;
                num = (num - t) / 26 | 0;
            }
            return s || undefined;
        }

        function getSelectedHeaders() {
            return vm.headers.filter(function (item) {
                return item.value !== 'NULL';
            });
        }

        function getPreview() {
            if (!vm.sheetData) {
                return;
            }
            var data = [];
            var headers = vm.headers.map(function (item) {
                return item.value !== 'NULL' ? $translate.instant('flyers.import.column.' + item.value) : item.value;
            });

            for (var i = 1; i < vm.sheetData.length; i++) {
                var result = [];
                for (var j = 0; j < headers.length; j++) {
                    var value = vm.sheetData[i][j];
                    if (headers[j] !== 'NULL') {
                        result.push(value);
                    }
                }
                data.push(result);
            }
            var headersPreview = headers.filter(function (header) {
                return header !== 'NULL'; 
            })

            vm.importPreview = {
                headers: headersPreview,
                data: data
            }
        }

       function getErrorSummary() {
            vm.errorSummary = [];

            if (vm.importResult && vm.importResult.details) {
                vm.importResult.details.forEach(function (product) {
                    product.errors.forEach(function (error) {
                        if (!vm.errorSummary.includes(error)) {
                            vm.errorSummary.push(error)
                        }
                    });
                });
            }
        }

        function requiredFieldsHaveBeenSelected() {
            var eanOrProductReference = false;
            var otherField = false;
            getSelectedHeaders().forEach(function (header) {
                if (header.value === "ean" || header.value === "productReference") {
                    eanOrProductReference = true;
                } else if (header.value !== "size") {
                    otherField = true;
                }
            });
            
            if (!eanOrProductReference) {
                toastr.warning($translate.instant('flyers.import.error.notAllowedNullableProductReferenceOrEan'));
            } else if (!otherField) {
                toastr.warning($translate.instant('flyers.import.error.noColumn'));
            }

            return eanOrProductReference && otherField;
        }

        vm.getDownloadLinkToTemplate = function () {
            return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/template-import-products.xlsx';
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("HubFlyersNewController", HubFlyersNewController);

    function HubFlyersNewController(
        $translate,
        $timeout,
        $scope,
        FlyerCategoryService,
        StoreService,
        HubFlyersService,
        $localStorage,
        $q,
        $state,
        toastr,
        moment,
        BrandService,
		$rootScope
    ) {
        var format = "L LT";
        var FORMAT_DATE = "L";
        // Beginning of the day
        var CURRENT_DAY = moment().startOf("day");

        var vm = this;

        StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
            vm.storeCategory = response.data.categoryKey;
        });

        vm.userInteracts = ["COUPON", "RENT", "CONTACT", "SALE"];
        vm.transactionalUserInteractions = ["RENT", "SALE"];
        vm.disabledCurrency = false;

        vm.currencyConfigurations = getCurrencyListConfiguration();

        vm.options = {
            fullscreenControl: false
        };
        vm.brands = [];
        vm.colors = getAllColors();
        vm.sizes = getAllSizes();

        vm.flyer = {
            image: null,
            discountPercentageValue: undefined,
            currency: "REAL",
            currencyInstance: vm.currencyConfigurations.REAL,
            discountType: "DISCOUNT_FIXED",
            sizes: [],
            tags: [],
            isLaunch: false,
            isBasic: true
        };

        const MAX_IMAGESIZE = 10240;

        vm.onValidityTypeDateChange = function(checked) {
            if (checked) {
                angular
                    .element("#expirationDateTime")
                    .data("DateTimePicker")
                    .clear();
            }
        };

        vm.onImmediateAvailability = function() {
            if (vm.checks.immediateAvailability) {
                vm.flyerSecondForm.startDate.$setValidity("minDate", true);
                angular
                    .element("#startDateTime")
                    .data("DateTimePicker")
                    .clear();
            }
        };

        vm.onChangeCategory = function() {
            vm.fullCategory = vm.categories.find(function(category) {
                return category.key === vm.flyer.categoryKey;
            });
        }

        vm.mainMap = {
            center: {
                latitude: 0,
                longitude: 0
            },
            zoom: 10,
            controls: {},
            bounds: {}
        };
        vm.tabsState = [{
                active: true
            },
            {
                active: false
            },
            {
                active: false
            }
        ];
        vm.actualTab = 0;
        vm.imageSize = 400;
        vm.mainMap.window = {
            model: {},
            show: false,
            options: {
                pixelOffset: {
                    width: -1,
                    height: -65
                }
            },
            closeClick: function() {
                this.show = false;
            }
        };
        vm.mainMap.markers = [];
        vm.checkBoxControl = [];
        vm.checks = {
            validityTypeDate: true,
            validityTypeNumber: true,
            usageLimitByUser: true,
            immediateAvailability: true
        };
        vm.flyerImage = "";
        vm.isOpenCalendarStart = false;
        vm.isOpenCalendarExpire = false;
        vm.startDateSelected = false;
        vm.showMap = false;
        vm.allSelected = false;
        vm.isSaving = false;
        vm.showExpirateDate = true;
        vm.imageChanged = false;
        vm.firstFormSubmitted = false;
        vm.loadingImage = false;

        const ICON_ACTIVE = "https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/pointactive.png";
        const ICON_INACTIVE = "content/images/pointinactive.png";

        vm.formatMoney = function(value, currencySymbol) {
            return formatMoney(
                value,
                currencySymbol,
                vm.flyer.currencyInstance.decimalQuant,
                vm.flyer.currencyInstance.centsSeparator,
                vm.flyer.currencyInstance.thousandsSeparator
            );
        };

        vm.getCurrencySymbol = function() {
            return JSON.parse(vm.flyer.currencyMethod);
        };

        vm.openInput = function(evt) {
            document.getElementById("fileInput").click();
        };

        vm.getHowMuchIsSaving = function() {
            if (vm.flyer.discountType == "DISCOUNT_PERCENTAGE") {
                if (vm.flyer.discountPercentageValue) {
                    return vm.flyer.discountPercentageValue.toFixed(1);
                }
            } else if (vm.flyer.discountType == "DISCOUNT_FIXED") {
                if (vm.flyer.discountValue && vm.flyer.purchaseValue) {
                    return (
                        (vm.flyer.discountValue * 100) /
                        vm.flyer.purchaseValue
                    ).toFixed(1);
                }
            }
        };

        vm.getDiscountedValueByDiscountType = function(
            value,
            discountType,
            discountValue
        ) {
            if (discountType == "DISCOUNT_PERCENTAGE") {
                discountValue =
                    vm.flyer.discountPercentageValue || discountValue;
                if (!discountValue) return value;
                return value - value * ((discountValue || 100) * 0.01);
            } else if (discountType == "DISCOUNT_FIXED") {
                discountValue = vm.flyer.discountValue;
                return value - (discountValue || 0);
            }
        };

        vm.getDiscountValueByDiscountType = function(
            value,
            discountType,
            discountValue
        ) {
            if (discountType == "DISCOUNT_PERCENTAGE") {
                discountValue =
                    vm.flyer.discountPercentageValue || discountValue;
                return value * ((discountValue || 100) * 0.01);
            } else if (discountType == "DISCOUNT_FIXED") {
                discountValue = vm.flyer.discountValue || discountValue;
                return discountValue;
            }
        };

        vm.isToDisplayMe = function(value) {
            return value == vm.flyer.discountType;
        };

        var handleFileSelect = function(evt) {
            var file = evt.currentTarget.files[0];
            if (file.size / 1024 > MAX_IMAGESIZE) {
                toastr.error(
                    $translate.instant("flyers.messages.create.image.sizeError")
                );
            } else {
                var reader = new FileReader();
                reader.onload = function(evt) {
                    $scope.$apply(function() {
                        vm.imageUpload = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            }
        };

        vm.activeImageCrop = function() {
            $timeout(function() {
                if ($("canvas")) {
                    $("canvas").click();
                }
            }, 100);
        };

        vm.startClosed = function() {
            vm.startDateSelected = true;
        };

        vm.changeExpireDate = function(value) {
            vm.isSelectExpireDate = value;
        };

        vm.firstZoom = true;

        $scope.$watch("vm.mainMap.zoom", function(newVal) {
            if (newVal > 16 && vm.firstZoom) {
                vm.mainMap.zoom = 16;
                vm.firstZoom = false;
            }
        });

        vm.reopen = false;

        vm.checkIfSizeSelected = function(size) {
            return vm.flyer.sizes.includes(size);
        }

        vm.updateSizeOrRemove = function(size) {
            var isSelected = vm.flyer.sizes.includes(size);
            if (isSelected) {
                vm.flyer.sizes = vm.flyer.sizes.filter(function(item) {
                    return item !== size;
                });
            } else {
                vm.flyer.sizes.push(size);
            }
        }

        vm.checkIfLaunchSelected = function() {
            return vm.flyer.isLaunch;
        }

        vm.updateLaunchOrRemove = function() {
            vm.flyer.isLaunch = !vm.flyer.isLaunch;
        }

        vm.checkIfBasicSelected = function() {
            return vm.flyer.isBasic;
        }

        vm.updateBasicOrRemove = function() {
            vm.flyer.isBasic = !vm.flyer.isBasic;
        }

        vm.saveFlyer = function() {
            if (!vm.isSaving) {
                vm.isSaving = true;
                vm.flyer.purchaseValue =
                    vm.flyer.purchaseValue === 0 ?
                    null :
                    vm.flyer.purchaseValue;
                vm.flyer.discountValue =
                    vm.flyer.discountValue === 0 ?
                    null :
                    vm.flyer.discountValue;
                var flyerToSave = angular.copy(vm.flyer);
                flyerToSave.startDate = moment(
                    flyerToSave.startDate,
                    format
                ).toDate();
                flyerToSave.expirationDate = flyerToSave.expirationDate ?
                    moment(flyerToSave.expirationDate, format).toDate() :
                    undefined;
                vm.existsSalesPoint = false;
                flyerToSave.validityTypeDate = !vm.checks["validityTypeDate"];
                flyerToSave.validityTypeNumber = !vm.checks[
                    "validityTypeNumber"
                ];
                flyerToSave.usageLimitByUser = !vm.checks["usageLimitByUser"];
                flyerToSave.immediateAvailability =
                    vm.checks["immediateAvailability"];
                flyerToSave.hub = $localStorage.hub.id;
                flyerToSave.salesPoint = [];
                flyerToSave.discountValue =
                    flyerToSave.discountValue ||
                    flyerToSave.discountPercentageValue;
                flyerToSave.currency = vm.flyer.currencyInstance.key;
                flyerToSave.gender = parseInt(vm.flyer.gender);
                flyerToSave.brand = vm.flyer.brand;
                flyerToSave.color = vm.flyer.color;
                flyerToSave.sizes = vm.flyer.sizes;
                flyerToSave.tags = vm.flyer.tags.map(function(tag) {
                    return tag['text'];
                });
                flyerToSave.productReference = vm.flyer.productReference;
                flyerToSave.isLaunch = vm.flyer.isLaunch;
                flyerToSave.isBasic = vm.flyer.isBasic;

                var blob = dataURItoBlob(vm.flyerImage);
                HubFlyersService.saveFlyerImage(blob).then(
                    function(response) {
                        $timeout(function() {
                            vm.flyer.addImageFileDTO = response.data;
                            flyerToSave.addImageFileDTO = response.data;
                            if (vm.flyer.addImageFileDTO) {
                                HubFlyersService.createFlyer(flyerToSave).then(
                                    function(data) {
                                        $state.go("hub-flyers", {
                                            type: flyerToSave.type
                                        });
                                        toastr.success(
                                            $translate.instant(
                                                "flyers.messages.create.success"
                                            )
                                        );
                                        vm.isSaving = false;
                                    },
                                    function(error) {
                                        vm.flyer.startDate = moment(
                                            vm.flyer.startDate
                                        ).format(format);
                                        vm.flyer.expirationDate = vm.flyer
                                            .expirationDate ?
                                            moment(
                                                vm.flyer.expirationDate
                                            ).format(format) :
                                            undefined;
                                        vm.isSaving = false;
                                        toastr.error(
                                            $translate.instant(
                                                "flyers.messages.create.error"
                                            )
                                        );
                                    }
                                );
                            } else {
                                toastr.error(
                                    $translate.instant(
                                        "flyers.messages.create.error"
                                    )
                                );
                            }
                            vm.loadingImage = false;
                        }, 3000);
                    },
                    function(response) {
                        toastr.error(
                            $translate.instant(
                                "flyers.messages.create.image.uploadError"
                            )
                        );
                        vm.loadingImage = false;
                    }
                );
            }
        };

        vm.mainMap.markerEvents = {
            dragend: function(marker, eventName, model) {
                vm.refreshMapWithCoordinates(
                    marker.position.lat(),
                    marker.position.lng()
                );
            },
            mouseover: function(marker, eventName, model, args) {
                vm.mainMap.window.model = model;
                vm.mainMap.window.show = true;
            },
            mouseout: function(marker, eventName, model, args) {
                vm.mainMap.window.show = false;
            },
            click: function(marker, eventName, model, args) {
                for (var i = 0; i < vm.mainMap.markers.length; i++) {
                    if (vm.mainMap.markers[i].id == marker.key) {
                        if (vm.mainMap.markers[i].clicked) {
                            vm.mainMap.markers[i].options.icon = ICON_INACTIVE;
                            vm.mainMap.markers[i].clicked = false;
                        } else {
                            vm.mainMap.markers[i].options.icon = ICON_ACTIVE;
                            vm.mainMap.markers[i].clicked = true;
                        }
                    }
                }
            }
        };

        vm.checkAllMarkers = function() {
            vm.allSelected = !vm.allSelected;
            var icon;
            if (vm.allSelected) {
                icon = ICON_ACTIVE;
            } else {
                icon = ICON_INACTIVE;
            }
            for (var i = 0; i < vm.mainMap.markers.length; i++) {
                vm.mainMap.markers[i].options.icon = icon;
                vm.mainMap.markers[i].clicked = vm.allSelected;
            }
        };

        vm.typeChanged = function() {
            if (vm.flyer.type == "RENT") {
                vm.flyer.maxUsageByUser = 1;
                vm.flyer.maxUsages = 1;
                vm.checks["usageLimitByUser"] = false;
                vm.checks["validityTypeNumber"] = false;
                vm.checks["validityTypeDate"] = true;
            } else {
                vm.flyer.maxUsageByUser = undefined;
                vm.flyer.maxUsages = undefined;
                vm.checks["usageLimitByUser"] = true;
                vm.checks["validityTypeNumber"] = true;
            }

            vm.flyer.bulkQuantity = null;
            vm.flyer.discountBulkPercentage = null;

            if (vm.transactionalUserInteractions.includes(vm.flyer.type)) {
                vm.flyer.currency = "REAL";
                vm.flyer.currencyInstance = vm.currencyConfigurations.REAL;
                vm.disabledCurrency = true;
            } else {
                vm.disabledCurrency = false;
            }
        };

        function checkExpirationDate() {
            if (vm.flyer.expirationDate) {
                if (
                    moment(vm.flyer.startDate, format).isSameOrAfter(
                        moment(vm.flyer.expirationDate, format)
                    )
                ) {
                    /** returns false if the expirationDate is before startDate */
                    return false;
                }
                /** returns true if the expirationDate is ok (the expirationDate is after startDate) */
                return true;
            }
        }

        vm.changeToTab = function(tab) {
            if (tab === 1) {
                vm.activeImageCrop();
                vm.firstFormSubmitted = true;
                if (!vm.flyerFirstForm.$invalid) {
                    vm.tabsState[tab].active = true;
                    vm.actualTab = tab;
                }
            } else if (tab === 2) {
                if (vm.flyerImage) {
                    vm.loadingImage = true;
                    vm.secondFormSubmitted = true;
                    var expirationDateStatus = checkExpirationDate();
                    if (expirationDateStatus == false) {
                        vm.tabsState[1].active = true;
                        vm.actualTab = 1;
                        toastr.warning(
                            $translate.instant(
                                "error.flyerStartDateGreaterThanOrEqualsToExpirationDate"
                            )
                        );
                        return;
                    }
                    if (vm.flyerSecondForm.$valid) {
                        vm.uploadImage(vm.flyerImage, function(data) {
                            vm.loadingImage = false;
                            vm.tabsState[tab].active = true;
                            vm.actualTab = tab;
                            $timeout(function() {
                                vm.showMap = false;
                                $timeout(function() {
                                    vm.showMap = true;
                                }, 300);
                            }, 100);
                        });
                    } else {
                        vm.loadingImage = false;
                    }
                }
            }
        };

        vm.uploadImage = function(file, callback) {
            var blob = dataURItoBlob(file);
            HubFlyersService.saveFlyerImage(blob).then(
                function(response) {
                    $timeout(function() {
                        vm.flyer.addImageFileDTO = response.data;
                        if (vm.flyer.addImageFileDTO) {
                            callback();
                        } else {
                            toastr.error(
                                $translate.instant(
                                    "flyers.messages.create.error"
                                )
                            );
                        }
                        vm.loadingImage = false;
                    });
                },
                function(response) {
                    toastr.error(
                        $translate.instant(
                            "flyers.messages.create.image.uploadError"
                        )
                    );
                    vm.loadingImage = false;
                }
            );
        };

        vm.imageIsLoaded = function(e) {
            $scope.$apply(function() {
                vm.flyer.imagePath = e.target.result;
            });
        };

        vm.getFlyerPrice = function() {
            if (vm.flyer.discountType === "DISCOUNT_PERCENTAGE") {
                return (
                    (vm.flyer.purchaseValue ? vm.flyer.purchaseValue : 0) -
                    (vm.flyer.purchaseValue ?
                        vm.flyer.purchaseValue *
                        (vm.flyer.discountValue ?
                            vm.flyer.discountValue / 100 :
                            0) :
                        0)
                );
            } else {
                return vm.flyer.purchaseValue && vm.flyer.discountValue ?
                    vm.flyer.purchaseValue -
                    (vm.flyer.discountValue ? vm.flyer.discountValue : 0) :
                    vm.flyer.purchaseValue;
            }
        };

        vm.checkDiscountType = function() {
            if (vm.flyer.discountValue && !vm.flyer.discountType) {
                vm.flyer.discountType = "DISCOUNT_FIXED";
            }
            if (vm.flyer.discountType === "DISCOUNT_FIXED") {
                vm.flyer.discountPercentageValue = undefined;
                vm.flyerFirstForm.discountValue.$setValidity("max", true);
                if (
                    parseFloat(vm.flyer.discountValue) >
                    parseFloat(vm.flyer.purchaseValue)
                ) {
                    vm.flyerFirstForm.discountValue.$setValidity(
                        "discountGreaterThanValue",
                        false
                    );
                } else {
                    vm.flyerFirstForm.discountValue.$setValidity(
                        "discountGreaterThanValue",
                        true
                    );
                }
            } else {
                vm.flyer.discountValue = undefined;
            }
        };

        function convertToMarkers(points) {
            points.forEach(function(point) {
                vm.mainMap.markers.push({
                    pointlocation: {
                        name: point.name,
                        country: point.country,
                        state: point.state,
                        neighborhood: point.neighborhood,
                        number: point.number,
                        address: point.address,
                        city: point.city,
                        salesPointId: point.id,
                        postalCode: point.postalCode,
                        contactPhone: point.contactPhone,
                        storeId: vm.store
                    },
                    latitude: point.coordinate.latitude,
                    longitude: point.coordinate.longitude,
                    id: point.id,
                    clicked: false,
                    options: {
                        icon: ICON_INACTIVE
                    }
                });
            });
        }

        function loadAll() {
            loadBrands();
            FlyerCategoryService.listCategories($translate.use()).then(function(
                response
            ) {
                vm.categories = response.data;
                vm.fullCategory = vm.categories[0];
                vm.flyer.categoryKey = vm.categories[0].key;
                vm.activeImageCrop();
                vm.initSecondTab();
                vm.changeToTab(1);
                vm.changeToTab(2);
            });

            StoreService.getSalesPoints(
                $localStorage.defaultStore.storeId
            ).then(function(response) {
                convertToMarkers(response.data);
            });
        }

        function loadBrands() {
            BrandService.getBrandsByCurrentStore().then(function(response) {
                vm.brands = response.data;
            });
        }

        function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(",")[0].indexOf("base64") >= 0)
                byteString = atob(dataURI.split(",")[1]);
            else byteString = unescape(dataURI.split(",")[1]);

            var mimeString = dataURI
                .split(",")[0]
                .split(":")[1]
                .split(";")[0];

            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {
                type: mimeString
            });
        }

        vm.initSecondTab = function() {
            dateTimePicker();
            angular
                .element(document.querySelector("#fileInput"))
                .on("change", handleFileSelect);
        };

        loadAll();

        function dateTimePicker() {
            vm.startDateOptions = {
                format: format,
                sideBySide: true,
                ignoreReadonly: true,
                locale: moment.locale(),
                // minDate: CURRENT_DAY,
                allowInputToggle: true
            };

            vm.expireDateOptions = {
                format: format,
                sideBySide: true,
                ignoreReadonly: true,
                minDate: moment(),
                locale: moment.locale(),
                allowInputToggle: true,
                useCurrent: false
            };

            angular
                .element("#startDateTime")
                .datetimepicker(vm.startDateOptions)
                .on("dp.change", function(ev) {
                    if (ev.date) {
                        vm.flyer.startDate = ev.date.format(format);
                        if (vm.flyer.expirationDate && !checkExpirationDate()) {
                            vm.flyer.expirationDate = undefined;
                            angular
                                .element("#expirationDateTime")
                                .data("DateTimePicker")
                                .minDate(ev.date || moment());
                        } else {
                            angular
                                .element("#expirationDateTime")
                                .data("DateTimePicker")
                                .minDate(moment());
                        }
                        $scope.$apply(function() {
                            vm.flyerSecondForm.startDate.$setValidity(
                                "minDate",
                                true
                            );
                        });
                    } else {
                        vm.flyer.startDate = undefined;
                    }
                });

            angular
                .element("#expirationDateTime")
                .datetimepicker(vm.expireDateOptions)
                .on("dp.change", function(ev) {
                    if (ev.date) {
                        vm.flyer.expirationDate = ev.date.format(format);
                        $scope.$apply(function() {
                            vm.flyerSecondForm.expirationDate.$setValidity(
                                "required",
                                true
                            );
                        });
                    } else {
                        vm.flyer.expirationDate = undefined;
                    }
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubFlyersFormController', HubFlyersFormController);

    function HubFlyersFormController($translate, $timeout, $scope, $localStorage, $q, $state, $uibModal, $stateParams, toastr, moment,
                                  FlyerCategoryService, StoreService, FlyersService, HubFlyersService, BrandService, $rootScope) {

        const MAX_IMAGE_SIZE = 10240;
        const ICON_ACTIVE = 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/pointactive.png';
        const ICON_INACTIVE = 'content/images/pointinactive.png';
        const DATE_FORMAT = 'L LT';
        const now = moment(moment(), DATE_FORMAT).toDate();
        const SRC_IMAGE_DEFAULT = 'content/images/1-image-default-product.png';
        const SRC_IMAGE_DETAIL_DEFAULT = 'content/images/2-image-default-product_mini.png';

        StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
            vm.storeCategory = response.data.categoryKey;
        });

        var vm = this;

        vm.isEdit = false;
        vm.isLoading = true;
        vm.currencyConfigurations = getCurrencyListConfiguration();
        vm.transactionalUserInteractions = ["RENT", "SALE"];
        vm.colors = getAllColors();

        vm.enableMeasures = false;
        vm.enableDimension = false;
        vm.measureList = []
        vm.enableDemoVideo = false;
        vm.srcImgDefault = SRC_IMAGE_DEFAULT;
		vm.srcImgDetailDefault = SRC_IMAGE_DETAIL_DEFAULT;
        vm.imgsFlyers = [
            {
                id: '1',
                src: vm.srcImgDefault,
                isDefault: true,
                isThumbnail: false
            },
            {
                id: '2',
                src: vm.srcImgDefault,
                isDefault: true,
                isThumbnail: false
            },
            {
                id: '3',
                src: vm.srcImgDefault,
                isDefault: true,
                isThumbnail: false
            },
            {
                id: '4',
                src: vm.srcImgDefault,
                isDefault: true,
                isThumbnail: false
            }
        ]

        if ($stateParams.id) {
            vm.isEdit = true;
            loadFlyer($stateParams.id);
        } else {
            loadData();
        }
        $scope.sortableOptions = {
            update: function (e, ui) {
                //if (vm.getCountDefaultImageFlyer() > 0) {
                    vm.moveImageFlyerToFirstIndex();
                //}
            }
        };

        $scope.$watch(function () {
            return document.getElementById("content").clientWidth;
        }, function (newVal, oldVal) {
            if (!document.getElementById('brand'))
                return;
            if ((newVal - oldVal) > 20 || (oldVal - newVal) > 20) {
                var autoChild = document.getElementById('brand').firstElementChild;
                var el = angular.element(autoChild);
                el.scope().$mdAutocompleteCtrl.hidden = true;
            }
        });

        // Auxiliaries for brand entities
        vm.querySearchBrand     = querySearchBrand;
        vm.selectedBrandChange  = selectedBrandChange;
        vm.brands               = [];

        vm.imageSize = 600;
        vm.flyerImage = '';
        vm.firstZoom = true;
        vm.isSaving = false;
        vm.selectedSizes = [];

        vm.enableTags = false;
        vm.enableSchedules = false;
        vm.enableBatchSale = false;
        vm.enableIndiviualPrice = true;
        vm.enableRules = false;

        vm.flyer = {
            discountPercentageValue: undefined,
            currency: 'REAL',
            currencyInstance: vm.currencyConfigurations.REAL,
            discountType: 'DISCOUNT_FIXED',
            details: [],
            tags: [],
            isLaunch: false,
            isBasic: false,
            validityTypeDate: false,
			addImageFileDTO: []
        };

        vm.mainMap = {
            center: {
                latitude: 0,
                longitude: 0
            },
            zoom: 10,
            controls: {},
            bounds: {},
            markers: [],
            window: {
                model: {},
                show: false,
                options: {
                    pixelOffset: {
                        width: -1,
                        height: -65
                    }
                },
                closeClick: function () {
                    this.show = false;
                }
            },
            markerEvents: {
                dragend: function (marker) {
                    vm.refreshMapWithCoordinates(marker.position.lat(), marker.position.lng());
                },
                mouseover: function (marker, eventName, model) {
                    vm.mainMap.window.model = model;
                    vm.mainMap.window.show = true;
                },
                mouseout: function () {
                    vm.mainMap.window.show = false;
                },
                click: function (marker) {
                    for (var i = 0; i < vm.mainMap.markers.length; i++) {
                        if (vm.mainMap.markers[i].id === marker.key) {
                            if (vm.mainMap.markers[i].clicked) {
                                vm.mainMap.markers[i].options.icon = ICON_INACTIVE;
                                vm.mainMap.markers[i].clicked = false;
                            } else {
                                vm.mainMap.markers[i].options.icon = ICON_ACTIVE;
                                vm.mainMap.markers[i].clicked = true;
                            }
                        }
                    }
                }
            }
        };

        vm.onChangeCategory = function () {
            vm.fullCategory = vm.categories.find(function (category) {
                return category.key === vm.flyer.categoryKey;
            });
        }

        vm.onChangeEan = function (value, index) {
            if (value.ean === "" || value.ean === null || value.ean === undefined) {
                return false;
            }
            for (var i = 0; i < vm.flyer.details.length; i++) {
                var details = vm.flyer.details[i];
                if (index !== i && value.ean === details.ean) {
                    return true;
                }
            }
            return false;
        }

        vm.checkIfLaunchSelected = function () {
            return vm.flyer.isLaunch;
        }

        vm.updateLaunchOrRemove = function () {
            vm.flyer.isLaunch = !vm.flyer.isLaunch;
        }

        vm.checkIfBasicSelected = function () {
            return vm.flyer.isBasic;
        }

        vm.updateBasicOrRemove = function () {
            vm.flyer.isBasic = !vm.flyer.isBasic;
        }

        vm.openInput = function (evt) {
            document.getElementById('fileInput').click();
        }

        vm.changeIndividualPrice = function () {
            vm.enableIndiviualPrice = !vm.enableIndiviualPrice;
            if (vm.enableIndiviualPrice) {
                vm.flyer.details = [];
                vm.selectedSizes = [];
                if(vm.enableMeasure) {
                    vm.measureList = [];
                    vm.addMeasures();
                } else {
                    vm.measureList = [];
                }
            } else {
                if(vm.enableMeasure) {
                    vm.addVariation();
                }
                vm.flyer.purchaseValue = undefined;
                vm.flyer.discountedValue = undefined;
                vm.flyer.inventory = undefined;
                if(vm.flyer.dimension){
                    vm.flyer.dimension.weight = '';
                    vm.flyer.dimension.height = '';
                    vm.flyer.dimension.width = '';
                    vm.flyer.dimension.length = '';
                }
            }
                if(vm.flyer.measureList){
                    vm.flyer.measureList = [];
                }
        }

        vm.changeDimension = function() {
            if (!vm.enableDimension) {
                if(vm.flyer.dimension){
                    vm.flyer.dimension.weight = '';
                    vm.flyer.dimension.height = '';
                    vm.flyer.dimension.width = '';
                    vm.flyer.dimension.length = '';
                }
                vm.flyer.details.forEach(function (detail) {
                    detail.dimension = undefined;
                });
            }
        }

        vm.changeMeasure = function() {
            if (!vm.enableMeasure) {
                if(vm.flyer.dimension){
                    vm.flyer.measureList = [];
                }
                vm.flyer.details.forEach(function (detail) {
                    detail.measureList = [];
                });
                vm.measureList = [];
            } else {
                vm.addMeasures();
            }
        }

        vm.addMeasures = function () {
            if (!vm.flyer.details.length) {
                if (!vm.flyer.measureList) {
                    vm.flyer.measureList = [];
                }

                if (vm.flyer.measureList.length) {
                    vm.flyer.measureList.push({ name: '', value: 0 });
                } else {
                    vm.flyer.measureList.push({ name: $translate.instant('flyers.new.form.weight-dimensions.height'), value: 0 });
                    vm.flyer.measureList.push({ name: $translate.instant('flyers.new.form.weight-dimensions.width'), value: 0 });
                }
            } else {
                vm.flyer.details.forEach(function (detail) {
                    if (!detail.measureList) {
                        detail.measureList = [];
                    }

                    if (detail.measureList.length) {
                        detail.measureList.push({ name: '', value: 0 });
                    } else {
                        detail.measureList.push({ name: $translate.instant('flyers.new.form.weight-dimensions.height'), value: 0 });
                        detail.measureList.push({ name: $translate.instant('flyers.new.form.weight-dimensions.width'), value: 0 });
                    }

                });
            }
            if (vm.measureList.length) {
                vm.measureList.push({ name: '' });
            } else {
                vm.measureList.push({ name: $translate.instant('flyers.new.form.weight-dimensions.height') });
                vm.measureList.push({ name: $translate.instant('flyers.new.form.weight-dimensions.width') });
            }

        }

        function addValueToColumn() {
            vm.measureList.forEach(function (measure) {
                vm.flyer.details[vm.flyer.details.length - 1].measureList.push({ name: measure.name, value: 0 })
            });
        }

        function findIndex(value){
			return value.name == this
		}


        function mapMeasures(nameMeasure) {
            if (!vm.flyer.details.length) {
                if (vm.flyer.measureList) {
                    if (vm.measureList.findIndex(findIndex, nameMeasure) < 0 || nameMeasure === '') {
                        vm.measureList.push({ name: nameMeasure });
                    }
                }
            } else {
                vm.flyer.details.forEach(function (detail) {
                    if (detail.measureList) {
                        if (vm.measureList.findIndex(findIndex, nameMeasure) < 0 || nameMeasure === '') {
                            vm.measureList.push({ name: nameMeasure });
                        } else {
                            if(detail.measureList.map(function(el) {return el.name}).indexOf(nameMeasure) == -1) {
                                detail.measureList.push({"name": nameMeasure, "value": "0"})
                            }
                        }
                    } else {
                        detail.measureList = [];
                        detail.measureList.push({"name": nameMeasure, "value": "0"});
                    }
                });
            }
        }

        vm.removeMeasure = function (index) {
            if (vm.measureList.length > 1) {
                vm.measureList.splice(index, 1);
                if (!vm.flyer.details.length) {
                    vm.flyer.measureList.splice(index, 1);
                } else {
                    vm.flyer.details.forEach(function (detail) {
                        detail.measureList.splice(index, 1);
                    });
                }
            }
        }


        vm.changeTags = function () {
            if (!vm.enableTags) {
                vm.flyer.tags = [];
            }
        }

        vm.changeBatchSale = function () {
            if (!vm.enableBatchSale) {
                vm.flyer.bulkQuantity = undefined;
                vm.flyer.discountBulkPercentage = undefined;
            }
        }

        vm.changeRulesForUse = function() {
            if (!vm.enableRules) {
                vm.flyer.rulesForUse = undefined;
            }
        }

        vm.changeSchedules = function () {
            if (vm.enableSchedules) {
                vm.startDateOptions = {
                    format: DATE_FORMAT,
                    sideBySide: true,
                    ignoreReadonly: true,
                    locale: moment.locale(),
                    allowInputToggle: true
                };

                vm.expireDateOptions = {
                    format: DATE_FORMAT,
                    sideBySide: true,
                    ignoreReadonly: true,
                    minDate: now,
                    locale: moment.locale(),
                    allowInputToggle: true,
                    useCurrent: false
                };

                angular.element('#startDateTime').datetimepicker(vm.startDateOptions).on('dp.change', function (ev) {
                    if (ev.date) {
                        vm.flyer.startDate = ev.date.format(DATE_FORMAT);
                        if (vm.flyer.expirationDate && !checkExpirationDate()) {
                            vm.flyer.expirationDate = undefined;
                            angular.element('#expirationDateTime').data("DateTimePicker").minDate(ev.date || now);
                        } else {
                            angular.element('#expirationDateTime').data("DateTimePicker").minDate(now);
                        }
                        $scope.$apply(function () {
                            vm.flyerForm.startDate.$setValidity('minDate', true);
                        });
                    } else {
                        vm.flyer.startDate = undefined;
                    }
                });

                angular.element("#expirationDateTime").datetimepicker(vm.expireDateOptions).on('dp.change', function (ev) {
                    if (ev.date) {
                        vm.flyer.expirationDate = ev.date.format(DATE_FORMAT);
                        $scope.$apply(function () {
                            vm.flyerForm.expirationDate.$setValidity('required', true);
                        });
                    } else {
                        vm.flyer.expirationDate = undefined;
                    }
                });
            } else {
                vm.flyer.startDate = undefined;
                vm.flyer.expirationDate = undefined;
                vm.flyer.immediateAvailability = true;
                vm.flyer.validityTypeDate = true;
            }
        }

        vm.onImmediateAvailabilityChange = function () {
            if (vm.flyer.immediateAvailability) {
                vm.flyerForm.startDate.$setValidity('minDate', true);
                angular.element('#startDateTime').data("DateTimePicker").clear();
            }
        }

        vm.onValidityTypeDateChange = function (checked) {
            if (checked) {
                angular.element('#expirationDateTime').data("DateTimePicker").clear();
            }
        };

		vm.loadImages = function () {
			vm.imgsFlyers[0].isThumbnail = true;
			for (var i = 0 ; i < vm.imgsFlyers.length; i++){
				var random = new Date().getTime();
				var src = null;
				if (i != 0){
					src = '/flyer/api/' + vm.flyer.id + '__'+ i + '/hub-picture?type=large&ts=' + random;
				}else{
					src = '/flyer/api/' + vm.flyer.id + '/hub-picture?type=large&ts=' + random;
				}
				var img = new Image();
				img.src = src;
				img.id = i
				img.onload = function() {
					vm.imgsFlyers[this.id].src = this.src;
					vm.imgsFlyers[this.id].isDefault = false;
					vm.moveImageFlyerToFirstIndex();
				}
				img.onerror = function() {
					vm.imgsFlyers[this.id].src = SRC_IMAGE_DEFAULT;
				}
			}
		}

        vm.typeChanged = function () {
            if (vm.flyer.type === 'RENT') {
                vm.flyer.maxUsageByUser = 1;
                vm.flyer.maxUsages = 1;
                vm.flyer.usageLimitByUser = false;
                vm.flyer.validityTypeNumber = false;
                vm.flyer.validityTypeDate = true;
            }

            vm.flyer.bulkQuantity = null;
            vm.flyer.discountBulkPercentage = null;

            if (vm.transactionalUserInteractions.includes(vm.flyer.type)) {
                vm.flyer.currency = 'REAL';
                vm.flyer.currencyInstance = vm.currencyConfigurations.REAL;
                vm.disabledCurrency = true;
            } else {
                vm.disabledCurrency = false;
            }
        }

        vm.uploadImage = function () {
            if(vm.isSaving) {
                return;
            }
            vm.isSaving = true;

            if (vm.flyerForm.$invalid) {
                toastr.warning("Verifique os campos invalidos")
                angular.forEach(vm.flyerForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    });
                });
                return;
            }

            if(vm.flyer.brand === null){
                toastr.warning($translate.instant('brand.messages.warning.selectBrand'));
                return;
            }

			var cont = 0;
			var contImageModified = vm.imgsFlyers.length;
			vm.flyer.addImageFileDTO = [];
			for (var i = 0; i < vm.imgsFlyers.length; i++) {
				if (vm.imgsFlyers[i].src.includes(SRC_IMAGE_DEFAULT)){
					vm.flyer.addImageFileDTO.push(createJsonImage(null, null, i, 'DELETE'));
					cont = cont + 1;
					if (cont == contImageModified){
                        if (vm.flyer.addImageFileDTO.length > 0) {
							saveFlyer();
                        } else {
                            toastr.error($translate.instant('flyers.messages.create.error'));
                        }
                        vm.loadingImage = false;
					}
				}else if (!vm.imgsFlyers[i].src.includes('base64')){
					vm.flyer.addImageFileDTO.push(createJsonImage(vm.imgsFlyers[i].src, null, i, 'UPDATE'));
					cont = cont + 1;
					if (cont == contImageModified){
                        if (vm.flyer.addImageFileDTO.length > 0) {
							saveFlyer();
                        } else {
                            toastr.error($translate.instant('flyers.messages.create.error'));
                        }
                        vm.loadingImage = false;
					}
				}else{
                	var blob = dataURItoBlob(vm.imgsFlyers[i].src);
	                HubFlyersService.saveFlyerMultiImage(blob, i).then(function (response) {
	                    $timeout(function () {
	                        vm.flyer.addImageFileDTO.push(response.data);
                            cont = cont + 1;
							if (cont == contImageModified){
		                        if (vm.flyer.addImageFileDTO.length > 0) {
									saveFlyer();
		                        } else {
		                            toastr.error($translate.instant('flyers.messages.create.error'));
		                        }
		                        vm.loadingImage = false;
							}
	                    });
	                }, function () {
	                    toastr.error($translate.instant('flyers.messages.create.image.uploadError'));
	                    vm.isSaving = false;
	                    vm.loadingImage = false;
	                });
				}
			}

        }

        function createJsonImage(uuid, extensionFile, orderNumber, action) {
            return{
                uuid: uuid,
                extensionFile: extensionFile,
                orderNumber: orderNumber,
				action: action
            };
        }

        vm.formatMoney = function (value, currencySymbol) {
            return formatMoney(value, currencySymbol, vm.flyer.currencyInstance.decimalQuant,
                vm.flyer.currencyInstance.centsSeparator, vm.flyer.currencyInstance.thousandsSeparator);
        };

        vm.checkDiscountedValue = function () {
            if (vm.flyer.purchaseValue && vm.flyer.discountedValue) {
                if (parseFloat(vm.flyer.discountedValue) > parseFloat(vm.flyer.purchaseValue)) {
                    vm.flyerForm.discountedValue.$setValidity('discountGreaterThanValue', false);
                } else {
                    vm.flyerForm.discountedValue.$setValidity('discountGreaterThanValue', true);
                }
            }
        }

        vm.addVariation = function () {
            $uibModal.open({
                templateUrl: 'app/admin/hub-management/flyers/flyers-add-size-variation.html',
                controller: function (selectedSizes, $uibModalInstance) {
                    var vm = this;

                    vm.tab = 'classic';
                    vm.sizes = getClassicSizes();
                    vm.selectedSizes = selectedSizes;

                    vm.changeTab = function(tab) {
                        vm.tab = tab;
                        switch (tab) {
                            case 'classic':
                                vm.sizes = getClassicSizes();
                                break;
                            case 'juvenileChild':
                                vm.sizes = getJuvenileChildSizes();
                                break;
                            case 'shorts':
                                vm.sizes = getShortSizes();
                                break;
                            case 'plusSize':
                                vm.sizes = getPlusSizes();
                                break;
                            case 'others':
                                vm.sizes = vm.sizes = getOtherSizes();
                                break;
                            default:
                                break;
                        }
                    }

                    vm.checkSize = function (size, evt) {
                        if (evt.target.checked) {
                            vm.selectedSizes.push(size);
                        } else {
                            var index = vm.selectedSizes.indexOf(size);
                            vm.selectedSizes.splice(index, 1);
                        }
                    }

                    vm.isChecked = function (size) {
                        return selectedSizes.includes(size)
                    }

                    vm.closeModal = function () {
                        $uibModalInstance.dismiss('cancel');
                    }

                    vm.ok = function () {
                        $uibModalInstance.close(vm.selectedSizes);
                    }
                },
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    selectedSizes: function () {
                        return angular.copy(vm.selectedSizes);
                    }
                }
            }).result.then(function (response) {
                if (response) {
                    // Add new items
                    angular.forEach(response, function (newSize) {
                        if (!vm.selectedSizes.includes(newSize)) {
                            vm.flyer.details.push({
                                size: newSize,
                                purchaseValue: undefined,
                                discountedValue: undefined,
                                inventory: undefined,
                                quantityByPerson: undefined,
								imgFlyerId: undefined,
                                measureList: []
                            })
                            addValueToColumn();
                        }
                    })

                    // Remove old items
                    angular.forEach(vm.selectedSizes, function (currentSize) {
                        if (!response.includes(currentSize)) {
                            _.remove(vm.flyer.details, function (detail) {
                                return detail.size === currentSize;
                            });
                        }
                    })
                    vm.selectedSizes = response;
                }
            });
        }

        vm.removeVariation = function (index) {
            _.remove(vm.selectedSizes, function (size) {
                return vm.flyer.details[index].size === size;
            })
            vm.flyer.details.splice(index, 1);
        }

        // private methods
        $scope.$watch('vm.mainMap.zoom', function (newVal) {
            if (newVal > 16 && vm.firstZoom) {
                vm.mainMap.zoom = 16;
                vm.firstZoom = false;
            }
        });

        function saveFlyer() {
            // Valid dates

            if (!vm.enableIndiviualPrice) {
                if (!vm.flyer.details || vm.flyer.details.length === 0) {
                    toastr.warning('Adicione ao menos uma variação');
                    return;
                }
                vm.flyer.ean = null;
            }

            if (vm.flyer.startDate) {
                // Compare the day
                if (vm.flyer.expirationDate) {
                    if (moment(vm.flyer.startDate, DATE_FORMAT).isSameOrAfter(moment(vm.flyer.expirationDate, DATE_FORMAT))) {
                        toastr.warning($translate.instant('error.flyerStartDateGreaterThanOrEqualsToExpirationDate'));
                        return;
                    }
                }
            }

            if (vm.measureList.length) {
                var obj = {};
                for ( var i=0, len=vm.measureList.length; i < len; i++ ) {
                    obj[vm.measureList[i]['name']] = vm.measureList[i];
                }
                var unique = new Array();
                for ( var key in obj ) {
                    unique.push(obj[key]);
                }
                if (unique.length != vm.measureList.length) {
                    toastr.error($translate.instant('error.flyerDuplicateMeasures'));
                    vm.isSaving = false;
                    return;
                }
            }

            if (vm.flyer.measureList && vm.flyer.measureList.length) {
                vm.flyer.measureList.forEach(function (measure, index) {
                    measure.name = vm.measureList[index].name;
                });
            } else {
                vm.flyer.details.forEach(function (detail) {
                    if (detail.measureList) {
                        detail.measureList.forEach(function (measure, index) {
                            measure.name = vm.measureList[index].name;
                        })
                    }
                });
            }

            vm.isSaving = true;

            var flyerToSave = angular.copy(vm.flyer);
            flyerToSave.id = vm.isEdit ? vm.flyer.id : undefined;
            flyerToSave.startDate = vm.flyer.startDate ? moment(vm.flyer.startDate, DATE_FORMAT).toDate() : now;
            flyerToSave.expirationDate = vm.flyer.expirationDate ? moment(vm.flyer.expirationDate, DATE_FORMAT).toDate() : undefined;
            flyerToSave.validityTypeDate = !!vm.flyer.expirationDate;
            flyerToSave.storeId = $localStorage.defaultStore.storeId;
            flyerToSave.salesPoint = [];
            flyerToSave.currency = vm.flyer.currencyInstance.key;
            flyerToSave.gender = parseInt(vm.flyer.gender);
            flyerToSave.hub = $localStorage.hub.id;
            flyerToSave.tags = vm.flyer.tags.map(function (tag) {
                return tag['text'];
            });
            flyerToSave.discountedValue = flyerToSave.discountedValue > 0 ? flyerToSave.discountedValue : null;
            flyerToSave.brand = vm.flyer.brand.name;

            if (vm.flyer.discountType == 'DISCOUNT_PERCENTAGE') flyerToSave.discountValue = vm.flyer.discountPercentageValue;

            if (vm.isEdit) {
                HubFlyersService.updateFlyer(flyerToSave).then(function(data) {
                        var params = {'brand': flyerToSave.brand};
                        vm.isSaving = false;
                        toastr.success($translate.instant('flyers.messages.update.success'));
                        $state.go('hub-flyers', params);
                    },
                    function(error) {
                        var header = error.headers();
                        vm.isSaving = false;
                        if (error.status == 400) {
                            var eans = error.data.data.data.join(", ")
                            toastr.error($translate.instant(error.data.data.message, {value: eans}));
                        } else {
                            toastr.error($translate.instant(header['x-flyerapp-error']));
                        }
                    });
            } else {
                HubFlyersService.createFlyer(flyerToSave).then(function () {
                    var params = {'brand': flyerToSave.brand};
                    $state.go('hub-flyers', params);
                    toastr.success($translate.instant('flyers.messages.create.success'));
                    vm.isSaving = false;
                }, function (error) {
                    vm.isSaving = false;
                    if (error.status == 400) {
                        if (error.data.message.includes('duplicatedProductReferenceInHub')) {
                            toastr.error($translate.instant(error.data.message, {value: error.data.data}));
                        } else {
                            var eans = error.data.data.join(", ")
                            toastr.error($translate.instant(error.data.message, {value: eans}));
                        }
                    } else {
                        toastr.error($translate.instant(header['x-flyerapp-error']));
                    }
                });
            }
        }

        function loadFlyer(flyerId) {
            HubFlyersService.getFlyer(flyerId)
                .then(function (response) {
                    vm.flyer = response.data

                    if (!vm.colors.includes(vm.flyer.color)) {
                        vm.colors.push(vm.flyer.color);
                    }

					if (vm.flyer.demoVideo){
						vm.enableDemoVideo = true;
					}
                    vm.flyer.currencyInstance = vm.currencyConfigurations[vm.flyer.currency];
                    vm.flyer.gender = vm.flyer.gender ? vm.flyer.gender.toString() : undefined;
                    if(vm.flyer.dimension && vm.flyer.dimension.weight != null) {
                        vm.enableDimension = true;
                    }

                    if (vm.flyer.tags && vm.flyer.tags.length > 0) {
                        vm.enableTags = true;
                    } else {
                        vm.flyer.tags = [];
                    }

                    if (vm.flyer.details && vm.flyer.details.length > 0) {
                        angular.forEach(vm.flyer.details, function (detail) {
                            vm.selectedSizes.push(detail.size);
                        })

                        vm.flyer.details.forEach(function (detail) {
                            vm.enableIndiviualPrice = false;
                            if(detail.dimension && detail.dimension.weight != null && !vm.enableDimension) {
                                vm.enableDimension = true;
                            }
                            if(detail.measureList && detail.measureList.length) {
                                vm.enableMeasure = true;
                                detail.measureList.forEach(function(measure){
                                    mapMeasures(measure.name);
                                })
                            } else {
                                detail.measureList = [];
                            }
                        });

                    } else {
                        vm.flyer.details = [];
                    }

                    if(vm.flyer.measureList && vm.flyer.measureList.length) {
                        vm.enableMeasure = true;
                        vm.flyer.measureList.forEach(function(measure){
                            mapMeasures(measure.name);
                        })
                    }

                    if (vm.flyer.bulkQuantity) {
                        vm.enableBatchSale = true;
                    }

                    if (vm.flyer.rulesForUse) {
                        vm.enableRules = true;
                    }

                    if (vm.flyer.startDate || vm.flyer.expirationDate) {
                        vm.enableSchedules = true;
                        if (vm.flyer.startDate) {
                            vm.flyer.startDate = moment(vm.flyer.startDate).format(DATE_FORMAT)
                        }
                        if (vm.flyer.expirationDate) {
                            vm.flyer.expirationDate = moment(vm.flyer.expirationDate).format(DATE_FORMAT);
                            vm.flyer.validityTypeDate = true;
                        }
                        $timeout(function () {
                            vm.changeSchedules();
                        }, 200)
                    }
					vm.loadImages();
                    BrandService.findBrand(vm.flyer.brand).then(function (response) {
                        vm.brands = response.data;
                        setBrandObjectOnForm();
                    });

                    loadData();
                }, function () {
                    toastr.success($translate.instant('flyers.messages.load.success'));
                });
        }

        function loadData() {
            FlyerCategoryService.listCategoriesByCurrentStore($translate.use(), $localStorage.defaultStore.storeId).then(function (response) {
                vm.categories = response.data;
                if (vm.isEdit) {
                   vm.fullCategory = _.find(vm.categories, function (category) {
                        return category.key === vm.flyer.categoryKey;
                   })
                } else {
                    vm.flyer.categoryKey = vm.categories[0].key;
                    vm.fullCategory = vm.categories[0];
                }
                vm.isLoading = false;
                initImageHandle();
            });

            BrandService.findBrand("").then(function (response) {
                vm.brands = response.data;
                setBrandObjectOnForm();
            });
        }

        function querySearchBrand(query) {
            var defer = $q.defer();
            BrandService.findBrand(query === undefined ? "" : query).then(function (response) {
                defer.resolve(response.data)
                vm.brands = response.data.slice();
            }, function (_) {
                deferred.resolve([]);
            });
            return defer.promise;
        }

        function selectedBrandChange(brand) {
            // console.log('Brand changed to ' + JSON.stringify(brand));
        }

        function initImageHandle() {
                $timeout(function () {
                    angular.element(document.querySelector('#imgInput1')).on('change', handleFileSelect);
                    angular.element(document.querySelector('#imgInput2')).on('change', handleFileSelect);
                    angular.element(document.querySelector('#imgInput3')).on('change', handleFileSelect);
                    angular.element(document.querySelector('#imgInput4')).on('change', handleFileSelect);
                }, 200)
        }
		function handleFileSelect(e) {
			var id = e.currentTarget.id.replace('imgInput','');
            var file = e.currentTarget.files[0];
            if ((file.size / 1024) > MAX_IMAGE_SIZE) {
                toastr.error($translate.instant('flyers.messages.create.image.sizeError'));
            } else {
                var reader = new FileReader();
	            reader.onload = function (e) {
	                $scope.PreviewImage = e.target.result;
	                $scope.$apply();
	                vm.imgsFlyers.forEach(function (imgFlyer) {
	                    if (imgFlyer.id === id) {
	                        imgFlyer.src = e.target.result;
	                        imgFlyer.isDefault = false;
							imgFlyer.isModified = true;
	                    }
	                });
	                vm.moveImageFlyerToFirstIndex();
                    /*$scope.$apply(function () {
                        vm.imageUpload = evt.target.result;
                    });*/
                };
                reader.readAsDataURL(file);
            }
        }

        function checkExpirationDate() {
            if (vm.flyer.expirationDate) {
                if (moment(vm.flyer.startDate, DATE_FORMAT).isSameOrAfter(moment(vm.flyer.expirationDate, DATE_FORMAT))) {
                    /** returns false if the expirationDate is before startDate */
                    return false;
                }
                /** returns true if the expirationDate is ok (the expirationDate is after startDate) */
                return true;
            }
        }

        function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);

            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {
                type: mimeString
            });
        }

        function setBrandObjectOnForm() {
            vm.brands.forEach(function (brand){
                if(brand.name === vm.flyer.brand) {
                    vm.flyer.brand = brand
                    return;
                }
            });
        }

        vm.flyersSelectImageDetailModal = function(detail, index) {
            $uibModal.open({
                templateUrl: 'app/admin/flyers/flyers-select-image-detail.html',
                controller: function (imgsFlyers, imgFlyerId, size, $uibModalInstance) {
                    var vm = this;
                    vm.imgsFlyers = imgsFlyers;
                    vm.imgFlyerId = imgFlyerId;
                    vm.size = size;
                    vm.close = close;

                    vm.sortableOptionsDetail = {
                        disabled: true
                    };

                    vm.selectImg = function(imgsFlyer) {
                        if (!imgsFlyer.isDefault) {
                            if(vm.imgFlyerId === imgsFlyer.id) {
                                vm.imgFlyerId = null;
                            } else {
                                vm.imgFlyerId = imgsFlyer.id;
                            }
                        }
                    }

		            vm.getCountDefaultImageFlyer = function () {
			            var count = 0;
			            vm.imgsFlyers.forEach(function (img){
			                if(img.isDefault) {
			                    count++;
			                }
			            });
			            return count;
			        }

                    function close() {
                        $uibModalInstance.close(vm.imgFlyerId);
                    }

                },
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                keyboard  : false,
                resolve: {
                    imgsFlyers: function () {
                        return angular.copy(vm.imgsFlyers);
                    },
                    size: function () {
                        return detail.size;
                    },
                    imgFlyerId: function () {
                        return detail.imgFlyerId;
                    }
                }
            }).result.then(function(selectImgId) {
                vm.addOrUpdateImgDetail(selectImgId, index)

            });
        }

        vm.openInputImage = function (evt, id) {
            document.getElementById('imgInput' + id).click();
        }

        vm.changeDemoVideo = function () {
            if (!vm.enableDemoVideo) {
                vm.flyer.demoVideo = null;
            }
        }

        vm.getCountDefaultImageFlyer = function () {
            var count = 0;
            vm.imgsFlyers.forEach(function (img){
                if(img.isDefault) {
                    count++;
                }
            });
            return count;
        }

        vm.moveImageFlyerToFirstIndex = function () {
            var imgsDefault = [];
            var imgs = [];
            $timeout(function () {
                for (var i = 0; i < vm.imgsFlyers.length; i++) {
                    vm.imgsFlyers[i].isThumbnail = false;
                    if (vm.imgsFlyers[i].isDefault) {
                        imgsDefault.push(vm.imgsFlyers[i]);
                    } else {
                        imgs.push(vm.imgsFlyers[i]);
                    }
				}

                vm.imgsFlyers = imgs;
				for (var j = 0; j < imgsDefault.length; j++) {
					vm.imgsFlyers.push(imgsDefault[j]);
				}
				if (vm.imgsFlyers[0].isDefault){
					vm.imgsFlyers[0].isThumbnail = false;
				}else{
					vm.imgsFlyers[0].isThumbnail = true
				}
            }, 500);
        }

       vm.removeImgFlyer = function (id) {
           vm.imgsFlyers.forEach(function (imgFlyer) {
                if (imgFlyer.id === id) {
                    imgFlyer.src = vm.srcImgDefault;
                    imgFlyer.isDefault = true;
                    imgFlyer.isThumbnail = false;
                }
            });
           vm.removeReferenceImgDetail(id);
            vm.moveImageFlyerToFirstIndex();
        }

        vm.addOrUpdateImgDetail = function (imgFlyerId, index) {
            vm.flyer.details[index].imgFlyerId = imgFlyerId;

//			vm.flyer.details.forEach(function (detail) {
//                if (detail.size === sizeDetail) {
//                    detail.imgFlyerId = imgFlyerId;
//                }
//            });
        }

        vm.removeReferenceImgDetail = function (imgFlyerId) {
            vm.flyer.details.forEach(function (detail) {
                if (detail.imgFlyerId === imgFlyerId) {
                    detail.imgFlyerId = null;
                }
            });
        }

        vm.getIndexImageById = function (imgFlyerId) {
            for (var i = 0; i < vm.imgsFlyers.length; i++) {
                if (vm.imgsFlyers[i].id === imgFlyerId) {
                    return parseInt(i);
                }
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubFlyersEditInfoController', HubFlyersEditInfoController);

    HubFlyersEditInfoController.$inject = ['$translate', 'HubFlyersService', 'toastr','$uibModalInstance', 'flyer'];

    function HubFlyersEditInfoController( $translate, HubFlyersService,toastr, $uibModalInstance, flyer) {
        var vm = this;
        vm.flyer = flyer;
        vm.saveFlyer = function() {
            vm.isSaving = true;
            HubFlyersService.updateFlyer(vm.flyer).then(function(data) {
                    vm.isSaving = false;
                    toastr.success($translate.instant('flyers.messages.update.success'));
                    $uibModalInstance.close(data);
                },
                function(data) {
                    vm.isSaving = false;
                    toastr.success($translate.instant('ERROR'));
                    $uibModalInstance.dismiss(data);
                });
        }

        vm.closeModal = function() {
            $uibModalInstance.close();
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubFlyersEditImageController', HubFlyersEditImageController);

    HubFlyersEditImageController.$inject = ['$translate', '$timeout', '$scope', 'HubFlyersService', 'toastr', '$uibModalInstance', 'flyer'];

    function HubFlyersEditImageController($translate, $timeout, $scope, HubFlyersService, toastr, $uibModalInstance, flyer) {
        var vm = this;
        vm.isSaving = false;
        vm.imageSize = 400;
        vm.flyer = flyer;
        vm.flyerImage = '';

        vm.closeModal = function() {
            $uibModalInstance.close();
        }

        vm.uploadPreview = function(img) {
            var reader = new FileReader();
            reader.onload = vm.imageIsLoaded;
            reader.readAsDataURL(img)
        }

        vm.openInput = function(evt) {
            document.getElementById('fileInput').click();
        }

        var handleFileSelect = function(evt) {
            var file = evt.currentTarget.files[0];
            var reader = new FileReader();
            reader.onload = function(evt) {
                $scope.$apply(function($scope) {
                    vm.imageUpload = evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        };

        vm.imageIsLoaded = function(e) {
            $scope.$apply(function() {
                vm.flyer.imagePath = e.target.result;
            });
        }

        function dataURItoBlob(dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {
                type: mimeString
            });
        }

        vm.save = function() {
            HubFlyersService.saveFlyerImage(dataURItoBlob(vm.flyerImage)).then(function(response) {
                $timeout(function() {
                    vm.flyer.addImageFileDTO = response.data;
                    vm.isSaving = true;
                    HubFlyersService.updateFlyer(vm.flyer).then(function(data) {
                        vm.isSaving = false;
                        $uibModalInstance.close(data);
                        toastr.success($translate.instant('flyers.messages.update.success'));
                    }, function(error) {
                        $uibModalInstance.dismiss(error);
                    });
                });
            });
        }

        vm.initFlyerImageModal = function() {
            angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubFlyersEditController', HubFlyersEditController);

    function HubFlyersEditController($scope, $translate, FlyersCurrencyValue, FlyerCategoryService, HubFlyersService, toastr, $uibModalInstance, flyer, moment, BrandService, $localStorage, StoreService) {
        var format = 'L LT';
        var FORMAT_DATE = 'L';
        // Beginning of the day
        var CURRENT_DAY = moment().startOf('day');
        var vm = this;

        StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
            vm.storeCategory = response.data.categoryKey;
        });

        vm.flyer = flyer;
        vm.flyerSnapshot = angular.copy(vm.flyer);
        delete vm.flyerSnapshot.addImageFileDTO;
        if (flyer.discountType == 'DISCOUNT_PERCENTAGE') {
            vm.flyer.discountPercentageValue = flyer.discountValue;
            vm.flyer.discountValue = undefined;
        }
        vm.convertDate = true;
        vm.isSaving = false;
        vm.checks = {
            validityTypeDate: !vm.flyer.validityTypeDate,
            validityTypeNumber: !vm.flyer.validityTypeNumber,
            usageLimitByUser: !vm.flyer.usageLimitByUser
        };

        vm.transactionalUserInteractions = ["RENT", "SALE"];
        vm.disabledCurrency = false;
        vm.sizes = getAllSizes();
        vm.brands = [];
        vm.colors = getAllColors();
        loadBrands();

        loadCategories();
        checkValidateFields();

        vm.currencyConfigurations = getCurrencyListConfiguration();

        vm.init = init;
        vm.checkFlyerHasCouponGenerated = checkFlyerHasCouponGenerated;
        vm.onValidityTypeDateChange = onValidityTypeDateChange;

        function init() {
            dateTimePicker();
            vm.flyer.currencyInstance = vm.currencyConfigurations[vm.flyer.currency];
            vm.blockCurrency();
            vm.flyer.gender = vm.flyer.gender ? vm.flyer.gender.toString() : null;
            vm.flyer.sizes = vm.flyer.sizes ? vm.flyer.sizes : [];
        }

        vm.checkIfSizeSelected = function(size) {
            return vm.flyer.sizes.includes(size);
        }

        vm.updateSizeOrRemove = function(size) {
            var isSelected = vm.flyer.sizes.includes(size);
            if (isSelected) {
                vm.flyer.sizes = vm.flyer.sizes.filter(function(item) {
                    return item !== size;
                });
            } else {
                vm.flyer.sizes.push(size);
            }
        }

        vm.closeModal = function() {
            $uibModalInstance.close();
        }

        vm.checkDiscountType = function() {

            if (vm.flyer.discountValue && (!vm.flyer.discountType)) {
                vm.flyer.discountType = 'DISCOUNT_FIXED';
            }
            if (vm.flyer.discountType === 'DISCOUNT_FIXED') {

                vm.flyerEditForm.discountValue.$setValidity('max', true);
                if (parseFloat(vm.flyer.discountValue) > parseFloat(vm.flyer.purchaseValue)) {
                    vm.flyerEditForm.discountValue.$setValidity('discountGreaterThanValue', false);
                } else {
                    vm.flyerEditForm.discountValue.$setValidity('discountGreaterThanValue', true);
                }
            }
        }

        vm.blockCurrency = function() {
            if (vm.transactionalUserInteractions.includes(vm.flyer.type)) {
                vm.flyer.currency = 'REAL';
                vm.flyer.currencyInstance = vm.currencyConfigurations.REAL;
                vm.disabledCurrency = true;
            } else {
                vm.disabledCurrency = false;
            }
        }

        vm.typeChanged = function() {
            if (vm.flyer.type == 'RENT') {
                vm.flyer.maxUsageByUser = 1;
                vm.flyer.maxUsages = 1;
                vm.checks['usageLimitByUser'] = false;
                vm.checks['validityTypeNumber'] = false;
                vm.checks['validityTypeDate'] = true;
            } else {
                vm.flyer.maxUsageByUser = vm.flyerSnapshot.maxUsageByUser;
                vm.flyer.maxUsages = vm.flyerSnapshot.maxUsages;
                vm.checks['usageLimitByUser'] = !vm.flyerSnapshot.usageLimitByUser;
                vm.checks['validityTypeNumber'] = !vm.flyerSnapshot.validityTypeNumber;
            }

            vm.flyer.bulkQuantity = null;
            vm.flyer.discountBulkPercentage = null;

            vm.blockCurrency();

        }

        function loadBrands() {
            BrandService.getBrandsByCurrentStore().then(function(response) {
                vm.brands = response.data;
            });
        }

        vm.isToDisplayMe = function(value) {
            return value == vm.flyer.discountType;
        }

        vm.getFlyerCurrency = function(currency) {
            return FlyersCurrencyValue[currency];
        }

        vm.checkIfLaunchSelected = function() {
            return vm.flyer.isLaunch;
        }

        vm.updateLaunchOrRemove = function() {
            vm.flyer.isLaunch = !vm.flyer.isLaunch;
        }

        vm.checkIfBasicSelected = function() {
            return vm.flyer.isBasic;
        }

        vm.updateBasicOrRemove = function() {
            vm.flyer.isBasic = !vm.flyer.isBasic;
        }

        vm.saveFlyer = function() {
            if (!vm.flyerEditForm.$invalid) {
                // Valid dates
                if (vm.flyer.startDate) {

                    if (vm.flyer.expirationDate) {
                        if (moment(vm.flyer.startDate, format).isSameOrAfter(moment(vm.flyer.expirationDate, format))) {
                            toastr.warning($translate.instant('error.flyerStartDateGreaterThanOrEqualsToExpirationDate'));
                            return;
                        }
                    }
                }

                vm.isSaving = true;
                var flyerToSave = angular.copy(vm.flyer);
                delete flyerToSave.addImageFileDTO;
                flyerToSave.validityTypeDate = !vm.checks['validityTypeDate'];
                flyerToSave.validityTypeNumber = !vm.checks['validityTypeNumber'];
                flyerToSave.usageLimitByUser = !vm.checks['usageLimitByUser'];
                flyerToSave.startDate = flyerToSave.startDate ? moment(flyerToSave.startDate, format).toDate() : moment().add(2, 'm');
                flyerToSave.expirationDate = flyerToSave.expirationDate ? moment(flyerToSave.expirationDate, format).toDate() : undefined;
                flyerToSave.currency = vm.flyer.currencyInstance.key;
                flyerToSave.gender = parseInt(vm.flyer.gender);
                flyerToSave.brand = vm.flyer.brand;
                flyerToSave.color = vm.flyer.color;
                flyerToSave.sizes = vm.flyer.sizes;
                flyerToSave.tags = vm.flyer.tags.map(function(tag) {
                    return tag['text'];
                });
                flyerToSave.productReference = vm.flyer.productReference;
                flyerToSave.isLaunch = vm.flyer.isLaunch;
                flyerToSave.isBasic = vm.flyer.isBasic;

                if (vm.flyer.discountType == 'DISCOUNT_PERCENTAGE') flyerToSave.discountValue = vm.flyer.discountPercentageValue;
                HubFlyersService.updateFlyer(flyerToSave).then(function(data) {
                        vm.isSaving = false;
                        toastr.success($translate.instant('flyers.messages.update.success'));
                        $uibModalInstance.close(data);
                    },
                    function(data) {
                        var header = data.headers();
                        vm.flyer.startDate = moment(vm.flyer.startDate).format(format);
                        vm.flyer.expirationDate = vm.flyer.expirationDate ? moment(vm.flyer.expirationDate).format(format) : undefined;
                        vm.isSaving = false;
                        toastr.error($translate.instant(header['x-flyerapp-error']));
                        $uibModalInstance.dismiss(data);
                    });
            }
        }

        function loadCategories() {
            FlyerCategoryService.listCategories($translate.use()).then(function(response) {
                vm.categories = response.data;
                vm.onChangeCategory();
            });
        }

        vm.onChangeCategory = function() {
            vm.fullCategory = vm.categories.find(function(category) {
                return category.key === vm.flyer.categoryKey;
            });
        }

        function checkValidateFields() {
            if (vm.flyer.expirationDate) {
                vm.flyer.expirationDate = new Date(vm.flyer.expirationDate);
                vm.flyer.validityTypeDate = true;
            }
            if (vm.flyer.maxUsages) {
                vm.flyer.maxUsages = parseInt(vm.flyer.maxUsages);
            }
            if (vm.flyer.maxUsageByUser) {
                vm.flyer.maxUsageByUser = parseInt(vm.flyer.maxUsageByUser);
            }
        }

        function checkExpirationDate() {
            if (vm.flyer.expirationDate) {
                if (moment(vm.flyer.startDate, format).isSameOrAfter(moment(vm.flyer.expirationDate, format))) {
                    /** returns false if the expirationDate is before startDate */
                    return false;
                }
                /** returns true if the expirationDate is ok (the expirationDate is after startDate) */
                return true;
            }
        }


        function checkFlyerHasCouponGenerated() {
            if (!vm.flyer.startDate && vm.flyer.hasAlreadyCouponGenerated) return false;
            return (moment(vm.flyer.startDate, format).isBefore(moment()) && vm.flyer.hasAlreadyCouponGenerated);
        }

        function onValidityTypeDateChange(checked) {
            if (checked) {
                angular.element('#expirationDateTime').data("DateTimePicker").clear();
            }
        }

        function dateTimePicker() {

            vm.startDateOptions = {
                format: format,
                sideBySide: true,
                ignoreReadonly: true,
                locale: moment.locale(),
                allowInputToggle: true,
                useCurrent: false,
                widgetPositioning: {
                    horizontal: 'auto',
                    vertical: 'top'
                }
            };

            vm.expireDateOptions = {
                format: format,
                sideBySide: true,
                ignoreReadonly: true,
                locale: moment.locale(),
                allowInputToggle: true,
                minDate: moment().add(1, 'minutes'),
                widgetPositioning: {
                    horizontal: 'auto',
                    vertical: 'top'
                },
                useCurrent: false
            };

            angular.element('#startDateTime').datetimepicker(vm.startDateOptions).on('dp.change', function(ev) {
                if (ev.date) {
                    vm.flyer.startDate = ev.date.format(format);

                    if (vm.flyer.expirationDate && !checkExpirationDate()) {
                        vm.flyer.expirationDate = undefined;
                        angular.element('#expirationDateTime').data("DateTimePicker").minDate(ev.date || moment().seconds(0).milliseconds(0).add(1, 'minutes'));
                    } else {
                        angular.element('#expirationDateTime').data("DateTimePicker").minDate(moment().seconds(0).milliseconds(0).add(1, 'minutes'));
                    }

                    $scope.$apply(function() {
                        vm.flyerEditForm.startDate.$setValidity('minDate', true);
                    });
                } else {
                    vm.flyer.startDate = undefined;
                }
            });

            angular.element("#expirationDateTime").datetimepicker(vm.expireDateOptions).on('dp.change', function(ev) {
                if (ev.date) {
                    vm.flyer.expirationDate = ev.date.format(format);
                    $scope.$apply(function() {
                        vm.flyerEditForm.expirationDate.$setValidity('required', true);
                    });
                } else {
                    vm.flyer.expirationDate = undefined;
                }
            });

            vm.flyer.startDate = vm.flyer.startDate ? moment(vm.flyer.startDate).format(format) : null;
            vm.flyer.expirationDate = vm.flyer.expirationDate ? moment(vm.flyer.expirationDate).format(format) : null;

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubFlyersDetailController', HubFlyersDetailController);

    HubFlyersDetailController.$inject = ['$state', '$scope', '$filter', '$timeout', 'uiGmapGoogleMapApi', 'FlyersCurrencyValue', '$translate', 'FlyerCategoryService', 'StoreService', 'HubFlyersService', '$localStorage', '$q', '$stateParams', 'toastr', '$uibModal' , '$rootScope'];

    function HubFlyersDetailController($state, $scope, $filter, $timeout, uiGmapGoogleMapApi, FlyersCurrencyValue, $translate, FlyerCategoryService, StoreService, HubFlyersService, $localStorage, $q, $stateParams, toastr, $uibModal, $rootScope) {

        var vm = this;

        vm.loadingImage = false;
        vm.mainMap = {
            center: {
                latitude: 0,
                longitude: 0
            },
            zoom: 8,
            controls: {},
            bounds: {}
        };
        vm.options= {
            fullscreenControl: false
        };
        vm.allSelected = false;
        vm.isLoading = true;
        vm.showImage = true;
        vm.mainMap.markers = [];
        vm.showMap = false;
        vm.mainMap.window = {
            model: {},
            show: false,
            options: {
                pixelOffset: {
                    width: -1,
                    height: -65
                }
            },
            closeClick: function() {
                this.show = false;
            }
        }

        uiGmapGoogleMapApi.then(function() {
            loadFlyer();
        });

        vm.openDescriptionModal = openDescriptionModal;

        vm.mainMap.markerEvents = {
            dragend: function(marker, eventName, model) {
                vm.refreshMapWithCoordinates(marker.position.lat(), marker.position.lng());
            },
            mouseover: function(marker, eventName, model, args) {
                vm.mainMap.window.model = model;
                vm.mainMap.window.show = true;
            },
            mouseout: function(marker, eventName, model, args) {
                vm.mainMap.window.show = false;
            },
            click: function(marker, eventName, model, args) {
                if (!isOnlyOneSelected(model)) {
                  for (var i = 0; i < vm.mainMap.markers.length; i++) {
                      if (vm.mainMap.markers[i].id == marker.key) {
                          if (vm.mainMap.markers[i].clicked) {
                              vm.mainMap.markers[i].options.icon = ICON_INACTIVE;
                              vm.mainMap.markers[i].clicked = false;
                              updateFlyer();
                          } else {
                              vm.mainMap.markers[i].options.icon = ICON_ACTIVE;
                              vm.mainMap.markers[i].clicked = true;
                              updateFlyer();
                          }
                      }
                  }
                //   checkAllMarkersIsSelected();
                } else {
                  toastr.error($translate.instant('flyers.detail.error.atLeastOneSelected'));
                }
            }
        };

        vm.firstZoom = true;

        $scope.$watch('vm.mainMap.zoom', function(newVal) {
            if (newVal > 16 && vm.firstZoom) {
                vm.mainMap.zoom = 16;
                vm.firstZoom = false;
            }
        });

        vm.getEditFlyerInfo = function() {
            $uibModal.open({
                templateUrl: 'app/admin/hub-management/flyers/flyers-edit-info.html',
                controller: 'HubFlyersEditInfoController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    flyer: function() {
                        return angular.copy(vm.flyer);
                    }
                }
            }).result.then(function(response) {
                if (response) {
                    vm.flyer = response.data;
                    // It's not needed to load Image again, since that only has changed info
                    // $timeout(function() {
                    //     vm.imagePath = $filter('randomSrc')("/flyer/api/" + vm.flyer.id + "/picture?type=large");
                    // }, 1000);
                    refreshCategory();
                }
            });
        }


        vm.getEditFlyer = function() {
            $state.go('hub-flyers.edit', {
                id: vm.flyer.id
            });

            // $uibModal.open({
            //     templateUrl: 'app/admin/hub-management/flyers/flyers-edit.html',
            //     controller: 'HubFlyersEditController',
            //     controllerAs: 'vm',
            //     backdrop: 'static',
            //     size: 'lg',
            //     resolve: {
            //         flyer: function() {
            //             return angular.copy(vm.flyer);
            //         }
            //     }
            // }).result.then(function(response) {
            //     if (response) {
            //         vm.flyer = response.data;
            //         // It's not needed to load Image again, since that only has changed info
            //         // $timeout(function() {
            //         //     vm.imagePath = $filter('randomSrc')("/flyer/api/" + vm.flyer.id + "/picture?type=large");
            //         // }, 1000);
            //         refreshCategory();
            //     }
            // });
        }

        vm.getEditFlyerImage = function() {
            $uibModal.open({
                templateUrl: 'app/admin/hub-management/flyers/flyers-edit-image.html',
                controller: 'HubFlyersEditImageController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    flyer: function() {
                        return angular.copy(vm.flyer);
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function(response) {
                if (response) {
                    vm.loadingImage = true;
                    vm.flyer = response.data;
                    $timeout(function() {
                        vm.imagePath = $filter('randomSrc')("/flyer/api/" + vm.flyer.id + "/hub-picture?type=large&t=" + new Date().getTime());
                        vm.loadingImage = false;
                    }, 1000);
                    refreshCategory();
                }
            });
        }

        const ICON_ACTIVE = 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/pointactive.png';
        const ICON_INACTIVE = 'content/images/pointinactive.png';

        function isOnlyOneSelected(model){
            var count = 0;
            var modelIsSelected = false;
            for (var i = 0; i < vm.mainMap.markers.length; i++) {
                vm.mainMap.markers[i].clicked ? count++ : null;
                if (vm.mainMap.markers[i].id == model.id){
                    modelIsSelected =  vm.mainMap.markers[i].clicked;
                }
            }

            return (count == 1 && modelIsSelected);

        }

        vm.checkAllMarkers = function() {
            vm.allSelected = !vm.allSelected;
            var icon;
            if (vm.allSelected) {
                icon = ICON_ACTIVE;
            } else {
                icon = ICON_INACTIVE;
            }
            // The index need to begin with 1 because has to left unless one salespoint selected
            if (vm.allSelected){
                var beginsWith = 0;
            }
            else {
                var beginsWith = 1;
            }
            for (var i = beginsWith; i < vm.mainMap.markers.length; i++) {
                vm.mainMap.markers[i].options.icon = icon;
                vm.mainMap.markers[i].clicked = vm.allSelected;
            }
            updateFlyer();
        }

        vm.getFlyerCurrency = function(currency) {
            return FlyersCurrencyValue[currency];
        }


        vm.getFlyerTooltip = function (status) {
            switch (status) {
                case 'ACTIVATED':
                    return 'flyers.offer.active';
                case 'DEACTIVATED':
                    return 'flyers.offer.disabled';
                case 'EXPIRED':
                    return 'flyers.offer.expired';
                case 'CLOSED':
                    return 'flyers.offer.closed';
            }
        }

        function loadFlyer() {
            HubFlyersService.getFlyer($stateParams.id).then(function(response) {
                vm.flyer = response.data;
                vm.imagePath = $filter('randomSrc')("/flyer/api/" + vm.flyer.id + "/hub-picture?type=large");
                refreshCategory();
                StoreService.getSalesPoints($localStorage.defaultStore.storeId).then(function(response) {
                    convertToMarkers(response.data);
                    // checkAllMarkersIsSelected();
                });
            }, function (err) {
                if (err.status == 404){
                    toastr.error($translate.instant('flyers.messages.load.notFound'));
                    $state.go('flyers');

                }
            });
        }

        function checkAllMarkersIsSelected() {
            if (vm.flyer.salesPoint.length === vm.mainMap.markers.length) {
                vm.allMarkersChecked = true;
                vm.allSelected = true;
            } else {
                vm.allMarkersChecked = false;
                vm.allSelected = false;
            }
        }

        function openDescriptionModal(){
            $uibModal.open({
                templateUrl: 'app/admin/flyers/flyers-description-modal.html',
                controller: function(flyerDescription, $uibModalInstance){
                    var vm = this;
                    vm.flyerDescription = flyerDescription;

                    vm.closeModal = function(){
                        $uibModalInstance.dismiss('cancel');
                    }

                    vm.ok = function(){
                        $uibModalInstance.close();
                    }
                },
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    flyerDescription: function() {
                        return angular.copy(vm.flyer.description);
                    }
                }
            }).result
        }

        function convertToMarkers(points) {
            points.forEach(function(point) {
                vm.mainMap.markers.push({
                    pointlocation: {
                        name: point.name,
                        country: point.country,
                        state: point.state,
                        neighborhood: point.neighborhood,
                        number: point.number,
                        address: point.address,
                        city: point.city,
                        id: point.id,
                        postalCode: point.postalCode,
                        contactPhone: point.contactPhone,
                        storeId: vm.store,
                        salesPointId: point.id
                    },
                    latitude: point.coordinate.latitude,
                    longitude: point.coordinate.longitude,
                    id: point.id,
                    clicked: false,
                    options: {
                        icon: ICON_INACTIVE
                    }
                });
            });
            $q.all(vm.mainMap.markers).then(function(markers) {
                // updateFlyerMarkers();
                $timeout(function() {
                    vm.showMap = false;
                    vm.isLoading = false;
                    $timeout(function () {
                        vm.showMap = true;
                    }, 100);
                }, 50);
            });
        }

        function updateFlyerMarkers() {
            vm.flyer.salesPoint.forEach(function(salesPoint) {
                for (var i = 0; i < vm.mainMap.markers.length; i++) {
                    if (salesPoint.salesPointId == vm.mainMap.markers[i].pointlocation.salesPointId) {
                        vm.mainMap.markers[i].clicked = true;
                        vm.mainMap.markers[i].options.icon = ICON_ACTIVE;
                    }
                }
            });
        }

        function updateFlyer() {
            vm.flyer.salesPoint = [];
            vm.mainMap.markers.forEach(function(point) {
                if (point.clicked) {
                    var newPoint = point.pointlocation;
                    newPoint.storeId = $localStorage.defaultStore.storeId;
                    newPoint.location = {
                        type: "POINT",
                        "x": point.latitude,
                        "y": point.longitude,
                        coordinates: [point.latitude, point.longitude]
                    };
                    vm.flyer.salesPoint.push(newPoint);
                }
            });
            $q.all(vm.flyer.salesPoint).then(function(data) {
                HubFlyersService.updateFlyer(vm.flyer).then(function(response) {
                    vm.flyer = response.data;
                    toastr.success($translate.instant('flyers.messages.update.success'));
                    // updateFlyerMarkers();
                    // checkAllMarkersIsSelected();
                    refreshCategory();
                }, function (error) {
                    var header = error.headers();
                    toastr.error($translate.instant(header['x-flyerapp-error']));
                });
            });
        }

        function refreshCategory() {
            FlyerCategoryService.getCategoryTitleByKey(vm.flyer.categoryKey, $translate.use()).then(function(response) {
                vm.flyer.category = response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hub-flyers', {
            parent: 'admin',
            url: '/hub-flyers',
            data: {
                authorities: ['STORE_READ_FLYER'],
                pageTitle: 'global.hub.products-distribute'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/hub-management/flyers/flyers.html',
                    controller: 'HubFlyersController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                type: null,
                brand: null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('flyers');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hub-flyers.new', {
            url: '/hub-new',
            data: {
                pageTitle: 'flyers.new.title',
                authorities: ['STORE_CREATE_FLYER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/hub-management/flyers/flyers-form.html',
                    controller: 'HubFlyersFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('flyers');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('brand');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hub-flyers.edit', {
            url: '/hub-edit/{id}',
            data: {
                pageTitle: 'flyers.edit.title',
                authorities: ['STORE_UPDATE_FLYER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/hub-management/flyers/flyers-form.html',
                    controller: 'HubFlyersFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('flyers');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('brand');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hub-flyers-detail', {
            parent: 'hub-flyers',
            url: '/{id}',
            data: {
                authorities: ['STORE_READ_FLYER', 'STORE_UPDATE_FLYER'],
                pageTitle: 'flyers.detail.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/hub-management/flyers/flyers-detail.html',
                    controller: 'HubFlyersDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('flyers');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('store-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('hub-flyers.import', {
            parent: 'admin',
            url: '/hub-flyers-import',
            data: {
                pageTitle: 'flyers.import.title',
                authorities: ['STORE_CREATE_FLYER'],
                specialClass: "md-skin fixed-nav"
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/hub-management/flyers/import/hub-flyer-import.html',
                    controller: 'HubFlyerImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('flyers');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('HubFlyersService', HubFlyersService);

    HubFlyersService.$inject = ['HubFlyersFactory', '$localStorage', 'Upload'];

    function HubFlyersService(HubFlyersFactory, $localStorage, Upload) {

        var service = {
            createFlyer: createFlyer,
            saveFlyerImage: saveFlyerImage,
			saveFlyerMultiImage: saveFlyerMultiImage,
            deleteFlyers: deleteFlyers,
            listFlyers: listFlyers,
            listFlyersPage: listFlyersPage,
            listFlyersFiltered: listFlyersFiltered,
            updateFlyer: updateFlyer,
            getFlyer: getFlyer,
            getNumberOfFlyers: getNumberOfFlyers,
            getFlyerTypes: getFlyerTypes,
            listAllFlyers: listAllFlyers,
            getImageFlyer: getImageFlyer,
            getLinkImageFlyerAsString: getLinkImageFlyerAsString,
            listAllToAdmin: listAllToAdmin,
            listFlyersPageToModal: listFlyersPageToModal,
            flyersImportStatus: flyersImportStatus,
            listAllFlyersByHub: listAllFlyersByHub,
            listAllFlyersByBrand: listAllFlyersByBrand,
            importFlyersFromVtex: importFlyersFromVtex
        };

        return service;

        function createFlyer(flyer) {
            return HubFlyersFactory.save(flyer).$promise;
        }

        function listFlyers(pageable, filter, onSuccess, onError) {
            return HubFlyersFactory.listAll(pageable, filter, onSuccess, onError);
        }

        function listAllToAdmin(pageable, filter, onSuccess, onError) {
            return HubFlyersFactory.listAllToAdmin(pageable, filter, onSuccess, onError);
        }

        function listFlyersPage(pageable, filter, onSuccess, onError) {
            return HubFlyersFactory.listAllPageable(pageable, filter, onSuccess, onError);
        }

        function listFlyersFiltered(pageable, filter, onSuccess, onError) {
            return HubFlyersFactory.listAllFiltered(pageable, filter, onSuccess, onError);
        }

        function listFlyersPageToModal(pageable) {
            return HubFlyersFactory.listAllPageableToModal(pageable, { storeId: $localStorage.defaultStore.storeId }).$promise;
        }

        function deleteFlyers(flyerIds) {
            return HubFlyersFactory.deletebyids({flyerIds: flyerIds}).$promise;
        }

        function getFlyer(flyer) {
            return HubFlyersFactory.get({flyerId: flyer, storeId: $localStorage.defaultStore.storeId}).$promise;
        }

        function updateFlyer(flyer) {
            return HubFlyersFactory.update(flyer).$promise;
        }

        function saveFlyerImage(image) {
            return Upload.upload({url: 'zuul/flyer/api/upload', data: {file: image}});
        }

        function saveFlyerMultiImage(image, orderNumber) {
            return Upload.upload({url: 'zuul/flyer/api/multiUpload', data: {file: image, orderNumber: orderNumber}});
        }

        function getNumberOfFlyers(storeId) {
            return HubFlyersFactory.numberOfFlyers({storeId: storeId}).$promise;
        }

        function getFlyerTypes(storeId) {
            return HubFlyersFactory.getFlyerTypes().$promise;
		}

        function listAllFlyers() {
            return HubFlyersFactory.listAllFlyers().$promise;
        }

        function getImageFlyer(flyerId) {
            return HubFlyersFactory.flyerImage({id: flyerId}).$promise;
        }

        function getLinkImageFlyerAsString(flyerId) {
            return HubFlyersFactory.flyerLinkImageAsString({id: flyerId}).$promise;
        }

        function flyersImportStatus(importId) {
            return HubFlyersFactory.flyersImportStatus({id: $localStorage.hub.id, importId: importId}).$promise;
        }

        function listAllFlyersByHub() {
            return HubFlyersFactory.listAllFlyersByHub().$promise;
        }

        function listAllFlyersByBrand(brand) {
            return HubFlyersFactory.listAllFlyersByBrand({brand: brand}).$promise;
        }

        function importFlyersFromVtex(hub) {
            var param = {
                hub: hub
            }
            return HubFlyersFactory.importFlyersFromVtex(param).$promise;
        }

    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('HubFlyersFactory', HubFlyersFactory);

        HubFlyersFactory.$inject = ['$resource'];

    function HubFlyersFactory($resource) {
        var resourceUrl =  'flyer/api/hub-flyer/:flyerId';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'numberOfFlyers': {
                method: 'GET',
                url: 'flyer/api/store/:storeId/numberOfFlyers',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getFlyerTypes': {
                method: 'GET',
                url: 'flyer/api/flyer/getFlyerTypes',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deletebyids': {
                method: 'POST',
                url: '/flyer/api/hub-flyer/deletebyids'
            },
            'fileUpload': {
                method: 'POST',
                url: '/flyer/api/flyer/upload'
            },
            'listAll': {
                method: 'POST',
                url: 'flyer/api/hub-flyer/list',
                isArray: true
            },
            'listAllToAdmin': {
                method: 'GET',
                url: 'flyer/api/hub-flyer/listall',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'listAllFlyers': {
                method: 'GET',
                url: 'flyer/api/hub-flyer/listall',
                isArray: true,
                cache: false
            },
            'listAllPageable': {
                method: 'POST',
                url: 'flyer/api/hub-flyer/list/page',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'listAllFiltered': {
                method: 'POST',
                url: 'flyer/api/hub-flyer/filtered',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'listAllPageableToModal': {
                method: 'POST',
                url: 'flyer/api/flyer/list/page/to-modal',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'flyerImage': {
                method: 'GET',
                url: 'flyer/api/:id/hub-picture',
                cache: false
            },
            'flyerLinkImageAsString': {
                method: 'GET',
                url: 'flyer/api/:id/hub-picture-link-as-string',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'update': {
                method:'PUT',
                cache: false,
                timeout: 20000,
                transformResponse: function (data, headers) {
                    if(data){
                        var response = {};
                        response.data = angular.fromJson(data);
                        response.headers = headers();
                        return response;
                    }
                }
            },
            'flyersImportStatus': {
                method: 'GET',
                url: 'flyer/api/hub-flyer/hub/:id/import-flyers-from-table/:importId',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'listAllFlyersByHub': {
                method: 'GET',
                url: 'flyer/api/hub-flyer/list-all-by-hub',
                isArray: true,
                cache: false
            },
            'listAllFlyersByBrand': {
                method: 'GET',
                url: 'flyer/api/hub-flyer/list-all-by-brand/:brand',
                isArray: true,
                cache: false
            },
            'importFlyersFromVtex': {
                method: 'POST',
                url: 'flyer/api/hub/:hub/import-flyers/',
                params: {
                    hub: '@hub'
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubFlyersController', HubFlyersController);

    function HubFlyersController(FlyersCurrencyValue, Principal, $translate, $localStorage, $state, HubFlyersService,
        toastr, RemoveModalFactory, paginationConstants, StoreService, $stateParams, HubService, BrandService, StoreTypeService,
        ConfirmPublishModalFactory) {

        var vm = this;

        vm.currentPage = 1;
        vm.numPerPage = 70;
        vm.maxSize = 5;
        vm.totalFlyers = 0;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage
        };

        vm.requestParamsStore = {
            page: 0,
            size: 25
        }
        vm.isStoresAvailable = true;
        vm.quantStoresSelected = 0;

        vm.colors = getAllColors();
        vm.flyerName = '';
        vm.flyersFiltered = [];
        vm.flyersTypes = [];
        vm.displayType = "Table";
        vm.zeroOffers = false;
        vm.displayTypeList = ["Cards", "Table"];
        vm.startDate = {
            startDate: null,
            endDate: null
        };
        vm.tabInfo = {
            existsCouponsFlyer: false,
            existsRentFlyer: false,
            existsContactFlyer: false,
            existsSaleFlyer: false
        };
        vm.showCouponsWithActive = false;
        vm.isLoading = true;
        vm.listFlyers = true;
        vm.loadingArray = ["1", "2", "3", "4"];
        vm.selectedFlyers = [];
        vm.listFilter = {
            hub: $localStorage.defaultStore.hubId
        };
        vm.selectedAllHub = false;
        vm.brandGroups = {};
        vm.filters = {
            active: false,
            inactive: false
        };
        vm.userIsAdmin = false;

        vm.flyersToRemove = [];

        vm.mySalePoints = [];

        vm.page = 0;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.hasNextPage = false;
        vm.busy = false;
        vm.loadingTab = true;
        vm.isAvailable = false;

        vm.hubId = $localStorage.defaultStore.hubId;
        vm.time_stamp_to_image = '';

        checkUserIsAdmin();
        getFlyersTypes();
        vm.storeTypes = [];
        StoreTypeService.getAllStoreTypesByOwner().then(function(response) {
            vm.storeTypes = response.data;
        });

        vm.stores = [];
        vm.storesSelected = [];
        vm.storeName = '';

        vm.changePage = function() {

            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            // vm.customers = listCustomers(vm.paginationOptions, vm.filter, true);
            loadFlyers();
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;

        };

        vm.currencyConfiguration = getCurrencyListConfiguration();

        vm.tabClick = function(brand) {
            vm.loadingTab = true;

            // Changes the type to the new type Clicked
            vm.listFilter.brand = brand.name;

            // Erases the offer list
            vm.flyersFiltered = [];

            // Turn to 0 the page to give right page on pageable
            vm.page = 0;

            // loadOffers
            loadFlyers();

        };

        function checkUserIsAdmin() {
            Principal.hasAuthority("ADMIN_MANAGE_SYSTEM").then(function(result) {
                if (result) {
                    vm.userIsAdmin = true;
                } else {
                    vm.userIsAdmin = false;
                }
            });
        }

        vm.stopPropagation = function(event) {
            event.stopPropagation();
        };

        vm.changeStatusFilterToActive = function() {
            vm.loadingTab = true;
            vm.page = 0;
            if (vm.filters.active) {
                vm.filters.inactive = false;
                vm.listFilter.status = "ACTIVATED";
            }
            checkIsListAll();
            loadFlyers();
        };

        function getMySalePoints() {
            if (vm.listFilter.storeId) {
                StoreService.getSalesPoints(vm.listFilter.storeId).then(function(response) {
                    vm.mySalePoints = response.data;
                });
            }
        }

        vm.changeStatusFilterToInactive = function() {
            vm.loadingTab = true;
            vm.page = 0;
            if (vm.filters.inactive) {
                vm.filters.active = false;
                vm.listFilter.status = "DEACTIVATED";
            }
            checkIsListAll();
            loadFlyers();
        };

        function checkIsListAll() {
            vm.loadingTab = true;
            vm.page = 0;
            vm.flyersFiltered = [];
            if (!vm.filters.inactive && !vm.filters.active) {
                vm.listFilter.status = null;
                loadFlyers();
            }
        }


        vm.checkType = function(type) {
            vm.createArray("displayType", vm.displayTypeList.length, false);
            vm.displayTypeListCheck[vm.displayTypeList.indexOf(type)] = true;
            vm.displayType = type;
        };

        vm.isEven = function(number) {
            return (number % 2 === 0);
        };

        vm.refreshSelectedFlyers = function (flyer) {
            vm.brandGroups[flyer.brand] = vm.brandGroups[flyer.brand] ? { size: vm.brandGroups[flyer.brand].size } : { size: 0 };
            if (vm.selectedFlyers.indexOf(flyer.id) != '-1') {
                vm.brandGroups[flyer.brand].size = vm.brandGroups[flyer.brand].size - 1;
                vm.selectedFlyers.splice(vm.selectedFlyers.indexOf(flyer.id), 1);
            } else {
                vm.brandGroups[flyer.brand].size = vm.brandGroups[flyer.brand].size + 1;
                vm.selectedFlyers.push(flyer.id);
            }
        };

        vm.getCountSelectedByBrand = function (brand) {
            if (vm.selectedFlyers && vm.selectedFlyers.length && !vm.selectedAllHub) {
                return vm.brandGroups[brand] ? vm.brandGroups[brand].size : vm.brandGroups[brand];
            }

            return 0;
        };

        vm.importFromVtex = function() {
            HubFlyersService.importFlyersFromVtex(vm.hubId).then(function (data) {
                toastr.success($translate.instant('flyers.import.vtex-success-msg'));
            });
        };

        vm.existsSelectedItems = function() {
            return vm.selectedFlyers.length >= 1;
        };

        vm.cleanSelection = function () {
            vm.selectedFlyers = [];
            vm.selectedAllHub = false;
            vm.brandGroups = {};
        }

        vm.selectAllPage = function () {
            if (vm.selectedAllHub) {
                vm.selectedFlyers = [];
                vm.selectedAllHub = false;
            }
            if (vm.brandGroups[vm.listFilter.brand] && vm.brandGroups[vm.listFilter.brand].selectedAllBrand) {
                HubFlyersService.listAllFlyersByBrand(vm.listFilter.brand).then(function (data) {
                    angular.forEach(data, function (flyer) {
                        vm.selectedFlyers.pop(flyer.id);
                    });
                    selectItemOfPage();
                });

            } else {
                selectItemOfPage();
            }
        };

        function selectItemOfPage() {
            vm.brandGroups[vm.listFilter.brand] = { size: vm.flyersFiltered.length, selectedAllBrand: false, selectedAllPage: true }
            angular.forEach(vm.flyersFiltered, function (flyer) {
                if (vm.selectedFlyers.indexOf(flyer.id) === -1) {
                    vm.selectedFlyers.push(flyer.id);
                }
            });
        }

        vm.selectAllItemsAllHub = function () {
            vm.loadingTab = true;
            vm.selectedFlyers = [];
            vm.brandGroups = {};
            HubFlyersService.listAllFlyersByHub().then(function (data) {
                vm.selectedAllHub = true;
                angular.forEach(data, function (flyer) {
                    vm.selectedFlyers.push(flyer.id);
                });
                vm.loadingTab = false;
            });
        }

        vm.selectAllItemsAllBrand = function () {
            HubFlyersService.listAllFlyersByBrand(vm.listFilter.brand).then(function (data) {
                if (vm.selectedAllHub) {
                    vm.selectedFlyers = [];
                    vm.selectedAllHub = false;
                }
                vm.brandGroups[vm.listFilter.brand] = { size: data.length, selectedAllBrand: true, selectedAllPage: false }
                angular.forEach(data, function (flyer) {
                    if (vm.selectedFlyers.indexOf(flyer.id) === -1) {
                        vm.selectedFlyers.push(flyer.id);
                    }
                });
            });
        }

        vm.changeDisplayType = function() {
            vm.displayType = vm.displayType === 'Table' ? 'Cards' : 'Table';
        };

        vm.checkDisplayType = function(type) {
            return (vm.displayType === type);
        };

        vm.changeActivated = function() {
            vm.loadingTab = true;
            vm.page = 0;
            if (vm.listFilter.activated === null) {
                vm.listFilter.activated = true;
            } else {
                vm.listFilter.activated = !vm.listFilter.activated;
            }
            loadFlyers();
        };


        vm.openCalendarStart = function(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenCalendarStart = true;
        };

        vm.openCalendarExpire = function(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenCalendarExpire = true;
        };

        vm.flyerDetailPage = function(flyerId) {
            $state.go('hub-flyers.edit', {
                id: flyerId
            });
        };

        vm.migrateFlyers = function() {
            vm.isAvailable = true;

            if (vm.selectedFlyers.length >= 1) {
                var cleanOptions = function() {
                    vm.isAvailable = false;
                    // vm.selectedFlyers = [];
                    // vm.brandGroups = {};
                    vm.storesSelected = [];
                }
                var stores = vm.stores.filter(function(store) {
                    return vm.storesSelected.includes(store.storeId);
                });

                if (vm.storeTypeId && vm.storeTypeId > 0) {
                    HubService.migrateFlyersToStoresByStoreType(vm.selectedFlyers, vm.storeTypeId).then(function() {
                        toastr.success($translate.instant('flyers.messages.global.distribution-started'));
                        cleanOptions();
                    });
                } else if (stores.length > 0) {
                    HubService.migrateFlyersToStores(vm.selectedFlyers, stores).then(function(data) {
                        toastr.success($translate.instant('flyers.messages.global.distribution-started'));
                        cleanOptions();
                    });
                } else {
                    ConfirmPublishModalFactory.publishItem().then(function(data) {
                        if(data) {
                            HubService.migrateFlyersToStores(vm.selectedFlyers, stores).then(function(data) {
                                toastr.success($translate.instant('flyers.messages.global.distribution-started'));
                                cleanOptions();
                            });
                        }
                    }, function(err) {
                        vm.isAvailable = false;
                    });
                }
            }
        };

        vm.removeFlyers = function() {
            if (vm.selectedFlyers.length >= 1) {
                RemoveModalFactory.deleteItem(vm.selectedFlyers.length).then(function(data) {
                    HubFlyersService.deleteFlyers(vm.selectedFlyers).then(function(data) {
                        toastr.success($translate.instant('flyers.messages.remove.success'));
                        vm.selectedFlyers = [];
                        $state.reload();
                    }, function(data) {
                        toastr.error($translate.instant('flyers.messages.remove.error'));
                    });
                });
            } else {
                toastr.error($translate.instant('flyers.messages.remove.noItens'));
            }
        };

        vm.getFlyerCurrency = function(currency) {
            return FlyersCurrencyValue[currency];
        };

        vm.checkStoreIsSelected = function(id) {
            return vm.storesSelected.includes(id);
        }

        vm.changeStoreSelected = function(store) {
            if (vm.checkStoreIsSelected(store.storeId)) {
                vm.storesSelected = vm.storesSelected.filter(function(id) {
                    return store.storeId !== id;
                });
            } else {
                vm.storesSelected.push(store.storeId);
            }
        }

        vm.markAllStoreType = function() {
            if (!vm.storeTypeId || vm.storeTypeId == '') {
                vm.storesSelected = [];
                vm.quantStoresSelected = 0;
                return;
            }
            StoreService.countStoresByCurrentHubAndStoreType(vm.storeTypeId).then(function(response) {
                vm.quantStoresSelected = response.count;
            });

            var storeType = vm.storeTypes.find(function(storeType) {
                return vm.storeTypeId == storeType.id;
            });

            vm.storesSelected = [];
            vm.stores.forEach(function(store) {
                if (store.storeType === storeType.name) vm.changeStoreSelected(store);
            });
        }

        vm.hasStoreSelected = function() {
            return vm.quantStoresSelected > 0;
        }

        vm.fetchMoreStores = function() {
            vm.requestParamsStore.page = vm.requestParamsStore.page + 1;
            loadStores(vm.requestParamsStore);
        }

        function loadStores(pageOptions) {
            vm.isStoresAvailable = false;
            StoreService.listStoresByCurrentHub({}, pageOptions, function(data, headers) {
                vm.stores = data;
                vm.markAllStoreType();
                vm.isStoresAvailable = true;
            }, function(error) {
                vm.isStoresAvailable = true;
            });
        }

        vm.onChangeStoreName = function() {
            vm.requestParamsStore.name = vm.storeName;
            loadStores(vm.requestParamsStore);
        }

        function loadAll() {
            vm.time_stamp_to_image = '?' + Date.now();
            vm.requestParamsStore.name = vm.storeName;
            loadStores(vm.requestParamsStore);

            BrandService.getBrandsByCurrentStore().then(function(response) {
                vm.brands = response.data;

                if ($stateParams.brand) {
                    vm.listFilter.brand = $stateParams.brand;
                }
                else {
                    vm.listFilter.brand = response.data[0].name;
                }
                loadFlyers();
            });
            if ($stateParams.type) {
                vm.loadingTab = true;

                // Changes the type to the new type Clicked
                // vm.listFilter.type = $stateParams.type;

                // Erases the offer list
                vm.flyersFiltered = [];

                // Turn to 0 the page to give right page on pageable
                vm.page = 0;
            }
            getMySalePoints();
        }

        function getFlyersTypes() {
            HubFlyersService.getFlyerTypes().then(function(response) {
                var removeRent = response.data.map(function(item) {
                    return item.code;
                }).indexOf('RENT');
                response.data.splice(removeRent, 1);
                var removeContact = response.data.map(function(item) {
                    return item.code;
                }).indexOf('CONTACT');
                response.data.splice(removeContact, 1);
                vm.flyersTypes = response.data;
            });
        }

        vm.loadFlyers = function(page, reset) {
            if (reset) {
                vm.reset();
            } else vm.page = page;

            getFlyersTypes();
            loadFlyers();
        };

        vm.reset = function reset() {
            vm.page = 0;
            vm.flyersFiltered = [];
        };

        vm.checkIfFlyerSelected = function(flyerId) {
            return vm.selectedFlyers.indexOf(flyerId) != '-1';
        };

        vm.getFlyerTooltip = function(status) {
            switch (status) {
                case 'ACTIVATED':
                    return 'flyers.offer.active';
                case 'DEACTIVATED':
                    return 'flyers.offer.disabled';
                case 'EXPIRED':
                    return 'flyers.offer.expired';
                case 'CLOSED':
                    return 'flyers.offer.closed';
            }
        };

        vm.onChangeFlyerName = function() {
            loadFlyers();
        };

        function loadFlyers() {
            if (vm.busy) return;
            vm.busy = true;

            // if (!vm.listFilter.type){
            //     vm.listFilter.type = 'COUPON';
            // }

            var pageable = {
                page: vm.page,
                size: 50
                // size: 1000 || vm.itemsPerPage
            };

            vm.listFilter.hub = $localStorage.defaultStore.hubId;

            HubFlyersService.listFlyers(vm.paginationOptions, vm.listFilter, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.zeroOffers = data.length <= 0;
                if (vm.zeroOffers) {
                    vm.flyersFiltered = [];
                } else {
                    vm.flyersFiltered = data;
                }
                vm.totalFlyers = headers('X-Total-Count');

                vm.isLoading = false;
                vm.busy = false;
                vm.loadingTab = false;
            }

            function onError(error) {
                vm.busy = false;
                vm.loadingTab = false;
                vm.isLoading = false;
                toastr.error($translate.instant('flyers.messages.load.error'));
            }
        }

        loadAll();
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('ngFileModel', ['$parse', function ($parse) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var model = $parse(attrs.ngFileModel);
                    var isMultiple = attrs.multiple;
                    var modelSetter = model.assign;
                    element.bind('change', function () {
                        var values = [];
                        angular.forEach(element[0].files, function (item) {
                            var value = {
                                // File Name
                                name: item.name,
                                //File Size
                                size: item.size,
                                //File URL to view
                                url: URL.createObjectURL(item),
                                // File Input Value
                                blob: item
                            };
                            values.push(value);
                        });
                        scope.$apply(function () {
                            if (isMultiple) {
                                modelSetter(scope, values);
                            } else {
                                modelSetter(scope, values[0]);
                            }
                        });
                    });
                }
            };
        }]);

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('file-manager', {
            parent: 'admin',
            url: '/file-manager',
            data: {
                pageTitle: 'file-manager.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/hub-management/file-manager/file-manager.html',
                    controller: 'FileManagerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('file-manager');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .service('FileManagerService', FileManagerService);

    FileManagerService.$inject = ['FileManagerFactory', '$http'];

    function FileManagerService(FileManagerFactory, $http) {

        var service = {
            createEditFolder: createEditFolder,
            deleteFolder: deleteFolder,
            getFolderChildren: getFolderChildren,
            getFolderFiles: getFolderFiles,
            uploadFile: uploadFile,
            updateFile: updateFile,
            deleteFile: deleteFile,
            filterFiles: filterFiles,
            getFileTags: getFileTags
        };

        return service;

        function createEditFolder(hubId, folder) {
            if (folder.id) {
                return FileManagerFactory.editFolder({hubId: hubId}, folder).$promise;
            }
            return FileManagerFactory.createFolder({hubId: hubId}, folder).$promise;
        }

        function deleteFolder(hubId, folderId) {
            return FileManagerFactory.deleteFolder({ hubId: hubId, folderId: folderId }).$promise;
        }

        function getFolderChildren(hubId, folderId) {
            return FileManagerFactory.getFolderChildren({ hubId: hubId, folderId: folderId }).$promise;
        }

        function getFolderFiles (hubId, folderId) {
            return FileManagerFactory.getFolderFiles({ hubId: hubId, folderId: folderId }).$promise;
        }

        function getFileTags(hubId) {
            return FileManagerFactory.getFileTags({ hubId: hubId }).$promise;
        }



        function updateFile(hubId, file) {
            return FileManagerFactory.updateFile({ hubId: hubId }, file).$promise;
        }

        function filterFiles(hubId, name, tags) {
            return $http({
                method: 'GET',
                url: 'admin/api/gcs-manager/hub/' + hubId + '/file?tags=' +  tags + "&name=" + name,
            });
        }

        function uploadFile(hubId, data) {
            return $http({
                method: 'POST',
                url: 'admin/api/gcs-manager/hub/' + hubId + '/file' ,
                data: data,
                headers:{
                    'Content-Type': undefined,
                    'Accept':'application/json'
                }
            });
        }

        function deleteFile(hubId, fileId) {
            return FileManagerFactory.deleteFile({ hubId: hubId, fileId: fileId }).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('FileManagerFactory', FileManagerFactory);

    FileManagerFactory.$inject = ['$resource'];

    function FileManagerFactory($resource) {
        var resourceUrl =  'admin/api/gcs-manager/hub/:hubId';

        return $resource(resourceUrl, {hubId: '@hubId', folderId: '@folderId', fileId: '@fileId'}, {
            'createFolder': {
                method: 'POST',
                url: resourceUrl +  '/folder',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'editFolder': {
                method: 'PUT',
                url: resourceUrl +  '/folder',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deleteFolder': {
                method: 'DELETE',
                url: resourceUrl + '/folder/:folderId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getFolderChildren': {
                method: 'GET',
                url: resourceUrl + '/folder/:folderId/children',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getFolderFiles': {
                method: 'GET',
                url: resourceUrl + '/folder/:folderId/file',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'uploadFile': {
                method: 'POST',
                url: resourceUrl +  '/file',
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined},
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'updateFile': {
                method: 'PUT',
                url: resourceUrl +  '/file',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deleteFile': {
                method: 'DELETE',
                url: resourceUrl + '/file/:fileId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getFileTags': {
                method: 'GET',
                url: resourceUrl + '/tag',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FileManagerController', FileManagerController);

    function FileManagerController(FileManagerService, $uibModal, $scope, $localStorage, $translate, toastr) {

        var vm = this;

        vm.hubId = $localStorage.hub.id;
        vm.currentFolder = {id: -1};
        vm.children = [];
        vm.files = [];
        vm.tags = [];
        vm.breadcrumbs = [];
        vm.filterName = "";
        vm.filterTags = [];
        vm.loadingChildren = true;
        vm.loadingFiles = true;
        vm.loadingBreadcrumb = false;

        getFolderChildren(vm.currentFolder);
        getFolderFiles(vm.currentFolder);
        getFileTags();

        vm.enterInFolder = function (folder) {
            vm.filtring = false;
            vm.currentFolder = folder;
            clearFilter();
            getFolderChildren(vm.currentFolder);
            getFolderFiles(vm.currentFolder);
            if (vm.currentFolder.id === -1) {
                vm.breadcrumbs = [{id: -1, name: $translate.instant("file-manager.folder.home")}];
                vm.loadingBreadcrumb = false;
            } else {
                vm.loadingBreadcrumb = true;
                vm.breadcrumbs = mountBreadCrumb(folder, [{id: -1, name: $translate.instant("file-manager.folder.home")}]);
                setTimeout(function () {
                    vm.loadingBreadcrumb = false;
                    $scope.$apply();
                }, 650);
            }
        }

        vm.createEditFolder = function (folder) {
            return $uibModal.open({
                templateUrl: "app/admin/hub-management/file-manager/_modal_add_edit_folder.html",
                size: 'md',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                backdrop: 'static',
                resolve: {
                    folder: function () {
                        if (!folder.id) {
                            return  {
                                hubId: vm.hubId,
                                parent: vm.currentFolder.id === -1 ? null : vm.currentFolder,
                                name: ''
                            }
                        } else {
                            return folder;
                        }
                    }
                },
                controller: function ($uibModalInstance, FileManagerService, toastr, $translate, folder) {
                    var vm = this;

                    vm.folder = folder

                    vm.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };

                    vm.save = function () {
                        vm.submitting = true;
                        if (vm.formFolder.$valid) {
                            FileManagerService.createEditFolder(vm.folder.hubId, vm.folder)
                                .then(function () {
                                    toastr.success($translate.instant("file-manager.message.folder-created"));
                                    $uibModalInstance.close();
                                }, function () {
                                    toastr.error($translate.instant("file-manager.message.error-to-create-folder"));
                                }).finally(function () { vm.submitting = false; });
                        } else {
                            touchForm(vm.formFolder)
                            vm.submitting = false;
                        }
                    }
                },
                controllerAs: "vm"
            }).result.then(function() {
                getFolderChildren(vm.currentFolder);
            });
        }

        vm.editFile = function (file) {
            return $uibModal.open({
                templateUrl: "app/admin/hub-management/file-manager/_modal_edit_file.html",
                size: 'lg',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                backdrop: 'static',
                resolve: {
                    file: function () {
                        return angular.copy(file);
                    },
                    tags: function () {
                        return angular.copy(vm.tags);
                    }
                },
                controller: function ($uibModalInstance, FileManagerService, toastr, $translate, file, tags) {
                    var vm = this;

                    var fileExtension = "." + file.name.substring(file.name.lastIndexOf(".") + 1)

                    vm.file = file;
                    vm.file.name = vm.file.name.replace(fileExtension, '');
                    vm.currentTags = tags;


                    vm.searchTags = function (search) {
                        return vm.currentTags.filter( function (tag) {
                            return tag.name.toLowerCase().indexOf(search.toLocaleLowerCase()) >= 0;
                        });
                    }

                    vm.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };

                    vm.save = function () {
                        if (vm.formFile.$valid) {
                            vm.submitting = true;
                            vm.file.tags = vm.file.tags.map(function (tag) {
                                return {id: tag.id, name: tag.name}
                            })
                            vm.file.name = vm.file.name + fileExtension;
                            FileManagerService.updateFile(vm.file.hubId, vm.file)
                                .then(function () {
                                    toastr.success($translate.instant("file-manager.message.file-updated"));
                                    $uibModalInstance.close();
                                }, function () {
                                    vm.file.name = vm.file.name.replace(fileExtension, '');
                                    toastr.error($translate.instant("file-manager.message.error-to-update-file"));
                                }).finally(function () { vm.submitting = false; });
                        } else {
                            touchForm(vm.formFile)
                            vm.submitting = false;
                        }
                    }
                },
                controllerAs: "vm"
            }).result.then(function() {
                getFolderFiles(vm.currentFolder);
                getFileTags();
            });
        }

        vm.uploadFiles = function () {
            return $uibModal.open({
                templateUrl: "app/admin/hub-management/file-manager/_modal_upload_files.html",
                size: 'lg',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                backdrop: 'static',
                resolve: {
                    parent: function () {
                        return vm.currentFolder;
                    },
                    hubId: function () {
                        return vm.hubId;
                    },
                    tags: function () {
                        return vm.tags;
                    }
                },
                controller: function ($uibModalInstance, FileManagerService, toastr, $translate,  parent, hubId, tags) {
                    var vm = this;

                    vm.files = [];
                    vm.currentTags = tags;
                    vm.tags = []

                    vm.searchTags = function (search) {
                        return vm.currentTags.filter( function (tag) {
                            return tag.name.toLowerCase().indexOf(search.toLocaleLowerCase()) >= 0;
                        });
                    }


                    vm.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };

                    vm.remove = function (index) {
                        if (vm.submitting) {
                            return;
                        }
                        vm.files.splice(index, 1);
                    }

                    vm.upload = function () {
                        vm.submitting = true;
                        uploadSync(0);
                    }

                    function uploadSync(index) {
                        if (index > vm.files.length -1) {
                            vm.submitting = false;
                            toastr.success($translate.instant("file-manager.message.files-uploaded"));
                            $uibModalInstance.close();
                            return;
                        }

                        var tagsObject = vm.tags.map(function (tag) {
                            return {id: tag.id, name: tag.name}
                        })

                        var file = vm.files[index];

                        if (file && file.status === 'SUCCESS') {
                            uploadSync(index + 1);
                        }

                        file.status = "IN_PROGRESS";
                        var fileInfo = {
                            hubId: hubId,
                            parent: parent.id === -1 ? null : parent,
                            name: file.name,
                            size: file.size,
                            type: file.blob.type,
                            tags: tagsObject
                        }

                        var data = new FormData();
                        data.append('file', file.blob, file.name)
                        data.append('fileInfo', new Blob([JSON.stringify(fileInfo)], {type: "application/json"}));

                        FileManagerService.uploadFile(hubId, data)
                            .then(function () {
                                file.status = "SUCCESS";
                                uploadSync(index + 1);
                            }, function () {
                                vm.submitting = false;
                                file.status = "ERROR";
                                toastr.error($translate.instant("file-manager.message.error-to-upload-file"));
                            })
                    }
                },
                controllerAs: "vm"
            }).result.then(function() {
                getFolderFiles(vm.currentFolder);
                getFileTags();
            });
        }

        vm.deleteConfirmation = function (isFolder, object, callback) {
            return $uibModal.open({
                templateUrl: "app/admin/hub-management/file-manager/_modal_delete_confirmation.html",
                size: 'md',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                backdrop: 'static',
                resolve: {
                    isFolder: function () {
                        return isFolder;
                    },
                    objectName: function () {
                        return object.name;
                    }
                },
                controller: function ($uibModalInstance, FileManagerService, $translate, isFolder, objectName) {
                    var vm = this;

                    vm.objectName = objectName;
                    vm.isFolder = isFolder;

                    vm.confirm = function (confirm) {
                        $uibModalInstance.close(confirm);
                    }
                },
                controllerAs: "vm"
            }).result.then(function(confirmation) {
                if (confirmation) {
                    callback(object.id);
                }
            });
        }

        vm.deleteFolder = function (folderId) {
            FileManagerService.deleteFolder(vm.hubId, folderId)
                .then(function () {
                    getFolderChildren(vm.currentFolder);
                    getFileTags();
                    toastr.success($translate.instant("file-manager.message.folder-deleted"));
                }, function () {
                    toastr.error($translate.instant("file-manager.message.error-to-delete-folder"));
                });
        }

        vm.deleteFile = function (fileId) {
            FileManagerService.deleteFile(vm.hubId, fileId)
                .then(function () {
                    getFolderFiles(vm.currentFolder);
                    getFileTags();
                    toastr.success($translate.instant("file-manager.message.file-deleted"));
                }, function () {
                    toastr.error($translate.instant("file-manager.message.error-to-delete-file"));
                });
        }

        vm.getFileType = function (type) {
            type = type.split('/')[0];
            switch (type){
                case 'image':
                    return 'IMAGE'
                case 'video':
                    return 'VIDEO';
                default:
                    return 'OTHER';
            }
        }

        vm.getFileName = function (originalName) {
            var extension = "." + originalName.substring(originalName.lastIndexOf(".") + 1);
            return originalName.substring(0, 14) + '(...)' + extension;
        }

        vm.filterByName = function () {
            filterFiles();
        }

        vm.filterByTag = function (tag) {
            var index = _.findIndex(vm.filterTags,function (t) { return t  === tag.id })
            if (index >= 0) {
                tag.selected = false;
                vm.filterTags.splice(index, 1);
            } else {
                tag.selected = true;
                vm.filterTags.push(tag.id)
            }
            filterFiles();
        }

        function getFolderChildren(folder) {
            vm.loadingChildren = true;
            FileManagerService.getFolderChildren(vm.hubId, folder.id)
                .then(function (result) {
                    vm.children = result.data;
                    vm.loadingChildren = false;
                }, function () {
                    toastr.error($translate.instant("file-manager.message.error-to-load-folder-children"));
                    vm.loadingChildren = false;
                });
        }

        function getFolderFiles(folder) {
            vm.loadingFiles = true;
            FileManagerService.getFolderFiles(vm.hubId, folder.id)
                .then(function (result) {
                    vm.files = result.data;
                    vm.loadingFiles = false;
                }, function () {
                    toastr.error($translate.instant("file-manager.message.error-to-load-folder-files"));
                    vm.loadingFiles = false;
                });
        }

        function getFileTags() {
            vm.loadingTags = true;
            FileManagerService.getFileTags(vm.hubId)
                .then(function (result) {
                    vm.tags = result.data;
                    vm.loadingTags = false;
                }, function () {
                    toastr.error($translate.instant("file-manager.message.error-to-load-tags"));
                    vm.loadingTags = false;
                });
        }

        function mountBreadCrumb(folder, breadcrumbs) {
            if (folder.id === -1) {
                return [];
            }

            if (folder.parent) {
                mountBreadCrumb(folder.parent, breadcrumbs)
            }

            breadcrumbs.push({id: folder.id, name: folder.name, parent: folder.parent})
            return breadcrumbs;
        }

        function touchForm(form) {
            angular.forEach(form.$error, function (field) {
                angular.forEach(field, function (errorField) {
                    errorField.$setTouched();
                });
            });
            toastr.warning($translate.instant("file-manager.form.check-form"));
        }

        function filterFiles() {
            if (!vm.filterName && !vm.filterTags.length) {
                getFolderFiles(vm.currentFolder);
                vm.filtring = false;
                return;
            }

            vm.filtring = true;

            vm.loadingFiles = true;
            FileManagerService.filterFiles(vm.hubId, vm.filterName, vm.filterTags)
                .then(function (result) {
                    vm.files = result.data;
                }, function () {
                    toastr.error($translate.instant("file-manager.message.error-to-load-files"));
                }).finally(function () { vm.loadingFiles = false});
        }

        function clearFilter () {
            vm.filterName = "";
            vm.filterTags = [];
            angular.forEach(vm.tags, function (tag) {
                tag.selected = false;
            })
        }

    }
})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("ConfirmPublishModalFactory", ConfirmPublishModalFactory);


    /** @ngInject */
    function ConfirmPublishModalFactory($uibModal) {

        var factory = {
            publishItem: publishItem
        };

        return factory;


        function publishItem() {
            return $uibModal.open({
                templateUrl: 'app/admin/hub-management/confirm-publish/confirm-publish.modal.html',
                controller: 'ConfirmPublishModalController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {}
            }).result;
        }


    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ConfirmPublishModalController', ConfirmPublishModalController);

        ConfirmPublishModalController.$inject = ['$scope', '$uibModal', '$uibModalInstance', 'toastr'];

    function ConfirmPublishModalController($scope, $uibModal, $uibModalInstance, toastr) {
        var vm = this;

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.closeModal = function() {
            $uibModalInstance.dismiss();
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubCampaignFormController', HubCampaignFormController);


    /** @ngInject */
    function HubCampaignFormController(HubCampaignService, toastr, $stateParams, $localStorage, $translate, $uibModal, $state) {

        var vm = this;

        vm.loading = false;
        vm.submitting = false;
        vm.isEdit = false;
        vm.hubId = $localStorage.hub.id;

        vm.currentTags = [
            {id: 1, name: "Test"}
        ]

        if ($stateParams.id) {
            vm.isEdit = true;
            getCampaign($stateParams.id)
        } else {
            vm.campaign = {hubId: vm.hubId};
            loadTags();
        }


        vm.searchTags = function (search) {
            return vm.currentTags.filter( function (tag) {
                return tag.name.toLowerCase().indexOf(search.toLocaleLowerCase()) >= 0;
            });
        }

        vm.save = function () {
            vm.submitting = true;

            if (vm.campaign.tags) {
                vm.campaign.tags = vm.campaign.tags.map(function (tag) {
                    return {id: tag.id, name: tag.name}
                })
            } else {
                vm.campaign.tags = [];
            }

            if (vm.isEdit) {
                HubCampaignService.update(vm.campaign.id, vm.campaign)
                    .then(function () {
                        toastr.success($translate.instant("campaign.message.campaign-saved"));
                        $state.go('hub-campaigns');
                    }, function () {
                        toastr.error($translate.instant("campaign.message.error-to-update"));
                    }).finally(function () { vm.submitting = false});
            } else {
                HubCampaignService.create(vm.campaign)
                    .then(function () {
                        toastr.success($translate.instant("campaign.message.campaign-saved"));
                        $state.go('hub-campaigns');
                    }, function () {
                        toastr.error($translate.instant("campaign.message.error-to-create"));
                    }).finally(function () { vm.submitting = false});
            }
        }

        vm.addShowcase = function () {
            $uibModal.open({
                templateUrl: 'app/admin/hub-management/campaign/_modal_add_showcase.html',
                controller: function (hubId, selectedShowcases, $uibModalInstance, HubShowcasesService, toastr) {

                    var vm = this;

                    vm.loadingShowcases = true;
                    vm.selectedShowcases = selectedShowcases ? selectedShowcases : [];

                    vm.listFilter = {
                        ownerId: hubId,
                        name: ''
                    };

                    loadShowcases();

                    vm.check = function (showcase, evt) {
                        if (evt.target.checked) {
                            vm.selectedShowcases.push(showcase);
                        } else {
                            var index = _.findIndex(vm.selectedShowcases, function (shc) {
                                return shc.id === showcase.id;
                            });
                            vm.selectedShowcases.splice(index, 1);
                        }
                    }

                    vm.isChecked = function (showcase) {
                        var index = _.findIndex(vm.selectedShowcases, function (shc) {
                            return shc.id === showcase.id;
                        });
                        return index > -1
                    }

                    vm.closeModal = function () {
                        $uibModalInstance.dismiss('cancel');
                    }

                    vm.ok = function () {
                        $uibModalInstance.close(vm.selectedShowcases);
                    }

                    function loadShowcases() {
                        HubShowcasesService.listShowcases(vm.listFilter)
                            .then(function (result) {
                                vm.showcases = result.data;
                            }, function () {
                                toastr.error("Erro ao carregar as vitrines")
                            }).finally(function () {vm.loadingShowcases = false;});
                    }
                },
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    selectedShowcases: function () {
                        return angular.copy(vm.campaign.showcases);
                    },
                    hubId: function () {
                        return vm.hubId;
                    }
                }
            }).result.then(function (response) {
                if (response) {
                    vm.campaign.showcases = response;
                }
            });
        }

        vm.removeShowcase = function (index) {
            vm.campaign.showcases.splice(index, 1);
        }

        function getCampaign(id) {
            vm.loading = true;
            HubCampaignService.getOne(id)
                .then(function (response) {
                    vm.campaign = response.data;
                }, function () {
                    toastr.error($translate.instant("Erro ao carregar a campanha"));
                }).finally(function () { vm.loading = false});
        }

        function loadTags() {

        }

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubCampaignDistributeController', HubCampaignDistributeController);

    function HubCampaignDistributeController(HubCampaignService, StoreService, StoreTypeService, toastr, $translate, $localStorage, $state, $stateParams) {

        var vm = this;

        vm.hubId = $localStorage.hub.id;
        vm.campaignId = $stateParams.id;
        vm.storesSelected = [];
		vm.storesSelectedFullData = [];
        vm.storeTypes = [];
        vm.requestParams = {
            page: 0,
            size: 25,
            name: ''
        }

        initLoad();

        vm.checkStoreIsSelected = function(id) {
            return vm.storesSelected.includes(id);
        }

        vm.changeStoreSelected = function(store) {
            if (vm.checkStoreIsSelected(store.storeId)) {
                vm.storesSelected = vm.storesSelected.filter(function(id) {
                    return store.storeId !== id;
                });
				vm.storesSelectedFullData = vm.storesSelectedFullData.filter(function (storeRemove) {
					return store !== storeRemove;
				});
            } else {
                vm.storesSelected.push(store.storeId);
				//Stores the data of the stores that were selected at some point
				vm.storesSelectedFullData.push(store);
            }
        }

        vm.markAllStoreType = function () {
            if (!vm.storeTypeId || vm.storeTypeId === '') {
                if (!vm.storesSelected.length) {
                    vm.storesSelected = [];
                    vm.quantStoresSelected = 0;
                }
                return;
            }

            StoreService.countStoresByCurrentHubAndStoreType(vm.storeTypeId).then(function (response) {
                vm.quantStoresSelected = response.count;
            });

            var storeType = vm.storeTypes.find(function (storeType) {
                return vm.storeTypeId === storeType.id.toString();
            });

            vm.storesSelected = [];
            if (vm.storeTypeId === 'all') {
                vm.stores.forEach(function (store) {
                    vm.changeStoreSelected(store);
                });
            } else {
                vm.stores.forEach(function (store) {
                    if (store.storeType === storeType.name) {
                        vm.changeStoreSelected(store);
                    }
                });
            }
        }

        vm.onChangeStoreName = function() {
            vm.requestParams.name = vm.storeName;
            loadStores(vm.requestParams);
        }

        vm.distribute = function() {
            var stores = vm.storesSelectedFullData.filter(function(store) {
                return vm.storesSelected.includes(store.storeId);
            });

            var request = (vm.storeTypeId && vm.storeTypeId > 0) ? { hubId: vm.hubId, storeTypeId: vm.storeTypeId } : { hubId: vm.hubId, stores: stores };
            HubCampaignService.distribute(vm.campaignId, request)
                .then(function () {
                    toastr.success($translate.instant('campaign.message.distribution-started'));
                    $state.go('hub-campaigns');
                }, function () {
                    toastr.error($translate.instant('campaign.message.error-to-distribute'));
                })
        };

        function initLoad() {
            loadStores(vm.requestParams);
            StoreTypeService.getAllStoreTypesByOwner().then(function(response) {
                vm.storeTypes = response.data;
            });
        }

        function loadStores(pageOptions) {
            StoreService.listStoresByCurrentHub({}, pageOptions, function(data) {
                vm.stores = data;
                vm.markAllStoreType();
            }, function() {
                toastr.error($translate.instant('campaign.message.error-to-stores'));
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hub-campaigns', {
                parent: 'admin',
                url: '/hub-campaigns',
                data: {
                    authorities: ['ADMIN_HUB'],
                    pageTitle: 'global.hub.campaigns'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/campaign/hub-campaign.html',
                        controller: 'HubCampaignController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('campaigns');
                        return $translate.refresh();
                    }]

                }
            })
            .state('hub-campaigns.new', {
                parent: 'hub-campaigns',
                url: '/new',
                data: {
                    authorities: ['ADMIN_HUB'],
                    pageTitle: 'campaign.actions.create'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/campaign/hub-campaign-form.html',
                        controller: 'HubCampaignFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('campaigns');
                        return $translate.refresh();
                    }]

                }
            })
            .state('hub-campaigns.edit', {
                parent: 'hub-campaigns',
                url: '/{id}',
                data: {
                    authorities: ['ADMIN_HUB'],
                    pageTitle: 'campaign.actions.edit'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/campaign/hub-campaign-form.html',
                        controller: 'HubCampaignFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('campaigns');
                        return $translate.refresh();
                    }]

                }
            })
            .state('hub-campaigns.distribute', {
                parent: 'hub-campaigns',
                url: '/{id}/distribute',
                data: {
                    authorities: ['ADMIN_HUB'],
                    pageTitle: 'campaign.actions.distribute'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/campaign/hub-campaign-distribute.html',
                        controller: 'HubCampaignDistributeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('campaigns');
                        return $translate.refresh();
                    }]

                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('HubCampaignService', HubCampaignService);

    HubCampaignService.$inject = ['HubCampaignFactory'];

    function HubCampaignService(HubCampaignFactory) {

        var service = {
            listAll: listAll,
            getOne: getOne,
            create: create,
            update: update,
            remove: remove,
            distribute: distribute
        };

        return service;


        function listAll(hubId, filter) {
            return HubCampaignFactory.listAll({hubId: hubId}, filter).$promise;
        }

        function getOne(id) {
            return HubCampaignFactory.getOne({id: id}).$promise;
        }

        function create(campaign) {
            return HubCampaignFactory.create(campaign).$promise;
        }

        function update(id, campaign) {
            return HubCampaignFactory.update({id: id}, campaign).$promise;
        }

        function remove(id) {
            return HubCampaignFactory.remove({id: id}).$promise;
        }

        function distribute(id, request) {
            return HubCampaignFactory.distribute({id: id}, request).$promise;
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('HubCampaignFactory', HubCampaignFactory);

    HubCampaignFactory.$inject = ['$resource'];

    function HubCampaignFactory($resource) {
        var resourceUrl = 'flyer/api/hub-campaign';

        return $resource(resourceUrl, {}, {
            'listAll': {
                method: 'POST',
                url: resourceUrl + '/hub/:hubId',
                transformResponse: transformResponse
            },
            'getOne': {
                method: 'GET',
                url: resourceUrl + '/:id',
                transformResponse: transformResponse
            },
            'create': {
                method: 'POST',
                url: resourceUrl,
                transformResponse: transformResponse
            },
            'update': {
                method: 'PUT',
                url: resourceUrl + '/:id',
                transformResponse: transformResponse
            },
            'remove': {
                method: 'DELETE',
                url: resourceUrl + '/:id',
                transformResponse: transformResponse
            },
            'distribute': {
                method: 'POST',
                url: resourceUrl + '/:id/distribute'
            }
        });

        function transformResponse(data, headers) {
            var response = {};
            response.data = angular.fromJson(data);
            response.headers = headers();
            return response;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('HubCampaignController', HubCampaignController);


    /** @ngInject */
    function HubCampaignController(HubCampaignService, toastr, $translate, $localStorage) {

        var vm = this;

        vm.hubId = $localStorage.hub.id;
        vm.loading = false;
        vm.campaigns = [];

        vm.filter = {
            hubId: vm.hubId,
            name: ''
        }

        vm.listCampaigns = function () {
            vm.loading = true;
            HubCampaignService.listAll(vm.hubId, vm.filter)
                .then(function (result) {
                    vm.campaigns = result.data;
                }, function () {
                    toastr.error($translate.instant('campaign.message.error-to-load-campaign'));
                }).finally(function (){ vm.loading = false});
        }

        vm.listCampaigns();

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ADMIN_MANAGE_SYSTEM'],
                pageTitle: 'health.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('showcaseApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('gift-card', {
            parent: 'admin',
            url: '/gift-card',
            data: {
                pageTitle: 'gift-card.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/gift-card/gift-card.html',
                    controller: 'GiftCardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gift-card');
                    return $translate.refresh();
                }]
            }
        }).state('gift-card-validate', {
            parent: 'admin',
            url: '/gift-card-validate',
            data: {
                pageTitle: 'gift-card.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/gift-card/gift-card-validate.html',
                    controller: 'GiftCardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gift-card');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .service('GiftCardService', GiftCardService);

    GiftCardService.$inject = ['GiftCardFactory', '$localStorage', 'MoipPlansFactory'];

    function GiftCardService(GiftCardFactory, $localStorage, MoipPlansFactory) {

        var service = {
            cardsAvailable: cardsAvailable,
            sendGiftCard: sendGiftCard,
			validateGiftCard: validateGiftCard,
			updateSubscriptionGiftCard: updateSubscriptionGiftCard
        };

        return service;

        function cardsAvailable(hubId) {
            return GiftCardFactory.cardsAvailable({ hubId: hubId }).$promise;
        }

        function sendGiftCard(giftCardReceiverDTO) {
            return GiftCardFactory.sendGiftCard(giftCardReceiverDTO).$promise;
        }

        function validateGiftCard(token) {
            return GiftCardFactory.validateGiftCard({token: token}).$promise;
        }

        function updateSubscriptionGiftCard(giftCardSubscriptionDTO) {
            return MoipPlansFactory.updateSubscriptionGiftCard(giftCardSubscriptionDTO).$promise;
        }



    }

})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('GiftCardFactory', GiftCardFactory);

    GiftCardFactory.$inject = ['$resource'];

    function GiftCardFactory($resource) {
        var resourceUrl = '';
        return $resource(resourceUrl, {}, {
            'cardsAvailable': {
                method: 'GET',
                url: 'admin/api/gift-card/available/:hubId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'sendGiftCard': {
                method: 'POST',
                url: 'admin/api/gift-card/send',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }//,
//            'validateGiftCard': {
//                method: 'GET',
//                url: 'admin/api/gift-card/validate/:token',
//                transformResponse: function (data, headers) {
//                    var response = {};
//                    if (data) {
//                        response.data = angular.fromJson(data);
//                    }
//                    response.headers = headers();
//                    return response;
//                }
//            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('GiftCardController', GiftCardController);

    function GiftCardController($localStorage, GiftCardService, CheckoutService, $translate, toastr) {

        var vm = this;

        vm.hubId = $localStorage.defaultStore.hubId;
        vm.giftSending = {};
        vm.sendGift = sendGift;
		vm.validateGiftCard = validateGiftCard;
		vm.giftCard = {};

        function getHubGiftCardsAvailable() {
            vm.isLoading = true;

            GiftCardService.cardsAvailable(vm.hubId).then(function (response) {
                vm.isLoading = false;
                vm.hubGifts = response.data;
            }, function (error) {
                vm.isLoading = false;
                vm.hubGifts = 0;
            });
        }

        function sendGift() {
            vm.giftSending.hubId = vm.hubId;
            if (vm.formGiftSending.$valid && !vm.isSending) {
                vm.isSending = true;

                GiftCardService.sendGiftCard(vm.giftSending).then(function (response) {
                    vm.isSending = false;
                    vm.hubGifts = response.data;

                    toastr.success($translate.instant('gift-card.send-success'));

                    //clear data
                    vm.giftSending = {};
                    vm.formGiftSending.$setPristine();

                    getHubGiftCardsAvailable();
                }, function (error) {
                    vm.isSending = false;

                    toastr.error($translate.instant('gift-card.send-error'));

                    getHubGiftCardsAvailable();
                });
            }
        }

		function validateGiftCard() {
            if (vm.formGiftValidate.$valid && !vm.isSending) {
                vm.isSending = true;
				GiftCardService.updateSubscriptionGiftCard(vm.giftCard).then(function (response) {
                    vm.isSending = false;
                    toastr.success($translate.instant('gift-card.validate-sucess'));
	            }, function (response) {
                    vm.isSending = false;
					if (response.headers()['x-error-validate']){
				    	toastr.error($translate.instant('gift-card.not-exists'));
				    }else if (response.headers()['x-error']){
	                    toastr.error($translate.instant('gift-card.validate-error'));
					}
	            });

            }
        }

        getHubGiftCardsAvailable();

    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('GatewayRoutes', GatewayRoutes);

    GatewayRoutes.$inject = ['$resource'];

    function GatewayRoutes ($resource) {
        var service = $resource('api/gateway/routes/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('gateway', {
            parent: 'admin',
            url: '/gateway',
            data: {
                authorities: ['ADMIN_MANAGE_SYSTEM'],
                pageTitle: 'gateway.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/gateway/gateway.html',
                    controller: 'GatewayController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gateway');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('GatewayController', GatewayController);

    GatewayController.$inject = ['$filter', '$interval', 'GatewayRoutes'];

    function GatewayController ($filter, $interval, GatewayRoutes) {
        var vm = this;

        vm.gatewayRoutes = null;
        vm.refresh = refresh;
        vm.updatingRoutes = null;

        vm.refresh();

        function refresh () {
            vm.updatingRoutes = true;
            GatewayRoutes.query(function(result) {
                vm.gatewayRoutes = result;
                vm.updatingRoutes = false;
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('SyncWithHubModalController', SyncWithHubModalController);

    function SyncWithHubModalController($uibModalInstance, modalTitle, modalMessage, smallText, warningText, 
        checkBoxes, buttonConfirmText, buttonCancelText, buttonConfirmAction) {
        var vm = this;

        vm.modalTitle = modalTitle;
        vm.modalMessage = modalMessage;
        vm.smallText = smallText;
        vm.warningText = warningText;
        vm.checkBoxes = checkBoxes;
        vm.buttonConfirmText = buttonConfirmText;
        vm.buttonCancelText = buttonCancelText;
        vm.buttonConfirmAction = action;

        vm.isConfirmButtonEnabled = function () {
            return vm.checkBoxes
                    .filter(function(checkbox) { return checkbox.value }).length > 0;
        }

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.closeModal = function() {
            $uibModalInstance.dismiss(true);
        }

        function action() {
            var params = [];
            if (vm.checkBoxes) {
                params = vm.checkBoxes
                    .filter(function(checkbox) { return checkbox.value })
                    .map(function(checkbox) { return checkbox.syncParam });
            }
            buttonConfirmAction(params);
            vm.confirm();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FiltersFlyersController', FiltersFlyersController);

    FiltersFlyersController.$inject = ['$uibModalInstance', '$translate', '$localStorage', 'toastr', 'filters', 'options', 'list', 'paginationConstants', 'StoreService'];

    function FiltersFlyersController($uibModalInstance, $translate, $localStorage, toastr, filters, options, list, paginationConstants, StoreService) {

        var vm = this;
        vm.originalFilters = angular.copy(filters);
        vm.filters = angular.copy(filters);
        vm.listFilter = list;
        vm.canChangeView = options.canChangeView;
        vm.sortOptions = paginationConstants.sortOptions[$translate.use().toLowerCase()];

        vm.colors = formatOptionsDict(options.colors);
        vm.sizes = formatOptionsDict(options.sizes);
        vm.categories = formatOptionsDict(options.categories);
        vm.brands = formatOptionsDict(options.brands);
        vm.tags = formatOptionsDict(options.tags);
        vm.hasInventory = filters.hasInventory;
        vm.viewByCategories = options.viewByCategories;

        StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
            vm.storeCategory = response.data.categoryKey;
        });

        vm.genders = formatOptionsDict(
            [{"label":"flyers.new.form.gender.male","id":1},
            {"label":"flyers.new.form.gender.female","id":2},
            {"label":"flyers.new.form.gender.both","id":3}]);
        vm.configurations = formatOptionsDict([
            {"label":"flyers.new.form.configurations.launch","id":1, "code": "launch"},
            {"label":"flyers.new.form.configurations.basic","id":2, "code": "basic"}]);

        vm.isBagFilter = false
        if (options.isBagFilter) {
            vm.isBagFilter = options.isBagFilter;
            formatFilterOptions();
        }

        vm.closeModal = function(response, applyFilters) {
            if (!applyFilters) {
                vm.filters = vm.originalFilters;
            }
            $uibModalInstance.close(response);
        }

        vm.closeDropDown = function () {
            $("md-backdrop").trigger('click');
        }

        vm.getSelectedText = function (filter) {
            if (filter.length === 0) return '';

            var elementTranslate = (filter[0].label);
            if (elementTranslate.includes("."))
                elementTranslate = $translate.instant(filter[0].label);

            if (filter.length === 1) {
                return '<span class="highlight">' + elementTranslate + '</span>';
            }

            if (filter.length > 1) {
                var temp = '  +';
                temp += filter.length - 1;
                temp += ' ' + $translate.instant('flyers.filters.selected');

                return '<span class="highlight">' + elementTranslate + '</span>' +
                    '<span>&nbsp</span>' +
                    '<span class="highlight">' + temp + '</span>';
            }
            return '';
        }

        vm.clearFilters = function () {
            vm.filters.categories = [];
            vm.filters.brands = [];
            vm.filters.colors = [];
            vm.filters.sizes = [];
            vm.filters.genders = [];
            vm.filters.configurations = [];
            vm.filters.tags = [];
            vm.hasInventory = false;
            vm.filters.sortSelected = {
                value: 'lastModifiedDate',
                direction: 'desc'
            };
        }

        vm.applyFilters = function () {
            var filters = angular.copy(vm.filters);
            filters.categories = filters.categories.map(function(category){ return category.key });
            filters.brands = filters.brands.map(function(brand){ return brand.name });
            filters.colors = filters.colors.map(function(color){ return color.label });
            filters.sizes = filters.sizes.map(function(size){ return size.label });
            filters.genders = filters.genders.map(function(gender){ return gender.id });
            filters.configurations = filters.configurations.map(function(configuration) { return configuration.code })
            filters.sortDirection = filters.sortSelected ? filters.sortSelected.direction : 'desc';
            filters.sortBy = filters.sortSelected ? filters.sortSelected.value : 'lastModifiedDate';

            var totalFilters = filters.categories.length + filters.brands.length + filters.colors.length + filters.sizes.length +
                filters.genders.length + filters.configurations.length;

            if ((filters.categories).length > 0) {
                vm.listFilter.categoryKeys = filters.categories;
                vm.listFilter.categoryKey = filters.categories[0];
            } else {
                vm.listFilter.categoryKeys = [];
            }

            if ((filters.colors).length > 0) {
                vm.listFilter.colors = filters.colors;
            } else {
                vm.listFilter.colors = [];
            }

            if ((filters.sizes).length > 0) {
                vm.listFilter.sizes = filters.sizes;
            } else {
                vm.listFilter.sizes = [];
            }

            if ((filters.genders).length > 0) {
                vm.listFilter.genders = filters.genders;
            } else {
                vm.listFilter.genders = [];
            }

            if ((filters.configurations).length > 0) {
                vm.listFilter.configurations = filters.configurations;
            } else {
                vm.listFilter.configurations = [];
            }

            if ((filters.brands).length > 0) {
                vm.listFilter.brands = filters.brands;
            } else {
                vm.listFilter.brands = [];
            }

            if (filters.sortBy && filters.sortDirection) {
                vm.listFilter.sortBy = filters.sortBy;
                vm.listFilter.sortDirection = filters.sortDirection;
            } else {
                vm.listFilter.sortBy = '';
                vm.listFilter.sortDirection = '';
            }

            vm.listFilter.hasInventory = vm.hasInventory;
            vm.filters.hasInventory = vm.hasInventory;

            if (vm.viewByCategories !== options.viewByCategories){
                vm.changeView = true;
                vm.filters.viewByCategories = vm.viewByCategories;
            }

            vm.closeModal({filtered: filters, selectedFilters: angular.copy(vm.filters), totalFilters: totalFilters,
                listFilter: vm.listFilter, changeView: vm.changeView}, true);
        }

        function formatOptionsDict(optionsDict) {
            if (!optionsDict) {
                return {}
            }
            var count = 0;
            optionsDict.forEach(function(option) {
                if (typeof option === 'string' || option instanceof String) {
                    optionsDict[count] = {'label': option};
                } else if (!option.hasOwnProperty('label')){
                    if (option.hasOwnProperty('title')) {
                        option.label = option.title;
                    } else {
                        option.label = option.name;
                    }
                }
                count++;
            });

            count = 1;
            optionsDict.forEach(function(option) {
                if(!option.hasOwnProperty('id')){
                    option.id = count;
                }
                count++;
            });
            return optionsDict;
        }

        function formatFilterOptions() {
            var categories = [];
            vm.filters.categories.map(function(category) {
                vm.categories.forEach(function(configured_category) { if (configured_category.key === category) {
                    categories.push({'label': configured_category.label, 'id': configured_category.id, 'title': configured_category.title, 'key': category})
                }});
            })
            vm.filters.categories = categories;

            var sizes = [];
            vm.filters.sizes.map(function(size) {
                vm.sizes.forEach(function(configured_size) { if (configured_size.label === size) { sizes.push({'label': size, 'id': configured_size.id}); }});
            })
            vm.filters.sizes = sizes;

            var brands = [];
            vm.filters.brands.map(function(brand) {
                vm.brands.forEach(function(configured_brand) { if (configured_brand.name === brand) { brands.push({'name': brand, 'label': brand, 'id': configured_brand.id}); }});
            })
            vm.filters.brands = brands;

            var colors = [];
            vm.filters.colors.map(function(color) {
                vm.colors.forEach(function(configured_color) { if (configured_color.label === color) { colors.push({'label': color, 'id': configured_color.id});}});
            })
            vm.filters.colors = colors;

            var genders = [];
            vm.filters.genders.map(function(gender) {
                vm.genders.forEach(function(configured_gender) { if (configured_gender.id === gender) { genders.push({'label': configured_gender.label, 'id': gender});}});
            })
            vm.filters.genders = genders;

            var tags = [];
            vm.filters.tags.map(function(tag) {
                vm.tags.forEach(function(configured_tag) { if (configured_tag.label === tag) { tags.push({'label': tag, 'id': configured_tag.id})}});
            })
            vm.filters.tags = tags;
        }

    }

})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("FlyerImportController", FlyerImportController);

    /** @ngInject */
    function FlyerImportController($scope, Upload, toastr, $translate, FlyersService, $interval, $window) {
        var vm = this;

        vm.file = null;
        vm.isLoading = false;
        vm.isUploading = false;
        vm.descriptonStep1 = $translate.instant("flyers.import.steps.step1.description2");
        vm.flyerAttributes = [
            "ean",
            "productReference",
            "name",
            "description",
            "gender",
            "brand",
            "category",
            "color",
            "size",
            "productPrice",
            "promotionalPrice",
            "qttPerPerson",
            "inventory",
            "height",
            "width",
            "length",
            "weight",
            "measureList",
            "imageUrl1",
            "imageUrl2",
            "imageUrl3",
            "imageUrl4",
            "demoVideo",
            "tags"
        ];

        vm.currentStep = 1;

        vm.gotoStep = function(step) {
            if (((step === 2 || step === 3) && !vm.file) || vm.isUploading) {
                return;
            }
            if (step === 3) {
                if (!requiredFieldsHaveBeenSelected()) {
                    return;
                }
                getPreview();
            }
            vm.currentStep = step;
        };

        vm.loadFile = function (file, errFiles) {
            vm.file = file;
            vm.errFiles = errFiles && errFiles[0];
            vm.isLoading = true;
            vm.importResult = null;
            vm.errorSummary = null;

            if (vm.errFiles) {
                vm.isLoading = false;
                if (errFiles[0].$error == "pattern") {
                    toastr.error($translate.instant("flyers.import.error.invalidType"));
                    return;
                }
            }

            if (file) {
                vm.currentStep = 2;

                var fileReader = new FileReader();
                fileReader.onload = function() {
                    this.arrayBuffer = fileReader.result;
                    var data = new Uint8Array(this.arrayBuffer);
                    var arr = new Array();
                    for (var i = 0; i != data.length; ++i)
                        arr[i] = String.fromCharCode(data[i]);
                    var bstr = arr.join("");
                    var workbook = XLSX.read(bstr, {
                        type: "binary", sheetRows: 4
                    });
                    var first_sheet_name = workbook.SheetNames[0];
                    var worksheet = workbook.Sheets[first_sheet_name];

                    vm.headers = getHeaderRow(worksheet);

                    var sheetsList = workbook.SheetNames;
                    vm.sheetData = XLSX.utils.sheet_to_json(
                        workbook.Sheets[sheetsList[0]],
                        {
                            header: 1,
                            defval: "",
                            blankrows: true
                        }
                    );

                    vm.isLoading = false;

                    $scope.$apply();
                };
                fileReader.readAsArrayBuffer(file);
            } else {
                vm.isLoading = false;
            }
        };

        function getHeaderRow(sheet) {
            var headers = [];
            var range = XLSX.utils.decode_range(sheet["!ref"]);
            var C,
                R = range.s.r; /* start in the first row */
            /* walk every column in the range */
            for (C = range.s.c; C <= range.e.c; ++C) {
                var cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]; /* find the cell in the first row */
                var hdr = "UNKNOWN " + C; // <-- replace with your desired default
                if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);

                headers.push({ column: numToSSColumn(C + 1), key: hdr, value: "NULL" });
            }
            return headers;
        }

        vm.uploadFile = function () {
            if (vm.file) {
                vm.isUploading = true;

                vm.file.upload = Upload.upload({
                    url: 'flyer/api/flyer/import-flyers-from-table?headers=' + getHeadersStringList(),
                    data: {
                        file: vm.file
                    }
                });

                vm.file.upload.then(function (response) {
                    if (response.data) {
                        // vm.file = null;

                        var interval = $interval(function () {
                            FlyersService.flyersImportStatus(response.data.id)
                                .then(function (response) {
                                    var data = JSON.parse(response.data)
                                    if (data.status === 'FINISHED') {
                                        $interval.cancel(interval);
                                        vm.isUploading = false;
                                        toastr.success($translate.instant('flyers.import.statusSuccessfulDescription'));
                                        vm.currentStep = 1;
                                        vm.file = null;
                                    } else if (data.status === 'IN_PROGRESS') {
                                        $interval.cancel(interval);
                                        vm.isUploading = false;
                                        toastr.success($translate.instant('flyers.import.successfullyImport'));
                                        vm.currentStep = 1;
                                        vm.file = null;
                                    } else if (data.status === 'FAILED') {
                                        $interval.cancel(interval);
                                        errorOnFileUploadOrSaveImport('flyers.import.error.errorOnSaveImport');
                                        vm.importResult = data;

                                        getErrorSummary();
                                    }
                                }, function (data) {
                                    $interval.cancel(interval);
                                    errorOnFileUploadOrSaveImport('flyers.import.error.errorOnSaveImport');
                                })
                                .catch(function (err) {
                                    $interval.cancel(interval);
                                    errorOnFileUploadOrSaveImport('flyers.import.error.errorOnSaveImport');
                                });
                        }, 5000);

                    } else {
                        errorOnFileUploadOrSaveImport('flyers.import.error.errorOnUploadFile');
                    }

                }, function (response) {
                    errorOnFileUploadOrSaveImport('flyers.import.error.errorOnUploadFile');
                });
            }
        }

        vm.cancel = function () {
            vm.file = null;
        }

        function errorOnFileUploadOrSaveImport(error) {
            toastr.error($translate.instant(error));
            vm.isUploading = false;
        }

        function getHeadersList() {
            return vm.headers.map(function (item) {
                return item.value;
            });
        }

        function getHeadersStringList() {
            return getHeadersList().join();
        }

        vm.getXlsxResult = function () {
            var fileExt = '.xlsx';
            var fileName = vm.importResult.id + fileExt;
            var header = vm.flyerAttributes.concat(["errors"]);

            var details = JSON.parse(JSON.stringify(vm.importResult.details));

            if (!details) {
                return;    
            }
            
            // translate errors
            details.forEach(function (product) {
                var errors = product.errors.map(function (error) {
                    return $translate.instant('flyers.import.error.' + error);
                }).join(' | ');
                product.errors = errors;
            });

            var workbook = XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(details, { header: header });

            var range = XLSX.utils.decode_range(worksheet['!ref']);

            // translate header
            for (var C = range.s.c; C <= range.e.c; ++C) {
                var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
                if (!worksheet[address]) continue;
                worksheet[address].v = $translate.instant('flyers.import.column.' + worksheet[address].v);
            }

            var wscols = [];
            for (var i = 0; i < header.length; i++) {  // columns length added
                wscols.push({ wch: 15 })
            }
            wscols[wscols.length - 1] = { wch: 80 };
            worksheet["!cols"] = wscols;

            XLSX.utils.book_append_sheet(workbook, worksheet, 'tab1');
            XLSX.writeFile(workbook, fileName, { compression: true });
        }

        vm.changeHeaderValue = function(header) {
            vm.errorSummary = null;
            if (header.value === '') {
                header.value = 'NULL';
            } else {
                vm.headers.forEach(function (item) {
                    if (header.key !== item.key && header.value === item.value) {
                        header.value = 'NULL';
                        toastr.warning($translate.instant('flyers.import.error.repeatedColumn'));
                    } 
                });
            }
        }

        function numToSSColumn(num) {
            var s = '', t;

            while (num > 0) {
                t = (num - 1) % 26;
                s = String.fromCharCode(65 + t) + s;
                num = (num - t) / 26 | 0;
            }
            return s || undefined;
        }

        function getSelectedHeaders() {
            return vm.headers.filter(function (item) {
                return item.value !== 'NULL';
            });
        }

        function getPreview() {
            if (!vm.sheetData) {
                return;
            }
            var data = [];
            var headers = vm.headers.map(function (item) {
                return item.value !== 'NULL' ? $translate.instant('flyers.import.column.' + item.value) : item.value;
            });

            for (var i = 1; i < vm.sheetData.length; i++) {
                var result = [];
                for (var j = 0; j < headers.length; j++) {
                    var value = vm.sheetData[i][j];
                    if (headers[j] !== 'NULL') {
                        result.push(value);
                    }
                }
                data.push(result);
            }
            var headersPreview = headers.filter(function (header) {
                return header !== 'NULL'; 
            })

            vm.importPreview = {
                headers: headersPreview,
                data: data
            }
        }

       function getErrorSummary() {
            vm.errorSummary = [];

            if (vm.importResult && vm.importResult.details) {
                vm.importResult.details.forEach(function (product) {
                    product.errors.forEach(function (error) {
                        if (!vm.errorSummary.includes(error)) {
                            vm.errorSummary.push(error)
                        }
                    });
                });
            }
        }

        function requiredFieldsHaveBeenSelected() {
            var eanOrProductReference = false;
            var otherField = false;
            getSelectedHeaders().forEach(function (header) {
                if (header.value === "ean" || header.value === "productReference") {
                    eanOrProductReference = true;
                } else if (header.value !== "size") {
                    otherField = true;
                }
            });
            
            if (!eanOrProductReference) {
                toastr.warning($translate.instant('flyers.import.error.notAllowedNullableProductReferenceOrEan'));
            } else if (!otherField) {
                toastr.warning($translate.instant('flyers.import.error.noColumn'));
            }

            return eanOrProductReference && otherField;
        }

        vm.getDownloadLinkToTemplate = function () {
            return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/template-import-products.xlsx';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FlyersFormController', FlyersFormController);

    function FlyersFormController($translate, $timeout, $scope, $window, $localStorage, $q, $state, $uibModal, $stateParams, toastr, moment,
                                  FlyerCategoryService, StoreService, FlyersService, BrandService, ColorService, ShowcasesService,
                                  ErpsSettingsService, $rootScope) {

        const MAX_IMAGE_SIZE = 10240;
        const ICON_ACTIVE = 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/pointactive.png';
        const ICON_INACTIVE = 'content/images/pointinactive.png';
        const DATE_FORMAT = 'L LT';
        const now = moment(moment(), DATE_FORMAT).toDate();
        const SRC_IMAGE_DEFAULT = 'content/images/1-image-default-product.png';
        const SRC_IMAGE_DETAIL_DEFAULT = 'content/images/2-image-default-product_mini.png';

        var vm = this;


        loadStore();
        loadErpConfiguration();

        vm.configuration = null;
		vm.regexForValueZero = '([1-9]{1}[0-9]{0,2})(\.[0-9]{3})*\,[0-9]{2}|[0-9]{0,3}(\.[0-9]{3})*\,([0-9][1-9]|[1-9][0-9])';
        vm.isEdit = false;
        vm.isLoading = true;
        vm.currencyConfigurations = getCurrencyListConfiguration();
        vm.transactionalUserInteractions = ["RENT", "SALE"];
        vm.enableDemoVideo = false;
        vm.srcImgDefault = SRC_IMAGE_DEFAULT;
		vm.srcImgDetailDefault = SRC_IMAGE_DETAIL_DEFAULT;
        vm.imgsFlyers = [
            {
                id: '1',
                src: vm.srcImgDefault,
                isDefault: true,
                isThumbnail: false
            },
            {
                id: '2',
                src: vm.srcImgDefault,
                isDefault: true,
                isThumbnail: false
            },
            {
                id: '3',
                src: vm.srcImgDefault,
                isDefault: true,
                isThumbnail: false
            },
            {
                id: '4',
                src: vm.srcImgDefault,
                isDefault: true,
                isThumbnail: false
            }
        ]

		vm.listBlobs = [];

        $scope.windowWidth = $window.innerWidth;

        $window.onresize = function(event) {
            $timeout(function() {
              $scope.windowWidth = $window.innerWidth;
            });
          };

        if ($stateParams.id) {
            vm.isEdit = true;
            loadFlyer($stateParams.id);
        } else {
            loadData();
        }
        $scope.sortableOptions = {
            update: function (e, ui) {
                //if (vm.getCountDefaultImageFlyer() > 0) {
                    vm.moveImageFlyerToFirstIndex();
                //}
            }
        };

        $scope.$watch(function () {
            return document.getElementById("content").clientWidth;
        }, function (newVal, oldVal) {
            if (!document.getElementById('brand'))
                return;
            if ((newVal - oldVal) > 20 || (oldVal - newVal) > 20) {
                var autoChild = document.getElementById('brand').firstElementChild;
                var el = angular.element(autoChild);
                el.scope().$mdAutocompleteCtrl.hidden = true;
            }
        });

        // Auxiliaries for brand entities
        vm.querySearchBrand     = querySearchBrand;
        vm.selectedBrandChange  = selectedBrandChange;
        vm.newBrand             = newBrand;
        vm.brands               = [];

        // Auxiliaries for category entities
        vm.querySearchCategory  = querySearchCategory;
        vm.selectedCategoryChange = selectedCategoryChange;
        vm.newCategory          = newCategory;

        // Auxiliaries for color entities
        vm.querySearchColor     = querySearchColor;
        vm.selectedColorChange  = selectedColorChange;
        vm.newColor             = newColor;
       	vm.colors               = [];

        vm.imageSize = 600;
        vm.flyerImage = '';
        vm.firstZoom = true;
        vm.isSaving = false;
        vm.selectedSizes = [];

        vm.enableTags = false;
        vm.enableDimension = false;
        vm.enableSchedules = false;
        vm.enableBatchSale = false;
        vm.enableIndiviualPrice = true;
        vm.enableRules = false;
        vm.enableMeasures = false;

        vm.measureList = [];
		vm.capitalize = function (str){
			if (typeof str !== 'string') {
				return '';
			}
			return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
		}

        vm.flyer = {
            discountPercentageValue: undefined,
            currency: 'REAL',
            currencyInstance: vm.currencyConfigurations.REAL,
            discountType: 'DISCOUNT_FIXED',
            details: [],
            tags: [],
            isLaunch: false,
            isBasic: false,
            validityTypeDate: false,
            isPublished: false,
			addImageFileDTO: [],
            type: 'SALE'
        };

        vm.mainMap = {
            center: {
                latitude: 0,
                longitude: 0
            },
            zoom: 10,
            controls: {},
            bounds: {},
            markers: [],
            window: {
                model: {},
                show: false,
                options: {
                    pixelOffset: {
                        width: -1,
                        height: -65
                    }
                },
                closeClick: function () {
                    this.show = false;
                }
            },
            markerEvents: {
                dragend: function (marker) {
                    vm.refreshMapWithCoordinates(marker.position.lat(), marker.position.lng());
                },
                mouseover: function (marker, eventName, model) {
                    vm.mainMap.window.model = model;
                    vm.mainMap.window.show = true;
                },
                mouseout: function () {
                    vm.mainMap.window.show = false;
                },
                click: function (marker) {
                    for (var i = 0; i < vm.mainMap.markers.length; i++) {
                        if (vm.mainMap.markers[i].id === marker.key) {
                            if (vm.mainMap.markers[i].clicked) {
                                vm.mainMap.markers[i].options.icon = ICON_INACTIVE;
                                vm.mainMap.markers[i].clicked = false;
                            } else {
                                vm.mainMap.markers[i].options.icon = ICON_ACTIVE;
                                vm.mainMap.markers[i].clicked = true;
                            }
                        }
                    }
                }
            }
        };

        init();

        function init() {
            loadStoreData();
        }

        function loadStoreData() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
                if (response && response.data) {
                    vm.storeCategory = response.data.categoryKey;
                    loadCurrencyPrefix(response.data);
                }
            })
        }

        function loadCurrencyPrefix(store) {
            var key = store.currency ? store.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            vm.currencyPrefix = config.prefix;
            vm.flyer.currency = key;
            vm.flyer.currencyInstance = config;
            console.log(vm.flyer);
        }

        vm.onChangeEan = function (value, index) {
            if (value.ean === "" || value.ean === null || value.ean === undefined) {
                return false;
            }
            for (var i = 0; i < vm.flyer.details.length; i++) {
                var details = vm.flyer.details[i];
                if (index !== i && value.ean === details.ean) {
                    return true;
                }
            }
            return false;
        }

        vm.onChangeSize = function (value, index) {
            if (value.size === "" || value.size === null || value.size === undefined) {
                return false;
            }
            for (var i = 0; i < vm.flyer.details.length; i++) {
                var details = vm.flyer.details[i];
                if (index !== i && value.size === details.size) {
                    return true;
                }
            }
            return false;
        }

        vm.checkIfLaunchSelected = function () {
            return vm.flyer.isLaunch;
        }

        vm.updateLaunchOrRemove = function () {
            vm.flyer.isLaunch = !vm.flyer.isLaunch;
        }

        vm.checkIfBasicSelected = function () {
            return vm.flyer.isBasic;
        }

        vm.updateBasicOrRemove = function () {
            vm.flyer.isBasic = !vm.flyer.isBasic;
        }

        vm.openInput = function (evt) {
            document.getElementById('fileInput').click();
        }

        vm.changeIndividualPrice = function () {
            vm.enableIndiviualPrice = !vm.enableIndiviualPrice;
            if (vm.enableIndiviualPrice) {
                vm.flyer.details = [];
                vm.selectedSizes = [];
                if(vm.enableMeasure) {
                    vm.measureList = [];
                    vm.addMeasures();
                } else {
                    vm.measureList = [];
                }
            } else {
                vm.addDetail();
                vm.flyer.purchaseValue = undefined;
                vm.flyer.discountedValue = undefined;
                vm.flyer.inventory = undefined;
                if(vm.flyer.dimension){
                    vm.flyer.dimension.weight = '';
                    vm.flyer.dimension.height = '';
                    vm.flyer.dimension.width = '';
                    vm.flyer.dimension.length = '';
                }
                if(vm.flyer.measureList){
                    vm.flyer.measureList = [];
                }
            }
        }

        vm.changeTags = function () {
            if (!vm.enableTags) {
                vm.flyer.tags = [];
            }
        }

        vm.changeDimension = function() {
            if (!vm.enableDimension) {
                if(vm.flyer.dimension){
                    vm.flyer.dimension.weight = '';
                    vm.flyer.dimension.height = '';
                    vm.flyer.dimension.width = '';
                    vm.flyer.dimension.length = '';
                }
                vm.flyer.details.forEach(function (detail) {
                    detail.dimension = undefined;
                });
            }
        }

        vm.changeMeasure = function() {
            if (!vm.enableMeasure) {
                if(vm.flyer.dimension){
                    vm.flyer.measureList = [];
                }
                vm.flyer.details.forEach(function (detail) {
                    detail.measureList = [];
                });
                vm.measureList = [];
            } else {
                vm.addMeasures();
            }
        }

        vm.changeBatchSale = function () {
            if (!vm.enableBatchSale) {
                vm.flyer.bulkQuantity = undefined;
                vm.flyer.discountBulkPercentage = undefined;
            }
        }

        vm.changeRulesForUse = function() {
            if (!vm.enableRules) {
                vm.flyer.rulesForUse = undefined;
            }
        }

        vm.changeSchedules = function () {
            if (vm.enableSchedules) {
                vm.startDateOptions = {
                    format: DATE_FORMAT,
                    sideBySide: true,
                    ignoreReadonly: true,
                    locale: moment.locale(),
                    allowInputToggle: true
                };

                vm.expireDateOptions = {
                    format: DATE_FORMAT,
                    sideBySide: true,
                    ignoreReadonly: true,
                    minDate: moment(),
                    locale: moment.locale(),
                    allowInputToggle: true,
                    useCurrent: false
                };

                angular.element('#startDateTime').datetimepicker(vm.startDateOptions).on('dp.change', function (ev) {
                    if (ev.date) {
                        vm.flyer.startDate = ev.date.format(DATE_FORMAT);
                        if (vm.flyer.expirationDate && !checkExpirationDate()) {
                            vm.flyer.expirationDate = undefined;
                            angular.element('#expirationDateTime').data("DateTimePicker").minDate(ev.date || now);
                        } else {
                            angular.element('#expirationDateTime').data("DateTimePicker").minDate(now);
                        }
                        $scope.$apply(function () {
                            vm.flyerForm.startDate.$setValidity('minDate', true);
                        });
                    } else {
                        vm.flyer.startDate = undefined;
                    }
                });

                angular.element("#expirationDateTime").datetimepicker(vm.expireDateOptions).on('dp.change', function (ev) {
                    if (ev.date) {
                        vm.flyer.expirationDate = ev.date.format(DATE_FORMAT);
                        $scope.$apply(function () {
                            vm.flyerForm.expirationDate.$setValidity('required', true);
                        });
                    } else {
                        vm.flyer.expirationDate = undefined;
                    }
                });
            } else {
                vm.flyer.startDate = undefined;
                vm.flyer.expirationDate = undefined;
                vm.flyer.immediateAvailability = true;
                vm.flyer.validityTypeDate = true;
            }
        }

        vm.onImmediateAvailabilityChange = function () {
            if (vm.flyer.immediateAvailability) {
                vm.flyerForm.startDate.$setValidity('minDate', true);
                angular.element('#startDateTime').data("DateTimePicker").clear();
            }
        }

        vm.onValidityTypeDateChange = function (checked) {
            if (checked) {
                angular.element('#expirationDateTime').data("DateTimePicker").clear();
            }
        };

		vm.loadImages = function () {
			vm.imgsFlyers[0].isThumbnail = true;
			for (var i = 0 ; i < vm.imgsFlyers.length; i++){
				var random = new Date().getTime();
				var src = null;
				if (i != 0){
					src = '/flyer/api/' + vm.flyer.id + '__'+ i + '/picture?type=large&ts=' + random;
				}else{
					src = '/flyer/api/' + vm.flyer.id + '/picture?type=large&ts=' + random;
				}
				var img = new Image();
				img.src = src;
				img.id = i
				img.onload = function() {
					vm.imgsFlyers[this.id].src = this.src;
					vm.imgsFlyers[this.id].isDefault = false;
					vm.moveImageFlyerToFirstIndex();
				}
				img.onerror = function() {
					vm.imgsFlyers[this.id].src = SRC_IMAGE_DEFAULT;
				}
			}
			this.$apply;
		}

        vm.typeChanged = function () {
            if (vm.flyer.type === 'RENT') {
                vm.flyer.maxUsageByUser = 1;
                vm.flyer.maxUsages = 1;
                vm.flyer.usageLimitByUser = false;
                vm.flyer.validityTypeNumber = false;
                vm.flyer.validityTypeDate = true;
            }

            vm.flyer.bulkQuantity = null;
            vm.flyer.discountBulkPercentage = null;

            if (vm.transactionalUserInteractions.includes(vm.flyer.type)) {
                vm.flyer.currency = 'REAL';
                vm.flyer.currencyInstance = vm.currencyConfigurations.REAL;
                vm.disabledCurrency = true;
            } else {
                vm.disabledCurrency = false;
            }
        }

        vm.checkAllMarkers = function () {
            var icon;
            if (vm.allSalesPoint) {
                icon = ICON_ACTIVE;
            } else {
                icon = ICON_INACTIVE;
            }
            for (var i = 0; i < vm.mainMap.markers.length; i++) {
                vm.mainMap.markers[i].options.icon = icon;
                vm.mainMap.markers[i].clicked = vm.allSalesPoint;
            }
        }

        vm.uploadImage = function () {
            if(vm.isSaving) {
                return;
            }
            vm.isSaving = true;
            if (vm.flyerForm.$invalid) {
                toastr.warning("Verifique os campos invalidos")
                angular.forEach(vm.flyerForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    });
                });
                vm.isSaving = false;
                return;
            }

            if (vm.flyer.brand === null) {
                toastr.warning($translate.instant('brand.messages.warning.selectBrand'));
                vm.isSaving = false;
                return;
            }

            if (vm.fullCategory === null) {
                toastr.warning($translate.instant('categorys.messages.warning.selectCategory'));
                vm.isSaving = false;
                return;
            }


			var cont = 0;
			var contImageModified = vm.imgsFlyers.length;
			vm.flyer.addImageFileDTO = [];
			for (var i = 0; i < vm.imgsFlyers.length; i++) {
				if (vm.imgsFlyers[i].src.includes(SRC_IMAGE_DEFAULT)){
					vm.flyer.addImageFileDTO.push(createJsonImage(null, null, i, 'DELETE'));
					cont = cont + 1;
					if (cont == contImageModified){
                        if (vm.flyer.addImageFileDTO.length > 0) {
							saveFlyer();
                        } else {
                            toastr.error($translate.instant('flyers.messages.create.error'));
                            vm.isSaving = false;
                        }
                        vm.loadingImage = false;
					}
				}else if (!vm.imgsFlyers[i].src.includes('base64')){
					vm.flyer.addImageFileDTO.push(createJsonImage(vm.imgsFlyers[i].src, null, i, 'UPDATE'));
					cont = cont + 1;
					if (cont == contImageModified){
                        if (vm.flyer.addImageFileDTO.length > 0) {
							saveFlyer();
                        } else {
                            toastr.error($translate.instant('flyers.messages.create.error'));
                            vm.isSaving = false;
                        }
                        vm.loadingImage = false;
					}
				}else{
                	var blob = dataURItoBlob(vm.imgsFlyers[i].src);
	                FlyersService.saveFlyerMultiImage(blob, i).then(function (response) {
	                    $timeout(function () {
	                        vm.flyer.addImageFileDTO.push(response.data);
                            cont = cont + 1;
							if (cont == contImageModified){
		                        if (vm.flyer.addImageFileDTO.length > 0) {
									saveFlyer();
		                        } else {
		                            toastr.error($translate.instant('flyers.messages.create.error'));
                                    vm.isSaving = false;
		                        }
		                        vm.loadingImage = false;
							}
	                    });
	                }, function () {
	                    toastr.error($translate.instant('flyers.messages.create.image.uploadError'));
	                    vm.isSaving = false;
	                    vm.loadingImage = false;
	                });
				}
			}
        }

        function loadStore() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
                vm.defaultStoreCategory = response.data.categoryKey;
            });
        }

        function loadErpConfiguration() {
            ErpsSettingsService.getERPConfigurationByStoreId($localStorage.defaultStore.storeId)
                .then(function (response) {
                    if (response.data && response.data.id) {
                        vm.configuration = response.data;
                    }
                });
        }

        function createJsonImage(uuid, extensionFile, orderNumber, action) {
            return{
                uuid: uuid,
                extensionFile: extensionFile,
                orderNumber: orderNumber,
				action: action
            };
        }

        vm.formatMoney = function (value, currencySymbol) {
            return formatMoney(value, currencySymbol, vm.flyer.currencyInstance.decimalQuant,
                vm.flyer.currencyInstance.centsSeparator, vm.flyer.currencyInstance.thousandsSeparator);
        };

        vm.checkDiscountedValue = function () {
            if (vm.flyer.purchaseValue && vm.flyer.discountedValue) {
                if (parseFloat(vm.flyer.discountedValue) > parseFloat(vm.flyer.purchaseValue)) {
                    vm.flyerForm.discountedValue.$setValidity('discountGreaterThanValue', false);
                } else {
                    vm.flyerForm.discountedValue.$setValidity('discountGreaterThanValue', true);
                }
            }
        }

        vm.checkVariationDiscountedValue = function (index) {
            if (vm.flyer.details[index].purchaseValue && vm.flyer.details[index].discountedValue) {
                if (vm.flyer.details[index].discountedValue > vm.flyer.details[index].purchaseValue) {
                    vm.flyerForm['varDiscountedValue' + index].$setValidity('discountGreaterThanValue', false);
                } else {
                    vm.flyerForm['varDiscountedValue' + index].$setValidity('discountGreaterThanValue', true);
                }
            }
        }

        vm.addDetail = function () {
            vm.flyer.details.push({
                size: undefined,
                purchaseValue: undefined,
                discountedValue: undefined,
                inventory: undefined,
                quantityByPerson: undefined,
                measureList: []
            });
            addValueToColumn();
        }

        function addValueToColumn() {
            vm.measureList.forEach(function (measure) {
                vm.flyer.details[vm.flyer.details.length - 1].measureList.push({ name: measure.name, value: 0 })
            });
        }

        vm.addMeasures = function () {
            if (!vm.flyer.details.length) {
                if (!vm.flyer.measureList) {
                    vm.flyer.measureList = [];
                }

                if (vm.flyer.measureList.length) {
                    vm.flyer.measureList.push({ name: '', value: 0 });
                } else {
                    vm.flyer.measureList.push({ name: $translate.instant('flyers.new.form.weight-dimensions.height'), value: 0 });
                    vm.flyer.measureList.push({ name: $translate.instant('flyers.new.form.weight-dimensions.width'), value: 0 });
                }
            } else {
                vm.flyer.details.forEach(function (detail) {
                    if (!detail.measureList) {
                        detail.measureList = [];
                    }

                    if (detail.measureList.length) {
                        detail.measureList.push({ name: '', value: 0 });
                    } else {
                        detail.measureList.push({ name: $translate.instant('flyers.new.form.weight-dimensions.height'), value: 0 });
                        detail.measureList.push({ name: $translate.instant('flyers.new.form.weight-dimensions.width'), value: 0 });
                    }

                });
            }
            if (vm.measureList.length) {
                vm.measureList.push({ name: '' });
            } else {
                vm.measureList.push({ name: $translate.instant('flyers.new.form.weight-dimensions.height') });
                vm.measureList.push({ name: $translate.instant('flyers.new.form.weight-dimensions.width') });
            }

        }

		function findIndex(value){
			return value.name == this;
		}

        function mapMeasures(nameMeasure) {
            if (!vm.flyer.details.length) {
                if (vm.flyer.measureList) {
                    if (vm.measureList.findIndex(findIndex, nameMeasure) < 0 || nameMeasure === '') {
                        vm.measureList.push({ name: nameMeasure });
                    }

                }
            } else {
                vm.flyer.details.forEach(function (detail) {
                    if (detail.measureList) {
                        if (vm.measureList.findIndex(findIndex, nameMeasure) < 0 || nameMeasure === '') {
                            vm.measureList.push({ name: nameMeasure });
                        } else {
                            if(detail.measureList.map(function(el) {return el.name}).indexOf(nameMeasure) == -1) {
                                detail.measureList.push({"name": nameMeasure, "value": "0"})
                            }
                        }

                    } else {
                        detail.measureList = [];
                        detail.measureList.push({"name": nameMeasure, "value": "0"});
                    }
                });
            }
        }

        vm.removeMeasure = function (index) {
            if (vm.measureList.length > 1) {
                vm.measureList.splice(index, 1);
                if (!vm.flyer.details.length) {
                    vm.flyer.measureList.splice(index, 1);
                } else {
                    vm.flyer.details.forEach(function (detail) {
                        detail.measureList.splice(index, 1);
                    });
                }
            }
        }

        vm.addVariation = function () {
            $uibModal.open({
                templateUrl: 'app/admin/flyers/flyers-add-size-variation.html',
                controller: function (selectedSizes, $uibModalInstance) {
                    var vm = this;

                    vm.tab = 'classic';
                    vm.sizes = getClassicSizes();
                    vm.selectedSizes = selectedSizes;

                    vm.changeTab = function(tab) {
                        vm.tab = tab;
                        switch (tab) {
                            case 'classic':
                                vm.sizes = getClassicSizes();
                                break;
                            case 'juvenileChild':
                                vm.sizes = getJuvenileChildSizes();
                                break;
                            case 'shorts':
                                vm.sizes = getShortSizes();
                                break;
                            case 'plusSize':
                                vm.sizes = getPlusSizes();
                                break;
                            case 'others':
                                vm.sizes = vm.sizes = getOtherSizes();
                                break;
                            default:
                                break;
                        }
                    }

                    vm.checkSize = function (size, evt) {
                        if (evt.target.checked) {
                            vm.selectedSizes.push(size);
                        } else {
                            var index = vm.selectedSizes.indexOf(size);
                            vm.selectedSizes.splice(index, 1);
                        }
                    }

                    vm.isChecked = function (size) {
                        return selectedSizes.includes(size)
                    }

                    vm.closeModal = function () {
                        $uibModalInstance.dismiss('cancel');
                    }

                    vm.ok = function () {
                        $uibModalInstance.close(vm.selectedSizes);
                    }
                },
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    selectedSizes: function () {
                        return angular.copy(vm.selectedSizes);
                    }
                }
            }).result.then(function (response) {
                if (response) {
                    // Add new items
                    angular.forEach(response, function (newSize) {
                        if (!vm.selectedSizes.includes(newSize)) {
                            vm.flyer.details.push({
                                size: newSize,
                                purchaseValue: undefined,
                                discountedValue: undefined,
                                inventory: undefined,
                                quantityByPerson: undefined,
                                dimension: undefined,
								imgFlyerId: undefined,
                                measureList: []
                            })
                        }
                    })

                    // Remove old items
                    angular.forEach(vm.selectedSizes, function (currentSize) {
                        if (!response.includes(currentSize)) {
                            _.remove(vm.flyer.details, function (detail) {
                                return detail.size === currentSize;
                            });
                        }
                    })
                    vm.selectedSizes = response;
                }
            });
        }

        vm.removeVariation = function (index) {
            _.remove(vm.selectedSizes, function (size) {
                return vm.flyer.details[index].size === size;
            })
            vm.flyer.details.splice(index, 1);
        }

        // private methods
        $scope.$watch('vm.mainMap.zoom', function (newVal) {
            if (newVal > 16 && vm.firstZoom) {
                vm.mainMap.zoom = 16;
                vm.firstZoom = false;
            }
        });

        function saveFlyer() {
            // Valid dates

            if (!vm.enableIndiviualPrice) {
                if (!vm.flyer.details || vm.flyer.details.length === 0) {
                    toastr.warning('Adicione ao menos uma variação');
                    return;
                }
                vm.flyer.ean = null;
            }

            if (vm.flyer.startDate) {
                // Compare the day
                if (vm.flyer.expirationDate) {
                    if (moment(vm.flyer.startDate, DATE_FORMAT).isSameOrAfter(moment(vm.flyer.expirationDate, DATE_FORMAT))) {
                        toastr.warning($translate.instant('error.flyerStartDateGreaterThanOrEqualsToExpirationDate'));
                        return;
                    }
                }
            }

            if (vm.measureList.length) {
                var obj = {};
                for ( var i=0, len=vm.measureList.length; i < len; i++ ) {
                    obj[vm.measureList[i]['name']] = vm.measureList[i];
                }
                var unique = new Array();
                for ( var key in obj ) {
                    unique.push(obj[key]);
                }
                if (unique.length != vm.measureList.length) {
                    toastr.error($translate.instant('error.flyerDuplicateMeasures'));
                    vm.isSaving = false;
                    return;
                }
            }

            if (vm.flyer.measureList && vm.flyer.measureList.length) {
                vm.flyer.measureList.forEach(function (measure, index) {
                    measure.name = vm.measureList[index].name;
                });
            } else {
                vm.flyer.details.forEach(function (detail) {
                    if (detail.measureList) {
                        detail.measureList.forEach(function (measure, index) {
                            measure.name = vm.measureList[index].name;
                        });
                    }
                });
            }


            vm.existsSalesPoint = false;

            var flyerToSave = angular.copy(vm.flyer);
            flyerToSave.id = vm.isEdit ? vm.flyer.id : undefined;
            flyerToSave.isPublished = vm.flyer.isPublished ? vm.flyer.isPublished : false;

            flyerToSave.startDate = vm.flyer.startDate ? moment(vm.flyer.startDate, DATE_FORMAT).toDate() : now;
            flyerToSave.expirationDate = vm.flyer.expirationDate ? moment(vm.flyer.expirationDate, DATE_FORMAT).toDate() : undefined;
            flyerToSave.validityTypeDate = !!vm.flyer.expirationDate;
            flyerToSave.storeId = $localStorage.defaultStore.storeId;
            flyerToSave.salesPoint = [];
            flyerToSave.currency = vm.flyer.currencyInstance.key;
            flyerToSave.gender = parseInt(vm.flyer.gender);
            flyerToSave.tags = vm.flyer.tags.map(function (tag) {
                return tag['text'];
            });

            flyerToSave.discountedValue = flyerToSave.discountedValue > 0 ? flyerToSave.discountedValue : null;
            flyerToSave.brand = vm.flyer.brand.name;
			if (document.getElementById('color') && vm.searchColorText != "" && vm.flyer.color == null) {
				toastr.warning("A cor informada não está cadastrada")
				return;
			}
			if (vm.searchColorText != "" && vm.flyer.color != null){
				flyerToSave.color = vm.flyer.color.name;
            }

            vm.mainMap.markers.forEach(function (point) {
                if (point.clicked) {
                    vm.existsSalesPoint = true;
                    var newPoint = point.pointlocation;
                    newPoint.storeId = $localStorage.defaultStore.storeId;
                    newPoint.location = {
                        type: "POINT",
                        "x": point.latitude,
                        "y": point.longitude,
                        coordinates: [point.latitude, point.longitude]
                    };
                    flyerToSave.salesPoint.push(newPoint);
                }
            });
            if (vm.existsSalesPoint) {
                $q.all(flyerToSave.salesPoint).then(function () {
                    if (vm.isEdit) {
                        FlyersService.updateFlyer(flyerToSave).then(function () {
                            var params = {'brand': flyerToSave.brand, 'category': flyerToSave.categoryKey};
                            $state.go('flyers', params);
                            toastr.success($translate.instant('flyers.messages.update.success'));
                            vm.isSaving = false;
                        }, function (error) {
                            vm.isSaving = false;

                            if (error.status == 400) {
                                var errorValue;
                                if (error.data.data.message.includes('duplicatedEANInDatabase')) {
                                    errorValue = error.data.data.data.join(", ");
                                } else if (error.data.data.message.includes('duplicatedSizeInTable')) {
                                    errorValue = error.data.data.data.join(", ");
                                } else if (error.data.data.message.includes('flyers.messages.published.warning')) {
                                    toastr.warning($translate.instant(error.data.data.message));
                                } else {
                                    errorValue = error.data.data.data;
                                }
                                toastr.error($translate.instant(error.data.data.message, { value: errorValue }));
                            } else {
                                toastr.error($translate.instant('flyers.messages.update.error.general'));
                            }

                        });
                    } else {
                        FlyersService.createFlyer(flyerToSave).then(function () {
                            var params = {'brand': flyerToSave.brand, 'category': flyerToSave.categoryKey};
                            $state.go('flyers', params);
                            toastr.success($translate.instant('flyers.messages.create.success'));
                            vm.isSaving = false;
                        }, function (error) {
                            vm.isSaving = false;
                            if (error.status == 400) {
                                var errorValue;
                                if (error.data.message.includes('duplicatedEANInDatabase')) {
                                    errorValue = error.data.data.join(", ");
                                } else if (error.data.message.includes('flyers.messages.published.warning')) {
                                    toastr.warning($translate.instant(error.data.message));
                                } else {
                                    errorValue = error.data.data;
                                }
                                toastr.error($translate.instant(error.data.message, { value: errorValue }));
                            } else {
                                toastr.error($translate.instant('flyers.messages.create.error.general'));
                            }

                        });
                    }

                });
            } else {
                vm.isSaving = false;
                toastr.error("Você deve selecionar pelo menos um ponto de venda.");
            }
        }

        function loadFlyer(flyerId) {
            FlyersService.getFlyer(flyerId)
                .then(function (response) {
                    vm.flyer = response.data;
                    if (!vm.colors.includes(vm.flyer.color)) {
                        vm.colors.push(vm.flyer.color);
                    }

					if (vm.flyer.demoVideo){
						vm.enableDemoVideo = true;
					}
                    vm.flyer.currencyInstance = vm.currencyConfigurations[vm.flyer.currency];
                    vm.flyer.gender = vm.flyer.gender ? vm.flyer.gender.toString() : undefined;
                    if(vm.flyer.dimension && vm.flyer.dimension.weight != null) {
                        vm.enableDimension = true;
                    }

                    if (vm.flyer.tags && vm.flyer.tags.length > 0) {
                        vm.enableTags = true;
                    } else {
                        vm.flyer.tags = [];
                    }

                    if (vm.flyer.details && vm.flyer.details.length > 0) {
                        angular.forEach(vm.flyer.details, function (detail) {
                            vm.selectedSizes.push(detail.size);
                        })

                        vm.flyer.details.forEach(function (detail) {
                            vm.enableIndiviualPrice = false;

                            if(detail.dimension && detail.dimension.weight != null && !vm.enableDimension) {
                                vm.enableDimension = true;
                            }
                            if(detail.measureList && detail.measureList.length) {
                                vm.enableMeasure = true;
                                detail.measureList.forEach(function(measure){
                                    mapMeasures(measure.name);
                                })
                            } else {
                                detail.measureList = [];
                            }
                        });

                    } else {
                        vm.flyer.details = [];
                    }

                    if(vm.flyer.measureList && vm.flyer.measureList.length) {
                        vm.enableMeasure = true;
                        vm.flyer.measureList.forEach(function(measure){
                            mapMeasures(measure.name);
                        })
                    }

                    if (vm.flyer.bulkQuantity) {
                        vm.enableBatchSale = true;
                    }

                    if (vm.flyer.rulesForUse) {
                        vm.enableRules = true;
                    }

                    if (vm.flyer.startDate || vm.flyer.expirationDate) {
                        vm.enableSchedules = true;
                        if (vm.flyer.startDate) {
                            vm.flyer.startDate = moment(vm.flyer.startDate).format(DATE_FORMAT)
                        }
                        if (vm.flyer.expirationDate) {
                            vm.flyer.expirationDate = moment(vm.flyer.expirationDate).format(DATE_FORMAT);
                            vm.flyer.validityTypeDate = true;
                        }
                        $timeout(function () {
                            vm.changeSchedules();
                        }, 200)
                    }
					vm.loadImages();
                    BrandService.findBrand(vm.flyer.brand).then(function (response) {
                        vm.brands = response.data;
                    });

                    ShowcasesService.isFlyerPublished(flyerId)
                    .then(function (response) {
                        vm.flyer.isPublished = response.data;
                    });

                    loadData();
                }, function () {
                    toastr.success($translate.instant('flyers.messages.load.success'));
                });
        }

        vm.verifyPurchaseNotValid = function() {
            if (vm.flyer.purchaseValue === undefined || vm.flyer.purchaseValue === null) {
                vm.flyerForm.purchaseValue.$setValidity('pattern', true);
                return;
            }

            vm.flyerForm.purchaseValue.$setValidity('pattern', !(vm.flyer.purchaseValue <= 0));
        }

        vm.verifyNotValid = function(index, value) {
            if (value === undefined || value === null) {
                vm.flyerForm['varPurchaseValue' + index].$setValidity('pattern', true);
                return;
            }

            vm.flyerForm['varPurchaseValue' + index].$setValidity('pattern', !(value <= 0));

            // if (!value || isNaN(value)) {
            //     vm.flyerForm['varPurchaseValue' + index].$error.pattern = true;
            //     return true;
            // }

            // vm.flyerForm['varPurchaseValue' + index].$error.pattern = value <= 0;
            // console.log(index + ' ' + value + ' = ' + vm.flyerForm['varPurchaseValue' + index].$error.pattern);
            // return value <= 0;
        }

        function loadData() {
            FlyerCategoryService.listCategoriesByCurrentStore($translate.use(), $localStorage.defaultStore.storeId).then(function (response) {
                vm.categories = response.data;
                sortCategoriesByName();
                if (vm.isEdit) {
                    vm.fullCategory = _.find(vm.categories, function (category) {
                        return category.key === vm.flyer.categoryKey;
                    })
                }
                selectedColorChange();
                vm.isLoading = false;
                initImageHandle();
            });

            StoreService.getSalesPoints($localStorage.defaultStore.storeId).then(function (response) {
                convertToMarkers(response.data);
                if (vm.isEdit) {
                    vm.allSalesPoint = vm.flyer.salesPoint.length === vm.mainMap.markers.length;
                    if (vm.allSalesPoint) {
                        vm.checkAllMarkers();
                    } else {
                        vm.flyer.salesPoint.forEach(function(salesPoint) {
                            for (var i = 0; i < vm.mainMap.markers.length; i++) {
                                if (salesPoint.salesPointId == vm.mainMap.markers[i].pointlocation.salesPointId) {
                                    vm.mainMap.markers[i].clicked = true;
                                    vm.mainMap.markers[i].options.icon = ICON_ACTIVE;
                                }
                            }
                        });
                    }
                } else {
                    vm.allSalesPoint = true;
                    vm.checkAllMarkers();
                }
            });

            BrandService.findBrand("").then(function (response) {
                vm.brands = response.data;
                setBrandObjectOnForm();
            });

        }

        function newBrand(name) {
            BrandService.createBrand(name).then(function (response) {
                toastr.success($translate.instant('brand.messages.success.create'));
                vm.flyer.brand = response.data
				var defer = $q.defer();
				defer.resolve(response.data)
                vm.brands = response.data.slice();
            });
        }

        function querySearchBrand(query) {
            var defer = $q.defer();
            BrandService.findBrand(query === undefined ? "" : query).then(function (response) {
                defer.resolve(response.data)
                vm.brands = response.data.slice();
            }, function (_) {
                deferred.resolve([]);
            });
            return defer.promise;
        }

        function querySearchCategory(query) {
            var results = query ? vm.categories.filter(createFilterFor(query)) : vm.categories;
            var defer = $q.defer();
            defer.resolve(results);
            return defer.promise;
        }

        function createFilterFor(query) {
            var lowercaseQuery = query.toLowerCase();

            return function filterFn(category) {
              return (category.title.toLowerCase().indexOf(lowercaseQuery) === 0);
            };
        }

        function newCategory(name) {
            if (!vm.isCreatingCategory) {
                vm.isCreatingCategory = true;
                var key = name.toUpperCase().replace(/ /g, "_");
                var category = {
                    key: key,
                    langKey: $translate.use(),
                    title: name
                };
                var categoryDTO = { key: key, languages: [{ langKey: $translate.use(), title: name }], categoryGroup: "OUTROS" };

                FlyerCategoryService.createCategoryByStore(categoryDTO).then(function (response) {
                    toastr.success($translate.instant('categorys.messages.new.success'));
                    vm.isCreatingCategory = false;

                    category.ownerKey = response.data.ownerKey;

                    vm.categories.push(category);
                    sortCategoriesByName();
                    selectedCategoryChange(category);

                }, function () {
                    toastr.error($translate.instant('categorys.messages.new.error'));
                    vm.isCreatingCategory = false;
                });
            }
        }

        function selectedCategoryChange(category) {
            if (category) {
                vm.flyer.categoryKey = category.key;
                vm.fullCategory = category;
            }
        }

        function sortCategoriesByName() {
            vm.categories = vm.categories.sort(function(a, b) {
                if (a.title.toLowerCase() < b.title.toLowerCase()) {
                    return -1;
                }
                if (a.title.toLowerCase() > b.title.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
        }

        function selectedColorChange() {

            ColorService.findColor("").then(function (response) {
				var defer = $q.defer();
				defer.resolve(response.data)
                vm.colors = response.data.slice();
                var index = vm.colors.findIndex(function (value) {
                    return value.name == vm.flyer.color;
                });
                vm.flyer.color =  vm.colors[index];
            });
        }

        function newColor(name) {
            ColorService.createColor(name).then(function (response) {
                toastr.success($translate.instant('color.messages.success.create'));
                vm.flyer.color = response.data
				var defer = $q.defer();
				defer.resolve(response.data)
                vm.colors = response.data.slice();
            });
        }


//		$scope.ok = function() {
//		  document.querySelector('md-virtual-repeat-container').classList.add('ng-hide');
//		};
//
//		$scope.searchTextChange = function() {
//		  document.querySelector('md-virtual-repeat-container').classList.remove('ng-hide');
//		};

        function querySearchColor(query) {
			vm.searchColorText = vm.capitalize(query);
			query = vm.searchColorText;
            var defer = $q.defer();
            ColorService.findColor(query === undefined ? "" : query).then(function (response) {
                defer.resolve(response.data)
                vm.colors = response.data.slice();
            }, function (_) {
                deferred.resolve([]);
            });
            return defer.promise;
        }

        function selectedBrandChange(brand) {
            // console.log('Brand changed to ' + JSON.stringify(brand));
        }

        function convertToMarkers(points) {
            points.forEach(function (point) {
                vm.mainMap.markers.push({
                    pointlocation: {
                        name: point.name,
                        country: point.country,
                        state: point.state,
                        neighborhood: point.neighborhood,
                        number: point.number,
                        address: point.address,
                        city: point.city,
                        salesPointId: point.id,
                        postalCode: point.postalCode,
                        contactPhone: point.contactPhone,
                        storeId: vm.store
                    },
                    latitude: point.coordinate.latitude,
                    longitude: point.coordinate.longitude,
                    id: point.id,
                    clicked: false,
                    options: {
                        icon: ICON_INACTIVE
                    }
                });
            });
            if (points.length === 1) {
                vm.allSalesPoint =
                vm.checkAllMarkers();
            }
        }

        function initImageHandle() {
                $timeout(function () {
                    angular.element(document.querySelector('#imgInput1')).on('change', handleFileSelect);
                    angular.element(document.querySelector('#imgInput2')).on('change', handleFileSelect);
                    angular.element(document.querySelector('#imgInput3')).on('change', handleFileSelect);
                    angular.element(document.querySelector('#imgInput4')).on('change', handleFileSelect);
                }, 200)
        }

		function handleFileSelect(e) {
			var id = e.currentTarget.id.replace('imgInput','');
            var file = e.currentTarget.files[0];
            if ((file.size / 1024) > MAX_IMAGE_SIZE) {
                toastr.error($translate.instant('flyers.messages.create.image.sizeError'));
            } else {
                var reader = new FileReader();
	                reader.onload = function (e) {
	                $scope.PreviewImage = e.target.result;
	                $scope.$apply();
	                vm.imgsFlyers.forEach(function (imgFlyer) {
	                    if (imgFlyer.id === id) {
	                        imgFlyer.src = e.target.result;
	                        imgFlyer.isDefault = false;
							imgFlyer.isModified = true;
	                    }
	                });
	                vm.moveImageFlyerToFirstIndex();
                    /*$scope.$apply(function () {
                        vm.imageUpload = evt.target.result;
                    });*/
                };
                reader.readAsDataURL(file);
            }
        }

        function checkExpirationDate() {
            if (vm.flyer.expirationDate) {
                if (moment(vm.flyer.startDate, DATE_FORMAT).isSameOrAfter(moment(vm.flyer.expirationDate, DATE_FORMAT))) {
                    /** returns false if the expirationDate is before startDate */
                    return false;
                }
                /** returns true if the expirationDate is ok (the expirationDate is after startDate) */
                return true;
            }
        }

        function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);

            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {
                type: mimeString
            });
        }

        function setBrandObjectOnForm() {
            vm.brands.forEach(function (brand){
                if(brand.name === vm.flyer.brand) {
                    vm.flyer.brand = brand
                    return;
                }
            });
        }

        vm.flyersSelectImageDetailModal = function(detail, index) {
            $uibModal.open({
                templateUrl: 'app/admin/flyers/flyers-select-image-detail.html',
                controller: function (imgsFlyers, imgFlyerId, size, $uibModalInstance) {
                    var vm = this;
                    vm.imgsFlyers = imgsFlyers;
                    vm.imgFlyerId = imgFlyerId;
                    vm.size = size;
                    vm.close = close;

                    vm.sortableOptionsDetail = {
                        disabled: true
                    };

                    vm.selectImg = function(imgsFlyer) {
                        if (!imgsFlyer.isDefault) {
                            if(vm.imgFlyerId === imgsFlyer.id) {
                                vm.imgFlyerId = null;
                            } else {
                                vm.imgFlyerId = imgsFlyer.id;
                            }
                        }
                    }

		            vm.getCountDefaultImageFlyer = function () {
			            var count = 0;
			            vm.imgsFlyers.forEach(function (img){
			                if(img.isDefault) {
			                    count++;
			                }
			            });
			            return count;
			        }

                    function close() {
                        $uibModalInstance.close(vm.imgFlyerId);
                    }

                },
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                keyboard  : false,
                resolve: {
                    imgsFlyers: function () {
                        return angular.copy(vm.imgsFlyers);
                    },
                    size: function () {
                        return detail.size;
                    },
                    imgFlyerId: function () {
                        return detail.imgFlyerId;
                    }
                }
            }).result.then(function(selectImgId) {
                vm.addOrUpdateImgDetail(selectImgId, index)

            });
        }

        vm.openInputImage = function (evt, id) {
            document.getElementById('imgInput' + id).click();
        }

        vm.changeDemoVideo = function () {
            if (!vm.enableDemoVideo) {
                vm.flyer.demoVideo = null;
            }
        }

        vm.getCountDefaultImageFlyer = function () {
            var count = 0;
            vm.imgsFlyers.forEach(function (img){
                if(img.isDefault) {
                    count++;
                }
            });
            return count;
        }

        vm.moveImageFlyerToFirstIndex = function () {
            var imgsDefault = [];
            var imgs = [];
            $timeout(function () {
                for (var i = 0; i < vm.imgsFlyers.length; i++) {
                    vm.imgsFlyers[i].isThumbnail = false;
                    if (vm.imgsFlyers[i].isDefault) {
                        imgsDefault.push(vm.imgsFlyers[i]);
                    } else {
                        imgs.push(vm.imgsFlyers[i]);
                    }
				}

                vm.imgsFlyers = imgs;
				for (var j = 0; j < imgsDefault.length; j++) {
					vm.imgsFlyers.push(imgsDefault[j]);
				}
				if (vm.imgsFlyers[0].isDefault){
					vm.imgsFlyers[0].isThumbnail = false;
				}else{
					vm.imgsFlyers[0].isThumbnail = true
				}
            }, 500);
        }

       vm.removeImgFlyer = function (id) {
           vm.imgsFlyers.forEach(function (imgFlyer) {
                if (imgFlyer.id === id) {
                    imgFlyer.src = vm.srcImgDefault;
                    imgFlyer.isDefault = true;
                    imgFlyer.isThumbnail = false;
                }
            });
           vm.removeReferenceImgDetail(id);
            vm.moveImageFlyerToFirstIndex();
        }

        vm.addOrUpdateImgDetail = function (imgFlyerId, index) {
            vm.flyer.details[index].imgFlyerId = imgFlyerId;

//			vm.flyer.details.forEach(function (detail) {
//                if (detail.size === sizeDetail) {
//                    detail.imgFlyerId = imgFlyerId;
//                }
//            });
        }

        vm.removeReferenceImgDetail = function (imgFlyerId) {
            vm.flyer.details.forEach(function (detail) {
                if (detail.imgFlyerId === imgFlyerId) {
                    detail.imgFlyerId = null;
                }
            });
        }

        vm.getIndexImageById = function (imgFlyerId) {
            for (var i = 0; i < vm.imgsFlyers.length; i++) {
                if (vm.imgsFlyers[i].id === imgFlyerId) {
                    return parseInt(i);
                }
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('flyersDescriptionCollapse', FlyersDescriptionCollapse);

    FlyersDescriptionCollapse.$inject = ['$compile'];

    function FlyersDescriptionCollapse($compile) {
        return {
            restrict: 'A',
            scope: true,
            link: function(scope, element, attrs) {
                scope.collapsed = false;

                scope.toggle = function() {
                    scope.collapsed = !scope.collapsed;
                };

                attrs.$observe('flyersDescriptionCollapseText', function(text) {
                    scope.text = text;
                    var maxLength = scope.$eval(attrs.flyersDescriptionCollapseMaxLength);

                    if (text.length > maxLength) {
                        var firstPart = String(text).substring(0, maxLength);
                        var firstSpan = $compile('<span>' + firstPart + '</span>')(scope);
                        var moreIndicatorSpan = $compile('<span>... </span>')(scope);
                        var lineSpan = $compile('<br>')(scope);
                        var toggleButton = $compile('<span ng-click="vm.openDescriptionModal()"><span class="flyer-detail-description" data-translate="flyers.detail.fulldescription"></span></span>')(scope);
                        element.empty();
                        element.append(firstSpan);
                        element.append(moreIndicatorSpan);
                        element.append(lineSpan);
                        element.append(toggleButton);
                    }
                    else {
                        element.empty();
                        element.append(text);
                    }
                });
            }
        };
    }
}());

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FlyersEditImageController', FlyersEditImageController);

    FlyersEditImageController.$inject = ['$translate', '$timeout', '$scope', 'FlyersService', 'toastr', '$uibModalInstance', 'flyer'];

    function FlyersEditImageController($translate, $timeout, $scope, FlyersService, toastr, $uibModalInstance, flyer) {
        var vm = this;
        vm.isSaving = false;
        vm.imageSize = 600;
        vm.flyer = flyer;
        vm.flyerImage = '';

        vm.closeModal = function() {
            $uibModalInstance.close();
        }

        vm.uploadPreview = function(img) {
            var reader = new FileReader();
            reader.onload = vm.imageIsLoaded;
            reader.readAsDataURL(img)
        }

        vm.openInput = function(evt) {
            document.getElementById('fileInput').click();
        }

        var handleFileSelect = function(evt) {
            var file = evt.currentTarget.files[0];
            var reader = new FileReader();
            reader.onload = function(evt) {
                $scope.$apply(function($scope) {
                    vm.imageUpload = evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        };

        vm.imageIsLoaded = function(e) {
            $scope.$apply(function() {
                vm.flyer.imagePath = e.target.result;
            });
        }

        function dataURItoBlob(dataURI) {
            // convert base64/URLEncoded data component to raw binary data held in a string
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], {
                type: mimeString
            });
        }

        vm.save = function() {
            FlyersService.saveFlyerImage(dataURItoBlob(vm.flyerImage)).then(function(response) {
                $timeout(function() {
                    vm.flyer.addImageFileDTO = response.data;
                    vm.isSaving = true;
                    FlyersService.updateFlyer(vm.flyer).then(function(data) {
                        vm.isSaving = false;
                        $uibModalInstance.close(data);
                        toastr.success($translate.instant('flyers.messages.update.success'));
                    }, function(error) {
                        $uibModalInstance.dismiss(error);
                    });
                });
            });
        }

        vm.initFlyerImageModal = function() {
            angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FlyersDetailController', FlyersDetailController);

    FlyersDetailController.$inject = ['$state', '$scope', '$filter', '$timeout', 'uiGmapGoogleMapApi', 'FlyersCurrencyValue', '$translate', 'FlyerCategoryService', 'StoreService', 'FlyersService', '$localStorage', '$q', '$stateParams', 'toastr', '$uibModal', '$rootScope'];

    function FlyersDetailController($state, $scope, $filter, $timeout, uiGmapGoogleMapApi, FlyersCurrencyValue, $translate, FlyerCategoryService, StoreService, FlyersService, $localStorage, $q, $stateParams, toastr, $uibModal, $rootScope) {

        var vm = this;

        vm.loadingImage = false;
        vm.mainMap = {
            center: {
                latitude: 0,
                longitude: 0
            },
            zoom: 8,
            controls: {},
            bounds: {}
        };
        vm.options= {
            fullscreenControl: false
        };
        vm.allSelected = false;
        vm.isLoading = true;
        vm.showImage = true;
        vm.mainMap.markers = [];
        vm.showMap = false;
        vm.mainMap.window = {
            model: {},
            show: false,
            options: {
                pixelOffset: {
                    width: -1,
                    height: -65
                }
            },
            closeClick: function() {
                this.show = false;
            }
        }

        uiGmapGoogleMapApi.then(function() {
            loadFlyer();
        });

        vm.openDescriptionModal = openDescriptionModal;

        vm.mainMap.markerEvents = {
            dragend: function(marker, eventName, model) {
                vm.refreshMapWithCoordinates(marker.position.lat(), marker.position.lng());
            },
            mouseover: function(marker, eventName, model, args) {
                vm.mainMap.window.model = model;
                vm.mainMap.window.show = true;
            },
            mouseout: function(marker, eventName, model, args) {
                vm.mainMap.window.show = false;
            },
            click: function(marker, eventName, model, args) {
                if (!isOnlyOneSelected(model)) {
                  for (var i = 0; i < vm.mainMap.markers.length; i++) {
                      if (vm.mainMap.markers[i].id == marker.key) {
                          if (vm.mainMap.markers[i].clicked) {
                              vm.mainMap.markers[i].options.icon = ICON_INACTIVE;
                              vm.mainMap.markers[i].clicked = false;
                              updateFlyer();
                          } else {
                              vm.mainMap.markers[i].options.icon = ICON_ACTIVE;
                              vm.mainMap.markers[i].clicked = true;
                              updateFlyer();
                          }
                      }
                  }
                  checkAllMarkersIsSelected();
                } else {
                  toastr.error($translate.instant('flyers.detail.error.atLeastOneSelected'));
                }
            }
        };

        vm.firstZoom = true;

        $scope.$watch('vm.mainMap.zoom', function(newVal) {
            if (newVal > 16 && vm.firstZoom) {
                vm.mainMap.zoom = 16;
                vm.firstZoom = false;
            }
        });

        vm.getEditFlyer = function() {
            $state.go('flyers.edit', {
                id: vm.flyer.id
            });
        }

        vm.getEditFlyerImage = function() {
            $uibModal.open({
                templateUrl: 'app/admin/flyers/flyers-edit-image.html',
                controller: 'FlyersEditImageController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    flyer: function() {
                        return angular.copy(vm.flyer);
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function(response) {
                if (response) {
                    vm.loadingImage = true;
                    vm.flyer = response.data;
                    $timeout(function() {
                        vm.imagePath = $filter('randomSrc')("/flyer/api/" + vm.flyer.id + "/picture?type=x_large&t=" + new Date().getTime());
                        vm.loadingImage = false;
                    }, 2000);
                    refreshCategory();
                }
            });
        }

        var ICON_ACTIVE = 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/pointactive.png';
        var ICON_INACTIVE = 'content/images/pointinactive.png';

        function isOnlyOneSelected(model){
            var count = 0;
            var modelIsSelected = false;
            for (var i = 0; i < vm.mainMap.markers.length; i++) {
                vm.mainMap.markers[i].clicked ? count++ : null;
                if (vm.mainMap.markers[i].id == model.id){
                    modelIsSelected =  vm.mainMap.markers[i].clicked;
                }
            }

            return (count == 1 && modelIsSelected);

        }

        vm.checkAllMarkers = function() {
            vm.allSelected = !vm.allSelected;
            var icon;
            if (vm.allSelected) {
                icon = ICON_ACTIVE;
            } else {
                icon = ICON_INACTIVE;
            }
            // The index need to begin with 1 because has to left unless one salespoint selected
            if (vm.allSelected){
                var beginsWith = 0;
            }
            else {
                var beginsWith = 1;
            }
            for (var i = beginsWith; i < vm.mainMap.markers.length; i++) {
                vm.mainMap.markers[i].options.icon = icon;
                vm.mainMap.markers[i].clicked = vm.allSelected;
            }
            updateFlyer();
        }

        vm.getFlyerCurrency = function(currency) {
            return FlyersCurrencyValue[currency];
        }


        vm.getFlyerTooltip = function (status) {
            switch (status) {
                case 'ACTIVATED':
                    return 'flyers.offer.active';
                case 'DEACTIVATED':
                    return 'flyers.offer.disabled';
                case 'EXPIRED':
                    return 'flyers.offer.expired';
                case 'CLOSED':
                    return 'flyers.offer.closed';
            }
        }

        function loadFlyer() {
            FlyersService.getFlyer($stateParams.id).then(function(response) {
                vm.flyer = response.data;
                vm.imagePath = $filter('randomSrc')("/flyer/api/" + vm.flyer.id + "/picture?type=x_large");
                refreshCategory();
                StoreService.getSalesPoints($localStorage.defaultStore.storeId).then(function(response) {
                    convertToMarkers(response.data);
                    checkAllMarkersIsSelected();
                });
            }, function (err) {
                if (err.status == 404){
                    toastr.error($translate.instant('flyers.messages.load.notFound'));
                    $state.go('flyers');

                }
            });
        }

        function checkAllMarkersIsSelected() {
            if (vm.flyer.salesPoint.length === vm.mainMap.markers.length) {
                vm.allMarkersChecked = true;
                vm.allSelected = true;
            } else {
                vm.allMarkersChecked = false;
                vm.allSelected = false;
            }
        }

        function openDescriptionModal(){
            $uibModal.open({
                templateUrl: 'app/admin/flyers/flyers-description-modal.html',
                controller: function(flyerDescription, $uibModalInstance){
                    var vm = this;
                    vm.flyerDescription = flyerDescription;

                    vm.closeModal = function(){
                        $uibModalInstance.dismiss('cancel');
                    }

                    vm.ok = function(){
                        $uibModalInstance.close();
                    }
                },
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    flyerDescription: function() {
                        return angular.copy(vm.flyer.description);
                    }
                }
            }).result
        }

        function convertToMarkers(points) {
            points.forEach(function(point) {
                vm.mainMap.markers.push({
                    pointlocation: {
                        name: point.name,
                        country: point.country,
                        state: point.state,
                        neighborhood: point.neighborhood,
                        number: point.number,
                        address: point.address,
                        city: point.city,
                        id: point.id,
                        postalCode: point.postalCode,
                        contactPhone: point.contactPhone,
                        storeId: vm.store,
                        salesPointId: point.id
                    },
                    latitude: point.coordinate.latitude,
                    longitude: point.coordinate.longitude,
                    id: point.id,
                    clicked: false,
                    options: {
                        icon: ICON_INACTIVE
                    }
                });
            });
            $q.all(vm.mainMap.markers).then(function(markers) {
                updateFlyerMarkers();
                $timeout(function() {
                    vm.showMap = false;
                    vm.isLoading = false;
                    $timeout(function () {
                        vm.showMap = true;
                    }, 100);
                }, 50);
            });
        }

        function updateFlyerMarkers() {
            vm.flyer.salesPoint.forEach(function(salesPoint) {
                for (var i = 0; i < vm.mainMap.markers.length; i++) {
                    if (salesPoint.salesPointId == vm.mainMap.markers[i].pointlocation.salesPointId) {
                        vm.mainMap.markers[i].clicked = true;
                        vm.mainMap.markers[i].options.icon = ICON_ACTIVE;
                    }
                }
            });
        }

        function updateFlyer() {
            vm.flyer.salesPoint = [];
            vm.mainMap.markers.forEach(function(point) {
                if (point.clicked) {
                    var newPoint = point.pointlocation;
                    newPoint.storeId = $localStorage.defaultStore.storeId;
                    newPoint.location = {
                        type: "POINT",
                        "x": point.latitude,
                        "y": point.longitude,
                        coordinates: [point.latitude, point.longitude]
                    };
                    vm.flyer.salesPoint.push(newPoint);
                }
            });
            $q.all(vm.flyer.salesPoint).then(function(data) {
                FlyersService.updateFlyer(vm.flyer).then(function(response) {
                    vm.flyer = response.data;
                    toastr.success($translate.instant('flyers.messages.update.success'));
                    updateFlyerMarkers();
                    checkAllMarkersIsSelected();
                    refreshCategory();
                }, function (error) {
                    var header = error.headers();
                    toastr.error($translate.instant(header['x-flyerapp-error']));
                });
            });
        }

        function refreshCategory() {
            FlyerCategoryService.getCategoryTitleByKey(vm.flyer.categoryKey, $translate.use()).then(function(response) {
                vm.flyer.category = response.data;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .value('FlyersCurrencyValue', {
            EURO: "€",
            DOLLAR: "$",
            REAL: "R$",
            LIBRA: "£",
            NOVO_SOL_PERUANO: "S/",
            DINAR_KUWAITIANO: "د.ك",
            DIRHAM_DOS_EMIRADOS_ARABES_UNIDOS: "د.إ",
            PESO_MEXICANO: "Mex$",
            PESO_DOMINICANO: "RD$",
            PESO_FILIPINO: "₱",
        });
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('flyers', {
            parent: 'admin',
            url: '/flyers',
            data: {
                authorities: ['STORE_READ_FLYER'],
                pageTitle: 'flyers.home.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/flyers/flyers.html',
                    controller: 'FlyersController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                type: null,
                brand: null,
                category: null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('flyers');
                    $translatePartialLoader.addPart('brand');
                    $translatePartialLoader.addPart('color');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('flyers.new', {
            url: '/new',
            data: {
                pageTitle: 'flyers.new.title',
                authorities: ['STORE_CREATE_FLYER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/flyers/flyers-form.html',
                    controller: 'FlyersFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('flyers');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('brand');
                    $translatePartialLoader.addPart('color');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('categorys');
                    return $translate.refresh();
                }]
            }
        })
            .state('flyers.edit', {
                url: '/edit/{id}',
                data: {
                    pageTitle: 'flyers.edit.title',
                    authorities: ['STORE_UPDATE_FLYER']
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/flyers/flyers-form.html',
                        controller: 'FlyersFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('error');
                        $translatePartialLoader.addPart('brand');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('categorys');
                        return $translate.refresh();
                    }]
                }
            })
        .state('flyers-detail', {
            parent: 'flyers',
            url: '/{id}',
            data: {
                authorities: ['STORE_READ_FLYER', 'STORE_UPDATE_FLYER'],
                pageTitle: 'flyers.detail.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/flyers/flyers-detail.html',
                    controller: 'FlyersDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('flyers');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('store-management');
                    return $translate.refresh();
                }]
            }
        }).state('flyers.import', {
            parent: 'app',
            url: '/flyers-import',
            data: {
                pageTitle: 'flyers.import.title',
                authorities: ['STORE_CREATE_FLYER'],
                specialClass: "md-skin fixed-nav"
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/flyers/import/flyer-import.html',
                    controller: 'FlyerImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('flyers');
                    return $translate.refresh();
                }]
            }
        });;
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('FlyersService', FlyersService);

    FlyersService.$inject = ['FlyersFactory', '$localStorage', 'Upload'];

    function FlyersService(FlyersFactory, $localStorage, Upload) {

        var service = {
            createFlyer: createFlyer,
            saveFlyerImage: saveFlyerImage,
			saveFlyerMultiImage: saveFlyerMultiImage,
            deleteFlyers: deleteFlyers,
            verifyIfFlyersIsPublished: verifyIfFlyersIsPublished,
            listFlyers: listFlyers,
            listFlyersPage: listFlyersPage,
            updateFlyer: updateFlyer,
            getFlyer: getFlyer,
            getNumberOfFlyers: getNumberOfFlyers,
            getFlyerTypes: getFlyerTypes,
            listAllFlyers: listAllFlyers,
            getImageFlyer: getImageFlyer,
            getLinkImageFlyerAsString: getLinkImageFlyerAsString,
            listAllToAdmin: listAllToAdmin,
            listFlyersPageToModal: listFlyersPageToModal,
            updateFlyerList: updateFlyerList,
            getSizes: getSizes,
            getColors: getColors,
            flyersImportStatus: flyersImportStatus,
            getTypes: getTypes,
            getBrands: getBrands,
            getFeatureds: getFeatureds,
            getTags: getTags,
            getGenders: getGenders,
			getAllFiltersFromFlyersIsPublish: getAllFiltersFromFlyersIsPublish,
			getAllFiltersFlyer: getAllFiltersFlyer,
            listAllFlyersIds: listAllFlyersIds,
            clearFlyersStock: clearFlyersStock,
            applyDiscountsForFlyers: applyDiscountsForFlyers,
            clearFlyersDiscountedValue: clearFlyersDiscountedValue,
            syncFlyersWithHub: syncFlyersWithHub,
            findFlyersByIds: findFlyersByIds
        };

        return service;

        function createFlyer(flyer) {
            return FlyersFactory.save(flyer).$promise;
        }

        function listFlyers(pageable, filter, onSuccess, onError) {
            return FlyersFactory.listAll(pageable, filter, onSuccess, onError);
        }

        function listAllToAdmin(pageable, filter, onSuccess, onError) {
            return FlyersFactory.listAllToAdmin(pageable, filter, onSuccess, onError);
        }

        function listAllFlyersIds(filter) {
            return FlyersFactory.listAllFlyersIds(filter).$promise;
        }

        function listFlyersPage(pageable, filter, onSuccess, onError) {
            return FlyersFactory.listAllPageable(pageable, filter, onSuccess, onError);
        }

        function listFlyersPageToModal(pageable) {
            return FlyersFactory.listAllPageableToModal(pageable, { storeId: $localStorage.defaultStore.storeId }).$promise;
        }

        function verifyIfFlyersIsPublished(flyerIds) {
            return FlyersFactory.verifyIfFlyersIsPublished({flyerIds: flyerIds}).$promise;
        }

        function deleteFlyers(flyerIds) {
            return FlyersFactory.deletebyids({flyerIds: flyerIds}).$promise;
        }

        function getFlyer(flyer) {
            return FlyersFactory.get({flyerId: flyer, storeId: $localStorage.defaultStore.storeId}).$promise;
        }

        function updateFlyer(flyerToSave) {
            return FlyersFactory.update(flyerToSave).$promise;
        }

        function saveFlyerImage(image) {
            return Upload.upload({url: 'zuul/flyer/api/upload', data: {file: image}});
        }

        function saveFlyerMultiImage(image, orderNumber) {
            return Upload.upload({url: 'zuul/flyer/api/multiUpload', data: {file: image, orderNumber: orderNumber}});
        }

        function getNumberOfFlyers(storeId) {
            return FlyersFactory.numberOfFlyers({storeId: storeId}).$promise;
        }

        function getFlyerTypes(storeId) {
            return FlyersFactory.getFlyerTypes().$promise;
		}

        function listAllFlyers() {
            return FlyersFactory.listAllFlyers().$promise;
        }

        function getImageFlyer(flyerId) {
            return FlyersFactory.flyerImage({id: flyerId}).$promise;
        }

        function getLinkImageFlyerAsString(flyerId) {
            return FlyersFactory.flyerLinkImageAsString({id: flyerId}).$promise;
        }

        function updateFlyerList(flyerImport) {
            return FlyersFactory.updateFlyerList(flyerImport).$promise;
        }

        function getSizes() {
            return FlyersFactory.getSizes().$promise;
        }

        function getColors() {
            return FlyersFactory.getColors().$promise;
        }

        function flyersImportStatus(importId) {
            return FlyersFactory.flyersImportStatus({importId: importId}).$promise;
        }

        function getTypes() {
            return FlyersFactory.getTypes().$promise;
        }

        function getBrands() {
            return FlyersFactory.getBrands().$promise;
        }

        function getFeatureds() {
            return FlyersFactory.getFeatureds().$promise;
        }

        function getTags() {
            return FlyersFactory.getTags().$promise;
        }

        function getGenders() {
            return FlyersFactory.getGenders().$promise;
        }

        function getAllFiltersFromFlyersIsPublish() {
            return FlyersFactory.getAllFiltersFromFlyersIsPublish().$promise;
        }

        function getAllFiltersFlyer() {
            return FlyersFactory.getAllFiltersFlyer().$promise;
        }

        function findFlyersByIds(flyerIds) {
            return FlyersFactory.findFlyersByIds(flyerIds).$promise;
        }

        function clearFlyersStock(flyersId) {
            return FlyersFactory.clearFlyersStock(flyersId).$promise;
        }

        function applyDiscountsForFlyers(flyersId, discountPercentage) {
            return FlyersFactory.applyDiscountsForFlyers({ flyersId: flyersId, discountPercentage: discountPercentage }).$promise;
        }

        function clearFlyersDiscountedValue() {
            return FlyersFactory.clearFlyersDiscountedValue().$promise;
        }

        function syncFlyersWithHub(flyerIds, params) {
            return FlyersFactory.syncFlyersWithHub({ flyerIds: flyerIds, syncParams: params }).$promise;
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('FlyersFactory', FlyersFactory);

    FlyersFactory.$inject = ['$resource'];

    function FlyersFactory($resource) {
        var resourceUrl =  'flyer/api/flyer/:flyerId';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'numberOfFlyers': {
                method: 'GET',
                url: 'flyer/api/store/:storeId/numberOfFlyers',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        try {
                            response.data = angular.fromJson(data);
                        } catch (err) {}
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getFlyerTypes': {
                method: 'GET',
                url: 'flyer/api/flyer/getFlyerTypes',
                // isArray: true,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deletebyids': {
                method: 'POST',
                url: '/flyer/api/flyer/deletebyids'
            },
            'verifyIfFlyersIsPublished': {
                method: 'POST',
                url: '/flyer/api/flyer/verify-flyer-is-published'
            },
            'fileUpload': {
                method: 'POST',
                url: '/flyer/api/flyer/upload'
            },
            'listAll': {
                method: 'POST',
                url: 'flyer/api/flyer/list',
                isArray: true
            },
            'listAllToAdmin': {
                method: 'POST',
                url: 'flyer/api/flyer/list-to-admin',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'listAllFlyersIds': {
                method: 'POST',
                url: 'flyer/api/flyer/list-flyers-ids',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getSizes': {
                method: 'GET',
                url: 'flyer/api/flyer/size',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'listAllFlyers': {
                method: 'GET',
                url: 'flyer/api/flyer/listall',
                isArray: true,
                cache: false
            },
            'listAllPageable': {
                method: 'POST',
                url: 'flyer/api/flyer/list/page',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'listAllPageableToModal': {
                method: 'POST',
                url: 'flyer/api/flyer/list/page/to-modal',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'flyerImage': {
                method: 'GET',
                url: 'flyer/api/:id/picture',
                cache: false
            },
            'flyerLinkImageAsString': {
                method: 'GET',
                url: 'flyer/api/:id/picture-link-as-string',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'update': {
                method:'PUT',
                cache: false,
                timeout: 20000,
                transformResponse: function (data, headers) {
                    if(data){
                        var response = {};
                        response.data = angular.fromJson(data);
                        response.headers = headers();
                        return response;
                    }
                }
            },
            'updateFlyerList': {
                method: 'POST',
                url: 'flyer/api/flyer/updateList',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getColors': {
                method: 'GET',
                url: 'flyer/api/flyer/color',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'flyersImportStatus': {
                method: 'GET',
                url: 'flyer/api/flyer/import-flyers-from-table/:importId',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'getTypes': {
                method: 'GET',
                url: 'flyer/api/flyer/types',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getBrands': {
                method: 'GET',
                url: 'flyer/api/flyer/brands',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getFeatureds': {
                method: 'GET',
                url: 'flyer/api/flyer/featureds',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getTags': {
                method: 'GET',
                url: 'flyer/api/flyer/tags',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getGenders': {
                method: 'GET',
                url: 'flyer/api/flyer/genders',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getAllFiltersFromFlyersIsPublish': {
                method: 'GET',
                url: 'flyer/api/flyer/filters-flyers-publish',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getAllFiltersFlyer': {
                method: 'GET',
                url: 'flyer/api/flyer/filters-flyers',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'clearFlyersStock': {
                method: 'PUT',
                url: 'flyer/api/flyer/clear-stock',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'applyDiscountsForFlyers': {
                method: 'PUT',
                url: 'flyer/api/flyer/apply-discounts',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'clearFlyersDiscountedValue': {
                method: 'POST',
                url: 'flyer/api/flyer/clear-discounted-value',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'syncFlyersWithHub': {
                method: 'POST',
                url: 'flyer/api/flyer/sync-flyer-with-hub',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'findFlyersByIds': {
                method: 'POST',
                url: 'flyer/api/flyer/find-by-ids',
                cache: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FlyersController', FlyersController);

    function FlyersController(FlyersCurrencyValue, Principal, Constants, $scope, $translate, $localStorage, $state, FlyersService,
                              FlyerCategoryService, toastr, $timeout, RemoveModalFactory, ModalFactory, paginationConstants,
                              StoreService, $stateParams, BrandService, ModalBrandFactory, ShowcasesService,
                              ErpsSettingsService, OnlineRetailService, BlingService, NexaasService, $uibModal) {

        var vm = this;

        vm.currentPage = 1;
        vm.numPerPage = paginationConstants.itemsPerPage;
        vm.maxSize = 5;
        vm.totalFlyers = 0;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;
        vm.time_stamp_to_image = '';

        vm.selectedFlyers = [];

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage
        };
        vm.configuration = {};

        vm.flyersFiltered = [];
        vm.flyersTypes = [];
        vm.displayType = "Table";
        vm.zeroOffers = false;
        vm.displayTypeList = ["Cards", "Table"];
        vm.startDate = {
            startDate: null,
            endDate: null
        };
        vm.tabInfo = {
            existsCouponsFlyer: false,
            existsRentFlyer: false,
            existsContactFlyer: false,
            existsSaleFlyer:false
        };
        vm.showCouponsWithActive = false;
        vm.isLoading = true;
        vm.listFlyers = true;
        vm.loadingArray = ["1", "2", "3", "4"];
        vm.removeCouponsWithIds = [];
        vm.listFilter = {
            storeId: $localStorage.defaultStore.storeId,
            activated: null,
            text: '',
            hasInventory: false
        };
        vm.userIsAdmin = false;

        vm.flyersToRemove = [];

        vm.page = 0;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.hasNextPage = false;
        vm.busy = false;
        vm.loadingTab = true;
        vm.brands = [];
        vm.brandGroups = {};
        vm.colors = [];
        vm.viewByCategories = false;
        vm.categoryGroups = {};
        vm.numberFilterSelected = 0;

        vm.sortOptions = paginationConstants.sortOptions[$translate.use().toLowerCase()];
        
        vm.selectedSortByOption = "";

        vm.loadingActionRequest = false;
        vm.erpProductsCount = 0;
        vm.actions = [
            {
                value: 'REMOVE',
                translation: 'flyers.selection-actions.remove',
                actionFunc: function () {
                    return vm.verifyIfFlyersIsPublished();
                }
            },
            {
                value: 'PUBLISH',
                translation: 'flyers.selection-actions.publish',
                actionFunc: function () {
                    ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.publish-modal.title'),
                        $translate.instant('flyers.selection-actions.modals.publish-modal.subtitle', { amount: vm.selectedFlyers.length }),
                        $translate.instant('flyers.selection-actions.modals.publish-modal.small-text'),
                        null,
                        $translate.instant('flyers.selection-actions.modals.publish-modal.confirm-button'),
                        $translate.instant('flyers.selection-actions.modals.cancel'),
                        vm.publishFlyers
                    );
                }
            },
            {
                value: 'UNPUBLISH',
                translation: 'flyers.selection-actions.unpublish',
                actionFunc: function () {
                    ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.unpublish-modal.title'),
                        $translate.instant('flyers.selection-actions.modals.unpublish-modal.subtitle', { amount: vm.selectedFlyers.length }),
                        $translate.instant('flyers.selection-actions.modals.unpublish-modal.small-text'),
                        null,
                        $translate.instant('flyers.selection-actions.modals.unpublish-modal.confirm-button'),
                        $translate.instant('flyers.selection-actions.modals.cancel'),
                        vm.unpublishFlyers
                    );
                }
            },
            {
                value: 'CLEAR_STOCK',
                translation: 'flyers.selection-actions.clear-stock',
                actionFunc: function () {
                    ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.clear-stock-modal.title'),
                        $translate.instant('flyers.selection-actions.modals.clear-stock-modal.subtitle', { amount: vm.selectedFlyers.length }),
                        $translate.instant('flyers.selection-actions.modals.clear-stock-modal.small-text'),
                        null,
                        $translate.instant('flyers.selection-actions.modals.clear-stock-modal.confirm-button'),
                        $translate.instant('flyers.selection-actions.modals.cancel'),
                        vm.clearStock
                    );
                }
            },
            {
                value: 'APPLY_DISCOUNTS',
                translation: 'flyers.selection-actions.apply-discounts',
                actionFunc: function () {
                    ModalFactory.openDiscountModal($translate.instant('flyers.selection-actions.modals.discount-modal.title'),
                        $translate.instant('flyers.selection-actions.modals.discount-modal.subtitle'),
                        $translate.instant('flyers.selection-actions.modals.discount-modal.input-label'),
                        $translate.instant('flyers.selection-actions.modals.discount-modal.input-footer'),
                        $translate.instant('flyers.selection-actions.modals.discount-modal.confirm-button'),
                        $translate.instant('flyers.selection-actions.modals.cancel'),
                        applyDiscounts
                    );
                }
            },
            {
                value: 'SYNC_ERP',
                translation: 'flyers.selection-actions.sync-with-erp',
                actionFunc: function () {
                    ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.sync-erp-modal.title'),
                        $translate.instant('flyers.selection-actions.modals.sync-erp-modal.subtitle', { amount: vm.selectedFlyers.length }),
                        $translate.instant('flyers.selection-actions.modals.sync-erp-modal.small-text'),
                        $translate.instant('flyers.selection-actions.modals.sync-erp-modal.warning-text'),
                        $translate.instant('flyers.selection-actions.modals.sync-erp-modal.confirm-button'),
                        $translate.instant('flyers.selection-actions.modals.cancel'),
                        vm.syncronizeProducts
                    );
                }
            },
            {
                value: 'SYNC_IMAGE_FLYERS',
                translation: 'flyers.selection-actions.sync-flyers-with-hub',
                actionFunc: function () {
                    ModalFactory.openSyncWithHubModal($translate.instant('flyers.selection-actions.modals.sync-flyers-with-hub-modal.title'),
                        $translate.instant('flyers.selection-actions.modals.sync-flyers-with-hub-modal.subtitle', { amount: vm.selectedFlyers.length }),
                        $translate.instant('flyers.selection-actions.modals.sync-flyers-with-hub-modal.small-text'),
                        null,
                        [
                            {
                                translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-name',
                                value: false,
                                syncParam: "SYNC_PARAM_NAME"
                            },
                            {
                                translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-description',
                                value: false,
                                syncParam: "SYNC_PARAM_DESCRIPTION"
                            },
                            {
                                translateId: 'flyers.selection-actions.modals.sync-flyers-with-hub-modal.param-image',
                                value: false,
                                syncParam: "SYNC_PARAM_IMAGE"
                            }
                        ],
                        $translate.instant('flyers.selection-actions.modals.sync-flyers-with-hub-modal.confirm-button'),
                        $translate.instant('flyers.selection-actions.modals.cancel'),
                        vm.syncronizeProductsWithHub
                    );
                }
            }
        ]

        vm.selectionTypes = [
            {
                value: 'ALL',
                translation: 'flyers.selection-filters.all'
            },
            {
                value: 'ALL_FROM_PAGE',
                translation: 'flyers.selection-filters.select-all-from-page'
            },
            {
                value: 'ALL_FROM_TAB',
                translation: 'flyers.selection-filters.select-all-from-tab'
            },
            {
                value: 'PUBLISHED',
                translation: 'flyers.selection-filters.published'
            },
            {
                value: 'UNPUBLISHED',
                translation: 'flyers.selection-filters.unpublished'
            },
            {
                value: 'OUT_OF_STOCK',
                translation: 'flyers.selection-filters.out-of-stock'
            },
            {
                value: 'WITH_STOCK',
                translation: 'flyers.selection-filters.with-stock'
            },
            {
                value: 'NONE',
                translation: 'flyers.selection-filters.select-none'
            }
        ];

        vm.selectionTypesData = {
            currentSelection: 'NONE',
            'ALL': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllFromStore();
                }
            },
            'ALL_FROM_PAGE': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllItems();
                }
            },
            'ALL_FROM_TAB': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllFromTab();
                }
            },
            'PUBLISHED': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllPublished();
                }
            },
            'UNPUBLISHED': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllUnpublished();
                }
            },
            'OUT_OF_STOCK': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllOutOfStock();
                }
            },
            'WITH_STOCK': {
                isActivated: false,
                selectFunc: function () {
                    return vm.selectAllWithStock();
                }
            },
            'NONE': {
                isActivated: false,
                selectFunc: function () {
                    return vm.unselectAll();
                }
            }
        };

        vm.onSelectedSortOption = function () {
            clearPaginationInfo();
            vm.listFilter.sortBy = vm.selectedSortByOption.value;
            vm.listFilter.sortDirection = vm.selectedSortByOption.direction;
            loadFlyers();
        }

        checkUserIsAdmin();
        //getFlyersTypes();

        vm.loadFlyers  = loadFlyers;

        vm.currencyConfiguration = getCurrencyListConfiguration();

        vm.randomTime = new Date().getTime();

        function clearPaginationInfo(){
            // Turn to 0 the page to give right page on pageable
            vm.page = 0;
            vm.currentPage = 1;
            vm.paginationOptions = {
                page: vm.currentPage - 1,
                size: vm.numPerPage
            };
        }

        vm.tabClick = function(brandName){

            vm.loadingTab = true;

            // Changes the type to the new type Clicked
            vm.listFilter.brand = brandName;
            // Erases the offer list
            vm.flyersFiltered = [];

            clearPaginationInfo();

            // loadOffers
            loadFlyers();

        }

        vm.tabCategoryClick = function(categoryKey){

            vm.loadingTab = true;

            // Changes the type to the new type Clicked
            vm.listFilter.categoryKey = categoryKey;
            // Erases the offer list
            vm.flyersFiltered = [];

            // Turn to 0 the page to give right page on pageable
            vm.page = 0;
			vm.currentPage = 1;
	        vm.paginationOptions = {
	            page: vm.currentPage - 1,
	            size: vm.numPerPage
	        };

            // loadOffers
            loadFlyers();

        }

//        function loadFilter() {
//            vm.getSizes();
//            vm.getColors();
//        }
//
//        vm.getSizes = function() {
//            console.log(FlyersService.getSizes());
//            FlyersService.getSizes().then(function(response) {
//                vm.sizes = response.data;
//            });
//        }
//
//        vm.getColors = function() {
//            FlyersService.getColors().then(function(response) {
//                vm.colors = response.data;
//            });
//        }

        function checkUserIsAdmin() {
            Principal.hasAuthority("ADMIN_MANAGE_SYSTEM").then(function(result) {
                if (result) {
                    vm.userIsAdmin = true;
                } else {
                    vm.userIsAdmin = false;
                }
            });
        }

        vm.stopPropagation = function(event) {
            event.stopPropagation();
        };

        vm.checkType = function(type) {
            vm.createArray("displayType", vm.displayTypeList.length, false);
            vm.displayTypeListCheck[vm.displayTypeList.indexOf(type)] = true;
            vm.displayType = type;
        }


        vm.isEven = function(number) {
            return (number % 2 == 0);
        };

        vm.refreshCouponToRemove = function(id) {
            if (vm.removeCouponsWithIds.indexOf(id) != '-1') {
                vm.removeCouponsWithIds.splice(vm.removeCouponsWithIds.indexOf(id), 1);
            } else {
                vm.removeCouponsWithIds.push(id);
            }
        };

        vm.existsItensToRemove = function() {
            return vm.removeCouponsWithIds.length >= 1;
        };

        vm.changeDisplayType = function() {
            vm.displayType = vm.displayType === 'Table' ? 'Cards' : 'Table';
        };

        vm.checkDisplayType = function(type) {
            return (vm.displayType === type);
        };

        vm.changeActivated = function() {
            vm.loadingTab = true;
            vm.page = 0;
            if (vm.listFilter.activated === null) {
                vm.listFilter.activated = true;
            } else {
                vm.listFilter.activated = !vm.listFilter.activated;
            }
            loadFlyers();
        };


        vm.openCalendarStart = function(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenCalendarStart = true;
        };

        vm.openCalendarExpire = function(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenCalendarExpire = true;
        };

        vm.flyerDetailPage = function(flyerId) {
            $state.go('flyers.edit', {
                id: flyerId
            });
        };

        vm.verifyIfFlyersIsPublished = function () {
            FlyersService.verifyIfFlyersIsPublished(vm.selectedFlyers).then(function (response) {
                ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.remove-modal.title'),
                    $translate.instant('flyers.selection-actions.modals.remove-modal.subtitle', { amount: vm.selectedFlyers.length }),
                    $translate.instant('flyers.selection-actions.modals.remove-modal.small-text'),
                    null,
                    $translate.instant('flyers.selection-actions.modals.remove-modal.confirm-button'),
                    $translate.instant('flyers.selection-actions.modals.cancel'),
                    vm.removeFlyers
                );
            }, function(response) {
                ModalFactory.openWarningModal($translate.instant('flyers.selection-actions.modals.remove-published-modal.title'),
                    $translate.instant('flyers.selection-actions.modals.remove-published-modal.subtitle',
                        { amount: response.data.data.amount, amountPublished: response.data.data.publishedAmount }),
                    $translate.instant('flyers.selection-actions.modals.remove-published-modal.small-text'),
                    null,
                    $translate.instant('flyers.selection-actions.modals.remove-published-modal.confirm-button'),
                    $translate.instant('flyers.selection-actions.modals.cancel'),
                    vm.removeFlyers
                );
            });
        }

        vm.removeFlyers = function() {
            if (vm.existsSelectedItems()) {
                vm.removalLoading = true;
                vm.loadingActionRequest = true;
                FlyersService.deleteFlyers(vm.selectedFlyers).then(function(data) {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.success($translate.instant('flyers.messages.remove.success'));
                    vm.selectedFlyers = [];
                    $state.reload();
                }, function(data) {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    if (data.data.message.includes('errorShowcase')){
                        toastr.error($translate.instant('flyers.messages.remove.errorShowcase'));
                    }else{
                        toastr.error($translate.instant('flyers.messages.remove.error'));
                    }
                });
            } else {
                toastr.error($translate.instant('flyers.messages.remove.noItens'));
            }
        };

        vm.getCategoryName = function(flyer) {
            var category = _.find(vm.categories, function(el) {return el.key === flyer.categoryKey});
            if (category) {
                flyer.category = category.title;
            }
        }


        vm.getFlyerCurrency = function(currency) {
            return FlyersCurrencyValue[currency];
        };

        vm.hasActiveFilter = function() {
            return vm.numberFilterSelected && vm.numberFilterSelected > 0;
        };

        vm.changeView = function () {
            vm.flyersFiltered = [];
            delete vm.listFilter.categoryKey;
            delete vm.listFilter.categoryKeys;

            delete vm.listFilter.brand;
            delete vm.listFilter.brands;

            StoreService.updateDefaultFilter(
                {
                    id: $localStorage.defaultStore.storeId,
                    defaultFilter: vm.viewByCategories ? 'CATEGORY' : 'BRAND'
                }
            )

            $localStorage.defaultStore.defaultFilter = vm.viewByCategories ? 'CATEGORY' : 'BRAND';

            if (vm.viewByCategories) {
                getCategories();
            } else {
                getBrands();
            }
        }

        function loadAll() {
            vm.time_stamp_to_image = '?' + Date.now();
            loadErpConfiguration();
            getDefaultFilter();
            getFlyersTypes();
            getCategories();

            ShowcasesService.getAllFlyerIdsFromShowcasesPublished().then(function (data) {
                vm.publishedProducts = data;
            });

            if ($stateParams.type) {
                vm.loadingTab = true;

                // Changes the type to the new type Clicked
                vm.listFilter.type = $stateParams.type;

                // Erases the offer list
                vm.flyersFiltered = [];

                // Turn to 0 the page to give right page on pageable
                vm.page = 0;
            }

			FlyersService.getAllFiltersFlyer().then(function (response) {
				vm.colors = response.data.colors;
				vm.sizes = response.data.sizes;
            });
        }

        function getCategories() {
            if (!vm.categories || !vm.categories.length) {
                FlyerCategoryService.listCategoriesByCurrentStore($translate.use(), $localStorage.defaultStore.storeId).then(function (response) {
                    vm.categories = response.data.filter(function (category) {
                        return category.countFlyer > 0;
                    });
                    vm.categories = _.uniqBy(vm.categories, 'key');
                    vm.categories.forEach(function (category) {
                        vm.categoryGroups[category.key] = {
                            count: 0,
                            total: category.countFlyer
                        };
                    });
                    sortCategoriesByName();
                });
            } else {
                selectTabCategory();
            }
        }

        function selectTabCategory() {
            if (vm.viewByCategories && vm.categories.length > 0) {
                if ($stateParams.category) {
                    vm.listFilter.categoryKey = $stateParams.category;
                    vm.tabCategoryClick($stateParams.category)
                }
                else {
                    vm.listFilter.categoryKey = vm.categories[0].key;
                    vm.tabCategoryClick(vm.categories[0].key);
                }
            }
        }

        function getBrands() {
            if (!vm.brands || !vm.brands.length) {
                BrandService.getBrandsByCurrentStore().then(function (response) {
                    vm.brands = response.data.filter(function (brand) {
                        return brand.quantFlyer > 0;
                    });
                    vm.brands = _.uniqBy(vm.brands, 'name');
                    vm.brands.forEach(function (brand) {
                        vm.brandGroups[brand.name] = {
                            count: 0,
                            total: brand.quantFlyer
                        };
                    });
                    selectTabBrand();
                });
            } else {
                selectTabBrand();
            }
        }

        function selectTabBrand() {
            if ((!vm.viewByCategories) && vm.brands.length > 0) {
                if ($stateParams.brand) {
                    vm.listFilter.brand = $stateParams.brand;
                    vm.tabClick($stateParams.brand);
                }
                else {
                    vm.listFilter.brand = vm.brands[0].name;
                    vm.tabClick(vm.brands[0].name);
                }
            }
        }

        function getFlyersTypes() {
            FlyersService.getFlyerTypes().then(function (response) {
                var removeRent = response.data.map(function(item) { return item.code; }).indexOf('RENT');
                response.data.splice(removeRent, 1);
                var removeContact = response.data.map(function(item) { return item.code; }).indexOf('CONTACT');
                response.data.splice(removeContact, 1);
                vm.flyersTypes = response.data;
            });
        }

        function loadErpConfiguration() {
            ErpsSettingsService.getERPConfigurationByStoreId($localStorage.defaultStore.storeId)
                .then(function (response) {
                    if (response.data && response.data.id) {
                        vm.configuration = response.data;
                    }
                });
        }

        function getDefaultFilter() {
            setTimeout(function() {
                vm.viewByCategories = $localStorage.defaultStore.defaultFilter === 'CATEGORY';

                //load default filter
                vm.flyersFiltered = [];
                delete vm.listFilter.categoryKey;
                delete vm.listFilter.categoryKeys;

                delete vm.listFilter.brand;
                delete vm.listFilter.brands;

                getCategories();
                getBrands();


            }, 1000);
        }

        function sortCategoriesByName() {
            vm.categories = vm.categories.sort(function(a, b) {
                if (a.title.toLowerCase() < b.title.toLowerCase()) {
                    return -1;
                }
                if (a.title.toLowerCase() > b.title.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
        }

        vm.refreshSelectedFlyers = function(flyer) {
            vm.brandGroups[flyer.brand] = vm.brandGroups[flyer.brand] ? vm.brandGroups[flyer.brand] : { count: 0 };
            vm.categoryGroups[flyer.categoryKey] = vm.categoryGroups[flyer.categoryKey] ? vm.categoryGroups[flyer.categoryKey] : { count: 0 };
            if (vm.selectedFlyers.indexOf(flyer.id) != '-1') {
                vm.brandGroups[flyer.brand].count = vm.brandGroups[flyer.brand].count - 1;
                vm.categoryGroups[flyer.categoryKey].count = vm.categoryGroups[flyer.categoryKey].count - 1;
                flyer.isSelected = false;
                vm.selectedFlyers.splice(vm.selectedFlyers.indexOf(flyer.id), 1);
            } else {
                vm.brandGroups[flyer.brand].count = vm.brandGroups[flyer.brand].count + 1;
                vm.categoryGroups[flyer.categoryKey].count = vm.categoryGroups[flyer.categoryKey].count + 1;
                flyer.isSelected = true;
                vm.selectedFlyers.push(flyer.id);
            }
            vm.selectedAll = true;
            angular.forEach(vm.flyersFiltered, function(flyer) {
                if (vm.selectedFlyers.indexOf(flyer.id) === -1) {
                    vm.selectedAll = false;
                    flyer.isSelected = false;
                }
            });
        };

        vm.existsSelectedItems = function() {
            return vm.selectedFlyers.length >= 1;
        };

        vm.isIndeterminate = function () {
            var filteredSelected = vm.flyersFiltered.filter(function(flyer) { return flyer.isSelected });
            return vm.selectedFlyers.length > 0
                && filteredSelected.length >= 1
                && filteredSelected.length !== vm.flyersFiltered.length;
        }

        vm.isAllFromPageSelected = function () {
            return vm.selectedFlyers.length > 0 && vm.flyersFiltered.every(function(flyer) { return flyer.isSelected });
        }

        vm.getCountSelectedByBrand = function(brand) {
            return vm.brandGroups[brand].count;
        };

        vm.getCountSelectedByCategory = function(category) {
            return vm.categoryGroups[category].count;
        };

        vm.refreshFlyersSelected = function() {
            vm.makeBrandGroups();
        }

        vm.selectAllItems = function() {
            vm.selectedAll = !vm.isAllFromPageSelected();
            angular.forEach(vm.flyersFiltered, function(flyer) {
                if (vm.selectedAll) {
                    if (vm.selectedFlyers.indexOf(flyer.id) === -1) {
                        if (!vm.brandGroups[flyer.brand]) {
                            vm.brandGroups[flyer.brand] = {count: 0}
                        }

                        if (!vm.categoryGroups[flyer.categoryKey]) {
                            vm.categoryGroups[flyer.categoryKey] = { count: 0 }
                        }
                        vm.brandGroups[flyer.brand].count = vm.brandGroups[flyer.brand].count + 1;
                        vm.categoryGroups[flyer.categoryKey].count = vm.categoryGroups[flyer.categoryKey].count + 1;
                        flyer.isSelected = true;
                        vm.selectedFlyers.push(flyer.id);
                    }
                } else {
                    if (vm.selectedFlyers.indexOf(flyer.id) !== -1) {
                        vm.brandGroups[flyer.brand].count = vm.brandGroups[flyer.brand].count - 1;
                        vm.categoryGroups[flyer.categoryKey].count = vm.categoryGroups[flyer.categoryKey].count - 1;
                        flyer.isSelected = false;
                        vm.selectedFlyers.splice(vm.selectedFlyers.indexOf(flyer.id), 1);
                    }
                }
            });
        };

        vm.reset = function reset() {
            vm.page = 0;
            vm.flyersFiltered = [];
        };

        vm.checkIfFlyerSelected = function(flyer) {
            return vm.selectedFlyers.indexOf(flyer.id) != '-1';
        }

        vm.selectItemsBy = function (selectBy, isFromSelection) {
            isFromSelection = isFromSelection ? isFromSelection : false;
            if (selectBy === 'ALL_FROM_PAGE' && vm.isAllFromPageSelected() && !vm.isIndeterminate() && !isFromSelection) {
                vm.unselectAllFromPage();
                vm.selectionTypesData[vm.selectionTypesData.currentSelection].isActivated = false;
                vm.selectionTypesData.currentSelection = 'NONE'
                return;
            }

            if (isFromSelection && selectBy !== 'ALL_FROM_TAB' && selectBy !== 'ALL_FROM_PAGE') vm.unselectAll();
            vm.selectionTypesData[vm.selectionTypesData.currentSelection].isActivated = false;

            vm.selectionTypesData[selectBy].selectFunc();

            vm.selectionTypesData.currentSelection = selectBy;
            vm.selectionTypesData[selectBy].isActivated = true;
        }

        vm.isErpIntegrated = function(flyer) {
            if (flyer.erpProductId) {
                return true;
            } else if (flyer.details && flyer.details.length) {
                for (var index in flyer.details){
                    var detail = flyer.details[index];
                    if (detail.erpProductId) {
                        return true;
                    }
                }
            } else {
                return false;
            }
        }

        vm.showAction = function(action) {
            if (action.value === 'SYNC_ERP') {
                return vm.configuration && vm.configuration.id && vm.configuration.id != Constants.ErpPartnerId.SETA;
            }
            return true;
        }

        function setSelectedProductsByBrand(brandSet) {
            vm.brands.forEach(function (brand) {
                if (brandSet[brand.name]) {
                    var flyersId = brandSet[brand.name].map(function (product) {
                        var flyerSelected = vm.flyersFiltered.find(function (flyer) {
                            return flyer.id === product.id;
                        });
                        if (flyerSelected) flyerSelected.isSelected = true;
                        return product.id;
                    })
                    vm.selectedFlyers = vm.selectedFlyers.concat(flyersId);
                    vm.brandGroups[brand.name].count = brandSet[brand.name].length;
                }
            });
            vm.selectedFlyers = _.uniq(vm.selectedFlyers);
        }

        function setSelectedProductsByCategory(categorySet) {
            vm.categories.forEach(function (category) {
                if (categorySet[category.key]) {
                    var flyersId = categorySet[category.key].map(function (product) {
                        var flyerSelected = vm.flyersFiltered.find(function (flyer) {
                            return flyer.id === product.id;
                        });
                        if (flyerSelected) flyerSelected.isSelected = true;
                        return product.id;
                    })
                    vm.selectedFlyers = vm.selectedFlyers.concat(flyersId);
                    vm.categoryGroups[category.key].count = categorySet[category.key].length;
                }
            });
            vm.selectedFlyers = _.uniq(vm.selectedFlyers);
        }

        vm.selectAllFromStore = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                brandSelected: !!vm.listFilter.brand
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.selectAllFromTab = function () {
            var payload = {
                storeId: $localStorage.defaultStore.storeId,
                brandSelected: !!vm.listFilter.brand
            };

            if (vm.listFilter.brand) {
                payload.brand = vm.listFilter.brand;
                payload.brands = [vm.listFilter.brand];
            } else {
                payload.categoryKey = vm.listFilter.categoryKey;
                payload.categoryKeys = [vm.listFilter.categoryKey];
            }

            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds(payload).then(function (response) {
                vm.loadingSelection = false;
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.selectAllPublished = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                brandSelected: !!vm.listFilter.brand,
                isPublished: true
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.selectAllUnpublished = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                brandSelected: !!vm.listFilter.brand,
                isPublished: false
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.selectAllWithStock = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                brandSelected: !!vm.listFilter.brand,
                hasInventory: true
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.selectAllOutOfStock = function () {
            vm.loadingSelection = true;
            FlyersService.listAllFlyersIds({
                storeId: $localStorage.defaultStore.storeId,
                hasNoInventory: true,
                brandSelected: !!vm.listFilter.brand
            }).then(function (response) {
                vm.unselectAll();
                if (vm.listFilter.brand) {
                    setSelectedProductsByBrand(response);
                } else {
                    setSelectedProductsByCategory(response)
                }
            });
        }

        vm.unselectAll = function () {
            vm.selectedFlyers = [];
            vm.brands.forEach(function (brand) {
                vm.brandGroups[brand.name].count = 0;
            });
            vm.categories.forEach(function (category) {
                vm.categoryGroups[category.key].count = 0;
            });
            vm.loadingSelection = false;
        }

        vm.unselectAllFromPage = function () {
            vm.flyersFiltered.forEach(function (flyer) {
                if (vm.selectedFlyers.indexOf(flyer.id) !== -1) {
                    vm.brandGroups[flyer.brand].count = vm.brandGroups[flyer.brand].count - 1;
                    vm.categoryGroups[flyer.categoryKey].count = vm.categoryGroups[flyer.categoryKey].count - 1;
                    flyer.isSelected = false;
                    vm.selectedFlyers.splice(vm.selectedFlyers.indexOf(flyer.id), 1);
                }
            });
            vm.loadingSelection = false;
        }

        vm.publishFlyers = function () {
            vm.loadingActionRequest = true;
            ShowcasesService.addPublishedFlyers(vm.selectedFlyers).then(function () {
                vm.selectedFlyers.forEach(function (flyerId) {
                    addFlyerPublished(flyerId);
                    vm.loadingActionRequest = false;
                });
                vm.unselectAll();
            }, function (response) {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant("flyers.messages.publishFlyers.error"));
            });
        }

        vm.unpublishFlyers = function () {
            vm.loadingActionRequest = true;
            ShowcasesService.deletePublishedFlyers(vm.selectedFlyers).then(function () {
                vm.selectedFlyers.forEach(function (flyerId) {
                    removeFlyerPublished(flyerId);
                });
                vm.loadingActionRequest = false;
                vm.unselectAll();
            }, function (response) {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant("flyers.messages.unpublishFlyers.error"));
            });
        }

        vm.clearStock = function () {
            vm.loadingActionRequest = true;
            FlyersService.clearFlyersStock(vm.selectedFlyers).then(function () {
                vm.selectedFlyers.forEach(function (flyerId) {
                    clearFlyerStock(flyerId);
                });
                vm.unselectAll();
                vm.loadingActionRequest = false;
            }, function (response) {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant("flyers.messages.clearStock.error"));
            });
        }

        vm.syncronizeProductsWithHub = function (params) {
            if (!vm.selectedFlyers) {
                return;
            }
            
            FlyersService.syncFlyersWithHub(vm.selectedFlyers, params).then(function () {
                vm.unselectAll();
                vm.loadingActionRequest = false;
                toastr.success($translate.instant("flyers.messages.syncFlyersWithHub.success"));
            }, function (response) {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant("flyers.messages.syncFlyersWithHub.error"));
            });
        }

        vm.syncronizeProducts = function () {
            if (!vm.selectedFlyers) {
                return;
            }

            if (vm.selectedFlyers.length > 100) {
                toastr.error($translate.instant("flyers.messages.syncErp.hundred-error"));
                return;
            }

            if (!vm.configuration || !vm.configuration.id || !vm.configuration.partnerId) {
                toastr.error($translate.instant("flyers.messages.syncErp.configuration-error"));
                return;
            }

            switch (vm.configuration.partnerId) {
                case Constants.ErpPartnerId.VAREJO_ONLINE:
                    synchronizeProductsWithVarejoOnline();
                    break;
                case Constants.ErpPartnerId.NEXAAS:
                    synchronizeProductsWithNexaas();
                    break;
                case Constants.ErpPartnerId.BLING:
                    synchronizeProductsWithBling();
                    break;
                default:
                    console.log("Sincronização de produtos indisponível com parceiro " + vm.configuration.partnerId);
            }
        }

        function synchronizeProductsWithVarejoOnline() {
            vm.removalLoading = true;
            vm.loadingActionRequest = true;
            OnlineRetailService.syncProductsByStoreAndFlyerIds($localStorage.defaultStore.storeId, vm.selectedFlyers)
                .then(function (response) {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.success($translate.instant('flyers.messages.syncErp.success'));
                    vm.unselectAll();
                    loadFlyers();
                }, function (error) {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.error($translate.instant("flyers.messages.syncErp.general-error"));
                });
        }

        function synchronizeProductsWithNexaas() {
            vm.removalLoading = true;
            vm.loadingActionRequest = true;
            NexaasService.syncProductsByStoreAndFlyerIds($localStorage.defaultStore.storeId, vm.selectedFlyers)
                .then(function (response) {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.success($translate.instant('flyers.messages.syncErp.success'));
                    vm.unselectAll();
                    loadFlyers();
                }, function (error) {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.error($translate.instant("flyers.messages.syncErp.general-error"));
                });
        }

        function synchronizeProductsWithBling() {
            vm.removalLoading = true;
            vm.loadingActionRequest = true;
            BlingService.syncProductsByStoreAndFlyerIds($localStorage.defaultStore.storeId, vm.selectedFlyers)
                .then(function (response) {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.success($translate.instant('flyers.messages.syncErp.success'));
                    vm.unselectAll();
                    loadFlyers();
                }, function (error) {
                    vm.removalLoading = false;
                    vm.loadingActionRequest = false;
                    toastr.error($translate.instant("flyers.messages.syncErp.general-error"));
                });
        }

        function applyDiscounts (discountApplied) {
            vm.loadingActionRequest = true;
            FlyersService.applyDiscountsForFlyers(vm.selectedFlyers, discountApplied).then(function () {
                loadFlyers();
                vm.unselectAll();
                vm.loadingActionRequest = false;
            }, function (response) {
                vm.loadingActionRequest = false;
                toastr.error($translate.instant("flyers.messages.applyDiscounts.error"));
            });
        }

        vm.getFlyerTooltip = function (status) {
            switch (status) {
                case 'ACTIVATED':
                    return 'flyers.offer.active';
                case 'DEACTIVATED':
                    return 'flyers.offer.disabled';
                case 'EXPIRED':
                    return 'flyers.offer.expired';
                case 'CLOSED':
                    return 'flyers.offer.closed';
            }
        }

        vm.changePage = function () {

            var begin = ((vm.currentPage - 1) * vm.numPerPage),
            end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            loadFlyers();
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;

        }

        function loadFlyers() {
            if(vm.busy) return;
            vm.busy = true;

            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("launch")) {
                vm.listFilter.launch = true;
            } else {
                delete vm.listFilter.launch;
            }

            if (vm.listFilter.configurations && (vm.listFilter.configurations).includes("basic")) {
                vm.listFilter.basic = true;
            } else {
                delete vm.listFilter.basic;
            }

            if (!vm.listFilter.colors || !(vm.listFilter.colors.length > 0)) {
                delete vm.listFilter.colors
            }

            if (!vm.listFilter.sizes || !(vm.listFilter.sizes.length > 0)) {
                delete vm.listFilter.sizes
            }

            if (!vm.listFilter.genders || !(vm.listFilter.genders.length > 0)) {
                delete vm.listFilter.genders
            }

            if (vm.numberFilterSelected === 0 && vm.listFilter.categoryKey && vm.listFilter.categoryKey !== '' && vm.listFilter.text === '') {
                vm.listFilter.categoryKeys = [vm.listFilter.categoryKey]
            } else if (vm.filters.categories.length > 0) {
                vm.listFilter.categoryKey = vm.listFilter.categoryKeys[0]
            } else {
                delete vm.listFilter.categoryKeys
            }

            if (vm.numberFilterSelected === 0 && vm.listFilter.brand && vm.listFilter.brand !== '' && vm.listFilter.text === '') {
                vm.listFilter.brands = [vm.listFilter.brand]
            } else if (!vm.filters.brands || !(vm.filters.brands.length > 0)) {
                delete vm.listFilter.brands
            }

            if (vm.selectedSortByOption.label === "Sem estoque")
                vm.listFilter.hasInventory = false;
            FlyersService.listAllToAdmin(vm.paginationOptions, vm.listFilter, onSuccess, onError);

            function onSuccess(data, headers) {

                //vm.tabInfo.existsCouponsFlyer = data.existsCouponsFlyer;
                //vm.tabInfo.existsRentFlyer = data.existsRentFlyer;
                //vm.tabInfo.existsContactFlyer = data.existsContactFlyer;
                //vm.tabInfo.existsSaleFlyer = data.existsSaleFlyer;

                vm.zeroOffers = data.content.length <= 0;

                if(vm.zeroOffers) {
                    vm.flyersFiltered = [];
                    vm.selectedAll = false;
                } else {
                    vm.flyersFiltered = data.content;
                    vm.selectedAll = true;
                    angular.forEach(vm.flyersFiltered, function(flyer) {
                        var isSelected = vm.selectedFlyers.indexOf(flyer.id);
                        flyer.isSelected = isSelected > -1;
                        if (isSelected === -1) {
                            vm.selectedAll = false;
                        }
                    })
                }

                vm.flyersFiltered = data.content;
                vm.flyersFiltered = vm.flyersFiltered.map(function(flyer) {
                    vm.getCategoryName(flyer);
                    flyer.currencyInstance = vm.currencyConfiguration[flyer.currency];
                    return flyer;
                });

                vm.totalFlyers = headers('X-Total-Count');

                vm.isLoading = false;
                vm.busy = false;
                vm.loadingTab = false;

            }

            function onError(_) {
                vm.busy = false;
                vm.loadingTab = false;
                vm.isLoading = false;
                toastr.error($translate.instant('flyers.messages.load.error'));
            }
        }

        loadAll();

        function checkForCurrentBrand(brands) {
            var result = false;
            brands.forEach(function (brand) {
                if (brand.name == vm.listFilter.brand)
                    result = true;
            });
            return result;
        }

        function loadBrands() {
            BrandService.getBrandsByCurrentStore().then(function(response) {
                vm.brands = response.data;
                if (!vm.viewByCategories && !checkForCurrentBrand(response.data))
                    vm.listFilter.brand = response.data[0].name;
                loadFlyers();
            });
        }

        vm.showModalBrand = function showModalBrand() {
            ModalBrandFactory.listModal().then(function (_) {
                BrandService.getBrandsByCurrentStore().then(function(_) {
                    loadBrands();
                });
            });
        }

        vm.checkFlyerIsSelected = function(flyer) {
            if (vm.publishedProducts) {
                if (vm.publishedProducts.includes(flyer.id))
                    return true;
                return false
            }
        };


        function removeFlyerPublished(flyerId) {
            vm.publishedProducts = vm.publishedProducts.filter(function(id) {
                    return flyerId !== id;
                });
        }

        function clearFlyerStock(flyerId) {
            var flyer = vm.flyersFiltered.find(function(filterdFlyer) {
                return flyerId === filterdFlyer.id;
            });
            if (flyer) {
                if (flyer.details && flyer.details.length) {
                    flyer.details.forEach(function (detail) {
                        detail.inventory = 0;
                    })
                } else {
                    flyer.inventory = 0;
                }
            }
        }

        function addFlyerPublished(flyerId) {
            vm.publishedProducts.push(flyerId)
        }

        vm.unpublishFlyer = function (flyerId) {
            ShowcasesService.deletePublishedFlyer(flyerId).then(function (data) {
                removeFlyerPublished(flyerId);
            }, function () {});
        }

        vm.publishFlyer = function (flyerId) {
            ShowcasesService.addPublishedFlyer(flyerId).then(function (data) {
                addFlyerPublished(flyerId);
            }, function (response) {
                if (response.status === 404 || response.status === 400) {
                    toastr.warning($translate.instant('flyers.messages.published.warning'));
                } else {
                    toastr.error($translate.instant("flyers.messages.published.error"));
                }
            });
        }

        //loadFilter();

        vm.filters = {
            categories: [],
            brands: [],
            colors: [],
            sizes: [],
            genders: [],
            configurations: [],
            hasInventory : false
        };

        vm.openFiltersModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/admin/flyers/modal-filter-flyer/flyer-filter-modal.html',
                controller: 'FiltersFlyersController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    options: function () {
                        return {
                            categories: vm.categories,
                            brands: vm.brands,
                            colors: vm.colors,
                            sizes: vm.sizes,
                            canChangeView: true,
                            viewByCategories: vm.viewByCategories,
                            clearFilters: vm.clearFilters
                        }
                    },
                    filters: function () {
                        return vm.filters
                    },
                    list: function () {
                        return vm.listFilter
                    }
                },
            }).result.then(function (response) {
                vm.unselectAll();
                if (response) {
                    vm.numberFilterSelected = response.totalFilters;
                    if (response.changeView) {
                        vm.viewByCategories = response.selectedFilters.viewByCategories;
                        vm.changeView();
                    }
                    vm.filters = response.selectedFilters;
                    if (response.totalFilters === 0 && !(response.changeView)) {
                        getDefaultFilter();
                    } else
                        vm.listFilter = response.listFilter;
                    loadFlyers();
                }
            });
        }
    }

})();

(function () {
  'use strict';

  angular.module('showcaseApp')
    .controller('CategoryFlyerListController', CategoryFlyerListController);

  /** @ngInject */
  function CategoryFlyerListController($scope, RemoveModalFactory, CategoryFlyerService, toastr, $translate, $state) {
    var vm = this;
    vm.showModalAddCategory = showModalAddCategory;
    vm.categorys = [];
    vm.search = '';
    vm.fullCategories = []
    vm.loadingList = false;

    getCategorys();

    function showModalAddCategory() {
      CategoryFlyerService.showAddEditModal().then(function (result) {
      });
    }

    vm.showModalEditcategory = function (category) {
      CategoryFlyerService.showAddEditModal(category).then(function (result) {
        vm.category = result.data;
      });
    }

    function getCategorys() {
      vm.loadingList = true;
      CategoryFlyerService.listCategoriesByCurrentStore($translate.use()).then(function (response) {
        vm.fullCategories = response.data;
        if (vm.fullCategories.length > 0) {
          vm.categorys = listToTree(vm.fullCategories);
        } else {
          vm.categorys = [];
          vm.loadingList = false;
        }
      });
    }

    function findIndex(value) {
      return value.id == this;
    }

    function listToTree(list) {
      var map = {}, node, roots = [], i;

      for (i = 0; i < list.length; i += 1) {
        map[list[i].id] = i; // initialize the map
        list[i].children = []; // initialize the children
      }

      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.categoryId && node.categoryId !== '0' && list.findIndex(findIndex, node.categoryId) !== -1) {
          list[map[node.categoryId]].children.push(node);
        } else {
          roots.push(node);
        }
      }
      vm.loadingList = false;
      return roots;
    }

    vm.querySearchCategory = function () {
      vm.loadingList = true;
      var results = vm.fullCategories.filter(createFilterFor(vm.search));
      if (results.length) {
        vm.categorys = listToTree(results);
      } else {
        vm.categorys = [];
        vm.loadingList = false;
      }
    }

    function createFilterFor(query) {
      var lowercaseQuery = query.toLowerCase();

      return function filterFn(category) {
        return (category.title.toLowerCase().indexOf(lowercaseQuery) === 0);
      };
    }

    vm.removeCategory = function (category) {
      RemoveModalFactory.deleteItem(1).then(function (data) {
        CategoryFlyerService.deleteCategory(category.id).then(function (data) {
          toastr.success($translate.instant('categorys.messages.remove.success'));
          $state.reload();
        }, function (error) {
          if (error && error.data && error.data.headers.statuskey === 'categoryCannotBeRemoved') {
            toastr.error($translate.instant('categorys.messages.remove.error-associated-category'));
          } else {
            toastr.error($translate.instant('categorys.messages.remove.error'));
          }
        });
      });
    }

    vm.toggle = function (scope) {
      scope.toggle();
    };

    $scope.collapseAll = function () {
      $scope.$broadcast('angular-ui-tree:collapse-all');
    };

    $scope.expandAll = function () {
      $scope.$broadcast('angular-ui-tree:expand-all');
    };


  }

}());
(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('category', {
                parent: 'admin',
                abstract: true,
                data: {
                    authorities: [],
                    pageTitle: 'category.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/flyers/category-flyer/category-flyer.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('categorys');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            }).state('categorys-list', {
                parent: 'category',
                url: '/categorys-list',
                data: {
                    pageTitle: 'categorys.title',
                    authorities: []
                },
                views: {
                    'category-list': {
                        templateUrl: 'app/admin/flyers/category-flyer/category-flyer-list.html',
                        controller: 'CategoryFlyerListController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .service('CategoryFlyerService', CategoryFlyerService);

    /** @ngInject */
    function CategoryFlyerService(CategoryFlyerFactory, $uibModal) {

        var service = {
            create: create,
            update: update,
            listCategoriesByCurrentStore: listCategoriesByCurrentStore,
            deleteCategory: deleteCategory,
            showAddEditModal: showAddEditModal
        };

        return service;


        function create(category) {
            return CategoryFlyerFactory.create(category).$promise;
        }

        function update(category) {
            return CategoryFlyerFactory.update(category).$promise;
        }

        function deleteCategory(id) {
            return CategoryFlyerFactory.deleteCategory({ id: id }).$promise;
        }

        function listCategoriesByCurrentStore(userLang) {
            return CategoryFlyerFactory.listAllByCurrentStore({ langKey: userLang }).$promise;
        }

        function showAddEditModal(category) {
            return $uibModal.open({
                templateUrl: "app/admin/flyers/category-flyer/category-flyer.modal.html",
                size: 'md',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                resolve: {
                    category: function () {
                        return angular.copy(category);
                    }
                },
                controller: "CategoryFlyerModalController",
                controllerAs: "vm"
            }).result;
        }
    }

})();

(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .controller('CategoryFlyerModalController', CategoryFlyerModalController);

    /** @ngInject */
    function CategoryFlyerModalController($uibModalInstance, category, CategoryFlyerService, $localStorage, toastr, $translate, $state) {
        var vm = this;
        vm.close = close;
        vm.save = save;
        vm.categorys = [];
        vm.category = category || { categoryId: '0' };
        vm.indexCategoryParent;

        init();

        function init() {
            getCategorys();
            vm.category.categoryId = vm.category.categoryId || '0';
        }

        function getCategorys() {
            CategoryFlyerService.listCategoriesByCurrentStore($translate.use()).then(function (response) {
                if (response && response.data) {
                    vm.categorys = response.data;
                    if (vm.category && vm.category.id) {
                        vm.categorys = response.data.filter(function(category) {
                            return category.id != vm.category.id;
                        });
                    }
                }
            });
        }

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function findIndex(value){
			return value.id == this;
		}

        function save() {
            if (vm.categoryForm.$valid) {
                vm.isSaving = true;
                var key = vm.category.title.toUpperCase().replace(/ /g, "_");

                if (vm.category.id) {
                    var categoryDTO = { id: vm.category.id, key: key, title: vm.category.title, categoryId: vm.category.categoryId, index: vm.category.index };
                    CategoryFlyerService.update(categoryDTO).then(function () {
                        toastr.success($translate.instant('categorys.messages.edit.success'));
                        $state.reload();

                    }, function (error) {
                        if (error && error.data && error.data.headers.statuskey === 'categoryCannotBeChild') {
                            var index = vm.categorys.findIndex(findIndex, vm.category.categoryId);
                            toastr.error($translate.instant('categorys.messages.edit.error-child', {value: vm.categorys[index].title}));
                        } else {
                            toastr.error($translate.instant('categorys.messages.edit.error'));
                        }
                        vm.isCreatingCategory = false;
                    });
                } else {
                    var categoryDTO = { key: key, languages: [{ langKey: $translate.use(), title: vm.category.title }], categoryId: vm.category.categoryId };
                    CategoryFlyerService.create(categoryDTO).then(function () {
                        toastr.success($translate.instant('categorys.messages.new.success'));
                        $state.reload();

                    }, function (error) {
                        if(error && error.data && error.data.headers.statuskey === 'categoryAlreadyExists') {
                            toastr.error($translate.instant('categorys.messages.new.duplicated'));
                        } else {
                            toastr.error($translate.instant('categorys.messages.new.error'));
                        }
                        vm.isCreatingCategory = false;
                    });
                }

            }
        }

    }

})();

(function () {
    'user strict'

    angular.module('showcaseApp')
        .factory('CategoryFlyerFactory', CategoryFlyerFactory);

    /** ngInject */
    function CategoryFlyerFactory($resource) {

        var resourceUrl = 'flyer/api/category';

        return $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                url: 'flyer/api/category/store',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'update': {
                method: 'PUT',
                url: 'flyer/api/category/store',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deleteCategory': {
                method: 'DELETE',
                url: 'flyer/api/category/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.headers = headers();
                    return response;
                }
            },
            'listAllByCurrentStore': {
                url: 'flyer/api/category/current-store',
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            }          
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ApplyDiscountModalController', ApplyDiscountModalController);

    function ApplyDiscountModalController($uibModalInstance, modalTitle, modalSubtitle, inputLabel, inputFooter,
                                          buttonConfirmText, buttonCancelText, buttonConfirmAction) {
        var vm = this;

        vm.modalTitle = modalTitle;
        vm.modalSubtitle = modalSubtitle;
        vm.inputLabel = inputLabel;
        vm.inputFooter = inputFooter;
        vm.buttonConfirmText = buttonConfirmText;
        vm.buttonCancelText = buttonCancelText;
        vm.buttonConfirmAction = action;

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.closeModal = function() {
            $uibModalInstance.dismiss(true);
        }

        function action(){
            var discountPercentage = vm.discountValue / 100;
            buttonConfirmAction(discountPercentage);
            vm.confirm();
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('store-file-manager', {
            parent: 'admin',
            url: '/store-file-manager',
            data: {
                pageTitle: 'file-manager.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/file-manager/store-file-manager.html',
                    controller: 'StoreFileManagerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('file-manager');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('StoreFileManagerController', StoreFileManagerController);

    function StoreFileManagerController(FileManagerService, $scope, $localStorage, $translate, toastr) {

        var vm = this;

        vm.hubId = $localStorage.defaultStore.hubId;
        vm.currentFolder = {id: -1};
        vm.children = [];
        vm.files = [];
        vm.tags = [];
        vm.breadcrumbs = [];
        vm.filterName = "";
        vm.filterTags = [];
        vm.loadingChildren = true;
        vm.loadingFiles = true;
        vm.loadingBreadcrumb = false;

        getFolderChildren(vm.currentFolder);
        getFolderFiles(vm.currentFolder);
        getFileTags();

        vm.enterInFolder = function (folder) {
            vm.filtring = false;
            vm.currentFolder = folder;
            clearFilter();
            getFolderChildren(vm.currentFolder);
            getFolderFiles(vm.currentFolder);
            if (vm.currentFolder.id === -1) {
                vm.breadcrumbs = [{id: -1, name: $translate.instant("file-manager.folder.home")}];
                vm.loadingBreadcrumb = false;
            } else {
                vm.loadingBreadcrumb = true;
                vm.breadcrumbs = mountBreadCrumb(folder, [{id: -1, name: $translate.instant("file-manager.folder.home")}]);
                setTimeout(function () {
                    vm.loadingBreadcrumb = false;
                    $scope.$apply();
                }, 650);
            }
        }

        vm.getFileType = function (type) {
            type = type.split('/')[0];
            switch (type){
                case 'image':
                    return 'IMAGE'
                case 'video':
                    return 'VIDEO';
                default:
                    return 'OTHER';
            }
        }

        vm.getFileName = function (originalName) {
            var extension = "." + originalName.substring(originalName.lastIndexOf(".") + 1);
            return originalName.substring(0, 14) + '(...)' + extension;
        }

        vm.filterByName = function () {
            filterFiles();
        }

        vm.filterByTag = function (tag) {
            var index = _.findIndex(vm.filterTags,function (t) { return t  === tag.id })
            if (index >= 0) {
                tag.selected = false;
                vm.filterTags.splice(index, 1);
            } else {
                tag.selected = true;
                vm.filterTags.push(tag.id)
            }
            filterFiles();
        }

        function getFolderChildren(folder) {
            vm.loadingChildren = true;
            FileManagerService.getFolderChildren(vm.hubId, folder.id)
                .then(function (result) {
                    vm.children = result.data;
                    vm.loadingChildren = false;
                }, function () {
                    toastr.error($translate.instant("file-manager.message.error-to-load-folder-children"));
                    vm.loadingChildren = false;
                });
        }

        function getFolderFiles(folder) {
            vm.loadingFiles = true;
            FileManagerService.getFolderFiles(vm.hubId, folder.id)
                .then(function (result) {
                    vm.files = result.data;
                    vm.loadingFiles = false;
                }, function () {
                    toastr.error($translate.instant("file-manager.message.error-to-load-folder-files"));
                    vm.loadingFiles = false;
                });
        }

        function getFileTags() {
            vm.loadingTags = true;
            FileManagerService.getFileTags(vm.hubId)
                .then(function (result) {
                    vm.tags = result.data;
                    vm.loadingTags = false;
                }, function () {
                    toastr.error($translate.instant("file-manager.message.error-to-load-tags"));
                    vm.loadingTags = false;
                });
        }

        function mountBreadCrumb(folder, breadcrumbs) {
            if (folder.id === -1) {
                return [];
            }

            if (folder.parent) {
                mountBreadCrumb(folder.parent, breadcrumbs)
            }

            breadcrumbs.push({id: folder.id, name: folder.name, parent: folder.parent})
            return breadcrumbs;
        }

        function filterFiles() {
            if (!vm.filterName && !vm.filterTags.length) {
                getFolderFiles(vm.currentFolder);
                vm.filtring = false;
                return;
            }

            vm.filtring = true;

            vm.loadingFiles = true;
            FileManagerService.filterFiles(vm.hubId, vm.filterName, vm.filterTags)
                .then(function (result) {
                    vm.files = result.data;
                }, function () {
                    toastr.error($translate.instant("file-manager.message.error-to-load-files"));
                }).finally(function () { vm.loadingFiles = false});
        }

        function clearFilter () {
            vm.filterName = "";
            vm.filterTags = [];
            angular.forEach(vm.tags, function (tag) {
                tag.selected = false;
            })
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ADMIN_MANAGE_SYSTEM'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('DiscountCouponListController', DiscountCouponListController);

    /** @ngInject */
    function DiscountCouponListController($rootScope, $scope, $localStorage, $translate, toastr,
        DiscountCouponService, StoreService, DiscountCouponModalFactory, RemoveModalFactory) {

        var vm = this;
        vm.filter = {};
        vm.discountCoupons = [];

        vm.originalOrder = [];

        vm.currentPage = 1;
        vm.numPerPage = 10;
        vm.maxSize = 5;
        vm.totalDiscoutCoupon = 0;

        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        vm.filtring = false;

        vm.orderedByBirthdayWeek = false;

        vm.showModalAddDiscountCoupon = showModalAddDiscountCoupon;
        vm.showModalEditDiscountCoupon = showModalEditDiscountCoupon;
        vm.selectCustomer = selectCustomer;
        vm.searchByFilter = searchByFilter;
        vm.filterChange = filterChange;

        init();

        function init() {
            loadStoreData();
            listDiscountCoupon(vm.paginationOptions, vm.filter, true);
        }

        function loadStoreData() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
                if (response){
                    loadCurrencyPrefix(response.data);
                }
            })
        }

        function loadCurrencyPrefix(store) {
            var key = store.currency ? store.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            vm.currencyPrefix = config.prefix;
            vm.currency = key;
        }

        vm.orderByBirthdayWeek = function () {
            vm.orderedByBirthdayWeek = !vm.orderedByBirthdayWeek;

            vm.filter.orderedByBirthdayWeek = vm.orderedByBirthdayWeek;
            vm.currentPage = 1;
            vm.paginationOptions.page = 0;
            listDiscountCoupon(vm.paginationOptions, vm.filter, true);

        }

        function parseDates(elements) {
            elements.forEach(function (element) {
                if (element.expirationDate) {
                    element.expirationDate = moment.utc(element.expirationDate);
                }
                if (element.startDate) {
                    element.startDate = moment.utc(element.startDate);
                }
            });
        }

        function listDiscountCoupon(pagination, filter, selectFirst) {
            vm.loadingCustomers = true;
            DiscountCouponService.search(pagination, filter).then(function (result) {
                parseDates(result.data);
                vm.totalDiscoutCoupon = result.headers['x-total-count'];
                vm.discountCoupons = result.data.slice();
                vm.originalOrder = result.data;
                if (selectFirst) {
                    $rootScope.$broadcast('selectedCustomer', angular.copy(vm.discountCoupons[0]));
                }
                vm.loadingCustomers = false;
            }, function (error) {
                vm.loadingCustomers = false;
            });
        }

        function showModalAddDiscountCoupon() {
            DiscountCouponModalFactory.addDiscountCoupon(undefined, vm.currency).then(function (result) {
                toastr.success($translate.instant('global.messages.success.created-coupon'));
                listDiscountCoupon(vm.paginationOptions, {}, true);
            });
        }

        function showModalEditDiscountCoupon(discountCoupon) {
            DiscountCouponModalFactory.editDiscountCoupon(discountCoupon, vm.currency).then(function (result) {
                toastr.success($translate.instant('global.messages.success.edited-coupon'));
                listDiscountCoupon(vm.paginationOptions, {}, true);
            });
        }

        vm.showModalRemoveDiscountCoupon = function (couponId) {
            RemoveModalFactory.deleteCoupon().then(function (data) {
                DiscountCouponService.deleteCoupon(couponId).then(function (data) {
                    toastr.success($translate.instant('global.messages.success.removed-coupon'));
                    listDiscountCoupon(vm.paginationOptions, {}, true);
                }, function (error) {
                    toastr.error($translate.instant('global.messages.error.remove-coupon'));
                });
            });
        }

        vm.copyDiscountCoupon = function (discountCoupon) {
            var textoCopiado = document.getElementById("code_" + discountCoupon.id);
            textoCopiado.select();
            textoCopiado.setSelectionRange(0, 99999);
            document.execCommand("copy");
        }

        function selectCustomer(customer) {
            $rootScope.$broadcast('selectedCustomer', angular.copy(customer));
        }

        vm.stopPropagation = function(event) {
            event.stopPropagation();
        };

        function searchByFilter() {
            if (vm.filter.text) {
                var filter = {
                    "name": vm.filter.text,
                    "code": vm.filter.text
                }
                vm.currentPage = 1;
                vm.paginationOptions.page = 0;
                listDiscountCoupon(vm.paginationOptions, filter, true);
            }
        }

        function filterChange() {
            if (vm.filter.text === null || vm.filter.text === '') {
                vm.filtring = false;
            } else {
                vm.filtring = true;
            }
            var filter = {
                "name": vm.filter.text,
                "code": vm.filter.text
            }
            vm.currentPage = 1;
            vm.paginationOptions.page = 0;
            listDiscountCoupon(vm.paginationOptions, filter, true);
        }

        vm.changePage = function () {

            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            vm.discountCoupons = listDiscountCoupon(vm.paginationOptions, vm.filter, true);
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;

        }

        $scope.$on('refreshListCustomer', function (env) {
            listDiscountCoupon(vm.paginationOptions, vm.filter, false);
        });

        $scope.$on('deletedCustomer', function (env) {
            listDiscountCoupon(vm.paginationOptions, vm.filter, true);
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('discount-coupons', {
            parent: 'admin',
            url: '/discount-coupon',
            data: {
                pageTitle: 'discount-coupon.title',
                authorities: [],
                // specialClass: "md-skin fixed-nav mini-navbar"
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/discount-coupon/discount-coupon-list.html',
                    controller: 'DiscountCouponListController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                type: null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('discount-coupon');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .service('DiscountCouponService', DiscountCouponService);

    /** @ngInject */
    function DiscountCouponService(DiscountCouponFactory) {

        var service = {
            create: create,
            update: update,
            list: list,
            search: search,
            deleteCoupon: deleteCoupon
        };

        return service;

        function create(discountCoupon) {
            return DiscountCouponFactory.create(discountCoupon).$promise;
        }

        function update(discountCoupon) {
            return DiscountCouponFactory.update({ id: discountCoupon.id }, discountCoupon).$promise;
        }

        function list(pageable, discountCouponFilter) {
            return DiscountCouponFactory.list(pageable, discountCouponFilter).$promise;
        }

        function search(pageable, discountCouponFilter) {
            return DiscountCouponFactory.search(pageable, discountCouponFilter).$promise;
        }

        function deleteCoupon(discountCouponId) {
            return DiscountCouponFactory.deleteCoupon({discountCouponId: discountCouponId}).$promise;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('DiscountCouponModalFactory', DiscountCouponModalFactory);

    /** @ngInject */
    function DiscountCouponModalFactory($uibModal) {

        var factory = {
            addDiscountCoupon: addDiscountCoupon,
            editDiscountCoupon: editDiscountCoupon,
            deleteDiscountCoupon: deleteDiscountCoupon
        }

        return factory;

        function addDiscountCoupon(discountCoupon, currency) {
            return showAddEditModal(discountCoupon, currency);
        }

        function editDiscountCoupon(discountCoupon, currency) {
            return showAddEditModal(discountCoupon, currency);
        }

        function deleteDiscountCoupon(discountCoupon) {
            return showDeleteModal(discountCoupon.fullName);
        }

        function showAddEditModal(discountCoupon, currency) {
            return $uibModal.open({
                templateUrl: "app/admin/discount-coupon/_modal_add_edit_discount_coupon.html",
                size: 'md',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                resolve: {
                    discountCoupon: function () {
                        return angular.copy(discountCoupon);
                    },
                    currency: function () {
                        return currency;
                    }
                },
                controller: "DiscountCouponModalConstroller",
                controllerAs: "vm"
            }).result;
        }

        function showDeleteModal(fullName) {
            return $uibModal.open({
                templateUrl: "app/admin/discount-coupon/_modal_delete_discount-coupon.html",
                size: 'md',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                resolve: {
                    fullName: function () {
                        return fullName;
                    }
                },
                controller: function ($uibModalInstance, fullName) {
                    var vm = this;
                    vm.fullName = fullName;
                    vm.cancel = cancel;
                    vm.ok = ok;

                    function cancel() {
                        $uibModalInstance.dismiss('cancel');
                    }

                    function ok() {
                        $uibModalInstance.close(true);
                    }
                },
                controllerAs: "vm"
            }).result;
        }
    }
})();

(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .controller('DiscountCouponModalConstroller', DiscountCouponModalConstroller);

    /** @ngInject */
    function DiscountCouponModalConstroller(discountCoupon, currency, $uibModalInstance, $scope, toastr, $translate, moment, FlyerCategoryService, DiscountCouponService, $timeout) {
        var format = 'L';

        var vm = this;

        vm.maskLocale = '99/99/9999';
        vm.currency = currency;
        vm.discountCoupon = discountCoupon || {};
        vm.cancel = cancel;
        vm.init = init;
        vm.save = save;
        vm.usedCoupons = 0;
        const DATE_FORMAT = 'L';
        vm.discountTypes = [
            { name: $translate.instant('global.form.discount-type.percentage'), key: "PERCENTAGE" },
            { name: $translate.instant('global.form.discount-type.fixed-value'), key: "DISCOUNT_VALUE" },
            { name: $translate.instant('global.form.discount-type.free-shipping'), key: "FREE_SHIPPING" }
        ]

        if (vm.discountCoupon.isEnabled == null) {
            vm.discountCoupon.isEnabled = true;
        }

        if (vm.discountCoupon.hasUsageLimit) {
            vm.hasUsageLimit = true;
        } else {
            vm.hasUsageLimit = false;
        }

        vm.currencyConfigurations = getCurrencyListConfiguration();
        vm.configutaionsPrice = vm.currencyConfigurations[vm.currency];
        
        function init() {

            FlyerCategoryService.listCategoriesWithFlyers($translate.use()).then(function (response) {
                vm.categories = response.data;
            });

            if (vm.discountCoupon.startDate || vm.discountCoupon.expirationDate) {
                if (vm.discountCoupon.startDate) {
                    vm.discountCoupon.startDate = moment(vm.discountCoupon.startDate).format(DATE_FORMAT)
                }
                if (vm.discountCoupon.expirationDate) {
                    vm.discountCoupon.expirationDate = moment(vm.discountCoupon.expirationDate).format(DATE_FORMAT);
                }
                $timeout(function () {
                    dateTimePicker();
                }, 300)
            } else {
                dateTimePicker();
            }

            if(!vm.discountCoupon.discountType) {
                vm.discountCoupon.discountType = "PERCENTAGE";
            }

            if (!vm.discountCoupon.categoryKeys) {
                vm.discountCoupon.categoryKeys = [];
            }

            vm.usedCoupons = vm.discountCoupon.maxUsages - vm.discountCoupon.couponsAvailable;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        vm.closeDropDown = function () {
            $("md-backdrop").trigger('click');
        }

        function save() {
            if (vm.formAddEditDiscountCoupon.$valid) {
                vm.isSaving = true;

                if (vm.discountCoupon.maxUsages < vm.usedCoupons) {
                    vm.isSaving = false;
                    toastr.error($translate.instant('global.messages.error.quantity-used-discount-coupon'));
                    return "";
                }

                vm.discountCoupon.hasUsageLimit = vm.discountCoupon.hasUsageLimit ? vm.discountCoupon.hasUsageLimit : false;
                var discountCouponToSave = angular.copy(vm.discountCoupon);
                discountCouponToSave.expirationDate = discountCouponToSave.expirationDate ? moment.utc(discountCouponToSave.expirationDate, format).toDate() : undefined;
                discountCouponToSave.startDate = discountCouponToSave.startDate ? moment.utc(discountCouponToSave.startDate, format).toDate() : undefined;
                if (vm.discountCoupon.id) {
                    DiscountCouponService.update(discountCouponToSave).then(onSuccess, onError);
                } else {
                    DiscountCouponService.create(discountCouponToSave).then(onSuccess, onError);
                }

                function onSuccess(result) {
                    vm.isSaving = false;
                    $uibModalInstance.close(result);
                }

                function onError(error) {
                    vm.isSaving = false;
                    if (error.data.headers["x-adminapp-params"]) {
                        toastr.error($translate.instant(error.data.headers["x-adminapp-params"].concat(".").concat(error.data.headers["x-adminapp-error"])));
                    } else {
                        toastr.error($translate.instant("global.messages.somethingWrong"));
                    }
                }
            }
        }

        vm.checkDiscountValue = function() {
            vm.formAddEditDiscountCoupon.discount.$setValidity('min', !(vm.discountCoupon && vm.discountCoupon.discount == 0));
        }

        vm.getSelectedTextCategory = function (filter) {
            for (var i = 0; i < vm.categories.length; i++) {
                if (vm.categories[i].key === filter[0]) {
                    if (filter.length == 1) {
                        return '<span class="highlight">' + vm.categories[i].title + '</span>';
                    }
                    if (filter.length > 1) {
                        var temp = '  +';
                        temp += filter.length - 1;
                        temp += ' selecionados';

                        return '<span class="highlight">' + vm.categories[i].title + '</span>' +
                            '<span>&nbsp</span>' +
                            '<span class="highlight">' + temp + '</span>';
                    }
                    return '';
                }
            }
            return '';
        }

        vm.changeDiscountType = function () {
            vm.discountCoupon.discount = null;
        }

        vm.changehasUsageLimit = function () {
            if (!vm.hasUsageLimit) {
                vm.discountCoupon.maxUsages = null;
                vm.discountCoupon.categoryKeys = null;
                vm.discountCoupon.startDate = null;
                vm.discountCoupon.expirationDate = null;
                vm.discountCoupon.usageLimitPerClient = null;
            }
            vm.discountCoupon.hasUsageLimit = vm.hasUsageLimit;
            $timeout(function () {
            }, 500);
        }

        function dateTimePicker() {

            vm.startDateOptions = {
                format: DATE_FORMAT,
                sideBySide: true,
                ignoreReadonly: true,
                locale: moment.locale(),
                allowInputToggle: true
            };

            vm.expireDateOptions = {
                format: DATE_FORMAT,
                sideBySide: true,
                ignoreReadonly: true,
                locale: moment.locale(),
                allowInputToggle: true,
                useCurrent: false
            };

            angular.element('#startDate').datetimepicker(vm.startDateOptions).on('dp.change', function (ev) {
                if (ev.date) {
                    $scope.$apply(function () {
                        vm.discountCoupon.startDate = ev.date.format(format);
                    });
                } else {
                    $scope.$apply(function () {
                        vm.discountCoupon.startDate = undefined;
                    });
                }
            });

            angular.element('#expirationDate').datetimepicker(vm.expireDateOptions).on('dp.change', function (ev) {
                if (ev.date) {
                    vm.discountCoupon.expirationDate = ev.date.format(DATE_FORMAT);
                } else {
                    vm.discountCoupon.expirationDate = undefined;
                }
            });

            if(vm.discountCoupon.startDate) {
                vm.discountCoupon.startDate = discountCoupon.startDate ? discountCoupon.startDate : null;
            }
            if(vm.discountCoupon.startDate) {
                vm.discountCoupon.expirationDate = discountCoupon.expirationDate ? discountCoupon.expirationDate : null;
            }
        }

        vm.validateValueCoupom = function() {
            return false;
        }

        vm.makecoupon = function () {
            var length = 10;
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters[Math.floor(Math.random() * charactersLength)];
            }
            vm.discountCoupon.code = result;
        }
    }


})();

(function () {
    'user strict'

    angular.module('showcaseApp')
        .factory('DiscountCouponFactory', DiscountCouponFactory);

    /** ngInject */
    function DiscountCouponFactory($resource) {

        var resourceUrl = 'admin/api/discount-coupon';

        return $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'update': {
                method: 'PUT',
                url: resourceUrl + '/:id',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'list': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'search': {
                method: 'POST',
                url: resourceUrl + 's',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deleteCoupon': {
                method: 'DELETE',
                url: resourceUrl + '/:discountCouponId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    function stateConfig($stateProvider) {
        $stateProvider
        .state('poster-create-new', {
            parent: 'admin',
            url: '/digital-poster/new',
            data: {
                authorities: ['POSTER_CREATE'],
                pageTitle: 'digitalPoster.title',
                // specialClass: "md-skin fixed-nav"
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/digital-poster/digital-poster.html',
                    controller: 'DigitalPosterController',
                    controllerAs: 'vm'
                }
            },
            params: {

            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('digital-poster');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict'


    angular
        .module('showcaseApp')
        .service('DigitalPosterService', DigitalPosterService);

    //** NgInject */
    function DigitalPosterService(DigitalPosterFactory) {

        var service = {
            generatePoster: generatePoster
        };
        
        function generatePoster(posterDTO) {
            return DigitalPosterFactory.generatePoster(posterDTO).$promise;
        }

        return service;

       
    }


})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('DigitalPosterFactory', DigitalPosterFactory);

    function DigitalPosterFactory($resource) {

        var resourceUrl = '';

        return $resource(resourceUrl, {}, {
            'generatePoster': {
                method: 'POST',
                url: '/flyer/api/poster/generate-poster',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('DigitalPosterController', DigitalPosterController);

    function DigitalPosterController($translate, toastr, DigitalPosterService, ModalFactory, $rootScope, SelectOfferModalService, $timeout) {

        var vm = this;
        vm.poster = {};
        vm.isGeneratingPoster = false;
        vm.integerSize = 1;
        vm.preview = {};
        vm.control = {};

        vm.productNameSize = 20;
        vm.descriptionSize = vm.productCodeSize = 40;

        vm.getIntegerCount = function() {
            return vm.preview.integerDiscounted ? vm.preview.integerDiscounted.length : '';
        }


        vm.formatMoney = function (value, currencySymbol) {
            vm.processAllData();
            return formatMoney(value, currencySymbol, vm.poster.currencyInstance.decimalQuant, vm.poster.currencyInstance.centsSeparator, vm.poster.currencyInstance.thousandsSeparator);
        };

        function formatMoneyInternally(value, currencySymbol) {
            return formatMoney(value, currencySymbol, vm.poster.currencyInstance.decimalQuant, vm.poster.currencyInstance.centsSeparator, vm.poster.currencyInstance.thousandsSeparator);
        };

        vm.isToDisplayMe = function (value) {
            return value == vm.poster.discountType;
        }

        vm.selectTemplate = function(template) {
            vm.poster.selectedTemplate = template;
        }

        vm.pagesTypes = [{
            title: "A4 - 210 X 297mm",
            key: "A4",
            description: "A4 (210mm X 297mm)"
        }];

        vm.templatesKeys = ['DE_POR_1x1', 'DE_POR_2x1', 'DE_POR_4x1'];

        vm.currencyConfigurations = getCurrencyListConfiguration();

        vm.templatesTypes = {
            DE_POR_1x1: {
                iconImg: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/1-page-template.png',
                htmlTemplate: 'app/admin/digital-poster/components/posters/poster-1x1.html',
                key: 'DE_POR_1x1'
            },
            DE_POR_2x1: {
                iconImg: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/2-page-template.png',
                htmlTemplate: 'app/admin/digital-poster/components/posters/poster-1x2.html',
                key: 'DE_POR_2x1'
            },
            DE_POR_4x1: {
                iconImg: 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/3-page-template.png',
                htmlTemplate: 'app/admin/digital-poster/components/posters/poster-1x4.html',
                key: 'DE_POR_4x1'
            }
        };

        vm.campaignTypes = [{
            title: $translate.instant('digitalPoster.creater.campaignTypes.offer'),
            key: "OFFER"
        }];

        function loadAll() {
            vm.poster.pageSize = "A4";
            vm.poster.campaign = "OFFER";
            vm.poster.currencyInstance = vm.currencyConfigurations.REAL;
            vm.poster.discountType = "DISCOUNT_FIXED";
            vm.poster.selectedTemplate = vm.templatesTypes['DE_POR_1x1'];
        }

        function canGeneratePoster(){
            if (vm.posterDTO){
                if (vm.poster.campaign == 'OFFER'){
                    if (!vm.posterDTO.purchaseValue) {
                        toastr.warning($translate.instant('digitalPoster.messages.error.emptyPurchaseValue'));
                        return false;
                    } else if (!vm.posterDTO.discountedValue && !vm.posterDTO.centsInfo) {
                        toastr.warning($translate.instant('digitalPoster.messages.error.emptyDiscountValue'));
                        return false;
                    } else if (vm.poster.discountValue > vm.poster.purchaseValue) {
                        toastr.warning($translate.instant('digitalPoster.messages.error.discountBiggerThan'));
                        return false;
                    } else if (Number(vm.posterDTO.discountedValue) < 1) {
                        toastr.warning($translate.instant('digitalPoster.messages.error.negativePrice'));
                        return false;
                    } else if (!vm.posterDTO.discount) {
                        toastr.warning($translate.instant('digitalPoster.messages.error.emptyDiscountValue'));
                        return false;
                    } else if (vm.poster.discount <= 0){
                        toastr.warning($translate.instant('digitalPoster.messages.error.discountValueCannotLessThanOrZero'));
                        return false;
                    } else if (!vm.posterDTO.productName) {
                        toastr.warning($translate.instant('digitalPoster.messages.error.productNameEmpty'));
                        return false;
                    } else if (vm.posterDTO.productName.length > vm.productNameSize) {
                        toastr.warning($translate.instant('digitalPoster.messages.error.nameSize'));
                        return false;
                    } else if (vm.posterDTO.code && vm.posterDTO.code.length > vm.productCodeSize) {
                        toastr.warning($translate.instant('digitalPoster.messages.error.codeSize'));
                        return false;
                    } else if (vm.posterDTO.description && vm.posterDTO.description.length > vm.descriptionSize) {
                        toastr.warning($translate.instant('digitalPoster.messages.error.descriptionSize'));
                        return false;
                    }
                }
            } else {
                toastr.warning($translate.instant('digitalPoster.messages.error.emptyPoster'));
                return false;
            }

            return true;

        }

        function prepareDTO() {

            vm.posterDTO = {}
            vm.posterDTO.productName = vm.poster.productName ? vm.poster.productName.toUpperCase() : vm.poster.productName ;
            vm.posterDTO.description = vm.poster.description ? vm.poster.description.toUpperCase() : vm.poster.description ;
            vm.posterDTO.code = vm.poster.code ? vm.poster.code.toUpperCase() : vm.poster.code ;
            vm.posterDTO.centsInfo = vm.poster.centsInfo ? vm.poster.centsInfo.toUpperCase() : vm.poster.centsInfo ;

            vm.posterDTO.currency = vm.poster.currencyInstance.prefix.trim();
            vm.posterDTO.purchaseValue = formatMoneyInternally(vm.poster.purchaseValue) == "0,00" ? undefined : formatMoneyInternally(vm.poster.purchaseValue);
            vm.posterDTO.discountedValue = vm.preview.integerDiscounted;
            vm.posterDTO.discount = vm.poster.discount ? formatMoneyInternally(vm.poster.discount) : undefined;
            vm.posterDTO.posterType = vm.poster.selectedTemplate.key;

        }

        function succesPrint(res) {

            var saveByteArray = (function () {
                return function (data, name, mimeType) {
                    var blob = new Blob(data, {
                        type: mimeType
                    });
                    var url = window.URL.createObjectURL(blob);
                    var element = angular.element('<a/>');
                    var dynamicName = "";
                    if ($translate.instant('digitalPoster.home.buttons.generatePoster')
                        !== 'digitalPoster.home.buttons.generatePoster' ) {
                        dynamicName = $translate.instant('digitalPoster.home.buttons.generatePoster').split(" ")[1];
                    }
                    element.attr({
                        href: url,
                        target: '_blank',
                        download: dynamicName.toUpperCase() + '-' + vm.posterDTO.productName + '.pdf'
                    });
                    if (document.createEvent) {
                        var ev = document.createEvent("MouseEvent");
                        ev.initMouseEvent("click", true /* bubble */ , true /* cancelable */ , window, null, 0, 0, 0, 0, /* coordinates */
                            false, false, false, false,
                            /*
                             * modifier keys
                             */
                            0 /* left */ , null);
                        element[0].dispatchEvent(ev);
                    } else {
                        element[0].fireEvent("onclick");
                    }
                    setTimeout(function () {
                        document.body.removeChild;
                        window.URL.revokeObjectURL(url);
                    }, 200);
                };
            }());
            if (res.headers["content-disposition"]) {
                var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                var mimeType = res.headers["content-type"];
                filename = filename.replace(/['"]/g, '');
                saveByteArray([res.data], filename, mimeType);
            } else {
                toastr.error($translate.instant('digitalPoster.messages.error.generalError'));
            }

            vm.isGeneratingPoster = false;
            $rootScope.$emit('finish-generate-poster');
        }

        function errorPrint(response) {
            vm.isGeneratingPoster = false;
            toastr.error($translate.instant('digitalPoster.messages.error.generalError'));
            $rootScope.$emit('finish-generate-poster');
        }

        function buildMessageGeneratedPoster() {
            ModalFactory.openModal(null,
                'digitalPoster.messages.readyPoster',
                null, null, 'OK', null, 'close', null, null, null,
                'digitalPoster.messages.ifNotDownloaded', 'digitalPoster.messages.clickHere',
                function (callback) {
                    DigitalPosterService.generatePoster(vm.posterDTO).then(function (res) {
                        var saveByteArray = (function () {
                            return function (data, name, mimeType) {
                                var blob = new Blob(data, {
                                    type: mimeType
                                });
                                var url = window.URL.createObjectURL(blob);
                                var element = angular.element('<a/>');
                                element.attr({
                                    href: url,
                                    target: '_blank',
                                    download: name
                                });
                                if (document.createEvent) {
                                    var ev = document.createEvent("MouseEvent");
                                    ev.initMouseEvent("click", true /* bubble */ , true /* cancelable */ , window, null, 0, 0, 0, 0, /* coordinates */
                                        false, false, false, false,
                                        /*
                                         * modifier keys
                                         */
                                        0 /* left */ , null);
                                    element[0].dispatchEvent(ev);
                                } else {
                                    element[0].fireEvent("onclick");
                                }
                                setTimeout(function () {
                                    document.body.removeChild;
                                    window.URL.revokeObjectURL(url);
                                }, 200);
                            };
                        }());
                        if (res.headers["content-disposition"]) {
                            var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                            var mimeType = res.headers["content-type"];
                            filename = filename.replace(/['"]/g, '');
                            saveByteArray([res.data], filename, mimeType);
                        } else {
                            toastr.error($translate.instant('digitalPoster.messages.error.generalError'));
                        }
                        vm.isGeneratingPoster = false;
                        callback();
                    }, function (response) {
                        vm.isGeneratingPoster = false;
                        callback();
                    });
                }, 'width: 143px; height: 170px;', 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/download-cartaz.png');
        }

        vm.generatePoster = function () {
            prepareDTO();
            if (canGeneratePoster()){
                vm.isGeneratingPoster = true;
                buildMessageGeneratedPoster();
                $rootScope.$emit('waiting-generates-tabloid');
                vm.posterDTO.unity = vm.getUnitType();
                DigitalPosterService.generatePoster(vm.posterDTO).then(succesPrint, errorPrint);
            }
        }

        vm.checkMaxAndMinDiscountValue = function () {
            checkNegativeValues();

            if (vm.poster.discountValue && (!vm.poster.discountType)) {
                vm.poster.discountType = 'DISCOUNT_FIXED';
            }
            if (vm.poster.discountType === 'DISCOUNT_FIXED' && vm.posterEditForm.discountValue) {
                vm.posterEditForm.discountValue.$setValidity('max', true);
                if (vm.poster.discountValue > vm.poster.purchaseValue) {
                    vm.posterEditForm.discountValue.$setValidity('discountGreaterThanValue', false);
                } else {
                    vm.posterEditForm.discountValue.$setValidity('discountGreaterThanValue', true);
                    vm.processAllData();
                }
            } else {
                vm.poster.discountValue = undefined;
            }
        }

        function checkNegativeValues() {
            if (vm.poster.purchaseValue < 0) {
                vm.poster.purchaseValue = 0;
            }
            if (vm.poster.discountValue < 0) {
                vm.poster.discountValue = 0;
            }
        }

        function transformValueStringInDouble(value) {
            return Number(value.replace(/[^0-9.-]+/g, ""));
        }

        vm.selectFlyer = function (){
            SelectOfferModalService.selectOffers(true, 'digitalPoster.messages.singleSelectionTitle').result.then(function (flyer) {
                vm.poster.productName = flyer.name;
                vm.poster.description = flyer.description;
                vm.poster.currencyInstance = vm.currencyConfigurations[flyer.currency];
                vm.poster.discountType = flyer.discountType || 'DISCOUNT_FIXED';
                vm.poster.purchaseValue = flyer.purchaseValue;
                vm.poster.discountValue = vm.poster.discountType == 'DISCOUNT_FIXED' ? flyer.discountValue : undefined;
                vm.poster.discountedValue = flyer.discountedValue;
                vm.poster.discountValuePercentage = vm.poster.discountType == 'DISCOUNT_PERCENTAGE' ? flyer.discountValue : undefined;
                vm.processAllData();
            });
        }

        vm.getIntegerDiscountFromPrice = function () {
            if (!vm.poster.discountedValue) return '';
            var discountedValue = formatMoneyInternally(vm.poster.discountedValue);
            return discountedValue.substr(0, discountedValue.indexOf(vm.poster.currencyInstance.centsSeparator));
        }

        vm.getCentsDiscountFromPrice = function () {
            if (!vm.poster.discountedValue) return '';
            var discountedValue = formatMoneyInternally(vm.poster.discountedValue);
            vm.poster.centsInfo = discountedValue.substr(discountedValue.indexOf(vm.poster.currencyInstance.centsSeparator));
            return vm.poster.centsInfo;
        }

        vm.getModeOldPrefix = function () {
            // MOCKED BECAUSE HAS ONLY ONE TYPE OF OFFER
            return 'DE: ';
        }

        vm.getUnitType = function () {
            switch (vm.poster.unitType) {
                case 'UNITY_UNITY':
                    return $translate.instant('digitalPoster.creater.fields.unity.units.unity');
                case 'UNITY_LIB':
                    return $translate.instant('digitalPoster.creater.fields.unity.units.lib');
                case 'UNITY_METER':
                    return $translate.instant('digitalPoster.creater.fields.unity.units.meter');
                case 'UNITY_PACKAGE':
                    return $translate.instant('digitalPoster.creater.fields.unity.units.package');
                default:
                    break;
            }
        }

        vm.getModeNewPrefix = function () {
            // MOCKED BECAUSE HAS ONLY ONE TYPE OF OFFER
            return 'POR: ';
        }

        vm.selectTemplate = function (selectedTemplate) {
            vm.poster.selectedTemplate = selectedTemplate;
        }


        loadAll();

        vm.getHtmlTemplate = function () {
            var templateType = findElementByAttr(vm.templatesTypes, 'templateKey', vm.poster.selectedTemplate);
            return templateType ? templateType.htmlTemplate : '';
        }

        vm.getPageConfiguration = function () {
            var pageType = findElementByAttr(vm.pagesTypes, 'key', vm.poster.pageSize);
            return pageType ? pageType.description : '';
        }

        function getDiscountedValueByDiscountType(value, discountType, discountValue) {
            if (discountType == 'DISCOUNT_PERCENTAGE') {
                return value - (value * ((discountValue || 100) * 0.01));

            } else if (discountType == 'DISCOUNT_FIXED') {
                return value - (discountValue || 0);
            }
        }

        function getDiscountValueByDiscountType(value, discountType, discountValue) {
            if (discountType == 'DISCOUNT_PERCENTAGE') {
                return value * ((discountValue || 100) * 0.01);

            } else if (discountType == 'DISCOUNT_FIXED') {
                return discountValue;
            }
        }

        vm.processAllData = function () {
            if( (vm.posterEditForm.discountValuePercentage && vm.posterEditForm.discountValuePercentage.$valid)
                    || (vm.posterEditForm.discountValue && vm.posterEditForm.discountValue.$valid)) {
                if(vm.poster.purchaseValue > 9999.99){
                    vm.poster.purchaseValue = 9999.99;
                }
                if (vm.poster.discountValue > 9999.99){
                    vm.poster.discountValue = 9999.99;
                }
                var discountType = vm.poster.discountType;
                var currencyType = vm.poster.currencyInstance.key;
                var purchaseValue = vm.poster.purchaseValue;
                var discountValue = discountType == 'DISCOUNT_PERCENTAGE' ? vm.poster.discountValuePercentage : vm.poster.discountValue;
                var discountedValue = undefined;
                var integerDiscounted = undefined;
                var centsDiscounted = undefined;
                if (!discountType || !currencyType) return;

                discountedValue = getDiscountedValueByDiscountType((purchaseValue || 0.00), discountType, discountValue);
                discountValue = getDiscountValueByDiscountType((purchaseValue || 0.00), discountType, discountValue);

                // Setting up to posterDTO
                vm.poster.discount = discountValue;
                vm.poster.discountedValue = discountedValue;

                // Setting up to preview variables
                vm.preview.discountedValue = discountedValue;
                vm.preview.discountValue = discountValue;

                vm.preview.integerDiscounted = vm.getIntegerDiscountFromPrice();
                vm.preview.centsDiscounted = vm.getCentsDiscountFromPrice();
            }


        }

    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('CustomersImportController', CustomersImportController);

    /** @ngInject */
    function CustomersImportController($scope, $state, Upload, toastr, $translate, CustomerService, $window) {
        var format = "L";
        var vm = this;

        vm.filteredCustomers = []
        vm.currentPage = 1;
        vm.numPerPage = 10;
        vm.maxSize = 5;

        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.uploaded = false;
        vm.allStatusOk = false;
        vm.customersImported = [];
        vm.isUploading = false;
        vm.isSaving = false;

        vm.file = null;

        vm.getDownloadLinkToTemplate = function () {
            return $window.location.protocol + "//" + $window.location.host + '/content/docs/template-import-clients.xlsx';
        }

        vm.save = function () {
            vm.isSaving = true;
            if (vm.customersImported.length > 0 && vm.allStatusOk) {
                CustomerService.saveImportedCustomers(vm.customersImported).then(function (response) {
                    toastr.success($translate.instant('customer.import.successfullyImport'));
                    vm.uploaded = false;
                    vm.allStatusOk = false;
                    vm.isSaving = false;
                    $state.go('customers');
                }, function (error) {
                    toastr.error($translate.instant('customer.import.error.errorOnSaveImport'));
                    vm.isSaving = false;
                });
            }
            vm.isSaving = false;
        }

        function orderByErrors() {
            if (vm.customersImported.length > 0) {
                vm.customersImported.sort(function (a, b) {
                    //Inverted sort to make all row with error go to top
                    return b.errors.length - a.errors.length;
                });
            }
        }

        vm.uploadFile = function (file, errFiles) {
            vm.file = file;
            vm.errFiles = errFiles && errFiles[0];


            if (vm.errFiles) {
                if (errFiles[0].$error == 'pattern') {
                    toastr.error($translate.instant('customer.import.error.invalidType'));
                    return;
                }
            }

            if (file) {
                vm.isUploading = true;

                file.upload = Upload.upload({
                    url: 'admin/api/upload-customers-table',
                    data: {
                        file: file
                    }
                });

                file.upload.then(function (response) {
                    if (response.data) {
                        vm.customersImported = response.data;
                        vm.allStatusOk = true;
                        // vm.customersImportedErrors = [];
                        vm.customersImported.forEach(function (element) {
                            if (element.errors.length > 0) {
                                vm.allStatusOk = false;
                                // vm.customersImportedErrors.push(element);
                            }
                        });

                        // vm.customersImported = vm.customersImportedErrors;

                        vm.isUploading = false;

                        orderByErrors();

                        if (vm.customersImported.length > 0) {
                            vm.changePage();
                        }
                    } else {
                        toastr.warning($translate.instant('customer.import.error.tryAgain'));
                        vm.isUploading = false;
                        vm.customersImported = [];
                    }

                }, function (response) {
                    vm.customersImported = [];
                    vm.isUploading = false;
                    toastr.error($translate.instant('customer.import.error.errorOnUploadFile'));
                });

            }
        }

        vm.cancel = function () {
            vm.uploaded = false;
            vm.allStatusOk = false;
            $state.go('customers');
        }

        vm.changePage = function () {
            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;
            vm.filteredCustomers = vm.customersImported.slice(begin, end);
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;
        }

        // Workaround to fix navigation sidebar
        $(document).ready(function () {
            // if (!document.getElementsByClassName('slimScrollDiv').length) {
            //     setTimeout(function () {
            //         document.getElementsByClassName('slimScrollDiv')[0].setAttribute('style', 'position: relative; width: auto; height: 690px;');
            //     }, 1000);
            // } else {
            //     document.getElementsByClassName('slimScrollDiv').setAttribute('style', 'position: relative; width: auto; height: 690px;');
            // }

            // if (!document.getElementById('side-menu').length) {
            //     setTimeout(function () {
            //         document.getElementById('side-menu').setAttribute('style', 'height: 690px; width: auto;');
            //     }, 500);
            // } else {

            // }

        });

    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('CustomersListController', CustomersListController);

    /** @ngInject */
    function CustomersListController($rootScope, $scope, CustomerService, CustomerModalFactory, toastr, $translate) {

        var vm = this;
        vm.filter = {};
        vm.customers = [];

        vm.originalOrder = [];

        vm.currentPage = 1;
        vm.numPerPage = 10;
        vm.maxSize = 5;
        vm.totalCustomers = 0;

        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        vm.orderedByBirthdayWeek = false;

        vm.showModalAddCustomer = showModalAddCustomer;
        vm.selectCustomer = selectCustomer;
        vm.searchByFilter = searchByFilter;
        vm.filterChange = filterChange;

        init();

        function init() {
            listCustomers(vm.paginationOptions, vm.filter, true);
        }

        vm.orderByBirthdayWeek = function () {
            vm.orderedByBirthdayWeek = !vm.orderedByBirthdayWeek;

            vm.filter.orderedByBirthdayWeek = vm.orderedByBirthdayWeek;
            vm.currentPage = 1;
            vm.paginationOptions.page = 0;
            listCustomers(vm.paginationOptions, vm.filter, true);

        }

        function parseDates(elements){
            elements.forEach(function (element){
                element.birthdate = moment.utc(element.birthdate);
            });
        }

        function listCustomers(pagination, filter, selectFirst) {
            vm.loadingCustomers = true;
            CustomerService.list(pagination, filter).then(function (result) {
                parseDates(result.data);
                vm.totalCustomers = result.headers['x-total-count'];
                vm.customers = result.data.slice();
                vm.originalOrder = result.data;
                if (selectFirst) {
                    $rootScope.$broadcast('selectedCustomer', angular.copy(vm.customers[0]));
                }
                vm.loadingCustomers = false;
            }, function (error) {
                vm.loadingCustomers = false;
            });
        }

        function showModalAddCustomer() {
            CustomerModalFactory.addCustomer().then(function (result) {
                toastr.success($translate.instant(result.headers["x-adminapp-alert"]));
                listCustomers(vm.paginationOptions, {}, true);
            });
        }

        function selectCustomer(customer) {
            $rootScope.$broadcast('selectedCustomer', angular.copy(customer));
        }

        function searchByFilter() {
            if (vm.filter.fullName) {
                vm.currentPage = 1;
                vm.paginationOptions.page = 0;
                listCustomers(vm.paginationOptions, vm.filter, true);
            }
        }

        function filterChange() {
            vm.currentPage = 1;
            vm.paginationOptions.page = 0;
            listCustomers(vm.paginationOptions, vm.filter, true);
        }

        vm.changePage = function () {

            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            vm.customers = listCustomers(vm.paginationOptions, vm.filter, true);
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;

        }

        $scope.$on('refreshListCustomer', function (env) {
            listCustomers(vm.paginationOptions, vm.filter, false);
        });

        $scope.$on('deletedCustomer', function (env) {
            listCustomers(vm.paginationOptions, vm.filter, true);
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('CustomersDetailController', CustomersDetailController);

    /** @ngInject */

    function CustomersDetailController($rootScope, $scope, CustomerModalFactory,
                                       toastr, $translate, moment, CustomerService,
                                       NoteTagService, $localStorage) {
        var format = "L";
        var vm = this;
        vm.notes = [];
        vm.tags = [];
        vm.newNoteText = "";
        vm.newTagText = "";
        vm.isWritingNote = false;
        vm.isEditingNote = false;
        vm.currentlyEditingNote = 0;
        vm.customer = {};

        vm.showModalEditCustomer = showModalEditCustomer;
        vm.showModalDeleteCustomer = showModalDeleteCustomer;

        $scope.$on('selectedCustomer', function (event, customer) {
            if (customer) {
                vm.customer = customer;
                loadNotesTags(vm.customer.id);
            }
        });

        function addNine(numberWithNine) {
            if (numberWithNine.includes('+55') && numberWithNine.length === 13) {
                numberWithNine = numberWithNine.slice(0, 5) + '9' + numberWithNine.slice(5, numberWithNine.length);
            }
            return numberWithNine;
        }

        function showModalEditCustomer() {
            vm.customer.phone = addNine(vm.customer.phone);
            CustomerModalFactory.editCustomer(vm.customer).then(function (result) {
                vm.customer = result.data;
                vm.customer.birthdate = moment.utc(vm.customer.birthdate);
                $rootScope.$broadcast('refreshListCustomer');
                toastr.success($translate.instant(result.headers["x-adminapp-alert"]));
            });
        }

        function showModalDeleteCustomer() {
            CustomerModalFactory.deleteCustomer(vm.customer).then(function (result) {
                if (result) {
                    CustomerService.delete(vm.customer.id).then(function (result) {
                        toastr.success($translate.instant(result.headers["x-adminapp-alert"]));
                        $rootScope.$broadcast('deletedCustomer');
                    });
                }
            });
        }

        vm.sendMessageToWhastapp = function (number) {
            var whatsappApiDomain;
            if (detectar_mobile()) {
                whatsappApiDomain = "https://api.whatsapp.com/send?phone=";
            } else {
                whatsappApiDomain = "https://web.whatsapp.com/send?phone=";
            }
            return whatsappApiDomain + number;
        }

        //2021-10-01T15:51:08.760+0000
        function convertToDatePT(date) {
            var newDate = date.substring(8, 10) + "/" + date.substring(5, 7) + "/" + date.substring(0, 4)
            return newDate;
        }

        function loadNotesTags(customerId) {
            NoteTagService.getNotesTags(customerId).then(function (notesTags) {
                vm.notes = notesTags.filter(function (noteTag) {
                    noteTag.timestamp = convertToDatePT(noteTag.timestamp.substring(0, 10)) + " " + noteTag.timestamp.substring(11, 16);
                    if (noteTag.id && noteTag.type == 'note') {
                        return true
                    };
                })

                vm.tags = notesTags.filter(function (noteTag) {
                    if (noteTag.id && noteTag.type == 'tag') {
                        return true
                    };
                });

                vm.loadingCustomerInfos = false;
            })
        }

        vm.deleteNoteTag = function (tagId, isTag) {
            NoteTagService.deleteNoteTag(tagId).then(function () {
                isTag ?
                    vm.tags = vm.tags.filter(function (value) {
                        return value.id != tagId && value.type == "tag";
                    }) :
                    vm.notes = vm.notes.filter(function (value) {
                        return value.id != tagId && value.type == "note";
                    })
            })
        }

        vm.startWritingNote = function (isEditingNote, noteId, index) {
            if (isEditingNote) {
                vm.newNoteText = vm.notes[index].text;
            }

            vm.isWritingNote = true;
            vm.isEditingNote = isEditingNote;
            vm.currentlyEditingNote = noteId;
        }

        /**
         * adds a new tag or note to the user
         * @param {the text of the tag that's being created} newNoteTagText
         * @param {is true if it's suppose to add a tag} isTag
         */
        vm.addNoteTag = function (newNoteTagText, isTag) {
            if (newNoteTagText == "" || newNoteTagText == null) {
                toastr.warning('O texto não pode ser vazio');
                return;
            }

            if (vm.isEditingNote == true) {
                NoteTagService.updateNote({ noteId: vm.currentlyEditingNote, text: newNoteTagText }).then(function (result) {
                    for (var i = 0; i < vm.notes.length; i++) {
                        if (vm.notes[i].id == vm.currentlyEditingNote) {
                            vm.notes[i].text = result.text;
                            break;
                        }
                    }
                })
            } else {
                NoteTagService.createNoteTag({
                    "customerId": vm.customer.id,
                    "text": newNoteTagText,
                    "type": isTag ? "tag" : "note",
                    "createdBy": $localStorage.userId
                }).then(function (result) {
                    result.timestamp = convertToDatePT(result.timestamp.substring(0, 10)) + " " + result.timestamp.substring(11, 16);
                    isTag ? vm.tags.push(result) : vm.notes.push(result);
                });
            }
            isTag ? vm.newTagText = "" : vm.newNoteText = "";

            vm.isWritingNote = false;
            vm.isEditingNote = false;
        }

        vm.stopWritingNote = function () {
            vm.newNoteText = "";
            vm.isWritingNote = false;
            vm.isEditingNote = false;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer', {
            parent: 'admin',
            abstract: true,
            data: {
                authorities: ['STORE_READ_CUSTOMER'],
                pageTitle: 'customers.home.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/customer/customer.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customers');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('communication');
                    return $translate.refresh();
                }]
            }
        })
        .state('customers', {
            parent: 'customer',
            url: '/customers',
            data: {
                pageTitle: 'customer.title',
                authorities: [],
                // specialClass: "md-skin fixed-nav mini-navbar"
            },
            views: {
                'customer-list': {
                    templateUrl: 'app/admin/customer/customers-list.html',
                    controller: 'CustomersListController',
                    controllerAs: 'vm'
                },
                'customer-detail': {
                    templateUrl: 'app/admin/customer/customers-detail.html',
                    controller: 'CustomersDetailController',
                    controllerAs: 'vm'
                }
            }
        }).state('import-customers', {
            parent: 'app',
            url: '/customers-import',
            data: {
                pageTitle: 'customer.importTitle',
                authorities: ['STORE_CREATE_CUSTOMER'],
                specialClass: "md-skin fixed-nav"
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/customer/import/customers-import.html',
                    controller: 'CustomersImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('customers');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .service('CustomerService', CustomerService);

    /** @ngInject */
    function CustomerService(CustomerFactory) {

        var service = {
            create: create,
            update: update,
            list: list,
            listAllByIds: listAllByIds,
            delete: deleteCustomers,
            saveImportedCustomers: saveImportedCustomers,
            getOrCreateCustomerByWhatsapp: getOrCreateCustomerByWhatsapp,
            getByName: getByName,
            getOrCreateCustomerByFbInstagram: getOrCreateCustomerByFbInstagram
        };

        return service;


        function create(customer) {
            return CustomerFactory.create(customer).$promise;
        }

        function update(customer) {
            return CustomerFactory.update({id: customer.id}, customer).$promise;
        }

        function list(pageable, customerFilter) {
            return CustomerFactory.list(pageable, customerFilter).$promise;
        }

        function listAllByIds(customerFilter, onSuccess, onError) {
            return CustomerFactory.listAllByIds(customerFilter, onSuccess, onError);
        }

        function deleteCustomers(id) {
            return CustomerFactory.delete({id: id}).$promise;
        }

        function saveImportedCustomers (customers) {
            return CustomerFactory.importCustomers(customers).$promise;
        }

        function getOrCreateCustomerByWhatsapp(customer) {
            return CustomerFactory.getOrCreateCustomerByWhatsapp(customer).$promise;
        }

        function getByName(fullname, storeId) {
            return CustomerFactory.getByName({search: fullname, storeId: storeId}).$promise;
        }

        function getOrCreateCustomerByFbInstagram(customer) {
            return CustomerFactory.getOrCreateCustomerByFbInstagram(customer).$promise;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('CustomerModalFactory', CustomerModalFactory);

    /** @ngInject */
    function CustomerModalFactory($uibModal) {

        var factory = {
            addCustomer: addCustomer,
            editCustomer: editCustomer,
            deleteCustomer: deleteCustomer
        }

        return factory;

        function addCustomer() {
            return showAddEditModal();
        }

        function editCustomer(customer) {
            return showAddEditModal(customer);
        }

        function deleteCustomer(customer) {
            return showDeleteModal(customer.fullName);
        }

        function showAddEditModal(customer) {
            return $uibModal.open({
                templateUrl: "app/admin/customer/_modal_add_edit_customer.html",
                size: 'lg',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                resolve: {
                    customer: function () {
                        return angular.copy(customer);
                    }
                },
                controller: "CustomerModalConstroller",
                controllerAs: "vm"
            }).result;
        }

        function showDeleteModal(fullName) {
            return $uibModal.open({
                templateUrl: "app/admin/customer/_modal_delete_customer.html",
                size: 'md',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                resolve: {
                    fullName: function () {
                        return fullName;
                    }
                },
                controller: function ($uibModalInstance, fullName) {
                    var vm = this;
                    vm.fullName = fullName;
                    vm.cancel = cancel;
                    vm.ok = ok;

                    function cancel() {
                        $uibModalInstance.dismiss('cancel');
                    }

                    function ok() {
                        $uibModalInstance.close(true);
                    }
                },
                controllerAs: "vm"
            }).result;
        }
    }
})();

(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .controller('CustomerModalConstroller', CustomerModalConstroller);

    /** @ngInject */
    function CustomerModalConstroller(customer, $uibModalInstance, $scope,
                                      UserService, CustomerService, StoreInfoFactory,
                                      toastr, $translate, moment, NoteTagService,
                                      $localStorage) {
        var format = 'L';

        var vm = this;

        vm.maskLocale = '99/99/9999';

        vm.customer = customer || {};
        vm.cancel = cancel;
        vm.getGenderKey = getGenderKey;
        vm.init = init;
        vm.save = save;

        function init() {
            loadGenders();
            dateTimePicker();
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function loadGenders() {
            UserService.listUserGenders().then(function (genders) {
                vm.genders = genders;
            });
        }

        function removeNine(numberWithNine) {
            if (numberWithNine.includes('+55') && numberWithNine.length === 14) {
                numberWithNine = numberWithNine.substring(0, 5) + numberWithNine.substring(6, numberWithNine.length);
            }
            return numberWithNine;
        }

        vm.documentInputType = function() {
            if (vm.customer && vm.customer.customerIdentity) {
                var documentType = vm.customer.customerIdentity.length <= 11 ? 'INDIVIDUAL' : 'COMPANY';
                return documentType;
            }
            return 'INDIVIDUAL';
        }

        function save() {
            if (vm.formAddEditCustomer.$valid) {
                vm.isSaving = true;
                var customerToSave = angular.copy(vm.customer);
                customerToSave.phone = removeNine(customerToSave.phone);
                customerToSave.birthDate = customerToSave.birthDate ? moment.utc(customerToSave.birthDate, format).toDate() : undefined;
                customerToSave.storeId = StoreInfoFactory.getStoreId();
                customerToSave.type = vm.documentInputType();
                customerToSave.customerIdentity = customerToSave.customerIdentity === "" ? undefined : customerToSave.customerIdentity;

                if (vm.customer.id) {
                    CustomerService.update(customerToSave).then(onSuccess, onError);
                } else {
                    CustomerService.create(customerToSave).then(onSuccess, onError);
                }

                function onSuccess(result) {
                    vm.isSaving = false;
                    $uibModalInstance.close(result);

                        if (result.data.notes !== '') {
                            NoteTagService.createNoteTag({
                                "customerId": result.data.id,
                                "text": result.data.notes,
                                "type": "note",
                                "createdBy": $localStorage.userId
                            }).then(function (result) {
                            });
                        }
                }

                function onError(error) {
                    vm.isSaving = false;
                    if (error.data && error.data.data) {
                        switch(error.data.data) {
                            case "CUSTOMER_DOCUMENT_DUPLICATED_ERROR":
                                toastr.error($translate.instant("customer.error.duplicateCustomerIdentity"));
                                return;
                            case "CUSTOMER_EMAIL_DUPLICATED_ERROR":
                                toastr.error($translate.instant("customer.error.emailExists"));
                                return;
                            case "CUSTOMER_PHONE_DUPLICATED_ERROR":
                                toastr.error($translate.instant("customer.error.phoneExists"));
                                return;
                        }
                    }
                    if (error.data.headers["x-adminapp-params"]) {
                        toastr.error($translate.instant(error.data.headers["x-adminapp-params"].concat(".").concat(error.data.headers["x-adminapp-error"])));
                    } else {
                        toastr.error($translate.instant("global.messages.somethingWrong"));
                    }
                }
            }
        }

        function getGenderKey(value) {
            return "customer".concat(".").concat(value);
        }

        function dateTimePicker() {
            vm.dateOfBirthOptions = {
                format: format,
                sideBySide: true,
                ignoreReadonly: true,
                locale: moment.locale(),
                allowInputToggle: true,
                showClear: true,
                maxDate: moment()
            };

            angular.element('#dateOfBirth').datetimepicker(vm.dateOfBirthOptions).on('dp.change', function (ev) {
                if (ev.date) {
                    $scope.$apply(function () {
                        vm.customer.birthDate = ev.date.format(format);
                    });
                } else {
                    $scope.$apply(function () {
                        vm.customer.birthDate = undefined;
                    });
                }
            });

            vm.customer.birthDate = vm.customer.birthDate ? moment.utc(vm.customer.birthDate).format(format) : null;
        }
    }

})();

(function () {
    'user strict'

    angular.module('showcaseApp')
        .factory('CustomerFactory', CustomerFactory);

    /** ngInject */
    function CustomerFactory($resource) {

        var resourceUrl = 'admin/api/customer/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'create': {
                method: 'POST',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'update': {
                method: 'PUT',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'delete': {
                method: 'DELETE',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.headers = headers();
                    return response;
                }
            },
            'listAll': {
                method: 'POST',
                url: 'admin/api/customer/list',
                isArray: true
            },
            'listAllByIds': {
                method: 'POST',
                url: 'admin/api/customer/list-by-ids',
                isArray: true
            },
            'list': {
                method: 'POST',
                url: 'admin/api/customers',
                // isArray: true,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'importCustomers': {
                method: 'POST',
                url: 'admin/api/customer/import',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getOrCreateCustomerByWhatsapp': {
                method: 'POST',
                url: 'admin/api/customer/create/by-whatsapp',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getByName': {
                method: 'GET',
                url: 'admin/api/customers',
                // isArray: true,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getOrCreateCustomerByFbInstagram': {
                method: 'POST',
                url: 'admin/api/customer/create/by-facebook-instagram',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ADMIN_MANAGE_SYSTEM'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('informativeBalloon', informativeBalloon)
        .directive('warningBalloon', warningBalloon);

    function informativeBalloon() {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/components/balloon/informative-balloon.html',
            scope: {
                messageId: '='
            },
        };
    }

    function warningBalloon() {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/components/balloon/warning-balloon.html',
            scope: {
                messageId: '='
            },
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ViewChatOrderModalController', ViewChatOrderModalController);

    ViewChatOrderModalController.$inject = ['$scope', '$uibModalInstance', '$translate', 'ordersList'];

    function ViewChatOrderModalController($scope, $uibModalInstance, $translate, ordersList) {
        var vm = this;

        vm.ordersList = ordersList

        vm.getOrderAmount = function (orders) {
            return _.sumBy(orders, function (order) {
                return order.price;
            }).toFixed(2);
        }

        vm.closeModal = function () {
            $uibModalInstance.close();
        }

    }
})();

/* globals $ */
(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .filter('formatTimer', function() {
            return function(input) {
                function z(n) { return (n<10? '0' : '') + n; }
                var seconds = input % 60;
                var minutes = Math.floor(input / 60);
                var hours = Math.floor(minutes / 60);
                return (z(hours) +':'+z(minutes)+':'+z(seconds));
            };
        });
})();


(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('TemplateMessageService', TemplateMessageService);

    TemplateMessageService.$inject = ['TemplateMessageFactory'];

    function TemplateMessageService(TemplateMessageFactory) {

        var service = {
            create: create,
            getAll: getAll,
            remove: remove,
            update: update
        };

        return service;

        function create(body) {
            return TemplateMessageFactory.create(body).$promise;
        }

        function getAll() {
            return TemplateMessageFactory.getAll().$promise;
        }

        function remove(id) {
            return TemplateMessageFactory.deleteTemplate({id: id}).$promise;
        }

        function update(id, body) {
            return TemplateMessageFactory.update({id: id}, body).$promise;
        }

    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('TemplateMessageFactory', TemplateMessageFactory);

        TemplateMessageFactory.$inject = ['$resource'];

    function TemplateMessageFactory($resource) {
        var resourceTemplateMessage =  '/admin/api/template-message';
        var resourceTemplateMessageById =  resourceTemplateMessage + '/:id';

        return $resource(resourceTemplateMessage, {}, {
            'create': {
                method: 'POST',
                url: resourceTemplateMessage
            },
            'update': {
                method: 'PUT',
                url: resourceTemplateMessageById
            }, 
            'getAll': {
                method: 'GET',
                url: resourceTemplateMessage,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'deleteTemplate': {
                method: 'DELETE',
                url: resourceTemplateMessageById,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('TemplateMessageController', TemplateMessageController);

        TemplateMessageController.$inject = ['$uibModalInstance', 'TemplateMessageService', 'DeleteTemplateModalFactory'];

    function TemplateMessageController($uibModalInstance, TemplateMessageService, DeleteTemplateModalFactory) {
        
        var vm = this;

        vm.templates = []

        TemplateMessageService.getAll().then(function(result) {
            vm.templates = result.data;
        });

        vm.onSelectTemplate = function(template) {
            vm.template = template.template;
            vm.currentTemplate = template;
        }

        vm.dismiss = function() {
			$uibModalInstance.dismiss();
		}

        vm.sendTemplate = function(template) {
            $uibModalInstance.close(template.template);
        }

        vm.addTemplate = function() {
            if (vm.currentTemplate !== undefined) {
                vm.update();
            } else {
                TemplateMessageService.create({template: vm.template}).then(function(result) {
                    vm.templates.push({id: result.id, template: result.template});
                    vm.template = '';
                });}
            }


        vm.remove = function(template) {
            vm.removeModalActive = true;
            DeleteTemplateModalFactory.deleteTemplate(template).then(function(result) {
                if (result) {
                    TemplateMessageService.remove(template.id).then(function(result) {
                        vm.templates = vm.templates.filter(function(temp) {
                            return template.id != temp.id;
                        });
                    });
                }
                vm.removeModalActive = false;
                
            }, function(cancel) {
                vm.removeModalActive = false;
            })

        }

        vm.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        }

        vm.ok = function() {
            $uibModalInstance.close(true);
        }

        vm.update = function() {
            vm.currentTemplate.template = vm.template
            TemplateMessageService.update(vm.currentTemplate.id, vm.currentTemplate).then(function(result) {
                var templateIndex = vm.templates.findIndex(function (template) {
                    return template.id == vm.currentTemplate.id;
                });
                vm.templates[templateIndex] = vm.currentTemplate;
                vm.template = '';
                vm.currentTemplate = undefined;
            });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('DeleteTemplateModalFactory', DeleteTemplateModalFactory);

    /** @ngInject */
    function DeleteTemplateModalFactory($uibModal) {

        var factory = {
            deleteTemplate: deleteTemplate
        }

        return factory;

        function deleteTemplate(id) {
            return showDeleteModal(id);
        }

        function showDeleteModal(template) {
            return $uibModal.open({
                templateUrl: 'app/admin/communication/template-message/_modal_delete_template_message.html',
                size: 'md',
                windowClass: 'modal-center delete-template-modal',
                windowTopClass: 'modal-dialog-center',
                resolve: {
                    template: function () {
                        return template;
                    }
                },
                controller: function ($uibModalInstance, template) {
                    var vm = this;
                    vm.template = template;
                    vm.cancel = cancel;
                    vm.ok = ok;

                    function cancel() {
                        $uibModalInstance.dismiss('cancel');
                    }

                    function ok() {
                        $uibModalInstance.close(true);
                    }
                },
                controllerAs: "vm"
            }).result;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('WatiSettingsModalController', WatiSettingsModalController);

    function WatiSettingsModalController($uibModalInstance, $state, $localStorage, communicationConstants,
                                         $window, ChatCommerceService, toastr, FBAuthModalFactory, SocialMediaService,
                                         token, $scope) {
        var vm = this;

        vm.step = 0;

        var SOURCE = 'WATI';

        vm.webhook = document.location.protocol + '//admin.' + document.location.hostname.split('.').slice(1).join('.') + '/admin/api/wati/hook?accessToken=' + token;

        vm.popoverIsOpen = false

        vm.watiAccountData = {};

        vm.isSaving = false;

        vm.syncProgress = 0;

        vm.progressInterval;

        vm.closeModal = function(url) {
            $uibModalInstance.close(url);
        }

        vm.nextStep = function() {
            vm.step = vm.step + 1;
        }

        vm.previousStep = function() {
            if (vm.step == 0) {
                vm.closeModal();
            } else {
                vm.step = vm.step - 1;
            }
        }

        vm.changeTextPopover = function() {
            vm.popoverIsOpen = true;
            setTimeout(function() {
                vm.popoverIsOpen = false;
            }, 5000)
        }

        var validateSetting = function() {
            if (vm.watiAccountDataForm.$invalid) {
                toastr.warning("Campos obrigatórios não foram preenchidos");
                return false;
            }
            return true;
        }

        var makeBodyToRequest = function() {
            vm.isSaving = true;

            return angular.copy(vm.watiAccountData);
        }

        vm.saveSetting = function() {
            if(!validateSetting()) return;

            vm.isSaving = true;
            vm.watiAccountData.accessToken = token;

            vm.progressInterval = setInterval(function () {
                if (vm.syncProgress === 100) {
                    clearInterval(vm.progressInterval);
                    return;
                }
                vm.syncProgress = vm.syncProgress + 5;
                $scope.$apply();
            }, 1000);

            ChatCommerceService.connectToChat(
                {
                    watiAccountData: makeBodyToRequest(),
                    chatPlatform: SOURCE
                }
            ).then(function(response) {
                vm.syncProgress = 100;
                clearInterval(vm.progressInterval);
                setTimeout(function () {
                    vm.isSaving = false;
                    toastr.success("Configuração criada com sucesso");
                    vm.closeModal({data: response, source: 'whatsapp'})
                }, 1000);
            });
        }

    }

})();


(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('SocialNetworksConnectModalController', SocialNetworksConnectModalController);

    function SocialNetworksConnectModalController($uibModalInstance, $state, $localStorage, communicationConstants, $window,
                                                  ChatCommerceService, toastr, FBAuthModalFactory, SocialMediaService, $translate, token, $scope) {
        var vm = this;

        vm.step = 0;

        var SOURCE = 'WATI';

        vm.whatsapp = false;
        vm.faceinsta = false;

        vm.webhook = document.location.protocol + '//admin.' + document.location.hostname.split('.').slice(1).join('.') + '/admin/api/wati/hook?accessToken=' + token;

        vm.popoverIsOpen = false

        vm.SOCIAL_NETWORKS = {
            FACE_INSTA: "FACE_INSTA",
            WHATSAPP: "WHATSAPP"
        }

        vm.watiAccountData = {};

        vm.isSaving = false;

        vm.syncProgress = 0;

        vm.progressInterval;

        vm.closeModal = function(url) {
            $uibModalInstance.close(url);
        }

        vm.nextStep = function() {
            if (vm.whatsapp) {
                vm.step = vm.step + 1;
            } else {
                vm.closeModal('facebook');
            }

        }

        vm.previousStep = function() {
            if (vm.step == 0) {
                vm.closeModal();
            } else {
                vm.step = vm.step - 1;
            }
        }

        vm.selectSocialNetwork = function(socialNetwork) {
            if (socialNetwork == vm.SOCIAL_NETWORKS.WHATSAPP) {
                vm.whatsapp = true;
                vm.faceinsta = false;
            } else {
                vm.whatsapp = false;
                vm.faceinsta = true;
            }
        }

        vm.changeTextPopover = function() {
            vm.popoverIsOpen = true;
            setTimeout(function() {
                vm.popoverIsOpen = false;
            }, 5000)
        }

        var validateSetting = function() {
            if (vm.watiAccountDataForm.$invalid) {
                toastr.warning("Campos obrigatórios não foram preenchidos");
                return false;
            }
            return true;
        }

        var makeBodyToRequest = function() {
            vm.isSaving = true;
            return angular.copy(vm.watiAccountData);
        }

        vm.saveSetting = function() {
            if(!validateSetting()) return;

            vm.isSaving = true;
            vm.watiAccountData.accessToken = token;

            vm.progressInterval = setInterval(function () {
                if (vm.syncProgress === 100) {
                    clearInterval(vm.progressInterval);
                    return;
                }
                vm.syncProgress = vm.syncProgress + 5;
                $scope.$apply();
            }, 1000);

            ChatCommerceService.connectToChat(
                {
                    watiAccountData: makeBodyToRequest(),
                    chatPlatform: SOURCE
                }
            ).then(function(response) {
                vm.syncProgress = 100;
                clearInterval(vm.progressInterval);
                setTimeout(function () {
                    vm.isSaving = false;
                    toastr.success("Configuração criada com sucesso");
                    vm.closeModal({data: response, source: 'whatsapp'})
                }, 1000);
            });
        }

    }

})();


(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('SingleProductController', SingleProductController);

    SingleProductController.$inject = ['$uibModalInstance', '$window', '$stateParams', '$localStorage',
        'StoreService', '$translate', 'FlyersService', 'conversation',
        'FlyerCategoryService', 'ShowcasesService', 'toastr', 'WatiService',
        'communicationConstants', '$rootScope', '$timeout', '$scope'];

    function SingleProductController($uibModalInstance, $window, $stateParams, $localStorage,
        StoreService, $translate, FlyersService, conversation, FlyerCategoryService,
        ShowcasesService, toastr, WatiService, communicationConstants, $rootScope, $timeout, $scope) {

        StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
            vm.storeCategory = response.data.categoryKey;
        });

        var vm = this;
        vm.isMobile = detectar_mobile();
        var storeId = $localStorage.defaultStore.storeId;
        vm.showcaseId = $stateParams.showcaseId;
        vm.isWati = conversation.platform === communicationConstants.SOCIAL_MEDIAS.WATI;
        vm.isCarousel = !vm.isWati;

        vm.currentPage = 1;
        vm.maxSize = 15;
        vm.numPerPage = vm.maxSize;
        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        var FLYER_ID_MARKER = "{{flyerName}}-SHW_{{flyerId}}_KSE";

        vm.colors = [];
        vm.sizes = [];
        vm.excludes = [];
        vm.featureds = [];
        vm.tags = [];
        vm.genders = [];
        vm.isActive = false;
        vm.file = {};
        vm.flyersToSend = [];

        vm.selected = {};
        vm.selectedProductsLen = function () {
            return Object.keys(vm.selected).length;
        }

        vm.filters = {
            brands: [],
            colors: [],
            sizes: [],
            categories: [],
            genders: [],
            tags: [],
            storeId: storeId
        }
        vm.originalFlyers = [];

        vm.watiMessages = [];

        vm.filtersLen = 0;
        vm.getFiltersLen = function () {
            vm.filtersLen = 0;
            for (var filter in vm.filters) {
                if (Array.isArray(vm.filters[filter])) {
                    vm.filtersLen += vm.filters[filter].length;
                }
            }

        }

        vm.changeActive = function () {
            vm.isActive = !vm.isActive;
        }

        vm.closePreferences = function () {
            $("btn-group preferences open").removeClass("open");
        }

        vm.closeDropDown = function (event, level) {
            $("md-backdrop").trigger('click');
        }

        vm.getSelectedTextGender = function (filter) {
            var genderTranslate = '';
            if (filter[0] === 1) {
                genderTranslate = $translate.instant('flyers.new.form.gender.male');
            }
            if (filter[0] === 2) {
                genderTranslate = $translate.instant('flyers.new.form.gender.female');
            }
            if (filter[0] === 3) {
                genderTranslate = $translate.instant('flyers.new.form.gender.both');
            }
            if (filter.length == 1) {
                return '<span class="highlight">' + genderTranslate + '</span>';
            }
            if (filter.length > 1) {
                var temp = '  +';
                temp += filter.length - 1;
                temp += ' selecionados';
                return '<span class="highlight">' + genderTranslate + '</span>' +
                    '<span>&nbsp</span>' +
                    '<span class="highlight">' + temp + '</span>';
            }
            return '';
        }

        vm.getSelectedTextCategory = function (filter) {
            for (var i = 0; i < vm.categories.length; i++) {
                if (vm.categories[i].key === filter[0]) {
                    if (filter.length == 1) {
                        return '<span class="highlight">' + vm.categories[i].title + '</span>';
                    }
                    if (filter.length > 1) {
                        var temp = '  +';
                        temp += filter.length - 1;
                        temp += ' selecionados';

                        return '<span class="highlight">' + vm.categories[i].title + '</span>' +
                            '<span>&nbsp</span>' +
                            '<span class="highlight">' + temp + '</span>';
                    }
                    return '';
                }
            }
            return '';
        }

        vm.getSelectedText = function (filter) {
            var elementTranslate = '';

            if (filter[0] === 'launch' || filter[0] === 'basic') {
                elementTranslate = $translate.instant('flyers.new.form.configurations.' + filter[0].toLowerCase());
            } else {
                elementTranslate = filter[0];
            }
            if (filter.length == 1) {
                return '<span class="highlight">' + elementTranslate + '</span>';
            }
            if (filter.length > 1) {
                var temp = '  +';
                temp += filter.length - 1;
                temp += ' selecionados';

                return '<span class="highlight">' + elementTranslate + '</span>' +
                    '<span>&nbsp</span>' +
                    '<span class="highlight">' + temp + '</span>';
            }
            return '';

        }

        vm.checkIfFilterSelected = function (filterKey, filter) {
            return (vm.filters[filterKey] ? vm.filters[filterKey] : []).indexOf(filter) >= 0 ? true : false;
        }

        vm.updateFilterOrRemove = function (filterKey, filter) {
            if (!vm.filters[filterKey]) {
                vm.filters[filterKey] = [];
            }
            var index = vm.filters[filterKey].indexOf(filter);
            if (index === -1) {
                vm.filters[filterKey].push(filter);
                return;
            }
            vm.filters[filterKey].splice(index, 1);
        }

        vm.hasSome = function (list, arr) {
            if (arr) {
                return arr.some(function (v) {
                    return list.indexOf(v.id) >= 0;
                });
            }
        };

        vm.makeTagsToFilter = function () {
            vm.filters.tags = vm.filters.tags ? vm.filters.tags.map(function (item) { return item.text ? item.text : item }) : [];
        }

        vm.getCategoryName = function (flyer) {
            var category = _.find(vm.categories, function (el) { return el.key === flyer.categoryKey });
            if (category) {
                flyer.category = category.title;
            }
        }

        vm.getTranslateType = function (type) {
            return 'flyers.new.form.userInteract.types.' + type.toLowerCase();
        }

        vm.getTranslateFeatureds = function (featured) {
            return 'flyers.new.form.configurations.' + featured.toLowerCase();
        }

        vm.getTranslateGenders = function (gender) {
            if (gender === 1) {
                return 'flyers.new.form.gender.male';
            }
            if (gender === 2) {
                return 'flyers.new.form.gender.female';
            }
            if (gender === 3) {
                return 'flyers.new.form.gender.both';
            }
            return '';
        }
        
        init();

        function init() {
            loadStore();
            loadAll();
        }

        function loadAll() {
            FlyersService.getAllFiltersFlyer().then(function (response) {
                vm.brands = response.data.brands;
                vm.colors = response.data.colors;
                vm.sizes = response.data.sizes;
                vm.types = response.data.types;
                vm.featureds = response.data.features;
                vm.tags = response.data.tags;
                vm.genders = response.data.genders;
            });

            FlyerCategoryService.listCategoriesWithFlyers($translate.use()).then(function (response) {
                vm.categories = response.data;
            });

            ShowcasesService.findFlyerByFilterBag(vm.paginationOptions, vm.filters).then(function (response) {
                vm.flyersFiltered = response.content;
                vm.originalFlyers = vm.flyersFiltered;
            });

        }

        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId);
        }

        function loadStore() {
            getStoreInfo().then(function (response) {
                if (response.data) {
                    vm.store = response.data;
                    $localStorage.defaultStore.storeType = response.data.storeType;
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    loadCurrencyPrefix(response.data)
                }
            });
        }

        function loadCurrencyPrefix(store) {
            var key = store.currency ? store.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            vm.currencyPrefix = config.prefix;
        }

        vm.getCurrencyPrefix = function(flyer) {
            var key = flyer.currency ? flyer.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            return config.prefix;
        }

        vm.totalFlyers = 0;
        vm.getTotalFlyers = function () {
            if (vm.flyersFiltered !== undefined && vm.selected !== undefined) {
                return vm.flyersFiltered.length - (vm.flyersFiltered.length - Object.keys(vm.selected).length);
            }

            return 0;
        }

        vm.flyersSelected = function () {
            if (vm.flyersFiltered) {
                return Object.keys(vm.selected).length === vm.flyersFiltered.length;
            } else {
                return false;
            }
        }

        vm.refreshSelectedFlyers = function (flyer) {
            if (flyer.id in vm.selected) {
                delete vm.selected[flyer.id]
            } else {
                if (vm.selectedProductsLen() < 10) {
                    vm.selected[flyer.id] = flyer
                }
            }
            vm.totalFlyers = vm.getTotalFlyers();
        }

        vm.checkIfFlyerSelected = function (idFlyer) {
            return idFlyer in vm.selected;
        }

        function flyerExists(id, arr) {
            return arr.some(function (flyer) {
                return flyer.id === id;
            });
        }

        vm.searchFlyers = function () {

            if (vm.filters.text === '') {
                vm.flyersFiltered = vm.originalFlyers
                for (var flyerId in vm.selected) {
                    if (!(flyerExists(flyerId, vm.flyersFiltered))) {
                        vm.flyersFiltered.push(vm.selected[flyerId])
                    }
                }
            } else {
                vm.currentPage = 0;
                vm.paginationOptions.page = vm.currentPage;
                FlyersService.listAllToAdmin(vm.paginationOptions, vm.filters, function (data, headers) {
                    vm.flyersFiltered = data.content;
                }, function (_) { });
            }

        }

        vm.filterFlyers = function () {
            vm.currentPage = 0;
            vm.paginationOptions.page = vm.currentPage;
            scrollToTop();
            ShowcasesService.findFlyerByFilterBag(vm.paginationOptions, vm.filters).then(function (response) {
                vm.flyersFiltered = response.content;
                vm.originalFlyers = vm.flyersFiltered;
            });

            vm.getFiltersLen();
            $('.btn-group.preferences').removeClass('open');
            $('.dropdown-backdrop').css('display', 'none');
            vm.changeActive();

        };

        function scrollToTop() {
            $timeout(function () {
                var scroller = document.getElementById("scroll-div");
                if (scroller) {
                    scroller.scrollTop = 0;
                }
            }, 0, false);
        }

        vm.flyerScrollToBottom = function () {
            vm.currentPage += 1;
            vm.paginationOptions.page += 1;
            ShowcasesService.findFlyerByFilterBag(vm.paginationOptions, vm.filters).then(function (response) {
                var temp = response.content;
                vm.flyersFiltered = vm.flyersFiltered.concat(temp)
            })
        }

        vm.closeModal = function (url) {
            $uibModalInstance.close(url);
        }

        vm.sendProducts = function () {
            var finalFlyers = [];
            for (var flyerId in vm.selected) {
                finalFlyers.push(vm.selected[flyerId])
            }

            if (vm.isWati) {
                sendWatiSingleProducts(finalFlyers);
            } else {
                if (!$localStorage.defaultStore.storeNickname) {
                    getStoreInfo().then(function (response) {
                        vm.closeModal({ flyers: finalFlyers, isCarousel: vm.isCarousel });
                    });
                } else {
                    vm.closeModal({ flyers: finalFlyers, isCarousel: vm.isCarousel });
                }
            }
        }

        function toDataUrl(url, flyer) {
            return new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        resolve({base64: reader.result, flyer: flyer, url: url});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        }

        vm.getUrlImage = function (message) {
            if (message.isServer && message.fullData) {
                return message.fullData + '&token=' + WatiService.replaceWatiToken(vm.watiSetting.watiToken);
            } else if (message.isServer) {
                return WatiService.makeUriToShowImageByWati(vm.watiSetting.watiUri, message.data, vm.watiSetting.watiToken);
            }
            return message.data.fullData.fullBase64;
        }

        function formatWatiMessages(mediaMessage) {
            var imageMessage = {
                owner: true,
                type: mediaMessage.type,
                data: mediaMessage.media,
                text: mediaMessage.media.caption,
                isServer: false,
                created: moment().valueOf()
            };
            imageMessage.data = vm.getUrlImage(imageMessage);
            vm.watiMessages.push(imageMessage);

        }

        function sendMultipleMessagesToWhatsapp(messageList) {
            WatiService.sendMultipleMessages(messageList).then(function () {
                messageList.forEach(function (mediaMessage) {
                    formatWatiMessages(mediaMessage);
                });
                vm.closeModal({ flyers: vm.flyersToSend, isCarousel: vm.isCarousel, watiMessages: vm.watiMessages });
                vm.isSendingMessage = false;

            }).catch(function (error) {
                vm.isSendingMessage = false;
                toastr.warning($translate.instant('communication.errors.watiConfiguration'));
            });
        }

        function getFlyerUrl(flyer) {
            return 'https://' + $rootScope.bucket + '.s3-sa-east-1.amazonaws.com/flyer/' + storeId + '/400x400/' + flyer.id + '.jpg';
        }

        function formatCaption(flyer) {
            var caption = '';
            caption = '*' + flyer.name + '* - ';
            var price = flyer.purchaseValue;
            price = price.toLocaleString('pt-br', {minimumFractionDigits: 2});

            if (flyer.discountedValue) {
                var discountedPrice = flyer.discountedValue;
                caption = caption + '*R$ ' + discountedPrice.toLocaleString('pt-br', {minimumFractionDigits: 2}) + '*';
                price = '~' + price + '~';
            }
            caption = caption + ' R$ ' + price;
            caption = caption + ' \n\n ';

            var cleanName = flyer.name.normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(/[^\w\d]/g, '-');

            caption = caption + $window.location.protocol + '//' + $localStorage.defaultStore.storeNickname.toLowerCase()
                + "." + getDomainNameSufix($window) + '/flyer/'
                + FLYER_ID_MARKER.replace('{{flyerName}}', cleanName).replace('{{flyerId}}', flyer.id) ;
            caption = caption.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            return caption
        }

        function formatSetting(fullBase64, url) {
            var setting = makeSettingByBase64(fullBase64);
            if (setting.type != communicationConstants.TYPES.IMAGE.toLowerCase()) {
                setting.type = communicationConstants.TYPES.IMAGE.toLowerCase();
                var splitedUrl = url.split('.')
                setting.mimeType = 'image/' + splitedUrl[splitedUrl.length - 1]
            }

            if (setting.mimeType.split('/')[1] == 'jpg') {
                setting.mimeType = setting.mimeType.split('/')[0] + '/jpeg';
            }
            return setting
        }

        function makePromiseFlyersImages(flyers) {
            return new Promise(function (resolve, reject) {
                var requests = [];
                flyers.forEach(function (flyer) {
                    requests.push(toDataUrl(getFlyerUrl(flyer), flyer))
                })
                Promise.all(requests).then(function (result) {
                    result.forEach(function (obj) {
                        vm.file = {};
                        if (obj.base64.slice(5, 9) == 'imag'){
                            obj.base64 = obj.base64.slice(0, 5) + 'image' + obj.base64.slice(9, obj.base64.length)
                        }
                        vm.file.fullBase64 = obj.base64;
                        vm.file.base64 = vm.file.fullBase64.split(',')[1];
                        var setting = formatSetting(vm.file.fullBase64, obj.url);
                        vm.file.type = setting.type;
                        vm.file.mimeType = setting.mimeType;
                        vm.file.name = obj.flyer.name;
                        vm.flyersToSend.push({number: conversation.chatUserId, text: undefined, media: { data: vm.file.base64, mimeType: vm.file.mimeType, caption: formatCaption(obj.flyer), fullData: vm.file }, type: "image"})

                    })
                    resolve();
                })
            })
        }

        vm.isSendingMessage = false;

        function sendWatiSingleProducts(flyers) {
            vm.isSendingMessage = true;
            makePromiseFlyersImages(flyers).then(function () {
                sendMultipleMessagesToWhatsapp(vm.flyersToSend);
            })
        }

        /**
         * Extracts information of the base64, as extension (png/jpg/jpeg,pdf), mimeType (image/png or application/pdf).
         * @param {*} base64
         * @returns
         */
        function makeSettingByBase64(base64) {
            var base = base64.split(';')[0];
            var types = communicationConstants.FILE_TYPES;
            return {
                type: types.find(function (type) {
                    return base.split('/')[1] === type.source;
                }).target, mimeType: base.split(':')[1]
            };
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('IndexedDBCommunication', IndexedDBCommunication);

    function IndexedDBCommunication($q) {
        var db;

        openDB();

        function openDB() {
            var requestDB = indexedDB.open('communicationDB', 1);

            requestDB.onsuccess = function (event) {
                db = event.target.result;

                db.onclose = function (error) {
                    openDB();
                }
            };

            requestDB.onerror = function (event) {
                console.error("Erro ao abrir o banco de dados:", event.target.error);
            };

            requestDB.onupgradeneeded = function (event) {
                db = event.target.result;
                var objectStore = db.createObjectStore('sending-files', { keyPath: 'id', autoIncrement: true });
                objectStore.createIndex('file-index', 'fileIndex', { unique: false });
            };
        }

        var service = {
            addSendingFiles: addSendingFiles,
            removeSendingFile: removeSendingFile,
            updateSendingFileStatus: updateSendingFileStatus,
            getSendingFileByLocalMessageId: getSendingFileByLocalMessageId,
            getSendingFileByFilenameAndConversationId: getSendingFileByFilenameAndConversationId,
            getSendingFileByConversatonId: getSendingFileByConversatonId,
            updateSendingFilesByStatus: updateSendingFilesByStatus,
            updateSendingFileProgress: updateSendingFileProgress
        };

        return service;

       function addSendingFiles(item, callback) {
            var transaction = db.transaction(['sending-files'], 'readwrite');
            var objectStore = transaction.objectStore('sending-files');
            var request = objectStore.add(item);

            request.onsuccess = function (event) {
                if (callback) callback(event.target.result);
            };

            request.onerror = function (event) {
                console.error("Erro ao adicionar item:", event.target.error);
            };
        };

        function updateSendingFilesByStatus(status, callback) {
            try {
                var transaction = db.transaction(['sending-files'], 'readwrite');
                var objectStore = transaction.objectStore('sending-files');
                var request = objectStore.openCursor();

                request.onsuccess = function (event) {
                    var cursor = event.target.result;
                    if (cursor) {
                        cursor.value.status = status;

                        if (cursor.value.message
                                && cursor.value.message.data
                                && cursor.value.message.data.fullData
                                && cursor.value.message.data.fullData.fullBase64) {
                            delete cursor.value.message.data.fullData.base64;
                            delete cursor.value.message.data.fullData.fullBase64;
                        }

                        objectStore.put(cursor.value);
                        cursor.continue();
                    } else {
                        if (callback) callback("Todos os objetos atualizados com sucesso");
                    }
                };

                request.onerror = function (event) {
                    console.error("Erro ao buscar objetos para atualização:", event.target.error);
                };
            } catch (error) {
                console.log(error)
            }
        }

        function updateSendingFileStatus(id, status, callback) {
            var transaction = db.transaction(['sending-files'], 'readwrite');
            var objectStore = transaction.objectStore('sending-files');

            var getRequest = objectStore.get(id);

            getRequest.onsuccess = function (event) {
                var existingItem = event.target.result;
                if (existingItem) {
                    // Atualize os campos desejados do objeto.
                    existingItem.status = status;

                    // Use o método put para atualizar o objeto.
                    var updateRequest = objectStore.put(existingItem);
                    updateReturn(updateRequest, callback);
                } else {
                    console.error("Objeto não encontrado com a chave primária:", id);
                }
            };

            getRequest.onerror = function (event) {
                console.error("Erro ao buscar objeto para atualização:", event.target.error);
            };
        }

        function updateSendingFileProgress(id, sendingProgress, callback) {
            var transaction = db.transaction(['sending-files'], 'readwrite');
            var objectStore = transaction.objectStore('sending-files');

            var getRequest = objectStore.get(id);

            getRequest.onsuccess = function (event) {
                var existingItem = event.target.result;
                if (existingItem) {
                    existingItem.message.sendingProgress = sendingProgress;
                    var updateRequest = objectStore.put(existingItem);
                    updateReturn(updateRequest, callback);
                } else {
                    console.error("Objeto não encontrado com a chave primária:", id);
                }
            };

            getRequest.onerror = function (event) {
                console.error("Erro ao buscar objeto para atualização:", event.target.error);
            };
        }

        function updateReturn(updateRequest, callback) {
            updateRequest.onsuccess = function () {
                if (callback) callback("Objeto atualizado com sucesso");
            };

            updateRequest.onerror = function (event) {
                console.error("Erro ao atualizar o objeto:", event.target.error);
            };
        }

        function getSendingFileByFilenameAndConversationId(filename, conversationId, callback) {
            var transaction = db.transaction(['sending-files'], 'readonly');
            var objectStore = transaction.objectStore('sending-files');
            var request = objectStore.openCursor();

            request.onsuccess = function (event) {
                var cursor = event.target.result;
                if (cursor) {
                    if (cursor.value.conversationId === conversationId &&
                        cursor.value.message.text === filename) {
                        if (callback) callback(cursor.value);
                        return; // Encerre a pesquisa após encontrar um correspondente
                    }
                    cursor.continue();
                } else {
                    if (callback) callback(null); // Se não for encontrado, retorne null
                }
            };

            request.onerror = function (event) {
                console.error("Erro ao buscar objeto por localMessageId:", event.target.error);
                if (callback) callback(null);
            };
        }

        function getSendingFileByLocalMessageId(localMessageId, callback) {
            var transaction = db.transaction(['sending-files'], 'readonly');
            var objectStore = transaction.objectStore('sending-files');
            var request = objectStore.openCursor();

            request.onsuccess = function (event) {
                var cursor = event.target.result;
                if (cursor) {
                    if (cursor.value.localMessageId === localMessageId) {
                        if (callback) callback(cursor.value);
                        return; // Encerre a pesquisa após encontrar um correspondente
                    }
                    cursor.continue();
                } else {
                    if (callback) callback(null); // Se não for encontrado, retorne null
                }
            };

            request.onerror = function (event) {
                console.error("Erro ao buscar objeto por localMessageId:", event.target.error);
                if (callback) callback(null);
            };
        }

        function getSendingFileByConversatonId(conversationId, callback) {
            var transaction = db.transaction(['sending-files'], 'readonly');
            var objectStore = transaction.objectStore('sending-files');
            var request = objectStore.openCursor();
            var items = [];

            request.onsuccess = function (event) {
                var cursor = event.target.result;
                if (cursor) {
                    if (cursor.value.conversationId === conversationId) {
                        items.push(cursor.value);
                    }
                    cursor.continue();
                } else {
                    if (callback) callback(items);
                }
            };

            request.onerror = function (event) {
                console.error("Erro ao buscar objeto por localMessageId:", event.target.error);
            };
        }

        function getSendingFiles(callback) {
            var transaction = db.transaction(['sending-files'], 'readonly');
            var objectStore = transaction.objectStore('sending-files');
            var request = objectStore.openCursor();
            var itens = [];

            request.onsuccess = function (event) {
                var cursor = event.target.result;
                if (cursor) {
                    itens.push(cursor.value);
                    cursor.continue();
                } else {
                    if (callback) callback(itens);
                }
            };

            request.onerror = function (event) {
                console.error("Erro ao listar itens:", event.target.error);
            };
        };

        function removeSendingFile(itemId, callback) {
            var transaction = db.transaction(['sending-files'], 'readwrite');
            var objectStore = transaction.objectStore('sending-files');
            var request = objectStore.delete(itemId);

            request.onsuccess = function (event) {
                if (callback) callback();
            };

            request.onerror = function (event) {
                console.error("Erro ao remover item:", event.target.error);
            };
        };

    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('ImageManagerService', ImageManagerService);

    function ImageManagerService() {

        var service = {
            handleImageSize: handleImageSize
        };

        return service;

        function handleImageSize(img, file) {
            var canvas = document.createElement("canvas");
            var MAX_WIDTH = img.width * 0.6;
            var MAX_HEIGHT = img.height * 0.6;

            canvas.width = Math.floor(MAX_WIDTH);
            canvas.height = Math.floor(MAX_HEIGHT);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, MAX_WIDTH, MAX_HEIGHT);

            return canvas.toDataURL(file.type);
        };
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('ChatCommerceService', ChatCommerceService);

    ChatCommerceService.$inject = ['ChatCommerceFactory', 'ChatConfigurationFactory'];

    function ChatCommerceService(ChatCommerceFactory, ChatConfigurationFactory) {

        var service = {
            getConversations: getConversations,
            getConversationsByFilter: getConversationsByFilter,
            getConversationByConversationId: getConversationByConversationId,
            connectToChat: connectToChat,
            synchronizeChat: synchronizeChat,
            getChatConfiguration: getChatConfiguration
        };

        return service;

        function getConversations(filter) {
            return ChatCommerceFactory.getConversations(filter).$promise;
        }

        function getConversationsByFilter(filter) {
            return ChatCommerceFactory.getConversationsByFilter(filter).$promise;
        }

        function synchronizeChat(chatPlatform) {
            return ChatCommerceFactory.synchronizeChat(chatPlatform).$promise;
        }

        function connectToChat(chatConnectionData) {
            return ChatCommerceFactory.connectToChat(chatConnectionData).$promise;
        }

        function getConversationByConversationId(conversationId) {
            return ChatCommerceFactory.getConversationByConversationId({conversationId: conversationId}).$promise;
        }

        function getChatConfiguration() {
            return ChatConfigurationFactory.getChatConfiguration().$promise;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('SelectContactsModalController', SelectContactsModalController);

    SelectContactsModalController.$inject = ['$scope', '$uibModalInstance', '$translate', '$q', '$window',
        'BroadcastListService', 'ForwardMessageService', 'ChatCommerceService', 'allAttendants',
        '$localStorage', 'toastr', 'moment', 'selectedMessages', 'communicationConstants'];

    function SelectContactsModalController($scope, $uibModalInstance, $translate, $q, $window,
                                           BroadcastListService, ForwardMessageService, ChatCommerceService, allAttendants,
                                           $localStorage, toastr, moment, selectedMessages, communicationConstants) {
        var vm = this;

        vm.isMobile = detectar_mobile();
        vm.selectedContacts = [];
        vm.processedMessages = [];

        // Select contacts
        vm.SORTBY_VALUES = {
            'NAME': 1,
            'PHONE': 4
        };
        vm.loadingContacts = false;
        vm.loadingForwardMessages = false;
        vm.numberPerPage = [5, 10, 25, 100]
        vm.totalItems = 0;
        vm.numPerPage = 10;
        vm.maxSize = 10;
        vm.status = {
            'NEW': 'Novo',
            'OPENED': 'Aberto',
            'PENDING': 'Pendente',
            'RESOLVED': 'Resolvido',
            'EXPIRED': 'Expirado'
        }
        vm.filters = {
            "status": [
                "NEW",
                "OPENED",
                "PENDING"
            ],
            "attendants": [],
            "socialMedias": ['WATI'],
            "order": {},
            "rangeDate": null,
            "allAttendants": allAttendants.map(function(attendant) { return attendant.id }),
            "pageNumber": 0,
            "searchString": "",
            "connectedChats": {
                "isWATIConnected": true,
                "isMetaConnected": true
            }
        };
        vm.contacts = [];

        init();

        function init() {
            getContacts();
            processMessages();
            vm.modalHeight = window.innerHeight;
        }

        vm.closeModal = function (response) {
            $uibModalInstance.close(response);
        }

        function getContacts() {
            vm.loadingContacts = true;
            ChatCommerceService.getConversationsByFilter(vm.filters).then(function (response) {
                vm.contacts = vm.contacts.concat(response.data.items);
                vm.loadingContacts = false;
            });
        }

        vm.conversationsScrolledToBottom = function () {
            if (vm.loadingContacts || vm.totalItems === vm.contacts.length) return;

            vm.filters.pageNumber = vm.filters.pageNumber + 1;
            getContacts();
        }

        function processMessages() {
            selectedMessages.forEach(function (messageData, index) {
                messageData.position = index;
                if (messageData.type !== 'text') {
                    passMessageDataToBase64(messageData, function (result) {
                        var settings = makeSettingByBase64(result);
                        vm.processedMessages.push({
                            text: messageData.text ? messageData.text : '',
                            type: messageData.type,
                            media: {
                                caption: messageData.text ? messageData.text : '',
                                data: result.split('base64,')[1],
                                mimeType: settings.mimeType
                            }
                        })
                    });
                } else {
                    vm.processedMessages.push({
                        text: messageData.text,
                        type: messageData.type,
                        created: messageData.created
                    })
                }
            });
        }

        function passMessageDataToBase64(message, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', message.data);
            xhr.responseType = 'blob';
            xhr.send();
        }

        function makeSettingByBase64(base64) {
            var base = base64.split(';')[0];
            var types = communicationConstants.FILE_TYPES;
            return {
                type: types.find(function (type) {
                    return base.split('/')[1] === type.source;
                }).target, mimeType: base.split(':')[1]
            };
        }

        vm.sendMessages = function () {
            vm.loadingForwardMessages = true;
            var forwardMessagesData = {
                messages: _.sortBy(vm.processedMessages, 'created'),
                contacts: vm.selectedContacts.map(function (selectedContacts) {
                    return selectedContacts.chatUserId;
                })
            }
            ForwardMessageService.sendMessages(forwardMessagesData).then(function () {
                vm.loadingForwardMessages = false;
                toastr.success($translate.instant('communication.forward-messages-modal.request-messages.forward-messages-success'));
                vm.closeModal(forwardMessagesData);
            }).catch(function (error) {
                vm.loadingForwardMessages = false;
                toastr.error($translate.instant('communication.forward-messages-modal.request-messages.forward-messages-error'));
            });
        }

        vm.refreshContacts = function () {
            vm.contacts = [];
            getContacts();
        }

        vm.sortContactsBy = function (sortBy) {
            if (vm.filters.sortBy === vm.SORTBY_VALUES[sortBy]) {
                if (vm.filters.orderBy === 'asc') {
                    vm.filters.orderBy = 'desc';
                } else {
                    vm.filters.orderBy = 'asc';
                }
            } else {
                vm.filters.orderBy = 'asc';
            }
            vm.filters.sortBy = vm.SORTBY_VALUES[sortBy];
            getContacts();
        }

        vm.numberOfContactsLabel = function () {
            if (vm.selectedContacts.length <= 1) {
                return $translate.instant('communication.broadcast-list-modal.contact');
            } else {
                return $translate.instant('communication.broadcast-list-modal.contacts');
            }
        }

        vm.selectOne = function (contact) {
            var contactFound = vm.checkIfContactSelected(contact);

            if (!contactFound && vm.selectedContacts.length >= 5) return;

            if (contactFound) {
                _.remove(vm.selectedContacts, function (selectedContact) {
                    return selectedContact.conversationId === contact.conversationId;
                });
                contact.isSelected = false;
            } else {
                vm.selectedContacts.push(contact);
                contact.isSelected = true;
            }
        }

        vm.checkIfContactSelected = function(contact) {
            var contactFound = _.find(vm.selectedContacts, function (selectedContact) {
                return selectedContact.conversationId === contact.conversationId;
            });
            return contactFound;
        }

        vm.labelNoContactsAvailable = function () {
            return vm.contacts.length === 0 && !vm.loadingContacts && vm.filters.pageNumber === 0 && vm.filters.searchString.trim() === '';
        }

        vm.selectContactsValidation = function () {
            return vm.totalSelected() > 0;
        }

        vm.totalSelected = function () {
            return vm.selectedContacts.length;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('ForwardMessageService', ForwardMessageService);

    ForwardMessageService.$inject = ['ForwardMessageFactory'];

    function ForwardMessageService(ForwardMessageFactory) {

        var service = {
            sendMessages: sendMessages
        };

        return service;

        function sendMessages(filters){
            return ForwardMessageFactory.sendMessages(filters).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ForwardMessageFactory', ForwardMessageFactory);

    ForwardMessageFactory.$inject = ['$resource'];

    function ForwardMessageFactory($resource) {
        var resourceForwardMessage =  'admin/api/wati/forward-message';
        var resourceSendMessages = resourceForwardMessage + '/send';

        return $resource(resourceForwardMessage, {}, {
            'sendMessages': {
                method: 'POST',
                url: resourceSendMessages,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('RecommendationService', RecommendationService);

    RecommendationService.$inject = ['RecommendationFactory', '$localStorage'];

    function RecommendationService(RecommendationFactory, $localStorage) {

        var service = {
            trendRec: trendRec,
            boughtTogetherRec: boughtTogetherRec,
            clusterRec: clusterRec,
            svdRec: svdRec,
            addToRecommendationHistory: addToRecommendationHistory
        };

        return service;

        function trendRec(setting) {
            return RecommendationFactory.trendRec(setting).$promise;
        }

        function boughtTogetherRec(setting) {
            return RecommendationFactory.boughtTogetherRec(setting).$promise;
        }

        function clusterRec(setting) {
            return RecommendationFactory.cluster(setting).$promise;
        }

        function svdRec(setting) {
            return RecommendationFactory.SVD(setting).$promise;
        }

        function addToRecommendationHistory(recommendation) {
            return RecommendationFactory.recommendationHistory(recommendation).$promise;
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('RecommendationFactory', RecommendationFactory);

        RecommendationFactory.$inject = ['$resource', '$localStorage', '$window'];

    function RecommendationFactory($resource, $localStorage, $window) {
        var PORT = 5000;
        var resourceRecommendationAPI =  $window.location.protocol + '//admin.' + getDomainNameSufix($window) + ':' + PORT;
        var resourceRecommendationTrend =  resourceRecommendationAPI + '/api/v1.0/algorithm/trend';
        var resourceRecommendationBt =  resourceRecommendationAPI + '/api/v1.0/algorithm/bt';
        var resourceRecommendationCluster =  resourceRecommendationAPI + '/api/v1.0/algorithm/cluster';
        var resourceRecommendationSVD =  resourceRecommendationAPI + '/api/v1.0/algorithm/funk_svd';
        var resourceRecommendationHistory = 'flyer/api/recommendation-history';

        return $resource(resourceRecommendationAPI, {}, {
            'cluster': {
                method: 'POST',
                url: resourceRecommendationCluster,
                isArray: true
             },
             'SVD': {
                method: 'POST',
                url: resourceRecommendationSVD,
                isArray: true
             },
            'trendRec': {
                method: 'POST',
                url: resourceRecommendationTrend,
                isArray: true
            },
            'boughtTogetherRec': {
                method: 'POST',
                url: resourceRecommendationBt,
                isArray: true
            },
            'recommendationHistory': {
                method: 'POST',
                url: resourceRecommendationHistory
            },
        });
    }

})();

    (function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('RecommendationModalController', RecommendationModalController);

        RecommendationModalController.$inject = ['$uibModalInstance', '$state', '$localStorage', 'conversation',
                                                 'RecommendationService', 'FlyersService', 'ShowcasesService',
                                                 'communicationConstants', 'StoreService', '$window', 'currentCustomer'];

    function RecommendationModalController($uibModalInstance, $state, $localStorage, conversation, RecommendationService,
                                            FlyersService, ShowcasesService, communicationConstants, StoreService,
                                            $window, currentCustomer) {
        var vm = this;

        StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
            vm.storeCategory = response.data.categoryKey;
        });


        var mainColor = getComputedStyle(document.documentElement).getPropertyValue('--main-color');
        var NUMBER_REC = 10;
        vm.isWati = conversation.source === communicationConstants.SOCIAL_MEDIAS.WATI;

        vm.currentStep = 0;

        vm.trendRec = false;
        vm.boughtTogetherRec = false;
        vm.clusterRec = false;
        vm.SVDRec = false;

        vm.recommendIds = [];
        vm.recommendedFlyers = [];
        vm.excludes = [];

        vm.page = 0;
        vm.currentPage = 1;
        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: 15
        };

        vm.flyers = [];
        vm.listFilter = {
            activated: null,
            brand: "",
            type: "SALE",
            brands: [],
            storeId: $localStorage.defaultStore.storeId,
            hasInventory: true
        };

        vm.bagName = '';

        vm.closeModal = function(url) {
            $uibModalInstance.close(url);
        }

        vm.getShowcaseURL = function(idBag) {
            if (!$localStorage.defaultStore.storeNickname) {
                getStoreInfo().then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    vm.closeModal({flyers: vm.recommendedFlyers, url: $window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/bag/' + idBag, isCarousel: vm.isCarousel});
                });
            } else {
                vm.closeModal({flyers: vm.recommendedFlyers, url: $window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/bag/' + idBag, isCarousel: vm.isCarousel});
            }

        }

        vm.loadFlyers = function() {
            FlyersService.listAllToAdmin(vm.paginationOptions, vm.listFilter, function(data, headers) {
                vm.recommendedFlyers = data.content;
                vm.recommendedFlyers.forEach(function(flyer) {
                    vm.recommendIds.push(flyer.id);
                    vm.excludes.push(flyer.id);
                });
            }, function(_) {});
        }

        vm.hasSome = function (list, arr) {
            if (arr) {
                return arr.some(function (v) {
                    return list.indexOf(v) >= 0;
                });
            }
        };

        vm.selectedAll = false;
        vm.onSelectAll = function() {
            if(!vm.selectedAll) {
                vm.selectedAll = true;
                vm.excludes = [];
            } else {
                vm.selectedAll = false;
                vm.excludes = angular.copy(vm.recommendIds);
            }
        }

        vm.loadFlyers();

        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId);
        }

        getStoreInfo().then(function(response) {
            $localStorage.defaultStore.storeType = response.data.storeType;
            vm.store = response.data;
        });

        function addBagFilters(bagByRecommendation) {
            bagByRecommendation.bagFilters = {}
            bagByRecommendation.bagFilters.brands = [];
            bagByRecommendation.bagFilters.categories = [];
            bagByRecommendation.bagFilters.colors = [];
            bagByRecommendation.bagFilters.excludes = [];
            bagByRecommendation.bagFilters.genders = [];
            bagByRecommendation.bagFilters.sizes = [];
            bagByRecommendation.bagFilters.tags = [];

            return bagByRecommendation;
        }

        function getDefaultImageBagUrl() {
            if ($localStorage.defaultStore.hubId == 25) {
                return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/storepiccadilly/image_default_bag.png'
            } else {
                return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/showkase/image_default_bag.png';
            }
        }

        vm.createBagByRecommendation = function() {
            var bagByRecommendation = communicationConstants.DEFAULT_BAG;
            bagByRecommendation.converUrl = getDefaultImageBagUrl();
            var count = 1;
            vm.recommendedFlyers = vm.recommendedFlyers.filter(function(flyer) {
                return vm.checkIfFlyerSelected(flyer.id);
            });
            bagByRecommendation.flyers = vm.recommendedFlyers.map(function(flyer) {
                return {flyerId: flyer.id, position: count++}
            });
            bagByRecommendation.backgroundColor = mainColor;
            bagByRecommendation.name = vm.bagName;
            bagByRecommendation.isPrimary = false;
            bagByRecommendation = addBagFilters(bagByRecommendation);
            if(vm.bagName) {
                ShowcasesService.createBagByRecommendation(bagByRecommendation).then(function(result) {
                    vm.getShowcaseURL(result.id);
                });
                return;
            }
            vm.getShowcaseURL('');
        }

        vm.getCurrencyPrefix = function(flyer) {
            var key = flyer.currency ? flyer.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            return config.prefix;
        }

        vm.nextStep = function() {
            switch(vm.currentStep) {
                case communicationConstants.STEPS_RECOMMENDATION.FIRST:
                    /**
                     *
                     */
                    vm.currentStep = vm.currentStep + 3;
                    break;
                case communicationConstants.STEPS_RECOMMENDATION.SECOND:
                    vm.execRecommendation();
                    vm.currentStep = vm.currentStep + 1;
                    break;
                case communicationConstants.STEPS_RECOMMENDATION.THIRD:
                    vm.currentStep = vm.currentStep + 1;
                    break;
            }
        }

        vm.backStep = function() {
            switch(vm.currentStep) {
                case communicationConstants.STEPS_RECOMMENDATION.FIRST:
                    /**
                     *
                     */
                     vm.closeModal();
                     return;
                case communicationConstants.STEPS_RECOMMENDATION.FOURTH:
                    vm.currentStep = vm.currentStep - 3;
                    break;
                default:
                    vm.currentStep = vm.currentStep - 1;
                    break;
            }

        }

        vm.recommendIds = [];
        vm.recommendedFlyers = [];

        vm.postRecommendationHistory = function(algo, recommendations) {
            vm.recommendationHistory = {
                algoritmo: algo,
                recomendacoes: recommendations,
                userId: currentCustomer.id,
                timestamp: new Date()
            };
            RecommendationService.addToRecommendationHistory(vm.recommendationHistory);
        }

        vm.execRecommendation = function() {

            RecommendationService.trendRec({rec_number: NUMBER_REC, user_id: currentCustomer.id}).then(function(items) {
                vm.postRecommendationHistory(communicationConstants.RECOMMENDATION_TYPES.TREND, items);
                if(vm.trendRec && vm.boughtTogetherRec) {
                    var requests = items.map(function(id) {
                        vm.recommendIds.push(id);
                        return RecommendationService.boughtTogetherRec({rec_number: NUMBER_REC, flyer_id: id, user_id: currentCustomer.id});
                    });

                    Promise.all(requests)
                        .then(function(result) {
                            var btIds = [];
                            result.forEach(function(item) {
                                vm.recommendIds = vm.recommendIds.concat(item);
                                btIds = btIds.concat(item)
                            });
                            vm.postRecommendationHistory(communicationConstants.RECOMMENDATION_TYPES.BOUGHT_TOGETHER, btIds);

                            FlyersService.findFlyersByIds(vm.recommendIds).then(function(flyers) {
                                vm.recommendedFlyers = vm.recommendedFlyers.concat(flyers);
                            });
                        });
                } else {
                    FlyersService.findFlyersByIds(items).then(function(flyers) {
                        flyers.forEach(function(flyer) {
                            vm.recommendIds.push(flyer.id);
                        });
                        vm.recommendedFlyers = vm.recommendedFlyers.concat(flyers);
                    });
                }
            });

            if (vm.clusterRec) {
                RecommendationService.clusterRec({rec_number: NUMBER_REC, user_id: currentCustomer.id}).then(function(items) {
                    vm.postRecommendationHistory(communicationConstants.RECOMMENDATION_TYPES.CLUSTER, items);
                    vm.recommendIds = vm.recommendIds.concat(items);
                    FlyersService.findFlyersByIds(vm.recommendIds).then(function(flyers) {
                        vm.recommendedFlyers = vm.recommendedFlyers.concat(flyers);
                    });
                });
            }

            if (vm.SVDRec) {
                RecommendationService.svdRec({rec_number: NUMBER_REC, user_id: currentCustomer.id}).then(function(items) {
                    vm.postRecommendationHistory(communicationConstants.RECOMMENDATION_TYPES.FUNKSVD, items);
                    vm.recommendIds = vm.recommendIds.concat(items);
                    FlyersService.findFlyersByIds(vm.recommendIds).then(function(flyers) {
                        vm.recommendedFlyers = vm.recommendedFlyers.concat(flyers);
                    });
                });
            }

        }

        vm.checkIfFlyerSelected = function(idFlyer) {
            var result = !vm.excludes.includes(idFlyer);
            return result;
        }

        vm.refreshSelectedFlyers = function(flyer) {
            var index = vm.excludes.indexOf(flyer.id);
            if(index >= 0) {
                vm.excludes.splice(index, 1);
                return;
            }
            vm.selectedAll = false;
            vm.excludes.push(flyer.id);
        }

    }

})();

/* globals $ */
(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .filter('tel', function () {
            return function (input) {
                if (input.startsWith('+55')) {
                    var str = input + '';
                    str = str.replace(/\D/g, '');
                    if (str.length === 13) {
                        str = str.replace(/^(\d\d)(\d\d)(\d{5})(\d{4}).*/, "+$1 ($2) $3-$4");
                    } else {
                        str = str.replace(/^(\d\d)(\d\d)(\d{4})(\d{4}).*/, '+$1 ($2) $3-$4');
                    }
                    return str;
                } else {
                    return input
                }

            };
        });
})();


/* globals $ */
(function() {
	'use strict';

	angular.module("showcaseApp").directive("ngUploadChange",function(){
        return{
            scope:{
                ngUploadChange:"&"
            },
            link:function($scope, $element, $attrs){
                $element.on("change", function(event){
                    $scope.$apply(function(){
                        $scope.ngUploadChange({$event: event})

                        var list = new DataTransfer();
                        var myFileList = list.files;

                        event.target.files = myFileList;
                    })
                })

                $scope.$on("$destroy",function(event){
                    $element.files = [];
                    $element.off();
                });
            }
        }
    });
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('NoteTagService', NoteTagService);

        NoteTagService.$inject = ['NoteTagFactory'];

    function NoteTagService(NoteTagFactory) {

        var service = {
            createNoteTag: createNoteTag,
            getNotesTags: getNotesTags,
            deleteNoteTag: deleteNoteTag,
            updateNote: updateNote
        };

        return service;

        function createNoteTag(NoteTag) {
            return NoteTagFactory.createNoteTag(NoteTag).$promise;
        }

        function getNotesTags(customerId){
            return NoteTagFactory.getNotesTags({customerId: customerId}).$promise;
        }

        function deleteNoteTag(noteTagId){
            return NoteTagFactory.deleteNoteTag({noteTagId: noteTagId}).$promise;
        }

        function updateNote(newNote){
            return NoteTagFactory.updateNote({noteId: newNote.noteId, text: newNote.text}).$promise;
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('NoteTagFactory', NoteTagFactory);

        NoteTagFactory.$inject = ['$resource'];

    function NoteTagFactory($resource) {
        var resourceNoteTag =  'admin/api/note-tag';
        var resourceNewNoteTag = resourceNoteTag + '/new-note-tag';
        var resourceGetCustomerNotes = resourceNoteTag + '/customer-notes/:customerId';
        var resourceDeleteNoteTag = resourceNoteTag + '/:noteTagId';
        var resourceUpdateNote = resourceNoteTag + '/update-note';

        return $resource(resourceNoteTag, {}, {

            'createNoteTag': {
                method: 'POST',
                url: resourceNewNoteTag,
            },

            'getNotesTags':{
                method: 'GET',
                url: resourceGetCustomerNotes,
                isArray: true,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }                    
                    response.headers = headers();
                    return response;
                }
            },

            'deleteNoteTag': {
                method: 'DELETE',
                url: resourceDeleteNoteTag
                
            },

            'updateNote': {
                method: 'PUT',
                url: resourceUpdateNote
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('NewConversationController', NewConversationController);

        NewConversationController.$inject = ['watiSetting', '$uibModalInstance', '$translate', 'WatiService', '$localStorage', 'toastr', 'MessengerService'];

    function NewConversationController(watiSetting, $uibModalInstance, $translate, WatiService, $localStorage, toastr, MessengerService) {

        var vm = this;
        vm.watiSetting = watiSetting;

        vm.specialKey = '{{ }}';

        vm.templates = [];
        vm.originalTemplates = [];

        vm.step = 0;

        vm.currentTemplate;

        vm.customer = {};

        vm.isFb = false;

        vm.phone = '';

        vm.isConnectedToWati = vm.watiSetting;

        vm.loadingTemplates = false;

        var storeId = $localStorage.defaultStore.storeId;

        searchTemplateMessages();

        function searchTemplateMessages() {
            vm.loadingTemplates = true;
            var promise = WatiService.searchTemplateMessages(100, 0);
            var callback = function(result) {
                vm.templates = result.data.messageTemplates;
                vm.originalTemplates = angular.copy(vm.templates);
                vm.loadingTemplates = false;
            }
            promise.then(callback).catch(function(err) {
                promise.then(callback);
            });

        }

        vm.nextStep = function() {
            if(vm.step === 0 && (vm.phone || vm.selectedCustomerToSendMessage.phone) ) {
                vm.step = 1;
                return;
            } else if(vm.step === 1 && vm.currentTemplate) {
                vm.step = 2;
                return;
            }
        }

        vm.previousStep = function() {
            if(vm.step === 2 && vm.isFb) {
                vm.step = vm.step - 2;
                vm.isFb = false;
            } else {
                vm.step = vm.step - 1;
            }

        }

        vm.closeModal = function(response) {
            $uibModalInstance.close(response);
        }

        vm.onSelectTemplate = function(template) {
            if(vm.currentTemplate && vm.currentTemplate.id === template.id) {
                vm.currentTemplate = null;
                return;
            }
            vm.currentTemplate = template;
            vm.bodyOriginal = vm.currentTemplate.bodyOriginal;
            vm.params = {};
        }

        vm.makeParamNameWithKeys = function(paramName) {
            return '{{' + paramName + '}}';
        }

        vm.changeParamValue = function(paramName) {
            updateTemplateBody(vm.params[paramName]);
        }

        function updateTemplateBody() {
            var keys = Object.keys(vm.params).join('|');
            var regex = new RegExp(keys, 'gi');
            vm.currentTemplate.bodyOriginal = vm.bodyOriginal.replace(regex, function(matched) {
                return vm.params[matched].value || matched;
            });
        }

        vm.selectedCustomer = function (item) {
            vm.selectedCustomerToSendMessage = item.originalObject;
            if(vm.phone || vm.selectedCustomerToSendMessage.phone || vm.selectedCustomerToSendMessage.facebookInstagramId) {
                if(vm.selectedCustomerToSendMessage.facebookInstagramId) {
                    vm.isFb = true;
                    vm.step = 2;
                    return;
                }
                if (!vm.isConnectedToWati) {
                    toastr.warning($translate.instant('communication.new-conversation.connectToWati'));
                    return;
                } else {
                    vm.step = 1;
                    return;
                }

            }
            toastr.warning($translate.instant('communication.new-conversation.noFbAndWhatsapp'));
        }

        vm.changeCustomer = function (value) {
            if (value) {
                vm.customer.fullName = value.trim();
            } else {
                vm.customer.fullName = null;
            }
        }

        vm.requestParams = function (query) {
            return {
                page: 0,
                size: 10,
                storeId: storeId,
                search: query
            }
        }

        function removeNine(numberWithNine) {
            if (numberWithNine.includes('+55') && numberWithNine.length === 14) {
                numberWithNine = numberWithNine.substring(0, 5) + numberWithNine.substring(6, numberWithNine.length);
            }
            return numberWithNine;
        }

        vm.sendTemplate = function() {
            if(vm.isFb && vm.tagMessage) {
                MessengerService.sendMessage(vm.tagMessage, vm.selectedCustomerToSendMessage.facebookInstagramId, 'MESSAGE_TAG').then(function() {
                    toastr.success($translate.instant('communication.new-conversation.success'));
                    vm.closeModal({user: vm.selectedCustomerToSendMessage.facebookInstagramId, message: vm.tagMessage, type: 'facebok'});
                });
                return;
            }

            var parameters = [];
            vm.currentTemplate.customParams.forEach(function(param) {
                parameters.push({name: param.paramName, value: vm.params[vm.makeParamNameWithKeys(param.paramName)] ? vm.params[vm.makeParamNameWithKeys(param.paramName)].value : param.paramValue});
            });

            WatiService.sendTemplateMessage(vm.currentTemplate.elementName, parameters, vm.phone || vm.selectedCustomerToSendMessage.phone).then(function(result) {
                toastr.success($translate.instant('communication.new-conversation.success'));
                vm.closeModal({user: vm.phone || vm.selectedCustomerToSendMessage.phone, message: vm.currentTemplate, type: 'wati'});
            });
        }

        vm.localSearch = function() {
            vm.templates = vm.originalTemplates.filter(function(template) {
                return template.elementName.replaceAll('_', ' ').toUpperCase().includes(vm.search.toUpperCase());
            });
        }

        vm.paramIsInBody = function(param) {
            return vm.currentTemplate.bodyOriginal.includes('{{' + param.paramName + '}}');
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('SendImagesModalController', SendImagesModalController);

    SendImagesModalController.$inject = ['$uibModalInstance', '$timeout', '$scope', '$window', 'images', 'conversation', 'communicationConstants',
                                        'ImageManagerService'];

    function SendImagesModalController($uibModalInstance, $timeout, $scope, $window, images, conversation, communicationConstants, ImageManagerService) {

        var vm = this;

        vm.imagesToSend = images;
        vm.selectedImage = vm.imagesToSend[0];
        vm.conversation = conversation;
        vm.supportedImagesType = communicationConstants.SUPPORTED_IMAGES_TYPES;

        vm.closeAndSendFile = function() {
            clearInput();
            $uibModalInstance.close(vm.imagesToSend);
        }

        vm.dismiss = function() {
            clearInput();
            $uibModalInstance.dismiss();
        }

        vm.openImageSelect = function () {
            angular.element('#more-image-upload-sheet').trigger('click');
        }

        vm.removeImage = function (index) {
            _.remove(vm.imagesToSend, function (image) {
               return image.index === index;
            });

            if (vm.imagesToSend.length === 0) {
                clearInput();
                $uibModalInstance.dismiss();
            }
        }

        vm.addMoreImages = function (event) {
            var images = event.target.files;
            Array.from(images).forEach(function (file, index) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    var imageBlob = dataURItoBlob(reader.result);
                    var setting = makeSettingByBase64(reader.result);

                    var img = new Image();
                    img.onload = function (evt) {
                        var dataurl = reader.result;

                        if (img.width > 2560 || img.height > 1440) {
                            dataurl = ImageManagerService.handleImageSize(img, file);
                        }

                        vm.imagesToSend.push({
                            index: vm.imagesToSend[vm.imagesToSend.length - 1].index + 1,
                            name: file.name,
                            base64: dataurl.split(',')[1],
                            fullBase64: dataurl,
                            type: setting.type,
                            mimeType: setting.mimeType,
                            blob: imageBlob
                        });

                        $scope.$apply();
                    };
                    img.src = reader.result;
                }
            });
        }

        function makeSettingByBase64(base64) {
            var base = base64.split(';')[0];
            var types = communicationConstants.FILE_TYPES;
            return {
                type: types.find(function (type) {
                    return base.split('/')[1] === type.source;
                }).target, mimeType: base.split(':')[1]
            };
        }

        function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            var blob = new Blob([ia], {
                type: mimeString
            });

            return $window.URL.createObjectURL(blob);
        }

        function clearInput() {
            var fileInput = document.getElementById('file-upload');
            var fileInputInSheet = document.getElementById('file-upload-sheet');
            if (fileInput) {
                fileInput.value = null;
            } else {
                fileInputInSheet.value = null;
            }

            angular.forEach(
                angular.element("input[type='file']"),
                function(inputElem) {
                    angular.element(inputElem).val(null);
                }
            );
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ModalFileController', ModalFileController);

    ModalFileController.$inject = ['$uibModalInstance', 'file', 'conversation'];

    function ModalFileController($uibModalInstance, file, conversation) {

        var vm = this;

        vm.file = file;
        vm.file.caption = '';
        vm.conversation = conversation;

        vm.closeAndSendFile = function() {
            clearInput();
            $uibModalInstance.close(vm.file);
        }

        vm.dismiss = function() {
            clearInput();
            $uibModalInstance.dismiss();
        }

        function clearInput() {
            var fileInput = document.getElementById('file-upload');
            var fileInputInSheet = document.getElementById('file-upload-sheet');
            if (fileInput) {
                fileInput.value = null;
            } else {
                fileInputInSheet.value = null;
            }
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ModalAudioController', ModalAudioController);

    ModalAudioController.$inject = ['$scope', '$uibModal', '$uibModalInstance'];

    function ModalAudioController($scope, $uibModal, $uibModalInstance) {
        var vm = this;

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.exclude = function() {
            $uibModalInstance.close(false);
        }

        vm.closeModal = function() {
            $uibModalInstance.dismiss();
        }
    }

})();

(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .factory("AudioModalFactory", AudioModalFactory);


    /** @ngInject */
    function AudioModalFactory($uibModal)  {

        var factory = {
            confirmAction: confirmAction
        };

        return factory;

        function confirmAction() {
            return $uibModal.open({
                templateUrl: 'app/admin/communication/modal-audio/modal-audio.modal.html',
                controller: 'ModalAudioController',
                controllerAs: 'vm',
                size: 'md'
            }).result;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('MediaDeviceService', MediaDeviceService);

    function MediaDeviceService() {
        var service = {
            getAudioRecorder: getAudioRecorder,
            verifyMicrophonePermission: verifyMicrophonePermission,
            requestMicrophonePermission: requestMicrophonePermission
        };

        function requestMicrophonePermission() {
            return new Promise(function (resolve, reject) {
                navigator.mediaDevices.getUserMedia({ audio: true })
                    .then(function (stream) {
                        resolve(stream != null || stream != undefined);
                    }, function (err) {
                        reject(err.name);
                    });
            });
        }

        function verifyMicrophonePermission() {
            return new Promise(function (resolve, reject) {
                navigator.permissions.query({name: 'microphone'})
                    .then(function(permissionObj) {
                        resolve(permissionObj.state);
                    })
                    .catch(function(error) {
                        reject(error.name);
                    })
            });
        }

        function getAudioRecorder() {
            return new Promise(function (resolve, reject) {
                navigator.mediaDevices.getUserMedia({ audio: true })
                    .then(function (stream) {
                        var mediaRecorder = new MediaRecorder(stream);
                        var audioChunks = [];

                        mediaRecorder.addEventListener('dataavailable', function(event) {
                            audioChunks.push(event.data);
                        });

                        var start = function() {
                            mediaRecorder.start();
                        };

                        var stop = function() {
                            return new Promise(function (resolve, reject) {
                                mediaRecorder.addEventListener('stop', function() {
                                    var audioBlob = new Blob(audioChunks, { type: 'audio/mpeg' });
                                    var audioUrl = URL.createObjectURL(audioBlob);
                                    var audio = new Audio(audioUrl);
                                    var play = function() {
                                        audio.play();
                                    };
                                    // deactivate mic.
                                    stream.getTracks().forEach(function(track) {
                                        track.stop();
                                    });
                                    resolve({ audioBlob: audioBlob, audioUrl: audioUrl, play: play });
                                });
                                mediaRecorder.stop();
                            });
                        };

                        var deactivateMicrophone = function() {
                            stream.getTracks().forEach(function(track) {
                                track.stop();
                            });
                        }

                        resolve({ start: start, stop: stop, deactivateMicrophone: deactivateMicrophone });
                    }, function (err) {
                        console.log(err);
                        reject(err.name);
                    });
            });
        }

        return service;

    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('MagicService', MagicService);

    MagicService.$inject = ['MagicFactory', '$localStorage'];

    function MagicService(MagicFactory, $localStorage) {

        var service = {
            trendRec: trendRec,
            boughtTogetherRec: boughtTogetherRec,
            clusterRec: clusterRec,
            svdRec: svdRec,
            addToRecommendationHistory: addToRecommendationHistory
        };

        return service;

        function trendRec(setting) {
            return MagicFactory.trendRec(setting).$promise;
        }

        function boughtTogetherRec(setting) {
            return MagicFactory.boughtTogetherRec(setting).$promise;
        }

        function clusterRec(setting) {
            return MagicFactory.cluster(setting).$promise;
        }

        function svdRec(setting) {
            return MagicFactory.SVD(setting).$promise;
        }

        function addToRecommendationHistory(recommendation) {
            return MagicFactory.recommendationHistory(recommendation).$promise;
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('MagicFactory', MagicFactory);

        MagicFactory.$inject = ['$resource', '$localStorage', '$window'];

    function MagicFactory($resource, $localStorage, $window) {
        var PORT = 5000;
        var resourceRecommendationAPI =  $window.location.protocol + '//admin.' + getDomainNameSufix($window) + ':' + PORT;
        var resourceRecommendationTrend =  resourceRecommendationAPI + '/api/v1.0/algorithm/trend';
        var resourceRecommendationBt =  resourceRecommendationAPI + '/api/v1.0/algorithm/bt';
        var resourceRecommendationCluster =  resourceRecommendationAPI + '/api/v1.0/algorithm/cluster';
        var resourceRecommendationSVD =  resourceRecommendationAPI + '/api/v1.0/algorithm/funk_svd';
        var resourceRecommendationHistory = 'flyer/api/recommendation-history';

        return $resource(resourceRecommendationAPI, {}, {
            'cluster': {
                method: 'POST',
                url: resourceRecommendationCluster,
                isArray: true
             },
             'SVD': {
                method: 'POST',
                url: resourceRecommendationSVD,
                isArray: true
             },
            'trendRec': {
                method: 'POST',
                url: resourceRecommendationTrend,
                isArray: true
            },
            'boughtTogetherRec': {
                method: 'POST',
                url: resourceRecommendationBt,
                isArray: true
            },
            'recommendationHistory': {
                method: 'POST',
                url: resourceRecommendationHistory
            },
        });
    }

})();

    (function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('MagicModalController', MagicModalController);

        MagicModalController.$inject = ['$uibModalInstance', '$state', '$localStorage',
                                                 'MagicService', 'FlyersService', 'ShowcasesService',
                                                 'communicationConstants', 'StoreService', '$window', 'currentCustomer', 'toastr'];

    function MagicModalController($uibModalInstance, $state, $localStorage, MagicService,
                                            FlyersService, ShowcasesService, communicationConstants, StoreService,
                                            $window, currentCustomer, toastr) {
        var vm = this;

        var mainColor = getComputedStyle(document.documentElement).getPropertyValue('--main-color');
        var NUMBER_REC = 10;

        StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
            vm.storeCategory = response.data.categoryKey;
        });

        vm.currentStep = 1;

        vm.trendRec = false;
        vm.boughtTogetherRec = true;
        vm.clusterRec = false;
        vm.SVDRec = false;

        vm.recommendIds = [];
        vm.recommendedFlyers = [];
        vm.excludes = [];

        vm.page = 0;
        vm.currentPage = 1;
        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: 15
        };

        vm.selectedAll = false;

        vm.flyers = [];
        vm.listFilter = {
            activated: null,
            brand: "",
            type: "SALE",
            brands: [],
            storeId: $localStorage.defaultStore.storeId,
            hasInventory: true
        };

        vm.bagName = '';

        vm.closeModal = function(url) {
            $uibModalInstance.close(url);
        }

        vm.getShowcaseURL = function(idBag) {
            if (!$localStorage.defaultStore.storeNickname) {
                getStoreInfo().then(function(response) {
                    if (response && response.data) {
                        $localStorage.defaultStore.storeNickname = response.data.nickname;
                    }
                    vm.closeModal({flyers: vm.recommendedFlyers, url: $window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/bag/' + idBag, isCarousel: vm.isCarousel});
                });
            } else {
                vm.closeModal({flyers: vm.recommendedFlyers, url: $window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/bag/' + idBag, isCarousel: vm.isCarousel});
            }

        }

        vm.loadFlyers = function() {
            FlyersService.listAllToAdmin(vm.paginationOptions, vm.listFilter, function(data, headers) {
                vm.recommendedFlyers = data.content;
                vm.recommendedFlyers.forEach(function(flyer) {
                    vm.recommendIds.push(flyer.id);
                    vm.excludes.push(flyer.id);
                });
            }, function(_) {});
        }

        vm.hasSome = function (list, arr) {
            if (arr) {
                return arr.some(function (v) {
                    return list.indexOf(v) >= 0;
                });
            }
        };

        vm.onSelectAll = function() {
            if(!vm.selectedAll) {
                vm.selectedAll = true;
                vm.excludes = [];
            } else {
                vm.selectedAll = false;
                vm.excludes = angular.copy(vm.recommendIds);
            }
        }

        vm.loadFlyers();

        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId);
        }

        getStoreInfo().then(function(response) {
            $localStorage.defaultStore.storeType = response.data.storeType;
            vm.store = response.data;
            vm.getCurrencyPrefix(vm.store);
        });

        vm.getCurrencyPrefix = function(flyer) {
            var key = flyer.currency ? flyer.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            return config.prefix;
        }

        function addBagFilters(bagByRecommendation) {
            bagByRecommendation.bagFilters = {}
            bagByRecommendation.bagFilters.brands = [];
            bagByRecommendation.bagFilters.categories = [];
            bagByRecommendation.bagFilters.colors = [];
            bagByRecommendation.bagFilters.excludes = [];
            bagByRecommendation.bagFilters.genders = [];
            bagByRecommendation.bagFilters.sizes = [];
            bagByRecommendation.bagFilters.tags = [];

            return bagByRecommendation;
        }

        function getDefaultImageBagUrl() {
            if ($localStorage.defaultStore.hubId == 25) {
                return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/storepiccadilly/image_default_bag.png'
            } else {
                return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/showkase/image_default_bag.png';
            }
        }

        vm.createBagByRecommendation = function() {
            var bagByRecommendation = communicationConstants.DEFAULT_BAG;
            bagByRecommendation.coverUrl = getDefaultImageBagUrl();
            var count = 1;
            vm.recommendedFlyers = vm.recommendedFlyers.filter(function(flyer) {
                return vm.checkIfFlyerSelected(flyer.id);
            });
            bagByRecommendation.flyers = vm.recommendedFlyers.map(function(flyer) {
                return {flyerId: flyer.id, position: count++}
            });
            bagByRecommendation.backgroundColor = mainColor;
            bagByRecommendation.name = vm.bagName;
            bagByRecommendation.isPrimary = false;
            bagByRecommendation = addBagFilters(bagByRecommendation);
            bagByRecommendation.isAllProductsSelected = vm.selectedAll;
            if(vm.bagName) {
                ShowcasesService.createBagByRecommendation(bagByRecommendation).then(function(result) {
                    vm.getShowcaseURL(result.id);
                });
                return;
            }
            vm.getShowcaseURL('');
        }

        vm.nextStep = function() {
            switch(vm.currentStep) {
                case communicationConstants.STEPS_RECOMMENDATION.FIRST:
                    if(vm.trendRec || vm.clusterRec || vm.SVDRec) {
                        vm.execRecommendation();
                        vm.currentStep = vm.currentStep + 1;
                        break;
                    }
                    toastr.warning('Selecione pelo menos um algorítmo.');
                    break;
                case communicationConstants.STEPS_RECOMMENDATION.SECOND:
                    var items = vm.recommendedFlyers.filter(function(flyer) {
                        return vm.checkIfFlyerSelected(flyer.id);
                    });
                    if(items.length === 0) {
                        toastr.warning('Selecione pelo menos um produto.');
                        break;
                    }
                    vm.currentStep = vm.currentStep + 1;
                    break;
            }
        }

        vm.backStep = function() {
            switch(vm.currentStep) {
                case communicationConstants.STEPS_RECOMMENDATION.FIRST:
                     vm.closeModal();
                     return;
                default:
                    vm.currentStep = vm.currentStep - 1;
                    break;
            }

        }

        vm.postRecommendationHistory = function(algo, recommendations) {
            vm.recommendationHistory = {
                algoritmo: algo,
                recomendacoes: recommendations,
                userId: currentCustomer.id,
                timestamp: new Date()
            };
            MagicService.addToRecommendationHistory(vm.recommendationHistory);
        }

        /**
         * Execute all requests to sk_service.
         */
        vm.execRecommendation = function() {

            MagicService.trendRec({rec_number: NUMBER_REC, user_id: currentCustomer.id}).then(function(items) {
                vm.postRecommendationHistory(communicationConstants.RECOMMENDATION_TYPES.TREND, items);
                if(vm.trendRec && vm.boughtTogetherRec) {
                    var requests = items.map(function(id) {
                        vm.recommendIds.push(id);
                        return MagicService.boughtTogetherRec({rec_number: NUMBER_REC, flyer_id: id, user_id: currentCustomer.id});
                    });

                    Promise.all(requests)
                        .then(function(result) {
                            var btIds = [];
                            result.forEach(function(item) {
                                vm.recommendIds = vm.recommendIds.concat(item);
                                btIds = btIds.concat(item)
                            });
                            vm.postRecommendationHistory(communicationConstants.RECOMMENDATION_TYPES.BOUGHT_TOGETHER, btIds);

                            FlyersService.findFlyersByIds(vm.recommendIds).then(function(flyers) {
                                vm.recommendedFlyers = vm.recommendedFlyers.concat(flyers);
                            });
                        });
                } else {
                    FlyersService.findFlyersByIds(items).then(function(flyers) {
                        flyers.forEach(function(flyer) {
                            vm.recommendIds.push(flyer.id);
                        });
                        vm.recommendedFlyers = vm.recommendedFlyers.concat(flyers);
                    });
                }
            });

            if (vm.clusterRec) {
                MagicService.clusterRec({rec_number: NUMBER_REC, user_id: currentCustomer.id}).then(function(items) {
                    vm.postRecommendationHistory(communicationConstants.RECOMMENDATION_TYPES.CLUSTER, items);
                    vm.recommendIds = vm.recommendIds.concat(items);
                    FlyersService.findFlyersByIds(vm.recommendIds).then(function(flyers) {
                        vm.recommendedFlyers = vm.recommendedFlyers.concat(flyers);
                    });
                });
            }

            if (vm.SVDRec) {
                MagicService.svdRec({rec_number: NUMBER_REC, user_id: currentCustomer.id}).then(function(items) {
                    vm.postRecommendationHistory(communicationConstants.RECOMMENDATION_TYPES.FUNKSVD, items);
                    vm.recommendIds = vm.recommendIds.concat(items);
                    FlyersService.findFlyersByIds(vm.recommendIds).then(function(flyers) {
                        vm.recommendedFlyers = vm.recommendedFlyers.concat(flyers);
                    });
                });
            }

        }

        vm.checkIfFlyerSelected = function(idFlyer) {
            var result = !vm.excludes.includes(idFlyer);
            return result;
        }

        vm.refreshSelectedFlyers = function(flyer) {
            var index = vm.excludes.indexOf(flyer.id);
            if(index >= 0) {
                vm.excludes.splice(index, 1);
                return;
            }
            vm.selectedAll = false;
            vm.excludes.push(flyer.id);
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('LogoutModalController', LogoutModalController);

        LogoutModalController.$inject = ['$uibModalInstance', 'watiSettingId', 'socialMedia', 'WatiService', 'SocialMediaService', 'communicationConstants'];

    function LogoutModalController($uibModalInstance, watiSettingId, socialMedia, WatiService, SocialMediaService, communicationConstants) {
        var vm = this;

        if(socialMedia == communicationConstants.SOCIAL_MEDIAS.WATI){
            vm.logoutSocialMediaText = "WhatsApp Bussiness API";
            vm.socialMedia = "WATI";
        } else if(socialMedia == communicationConstants.SOCIAL_MEDIAS.FACEBOOK) {
            vm.logoutSocialMediaText = "Facebook/Instagram";
            vm.socialMedia = "FACEBOOK";
        }

        vm.closeModal = function(response) {
            $uibModalInstance.close(response);
        }

        vm.logoutOfWhatsapp = function(){
            WatiService.deleteConfigByStoreId(watiSettingId).then(function(watiConfig){
                vm.closeModal({isLogginOut: true, socialMedia: communicationConstants.SOCIAL_MEDIAS.WATI});
            })
        };

        vm.facebookDisconnect = function(){
            SocialMediaService.facebookDisconnect().then(function(response){
                vm.closeModal({isLogginOut: true, socialMedia: communicationConstants.SOCIAL_MEDIAS.FACEBOOK});
            });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('LocationChatController', LocationChatController);

    LocationChatController.$inject = ['$uibModalInstance', '$localStorage', 'StoreService'];

    function LocationChatController($uibModalInstance, $localStorage, StoreService) {

        var vm = this;
        var storeId = $localStorage.defaultStore.storeId;
        vm.pointSelected = null;
        const URL_MAP = 'https://www.google.com/maps?saddr=My+Location&daddr='


        loadAll();

        function loadAll() {
            StoreService.getSalesPoints(storeId).then(function (response) {
                vm.salesPoint = response.data;
            });
        }

        vm.closeModal = function () {
            $uibModalInstance.close();
        }

        vm.addPoint = function () {
            const number = vm.pointSelected.number  ? vm.pointSelected.number + ', ' : '';
            const neighborhood = vm.pointSelected.neighborhood ? vm.pointSelected.neighborhood + ', ' : '';
            const andress = vm.pointSelected.name + '\n' + 
            vm.pointSelected.address + ', ' + number + 
            neighborhood + vm.pointSelected.city + '/' + 
            vm.pointSelected.state + ', ' + vm.zipCodeMask(vm.pointSelected.postalCode) + '\n' +
            '\nAcesse a rota através do link:\n';
            $uibModalInstance.close(andress + buildUrlMap());
        }

        vm.selectPoint = function (point) {
            point.selected = true;
            vm.salesPoint.forEach(function (salesPoint) {
                if (salesPoint.id != point.id) {
                    salesPoint.selected = false;
                }
            });

            vm.pointSelected = point;
        }

        function buildUrlMap() {
            const point = vm.pointSelected.coordinate.latitude + ',' + vm.pointSelected.coordinate.longitude;
            return URL_MAP + point;
        }

        vm.zipCodeMask = function (value) {
            if (!value) return ""
            value = value.replace(/\D/g,'')
            value = value.replace(/(\d{5})(\d)/,'$1-$2')
            return value
          }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FiltersConversationController', FiltersConversationController);

        FiltersConversationController.$inject = ['$uibModalInstance', '$translate', 'WatiService', '$localStorage', 'toastr', 'MessengerService', 'attendants', 'filters', 'isWatiConnected', 'isFacebookConnected'];

    function FiltersConversationController($uibModalInstance, $translate, WatiService, $localStorage, toastr, MessengerService, attendants, filters, isWatiConnected, isFacebookConnected) {

        var vm = this;

        vm.filters = filters;
        vm.isFacebookConnected = isFacebookConnected;
        vm.isWatiConnected = isWatiConnected;
        vm.maxDate = moment();

        vm.status = [
            {value: "EXPIRED", label: "Expirado", id: 1},
            {value: "NEW", label: "Novo", id: 2},
            {value: "OPENED", label: "Aberto", id: 3},
            {value: "PENDING", label: "Pendente", id: 4},
            {value: "RESOLVED", label: "Resolvido", id: 5}
        ];

        vm.orderFields = [
            {label: "Não lidas", value: {field: "unread_messages", direction: "DESC"}, id: 1},
            {label: "Lidas", value: {field: "unread_messages", direction: "ASC"}, id: 2},
            {label: "Mais antigas", value: {field: "timestamp", direction: "ASC"}, id: 3},
            {label: "Mais recentes", value: {field: "timestamp", direction: "DESC"}, id: 4}
        ];

        vm.attendants = attendants;

        var dateFormat = "DD/MM/YYYY";
        vm.dateRangeOptions = {
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Aplicar",
                fromLabel: "From",
                format: dateFormat,
                toLabel: "To",
                cancelLabel: 'Cancelar',
                customRangeLabel: 'Personalizado'
            },
            ranges: {
                'Desde de ontem': [moment().subtract(1, 'days'), moment(new Date())],
                'Últimos 7 dias': [moment().subtract(7, 'days'), moment()],
                'Últimos 30 dias': [moment().subtract(30, 'days'), moment()],
                'Último ano': [moment().subtract(1, 'year'), moment()]
            },
            eventHandlers: {
                'apply.daterangepicker': function (ev, picker) {
                }
            },
            alwaysShowCalendars: true
        };
        vm.dateRange = null;

        vm.closeModal = function(response) {
            $uibModalInstance.close(response);
        }

        vm.closeDropDown = function () {
            $("md-backdrop").trigger('click');
        }

        vm.getSelectedText = function (filter) {

            if (filter.length === 0) return '';
            var elementTranslate = filter[0].label;

            if (filter.length == 1) {
                return '<span class="highlight">' + elementTranslate + '</span>';
            }
            if (filter.length > 1) {
                var temp = '  +';
                temp += filter.length - 1;
                temp += ' selecionados';

                return '<span class="highlight">' + elementTranslate + '</span>' +
                    '<span>&nbsp</span>' +
                    '<span class="highlight">' + temp + '</span>';
            }
            return '';
        }

        function makeLists() {
            var attendants = []
            vm.attendants.forEach(function(attendant) {
                attendants.push({label: attendant.firstName + " " + attendant.lastName, value: attendant.id})
            });
            vm.attendants = attendants;

            var socialMedias = []

            if (isWatiConnected) {
                socialMedias.push({ label: "WhatsApp", value: "WATI", id: 1 })
            }
            if (isFacebookConnected) {
                socialMedias.push({ label: "Messenger", value: "MESSENGER", id: 2 })
                socialMedias.push({ label: "Instagram", value: "INSTAGRAM", id: 3 })
            }

            vm.socialMedias = socialMedias;
        }

        makeLists();

        vm.clearFilters = function () {
            vm.filters = {
                status: [{
                    "value": "EXPIRED",
                    "label": "Expirado",
                    "id": 1
                },
                    {
                        "value": "NEW",
                        "label": "Novo",
                        "id": 2
                    },
                    {
                        "value": "OPENED",
                        "label": "Aberto",
                        "id": 3
                    },
                    {
                        "value": "PENDING",
                        "label": "Pendente",
                        "id": 4
                    }],
                attendants: [],
                socialMedias: [],
                rangeDate: {startDate: null, endDate: null},
                order: {}
            };
        }

        vm.apllyFilters = function () {
            var filters = angular.copy(vm.filters);
            filters.order = filters.order.value ? filters.order.value : {};
            filters.attendants = filters.attendants.map(function(attendant){ return attendant.value });
            filters.status = filters.status.map(function(status){ return status.value });
            filters.socialMedias = filters.socialMedias.map(function(socialMedia){ return socialMedia.value });
            filters.rangeDate = filters.rangeDate.startDate && filters.rangeDate.endDate ? formatDate(filters.rangeDate.startDate, filters.rangeDate.endDate) : null;
            filters.allAttendants = attendants.map(function(attendant) { return attendant.id })
            vm.closeModal({filtered: filters, selectedFilters: angular.copy(vm.filters)});
        }

        function formatDate(startDate, endDate) {
            var start = startDate.format('YYYY-MM-DD');
            var end = endDate.format('YYYY-MM-DD');
            return start + "->" + end;
        }

    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ChatConfigurationFactory', ChatConfigurationFactory);

    ChatConfigurationFactory.$inject = ['$resource'];

    function ChatConfigurationFactory($resource) {

        var CHAT_CONFIGURATION = 'admin/api/chat-configuration';
        var CHAT_CONFIGURATION_GET_CHAT_CONFIG = CHAT_CONFIGURATION + '/get-configuration';

        return $resource(CHAT_CONFIGURATION, {}, {
            'getChatConfiguration': {
                method: 'GET',
                url: CHAT_CONFIGURATION_GET_CHAT_CONFIG,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    } else {
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ChatCommerceFactory', ChatCommerceFactory);

    ChatCommerceFactory.$inject = ['$resource'];

    function ChatCommerceFactory($resource) {

        var CHAT_COMMERCE = 'admin/api/chat-commerce';
        var CHAT_COMMERCE_CONNECT_CHAT = CHAT_COMMERCE + '/connect-chat';
        var CHAT_COMMERCE_SYNCHRONIZE_CHAT = CHAT_COMMERCE + '/sync-chat';
        var CHAT_COMMERCE_GET_CONVERSATIONS = CHAT_COMMERCE + '/get-conversations';
        var CHAT_COMMERCE_GET_CONVERSATION_BY_CONVERSATION_ID = CHAT_COMMERCE + '/get-conversation/:conversationId';
        var CHAT_COMMERCE_GET_CONVERSATIONS_BY_FILTER = CHAT_COMMERCE_GET_CONVERSATIONS + '/filter';

        return $resource(CHAT_COMMERCE, {}, {
            'getConversations': {
                method: 'POST',
                url: CHAT_COMMERCE_GET_CONVERSATIONS,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getConversationsByFilter': {
                method: 'POST',
                url: CHAT_COMMERCE_GET_CONVERSATIONS_BY_FILTER,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'synchronizeChat': {
                method: 'POST',
                url: CHAT_COMMERCE_SYNCHRONIZE_CHAT,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response.data = angular.fromJson(data);
                    } else{
                        response.data = data;
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'connectToChat': {
                method: 'POST',
                url: CHAT_COMMERCE_CONNECT_CHAT
            },
            'getConversationByConversationId': {
                method: 'GET',
                url: CHAT_COMMERCE_GET_CONVERSATION_BY_CONVERSATION_ID
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('EmojisConstants', {
            "EMOJIS":[
                {
                  "code": "1f600",
                  "name": "grinning face",
                  "category": "people",
                  "keywords": "['face', 'grin']",
                  "display": 1,
                  "translatedName": "sorrindo cara"
                },
                {
                  "code": "1f603",
                  "name": "smiling face with open mouth",
                  "category": "people",
                  "keywords": "['face', 'mouth', 'open', 'smile']",
                  "display": 1,
                  "translatedName": "rosto sorridente com boca aberta"
                },
                {
                  "code": "1f604",
                  "name": "smiling face with open mouth & smiling eyes",
                  "category": "people",
                  "keywords": "['eye', 'face', 'mouth', 'open', 'smile']",
                  "display": 1,
                  "translatedName": "Rosto sorridente com boca aberta e olhos de sorriso"
                },
                {
                  "code": "1f601",
                  "name": "grinning face with smiling eyes",
                  "category": "people",
                  "keywords": "['eye', 'face', 'grin', 'smile']",
                  "display": 1,
                  "translatedName": "sorrindo cara com olhos sorridentes"
                },
                {
                  "code": "1f606",
                  "name": "smiling face with open mouth & closed eyes",
                  "category": "people",
                  "keywords": "['face', 'laugh', 'mouth', 'open', 'satisfied', 'smile']",
                  "display": 1,
                  "translatedName": "Rosto sorridente com boca aberta e olhos fechados"
                },
                {
                  "code": "1f605",
                  "name": "smiling face with open mouth & cold sweat",
                  "category": "people",
                  "keywords": "['cold', 'face', 'open', 'smile', 'sweat']",
                  "display": 1,
                  "translatedName": "Rosto sorridente com boca aberta e suor frio"
                },
                {
                  "code": "1f602",
                  "name": "face with tears of joy",
                  "category": "people",
                  "keywords": "['face', 'joy', 'laugh', 'tear']",
                  "display": 1,
                  "translatedName": "cara com lágrimas de alegria"
                },
                {
                  "code": "1f923",
                  "name": "rolling on the floor laughing",
                  "category": "people",
                  "keywords": "['face', 'floor', 'laugh', 'rolling']",
                  "display": 1,
                  "translatedName": "rolando de rir no chão"
                },
                {
                  "code": "263a",
                  "name": "smiling face",
                  "category": "people",
                  "keywords": "['face', 'outlined', 'relaxed', 'smile']",
                  "display": 1,
                  "translatedName": "rosto sorridente"
                },
                {
                  "code": "1f60a",
                  "name": "smiling face with smiling eyes",
                  "category": "people",
                  "keywords": "['blush', 'eye', 'face', 'smile']",
                  "display": 1,
                  "translatedName": "Rosto sorridente com olhos sorridentes"
                },
                {
                  "code": "1f607",
                  "name": "smiling face with halo",
                  "category": "people",
                  "keywords": "['angel', 'face', 'fairy tale', 'fantasy', 'halo', 'innocent', 'smile']",
                  "display": 1,
                  "translatedName": "rosto sorridente com halo"
                },
                {
                  "code": "1f642",
                  "name": "slightly smiling face",
                  "category": "people",
                  "keywords": "['face', 'smile']",
                  "display": 1,
                  "translatedName": "cara ligeiramente sorridente"
                },
                {
                  "code": "1f643",
                  "name": "upside-down face",
                  "category": "people",
                  "keywords": "['face', 'upside-down']",
                  "display": 1,
                  "translatedName": "rosto de cabeça para baixo"
                },
                {
                  "code": "1f609",
                  "name": "winking face",
                  "category": "people",
                  "keywords": "['face', 'wink']",
                  "display": 1,
                  "translatedName": "cara piscando"
                },
                {
                  "code": "1f60c",
                  "name": "relieved face",
                  "category": "people",
                  "keywords": "['face', 'relieved']",
                  "display": 1,
                  "translatedName": "rosto aliviado"
                },
                {
                  "code": "1f60d",
                  "name": "smiling face with heart-eyes",
                  "category": "people",
                  "keywords": "['eye', 'face', 'love', 'smile']",
                  "display": 1,
                  "translatedName": "cara sorridente com coração-olhos"
                },
                {
                  "code": "1f618",
                  "name": "face blowing a kiss",
                  "category": "people",
                  "keywords": "['face', 'kiss']",
                  "display": 1,
                  "translatedName": "cara soprando um beijo"
                },
                {
                  "code": "1f617",
                  "name": "kissing face",
                  "category": "people",
                  "keywords": "['face', 'kiss']",
                  "display": 1,
                  "translatedName": "Beijando o rosto"
                },
                {
                  "code": "1f619",
                  "name": "kissing face with smiling eyes",
                  "category": "people",
                  "keywords": "['eye', 'face', 'kiss', 'smile']",
                  "display": 1,
                  "translatedName": "Beijando o rosto com olhos sorridentes"
                },
                {
                  "code": "1f61a",
                  "name": "kissing face with closed eyes",
                  "category": "people",
                  "keywords": "['closed', 'eye', 'face', 'kiss']",
                  "display": 1,
                  "translatedName": "Beijando o rosto com os olhos fechados"
                },
                {
                  "code": "1f60b",
                  "name": "face savouring delicious food",
                  "category": "people",
                  "keywords": "['delicious', 'face', 'savouring', 'smile', 'um', 'yum']",
                  "display": 1,
                  "translatedName": "rosto saboreando comida deliciosa"
                },
                {
                  "code": "1f61c",
                  "name": "face with stuck-out tongue & winking eye",
                  "category": "people",
                  "keywords": "['eye', 'face', 'joke', 'tongue', 'wink']",
                  "display": 1,
                  "translatedName": "cara com língua presa e olho piscando"
                },
                {
                  "code": "1f61d",
                  "name": "face with stuck-out tongue & closed eyes",
                  "category": "people",
                  "keywords": "['eye', 'face', 'horrible', 'taste', 'tongue']",
                  "display": 1,
                  "translatedName": "cara com língua presa e olhos fechados"
                },
                {
                  "code": "1f61b",
                  "name": "face with stuck-out tongue",
                  "category": "people",
                  "keywords": "['face', 'tongue']",
                  "display": 1,
                  "translatedName": "cara com língua presa"
                },
                {
                  "code": "1f911",
                  "name": "money-mouth face",
                  "category": "people",
                  "keywords": "['face', 'money', 'mouth']",
                  "display": 1,
                  "translatedName": "rosto de boca-boca"
                },
                {
                  "code": "1f917",
                  "name": "hugging face",
                  "category": "people",
                  "keywords": "['face', 'hug', 'hugging']",
                  "display": 1,
                  "translatedName": "Abraçando o rosto"
                },
                {
                  "code": "1f913",
                  "name": "nerd face",
                  "category": "people",
                  "keywords": "['face', 'geek', 'nerd']",
                  "display": 1,
                  "translatedName": "Nerd face"
                },
                {
                  "code": "1f60e",
                  "name": "smiling face with sunglasses",
                  "category": "people",
                  "keywords": "['bright', 'cool', 'eye', 'eyewear', 'face', 'glasses', 'smile', 'sun', 'sunglasses']",
                  "display": 1,
                  "translatedName": "rosto sorridente com óculos de sol"
                },
                {
                  "code": "1f921",
                  "name": "clown face",
                  "category": "people",
                  "keywords": "['clown', 'face']",
                  "display": 1,
                  "translatedName": "rosto palhaço"
                },
                {
                  "code": "1f920",
                  "name": "cowboy hat face",
                  "category": "people",
                  "keywords": "['cowboy', 'cowgirl', 'face', 'hat']",
                  "display": 1,
                  "translatedName": "Cara do chapéu de cowboy"
                },
                {
                  "code": "1f60f",
                  "name": "smirking face",
                  "category": "people",
                  "keywords": "['face', 'smirk']",
                  "display": 1,
                  "translatedName": "Smirking Face."
                },
                {
                  "code": "1f612",
                  "name": "unamused face",
                  "category": "people",
                  "keywords": "['face', 'unamused', 'unhappy']",
                  "display": 1,
                  "translatedName": "rosto não amuado"
                },
                {
                  "code": "1f61e",
                  "name": "disappointed face",
                  "category": "people",
                  "keywords": "['disappointed', 'face']",
                  "display": 1,
                  "translatedName": "rosto desapontado"
                },
                {
                  "code": "1f614",
                  "name": "pensive face",
                  "category": "people",
                  "keywords": "['dejected', 'face', 'pensive']",
                  "display": 1,
                  "translatedName": "rosto pensativo"
                },
                {
                  "code": "1f61f",
                  "name": "worried face",
                  "category": "people",
                  "keywords": "['face', 'worried']",
                  "display": 1,
                  "translatedName": "cara preocupada"
                },
                {
                  "code": "1f615",
                  "name": "confused face",
                  "category": "people",
                  "keywords": "['confused', 'face']",
                  "display": 1,
                  "translatedName": "rosto confuso"
                },
                {
                  "code": "1f641",
                  "name": "slightly frowning face",
                  "category": "people",
                  "keywords": "['face', 'frown']",
                  "display": 1,
                  "translatedName": "cara ligeiramente franzida"
                },
                {
                  "code": 2639,
                  "name": "frowning face",
                  "category": "people",
                  "keywords": "['face', 'frown']",
                  "display": 1,
                  "translatedName": "Cara franzindo a testa"
                },
                {
                  "code": "1f623",
                  "name": "persevering face",
                  "category": "people",
                  "keywords": "['face', 'persevere']",
                  "display": 1,
                  "translatedName": "cara perseverante"
                },
                {
                  "code": "1f616",
                  "name": "confounded face",
                  "category": "people",
                  "keywords": "['confounded', 'face']",
                  "display": 1,
                  "translatedName": "rosto confundido"
                },
                {
                  "code": "1f62b",
                  "name": "tired face",
                  "category": "people",
                  "keywords": "['face', 'tired']",
                  "display": 1,
                  "translatedName": "cara cansada"
                },
                {
                  "code": "1f629",
                  "name": "weary face",
                  "category": "people",
                  "keywords": "['face', 'tired', 'weary']",
                  "display": 1,
                  "translatedName": "rosto cansado"
                },
                {
                  "code": "1f624",
                  "name": "face with steam from nose",
                  "category": "people",
                  "keywords": "['face', 'triumph', 'won']",
                  "display": 1,
                  "translatedName": "cara com vapor do nariz"
                },
                {
                  "code": "1f620",
                  "name": "angry face",
                  "category": "people",
                  "keywords": "['angry', 'face', 'mad']",
                  "display": 1,
                  "translatedName": "cara de bravo"
                },
                {
                  "code": "1f621",
                  "name": "pouting face",
                  "category": "people",
                  "keywords": "['angry', 'face', 'mad', 'pouting', 'rage', 'red']",
                  "display": 1,
                  "translatedName": "cara de beicinho"
                },
                {
                  "code": "1f636",
                  "name": "face without mouth",
                  "category": "people",
                  "keywords": "['face', 'mouth', 'quiet', 'silent']",
                  "display": 1,
                  "translatedName": "cara sem boca"
                },
                {
                  "code": "1f610",
                  "name": "neutral face",
                  "category": "people",
                  "keywords": "['deadpan', 'face', 'neutral']",
                  "display": 1,
                  "translatedName": "rosto neutro"
                },
                {
                  "code": "1f611",
                  "name": "expressionless face",
                  "category": "people",
                  "keywords": "['expressionless', 'face', 'inexpressive', 'unexpressive']",
                  "display": 1,
                  "translatedName": "rosto inexpressivo."
                },
                {
                  "code": "1f62f",
                  "name": "hushed face",
                  "category": "people",
                  "keywords": "['face', 'hushed', 'stunned', 'surprised']",
                  "display": 1,
                  "translatedName": "cara silenciada"
                },
                {
                  "code": "1f626",
                  "name": "frowning face with open mouth",
                  "category": "people",
                  "keywords": "['face', 'frown', 'mouth', 'open']",
                  "display": 1,
                  "translatedName": "Cara franzindo a testa com a boca aberta"
                },
                {
                  "code": "1f627",
                  "name": "anguished face",
                  "category": "people",
                  "keywords": "['anguished', 'face']",
                  "display": 1,
                  "translatedName": "rosto angustiado"
                },
                {
                  "code": "1f62e",
                  "name": "face with open mouth",
                  "category": "people",
                  "keywords": "['face', 'mouth', 'open', 'sympathy']",
                  "display": 1,
                  "translatedName": "cara com boca aberta"
                },
                {
                  "code": "1f632",
                  "name": "astonished face",
                  "category": "people",
                  "keywords": "['astonished', 'face', 'shocked', 'totally']",
                  "display": 1,
                  "translatedName": "cara atônita"
                },
                {
                  "code": "1f635",
                  "name": "dizzy face",
                  "category": "people",
                  "keywords": "['dizzy', 'face']",
                  "display": 1,
                  "translatedName": "rosto vertiginoso"
                },
                {
                  "code": "1f633",
                  "name": "flushed face",
                  "category": "people",
                  "keywords": "['dazed', 'face', 'flushed']",
                  "display": 1,
                  "translatedName": "Cara corada"
                },
                {
                  "code": "1f631",
                  "name": "face screaming in fear",
                  "category": "people",
                  "keywords": "['face', 'fear', 'fearful', 'munch', 'scared', 'scream']",
                  "display": 1,
                  "translatedName": "rosto gritando com medo"
                },
                {
                  "code": "1f628",
                  "name": "fearful face",
                  "category": "people",
                  "keywords": "['face', 'fear', 'fearful', 'scared']",
                  "display": 1,
                  "translatedName": "rosto temeroso"
                },
                {
                  "code": "1f630",
                  "name": "face with open mouth & cold sweat",
                  "category": "people",
                  "keywords": "['blue', 'cold', 'face', 'mouth', 'open', 'rushed', 'sweat']",
                  "display": 1,
                  "translatedName": "cara com boca aberta e suor frio"
                },
                {
                  "code": "1f622",
                  "name": "crying face",
                  "category": "people",
                  "keywords": "['cry', 'face', 'sad', 'tear']",
                  "display": 1,
                  "translatedName": "cara de choro"
                },
                {
                  "code": "1f625",
                  "name": "disappointed but relieved face",
                  "category": "people",
                  "keywords": "['disappointed', 'face', 'relieved', 'whew']",
                  "display": 1,
                  "translatedName": "rosto desapontado mas aliviado"
                },
                {
                  "code": "1f924",
                  "name": "drooling face",
                  "category": "people",
                  "keywords": "['drooling', 'face']",
                  "display": 1,
                  "translatedName": "cara de babando"
                },
                {
                  "code": "1f62d",
                  "name": "loudly crying face",
                  "category": "people",
                  "keywords": "['cry', 'face', 'sad', 'sob', 'tear']",
                  "display": 1,
                  "translatedName": "cara de choro alto"
                },
                {
                  "code": "1f613",
                  "name": "face with cold sweat",
                  "category": "people",
                  "keywords": "['cold', 'face', 'sweat']",
                  "display": 1,
                  "translatedName": "cara com suor frio"
                },
                {
                  "code": "1f62a",
                  "name": "sleepy face",
                  "category": "people",
                  "keywords": "['face', 'sleep']",
                  "display": 1,
                  "translatedName": "cara de sono"
                },
                {
                  "code": "1f634",
                  "name": "sleeping face",
                  "category": "people",
                  "keywords": "['face', 'sleep', 'zzz']",
                  "display": 1,
                  "translatedName": "cara de dormir"
                },
                {
                  "code": "1f644",
                  "name": "face with rolling eyes",
                  "category": "people",
                  "keywords": "['eyes', 'face', 'rolling']",
                  "display": 1,
                  "translatedName": "cara com olhos rolantes"
                },
                {
                  "code": "1f914",
                  "name": "thinking face",
                  "category": "people",
                  "keywords": "['face', 'thinking']",
                  "display": 1,
                  "translatedName": "cara de pensamento"
                },
                {
                  "code": "1f925",
                  "name": "lying face",
                  "category": "people",
                  "keywords": "['face', 'lie', 'pinocchio']",
                  "display": 1,
                  "translatedName": "rosto deitado"
                },
                {
                  "code": "1f62c",
                  "name": "grimacing face",
                  "category": "people",
                  "keywords": "['face', 'grimace']",
                  "display": 1,
                  "translatedName": "careta cara"
                },
                {
                  "code": "1f910",
                  "name": "zipper-mouth face",
                  "category": "people",
                  "keywords": "['face', 'mouth', 'zipper']",
                  "display": 1,
                  "translatedName": "rosto de boca com zíper"
                },
                {
                  "code": "1f922",
                  "name": "nauseated face",
                  "category": "people",
                  "keywords": "['face', 'nauseated', 'vomit']",
                  "display": 1,
                  "translatedName": "rosto nauseado"
                },
                {
                  "code": "1f927",
                  "name": "sneezing face",
                  "category": "people",
                  "keywords": "['face', 'gesundheit', 'sneeze']",
                  "display": 1,
                  "translatedName": "sneezing face"
                },
                {
                  "code": "1f637",
                  "name": "face with medical mask",
                  "category": "people",
                  "keywords": "['cold', 'doctor', 'face', 'mask', 'medicine', 'sick']",
                  "display": 1,
                  "translatedName": "cara com máscara médica"
                },
                {
                  "code": "1f912",
                  "name": "face with thermometer",
                  "category": "people",
                  "keywords": "['face', 'ill', 'sick', 'thermometer']",
                  "display": 1,
                  "translatedName": "cara com termômetro"
                },
                {
                  "code": "1f915",
                  "name": "face with head-bandage",
                  "category": "people",
                  "keywords": "['bandage', 'face', 'hurt', 'injury']",
                  "display": 1,
                  "translatedName": "cara com atadura de cabeça"
                },
                {
                  "code": "1f608",
                  "name": "smiling face with horns",
                  "category": "people",
                  "keywords": "['face', 'fairy tale', 'fantasy', 'horns', 'smile']",
                  "display": 1,
                  "translatedName": "rosto sorridente com chifres"
                },
                {
                  "code": "1f47f",
                  "name": "angry face with horns",
                  "category": "people",
                  "keywords": "['demon', 'devil', 'face', 'fairy tale', 'fantasy', 'imp']",
                  "display": 1,
                  "translatedName": "cara irritada com chifres"
                },
                {
                  "code": "1f479",
                  "name": "ogre",
                  "category": "people",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "ogro"
                },
                {
                  "code": "1f47a",
                  "name": "goblin",
                  "category": "people",
                  "keywords": "['creature', 'face', 'fairy tale', 'fantasy', 'monster']",
                  "display": 1,
                  "translatedName": "Goblin."
                },
                {
                  "code": "1f4a9",
                  "name": "pile of poo",
                  "category": "people",
                  "keywords": "['comic', 'dung', 'face', 'monster', 'poo', 'poop']",
                  "display": 1,
                  "translatedName": "Pilha de Poo."
                },
                {
                  "code": "1f47b",
                  "name": "ghost",
                  "category": "people",
                  "keywords": "['creature', 'face', 'fairy tale', 'fantasy', 'monster']",
                  "display": 1,
                  "translatedName": "fantasma"
                },
                {
                  "code": "1f480",
                  "name": "skull",
                  "category": "people",
                  "keywords": "['death', 'face', 'fairy tale', 'monster']",
                  "display": 1,
                  "translatedName": "crânio"
                },
                {
                  "code": 2620,
                  "name": "skull and crossbones",
                  "category": "people",
                  "keywords": "['crossbones', 'death', 'face', 'monster', 'skull']",
                  "display": 1,
                  "translatedName": "Crânio e Crossbones"
                },
                {
                  "code": "1f47d",
                  "name": "alien",
                  "category": "people",
                  "keywords": "['creature', 'extraterrestrial', 'face', 'fairy tale', 'fantasy', 'monster', 'ufo']",
                  "display": 1,
                  "translatedName": "estrangeiro"
                },
                {
                  "code": "1f47e",
                  "name": "alien monster",
                  "category": "people",
                  "keywords": "['alien', 'creature', 'extraterrestrial', 'face', 'fairy tale', 'fantasy', 'monster', 'ufo']",
                  "display": 1,
                  "translatedName": "monstro alienígena"
                },
                {
                  "code": "1f916",
                  "name": "robot face",
                  "category": "people",
                  "keywords": "['face', 'monster', 'robot']",
                  "display": 1,
                  "translatedName": "Robot Face."
                },
                {
                  "code": "1f383",
                  "name": "jack-o-lantern",
                  "category": "people",
                  "keywords": "['celebration', 'halloween', 'jack', 'lantern']",
                  "display": 1,
                  "translatedName": "jack-o-lantern"
                },
                {
                  "code": "1f63a",
                  "name": "smiling cat face with open mouth",
                  "category": "people",
                  "keywords": "['cat', 'face', 'mouth', 'open', 'smile']",
                  "display": 1,
                  "translatedName": "Rosto de gato sorridente com boca aberta"
                },
                {
                  "code": "1f638",
                  "name": "grinning cat face with smiling eyes",
                  "category": "people",
                  "keywords": "['cat', 'eye', 'face', 'grin', 'smile']",
                  "display": 1,
                  "translatedName": "Rosto de gato sorrindo com olhos sorridentes"
                },
                {
                  "code": "1f639",
                  "name": "cat face with tears of joy",
                  "category": "people",
                  "keywords": "['cat', 'face', 'joy', 'tear']",
                  "display": 1,
                  "translatedName": "cara de gato com lágrimas de alegria"
                },
                {
                  "code": "1f63b",
                  "name": "smiling cat face with heart-eyes",
                  "category": "people",
                  "keywords": "['cat', 'eye', 'face', 'love', 'smile']",
                  "display": 1,
                  "translatedName": "Rosto de gato sorridente com coração-olhos"
                },
                {
                  "code": "1f63c",
                  "name": "cat face with wry smile",
                  "category": "people",
                  "keywords": "['cat', 'face', 'ironic', 'smile', 'wry']",
                  "display": 1,
                  "translatedName": "cara de gato com sorriso irônico"
                },
                {
                  "code": "1f63d",
                  "name": "kissing cat face with closed eyes",
                  "category": "people",
                  "keywords": "['cat', 'eye', 'face', 'kiss']",
                  "display": 1,
                  "translatedName": "Beijando o rosto de gato com olhos fechados"
                },
                {
                  "code": "1f640",
                  "name": "weary cat face",
                  "category": "people",
                  "keywords": "['cat', 'face', 'oh', 'surprised', 'weary']",
                  "display": 1,
                  "translatedName": "Cara do gato cansado"
                },
                {
                  "code": "1f63f",
                  "name": "crying cat face",
                  "category": "people",
                  "keywords": "['cat', 'cry', 'face', 'sad', 'tear']",
                  "display": 1,
                  "translatedName": "cara de gato chorando"
                },
                {
                  "code": "1f63e",
                  "name": "pouting cat face",
                  "category": "people",
                  "keywords": "['cat', 'face', 'pouting']",
                  "display": 1,
                  "translatedName": "cara de gato de beicinho"
                },
                {
                  "code": "1f450",
                  "name": "open hands",
                  "category": "people",
                  "keywords": "['hand', 'open']",
                  "display": 1,
                  "translatedName": "mãos abertas"
                },
                {
                  "code": "1f64f",
                  "name": "folded hands",
                  "category": "people",
                  "keywords": "['ask', 'bow', 'folded', 'gesture', 'hand', 'please', 'pray', 'thanks']",
                  "display": 1,
                  "translatedName": "mãos dobradas"
                },
                {
                  "code": "1f91d",
                  "name": "handshake",
                  "category": "people",
                  "keywords": "['agreement', 'hand', 'handshake', 'meeting', 'shake']",
                  "display": 1,
                  "translatedName": "aperto de mão"
                },
                {
                  "code": "1f44d",
                  "name": "thumbs up",
                  "category": "people",
                  "keywords": "['+1', 'hand', 'thumb', 'up']",
                  "display": 1,
                  "translatedName": "afirmativo"
                },
                {
                  "code": "1f44a",
                  "name": "oncoming fist",
                  "category": "people",
                  "keywords": "['clenched', 'fist', 'hand', 'punch']",
                  "display": 1,
                  "translatedName": "punho que se aproxima"
                },
                {
                  "code": "270a",
                  "name": "raised fist",
                  "category": "people",
                  "keywords": "['clenched', 'fist', 'hand', 'punch']",
                  "display": 1,
                  "translatedName": "punho levantado"
                },
                {
                  "code": "1f91c",
                  "name": "right-facing fist",
                  "category": "people",
                  "keywords": "['fist', 'rightwards']",
                  "display": 1,
                  "translatedName": "punho voltado para a direita"
                },
                {
                  "code": "1f91e",
                  "name": "crossed fingers",
                  "category": "people",
                  "keywords": "['cross', 'finger', 'hand', 'luck']",
                  "display": 1,
                  "translatedName": "dedos cruzados"
                },
                {
                  "code": "270c",
                  "name": "victory hand",
                  "category": "people",
                  "keywords": "['hand', 'v', 'victory']",
                  "display": 1,
                  "translatedName": "mão da vitória"
                },
                {
                  "code": "1f918",
                  "name": "sign of the horns",
                  "category": "people",
                  "keywords": "['finger', 'hand', 'horns', 'rock-on']",
                  "display": 1,
                  "translatedName": "Sinal dos chifres"
                },
                {
                  "code": "1f44c",
                  "name": "OK hand",
                  "category": "people",
                  "keywords": "['OK', 'hand']",
                  "display": 1,
                  "translatedName": "Ok mão"
                },
                {
                  "code": "1f448",
                  "name": "backhand index pointing left",
                  "category": "people",
                  "keywords": "['backhand', 'finger', 'hand', 'index', 'point']",
                  "display": 1,
                  "translatedName": "índice de backhand apontando para a esquerda"
                },
                {
                  "code": "1f449",
                  "name": "backhand index pointing right",
                  "category": "people",
                  "keywords": "['backhand', 'finger', 'hand', 'index', 'point']",
                  "display": 1,
                  "translatedName": "índice de backhand apontando para a direita"
                },
                {
                  "code": "1f446",
                  "name": "backhand index pointing up",
                  "category": "people",
                  "keywords": "['backhand', 'finger', 'hand', 'index', 'point', 'up']",
                  "display": 1,
                  "translatedName": "índice de backhand apontando para cima"
                },
                {
                  "code": "1f447",
                  "name": "backhand index pointing down",
                  "category": "people",
                  "keywords": "['backhand', 'down', 'finger', 'hand', 'index', 'point']",
                  "display": 1,
                  "translatedName": "índice de backhand apontando para baixo"
                },
                {
                  "code": "261d",
                  "name": "index pointing up",
                  "category": "people",
                  "keywords": "['finger', 'hand', 'index', 'point', 'up']",
                  "display": 1,
                  "translatedName": "Índice apontando para cima"
                },
                {
                  "code": "270b",
                  "name": "raised hand",
                  "category": "people",
                  "keywords": "['hand']",
                  "display": 1,
                  "translatedName": "mão levantada"
                },
                {
                  "code": "1f91a",
                  "name": "raised back of hand",
                  "category": "people",
                  "keywords": "['backhand', 'raised']",
                  "display": 1,
                  "translatedName": "levantou a parte de trás da mão"
                },
                {
                  "code": "1f590",
                  "name": "raised hand with fingers splayed",
                  "category": "people",
                  "keywords": "['finger', 'hand', 'splayed']",
                  "display": 1,
                  "translatedName": "mão levantada com os dedos esplêndidos"
                },
                {
                  "code": "1f596",
                  "name": "vulcan salute",
                  "category": "people",
                  "keywords": "['finger', 'hand', 'spock', 'vulcan']",
                  "display": 1,
                  "translatedName": "saudação vulcana."
                },
                {
                  "code": "1f44b",
                  "name": "waving hand",
                  "category": "people",
                  "keywords": "['hand', 'wave', 'waving']",
                  "display": 1,
                  "translatedName": "Acenando a mão"
                },
                {
                  "code": "1f919",
                  "name": "call me hand",
                  "category": "people",
                  "keywords": "['call', 'hand']",
                  "display": 1,
                  "translatedName": "me chame de mão"
                },
                {
                  "code": "1f4aa",
                  "name": "flexed biceps",
                  "category": "people",
                  "keywords": "['biceps', 'comic', 'flex', 'muscle']",
                  "display": 1,
                  "translatedName": "Bíceps flexionados"
                },
                {
                  "code": "1f595",
                  "name": "middle finger",
                  "category": "people",
                  "keywords": "['finger', 'hand']",
                  "display": 1,
                  "translatedName": "dedo do meio"
                },
                {
                  "code": "270d",
                  "name": "writing hand",
                  "category": "people",
                  "keywords": "['hand', 'write']",
                  "display": 1,
                  "translatedName": "Escrevendo a mão"
                },
                {
                  "code": "1f933",
                  "name": "selfie",
                  "category": "people",
                  "keywords": "['camera', 'phone', 'selfie']",
                  "display": 1,
                  "translatedName": "selfie"
                },
                {
                  "code": "1f485",
                  "name": "nail polish",
                  "category": "people",
                  "keywords": "['care', 'cosmetics', 'manicure', 'nail', 'polish']",
                  "display": 1,
                  "translatedName": "lixador de unha"
                },
                {
                  "code": "1f48d",
                  "name": "ring",
                  "category": "people",
                  "keywords": "['diamond']",
                  "display": 1,
                  "translatedName": "anel"
                },
                {
                  "code": "1f484",
                  "name": "lipstick",
                  "category": "people",
                  "keywords": "['cosmetics', 'makeup']",
                  "display": 1,
                  "translatedName": "batom"
                },
                {
                  "code": "1f48b",
                  "name": "kiss mark",
                  "category": "people",
                  "keywords": "['kiss', 'lips']",
                  "display": 1,
                  "translatedName": "marca de beijo"
                },
                {
                  "code": "1f444",
                  "name": "mouth",
                  "category": "people",
                  "keywords": "['lips']",
                  "display": 1,
                  "translatedName": "boca"
                },
                {
                  "code": "1f445",
                  "name": "tongue",
                  "category": "people",
                  "keywords": "['body']",
                  "display": 1,
                  "translatedName": "língua"
                },
                {
                  "code": "1f442",
                  "name": "ear",
                  "category": "people",
                  "keywords": "['body']",
                  "display": 1,
                  "translatedName": "orelha"
                },
                {
                  "code": "1f443",
                  "name": "nose",
                  "category": "people",
                  "keywords": "['body']",
                  "display": 1,
                  "translatedName": "nariz"
                },
                {
                  "code": "1f463",
                  "name": "footprints",
                  "category": "people",
                  "keywords": "['clothing', 'footprint', 'print']",
                  "display": 1,
                  "translatedName": "pegadas"
                },
                {
                  "code": "1f441",
                  "name": "eye",
                  "category": "people",
                  "keywords": "['body']",
                  "display": 1,
                  "translatedName": "olho"
                },
                {
                  "code": "1f440",
                  "name": "eyes",
                  "category": "people",
                  "keywords": "['eye', 'face']",
                  "display": 1,
                  "translatedName": "olhos"
                },
                {
                  "code": "1f5e3",
                  "name": "speaking head",
                  "category": "people",
                  "keywords": "['face', 'head', 'silhouette', 'speak', 'speaking']",
                  "display": 1,
                  "translatedName": "Falando cabeça"
                },
                {
                  "code": "1f464",
                  "name": "bust in silhouette",
                  "category": "people",
                  "keywords": "['bust', 'silhouette']",
                  "display": 1,
                  "translatedName": "Busto na silhueta"
                },
                {
                  "code": "1f465",
                  "name": "busts in silhouette",
                  "category": "people",
                  "keywords": "['bust', 'silhouette']",
                  "display": 1,
                  "translatedName": "Bustos na silhueta"
                },
                {
                  "code": "1f476",
                  "name": "baby",
                  "category": "people",
                  "keywords": "['baby', 'young']",
                  "display": 1,
                  "translatedName": "bebê"
                },
                {
                  "code": "1f466",
                  "name": "boy",
                  "category": "people",
                  "keywords": "['boy', 'young']",
                  "display": 1,
                  "translatedName": "Garoto"
                },
                {
                  "code": "1f467",
                  "name": "girl",
                  "category": "people",
                  "keywords": "['Virgo', 'young', 'zodiac']",
                  "display": 1,
                  "translatedName": "garota"
                },
                {
                  "code": "1f468",
                  "name": "man",
                  "category": "people",
                  "keywords": "['man']",
                  "display": 1,
                  "translatedName": "cara"
                },
                {
                  "code": "1f469",
                  "name": "woman",
                  "category": "people",
                  "keywords": "['woman']",
                  "display": 1,
                  "translatedName": "mulher"
                },
                {
                  "code": "1f471-2640",
                  "name": "blond-haired woman",
                  "category": "people",
                  "keywords": "['blonde', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher de cabelos loiros"
                },
                {
                  "code": "1f471",
                  "name": "blond-haired person",
                  "category": "people",
                  "keywords": "['blond']",
                  "display": 1,
                  "translatedName": "pessoa de cabelos louro"
                },
                {
                  "code": "1f471-2642",
                  "name": "blond-haired man",
                  "category": "people",
                  "keywords": "['blond', 'man']",
                  "display": 0,
                  "translatedName": "homem de cabelos loiros"
                },
                {
                  "code": "1f474",
                  "name": "old man",
                  "category": "people",
                  "keywords": "['man', 'old']",
                  "display": 1,
                  "translatedName": "Velhote"
                },
                {
                  "code": "1f475",
                  "name": "old woman",
                  "category": "people",
                  "keywords": "['old', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher velha"
                },
                {
                  "code": "1f472",
                  "name": "man with Chinese cap",
                  "category": "people",
                  "keywords": "['gua pi mao', 'hat', 'man']",
                  "display": 1,
                  "translatedName": "Homem com boné chinês"
                },
                {
                  "code": "1f473-2640",
                  "name": "woman wearing turban",
                  "category": "people",
                  "keywords": "['turban', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher vestindo turbante"
                },
                {
                  "code": "1f473",
                  "name": "person wearing turban",
                  "category": "people",
                  "keywords": "['turban']",
                  "display": 1,
                  "translatedName": "Pessoa vestindo turbante"
                },
                {
                  "code": "1f473-2642",
                  "name": "man wearing turban",
                  "category": "people",
                  "keywords": "['man', 'turban']",
                  "display": 0,
                  "translatedName": "Homem vestindo turbante"
                },
                {
                  "code": "1f46e-2640",
                  "name": "woman police officer",
                  "category": "people",
                  "keywords": "['cop', 'officer', 'police', 'woman']",
                  "display": 1,
                  "translatedName": "policial de mulher"
                },
                {
                  "code": "1f46e",
                  "name": "police officer",
                  "category": "people",
                  "keywords": "['cop', 'officer', 'police']",
                  "display": 1,
                  "translatedName": "policial"
                },
                {
                  "code": "1f46e-2642",
                  "name": "man police officer",
                  "category": "people",
                  "keywords": "['cop', 'man', 'officer', 'police']",
                  "display": 0,
                  "translatedName": "policial do homem"
                },
                {
                  "code": "1f477",
                  "name": "construction worker",
                  "category": "people",
                  "keywords": "['construction', 'hat', 'worker']",
                  "display": 1,
                  "translatedName": "trabalhador da construção"
                },
                {
                  "code": "1f482-2640",
                  "name": "woman guard",
                  "category": "people",
                  "keywords": "['guard', 'woman']",
                  "display": 1,
                  "translatedName": "guarda mulher"
                },
                {
                  "code": "1f482",
                  "name": "guard",
                  "category": "people",
                  "keywords": "['guard']",
                  "display": 1,
                  "translatedName": "guarda"
                },
                {
                  "code": "1f575-2640",
                  "name": "woman detective",
                  "category": "people",
                  "keywords": "['detective', 'sleuth', 'spy', 'woman']",
                  "display": 1,
                  "translatedName": "Detetive de mulher"
                },
                {
                  "code": "1f575",
                  "name": "detective",
                  "category": "people",
                  "keywords": "['detective', 'sleuth', 'spy']",
                  "display": 1,
                  "translatedName": "detetive"
                },
                {
                  "code": "1f575-2642",
                  "name": "man detective",
                  "category": "people",
                  "keywords": "['detective', 'man', 'sleuth', 'spy']",
                  "display": 0,
                  "translatedName": "detetive do homem"
                },
                {
                  "code": "1f469-2695",
                  "name": "woman health worker",
                  "category": "people",
                  "keywords": "['doctor', 'healthcare', 'nurse', 'therapist', 'woman']",
                  "display": 1,
                  "translatedName": "Trabalhador de saúde da mulher"
                },
                {
                  "code": "1f468-2695",
                  "name": "man health worker",
                  "category": "people",
                  "keywords": "['doctor', 'healthcare', 'man', 'nurse', 'therapist']",
                  "display": 1,
                  "translatedName": "Trabalhador de saúde do homem"
                },
                {
                  "code": "1f469-1f33e",
                  "name": "woman farmer",
                  "category": "people",
                  "keywords": "['farmer', 'gardener', 'rancher', 'woman']",
                  "display": 1,
                  "translatedName": "fazendeiro de mulher"
                },
                {
                  "code": "1f468-1f33e",
                  "name": "man farmer",
                  "category": "people",
                  "keywords": "['farmer', 'gardener', 'man', 'rancher']",
                  "display": 1,
                  "translatedName": "fazendeiro de homem"
                },
                {
                  "code": "1f469-1f373",
                  "name": "woman cook",
                  "category": "people",
                  "keywords": "['chef', 'cook', 'woman']",
                  "display": 1,
                  "translatedName": "Cozinheiro de mulher"
                },
                {
                  "code": "1f468-1f373",
                  "name": "man cook",
                  "category": "people",
                  "keywords": "['chef', 'cook', 'man']",
                  "display": 1,
                  "translatedName": "Cook do homem"
                },
                {
                  "code": "1f469-1f393",
                  "name": "woman student",
                  "category": "people",
                  "keywords": "['graduate', 'student', 'woman']",
                  "display": 1,
                  "translatedName": "estudante de mulher"
                },
                {
                  "code": "1f468-1f393",
                  "name": "man student",
                  "category": "people",
                  "keywords": "['graduate', 'man', 'student']",
                  "display": 1,
                  "translatedName": "estudante de homem"
                },
                {
                  "code": "1f469-1f3a4",
                  "name": "woman singer",
                  "category": "people",
                  "keywords": "['actor', 'entertainer', 'rock', 'singer', 'star', 'woman']",
                  "display": 1,
                  "translatedName": "cantor de mulher"
                },
                {
                  "code": "1f468-1f3a4",
                  "name": "man singer",
                  "category": "people",
                  "keywords": "['actor', 'entertainer', 'man', 'rock', 'singer', 'star']",
                  "display": 1,
                  "translatedName": "Cantor de homem"
                },
                {
                  "code": "1f469-1f3eb",
                  "name": "woman teacher",
                  "category": "people",
                  "keywords": "['instructor', 'professor', 'teacher', 'woman']",
                  "display": 1,
                  "translatedName": "professor de mulher"
                },
                {
                  "code": "1f468-1f3eb",
                  "name": "man teacher",
                  "category": "people",
                  "keywords": "['instructor', 'man', 'professor', 'teacher']",
                  "display": 1,
                  "translatedName": "professor de homem"
                },
                {
                  "code": "1f469-1f3ed",
                  "name": "woman factory worker",
                  "category": "people",
                  "keywords": "['assembly', 'factory', 'industrial', 'woman', 'worker']",
                  "display": 1,
                  "translatedName": "trabalhador de fábrica de mulher"
                },
                {
                  "code": "1f468-1f3ed",
                  "name": "man factory worker",
                  "category": "people",
                  "keywords": "['assembly', 'factory', 'industrial', 'man', 'worker']",
                  "display": 1,
                  "translatedName": "Homem de fábrica de homem"
                },
                {
                  "code": "1f469-1f4bb",
                  "name": "woman technologist",
                  "category": "people",
                  "keywords": "['coder', 'developer', 'inventor', 'software', 'technologist', 'woman']",
                  "display": 1,
                  "translatedName": "Tecnólogo de mulher"
                },
                {
                  "code": "1f468-1f4bb",
                  "name": "man technologist",
                  "category": "people",
                  "keywords": "['coder', 'developer', 'inventor', 'man', 'software', 'technologist']",
                  "display": 1,
                  "translatedName": "Tecnólogo de homem"
                },
                {
                  "code": "1f469-1f4bc",
                  "name": "woman office worker",
                  "category": "people",
                  "keywords": "['architect', 'business', 'manager', 'office', 'white-collar', 'woman']",
                  "display": 1,
                  "translatedName": "Trabalhador de escritório de mulher"
                },
                {
                  "code": "1f468-1f4bc",
                  "name": "man office worker",
                  "category": "people",
                  "keywords": "['architect', 'business', 'man', 'manager', 'office', 'white-collar']",
                  "display": 1,
                  "translatedName": "Trabalhador de escritório do homem"
                },
                {
                  "code": "1f469-1f527",
                  "name": "woman mechanic",
                  "category": "people",
                  "keywords": "['electrician', 'mechanic', 'plumber', 'tradesperson', 'woman']",
                  "display": 1,
                  "translatedName": "Mecânico de mulher"
                },
                {
                  "code": "1f468-1f527",
                  "name": "man mechanic",
                  "category": "people",
                  "keywords": "['electrician', 'man', 'mechanic', 'plumber', 'tradesperson']",
                  "display": 1,
                  "translatedName": "Mecânico de homem"
                },
                {
                  "code": "1f469-1f52c",
                  "name": "woman scientist",
                  "category": "people",
                  "keywords": "['biologist', 'chemist', 'engineer', 'mathematician', 'physicist', 'scientist', 'woman']",
                  "display": 1,
                  "translatedName": "cientista de mulher"
                },
                {
                  "code": "1f468-1f52c",
                  "name": "man scientist",
                  "category": "people",
                  "keywords": "['biologist', 'chemist', 'engineer', 'man', 'mathematician', 'physicist', 'scientist']",
                  "display": 1,
                  "translatedName": "Cientista do homem"
                },
                {
                  "code": "1f469-1f3a8",
                  "name": "woman artist",
                  "category": "people",
                  "keywords": "['artist', 'palette', 'woman']",
                  "display": 1,
                  "translatedName": "Artista de mulher"
                },
                {
                  "code": "1f468-1f3a8",
                  "name": "man artist",
                  "category": "people",
                  "keywords": "['artist', 'man', 'palette']",
                  "display": 1,
                  "translatedName": "artista do homem."
                },
                {
                  "code": "1f469-1f692",
                  "name": "woman firefighter",
                  "category": "people",
                  "keywords": "['firefighter', 'firetruck', 'woman']",
                  "display": 1,
                  "translatedName": "Bombeiro de mulher"
                },
                {
                  "code": "1f468-1f692",
                  "name": "man firefighter",
                  "category": "people",
                  "keywords": "['firefighter', 'firetruck', 'man']",
                  "display": 1,
                  "translatedName": "bombeiro de homem"
                },
                {
                  "code": "1f469-2708",
                  "name": "woman pilot",
                  "category": "people",
                  "keywords": "['pilot', 'plane', 'woman']",
                  "display": 1,
                  "translatedName": "piloto de mulher"
                },
                {
                  "code": "1f468-2708",
                  "name": "man pilot",
                  "category": "people",
                  "keywords": "['man', 'pilot', 'plane']",
                  "display": 1,
                  "translatedName": "homem piloto"
                },
                {
                  "code": "1f469-1f680",
                  "name": "woman astronaut",
                  "category": "people",
                  "keywords": "['astronaut', 'rocket', 'woman']",
                  "display": 1,
                  "translatedName": "Astronauta da mulher."
                },
                {
                  "code": "1f468-1f680",
                  "name": "man astronaut",
                  "category": "people",
                  "keywords": "['astronaut', 'man', 'rocket']",
                  "display": 1,
                  "translatedName": "Astronauta do homem."
                },
                {
                  "code": "1f469-2696",
                  "name": "woman judge",
                  "category": "people",
                  "keywords": "['judge', 'scales', 'woman']",
                  "display": 1,
                  "translatedName": "juiz de mulher"
                },
                {
                  "code": "1f468-2696",
                  "name": "man judge",
                  "category": "people",
                  "keywords": "['justice', 'man', 'scales']",
                  "display": 1,
                  "translatedName": "juiz do homem"
                },
                {
                  "code": "1f936",
                  "name": "Mrs. Claus",
                  "category": "people",
                  "keywords": "['Christmas', 'Mrs.', 'celebration', 'claus', 'mother']",
                  "display": 1,
                  "translatedName": "Sra. Claus."
                },
                {
                  "code": "1f385",
                  "name": "Santa Claus",
                  "category": "people",
                  "keywords": "['Christmas', 'celebration', 'claus', 'father', 'santa']",
                  "display": 1,
                  "translatedName": "Papai Noel"
                },
                {
                  "code": "1f478",
                  "name": "princess",
                  "category": "people",
                  "keywords": "['fairy tale', 'fantasy']",
                  "display": 1,
                  "translatedName": "Princesa"
                },
                {
                  "code": "1f934",
                  "name": "prince",
                  "category": "people",
                  "keywords": "['prince']",
                  "display": 1,
                  "translatedName": "Principe"
                },
                {
                  "code": "1f470",
                  "name": "bride with veil",
                  "category": "people",
                  "keywords": "['bride', 'veil', 'wedding']",
                  "display": 1,
                  "translatedName": "Noiva com véu"
                },
                {
                  "code": "1f935",
                  "name": "man in tuxedo",
                  "category": "people",
                  "keywords": "['groom', 'man', 'tuxedo']",
                  "display": 1,
                  "translatedName": "Homem em smoking."
                },
                {
                  "code": "1f47c",
                  "name": "baby angel",
                  "category": "people",
                  "keywords": "['angel', 'baby', 'face', 'fairy tale', 'fantasy']",
                  "display": 1,
                  "translatedName": "anjo do bebê"
                },
                {
                  "code": "1f930",
                  "name": "pregnant woman",
                  "category": "people",
                  "keywords": "['pregnant', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher grávida"
                },
                {
                  "code": "1f647-2640",
                  "name": "woman bowing",
                  "category": "people",
                  "keywords": "['apology', 'bowing', 'favor', 'gesture', 'sorry', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher curva"
                },
                {
                  "code": "1f647",
                  "name": "person bowing",
                  "category": "people",
                  "keywords": "['apology', 'bow', 'gesture', 'sorry']",
                  "display": 1,
                  "translatedName": "pessoa curvando"
                },
                {
                  "code": "1f647-2642",
                  "name": "man bowing",
                  "category": "people",
                  "keywords": "['apology', 'bowing', 'favor', 'gesture', 'man', 'sorry']",
                  "display": 0,
                  "translatedName": "homem curvando"
                },
                {
                  "code": "1f481",
                  "name": "person tipping hand",
                  "category": "people",
                  "keywords": "['hand', 'help', 'information', 'sassy', 'tipping']",
                  "display": 1,
                  "translatedName": "Pessoa derrubando a mão"
                },
                {
                  "code": "1f481-2642",
                  "name": "man tipping hand",
                  "category": "people",
                  "keywords": "['man', 'sassy', 'tipping hand']",
                  "display": 1,
                  "translatedName": "Homem derrubando a mão"
                },
                {
                  "code": "1f481-2640",
                  "name": "woman tipping hand",
                  "category": "people",
                  "keywords": "['sassy', 'tipping hand', 'woman']",
                  "display": 0,
                  "translatedName": "Mulher derrubando a mão"
                },
                {
                  "code": "1f645",
                  "name": "person gesturing NO",
                  "category": "people",
                  "keywords": "['forbidden', 'gesture', 'hand', 'no', 'not', 'prohibited']",
                  "display": 1,
                  "translatedName": "Pessoa gesticulando No."
                },
                {
                  "code": "1f645-2642",
                  "name": "man gesturing NO",
                  "category": "people",
                  "keywords": "['forbidden', 'gesture', 'hand', 'man', 'no', 'prohibited']",
                  "display": 1,
                  "translatedName": "Homem gesticulando No."
                },
                {
                  "code": "1f645-2640",
                  "name": "woman gesturing NO",
                  "category": "people",
                  "keywords": "['forbidden', 'gesture', 'hand', 'no', 'prohibited', 'woman']",
                  "display": 0,
                  "translatedName": "Mulher gesticulando não"
                },
                {
                  "code": "1f646",
                  "name": "person gesturing OK",
                  "category": "people",
                  "keywords": "['OK', 'gesture', 'hand']",
                  "display": 1,
                  "translatedName": "Pessoa gesticulando ok"
                },
                {
                  "code": "1f646-2642",
                  "name": "man gesturing OK",
                  "category": "people",
                  "keywords": "['OK', 'gesture', 'hand', 'man']",
                  "display": 1,
                  "translatedName": "Homem gesticulando ok"
                },
                {
                  "code": "1f646-2640",
                  "name": "woman gesturing OK",
                  "category": "people",
                  "keywords": "['OK', 'gesture', 'hand', 'woman']",
                  "display": 0,
                  "translatedName": "Mulher que gesticula ok"
                },
                {
                  "code": "1f64b",
                  "name": "person raising hand",
                  "category": "people",
                  "keywords": "['gesture', 'hand', 'happy', 'raised']",
                  "display": 1,
                  "translatedName": "pessoa levantando a mão"
                },
                {
                  "code": "1f64b-2642",
                  "name": "man raising hand",
                  "category": "people",
                  "keywords": "['gesture', 'man', 'raising hand']",
                  "display": 1,
                  "translatedName": "Homem levantando a mão"
                },
                {
                  "code": "1f64b-2640",
                  "name": "woman raising hand",
                  "category": "people",
                  "keywords": "['gesture', 'raising hand', 'woman']",
                  "display": 0,
                  "translatedName": "Mulher levantando a mão"
                },
                {
                  "code": "1f926-2640",
                  "name": "woman facepalming",
                  "category": "people",
                  "keywords": "['disbelief', 'exasperation', 'facepalm', 'woman']",
                  "display": 1,
                  "translatedName": "mulher facepalming"
                },
                {
                  "code": "1f926-2642",
                  "name": "man facepalming",
                  "category": "people",
                  "keywords": "['disbelief', 'exasperation', 'facepalm', 'man']",
                  "display": 1,
                  "translatedName": "homem facepalming"
                },
                {
                  "code": "1f926",
                  "name": "person facepalming",
                  "category": "people",
                  "keywords": "['disbelief', 'exasperation', 'face', 'palm']",
                  "display": 0,
                  "translatedName": "pessoa facepalming"
                },
                {
                  "code": "1f937-2640",
                  "name": "woman shrugging",
                  "category": "people",
                  "keywords": "['doubt', 'ignorance', 'indifference', 'shrug', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher encolhendo os ombros."
                },
                {
                  "code": "1f937-2642",
                  "name": "man shrugging",
                  "category": "people",
                  "keywords": "['doubt', 'ignorance', 'indifference', 'man', 'shrug']",
                  "display": 1,
                  "translatedName": "homem encolhendo os ombros."
                },
                {
                  "code": "1f937",
                  "name": "person shrugging",
                  "category": "people",
                  "keywords": "['doubt', 'ignorance', 'indifference', 'shrug']",
                  "display": 0,
                  "translatedName": "Pessoa encolhendo os ombros."
                },
                {
                  "code": "1f64e",
                  "name": "person pouting",
                  "category": "people",
                  "keywords": "['gesture', 'pouting']",
                  "display": 1,
                  "translatedName": "Pouting Pouting."
                },
                {
                  "code": "1f64e-2642",
                  "name": "man pouting",
                  "category": "people",
                  "keywords": "['gesture', 'man', 'pouting']",
                  "display": 1,
                  "translatedName": "fazendo beicinho"
                },
                {
                  "code": "1f64e-2640",
                  "name": "woman pouting",
                  "category": "people",
                  "keywords": "['gesture', 'pouting', 'woman']",
                  "display": 0,
                  "translatedName": "mulher fazendo beicinho"
                },
                {
                  "code": "1f64d",
                  "name": "person frowning",
                  "category": "people",
                  "keywords": "['frown', 'gesture']",
                  "display": 1,
                  "translatedName": "pessoa franzindo a testa"
                },
                {
                  "code": "1f64d-2642",
                  "name": "man frowning",
                  "category": "people",
                  "keywords": "['frowning', 'gesture', 'man']",
                  "display": 1,
                  "translatedName": "homem franzindo a testa"
                },
                {
                  "code": "1f64d-2640",
                  "name": "woman frowning",
                  "category": "people",
                  "keywords": "['frowning', 'gesture', 'woman']",
                  "display": 0,
                  "translatedName": "Mulher franzindo a testa"
                },
                {
                  "code": "1f487",
                  "name": "person getting haircut",
                  "category": "people",
                  "keywords": "['barber', 'beauty', 'haircut', 'parlor']",
                  "display": 1,
                  "translatedName": "pessoa recebendo corte de cabelo"
                },
                {
                  "code": "1f487-2642",
                  "name": "man getting haircut",
                  "category": "people",
                  "keywords": "['haircut', 'man']",
                  "display": 1,
                  "translatedName": "Homem recebendo corte de cabelo"
                },
                {
                  "code": "1f487-2640",
                  "name": "woman getting haircut",
                  "category": "people",
                  "keywords": "['haircut', 'woman']",
                  "display": 0,
                  "translatedName": "Mulher recebendo corte de cabelo"
                },
                {
                  "code": "1f486",
                  "name": "person getting massage",
                  "category": "people",
                  "keywords": "['face', 'massage', 'salon']",
                  "display": 1,
                  "translatedName": "pessoa ficando massagem."
                },
                {
                  "code": "1f486-2642",
                  "name": "man getting massage",
                  "category": "people",
                  "keywords": "['face', 'man', 'massage']",
                  "display": 1,
                  "translatedName": "Homem ficando massagem"
                },
                {
                  "code": "1f486-2640",
                  "name": "woman getting massage",
                  "category": "people",
                  "keywords": "['face', 'massage', 'woman']",
                  "display": 0,
                  "translatedName": "Mulher recebendo massagem"
                },
                {
                  "code": "1f574",
                  "name": "man in business suit levitating",
                  "category": "people",
                  "keywords": "['business', 'man', 'suit']",
                  "display": 1,
                  "translatedName": "Homem em terno de negócio levitando"
                },
                {
                  "code": "1f483",
                  "name": "woman dancing",
                  "category": "people",
                  "keywords": "['dancing', 'woman']",
                  "display": 1,
                  "translatedName": "Dança da mulher"
                },
                {
                  "code": "1f57a",
                  "name": "man dancing",
                  "category": "people",
                  "keywords": "['dance', 'man']",
                  "display": 1,
                  "translatedName": "dança do homem"
                },
                {
                  "code": "1f46f",
                  "name": "people with bunny ears partying",
                  "category": "people",
                  "keywords": "['bunny ear', 'dancer', 'partying']",
                  "display": 1,
                  "translatedName": "Pessoas com orelhas de coelho festejando"
                },
                {
                  "code": "1f46f-2642",
                  "name": "men with bunny ears partying",
                  "category": "people",
                  "keywords": "['bunny ear', 'dancer', 'men', 'partying']",
                  "display": 1,
                  "translatedName": "Homens com orelhas de coelho festejando"
                },
                {
                  "code": "1f46f-2640",
                  "name": "women with bunny ears partying",
                  "category": "people",
                  "keywords": "['bunny ear', 'dancer', 'partying', 'women']",
                  "display": 0,
                  "translatedName": "mulheres com orelhas de coelho festejando"
                },
                {
                  "code": "1f6b6-2640",
                  "name": "woman walking",
                  "category": "people",
                  "keywords": "['hike', 'walk', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher andando"
                },
                {
                  "code": "1f6b6",
                  "name": "person walking",
                  "category": "people",
                  "keywords": "['hike', 'walk', 'walking']",
                  "display": 1,
                  "translatedName": "Pessoa andando"
                },
                {
                  "code": "1f6b6-2642",
                  "name": "man walking",
                  "category": "people",
                  "keywords": "['hike', 'man', 'walk']",
                  "display": 0,
                  "translatedName": "homem andando"
                },
                {
                  "code": "1f3c3-2640",
                  "name": "woman running",
                  "category": "people",
                  "keywords": "['marathon', 'racing', 'running', 'woman']",
                  "display": 1,
                  "translatedName": "mulher correndo"
                },
                {
                  "code": "1f3c3",
                  "name": "person running",
                  "category": "people",
                  "keywords": "['marathon', 'running']",
                  "display": 1,
                  "translatedName": "Pessoa correndo"
                },
                {
                  "code": "1f3c3-2642",
                  "name": "man running",
                  "category": "people",
                  "keywords": "['man', 'marathon', 'racing', 'running']",
                  "display": 0,
                  "translatedName": "homem correndo"
                },
                {
                  "code": "1f46b",
                  "name": "man and woman holding hands",
                  "category": "people",
                  "keywords": "['couple', 'hand', 'hold', 'man', 'woman']",
                  "display": 1,
                  "translatedName": "homem e mulher de mãos dadas"
                },
                {
                  "code": "1f46d",
                  "name": "two women holding hands",
                  "category": "people",
                  "keywords": "['couple', 'hand', 'hold', 'woman']",
                  "display": 1,
                  "translatedName": "Duas mulheres de mãos dadas"
                },
                {
                  "code": "1f46c",
                  "name": "two men holding hands",
                  "category": "people",
                  "keywords": "['Gemini', 'couple', 'hand', 'hold', 'man', 'twins', 'zodiac']",
                  "display": 1,
                  "translatedName": "dois homens de mãos dadas"
                },
                {
                  "code": "1f491",
                  "name": "couple with heart",
                  "category": "people",
                  "keywords": "['couple', 'love']",
                  "display": 1,
                  "translatedName": "Casal com coração"
                },
                {
                  "code": "1f469-2764-1f469",
                  "name": "couple with heart: woman, woman",
                  "category": "people",
                  "keywords": "['couple', 'love', 'woman']",
                  "display": 1,
                  "translatedName": "Casal com coração: mulher, mulher"
                },
                {
                  "code": "1f468-2764-1f468",
                  "name": "couple with heart: man, man",
                  "category": "people",
                  "keywords": "['couple', 'love', 'man']",
                  "display": 1,
                  "translatedName": "Casal com coração: homem, homem"
                },
                {
                  "code": "1f48f",
                  "name": "kiss",
                  "category": "people",
                  "keywords": "['couple']",
                  "display": 1,
                  "translatedName": "beijo"
                },
                {
                  "code": "1f469-2764-1f48b-1f469",
                  "name": "kiss: woman, woman",
                  "category": "people",
                  "keywords": "['couple', 'woman']",
                  "display": 1,
                  "translatedName": "Beijo: mulher, mulher"
                },
                {
                  "code": "1f468-2764-1f48b-1f468",
                  "name": "kiss: man, man",
                  "category": "people",
                  "keywords": "['couple', 'man']",
                  "display": 1,
                  "translatedName": "Beijo: homem, homem"
                },
                {
                  "code": "1f46a",
                  "name": "family",
                  "category": "people",
                  "keywords": "['family']",
                  "display": 1,
                  "translatedName": "família"
                },
                {
                  "code": "1f468-1f469-1f467",
                  "name": "family: man, woman, girl",
                  "category": "people",
                  "keywords": "['family', 'girl', 'man', 'woman']",
                  "display": 1,
                  "translatedName": "Família: homem, mulher, menina"
                },
                {
                  "code": "1f468-1f469-1f467-1f466",
                  "name": "family: man, woman, girl, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'girl', 'man', 'woman']",
                  "display": 1,
                  "translatedName": "Família: homem, mulher, menina, menino"
                },
                {
                  "code": "1f468-1f469-1f466-1f466",
                  "name": "family: man, woman, boy, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'man', 'woman']",
                  "display": 1,
                  "translatedName": "Família: homem, mulher, menino, menino"
                },
                {
                  "code": "1f468-1f469-1f467-1f467",
                  "name": "family: man, woman, girl, girl",
                  "category": "people",
                  "keywords": "['family', 'girl', 'man', 'woman']",
                  "display": 1,
                  "translatedName": "Família: homem, mulher, menina, menina"
                },
                {
                  "code": "1f469-1f469-1f466",
                  "name": "family: woman, woman, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'woman']",
                  "display": 1,
                  "translatedName": "Família: mulher, mulher, menino"
                },
                {
                  "code": "1f469-1f469-1f467",
                  "name": "family: woman, woman, girl",
                  "category": "people",
                  "keywords": "['family', 'girl', 'woman']",
                  "display": 1,
                  "translatedName": "Família: mulher, mulher, menina"
                },
                {
                  "code": "1f469-1f469-1f467-1f466",
                  "name": "family: woman, woman, girl, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'girl', 'woman']",
                  "display": 1,
                  "translatedName": "Família: mulher, mulher, menina, menino"
                },
                {
                  "code": "1f469-1f469-1f466-1f466",
                  "name": "family: woman, woman, boy, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'woman']",
                  "display": 1,
                  "translatedName": "Família: mulher, mulher, menino, menino"
                },
                {
                  "code": "1f469-1f469-1f467-1f467",
                  "name": "family: woman, woman, girl, girl",
                  "category": "people",
                  "keywords": "['family', 'girl', 'woman']",
                  "display": 1,
                  "translatedName": "Família: mulher, mulher, menina, menina"
                },
                {
                  "code": "1f468-1f468-1f466",
                  "name": "family: man, man, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'man']",
                  "display": 1,
                  "translatedName": "Família: homem, homem, menino"
                },
                {
                  "code": "1f468-1f468-1f467",
                  "name": "family: man, man, girl",
                  "category": "people",
                  "keywords": "['family', 'girl', 'man']",
                  "display": 1,
                  "translatedName": "Família: homem, homem, menina"
                },
                {
                  "code": "1f468-1f468-1f467-1f466",
                  "name": "family: man, man, girl, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'girl', 'man']",
                  "display": 1,
                  "translatedName": "Família: homem, homem, menina, menino"
                },
                {
                  "code": "1f468-1f468-1f466-1f466",
                  "name": "family: man, man, boy, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'man']",
                  "display": 1,
                  "translatedName": "Família: homem, homem, menino, menino"
                },
                {
                  "code": "1f468-1f468-1f467-1f467",
                  "name": "family: man, man, girl, girl",
                  "category": "people",
                  "keywords": "['family', 'girl', 'man']",
                  "display": 1,
                  "translatedName": "Família: homem, homem, menina, menina"
                },
                {
                  "code": "1f469-1f466",
                  "name": "family: woman, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'woman']",
                  "display": 1,
                  "translatedName": "Família: mulher, menino"
                },
                {
                  "code": "1f469-1f467",
                  "name": "family: woman, girl",
                  "category": "people",
                  "keywords": "['family', 'girl', 'woman']",
                  "display": 1,
                  "translatedName": "Família: mulher, menina"
                },
                {
                  "code": "1f469-1f467-1f466",
                  "name": "family: woman, girl, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'girl', 'woman']",
                  "display": 1,
                  "translatedName": "Família: mulher, menina, menino"
                },
                {
                  "code": "1f469-1f466-1f466",
                  "name": "family: woman, boy, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'woman']",
                  "display": 1,
                  "translatedName": "Família: mulher, menino, menino"
                },
                {
                  "code": "1f469-1f467-1f467",
                  "name": "family: woman, girl, girl",
                  "category": "people",
                  "keywords": "['family', 'girl', 'woman']",
                  "display": 1,
                  "translatedName": "Família: mulher, menina, menina"
                },
                {
                  "code": "1f468-1f466",
                  "name": "family: man, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'man']",
                  "display": 1,
                  "translatedName": "Família: homem, menino"
                },
                {
                  "code": "1f468-1f467",
                  "name": "family: man, girl",
                  "category": "people",
                  "keywords": "['family', 'girl', 'man']",
                  "display": 1,
                  "translatedName": "Família: homem, menina"
                },
                {
                  "code": "1f468-1f467-1f466",
                  "name": "family: man, girl, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'girl', 'man']",
                  "display": 1,
                  "translatedName": "Família: homem, menina, menino"
                },
                {
                  "code": "1f468-1f466-1f466",
                  "name": "family: man, boy, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'man']",
                  "display": 1,
                  "translatedName": "Família: homem, menino, menino"
                },
                {
                  "code": "1f468-1f467-1f467",
                  "name": "family: man, girl, girl",
                  "category": "people",
                  "keywords": "['family', 'girl', 'man']",
                  "display": 1,
                  "translatedName": "Família: homem, menina, menina"
                },
                {
                  "code": "1f45a",
                  "name": "woman’s clothes",
                  "category": "people",
                  "keywords": "['clothing', 'woman']",
                  "display": 1,
                  "translatedName": "roupas da mulher"
                },
                {
                  "code": "1f455",
                  "name": "t-shirt",
                  "category": "people",
                  "keywords": "['clothing', 'shirt', 'tshirt']",
                  "display": 1,
                  "translatedName": "camisa"
                },
                {
                  "code": "1f456",
                  "name": "jeans",
                  "category": "people",
                  "keywords": "['clothing', 'pants', 'trousers']",
                  "display": 1,
                  "translatedName": "jeans"
                },
                {
                  "code": "1f454",
                  "name": "necktie",
                  "category": "people",
                  "keywords": "['clothing']",
                  "display": 1,
                  "translatedName": "gravata"
                },
                {
                  "code": "1f457",
                  "name": "dress",
                  "category": "people",
                  "keywords": "['clothing']",
                  "display": 1,
                  "translatedName": "vestir"
                },
                {
                  "code": "1f459",
                  "name": "bikini",
                  "category": "people",
                  "keywords": "['clothing', 'swim']",
                  "display": 1,
                  "translatedName": "bikini"
                },
                {
                  "code": "1f458",
                  "name": "kimono",
                  "category": "people",
                  "keywords": "['clothing']",
                  "display": 1,
                  "translatedName": "quimono"
                },
                {
                  "code": "1f460",
                  "name": "high-heeled shoe",
                  "category": "people",
                  "keywords": "['clothing', 'heel', 'shoe', 'woman']",
                  "display": 1,
                  "translatedName": "sapato de salto alto"
                },
                {
                  "code": "1f461",
                  "name": "woman’s sandal",
                  "category": "people",
                  "keywords": "['clothing', 'sandal', 'shoe', 'woman']",
                  "display": 1,
                  "translatedName": "Sandália da mulher"
                },
                {
                  "code": "1f462",
                  "name": "woman’s boot",
                  "category": "people",
                  "keywords": "['boot', 'clothing', 'shoe', 'woman']",
                  "display": 1,
                  "translatedName": "bota da mulher"
                },
                {
                  "code": "1f45e",
                  "name": "man’s shoe",
                  "category": "people",
                  "keywords": "['clothing', 'man', 'shoe']",
                  "display": 1,
                  "translatedName": "sapato de homem"
                },
                {
                  "code": "1f45f",
                  "name": "running shoe",
                  "category": "people",
                  "keywords": "['athletic', 'clothing', 'shoe', 'sneaker']",
                  "display": 1,
                  "translatedName": "tênis de corrida"
                },
                {
                  "code": "1f452",
                  "name": "woman’s hat",
                  "category": "people",
                  "keywords": "['clothing', 'hat', 'woman']",
                  "display": 1,
                  "translatedName": "chapéu da mulher"
                },
                {
                  "code": "1f3a9",
                  "name": "top hat",
                  "category": "people",
                  "keywords": "['clothing', 'hat', 'top', 'tophat']",
                  "display": 1,
                  "translatedName": "cartola"
                },
                {
                  "code": "1f393",
                  "name": "graduation cap",
                  "category": "people",
                  "keywords": "['cap', 'celebration', 'clothing', 'graduation', 'hat']",
                  "display": 1,
                  "translatedName": "chapéu de graduação"
                },
                {
                  "code": "1f451",
                  "name": "crown",
                  "category": "people",
                  "keywords": "['clothing', 'king', 'queen']",
                  "display": 1,
                  "translatedName": "coroa"
                },
                {
                  "code": "26d1",
                  "name": "rescue worker’s helmet",
                  "category": "people",
                  "keywords": "['aid', 'cross', 'face', 'hat', 'helmet']",
                  "display": 1,
                  "translatedName": "Capacete do trabalhador de resgate"
                },
                {
                  "code": "1f392",
                  "name": "school backpack",
                  "category": "people",
                  "keywords": "['bag', 'satchel', 'school']",
                  "display": 1,
                  "translatedName": "mochila escolar"
                },
                {
                  "code": "1f45d",
                  "name": "clutch bag",
                  "category": "people",
                  "keywords": "['bag', 'clothing', 'pouch']",
                  "display": 1,
                  "translatedName": "necessaire"
                },
                {
                  "code": "1f45b",
                  "name": "purse",
                  "category": "people",
                  "keywords": "['clothing', 'coin']",
                  "display": 1,
                  "translatedName": "Bolsa"
                },
                {
                  "code": "1f45c",
                  "name": "handbag",
                  "category": "people",
                  "keywords": "['bag', 'clothing', 'purse']",
                  "display": 1,
                  "translatedName": "Bolsa"
                },
                {
                  "code": "1f4bc",
                  "name": "briefcase",
                  "category": "people",
                  "keywords": "['briefcase']",
                  "display": 1,
                  "translatedName": "pasta"
                },
                {
                  "code": "1f453",
                  "name": "glasses",
                  "category": "people",
                  "keywords": "['clothing', 'eye', 'eyeglasses', 'eyewear']",
                  "display": 1,
                  "translatedName": "copos"
                },
                {
                  "code": "1f576",
                  "name": "sunglasses",
                  "category": "people",
                  "keywords": "['dark', 'eye', 'eyewear', 'glasses']",
                  "display": 1,
                  "translatedName": "oculos escuros"
                },
                {
                  "code": "1f302",
                  "name": "closed umbrella",
                  "category": "people",
                  "keywords": "['clothing', 'rain', 'umbrella']",
                  "display": 1,
                  "translatedName": "guarda-chuva fechado."
                },
                {
                  "code": 2602,
                  "name": "umbrella",
                  "category": "people",
                  "keywords": "['clothing', 'rain']",
                  "display": 1,
                  "translatedName": "guarda-chuva"
                },
                {
                  "code": "1f436",
                  "name": "dog face",
                  "category": "nature",
                  "keywords": "['dog', 'face', 'pet']",
                  "display": 1,
                  "translatedName": "cara de cachorro."
                },
                {
                  "code": "1f431",
                  "name": "cat face",
                  "category": "nature",
                  "keywords": "['cat', 'face', 'pet']",
                  "display": 1,
                  "translatedName": "cara de Gato"
                },
                {
                  "code": "1f42d",
                  "name": "mouse face",
                  "category": "nature",
                  "keywords": "['face', 'mouse']",
                  "display": 1,
                  "translatedName": "Cara do rato"
                },
                {
                  "code": "1f439",
                  "name": "hamster face",
                  "category": "nature",
                  "keywords": "['face', 'hamster', 'pet']",
                  "display": 1,
                  "translatedName": "cara de hamster"
                },
                {
                  "code": "1f430",
                  "name": "rabbit face",
                  "category": "nature",
                  "keywords": "['bunny', 'face', 'pet', 'rabbit']",
                  "display": 1,
                  "translatedName": "rosto de coelho"
                },
                {
                  "code": "1f98a",
                  "name": "fox face",
                  "category": "nature",
                  "keywords": "['face', 'fox']",
                  "display": 1,
                  "translatedName": "raposa cara"
                },
                {
                  "code": "1f43b",
                  "name": "bear face",
                  "category": "nature",
                  "keywords": "['bear', 'face']",
                  "display": 1,
                  "translatedName": "Cara de urso"
                },
                {
                  "code": "1f43c",
                  "name": "panda face",
                  "category": "nature",
                  "keywords": "['face', 'panda']",
                  "display": 1,
                  "translatedName": "Panda Face"
                },
                {
                  "code": "1f428",
                  "name": "koala",
                  "category": "nature",
                  "keywords": "['bear']",
                  "display": 1,
                  "translatedName": "Koala."
                },
                {
                  "code": "1f42f",
                  "name": "tiger face",
                  "category": "nature",
                  "keywords": "['face', 'tiger']",
                  "display": 1,
                  "translatedName": "Cara do tigre"
                },
                {
                  "code": "1f981",
                  "name": "lion face",
                  "category": "nature",
                  "keywords": "['Leo', 'face', 'lion', 'zodiac']",
                  "display": 1,
                  "translatedName": "rosto de leão"
                },
                {
                  "code": "1f42e",
                  "name": "cow face",
                  "category": "nature",
                  "keywords": "['cow', 'face']",
                  "display": 1,
                  "translatedName": "cara de vaca."
                },
                {
                  "code": "1f437",
                  "name": "pig face",
                  "category": "nature",
                  "keywords": "['face', 'pig']",
                  "display": 1,
                  "translatedName": "cara de porco"
                },
                {
                  "code": "1f43d",
                  "name": "pig nose",
                  "category": "nature",
                  "keywords": "['face', 'nose', 'pig']",
                  "display": 1,
                  "translatedName": "nariz de porco"
                },
                {
                  "code": "1f438",
                  "name": "frog face",
                  "category": "nature",
                  "keywords": "['face', 'frog']",
                  "display": 1,
                  "translatedName": "rosto de sapo"
                },
                {
                  "code": "1f435",
                  "name": "monkey face",
                  "category": "nature",
                  "keywords": "['face', 'monkey']",
                  "display": 1,
                  "translatedName": "cara de macaco"
                },
                {
                  "code": "1f648",
                  "name": "see-no-evil monkey",
                  "category": "nature",
                  "keywords": "['evil', 'face', 'forbidden', 'gesture', 'monkey', 'no', 'not', 'prohibited', 'see']",
                  "display": 1,
                  "translatedName": "Macaco Ver-No-Evil"
                },
                {
                  "code": "1f649",
                  "name": "hear-no-evil monkey",
                  "category": "nature",
                  "keywords": "['evil', 'face', 'forbidden', 'gesture', 'hear', 'monkey', 'no', 'not', 'prohibited']",
                  "display": 1,
                  "translatedName": "Macaco Hear-No-Evil"
                },
                {
                  "code": "1f64a",
                  "name": "speak-no-evil monkey",
                  "category": "nature",
                  "keywords": "['evil', 'face', 'forbidden', 'gesture', 'monkey', 'no', 'not', 'prohibited', 'speak']",
                  "display": 1,
                  "translatedName": "Macaco Não-Evil"
                },
                {
                  "code": "1f412",
                  "name": "monkey",
                  "category": "nature",
                  "keywords": "['monkey']",
                  "display": 1,
                  "translatedName": "macaco"
                },
                {
                  "code": "1f414",
                  "name": "chicken",
                  "category": "nature",
                  "keywords": "['bird', 'chicken']",
                  "display": 1,
                  "translatedName": "frango"
                },
                {
                  "code": "1f427",
                  "name": "penguin",
                  "category": "nature",
                  "keywords": "['bird', 'penguin']",
                  "display": 1,
                  "translatedName": "pinguim"
                },
                {
                  "code": "1f426",
                  "name": "bird",
                  "category": "nature",
                  "keywords": "['bird']",
                  "display": 1,
                  "translatedName": "pássaro"
                },
                {
                  "code": "1f424",
                  "name": "baby chick",
                  "category": "nature",
                  "keywords": "['baby', 'bird', 'chick']",
                  "display": 1,
                  "translatedName": "garota do bebê"
                },
                {
                  "code": "1f423",
                  "name": "hatching chick",
                  "category": "nature",
                  "keywords": "['baby', 'bird', 'chick', 'hatching']",
                  "display": 1,
                  "translatedName": "Chicking Chick"
                },
                {
                  "code": "1f425",
                  "name": "front-facing baby chick",
                  "category": "nature",
                  "keywords": "['baby', 'bird', 'chick']",
                  "display": 1,
                  "translatedName": "Pintainho de bebê voltado para frente"
                },
                {
                  "code": "1f986",
                  "name": "duck",
                  "category": "nature",
                  "keywords": "['bird', 'duck']",
                  "display": 1,
                  "translatedName": "Pato"
                },
                {
                  "code": "1f985",
                  "name": "eagle",
                  "category": "nature",
                  "keywords": "['bird', 'eagle']",
                  "display": 1,
                  "translatedName": "Águia"
                },
                {
                  "code": "1f989",
                  "name": "owl",
                  "category": "nature",
                  "keywords": "['bird', 'owl', 'wise']",
                  "display": 1,
                  "translatedName": "Coruja"
                },
                {
                  "code": "1f987",
                  "name": "bat",
                  "category": "nature",
                  "keywords": "['bat', 'vampire']",
                  "display": 1,
                  "translatedName": "bastão"
                },
                {
                  "code": "1f43a",
                  "name": "wolf face",
                  "category": "nature",
                  "keywords": "['face', 'wolf']",
                  "display": 1,
                  "translatedName": "cara de lobo."
                },
                {
                  "code": "1f417",
                  "name": "boar",
                  "category": "nature",
                  "keywords": "['pig']",
                  "display": 1,
                  "translatedName": "javali"
                },
                {
                  "code": "1f434",
                  "name": "horse face",
                  "category": "nature",
                  "keywords": "['face', 'horse']",
                  "display": 1,
                  "translatedName": "Cara de cavalo"
                },
                {
                  "code": "1f984",
                  "name": "unicorn face",
                  "category": "nature",
                  "keywords": "['face', 'unicorn']",
                  "display": 1,
                  "translatedName": "cara de unicórnio"
                },
                {
                  "code": "1f41d",
                  "name": "honeybee",
                  "category": "nature",
                  "keywords": "['bee', 'insect']",
                  "display": 1,
                  "translatedName": "Honeybee."
                },
                {
                  "code": "1f41b",
                  "name": "bug",
                  "category": "nature",
                  "keywords": "['insect']",
                  "display": 1,
                  "translatedName": "erro"
                },
                {
                  "code": "1f98b",
                  "name": "butterfly",
                  "category": "nature",
                  "keywords": "['butterfly', 'insect', 'pretty']",
                  "display": 1,
                  "translatedName": "borboleta"
                },
                {
                  "code": "1f40c",
                  "name": "snail",
                  "category": "nature",
                  "keywords": "['snail']",
                  "display": 1,
                  "translatedName": "Caracol"
                },
                {
                  "code": "1f41a",
                  "name": "spiral shell",
                  "category": "nature",
                  "keywords": "['shell', 'spiral']",
                  "display": 1,
                  "translatedName": "concha espiral"
                },
                {
                  "code": "1f41e",
                  "name": "lady beetle",
                  "category": "nature",
                  "keywords": "['beetle', 'insect', 'ladybird', 'ladybug']",
                  "display": 1,
                  "translatedName": "Lady Beetle."
                },
                {
                  "code": "1f41c",
                  "name": "ant",
                  "category": "nature",
                  "keywords": "['insect']",
                  "display": 1,
                  "translatedName": "formiga"
                },
                {
                  "code": "1f577",
                  "name": "spider",
                  "category": "nature",
                  "keywords": "['insect']",
                  "display": 1,
                  "translatedName": "aranha"
                },
                {
                  "code": "1f578",
                  "name": "spider web",
                  "category": "nature",
                  "keywords": "['spider', 'web']",
                  "display": 1,
                  "translatedName": "teia de aranha"
                },
                {
                  "code": "1f422",
                  "name": "turtle",
                  "category": "nature",
                  "keywords": "['terrapin', 'tortoise', 'turtle']",
                  "display": 1,
                  "translatedName": "tartaruga"
                },
                {
                  "code": "1f40d",
                  "name": "snake",
                  "category": "nature",
                  "keywords": "['Ophiuchus', 'bearer', 'serpent', 'zodiac']",
                  "display": 1,
                  "translatedName": "cobra"
                },
                {
                  "code": "1f98e",
                  "name": "lizard",
                  "category": "nature",
                  "keywords": "['lizard', 'reptile']",
                  "display": 1,
                  "translatedName": "Lagarto"
                },
                {
                  "code": "1f982",
                  "name": "scorpion",
                  "category": "nature",
                  "keywords": "['Scorpius', 'scorpio', 'zodiac']",
                  "display": 1,
                  "translatedName": "escorpião"
                },
                {
                  "code": "1f980",
                  "name": "crab",
                  "category": "nature",
                  "keywords": "['Cancer', 'zodiac']",
                  "display": 1,
                  "translatedName": "caranguejo"
                },
                {
                  "code": "1f991",
                  "name": "squid",
                  "category": "nature",
                  "keywords": "['food', 'molusc', 'squid']",
                  "display": 1,
                  "translatedName": "Lula"
                },
                {
                  "code": "1f419",
                  "name": "octopus",
                  "category": "nature",
                  "keywords": "['octopus']",
                  "display": 1,
                  "translatedName": "polvo"
                },
                {
                  "code": "1f990",
                  "name": "shrimp",
                  "category": "nature",
                  "keywords": "['food', 'shellfish', 'shrimp', 'small']",
                  "display": 1,
                  "translatedName": "camarão"
                },
                {
                  "code": "1f420",
                  "name": "tropical fish",
                  "category": "nature",
                  "keywords": "['fish', 'tropical']",
                  "display": 1,
                  "translatedName": "peixe tropical"
                },
                {
                  "code": "1f41f",
                  "name": "fish",
                  "category": "nature",
                  "keywords": "['Pisces', 'zodiac']",
                  "display": 1,
                  "translatedName": "peixe"
                },
                {
                  "code": "1f421",
                  "name": "blowfish",
                  "category": "nature",
                  "keywords": "['fish']",
                  "display": 1,
                  "translatedName": "blowfish"
                },
                {
                  "code": "1f42c",
                  "name": "dolphin",
                  "category": "nature",
                  "keywords": "['flipper']",
                  "display": 1,
                  "translatedName": "golfinho"
                },
                {
                  "code": "1f988",
                  "name": "shark",
                  "category": "nature",
                  "keywords": "['fish', 'shark']",
                  "display": 1,
                  "translatedName": "Tubarão"
                },
                {
                  "code": "1f433",
                  "name": "spouting whale",
                  "category": "nature",
                  "keywords": "['face', 'spouting', 'whale']",
                  "display": 1,
                  "translatedName": "baleia de jorrar"
                },
                {
                  "code": "1f40b",
                  "name": "whale",
                  "category": "nature",
                  "keywords": "['whale']",
                  "display": 1,
                  "translatedName": "baleia"
                },
                {
                  "code": "1f40a",
                  "name": "crocodile",
                  "category": "nature",
                  "keywords": "['crocodile']",
                  "display": 1,
                  "translatedName": "crocodilo"
                },
                {
                  "code": "1f406",
                  "name": "leopard",
                  "category": "nature",
                  "keywords": "['leopard']",
                  "display": 1,
                  "translatedName": "leopardo"
                },
                {
                  "code": "1f405",
                  "name": "tiger",
                  "category": "nature",
                  "keywords": "['tiger']",
                  "display": 1,
                  "translatedName": "tigre"
                },
                {
                  "code": "1f403",
                  "name": "water buffalo",
                  "category": "nature",
                  "keywords": "['buffalo', 'water']",
                  "display": 1,
                  "translatedName": "búfalo Marinho"
                },
                {
                  "code": "1f402",
                  "name": "ox",
                  "category": "nature",
                  "keywords": "['Taurus', 'bull', 'zodiac']",
                  "display": 1,
                  "translatedName": "boi"
                },
                {
                  "code": "1f404",
                  "name": "cow",
                  "category": "nature",
                  "keywords": "['cow']",
                  "display": 1,
                  "translatedName": "vaca"
                },
                {
                  "code": "1f98c",
                  "name": "deer",
                  "category": "nature",
                  "keywords": "['deer']",
                  "display": 1,
                  "translatedName": "cervo"
                },
                {
                  "code": "1f42a",
                  "name": "camel",
                  "category": "nature",
                  "keywords": "['dromedary', 'hump']",
                  "display": 1,
                  "translatedName": "camelo"
                },
                {
                  "code": "1f42b",
                  "name": "two-hump camel",
                  "category": "nature",
                  "keywords": "['bactrian', 'camel', 'hump']",
                  "display": 1,
                  "translatedName": "camelo de dois corcunda"
                },
                {
                  "code": "1f418",
                  "name": "elephant",
                  "category": "nature",
                  "keywords": "['elephant']",
                  "display": 1,
                  "translatedName": "elefante"
                },
                {
                  "code": "1f98f",
                  "name": "rhinoceros",
                  "category": "nature",
                  "keywords": "['rhinoceros']",
                  "display": 1,
                  "translatedName": "rinoceronte"
                },
                {
                  "code": "1f98d",
                  "name": "gorilla",
                  "category": "nature",
                  "keywords": "['gorilla']",
                  "display": 1,
                  "translatedName": "gorila"
                },
                {
                  "code": "1f40e",
                  "name": "horse",
                  "category": "nature",
                  "keywords": "['equestrian', 'racehorse', 'racing']",
                  "display": 1,
                  "translatedName": "cavalo"
                },
                {
                  "code": "1f416",
                  "name": "pig",
                  "category": "nature",
                  "keywords": "['sow']",
                  "display": 1,
                  "translatedName": "porco"
                },
                {
                  "code": "1f410",
                  "name": "goat",
                  "category": "nature",
                  "keywords": "['Capricorn', 'zodiac']",
                  "display": 1,
                  "translatedName": "cabra"
                },
                {
                  "code": "1f40f",
                  "name": "ram",
                  "category": "nature",
                  "keywords": "['Aries', 'male', 'sheep', 'zodiac']",
                  "display": 1,
                  "translatedName": "RAM"
                },
                {
                  "code": "1f411",
                  "name": "ewe",
                  "category": "nature",
                  "keywords": "['female', 'sheep']",
                  "display": 1,
                  "translatedName": "ovelha"
                },
                {
                  "code": "1f415",
                  "name": "dog",
                  "category": "nature",
                  "keywords": "['pet']",
                  "display": 1,
                  "translatedName": "cão"
                },
                {
                  "code": "1f429",
                  "name": "poodle",
                  "category": "nature",
                  "keywords": "['dog']",
                  "display": 1,
                  "translatedName": "poodle"
                },
                {
                  "code": "1f408",
                  "name": "cat",
                  "category": "nature",
                  "keywords": "['pet']",
                  "display": 1,
                  "translatedName": "gato"
                },
                {
                  "code": "1f413",
                  "name": "rooster",
                  "category": "nature",
                  "keywords": "['bird', 'rooster']",
                  "display": 1,
                  "translatedName": "Galo"
                },
                {
                  "code": "1f983",
                  "name": "turkey",
                  "category": "nature",
                  "keywords": "['bird', 'turkey']",
                  "display": 1,
                  "translatedName": "Turquia"
                },
                {
                  "code": "1f54a",
                  "name": "dove",
                  "category": "nature",
                  "keywords": "['bird', 'fly', 'peace']",
                  "display": 1,
                  "translatedName": "pomba"
                },
                {
                  "code": "1f407",
                  "name": "rabbit",
                  "category": "nature",
                  "keywords": "['bunny', 'pet']",
                  "display": 1,
                  "translatedName": "Coelho"
                },
                {
                  "code": "1f401",
                  "name": "mouse",
                  "category": "nature",
                  "keywords": "['mouse']",
                  "display": 1,
                  "translatedName": "mouse"
                },
                {
                  "code": "1f400",
                  "name": "rat",
                  "category": "nature",
                  "keywords": "['rat']",
                  "display": 1,
                  "translatedName": "rato"
                },
                {
                  "code": "1f43f",
                  "name": "chipmunk",
                  "category": "nature",
                  "keywords": "['chipmunk']",
                  "display": 1,
                  "translatedName": "Esquilo"
                },
                {
                  "code": "1f43e",
                  "name": "paw prints",
                  "category": "nature",
                  "keywords": "['feet', 'paw', 'print']",
                  "display": 1,
                  "translatedName": "pegadas"
                },
                {
                  "code": "1f409",
                  "name": "dragon",
                  "category": "nature",
                  "keywords": "['fairy tale']",
                  "display": 1,
                  "translatedName": "Dragão"
                },
                {
                  "code": "1f432",
                  "name": "dragon face",
                  "category": "nature",
                  "keywords": "['dragon', 'face', 'fairy tale']",
                  "display": 1,
                  "translatedName": "Face do dragão"
                },
                {
                  "code": "1f335",
                  "name": "cactus",
                  "category": "nature",
                  "keywords": "['plant']",
                  "display": 1,
                  "translatedName": "cacto"
                },
                {
                  "code": "1f384",
                  "name": "Christmas tree",
                  "category": "nature",
                  "keywords": "['Christmas', 'celebration', 'tree']",
                  "display": 1,
                  "translatedName": "árvore de Natal"
                },
                {
                  "code": "1f332",
                  "name": "evergreen tree",
                  "category": "nature",
                  "keywords": "['tree']",
                  "display": 1,
                  "translatedName": "Árvore Evergreen"
                },
                {
                  "code": "1f333",
                  "name": "deciduous tree",
                  "category": "nature",
                  "keywords": "['deciduous', 'shedding', 'tree']",
                  "display": 1,
                  "translatedName": "árvore de folhas secas"
                },
                {
                  "code": "1f334",
                  "name": "palm tree",
                  "category": "nature",
                  "keywords": "['palm', 'tree']",
                  "display": 1,
                  "translatedName": "Palmeira"
                },
                {
                  "code": "1f331",
                  "name": "seedling",
                  "category": "nature",
                  "keywords": "['young']",
                  "display": 1,
                  "translatedName": "plantinha"
                },
                {
                  "code": "1f33f",
                  "name": "herb",
                  "category": "nature",
                  "keywords": "['leaf']",
                  "display": 1,
                  "translatedName": "erva"
                },
                {
                  "code": 2618,
                  "name": "shamrock",
                  "category": "nature",
                  "keywords": "['plant']",
                  "display": 1,
                  "translatedName": "trevo"
                },
                {
                  "code": "1f340",
                  "name": "four leaf clover",
                  "category": "nature",
                  "keywords": "['4', 'clover', 'four', 'leaf']",
                  "display": 1,
                  "translatedName": "trevo-de-quatro-folhas"
                },
                {
                  "code": "1f38d",
                  "name": "pine decoration",
                  "category": "nature",
                  "keywords": "['Japanese', 'bamboo', 'celebration', 'pine']",
                  "display": 1,
                  "translatedName": "decoração de pinho"
                },
                {
                  "code": "1f38b",
                  "name": "tanabata tree",
                  "category": "nature",
                  "keywords": "['Japanese', 'banner', 'celebration', 'tree']",
                  "display": 1,
                  "translatedName": "Árvore Tanabata."
                },
                {
                  "code": "1f343",
                  "name": "leaf fluttering in wind",
                  "category": "nature",
                  "keywords": "['blow', 'flutter', 'leaf', 'wind']",
                  "display": 1,
                  "translatedName": "Folha tremulando no vento"
                },
                {
                  "code": "1f342",
                  "name": "fallen leaf",
                  "category": "nature",
                  "keywords": "['falling', 'leaf']",
                  "display": 1,
                  "translatedName": "folha caída"
                },
                {
                  "code": "1f341",
                  "name": "maple leaf",
                  "category": "nature",
                  "keywords": "['falling', 'leaf', 'maple']",
                  "display": 1,
                  "translatedName": "folha de Carvalho"
                },
                {
                  "code": "1f344",
                  "name": "mushroom",
                  "category": "nature",
                  "keywords": "['toadstool']",
                  "display": 1,
                  "translatedName": "cogumelo"
                },
                {
                  "code": "1f33e",
                  "name": "sheaf of rice",
                  "category": "nature",
                  "keywords": "['ear', 'grain', 'rice']",
                  "display": 1,
                  "translatedName": "feixe de arroz"
                },
                {
                  "code": "1f490",
                  "name": "bouquet",
                  "category": "nature",
                  "keywords": "['flower']",
                  "display": 1,
                  "translatedName": "ramalhete"
                },
                {
                  "code": "1f337",
                  "name": "tulip",
                  "category": "nature",
                  "keywords": "['flower']",
                  "display": 1,
                  "translatedName": "tulipa"
                },
                {
                  "code": "1f339",
                  "name": "rose",
                  "category": "nature",
                  "keywords": "['flower']",
                  "display": 1,
                  "translatedName": "Rosa"
                },
                {
                  "code": "1f940",
                  "name": "wilted flower",
                  "category": "nature",
                  "keywords": "['flower', 'wilted']",
                  "display": 1,
                  "translatedName": "Flor murcha"
                },
                {
                  "code": "1f33b",
                  "name": "sunflower",
                  "category": "nature",
                  "keywords": "['flower', 'sun']",
                  "display": 1,
                  "translatedName": "girassol"
                },
                {
                  "code": "1f33c",
                  "name": "blossom",
                  "category": "nature",
                  "keywords": "['flower']",
                  "display": 1,
                  "translatedName": "Flor"
                },
                {
                  "code": "1f338",
                  "name": "cherry blossom",
                  "category": "nature",
                  "keywords": "['blossom', 'cherry', 'flower']",
                  "display": 1,
                  "translatedName": "Flor de cerejeira"
                },
                {
                  "code": "1f33a",
                  "name": "hibiscus",
                  "category": "nature",
                  "keywords": "['flower']",
                  "display": 1,
                  "translatedName": "Hibiscus."
                },
                {
                  "code": "1f30e",
                  "name": "globe showing Americas",
                  "category": "nature",
                  "keywords": "['Americas', 'earth', 'globe', 'world']",
                  "display": 1,
                  "translatedName": "Globo mostrando as Américas"
                },
                {
                  "code": "1f30d",
                  "name": "globe showing Europe-Africa",
                  "category": "nature",
                  "keywords": "['Africa', 'Europe', 'earth', 'globe', 'world']",
                  "display": 1,
                  "translatedName": "Globo mostrando Europa-África"
                },
                {
                  "code": "1f30f",
                  "name": "globe showing Asia-Australia",
                  "category": "nature",
                  "keywords": "['Asia', 'Australia', 'earth', 'globe', 'world']",
                  "display": 1,
                  "translatedName": "Globo mostrando a Ásia-Austrália"
                },
                {
                  "code": "1f315",
                  "name": "full moon",
                  "category": "nature",
                  "keywords": "['full', 'moon']",
                  "display": 1,
                  "translatedName": "lua cheia"
                },
                {
                  "code": "1f316",
                  "name": "waning gibbous moon",
                  "category": "nature",
                  "keywords": "['gibbous', 'moon', 'waning']",
                  "display": 1,
                  "translatedName": "Lua Gibbous Waning."
                },
                {
                  "code": "1f317",
                  "name": "last quarter moon",
                  "category": "nature",
                  "keywords": "['moon', 'quarter']",
                  "display": 1,
                  "translatedName": "Último quarto da lua"
                },
                {
                  "code": "1f318",
                  "name": "waning crescent moon",
                  "category": "nature",
                  "keywords": "['crescent', 'moon', 'waning']",
                  "display": 1,
                  "translatedName": "Moon Crescent Waning."
                },
                {
                  "code": "1f311",
                  "name": "new moon",
                  "category": "nature",
                  "keywords": "['dark', 'moon']",
                  "display": 1,
                  "translatedName": "lua Nova"
                },
                {
                  "code": "1f312",
                  "name": "waxing crescent moon",
                  "category": "nature",
                  "keywords": "['crescent', 'moon', 'waxing']",
                  "display": 1,
                  "translatedName": "Despanhando a lua crescente"
                },
                {
                  "code": "1f313",
                  "name": "first quarter moon",
                  "category": "nature",
                  "keywords": "['moon', 'quarter']",
                  "display": 1,
                  "translatedName": "primeiro quarto da lua"
                },
                {
                  "code": "1f314",
                  "name": "waxing gibbous moon",
                  "category": "nature",
                  "keywords": "['gibbous', 'moon', 'waxing']",
                  "display": 1,
                  "translatedName": "Encerre a lua gibbous."
                },
                {
                  "code": "1f31a",
                  "name": "new moon face",
                  "category": "nature",
                  "keywords": "['face', 'moon']",
                  "display": 1,
                  "translatedName": "cara da nova lua"
                },
                {
                  "code": "1f31d",
                  "name": "full moon with face",
                  "category": "nature",
                  "keywords": "['bright', 'face', 'full', 'moon']",
                  "display": 1,
                  "translatedName": "Lua cheia com cara"
                },
                {
                  "code": "1f31e",
                  "name": "sun with face",
                  "category": "nature",
                  "keywords": "['bright', 'face', 'sun']",
                  "display": 1,
                  "translatedName": "Sol com cara"
                },
                {
                  "code": "1f31b",
                  "name": "first quarter moon with face",
                  "category": "nature",
                  "keywords": "['face', 'moon', 'quarter']",
                  "display": 1,
                  "translatedName": "Lua do primeiro quarto com cara"
                },
                {
                  "code": "1f31c",
                  "name": "last quarter moon with face",
                  "category": "nature",
                  "keywords": "['face', 'moon', 'quarter']",
                  "display": 1,
                  "translatedName": "Última lua de quarto com rosto"
                },
                {
                  "code": "1f319",
                  "name": "crescent moon",
                  "category": "nature",
                  "keywords": "['crescent', 'moon']",
                  "display": 1,
                  "translatedName": "lua crescente"
                },
                {
                  "code": "1f4ab",
                  "name": "dizzy",
                  "category": "nature",
                  "keywords": "['comic', 'star']",
                  "display": 1,
                  "translatedName": "tonto"
                },
                {
                  "code": "2b50",
                  "name": "white medium star",
                  "category": "nature",
                  "keywords": "['star']",
                  "display": 1,
                  "translatedName": "Estrela média branca"
                },
                {
                  "code": "1f31f",
                  "name": "glowing star",
                  "category": "nature",
                  "keywords": "['glittery', 'glow', 'shining', 'sparkle', 'star']",
                  "display": 1,
                  "translatedName": "estrela brilhante."
                },
                {
                  "code": 2728,
                  "name": "sparkles",
                  "category": "nature",
                  "keywords": "['sparkle', 'star']",
                  "display": 1,
                  "translatedName": "brilhos"
                },
                {
                  "code": "26a1",
                  "name": "high voltage",
                  "category": "nature",
                  "keywords": "['danger', 'electric', 'electricity', 'lightning', 'voltage', 'zap']",
                  "display": 1,
                  "translatedName": "alta voltagem"
                },
                {
                  "code": "1f525",
                  "name": "fire",
                  "category": "nature",
                  "keywords": "['flame', 'tool']",
                  "display": 1,
                  "translatedName": "incêndio"
                },
                {
                  "code": "1f4a5",
                  "name": "collision",
                  "category": "nature",
                  "keywords": "['boom', 'comic']",
                  "display": 1,
                  "translatedName": "colisão"
                },
                {
                  "code": 2604,
                  "name": "comet",
                  "category": "nature",
                  "keywords": "['space']",
                  "display": 1,
                  "translatedName": "cometa"
                },
                {
                  "code": 2600,
                  "name": "sun",
                  "category": "nature",
                  "keywords": "['bright', 'rays', 'sunny']",
                  "display": 1,
                  "translatedName": "sol"
                },
                {
                  "code": "1f324",
                  "name": "sun behind small cloud",
                  "category": "nature",
                  "keywords": "['cloud', 'sun']",
                  "display": 1,
                  "translatedName": "Sol atrás de pequena nuvem"
                },
                {
                  "code": "26c5",
                  "name": "sun behind cloud",
                  "category": "nature",
                  "keywords": "['cloud', 'sun']",
                  "display": 1,
                  "translatedName": "Sol atrás da nuvem"
                },
                {
                  "code": "1f325",
                  "name": "sun behind large cloud",
                  "category": "nature",
                  "keywords": "['cloud', 'sun']",
                  "display": 1,
                  "translatedName": "Sol atrás de grande nuvem"
                },
                {
                  "code": "1f326",
                  "name": "sun behind rain cloud",
                  "category": "nature",
                  "keywords": "['cloud', 'rain', 'sun']",
                  "display": 1,
                  "translatedName": "Sol atrás da nuvem de chuva"
                },
                {
                  "code": "1f308",
                  "name": "rainbow",
                  "category": "nature",
                  "keywords": "['rain']",
                  "display": 1,
                  "translatedName": "arco-íris"
                },
                {
                  "code": 2601,
                  "name": "cloud",
                  "category": "nature",
                  "keywords": "['weather']",
                  "display": 1,
                  "translatedName": "nuvem"
                },
                {
                  "code": "1f327",
                  "name": "cloud with rain",
                  "category": "nature",
                  "keywords": "['cloud', 'rain']",
                  "display": 1,
                  "translatedName": "nuvem com chuva"
                },
                {
                  "code": "26c8",
                  "name": "cloud with lightning and rain",
                  "category": "nature",
                  "keywords": "['cloud', 'rain', 'thunder']",
                  "display": 1,
                  "translatedName": "nuvem com relâmpago e chuva"
                },
                {
                  "code": "1f329",
                  "name": "cloud with lightning",
                  "category": "nature",
                  "keywords": "['cloud', 'lightning']",
                  "display": 1,
                  "translatedName": "Nuvem com relâmpago"
                },
                {
                  "code": "1f328",
                  "name": "cloud with snow",
                  "category": "nature",
                  "keywords": "['cloud', 'cold', 'snow']",
                  "display": 1,
                  "translatedName": "nuvem com neve"
                },
                {
                  "code": 2603,
                  "name": "snowman",
                  "category": "nature",
                  "keywords": "['cold', 'snow']",
                  "display": 1,
                  "translatedName": "boneco de neve"
                },
                {
                  "code": "26c4",
                  "name": "snowman without snow",
                  "category": "nature",
                  "keywords": "['cold', 'snow', 'snowman']",
                  "display": 1,
                  "translatedName": "Boneco de neve sem neve"
                },
                {
                  "code": 2744,
                  "name": "snowflake",
                  "category": "nature",
                  "keywords": "['cold', 'snow']",
                  "display": 1,
                  "translatedName": "floco de neve"
                },
                {
                  "code": "1f32c",
                  "name": "wind face",
                  "category": "nature",
                  "keywords": "['blow', 'cloud', 'face', 'wind']",
                  "display": 1,
                  "translatedName": "cara de vento"
                },
                {
                  "code": "1f4a8",
                  "name": "dashing away",
                  "category": "nature",
                  "keywords": "['comic', 'dash', 'running']",
                  "display": 1,
                  "translatedName": "arremessando"
                },
                {
                  "code": "1f32a",
                  "name": "tornado",
                  "category": "nature",
                  "keywords": "['cloud', 'whirlwind']",
                  "display": 1,
                  "translatedName": "tornado"
                },
                {
                  "code": "1f32b",
                  "name": "fog",
                  "category": "nature",
                  "keywords": "['cloud']",
                  "display": 1,
                  "translatedName": "névoa"
                },
                {
                  "code": "1f30a",
                  "name": "water wave",
                  "category": "nature",
                  "keywords": "['ocean', 'water', 'wave']",
                  "display": 1,
                  "translatedName": "onda de água"
                },
                {
                  "code": "1f4a7",
                  "name": "droplet",
                  "category": "nature",
                  "keywords": "['cold', 'comic', 'drop', 'sweat']",
                  "display": 1,
                  "translatedName": "gotícula"
                },
                {
                  "code": "1f4a6",
                  "name": "sweat droplets",
                  "category": "nature",
                  "keywords": "['comic', 'splashing', 'sweat']",
                  "display": 1,
                  "translatedName": "gotas de suor"
                },
                {
                  "code": 2614,
                  "name": "umbrella with rain drops",
                  "category": "nature",
                  "keywords": "['clothing', 'drop', 'rain', 'umbrella']",
                  "display": 1,
                  "translatedName": "Guarda-chuva com gotas de chuva"
                },
                {
                  "code": "1f992",
                  "name": "giraffe",
                  "category": "nature",
                  "keywords": "['spots']",
                  "display": 1,
                  "translatedName": "girafa"
                },
                {
                  "code": "1f993",
                  "name": "zebra",
                  "category": "nature",
                  "keywords": "['stripe']",
                  "display": 1,
                  "translatedName": "zebra"
                },
                {
                  "code": "1f994",
                  "name": "hedgehog",
                  "category": "nature",
                  "keywords": "['spiny']",
                  "display": 1,
                  "translatedName": "ouriço"
                },
                {
                  "code": "1f995",
                  "name": "sauropod",
                  "category": "nature",
                  "keywords": "['brachiosaurus', 'brontosaurus', 'diplodocus']",
                  "display": 1,
                  "translatedName": "saurópod."
                },
                {
                  "code": "1f996",
                  "name": "T-Rex",
                  "category": "nature",
                  "keywords": "['Tyrannosaurus Rex']",
                  "display": 1,
                  "translatedName": "T-rex."
                },
                {
                  "code": "1f997",
                  "name": "cricket",
                  "category": "nature",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "Grilo"
                },
                {
                  "code": "1f34f",
                  "name": "green apple",
                  "category": "food",
                  "keywords": "['apple', 'fruit', 'green']",
                  "display": 1,
                  "translatedName": "maçã verde"
                },
                {
                  "code": "1f34e",
                  "name": "red apple",
                  "category": "food",
                  "keywords": "['apple', 'fruit', 'red']",
                  "display": 1,
                  "translatedName": "maçã vermelha"
                },
                {
                  "code": "1f350",
                  "name": "pear",
                  "category": "food",
                  "keywords": "['fruit']",
                  "display": 1,
                  "translatedName": "pera"
                },
                {
                  "code": "1f34a",
                  "name": "tangerine",
                  "category": "food",
                  "keywords": "['fruit', 'orange']",
                  "display": 1,
                  "translatedName": "tangerina"
                },
                {
                  "code": "1f34b",
                  "name": "lemon",
                  "category": "food",
                  "keywords": "['citrus', 'fruit']",
                  "display": 1,
                  "translatedName": "limão"
                },
                {
                  "code": "1f34c",
                  "name": "banana",
                  "category": "food",
                  "keywords": "['fruit']",
                  "display": 1,
                  "translatedName": "banana"
                },
                {
                  "code": "1f349",
                  "name": "watermelon",
                  "category": "food",
                  "keywords": "['fruit']",
                  "display": 1,
                  "translatedName": "Melancia"
                },
                {
                  "code": "1f347",
                  "name": "grapes",
                  "category": "food",
                  "keywords": "['fruit', 'grape']",
                  "display": 1,
                  "translatedName": "uvas"
                },
                {
                  "code": "1f353",
                  "name": "strawberry",
                  "category": "food",
                  "keywords": "['berry', 'fruit']",
                  "display": 1,
                  "translatedName": "morango"
                },
                {
                  "code": "1f348",
                  "name": "melon",
                  "category": "food",
                  "keywords": "['fruit']",
                  "display": 1,
                  "translatedName": "Melão"
                },
                {
                  "code": "1f352",
                  "name": "cherries",
                  "category": "food",
                  "keywords": "['cherry', 'fruit']",
                  "display": 1,
                  "translatedName": "cerejas"
                },
                {
                  "code": "1f351",
                  "name": "peach",
                  "category": "food",
                  "keywords": "['fruit']",
                  "display": 1,
                  "translatedName": "pêssego"
                },
                {
                  "code": "1f34d",
                  "name": "pineapple",
                  "category": "food",
                  "keywords": "['fruit']",
                  "display": 1,
                  "translatedName": "abacaxi"
                },
                {
                  "code": "1f95d",
                  "name": "kiwi fruit",
                  "category": "food",
                  "keywords": "['food', 'fruit', 'kiwi']",
                  "display": 1,
                  "translatedName": "Kiwi Fruit."
                },
                {
                  "code": "1f951",
                  "name": "avocado",
                  "category": "food",
                  "keywords": "['avocado', 'food', 'fruit']",
                  "display": 1,
                  "translatedName": "abacate"
                },
                {
                  "code": "1f345",
                  "name": "tomato",
                  "category": "food",
                  "keywords": "['fruit', 'vegetable']",
                  "display": 1,
                  "translatedName": "tomate"
                },
                {
                  "code": "1f346",
                  "name": "eggplant",
                  "category": "food",
                  "keywords": "['aubergine', 'vegetable']",
                  "display": 1,
                  "translatedName": "beringela"
                },
                {
                  "code": "1f952",
                  "name": "cucumber",
                  "category": "food",
                  "keywords": "['cucumber', 'food', 'pickle', 'vegetable']",
                  "display": 1,
                  "translatedName": "pepino"
                },
                {
                  "code": "1f955",
                  "name": "carrot",
                  "category": "food",
                  "keywords": "['carrot', 'food', 'vegetable']",
                  "display": 1,
                  "translatedName": "cenoura"
                },
                {
                  "code": "1f33d",
                  "name": "ear of corn",
                  "category": "food",
                  "keywords": "['corn', 'ear', 'maize', 'maze']",
                  "display": 1,
                  "translatedName": "espiga de milho"
                },
                {
                  "code": "1f336",
                  "name": "hot pepper",
                  "category": "food",
                  "keywords": "['hot', 'pepper']",
                  "display": 1,
                  "translatedName": "pimenta quente"
                },
                {
                  "code": "1f954",
                  "name": "potato",
                  "category": "food",
                  "keywords": "['food', 'potato', 'vegetable']",
                  "display": 1,
                  "translatedName": "batata"
                },
                {
                  "code": "1f360",
                  "name": "roasted sweet potato",
                  "category": "food",
                  "keywords": "['potato', 'roasted', 'sweet']",
                  "display": 1,
                  "translatedName": "batata doce assada"
                },
                {
                  "code": "1f330",
                  "name": "chestnut",
                  "category": "food",
                  "keywords": "['plant']",
                  "display": 1,
                  "translatedName": "castanha"
                },
                {
                  "code": "1f95c",
                  "name": "peanuts",
                  "category": "food",
                  "keywords": "['food', 'nut', 'peanut', 'vegetable']",
                  "display": 1,
                  "translatedName": "amendoim"
                },
                {
                  "code": "1f36f",
                  "name": "honey pot",
                  "category": "food",
                  "keywords": "['honey', 'honeypot', 'pot', 'sweet']",
                  "display": 1,
                  "translatedName": "pote de mel"
                },
                {
                  "code": "1f950",
                  "name": "croissant",
                  "category": "food",
                  "keywords": "['bread', 'crescent roll', 'croissant', 'food', 'french']",
                  "display": 1,
                  "translatedName": "croissant"
                },
                {
                  "code": "1f35e",
                  "name": "bread",
                  "category": "food",
                  "keywords": "['loaf']",
                  "display": 1,
                  "translatedName": "pão"
                },
                {
                  "code": "1f956",
                  "name": "baguette bread",
                  "category": "food",
                  "keywords": "['baguette', 'bread', 'food', 'french']",
                  "display": 1,
                  "translatedName": "Pão de baguete"
                },
                {
                  "code": "1f9c0",
                  "name": "cheese wedge",
                  "category": "food",
                  "keywords": "['cheese']",
                  "display": 1,
                  "translatedName": "cunha de queijo."
                },
                {
                  "code": "1f95a",
                  "name": "egg",
                  "category": "food",
                  "keywords": "['egg', 'food']",
                  "display": 1,
                  "translatedName": "ovo"
                },
                {
                  "code": "1f373",
                  "name": "cooking",
                  "category": "food",
                  "keywords": "['egg', 'frying', 'pan']",
                  "display": 1,
                  "translatedName": "cozinhando"
                },
                {
                  "code": "1f953",
                  "name": "bacon",
                  "category": "food",
                  "keywords": "['bacon', 'food', 'meat']",
                  "display": 1,
                  "translatedName": "bacon"
                },
                {
                  "code": "1f95e",
                  "name": "pancakes",
                  "category": "food",
                  "keywords": "['crêpe', 'food', 'hotcake', 'pancake']",
                  "display": 1,
                  "translatedName": "panquecas"
                },
                {
                  "code": "1f364",
                  "name": "fried shrimp",
                  "category": "food",
                  "keywords": "['fried', 'prawn', 'shrimp', 'tempura']",
                  "display": 1,
                  "translatedName": "camarão frito"
                },
                {
                  "code": "1f357",
                  "name": "poultry leg",
                  "category": "food",
                  "keywords": "['bone', 'chicken', 'leg', 'poultry']",
                  "display": 1,
                  "translatedName": "perna de aves"
                },
                {
                  "code": "1f356",
                  "name": "meat on bone",
                  "category": "food",
                  "keywords": "['bone', 'meat']",
                  "display": 1,
                  "translatedName": "carne no osso"
                },
                {
                  "code": "1f355",
                  "name": "pizza",
                  "category": "food",
                  "keywords": "['cheese', 'slice']",
                  "display": 1,
                  "translatedName": "pizza"
                },
                {
                  "code": "1f32d",
                  "name": "hot dog",
                  "category": "food",
                  "keywords": "['frankfurter', 'hotdog', 'sausage']",
                  "display": 1,
                  "translatedName": "cachorro-quente"
                },
                {
                  "code": "1f354",
                  "name": "hamburger",
                  "category": "food",
                  "keywords": "['burger']",
                  "display": 1,
                  "translatedName": "Hamburger"
                },
                {
                  "code": "1f35f",
                  "name": "french fries",
                  "category": "food",
                  "keywords": "['french', 'fries']",
                  "display": 1,
                  "translatedName": "batatas fritas"
                },
                {
                  "code": "1f959",
                  "name": "stuffed flatbread",
                  "category": "food",
                  "keywords": "['falafel', 'flatbread', 'food', 'gyro', 'kebab', 'stuffed']",
                  "display": 1,
                  "translatedName": "flatbread recheado"
                },
                {
                  "code": "1f32e",
                  "name": "taco",
                  "category": "food",
                  "keywords": "['mexican']",
                  "display": 1,
                  "translatedName": "taco."
                },
                {
                  "code": "1f32f",
                  "name": "burrito",
                  "category": "food",
                  "keywords": "['mexican', 'wrap']",
                  "display": 1,
                  "translatedName": "burrito"
                },
                {
                  "code": "1f957",
                  "name": "green salad",
                  "category": "food",
                  "keywords": "['food', 'green', 'salad']",
                  "display": 1,
                  "translatedName": "salada verde"
                },
                {
                  "code": "1f958",
                  "name": "shallow pan of food",
                  "category": "food",
                  "keywords": "['casserole', 'food', 'paella', 'pan', 'shallow']",
                  "display": 1,
                  "translatedName": "Panela rasa de alimentos"
                },
                {
                  "code": "1f35d",
                  "name": "spaghetti",
                  "category": "food",
                  "keywords": "['pasta']",
                  "display": 1,
                  "translatedName": "espaguete"
                },
                {
                  "code": "1f35c",
                  "name": "steaming bowl",
                  "category": "food",
                  "keywords": "['bowl', 'noodle', 'ramen', 'steaming']",
                  "display": 1,
                  "translatedName": "Bacia fumegante"
                },
                {
                  "code": "1f372",
                  "name": "pot of food",
                  "category": "food",
                  "keywords": "['pot', 'stew']",
                  "display": 1,
                  "translatedName": "pote de comida"
                },
                {
                  "code": "1f365",
                  "name": "fish cake with swirl",
                  "category": "food",
                  "keywords": "['cake', 'fish', 'pastry', 'swirl']",
                  "display": 1,
                  "translatedName": "Bolo de peixe com redemoinho"
                },
                {
                  "code": "1f363",
                  "name": "sushi",
                  "category": "food",
                  "keywords": "['sushi']",
                  "display": 1,
                  "translatedName": "Sushi"
                },
                {
                  "code": "1f371",
                  "name": "bento box",
                  "category": "food",
                  "keywords": "['bento', 'box']",
                  "display": 1,
                  "translatedName": "Bento Box."
                },
                {
                  "code": "1f35b",
                  "name": "curry rice",
                  "category": "food",
                  "keywords": "['curry', 'rice']",
                  "display": 1,
                  "translatedName": "arroz de curry"
                },
                {
                  "code": "1f359",
                  "name": "rice ball",
                  "category": "food",
                  "keywords": "['Japanese', 'ball', 'rice']",
                  "display": 1,
                  "translatedName": "bola de arroz"
                },
                {
                  "code": "1f35a",
                  "name": "cooked rice",
                  "category": "food",
                  "keywords": "['cooked', 'rice']",
                  "display": 1,
                  "translatedName": "arroz cozido"
                },
                {
                  "code": "1f358",
                  "name": "rice cracker",
                  "category": "food",
                  "keywords": "['cracker', 'rice']",
                  "display": 1,
                  "translatedName": "Cracker de arroz"
                },
                {
                  "code": "1f362",
                  "name": "oden",
                  "category": "food",
                  "keywords": "['kebab', 'seafood', 'skewer', 'stick']",
                  "display": 1,
                  "translatedName": "oden."
                },
                {
                  "code": "1f361",
                  "name": "dango",
                  "category": "food",
                  "keywords": "['Japanese', 'dessert', 'skewer', 'stick', 'sweet']",
                  "display": 1,
                  "translatedName": "DANGO."
                },
                {
                  "code": "1f367",
                  "name": "shaved ice",
                  "category": "food",
                  "keywords": "['dessert', 'ice', 'shaved', 'sweet']",
                  "display": 1,
                  "translatedName": "gelo raspado"
                },
                {
                  "code": "1f368",
                  "name": "ice cream",
                  "category": "food",
                  "keywords": "['cream', 'dessert', 'ice', 'sweet']",
                  "display": 1,
                  "translatedName": "sorvete"
                },
                {
                  "code": "1f366",
                  "name": "soft ice cream",
                  "category": "food",
                  "keywords": "['cream', 'dessert', 'ice', 'icecream', 'soft', 'sweet']",
                  "display": 1,
                  "translatedName": "sorvete macio"
                },
                {
                  "code": "1f370",
                  "name": "shortcake",
                  "category": "food",
                  "keywords": "['cake', 'dessert', 'pastry', 'slice', 'sweet']",
                  "display": 1,
                  "translatedName": "Shortcake"
                },
                {
                  "code": "1f382",
                  "name": "birthday cake",
                  "category": "food",
                  "keywords": "['birthday', 'cake', 'celebration', 'dessert', 'pastry', 'sweet']",
                  "display": 1,
                  "translatedName": "bolo de aniversário"
                },
                {
                  "code": "1f36e",
                  "name": "custard",
                  "category": "food",
                  "keywords": "['dessert', 'pudding', 'sweet']",
                  "display": 1,
                  "translatedName": "Quindim"
                },
                {
                  "code": "1f36d",
                  "name": "lollipop",
                  "category": "food",
                  "keywords": "['candy', 'dessert', 'sweet']",
                  "display": 1,
                  "translatedName": "pirulito"
                },
                {
                  "code": "1f36c",
                  "name": "candy",
                  "category": "food",
                  "keywords": "['dessert', 'sweet']",
                  "display": 1,
                  "translatedName": "doce"
                },
                {
                  "code": "1f36b",
                  "name": "chocolate bar",
                  "category": "food",
                  "keywords": "['bar', 'chocolate', 'dessert', 'sweet']",
                  "display": 1,
                  "translatedName": "Barra de chocolate"
                },
                {
                  "code": "1f37f",
                  "name": "popcorn",
                  "category": "food",
                  "keywords": "['popcorn']",
                  "display": 1,
                  "translatedName": "Pipoca"
                },
                {
                  "code": "1f369",
                  "name": "doughnut",
                  "category": "food",
                  "keywords": "['dessert', 'donut', 'sweet']",
                  "display": 1,
                  "translatedName": "rosquinha"
                },
                {
                  "code": "1f36a",
                  "name": "cookie",
                  "category": "food",
                  "keywords": "['dessert', 'sweet']",
                  "display": 1,
                  "translatedName": "biscoito"
                },
                {
                  "code": "1f95b",
                  "name": "glass of milk",
                  "category": "food",
                  "keywords": "['drink', 'glass', 'milk']",
                  "display": 1,
                  "translatedName": "copo de leite"
                },
                {
                  "code": "1f37c",
                  "name": "baby bottle",
                  "category": "food",
                  "keywords": "['baby', 'bottle', 'drink', 'milk']",
                  "display": 1,
                  "translatedName": "Mamadeira"
                },
                {
                  "code": 2615,
                  "name": "hot beverage",
                  "category": "food",
                  "keywords": "['beverage', 'coffee', 'drink', 'hot', 'steaming', 'tea']",
                  "display": 1,
                  "translatedName": "bebida quente"
                },
                {
                  "code": "1f375",
                  "name": "teacup without handle",
                  "category": "food",
                  "keywords": "['beverage', 'cup', 'drink', 'tea', 'teacup']",
                  "display": 1,
                  "translatedName": "xícara de chá sem cabo"
                },
                {
                  "code": "1f376",
                  "name": "sake",
                  "category": "food",
                  "keywords": "['bar', 'beverage', 'bottle', 'cup', 'drink']",
                  "display": 1,
                  "translatedName": "interesse"
                },
                {
                  "code": "1f37a",
                  "name": "beer mug",
                  "category": "food",
                  "keywords": "['bar', 'beer', 'drink', 'mug']",
                  "display": 1,
                  "translatedName": "Caneca de cerveja"
                },
                {
                  "code": "1f37b",
                  "name": "clinking beer mugs",
                  "category": "food",
                  "keywords": "['bar', 'beer', 'clink', 'drink', 'mug']",
                  "display": 1,
                  "translatedName": "Canecas de cerveja tilinting"
                },
                {
                  "code": "1f942",
                  "name": "clinking glasses",
                  "category": "food",
                  "keywords": "['celebrate', 'clink', 'drink', 'glass']",
                  "display": 1,
                  "translatedName": "copos clinking"
                },
                {
                  "code": "1f377",
                  "name": "wine glass",
                  "category": "food",
                  "keywords": "['bar', 'beverage', 'drink', 'glass', 'wine']",
                  "display": 1,
                  "translatedName": "copo de vinho"
                },
                {
                  "code": "1f943",
                  "name": "tumbler glass",
                  "category": "food",
                  "keywords": "['glass', 'liquor', 'shot', 'tumbler', 'whisky']",
                  "display": 1,
                  "translatedName": "copo de tumbler."
                },
                {
                  "code": "1f378",
                  "name": "cocktail glass",
                  "category": "food",
                  "keywords": "['bar', 'cocktail', 'drink', 'glass']",
                  "display": 1,
                  "translatedName": "copo de copo"
                },
                {
                  "code": "1f379",
                  "name": "tropical drink",
                  "category": "food",
                  "keywords": "['bar', 'drink', 'tropical']",
                  "display": 1,
                  "translatedName": "Bebida tropical"
                },
                {
                  "code": "1f37e",
                  "name": "bottle with popping cork",
                  "category": "food",
                  "keywords": "['bar', 'bottle', 'cork', 'drink', 'popping']",
                  "display": 1,
                  "translatedName": "garrafa com estalo de cortiça"
                },
                {
                  "code": "1f944",
                  "name": "spoon",
                  "category": "food",
                  "keywords": "['spoon', 'tableware']",
                  "display": 1,
                  "translatedName": "colher"
                },
                {
                  "code": "1f374",
                  "name": "fork and knife",
                  "category": "food",
                  "keywords": "['cooking', 'fork', 'knife']",
                  "display": 1,
                  "translatedName": "garfo e faca"
                },
                {
                  "code": "1f37d",
                  "name": "fork and knife with plate",
                  "category": "food",
                  "keywords": "['cooking', 'fork', 'knife', 'plate']",
                  "display": 1,
                  "translatedName": "garfo e faca com placa"
                },
                {
                  "code": "1f95f",
                  "name": "dumpling",
                  "category": "food",
                  "keywords": "['empanada', 'gyōza', 'jiaozi', 'pierogi', 'potsticker']",
                  "display": 1,
                  "translatedName": "bolinho de massa"
                },
                {
                  "code": "1f960",
                  "name": "fortune cookie",
                  "category": "food",
                  "keywords": "['prophecy']",
                  "display": 1,
                  "translatedName": "biscoito da sorte"
                },
                {
                  "code": "1f961",
                  "name": "takeout box",
                  "category": "food",
                  "keywords": "['oyster pail']",
                  "display": 1,
                  "translatedName": "Caixa de takeout"
                },
                {
                  "code": "1f962",
                  "name": "chopsticks",
                  "category": "food",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "pauzinhos"
                },
                {
                  "code": "1f963",
                  "name": "bowl with spoon",
                  "category": "food",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "Tigela com colher"
                },
                {
                  "code": "1f964",
                  "name": "cup with straw",
                  "category": "food",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "Copo com palha"
                },
                {
                  "code": "1f965",
                  "name": "coconut",
                  "category": "food",
                  "keywords": "['palm', 'piña colada']",
                  "display": 1,
                  "translatedName": "coco"
                },
                {
                  "code": "1f966",
                  "name": "broccoli",
                  "category": "food",
                  "keywords": "['wild cabbage']",
                  "display": 1,
                  "translatedName": "brócolis"
                },
                {
                  "code": "1f967",
                  "name": "pie",
                  "category": "food",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "torta"
                },
                {
                  "code": "1f968",
                  "name": "pretzel",
                  "category": "food",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "pretzel"
                },
                {
                  "code": "1f969",
                  "name": "cut of meat",
                  "category": "food",
                  "keywords": "['chop', 'lambchop', 'porkchop', 'steak']",
                  "display": 1,
                  "translatedName": "Corte de carne"
                },
                {
                  "code": "1f96a",
                  "name": "sandwich",
                  "category": "food",
                  "keywords": "['bread']",
                  "display": 1,
                  "translatedName": "sanduíche"
                },
                {
                  "code": "1f96b",
                  "name": "canned food",
                  "category": "food",
                  "keywords": "['can']",
                  "display": 1,
                  "translatedName": "comida enlatada"
                },
                {
                  "code": "26bd",
                  "name": "soccer ball",
                  "category": "activity",
                  "keywords": "['ball', 'football', 'soccer']",
                  "display": 1,
                  "translatedName": "bola de futebol"
                },
                {
                  "code": "1f3c0",
                  "name": "basketball",
                  "category": "activity",
                  "keywords": "['ball', 'hoop']",
                  "display": 1,
                  "translatedName": "basquetebol"
                },
                {
                  "code": "1f3c8",
                  "name": "american football",
                  "category": "activity",
                  "keywords": "['american', 'ball', 'football']",
                  "display": 1,
                  "translatedName": "futebol americano"
                },
                {
                  "code": "26be",
                  "name": "baseball",
                  "category": "activity",
                  "keywords": "['ball']",
                  "display": 1,
                  "translatedName": "baseball"
                },
                {
                  "code": "1f3be",
                  "name": "tennis",
                  "category": "activity",
                  "keywords": "['ball', 'racquet']",
                  "display": 1,
                  "translatedName": "tênis"
                },
                {
                  "code": "1f3d0",
                  "name": "volleyball",
                  "category": "activity",
                  "keywords": "['ball', 'game']",
                  "display": 1,
                  "translatedName": "voleibol"
                },
                {
                  "code": "1f3c9",
                  "name": "rugby football",
                  "category": "activity",
                  "keywords": "['ball', 'football', 'rugby']",
                  "display": 1,
                  "translatedName": "futebol de rugby."
                },
                {
                  "code": "1f3b1",
                  "name": "pool 8 ball",
                  "category": "activity",
                  "keywords": "['8', '8 ball', 'ball', 'billiard', 'eight', 'game']",
                  "display": 1,
                  "translatedName": "Pool 8 Ball."
                },
                {
                  "code": "1f3d3",
                  "name": "ping pong",
                  "category": "activity",
                  "keywords": "['ball', 'bat', 'game', 'paddle', 'ping pong', 'table tennis']",
                  "display": 1,
                  "translatedName": "pingue-pongue"
                },
                {
                  "code": "1f3f8",
                  "name": "badminton",
                  "category": "activity",
                  "keywords": "['birdie', 'game', 'racquet', 'shuttlecock']",
                  "display": 1,
                  "translatedName": "badminton"
                },
                {
                  "code": "1f945",
                  "name": "goal net",
                  "category": "activity",
                  "keywords": "['goal', 'net']",
                  "display": 1,
                  "translatedName": "Net Net."
                },
                {
                  "code": "1f3d2",
                  "name": "ice hockey",
                  "category": "activity",
                  "keywords": "['game', 'hockey', 'ice', 'puck', 'stick']",
                  "display": 1,
                  "translatedName": "Hockey no gelo"
                },
                {
                  "code": "1f3d1",
                  "name": "field hockey",
                  "category": "activity",
                  "keywords": "['ball', 'field', 'game', 'hockey', 'stick']",
                  "display": 1,
                  "translatedName": "hóquei em campo"
                },
                {
                  "code": "1f3cf",
                  "name": "cricket game",
                  "category": "activity",
                  "keywords": "['ball', 'bat', 'game']",
                  "display": 1,
                  "translatedName": "Jogo de críquete"
                },
                {
                  "code": "26f3",
                  "name": "flag in hole",
                  "category": "activity",
                  "keywords": "['golf', 'hole']",
                  "display": 1,
                  "translatedName": "Bandeira no buraco"
                },
                {
                  "code": "1f3f9",
                  "name": "bow and arrow",
                  "category": "activity",
                  "keywords": "['Sagittarius', 'archer', 'archery', 'arrow', 'bow', 'tool', 'weapon', 'zodiac']",
                  "display": 1,
                  "translatedName": "arco e flecha"
                },
                {
                  "code": "1f3a3",
                  "name": "fishing pole",
                  "category": "activity",
                  "keywords": "['fish', 'pole']",
                  "display": 1,
                  "translatedName": "Vara de pescar"
                },
                {
                  "code": "1f94a",
                  "name": "boxing glove",
                  "category": "activity",
                  "keywords": "['boxing', 'glove']",
                  "display": 1,
                  "translatedName": "luva de boxe"
                },
                {
                  "code": "1f94b",
                  "name": "martial arts uniform",
                  "category": "activity",
                  "keywords": "['judo', 'karate', 'martial arts', 'taekwondo', 'uniform']",
                  "display": 1,
                  "translatedName": "uniforme de artes marciais"
                },
                {
                  "code": "26f8",
                  "name": "ice skate",
                  "category": "activity",
                  "keywords": "['ice', 'skate']",
                  "display": 1,
                  "translatedName": "patins de gelo"
                },
                {
                  "code": "1f3bf",
                  "name": "skis",
                  "category": "activity",
                  "keywords": "['ski', 'snow']",
                  "display": 1,
                  "translatedName": "esquis."
                },
                {
                  "code": "26f7",
                  "name": "skier",
                  "category": "activity",
                  "keywords": "['ski', 'snow']",
                  "display": 1,
                  "translatedName": "esquiador"
                },
                {
                  "code": "1f3c2",
                  "name": "snowboarder",
                  "category": "activity",
                  "keywords": "['ski', 'snow', 'snowboard']",
                  "display": 1,
                  "translatedName": "snowboarder."
                },
                {
                  "code": "1f3cb-2640",
                  "name": "woman lifting weights",
                  "category": "activity",
                  "keywords": "['weight lifter', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher levantando pesos"
                },
                {
                  "code": "1f3cb",
                  "name": "person lifting weights",
                  "category": "activity",
                  "keywords": "['lifter', 'weight']",
                  "display": 1,
                  "translatedName": "Pessoa levantando pesos"
                },
                {
                  "code": "1f3cb-2642",
                  "name": "man lifting weights",
                  "category": "activity",
                  "keywords": "['man', 'weight lifter']",
                  "display": 0,
                  "translatedName": "Homem levantando pesos"
                },
                {
                  "code": "1f93a",
                  "name": "person fencing",
                  "category": "activity",
                  "keywords": "['fencer', 'fencing', 'sword']",
                  "display": 1,
                  "translatedName": "Esgrima pessoa"
                },
                {
                  "code": "1f93c-2640",
                  "name": "women wrestling",
                  "category": "activity",
                  "keywords": "['women', 'wrestle']",
                  "display": 1,
                  "translatedName": "Mulheres wrestling"
                },
                {
                  "code": "1f93c-2642",
                  "name": "men wrestling",
                  "category": "activity",
                  "keywords": "['men', 'wrestle']",
                  "display": 1,
                  "translatedName": "Homens wrestling"
                },
                {
                  "code": "1f93c",
                  "name": "people wrestling",
                  "category": "activity",
                  "keywords": "['wrestle', 'wrestler']",
                  "display": 0,
                  "translatedName": "wrestling de pessoas"
                },
                {
                  "code": "1f938-2640",
                  "name": "woman cartwheeling",
                  "category": "activity",
                  "keywords": "['cartwheel', 'gymnastics', 'woman']",
                  "display": 1,
                  "translatedName": "Cartwheeling da mulher"
                },
                {
                  "code": "1f938-2642",
                  "name": "man cartwheeling",
                  "category": "activity",
                  "keywords": "['cartwheel', 'gymnastics', 'man']",
                  "display": 1,
                  "translatedName": "Cartwheeling do homem"
                },
                {
                  "code": "1f938",
                  "name": "person cartwheeling",
                  "category": "activity",
                  "keywords": "['cartwheel', 'gymnastics']",
                  "display": 0,
                  "translatedName": "Cartwheeling de pessoa"
                },
                {
                  "code": "26f9-2640",
                  "name": "woman bouncing ball",
                  "category": "activity",
                  "keywords": "['ball', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher saltando bola"
                },
                {
                  "code": "26f9",
                  "name": "person bouncing ball",
                  "category": "activity",
                  "keywords": "['ball']",
                  "display": 1,
                  "translatedName": "Pessoa saltando bola"
                },
                {
                  "code": "26f9-2642",
                  "name": "man bouncing ball",
                  "category": "activity",
                  "keywords": "['ball', 'man']",
                  "display": 0,
                  "translatedName": "Homem saltando bola"
                },
                {
                  "code": "1f93e-2640",
                  "name": "woman playing handball",
                  "category": "activity",
                  "keywords": "['handball', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher jogando handebol"
                },
                {
                  "code": "1f93e-2642",
                  "name": "man playing handball",
                  "category": "activity",
                  "keywords": "['handball', 'man']",
                  "display": 1,
                  "translatedName": "Homem jogando handebol"
                },
                {
                  "code": "1f93e",
                  "name": "person playing handball",
                  "category": "activity",
                  "keywords": "['ball', 'handball']",
                  "display": 0,
                  "translatedName": "Pessoa jogando handebol"
                },
                {
                  "code": "1f3cc-2640",
                  "name": "woman golfing",
                  "category": "activity",
                  "keywords": "['golf', 'woman']",
                  "display": 1,
                  "translatedName": "mulher golfe"
                },
                {
                  "code": "1f3cc",
                  "name": "person golfing",
                  "category": "activity",
                  "keywords": "['ball', 'golf']",
                  "display": 1,
                  "translatedName": "Pessoa golfe"
                },
                {
                  "code": "1f3cc-2642",
                  "name": "man golfing",
                  "category": "activity",
                  "keywords": "['golf', 'man']",
                  "display": 0,
                  "translatedName": "homem golfe"
                },
                {
                  "code": "1f3c4-2640",
                  "name": "woman surfing",
                  "category": "activity",
                  "keywords": "['surfing', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher surfando"
                },
                {
                  "code": "1f3c4",
                  "name": "person surfing",
                  "category": "activity",
                  "keywords": "['surfing']",
                  "display": 1,
                  "translatedName": "Pessoa Surf"
                },
                {
                  "code": "1f3c4-2642",
                  "name": "man surfing",
                  "category": "activity",
                  "keywords": "['man', 'surfing']",
                  "display": 0,
                  "translatedName": "Homem surfando"
                },
                {
                  "code": "1f3ca-2640",
                  "name": "woman swimming",
                  "category": "activity",
                  "keywords": "['swim', 'woman']",
                  "display": 1,
                  "translatedName": "mulher nadando"
                },
                {
                  "code": "1f3ca",
                  "name": "person swimming",
                  "category": "activity",
                  "keywords": "['swim']",
                  "display": 1,
                  "translatedName": "Pessoa nadando"
                },
                {
                  "code": "1f3ca-2642",
                  "name": "man swimming",
                  "category": "activity",
                  "keywords": "['man', 'swim']",
                  "display": 0,
                  "translatedName": "Natação do homem"
                },
                {
                  "code": "1f93d-2640",
                  "name": "woman playing water polo",
                  "category": "activity",
                  "keywords": "['water polo', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher, tocando água, polo"
                },
                {
                  "code": "1f93d-2642",
                  "name": "man playing water polo",
                  "category": "activity",
                  "keywords": "['man', 'water polo']",
                  "display": 1,
                  "translatedName": "homem jogando água polo"
                },
                {
                  "code": "1f93d",
                  "name": "person playing water polo",
                  "category": "activity",
                  "keywords": "['polo', 'water']",
                  "display": 0,
                  "translatedName": "Pessoa jogando água polo"
                },
                {
                  "code": "1f6a3-2640",
                  "name": "woman rowing boat",
                  "category": "activity",
                  "keywords": "['boat', 'rowboat', 'woman']",
                  "display": 1,
                  "translatedName": "Barco de remos da mulher"
                },
                {
                  "code": "1f6a3",
                  "name": "person rowing boat",
                  "category": "activity",
                  "keywords": "['boat', 'rowboat']",
                  "display": 1,
                  "translatedName": "Barco de remo da pessoa"
                },
                {
                  "code": "1f6a3-2642",
                  "name": "man rowing boat",
                  "category": "activity",
                  "keywords": "['boat', 'man', 'rowboat']",
                  "display": 0,
                  "translatedName": "Barco de remo do homem"
                },
                {
                  "code": "1f3c7",
                  "name": "horse racing",
                  "category": "activity",
                  "keywords": "['horse', 'jockey', 'racehorse', 'racing']",
                  "display": 1,
                  "translatedName": "corrida de cavalo"
                },
                {
                  "code": "1f6b4-2640",
                  "name": "woman biking",
                  "category": "activity",
                  "keywords": "['bicycle', 'biking', 'cyclist', 'woman']",
                  "display": 1,
                  "translatedName": "Biking de mulher"
                },
                {
                  "code": "1f6b4",
                  "name": "person biking",
                  "category": "activity",
                  "keywords": "['bicycle', 'biking', 'cyclist']",
                  "display": 1,
                  "translatedName": "Pessoa de bicicleta"
                },
                {
                  "code": "1f6b4-2642",
                  "name": "man biking",
                  "category": "activity",
                  "keywords": "['bicycle', 'biking', 'cyclist', 'man']",
                  "display": 0,
                  "translatedName": "homem de bicicleta"
                },
                {
                  "code": "1f6b5-2640",
                  "name": "woman mountain biking",
                  "category": "activity",
                  "keywords": "['bicycle', 'bike', 'biking', 'cyclist', 'mountain', 'woman']",
                  "display": 1,
                  "translatedName": "Bicicleta de montanha de mulher"
                },
                {
                  "code": "1f6b5",
                  "name": "person mountain biking",
                  "category": "activity",
                  "keywords": "['bicycle', 'bicyclist', 'bike', 'cyclist', 'mountain']",
                  "display": 1,
                  "translatedName": "Pessoa mountain bike."
                },
                {
                  "code": "1f6b5-2642",
                  "name": "man mountain biking",
                  "category": "activity",
                  "keywords": "['bicycle', 'bike', 'cyclist', 'man', 'mountain']",
                  "display": 0,
                  "translatedName": "Homem mountain bike."
                },
                {
                  "code": "1f3bd",
                  "name": "running shirt",
                  "category": "activity",
                  "keywords": "['athletics', 'running', 'sash', 'shirt']",
                  "display": 1,
                  "translatedName": "Camisa correndo"
                },
                {
                  "code": "1f3c5",
                  "name": "sports medal",
                  "category": "activity",
                  "keywords": "['medal']",
                  "display": 1,
                  "translatedName": "Medalha de esportes"
                },
                {
                  "code": "1f396",
                  "name": "military medal",
                  "category": "activity",
                  "keywords": "['celebration', 'medal', 'military']",
                  "display": 1,
                  "translatedName": "Medalha militar"
                },
                {
                  "code": "1f947",
                  "name": "1st place medal",
                  "category": "activity",
                  "keywords": "['first', 'gold', 'medal']",
                  "display": 1,
                  "translatedName": "1º lugar medalha."
                },
                {
                  "code": "1f948",
                  "name": "2nd place medal",
                  "category": "activity",
                  "keywords": "['medal', 'second', 'silver']",
                  "display": 1,
                  "translatedName": "2º lugar medalha."
                },
                {
                  "code": "1f949",
                  "name": "3rd place medal",
                  "category": "activity",
                  "keywords": "['bronze', 'medal', 'third']",
                  "display": 1,
                  "translatedName": "3ª Medalha de Lugar"
                },
                {
                  "code": "1f3c6",
                  "name": "trophy",
                  "category": "activity",
                  "keywords": "['prize']",
                  "display": 1,
                  "translatedName": "troféu"
                },
                {
                  "code": "1f3f5",
                  "name": "rosette",
                  "category": "activity",
                  "keywords": "['plant']",
                  "display": 1,
                  "translatedName": "roseta"
                },
                {
                  "code": "1f397",
                  "name": "reminder ribbon",
                  "category": "activity",
                  "keywords": "['celebration', 'reminder', 'ribbon']",
                  "display": 1,
                  "translatedName": "Fita de lembrete"
                },
                {
                  "code": "1f3ab",
                  "name": "ticket",
                  "category": "activity",
                  "keywords": "['admission']",
                  "display": 1,
                  "translatedName": "bilhete"
                },
                {
                  "code": "1f39f",
                  "name": "admission tickets",
                  "category": "activity",
                  "keywords": "['admission', 'ticket']",
                  "display": 1,
                  "translatedName": "ingressos de admissão"
                },
                {
                  "code": "1f3aa",
                  "name": "circus tent",
                  "category": "activity",
                  "keywords": "['circus', 'tent']",
                  "display": 1,
                  "translatedName": "tenda de circo"
                },
                {
                  "code": "1f939-2640",
                  "name": "woman juggling",
                  "category": "activity",
                  "keywords": "['juggling', 'multitask', 'woman']",
                  "display": 1,
                  "translatedName": "Mulher malabarismo"
                },
                {
                  "code": "1f939-2642",
                  "name": "man juggling",
                  "category": "activity",
                  "keywords": "['juggling', 'man', 'multitask']",
                  "display": 1,
                  "translatedName": "Homem malabarismo"
                },
                {
                  "code": "1f939",
                  "name": "person juggling",
                  "category": "activity",
                  "keywords": "['balance', 'juggle', 'multitask', 'skill']",
                  "display": 0,
                  "translatedName": "Pessoa, malabarismo"
                },
                {
                  "code": "1f3ad",
                  "name": "performing arts",
                  "category": "activity",
                  "keywords": "['art', 'mask', 'performing', 'theater', 'theatre']",
                  "display": 1,
                  "translatedName": "Artes performáticas"
                },
                {
                  "code": "1f3a8",
                  "name": "artist palette",
                  "category": "activity",
                  "keywords": "['art', 'museum', 'painting', 'palette']",
                  "display": 1,
                  "translatedName": "Paleta do artista"
                },
                {
                  "code": "1f3ac",
                  "name": "clapper board",
                  "category": "activity",
                  "keywords": "['clapper', 'movie']",
                  "display": 1,
                  "translatedName": "Clapper Board"
                },
                {
                  "code": "1f3a4",
                  "name": "microphone",
                  "category": "activity",
                  "keywords": "['karaoke', 'mic']",
                  "display": 1,
                  "translatedName": "microfone"
                },
                {
                  "code": "1f3a7",
                  "name": "headphone",
                  "category": "activity",
                  "keywords": "['earbud']",
                  "display": 1,
                  "translatedName": "fone de ouvido"
                },
                {
                  "code": "1f3bc",
                  "name": "musical score",
                  "category": "activity",
                  "keywords": "['music', 'score']",
                  "display": 1,
                  "translatedName": "pontuação musical"
                },
                {
                  "code": "1f3b9",
                  "name": "musical keyboard",
                  "category": "activity",
                  "keywords": "['instrument', 'keyboard', 'music', 'piano']",
                  "display": 1,
                  "translatedName": "Teclado musical"
                },
                {
                  "code": "1f941",
                  "name": "drum",
                  "category": "activity",
                  "keywords": "['drum', 'drumsticks', 'music']",
                  "display": 1,
                  "translatedName": "tambor"
                },
                {
                  "code": "1f3b7",
                  "name": "saxophone",
                  "category": "activity",
                  "keywords": "['instrument', 'music', 'sax']",
                  "display": 1,
                  "translatedName": "saxofone"
                },
                {
                  "code": "1f3ba",
                  "name": "trumpet",
                  "category": "activity",
                  "keywords": "['instrument', 'music']",
                  "display": 1,
                  "translatedName": "trompete"
                },
                {
                  "code": "1f3b8",
                  "name": "guitar",
                  "category": "activity",
                  "keywords": "['instrument', 'music']",
                  "display": 1,
                  "translatedName": "violão"
                },
                {
                  "code": "1f3bb",
                  "name": "violin",
                  "category": "activity",
                  "keywords": "['instrument', 'music']",
                  "display": 1,
                  "translatedName": "violino"
                },
                {
                  "code": "1f3b2",
                  "name": "game die",
                  "category": "activity",
                  "keywords": "['dice', 'die', 'game']",
                  "display": 1,
                  "translatedName": "jogo morrer"
                },
                {
                  "code": "1f3af",
                  "name": "direct hit",
                  "category": "activity",
                  "keywords": "['bull', 'bullseye', 'dart', 'eye', 'game', 'hit', 'target']",
                  "display": 1,
                  "translatedName": "ataque direto"
                },
                {
                  "code": "1f3b3",
                  "name": "bowling",
                  "category": "activity",
                  "keywords": "['ball', 'game']",
                  "display": 1,
                  "translatedName": "boliche"
                },
                {
                  "code": "1f3ae",
                  "name": "video game",
                  "category": "activity",
                  "keywords": "['controller', 'game']",
                  "display": 1,
                  "translatedName": "videogame"
                },
                {
                  "code": "1f3b0",
                  "name": "slot machine",
                  "category": "activity",
                  "keywords": "['game', 'slot']",
                  "display": 1,
                  "translatedName": "Slot Machine."
                },
                {
                  "code": "1f6f7",
                  "name": "sled",
                  "category": "activity",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "trenó"
                },
                {
                  "code": "1f931",
                  "name": "breast-feeding",
                  "category": "activity",
                  "keywords": "['baby', 'breast', 'nursing']",
                  "display": 1,
                  "translatedName": "amamentação"
                },
                {
                  "code": "1f94c",
                  "name": "curling stone",
                  "category": "activity",
                  "keywords": "['game', 'rock']",
                  "display": 1,
                  "translatedName": "pedra curling"
                },
                {
                  "code": "1f9d6",
                  "name": "person in steamy room",
                  "category": "activity",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "Pessoa na sala fumegante"
                },
                {
                  "code": "1f9d7",
                  "name": "person climbing",
                  "category": "activity",
                  "keywords": "['climber']",
                  "display": 0,
                  "translatedName": "Escalada de pessoa"
                },
                {
                  "code": "1f9d8",
                  "name": "person in lotus position",
                  "category": "activity",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "Pessoa na posição de lótus"
                },
                {
                  "code": "1f9d6-2640",
                  "name": "woman in steamy room",
                  "category": "activity",
                  "keywords": "['sauna', 'steam room']",
                  "display": 1,
                  "translatedName": "Mulher, em, sala fumegante"
                },
                {
                  "code": "1f9d6-2642",
                  "name": "man in steamy room",
                  "category": "activity",
                  "keywords": "['sauna', 'steam room']",
                  "display": 1,
                  "translatedName": "Homem, em, sala fumegante"
                },
                {
                  "code": "1f9d7-2640",
                  "name": "woman climbing",
                  "category": "activity",
                  "keywords": "['climber']",
                  "display": 1,
                  "translatedName": "escalada de mulher"
                },
                {
                  "code": "1f9d7-2642",
                  "name": "man climbing",
                  "category": "activity",
                  "keywords": "['climber']",
                  "display": 1,
                  "translatedName": "homem escalando"
                },
                {
                  "code": "1f9d8-2640",
                  "name": "woman in lotus position",
                  "category": "activity",
                  "keywords": "['meditation', 'yoga']",
                  "display": 1,
                  "translatedName": "Mulher na posição de lótus"
                },
                {
                  "code": "1f9d8-2642",
                  "name": "man in lotus position",
                  "category": "activity",
                  "keywords": "['meditation', 'yoga']",
                  "display": 1,
                  "translatedName": "Homem na posição de lótus"
                },
                {
                  "code": "1f697",
                  "name": "automobile",
                  "category": "travel",
                  "keywords": "['car']",
                  "display": 1,
                  "translatedName": "automóvel"
                },
                {
                  "code": "1f695",
                  "name": "taxi",
                  "category": "travel",
                  "keywords": "['vehicle']",
                  "display": 1,
                  "translatedName": "Táxi"
                },
                {
                  "code": "1f699",
                  "name": "sport utility vehicle",
                  "category": "travel",
                  "keywords": "['recreational', 'sport utility']",
                  "display": 1,
                  "translatedName": "veículo utilitário esportivo"
                },
                {
                  "code": "1f68c",
                  "name": "bus",
                  "category": "travel",
                  "keywords": "['vehicle']",
                  "display": 1,
                  "translatedName": "ônibus"
                },
                {
                  "code": "1f68e",
                  "name": "trolleybus",
                  "category": "travel",
                  "keywords": "['bus', 'tram', 'trolley']",
                  "display": 1,
                  "translatedName": "Trólebus."
                },
                {
                  "code": "1f3ce",
                  "name": "racing car",
                  "category": "travel",
                  "keywords": "['car', 'racing']",
                  "display": 1,
                  "translatedName": "carro de corrida"
                },
                {
                  "code": "1f693",
                  "name": "police car",
                  "category": "travel",
                  "keywords": "['car', 'patrol', 'police']",
                  "display": 1,
                  "translatedName": "carro de polícia"
                },
                {
                  "code": "1f691",
                  "name": "ambulance",
                  "category": "travel",
                  "keywords": "['vehicle']",
                  "display": 1,
                  "translatedName": "ambulância"
                },
                {
                  "code": "1f692",
                  "name": "fire engine",
                  "category": "travel",
                  "keywords": "['engine', 'fire', 'truck']",
                  "display": 1,
                  "translatedName": "Engine de bombeiros"
                },
                {
                  "code": "1f690",
                  "name": "minibus",
                  "category": "travel",
                  "keywords": "['bus']",
                  "display": 1,
                  "translatedName": "mini onibus"
                },
                {
                  "code": "1f69a",
                  "name": "delivery truck",
                  "category": "travel",
                  "keywords": "['delivery', 'truck']",
                  "display": 1,
                  "translatedName": "Caminhão de entrega"
                },
                {
                  "code": "1f69b",
                  "name": "articulated lorry",
                  "category": "travel",
                  "keywords": "['lorry', 'semi', 'truck']",
                  "display": 1,
                  "translatedName": "camião articulado"
                },
                {
                  "code": "1f69c",
                  "name": "tractor",
                  "category": "travel",
                  "keywords": "['vehicle']",
                  "display": 1,
                  "translatedName": "trator"
                },
                {
                  "code": "1f6f4",
                  "name": "kick scooter",
                  "category": "travel",
                  "keywords": "['kick', 'scooter']",
                  "display": 1,
                  "translatedName": "chute scooter."
                },
                {
                  "code": "1f6b2",
                  "name": "bicycle",
                  "category": "travel",
                  "keywords": "['bike']",
                  "display": 1,
                  "translatedName": "bicicleta"
                },
                {
                  "code": "1f6f5",
                  "name": "motor scooter",
                  "category": "travel",
                  "keywords": "['motor', 'scooter']",
                  "display": 1,
                  "translatedName": "motoneta"
                },
                {
                  "code": "1f3cd",
                  "name": "motorcycle",
                  "category": "travel",
                  "keywords": "['racing']",
                  "display": 1,
                  "translatedName": "motocicleta"
                },
                {
                  "code": "1f6a8",
                  "name": "police car light",
                  "category": "travel",
                  "keywords": "['beacon', 'car', 'light', 'police', 'revolving']",
                  "display": 1,
                  "translatedName": "luz do carro da polícia"
                },
                {
                  "code": "1f694",
                  "name": "oncoming police car",
                  "category": "travel",
                  "keywords": "['car', 'oncoming', 'police']",
                  "display": 1,
                  "translatedName": "carro policial que se aproxima"
                },
                {
                  "code": "1f68d",
                  "name": "oncoming bus",
                  "category": "travel",
                  "keywords": "['bus', 'oncoming']",
                  "display": 1,
                  "translatedName": "ônibus que se aproxima"
                },
                {
                  "code": "1f698",
                  "name": "oncoming automobile",
                  "category": "travel",
                  "keywords": "['automobile', 'car', 'oncoming']",
                  "display": 1,
                  "translatedName": "Automóvel que se aproxima"
                },
                {
                  "code": "1f696",
                  "name": "oncoming taxi",
                  "category": "travel",
                  "keywords": "['oncoming', 'taxi']",
                  "display": 1,
                  "translatedName": "Táxi que se aproxima"
                },
                {
                  "code": "1f6a1",
                  "name": "aerial tramway",
                  "category": "travel",
                  "keywords": "['aerial', 'cable', 'car', 'gondola', 'tramway']",
                  "display": 1,
                  "translatedName": "Tramway aéreo."
                },
                {
                  "code": "1f6a0",
                  "name": "mountain cableway",
                  "category": "travel",
                  "keywords": "['cable', 'gondola', 'mountain']",
                  "display": 1,
                  "translatedName": "Cabo aéreo da montanha"
                },
                {
                  "code": "1f69f",
                  "name": "suspension railway",
                  "category": "travel",
                  "keywords": "['railway', 'suspension']",
                  "display": 1,
                  "translatedName": "Ferrovia de suspensão"
                },
                {
                  "code": "1f683",
                  "name": "railway car",
                  "category": "travel",
                  "keywords": "['car', 'electric', 'railway', 'train', 'tram', 'trolleybus']",
                  "display": 1,
                  "translatedName": "carro ferroviário"
                },
                {
                  "code": "1f68b",
                  "name": "tram car",
                  "category": "travel",
                  "keywords": "['car', 'tram', 'trolleybus']",
                  "display": 1,
                  "translatedName": "carro de bonde"
                },
                {
                  "code": "1f69e",
                  "name": "mountain railway",
                  "category": "travel",
                  "keywords": "['car', 'mountain', 'railway']",
                  "display": 1,
                  "translatedName": "Estrada de ferro da montanha"
                },
                {
                  "code": "1f69d",
                  "name": "monorail",
                  "category": "travel",
                  "keywords": "['vehicle']",
                  "display": 1,
                  "translatedName": "monotrilho"
                },
                {
                  "code": "1f684",
                  "name": "high-speed train",
                  "category": "travel",
                  "keywords": "['railway', 'shinkansen', 'speed', 'train']",
                  "display": 1,
                  "translatedName": "trem de alta velocidade"
                },
                {
                  "code": "1f685",
                  "name": "high-speed train with bullet nose",
                  "category": "travel",
                  "keywords": "['bullet', 'railway', 'shinkansen', 'speed', 'train']",
                  "display": 1,
                  "translatedName": "Trem de alta velocidade com nariz de bala"
                },
                {
                  "code": "1f688",
                  "name": "light rail",
                  "category": "travel",
                  "keywords": "['railway']",
                  "display": 1,
                  "translatedName": "Veiculo Leve Sobre Trilhos"
                },
                {
                  "code": "1f682",
                  "name": "locomotive",
                  "category": "travel",
                  "keywords": "['engine', 'railway', 'steam', 'train']",
                  "display": 1,
                  "translatedName": "locomotiva"
                },
                {
                  "code": "1f686",
                  "name": "train",
                  "category": "travel",
                  "keywords": "['railway']",
                  "display": 1,
                  "translatedName": "Comboio"
                },
                {
                  "code": "1f687",
                  "name": "metro",
                  "category": "travel",
                  "keywords": "['subway']",
                  "display": 1,
                  "translatedName": "metrô"
                },
                {
                  "code": "1f68a",
                  "name": "tram",
                  "category": "travel",
                  "keywords": "['trolleybus']",
                  "display": 1,
                  "translatedName": "eléctrico"
                },
                {
                  "code": "1f689",
                  "name": "station",
                  "category": "travel",
                  "keywords": "['railway', 'train']",
                  "display": 1,
                  "translatedName": "estação"
                },
                {
                  "code": "1f681",
                  "name": "helicopter",
                  "category": "travel",
                  "keywords": "['vehicle']",
                  "display": 1,
                  "translatedName": "helicóptero"
                },
                {
                  "code": "1f6e9",
                  "name": "small airplane",
                  "category": "travel",
                  "keywords": "['aeroplane', 'airplane']",
                  "display": 1,
                  "translatedName": "Pequeno avião"
                },
                {
                  "code": 2708,
                  "name": "airplane",
                  "category": "travel",
                  "keywords": "['aeroplane', 'airplane']",
                  "display": 1,
                  "translatedName": "avião"
                },
                {
                  "code": "1f6eb",
                  "name": "airplane departure",
                  "category": "travel",
                  "keywords": "['aeroplane', 'airplane', 'check-in', 'departure', 'departures']",
                  "display": 1,
                  "translatedName": "Partida do avião."
                },
                {
                  "code": "1f6ec",
                  "name": "airplane arrival",
                  "category": "travel",
                  "keywords": "['aeroplane', 'airplane', 'arrivals', 'arriving', 'landing']",
                  "display": 1,
                  "translatedName": "Avião de chegada"
                },
                {
                  "code": "1f680",
                  "name": "rocket",
                  "category": "travel",
                  "keywords": "['space']",
                  "display": 1,
                  "translatedName": "foguete"
                },
                {
                  "code": "1f6f0",
                  "name": "satellite",
                  "category": "travel",
                  "keywords": "['space']",
                  "display": 1,
                  "translatedName": "satélite"
                },
                {
                  "code": "1f4ba",
                  "name": "seat",
                  "category": "travel",
                  "keywords": "['chair']",
                  "display": 1,
                  "translatedName": "assento"
                },
                {
                  "code": "1f6f6",
                  "name": "canoe",
                  "category": "travel",
                  "keywords": "['boat', 'canoe']",
                  "display": 1,
                  "translatedName": "canoa"
                },
                {
                  "code": "26f5",
                  "name": "sailboat",
                  "category": "travel",
                  "keywords": "['boat', 'resort', 'sea', 'yacht']",
                  "display": 1,
                  "translatedName": "barco a vela"
                },
                {
                  "code": "1f6e5",
                  "name": "motor boat",
                  "category": "travel",
                  "keywords": "['boat', 'motorboat']",
                  "display": 1,
                  "translatedName": "barco a motor"
                },
                {
                  "code": "1f6a4",
                  "name": "speedboat",
                  "category": "travel",
                  "keywords": "['boat']",
                  "display": 1,
                  "translatedName": "lancha"
                },
                {
                  "code": "1f6f3",
                  "name": "passenger ship",
                  "category": "travel",
                  "keywords": "['passenger', 'ship']",
                  "display": 1,
                  "translatedName": "navio de passageiros"
                },
                {
                  "code": "26f4",
                  "name": "ferry",
                  "category": "travel",
                  "keywords": "['boat', 'passenger']",
                  "display": 1,
                  "translatedName": "balsa"
                },
                {
                  "code": "1f6a2",
                  "name": "ship",
                  "category": "travel",
                  "keywords": "['boat', 'passenger']",
                  "display": 1,
                  "translatedName": "enviar"
                },
                {
                  "code": 2693,
                  "name": "anchor",
                  "category": "travel",
                  "keywords": "['ship', 'tool']",
                  "display": 1,
                  "translatedName": "âncora"
                },
                {
                  "code": "1f6a7",
                  "name": "construction",
                  "category": "travel",
                  "keywords": "['barrier']",
                  "display": 1,
                  "translatedName": "construção"
                },
                {
                  "code": "26fd",
                  "name": "fuel pump",
                  "category": "travel",
                  "keywords": "['fuel', 'fuelpump', 'gas', 'pump', 'station']",
                  "display": 1,
                  "translatedName": "bomba de combustivel"
                },
                {
                  "code": "1f68f",
                  "name": "bus stop",
                  "category": "travel",
                  "keywords": "['bus', 'busstop', 'stop']",
                  "display": 1,
                  "translatedName": "ponto de ônibus"
                },
                {
                  "code": "1f6a6",
                  "name": "vertical traffic light",
                  "category": "travel",
                  "keywords": "['light', 'signal', 'traffic']",
                  "display": 1,
                  "translatedName": "semáforo vertical"
                },
                {
                  "code": "1f6a5",
                  "name": "horizontal traffic light",
                  "category": "travel",
                  "keywords": "['light', 'signal', 'traffic']",
                  "display": 1,
                  "translatedName": "semáforo horizontal"
                },
                {
                  "code": "1f5fa",
                  "name": "world map",
                  "category": "travel",
                  "keywords": "['map', 'world']",
                  "display": 1,
                  "translatedName": "mapa mundial"
                },
                {
                  "code": "1f5ff",
                  "name": "moai",
                  "category": "travel",
                  "keywords": "['face', 'moyai', 'statue']",
                  "display": 1,
                  "translatedName": "moai."
                },
                {
                  "code": "1f5fd",
                  "name": "Statue of Liberty",
                  "category": "travel",
                  "keywords": "['liberty', 'statue']",
                  "display": 1,
                  "translatedName": "Estátua da Liberdade"
                },
                {
                  "code": "26f2",
                  "name": "fountain",
                  "category": "travel",
                  "keywords": "['fountain']",
                  "display": 1,
                  "translatedName": "fonte"
                },
                {
                  "code": "1f5fc",
                  "name": "Tokyo tower",
                  "category": "travel",
                  "keywords": "['Tokyo', 'tower']",
                  "display": 1,
                  "translatedName": "Torre de Tóquio"
                },
                {
                  "code": "1f3f0",
                  "name": "castle",
                  "category": "travel",
                  "keywords": "['European']",
                  "display": 1,
                  "translatedName": "castelo"
                },
                {
                  "code": "1f3ef",
                  "name": "Japanese castle",
                  "category": "travel",
                  "keywords": "['Japanese', 'castle']",
                  "display": 1,
                  "translatedName": "Castelo japonês"
                },
                {
                  "code": "1f3df",
                  "name": "stadium",
                  "category": "travel",
                  "keywords": "['stadium']",
                  "display": 1,
                  "translatedName": "estádio"
                },
                {
                  "code": "1f3a1",
                  "name": "ferris wheel",
                  "category": "travel",
                  "keywords": "['amusement park', 'ferris', 'wheel']",
                  "display": 1,
                  "translatedName": "roda gigante"
                },
                {
                  "code": "1f3a2",
                  "name": "roller coaster",
                  "category": "travel",
                  "keywords": "['amusement park', 'coaster', 'roller']",
                  "display": 1,
                  "translatedName": "montanha russa"
                },
                {
                  "code": "1f3a0",
                  "name": "carousel horse",
                  "category": "travel",
                  "keywords": "['carousel', 'horse']",
                  "display": 1,
                  "translatedName": "cavalo carrossel."
                },
                {
                  "code": "26f1",
                  "name": "umbrella on ground",
                  "category": "travel",
                  "keywords": "['rain', 'sun', 'umbrella']",
                  "display": 1,
                  "translatedName": "guarda-chuva no chão"
                },
                {
                  "code": "1f3d6",
                  "name": "beach with umbrella",
                  "category": "travel",
                  "keywords": "['beach', 'umbrella']",
                  "display": 1,
                  "translatedName": "Praia com guarda-chuva"
                },
                {
                  "code": "1f3dd",
                  "name": "desert island",
                  "category": "travel",
                  "keywords": "['desert', 'island']",
                  "display": 1,
                  "translatedName": "ilha deserta"
                },
                {
                  "code": "26f0",
                  "name": "mountain",
                  "category": "travel",
                  "keywords": "['mountain']",
                  "display": 1,
                  "translatedName": "montanha"
                },
                {
                  "code": "1f3d4",
                  "name": "snow-capped mountain",
                  "category": "travel",
                  "keywords": "['cold', 'mountain', 'snow']",
                  "display": 1,
                  "translatedName": "montanha coberta de neve"
                },
                {
                  "code": "1f5fb",
                  "name": "mount fuji",
                  "category": "travel",
                  "keywords": "['fuji', 'mountain']",
                  "display": 1,
                  "translatedName": "Monte Fuji."
                },
                {
                  "code": "1f30b",
                  "name": "volcano",
                  "category": "travel",
                  "keywords": "['eruption', 'mountain']",
                  "display": 1,
                  "translatedName": "vulcão"
                },
                {
                  "code": "1f3dc",
                  "name": "desert",
                  "category": "travel",
                  "keywords": "['desert']",
                  "display": 1,
                  "translatedName": "deserto"
                },
                {
                  "code": "1f3d5",
                  "name": "camping",
                  "category": "travel",
                  "keywords": "['camping']",
                  "display": 1,
                  "translatedName": "acampamento"
                },
                {
                  "code": "26fa",
                  "name": "tent",
                  "category": "travel",
                  "keywords": "['camping']",
                  "display": 1,
                  "translatedName": "tenda"
                },
                {
                  "code": "1f6e4",
                  "name": "railway track",
                  "category": "travel",
                  "keywords": "['railway', 'train']",
                  "display": 1,
                  "translatedName": "Trilha Railway"
                },
                {
                  "code": "1f6e3",
                  "name": "motorway",
                  "category": "travel",
                  "keywords": "['highway', 'road']",
                  "display": 1,
                  "translatedName": "auto-estrada"
                },
                {
                  "code": "1f3d7",
                  "name": "building construction",
                  "category": "travel",
                  "keywords": "['construction']",
                  "display": 1,
                  "translatedName": "construção civil"
                },
                {
                  "code": "1f3ed",
                  "name": "factory",
                  "category": "travel",
                  "keywords": "['building']",
                  "display": 1,
                  "translatedName": "fábrica"
                },
                {
                  "code": "1f3e0",
                  "name": "house",
                  "category": "travel",
                  "keywords": "['home', 'house']",
                  "display": 1,
                  "translatedName": "casa"
                },
                {
                  "code": "1f3e1",
                  "name": "house with garden",
                  "category": "travel",
                  "keywords": "['garden', 'home', 'house']",
                  "display": 1,
                  "translatedName": "Casa com jardim"
                },
                {
                  "code": "1f3d8",
                  "name": "houses",
                  "category": "travel",
                  "keywords": "['houses']",
                  "display": 1,
                  "translatedName": "Casas"
                },
                {
                  "code": "1f3da",
                  "name": "derelict house",
                  "category": "travel",
                  "keywords": "['derelict', 'house']",
                  "display": 1,
                  "translatedName": "casa abandonada"
                },
                {
                  "code": "1f3e2",
                  "name": "office building",
                  "category": "travel",
                  "keywords": "['building']",
                  "display": 1,
                  "translatedName": "Prédio comercial"
                },
                {
                  "code": "1f3ec",
                  "name": "department store",
                  "category": "travel",
                  "keywords": "['department', 'store']",
                  "display": 1,
                  "translatedName": "loja de departamento"
                },
                {
                  "code": "1f3e3",
                  "name": "Japanese post office",
                  "category": "travel",
                  "keywords": "['Japanese', 'post']",
                  "display": 1,
                  "translatedName": "Correios japoneses."
                },
                {
                  "code": "1f3e4",
                  "name": "post office",
                  "category": "travel",
                  "keywords": "['European', 'post']",
                  "display": 1,
                  "translatedName": "Correios"
                },
                {
                  "code": "1f3e5",
                  "name": "hospital",
                  "category": "travel",
                  "keywords": "['doctor', 'medicine']",
                  "display": 1,
                  "translatedName": "hospital"
                },
                {
                  "code": "1f3e6",
                  "name": "bank",
                  "category": "travel",
                  "keywords": "['building']",
                  "display": 1,
                  "translatedName": "Banco"
                },
                {
                  "code": "1f3e8",
                  "name": "hotel",
                  "category": "travel",
                  "keywords": "['building']",
                  "display": 1,
                  "translatedName": "hotel"
                },
                {
                  "code": "1f3ea",
                  "name": "convenience store",
                  "category": "travel",
                  "keywords": "['convenience', 'store']",
                  "display": 1,
                  "translatedName": "loja de conveniência"
                },
                {
                  "code": "1f3eb",
                  "name": "school",
                  "category": "travel",
                  "keywords": "['building']",
                  "display": 1,
                  "translatedName": "escola"
                },
                {
                  "code": "1f3e9",
                  "name": "love hotel",
                  "category": "travel",
                  "keywords": "['hotel', 'love']",
                  "display": 1,
                  "translatedName": "Amor Hotel."
                },
                {
                  "code": "1f492",
                  "name": "wedding",
                  "category": "travel",
                  "keywords": "['chapel', 'romance']",
                  "display": 1,
                  "translatedName": "Casamento"
                },
                {
                  "code": "1f3db",
                  "name": "classical building",
                  "category": "travel",
                  "keywords": "['classical']",
                  "display": 1,
                  "translatedName": "edifício clássico"
                },
                {
                  "code": "26ea",
                  "name": "church",
                  "category": "travel",
                  "keywords": "['Christian', 'cross', 'religion']",
                  "display": 1,
                  "translatedName": "Igreja"
                },
                {
                  "code": "1f54c",
                  "name": "mosque",
                  "category": "travel",
                  "keywords": "['Muslim', 'islam', 'religion']",
                  "display": 1,
                  "translatedName": "mesquita"
                },
                {
                  "code": "1f54d",
                  "name": "synagogue",
                  "category": "travel",
                  "keywords": "['Jew', 'Jewish', 'religion', 'temple']",
                  "display": 1,
                  "translatedName": "sinagoga"
                },
                {
                  "code": "1f54b",
                  "name": "kaaba",
                  "category": "travel",
                  "keywords": "['Muslim', 'islam', 'religion']",
                  "display": 1,
                  "translatedName": "kaaba."
                },
                {
                  "code": "2,60E+10",
                  "name": "shinto shrine",
                  "category": "travel",
                  "keywords": "['religion', 'shinto', 'shrine']",
                  "display": 1,
                  "translatedName": "santuário de Xintoísmo"
                },
                {
                  "code": "1f5fe",
                  "name": "map of Japan",
                  "category": "travel",
                  "keywords": "['Japan', 'map']",
                  "display": 1,
                  "translatedName": "Mapa do Japão"
                },
                {
                  "code": "1f391",
                  "name": "moon viewing ceremony",
                  "category": "travel",
                  "keywords": "['celebration', 'ceremony', 'moon']",
                  "display": 1,
                  "translatedName": "Cerimônia de visualização da lua"
                },
                {
                  "code": "1f3de",
                  "name": "national park",
                  "category": "travel",
                  "keywords": "['park']",
                  "display": 1,
                  "translatedName": "Parque Nacional"
                },
                {
                  "code": "1f305",
                  "name": "sunrise",
                  "category": "travel",
                  "keywords": "['morning', 'sun']",
                  "display": 1,
                  "translatedName": "nascer do sol"
                },
                {
                  "code": "1f304",
                  "name": "sunrise over mountains",
                  "category": "travel",
                  "keywords": "['morning', 'mountain', 'sun', 'sunrise']",
                  "display": 1,
                  "translatedName": "Nascer do sol sobre montanhas"
                },
                {
                  "code": "1f320",
                  "name": "shooting star",
                  "category": "travel",
                  "keywords": "['falling', 'shooting', 'star']",
                  "display": 1,
                  "translatedName": "estrela cadente"
                },
                {
                  "code": "1f387",
                  "name": "sparkler",
                  "category": "travel",
                  "keywords": "['celebration', 'fireworks', 'sparkle']",
                  "display": 1,
                  "translatedName": "Sparkler."
                },
                {
                  "code": "1f386",
                  "name": "fireworks",
                  "category": "travel",
                  "keywords": "['celebration']",
                  "display": 1,
                  "translatedName": "fogos de artifício"
                },
                {
                  "code": "1f307",
                  "name": "sunset",
                  "category": "travel",
                  "keywords": "['dusk', 'sun']",
                  "display": 1,
                  "translatedName": "pôr do sol"
                },
                {
                  "code": "1f306",
                  "name": "cityscape at dusk",
                  "category": "travel",
                  "keywords": "['city', 'dusk', 'evening', 'landscape', 'sun', 'sunset']",
                  "display": 1,
                  "translatedName": "Arquitetura da cidade no crepúsculo"
                },
                {
                  "code": "1f3d9",
                  "name": "cityscape",
                  "category": "travel",
                  "keywords": "['city']",
                  "display": 1,
                  "translatedName": "Arquitetura da cidade"
                },
                {
                  "code": "1f303",
                  "name": "night with stars",
                  "category": "travel",
                  "keywords": "['night', 'star']",
                  "display": 1,
                  "translatedName": "noite com estrelas"
                },
                {
                  "code": "1f30c",
                  "name": "milky way",
                  "category": "travel",
                  "keywords": "['space']",
                  "display": 1,
                  "translatedName": "via Láctea"
                },
                {
                  "code": "1f309",
                  "name": "bridge at night",
                  "category": "travel",
                  "keywords": "['bridge', 'night']",
                  "display": 1,
                  "translatedName": "Ponte à noite"
                },
                {
                  "code": "1f301",
                  "name": "foggy",
                  "category": "travel",
                  "keywords": "['fog']",
                  "display": 1,
                  "translatedName": "enevoado"
                },
                {
                  "code": "1f6f8",
                  "name": "flying saucer",
                  "category": "travel",
                  "keywords": "['UFO']",
                  "display": 1,
                  "translatedName": "disco voador"
                },
                {
                  "code": "231a",
                  "name": "watch",
                  "category": "objects",
                  "keywords": "['clock']",
                  "display": 1,
                  "translatedName": "Assistir"
                },
                {
                  "code": "1f4f1",
                  "name": "mobile phone",
                  "category": "objects",
                  "keywords": "['cell', 'mobile', 'phone', 'telephone']",
                  "display": 1,
                  "translatedName": "celular"
                },
                {
                  "code": "1f4f2",
                  "name": "mobile phone with arrow",
                  "category": "objects",
                  "keywords": "['arrow', 'call', 'cell', 'mobile', 'phone', 'receive', 'telephone']",
                  "display": 1,
                  "translatedName": "Telefone celular com seta"
                },
                {
                  "code": "1f4bb",
                  "name": "laptop computer",
                  "category": "objects",
                  "keywords": "['computer', 'pc', 'personal']",
                  "display": 1,
                  "translatedName": "notebook"
                },
                {
                  "code": 2328,
                  "name": "keyboard",
                  "category": "objects",
                  "keywords": "['computer']",
                  "display": 1,
                  "translatedName": "teclado"
                },
                {
                  "code": "1f5a5",
                  "name": "desktop computer",
                  "category": "objects",
                  "keywords": "['computer', 'desktop']",
                  "display": 1,
                  "translatedName": "computador desktop"
                },
                {
                  "code": "1f5a8",
                  "name": "printer",
                  "category": "objects",
                  "keywords": "['computer']",
                  "display": 1,
                  "translatedName": "impressora"
                },
                {
                  "code": "1f5b1",
                  "name": "computer mouse",
                  "category": "objects",
                  "keywords": "['computer']",
                  "display": 1,
                  "translatedName": "Mouse de computador"
                },
                {
                  "code": "1f5b2",
                  "name": "trackball",
                  "category": "objects",
                  "keywords": "['computer']",
                  "display": 1,
                  "translatedName": "trackball."
                },
                {
                  "code": "1f579",
                  "name": "joystick",
                  "category": "objects",
                  "keywords": "['game', 'video game']",
                  "display": 1,
                  "translatedName": "controle de video game"
                },
                {
                  "code": "1f5dc",
                  "name": "clamp",
                  "category": "objects",
                  "keywords": "['compress', 'tool', 'vice']",
                  "display": 1,
                  "translatedName": "braçadeira"
                },
                {
                  "code": "1f4bd",
                  "name": "computer disk",
                  "category": "objects",
                  "keywords": "['computer', 'disk', 'minidisk', 'optical']",
                  "display": 1,
                  "translatedName": "disco de computador"
                },
                {
                  "code": "1f4be",
                  "name": "floppy disk",
                  "category": "objects",
                  "keywords": "['computer', 'disk', 'floppy']",
                  "display": 1,
                  "translatedName": "disquete"
                },
                {
                  "code": "1f4bf",
                  "name": "optical disk",
                  "category": "objects",
                  "keywords": "['cd', 'computer', 'disk', 'optical']",
                  "display": 1,
                  "translatedName": "disco óptico"
                },
                {
                  "code": "1f4c0",
                  "name": "dvd",
                  "category": "objects",
                  "keywords": "['blu-ray', 'computer', 'disk', 'dvd', 'optical']",
                  "display": 1,
                  "translatedName": "DVD"
                },
                {
                  "code": "1f4fc",
                  "name": "videocassette",
                  "category": "objects",
                  "keywords": "['tape', 'vhs', 'video']",
                  "display": 1,
                  "translatedName": "videocassete"
                },
                {
                  "code": "1f4f7",
                  "name": "camera",
                  "category": "objects",
                  "keywords": "['video']",
                  "display": 1,
                  "translatedName": "Câmera"
                },
                {
                  "code": "1f4f8",
                  "name": "camera with flash",
                  "category": "objects",
                  "keywords": "['camera', 'flash', 'video']",
                  "display": 1,
                  "translatedName": "câmera com flash"
                },
                {
                  "code": "1f4f9",
                  "name": "video camera",
                  "category": "objects",
                  "keywords": "['camera', 'video']",
                  "display": 1,
                  "translatedName": "câmera de vídeo"
                },
                {
                  "code": "1f3a5",
                  "name": "movie camera",
                  "category": "objects",
                  "keywords": "['camera', 'cinema', 'movie']",
                  "display": 1,
                  "translatedName": "câmera cinematográfica"
                },
                {
                  "code": "1f4fd",
                  "name": "film projector",
                  "category": "objects",
                  "keywords": "['cinema', 'film', 'movie', 'projector', 'video']",
                  "display": 1,
                  "translatedName": "projetor de filme."
                },
                {
                  "code": "1f39e",
                  "name": "film frames",
                  "category": "objects",
                  "keywords": "['cinema', 'film', 'frames', 'movie']",
                  "display": 1,
                  "translatedName": "quadros de filme"
                },
                {
                  "code": "1f4de",
                  "name": "telephone receiver",
                  "category": "objects",
                  "keywords": "['phone', 'receiver', 'telephone']",
                  "display": 1,
                  "translatedName": "receptor de telefone"
                },
                {
                  "code": "260e",
                  "name": "telephone",
                  "category": "objects",
                  "keywords": "['phone']",
                  "display": 1,
                  "translatedName": "Telefone"
                },
                {
                  "code": "1f4df",
                  "name": "pager",
                  "category": "objects",
                  "keywords": "['pager']",
                  "display": 1,
                  "translatedName": "pager."
                },
                {
                  "code": "1f4e0",
                  "name": "fax machine",
                  "category": "objects",
                  "keywords": "['fax']",
                  "display": 1,
                  "translatedName": "maquina de fax"
                },
                {
                  "code": "1f4fa",
                  "name": "television",
                  "category": "objects",
                  "keywords": "['tv', 'video']",
                  "display": 1,
                  "translatedName": "televisão"
                },
                {
                  "code": "1f4fb",
                  "name": "radio",
                  "category": "objects",
                  "keywords": "['video']",
                  "display": 1,
                  "translatedName": "rádio"
                },
                {
                  "code": "1f399",
                  "name": "studio microphone",
                  "category": "objects",
                  "keywords": "['mic', 'microphone', 'music', 'studio']",
                  "display": 1,
                  "translatedName": "Microfone de estúdio"
                },
                {
                  "code": "1f39a",
                  "name": "level slider",
                  "category": "objects",
                  "keywords": "['level', 'music', 'slider']",
                  "display": 1,
                  "translatedName": "Slider de nível"
                },
                {
                  "code": "1f39b",
                  "name": "control knobs",
                  "category": "objects",
                  "keywords": "['control', 'knobs', 'music']",
                  "display": 1,
                  "translatedName": "Botões de controle"
                },
                {
                  "code": "23f1",
                  "name": "stopwatch",
                  "category": "objects",
                  "keywords": "['clock']",
                  "display": 1,
                  "translatedName": "cronômetro"
                },
                {
                  "code": "23f2",
                  "name": "timer clock",
                  "category": "objects",
                  "keywords": "['clock', 'timer']",
                  "display": 1,
                  "translatedName": "relógio temporizador"
                },
                {
                  "code": "23f0",
                  "name": "alarm clock",
                  "category": "objects",
                  "keywords": "['alarm', 'clock']",
                  "display": 1,
                  "translatedName": "despertador"
                },
                {
                  "code": "1f570",
                  "name": "mantelpiece clock",
                  "category": "objects",
                  "keywords": "['clock']",
                  "display": 1,
                  "translatedName": "Relógio de mantelpiece"
                },
                {
                  "code": "231b",
                  "name": "hourglass",
                  "category": "objects",
                  "keywords": "['sand', 'timer']",
                  "display": 1,
                  "translatedName": "ampulheta"
                },
                {
                  "code": "23f3",
                  "name": "hourglass with flowing sand",
                  "category": "objects",
                  "keywords": "['hourglass', 'sand', 'timer']",
                  "display": 1,
                  "translatedName": "Ampulheta com areia fluindo"
                },
                {
                  "code": "1f4e1",
                  "name": "satellite antenna",
                  "category": "objects",
                  "keywords": "['antenna', 'dish', 'satellite']",
                  "display": 1,
                  "translatedName": "Antena de satélite"
                },
                {
                  "code": "1f50b",
                  "name": "battery",
                  "category": "objects",
                  "keywords": "['battery']",
                  "display": 1,
                  "translatedName": "bateria"
                },
                {
                  "code": "1f50c",
                  "name": "electric plug",
                  "category": "objects",
                  "keywords": "['electric', 'electricity', 'plug']",
                  "display": 1,
                  "translatedName": "Plugue elétrico"
                },
                {
                  "code": "1f4a1",
                  "name": "light bulb",
                  "category": "objects",
                  "keywords": "['bulb', 'comic', 'electric', 'idea', 'light']",
                  "display": 1,
                  "translatedName": "lâmpada elétrica"
                },
                {
                  "code": "1f526",
                  "name": "flashlight",
                  "category": "objects",
                  "keywords": "['electric', 'light', 'tool', 'torch']",
                  "display": 1,
                  "translatedName": "lanterna"
                },
                {
                  "code": "1f56f",
                  "name": "candle",
                  "category": "objects",
                  "keywords": "['light']",
                  "display": 1,
                  "translatedName": "vela"
                },
                {
                  "code": "1f5d1",
                  "name": "wastebasket",
                  "category": "objects",
                  "keywords": "['wastebasket']",
                  "display": 1,
                  "translatedName": "lixebasket."
                },
                {
                  "code": "1f6e2",
                  "name": "oil drum",
                  "category": "objects",
                  "keywords": "['drum', 'oil']",
                  "display": 1,
                  "translatedName": "tambor de óleo"
                },
                {
                  "code": "1f4b8",
                  "name": "money with wings",
                  "category": "objects",
                  "keywords": "['bank', 'banknote', 'bill', 'dollar', 'fly', 'money', 'note', 'wings']",
                  "display": 1,
                  "translatedName": "Dinheiro com asas"
                },
                {
                  "code": "1f4b5",
                  "name": "dollar banknote",
                  "category": "objects",
                  "keywords": "['bank', 'banknote', 'bill', 'currency', 'dollar', 'money', 'note']",
                  "display": 1,
                  "translatedName": "Nota de dólar"
                },
                {
                  "code": "1f4b4",
                  "name": "yen banknote",
                  "category": "objects",
                  "keywords": "['bank', 'banknote', 'bill', 'currency', 'money', 'note', 'yen']",
                  "display": 1,
                  "translatedName": "notas de iene"
                },
                {
                  "code": "1f4b6",
                  "name": "euro banknote",
                  "category": "objects",
                  "keywords": "['bank', 'banknote', 'bill', 'currency', 'euro', 'money', 'note']",
                  "display": 1,
                  "translatedName": "notas de euro"
                },
                {
                  "code": "1f4b7",
                  "name": "pound banknote",
                  "category": "objects",
                  "keywords": "['bank', 'banknote', 'bill', 'currency', 'money', 'note', 'pound']",
                  "display": 1,
                  "translatedName": "Cédula de libra"
                },
                {
                  "code": "1f4b0",
                  "name": "money bag",
                  "category": "objects",
                  "keywords": "['bag', 'dollar', 'money', 'moneybag']",
                  "display": 1,
                  "translatedName": "Bolsa de dinheiro"
                },
                {
                  "code": "1f4b3",
                  "name": "credit card",
                  "category": "objects",
                  "keywords": "['bank', 'card', 'credit', 'money']",
                  "display": 1,
                  "translatedName": "Cartão de crédito"
                },
                {
                  "code": "1f48e",
                  "name": "gem stone",
                  "category": "objects",
                  "keywords": "['diamond', 'gem', 'jewel']",
                  "display": 1,
                  "translatedName": "pedra de gema"
                },
                {
                  "code": 2696,
                  "name": "balance scale",
                  "category": "objects",
                  "keywords": "['Libra', 'balance', 'justice', 'scales', 'tool', 'weight', 'zodiac']",
                  "display": 1,
                  "translatedName": "escala de equilíbrio."
                },
                {
                  "code": "1f527",
                  "name": "wrench",
                  "category": "objects",
                  "keywords": "['spanner', 'tool', 'wrench']",
                  "display": 1,
                  "translatedName": "Chave"
                },
                {
                  "code": "1f528",
                  "name": "hammer",
                  "category": "objects",
                  "keywords": "['tool']",
                  "display": 1,
                  "translatedName": "martelo"
                },
                {
                  "code": 2692,
                  "name": "hammer and pick",
                  "category": "objects",
                  "keywords": "['hammer', 'pick', 'tool']",
                  "display": 1,
                  "translatedName": "martelo e pick."
                },
                {
                  "code": "1f6e0",
                  "name": "hammer and wrench",
                  "category": "objects",
                  "keywords": "['hammer', 'spanner', 'tool', 'wrench']",
                  "display": 1,
                  "translatedName": "martelo e chave"
                },
                {
                  "code": "26cf",
                  "name": "pick",
                  "category": "objects",
                  "keywords": "['mining', 'tool']",
                  "display": 1,
                  "translatedName": "escolha"
                },
                {
                  "code": "1f529",
                  "name": "nut and bolt",
                  "category": "objects",
                  "keywords": "['bolt', 'nut', 'tool']",
                  "display": 1,
                  "translatedName": "porca e parafuso"
                },
                {
                  "code": 2699,
                  "name": "gear",
                  "category": "objects",
                  "keywords": "['tool']",
                  "display": 1,
                  "translatedName": "engrenagem"
                },
                {
                  "code": "26d3",
                  "name": "chains",
                  "category": "objects",
                  "keywords": "['chain']",
                  "display": 1,
                  "translatedName": "correntes"
                },
                {
                  "code": "1f52b",
                  "name": "pistol",
                  "category": "objects",
                  "keywords": "['gun', 'handgun', 'revolver', 'tool', 'weapon']",
                  "display": 1,
                  "translatedName": "pistola"
                },
                {
                  "code": "1f4a3",
                  "name": "bomb",
                  "category": "objects",
                  "keywords": "['comic']",
                  "display": 1,
                  "translatedName": "bombear"
                },
                {
                  "code": "1f52a",
                  "name": "kitchen knife",
                  "category": "objects",
                  "keywords": "['cooking', 'hocho', 'knife', 'tool', 'weapon']",
                  "display": 1,
                  "translatedName": "faca de cozinha"
                },
                {
                  "code": "1f5e1",
                  "name": "dagger",
                  "category": "objects",
                  "keywords": "['knife', 'weapon']",
                  "display": 1,
                  "translatedName": "punhal"
                },
                {
                  "code": 2694,
                  "name": "crossed swords",
                  "category": "objects",
                  "keywords": "['crossed', 'swords', 'weapon']",
                  "display": 1,
                  "translatedName": "Espadas cruzadas"
                },
                {
                  "code": "1f6e1",
                  "name": "shield",
                  "category": "objects",
                  "keywords": "['weapon']",
                  "display": 1,
                  "translatedName": "escudo"
                },
                {
                  "code": "1f6ac",
                  "name": "cigarette",
                  "category": "objects",
                  "keywords": "['smoking']",
                  "display": 1,
                  "translatedName": "cigarro"
                },
                {
                  "code": "26b0",
                  "name": "coffin",
                  "category": "objects",
                  "keywords": "['death']",
                  "display": 1,
                  "translatedName": "caixão"
                },
                {
                  "code": "26b1",
                  "name": "funeral urn",
                  "category": "objects",
                  "keywords": "['ashes', 'death', 'funeral', 'urn']",
                  "display": 1,
                  "translatedName": "urna funerária"
                },
                {
                  "code": "1f3fa",
                  "name": "amphora",
                  "category": "objects",
                  "keywords": "['Aquarius', 'cooking', 'drink', 'jug', 'tool', 'weapon', 'zodiac']",
                  "display": 1,
                  "translatedName": "ânfora"
                },
                {
                  "code": "1f52e",
                  "name": "crystal ball",
                  "category": "objects",
                  "keywords": "['ball', 'crystal', 'fairy tale', 'fantasy', 'fortune', 'tool']",
                  "display": 1,
                  "translatedName": "bola de cristal"
                },
                {
                  "code": "1f4ff",
                  "name": "prayer beads",
                  "category": "objects",
                  "keywords": "['beads', 'clothing', 'necklace', 'prayer', 'religion']",
                  "display": 1,
                  "translatedName": "grânulos de oração"
                },
                {
                  "code": "1f488",
                  "name": "barber pole",
                  "category": "objects",
                  "keywords": "['barber', 'haircut', 'pole']",
                  "display": 1,
                  "translatedName": "Barber Pole"
                },
                {
                  "code": 2697,
                  "name": "alembic",
                  "category": "objects",
                  "keywords": "['chemistry', 'tool']",
                  "display": 1,
                  "translatedName": "alambique"
                },
                {
                  "code": "1f52d",
                  "name": "telescope",
                  "category": "objects",
                  "keywords": "['science', 'tool']",
                  "display": 1,
                  "translatedName": "telescópio"
                },
                {
                  "code": "1f52c",
                  "name": "microscope",
                  "category": "objects",
                  "keywords": "['science', 'tool']",
                  "display": 1,
                  "translatedName": "microscópio"
                },
                {
                  "code": "1f573",
                  "name": "hole",
                  "category": "objects",
                  "keywords": "['hole']",
                  "display": 1,
                  "translatedName": "buraco"
                },
                {
                  "code": "1f48a",
                  "name": "pill",
                  "category": "objects",
                  "keywords": "['doctor', 'medicine', 'sick']",
                  "display": 1,
                  "translatedName": "comprimido"
                },
                {
                  "code": "1f489",
                  "name": "syringe",
                  "category": "objects",
                  "keywords": "['doctor', 'medicine', 'needle', 'shot', 'sick', 'tool']",
                  "display": 1,
                  "translatedName": "seringa"
                },
                {
                  "code": "1f321",
                  "name": "thermometer",
                  "category": "objects",
                  "keywords": "['weather']",
                  "display": 1,
                  "translatedName": "termômetro"
                },
                {
                  "code": "1f6bd",
                  "name": "toilet",
                  "category": "objects",
                  "keywords": "['toilet']",
                  "display": 1,
                  "translatedName": "banheiro"
                },
                {
                  "code": "1f6b0",
                  "name": "potable water",
                  "category": "objects",
                  "keywords": "['drinking', 'potable', 'water']",
                  "display": 1,
                  "translatedName": "água potável"
                },
                {
                  "code": "1f6bf",
                  "name": "shower",
                  "category": "objects",
                  "keywords": "['water']",
                  "display": 1,
                  "translatedName": "banho"
                },
                {
                  "code": "1f6c1",
                  "name": "bathtub",
                  "category": "objects",
                  "keywords": "['bath']",
                  "display": 1,
                  "translatedName": "banheira"
                },
                {
                  "code": "1f6c0",
                  "name": "person taking bath",
                  "category": "objects",
                  "keywords": "['bath', 'bathtub']",
                  "display": 1,
                  "translatedName": "Pessoa tomando banho"
                },
                {
                  "code": "1f6ce",
                  "name": "bellhop bell",
                  "category": "objects",
                  "keywords": "['bell', 'bellhop', 'hotel']",
                  "display": 1,
                  "translatedName": "Bellhop Bell."
                },
                {
                  "code": "1f511",
                  "name": "key",
                  "category": "objects",
                  "keywords": "['lock', 'password']",
                  "display": 1,
                  "translatedName": "chave"
                },
                {
                  "code": "1f5dd",
                  "name": "old key",
                  "category": "objects",
                  "keywords": "['clue', 'key', 'lock', 'old']",
                  "display": 1,
                  "translatedName": "chave velha"
                },
                {
                  "code": "1f6aa",
                  "name": "door",
                  "category": "objects",
                  "keywords": "['door']",
                  "display": 1,
                  "translatedName": "porta"
                },
                {
                  "code": "1f6cb",
                  "name": "couch and lamp",
                  "category": "objects",
                  "keywords": "['couch', 'hotel', 'lamp']",
                  "display": 1,
                  "translatedName": "sofá e lâmpada."
                },
                {
                  "code": "1f6cf",
                  "name": "bed",
                  "category": "objects",
                  "keywords": "['hotel', 'sleep']",
                  "display": 1,
                  "translatedName": "cama"
                },
                {
                  "code": "1f6cc",
                  "name": "person in bed",
                  "category": "objects",
                  "keywords": "['hotel', 'sleep']",
                  "display": 1,
                  "translatedName": "pessoa na cama."
                },
                {
                  "code": "1f5bc",
                  "name": "framed picture",
                  "category": "objects",
                  "keywords": "['art', 'frame', 'museum', 'painting', 'picture']",
                  "display": 1,
                  "translatedName": "Imagem emoldurada"
                },
                {
                  "code": "1f6cd",
                  "name": "shopping bags",
                  "category": "objects",
                  "keywords": "['bag', 'hotel', 'shopping']",
                  "display": 1,
                  "translatedName": "sacolas de compras"
                },
                {
                  "code": "1f6d2",
                  "name": "shopping cart",
                  "category": "objects",
                  "keywords": "['cart', 'shopping', 'trolley']",
                  "display": 1,
                  "translatedName": "carrinho de compras"
                },
                {
                  "code": "1f381",
                  "name": "wrapped gift",
                  "category": "objects",
                  "keywords": "['box', 'celebration', 'gift', 'present', 'wrapped']",
                  "display": 1,
                  "translatedName": "presente embrulhado"
                },
                {
                  "code": "1f388",
                  "name": "balloon",
                  "category": "objects",
                  "keywords": "['celebration']",
                  "display": 1,
                  "translatedName": "balão"
                },
                {
                  "code": "1f38f",
                  "name": "carp streamer",
                  "category": "objects",
                  "keywords": "['carp', 'celebration', 'streamer']",
                  "display": 1,
                  "translatedName": "flâmula de carpa."
                },
                {
                  "code": "1f380",
                  "name": "ribbon",
                  "category": "objects",
                  "keywords": "['celebration']",
                  "display": 1,
                  "translatedName": "fita"
                },
                {
                  "code": "1f38a",
                  "name": "confetti ball",
                  "category": "objects",
                  "keywords": "['ball', 'celebration', 'confetti']",
                  "display": 1,
                  "translatedName": "bola de confete."
                },
                {
                  "code": "1f389",
                  "name": "party popper",
                  "category": "objects",
                  "keywords": "['celebration', 'party', 'popper', 'tada']",
                  "display": 1,
                  "translatedName": "Popper de festa"
                },
                {
                  "code": "1f38e",
                  "name": "Japanese dolls",
                  "category": "objects",
                  "keywords": "['Japanese', 'celebration', 'doll', 'festival']",
                  "display": 1,
                  "translatedName": "Bonecas japonesas"
                },
                {
                  "code": "1f3ee",
                  "name": "red paper lantern",
                  "category": "objects",
                  "keywords": "['bar', 'lantern', 'light', 'red']",
                  "display": 1,
                  "translatedName": "Lanterna de papel vermelho"
                },
                {
                  "code": "1f390",
                  "name": "wind chime",
                  "category": "objects",
                  "keywords": "['bell', 'celebration', 'chime', 'wind']",
                  "display": 1,
                  "translatedName": "carrilhão de vento"
                },
                {
                  "code": 2709,
                  "name": "envelope",
                  "category": "objects",
                  "keywords": "['email', 'letter']",
                  "display": 1,
                  "translatedName": "envelope"
                },
                {
                  "code": "1f4e9",
                  "name": "envelope with arrow",
                  "category": "objects",
                  "keywords": "['arrow', 'down', 'e-mail', 'email', 'envelope', 'letter', 'mail', 'outgoing', 'sent']",
                  "display": 1,
                  "translatedName": "envelope com seta"
                },
                {
                  "code": "1f4e8",
                  "name": "incoming envelope",
                  "category": "objects",
                  "keywords": "['e-mail', 'email', 'envelope', 'incoming', 'letter', 'mail', 'receive']",
                  "display": 1,
                  "translatedName": "Envelope recebido"
                },
                {
                  "code": "1f4e7",
                  "name": "e-mail",
                  "category": "objects",
                  "keywords": "['email', 'letter', 'mail']",
                  "display": 1,
                  "translatedName": "o email"
                },
                {
                  "code": "1f48c",
                  "name": "love letter",
                  "category": "objects",
                  "keywords": "['heart', 'letter', 'love', 'mail']",
                  "display": 1,
                  "translatedName": "carta de amor"
                },
                {
                  "code": "1f4e5",
                  "name": "inbox tray",
                  "category": "objects",
                  "keywords": "['box', 'inbox', 'letter', 'mail', 'receive', 'tray']",
                  "display": 1,
                  "translatedName": "Bandeja de caixa de entrada"
                },
                {
                  "code": "1f4e4",
                  "name": "outbox tray",
                  "category": "objects",
                  "keywords": "['box', 'letter', 'mail', 'outbox', 'sent', 'tray']",
                  "display": 1,
                  "translatedName": "Bandeja Outbox."
                },
                {
                  "code": "1f4e6",
                  "name": "package",
                  "category": "objects",
                  "keywords": "['box', 'parcel']",
                  "display": 1,
                  "translatedName": "pacote"
                },
                {
                  "code": "1f3f7",
                  "name": "label",
                  "category": "objects",
                  "keywords": "['label']",
                  "display": 1,
                  "translatedName": "rótulo"
                },
                {
                  "code": "1f4ea",
                  "name": "closed mailbox with lowered flag",
                  "category": "objects",
                  "keywords": "['closed', 'lowered', 'mail', 'mailbox', 'postbox']",
                  "display": 1,
                  "translatedName": "caixa de correio fechada com bandeira abaixada"
                },
                {
                  "code": "1f4eb",
                  "name": "closed mailbox with raised flag",
                  "category": "objects",
                  "keywords": "['closed', 'mail', 'mailbox', 'postbox']",
                  "display": 1,
                  "translatedName": "caixa de correio fechada com bandeira levantada"
                },
                {
                  "code": "1f4ec",
                  "name": "open mailbox with raised flag",
                  "category": "objects",
                  "keywords": "['mail', 'mailbox', 'open', 'postbox']",
                  "display": 1,
                  "translatedName": "Abra a caixa de correio com bandeira levantada"
                },
                {
                  "code": "1f4ed",
                  "name": "open mailbox with lowered flag",
                  "category": "objects",
                  "keywords": "['lowered', 'mail', 'mailbox', 'open', 'postbox']",
                  "display": 1,
                  "translatedName": "Abra a caixa de correio com bandeira abaixada"
                },
                {
                  "code": "1f4ee",
                  "name": "postbox",
                  "category": "objects",
                  "keywords": "['mail', 'mailbox']",
                  "display": 1,
                  "translatedName": "caixa postal"
                },
                {
                  "code": "1f4ef",
                  "name": "postal horn",
                  "category": "objects",
                  "keywords": "['horn', 'post', 'postal']",
                  "display": 1,
                  "translatedName": "chifre postal"
                },
                {
                  "code": "1f4dc",
                  "name": "scroll",
                  "category": "objects",
                  "keywords": "['paper']",
                  "display": 1,
                  "translatedName": "rolagem"
                },
                {
                  "code": "1f4c3",
                  "name": "page with curl",
                  "category": "objects",
                  "keywords": "['curl', 'document', 'page']",
                  "display": 1,
                  "translatedName": "página com curl."
                },
                {
                  "code": "1f4c4",
                  "name": "page facing up",
                  "category": "objects",
                  "keywords": "['document', 'page']",
                  "display": 1,
                  "translatedName": "página voltada para cima"
                },
                {
                  "code": "1f4d1",
                  "name": "bookmark tabs",
                  "category": "objects",
                  "keywords": "['bookmark', 'mark', 'marker', 'tabs']",
                  "display": 1,
                  "translatedName": "guias de marcadores"
                },
                {
                  "code": "1f4ca",
                  "name": "bar chart",
                  "category": "objects",
                  "keywords": "['bar', 'chart', 'graph']",
                  "display": 1,
                  "translatedName": "gráfico de barras"
                },
                {
                  "code": "1f4c8",
                  "name": "chart increasing",
                  "category": "objects",
                  "keywords": "['chart', 'graph', 'growth', 'trend', 'upward']",
                  "display": 1,
                  "translatedName": "Gráfico aumentando"
                },
                {
                  "code": "1f4c9",
                  "name": "chart decreasing",
                  "category": "objects",
                  "keywords": "['chart', 'down', 'graph', 'trend']",
                  "display": 1,
                  "translatedName": "Gráfico decrescente"
                },
                {
                  "code": "1f5d2",
                  "name": "spiral notepad",
                  "category": "objects",
                  "keywords": "['note', 'pad', 'spiral']",
                  "display": 1,
                  "translatedName": "bloco de notas espiral."
                },
                {
                  "code": "1f5d3",
                  "name": "spiral calendar",
                  "category": "objects",
                  "keywords": "['calendar', 'pad', 'spiral']",
                  "display": 1,
                  "translatedName": "calendário espiral."
                },
                {
                  "code": "1f4c6",
                  "name": "tear-off calendar",
                  "category": "objects",
                  "keywords": "['calendar']",
                  "display": 1,
                  "translatedName": "Calendário de rasgo"
                },
                {
                  "code": "1f4c5",
                  "name": "calendar",
                  "category": "objects",
                  "keywords": "['date']",
                  "display": 1,
                  "translatedName": "calendário"
                },
                {
                  "code": "1f4c7",
                  "name": "card index",
                  "category": "objects",
                  "keywords": "['card', 'index', 'rolodex']",
                  "display": 1,
                  "translatedName": "fichário"
                },
                {
                  "code": "1f5c3",
                  "name": "card file box",
                  "category": "objects",
                  "keywords": "['box', 'card', 'file']",
                  "display": 1,
                  "translatedName": "Caixa de arquivo de cartão"
                },
                {
                  "code": "1f5f3",
                  "name": "ballot box with ballot",
                  "category": "objects",
                  "keywords": "['ballot', 'box']",
                  "display": 1,
                  "translatedName": "cédula com cédula"
                },
                {
                  "code": "1f5c4",
                  "name": "file cabinet",
                  "category": "objects",
                  "keywords": "['cabinet', 'file', 'filing']",
                  "display": 1,
                  "translatedName": "Armário de arquivo"
                },
                {
                  "code": "1f4cb",
                  "name": "clipboard",
                  "category": "objects",
                  "keywords": "['clipboard']",
                  "display": 1,
                  "translatedName": "prancheta"
                },
                {
                  "code": "1f4c1",
                  "name": "file folder",
                  "category": "objects",
                  "keywords": "['file', 'folder']",
                  "display": 1,
                  "translatedName": "pasta de arquivo"
                },
                {
                  "code": "1f4c2",
                  "name": "open file folder",
                  "category": "objects",
                  "keywords": "['file', 'folder', 'open']",
                  "display": 1,
                  "translatedName": "Abra a pasta de arquivos"
                },
                {
                  "code": "1f5c2",
                  "name": "card index dividers",
                  "category": "objects",
                  "keywords": "['card', 'dividers', 'index']",
                  "display": 1,
                  "translatedName": "Divisores de índice de cartão"
                },
                {
                  "code": "1f5de",
                  "name": "rolled-up newspaper",
                  "category": "objects",
                  "keywords": "['news', 'newspaper', 'paper', 'rolled']",
                  "display": 1,
                  "translatedName": "jornal enrolado"
                },
                {
                  "code": "1f4f0",
                  "name": "newspaper",
                  "category": "objects",
                  "keywords": "['news', 'paper']",
                  "display": 1,
                  "translatedName": "jornal"
                },
                {
                  "code": "1f4d3",
                  "name": "notebook",
                  "category": "objects",
                  "keywords": "['notebook']",
                  "display": 1,
                  "translatedName": "caderno"
                },
                {
                  "code": "1f4d4",
                  "name": "notebook with decorative cover",
                  "category": "objects",
                  "keywords": "['book', 'cover', 'decorated', 'notebook']",
                  "display": 1,
                  "translatedName": "Notebook com cobertura decorativa"
                },
                {
                  "code": "1f4d2",
                  "name": "ledger",
                  "category": "objects",
                  "keywords": "['notebook']",
                  "display": 1,
                  "translatedName": "Ledger."
                },
                {
                  "code": "1f4d5",
                  "name": "closed book",
                  "category": "objects",
                  "keywords": "['book', 'closed']",
                  "display": 1,
                  "translatedName": "livro fechado"
                },
                {
                  "code": "1f4d7",
                  "name": "green book",
                  "category": "objects",
                  "keywords": "['book', 'green']",
                  "display": 1,
                  "translatedName": "Livro Verde"
                },
                {
                  "code": "1f4d8",
                  "name": "blue book",
                  "category": "objects",
                  "keywords": "['blue', 'book']",
                  "display": 1,
                  "translatedName": "livro Azul"
                },
                {
                  "code": "1f4d9",
                  "name": "orange book",
                  "category": "objects",
                  "keywords": "['book', 'orange']",
                  "display": 1,
                  "translatedName": "Livro laranja"
                },
                {
                  "code": "1f4da",
                  "name": "books",
                  "category": "objects",
                  "keywords": "['book']",
                  "display": 1,
                  "translatedName": "livros"
                },
                {
                  "code": "1f4d6",
                  "name": "open book",
                  "category": "objects",
                  "keywords": "['book', 'open']",
                  "display": 1,
                  "translatedName": "abra o livro"
                },
                {
                  "code": "1f516",
                  "name": "bookmark",
                  "category": "objects",
                  "keywords": "['mark']",
                  "display": 1,
                  "translatedName": "marca páginas"
                },
                {
                  "code": "1f517",
                  "name": "link",
                  "category": "objects",
                  "keywords": "['link']",
                  "display": 1,
                  "translatedName": "ligação"
                },
                {
                  "code": "1f4ce",
                  "name": "paperclip",
                  "category": "objects",
                  "keywords": "['paperclip']",
                  "display": 1,
                  "translatedName": "clipe de papel"
                },
                {
                  "code": "1f587",
                  "name": "linked paperclips",
                  "category": "objects",
                  "keywords": "['link', 'paperclip']",
                  "display": 1,
                  "translatedName": "Paperclips vinculados"
                },
                {
                  "code": "1f4d0",
                  "name": "triangular ruler",
                  "category": "objects",
                  "keywords": "['ruler', 'set', 'triangle']",
                  "display": 1,
                  "translatedName": "régua triangular"
                },
                {
                  "code": "1f4cf",
                  "name": "straight ruler",
                  "category": "objects",
                  "keywords": "['ruler', 'straight edge']",
                  "display": 1,
                  "translatedName": "governante reto"
                },
                {
                  "code": "1f4cc",
                  "name": "pushpin",
                  "category": "objects",
                  "keywords": "['pin']",
                  "display": 1,
                  "translatedName": "pushpin"
                },
                {
                  "code": "1f4cd",
                  "name": "round pushpin",
                  "category": "objects",
                  "keywords": "['pin', 'pushpin']",
                  "display": 1,
                  "translatedName": "Pushpin redondo"
                },
                {
                  "code": 2702,
                  "name": "scissors",
                  "category": "objects",
                  "keywords": "['cutting', 'tool']",
                  "display": 1,
                  "translatedName": "tesoura"
                },
                {
                  "code": "1f58a",
                  "name": "pen",
                  "category": "objects",
                  "keywords": "['ballpoint']",
                  "display": 1,
                  "translatedName": "caneta"
                },
                {
                  "code": "1f58b",
                  "name": "fountain pen",
                  "category": "objects",
                  "keywords": "['fountain', 'pen']",
                  "display": 1,
                  "translatedName": "caneta tinteiro"
                },
                {
                  "code": 2712,
                  "name": "black nib",
                  "category": "objects",
                  "keywords": "['nib', 'pen']",
                  "display": 1,
                  "translatedName": "nib negra"
                },
                {
                  "code": "1f58c",
                  "name": "paintbrush",
                  "category": "objects",
                  "keywords": "['painting']",
                  "display": 1,
                  "translatedName": "pincel"
                },
                {
                  "code": "1f58d",
                  "name": "crayon",
                  "category": "objects",
                  "keywords": "['crayon']",
                  "display": 1,
                  "translatedName": "GIS de cera"
                },
                {
                  "code": "1f4dd",
                  "name": "memo",
                  "category": "objects",
                  "keywords": "['pencil']",
                  "display": 1,
                  "translatedName": "memorando"
                },
                {
                  "code": "270f",
                  "name": "pencil",
                  "category": "objects",
                  "keywords": "['pencil']",
                  "display": 1,
                  "translatedName": "lápis"
                },
                {
                  "code": "1f50d",
                  "name": "left-pointing magnifying glass",
                  "category": "objects",
                  "keywords": "['glass', 'magnifying', 'search', 'tool']",
                  "display": 1,
                  "translatedName": "Lupa apontadora esquerda"
                },
                {
                  "code": "1f50e",
                  "name": "right-pointing magnifying glass",
                  "category": "objects",
                  "keywords": "['glass', 'magnifying', 'search', 'tool']",
                  "display": 1,
                  "translatedName": "Lupa apontando para a direita"
                },
                {
                  "code": "1f50f",
                  "name": "locked with pen",
                  "category": "objects",
                  "keywords": "['ink', 'lock', 'nib', 'pen', 'privacy']",
                  "display": 1,
                  "translatedName": "Trancado com caneta"
                },
                {
                  "code": "1f510",
                  "name": "locked with key",
                  "category": "objects",
                  "keywords": "['closed', 'key', 'lock', 'secure']",
                  "display": 1,
                  "translatedName": "Bloqueado com chave"
                },
                {
                  "code": "1f512",
                  "name": "locked",
                  "category": "objects",
                  "keywords": "['closed']",
                  "display": 1,
                  "translatedName": "trancado"
                },
                {
                  "code": "1f513",
                  "name": "unlocked",
                  "category": "objects",
                  "keywords": "['lock', 'open', 'unlock']",
                  "display": 1,
                  "translatedName": "desbloqueado"
                },
                {
                  "code": "1f9e1",
                  "name": "orange heart",
                  "category": "objects",
                  "keywords": "['orange']",
                  "display": 1,
                  "translatedName": "coração laranja"
                },
                {
                  "code": 2764,
                  "name": "red heart",
                  "category": "symbols",
                  "keywords": "['heart']",
                  "display": 1,
                  "translatedName": "coração vermelho"
                },
                {
                  "code": "1f49b",
                  "name": "yellow heart",
                  "category": "symbols",
                  "keywords": "['yellow']",
                  "display": 1,
                  "translatedName": "Coração amarelo"
                },
                {
                  "code": "1f49a",
                  "name": "green heart",
                  "category": "symbols",
                  "keywords": "['green']",
                  "display": 1,
                  "translatedName": "coração verde"
                },
                {
                  "code": "1f499",
                  "name": "blue heart",
                  "category": "symbols",
                  "keywords": "['blue']",
                  "display": 1,
                  "translatedName": "Coração azul"
                },
                {
                  "code": "1f49c",
                  "name": "purple heart",
                  "category": "symbols",
                  "keywords": "['purple']",
                  "display": 1,
                  "translatedName": "coração roxo"
                },
                {
                  "code": "1f5a4",
                  "name": "black heart",
                  "category": "symbols",
                  "keywords": "['black', 'evil', 'wicked']",
                  "display": 1,
                  "translatedName": "coração preto"
                },
                {
                  "code": "1f494",
                  "name": "broken heart",
                  "category": "symbols",
                  "keywords": "['break', 'broken']",
                  "display": 1,
                  "translatedName": "coração partido"
                },
                {
                  "code": 2763,
                  "name": "heavy heart exclamation",
                  "category": "symbols",
                  "keywords": "['exclamation', 'mark', 'punctuation']",
                  "display": 1,
                  "translatedName": "Exclamação do coração pesado"
                },
                {
                  "code": "1f495",
                  "name": "two hearts",
                  "category": "symbols",
                  "keywords": "['love']",
                  "display": 1,
                  "translatedName": "dois corações"
                },
                {
                  "code": "1f49e",
                  "name": "revolving hearts",
                  "category": "symbols",
                  "keywords": "['revolving']",
                  "display": 1,
                  "translatedName": "corações rotativos"
                },
                {
                  "code": "1f493",
                  "name": "beating heart",
                  "category": "symbols",
                  "keywords": "['beating', 'heartbeat', 'pulsating']",
                  "display": 1,
                  "translatedName": "batendo coração"
                },
                {
                  "code": "1f497",
                  "name": "growing heart",
                  "category": "symbols",
                  "keywords": "['excited', 'growing', 'nervous', 'pulse']",
                  "display": 1,
                  "translatedName": "Coração crescente"
                },
                {
                  "code": "1f496",
                  "name": "sparkling heart",
                  "category": "symbols",
                  "keywords": "['excited', 'sparkle']",
                  "display": 1,
                  "translatedName": "coração espumante"
                },
                {
                  "code": "1f498",
                  "name": "heart with arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'cupid']",
                  "display": 1,
                  "translatedName": "Coração com flecha"
                },
                {
                  "code": "1f49d",
                  "name": "heart with ribbon",
                  "category": "symbols",
                  "keywords": "['ribbon', 'valentine']",
                  "display": 1,
                  "translatedName": "Coração com fita"
                },
                {
                  "code": "1f49f",
                  "name": "heart decoration",
                  "category": "symbols",
                  "keywords": "['heart']",
                  "display": 1,
                  "translatedName": "Decoração do coração"
                },
                {
                  "code": "262e",
                  "name": "peace symbol",
                  "category": "symbols",
                  "keywords": "['peace']",
                  "display": 1,
                  "translatedName": "símbolo de paz"
                },
                {
                  "code": "271d",
                  "name": "latin cross",
                  "category": "symbols",
                  "keywords": "['Christian', 'cross', 'religion']",
                  "display": 1,
                  "translatedName": "Cross latin."
                },
                {
                  "code": "262a",
                  "name": "star and crescent",
                  "category": "symbols",
                  "keywords": "['Muslim', 'islam', 'religion']",
                  "display": 1,
                  "translatedName": "estrela e crescente"
                },
                {
                  "code": "1f549",
                  "name": "om",
                  "category": "symbols",
                  "keywords": "['Hindu', 'religion']",
                  "display": 1,
                  "translatedName": "om."
                },
                {
                  "code": 2638,
                  "name": "wheel of dharma",
                  "category": "symbols",
                  "keywords": "['Buddhist', 'dharma', 'religion', 'wheel']",
                  "display": 1,
                  "translatedName": "Roda do Dharma"
                },
                {
                  "code": 2721,
                  "name": "star of David",
                  "category": "symbols",
                  "keywords": "['David', 'Jew', 'Jewish', 'religion', 'star']",
                  "display": 1,
                  "translatedName": "estrela de Davi"
                },
                {
                  "code": "1f52f",
                  "name": "dotted six-pointed star",
                  "category": "symbols",
                  "keywords": "['fortune', 'star']",
                  "display": 1,
                  "translatedName": "estrela pontilhada de seis pontas"
                },
                {
                  "code": "1f54e",
                  "name": "menorah",
                  "category": "symbols",
                  "keywords": "['candelabrum', 'candlestick', 'religion']",
                  "display": 1,
                  "translatedName": "Menorah."
                },
                {
                  "code": "262f",
                  "name": "yin yang",
                  "category": "symbols",
                  "keywords": "['religion', 'tao', 'taoist', 'yang', 'yin']",
                  "display": 1,
                  "translatedName": "Yin Yang."
                },
                {
                  "code": 2626,
                  "name": "orthodox cross",
                  "category": "symbols",
                  "keywords": "['Christian', 'cross', 'religion']",
                  "display": 1,
                  "translatedName": "Cross ortodoxo"
                },
                {
                  "code": "1f6d0",
                  "name": "place of worship",
                  "category": "symbols",
                  "keywords": "['religion', 'worship']",
                  "display": 1,
                  "translatedName": "local de culto"
                },
                {
                  "code": "26ce",
                  "name": "Ophiuchus",
                  "category": "symbols",
                  "keywords": "['bearer', 'serpent', 'snake', 'zodiac']",
                  "display": 1,
                  "translatedName": "Ophiuchus."
                },
                {
                  "code": 2648,
                  "name": "Aries",
                  "category": "symbols",
                  "keywords": "['ram', 'zodiac']",
                  "display": 1,
                  "translatedName": "Áries"
                },
                {
                  "code": 2649,
                  "name": "Taurus",
                  "category": "symbols",
                  "keywords": "['bull', 'ox', 'zodiac']",
                  "display": 1,
                  "translatedName": "Touro"
                },
                {
                  "code": "264a",
                  "name": "Gemini",
                  "category": "symbols",
                  "keywords": "['twins', 'zodiac']",
                  "display": 1,
                  "translatedName": "Gêmeos"
                },
                {
                  "code": "264b",
                  "name": "Cancer",
                  "category": "symbols",
                  "keywords": "['crab', 'zodiac']",
                  "display": 1,
                  "translatedName": "Câncer"
                },
                {
                  "code": "264c",
                  "name": "Leo",
                  "category": "symbols",
                  "keywords": "['lion', 'zodiac']",
                  "display": 1,
                  "translatedName": "Leo."
                },
                {
                  "code": "264d",
                  "name": "Virgo",
                  "category": "symbols",
                  "keywords": "['zodiac']",
                  "display": 1,
                  "translatedName": "Virgem"
                },
                {
                  "code": "264e",
                  "name": "Libra",
                  "category": "symbols",
                  "keywords": "['balance', 'justice', 'scales', 'zodiac']",
                  "display": 1,
                  "translatedName": "Libra"
                },
                {
                  "code": "264f",
                  "name": "Scorpius",
                  "category": "symbols",
                  "keywords": "['scorpio', 'scorpion', 'zodiac']",
                  "display": 1,
                  "translatedName": "Scorpius."
                },
                {
                  "code": 2650,
                  "name": "Sagittarius",
                  "category": "symbols",
                  "keywords": "['archer', 'zodiac']",
                  "display": 1,
                  "translatedName": "Sagitário"
                },
                {
                  "code": 2651,
                  "name": "Capricorn",
                  "category": "symbols",
                  "keywords": "['goat', 'zodiac']",
                  "display": 1,
                  "translatedName": "Capricórnio"
                },
                {
                  "code": 2652,
                  "name": "Aquarius",
                  "category": "symbols",
                  "keywords": "['bearer', 'water', 'zodiac']",
                  "display": 1,
                  "translatedName": "Aquário"
                },
                {
                  "code": 2653,
                  "name": "Pisces",
                  "category": "symbols",
                  "keywords": "['fish', 'zodiac']",
                  "display": 1,
                  "translatedName": "Peixes"
                },
                {
                  "code": "1f194",
                  "name": "ID button",
                  "category": "symbols",
                  "keywords": "['id', 'identity']",
                  "display": 1,
                  "translatedName": "Botão de identificação"
                },
                {
                  "code": "269b",
                  "name": "atom symbol",
                  "category": "symbols",
                  "keywords": "['atheist', 'atom']",
                  "display": 1,
                  "translatedName": "símbolo do átomo."
                },
                {
                  "code": "1f251",
                  "name": "Japanese “acceptable” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“acceptable”', '可']",
                  "display": 1,
                  "translatedName": "Botão \"aceitável\" japonês"
                },
                {
                  "code": 2622,
                  "name": "radioactive",
                  "category": "symbols",
                  "keywords": "['radioactive', 'sign']",
                  "display": 1,
                  "translatedName": "radioativo"
                },
                {
                  "code": 2623,
                  "name": "biohazard",
                  "category": "symbols",
                  "keywords": "['biohazard', 'sign']",
                  "display": 1,
                  "translatedName": "risco biológico"
                },
                {
                  "code": "1f4f4",
                  "name": "mobile phone off",
                  "category": "symbols",
                  "keywords": "['cell', 'mobile', 'off', 'phone', 'telephone']",
                  "display": 1,
                  "translatedName": "Telefone celular desligado"
                },
                {
                  "code": "1f4f3",
                  "name": "vibration mode",
                  "category": "symbols",
                  "keywords": "['cell', 'mobile', 'mode', 'phone', 'telephone', 'vibration']",
                  "display": 1,
                  "translatedName": "modo de vibração"
                },
                {
                  "code": "1f236",
                  "name": "Japanese “not free of charge” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“not free of charge”', '有']",
                  "display": 1,
                  "translatedName": "Botão japonês \"não livre"
                },
                {
                  "code": "1f21a",
                  "name": "Japanese “free of charge” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“free of charge”', '無']",
                  "display": 1,
                  "translatedName": "Botão japonês de \"grátis"
                },
                {
                  "code": "1f238",
                  "name": "Japanese “application” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“application”', '申']",
                  "display": 1,
                  "translatedName": "Botão de \"aplicação\" japonês"
                },
                {
                  "code": "1f23a",
                  "name": "Japanese “open for business” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“open for business”', '営']",
                  "display": 1,
                  "translatedName": "Botão japonês \"aberto para negócios"
                },
                {
                  "code": "1f237",
                  "name": "Japanese “monthly amount” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“monthly amount”', '月']",
                  "display": 1,
                  "translatedName": "Botão de \"quantidade mensal\" japonês"
                },
                {
                  "code": 2734,
                  "name": "eight-pointed star",
                  "category": "symbols",
                  "keywords": "['star']",
                  "display": 1,
                  "translatedName": "estrela de oito pontas"
                },
                {
                  "code": "1f19a",
                  "name": "VS button",
                  "category": "symbols",
                  "keywords": "['versus', 'vs']",
                  "display": 1,
                  "translatedName": "Vs botão."
                },
                {
                  "code": "1f4ae",
                  "name": "white flower",
                  "category": "symbols",
                  "keywords": "['flower']",
                  "display": 1,
                  "translatedName": "Flor branca"
                },
                {
                  "code": "1f250",
                  "name": "Japanese “bargain” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“bargain”', '得']",
                  "display": 1,
                  "translatedName": "Botão japonês \"barganha"
                },
                {
                  "code": 3299,
                  "name": "Japanese “secret” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“secret”', '秘']",
                  "display": 1,
                  "translatedName": "Botão \"secreto\" japonês"
                },
                {
                  "code": 3297,
                  "name": "Japanese “congratulations” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“congratulations”', '祝']",
                  "display": 1,
                  "translatedName": "Botão japonês \"Parabéns"
                },
                {
                  "code": "1f234",
                  "name": "Japanese “passing grade” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“passing grade”', '合']",
                  "display": 1,
                  "translatedName": "Botão japonês \"passagem"
                },
                {
                  "code": "1f235",
                  "name": "Japanese “no vacancy” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“no vacancy”', '満']",
                  "display": 1,
                  "translatedName": "Botão japonês \"No Vacancy"
                },
                {
                  "code": "1f239",
                  "name": "Japanese “discount” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“discount”', '割']",
                  "display": 1,
                  "translatedName": "Botão de \"desconto\" japonês"
                },
                {
                  "code": "1f232",
                  "name": "Japanese “prohibited” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“prohibited”', '禁']",
                  "display": 1,
                  "translatedName": "Botão japonês \"proibido"
                },
                {
                  "code": "1f170",
                  "name": "A button (blood type)",
                  "category": "symbols",
                  "keywords": "['a', 'blood type']",
                  "display": 1,
                  "translatedName": "Um botão (tipo de sangue)"
                },
                {
                  "code": "1f171",
                  "name": "B button (blood type)",
                  "category": "symbols",
                  "keywords": "['b', 'blood type']",
                  "display": 1,
                  "translatedName": "Botão B (tipo de sangue)"
                },
                {
                  "code": "1f18e",
                  "name": "AB button (blood type)",
                  "category": "symbols",
                  "keywords": "['ab', 'blood type']",
                  "display": 1,
                  "translatedName": "Botão ab (tipo de sangue)"
                },
                {
                  "code": "1f191",
                  "name": "CL button",
                  "category": "symbols",
                  "keywords": "['cl']",
                  "display": 1,
                  "translatedName": "Botão cl"
                },
                {
                  "code": "1f17e",
                  "name": "O button (blood type)",
                  "category": "symbols",
                  "keywords": "['blood type', 'o']",
                  "display": 1,
                  "translatedName": "O botão (tipo de sangue)"
                },
                {
                  "code": "1f198",
                  "name": "SOS button",
                  "category": "symbols",
                  "keywords": "['help', 'sos']",
                  "display": 1,
                  "translatedName": "Botão SOS."
                },
                {
                  "code": "274c",
                  "name": "cross mark",
                  "category": "symbols",
                  "keywords": "['cancel', 'mark', 'multiplication', 'multiply', 'x']",
                  "display": 1,
                  "translatedName": "Marca Cross"
                },
                {
                  "code": "2b55",
                  "name": "heavy large circle",
                  "category": "symbols",
                  "keywords": "['circle', 'o']",
                  "display": 1,
                  "translatedName": "Círculo grande pesado"
                },
                {
                  "code": "1f6d1",
                  "name": "stop sign",
                  "category": "symbols",
                  "keywords": "['octagonal', 'sign', 'stop']",
                  "display": 1,
                  "translatedName": "Sinal de parada"
                },
                {
                  "code": "26d4",
                  "name": "no entry",
                  "category": "symbols",
                  "keywords": "['entry', 'forbidden', 'no', 'not', 'prohibited', 'traffic']",
                  "display": 1,
                  "translatedName": "Entrada proibida"
                },
                {
                  "code": "1f4db",
                  "name": "name badge",
                  "category": "symbols",
                  "keywords": "['badge', 'name']",
                  "display": 1,
                  "translatedName": "Nome Badge."
                },
                {
                  "code": "1f6ab",
                  "name": "prohibited",
                  "category": "symbols",
                  "keywords": "['entry', 'forbidden', 'no', 'not']",
                  "display": 1,
                  "translatedName": "Proibido"
                },
                {
                  "code": "1f4af",
                  "name": "hundred points",
                  "category": "symbols",
                  "keywords": "['100', 'full', 'hundred', 'score']",
                  "display": 1,
                  "translatedName": "cem pontos"
                },
                {
                  "code": "1f4a2",
                  "name": "anger symbol",
                  "category": "symbols",
                  "keywords": "['angry', 'comic', 'mad']",
                  "display": 1,
                  "translatedName": "símbolo de raiva"
                },
                {
                  "code": 2668,
                  "name": "hot springs",
                  "category": "symbols",
                  "keywords": "['hot', 'hotsprings', 'springs', 'steaming']",
                  "display": 1,
                  "translatedName": "Hot Springs."
                },
                {
                  "code": "1f6b7",
                  "name": "no pedestrians",
                  "category": "symbols",
                  "keywords": "['forbidden', 'no', 'not', 'pedestrian', 'prohibited']",
                  "display": 1,
                  "translatedName": "Proibido Pedestres"
                },
                {
                  "code": "1f6af",
                  "name": "no littering",
                  "category": "symbols",
                  "keywords": "['forbidden', 'litter', 'no', 'not', 'prohibited']",
                  "display": 1,
                  "translatedName": "Proibido jogar lixo"
                },
                {
                  "code": "1f6b3",
                  "name": "no bicycles",
                  "category": "symbols",
                  "keywords": "['bicycle', 'bike', 'forbidden', 'no', 'not', 'prohibited']",
                  "display": 1,
                  "translatedName": "Proibido Bicicletas"
                },
                {
                  "code": "1f6b1",
                  "name": "non-potable water",
                  "category": "symbols",
                  "keywords": "['non-drinking', 'non-potable', 'water']",
                  "display": 1,
                  "translatedName": "água não potável"
                },
                {
                  "code": "1f51e",
                  "name": "no one under eighteen",
                  "category": "symbols",
                  "keywords": "['18', 'age restriction', 'eighteen', 'forbidden', 'no', 'not', 'prohibited', 'underage']",
                  "display": 1,
                  "translatedName": "Ninguém com menos de dezoito anos"
                },
                {
                  "code": "1f4f5",
                  "name": "no mobile phones",
                  "category": "symbols",
                  "keywords": "['cell', 'forbidden', 'mobile', 'no', 'not', 'phone', 'prohibited', 'telephone']",
                  "display": 1,
                  "translatedName": "Não há telefones celulares"
                },
                {
                  "code": "1f6ad",
                  "name": "no smoking",
                  "category": "symbols",
                  "keywords": "['forbidden', 'no', 'not', 'prohibited', 'smoking']",
                  "display": 1,
                  "translatedName": "Proibido fumar"
                },
                {
                  "code": 2757,
                  "name": "exclamation mark",
                  "category": "symbols",
                  "keywords": "['exclamation', 'mark', 'punctuation']",
                  "display": 1,
                  "translatedName": "ponto de exclamação"
                },
                {
                  "code": 2755,
                  "name": "white exclamation mark",
                  "category": "symbols",
                  "keywords": "['exclamation', 'mark', 'outlined', 'punctuation']",
                  "display": 1,
                  "translatedName": "Marca de exclamação branca"
                },
                {
                  "code": 2753,
                  "name": "question mark",
                  "category": "symbols",
                  "keywords": "['mark', 'punctuation', 'question']",
                  "display": 1,
                  "translatedName": "ponto de interrogação"
                },
                {
                  "code": 2754,
                  "name": "white question mark",
                  "category": "symbols",
                  "keywords": "['mark', 'outlined', 'punctuation', 'question']",
                  "display": 1,
                  "translatedName": "Ponto de interrogação branco"
                },
                {
                  "code": "203c",
                  "name": "double exclamation mark",
                  "category": "symbols",
                  "keywords": "['bangbang', 'exclamation', 'mark', 'punctuation']",
                  "display": 1,
                  "translatedName": "Marca de exclamação dupla."
                },
                {
                  "code": 2049,
                  "name": "exclamation question mark",
                  "category": "symbols",
                  "keywords": "['exclamation', 'interrobang', 'mark', 'punctuation', 'question']",
                  "display": 1,
                  "translatedName": "ponto de interrogação de exclamação."
                },
                {
                  "code": "1f505",
                  "name": "dim button",
                  "category": "symbols",
                  "keywords": "['brightness', 'dim', 'low']",
                  "display": 1,
                  "translatedName": "Botão escuro"
                },
                {
                  "code": "1f506",
                  "name": "bright button",
                  "category": "symbols",
                  "keywords": "['bright', 'brightness']",
                  "display": 1,
                  "translatedName": "Botão brilhante"
                },
                {
                  "code": "303d",
                  "name": "part alternation mark",
                  "category": "symbols",
                  "keywords": "['mark', 'part']",
                  "display": 1,
                  "translatedName": "Parte de marca de alternância"
                },
                {
                  "code": "26a0",
                  "name": "warning",
                  "category": "symbols",
                  "keywords": "['warning']",
                  "display": 1,
                  "translatedName": "aviso"
                },
                {
                  "code": "1f6b8",
                  "name": "children crossing",
                  "category": "symbols",
                  "keywords": "['child', 'crossing', 'pedestrian', 'traffic']",
                  "display": 1,
                  "translatedName": "Cruzamento de crianças"
                },
                {
                  "code": "1f531",
                  "name": "trident emblem",
                  "category": "symbols",
                  "keywords": "['anchor', 'emblem', 'ship', 'tool', 'trident']",
                  "display": 1,
                  "translatedName": "Emblema Tridente"
                },
                {
                  "code": "269c",
                  "name": "fleur-de-lis",
                  "category": "symbols",
                  "keywords": "['fleur-de-lis']",
                  "display": 1,
                  "translatedName": "fleur-de-lis"
                },
                {
                  "code": "1f530",
                  "name": "Japanese symbol for beginner",
                  "category": "symbols",
                  "keywords": "['Japanese', 'beginner', 'chevron', 'green', 'leaf', 'tool', 'yellow']",
                  "display": 1,
                  "translatedName": "Símbolo japonês para iniciante"
                },
                {
                  "code": "267b",
                  "name": "recycling symbol",
                  "category": "symbols",
                  "keywords": "['recycle']",
                  "display": 1,
                  "translatedName": "Símbolo de reciclagem"
                },
                {
                  "code": 2705,
                  "name": "white heavy check mark",
                  "category": "symbols",
                  "keywords": "['check', 'mark']",
                  "display": 1,
                  "translatedName": "marca de cheque pesado branco"
                },
                {
                  "code": "1f22f",
                  "name": "Japanese “reserved” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“reserved”', '指']",
                  "display": 1,
                  "translatedName": "Botão japonês \"reservado"
                },
                {
                  "code": "1f4b9",
                  "name": "chart increasing with yen",
                  "category": "symbols",
                  "keywords": "['bank', 'chart', 'currency', 'graph', 'growth', 'market', 'money', 'rise', 'trend', 'upward', 'yen']",
                  "display": 1,
                  "translatedName": "Gráfico aumentando com iene"
                },
                {
                  "code": 2747,
                  "name": "sparkle",
                  "category": "symbols",
                  "keywords": "['sparkle']",
                  "display": 1,
                  "translatedName": "brilhar"
                },
                {
                  "code": 2733,
                  "name": "eight-spoked asterisk",
                  "category": "symbols",
                  "keywords": "['asterisk']",
                  "display": 1,
                  "translatedName": "asterisco de oito direcionado"
                },
                {
                  "code": "274e",
                  "name": "cross mark button",
                  "category": "symbols",
                  "keywords": "['mark', 'square']",
                  "display": 1,
                  "translatedName": "Botão de marca cruzada"
                },
                {
                  "code": "1f310",
                  "name": "globe with meridians",
                  "category": "symbols",
                  "keywords": "['earth', 'globe', 'meridians', 'world']",
                  "display": 1,
                  "translatedName": "Globo com meridianos"
                },
                {
                  "code": "1f4a0",
                  "name": "diamond with a dot",
                  "category": "symbols",
                  "keywords": "['comic', 'diamond', 'geometric', 'inside']",
                  "display": 1,
                  "translatedName": "diamante com um ponto"
                },
                {
                  "code": "24c2",
                  "name": "circled M",
                  "category": "symbols",
                  "keywords": "['circle', 'm']",
                  "display": 1,
                  "translatedName": "circulou M."
                },
                {
                  "code": "1f300",
                  "name": "cyclone",
                  "category": "symbols",
                  "keywords": "['dizzy', 'twister', 'typhoon']",
                  "display": 1,
                  "translatedName": "ciclone"
                },
                {
                  "code": "1f4a4",
                  "name": "zzz",
                  "category": "symbols",
                  "keywords": "['comic', 'sleep']",
                  "display": 1,
                  "translatedName": "zzz."
                },
                {
                  "code": "1f3e7",
                  "name": "ATM sign",
                  "category": "symbols",
                  "keywords": "['atm', 'automated', 'bank', 'teller']",
                  "display": 1,
                  "translatedName": "Sinal ATM"
                },
                {
                  "code": "1f6be",
                  "name": "water closet",
                  "category": "symbols",
                  "keywords": "['closet', 'lavatory', 'restroom', 'water', 'wc']",
                  "display": 1,
                  "translatedName": "armário de água."
                },
                {
                  "code": "267f",
                  "name": "wheelchair symbol",
                  "category": "symbols",
                  "keywords": "['access']",
                  "display": 1,
                  "translatedName": "Símbolo de cadeira de rodas"
                },
                {
                  "code": "1f17f",
                  "name": "P button",
                  "category": "symbols",
                  "keywords": "['parking']",
                  "display": 1,
                  "translatedName": "Botão P."
                },
                {
                  "code": "1f233",
                  "name": "Japanese “vacancy” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'ideograph', '“vacancy”', '空']",
                  "display": 1,
                  "translatedName": "Botão de \"vaga\" japonês"
                },
                {
                  "code": "1f202",
                  "name": "Japanese “service charge” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'katakana', '“service charge”', 'サ']",
                  "display": 1,
                  "translatedName": "Botão de \"custo de serviço\" japonês"
                },
                {
                  "code": "1f6c2",
                  "name": "passport control",
                  "category": "symbols",
                  "keywords": "['control', 'passport']",
                  "display": 1,
                  "translatedName": "controle de passaporte"
                },
                {
                  "code": "1f6c3",
                  "name": "customs",
                  "category": "symbols",
                  "keywords": "['customs']",
                  "display": 1,
                  "translatedName": "Alfândega"
                },
                {
                  "code": "1f6c4",
                  "name": "baggage claim",
                  "category": "symbols",
                  "keywords": "['baggage', 'claim']",
                  "display": 1,
                  "translatedName": "Reivindicação de bagagem"
                },
                {
                  "code": "1f6c5",
                  "name": "left luggage",
                  "category": "symbols",
                  "keywords": "['baggage', 'locker', 'luggage']",
                  "display": 1,
                  "translatedName": "bagagem esquerda"
                },
                {
                  "code": "1f6b9",
                  "name": "men’s room",
                  "category": "symbols",
                  "keywords": "['lavatory', 'man', 'restroom', 'wc']",
                  "display": 1,
                  "translatedName": "quarto de homens"
                },
                {
                  "code": "1f6ba",
                  "name": "women’s room",
                  "category": "symbols",
                  "keywords": "['lavatory', 'restroom', 'wc', 'woman']",
                  "display": 1,
                  "translatedName": "sala das mulheres"
                },
                {
                  "code": "1f6bc",
                  "name": "baby symbol",
                  "category": "symbols",
                  "keywords": "['baby', 'changing']",
                  "display": 1,
                  "translatedName": "símbolo do bebê"
                },
                {
                  "code": "1f6bb",
                  "name": "restroom",
                  "category": "symbols",
                  "keywords": "['WC', 'lavatory', 'restroom']",
                  "display": 1,
                  "translatedName": "banheiro"
                },
                {
                  "code": "1f6ae",
                  "name": "litter in bin sign",
                  "category": "symbols",
                  "keywords": "['litter', 'litter bin']",
                  "display": 1,
                  "translatedName": "ninhada no sinal de bin"
                },
                {
                  "code": "1f3a6",
                  "name": "cinema",
                  "category": "symbols",
                  "keywords": "['camera', 'film', 'movie']",
                  "display": 1,
                  "translatedName": "cinema"
                },
                {
                  "code": "1f4f6",
                  "name": "antenna bars",
                  "category": "symbols",
                  "keywords": "['antenna', 'bar', 'cell', 'mobile', 'phone', 'signal', 'telephone']",
                  "display": 1,
                  "translatedName": "barras de antena"
                },
                {
                  "code": "1f201",
                  "name": "Japanese “here” button",
                  "category": "symbols",
                  "keywords": "['Japanese', 'katakana', '“here”', 'ココ']",
                  "display": 1,
                  "translatedName": "Botão japonês \"aqui"
                },
                {
                  "code": "1f523",
                  "name": "input symbols",
                  "category": "symbols",
                  "keywords": "['input', '〒♪&amp;%']",
                  "display": 1,
                  "translatedName": "Símbolos de entrada"
                },
                {
                  "code": 2139,
                  "name": "information",
                  "category": "symbols",
                  "keywords": "['i', 'information']",
                  "display": 1,
                  "translatedName": "em formação"
                },
                {
                  "code": "1f524",
                  "name": "input latin letters",
                  "category": "symbols",
                  "keywords": "['abc', 'alphabet', 'input', 'latin', 'letters']",
                  "display": 1,
                  "translatedName": "Entrada letras latinas."
                },
                {
                  "code": "1f521",
                  "name": "input latin lowercase",
                  "category": "symbols",
                  "keywords": "['abcd', 'input', 'latin', 'letters', 'lowercase']",
                  "display": 1,
                  "translatedName": "entrada em minúsculas latin."
                },
                {
                  "code": "1f520",
                  "name": "input latin uppercase",
                  "category": "symbols",
                  "keywords": "['ABCD', 'input', 'latin', 'letters', 'uppercase']",
                  "display": 1,
                  "translatedName": "entrada em maiúsculas latinas."
                },
                {
                  "code": "1f196",
                  "name": "NG button",
                  "category": "symbols",
                  "keywords": "['ng']",
                  "display": 1,
                  "translatedName": "Botão ng."
                },
                {
                  "code": "1f197",
                  "name": "OK button",
                  "category": "symbols",
                  "keywords": "['OK']",
                  "display": 1,
                  "translatedName": "Botão OK"
                },
                {
                  "code": "1f199",
                  "name": "UP! button",
                  "category": "symbols",
                  "keywords": "['mark', 'up']",
                  "display": 1,
                  "translatedName": "ACIMA! botão"
                },
                {
                  "code": "1f192",
                  "name": "COOL button",
                  "category": "symbols",
                  "keywords": "['cool']",
                  "display": 1,
                  "translatedName": "Botão legal"
                },
                {
                  "code": "1f195",
                  "name": "NEW button",
                  "category": "symbols",
                  "keywords": "['new']",
                  "display": 1,
                  "translatedName": "Botão novo"
                },
                {
                  "code": "1f193",
                  "name": "FREE button",
                  "category": "symbols",
                  "keywords": "['free']",
                  "display": 1,
                  "translatedName": "Botão grátis"
                },
                {
                  "code": "0030-20e3",
                  "name": "keycap: 0",
                  "category": "symbols",
                  "keywords": "['keycap']",
                  "display": 1,
                  "translatedName": "Keycap: 0."
                },
                {
                  "code": "0031-20e3",
                  "name": "keycap: 1",
                  "category": "symbols",
                  "keywords": "['keycap']",
                  "display": 1,
                  "translatedName": "Keycap: 1."
                },
                {
                  "code": "0032-20e3",
                  "name": "keycap: 2",
                  "category": "symbols",
                  "keywords": "['keycap']",
                  "display": 1,
                  "translatedName": "Keycap: 2."
                },
                {
                  "code": "0033-20e3",
                  "name": "keycap: 3",
                  "category": "symbols",
                  "keywords": "['keycap']",
                  "display": 1,
                  "translatedName": "Keycap: 3."
                },
                {
                  "code": "0034-20e3",
                  "name": "keycap: 4",
                  "category": "symbols",
                  "keywords": "['keycap']",
                  "display": 1,
                  "translatedName": "Keycap: 4."
                },
                {
                  "code": "0035-20e3",
                  "name": "keycap: 5",
                  "category": "symbols",
                  "keywords": "['keycap']",
                  "display": 1,
                  "translatedName": "Keycap: 5."
                },
                {
                  "code": "0036-20e3",
                  "name": "keycap: 6",
                  "category": "symbols",
                  "keywords": "['keycap']",
                  "display": 1,
                  "translatedName": "Keycap: 6."
                },
                {
                  "code": "0037-20e3",
                  "name": "keycap: 7",
                  "category": "symbols",
                  "keywords": "['keycap']",
                  "display": 1,
                  "translatedName": "Keycap: 7."
                },
                {
                  "code": "0038-20e3",
                  "name": "keycap: 8",
                  "category": "symbols",
                  "keywords": "['keycap']",
                  "display": 1,
                  "translatedName": "Keycap: 8."
                },
                {
                  "code": "0039-20e3",
                  "name": "keycap: 9",
                  "category": "symbols",
                  "keywords": "['keycap']",
                  "display": 1,
                  "translatedName": "KeyCap: 9."
                },
                {
                  "code": "1f51f",
                  "name": "keycap 10",
                  "category": "symbols",
                  "keywords": "['keycap 10']",
                  "display": 1,
                  "translatedName": "Keycap 10."
                },
                {
                  "code": "1f522",
                  "name": "input numbers",
                  "category": "symbols",
                  "keywords": "['1234', 'input', 'numbers']",
                  "display": 1,
                  "translatedName": "Números de entrada"
                },
                {
                  "code": "0023-20e3",
                  "name": "keycap: #",
                  "category": "symbols",
                  "keywords": "['keycap']",
                  "display": 1,
                  "translatedName": "Keycap: #"
                },
                {
                  "code": "002a-20e3",
                  "name": "keycap: *",
                  "category": "symbols",
                  "keywords": "['keycap']",
                  "display": 1,
                  "translatedName": "Keycap: *"
                },
                {
                  "code": "25b6",
                  "name": "play button",
                  "category": "symbols",
                  "keywords": "['arrow', 'play', 'right', 'triangle']",
                  "display": 1,
                  "translatedName": "Botão de reprodução"
                },
                {
                  "code": "23f8",
                  "name": "pause button",
                  "category": "symbols",
                  "keywords": "['bar', 'double', 'pause', 'vertical']",
                  "display": 1,
                  "translatedName": "Botão de pausa"
                },
                {
                  "code": "23ef",
                  "name": "play or pause button",
                  "category": "symbols",
                  "keywords": "['arrow', 'pause', 'play', 'right', 'triangle']",
                  "display": 1,
                  "translatedName": "Botão Reproduzir ou Pausar"
                },
                {
                  "code": "23f9",
                  "name": "stop button",
                  "category": "symbols",
                  "keywords": "['square', 'stop']",
                  "display": 1,
                  "translatedName": "botão de parada"
                },
                {
                  "code": "23fa",
                  "name": "record button",
                  "category": "symbols",
                  "keywords": "['circle', 'record']",
                  "display": 1,
                  "translatedName": "Botão de registro"
                },
                {
                  "code": "23cf",
                  "name": "eject button",
                  "category": "symbols",
                  "keywords": "['eject']",
                  "display": 1,
                  "translatedName": "botão de ejeção"
                },
                {
                  "code": "23ed",
                  "name": "next track button",
                  "category": "symbols",
                  "keywords": "['arrow', 'next scene', 'next track', 'triangle']",
                  "display": 1,
                  "translatedName": "Próximo botão de faixa"
                },
                {
                  "code": "23ee",
                  "name": "last track button",
                  "category": "symbols",
                  "keywords": "['arrow', 'previous scene', 'previous track', 'triangle']",
                  "display": 1,
                  "translatedName": "Último botão de faixa"
                },
                {
                  "code": "2,30E+10",
                  "name": "fast-forward button",
                  "category": "symbols",
                  "keywords": "['arrow', 'double', 'fast', 'forward']",
                  "display": 1,
                  "translatedName": "Botão Avançado"
                },
                {
                  "code": "23ea",
                  "name": "fast reverse button",
                  "category": "symbols",
                  "keywords": "['arrow', 'double', 'rewind']",
                  "display": 1,
                  "translatedName": "Botão reverso rápido"
                },
                {
                  "code": "23eb",
                  "name": "fast up button",
                  "category": "symbols",
                  "keywords": "['arrow', 'double']",
                  "display": 1,
                  "translatedName": "Botão de jejum"
                },
                {
                  "code": "23ec",
                  "name": "fast down button",
                  "category": "symbols",
                  "keywords": "['arrow', 'double', 'down']",
                  "display": 1,
                  "translatedName": "Botão rápido"
                },
                {
                  "code": "25c0",
                  "name": "reverse button",
                  "category": "symbols",
                  "keywords": "['arrow', 'left', 'reverse', 'triangle']",
                  "display": 1,
                  "translatedName": "Botão reverso"
                },
                {
                  "code": "1f53c",
                  "name": "up button",
                  "category": "symbols",
                  "keywords": "['arrow', 'button', 'red']",
                  "display": 1,
                  "translatedName": "botão para cima"
                },
                {
                  "code": "1f53d",
                  "name": "down button",
                  "category": "symbols",
                  "keywords": "['arrow', 'button', 'down', 'red']",
                  "display": 1,
                  "translatedName": "Botão para baixo"
                },
                {
                  "code": "27a1",
                  "name": "right arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'cardinal', 'direction', 'east']",
                  "display": 1,
                  "translatedName": "seta direita"
                },
                {
                  "code": "2b05",
                  "name": "left arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'cardinal', 'direction', 'west']",
                  "display": 1,
                  "translatedName": "seta esquerda"
                },
                {
                  "code": "2b06",
                  "name": "up arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'cardinal', 'direction', 'north']",
                  "display": 1,
                  "translatedName": "seta para cima"
                },
                {
                  "code": "2b07",
                  "name": "down arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'cardinal', 'direction', 'down', 'south']",
                  "display": 1,
                  "translatedName": "seta para baixo"
                },
                {
                  "code": 2197,
                  "name": "up-right arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'direction', 'intercardinal', 'northeast']",
                  "display": 1,
                  "translatedName": "seta para a direita"
                },
                {
                  "code": 2198,
                  "name": "down-right arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'direction', 'intercardinal', 'southeast']",
                  "display": 1,
                  "translatedName": "arrow para baixo"
                },
                {
                  "code": 2199,
                  "name": "down-left arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'direction', 'intercardinal', 'southwest']",
                  "display": 1,
                  "translatedName": "seta para baixo para a esquerda"
                },
                {
                  "code": 2196,
                  "name": "up-left arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'direction', 'intercardinal', 'northwest']",
                  "display": 1,
                  "translatedName": "seta para a esquerda"
                },
                {
                  "code": 2195,
                  "name": "up-down arrow",
                  "category": "symbols",
                  "keywords": "['arrow']",
                  "display": 1,
                  "translatedName": "seta para baixo"
                },
                {
                  "code": 2194,
                  "name": "left-right arrow",
                  "category": "symbols",
                  "keywords": "['arrow']",
                  "display": 1,
                  "translatedName": "Seta à esquerda"
                },
                {
                  "code": "21aa",
                  "name": "left arrow curving right",
                  "category": "symbols",
                  "keywords": "['arrow']",
                  "display": 1,
                  "translatedName": "seta esquerda curva direita"
                },
                {
                  "code": "21a9",
                  "name": "right arrow curving left",
                  "category": "symbols",
                  "keywords": "['arrow']",
                  "display": 1,
                  "translatedName": "arrow direita curva esquerda"
                },
                {
                  "code": 2934,
                  "name": "right arrow curving up",
                  "category": "symbols",
                  "keywords": "['arrow']",
                  "display": 1,
                  "translatedName": "arrow direita curvando-se"
                },
                {
                  "code": 2935,
                  "name": "right arrow curving down",
                  "category": "symbols",
                  "keywords": "['arrow', 'down']",
                  "display": 1,
                  "translatedName": "arrow direito curva-se"
                },
                {
                  "code": "1f500",
                  "name": "shuffle tracks button",
                  "category": "symbols",
                  "keywords": "['arrow', 'crossed']",
                  "display": 1,
                  "translatedName": "Botão Shuffle Tracks."
                },
                {
                  "code": "1f501",
                  "name": "repeat button",
                  "category": "symbols",
                  "keywords": "['arrow', 'clockwise', 'repeat']",
                  "display": 1,
                  "translatedName": "Repetir botão"
                },
                {
                  "code": "1f502",
                  "name": "repeat single button",
                  "category": "symbols",
                  "keywords": "['arrow', 'clockwise', 'once']",
                  "display": 1,
                  "translatedName": "Repita o botão único"
                },
                {
                  "code": "1f504",
                  "name": "anticlockwise arrows button",
                  "category": "symbols",
                  "keywords": "['anticlockwise', 'arrow', 'counterclockwise', 'withershins']",
                  "display": 1,
                  "translatedName": "Botão de setas anti-horário"
                },
                {
                  "code": "1f503",
                  "name": "clockwise vertical arrows",
                  "category": "symbols",
                  "keywords": "['arrow', 'clockwise', 'reload']",
                  "display": 1,
                  "translatedName": "setas verticais no sentido horário"
                },
                {
                  "code": "1f3b5",
                  "name": "musical note",
                  "category": "symbols",
                  "keywords": "['music', 'note']",
                  "display": 1,
                  "translatedName": "nota musical"
                },
                {
                  "code": "1f3b6",
                  "name": "musical notes",
                  "category": "symbols",
                  "keywords": "['music', 'note', 'notes']",
                  "display": 1,
                  "translatedName": "notas musicais"
                },
                {
                  "code": 2795,
                  "name": "heavy plus sign",
                  "category": "symbols",
                  "keywords": "['math', 'plus']",
                  "display": 1,
                  "translatedName": "sinal pesado mais"
                },
                {
                  "code": 2796,
                  "name": "heavy minus sign",
                  "category": "symbols",
                  "keywords": "['math', 'minus']",
                  "display": 1,
                  "translatedName": "sinal pesado de menos"
                },
                {
                  "code": 2797,
                  "name": "heavy division sign",
                  "category": "symbols",
                  "keywords": "['division', 'math']",
                  "display": 1,
                  "translatedName": "sinal de divisão pesada"
                },
                {
                  "code": 2716,
                  "name": "heavy multiplication x",
                  "category": "symbols",
                  "keywords": "['cancel', 'multiplication', 'multiply', 'x']",
                  "display": 1,
                  "translatedName": "Multiplicação pesada X."
                },
                {
                  "code": "1f4b2",
                  "name": "heavy dollar sign",
                  "category": "symbols",
                  "keywords": "['currency', 'dollar', 'money']",
                  "display": 1,
                  "translatedName": "Sinal de dólar pesado"
                },
                {
                  "code": "1f4b1",
                  "name": "currency exchange",
                  "category": "symbols",
                  "keywords": "['bank', 'currency', 'exchange', 'money']",
                  "display": 1,
                  "translatedName": "câmbio monetário"
                },
                {
                  "code": 2122,
                  "name": "trade mark",
                  "category": "symbols",
                  "keywords": "['mark', 'tm', 'trademark']",
                  "display": 1,
                  "translatedName": "marca comercial"
                },
                {
                  "code": "00a9",
                  "name": "copyright",
                  "category": "symbols",
                  "keywords": "['copyright']",
                  "display": 1,
                  "translatedName": "direito autoral"
                },
                {
                  "code": "00ae",
                  "name": "registered",
                  "category": "symbols",
                  "keywords": "['registered']",
                  "display": 1,
                  "translatedName": "registrado"
                },
                {
                  "code": 3030,
                  "name": "wavy dash",
                  "category": "symbols",
                  "keywords": "['dash', 'punctuation', 'wavy']",
                  "display": 1,
                  "translatedName": "traço ondulado"
                },
                {
                  "code": "27b0",
                  "name": "curly loop",
                  "category": "symbols",
                  "keywords": "['curl', 'loop']",
                  "display": 1,
                  "translatedName": "loop encaracolado"
                },
                {
                  "code": "27bf",
                  "name": "double curly loop",
                  "category": "symbols",
                  "keywords": "['curl', 'double', 'loop']",
                  "display": 1,
                  "translatedName": "loop duplo encaracolado"
                },
                {
                  "code": "1f51a",
                  "name": "END arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'end']",
                  "display": 1,
                  "translatedName": "Seta final"
                },
                {
                  "code": "1f519",
                  "name": "BACK arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'back']",
                  "display": 1,
                  "translatedName": "Back arrow."
                },
                {
                  "code": "1f51b",
                  "name": "ON! arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'mark', 'on']",
                  "display": 1,
                  "translatedName": "SOBRE! seta"
                },
                {
                  "code": "1f51d",
                  "name": "TOP arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'top', 'up']",
                  "display": 1,
                  "translatedName": "Seta superior"
                },
                {
                  "code": "1f51c",
                  "name": "SOON arrow",
                  "category": "symbols",
                  "keywords": "['arrow', 'soon']",
                  "display": 1,
                  "translatedName": "Logo arrow."
                },
                {
                  "code": 2714,
                  "name": "heavy check mark",
                  "category": "symbols",
                  "keywords": "['check', 'mark']",
                  "display": 1,
                  "translatedName": "Marca de verificação pesada"
                },
                {
                  "code": 2611,
                  "name": "ballot box with check",
                  "category": "symbols",
                  "keywords": "['ballot', 'box', 'check']",
                  "display": 1,
                  "translatedName": "cédula com cheque"
                },
                {
                  "code": "1f518",
                  "name": "radio button",
                  "category": "symbols",
                  "keywords": "['button', 'geometric', 'radio']",
                  "display": 1,
                  "translatedName": "botao de radio"
                },
                {
                  "code": "26aa",
                  "name": "white circle",
                  "category": "symbols",
                  "keywords": "['circle', 'geometric']",
                  "display": 1,
                  "translatedName": "Círculo branco"
                },
                {
                  "code": "26ab",
                  "name": "black circle",
                  "category": "symbols",
                  "keywords": "['circle', 'geometric']",
                  "display": 1,
                  "translatedName": "Círculo preto"
                },
                {
                  "code": "1f534",
                  "name": "red circle",
                  "category": "symbols",
                  "keywords": "['circle', 'geometric', 'red']",
                  "display": 1,
                  "translatedName": "círculo vermelho"
                },
                {
                  "code": "1f535",
                  "name": "blue circle",
                  "category": "symbols",
                  "keywords": "['blue', 'circle', 'geometric']",
                  "display": 1,
                  "translatedName": "Círculo azul"
                },
                {
                  "code": "1f53a",
                  "name": "red triangle pointed up",
                  "category": "symbols",
                  "keywords": "['geometric', 'red']",
                  "display": 1,
                  "translatedName": "Triângulo vermelho apontou para cima"
                },
                {
                  "code": "1f53b",
                  "name": "red triangle pointed down",
                  "category": "symbols",
                  "keywords": "['down', 'geometric', 'red']",
                  "display": 1,
                  "translatedName": "Triângulo vermelho apontou para baixo"
                },
                {
                  "code": "1f538",
                  "name": "small orange diamond",
                  "category": "symbols",
                  "keywords": "['diamond', 'geometric', 'orange']",
                  "display": 1,
                  "translatedName": "pequeno diamante laranja"
                },
                {
                  "code": "1f539",
                  "name": "small blue diamond",
                  "category": "symbols",
                  "keywords": "['blue', 'diamond', 'geometric']",
                  "display": 1,
                  "translatedName": "Diamante azul pequeno"
                },
                {
                  "code": "1f536",
                  "name": "large orange diamond",
                  "category": "symbols",
                  "keywords": "['diamond', 'geometric', 'orange']",
                  "display": 1,
                  "translatedName": "Grande laranja diamante"
                },
                {
                  "code": "1f537",
                  "name": "large blue diamond",
                  "category": "symbols",
                  "keywords": "['blue', 'diamond', 'geometric']",
                  "display": 1,
                  "translatedName": "Grande diamante azul"
                },
                {
                  "code": "1f533",
                  "name": "white square button",
                  "category": "symbols",
                  "keywords": "['button', 'geometric', 'outlined', 'square']",
                  "display": 1,
                  "translatedName": "Botão quadrado branco"
                },
                {
                  "code": "1f532",
                  "name": "black square button",
                  "category": "symbols",
                  "keywords": "['button', 'geometric', 'square']",
                  "display": 1,
                  "translatedName": "Botão quadrado preto"
                },
                {
                  "code": "25aa",
                  "name": "black small square",
                  "category": "symbols",
                  "keywords": "['geometric', 'square']",
                  "display": 1,
                  "translatedName": "Quadrado pequeno preto"
                },
                {
                  "code": "25ab",
                  "name": "white small square",
                  "category": "symbols",
                  "keywords": "['geometric', 'square']",
                  "display": 1,
                  "translatedName": "Quadrado pequeno branco"
                },
                {
                  "code": "25fe",
                  "name": "black medium-small square",
                  "category": "symbols",
                  "keywords": "['geometric', 'square']",
                  "display": 1,
                  "translatedName": "quadrado médio-pequeno preto"
                },
                {
                  "code": "25fd",
                  "name": "white medium-small square",
                  "category": "symbols",
                  "keywords": "['geometric', 'square']",
                  "display": 1,
                  "translatedName": "Quadrado médio-pequeno branco"
                },
                {
                  "code": "25fc",
                  "name": "black medium square",
                  "category": "symbols",
                  "keywords": "['geometric', 'square']",
                  "display": 1,
                  "translatedName": "quadrado médio preto"
                },
                {
                  "code": "25fb",
                  "name": "white medium square",
                  "category": "symbols",
                  "keywords": "['geometric', 'square']",
                  "display": 1,
                  "translatedName": "quadrado médio branco"
                },
                {
                  "code": "2b1b",
                  "name": "black large square",
                  "category": "symbols",
                  "keywords": "['geometric', 'square']",
                  "display": 1,
                  "translatedName": "grande quadrado preto"
                },
                {
                  "code": "2b1c",
                  "name": "white large square",
                  "category": "symbols",
                  "keywords": "['geometric', 'square']",
                  "display": 1,
                  "translatedName": "grande quadrado branco"
                },
                {
                  "code": "1f508",
                  "name": "speaker low volume",
                  "category": "symbols",
                  "keywords": "['soft']",
                  "display": 1,
                  "translatedName": "Alto-falante baixo volume."
                },
                {
                  "code": "1f507",
                  "name": "muted speaker",
                  "category": "symbols",
                  "keywords": "['mute', 'quiet', 'silent', 'speaker']",
                  "display": 1,
                  "translatedName": "Alto-falante silenciado."
                },
                {
                  "code": "1f509",
                  "name": "speaker medium volume",
                  "category": "symbols",
                  "keywords": "['medium']",
                  "display": 1,
                  "translatedName": "volume médio de alto-falante"
                },
                {
                  "code": "1f50a",
                  "name": "speaker high volume",
                  "category": "symbols",
                  "keywords": "['loud']",
                  "display": 1,
                  "translatedName": "Volume alto de alto-falante"
                },
                {
                  "code": "1f514",
                  "name": "bell",
                  "category": "symbols",
                  "keywords": "['bell']",
                  "display": 1,
                  "translatedName": "Sino"
                },
                {
                  "code": "1f515",
                  "name": "bell with slash",
                  "category": "symbols",
                  "keywords": "['bell', 'forbidden', 'mute', 'no', 'not', 'prohibited', 'quiet', 'silent']",
                  "display": 1,
                  "translatedName": "sino com barra"
                },
                {
                  "code": "1f4e3",
                  "name": "megaphone",
                  "category": "symbols",
                  "keywords": "['cheering']",
                  "display": 1,
                  "translatedName": "megafone"
                },
                {
                  "code": "1f4e2",
                  "name": "loudspeaker",
                  "category": "symbols",
                  "keywords": "['loud', 'public address']",
                  "display": 1,
                  "translatedName": "Alto-falante"
                },
                {
                  "code": "1f5e8",
                  "name": "left speech bubble",
                  "category": "symbols",
                  "keywords": "['dialog', 'speech']",
                  "display": 1,
                  "translatedName": "Bolha do discurso esquerdo"
                },
                {
                  "code": "1f441-1f5e8",
                  "name": "eye in speech bubble",
                  "category": "symbols",
                  "keywords": "['eye', 'speech bubble', 'witness']",
                  "display": 1,
                  "translatedName": "olho na bolha do discurso"
                },
                {
                  "code": "1f4ac",
                  "name": "speech balloon",
                  "category": "symbols",
                  "keywords": "['balloon', 'bubble', 'comic', 'dialog', 'speech']",
                  "display": 1,
                  "translatedName": "balão de fala"
                },
                {
                  "code": "1f4ad",
                  "name": "thought balloon",
                  "category": "symbols",
                  "keywords": "['balloon', 'bubble', 'comic', 'thought']",
                  "display": 1,
                  "translatedName": "balão de pensamento"
                },
                {
                  "code": "1f5ef",
                  "name": "right anger bubble",
                  "category": "symbols",
                  "keywords": "['angry', 'balloon', 'bubble', 'mad']",
                  "display": 1,
                  "translatedName": "Bolha de raiva direita"
                },
                {
                  "code": 2660,
                  "name": "spade suit",
                  "category": "symbols",
                  "keywords": "['card', 'game']",
                  "display": 1,
                  "translatedName": "terno de pá"
                },
                {
                  "code": 2663,
                  "name": "club suit",
                  "category": "symbols",
                  "keywords": "['card', 'game']",
                  "display": 1,
                  "translatedName": "terno do clube"
                },
                {
                  "code": 2665,
                  "name": "heart suit",
                  "category": "symbols",
                  "keywords": "['card', 'game']",
                  "display": 1,
                  "translatedName": "terno de coração"
                },
                {
                  "code": 2666,
                  "name": "diamond suit",
                  "category": "symbols",
                  "keywords": "['card', 'game']",
                  "display": 1,
                  "translatedName": "terno de diamante"
                },
                {
                  "code": "1f0cf",
                  "name": "joker",
                  "category": "symbols",
                  "keywords": "['card', 'game', 'wildcard']",
                  "display": 1,
                  "translatedName": "palhaço"
                },
                {
                  "code": "1f3b4",
                  "name": "flower playing cards",
                  "category": "symbols",
                  "keywords": "['Japanese', 'card', 'flower', 'game', 'playing']",
                  "display": 1,
                  "translatedName": "Cartas de jogar flor"
                },
                {
                  "code": "1f004",
                  "name": "mahjong red dragon",
                  "category": "symbols",
                  "keywords": "['game', 'mahjong', 'red']",
                  "display": 1,
                  "translatedName": "dragão vermelho de mahjong."
                },
                {
                  "code": "1f550",
                  "name": "one o’clock",
                  "category": "symbols",
                  "keywords": "['00', '1', '1:00', 'clock', 'one', 'o’clock']",
                  "display": 1,
                  "translatedName": "uma hora"
                },
                {
                  "code": "1f551",
                  "name": "two o’clock",
                  "category": "symbols",
                  "keywords": "['00', '2', '2:00', 'clock', 'o’clock', 'two']",
                  "display": 1,
                  "translatedName": "duas horas"
                },
                {
                  "code": "1f552",
                  "name": "three o’clock",
                  "category": "symbols",
                  "keywords": "['00', '3', '3:00', 'clock', 'o’clock', 'three']",
                  "display": 1,
                  "translatedName": "três horas"
                },
                {
                  "code": "1f553",
                  "name": "four o’clock",
                  "category": "symbols",
                  "keywords": "['00', '4', '4:00', 'clock', 'four', 'o’clock']",
                  "display": 1,
                  "translatedName": "quatro horas"
                },
                {
                  "code": "1f554",
                  "name": "five o’clock",
                  "category": "symbols",
                  "keywords": "['00', '5', '5:00', 'clock', 'five', 'o’clock']",
                  "display": 1,
                  "translatedName": "cinco horas"
                },
                {
                  "code": "1f555",
                  "name": "six o’clock",
                  "category": "symbols",
                  "keywords": "['00', '6', '6:00', 'clock', 'o’clock', 'six']",
                  "display": 1,
                  "translatedName": "seis horas"
                },
                {
                  "code": "1f556",
                  "name": "seven o’clock",
                  "category": "symbols",
                  "keywords": "['00', '7', '7:00', 'clock', 'o’clock', 'seven']",
                  "display": 1,
                  "translatedName": "sete horas"
                },
                {
                  "code": "1f557",
                  "name": "eight o’clock",
                  "category": "symbols",
                  "keywords": "['00', '8', '8:00', 'clock', 'eight', 'o’clock']",
                  "display": 1,
                  "translatedName": "oito horas"
                },
                {
                  "code": "1f558",
                  "name": "nine o’clock",
                  "category": "symbols",
                  "keywords": "['00', '9', '9:00', 'clock', 'nine', 'o’clock']",
                  "display": 1,
                  "translatedName": "nove horas"
                },
                {
                  "code": "1f559",
                  "name": "ten o’clock",
                  "category": "symbols",
                  "keywords": "['00', '10', '10:00', 'clock', 'o’clock', 'ten']",
                  "display": 1,
                  "translatedName": "dez horas"
                },
                {
                  "code": "1f55a",
                  "name": "eleven o’clock",
                  "category": "symbols",
                  "keywords": "['00', '11', '11:00', 'clock', 'eleven', 'o’clock']",
                  "display": 1,
                  "translatedName": "onze horas"
                },
                {
                  "code": "1f55b",
                  "name": "twelve o’clock",
                  "category": "symbols",
                  "keywords": "['00', '12', '12:00', 'clock', 'o’clock', 'twelve']",
                  "display": 1,
                  "translatedName": "doze horas"
                },
                {
                  "code": "1f55c",
                  "name": "one-thirty",
                  "category": "symbols",
                  "keywords": "['1', '1:30', '30', 'clock', 'one', 'thirty']",
                  "display": 1,
                  "translatedName": "uma e meia"
                },
                {
                  "code": "1f55d",
                  "name": "two-thirty",
                  "category": "symbols",
                  "keywords": "['2', '2:30', '30', 'clock', 'thirty', 'two']",
                  "display": 1,
                  "translatedName": "duas e meia"
                },
                {
                  "code": "1f55e",
                  "name": "three-thirty",
                  "category": "symbols",
                  "keywords": "['3', '30', '3:30', 'clock', 'thirty', 'three']",
                  "display": 1,
                  "translatedName": "três e meia"
                },
                {
                  "code": "1f55f",
                  "name": "four-thirty",
                  "category": "symbols",
                  "keywords": "['4', '30', '4:30', 'clock', 'four', 'thirty']",
                  "display": 1,
                  "translatedName": "quatro e meia"
                },
                {
                  "code": "1f560",
                  "name": "five-thirty",
                  "category": "symbols",
                  "keywords": "['5', '30', '5:30', 'clock', 'five', 'thirty']",
                  "display": 1,
                  "translatedName": "cinco e meia"
                },
                {
                  "code": "1f561",
                  "name": "six-thirty",
                  "category": "symbols",
                  "keywords": "['6', '30', '6:30', 'clock', 'six', 'thirty']",
                  "display": 1,
                  "translatedName": "seis e Meia"
                },
                {
                  "code": "1f562",
                  "name": "seven-thirty",
                  "category": "symbols",
                  "keywords": "['7', '30', '7:30', 'clock', 'seven', 'thirty']",
                  "display": 1,
                  "translatedName": "sete e meia"
                },
                {
                  "code": "1f563",
                  "name": "eight-thirty",
                  "category": "symbols",
                  "keywords": "['8', '30', '8:30', 'clock', 'eight', 'thirty']",
                  "display": 1,
                  "translatedName": "oito e meia"
                },
                {
                  "code": "1f564",
                  "name": "nine-thirty",
                  "category": "symbols",
                  "keywords": "['9', '30', '9:30', 'clock', 'nine', 'thirty']",
                  "display": 1,
                  "translatedName": "nove e meia"
                },
                {
                  "code": "1f565",
                  "name": "ten-thirty",
                  "category": "symbols",
                  "keywords": "['10', '10:30', '30', 'clock', 'ten', 'thirty']",
                  "display": 1,
                  "translatedName": "10:30"
                },
                {
                  "code": "1f566",
                  "name": "eleven-thirty",
                  "category": "symbols",
                  "keywords": "['11', '11:30', '30', 'clock', 'eleven', 'thirty']",
                  "display": 1,
                  "translatedName": "onze e meia"
                },
                {
                  "code": "1f567",
                  "name": "twelve-thirty",
                  "category": "symbols",
                  "keywords": "['12', '12:30', '30', 'clock', 'thirty', 'twelve']",
                  "display": 1,
                  "translatedName": "doze trinta"
                },
                {
                  "code": "1f3f3",
                  "name": "white flag",
                  "category": "flags",
                  "keywords": "['waving']",
                  "display": 1,
                  "translatedName": "bandeira branca"
                },
                {
                  "code": "1f3f4",
                  "name": "black flag",
                  "category": "flags",
                  "keywords": "['waving']",
                  "display": 1,
                  "translatedName": "Bandeira preta"
                },
                {
                  "code": "1f3c1",
                  "name": "chequered flag",
                  "category": "flags",
                  "keywords": "['checkered', 'chequered', 'racing']",
                  "display": 1,
                  "translatedName": "bandeira quadriculada"
                },
                {
                  "code": "1f6a9",
                  "name": "triangular flag",
                  "category": "flags",
                  "keywords": "['post']",
                  "display": 1,
                  "translatedName": "Bandeira triangular"
                },
                {
                  "code": "1f3f3-1f308",
                  "name": "rainbow flag",
                  "category": "flags",
                  "keywords": "['rainbow']",
                  "display": 1,
                  "translatedName": "Bandeira do arco-íris"
                },
                {
                  "code": "1f1e6-1f1eb",
                  "name": "Afghanistan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Afeganistão"
                },
                {
                  "code": "1f1e6-1f1fd",
                  "name": "Åland Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas Aland"
                },
                {
                  "code": "1f1e6-1f1f1",
                  "name": "Albania",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Albânia"
                },
                {
                  "code": "1f1e9-1f1ff",
                  "name": "Algeria",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Argélia"
                },
                {
                  "code": "1f1e6-1f1f8",
                  "name": "American Samoa",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Samoa Americana"
                },
                {
                  "code": "1f1e6-1f1e9",
                  "name": "Andorra",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Andorra."
                },
                {
                  "code": "1f1e6-1f1f4",
                  "name": "Angola",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Angola"
                },
                {
                  "code": "1f1e6-1f1ee",
                  "name": "Anguilla",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Anguilla."
                },
                {
                  "code": "1f1e6-1f1f6",
                  "name": "Antarctica",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Antártica"
                },
                {
                  "code": "1f1e6-1f1ec",
                  "name": "Antigua & Barbuda",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Antígua e Barbuda."
                },
                {
                  "code": "1f1e6-1f1f7",
                  "name": "Argentina",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Argentina"
                },
                {
                  "code": "1f1e6-1f1f2",
                  "name": "Armenia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Armênia"
                },
                {
                  "code": "1f1e6-1f1fc",
                  "name": "Aruba",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Aruba."
                },
                {
                  "code": "1f1e6-1f1fa",
                  "name": "Australia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Austrália"
                },
                {
                  "code": "1f1e6-1f1f9",
                  "name": "Austria",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Áustria"
                },
                {
                  "code": "1f1e6-1f1ff",
                  "name": "Azerbaijan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Azerbaijão"
                },
                {
                  "code": "1f1e7-1f1f8",
                  "name": "Bahamas",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Bahamas."
                },
                {
                  "code": "1f1e7-1f1ed",
                  "name": "Bahrain",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Bahrein"
                },
                {
                  "code": "1f1e7-1f1e9",
                  "name": "Bangladesh",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Bangladesh"
                },
                {
                  "code": "1f1e7-1f1e7",
                  "name": "Barbados",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Barbados."
                },
                {
                  "code": "1f1e7-1f1fe",
                  "name": "Belarus",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Bielorrússia"
                },
                {
                  "code": "1f1e7-1f1ea",
                  "name": "Belgium",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Bélgica"
                },
                {
                  "code": "1f1e7-1f1ff",
                  "name": "Belize",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Belize"
                },
                {
                  "code": "1f1e7-1f1ef",
                  "name": "Benin",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Benin"
                },
                {
                  "code": "1f1e7-1f1f2",
                  "name": "Bermuda",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Bermudas"
                },
                {
                  "code": "1f1e7-1f1f9",
                  "name": "Bhutan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Butão"
                },
                {
                  "code": "1f1e7-1f1f4",
                  "name": "Bolivia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Bolívia"
                },
                {
                  "code": "1f1e7-1f1e6",
                  "name": "Bosnia & Herzegovina",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Bósnia e Herzegovina"
                },
                {
                  "code": "1f1e7-1f1fc",
                  "name": "Botswana",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Botsuana."
                },
                {
                  "code": "1f1e7-1f1f7",
                  "name": "Brazil",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Brasil"
                },
                {
                  "code": "1f1ee-1f1f4",
                  "name": "British Indian Ocean Territory",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Território do Oceano Índico Britânico"
                },
                {
                  "code": "1f1fb-1f1ec",
                  "name": "British Virgin Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas Virgens Britânicas"
                },
                {
                  "code": "1f1e7-1f1f3",
                  "name": "Brunei",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Brunei"
                },
                {
                  "code": "1f1e7-1f1ec",
                  "name": "Bulgaria",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Bulgária"
                },
                {
                  "code": "1f1e7-1f1eb",
                  "name": "Burkina Faso",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Burkina Faso"
                },
                {
                  "code": "1f1e7-1f1ee",
                  "name": "Burundi",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Burundi"
                },
                {
                  "code": "1f1f0-1f1ed",
                  "name": "Cambodia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Camboja"
                },
                {
                  "code": "1f1e8-1f1f2",
                  "name": "Cameroon",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Camarões"
                },
                {
                  "code": "1f1e8-1f1e6",
                  "name": "Canada",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Canadá"
                },
                {
                  "code": "1f1ee-1f1e8",
                  "name": "Canary Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas Canárias"
                },
                {
                  "code": "1f1e8-1f1fb",
                  "name": "Cape Verde",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "cabo Verde"
                },
                {
                  "code": "1f1e7-1f1f6",
                  "name": "Caribbean Netherlands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Caribe Holanda"
                },
                {
                  "code": "1f1f0-1f1fe",
                  "name": "Cayman Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas Cayman"
                },
                {
                  "code": "1f1e8-1f1eb",
                  "name": "Central African Republic",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "República Centro-Africana"
                },
                {
                  "code": "1f1f9-1f1e9",
                  "name": "Chad",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Chade"
                },
                {
                  "code": "1f1e8-1f1f1",
                  "name": "Chile",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Chile"
                },
                {
                  "code": "1f1e8-1f1f3",
                  "name": "China",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "China"
                },
                {
                  "code": "1f1e8-1f1fd",
                  "name": "Christmas Island",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilha do Natal"
                },
                {
                  "code": "1f1e8-1f1e8",
                  "name": "Cocos (Keeling) Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas Cocos (Keeling)"
                },
                {
                  "code": "1f1e8-1f1f4",
                  "name": "Colombia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Colômbia"
                },
                {
                  "code": "1f1f0-1f1f2",
                  "name": "Comoros",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Comores."
                },
                {
                  "code": "1f1e8-1f1ec",
                  "name": "Congo - Brazzaville",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Congo - Brazzaville"
                },
                {
                  "code": "1f1e8-1f1e9",
                  "name": "Congo - Kinshasa",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Congo - Kinshasa."
                },
                {
                  "code": "1f1e8-1f1f0",
                  "name": "Cook Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas Cook"
                },
                {
                  "code": "1f1e8-1f1f7",
                  "name": "Costa Rica",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Costa Rica"
                },
                {
                  "code": "1f1e8-1f1ee",
                  "name": "Côte d’Ivoire",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Costa do Marfim"
                },
                {
                  "code": "1f1ed-1f1f7",
                  "name": "Croatia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Croácia"
                },
                {
                  "code": "1f1e8-1f1fa",
                  "name": "Cuba",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Cuba"
                },
                {
                  "code": "1f1e8-1f1fc",
                  "name": "Curaçao",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Curaçao."
                },
                {
                  "code": "1f1e8-1f1fe",
                  "name": "Cyprus",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Chipre"
                },
                {
                  "code": "1f1e8-1f1ff",
                  "name": "Czechia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Czechia."
                },
                {
                  "code": "1f1e9-1f1f0",
                  "name": "Denmark",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Dinamarca"
                },
                {
                  "code": "1f1e9-1f1ef",
                  "name": "Djibouti",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Djibuti."
                },
                {
                  "code": "1f1e9-1f1f2",
                  "name": "Dominica",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Dominica."
                },
                {
                  "code": "1f1e9-1f1f4",
                  "name": "Dominican Republic",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "República Dominicana"
                },
                {
                  "code": "1f1ea-1f1e8",
                  "name": "Ecuador",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Equador"
                },
                {
                  "code": "1f1ea-1f1ec",
                  "name": "Egypt",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Egito"
                },
                {
                  "code": "1f1f8-1f1fb",
                  "name": "El Salvador",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "El Salvador"
                },
                {
                  "code": "1f1ec-1f1f6",
                  "name": "Equatorial Guinea",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Guiné Equatorial"
                },
                {
                  "code": "1f1ea-1f1f7",
                  "name": "Eritrea",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Eritreia."
                },
                {
                  "code": "1f1ea-1f1ea",
                  "name": "Estonia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Estônia"
                },
                {
                  "code": "1f1ea-1f1f9",
                  "name": "Ethiopia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Etiópia"
                },
                {
                  "code": "1f1ea-1f1fa",
                  "name": "European Union",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "União Européia"
                },
                {
                  "code": "1f1eb-1f1f0",
                  "name": "Falkland Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas Falkland"
                },
                {
                  "code": "1f1eb-1f1f4",
                  "name": "Faroe Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "ilhas Faroe"
                },
                {
                  "code": "1f1eb-1f1ef",
                  "name": "Fiji",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Fiji."
                },
                {
                  "code": "1f1eb-1f1ee",
                  "name": "Finland",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Finlândia"
                },
                {
                  "code": "1f1eb-1f1f7",
                  "name": "France",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "França"
                },
                {
                  "code": "1f1ec-1f1eb",
                  "name": "French Guiana",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Guiana Francesa"
                },
                {
                  "code": "1f1f5-1f1eb",
                  "name": "French Polynesia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Polinésia Francesa"
                },
                {
                  "code": "1f1f9-1f1eb",
                  "name": "French Southern Territories",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Territórios do Sul franceses"
                },
                {
                  "code": "1f1ec-1f1e6",
                  "name": "Gabon",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Gabão"
                },
                {
                  "code": "1f1ec-1f1f2",
                  "name": "Gambia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Gâmbia"
                },
                {
                  "code": "1f1ec-1f1ea",
                  "name": "Georgia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Geórgia"
                },
                {
                  "code": "1f1e9-1f1ea",
                  "name": "Germany",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Alemanha"
                },
                {
                  "code": "1f1ec-1f1ed",
                  "name": "Ghana",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Gana"
                },
                {
                  "code": "1f1ec-1f1ee",
                  "name": "Gibraltar",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Gibraltar"
                },
                {
                  "code": "1f1ec-1f1f7",
                  "name": "Greece",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Grécia"
                },
                {
                  "code": "1f1ec-1f1f1",
                  "name": "Greenland",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Groenlândia"
                },
                {
                  "code": "1f1ec-1f1e9",
                  "name": "Grenada",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Granada"
                },
                {
                  "code": "1f1ec-1f1f5",
                  "name": "Guadeloupe",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Guadalupe."
                },
                {
                  "code": "1f1ec-1f1fa",
                  "name": "Guam",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Guam"
                },
                {
                  "code": "1f1ec-1f1f9",
                  "name": "Guatemala",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Guatemala"
                },
                {
                  "code": "1f1ec-1f1ec",
                  "name": "Guernsey",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Guernsey."
                },
                {
                  "code": "1f1ec-1f1f3",
                  "name": "Guinea",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Guiné"
                },
                {
                  "code": "1f1ec-1f1fc",
                  "name": "Guinea-Bissau",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Guiné-Bissau."
                },
                {
                  "code": "1f1ec-1f1fe",
                  "name": "Guyana",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Guiana"
                },
                {
                  "code": "1f1ed-1f1f9",
                  "name": "Haiti",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Haiti"
                },
                {
                  "code": "1f1ed-1f1f3",
                  "name": "Honduras",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Honduras"
                },
                {
                  "code": "1f1ed-1f1f0",
                  "name": "Hong Kong SAR China",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Hong Kong SAR China"
                },
                {
                  "code": "1f1ed-1f1fa",
                  "name": "Hungary",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Hungria"
                },
                {
                  "code": "1f1ee-1f1f8",
                  "name": "Iceland",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Islândia"
                },
                {
                  "code": "1f1ee-1f1f3",
                  "name": "India",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Índia"
                },
                {
                  "code": "1f1ee-1f1e9",
                  "name": "Indonesia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Indonésia"
                },
                {
                  "code": "1f1ee-1f1f7",
                  "name": "Iran",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Irã"
                },
                {
                  "code": "1f1ee-1f1f6",
                  "name": "Iraq",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Iraque"
                },
                {
                  "code": "1f1ee-1f1ea",
                  "name": "Ireland",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Irlanda"
                },
                {
                  "code": "1f1ee-1f1f2",
                  "name": "Isle of Man",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilha do homem"
                },
                {
                  "code": "1f1ee-1f1f1",
                  "name": "Israel",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Israel"
                },
                {
                  "code": "1f1ee-1f1f9",
                  "name": "Italy",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Itália"
                },
                {
                  "code": "1f1ef-1f1f2",
                  "name": "Jamaica",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Jamaica"
                },
                {
                  "code": "1f1ef-1f1f5",
                  "name": "Japan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Japão"
                },
                {
                  "code": "1f38c",
                  "name": "crossed flags",
                  "category": "flags",
                  "keywords": "['Japanese', 'celebration', 'cross', 'crossed']",
                  "display": 1,
                  "translatedName": "bandeiras cruzadas"
                },
                {
                  "code": "1f1ef-1f1ea",
                  "name": "Jersey",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Jersey."
                },
                {
                  "code": "1f1ef-1f1f4",
                  "name": "Jordan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Jordânia"
                },
                {
                  "code": "1f1f0-1f1ff",
                  "name": "Kazakhstan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Cazaquistão"
                },
                {
                  "code": "1f1f0-1f1ea",
                  "name": "Kenya",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Quênia"
                },
                {
                  "code": "1f1f0-1f1ee",
                  "name": "Kiribati",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Kiribati."
                },
                {
                  "code": "1f1fd-1f1f0",
                  "name": "Kosovo",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Kosovo"
                },
                {
                  "code": "1f1f0-1f1fc",
                  "name": "Kuwait",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Kuwait"
                },
                {
                  "code": "1f1f0-1f1ec",
                  "name": "Kyrgyzstan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Quirguistão."
                },
                {
                  "code": "1f1f1-1f1e6",
                  "name": "Laos",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Laos"
                },
                {
                  "code": "1f1f1-1f1fb",
                  "name": "Latvia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Letônia"
                },
                {
                  "code": "1f1f1-1f1e7",
                  "name": "Lebanon",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Líbano"
                },
                {
                  "code": "1f1f1-1f1f8",
                  "name": "Lesotho",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Lesoto"
                },
                {
                  "code": "1f1f1-1f1f7",
                  "name": "Liberia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Libéria"
                },
                {
                  "code": "1f1f1-1f1fe",
                  "name": "Libya",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Líbia"
                },
                {
                  "code": "1f1f1-1f1ee",
                  "name": "Liechtenstein",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Liechtenstein."
                },
                {
                  "code": "1f1f1-1f1f9",
                  "name": "Lithuania",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Lituânia"
                },
                {
                  "code": "1f1f1-1f1fa",
                  "name": "Luxembourg",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Luxemburgo"
                },
                {
                  "code": "1f1f2-1f1f4",
                  "name": "Macau SAR China",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Macau SAR China."
                },
                {
                  "code": "1f1f2-1f1f0",
                  "name": "Macedonia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Macedônia."
                },
                {
                  "code": "1f1f2-1f1ec",
                  "name": "Madagascar",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Madagáscar"
                },
                {
                  "code": "1f1f2-1f1fc",
                  "name": "Malawi",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Malawi."
                },
                {
                  "code": "1f1f2-1f1fe",
                  "name": "Malaysia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Malásia"
                },
                {
                  "code": "1f1f2-1f1fb",
                  "name": "Maldives",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Maldivas"
                },
                {
                  "code": "1f1f2-1f1f1",
                  "name": "Mali",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Mali."
                },
                {
                  "code": "1f1f2-1f1f9",
                  "name": "Malta",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Malta"
                },
                {
                  "code": "1f1f2-1f1ed",
                  "name": "Marshall Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas Marshall"
                },
                {
                  "code": "1f1f2-1f1f6",
                  "name": "Martinique",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Martinica."
                },
                {
                  "code": "1f1f2-1f1f7",
                  "name": "Mauritania",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Mauritânia"
                },
                {
                  "code": "1f1f2-1f1fa",
                  "name": "Mauritius",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Maurício"
                },
                {
                  "code": "1f1fe-1f1f9",
                  "name": "Mayotte",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Mayotte."
                },
                {
                  "code": "1f1f2-1f1fd",
                  "name": "Mexico",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "México"
                },
                {
                  "code": "1f1eb-1f1f2",
                  "name": "Micronesia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Micronésia."
                },
                {
                  "code": "1f1f2-1f1e9",
                  "name": "Moldova",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Moldávia"
                },
                {
                  "code": "1f1f2-1f1e8",
                  "name": "Monaco",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Mônaco"
                },
                {
                  "code": "1f1f2-1f1f3",
                  "name": "Mongolia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Mongólia"
                },
                {
                  "code": "1f1f2-1f1ea",
                  "name": "Montenegro",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Montenegro"
                },
                {
                  "code": "1f1f2-1f1f8",
                  "name": "Montserrat",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Montserrat."
                },
                {
                  "code": "1f1f2-1f1e6",
                  "name": "Morocco",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Marrocos"
                },
                {
                  "code": "1f1f2-1f1ff",
                  "name": "Mozambique",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Moçambique"
                },
                {
                  "code": "1f1f2-1f1f2",
                  "name": "Myanmar (Burma)",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Myanmar (Birmânia)"
                },
                {
                  "code": "1f1f3-1f1e6",
                  "name": "Namibia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Namíbia."
                },
                {
                  "code": "1f1f3-1f1f7",
                  "name": "Nauru",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Nauru."
                },
                {
                  "code": "1f1f3-1f1f5",
                  "name": "Nepal",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Nepal"
                },
                {
                  "code": "1f1f3-1f1f1",
                  "name": "Netherlands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Holanda"
                },
                {
                  "code": "1f1f3-1f1e8",
                  "name": "New Caledonia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Nova Caledônia"
                },
                {
                  "code": "1f1f3-1f1ff",
                  "name": "New Zealand",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Nova Zelândia"
                },
                {
                  "code": "1f1f3-1f1ee",
                  "name": "Nicaragua",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Nicarágua"
                },
                {
                  "code": "1f1f3-1f1ea",
                  "name": "Niger",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Níger"
                },
                {
                  "code": "1f1f3-1f1ec",
                  "name": "Nigeria",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Nigéria"
                },
                {
                  "code": "1f1f3-1f1fa",
                  "name": "Niue",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Niue."
                },
                {
                  "code": "1f1f3-1f1eb",
                  "name": "Norfolk Island",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilha de Norfolk."
                },
                {
                  "code": "1f1f0-1f1f5",
                  "name": "North Korea",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Coréia do Norte"
                },
                {
                  "code": "1f1f2-1f1f5",
                  "name": "Northern Mariana Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas Marianas do Norte"
                },
                {
                  "code": "1f1f3-1f1f4",
                  "name": "Norway",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Noruega"
                },
                {
                  "code": "1f1f4-1f1f2",
                  "name": "Oman",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Omã"
                },
                {
                  "code": "1f1f5-1f1f0",
                  "name": "Pakistan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Paquistão"
                },
                {
                  "code": "1f1f5-1f1fc",
                  "name": "Palau",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Palau."
                },
                {
                  "code": "1f1f5-1f1f8",
                  "name": "Palestinian Territories",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Territórios Palestinos"
                },
                {
                  "code": "1f1f5-1f1e6",
                  "name": "Panama",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Panamá"
                },
                {
                  "code": "1f1f5-1f1ec",
                  "name": "Papua New Guinea",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Papua Nova Guiné"
                },
                {
                  "code": "1f1f5-1f1fe",
                  "name": "Paraguay",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Paraguai"
                },
                {
                  "code": "1f1f5-1f1ea",
                  "name": "Peru",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Peru"
                },
                {
                  "code": "1f1f5-1f1ed",
                  "name": "Philippines",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Filipinas"
                },
                {
                  "code": "1f1f5-1f1f3",
                  "name": "Pitcairn Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas de Pitcairn."
                },
                {
                  "code": "1f1f5-1f1f1",
                  "name": "Poland",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Polônia"
                },
                {
                  "code": "1f1f5-1f1f9",
                  "name": "Portugal",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Portugal"
                },
                {
                  "code": "1f1f5-1f1f7",
                  "name": "Puerto Rico",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Porto Rico"
                },
                {
                  "code": "1f1f6-1f1e6",
                  "name": "Qatar",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Catar"
                },
                {
                  "code": "1f1f7-1f1ea",
                  "name": "Réunion",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Reunião"
                },
                {
                  "code": "1f1f7-1f1f4",
                  "name": "Romania",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Romênia"
                },
                {
                  "code": "1f1f7-1f1fa",
                  "name": "Russia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Rússia"
                },
                {
                  "code": "1f1f7-1f1fc",
                  "name": "Rwanda",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ruanda"
                },
                {
                  "code": "1f1fc-1f1f8",
                  "name": "Samoa",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Samoa."
                },
                {
                  "code": "1f1f8-1f1f2",
                  "name": "San Marino",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "San Marino."
                },
                {
                  "code": "1f1f8-1f1f9",
                  "name": "São Tomé & Príncipe",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "São Tomé e Príncipe"
                },
                {
                  "code": "1f1f8-1f1e6",
                  "name": "Saudi Arabia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Arábia Saudita"
                },
                {
                  "code": "1f1f8-1f1f3",
                  "name": "Senegal",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Senegal"
                },
                {
                  "code": "1f1f7-1f1f8",
                  "name": "Serbia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Sérvia"
                },
                {
                  "code": "1f1f8-1f1e8",
                  "name": "Seychelles",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Seychelles."
                },
                {
                  "code": "1f1f8-1f1f1",
                  "name": "Sierra Leone",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Serra Leoa"
                },
                {
                  "code": "1f1f8-1f1ec",
                  "name": "Singapore",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Cingapura"
                },
                {
                  "code": "1f1f8-1f1fd",
                  "name": "Sint Maarten",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Sint Maarten."
                },
                {
                  "code": "1f1f8-1f1f0",
                  "name": "Slovakia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Eslováquia"
                },
                {
                  "code": "1f1f8-1f1ee",
                  "name": "Slovenia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Eslovênia"
                },
                {
                  "code": "1f1ec-1f1f8",
                  "name": "South Georgia & South Sandwich Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "South Georgia & South Sandwich Islands"
                },
                {
                  "code": "1f1f8-1f1e7",
                  "name": "Solomon Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas Salomão"
                },
                {
                  "code": "1f1f8-1f1f4",
                  "name": "Somalia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Somália"
                },
                {
                  "code": "1f1ff-1f1e6",
                  "name": "South Africa",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "África do Sul"
                },
                {
                  "code": "1f1f0-1f1f7",
                  "name": "South Korea",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Coreia do Sul"
                },
                {
                  "code": "1f1f8-1f1f8",
                  "name": "South Sudan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Sudão do Sul"
                },
                {
                  "code": "1f1ea-1f1f8",
                  "name": "Spain",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Espanha"
                },
                {
                  "code": "1f1f1-1f1f0",
                  "name": "Sri Lanka",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Sri Lanka"
                },
                {
                  "code": "1f1e7-1f1f1",
                  "name": "St. Barthélemy",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "St. BarthÉlemy."
                },
                {
                  "code": "1f1f8-1f1ed",
                  "name": "St. Helena",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "St. Helena"
                },
                {
                  "code": "1f1f0-1f1f3",
                  "name": "St. Kitts & Nevis",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "St. Kitts & Nevis"
                },
                {
                  "code": "1f1f1-1f1e8",
                  "name": "St. Lucia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Santa Lúcia"
                },
                {
                  "code": "1f1f5-1f1f2",
                  "name": "St. Pierre & Miquelon",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "St. Pierre & Miquelon"
                },
                {
                  "code": "1f1fb-1f1e8",
                  "name": "St. Vincent & Grenadines",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "São Vicente e Granadinas"
                },
                {
                  "code": "1f1f8-1f1e9",
                  "name": "Sudan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Sudão"
                },
                {
                  "code": "1f1f8-1f1f7",
                  "name": "Suriname",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Suriname"
                },
                {
                  "code": "1f1f8-1f1ff",
                  "name": "Swaziland",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Suazilândia."
                },
                {
                  "code": "1f1f8-1f1ea",
                  "name": "Sweden",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Suécia"
                },
                {
                  "code": "1f1e8-1f1ed",
                  "name": "Switzerland",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Suíça"
                },
                {
                  "code": "1f1f8-1f1fe",
                  "name": "Syria",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Síria"
                },
                {
                  "code": "1f1f9-1f1fc",
                  "name": "Taiwan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Taiwan"
                },
                {
                  "code": "1f1f9-1f1ef",
                  "name": "Tajikistan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Tajiquistão."
                },
                {
                  "code": "1f1f9-1f1ff",
                  "name": "Tanzania",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Tanzânia"
                },
                {
                  "code": "1f1f9-1f1ed",
                  "name": "Thailand",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Tailândia"
                },
                {
                  "code": "1f1f9-1f1f1",
                  "name": "Timor-Leste",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Timor-Leste."
                },
                {
                  "code": "1f1f9-1f1ec",
                  "name": "Togo",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ir"
                },
                {
                  "code": "1f1f9-1f1f0",
                  "name": "Tokelau",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Tokelau."
                },
                {
                  "code": "1f1f9-1f1f4",
                  "name": "Tonga",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Tonga"
                },
                {
                  "code": "1f1f9-1f1f9",
                  "name": "Trinidad & Tobago",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Trinidad & Tobago."
                },
                {
                  "code": "1f1f9-1f1f3",
                  "name": "Tunisia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Tunísia"
                },
                {
                  "code": "1f1f9-1f1f7",
                  "name": "Turkey",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Turquia"
                },
                {
                  "code": "1f1f9-1f1f2",
                  "name": "Turkmenistan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Turquemenistão."
                },
                {
                  "code": "1f1f9-1f1e8",
                  "name": "Turks & Caicos Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas Turks & Caicos"
                },
                {
                  "code": "1f1f9-1f1fb",
                  "name": "Tuvalu",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Tuvalu."
                },
                {
                  "code": "1f1fb-1f1ee",
                  "name": "U.S. Virgin Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas Virgens U.S."
                },
                {
                  "code": "1f1fa-1f1ec",
                  "name": "Uganda",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Uganda"
                },
                {
                  "code": "1f1fa-1f1e6",
                  "name": "Ukraine",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ucrânia"
                },
                {
                  "code": "1f1e6-1f1ea",
                  "name": "United Arab Emirates",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Emirados Árabes Unidos"
                },
                {
                  "code": "1f1ec-1f1e7",
                  "name": "United Kingdom",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Reino Unido"
                },
                {
                  "code": "1f1fa-1f1f8",
                  "name": "United States",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Estados Unidos"
                },
                {
                  "code": "1f1fa-1f1fe",
                  "name": "Uruguay",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Uruguai"
                },
                {
                  "code": "1f1fa-1f1ff",
                  "name": "Uzbekistan",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Uzbequistão"
                },
                {
                  "code": "1f1fb-1f1fa",
                  "name": "Vanuatu",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Vanuatu"
                },
                {
                  "code": "1f1fb-1f1e6",
                  "name": "Vatican City",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Cidade do Vaticano"
                },
                {
                  "code": "1f1fb-1f1ea",
                  "name": "Venezuela",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Venezuela"
                },
                {
                  "code": "1f1fb-1f1f3",
                  "name": "Vietnam",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Vietnã"
                },
                {
                  "code": "1f1fc-1f1eb",
                  "name": "Wallis & Futuna",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Wallis & Futuna."
                },
                {
                  "code": "1f1ea-1f1ed",
                  "name": "Western Sahara",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Saara Ocidental"
                },
                {
                  "code": "1f1fe-1f1ea",
                  "name": "Yemen",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Iémen"
                },
                {
                  "code": "1f1ff-1f1f2",
                  "name": "Zambia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Zâmbia"
                },
                {
                  "code": "1f1ff-1f1fc",
                  "name": "Zimbabwe",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Zimbábue"
                },
                {
                  "code": "1f1e6-1f1e8",
                  "name": "Ascension Island",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilha de ascensão"
                },
                {
                  "code": "1f1f9-1f1e6",
                  "name": "Tristan da Cunha",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Tristan da cunha."
                },
                {
                  "code": "1f1e7-1f1fb",
                  "name": "Bouvet Island",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilha Bouvet."
                },
                {
                  "code": "1f1ed-1f1f2",
                  "name": "Heard & McDonald Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Heard & McDonald Islands"
                },
                {
                  "code": "1f1f8-1f1ef",
                  "name": "Svalbard & Jan Mayen",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Svalbard & Jan Mayen"
                },
                {
                  "code": "1f1fa-1f1f2",
                  "name": "U.S. Outlying Islands",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilhas U.S. Distantes"
                },
                {
                  "code": "1f1ea-1f1e6",
                  "name": "Ceuta & Melilla",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ceuta e Melila"
                },
                {
                  "code": "1f1e8-1f1f5",
                  "name": "Clipperton Island",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Ilha de Clipperton."
                },
                {
                  "code": "1f1e9-1f1ec",
                  "name": "Diego Garcia",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Diego Garcia."
                },
                {
                  "code": "1f1f2-1f1eb",
                  "name": "St. Martin",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "St. Martin."
                },
                {
                  "code": "1f1fa-1f1f3",
                  "name": "United Nations",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Nações Unidas"
                },
                {
                  "code": "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
                  "name": "England",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Inglaterra"
                },
                {
                  "code": "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
                  "name": "Scotland",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "Escócia"
                },
                {
                  "code": "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
                  "name": "Wales",
                  "category": "flags",
                  "keywords": "['flag']",
                  "display": 1,
                  "translatedName": "País de Gales."
                },
                {
                  "code": "002a",
                  "name": "asterisk",
                  "category": "symbols",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "asterisco"
                },
                {
                  "code": "1f1ff",
                  "name": "regional indicator symbol letter z",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "Indicador Regional Symbol Letter Z"
                },
                {
                  "code": "1f1fe",
                  "name": "regional indicator symbol letter y",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional y"
                },
                {
                  "code": "1f1fd",
                  "name": "regional indicator symbol letter x",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional x"
                },
                {
                  "code": 23,
                  "name": "pound symbol",
                  "category": "symbols",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "símbolo de libra"
                },
                {
                  "code": "1f1fc",
                  "name": "regional indicator symbol letter w",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional w"
                },
                {
                  "code": "1f1fb",
                  "name": "regional indicator symbol letter v",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "Indicador Regional Symbol Letter V"
                },
                {
                  "code": "1f1fa",
                  "name": "regional indicator symbol letter u",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional u"
                },
                {
                  "code": "1f1f9",
                  "name": "regional indicator symbol letter t",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional t"
                },
                {
                  "code": "1f1f8",
                  "name": "regional indicator symbol letter s",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional s"
                },
                {
                  "code": "1f1f7",
                  "name": "regional indicator symbol letter r",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional r"
                },
                {
                  "code": "1f1f6",
                  "name": "regional indicator symbol letter q",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional Q"
                },
                {
                  "code": "1f1f5",
                  "name": "regional indicator symbol letter p",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional p"
                },
                {
                  "code": "1f1f4",
                  "name": "regional indicator symbol letter o",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra do símbolo indicador regional"
                },
                {
                  "code": "1f1f3",
                  "name": "regional indicator symbol letter n",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional n"
                },
                {
                  "code": "1f1f2",
                  "name": "regional indicator symbol letter m",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional m"
                },
                {
                  "code": "1f1f1",
                  "name": "regional indicator symbol letter l",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional l"
                },
                {
                  "code": "1f1f0",
                  "name": "regional indicator symbol letter k",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional k"
                },
                {
                  "code": "1f1ef",
                  "name": "regional indicator symbol letter j",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "Símbolo de indicador regional letra j"
                },
                {
                  "code": "1f1ee",
                  "name": "regional indicator symbol letter i",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra do símbolo indicador regional i"
                },
                {
                  "code": "1f1ed",
                  "name": "regional indicator symbol letter h",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional h"
                },
                {
                  "code": "1f1ec",
                  "name": "regional indicator symbol letter g",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional g"
                },
                {
                  "code": "1f1eb",
                  "name": "regional indicator symbol letter f",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional f"
                },
                {
                  "code": "1f1ea",
                  "name": "regional indicator symbol letter e",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra do símbolo indicador regional e"
                },
                {
                  "code": "1f1e9",
                  "name": "regional indicator symbol letter d",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional d"
                },
                {
                  "code": "1f1e8",
                  "name": "regional indicator symbol letter c",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo de indicador regional c"
                },
                {
                  "code": "1f1e7",
                  "name": "regional indicator symbol letter b",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo de indicador regional b"
                },
                {
                  "code": "1f1e6",
                  "name": "regional indicator symbol letter a",
                  "category": "regional",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "letra de símbolo indicador regional A"
                },
                {
                  "code": 39,
                  "name": "digit nine",
                  "category": "symbols",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "dígito nove"
                },
                {
                  "code": 38,
                  "name": "digit eight",
                  "category": "symbols",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "dígito oito."
                },
                {
                  "code": 37,
                  "name": "digit seven",
                  "category": "symbols",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "dígito sete."
                },
                {
                  "code": 36,
                  "name": "digit six",
                  "category": "symbols",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "dígito seis."
                },
                {
                  "code": 35,
                  "name": "digit five",
                  "category": "symbols",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "dígito cinco."
                },
                {
                  "code": 34,
                  "name": "digit four",
                  "category": "symbols",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "dígito quatro."
                },
                {
                  "code": 33,
                  "name": "digit three",
                  "category": "symbols",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "dígito três."
                },
                {
                  "code": 32,
                  "name": "digit two",
                  "category": "symbols",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "Dígito dois."
                },
                {
                  "code": 31,
                  "name": "digit one",
                  "category": "symbols",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "dígito um"
                },
                {
                  "code": 30,
                  "name": "digit zero",
                  "category": "symbols",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "dígito zero"
                },
                {
                  "code": 2640,
                  "name": "female sign",
                  "category": "people",
                  "keywords": "['woman']",
                  "display": 0,
                  "translatedName": "sinal feminino"
                },
                {
                  "code": 2642,
                  "name": "male sign",
                  "category": "people",
                  "keywords": "['man']",
                  "display": 0,
                  "translatedName": "sinal masculino"
                },
                {
                  "code": 2695,
                  "name": "medical symbol",
                  "category": "people",
                  "keywords": "['aesculapius', 'medicine', 'staff']",
                  "display": 0,
                  "translatedName": "símbolo médico"
                },
                {
                  "code": "1f468-1f469-1f466",
                  "name": "family: man, woman, boy",
                  "category": "people",
                  "keywords": "['boy', 'family', 'man', 'woman']",
                  "display": 0,
                  "translatedName": "Família: homem, mulher, menino"
                },
                {
                  "code": "1f469-2764-1f468",
                  "name": "couple with heart: woman, man",
                  "category": "people",
                  "keywords": "['couple', 'love', 'man', 'woman']",
                  "display": 0,
                  "translatedName": "Casal com coração: mulher, homem"
                },
                {
                  "code": "1f469-2764-1f48b-1f468",
                  "name": "kiss: woman, man",
                  "category": "people",
                  "keywords": "['couple', 'man', 'woman']",
                  "display": 0,
                  "translatedName": "Beijo: Mulher, Homem"
                },
                {
                  "code": "1f928",
                  "name": "face with raised eyebrow",
                  "category": "people",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "rosto com sobrancelha levantada"
                },
                {
                  "code": "1f929",
                  "name": "star-struck",
                  "category": "people",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "estrela struck."
                },
                {
                  "code": "1f92a",
                  "name": "crazy face",
                  "category": "people",
                  "keywords": "['eye', 'large', 'small']",
                  "display": 1,
                  "translatedName": "Cara de maluco"
                },
                {
                  "code": "1f92b",
                  "name": "shushing face",
                  "category": "people",
                  "keywords": "['quiet', 'shush']",
                  "display": 1,
                  "translatedName": "Shushing Face"
                },
                {
                  "code": "1f92c",
                  "name": "face with symbols over mouth",
                  "category": "people",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "rosto com símbolos sobre a boca"
                },
                {
                  "code": "1f92d",
                  "name": "face with hand over mouth",
                  "category": "people",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "cara com a mão sobre a boca"
                },
                {
                  "code": "1f92e",
                  "name": "face vomiting",
                  "category": "people",
                  "keywords": "['sick', 'vomit']",
                  "display": 1,
                  "translatedName": "vômito de rosto"
                },
                {
                  "code": "1f92f",
                  "name": "exploding head",
                  "category": "people",
                  "keywords": "['shocked']",
                  "display": 1,
                  "translatedName": "cabeça explodindo"
                },
                {
                  "code": "1f9d0",
                  "name": "face with monocle",
                  "category": "people",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "rosto com monóculo"
                },
                {
                  "code": "1f9d1",
                  "name": "adult",
                  "category": "people",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "adulto"
                },
                {
                  "code": "1f9d2",
                  "name": "child",
                  "category": "people",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "filho"
                },
                {
                  "code": "1f9d3",
                  "name": "older adult",
                  "category": "people",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "adulto mais velho"
                },
                {
                  "code": "1f9d4",
                  "name": "bearded person",
                  "category": "people",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "pessoa barbada"
                },
                {
                  "code": "1f9d5",
                  "name": "woman with headscarf",
                  "category": "people",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "Mulher com headscarf."
                },
                {
                  "code": "1f9e0",
                  "name": "brain",
                  "category": "people",
                  "keywords": "['intelligent']",
                  "display": 1,
                  "translatedName": "cérebro"
                },
                {
                  "code": "1f9e2",
                  "name": "billed cap",
                  "category": "people",
                  "keywords": "['baseball cap']",
                  "display": 1,
                  "translatedName": "Tampa faturada"
                },
                {
                  "code": "1f9d9",
                  "name": "mage",
                  "category": "people",
                  "keywords": "['sorcerer', 'sorceress', 'witch', 'wizard']",
                  "display": 0,
                  "translatedName": "mago"
                },
                {
                  "code": "1f9da",
                  "name": "fairy",
                  "category": "people",
                  "keywords": "['Oberon', 'Puck', 'Titania']",
                  "display": 0,
                  "translatedName": "fadas"
                },
                {
                  "code": "1f9db",
                  "name": "vampire",
                  "category": "people",
                  "keywords": "['Dracula', 'undead']",
                  "display": 0,
                  "translatedName": "vampiro"
                },
                {
                  "code": "1f9dc",
                  "name": "merperson",
                  "category": "people",
                  "keywords": "['mermaid', 'merman', 'merwoman']",
                  "display": 0,
                  "translatedName": "merperson."
                },
                {
                  "code": "1f9dd",
                  "name": "elf",
                  "category": "people",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "duende"
                },
                {
                  "code": "1f9de",
                  "name": "genie",
                  "category": "people",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "gênio"
                },
                {
                  "code": "1f9df",
                  "name": "zombie",
                  "category": "people",
                  "keywords": "['']",
                  "display": 0,
                  "translatedName": "zumbi."
                },
                {
                  "code": "1f9e3",
                  "name": "scarf",
                  "category": "people",
                  "keywords": "['neck']",
                  "display": 1,
                  "translatedName": "lenço"
                },
                {
                  "code": "1f9e4",
                  "name": "gloves",
                  "category": "people",
                  "keywords": "['hand']",
                  "display": 1,
                  "translatedName": "luvas"
                },
                {
                  "code": "1f9e5",
                  "name": "coat",
                  "category": "people",
                  "keywords": "['jacket']",
                  "display": 1,
                  "translatedName": "casaco"
                },
                {
                  "code": "1f9e6",
                  "name": "socks",
                  "category": "people",
                  "keywords": "['stocking']",
                  "display": 1,
                  "translatedName": "meias"
                },
                {
                  "code": "1f91f",
                  "name": "love-you gesture",
                  "category": "people",
                  "keywords": "['ILY', 'hand']",
                  "display": 1,
                  "translatedName": "amor-você gesto"
                },
                {
                  "code": "1f932",
                  "name": "palms up together",
                  "category": "people",
                  "keywords": "['']",
                  "display": 1,
                  "translatedName": "palmas juntas"
                },
                {
                  "code": "1f9d9-2640",
                  "name": "woman mage",
                  "category": "people",
                  "keywords": "['sorceress', 'witch']",
                  "display": 1,
                  "translatedName": "Mago de mulher"
                },
                {
                  "code": "1f9d9-2642",
                  "name": "man mage",
                  "category": "people",
                  "keywords": "['sorcerer', 'wizard']",
                  "display": 1,
                  "translatedName": "homem mago"
                },
                {
                  "code": "1f9da-2640",
                  "name": "woman fairy",
                  "category": "people",
                  "keywords": "['Titania']",
                  "display": 1,
                  "translatedName": "Fada da mulher"
                },
                {
                  "code": "1f9da-2642",
                  "name": "man fairy",
                  "category": "people",
                  "keywords": "['Oberon', 'Puck']",
                  "display": 1,
                  "translatedName": "fada do homem."
                },
                {
                  "code": "1f9db-2640",
                  "name": "woman vampire",
                  "category": "people",
                  "keywords": "['undead']",
                  "display": 1,
                  "translatedName": "Vampiro de mulher"
                },
                {
                  "code": "1f9db-2642",
                  "name": "man vampire",
                  "category": "people",
                  "keywords": "['Dracula', 'undead']",
                  "display": 1,
                  "translatedName": "homem vampiro."
                },
                {
                  "code": "1f9dc-2640",
                  "name": "mermaid",
                  "category": "people",
                  "keywords": "['merwoman']",
                  "display": 1,
                  "translatedName": "sereia"
                },
                {
                  "code": "1f9dc-2642",
                  "name": "merman",
                  "category": "people",
                  "keywords": "['Triton']",
                  "display": 1,
                  "translatedName": "tritão"
                },
                {
                  "code": "1f9dd-2640",
                  "name": "woman elf",
                  "category": "people",
                  "keywords": "['magical']",
                  "display": 1,
                  "translatedName": "Elf mulher"
                },
                {
                  "code": "1f9dd-2642",
                  "name": "man elf",
                  "category": "people",
                  "keywords": "['magical']",
                  "display": 1,
                  "translatedName": "Elf do homem"
                },
                {
                  "code": "1f9de-2640",
                  "name": "woman genie",
                  "category": "people",
                  "keywords": "['djinn']",
                  "display": 1,
                  "translatedName": "Genie da mulher"
                },
                {
                  "code": "1f9de-2642",
                  "name": "man genie",
                  "category": "people",
                  "keywords": "['djinn']",
                  "display": 1,
                  "translatedName": "Genie do homem"
                },
                {
                  "code": "1f9df-2640",
                  "name": "woman zombie",
                  "category": "people",
                  "keywords": "['undead', 'walking dead']",
                  "display": 1,
                  "translatedName": "Zumbi de mulher"
                },
                {
                  "code": "1f9df-2642",
                  "name": "man zombie",
                  "category": "people",
                  "keywords": "['undead', 'walking dead']",
                  "display": 1,
                  "translatedName": "homem zumbi"
                }
              ],
            "FILTERS": [
              {
                "name": "all",
                "emoji": "🔎",
                "template": "Todos os emojis" 
              }
              ,{
                "name": "people",
                "emoji": "😊",
                "template": "Smillies e pessoas" 
              }
              ,{
                "name": "nature",
                "emoji": "🐻",
                "template": "Animais e natureza" 
              }
              ,{
                "name": "food",
                "emoji": "🍔",
                "template": "Alimentos" 
              }
              ,{
                "name": "activity",
                "emoji": "⚽",
                "template": "Atividades" 
              }
              ,{
                "name": "travel",
                "emoji": "🚌",
                "template": "Transportes e viagens" 
              }
              ,{
                "name": "objects",
                "emoji": "💡",
                "template": "Objetos" 
              }
              ,{
                "name": "symbols",
                "emoji": "🔣",
                "template": "Símbolos" 
              }
              ,{
                "name": "flags",
                "emoji": "🚩",
                "template": "Bandeiras" 
              }
            ]
        }
        )
})();

/* globals $ */
(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .component('quotedMessageContainer', {
            bindings: {
                replySourceMessage: '<',
                messageOwnerName: '<'
            },
            controller: QuotedMessageContainerController,
            templateUrl: 'app/admin/communication/directives/quoted-message-container/quoted-message-container.html',
            controllerAs: 'vm'
        });

    QuotedMessageContainerController.$inject = ['$scope', '$rootScope', '$translate', '$uibModal', 'WatiService', '$window'];

    function QuotedMessageContainerController($scope, $rootScope, $translate, $uibModal, WatiService, $window) {
        var vm = this;

        vm.downloadDocument = function (message) {
            if (message.downloadedData) {
                $window.open(message.downloadedData);
            } else {
                message.loadingDownload = true;
                if (!message.data.includes('/data')) message.data = '/' + message.data;
                WatiService.findFileByName({ fileName: message.data }).then(function (result) {
                    var blob = new Blob([result.data], { type: result.data.type });
                    var url = $window.URL.createObjectURL(blob);
                    message.downloadedData = url;
                    message.loadingDownload = false;
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('onLongPress', onLongPress);

    function onLongPress($timeout) {
        return {
            restrict: 'A',
            link: function($scope, $elm, $attrs) {
                $elm.bind('touchstart', function(evt) {
                    // Locally scoped variable that will keep track of the long press
                    $scope.longPress = true;
                    $scope.pressed = false;

                    // We'll set a timeout for 600 ms for a long press
                    $timeout(function() {
                        if ($scope.longPress) {
                            $scope.pressed = true;
                            // If the touchend event hasn't fired,
                            // apply the function given in on the element's on-long-press attribute
                            $scope.$apply(function() {
                                $scope.$eval($attrs.onLongPress)
                            });
                        }
                    }, 600);
                });
        
                $elm.bind('touchend', function(evt) {
                    $scope.longPress = false;
                    if ($attrs.onTouchEnd && $scope.pressed) {
                        $scope.pressed = false;
                        $scope.$apply(function() {
                            $scope.$eval($attrs.onTouchEnd)
                        });
                    }
                });
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('noContenteditable', noContenteditable);

    /* @ngInject */
    function noContenteditable() {
        /**
         * @ngdoc directive
         * @name app.directive:noContenteditable
         * @description
         * # noContenteditable
         */
        var directive = {
            link: link,
            restrict: 'EA'
        };

        return directive;

        function link(scope, element, attrs, ngModel){
            element.on('keypress', function(event) {
                if (event && event.keyCode == 13 && !event.shiftKey) {
                    event.preventDefault();
                }
            });
        };
    };
})();

/* globals $ */
(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .component('messageReply', {
            bindings: {
                messageToReply: '<',
                messageOwnerName: '<',
                cancelReply: '<'
            },
            controller: MessageReplyController,
            templateUrl: 'app/admin/communication/directives/message-reply/message-reply.html',
            controllerAs: 'vm'
        });

    MessageReplyController.$inject = ['$scope', '$window'];

    function MessageReplyController($scope, $window) {
        var vm = this;
        vm.isMobile = detectar_mobile();

        getVideoDuration();
        getAudioDuration();

        function getVideoDuration() {
            if (vm.messageToReply.type === 'video' && !vm.messageToReply.text) {
                var video = document.createElement('video');
                video.preload = 'metadata';
                video.onloadedmetadata = function() {
                    window.URL.revokeObjectURL(this.src)
                    var duration = video.duration;
                    vm.messageToReply.duration = moment(duration * 1000).format('mm:ss');
                    $scope.$apply();
                }

                video.src = vm.messageToReply.data;
            }
        }

        function getAudioDuration() {
            if (vm.messageToReply.type === 'audio' && !vm.messageToReply.text) {
                var audio = document.createElement('audio');
                audio.preload = 'metadata';
                audio.onloadedmetadata = function() {
                    window.URL.revokeObjectURL(this.src)
                    var duration = audio.duration;
                    vm.messageToReply.duration = moment(duration * 1000).format('mm:ss');
                    $scope.$apply();
                }

                audio.src = vm.messageToReply.data;
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .component('messageReferral', {
            bindings: {
                value: '<'
            },
            controller: MessageReferralController,
            templateUrl: 'app/admin/communication/directives/message-referral/message-referral.html',
            controllerAs: 'vm'
        });

    MessageReferralController.$inject = ['$scope', '$window'];

    function MessageReferralController($scope, $window) {
        var vm = this;

        vm.openUrl = function () {
            $window.open(vm.value.url, '_blank');
        }

    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('messageOptions', messageOptions);

    function messageOptions() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/admin/communication/directives/message-options.html',
            scope: {
                message: '=',
                applyOption: '&'
            },
            link: function(scope, element, attr) {
                scope.isOpen = false;
                scope.isMobile = detectar_mobile();

                scope.callApplyOption = function (option, message) {
                    scope.applyOption(option, message);
                }

                scope.toggled = function (isOpen) {
                    scope.message.holdMessage = isOpen;
                }
            }
        };

        return directive;
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('messageLongPress', messageLongPress);

    function messageLongPress($timeout) {
        var directive = {
            restrict: 'A',
            link: function($scope, $elm, $attrs) {
                $elm.bind('touchstart', function(evt) {
                    // Locally scoped variable that will keep track of the long press
                    $scope.longPress = true;

                    // We'll set a timeout for 600 ms for a long press
                    $timeout(function() {
                        if ($scope.longPress) {
                            var message = $scope.$eval($attrs.message);
                            // If the touchend event hasn't fired,
                            // apply the function given in on the element's on-long-press attribute
                            $scope.$apply(function() {
                                message.holdMessage = false;
                            });

                            $scope.$apply(function() {
                                evt.preventDefault();
                                evt.stopPropagation();
                                message.holdMessage = true;
                            });
                        }
                    }, 600);
                });

                $elm.bind('touchend', function(evt) {
                    // Prevent the onLongPress event from firing
                    $scope.longPress = false;
                    // If there is an on-touch-end function attached to this element, apply it
                    if ($attrs.onTouchEnd) {
                        $scope.$apply(function() {
                            $scope.$eval($attrs.onTouchEnd)
                        });
                    }
                });
            }
        };

        return directive;
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('messageLoading', messageLoading);

    function messageLoading() {
        return {
            restrict: 'E',
            scope: {
                size: '=',
                alignSide: '=',
                margin: '='
            },
            templateUrl: 'app/admin/communication/directives/message-loading/message-loading.html'
        };
    }
})();

/* globals $ */
(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .component('messageContainer', {
            bindings: {
                currentCustomer: '<',
                currentConversation: '<',
                message: '<'
            },
            controller: MessageContainerController,
            templateUrl: 'app/admin/communication/directives/message-container/message-container.html',
            controllerAs: 'vm'
        });

    MessageContainerController.$inject = ['$scope', '$rootScope', '$translate', '$uibModal', '$window', 'WatiService'];

    function MessageContainerController($scope, $rootScope, $translate, $uibModal, $window, WatiService) {
        var vm = this;

        vm.getOrderAmount = function (orders) {
            return _.sumBy(orders, function (order) {
                return order.quantity * order.price;
            }).toFixed(2);
        }

        vm.getOrderQuantity = function (orders) {
            return orders.reduce(function (accumulator, order) {
                return accumulator + order.quantity;
            }, 0);
        }

        vm.downloadDocument = function (message) {
            if (message.downloadedData) {
                $window.open(message.downloadedData);
            } else {
                message.loadingDownload = true;
                WatiService.findFileByName({ fileName: message.data }).then(function (result) {
                    var blob = new Blob([result.data], { type: result.data.type });
                    var url = $window.URL.createObjectURL(blob);
                    message.downloadedData = url;
                    message.loadingDownload = false;
                });
            }
        }

        vm.getStoryLabel = function () {
            if (!vm.message.owner) {
                if (vm.message.type === 'story_reply') {
                    return 'communication.someone-story-reply';
                } else if (vm.message.type === 'story_mention') {
                    return 'communication.someone-story-mention';
                }
            } else if (vm.message.owner) {
                if (vm.message.type === 'story_reply') {
                    return 'communication.your-story-reply';
                } else if (vm.message.type === 'story_mention') {
                    return 'communication.your-story-mention';
                }
            }
        }

        vm.openCart = function () {
            vm.chatInvoiceNewModal = $uibModal.open({
                templateUrl: 'app/admin/invoices/chat/chat-invoice-new.html',
                controller: 'ChatInvoiceNewController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    currentCustomer: function () {
                        return vm.currentCustomer
                    },
                    cartProducts: function () {
                        return vm.message.orderProducts.productItems
                    }
                },
            }).result.then(function (response) {
                $rootScope.$emit('$applyResponseFromCreatedOrder', response);
            });
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('messageContact', messageContact);

    function messageContact() {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/communication/directives/message-contact/message-contact.html'
        };
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('chatSkeleton', chatSkeleton)
        .directive('chatMessageSkeleton', chatMessageSkeleton)
        .directive('chatContactsSkeleton', chatContactsSkeleton)
        .directive('chatContactInfoSkeleton', chatContactInfoSkeleton)
        .directive('row', skeletonRow)
        .directive('column', skeletonColumn);

    function chatSkeleton() {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/communication/directives/chat-skeleton/chat-skeleton.html',
            controller: 'ChatSkeletonController',
            controllerAs: 'vm',
            scope: {
                hasIcon: '='
            },
        };
    }

    function chatContactInfoSkeleton() {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/communication/directives/chat-skeleton/chat-contact-info-skeleton.html',
        };
    }

    function chatContactsSkeleton() {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/communication/directives/chat-skeleton/chat-contacts-skeleton.html',
            controller: 'ChatContactsSkeletonController',
            controllerAs: 'vm',
            scope: {
                cardQtt: '='
            },
        };
    }

    function chatMessageSkeleton() {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/communication/directives/chat-skeleton/chat-message-skeleton.html',
            controller: 'ChatMessageSkeletonController',
            controllerAs: 'vm',
            scope: {
                hasIcon: '=',
                side: '='
            },
        };
    }

    function skeletonRow() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                columns: '='
            },
            template:
                '<div class="row">' +
                '<column ng-repeat="column in columns" classes="column.classes">' +
                '</column>' +
                '</div>'
        }
    }

    /**
     * <column classes="<Skeleton CSS grid classes>"
     *
     *    Examples:
     *
     *      <column classes="one column">[content]</column>
     *      <column classes="nine columns">[content]</column>
     *      <column classes="one-third column">[content]</column>
     *
     *  Content within the directive will be transcluded within
     *  the generated <div> element. HTML cam be passed as content
     *  and will be rendered in the DOM accordingly via the <dynamic>
     *  directive
     *
     */
    function skeletonColumn() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                classes: '=',
            },
            template: '<div class="{{classes}}"></div>'
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ChatSkeletonController', ChatSkeletonController);

    ChatSkeletonController.$inject = ['$scope'];

    function ChatSkeletonController($scope) {
        var vm = this;

        vm.hasIcon = true;
        vm.messageCount = 1;

        function init() {
            vm.hasIcon = $scope.hasIcon;
            vm.messageCount = $scope.messageCount;
        }

        init();
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ChatMessageSkeletonController', ChatMessageSkeletonController);

    ChatMessageSkeletonController.$inject = ['$scope'];

    function ChatMessageSkeletonController($scope) {
        var vm = this;

        vm.side = 'left';
        vm.hasIcon = true;

        function init() {
            vm.side = $scope.side;
            vm.hasIcon = $scope.hasIcon;
        }

        init();
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ChatContactsSkeletonController', ChatContactsSkeletonController);

    ChatContactsSkeletonController.$inject = ['$scope'];

    function ChatContactsSkeletonController($scope) {
        var vm = this;

        vm.conversationHeight = window.innerHeight - 71;
        vm.cards = [];

        function init() {
            var lenght = $scope.cardQtt ? $scope.cardQtt : 1;
            vm.cards = Array.from({length: lenght}, function(v, k) { return k+1 });
        }

        init();
    }

})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('recordingTimer', recordingTimer);

    function recordingTimer() {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/communication/directives/audio-recording/recording-timer.html',
            controller: 'RecordingTimerController'
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('RecordingTimerController', RecordingTimerController);

    RecordingTimerController.$inject = ['$scope', '$timeout'];

    function RecordingTimerController($scope, $timeout) {
        var recordStopped;
        var blinking;

        $scope.timer = 0;
        $scope.showRedLight = false;
        function init() {
            $scope.timer = 0;
            $scope.showRedLight = false;
            recordCountdown();
            blink();
        }

        $scope.$on("$destroy", function() {
            stopRecordCountdown();
        });

        function recordCountdown() {
            recordStopped = $timeout(function() {
                $scope.timer++;
                recordCountdown();
            }, 1000);
        };

        function stopRecordCountdown(){
            $scope.timer = 0;
            $scope.showRedLight = false;
            $timeout.cancel(recordStopped);
            $timeout.cancel(blinking);
        };

        function blink() {
            blinking = $timeout(function() {
                $scope.showRedLight = !$scope.showRedLight;
                blink();
            }, 500);
        }

        init();
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('detectScrollToTop', function() {

            return{

                restrict: 'A',
                link: function (scope, element, attrs) {
                    var fn = scope.$eval(attrs.detectScrollToTop);
                    element.on('scroll', function (e) {
                        if (!e.target.scrollTop) {
                            scope.$apply(fn);
                        }
                    });
                }

            }
        })
})();

/* globals $ */
(function() {
	'use strict';

	angular
		.module('showcaseApp')
		.directive('detectScrollToBottom', function () {

			return{

				restrict: 'A',
				link: function (scope, element, attrs) {
					var fn = scope.$eval(attrs.detectScrollToBottom);
					element.on('scroll', function (e) {
						if ((e.target.scrollHeight - e.target.scrollTop) <= e.target.clientHeight + 1) {
							scope.$apply(fn);
						}
					});
				}

			};
		})
})();

/* globals $ */
(function() {
	'use strict';

	angular
		.module('showcaseApp')
		.directive('detectLastInteration', function () {
			return function(scope, element, attrs) {
                if (scope.$last){
                  // iteration is complete, do whatever post-processing
                  // is necessary
                  setTimeout(function() {
                    var elements = document.querySelectorAll('video');
                    for(var i = 0; i < elements.length; i++) {
                        var state = elements[i].networkState;
                        if (state === 1) {
                            elements[i].style.display = 'block';
                        }
                    }
                  }, 1500);
                }
              };
		})
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    function stateConfig($stateProvider) {
        $stateProvider
            .state('communication', {
                parent: 'admin',
                url: '/communication/{chatPlatform}/{conversationId}',
                params: {
                    chatPlatform: { squash: true, value: '' },
                    conversationId: { squash: true, value: '' }
                },
                data: {
                    authorities: ['SEND_MESSAGE_TO_WATI', 'SEND_MESSAGE_TO_FACEBOOK'],
                    pageTitle: 'global.menu.admin.communication'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/communication/communication.html',
                        controller: 'CommunicationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('communication');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('customers');
                        $translatePartialLoader.addPart('bag');
                        $translatePartialLoader.addPart('integrations');
                        $translatePartialLoader.addPart('social-media');
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('CommunicationService', CommunicationService);

    function CommunicationService($q) {
        var service = {
            sendMessageWhatsapp: sendMessageWhatsapp,
            getOldMessagesWhatsapp: getOldMessagesWhatsapp,
            getAudioRecorder: getAudioRecorder
        },

        listener = $q.defer(), socket = {
            client: null,
            stomp: null
        }, messageIds = [];

        service.RECONNECT_TIMEOUT = 30000;


        service.configureWS = function() {
            this.stompClient = Stomp.over(
                SockJS("https://localhost:8080/chat")
              );

              // tslint:disable-next-line:only-arrow-functions
              this.stompClient.connect({}, function () {
                //this.configureWsMessenger();
                //this.configureWsInstagram();
                configureWsWati();
              });
        };

        function sendMessageWhatsapp() {
        }

        function getOldMessagesWhatsapp() {
        }

        /**
         * Configures the subscriber Wati.
         */
         function configureWsWati() {
            this.stompClient.subscribe(
            "topic/new-message-wati",
            function (message) {
                var body = this.makeBody(message);
                if (!body.text) return;
                if (!Object.keys(this.conversations).includes(body.waId)) {
                this.currentUser = body.waId;
                this.conversations[this.currentUser] = {
                    messages: [],
                    source: body.source,
                    id: body.waId,
                };
                }
                this.currentUser = body.waId;
                this.conversations[this.currentUser].messages.push({
                isSource: false,
                text: body.text,
                type: MESSAGE.TYPES.TEXT,
                });
                this.scrollToBottom();
            }
            );
        }

        return service;

    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('CommunicationController', CommunicationController)
        .filter('parseUrl', function () {
            var url_match = /((http|ftp|https):\/\/)*([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*)/gim

            return function (text) {
                if (text.match(url_match)) {
                    text = text.replace(url_match, "<a href=\"https://$3$4\" target=\"_blank\">$3$4</a>")
                }

                return text
            }
        })
        .filter('messageTextFormat', function() {
            return function(text) {
                var url_match = /((http|ftp|https):\/\/)*([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*)/gim

                if (text.match(url_match)) {
                    return text;
                }
                return text.replace(/(?:\*)(?:(?!\s))((?:(?!\*|\n).)+)(?:\*)/g,'<b>$1</b>')
                    .replace(/(?:_)(?:(?!\s))((?:(?!\n|_).)+)(?:_)/g,'<i>$1</i>')
                    .replace(/(?:~)(?:(?!\s))((?:(?!\n|~).)+)(?:~)/g,'<s>$1</s>')
                    .replace(/(?:--)(?:(?!\s))((?:(?!\n|--).)+)(?:--)/g,'<u>$1</u>')
                    .replace(/(?:```)(?:(?!\s))((?:(?!\n|```).)+)(?:```)/g,'<tt>$1</tt>');
            };
        });

    function CommunicationController(ChatService, communicationConstants, $uibModal, WatiService, toastr, $scope, $window, EmojisConstants, FlyersService,
        $localStorage, MessengerService, FacebookService, $timeout, $translate, SocialMediaService, $state, CustomerService, NoteTagService,
        ChatTicketService, UserService, StoreService, ChatUnreadMessageService, FBAuthModalFactory, WsService, CheckCEPService, UserEngagementService, FlyerCategoryService, Principal, FlyersCurrencyValue,
                                     $stateParams, NotificationService, $rootScope, AudioModalFactory, ChatCommerceService, IndexedDBCommunication,
                                     MediaDeviceService, ImageManagerService) {
        var vm = this;

        vm.allChatsConnected = false;
        vm.isLoadingConnection = true;
        vm.loadingConversations = true;
        vm.loadingMoreConversations = false;
        vm.loadingMessages = false;
        vm.showSkeleton = true;
        vm.loadingCustomerInfos = true;
        vm.sendMessageBtnLoading = false;
        vm.isSendLocation = false;
        vm.text = '';
        vm.gumStream = undefined;
        vm.recorder = undefined;
        vm.input = undefined;
        vm.discarded = false;

        vm.mobileFlow = {
            'listConversations': true,
            'chatConversation': false,
            'customerInfos': false
        }

        vm.notes = [];
        vm.tags = [];
        vm.stickers = [];
        vm.stickersApi = '';
        vm.stickersPageNumber = 0;

        vm.emojis = EmojisConstants.EMOJIS;
        vm.currentEmojiFilter = 'all';
        vm.searchedEmojiWord = '';
        vm.filteredEmojis = {};
        vm.emojiFilters = EmojisConstants.FILTERS;

        vm.supportedFilesType = communicationConstants.SUPPORTED_FILES_TYPES;
        vm.supportedImagesType = communicationConstants.SUPPORTED_IMAGES_TYPES;

        vm.newNoteText = "";
        vm.newTagText = ""
        vm.isWritingNote = false;
        vm.isEditingNote = false;
        vm.currentlyEditingNote = 0;
        vm.allWatiMessages = 0;
        vm.allInstaMessages = 0;
        vm.allMessengerMessages = 0;
        vm.attachmentTypes = ['image', communicationConstants.MESSAGES_TYPES.STORYMENTION];
        vm.allMessages = vm.allWatiMessages + vm.allInstaMessages + vm.allMessengerMessages;
        vm.days = [$translate.instant('communication.days.sunday'),
        $translate.instant('communication.days.monday'),
        $translate.instant('communication.days.tuesday'),
        $translate.instant('communication.days.wednesday'),
        $translate.instant('communication.days.thursday'),
        $translate.instant('communication.days.friday'),
        $translate.instant('communication.days.saturday')]
        var RESERVED_TYPE = 'RESERVED';
        var FORMAT_DATE = 'DD/MM/YYYY';
        var FORMAT_TIME = 'HH:mm';

        vm.loadingUserInfo = false;
        vm.loadingUserCategoryStatistics = false;
        vm.loadingUserOfferEngagements = false;

        vm.currentPage = 1;
        vm.numPerPage = 5;
        vm.maxSize = 5;
        vm.totalElements = 0;

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        vm.usersAttendants = [];

        vm.status = {
            'NEW': 'Novo',
            'OPENED': 'Aberto',
            'PENDING': 'Pendente',
            'RESOLVED': 'Resolvido',
            'EXPIRED': 'Expirado'
        }

        vm.isWatiConnected = false;
        vm.fbConnected = false;

        vm.syncSocialPromise = {
            wati: false,
            instagram: false,
            messenger: false
        }

        getManagerUser();

        function getManagerUser() {
            Principal.identity().then(function (account) {
                if (account) {
                    vm.account = angular.copy(account);
                }
            });
        }

        vm.proxy = new Proxy(vm.days, {
            get: function (target, prop) {
                if (!isNaN(prop)) {
                    prop = parseInt(prop, 10);
                    if (prop < 0) {
                        prop += target.length;
                    }
                }
                return target[prop];
            }
        });

        var oneHourInMilliseconds = 3600000
        var oneMinuteInMiliseconds = 60000
        vm.startingTime = 24;
        vm.interval = undefined;
        vm.openedMessages = [];
        vm.attemptToSendMedia = 0;
        vm.chatConfiguration = {};

        vm.pageNumber = 1;
        vm.currentUser = "";
        vm.currentCustomer = {};
        vm.conversations = {};

        vm.cursors = { 'INSTAGRAM': null, 'MESSENGER': null };
        vm.file = {};
        vm.imagesToSend = [];
        var chunkSize = 534 * 1000; // 525KB em bytes

        vm.myInstagramId = "";
        vm.conversations = new Map();

        vm.conversationsList = [];
        vm.currentConversation = ("", {});
        vm.currentConversation.time = vm.startingTime * oneHourInMilliseconds;
        vm.currentSocialMedia = communicationConstants.ALL;
        vm.messenger = {};

        vm.isEditMode = false;
        vm.maskLocale = '99/99/9999';
        vm.customerEdit = {}

        var storeId = $localStorage.defaultStore.storeId;

        vm.currentStore = $localStorage.defaultStore;

        vm.userManager = null;
        vm.currentAttendant = null

        vm.mainColor = getComputedStyle(document.documentElement).getPropertyValue('--main-color');

        vm.isMobile = detectar_mobile();

        vm.searchText = "";

        vm.socialMediasOptions = [
            {
                tabId: 'WATI',
                title: 'Whatsapp',
                position: 2,
                numberOfMessages: function() { return vm.allWatiMessages },
                connected: function() {return vm.isWatiConnected}
            },
            {
                tabId: 'INSTAGRAM',
                title: 'Instagram',
                position: 1,
                numberOfMessages: function() {return  vm.allInstaMessages},
                connected: function() {return vm.fbConnected }
            },
            {
                tabId: 'MESSENGER',
                title: 'Messenger',
                position: 0,
                numberOfMessages: function() { return vm.allMessengerMessages},
                connected: function() {return vm.fbConnected}
            }
        ];

        vm.numberFilterSelected = 0;

        vm.filters = {
            status: [
                {
                    "value": "EXPIRED",
                    "label": "Expirado",
                    "id": 1
                },
                {
                    "value": "NEW",
                    "label": "Novo",
                    "id": 2
                },
                {
                    "value": "OPENED",
                    "label": "Aberto",
                    "id": 3
                },
                {
                    "value": "PENDING",
                    "label": "Pendente",
                    "id": 4
                }
            ],
            attendants: [],
            socialMedias: [],
            order: {},
            rangeDate: { startDate: null, endDate: null }
        };

        vm.selectMultipleMessages = false;
        vm.replyMessage = false;
        vm.selectedMessages = [];

        vm.messageOptions = {
            'FORWARD': {
                doAction: function(message) {
                    vm.updateMessagesToForward(message);
                    vm.selectMultipleMessages = true;
                },
            },
            'REPLY': {
                doAction: function (message) {
                    vm.replyMessage = true;
                    vm.messageToReply = message;
                }
            },
            'COPY_MESSAGE': {
                doAction: function (message) {
                    if (window.isSecureContext && navigator.clipboard) {
                        navigator.clipboard.writeText(message.text);
                    } else {
                        var dummy = document.createElement("textarea");
                        document.body.appendChild(dummy);
                        dummy.value = message.text;
                        dummy.select();
                        document.execCommand("copy");
                        document.body.removeChild(dummy);
                    }
                }
            },
            'DELETE_MESSAGE': {
                doAction: function (message) {
                    IndexedDBCommunication.getSendingFileByLocalMessageId(message.localMessageId, function (result) {
                        if (result !== null) {

                            _.remove(vm.openedMessages, function (openedMessage) {
                                return openedMessage.localMessageId === result.localMessageId;
                            });

                            IndexedDBCommunication.removeSendingFile(result.id);
                        }
                    });
                }
            }
        }

        $scope.data = {
            selectedIndex: 0,
            secondLabel: "Item Two",
            bottom: false
        };

        $scope.next = function () {
            $scope.data.selectedIndex = Math.min($scope.data.selectedIndex + 1, 2);
        };

        $scope.previous = function () {
            $scope.data.selectedIndex = Math.max($scope.data.selectedIndex - 1, 0);
        };

        vm.changeTab = function (tabName) {
            $localStorage.chatFilters.filtered.socialMedias = [];
            vm.currentSocialMedia = tabName;
            vm.conversationsList = [];
            vm.conversations = new Map();
            vm.loadingConversations = true;
            var filters = angular.copy($localStorage.chatFilters.filtered);
            filters.pageNumber = 0;
            $localStorage.chatFilters.filtered.pageNumber = 0;
            $localStorage.chatFilters.selectedFilters.pageNumber = 0;
            searchByFilter(filters);
        }

        vm.redirectTo = function (value) {
            $state.go(value)
        }

        setTimeout(function () {
            ChatCommerceService.getChatConfiguration().then(function (result) {
                vm.chatConfiguration = result.data;
            });
            IndexedDBCommunication.updateSendingFilesByStatus('CANCELED');
            verifyAllChatsConnected().finally(function () {
                WsService.getInfo().then(function (result) {
                    vm.wsToken = result.token;

                    ChatService.connectWS(function () {
                        vm.fbIsSubscribed = false;
                        getInfoAndSubscribeWhatsapp();
                        isFacebookConnected()
                        if (vm.conversationsList.length > 0) {
                            $localStorage.chatFilters.filtered.pageNumber = 0;
                            $localStorage.chatFilters.selectedFilters.pageNumber = 0;
                            vm.conversationsList = [];
                            vm.conversations = new Map();
                        }
                        vm.init();
                    });
                });
            });
        }, 500);

        function getFormattedFilters() {
            var filters = angular.copy(vm.filters);
            filters.order = filters.order.value ? filters.order.value : {};
            filters.attendants = filters.attendants.map(function(attendant){ return attendant.value });
            filters.status = filters.status.map(function(status){ return status.value });
            filters.socialMedias = [];
            filters.rangeDate = filters.rangeDate.startDate && filters.rangeDate.endDate ? formatDate(filters.rangeDate.startDate, filters.rangeDate.endDate) : null;
            filters.allAttendants = vm.usersAttendants.map(function(attendant) { return attendant.id });
            filters.pageNumber = vm.filters.pageNumber;
            return filters;
        }

        function formatDate(startDate, endDate) {
            var start = startDate.format('YYYY-MM-DD');
            var end = endDate.format('YYYY-MM-DD');
            return start + "->" + end;
        }

        vm.currentChatsStatus = {
            'WATI': {
                loading: false,
                failed: false,
                isConnected: false
            },
            'INSTAGRAM': {
                loading: false,
                failed: false,
                isConnected: false
            },
            'MESSENGER': {
                loading: false,
                failed: false,
                isConnected: false
            }
        };

        var conversationsPromises = [
            {
                platform: communicationConstants.SOCIAL_MEDIAS.WATI,
                payload: {
                    pageSize: 10,
                    chatPlatform: communicationConstants.SOCIAL_MEDIAS.WATI,
                    lastId: null
                }
            },
            {
                platform: communicationConstants.SOCIAL_MEDIAS.MESSENGER,
                payload: {
                    pageSize: 10,
                    chatPlatform: communicationConstants.SOCIAL_MEDIAS.MESSENGER,
                    cursor: null
                }
            },
            {
                platform: communicationConstants.SOCIAL_MEDIAS.INSTAGRAM,
                payload: {
                    pageSize: 5,
                    chatPlatform: communicationConstants.SOCIAL_MEDIAS.INSTAGRAM,
                    cursor: null,
                }
            }
        ];

        function updateNewConversations(conversations) {
            if (vm.conversationsList.length > 0) {
                var filters = angular.copy($localStorage.chatFilters.filtered);
                if (filters.order && filters.order.direction === 'ASC') {
                    vm.conversationsList = _.unionBy(vm.conversationsList, conversations, 'chatUserId');
                } else {
                    vm.conversationsList = _.unionBy(conversations, vm.conversationsList, 'chatUserId');
                }
            }
        }

        $scope.$on('$destroy', function () {
            clearInterval(vm.synchronizeChatInterval);
        });

        function synchronizeChat() {
            vm.synchronizeChatInterval = setInterval(function () {
                var filters = angular.copy($localStorage.chatFilters.filtered);
                filters.searchString = vm.searchText.trim();
                if (vm.currentSocialMedia !== 'ALL') {
                    filters.socialMedias = [vm.currentSocialMedia];
                }
                filters.connectedChats = {
                    isWATIConnected: vm.isWatiConnected,
                    isMetaConnected: vm.fbConnected
                };
                filters.pageNumber = 0;

                ChatCommerceService.synchronizeChat({
                    chatPlatform: 'WATI',
                    pageSize: 20
                });

                ChatCommerceService.getConversationsByFilter(filters).then(function (result) {
                    updateNewConversations(result.data.items);
                    vm.conversationsList.forEach(function (conversation) {
                        getProfilePicFromUrl(conversation);
                        if (vm.currentConversation 
                            && conversation.attendantId 
                            && vm.currentConversation.conversationId == conversation.conversationId) {
                            vm.currentConversation.attendantId = conversation.attendantId;
                            getCurrentAttendant();
                        }
                    });
                });
            }, 20000);
        }

        vm.init = function () {
            verifyPermission();
            vm.dontScrolled = true;
            vm.conversationHeight = window.innerHeight - 71;
            if (!$localStorage.chatFilters) {
                $localStorage.chatFilters = {
                    selectedFilters: {
                        status: vm.filters.status,
                        attendants: [],
                        socialMedias: [],
                        order: {},
                        rangeDate: { startDate: null, endDate: null },
                        pageNumber: 0
                    },
                    filtered: getFormattedFilters(),
                    numberFilterSelected: 1
                };
            }

            $localStorage.chatFilters.filtered.pageNumber = 0;
            $localStorage.chatFilters.selectedFilters.pageNumber = 0;

            vm.filters = $localStorage.chatFilters.selectedFilters;
            vm.numberFilterSelected = $localStorage.chatFilters && $localStorage.chatFilters.numberFilterSelected
                ? $localStorage.chatFilters.numberFilterSelected
                : vm.numberFilterSelected;

            if (vm.synchronizeChatInterval) {
                clearInterval(vm.synchronizeChatInterval);
            }

            synchronizeChat();
            if (vm.usersAttendants.length === 0) {
                getAttendantsForFilter();
            } else {
                isFacebookConnected();
                searchByFilter($localStorage.chatFilters.filtered);
                findConversationByConversationId();
            }

            updateUnreadMessagesBySocialMedia(communicationConstants.SOCIAL_MEDIAS.MESSENGER);
            updateUnreadMessagesBySocialMedia(communicationConstants.SOCIAL_MEDIAS.INSTAGRAM);
            updateUnreadMessagesBySocialMedia(communicationConstants.SOCIAL_MEDIAS.WATI);
        };
        verifyPermission();

        /**
         * Gets called when conversations are scrolled to bottom and updates the shown conversations to include older ones.
         */
        vm.conversationsScrolledToBottom = function () {
            if (vm.dontScrolled) return;
            vm.loadingMoreConversations = true;

            var filters = angular.copy($localStorage.chatFilters.filtered);
            if (vm.currentSocialMedia !== 'ALL') {
                filters.socialMedias = [vm.currentSocialMedia];
            }

            searchByFilter(filters);
        }

        vm.hasLoadingActive = function () {
            return vm.sendMessageBtnLoading || vm.loadingMessages || vm.loadingConversations;
        }

        function getAttendantsForFilter() {
            getAllAttendantsPromise().then(function (result) {
                vm.usersAttendants = result.data;
                Principal.identity().then(function (account) {
                    if (account) {
                        $localStorage.chatFilters.filtered = getFormattedFilters();
                        isFacebookConnected();
                        searchByFilter($localStorage.chatFilters.filtered);
                    }
                });
            })
        }

        function showSelectedConversation(conversation) {
            ChatCommerceService.getConversationByConversationId(conversation.conversationId)
                .then(function (result) {
                    vm.openConversation(result);
                    vm.loadingConversations = false;
                }, function (err) {
                    $localStorage.redirectNotificationData = null;
                    vm.loadingConversations = false;
                }
            );
        }

        function getAllChatConnectionPromise() {
            return Promise.all([WatiService.getConfigByCurrentStore(), SocialMediaService.isFacebookConnected()]);
        }

        function verifyAllChatsConnected() {
            vm.isLoadingConnection = true;
            return getAllChatConnectionPromise().then(function(results) {
                    var connectedWati = false;
                    var connectedFb = false;
                    var resultWati = results[0];
                    var resultFb = results[1];

                    if (resultWati.data.id) {
                        vm.isWatiConnected = true;
                        vm.watiSetting = resultWati.data;
                        connectedWati = true;
                    } else {
                        vm.isWatiConnected = false;
                    }

                    if (resultFb.data) {
                        vm.fbConnected = true;
                        connectedFb = true;
                        $localStorage.fb = resultFb.data;
                    }

                    vm.allChatsConnected = connectedWati || connectedFb;
                    vm.isLoadingConnection = false;
                }
            );
        }

        function isFacebookConnected() {
            SocialMediaService.isFacebookConnected().then(function (result) {
                if (result.data) {
                    vm.fbConnected = true;
                    $localStorage.fb = result.data;

                    if (!vm.fbIsSubscribed) {
                        ChatService.subscribeOnMessenger($localStorage.fb.page.pageId, subscribeOnMessenger);
                        ChatService.subscribeOnInstagram($localStorage.fb.business.igBusinessAccount.igAccountId, subscribeOnInstagram);
                        vm.fbIsSubscribed = true;
                    }

                    return;
                }
            });
        }

        vm.users = [];

        vm.attachFile = function () {
            var tag = document.querySelector('#file-upload-sheet');
            if (!tag.disabled) {
                vm.closeFeedbackPopUp();
            }
        }

        function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            var blob = new Blob([ia], {
                type: mimeString
            });

            return $window.URL.createObjectURL(blob);
        }

        /**
         * Executes when any person click in the button to send file.
         */
        vm.onSelectFile = function (event) {
            var file = event.target.files[0];
            if (file.size > communicationConstants.FILES.MAX_SIZE) {
                toastr.warning($translate.instant('communication.errors.sizeExceed'));
            } else {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    vm.file.base64 = reader.result.split(',')[1];
                    vm.file.fullBase64 = reader.result;
                    vm.file.blob = dataURItoBlob(reader.result);
                    var setting = makeSettingByBase64(reader.result);
                    vm.file.type = setting.type;
                    vm.file.mimeType = setting.mimeType;
                    vm.file.name = file.name;
                    openModalToSendFile().then(function (file) {
                        if (vm.currentConversation.platform == communicationConstants.SOCIAL_MEDIAS.WATI) {
                            var base64 = file.base64;
                            delete file.base64;
                            delete file.fullBase64;

                            sendMediaMessageToWhatsapp(vm.currentConversation.chatUserId,
                                {
                                    data: base64,
                                    mimeType: file.mimeType,
                                    caption: file.name,
                                    fullData: file,
                                    blob: vm.file.blob
                                },
                                file.type, vm.file.name);
                            return;
                        }
                        sendMediaMessageToFacebook(file);

                    });
                };
            }
        }

        vm.onSelectImages = function (event) {
            vm.imagesToSend = [];
            var images = event.target.files;
            Array.from(images).forEach(function (file, index) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    var imageBlob = dataURItoBlob(reader.result);
                    var setting = makeSettingByBase64(reader.result);

                    var img = new Image();
                    img.onload = function (evt) {
                        var dataurl = reader.result;

                        if (img.width > 2560 || img.height > 1440) {
                            dataurl = ImageManagerService.handleImageSize(img, file);
                        }

                        vm.imagesToSend.push({
                            index: index,
                            name: file.name,
                            base64: dataurl.split(',')[1],
                            fullBase64: dataurl,
                            type: setting.type,
                            mimeType: setting.mimeType,
                            blob: imageBlob
                        });

                        if (vm.imagesToSend.length === images.length) {
                            openModalToSendImages().then(function (filesToSend) {
                                if (vm.currentConversation.platform == communicationConstants.SOCIAL_MEDIAS.WATI) {
                                    filesToSend.forEach(function (fileToSend) {
                                        sendMediaMessageToWhatsapp(vm.currentConversation.chatUserId,
                                            {
                                                data: fileToSend.base64,
                                                mimeType: fileToSend.mimeType,
                                                caption: fileToSend.name,
                                                fullData: fileToSend,
                                                blob: fileToSend.blob
                                            }, fileToSend.type, fileToSend.name);
                                    });
                                } else {
                                    filesToSend.forEach(function (fileToSend) {
                                        sendMediaMessageToFacebook(fileToSend);
                                    });
                                }
                            });
                        }
                    };
                    img.src = reader.result;
                }
            });
        }

        function assignChatTicketToMeIfNeeded() {
            ChatTicketService.assignTicketToAttendant(vm.currentConversation.chatTicketId, $localStorage.userId)
                .then(function (result) {
                    toastr.info($translate.instant('communication.info.assigned-to-you'));
                });
        }

        vm.updateMessageText = function() {
            var inputMessage = document.getElementById('message-input');
            if (inputMessage) {
                inputMessage.innerText = vm.text;
            }
        }

        vm.collectText = function(event) {
            vm.text = event.target.innerText;
        }

        vm.pasteText = function (event) {
            setTimeout(function() {
                vm.text = event.target.innerText;
                var keyup = new KeyboardEvent('keyup',{'bubbles':true});
                document.getElementById('message-input').dispatchEvent(keyup);
            }, 0);
        }

        function refreshWithTextMessage(messageToSend) {
            var userId = vm.currentConversation.chatUserId;
            var index = vm.conversationsList.findIndex(function (value) {
                return value.chatUserId == userId;
            });

            vm.openedMessages.push(messageToSend);

            vm.conversationsList = array_move(vm.conversationsList, index, 0);
            vm.conversationsList[0].lastMessage = angular.copy(vm.text);
            vm.conversationsList[0].lastMessageDate = new Date().getTime();
            vm.conversationsList[0].messageType = 'text';
            updateConversationData(vm.currentConversation.chatUserId, $localStorage.userId, vm.text);
            clearTextMessage();
            scrollToBottom();
            vm.isSendLocation = false;
            setTimeout(function () {
                document.getElementById('message-input').focus();
            });

            vm.closeMessageToReply();
        }

        function setAttendantName() {
            if (vm.chatConfiguration.enableSenderName) {
                var attendant = vm.usersAttendants.find(function (user) {
                    return user.id === $localStorage.userId;
                });
                if (attendant) {
                    vm.text = '*'.concat(attendant.firstName).concat(' ')
                        .concat(attendant.lastName.split(' ')[0]).concat(':*')
                        .concat('\n')
                        .concat('\n')
                        .concat(vm.text);
                }
            }
        }

        /**
         * Sends message to any person by number Whatsapp.
         */
        vm.sendTextMessage = function () {
            if(vm.recording) {
                vm.stopRecord();
                return
            }
            vm.discardAudio();

            if (vm.text && vm.text.length > 4096) {
                return;
            }

            if (!vm.text || (vm.text && !vm.text.trim())) {
                clearTextMessage();
                return;
            }

            if (vm.currentConversation.attendantId !== $localStorage.userId) {
                assignChatTicketToMeIfNeeded();
            }

            setAttendantName();

            var messageToSend = vm.text;
            var messageToReply = vm.messageToReply;

            var messageToSendData = {
                owner: true,
                text: messageToSend,
                type: communicationConstants.TYPES.TEXT.toLowerCase(),
                created: new Date().getTime(),
                replySourceMessage: messageToReply,
                isSending: true
            }

            refreshWithTextMessage(messageToSendData);

            switch (vm.currentConversation.platform) {
                case communicationConstants.SOCIAL_MEDIAS.INSTAGRAM:
                case communicationConstants.SOCIAL_MEDIAS.MESSENGER:
                     MessengerService.sendMessage(
                         messageToSend, vm.currentConversation.chatUserId
                     ).then(function (result) {
                         messageToSendData.isSending = false;
                     }).catch(function (error) {
                        vm.isSendLocation = false;
                        toastr.warning($translate.instant('communication.errors.facebookInstagramConfiguration'));
                    });
                    break;
                case communicationConstants.SOCIAL_MEDIAS.WATI:
                    WatiService.sendMessage({
                        number: vm.currentConversation.chatUserId,
                        text: messageToSend,
                        type: communicationConstants.TYPES.TEXT.toLowerCase(),
                        time: String(moment().valueOf() / 1000).split('.')[0],
                        attendantId: $localStorage.userId,
                        replyContextId: messageToReply ? messageToReply.id : null
                    }).then(function () {
                        messageToSendData.isSending = false;
                    }).catch(function (error) {
                        vm.isSendLocation = false;
                        if (error.status === 500) toastr.warning($translate.instant('communication.errors.problemSendingMessage'));
                        else if (error.status === 400) toastr.warning($translate.instant('communication.errors.argumentInvalid'));
                        else if (error.status === -1) toastr.error($translate.instant('communication.errors.connectionProblem'));
                        else toastr.warning($translate.instant('communication.errors.watiConfiguration'));
                    });

                    break;
            }
        }

        function makeMessageInstaOrMessenger(message, socialMedia) {
            var data = {
                id: message.id,
                owner: message.recipientId === message.to.data[0].id,
                timestamp: message.created_time,
                isServer: true
            }

            /** if message contains images or files (pdf, for example) **/
            if (message.attachments) {
                var attachment = message.attachments.data[0];
                data.platform = vm.currentConversation.platform;
                if (attachment.video_data) {
                    var resource = attachment.video_data;
                    data.data = resource.url;
                    data.type = 'video';
                } else {
                    var resource = attachment.image_data ? { type: communicationConstants.TYPES.IMAGE.toLowerCase(), data: attachment.image_data.url } : { type: communicationConstants.TYPES.FILE.toLowerCase(), data: attachment.file_url };
                    data.data = resource.data;
                    data.type = attachment.mime_type && attachment.mime_type.includes('audio') ? 'audio' : resource.type;
                }
            } else if (message.story) {
                data.platform = vm.currentConversation.platform;
                if (message.story.mention) {
                    data.data = message.story.mention.link;
                    data.type = communicationConstants.MESSAGES_TYPES.STORYMENTION;
                } else if (message.story.reply_to) {
                    data.data = message.story.reply_to.link
                    data.type = communicationConstants.MESSAGES_TYPES.STORYREPLY;
                    data.text = message.message;
                }
                vm.getImageFromUrl(data);
            } else if (message.is_unsupported) {
                data.text = $translate.instant('communication.errors.unsupportedMessage');
                data.type = communicationConstants.MESSAGES_TYPES.UNSUPPORTED;
            } else if (message.shares && message.shares.data[0].name) {
                data.text = "Carousel enviado com os produtos: " + message.shares.data[0].name;
                data.type = communicationConstants.MESSAGES_TYPES.TEXT;
            } else if (message.shares && message.shares.data[0].link) {
                data.type = communicationConstants.MESSAGES_TYPES.STICKER;
                data.api = message.shares.data[0].link;
            }
            else {
                data.text = message.message;
                data.type = communicationConstants.MESSAGES_TYPES.TEXT;
            }
            return data;
        }

        vm.fixTimestampFormat = function (timestamp) {
            if (timestamp.length < 28) {
                var timestamArr = timestamp.split(' ');
                return timestamArr[0] + "T" + timestamArr[1] + "+0000"
            }
            return timestamp;
        }

        vm.turnToZero = function (index, socialNetwork) {
            switch (socialNetwork) {
                case communicationConstants.SOCIAL_MEDIAS.MESSENGER:
                    vm.allMessengerMessages -= vm.conversationsList[index].unreadMessages || 0;
                    vm.allMessengerMessages = vm.allMessengerMessages < 0 ? 0 : vm.allMessengerMessages;
                    break;
                case communicationConstants.SOCIAL_MEDIAS.INSTAGRAM:

                    vm.allInstaMessages -= vm.conversationsList[index].unreadMessages || 0;
                    vm.allInstaMessages = vm.allInstaMessages < 0 ? 0 : vm.allInstaMessages;
                    break;
                case communicationConstants.SOCIAL_MEDIAS.WATI:
                    vm.allWatiMessages -= vm.conversationsList[index].unreadMessages || 0;
                    vm.allWatiMessages = vm.allWatiMessages < 0 ? 0 : vm.allWatiMessages;
                    break;
            }
            vm.conversationsList[index].unreadMessages = 0;
        }

        vm.getCountdownPercentage = function () {
            var hours = vm.currentConversation.hours * 60;
            hours = hours + vm.currentConversation.minutes;
            vm.currentConversation.percentage = (Math.floor((100 * hours) / 1440)).toFixed(0);
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }

        vm.updateCountdown = function (should_decrease) {
            if (should_decrease) {
                vm.currentConversation.time = vm.currentConversation.time - oneMinuteInMiliseconds;
            }

            var minutes = Math.floor((vm.currentConversation.time / (1000 * 60)) % 60),
                hours = Math.floor((vm.currentConversation.time / (1000 * 60 * 60)) % 24);


            vm.currentConversation.hours = hours < 0 ? 0 : hours;
            vm.currentConversation.minutes = minutes < 0 ? 0 : minutes;

            vm.currentConversation.currentConversationTime = vm.currentConversation.hours + ':' + vm.currentConversation.minutes.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
            vm.getCountdownPercentage();
        }

        function resetTimer() {
            vm.currentConversation.time = vm.startingTime * oneHourInMilliseconds - 1;
            vm.updateCountdown(false)
        }

        function getMetaMessages(conversation) {
            MessengerService.findMessages(conversation.conversationId).then(function (messages) {
                vm.loadingMessages = false;
                vm.showSkeleton = false;

                vm.currentConversation.paging = messages.paging;
                vm.currentConversation.lastIncomingDate = messages.lastIncomingDate;
                vm.openedMessages = messages.data.reverse().map(function (message) {
                    message.recipientId = String(conversation.chatUserId);
                    var data = makeMessageInstaOrMessenger(message, conversation.platform);
                    if (message.story) {
                        vm.getImageFromUrl(data);
                    }
                    return data;
                });

                makeDateInfo();

                var index = vm.conversationsList.findIndex(function (value) {
                    return value.chatUserId == vm.currentConversation.chatUserId;
                })
                if (index > -1) {
                    vm.turnToZero(index, vm.currentConversation.platform);
                }
                setTimeout(function () {
                    document.getElementById('message-input').focus();
                    if ($localStorage.redirectNotificationData) {
                        $localStorage.redirectNotificationData = null;
                    }
                    scrollToBottom();
                }, 500);
                setTimer();
                scrollToBottom();
            }).catch(function (err) {
                vm.loadingMessages = false;
                vm.showSkeleton = false;
            });

            getCustomerByFbOrInstagram(conversation);
        }

        function getWATIMessages() {
            WatiService.findMessagesByNumber({ number: vm.currentConversation.conversationId, pageSize: communicationConstants.PAGE_SIZE.MESSAGES, lastId: vm.lastMessageId }).then(function (result) {
                if (!result.data.ok) {
                    vm.openedMessages = [];
                    toastr.warning($translate.instant('communication.errors.invalidWhatsappNumber'));
                    vm.loadingMessages = false;
                    vm.showSkeleton = false;
                    return;
                }

                var reversedMessages = result.data.result.items ? result.data.result.items.reverse() : [];

                vm.lastMessageId = reversedMessages.length > 0 ? reversedMessages[0].id : null;

                var filtered = reversedMessages.filter(function(message) { 
                    return (!isNullOrUndefined(message.text) && message.text.length > 0) 
                        || message.eventType === "message"
                        || message.eventType === "broadcastMessage"
                        || message.eventType === "sessionMessageSent";
                })

                vm.openedMessages = angular.copy(filtered.filter(function (message) {
                        message.isServer = true;
                        manageMediaMessageFromWATI(message);
                        if (message.replySourceMessage) {
                            message.replySourceMessage.isServer = true;
                            manageMediaMessageFromWATI(message.replySourceMessage, true);
                        }
                        return message;
                    })
                );
                makeDateInfo();
                IndexedDBCommunication.getSendingFileByConversatonId(vm.currentConversation.conversationId, function (sendingFiles) {
                    if($localStorage.failedMessages && $localStorage.failedMessages[storeId]
                        && $localStorage.failedMessages[storeId][vm.currentConversation.chatUserId])
                        vm.failedMessages = $localStorage.failedMessages[storeId][vm.currentConversation.chatUserId];

                    getPendingFilesSending(sendingFiles);

                    vm.loadingMessages = false;
                    vm.showSkeleton = false;
                    setTimeout(function () {
                        document.getElementById('message-input').focus();
                        if ($localStorage.redirectNotificationData) {
                            $localStorage.redirectNotificationData = null;
                        }
                        scrollToBottom();
                    }, 500);
                    setTimer();
                })
            }).catch(function () {
                vm.loadingMessages = false;
                vm.showSkeleton = false;
            });
            getCustomerByWati(vm.currentConversation);
        }

        function getPendingFilesSending(sendingFiles) {
            if (sendingFiles.length > 0) {
                sendingFiles.forEach(function (sendingFile) {
                    var message = _.find(vm.openedMessages, function (message) {
                        return sendingFile.localMessageId === message.localMessageId;
                    });

                    if (message) {
                        if (message.type === 'document' || message.type === 'image' || message.type === 'video') {
                            IndexedDBCommunication.getSendingFileByLocalMessageId(message.localMessageId, function (result) {
                                if (result !== null) {
                                    IndexedDBCommunication.removeSendingFile(result.id, function (){});
                                }
                            });
                        }
                    } else  {
                        var openedMessagesCopy = angular.copy(vm.openedMessages);
                        var previousMessageIndex = _.findIndex(openedMessagesCopy, function (previousMessage) {
                            return previousMessage.id === sendingFile.lastMessageId
                                || previousMessage.localMessageId === sendingFile.lastMessageId;
                        });

                        if (sendingFile.status === 'CANCELED') {
                            sendingFile.message.failedToSend = true;
                            sendingFile.message.loadingDownload = false;
                        }

                        sendingFile.message.localMessageId = sendingFile.localMessageId;

                        vm.openedMessages.splice(previousMessageIndex + 1, 0, sendingFile.message);
                    }
                });

                vm.loadingMessages = false;
                vm.showSkeleton = false;
                scrollToBottom();
            }
        }

        function clearTextMessage() {
            var inputMessage = document.getElementById('message-input');

            if (inputMessage) {
                inputMessage.innerText = ''
            }
            vm.text = '';
        }

        /**
         * Sets value the variable {vm.currentConversation}.
         * @param {*} conversationId
         */
        vm.openConversation = function (conversation) {
            if (vm.loadingMessages || !conversation) {
                return;
            }

            if (vm.recording)
                vm.discardAudio();
            if (vm.selectMultipleMessages)
                vm.closeMessageSelection();
            if (vm.replyMessage)
                vm.closeMessageToReply();

            clearTextMessage();
            vm.failedMessages = [];
            changeMobileFlow('chatConversation');
            vm.currentConversation = conversation;
            vm.pageNumber = 1;
            vm.currentCustomer = {};
            vm.currentAttendant = null;
            vm.loadingMessages = true;
            vm.showSkeleton = true;
            vm.isEditMode = false;
            vm.openedMessages = [];
            switch (vm.currentConversation.platform) {
                case communicationConstants.SOCIAL_MEDIAS.MESSENGER:
                case communicationConstants.SOCIAL_MEDIAS.INSTAGRAM:
                    if (conversation.conversationId) {
                        getMetaMessages(conversation);
                    } else {
                        vm.openedMessages = vm.messenger[conversation.conversationId].messages;
                        vm.failedMessages = $localStorage.failedMessages[storeId][vm.currentConversation.number];
                        makeDateInfo();
                        scrollToBottom();
                    }
                    getCurrentAttendant();

                    break;

                case communicationConstants.SOCIAL_MEDIAS.WATI:
                    vm.lastMessageId = null;
                    var callback = function () {
                        getWATIMessages();
                    }
                    callback();

                    getCurrentAttendant();
                    var index = vm.conversationsList.findIndex(function (value) {
                        return value.conversationId == vm.currentConversation.conversationId;
                    })
                    if (index > -1) {
                        vm.turnToZero(index, vm.currentConversation.platform);
                    }
                    break;
            }

            NotificationService.updateNotificationsAsReadByStoreIdAndConversationId(
                $localStorage.defaultStore.storeId,
                conversation.conversationId
            ).then(function (data) {
                $rootScope.$emit("UpdateNotificationCount", {});
            }, function (err) {
                $localStorage.redirectNotificationData = null;
                vm.loadingConversations = false;
                vm.loadingMessages = false;
            });
        }

        vm.isConversationWithoutMessages = function () {
            var messages = vm.openedMessages.filter(function (message) {
                return message.type !== RESERVED_TYPE;
            })

            return messages.length === 0 && !vm.hasLoadingActive() && vm.openedMessages.length > 0;
        }

        vm.noMessagesLabel = function () {
            return $translate.instant('communication.no-messages-on-conversation', {username: vm.currentConversation.name});
        }

        function setTimer() {
            if (!vm.currentConversation.lastIncomingDate) return;
            var lastTimestamp = parseInt(vm.currentConversation.lastIncomingDate);
            vm.currentConversation.time = vm.startingTime * oneHourInMilliseconds - (moment().valueOf() - lastTimestamp);

            vm.updateCountdown(false);
            if (vm.interval) {
                clearInterval(vm.interval);
            }

            vm.interval = setInterval(function () {
                if (!vm.currentConversation.lastIncomingDate) return;
                vm.updateCountdown(true)
            }, oneMinuteInMiliseconds);
        }

        vm.loadAudioFile = function (message) {
            if (message.isServer && message.fullData) {
                return message.data + '&token=' + WatiService.replaceWatiToken(vm.watiSetting.watiToken);
            } else if (message.isServer) {
                return WatiService.makeUriToShowImageByWati(vm.watiSetting.watiUri, message.data, vm.watiSetting.watiToken);
            }
            return message.data.fullData ? message.data.fullData.fullBase64 : message.data;
        }

        function getProfilePicFromUrl(conversation) {
            var xhr = new XMLHttpRequest();

            if (!conversation.profilePic) {
                conversation.profilePic = "./assets/images/avatar.png";
                return;
            }

            if (conversation.profilePic == "./assets/images/avatar.png") {
                return;
            }

            xhr.onreadystatechange = function (oEvent) {
                if (xhr.readyState === 4) {
                    if (xhr.status !== 200) {
                        conversation.profilePic = "./assets/images/avatar.png";
                        $scope.$apply();
                    }
                }
            }

            xhr.open('GET', conversation.profilePic);
            xhr.responseType = 'blob';

            try {
                xhr.send()
            } catch (error) {
                console.log(error)
            }
        }

        vm.openFullScreenPreview = function (message) {
            if (!message.failedToSend) {
                vm.messageFullScreen = {
                    isFullScreen:true,
                    message: message
                }
            }
        };

        vm.closeFullScreenPreview = function () {
            vm.messageFullScreen = {
                isFullScreen:false,
                message: null
            }
        };

        vm.getImageFromUrl = function (message) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function (result) {
                    var foundMessage = vm.openedMessages.find(function (messageOnList) {
                        return messageOnList.id === message.id;
                    });
                    foundMessage.storyType = 'video';
                    foundMessage.loadComplete = true;
                    $scope.$apply();
                }
                reader.readAsDataURL(xhr.response);
            };

            xhr.onreadystatechange = function (oEvent) {
                if (xhr.readyState === 4) {
                    if (xhr.status !== 200) {
                        var foundMessage = vm.openedMessages.find(function (messageOnList) {
                            return messageOnList.id === message.id;
                        });
                        foundMessage.storyType = 'image';
                        foundMessage.loadComplete = true;
                        $scope.$apply();
                    }
                }
            }

            xhr.open('GET', message.data);
            xhr.responseType = 'blob';

            try {
                xhr.send()
            } catch (error) {
                console.log(error)
            }
        }

        vm.getUrlImage = function (message) {
            if (message.isServer && message.data && message.data.includes(vm.watiSetting.watiUri)) {
                return message.data;
            }
            if (message.isServer && message.fullData) {
                return message.fullData + '&token=' + WatiService.replaceWatiToken(vm.watiSetting.watiToken);
            } else if (message.isServer) {
                return WatiService.makeUriToShowImageByWati(vm.watiSetting.watiUri, message.data, vm.watiSetting.watiToken);
            }
            return message.data.fullData ? message.data.fullData.fullBase64 : message.data;
        }

        vm.downloadDocument = function (message) {
            if (message.downloadedData) {
                $window.open(message.downloadedData);
            } else {
                message.loadingDownload = true;
                WatiService.findFileByName({ fileName: message.data }).then(function (result) {
                    var blob = new Blob([result.data], { type: result.data.type });
                    var url = $window.URL.createObjectURL(blob);
                    message.downloadedData = url;
                    message.loadingDownload = false;
                });
            }
        }

        vm.downloadMediaFromWATI = function (data) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", data, true);
            xhr.responseType = "blob";
            xhr.onload = function(){
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(this.response);
                var tag = document.createElement('a');
                tag.href = imageUrl;
                tag.download = 'Showkase Image ' + moment().format();
                document.body.appendChild(tag);
                tag.click();
                document.body.removeChild(tag);
            }
            xhr.send();
        }

        /**
         * Gets called when conversation's messages are scrolled to top and updates the shown messages to include older ones.
         */
        vm.messagesScrolledToTop = function () {
            if (vm.loadingMessages || (vm.currentConversation.platform !== 'WATI' && !vm.currentConversation.paging)) {
                return;
            }

            vm.loadingMoreMessages = true;
            if (vm.currentConversation.platform !== communicationConstants.SOCIAL_MEDIAS.WATI) {
                MessengerService.findMessages(vm.currentConversation.conversationId, vm.currentConversation.paging ? vm.currentConversation.paging.cursors.after : null).then(function (messages) {
                    vm.currentConversation.paging = messages.paging;
                    vm.openedMessages = messages.data.reverse().map(function (message) {
                        message.recipientId = String(vm.currentConversation.chatUserId);
                        return makeMessageInstaOrMessenger(message, vm.currentConversation.platform);
                    }).concat(vm.openedMessages);

                    vm.loadingMoreMessages = false;

                    if($localStorage.failedMessages && $localStorage.failedMessages[storeId]
                        && $localStorage.failedMessages[storeId][vm.currentConversation.chatUserId])
                        vm.failedMessages = $localStorage.failedMessages[storeId][vm.currentConversation.chatUserId];
                    makeDateInfo();
                    $timeout(function () {
                        var scroller = document.getElementById("messages-container");
                        if (scroller) {
                            scroller.scrollTop = 200;
                        }
                    }, 0, false);
                });
                return;
            }
            vm.pageNumber = vm.pageNumber + 1;
            WatiService.findMessagesByNumber({ number: vm.currentConversation.conversationId, pageSize: communicationConstants.PAGE_SIZE.MESSAGES, lastId: vm.lastMessageId }).then(function (result) {

                var olderMessages = angular.copy(result.data.result.items ? result.data.result.items.reverse().filter(function (message) {
                    message.isServer = true;

                    if (message.replySourceMessage) {
                        message.replySourceMessage.isServer = true;
                        manageMediaMessageFromWATI(message.replySourceMessage, true);
                    }

                    manageMediaMessageFromWATI(message);
                    return message;
                }) : []);

                vm.openedMessages = olderMessages.concat(vm.openedMessages);

                vm.openedMessages = vm.openedMessages.filter(function(message) { 
                    return (!isNullOrUndefined(message.text) && message.text.length > 0) 
                        || message.eventType === "message"
                        || message.eventType === "broadcastMessage"
                        || message.eventType === "sessionMessageSent";
                });

                vm.openedMessages.forEach(function(message) {
                    manageMediaMessageFromWATI(message);
                });

                vm.loadingMoreMessages = false;

                if($localStorage.failedMessages && $localStorage.failedMessages[storeId]
                    && $localStorage.failedMessages[storeId][vm.currentConversation.chatUserId]) {
                        vm.failedMessages = $localStorage.failedMessages[storeId][vm.currentConversation.chatUserId];
                }

                if (olderMessages && olderMessages[0]) {
                    vm.lastMessageId = olderMessages[0].id;
                } else {
                    return;
                }

                makeDateInfo();

                $timeout(function () {
                    var scroller = document.getElementById("messages-container");
                    if (scroller) {
                        scroller.scrollTop = 200;
                    }
                }, 0, false);
            })
        }

        function getFileNameFromUrl(value) {
            if (!value) {
                return "";
            }

            var fileName = "";

            if (value.includes("fileName=") && value.includes(".opus")) {
                var aux = value.split('fileName=')[1];
                fileName = aux.split('.opus')[0] + '.opus';
            } else if (value.includes("fileName=") && value.includes(".mp3")) {
                var aux = value.split('fileName=')[1];
                fileName = aux.split('.mp3')[0] + '.mp3';
            } else if (value.includes("fileName=") && value.includes("?")) {
                var aux = value.split('fileName=')[1];
                fileName = aux.split('?')[0];
            } else if (value.includes("fileName=")) {
                fileName = value.split('fileName=')[1];
            } else {
                fileName = value;
            }

            return fileName;
        }

        function manageMediaMessageFromWATI(message, isReply) {
            switch (message.type) {
                case communicationConstants.TYPES.IMAGE.toLowerCase():
                    message.data = vm.getUrlImage(message);
                    break;
                case communicationConstants.TYPES.STICKER.toLowerCase():
                    if (message.data.includes('/data')) {
                        message.data = message.data.replace('/data', 'data');
                    }
                    message.api = vm.stickersApi.replace("data_default/stickers/{name}", message.data);
                    break;
                case communicationConstants.TYPES.AUDIO.toLowerCase():
                    var fileName = getFileNameFromUrl(message.data);
                    if (message.isServer) {
                        message.loadingDownload = true;
                    }
                    WatiService.findAudioFileByName({ fileName: fileName }).then(function (result) {
                        if (result && result.data) {
                            var foundMessage = _.find(vm.openedMessages, function (openedMessage) {
                                return openedMessage.id === message.id;
                            });

                            if (foundMessage) {
                                message = foundMessage;
                            }

                            var blob = new Blob([result.data], {
                                type: 'audio/mp3'
                            });

                            var url = URL.createObjectURL(blob);

                            if (isReply) {
                                document.getElementById('reply-' + message.id).src = url;
                            } else {
                                document.getElementById(message.id).src = url;
                            }

                            message.loadingDownload = false;
                        }
                    });

                    break;
                case communicationConstants.TYPES.VIDEO.toLowerCase():
                    if (message.data.includes('/data')) {
                        message.data = message.data.replace('/data', 'data');
                    }

                    if (message.data && message.data.includes(vm.watiSetting.watiUri)) {
                        break;
                    }

                    message.data = WatiService.makeUriToShowVideoByWati(vm.watiSetting.watiUri, message.data, vm.watiSetting.watiToken);
                    break;
                default:
                    break;
            }

            if (message.eventType == 'broadcastMessage') {
                message.type = 'broadcastMessage';
                message.text = message.finalText;
                if (message.template && message.template.header) {
                    if (message.template.header.type === 2) {
                        message.data = message.template.header.link !== '' ? message.template.header.link
                            : WatiService.makeUriToShowImageByWati(vm.watiSetting.watiUri,
                                'data/images/' + message.template.header.mediaFromPC, vm.watiSetting.watiToken);
                    } else if (message.template.header.type === 3) {
                        message.data = message.template.header.link !== '' ? message.template.header.link
                            : WatiService.makeUriToShowImageByWati(vm.watiSetting.watiUri,
                                'data/videos/' + message.template.header.mediaFromPC, vm.watiSetting.watiToken);
                    } else if (message.template.header.type === 4) {
                        message.data = message.template.header.link !== '' ? message.template.header.link
                            : 'data/documents/' + message.template.header.mediaFromPC;
                    }
                }
                message.owner = true;
            }

            if (message.statusString === 'FAILED') {
                message.failedToSend = true;
            }
        }

        function makeDateInfo() {
            vm.openedMessages = vm.openedMessages.filter(function (item) {
                return item.type != RESERVED_TYPE
            });
            vm.openedMessagesAux = angular.copy(vm.openedMessages);
            var changedOne = false;

            if (vm.openedMessagesAux.length === 0) {
                vm.openedMessages.push({ type: RESERVED_TYPE, value: getDayLabel(moment().valueOf()) });
                return;
            }

            var dateToConsider = vm.openedMessagesAux[0].created
                ? parseInt(vm.openedMessagesAux[0].created)
                : parseInt(vm.openedMessagesAux[0].timestamp);
            var dateToConsiderFormatted = moment(dateToConsider).format(FORMAT_DATE);

            var listResult = [];
            vm.openedMessagesAux.forEach(function (message, index) {
                var currentMessageDate = moment(message.created ? parseInt(message.created) : parseInt(message.timestamp)).format(FORMAT_DATE);
                if (dateToConsiderFormatted !== currentMessageDate) {
                    dateToConsider = message.created ? message.created : message.timestamp;
                    listResult.push({ type: RESERVED_TYPE, value: getDayLabel(dateToConsider) });
                    dateToConsiderFormatted = currentMessageDate;
                    changedOne = true;
                }
                listResult.push(message);

            });

            if ((vm.openedMessagesAux[0].timestamp || vm.openedMessagesAux[0].created)) {
                listResult.unshift({ type: RESERVED_TYPE, value: getDayLabel(vm.openedMessagesAux[0].created
                        ? vm.openedMessagesAux[0].created
                        : vm.openedMessagesAux[0].timestamp) });
            }

            vm.openedMessages = angular.copy(listResult);
        }

        vm.getMessageDayLabel = function (date) {
            return getDayLabel(date, true)
        }

        vm.zoomImage = function (e) {
            var image = $(e.currentTarget);

            if (image.hasClass('zoomed')) {
                image.removeClass('zoomed');
                image[0].style.cursor = 'zoom-in';
            } else {
                image.addClass('zoomed');
                image[0].style.cursor = 'zoom-out';
            }
        }

        vm.moveZoomedImage = function (e){
            var image = $(e.currentTarget);

            var percentX = ((e.pageX - image[0].offsetLeft) / image[0].offsetWidth) * 100;
            var percentY = ((e.pageY - image[0].offsetTop) / image[0].offsetHeight) * 100;

            image.css({
                'transform-origin': percentX + '%' + ' ' + percentY + '%',
            });
        }

        function getDayLabel(date, isFromConversationList) {
            date = parseInt(date);
            var today = moment();
            var messageDate = moment(date);

            if (today.diff(messageDate, 'days') < 7) {
                if (moment(messageDate).isSame(moment(), "day")) {
                    return isFromConversationList
                        ? moment(date).format(FORMAT_TIME)
                        : $translate.instant('communication.days.today');
                } else if (messageDate.isSame(today.subtract(1, 'days').startOf('day'), 'day')){
                    return $translate.instant('communication.days.yesterday');
                }
                return messageDate.format('dddd');
            }

            return moment(date).format(FORMAT_DATE);
        }

        /**
         * Gets called when sticker picker is scrolled to bottom
         */
        vm.stickersScrolledToBottom = function () {
            vm.stickersPageNumber = vm.stickersPageNumber + 1;
            WatiService.findStickers({ pageNumber: vm.stickersPageNumber, pageSize: 9 }).then(function (result) {
                result.data.items.map(function (sticker) {
                    sticker.api = vm.stickersApi.replace("data_default/stickers/{name}", sticker.content.slice(1))
                    vm.stickers.push(sticker);
                })
            });
        }

        /**
         * Config the chat of Instagram and Messenger.
         */
        function configSubscriberInstaMessenger(chatConversation, message) {
            var index = vm.conversationsList.findIndex(function (value) {
                return value.conversationId == chatConversation.conversationId;
            })
            var data = { text: chatConversation.lastMessage, type: communicationConstants.MESSAGES_TYPES.TEXT, owner: false };

            if (!vm.conversations.get(chatConversation.conversationId)) {
                vm.messenger[chatConversation.conversationId] = { messages: [data] };

                if (verifySelectedFilters(vm.filters)) {
                    vm.allMessengerMessages += 1;
                }
                vm.conversationsList.unshift(chatConversation);
                vm.conversations.set(String(chatConversation.conversationId), chatConversation);

                makeDateInfo();
                receiveMessage(chatConversation);

            } else if (String(vm.currentConversation.conversationId) === String(chatConversation.conversationId)) {
                resetTimer();
                vm.turnToZero(index, chatConversation.platform);
                var messageData = {
                    isSource: false,
                    text: chatConversation.lastMessage,
                    type: chatConversation.lastMessage ? communicationConstants.TYPES.TEXT.toLowerCase() : message.messaging[0].message.attachments[0].type,
                    created: chatConversation.lastMessageDate,
                    isServer: true,
                    socialMediaName: chatConversation.platform
                };

                if (vm.attachmentTypes.includes(messageData.type)) {
                    messageData.data = message.messaging[0].message.attachments[0].payload.url;
                } else if (messageData.type !== communicationConstants.TYPES.TEXT.toLowerCase()) {
                    messageData.text = $translate.instant('communication.errors.unsupportedMessage');
                    messageData.type = communicationConstants.MESSAGES_TYPES.UNSUPPORTED;
                }

                updateMetaConversationData(chatConversation, vm.conversationsList[index]);
                vm.conversationsList[index].unreadMessages = 0;
                chatConversation.unreadMessages = 0
                vm.messenger[chatConversation.conversationId].messages.push(messageData);
                vm.openedMessages.push(messageData);
                receiveMessage(vm.currentConversation)
                makeDateInfo();
                scrollToBottom();
            } else {
                var messageData = {
                    isSource: false,
                    text: chatConversation.lastMessage,
                    type: communicationConstants.MESSAGES_TYPES.TEXT,
                    created: chatConversation.lastMessageDate,
                    fullData: message,
                };
                if (!vm.conversations.get(String(chatConversation.conversationId)).conversationId) {
                    vm.messenger[chatConversation.conversationId].messages.push(messageData);
                }

                receiveMessage(vm.conversationsList[index]);

                vm.conversationsList = array_move(vm.conversationsList, index, 0);
                updateMetaConversationData(chatConversation, vm.conversationsList[0]);
                if (verifySelectedFilters(vm.filters)) {
                    vm.allMessengerMessages += 1;
                }
            }

            if (vm.conversations.get(String(chatConversation.conversationId))) {
                vm.conversations.get(String(chatConversation.conversationId)).lastMessage = chatConversation.lastMessage;
            }

            if (String(vm.currentConversation.conversationId) !== String(chatConversation.conversationId) ) {
                if (chatConversation.platform === communicationConstants.SOCIAL_MEDIAS.MESSENGER) {
                    if (!verifySelectedFilters(vm.filters)) {
                        updateUnreadMessagesBySocialMedia(communicationConstants.SOCIAL_MEDIAS.MESSENGER);
                    } else {
                        vm.allMessengerMessages += chatConversation.unreadMessages;
                    }
                } else {
                    if (!verifySelectedFilters(vm.filters)) {
                        updateUnreadMessagesBySocialMedia(communicationConstants.SOCIAL_MEDIAS.INSTAGRAM);
                    } else {
                        vm.allInstaMessages += chatConversation.unreadMessages;
                    }
                }

            }
            $scope.$apply()
        }

        function updateMetaConversationData(conversationSource, conversationEnd) {
            conversationEnd.text = conversationSource.lastMessage;
            conversationEnd.lastMessage = conversationSource.lastMessage;
            conversationEnd.unreadMessages = conversationSource.unreadMessages;
            conversationEnd.lastMessageDate = moment(conversationSource.lastMessageDate).valueOf();
            conversationEnd.lastIncomingDate = moment(conversationSource.lastIncomingDate).valueOf();
            conversationEnd.status = conversationSource.status;
        }

        /**
         * Subscribe on socket to receive notification of the Messenger.
         */
        function subscribeOnMessenger(message) {
            if (vm.currentSocialMedia !== 'ALL' && vm.currentSocialMedia !== communicationConstants.SOCIAL_MEDIAS.MESSENGER) {
                return;
            }

            var chatConversation = {
                conversationId: message.userSocialMediaId,
                chatUserId: message.messaging[0].sender.id,
                name: message.messaging[0].sender.name,
                profilePic: message.messaging[0].sender.profilePic,
                lastMessage: message.messaging[0].message.text || '',
                messageType: 'text',
                chatTicketId: message.chatTicketId,
                unreadMessages: message.chatUnreadMessage.unreadMessages,
                platform: communicationConstants.SOCIAL_MEDIAS.MESSENGER,
                lastIncomingDate: message.time,
                lastMessageDate: message.time,
                status: communicationConstants.CHAT_STATUS.NEW
            }

            configSubscriberInstaMessenger(chatConversation, message)
        }

        /**
         * Subscribe on socket to receive notification of the Instagram.
         */
        function subscribeOnInstagram(message) {
            if (vm.currentSocialMedia !== 'ALL' && vm.currentSocialMedia !== communicationConstants.SOCIAL_MEDIAS.INSTAGRAM) {
                return;
            }
            var chatConversation = {
                conversationId: message.userSocialMediaId,
                chatUserId: message.messaging[0].sender.id,
                name: message.messaging[0].sender.name,
                profilePic: message.messaging[0].sender.profilePic,
                lastMessage: message.messaging[0].message.text || '',
                messageType: 'text',
                chatTicketId: message.chatTicketId,
                unreadMessages: message.chatUnreadMessage.unreadMessages,
                platform: communicationConstants.SOCIAL_MEDIAS.INSTAGRAM,
                lastIncomingDate: message.time,
                lastMessageDate: message.time,
                status: communicationConstants.CHAT_STATUS.NEW
            }

            configSubscriberInstaMessenger(chatConversation, message);
        }

        function updateUnreadMessagesBySocialMedia(socialMedia) {
            ChatTicketService.getSumBySocialMediaName(socialMedia).then(function (result) {
                switch (socialMedia) {
                    case communicationConstants.SOCIAL_MEDIAS.WATI:
                        vm.allWatiMessages = parseInt(result.sum) || 0;
                        break;
                    case communicationConstants.SOCIAL_MEDIAS.MESSENGER:
                        vm.allMessengerMessages = parseInt(result.sum) || 0;
                        break
                    case communicationConstants.SOCIAL_MEDIAS.INSTAGRAM:
                        vm.allInstaMessages = parseInt(result.sum) || 0;
                        break;
                }

            });
        }


        /**
         * Subscribe on socket to receive notification of the Wati.
         */
        function subscribeOnWhatsapp(message) {
            if (vm.currentSocialMedia !== 'ALL' && vm.currentSocialMedia !== communicationConstants.SOCIAL_MEDIAS.WATI) {
                return;
            }
            var index = vm.conversationsList.findIndex(function (value) {
                return value.conversationId == message.conversationId;
            });

            if (!vm.conversations.has(message.conversationId)) {
                var chatConversation = {
                    conversationId: message.conversationId,
                    chatUserId: message.waId,
                    name: message.senderName ? message.senderName : message.waId,
                    platform: communicationConstants.SOCIAL_MEDIAS.WATI,
                    unreadMessages: message.owner || message.type === 'template' ? 0 : 1,
                    chatTicketId: message.chatTicketId,
                    lastMessage: message.listReply ? message.listReply.title : message.text,
                    messageType: 'text',
                    lastIncomingDate: message.owner || message.type === 'template' ? null : message.timestamp,
                    lastMessageDate: message.timestamp,
                    isFavorite: false,
                    status: message.type !== 'template' ? communicationConstants.CHAT_STATUS.NEW : vm.conversationsList[0].status
                };
                vm.conversationsList.unshift(chatConversation);
                vm.conversations.set(message.conversationId, chatConversation);
                if (!verifySelectedFilters(vm.filters)) {
                    updateUnreadMessagesBySocialMedia(communicationConstants.SOCIAL_MEDIAS.WATI);
                } else {
                    vm.allWatiMessages = vm.allWatiMessages + 1;
                }
            } else {
                if (!(message.owner || message.type === 'template')) {
                    vm.conversationsList[index].unreadMessages = parseInt(vm.conversationsList[index].unreadMessages) + 1;
                }
                if (vm.currentConversation.conversationId !== message.conversationId) {
                    if (!verifySelectedFilters(vm.filters)) {
                        updateUnreadMessagesBySocialMedia(communicationConstants.SOCIAL_MEDIAS.WATI);
                    } else if (!(message.owner || message.type === 'template')) {
                        vm.allWatiMessages = vm.allWatiMessages + 1;
                    }
                } else {
                    if (!(message.owner || message.type === 'template') && message.operatorName && !message.operatorName.toUpperCase().includes('BOT')) resetTimer();
                    vm.conversationsList[0].status = communicationConstants.CHAT_STATUS.OPENED;
                    vm.conversationsList[index].unreadMessages = 0;
                    vm.turnToZero(index, communicationConstants.SOCIAL_MEDIAS.WATI);
                }
                vm.conversationsList = array_move(vm.conversationsList, index, 0);
                vm.conversationsList[0].text = message.text;
                vm.conversationsList[0].lastMessage = message.listReply ? message.listReply.title : message.text;
                vm.conversationsList[0].conversationId = message.conversationId;
                vm.conversationsList[0].lastIncomingDate = message.owner  || message.type === 'template' ? vm.conversationsList[0].lastIncomingDate : message.timestamp;
                vm.conversationsList[0].lastMessageDate = message.timestamp;
                vm.conversationsList[0].status = message.type !== 'template' ? communicationConstants.CHAT_STATUS.NEW : vm.conversationsList[0].status;
                vm.conversationsList[0].messageType = message.type === 'interactive' ? 'text' : message.type;
            }

            var time = timeConverter(message.timestamp);

            if (vm.currentConversation.conversationId == message.conversationId && message) {
                var receivedMessage = {
                    id: message.id,
                    isSource: false,
                    text: message.text ? message.text : '',
                    type: message.type === 'interactive' ? 'text' : message.type,
                    created: time,
                    orderProducts: message.orderProducts,
                    fullData: message.data,
                    isServer: true,
                    owner: message.owner,
                    contacts: message.messageContact
                };
                if (message.listReply) {
                    receivedMessage.text =  message.listReply.title;
                }

                switch (message.type) {
                    case communicationConstants.TYPES.DOCUMENT.toLowerCase():
                        receivedMessage.data = message.data.split('fileName=')[1];
                        IndexedDBCommunication.getSendingFileByFilenameAndConversationId(message.text, vm.currentConversation.conversationId,
                            function (result) {
                                if (result !== null) {
                                    _.remove(vm.openedMessages, function (messageFrom) {
                                        return messageFrom.loadingDownload && (result.localMessageId === messageFrom.localMessageId);
                                    });
                                    IndexedDBCommunication.removeSendingFile(result.id, function () {
                                        vm.openedMessages.push(receivedMessage);
                                    });
                                }
                        });
                        break;
                    case communicationConstants.TYPES.IMAGE.toLowerCase():
                        receivedMessage.data = vm.getUrlImage(receivedMessage);
                        break;
                    case communicationConstants.TYPES.STICKER.toLowerCase():
                        receivedMessage.api = message.data + '&token=' + WatiService.replaceWatiToken(vm.watiSetting.watiToken);
                        break
                    case communicationConstants.TYPES.AUDIO.toLowerCase():
                        var fileName = getFileNameFromUrl(message.data);
                        WatiService.findAudioFileByName({ fileName: fileName }).then(function (result) {
                            if (result && result.data) {

                                var blob = new Blob([result.data], {
                                    type: 'audio/mp3'
                                });

                                var url = URL.createObjectURL(blob);

                                document.getElementById(message.id).src = url;

                            }
                        });
                        break
                    default:
                        break;
                }

                if (!receivedMessage.owner || message.operatorName && message.operatorName.toUpperCase().includes('BOT')) {
                    vm.openedMessages.push(receivedMessage);
                }
                scrollToBottom();
            }

            if (vm.openChatAfterForwardMessages) {
                vm.openChatAfterForwardMessages = false;
                vm.openConversation(vm.conversationsList[0]);
            }

            vm.conversations.get(message.conversationId).text = message.listReply ? message.listReply.title : message.text;

            receiveMessage(vm.conversationsList[0]);

            $scope.$apply();
        }

        $scope.$watch('vm.allWatiMessages', function (newVal, oldVal) {
            vm.allMessages += (newVal - oldVal);
            $rootScope.$emit('$countMessages', vm.allMessages);
        });

        $scope.$watch('vm.allInstaMessages', function (newVal, oldVal) {
            vm.allMessages += (newVal - oldVal);
            $rootScope.$emit('$countMessages', vm.allMessages);
        });

        $scope.$watch('vm.allMessengerMessages', function (newVal, oldVal) {
            vm.allMessages += (newVal - oldVal);
            $rootScope.$emit('$countMessages', vm.allMessages);
        });

        function removeNine(numberWithNine) {
            return numberWithNine.slice(1, 5) + numberWithNine.slice(6, numberWithNine.length)
        }

        /**
         * Opens the modal to start new conversation.
         */
        vm.openNewConversationModal = function () {
            vm.recommendationModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/communication/new-conversation-modal/new-conversation-modal.html',
                controller: 'NewConversationController',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    watiSetting: function () {
                        return vm.watiSetting;
                    }
                },
                keyboard: false
            }).result.then(function (response) {
                if (response) {
                    var id = String(response.user);
                    if (response.type === 'wati') {
                        if (vm.currentConversation.chatUserId === id.slice(1, id.length) || removeNine(id) === vm.currentConversation.chatUserId) {
                            var messageData = {
                                text: response.message.bodyOriginal,
                                owner: true,
                                type: 'text',
                                created: moment().valueOf()
                            };
                            vm.openedMessages.push(messageData);
                        }
                    } else {
                        if (String(vm.currentConversation.chatUserId) === String(id)) {
                            var messageData = {
                                text: response.message,
                                owner: true,
                                type: 'text',
                                created: moment().valueOf()
                            };
                            vm.openedMessages.push(messageData);
                        }
                    }
                }
            });
        }

        vm.openBagChatModal = function () {
            vm.bagChatModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/communication/bag-chat-modal/bag-chat.html',
                controller: 'BagChatController',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                controllerAs: 'vm',
                resolve: {
                    currentCustomer: function () {
                        return vm.currentCustomer
                    },
                    currentSellerId: function () {
                        return $localStorage.userId
                    }
                },
                keyboard: false
            }).result.then(function (response) {
                if (response) {
                    vm.text = communicationConstants.TEMPLATE_MESSAGE_RECOMMENDATION.replace('{url}', response.url);
                    vm.updateMessageText()
                    toastr.success('Mala pronta para envio');
                }
            });
        };

        vm.openLocationChatModal = function () {
            vm.bagChatModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/communication/location-chat-modal/location-chat.html',
                controller: 'LocationChatController',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                controllerAs: 'vm',
                keyboard: false
            }).result.then(function (response) {
                if (response) {
                    vm.text = response;
                    vm.isSendLocation = true;
                    vm.sendTextMessage();
                }
            });
        };

        vm.openSingleProductsModal = function () {
            vm.singleProductsModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/communication/single-products/single-products.html',
                controller: 'SingleProductController',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                controllerAs: 'vm',
                resolve: {
                    conversation: function () {
                        return vm.currentConversation
                    },
                    currentCustomer: function () {
                        return vm.currentCustomer
                    }
                },
                keyboard: false
            }).result.then(function (response) {
                if (response) {
                    var index = vm.conversationsList.findIndex(function (value) {
                        return value.conversationId === vm.currentConversation.conversationId;
                    });
                    var lastMessage = '';
                    if (response.isCarousel) {
                        response.flyers = response.flyers.slice(0, 15);
                        var messageData = {
                            flyers: response.flyers,
                            owner: true,
                            type: communicationConstants.MESSAGES_TYPES.CAROUSEL,
                            created: moment().valueOf()
                        };
                        var title = '';
                        response.flyers.forEach(function (flyer) {
                            var price = flyer.finalValue ? flyer.finalValue : flyer.purchaseValue
                            title = flyer.name + ' - R$ ' + price.toLocaleString('pt-br', { minimumFractionDigits: 2 });
                            flyer.name = title
                        });
                        lastMessage = title;
                        vm.openedMessages.push(messageData);
                        MessengerService.sendCarousel(response.flyers, vm.currentConversation.chatUserId).then(function (result) {
                            toastr.success('Produtos enviados em modo de carousel');
                        });
                    } else {
                        response.watiMessages.forEach(function (message) {
                            vm.openedMessages.push(message);
                        });
                        lastMessage = response.watiMessages[response.watiMessages.length - 1];
                        scrollToBottom();
                    }

                    vm.conversationsList = array_move(vm.conversationsList, index, 0);
                    vm.conversationsList[0].text = lastMessage;
                    vm.conversationsList[0].lastUpdated = moment().valueOf();
                }
            });
        };

        vm.addEmojiToTextBox = function (emoji) {
            vm.text = vm.text ? vm.text + emoji : emoji;
            vm.updateMessageText()
        }

        vm.setEmojiFilter = function (filter) {
            vm.currentEmojiFilter = filter;
            setFilteredEmojis();
        }

        function setFilteredEmojis(value) {
            if (value) {
                vm.filteredEmojis = {}
                for (var i = 0; i < vm.emojis.length - 1; i++) {
                    if (vm.emojis[i] != undefined && vm.emojis[i].translatedName.includes(value)) {
                        vm.filteredEmojis[vm.emojis[i].code] = vm.emojis[i]
                    }
                }
            } else {
                vm.filteredEmojis = {}
                Object.entries(vm.emojis).map(function (emoji) {
                    if (vm.currentEmojiFilter == "all") {
                        vm.filteredEmojis[emoji[0]] = emoji[1];
                    }
                    if (emoji[1].category == vm.currentEmojiFilter) {
                        vm.filteredEmojis[emoji[0]] = emoji[1];
                    }
                })
            }
        }

        /*
            searchs emojis by typed word
        */
        vm.searchEmoji = function (word) {
            setFilteredEmojis(word)
        }

        vm.sendStickerMessage = function (sticker) {
            sendStickerToWhatsapp(vm.currentConversation.chatUserId,
                { data: sticker.content, mimeType: sticker.media.mimeType, serverFile: true },
                communicationConstants.TYPES.STICKER.toLowerCase(), sticker.content, sticker.api);
        }

        /**
         * deletes a not or a tag
         * @param {the tag id} tagId
         * @param {is true if it's suppose to delete a tag} isTag
         */
        vm.deleteNoteTag = function (tagId, isTag) {
            NoteTagService.deleteNoteTag(tagId).then(function () {
                isTag ?
                    vm.tags = vm.tags.filter(function (value) {
                        return value.id != tagId && value.type == "tag";
                    }) :
                    vm.notes = vm.notes.filter(function (value) {
                        return value.id != tagId && value.type == "note";
                    })
            })
        }

        /**
         * adds a new tag or note to the user
         * @param {the text of the tag that's being created} newNoteTagText
         * @param {is true if it's suppose to add a tag} isTag
         */
        vm.addNoteTag = function (newNoteTagText, isTag) {
            if (newNoteTagText == "" || newNoteTagText == null) {
                toastr.warning('O texto não pode ser vazio');
                return;
            }

            if (vm.isEditingNote == true) {
                NoteTagService.updateNote({ noteId: vm.currentlyEditingNote, text: newNoteTagText }).then(function (result) {
                    for (var i = 0; i < vm.notes.length; i++) {
                        if (vm.notes[i].id == vm.currentlyEditingNote) {
                            vm.notes[i].text = result.text;
                            break;
                        }
                    }
                })
            } else {
                NoteTagService.createNoteTag({
                    "customerId": vm.currentCustomer.id,
                    "text": newNoteTagText,
                    "type": isTag ? "tag" : "note",
                    "createdBy": $localStorage.userId
                }).then(function (result) {
                    result.timestamp = convertToDatePT(result.timestamp.substring(0, 10)) + " " + result.timestamp.substring(11, 16);
                    isTag ? vm.tags.push(result) : vm.notes.push(result);
                });
            }
            isTag ? vm.newTagText = "" : vm.newNoteText = "";

            vm.isWritingNote = false;
            vm.isEditingNote = false;
        }

        vm.startWritingNote = function (isEditingNote, noteId, index) {
            if (isEditingNote) {
                vm.newNoteText = vm.notes[index].text;
            }

            vm.isWritingNote = true;
            vm.isEditingNote = isEditingNote;
            vm.currentlyEditingNote = noteId;
        }

        vm.stopWritingNote = function () {
            vm.newNoteText = "";
            vm.isWritingNote = false;
            vm.isEditingNote = false;
        }

        function loadNotesTags(customerId) {
            NoteTagService.getNotesTags(customerId).then(function (notesTags) {
                vm.notes = notesTags.filter(function (noteTag) {
                    noteTag.timestamp = convertToDatePT(noteTag.timestamp.substring(0, 10)) + " " + noteTag.timestamp.substring(11, 16);
                    if (noteTag.id && noteTag.type == 'note') {
                        return true
                    };
                })

                vm.tags = notesTags.filter(function (noteTag) {
                    if (noteTag.id && noteTag.type == 'tag') {
                        return true
                    };
                });

                vm.loadingCustomerInfos = false;
            }, function (err) {
                vm.loadingCustomerInfos = false;
            });
        }

        //2021-10-01T15:51:08.760+0000
        function convertToDatePT(date) {
            var newDate = date.substring(8, 10) + "/" + date.substring(5, 7) + "/" + date.substring(0, 4)
            return newDate;
        }

        function splitBase64FileIntoChunks(base64String, chunkSize) {
            var totalLength = base64String.length;
            var chunks = [];

            for (var i = 0; i < totalLength; i += chunkSize) {
                var chunk = base64String.slice(i, i + chunkSize);
                chunks.push(chunk);
            }

            return chunks;
        }

        vm.retrySendMediaMessageToWhatsapp = function (message) {
            IndexedDBCommunication.getSendingFileByLocalMessageId(message.localMessageId, function (result) {
                if (result !== null) {

                    _.remove(vm.openedMessages, function (openedMessage) {
                        return openedMessage.localMessageId === result.localMessageId;
                    });

                    IndexedDBCommunication.removeSendingFile(result.id, function () {
                        sendMediaMessageToWhatsapp(vm.currentConversation.chatUserId,
                            message.data, message.type, message.text);
                    });
                }
            });
        }

        /* Sends files, audio, images and stickers to whatsapp*/
        function sendAudioMessageToWhatsapp(number, media, type, text, stickerApi, message) {
            vm.sendMessageBtnLoading = false;
            if(media.fullData && media.fullData.blob) {
                var blob = media.fullData.blob
                delete media.fullData.blob
            }

            var failedMessages = $localStorage.failedMessages ? $localStorage.failedMessages : {};
            var storeMessages = failedMessages[storeId];

            if (!message) {
                var message = {
                    owner: true,
                    text: text,
                    type: type,
                    data: media,
                    isServer: false,
                    created: new Date().getTime(),
                    api: stickerApi,
                    downloadedData: media.blob,
                    loadingDownload: true,
                    loading: true
                };
                if (type == communicationConstants.TYPES.IMAGE.toLowerCase() ||
                    type == communicationConstants.TYPES.VIDEO.toLowerCase()) {
                    message.data = vm.getUrlImage(message);
                } else if (type == communicationConstants.TYPES.AUDIO.toLowerCase()) {
                    message.data = blob;
                }
                vm.openedMessages.push(message);
                clearTextMessage();
                scrollToBottom();
            }

            WatiService.sendMessage({ number: number, text: text, media: media, type: type }).then(function () {
                if (vm.currentConversation.attendantId !== $localStorage.userId) {
                    assignChatTicketToMeIfNeeded();
                }

                if (storeMessages != null && storeMessages[number] != null) {
                    failedMessages[storeId][number] = storeMessages[number].filter(function (m) {
                        return m.media != media;
                    });
                    $localStorage.failedMessages = failedMessages;
                    vm.failedMessages = failedMessages[storeId][number];
                }

                message.loading = false;
                message.loadingDownload = false;
                scrollToBottom();
                updateConversationData(number, $localStorage.userId, text);
                vm.attemptToSendMedia = 0;
            }).catch(function (error) {
                if (vm.attemptToSendMedia === 1) {
                    toastr.warning('Erro ao enviar a mensagem');
                }

                if (vm.attemptToSendMedia < 1) {
                    $timeout(function() {
                        vm.attemptToSendMedia = vm.attemptToSendMedia + 1;

                        if ($window.location.href.includes('communication'))
                        sendAudioMessageToWhatsapp(number, media, type, text, stickerApi, message);
                    }, 2000);
                } else {
                    message.loadingDownload = false;
                    message.failedToSend = true;
                    message.loading = false;
                }
            });
        }

        function getLastMessageId() {
            return vm.openedMessages.length > 1
                ? (vm.openedMessages[vm.openedMessages.length - 2].id
                    ? vm.openedMessages[vm.openedMessages.length - 2].id
                        : vm.openedMessages[vm.openedMessages.length - 2].localMessageId)
                            : null;
        }

        vm.getFailedMessageError = function (message) {
            if (message.type === communicationConstants.TYPES.IMAGE.toLowerCase()) {
                return $translate.instant('communication.errors.imageIsInvalid');
            } else if (message.type === communicationConstants.TYPES.VIDEO.toLowerCase()) {
                return $translate.instant('communication.errors.videoIsInvalid');
            }
        }

        function sendStickerToWhatsapp(number, media, type, text, stickerApi) {
            if (!message) {
                var message = {
                    owner: true,
                    text: text,
                    type: type,
                    data: media,
                    isServer: false,
                    created: new Date().getTime(),
                    api: stickerApi,
                    isSending: true
                };

                vm.openedMessages.push(message);
                vm.text = '';
                vm.updateMessageText()
                scrollToBottom();
            }

            WatiService.sendMessage({ number: number, text: text, media: media, type: type }).then(function () {
                message.loadingDownload = false;
                vm.sendMessageBtnLoading = false;
                message.isSending = false;
                scrollToBottom();
                updateConversationData(number, $localStorage.userId, text);
            }).catch(function (error) {
                toastr.warning('Erro ao enviar a mensagem');
                message.loadingDownload = false;
                message.failedToSend = true;
                message.isSending = false;
            });
        }

        /* Sends files, audio, images and stickers to whatsapp*/
        function sendMediaMessageToWhatsapp(number, media, type, text, stickerApi, message) {
            if(media.fullData && media.fullData.blob) {
                var blob = media.fullData.blob
                delete media.fullData.blob
            }
            var blobSplitted = media.blob.split('/');
            var blobId = blobSplitted[blobSplitted.length - 1];

            if (!message) {
                var message = {
                    owner: true,
                    text: text,
                    type: type,
                    data: media,
                    isServer: false,
                    created: new Date().getTime(),
                    api: stickerApi,
                    localMessageId: blobId,
                    downloadedData: media.blob,
                    loadingDownload: true
                };
                if (type == communicationConstants.TYPES.IMAGE.toLowerCase() ||
                    type == communicationConstants.TYPES.VIDEO.toLowerCase()) {
                    message.data = vm.getUrlImage(message);
                } else if (type == communicationConstants.TYPES.AUDIO.toLowerCase()) {
                    message.data = blob;
                }

                message.sendingProgress = 0;

                vm.openedMessages.push(message);
                clearTextMessage();
                scrollToBottom();

                var lastMessageId = getLastMessageId();

                IndexedDBCommunication.addSendingFiles({
                    message: message,
                    lastMessageId: lastMessageId,
                    conversationId: vm.currentConversation.conversationId,
                    localMessageId: blobId,
                    status: 'SENDING'
                }, function (result) {
                    message.indexedDBId = result;
                    finishFileSending(message, media, blobId);
                });
            } else {
                finishFileSending(message, media, blobId);
            }
        }

        function finishFileSending(message, media, blobId) {
            var base64Chunks = splitBase64FileIntoChunks(media.data, chunkSize);

            var index = 0;
            var messageTime = String(moment().valueOf() / 1000).split('.')[0];
            var conversationId = vm.currentConversation.chatUserId;
            var progressIncrement = Math.floor(100 / base64Chunks.length);

            var chunkData = {
                id: conversationId,
                localMessageId: blobId,
                media: {
                    caption: media.caption,
                    data: base64Chunks[index],
                    mimeType: media.mimeType,
                    isLastChunk: (index + 1 === base64Chunks.length)
                },
                text: media.caption,
                time: messageTime,
                type: message.type
            }

            uploadChunksInOrder(0, message, chunkData, base64Chunks, progressIncrement);
        }

        function uploadChunksInOrder(index, message, chunkData, base64Chunks, progressIncrement) {
            if (index < base64Chunks.length) {
                chunkData.media.isLastChunk = (index + 1 === base64Chunks.length);
                chunkData.media.data = base64Chunks[index];
                var messageFound = _.find(vm.openedMessages, function (messageToFind) {
                    return messageToFind.localMessageId === message.localMessageId;
                });

                WatiService.uploadByChunk(chunkData).then(function (result) {
                    if (index + 1 === base64Chunks.length) {
                        vm.sendMessageBtnLoading = false;
                        if (messageFound) {
                            messageFound.sendingProgress = 100;
                            IndexedDBCommunication.updateSendingFileProgress(message.indexedDBId, 100, function (result) { });
                        }
                        IndexedDBCommunication.updateSendingFileStatus(message.indexedDBId, 'PROCESSING', function (result) { });
                    } else {
                        if (messageFound) {
                            messageFound.sendingProgress = messageFound.sendingProgress + progressIncrement;
                            IndexedDBCommunication.updateSendingFileProgress(message.indexedDBId, messageFound.sendingProgress, function (result) { });
                        }
                    }
                    uploadChunksInOrder(index + 1, message, chunkData, base64Chunks, progressIncrement); // Chame a próxima requisição após o sucesso
                }).catch(function (err) {
                    message.loadingDownload = false;
                    message.failedToSend = true;
                    IndexedDBCommunication.updateSendingFileStatus(message.indexedDBId, 'CANCELED', function (result) { });

                    if (messageFound) {
                        IndexedDBCommunication.updateSendingFileProgress(message.indexedDBId, 0, function (result) { });
                    }
                });
            }
        }

        /* Sends images to Instagram*/
        function sendMediaMessageToFacebook(file) {
            file.type = file.type.toUpperCase() === communicationConstants.TYPES.DOCUMENT ? communicationConstants.TYPES.FILE : file.type;
            var body = {
                recipient: {
                    id: vm.currentConversation.chatUserId
                },
                platform: vm.currentConversation.platform.toUpperCase(),
                type: file.type.toUpperCase(),
                file: {
                    name: file.name,
                    extension: file.mimeType,
                    body: file.base64
                }
            };
            updateConversationData(vm.currentConversation.chatUserId, $localStorage.userId, file.name);
            MessengerService.sendMedia(body).then(function (result) {
                var message = {
                    owner: true,
                    data: file.fullBase64,
                    type: file.type.toLowerCase(),
                    created: timeConverter(new Date().getTime()),
                    isServer: false,
                    socialMediaName: vm.currentConversation.platform
                };
                vm.openedMessages.push(message);
            });
        }

        function array_move(arr, old_index, new_index) {
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
            return arr; // for testing
        };

        /**
         * Opens the modal to recommendation and return Promise to get callback when modal close.
         */
        function openModalToSendFile() {
            return vm.recommendationModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/communication/modal-file/modal-file.html',
                controller: 'ModalFileController',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    file: function () {
                        return vm.file;
                    },
                    conversation: function () {
                        return vm.currentConversation
                    }
                },
                keyboard: false
            }).result;
        }

        /**
         * Opens the modal to recommendation and return Promise to get callback when modal close.
         */
        function openModalToSendImages() {
            return vm.recommendationModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/communication/modals/send-images-modal/send-images-modal.html',
                controller: 'SendImagesModalController',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    images: function () {
                        return vm.imagesToSend;
                    },
                    conversation: function () {
                        return vm.currentConversation
                    }
                },
                keyboard: false
            }).result;
        }

        /**
         * Extracts information of the base64, as extension (png/jpg/jpeg,pdf), mimeType (image/png or application/pdf).
         * @param {*} base64
         * @returns
         */
        function makeSettingByBase64(base64) {
            var base = base64.split(';')[0];
            var types = communicationConstants.FILE_TYPES;
            return {
                type: types.find(function (type) {
                    return base.split('/')[1] === type.source;
                }).target, mimeType: base.split(':')[1]
            };
        }

        function timeConverter(UNIX_timestamp) {
            var convertedDate = new Date(parseInt(UNIX_timestamp));
            var hour = convertedDate.getHours();
            var min = (convertedDate.getMinutes() < 10 ? '0' : '') + convertedDate.getMinutes();
            var time = hour + ':' + min;
            return time;
        }

        /**
         * Move scroll to bottom in chat.
         */
        function scrollToBottom() {
            $timeout(function () {
                var scroller = document.getElementById("messages-container");
                if (scroller) {
                    scroller.scrollTop = scroller.scrollHeight;
                }
            }, 0, false);
        }

        /**
         * Opens the modal to recommendation.
         */
        vm.openTemplateMessageModal = function () {
            vm.recommendationModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/communication/template-message/template-message.html',
                controller: 'TemplateMessageController',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                controllerAs: 'vm',
                size: 'md',
                keyboard: false
            }).result.then(function (template) {
                vm.text = template;
                vm.updateMessageText()
            });
        };

        function checkNumberFormat(number) {
            number = String(number);

            if (number.length == 12) {
                return number.slice(0, 4)  + number.slice(4, number.length);
            }

            return number;
        }

        function getCustomerByWati(conversation) {
            conversation.chatUserId = checkNumberFormat((conversation.chatUserId ?  conversation.chatUserId :  conversation.numberId));

            var customer = {
                fullName: conversation.name ? conversation.name : String(conversation.chatUserId),
                phone: "+" + conversation.chatUserId,
                storeId: storeId,
                createdThrough: conversation.platform
            }
            CustomerService.getOrCreateCustomerByWhatsapp(customer).then(function (result) {
                if (conversation.conversationId === vm.currentConversation.conversationId) {
                    vm.currentCustomer = result.data;
                    loadNotesTags(vm.currentCustomer.id);
                    changeTicketStatusToOpened(conversation, false);

                    if (vm.currentCustomer.userDBId) {
                        loadUserOfferEngagements();
                        loadUserCategoryStatistics();
                    } else {
                        vm.offers = null;
                    }
                }
            }).catch(function (err) {
                console.log(err);
                loadAllFalse();
            });
        }

        vm.openFeedbackPopUp = function () {
            document.getElementById("bottom-sheet").classList.add("active");
            setTimeout(function () {
                document.getElementById("sheet-body").classList.add("active");
            }, 1);
        };

        vm.closeFeedbackPopUp = function () {
            setTimeout(function () {
                document.getElementById("bottom-sheet").classList.remove("active");
            },500);
            document.getElementById("sheet-body").classList.remove("active");
        }

        function getCustomerByFbOrInstagram(data) {
            var customer = {
                fullName: data.name,
                facebookInstagramProfile: data.profilePic,
                storeId: storeId,
                facebookInstagramId: data.chatUserId,
                createdThrough: data.platform
            }
            CustomerService.getOrCreateCustomerByFbInstagram(customer).then(function (result) {
                vm.currentCustomer = result.data;
                changeTicketStatusToOpened(data, false)
                loadNotesTags(vm.currentCustomer.id);

                if (vm.currentCustomer.userDBId) {
                    loadUserOfferEngagements();
                    loadUserCategoryStatistics();
                } else {
                    vm.offers = null;
                }
                scrollToBottom();
            }).catch(function (err) {
                console.log(err);
                loadAllFalse();
            });
        }

        function loadAllFalse() {
            vm.loadingConversations = false;
            vm.loadingMessages = false;
            vm.showSkeleton = false;
            vm.loadingCustomerInfos = false;
        }

        vm.addressFormat = function () {
            var zipcode = vm.currentCustomer.zipcode;
            var address = vm.currentCustomer.address;
            var state = vm.currentCustomer.state;
            var city = vm.currentCustomer.city;
            var addressNumber = vm.currentCustomer.addressNumber;

            if (!zipcode && !address && !state && !city && !addressNumber) {
                return $translate.instant('communication.no-information');
            }

            return (address ? address + (addressNumber ? ', ' : ' ') : '') + (addressNumber ? addressNumber + (city ? ' - ' : ' ') : '') + (city ? city + (state ? ', ' : ' ') : "") + (state ? state + (zipcode ? ', ' : ' ') : '') + (zipcode ? zipcode : '');
        }

        vm.toEditMode = function () {
            if (!vm.isEditMode) {
                vm.isEditMode = true;
                vm.customerEdit = angular.copy(vm.currentCustomer)
                dateTimePicker();
            }
        }

        function dateTimePicker() {
            var format = 'L';

            vm.dateOfBirthOptions = {
                format: format,
                sideBySide: true,
                ignoreReadonly: true,
                locale: moment.locale(),
                allowInputToggle: true,
                showClear: true,
                maxDate: moment()
            };

            angular.element('#dateOfBirth').datetimepicker(vm.dateOfBirthOptions).on('dp.change', function (ev) {
                if (ev.date) {
                    $scope.$apply(function () {
                        vm.customerEdit.birthdate = ev.date.format(format);
                    });
                } else {
                    $scope.$apply(function () {
                        vm.customerEdit.birthdate = undefined;
                    });
                }
            });

            vm.customerEdit.birthdate = vm.customerEdit.birthdate ? moment.utc(vm.customerEdit.birthdate).format(format) : null;
        }

        vm.cancelEditMode = function () {
            document.getElementById('infos').style.display = 'none';
            vm.customerEdit = {};
            vm.isEditMode = false;
            setTimeout(function () {
                document.getElementById('infos').style.display = 'block';
            }, 250)
        }

        vm.saveEditCustomer = function () {
            var format = 'L';
            var customerToSave = angular.copy(vm.customerEdit);
            customerToSave.birthdate = vm.customerEdit.birthdate ? moment.utc(vm.customerEdit.birthdate, format).toDate() : undefined;
            CustomerService.update(customerToSave).then(function (result) {
                toastr.success($translate.instant('customer.updated'))
                vm.currentCustomer = result.data
                vm.cancelEditMode();
            }, function (error) {
                if (error.data.headers["x-adminapp-params"]) {
                    toastr.error($translate.instant(error.data.headers["x-adminapp-params"].concat(".").concat(error.data.headers["x-adminapp-error"])));
                } else {
                    toastr.error($translate.instant("global.messages.somethingWrong"));
                }
            });
        }

        function changeTicketStatusToOpened(conversation, isNewMessage) {
            if (conversation.status === communicationConstants.CHAT_STATUS.NEW || isNewMessage) {
                conversation.status = communicationConstants.CHAT_STATUS.OPENED;
                ChatTicketService.updateChatTicketStatus(conversation.chatTicketId, communicationConstants.CHAT_STATUS.OPENED).then(function (result) {
                    vm.currentConversation.status = result.status;
                    vm.currentConversation.unreadMessages = result.unreadMessages;
                });
            }
        }

        vm.openDropdownStatus = function (index) {
            $('.dropdown').removeClass('open');
            $('#dropdownMenuButtonOpt-' + index).dropdown('toggle');
        }

        vm.changeTicketStatus = function (conversation, newStatus, event) {
            if (event) {
                event.stopPropagation();
            }
            if (newStatus === 'NEW') {
                conversation.unreadMessages = -1;
            }

            ChatTicketService.updateChatTicketStatus(conversation.chatTicketId, newStatus).then(function (result) {
                var findedIndex = vm.conversationsList.findIndex(function (item) {
                    return item.conversationId === conversation.conversationId && item.name === conversation.name;
                });

                vm.conversationsList[findedIndex].status = result.status;
                if (vm.currentConversation.conversationId === conversation.conversationId) {
                    vm.currentConversation.status = result.status;
                }
            });
        }

        vm.changeIsFavorite = function (conversation) {
            ChatTicketService.changeTicketFavorite(conversation.chatTicketId).then(function (result) {
                conversation.isFavorite = result.isFavorite;
            });
        }

        function findConversationByConversationId() {
            if ($localStorage.redirectNotificationData
                && $localStorage.redirectNotificationData.conversationId) {
                var targetId = $localStorage.redirectNotificationData.conversationId;
                var chatPlatform = $localStorage.redirectNotificationData.chatPlatform;
                var conversation = {
                    conversationId: targetId,
                    platform: chatPlatform
                };
                showSelectedConversation(conversation);
            } else {
                $localStorage.redirectNotificationData = null;
            }
        }

        function receiveMessage(conversation) {
            var chatId = conversation.chatUserId;
            var socialMediaId = conversation.conversationId;
            var field = 'chatUserId';
            if (conversation.platform == communicationConstants.SOCIAL_MEDIAS.WATI) {
                var customer = {
                    fullName: conversation.name ? conversation.name : String(conversation.chatUserId),
                    phone: "+" + conversation.chatUserId,
                    storeId: storeId,
                    createdThrough: conversation.platform,
                    socialMediaId: socialMediaId
                }

                CustomerService.getOrCreateCustomerByWhatsapp(customer).then(function (result) {
                    ChatTicketService.getAnExistChatTicket(chatId, conversation.platform, socialMediaId,
                        conversation.lastMessage, moment().valueOf(),
                        conversation.messageType, result.data.id, conversation.attendantId)
                        .then(function (ticket) {
                            var index = vm.conversationsList.findIndex(function (item) {
                                return String(item[field]) == String(conversation[field]);
                            });

                            if (vm.currentConversation[field] == vm.conversationsList[index][field]) {
                                changeTicketStatusToOpened(conversation, true);
                                vm.conversationsList[index].status = communicationConstants.CHAT_STATUS.OPENED;
                            }
                            vm.conversationsList[index].attendantId = ticket.attendantId;
                        });
                })
            } else {
                var customer = {
                    fullName: conversation.name,
                    facebookInstagramProfile: conversation.profile_pic,
                    storeId: storeId,
                    facebookInstagramId: conversation.chatUserId,
                    createdThrough: conversation.platform
                }
                CustomerService.getOrCreateCustomerByFbInstagram(customer).then(function (result) {
                    ChatTicketService.getAnExistChatTicket(chatId, conversation.platform, socialMediaId, conversation.lastMessage || "",
                      moment().valueOf(), conversation.messageType, result.data.id, conversation.attendantId).then(function (ticket) {
                        var index = vm.conversationsList.findIndex(function (item) {
                            return String(item[field]) == String(conversation[field]);
                        });

                        if (vm.currentConversation[field] == vm.conversationsList[index][field]) {
                            changeTicketStatusToOpened(conversation, true);
                            vm.conversationsList[index].status = communicationConstants.CHAT_STATUS.OPENED;
                        }
                        vm.conversationsList[index].attendantId = ticket.attendantId;
                    });
                })

            }
        }

        function updateConversationData(chatId, attendantId, lastMessage) {
            if (vm.currentConversation.attendantId === attendantId) { return; }
            vm.currentConversation.lastMessage = lastMessage;
            vm.currentConversation.lastMessageDate = moment().valueOf();
            vm.currentConversation.messageType = 'text'
            vm.currentConversation.attendantId = attendantId
            var index = vm.conversationsList.findIndex(function (value) {
                return value.conversationId == vm.currentConversation.conversationId;
            });
            vm.conversationsList[index].attendantId = attendantId;
            getCurrentAttendant();
            vm.conversations.set(vm.currentConversation.conversationId, vm.currentConversation);
        }

        function getAllAttendantsPromise() {
            var pageable = {
                size: 100,
                page: 0
            };
            var params = {
                login: "",
                firstName: "",
                lastName: "",
                email: "",
                all: true
            }
            return UserService.listUsersByStoreId(pageable, storeId, params);
        }

        function getAllUsersAttendants() {
            getAllAttendantsPromise().then(function (result) {
                vm.usersAttendants = result.data;
            });
        }

        getAllUsersAttendants();

        function getCurrentAttendant() {
            vm.usersAttendants.forEach(function (item) {
                if (item.id == vm.currentConversation.attendantId) {
                    vm.currentAttendant = item;
                    return;
                }
            });
        }

        vm.getAttendant = function (attendantId) {
            var attendant = vm.usersAttendants.find(function (userAttendant) {
                return userAttendant.id === attendantId;
            })
            return attendant;
        }

        vm.getAssignedAttendantTooltip = function (attendantId) {
            var attendant = vm.getAttendant(attendantId);
            var attendantName = (attendant.firstName ? attendant.firstName : '') + ' ' +
                (attendant.lastName ? attendant.lastName : '');
            return $translate.instant('communication.attendant-attribution', {attendant: attendantName});
        }

        vm.assignConversation = function (attendant) {
            if (attendant.id !== vm.currentConversation.attendantId) {
                ChatTicketService.assignTicketToAttendant(vm.currentConversation.chatTicketId, attendant.id).then(function (result) {
                    var index = vm.conversationsList.findIndex(function (value) {
                        return value.conversationId == vm.currentConversation.conversationId;
                    });
                    vm.conversationsList[index].attendantId = attendant.id;
                    vm.currentConversation.attendantId = attendant.id
                    getCurrentAttendant();
                    if (attendant.id === $localStorage.userId) {
                        toastr.info($translate.instant('communication.info.assigned-to-you'));
                    } else {
                        toastr.info($translate.instant('communication.info.assigned-to',
                            { attendant: attendant.firstName.concat(' ').concat(attendant.lastName) }));
                    }
                });
            }
        }

        vm.openSocialNetworksConnect = function () {
            vm.socialNetworksModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/communication/social-networks-connect/social-networks-connect.html',
                controller: 'SocialNetworksConnectModalController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    token: function () {
                        return vm.wsToken;
                    }
                },
            }).result.then(function (response) {
                if (response == 'facebook') {
                    vm.facebookAuth();
                } else if (response.source == 'whatsapp') {
                    if (response) {
                        vm.watiSetting = response.data.watiAccountData;
                        vm.isWatiConnected = true;
                        vm.loadingConversations = true;
                        $localStorage.chatFilters.filtered.pageNumber = 0;
                        $localStorage.chatFilters.selectedFilters.pageNumber = 0;
                        vm.conversationsList = [];
                        vm.conversations = new Map();
                        searchByFilter($localStorage.chatFilters.filtered);
                        getInfoAndSubscribeWhatsapp();
                    }
                }
                verifyAllChatsConnected();
            });
        };

        vm.openWatiSettingsModal = function () {
            vm.watiSettingsModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/communication/social-networks-connect/wati-settings-modal/wati-settings-modal.html',
                controller: 'WatiSettingsModalController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    token: function () {
                        return vm.wsToken;
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    vm.watiSetting = response.data.watiAccountData;
                    vm.isWatiConnected = true;
                    vm.loadingConversations = true;
                    $localStorage.chatFilters.filtered.pageNumber = 0;
                    $localStorage.chatFilters.selectedFilters.pageNumber = 0;
                    vm.conversationsList = [];
                    vm.conversations = new Map();
                    searchByFilter($localStorage.chatFilters.filtered);
                    getInfoAndSubscribeWhatsapp();
                }
            });
        };

        vm.facebookAuth = function () {
            FBAuthModalFactory.connect(true).then(function (data) {
                if (data) {
                    vm.loadingConversations = true;
                    $localStorage.chatFilters.filtered.pageNumber = 0;
                    $localStorage.chatFilters.selectedFilters.pageNumber = 0;
                    vm.conversationsList = [];
                    vm.conversations = new Map();
                    var filters = angular.copy($localStorage.chatFilters.filtered);
                    filters.socialMedias = [vm.currentSocialMedia];
                    vm.fbConnected = true;
                    searchByFilter(filters);
                    isFacebookConnected();
                }
            });
        }

        function getInfoAndSubscribeWhatsapp() {
            WatiService.findConfigByCurrentStore(function (result) {
                if (result.data.id) {
                    vm.watiSetting = result.data;
                    vm.isWatiConnected = true;
                    ChatService.subscribeOnWhatsapp(vm.wsToken, subscribeOnWhatsapp);
                } else {
                    vm.isWatiConnected = false;
                }
            }, function (err) {
            });
        }

        vm.checkCEP = function () {
            if (vm.customerEdit.zipcode && vm.customerEdit.zipcode.length === 8) {
                CheckCEPService.getAddress(vm.customerEdit.zipcode).then(function (response) {
                    var result = response.data;
                    if (result) {
                        vm.customerEdit.address = result.name ? result.name + (result.district.name ? ", " + result.district.name : "") : "";
                        vm.customerEdit.state = result.location.uf;
                        vm.customerEdit.city = result.location.name;
                    }
                }).catch(function (err) {
                    console.log(err)
                });
            }
        }

        vm.changePage = function () {
            vm.paginationOptions.page = vm.currentPage - 1;
            if (vm.currentCustomer.userDBId) {
                loadUserOfferEngagements();
            }
        }

        /**
         * Opens the modal to log out of Whatsapp.
         */
        vm.openLogoutModal = function (socialMedia) {

            if (!vm.isWatiConnected && socialMedia == communicationConstants.SOCIAL_MEDIAS.WATI) return;
            if (!vm.fbConnected && socialMedia == communicationConstants.SOCIAL_MEDIAS.FACEBOOK) return;

            vm.recommendationModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/communication/logout-modal/logout.html',
                controller: 'LogoutModalController',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                controllerAs: 'vm',
                size: 'md',
                keyboard: false,
                resolve: {
                    watiSettingId: function () {
                        return vm.isWatiConnected ? vm.watiSetting.id : 0;
                    },
                    socialMedia: function () {
                        return socialMedia
                    }
                }
            }).result.then(function (response) {
                if (response.isLogginOut) {
                    $localStorage.chatFilters.filtered.pageNumber = 0;
                    $localStorage.chatFilters.selectedFilters.pageNumber = 0;
                    vm.conversationsList = [];
                    vm.conversations = new Map();
                    if (response.socialMedia === communicationConstants.SOCIAL_MEDIAS.FACEBOOK) {
                        vm.fbConnected = false;
                    } else {
                        vm.isWatiConnected = false;
                    }
                    searchByFilter($localStorage.chatFilters.filtered);
                    verifyAllChatsConnected();
                }
            });
        };

        function getCategoryName(flyer) {
            FlyerCategoryService.getCategoryTitleByKey(flyer.categoryKey, $translate.use()).then(function (response) {
                flyer.category = response.data;
            });
        }

        function loadUserCategoryStatistics() {
            vm.loadingUserCategoryStatistics = true;
            UserEngagementService.getUserCategoryStatistics(vm.currentCustomer.userDBId, 'all').then(function (result) {
                vm.categoryStatistics = result.mostLikedCategories;
                vm.totalBrand = result.total;
                vm.loadingUserCategoryStatistics = false;
            }, function (err) {
                vm.loadingUserCategoryStatistics = false;
            });
        }

        function loadUserOfferEngagements() {
            vm.loadingUserOfferEngagements = true;
            UserEngagementService.getUserOfferEngagements(vm.currentCustomer.userDBId, 'all', vm.paginationOptions).then(function (result) {
                vm.offers = result.content;

                angular.forEach(vm.offers, function (offer) {
                    getCategoryName(offer.flyer);
                });

                vm.totalElements = result.totalElements;
                vm.startElement = (result.number * result.size) + 1;
                vm.ofQuantityElements = (result.number * result.size) + result.numberOfElements;

                vm.loadingUserOfferEngagements = false;
            }, function (err) {
                vm.loadingUserOfferEngagements = false;
            });
        }

        vm.goToElement = function (element) {
            if (element === 'listConversations') {
                vm.currentConversation = {}
            }
            changeMobileFlow(element);
        }

        function changeMobileFlow(source) {
            if (detectar_mobile()) {
                Object.keys(vm.mobileFlow).map(function (item) {
                    vm.mobileFlow[item] = source === item ? true : false;
                });
            }
        }

        function resetChatCommercePromises() {
            conversationsPromises.forEach(function (promise) {
               promise.payload.cursor = null;
               promise.payload.lastId = null;
            });
        }

        vm.findByName = function () {
            var value = vm.searchText.trim();
            if (value.length == 0) {
                vm.conversationsList = [];
                vm.conversations = new Map();
                vm.loadingConversations = true;
                vm.init();
            } else {
                vm.conversationsList = [];
                vm.conversations = new Map();
                vm.loadingConversations = true;
                var filters = angular.copy($localStorage.chatFilters.filtered);
                filters.pageNumber = 0;
                $localStorage.chatFilters.filtered.pageNumber = 0;
                $localStorage.chatFilters.selectedFilters.pageNumber = 0;
                searchByFilter(filters);
            }
        }

        function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
            var startTimeInMs = Date.now();
            (function loopSearch() {
                if (document.getElementById(selector) != null) {
                    callback();
                    return;
                } else {
                    setTimeout(function () {
                        if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                            return;
                        loopSearch();
                    }, checkFrequencyInMs);
                }
            })();
        }

        vm.confirmReprocess = function(message) {
            AudioModalFactory.confirmAction().then(function(data) {
                if(data) {
                    sendMediaMessageToWhatsapp(message.number, message.media, message.type, message.text, message.stickerApi);
                } else {
                    var failedMessages = $localStorage.failedMessages ? $localStorage.failedMessages : {};
                    var storeMessages = failedMessages[storeId];
                    if (storeMessages && storeMessages[message.number]) {
                        failedMessages[storeId][message.number] = storeMessages[message.number].filter(function (m) {
                            return m.media != message.media;
                        });
                        $localStorage.failedMessages = failedMessages;
                        vm.failedMessages = failedMessages[storeId][message.number];
                    }
                }
            });
        }

        vm.recordingPressed = false;

        vm.showRecordButton = function () {
            if (vm.recording) {
                return vm.currentConversation.platform === 'WATI' && vm.recordingPressed;
            } else {
                var inputText = document.getElementById('message-input').innerText;
                return vm.currentConversation.platform === 'WATI' && inputText.trim().length == 0;
            }
        }

        function verifyPermission() {
            MediaDeviceService.verifyMicrophonePermission().then(function (result) {
                $localStorage.micPermission = result;
            },
            function (err) {
                $localStorage.micPermission = 'none';
                vm.discardAudio();
            });
        }

        vm.requestAudioRecordPermissionAndRecord = function(pressed) {
            switch ($localStorage.micPermission) {
                case 'granted':
                    vm.recordAudio(pressed);
                    break;
                case 'denied':
                    toastr.warning($translate.instant('communication.media.audio.error.general-error'));
                    vm.discardAudio();
                    break;
                case 'prompt':
                    requestMicrophonePermission();
                    break;
                default:
                    requestMicrophonePermission();
                    break;
            }
        }

        function requestMicrophonePermission() {
            MediaDeviceService.getAudioRecorder().then(function (result) {
                if (result) {
                    $localStorage.micPermission = 'granted';
                    vm.recorder = result;
                    vm.recorder.deactivateMicrophone();
                    vm.discardAudio();
                    toastr.success($translate.instant('communication.media.audio.success.device-permission-granted'));
                } else {
                    vm.discardAudio();
                    toastr.warning($translate.instant('communication.media.audio.error.general-error'));
                }
            },
            function (err) {
                vm.discardAudio();
                verifyPermissionError(err);
                verifyPermission();
            });
        }

        vm.recordAudio = function (pressed) {
            if (!navigator.permissions) {
                vm.recording = true;
                vm.recordingPressed = pressed;
                MediaDeviceService.getAudioRecorder().then(function (result) {
                    $localStorage.micPermission = 'granted';
                    vm.recorder = result;
                    vm.audioUrl = null;
                    vm.discarded = false;
                    vm.recorder.start();
                },
                function (err) {
                    vm.discardAudio();
                    verifyPermissionError(err);
                });
            } else {
                MediaDeviceService.verifyMicrophonePermission().then(function (result) {
                    $localStorage.micPermission = result;

                    if (result !== 'granted') {
                        vm.discardAudio();
                        requestMicrophonePermission();
                        return;
                    }

                    vm.recording = true;
                    vm.recordingPressed = pressed;
                    MediaDeviceService.getAudioRecorder().then(function (result) {
                        $localStorage.micPermission = 'granted';
                        vm.recorder = result;
                        vm.audioUrl = null;
                        vm.discarded = false;
                        vm.recorder.start();
                    },
                    function (err) {
                        $localStorage.micPermission = 'none';
                        vm.discardAudio();
                        verifyPermissionError(err);
                    });
                },
                function (err) {
                    $localStorage.micPermission = 'none';
                    vm.discardAudio();
                });
            }
        }

        function verifyPermissionError(errorName) {
            if (errorName == "NotFoundError" || errorName == "DevicesNotFoundError") {
                toastr.warning($translate.instant('communication.media.audio.error.device-not-found'));
            } else if (errorName == "NotReadableError" || errorName == "TrackStartError") {
                toastr.warning($translate.instant('communication.media.audio.error.device-in-use'));
            } else if (errorName == "OverconstrainedError" || errorName == "ConstraintNotSatisfiedError") {
                toastr.warning($translate.instant('communication.media.audio.error.device-overconstrained'));
            } else if (errorName == "NotAllowedError" || errorName == "PermissionDeniedError") {
                toastr.warning($translate.instant('communication.media.audio.error.device-not-allowed'));
            } else if (errorName == "TypeError" || errorName == "TypeError") {
                toastr.warning($translate.instant('communication.media.audio.error.device-not-allowed'));
            } else {
                toastr.warning($translate.instant('communication.media.audio.error.device-not-allowed'));
            }
        }

        vm.stopRecord = function () {
            vm.recorder.stop().then(function (audio) {
                vm.sendMessageBtnLoading = true;
                vm.audioUrl = audio.audioUrl;
                vm.recorder.deactivateMicrophone();
                vm.sendAudioMessage(audio.audioBlob);
                vm.recording = false;
                vm.recordingPressed = false;
            },
            function (error) {
                vm.discardAudio();
                console.log(error);
            });
        }

        vm.playAudio = function () {
            var audio = new Audio(vm.audioUrl);
            audio.play();
        }

        vm.discardAudio = function () {
            vm.audioUrl = null;
            vm.recording = false;
            vm.recordingPressed = false;
            vm.discarded = true;
            if (vm.recorder) {
                vm.recorder.deactivateMicrophone();
                vm.recorder = undefined;
            }
        }

        function convertDataURIToBinary(dataURI) {
            var BASE64_MARKER = ';base64,';
            var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
            var base64 = dataURI.substring(base64Index);
            var raw = window.atob(base64);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));

            for(i = 0; i < rawLength; i++) {
              array[i] = raw.charCodeAt(i);
            }
            return array;
        }

        vm.sendAudioMessage = function (audioBlob) {
            if (vm.currentConversation.attendantId !== $localStorage.userId) {
                assignChatTicketToMeIfNeeded();
            }

            var reader = new FileReader();
            reader.readAsDataURL(audioBlob);
            reader.onload = function () {
                var setting = makeSettingByBase64(reader.result);
                var base64 = reader.result.split('base64,')[1];
                var media = {
                    data: base64,
                    mimeType: setting.mimeType,
                    caption: '',
                    type: setting.mimeType,
                    blob: dataURItoBlob(reader.result),
                    fullData: {
                        base64: base64,
                        fullBase64: reader.result,
                        type: setting.mimeType,
                        mimeType: setting.mimeType,
                        name: 'new audio',
                        caption: '',
                        blob: dataURItoBlob(reader.result)
                    }
                }

                sendAudioMessageToWhatsapp(vm.currentConversation.chatUserId, media, 'audio', '', null, null);
                vm.discardAudio();
                scrollToBottom();
            };
        }

        vm.openChatInvoiceNew = function () {
            vm.closeFeedbackPopUp()
            vm.chatInvoiceNewModal = $uibModal.open({
                templateUrl: 'app/admin/invoices/chat/chat-invoice-new.html',
                controller: 'ChatInvoiceNewController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    currentCustomer: function () {
                        return vm.currentCustomer;
                    },
                    cartProducts: function () {
                        return [];
                    }
                },
            }).result.then(function (response) {
                $rootScope.$emit('$applyResponseFromCreatedOrder', response);
            });
        }

        $rootScope.$on('$applyResponseFromCreatedOrder', function (event, response) {
            if (response && response.message) {
                if (vm.currentConversation) {
                    vm.openConversation(vm.currentConversation);
                }
                vm.text = response.message;
                vm.updateMessageText()
            }
        });

        vm.openMagicModal = function () {
            vm.magicModalCtrl = $uibModal.open({
                templateUrl: 'app/admin/communication/magic-modal/magic-modal.html',
                controller: 'MagicModalController',
                windowClass: 'modal-center',
                windowTopClass: 'modal-dialog-center',
                controllerAs: 'vm',
                resolve: {
                    currentCustomer: function () {
                        return vm.currentCustomer
                    }
                },
                keyboard: false
            }).result.then(function (response) {
                if (response) {
                    vm.text = communicationConstants.TEMPLATE_MESSAGE_RECOMMENDATION.replace('{url}', response.url);
                    vm.updateMessageText()
                    toastr.success('Mala pronta para envio');
                }
            });
        };

        vm.hasConversations = function () {
            return !vm.loadingConversations
                && !(!vm.fbConnected && (vm.currentSocialMedia=='MESSENGER' || vm.currentSocialMedia=='INSTAGRAM'))
                && !((!vm.isWatiConnected) && vm.currentSocialMedia=='WATI');
        }

        function searchByFilter(filters) {
            filters.searchString = vm.searchText.trim();
            filters.connectedChats = {
                isWATIConnected: vm.isWatiConnected,
                isMetaConnected: vm.fbConnected
            }
            if (filters.socialMedias.length === 0) {
                if (vm.currentSocialMedia !== 'ALL') {
                    filters.socialMedias = [vm.currentSocialMedia];
                } else {
                    filters.socialMedias = [];
                }
            } else {

                if (vm.currentSocialMedia !== 'ALL') {
                    var find = _.find(filters.socialMedias, function (socialMedia) {
                        return socialMedia === vm.currentSocialMedia;
                    });
                    if (!find) {
                        vm.conversationsList = [];
                        vm.conversations = new Map();
                        vm.dontScrolled = false;
                        if (!$localStorage.redirectNotificationData) vm.loadingConversations = false;
                        vm.loadingMoreConversations = false;
                        return;
                    } else {
                        filters.socialMedias = [vm.currentSocialMedia];
                    }
                }
            }
            filters = JSON.stringify(filters);

            resetChatCommercePromises();
            vm.dontScrolled = true;
            ChatCommerceService.getConversationsByFilter(filters).then(function (result) {
                vm.dontScrolled = false;
                $localStorage.chatFilters.filtered.pageNumber = $localStorage.chatFilters.filtered.pageNumber + 1;
                $localStorage.chatFilters.selectedFilters.pageNumber = $localStorage.chatFilters.selectedFilters.pageNumber + 1;
                var newConversations = angular.copy(vm.conversationsList);
                result.data.items.forEach(function (conversation) {
                    newConversations.push(conversation);
                    if (!vm.conversations.has(conversation.conversationId)) {
                        vm.conversations.set(conversation.conversationId, conversation);
                    }

                    if (conversation.platform !== communicationConstants.SOCIAL_MEDIAS.WATI) {
                        vm.messenger[conversation.conversationId] = {messages: []};
                        getProfilePicFromUrl(conversation);
                    }
                });
                vm.conversationsList = _.uniqBy(newConversations, function (conversation) {
                    return conversation.conversationId;
                });

                if (vm.isWatiConnected && vm.stickers && vm.stickers.length === 0) getStickers();
                if (!$localStorage.redirectNotificationData) vm.loadingConversations = false;
                vm.loadingMoreConversations = false;
            }, function (err) {
                vm.dontScrolled = false;
                vm.loadingConversations = false;
                vm.loadingMoreConversations = false;
            });
        }

        function getStickers() {
            WatiService.findStickers({ pageNumber: vm.stickersPageNumber, pageSize: 9 }).then(function (result) {
                vm.stickersApi = result.data.api.replace("Bearer ", "");
                vm.stickers = result.data.items;
                vm.stickers.map(function (sticker) {
                    sticker.api = vm.stickersApi.replace("data_default/stickers/{name}", sticker.content.slice(1))
                })
            });
        }

        vm.openFiltersModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/admin/communication/filters-conversation-modal/filters-conversation-modal.html',
                controller: 'FiltersConversationController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'md',
                keyboard: false,
                resolve: {
                    attendants: function () {
                        return vm.usersAttendants
                    },
                    filters: function () {
                        return vm.filters
                    },
                    isWatiConnected: function () {
                        return vm.isWatiConnected
                    },
                    isFacebookConnected: function () {
                        return vm.fbConnected
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    vm.numberFilterSelected = 0;
                    response.filtered.pageNumber = 0;
                    vm.filters = response.selectedFilters;
                    vm.filters.pageNumber = 0;
                    $localStorage.chatFilters = {
                        selectedFilters: vm.filters,
                        filtered: response.filtered
                    };

                    if (response.filtered.order && response.filtered.order.field) {
                        vm.numberFilterSelected++;
                    }

                    if (response.selectedFilters.attendants.length > 0) {
                        vm.numberFilterSelected++;
                    }

                    if (response.filtered.status.length > 0) {
                        vm.numberFilterSelected++;
                    }

                    if (response.filtered.socialMedias.length > 0) {
                        vm.numberFilterSelected++;
                    }

                    if (response.filtered.rangeDate) {
                        vm.numberFilterSelected++;
                    }

                    $localStorage.chatFilters.numberFilterSelected = vm.numberFilterSelected;
                    if (vm.currentSocialMedia !== 'ALL') {
                        vm.changeTab(vm.currentSocialMedia);
                    } else {
                        if (verifySelectedFilters(response.selectedFilters)) {
                            vm.conversationsList = [];
                            vm.conversations = new Map();
                            searchByFilter(response.filtered);
                        } else {
                            vm.conversationsList = [];
                            vm.conversations = new Map();
                            vm.loadingConversations = true;
                            vm.init();
                        }
                    }
                }
            });
        }

        function verifySelectedFilters(selectedFiltes) {
            if (selectedFiltes.attendants.length > 0) return true;

            if (selectedFiltes.socialMedias.length > 0) return true;

            if (selectedFiltes.status.length > 0) return true;

            if (selectedFiltes.rangeDate.startDate && selectedFiltes.rangeDate.endDate) return true;

            if (selectedFiltes.order.id) return true;

            return false;
        }

        vm.getAmountSelectedMessages = function () {
            return $translate.instant(vm.selectedMessages.length === 1 ?
                    'communication.message-selected-singular' : 'communication.message-selected-plural',
                { amount: vm.selectedMessages.length })
        }

        vm.closeMessageSelection = function () {
            vm.selectedMessages = [];
            vm.selectMultipleMessages = false;
        }

        vm.closeMessageToReply = function () {
            vm.replyMessage = false;
            vm.messageToReply = null;
        }

        vm.checkIfMessageSelected = function (message) {
            if (!message || (message && message.type === 'RESERVED')) return;
            return _.find(vm.selectedMessages, function (selectedMessage) {
                return selectedMessage.id === message.id;
            });
        }

        vm.updateMessagesToForward = function (message) {
            if (!vm.selectMultipleMessages) return;

            var isMessageSelected = vm.checkIfMessageSelected(message);

            if (!isMessageSelected && vm.selectedMessages.length >= 30) return;

            if (isMessageSelected) {
                _.remove(vm.selectedMessages, function (selectedMessage) {
                    return selectedMessage.id === message.id;
                });
            } else {
                vm.selectedMessages.push(message);
            }
        }

        vm.applyOption = function (option, message) {
            vm.messageOptions[option].doAction(message);
        }

        vm.openForwardMessagesModal = function () {
            $uibModal.open({
                templateUrl: 'app/admin/communication/select-contacts-modal/select-contacts-modal.html',
                controller: 'SelectContactsModalController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                resolve: {
                    selectedMessages: function () {
                        return vm.selectedMessages;
                    },
                    allAttendants: function () {
                        return vm.usersAttendants;
                    }
                },
                keyboard: false
            }).result.then(function (response) {
                if (response) {
                    if (response.contacts.length === 1) {
                        vm.openChatAfterForwardMessages = true;
                    }
                    toastr.success($translate.instant('communication.forward-messages-modal.request-messages.forward-messages-success'));
                    vm.closeMessageSelection();
                }
            });
        }

        vm.openBroadcastListModal = function () {
            $uibModal.open({
                templateUrl: 'app/admin/communication/broadcast-list-modal/broadcast-list-modal.html',
                controller: 'BroadcastListController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    isWatiConnected: function () {
                        return vm.isWatiConnected
                    },
                    watiSetting: function () {
                        return vm.watiSetting;
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    toastr.success($translate.instant('communication.broadcast-list-modal.request-messages.broadcast-success'));
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('communicationConstants', {
            STEPS_RECOMMENDATION: {
                FIRST: 1,
                SECOND: 2,
                THIRD: 3,
                FOURTH: 4
            },
            'ALL': "ALL",
            TYPES :{
                "TEXT": "TEXT",
                "FILE": "FILE",
                "IMAGE": "IMAGE",
                "VIDEO": "VIDEO",
                "STICKER": "STICKER",
                "DOCUMENT": "DOCUMENT",
                "TEMPLATE": "TEMPLATE",
                "AUDIO": "AUDIO"
            },
            SOCIAL_MEDIAS: {
                "WATI": "WATI",
                "MESSENGER": "MESSENGER",
                "INSTAGRAM": "INSTAGRAM",
                "FACEBOOK": "FACEBOOK"
            },
            FILE_TYPES: [
                {source: 'xml', target: 'application'},
                {source: 'octet-stream', target: 'application'},
                {source: 'png', target: 'image'},
                {source: 'jpg', target: 'image'},
                {source: 'webp', target: 'image'},
                {source: 'jpeg', target: 'image'},
                {source: 'pdf', target: 'document'},
                {source: 'doc', target: 'document'},
                {source: 'docx', target: 'document'},
                {source: 'wav', target: 'audio'},
                {source: 'ogg', target: 'audio'},
                {source: 'mpeg', target: 'audio'},
                {source: 'mpeg-3', target: 'audio'},
                {source: 'mp4', target: 'video'}
            ],
            SUPPORTED_FILES_TYPES: 'video/mp4, video/x-m4v, audio/wav, audio/mpeg, audio/mpeg-3, .opus, image/jpeg, image/png, image/webp, .doc, .docx, .xml, text/plain, application/pdf',
            SUPPORTED_IMAGES_TYPES: 'image/jpeg, image/png, image/webp',
            DEFAULT_BAG: {
                ownerId: 0,
                showcaseTemplateId : 1,
                cover : null,
                coverUrl : "https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/showkase/image_default_bag.png",
                status : "RELEASED",
                published : false,
                userInteract : "SALE",
                hasCover : true,
            },
            TEMPLATE_MESSAGE_RECOMMENDATION: 'Olha só essa mala que acabamos de montar especialmente para você. \n \n {url}',
            PAGE_SIZE: {
                "MESSAGES": "20",
                "CONVERSATIONS": "10"
            },
            CHAT_STATUS: {
                "OPENED": "OPENED",
                "NEW": "NEW",
                "PENDING": "PENDING",
                "RESOLVED": "RESOLVED" ,
                "EXPIRED": "EXPIRED"
            },
            MESSAGES_TYPES: {
                "TEXT": "text",
                "UNSUPPORTED": "unsupported",
                "STORYMENTION": "story_mention",
                "STORYREPLY": "story_reply",
                "CAROUSEL": "carousel",
                "STICKER": "sticker"
            },
            RECOMMENDATION_TYPES: {
                "TREND": "TREND",
                "BOUGHT_TOGETHER": "BOUGHT_TOGETHER",
                "CLUSTER": "CLUSTER",
                "FUNKSVD": "FUNKSVD"
            },
            FILES: {
                MAX_SIZE: 26214400
            }
        });
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('ChatUnreadMessageService', ChatUnreadMessageService);

        ChatUnreadMessageService.$inject = ['ChatUnreadMessageFactory'];

    function ChatUnreadMessageService(ChatUnreadMessageFactory) {

        var service = {
            getChatUnreadMessage: getChatUnreadMessage,
            updateChatUnreadMessage: updateChatUnreadMessage,
            getUnreadMessagesSum: getUnreadMessagesSum
        };

        return service;

        function getChatUnreadMessage(chatId, body){
            return ChatUnreadMessageFactory.getChatUnreadMessage({chatId: chatId}, body).$promise;
        }

        function updateChatUnreadMessage(id, body){
            return ChatUnreadMessageFactory.updateChatUnreadMessage({id: id}, body).$promise;
        }

        function getUnreadMessagesSum(socialNetwork){
             return ChatUnreadMessageFactory.getUnreadMessagesSum({socialNetwork: socialNetwork}).$promise;
        }

    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ChatUnreadMessageFactory', ChatUnreadMessageFactory);

        ChatUnreadMessageFactory.$inject = ['$resource'];

    function ChatUnreadMessageFactory($resource) {
        var resourceChatUnreadMessage =  'admin/api/chat-unread-messages';
        var resourceUpdateChatUnreadMessageById = resourceChatUnreadMessage + '/:id';
        var resourceSumChatUnreadMessage = resourceChatUnreadMessage + '/:socialNetwork';
        var resourceGetChatUnreadMessage = resourceChatUnreadMessage + '/chat-id/:chatId';

        return $resource(resourceChatUnreadMessage, {}, {
            'getChatUnreadMessage': {
                method: 'POST',
                url: resourceGetChatUnreadMessage,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'updateChatUnreadMessage':{
                method: 'PUT',
                url: resourceUpdateChatUnreadMessageById,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'getUnreadMessagesSum':{
                method: 'GET',
                url: resourceSumChatUnreadMessage,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('ChatTicketService', ChatTicketService);

        ChatTicketService.$inject = ['ChatTicketFactory'];

    function ChatTicketService(ChatTicketFactory) {

        var service = {
            getChatTicket: getChatTicket,
            updateChatTicket: updateChatTicket,
            updateChatTicketStatus: updateChatTicketStatus,
            assignTicketToAttendant: assignTicketToAttendant,
            getAnExistChatTicket: getAnExistChatTicket,
            searchByName: searchByName,
            searchByFilter: searchByFilter,
            getSumBySocialMediaName: getSumBySocialMediaName,
            changeTicketFavorite: changeTicketFavorite
        };

        return service;

        function getChatTicket(chatId, socialMediaName, socialMediaId, lastMessage, lastUpdate, messageType, customerId, lastIncomingDate){
            return ChatTicketFactory.getChatTicket({chatId: chatId, socialMediaName: socialMediaName, socialMediaId: socialMediaId, lastMessage: lastMessage, lastUpdate: lastUpdate, messageType: messageType, customerId: customerId, lastIncomingDate: lastIncomingDate}).$promise;
        }

        function updateChatTicket(id, body){
            return ChatTicketFactory.updateChatTicket({id: id}, body).$promise;
        }

        function updateChatTicketStatus(id, body){
            return ChatTicketFactory.updateChatTicketStatus({id: id}, body).$promise;
        }

        function changeTicketFavorite(id){
            return ChatTicketFactory.changeTicketFavorite({id: id}).$promise;
        }

        function assignTicketToAttendant(chatTicketId, attendantId) {
            return ChatTicketFactory.assignTicketToAttendant({id: chatTicketId}, attendantId).$promise;
        }

        function getAnExistChatTicket(chatId, socialMediaName, socialMediaId, lastMessage, lastUpdate, messageType, customerId, attendantId) {
            return ChatTicketFactory.getAnExistChatTicket({chatId: chatId, socialMediaName: socialMediaName, socialMediaId: socialMediaId,
                lastMessage: lastMessage, lastUpdate: lastUpdate, messageType: messageType, customerId: customerId, attendantId: attendantId}).$promise;
        }

        function searchByName(searchText) {
            return ChatTicketFactory.searchByName({searchText: searchText}).$promise;
        }

        function searchByFilter(filters) {
            return ChatTicketFactory.searchByFilter(filters).$promise;
        }

        function getSumBySocialMediaName(socialMediaName) {
            return ChatTicketFactory.getSumBySocialMediaName({socialMediaName: socialMediaName}).$promise;
        }
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ChatTicketFactory', ChatTicketFactory);

        ChatTicketFactory.$inject = ['$resource'];

    function ChatTicketFactory($resource) {
        var resourceChatTicket =  'admin/api/chat-ticket';
        var resourceChatTicketById = resourceChatTicket + '/:id';
        var resourceChatTicketChangeStatusById = resourceChatTicket + '/change-status/:id';
        var resourceChatTicketChangeFavoriteById = resourceChatTicket + '/change-favorite/:id';
        var resourceAssignTicketToAttendant = resourceChatTicket + '/assign-attendant/:id';
        var resourceGetChatTicket = resourceChatTicket + '/:chatId';
        var resourceGetChatTicketExist = resourceChatTicket + '/:chatId/exist';
        var resourceChatTicketFilter =  resourceChatTicket + '/filter';
        var resourceChatTicketUnreadMessages =  resourceChatTicket + '/unread-messages/:socialMediaName';

        return $resource(resourceChatTicket, {}, {
            'getChatTicket': {
                method: 'GET',
                url: resourceGetChatTicket,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'updateChatTicket':{
                method: 'PUT',
                url: resourceChatTicketById,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'updateChatTicketStatus':{
                method: 'PUT',
                url: resourceChatTicketChangeStatusById,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'changeTicketFavorite':{
                method: 'GET',
                url: resourceChatTicketChangeFavoriteById,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'assignTicketToAttendant':{
                method: 'PUT',
                url: resourceAssignTicketToAttendant,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'getAnExistChatTicket':{
                method: 'GET',
                url: resourceGetChatTicketExist,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'searchByName':{
                method: 'GET',
                url: resourceChatTicket,
                isArray: true,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'searchByFilter':{
                method: 'POST',
                url: resourceChatTicketFilter,
                isArray: true,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'getSumBySocialMediaName':{
                method: 'GET',
                url: resourceChatTicketUnreadMessages,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.sum = data;
                    return response;
                }
            },
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('BroadcastListFactory', BroadcastListFactory);

    BroadcastListFactory.$inject = ['$resource'];

    function BroadcastListFactory($resource) {
        var resourceBroadcastList =  'admin/api/wati/broadcast-list';
        var resourceGetContacts = resourceBroadcastList + '/contacts';
        var resourceImportContacts = resourceBroadcastList + '/import-contacts';
        var resourceAddBroadcastList = resourceBroadcastList + '/insert';
        var resourceGetBroadcastDashboard = resourceBroadcastList + '/broadcast-dashboard'

        return $resource(resourceBroadcastList, {}, {
            'getContacts': {
                method: 'POST',
                url: resourceGetContacts,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'importContacts':{
                method: 'POST',
                url: resourceImportContacts,
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined},
                isArray: true
            },
            'addBroadcastList':{
                method: 'POST',
                url: resourceAddBroadcastList,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            },
            'getBroadcastDashboard': {
                method: 'POST',
                url: resourceGetBroadcastDashboard,
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data){
                        response = angular.fromJson(data);
                    }
                    return response;
                }
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('BroadcastListController', BroadcastListController);

    BroadcastListController.$inject = ['$scope', '$uibModalInstance', '$translate', '$q', '$window', 'WatiService',
        'BroadcastListService', '$localStorage', 'toastr', 'moment', 'watiSetting'];

    function BroadcastListController($scope, $uibModalInstance, $translate, $q, $window, WatiService,
                                     BroadcastListService, $localStorage, toastr, moment, watiSetting) {
        var vm = this;
        var format = 'DD/MM/YYYY HH:mm';
        var SCHEDULED_SENDING = 'SCHEDULE';
        var SENDING_NOW = 'NOW';

        vm.isMobile = detectar_mobile();

        vm.watiSetting = watiSetting;
        vm.currentStep = 1;
        vm.form = {
            broadcastName: 'Untitled_' + moment().format('DDMMYYYYHHmm'),
            templateId: '',
            whenSend: SENDING_NOW,
            selectedContactIds: [],
            deselectedContactIds: [],
            IsAllSelected: false,
        };

        // Broadcast list form
        vm.searchMessageTemplate = '';
        vm.messageTemplates = [];
        vm.messageTemplate = null;
        vm.loadingTemplates = false;

        vm.broadcastDashboard = [];
        var broadcastDashboardFilter = {
            "dateFrom": moment().subtract(7, 'd').format(),
            "dateTo": moment().format(),
            "searchString": "",
            "sortBy": 0,
            "filterStatus": [],
            "pageSize": 7,
            "pageNumber": 0,
            "isUpdate": false
        }

        // Select contacts
        vm.SORTBY_VALUES = {
            'NAME': 1,
            'PHONE': 4
        };
        vm.loadingContacts = false;
        vm.loadingImportContacts = false;
        vm.loadingAddBroadcast = false;
        vm.maskLocale = '99/99/9999 99:99';
        vm.scheduledAt = moment().format(format);
        vm.numberPerPage = [5, 10, 25, 100]
        vm.totalItems = 0;
        vm.numPerPage = 10;
        vm.maxSize = 5;
        vm.filters = {
            filterAttributes: [],
            includeInvalidContact: true,
            orderBy: 'asc',
            pageSize: 5,
            searchString: '',
            sortBy: 1,
            pageNumber: 1
        };
        vm.contacts = [];

        vm.initDateTimePicker = dateTimePicker;

        init();

        function init() {
            dateTimePicker();
            searchTemplateMessages();
            getBroadcastDashboard();
        }

        vm.selectMessageTemplate = function (item) {
            if (item) {
                vm.form.templateId = item.id;
            }
        }

        function getBroadcastDashboard () {
            vm.dashboardLoading = true;
            BroadcastListService.getBroadcastDashboard(broadcastDashboardFilter).then(function (response) {
                vm.broadcastDashboard = response.result.items;
                vm.dashboardLoading = false;
            });
        }

        function setMediaFromTemplate (messageTemplate) {
            if (messageTemplate.header) {
                if (messageTemplate.header.type === 2) {
                    messageTemplate.data = messageTemplate.header.link !== '' ? messageTemplate.header.link
                        : WatiService.makeUriToShowImageByWati(vm.watiSetting.watiUri,
                            'data/images/' + messageTemplate.header.mediaFromPC, vm.watiSetting.watiToken);
                } else if (messageTemplate.header.type === 3) {
                    messageTemplate.data = messageTemplate.header.link !== '' ? messageTemplate.header.link
                        : WatiService.makeUriToShowImageByWati(vm.watiSetting.watiUri,
                            'data/videos/' + messageTemplate.header.mediaFromPC, vm.watiSetting.watiToken);
                } else if (messageTemplate.header.type === 4) {
                    messageTemplate.data = messageTemplate.header.link !== '' ? messageTemplate.header.link
                        : 'data/documents/' + messageTemplate.header.mediaFromPC;
                }
            }
        }

        vm.nextStep = function () {
            vm.currentStep = 2;
            if (!vm.contacts.length) {
                getContacts();
            }
        }

        vm.previousStep = function () {
            vm.currentStep = 1;
        }

        vm.closeModal = function (response) {
            $uibModalInstance.close(response);
        }

        function searchTemplateMessages() {
            vm.loadingTemplates = true;
            var promise = WatiService.getTemplateMessages();
            var callback = function(result) {
                vm.messageTemplates = result.data.messageTemplates;

                vm.messageTemplates.forEach(function (messageTemplate) {
                    setMediaFromTemplate(messageTemplate);
                });

                vm.originalTemplates = angular.copy(vm.templates);
                vm.loadingTemplates = false;
            }
            promise.then(callback).catch(function(err) {
                promise.then(callback);
            });

        }

        vm.querySearchTemplate = function(query) {
            var results = query ? vm.messageTemplates.filter(createFilterFor(query)) : vm.messageTemplates;
            var defer = $q.defer();
            defer.resolve(results);
            return defer.promise;
        }

        function createFilterFor(query) {
            var lowercaseQuery = query.toLowerCase();

            return function filterFn(template) {
                return (template.elementName.toLowerCase().indexOf(lowercaseQuery) === 0);
            };
        }

        vm.formatWhatsAppMessage = function (text) {
            return text.replace(/(?:\*)(?:(?!\s))((?:(?!\*|\n).)+)(?:\*)/g,'<b>$1</b>')
                .replace(/(?:_)(?:(?!\s))((?:(?!\n|_).)+)(?:_)/g,'<i>$1</i>')
                .replace(/(?:~)(?:(?!\s))((?:(?!\n|~).)+)(?:~)/g,'<s>$1</s>')
                .replace(/(?:--)(?:(?!\s))((?:(?!\n|--).)+)(?:--)/g,'<u>$1</u>')
                .replace(/(?:```)(?:(?!\s))((?:(?!\n|```).)+)(?:```)/g,'<tt>$1</tt>');
        }

        vm.getDownloadLinkToTemplate = function () {
            return $window.location.protocol + "//" + $window.location.host + '/content/docs/template_contatos.xlsx';
        }

        function getContacts(importedContacts) {
            vm.loadingContacts = true;
            vm.contacts = [];

            vm.filters.pageNumber = vm.filters.pageNumber - 1;
            BroadcastListService.getContacts(vm.filters).then(function (response) {
                console.log(response);
                vm.contacts = response.result.items;
                selectContacts(importedContacts);
                vm.filters.filterAttributes = response.result.filterAttributes;
                vm.filters.sortBy = response.result.sortBy;
                vm.filters.orderBy = response.result.orderBy;
                vm.filters.pageSize = response.result.pageSize;
                vm.filters.pageNumber = response.result.pageNumber + 1;
                vm.totalItems = response.result.total;
                vm.loadingContacts = false;
            });
        }

        function selectContacts(importedContacts) {
            if (importedContacts) {
                importedContacts.forEach(function (contact) {
                    vm.form.selectedContactIds.push(contact.id)
                });
            }
        }

        vm.refreshContacts = function () {
            getContacts();
        }

        vm.sortContactsBy = function (sortBy) {
            if (vm.filters.sortBy === vm.SORTBY_VALUES[sortBy]) {
                if (vm.filters.orderBy === 'asc') {
                    vm.filters.orderBy = 'desc';
                } else {
                    vm.filters.orderBy = 'asc';
                }
            } else {
                vm.filters.orderBy = 'asc';
            }
            vm.filters.sortBy = vm.SORTBY_VALUES[sortBy];
            getContacts();
        }

        vm.addBroadcastList = function () {
            vm.loadingAddBroadcast = true;
            if (vm.form.whenSend === SCHEDULED_SENDING) {
                vm.form.scheduledAt = moment(vm.scheduledAt, format).toDate();
            } else {
                vm.form.scheduledAt = moment().add(1, 'minutes').toDate();
            }
            BroadcastListService.addBroadcastList(vm.form).then(function (response) {
                vm.loadingAddBroadcast = false;
                vm.closeModal(response);
            }).catch(function (err) {
                vm.loadingAddBroadcast = false;
                toastr.error($translate.instant('communication.broadcast-list-modal.request-messages.broadcast-error'));
            });
        }

        vm.loadFile = function (file, errFiles) {
            var formData = new FormData();
            vm.loadingImportContacts = true;
            formData.append('File', file);
            formData.append('RewriteAll', true);
            file.inProgress = true;
            BroadcastListService.importContacts(formData).then(function (response) {
                console.log(response);
                if (response) {
                    getContacts(response);
                } else {
                    getContacts();
                }
                
                vm.loadingImportContacts = false;
                toastr.success($translate.instant('communication.broadcast-list-modal.request-messages.import-success'));
            }).catch(function (err) {
                vm.loadingImportContacts = false;
                toastr.error($translate.instant('communication.broadcast-list-modal.request-messages.import-error'));
            });
        };

        function dateTimePicker() {
            vm.scheduleDateOptions = {
                sideBySide: true,
                ignoreReadonly: true,
                locale: moment.locale(),
                allowInputToggle: true,
                showClear: true,
                widgetPositioning: {
                    horizontal: 'auto',
                    vertical: 'top'
                },
                minDate: moment()
            };

            angular.element('#scheduleDate').datetimepicker(vm.scheduleDateOptions).on('dp.change', function(ev) {
                if (ev.date) {
                    $scope.$apply(function() {
                        vm.scheduledAt = ev.date.format(format);
                    });
                } else {
                    $scope.$apply(function() {
                        vm.scheduledAt = undefined;
                    });
                }
            });
        }

        vm.numberOfContactsLabel = function () {
            if (vm.form.selectedContactIds.length <= 1) {
                return $translate.instant('communication.broadcast-list-modal.contact');
            } else {
                return $translate.instant('communication.broadcast-list-modal.contacts');
            }
        }

        vm.selectOne = function (contact) {
            if (vm.form.IsAllSelected) {
                if (vm.form.deselectedContactIds.indexOf(contact.id) != -1) {
                    vm.form.deselectedContactIds.splice(vm.form.deselectedContactIds.indexOf(contact.id), 1);
                    contact.isSelected = true;
                } else {
                    vm.form.deselectedContactIds.push(contact.id);
                    contact.isSelected = false;
                }

                if (vm.form.deselectedContactIds.length === vm.totalItems) {
                    vm.form.selectedContactIds = [];
                    vm.form.deselectedContactIds = [];
                    vm.form.IsAllSelected = false;
                }
            } else {
                if (vm.form.selectedContactIds.indexOf(contact.id) != '-1') {
                    vm.form.selectedContactIds.splice(vm.form.selectedContactIds.indexOf(contact.id), 1);
                    contact.isSelected = false;
                } else {
                    vm.form.selectedContactIds.push(contact.id);
                    contact.isSelected = true;
                }
            }
        }

        vm.selectAll = function () {
            if (vm.form.IsAllSelected && vm.form.deselectedContactIds.length > 0) {
                vm.form.selectedContactIds = [];
                vm.form.deselectedContactIds = [];
                vm.form.IsAllSelected = true;
            } else if (vm.form.IsAllSelected || vm.isAllSelected()) {
                vm.form.IsAllSelected = false;
                vm.form.selectedContactIds = [];
                vm.form.deselectedContactIds = [];
            } else {
                vm.form.IsAllSelected = true;
            }
        }

        vm.isAllSelected = function () {
            return vm.form.selectedContactIds.length > 0 && vm.contacts.every(function(contact) { return contact.isSelected })
                || vm.form.IsAllSelected && vm.form.deselectedContactIds.length === 0;
        }

        vm.isIndeterminate = function () {
            return vm.form.selectedContactIds.length > 0 && vm.form.selectedContactIds.length < vm.totalItems
                || vm.totalSelected() > 0 && vm.totalSelected() < vm.totalItems;
        }

        vm.checkIfContactSelected = function(contactId) {
            return vm.form.selectedContactIds.indexOf(contactId) != '-1'
                || vm.form.IsAllSelected && vm.form.deselectedContactIds.indexOf(contactId) === -1;
        }

        vm.totalSelected = function () {
            return vm.form.IsAllSelected ? vm.totalItems - vm.form.deselectedContactIds.length : vm.form.selectedContactIds.length;
        }

        vm.selectContactsValidation = function () {
            return vm.totalSelected() > 0 && (vm.form.whenSend === SCHEDULED_SENDING ? moment(vm.scheduledAt, format).isValid() : true);
        }

        vm.selectTemplateValidation = function () {
            return vm.form.broadcastName && vm.form.templateId;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('BroadcastListService', BroadcastListService);

    BroadcastListService.$inject = ['BroadcastListFactory'];

    function BroadcastListService(BroadcastListFactory) {

        var service = {
            getContacts: getContacts,
            importContacts: importContacts,
            getBroadcastDashboard: getBroadcastDashboard,
            addBroadcastList: addBroadcastList
        };

        return service;

        function getContacts(filters){
            return BroadcastListFactory.getContacts(filters).$promise;
        }

        function importContacts(contactsFile){
            return BroadcastListFactory.importContacts(contactsFile).$promise;
        }

        function addBroadcastList(broadcastList) {
            return BroadcastListFactory.addBroadcastList(broadcastList).$promise;
        }

        function getBroadcastDashboard(filters) {
            return BroadcastListFactory.getBroadcastDashboard(filters).$promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('BagChatController', BagChatController);

        BagChatController.$inject =['$uibModalInstance', '$window', '$stateParams', '$localStorage',
                                    'StoreService', '$translate', 'FlyersService', '$timeout',
                                    'FlyerCategoryService', 'ShowcasesService', 'toastr',
                                    'Principal', 'communicationConstants', 'currentCustomer', 'currentSellerId'];

    function BagChatController($uibModalInstance, $window, $stateParams, $localStorage,
        StoreService, $translate, FlyersService, $timeout, FlyerCategoryService,
        ShowcasesService, toastr, Principal, communicationConstants, currentCustomer, currentSellerId) {

        var vm = this;
        var storeId = $localStorage.defaultStore.storeId;
        var mainColor = getComputedStyle(document.documentElement).getPropertyValue('--main-color');
        vm.showcaseId = $stateParams.showcaseId;

        StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
            vm.storeCategory = response.data.categoryKey;
        });

        vm.currentPage = 1;
        vm.maxSize = 15;
        vm.numPerPage = vm.maxSize;
        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage,
            sort: null
        };

        vm.totalAvailableFlyers = 0;

        vm.colors = [];
        vm.sizes = [];
        vm.featureds = [];
        vm.tags = [];
        vm.genders = [];
        vm.isActive = false;
        vm.totalPages = 0;

        vm.showcase = {
            'backgroundColor': false,
            flyers: [],
            ownerId: null,
            hasCover: false,
            name: ''
        };
        vm.selected = {};
        vm.originalFlyers = [];
        vm.allSelected = false;

        vm.filters = {
            brands: [],
            colors: [],
            sizes: [],
            categories: [],
            genders: [],
            tags: [],
            storeId: storeId
        }
 
        var bagDefaultImg = getDefaultImageBagUrl();
        var bagDefaultImgData = '';

        function getDefaultImageBagUrl() {
            if ($localStorage.defaultStore.hubId == 25) {
                return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/storepiccadilly/image_default_bag.png'
            } else {
                return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/showkase/image_default_bag.png';
            }
        }

        vm.filtersLen = 0;
        vm.getFiltersLen = function() {
            vm.filtersLen = 0;
            for (var filter in vm.filters) {
                if (Array.isArray(vm.filters[filter])) {
                    vm.filtersLen += vm.filters[filter].length;
                }
            }

        }

        vm.changeActive = function () {
            vm.isActive = !vm.isActive;
        }

        vm.closePreferences = function () {
            $("btn-group preferences open").removeClass("open");
        }

        vm.closeDropDown = function (event, level) {
            $("md-backdrop").trigger('click');
        }

        vm.getSelectedTextGender = function (filter) {
            var genderTranslate = '';
            if (filter[0] === 1) {
                genderTranslate = $translate.instant('flyers.new.form.gender.male');
            }
            if (filter[0] === 2) {
                genderTranslate = $translate.instant('flyers.new.form.gender.female');
            }
            if (filter[0] === 3) {
                genderTranslate = $translate.instant('flyers.new.form.gender.both');
            }
            if (filter.length == 1) {
                return '<span class="highlight">' + genderTranslate + '</span>';
            }
            if (filter.length > 1) {
                var temp = '  +';
                temp += filter.length - 1;
                temp += ' selecionados';
                return '<span class="highlight">' + genderTranslate + '</span>' +
                    '<span>&nbsp</span>' +
                    '<span class="highlight">' + temp + '</span>';
            }
            return '';
        }


        vm.getSelectedTextCategory = function (filter) {
            for (var i = 0; i < vm.categories.length; i++) {
				if (vm.categories[i].key === filter[0]){
		            if (filter.length == 1) {
		                return '<span class="highlight">' + vm.categories[i].title + '</span>';
		            }
		            if (filter.length > 1) {
		                var temp = '  +';
		                temp += filter.length - 1;
		                temp += ' selecionados';

		                return '<span class="highlight">' + vm.categories[i].title + '</span>' +
		                    '<span>&nbsp</span>' +
		                    '<span class="highlight">' + temp + '</span>';
		            }
		            return '';
				}
			}
            return '';
        }

        vm.getSelectedText = function (filter) {
            var elementTranslate = '';

            if (filter[0] === 'launch' || filter[0] === 'basic') {
                elementTranslate = $translate.instant('flyers.new.form.configurations.' + filter[0].toLowerCase());
            } else {
                elementTranslate = filter[0];
            }
            if (filter.length == 1) {
                return '<span class="highlight">' + elementTranslate + '</span>';
            }
            if (filter.length > 1) {
                var temp = '  +';
                temp += filter.length - 1;
                temp += ' selecionados';

                return '<span class="highlight">' + elementTranslate + '</span>' +
                    '<span>&nbsp</span>' +
                    '<span class="highlight">' + temp + '</span>';
            }
            return '';

        }


        vm.checkIfFilterSelected = function (filterKey, filter) {
            return (vm.filters[filterKey] ? vm.filters[filterKey] : []).indexOf(filter) >= 0 ? true : false;
        }

        vm.updateFilterOrRemove = function (filterKey, filter) {
            if (!vm.filters[filterKey]) {
                vm.filters[filterKey] = [];
            }
            var index = vm.filters[filterKey].indexOf(filter);
            if (index === -1) {
                vm.filters[filterKey].push(filter);
                return;
            }
            vm.filters[filterKey].splice(index, 1);
        }

        vm.hasSome = function (list, arr) {
            if (arr) {
                return arr.some(function (v) {
                    return list.indexOf(v.id) >= 0;
                });
            }
        };

        vm.makeTagsToFilter = function () {
            vm.filters.tags = vm.filters.tags ? vm.filters.tags.map(function (item) { return item.text ? item.text : item }) : [];
        }

        vm.getCategoryName = function (flyer) {
            var category = _.find(vm.categories, function(el) {return el.key === flyer.categoryKey});
            if (category) {
                flyer.category = category.title;
            }
        }

        vm.saveBag = function () {
            ShowcasesService.saveBag({
                showcaseTemplateId: 1,
                backgroundColor: mainColor,
                ownerId: 0,
                hasCover: true,
                userInteract: 'SALE',
                flyers: [],
                excludes: [],
                bagFilters: vm.filters
            });
        }


        vm.templateIsLoading = true;
        vm.templates = [];

        vm.storeOwnerHasMoipAccount = false;
        storeOwnerHasMoipAccount();

        function storeOwnerHasMoipAccount() {
            Principal.storeOwnerHasMoipAccount().then(function (responseMoipAccount) {
                vm.storeOwnerHasMoipAccount = responseMoipAccount.data != null && responseMoipAccount.data.moipLogin != null;
            });
        }

        vm.getTranslateType = function (type) {
            return 'flyers.new.form.userInteract.types.' + type.toLowerCase();
        }

        vm.getTranslateFeatureds = function (featured) {
            return 'flyers.new.form.configurations.' + featured.toLowerCase();
        }

        vm.getTranslateGenders = function (gender) {
            if (gender === 1) {
                return 'flyers.new.form.gender.male';
            }
            if (gender === 2) {
                return 'flyers.new.form.gender.female';
            }
            if (gender === 3) {
                return 'flyers.new.form.gender.both';
            }
            return '';
        }
        loadAll();

        function loadAll() {
			FlyersService.getAllFiltersFlyer().then(function (response) {
                vm.brands = response.data.brands;
				vm.colors = response.data.colors;
				vm.sizes = response.data.sizes;
				vm.types = response.data.types;
				vm.featureds = response.data.features;
				vm.tags = response.data.tags;
				vm.genders = response.data.genders;
            });

            FlyerCategoryService.listCategoriesWithFlyers($translate.use()).then(function (response) {
                vm.categories = response.data;
            });


            vm.templateId = 1; // Chose the first template as default
            ShowcasesService.getTemplates().then(function (response) {
                vm.templates = response;
            });

            if (vm.showcaseId) {
                loadShowcase().then(function () {
                    loadFlyers();
                });
            } else {
                vm.showcase.ownerId = storeId;
                vm.showcase.backgroundColor = mainColor;
                vm.showcase.showcaseTemplateId = vm.templateId;
                vm.templateIsLoading = false;
                if(!vm.showcase.bagFilters || (vm.showcase.bagFilters && !vm.showcase.bagFilters.type)) {
                    vm.filters.type = 'SALE';
                }

            }

            StoreService.getOwnerCategoryCurrentStore().then(function (response) {
                vm.storeCategory = response.data;
            });
            vm.loading = true;
            ShowcasesService.findFlyerByFilterBag(vm.paginationOptions, vm.filters).then(
                function (response) {
                    vm.currentPage = response.page;
                    vm.totalPages = response.totalPages;
                    vm.flyersFiltered = response.content;
                    vm.totalAvailableFlyers = response.totalElements;
                    vm.loading = false
                    vm.verifyAllPageChecked();
                },
                function (err) {
                    vm.loading = false;
                }
            );
        }

        vm.verifyAllPageChecked = function() {
            var count = 0;
            vm.flyersFiltered.forEach(function(flyer) {
                if (vm.selected[flyer.id]) {
                    count++;
                }
            });
            vm.allSelected = vm.flyersFiltered.length == count;
        }

        vm.onSelectAll = function() {
            vm.allSelected = !vm.allSelected;
            vm.flyersFiltered.forEach(function(flyer) {
                if (vm.allSelected) {
                    if (!(flyer.id in vm.selected)) {
                        vm.selected[flyer.id] = flyer;
                    }
                } else {
                    delete vm.selected[flyer.id];
                }
            });
            vm.totalFlyers = vm.getTotalFlyers();
        }

        vm.getCurrencyPrefix = function(flyer) {
            var key = flyer.currency ? flyer.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            return config.prefix;
        }

        vm.totalFlyers = 0;
        vm.getTotalFlyers = function () {
            if (vm.flyersFiltered !== undefined && vm.selected !== undefined) {
                return vm.flyersFiltered.length - (vm.flyersFiltered.length - Object.keys(vm.selected).length);
            }

            return 0;
        }

        vm.flyersSelected = function () {
            return Object.keys(vm.selected).length === vm.totalAvailableFlyers;
        }

        vm.refreshSelectedFlyers = function (flyer) {
            if (flyer.id in vm.selected) {
                delete vm.selected[flyer.id]
            } else {
                vm.selected[flyer.id] = flyer
            }
            vm.totalFlyers = vm.getTotalFlyers();
            vm.allSelected = vm.flyersSelected();
        }

        vm.checkIfFlyerSelected = function (idFlyer) {
            return idFlyer in vm.selected;
        }

        vm.filterFlyers = function () {
            scrollToTop();
            vm.currentPage = 1;
            if (hasTextFilter()) {
                loadFlyersFromFlyerService(vm.currentPage);
            } else {
                loadFlyersFromShowcaseService(vm.currentPage);
            }

            vm.getFiltersLen();
            $('.btn-group.preferences').removeClass('open');
            $('.dropdown-backdrop').css('display', 'none');
            vm.changeActive();
        };

        vm.loadFlyers = function () {
            vm.allSelected = false;
            if (vm.loading) {
                return;
            }

            if (vm.totalPages == (vm.currentPage - 1)) {
                return;
            }

            if (hasTextFilter()) {
                loadFlyersFromFlyerService(vm.currentPage);
            } else {
                loadFlyersFromShowcaseService(vm.currentPage);
            }
        }

        vm.closeModal = function(url) {
            $uibModalInstance.close(url);
        }

        function scrollToTop() {
            $timeout(function () {
                var scroller = document.getElementById("scroll-div");
                if (scroller) {
                    scroller.scrollTop = 0;
                }
            }, 0, false);
        }

        function hasTextFilter() {
            return vm.filters.text && vm.filters.text.length > 0;
        }

        function loadFlyersFromFlyerService(page) {
            vm.paginationOptions.page = page - 1;
            vm.loading = true;
            FlyersService.listAllToAdmin(vm.paginationOptions, vm.filters, function(data, headers) {
                vm.flyersFiltered = data.content;
                vm.totalAvailableFlyers = data.totalElements;
                vm.currentPage = data.page + 1;
                vm.totalPages = data.totalPages;
                vm.loading = false;
                vm.verifyAllPageChecked();
            }, function(_) {
                vm.loading = false;
            });
        }

        function loadFlyersFromShowcaseService(page) {
            vm.paginationOptions.page = page - 1;
            vm.loading = true;
            ShowcasesService.findFlyerByFilterBag(vm.paginationOptions, vm.filters).then(function (response) {
                vm.flyersFiltered = response.content;
                vm.currentPage = response.number + 1;
                vm.totalPages = response.totalPages;
                vm.totalAvailableFlyers = response.totalElements;
                vm.loading = false;
                vm.verifyAllPageChecked();
            }, function(_) {
                vm.loading = false;
            });
        }


        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId);
        }

        getStoreInfo().then(function(response) {
            $localStorage.defaultStore.storeType = response.data.storeType;
            vm.store = response.data;
        });

        vm.getShowcaseURL = function(idBag) {
            if (!$localStorage.defaultStore.storeNickname) {
                getStoreInfo().then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    vm.closeModal({flyers: vm.finalFlyers, url: $window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/bag/' + idBag});
                });
            } else {
                vm.closeModal({flyers: vm.finalFlyers, url: $window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/bag/' + idBag});
            }

        }

        var getBase64Image = function (url) {
            var img = new Image();
            img.setAttribute('crossOrigin', 'anonymous');
            img.onload = function () {
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL("image/png");
                bagDefaultImgData = dataURL;
            }
            img.src = url
        }
        getBase64Image(bagDefaultImg);

        function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {
                type: mimeString
            });
        }

        vm.createBagWithProducts = function() {
            var bagWithProducts = communicationConstants.DEFAULT_BAG;
            bagWithProducts.coverUrl = getDefaultImageBagUrl();
            var count = 1;

            bagWithProducts.flyers = [];

            for (var flyerId in vm.selected) {
                bagWithProducts.flyers.push({flyerId: flyerId, position: count++})
            }
            
            bagWithProducts.isAllProductsSelected = false;
            bagWithProducts.backgroundColor = mainColor;
            bagWithProducts.name = vm.showcase.name;
            bagWithProducts.isPrimary = false;
            bagWithProducts.bagFilters = vm.filters;
            bagWithProducts.customers = [currentCustomer.id];
            bagWithProducts.users = [currentSellerId];

            if(vm.showcase.name) {
                vm.loadingImage = true;
                FlyersService.saveFlyerMultiImage(dataURItoBlob(bagDefaultImgData), 0).then(function (response) {
                    $timeout(function () {
                        if (response.data) {
                            response.data.action = '';
                            response.data.nameFile = '';
                            bagWithProducts.addImageFileDTO = [response.data];
                            ShowcasesService.createBagByRecommendation(bagWithProducts).then(function (result) {
                                vm.getShowcaseURL(result.id);
                            });
                            return;
                        } else {
                            toastr.error($translate.instant('flyers.messages.create.error'));
                        }
                        vm.loadingImage = false;
                    });
                }, function (response) {
                    toastr.error($translate.instant('flyers.messages.create.image.uploadError'));
                    vm.loadingImage = false;
                });
            } else {
                vm.getShowcaseURL('');
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('ModalBrandFactory', ModalBrandFactory);

    /** @ngInject */
    function ModalBrandFactory($uibModal) {

        var factory = {
            listModal: listModal,
        }

        return factory;

        function listModal() {
            return listBrandModal();
        }

        function listBrandModal() {
            return $uibModal.open({
                templateUrl: "app/admin/brand/modal-brand.html",
                windowClass: 'modal-fit',
                size: 'md',
                controller: "ModalBrandConstroller",
                controllerAs: "vm",
                backdrop: 'static'
            }).result;
        }
    }
})();

(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .controller('ModalBrandConstroller', ModalBrandConstroller);

    /** @ngInject */
    function ModalBrandConstroller(BrandService, toastr, $uibModalInstance, $translate) {
        var vm = this;

        vm.filterChange = filterChange
        vm.brands = [];
        vm.init = init;
        vm.brandFilter = { "id": "", "name": "" };
        vm.createBrand = createBrand;
        vm.disableButtonCreate = disableButtonCreate;
        vm.disableButtonEdit = disableButtonEdit;
        vm.loadingBrands = false;
        vm.getBrandById = getBrandById;
        vm.removeBrand = removeBrand;
        vm.editBrand = editBrand;
        vm.clearResults = clearResults;
        vm.editing = false;
        vm.editCancel = editCancel;
        vm.close = close;

        function init() {
            vm.brandFilter = { "id": "", "name": "" };
            filterChange(vm.brandFilter.name);
        }

        function clearResults() {
            vm.brands = [];
        }

        function filterChange() {
            if (vm.editing) return;
            vm.loadingBrands = true;
            BrandService.findBrand(vm.brandFilter.name).then(function (result) {
                vm.brands = result.data.slice();
                vm.loadingBrands = false;
            }, function (_) {
                vm.loadingBrands = false;
            });
        }

        function createBrand() {
            vm.loadingBrands = true;
            BrandService.createBrand(vm.brandFilter.name).then(function (_) {
                vm.init();
                toastr.success($translate.instant('brand.messages.success.create'));
                vm.loadingBrands = false;
            }, function (_) {
                toastr.warning($translate.instant('brand.messages.warning.alreadyExists'));
                vm.loadingBrands = false;
            });
        }

        function getBrandById(brand) {
            BrandService.getBrandById(brand.id).then(function (result) {
                vm.editing = true;
                vm.brandFilter = result.data;
                vm.clearResults();
            }, function (_) {
                toastr.warning($translate.instant('brand.messages.warning.notFound'));
                vm.loadingBrands = false;
            });
        }

        function editBrand() {
            BrandService.editBrand(vm.brandFilter).then(function (_) {
                vm.editing = false;
                vm.init();
                toastr.success($translate.instant('brand.messages.success.edit'));
            }, function (_) {
                toastr.warning($translate.instant('brand.messages.warning.alreadyExists'));
                vm.editing = false;
                vm.init();
            });
        }

        function removeBrand(brand) {
            BrandService.removeBrand(brand.id).then(function (_) {
                vm.brandFilter.name = "";
                vm.init();
                toastr.success($translate.instant('brand.messages.success.remove'));
                vm.loadingBrands = false;
            }, function (_) {
                toastr.warning($translate.instant('brand.messages.warning.withRegisteredProducts'));
                vm.loadingBrands = false;
            });
        }

        function disableButtonCreate() {
            if (vm.loadingBrands || vm.brandFilter.name.length === 0) return true;
        }


        function disableButtonEdit() {
            if (vm.brandFilter.name.length === 0) return true;
            if (vm.brands.id === "") return true;
        }

        function editCancel() {
            vm.editing = false;
            vm.init();
        }

        function close () {
            $uibModalInstance.close();
        }
    }

})();


(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .service('ColorService', ColorService);

    ColorService.$inject = ['ColorFactoryAdmin'];

    function ColorService(ColorFactoryAdmin) {
        var service = {
            getColorsByCurrentStore: getColorsByCurrentStore,
            findColor: findColor,
            createColor: createColor,
            getColorById: getColorById,
            removeColor: removeColor,
            editColor: editColor
        };

        return service;

        function getColorsByCurrentStore() {
            return ColorFactoryAdmin.getColorsByCurrentSTore().$promise;
        }

        function findColor(colorName) {
            return ColorFactoryAdmin.findColor({ "name": colorName }).$promise;
        }

        function createColor(colorName) {
            return ColorFactoryAdmin.createColor({ "name": colorName }).$promise;
        }

        function getColorById(colorId) {
            return ColorFactoryAdmin.getColorById({"colorId": colorId}).$promise;
        }

        function removeColor(colorId) {
            return ColorFactoryAdmin.removeColor({"colorId": colorId}).$promise;
        }

        function editColor(color) {   
            return ColorFactoryAdmin.editColor({"colorId": color.id}, color).$promise;
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ColorFactoryAdmin', ColorFactoryAdmin);

    ColorFactoryAdmin.$inject = ['$resource'];

    function ColorFactoryAdmin($resource) {
        var resourceUrl = 'admin/api/color';

        return $resource(resourceUrl, {}, {
            'getColorsByCurrentSTore': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'findColor': {
                method: 'POST',
                url: 'admin/api/color/search',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'createColor': {
                method: 'POST',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getColorById': {
                method: 'GET',
                url: 'admin/api/color/:colorId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'removeColor': {
                method: 'DELETE',
                url: 'admin/api/color/:colorId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'editColor': {
                method: 'PUT',
                url: 'admin/api/color/:colorId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('showcaseApp').factory('ChecklistService', ChecklistService);

    ChecklistService.$inject = ['ChecklistFactory', '$uibModal'];

    function ChecklistService(ChecklistFactory, $uibModal) {
        var service = {
            getActivitiesList: getActivitiesList,
            getActivitiesListByStatus: getActivitiesListByStatus,
            updateActivity: updateActivity

        };

        return service;


        function getActivitiesList() {
            return ChecklistFactory.getActivitiesList().$promise;
        }

        function getActivitiesListByStatus(status) {
            return ChecklistFactory.getActivitiesListByStatus({'status': status}).$promise;
        }

        function updateActivity(id, status) {
            return ChecklistFactory.updateActivity({'activityId': id}, {'status': status, 'sort': 'id'}).$promise;
        }


    }

})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ChecklistFactory', ChecklistFactory);

    ChecklistFactory.$inject = ['$resource'];

    function ChecklistFactory($resource) {
        var resourceUrl = 'admin/api/activity';

        return $resource(resourceUrl, {}, {
            'getActivitiesList': {
                method: 'GET',
                isArray: false,
                url: 'admin/api/activity/list'
            },
            'getActivitiesListByStatus': {
                method: 'GET',
                isArray: false,
                url: 'admin/api/activity/list/:status'
            },
            'updateActivity': {
                method:'PUT',
                isArray: false,
                url: 'admin/api/activity/:activityId'
            },
        });
    }
})();

(function () {
	'use strict';

	angular.module('showcaseApp')
		.controller('ChecklistController', ChecklistController);

    ChecklistController.$inject = ['$uibModalInstance', '$localStorage', 'ChecklistService', 'toastr', '$translate', 'Principal', 'HubService'];

	function ChecklistController($uibModalInstance, $localStorage, ChecklistService, toastr, $translate, Principal, HubService) {
		var vm = this;

        vm.checklistTypes = [{'title': 'Todas', 'key': 'ALL'},
            {'title': 'Não iniciadas', 'key': 'PENDING'},
            {'title': 'Finalizadas', 'key': 'DONE'}];

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var yyyy = today.getFullYear();
        var month = today.toLocaleString('default', { month: 'long' });
        vm.todayDate = dd + ' de ' + month + ' de ' + yyyy;

        vm.listItems = [];
        vm.doneItemsTotal = 0;

        vm.totalItems= 0;
        vm.doneItems = 0;

        vm.listFilter = { storeId: $localStorage.defaultStore.storeId, type: 'ALL'};

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		}


        vm.updateItem = function (activity, status) {
            ChecklistService.updateActivity(activity.id, status).then(function (data) {
                vm.listItems = [];
                loadChecklistItems(vm.listFilter.type);
            });
        };

        vm.getFormattedTime = function (dateTime) {
            var date = new Date(dateTime);
            var hoursAndMinutes = date.getHours() + 'h' + date.getMinutes() + 'min';
            return hoursAndMinutes;
        }

        vm.getFormattedName = function (name, sizeLimit) {
            if (name.length > sizeLimit) {
            return name.substr(0, sizeLimit - 3) + '...';
            }
            return name;
        }

        function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
            var startTimeInMs = Date.now();
            (function loopSearch() {
                if (document.getElementById(selector) != null) {
                    callback();
                    return;
                } else {
                    setTimeout(function () {
                        if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
                            return;
                        loopSearch();
                    }, checkFrequencyInMs);
                }
            })();
        }

        function loadAccordion() {
            if (vm.listItems.length > 0) {
            waitForElementToDisplay(vm.listFilter.type + '-' + vm.listItems[0].id,function() {

                var acc = document.getElementById("tabContent");
                var heightFactor = 0.4;
                if (screen.height < 700) {
                    heightFactor = 0.5;
                }
                acc.style.height = screen.height - (screen.height * heightFactor) + 'px';

                var acc = document.getElementsByClassName("accordion");
                var i;
                for (i = 0; i < acc.length; i++) {
                    acc[i].addEventListener("click", function() {
                        this.classList.toggle("active-item");
                        var panel = this.nextElementSibling;
                        if (panel.style.maxHeight) {
                            panel.style.paddingBottom = 0;
                            panel.style.maxHeight = null;
                            panel.style.border = null;
                            var height = document.getElementById(this.id + '-content').clientHeight;
                            if (height <= 40) {
                                this.style.height = 60 + 'px';
                            } else {
                                this.style.height = 80 + 'px';
                            }
                        } else {
                            panel.style.paddingBottom = '5%';
                            panel.style.maxHeight = panel.scrollHeight + "px";
                            panel.style.borderBottom = "1px solid #eeecec";
                            panel.style.borderRight = "1px solid #eeecec";
                            panel.style.borderLeft = "1px solid #eeecec";
                            var height = document.getElementById(this.id + '-content').clientHeight;
                            this.style.height = Math.max((height + 20), 60) + 'px';
                        }
                    });
                    var height = document.getElementById(acc[i].id + '-content').clientHeight;
                    if (height <= 40) {
                        acc[i].style.height = 60 + 'px';
                    } else {
                        acc[i].style.height = 80 + 'px';
                    }
                }
            },50,9000);
            } else {
                vm.loadingTab = false;
            }
        }

        function loadChecklistItems(typeKey) {
            vm.loadingTab = true;

            if (typeKey == 'ALL') {
                ChecklistService.getActivitiesList().then(function (data) {
                    vm.listItems = data['activities'].sort(function(a,b) {
                        return a.id - b.id
                    });
                    vm.doneItems = 0;
                    vm.totalItems = 0;
                    for (var j = 0; j < vm.listItems.length; j++) {
                        vm.listItems.index = j;
                        if (vm.listItems[j].status == 'DONE') {
                            vm.doneItems += 1;
                        }

                        if (vm.listItems[j].status != 'CANCELLED') {
                            vm.totalItems += 1;
                        }
                    }
                    vm.doneItemsTotal = vm.doneItems;

                    loadAccordion();

                    var percentage = ((360/100) * ((vm.doneItems/vm.totalItems) * 100).toFixed(2)) / 2;

                    var acc = document.getElementById("maskFill");
                    acc.style.transform = 'rotate(' + percentage + 'deg)';
                    var acc2 = document.getElementById("maskFillPercentage");
                    acc2.style.transform = 'rotate(' + percentage + 'deg)';
                    var acc3 = document.getElementById("fillPercentage");
                    acc3.style.transform = 'rotate(' + percentage + 'deg)';
                    vm.loadingTab = false;
                });
            } else {
                ChecklistService.getActivitiesListByStatus(typeKey).then(function (data) {
                    vm.listItems = data['activities'];
                    vm.doneItems = 0;
                    for (var j = 0; j < vm.listItems.length; j++) {
                        if (vm.listItems[j].status == 'DONE') {
                            vm.doneItems += 1;
                        }
                    }
                    loadAccordion();
                    vm.loadingTab = false;
                });
            }
        }

        function getAccount() {
            Principal.identity(false).then(function (account) {
                vm.account = account;
                $translate.use(vm.account.langKey);
            });
        }

        vm.tabTypeClick = function(typeKey){
            vm.loadingTab = true;
            vm.listItems = [];
            vm.listFilter.type = typeKey;
            loadChecklistItems(typeKey);
        }



        function loadAll() {
            getAccount();
            loadChecklistItems('ALL');
        }

        loadAll();

	}
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('ChatService', ChatService);

    ChatService.$inject = ['$q'];

    function ChatService($q, WatiFactory, $localStorage) {

        var MICROSERVICE_SOCKET_URI = document.location.protocol + '//admin.' + document.location.hostname.split('.').slice(1).join('.') + '/chat';

        var BROKER_WHATSAPP = '/broker/new-message-wati/';
        var BROKER_MESSENGER = '/broker/new-message-messenger/';
        var BROKER_INSTAGRAM = '/broker/new-message-instagram/';
        var BROKER_SYSTEM_NOTIFICATION = '/broker/new-system-notification/';
        var BROKER_SYSTEM_UPDATE_NOTIFICATION = '/broker/update-system-notification/';

        var socket = {
            client: null,
            stomp: null
        };

        var deferred = $q.defer();

        var service = {
            subscribeOnWhatsapp: subscribeOnWhatsapp,
            subscribeOnMessenger: subscribeOnMessenger,
            subscribeOnInstagram: subscribeOnInstagram,
            subscribeOnNewNotifications: subscribeOnNewNotifications,
            subscribeOnUpdateNotifications: subscribeOnUpdateNotifications,
            connectWS: connectWS
        };

        return service;

        function connectWS(callback) {
            
            if (socket.stomp && socket.stomp.connected) {
            
                callback();
                return;
            }
        
            socket.client = SockJS(MICROSERVICE_SOCKET_URI);
            socket.stomp = Stomp.over(socket.client);
         
            socket.stomp.connect({}, function () {
                deferred.resolve(socket.stomp.connected);
                callback();
            }, function () {
                reconnect(callback);
            });
        }

        function reconnect(callback) {
            console.info('Tentando reconectar...');
            setTimeout(function() {
                connectWS(callback);
            }, 5000);
        }

        function subscribeOnMessenger(origin, onMessage) {
            socket.stomp.subscribe(BROKER_MESSENGER + origin, function(message) {
                onMessage(JSON.parse(message.body));
            });
        }

        function subscribeOnWhatsapp(origin, onMessage) {
            socket.stomp.subscribe(BROKER_WHATSAPP + origin, function(message) {
                onMessage(JSON.parse(message.body));
            });
        }

        function subscribeOnNewNotifications(origin, onMessage) {
            socket.stomp.subscribe(BROKER_SYSTEM_NOTIFICATION + origin, function(message) {
                onMessage(JSON.parse(message.body));
            });
        }

        function subscribeOnUpdateNotifications(origin, onMessage) {
            socket.stomp.subscribe(BROKER_SYSTEM_UPDATE_NOTIFICATION + origin, function(message) {
                onMessage(JSON.parse(message.body));
            });
        }

        function subscribeOnInstagram(origin, onMessage) {
            socket.stomp.subscribe(BROKER_INSTAGRAM + origin, function(message) {
                onMessage(JSON.parse(message.body));
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('store-categorys', {
                parent: 'admin',
                url: '/store-categorys',
                data: {
                    authorities: ['STORE_READ'],
                    pageTitle: 'categorys.store.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/category/categorys-table.html',
                        controller: 'StoreCategorysController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('categorys');
                        return $translate.refresh();
                    }]

                }
            })
            // .state('store-management-detail', {
            //     parent: 'store-management',
            //     url: '/store/{id:int}',
            //     data: {
            //         authorities: ['STORE_READ', 'ADMIN_MANAGE_SYSTEM'],
            //         pageTitle: 'store-management.detail.title'
            //     },
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/admin/store-management/store-management-detail.html',
            //             controller: 'StoreManagementDetailController',
            //             controllerAs: 'vm'
            //         }
            //     },
            //     params: {
            //         storeId: null
            //     },
            //     resolve: {
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('store-management');
            //             $translatePartialLoader.addPart('profile');
            //             $translatePartialLoader.addPart('error');
            //             $translatePartialLoader.addPart('user-management');
            //             return $translate.refresh();
            //         }]
            //     }
            // })
            // .state('store-detail', {
            //     parent: 'store-management',
            //     url: '^/store/detail',
            //     data: {
            //         authorities: ['STORE_READ'],
            //         pageTitle: 'store-management.detail.title'
            //     },
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/admin/store-management/store-management-detail.html',
            //             controller: 'StoreManagementDetailController',
            //             controllerAs: 'vm'
            //         }
            //     },
            //     resolve: {
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('store-management');
            //             $translatePartialLoader.addPart('user-management');
            //             $translatePartialLoader.addPart('profile');
            //             return $translate.refresh();
            //         }],
            //         stateParams: ['$stateParams', '$localStorage', function($stateParams, $localStorage) {
            //             $stateParams.id = $localStorage.defaultStore.storeId;
            //             return $stateParams;
            //         }]
            //     }
            // })
            // .state('store-management.addsalespoint', {
            //     url: '/newsalespoint',
            //     data: {
            //         pageTitle: 'store-management.new.title',
            //         authorities: ['STORE_UPDATE']
            //     },
            //     onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            //         $uibModal.open({
            //             templateUrl: 'app/admin/store-management/store-management-newsalespoint.html',
            //             controller: 'AddSalesPointManagementController',
            //             controllerAs: 'vm',
            //             backdrop: 'static',
            //             size: 'md',
            //             resolve: {}
            //         });
            //     }],
            //     resolve: {
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('store-management');
            //             return $translate.refresh();
            //         }]
            //
            //     }
            // })
            // .state('store-management.new', {
            //     url: '/new',
            //     data: {
            //         pageTitle: 'store-management.new.title',
            //         authorities: ['STORE_CREATE']
            //     },
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/admin/store-management/store-management-new.html',
            //             controller: 'StoreManagementNewController',
            //             controllerAs: 'vm'
            //         }
            //     },
            //     resolve: {
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('store-management');
            //             $translatePartialLoader.addPart('global');
            //             return $translate.refresh();
            //         }]
            //     }
            // })
            // .state('store-profile-detail', {
            //     parent: 'store-detail',
            //     url: '^/perfil/{id}',
            //     data: {
            //         authorities: ['STORE_READ_PROFILE'],
            //         pageTitle: 'showcaseApp.profile.detail.title'
            //     },
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/entities/profile/profile-management-detail.html',
            //             controller: 'ProfileDetailController',
            //             controllerAs: 'vm'
            //         }
            //     },
            //     params: {
            //         'storeId': {
            //             value: null
            //         }
            //     },
            //     resolve: {
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('profile');
            //             return $translate.refresh();
            //         }],
            //         previousState: ["$state", function($state) {
            //             var currentStateData = {
            //                 name: $state.current.name || 'profile-management',
            //                 params: $state.params,
            //                 url: $state.href($state.current.name, $state.params)
            //             };
            //             return currentStateData;
            //         }]
            //     }
            // });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('StoreCategorysController', StoreCategorysController);

    StoreCategorysController.$inject = ['$scope', '$state', 'uiGridConstants', 'uiGridBuilder', 'CategoryService', '$localStorage', '$translate', '$uibModal'];

    function StoreCategorysController($scope, $state, uiGridConstants, uiGridBuilder, CategoryService, $localStorage, $translate, $uibModal) {

      var vm = this;
      vm.arrayPagination = [];
      vm.startRegistry = 0;
      vm.endRegistry = 0;
      vm.tableDivisor = 10;
      vm.filterFields = {};
      vm.defaultSearchIndex = 0;
      vm.checkIsFirstPage = false;
      vm.checkIsLastPage = false;
      vm.columnDefs = getColumnDefs();
      vm.currentPage = $state.current.name;

      loadAll();

      function loadAll() {
          vm.gridTableOptions = getGridOptions();
      }

      function getColumnDefs() {
          return [{
                  field: 'key',
                  displayName: 'categorys.form.key',
                  headerCellFilter: 'translate',
              },
              {
                  field: 'langKey',
                  displayName: 'categorys.form.langKey',
                  headerCellFilter: 'translate',
              },
              {
                  field: 'title',
                  displayName: 'categorys.form.title',
                  headerCellFilter: 'translate',
              }
          ];
      }

      function getGridOptions() {
          return uiGridBuilder.withDefaultOptions()
              .withActionColumn(100)
              .addActionToActionColumn("edit", "vm.getEditPage", "fa fa-edit", "text-primary", true)
              .addActionToActionColumn("delete", "vm.getDeletePage", "fa fa-trash", "text-primary", true)
              .withColumns(vm.columnDefs).build('search');
      }

      $scope.search = function() {
          var params = null;
          var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();
          CategoryService.listAllCategories(pageable, vm.filterFields).then(function(response) {
              vm.totalItems = response.headers['x-total-count'];
              vm.gridTableOptions.virtualizationThreshold = response.data.length;
              vm.gridTableOptions.update(response.data, vm.totalItems);
              vm.gridTableOptions.getArrayPagination(function(arrayPagination) {
                  vm.arrayPagination = arrayPagination;
              });
              refreshDataInfos();
              vm.checkIsLastPage = vm.gridTableApi.pagination.getPage() === vm.gridTableApi.pagination.getTotalPages();
              vm.checkIsFirstPage = vm.gridTableApi.pagination.getPage() === 1;
              vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
          });
      }

      vm.reload = function() {
        $scope.search();
      }

      function createArray(range, divisor) {
          if(!divisor)divisor = 0;
          if (divisor != 0) {
              range = range / divisor;
          }
          var values = [];
          var iteratorNumber = 0;
          for (var i = 0; i < range; i++) {
              iteratorNumber = divisor != 0 ? i * divisor : i + 1;
              values.push(iteratorNumber);
          }
          return values;
      };

      function refreshDataInfos() {
          vm.gridTableApi = vm.gridTableOptions.getApiGridTable();
          vm.startRegistry = (vm.gridTableApi.pagination.getPage() * vm.gridTableOptions.paginationPageSize) - vm.gridTableOptions.paginationPageSize;
          vm.endCalc = vm.gridTableOptions.paginationPageSize * vm.gridTableApi.pagination.getPage();
          vm.endRegistry = vm.endCalc > vm.totalItems ? vm.totalItems : vm.endCalc;
      };

      vm.changePageSize = function(pageSize) {
          vm.gridTableOptions.paginationPageSize = pageSize;
      };

      vm.reloadUsers = function() {
          $scope.search();
      }

      vm.stopPropagation = function(event) {
          event.stopPropagation();
      };

      vm.changeColumnView = function($index) {
          vm.gridTableOptions.columnDefs[$index].visible = !(vm.gridTableOptions.columnDefs[$index].visible || vm.gridTableOptions.columnDefs[$index].visible === undefined);
          vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
      };

      vm.exporterTable = function(type) {
          if (type === 'pdf') {
              vm.gridTableApi.exporter.pdfExport('visible', 'visible');
          } else if (type === 'csv') {
              vm.gridTableApi.exporter.csvExport('visible', 'visible');
          }
      };

      vm.addCategory = function() {
          $uibModal.open({
              templateUrl: 'app/admin/category/category-new.html',
              controller: 'StoreCategorysNewController',
              controllerAs: 'vm',
              scope: $scope,
              backdrop: 'static',
              size: 'md',
              resolve: {
                  user: function() {
                      return undefined;
                  }
              }
          });
      }

      vm.getEditPage = function(category) {
          $uibModal.open({
              templateUrl: 'app/admin/category/category-edit.html',
              controller: 'StoreCategorysEditController',
              controllerAs: 'vm',
              scope: $scope,
              backdrop: 'static',
              size: 'md',
              resolve: {
                  category: function() {
                      return angular.copy(category);
                  }
              }
          }).result.then(function(response) {
              $scope.search();
          });;
      }

      $scope.$on('storeUpdated', function(event, data) {
          $scope.search();
      });

      $scope.$on('$localeChangeSuccess', function(e, locale) {
          vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
          vm.gridTableApi.grid.refresh();
      });

    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('StoreCategorysNewController', StoreCategorysNewController);

    StoreCategorysNewController.$inject = ['$timeout', '$localStorage', '$state', '$scope', '$stateParams', '$translate', '$uibModalInstance', 'CategoryService', 'toastr'];

    function StoreCategorysNewController($timeout, $localStorage, $state, $scope, $stateParams, $translate, $uibModalInstance, CategoryService, toastr) {
        var vm = this;

        vm.category = { key: "", languages: [ {langKey: "pt-BR", title: ""}, {langKey: "en", title: ""}, {langKey: "es", title: ""} ]};

        vm.save = save;

        function save () {
          CategoryService.createCategory(vm.category).then(function (data) {
            toastr.success($translate.instant('categorys.messages.new.success'));
            $uibModalInstance.close(true);
          }, function () {
            toastr.error($translate.instant('categorys.messages.new.error'));
          });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('StoreCategorysEditController', StoreCategorysEditController);

    StoreCategorysEditController.$inject = ['$timeout', '$localStorage', '$state', '$scope', '$stateParams', '$translate', '$uibModalInstance', 'CategoryService', 'toastr', 'category'];

    function StoreCategorysEditController($timeout, $localStorage, $state, $scope, $stateParams, $translate, $uibModalInstance, CategoryService, toastr, category) {
        var vm = this;
        vm.save = save;
        vm.clear = clear;
        vm.category = category;

        function save() {
          CategoryService.updateCategory(vm.category).then(function (data) {
            toastr.success($translate.instant('categorys.messages.edit.success'));
            $uibModalInstance.close(true);
          }, function () {
            toastr.error($translate.instant('categorys.messages.edit.error'));
          });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

    }

})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('CategoryService', CategoryService);

    CategoryService.$inject = ['CategoryFactory', '$localStorage'];

    function CategoryService(CategoryFactory, $localStorage) {
        var service = {
                createCategory: createCategory,
                updateCategory: updateCategory,
                deleteCategory: deleteCategory,
                listAllCategories: listAllCategories,
                listCategories: listCategories,
                getCategoryTitleByKey: getCategoryTitleByKey
        };

        return service;

        function getCategoryTitleByKey(categoryKey, categoryLang) {
            return CategoryFactory.getData({key: categoryKey, langKey: categoryLang}).$promise;
        }

        function createCategory(category) {
            return CategoryFactory.save(category).$promise;
        }

        function updateCategory(category) {
            return CategoryFactory.update(category).$promise;
        }

        function deleteCategory(categoryId) {
            return CategoryFactory.delete({id: categoryId}).$promise;
        }

        function listCategories(userLang) {
            return CategoryFactory.getJSON({langKey: userLang}).$promise;
        }

        function listAllCategories(pageable, params) {
            return CategoryFactory.listAll(pageable, params).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('CategoryFactory', CategoryFactory);

    CategoryFactory.$inject = ['$resource'];

    function CategoryFactory ($resource) {
        var resourceUrl =  'admin/api/category/:key';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getJSON': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'listAll': {
                url: 'admin/api/category/list',
                method: 'POST',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'save': {
              url: 'admin/api/category',
              method: 'POST'
            },
            'getData': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'update': { method:'PUT' },
            'delete': { method:'DELETE' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('FlyerCategoryService', FlyerCategoryService);

    FlyerCategoryService.$inject = ['FlyerCategoryFactory', '$localStorage'];

    function FlyerCategoryService(FlyerCategoryFactory, $localStorage) {
        var service = {
                createCategory: createCategory,
                updateCategory: updateCategory,
                deleteCategory: deleteCategory,
                listCategories: listCategories,
                listAllCategories: listAllCategories,
                getCategoryTitleByKey: getCategoryTitleByKey,
                listCategoriesByCurrentStore: listCategoriesByCurrentStore,
                createCategoryByStore: createCategoryByStore,
                listCategoriesByStoreId: listCategoriesByStoreId,
                listCategoriesWithFlyers: listCategoriesWithFlyers
        };

        return service;

        function getCategoryTitleByKey(categoryKey, categoryLang) {
            return FlyerCategoryFactory.getData({key: categoryKey, langKey: categoryLang}).$promise;
        }

        function createCategory(category) {
            return FlyerCategoryFactory.save(category).$promise;
        }

        function updateCategory(category) {
            return FlyerCategoryFactory.update(category).$promise;
        }

        function deleteCategory(categoryId) {
            return FlyerCategoryFactory.delete({id: categoryId}).$promise;
        }

        function listCategories(userLang) {
            return FlyerCategoryFactory.getJSON({langKey: userLang}).$promise;
        }

        function listCategoriesByCurrentStore(userLang) {
            return FlyerCategoryFactory.listAllByCurrentStore({langKey: userLang}).$promise;
        }

        function listAllCategories(pageable) {
            return FlyerCategoryFactory.listAll(pageable, {}).$promise;
        }

        function createCategoryByStore(category) {
            return FlyerCategoryFactory.createByStore(category).$promise;
        }

        function listCategoriesByStoreId(userLang, storeId) {
            return FlyerCategoryFactory.listCategoriesByStoreId({langKey: userLang, storeId: storeId}).$promise;
        }
        
        function listCategoriesWithFlyers(userLang){
            return FlyerCategoryFactory.listCategoriesWithFlyers({langKey: userLang}).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('FlyerCategoryFactory', FlyerCategoryFactory);

    FlyerCategoryFactory.$inject = ['$resource'];

    function FlyerCategoryFactory ($resource) {
        var resourceUrl =  'flyer/api/category/:key';

        return $resource(resourceUrl, {}, {
            'listAllByCurrentStore': {
                url: 'flyer/api/category/current-store',
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'query': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getJSON': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'listAll': {
                url: 'flyer/api/category/list',
                method: 'POST',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getData': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'update': { method:'PUT' },
            'delete': { method:'DELETE' },
            'createByStore': {
                method: 'POST',
                url: 'flyer/api/category/store',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'listCategoriesByStoreId': {
                method: 'GET',
                url: 'flyer/api/category/store/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'listCategoriesWithFlyers': {
                method: 'POST',
                url: 'flyer/api/category/flyers',
                transformResponse: function(data, headers) {
                  var response = {};
                  response.data = angular.fromJson(data);
                  response.headers = headers();
                  return response;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FlyerCategorysNewController', FlyerCategorysNewController);

    FlyerCategorysNewController.$inject = ['$timeout', '$localStorage', '$state', '$scope', '$stateParams', '$translate', '$uibModalInstance', 'FlyerCategoryService', 'toastr'];

    function FlyerCategorysNewController($timeout, $localStorage, $state, $scope, $stateParams, $translate, $uibModalInstance, FlyerCategoryService, toastr) {
        var vm = this;

        vm.category = { key: "", languages: [ {langKey: "pt-BR", title: ""}, {langKey: "en", title: ""}, {langKey: "es", title: ""} ]};

        vm.save = save;

        function save () {
          FlyerCategoryService.createCategory(vm.category).then(function (data) {
            toastr.success($translate.instant('categorys.messages.new.success'));
            $uibModalInstance.close(true);
          }, function (data) {
            toastr.error($translate.instant('categorys.messages.new.error'));
          });
        }


    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FlyerCategorysEditController', FlyerCategorysEditController);

    FlyerCategorysEditController.$inject = ['$timeout', '$localStorage', '$state', '$scope', '$stateParams', '$translate', '$uibModalInstance', 'FlyerCategoryService', 'toastr', 'category'];

    function FlyerCategorysEditController($timeout, $localStorage, $state, $scope, $stateParams, $translate, $uibModalInstance, FlyerCategoryService, toastr, category) {
        var vm = this;
        vm.save = save;
        vm.clear = clear;
        vm.category = category;

        function save() {
          FlyerCategoryService.updateCategory(vm.category).then(function (data) {
            toastr.success($translate.instant('categorys.messages.edit.success'));
            $uibModalInstance.close(true);
          }, function (data) {
            toastr.error($translate.instant('categorys.messages.edit.error'));
          });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('flyer-categorys', {
                parent: 'admin',
                url: '/flyer-categorys',
                data: {
                    authorities: ['STORE_READ'],
                    pageTitle: 'categorys.flyer.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/category/categorys-table.html',
                        controller: 'FlyerCategorysController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('categorys');
                        return $translate.refresh();
                    }]

                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FlyerCategorysController', FlyerCategorysController);

    FlyerCategorysController.$inject = ['$scope', '$state', 'uiGridConstants', 'uiGridBuilder', 'FlyerCategoryService', '$localStorage', '$uibModal'];

    function FlyerCategorysController($scope, $state, uiGridConstants, uiGridBuilder, FlyerCategoryService, $localStorage, $uibModal) {

      var vm = this;
      vm.arrayPagination = [];
      vm.startRegistry = 0;
      vm.endRegistry = 0;
      vm.tableDivisor = 10;
      vm.filterFields = {};
      vm.defaultSearchIndex = 0;
      vm.checkIsFirstPage = false;
      vm.checkIsLastPage = false;
      vm.columnDefs = getColumnDefs();
      vm.currentPage = $state.current.name;

      loadAll();

      function loadAll() {
          vm.gridTableOptions = getGridOptions();
      }

      function getColumnDefs() {
          return [{
                  field: 'key',
                  displayName: 'categorys.form.key',
                  headerCellFilter: 'translate',
              },
              {
                  field: 'langKey',
                  displayName: 'categorys.form.langKey',
                  headerCellFilter: 'translate',
              },
              {
                  field: 'title',
                  displayName: 'categorys.form.title',
                  headerCellFilter: 'translate',
              }
          ];
      }

      function getGridOptions() {
          return uiGridBuilder.withDefaultOptions()
              .withActionColumn(100)
              .addActionToActionColumn("edit", "vm.getEditPage", "fa fa-edit", "text-primary", true)
              .addActionToActionColumn("delete", "vm.getDeletePage", "fa fa-trash", "text-primary", true)
              .withColumns(vm.columnDefs).build('search');
      }

      $scope.search = function() {
          var params = null;
          var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();
          FlyerCategoryService.listAllCategories(pageable).then(function(response) {
              vm.totalItems = response.headers['x-total-count'];
              vm.gridTableOptions.virtualizationThreshold = response.data.length;
              vm.gridTableOptions.update(response.data, vm.totalItems);
              vm.gridTableOptions.getArrayPagination(function(arrayPagination) {
                  vm.arrayPagination = arrayPagination;
              });
              refreshDataInfos();
              vm.checkIsLastPage = vm.gridTableApi.pagination.getPage() === vm.gridTableApi.pagination.getTotalPages();
              vm.checkIsFirstPage = vm.gridTableApi.pagination.getPage() === 1;
              vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
          });
      }

      function createArray(range, divisor) {
          if(!divisor)divisor = 0;
          if (divisor != 0) {
              range = range / divisor;
          }
          var values = [];
          var iteratorNumber = 0;
          for (var i = 0; i < range; i++) {
              iteratorNumber = divisor != 0 ? i * divisor : i + 1;
              values.push(iteratorNumber);
          }
          return values;
      };

      function refreshDataInfos() {
          vm.gridTableApi = vm.gridTableOptions.getApiGridTable();
          vm.startRegistry = (vm.gridTableApi.pagination.getPage() * vm.gridTableOptions.paginationPageSize) - vm.gridTableOptions.paginationPageSize;
          vm.endCalc = vm.gridTableOptions.paginationPageSize * vm.gridTableApi.pagination.getPage();
          vm.endRegistry = vm.endCalc > vm.totalItems ? vm.totalItems : vm.endCalc;
      };

      vm.changePageSize = function(pageSize) {
          vm.gridTableOptions.paginationPageSize = pageSize;
      };

      vm.reloadUsers = function() {
          $scope.search();
      }

      vm.stopPropagation = function(event) {
          event.stopPropagation();
      };

      vm.changeColumnView = function($index) {
          vm.gridTableOptions.columnDefs[$index].visible = !(vm.gridTableOptions.columnDefs[$index].visible || vm.gridTableOptions.columnDefs[$index].visible === undefined);
          vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
      };

      vm.exporterTable = function(type) {
          if (type === 'pdf') {
              vm.gridTableApi.exporter.pdfExport('visible', 'visible');
          } else if (type === 'csv') {
              vm.gridTableApi.exporter.csvExport('visible', 'visible');
          }
      };

      vm.addCategory = function() {
          $uibModal.open({
              templateUrl: 'app/admin/category/category-new.html',
              controller: 'FlyerCategorysNewController',
              controllerAs: 'vm',
              scope: $scope,
              backdrop: 'static',
              size: 'md',
              resolve: {
                  user: function() {
                      return undefined;
                  }
              }
          });
      }

      vm.getEditPage = function(category) {
          $uibModal.open({
              templateUrl: 'app/admin/category/category-edit.html',
              controller: 'FlyerCategorysEditController',
              controllerAs: 'vm',
              scope: $scope,
              backdrop: 'static',
              size: 'md',
              resolve: {
                  category: function() {
                      return angular.copy(category);
                  }
              }
          }).result.then(function(response) {
              $scope.search();
          });;
      }

      vm.reload = function() {
        $scope.search();
      }

      $scope.$on('storeUpdated', function(event, data) {
          $scope.search();
      });

      $scope.$on('$localeChangeSuccess', function(e, locale) {
          vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
          vm.gridTableApi.grid.refresh();
      });

    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('ModalBrandFactory', ModalBrandFactory);

    /** @ngInject */
    function ModalBrandFactory($uibModal) {

        var factory = {
            listModal: listModal,
        }

        return factory;

        function listModal() {
            return listBrandModal();
        }

        function listBrandModal() {
            return $uibModal.open({
                templateUrl: "app/admin/brand/modal-brand.html",
                windowClass: 'modal-fit',
                size: 'md',
                controller: "ModalBrandConstroller",
                controllerAs: "vm",
                backdrop: 'static'
            }).result;
        }
    }
})();

(function () {
    'use strict'

    angular
        .module('showcaseApp')
        .controller('ModalBrandConstroller', ModalBrandConstroller);

    /** @ngInject */
    function ModalBrandConstroller(BrandService, toastr, $uibModalInstance, $translate) {
        var vm = this;

        vm.filterChange = filterChange
        vm.brands = [];
        vm.init = init;
        vm.brandFilter = { "id": "", "name": "" };
        vm.createBrand = createBrand;
        vm.disableButtonCreate = disableButtonCreate;
        vm.disableButtonEdit = disableButtonEdit;
        vm.loadingBrands = false;
        vm.getBrandById = getBrandById;
        vm.removeBrand = removeBrand;
        vm.editBrand = editBrand;
        vm.clearResults = clearResults;
        vm.editing = false;
        vm.editCancel = editCancel;
        vm.close = close;

        function init() {
            vm.brandFilter = { "id": "", "name": "" };
            filterChange(vm.brandFilter.name);
        }

        function clearResults() {
            vm.brands = [];
        }

        function filterChange() {
            if (vm.editing) return;
            vm.loadingBrands = true;
            BrandService.findBrand(vm.brandFilter.name).then(function (result) {
                vm.brands = result.data.slice();
                vm.loadingBrands = false;
            }, function (_) {
                vm.loadingBrands = false;
            });
        }

        function createBrand() {
            vm.loadingBrands = true;
            BrandService.createBrand(vm.brandFilter.name).then(function (_) {
                vm.init();
                toastr.success($translate.instant('brand.messages.success.create'));
                vm.loadingBrands = false;
            }, function (_) {
                toastr.warning($translate.instant('brand.messages.warning.alreadyExists'));
                vm.loadingBrands = false;
            });
        }

        function getBrandById(brand) {
            BrandService.getBrandById(brand.id).then(function (result) {
                vm.editing = true;
                vm.brandFilter = result.data;
                vm.clearResults();
            }, function (_) {
                toastr.warning($translate.instant('brand.messages.warning.notFound'));
                vm.loadingBrands = false;
            });
        }

        function editBrand() {
            BrandService.editBrand(vm.brandFilter).then(function (_) {
                vm.editing = false;
                vm.init();
                toastr.success($translate.instant('brand.messages.success.edit'));
            }, function (_) {
                toastr.warning($translate.instant('brand.messages.warning.alreadyExists'));
                vm.editing = false;
                vm.init();
            });
        }

        function removeBrand(brand) {
            BrandService.removeBrand(brand.id).then(function (_) {
                vm.brandFilter.name = "";
                vm.init();
                toastr.success($translate.instant('brand.messages.success.remove'));
                vm.loadingBrands = false;
            }, function (_) {
                toastr.warning($translate.instant('brand.messages.warning.withRegisteredProducts'));
                vm.loadingBrands = false;
            });
        }

        function disableButtonCreate() {
            if (vm.loadingBrands || vm.brandFilter.name.length === 0) return true;
        }


        function disableButtonEdit() {
            if (vm.brandFilter.name.length === 0) return true;
            if (vm.brands.id === "") return true;
        }

        function editCancel() {
            vm.editing = false;
            vm.init();
        }

        function close () {
            $uibModalInstance.close();
        }
    }

})();


(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .service('BrandService', BrandService);

    BrandService.$inject = ['BrandFactoryAdmin'];

    function BrandService(BrandFactoryAdmin) {
        var service = {
            getBrandsByCurrentStore: getBrandsByCurrentStore,
            findBrand: findBrand,
            createBrand: createBrand,
            getBrandById: getBrandById,
            removeBrand: removeBrand,
            editBrand: editBrand
        };

        return service;

        function getBrandsByCurrentStore() {
            return BrandFactoryAdmin.getBrandsByCurrentSTore().$promise;
        }

        function findBrand(brandName) {
            return BrandFactoryAdmin.findBrand({ "name": brandName }).$promise;
        }

        function createBrand(brandName) {
            return BrandFactoryAdmin.createBrand({ "name": brandName }).$promise;
        }

        function getBrandById(brandId) {
            return BrandFactoryAdmin.getBrandById({"brandId": brandId}).$promise;
        }

        function removeBrand(brandId) {
            return BrandFactoryAdmin.removeBrand({"brandId": brandId}).$promise;
        }

        function editBrand(brand) {   
            return BrandFactoryAdmin.editBrand({"brandId": brand.id}, brand).$promise;
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('BrandFactoryAdmin', BrandFactoryAdmin);

    BrandFactoryAdmin.$inject = ['$resource'];

    function BrandFactoryAdmin($resource) {
        var resourceUrl = 'admin/api/brand';

        return $resource(resourceUrl, {}, {
            'getBrandsByCurrentSTore': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'findBrand': {
                method: 'POST',
                url: 'admin/api/brand/search',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'createBrand': {
                method: 'POST',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'getBrandById': {
                method: 'GET',
                url: 'admin/api/brand/:brandId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'removeBrand': {
                method: 'DELETE',
                url: 'admin/api/brand/:brandId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'editBrand': {
                method: 'PUT',
                url: 'admin/api/brand/:brandId',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FiltersBagsController', FiltersBagsController);

    FiltersBagsController.$inject = ['$uibModalInstance', '$translate', '$localStorage', 'toastr', 'filters', 'options', 'list', 'StoreService'];

    function FiltersBagsController($uibModalInstance, $translate, $localStorage, toastr, filters, options, list, StoreService) {

        var vm = this;
        vm.originalFilters = angular.copy(filters);
        vm.filters = angular.copy(filters);
        vm.listFilter = list;
        vm.canChangeView = options.canChangeView;

        vm.colors = formatOptionsDict(options.colors);
        vm.sizes = formatOptionsDict(options.sizes);
        vm.categories = formatOptionsDict(options.categories);
        vm.brands = formatOptionsDict(options.brands);
        // vm.tags = formatOptionsDict(options.tags);
        vm.customers = formatOptionsDict(options.customers);
        vm.hasInventory = filters.hasInventory;
        vm.viewByCategories = options.viewByCategories;

        StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
            vm.storeCategory = response.data.categoryKey;
        });
        vm.genders = formatOptionsDict(
            [{"label":"flyers.new.form.gender.male","id":1},
                {"label":"flyers.new.form.gender.female","id":2},
                {"label":"flyers.new.form.gender.both","id":3}]);

        vm.isBagFilter = false;
        if (options.isBagFilter) {
            vm.isBagFilter = options.isBagFilter;
            formatFilterOptions();
        }

        vm.closeModal = function(response, applyFilters) {
            if (!applyFilters) {
                vm.filters = vm.originalFilters;
            }
            $uibModalInstance.close(response);
        }

        vm.closeDropDown = function () {
            $("md-backdrop").trigger('click');
        }

        vm.getSelectedText = function (filter) {
            if (filter.length === 0) return '';

            var elementTranslate = (filter[0].label);
            if (elementTranslate.includes("."))
                elementTranslate = $translate.instant(filter[0].label);

            if (filter.length === 1) {
                return '<span class="highlight">' + elementTranslate + '</span>';
            }

            if (filter.length > 1) {
                var temp = '  +';
                temp += filter.length - 1;
                temp += ' ' + $translate.instant('flyers.filters.selected');

                return '<span class="highlight">' + elementTranslate + '</span>' +
                    '<span>&nbsp</span>' +
                    '<span class="highlight">' + temp + '</span>';
            }
            return '';
        }

        vm.clearFilters = function () {
            vm.filters.categories = [];
            vm.filters.brands = [];
            vm.filters.colors = [];
            vm.filters.sizes = [];
            vm.filters.genders = [];
            vm.filters.customers = [];
            // vm.filters.tags = [];
            vm.hasInventory = true;
        }

        vm.applyFilters = function () {
            var filters = angular.copy(vm.filters);
            filters.categories = filters.categories.map(function(category){ return category.key });
            filters.brands = filters.brands.map(function(brand){ return brand.name });
            filters.colors = filters.colors.map(function(color){ return color.label });
            filters.sizes = filters.sizes.map(function(size){ return size.label });
            filters.genders = filters.genders.map(function(gender){ return gender.id });
            filters.customers = filters.customers.map(function(customer) { return customer.id });

            var totalFilters = filters.categories.length + filters.brands.length + filters.colors.length + filters.sizes.length +
                filters.genders.length + filters.customers.length;

            if ((filters.categories).length > 0) {
                vm.listFilter.categoryKeys = filters.categories;
                vm.listFilter.categoryKey = filters.categories[0];
            } else {
                vm.listFilter.categoryKeys = [];
            }

            if ((filters.colors).length > 0) {
                vm.listFilter.colors = filters.colors;
            } else {
                vm.listFilter.colors = [];
            }

            if ((filters.sizes).length > 0) {
                vm.listFilter.sizes = filters.sizes;
            } else {
                vm.listFilter.sizes = [];
            }

            if ((filters.genders).length > 0) {
                vm.listFilter.genders = filters.genders;
            } else {
                vm.listFilter.genders = [];
            }

            if ((filters.customers).length > 0) {
                vm.listFilter.customers = filters.customers;
            } else {
                vm.listFilter.customers = [];
            }

            if ((filters.brands).length > 0) {
                vm.listFilter.brands = filters.brands;
            } else {
                vm.listFilter.brands = [];
            }

            vm.listFilter.hasInventory = vm.hasInventory;
            vm.filters.hasInventory = vm.hasInventory;

            if (vm.viewByCategories !== options.viewByCategories){
                vm.changeView = true;
                vm.filters.viewByCategories = vm.viewByCategories;
            }

            vm.closeModal({filtered: filters, selectedFilters: angular.copy(vm.filters), totalFilters: totalFilters,
                listFilter: vm.listFilter, changeView: vm.changeView}, true);
        }

        function formatOptionsDict(optionsDict) {
            if (!optionsDict) {
                return {}
            }
            var count = 0;
            optionsDict.forEach(function(option) {
                if (typeof option === 'string' || option instanceof String) {
                    optionsDict[count] = {'label': option};
                } else if (!option.hasOwnProperty('label')){
                    if (option.hasOwnProperty('title')) {
                        option.label = option.title;
                    } else if (option.hasOwnProperty('fullName')) {
                        option.label = option.fullName;
                    } else {
                        option.label = option.name;
                    }
                }
                count++;
            });

            count = 1;
            optionsDict.forEach(function(option) {
                if(!option.hasOwnProperty('id')){
                    option.id = count;
                }
                count++;
            });
            return optionsDict;
        }

        function formatFilterOptions() {
            var categories = [];
            vm.filters.categories.map(function(category) {
                vm.categories.forEach(function(configured_category) { if (configured_category.key === category) {
                    categories.push({'label': configured_category.label, 'id': configured_category.id, 'title': configured_category.title, 'key': category})
                }});
            })
            vm.filters.categories = categories;

            var sizes = [];
            vm.filters.sizes.map(function(size) {
                vm.sizes.forEach(function(configured_size) { if (configured_size.label === size) { sizes.push({'label': size, 'id': configured_size.id}); }});
            })
            vm.filters.sizes = sizes;

            var brands = [];
            vm.filters.brands.map(function(brand) {
                vm.brands.forEach(function(configured_brand) { if (configured_brand.name === brand) { brands.push({'name': brand, 'label': brand, 'id': configured_brand.id}); }});
            })
            vm.filters.brands = brands;

            var colors = [];
            vm.filters.colors.map(function(color) {
                vm.colors.forEach(function(configured_color) { if (configured_color.label === color) { colors.push({'label': color, 'id': configured_color.id});}});
            })
            vm.filters.colors = colors;

            var genders = [];
            vm.filters.genders.map(function(gender) {
                vm.genders.forEach(function(configured_gender) { if (configured_gender.id === gender) { genders.push({'label': configured_gender.label, 'id': gender});}});
            })
            vm.filters.genders = genders;

            // var tags = [];
            // vm.filters.tags.map(function(tag) {
            //     vm.tags.forEach(function(configured_tag) { if (configured_tag.label === tag) { tags.push({'label': tag, 'id': configured_tag.id})}});
            // })
            // vm.filters.tags = tags;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('BagDetailController', BagDetailController);

    /** @ngInject */
    function BagDetailController($state, $timeout, $stateParams, $q, $window, $localStorage,
                                 StoreService, $scope, $translate, FlyersService, FlyerCategoryService, FlyersCurrencyValue,
                                 ShowcasesService, toastr, Principal, UserInteractModalFactory, ModalFactory, DOMAIN, $rootScope,
                                 BrandService, CustomerService, UserService, paginationConstants, $uibModal) {

        var vm = this;
        var userInteractModal;
        var storeId = $localStorage.defaultStore.storeId;
        var mainColor = getComputedStyle(document.documentElement).getPropertyValue('--main-color');
        vm.showcaseId = $stateParams.showcaseId;
        vm.isEditMode = vm.showcaseId ? true : false;

        vm.isFiltering = false;

        vm.currentPage = 1;
        vm.maxSize = 15;
        vm.numPerPage = vm.maxSize;
        vm.totalFlyers = 0;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;
        vm.banners = [];
        vm.haveBanners = false;
        vm.isMobile = detectar_mobile();

        var bagDefaultImg = getDefaultImageBagUrl();
        var bagDefaultImgData = '';

        function getDefaultImageBagUrl() {
            if ($localStorage.defaultStore.hubId == 25) {
                return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/storepiccadilly/image_default_bag.png'
            } else {
                return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/showkase/image_default_bag.png';
            }
        }

//		function loadCanvaAPI(c,a,n){
//			var w=c.createElement(a),s=c.getElementsByTagName(a)[0];
//			w.src=n;s.parentNode.insertBefore(w,s);
//		}
//
//		loadCanvaAPI (document,'script','https://sdk.canva.com/designbutton/v2/api.js');

        vm.paginationOptions = {
            page: vm.currentPage - 1,
            size: vm.numPerPage
        };

        vm.showcase = {
            'backgroundColor': false,
            flyers: [],
            ownerId: null,
            hasCover: false
        };

        vm.saveImageCover = true;
        vm.isPrinting = false;
        vm.tab = 1;
        vm.colors = [];
        vm.sizes = [];
        vm.excludes = [];
        vm.featureds = [];
        vm.tags = [];
        vm.genders = [];


        vm.isLoading = false;

        vm.filters = {
            brands: [],
            colors: [],
            configurations: [],
            sizes: [],
            categories: [],
            genders: [],
            tags: [],
            type: null,
            isLaunch: null,
            isBasic: null,
            text: ''
        }

        vm.numberFilterSelected = 0;

        vm.selectedFeatured = [];
        vm.sortOptions = paginationConstants.sortOptions[$translate.use().toLowerCase()];
        vm.selectedSortByOption = "";

        vm.onSelectedSortOption = function () {
            vm.currentPage = 1;
            vm.paginationOptions = {
                page: vm.currentPage - 1,
                size: vm.numPerPage
            };

            vm.filters.sortBy = vm.selectedSortByOption.value;
            vm.filters.sortDirection = vm.selectedSortByOption.direction;
            loadFlyers();
        }

        vm.closeDropDown = function () {
            $("md-backdrop").trigger('click');
        }

        vm.featuredChange = function () {
            if (vm.selectedFeatured.includes('launch')) {
                vm.filters.isLaunch = true;
            } else {
                vm.filters.isLaunch = false;
            }
            if (vm.selectedFeatured.includes('basic')) {
                vm.filters.isBasic = true;
            } else {
                vm.filters.isBasic = false;
            }
        };

        vm.getSelectedTextGender = function (filter) {
            var genderTranslate = '';
            if (filter[0] === 1) {
                genderTranslate = $translate.instant('flyers.new.form.gender.male');
            }
            if (filter[0] === 2) {
                genderTranslate = $translate.instant('flyers.new.form.gender.female');
            }
            if (filter[0] === 3) {
                genderTranslate = $translate.instant('flyers.new.form.gender.both');
            }
            if (filter.length == 1) {
                return '<span class="highlight">' + genderTranslate + '</span>';
            }
            if (filter.length > 1) {
                var temp = '  +';
                temp += filter.length - 1;
                temp += ' selecionados';
                return '<span class="highlight">' + genderTranslate + '</span>' +
                    '<span>&nbsp</span>' +
                    '<span class="highlight">' + temp + '</span>';
            }
            return '';
        }


        vm.getSelectedTextCategory = function (filter) {
            for (var i = 0; i < vm.categories.length; i++) {
				if (vm.categories[i].key === filter[0]){
		            if (filter.length == 1) {
		                return '<span class="highlight">' + vm.categories[i].title + '</span>';
		            }
		            if (filter.length > 1) {
		                var temp = '  +';
		                temp += filter.length - 1;
		                temp += ' selecionados';

		                return '<span class="highlight">' + vm.categories[i].title + '</span>' +
		                    '<span>&nbsp</span>' +
		                    '<span class="highlight">' + temp + '</span>';
		            }
		            return '';
				}
			}
            return '';
        }

        vm.getSelectedTextBrands = function (filter) {
            for (var i = 0; i < vm.brands.length; i++) {
                if (filter[0] && vm.brands[i].name === filter[0]){
                    if (filter.length == 1) {
                        return '<span class="highlight">' + vm.brands[i].name + '</span>';
                    }
                    if (filter.length > 1) {
                        var temp = '  +';
                        temp += filter.length - 1;
                        temp += ' selecionados';

                        return '<span class="highlight">' + vm.brands[i].name + '</span>' +
                            '<span>&nbsp</span>' +
                            '<span class="highlight">' + temp + '</span>';
                    }
                    return '';
                }
            }
            return '';
        }

        vm.getSelectedText = function (filter) {
            var elementTranslate = '';

            if (filter[0] === 'launch' || filter[0] === 'basic') {
                elementTranslate = $translate.instant('flyers.new.form.configurations.' + filter[0].toLowerCase());
            } else {
                elementTranslate = filter[0];
            }
            if (filter.length == 1) {
                return '<span class="highlight">' + elementTranslate + '</span>';
            }
            if (filter.length > 1) {
                var temp = '  +';
                temp += filter.length - 1;
                temp += ' selecionados';

                return '<span class="highlight">' + elementTranslate + '</span>' +
                    '<span>&nbsp</span>' +
                    '<span class="highlight">' + temp + '</span>';
            }
            return '';

        }

        vm.customers = [];

        vm.customer = {};

        vm.users = [];

        vm.user = {};

        vm.checkIfFilterSelected = function (filterKey, filter) {
            return (vm.filters[filterKey] ? vm.filters[filterKey] : []).indexOf(filter) >= 0 ? true : false;
        }

        vm.updateFilterOrRemove = function (filterKey, filter) {
            if (!vm.filters[filterKey]) {
                vm.filters[filterKey] = [];
            }
            var index = vm.filters[filterKey].indexOf(filter);
            if (index === -1) {
                vm.filters[filterKey].push(filter);
                return;
            }
            vm.filters[filterKey].splice(index, 1);
        }

        vm.checkIfLaunchSelected = function () {
            return vm.filters.isLaunch;
        }

        vm.updateLaunchOrRemove = function () {
            vm.filters.isLaunch = !vm.filters.isLaunch;
        }

        vm.checkIfBasicSelected = function () {
            return vm.filters.isBasic;
        }

        vm.updateBasicOrRemove = function () {
            vm.filters.isBasic = !vm.filters.isBasic;
        }

        vm.checkIfFlyerSelected = function (idFlyer) {
            return vm.excludes.includes(idFlyer);
        }

        vm.refreshSelectedFlyers = function (flyer) {
            var index = vm.excludes.indexOf(flyer.id);
            if (index >= 0) {
                vm.excludes.splice(index, 1);
                return;
            }
            vm.excludes.push(flyer.id);
        }

        vm.removeFromSelectedList = function (flyer) {
            var index = vm.excludes.indexOf(flyer);
            if (index > -1) {
                vm.excludes.splice(index, 1);
            }
        }

        vm.hasSome = function (list, arr) {
            if (arr) {
                return arr.some(function (v) {
                    return list.indexOf(v.id) >= 0;
                });
            }
        };

        vm.addPageToList = function () {
            if (vm.hasSome(vm.excludes, vm.flyersFiltered)) {
                for (var i = 0; i < vm.flyersFiltered.length; i++) {
                    vm.removeFromSelectedList(vm.flyersFiltered[i].id);
                }
            } else {


                var notIn = vm.flyersFiltered.filter(function (el) {
                    return vm.excludes.indexOf(el.id) < 0;
                });
                if (notIn && notIn.length) {
                    for (var i = 0; i < notIn.length; i++) {
                        vm.refreshSelectedFlyers(notIn[i]);
                    }
                } else {
                    for (var i = 0; i < vm.flyersFiltered.length; i++) {
                        vm.removeFromSelectedList(vm.flyersFiltered[i].id);
                    }
                }

            }
        }

        vm.makeTagsToFilter = function () {
            vm.filters.tags = vm.filters.tags ? vm.filters.tags.map(function (item) { return item.text ? item.text : item }) : [];
        }

        vm.filterFlyers = function () {
            countFilters();

            vm.flyersFiltered = [];
            vm.isFiltering = true;
            vm.filters.type = null;
            vm.makeTagsToFilter();

            ShowcasesService.findFlyerByFilterBag(vm.paginationOptions, vm.filters).then(function (response) {
                vm.isFiltering = false;
                vm.totalFlyers = response.totalElements;
                vm.flyersFiltered = response.content;

                vm.flyersFiltered.map(function (data) {
                    data.stock = data.inventory ? +data.inventory : 0;
                    if (data.details) {
                        data.stock += +data.details.reduce(function (a, b) {
                            return a + +b.inventory
                        }, 0)
                    }
                    vm.getCategoryName(data);
                })
                /**
                 * Verifica se o flyer possui estoque
                 */
                vm.flyersFiltered.forEach(function (flyer) {
                    if (flyer.details && flyer.details.length > 0) {

                        flyer.details.every(function (detail) {
                            flyer.hasInventory = detail.inventory === null || (detail.inventory !== null && detail.inventory > 0) ? true : false;
                            return !flyer.hasInventory;
                        });
                    } else {
                        flyer.hasInventory = flyer.inventory === null || (flyer.inventory !== null && flyer.inventory > 0) ? true : false;
                    }
                });
            });
        }

        vm.saveBag = function () {
            ShowcasesService.saveBag({
                showcaseTemplateId: 1,
                backgroundColor: mainColor,
                ownerId: 0,
                hasCover: true,
                userInteract: 'SALE',
                flyers: [],
                excludes: [],
                bagFilters: vm.filters
            });
        }

        vm.goToTabTwo = function () {
            if (!vm.showcase.id) {
                vm.saveBag
            }
        }

        vm.showcase = {
            'backgroundColor': false,
            flyers: [],
            ownerId: null,
            hasCover: false
        };

        vm.listFilter = {
            storeId: storeId,
            activated: null,
            type: null
        };

        // if (!vm.showcaseId) {
        //     openShowcaseModalType();
        // }

        vm.openShowcaseModalType = openShowcaseModalType;

        vm.imageSize = 800;

        vm.storeOwnerHasMoipAccount = false;
        storeOwnerHasMoipAccount();
        vm.loadFlyers = loadFlyers;
        vm.dynamicPopover = {
            templateUrl: 'userInteractPopoverTemplate.html',
        };

        vm.coverEdit = true;
        vm.templateIsLoading = true;
        vm.showcases = [1, 2, 3, 4, 5, 6, 7, 8];
        vm.templates = [];
        vm.flyersToLoad = 1;
        vm.isSaving = false;
        vm.isSavingPreview = false;
        vm.showcaseColors = [
            [{
                color: "#201E1E",
                border: 0
            }, {
                color: "#363231",
                border: 0
            }, {
                color: "#4B4544",
                border: 0
            }, {
                color: "#870200",
                border: 0
            }, {
                color: "#05a19c",
                border: 0
            }, {
                color: "#37003C",
                border: 0
            }, {
                color: "#5A1846",
                border: 0
            }, {
                color: "#910D3F",
                border: 0
            }, {
                color: "#C70039",
                border: 0
            }, {
                color: "#263545",
                border: 0
            }],
            [{
                color: "#002A4A",
                border: 0
            }, {
                color: "#01201B",
                border: 0
            }, {
                color: "#015146",
                border: 0
            }, {
                color: "#1A5B28",
                border: 0
            }, {
                color: "#277B25",
                border: 0
            }, {
                color: "#331908",
                border: 0
            }, {
                color: "#D35400",
                border: 0
            }, {
                color: "#DF7F05",
                border: 0
            }, {
                color: mainColor,
                border: 0
            }]
        ];

        loadAll();

        vm.goToSettings = function () {
            $state.go('settings');
        }

        vm.tabClick = function (tab) {
            if (vm.showcaseId && tab === 2) {
                vm.filterFlyers();
            } else if (!vm.showcase.name) {
                toastr.warning($translate.instant('bag.error.no-bag-name'));
                return;
            } else if (tab === 2) {
                vm.saveFlyerPreview();
                return;
            }
            vm.tab = tab;
            vm.loadingTab = true;
        }


        function removeInvalidFilter(key, validOptions, listFilter) {
            var validItens = [];
            if (key && validOptions) {
                validOptions.forEach(function(category) {
                    validItens.push(category[key]);
                });
            } else {
                validItens = validOptions;
            }
            if (listFilter){
                listFilter.forEach(function(obj) {
                    if (!(validItens.includes(obj))) {
                        var index = listFilter.indexOf(obj);
                        listFilter.splice(index, 1);
                    }
                });
            }
        }

        function verifyFilters() {
            removeInvalidFilter('key', vm.categories, vm.filters.categories);
            removeInvalidFilter('name', vm.brands, vm.filters.brands);
            removeInvalidFilter(null, vm.sizes, vm.filters.sizes);
            removeInvalidFilter(null, vm.colors, vm.filters.colors);
        }

        function countFilters(){
            verifyFilters();

            vm.numberFilterSelected = vm.filters.colors.length + vm.filters.categories.length + vm.filters.brands.length +
                vm.filters.sizes.length + vm.filters.genders.length + vm.filters.tags.length;
            if (vm.filters.isLaunch) vm.numberFilterSelected += 1;
            if (vm.filters.isBasic) vm.numberFilterSelected += 1;
        }

        function getLoggedUser() {
            Principal.identity().then(function(account) {
                vm.users.push(account);
            });
        }

        function loadAll() {
			FlyersService.getAllFiltersFlyer().then(function (response) {
				vm.colors = response.data.colors;
				vm.sizes = response.data.sizes;
				vm.featureds = response.data.features;
				vm.tags = response.data.tags;
				vm.genders = response.data.genders;
                getBase64Image(bagDefaultImg);
            });

            BrandService.getBrandsByCurrentStore().then(function (response) {
                vm.brands = response.data;
            });

            FlyerCategoryService.listCategoriesByCurrentStore($translate.use()).then(function (response) {
                vm.categories = response.data;
            });

            vm.templateId = 1; // Chose the first template as default
            ShowcasesService.getTemplates().then(function (response) {
                vm.templates = response;
            });

            if (vm.showcaseId) {
                loadShowcase().then(function () {
                    loadFlyers();
                });
            } else {

                vm.showcase.ownerId = storeId;
                vm.showcase.backgroundColor = mainColor;
                vm.showcase.showcaseTemplateId = vm.templateId;
                vm.templateIsLoading = false;
                if(!vm.showcase.bagFilters || (vm.showcase.bagFilters && !vm.showcase.bagFilters.type)) {
                    vm.filters.type = 'SALE';
                }
                loadFlyers();
                getLoggedUser();
            }

            StoreService.getOwnerCategoryCurrentStore().then(function (response) {
                vm.storeCategory = response.data;
            });

        }

        function loadShowcase() {
            return ShowcasesService.getShowcase(vm.showcaseId).then(function (response) {
                vm.showcase = response;
                vm.customers = vm.showcase.customers;
                vm.users = vm.showcase.users;
                vm.filters = vm.showcase.bagFilters;
                vm.showcase.bagFilters.tags = vm.showcase.bagFilters.tags.map(function (tag) { return { text: tag } });
                vm.excludes = vm.showcase.flyers.map(function (data) { return data.id });
                if (vm.showcase.bagFilters && vm.showcase.bagFilters.isBasic) {
                    vm.selectedFeatured.push('basic')
                }
                if (vm.showcase.bagFilters && vm.showcase.bagFilters.isLaunch) {
                    vm.selectedFeatured.push('launch')
                }
                if(!vm.showcase.bagFilters || (vm.showcase.bagFilters && !vm.showcase.bagFilters.type)) {
                    vm.filters.type = 'SALE';
                }
                vm.excludes = vm.showcase.flyers.map(function(data) {return data.id}) ;

                vm.showcase.userInteract = vm.originalUserInteract ? vm.originalUserInteract : vm.showcase.userInteract;

                if(vm.showcase.banners != null && vm.showcase.banners.length > 0) {
                    vm.banners = vm.showcase.banners;
                    vm.haveBanners = true;
                    vm.showcase.banners.forEach(function(banner, i) {
                        vm.banners[i].image = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].cover;

                        if (vm.banners[i].coverMobile) {
                            vm.banners[i].imageMobile = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].coverMobile;
                        }
                    })
                } else if (vm.showcase.hasCover && vm.showcase.coverUrl !== '') {
                    checkImage(function (url) {
                        vm.banners.push({'id': 1, 'image': url, 'name': '', 'link': ''});
                        loadCarousel();
                    });
                    vm.haveBanners = true;
                }

                loadCarousel();
                loadShowcasesFlyers();
            });
        }

        vm.getProfileName = function(user) {
            var profiles = user.userProfiles.filter(function (prof) {
                return prof.storeId === storeId; 
            });

            return profiles && profiles.length > 0 ? (" - " + profiles[0].profileName) : "";
        }

        vm.checkFlyerIsSelected = function (id) {
            if (vm.flyersMap) {
                if (vm.flyersMap[id]) {
                    return true;
                } else {
                    return false;
                }
            }
        };

        vm.changeFlyerSelected = function (flyer) {
            if (vm.flyersMap) {
                if (vm.flyersMap[flyer.id]) {
                    vm.showcase.flyers.splice(vm.flyersMap[flyer.id].pos, 1);
                    loadShowcasesFlyers();
                } else {
                    vm.showcase.flyers.splice(0, 0, flyer);
                    loadShowcasesFlyers();
                }
            } else {
                vm.showcase.flyers.splice(0, 0, flyer);
                loadShowcasesFlyers();
            }
        };

        vm.changeTemplate = function (templateId) {
            vm.templateIsLoading = true;
            vm.templateId = templateId;
            loadTemplate().then(function () {
                vm.showcase.showcaseTemplateId = templateId;
                loadFlyersToTemplate(angular.copy(vm.showcase.flyers));
            });
        };

        function changeMaxFlyerPerShowcase() {
            vm.maxFlyersPerShowcase = vm.template.quantityOfRows * (12 / vm.template.row.items[0].size);
        }

        vm.getImageSrc = function (templateId) {
            return 'content/images/templates/' + templateId + '.png';
        };


        function succesPrint(res) {

            var saveByteArray = (function() {
                return function (data, name, mimeType) {
                    var blob = new Blob(data, {
                        type: mimeType
                    });
                    var url = window.URL.createObjectURL(blob);
                    var element = angular.element('<a/>');
                    element.attr({
                        href: url,
                        target: '_blank',
                        download: name
                    });
                    if (document.createEvent) {
                        var ev = document.createEvent("MouseEvent");
                        ev.initMouseEvent("click",
                            true /* bubble */,
                            true /* cancelable */,
                            window,
                            null,
                            0, 0, 0, 0, /* coordinates */
                            false,
                            false,
                            false,
                            false,
                            0 /* left */,
                            null);
                        element[0].dispatchEvent(ev);
                    } else {
                        element[0].fireEvent("onclick");
                    }
                    setTimeout(function () {
                        document.body.removeChild;
                        window.URL.revokeObjectURL(url);
                    }, 200);
                };
            }());
            if (res.headers["content-disposition"]) {
                var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                var mimeType = res.headers["content-type"];
                filename = filename.replace(/['"]/g, '');
                saveByteArray([res.data], filename, mimeType);
            } else {
                toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
            }

            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
        }

        function errorPrint(response) {
            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
            toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));

        }

        vm.generateTabloid = function () {
            vm.saveFlyer(false, function () {
                if (!vm.showcase.hasCover) {
                    toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                    vm.isSaving = false;
                } else if (vm.showcase.flyers.length < 1) {
                    toastr.error($translate.instant('showcases.messages.errors.blankFlyers'));
                } else if (!vm.showcase.name) {
                    toastr.error($translate.instant('showcases.messages.errors.blankName'));
                } else {
                    vm.isPrinting = true;
                    buildMessageGeneratedTabloid();
                    $rootScope.$emit('waiting-generates-tabloid');
                    ShowcasesService.generateTabloid({
                        showcaseId: Number(vm.showcase.id) || undefined,
                        storeId: (storeId ? storeId + "" : undefined) || undefined,
                        flyers: vm.showcase.flyers.map(function (flyer) {
                            return flyer.id;
                        })
                    }).then(succesPrint, errorPrint);
                }
            });
        }

        function loadShowcasesFlyers() {
            if (vm.showcase.flyers) {
                vm.flyerId = 0;
                if (vm.showcase.showcaseTemplateId) {
                    vm.templateId = vm.showcase.showcaseTemplateId;
                }
                reduceFlyersToMap();
                vm.showcase.flyers.forEach(function (flyer) {
                    vm.getCategoryName(flyer);
                    var random = new Date().getTime();
                    flyer.imagePath = '/flyer/api/' + flyer.id + '/picture?type=large&ts=' + random;
                });
                $q.all(vm.showcase.flyers).then(function (flyers) {
                    loadTemplate().then(function () {
                        loadFlyersToTemplate(flyers);
                    });
                });
            }
        }

        function reduceFlyersToMap() {
            var index = 0;
            vm.flyersMap = vm.showcase.flyers.reduce(function (map, flyer) {
                map[flyer.id] = {
                    name: flyer.name,
                    pos: index
                };
                index++;
                return map;
            }, {})
        }

        function loadFlyerTemplateRows() {
            vm.template.rows = [];
            for (var i = 0; i < vm.template.quantityOfRows; i++) {
                var item = {};
                angular.copy(vm.template.row, item);
                vm.template.rows.push(item);
            };
        }

        function loadFlyersToTemplate(flyers) {
            // loadFlyerTemplateRows();
            $q.all(vm.template.rows).then(function (data) {

                for (var i = 0; i < vm.template.rows.length && flyers.length > 0; i++) {
                    for (var k = 0; k < vm.template.rows[i].items.length && flyers.length > 0; k++) {
                        if (vm.template.rows[i].items[k]) {
                            if (flyers.length > 0) {
                                vm.template.rows[i].items[k].flyer = flyers[0];
                                flyers.splice(0, 1);
                            }
                        }
                    }
                }
            });
            $q.all(vm.template).then(function (data) {
                vm.templateIsLoading = false;
            });

        }

        function loadTemplate() {
            return ShowcasesService.getTemplate(vm.templateId).then(function (response) {
                vm.template = response;
                changeMaxFlyerPerShowcase();
                loadFlyerTemplateRows();

            });
        }


        function openShowcaseModalType() {
            userInteractModal = UserInteractModalFactory.selectUserInterectType(storeId, vm.showcase.userInteract);
            userInteractModal.result.then(function (userInteract) {

                vm.originalUserInteract = angular.copy(vm.showcase.userInteract);
                vm.showcase.userInteract = userInteract;

                vm.listFilter.type = vm.showcase.userInteract;
                if (!(vm.originalUserInteract && vm.originalUserInteract === vm.showcase.userInteract)) {
                    vm.flyersInfo = null;
                    vm.flyersFiltered = [];
                    vm.flyersMap = undefined;
                    vm.showcase.flyers = [];
                    loadFlyers();
                    loadShowcasesFlyers();
                }
            });
        }

        function loadFlyers() {
            vm.filterFlyers();
            vm.isLoading = true;
        }

        vm.getShowcasesFlyer = function () {
            vm.saveFlyer(true);
        }

        vm.goToFlyerByShowkase = function () {
            vm.saveFlyer(true);
        }

        vm.goToList = function () {
            $state.go('bag');
        }

        vm.saveFlyerPreview = function (isRedirectToFlyersScreen, callback) {
            vm.showcase.showcaseTemplateId = 1;
            if (vm.showcase.name) {
                vm.isSaving = true;
                vm.showcase.cover = "";
                vm.saveCover(function () {
                    if (vm.showcase.addImageFileDTO.length > 0) {
                        var banners = angular.copy(vm.showcase.addImageFileDTO);
                        vm.showcase.addImageFileDTO.forEach(function (banner, index) {
                            banners[index].nameFile = vm.banners[index].name;
                            banners[index].action = vm.banners[index].link;
                        });
                        vm.showcase.addImageFileDTO = banners;

                        vm.showcase.flyers = [];
                        vm.filters.excludes = vm.excludes;
                        vm.makeTagsToFilter();
                        vm.showcase.bagFilters = vm.filters;
                        vm.showcase.customers = vm.customers.map(function (item) { return + item.id });
                        vm.showcase.users = vm.users.map(function (item) { return + item.id });

                        if (vm.showcaseId) {
                            vm.isFiltering = true;
                            vm.showcase.bagFilters.apply = true;
                            vm.showcase.customers = vm.customers.map(function (item) { return +item.id });
                            var reversedUsers = vm.users.map(function (item) { return +item.id });
                            vm.showcase.users = reversedUsers.reverse();

                            ShowcasesService.updateShowcase(vm.showcase).then(function (data) {
                                vm.showcase = data;
                                vm.banners = data.banners;
                                vm.showcase.banners.forEach(function(banner, i) {
                                    vm.banners[i].image = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].cover;

                                    if (vm.banners[i].coverMobile) {
                                        vm.banners[i].imageMobile = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].coverMobile;
                                    }
                                })
                                if (isRedirectToFlyersScreen) {
                                    $state.go('bag', {
                                        showcaseId: data.id
                                    });
                                } else {
                                    vm.showcaseId = data.id;
                                    // toastr.success($translate.instant('showcases.messages.update.success'));
                                    vm.isSaving = false;
                                    vm.tabClick(2);
                                }
                                if (callback) {
                                    callback(true);
                                }
                                // vm.showcase.flyers = flyers;
                                vm.isSavingPreview = false;
                            }, function (data) {
                                toastr.error($translate.instant('bag.error.filter'));
                                vm.isSaving = false;
                            }).finally(function () { vm.isSaving = false; });
                        } else {
                            vm.isFiltering = true;

                            var reversedUsers = vm.users.map(function (item) { return +item.id });
                            ShowcasesService.saveBag({
                                showcaseTemplateId: 1,
                                backgroundColor: mainColor,
                                ownerId: 0,
                                hasCover: true,
                                userInteract: 'SALE',
                                flyers: [],
                                bagFilters: vm.filters,
                                name: vm.showcase.name,
                                addImageFileDTO: vm.showcase.addImageFileDTO,
                                customers: vm.customers.map(function (item) { return +item.id }),
                                users: reversedUsers.reverse()
                            }).then(function (data) {
                                vm.showcase = data;
                                vm.showcaseId = data.id;
                                vm.showcase.customers = vm.customers.map(function (item) { return +item.id });
                                vm.showcase.users = vm.users.map(function (item) { return +item.id });
                                vm.tabClick(2);
                            }, function (data) {
                                toastr.error($translate.instant('bag.error.filter'));
                                vm.isSavingPreview = false;
                            }).finally(function () {  vm.isSaving = false;});
                        }
                    } else if (!vm.showcase.cover) {
                        vm.isSaving = false;
                        toastr.warning($translate.instant('Insira um estilo para a mala'));
                    }
                });
            } else if (!vm.showcase.name) {
                toastr.warning($translate.instant('Insira o nome da Mala'));
            }
        }

        vm.saveFlyer = function (isRedirectToFlyersScreen, callback, isSaving) {
            vm.showcase.flyers = [];
            vm.filters.excludes = vm.excludes;

            vm.makeTagsToFilter()
            vm.showcase.bagFilters = vm.filters;
            vm.showcase.bagFilters.apply = true;
            vm.isFiltering = true;
            if (vm.showcaseId) {
                vm.saveCover(function () {
                    var banners = angular.copy(vm.showcase.addImageFileDTO);
                    vm.showcase.addImageFileDTO.forEach(function (banner, index) {
                        banners[index].nameFile = vm.banners[index].name;
                        banners[index].action = vm.banners[index].link;
                    });
                    vm.showcase.addImageFileDTO = banners;
                    vm.showcase.customers = vm.customers.map(function (item) { return +item.id });
                    vm.showcase.users = vm.users.map(function (item) { return +item.id });
                    ShowcasesService.updateShowcase(vm.showcase).then(function (data) {
                        vm.showcase = data;
                        vm.banners = vm.showcase.banners;
                        vm.showcase.banners.forEach(function(banner, i) {
                            vm.banners[i].image = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].cover;

                            if (vm.banners[i].coverMobile) {
                                vm.banners[i].imageMobile = vm.showcase.coverUrl.split("showcase")[0] + vm.banners[i].coverMobile;
                            }
                        })

                        if (isRedirectToFlyersScreen) {
                            toastr.success($translate.instant('Sua mala está pronta!'));
                            $state.go('bag', {
                                showcaseId: data.id
                            });
                        } else {
                            toastr.success($translate.instant('Sua mala está pronta!'));
                            vm.isSaving = false;
                            vm.isFiltering = false;
                            // Follow the instruction of Jackson, when saves the showcase the state doesn't need to be changed
                            // $state.go('showcases');
                        }
                        if (callback) {
                            callback(true);
                            vm.isFiltering = false;
                        }
                        vm.isFiltering = false;

                    }, function (data) {
                        if (isRedirectToFlyersScreen) {
                            toastr.error($translate.instant('Erro ao tentar atualizar sua mala'));
                            vm.isSaving = false;
                            vm.isFiltering = false;
                        }
                    });
                });
            }
        }

        vm.setBackgroundColor = function (color) {
            vm.showcase.backgroundColor = color;
        }

        vm.getCategoryName = function (flyer) {
            var category = _.find(vm.categories, function(el) {return el.key === flyer.categoryKey});
            if (category) {
                flyer.category = category.title;
            }
        }

        vm.getFlyerCurrency = function (currency) {
            return FlyersCurrencyValue[currency];
        }

        vm.getFlyerImageURL = function (flyer) {
            flyer.imagePath = FlyersService.getFlyerImageURL(flyer.id);
        }

        vm.loadFlyer = function () {
            vm.flyerId++;
            vm.flyersToLoad--;
        }

        vm.checkIfShowcasePublished = function () {
            if (vm.showcase.published) {
                return true;
            } else {
                return false;
            }
        }

        vm.getBackgroundImg = function (flyerId) {
            return ('\'/flyer/api/' + flyerId + '/picture\'');
        }

        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId);
        }

        vm.getTranslateFeatureds = function (featured) {
            return 'flyers.new.form.configurations.' + featured.toLowerCase();
        }

        vm.getTranslateGenders = function (gender) {
            if (gender === 1) {
                return 'flyers.new.form.gender.male';
            }
            if (gender === 2) {
                return 'flyers.new.form.gender.female';
            }
            if (gender === 3) {
                return 'flyers.new.form.gender.both';
            }
            return '';
        }

        function showMessagePublishShowcase() {
            if (!$localStorage.defaultStore.storeNickname) {
                getStoreInfo().then(function (response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    buildMessagePublishShowcase();
                });
            } else {
                buildMessagePublishShowcase();
            }
        }

        function buildMessagePublishShowcase() {
            ModalFactory.openModal(null,
                $translate.instant('showcases.messages.publish.successTitle', {
                    showcaseType: $translate.instant('global.showcaseTypes.' + vm.showcase.userInteract)
                }),
                $translate.instant('showcases.messages.publish.successSubtitle', {
                    url: 'http://' + $localStorage.defaultStore.storeNickname.toLowerCase() + "." + getDomainNameSufix($window)
                }),
                null, $translate.instant('showcases.messages.publish.goToShowcase'),
                'OK', function () { $window.open('http://' + $localStorage.defaultStore.storeNickname.toLowerCase() + "." + getDomainNameSufix($window), '_blank'); },
                null, null, 'icon-ksc-showcasepublished');
        }

        function buildMessageGeneratedTabloid() {
            ModalFactory.openModal(null,
                'showcases.messages.tabloid.readyTabloid',
                null, null, 'OK', null, 'close', null, null, null,
                'showcases.messages.tabloid.ifNotDownloaded', 'showcases.messages.tabloid.clickHere',
                function (callback) {
                    ShowcasesService.generateTabloid({
                        showcaseId: Number(vm.showcase.id) || undefined,
                        storeId: (storeId ? storeId + "" : undefined) || undefined,
                        flyers: vm.showcase.flyers.map(function (flyer) {
                            return flyer.id;
                        })
                    }).then(function (res) {
                        var saveByteArray = (function () {
                            return function (data, name, mimeType) {
                                var blob = new Blob(data, {
                                    type: mimeType
                                });
                                var url = window.URL.createObjectURL(blob);
                                var element = angular.element('<a/>');
                                element.attr({
                                    href: url,
                                    target: '_blank',
                                    download: name
                                });
                                if (document.createEvent) {
                                    var ev = document.createEvent("MouseEvent");
                                    ev.initMouseEvent("click", true /* bubble */, true /* cancelable */, window, null, 0, 0, 0, 0, /* coordinates */
                                        false, false, false, false,
                                        /*
                                         * modifier keys
                                         */
                                        0 /* left */, null);
                                    element[0].dispatchEvent(ev);
                                } else {
                                    element[0].fireEvent("onclick");
                                }
                                setTimeout(function () {
                                    document.body.removeChild;
                                    window.URL.revokeObjectURL(url);
                                }, 200);
                            };
                        }());
                        if (res.headers["content-disposition"]) {
                            var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                            var mimeType = res.headers["content-type"];
                            filename = filename.replace(/['"]/g, '');
                            saveByteArray([res.data], filename, mimeType);
                        } else {
                            toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
                        }
                        vm.isPrinting = false;
                        callback();
                    }, function (response) {
                        vm.isPrinting = false;
                        callback();
                    });
                }, 'width: 143px; height: 170px;', 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/' + $rootScope.urlImage + '/download-tabloide.png');
        }

        function storeOwnerHasMoipAccount() {
            Principal.storeOwnerHasMoipAccount().then(function (responseMoipAccount) {
                vm.storeOwnerHasMoipAccount = responseMoipAccount.data != null && responseMoipAccount.data.moipLogin != null;
            });
        }

        vm.publishShowcase = function () {
            vm.isPublishing = true;
            if (!vm.showcase.hasCover && vm.coverEdit) {
                toastr.warning($translate.instant('showcases.messages.errors.blankCover'));
                vm.isSaving = false;
                vm.isPublishing = false;
            } else if (vm.showcase.flyers.length < 1) {
                toastr.warning($translate.instant('showcases.messages.errors.blankFlyers'));
                vm.isPublishing = false;
                vm.isSaving = false;
            } else if (!vm.showcase.name) {
                toastr.warning($translate.instant('showcases.messages.errors.blankName'));
                vm.isPublishing = false;
                vm.isSaving = false;
            } else {
                vm.saveFlyer(false, function () {
                    ShowcasesService.publishShowcase(vm.showcase.id).then(function (data) {
                        vm.isPublishing = false;
                        showMessagePublishShowcase();
                        $state.go('showcases');
                    }, function (data) {
                        if (data.headers("errorKey")) {
                            toastr.error($translate.instant('showcases.messages.publish.errors.' + data.headers("errorKey")));
                        } else {
                            toastr.error($translate.instant('showcases.messages.publish.errors.genericError'));
                        }

                        vm.isPublishing = false;
                    });
                });
            }
        }

        vm.openInput = function (evt) {
            document.getElementById('fileInput').click();
        }

        vm.getPreviewURL = function (showcase) {
            if (showcase.id) {
                vm.openPreviewURL();
            } else {
                if (vm.saveFlyerPreview(false, function (data) {
                    if (data) {
                        $timeout(function (data) {
                            vm.openPreviewURL();
                        }, 1000);
                    }
                }));
            }
        };

        vm.openPreviewURL = function () {
            $window.open('http://' + $localStorage.defaultStore.storeNickname + '.showkase.com.br/preview/' + vm.showcase.id, '_blank');
        };

        function checkImage(callback) {
            var image = new Image();
            image.onload = function () {
                if (this.width > 0) {
                    callback(vm.showcase.coverUrl);
                }
            }
            image.onerror = function () {
                callback(bagDefaultImg);
            }
            image.src = vm.showcase.coverUrl;
        }

        function loadCarousel() {
            var carousel = document.getElementById("carousel");

            while(carousel.firstChild) {
                carousel.removeChild(carousel.firstChild);
            }

            var counter = vm.banners.length;
            if(counter > 0) {
                carousel.style.display = 'block';
                var reversedBanners = vm.banners.slice().reverse();
                reversedBanners.forEach(function (banner) {
                    var name = "";
                    if(banner.name != null) {
                        name = banner.name;
                    }
                    if (name.length > 20) {
                        name = name.slice(0, 20).concat('...');
                    } else if (name.length == 0) {
                        name = "[SEM NOME]"
                    }

                    var srcImage = banner.image;
                    if (srcImage.split(',')[0].indexOf('base64') == -1) {
                        srcImage += '?dummy=' + new Date().getTime();
                    }
                    carousel.insertAdjacentHTML(
                        "afterbegin",
                        ' <div class="carousel__item" style=" height: 100%; width: 100%;"> ' +
                        '<img id="img" style=" width: 100%; object-fit: cover; max-height: 100%;" src="' + srcImage + '"  alt="">  ' +
                        '<div style="width: 100%; position: absolute; bottom: 0; left: 0; text-align: center;" class="hidden-xs hidden-sm"> ' +
                        '<div class="carousel__title col-md-5">' + counter + 'º Banner <span class="carrousel__banner__name"> - ' + name + ' </span> ' +
                        '<span class="fa fa-edit" style="z-index: 10; color: #5b5b5b !important;"> </span> ' +
                        '<span class="fa fa-trash" style="z-index: 10; color: #5b5b5b !important; margin-left: 8px"> </span> </div> </div> </img> </div> '
                    );
                    counter--;
                });

                var items = carousel.querySelectorAll(".carousel__item");

                var buttonsHtml = Array.from(items, function () {
                    return '<span class="carousel__button"></span>';
                });

                carousel.insertAdjacentHTML(
                    "beforeend",
                    ' <div class="carousel__nav">' + buttonsHtml.join("") + ' </div> ' );

                var carouselButtons = carousel.querySelectorAll(".carousel__button");
                carouselButtons.forEach(function (button, i) {
                    button.addEventListener("click", function() {
                        // un-select all the items
                        items.forEach(function (item) {
                            item.classList.remove("carousel__item--selected")
                        });
                        carouselButtons.forEach(function (button) {
                            button.classList.remove("carousel__button--selected")
                        });

                        items[i].classList.add("carousel__item--selected");
                        button.classList.add("carousel__button--selected");
                        vm.selectedBanner = i;
                    });
                });

                // Select the first item on page load
                items[0].classList.add("carousel__item--selected");
                carouselButtons[0].classList.add("carousel__button--selected");

                // ARROW BUTTONS
                if (reversedBanners.length > 1) {
                    carousel.insertAdjacentHTML(
                        "beforeend",
                        ' <div class="backward_button arrow_buttons col-md-1"> <i class="fa fa-chevron-left carousel_arrows"></i> </div> ' );

                    carousel.insertAdjacentHTML(
                        "beforeend",
                        ' <div class="forward_button arrow_buttons col-md-1" style="margin-left: 91%"> <i class="fa fa-chevron-right carousel_arrows"></i> </div> ' );

                    var backwardButton = carousel.querySelectorAll(".backward_button");
                    backwardButton.forEach(function (button, i) {
                        button.addEventListener("click", function (){
                            // un-select all the items
                            items.forEach(function (item) {
                                item.classList.remove("carousel__item--selected")
                            });
                            carouselButtons.forEach(function (button) {
                                button.classList.remove("carousel__button--selected")
                            });

                            var index = vm.selectedBanner -= 1;
                            if (index < 0) {
                                index = 0;
                            }
                            vm.selectedBanner = index;
                            items[index].classList.add("carousel__item--selected");
                            carouselButtons[index].classList.add("carousel__button--selected");
                        });
                    });

                    var forwardButton = carousel.querySelectorAll(".forward_button");
                    forwardButton.forEach(function (button, i) {
                        button.addEventListener("click", function () {
                            // un-select all the items
                            items.forEach(function (item) {
                                item.classList.remove("carousel__item--selected")
                            });
                            carouselButtons.forEach(function (button){
                                button.classList.remove("carousel__button--selected")
                            });

                            var index = vm.selectedBanner += 1;
                            if (index > reversedBanners.length - 1) {
                                index = reversedBanners.length - 1;
                            }
                            vm.selectedBanner = index;
                            items[index].classList.add("carousel__item--selected");
                            carouselButtons[index].classList.add("carousel__button--selected");
                        });
                    });
                }


                vm.selectedBanner = 0;

                // BUTTON ACTIONS
                var editButtons = carousel.querySelectorAll(".fa-edit");
                editButtons.forEach(function (button, i) {
                    button.addEventListener("click", function() {
                        openBannersModal();
                    });
                });

                var trashButtons = carousel.querySelectorAll(".fa-trash");
                trashButtons.forEach(function (button, i) {
                    button.addEventListener("click", function(){
                        removeBanner(i);
                    });
                });

            }
        }

        function openBannersModal() {
            vm.openAddBannersModal();
        }

        function removeBanner(index) {
            var carousel = document.getElementById("carousel");
            var height = carousel.clientHeight;
            carousel.style.minHeight = height + "px";

            if (vm.banners.length > 1) {
                vm.banners.splice(index, 1);
                if (vm.showcase.banners) {
                    vm.showcase.banners.splice(index, 1);
                }
                loadCarousel();
            }
        }

        var handleFileSelect = function (evt) {

            var file = evt.currentTarget.files[0];
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    vm.imageUpload = evt.target.result;
                    loadImageToCroppieByBase64(evt.target.result);
                });
            };
            reader.readAsDataURL(file);
        };


        vm.initShowcase = function () {
            angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
        };

        var getBase64Image = function (url) {
            var img = new Image();
            img.setAttribute('crossOrigin', 'anonymous');
            img.onload = function () {
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL("image/png");
                bagDefaultImgData = dataURL;
            }
            img.src = url
        }

        vm.saveCover = function (callback) {
            vm.showcase.addImageFileDTO = [];
            if(vm.banners && vm.banners.length == 0) {
                vm.banners = [{'image': bagDefaultImgData, 'name': '', 'link': ''}];
            }

            var arr = Array.from(Array(vm.banners.length).keys());
            var aux = [];
            var index = 0;
            var orderNumber = 0;
            var blob = dataURItoBlob(vm.banners[index].image);
            var mobileImage = vm.banners[index].imageMobile;
            saveFlyerMultiImage(blob, arr, aux, index, orderNumber, mobileImage, callback);
        }

        function saveFlyerMultiImage(blob, arr, aux, i, orderNumber, hasMobileImage, callback) {
            if (i === vm.banners.length) return;

            hasMobileImage = vm.banners[i].imageMobile;
            blob = dataURItoBlob(vm.banners[i].image);

            FlyersService.saveFlyerMultiImage(blob, i).then(function (response) {
                $timeout(function () {
                    if (response.data) {
                        aux.push('');
                        vm.showcase.hasCover = true;
                        if (hasMobileImage) {
                            var blobImageMobile = dataURItoBlob(vm.banners[i].imageMobile);
                            orderNumber = orderNumber + 1;
                            FlyersService.saveFlyerMultiImage(blobImageMobile, orderNumber).then(function (responseMobile) {
                                if (responseMobile) {
                                    response.data.mobileImageFile = responseMobile.data;
                                    arr[response.data.orderNumber] = response.data;
                                    if (aux.length === vm.banners.length) {
                                        vm.showcase.addImageFileDTO = arr;
                                        callback();
                                    }
                                    i = i + 1;
                                    saveFlyerMultiImage(blob, arr, aux, i, orderNumber, hasMobileImage, callback);
                                }
                            });
                        } else {
                            response.data.hasMobileImage = false;
                            arr[response.data.orderNumber] = response.data;
                            orderNumber = orderNumber + 1;
                            if (aux.length === vm.banners.length) {
                                vm.showcase.addImageFileDTO = arr;
                                callback();
                            }
                            i = i + 1;
                            saveFlyerMultiImage(blob, arr, aux, i, orderNumber, hasMobileImage, callback);
                        }
                    } else {
                        toastr.error($translate.instant('flyers.messages.create.error'));
                    }
                    vm.loadingImage = false;
                });
            }, function (response) {
                toastr.error($translate.instant('flyers.messages.create.image.uploadError'));
                vm.loadingImage = false;
            });
        }

        function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(dataURI.split(',')[1]);
            else
                byteString = unescape(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {
                type: mimeString
            });
        }

        vm.changePage = function () {

            var begin = ((vm.currentPage - 1) * vm.numPerPage),
            end = begin + vm.numPerPage;

            vm.paginationOptions.page = vm.currentPage - 1;

            vm.filterFlyers();
            vm.startRegistry = begin + 1;
            vm.endRegistry = end;

        }

        window.onDesignPublishCallback = function (data) {
            var exportUrl = data.exportUrl;
            var designId = data.designId;
            loadImageToCroppieByURLCanvas(exportUrl);
            //sendDataViaAjax (exportUrl, designId);
        }

        $scope.$on("$destroy", function () {
            if (!angular.isUndefined(userInteractModal)) {
                userInteractModal.close();
            }
        });

        vm.changeCustomer = function (value) {
            if (value) {
                vm.customer.fullName = value.trim();
            } else {
                vm.customer.fullName = null;
            }
        }

        vm.selectedCustomer = function (item) {
            if (item) {
                var customerFinded = vm.customers.find(function (c) { return c.id == item.originalObject.id });
                if (!customerFinded) {
                    vm.customers.push(item.originalObject)
                }
            }
        }

        vm.changeUser = function (value) {
            if (value) {
                vm.user.fullName = value.trim();
            } else {
                vm.user.fullName = null;
            }
        }

        vm.selectedUser = function (item) {
            if (item) {
                var userFinded = vm.users.find(function (c) { return c.id == item.originalObject.id });
                if (!userFinded) {
                    vm.users.push(item.originalObject)
                }
            }
        }

        vm.removeUser = function (user) {
            vm.users = vm.users.filter(function(item) { return item.id != user.id })
        }

        vm.requestParams = function (query) {
            return {
                page: 0,
                size: 10,
                storeId: storeId,
                search: query
            }
        }

        vm.removeCustomer = function (customer) {
            vm.customers = vm.customers.filter(function(item) { return item.id != customer.id })
        }

        vm.createCustomer = function () {
            if (vm.customer.fullName && vm.customer.phone) {
                vm.customer.storeId = storeId;
                CustomerService.create(vm.customer).then(function(result) {
                    toastr.success($translate.instant('bag.success.customer-save'))
                    vm.customers.push(result.data);
                    vm.customer = {};
                    vm.clearAutocompleteField();
                })
            }
        }

         vm.clearAutocompleteField = function() {
            var input = document.getElementById("customer_value");
            input.value = "";
        }

        function formatModalFilters(filters) {
            if (!filters) return null;

            var sizes = [];
            if (filters.sizes.length > 0) {
                filters.sizes.map(function(size) { sizes.push(size.label) });
                filters.sizes = sizes;
            }

            vm.selectedFeatured = [];
            if(filters.configurations.length > 0) {
                var configurations = [];
                filters.configurations.map(function(config) { configurations.push(config.code)});
                if(configurations.includes('launch')) {
                    filters.isLaunch = true;
                    vm.selectedFeatured.push('launch');
                }
                if(configurations.includes('basic')) {
                    filters.isBasic = true;
                    vm.selectedFeatured.push('basic');
                }
            } else {
                filters.isLaunch = false;
                filters.isBasic = false;
            }

            var genders = [];
            if (filters.genders.length > 0) {
                filters.genders.map(function(gender) { genders.push(gender.id) });
                filters.genders = genders;
            }

            var brands = [];
            if (filters.brands.length > 0) {
                filters.brands.map(function(brand) { brands.push(brand.label)});
                filters.brands = brands;
            }

            var colors = [];
            if (filters.colors.length > 0) {
                filters.colors.map(function(color) { colors.push(color.label) });
                filters.colors = colors;
            }

            var categories = [];
            if (filters.categories.length > 0) {
                filters.categories.map(function(category) { categories.push(category.key) });
                filters.categories = categories;
            }

            var tags = [];
            if (filters.tags.length > 0) {
                filters.tags.map(function(tag) { tags.push(tag.label) });
                filters.tags = tags;
            }

            return filters;
        }

        function formatOptionsFilters() {
            var sizes = [];
            vm.sizes = vm.sizes.map(function(size) {sizes.push(size.label)});
            vm.sizes = sizes;

            var colors = [];
            vm.colors = vm.colors.map(function(color) {colors.push(color.label)});
            vm.colors = colors;

            var tags = [];
            vm.tags = vm.tags.map(function(tag) {tags.push(tag.label)});
            vm.tags = tags;
        }


        vm.openFiltersModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/admin/flyers/modal-filter-flyer/flyer-filter-modal.html',
                controller: 'FiltersFlyersController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    options: function () {
                        return {
                            categories: vm.categories,
                            brands: vm.brands,
                            colors: vm.colors,
                            sizes: vm.sizes,
                            tags: vm.tags,
                            canChangeView: false,
                            isBagFilter: true
                        }
                    },
                    filters: function () {
                        var configurations = [];
                        if(vm.filters.isBasic) configurations.push({"label":"flyers.new.form.configurations.basic","id":2, "code": "basic"})
                        if(vm.filters.isLaunch) configurations.push({"label":"flyers.new.form.configurations.launch","id":1, "code": "launch"})
                        vm.filters.configurations = configurations;
                        return vm.filters
                    },
                    list: function () {
                        return vm.listFilter
                    }
                },
            }).result.then(function (response) {
                formatOptionsFilters();
                if (response) {
                    vm.numberFilterSelected = response.totalFilters;
                    vm.filters = formatModalFilters(response.selectedFilters);
                    loadFlyers();
                }
            });
        }

        vm.openAddBannersModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/admin/showcases/banner-modal/banners_modal.html',
                controller: 'BannersModalController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    banners: function () {
                        return vm.banners
                    }
                },
            }).result.then(function (response) {
                if (response) {

                    var carousel = document.getElementById("carousel");
                    var height = carousel.clientHeight;
                    carousel.style.minHeight = height + "px";

                    vm.banners = response.banners;
                    vm.haveBanners = true;
                    loadCarousel();
                }
            });
        }

        vm.getCurrencyPrefix = function(flyer) {
            var key = flyer.currency ? flyer.currency : 'REAL';
            var config = getCurrencyListConfiguration()[key];
            return config.prefix;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('bag', {
                parent: 'admin',
                url: '/bags',
                data: {
                    authorities: ['STORE_READ_SHOWCASE'],
                    pageTitle: 'global.menu.admin.bags'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/bag/bag.html',
                        controller: 'BagController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('bag');
                        return $translate.refresh();
                    }]

                }
            }).state('bag.new', {
                parent: 'bag',
                url: '/new',
                data: {
                    authorities: ['STORE_UPDATE_SHOWCASE'],
                    pageTitle: 'bag.title.build',
                    specialClass: "md-skin fixed-nav"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/bag/bag-detail.html',
                        controller: 'BagDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]

                }
            })
            .state('bag.edit', {
                parent: 'bag',
                url: '/{showcaseId}',
                data: {
                    authorities: ['STORE_UPDATE_SHOWCASE'],
                    pageTitle: 'bag.title.details',
                    specialClass: "md-skin fixed-nav"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/bag/bag-detail.html',
                        controller: 'BagDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]

                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('BagController', BagController);


    /** @ngInject */
    function BagController(   $window, $state, RemoveModalFactory, $localStorage, $translate, StoreService,
                              ShowcasesService, toastr, ModalFactory, paginationConstants, DOMAIN, $rootScope,
                              $uibModal, BrandService, FlyerCategoryService, FlyersService, CustomerService) {

        var vm = this;

        vm.redirectUrl = undefined;

        vm.goToBag = function(bag) {
            vm.getShowcaseURL(bag.id);
        }

        vm.getBagUrl = function(bag) {
            if (vm.redirectUrl) {
                return $window.location.protocol + '//' + vm.redirectUrl + '/bag/' + bag.id;
            } else if (vm.store.nickname) {
                return $window.location.protocol + '//' + vm.store.nickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/bag/' + bag.id;
            } else {
                return $window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/bag/' + bag.id;
            }
        }

        vm.copiedUrl = function() {
            toastr.success($translate.instant('bag.success.copied'));
        }

        vm.goToReport = function(bag) {
            $localStorage.defaultStore.currentBagReport = bag.bagReportUrl;
            $state.go('virtual-bag-performance', {
                report: 'virtual-bag'
            });
        }

        init();

        function init() {
            loadStoreData();
        }

        function loadStoreData() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
                vm.storeCategory = response.data.categoryKey;
                vm.redirectUrl = response.data.redirectURL;
            
            });
        }

        vm.filters = {
            categories: [],
            brands: [],
            colors: [],
            sizes: [],
            genders: [],
            customers: [],
            hasInventory : true
        };

        vm.brands = []
        vm.categories = []
        vm.customers = []
        vm.colors = []
        vm.sizes = []

        vm.listFilter = {
            ownerId: $localStorage.defaultStore.storeId,
            rowsForPage: "20"
        };

        vm.numberFilterSelected = 0;

        vm.totalBags = 0;
        vm.maxSize = 5;
        vm.numPerPage = parseInt(vm.listFilter.rowsForPage);
        vm.currentPage = 1;
        vm.startRegistry = 1;
        vm.endRegistry = vm.numPerPage;

        vm.dateRangeOptions = {
            opens: 'right',
            locale: {
                applyClass: 'btn-green',
                applyLabel: $translate.instant('bag.filters.apply'),
                fromLabel: "From",
                format: "DD/MM/YYYY",
                toLabel: "To",
                cancelLabel: $translate.instant('bag.form.buttons.cancel'),
                customRangeLabel: $translate.instant('global.form.period')
            },
            ranges: {
            },
            eventHandlers: {
                'apply.daterangepicker': function (ev, picker) {
                    if(vm.dateRange.startDate === undefined || vm.dateRange.endDate === undefined) {
                        vm.dateRange = {startDate: moment().startOf("day"), endDate: moment().endOf("day")}
                    }
                    vm.listFilter.startDate = vm.dateRange.startDate;
                    vm.listFilter.endDate = vm.dateRange.endDate;
                    vm.resetPage();
                }
            }
        };
        vm.dateRange = '';

        vm.hasntStoreYet = !$localStorage.defaultStore.storeId;

        vm.isPublishing = false;

        vm.isAllSelected = false;
        vm.showcases = [];
        vm.showcasesToRemove = [];
        vm.userHasShowcases = false;

        vm.page = 0;

        vm.hasNextPage = false;
        vm.busy = false;
        var SHOWCASE_PUBLISHED = "RELEASED";

        loadAll();

        /**
         * Load all values and filters for bags
         */
        function loadAll() {
            vm.isLoading = true;

            getDefaultFilter();

            fillRanges();

            loadShowcases();
        }

        /**
         * Prepare the brands array to be used on filters
         * @param array
         *  the brands array
         * @returns {*[]}
         *  the brands in format to be used on filters
         */
        function prepareFilterBrands(array) {
            var response = [];
            for (var i = 0; i < array.length; i++) {
                response.push({key: array[i], name: array[i]});
            }
            return response;
        }

        /**
         * Loads the default values for categories, brands, colors, sizes and customers to be used on filters
         */
        function getDefaultFilter() {

            function onSuccess (data) {

                vm.categories = data.categories;
                vm.categories = sortListByStrAttribute(vm.categories, 'title');

                vm.brands = prepareFilterBrands(data.brands);
                vm.brands = sortListByStrAttribute(vm.brands, 'name');

                vm.colors = data.colors.sort();

                vm.sizes = data.sizes.sort();

                function onSuccessCustomer (data) {
                    vm.customers = data;
                    vm.customers = sortListByStrAttribute(vm.customers, 'fullName');
                }

                var body = {
                    ids: data.customers
                };

                CustomerService.listAllByIds(body, onSuccessCustomer, onError);

            }

            function onError (response) {
                vm.isLoading = false;
                vm.busy = false;

                if (response.headers('X-flyerApp-alert') == 'userHasNoStore'){
                    toastr.error($translate.instant('showcases.messages.errors.noStore'));
                }
            }

            setTimeout(function() {
                var body = {
                    ownerId: $localStorage.defaultStore.storeId
                };

                if (vm.listFilter.ownerId) {
                    ShowcasesService.listBagsFiltersValues(body, onSuccess, onError);
                }

            }, 1000);

        }

        /**
         * Callback to refresh page view when page is changed.
         */
        vm.onPageChanged = function () {
            vm.deselectAllShowcases();

            var begin = ((vm.currentPage - 1) * vm.numPerPage),
                end = begin + vm.numPerPage;

            vm.startRegistry = begin + 1;
            vm.endRegistry = end;
        }

        vm.openDatePicker = function () {
            document.getElementById('dateRangeInput').click()
        }

        /**
         * Refresh the page of bags exhibition
         */
        vm.refreshPage = function () {
            vm.page = vm.currentPage - 1;

            loadShowcases();
            vm.onPageChanged();
        }

        /**
         * Resets the pagination
         */
        vm.resetPage = function () {
            vm.currentPage = 1;
            vm.refreshPage();
        }

        /**
         * Changes by select box the current quantity of bags to be shown for each page and resets the pagination
         */
        vm.changePagination = function() {
            vm.numPerPage = parseInt(vm.listFilter.rowsForPage);
            vm.resetPage();
        };

        /**
         * Loads all the bags with pagination and filtered
         */
        function loadShowcases() {
            if(vm.busy) return;
            vm.busy = true;


            var pageable = {
                page: vm.page,
                size: vm.numPerPage
            };

            if (vm.listFilter.ownerId){

                vm.listFilter.isPrimary = false;

                /**
                 * If the user hasn't a store, this script below cannot be executed
                 */

                ShowcasesService.listShowcases(vm.listFilter, pageable, onSuccess, onError);

                function onSuccess(data, headers) {
                    vm.hasNextPage = headers('X-Has-Next-Page') === "true";
                    vm.totalBags = parseInt(headers('X-Total-Count'));
                    vm.showcases = []
                    for (var i = 0; i < data.length; i++) {
                        vm.showcases.push(data[i]);
                    }
                    vm.isLoading = false;
                    if (vm.showcases.length >= 1) {
                        vm.userHasShowcases = true;
                    }

                    vm.showcases.forEach(function(showcase) {
                        ShowcasesService.getNumberOfFlyers(showcase.id).then(function(response) {
                            showcase.numberOfFlyers = response.data;
                        });
                    });
                    vm.busy = false;
                }

                function onError(response) {
                    vm.isLoading = false;
                    vm.busy = false;

                    if (response.headers('X-flyerApp-alert') == 'userHasNoStore'){
                        toastr.error($translate.instant('showcases.messages.errors.noStore'));
                    }
                }

            } else {
                vm.hasntStoreYet = true;
                vm.busy = false;
                vm.isLoading = false;
            }


        }

        /**
         * Fill dateRangeOptions variable with translated keys and respective date values
         */
        function fillRanges() {
            vm.dateRangeOptions.ranges[$translate.instant('global.form.today')] = [moment(), moment()]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.yesterday')] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.last7Days')] = [moment().subtract(6, 'days'), moment()]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.last15Days')] = [moment().subtract(14, 'days'), moment()]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.last30Days')] = [moment().subtract(29, 'days'), moment()]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.last60Days')] = [moment().subtract(59, 'days'), moment()]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.last90Days')] = [moment().subtract(99, 'days'), moment()]
            vm.dateRangeOptions.ranges[$translate.instant('global.form.lastYear')] = [moment().subtract(365, 'days'), moment()]
        }

        vm.getEditPage = function(showcaseId) {
            $state.go('bag.edit', {
                showcaseId: showcaseId
            });
        }


        vm.updateShowcasesToRemove = function(showcaseId) {
            if (vm.showcasesToRemove.indexOf(showcaseId) != '-1') {
                vm.showcasesToRemove.splice(vm.showcasesToRemove.indexOf(showcaseId), 1);
            } else {
                vm.showcasesToRemove.push(showcaseId);
            }
        }

        vm.checkIfShowcaseSelected = function(showcaseId) {
            if (vm.showcasesToRemove.indexOf(showcaseId) != '-1') {
                return true;
            } else {
                return false;
            }
        }

        vm.checkIsNotLoading = function() {
            return !vm.isLoading;
        }

        vm.checkIfShowcasePublished = function(showcaseStatus) {
            if (showcaseStatus) {
                return true;
            } else {
                return false;
            }
        }

        vm.publishShowcase = function(showcaseId) {
            var showcase = undefined;
            ShowcasesService.getShowcase(showcaseId).then(function (response) {
                showcase = response;
                if (!showcase || !showcase.id){
                    toastr.error($translate.instant('showcases.messages.publish.error'));
                }
                else if (!showcase.hasCover) {
                    toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                    vm.isSaving = false;
                } else if (showcase.flyers.length < 1) {
                    toastr.error($translate.instant('showcases.messages.errors.blankFlyers'));
                } else if (!showcase.name) {
                    toastr.error($translate.instant('showcases.messages.errors.blankName'));
                } else {
                    vm.isPublishing = true;
                    ShowcasesService.publishShowcase(showcaseId).then(function(data) {
                        toastr.success($translate.instant('showcases.messages.publish.success'));
                        vm.isPublishing = false;

                        ModalFactory.openModal(null,
                            $translate.instant('showcases.messages.publish.successTitle', {
                            showcaseType: $translate.instant('global.showcaseTypes.' + showcase.userInteract) }),
                            $translate.instant('showcases.messages.publish.successSubtitle', {
                                url: 'http://' + $localStorage.defaultStore.storeNickname.toLowerCase() + "." + getDomainNameSufix($window, vm.store.storeType) }),
                            null, $translate.instant('showcases.messages.publish.goToShowcase'),
                            'OK', function(){$window.open('http://' + $localStorage.defaultStore.storeNickname.toLowerCase() + "." + getDomainNameSufix($window, vm.store.storeType), '_blank')},
                            null, null, 'icon-ksc-showcasepublished');

                        $state.reload();
                    }, function(data) {
                        vm.isPublishing = false;
                        toastr.error($translate.instant('showcases.messages.publish.error'));
                    });
                }
            }, function (data) {

                if (data.headers("errorKey")){
                    toastr.error($translate.instant('showcases.messages.publish.errors.' + data.headers("errorKey")));
                } else {
                    toastr.error($translate.instant('showcases.messages.publish.errors.genericError'));
                }

                vm.isPublishing = false;
            });

        }

        vm.getPreviewURL = function(showcaseId) {
            if (!$localStorage.defaultStore.storeNickname){
                getStoreInfo().then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    $window.open($window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/preview/' + showcaseId, '_blank');
                });
            } else {
                $window.open($window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/preview/' + showcaseId, '_blank');
            }

        }

        vm.getShowcaseURL = function(idBag) {
            if (!$localStorage.defaultStore.storeNickname) {
                getStoreInfo().then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    $window.open($window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/bag/' + idBag, '_blank');
                });
            } else {
                $window.open($window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType) + '/bag/' + idBag, '_blank');
            }

        }

        vm.generateTabloid = function(showkase) {
            ShowcasesService.getShowcase(showkase.id).then(function (response) {
                showkase = response;
                if (!showkase.hasCover) {
                    toastr.error($translate.instant('showcases.messages.errors.blankCover'));
                    vm.isSaving = false;
                } else if (showkase.flyers.length < 1) {
                    toastr.warning($translate.instant('Sua mala não possui nenhum produto.'));
                } else if (!showkase.name) {
                    toastr.error($translate.instant('showcases.messages.errors.blankName'));
                } else {
                    vm.isPrinting = true;
                    buildMessageGeneratedTabloid(showkase);
                    $rootScope.$emit('waiting-generates-tabloid');
                    ShowcasesService.generateTabloid({
                        showcaseId: Number(showkase.id) || undefined,
                        storeId: ( $localStorage.defaultStore ? $localStorage.defaultStore.storeId + "" : undefined) || undefined,
                        flyers: []
                    }).then(succesPrint, errorPrint);
                }
            })
        }

        function buildMessageGeneratedTabloid(showkase) {
            ModalFactory.openModal(null,
                'A sua mala está sendo preparada',
                null, null, 'OK', null, 'close',null, null, null,
                'showcases.messages.tabloid.ifNotDownloaded', 'showcases.messages.tabloid.clickHere',
            function(callback){
                ShowcasesService.generateTabloid({
                    showcaseId: Number(showkase.id) || undefined,
                    storeId: ( $localStorage.defaultStore ? $localStorage.defaultStore.storeId + "" : undefined) || undefined,
                    flyers: []
                }).then(succesPrint, errorPrint);
            }, 'width: 40%;', 'https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/'+$rootScope.urlImage+'/mala-m.png');
        }

        function succesPrint(res) {

            var saveByteArray = (function() {
                return function(data, name, mimeType) {
                    var blob = new Blob(data, {
                        type: mimeType
                    });
                    var url = window.URL.createObjectURL(blob);
                    var element = angular.element('<a/>');
                    element.attr({
                        href: url,
                        target: '_blank',
                        download: name
                    });
                    if(document.createEvent) {
                        var ev = document.createEvent("MouseEvent");
                        ev.initMouseEvent("click", true /* bubble */, true /* cancelable */, window, null, 0, 0, 0, 0, /* coordinates */
                        false, false, false, false,
                        /*
                         * modifier keys
                         */
                        0 /* left */, null);
                        element[0].dispatchEvent(ev);
                    } else {
                        element[0].fireEvent("onclick");
                    }
                    setTimeout(function() {
                        document.body.removeChild;
                        window.URL.revokeObjectURL(url);
                    }, 200);
                };
            }());
            if (res.headers["content-disposition"]){
                var filename = res.headers["content-disposition"].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1];
                var mimeType = res.headers["content-type"];
                filename = filename.replace(/['"]/g, '');
                saveByteArray([res.data], filename, mimeType);
            } else {
                toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
            }

            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
        }

        function errorPrint(response) {
            vm.isPrinting = false;
            $rootScope.$emit('finish-generate-tabloid');
            toastr.error($translate.instant('showcases.messages.tabloid.error.erroByGenerateCatalog'));
        }

        function getStoreInfo() {
            return StoreService.getStore($localStorage.defaultStore.storeId);
        }

        getStoreInfo().then(function(response) {
            $localStorage.defaultStore.storeType = response.data.storeType;
            $localStorage.defaultStore.storeNickname = response.data.nickname;
            vm.store = response.data;
        });

        /**
         * Verify if all showcases are selected
         * @returns {*|boolean} True if all showcases are selected
         */
        vm.isShowAllSelected = function () {
            vm.isAllSelected = vm.showcases.length > 0 && vm.showcasesToRemove.length === vm.showcases.length;
            return vm.isAllSelected;
        }

        /**
         * Select or deselect all bags.
         * If all bags are selected, deselect all the bags
         * If not all bags are selected, then selects all the bags
         */
        vm.changeSelectionOfAllShowcases = function () {
            if (vm.isAllSelected) {
                vm.deselectAllShowcases();
            } else {
                vm.selectAllShowcases();
            }

        }

        /**
         * Select all bags
         */
        vm.selectAllShowcases = function () {
            var showcasesToRemoveTemp = [];
            for (var i = 0; i < vm.showcases.length; i++) {
                showcasesToRemoveTemp.push(vm.showcases[i].id)
            }
            vm.showcasesToRemove = showcasesToRemoveTemp;
            vm.isAllSelected = true;
        }

        /**
         * Deselect all bags
         */
        vm.deselectAllShowcases = function () {
            vm.showcasesToRemove = [];
            vm.isAllSelected = false;
        }

        /**
         * Opens a modal to filter bags
         */
        vm.openFiltersModal = function () {
            vm.filtersConversationModal = $uibModal.open({
                templateUrl: 'app/admin/bag/modal-filter-bag/bag-filter-modal.html',
                controller: 'FiltersBagsController',
                windowClass: 'modal-center',
                windowTopClass: 'center-modal',
                controllerAs: 'vm',
                size: 'lg',
                keyboard: false,
                resolve: {
                    options: function () {
                        return {
                            categories: vm.categories,
                            brands: vm.brands,
                            colors: vm.colors,
                            sizes: vm.sizes,
                            customers: vm.customers,
                            canChangeView: true,
                            viewByCategories: vm.viewByCategories,
                            clearFilters: vm.clearFilters
                        }
                    },
                    filters: function () {
                        return vm.filters
                    },
                    list: function () {
                        return vm.listFilter
                    }
                },
            }).result.then(function (response) {
                if (response) {
                    // Refresh the page with selected filters
                    vm.numberFilterSelected = response.totalFilters;
                    vm.filters = response.selectedFilters;
                    vm.listFilter = response.listFilter;
                    vm.resetPage();
                }
            });
        }

        /**
         * Removes from database the selected bags
         */
        vm.removeShowcases = function() {
            if (vm.showcasesToRemove.length >= 1) {
                RemoveModalFactory.deleteItem(vm.showcasesToRemove.length).then(function(data) {
                    ShowcasesService.deleteShowcases(vm.showcasesToRemove).then(function(data) {
                        toastr.success($translate.instant('Mala removida com sucesso'));
                        vm.showcases = [];
                        vm.showcasesToRemove = [];
                        vm.userHasShowcases = false;
                        vm.resetPage();
                    }, function(data) {
                        toastr.error($translate.instant('showcases.messages.remove.error'));
                    });
                });
            } else {
                toastr.error($translate.instant('showcases.messages.remove.noItens'));
            }
        }

        vm.getImageSrc = function (showcaseId) {
            return "content/images/templates/"+ showcaseId +".png"
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ADMIN_MANAGE_SYSTEM'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings?code&tab',
            data: {
                authorities: ['SYSTEM_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                'tab': null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('SettingsService', SettingsService);

    SettingsService.$inject = ['SettingsFactory'];

    function SettingsService(SettingsFactory) {

        var service = {
            getRegisterKey: getRegisterKey,
            registerToReceiveNotifications: registerToReceiveNotifications,
            unregisterToReceiveNotifications: unregisterToReceiveNotifications,
            updateSystemNotifications: updateSystemNotifications,
            updateEmailNotifications: updateEmailNotifications,
            getRegister: getRegister
        };

        return service;

        function getRegisterKey(id, endpoint) {
            return SettingsFactory.getKey({'accountId': id, 'registerEndpoint': endpoint}).$promise;
        }

        function getRegister(accountId, storeId) {
            return SettingsFactory.getRegister({'accountId': accountId, 'storeId': storeId}).$promise;
        }

        function registerToReceiveNotifications(endpoint, auth, p256dh, accountId, storeId) {
            return SettingsFactory.registerToReceiveNotifications({}, {'endpoint': endpoint, 'auth': auth,
                'p256dh':p256dh, 'accountId':accountId, 'storeId':storeId}).$promise;
        }

        function updateSystemNotifications(id, value) {
            return SettingsFactory.updateSystemNotifications({'accountId': id}, value).$promise;
        }

        function updateEmailNotifications(id, value) {
            return SettingsFactory.updateEmailNotifications({'accountId': id}, value).$promise;
        }

        function unregisterToReceiveNotifications(id) {
            return SettingsFactory.unregisterToReceiveNotifications({'accountId': id}).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('SettingsFactory', SettingsFactory);

    SettingsFactory.$inject = ['$resource'];

    function SettingsFactory($resource) {
        var resourceUrl = 'admin/api/notifications';
        return $resource(resourceUrl, {}, {
            'getKey': {
                method: 'GET',
                isArray: false,
                url: 'admin/api/notifications/:accountId/key'
            },
            'getRegister': {
                method: 'GET',
                isArray: false,
                url: 'admin/api/notifications/:accountId/:storeId'
            },
            'registerToReceiveNotifications': {
                method: 'POST',
                isArray: false,
                url: resourceUrl
            },
            'unregisterToReceiveNotifications': {
                method:'DELETE',
                isArray: false,
                url: 'admin/api/notifications/:accountId'
            },
            'updateSystemNotifications': {
                method:'POST',
                isArray: false,
                url: 'admin/api/notifications/:accountId/system'
            },
            'updateEmailNotifications': {
                method:'POST',
                isArray: false,
                url: 'admin/api/notifications/:accountId/email'
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('SettingsController', SettingsController);

    function SettingsController(toastr, StoreService, Principal, ModalFactory, $localStorage,
        Auth, JhiLanguageService, $translate, moment, $scope, $rootScope, $stateParams, $timeout, SettingsService
    ) {
        var format = 'DD/MM/YYYY';
        var vm = this;

        vm.maskLocale = '99/99/9999';

        vm.stores = [];
        vm.hasShipping = false;

        vm.store = $localStorage.defaultStore;

        vm.error = null;
        vm.settingsAccount = null;
        vm.success = null;

		vm.islocked = $localStorage.isMoipPlanFree;
        $timeout(function() {
            if ($stateParams.tab) {
                vm.tab = $stateParams.tab;
            }
        }, 500);



        StoreService.getMyAllStores().then(function(response) {
            if (response && response.data) {
                response.data.forEach(function(elem) {
                    var store = {};
                    store.nickname = elem.nickname;
                    store.id = elem.id;
                    store.redirectURL = elem.redirectURL;
                    store.fbPixel = elem.fbPixel;
                    store.glAnalytics = elem.glAnalytics;
                    store.fbActivation = elem.fbActivation;
    
                    vm.stores.push(store);
                });
            }
        });

        isUserSubscribed();

        vm.authShipping = function() {
            StoreService.authorizeShipping().then(function(response) {});
        }

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function(account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login,
                gender: account.gender,
                twoFactorAuth: account.twoFactorAuth,
                dateOfBirth: moment(account.dateOfBirth).format(format),
                phone: account.phone,
                moipAccountInfo: account.moipAccountInfo
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
            if (vm.settingsAccount.moipAccountInfo) {
                vm.addressDTO = vm.settingsAccount.moipAccountInfo;
            }
            dateTimePicker();

        });

		vm.openModal = function(){
			$localStorage.isLocked = true;
		}


        vm.savePersonalData = function(form, test) {
            if (form.$valid) {
                // if (vm.stores.length > 0) {
                    vm.isSaving = true;
                    var accountToSave = angular.copy(vm.settingsAccount);
                    accountToSave.dateOfBirth = moment(vm.settingsAccount.dateOfBirth, format).toDate();
                    Auth.updateAccount(accountToSave)
                        .then(function() {
                            vm.error = null;
                            vm.success = 'OK';
                            Principal.identity(true).then(function(account) {
                                vm.settingsAccount = copyAccount(account);
                                JhiLanguageService.getCurrent().then(function(current) {
                                    if (vm.settingsAccount && vm.settingsAccount.langKey !== current) {
                                        $translate.use(vm.settingsAccount.langKey)
                                            .then(function(result) { 
                                                processResponse();
                                                vm.isSaving = false; 
                                            }, function(err) { 
                                                processResponse();
                                                vm.isSaving = false;
                                            });
                                    }
                                }, function(err) {
                                    m.isSaving = false;
                                });
                                // $rootScope.$emit('settings-updated');
                            }, function(err) {
                                m.isSaving = false;
                            });
                        }).catch(function(error) {
                            if (error.status === 401) {
                                toastr.success($translate.instant('settings.store.messages.success.login'));
                            }
                            vm.isSaving = false;
                            vm.success = null;
                            vm.error = 'ERROR';
                        });
                // }
            }
        };

        vm.saveURLRedirectDomainsData = function() {
            if (vm.stores.length > 0) {
                vm.isSaving = true;
                vm.stores.forEach(function(elem) {
                    elem.redirectURL = splitAbsoluteUrl('http://www.', elem.redirectURL);
                    elem.redirectURL = splitAbsoluteUrl('http://', elem.redirectURL);
                    elem.redirectURL = splitAbsoluteUrl('https://', elem.redirectURL);
                    elem.redirectURL = splitAbsoluteUrl('https://www.', elem.redirectURL);
                    elem.redirectURL = splitAbsoluteUrl('www.', elem.redirectURL);
                });

                StoreService.saveRedirectDomains(vm.stores).then(
                    function(response) {
                        vm.isSaving = false;
                        vm.error = null;
                        vm.success = 'OK';
                        processResponse();
                    },
                    function(err) {
                        vm.isSaving = false;
                        vm.success = null;
                        vm.error = 'ERROR';
                    }
                );
            }
        };

        vm.saveAnalyticsData = function() {
            vm.isSaving = true;
            StoreService.saveStoreAnalytics(vm.stores).then(
                function(response) {
                    vm.isSaving = false;
                    vm.error = null;
                    vm.success = 'OK';
                    processResponse();
                },
                function(err) {
                    vm.isSaving = false;
                    vm.success = null;
                    vm.error = 'ERROR';
                }
            );
        };

        function splitAbsoluteUrl(url, value) {
            if (value) {
                if (value.includes(url)) {
                    return value.split(url)[1];
                }
            }
            return value;
        }

        function dateTimePicker() {
            vm.dateOfBirthOptions = {
                format: format,
                ignoreReadonly: true,
                locale: moment.locale(),
                allowInputToggle: true,
                maxDate: moment(),
                widgetPositioning: {
                    horizontal: 'right',
                    vertical: 'bottom'
                }
            };

            angular
                .element('#dateOfBirth')
                .datetimepicker(vm.dateOfBirthOptions)
                .on('dp.change', function(ev) {
                    if (ev.date) {
                        $scope.$apply(function() {
                            vm.settingsAccount.dateOfBirth = ev.date.format(
                                format
                            );
                        });
                    } else {
                        $scope.$apply(function() {
                            vm.settingsAccount.dateOfBirth = undefined;
                        });
                    }
                });
        }

        function processResponse() {
            if (vm.error) {
                toastr.error(
                    $translate.instant('settings.store.messages.error.fail')
                );
                vm.error = undefined;
            } else if (vm.success && vm.success == 'OK') {
                vm.success = undefined;
                toastr.success($translate.instant('settings.store.messages.success'));
            }
        }

        function actualyDisconnect(){
            Principal.disconnectFromPaymentGateway().then(function(response){
                if (response.data == 'OK'){
                    vm.moipInfo = {};
                }
            });
        }

        function disconnect(){

            ModalFactory.openSimpleModal(
                $translate.instant('settings.paymentConfiguration.sureDisconnectTitle'),
                $translate.instant('settings.paymentConfiguration.sureDisconnectQuestion'),
                $translate.instant('settings.paymentConfiguration.yes'),
                $translate.instant('settings.paymentConfiguration.no'),
                actualyDisconnect);
        }

        vm.changeWebNotifications = function () {
            if(vm.webNotifications) {
                subscribeButtonHandler();
            } else {
                if (vm.registerId != null) {
                    SettingsService.unregisterToReceiveNotifications(vm.registerId).then(function (data) {
                        navigator.serviceWorker.getRegistration().then( function (data) {
                            data.pushManager.getSubscription().then(function (data) {
                                data.unsubscribe();
                                vm.webNotifications = false;
                            });
                        });
                    });
                }
            }
        }

        vm.changeSystemNotifications = function () {
            SettingsService.updateSystemNotifications(vm.registerId, vm.systemNotifications).then(function (data) {
                $rootScope.$emit('settings-updated');
            });
        }

        vm.changeEmailNotifications = function () {
            SettingsService.updateEmailNotifications(vm.registerId, vm.systemNotifications).then(function (data) {
                $rootScope.$emit('settings-updated');
            });
        }


        function urlB64ToUint8Array(base64String) {
            const padding = '='.repeat((4 - base64String.length % 4) % 4);
            const base64 = (base64String + padding)
                .replace(/\-/g, '+')
                .replace(/_/g, '/');
            const rawData = window.atob(base64);
            const outputArray = new Uint8Array(rawData.length);
            for (var i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        }

        function subscribeButtonHandler() {
            // Prevent the user from clicking the subscribe button multiple times.
            Notification.requestPermission().then(function (result) {
                if (result === 'denied') {
                    toastr.error($translate.instant('settings.notifications.error'));
                    vm.webNotifications = false;
                    return;
                }

                navigator.serviceWorker.getRegistration().then( function (registration) {
                    if (registration) {
                        registration.pushManager.getSubscription().then(function (subscribed) {
                            if (subscribed) {
                                return;
                            }
                            registration.pushManager.subscribe({
                                userVisibleOnly: true,
                                applicationServerKey: urlB64ToUint8Array('BI4I7aPcZIoAL7ZpvzE3vxlpAfBdswMmokjuAoE47H8DLOus99-Rsw5nJQLr93YWXo4Xr5f-jIQZ6ONSSD0eClY')
                            }).then(function (subscription) {
                                const subscriptionJSON = JSON.parse(JSON.stringify(subscription));
                                SettingsService.registerToReceiveNotifications(subscriptionJSON.endpoint,
                                    subscriptionJSON.keys.auth, subscriptionJSON.keys.p256dh, $localStorage.userId, vm.store.storeId).then(function (data) {
                                    vm.registerId = data.id;
                                    vm.webNotifications = true;
                                });
                            });
                        });
                    } else {
                        toastr.error($translate.instant('settings.notifications.error'));
                        vm.webNotifications = false;
                    }
                });

            });
        }

        function isUserSubscribed() {
            vm.webNotifications = false;
            vm.systemNotifications = false;
            vm.emailNotifications = false;

            SettingsService.getRegister($localStorage.userId, vm.store.storeId).then(function (data) {
                vm.systemNotifications = data['soundNotification'];
                vm.emailNotifications = data['emailNotification'];
                vm.webNotifications = data['endpoint'] != null;
                vm.registerId = data['id'];
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            url: '/reset/request',
            templateUrl: 'app/account/reset/request/reset.request.html',
            controller: 'RequestResetController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            url: '/reset/finish?key',
            templateUrl: 'app/account/reset/finish/reset.finish.html',
            controller: 'ResetFinishController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$scope', '$state', '$stateParams', '$timeout', 'Auth'];

    function ResetFinishController ($scope, $state, $stateParams, $timeout, Auth) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = login;
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.error = null;
            if (vm.password === vm.confirmPassword) {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                    $scope.form.$setPristine();
                    vm.password = null;
                    vm.confirmPassword = null;
                });
            }
        }
        
        function login() {
            $state.go('main-login')
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['SYSTEM_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['$scope', 'Auth', 'Principal', 'toastr', '$translate'];

    function PasswordController ($scope, Auth, Principal, toastr, $translate) {
        var vm = this;

        vm.changePassword = changePassword;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password === vm.confirmPassword) {
                Auth.changePassword(vm.password).then(function () {
                    toastr.success($translate.instant('password.messages.success'));
                    $scope.form.$setPristine();
                    vm.password = null;
                    vm.confirmPassword = null;
                }).catch(function () {
                    toastr.error($translate.instant('password.messages.error'));
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('main-register', {
            url: '/main-register',
            templateUrl: 'app/account/main-register/main-register.html',
            controller: 'MainRegisterController',
            controllerAs: 'vm',
            data: {
                authorities: [],
                pageTitle: 'Register to Kaztor',
                specialClass: 'main-register'
            },
            params: {
                'login': null,
                'email': null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('MainRegisterController', MainRegisterController);


    function MainRegisterController($state, $translate, $stateParams, $timeout, $location, Auth, toastr, UserService, moment, $scope, Principal, DirectRegisterService, $sessionStorage) {
        var format = 'L';

        toastr.options = {
            closeButton: true
        };

        var vm = this;
        getAndSaveHubToken();
        function getAndSaveHubToken() {
            if ($location.search().client) {
                $sessionStorage.clientHub = $location.search().client;
				vm.hubToken = $sessionStorage.clientHub;
            }else{
				vm.hubToken = $sessionStorage.clientHub;
			}
        }
		vm.urlFromAccount = window.location.href;
        vm.maskLocale = '99/99/9999';

        vm.error = null;
        vm.register = register;
        vm.success = null;
        vm.getGenderKey = getGenderKey;
        vm.checkPasswords = checkPasswords;
        vm.dateTimePicker = dateTimePicker();

        $timeout(function () {
            angular.element('#login').focus();
        });

        loadAll();

        function loadAll() {
            loadUserGenders();

            if (angular.isUndefined(vm.account)) {
                vm.account = {};
            }
            if ($stateParams.email) {
                vm.account.email = $stateParams.email;
            }
        }

        vm.validDate = function validDate(dateHour) {
            var dateHourInput = moment(dateHour.$viewValue, format).isValid() ? moment.utc(dateHour.$viewValue, format) : undefined;
            if (dateHourInput) {
                if (dateHourInput.isAfter(moment.utc(moment().format(), 'YYYY-MM-DDTHH:mm').toDate())) {
                    vm.account.dateOfBirth = undefined;
                    return;
                }
                vm.account.dateOfBirth = dateHour.$viewValue;
                vm.form.dateOfBirth.$setValidity('maxDate', true);
            } else {
                vm.account.dateOfBirth = undefined;
            }
        }

        function checkPasswords() {
            if ((vm.account.password != vm.account.confirmPassword) && vm.account.confirmPassword) {
                vm.form.confirmPassword.$setValidity('notEquals', false);
            } else {
                vm.form.confirmPassword.$setValidity('notEquals', true);
            }
        }

        vm.checkUserName = function () {
            if (vm.account.login) {
                Principal.isAvaliableUsername(vm.account.login).then(function (response) {
                    vm.form.login.$setValidity('usernameAlreadyUsed', response.data);
                });
            } else {
                vm.form.login.$setValidity('usernameAlreadyUsed', true);
            }
        }

        vm.checkEmail = function () {
            var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            if (vm.account.email && emailPattern.test(vm.account.email)) {
                Principal.isAvaliableEmail(vm.account.email).then(function (response) {
                    vm.form.email.$setValidity('emailAlreadyUsed', response.data);
                });
            } else {
                vm.form.email.$setValidity('emailAlreadyUsed', true);
            }
        }

        function register() {
            if (vm.form.$valid) {
                vm.isSaving = true;
                var accountToSave = angular.copy(vm.account);
                accountToSave.langKey = $translate.use();
                vm.error = null;
                accountToSave.hubToken = vm.hubToken;
				accountToSave.urlFrom = vm.urlFromAccount;
                Auth.createAccount(accountToSave).then(function () {
                    vm.gender = null;
                    //vm.success = 'OK';
                    vm.isSaving = false;
                    Auth.login({
                        usernameOrEmail: vm.account.email,
                        password: vm.account.password,
                        rememberMe: true
                    }).then(function () {
                        $state.go('store-info');
                    });
                }).catch(function (response) {
                    vm.isSaving = false;
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        toastr.warning($translate.instant('register.messages.error.userexists'), toastr.options)
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        toastr.warning($translate.instant('register.messages.error.emailexists'), toastr.options)
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }

        function loadUserGenders() {
            UserService.listUserGenders().then(function (genders) {
                vm.genders = genders;
            });
        }

        function getGenderKey(value) {
            return "register".concat(".").concat(value);
        }

        function dateTimePicker() {
            vm.dateOfBirthOptions = {
                format: format,
                sideBySide: true,
                ignoreReadonly: true,
                locale: moment.locale(),
                allowInputToggle: true,
                showClear: true,
                useCurrent: false,
                defaultDate: moment(),
                maxDate: moment(),


            };
        }

        vm.loginNewAccount = function() {
            $state.go('main-login', {'email': vm.account.email, 'password': vm.account.password});
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('direct-register', {
            url: '/direct-register',
            templateUrl: 'app/account/direct-register/direct-register.html',
            controller: 'DirectRegisterController',
            controllerAs: 'vm',
            data: {
                authorities: [],
                pageTitle: 'Register to Kaztor',
                specialClass: 'direct-register'
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .service('DirectRegisterService', DirectRegisterService);

    DirectRegisterService.$inject = ['DirectRegisterFactory', '$localStorage'];

    function DirectRegisterService(DirectRegisterFactory, $localStorage) {

        return {
            registerInit: registerInit,
            registerFinish: registerFinish
        }

        function registerInit(loginOrMail) {
            return DirectRegisterFactory.init(loginOrMail).$promise;
        }

        function registerFinish(login, password) {
            return DirectRegisterFactory.finish({
                login: login,
                password: password
            }).$promise;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('DirectRegisterFactory', DirectRegisterFactory);

    DirectRegisterFactory.$inject = ['$resource'];

    function DirectRegisterFactory($resource) {
        var resourceUrl = '';

        return $resource(resourceUrl, {}, {
            'init': {
                method: 'POST',
                url: '/api/register/init',
                transformResponse: function(data, headers) {
                    var response = {};
                    response.headers = headers();
                    try {
                        response.data = angular.fromJson(data);
                        return response
                    } catch (err){
                        return response;
                    }
                }
            },
            'finish': {
                method: 'POST',
                url: '/api/register/finish',
                transformResponse: function(data, headers) {
                    var response = {};
                    response.headers = headers();
                    try{
                        response.data = angular.fromJson(data);
                        return response
                    }catch (err){
                        return response;
                    }
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('DirectRegisterController', DirectRegisterController);


    DirectRegisterController.$inject = ['$translate', '$state', 'AuthServerProvider', 'DirectRegisterService', 'toastr', 'Principal', '$location', '$sessionStorage'];

    function DirectRegisterController($translate, $state, AuthServerProvider, DirectRegisterService, toastr, Principal, $location, $sessionStorage) {
        var vm = this;

        vm.firstStep = true;
        vm.loginOption = "login";

        vm.user = {};
        vm.authenticationError = false;

        function clearToken() {

        }
        getAndSaveHubToken();
        function getAndSaveHubToken() {
            if ($location.search().client) {
                $sessionStorage.clientHub = $location.search().client;
            }
        }

        vm.userRegister = function() {
            if (vm.firstStep) {
                if (vm.loginOrMail) {
                    DirectRegisterService.registerInit(vm.loginOrMail).then(function(response) {
                        var statuscode = response.headers.statuscode;
                        if (statuscode == 41) {
                            var params = {};
                            if (vm.loginOrMail.indexOf("@") != '-1') {
                                var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
                                var isValidMail = emailPattern.test(vm.loginOrMail);
                                if (isValidMail) {
                                  params.email = vm.loginOrMail;
                                  $state.go('main-register', params);
                                } else {
                                  toastr.error($translate.instant('userManagement.error.invalidEmail'));
                                }
                            } else {
                                toastr.error($translate.instant('userManagement.error.invalidEmail'));
                            };
                        } else if (statuscode == 40) {
                            vm.user.email = response.data.email;
                            vm.user.login = response.data.login;
                            vm.user.firstName = response.data.firstName;
                            vm.userExists = true;
                            vm.firstStep = false;
                        } else {
                            toastr.error();
                        }
                    }, function(response) {
                        toastr.error($translate.instant('register.messages.alreadyHaveAdminAccount'));
                    });
                } else {
                    toastr.warning($translate.instant('register.messages.loginOrMailIsBlank', {
                        option: vm.loginOption
                    }));
                }
            } else if (!vm.firstStep) {
                if (vm.userExists) {
                    AuthServerProvider.logout();
                    DirectRegisterService.registerFinish(vm.user.login, vm.user.password).then(function(response) {
                        var bearerToken = response.headers['authorization'];
                        if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                            var jwt = bearerToken.slice(7, bearerToken.length);
                            AuthServerProvider.storeAuthenticationToken(jwt, false);
                        }
                        Principal.identity(true).then(function() {
                            $state.go('store-info');
                        });
                    }, function (error) {
                        vm.authenticationError = true;
                    });
                }
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('PlanModalController', PlanModalController);

        PlanModalController.$inject = ['$uibModalInstance', '$state'];

    function PlanModalController($uibModalInstance, $state) {
        var vm = this;

        vm.closeModal = function() {
            $uibModalInstance.close(false);
        }

    }

})();
	
	(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('GiftCardCheckoutController', GiftCardCheckoutController);

    function GiftCardCheckoutController(GiftCardService, $translate, toastr) {

        var vm = this;

		vm.validateGiftCard = validateGiftCard;

		function validateGiftCard() {
            if (vm.formGiftValidate.$valid && !vm.isSending) {
                vm.isSending = true;
				GiftCardService.updateSubscriptionGiftCard(vm.giftCard).then(function (response) {
                    vm.isSending = false;
					/*if (response.headers()['x-error-on-subscriber-message']){
				    	toastr.error(response.headers()['x-error-on-subscriber-message']);
				    }*/
					toastr.success($translate.instant('gift-card.validate-sucess'));
	            }, function (response) {
                    vm.isSending = false;
					if (response.headers()['x-error-validate']){
				    	toastr.error($translate.instant('gift-card.not-exists'));
				    }else if (response.headers()['x-error']){
	                    toastr.error($translate.instant('gift-card.validate-error'));
					}
	            });

            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('checkoutDefault', {
                abstract: true,
                templateUrl: "app/account/checkout/default/content.html",
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('checkoutInner', {
                parent: 'checkoutDefault',
                url: '/checkout?payment',
                data: {
                    authorities: [],
                    pageTitle: 'store-info.pageTitle'
                },
                views: {
                    'content@checkoutDefault': {
                        templateUrl: 'app/account/checkout/checkout.html',
                        controller: 'CheckoutController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    plans: function(CheckoutService, $q, $location){
                        var deferred = $q.defer();
                        var currentEnv = $location.absUrl().split('.')[1];
                        CheckoutService.getPlans(currentEnv).then(function(result) {
                            deferred.resolve(result.data);
                        }, function (error) {
                            deferred.resolve(error);
                        });
                        return deferred.promise;
                    },
                    account: function (Principal, $q) {
                        var deferred = $q.defer();

                        Principal.identity().then(function(account) {
                            deferred.resolve(account);
                        }, function (error) {
                            deferred.resolve(undefined);
                        });
                        angular.element('body').removeClass('mini-navbar');
                        return deferred.promise;
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('checkout');
						$translatePartialLoader.addPart('gift-card');
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]

                }
            })
            .state('checkoutInprogress', {
                parent: 'checkoutDefault',
                url: '/checkout-done',
                data: {
                    authorities: [],
                    pageTitle: 'store-info.pageTitle'
                },
                views: {
                    'content@checkoutDefault': {
                        templateUrl: 'app/account/checkout/checked.html',
                        controller: 'CheckedController',
                        controllerAs: 'vm'

                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('checkout');
						$translatePartialLoader.addPart('gift-card');
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }
            });
    }
})();

(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .service('CheckoutService', CheckoutService);

    CheckoutService.$inject = ['$localStorage', 'MoipPlansFactory'];

    function CheckoutService($localStorage, MoipPlansFactory) {

        var service = {
            getPlans: getPlans,
            resetBillet: resetBillet,
            getPlanByCode: getPlanByCode,
            getSubscriber: getSubscriber,
            generateBillet: generateBillet,
            validateCoupon: validateCoupon,
            isBilletOverdue: isBilletOverdue,
            updateSubscriber: updateSubscriber,
            createSubscriber: createSubscriber,
            createSubscriberFree: createSubscriberFree,
            updateSubscriberCard: updateSubscriberCard
        };

        return service;

        function getPlans(environment) {
            return MoipPlansFactory.getPlans({environment: environment}).$promise;
        }

        function getPlanByCode(code) {
            return MoipPlansFactory.getPlanByCode({
                code: code
            }).$promise;
        }

        function getSubscriber(code) {
            return MoipPlansFactory.getSubscriber({
                code: code
            }).$promise;
        }

        function updateSubscriber(subscriberDTO) {
            return MoipPlansFactory.updateSubscriber(subscriberDTO).$promise;
        }

        function createSubscriber(subscriberDTO) {
            return MoipPlansFactory.createSubscriber(subscriberDTO).$promise;
        }

        function createSubscriberFree() {
            return MoipPlansFactory.createSubscriberFree().$promise;
        }

        function updateSubscriberCard(cardDTO) {
            return MoipPlansFactory.updateSubscriberCard(cardDTO).$promise;
        }

        function isBilletOverdue(cardDTO) {
            return MoipPlansFactory.isBilletOverdue().$promise;
        }

        function generateBillet() {
            return MoipPlansFactory.generateBillet().$promise;
        }

        function resetBillet() {
            return MoipPlansFactory.resetBillet().$promise;
        }

        function validateCoupon(coupon) {
            return MoipPlansFactory.validateCoupon({'coupon': coupon }).$promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('CheckoutController', CheckoutController);

    function CheckoutController($translate, CheckCEPService, Auth,
                                    CheckoutService, $state, $localStorage,
                                    toastr, Principal, plans, account, $window,
                                    $timeout, $stateParams, $filter, $uibModal, moment) {

        var vm = this;
        vm.maskLocale = '99/99/9999';
        vm.changeState = changeState;
        vm.hubId = $localStorage.defaultStore.hubId;
        vm.hubURL = $localStorage.defaultStore.hubURL;
		vm.visibleAlert = false;
        vm.periodSelected = 'annually';
        var mainColor = getComputedStyle(document.documentElement).getPropertyValue('--main-color');
        vm.mainColor = mainColor;
        vm.paymentUrl = ""

        var copyAccount = function (account) {
            if (account){
                return {
                    activated: account.activated,
                    hasMoipPlan: account.hasMoipPlan,
                    isMoipPlanFree: account.isMoipPlanFree,
                    statusPaymentSignature: account.statusPaymentSignature,
                    isExpired: account.isExpired,
                    billetLink: account.billetLink,
                    firstName: account.firstName
                };
            }

            return null;
        };

        vm.isGeneratingBillet = false;

        vm.hasSuccess = false;
        vm.loggedAccount = copyAccount(account);
        vm.selectedPlan = undefined;
        vm.invalidCardNumber = true;
        vm.invalidExpirationDate = true;
        vm.brandCard = undefined;
        vm.isLoading = false;
        vm.isSaving = false;
        vm.isValidatingCoupon = false;
        vm.expirationDate = undefined;
        vm.checkout = {
            paymentMethod: '',
        };
        vm.gettedPlans = undefined;
        vm.creditCardInfoIsValid = true;

        vm.checkedBoleto = false;
        vm.checkedCreditCard = false;
        vm.boletoSpanStyle = undefined;
        vm.creditCardSpanStyle = undefined;
        vm.showBilletOption = $stateParams.payment === 'billet';

        vm.logout = undefined;

		vm.isVisibleForm = function(){
			if (!vm.loggedAccount.isMoipPlanFree && vm.loggedAccount.hasMoipPlan && ["PAGO", "ATRASADA", "NAO_PAGO", "CANCELADA", "AGUARDANDO_CONFIRMACAO"].includes(vm.loggedAccount.statusPaymentSignature)){
				return false;
			} else if (vm.loggedAccount.hasMoipPlan && vm.loggedAccount.isMoipPlanFree){
				return true;
			} else if (vm.loggedAccount.hasMoipPlan && vm.loggedAccount.isExpired){
				return true;
			} else if (!vm.loggedAccount.hasMoipPlan){
				return true;
			}
		}

        vm.logout = function logout() {
            Auth.logout();
            $timeout(function(){
                $state.go('main-login');
            }, 200);

        }

		function insertMessageAlert(message){
			vm.messageAlert = message;
			vm.visibleAlert = true;
		}

        vm.getNewBillet = function () {
            vm.isGeneratingBillet = true;
            CheckoutService.generateBillet().then(function (response) {
                vm.isGeneratingBillet = false;
                if (response.headers['x-billet-href']) {
                    $window.open(response.headers['x-billet-href'] + '/print', 'BILLET', 'location=yes,height=800,width=600,scrollbars=yes');
                }
            }, function (response) {
                vm.isGeneratingBillet = false;
                insertMessageAlert($translate.instant('checkout.afterPages.hasPlan.error.' + response.headers()['x-error']));
            });
        }


        vm.resetBillet = function () {
            vm.isGeneratingBillet = true;
            CheckoutService.generateBillet().then(function (response) {
                vm.isGeneratingBillet = false;
                if (response.headers['x-billet-href']) {
                    $window.open(response.headers['x-billet-href'] + '/print', 'BILLET', 'location=yes,height=800,width=600,scrollbars=yes');
                }
            }, function (response) {
                vm.isGeneratingBillet = false;
                insertMessageAlert($translate.instant('checkout.afterPages.hasPlan.error.' + response.headers()['x-error']));
            });
        }

        function loadCountrysAndStates() {
            CheckCEPService.listStates().then(function(response) {
                vm.states = response.data;
                vm.checkout.country = 'BRA';
            });
            CheckCEPService.listCountrys().then(function(response) {
                vm.countrys = response.data;
            });
        }

        function changeState(state) {
            $state.go(state);
        }

        vm.getBilletLink = function(){
            if (vm.loggedAccount){
                return vm.loggedAccount.billetLink;
            }
        }

        vm.makePayment = function() {
			if (!vm.selectedPlan.free){
				vm.visibleAlert = false;
	            if (vm.checkedBoleto) {
	                vm.sendToMopiPaymentWithBillet();
	            } else if (vm.checkedCreditCard) {
	                vm.sendToMopiPaymentWithCard();
	            }
			}else{
				vm.isSaving = true;
                createSubscriber();
			}
        }

        function loadPaymentUrl() {
            if (vm.selectedPlan.annuallyCode === "1669774992") {
                // Showkase Plan
                vm.paymentUrl = "https://payment-link.pagar.me/pl_x7bWJq1VeyKBnJKIggI5JBMYZlnvkwjo";
            } else if (vm.selectedPlan.annuallyCode === "1669775157") {
                // Impulso Plan
                vm.paymentUrl = "https://payment-link.pagar.me/pl_mZ3lxa0r7kvQeyzUjS9qEwKyODp682bJ";
            } else if (vm.selectedPlan.annuallyCode === "1669775314") {
                // Escala Plan
                vm.paymentUrl = "https://payment-link.pagar.me/pl_oMag8v43m9VXazotJJcr2n7qGw65J1xB";
            }
        }

        function loadAll() {
            if (vm.loggedAccount){
                if (vm.loggedAccount.isFree){
                    $state.go('home');
                    return;
                }
            }
            vm.gettedPlans = plans;
            if(vm.gettedPlans && vm.gettedPlans.length){
                vm.selectPlan(vm.gettedPlans[0]);
            }

            loadPaymentUrl();
            loadCountrysAndStates();
        }

        vm.verifyExpirationDate = function(){
            if (vm.expirationDate && vm.expirationDate.length == 4){
                vm.invalidExpirationDate = !Moip.Validator.isExpiryDateValid(vm.expirationDate.substring(0,2), vm.expirationDate.substring(2,4));
            }
        }

        vm.hasMoipPlanAndIsExpired = function(){
            if (vm.loggedAccount){
                return vm.loggedAccount.isExpired && vm.loggedAccount.hasMoipPlan;
            }
        }

        vm.statusPaymentIsAnalyzing = function(){
            if (vm.loggedAccount){
                return vm.loggedAccount.statusPaymentSignature == 'AGUARDANDO_CONFIRMACAO' && !vm.loggedAccount.isExpired;
            }
        }

        vm.getFormattedPrice = function(price) {
			if (!price || price == 0){
	            return '0' + ',' + '00';
			}else {
	            price = price.toString();
	            return price.substring(0, price.length - 2) + ',' + price.substring(price.length - 2, price.length);
			}
        }

		vm.getPriceWithoutCents = function(price) {
            price = price.toString();
            return price.substring(0, price.length - 2);
        }

		vm.loadValueStarter = function(){
			valueStarter
		}

        vm.getWithCouponPrice = function(price) {
            if (vm.checkout.coupon && vm.checkout.coupon.status === 'ACTIVE' && vm.isPlanoPro) {
                delete vm.checkout.coupon.creationDate
                if (vm.checkout.coupon.discount.type === 'PERCENT') {
                    price = price - (price * (vm.checkout.coupon.discount.value / 100) ) / 100;
                } else if (vm.checkout.coupon.discount.type === 'AMOUNT') {
                    price = price - vm.checkout.coupon.discount.value;
                };
                if (price === 0) {
                    price = "000"
                };
            }
            price = price.toString();
            return price.substring(0, price.length - 2) + ',' + price.substring(price.length - 2, price.length);
        }

        vm.verifyCardNumber = function(){
            vm.invalidCardNumber = !Moip.Validator.isValid(vm.checkout.cardNumber);
            vm.brandCard = Moip.Validator.cardType(vm.checkout.cardNumber) ? Moip.Validator.cardType(vm.checkout.cardNumber).brand : null;
        }

        function commonsVerifies(){
            if (vm.outsideBrazilState && vm.checkout.country != "BRA") {
                vm.checkout.state = vm.outsideBrazilState;
            }

            if (vm.selectedPlan && vm.selectedPlan.code){
                vm.checkout.planCode = vm.periodSelected == 'annually' ?  vm.selectedPlan.annuallyCode : vm.selectedPlan.code;
                return true;
            }

            return false;
        }

        function selectColorBoleto(){

            if (!vm.checkedBoleto) {
                $( "#boleto_div" ).css("background-color", "");
                $( "#boleto_span" ).css("color", "");

            } else {
                $( "#boleto_div" ).css("background-color", mainColor);
                $( "#boleto_span" ).css("color", "white");
            }



            $( "#credit_card_div" ).css("background-color", "");
            $( "#credit_card_span" ).css("color", "");
        }

        function selectColorCreditCard(){

            if (!vm.checkedCreditCard) {
                $( "#credit_card_div" ).css("background-color", "");
                $( "#credit_card_span" ).css("color", "");

            } else {
                $( "#credit_card_div" ).css("background-color", mainColor);
                $( "#credit_card_span" ).css("color", "white");
            }

            $( "#boleto_div" ).css("background-color", "");
            $( "#boleto_span" ).css("color", "");
        }

        vm.selectBoletoAsPaymentWay = function () {
            if (!vm.selectedPlan.paymentMethod == 'BOLETO' || !vm.selectedPlan.paymentMethod == 'ALL'){
                vm.checkedBoleto = !vm.checkedBoleto;
            }

            if (vm.checkedCreditCard && vm.checkedBoleto){
                vm.checkedCreditCard = false;
            }

            selectColorBoleto();

        }

        vm.selectCreditCardAsPaymentWay = function () {
            if (!vm.selectedPlan.paymentMethod == 'CREDIT_CARD' || !vm.selectedPlan.paymentMethod == 'ALL'){
                vm.checkedCreditCard = !vm.checkedCreditCard;
            }
            if (vm.checkedBoleto && vm.checkedCreditCard){
                vm.checkedBoleto = false;
            }

            selectColorCreditCard();

        }

        function createSubscriber(){
			if (!vm.selectedPlan.free){
	            vm.isSaving = true;
	            Principal.identity().then(function(account) {
                    vm.settingsAccount = copyAccount(account)
	                vm.checkout.subscriberLogin = account.login;
	            });
				if (!vm.isPlanoPro){
					vm.checkout.coupon = null;
				}
	            var params = {};
	            vm.checkout.phoneAreaCode = vm.checkout.telNumber.substring(0,2);
	            vm.checkout.phoneNumber = vm.checkout.telNumber.substring(2, vm.checkout.telNumber.length);
	            vm.checkout.streetNumber = vm.checkout.streetNumber || 0;
                vm.checkout.planId = vm.selectedPlan.id;
                vm.checkout.planId = vm.selectedPlan.id;
	            CheckoutService.createSubscriber(vm.checkout).then(function (response) {
	                if (response.data == "OK"){
	                    toastr.success($translate.instant('checkout.form.success.saved'));
	                    params.success = true;

	                    if (response.headers['x-billet-href']){
	                        params.billetLink = response.headers['x-billet-href'] + '/print';
	                    }
	                    $state.go('checkout-result', params);

	                }
	            }, function (response){
	                if (response.headers()['x-error-on-subscriber-message']){
	                    insertMessageAlert(response.headers()['x-error-on-subscriber-message']);
	                }
	                else if (response.headers()['x-showcaseapp-params']){
	                    insertMessageAlert($translate.instant('checkout.form.error.' + response.headers()['x-showcaseapp-params']));
	                }
	                else {
	                    insertMessageAlert($translate.instant('checkout.form.error.notSaved'));
	                }
	                vm.isSaving = false;
					vm.disableButton();
	            });
			}else{
				vm.isSaving = true;
				vm.checkout.planCode = '9999999999'
	            Principal.identity().then(function(account) {
                    vm.settingsAccount = copyAccount(account)
	                vm.checkout.subscriberLogin = account.login;
	            });
	            var params = {};
	            CheckoutService.createSubscriber(vm.checkout).then(function (response) {
	                if (response.data == "OK"){
	                    toastr.success($translate.instant('checkout.form.success.saved'));
	                    params.success = true;

	                    if (response.headers['x-billet-href']){
	                        params.billetLink = response.headers['x-billet-href'] + '/print';
	                    }
	                    //$state.go('checkout-result', params);
						window.location.href = '/app/home';

	                }
	            }, function (response){
	                if (response.headers()['x-error-on-subscriber-message']){
	                    insertMessageAlert(response.headers()['x-error-on-subscriber-message']);
	                }
	                else if (response.headers()['x-showcaseapp-params']){
	                    insertMessageAlert($translate.instant('checkout.form.error.' + response.headers()['x-showcaseapp-params']));
	                }
	                else {
	                    insertMessageAlert($translate.instant('checkout.form.error.notSaved'));
	                }
	                vm.isSaving = false;
					vm.disableButton();
	            });
			}
        }

        vm.validateCoupon = function() {
			vm.visibleAlert = false;
            vm.isValidatingCoupon = true;
            CheckoutService.validateCoupon(vm.checkout.couponCode).then( function (res) {
                if (res && res.data && res.data.status === 'ACTIVE') {
                    vm.checkout.coupon = res.data;
                } else {
                    insertMessageAlert($translate.instant('checkout.plan.coupon.error.invalid'));
                }
            }).catch(function(err) {
                vm.checkout.coupon = null;
                insertMessageAlert($translate.instant('checkout.plan.coupon.error.notFound'));
            }).finally(function(){
                vm.isValidatingCoupon = false;
            });
        }

        vm.subscribAsFree = function() {
            vm.isSaving = true;
            CheckoutService.createSubscriberFree().then(function() {
                vm.isSaving = false;
                $timeout(function(){
                    if (!$localStorage.defaultStore.storeId) {
                        window.location = '/first/info';
                    } else {
                        $state.go('home');
                    }
                }, 200);
            }).catch(function() {
                vm.isSaving = false;
            });
        }

        vm.sendToMopiPaymentWithBillet = function() {
            if (!vm.formAddress.$invalid){
                if (commonsVerifies()){
                    vm.checkout.birthdateDay = vm.checkout.dateOfBirth.substring(0,2);
                    vm.checkout.birthdateMonth = vm.checkout.dateOfBirth.substring(2,4);
                    vm.checkout.birthdateYear = vm.checkout.dateOfBirth.substring(4,8);

                    vm.checkout.paymentMethod = 'BOLETO';
                    vm.checkout.expirationMonth = undefined;
                    vm.checkout.expirationYear = undefined;
                    vm.checkout.holderName = undefined;
                    vm.isSaving = true;
                    createSubscriber();
                }
            }
        }

        vm.sendToMopiPaymentWithCard = function() {
            if (!vm.paymentForm.$invalid && !vm.formAddress.$invalid){
                if (commonsVerifies()){
                    if (vm.expirationDate && !vm.invalidExpirationDate) {
                        vm.checkout.birthdateDay = vm.checkout.dateOfBirth.substring(0,2);
                        vm.checkout.birthdateMonth = vm.checkout.dateOfBirth.substring(2,4);
                        vm.checkout.birthdateYear = vm.checkout.dateOfBirth.substring(4,8)

                        vm.checkout.expirationMonth = vm.expirationDate.substring(0,2);
                        vm.checkout.expirationYear = vm.expirationDate.substring(2,4);
                        vm.isSaving = true;
                        vm.checkout.paymentMethod = 'CREDIT_CARD';
                        createSubscriber();
                    }
                    else {
                        toastr.warning($translate.instant('checkout.form.error.wrongExpirationDate'));
                    }

                }
            }
        }

		vm.initSelectPlan = function(){
			//vm.checkPlanStarter = true;
			vm.checkPlanPro = false;
			vm.selectPlanStarter();
			vm.selectPlanPro();
		}

		vm.selectPlanStarter = function(){
			//if(vm.checkPlanStarter){
			vm.selectedPlanStarter = vm.gettedPlans[5];
			/*}else{
				vm.selectedPlanStarter = vm.gettedPlans[1];
			}*/

			// vm.selectPlan(vm.selectedPlanStarter);
            unmarkSelected("planPro");
	        markSelected("planStarter");
			$( "#chkPlanStarter" ).addClass( "md-checked" );
			$( "#chkPlanPro" ).removeClass( "md-checked" );
			vm.isPlanoPro = false;
			vm.isSaving = false;
		}




		vm.selectPlanPro = function(){
			if(vm.checkPlanPro){
				vm.selectedPlanPro = vm.gettedPlans[4];
			}else{
				vm.selectedPlanPro = vm.gettedPlans[3];
			}
			// vm.selectPlan(vm.selectedPlanPro);
	        unmarkSelected("planStarter");
            markSelected( "planPro");
			$( "#chkPlanStarter" ).removeClass( "md-checked" );
			$( "#chkPlanPro" ).addClass( "md-checked" );
			vm.isPlanoPro = true;
		}

		vm.saibaMais = function (){
			/*PlanModalFactory.choosePlan().then(function() {
            });*/
 			return $uibModal.open({
                templateUrl: 'app/account/checkout/plan-modal.html',
                controller: 'PlanModalController',
                controllerAs: 'vm',
                size: 'md',
                keyboard : false
            }).result;
		}

        vm.getCurrentPrice = function() {
            if (vm.selectedPlan) {
                return vm.periodSelected == 'annually' ? vm.selectedPlan.amountAnnually : vm.selectedPlan.amountMonth;
            }
            return 0;
        }

        vm.selectPlan = function (plan){
            vm.selectedPlan = plan;

            vm.checkedBoleto = false;
            vm.checkedCreditCard = false;

            selectColorBoleto();
            selectColorCreditCard();
            loadPaymentUrl();
        }

        vm.disableButton = function (){
            // if (vm.formAddress.$invalid){
            //     return true;
            // } else if (!vm.checkedBoleto && !vm.checkedCreditCard) {
            //     return true;
            // } else if (vm.checkedCreditCard && vm.paymentForm.$invalid) {
            //     return true;
            // } else if (vm.checkedCreditCard && vm.invalidCardNumber){
            //     return true;
            // } else if(vm.isSaving){
            //     return vm.isSaving;
            // } else if (vm.checkout.dateOfBirth == undefined ) {
            //     return true;
            // } else {
            //     return false;
            // }

            return false;
        }


        function markSelected(plan){
            $("#" + plan).css("background-color", mainColor);
            $("#" + plan).css("color", "white");
			$("#saibaMais" + plan).css("color", "#45ce84")
        }

        function unmarkSelected(plan){
            $("#" + plan).css("background-color", "white");
            $("#" + plan).css("color", "black");
			$("#saibaMais" + plan).css("color", mainColor)
        }

        vm.getStoreNickName = function () {
            if ($localStorage.defaultStore){
                return $localStorage.defaultStore.storeNickname;
            }
        }

		vm.goHome = function(){
			window.location.href = '/app/home';
		}

        vm.checkCEP = function () {
            if (vm.checkout.zipcode && vm.checkout.zipcode.length === 8) {
                CheckCEPService.getAddress(vm.checkout.zipcode).then(function (response) {
                    // For now, only Brazilan addresses
                    if (response.data){
                        vm.checkout.country = "BRA";
                        vm.checkout.city = response.data.location.name;
                        vm.checkout.state = response.data.location.uf;
                        vm.checkout.street = response.data.name;
                        vm.checkout.district = response.data.district.name;
                    }
                });
            }
        }

        loadAll();
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('checkout-result', {
            url: '/checkout-result',
            data: {
                pageTitle: 'store-info.pageTitle'
            },
            templateUrl: 'app/account/checkout/checked.html',
            controller: 'CheckedController',
            controllerAs: 'vm',
            params: {
                'success': null,
                'billetLink' : null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('checkout');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('CheckedController', CheckedController);

    function CheckedController($stateParams, toastr, CheckoutService, Auth, $state, $window) {

        var vm = this;

        vm.hasSuccess = undefined;
        vm.billetLink = null;
        vm.account = null;
        vm.isGeneratingBillet = false;

        function loadAll(){
            vm.hasSuccess = $stateParams.success;
            vm.billetLink = $stateParams.billetLink;
        }

        vm.openReceivedBilletLink = function(){
            if (vm.billetLink){
                $window.open(vm.billetLink, 'BILLET', 'height=800,width=600,scrollbars=yes');
            }            
        }

        vm.openBilletLink = function () {
            vm.isGeneratingBillet = true;
            CheckoutService.generateBillet().then(function (response) {
                if (response.headers['x-billet-href']) {
                    $window.open(response.headers['x-billet-href'] + '/print', 'BILLET', 'location=yes,height=800,width=600,scrollbars=yes');
                }
                vm.isGeneratingBillet = false;
            }, function (error) {
                vm.isGeneratingBillet = false;
                toastr.error($translate.instant('register.messages.error.emailexists'));
            });
        }

        vm.logout = function () {
            Auth.logout();
            $state.go('main-login');
        }

        loadAll();
    }

})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            templateUrl: 'app/account/activate/activate.html',
            controller: 'ActivationController',
            controllerAs: 'vm',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$state', '$stateParams', 'Auth'];

    function ActivationController($state, $stateParams, Auth) {
        var vm = this;

        Auth.activateAccount({
            key: $stateParams.key
        }).then(function() {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function() {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = function() {
            $state.go('main-login');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){'use strict';angular.module('showcaseApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<style>.link-div {\n        display: inline-block;\n        padding-left: 25px;\n        padding-right: 25px;\n        padding-top: 15px;\n        padding-bottom: 15px;\n        box-shadow: 0 0 6px #bbbbbb;\n        font-size: 18px;\n        text-align: left;\n        font-weight: 500;\n    }\n\n    .parent {\n        height: 350px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n        align-items: center;\n    }</style><div class="wrapper wrapper-content animated fadeInRight mb-trial-mobile"><div class="row"><div ng-show="vm.loading" class="col-xs-12 m-t-xl"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div><div class="col-lg-12" ng-show="!vm.loading"><div class="col-xs-12 col-md-6"><div ng-style="{\'margin-top\': (vm.storePendencies && !vm.storePendencies.hasPublishedShowcase) ? \'130px\' : \'0\'}"><h1 style="font-size: 35px">{{\'home.welcome.hello\' | translate}}, {{vm.account.firstName}}!</h1><p ng-if="vm.storePendencies && !vm.storePendencies.hasPublishedShowcase" class="text-muted">{{\'home.welcome.subtitle1\' | translate}}</p><p ng-if="vm.storePendencies && vm.storePendencies.hasPublishedShowcase" class="text-muted m-b-lg" data-translate="home.welcome.subtitle2">{{\'home.welcome.subtitle2\' | translate}}</p></div><div class="row" style="display: flex" ng-if="vm.userProfile.profileId != 7 && vm.storePendencies && vm.storePendencies.hasPublishedShowcase"><div style="padding: 0 15px"><div class="ibox" style="width: 160px"><div class="ibox-content text-center p-sm"><h2 class="font-bold m-t-lg m-b-xs" style="margin-top: 20px; font-size: 20px">{{vm.report.totalOrders}}</h2><span class="text-muted">{{\'home.dashboard.order\' | translate}}</span> <a ui-sref="invoices" class="btn btn-primary m-t-lg full-width">{{\'home.button-details\' | translate}}</a></div></div></div><div style="padding: 0 15px"><div class="ibox" style="width: 160px"><div class="ibox-content text-center p-sm"><h2 class="font-bold m-t-lg m-b-xs" style="margin-top: 20px; font-size: 20px">{{vm.report.totalCustomers}}</h2><span class="text-muted">{{\'home.dashboard.clients\' | translate}}</span> <a ui-sref="customers" class="btn btn-primary m-t-lg full-width">{{\'home.button-details\' | translate}}</a></div></div></div><div ng-if="vm.showTotalSales()" style="padding: 0 15px"><div class="ibox" style="width: 160px"><div class="ibox-content text-center p-sm"><h2 class="font-bold m-t-lg m-b-xs" style="margin-top: 20px; font-size: 20px"><span>R$ {{vm.report.totalBilled | number : 2}}</span></h2><span class="text-muted">{{\'home.dashboard.total\' | translate}}</span> <a ui-sref="invoices" class="btn btn-primary m-t-lg full-width">{{\'home.button-details\' | translate}}</a></div></div></div></div></div><div class="col-md-6 hidden-xs"><img class="pull-right" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/dashboard-virtual-store.png" style="width: auto; height: 320px"></div></div><div class="col-xs-12 m-b-md" ng-show="vm.loading"><div class="hr-line-dashed no-margins"></div></div><div class="col-xs-12" ng-show="!vm.loading"><div ng-if="vm.video" style="color: #5d5d5d"><div class="col-xs-12 col-md-3"><div class="ibox"><div class="ibox-content text-center p-sm" style="height: 306px"><img ng-src="{{vm.video.imagePath}}" style="width: auto; height: 100px; margin-top: 20px"><div class="m-l-md m-r-md m-t-lg"><h3 class="font-normal">{{vm.video.title}}</h3><p class="text-muted truncate">{{vm.video.subtitle}}</p></div></div><div class="ibox-footer noborder"><div class="row text-muted" style="font-size: 16px"><div class="col-xs-2 text-left"><button class="btn-transparent no-padding" ng-click="vm.changeStep(-1)" ng-disabled="vm.videoStep === 0"><i class="fa fa-chevron-left"></i></button></div><div class="col-xs-8 text-center m-t-xxs" style="font-size: 15px"><span class="coupon-text-color">{{\'home.welcome.step\' | translate}} {{vm.videoStep + 1}}</span></div><div class="col-xs-2 text-right"><button class="btn-transparent no-padding" ng-click="vm.changeStep(1)" ng-disabled="vm.videoStep === vm.videos.length-1"><i class="fa fa-chevron-right"></i></button></div></div></div></div></div><div class="col-xs-12 col-md-9" ng-if="!vm.video.links && vm.store.hubId !=4"><div class="ibox"><div class="ibox-content text-center p-sm" style="height: 350px"><div class="col-md-9 p-sm"><figure style="width: 100%; height: 295px"><iframe ng-src="{{vm.getTrustedUrl(vm.video.url)}}" style="width: 100%; height: 100%; max-width: 524px; float: left; border: 1px solid #efefef" frameborder="0" allowfullscreen="" data-aspectratio="0.8211764705882353"></iframe></figure></div><div class="col-md-3" ng-style="{\'margin-top\': (100/vm.video.actions.length + 1) + \'px\'}"><p class="text-muted">{{vm.video.actionText}}</p><div class="m-b-md" ng-repeat="action in vm.video.actions"><a ui-sref="{{action.url}}" class="btn btn-primary" style="min-width: 166px">{{action.label}}</a></div></div></div></div></div><div class="col-xs-12 col-md-9" ng-if="!vm.video.links && vm.store.hubId ==4"><div class="ibox"><div class="ibox-content text-center p-sm" style="height: 350px"><div class="col-md-9 p-sm"><figure style="width: 100%; height: 295px"><img style="width: 100%; height: 100%; max-width: 524px; float: left; border: 1px solid #efefef" src="{{vm.video.url}}"></figure></div><div class="col-md-3" ng-style="{\'margin-top\': (100/vm.video.actions.length + 1) + \'px\'}"><p class="text-muted">{{vm.video.actionText}}</p><div class="m-b-md" ng-repeat="action in vm.video.actions"><a ui-sref="{{action.url}}" class="btn btn-primary" style="min-width: 166px">{{action.label}}</a></div></div></div></div></div><div class="col-xs-12 col-md-9" ng-if="vm.video.links"><div class="ibox"><div class="ibox-content parent"><div class="row"><div class="col-md-12"><div class="m-l-md m-r-md m-t-lg text-center"><label class="font-normal" style="font-size: 25px">{{vm.video.titleRight}}</label><p class="text-muted truncate">{{vm.video.subtitleRight}} <a href="https://www.facebook.com/help/instagram/362497417173378?helpref=uf_permalink" target="_blank"><span class="coupon-text-color" style="cursor:pointer">{{vm.video.link}}</span></a></p></div></div></div><div class="row" style="text-align: center; margin-top: 15px; margin-bottom: 25px; width: 70%"><div class="m-t-xxs link-div col-md-12"><i class="fa-rotate-270 fa fa-link" aria-hidden="true" style="color:#bdbdbd"></i> <span class="coupon-text-color">{{ vm.getShowcaseURL() }}</span></div></div><div class="row"><div class="m-b-md"><a ng-click="vm.copyLink()" class="btn btn-primary" style="min-width: 166px">{{vm.video.actionLabel}}</a></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/integrations/integrations.html','<div class="wrapper wrapper-content"><div class=""><ul class="nav nav-tabs" ng-init="vm.changeTab(\'instagramBusiness\')"><li ng-class="{\'active\' : vm.tabSelected === \'instagramBusiness\'}" class="ksc-tab"><a ng-click="vm.changeTab(\'instagramBusiness\')"><i class="fa fa-instagram"></i>&nbsp; <span>Instagram</span></a></li><li ng-class="{\'active\' : vm.tabSelected === \'facebook\'}" class="ksc-tab"><a ng-click="vm.changeTab(\'facebook\')"><i class="fa fa-facebook"></i>&nbsp; <span>Facebook</span></a></li><li ng-class="{\'active\' : vm.tabSelected === \'facebookBusiness\'}" class="ksc-tab" ng-show="false"><a ng-click="vm.changeTab(\'facebookBusiness\')"><i class="fa fa-bullhorn"></i>&nbsp; <span>Campanhas Patrocinadas</span></a></li><li ng-class="{\'active\' : vm.tabSelected === \'googleBusiness\'}" class="ksc-tab" ng-show="false"><a ng-click="vm.changeTab(\'googleBusiness\')"><i class="fa fa-google"></i>&nbsp; <span>Google My Business</span></a></li><li ng-if="false" ng-class="{\'active\' : vm.tabSelected === \'whatsapp\'}" class="ksc-tab"><a ng-click="vm.changeTab(\'whatsapp\')"><i class="fa fa-whatsapp"></i>&nbsp; <span>Whatsapp</span></a></li><div style="display: flex; justify-content: flex-end; margin-top: 3px"><div ng-show="(vm.tabSelected === \'instagramBusiness\' && vm.igAccountConnected) || (vm.tabSelected === \'facebook\' && vm.facebook.connected)"><div class="input-group date" id="insigthsDateRange"><input id="dateRangeInput" style="float: right; background-color: #fffefe" date-range-picker class="form-control date-picker ng-pristine ng-valid ng-isolate-scope ng-touched" readonly="readonly" ng-model="vm.dateRange" options="vm.dateRangeOptions" required=""> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div></div></div></ul></div><div class="tab-content" style="min-height: 450px; background-color: white" class="ksc-painel-tab"><div id="tab-Insta" class="row active" ng-show="vm.tabSelected ===\'instagramBusiness\'"><div class="col-sm-12" ng-include="\'app/integrations/instagram-business/instagram-business-tab.html\'"></div></div><div id="tab-auth" class="row active" ng-show="vm.tabSelected ===\'facebook\'"><div class="col-sm-12" ng-include="\'app/integrations/facebook-business/facebook-tab.html\'"></div></div><div id="tab-camp" class="row active" ng-show="vm.tabSelected ===\'facebookBusiness\'"><div class="col-sm-12" ng-include="\'app/integrations/facebook-business/facebook-my-business-tab.html\'"></div></div><div id="tab-G" class="row active" ng-show="vm.tabSelected ===\'googleBusiness\'"><div class="col-sm-12" ng-include="\'app/integrations/google-my-business/google-my-business-tab.html\'"></div></div><div id="tab-W" class="row ative" ng-show="vm.tabSelected ===\'whatsapp\'"><div ng-include="\'app/integrations/whatsapp/whatsapp-campaing.html\'"></div></div></div></div>');
$templateCache.put('app/social-media/publish-creater.html','<div class="ibox"><div class="ibox-content" style="min-height: 840px; padding-bottom: 0"><div class="tab-content"><div class="tab-pane active"><div id="social-media-connected" class="row m-b-lg"><div class="col-lg-12"><h3 data-translate="socialMedia.fields.sections.postDestinyTitle" style="color: #606062; font-size: 1.2em; font-family: Humanst521 Lt BT"></h3><h3 data-translate="socialMedia.fields.sections.postDestinyDescription" style="color: #606062; font-size: 1em; font-family: Humanst521 Lt BT"></h3></div><div class="col-lg-12"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" style="padding: 0%"><button id="button_facebook" class="btn btn btn-facebook" ng-if="vm.facebookConnected" style="color: white" ng-click="vm.connectOrSelectFacebook()"><span class="fa fa-facebook" style="margin: 0 5px 0 2px"></span> <span ng-if="!vm.facebookConnected || vm.facebookSelected">|</span> <span data-translate="socialMedia.button.connectToFacebook" ng-if="!vm.facebookConnected"></span> <span class="fa fa-check" style="color: white" ng-if="vm.facebookSelected"></span></button> <button id="button_facebook" ng-if="!vm.facebookConnected" has-authority="SOCIAL_MEDIA_LOGIN" class="btn btn-facebook" style="color: white" ng-click="vm.connectOrSelectFacebook()"><span class="fa fa-facebook" style="margin: 0 5px 0 2px"></span> <span ng-if="!vm.facebookConnected || vm.facebookSelected">|</span> <span data-translate="socialMedia.button.connectToFacebook" ng-if="!vm.facebookConnected"></span></button></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" style="margin-top: 9px"><span class="pull-right" ng-if="vm.facebookConnected" ng-click="vm.facebookDisconnect()" data-translate="socialMedia.button.logout">Logout</span></div></div><div class="col-lg-12" ng-if="false"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" style="padding: 0%"><button id="button_instagram" class="btn" ng-style="(!vm.instagramConnected || vm.instagramSelected) &&\n                                        {\'background-color\': \'none\', \'background-image\': \'linear-gradient(to right, rgb(190, 51, 128), rgb(236, 86, 66))\'}\n                                        || {\'background-color\': \'gray\', \'background-image\': \'none\'} " style="color: white; margin-top: 10px" ng-click="vm.connectOrSelectInstagram()"><img src="/content/images/instagram_icon.png" style="width: 15px; margin-bottom: 2px"><span ng-if="!vm.instagramConnected || vm.instagramSelected">|</span> <span data-translate="socialMedia.button.connectToInstagram" ng-if="!vm.instagramConnected"></span> <span class="fa fa-check" style="color: white" ng-if="vm.instagramSelected"></span></button></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" style="margin-top: 20px"><span class="pull-right" ng-if="vm.instagramConnected" ng-click="vm.instagramDisconnect()" data-translate="socialMedia.button.logout">Logout</span></div></div></div><div class="hr-line-dashed" ng-if="false"></div><div class="row" ng-if="vm.facebookSelected"><div class="col-sm-5 col-lg-5 col-md-5 col-xs-12"><h3 data-translate="socialMedia.fields.sections.pageSelectionTitle" style="color: #606062; font-size: 1.2em; font-family: Humanst521 Lt BT"></h3></div><div id="select-page-section" class="col-sm-7 col-lg-7 col-md-7 col-xs-12"><div class="pull-right" class="col-sm-12 col-lg-12 col-md-12 col-xs-12"><select ng-if="vm.facebookConnected" id="type" name="type" type="text" class="form-control" ng-change="vm.changePage()" ng-model="vm.postDTO.pageSelected" required><option ng-repeat="page in vm.facebookDataConnected.pages" value="{{page}}">{{page.name}}</option></select><div class="col-sm-12 col-lg-12 col-md-12 col-xs-12" ng-if="!vm.facebookConnected"><h3 data-translate="socialMedia.error.needBeConnected" style="color: #606062; font-size: 1.0em; font-family: Humanst521 Lt BT"></h3></div><div class="col-sm-12 col-lg-12 col-md-12 col-xs-12" ng-if="vm.facebookConnected && (!vm.facebookDataConnected.pages || vm.facebookDataConnected.pages.length <= 0)"><h3 data-translate="socialMedia.error.noPagesExists" style="color: #606062; font-size: 1.0em; font-family: Humanst521 Lt BT"></h3></div></div></div></div><div class="row" ng-if="vm.instagramSelected"><div class="col-sm-12 col-lg-12 col-md-12 col-xs-12"><h3 style="color: #606062; font-size: 1.2em; font-family: Humanst521 Lt BT">{{ \'socialMedia.fields.sections.instagramConnectedAccount\' | translate }}: {{ vm.instagramAccountConnected }}</h3></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-sm-6 col-lg-6 col-md-6 col-xs-12"><h3 data-translate="socialMedia.fields.sections.offerSelectionTitle" style="color: #606062; font-size: 1.2em; font-family: Humanst521 Lt BT"></h3></div><div id="select-flyer-section" class="col-sm-6 col-lg-6 col-md-6 col-xs-12"><div id="offer-selection-section" class="col-lg-12"><div class="pull-right" style="z-index: 999999"><div class="dropdown dropdown-table btn-group"><a class="showcase-menu-button" data-toggle="dropdown" aria-expanded="false"><span tooltip-placement="top-right" ng-click="vm.openSelectionFlyers()" uib-tooltip="{{\'socialMedia.button.selectOffer\' | translate}}" class="fa fa-tag" style="font-size: 2.6em !important"></span> </a><!-- <i class="fa fa-question-circle" tooltip-placement="bottom-right" uib-tooltip="{{\'socialMedia.button.explanation\' | translate}}" style="color: #676A6C; font-size: 1.3em"></i> --></div></div></div></div></div><div class="hr-line-dashed"></div><div class="row m-b-lg"><div id="content-section" class="col-lg-12"><h3 data-translate="socialMedia.fields.sections.content" style="color: #606062; font-size: 1.2em; font-family: Humanst521 Lt BT"></h3><h3 data-translate="socialMedia.fields.sections.contentDescription" style="color: #606062; font-size: 1em; font-family: Humanst521 Lt BT"></h3><div class="full-height-scroll" full-scroll><textarea id="post_content" rows="5" ng-model="vm.postDTO.message" style="width: 100%"></textarea></div></div></div><div class="hr-line-dashed"></div><div class="row m-b-lg"><div class="col-lg-12 col-sm-12 col-md-12 col-xs-12"><h3 data-translate="socialMedia.fields.sections.imageContent" style="color: #606062; font-size: 1.2em; font-family: Humanst521 Lt BT"></h3><h3 data-translate="socialMedia.fields.sections.imageContentDescription" style="color: #606062; font-size: 1em; font-family: Humanst521 Lt BT"></h3><span class="pull-right col-lg-6 col-sm-6 col-md-6 col-xs-6 center" style="padding: 0px; color: #606062; font-size: 1em; font-family: Humanst521 Lt BT">{{ vm.image ? vm.image.name : ( \'socialMedia.fields.noImageContent\' | translate ) }} <i ng-if="vm.image" class="fa fa-trash primary-color" ng-click="vm.excludeImageUploaded()"></i> </span><span class="pull-right col-lg-6 col-sm-6 col-md-6 col-xs-6"><button id="button_add_image" class="btn btn btn-primary" ng-change="vm.selectedImage()" ngf-select="vm.selectedImage($file)" ng-model="vm.image" name="image" ngf-pattern="\'image/*\'" ngf-accept="\'image/*\'" ngf-max-size="5MB"><span class="fa fa-upload"></span> <span data-translate="socialMedia.button.addImage"></span></button></span></div></div><div class="hr-line-dashed"></div><div class="row m-b-lg"><div class="col-lg-12 col-sm-12 col-md-12 col-xs-12"><h3 data-translate="socialMedia.fields.sections.postOption" style="color: #606062; font-size: 1.2em; font-family: Humanst521 Lt BT"></h3><h3 data-translate="socialMedia.fields.sections.postOptionDescription" style="color: #606062; font-size: 1em; font-family: Humanst521 Lt BT"></h3><div class="col-lg-6 col-sm-6 col-md-6 col-xs-6"><div class="checkbox"><label><input ng-disabled="vm.instagramSelected" type="checkbox" class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-empty" ng-model="vm.isToSchedule" ng-click="vm.toSchedule()" aria-invalid="false"> <span class="checkbox-material"><span class="check"></span> </span><span id="boleto_span" data-translate="socialMedia.button.schedule" class="ng-scope">Schedule post</span></label></div></div><div class="col-lg-6 col-sm-6 col-md-6 col-xs-6"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-empty" ng-model="vm.isToNow" ng-click="vm.toNow()" aria-invalid="false"> <span class="checkbox-material"><span class="check"></span> </span><span id="boleto_span" data-translate="socialMedia.button.sendPostNow" class="ng-scope">Send now</span></label></div></div><div class="col-lg-12 col-sm-12 col-md-12 col-xs-12" ng-if="vm.isToSchedule"><form name="vm.postDTOForm" role="form" novalidate ng-init="vm.init()"><div class="row" style="margin: 0 !important; padding: 0 !important"><div class="form-group col-md-12 store-input-detail-nopadding"><div class="form-group" style="margin-top: 5px; margin-bottom: 5px"><label for="schedule" class="required" data-translate="socialMedia.fields.dateAndHour">Start Date</label><div class="input-group date" id="schedulePicker"><input name="schedule" type="text" id="schedule" class="form-control inputDate" readonly="readonly" ng-required="vm.isToSchedule" autocomplete="off" ng-model="vm.postDTO.schedule"> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><div class="help-block-div" ng-show="vm.postDTOForm.schedule.$invalid && vm.postDTOForm.$submitted"><p class="help-block form-invalid-field" ng-show="vm.postDTOForm.schedule.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.postDTOForm.schedule.$error.minDate" data-translate="socialMedia.fields.error.scheduleTimeGreaterOrEqualNow">Start date must be greater than or equal to current date.</p></div></div></div></div></form></div></div></div><div class="row" style="padding-bottom: 20px"><div class="col-lg-12"><button id="button_do_post" ladda="vm.isSaving" class="btn btn btn-primary col-lg-12 col-md-12 col-xs-12 col-sm-12" ng-click="vm.doPost()" ng-disabled="vm.isInvalidForm()"><span ng-if="vm.isToNow" data-translate="socialMedia.button.send"></span> <span ng-if="vm.isToSchedule" data-translate="socialMedia.button.schedule"></span></button></div></div></div></div></div></div>');
$templateCache.put('app/social-media/publish-previewer.html','<div class="ibox"><div class="social-feed-box" style="padding: 0 2%  0 2%; min-height: 840px"><div class="social-body"><div class="row m-b-lg" style="margin-bottom: 5px"><div id="title-section" class="col-lg-12" style="padding: 0; margin-bottom: 10px"><h3 data-translate="socialMedia.fields.sections.postPreviewer" style="color: #606062; font-size: 1.2em; font-family: Humanst521 Lt BT"></h3><h3 data-translate="socialMedia.fields.sections.postPreviewerDescription" style="color: #606062; font-size: 1em; font-family: Humanst521 Lt BT"></h3></div></div><div class="row" style="border: 1px solid #C0C0C0; padding: 2%; min-height: 400px"><div id="obs-section" class="col-lg-12" style="padding: 0" ng-if="!vm.postDTO.message && !vm.postDTO.picture"><h3 data-translate="socialMedia.fields.sections.noContentToPost" style="color: #606062; font-size: 1.2em; font-family: Humanst521 Lt BT; max-height: 850px; display: block; margin-left: auto; margin-right: auto; padding-bottom: 0; text-align: center"></h3></div><div class="row m-b-lg" ng-if="vm.postDTO.message"><div id="message-section" class="col-lg-12"><div ng-bind="vm.postDTO.message"></div></div></div><div class="row" ng-if="vm.postDTO.picture"><div id="message-section" class="col-lg-12"><img src="{{ vm.postDTO.picture }}" class="img-responsive" style="max-height: 850px; display: block; margin-left: auto; margin-right: auto; width: 50%; padding-bottom: 0"></div></div></div></div></div></div>');
$templateCache.put('app/social-media/social-media.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-sm-4" ng-include="\'app/social-media/publish-creater.html\'"><!-- <div ></div> --></div><div class="col-sm-8" ng-include="\'app/social-media/publish-previewer.html\'"><!-- <div ></div> --></div></div></div>');
$templateCache.put('app/store/form.store.info.html','<div class="row text-center"><div class="col-lg-12"><h1 style="font-size: 1.8em; font-family: Roboto">1. <span data-translate="store-management.first.info.title"></span></h1></div><div class="col-lg-12 hidden-xs" style="padding: 20px 0"><img style="height: auto;\n    width: 15%" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/store-information-lg.png"></div><div class="col-lg-12 hidden-xs" style="padding: 20px 50px"><span class="red-color-information" data-translate="store-management.first.info.message"></span></div></div>');
$templateCache.put('app/store/form.store.info.view.html','<ng-form name="storeInfoForm"><div class="row"><div class="col-lg-12 form-group"><label for="socialName" class="required" data-translate="store-management.new.form.name">Name</label><input id="socialName" name="socialName" type="text" class="form-control mobile-input-style" ng-model="vm.store.name" ng-maxlength="128" ng-minlength="4" required ng-change="updateInfoAndLogoStateStep(storeInfoForm.$valid); fillNickname(storeInfoForm)"><div class="help-block-div" ng-show="storeInfoForm.socialName.$invalid && storeInfoForm.socialName.$touched && storeInfoForm.socialName.$dirty || (storeInfoForm.socialName.$invalid && storeInfoForm.$submitted)"><p class="help-block form-invalid-field" ng-show="storeInfoForm.socialName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="storeInfoForm.socialName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="storeInfoForm.socialName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div></div><div class="row"><div class="col-sm-12 form-group" ng-class="{\'col-md-5\': vm.store.nickname}"><label for="nickname" class="required" data-translate="store-management.new.form.nickname">Nickname</label><input id="nickname" name="nickname" type="text" class="form-control mobile-input-style" ng-model="vm.store.nickname" ng-maxlength="40" ng-minlength="4" alphanumeric-only required ng-change="updateInfoAndLogoStateStep(storeInfoForm.$valid); verifyNicknameIsAvailable(storeInfoForm);"><div class="help-block-div" ng-show="storeInfoForm.nickname.$invalid && storeInfoForm.nickname.$touched || (storeInfoForm.nickname.$invalid && storeInfoForm.$submitted)"><p class="help-block form-invalid-field" ng-show="storeInfoForm.nickname.$error.required || storeInfoForm.nickname.$error.parse" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="storeInfoForm.nickname.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="storeInfoForm.nickname.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="40">This field cannot be longer than 40 characters.</p><p class="help-block form-invalid-field" ng-show="storeInfoForm.nickname.$error.nicknameIsUnavailable" data-translate="entity.validation.nickname.unavailable">This nickname is unavailable.</p></div></div><div class="animated fadeInRight form-group" ng-class="{\'col-sm-12 col-md-7\': vm.store.nickname, \'hidden-sm hidden-md hidden-lg hidden-xs\': !vm.store.nickname}"><p class="store-new-domaintext"><span data-translate="store-management.messages.create.yourDomain">Your domain will be:</span><br><span>{{(vm.store.nickname | lowercase) + domainSufix}}</span></p></div></div><div class="row"><div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 form-group"><label for="cnpj">CNPJ</label><input id="cnpj" name="cnpj" type="text" class="form-control mobile-input-style" ng-model="vm.store.cnpj" ng-cnpj ui-mask="99.999.999/9999-99" ng-change="updateInfoAndLogoStateStep(storeInfoForm.$valid); verifyCnpjIsAvailable(storeInfoForm);"><div class="help-block-div" ng-show="(storeInfoForm.cnpj.$invalid && storeInfoForm.$submitted)"><p class="help-block form-invalid-field" ng-show="storeInfoForm.cnpj.$invalid && \n                                                            !storeInfoForm.cnpj.$error.cnpjIsUnavailable && \n                                                            !storeInfoForm.cnpj.$error.required" data-translate="entity.validation.cnpj">This field CNPJ is invalid.</p><p class="help-block form-invalid-field" ng-show="storeInfoForm.cnpj.$error.cnpjIsUnavailable" data-translate="entity.validation.cnpj-unavailable">This CNPJ is unavailable.</p></div></div><div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 form-group"><label for="category" class="required" data-translate="store-management.new.form.category">Category:</label><select class="form-control mobile-input-style" name="category" id="category" ng-model="vm.store.categoryId" required ng-change="updateInfoAndLogoStateStep(storeInfoForm.$valid)"><option ng-repeat="category in vm.categories" value="{{category.id}}">{{category.title}}</option></select><div class="help-block-div" ng-show="storeInfoForm.category.$invalid && storeInfoForm.category.$touched && storeInfoForm.category.$dirty || (storeInfoForm.category.$invalid && storeInfoForm.$submitted)"><p class="help-block form-invalid-field" ng-show="storeInfoForm.category.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 form-group"><label class="required" for="contactPhone" data-translate="store-management.new.form.celphone">Cel phone</label><input type="text" name="contactPhone" id="contactPhone" class="form-control mobile-input-style" ng-model="vm.store.contactPhone" intl-tel-input required ng-change="updateInfoAndLogoStateStep(storeInfoForm.$valid)"><div class="help-block-div" ng-show="storeInfoForm.contactPhone.$invalid && storeInfoForm.contactPhone.$touched && storeInfoForm.contactPhone.$dirty || (storeInfoForm.contactPhone.$invalid && storeInfoForm.$submitted)"><p class="help-block form-invalid-field" ng-show="storeInfoForm.contactPhone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="storeInfoForm.contactPhone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div><div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 form-group"><label for="contactWhatsApp" data-translate="store-management.new.form.whatsapp">WhatsApp</label><input type="text" name="contactWhatsApp" id="contactWhatsApp" class="form-control mobile-input-style" ng-model="vm.store.contactWhatsApp" intl-tel-input ng-change="updateInfoAndLogoStateStep(storeInfoForm.$valid)"><div class="help-block-div" ng-show="storeInfoForm.contactWhatsApp.$invalid && storeInfoForm.contactWhatsApp.$touched && storeInfoForm.contactWhatsApp.$dirty || (storeInfoForm.contactWhatsApp.$invalid && storeInfoForm.$submitted)"><p class="help-block form-invalid-field" ng-show="storeInfoForm.contactWhatsApp.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div><div class="row"><div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 form-group" ng-if="vm.storeTypes.length > 0"><label for="storeType" class="required" data-translate="store-management.new.form.storeType">Store Type:</label><select class="form-control mobile-input-style" required name="storeType" id="storeType" ng-model="vm.store.storeType" ng-change="updateInfoAndLogoStateStep(storeInfoForm.$valid)"><option ng-repeat="storeType in vm.storeTypes" value="{{storeType.id}}">{{storeType.name}}</option></select><div class="help-block-div" ng-show="storeInfoForm.storeType.$invalid && storeInfoForm.storeType.$touched && storeInfoForm.storeType.$dirty || (storeInfoForm.storeType.$invalid && storeInfoForm.$submitted)"><p class="help-block form-invalid-field" ng-show="storeInfoForm.storeType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-class="vm.storeTypes.length > 0 ? \'col-lg-7 col-md-7 col-sm-7 col-xs-12\' : \'col-lg-7 col-md-7 col-sm-7 col-xs-12\'"><label for="email" class="required" data-translate="store-management.new.form.email">E-mail</label><input id="email" name="email" type="email" class="form-control mobile-input-style" ng-model="vm.store.email" ng-maxlength="100" ng-pattern=\'/^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$/i\' required ng-change="updateInfoAndLogoStateStep(storeInfoForm.$valid)"><div class="help-block-div" ng-show="storeInfoForm.email.$invalid && storeInfoForm.email.$touched && storeInfoForm.email.$dirty || (storeInfoForm.$submitted && storeInfoForm.email.$invalid)"><p class="help-block form-invalid-field" ng-show="storeInfoForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="storeInfoForm.email.$error.pattern" data-translate="global.messages.validate.email.invalid">Please input a valid mail.</p><p class="help-block" ng-show="storeInfoForm.email.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">Your email is required to be at least 5 character.</p><p class="help-block form-invalid-field" ng-show="storeInfoForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div></ng-form>');
$templateCache.put('app/store/form.store.logo.info.html','<div class="row form-group text-center"><div class="col-lg-12" title-step-info><h1 style="font-size: 1.8em">2. <span data-translate="store-management.first.logo.title"></span></h1></div><div class="col-lg-12 image-step-info"><img style="height: auto; width: 20%" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/picture-icon-logo.png"></div><div class="col-lg-12 description-step-info"><span class="red-color-information"><span class="red-color-information" data-translate="store-management.first.logo.message"></span></span></div></div>');
$templateCache.put('app/store/form.store.logo.view.html','<div class="row"><div class="col-lg-12 form-group"><input type="file" id="fileInput" accept="image/x-png,image/gif,image/jpeg" style="display: none"><div class="cropArea crop-area-step-info"><img-crop ng-if="$state.current.name == \'store-logo\'" area-type="square" image="logo.imageUpload" on-load-begin="logo.imageChanged = true" result-image-size="vm.imageSize" result-image="vm.store.image" result-image-quality="1.0"></img-crop></div></div><div class="col-xs-12 col-md-5 col-md-offset-7 form-group"><a class="pull-right red-color-information forward-step-button forward-step-button-info" ng-click="vm.openInput($event)" style="font-size: 1.1em"><span data-translate="store-management.first.logo.choose-file">Choose File </span><i class="icon-ksc-upload"></i></a></div></div>');
$templateCache.put('app/store/form.store.point.info.html','<div class="row form-group text-center"><div class="col-lg-12"><h1 style="font-size: 1.8em">2. <span data-translate="store-management.first.point.title"></span></h1></div><div class="col-lg-12 image-step-info"><img style="width: 35%; height: auto" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/point-lg.png"></div><div class="col-lg-12 description-step-info"><span class="red-color-information"><span data-translate="store-management.first.point.message"></span></span></div></div>');
$templateCache.put('app/store/form.store.point.view.html','<div class="row"><div class="col-lg-12 form-group"><ng-form name="vm.salesPointForm"><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-12 col-lg-12" style="padding: 0"><div class="row form-group"><div class="col-xs-12 col-lg-12 col-sm-12 col-md-12"><label class="required" data-translate="store-management.new.form.location.name">Sales point name</label><input type="text" class="form-control mobile-input-style" name="name" ng-model="vm.salespoint.pointlocation.name" ng-required="vm.user.id == null" ng-minlength="4"><div class="help-block-div" ng-show="vm.salesPointForm.name.$invalid && vm.salesPointForm.name.$touched"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p></div></div></div><div class="row form-group"><div class="col-xs-6"><label for="zipcode" class="required" data-translate="store-management.new.form.location.zipcode">Zip code</label><input id="zipcode" type="text" class="form-control mobile-input-style" name="zipcode" ui-mask="99999-999" ng-model="vm.salespoint.pointlocation.postalCode" ng-change="vm.checkCEP()" required><div class="help-block-div" ng-show="vm.salesPointForm.zipcode.$invalid && vm.salesPointForm.zipcode.$touched"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.zipcode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.zipcode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 50 characters.</p></div></div><div class="col-xs-6" ng-if="!vm.user.id"><label for="country" class="required" data-translate="store-management.new.form.location.country">Country</label><select class="form-control mobile-input-style" id="country" name="country" ng-model="vm.salespoint.pointlocation.country" ng-blur="vm.refreshMapWithAddress()" required><option ng-repeat="country in vm.countrys" value="{{country.key}}">{{country.value}}</option></select><div class="help-block-div" ng-show="vm.salesPointForm.country.$invalid && vm.salesPointForm.country.$touched"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.country.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row form-group"><div class="col-xs-6 col-md-6"><label for="state" class="required" data-translate="store-management.new.form.location.state">State</label><select id="state" class="form-control mobile-input-style" name="state" ng-model="vm.salespoint.pointlocation.state" ng-if="vm.salespoint.pointlocation.country === \'BRASIL\'" required><option ng-repeat="state in vm.states" value="{{state.key}}">{{state.value}}</option></select><input type="text" class="form-control mobile-input-style" name="state" ng-model="vm.salespoint.pointlocation.state" ng-if="vm.salespoint.pointlocation.country != \'BRASIL\'" ng-maxlength="30" required><div class="help-block-div" ng-show="vm.salesPointForm.state.$invalid && vm.salesPointForm.state.$touched"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.state.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-xs-6 col-md-6"><label for="city" class="required" data-translate="store-management.new.form.location.city">City</label><input id="city" type="text" class="form-control mobile-input-style" name="city" ng-model="vm.salespoint.pointlocation.city" ng-blur="vm.refreshMapWithAddress()" ng-maxlength="50" required><div class="help-block-div" ng-show="vm.salesPointForm.city.$invalid && vm.salesPointForm.city.$touched"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.city.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row form-group"><div class="col-xs-12"><label class="required" data-translate="store-management.new.form.location.address">Address</label><input type="text" class="form-control mobile-input-style" name="address" ng-maxlength="50" ng-model="vm.salespoint.pointlocation.address" ng-blur="vm.refreshMapWithAddress()" ng-maxlength="50" required><div class="help-block-div" ng-show="vm.salesPointForm.address.$invalid && vm.salesPointForm.address.$touched"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.address.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.address.$error.maxlength" data-translate="entity.validation.maxlength" ranslate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row form-group"><div class="col-xs-6"><label for="neighborhood" data-translate="store-management.new.form.location.neighborhood">Neighborhood</label><input id="neighborhood" type="text" class="form-control mobile-input-style" name="neighborhood" ng-model="vm.salespoint.pointlocation.neighborhood" ng-blur="vm.refreshMapWithAddress()" ng-maxlength="50"><div class="help-block-div" ng-show="vm.salesPointForm.neighborhood.$invalid && vm.salesPointForm.neighborhood.$touched"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.neighborhood.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="col-xs-6 col-md-6 col-lg-6 col-sm-6"><label for="number" data-translate="store-management.new.form.location.number">N\xFAmero</label><input id="number" maxlength="8" numbers-only type="text" class="form-control mobile-input-style" name="number" ng-model="vm.salespoint.pointlocation.number" ng-blur="vm.refreshMapWithAddress()"></div></div><div class="row form-group" style="margin-bottom: 0"><div class="col-xs-12 col-md-12 col-sm-12 col-lg-12"><label for="contactnumber" class="required" data-translate="store-management.new.form.contactnumber">Contact number</label><input id="contactnumber" type="text" class="form-control mobile-input-style" name="contactNumber" intl-tel-input ng-model="vm.salespoint.pointlocation.contactPhone" ng-blur="vm.refreshMapWithAddress()" required><div class="help-block-div" ng-show="vm.salesPointForm.contactNumber.$invalid && vm.salesPointForm.contactNumber.$touched"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.contactNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.contactNumber.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div></div></div></div></ng-form></div><div class="col-md-12 form-group" style="margin-bottom: 0"><div class="help-block-div" ng-show="vm.formInvalid" style="padding-left: inherit"><p class="help-block form-invalid-field" data-translate="store-management.first.validation.sales-point">Please fill in all required fields (*)</p></div></div></div>');
$templateCache.put('app/store/info.html','<div class="info-item info-title"><div class="app-container"><h1 data-translate="store-management.first.title">Criar uma loja nunca foi t\xE3o simples</h1><span data-translate="store-management.first.subtitle">Apenas 3 passos para sua loja ficar pronta e come\xE7ar a vender agora mesmo!</span></div></div><div class="info-item info-steps"><div class="app-container"><div class="step1"><span class="page-external-font custom-step-title-mobile" data-translate="store-management.first.header.first-step">1. Store Information</span> <img class="store-info hidden-xs" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/store-information-lg.png"></div><div class="icon1"><i class="icon-ksc-step"></i></div><div class="step2"><span class="page-external-font custom-step-title-mobile" data-translate="store-management.first.header.second-step">2. Store Logo</span> <img class="store-logo hidden-xs" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/picture-icon-logo.png"></div><div class="icon2"><i class="icon-ksc-step"></i></div><div class="step3"><span class="page-external-font custom-step-title-mobile" data-translate="store-management.first.header.third-step">3. Store Point</span> <img class="store-location hidden-xs" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/sales-points-lg.png"></div></div></div><div class="info-item info-footer"><div class="app-container"><div class="row no-margin"><button ui-sref="store-info" class="btn btn-primary btn-steps-mobile" data-translate="store-management.home.buttons.new"><span class="icon-ksc-store" style="font-size: 1.5em" aria-hidden="true">&nbsp;</span><span class="ng-scope">Continuar</span></button></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div class="container-fluid" style="padding-left: 0px; padding-right: 0px"><div ng-include="\'app/inspinia/components/common/topheader.html\'"></div><div class="first-step middle-box text-center loginscreen animated fadeInDown" style="margin-top: 10%"><div ng-show="vm.success"><span class="icon-ok page-external-top-icon" style="color: #9aca5b !important"></span><h2 class="page-external-font" style="font-size: 3.2em" data-translate="activate.messages.success">Your user has been activated.</h2><p class="page-external-font" style="font-size: 1.2em" data-translate="activate.messages.subSuccess"></p><div class="col-xs-12"><button class="btn btn-primary page-external-button" style="padding: 7px 50px" ui-sref="home"><span data-translate="activate.messages.getIn">Login</span></button></div></div><div ng-show="vm.error"><span class="fa fa-times page-external-top-icon primary-color" style="font-size: 12em"></span><h2 class="page-external-font" style="font-size: 3.2em" data-translate="activate.messages.error">Please try again later.</h2><p class="page-external-font" style="font-size: 1.2em" data-translate="activate.messages.subError"></p><div class="col-xs-12"><button class="btn btn-primary page-external-button" style="padding: 7px 50px" ui-sref="main-register"><span data-translate="activate.messages.signUp">Sign Up</span></button></div></div></div></div>');
$templateCache.put('app/account/checkout/already-has-plan.html','<div class="first-step middle-box text-center loginscreen animated fadeInDown" style="margin-top: 5%; width: 80%"><!-- In case of not overdue or not not_paid --><!-- <div class="row" ng-if="![\'ATRASADA\', \'NAO_PAGO\', \'CANCELADA\'].includes(vm.loggedAccount.statusPaymentSignature)">\n        <img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/newAccountFinalUser.png" style="width: 250px; margin-left: 18%;" align="center" />\n        <h2 class="page-external-font" style="font-size: 4em;">\n            <span data-translate="checkout.afterPages.hasPlan.title">Hello,</span>\n            <span>{{vm.loggedAccount.firstName + \'!\'}}</span>\n        </h2>\n        <div class="col-xs-12">\n            <strong>\n                <p class="page-external-font" style="margin: 0 0 0px; font-size: 1.5em;" data-translate="checkout.afterPages.hasPlan.hasPlanMessage1">You already has a plan registered!</p>\n            </strong>\n            <p style="font-size: 1.2em;" class="page-external-font" ng-if="vm.loggedAccount.billetLink" data-translate="checkout.afterPages.hasPlan.hasPlanMessage2">But we couldn\'t identify your payment yet.</p>\n            <p style="font-size: 1.2em;" class="page-external-font" ng-if="!vm.loggedAccount.billetLink" data-translate="checkout.afterPages.hasPlan.hasPlanMessage3">But we couldn\'t identify your payment yet.</p>\n        </div>\n        <div class="col-sm-12" style="padding: 2%" ng-if="vm.loggedAccount.billetLink">\n            <button class="btn btn-primary page-external-button" ng-click="vm.getNewBillet()" style="padding: 5px 45px;" ladda="vm.isGeneratingBillet">\n                <span data-translate="checkout.afterPages.hasPlan.generateNewBillet">Generate New Billet</span>\n            </button>\n        </div>\n        <div class="col-sm-12" style="padding: 2%" ng-if="!vm.loggedAccount.billetLink">\n            <button class="btn btn-primary page-external-button" style="padding: 5px 45px;" ng-click="vm.logout()">\n                <span data-translate="checkout.afterPages.hasPlan.understand">Understood</span>\n            </button>\n        </div>\n    </div> --><!-- In case of overdue --><div class="row" ng-if="[\'ATRASADA\', \'NAO_PAGO\'].includes(vm.loggedAccount.statusPaymentSignature)"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/newAccountFinalUser.png" style="width: 250px; margin-left: 18%" align="center"><h2 class="page-external-font" style="font-size: 4em"><span data-translate="checkout.afterPages.hasPlan.title">Hello,</span> <span>{{vm.loggedAccount.firstName + \'!\'}}</span></h2><div class="col-xs-12"><strong><p class="page-external-font" style="margin: 0 0 0px; font-size: 1.5em" data-translate="checkout.afterPages.hasPlan.overdueMessage"></p></strong><p style="font-size: 1.2em" class="page-external-font" data-translate="checkout.afterPages.hasPlan.overdueSubMessage" translate-value-email="suporte@showkase.com.br"></p></div><div class="col-sm-6" style="padding: 2%"><button class="btn btn-primary page-external-button" style="padding: 5px 45px" ng-click="vm.logout()"><span data-translate="checkout.afterPages.hasPlan.understand">Understood</span></button></div><div class="col-sm-6" style="padding: 2%"><button class="btn btn-primary page-external-button" ng-click="vm.getNewBillet()" style="padding: 5px 45px" ladda="vm.isGeneratingBillet"><span data-translate="checkout.afterPages.hasPlan.generateNewBillet">Generate New Billet</span></button></div></div><!-- In case of canceled or not paid--><div class="row" ng-if="[\'CANCELADA\'].includes(vm.loggedAccount.statusPaymentSignature)"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/newAccountFinalUser.png" style="width: 250px; margin-left: 18%" align="center"><h2 class="page-external-font" style="font-size: 4em"><span data-translate="checkout.afterPages.hasPlan.title">Hello,</span> <span>{{vm.loggedAccount.firstName + \'!\'}}</span></h2><div class="col-xs-12"><strong><p class="page-external-font" style="margin: 0 0 0px; font-size: 1.5em" data-translate="checkout.afterPages.hasPlan.canceledOrNotpaidMessage" translate-value-status="{{ vm.loggedAccount.statusPaymentSignature == \'NAO_PAGO\' ? (\'checkout.afterPages.hasPlan.notPaidMessage\' | translate) : (\'checkout.afterPages.hasPlan.canceledMessage\' | translate) }}"></p></strong><p style="font-size: 1.2em" class="page-external-font" data-translate="checkout.afterPages.hasPlan.canceledOrNotPaidSubMessage" translate-value-email="suporte@showkase.com.br"></p></div><div class="col-sm-12" style="padding: 2%"><button class="btn btn-primary page-external-button" style="padding: 5px 45px" ng-click="vm.logout()"><span data-translate="checkout.afterPages.hasPlan.understand">Understood</span></button></div></div></div>');
$templateCache.put('app/account/checkout/checked.html','<div class="container-fluid" style="padding-left: 0px; padding-right: 0px"><div ng-include="\'app/inspinia/components/common/topheader.html\'"></div><div class="first-step middle-box text-center loginscreen animated fadeInDown" style="margin-top: 10%; width: 80%"><div ng-show="vm.hasSuccess"><span class="fa fa-7x fa-trophy" style="color: rgb(185, 185, 187)!important; font-size: 10em"></span><h2 data-translate="checkout.form.success.congratularionTitle" style="color: #606062; font-size: 4em; font-family: Humanst521 Lt BT"></h2><h3 data-translate="checkout.form.success.congratulationMesage" style="color: #606062; font-size: 1.5em; font-family: Humanst521 Lt BT"></h3><!-- <a class="page-external-font" ng-if="vm.hasSuccess" data-translate="checkout.payment.billet.generateNewBillet" ng-click="vm.openBilletLink()"></a>\n            <a class="page-external-font" ng-if="!vm.hasSuccess" data-translate="checkout.payment.billet.downloadBillet" ng-click="vm.openBilletLink()"></a> --></div><div ng-show="!vm.hasSuccess"><span class="fa fa-times page-external-top-icon primary-color" style="font-size: 12em"></span><h2 class="page-external-font" data-translate="checkout.form.error.notSaved">Please try again later.</h2></div><button type="button" class="btn btn-default" style="margin-top: 2%; padding: 6px 40px" ng-click="vm.logout()"><span>OK!</span></button> <button ng-if="vm.billetLink" type="button" class="btn btn-primary" style="margin-top: 2%; margin-left: 2%; padding: 6px 40px" ng-click="vm.openReceivedBilletLink()"><span>{{ \'checkout.payment.billet.accessBillet\' | translate }}</span></button></div></div>');
$templateCache.put('app/account/checkout/checkout.html','<style>.padding-btn span {\n        padding: 7px 25px;\n        font-weight: 600;\n    }\n\n    #contract_btn .ladda-spinner {\n        padding: 0px;\n    }\n\n    #page-top>div:nth-child(2)>div>div.ibox.float-e-margins.ng-scope>div.wrapper.wrapper-content.animated.fadeInRight.content.container.ng-scope>div.col-lg-12>div>div:nth-child(4)>div:nth-child(2)>div:nth-child(1)>div>div.form-group.col-md-12.ng-scope>div>div>button>span.ladda-spinner {\n        margin-left: -22px;\n        margin-top: -7px;\n    }\n\n    md-autocomplete-wrap {\n        height: 34px !important;\n        box-shadow: none !important;\n        border: 1px solid #e5e6e7;\n        border-radius: 1px;\n        height: 0px;\n    }\n    .md-virtual-repeat-container.md-autocomplete-suggestions-container {\n        width: 250px !important;\n    }\n\n    md-switch.md-checked .md-thumb {\n        background-color: #00ff8b;\n    }\n\n    md-switch.md-checked .md-bar {\n        background-color: rgba(5, 161, 156, 0.541);\n    }\n\n\n    md-switch .md-thumb {\n        background-color: #00ff8b;\n    }\n\n    md-switch .md-bar {\n        background-color: rgba(5, 161, 156, 0.541);\n    }\n\n    md-switch:last-of-type {\n        margin: 0px;\n    }\n\n\tmd-checkbox.md-checked .md-icon {\n\t    background-color: #00ff8b;\n\t}\n\n\t.md-switch-label{\n\t\twhite-space: nowrap;\n\t\tcursor: pointer;\n\t\tline-height: 32px;\n\t}\n\n\t._ngcontent-c16 {\n\t    top: 1rem;\n\t    padding: 4px 16px 1px 16px;\n\t    background-color: #45ce84;\n\t    border-radius: 15px;\n\t    font-size: 14px;\n\t    font-weight: 400;\n\t    line-height: 1.33;\n\t    letter-spacing: normal;\n\t    color: #2F0E7F;\n\t    right: 10px;\n    }</style><div class="row text-center" ng-if="!vm.loggedAccount.hasMoipPlan"><div style="padding: 1%" class="col-lg-12"><h2 data-translate="checkout.plan.contract.title" style="color: #606062; font-size: 3em; font-family: Humanst521 Lt BT"></h2><h3 data-translate="checkout.plan.contract.description" style="color: #606062; font-size: 1.1em; font-family: Humanst521 Lt BT"></h3></div></div><div class="wrapper wrapper-content animated fadeInRight content container" ng-if="vm.isVisibleForm()"><!-- <div class="row" style="margin-bottom: 20px;" ng-if="vm.isVisibleForm()">\n        <div ng-style="{\'background-color\': vm.mainColor}" class="select-plan-period-container">\n            <div  ng-class="{\'select-plan-period-selected\': vm.periodSelected == \'monthly\', \'select-plan-period-unselected\':  vm.periodSelected == \'annually\'}" class="ng-pristine ng-untouched ng-valid ng-not-empty select-plan-period"  ng-model="vm.periodSelected" ng-click="vm.periodSelected = \'monthly\'">Trimestral</div>\n            <div  ng-class="{\'select-plan-period-selected\': vm.periodSelected == \'annually\', \'select-plan-period-unselected\':  vm.periodSelected == \'monthly\'}" class="ng-pristine ng-untouched ng-valid ng-not-empty select-plan-period"  ng-model="vm.periodSelected" ng-click="vm.periodSelected = \'annually\'">Anual</div>\n        </div>\n    </div> --><div class="row" style="align-items: center; justify-content: center"><!-- [START - AVAILABLE PLANS CARDS]  --><div ng-repeat="plan in vm.gettedPlans" class="col-xs-12 col-sm-6 col-md-4 col-lg-4 card-hover" ng-if="vm.isVisibleForm()"><div ng-if="(vm.periodSelected == \'annually\' && plan.annually) || vm.periodSelected == \'monthly\'" ng-style="{\'background-color\': vm.selectedPlan.code == plan.code ? vm.mainColor : \'white\', \'border-bottom-color\': vm.mainColor,\n            \'color\': vm.selectedPlan.code == plan.code ? \'white\' : \'black\'}" class="payment-card" ng-click="vm.selectPlan(plan, $index)"><div class="checkbox-options row" style="margin-left: 0; margin-right:0"><div class="row"><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"></div><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 text-right collapse in"><span ng-if="(vm.periodSelected == \'annually\' && plan.showBestSellerAnnually) || (vm.periodSelected == \'monthly\' && plan.showBestSeller)" class="badge-price ng-star-inserted _ngcontent-c16">Mais Vendido</span></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><md-checkbox style="font-size: 20px;   font-weight: 900" ng-checked="vm.selectedPlan.code == plan.code" ng-click="vm.selectPlan(plan)" md-no-ink class="dynamic-color-checkbox"><span>{{plan.name}} {{ ( vm.periodSelected === \'annually\' ? "Anual": "Trimestral")}}</span></md-checkbox></div></div></div><div style="height: 40px" class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">{{plan.description}}</div></div><div class="clearfix"></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><br><a ng-style="{\'color\': vm.selectedPlan.code == plan.code ? \'#45ce84\' : vm.mainColor}" ng-click="vm.saibaMais()" id="saibaMais">Compare os planos</a><div class="clearfix"></div></div><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8"><div class="row"><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 nopadding" style="text-align: left"><span style="text-transform: uppercase; display: block; font-size: 9px">por</span> <span style="text-transform: uppercase; display: block; font-size: 9px">apenas</span> <span style="font-size: 25px; text-transform:uppercase">R$</span></div><div class="display-horizontally-inline col-xs-6 col-sm-6 col-md-6 col-lg-6 nopadding" style="text-align: right; justify-content: unset"><span ng-if="vm.periodSelected === \'annually\'" style="font-size: 25px; line-height: 72px; text-align: right; margin-top: 8px" ng-init="vm.initSelectPlan()">{{ vm.getFormattedPrice(plan.amountAnnually) }}</span> <span style="text-transform: uppercase; display: block; font-size: 11px;margin-top: 16px">/{{ ( vm.periodSelected === \'annually\' ? "ano": "tri")}}</span><!-- <span ng-if="vm.periodSelected === \'annually\'"   ng-style="{ \'font-size\' : (plan.amountAnnually.toString().length - 2 <= 2) ? \'70px\' : (plan.amountAnnually.toString().length - 2 == 3) ? \'50px\' : \'40px\' }" style="font-size: 50px; line-height: 72px; text-align: right; " ng-init="vm.initSelectPlan()">{{plan.free ? "0" : plan.amountAnnually.toString().substring(0, plan.amountAnnually.toString().length - 2) }}</span> --> <span ng-if="vm.periodSelected === \'monthly\'" ng-style="{ \'font-size\' : (plan.amountMonth.toString().length - 2 <= 2) ? \'70px\' : (plan.amountMonth.toString().length - 2 == 3) ? \'50px\' : \'40px\' }" style="font-size: 50px; line-height: 72px; text-align: right" ng-init="vm.initSelectPlan()">{{plan.free ? "0" : plan.amountMonth.toString().substring(0, plan.amountMonth.toString().length - 2) }}</span></div><!-- <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 nopadding" style="text-align: right;">\n\t\t\t\t\t\t\t\t<span style="text-transform: uppercase; display: block; font-size: 20px;">{{ plan.free ? "00" : plan.amountMonth.toString().substring(plan.amountMonth.toString().length - 2, plan.amountMonth.toString().length) }}</span>\n\t\t\t\t\t\t\t\t<span style="text-transform: uppercase; display: block; font-size: 11px;">/{{ ( vm.periodSelected === \'annually\' ?  "ano":  "tri")}}</span>\n\t\t\t\t\t\t\t</div> --></div></div></div><div ng-show="plan.isAnnually" class="row text-right nopadding">Economize mais de 20% no plano anual</div></div></div><!-- [END - AVAILABLE PLANS CARDS]  --></div><!-- form !--><div class="col-lg-12 nopadding" id="formContractDetails" ng-if="vm.isVisibleForm()"><div class="container-fluid" style="background-color: white; padding: 7px 20px 7px 20px"><div ng-if="!vm.selectedPlan.free" class="row"><div class="col-lg-6"><h2 data-translate="checkout.plan.contract.detail" style="color: #606062; font-size: 2em; font-family: Humanst521 Lt BT"></h2><!-- <h3 data-translate="checkout.plan.contract.detailsPersonal"\n                        style="color: #606062; font-size: 0.9em; font-family: Humanst521 Lt BT;">Personal data</h3> --></div><!-- <div class="col-lg-6">\n                    <img class="pull-right" src="../../../content/images/selo-moip-p.png"\n                        style="height: auto; width: 45%; padding: 20px;">\n                </div> --></div><!-- [START - ADDRESS FROM]  --><!-- <form id="form-plan-free" ng-if="!vm.selectedPlan.free" name="vm.formAddress" style="padding: 1% 0 0 0;">\n                <div class="row">\n                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 form-group">\n                        <label for="fullName" class="required" data-translate="checkout.payment.personal.fullName">Full Name</label>\n                        <input id="fullName" name="fullName" type="text" class="form-control"\n                            ng-model="vm.checkout.fullname" required />\n                        <div class="help-block-div"\n                            ng-show="vm.formAddress.fullName.$invalid && (vm.formAddress.fullName.$touched || vm.formAddress.fullName.$dirty)">\n                            <p class="help-block form-invalid-field" ng-show="vm.formAddress.fullName.$error.required"\n                                data-translate="entity.validation.required">\n                                This field is required.\n                            </p>\n                        </div>\n                    </div>\n                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group">\n                        <label for="dateOfBirth" class="required" style="text-transform: capitalize;"\n                            data-translate="checkout.payment.personal.dateOfBirth">Date of birth</label>\n                            <div class=\'input-group date\' id=\'dateOfBirth\'>\n                                <input type="text" name="dateOfBirth" class="form-control inputDate external-control" autocomplete="off" ng-model="vm.checkout.dateOfBirth" ui-mask-placeholder ui-mask="{{vm.maskLocale}}" placeholder="{{\'global.form.dateOfBirth\' | translate}}">\n                                <span class="input-group-addon">\n                                    <span class="glyphicon glyphicon-calendar"></span>\n                                </span>\n                            </div>\n                        <div class="help-block-div"\n                            ng-show="vm.formAddress.dateOfBirth.$invalid  && (vm.formAddress.dateOfBirth.$touched || vm.formAddress.dateOfBirth.$dirty)">\n                            <p class="help-block form-invalid-field"\n                                ng-show="vm.formAddress.dateOfBirth.$error.dateOfBirth"\n                                data-translate="entity.validation.dateOfBirth">\n                                Date invalid.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 form-group">\n                        <label for="cpf" class="required" data-translate="checkout.payment.personal.cpf">CPF</label>\n                        <input id="cpf" name="cpf" ng-cpf type="text" ui-mask="999.999.999-99" class="form-control"\n                            ng-model="vm.checkout.cpf" ng-maxlength=14 required />\n                        <div class="help-block-div"\n                            ng-show="vm.formAddress.cpf.$invalid && (vm.formAddress.cpf.$touched || vm.formAddress.cpf.$dirty)">\n                            <p class="help-block form-invalid-field"\n                                ng-show="vm.formAddress.cpf.$invalid && !vm.formAddress.cpf.$error.required"\n                                data-translate="entity.validation.cpf">\n                                This field CPF is invalid.\n                            </p>\n                            <p class="help-block form-invalid-field" ng-show="vm.formAddress.cpf.$error.required"\n                                data-translate="entity.validation.required">\n                                This field is required.\n                            </p>\n                            <p class="help-block form-invalid-field" ng-show="vm.formAddress.cpf.$error.maxlength"\n                                data-translate="entity.validation.maxlength" translate-value-max="11">\n                                This field cannot be longer than 11 characters.\n                            </p>\n                        </div>\n                    </div>\n                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group">\n                        <label for="phoneNumber" class="required"\n                            data-translate="checkout.payment.personal.phoneNumber">Phone Number</label>\n                        <input type="tel" name="phone" id="phone"\n                            class="form-control page-external-input-2 external-control" ng-model="vm.checkout.telNumber"\n                            required ui-mask="+55 (99) 99999-9999" />\n                        <div class="help-block-div"\n                            ng-show="vm.formAddress.phoneNumber.$invalid  && (vm.formAddress.phoneNumber.$touched || vm.formAddress.phoneNumber.$dirty)">\n                            <p class="help-block form-invalid-field"\n                                ng-show="vm.formAddress.phoneNumber.$error.required"\n                                data-translate="entity.validation.required">\n                                This field is required.\n                            </p>\n                            <p class="help-block form-invalid-field"\n                                ng-show="vm.formAddress.phoneNumber.$error.phoneNumber"\n                                data-translate="entity.validation.phoneNumber">\n                                Number invalid.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n                <div ng-if="vm.selectedPlan.code !== \'9999999999\'" class="row">\n                    <div class="col-lg-6" style="margin-bottom: 11px;">\n                        <h3 data-translate="checkout.plan.contract.detailsDescription"\n                            style="color: #606062; font-size: 0.9em; font-family: Humanst521 Lt BT; margin-bottom: 11px;"></h3>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 form-group">\n                        <label for="zipcode" class="required" data-translate="checkout.payment.address.zipcode">Zip\n                            Code</label>\n                        <input id="zipcode" name="zipcode" type="text" class="form-control"\n                            ng-model="vm.checkout.zipcode" ng-change="vm.checkCEP()" required>\n                        <div class="help-block-div"\n                            ng-show="vm.formAddress.zipcode.$invalid && (vm.formAddress.zipcode.$touched || vm.formAddress.zipcode.$dirty)">\n                            <p class="help-block form-invalid-field" ng-show="vm.formAddress.zipcode.$error.required"\n                                data-translate="entity.validation.required">\n                                This field is required.\n                            </p>\n                        </div>\n                    </div>\n                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 form-group">\n                        <label for="country" class="required"\n                            data-translate="checkout.payment.address.country">Country:</label>\n                        <select class="form-control" id="country" name="country" ng-model="vm.checkout.country">\n                            <option value="BRA" selected="selected"> Brasil </option>\n                        </select>\n                        <div class="help-block-div"\n                            ng-show="vm.formAddress.country.$invalid && vm.formAddress.country.$touched && vm.formAddress.country.$dirty">\n                            <p class="help-block form-invalid-field" ng-show="vm.formAddress.country.$error.required"\n                                data-translate="entity.validation.required">\n                                This field is required.\n                            </p>\n                        </div>\n                    </div>\n                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 form-group">\n                        <label for="state" class="required"\n                            data-translate="checkout.payment.address.state">State</label>\n                        <select id="state" class="form-control" name="state" ng-model="vm.checkout.state"\n                            ng-if="vm.states && vm.states.length > 0" required>\n                            <option ng-repeat="state in vm.states" value="{{state.key}}">{{state.value}}</option>\n                        </select>\n                        <input type="text" class="form-control" name="state" ng-model="vm.outsideBrazilState"\n                            ng-if="vm.checkout.country != \'BRA\' && vm.checkout.country != \'\'" ng-maxlength=30\n                            required />\n                        <div class="help-block-div"\n                            ng-show="vm.formAddress.state.$invalid && vm.formAddress.state.$touched && vm.formAddress.state.$dirty">\n                            <p class="help-block form-invalid-field" ng-show="vm.formAddress.state.$error.required"\n                                data-translate="entity.validation.required">\n                                This field is required.\n                            </p>\n                        </div>\n                    </div>\n                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 form-group">\n                        <label for="city" class="required" data-translate="checkout.payment.address.city">City</label>\n                        <input id="city" name="city" type="text" class="form-control" ng-model="vm.checkout.city"\n                            required />\n                        <div class="help-block-div"\n                            ng-show="vm.formAddress.city.$invalid && vm.formAddress.city.$touched">\n                            <p class="help-block form-invalid-field" ng-show="vm.formAddress.city.$error.required"\n                                data-translate="entity.validation.required">\n                                This field is required.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n\n                <div class="row">\n                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 form-group">\n                        <label for="street" class="required"\n                            data-translate="checkout.payment.address.street">Street</label>\n                        <input id="street" name="street" type="text" class="form-control" ng-model="vm.checkout.street"\n                            required />\n                        <div class="help-block-div"\n                            ng-show="vm.formAddress.street.$invalid && (vm.formAddress.street.$touched || vm.formAddress.street.$dirty)">\n                            <p class="help-block form-invalid-field" ng-show="vm.formAddress.street.$error.required"\n                                data-translate="entity.validation.required">\n                                This field is required.\n                            </p>\n                        </div>\n                    </div>\n                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 form-group">\n                        <label for="neighborhood" class="required"\n                            data-translate="checkout.payment.address.district">District</label>\n                        <input id="neighborhood" name="neighborhood" type="text" class="form-control"\n                            ng-model="vm.checkout.district" required />\n                        <div\n                            ng-show="vm.formAddress.neighborhood.$invalid && (vm.formAddress.neighborhood.$touched || vm.formAddress.neighborhood.$dirty)">\n                            <p class="help-block form-invalid-field"\n                                ng-show="vm.formAddress.neighborhood.$error.required"\n                                data-translate="entity.validation.required">\n                                This field is required.\n                            </p>\n                        </div>\n                    </div>\n                    <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 form-group">\n                        <label for="streetNumber" data-translate="checkout.payment.address.streetNumber">Street\n                            Number</label>\n                        <input id="streetNumber" name="streetNumber" type="text" class="form-control"\n                            ng-model="vm.checkout.streetNumber" maxlength="20"/>\n                        <div\n                            ng-show="vm.formAddress.streetNumber.$invalid && (vm.formAddress.streetNumber.$touched || vm.formAddress.streetNumber.$dirty)">\n                            <p class="help-block form-invalid-field"\n                                ng-show="vm.formAddress.streetNumber.$error.maxlength"\n                                data-translate="entity.validation.maxlength" translate-value-max="12">\n                                This field cannot be longer than 12 characters.\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </form> --><!-- [END - ADDRESS FROM]  --><!-- <div class="col-lg-12"  style="padding: 0;" ng-if="!vm.selectedPlan.free">\n                <h2 data-translate="checkout.plan.contract.paymentWayTitle"\n                    style="color: #606062; font-size: 2em; font-family: Humanst521 Lt BT;"></h2>\n                <h3 data-translate="checkout.plan.contract.paymentWayTitleDescription"\n                    style="color: #606062; font-size: 1em; font-family: Humanst521 Lt BT;"></h3>\n            </div> --><div ng-init="vm.selectedPlan.paymentMethod == \'CREDIT_CARD\'; vm.checkedCreditCard = true; vm.selectCreditCardAsPaymentWay(); " class="col-lg-12" style="padding: 1% 0 0 0" ng-if="!vm.selectedPlan.free"><!-- <div class="col-lg-12 col-sm-12 col-md-6 col-xs-12" style="padding: 0;">\n                    <div id="credit_card_div" class="col-lg-6 col-sm-6 col-md-6 col-xs-12"\n                        style="border:1px solid #606062; padding-right: 5px; margin: 0 0px 10px 0;"\n                        ng-if="vm.selectedPlan.paymentMethod == \'CREDIT_CARD\' || vm.selectedPlan.paymentMethod == \'ALL\'">\n                        <div class="checkbox">\n                            <label>\n                                <input type="checkbox"\n                                    class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-empty"\n                                    ng-click="vm.selectCreditCardAsPaymentWay()" aria-invalid="false"\n                                    ng-model="vm.checkedCreditCard">\n                                <span class="checkbox-material">\n                                    <span class="check">\n                                    </span>\n                                </span>\n                                <span id="credit_card_span" data-translate="checkout.plan.payments-way.creditCard"\n                                    class="ng-scope">Cart\xE3o de Cr\xE9dito</span>\n                            </label>\n                        </div>\n                    </div>\n\n                    <div id="boleto_div" class="col-lg-6 col-sm-6 col-md-6 col-xs-12"\n                    style="border:1px solid #606062; padding-left: 5px; margin: 0 0px 10px 0;">\n                        <div class="checkbox">\n                            <label>\n                                <input type="checkbox"\n                                    class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-empty"\n                                    ng-click="vm.selectBoletoAsPaymentWay()" aria-invalid="false"\n                                    ng-model="vm.checkedBoleto">\n                                <span class="checkbox-material">\n                                    <span class="check">\n                                    </span>\n                                </span>\n                                <span id="boleto_span" data-translate="checkout.plan.payments-way.billet"\n                                    class="ng-scope">Boleto</span>\n                            </label>\n                        </div>\n                    </div>\n\n                    <div class="col-lg-11 col-sm-12 col-md-12 col-xs-12" style="border: 1px solid #2F0E7F;"\n                        ng-show="vm.checkedBoleto" style="padding: 50px;">\n                        <i class="fa fa-exclamation-triangle fa-2x" style="color:orange; margin-top: 5px;"></i>\n                        <small data-translate="checkout.plan.instructions.title"\n                            style="font-size: 1.5em; margin-left: 3px;">\n                            <strong>IMPORTANTE:</strong>\n                        </small>\n                        <ul>\n                            <li>\n                                <p data-translate="checkout.plan.instructions.popUpWarning">Se voc\xEA tem um bloqueador de\n                                    pop-up \xE9 preciso desativ\xE1-lo antes de finalizar a compra.</p>\n                            </li>\n                            <li>\n                                <p data-translate="checkout.plan.instructions.print">Voc\xEA pode imprimir o boleto e pagar\n                                    no banco, ou ainda pagar pela internet utilizando o c\xF3digo de barras.</p>\n                            </li>\n                            <li>\n                                <p data-translate="checkout.plan.instructions.validate">O boleto tem validade de 4 dias\n                                    e, se n\xE3o for pago, at\xE9 a data de vencimento, o pedido ser\xE1 cancelado.</p>\n                            </li>\n                            <li>\n                                <p data-translate="checkout.plan.instructions.overDueWarning">Seu pedido pode levar at\xE9\n                                    3 dias para ser processado ap\xF3s a confirma\xE7\xE3o de pagamento.</p>\n                            </li>\n                            <li>\n                                <p data-translate="checkout.plan.instructions.mail">N\xE3o \xE9 poss\xEDvel fazer dep\xF3sito ou\n                                    transfer\xEAncia entre contas por meio do boleto, e o boleto n\xE3o pode ser enviado pelo\n                                    correio.</p>\n                            </li>\n                        </ul>\n                    </div>\n\n                    <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12" ng-show="vm.checkedCreditCard"\n                        style="padding: 0;">\n                        <form role="form" id="paymentForm" name="vm.paymentForm">\n                            <div class="row">\n                                <div class="col-xs-12">\n                                    <h3 data-translate="checkout.payment.card.subjectTitle">Card Data</h3>\n                                    <div class="form-group">\n                                        <label data-translate="checkout.payment.card.cardNumber" class="required">CARD\n                                            NUMBER</label>\n                                        <div class="input-group">\n                                            <input numbers-only ng-model="vm.checkout.cardNumber"\n                                                ng-change="vm.verifyCardNumber()" class="form-control" name="cardnumber"\n                                                placeholder="{{ \'checkout.payment.card.placeHolderNumberCard\' | translate }}"\n                                                required />\n                                            <span class="input-group-addon">\n                                                <i class="fa fa-credit-card"\n                                                    ng-if="!vm.brandCard || vm.cardsWithoutBrand.includes(vm.brandCard)"></i>\n                                                <i class="fa fa-cc-visa" ng-if="vm.brandCard == \'VISA\'"></i>\n                                                <i class="fa fa-cc-mastercard" ng-if="vm.brandCard == \'MASTERCARD\'"></i>\n                                                <i class="fa fa-cc-amex" ng-if="vm.brandCard == \'AMEX\'"></i>\n                                                <i class="fa fa-cc-diners-club" ng-if="vm.brandCard == \'DINERS\'"></i>\n                                            </span>\n                                        </div>\n                                        <div\n                                            ng-show="(vm.paymentForm.cardnumber.$invalid || vm.invalidCardNumber)  && (vm.paymentForm.cardnumber.$touched || vm.paymentForm.cardnumber.$dirty)">\n                                            <p class="help-block form-invalid-field"\n                                                ng-show="vm.paymentForm.cardnumber.$error.required"\n                                                data-translate="entity.validation.required">\n                                                This field is required\n                                            </p>\n                                            <p class="help-block form-invalid-field"\n                                                ng-show="vm.invalidCardNumber && vm.checkout.cardNumber"\n                                                data-translate="checkout.payment.card.invalidCardNumber">\n                                                Invalid Card Number\n                                            </p>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">\n                                    <div class="form-group">\n                                        <label data-translate="checkout.payment.card.expirationDate"\n                                            class="required">EXPIRATION DATE</label>\n                                        <input type="text" ng-change="vm.verifyExpirationDate()"\n                                            ng-model="vm.expirationDate" class="form-control" name="expirationdDate"\n                                            ui-mask="99/99" required />\n                                        <div\n                                            ng-show="(vm.paymentForm.expirationdDate.$invalid || vm.invalidCardNumber)  && (vm.paymentForm.expirationdDate.$touched || vm.paymentForm.expirationdDate.$dirty)">\n                                            <p class="help-block form-invalid-field"\n                                                ng-show="vm.paymentForm.expirationdDate.$error.required"\n                                                data-translate="entity.validation.required">\n                                                This field is required\n                                            </p>\n                                            <p class="help-block form-invalid-field"\n                                                ng-show="vm.invalidExpirationDate && vm.expirationDate"\n                                                data-translate="checkout.payment.card.invalidExpirationDate">\n                                                Invalid Expiration Date\n                                            </p>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8">\n                                    <div class="form-group">\n                                        <label data-translate="checkout.payment.card.nameAtTheCard"\n                                            class="required">NAME OF CARD</label>\n                                        <input type="text" class="form-control" name="holderName"\n                                            ng-model="vm.checkout.holderName"\n                                            placeholder="{{ \'checkout.payment.card.nameAtTheCard\' | translate }}"\n                                            required />\n                                        <div\n                                            ng-show="(vm.paymentForm.holderName.$invalid || vm.invalidCardNumber)  && (vm.paymentForm.holderName.$touched || vm.paymentForm.holderName.$dirty)">\n                                            <p class="help-block form-invalid-field"\n                                                ng-show="vm.paymentForm.holderName.$error.required"\n                                                data-translate="entity.validation.required">\n                                                This field is required\n                                            </p>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </form>\n                        <img src="../../../content/images/card-list-p.jpg" style="height: auto; width: 30%">\n                    </div>\n                </div> --><div class="col-lg-12 col-sm-12 col-md-6 col-xs-12" style="padding: 0"><!-- <div ng-if="vm.isPlanoPro">\n                        <div class="col-md-12" style="border-style: solid; border-width: 1px;">\n                            <div class="checkbox">\n                                <label>\n                                    <input type="checkbox"  ng-click="vm.checkout.coupon = null; vm.checkout.couponCode = \'\'"\n                                        class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-empty"\n                                        aria-invalid="false" ng-model="vm.checkout.withCupom">\n                                    <span class="checkbox-material">\n                                        <span class="check">\n                                        </span>\n                                    </span>\n                                    <span id="boleto_span" data-translate="checkout.plan.coupon.title" class="ng-scope">Possui cupom?</span>\n                                </label>\n                            </div>\n                            <div ng-if="vm.checkout.withCupom" class="form-group col-md-12">\n                                <div class="row">\n                                    <div class="col-md-12">\n                                        <label class="required" data-translate="checkout.plan.coupon.input.title">Digite o c\xF3digo do seu cupom</label>\n                                        <input type="text" class="form-control" name=""\n                                            ng-model="vm.checkout.couponCode"\n                                            ng-change="vm.checkout.couponCode = (vm.checkout.couponCode | uppercase)" />\n\n                                        <button ladda="vm.isValidatingCoupon" data-style="zoom-in"\n                                            ng-disabled="!vm.checkout.couponCode"  data-translate="checkout.plan.coupon.input.button"\n                                            class="btn btn-primary pull-right padding-btn no-animate"\n                                            ng-click="vm.validateCoupon()" style="margin-top: 20px;">Aplicar</button>\n                                    </div>\n\n                                </div>\n                            </div>\n                        </div>\n                    </div> --><div class="col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding-left no-padding-right" style="padding-top: 5%"><div class="col-lg-5 col-sm-5 col-md-5 col-xs-5 no-padding-left"><h3 data-translate="checkout.payment.resume">Summary</h3><span style="font-size: 1.5em"><strong>{{ vm.selectedPlan.name }} {{vm.periodSelected == \'annually\'? "checkout.plan.billingCycles.year" : "checkout.plan.billingCycles.month" | translate}}</strong></span><br><p class="m-t">{{ vm.selectedPlan.description }}</p></div><div class="col-lg-7 col-sm-7 col-md-7 col-xs-7"><div class="row"><span ng-style="(vm.checkout.coupon && vm.checkout.coupon.status === \'ACTIVE\' && vm.isPlanoPro) && {\'font-size\': \'0.8em\', \'color\': \'gray\' } || (!vm.checkout.coupon) && {\'color\': \'#2F0E7F\', \'font-size\': \'1.2em\' } " class="text-navy pull-right" style="font-size: 1.2em">R$ <strong ng-style="(vm.checkout.coupon && vm.checkout.coupon.status === \'ACTIVE\' && vm.isPlanoPro) && {\'text-decoration\':  \'line-through\', \'font-size\': \'2.5em\', \'color\': \'gray\' } || (!vm.checkout.coupon) && {\'color\': \'#2F0E7F\', \'font-size\': \'2.5em\' }" style="font-size: 2.5em">{{ vm.getFormattedPrice( vm.getCurrentPrice() ) }} </strong><strong ng-style="(vm.checkout.coupon && vm.checkout.coupon.status === \'ACTIVE\') && {\'font-size\': \'0.8em\', \'color\': \'gray\' } || (!vm.checkout.coupon) && {\'color\': \'#2F0E7F\', \'font-size\': \'1.5em\' } " style="font-size: 1.5em">/ {{ ( vm.periodSelected == \'annually\' ? "checkout.plan.billingCycles.year" : "checkout.plan.billingCycles.month" ) | translate }}</strong></span></div><div class="row"><span ng-if="vm.checkout.coupon && vm.checkout.coupon.status === \'ACTIVE\'" class="text-navy pull-right" style="font-size: 1.2em">Por R$ <strong style="font-size: 2.5em">{{ vm.getWithCouponPrice(vm.getCurrentPrice()) }} </strong><strong style="font-size: 1.5em">/ {{ ( vm.periodSelected == \'annually\' ? "checkout.plan.billingCycles.year" : "checkout.plan.billingCycles.month" ) | translate }}</strong></span></div></div></div></div></div><div class="row" ng-if="!vm.selectedPlan.free"><!-- <div class="col-lg-6 col-sm-6 col-md-6 col-xs-6">\n                    <img src="../../../content/images/selo-moip-p.png"\n                        style="height: auto; width: 45%; padding-top: 20px;">\n                </div> --><div class="col-xs-12" ng-if="vm.selectedPlan.code !== \'9999999999\' && vm.visibleAlert"><div id="div-alert" class="alert alert-danger alert-dismissable"><button aria-hidden="true" data-dismiss="alert" class="close" type="button">\xD7</button> <span>{{ vm.messageAlert }}</span></div></div><div class="col-xs-12"><div class="pull-right m-l-sm"><a id="contract_btn" type="button" ladda="vm.isSaving" data-style="zoom-in" ng-disabled="vm.disableButton()" class="btn btn-primary pull-right padding-btn" ng-href="{{vm.paymentUrl}}" target="_blank" data-translate="checkout.plan.payments-way.payNow" style="margin-top: 20px">Pay now</a></div><!-- <div class="pull-right">\n\t                    <button ladda="vm.isSaving" data-style="zoom-in"\n\t                        class="btn btn-primary pull-right padding-btn" ng-click="vm.goHome()"\n\t                        data-translate="entity.action.back" style="margin-top: 20px; background-color: #7b63b7; border-color:#7b63b7">Back</button>\n\t                </div> --></div></div><div class="row" ng-if="vm.selectedPlan.free" style="padding: 0"><div class="col-lg-12 col-sm-12 col-md-12 col-xs-12 no-padding-left no-padding-right" style="padding-top: 5%"><div class="col-lg-6 col-sm-6 col-md-6 col-xs-6 no-padding-left"><h3 data-translate="checkout.payment.resume">Summary</h3><span style="font-size: 1.5em"><strong>{{ vm.selectedPlan.name }}</strong></span><br><p class="m-t">{{ vm.selectedPlan.description }}</p></div><div class="col-lg-6 col-sm-6 col-md-6 col-xs-6"><div class="row"><span ng-style="(vm.checkout.coupon && vm.checkout.coupon.status === \'ACTIVE\' && vm.isPlanoPro) && {\'font-size\': \'0.8em\', \'color\': \'gray\' } || (!vm.checkout.coupon) && {\'color\': \'#2F0E7F\', \'font-size\': \'1.2em\' } " class="text-navy pull-right" style="font-size: 1.2em">R$ <strong ng-style="(vm.checkout.coupon && vm.checkout.coupon.status === \'ACTIVE\' && vm.isPlanoPro) && {\'text-decoration\':  \'line-through\', \'font-size\': \'2.5em\', \'color\': \'gray\' } || (!vm.checkout.coupon) && {\'color\': \'#2F0E7F\', \'font-size\': \'2.5em\' }" style="font-size: 2.5em">{{ vm.getFormattedPrice(vm.getCurrentPrice()) }} </strong><strong ng-style="(vm.checkout.coupon && vm.checkout.coupon.status === \'ACTIVE\') && {\'font-size\': \'0.8em\', \'color\': \'gray\' } || (!vm.checkout.coupon) && {\'color\': \'#2F0E7F\', \'font-size\': \'1.5em\' } " style="font-size: 1.5em">/ {{ ( vm.selectedPlan.interval.unit == \'YEAR\' ? "checkout.plan.billingCycles.year" : "checkout.plan.billingCycles.month" ) | translate }}</strong></span></div><div class="row"><span ng-if="vm.checkout.coupon && vm.checkout.coupon.status === \'ACTIVE\'" class="text-navy pull-right" style="font-size: 1.2em">Por R$ <strong style="font-size: 2.5em">{{ vm.getWithCouponPrice(vm.getCurrentPrice()) }} </strong><strong style="font-size: 1.5em">/ {{ ( vm.selectedPlan.interval.unit == \'YEAR\' ? "checkout.plan.billingCycles.year" : "checkout.plan.billingCycles.month" ) | translate }}</strong></span></div></div></div></div><div class="row" ng-if="vm.selectedPlan.free"><div class="col-lg-6 col-sm-6 col-md-6 col-xs-6"><img src="../../../content/images/selo-moip-p.png" style="height: auto; width: 45%; padding-top: 20px"></div><div class="col-xs-12" ng-if="vm.selectedPlan.code !== \'9999999999\' && vm.visibleAlert"><div id="div-alert" class="alert alert-danger alert-dismissable"><button aria-hidden="true" data-dismiss="alert" class="close" type="button">\xD7</button> <span>{{ vm.messageAlert }}</span></div></div><div class="col-xs-12"><div class="pull-right m-l-sm"><button id="contract_btn" ladda="vm.isSaving" data-style="zoom-in" class="btn btn-primary pull-right padding-btn" ng-click="vm.makePayment()" data-translate="checkout.plan.payments-way.payNow" style="margin-top: 20px">Make a payment!</button></div><!-- <div class="pull-right">\n\t                    <button ladda="vm.isSaving" data-style="zoom-in"\n\t                        class="btn btn-primary pull-right padding-btn" ng-click="vm.goHome()"\n\t                        data-translate="entity.action.back" style="margin-top: 20px; background-color: #7b63b7; border-color:#7b63b7">Back</button>\n\t                </div> --></div></div></div></div></div><div ng-include="\'app/account/checkout/already-has-plan.html\'" ng-if="!vm.isVisibleForm()"></div>');
$templateCache.put('app/account/checkout/plan-modal.html','<style>.modal-header {\n        text-align: center;\n    }\n\n    .modal-body {\n        overflow-y: auto;\n        max-height: 550px;\n        background-color: #f8fafb;\n    }\n\n    .term p {\n        text-align: justify;\n        text-justify: inter-word;\n        font-size: 1.4rem;\n    }\n\n    .btn-footer {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n    }\n\n\n    .modal-header label {\n        margin-top: 10px;\n        font-weight: normal;\n    }\n\n\t.modal-dialog.modal-md{\n\t\twidth: 900px;\n\t}</style><div><div class="modal-header"><h1 class="modal-title">Compare os Planos</h1></div><div class="modal-body"><div class="container-fluid"><div class="term"><table class="table table-theme text-center"><thead><tr><th></th><th style="text-align: center">Starter</th><th style="text-align: center">Pro</th></tr></thead><tbody><tr><td class="text-left">Quantidade ilimitada de produtos, vendas e visitas</td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Integra\xE7\xE3o com log\xEDstica e frete</td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Integra\xE7\xE3o com meios de pagamento</td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Integra\xE7\xE3o com WhatsApp</td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Publica\xE7\xE3o autom\xE1tica de produtos no Google</td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Monitoramento de acessos via Google Analytics e Facebook Pixel</td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Suporte por e-mail</td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Automa\xE7\xE3o de campanhas patrocinadas</td><td><i class="fa fa-times fa-2x"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Gest\xE3o de clientes e CRM</td><td><i class="fa fa-times fa-2x"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Mala Virtual</td><td><i class="fa fa-times fa-2x"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Gestor de Conte\xFAdo</td><td><i class="fa fa-times fa-2x"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Dom\xEDnio pr\xF3prio</td><td><i class="fa fa-times fa-2x"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Automa\xE7\xE3o de posts nas redes sociais</td><td><i class="fa fa-times fa-2x"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Relat\xF3rios Inteligentes</td><td><i class="fa fa-times fa-2x"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Cartazista Digital</td><td><i class="fa fa-times fa-2x"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">App do Lojista</td><td><i class="fa fa-times fa-2x"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Suporte por chat</td><td><i class="fa fa-times fa-2x"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr><tr><td class="text-left">Suporte em hor\xE1rio comercial via WhatsApp ap\xF3s primeiro pagamento</td><td><i class="fa fa-times fa-2x"></i></td><td><i class="fa fa-check fa-2x" style="color: #00CC3F"></i></td></tr></tbody></table></div></div></div><div class="modal-footer" style="display: block"><div class="btn-footer"><button type="button" class="btn btn-primary mr-auto" ng-click="vm.closeModal()"><span data-translate="global.modal-plan.buttons.close">Cancelar</span></button></div></div></div>');
$templateCache.put('app/account/direct-register/direct-register.html','<div class="container-fluid registration-container" style="padding-left: 0px; padding-right: 0px"><div ng-include="\'app/inspinia/components/common/topheader.html\'"></div><div class="first-step middle-box text-center registerscreen animated fadeInDown"><div class="row" style="margin-top: 20%" ng-if="vm.firstStep"><div class="col-xs-12 email-register-content text-direct-register"><span id="icon-createuser" class="icon-createuser-admin icon-ksc-finaluser-createuser" style="color: #A7AAAD; font-size: 12em"></span><h2 class="page-external-font" style="font-size: 2.4em; font-family: \'Roboto\'"><span data-translate="register.direct-register.first-page.subtitle">Enter your e-mail address and press the button to continue.</span></h2><form class="m-t" role="form" name="firstDirectForm" ng-submit="vm.userRegister()"><div class="form-group"><div class="input-group display-horizontally-inline" style="width: 100%"><input class="form-control page-external-input-2 external-control direct-register-input-style" placeholder="{{\'register.direct-register.first-page.field\' | translate}}" ng-model="vm.loginOrMail" required> <button class="btn btn-continue btn-primary page-external-button" ng-disabled="firstDirectForm.$invalid"><span data-translate="register.direct-register.first-page.button">Next</span></button></div></div></form><p class="page-external-font" style="font-size: 1.2em; font-family: \'Roboto\'"><span data-translate="register.direct-register.first-page.title">Already have an Showkase account?</span> <a ui-sref="main-login"><span class="page-external-navy" data-translate="register.direct-register.first-page.login">Login</span></a></p></div></div><div class="row" style="margin-top: 15%" ng-if="!vm.firstStep && vm.userExists"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/newAccountFinalUser.png" style="width: 250px; margin-left: 18%" align="center"><h2 class="page-external-font" style="font-size: 5em"><span data-translate="register.direct-register.second-page.title">Hello</span>, <span id="showkase-account-user-firstname">{{vm.user.firstName + \'!\'}}</span></h2><div class="col-xs-12"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="register.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><p id="showkase-account-title" class="page-external-font" style="margin: 0 0 0px" data-translate="register.direct-register.second-page.subtitle">We noticed that you already have a Showkase account.</p><p id="showkase-account-title-support" class="page-external-font" data-translate="register.direct-register.second-page.info">Enter your password to create your first store.</p><form class="m-t" role="form" name="secondDirectForm" ng-submit="vm.userRegister()"><div class="form-group"><div class="input-group display-horizontally-inline" style="width: 100%"><input type="password" class="form-control page-external-input-2 external-control" placeholder="{{\'register.direct-register.second-page.placeholder\' | translate}}" ng-model="vm.user.password" required> <button class="btn btn-primary page-external-button" ng-disabled="secondDirectForm.$invalid"><span data-translate="register.direct-register.second-page.button">Enter</span></button></div></div></form><a ui-sref="requestReset"><a class="page-external-font" ui-sref="requestReset"><p data-translate="register.messages.forgotPassword">Forgot your password?</p></a></a></div></div><div class="form-group" ng-if="!vm.firstStep && !vm.userExists"><div class="form-group"><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username\' | translate}}" ng-model="vm.user.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="account.login.$dirty && account.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><input type="text" class="form-control" required="" ng-model="vm.user.firstName" placeholder="{{\'global.form.firstName\' | translate}}"><div ng-show="account.firstName.$dirty && account.firstName.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your first name is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your first name cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your first name can only contain lower-case letters and digits.</p></div></div><div class="form-group"><input type="text" class="form-control" required="" ng-model="vm.user.lastName" placeholder="{{\'global.form.lastName\' | translate}}"><div ng-show="account.lastName.$dirty && account.lastName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="register.messages.validate.login.required">Your last name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="register.messages.validate.login.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your last name cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.firstName.$error.pattern" data-translate="register.messages.validate.login.pattern">Your last name can only contain lower-case letters and digits.</p></div></div><div class="form-group"><input type="email" class="form-control" required="" ng-model="vm.user.email" placeholder="{{\'global.form.email\' | translate}}"><div ng-show="account.lastName.$dirty && account.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="register.messages.validate.login.required">Your e-mail is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="register.messages.validate.login.minlength">Your e-mail is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your e-mail cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.lastName.$error.pattern" data-translate="register.messages.validate.login.pattern">Your e-mail can only contain lower-case letters and digits.</p></div></div><div class="form-group"><input type="password" class="form-control" required="" ng-model="vm.user.password" placeholder="{{\'global.form.password\' | translate}}"><div ng-show="account.password.$dirty && account.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="register.messages.validate.login.required">Your e-mail is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="register.messages.validate.login.minlength">Your e-mail is required to be at least 1 character.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your e-mail cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.password.$error.pattern" data-translate="register.messages.validate.login.pattern">Your e-mail can only contain lower-case letters and digits.</p></div></div></div></div>');
$templateCache.put('app/account/main-register/main-register.html','<div class="container-fluid" style="padding-left: 0px; padding-right: 0px"><div ng-include="\'app/inspinia/components/common/topheader.html\'"></div><div class="page-body-external"><div class="container"><div ng-show="vm.success || vm.error" class="row" style="margin-top: 10%"><div class="first-step middle-box text-center loginscreen animated fadeInDown" style="width: 80%"><div ng-show="vm.success"><span class="icon-ok page-external-top-icon" style="color: #9aca5b !important"></span><h2 class="page-external-font" style="font-size: 3.2em" data-translate="register.messages.success.title">Registration saved!</h2><div class="col-xs-12"><button ng-click="vm.loginNewAccount()" class="btn btn-primary page-external-button" style="padding: 7px 50px"><span>OK</span></button></div></div><div ng-show="vm.error"><span class="fa fa-times page-external-top-icon primary-color" style="font-size: 12em"></span><h2 class="page-external-font" style="font-size: 3.2em" data-translate="register.messages.error.fail.title">Registration failed!</h2><p class="page-external-font" style="font-size: 1.2em" data-translate="register.messages.error.fail.subtitle">Please try again later.</p><div class="col-xs-12"><button class="btn btn-primary page-external-button" style="padding: 7px 50px" ui-sref="home"><span>OK</span></button></div></div></div></div><div ng-show="!(vm.success || vm.error)" class="row" style="margin-top: 15px"><div class="col-xs-12 title-main-register"><h1 class="page-external-font" style="color: #606062; font-size: 3em" data-translate="register.title">Create your Showkase Account</h1></div><div class="col-xs-12 subtitle-main-register" style="margin-top: 25px"><div class="hidden-xs col-sm-6"><img class="img-responsive" style="max-width: 80%" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/devices.png"></div><div class="col-xs-12 col-sm-6"><h2 class="page-external-font" style="text-align: center; color: #606062" data-translate="register.main-register.title">One account is all you need</h2><h3 class="page-external-font" style="text-align: center; color: #606062" data-translate="register.main-register.subtitle">An account to manage, sell and collect coupon</h3><form name="vm.form" class="m-t" role="form" novalidate><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><input type="text" name="firstName" class="form-control page-external-input-2 external-control mobile-input-style" required ng-model="vm.account.firstName" ng-maxlength="50" ng-minlength="1" placeholder="{{\'global.form.firstName\' | translate}}"><div class="help-block-div" ng-show="vm.form.firstName.$invalid && vm.form.$submitted"><p class="help-block form-invalid-field" ng-show="vm.form.firstName.$error.required" data-translate="register.messages.validate.firstName.required">Your first name is required.</p><p class="help-block form-invalid-field" ng-show="vm.form.firstName.$error.minlength" data-translate="register.messages.validate.firstName.minlength" translate-value-min="1">Your first name is required to be at least 1 character.</p><p class="help-block form-invalid-field" ng-show="vm.form.firstName.$error.maxlength" data-translate="register.messages.validate.firstName.maxlength" translate-value-max="50">Your first name cannot be longer than 50 characters.</p></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><input type="text" class="form-control page-external-input-2 external-control mobile-input-style" name="lastName" required ng-model="vm.account.lastName" ng-maxlength="50" ng-minlength="1" placeholder="{{\'global.form.lastName\' | translate}}"><div class="help-block-div" ng-show="vm.form.lastName.$invalid && vm.form.$submitted"><p class="help-block form-invalid-field" ng-show="vm.form.lastName.$error.required" data-translate="register.messages.validate.lastName.required">Your last name is required.</p><p class="help-block form-invalid-field" ng-show="vm.form.lastName.$error.minlength" data-translate="register.messages.validate.lastName.minlength" translate-value-min="1">Your last name is required to be at least 1 character.</p><p class="help-block form-invalid-field" ng-show="vm.form.lastName.$error.maxlength" data-translate="register.messages.validate.lastName.maxlength" translate-value-max="50">Your last name cannot be longer than 50 characters.</p></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><input type="email" name="email" class="form-control page-external-input-2 external-control mobile-input-style" required ng-model="vm.account.email" ng-maxlength="100" ng-change="vm.checkEmail()" ng-pattern=\'/^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$/i\' placeholder="{{\'global.form.email\' | translate}}" autocomplete="off"><div class="help-block-div" ng-show="vm.form.email.$invalid && (vm.form.$submitted || vm.form.email.$error.emailAlreadyUsed)"><p class="help-block form-invalid-field" ng-show="vm.form.email.$error.required" data-translate="register.messages.validate.email.required">Your e-mail is required.</p><p class="help-block form-invalid-field" ng-show="vm.form.email.$error.maxlength" data-translate="register.messages.validate.email.maxlength" translate-value-max="50">Your e-mail cannot be longer than 50 characters.</p><p class="help-block form-invalid-field" ng-show="vm.form.email.$error.pattern" data-translate="global.messages.validate.email.invalid">Please input a valid mail.</p><p class="help-block form-invalid-field" ng-show="vm.form.email.$error.emailAlreadyUsed" data-translate="register.messages.validate.email.alreadyUsed">This email is already in use.</p></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><input type="tel" name="phone" id="phone" class="form-control page-external-input-2 external-control mobile-input-style" ng-model="vm.account.phone" intl-tel-input required><div class="help-block-div" ng-show="vm.form.phone.$invalid && vm.form.$submitted"><p class="help-block form-invalid-field" ng-show="vm.form.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.form.phone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><input name="password" type="password" class="form-control page-external-input-2 external-control mobile-input-style" required ng-model="vm.account.password" ng-minlength="5" ng-maxlength="50" placeholder="{{\n                                      \'global.form.password\' | translate}}" autocomplete="off"><div class="help-block-div" ng-show="vm.form.password.$invalid && vm.form.$submitted"><p class="help-block form-invalid-field" ng-show="vm.form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block form-invalid-field" ng-show="vm.form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 5 characters.</p><p class="help-block form-invalid-field" ng-show="vm.form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><input type="password" type="password" name="confirmPassword" class="form-control page-external-input-2 external-control mobile-input-style" required ng-model="vm.account.confirmPassword" ng-minlength="5" ng-maxlength="50" placeholder="{{\n                                      \'global.form.confirmPassword\' | translate}}" autocomplete="off" ng-change="vm.checkPasswords()"><div class="help-block-div" ng-show="vm.form.confirmPassword.$invalid && vm.form.$submitted"><p class="help-block form-invalid-field" ng-show="vm.form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block form-invalid-field" ng-show="vm.form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 5 characters.</p><p class="help-block form-invalid-field" ng-show="vm.form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p><p class="help-block form-invalid-field" ng-show="vm.form.confirmPassword.$error.notEquals" data-translate="register.messages.validate.confirmPassword.not-equals">A senha da confirma\xE7\xE3o deve ser igual a senha original.</p></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><select id="howDidYouMeetUs" name="howDidYouMeetUs" type="text" class="form-control mobile-select-style" ng-model="vm.account.howDidYouMeetUs" required><option value="" disabled="disabled" selected="selected">{{\'global.form.howDidYouMeetUs\' | translate}}</option><option value="FACEBOOK">Facebook</option><option value="GOOGLE">Google</option><option value="INSTAGRAN">Instagram</option><option value="THROUGH_A_FRIEND">Atrav\xE9s de um amigo</option><option value="FAIR_OR_EVENT">Feira ou Evento</option><option value="BLOG_SHOWKASE">Blog da Showkase</option><option value="COMMERCIAL_PARTNER">Parceiro Comercial</option><option value="GROUP_MALWEE">Grupo Malwee</option><option value="SEBRAE">Sebrae</option><option value="ABF">ABF</option><option value="ARTICLES_NEWSPAPERS_WEBSITES">Artigo ou Not\xEDcia em jornal ou site</option><option value="OTHER">Outro</option></select><div class="help-block-div" ng-show="vm.form.howDidYouMeetUs.$invalid && vm.form.$submitted"><p class="help-block form-invalid-field" ng-show="vm.form.howDidYouMeetUs.$error.required" data-translate="register.messages.validate.howDidYouMeetUs.required">Your confirmation password is required.</p></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><input type="text" class="form-control page-external-input-2 external-control mobile-input-style" name="partnerCode" ng-model="vm.account.partnerCode" placeholder="{{\'global.form.partnerCode\' | translate}}"></div></div><div class="row"><div class="col-xs-12 col-lg-12 col-md-12 col-sm-12"><button ladda="vm.isSaving" ng-disabled="vm.form.$submitted && vm.form.$invalid" ng-click="vm.register()" class="btn btn-primary block full-width m-b btn-main-register" data-translate="register.form.button">Register</button></div></div></form><p style="text-align: center">Quando clicar voc\xEA concorda com os <a href="https://showkase.com.br/terms" target="_blank" rel="noreferrer">Termos de Uso</a> e <a href="https://showkase.com.br/privacy" target="_blank" rel="noreferrer">Pol\xEDtica de privacidade, </a>t\xE1?</p></div></div></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<form name="form" role="form" novalidate ng-submit="vm.changePassword()"><div class="row"><div class="col-md-8 col-md-offset-2 form-group"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2></div><div class="col-md-8 col-md-offset-2 form-group"><label class="control-label required" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div class="help-block-div" ng-show="form.password.$dirty && form.password.$touched && form.password.$invalid && !form.password.$pristine"><p class="help-block form-invalid-field" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block form-invalid-field" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block form-invalid-field" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div></div><div class="col-md-8 col-md-offset-2 form-group"><label class="control-label required" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div class="help-block-div" ng-show="form.confirmPassword.$dirty && form.confirmPassword.$touched && form.confirmPassword.$invalid && !form.confirmPassword.$pristine"><p class="help-block form-invalid-field" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block form-invalid-field" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block form-invalid-field" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div><div class="help-block-div" ng-show="!form.confirmPassword.$pristine && !form.confirmPassword.$invalid && (vm.password != vm.confirmPassword) && form.$submitted"><p class="help-block form-invalid-field" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</p></div></div><div class="col-md-8 col-md-offset-2 form-group"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></div></div></form>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div class="wrapper wrapper-content animated"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h5 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [ <b>{{vm.settingsAccount.login}}</b>]</h5></div><div class="ibox-content-custom"><jhi-alert-error></jhi-alert-error><div class="tabs-container"><ul class="nav nav-tabs"><li ng-class="{\'active\' : vm.tab == 1}"><a ng-click="vm.tab = 1" ng-init="vm.tab = 1"><i class="fa fa-info"></i> <span data-translate="settings.tabs.personalData">Personal Data</span></a></li><li ng-class="{\'active\' : vm.tab == 3}" has-authority="STORE_ADD_REDIRECT_HOSTS"><a ng-click="vm.tab = 3" ng-if="!vm.islocked" has-plan="SHOWKASE,ESCALA,IMPULSO"><i class="fa fa-globe"></i> <span data-translate="settings.tabs.myHosts">My Hosts</span> </a><a ng-click="vm.openModal();" ng-if="vm.islocked"><i class="fa fa-globe"></i> <span data-translate="settings.tabs.myHosts">My Hosts</span> <span ng-if="vm.islocked" style="margin-left: 10px" class="navbar-float-right label label-primary">PRO</span></a></li><li ng-class="{\'active\' : vm.tab == 4}" has-authority="STORE_ADD_ANALYTICS"><a ng-click="vm.tab = 4" ng-if="!vm.islocked"><i class="fa fa-line-chart"></i> <span data-translate="settings.tabs.analytics">Analytics</span> </a><a ng-click="vm.openModal();" ng-if="vm.islocked"><i class="fa fa-line-chart"></i> <span data-translate="settings.tabs.analytics">Analytics</span> <span ng-if="vm.islocked" style="margin-left: 10px" class="navbar-float-right label label-primary">PRO</span></a></li><li ng-class="{\'active\' : vm.tab == 5}"><a ng-click="vm.tab = 5" ng-if="!vm.islocked"><i class="fa fa-bell"></i> <span data-translate="settings.tabs.notifications">Notifications</span> </a><a ng-click="vm.openModal();" ng-if="vm.islocked"><i class="fa fa-bell"></i> <span data-translate="settings.tabs.notifications">Notifications</span> <span ng-if="vm.islocked" style="margin-left: 10px" class="navbar-float-right label label-primary">PRO</span></a></li></ul><div class="tab-content"><div id="tab-1" class="tab-pane active" ng-show="vm.tab == 1"><form name="personalDataForm" role="form" novalidate show-validation><div class="panel-body" ng-include="\'app/account/settings/settings-tabs/personal-data.html\'"></div></form></div><div id="tab-3" class="tab-pane active" ng-show="vm.tab == 3"><form name="urlRedirectDomainDataForm" role="form" novalidate show-validation ng-submit="vm.saveURLRedirectDomainsData()"><div class="panel-body" has-authority="STORE_ADD_REDIRECT_HOSTS" ng-include="\'app/account/settings/settings-tabs/my-hosts.html\'"></div></form></div><div id="tab-4" class="tab-pane active" ng-show="vm.tab == 4"><form name="analyticsDataForm" role="form" novalidate show-validation ng-submit="vm.saveAnalyticsData()"><div class="panel-body" has-authority="STORE_ADD_REDIRECT_HOSTS" ng-include="\'app/account/settings/settings-tabs/analytics.html\'"></div></form></div><div id="tab-5" class="tab-pane active" ng-show="vm.tab == 5"><div class="panel-body" ng-include="\'app/account/settings/settings-tabs/notifications.html\'"></div></div><!-- <li ng-class="{\'active\' : vm.tab == 5}" has-authority="BANK_CONFIG">\n                                <a ng-click="vm.tab = 5">\n                                    <i class="fa fa-file-text"></i>\n                                    <span >Envios</span>\n                                </a>\n                            </li> --></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div class="wrapper wrapper-content"><div class="row"><div class="ibox"><div class="ibox-content"><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/admin/bag/bag-detail.html','<style>md-select-menu md-content {\n        -webkit-overflow-scrolling: fixed !important;\n    }\n\n    .custom-md-input md-input-container {\n        display: inherit;\n        margin: unset;\n    }\n\n    .custom-md-input md-select.md-default-theme .md-select-value,\n    md-select .md-select-value {\n        border-color: rgba(0, 0, 0, 0.12) !important;\n        border: 1px;\n        border-style: solid;\n    }\n\n    .custom-select[multiple] .md-select-value span:first-child {\n        visibility: collapse;\n    }\n\n    .custom-select[multiple] .md-select-value .md-text {\n        display: inline-block !important;\n        visibility: visible;\n        background-color: rgb(224, 224, 224);\n        border-radius: 6px;\n        padding: 3px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected],\n    md-select-menu md-content md-option[selected] {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .md-select-value {\n        padding: 5px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected]:focus,\n    md-select-menu md-content md-option[selected]:focus {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-checkbox-enabled.md-default-theme[selected] .md-icon,\n    .md-checkbox-enabled[selected] .md-icon {\n        background-color: var(--main-color) !important;\n    }\n\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\n    md-select-menu md-content md-option:not([disabled]):focus,\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\n    md-select-menu md-content md-option:not([disabled]):hover {\n        background: none;\n    }\n\n    .highlight {\n        background: #f3f3f4;\n        padding: 5px;\n        display: inline-block;\n        color: var(--main-color-dark);\n        border-radius: 10px;\n        padding-bottom: 2px;\n        padding-top: 2px;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    md-select-menu {\n        margin-top: 50px;\n        width: 150.674px !important;\n        margin-left: 39px;\n    }\n\n    .remove-dropdown {\n        display: none !important;\n    }\n\n    .empty-list md-select-menu {\n        margin-top: 42px;\n        width: 192.674px !important;\n        margin-left: -1px;\n    }\n\n    md-select.md-default-theme[disabled] .md-select-value, md-select[disabled] .md-select-value {\n        background-image: none !important;\n    }\n\n    .btn-filters-modal {\n        color: rgb(136, 136, 136, 1);\n        width: 100%;\n        padding: 6px 0;\n        white-space: normal !important;\n        border: 1px solid rgb(180, 179, 179);\n        background-color: white;\n        border-radius: 18px;\n        font-weight: 500;\n    }\n\n    .filter-label {\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 1.42857;\n    }\n\n    @media only screen and (min-width: 1200px) and (max-width: 1600px) {\n        .numberCircleDiv{\n            width: 12.66% !important;\n        }\n    }\n\n\n    .carousel {\n        position: relative;\n    }\n\n    .carousel__item {\n        height: 300px;\n        font-weight: bold;\n        font-size: 2em;\n        color: #ffffff;\n        display: none;\n    }\n\n    .arrow_buttons {\n        padding: 0 0;\n        bottom: 50%;\n        position: absolute;\n    }\n\n    .carousel_arrows {\n        color: var(--main-color-dark);\n        background: rgba(255, 255, 255, 0.63);\n        border-radius: 50%;\n        padding: 15px;\n    }\n\n    @media screen and (max-width: 850px) {\n        .carousel_arrows {\n            height: 30px !important;\n            width: 30px !important;\n            padding: 10px !important;\n            font-size: 12px !important;\n        }\n    }\n\n    .carousel__item--selected {\n        display: block;\n    }\n\n    .carousel__title {\n        color: var(--main-color-dark);\n        margin-bottom: 60px;\n        border: 1px solid rgba(180, 179, 179, 0.44);\n        background-color: #ffffffa8;\n        border-radius: 18px;\n        padding: 5px 30px;\n        font-size: 16px;\n        font-weight: 500;\n        margin-left: 30%;\n    }\n\n    .carrousel__banner__name {\n        font-weight: 400 !important;\n        margin-right: 30px;\n    }\n\n    .carousel__nav {\n        width: 100%;\n        padding: 30px 0 20px 0;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        text-align: center;\n    }\n\n    .carousel__button {\n        width: 10px;\n        height: 10px;\n        display: inline-block;\n        background: rgba(255, 255, 255, 0.63);\n        border-radius: 50%;\n        margin: 0 5px;\n        cursor: pointer;\n    }\n\n    .carousel__button--selected {\n        background: var(--main-color-dark);\n    }</style><div class="wrapper wrapper-content bag-wrapper-content" ng-init="vm.initShowcase()"><div class="row" style="margin-top:20px"><div class="col-xs-12"><div class="clients-list" style="margin-top: -10px"><ul class="nav nav-tabs"><li class="ksc-tab" ng-class="{\'active\': vm.tab === 1}"><a ng-click="vm.tabClick(1)"><span class="text-truncate">1 - {{ \'bag.steps.first\' | translate }}</span></a></li><li class="ksc-tab" ng-class="{\'active\': vm.tab === 2}"><a ng-click="vm.tabClick(2)"><span class="text-truncate">2 - {{ \'bag.steps.second\' | translate }}</span></a></li></ul><div class="tab-content p-15" style="background-color: white; min-height: 600px; padding: 25px"><div id="aba1" ng-show="vm.tab === 1"><div class="row" style="margin-bottom: 20px"><div class="col-md-12"><h1>{{ \'bag.steps.first\' | translate }}</h1><p>{{ \'bag.form.first-part-subtitle\' | translate }}</p></div></div><form name="vm.flyerForm"><div class="row" ng-if="vm.isLoading"><div class="col-md-6"><!-- name --><div class="row"><div class="form-group col-md-6"><label class="required" for="name" data-translate="bag.title.name">Bag Name</label><input id="name" name="name" ng-model="vm.showcase.name" type="text" class="form-control" ng-maxlength="50" ng-minlength="4" required><div ng-show="vm.flyerForm.name.$invalid && vm.flyerForm.name.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.name.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div><div class="form-group col-md-6"><label for="size" data-translate="flyers.new.form.category">Categories</label><div class="dropdown custom-md-input"><md-input-container ng-if="vm.categories.length" class="category-select"><md-select class="custom-select-value" ng-model="vm.filters.categories" multiple="multiple" disableoptioncentering md-selected-html="vm.getSelectedTextCategory(vm.filters.categories)"><div ng-mouseleave="vm.closeDropDown($event)"><md-option ng-repeat="category in vm.categories" ng-value="category.key">{{category.title}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.categories.length" class="category-select"><md-select class="custom-select-value" ng-model="vm.filters.categories" multiple="multiple" disableoptioncentering disabled="!vm.categories.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div></div><div class="row"><div class="form-group col-md-6"><label for="brand" data-translate="flyers.new.form.brand">Brand</label><div class="dropdown custom-md-input"><md-input-container ng-if="vm.brands.length" class="brand-select"><md-select class="custom-select-value" ng-model="vm.filters.brands" multiple="multiple" md-selected-html="vm.getSelectedTextBrands(vm.filters.brands)"><div ng-mouseleave="vm.closeDropDown($event)"><md-option ng-repeat="brand in vm.brands | orderBy:\'name\'" ng-value="brand.name">{{brand.name}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.brands.length" class="brand-select"><md-select class="custom-select-value" ng-model="vm.filters.brands" multiple="multiple" disabled="!vm.brands.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><div class="form-group col-md-6"><label for="color" data-translate="flyers.new.form.color">Color</label><div class="dropdown custom-md-input"><md-input-container ng-if="vm.colors.length" class="color-select"><md-select class="custom-select-value" ng-model="vm.filters.colors" multiple="multiple" md-selected-html="vm.getSelectedText(vm.filters.colors)"><div ng-mouseleave="vm.closeDropDown($event)"><md-option ng-repeat="color in vm.colors" ng-value="color">{{color}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.colors.length" class="color-select"><md-select class="custom-select-value" ng-model="vm.filters.colors" multiple="multiple" disabled="!vm.colors.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div></div></div><div class="col-md-6"><div class="row"><div class="form-group col-md-6"><label for="dropdownMenuButtonOpt" data-translate="flyers.new.form.configurations.title">Configura\xE7\xF5es</label><div class="dropdown custom-md-input"><md-input-container ng-if="vm.featureds.length" class="featured-select"><md-select class="custom-select-value" ng-model="vm.selectedFeatured" multiple="multiple" ng-change="vm.featuredChange()" md-selected-html="vm.getSelectedText(vm.selectedFeatured)"><div ng-mouseleave="vm.closeDropDown($event)"><md-option ng-repeat="featured in vm.featureds" ng-value="featured">{{ vm.getTranslateFeatureds(featured) | translate}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.featureds.length" class="featured-select"><md-select class="custom-select-value" ng-model="vm.selectedFeatured" multiple="multiple" ng-change="vm.featuredChange()" disabled="!vm.featureds.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><div class="form-group col-md-6"><label for="size">{{ vm.storeCategory == FASHION ? \'flyers.new.form.size.title\' : \'flyers.new.form.variation\' | translate }}</label><div class="dropdown custom-md-input"><md-input-container ng-if="vm.sizes.length" class="size-select"><md-select class="custom-select-value" ng-model="vm.filters.sizes" multiple="multiple" md-selected-html="vm.getSelectedText(vm.filters.sizes)"><div ng-mouseleave="vm.closeDropDown($event)"><md-option ng-repeat="size in vm.sizes" ng-value="size">{{size}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.sizes.length" class="size-select"><md-select class="custom-select-value" ng-model="vm.filters.sizes" multiple="multiple" disabled="!vm.sizes.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div></div><div class="row"><div class="form-group col-md-6"><label for="size" data-translate="flyers.new.form.tags.title">Tags</label><div class="dropdown custom-md-input"><md-input-container ng-if="vm.tags.length" class="tag-select"><md-select class="custom-select-value" ng-model="vm.filters.tags" multiple="multiple" md-selected-html="vm.getSelectedText(vm.filters.tags)"><div ng-mouseleave="vm.closeDropDown($event)"><md-option ng-repeat="tag in vm.tags" ng-value="tag">{{tag}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.tags.length" class="tag-select"><md-select class="custom-select-value" ng-model="vm.filters.tags" multiple="multiple" disabled="!vm.tags.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><div class="form-group col-md-6" ng-if="vm.storeCategory === \'FASHION\'"><label for="gender" data-translate="flyers.new.form.gender.title">Gender</label><div class="dropdown custom-md-input"><md-input-container ng-if="vm.genders.length" class="gender-select"><md-select class="custom-select-value" ng-model="vm.filters.genders" multiple="multiple" md-selected-html="vm.getSelectedTextGender(vm.filters.genders)"><div ng-mouseleave="vm.closeDropDown($event)"><md-option ng-repeat="gender in vm.genders" ng-value="gender">{{vm.getTranslateGenders(gender) | translate}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.genders.length" class="gender-select"><md-select class="custom-select-value" ng-model="vm.filters.genders" multiple="multiple" disabled="!vm.genders.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div></div></div></div><div class="row"><div class="form-group col-md-12"><label>{{ \'bag.form.label.clients\' | translate }}</label><div style="margin-top: 5px; margin-bottom: 10px"><div ng-if="vm.customers.length > 0"><span ng-repeat="customer in vm.customers" class="custom-tag-bag">{{ customer.fullName }} {{ customer.phone ? \' - \' + customer.phone : \'\' }} {{ customer.phoneNumber ? \' - \' + customer.phoneNumber : \'\' }} <i ng-click="vm.removeCustomer(customer)" class="fa fa-times"></i></span></div><div ng-if="vm.customers.length == 0">{{ \'bag.form.messages.empty-clients\' | translate }}</div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><label class="control-label required" for="customer" data-translate="global.form.fullName">Name</label><angucomplete-alt id="customer" placeholder="{{ \'bag.form.placeholder.name-client\' | translate }}" text-no-results="{{ \'bag.form.placeholder.no-results\' | translate }}" text-searching="{{ \'bag.form.placeholder.searching\' | translate }}" pause="400" input-changed="vm.changeCustomer" selected-object="vm.selectedCustomer" remote-url-request-formatter="vm.requestParams" remote-url="/admin/api/customers" title-field="fullName" minlength="2" match-class="highlight" description-field="phone" clear-selected="true" input-class="form-control form-control-small"></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><div class="row container-cellphone"><div class="col-xs-12 col-sm-9 col-md-9 col-lg-9"><label for="phone" class="required">{{ \'bag.form.fields.phone\' | translate}}</label><input type="tel" name="phone" id="phone" class="form-control" ng-model="vm.customer.phone" ng-disabled="!vm.customer.fullName" intl-tel-input required></div><div class="col-xs-12 col-sm-3 col-md-3 col-lg-3"><button ng-click="vm.createCustomer()" ng-disabled="vm.customer.phone == null || vm.customer.fullName == null" class="btn btn-primary btn-add-phone text-truncate"><i style="margin-right: 10px" class="fa fa-plus"></i> {{ \'bag.form.buttons.add\' | translate }}</button></div></div></div></div><!-- responsible sellers --><label>{{ \'bag.form.label.responsible-seller\' | translate }}</label><div style="margin-top: 5px; margin-bottom: 5px"><div ng-if="vm.users.length > 0"><span ng-repeat="user in vm.users" class="custom-tag-bag">{{ user.firstName }} {{ user.lastName}} {{ vm.getProfileName(user) }} <i ng-click="vm.removeUser(user)" class="fa fa-times"></i></span></div><div ng-if="vm.users.length == 0">{{ \'bag.form.messages.empty-seller\' | translate }}</div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><label class="control-label" for="user" data-translate="global.form.fullName">Name</label><angucomplete-alt id="user" placeholder="{{ \'bag.form.placeholder.name-seller\' | translate }}" text-no-results="{{ \'bag.form.placeholder.no-results-seller\' | translate }}" text-searching="{{ \'bag.form.placeholder.searching\' | translate }}" pause="400" input-changed="vm.changeUser" selected-object="vm.selectedUser" remote-url-request-formatter="vm.requestParams" remote-url="/api/users/list/sellers" title-field="firstName,lastName" minlength="2" match-class="highlight" clear-selected="true" description-field="profilesName" input-class="form-control form-control-small"></div></div></div></div><div class="row" style="margin: 0"><div id="carousel" class="carousel showcase-logo-box-texts" style="display:none; margin: 0 !important; margin-bottom: 70px; max-height: 603px; overflow-y: hidden; overflow-x: hidden"></div><div style="width: 100%; bottom: 0; left: 0; text-align: center" class="hidden-lg hidden-xl"><button style="margin-top: 15px; padding: 6px 30px" class="btn btn-primary btn-large" ng-click="vm.openAddBannersModal()"><span class="glyphicon glyphicon-picture pull-left"></span> <span class="showcase-home-button-margin" data-translate="showcases.detail.cover.edit">Editar banners</span></button></div><div class="col-xs-12 showcase-logo-box" style="margin: 0 !important; padding: 0 !important" ng-if="!vm.haveBanners"><input type="file" id="fileInput" style="display: none" accept="image/x-png,image/jpeg,image/png"><div class="showcase-logo-box-texts" ng-if="vm.coverEdit" style="margin-top: 30px !important; margin-bottom: 70px"><img ng-src="content/images/2-image-default-product_mini.png" style="height: 150px"><h1 style="color: #282828 !important" data-translate="bag.title.banner-desc">Adicione banners para encantar seus clientes</h1><p data-translate="showcases.detail.cover.info" style="color: #888888"><br></p><button style="margin-top: 15px; padding: 6px 30px" class="btn btn-primary btn-large" ng-click="vm.openAddBannersModal()"><span class="glyphicon glyphicon-picture pull-left"></span> <span class="showcase-home-button-margin" data-translate="showcases.detail.cover.new">Add Cover</span></button></div></div></div><div class="row m-0"><div class="navigation-buttons"><button ladda="vm.isSaving" type="button" class="btn btn-default btn-custom text-truncate" ng-click="vm.goToList()"><i class="fa fa-times" aria-hidden="true"></i> {{ \'bag.form.buttons.cancel\' | translate }}</button> <button ladda="vm.isSaving" type="button" class="btn btn-primary btn-custom text-truncate" ng-click="vm.saveFlyerPreview()">{{ \'bag.form.buttons.next\' | translate }} <i class="fa fa-arrow-right" aria-hidden="true"></i></button></div></div></form></div><div id="aba2" ng-show="vm.tab === 2"><div class="row" style="margin-bottom: 20px; display: flex; align-items: center"><div class="col-md-12"><h1>{{ \'bag.steps.second\' | translate }}</h1><p>{{ \'bag.form.second-step-subtitle\' | translate }}</p></div></div><div class="checkbox select-all-check hidden-xs"><label><label id="select-all">{{ \'bag.form.label.select-all\' | translate}}</label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.hasSome(vm.excludes, vm.flyersFiltered)" ng-click="vm.addPageToList()"> <span class="checkbox-material"><span class="check coupon-checkbox m-0"></span></span></label></div><div class="row"><div class="hidden-sm hidden-md hidden-lg" style="margin: 3px 15px"><div class="col-xs-12 col-md-4"><div class="input-group date"><span class="input-group-addon"><i class="fa fa-search"></i> </span><input type="text" name="inputSearch" class="form-control" ng-change="vm.loadFlyers()" placeholder="Buscar ..." ng-model="vm.filters.text" ng-model-options="{ debounce: 500 }"></div></div></div><div class="hidden-xs col-xs-6 col-md-4" style="margin-left: 10px; margin-bottom: 10px"><div class="input-group date"><span class="input-group-addon"><i class="fa fa-search"></i> </span><input type="text" name="inputSearch" class="form-control" ng-change="vm.loadFlyers()" placeholder="{{\'flyers.home.search-hint\' | translate}}" ng-model="vm.filters.text" ng-model-options="{ debounce: 500 }"></div></div><div class="row hidden-sm hidden-md hidden-lg" style="padding-top: 5px"><div class="col-xs-5 coupons-menu-button" style="margin-left: 30px; padding-right: 5px"><div class="d-flex justify-content-flex-end"><button class="col-xs-12 col-md-6 btn-filters-modal d-flex" ng-click="vm.openFiltersModal()" type="button" aria-expanded="false" style="margin-top:10px"><span class="col-xs-5 filter-label" style="padding-left: 30%; margin-right: 25%">{{\'flyers.filters.title\' | translate}} </span><span ng-if="vm.numberFilterSelected > 0" class="numberCircle" style="margin-top: 1px">{{vm.numberFilterSelected}}</span></button></div></div><div class="col-xs-5 coupons-menu-button" style="padding-left: 5px"><div class="d-flex justify-content-flex-end"><div class="col-xs-12 col-md-6 d-flex" style="margin-top:10px; padding: 0px"><select id="sort" name="sort" type="text" class="form-control btn-filters-modal filter-label" ng-model="vm.selectedSortByOption" style="text-align-last:center" ng-options="item as item.label for item in vm.sortOptions track by item.id" ng-change="vm.onSelectedSortOption()"><option value="" disabled="disabled" selected="selected">{{ \'flyers.home.orderBy\' | translate}}</option></select></div></div></div></div><div class="row hidden-sm hidden-md hidden-lg" style="padding-top: 5px; margin-right: 25px"><div class="checkbox select-all-check"><label><label id="select-all">{{ \'bag.form.label.select-all\' | translate}}</label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.hasSome(vm.excludes, vm.flyersFiltered)" ng-click="vm.addPageToList()"> <span class="checkbox-material"><span class="check coupon-checkbox m-0"></span></span></label></div></div><div class="hidden-xs col-md-2 col-lg-1 d-flex justify-content-flex-end numberCircleDiv"><button class="btn-filters-modal d-flex" ng-click="vm.openFiltersModal()" type="button" aria-expanded="false"><span class="col-xs-5 filter-label" style="margin-right: 20px">{{\'flyers.filters.title\' | translate}} </span><span ng-if="vm.numberFilterSelected > 0" class="numberCircle" style="margin-top: 2px">{{vm.numberFilterSelected}}</span></button></div></div><div class="row" ng-include="\'app/admin/bag/flyers-view-structure.html\'" ng-if="vm.flyersFiltered.length > 0"></div><div class="row" ng-if="vm.flyersFiltered.length === 0 && !vm.isFiltering "><div class="col-xs-12 showcase-box-noflyer" style="padding: 3% 0"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/mala-vazia-m.png"><h1>{{ \'bag.form.messages.no-products-found\' | translate }}</h1><p class="ksc-sub-title" style="width: 48% !important">{{ \'bag.form.messages.back-first-step\' | translate }}</p></div></div><div class="row custom-pagination"><uib-pagination ng-model="vm.currentPage" total-items="vm.totalFlyers" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistry}}\', of: \'{{vm.endRegistry}}\', total: \'{{vm.totalFlyers}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalFlyers }}</p></div></div><div class="row m-0"><div class="navigation-buttons"><button ladda="vm.isFiltering" type="button" class="btn btn-default btn-custom text-truncate" ng-click="vm.tabClick(1)"><i class="fa fa-arrow-left" aria-hidden="true"></i> {{ \'bag.form.buttons.back\' | translate }}</button> <button ladda="vm.isFiltering" type="button" class="btn btn-primary btn-custom text-truncate" ng-click="vm.saveFlyer(true)"><i class="icon-icon-ksc-admin-bag" aria-hidden="true"></i> {{ \'bag.form.buttons.bag-close\' | translate }}</button></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/bag/bag.html','<style>.btn-filters-modal {\n        color: rgb(136, 136, 136, 1);\n        width: 100%;\n        padding: 6px 0;\n        white-space: normal !important;\n        border: 1px solid rgb(180, 179, 179);\n        background-color: white;\n        border-radius: 18px;\n        font-weight: 500;\n    }\n\n    .filter-label {\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 1.42857;\n    }\n\n    .applyBtn {\n        background-color: var(--main-color) !important;\n    }\n\n    .ranges li {\n        color: var(--main-color) !important;\n    }\n\n    .ranges li.active {\n        background-color: var(--main-color) !important;\n        border: 1px solid var(--main-color) !important;\n        color: #fff !important;\n    }\n\n    .ranges li:hover {\n        background-color: var(--main-color) !important;\n        border: 1px solid #000;\n        color: #fff !important;\n    }\n\n    .daterangepicker {\n        right: 10px !important;\n        left: auto !important;\n    }\n\n    .daterangepicker:before {\n        left: calc(90% - 11px) !important;\n    }\n\n    .daterangepicker:after {\n        left: calc(90% - 10px) !important;\n    }\n\n    .daterangepicker td.active, .daterangepicker td.active:hover {\n        background-color: var(--main-color) !important;\n        border-color: transparent;\n        color: #fff !important;\n    }</style><div class="wrapper wrapper-content container-fluid" ng-if="!vm.userHasShowcases && !vm.hasntStoreYet && vm.checkIsNotLoading()"><div class="row ksc-content-new-bag"><div class="col-xs-12 showcase-box-noflyer"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/mala-m.png"><h1 class="ksc-title-new-bags" data-translate="bag.form.messages.first-bag"></h1><p class="ksc-sub-title ksc-sub-title-new-bags text-truncate max-height-two-lines" data-translate="bag.form.messages.empty-bag-first"></p><button id="btnCreateShowcase" has-authority="STORE_CREATE_SHOWCASE" class="btn btn-primary btn-large" ui-sref="bag.new"><span class="icon-icon-ksc-admin-bag"></span> <span data-translate="bag.buttons.mount-bag"></span></button></div></div></div><div class="wrapper wrapper-content container-fluid" ng-if="vm.hasntStoreYet && vm.checkIsNotLoading()"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/mala-m.png"><h1 data-translate="showcases.messages.errors.noStore"></h1><p data-translate="showcases.messages.errors.subMessageNoStore"></p><button has-authority="STORE_CREATE" class="btn btn-primary btn-large" ui-sref="info"><span class="icon-ksc-store"></span> <span data-translate="store-management.home.buttons.new">Create new store</span></button></div></div></div><div class="wrapper wrapper-content" ng-if="vm.userHasShowcases && vm.checkIsNotLoading()"><div class="row"><div class="col-lg-12"><div class="ibox mb-0"><div class="ibox-content p-15"><div class="row"><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group no-margin-bottom"><div class="inner-addon left-addon"><i class="glyphicon glyphicon-search"></i> <input type="text" class="form-control" ng-model="vm.listFilter.name" ng-change="vm.resetPage()" placeholder="{{\'bag.form.placeholder.search-name\' | translate}}"></div></div></div><div class="col-xs-10 col-sm-10 col-md-2 col-lg-2 d-flex justify-content-flex-end" style="margin-bottom: 10px"><button class="col-xs-12 col-md-6 btn-filters-modal d-flex" ng-click="vm.openFiltersModal()" type="button" aria-expanded="false"><span class="col-xs-5 filter-label" style="margin-right: 20px">{{\'flyers.filters.title\' | translate}} </span><span ng-if="vm.numberFilterSelected > 0" class="numberCircle" style="margin-top: 2px">{{vm.numberFilterSelected}}</span></button></div><div class="col-xs-2 col-sm-2 col-md-1 col-lg-1"><div class="col-xs-12 store-input-nopadding button-delete-product"><a class="coupon-menu-button" ng-click="vm.removeShowcases()" aria-hidden="true"><span id="btnDelete" class="icon-ksc-trash fa-2x" ng-class="{\'coupon-text-color\': vm.showcasesToRemove.length >= 1}"></span> <span ng-if="vm.showcasesToRemove.length >= 1" class="label flyer-label-color">{{vm.showcasesToRemove.length}}</span></a></div></div><div class="col-xs-12 col-sm-12 col-md-3 col-md-offset-2 col-lg-3 col-lg-offset-2" ui-sref="bag.new"><button class="btn btn-primary btn-block mb-0"><span class="icon-icon-ksc-admin-bag showcase-new-icon"></span> <span data-translate="bag.buttons.new"></span></button></div></div></div></div></div></div><div class="row p-15"><div class="col-lg-12 no-padding"><div class="ibox mb-0"><div class="ibox-content custom-box"><div class="row" style="padding-top: 10px"><div class="col-md-4 col-lg-6"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.isShowAllSelected()" ng-click="vm.changeSelectionOfAllShowcases()" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{\'bag.form.label.select-all\' | translate}}</label></div></div><div class="col-md-4 col-lg-3" style="padding-top: 10px"><div class="form-group"><select name="showcasesForPage" ng-change="vm.changePagination()" id="status" ng-model="vm.listFilter.rowsForPage" class="form-control"><option value="20" data-translate="filter.twentyForPage">20 Itens for page</option><option value="40" data-translate="filter.fortyForPage">40 Itens for page</option><option value="60" data-translate="filter.sixtyForPage">60 Itens for page</option><option value="80" data-translate="filter.eightyForPage">80 Itens for page</option><option value="100" data-translate="filter.oneHundredForPage">100 Itens for page</option></select></div></div><div class="col-md-4 col-lg-3"><div style="margin-top: 10px"><div><div class="input-group date" id="showcasesDateRange" ng-click="vm.openDatePicker()"><input id="dateRangeInput" style="float: right; background-color: #fffefe" date-range-picker class="form-control date-picker ng-pristine ng-valid ng-isolate-scope ng-touched" readonly="readonly" placeholder="dd/mm/yyyy - dd/mm/yyyy" ng-model="vm.dateRange" options="vm.dateRangeOptions" required=""> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div></div></div></div></div><div align="center" ng-show="vm.showcases.length == 0"><span data-translate="bag.form.messages.empty-bags"></span></div><div class="row bags"><div class="col-xs-6 col-sm-6 col-md-4 col-lg-3 no-padding" ng-repeat="showcase in vm.showcases"><div class="product-box custom-bag showcase-box" ng-if="!item.flyer"><div class="showcase-box-checkbox form-group"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfShowcaseSelected(showcase.id)" ng-click="vm.updateShowcasesToRemove(showcase.id)" checked="checked"> <span class="checkbox-material"><span class="check"></span></span></label></div></div><div class="new-showcase-box-image"><span id="btnCreateOtherShowcase" class="icon-icon-ksc-admin-bag showcase-new-icon"></span><div class="details-bag"><h2 class="title-bag text-truncate max-height-two-lines">{{showcase.name}}</h2><p class="m-0 text-truncate"><span class="icon-tags showcase-box-icon"></span> <span>{{showcase.numberOfFlyers}}</span> <span data-translate="flyers.home.title"></span></p></div></div><div class="showcase-box-hover"><button class="btn btn-lg showcase-box-transparent-button text-truncate" type="button" ng-click="vm.goToReport(showcase)"><span class="mr-icon fa fa-line-chart"></span> <span data-translate="bag.buttons.report"></span></button> <button id="btnEditShowcase" type="button" has-authority="STORE_UPDATE_SHOWCASE" class="btn btn-lg showcase-box-transparent-button text-truncate" ng-click="vm.getEditPage(showcase.id)"><span class="icon-ksc-edit"></span> <span data-translate="bag.buttons.modify-bag"></span></button> <button ng-if="false" type="button" class="btn btn-lg showcase-box-transparent-button text-truncate" ng-click="vm.getPreviewURL(showcase.id)"><span class="icon-ksc-showcaseviews"></span> <span data-translate="showcases.home.buttons.preview"></span></button> <button class="btn btn-lg showcase-box-transparent-button text-truncate" type="button" ng-click="vm.generateTabloid(showcase)"><span class="mr-icon fa fa-download"></span> <span data-translate="bag.buttons.download"></span></button> <button copy-to-clipboard="{{vm.getBagUrl(showcase)}}" class="btn btn-lg showcase-box-transparent-button text-truncate" type="button" ng-click="vm.copiedUrl()"><span class="mr-icon fa fa-files-o"></span> <span data-translate="bag.buttons.copy-bag-link"></span></button></div></div></div></div><div align="center" style="padding-bottom: 30px; margin-bottom: 10px"><uib-pagination ng-model="vm.currentPage" total-items="vm.totalBags" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.refreshPage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistry}}\', of: \'{{vm.endRegistry}}\', total: \'{{vm.totalBags}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalBags }}</p></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/bag/flyers-view-structure.html','<div class="ibox container-flyers" ng-show="vm.flyersFiltered.length > 0"><div ng-repeat="flyer in vm.flyersFiltered" ng-click="vm.flyerDetailPage(flyer.id)" infinite-scroll="vm.loadFlyers(vm.page + 1)" infinite-scroll-disabled="!vm.hasNextPage || vm.busy" infinite-scroll-immediate-check="false" infinite-scroll-distance="1"><div class="row custom-flyer-content"><div class="flyer-image col-auto"><img id="flyers-image" class="flyer-table-img" ng-src="/flyer/api/{{flyer.id}}/picture" alt="{{flyer.name}}"></div><div class="flyer-descriptions col-xs-8 col-sm-9 col-md-10 col-lg-10"><h3 class="mb-0"><a class="text-navy"><small class="text-muted coupon-text-color product-category text-truncate">{{flyer.category}}</small><p class="flyer-product-name text-truncate max-height-two-lines mb-0">{{flyer.name}}</p></a></h3><div class="price-content text-truncate"><span class="product-info-price-normal" ng-if="flyer.purchaseValue && flyer.discountedValue"><span class="flyer-prices-remove-margin">{{vm.getCurrencyPrefix(flyer)}}</span> <span class="coupon-desactived-decoration">{{flyer.purchaseValue | number: 2}}</span> </span><span class="product-info-price flyer-price" ng-if="flyer.discountedValue"><span class="flyer-prices-remove-margin">{{vm.getCurrencyPrefix(flyer)}}</span> {{flyer.discountedValue | number: 2}} </span><span class="product-info-price flyer-price" ng-if="!flyer.discountedValue && flyer.purchaseValue"><span class="flyer-prices-remove-margin">{{vm.getCurrencyPrefix(flyer)}}</span> {{flyer.purchaseValue | number: 2}}</span></div><div class="inventory-content nowrap"><span uib-tooltip="{{flyer.inventory == 0 ? \'Estoque esgotado\' : \'\'}}" ng-if="flyer.details.length == 0" class="badge badge-details with-stock" ng-class="{\'out-of-stock\': flyer.inventory == 0 }">Estoque: {{flyer.inventory != null ? flyer.inventory : \'Ilimitado\' }} </span><span uib-tooltip="{{item.inventory <= 0 && item.inventory != null ? \'Estoque esgotado\' : \'\'}}" ng-if="flyer.details.length > 0" ng-repeat="item in flyer.details" class="badge badge-details with-stock" ng-class="{\'out-of-stock\': item.inventory <= 0 && item.inventory != null }">{{ vm.storeCategory == FASHION ? \'Tam\' : \'Var\'}} {{item.size}}: {{item.inventory != null ? item.inventory : \'Ilimitado\' }}</span></div><span ng-repeat="tag in flyer.tags" class="badge badge-secondary badge-tag-flyer custom-flyer-tag">{{tag}}</span><div class="flyer-details"><!-- <span class="fa fa-tag" ng-class="{\'ksc-tag-active\': flyer.status == \'ACTIVATED\', \'ksc-tag-inactive\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}"></span>\n                    <span class="flyer-table-info" ng-class="{\'flyer-active\': flyer.status == \'ACTIVATED\', \'flyer-disabled\': (flyer.status == \'DEACTIVATED\' || flyer.status == \'EXPIRED\')}">{{(flyer.status == \'ACTIVATED\' ? \'flyers.offer.active\' : \'flyers.offer.disabled\') | translate}}</span> --> <span class="tag-info" ng-if="flyer.productReference">{{\'Cod: \' + flyer.productReference }} </span><span class="tag-info" ng-show="flyer.expirationDate" tooltip-placement="bottom-left" uib-tooltip="{{\'flyers.new.form.expirationDate\' | translate}}"><span class="fa fa-clock-o product-date">{{flyer.expirationDate | date: "dd/MM/yyyy"}}</span></span></div></div><div class="flyer-checkbox"><div class="checkbox" ng-click="$event.stopPropagation()"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfFlyerSelected(flyer.id)" ng-click="vm.refreshSelectedFlyers(flyer)"> <span class="checkbox-material"><span class="check coupon-checkbox m-0"></span></span></label></div></div></div></div></div>');
$templateCache.put('app/admin/brand/modal-brand.html','<style>.modal-fit .modal-dialog {\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        margin: auto;\n        padding: 10px;\n    }\n\n    .modal-fit .modal-body {\n        /* max-height: calc(100vh - 200px); */\n        max-height: 250px;\n        overflow: auto;\n    }\n\n    .modal-body {\n        padding-top: 0px;\n    }\n\n    .modal-header {\n        padding-bottom: 0px;\n        border-bottom: 0 none;\n    }\n\n    .modal-footer {\n        border-top: 0 none;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n    }\n\n    .btn-large {\n        padding-left: 35px;\n        padding-right: 35px;\n        padding-top: 8px;\n        padding-bottom: 8px;\n    }\n\n    .sub-title {\n        margin-top: 8px;\n    }\n\n    .clients-list .tab-pane {\n        max-height: 250px;\n    }\n\n    .clients-list {\n        margin-top: 0px;\n    }\n\n    #btn-cancel {\n        white-space: normal !important;\n        padding-bottom: 6px;\n        border: 1px solid rgb(180, 179, 179);\n        background-color: white;\n        padding-left: 20px;\n        padding-right: 20px;\n    }</style><div id="add-edit-customer-modal" ng-init="vm.init()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" style="text-transform: uppercase" data-translate="brand.title">All brands</h4><div class="sub-title"><p data-translate="brand.subTitle">Register, remove or edit the marks according to your need</p></div><div class="row"><div ng-class="vm.brandFilter.id !== \'\' ? \'form-group col-md-6\' : \'form-group col-md-9\'" style="margin-top: 16px"><input type="text" name="inputSearch" class="form-control" ng-change="vm.filterChange()" placeholder="Ex. Showkase" ng-model="vm.brandFilter.name" ng-model-options="{ debounce: 500 }" style="box-sizing:border-box; width: 100%"></div><div class="col-md-3 coupons-menu-button" align="center" has-authority="STORE_CREATE_FLYER" ng-show="vm.brandFilter.id === \'\'" style="padding-right: 20px"><button ng-disabled="vm.disableButtonCreate()" ng-click="vm.createBrand()" id="btnCreateFlyer" class="btn btn-primary btn-block" style="white-space: normal !important"><span class="fa fa-plus" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="brand.buttons.create">Create</span></button></div><div ng-show="vm.brandFilter.id !== \'\'"><div class="col-md-3 coupons-menu-button" align="center" has-authority="STORE_CREATE_FLYER"><button ng-disabled="vm.disableButtonEdit()" ng-click="vm.editBrand()" id="btnCreateFlyer" class="btn btn-primary btn-block" style="white-space: normal !important"><span class="fa fa-pencil-square-o" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="brand.buttons.save">Edit</span></button></div><div style="padding-right: 20px" class="col-md-3 coupons-menu-button" align="center" has-authority="STORE_CREATE_FLYER"><button class="btn btn-primary btn-block" ng-click="vm.editCancel()" style="white-space: normal !important; white-space: normal !important; padding-bottom: 6px; border: 1px solid rgb(180, 179, 179); background-color: white"><span class="fa fa-times" style="font-size: 1.2em; color: rgb(179, 175, 175)" aria-hidden="true">&nbsp;</span> <span style="color: rgb(136, 136, 136, 1)" data-translate="brand.buttons.cancel">Cancel</span></button></div></div></div></div><div class="modal-body"><div class="row"><div class="clients-list"><div class="tab-content"><div id="tab-1" class="tab-pane active" style="margin-bottom: 10px"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th style="width: 75%"><span style="padding-left: 8px" data-translate="brand.table.brand">Brand</span></th><th style="width: 25%" class="text-center" header-class="\'text-center\'"><span data-translate="brand.table.actions">Actions</span></th></tr></thead><tbody><tr ng-repeat="brand in vm.brands | orderBy:\'name\' track by brand.id"><td class="client-avatar"><span class="client-link" ng-bind="brand.name" style="padding-left: 10px"></span></td><td class="client-avatar text-center" header-class="\'text-center\'"><a ng-click="vm.getBrandById(brand)" style="padding-left: 10px"><i class="fa fa-pencil-square-o" style="font-size: 22px; color: rgb(158, 155, 155)" aria-hidden="true"></i> </a><a ng-click="vm.removeBrand(brand)" style="padding-left: 10px"><i class="fa fa-trash" style="font-size: 22px; color: rgb(158, 155, 155)" aria-hidden="true"></i></a></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button class="btn btn-primary btn-large" ng-click="vm.close()"><span style="padding-left: 50px; padding-right: 50px" data-translate="brand.buttons.ok">OK</span></button></div></div>');
$templateCache.put('app/admin/category/category-edit.html','<form name="newForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="categorys.edit.title">Edit category</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="container"><div class="row"><div class="col-xs-5"><div class="form-group"><label class="control-label" data-translate="categorys.form.key" for="field_name">Chave da categoria</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.category.key" required></div><div class="form-group"><label class="control-label" data-translate="categorys.form.title" for="field_type">Nome da categoria</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.category.title" required></div></div></div></div></div><div class="modal-footer"><button class="btn btn-primary btn-large" ng-disabled="createForm.$invalid || vm.isSaving"><span class="fa fa-user-plus" aria-hidden="true"></span>&nbsp;<span data-translate="categorys.edit.button">Edit category</span></button></div></form>');
$templateCache.put('app/admin/category/category-new.html','<form name="newForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="categorys.new.title">Create new category</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="container"><div class="row"><div class="col-xs-5"><div class="form-group"><label class="control-label" data-translate="categorys.form.key" for="field_name">Chave da categoria</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.category.key" required></div><div class="form-group"><label class="control-label" data-translate="categorys.form.langPt" for="field_type">Categoria em Portugu\xEAs</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.category.languages[0].title" required></div><div class="form-group"><label class="control-label" data-translate="categorys.form.langEn" for="field_type">Categoria em Ingl\xEAs</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.category.languages[1].title" required></div><div class="form-group"><label class="control-label" data-translate="categorys.form.langEs" for="field_type">Categoria em Espanhol</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.category.languages[2].title" required></div></div></div></div></div><div class="modal-footer"><button class="btn btn-primary btn-large" ng-disabled="createForm.$invalid || vm.isSaving"><span class="fa fa-user-plus" aria-hidden="true"></span>&nbsp;<span data-translate="categorys.new.button">Create new category</span></button></div></form>');
$templateCache.put('app/admin/category/categorys-table.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-title"><p class="sc-default-title-font" data-translate="categorys.store.home.title" ng-if="vm.currentPage == \'store-categorys\'">Store Categorys</p><p class="sc-default-title-font" data-translate="categorys.flyer.home.title" ng-if="vm.currentPage == \'flyer-categorys\'">Flyers Categorys</p></div><div class="ibox-content"><div class="row"><div class="col-xs-12 col-sm-4" align="left"><div class="inner-addon left-addon"><i class="glyphicon glyphicon-search"></i> <input type="text" class="form-control" ng-model="vm.filterFields[vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].name]" ng-change="vm.reload()" placeholder="{{\'global.table.search\' | translate }}{{vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].displayName | translate | lowercase}}"></div></div><div class="col-xs-12 col-sm-4" align="left"><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"><span class="dropdown-text">{{vm.gridTableOptions.paginationPageSize}}</span></button><ul class="dropdown-menu pull-right" role="menu"><li ng-repeat="size in vm.pagesSize" ng-class="{\'active\': vm.gridTableOptions.paginationPageSize === size}" ng-click="vm.changePageSize(size)" ng-if="size != 0"><a class="dropdown-item dropdown-item-button">{{size}}</a></li><li aria-selected="false" ng-click="vm.changePageSize(vm.totalItems)"><a class="dropdown-item dropdown-item-button">All</a></li></ul><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span class="glyphicon glyphicon-th"></span></button><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)"><li ng-repeat="column in vm.gridTableOptions.columnDefs track by $index"><div class="form-group"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.changeColumnView($index)" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{column.displayName | translate}}</label></div></div></li></ul></div><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span class="glyphicon glyphicon-filter"></span></button><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)"><li ng-repeat="column in vm.gridTableOptions.columnDefs | limitTo:vm.gridTableOptions.columnDefs.length-2:1"><div class="form-group input-group"><input type="text" ng-model="vm.filterFields[column.name]" class="form-control input-size" ng-change="vm.reloadUsers()" placeholder="Search by {{column.displayName | translate | lowercase}}"></div></li></ul></div></div></div><div class="col-xs-12 col-sm-4" align="right"><button class="btn btn-primary btn-large" ng-click="vm.addCategory()" has-any-authority="ADMIN_UPDATE_USER, STORE_READ_USER"><span class="icon-ksc-adduser" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span><span data-translate="categorys.form.button">Create new category</span></button></div></div><div class="row"><div class="col-xs-12"><div ui-grid="vm.gridTableOptions" ui-grid-pagination ui-grid-exporter class="profile-table" style="margin-top: 15px"></div></div></div><div class="row"><div class="col-xs-12 col-sm-2" align="left"><i class="fa fa-file-pdf-o" ng-click="vm.exporterTable(\'pdf\')" aria-hidden="true"></i> <i class="fa fa-file-excel-o" ng-click="vm.exporterTable(\'csv\')" aria-hidden="true"></i> <i class="fa fa-print" aria-hidden="true"></i></div><div class="col-xs-12 col-sm-4 panel-entries-text" align="right"><p data-translate="global.table.pagination" translate-values="{start: \'{{vm.startRegistry}}\', end: \'{{vm.endRegistry}}\', total: \'{{vm.totalItems}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalItems }}</p></div><div class="col-xs-12 col-sm-6" align="right"><ul class="pagination"><li class="page-item" ng-class="{\'disabled\' : vm.checkIsFirstPage}" ng-disabled="vm.checkIsFirstPage"><a class="page-link" ng-click="vm.gridTableApi.pagination.seek(1)">&lt;&lt;</a></li><li class="page-item" ng-class="{\'disabled\' : vm.checkIsFirstPage}" ng-disabled="vm.checkIsFirstPage"><a class="page-link" ng-click="vm.gridTableApi.pagination.previousPage()">&lt;</a></li><li class="page-item" ng-repeat="page in vm.arrayPagination" ng-class="{\'active\': vm.gridTableApi.pagination.getPage() === page}"><a class="page-link" ng-click="vm.gridTableApi.pagination.seek(page)">{{page}}</a></li><li class="page-item" ng-class="{\'disabled\' : vm.checkIsLastPage}" ng-disabled="vm.checkIsLastPage"><a class="page-link" ng-disabled="vm.checkLastPage" ng-click="vm.gridTableApi.pagination.nextPage()">&gt;</a></li><li class="page-item" ng-class="{\'disabled\' : vm.checkIsLastPage}" ng-disabled="vm.checkIsLastPage"><a class="page-link" ng-click="vm.gridTableApi.pagination.seek(vm.gridTableApi.pagination.getTotalPages())">&gt;&gt;</a></li></ul></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/checklist/checklist.html','<style>@media (max-width: 800px) {\n        .modal-dialog {\n            width: 100% !important;\n        }\n    }\n\n    .modal-dialog {\n        position: fixed;\n        margin: auto;\n        width: 520px;\n        min-height: 100%;\n        z-index: 10040;\n        overflow: auto;\n        overflow-y: auto;\n        right: 0;\n        top: 0;\n        margin-top: 0 !important;\n    }\n\n    .modal-content {\n        min-height: 100%;\n        margin-top: -1px !important;\n    }\n\n    .content-title-nps {\n        background-image: linear-gradient(to bottom right, #00d8a6, #02a982);\n        height: 69px;\n    }\n\n    .modal-title {\n        font-size: 20px;\n        color: #fff;\n        padding: 11px 0;\n        font-weight: 500;\n    }\n\n    div.scrollmenu {\n        background-color: transparent;\n        overflow: auto;\n        white-space: nowrap;\n        border-bottom: 1px solid #d7d6d6;\n    }\n\n    div.scrollmenu a {\n        display: inline-block;\n        color: white;\n        text-align: center;\n        padding: 14px;\n        text-decoration: none;\n    }\n\n    div.scrollmenu a:hover {\n        background-color: #e6e6e6;\n        border-top-left-radius: 5px;\n        border-top-right-radius: 5px;\n    }\n\n    .panel {\n        padding: 0 5px;\n        margin-bottom: 5px;\n        background-color: white;\n        max-height: 0;\n        overflow: hidden;\n        transition: max-height 0.2s ease-out;\n        border-radius: 0 0 10px 10px;\n    }\n\n    .pending {\n        background-color: #f4ab1b;\n        margin-left: 10px;\n    }\n\n    .in-progress {\n        background-color: #3ea8ee;\n    }\n\n    .done {\n        background-color: #2ab892;\n    }\n\n    .cancelled {\n        background-color: #e73c3e;\n    }\n\n    .cancel-btn {\n        outline: none;\n        background-color: transparent;\n        border: none;\n        color: #868686;\n        font-size: 15px;\n    }\n\n    .btn-start-item {\n        background: white;\n        border: 1px solid var(--main-color) !important;\n        color: var(--main-color) !important;\n    }\n\n    /* CIRCLE PROGRESS */\n    .circle-wrap {\n        margin: 20px 0;\n        width: 60px;\n        height: 60px;\n        background: #2f137e59;\n        border-radius: 50%;\n        border: 1px solid #cdcbd0;\n        padding: 0;\n    }\n\n    .circle-wrap .circle .mask,\n    .circle-wrap .circle .fill {\n        width: 60px;\n        height: 60px;\n        position: absolute;\n        border-radius: 50%;\n    }\n\n    .circle-wrap .circle .mask {\n        clip: rect(0px, 60px, 60px, 30px);\n    }\n\n    .circle-wrap .inside-circle {\n        width: 49px;\n        height: 49px;\n        border-radius: 50%;\n        background: white;\n        line-height: 48px;\n        text-align: center;\n        margin-top: 5px;\n        margin-left: 5px;\n        color: var(--main-color);\n        position: absolute;\n        z-index: 100;\n        font-weight: 700;\n        font-size: 1.2em;\n    }\n\n    /* color animation */\n\n    /* 3rd progress bar */\n    .mask .fill {\n        clip: rect(0px, 30px, 60px, 0px);\n        background-color: var(--main-color);\n    }\n\n    .mask.full, .circle .fill {\n        animation: fill ease-in-out 0.5s;\n        transform: rotate(15deg);\n    }</style><div><div class="content-title-nps"><div class="row" style="height: 100%"><div class="col-xs-8" style="height: 100%"><p class="modal-title"><span>{{\'checklist.title\' | translate}}</span></p></div><div class="col-xs-4" style="height: 100%"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()" style="padding: 8px 0; color: white; opacity: 0.8 !important">&times;</button></div></div></div><div class="modal-body qualification-content" ng-style="!vm.showObservation && { \'padding-bottom\':\'5%\' }"><div class="row"><div class="col-xs-8"><div class="greetings">{{\'checklist.hello\' | translate}} {{vm.account.firstName}}!<br>{{\'checklist.today\' | translate}}, {{ vm.todayDate }}</div><div><div class="circle-wrap col-xs-4"><div class="circle"><div id="maskFill" class="mask full"><div id="maskFillPercentage" class="fill"></div></div><div class="mask half"><div id="fillPercentage" class="fill"></div></div><div class="inside-circle" ng-if="vm.doneItemsTotal > 0">{{ ((vm.doneItemsTotal / vm.totalItems) * 100).toFixed(0) }}%</div><div class="inside-circle" ng-if="vm.doneItemsTotal == 0">0%</div></div></div><div class="col-xs-8" style="margin-top: 40px">{{ \'checklist.task.status.performed\' | translate }}</div></div></div><div class="col-xs-4"><img class="pull-right" src="https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/seller-checklist.png" style="width: auto; height: 170px"></div></div><div class="row"><div class="scrollmenu"><a ng-click="vm.tabTypeClick(type.key)" ng-repeat="type in vm.checklistTypes" style="min-width: 100px" ng-class="{\'type-select\' : vm.listFilter.type == type.key}"><span style="color: #676a6c; font-weight: 500">{{type.title}}</span></a></div><div id="tabContent" class="tab-content" style="margin-top:10px; overflow: auto; scroll-behavior: auto; margin-bottom: 40px"><div ng-if="vm.loadingTab" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div style="text-align: center; padding: 5px 15px 15px; color: #676a6c" ng-if="!vm.loadingTab"><span ng-if="vm.listFilter.type == \'ALL\'">{{ vm.doneItems }} / {{ vm.listItems.length }} {{ \'checklist.task.status.all\' | translate }} </span><span ng-if="vm.listFilter.type == \'PENDING\'">{{ vm.listItems.length }} {{ \'checklist.task.status.pending\' | translate }}</span> <span ng-if="vm.listFilter.type == \'DONE\'">{{ vm.listItems.length }} {{ \'checklist.task.status.done\' | translate }}</span></div><div style="margin-right: 5px"><div ng-repeat="item in vm.listItems"><div id="{{vm.listFilter.type}}-{{item.id}}" class="accordion" ng-style="item.status == \'DONE\' && {\'background\': \'#eeecec\'}"><div id="{{vm.listFilter.type}}-{{item.id}}-content" style="width: 75%; float: left"><div ng-if="item.status == \'DONE\' || item.status == \'DOING\'" style="margin-top: -8px"><span ng-style="item.status == \'DONE\' && {\'text-decoration\': \'line-through\'}" class="checklist-item-title">{{ item.name }}</span><div class="task-info" style="font-size: 11px; margin-left: -2px"><span><i class="icon-ksc-finaluser-user"></i> {{ vm.getFormattedName(item.signedUserName, 20) }} <span ng-if="item.status == \'DOING\'"><i class="icon-ksc-clock" style="margin-left: 8px"></i> {{ \'checklist.task.signed\' | translate }} {{ vm.getFormattedTime(item.signedDate) }} </span></span><span ng-if="item.status == \'DONE\'"><i class="icon-ksc-clock" style="margin-left: 8px"></i> {{ \'checklist.task.finished\' | translate }} {{ vm.getFormattedTime(item.finishedDate) }}</span></div></div><div ng-if="item.status != \'DONE\' && item.status != \'DOING\'"><span class="checklist-item-title">{{ item.name }}</span></div></div><div class="checklist-item-badge" style="margin-left: 75%; width: 20%; display: block"><span ng-if="item.status == \'CANCELLED\'" class="label label-info check-list-label cancelled" style="margin-left: 24px">{{ \'checklist.task.badges.cancelled\' | translate }} </span><span ng-if="item.status == \'DONE\'" class="label label-info check-list-label done" style="margin-left: 25px">{{ \'checklist.task.badges.done\' | translate }} </span><span ng-if="item.status == \'DOING\'" class="label label-info check-list-label in-progress" style="margin-left: 5px">{{ \'checklist.task.badges.in-progress\' | translate }} </span><span ng-if="item.status == \'PENDING\'" class="label label-info check-list-label pending" style="margin-left: 26px">{{ \'checklist.task.badges.pending\' | translate }}</span></div></div><div class="panel" style="width: 100%"><div style="margin-left: 14px; width: 90%"><p>{{ item.description }}</p></div><div style="width: 100%"><div ng-if="item.status == \'DOING\' || item.status == \'PENDING\'" class="col-sm-12 col-md-5" style="margin-left: 9px; padding-left: 0; margin-top: 6px"><button type="button" class="cancel-btn" ng-click="vm.updateItem(item, \'CANCELLED\')" style="font-size: 13px; margin-top: 3px"><i class="fa fa-times"></i> {{ \'checklist.task.actions.cancel\' | translate }}</button></div><div ng-if="item.status == \'DOING\'" class="col-sm-12 col-md-6 task-action-button" style="padding-right: 0"><div style="display: flex; align-items: center; float: right; width: 100%"><button id="btnDone" class="btn btn-primary btn-block" ng-click="vm.updateItem(item, \'DONE\')" style="white-space: normal !important; width: 100%"><span>{{ \'checklist.task.actions.finish\' | translate }}</span></button></div></div><div ng-if="item.status == \'PENDING\'" class="col-sm-12 col-md-6 task-action-button" style="padding-right: 0"><div style="display: flex; align-items: center; float: right; width: 100%"><button id="btnStart" class="btn btn-start-item btn-block" ng-click="vm.updateItem(item, \'DOING\')" style="white-space: normal !important; width: 100%"><span class="fa fa-play" style="font-size: 1em" aria-hidden="true">&nbsp;</span> <span>{{ \'checklist.task.actions.start\' | translate }}</span></button></div></div><div ng-if="item.status == \'DONE\'" class="col-sm-12 col-md-12" style="margin-top: 6px"><div style="display: flex; align-items: center; float: right; width: 100%; text-align: center"><span style="font-size: 15px; color: #02a982; font-weight: 500; width: 100%">{{ \'checklist.task.congrats\' | translate }}</span></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/color/modal-color.html','<style>.modal-fit .modal-dialog {\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        margin: auto;\n        padding: 10px;\n    }\n\n    .modal-fit .modal-body {\n        /* max-height: calc(100vh - 200px); */\n        max-height: 250px;\n        overflow: auto;\n    }\n\n    .modal-body {\n        padding-top: 0px;\n    }\n\n    .modal-header {\n        padding-bottom: 0px;\n        border-bottom: 0 none;\n    }\n\n    .modal-footer {\n        border-top: 0 none;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n    }\n\n    .btn-large {\n        padding-left: 35px;\n        padding-right: 35px;\n        padding-top: 8px;\n        padding-bottom: 8px;\n    }\n\n    .sub-title {\n        margin-top: 8px;\n    }\n\n    .clients-list .tab-pane {\n        max-height: 250px;\n    }\n\n    .clients-list {\n        margin-top: 0px;\n    }\n\n    #btn-cancel {\n        white-space: normal !important;\n        padding-bottom: 6px;\n        border: 1px solid rgb(180, 179, 179);\n        background-color: white;\n        padding-left: 20px;\n        padding-right: 20px;\n    }</style><div id="add-edit-customer-modal" ng-init="vm.init()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" style="text-transform: uppercase" data-translate="brand.title">All brands</h4><div class="sub-title"><p data-translate="brand.subTitle">Register, remove or edit the marks according to your need</p></div><div class="row"><div ng-class="vm.brandFilter.id !== \'\' ? \'form-group col-md-6\' : \'form-group col-md-9\'" style="margin-top: 16px"><input type="text" name="inputSearch" class="form-control" ng-change="vm.filterChange()" placeholder="Ex. Showkase" ng-model="vm.brandFilter.name" ng-model-options="{ debounce: 500 }" style="box-sizing:border-box; width: 100%"></div><div class="col-md-3 coupons-menu-button" align="center" has-authority="STORE_CREATE_FLYER" ng-show="vm.brandFilter.id === \'\'" style="padding-right: 20px"><button ng-disabled="vm.disableButtonCreate()" ng-click="vm.createBrand()" id="btnCreateFlyer" class="btn btn-primary btn-block" style="white-space: normal !important"><span class="fa fa-plus" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="brand.buttons.create">Create</span></button></div><div ng-show="vm.brandFilter.id !== \'\'"><div class="col-md-3 coupons-menu-button" align="center" has-authority="STORE_CREATE_FLYER"><button ng-disabled="vm.disableButtonEdit()" ng-click="vm.editBrand()" id="btnCreateFlyer" class="btn btn-primary btn-block" style="white-space: normal !important"><span class="fa fa-pencil-square-o" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="brand.buttons.save">Edit</span></button></div><div style="padding-right: 20px" class="col-md-3 coupons-menu-button" align="center" has-authority="STORE_CREATE_FLYER"><button class="btn btn-primary btn-block" ng-click="vm.editCancel()" style="white-space: normal !important; white-space: normal !important; padding-bottom: 6px; border: 1px solid rgb(180, 179, 179); background-color: white"><span class="fa fa-times" style="font-size: 1.2em; color: rgb(179, 175, 175)" aria-hidden="true">&nbsp;</span> <span style="color: rgb(136, 136, 136, 1)" data-translate="brand.buttons.cancel">Cancel</span></button></div></div></div></div><div class="modal-body"><div class="row"><div class="clients-list"><div class="tab-content"><div id="tab-1" class="tab-pane active" style="margin-bottom: 10px"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th style="width: 75%"><span style="padding-left: 8px" data-translate="brand.table.brand">Brand</span></th><th style="width: 25%" class="text-center" header-class="\'text-center\'"><span data-translate="brand.table.actions">Actions</span></th></tr></thead><tbody><tr ng-repeat="brand in vm.brands track by brand.id"><td class="client-avatar"><span class="client-link" ng-bind="brand.name" style="padding-left: 10px"></span></td><td class="client-avatar text-center" header-class="\'text-center\'"><a ng-click="vm.getBrandById(brand)" style="padding-left: 10px"><i class="fa fa-pencil-square-o" style="font-size: 22px; color: rgb(158, 155, 155)" aria-hidden="true"></i> </a><a ng-click="vm.removeBrand(brand)" style="padding-left: 10px"><i class="fa fa-trash" style="font-size: 22px; color: rgb(158, 155, 155)" aria-hidden="true"></i></a></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button class="btn btn-primary btn-large" ng-click="vm.close()"><span style="padding-left: 50px; padding-right: 50px" data-translate="brand.buttons.ok">OK</span></button></div></div>');
$templateCache.put('app/admin/communication/communication.html','<link href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css" rel="stylesheet"><link href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.css" rel="stylesheet"><style>.loading-audio audio::-webkit-media-controls-play-button {\n        visibility: hidden;\n    }\n\n    .full-screen-preview {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(0, 0, 0, 0.8);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        z-index: 2040;\n    }\n\n    .full-screen-actions {\n        position: absolute;\n        top: 15px;\n        right: 30px;\n        width: 10vw;\n        display: flex;\n        justify-content: space-around;\n    }\n\n    .full-screen-actions button {\n        color: white;\n        font-size: 22px;\n        opacity: 1;\n        font-weight: 100;\n        padding: 0;\n        cursor: pointer;\n        background: transparent;\n        border: 0;\n        -webkit-appearance: none;\n    }\n\n    .full-screen-preview button:hover {\n        color: white;\n    }\n\n    .full-screen-preview img {\n        max-width: 90%;\n        max-height: 90%;\n    }\n\n    .full-screen-preview video {\n        max-width: 70%;\n        max-height: 80%;\n    }\n\n    video.story-reponse-video::-webkit-media-controls-panel {\n        display: none !important;\n        opacity: 1 !important;}\n\n    .play-icon {\n        font-size: 6rem;\n        color: white;\n        opacity: .8;\n        position: absolute;\n        cursor: pointer;\n    }\n\n    .video-failed-content {\n        opacity: .5;\n        position: absolute;\n        cursor: pointer;\n        color: #FFFFFF;\n        display: flex;\n        padding: 6px 15px;\n        border-radius: 15px;\n        flex-direction: row;\n        align-items: center;\n    }\n\n    .video-failed {\n        color: #FFFFFF;\n        font-size: 2rem;\n        margin-right: 10px;\n    }\n\n    svg {\n        width: 18px;\n        height: 18px;\n    }\n\n    .error-message {\n        border-color: #900 !important;\n    }\n\n    .pressable-element {\n        -khtml-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n    }\n\n    .icon-instagram-plataform {\n        width: 24px;\n        height: 24px;\n        background: rgb(220, 49, 117);\n        border-radius: 100%;\n        display: flex;\n        -webkit-box-align: center;\n        align-items: center;\n        -webkit-box-pack: center;\n        justify-content: center;\n        position: relative;\n        color: white;\n        box-sizing: border-box;\n        flex-shrink: 0;\n    }\n\n    .icon-whatsapp-plataform {\n        width: 26px;\n        height: 26px;\n        background: green;\n        border-radius: 100%;\n        display: flex;\n        -webkit-box-align: center;\n        align-items: center;\n        -webkit-box-pack: center;\n        justify-content: center;\n        position: relative;\n        color: white;\n        box-sizing: border-box;\n        flex-shrink: 0;\n    }\n\n    .icon-messenger-plataform {\n        width: 26px;\n        height: 26px;\n        border-radius: 100%;\n        display: flex;\n        -webkit-box-align: center;\n        align-items: center;\n        -webkit-box-pack: center;\n        justify-content: center;\n        position: relative;\n        flex-shrink: 0;\n        box-sizing: border-box;\n        color: rgb(0, 132, 255);\n    }\n\n    .date-container {\n        display: flex;\n        justify-content: center;\n    }\n\n    .content-reserved {\n        display: flex;\n        align-self: center;\n        justify-content: center;\n    }\n\n    .no-conversation-selected {\n        background-color: white;\n        background-clip: content-box;\n        text-align: center;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .no-conversation-selected-subtitle, .no-conversation {\n        font-size: 1.2em;\n    }\n\n    .no-conversation-content {\n        background-color: white;\n        background-clip: content-box;\n        text-align: center;\n        height: 100vh;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n    }\n\n    .date-info {\n        margin-top: 10px;\n        padding: 5px 12px 6px;\n        text-align: center;\n        background-color: rgb(225, 245, 254, 0.92);\n        border-radius: 7.5px;\n    }\n\n    /*.replying.ng-enter {*/\n    /*    overflow: hidden;*/\n    /*    animation-direction: reverse;*/\n    /*    animation:.3s 1 alternate forwards open;*/\n    /*}*/\n\n    /*.replying.ng-leave {*/\n    /*    overflow: hidden;*/\n    /*    animation-direction: reverse;*/\n    /*    animation:.3s 1 alternate forwards close;*/\n    /*}*/\n\n    /*@keyframes open {*/\n    /*    0% {*/\n    /*        height: 0;*/\n    /*    }*/\n    /*    100% {*/\n    /*        height: 154px;*/\n    /*    }*/\n    /*}*/\n\n    @keyframes close {\n        0% {\n            height: 154px;\n        }\n        100% {\n            height: 0;\n        }\n    }\n\n    .icon-plataform {\n        position: relative;\n        bottom: 25%;\n        left: 50%;\n    }\n\n    .icon-plataform img {\n        width: 22px;\n    }\n\n    .message-time-audio-container {\n        margin: -3px 0 -5px -25px;\n    }\n\n    audio::-webkit-media-controls-time-remaining-display  {\n        display: none !important;\n    }\n\n    html {\n        overflow: hidden;\n    }\n\n    ::-webkit-scrollbar {\n        width: 0px;\n        background: transparent;\n        /* make scrollbar transparent */\n    }\n\n    .user-image-content {\n        align-items: center;\n        display: flex;\n        margin-right: 10px;\n    }\n\n    .no-messages-content {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .no-messages {\n        background: #ffeecd;\n        padding: 5px 12px 6px;\n        border-radius: 7.5px;\n        margin-top: 20px;\n        font-size: 13px;\n    }\n\n    .bottom-sheet-container {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: rgba(0, 0, 0, 0.5);\n        align-items: flex-end;\n        justify-content: center;\n        display: none;\n        z-index: 2031;\n    }\n\n    .bottom-sheet-container-desktop {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        align-items: flex-end;\n        justify-content: center;\n        display: none;\n        z-index: 2031;\n    }\n\n    .bottom-sheet-container.active {\n        display: flex;\n    }\n\n    .bottom-sheet-container-desktop.active {\n        display: flex;\n    }\n\n    .bottom-sheet-body.mobile {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        border-top-left-radius: 25px;\n        border-top-right-radius: 25px;\n        padding-top: 15px;\n        background-color: #FFF;\n        width: 100%;\n        height: auto;\n        min-height: 175px;\n        transform: translateY(100%);\n        transition: transform 0.4s ease-in-out;\n        z-index: 2032;\n    }\n\n    .bottom-sheet-body.desktop {\n        position: fixed;\n        bottom: 0;\n        border-radius: 15px;\n        padding-top: 10px;\n        padding-bottom: 10px;\n        background-color: #FFF;\n        height: auto;\n        min-height: 175px;\n        transform: translateY(100%);\n        z-index: 2032;\n    }\n\n    .bottom-sheet-body {\n        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    }\n\n    .bottom-sheet-body a, .bottom-sheet-body label {\n        color: #333;\n        font-size: 15px;\n        text-decoration: none;\n        height: 50px;\n        padding: 20px !important;\n        display: flex;\n        align-items: center;\n        font-weight: normal !important;\n    }\n\n    .bottom-sheet-body .sheet-option-icon {\n        font-size: 20px;\n        margin-right: 15px;\n    }\n\n    .bottom-sheet-body .upload-file-label {\n        font-weight: normal;\n        margin-bottom: 0;\n    }\n\n    .bottom-sheet-body .upload-file-label:hover {\n        font-weight: normal;\n        margin-bottom: 0;\n        color: inherit;\n    }\n\n    .bottom-sheet-body.active.mobile {\n        transform: translateY(0);\n    }\n\n    .bottom-sheet-body.active.desktop {\n        transform: translateY(-37%);\n    }\n\n    .contact-name-container {\n        min-width: 0;\n    }\n\n    .chat-users-deactivated {\n        opacity: 60% !important;\n    }\n\n    .file-upload {\n        margin-top: 3px;\n        font-size: 18px;\n    }\n\n    .forward-message{\n        cursor: pointer;\n        margin: auto 10px;\n        border-radius: 50%;\n        width: 25px;\n        height: 25px;\n        opacity: 15%;\n        background-color: black;\n        color: white;\n        text-align: center;\n        padding: 5px;\n        font-size: 12px;\n    }\n\n    .selected-attendant {\n        display: flex;\n        align-items: center;\n    }\n\n    .attendant-circle {\n        display: inline-block;\n        font-size: 11px;\n        font-weight: bold;\n        width: 17px;\n        height: 17px;\n        min-width: 17px;\n        line-height: 1.7em;\n        text-align: center;\n        border-radius: 50%;\n        vertical-align: middle;\n        margin-right: 5px;\n        color: white;\n    }\n\n    .attendant-attribution {\n        font-size: 20px;\n        margin-right: 5px;\n        color: #969696;\n    }\n\n    .color-text-location {\n        color: #eeeeee;\n    }\n\n    .forward-message-btn {\n        cursor: auto !important;\n        margin-left: auto;\n        display: flex;\n        align-items: center;\n        flex-direction: row;\n    }\n\n    .alert-dismissable {\n        margin-top: 5px;\n        margin-bottom: 10px;\n        padding: 8px;\n        width: 100%;\n    }</style><div class="row" ng-if="!vm.isLoadingConnection && !vm.allChatsConnected"><div class="col-md-12"><div class="wrapper wrapper-content chat-container"><div class="ibox-content social-media-not-connected" style="min-height: 85vh"><div class="connect-box"><img src="https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/showkase/campaign-whatsapp-m.png"><h1>{{ \'communication.not-connected.title\' | translate }}</h1><p class="ksc-sub-title" data-translate="communication.not-connected.subtitle">{{ \'communication.not-connected.subtitle\' | translate }}</p><button class="btn btn-primary btn-large btn-connect" ng-click="vm.openSocialNetworksConnect()"><i class="fa fa-comments"></i> {{ \'communication.not-connected.button-connect\' | translate }}</button></div></div></div></div></div><div class="row" ng-if="vm.fbConnected || vm.isWatiConnected"><div class="col-xs-12" ng-class="{\'pl-0 pr-0\' : vm.isMobile}"><div class="wrapper wrapper-content chat-container w-100" ng-class="{\'pt-0\' : vm.isMobile}"><div class="row w-100 mr-0 ml-0"><div class="col-xs-12 col-md-4 col-lg-3 pr-0 pl-0" ng-class="{\'d-none\': !vm.mobileFlow[\'listConversations\'] && vm.isMobile }"><div class="ibox-content contacts-list" style="min-height: 85vh" ng-style="{\'max-height\': vm.conversationHeight}"><div class="input-group" style="display: flex"><input class="form-control" name="search" ng-change="vm.findByName()" ng-model="vm.searchText" ng-model-options="{ debounce: 500 }" placeholder="{{\'communication.searchCustomer\' | translate}}" type="text"><div class="dropdown open" uib-dropdown=""><button aria-expanded="true" aria-haspopup="true" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" style="padding-top: 7px; margin-left: 10px" type="button" uib-dropdown-toggle=""><i aria-hidden="true" class="fa fa-bars"></i></button><ul class="m-t-xs ng-scope right-configuration-menu-items dropdown-menu pull-right" uib-dropdown-menu=""><li><a class="ng-scope" ng-click="vm.openNewConversationModal()">{{\'communication.create-message\' | translate}}</a></li><li ng-if="vm.isWatiConnected"><a class="ng-scope" ng-click="vm.openBroadcastListModal()">{{\'communication.whatsapp-broadcast-list\' | translate}}</a></li><li ng-if="vm.isWatiConnected"><a class="ng-scope" ng-click="vm.openLogoutModal(\'WATI\')">{{\'communication.whatsapp-logout\' | translate}}</a></li><li ng-if="vm.fbConnected"><a class="ng-scope" ng-click="vm.openLogoutModal(\'FACEBOOK\')">{{\'communication.facebook-logout\' | translate}}</a></li></ul></div></div><div class="social-media-filter"><p class="social-media-filter-buttons" id="social-media-filter-scroll"><button ng-class="{\'selected-social-media-filter btn-primary\':vm.currentSocialMedia==\'ALL\', \'unselected-social-media-filter\':vm.currentSocialMedia!=\'ALL\'}" ng-click="vm.changeTab(\'ALL\')" ng-disabled="vm.loadingConversations"><span class="messages-tab"><span style="margin-right:5px">Tudo</span> <span ng-class="{\'numberCircle\':vm.currentSocialMedia==\'ALL\', \'numberCircle numberCircle-tab-unselected\':vm.currentSocialMedia!=\'ALL\'}">{{vm.allMessages}}</span></span></button> <button ng-class="{\'selected-social-media-filter btn-primary\':vm.currentSocialMedia==socialMedia.tabId,\n                                        \'unselected-social-media-filter\':vm.currentSocialMedia!=socialMedia.tabId}" ng-click="vm.changeTab(socialMedia.tabId)" ng-disabled="vm.loadingConversations" ng-repeat="socialMedia in vm.socialMediasOptions | orderBy: \'[connected, position]\' : true"><span class="messages-tab"><span style="margin-right:5px">{{socialMedia.title}}</span> <span ng-class="{\'numberCircle \':vm.currentSocialMedia==socialMedia.tabId, \'numberCircle numberCircle-tab-unselected\':vm.currentSocialMedia!=socialMedia.tabId}">{{socialMedia.numberOfMessages()}}</span></span></button></p></div><div class="row" style="margin-bottom: 10px"><div class="col-md-12 d-flex justify-content-flex-end"><button aria-expanded="false" class="btn-dropdown-status d-flex" ng-click="vm.openFiltersModal()" type="button"><i class="icon-ksc-filter" style="margin-right: 5px"></i> Filtros <span class="numberCircle mt-0" ng-if="vm.numberFilterSelected > 0" style="margin-left: 15px">{{vm.numberFilterSelected}}</span></button></div></div><div class="sk-container" ng-if="vm.loadingConversations" style="height: 100%; width: 100%; align-items: center"><chat-contacts-skeleton card-qtt="15"></chat-contacts-skeleton></div><div class="row" style="height: 80vh" ng-if="(!vm.isWatiConnected) && vm.currentSocialMedia==\'WATI\'"><div class="col-md-12 tab-connect-to-facebook-or-instagram"><img alt="" id="whatsapp" src="content/images/icon-whatsapp-connection.png"><div><h3>WhatsApp Business API</h3><h4>{{ \'communication.tabs.whatsapp-connect\' | translate }}</h4></div><button class="btn" ng-click="vm.openWatiSettingsModal()" ng-style="{\'background-color\': \'#63AF21\'}" style="display: flex" type="button"><i class="fa fa-whatsapp" style="font-size: 23px"></i> {{ \'communication.connect-modal.buttons.connect\' | translate }}</button></div></div><div class="row" style="height: 80vh" ng-if="!vm.fbConnected && (vm.currentSocialMedia==\'MESSENGER\' || vm.currentSocialMedia==\'INSTAGRAM\')"><div class="col-md-12 tab-connect-to-facebook-or-instagram"><img alt="" src="content/images/icon-messenger-instagram.png"><div><h3>Facebook e Instagram</h3><h4>{{ \'communication.tabs.facebook-connect\' | translate }}</h4></div><button class="btn" ng-click="vm.facebookAuth()" type="button"><i class="fa fa-comments"></i> {{ \'communication.connect-modal.buttons.connect\' | translate }}</button></div></div><div class="no-conversation-content" ng-if="vm.conversationsList.length === 0 && vm.hasConversations()"><i class="icon-ksc-comment-exclamation-light" aria-hidden="true" style="font-size: 6em;\n                                      color: var(--main-color-light)"></i> <span class="row text-muted" style="font-size: 1.5em; margin: 15px" data-translate="communication.no-conversation.title"></span></div><div class="chat-users conversation-list" detect-scroll-to-bottom="vm.conversationsScrolledToBottom" id="conversations" ng-class="{\'chat-users-deactivated\': vm.loadingConversations}" ng-if="vm.conversationsList.length > 0 && vm.hasConversations()"><div ng-repeat="conversation in vm.conversationsList track by conversation.conversationId"><div class="chat-user convesation" id="container-conversation" ng-class="{\'chat-user-deactivated\': vm.loadingMessages}" ng-class="{\'conversation-active\': conversation.conversationId == vm.currentConversation.conversationId}" ng-style="{\'border-left-color\': (conversation.conversationId == vm.currentConversation.conversationId ? vm.mainColor : \'#e7eaec\')}" ng-click="vm.openConversation(conversation)"><div class="chat-user-picture"><div><img class="profile-pic" ng-src="{{conversation.profilePic ? conversation.profilePic : \'./assets/images/avatar.png\'}}"></div><div class="icon-plataform" ng-if="conversation.platform === \'WATI\'"><img alt="" src="/content/images/icon-whatsapp.png"></div><div class="icon-plataform" ng-if="conversation.platform === \'INSTAGRAM\'"><img alt="" src="/content/images/icon-instagram.png"></div><div class="icon-plataform" ng-if="conversation.platform === \'MESSENGER\'"><img alt="Messenger icon" src="/content/images/icon-messenger.png"></div></div><div class="user-cell"><div class="chat-user-name-message"><div class="user-name-content"><div ng-if="vm.getAttendant(conversation.attendantId)" class="attendant-circle" uib-tooltip="{{vm.getAssignedAttendantTooltip(conversation.attendantId)}}" ng-style="{\'background-color\': vm.getAttendant(conversation.attendantId).userProfiles[0].colorCode}">{{vm.getAttendant(conversation.attendantId).firstName[0] | capitalize}}</div><i ng-if="vm.getAttendant(conversation.attendantId)" class="fa fa-angle-right attendant-attribution" aria-hidden="true"></i><div class="user-name">{{conversation.name}}</div><span class="fa fa-star" ng-class="conversation.isFavorite ? \'favorite-filled\' : \'favorite\'" ng-click="$event.stopPropagation(); vm.changeIsFavorite(conversation)" style="cursor:pointer"></span></div><div class="chat-time">{{vm.getMessageDayLabel(conversation.lastMessageDate)}}</div></div><div class="chat-user-time-status" style="justify-content: flex-start; align-items: flex-end"><p class="user-message" uib-tooltip="{{conversation.lastMessage}}" tooltip-popup-delay="500" ng-if="conversation.messageType == \'text\'\n                                                  || conversation.messageType === \'template\'">{{conversation.lastMessage}}</p><p class="user-message" ng-if="conversation.messageType != \'text\'\n                                            && conversation.messageType != \'template\'">Esta mensagem \xE9 um arquivo de m\xEDdia</p><div><p class="numberCircle numberCircle-conversation" ng-if="conversation.unreadMessages > 0">{{conversation.unreadMessages}}</p></div><div class="dropdown conversation-status"><button aria-expanded="false" aria-haspopup="true" class="btn btn-select-status dropdown-toggle" id="dropdownMenuButtonOpt-{{$index}}" ng-click="$event.stopPropagation(); vm.openDropdownStatus($index)" ng-disabled="conversation.status == \'EXPIRED\'" style="display: flex; justify-content: space-between; padding-right: 0px !important; padding-top: 0px !important; -webkit-box-shadow: none; box-shadow:none" type="button"><span class="badge-ticket" ng-class="{\n                                                \'bg-green\': conversation.status == \'NEW\',\n                                                \'bg-red\': conversation.status == \'OPENED\',\n                                                \'bg-blue\': conversation.status == \'PENDING\',\n                                                \'bg-grey\': conversation.status == \'RESOLVED\',\n                                                \'bg-purple\': conversation.status == \'EXPIRED\'}" style="margin-top: 5px">{{ vm.status[conversation.status] }} <i class="fa fa-angle-down" ng-if="conversation.status != \'EXPIRED\'"></i></span></button><div aria-labelledby="dropdownMenuButtonOpt" class="dropdown-menu pull-right" style="max-height: 25vh; overflow: auto"><div class="dropdown-item d-flex" ng-click="vm.changeTicketStatus(conversation, \'NEW\', $event)" ng-if="conversation.status !== \'NEW\'" style="padding: 7px 10px !important"><span style="margin-right: 10px"><div class="badge-round bg-green"></div></span>Novo</div><div class="dropdown-item d-flex" ng-click="vm.changeTicketStatus(conversation, \'PENDING\', $event)" ng-if="conversation.status !== \'PENDING\'" style="padding: 7px 10px !important"><span style="margin-right: 10px"><div class="badge-round bg-blue"></div></span>Pendente</div><div class="dropdown-item d-flex" ng-click="vm.changeTicketStatus(conversation, \'RESOLVED\', $event)" ng-if="conversation.status !== \'RESOLVED\'" style="padding: 7px 10px !important"><span style="margin-right: 10px"><div class="badge-round bg-grey"></div></span>Resolvido</div><div class="dropdown-item d-flex" ng-click="vm.changeTicketStatus(conversation, \'OPENED\', $event)" ng-if="conversation.status !== \'OPENED\'" style="padding: 7px 10px !important"><span style="margin-right: 10px"><div class="badge-round bg-red"></div></span>Aberto</div></div></div></div></div></div></div><div style="display: flex; flex-direction: row; padding: 15px 10px 10px 10px; justify-content: center"><message-loading ng-show="vm.conversationsList.length > 0 && vm.loadingMoreConversations"></message-loading></div></div></div></div><div class="col-xs-12 col-md-5 col-lg-6" ng-if="vm.currentConversation.conversationId" ng-class="{\'d-none\': !vm.mobileFlow[\'chatConversation\'] && vm.isMobile }"><div class="ibox-content selected-conversation" style="min-height: 85vh" ng-style="{\'max-height\': vm.conversationHeight}"><div class="conversation-header"><div class="header-content"><div class="header-content-contact-box" ng-if="vm.currentConversation.platform"><div class="back-button" style="align-self: center" ng-if="vm.isMobile" ng-click="vm.goToElement(\'listConversations\')"><i class="fa fa-arrow-left"></i></div><div class="user-image-content" ng-click="vm.isMobile && vm.goToElement(\'customerInfos\')"><img class="profile-pic-bigger" ng-src="{{vm.currentConversation.profilePic ? vm.currentConversation.profilePic : \'./assets/images/avatar.png\'}}"></div><div class="contact-name-container"><div class="contact-name text-ellipsis" ng-click="vm.isMobile && vm.goToElement(\'customerInfos\')">{{vm.currentConversation.name}}</div><div class="dropdown"><button aria-expanded="false" class="btn btn-dropdown dropdown-toggle assign-conversation-text" ng-style="vm.isMobile ? \'font-size: 12px\' : \'\'" data-toggle="dropdown" type="button"><div class="selected-attendant"><div ng-if="vm.currentAttendant" class="attendant-circle" ng-style="{\'background-color\': vm.currentAttendant.userProfiles[0].colorCode}">{{vm.currentAttendant.firstName[0] | capitalize}}</div><span>{{ vm.currentAttendant ? vm.currentAttendant.firstName + \' \' + vm.currentAttendant.lastName : \'Atribuir conversa\' }} </span><i class="fa fa-angle-down"></i></div></button><div class="dropdown-menu assign-menu" id="users-to-assign" role="menu" style="padding: 10px 5px"><a class="dropdown-item" href="#" ng-click="vm.assignConversation(attendant)" ng-repeat="attendant in vm.usersAttendants"><div ng-if="attendant.userProfiles[0].colorCode" class="attendant-circle" ng-style="{\'background-color\': attendant.userProfiles[0].colorCode}">{{attendant.firstName[0] | capitalize}}</div><span>{{attendant.firstName ? attendant.firstName : \'\' }} {{attendant.lastName ? attendant.lastName : \'\' }}</span></a></div></div></div></div><div class="display-flex"><div class="ko-progress-circle" data-progress="{{vm.currentConversation.percentage}}"><div class="ko-circle"><div class="full ko-progress-circle__slice"><div class="ko-progress-circle__fill"></div></div><div class="ko-progress-circle__slice"><div class="ko-progress-circle__fill"></div><div class="ko-progress-circle__fill ko-progress-circle__bar"></div></div></div><div class="ko-progress-circle__overlay"><div class="progress-circular-bar"><span class="time-progress">{{ vm.currentConversation && vm.currentConversation.currentConversationTime ? vm.currentConversation.currentConversationTime : \'0:00\' }}</span></div></div></div></div><div class="header-content-status" ng-if="vm.currentConversation.platform"><div class="dropdown"><button aria-expanded="false" class="btn-dropdown-status dropdown-toggle" data-toggle="dropdown" ng-disabled="vm.currentConversation.status === \'EXPIRED\'" ng-if="!vm.isMobile" ng-style="{\'color\': vm.mainColor}" type="button">Marcar como <i class="fa fa-angle-down" style="margin-left: 5px"></i></button> <button aria-expanded="false" class="btn-dropdown-status dropdown-toggle" data-toggle="dropdown" ng-disabled="vm.currentConversation.status == \'EXPIRED\'" ng-if="vm.isMobile" ng-style="{\'color\': vm.mainColor}" style="font: 20px" type="button"><i class="fa fa-tag"></i></button><div class="dropdown-menu assign-menu dropdown-menu-right-custom" id="change-status" role="menu" style="padding: 10px 5px"><a class="dropdown-item" href="#" ng-click="vm.changeTicketStatus(vm.currentConversation, \'NEW\')" ng-if="vm.currentConversation.status !== \'NEW\'"><span style="margin-right: 10px"><div class="badge-round bg-green"></div></span>Novo </a><a class="dropdown-item" href="#" ng-click="vm.changeTicketStatus(vm.currentConversation, \'PENDING\')" ng-if="vm.currentConversation.status !== \'PENDING\'"><span style="margin-right: 10px"><div class="badge-round bg-blue"></div></span>Pendente </a><a class="dropdown-item" href="#" ng-click="vm.changeTicketStatus(vm.currentConversation, \'RESOLVED\')" ng-if="vm.currentConversation.status !== \'RESOLVED\'"><span style="margin-right: 10px"><div class="badge-round bg-grey"></div></span>Resolvido </a><a class="dropdown-item" href="#" ng-click="vm.changeTicketStatus(vm.currentConversation, \'OPENED\')" ng-if="vm.currentConversation.status !== \'OPENED\'"><span style="margin-right: 10px"><div class="badge-round bg-red"></div></span>Aberto</a></div></div></div></div></div><div class="conversation-messages" detect-scroll-to-top="vm.messagesScrolledToTop" id="messages-container" ng-style="{\'overflow-y\': !vm.showSkeleton && !vm.loadingMessages ? \'auto\' : \'hidden\'}"><div style="padding: 15px 10px 10px 10px"><message-loading ng-show="vm.openedMessages.length > 0 && vm.loadingMoreMessages"></message-loading></div><chat-skeleton has-icon="true" ng-show="vm.showSkeleton && vm.loadingMessages"></chat-skeleton><div style="min-height: -webkit-fill-available"><div class="content-message" detect-last-interation style="cursor: auto" ng-class="{\'content-message-owner\': message.owner,\n                                                \'content-message-user\': !message.owner,\n                                                \'content-message-owner-img\': message.owner && message.type  == \'image\',\n                                                \'content-reserved\': message.type == \'RESERVED\',\n                                                \'message-selection-active\': vm.selectMultipleMessages && message.type !== \'RESERVED\',\n                                                \'message-selected\': vm.checkIfMessageSelected(message)}" ng-repeat="message in vm.openedMessages" ng-click="vm.updateMessagesToForward(message)"><div class="select-messages-checkbox form-group" ng-if="vm.selectMultipleMessages && message.type !== \'RESERVED\'"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-disabled="!vm.checkIfMessageSelected(message) && vm.selectedMessages.length === 30" ng-checked="vm.checkIfMessageSelected(message)" ng-click="vm.updateMessagesToForward(message)"> <span class="checkbox-material"><span class="check"></span></span></label></div></div><div class="row date-container" ng-if="message.type === \'RESERVED\'"><div class="date-info"><span dir="auto">{{message.value}}</span></div></div><div class="profile-img-message-container" ng-if="message.type == \'document\'" ng-class="{\'pressable-element\': vm.isMobile}" message-long-press time-out="600" message="message" ng-mouseover="message.showOptions = true;" ng-mouseleave="message.showOptions = false"><div ng-if="!message.owner"><img class="profile-pic-smaller" ng-src="{{vm.currentConversation.profilePic ? vm.currentConversation.profilePic : \'./assets/images/avatar.png\'}}"></div><div class="rounded-box-not-owner" ng-if="!message.owner" style="margin: 10px 10px 0 0"><message-options ng-if="!vm.selectMultipleMessages && vm.currentConversation.platform === \'WATI\'" message="message" apply-option="vm.applyOption(option, message)"></message-options><div class="message-file-container"><i class="fa fa-file{{message.data.split(\'.\')[1] === \'pdf\' ? \'-pdf-o\' : \'\'}} file-icon" aria-hidden="true"></i> <span class="mb-0">{{message.text ? message.text : message.data.split(\'/data/documents/\')[1] | messageTextFormat}}</span><div ng-if="message.loadingDownload" class="sk-container"><message-loading size="40" margin="5"></message-loading></div><button ng-if="!message.loadingDownload" class="btn btn-primary btn-download-document" ng-click="vm.downloadDocument(message)" style="margin: 5px" ng-disabled="message.loadingDownload"><i class="fa fa-{{message.downloadedData ? \'external-link\' : \'download\'}}"></i></button></div><div class="message-time-container"><span class="message-time-spacing"></span> <span class="message-time">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span></div></div><div class="rounded-box-owner" ng-if="message.owner" style="margin-top: 10px"><message-options ng-if="!vm.selectMultipleMessages\n                                                    && vm.currentConversation.platform === \'WATI\'\n                                                    && !message.loadingDownload" message="message" apply-option="vm.applyOption(option, message)"></message-options><div class="message-file-container"><i ng-if="!message.failedToSend" class="fa fa-file{{message.data.split(\'.\')[1] === \'pdf\' ? \'-pdf-o\' : \'\'}} file-icon" aria-hidden="true"></i> <i ng-if="message.failedToSend" aria-hidden="true" class="fa fa-exclamation-circle file-icon" uib-tooltip="N\xE3o foi poss\xEDvel enviar a mensagem." tooltip-placement="left" style="color: red"></i> <span class="mb-0">{{message.text ? message.text : message.data.split(\'/data/documents/\')[1]}}</span> <button ng-if="message.failedToSend && !message.loadingDownload" class="btn btn-primary btn-download-document" ng-click="vm.retrySendMediaMessageToWhatsapp(message)" style="margin: 5px"><i class="fa fa-upload" aria-hidden="true"></i></button><div ng-if="!message.failedToSend" class="ml-auto"><div ng-if="message.loadingDownload" class="sk-container" style="position: relative; color: gray"><i class="icon-ksc-arrows-rotate-light animate-spin" style="font-size: 3.2em"></i> <span ng-if="message.sendingProgress || message.sendingProgress === 0" style="position: absolute; top: 15px; right: 17px; font-size: .7em;\n                                                                    font-weight: 600; width: 25px; text-align: center">{{message.sendingProgress}}%</span></div><button ng-if="!message.loadingDownload" class="btn btn-primary btn-download-document" ng-click="vm.downloadDocument(message)" style="margin: 5px" ng-disabled="message.loadingDownload"><i class="fa fa-{{message.downloadedData ? \'external-link\' : \'download\'}}" ng-if="!message.loadingDownload"></i></button></div></div><div class="bg-primary p-xs b-r-lg owner mb-0" ng-if="message.owner" style="box-shadow: none"><div class="message-time-container"><span class="message-time-spacing"></span> <span class="message-time">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span> <i ng-if="message.sendingProgress < 100 && !message.failedToSend" class="icon-ksc-clock" style="font-size: 0.8em; color: #667781"></i></div></div></div><div ng-if="message.owner"><img class="profile-pic-smaller" ng-src="{{vm.currentStore.logo !== undefined ? vm.currentStore.logo : \'./assets/images/avatar.png\'}}"></div></div><div class="profile-img-message-container" ng-if="message.type == \'contacts\'" ng-mouseover="message.showOptions = true;" ng-mouseleave="message.showOptions = false"><div ng-if="!message.owner"><img class="profile-pic-smaller" ng-src="{{vm.currentConversation.profilePic ? vm.currentConversation.profilePic : \'./assets/images/avatar.png\'}}"></div><div class="rounded-box-not-owner" ng-if="!message.owner" style="margin: 10px 10px 0 0"><message-options ng-if="!vm.selectMultipleMessages && vm.currentConversation.platform === \'WATI\'" message="message" apply-option="vm.applyOption(option, message)"></message-options><message-contact message="message"></message-contact></div><div class="rounded-box-owner" ng-if="message.owner" style="margin-top: 10px"><message-options ng-if="!vm.selectMultipleMessages && vm.currentConversation.platform === \'WATI\'" message="message" apply-option="vm.applyOption(option, message)"></message-options><message-contact message="message"></message-contact></div><div ng-if="message.owner"><img class="profile-pic-smaller" ng-src="{{vm.currentStore.logo !== undefined ? vm.currentStore.logo : \'./assets/images/avatar.png\'}}"></div></div><div class="profile-img-message-container" ng-if="message.type == \'file\' && message.platform !== \'WATI\'"><div ng-if="!message.owner"><img class="profile-pic-smaller" ng-src="{{vm.currentConversation.profilePic ? vm.currentConversation.profilePic : \'./assets/images/avatar.png\'}}"></div><div class="message-file-container"><i class="fa fa-file{{message.data.split(\'.\')[1] === \'pdf\' ? \'-pdf\' : \'\'}}-o file-icon" aria-hidden="true"></i> <span class="mb-0">{{message.text ? message.text : message.data.split(\'/data/documents/\')[1]}}</span> <a class="btn btn-primary btn-download-document" download href="{{message.data}}" style="margin: 10px; padding-top: 10px"><i class="fa fa-download"></i></a></div><div class="bg-primary p-xs b-r-lg owner mb-0" ng-if="message.owner" style="box-shadow: none"><div class="message-time-container"><span class="message-time-spacing"></span> <span class="message-time">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span> <i ng-if="message.isSending" class="icon-ksc-clock" style="font-size: 0.8em; color: #667781"></i></div></div><div ng-if="message.owner"><img class="profile-pic-smaller" ng-src="{{vm.currentStore.logo !== undefined ? vm.currentStore.logo : \'./assets/images/avatar.png\'}}"></div></div><div ng-style="!message.owner && {\'display\': \'flex\', \'flex-direction\': \'column\'}" ng-if="!message.owner"><div class="profile-img-message-container" style="margin-top: 10px; max-width: 100%" ng-if="(message.type == \'video\' || message.type == \'image\' || message.type == \'audio\') && !message.owner"><div><img class="profile-pic-smaller" ng-src="{{vm.currentConversation.profilePic ? vm.currentConversation.profilePic : \'./assets/images/avatar.png\'}}"></div><div ng-if="message.type == \'audio\'" ng-class="{\'pressable-element\': vm.isMobile, \'loading-audio\': message.loadingDownload}" message-long-press time-out="600" message="message" ng-mouseover="message.showOptions = true;" ng-mouseleave="message.showOptions = false" class="bg-primary p-xs b-r-lg user" style="margin-top: 10px; max-width: 90%; position: relative"><div ng-if="message.loadingDownload" class="sk-container" style="position: absolute; left: 22px; top: 22px; z-index: 1"><message-loading size="20" margin="5"></message-loading></div><message-options ng-if="!vm.selectMultipleMessages && vm.currentConversation.platform === \'WATI\'" message="message" apply-option="vm.applyOption(option, message)"></message-options><quoted-message-container ng-if="message.replySourceMessage" reply-source-message="message.replySourceMessage" message-owner-name="vm.currentConversation.name"></quoted-message-container><audio controls id="{{message.id}}" class="audio-container mb-0" controlslist="novolume" style="max-width: 100%"><source src="message.data">Your browser does not support HTML5 audio.</audio><div class="message-time-container message-time-audio-container w-100"><span class="message-time pull-right">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span></div></div><div class="rounded-box-not-owner" ng-class="{\'pressable-element\': vm.isMobile}" message-long-press time-out="600" message="message" ng-mouseover="message.showOptions = true;" ng-mouseleave="message.showOptions = false" ng-if="message.type == \'image\'"><message-options ng-if="!vm.selectMultipleMessages && vm.currentConversation.platform === \'WATI\'" message="message" apply-option="vm.applyOption(option, message)"></message-options><quoted-message-container ng-if="message.replySourceMessage" reply-source-message="message.replySourceMessage" message-owner-name="vm.currentConversation.name"></quoted-message-container><div><img alt="" class="owner-img chat-image-not-owner" ng-click="vm.openFullScreenPreview(message)" src="{{message.data}}" ng-class="{\'pressable-element\': vm.isMobile}"><div ng-if="!message.text" class="message-time-container" style="margin: 10px 0 -5px 4px !important"><span class="message-time-spacing"></span> <span class="message-time" style="float: right">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span></div></div><div class="bg-primary p-xs b-r-lg user" ng-if="!message.owner && message.text && message.text !== null && message.text !== \'\' "><div><span class="message-text" ng-bind-html="message.text | parseUrl | messageTextFormat"></span> <span class="message-time-spacing"></span></div><div class="message-time-container"><span class="message-time">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span></div></div></div><div class="rounded-box-not-owner" ng-class="{\'pressable-element\': vm.isMobile}" message-long-press time-out="600" message="message" ng-mouseover="message.showOptions = true;" ng-mouseleave="message.showOptions = false" ng-if="message.storyType == \'video\' || message.type == \'video\'" ng-style="!message.owner && {\'display\': \'flex\', \'flex-direction\': \'column\'}"><message-options ng-if="!vm.selectMultipleMessages && vm.currentConversation.platform === \'WATI\'" message="message" apply-option="vm.applyOption(option, message)"></message-options><div style="display: flex; flex-direction: column; align-items: center; justify-content: center" ng-click="$event.stopPropagation(); vm.openFullScreenPreview(message, $event)"><video alt="" class="owner-img story-reponse-video m-0" ng-class="{\'pressable-element\': vm.isMobile}" style="width: 100% !important"><source src="{{message.data}}" type="video/mp4"></video><i class="fa fa-play-circle-o play-icon" aria-hidden="true"></i></div><span class="message-text" ng-if="message.text" ng-bind-html="message.text | parseUrl | messageTextFormat" style="padding: 10px"></span><div class="message-time-container" style="margin: 0px 0 -5px 4px !important"><span class="message-time-spacing"></span> <span class="message-time" style="float: right">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span></div></div></div></div><div class="profile-img-message-container-owner" ng-class="{\'pressable-element\': vm.isMobile, \'loading-audio\': message.loadingDownload}" message-long-press time-out="600" message="message" ng-mouseover="message.showOptions = true;" ng-mouseleave="message.showOptions = false" ng-if="message.owner && message.type == \'audio\' && message.statusString != \'FAILED\'"><div class="rounded-box-owner owner" style="max-width: 90%;margin-top: 10px;position: relative"><div ng-if="message.loadingDownload" class="sk-container" style="position: absolute; left: 22px; top: 22px; z-index: 1"><message-loading size="20" margin="5"></message-loading></div><message-options ng-if="!vm.selectMultipleMessages && vm.currentConversation.platform === \'WATI\'" message="message" apply-option="vm.applyOption(option, message)"></message-options><quoted-message-container ng-if="message.replySourceMessage" reply-source-message="message.replySourceMessage" message-owner-name="vm.currentConversation.name"></quoted-message-container><audio controls id="{{message.id}}" class="mb-0" controlslist="novolume" style="margin-top: 5px; max-width: 100%"><source src="{{message.data}}"></audio><div class="message-time-container display-horizontally-inline inline-end message-time-audio-container w-100"><span class="message-time">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span> <i ng-if="message.loading" class="message-time icon-ksc-clock-regular" aria-hidden="true"></i></div></div><img class="profile-pic-smaller-owner" ng-src="{{vm.currentStore.logo !== undefined ? vm.currentStore.logo : \'./assets/images/avatar.png\'}}"></div><div class="profile-img-message-container-owner" ng-if="message.owner && (message.type == \'image\' || message.type == \'video\')" style="margin-top: 10px"><div ng-if="message.failedToSend" style="position: absolute;\n                                                right: 0;\n                                                top: 60px"><i aria-hidden="true" class="fa fa-exclamation-circle file-icon" uib-tooltip="{{vm.getFailedMessageError(message)}}" tooltip-placement="left" style="color: red"></i></div><div class="rounded-box-owner" ng-class="{\'pressable-element\': vm.isMobile}" message-long-press time-out="600" message="message" ng-mouseover="message.showOptions = true;" ng-mouseleave="message.showOptions = false" ng-if="message.type == \'image\' || message.type == \'video\'"><message-options ng-if="!vm.selectMultipleMessages && vm.currentConversation.platform === \'WATI\' && !message.failedToSend" message="message" apply-option="vm.applyOption(option, message)"></message-options><div ng-if="message.type == \'image\'"><img alt="" class="owner-img chat-image-owner" ng-class="{\'pressable-element\': vm.isMobile}" ng-click="vm.openFullScreenPreview(message)" src="{{message.data}}"><div ng-if="!message.text" class="message-time-container" style="margin: 10px 0 -5px 4px !important"><span class="message-time-spacing"></span> <span class="message-time" style="float: right">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span> <i ng-if="message.isSending" class="icon-ksc-clock" style="font-size: 0.8em; color: #667781"></i></div></div><div ng-if="message.type == \'video\'" style="display: flex; flex-direction: column; align-items: center; justify-content: center" ng-click="$event.stopPropagation(); vm.openFullScreenPreview(message, $event)"><video alt="" class="owner-img story-reponse-video m-0" style="width: 100% !important"><source src="{{message.data}}" type="video/mp4"></video><i class="fa fa-play-circle-o play-icon" ng-if="!message.failedToSend" aria-hidden="true"></i><div class="video-failed-content" ng-if="message.failedToSend"><i class="fa fa-ban" style="color: #000000; font-size: 5em" aria-hidden="true"></i></div><div ng-if="!message.text" class="message-time-container" style="margin: 10px 0 -5px 4px !important"><span class="message-time-spacing"></span> <span class="message-time" style="float: right">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span> <i ng-if="message.isSending" class="icon-ksc-clock" style="font-size: 0.8em; color: #667781"></i></div></div><div class="bg-primary p-xs b-r-lg img-description" ng-if="message.owner && message.text && message.text !== null && message.text !== \'\' "><div><span class="message-text" style="float: left" ng-bind-html="message.text | parseUrl | messageTextFormat"></span> <span class="message-time-spacing"></span></div><div class="message-time-container"><span class="message-time">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span> <i ng-if="message.isSending" class="icon-ksc-clock" style="font-size: 0.8em; color: #667781"></i></div></div></div><div><img class="profile-pic-smaller" ng-src="{{vm.currentStore.logo !== undefined ? vm.currentStore.logo : \'./assets/images/avatar.png\'}}"></div></div><div class="profile-message-container" ng-if="message.type == \'unsupported\'"><div ng-if="!message.owner"><img class="profile-pic-smaller" ng-src="{{vm.currentConversation.profilePic ? vm.currentConversation.profilePic : \'./assets/images/avatar.png\'}}"></div><div ng-class="\'bg-primary p-xs b-r-lg user\'" ng-if="!message.owner" style="align-items: center">{{message.text | messageTextFormat}}<i aria-hidden="true" class="fa fa-exclamation-circle" style="color: red"></i></div><div ng-class="\'bg-primary p-xs b-r-lg owner\'" ng-if="message.owner" style="align-items: center"><i aria-hidden="true" class="fa fa-exclamation-circle" style="color: red; margin-right: 20px"></i>{{message.text | messageTextFormat}}</div><div ng-if="message.owner"><img class="profile-pic-smaller-owner" ng-src="{{vm.currentStore.logo !== undefined ? vm.currentStore.logo : \'./assets/images/avatar.png\'}}"></div></div><div class="profile-message-container" ng-if="message.owner && message.type == \'text\'" ng-class="{\'pressable-element\': vm.isMobile}" message-long-press time-out="600" message="message" ng-mouseover="message.showOptions = true;" ng-mouseleave="message.showOptions = false"><!-- please, don\'t break this line --><div ng-if="message.failedToSend" style="position: absolute;\n                                                right: 0;\n                                                bottom: 60px"><i aria-hidden="true" class="fa fa-exclamation-circle file-icon" uib-tooltip="Ocorreu um erro ao tentar enviar sua mensagem." tooltip-placement="left" style="color: red"></i></div><div class="bg-primary p-xs b-r-lg owner" ng-if="message.owner && (message.type == \'text\' || message.type == \'location\')"><message-options ng-if="!vm.selectMultipleMessages && vm.currentConversation.platform === \'WATI\'" message="message" apply-option="vm.applyOption(option, message)"></message-options><quoted-message-container ng-if="message.replySourceMessage" reply-source-message="message.replySourceMessage" message-owner-name="vm.currentConversation.name"></quoted-message-container><message-referral ng-if="message.messageReferral" value="message.messageReferral"></message-referral><div><span class="message-text" ng-bind-html="message.text | parseUrl | messageTextFormat"></span> <span class="message-time-spacing"></span></div><div class="message-time-container"><span class="message-time">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span> <i ng-if="message.isSending" class="icon-ksc-clock" style="font-size: 0.8em; color: #667781"></i></div></div><div><img class="profile-pic-smaller-owner" ng-src="{{vm.currentStore.logo !== undefined ? vm.currentStore.logo : \'./assets/images/avatar.png\'}}"></div></div><div class="profile-message-container" ng-if="!message.owner && (message.type == \'text\' || message.type == \'location\')" ng-class="{\'pressable-element\': vm.isMobile}" message-long-press time-out="600" message="message" ng-mouseover="message.showOptions = true;" ng-mouseleave="message.showOptions = false"><img class="profile-pic-smaller" ng-src="{{vm.currentConversation.profilePic ? vm.currentConversation.profilePic : \'./assets/images/avatar.png\'}}"><!-- please, don\'t break this line --><div class="bg-primary p-xs b-r-lg user" ng-if="!message.owner && (message.type == \'text\' || message.type == \'location\')"><message-options ng-if="!vm.selectMultipleMessages && vm.currentConversation.platform === \'WATI\'" message="message" apply-option="vm.applyOption(option, message)"></message-options><quoted-message-container ng-if="message.replySourceMessage" reply-source-message="message.replySourceMessage" message-owner-name="vm.currentConversation.name"></quoted-message-container><message-referral ng-if="message.messageReferral" value="message.messageReferral"></message-referral><div><span class="message-text" ng-bind-html="message.text | parseUrl | messageTextFormat"></span> <span class="message-time-spacing"></span></div><div class="message-time-container"><span class="message-time">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span></div></div></div><message-container ng-if="message.type == \'story_mention\' || message.type == \'story_reply\'\n                                            || message.type == \'broadcastMessage\' || message.type == \'order\'" message="message" current-conversation="vm.currentConversation" current-customer="vm.currentCustomer"></message-container><div class="profile-message-container" ng-if="!message.owner && message.type == \'sticker\'" ng-class="{\'pressable-element\': vm.isMobile}" message-long-press time-out="600" message="message" ng-mouseover="message.showOptions = true;" ng-mouseleave="message.showOptions = false"><div><img class="profile-pic-smaller" ng-src="{{vm.currentConversation.profilePic ? vm.currentConversation.profilePic : \'./assets/images/avatar.png\'}}"></div><div class="bg-primary p-xs b-r-lg user-sticker" ng-if="!message.owner && message.type == \'sticker\'"><img alt="" src="{{message.api}}" ng-class="{\'pressable-element\': vm.isMobile}" style="width: 100%; height: 100%"><message-options ng-if="!vm.selectMultipleMessages && vm.currentConversation.platform === \'WATI\'" message="message" apply-option="vm.applyOption(option, message)"></message-options><div class="message-time-container" style="margin-top: auto"><span class="message-time">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span></div></div></div><div class="profile-message-container" ng-if="message.owner && message.type == \'sticker\'" ng-class="{\'pressable-element\': vm.isMobile}" message-long-press time-out="600" message="message" ng-mouseover="message.showOptions = true;" ng-mouseleave="message.showOptions = false"><div class="bg-primary p-xs b-r-lg owner-sticker" ng-if="message.owner && message.type == \'sticker\'"><img alt="" ng-class="{\'pressable-element\': vm.isMobile}" src="{{message.api}}"><message-options ng-if="!vm.selectMultipleMessages && vm.currentConversation.platform === \'WATI\'" message="message" apply-option="vm.applyOption(option, message)"></message-options><div class="message-time-container" style="margin-top: auto"><span class="message-time">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span> <i ng-if="message.isSending" class="icon-ksc-clock" style="font-size: 0.8em; color: #667781"></i></div></div><div><img class="profile-pic-smaller-owner" ng-src="{{vm.currentStore.logo !== undefined ? vm.currentStore.logo : \'./assets/images/avatar.png\'}}"></div></div><div class="profile-message-container" ng-if="message.type == \'carousel\'"><div class="carousel" data-interval="false" id="slider-{{$index}}" style="margin-left: auto; max-width: 45%"><div class="carousel-inner"><div class="item" ng-class="{active:!$index}" ng-repeat="flyer in message.flyers"><img class="img-responsive" on-error-src="http://admin.showkase.com.br:8080/flyer/api/6136489330c49e00013a4637/picture?type=large&ts=1638197401498" src="/flyer/api/{{flyer.id}}/picture"><p class="product-name text-ellipsis-two-lines" style="text-align: center">{{flyer.name}}</p></div></div><a class="carousel-control left carousel-arrow-div" data-slide="prev" href="#slider-{{$index}}"><i class="fa fa-angle-left carousel-arrow"></i> </a><a carousel-arrow-div class="carousel-control right carousel-arrow-div" data-slide="next" href="#slider-{{$index}}"><i class="fa fa-angle-right carousel-arrow"></i></a></div><div class="m-l-xs"><img class="profile-pic-smaller-owner" ng-src="{{vm.currentStore.logo !== undefined ? vm.currentStore.logo : \'./assets/images/avatar.png\'}}"></div></div></div><div class="no-messages-content" ng-show="vm.isConversationWithoutMessages()"><p class="no-messages">{{vm.noMessagesLabel()}}</p></div></div></div><message-reply class="replying" ng-if="vm.replyMessage" cancel-reply="vm.closeMessageToReply" message-to-reply="vm.messageToReply" message-owner-name="vm.currentConversation.name"></message-reply><div ng-if="!vm.selectMultipleMessages" ng-class="{\'color-text-location\' : vm.isSendLocation}" class="conversation-input-message" style="display: flex; margin-left: 5px; align-items: center"><div ng-if="!vm.recording" style="font-size: 1.3em; color: #9a9a9a"><button aria-expanded="false" class="btn btn-default btn-xs action-message-btn p-0" id="btn-open-feedback" ng-click="vm.openFeedbackPopUp()" ng-disabled="vm.hasLoadingActive()"><i class="icon-ksc-plus-circle-regular"></i></button><div ng-class="{\'bottom-sheet-container\' : vm.isMobile, \'bottom-sheet-container-desktop\': !vm.isMobile}" id="bottom-sheet" ng-click="vm.closeFeedbackPopUp()"></div><div class="bottom-sheet-body" ng-class="{\'desktop\': !vm.isMobile, \'mobile\': vm.isMobile}" id="sheet-body"><label class="upload-file-label" for="image-upload-sheet" ng-style="vm.currentConversation.status === \'EXPIRED\' ?\n                                                       { \'cursor\': \'not-allowed\', \'color\': \'#dcdcdc\'} : {\'cursor\': \'pointer\'}"><i class="icon-ksc-image-light sheet-option-icon"></i> Fotos <input class="d-none file-button" id="image-upload-sheet" value="" ng-disabled="vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()" ng-upload-change="vm.onSelectImages($event)" multiple="multiple" style="display: none" accept="{{vm.supportedImagesType}}" type="file"></label><label class="upload-file-label" for="file-upload-sheet" ng-click="vm.attachFile()" ng-style="vm.currentConversation.status === \'EXPIRED\' ?\n                                                       { \'cursor\': \'not-allowed\', \'color\': \'#dcdcdc\'} : {\'cursor\': \'pointer\'}"><i class="icon-ksc-paperclip-regular sheet-option-icon"></i> Anexo <input class="d-none file-button" id="file-upload-sheet" ng-disabled="vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()" ng-upload-change="vm.onSelectFile($event)" style="display: none" accept="{{vm.supportedFilesType}}" type="file"></label><div class="btn-group dropup sticker-dropup w-100" ng-if="vm.currentConversation.platform == \'WATI\'"><a class="btn btn-default action-message-btn w-100" data-toggle="dropdown" href="#" ng-class="{\'action-message-btn-deactivated\' : vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()}" ng-style="vm.currentConversation.status === \'EXPIRED\' ?\n                                                           { \'cursor\': \'not-allowed\', \'pointer-events\': \'none\', \'color\': \'#dcdcdc\'} : {\'cursor\': \'pointer\'}"><i class="icon-ksc-sticker-regular sheet-option-icon"></i> Figurinhas</a><div class="dropdown-menu" detect-scroll-to-bottom="vm.stickersScrolledToBottom" id="sticker-container" x-placement="top-start"><div class="iboxe-content stickers-container"><div class="single-sticker" ng-click="vm.sendStickerMessage(sticker); $event.stopPropagation();" ng-repeat="sticker in vm.stickers"><img alt="" class="sticker" src="{{sticker.api}}"></div></div></div></div><a class="btn btn-default btn-xs dropdown-toggle action-message-btn w-100" href="#" ng-class="{\'action-message-btn-deactivated\' : vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()}" ng-click="vm.openChatInvoiceNew(); vm.closeFeedbackPopUp()" ng-style="vm.currentConversation.status === \'EXPIRED\' ?\n                                                       { \'cursor\': \'not-allowed\', \'pointer-events\': \'none\', \'color\': \'#dcdcdc\'} : {\'cursor\': \'pointer\'}"><i class="icon-ksc-shopping-cart-regular sheet-option-icon"></i> Criar Pedido <span class="Badge Badge--news Badge--small"><i class="Badge-icon icon-star" tooltip-placement="top" uib-tooltip="Temos novidades"></i> </span></a><a class="btn btn-default btn-xs dropdown-toggle action-message-btn w-100" href="#" ng-class="{\'action-message-btn-deactivated\' : vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()}" ng-click="vm.openTemplateMessageModal();" ng-style="vm.currentConversation.status === \'EXPIRED\' ?\n                                                       { \'cursor\': \'not-allowed\', \'pointer-events\': \'none\', \'color\': \'#dcdcdc\'} : {\'cursor\': \'pointer\'}"><i class="icon-ksc-quick-message-regular sheet-option-icon"></i> Mensagens R\xE1pidas </a><a class="btn btn-default action-message-btn" href="#" ng-class="{\'action-message-btn-deactivated\' : vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()}" ng-click="vm.openMagicModal(); vm.closeFeedbackPopUp()" ng-style="vm.currentConversation.status === \'EXPIRED\' ?\n                                                    { \'cursor\': \'not-allowed\', \'pointer-events\': \'none\', \'color\': \'#dcdcdc\'} : {\'cursor\': \'pointer\'}"><i class="icon-ksc-magic-solid sheet-option-icon"></i> Recomendar </a><a class="btn btn-default action-message-btn" href="#" ng-class="{\'action-message-btn-deactivated\' : vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()}" ng-click="vm.openLocationChatModal(); vm.closeFeedbackPopUp()" ng-style="vm.currentConversation.status === \'EXPIRED\' ?\n                                                    { \'cursor\': \'not-allowed\', \'pointer-events\': \'none\', \'color\': \'#dcdcdc\'} : {\'cursor\': \'pointer\'}"><i class="icon-ksc-finaluser-location sheet-option-icon"></i> Localiza\xE7\xE3o</a></div></div><div ng-if="!vm.recording" class="message-input-container" style="position: relative;\n                                        width: 100%;\n                                        display: flex;\n                                        align-items: center;\n                                        justify-content: space-between" ng-class="{\'message-input-disabled\': vm.currentConversation && vm.currentConversation.status === \'EXPIRED\'\n                                           || vm.sendMessageBtnLoading\n                                           || vm.loadingMessages\n                                           || vm.loadingConversations}"><div id="message-input" ng-class="{\'error-message\': vm.text && vm.text.length > 4096}" class="input-text-message" ng-paste="vm.pasteText($event)" ng-keyup="vm.collectText($event)" no-contenteditable ng-keypress="$event.keyCode == 13 && !$event.shiftKey && vm.sendTextMessage($event)" class="form-control message-input" name="message-input" contenteditable="{{ (vm.currentConversation && vm.currentConversation.status === \'EXPIRED\')\n                                           || (vm.currentConversation.hours === 0 && vm.currentConversation.minutes === 0)\n                                           || vm.sendMessageBtnLoading\n                                           || vm.loadingMessages\n                                           || vm.loadingConversations\n                                           || vm.text && vm.text.length > 4096 ? \'false\' : \'plaintext-only\' }}" role="textbox" tabindex="10" data-lexical-editor="true" spellcheck="true" placeholder="Digite sua mensagem"></div><div class="attach-buttons"><div class="btn-group dropup emoji-dropup" ng-show="false"><button aria-expanded="false" class="btn btn-default btn-xs dropdown-toggle action-message-btn" data-toggle="dropdown" ng-class="{\'action-message-btn-deactivated\' : vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()}" ng-disabled="vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()"><i class="icon-ksc-emoji-regular"></i></button><div class="dropdown-menu" id="emoji-container" x-placement="top-start"><div class="emoji-filter"><button class="emoji-filter-btn" ng-class="{\'selected-emoji-filter\' : vm.currentEmojiFilter == \'{{filter.name}}\', \'unselected-emoji-filter\': vm.currentEmojiFilter != \'{{filter.name}}\'}" ng-click="vm.setEmojiFilter(filter.name); $event.stopPropagation();" ng-repeat="filter in vm.emojiFilters" title="{{filter.label}}">{{filter.emoji}}</button></div><div class="search-emoji" ng-if="vm.currentEmojiFilter == \'all\'"><input class="form-control" ng-change="vm.searchEmoji(vm.searchedEmojiWord)" ng-model="vm.searchedEmojiWord" placeholder="Pesquisar emoji"></div><div class="ibox-content emojis-container"><div ng-click="vm.addEmojiToTextBox(emoji.code); $event.stopPropagation();" ng-repeat="(key, emoji) in vm.filteredEmojis"><span class="single-emoji" ng-if="emoji != \'\'">{{emoji.code}}</span></div></div></div></div><div><button class="btn btn-default btn-xs dropdown-toggle action-message-btn" ng-class="{\'action-message-btn-deactivated\' : vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()}" ng-click="vm.openSingleProductsModal()" ng-disabled="vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()"><i class="icon-ksc-tags-solid"></i></button></div><div><button class="btn btn-default btn-xs dropdown-toggle action-message-btn" ng-class="{\'action-message-btn-deactivated\' : vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()}" ng-click="vm.openBagChatModal()" ng-disabled="vm.currentConversation.status === \'EXPIRED\' || vm.hasLoadingActive()"><i class="icon-ksc-bag-solid"></i></button></div></div></div><div ng-if="!vm.loadingMessages && vm.recording && vm.recordingPressed" class="conversation-input-message" style="position: relative; width: 100%; display: flex"><recording-timer style="width: 100%; display: flex"></recording-timer></div><div id="container-send-button-text" style="margin-left: 5px"><button type="button" class="btn btn-primary send-button display-flex" ng-click="vm.sendTextMessage()" ng-if="!vm.showRecordButton() && !vm.recording" style="border-radius: 50% !important; height: 40px; width: 40px; margin-top: 5px" ng-disabled="vm.currentConversation.status == \'EXPIRED\'\n                                            || vm.sendMessageBtnLoading\n                                            || vm.loadingMessages\n                                            || vm.text && vm.text.length > 4096\n                                            || vm.loadingConversations"><i class="fa fa-send" ng-if="!vm.sendMessageBtnLoading"></i><message-loading ng-if="vm.sendMessageBtnLoading"></message-loading></button> <button ng-if="vm.showRecordButton()" type="button" class="btn btn-primary send-button display-flex" ng-click="vm.requestAudioRecordPermissionAndRecord(false)" on-long-press="vm.requestAudioRecordPermissionAndRecord(true)" on-touch-end="vm.stopRecord()" style="border-radius: 50% !important; height: 40px; width: 40px !important; margin-top: 5px" ng-disabled="vm.currentConversation.status == \'EXPIRED\' || vm.sendMessageBtnLoading || vm.text && vm.text.length > 4096"><i class="icon-ksc-microphone-regular" ng-if="!vm.sendMessageBtnLoading"></i><message-loading ng-if="vm.sendMessageBtnLoading"></message-loading></button></div></div><span class="form-invalid-field" ng-if="vm.text && vm.text.length > 4096">A mensagem n\xE3o pode ter mais de 4096 caracteres</span><!-- WHEN RECORDING AUDIO --><div ng-if="!vm.loadingMessages && vm.recording && !vm.recordingPressed" class="conversation-input-message" style="display: flex; margin-left: 5px"><recording-timer style="width: 100%; display: flex"></recording-timer><div id="container-send-button-audio" style="margin-left: 5px; display: flex; gap: 5px"><button type="button" class="btn btn-primary send-button display-flex" ng-click="vm.discardAudio()" style="border-radius: 50% !important; height: 40px; width: 40px !important; margin-top: 5px;\n                                               background: transparent;\n                                               border: 1px solid red"><i class="icon-ksc-trash" style="color: red"></i></button> <button type="button" class="btn btn-primary send-button display-flex" ng-click="vm.sendTextMessage()" style="border-radius: 50% !important; height: 40px !important; width: 40px !important; margin-top: 5px" ng-disabled="vm.currentConversation.status == \'EXPIRED\' || vm.sendMessageBtnLoading || vm.text && vm.text.length > 4096"><i class="fa fa-send" ng-if="!vm.sendMessageBtnLoading"></i><message-loading ng-if="vm.sendMessageBtnLoading"></message-loading></button></div></div><div class="conversation-footer" style="min-height: 40px" ng-if="!vm.recording && vm.selectMultipleMessages"><div class="w-100 footer-selected-messages" id="selection-buttons" ng-if="vm.selectMultipleMessages"><button type="button" class="close mr-1" aria-hidden="true" ng-click="vm.closeMessageSelection()">&times;</button> <span>{{vm.getAmountSelectedMessages()}} </span><a class="btn btn-default action-message-btn forward-message-btn" href="#" ng-class="{\'action-message-btn-deactivated\' : vm.selectedMessages.length === 0 || vm.selectedMessages.length >= 30 || vm.hasLoadingActive()}"><i class="fa fa-mail-forward apply-selection" ng-style="vm.currentConversation.status === vm.selectedMessages.length === 0 || vm.selectedMessages.length > 30 || vm.hasLoadingActive() ?\n                                                    { \'cursor\': \'not-allowed\', \'pointer-events\': \'none\', \'color\': \'#dcdcdc\'} : {\'cursor\': \'pointer\'}" ng-click="vm.openForwardMessagesModal()" aria-hidden="true"></i></a></div><!-- <div class="send-button">\n                                <button type="button" class="btn btn-primary btn-lg" ng-click="vm.sendTextMessage()">\n                                    <i class="fa fa-send"></i>\n                                    Enviar\n                                </button>\n                            </div> --></div><div class="alert alert-warning alert-dismissable error-message-center" ng-if="vm.selectedMessages.length >= 30" style="cursor: auto"><i class="fa fa-exclamation-triangle messages-amount-warning" aria-hidden="true"></i> <span class="messages-amount-warning-label" ng-style="{\'font-size\': !vm.isMobile ? \'14px\' : \'11px\'}">S\xF3 \xE9 poss\xEDvel encaminhar no m\xE1ximo 30 mensagens.</span></div></div></div><div class="col-xs-12 col-md-3 col-lg-3 pl-0 pr-0" ng-if="vm.currentConversation.conversationId" ng-class="{\'d-none\': !vm.mobileFlow[\'customerInfos\'] && vm.isMobile }"><div class="ibox-content contact-information" id="contact-information" style="min-height: 85vh" ng-style="{\'max-height\': vm.conversationHeight}"><div class="sk-container" ng-if="vm.loadingCustomerInfos" style="height: 100%"><chat-contact-info-skeleton></chat-contact-info-skeleton></div><div ng-if="!vm.loadingCustomerInfos" style="display: flex; align-items: center"><div class="back-button" ng-click="vm.goToElement(\'chatConversation\')" ng-if="vm.isMobile"><i class="fa fa-arrow-left"></i></div><div><img class="profile-pic-bigger" ng-src="{{vm.currentConversation.profilePic ? vm.currentConversation.profilePic : \'./assets/images/avatar.png\'}}"></div><div class="contact-name"><div>{{vm.currentConversation.name}}</div><div class="icon-social-medias" ng-if="vm.currentConversation.platform === \'WATI\'"><img alt="" src="/content/images/icon-whatsapp.png"> <span style="color: #66B428">WhatsApp</span><!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">\n                                        <path fill="currentColor"\n                                            d="M12.976 10.092c-.208-.104-1.227-.603-1.417-.672-.19-.069-.329-.103-.467.103-.138.207-.535.672-.656.81-.121.137-.242.155-.45.051-.207-.103-.875-.32-1.667-1.024-.617-.547-1.033-1.223-1.154-1.43-.12-.206-.012-.318.091-.42.094-.093.208-.242.311-.362.104-.12.139-.207.208-.344.069-.138.034-.259-.018-.362-.051-.103-.466-1.119-.639-1.532-.168-.403-.34-.348-.466-.354a8.356 8.356 0 0 0-.398-.008.763.763 0 0 0-.553.258c-.19.207-.725.706-.725 1.722s.743 1.997.846 2.135c.104.137 1.462 2.222 3.542 3.116.495.212.881.34 1.182.434.497.157.95.135 1.306.082.399-.06 1.227-.499 1.4-.981.173-.482.173-.895.12-.981-.05-.086-.19-.138-.396-.241m-3.784 5.14H9.19a6.912 6.912 0 0 1-3.51-.956l-.252-.149-2.61.682.696-2.533-.164-.26a6.824 6.824 0 0 1-1.054-3.653c.001-3.785 3.095-6.864 6.9-6.864 1.842 0 3.574.715 4.876 2.013a6.807 6.807 0 0 1 2.019 4.856c-.002 3.785-3.096 6.865-6.898 6.865m5.87-12.707A8.264 8.264 0 0 0 9.192.104C4.618.104.895 3.809.894 8.362A8.2221 8.2221 0 0 0 2 12.492L.824 16.77l4.4-1.149a8.323 8.323 0 0 0 3.965 1.005h.003c4.574 0 8.297-3.705 8.299-8.258a8.19 8.19 0 0 0-2.429-5.843">\n                                        </path>\n                                    </svg> --></div><div class="icon-social-medias" ng-if="vm.currentConversation.platform === \'INSTAGRAM\'"><img alt="" src="/content/images/icon-instagram.png"> <span class="instagram-text-gradient">Instagram</span></div><div class="icon-social-medias" ng-if="vm.currentConversation.platform === \'MESSENGER\'"><img alt="" src="/content/images/icon-messenger.png"> <span class="messenger-text-gradient">Messenger</span></div></div></div><div class="row" ng-if="!vm.loadingCustomerInfos" ng-if="vm.currentCustomer.id != null" style="margin-top: 20px" ng-style="{\'padding\': vm.isMobile ? \'0 15px\': \'0\' }"><div class="col-xs-12"><md-tabs class="md-indigo md-no-ink-bar-color" md-align-tabs="{{data.bottom ? \'bottom\' : \'top\'}}" md-dynamic-height md-selected="data.selectedIndex"><md-tab id="tab1" md-tab-class="example-selector-tab1"><md-tab-label>{{ \'communication.profile\' | translate }}</md-tab-label><md-tab-body><div class="row"><div class="col-md-12"><div class="about"><div class="header"><label>{{ \'communication.about\' | translate }}</label><a ng-click="vm.toEditMode()" ng-if="!vm.isEditMode" ng-style="{\'color\': vm.mainColor }">{{ \'entity.action.edit\' | translate }}</a></div><div class="infos" id="infos"><form name="vm.editCustomerForm" ng-submit="vm.saveEditCustomer()" novalidate role="form"><div class="row phone mr-0 ml-0" style="display: flex"><div class="col-xs-1 pr-0 pl-0" ng-style="{ \'display\': vm.isEditMode ? \'flex\' : \'\' , \'flex-direction\': vm.isEditMode ? \'row\' : \'\', \'align-items\': vm.isEditMode ? \'center\' : \'\' }"><i class="fa fa-phone contact-type col-xs-2"></i></div><div class="col-xs-10 pr-0 pl-0"><span class="" ng-if="!vm.isEditMode || vm.currentConversation.platform==\'WATI\'">{{ vm.currentCustomer.phone ? (vm.currentCustomer.phone | tel) : (\'communication.no-information\' | translate) }}</span><div ng-if="vm.isEditMode"><div class="row" style="width: 100%; margin-bottom: 10px"><div class="col-xs-12" id="phone-box"><input class="form-control ml-0" id="phone" name="phone" ng-if="vm.isEditMode && vm.currentConversation.platform!=\'WATI\'" ng-model="vm.customerEdit.phone" intl-tel-input></div></div></div></div></div><div class="row fullname mr-0 ml-0" style="display: flex"><div class="col-xs-1 pr-0 pl-0" ng-style="{ \'display\': vm.isEditMode ? \'flex\' : \'\' , \'flex-direction\': vm.isEditMode ? \'row\' : \'\', \'align-items\': vm.isEditMode ? \'center\' : \'\' }"><i class="fa fa-user contact-type col-xs-2"></i></div><div class="col-xs-10 pr-0 pl-0"><span class="" ng-if="!vm.isEditMode">{{ vm.currentCustomer.fullName }}</span><div ng-if="vm.isEditMode"><div class="row" style="width: 100%; margin-bottom: 10px"><div class="col-xs-12"><input class="form-control" class="form-control" id="fullName" name="fullName" ng-maxlength="100" ng-minlength="4" ng-model="vm.customerEdit.fullName" required type="text"><div class="help-block-div" ng-show="vm.editCustomerForm.fullName.$invalid && vm.editCustomerForm.$submitted" style="padding: 0px; margin-left: 25px"><p class="help-block form-invalid-field" data-translate="entity.validation.required" ng-show="vm.editCustomerForm.fullName.$error.required">This field is required.</p><p class="help-block form-invalid-field" data-translate="entity.validation.minlength" ng-show="vm.editCustomerForm.fullName.$error.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" data-translate="entity.validation.maxlength" ng-show="vm.editCustomerForm.fullName.$error.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div></div></div></div><div class="row email mr-0 ml-0" style="display: flex"><div class="col-xs-1 pr-0 pl-0" ng-style="{ \'display\': vm.isEditMode ? \'flex\' : \'\' , \'flex-direction\': vm.isEditMode ? \'row\' : \'\', \'align-items\': vm.isEditMode ? \'center\' : \'\' }"><i class="fa fa-envelope contact-type col-xs-2"></i></div><div class="col-xs-10 pr-0 pl-0"><span class="" ng-if="!vm.isEditMode">{{ vm.currentCustomer.email ? vm.currentCustomer.email : (\'communication.no-information\' | translate ) }}</span><div ng-if="vm.isEditMode"><div class="row" style="width: 100%; margin-bottom: 10px"><div class="col-xs-12"><input class="form-control" id="email" name="email" ng-if="vm.isEditMode" ng-maxlength="100" ng-model="vm.customerEdit.email" ng-pattern=\'/^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$/i\' placeholder="E-mail" type="email"><div class="help-block-div" ng-show="vm.editCustomerForm.email.$invalid && vm.editCustomerForm.$submitted" style="padding: 0px; margin-left: 25px"><p class="help-block form-invalid-field" data-translate="global.messages.validate.email.invalid" ng-show="vm.editCustomerForm.$error.pattern">Please input a valid email.</p><p class="help-block form-invalid-field" data-translate="entity.validation.maxlength" ng-show="vm.editCustomerForm.email.$error.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div></div></div></div><div class="row birthdate mr-0 ml-0" style="display: flex"><div class="col-xs-1 pr-0 pl-0" ng-style="{ \'display\': vm.isEditMode ? \'flex\' : \'\' , \'flex-direction\': vm.isEditMode ? \'row\' : \'\', \'align-items\': vm.isEditMode ? \'center\' : \'\' }"><i class="fa fa-birthday-cake contact-type col-xs-2" ng-style="{\'color\' : customer.birthdayWeek ? $rootScope.mainColor : \'\'}"></i></div><div class="col-xs-10 pr-0 pl-0"><span class="" ng-if="!vm.isEditMode">{{vm.currentCustomer.birthdate ? (vm.currentCustomer.birthdate | amUtc | amDateFormat:\'DD/MM/YYYY\') : (\'communication.no-information\' | translate )}}</span><div ng-if="vm.isEditMode"><div class="row" style="width: 100%; margin-bottom: 10px"><div class="col-xs-12"><input autocomplete="off" class="form-control inputDate external-control col-xs-11" name="dateOfBirth" ng-if="vm.isEditMode" ng-model="vm.customerEdit.birthdate" placeholder="{{\'global.form.dateOfBirth\' | translate}}" type="text" ui-mask="{{vm.maskLocale}}" ui-mask-placeholder></div></div></div></div></div><div class="row address mr-0 ml-0" style="display: flex"><div class="col-xs-1 pr-0 pl-0" ng-style="{ \'display\': vm.isEditMode ? \'flex\' : \'\' , \'flex-direction\': vm.isEditMode ? \'row\' : \'\' }"><i class="fa fa-home contact-type col-xs-2"></i></div><div class="col-xs-10 pr-0 pl-0"><span class="" ng-if="!vm.isEditMode">{{ vm.addressFormat() }}</span><div ng-if="vm.isEditMode"><div class="row" style="width: 100%; margin-bottom: 10px"><div class="col-xs-12"><input class="form-control" id="zipcode" name="zipcode" ng-change="vm.checkCEP()" ng-model="vm.customerEdit.zipcode" placeholder="{{\'global.form.zipcode\' | translate}}" type="text" ui-mask="99999-999"></div></div><div class="row" style="margin-bottom: 10px; width: 100%"><div class="col-xs-12"><input class="form-control" id="addressNumber" name="addressNumber" ng-model="vm.customerEdit.addressNumber" placeholder="{{\'global.form.number\' | translate}}" type="text"></div></div><div class="row" style="margin-bottom: 10px; width: 100%"><div class="col-xs-12"><input placeholder="{{\'global.form.address\' | translate}}" class="form-control" class="form-control" id="address" name="address" ng-maxlength="100" ng-model="vm.customerEdit.address" type="text"></div></div><div class="row" style="margin-bottom: 10px; width: 100%"><div class="col-xs-12"><input placeholder="{{\'global.form.city\' | translate}}" class="form-control" class="form-control" id="city" name="city" ng-maxlength="50" ng-model="vm.customerEdit.city" type="text"></div></div><div class="row" style="margin-bottom: 10px; width: 100%"><div class="col-xs-12"><input placeholder="{{\'global.form.state\' | translate}}" class="form-control" class="form-control" id="state" name="state" ng-maxlength="50" ng-model="vm.customerEdit.state" type="text"></div></div></div></div></div><div class="row" id="about-buttons" ng-if="vm.isEditMode" style="display: flex; justify-content: end; padding: 0px 20px;margin-top: 10px"><button class="btn-cancelar" ng-click="vm.cancelEditMode()" style="margin-right: 10px" type="button">{{ \'global.messages.remove.cancel\' | translate }}</button> <button ng-disabled="vm.editCustomerForm.$invalid" ng-style="{\'background-color\': vm.mainColor, \'color\': \'#fff\' }" type="submit">{{ \'communication.update\' | translate }}</button></div></form></div></div></div></div><div class="tags"><div class="tags-header"><h2 style="font-weight: 500; font-size: 18px; margin-top: 25px">{{ \'communication.tags\' | translate }}</h2></div><div class="add-tag"><input class="form-control form-control-lg" ng-keyup="$event.keyCode == 13 && vm.addNoteTag(vm.newTagText, true)" ng-model="vm.newTagText" placeholder="Adicionar etiqueta..." type="text"></div><div class="row ml-0 mr-0"><div class="col-xs-12"><span class="custom-tag" ng-repeat="tag in vm.tags">{{ tag.text }} <i class="fa fa-times" ng-click="vm.deleteNoteTag(tag.id, true)"></i></span></div></div></div><div class="notes"><div class="notes-header"><h2 style="font-weight: 500; font-size: 18px; margin-top: 25px">{{ \'communication.notes\' | translate }}</h2><button class="add-note-btn" ng-click="vm.startWritingNote(false)" ng-if="!vm.isEditingNote">+Adicionar</button></div><div class="add-note" ng-if="vm.isWritingNote"><textarea class="form-control form-control-lg" ng-model="vm.newNoteText" placeholder="Adicionar nota..." style="height: 70px" type="text"></textarea><div class="cancel-save-note-button" style="margin-top: 5px"><button class="btn cancel-button" class="btn cancel-button" ng-click="vm.stopWritingNote()" ng-click="vm.stopWritingNote()" style="margin-right: 10px">{{ \'global.messages.remove.cancel\' | translate }}</button> <button class="btn btn-primary" ng-click="vm.addNoteTag(vm.newNoteText, false)" ng-if="!vm.isEditingNote" type="button">{{ \'entity.action.save\' | translate }}</button> <button class="btn btn-primary btn-lg btn-save-note" ng-click="vm.addNoteTag(vm.newNoteText, false)" ng-if="vm.isEditingNote" type="button">{{ \'communication.update\' | translate }}</button></div></div><div class="notes-list"><div class="note" ng-repeat="note in vm.notes"><div class="note-header"><span style="color: #b3b3b3">{{note.timestamp}}</span><div class="note-btns"><i class="fa fa-trash" ng-click="vm.deleteNoteTag(note.id, false)"></i> <i class="fa fa-edit" ng-click="vm.startWritingNote(true, note.id, $index)"></i></div></div><span class="label note-text">{{note.text}}</span></div></div></div></md-tab-body></md-tab><md-tab id="tab2" md-tab-class="example-selector-tab1"><md-tab-label>{{ \'communication.habits\' | translate }}</md-tab-label><md-tab-body><div ng-if="!vm.loadingUserOfferEngagements && (!vm.offers || vm.offers.length < 1)"><div class="no-consumer-habits"><img src="content/images/consumer-habits.png"><p data-translate="reports.engagement.user.messages.no-habits"></p></div></div><div ng-if="!vm.loadingUserOfferEngagements && (vm.offers || vm.offers.length > 0)"><div ng-include="\'app/admin/communication/engagements/habits.html\'"></div><div ng-include="\'app/admin/communication/engagements/history.html\'"></div></div></md-tab-body></md-tab></md-tabs></div></div></div></div><div class="col-xs-12 col-md-8 col-lg-9 no-conversation-selected" ng-if="!vm.currentConversation.conversationId && !vm.isMobile"><div style="width: 40%"><img src="/content/images/no-selected-conversations.png" alt="no-selected-conversation" style="height: 32vh"><h2 class="font-bold">{{\'communication.no-conversation-selected.title\' | translate}}</h2><span class="no-conversation-selected-subtitle text-muted">{{\'communication.no-conversation-selected.subtitle\' | translate}}</span></div></div></div></div></div></div><div class="full-screen-preview" ng-show="vm.messageFullScreen.isFullScreen" ng-click="vm.closeFullScreenPreview()"><img ng-if="vm.messageFullScreen.message.type === \'image\'" ng-click="$event.stopPropagation();vm.zoomImage($event)" ng-mousemove="vm.moveZoomedImage($event)" ng-src="{{vm.messageFullScreen.message.data}}" alt="image" style="cursor: zoom-in"><video ng-if="vm.messageFullScreen.message.type === \'video\'" ng-click="$event.stopPropagation()" alt="" controls autoplay><source src="{{vm.messageFullScreen.message.data}}"></video><div class="full-screen-actions"><button ng-if="vm.currentConversation.platform === \'WATI\'" type="button" class="icon-ksc-download-solid" data-dismiss="modal" aria-hidden="true" ng-click="$event.stopPropagation();vm.downloadMediaFromWATI(vm.messageFullScreen.message.data)"></button> <button type="button" class="icon-ksc-close-light" data-dismiss="modal" aria-hidden="true"></button></div></div><script>$(document).click(function () {\n        $(".dropdown").removeClass(\'open\');\n    });</script><style>.label {\n        white-space: normal !important;\n    }\n\n    .zoomed {\n        transform: scale(2); /* Ajuste o valor para o n\xEDvel de zoom desejado */\n        transition: transform ease-in-out 0.3s; /* Dura\xE7\xE3o da transi\xE7\xE3o */\n    }\n\n\n    md-tabs > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active,\n    md-tabs > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon,\n    md-tabs.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon,\n    md-tabs.md-default-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused,\n    md-tabs.md-default-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {\n        color: black !important;\n        text-transform: inherit !important;\n    }\n\n    md-tabs > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {\n        color: black !important;\n        text-transform: inherit !important;\n    }\n\n    md-tabs.md-default-theme md-ink-bar,\n    md-tabs md-ink-bar {\n        color: #3442bd !important;\n        background-color: #3442bd !important;\n    }\n\n    md-tab-content {\n        padding: 30px 0;\n    }\n\n    .about .header {\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 20px;\n    }\n\n    .about .header label {\n        font-size: 18px;\n    }\n\n    .about .header a {\n        font-size: 16px;\n        font-weight: 500;\n    }\n\n    .about .header a:hover {\n        opacity: 0.8;\n    }\n\n    .about .infos i {\n        font-size: 18px;\n    }\n\n    .about .infos span {\n        font-size: 16px;\n        margin-left: 20px;\n    }\n\n    .about .infos input {\n        margin-left: 25px;\n    }\n\n    .about .infos .row {\n        padding: 0;\n    }\n\n    .about .infos div {\n        /* padding: 10px 0px; */\n    }\n\n    .intl-tel-input {\n        display: block !important;\n        margin-left: 25px !important;\n        padding-top: 0 !important;\n        padding-bottom: 0 !important;\n        width: 100% !important;\n    }\n\n    .intl-tel-input div {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important;\n    }\n\n    .intl-tel-input .country-list {\n        max-width: 284px;\n        overflow-x: hidden;\n    }\n\n    .btn-cancelar {\n        color: #939393;\n    }\n\n    .phone,\n    .fullname,\n    .email,\n    .birthday,\n    .address {\n        margin-top: 10px;\n        margin-bottom: 10px;\n    }\n\n    .badge-ticket {\n        padding: 3px 12px;\n        border-radius: 15px;\n        color: white;\n        font-size: 10px;\n        font-weight: 500;\n    }\n\n    .badge-round {\n        width: 15px;\n        height: 15px;\n        border-radius: 50%;\n        font-weight: 500;\n        font-size: 10px;\n    }\n\n    .bg-green {\n        background-color: rgb(24, 160, 24);\n    }\n\n    .bg-red {\n        background-color: rgb(240, 95, 95);\n    }\n\n    .bg-blue {\n        background-color: rgb(0, 174, 255);\n    }\n\n    .bg-purple {\n        background-color: rgb(139, 129, 196);\n    }\n\n    .bg-grey {\n        background-color: grey;\n    }\n\n    .btn-select-status {\n        background-color: transparent;\n        color: inherit;\n    }\n\n    .d-flex {\n        display: flex !important;\n    }</style>');
$templateCache.put('app/admin/configuration/configuration.html','<div class="wrapper wrapper-content"><div class="row"><div class="ibox"><div class="ibox-content"><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/admin/customer/_modal_add_edit_customer.html','<div id="add-edit-customer-modal" ng-init="vm.init()"><div class="modal-header"><button id="btCloseModalAddCustomer" type="button" class="close" data-dismiss="modal" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" ng-if="!vm.customer.id" data-translate="customer.label.title.new">New Customer</h4><h4 class="modal-title" ng-if="vm.customer.id" data-translate="customer.label.title.edit">Edit Customer</h4></div><form class="" ng-submit="vm.save()" id="formAddEditCustomer" name="vm.formAddEditCustomer" novalidate role="form"><div class="modal-body"><div class="tabs-container"><ul class="nav nav-tabs"><li ng-class="{\'active\' : tab == 1}"><a ng-click="tab = 1" ng-init="tab = 1"><i class="fa fa-user"></i> <span data-translate="customer.label.personal-info">Personal Info</span></a></li><li ng-class="{\'active\' : tab == 2}"><a ng-click="tab = 2"><i class="fa fa-address-card"></i> <span data-translate="customer.label.address">Address</span></a></li></ul><div class="tab-content"><div id="tab-1" class="tab-pane active" ng-show="tab == 1"><div class="panel-body"><div class="row"><div class="col-md-4 col-sm-4 col-xs-12 form-group"><label for="fullName" class="required" data-translate="global.form.customerName">Full name</label><input id="fullName" name="fullName" type="text" class="form-control" ng-model="vm.customer.fullName" ng-maxlength="100" ng-minlength="4" required><div class="help-block-div" ng-show="vm.formAddEditCustomer.fullName.$invalid && vm.formAddEditCustomer.$submitted"><p class="help-xblock form-invalid-field" ng-show="vm.formAddEditCustomer.fullName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.fullName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.fullName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-4 col-sm-4 col-xs-12 form-group"><label for="email" data-translate="global.form.email">Email</label><input id="email" type="email" name="email" class="form-control" ng-model="vm.customer.email" ng-maxlength="100" ng-pattern=\'/^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$/i\'><div class="help-block-div" ng-show="vm.formAddEditCustomer.email.$invalid && vm.formAddEditCustomer.$submitted"><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.$error.pattern" data-translate="global.messages.validate.email.invalid">Please input a valid email.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-4 col-sm-4 col-xs-12 form-group"><label for="customerIdentity" data-translate="global.form.cpf_cnpj">CPF/CNPJ</label><input id="customerIdentity" type="text" name="customerIdentity" class="form-control" ng-model="vm.customer.customerIdentity" ui-br-cpfcnpj-mask><div class="help-block-div" ng-show="vm.formAddEditCustomer.customerIdentity.$invalid && vm.formAddEditCustomer.customerIdentity.$touched"><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.customerIdentity.$invalid" data-translate="global.messages.validate.customerIdentity.invalid">This field CPF/CNPJ is invalid.</p></div></div></div><div class="row"><div class="col-md-4 form-group"><label id="gender" for="gender" data-translate="global.form.gender">Gender</label><select id="gender" name="gender" ng-model="vm.customer.gender" title="Choose a gender" class="form-control"><option></option><option ng-repeat="item in vm.genders" ng-value="item.key">{{vm.getGenderKey(item.key) | translate}}</option></select></div><div class="col-md-4 form-group"><label id="phone" for="phone" class="required" data-translate="customer.label.phoneAndWhatsapp">Phone/Whatsapp</label><input type="tel" name="phone" id="phone" class="form-control" ng-model="vm.customer.phone" intl-tel-input required><div class="help-block-div" ng-show="vm.formAddEditCustomer.phone.$invalid && vm.formAddEditCustomer.$submitted"><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.phone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div><div class="col-md-4 form-group"><label for="dateOfBirth" data-translate="global.form.birthDate">Birthdate</label><div class="input-group date" id="dateOfBirth"><input type="text" name="dateOfBirth" class="form-control inputDate external-control" autocomplete="off" ng-model="vm.customer.birthDate" ui-mask-placeholder ui-mask="{{vm.maskLocale}}" placeholder="{{\'global.form.dateOfBirth\' | translate}}"> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div></div></div><div class="row" ng-if="vm.customer.id === undefined"><div class="col-md-12 form-group"><label for="notes" data-translate="global.form.notes">Notes</label><textarea id="notes" name="notes" class="form-control" ng-model="vm.customer.notes" style="resize: none" rows="5">\n                                    </textarea></div></div></div></div><div id="tab-2" class="tab-pane active" ng-show="tab == 2"><div class="panel-body"><div class="row"><div class="col-md-5 form-group"><label for="addres" data-translate="global.form.address">Address</label><input id="address" name="address" type="text" class="form-control" ng-model="vm.customer.address" ng-maxlength="100"><div ng-show="vm.formAddEditCustomer.address.$invalid && vm.formAddEditCustomer.$submitted"><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.address.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-2 form-group"><label for="addressNumber" data-translate="global.form.number">Number</label><input id="addressNumber" name="addressNumber" type="text" class="form-control" ng-model="vm.customer.addressNumber" maxlength="10"></div><div class="col-md-5 form-group"><label for="complement" data-translate="global.form.complement">Complement</label><input id="complement" name="complement" type="text" class="form-control" ng-model="vm.customer.complement" ng-maxlength="100"><div ng-show="vm.formAddEditCustomer.complement.$invalid && vm.formAddEditCustomer.$submitted"><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.complement.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="row"><div class="col-md-4 form-group"><label for="state" data-translate="global.form.state">State</label><input id="city" name="state" type="text" class="form-control" ng-model="vm.customer.state" ng-maxlength="50"><div ng-show="vm.formAddEditCustomer.state.$invalid && vm.formAddEditCustomer.$submitted"><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.state.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="col-md-4 form-group"><label for="city" data-translate="global.form.city">City</label><input id="city" name="city" type="text" class="form-control" ng-model="vm.customer.city" ng-maxlength="50"><div ng-show="vm.formAddEditCustomer.city.$invalid && vm.formAddEditCustomer.$submitted"><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="col-md-4 form-group"><label for="zipcode" data-translate="global.form.zipcode">Zipcode</label><input id="zipcode" name="zipcode" type="text" class="form-control" ng-model="vm.customer.zipCode"></div></div></div></div></div></div></div><div class="modal-footer"><button ladda="vm.isSaving" type="submit" ng-disabled="(vm.formAddEditCustomer.$invalid && vm.formAddEditCustomer.$submitted)" class="btn btn-primary btn-md" data-style="slide-left"><span data-translate="global.form.save">Save</span></button></div></form></div>');
$templateCache.put('app/admin/customer/_modal_delete_customer.html','<div id="add-edit-customer-modal"><div class="modal-body"><span style="font-size: 1.3em" class="modal-title" data-translate="customer.label.delete" translate-value-name="{{vm.fullName}}"></span></div><div class="modal-footer"><button ng-click="vm.cancel()" class="btn btn-primary btn-md" data-style="slide-left"><span>Cancel</span></button> <button ng-click="vm.ok()" class="btn btn-primary btn-md" data-style="slide-left"><span>Deletar</span></button></div></div>');
$templateCache.put('app/admin/customer/customer.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-sm-9"><div ui-view="customer-list"></div></div><div class="col-sm-3" style="padding-left: 0"><div ui-view="customer-detail"></div></div></div></div>');
$templateCache.put('app/admin/customer/customers-detail.html','<div class="ibox"><div class="ibox-content" style="height: 725px"><div class="tab-content"><div ng-if="vm.customer" id="contact-1" class="tab-pane active"><div class="row m-b-lg"><div class="col-md-12"><span class="pull-right" style="margin-top: 3px"><span has-authority="STORE_DELETE_CUSTOMER" class="fa fa-trash store-detail-button" ng-click="vm.showModalDeleteCustomer()" data-toggle="tooltip" data-placement="top" title="{{\'customer.button.placeholders.delete\' | translate}}" role="button" style="color: #676a6cd6"></span> <span has-authority="STORE_UPDATE_CUSTOMER" class="fa fa-pencil-square-o store-detail-button" ng-click="vm.showModalEditCustomer()" data-toggle="tooltip" data-placement="top" title="{{\'customer.button.placeholders.update\' | translate}}" role="button" style="padding-right: 9px; color: #676a6cd6"></span></span></div><div class="col-md-12 text-center"><div class="m-b-sm"><img alt="image" class="img-circle" src="/content/images/profile_small.png" style="width: 32px"></div><h2 ng-bind="vm.customer.fullName"></h2></div><div class="col-md-12" ng-if="vm.customer.phone"><a type="button" class="btn btn-primary btn-sm btn-block" ng-href="{{ vm.sendMessageToWhastapp(vm.customer.phone) }}" target="_blank"><i class="fa fa-whatsapp"></i> <span data-translate="customer.button.sendMessageWhatsapp"></span></a></div><div class="col-md-12" style="margin-top: 10px" ng-if="vm.customer.userDBId && vm.customer.phone"><!--white space between buttons--></div><div class="col-md-12" ng-if="vm.customer.userDBId"><a type="button" class="btn btn-primary btn-sm btn-block" ui-sref="engagements-user({id: vm.customer.userDBId, from: \'all\'})"><i class="fa fa-bar-chart"></i> <span data-translate="customer.button.consumptionProfile"></span></a></div></div><div class="client-detail" style="height: 460px !important"><div class="full-height-scroll" full-scroll style="overflow: hidden;width: auto;height: 471px !important"><strong><h4><span data-translate="customer.label.personal-info">Personal Info</span></h4></strong><div style="font-size: 1em"><div><label><span data-translate="global.form.email">Email</span>:</label><span ng-bind="vm.customer.email"></span></div><div><label><span data-translate="global.form.phone">Phone</span>:</label><span ng-bind="vm.customer.phone"></span></div><div ng-if="vm.customer.whatsapp"><label><span data-translate="global.form.whatsapp">Whatsapp</span>:</label><span ng-bind="vm.customer.whatsapp"></span></div><div ng-if="vm.customer.customerIdentity"><label><span data-translate="global.form.cpf_cnpj">CPF/CNPJ</span>:</label><span ng-bind="vm.customer.customerIdentity"></span></div><div ng-if="vm.customer.birthDate"><label><span data-translate="global.form.birthDate">Birthdate</span>:</label><span>{{vm.customer.birthDate | amUtc | amDateFormat:\'DD/MM/YYYY\'}}</span></div><div ng-if="vm.customer.gender"><label><span data-translate="global.form.gender">Gender</span>:</label><span data-translate="customer.{{vm.customer.gender}}">Male</span></div><hr ng-if="vm.customer.address ||\n                                        vm.customer.addressNumber ||\n                                        vm.customer.complement ||\n                                        vm.customer.state ||\n                                        vm.customer.city"><strong ng-if="vm.customer.address ||\n                                            vm.customer.addressNumber ||\n                                            vm.customer.complement ||\n                                            vm.customer.state ||\n                                            vm.customer.city"><h4><span data-translate="customer.label.addressInfo">Address Info</span></h4></strong><div ng-if="vm.customer.address"><label><span data-translate="global.form.address">Address</span>:</label><span ng-bind="vm.customer.address"></span></div><div ng-if="vm.customer.addressNumber"><label><span data-translate="global.form.number">Address Number</span>:</label><span ng-bind="vm.customer.addressNumber"></span></div><div ng-if="vm.customer.complement"><label><span data-translate="global.form.complement">Complement</span>:</label><span ng-bind="vm.customer.complement"></span></div><div ng-if="vm.customer.state"><label><span data-translate="global.form.state">State</span>:</label><span ng-bind="vm.customer.state"></span></div><div ng-if="vm.customer.city"><label><span data-translate="global.form.city">City</span>:</label><span ng-bind="vm.customer.city"></span></div><div ng-if="vm.customer.zipCode"><label><span data-translate="global.form.zipcode">Zipcode</span>:</label><span ng-bind="vm.customer.zipCode"></span></div></div><div class="notes"><div class="notes-header"><h2 style="font-weight: 500; font-size: 18px; margin-top: 25px">{{ \'communication.notes\' | translate }}</h2><button class="add-note-btn" ng-click="vm.startWritingNote(false)" ng-if="!vm.isEditingNote">+Adicionar</button></div><div class="add-note" ng-if="vm.isWritingNote"><textarea type="text" placeholder="Adicionar nota..." ng-model="vm.newNoteText" class="form-control form-control-lg" style="height: 70px"></textarea><div class="cancel-save-note-button"><button type="button" style="margin-right: 10px" class="btn cancel-button" ng-click="vm.stopWritingNote()">{{ \'global.messages.remove.cancel\' | translate }}</button> <button ng-if="!vm.isEditingNote" type="button" class="btn btn-primary" ng-click="vm.addNoteTag(vm.newNoteText, false)">{{ \'entity.action.save\' | translate }}</button> <button ng-if="vm.isEditingNote" type="button" class="btn btn-primary btn-lg btn-save-note" ng-click="vm.addNoteTag(vm.newNoteText, false)">{{ \'communication.update\' | translate }}</button></div></div><div class="notes-list"><div ng-repeat="note in vm.notes" class="note"><div class="note-header"><span style="color: #b3b3b3">{{note.timestamp}}</span><div class="note-btns"><i class="fa fa-trash" ng-click="vm.deleteNoteTag(note.id, false)"></i> <i class="fa fa-edit" ng-click="vm.startWritingNote(true, note.id, $index)"></i></div></div><span class="label note-text">{{note.text}}</span></div></div></div></div></div></div><div ng-if="!vm.customer" style="height: auto; display: flex; align-items: center; justify-content: center"><div><span style="font-size:1.2em" class="insufficient-data ng-scope" data-translate="global.messages.insufficientDataCustomer">Dados insuficientes para a gera\xE7\xE3o do relat\xF3rio</span></div></div></div></div></div>');
$templateCache.put('app/admin/customer/customers-list.html','<div class="ibox"><div class="ibox-content" style="height: 725px"><div class="row" style="margin-top: 40px"><div class="col-md-6 col-xs-12"><div class="input-group form-group w-100"><input type="text" placeholder="{{\'customer.button.search\' | translate}}" class="input form-control" ng-model="vm.filter.fullName" ng-change="vm.filterChange()"></div></div><div class="col-md-6 col-xs-12" has-authority="STORE_CREATE_CUSTOMER"><button ng-click="vm.showModalAddCustomer()" class="btn btn-primary pull-right"><i class="fa fa-user-plus"></i> <span data-translate="customer.button.create">Create Customer</span></button> <button ui-sref="import-customers" class="btn btn-primary pull-right" style="margin-right: 1%"><i class="fa fa-cloud-upload"></i> <span data-translate="customer.button.import">Import</span></button></div></div><div class="clients-list"><div class="tab-content" ng-if="!vm.loadingCustomers"><div id="tab-1" class="tab-pane active" style="height: 520px; margin-bottom: 10px"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th><span data-translate="global.form.customerName">Full Name</span></th><th><span data-translate="global.form.phone">Phone</span></th><th><span data-translate="global.form.email">Email</span></th><th><span data-translate="global.form.birthDate">Birthdate</span> <a ng-click="vm.orderByBirthdayWeek()"><i class="fa fa-birthday-cake contact-type" ng-style="{\'color\' : vm.orderedByBirthdayWeek ? \'#2F0E7F\' : \'\', \'float\' : \'right\'}" tooltip-placement="left" uib-tooltip="{{\'global.form.orderByBirthDayWeek\' | translate}}"></a></th></tr></thead><tbody><tr ng-repeat="customer in vm.customers" ng-click="vm.selectCustomer(customer)"><td class="client-avatar" style="width: auto"><img alt="image" src="/content/images/profile_small.png"> <span class="client-link" ng-bind="customer.fullName" style="padding-left: 10px"></span></td><td><i class="fa fa-phone contact-type"></i> <span ng-bind="customer.phone"></span></td><td><i class="fa fa-envelope contact-type"></i> <span ng-bind="customer.email"></span></td><td><i class="fa fa-birthday-cake contact-type" ng-style="{\'color\' : customer.birthdayWeek ? $rootScope.mainColor : \'\', \'padding-right\' : \'10px\'}"></i> <span ng-if="customer.birthDate">{{customer.birthDate | amUtc | amDateFormat:\'DD/MM/YYYY\'}}</span></td></tr></tbody></table></div></div><div align="center" style="padding-bottom:  20px"><uib-pagination ng-model="vm.currentPage" total-items="vm.totalCustomers" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistry}}\', of: \'{{vm.endRegistry}}\', total: \'{{vm.totalCustomers}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalCustomers }}</p></div></div></div><div ng-if="vm.loadingCustomers" class="tab-content" style="height: 602px; display: flex;\n            align-items: center;\n            justify-content: center"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/digital-poster/digital-poster.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox float-e-margins"><div class="ibox-content" style="padding: 15px; display: flex"><div class="row" style="width: 100%"><div class="col-lg-12" style="margin: 0 !important"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" style="margin: 0 !important; padding: 0 !important; display: flex; align-items: center"><div class="inner-addon left-addon"><input type="text" class="form-control input-lg showcase-input-hidden-border showcase-input-fontsize showcase-input-placeholder" placeholder="{{\'digitalPoster.creater.fields.nameYourPoster\' | translate}}" ng-model="vm.poster.name"><div class="showcase-input-icon-box"><i class="glyphicon glyphicon-pencil showcase-input-icon"></i></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="col-xs-12" style="margin-top: 2%" align="center"><div class="btn-group" tooltip-placement="bottom-right" uib-tooltip="{{\'digitalPoster.home.buttons.selectOfferExplanation\' | translate}}"><a style="color: #676a66" class="showcase-menu-button" data-toggle="dropdown" aria-expanded="false" ng-click="vm.selectFlyer()"><i class="icon-ksc-addflyer" style="font-size: 2.8em !important"></i><p style="margin-top: 10px;  margin-bottom: 0px; font-size: 1.0em" data-translate="digitalPoster.home.buttons.selectOffer" class="pull-right">Offser</p></a></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 showcase-align-center"><div class="btn-group pull-right" role="group" aria-label="..." style="display: flex; align-items: center; right: -7px; padding-top: 9px"><button ladda="vm.isGeneratingPoster" class="btn btn-md btn-primary" ng-click="vm.generatePoster()" style="padding: 7px 20px 5px 20px"><span class="fa fa-print"></span> <span class="showcase-home-button-margin" data-translate="digitalPoster.home.buttons.generatePoster">Generate Poster</span></button></div></div></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content" style="padding:1.5%; display: flex; max-height: 800px"><div class="row"><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" style="padding-right: 0.4%; height: 100%"><div class="ibox-content" style="background-color: #F3F3F4; height: 100%" ng-include="\'app/admin/digital-poster/components/digital-poster.form.html\'"></div></div><div class="col-xs-12 col-sm-12 col-md-8 col-lg-8" style="height: 100%"><div class="ibox-content" style="background-color: #F3F3F4; height: 100%" ng-include="\'app/admin/digital-poster/components/digital-poster.preview.html\'"></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/discount-coupon/_modal_add_edit_discount_coupon.html','<style>md-select-menu md-content {\n        -webkit-overflow-scrolling: fixed !important;\n    }\n\n    .custom-md-input md-input-container {\n        display: inherit;\n        margin: unset;\n    }\n\n    .custom-md-input md-select.md-default-theme .md-select-value,\n    md-select .md-select-value {\n        border-color: rgba(0, 0, 0, 0.12) !important;\n        border: 1px;\n        border-style: solid;\n    }\n\n    .custom-select[multiple] .md-select-value span:first-child {\n        visibility: collapse;\n    }\n\n    .custom-select[multiple] .md-select-value .md-text {\n        display: inline-block !important;\n        visibility: visible;\n        background-color: rgb(224, 224, 224);\n        border-radius: 6px;\n        padding: 3px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected],\n    md-select-menu md-content md-option[selected] {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected]:focus,\n    md-select-menu md-content md-option[selected]:focus {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-checkbox-enabled.md-default-theme[selected] .md-icon,\n    .md-checkbox-enabled[selected] .md-icon {\n        background-color: var(--main-color) !important;\n    }\n\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\n    md-select-menu md-content md-option:not([disabled]):focus,\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\n    md-select-menu md-content md-option:not([disabled]):hover {\n        background: none;\n    }\n\n    .highlight {\n        background: #f3f3f4;\n        padding: 5px;\n        display: inline-block;\n        color: #5E5E5E;\n        border-radius: 10px;\n        padding-bottom: 2px;\n        padding-top: 2px;\n        z-index: 1000000;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    md-select-menu {\n        margin-top: 50px;\n        width: 150.674px !important;\n        margin-left: 39px;\n    }\n\n    .remove-dropdown {\n        display: none !important;\n    }\n\n    .empty-list md-select-menu {\n        margin-top: 42px;\n        width: 192.674px !important;\n        margin-left: -1px;\n    }\n\n    md-select.md-default-theme[disabled] .md-select-value,\n    md-select[disabled] .md-select-value {\n        background-image: none !important;\n    }\n\n    .custom-md-input md-select.md-default-theme \n    .md-select-value, md-select .md-select-value {\n        padding: 10px;\n    }\n\n    .md-select-menu-container {\n        z-index: 9999;\n    }\n\n    .btn-code-generate {\n        background-color: white;\n        color: var(--main-color);\n        border: solid 1px;\n        font-weight: 500;\n        border-color: var(--main-color);\n    }\n\n    md-switch .md-label {\n        margin-left: 35px;\n    }\n\n    .modal-footer {\n        padding: 0px 15px 15px 15px;\n        margin: 0px;\n        border-top: 0px;\n    }\n\n    .modal-body {\n        padding: 0px 30px 10px 30px;\n    }\n\n\n    .modal-header .close {\n        margin-top: -2px;\n        font-size: xx-large;\n    }</style><div id="add-edit-customer-modal" ng-init="vm.init()"><div class="modal-header" style="border-bottom: none; padding: 20px 35px 0px"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><div ng-if="!vm.discountCoupon.id"><h2 class="modal-title" data-translate="global.form.createCouponTitle">Novo cupom de desconto</h2><p data-translate="global.form.createCouponDesc">Preencha os campos abaixo para configura\xE7\xE3o e disponibiliza\xE7\xE3o do cupom</p></div><div ng-if="vm.discountCoupon.id"><h2 class="modal-title" data-translate="global.form.editCouponTitle">Editar cupom de desconto</h2><p data-translate="global.form.editCouponDesc">Preencha os campos abaixo para configura\xE7\xE3o e disponibiliza\xE7\xE3o do cupom</p></div></div><form class="" ng-submit="vm.save()" id="formAddEditDiscountCoupon" name="vm.formAddEditDiscountCoupon" novalidate role="form"><div class="modal-body"><div class="panel-body"><div class="row"><div class="col-md-12 form-group"><md-radio-group ng-model="vm.discountCoupon.isEnabled" layout="row"><md-radio-button class="my-radio" aria-label="Ativo" ng-value="true">{{\'global.form.active\' | translate}}</md-radio-button><md-radio-button class="my-radio" ng-value="false" aria-label="Inativo">{{\'global.form.inactive\' | translate}}</md-radio-button></md-radio-group></div></div><div class="row"><div class="col-md-12 col-sm-4 col-xs-12 form-group"><label for="name" class="required" data-translate="global.form.couponName">Cupon Name</label><input id="name" name="name" type="text" class="form-control" ng-model="vm.discountCoupon.name" ng-maxlength="100" ng-minlength="4" required placeholder="{{\'global.form.couponNamePlaceholder\' | translate}}"><div class="help-block-div" ng-show="vm.formAddEditDiscountCoupon.name.$invalid && vm.formAddEditDiscountCoupon.name.$touched"><p class="help-xblock form-invalid-field" ng-show="vm.formAddEditDiscountCoupon.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditDiscountCoupon.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditDiscountCoupon.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><label for="code" class="required" data-translate="global.form.code">Code</label><div class="input-group"><div style="margin-right: 20px"><input id="code" name="code" type="text" class="form-control" uppercase ng-model="vm.discountCoupon.code" ng-maxlength="100" ng-minlength="4" required placeholder="Ex.: CUPOM50OFF"></div><div class="input-group-btn" style="font-size: unset"><button type="button" class="btn btn-primary btn-md btn-code-generate" ng-click="vm.makecoupon()" data-style="slide-left"><span data-translate="global.form.generateCode">Generate Code</span></button></div><div style="display: table-row" ng-if="vm.formAddEditDiscountCoupon.code.$valid || vm.formAddEditDiscountCoupon.code.$untouched"><p style="font-size: 10px; margin: 0px; color: #7e7e7e" data-translate="global.form.couponCodeDesc">Este \xE9 o c\xF3digo que voc\xEA dar\xE1 para o seu cliente preencher no momento da compra.</p></div><div style="display: table-row" ng-show="vm.formAddEditDiscountCoupon.code.$invalid && vm.formAddEditDiscountCoupon.code.$touched"><p class="help-xblock form-invalid-field" ng-show="vm.formAddEditDiscountCoupon.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditDiscountCoupon.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditDiscountCoupon.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><br><div class="row"><div ng-class="vm.discountCoupon.discountType === \'FREE_SHIPPING\' ? \'form-group col-md-12\' : \'form-group col-md-6\'"><label id="discountType" for="discountType" class="required" data-translate="global.form.couponType">discountType</label><select id="discountType" name="discountType" ng-model="vm.discountCoupon.discountType" title="Choose a gender" class="form-control" ng-change="vm.changeDiscountType()" required><option ng-repeat="item in vm.discountTypes" ng-value="item.key">{{item.name}}</option></select><div class="help-block-div" ng-show="vm.formAddEditDiscountCoupon.discountType.$invalid && vm.formAddEditDiscountCoupon.$submitted"><p class="help-xblock form-invalid-field" ng-show="vm.formAddEditDiscountCoupon.discountType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!-- Price --><div ng-if="vm.discountCoupon.discountType == \'DISCOUNT_VALUE\'" class="col-md-6 col-sm-4 col-xs-12 form-group"><label for="purchaseValue" class="required" data-translate="global.form.discountValue">Valor do desconto</label><div class="input-group"><span class="input-group-addon">{{vm.configutaionsPrice.prefix }}</span> <input id="discount" name="discount" ng-model="vm.discountCoupon.discount" type="text" class="form-control" placeholder="{{ vm.configutaionsPrice.placeHolder }}" price ng-change="vm.checkDiscountValue()" price-decimal-separator="{{ vm.configutaionsPrice.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.configutaionsPrice.thousandsSeparator || \'.\' }}" price-currency-type="vm.configutaionsPrice.key" price-activated="true" required></div><div ng-show="vm.formAddEditDiscountCoupon.discount.$error && vm.formAddEditDiscountCoupon.$submitted"><p class="help-block form-invalid-field" ng-show="vm.formAddEditDiscountCoupon.discount.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.formAddEditDiscountCoupon.discount.$error.min" data-translate="entity.validation.min" translate-value-min="0"></p></div></div><!-- Percentage --><div ng-if="vm.discountCoupon.discountType == \'PERCENTAGE\'" class="col-md-6 col-sm-4 col-xs-12 form-group"><div class="form-group"><label for="discount" class="required" data-translate="global.form.discountValue">Valor do desconto</label><div class="input-group"><input id="discount" name="discount" class="form-control" type="number" required ng-model="vm.discountCoupon.discount" min="0.0" max="100" placeholder="Ex.: 10"> <span class="input-group-addon">%</span></div><div ng-show="vm.formAddEditDiscountCoupon.discount.$invalid && vm.formAddEditDiscountCoupon.$submitted"><p class="help-block form-invalid-field" ng-show="vm.formAddEditDiscountCoupon.discount.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.formAddEditDiscountCoupon.discount.$error.max" data-translate="entity.validation.max" translate-value-max="100"></p><p class="help-block form-invalid-field" ng-show="vm.formAddEditDiscountCoupon.discount.$error.min" data-translate="entity.validation.min" translate-value-min="0"></p></div></div></div></div><div class="row"><div class="col-sm-12 col-md-5"><div class="brand-category"><md-switch ng-model="vm.hasUsageLimit" ng-change="vm.changehasUsageLimit()" style="margin: 0px 0px 15px 0px"><span data-translate="global.form.usageLimitCoupon">Limitar o uso deste cupom?</span></md-switch></div></div></div><div ng-hide="!vm.hasUsageLimit"><div class="row"><div class="col-md-12 col-sm-4 col-xs-12 form-group"><label for="maxUsages" data-translate="global.form.totalAmountOfCoupons">Total Amount Of Coupons</label><input id="maxUsages" name="maxUsages" type="number" class="form-control" placeholder="Ex.: 30" ng-model="vm.discountCoupon.maxUsages" min="1"><div class="help-block-div" ng-show="vm.usedCoupons > vm.discountCoupon.maxUsages"><p class="help-xblock form-invalid-field">Infome um valor maior</p></div></div></div><div class="row"><div class="col-md-12 col-sm-4 col-xs-12 form-group"><label for="usageLimitPerClient" data-translate="global.form.usageLimitPerClient">Usage limit per client</label><input id="usageLimitPerClient" name="usageLimitPerClient" type="number" class="form-control" placeholder="Ex.: 1" ng-model="vm.discountCoupon.usageLimitPerClient" min="1"></div></div><div class="row"><div class="form-group col-md-12"><label for="size" data-translate="global.form.justCategoryCupom">Apply only to products in this(these) category(s)</label><div class="dropdown custom-md-input"><md-input-container ng-if="vm.categories.length" class="category-select"><md-select class="custom-select-value" ng-model="vm.discountCoupon.categoryKeys" multiple="multiple" disableoptioncentering><div ng-mouseleave="vm.closeDropDown($event)"><md-option ng-repeat="category in vm.categories" ng-value="category.key">{{category.title}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.categories.length" class="category-select"><md-select class="custom-select-value" ng-model="vm.discountCoupon.categoryKeys" multiple="multiple" disableoptioncentering disabled="!vm.categories.length"></md-select></md-input-container></div></div></div><div class="row"><div class="col-md-6 form-group"><label for="startDate" data-translate="global.form.from">From</label><div class="input-group date" id="startDate"><input type="text" name="startDate" class="form-control inputDate external-control" autocomplete="off" ng-model="vm.discountCoupon.startDate" ui-mask-placeholder ui-mask="{{vm.maskLocale}}" placeholder="{{\'global.form.from\' | translate}}"> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div></div><div class="col-md-6 form-group"><label for="expirationDate" data-translate="global.form.to">To</label><div class="input-group date" id="expirationDate"><input type="text" name="expirationDate" class="form-control inputDate external-control" autocomplete="off" ng-model="vm.discountCoupon.expirationDate" ui-mask-placeholder ui-mask="{{vm.maskLocale}}" placeholder="{{\'global.form.from\' | translate}}"> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div></div></div></div></div></div><div class="modal-footer" style="padding: 0px 40px 20px 15px"><button ladda="vm.isSaving" type="button" ng-click="vm.cancel()" ng-disabled="(vm.formAddEditDiscountCoupon.$invalid && vm.formAddEditDiscountCoupon.$submitted)" class="btn btn-default" data-style="slide-left"><span data-translate="entity.action.cancel">Cancelar</span></button> <button ladda="vm.isSaving" type="submit" ng-if="!vm.discountCoupon.id" ng-disabled="(vm.formAddEditDiscountCoupon.$invalid)" class="btn btn-primary btn-md" data-style="slide-left"><span data-translate="global.form.createCoupon">Criar cupom</span></button> <button ladda="vm.isSaving" type="submit" ng-if="vm.discountCoupon.id" ng-disabled="(vm.formAddEditDiscountCoupon.$invalid)" class="btn btn-primary btn-md" data-style="slide-left"><span data-translate="global.form.editCoupon">Editar cupom</span></button></div></form></div>');
$templateCache.put('app/admin/discount-coupon/discount-coupon-list.html','<style>.input-search {\n        display: contents;\n    }</style><div class="wrapper wrapper-content"><div class="row"><div class="col-sm-12"><div class="ibox"><div class="ibox-content" style="height: auto"><div class="row" style="margin-top: 10px"><div class="col-md-4"><div class="input-group form-group input-search" ng-if="vm.discountCoupons.length > 0 || vm.filtring"><input type="text" placeholder="{{\'discount-coupon.placeholder\' | translate}}" class="input form-control" id="input-search" ng-model="vm.filter.text" ng-change="vm.filterChange()"></div></div><div class="col-md-8" ng-if="vm.discountCoupons.length > 0 || vm.filtring"><button ng-click="vm.showModalAddDiscountCoupon()" class="btn btn-primary pull-right create-coupon"><i class="icon-ksc-activecoupon"></i> <span data-translate="global.form.createCoupon">Criar Cupom</span></button></div></div><div class="clients-list"><div class="tab-content" ng-if="!vm.loadingCustomers"><div id="tab-1" class="tab-pane active" style="height: 520px; margin-bottom: 10px"><div class="table-responsive"><table class="table table-striped table-hover" ng-if="vm.discountCoupons.length > 0 || vm.filtring"><thead><tr><th><span data-translate="global.form.name">Name</span></th><th><span data-translate="global.form.code">Code</span></th><th><span data-translate="global.form.discount">Discount</span></th><th><span data-translate="global.form.usedAvailable">Used/Available</span></th><th><span data-translate="global.form.validity">Validity</span></th><th><span data-translate="global.form.limitByCategory">Limit by Category</span></th><th><span data-translate="global.form.usageLimitPerClient">Usage limit per client</span></th><th><span data-translate="global.form.status">Status</span></th><th><span data-translate="global.form.actions">Actions</span></th></tr></thead><tbody ng-if="vm.discountCoupons.length > 0"><tr ng-repeat="discountCoupon in vm.discountCoupons"><td class="client-avatar" style="width: auto"><span ng-bind="discountCoupon.name"></span></td><td class="client-avatar" style="width: auto"><span class="client-link" ng-bind="discountCoupon.code"></span> <input type="text" style="position: absolute; top: -999px; left: -999px" id="code_{{discountCoupon.id}}" value="{{discountCoupon.code}}"></td><td class="client-avatar" style="width: auto"><span ng-if="discountCoupon.discountType === \'DISCOUNT_VALUE\'"><span class="client-link">{{ vm.currencyPrefix }} {{ discountCoupon.discount }}</span> </span><span ng-if="discountCoupon.discountType === \'FREE_SHIPPING\'"><span class="client-link" data-translate="global.form.freeShipping">Frete Gr\xE1tis</span> </span><span ng-if="discountCoupon.discountType === \'PERCENTAGE\'"><span class="client-link">{{ discountCoupon.discount }}%</span></span></td><td class="client-avatar" style="width: auto"><span ng-if="!discountCoupon.hasUsageLimit || discountCoupon.maxUsages === null" data-translate="global.form.unlimited"></span> <span ng-if="discountCoupon.hasUsageLimit && discountCoupon.maxUsages !== null">{{ (discountCoupon.maxUsages - discountCoupon.couponsAvailable) }} / {{ discountCoupon.maxUsages }}</span></td><td><span ng-if="!discountCoupon.hasUsageLimit">Ilimitado</span> <span ng-if="discountCoupon.hasUsageLimit"><span ng-if="discountCoupon.expirationDate">{{discountCoupon.startDate | amUtc | amDateFormat:\'DD/MM/YYYY\'}} - {{discountCoupon.expirationDate | amUtc | amDateFormat:\'DD/MM/YYYY\'}} </span><span ng-if="!discountCoupon.expirationDate" data-translate="global.form.unlimited">Ilimitado</span></span></td><td class="client-avatar" style="width: auto"><span ng-if="!discountCoupon.hasUsageLimit" data-translate="global.form.unlimited">Ilimitado</span> <span ng-if="discountCoupon.hasUsageLimit"><span ng-if="discountCoupon.categoryKeys.length !== 0" ng-repeat="categoryKey in discountCoupon.categoryKeys" class="badge badge-secondary badge-tag-flyer">{{categoryKey}}</span> <span ng-if="discountCoupon.categoryKeys.length === 0" data-translate="global.form.unlimited">Ilimitado</span></span></td><td><span>{{ discountCoupon.usageLimitPerClient ? discountCoupon.usageLimitPerClient : \'Ilimitado\' }}</span></td><td><span ng-if="discountCoupon.isEnabled"><span class="label label-info delivered">Ativo</span> </span><span ng-if="!discountCoupon.isEnabled"><span class="label label-info cancelled">Inativo</span></span></td><td class="client-avatar" style="width: auto; font-size: 20px; min-width: 101px"><a uib-tooltip="{{\'global.form.copyCouponTooltip\' | translate}}" class="fa fa-copy contact-type" style="padding-right: 25px" ng-click="vm.copyDiscountCoupon(discountCoupon)"></a> <a uib-tooltip="{{\'global.form.editCouponTooltip\' | translate}}" class="fa fa-edit contact-type" style="padding-right: 25px" ng-click="vm.showModalEditDiscountCoupon(discountCoupon)"></a> <a uib-tooltip="{{\'global.form.deleteCouponTooltip\' | translate}}" class="fa fa-trash contact-type" style="padding-right: 25px" ng-click="vm.showModalRemoveDiscountCoupon(discountCoupon.id)"></a></td></tr></tbody></table><div class="col-xs-12 showcase-box-noflyer m-t-md" ng-if="vm.discountCoupons.length == 0"><img ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/discount-coupons.png"><h1 ng-if="!vm.filtring" class="ng-scope">{{\'discount-coupon.title-empty\' | translate}}</h1><p ng-if="!vm.filtring" class="ksc-sub-title ng-scope">{{\'discount-coupon.subtitle-empty\' | translate}}</p><h1 ng-if="vm.filtring" class="ksc-sub-title ng-scope">{{\'discount-coupon.search-empty\' | translate}}</h1><button ng-if="!vm.filtring" ng-click="vm.showModalAddDiscountCoupon()" class="btn btn-primary pull-right create-coupon"><i class="icon-ksc-activecoupon"></i> <span data-translate="global.form.createCoupon">Criar Cupom</span></button></div></div></div><div align="center" style="padding-bottom:  20px" ng-if="vm.discountCoupons.length > 0"><uib-pagination ng-model="vm.currentPage" total-items="vm.totalDiscoutCoupon" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistry}}\', of: \'{{vm.endRegistry}}\', total: \'{{vm.totalDiscoutCoupon}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalDiscoutCoupon }}</p></div></div></div><div ng-if="vm.loadingCustomers" class="tab-content" style="height: 602px; display: flex;\n                        align-items: center;\n                        justify-content: center"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/docs/docs.html','<div class="wrapper wrapper-content"><div class="row"><div class="ibox"><div class="ibox-content"><iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe></div></div></div></div>');
$templateCache.put('app/admin/file-manager/store-file-manager.html','<div class="wrapper wrapper-content"><div class="row" style="margin-bottom: 64px"><div class="col-lg-3"><div class="ibox"><div class="ibox-content" style="padding: 15px 20px; min-height: 520px"><div class="file-manager"><h5>{{\'file-manager.form.filter\' | translate}} <i class="fa fa-question-circle" uib-tooltip="{{\'file-manager.form.filter-hint\' | translate}}"></i></h5><div class="m-b-md"><input class="form-control" placeholder="{{\'file-manager.form.filter-name\' | translate}}" ng-model="vm.filterName" ng-change="vm.filterByName()" ng-model-options="{ debounce: 300 }"></div><div class="hr-line-dashed"></div><h5 data-translate="file-manager.directory">Pastas</h5><div class="text-muted m-2" ng-if="!vm.loadingChildren"><span ng-if="vm.currentFolder.id === -1 && !vm.children.length">{{\'file-manager.folder.no-folder\' | translate}} </span><span ng-if="vm.currentFolder.id !== -1 && !vm.children.length">{{\'file-manager.folder.empty-children\' | translate}}</span></div><div ng-if="vm.loadingChildren" class="tab-content"><div class="sk-container"><div class="sk-spinner sk-spinner-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div></div><ul class="folder-list no-padding" ng-if="!vm.loadingChildren && vm.children.length"><li ng-repeat="child in vm.children" class="folder"><a class="col-xs-12 no-padding" ng-click="vm.enterInFolder(child)"><i class="fa fa-folder"></i> {{child.name}}</a></li></ul><div ng-if="!vm.loadingTags && vm.tags"><div class="hr-line-dashed"></div><h5 data-translate="file-manager.tags">Tags</h5></div><div ng-if="vm.loadingTags" class="tab-content"><div class="sk-container"><div class="sk-spinner sk-spinner-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div></div><ul class="tag-list" style="padding: 0"><li ng-repeat="tag in vm.tags" ng-click="vm.filterByTag(tag)"><a href="" style="display: inline-block !important" ng-class="{\'active\': tag.selected}">{{tag.name}}</a></li></ul><div class="clearfix"></div></div></div></div></div><div class="col-lg-9 animated fadeInRight"><div class="ibox"><div class="ibox-content" style="padding: 15px 20px"><div class="row"><div class="col-xs-12 col-sm-10 no-padding" ng-if="!vm.filtring"><label class="no-margin" style="padding: 8px 15px" ng-if="vm.breadcrumbs.length <= 1  && !vm.loadingBreadcrumb" data-translate="file-manager.folder.home">In\xEDcio</label><ol class="breadcrumb no-margin" ng-show="vm.breadcrumbs.length > 1 && !vm.loadingBreadcrumb"><li class="breadcrumb-item" ng-repeat="crumb in vm.breadcrumbs" ng-class="{ active: $last }"><a ng-if="!$last" ng-click="vm.enterInFolder(crumb)">{{ crumb.name }}</a> <strong ng-if="$last">{{ crumb.name }}</strong></li></ol><div ng-if="vm.loadingBreadcrumb"><div class="sk-container"><div class="sk-spinner sk-spinner-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div></div></div><div class="col-xs-12 col-sm-10 no-padding" ng-if="vm.filtring"><label class="no-margin" style="padding: 8px 15px">{{\'file-manager.form.filter-result\' | translate}}</label></div></div></div></div><div ng-if="vm.loadingFiles" class="tab-content"><div class="sk-container"><div class="sk-spinner sk-spinner-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div></div><div class="col-xs-12 showcase-box-noflyer m-t-md" ng-if="!vm.loadingFiles && !vm.files.length"><img ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/picture-icon-logo.png"><h1 data-translate="file-manager.message.no-file-title" class="ng-scope"></h1><p ng-if="!vm.filtring" class="ksc-sub-title ng-scope" data-translate="file-manager.message.no-file-subtitle"></p><p ng-if="vm.filtring" class="ksc-sub-title ng-scope" data-translate="file-manager.form.filter-no-result"></p></div><div class="row" ng-if="!vm.loadingFiles"><div class="col-lg-12 file-grid"><div class="file-box" ng-repeat="file in vm.files"><div class="file pointer"><div class="image" ng-if="vm.getFileType(file.type) === \'IMAGE\'"><img alt="image" class="img-fluid" ng-src="{{file.link}}"></div><div class="icon" ng-if="vm.getFileType(file.type) === \'VIDEO\'"><i class="fa fa-film"></i></div><div class="icon" ng-if="vm.getFileType(file.type) === \'OTHER\'"><i class="fa fa-file"></i></div><div class="file-name"><div class="row"><div class="col-xs-10 no-padding-right" tooltip-placement="bottom" uib-tooltip="{{file.name}}">{{vm.getFileName(file.name)}}</div><div class="col-xs-1"><a class="no-padding pull-right" target="_self" ng-href="{{file.link}}" download="{{file.name}}" uib-tooltip="{{\'file-manager.action.download\' | translate}}"><i class="fa fa-download" style="font-size: 15px"></i></a></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/flyers/flyers-add-size-variation.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" style="text-transform: uppercase" data-translate="flyers.new.form.price-inventory.add-variation"></h4></div><div class="modal-body"><p data-translate="flyers.new.form.price-inventory.add-variation-hint"></p><ul class="nav nav-tabs"><li ng-class="{\'active\' : vm.tab === \'classic\'}" class="ksc-tab active"><a ng-click="vm.changeTab(\'classic\')"><span data-translate="flyers.new.form.size.classic">Classicos</span></a></li><li ng-class="{\'active\' : vm.tab === \'juvenileChild\'}" class="ksc-tab"><a ng-click="vm.changeTab(\'juvenileChild\')"><span data-translate="flyers.new.form.size.juvenile-child">Infanto Juvenil</span></a></li><li ng-class="{\'active\' : vm.tab === \'shorts\'}" class="ksc-tab"><a ng-click="vm.changeTab(\'shorts\')"><span data-translate="flyers.new.form.size.shorts">Shorts, Bermudas e Cal\xE7as</span></a></li><li ng-class="{\'active\' : vm.tab === \'plusSize\'}" class="ksc-tab"><a ng-click="vm.changeTab(\'plusSize\')"><span data-translate="flyers.new.form.size.plus-size">Plus Size</span></a></li><li ng-class="{\'active\' : vm.tab === \'others\'}" class="ksc-tab"><a ng-click="vm.changeTab(\'others\')"><span data-translate="flyers.new.form.size.others">Outros</span></a></li></ul><div class="tab-content" style="border: 1px solid #efefef; border-top: 0"><div class="row no-margin"><div class="col-xs-2" ng-repeat="size in vm.sizes" style="padding: 0 10px"><div class="checkbox" style="background: whitesmoke; border-radius: 2px;padding: 5px; max-width: 75px"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.checkSize(size, $event)" ng-checked="vm.isChecked(size)"> <span id="{{size}}" class="checkbox-material"><span class="check"></span></span> <span>{{size}}</span></label></div></div></div></div></div><div class="modal-footer"><button class="btn btn-primary" data-style="slide-left" ng-click="vm.ok()">OK</button></div>');
$templateCache.put('app/admin/flyers/flyers-description-modal.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" style="text-transform: uppercase" data-translate="flyers.detail.about">Flyer About</h4></div><div class="modal-body"><div slim-scroll max-height="425px" style="text-align: justify;\n    text-justify: inter-word"><span style="word-wrap: break-word" ng-bind-html="vm.flyerDescription">{{vm.flyerDescription}}</span></div></div><div class="modal-footer"><button class="btn btn-primary" data-style="slide-left" ng-click="vm.ok()">OK</button></div>');
$templateCache.put('app/admin/flyers/flyers-detail.html','<div class="wrapper wrapper-content"><div class="row row-eq-height"><div class="col-xs-12 col-md-4"><div class="ibox flyer-detail-box" style="background-color: #FFFFFF"><div class="ibox-title"><h5 class="sc-default-title-font"><span data-translate="flyers.detail.title">Flyer Details</span></h5><span tooltip-placement="top-right" uib-tooltip="{{\'flyers.detail.buttons.info\' | translate}}" class="fa fa-pencil-square-o flyer-detail-button" has-authority="STORE_UPDATE_FLYER" ng-click="vm.getEditFlyer()"></span> <span class="fa fa-picture-o flyer-detail-button" style="padding-right: 5px" tooltip-placement="top-right" uib-tooltip="{{\'flyers.detail.buttons.image\' | translate}}" has-authority="STORE_UPDATE_FLYER" ng-click="vm.getEditFlyerImage()"></span></div><div style="background-color: #EAEAEA; height: 40%" ng-show="!vm.flyer" align="center"><span style="color: #FFFFFF; font-size: 12em; text-align: center" class="icon-ksc-storelogo"></span></div><div></div><img style="width: 100%" ng-if="vm.flyer && !vm.loadingImage" img-src="{{vm.imagePath}}"><div ng-if="vm.loadingImage" class="sk-container" style="padding-top: 40%; height: 329px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><hr class="flyer-line" ng-if="!vm.isLoading" tooltip-placement="bottom-right" uib-tooltip="{{vm.getFlyerTooltip(vm.flyer.status) | translate}}" ng-class="{\'flyer-line-activated-{{ vm.flyer.type }}\': vm.flyer.status == \'ACTIVATED\', \'flyer-line-deactivated-{{ vm.flyer.type }}\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(vm.flyer.status))}"><div class="ibox-content"><div class="row"><div class="col-xs-12" style="word-wrap: break-word; margin-top: 15px"><span class="store-item-category product-category">{{vm.flyer.category}}</span><p class="sc-default-title-font store-item-name" ng-show="!vm.isLoading" style="width: 100%">{{vm.flyer.name}}</p><p class="sc-default-subtitle-font flyer-item-contact" ng-show="!vm.isLoading" data-translate="flyers.detail.about">About the flyer</p><p flyers-description-collapse flyers-description-collapse-max-length="140" flyers-description-collapse-text="{{ vm.flyer.description }}"></p></div><div class="col-xs-12" style="display: table"><div style="display: table-cell; vertical-align: bottom; padding-bottom: 5px"><span ng-show="vm.flyer.expirationDate" tooltip-placement="bottom-left" uib-tooltip="{{\'flyers.new.form.expirationDate\' | translate}}"><i class="fa fa-clock-o product-date-icon"></i><span class="flyer-table-info product-date">{{vm.flyer.expirationDate | date: "dd/MM/yyyy"}}</span></span></div><div style="display: table-cell; text-align: right"><p class="product-info-price-normal flyer-prices-remove-margin" ng-if="vm.flyer.discountedValue && vm.flyer.purchaseValue"><span>{{vm.getFlyerCurrency(vm.flyer.currency)}} </span><span class="coupon-desactived-decoration">{{vm.flyer.purchaseValue | number : 2}}</span></p><p class="product-info-price flyer-prices-remove-margin" ng-if="vm.flyer.discountedValue"><span>{{vm.getFlyerCurrency(vm.flyer.currency)}} </span>{{vm.flyer.discountedValue | number : 2}}</p><p class="product-info-price flyer-prices-remove-margin" ng-if="!vm.flyer.discountedValue && vm.flyer.purchaseValue"><span>{{vm.getFlyerCurrency(vm.flyer.currency)}} </span>{{vm.flyer.purchaseValue | number : 2}}</p></div></div></div></div></div></div><div class="col-xs-12 col-md-8" style="padding-left: 0"><div class="ibox" style="height: 95.5%; background-color: #FFFFFF"><div class="ibox-title"><h5 class="sc-default-title-font" data-translate="flyers.detail.location">Location</h5><br></div><div class="ibox-content"><div class="col-xs-12" style="margin: 0 !important; padding: 0 !important" align="left"><div class="col-md-8" style="margin: 0 !important; padding: 0 0 0 0"><p data-translate="flyers.detail.map">View on the map the locations where coupons can be used</p></div><div class="col-md-4" style="margin: 0 !important; padding: 0 0 10px 0" align="right"><div class="checkbox" style="margin: 0 !important"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.checkAllMarkers()" ng-model="vm.allMarkersChecked"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="flyers.messages.global.checkAll">Marcar todos</span></label></div></div></div><div class="col-xs-12 loading-map-detail" ng-show="vm.isLoading"></div></div></div></div></div></div>');
$templateCache.put('app/admin/flyers/flyers-edit-image.html','<form name="flyerEditImageForm" role="form" novalidate ng-submit="vm.save()" ng-init="vm.initFlyerImageModal()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" data-translate="flyers.edit-image.title">Edit a Flyer Image</h4></div><div class="modal-body"><div class="container-fluid"><div class="row"><div class="col-xs-12"><input type="file" id="fileInput" style="display: none" accept="image/x-png,image/gif,image/jpeg"> <span class="store-upload-button" ng-click="vm.openInput($event)"><span data-translate="flyers.new.form.chooseimage">Choose Image</span><i style="margin-left: 5px" class="fa fa-upload" aria-hidden="true"></i></span> <span class="store-upload-button pull-right"><span data-translate="flyers.edit-image.editImageAlternative">Crie o seu design com o </span><a href="https://www.canva.com/pt_br/modelos/" target="_blank">Canva</a></span><div ng-show="flyerSecondForm.image.$invalid && flyerSecondForm.image.$dirty"><p class="help-block form-invalid-field" ng-show="flyerSecondForm.image.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="flyerSecondForm.image.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field is required.</p></div></div><div class="col-xs-12" style="margin-top: 15px" align="center"><div class="cropArea"><img-crop area-type="square" ng-if="vm.imageUpload" image="vm.imageUpload" result-image-size="vm.imageSize" on-load-begin="vm.imageChanged = true" result-image="vm.flyerImage" result-image-quality="1"></img-crop><span id="icon-empty" ng-if="!vm.imageUpload" style="color: #FFFFFF; font-size: 12em; text-align: center; position: relative; top: 25%" class="icon-ksc-storelogo"></span></div></div></div><div class="row" align="right" style="margin-top: 10px"><button id="btnSaveImageFlyer" ladda="vm.isSaving" type="submit" class="btn btn-primary" ng-disabled="flyerEditForm.$invalid" ng-click="vm.saveFlyer()" data-style="slide-left"><span data-translate="flyers.edit-image.button">Atualizar informa\xE7\xF5es do flyer</span></button></div></div></div></form>');
$templateCache.put('app/admin/flyers/flyers-form.html','<div class="wrapper wrapper-content animated fadeIn" id="content"><style>md-autocomplete-wrap {\n            height: 34px !important;\n            box-shadow: none !important;\n            border: 1px solid #e5e6e7;\n            border-radius: 1px;\n            height: 0px;\n        }\n\n        .md-virtual-repeat-container.md-autocomplete-suggestions-container {\n            width: 250px !important;\n        }\n\n        html.no-js.ng-scope {\n            overflow: auto !important;\n        }\n\n        .md-autocomplete-suggestions-container{\n            position: fixed !important;\n        }\n\n        md-switch .md-thumb {\n            background-color: darkgrey;\n        }\n\n        md-switch .md-bar {\n            background-color: lightgray;\n        }\n\n        md-switch:last-of-type {\n            margin: 0px;\n        }\n\n        .border-img-default {\n            border: dotted !important; border-width: 2px !important; border-color: #b9b9b9 !important;\n        }\n\n        .border-zero {\n            border: 0px !important;\n        }\n\n\t\t.ui-sortable-placeholder {\n\t\t  width: 50%;\n\t\t}\n\n\n\t\t.dragzone .product-card {\n\t\t  max-width: 100%;\n\t\t  margin: 0px;\n\t\t  padding: 5px;\n\t\t}\n\n\t\t.dragzone .product-card .product-image img {\n\t\t  width: 100%;\n\t\t}\n\n\t\t@media (min-width: 1550px) {\n\t\t  .col-lgg-1, .col-lgg-2, .col-lgg-3, .col-lgg-4, .col-lgg-5, .col-lgg-6, .col-lgg-7, .col-lgg-8, .col-lgg-9, .col-lgg-10, .col-lgg-11, .col-lgg-12 {\n\t\t    float: left; }\n\t\t  .col-lgg-1 {\n\t\t    width: 8.33333%; }\n\t\t  .col-lgg-2 {\n\t\t    width: 16.66667%; }\n\t\t  .col-lgg-3 {\n\t\t    width: 25%; }\n\t\t  .col-lgg-4 {\n\t\t    width: 33.33333%; }\n\t\t  .col-lgg-5 {\n\t\t    width: 41.66667%; }\n\t\t  .col-lgg-6 {\n\t\t    width: 50%; }\n\t\t  .col-lgg-7 {\n\t\t    width: 58.33333%; }\n\t\t  .col-lgg-8 {\n\t\t    width: 66.66667%; }\n\t\t  .col-lgg-9 {\n\t\t    width: 75%; }\n\t\t  .col-lgg-10 {\n\t\t    width: 83.33333%; }\n\t\t  .col-lgg-11 {\n\t\t    width: 91.66667%; }\n\t\t  .col-lgg-12 {\n\t\t    width: 100%; }\n\t\t  .col-lgg-pull-0 {\n\t\t    right: auto; }\n\t\t  .col-lgg-pull-1 {\n\t\t    right: 8.33333%; }\n\t\t  .col-lgg-pull-2 {\n\t\t    right: 16.66667%; }\n\t\t  .col-lgg-pull-3 {\n\t\t    right: 25%; }\n\t\t  .col-lgg-pull-4 {\n\t\t    right: 33.33333%; }\n\t\t  .col-lgg-pull-5 {\n\t\t    right: 41.66667%; }\n\t\t  .col-lgg-pull-6 {\n\t\t    right: 50%; }\n\t\t  .col-lgg-pull-7 {\n\t\t    right: 58.33333%; }\n\t\t  .col-lgg-pull-8 {\n\t\t    right: 66.66667%; }\n\t\t  .col-lgg-pull-9 {\n\t\t    right: 75%; }\n\t\t  .col-lgg-pull-10 {\n\t\t    right: 83.33333%; }\n\t\t  .col-lgg-pull-11 {\n\t\t    right: 91.66667%; }\n\t\t  .col-lgg-pull-12 {\n\t\t    right: 100%; }\n\t\t  .col-lgg-push-0 {\n\t\t    left: auto; }\n\t\t  .col-lgg-push-1 {\n\t\t    left: 8.33333%; }\n\t\t  .col-lgg-push-2 {\n\t\t    left: 16.66667%; }\n\t\t  .col-lgg-push-3 {\n\t\t    left: 25%; }\n\t\t  .col-lgg-push-4 {\n\t\t    left: 33.33333%; }\n\t\t  .col-lgg-push-5 {\n\t\t    left: 41.66667%; }\n\t\t  .col-lgg-push-6 {\n\t\t    left: 50%; }\n\t\t  .col-lgg-push-7 {\n\t\t    left: 58.33333%; }\n\t\t  .col-lgg-push-8 {\n\t\t    left: 66.66667%; }\n\t\t  .col-lgg-push-9 {\n\t\t    left: 75%; }\n\t\t  .col-lgg-push-10 {\n\t\t    left: 83.33333%; }\n\t\t  .col-lgg-push-11 {\n\t\t    left: 91.66667%; }\n\t\t  .col-lgg-push-12 {\n\t\t    left: 100%; }\n\t\t  .col-lgg-offset-0 {\n\t\t    margin-left: 0%; }\n\t\t  .col-lgg-offset-1 {\n\t\t    margin-left: 8.33333%; }\n\t\t  .col-lgg-offset-2 {\n\t\t    margin-left: 16.66667%; }\n\t\t  .col-lgg-offset-3 {\n\t\t    margin-left: 25%; }\n\t\t  .col-lgg-offset-4 {\n\t\t    margin-left: 33.33333%; }\n\t\t  .col-lgg-offset-5 {\n\t\t    margin-left: 41.66667%; }\n\t\t  .col-lgg-offset-6 {\n\t\t    margin-left: 50%; }\n\t\t  .col-lgg-offset-7 {\n\t\t    margin-left: 58.33333%; }\n\t\t  .col-lgg-offset-8 {\n\t\t    margin-left: 66.66667%; }\n\t\t  .col-lgg-offset-9 {\n\t\t    margin-left: 75%; }\n\t\t  .col-lgg-offset-10 {\n\t\t    margin-left: 83.33333%; }\n\t\t  .col-lgg-offset-11 {\n\t\t    margin-left: 91.66667%; }\n\t\t  .col-lgg-offset-12 {\n\t\t    margin-left: 100%; } }\n\n\n\t\t@media (min-width: 1880px) {\n\t\t  .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12 {\n\t\t    float: left; }\n\t\t  .col-xl-1 {\n\t\t    width: 8.33333%; }\n\t\t  .col-xl-2 {\n\t\t    width: 16.66667%; }\n\t\t  .col-xl-3 {\n\t\t    width: 25%; }\n\t\t  .col-xl-4 {\n\t\t    width: 33.33333%; }\n\t\t  .col-xl-5 {\n\t\t    width: 41.66667%; }\n\t\t  .col-xl-6 {\n\t\t    width: 50%; }\n\t\t  .col-xl-7 {\n\t\t    width: 58.33333%; }\n\t\t  .col-xl-8 {\n\t\t    width: 66.66667%; }\n\t\t  .col-xl-9 {\n\t\t    width: 75%; }\n\t\t  .col-xl-10 {\n\t\t    width: 83.33333%; }\n\t\t  .col-xl-11 {\n\t\t    width: 91.66667%; }\n\t\t  .col-xl-12 {\n\t\t    width: 100%; }\n\t\t  .col-xl-pull-0 {\n\t\t    right: auto; }\n\t\t  .col-xl-pull-1 {\n\t\t    right: 8.33333%; }\n\t\t  .col-xl-pull-2 {\n\t\t    right: 16.66667%; }\n\t\t  .col-xl-pull-3 {\n\t\t    right: 25%; }\n\t\t  .col-xl-pull-4 {\n\t\t    right: 33.33333%; }\n\t\t  .col-xl-pull-5 {\n\t\t    right: 41.66667%; }\n\t\t  .col-xl-pull-6 {\n\t\t    right: 50%; }\n\t\t  .col-xl-pull-7 {\n\t\t    right: 58.33333%; }\n\t\t  .col-xl-pull-8 {\n\t\t    right: 66.66667%; }\n\t\t  .col-xl-pull-9 {\n\t\t    right: 75%; }\n\t\t  .col-xl-pull-10 {\n\t\t    right: 83.33333%; }\n\t\t  .col-xl-pull-11 {\n\t\t    right: 91.66667%; }\n\t\t  .col-xl-pull-12 {\n\t\t    right: 100%; }\n\t\t  .col-xl-push-0 {\n\t\t    left: auto; }\n\t\t  .col-xl-push-1 {\n\t\t    left: 8.33333%; }\n\t\t  .col-xl-push-2 {\n\t\t    left: 16.66667%; }\n\t\t  .col-xl-push-3 {\n\t\t    left: 25%; }\n\t\t  .col-xl-push-4 {\n\t\t    left: 33.33333%; }\n\t\t  .col-xl-push-5 {\n\t\t    left: 41.66667%; }\n\t\t  .col-xl-push-6 {\n\t\t    left: 50%; }\n\t\t  .col-xl-push-7 {\n\t\t    left: 58.33333%; }\n\t\t  .col-xl-push-8 {\n\t\t    left: 66.66667%; }\n\t\t  .col-xl-push-9 {\n\t\t    left: 75%; }\n\t\t  .col-xl-push-10 {\n\t\t    left: 83.33333%; }\n\t\t  .col-xl-push-11 {\n\t\t    left: 91.66667%; }\n\t\t  .col-xl-push-12 {\n\t\t    left: 100%; }\n\t\t  .col-xl-offset-0 {\n\t\t    margin-left: 0%; }\n\t\t  .col-xl-offset-1 {\n\t\t    margin-left: 8.33333%; }\n\t\t  .col-xl-offset-2 {\n\t\t    margin-left: 16.66667%; }\n\t\t  .col-xl-offset-3 {\n\t\t    margin-left: 25%; }\n\t\t  .col-xl-offset-4 {\n\t\t    margin-left: 33.33333%; }\n\t\t  .col-xl-offset-5 {\n\t\t    margin-left: 41.66667%; }\n\t\t  .col-xl-offset-6 {\n\t\t    margin-left: 50%; }\n\t\t  .col-xl-offset-7 {\n\t\t    margin-left: 58.33333%; }\n\t\t  .col-xl-offset-8 {\n\t\t    margin-left: 66.66667%; }\n\t\t  .col-xl-offset-9 {\n\t\t    margin-left: 75%; }\n\t\t  .col-xl-offset-10 {\n\t\t    margin-left: 83.33333%; }\n\t\t  .col-xl-offset-11 {\n\t\t    margin-left: 91.66667%; }\n\t\t  .col-xl-offset-12 {\n\t\t    margin-left: 100%; } }\n\n        .erp-variation-icon {\n            font-size: 18px;\n            min-width: 25px;\n            text-align: center;\n        }</style><div class="ibox float-e-margins"><div class="ibox-content"><div ng-if="vm.isLoading" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><form name="vm.flyerForm" ng-if="!vm.isLoading" novalidate><!-- Product Info --><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.product-info.title"></h1><p data-translate="flyers.new.form.product-info.subtitle"></p></div></div><div class="row m-t-sm"><div class="col-md-12 col-sm-12 col-xs-12 col-lg-6 col-lgg-6 col-xl-6"><div class="row"><div class="form-group col-xs-12 col-md-8"><label class="required" for="name" data-translate="flyers.new.form.name">Name</label><div ng-class="{\'has-error\': (vm.flyerForm.name.$invalid && vm.flyerForm.name.$touched)}"><input id="name" name="name" ng-model="vm.flyer.name" type="text" class="form-control" ng-maxlength="150" ng-minlength="4" required></div><div ng-show="vm.flyerForm.name.$invalid && vm.flyerForm.name.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.name.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div><div class="form-group col-xs-12 col-md-4"><label for="productReference" data-translate="flyers.new.form.productReference">Product Reference</label><input id="productReference" name="productReference" ng-model="vm.flyer.productReference" type="text" class="form-control" placeholder="Ex: 120921212"></div></div><div class="row"><div ng-if="windowWidth <= 768" class="form-group" ng-class="vm.defaultStoreCategory === \'FASHION\' ? \'col-md-4\' : \'col-md-6\'"><label for="category" class="required" data-translate="flyers.new.form.category">category</label><select id="category" name="category" type="text" class="form-control" ng-model="vm.fullCategory" ng-options="value as value.title for (key, value) in vm.categories" ng-change="vm.selectedCategoryChange(vm.fullCategory)" required></select><div ng-show="vm.flyerForm.autocompleteFieldCategory.$invalid && vm.flyerForm.autocompleteFieldCategory.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.autocompleteFieldCategory.$error.required" data-translate="entity.validation.required"></p></div></div><div ng-if="windowWidth > 768" class="form-group col-xs-12" ng-class="vm.defaultStoreCategory === \'FASHION\' ? \'col-md-4\' : \'col-md-6\'"><label for="category" class="required" data-translate="flyers.new.form.category">Category</label><div ng-class="{\'has-error\': (vm.flyerForm.autocompleteFieldCategory.$invalid)}"><md-autocomplete required id="category" md-no-cache="true" md-search-text="vm.searchTextCategory" name="category" md-selected-item="vm.fullCategory" md-selected-item-change="vm.selectedCategoryChange(item)" md-items="item in vm.querySearchCategory(vm.searchTextCategory)" md-item-text="item.title" md-min-length="0" md-escape-options="clear" placeholder="Ex. Acess\xF3rios" input-aria-labelledby="favoriteStateLabel" md-input-name="autocompleteFieldCategory" md-item-text="item.title"><md-item-template><span md-highlight-text="vm.searchTextCategory" md-highlight-flags="^">{{item.title}}</span></md-item-template><md-not-found><span data-translate="categorys.categoryDoesNotExist">This category does not exist</span> <a ng-click="vm.newCategory(vm.searchTextCategory)" ng-disabled="vm.isCreatingCategory" data-translate="categorys.createCategory">Create category</a></md-not-found></md-autocomplete></div><div ng-show="vm.flyerForm.autocompleteFieldCategory.$invalid && vm.flyerForm.autocompleteFieldCategory.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.autocompleteFieldCategory.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-md-4" ng-if="vm.defaultStoreCategory === \'FASHION\'"><label for="gender" class="required" data-translate="flyers.new.form.gender.title">Gender</label><select id="gender" name="gender" type="text" class="form-control" ng-model="vm.flyer.gender" ng-required="vm.defaultStoreCategory === \'FASHION\'"><option value="1" data-translate="flyers.new.form.gender.male">Male</option><option value="2" data-translate="flyers.new.form.gender.female">Female</option><option value="3" data-translate="flyers.new.form.gender.both">Both</option></select><div ng-show="vm.flyerForm.gender.$invalid && vm.flyerForm.gender.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.gender.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-xs-12" ng-class="vm.defaultStoreCategory === \'FASHION\' ? \'col-md-4\' : \'col-md-6\'"><label for="dropdownMenuButtonOpt" data-translate="flyers.new.form.configurations.title">Configura\xE7\xF5es</label><div class="dropdown"><button style="text-align: left" class="btn btn-select-size dropdown-toggle" type="button" id="dropdownMenuButtonOpt" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{\'flyers.new.form.configurations.label-select\' | translate}} <i class="fa fa-caret-down"></i></button><div class="dropdown-menu" aria-labelledby="dropdownMenuButtonOpt" ng-click="$event.stopPropagation()" style="max-height: 25vh"><div class="checkbox dropdown-item" style="margin-top: 10px; margin-bottom: 10px"><label><input type="checkbox" class="dropdown-item-checkbox" checked="checked" ng-checked="vm.checkIfLaunchSelected()" ng-click="vm.updateLaunchOrRemove()"> <span class="checkbox-material"><span class="check"></span></span> {{\'flyers.new.form.configurations.launch\' | translate}}</label></div><div class="checkbox dropdown-item" style="margin-top: 10px; margin-bottom: 10px"><label><input type="checkbox" class="dropdown-item-checkbox" checked="checked" ng-checked="vm.checkIfBasicSelected()" ng-click="vm.updateBasicOrRemove()"> <span class="checkbox-material"><span class="check"></span></span> {{\'flyers.new.form.configurations.basic\' | translate}}</label></div></div></div></div></div><div class="row"><div ng-if="windowWidth <= 768" class="form-group" ng-class="vm.defaultStoreCategory === \'FASHION\' ? \'col-md-4\' : \'col-md-6\'"><label for="brandSelect" class="required" data-translate="flyers.new.form.brand">brand</label><select id="brandSelect" name="brandSelect" type="text" class="form-control" ng-model="vm.flyer.brand" ng-options="value as value.name for (key, value) in vm.brands" required></select><div ng-show="vm.flyerForm.autocompleteFieldBrand.$invalid && vm.flyerForm.autocompleteFieldBrand.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.autocompleteFieldBrand.$error.required" data-translate="entity.validation.required"></p></div></div><div ng-if="windowWidth > 768" class="form-group" ng-class="vm.defaultStoreCategory === \'FASHION\' ? \'col-md-4\' : \'col-md-6\'"><label for="brand" class="required" data-translate="flyers.new.form.brand">Brand</label><md-autocomplete id="brand" md-no-cache="true" required md-search-text="vm.searchText" id="brand" name="brand" md-selected-item="vm.flyer.brand" md-selected-item-change="vm.selectedBrandChange(item)" md-items="item in vm.querySearchBrand(vm.searchText)" md-item-text="item.name" md-min-length="0" md-escape-options="clear" placeholder="Ex. {{hubNameUpper}}" input-aria-labelledby="favoriteStateLabel" md-input-name="autocompleteFieldBrand"><md-item-template><span md-highlight-text="vm.searchText" md-highlight-flags="^">{{item.name}}</span></md-item-template><md-not-found><span data-translate="brand.brandDoesNotExist">This is brand does not exist</span> <a ng-click="vm.newBrand(vm.searchText)" data-translate="brand.createBrand">Create brand</a></md-not-found></md-autocomplete><div ng-show="vm.flyerForm.autocompleteFieldBrand.$invalid && vm.flyerForm.autocompleteFieldBrand.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.autocompleteFieldBrand.$error.required" data-translate="entity.validation.required"></p></div></div><div ng-if="windowWidth <= 768" class="form-group col-md-4" ng-show="vm.defaultStoreCategory === \'FASHION\' "><label for="colorSelect" data-translate="flyers.new.form.color">Color</label><select id="colorSelect" name="colorSelect" type="text" class="form-control" ng-model="vm.flyer.color" ng-options="value as value.name for (key, value) in vm.colors"><option value="" selected="selected"></option></select></div><div ng-if="windowWidth > 768" class="form-group col-md-4" ng-show="vm.defaultStoreCategory === \'FASHION\' "><label for="color" data-translate="flyers.new.form.color">Color</label><md-autocomplete id="color" md-no-cache="true" md-search-text="vm.searchColorText" md-input-id="color" md-input-name="color" md-selected-item="vm.flyer.color" md-items="item in vm.querySearchColor(vm.searchColorText)" md-item-text="item.name" md-min-length="0" md-escape-options="clear" placeholder="Ex. Azul" input-aria-labelledby="favoriteStateLabel" md-input-class="md-capitalize" md-input-name="autocompleteFieldColor" md-item-text="item.name"><md-item-template><span md-highlight-text="vm.searchColorText" md-highlight-flags="^">{{item.name}}</span></md-item-template><md-not-found><span data-translate="color.colorDoesNotExist">This is color does not exist</span> <a ng-click="vm.newColor(vm.searchColorText)" data-translate="color.createColor">Create color</a></md-not-found></md-autocomplete></div></div><div class="row"><div class="col-xs-12"><label for="description" data-translate="flyers.new.form.description">Description</label><textarea id="description" name="description" class="form-control" ng-model="vm.flyer.description" style="resize: both" rows="8">\n                                </textarea></div></div></div><div class="col-md-12 col-sm-12 col-xs-12 col-lg-6 col-lgg-6 col-xl-6" style="padding-left: 15px; padding-right: 15px; text-align: -webkit-center"><div class="hidden-xs row" style="justify-content: center"><div style="width: 100%; display: flex; justify-content: space-between; padding-left: 15px; padding-right: 15px"><span data-translate="flyers.edit-image.minSize" style="font-size: 11px">Recommended minimum size 600px X 600px</span> <span class="store-upload-button" style="font-size: 11px"><span data-translate="flyers.edit-image.editImageAlternative">Crie o seu design com o </span><a href="https://www.canva.com/pt_br/modelos/" target="_blank">Canva</a></span></div></div><div class="row pictures-layout" style="justify-content: center"><div class="dragzone" style="width: 100%; max-width: 100%"><ul ui-sortable="sortableOptions" style="margin-top: -6px; width: 100%" ng-model="vm.imgsFlyers" class="products"><li ng-repeat="imgFlyer in vm.imgsFlyers" tooltip-placement="top" uib-tooltip="{{\'flyers.edit-image.tooltip\' | translate}}" class="product-card" style="width: 50%"><div class="ibox no-margins border-img-default" style="width: 100%" ng-class="{\'border-img-default\': (imgFlyer.isDefault)}" ng-click="vm.openInputImage($event, imgFlyer.id)"><div class="product-image" style="height: 185px; text-align: initial; position: relative; background-color: #f4f4f5"><div ng-click="$event.stopPropagation()"><span class="fa fa-star flyer-detail-button" ng-if="imgFlyer.isThumbnail" style="padding-top: 5px; padding-left: 5px; position: initial; position: absolute; z-index: 2; color: #fec105"></span><div ng-if="!imgFlyer.isDefault"><span class="fa fa-trash flyer-detail-button" style="padding-top: 5px; padding-right: 5px; position: relative; z-index: 2" ng-click="vm.removeImgFlyer(imgFlyer.id)"></span></div></div><img style="max-height: 100%; max-width: 100%; object-fit: contain; position: absolute" ng-style="{\'object-fit\' : imgFlyer.isDefault ? \'contain\' : \'contain\'}" id="picture{{imgFlyer.id}}" ng-src="{{imgFlyer.src}}"></div></div></li></ul></div></div><div class="row" style="justify-content: center"><div style="justify-content: center"><p data-translate="flyers.edit-image.dragImages">Click and drag to sort the photos</p></div></div><!-- Inputs hidden --> <input id="imgInput1" style="display: none" type="file" accept="image/x-png,image/gif,image/jpeg" onchange="angular.element(this).scope().SelectFile(event, \'1\')"> <input id="imgInput2" style="display: none" type="file" accept="image/x-png,image/gif,image/jpeg" onchange="angular.element(this).scope().SelectFile(event, \'2\')"> <input id="imgInput3" style="display: none" type="file" accept="image/x-png,image/gif,image/jpeg" onchange="angular.element(this).scope().SelectFile(event, \'3\')"> <input id="imgInput4" style="display: none" type="file" accept="image/x-png,image/gif,image/jpeg" onchange="angular.element(this).scope().SelectFile(event, \'4\')"></div></div><!-- Demo Video --><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12 col-md-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.demo-video.title">Demo Video</h1><p data-translate="flyers.new.form.demo-video.subtitle"></p></div><div class="col-xs-12 col-md-3"><div class="checkbox pull-right active-productt-item"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableDemoVideo" ng-click="vm.changeDemoVideo()"> <span id="checkEnableTags" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.demo-video.enable"></span></label></div></div></div><div class="row" ng-show="vm.enableDemoVideo"><div class="col-xs-12 col-md-6"><label for="purchaseValue" class="required" data-translate="flyers.new.form.demo-video.title-input">Link to your product video directly from Youtube</label><input class="form-control" ng-model="vm.flyer.demoVideo" placeholder="{{\'flyers.new.form.demo-video.placeholder\' | translate }}"></div></div><!-- Product Price --><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12 col-md-6"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.price-inventory.title">Tags</h1><p data-translate="flyers.new.form.price-inventory.subtitle"></p></div><div class="col-xs-12 col-md-6"><div class="checkbox pull-right active-productt-item"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.changeIndividualPrice()" ng-checked="!vm.enableIndiviualPrice"> <span id="checkEnableIndividualPrice" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.price-inventory.disable"></span></label></div><div class="checkbox pull-right" style="margin-top: 10px; margin-right: 15px"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.changeIndividualPrice()" ng-checked="vm.enableIndiviualPrice"> <span id="checkDisableIndividualPrice" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.price-inventory.enable"></span></label></div></div></div><div class="row" ng-if="vm.enableIndiviualPrice"><div class="col-xs-12 col-md-2"><label for="purchaseValue" class="required" data-translate="flyers.new.form.purchase-value">Value</label><div class="input-group"><span class="input-group-addon">{{vm.flyer.currencyInstance.prefix }}</span> <input id="purchaseValue" name="purchaseValue" ng-model="vm.flyer.purchaseValue" type="text" class="form-control" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price ng-change="vm.checkDiscountedValue(); vm.verifyPurchaseNotValid(vm.flyer.purchaseValue);" price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true" required></div><div ng-show="vm.flyerForm.purchaseValue.$invalid && vm.flyerForm.purchaseValue.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.purchaseValue.$error.required" data-translate="entity.validation.required"></p></div><div ng-show="vm.flyerForm.purchaseValue.$invalid"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.purchaseValue.$error.pattern" data-translate="entity.validation.valueNotZero"></p></div></div><div class="col-xs-12 col-md-2"><label for="discountedValue" data-translate="flyers.new.form.discounted-value">Value</label><div class="input-group"><span class="input-group-addon">{{vm.flyer.currencyInstance.prefix }}</span> <input id="discountedValue" name="discountedValue" ng-model="vm.flyer.discountedValue" type="text" class="form-control" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price ng-change="vm.checkDiscountedValue()" price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true"></div><div ng-show="vm.flyerForm.discountedValue.$invalid && vm.flyerForm.discountedValue.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.discountedValue.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.discountedValue.$error.discountGreaterThanValue" data-translate="entity.validation.discountGreatThanValue"></p></div></div><div class="col-xs-12 col-md-2"><label for="inventory" data-translate="flyers.new.form.inventory"></label><input id="inventory" name="inventory" class="form-control" type="number" min="0" ng-model="vm.flyer.inventory" placeholder="\u221E"><div ng-show="vm.flyerForm.inventory.$invalid && vm.flyerForm.inventory.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.inventory.$error.min" data-translate="entity.validation.min" translate-value-min="0"></p></div></div><div class="col-xs-12 col-md-2"><label for="ean" data-translate="flyers.new.form.ean">EAN</label><div class="display-horizontally-inline"><input id="ean" name="ean" ng-model="vm.flyer.ean" type="text" class="form-control" placeholder="Ex: 120921212"> <i ng-if="vm.configuration && vm.configuration.partnerId == 11 && vm.flyer.erpProductId" style="color: #411D5A; font-size: 15px" class="erp-variation-icon icon-ksc-setadigital-solid" tooltip-placement="right" uib-tooltip="{{\'global.erps.info.seta.integrated\' | translate}}"></i> <i ng-if="vm.configuration && vm.configuration.partnerId == 10 && vm.flyer.erpProductId" style="color: #89bf04" class="erp-variation-icon icon-ksc-icon-bling-solid" tooltip-placement="right" uib-tooltip="{{\'global.erps.info.bling.integrated\' | translate}}"></i> <i ng-if="vm.configuration && vm.configuration.partnerId == 9 && vm.flyer.erpProductId" style="color: #da3063" class="erp-variation-icon icon-ksc-icon-nexaas-solid" tooltip-placement="right" uib-tooltip="{{\'global.erps.info.nexaas.integrated\' | translate}}"></i> <i ng-if="vm.configuration && vm.configuration.partnerId == 8 && vm.flyer.erpProductId" style="color: #00806e" class="erp-variation-icon icon-ksc-icon-varejo-online-solid" tooltip-placement="right" uib-tooltip="{{\'global.erps.info.varejoOnline.integrated\' | translate}}"></i> <i ng-if="vm.configuration && vm.configuration.id && !vm.flyer.erpProductId" style="color: #fdbe2d" class="erp-variation-icon fa fa-warning" tooltip-placement="right" uib-tooltip="{{\'global.erps.warning.notIntegrated\' | translate}}"></i></div></div><div class="col-xs-12 col-md-4 mobile-price-product" ng-style="vm.flyer.discountedValue && {\'margin-top\': \'-10px\'}"><div class="col-xs-12" ng-if="vm.flyer.purchaseValue && vm.flyer.discountedValue"><h1 class="product-new-price no-margins pull-right" style="color: rgb(146, 146, 148)"><span data-fittext data-fittext-min="15" data-fittext-max="20" data-ng-bind="vm.flyer.currencyInstance.prefix"></span> <span class="coupon-desactived-decoration" data-fittext data-fittext-min="15" data-fittext-max="20" data-ng-bind="vm.formatMoney(vm.flyer.purchaseValue)"></span></h1></div><div class="col-xs-12" ng-if="vm.flyer.purchaseValue"><h1 id="newPrice" class="product-new-price no-margins pull-right"><span data-fittext data-fittext-min="30" data-fittext-max="40" data-ng-bind="vm.flyer.currencyInstance.prefix"></span> <span class="product-new-price-value" data-fittext data-fittext-min="40" data-fittext-max="40" ng-if="vm.flyer.discountedValue" data-ng-bind="vm.formatMoney(vm.flyer.discountedValue)"></span> <span class="product-new-price-value" data-fittext data-fittext-min="40" data-fittext-max="40" ng-if="!vm.flyer.discountedValue" data-ng-bind="vm.formatMoney(vm.flyer.purchaseValue)"></span></h1></div><div class="col-xs-12" ng-if="vm.flyer.purchaseValue"><p style="text-align: end" data-translate="flyers.new.form.discount.description"></p></div></div></div><div class="row" ng-if="!vm.enableIndiviualPrice"><div class="col-xs-12"><span class="store-upload-button pointer" ng-click="vm.addDetail()"><i style="margin-right: 5px" class="fa fa-plus" aria-hidden="true"></i> <span data-translate="flyers.new.form.price-inventory.add-variation"></span></span></div><div class="col-xs-12"><div class="tab-content" ng-if="vm.flyer.details.length > 0"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th class="col-xs-1"><label data-translate="flyers.new.form.Photograph">Photograph</label></th><th class="col-xs-1"><label class="required">{{ vm.defaultStoreCategory == \'FASHION\' ? \'flyers.new.form.size.title\' : \'flyers.new.form.variation\' | translate }}</label></th><th class="col-xs-1"><label data-translate="flyers.new.form.inventory"></label></th><th class="col-xs-2"><label class="required" data-translate="flyers.new.form.purchase-value"></label></th><th class="col-xs-2"><label data-translate="flyers.new.form.discounted-value"></label></th><th class="col-xs-1"><span data-translate="flyers.new.form.quantity-by-person"></span></th><th class="col-xs-3"><label data-translate="flyers.new.form.ean"></label></th><th class="col-xs-1"></th></tr></thead><tbody><tr ng-repeat="variation in vm.flyer.details track by $index"><td style="vertical-align: middle"><div class="form-group no-margin" ng-class="{\'has-error\': (vm.flyerForm[\'varQuantityByPerson\' + $index].$invalid\n                                                     && vm.flyerForm[\'varQuantityByPerson\' + $index].$touched)}" style="max-width: 43px; text-align: center"><img ng-if="variation.imgFlyerId != null" ng-src="{{ vm.imgsFlyers[vm.getIndexImageById(variation.imgFlyerId)].src }}" alt="testimg" style="max-height: 43px; max-width: 43px" ng-click="vm.flyersSelectImageDetailModal(variation, $index)"> <img ng-if="variation.imgFlyerId == null" ng-src="{{ vm.srcImgDetailDefault }}" alt="testimg" style="max-height: 43px; max-width: 43px; border-width: 1px !important" class="ibox no-margins border-img-default" ng-click="vm.flyersSelectImageDetailModal(variation, $index)"></div></td><td style="vertical-align: middle"><div class="form-group no-margin" ng-class="{\'has-error\': ((vm.flyerForm[\'varSize\' + $index].$invalid\n                                                     && vm.flyerForm[\'varSize\' + $index].$touched) || vm.onChangeSize(variation, $index))}"><input name="varSize{{$index}}" class="form-control" type="text" ng-model="variation.size" placeholder="" required><div ng-show="vm.flyerForm[\'varSize\' + $index].$invalid && vm.flyerForm[\'varSize\' + $index].$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm[\'varSize\' + $index].$error.required" data-translate="entity.validation.required"></p></div></div></td><td style="vertical-align: middle"><div class="form-group no-margin" ng-class="{\'has-error\': (vm.flyerForm[\'varInventory\' + $index].$invalid\n                                                     && vm.flyerForm[\'varInventory\' + $index].$touched)}"><input name="varInventory{{$index}}" class="form-control" type="number" min="0" ng-model="variation.inventory" placeholder="\u221E"></div></td><td style="vertical-align: middle"><div class="form-group no-margin" ng-class="{\'has-error\': (vm.flyerForm[\'varPurchaseValue\' + $index].$invalid\n                                                     && vm.flyerForm[\'varPurchaseValue\' + $index].$touched)}"><div class="input-group"><span class="input-group-addon">{{vm.flyer.currencyInstance.prefix }}</span> <input name="varPurchaseValue{{$index}}" ng-model="variation.purchaseValue" type="text" ng-change="vm.checkVariationDiscountedValue($index); vm.verifyNotValid($index, variation.purchaseValue);" class="form-control" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true" required></div><div ng-show="vm.flyerForm[\'varPurchaseValue\' + $index].$invalid && vm.flyerForm[\'varPurchaseValue\' + $index].$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm[\'varPurchaseValue\' + $index].$error.required" data-translate="entity.validation.required"></p></div><div ng-show="vm.flyerForm[\'varPurchaseValue\' + $index].$invalid"><p class="help-block form-invalid-field" ng-show="vm.flyerForm[\'varPurchaseValue\' + $index].$error.pattern" data-translate="entity.validation.valueNotZero"></p></div></div></td><td style="vertical-align: middle"><div class="form-group no-margin" ng-class="{\'has-error\': (vm.flyerForm[\'varDiscountedValue\' + $index].$invalid\n                                                     && vm.flyerForm[\'varDiscountedValue\' + $index].$touched)}"><div class="input-group"><span class="input-group-addon">{{vm.flyer.currencyInstance.prefix }}</span> <input name="varDiscountedValue{{$index}}" ng-model="variation.discountedValue" type="text" ng-change="vm.checkVariationDiscountedValue($index)" class="form-control" price placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true"></div><div ng-show="vm.flyerForm[\'varDiscountedValue\' + $index].$invalid && vm.flyerForm[\'varDiscountedValue\' + $index].$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm[\'varDiscountedValue\' + $index].$error.discountGreaterThanValue" data-translate="entity.validation.discountGreatThanValue"></p></div></div></td><td style="vertical-align: middle"><div class="form-group no-margin" ng-class="{\'has-error\': (vm.flyerForm[\'varQuantityByPerson\' + $index].$invalid\n                                                     && vm.flyerForm[\'varQuantityByPerson\' + $index].$touched)}"><input name="varQuantityByPerson{{$index}}" class="form-control" type="number" min="1" ng-model="variation.quantityByPerson" placeholder="\u221E"></div></td><td style="vertical-align: middle"><div class="form-group no-margin display-horizontally-inline" style="width: -webkit-fill-available" ng-class="{\'has-error\': (vm.onChangeEan(variation, $index))}"><input id="ean" name="ean" ng-change="vm.onChangeEan(variation, $index)" ng-model="variation.ean" type="text" class="form-control" placeholder="Ex: 120921212"> <i ng-if="vm.configuration && vm.configuration.partnerId == 11 && variation.erpProductId" style="color: #411D5A; font-size: 15px" class="erp-variation-icon icon-ksc-setadigital-solid" tooltip-placement="top" uib-tooltip="{{\'global.erps.info.seta.integrated\' | translate}}"></i> <i ng-if="vm.configuration && vm.configuration.partnerId == 10 && variation.erpProductId" style="color: #89bf04" class="erp-variation-icon icon-ksc-icon-bling-solid" tooltip-placement="top" uib-tooltip="{{\'global.erps.info.bling.integrated\' | translate}}"></i> <i ng-if="vm.configuration && vm.configuration.partnerId == 9 && variation.erpProductId" style="color: #da3063" class="erp-variation-icon icon-ksc-icon-nexaas-solid" tooltip-placement="top" uib-tooltip="{{\'global.erps.info.nexaas.integrated\' | translate}}"></i> <i ng-if="vm.configuration && vm.configuration.partnerId == 8 && variation.erpProductId" style="color: #00806e" class="erp-variation-icon icon-ksc-icon-varejo-online-solid" tooltip-placement="top" uib-tooltip="{{\'global.erps.info.varejoOnline.integrated\' | translate}}"></i> <i ng-if="vm.configuration && vm.configuration.id && !variation.erpProductId" style="color: #fdbe2d" class="erp-variation-icon fa fa-warning" tooltip-placement="top" uib-tooltip="{{\'global.erps.warning.notIntegrated\' | translate}}"></i></div></td><td class="text-center" style="vertical-align: middle"><i class="fa fa-trash pointer" ng-click="vm.removeVariation($index)" style="font-size: 22px; margin-top: 4px"></i></td></tr></tbody></table></div></div></div></div><!-- flyers measuares --><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12 col-md-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.measures.title">Measures</h1><p data-translate="flyers.new.form.measures.subtitle"></p></div><div class="col-xs-12 col-md-3"><div class="checkbox pull-right active-productt-item"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableMeasure" ng-click="vm.changeMeasure()"> <span id="checkEnableTags" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.measures.enable-measure"></span></label></div></div></div><div class="row" ng-if="vm.enableMeasure"><div class="col-xs-12 nopadding"><div class="tab-content" ng-if="vm.flyer.details.length > 0 || vm.flyer.measureList.length"><div class="table-responsive col-xs-12 col-md-10 table-measure" style="width: auto; max-width: 86%"><table class="table table-striped table-hover" style="table-layout: auto; display: table-cell"><thead><tr><th ng-if="!vm.enableIndiviualPrice" class="col-xs-1"><label data-translate="flyers.new.form.measures.variations"></label></th><th ng-repeat="measure in vm.measureList track by $index"><div class="form-group no-margin col-xs-12"><div class="col-xs-12 nopadding"><div class="input-group"><div ng-class="{\'has-error\': (vm.flyerForm[\'varMeasureName\' + $index].$invalid && vm.flyerForm[\'varMeasureName\' + $index].$touched)}"><input name="varMeasureName{{$index}}" required ng-model="measure.name" type="text" class="form-control" placeholder="{{\'flyers.new.form.measures.height\' | translate}}"></div><span class="input-group-addon" style="border: 0px"><i class="fa fa-trash pointer" style="font-size: 22px; margin-top: 0px" ng-disabled="vm.measureList.length == 1" ng-click="vm.removeMeasure($index)" ng-style="vm.measureList.length == 1 && {\'color\': \'#676a6c\', \'cursor\': \'not-allowed\'}"></i></span></div><div ng-show="vm.flyerForm[\'varMeasureName\' + $index].$invalid && vm.flyerForm[\'varMeasureName\' + $index].$touched" ng-class="{\'has-error\': (vm.flyerForm[\'varMeasureName\' + $index].$invalid && vm.flyerForm[\'varMeasureName\' + $index].$touched)}"><p class="help-block form-invalid-field" ng-show="vm.flyerForm[\'varMeasureName\' + $index].$error.required" data-translate="entity.validation.required"></p></div></div></div></th></tr></thead><tbody><tr ng-if="vm.flyer.details.length" ng-repeat="variation in vm.flyer.details track by $index"><td><label style="font-size: 16px; margin-top: 6px">{{variation.size}}</label></td><td ng-repeat="measure in variation.measureList track by $index"><div class="form-group no-margin col-xs-12"><div class="input-group"><input name="varMeasureValue{{$index}}" ng-model="measure.value" min="1" type="text" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'varMeasureValue\' + $index].$invalid && vm.flyerForm[\'varMeasureValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'varMeasureValue\' + $index].$error.min" data-translate="entity.validation.min" translate-value-min="0"></p><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'varMeasureValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div></td></tr><tr ng-if="!vm.flyer.details.length"><td ng-repeat="measure in vm.flyer.measureList track by $index"><div class="form-group no-margin col-xs-12"><div class="input-group"><input name="varMeasureValue{{$index}}" ng-model="measure.value" min="1" type="text" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'varMeasureValue\' + $index].$invalid && vm.flyerForm[\'varMeasureValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'varMeasureValue\' + $index].$error.min" data-translate="entity.validation.min" translate-value-min="0"></p><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'varMeasureValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div></td></tr></tbody></table></div><div class="col-xs-12 col-md-2 button-measure" style="width: 13%; padding-top: 12px" uib-tooltip="{{vm.measureList.length == 5 ? \'N\xE3o \xE9 poss\xEDvel adicionar mais de 5 medidas\' : \'\'}}" style="padding-top: 13px; padding-left: 0px"><button ng-disabled="vm.measureList.length > 4" class="store-upload-button pointer" ng-click="vm.addMeasures()" style="background-color: white; border: none" ng-style="vm.measureList.length == 5 && {\'color\': \'#676a6c\', \'cursor\': \'not-allowed\'}"><i style="margin-right: 5px" class="fa fa-plus" aria-hidden="true"></i> <span data-translate="flyers.new.form.measures.add-measures"></span></button></div></div></div></div><!-- flyers dimensions --><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12 col-md-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.weight-dimensions.title">Dimensions</h1><p data-translate="flyers.new.form.weight-dimensions.subtitle"></p><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.flyer.hasLimitedShipping" ng-click="vm.changeDimension()"> <span id="checkhasLimitedShipping" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.has-limited-shipping"></span></label></div></div><div class="col-xs-12 col-md-3"><div class="checkbox pull-right active-productt-item"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableDimension" ng-click="vm.changeDimension()"> <span id="checkEnableTags" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.tags.dimension"></span></label></div></div></div><div class="row" ng-if="vm.enableIndiviualPrice && vm.enableDimension"><div class="col-xs-12 col-md-2"><label for="weight" data-translate="flyers.new.form.weight-dimensions.weight">Value</label><div class="input-group"><input id="weightValue" name="weightValue{{$index}}" ng-model="vm.flyer.dimension.weight" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">kg</span></div><div ng-show="vm.flyerForm[\'weightValue\' + $index].$invalid && vm.flyerForm[\'weightValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'weightValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div><div class="col-xs-12 col-md-2"><label for="height" data-translate="flyers.new.form.weight-dimensions.height">Value</label><div class="input-group"><input id="heightValue" name="heightValue{{$index}}" ng-model="vm.flyer.dimension.height" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'heightValue\' + $index].$invalid && vm.flyerForm[\'heightValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'heightValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div><div class="col-xs-12 col-md-2"><label for="width" data-translate="flyers.new.form.weight-dimensions.width">Value</label><div class="input-group"><input id="widthValue" name="widthValue{{$index}}" ng-model="vm.flyer.dimension.width" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'widthValue\' + $index].$invalid && vm.flyerForm[\'widthValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'widthValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div><div class="col-xs-12 col-md-2"><label for="length" data-translate="flyers.new.form.weight-dimensions.length">Value</label><div class="input-group"><input id="lengthValue" name="lengthValue{{$index}}" ng-model="vm.flyer.dimension.length" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'lengthValue\' + $index].$invalid && vm.flyerForm[\'lengthValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'lengthValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div><div class="hidden-xs col-xs-12 col-md-2"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/icon-send.png" style="max-width: 180px; margin-top: -70px"></div></div><div class="row" ng-if="!vm.enableIndiviualPrice && vm.enableDimension"><div class="col-xs-8"><div class="tab-content" ng-if="vm.flyer.details.length > 0"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th class="col-xs-1"><label>{{ vm.defaultStoreCategory == \'FASHION\' ? \'flyers.new.form.size.title\' : \'flyers.new.form.variation\' | translate }}</label></th><th class="col-xs-1"><label for="weight" data-translate="flyers.new.form.weight-dimensions.weight">Value</label></th><th class="col-xs-1"><label for="height" data-translate="flyers.new.form.weight-dimensions.height">Value</label></th><th class="col-xs-1"><label for="width" data-translate="flyers.new.form.weight-dimensions.width">Value</label></th><th class="col-xs-1"><label for="length" data-translate="flyers.new.form.weight-dimensions.length">Value</label></th></tr></thead><tbody><tr ng-repeat="variation in vm.flyer.details track by $index"><td><label style="font-size: 16px; margin-top: 6px">{{variation.size}}</label></td><td><div class="form-group no-margin"><div class="input-group"><input name="weightValue{{$index}}" ng-model="variation.dimension.weight" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">kg</span></div><div ng-show="vm.flyerForm[\'weightValue\' + $index].$invalid && vm.flyerForm[\'weightValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'weightValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div></td><td><div class="form-group no-margin"><div class="input-group"><input name="heightValue{{$index}}" ng-model="variation.dimension.height" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'heightValue\' + $index].$invalid && vm.flyerForm[\'heightValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'heightValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div></td><td><div class="form-group no-margin"><div class="input-group"><input name="widthValue{{$index}}" ng-model="variation.dimension.width" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'widthValue\' + $index].$invalid && vm.flyerForm[\'widthValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'widthValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div></td><td><div class="form-group no-margin"><div class="input-group"><input name="lengthValue{{$index}}" ng-model="variation.dimension.length" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'lengthValue\' + $index].$invalid && vm.flyerForm[\'lengthValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'lengthValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div></td></tr></tbody></table></div></div></div><div class="hidden-xs col-xs-4" ng-show="vm.flyer.details.length > 0"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/icon-send.png" style="max-width: 200px"></div></div><!-- Tag --><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12 col-md-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.tags.title">Tags</h1><p data-translate="flyers.new.form.tags.subtitle"></p></div><div class="col-xs-12 col-md-3"><div class="checkbox pull-right active-productt-item"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableTags" ng-click="vm.changeTags()"> <span id="checkEnableTags" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.tags.enable"></span></label></div></div></div><div class="row" ng-show="vm.enableTags"><div class="col-xs-12"><tags-input replace-spaces-with-dashes="false" ng-model="vm.flyer.tags" placeholder="{{\'flyers.new.form.tags.placeholder\' | translate }}"></div></div><!-- Schedules --><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12 col-md-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.schedules.title"></h1><p data-translate="flyers.new.form.schedules.subtitle"></p></div><div class="col-xs-12 col-md-3"><div class="checkbox pull-right active-productt-item"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableSchedules" ng-click="vm.changeSchedules()"> <span id="checkEnableSchedules" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.schedules.enable"></span></label></div></div></div><div class="row" ng-if="vm.enableSchedules"><div class="col-xs-12 col-md-6"><div class="form-group"><label for="startDate" data-translate="flyers.new.form.startDate" class="required"></label><div class="input-group date" id="startDateTime"><input name="startDate" type="text" id="startDate" class="form-control inputDate" readonly="readonly" autocomplete="off" ng-model="vm.flyer.startDate" required> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><div class="help-block-div" ng-show="vm.flyerForm.startDate.$invalid && vm.flyerForm.startDate.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.startDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.startDate.$error.minDate" data-translate="flyers.new.error.startDateGreaterOrEqualNow"></p></div></div></div><div class="col-xs-12 col-md-6"><div class="form-group"><label for="expirationDate" data-translate="flyers.new.form.expirationDate"></label><div class="input-group date" id="expirationDateTime"><input id="expirationDate" class="form-control inputDate" readonly="readonly" name="expirationDate" ng-model="vm.flyer.expirationDate"> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><div class="help-block-div" ng-show="vm.flyerForm.expirationDate.$invalid && vm.flyerForm.expirationDate.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.expirationDate.$error.required" data-translate="entity.validation.required"></p></div></div></div></div><!-- Batch Sale --><div class="hr-line-dashed" ng-if="vm.flyer.type === \'SALE\'"></div><div class="row" ng-if="vm.flyer.type === \'SALE\'"><div class="col-xs-12 col-md-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.batch-sale.title">Batch Sale</h1><p data-translate="flyers.new.form.batch-sale.subtitle"></p></div><div class="col-xs-12 col-md-3"><div class="checkbox pull-right active-productt-item"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableBatchSale" ng-click="vm.changeBatchSale()"> <span id="checkBatchSale" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.batch-sale.enable"></span></label></div></div></div><div class="row" ng-if="vm.enableBatchSale && vm.flyer.type === \'SALE\'"><div class="col-xs-12 col-md-6"><div class="form-group"><label for="bulkQuantity" class="required" data-translate="flyers.new.form.batch-sale.quantity"></label><input id="bulkQuantity" name="bulkQuantity" class="form-control" type="number" min="1" required ng-model="vm.flyer.bulkQuantity" placeholder="1"><div ng-show="vm.flyerForm.bulkQuantity.$invalid && vm.flyerForm.bulkQuantity.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.bulkQuantity.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.bulkQuantity.$error.min" data-translate="entity.validation.min" translate-value-min="0"></p></div></div></div><div class="col-xs-12 col-md-6"><div class="form-group"><label for="bulkDiscount" class="required" data-translate="flyers.new.form.batch-sale.discount"></label><div class="input-group"><span class="input-group-addon">%</span> <input id="bulkDiscount" name="discountBulkPercentage" class="form-control" type="number" required ng-model="vm.flyer.discountBulkPercentage" min="0.1" max="99.9" placeholder="5"></div><div ng-show="vm.flyerForm.discountBulkPercentage.$invalid && vm.flyerForm.discountBulkPercentage.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.discountBulkPercentage.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.discountBulkPercentage.$error.max" data-translate="entity.validation.max" translate-value-max="99.9"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.discountBulkPercentage.$error.min" data-translate="entity.validation.min" translate-value-min="0"></p></div></div></div></div><!-- Rules for Use --><div class="hr-line-dashed" ng-if="vm.flyer.type === \'COUPON\'"></div><div class="row" ng-if="vm.flyer.type === \'COUPON\'"><div class="col-xs-12 col-md-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.rules-for-use.title"></h1><p data-translate="flyers.new.form.rules-for-use.subtitle"></p></div><div class="col-xs-12 col-md-3"><div class="checkbox pull-right active-productt-item"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableRules" ng-click="vm.changeRulesForUse()"> <span id="checkBoxRules" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.rules-for-use.enable"></span></label></div></div></div><div class="row" ng-if="vm.enableRules && vm.flyer.type === \'COUPON\'"><div class="col-xs-12"><textarea id="rules" name="rulesForUse" class="form-control" ng-model="vm.flyer.rulesForUse" style="resize: none" rows="3" placeholder="" required>\n                        </textarea><div class="help-block-div m-t-xs" ng-show="vm.flyerForm.rulesForUse.$invalid && vm.flyerForm.rulesForUse.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.rulesForUse.$error.required" data-translate="entity.validation.required"></p></div></div></div><!-- Map --><div class="hidden-xs hr-line-dashed" ng-if="vm.mainMap.markers && vm.mainMap.markers.length > 1"></div><div class="hidden-xs row" ng-if="vm.mainMap.markers && vm.mainMap.markers.length > 1"><div class="col-xs-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.sales-point.title"></h1><p data-translate="flyers.new.form.sales-point.subtitle"></p></div><div class="col-xs-3"><div class="checkbox pull-right active-productt-item"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.checkAllMarkers()" ng-model="vm.allSalesPoint"> <span id="checkBoxSalesPoint" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.messages.global.checkAll">Marcar todos</span></label></div></div></div><div class="hidden-xs row" ng-if="vm.mainMap.markers && vm.mainMap.markers.length > 1"><div class="col-xs-12"><ui-gmap-google-map center="vm.mainMap.center" zoom="vm.mainMap.zoom" control="vm.mainMap.controls" options="vm.options" style="height: 350px"><ui-gmap-markers models="vm.mainMap.markers" coords="\'self\'" idkey="\'id\'" options="\'options\'" events="vm.mainMap.markerEvents" fit="\'true\'"></ui-gmap-markers><ui-gmap-window show="vm.mainMap.window.show" coords="vm.mainMap.window.model" options="vm.mainMap.window.options" templateurl="\'app/admin/flyers/flyers-marker.tpl.html\'" templateparameter="vm.mainMap.window.model" closeclick="vm.mainMap.window.closeClick()"></ui-gmap-window></ui-gmap-google-map></div></div></form><div class="row m-t-md"><div class="col-xs-12"><button id="btnCreateFlyer" ladda="vm.isSaving" class="btn btn-primary btn-large pull-right" ng-click="vm.uploadImage()" data-style="slide-left"><span data-translate="global.form.save"></span> <span class="fa fa-sign-in m-l-xs" style="font-size: 1.3em" aria-hidden="true"></span></button><div class="pull-right" style="margin-right: 15px; margin-bottom: 0px; margin-top: 5px"><md-switch ng-model="vm.flyer.isPublished"><span data-translate="flyers.new.form.is-published">Is published</span></md-switch></div></div></div></div></div></div>');
$templateCache.put('app/admin/flyers/flyers-marker.tpl.html','<div class="sales-point" ng-controller="StoreMarkerController as vm" style="width: 300px; overflow-y: hidden !important"><div class="container-fluid" style="overflow: hidden !important"><div class="row"><div class="col-xs-12"><h1 class="sales-point-page-title" style="padding-left: 16px">Store point information</h1><hr style="margin-top: -5px !important; margin-bottom: 4px !important"></div></div><div class="row"><div class="col-xs-5" align="right"><span class="fa icon-ksc-salesponitss fa-3x" style="font-size: 5em; vertical-align: middle"></span></div><div class="col-xs-7"><p class="sales-point-name" style="font-size: 2vh; margin: 0; padding: 0">{{parameter.pointlocation.name}}</p><p ng-show="parameter.pointlocation.address || parameter.pointlocation.number" style="font-size: 1.5vh; margin: 0; padding: 0">{{parameter.pointlocation.address}},{{parameter.pointlocation.number}}</p><p ng-show="parameter.pointlocation.city || parameter.pointlocation.state" style="font-size: 1.5vh; margin: 0; padding: 0">{{parameter.pointlocation.city}}/{{parameter.pointlocation.state}}</p><p style="font-size: 1.5vh; margin: 0; padding: 0">{{parameter.pointlocation.contactPhone}}</p></div></div></div></div>');
$templateCache.put('app/admin/flyers/flyers-select-image-detail.html','<style>.border-select-modal {\n        border-color: var(--main-color) !important;\n    }</style><form name="flyerEditImageForm" role="form" novalidate><div class="modal-header" style="border-bottom: none; padding: 15px 35px 0px"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h2 class="modal-title">Selecione uma imagem para a varia\xE7\xE3o {{ vm.size }}</h2><p>Para selecionar a imagem basta clicar sobre a imagem</p></div><div class="modal-body"><div class="container-fluid" ng-if="vm.getCountDefaultImageFlyer() != vm.imgsFlyers.length"><div class="dragzone"><ul ui-sortable="vm.sortableOptionsDetail" ng-model="vm.imgsFlyers" class="products"><li ng-repeat="imgFlyer in vm.imgsFlyers" ng-if="!imgFlyer.isDefault" class="product-card"><div class="ibox no-margins" style="width: 220px; margin-right: 5px" ng-click="vm.selectImg(imgFlyer)"><div class="product-image border-select-modal" style="height: 185px; text-align: initial; position: relative; background-color: #f4f4f5; border: 2px solid; border-radius: 5px" ng-class="{\'border-zero\': (imgFlyer.id !== vm.imgFlyerId) }" class="product-image border-select-modal"><div ng-if="imgFlyer.id === vm.imgFlyerId" style="padding-top: 5px; padding-left: 10px; position: initial; position: absolute; z-index: 2; color: #fec105"><div class="checkbox flyer-detail-button" ng-if="imgFlyer.id === vm.imgFlyerId"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="true" style="margin-top: 5px"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div></div><img style="max-height: 100%; max-width: 100%; object-fit: contain; position: absolute" ng-style="{\'object-fit\' : imgFlyer.isDefault ? \'initial\' : \'contain\'}" ng-src="{{imgFlyer.src}}"></div></div></li></ul></div></div><div class="container-fluid" ng-if="vm.getCountDefaultImageFlyer() == vm.imgsFlyers.length"><div class="dragzone" style="text-align: center"><h3>Nenhuma imagem dispon\xEDvel!</h3><p>N\xE3o existem imagens dispon\xEDveis para serem adicionadas nessa varia\xE7\xE3o.</p></div></div></div><div class="modal-footer" style="display: flex; justify-content: center; border: none; padding-top: 0px"><button class="btn btn-primary btn-large" ng-click="vm.close()"><span style="padding-left: 50px; padding-right: 50px" data-translate="global.form.done">Feito!</span></button></div></form>');
$templateCache.put('app/admin/flyers/flyers-view-structure.html','<style>.badge-details {\n        color: #5E5E5E;\n        font-family: \'Roboto\';\n        font-size: 11px;\n        font-weight: 600;\n        padding: 6px 7px;\n        text-shadow: none;\n        margin-right: 6px;\n        margin-bottom: 6px;\n        border-radius: 0px;\n        font-weight: normal;\n    }\n\n    .with-stock {\n        background-color: #eaeaea;\n    }\n\n    .out-of-stock {\n        background-color: rgb(249 203 203);\n    }\n\n    .tag-info {\n        font-size: 12px;\n        font-weight: 500;\n        word-wrap: break-word;\n    }\n\n    .btn-published {\n        margin-left: 10px;\n        border-radius: 10px;\n        background-color: white;\n        padding: 3px 8px;\n        border: 1px solid rgb(0 0 0);\n    }\n\n    .btn-published:hover,\n    .btn-published:focus {\n        background-color: #eaeaea;\n    }\n\n    .selection-actions-content {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        flex-direction: row;\n    }\n\n    .selection-content {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        flex-direction: row;\n        margin-left: 20px;\n    }\n\n    .selection-arrow {\n        cursor: pointer;\n        height: 40px;\n        width: 20px;\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .selection-arrow:hover {\n        background-color: #f3f3f4;\n        border-radius: 4px;\n    }\n\n    .selection-label {\n        padding: 10px !important;\n    }\n\n    .selection-label:hover {\n        background-color: #f3f3f4;\n        padding: 10px;\n        border-radius: 4px;\n    }\n\n    .checkbox .checkbox-material:before {\n        height: auto;\n        width: auto;\n    }\n\n    .checkbox .checkbox-material .check {\n        border-color: #D2D3D5 !important;\n    }\n\n    .checkbox .checkbox-material .check.indeterminate-checkbox {\n        border-color: var(--main-color) !important;\n    }\n\n    .action-select {\n        cursor: pointer;\n        margin-left: 20px;\n        padding: 5px;\n        font-size: 17px;\n    }\n\n    .action-select:hover {\n        background-color: #f3f3f4;\n        border-radius: 4px;\n    }\n\n    .action-caret-down {\n        margin-left: 7px;\n        font-size: 13px;\n    }\n\n    .indeterminate-icon {\n        color: var(--main-color);\n        position: absolute;\n        top: 17px;\n        left: 15px;\n    }\n\n    .sk-container {\n        position: relative;\n        display: block;\n        margin-top: 10px;\n        margin-bottom: 10px;\n        padding: 10px !important;\n    }\n\n    .store-input-nopadding {\n        padding-right: 0 !important;\n    }\n\n    .button-actions-flyers {\n        padding-right: 10px !important;\n    }\n\n    .flyer-img-erp-icon {\n        font-size: 20px;\n        background: white;\n        border-radius: 50%;\n        width: 20px;\n        height: 20px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        column-gap: 4px;\n    }</style><div class="ibox" ng-show="vm.flyersFiltered.length > 0"><div class="ibox-content" infinite-scroll="vm.loadFlyers(vm.page + 1)" infinite-scroll-disabled="!vm.hasNextPage || vm.busy" infinite-scroll-distance="1" infinite-scroll-immediate-check="false" style="min-height: 600px"><div class="row selection-actions-content"><div class="selection-content" ng-if="!vm.loadingSelection"><div class="checkbox" ng-click="$event.stopPropagation()"><label class="selection-label"><input class="dropdown-item-checkbox" ng-checked="vm.isAllFromPageSelected()" ng-click="vm.selectItemsBy(\'ALL_FROM_PAGE\')" id="checkbox-select-all" type="checkbox"> <i class="fa fa-minus indeterminate-icon" ng-if="vm.isIndeterminate()"></i> <span class="checkbox-material"><span class="check" ng-class="{\'indeterminate-checkbox\': vm.isIndeterminate()}"></span></span></label></div><div class="dropdown open" uib-dropdown=""><div class="selection-arrow" data-toggle="dropdown" aria-expanded="true" aria-haspopup="true" uib-dropdown-toggle=""><i class="fa fa-solid fa-caret-down"></i></div><ul class="m-t-xs ng-scope dropdown-menu pull-left" uib-dropdown-menu=""><li ng-repeat="selectionType in vm.selectionTypes" ng-click="vm.selectItemsBy(selectionType.value, true)"><a class="ng-scope">{{selectionType.translation | translate}}</a></li></ul></div></div><div ng-if="vm.loadingActionRequest || vm.loadingSelection" style="margin-left: 15px"><div class="sk-container"><div class="sk-spinner sk-spinner-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div></div><span ng-if="vm.removalLoading" data-translate="flyers.selection-actions.waiting-removal"></span><div class="actions-content" ng-if="vm.existsSelectedItems() && !vm.loadingActionRequest"><div class="dropdown open" uib-dropdown=""><div class="action-select" data-toggle="dropdown" aria-expanded="true" aria-haspopup="true" uib-dropdown-toggle="">{{\'flyers.selection-actions.actions\' | translate}} <i class="fa fa-solid fa-caret-down action-caret-down"></i></div><ul class="m-t-xs ng-scope right-configuration-menu-items dropdown-menu pull-left" uib-dropdown-menu=""><li class="display-horizontally-inline" style="width: 100%" ng-repeat="action in vm.actions" ng-if="vm.showAction(action)" ng-click="action.actionFunc()"><a style="width: 100%" class="ng-scope">{{action.translation | translate}}</a><div ng-if="action.value == \'SYNC_ERP\' || action.value == \'SYNC_IMAGE_FLYERS\'" class="Badge Badge--news Badge--small"><i class="Badge-icon icon-star" tooltip-placement="top" uib-tooltip="Novidade"></i></div></li></ul></div></div></div><div class="row"><div class="ibox-content flyer-table-box" ng-click="vm.flyerDetailPage(flyer.id)" ng-if="vm.checkDisplayType(\'Table\')" ng-repeat="flyer in vm.flyersFiltered track by flyer.id"><div class="table-responsive"><table class="table shoping-cart-table"><tbody><tr width="100%"><td style="display: table-cell; vertical-align: middle" width="5%"><div class="checkbox flyer-checkbox-remove-margin" ng-click="$event.stopPropagation()" style="margin-top: 10px !important"><label><input class="dropdown-item-checkbox" ng-checked="vm.checkIfFlyerSelected(flyer)" ng-click="vm.refreshSelectedFlyers(flyer)" type="checkbox"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div></td><td width="10%"><div back-img="https://{{bucket}}.s3-sa-east-1.amazonaws.com/flyer/{{vm.listFilter.storeId}}/100x100/{{flyer.id}}.jpg{{vm.time_stamp_to_image}}" class="erp-container cart-product-imitation flyer-table-img" style="background-size: 100% 100%; padding-top: 50px !important"><i ng-if="vm.configuration && vm.configuration.partnerId == 11 && vm.isErpIntegrated(flyer)" tooltip-placement="right" uib-tooltip="{{\'global.erps.info.seta.integrated\' | translate}}" class="flyer-img-erp-icon icon-ksc-setadigital-solid" style="color: #411D5A; font-size: 15px"></i> <i ng-if="vm.configuration && vm.configuration.partnerId == 10 && vm.isErpIntegrated(flyer)" tooltip-placement="right" uib-tooltip="{{\'global.erps.info.bling.integrated\' | translate}}" class="flyer-img-erp-icon icon-ksc-icon-bling-solid" style="color: #89bf04"></i> <i ng-if="vm.configuration && vm.configuration.partnerId == 9 && vm.isErpIntegrated(flyer)" tooltip-placement="right" uib-tooltip="{{\'global.erps.info.nexaas.integrated\' | translate}}" class="flyer-img-erp-icon icon-ksc-icon-nexaas-solid" style="font-size: 18px; color: #da3063"></i> <i ng-if="vm.configuration && vm.configuration.partnerId == 8 && vm.isErpIntegrated(flyer)" tooltisp-placement="right" uib-tooltip="{{\'global.erps.info.varejoOnline.integrated\' | translate}}" class="flyer-img-erp-icon icon-ksc-icon-varejo-online-solid" style="color: #00806e"></i></div></td><td class="desc" width="60%"><h3 style="margin-top: -5px !important"><a class="text-navy"><small class="text-muted coupon-text-color product-category">{{flyer.category}}</small><p class="product-name" style="word-wrap: break-word">{{flyer.name}}</p></a></h3><div><span class="badge badge-details with-stock" ng-class="{\'out-of-stock\': flyer.inventory == 0 }" ng-if="flyer.details.length == 0" uib-tooltip="{{flyer.inventory == 0 ? \'Estoque esgotado\' : \'\'}}">Estoque: {{flyer.inventory != null ? flyer.inventory : \'Ilimitado\' }} </span><span class="badge badge-details with-stock" ng-class="{\'out-of-stock\': item.inventory <= 0 && item.inventory != null }" ng-if="flyer.details.length > 0" ng-repeat="item in flyer.details" uib-tooltip="{{item.inventory <= 0 && item.inventory != null ? \'Estoque esgotado\' : \'\'}}">{{ $localStorage.defaultStore.category == FASHION ? \'Tam\' : \'Var\'}} {{item.size}}: {{item.inventory != null ? item.inventory : \'Ilimitado\'}}</span></div><span class="badge badge-secondary badge-tag-flyer" ng-repeat="tag in flyer.tags">{{tag}}</span><div ng-click="$event.stopPropagation()" style="margin-top: 6px"><!-- <span class="fa fa-tag" ng-class="{\'ksc-tag-active\': flyer.status == \'ACTIVATED\', \'ksc-tag-inactive\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}"></span>\n                                    <span class="flyer-table-info" ng-class="{\'flyer-active\': flyer.status == \'ACTIVATED\', \'flyer-disabled\': (flyer.status == \'DEACTIVATED\' || flyer.status == \'EXPIRED\')}">{{(flyer.status == \'ACTIVATED\' ? \'flyers.offer.active\' : \'flyers.offer.disabled\') | translate}}</span> --> <span class="tag-info" ng-if="flyer.productReference" style="color: #676a6c; font-size: 10px">{{\'Cod: \' + flyer.productReference }} </span><span ng-show="flyer.expirationDate" style="margin-left: 15px" tooltip-placement="bottom-left" uib-tooltip="{{\'flyers.new.form.expirationDate\' | translate}}"><span class="fa fa-clock-o product-date">{{flyer.expirationDate | date: "dd/MM/yyyy"}}</span></span></div></td><td style="padding-top: 0px; padding-bottom: 0px" width="30%"><div class="col-xs-12" style="margin-top: 15px"><span class="product-info-price-normal" ng-if="flyer.purchaseValue && flyer.discountedValue" style="white-space: nowrap"><span class="flyer-prices-remove-margin">{{flyer.currencyInstance.prefix}} </span><span class="coupon-desactived-decoration" style="white-space: nowrap">{{flyer.purchaseValue | number: 2}}</span></span><br><span class="product-info-price flyer-table-price" ng-if="flyer.discountedValue"><span class="flyer-prices-remove-margin">{{flyer.currencyInstance.prefix}} </span>{{flyer.discountedValue | number: 2}} </span><span class="product-info-price flyer-table-price" ng-if="!flyer.discountedValue && flyer.purchaseValue"><span class="flyer-prices-remove-margin">{{flyer.currencyInstance.prefix}} </span>{{flyer.purchaseValue | number: 2}}</span></div><div class="col-xs-12" ng-click="$event.stopPropagation()" style="margin-top: 15px"><div class="float-right"><!-- <a href="" class="btn btn-xs btn-white"><i class="fa fa-share"></i> Compartilhar</a> --> <a class="btn btn-xs btn-white" href="" ng-click="vm.publishFlyer(flyer.id)" ng-if="!vm.checkFlyerIsSelected(flyer)"><i class="fa fa-arrow-up"></i> {{\'flyers.selection-actions.publish-single\' | translate}} </a><a class="btn btn-xs btn-white btn-color" href="" ng-click="vm.unpublishFlyer(flyer.id)" ng-if="vm.checkFlyerIsSelected(flyer)"><i class="fa fa-times"></i> {{\'flyers.selection-actions.unpublish-single\' | translate}}</a></div></div></td></tr></tbody></table></div><hr class="flyer-table-line"></div><div ng-class="{\'col-xs-12 col-sm-4 col-md-3\': vm.checkDisplayType(\'Cards\')}" ng-click="vm.flyerDetailPage(flyer.id)" ng-if="vm.listFlyers && vm.checkDisplayType(\'Cards\')" ng-repeat="flyer in vm.flyersFiltered track by flyer.id" style="padding-left: 9px; padding-right: 9px; margin-bottom: -8px"><div class="ibox"><div class="ibox-content product-box flyer-box"><div class="product-imitation flyer-card-background" ng-style="{\'background-image\': \'url(/flyer/api/{{flyer.id}}/picture?r={{vm.randomTime}})\', \'padding-top\' : \'100% !important\'}"><div class="checkbox coupon-checkbox" ng-click="$event.stopPropagation()"><label><input class="dropdown-item-checkbox" ng-checked="vm.checkIfFlyerSelected(flyer.id)" ng-click="vm.refreshSelectedFlyers(flyer)" type="checkbox"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div></div><hr class="flyer-line" ng-class="{\'flyer-line-activated-{{ flyer.type }}\': flyer.status == \'ACTIVATED\', \'flyer-line-deactivated-{{ flyer.type }}\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}" tooltip-placement="bottom-right" uib-tooltip="{{vm.getFlyerTooltip(flyer.status) | translate}}"><div class="product-desc" style="padding: 17px !important"><small class="text-muted coupon-text-color product-category">{{flyer.category}}</small><div class="flyer-card-name"><p class="product-name" style="word-wrap: break-word">{{flyer.name}}</p></div><div class="row"><div class="col-xs-12 store-input-nopadding"><div align="left" class="col-xs-5" style="margin-top: 20px; height: 3vh"><span data-fittext data-fittext-max="15" data-fittext-min="1" ng-show="flyer.expirationDate" style="white-space: nowrap" tooltip-placement="bottom-left" uib-tooltip="{{\'flyers.new.form.expirationDate\' | translate}}"><i class="fa fa-clock-o product-date-icon"></i> <span class="product-date flyer-card-space" data-ng-bind="flyer.expirationDate | date: \'dd/MM/yyyy\'"></span></span></div><div align="right" class="col-xs-7 store-input-nopadding"><span class="product-info-price-normal flyer-prices-remove-margin" ng-if="flyer.purchaseValue && flyer.discountValue" style="white-space: nowrap"><span>{{flyer.currencyInstance.prefix}} </span><span class="coupon-desactived-decoration" ng-if="flyer.purchaseValue && flyer.discountValue" style="white-space: nowrap">{{flyer.purchaseValue | number: 2}}</span></span><br><span class="product-info-price flyer-prices-remove-margin" ng-if="flyer.discountValue"><span>{{flyer.currencyInstance.prefix}} </span>{{flyer.discountedValue | number: 2}} </span><span class="product-info-price flyer-prices-remove-margin" ng-if="!flyer.discountValue && flyer.purchaseValue"><span>{{flyer.currencyInstance.prefix}} </span>{{flyer.purchaseValue | number: 2}}</span></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/flyers/flyers.html','<style>div.scrollmenu {\n        background-color: transparent;\n        overflow: auto;\n        white-space: nowrap;\n    }\n\n    div.scrollmenu a {\n        display: inline-block;\n        color: white;\n        text-align: center;\n        padding: 14px;\n        text-decoration: none;\n    }\n\n    div.scrollmenu a:hover {\n        background-color: #e6e6e6;\n        border-top-left-radius: 5px;\n        border-top-right-radius: 5px;\n    }\n\n    .brand-select {\n        background-color: white;\n        border: 1px solid #dad6d6;\n        border-bottom: 1px solid #fff;\n        border-top-left-radius: 3px;\n        border-top-right-radius: 3px;\n    }\n\n    md-switch .md-thumb {\n        background-color: darkgrey;\n    }\n\n    md-switch .md-bar {\n        background-color: lightgray;\n    }\n\n\n    md-switch:last-of-type {\n        margin: 0px;\n    }\n\n    .brand-category md-switch .md-bar {\n        background-color: var(--main-color-dark);\n    }\n\n    .brand-category md-switch.md-checked .md-thumb {\n        background-color: var(--main-color);\n    }\n\n    .brand-category md-switch.md-checked .md-bar {\n        background-color: var(--main-color-dark);\n    }\n\n    .brand-category md-switch:last-of-type {\n        margin: 0px;\n    }\n\n    .brand-category md-switch .md-thumb {\n        background-color: var(--main-color);\n    }\n\n    .btn-filters-modal {\n        color: rgb(136, 136, 136, 1);\n        width: 100%;\n        padding: 6px 0;\n        white-space: normal !important;\n        border: 1px solid rgb(180, 179, 179);\n        background-color: white;\n        border-radius: 18px;\n        font-weight: 500;\n    }\n\n    .filter-label {\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 1.42857;\n    }</style><div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content" style="padding: 13px 20px 9px 20px"><div class="row hidden-sm hidden-md hidden-lg"><div class="col-xs-12 col-md-4"><div class="input-group date"><span class="input-group-addon"><i class="fa fa-search"></i> </span><input type="text" name="inputSearch" class="form-control" ng-change="vm.loadFlyers()" placeholder="Buscar ..." ng-model="vm.listFilter.text" ng-model-options="{ debounce: 500 }"></div></div></div><div class="row hidden-sm hidden-md hidden-lg" style="padding-top: 5px"><div class="col-xs-12 col-md-2 coupons-menu-button"><div class="d-flex justify-content-flex-end"><button class="col-xs-12 col-md-6 btn-filters-modal d-flex" ng-click="vm.openFiltersModal()" type="button" aria-expanded="false"><i class="icon-ksc-filter col-xs-3" style="margin-top: 5px; padding-left: 5px"></i> <span class="col-xs-5 filter-label" style="padding-left: 2px; margin-right: 15%; margin-top:2px">{{\'flyers.filters.title\' | translate}} </span><span ng-if="vm.numberFilterSelected > 0" class="numberCircle" style="margin-top: 2px">{{vm.numberFilterSelected}}</span></button></div></div></div><div class="row hidden-sm hidden-md hidden-lg" style="padding-top: 5px"><div class="col-xs-12"><div has-authority="STORE_CREATE_FLYER"><button class="btn btn-primary btn-block" ng-click="vm.showModalBrand()" style="white-space: normal !important; white-space: normal !important; padding-bottom: 6px; border: 1px solid rgb(180, 179, 179); background-color: white"><span class="fa fa-bookmark" style="font-size: 1.2em; color: rgb(179, 175, 175)" aria-hidden="true">&nbsp;</span> <span style="color: rgb(136, 136, 136, 1)" data-translate="brand.name">Brand</span></button></div></div></div><div class="row"><div class="hidden-xs col-xs-12 col-md-4"><div class="input-group date"><span class="input-group-addon"><i class="fa fa-search"></i> </span><input type="text" name="inputSearch" class="form-control" ng-change="vm.loadFlyers()" placeholder="{{\'flyers.home.search-hint\' | translate}}" ng-model="vm.listFilter.text" ng-model-options="{ debounce: 500 }"></div></div><div class="hidden-xs col-md-1 button-actions-flyers"><div class="store-input-nopadding"><div class="d-flex justify-content-flex-end"><button class="col-xs-12 col-md-6 btn-filters-modal d-flex" ng-click="vm.openFiltersModal()" type="button" aria-expanded="false"><span class="col-xs-5 filter-label" style="margin-right: 20px">{{\'flyers.filters.title\' | translate}} </span><span ng-if="vm.numberFilterSelected > 0" class="numberCircle" style="margin-top: 2px">{{vm.numberFilterSelected}}</span></button></div><div class="col-xs-1 store-input-nopadding hidden-xs" ng-if="false" uib-tooltip="{{(vm.displayType == \'Table\' ? \'flyers.home.buttons.view.grid\': \'flyers.home.buttons.view.list\') | translate}}"><a class="coupon-menu-button" ng-click="vm.changeDisplayType()" aria-hidden="true" tooltip-placement="top-right"><span class="fa fa-th-large coupon-text-color" style="font-size: 2.0em" ng-if="vm.checkDisplayType(\'Cards\')"></span> <span class="fa fa-th-list coupon-text-color" style="font-size: 2.0em" ng-if="vm.checkDisplayType(\'Table\')"></span></a></div></div></div><div class="hidden-xs col-sm-12 col-md-2 button-create-brands"><div has-authority="STORE_CREATE_FLYER"><button class="btn btn-primary btn-block" ng-click="vm.showModalBrand()" style="white-space: normal !important; white-space: normal !important; padding-bottom: 6px; border: 1px solid rgb(180, 179, 179); background-color: white"><span class="fa fa-bookmark" style="font-size: 1.2em; color: rgb(179, 175, 175)" aria-hidden="true">&nbsp;</span> <span style="color: rgb(136, 136, 136, 1)" data-translate="brand.name">Brand</span></button></div></div><div class="col-md-2 hidden-xs" style="padding-left: 5px; margin-right: -10px"><div has-authority="STORE_CREATE_FLYER"><a ui-sref="flyers.import"><button id="btnImportlyer" class="btn btn-primary btn-block" style="white-space: normal !important; white-space: normal !important; padding-bottom: 6px; border: 1px solid rgb(180, 179, 179); background-color: white"><span class="fa fa-cloud-upload" style="font-size: 1.2em; color: rgb(179, 175, 175)" aria-hidden="true">&nbsp;</span> <span data-translate="flyers.import.subtitle" style="color: rgb(136, 136, 136, 1)">Update Stock</span></button></a></div></div><div class="col-sm-12 col-md-2 button-create-flyer"><div has-authority="STORE_CREATE_FLYER"><a ui-sref="flyers.new"><button id="btnCreateFlyer" class="btn btn-primary btn-block" style="white-space: normal !important"><span class="fa fa-tags" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="flyers.home.buttons.new">Create flyer</span></button></a></div></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="clients-list" style="margin-top: -10px"><!-- Category --><div ng-if="vm.viewByCategories && !vm.hasActiveFilter()" class="scrollmenu" ng-class="{\'hidden-search-text\' : vm.listFilter.text !== \'\'}"><a ng-click="vm.tabCategoryClick(category.key)" ng-repeat="category in vm.categories track by category.id" ng-show="category.countFlyer > 0" ng-class="{\'brand-select\' : vm.listFilter.categoryKey == category.key}"><span style="color: #676a6c">{{category.title}}</span> <span ng-if="vm.getCountSelectedByCategory(category.key) > 0" class="label flyer-label-color">{{vm.getCountSelectedByCategory(category.key)}}</span></a></div><!-- Brand --><div ng-if="!vm.viewByCategories && !vm.hasActiveFilter()" class="scrollmenu" ng-class="{\'hidden-search-text\' : vm.listFilter.text !== \'\'}"><a ng-click="vm.tabClick(brand.name)" ng-repeat="brand in vm.brands track by brand.id" ng-show="brand.quantFlyer > 0" ng-class="{\'brand-select\' : vm.listFilter.brand == brand.name}"><span style="color: #676a6c">{{brand.name}}</span> <span ng-if="vm.getCountSelectedByBrand(brand.name) > 0" class="label flyer-label-color">{{vm.getCountSelectedByBrand(brand.name)}}</span></a></div><!-- Category --><div ng-if="vm.viewByCategories" class="tab-content" style="background-color: white; min-height: 600px"><div ng-attr-id="{{\'tab-\' + category.key}}" class="active" ng-if="vm.listFilter.categoryKey == category.key" ng-repeat="category in vm.categories track by category.id"><div ng-if="vm.busy" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div class="wrapper wrapper-content container-fluid" ng-if="vm.flyersFiltered.length <= 0 && !vm.busy"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/download-panfletos.png"><h1 data-translate="flyers.new.error.notFound">Create your first offer.</h1></div></div></div><div ng-include="\'app/admin/flyers/flyers-view-structure.html\'" ng-if="vm.flyersFiltered.length > 0"></div></div><div ng-attr-id="{{\'tab-\' + category.key}}" class="active" ng-if="vm.listFilter.categoryKey === \'\'"><div ng-if="vm.busy" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div class="wrapper wrapper-content container-fluid" ng-if="vm.flyersFiltered.length <= 0 && !vm.busy"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/download-panfletos.png"><h1 data-translate="flyers.new.error.notFound">Create your first offer.</h1></div></div></div><div ng-include="\'app/admin/flyers/flyers-view-structure.html\'" ng-if="vm.flyersFiltered.length > 0"></div></div><div nclass="active" ng-if="vm.categories.length <= 0"><div ng-if="vm.busy" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div class="wrapper wrapper-content container-fluid" ng-if="vm.flyersFiltered.length <= 0 && !vm.busy"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/download-panfletos.png"><h1 data-translate="flyers.new.error.notFound">Create your first offer.</h1></div></div></div><div ng-include="\'app/admin/flyers/flyers-view-structure.html\'" ng-if="vm.flyersFiltered.length > 0"></div></div></div><!-- Brand --><div ng-if="!vm.viewByCategories" class="tab-content" style="background-color: white; min-height: 600px"><div ng-attr-id="{{\'tab-\' + brand.name}}" class="active" ng-if="vm.listFilter.brand == brand.name" ng-repeat="brand in vm.brands track by brand.id"><div ng-if="vm.busy" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div class="wrapper wrapper-content container-fluid" ng-if="vm.flyersFiltered.length <= 0 && !vm.busy"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/download-panfletos.png"><h1 data-translate="flyers.new.error.notFound">Create your first offer.</h1></div></div></div><div ng-include="\'app/admin/flyers/flyers-view-structure.html\'" ng-if="vm.flyersFiltered.length > 0"></div></div><div ng-attr-id="{{\'tab-\' + brand.name}}" class="active" ng-if="vm.listFilter.brand === \'\'"><div ng-if="vm.busy" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div class="wrapper wrapper-content container-fluid" ng-if="vm.flyersFiltered.length <= 0 && !vm.busy"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/download-panfletos.png"><h1 data-translate="flyers.new.error.notFound">Create your first offer.</h1></div></div></div><div ng-include="\'app/admin/flyers/flyers-view-structure.html\'" ng-if="vm.flyersFiltered.length > 0"></div></div></div><div align="center" style="padding-bottom:  20px; margin-top: 20px" ng-if="vm.flyersFiltered.length > 0"><uib-pagination ng-model="vm.currentPage" total-items="vm.totalFlyers" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistry}}\', of: \'{{vm.endRegistry}}\', total: \'{{vm.totalFlyers}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalFlyers }}</p></div></div></div></div></div></div>');
$templateCache.put('app/admin/gateway/gateway.html','<div class="wrapper wrapper-content"><div class="row"><div class="ibox"><div class="ibox-content"><h2 data-translate="gateway.title">Gateway</h2><h3 data-translate="gateway.routes.title">Current routes</h3><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()" ng-show="vm.updatingRoutes == false"><span class="glyphicon glyphicon-refresh glyphicon-"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button> <button type="button" class="btn btn-danger" ng-show="vm.updatingRoutes"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button></p><table class="table table-striped table-responsive"><thead><tr><th data-translate="gateway.routes.url">URL</th><th data-translate="gateway.routes.service">Service</th><th data-translate="gateway.routes.servers">Available servers</th></tr></thead><tr ng-repeat="route in vm.gatewayRoutes"><td>{{route.path}}</td><td>{{route.serviceId}}</td><td><div ng-show="{{route.serviceInstances.length == 0}}" class="label label-danger" data-translate="gateway.routes.error">Warning: no server available!</div><table class="table table-responsive"><tr ng-repeat="instance in route.serviceInstances"><td>{{instance.host}}:{{instance.port}}</td><td ng-show="{{instance.instanceInfo.status == \'UP\'}}"><div class="label label-success">{{instance.instanceInfo.status}}</div></td><td ng-hide="{{instance.instanceInfo.status == \'UP\'}}"><div class="label label-danger">{{instance.instanceInfo.status}}</div></td></tr></table></td></tr></table></div></div></div></div>');
$templateCache.put('app/admin/gift-card/gift-card-validate.html','<div class="wrapper wrapper-content ng-scope"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content text-center p-md"><h2><span>{{\'gift-card.banner.description-1\' | translate}}</span></h2><p><span>{{\'gift-card.banner.description-2\' | translate}}</span></p></div></div></div></div><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content showcase-box-content"><div class="row"><div class="col-xs-6 b-r"><form class="" ng-submit="vm.validateGiftCard()" id="vm.formGiftValidate" name="vm.formGiftValidate" novalidate role="form"><div><div class="panel-body"><div class="row"><div class="col-md-12 col-sm-12 col-xs-12 form-group"><label class="required" for="token" data-translate="gift-card.code">Code</label><input id="token" name="token" type="text" class="form-control" ng-model="vm.giftCard.token" ng-maxlength="6" ng-minlength="6" required><div class="help-block-div" ng-show="vm.formGiftValidate.token.$invalid && vm.formGiftValidate.token.$touched"><p class="help-xblock form-invalid-field" ng-show="vm.formGiftValidate.token.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formGiftValidate.token.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="6">This field cannot be longer than 6 characters.</p><p class="help-block form-invalid-field" ng-show="vm.formGiftValidate.token.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6">This field cannot be longer than 6 characters.</p></div></div></div><div class="row"><div class="col-md-12 col-sm-12 col-xs-12 form-group"><label class="required" for="cnpj" data-translate="gift-card.gift-code">Card code</label><input id="cnpj" type="text" name="cnpj" class="form-control" ng-model="vm.giftCard.cnpj" ng-cnpj ui-mask="99.999.999/9999-99" required><div class="help-block-div" ng-show="vm.formGiftValidate.cnpj.$invalid && vm.formGiftValidate.cnpj.$touched"><p class="help-block form-invalid-field" ng-show="vm.formGiftValidate.cnpj.$invalid && !vm.formGiftValidate.cnpj.$error.required" data-translate="entity.validation.cnpj">This field CNPJ is invalid.</p><p class="help-xblock form-invalid-field" ng-show="vm.formGiftValidate.cnpj.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6"><button ladda="vm.isSending" type="submit" class="btn btn-primary btn-block ng-binding" data-style="slide-left"><span data-translate="gift-card.apply">Apply</span></button></div><div class="col-xs-3"></div></div></form></div><div class="col-xs-6"><div class="col-xs-12 showcase-box-noflyer m-t-md" style="color: lightgrey"><i class="fa fa-gift" style="font-size: 12em; margin-top: 0px"></i><h1 data-translate="gift-card.validate-data" class="ng-scope"></h1></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/gift-card/gift-card.html','<div ng-if="vm.isLoading" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div class="wrapper wrapper-content container-fluid" ng-if="!vm.isLoading && vm.hubGifts === 0"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><i class="fa fa-gift text-muted" style="font-size: 12em; color: #563b97"></i><h1 data-translate="gift-card.no-gift"></h1><p class="ksc-sub-title" data-translate="gift-card.subtitle" style="width: 48% !important"></p></div></div></div><div class="wrapper wrapper-content ng-scope" ng-if="false"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content text-center p-md"><!--<div class="col-xs-12 showcase-box-noflyer m-t-md" ng-if="!vm.isLoading && vm.hubGifts === 0" >--> <i class="fa fa-gift text-muted" style="font-size: 12em"></i><h1 data-translate="gift-card.no-gift" class="ng-scope"></h1><!--</div>--></div></div></div></div></div><div class="wrapper wrapper-content ng-scope" ng-if="!vm.isLoading && vm.hubGifts !== 0"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content text-center p-md"><h2><span>Encante o seu cliente com a nova experi\xEAncia de b\xF4nus atrav\xE9s de cart\xF5es digitais.</span></h2><p><span>\xC9 simples e \xE1gil gerir a sua carteira de c\xF3digos. Em um clique, o seu cliente estar\xE1 com o Showcase Card no email.</span></p></div></div></div></div><form class="" ng-submit="vm.sendGift()" id="formGiftSending" name="vm.formGiftSending" novalidate role="form"><div class="row"><div class="col-xs-7"><div class="ibox"><div class="ibox-title"><h5>Informa\xE7\xF5es B\xE1sicas</h5></div><div class="ibox-content showcase-box-content"><div class="row"><div class="col-xs-6 b-r"><div class="row"><div class="col-md-12 col-sm-12 col-xs-12 form-group"><label for="code" data-translate="gift-card.code">Code</label><input id="code" name="code" type="text" class="form-control" ng-model="vm.giftSending.code" ng-maxlength="100" ng-minlength="4"><div class="help-block-div" ng-show="vm.formGiftSending.code.$invalid && vm.formGiftSending.$submitted"><p class="help-xblock form-invalid-field" ng-show="vm.formGiftSending.code.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formGiftSending.code.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="vm.formGiftSending.code.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="row"><div class="col-md-12 col-sm-12 col-xs-12 form-group"><label for="ov" data-translate="gift-card.ov">OV</label><input id="ov" name="ov" type="text" class="form-control" ng-model="vm.giftSending.ov" ng-maxlength="100" ng-minlength="4"><div class="help-block-div" ng-show="vm.formGiftSending.ov.$invalid && vm.formGiftSending.$submitted"><p class="help-xblock form-invalid-field" ng-show="vm.formGiftSending.ov.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formGiftSending.ov.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="vm.formGiftSending.ov.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="row"><div class="col-md-12 col-sm-12 col-xs-12 form-group"><label for="cnpj">CNPJ</label><input id="cnpj" type="text" name="cnpj" class="form-control" ng-model="vm.giftSending.cnpj" ng-cnpj ui-mask="99.999.999/9999-99"><div class="help-block-div" ng-show="vm.formGiftSending.cnpj.$invalid && vm.formGiftSending.cnpj.$touched"><p class="help-block form-invalid-field" ng-show="vm.formGiftSending.cnpj.$invalid" data-translate="entity.validation.cnpj">This field CNPJ is invalid.</p></div></div></div></div><div class="col-xs-6"><div class="col-xs-12 showcase-box-noflyer m-t-md" style="color: lightgrey"><i class="fa fa-gift" style="font-size: 12em; margin-top: 0px"></i></div></div></div></div></div></div><div class="col-xs-5"><div class="ibox"><div class="ibox-title"><h5>Dados para envio</h5></div><div class="ibox-content showcase-box-content"><p>Informe os dados de contato para envio do c\xF3digo</p><div class="row"><div class="col-xs-12"><div class="row"><div class="col-md-12 col-sm-12 col-xs-12 form-group"><label for="email" data-translate="global.form.email" class="required">Email</label><input id="email" type="email" name="email" class="form-control" ng-model="vm.giftSending.email" ng-maxlength="100" required ng-pattern=\'/^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$/i\'><div class="help-block-div" ng-show="vm.formGiftSending.email.$invalid && vm.formGiftSending.$submitted"><p class="help-xblock form-invalid-field" ng-show="vm.formGiftSending.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formGiftSending.email.$error.pattern" data-translate="global.messages.validate.email.invalid">Please input a valid email.</p><p class="help-block form-invalid-field" ng-show="vm.formGiftSending.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="row"><div class="col-md-12 col-sm-12 col-xs-12 form-group"><label id="phone" for="phone" data-translate="gift-card.phone">Phone</label><input type="tel" name="phone" id="phone" class="form-control" ng-model="vm.giftSending.phone" intl-tel-input><div class="help-block-div" ng-show="vm.formGiftSending.phone.$invalid && vm.formGiftSending.$submitted"><p class="help-block form-invalid-field" ng-show="vm.formGiftSending.phone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div><div class="row" style="margin-top: 18px"><div class="col-xs-3"></div><div class="col-xs-6"><button ladda="vm.isSending" type="submit" class="tn btn-primary btn-block nopadding ng-binding" data-style="slide-left"><span data-translate="gift-card.send">Send</span></button></div><div class="col-xs-3"></div></div></div></div></div></div></div></div></form></div>');
$templateCache.put('app/admin/health/health.html','<div class="wrapper wrapper-content"><div class="row"><div class="ibox"><div class="ibox-content"><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/hub-management/hub-management.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-xs-6 col-sm-4 col-md-5"><div class="inner-addon left-addon"><i class="glyphicon glyphicon-search"></i> <input type="text" class="form-control" ng-model="vm.searchFilter.name" placeholder="{{\'global.table.search\' | translate }}{{\'store-management.home.searchName\' | translate | lowercase}}" ng-change="vm.reloadStores(null, true)"></div></div><div class="col-xs-6 col-sm-2 col-md-3"></div><div class="col-xs-6 col-sm-4 col-md-4 pull-right" style="margin-top: 10px; outline: none" ng-click="vm.share()"><span style="float: right"><i class="fa fa-copy pull-left" style="margin: 3px"></i><md-tooltip md-direction="left">Clique para copiar seu link de compartilhamento</md-tooltip><b>Token do Hub: </b>{{vm.hub.token}}</span></div></div></div></div></div></div><div class="row"><div class="col-xs-6" ng-repeat="loading in vm.loadingArray track by $index" ng-if="vm.isLoading"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-xs-3"><div class="store-item-thumbnail-container"><div class="store-item-thumbnail"></div></div></div><div class="col-xs-7"><div class="label-loading"><div class="loading-row"></div><div class="loading-row"></div><div class="loading-row"></div></div></div></div></div></div></div><div class="col-xs-12" ng-if="vm.storesData.length <= 0 && !vm.isLoading"><div class="ibox"><div class="ibox-title"><p style="text-align: center" data-translate="store-management.home.noStores">You don\'t have stores.</p></div></div></div><div class="col-xs-12" ng-if="vm.storesData.length > 0" infinite-scroll="vm.reloadStores(vm.page + 1)" infinite-scroll-disabled="!vm.hasNextPage || vm.busy" infinite-scroll-immediate-check="false"><div ng-repeat="store in vm.storesDataFiltered track by $index" ng-if="vm.checkDisplayType(\'Table\')" ng-click="vm.checkStoreClickAction(store.id)"><div class="ibox-content store-table-box"><div class="table-responsive"><table class="table shoping-cart-table"><tbody><tr width="100%"><td width="8%"><div class="store-table-img"><img class="img-responsive" ng-src="{{store.image}}" err-src="content/images/defaultShowcaseImage.png"></div></td><td class="desc" width="72%"><p class="store-item-name sc-default-title-font sc-default-title-capitalize">{{store.name | lowercase}}</p><div class="m-t-sm"><span class="icon-ksc-salesponitss" style="font-size: 1.1em"><span class="store-item-location sc-default-subtitle-font store-card-space">{{store.numberOfPoints}} <span data-translate="store-management.home.salespoint">sales points</span> </span></span><span class="fa fa-tag coupon-text-color">{{store.numberOfFlyers}} <span class="sc-default-subtitle-font sc-default-title-capitalize" data-translate="flyers.home.title">panfletos</span></span></div></td><td width="20%" has-authority="STORE_DELETE"><div class="checkbox flyer-checkbox-remove-margin" ng-click="$event.stopPropagation()"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.storesDataFiltered[$index].checked" ng-change="vm.checkStoresToRemove()"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div></td></tr></tbody></table><hr class="store-line"></div></div></div><div ng-repeat="store in vm.storesDataFiltered track by $index" ng-if="vm.checkDisplayType(\'Cards\')" ng-class="{\'col-xs-12 col-sm-4\': vm.checkDisplayType(\'Cards\'), \'store-item-margin-right\': !vm.isEven($index+1), \'store-item-margin-left\': vm.isEven($index+1)}"><div class="ibox"><div class="ibox-content store-card-box" style="padding: 15px; 10px; 10px; 15px"><div class="row"><div class="col-xs-6 col-md-4"><div style="width: 100%; height: 15vh; font-size: 64.5%; display: table-cell; vertical-align: middle" align="center"><!-- <span style="color: #FFFFFF; font-size: 9em;" class="icon-ksc-store img-responsive" ng-show="!store.logo"></span> --> <img class="img-responsive" style="width: 100%; min-height: 40px" ng-if="store.image" ng-src="{{store.image}}" err-src="content/images/defaultShowcaseImage.png"><div ng-if="!store.image" class="sk-container" style="padding-top: 40%"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1" style="background-color: #B9B9BB"></div><div class="sk-rect2" style="background-color: #B9B9BB"></div><div class="sk-rect3" style="background-color: #B9B9BB"></div><div class="sk-rect4" style="background-color: #B9B9BB"></div><div class="sk-rect5" style="background-color: #B9B9BB"></div></div></div></div></div><div class="col-xs-6 col-md-8"><p class="store-item-category sc-default-subtitle-font">{{store.categoryName}}</p><p class="store-item-name sc-default-title-font sc-default-title-capitalize">{{store.name | lowercase}}</p><p class="store-item-contact sc-default-subtitle-font">{{store.contactPhone}}<br>{{store.email}}</p><p class="store-item-location sc-default-subtitle-font"><span class="fa fa-tag coupon-text-color" style="font-size: 1.6em"></span><span class="store-card-space coupon-text-color"><span>{{store.numberOfFlyers}} </span><span data-translate="flyers.home.title">panfletos</span></span></p></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/invoices/invoice-modal-detail.html','<div class="ibox-content p-xl" id="invoice-detail-modal"><div class="row"><div class="col-xs-5"><p class="mb-0"><span><strong data-translate="{{!vm.getDocumentType() || vm.getDocumentType() === \'CPF\' ? \'invoice.details.customerName\' : \'invoice.details.corporateReason\'}}"></strong> {{vm.invoice.fullName}}</span></p><p><span ng-if="vm.isBrl && vm.invoice.cpf"><strong data-translate="invoice.details.{{vm.getDocumentType()}}"></strong> {{vm.invoice.cpf | cpfCnpj}} </span><span ng-if="!vm.isBrl"><strong data-translate="invoice.details.documentNumber"></strong> {{vm.invoice.cpf}}</span></p><address ng-if="vm.invoice.shippingAddress"><strong>{{\'invoice.details.title.deliveryAddress\' | translate}}:</strong><br>{{vm.invoice.shippingAddress.street}}, {{vm.invoice.shippingAddress.streetNumber}}, {{vm.invoice.shippingAddress.complement ? vm.invoice.shippingAddress.complement + \', \' : \'\'}} {{vm.invoice.shippingAddress.district}}, {{vm.invoice.shippingAddress.city}}, {{vm.invoice.shippingAddress.state}}, {{vm.invoice.shippingAddress.zipCode}}<p class="no-margins" ng-if="vm.invoice.customerPhone" title="Phone"><b>{{\'invoice.details.title.phoneNumber\' | translate}}:</b> {{vm.getPhoneNumber(vm.invoice.customerPhone)}}</p><p><b>{{\'invoice.details.title.email\' | translate}}:</b> {{vm.invoice.customerEmail}}</p></address><p ng-if="vm.invoice.receiveInStore && !vm.invoice.shippingMethod"><b>{{\'invoice.details.title.deliveryMethod\' | translate}}:</b> {{\'invoice.details.title.deliveryMethodPickupInStore\' | translate}}</p><p ng-if="vm.invoice.shippingMethod"><b>{{\'invoice.details.title.deliveryMethod\' | translate}}:</b> Melhor Envio | {{vm.invoice.shippingMethod}}</p><p ng-if="!vm.invoice.shippingMethod && !vm.invoice.shippingValue && !vm.invoice.receiveInStore"><b>{{\'invoice.details.title.deliveryMethod\' | translate}}:</b> {{\'invoice.details.title.deliveryMethodCombineWithStore\' | translate}}</p><div class="hidden-on-desktop" ng-if="vm.invoice.notes"><b class="mt-0">{{\'invoice.details.title.notes\' | translate}}:</b><p style="max-width: 255ch;overflow: hidden;text-overflow: ellipsis">{{vm.invoice.notes}}</p></div></div><div class="col-xs-7 text-right"><h4>{{\'invoice.details.title.orderNumber\' | translate}}: <span>{{vm.invoice.id}}</span></h4><p><span><strong>{{\'invoice.details.title.purchaseDate\' | translate}}:</strong> {{vm.invoice.transactionDate | date:"dd/MM/yyyy HH:mm:ss"}}</span></p><p ng-if="vm.invoice.paymentMethod || vm.invoice.paymentCondition"><b data-translate="invoice.home.payment-condition.title"></b>: <span ng-if="vm.invoice.paymentMethod">{{ \'invoice.home.payment-method.\' + vm.invoice.paymentMethod | translate}}</span> <span ng-if="vm.invoice.paymentCondition">| </span><span ng-if="vm.invoice.paymentCondition">{{ \'invoice.home.payment-condition.\' + vm.invoice.paymentCondition | translate}}</span> <span ng-if="vm.invoice.paymentCondition && vm.invoice.paymentCondition === \'CREDIT_CARD\' && vm.invoice.installments">{{ \'(\' + vm.invoice.installments + \'x)\'}}</span> <span ng-if="vm.invoice.paymentCondition && vm.invoice.paymentCondition === \'CREDIT_CARD\' && vm.invoice.brandCard">| </span><span ng-if="vm.invoice.paymentCondition && vm.invoice.paymentCondition === \'CREDIT_CARD\' && vm.invoice.brandCard">{{ vm.invoice.brandCard }}</span></p><p ng-if="vm.invoice.nsu"><b>nsu:</b> {{vm.invoice.nsu}}</p><p ng-if="vm.invoice.authorizationCode"><b>{{\'invoice.authorization-code\' | translate}}:</b> {{vm.invoice.authorizationCode}}</p><p ng-if="vm.invoice.discountCouponCode"><b>{{\'invoice.details.title.coupon\' | translate}}</b>: <span>{{ vm.invoice.discountCouponCode }}</span></p><p ng-if="vm.invoice.orderId"><b>{{\'invoice.transaction-code\' | translate}}:</b> {{vm.invoice.orderId}}</p><p ng-if="vm.invoice.sellerName"><b>{{\'invoice.home.table.seller\' | translate}}:</b> {{vm.invoice.sellerName}}</p></div><div class="col-xs-12 hidden-on-mobile" ng-if="vm.invoice.notes"><b class="mt-0">{{\'invoice.details.title.notes\' | translate}}:</b><p style="max-width: 255ch;overflow: hidden;text-overflow: ellipsis">{{vm.invoice.notes}}</p></div></div><div ng-if="vm.invoice.errorMessage" class="alert alert-danger alert-dismissable error-message-center"><i class="fa fa-info-circle fa-2x mr-1" style="margin-right: 10px"></i> {{vm.invoice.errorMessage}}</div><div class="table-responsive m-t printable-table"><table class="table invoice-table"><thead><tr><th>{{\'invoice.details.title.product\' | translate}}</th><th style="text-align: left !important">{{\'invoice.details.title.ean\' | translate}}</th><th style="text-align: left !important"><span ng-if="vm.storeCategory == \'FASHION\'">{{\'invoice.details.title.size\' | translate}} </span><span ng-if="vm.storeCategory != \'FASHION\'">{{\'invoice.details.title.variation\' | translate}}</span></th><th style="text-align: left !important">{{\'invoice.details.title.color\' | translate}}</th><th class="text-center">{{\'invoice.details.title.quantity\' | translate}}</th><th class="text-center">{{\'invoice.details.title.unitPrice\' | translate}}</th></tr></thead><tbody><tr ng-repeat="order in vm.orders"><td style="width: 300px"><div class="media"><span class="media-left"><img ng-src="/flyer/api/{{order.flyerId}}/picture?type=small" style="width: 40px; height: 40px"></span><div class="media-body" style="vertical-align: middle !important"><strong>{{order.flyerName}}</strong><br><small ng-if="order.productReference && order.productReference !== \'\'">Cod: {{order.productReference}}</small></div></div></td><td class="custom-aling-td-invoice">{{order.ean ? order.ean : \'-\'}}</td><td class="custom-aling-td-invoice">{{order.size ? order.size : \'-\'}}</td><td class="custom-aling-td-invoice">{{order.color ? order.color : \'-\'}}</td><td class="custom-aling-td-invoice" style="text-align: center !important">{{order.quantity ? order.quantity : \'-\'}}</td><td class="custom-aling-td-invoice" style="text-align: end !important">{{ vm.maskPrice((order.discountedValue ? order.discountedValue : order.purchaseValue), vm.invoice.currency) }}</td></tr></tbody></table></div><table class="table invoice-total"><tbody><tr ng-if="vm.hasDiscount"><td><strong>{{\'invoice.details.title.subtotal\' | translate}} :</strong></td><td>{{ vm.maskPrice(vm.subTotal, vm.invoice.currency) }}</td></tr><!--            <tr ng-if="vm.hasDiscount">--><!--                <td><strong>{{\'invoice.details.title.discount\' | translate}} :</strong></td>--><!--                <td>{{ vm.discount | currency }}</td>--><!--            </tr>--><tr ng-if="vm.hasDiscount && vm.discounts" ng-repeat="discount in vm.discounts"><td ng-if="discount.transactionDiscountType == \'PAYMENT_CONDITION_DISCOUNT\'"><strong>{{\'invoice.details.title.discounts.\' + discount.transactionDiscountType + \'.\' + discount.paymentCondition | translate}} :</strong></td><td ng-if="discount.transactionDiscountType == \'DISCOUNT_COUPON\'"><strong>{{\'invoice.details.title.discounts.\' + discount.transactionDiscountType | translate}} :</strong></td><td>{{ vm.maskPrice(discount.calculatedDiscountValue, vm.invoice.currency) }}</td></tr><tr ng-if="!vm.hasDiscount"><td><strong>{{\'invoice.details.title.subtotal\' | translate}} :</strong></td><td>{{ vm.maskPrice(vm.invoice.totalCost, vm.invoice.currency) }}</td></tr><tr><td><strong>{{\'invoice.details.title.shipping\' | translate}} :</strong></td><td>{{ vm.maskPrice(vm.getShippingValue(), vm.invoice.currency) }}</td></tr><tr><td><strong>{{\'invoice.details.title.total\' | translate}} :</strong></td><td>{{ vm.maskPrice(vm.invoice.totalCost + vm.getShippingValue(), vm.invoice.currency) }}</td></tr></tbody></table><div id="btn-actions" class="text-right"><button ng-disabled="vm.isSaving" ng-click="vm.cancelInvoice()" class="text-left btn btn-secondary" ng-if="vm.userProfile.profileId != 7 && (vm.invoice.paymentMethod == \'DELIVERY\' || vm.invoice.paymentMethod == \'DIRECT_SALE\') && vm.invoice.status !== \'CANCELLED\' && vm.invoice.status !== \'NOT_PAID\' && vm.invoice.status !== \'REVERTED\'" style="float: left; margin-right: 5px">{{\'invoice.details.buttons.cancel\' | translate}}</button> <button ng-disabled="vm.isSaving" ng-click="vm.openRefundModal()" ng-if="vm.userProfile.profileId != 7 && (vm.invoice.paymentCondition == \'CREDIT_CARD\' && vm.invoice.nsu && (vm.invoice.status === \'PAID\' || vm.invoice.status === \'SEPARATING\' || vm.invoice.status === \'AVAILABLE_TO_DELIVERY\' || vm.invoice.status === \'DELIVERED\'))" type="button" class="text-left btn btn-secondary" style="float: left"><span>{{\'invoice.details.buttons.refund\' | translate}}</span></button> <button class="btn btn-secondary" ng-click="vm.printInvoice()"><i class="fa fa-print"></i> <span>{{\'invoice.details.buttons.print\' | translate}}</span></button> <a ng-if="vm.invoice.redirectHrefBoleto" ng-href="{{vm.invoice.redirectHrefBoleto}}" target="_blank" class="btn btn-secondary"><i class="fa fa-barcode"></i> <span>{{\'invoice.details.buttons.urlBoleto\' | translate}}</span> </a><button ng-click="vm.close()" class="btn btn-primary" style="margin-left: 5px">{{\'invoice.details.buttons.close\' | translate}}</button></div></div>');
$templateCache.put('app/admin/invoices/invoice-new.html','<style>.badge-details {\n        color: #5E5E5E;\n        font-size: 14px;\n        font-weight: 400;\n        padding: 6px 7px;\n        text-shadow: none;\n        margin-right: 6px;\n        border-radius: 0;\n        height: 26px;\n    }\n\n    .angucomplete-image {\n        border-radius: 0 !important;\n        background: #EFEFEF;\n    }\n\n\n    input::-webkit-outer-spin-button,\n\n    input::-webkit-inner-spin-button {\n\n        -webkit-appearance: none;\n        margin: 0;\n    }\n\n    input[type=number] {\n        -moz-appearance: textfield;\n        /* Firefox */\n    }\n\n    .md-autocomplete-suggestions-container .md-autocomplete-suggestions li {\n        line-height: inherit;\n        height: auto;\n        margin: 4px;\n    }\n\n    .md-autocomplete-suggestions-container.md-not-found .md-autocomplete-suggestions li {\n        line-height: 20px;\n        height: auto;\n        margin: 7px;\n        color: #acacac;\n    }\n\n    md-autocomplete-wrap {\n        height: 42px !important;\n        box-shadow: none !important;\n        border: 1px solid #e5e6e7;\n        border-radius: 4px;\n    }\n\n    .md-virtual-repeat-container.md-autocomplete-suggestions-container {\n        min-height: 42px !important;\n        width: 250px !important;\n    }\n\n    .md-virtual-repeat-container.md-autocomplete-suggestions-container.md-not-found {\n        min-height: 34px !important;\n        width: 250px !important;\n    }\n\n    md-autocomplete .md-autocomplete-input-container {\n        position: relative;\n    }\n\n    md-autocomplete .md-autocomplete-input-container::before {\n        content: \'\';\n        position: absolute;\n        top: 50%;\n        left: 10px;\n        transform: translateY(-50%);\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        background-color: red;\n    }\n\n    md-autocomplete input {\n        padding-left: 40px; /* Espa\xE7o para o c\xEDrculo */\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    .md-autocomplete-suggestions-container {\n        position: fixed !important;\n        height: 23vh !important;\n    }\n\n    .md-virtual-repeat-container .md-virtual-repeat-sizer {\n        height: 23vh !important;\n    }\n\n    .client-avatar {\n        width: 30px;\n        height: 30px;\n        margin-right: 10px;\n        border-radius: 50%;\n        align-items: center;\n        display: flex;\n        justify-content: center;\n    }\n\n    md-autocomplete-wrap:after {\n        display: block;\n        content: \'\\25BC\';\n        position: relative;\n        top: 5px;\n        speak: none;\n        font-size: 13px;\n        left: -10px;\n        color: rgba(0,0,0,0.38);\n        -webkit-transform: scaleY(.5) scaleX(1);\n        transform: scaleY(.5) scaleX(1);\n    }</style><script type="text/ng-template" id="product-template"><div class="angucomplete-holder" ng-class="{\'angucomplete-dropdown-visible\': showDropdown}">\n        <input ng-model="searchStr"\n               ng-disabled="disableInput"\n               type="text"\n               placeholder="{{placeholder}}"\n               ng-focus="onFocusHandler()"\n               class="{{inputClass}}"\n               ng-focus="resetHideResults()"\n               ng-blur="hideResults($event)"\n               autocapitalize="off"\n               autocorrect="off"\n               autocomplete="off"\n               ng-change="inputChangeHandler(searchStr)"/>\n        <div class="angucomplete-dropdown" ng-show="showDropdown">\n            <div class="angucomplete-searching" ng-show="searching" ng-bind="textSearching"></div>\n            <div class="angucomplete-searching" ng-show="!searching && (!results || results.length == 0)" ng-bind="textNoResults"></div>\n            <div class="angucomplete-row" ng-repeat="result in results" ng-click="selectResult(result)" ng-mouseenter="hoverRow($index)" ng-class="{\'angucomplete-selected-row\': $index == currentIndex}">\n                <div class="angucomplete-image-holder">\n                    <img ng-src="flyer/api/{{result.originalObject.id}}/picture?type=small" class="angucomplete-image"\n                         onerror="this.src=\'https://showkase-prod.s3.sa-east-1.amazonaws.com/marketing-objects/default-flyer-image.png\'"/>\n                </div>\n                <div class="angucomplete-title" ng-if="matchClass" ng-bind-html="result.title"></div>\n                <div class="angucomplete-title" ng-if="!matchClass">{{ result.title }}</div>\n                <div ng-if="matchClass && result.description && result.description != \'\'" class="angucomplete-description" ng-bind-html="result.description"></div>\n                <div ng-if="!matchClass && result.description && result.description != \'\'" class="angucomplete-description">{{result.description}}</div>\n            </div>\n        </div>\n    </div></script><div class="wrapper wrapper-content" style="display: flex; flex-direction: row;\n                                        justify-content: space-between; padding-bottom: 0 !important;\n                                        padding-top: 22px !important"><div class="w-100"><div class="ibox float-e-margins mb-0"><div class="ibox-content" ng-style="{\'max-height\' : vm.height - 185}" style="overflow-x: hidden; overflow-y: auto; padding-bottom: 0 !important; padding-top: 0 !important; height: 100%"><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-store-font m-l-n-xxs" data-translate="invoice.new.details-title"></h1><p data-translate="invoice.new.details-desc"></p></div><div class="col-xs-12"><label class="control-label" translate>invoice.new.add-product</label><angucomplete-alt id="products" placeholder="{{\'invoice.new.product-search\' | translate}}" text-no-results="{{\'invoice.new.no-result-found\' | translate}}" text-searching="{{\'invoice.new.searching\' | translate}}" pause="300" selected-object="vm.selectedProduct" remote-url-request-formatter="vm.requestParams" remote-url="/flyer/api/flyer/search" title-field="name" description-field="productReference" search-fields="name,productReference" minlength="2" clear-selected="true" match-class="highlight" input-class="form-control form-control-small" template-url="product-template"></div><div class="col-xs-12 m-t-md"><div ng-repeat="item in vm.invoice.items"><div class="row no-margin"><div class="col-md-1 no-padding"><img class="cart-product-imitation" style="background-size: 100% 100% !important; width: 80px; height: 80px; padding: 0; border: 1px solid #f4f4f5" ng-src="flyer/api/{{item.flyer.id}}/picture?type=normal" onerror="this.src=\'https://showkase-prod.s3.sa-east-1.amazonaws.com/marketing-objects/default-flyer-image.png\'"></div><div class="col-md-5 m-t-sm"><p class="product-name" style="word-wrap: break-word">{{item.flyer.name}}</p><span class="tag-info" ng-if="item.flyer.productReference" style="color: #676a6c; font-size: 10px">Cod: {{item.flyer.productReference}}</span><div ng-if="!item.flyer.details.length"><h3 ng-if="item.flyer.discountedValue"><span class="coupon-desactived-decoration text-muted">{{vm.currencyPrefix}}</span> <span class="coupon-desactived-decoration text-muted m-r-sm">{{item.flyer.purchaseValue | number : 2}}</span> <span style="color: #05A19C">{{vm.currencyPrefix}}</span> <span style="color: #05A19C">{{item.flyer.discountedValue | number : 2}}</span></h3><h3 ng-if="!item.flyer.discountedValue" style="color: #05A19C"><span class="flyer-prices-remove-margin">{{vm.currencyPrefix}}</span> <span>{{item.flyer.purchaseValue | number : 2}}</span></h3></div><div ng-if="item.flyer.details.length && item.detail"><h3 ng-if="item.detail.discountedValue"><span class="coupon-desactived-decoration text-muted">{{vm.currencyPrefix}}</span> <span class="coupon-desactived-decoration text-muted m-r-sm">{{item.detail.purchaseValue | number : 2}}</span> <span style="color: #05A19C">{{vm.currencyPrefix}}</span> <span style="color: #05A19C">{{item.detail.discountedValue | number : 2}}</span></h3><h3 ng-if="!item.detail.discountedValue" style="color: #05A19C"><span class="flyer-prices-remove-margin">{{vm.currencyPrefix}}</span> <span>{{item.detail.purchaseValue | number : 2}}</span></h3></div></div><div class="col-md-3 m-t-sm"><span ng-if="!item.flyer.details.length" class="badge badge-details with-stock">{{\'invoice.new.unique-size\' | translate}}</span><select class="form-control" ng-if="item.flyer.details.length" ng-model="item.detail" ng-change="item.quantity = 1; vm.calculatePrice(); vm.checkIfVariationAlreadyExists(item, $index)" ng-options="detail as detail.size for detail in vm.filterSizes(item.flyer.details) track by detail.size"><option value="" disabled="disabled" selected="selected">{{vm.filterSizes(item.flyer.details).length ? vm.storeCategory == \'FASHION\' ? \'invoice.new.size\' : \'invoice.new.variation\' : \'invoice.new.no-variation\' | translate}}</option></select><div class="row no-margin" style="font-size: 14px" ng-if="(item.flyer.details.length && item.detail) ||\n                                             (!item.flyer.details.length && (item.flyer.inventory > 0|| item.flyer.inventory == null))"><i class="fa fa-tag" ng-style="{\'color\' : \'#08b309\'}"></i> <small ng-if="item.detail">{{\'invoice.new.inventory-available\' | translate}}: <span ng-if="item.detail.inventory">{{item.detail.inventory}}</span> </small><small ng-if="!item.detail && item.flyer.inventory && item.flyer.inventory !== 0">{{\'invoice.new.inventory-available\' | translate}}: {{item.flyer.inventory}} </small><small ng-if="!item.detail && item.flyer.inventory == null">{{\'invoice.new.inventory-available\' | translate}}: {{\'invoice.new.unlimited\' | translate}}</small></div></div><div class="col-md-2 m-t-sm"><div class="input-group" style="background-color: #fff; width: min-content; margin: 0 auto"><div class="input-group-addon" ng-click="vm.changeQuantity(item, -1)" role="button">-</div><input class="form-control quant-input ng-pristine ng-valid ng-not-empty ng-touched" size="1" ng-model="item.quantity" ng-disabled="item.flyer.details.length && !item.detail" style="text-align: center; margin-top: 0; padding-right: 3px; padding-left: 3px; min-width: 50px" aria-invalid="false" type="number" min="0" oninput="this.value = Math.abs(this.value)" ng-change="vm.onChangeQuantity(item)"><div class="input-group-addon" ng-click="vm.changeQuantity(item, 1)" role="button">+</div></div></div><div class="col-md-1 m-t-sm"><div class="m-t-xs text-center"><i class="fa fa-clone fa-2x text-muted" ng-click="vm.duplicateProduct(item.flyer)" tooltip-placement="top-right" uib-tooltip="Duplicar"></i> <i class="icon-ksc-trash fa-2x text-muted" ng-click="vm.deleteProduct($index)" tooltip-placement="top-right" uib-tooltip="Remover"></i></div></div></div><hr class="hr-line-solid"></div></div><div class="col-md-offset-6 col-md-6 col-xs-12" ng-if="vm.invoice.items.length"><div class="row col-md-12"><div class="col-md-5 col-xs-5"><h3>Subtotal:</h3></div><div class="col-md-6 col-xs-7"><h3>{{vm.currencyPrefix}} {{vm.invoice.subTotal | number : 2}}</h3></div></div><div class="row col-md-12" style="padding-top: 5px; padding-bottom: 5px"><div class="col-md-5 col-xs-5"><h3>{{\'invoice.new.shipping\' | translate}}:</h3></div><div class="col-md-5 col-xs-6"><div class="input-group"><span class="input-group-addon" style="border-top-left-radius: 5px; border-bottom-left-radius: 5px">{{vm.currencyPrefix}}</span> <input id="purchaseValue" ng-model="vm.invoice.shippingValue" type="text" class="form-control" placeholder="0,00" price ng-change="vm.calculatePrice()" price-decimal-separator="," price-thousand-separator="." price-activated="true"></div></div></div><div class="row col-md-12" style="padding-bottom: 5px"><div class="col-md-5 col-xs-5"><h3>{{\'invoice.new.discount-coupon\' | translate}}:</h3></div><div class="col-md-5 col-xs-6"><angucomplete-alt id="discount-coupon" style="padding-top: 2px" placeholder="{{\'invoice.new.coupon-search\' | translate}}" text-no-results="{{\'invoice.new.no-result-found\' | translate}}" text-searching="{{\'invoice.new.searching\' | translate}}" pause="400" input-changed="vm.changeDiscountCoupon" selected-object="vm.selectedDiscountCoupon" remote-url-request-formatter="vm.requestDiscountCouponParams" remote-url="/admin/api/discount-coupons" title-field="name" minlength="2" match-class="highlight" description-field="code" input-class="form-control form-control-small"></div></div><div class="row col-md-12" style="padding-bottom: 5px" ng-if="vm.selectedCoupon"><div class="col-md-5 col-xs-5"><h3>{{\'invoice.new.coupon\' | translate}}:</h3></div><div class="col-md-5 col-xs-6"><div class="input-group"><span ng-if="vm.selectedCoupon.discountType == \'PERCENTAGE\'" class="input-group-addon" style="border-top-left-radius: 5px; border-bottom-left-radius: 5px">{{ \'invoice.new.percentage\' | translate}} </span><span ng-if="vm.selectedCoupon.discountType != \'PERCENTAGE\'" class="input-group-addon" style="border-top-left-radius: 5px; border-bottom-left-radius: 5px">{{ \'invoice.new.brl\' | translate}} </span><input id="purchaseDiscountType1" ng-if="vm.selectedCoupon.discountType != \'FREE_SHIPPING\'" ng-model="vm.selectedCoupon.discount" type="text" ng-disabled="true" class="form-control" placeholder="0,00" price price-decimal-separator="," price-thousand-separator="." price-activated="true"> <input id="purchaseDiscountTypew" ng-if="vm.selectedCoupon.discountType == \'FREE_SHIPPING\'" ng-model="vm.invoice.shippingValue" type="text" ng-disabled="true" class="form-control" placeholder="0,00" price price-decimal-separator="," price-thousand-separator="." price-activated="true"></div></div></div><div class="row col-md-12" style="padding-top: 5px; padding-bottom: 5px" ng-if="vm.invoice.discount"><div class="col-md-5 col-xs-5"><h3>Desconto:</h3></div><div class="col-md-6 col-xs-7"><h3>{{vm.currencyPrefix}} {{vm.invoice.subTotal && vm.invoice.subTotal > 0 ? vm.invoice.discount : 0 | number : 2}}</h3></div></div><div class="row col-md-12" style="padding-top: 5px; padding-bottom: 5px"><div class="col-md-5 col-xs-5"><h3>Total:</h3></div><div class="col-md-6 col-xs-7"><h3>{{vm.currencyPrefix}} {{vm.purchaseValue | number : 2}}</h3></div></div></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-store-font m-l-n-xxs">{{ \'invoice.new.customer-title\' | translate }}</h1><p translate>invoice.new.customer-desc</p></div><div class="row no-margin"><div class="col-md-7 form-group"><label class="control-label required" for="customer" data-translate="global.form.fullName">Name</label><angucomplete-alt id="customer" placeholder="{{\'invoice.new.customer-search\' | translate}}" text-no-results="{{\'invoice.new.no-result-found\' | translate}}" text-searching="{{\'invoice.new.searching\' | translate}}" pause="400" input-changed="vm.changeCustomer" selected-object="vm.selectedCustomer" remote-url-request-formatter="vm.requestParams" remote-url="/admin/api/customers" title-field="fullName" minlength="2" match-class="highlight" description-field="phone" input-class="form-control form-control-small"></div><div class="col-md-5 form-group"><label for="phone" class="required" data-translate="invoice.new.phone">Phone/Whatsapp</label><input type="tel" name="phone" id="phone" class="form-control" ng-model="vm.invoice.customer.phone" ng-disabled="vm.invoice.customer.id" intl-tel-input required></div></div><div class="row no-margin"><div class="col-md-2 form-group"><label for="cpf" ng-class="{\'required\': vm.store.hasErp}" data-translate="invoice.details.documentNumber">CPF</label><input type="text" name="cpf" id="cpf" class="form-control" ng-model="vm.invoice.customer.customerIdentity" ui-br-cpfcnpj-mask ng-required="vm.store.hasErp"></div></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-store-font m-l-n-xxs" translate>invoice.new.seller-title</h1><p translate>invoice.new.seller-desc</p></div><div class="col-md-7 col-xs-12"><label class="control-label" for="customer" data-translate="invoice.new.seller-label">Vendedor</label><md-autocomplete md-no-cache="true" class="custom-md-autocomplete" md-search-text="vm.searchTextSeller" name="seller" md-selected-item="vm.selectedSeller" md-items="item in vm.querySearchSellers(vm.searchTextSeller)" md-item-text="vm.getTreatedName(item)" md-min-length="0" placeholder="{{\'invoice.new.seller-search\' | translate}}" md-selected-item-change="vm.selectedSellerChange(item)" md-item-text="item.firstName" md-autofocus="true"><md-item-template><div class="row" style="display: flex; align-items: center"><div class="client-avatar" ng-style="{\'background-color\': item.userProfiles[0].colorCode}"><span style="color: white">{{item.firstName.charAt(0).toUpperCase()}}</span></div><div><div md-highlight-text="vm.searchTextSeller" md-highlight-flags="^">{{vm.getTreatedName(item)}}</div><div style="font-size: 10px; color: #676a6c">{{item.profilesName}}</div></div></div></md-item-template><md-not-found>{{\'invoice.new.no-result-found\' | translate}}</md-not-found></md-autocomplete></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12"><div class="row"><div class="col-md-12 col-xs-12"><h1 class="sc-default-title-store-font m-l-n-xxs" translate>invoice.new.shipping-title</h1><p ng-if="vm.invoice.shippingOption === \'PICK_UP_IN_STORE\'" translate>invoice.new.shipping-desc-1</p><p ng-if="vm.invoice.shippingOption === \'RECEIVE_AT_HOME\'" translate>invoice.new.shipping-desc-2</p></div><div class="col-md-8 col-xs-12 m-t-sm"><div class="row"><div class="col-xs-6"><label style="font-size: 16px"><input type="radio" name="radioShipping" ng-model="vm.invoice.shippingOption" ng-value="\'PICK_UP_IN_STORE\'"> {{\'invoice.new.pick-up-at-store\' | translate}}</label></div><div class="col-xs-6"><label style="font-size: 16px"><input type="radio" name="radioShipping" ng-model="vm.invoice.shippingOption" ng-value="\'RECEIVE_AT_HOME\'"> {{\'invoice.new.receive-at-home\' | translate}}</label></div></div></div></div><div ng-if="vm.invoice.shippingOption === \'RECEIVE_AT_HOME\'" class="m-t-sm"><div class="row"><div ng-if="vm.isBrl" class="col-md-3 form-group"><label class="required" for="zipcode" data-translate="global.form.zipcode">Zipcode</label><input id="zipcode" name="zipcode" type="text" class="form-control" ng-maxlength="8" ng-model="vm.invoice.customer.zipcode" numbers-only ng-change="vm.checkCEP()"></div><div ng-if="!vm.isBrl" class="col-md-3 form-group"><label class="required" for="zipcode" data-translate="global.form.zipcode">Zipcode</label><input id="zipcode" name="zipcode" type="text" class="form-control" ng-model="vm.invoice.customer.zipcode" numbers-only></div><div class="col-md-5 form-group"><label class="required" for="address" data-translate="global.form.address">Address</label><input id="address" name="address" type="text" class="form-control" ng-model="vm.invoice.customer.address" ng-maxlength="100"></div><div class="col-md-2 form-group"><label class="required" for="addressNumber" data-translate="global.form.number">Number</label><input id="addressNumber" name="addressNumber" type="text" class="form-control" ng-model="vm.invoice.customer.addressNumber" maxlength="10"></div><div class="col-md-2 form-group"><label for="complement" data-translate="global.form.complement">Complement</label><input id="complement" name="complement" type="text" class="form-control" ng-model="vm.invoice.customer.complement" ng-maxlength="100"></div></div><div class="row"><div class="col-md-4 form-group"><label class="required" for="district" data-translate="global.form.district">District</label><input id="district" name="district" type="text" class="form-control" ng-model="vm.invoice.customer.district" ng-maxlength="100"></div><div class="col-md-4 form-group"><label class="required" for="city" data-translate="global.form.city">City</label><input id="city" name="city" type="text" class="form-control" ng-model="vm.invoice.customer.city" ng-maxlength="50"></div><div ng-if="vm.isBrl" class="col-md-4 form-group"><label class="required" for="state" data-translate="global.form.state">State</label><select id="state" class="form-control" name="state" ng-model="vm.invoice.customer.state" required><option ng-selected="state.uf == vm.invoice.customer.state" ng-repeat="state in vm.states" ng-value="{{state.uf}}">{{state.uf}} - {{state.name}}</option></select></div><div ng-if="!vm.isBrl" class="col-md-4 form-group"><label class="required" for="state" data-translate="global.form.state">State</label><input id="state" name="state" type="text" class="form-control" ng-model="vm.invoice.customer.state" ng-maxlength="50"></div></div></div></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12"><div class="row"><div class="col-md-12 col-xs-12"><h1 class="sc-default-title-store-font m-l-n-xxs">{{\'invoice.new.payment-method-title\' | translate}}</h1><p ng-if="vm.invoice.paymentCondition === \'MONEY\'" translate>invoice.new.payment-method-desc-1</p><p ng-if="vm.invoice.paymentCondition === \'CREDIT_CARD\'" translate>invoice.new.payment-method-desc-2</p></div><div class="col-md-8 col-xs-12 m-t-sm"><div class="row"><div class="col-xs-6"><label ng-if="vm.isBrl" style="font-size: 16px"><input type="radio" name="radioPayment" ng-model="vm.invoice.paymentCondition" ng-value="\'MONEY\'"> {{\'invoice.new.pix-money\' | translate}}</label><label ng-if="!vm.isBrl" style="font-size: 16px"><input type="radio" name="radioPayment" ng-model="vm.invoice.paymentCondition" ng-value="\'MONEY\'"> {{\'invoice.new.money\' | translate}}</label></div><div class="col-xs-6"><label style="font-size: 16px"><input type="radio" name="radioPayment" ng-model="vm.invoice.paymentCondition" ng-value="\'CREDIT_CARD\'"> {{\'invoice.new.credit-card\' | translate}}</label></div></div></div></div></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-store-font m-l-n-xxs" translate>invoice.new.notes-title</h1><p translate>invoice.new.notes-desc</p></div><div class="col-xs-12"><textarea class="form-control" rows="4" ng-model="vm.invoice.notes"></textarea><div ng-if="vm.invoice.notes.length > 1000"><div style="color: red">O limite maximo \xE9 de 1000 caracteres</div></div></div></div><div class="row m-t-lg"><div class="col-xs-12"><button id="btnSave" ladda="vm.isSaving" class="btn btn-primary btn-large pull-right" ng-click="vm.save()" ng-disabled="vm.invoice.notes.length > 1000" data-style="slide-left"><span data-translate="global.form.save"></span> <span class="fa fa-sign-in m-l-xs" style="font-size: 1.3em" aria-hidden="true"></span></button></div></div></div></div></div></div>');
$templateCache.put('app/admin/invoices/invoice-row-detail.html','<div style="margin-bottom: 4px" class="btn-group"><a style="margin-right: 10px" ng-disabled="grid.appScope.vm.isSaving" ng-click="grid.appScope.vm.openModalDetail(row.entity)" style="margin-left: 1px; color: #000; min-width: 130px" class="btn btn-default btn-sm">Detalhes </a><a ng-disabled="grid.appScope.vm.isSaving" ng-click="grid.appScope.vm.updateStatus(row, \'CONFIRMED\')" ng-if="row.entity.paymentMethod == \'DELIVERY\' && row.entity.status === \'WAITING_CONFIRMATION\'" style="margin-left: 1px; color: #fff; min-width: 130px; font-weight: bold" class="btn confirmed btn-sm">Confirmar Pedido </a><a ng-disabled="grid.appScope.vm.isSaving" ng-click="grid.appScope.vm.updateStatus(row, \'SEPARATING\')" ng-if="row.entity.status === \'CONFIRMED\' || row.entity.status === \'PAID\'" style="margin-left: 1px; color: #fff; min-width: 130px; font-weight: bold" class="btn separating btn-sm">Separar Pedido </a><a ng-disabled="grid.appScope.vm.isSaving" ng-click="grid.appScope.vm.updateStatus(row, \'AVAILABLE_TO_DELIVERY\')" ng-if="row.entity.status === \'SEPARATING\'" style="margin-left: 1px; color: #fff; min-width: 130px; font-weight: bold" class="btn available_to_delivery btn-sm">Disponibilizar para entrega </a><a ng-disabled="grid.appScope.vm.isSaving" ng-click="grid.appScope.vm.updateStatus(row, \'DELIVERED\')" ng-if="row.entity.status === \'AVAILABLE_TO_DELIVERY\'" style="margin-left: 1px; color: #fff; min-width: 130px; font-weight: bold" class="btn delivered btn-sm">Entregue</a></div>');
$templateCache.put('app/admin/invoices/invoices.html','<div class="wrapper wrapper-content animated ecommerce"><div class="ibox-content m-b-sm border-bottom"><div class="row"><div class="col-sm-2"><div class="form-group"><label class="control-label" data-translate="invoice.home.filter.id" for="product_name">Invoice ID</label><input ng-change="vm.filterInvoices()" type="text" id="product_name" name="product_name" ng-model="vm.filter.id" class="form-control"></div></div><div class="col-sm-1"><div class="form-group"><label class="control-label" data-translate="invoice.home.filter.price" for="price">Price</label><input type="number" ng-change="vm.filterInvoices()" id="price" name="price" ng-model="vm.filter.price" class="form-control"></div></div><div class="col-sm-2"><div class="form-group"><label class="control-label" data-translate="invoice.home.filter.client" for="client">Client</label><input type="text" ng-change="vm.filterInvoices()" id="client" name="client" ng-model="vm.filter.customerName" class="form-control"></div></div><div ng-if="vm.userProfile.profileId != 7" class="col-sm-2"><div class="form-group"><label class="control-label" data-translate="invoice.home.filter.seller" for="seller">Vendedor</label><input type="text" ng-change="vm.filterInvoices()" id="client" name="client" ng-model="vm.filter.sellerName" class="form-control"></div></div><div class="col-sm-2"><div class="form-group"><label class="control-label" data-translate="invoice.home.filter.status" for="status">Status</label><select name="status" ng-change="vm.filterInvoices()" id="status" ng-model="vm.filter.status" class="form-control"><option value=""></option><option value="WAITING_CONFIRMATION" data-translate="invoice.states.waitingConfirmation">Waiting Confirmation</option><option value="CONFIRMED" data-translate="invoice.states.confirmed">Confirmed</option><option value="SEPARATING" data-translate="invoice.states.separating">Separating</option><option value="AVAILABLE_TO_DELIVERY" data-translate="invoice.states.availableToDelivery">Available To Delivery</option><option value="DELIVERED" data-translate="invoice.states.delivered">Delivered</option><option value="WAITING_PAYMENT" data-translate="invoice.states.waiting">Waiting Payment</option><option value="PAID" data-translate="invoice.states.paid">Paid</option><option value="NOT_PAID" data-translate="invoice.states.notPaid">Not Paid</option><option value="CANCELLED" data-translate="invoice.states.cancelled">Cancelled</option><option value="REVERTED" data-translate="invoice.states.reverted">Reverted</option></select></div></div><div class="col-sm-3 text-center m-t-md"><a ui-sref="invoices.new" class="btn btn-primary pull-right m-l-md"><i class="fa fa-cart-plus"></i> <span data-translate="invoice.new.title"></span> </a><a ui-sref="redeem-coupons" ng-if="false" class="text-primary pull-right m-t-xs" style="font-size: 16px"><i class="icon-ksc-showcasepublished"></i> <span data-translate="global.menu.admin.couponsManagement">Redeem Coupons</span></a></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><div class="invoice-list"><div class="tab-content"><div id="tab-1" class="tab-pane active" style="margin-bottom: 10px"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th><span data-translate="invoice.home.table.id">Order Id</span></th><th><span data-translate="invoice.home.table.customer" for="client">Customer</span></th><th><span data-translate="invoice.home.table.seller" for="seller">Seller</span></th><th><span data-translate="invoice.home.table.total">Amount</span></th><th><span data-translate="invoice.home.table.date">Date</span></th><th><span data-translate="invoice.home.table.status">Status</span></th><th><span data-translate="invoice.home.table.recommended-action">Recommended action</span></th></tr></thead><tbody ng-if="!vm.loadingInvoices"><tr ng-if="vm.invoiceList.length == 0"><td colspan="12" style="text-align:center"><span data-translate="invoice.home.table.noContent">No data available</span></td></tr><tr ng-if="vm.invoiceList.length > 0" ng-repeat="invoice in vm.invoiceList"><td style="width: auto"><span ng-bind="invoice.id" style="padding-left: 10px"></span></td><td><span ng-bind="invoice.fullName"></span></td><td><span ng-bind="invoice.sellerName"></span></td><td><span>{{ vm.maskPrice(invoice.totalCost + invoice.shippingValue, invoice.currency) }}</span></td><td><span>{{invoice.transactionDate | amUtc | amDateFormat:\'DD/MM/YYYY\'}}</span></td><td><span ng-if="invoice.status === \'CANCELLED\'" class="label label-info cancelled" data-translate="invoice.states.cancelled">{{ invoice.status }}</span> <span ng-if="invoice.status === \'PAID\'" class="label label-info paid" data-translate="invoice.states.paid">{{ invoice.status }}</span> <span ng-if="invoice.status === \'WAITING_PAYMENT\'" class="label label-info waiting_payment" data-translate="invoice.states.waiting">{{ invoice.status }}</span> <span ng-if="invoice.status === \'NOT_PAID\'" class="label label-info cancelled" data-translate="invoice.states.notPaid">{{ row.entity[col.field] | statusFilter }}</span> <span ng-if="invoice.status === \'WAITING_CONFIRMATION\'" class="label label-info waiting_confirmation" data-translate="invoice.states.waitingConfirmation">{{ invoice.status }}</span> <span ng-if="invoice.status === \'CONFIRMED\'" class="label label-info confirmed" data-translate="invoice.states.confirmed">{{ invoice.status }}</span> <span ng-if="invoice.status === \'SEPARATING\'" class="label label-info separating" data-translate="invoice.states.separating">{{ invoice.status }}</span> <span ng-if="invoice.status === \'AVAILABLE_TO_DELIVERY\'" class="label label-info available_to_delivery" data-translate="invoice.states.availableToDelivery">{{ invoice.status }}</span> <span ng-if="invoice.status === \'REVERTED\'" class="label label-info reverted" data-translate="invoice.states.reverted">{{ invoice.status }}</span> <span ng-if="invoice.status === \'DELIVERED\'" class="label label-info delivered" data-translate="invoice.states.delivered">{{ invoice.status }}</span></td><td><div style="margin-bottom: 4px" class="btn-group"><a style="margin-right: 10px" ng-disabled="vm.isSaving" data-translate="invoice.actions.details" ng-click="vm.openModalDetail(invoice)" style="margin-left: 1px; color: #000; min-width: 130px" class="btn btn-default btn-sm">Detalhes </a><a ng-disabled="vm.isSaving" ng-click="vm.updateStatus(invoice, \'CONFIRMED\')" data-translate="invoice.actions.confirm-order" ng-if="vm.userProfile.profileId != 7 && invoice.paymentMethod == \'DELIVERY\' && invoice.status === \'WAITING_CONFIRMATION\'" style="margin-left: 1px; color: #fff; min-width: 130px; font-weight: bold" class="btn confirmed btn-sm">Confirmar Pedido </a><a ng-disabled="vm.isSaving" ng-click="vm.updateStatus(invoice, \'PAID\')" data-translate="invoice.actions.confirm-payment" ng-if="vm.userProfile.profileId != 7 && (invoice.paymentMethod == \'DELIVERY\' || invoice.paymentMethod == \'DIRECT_SALE\') && invoice.status === \'CONFIRMED\'" style="margin-left: 1px; color: #fff; min-width: 130px; font-weight: bold" class="btn confirmed btn-sm">Confirmar Pagamento </a><a ng-disabled="vm.isSaving" ng-click="vm.updateStatus(invoice, \'SEPARATING\')" data-translate="invoice.actions.separating-order" ng-if="vm.userProfile.profileId != 7 && invoice.status === \'PAID\'" style="margin-left: 1px; color: #fff; min-width: 130px; font-weight: bold" class="btn separating btn-sm">Separar Pedido </a><a ng-disabled="vm.isSaving" ng-click="vm.updateStatus(invoice, \'AVAILABLE_TO_DELIVERY\')" data-translate="invoice.actions.available-for-delivery" ng-if="vm.userProfile.profileId != 7 && invoice.status === \'SEPARATING\'" style="margin-left: 1px; color: #fff; min-width: 130px; font-weight: bold" class="btn available_to_delivery btn-sm">Disponibilizar para entrega </a><a ng-disabled="vm.isSaving" ng-click="vm.updateStatus(invoice, \'DELIVERED\')" data-translate="invoice.actions.delivered" ng-if="vm.userProfile.profileId != 7 && invoice.status === \'AVAILABLE_TO_DELIVERY\'" style="margin-left: 1px; color: #fff; min-width: 130px; font-weight: bold" class="btn delivered btn-sm">Entregue</a></div></td></tr></tbody></table></div></div></div><div ng-if="vm.loadingInvoices" class="tab-content" style="height: 602px; display: flex;\n\t\t\t\t            align-items: center;\n\t\t\t\t            justify-content: center"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div></div><div align="center" style="padding-bottom:  20px"><uib-pagination ng-model="vm.currentPage" total-items="vm.totalInvoices" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistry}}\', of: \'{{vm.endRegistry}}\', total: \'{{vm.totalInvoices}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalInvoices }}</p></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="wrapper wrapper-content"><div class="row"><div class="ibox"><div class="ibox-content"><div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div></div></div></div></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div class="wrapper wrapper-content"><div class="row"><div class="ibox"><div class="ibox-content"><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/redeem-coupons/redeem-coupons.html','<form name="couponForm"><div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group"><label for="couponCode" class="required" data-translate="redeem-coupons.home.code">Coupon code</label><input id="couponCode" type="text" name="couponCode" class="form-control" maxlength="6" ng-model="vm.codeCoupon" ng-change="vm.checkRedeemed()" required></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group"><label for="salesPoint" class="required" data-translate="redeem-coupons.home.salespoint">Sales point</label><select id="salesPoint" class="form-control" name="salesPoint" ng-model="vm.salesPointId" required><option ng-repeat="salespoint in vm.salesPoints" value="{{salespoint.id}}">{{salespoint.name}}</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 showcase-align-center" style="padding-top: 23px"><button class="btn btn-primary btn-block" style="white-space: normal !important" ng-disabled="couponForm.$invalid" ng-click="vm.validateCoupon()"><span class="icon-ksc-showcasepublished" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span><span data-translate="redeem-coupons.home.buttons.validate">Validate code</span></button></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="ibox float-e-margins"><div class="ibox-content" style="padding: 60px"><div class="coupon-box" style="border: 3px dashed #BEC1C3; font-size: 100%; font-weight: bold; background-color: #F3F3F4; height: 40vh" ng-if="!vm.flyer" align="center"><div class="showcase-table-checkbox"><h1 style="font-size: 40px" data-translate="redeem-coupons.home.messages.preview.title">Valid coupon preview.</h1><p style="color: #C1C3C5" data-translate="redeem-coupons.home.messages.preview.firstInfo">Lorem ipsum is simply dummy text of the printing and typesetting industry.</p><p style="color: #C1C3C5" data-translate="redeem-coupons.home.messages.preview.secondInfo">Lorem ipsum is simply dummy text of printing and .</p></div></div><div class="coupon-box" style="border: 3px dashed #BEC1C3; height: 100%; font-size: 100%; font-weight: bold; height: 40vh" ng-if="vm.flyer && vm.redeemed" align="center"><div class="showcase-table-checkbox"><p class="uppercase" style="text-align: center" data-translate="redeem-coupons.home.code">C\xF3digo do cupom</p><div style="padding: 15px; border: 3px dashed #7F7F81; width: 30%; font-size: 2em; font-weight: bold; text-align: center"><span class="coupon-text-color">{{vm.couponCode}}</span></div><h1 style="font-size: 50px; color: #9E9EA0" data-translate="redeem-coupons.home.messages.success.title">Was redeemed with success.</h1><p class="coupon-text-color" data-translate="redeem-coupons.home.messages.success.firstInfo">Lorem ipsum dolor lorem ipsum dolor lorem ipsum dolor</p></div></div><div class="coupon-box" style="border: 3px dashed #BEC1C3; height: 100%; font-size: 100%" ng-if="vm.flyer && !vm.redeemed"><div class="coupon-flyer-box" ng-if="vm.flyer" style="padding: 25px"><div class="row"><div class="col-xs-12"><h1>{{vm.flyer.name}}</h1></div></div><div class="row" style="width: 100%"><div class="col-xs-12"><div class="table-redeem" style="height: 100%; width: 100%; display: table"><div class="col-xs-12 col-sm-6 test" style="display: table-cell; height: 100%; float: none"><img class="img-responsive" ng-src="{{vm.getImagePath(vm.flyer.id)}}" alt="" style="float: left"></div><div class="col-xs-12 col-sm-6 test" style="display: table-cell; height: 100%; width: 100%"><div class="section-description light" align="center" style="height: 100%"><div class="row" style="width: 80%"><p class="uppercase" style="text-align: center">C\xF3digo do cupom</p><div style="padding: 15px; border: 3px dashed #7F7F81; font-size: 3em; font-weight: bold; text-align: center"><span class="coupon-text-color">{{vm.couponCode}}</span></div></div><div class="row" style="margin: 0 !important; padding: 0px !important; width: 80%"><div class="col-xs-12" align="right" style="padding: 0px !important"><p class="page-external-font" style="margin-top: 30px !important; font-weight: 100px !important" ng-if="vm.flyer.purchaseValue"><span data-fittext data-fittext-min="9" data-fittext-max="20" data-ng-bind="vm.getFlyerCurrency(vm.flyer.currency)"></span> <span data-fittext data-fittext-min="10" data-fittext-max="30" data-ng-bind="(vm.flyer.purchaseValue | currency:\'\':2)" style="text-decoration: line-through"></span></p><p class="page-external-font" style="margin-top: 50px !important; font-weight: 100px !important" ng-if="vm.flyer.discountedValue"><span data-fittext data-fittext-min="20" data-fittext-max="40" data-ng-bind="vm.getFlyerCurrency(vm.flyer.currency)" class="coupon-text-color"></span> <span data-fittext data-fittext-min="35" data-fittext-max="90" data-ng-bind="(vm.flyer.discountedValue | currency:\'\':2)" class="coupon-text-color"></span></p></div></div><div id="flyer-expirationDate-row" ng-if="vm.flyer.expirationDate"><p style="text-align: center; display: block; font-size: 2.5em; color: #838587; font-weight: 100px !important"><span class="fa fa-clock-o"></span><span style="margin-left: 5px">{{vm.calcTimeDifference(vm.flyer.expirationDate)}}</span></p></div><div id="flyer-button-row" class="row" style="margin-top: 20px"><button class="btn btn-block btn-primary" style="width: 80%" ng-click="vm.redeemCoupon()"><span class="uppercase" data-translate="redeem-coupons.home.buttons.redeem">PEGAR CUPOM</span></button></div><div id="flyer-validate-row" class="row" align="center" ng-if="vm.flyer.expirationDate" style="bottom: 0"><p class="uppercase" style="margin: 0 !important" data-translate="flyers.detail.expire" translate-value-date="{{vm.getExpirationDate(vm.flyer.expirationDate)}}">OFERTA VALIDA AT\xC9 31/08/2017</p></div></div></div></div></div></div></div></div></div></div></div></div></div></form>');
$templateCache.put('app/admin/rent-invoices/rent-row-detail.html','<div style="margin-left: 10px; margin-bottom: 4px" class="btn-group"><a ng-disabled="grid.appScope.vm.isSaving" ng-click="grid.appScope.vm.updateStatus(row, \'PAID\')" ng-if="row.entity.status === \'WAITING_PAYMENT\'" style="margin-left: 1px; color: #fff; background-color: #1ab394; border-color: #1ab394; width: 130px; font-weight: bold" class="btn btn-white btn-sm">Marcar como pago</a> <a ng-disabled="grid.appScope.vm.isSaving" ng-click="grid.appScope.vm.updateStatus(row, \'ACCEPTED\')" ng-if="row.entity.status === \'PAID\'" style="margin-left: 1px; color: #fff; background-color: rgb(50, 154, 207); border-color: rgb(50, 154, 207); width: 130px; font-weight: bold" class="btn btn-success btn-sm">Marcar como aceito</a> <a ng-disabled="grid.appScope.vm.isSaving" ng-click="grid.appScope.vm.updateStatus(row, \'ARCHIVED\')" ng-if="row.entity.status === \'ACCEPTED\' || row.entity.status === \'CANCELLED\' || row.entity.status === \'REFUSED\'" class="btn btn-secondary btn-sm" style="color: #fff; background-color: #6c757d; border-color: #6c757d; width: 130px; font-weight: bold">Arquivar</a> <a ng-disabled="true" ng-if="row.entity.status === \'ARCHIVED\'" class="btn btn-secondary btn-sm" style="color: #fff; background-color: #6c757d; border-color: #6c757d; width: 130px; font-weight: bold">Nenhuma A\xE7\xE3o</a></div>');
$templateCache.put('app/admin/rent-invoices/rent.html','<style>.ui-grid-row:nth-child(odd) .ui-grid-cell {\n        height: 30px !important;\n    }\n    .ui-grid-row:nth-child(even) .ui-grid-cell {\n        height: 30px !important;\n    }\n\n    .ui-grid-header-cell, .ui-grid-cell-contents {\n        padding-top: 11px;\n    }\n\n    *:focus {\n        outline: none;\n    }\n    .scrollFiller {\n        border: none;\n    }\n\n    .ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-cell:last-child {\n        box-sizing: border-box;\n        border-right: none;\n        height: 41px !important;\n        border-width: none;\n        border-right-color: #aeaeae;\n    }\n\n    .ui-grid-row:last-child .ui-grid-cell {\n        border-bottom-width: 1px;\n        height: 37px !important;\n        border: none ;\n    }\n    .ui-grid-pinned-container.ui-grid-pinned-container-left .ui-grid-header-cell:last-child {\n        border-right: none;\n    }</style><div class="wrapper wrapper-content animated fadeInRight ecommerce"><div class="ibox-content m-b-sm border-bottom"><div class="row"><div class="col-sm-2"><div class="form-group"><label class="control-label" data-translate="rent.home.filter.id" for="product_name">Product ID</label><input ng-change="vm.filterId()" type="text" id="product_name" name="product_name" ng-model="vm.idFilter" class="form-control"></div></div><div class="col-sm-3"><div class="form-group"><label class="control-label" data-translate="rent.home.filter.price" for="price">Price</label><input type="number" ng-change="vm.filterValue()" id="price" name="price" ng-model="vm.valueFilter" class="form-control"></div></div><div class="col-sm-3"><div class="form-group"><label class="control-label" data-translate="rent.home.filter.client" for="client">Client</label><input type="text" ng-change="vm.filterClient()" id="client" name="client" ng-model="vm.clientFilter" class="form-control"></div></div><div class="col-sm-3"><div class="form-group"><label class="control-label" data-translate="rent.home.filter.status" for="status">Status</label><select name="status" ng-change="vm.filterState()" id="status" ng-model="vm.stateFilter" class="form-control"><option value="">Todos</option><option value="REFUSED" data-translate="rent.states.refused">Recusdo</option><option value="WAITING_PAYMENT" data-translate="rent.states.waiting-payment">Waiting Payment</option><option value="PAID" data-translate="rent.states.paid">Paid</option><option value="CANCELLED" data-translate="rent.states.cancelled">Cancelled</option></select></div></div><div style="margin-top: 26px" class="col-sm-1"><a ng-disabled="!vm.gridApi.selection.getSelectedCount()" class="coupon-menu-button" ng-click="vm.declineOrders()" aria-hidden="true" style="width: 33.3%" tooltip-placement="top-right" uib-tooltip="{{\'rent.home.buttons.archive\' | translate}}" has-authority="UPDATE_TRANSACTION_STATUS"><span class="icon-ksc-trash fa-2x" ng-class="{\'coupon-text-color\': vm.gridApi.selection.getSelectedCount()}"></span> <span style="right: 33px; top: -4px" ng-if="vm.gridApi.selection.getSelectedCount()" class="label flyer-label-color">{{vm.gridApi.selection.getSelectedCount()}}</span></a></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-xs-12"><div ui-grid="vm.gridOptions" ui-grid-selection ui-grid-save-state ui-grid-pagination ui-grid-edit ui-grid-row-edit ui-grid-cellnav ui-grid-expandable ui-grid-auto-resize class="profile-table grid" style="margin-top: 15px"><div data-translate="rent.home.table.noContent" ng-show="!vm.gridOptions.data.length">No data available</div></div></div><div style="box-shadow: 0 0 0" ng-show="vm.gridOptions.data.length" align="center" style="padding-bottom:  20px"><uib-pagination ng-model="vm.currentPage" total-items="vm.totalCustomers" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistry}}\', of: \'{{vm.endRegistry}}\', total: \'{{vm.totalCustomers}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalCustomers }}</p></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/reports/engagement.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-6"><p>Aqui voc\xEA pode ver todos os usu\xE1rio que interagiram com as ofertas.</p></div><div class="col-md-6" align="left"><div class="inner-addon left-addon"><div class="pull-right"><div class="dropdown dropdown-table btn-group"><a class="showcase-menu-button" data-toggle="dropdown" aria-expanded="false"><span tooltip-placement="top-right" uib-tooltip="{{\'reports.engagement.filter.title\' | translate}}" class="icon-ksc-showcases" style="font-size: 2.6em !important"></span> </a><i class="fa fa-question-circle" tooltip-placement="bottom-right" uib-tooltip="{{\'reports.engagement.message.question-hint\' | translate}}" style="color: #676A6C; font-size: 1.3em"></i><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)" style="min-width: 400px !important"><div class="row"><div class="col-xs-12"><h1 class="showcases-table-flyer-header" data-translate="reports.engagement.filter.title">List of offer</h1></div></div><div class="showcase-flyer-table"><div class="table-responsive" ng-repeat="flyer in vm.flyersFiltered track by $index" style="overflow: hidden !important"><table class="table shoping-cart-table"><tbody><tr width="100%"><td width="10%" style="padding: 0 !important"><div class="checkbox" ng-click="$event.stopPropagation()" style="padding: 0 !important"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.flyersIds.indexOf(flyer.id) > -1" ng-click="vm.toggleSelection(flyer.id)"> <span class="checkbox-material"><span class="check showcase-flyer-table-checkbox"></span></span></label></div></td><td width="10%"><div class="cart-product-imitation showcase-flyer-table-img" style="background-size: 100% 100%; padding-top: 50px !important" ng-style="{\'background-image\': \'url(/flyer/api/{{flyer.id}}/picture?type=small)\'}"></div></td><td class="desc" width="80%"><div style="margin-top: -5px !important"><a class="text-navy"><div class="showcase-flyer-table-name"><p class="product-name showcase-flyer-table-name" style="word-wrap: break-word">{{flyer.name}}</p></div></a></div><span class="fa fa-tag" ng-class="{\'ksc-tag-active\': flyer.status == \'ACTIVATED\', \'ksc-tag-inactive\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}"></span> <span class="showcase-flyer-table-info" ng-class="{\'flyer-active\': flyer.status == \'ACTIVATED\', \'flyer-disabled\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}">{{(flyer.status == \'ACTIVATED\' ? \'reports.engagement.flyers.offer.active\' : \'reports.engagement.flyers.offer.disabled\') | translate}}</span> <span style="float: right; margin-top: -3px !important"><span class="showcase-product-info-price-normal" ng-if="flyer.discountedValue && flyer.purchaseValue" style="white-space: nowrap"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(flyer.currency)}} </span><span class="coupon-desactived-decoration" ng-if="flyer.discountedValue && flyer.purchaseValue" style="white-space: nowrap">{{flyer.purchaseValue | number : 2}}</span> <span class="showcase-flyer-table-price" ng-if="flyer.discountedValue"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(flyer.currency)}} </span>{{flyer.discountedValue | number : 2}}</span> </span><span class="showcase-flyer-table-price" ng-if="!flyer.discountedValue && flyer.purchaseValue"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(flyer.currency)}} </span>{{flyer.purchaseValue | number : 2}}</span></span></td></tr></tbody></table></div></div></ul></div></div></div></div></div><div class="clients-list"><ul class="nav nav-tabs"><li ng-class="{\'active\' : tab == 3}"><a ng-click="tab = 3" ng-init="tab = 3"><i class="fa fa-shopping-cart"></i> <span data-translate="reports.engagement.tab.sale">Sale</span></a></li><li ng-class="{\'active\' : tab == 1}"><a ng-click="tab = 1"><i class="fa fa-user"></i> <span data-translate="reports.engagement.tab.coupon">Coupon</span></a></li><li ng-if="false" ng-class="{\'active\' : tab == 2}"><a ng-click="tab = 2"><i class="fa fa-comment"></i> <span data-translate="reports.engagement.tab.contact">Contact</span></a></li></ul><div class="tab-content"><div id="tab-1" class="tab-pane active" ng-show="tab == 1"><div class="full-height-scroll" full-scroll><div ng-if="!vm.loadingUsersFromCoupons" class="table-responsive"><table class="table table-striped table-hover"><tbody><tr ng-repeat="userFromCouponsList in vm.listUsersFromCoupon"><td class="client-avatar"><img alt="image" src="/content/images/profile_small.png"></td><td><span class="client-link">{{userFromCouponsList.firstName}} {{userFromCouponsList.lastName}}</span></td><td class="contact-type"><i class="fa fa-phone" tooltip-placement="bottom" uib-tooltip="{{\'reports.engagement.title.phone\' | translate}}"></i></td><td><span ng-bind="userFromCouponsList.phone"></span></td><td class="contact-type"><i class="fa fa-envelope" tooltip-placement="bottom" uib-tooltip="{{\'reports.engagement.title.email\' | translate}}"></i></td><td><span ng-bind="userFromCouponsList.email"></span></td><td class="contact-type"><i ng-class="{\'fa fa-male\': {{userFromCouponsList.gender}} === messages.gender.male, \'fa fa-female\': {{userFromCouponsList.gender}} === messages.gender.female}" tooltip-placement="bottom" uib-tooltip="{{\'reports.engagement.title.gender\' | translate}}"></i></td><td><span>{{vm.getGender(userFromCouponsList.gender) | translate}}</span></td><td class="contact-type"><i class="fa fa-calendar" tooltip-placement="bottom" uib-tooltip="{{\'reports.engagement.title.birthday\' | translate}}"></i></td><td><span>{{ userFromCouponsList.dateOfBirth | date : format : timezone}}</span></td><td><a ui-sref="engagements-user({id: userFromCouponsList.id, from: \'coupons\'})"><i class="fa fa-bar-chart primary-color" tooltip-placement="bottom" tooltip-append-to-body="true" uib-tooltip="{{\'reports.engagement.user.report\' | translate}}"></i></a></td></tr></tbody></table></div><div ng-if="vm.loadingUsersFromCoupons" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div style="padding-top: 60px; text-align: center" ng-if="!vm.listUsersFromCoupon.length"><span class="insufficient-data" data-translate="reports.engagement.message.usersempty"><i>Insufficient data</i></span></div></div></div><div id="tab-2" class="tab-pane active" ng-show="tab == 2"><div class="full-height-scroll" full-scroll><div ng-if="!vm.loadingUsersFromContact" class="table-responsive"><table class="table table-striped table-hover"><tbody><tr ng-repeat="userFromContactList in vm.listUsersFromContact"><td class="client-avatar"><img alt="image" src="/content/images/profile_small.png"></td><td><span class="client-link">{{userFromContactList.firstName}} {{userFromContactList.lastName}}</span></td><td class="contact-type"><i class="fa fa-phone"></i></td><td><span ng-bind="userFromContactList.phone"></span></td><td class="contact-type"><i class="fa fa-envelope"></i></td><td><span ng-bind="userFromContactList.email"></span></td><td class="contact-type"><i ng-class="{\'fa fa-male\': {{userFromContactList.gender}} === messages.gender.male, \'fa fa-female\': {{userFromContactList.gender}} === messages.gender.female}"></i></td><td><span>{{ vm.getGender(userFromContactList.gender) | translate }}</span></td><td><i class="fa fa-calendar" title="{{\'reports.engagement.title.birthday\'}}"></i></td><td><span>{{ userFromContactList.dateOfBirth | date : format : timezone }}</span></td><td><a ui-sref="engagements-user({id: userFromContactList.id, from: \'contacts\'})"><i class="fa fa-bar-chart primary-color" tooltip-placement="bottom" tooltip-append-to-body="true" uib-tooltip="{{\'reports.engagement.user.report\' | translate}}"></i></a></td></tr></tbody></table></div><div ng-if="vm.loadingUsersFromContact" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div style="padding-top: 60px; text-align: center" ng-if="!vm.listUsersFromContact.length"><span class="insufficient-data" data-translate="reports.engagement.message.usersempty"><i>Insufficient data</i></span></div></div></div><div id="tab-3" class="tab-pane active" ng-show="tab == 3"><div class="full-height-scroll" full-scroll><div ng-if="!vm.loadingUsersFromSale" class="table-responsive"><table class="table table-striped table-hover"><tbody><tr ng-repeat="userFromSaleList in vm.listUsersFromSale"><td class="client-avatar"><img alt="image" src="/content/images/profile_small.png"></td><td><span class="client-link">{{userFromSaleList.firstName}} {{userFromSaleList.lastName}}</span></td><td class="contact-type"><i class="fa fa-phone"></i></td><td><span ng-bind="userFromSaleList.phone"></span></td><td class="contact-type"><i class="fa fa-envelope"></i></td><td><span ng-bind="userFromSaleList.email"></span></td><td class="contact-type"><i ng-class="{\'fa fa-male\': {{userFromSaleList.gender}} === messages.gender.male, \'fa fa-female\': {{userFromSaleList.gender}} === messages.gender.female}"></i></td><td><span>{{ vm.getGender(userFromSaleList.gender) | translate }}</span></td><td><i class="fa fa-calendar" title="{{\'reports.engagement.title.birthday\'}}"></i></td><td><span>{{ userFromSaleList.dateOfBirth | date : format : timezone }}</span></td><td><a ui-sref="engagements-user({id: userFromSaleList.id, from: \'sales\'})"><i class="fa fa-bar-chart primary-color" tooltip-placement="bottom" tooltip-append-to-body="true" uib-tooltip="{{\'reports.engagement.user.report\' | translate}}"></i></a></td></tr></tbody></table></div><div ng-if="vm.loadingUsersFromSale" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div style="padding-top: 60px; text-align: center" ng-if="!vm.listUsersFromSale.length"><span class="insufficient-data" data-translate="reports.engagement.message.usersempty"><i>Insufficient data</i></span></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/reports/follow-up-dashboard.html','<iframe src="https://analytics.showkase.com.br/public/dashboard/2a5811ac-0068-4130-836f-e31082e639d7" frameborder="0" width="100%" height="100%" allowtransparency style="min-width: 100%; min-height: 99.4vh; border: none"></iframe>');
$templateCache.put('app/admin/reports/reports-dashboard.html','<div class="row" style="margin-top:-53px!important" has-authority="STORE_MANAGE_REPORT"><div id="reportDashboard"><md-tabs md-selected="currentTab" md-stretch-tabs="always"><md-tab label="{{ \'reports.tabs.sale.title\' | translate}}" md-on-select="vm.onTabSelected(3)"></md-tab><md-tab label="{{ \'reports.tabs.coupon.title\' | translate}}" md-on-select="vm.onTabSelected(1)"></md-tab><md-tab ng-if="false" label="{{ \'reports.tabs.contact.title\' | translate}}" md-on-select="vm.onTabSelected(2)"></md-tab></md-tabs></div></div><div class="wrapper wrapper-content"><div ng-if="vm.selectedTab === 3" ui-view="sale-view"></div><div ng-if="vm.selectedTab === 1" ui-view="coupon-view"></div><div ng-if="vm.selectedTab === 2" ui-view="contact-view"></div></div>');
$templateCache.put('app/admin/satisfaction-survey/satisfaction-survey.html','<style>.modal-dialog {\n  position: absolute;\n  top: 10%;\n  right: 0px;\n  bottom: 0;\n  left: 0;\n  z-index: 10040;\n  overflow: auto;\n  overflow-y: auto;\n}</style><div class="content-title-nps"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h2 style="margin-top: 18px" data-translate="showcases.satisfaction-survey.question" translate-value-namehub="{{vm.nameHub}}">Question</h2></div><div class="modal-body qualification-content" ng-style="!vm.showObservation && { \'padding-bottom\':\'5%\' }"><div class="row"><div class="col-xs-6"><h4 class="qualification-labels bad-qualification" data-translate="showcases.satisfaction-survey.bad">Pouco prov\xE1vel</h4></div><div class="col-xs-6"><h4 class="qualification-labels good-qualification" data-translate="showcases.satisfaction-survey.good">Muito prov\xE1vel</h4></div></div><div class="row"><ul class="list-of-notes"><li ng-repeat="note in vm.notes"><button class="btn btn-default col-lg-1" ng-style="vm.satisfactionSurvey.note === note ? {\'background-color\':\'#2f137e\', \'color\':\'white\'} : {\'background-color\':\'#EEEEEE\', \'color\':\'black\'}" ng-click="vm.setNote(note)">{{note}}</button></li></ul></div><form ng-if="vm.showObservation" name="satisfactionForm" role="form" novalidate show-validation ng-submit="vm.confirm()"><div class="form-group" style="margin-top: 3%"><h3 for="exampleFormControlTextarea1" data-translate="{{vm.subtitle}}">Subtitle</h3><textarea name="observation" class="form-control" rows="5" ng-model="vm.satisfactionSurvey.observation" ng-maxlength="1000" placeholder="{{ \'showcases.satisfaction-survey.message-observation\' | translate }}"></textarea><div ng-show="satisfactionForm.observation.$invalid && satisfactionForm.observation.$touched"><p class="help-block form-invalid-field" ng-show="satisfactionForm.observation.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 25 characters.</p></div></div><div class="row" style="text-align: center; padding: 0 16px; bottom: 0; left: 0; right: 0"><button id="button_do_post" style="padding: 1% 15%" type="submit" class="btn btn btn-primary btn term-btn-continue-footer" ng-disabled="(satisfactionForm.$invalid) || vm.satisfactionSurvey.note === 0" data-translate="showcases.satisfaction-survey.button-submit">Enviar</button></div></form></div>');
$templateCache.put('app/admin/showcases/showcases-detail.html','<script type="text/javascript" src="https://sdk.canva.com/designbutton/v2/api.js"></script><style>.color-picker-wrapper .input-group .color-picker-input-swatch {\n        display: none;\n    }\n\n    .color-picker-wrapper {\n        max-width: 15px;\n    }\n\n    .color-picker-wrapper .input-group .input-group-addon:first-child {\n        visibility: hidden;\n    }\n\n    .pcr-app .pcr-interaction .pcr-save {\n        background: var(--main-color-dark) !important;\n        width: 100% !important;\n    }\n\n    .pcr-app .pcr-interaction .pcr-result {\n        text-align: center !important;\n        flex: 0px !important;\n        width: 100% !important;\n    }\n\n    .pcr-app .pcr-interaction input {\n        font-size: 1em !important;\n    }\n\n    .carousel {\n        position: relative;\n    }\n\n    .carousel__item {\n        height: 300px;\n        font-weight: bold;\n        font-size: 2em;\n        color: #ffffff;\n        display: none;\n    }\n\n    .arrow_buttons {\n        padding: 0 0;\n        bottom: 50%;\n        position: absolute;\n    }\n\n    .carousel_arrows {\n        color: var(--main-color-dark);\n        background: rgba(255, 255, 255, 0.63);\n        border-radius: 50%;\n        padding: 15px;\n    }\n\n    @media screen and (max-width: 850px) {\n        .carousel_arrows {\n            height: 30px !important;\n            width: 30px !important;\n            padding: 10px !important;\n            font-size: 12px !important;\n        }\n    }\n\n    .carousel__item--selected {\n        display: block;\n    }\n\n    .carousel__title {\n        color: var(--main-color-dark);\n        margin-bottom: 60px;\n        border: 1px solid rgba(180, 179, 179, 0.44);\n        background-color: #ffffffa8;\n        border-radius: 18px;\n        padding: 5px 30px;\n        font-size: 16px;\n        font-weight: 500;\n        margin-left: 30%;\n    }\n\n    .carrousel__banner__name {\n        font-weight: 400 !important;\n        margin-right: 30px;\n    }\n\n    .carousel__nav {\n        width: 100%;\n        padding: 30px 0 20px 0;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        text-align: center;\n    }\n\n    .carousel__button {\n        width: 10px;\n        height: 10px;\n        display: inline-block;\n        background: rgba(255, 255, 255, 0.63);\n        border-radius: 50%;\n        margin: 0 5px;\n        cursor: pointer;\n    }\n\n    .carousel__button--selected {\n        background: var(--main-color-dark);\n    }</style><div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox float-e-margins"><div class="ibox-content" style="padding: 15px"><div class="row"><div class="col-lg-12" style="margin: 0 !important" class="showcase-align-center"><div class="col-xs-12 col-sm-12 col-md-4" style="margin: 0 !important; padding: 0 !important; display: flex; align-items: center"><div class="inner-addon left-addon"><input id="inputNameShowcase" type="text" class="form-control input-lg showcase-input-hidden-border showcase-input-fontsize showcase-input-placeholder" placeholder="Nome da sua vitrine" ng-model="vm.showcase.name"><div class="showcase-input-icon-box"><i class="glyphicon glyphicon-pencil showcase-input-icon"></i></div></div></div><div class="col-xs-12 col-sm-12 col-md-4" class="showcase-align-center"><div class="col-xs-3"><div class="dropdown btn-group" style="text-align: center"><a ng-click="vm.openColorModal()" style="color: #676a66" class="showcase-menu-button" data-toggle="dropdown" aria-expanded="false" tooltip-placement="bottom-right" uib-tooltip="{{\'showcases.home.buttons.color\' | translate}}"><i class="icon-ksc-colorselection" style="font-size: 2.5em !important" ng-style="vm.showcase.backgroundColor && {\'color\': vm.showcase.backgroundColor}"></i><p style="margin-top: 2px; margin-bottom: 0" data-translate="showcases.detail.userInteract.options.color">Color</p></a></div></div><div class="col-xs-3" ng-if="false"><div class="dropdown btn-group" style="text-align: center"><a style="color: #676a66" class="showcase-menu-button" data-toggle="dropdown" aria-expanded="false" tooltip-placement="bottom-right" uib-tooltip="{{\'showcases.home.buttons.template\' | translate}}"><i class="icon-ksc-addtemplate" style="font-size: 2.5em !important"></i><p style="margin-top: 2px; margin-bottom: 0px" data-translate="showcases.detail.userInteract.options.model">Model</p></a><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)" style="min-width: 400px !important"><div class="row"><div class="col-xs-12"><h1 class="showcases-table-flyer-header" data-translate="showcases.home.buttons.templates.title">Choose a template</h1></div><div class="col-xs-12"><a ng-repeat="template in vm.templates" ng-click="vm.changeTemplate(template.id)" ng-if="template.id !== 2"><img class="template-item" ng-src="{{vm.getImageSrc(template.id)}}" style="max-height: 210px; max-width: 220px"></a></div></div></ul></div></div><div class="col-xs-3"><div class="dropdown dropdown-table btn-group" style="text-align: center"><a ng-click="vm.openAddBannersModal()" style="color: #676a66" class="showcase-menu-button" data-toggle="dropdown" aria-expanded="false" tooltip-placement="bottom-right" uib-tooltip="{{\'showcases.detail.banner.title\' | translate}}"><i class="icon-ksc-addimage" style="font-size: 2.5em !important"></i><p style="margin-top: 2px;  margin-bottom: 0">{{\'showcases.detail.banner.key\' | translate}} <span ng-if="vm.banners != null && vm.banners.length > 0">({{vm.banners.length}})</span></p></a></div></div><div class="col-xs-3"><div class="dropdown dropdown-table btn-group" style="text-align: center"><a ng-click="vm.goToFlyerByShowkase()" style="color: #676a66" class="showcase-menu-button" data-toggle="dropdown" aria-expanded="false" tooltip-placement="bottom-right" uib-tooltip="{{\'showcases.home.buttons.flyers.flyers\' | translate}}"><i class="icon-tags" style="font-size: 2.5em !important"></i><p style="margin-top: 2px;  margin-bottom: 0">{{\'showcases.detail.userInteract.options.offer\' | translate}} <span ng-if="vm.showcase.flyers != null && vm.showcase.flyers.length > 0">({{vm.showcase.flyers.length}})</span></p></a></div></div><div class="col-xs-3"><div class="dropdown dropdown-table btn-group" style="text-align: center"><a ng-click="vm.openAddCustomHtmlModal()" style="color: #676a66" class="showcase-menu-button" data-toggle="dropdown" aria-expanded="false" tooltip-placement="bottom-right" uib-tooltip="{{\'showcases.home.buttons.customHtml\' | translate}}"><i class="fa fa-code" style="font-size: 2.5em !important"></i><p style="margin-top: 2px;  margin-bottom: 0">{{\'showcases.detail.userInteract.options.customHtml\' | translate}} <i ng-if="vm.showcase.customHtml" class="fa fa-check"></i></p></a></div></div></div><div class="col-xs-12 col-sm-12 col-md-4 showcase-align-center"><div class="btn-group pull-right" role="group" aria-label="..." style="display: flex; align-items: center; right: -7px; padding-top: 9px"><button id="btnSaveShowcase" ladda="vm.isSaving" class="btn btn-md btn-default" ng-click="vm.preSaveFlyer()" style="padding: 7px 20px 5px 20px"><span class="glyphicon glyphicon-floppy-disk pull-left showcase-home-button"></span> <span class="showcase-home-button-margin" data-translate="showcases.home.buttons.save">Save</span></button> <button ng-show="false" class="btn btn-md btn-default" ladda="vm.isPrinting" ng-click="vm.generateTabloid()" style="padding: 7px 20px 5px 20px"><span class="fa fa-print pull-left showcase-home-button"></span> <span class="showcase-home-button-margin" data-translate="showcases.home.buttons.generateCatalog">Generate Tabloid</span></button> <button ng-if="false" ladda="vm.isSavingPreview" data-style="slide-left" class="btn btn-md btn-default" ng-click="vm.getPreviewURL(vm.showcase)" ng-disabled="[\'RENT\', \'SALE\'].includes(vm.showcase.userInteract) && !vm.storeOwnerHasMoipAccount" style="padding: 7px 20px 5px 20px"><span class="glyphicon glyphicon-eye-open pull-left showcase-home-button"></span> <span class="showcase-home-button-margin" data-translate="showcases.home.buttons.preview">Preview</span></button> <button id="btnPublishing" ladda="vm.isPublishing" class="btn btn-md btn-primary" ng-disabled="vm.checkIfShowcasePublished()" ng-click="vm.openModalConfirmCatalogChange()" style="padding: 7px 20px 5px 20px"><span class="glyphicon glyphicon-th-large pull-left showcase-home-button"></span> <span class="showcase-home-button-margin" data-translate="showcases.home.buttons.publish">Publish</span></button></div></div></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content showcase-box-content"><div class="row" style="margin-left: 0 !important; margin-right: 0 !important"><div id="carousel" class="carousel showcase-logo-box-texts" style="display:none; margin: 0 !important; margin-bottom: 70px; max-height: 603px; overflow-y: hidden; overflow-x: hidden"></div><div style="width: 100%; bottom: 0; left: 0; text-align: center" class="hidden-lg hidden-xl"><button style="margin-top: 15px; padding: 6px 30px" class="btn btn-primary btn-large" ng-click="vm.openAddBannersModal()"><span class="glyphicon glyphicon-picture pull-left"></span> <span class="showcase-home-button-margin" data-translate="showcases.detail.cover.edit">Editar banners</span></button></div><div class="col-xs-12 showcase-logo-box" style="margin: 0 !important; padding: 0 !important" ng-if="!vm.haveBanners"><input type="file" id="fileInput" style="display: none" accept="image/x-png,image/jpeg,image/png"><div class="showcase-logo-box-texts" ng-if="vm.coverEdit" style="margin-top: 30px !important; margin-bottom: 70px"><img ng-src="content/images/2-image-default-product_mini.png" style="height: 150px"><h1 style="color: #282828 !important" data-translate="showcases.detail.cover.title">Customize your cover</h1><p data-translate="showcases.detail.cover.info" style="color: #888888">Lorem ipsum Lorem ipsum Lorem ipsum Lorem Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum<br>Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum</p><button style="margin-top: 15px; padding: 6px 30px" class="btn btn-primary btn-large" ng-click="vm.openAddBannersModal()"><span class="glyphicon glyphicon-picture pull-left"></span> <span class="showcase-home-button-margin" data-translate="showcases.detail.cover.new">Add Cover</span></button><!-- <input type="file" onchange="angular.element(this).scope().handleFileSelect(event)"> --></div><div><img id="cover_image_id" ng-show="!vm.coverEdit"></div><div class="cover-buttons col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" align="center" ng-if="!vm.coverEdit" style="margin-bottom: 20px"><button class="btn btn-primary btn-large" ng-click="vm.openInput($event)"><span class="glyphicon glyphicon-refresh"></span> <span class="showcase-home-button-margin">Mudar Imagem</span></button></div></div></div><div class="row" style="margin-top: 20px" ng-if="!vm.templateIsLoading"><div class="text-center"><div class="text-center"><h2 data-translate="showcases.detail.select-title">Selecione um ou mais produtos</h2><span class="text-muted" data-translate="showcases.detail.select-desc">Clique nas op\xE7\xF5es abaixo para adicionar produtos e organizar a vitrine do seu jeito.</span></div><div ng-if="!vm.showcase.flyers.length" class="m-t-lg" style="display: table; width: 100%; height: 100%"><div style="position: relative; display: table-cell; height: 100%; cursor: pointer" class="col-xs-12 col-sm-4" ng-repeat="item in [1, 2, 3]" ng-click="vm.goToFlyerByShowkase()"><div class="ibox post-block showcase-border-box"><div class="flyer-box"><div class="flyer-box-img"><img class="img-responsive" ng-src="https://showkase-prod.s3.sa-east-1.amazonaws.com/marketing-objects/default-flyer-image.png"></div></div></div></div></div></div><div class="dragzone m-t-lg"><ul ui-sortable ng-model="vm.showcase.flyers" class="products"><li ng-repeat="flyer in vm.showcase.flyers | limitTo:20" tooltip-placement="top" uib-tooltip="{{\'showcases.detail.image-tooltip\' | translate}}" class="product-card"><div class="ibox no-margins"><div class="product-image"><img ng-src="{{flyer.imagePath}}"></div><hr class="flyer-line" tooltip-placement="bottom-right" uib-tooltip="{{(flyer.status == \'ACTIVATED\' ? \'flyers.offer.active\' : \'flyers.offer.disabled\') | translate}}" ng-class="{\'flyer-line-activated-{{ flyer.type }}\': flyer.status == \'ACTIVATED\', \'flyer-line-deactivated-{{ flyer.type }}\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}"><div class="product-info"><h5><a class="product-name">{{flyer.name}}</a></h5><div class="row"><div class="col-xs-12 store-input-nopadding" align="right"><span class="product-info-price-normal flyer-prices-remove-margin" style="white-space: nowrap" ng-if="flyer.purchaseValue && flyer.discountedValue"><span>{{vm.getFlyerCurrency(flyer.currency)}} </span><span class="coupon-desactived-decoration" style="white-space: nowrap">{{flyer.purchaseValue | number: 2}}</span></span><br><span class="product-info-price flyer-prices-remove-margin" ng-if="flyer.discountedValue"><span>{{vm.getFlyerCurrency(item.flyer.currency)}} </span>{{flyer.discountedValue | number: 2}} </span><span class="product-info-price flyer-prices-remove-margin" ng-if="!flyer.discountedValue && flyer.purchaseValue"><span>{{vm.getFlyerCurrency(flyer.currency)}} </span>{{flyer.purchaseValue | number: 2}}</span></div></div></div></div></li></ul></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/showcases/showcases-flyers-view-structure.html','<style>.badge-details {\n        color: #5E5E5E;\n        font-family: \'Roboto\';\n        font-size: 11px;\n        font-weight: 600;\n        padding: 6px 7px;\n        text-shadow: none;\n        margin-right: 6px;\n        margin-bottom: 6px;\n        border-radius: 0px;\n        font-weight: normal;\n    }\n\n    .with-stock {\n        background-color: #eaeaea;\n    }\n\n    .out-of-stock {\n        background-color: rgb(249 203 203);\n    }\n\n    .tag-info {\n        font-size: 12px; font-weight: 500; word-wrap: break-word;\n    }\n\n    .sort-select-box {\n        margin: 10px 20px;\n    }</style><div class="ibox sort-select-box"><div class="ibox-content flyer-table-box" ng-repeat="flyer in vm.flyersFiltered"><div class="table-responsive"><table class="table shoping-cart-table"><tbody><tr width="100%"><td width="5%" style="display: table-cell; vertical-align: middle"><div class="checkbox flyer-checkbox-remove-margin" ng-click="$event.stopPropagation()"><label style="padding-left: 20px !important"><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkFlyerIsSelected(flyer)" ng-click="vm.changeFlyerSelected(flyer)"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div></td><td width="10%" align="center" style="vertical-align:inherit"><div class="cart-product-imitation flyer-table-img" style="background-size: 100% 100%; padding-top: 50px !important" back-img="/flyer/api/{{flyer.id}}/picture"></div></td><td class="desc" width="50%"><h3><a class="text-navy"><small class="text-muted coupon-text-color product-category">{{flyer.category}}</small><p class="product-name" style="word-wrap: break-word">{{flyer.name}}</p></a></h3><div><span uib-tooltip="{{flyer.inventory == 0 ? \'Estoque esgotado\' : \'\'}}" ng-if="flyer.details.length == 0" class="badge badge-details with-stock" ng-class="{\'out-of-stock\': flyer.inventory == 0 }">Estoque: {{flyer.inventory != null ? flyer.inventory : \'Ilimitado\' }} </span><span uib-tooltip="{{item.inventory <= 0 && item.inventory != null ? \'Estoque esgotado\' : \'\'}}" ng-if="flyer.details.length > 0" ng-repeat="item in flyer.details" class="badge badge-details with-stock" ng-class="{\'out-of-stock\': item.inventory <= 0 && item.inventory != null }">{{ $localStorage.defaultStore.category == FASHION ? \'Tam\' : \'Var\'}} {{item.size}}: {{item.inventory != null ? item.inventory : \'Ilimitado\' }}</span></div><span ng-repeat="tag in flyer.tags" class="badge badge-secondary badge-tag-flyer">{{tag}}</span><div style="margin-top: 6px"><!-- <span class="fa fa-tag" ng-class="{\'ksc-tag-active\': flyer.status == \'ACTIVATED\', \'ksc-tag-inactive\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}"></span>\n                            <span class="flyer-table-info" ng-class="{\'flyer-active\': flyer.status == \'ACTIVATED\', \'flyer-disabled\': (flyer.status == \'DEACTIVATED\' || flyer.status == \'EXPIRED\')}">{{(flyer.status == \'ACTIVATED\' ? \'flyers.offer.active\' : \'flyers.offer.disabled\') | translate}}</span> --> <span class="tag-info" ng-if="flyer.productReference" style="color: #676a6c; font-size: 10px">{{\'Cod: \' + flyer.productReference }} </span><span ng-show="flyer.expirationDate" style="margin-left: 15px" tooltip-placement="bottom-left" uib-tooltip="{{\'flyers.new.form.expirationDate\' | translate}}"><span class="fa fa-clock-o product-date">{{flyer.expirationDate | date: "dd/MM/yyyy"}}</span> </span><span class="tag-info" style="color: #339af0; margin-left: 10px" ng-if="vm.checkFlyerIsSelected(flyer)"><i class="fa fa-check-square"></i> Produto na vitrine</span></div></td><td width="30%" align="center" style="vertical-align:inherit"><div class="col-xs-12" style="margin-top: 24px" ng-if="flyer.purchaseValue && flyer.discountedValue"><span class="product-info-price-normal" style="white-space: nowrap"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(flyer.currency)}} </span><span class="coupon-desactived-decoration" style="white-space: nowrap">{{flyer.purchaseValue | number : 2}}</span></span><br><span class="product-info-price flyer-table-price" ng-if="flyer.discountedValue"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(flyer.currency)}} </span>{{flyer.discountedValue | number : 2}}</span></div><div class="col-xs-12" style="margin-top: 24px" ng-if="flyer.purchaseValue && !flyer.discountedValue"><br><span class="product-info-price flyer-table-price"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(flyer.currency)}} </span>{{flyer.purchaseValue | number : 2}}</span></div></td></tr></tbody></table></div><hr class="flyer-table-line"></div></div>');
$templateCache.put('app/admin/showcases/showcases-flyers.html','<style>div.scrollmenu {\n        background-color: transparent;\n        overflow: auto;\n        white-space: nowrap;\n    }\n\n    div.scrollmenu a {\n        display: inline-block;\n        color: white;\n        text-align: center;\n        padding: 14px;\n        text-decoration: none;\n    }\n\n    div.scrollmenu a:hover {\n        background-color: #e6e6e6;\n        border-top-left-radius: 5px;\n        border-top-right-radius: 5px;\n    }\n\n    .brand-select {\n        background-color: white;\n        border: 1px solid #dad6d6;\n        border-bottom: 1px solid #fff;\n        border-top-left-radius: 3px;\n        border-top-right-radius: 3px;\n    }\n\n    md-switch .md-thumb {\n        background-color: darkgrey;\n    }\n\n    md-switch .md-bar {\n        background-color: lightgray;\n    }\n\n    md-switch:last-of-type {\n        margin: 0px;\n    }\n\n    .btn-filters-modal {\n        color: rgb(136, 136, 136, 1);\n        width: 100%;\n        padding: 6px 0;\n        white-space: normal !important;\n        border: 1px solid rgb(180, 179, 179);\n        background-color: white;\n        border-radius: 18px;\n        font-weight: 500;\n    }\n\n    .filter-label {\n        font-weight: normal;\n        font-size: 14px;\n        line-height: 1.42857;\n    }</style><div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="form-group col-xs-12 col-md-6" style="margin-top: 18px"><div class="input-group date"><span class="input-group-addon"><i class="fa fa-search"></i> </span><input type="text" name="inputSearch" class="form-control" ng-change="vm.loadFlyers()" placeholder="{{\'flyers.home.search-hint\' | translate}}" ng-model="vm.listFilter.text" ng-model-options="{ debounce: 500 }"></div></div><div class="col-xs-12 col-md-1 coupons-menu-button"><div class="d-flex justify-content-flex-end" style="margin-top: 3px"><button class="col-xs-12 col-md-6 btn-filters-modal d-flex" ng-click="vm.openFiltersModal()" type="button" aria-expanded="false"><span class="col-xs-5 filter-label" style="margin-right: 20px">{{\'flyers.filters.title\' | translate}} </span><span ng-if="vm.numberFilterSelected > 0" class="numberCircle" style="margin-top: 2px">{{vm.numberFilterSelected}}</span></button></div></div><div class="col-xs-12 col-md-2 pull-right" style="margin-top: 12px"><button class="btn btn-block btn-primary" ng-click="vm.saveShowcase(true)"><span class="glyphicon glyphicon-ok"></span> <span data-translate="showcases.home.buttons.flyers.finish">Finish</span></button></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="clients-list" style="margin-top: -10px"><div class="scrollmenu" ng-if="!vm.hasActiveFilter()"><a ng-click="vm.tabClick(brand)" ng-repeat="brand in vm.brands track by brand.id" ng-class="{\'brand-select\' : vm.listFilter.brand == brand.name}"><span style="color: #676a6c">{{brand.name}}</span> <span ng-if="vm.getCountSelectedByBrand(brand.name) > 0" class="label flyer-label-color">{{vm.getCountSelectedByBrand(brand.name)}}</span></a></div></div><div class="tab-content" style="background-color: white; min-height: 600px"><div ng-attr-id="{{\'tab-\' + brand.name}}" class="active" ng-show="vm.listFilter.brand == brand.name" ng-repeat="brand in vm.brands"><div ng-if="vm.busy" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-include="\'app/admin/showcases/showcases-flyers-view-structure.html\'" ng-if="vm.flyersFiltered.length > 0"></div><div class="wrapper wrapper-content container-fluid" ng-if="vm.flyersFiltered.length <= 0 && !vm.busy"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/download-panfletos.png"><h1 data-translate="flyers.new.error.notFound">Create your first offer.</h1></div></div></div></div></div><div align="center" style="padding-bottom:  20px; margin-top: 20px" ng-if="vm.flyersFiltered.length > 0"><uib-pagination ng-model="vm.currentPage" total-items="vm.totalFlyers" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistry}}\', of: \'{{vm.endRegistry}}\', total: \'{{vm.totalFlyers}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalFlyers }}</p></div></div></div></div></div>');
$templateCache.put('app/admin/showcases/showcases.html','<style>.applyBtn {\n        background-color: var(--main-color) !important;\n    }\n\n    .ranges li {\n        color: var(--main-color) !important;\n    }\n\n    .ranges li.active {\n        background-color: var(--main-color) !important;\n        border: 1px solid var(--main-color) !important;\n        color: #fff !important;\n    }\n\n    .ranges li:hover {\n        background-color: var(--main-color) !important;\n        border: 1px solid #000;\n        color: #fff !important;\n    }\n\n    .daterangepicker {\n        right: 10px !important;\n        left: auto !important;\n    }\n\n    .daterangepicker:before {\n        left: calc(90% - 11px) !important;\n    }\n\n    .daterangepicker:after {\n        left: calc(90% - 10px) !important;\n    }\n\n    .daterangepicker td.active, .daterangepicker td.active:hover {\n        background-color: var(--main-color) !important;\n        border-color: transparent;\n        color: #fff !important;\n    }</style><div class="wrapper wrapper-content container-fluid" ng-if="!vm.userHasShowcases && !vm.hasntStoreYet && vm.checkIsNotLoading()"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/noshowcases.png"><h1 data-translate="showcases.messages.create.title">Create your first showcase.</h1><p class="ksc-sub-title" data-translate="showcases.messages.create.info" style="width: 48% !important"></p><button id="btnCreateShowcase" has-authority="STORE_CREATE_SHOWCASE" class="btn btn-primary btn-large" ui-sref="showcases.new"><span class="icon-ksc-showcases"></span> <span data-translate="showcases.messages.create.button">Create new showcase</span></button></div></div></div><div class="wrapper wrapper-content container-fluid" ng-if="vm.hasntStoreYet && vm.checkIsNotLoading()"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/noshowcases.png"><h1 data-translate="showcases.messages.errors.noStore"></h1><p data-translate="showcases.messages.errors.subMessageNoStore"></p><button has-authority="STORE_CREATE" class="btn btn-primary btn-large" ui-sref="info"><span class="icon-ksc-store"></span> <span data-translate="store-management.home.buttons.new">Create new store</span></button></div></div></div><div class="wrapper wrapper-content" ng-if="vm.userHasShowcases && vm.checkIsNotLoading()"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row showcase-align-center"><div class="col-xs-11 col-sm-11"><div class="form-group"><span data-translate="showcases.home.search">Search by name</span><div class="inner-addon left-addon"><i class="glyphicon glyphicon-search"></i> <input type="text" class="form-control" ng-model="vm.listFilter.name" ng-change="vm.loadShowcases(null, true)"></div></div></div><div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"><div class="col-xs-12 store-input-nopadding button-delete-product"><a class="coupon-menu-button" ng-click="vm.removeShowcases()" aria-hidden="true"><span id="btnDelete" class="icon-ksc-trash fa-2x" ng-class="{\'coupon-text-color\': vm.showcasesToRemove.length >= 1}"></span> <span ng-if="vm.showcasesToRemove.length >= 1" class="label flyer-label-color">{{vm.showcasesToRemove.length}}</span></a></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row" style="margin-bottom: 10px"><div class="col-md-4 col-lg-6"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.isShowAllSelected()" ng-click="vm.changeSelectionOfAllShowcases()" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{\'showcases.home.select-all\' | translate}}</label></div></div><div class="col-md-4 col-lg-3" style="padding-top: 10px"><div class="form-group"><select name="showcasesForPage" ng-change="vm.changePagination()" id="status" ng-model="vm.listFilter.rowsForPage" class="form-control"><option value="20" data-translate="filter.twentyForPage">20 Itens for page</option><option value="40" data-translate="filter.fortyForPage">40 Itens for page</option><option value="60" data-translate="filter.sixtyForPage">60 Itens for page</option><option value="80" data-translate="filter.eightyForPage">80 Itens for page</option><option value="100" data-translate="filter.oneHundredForPage">100 Itens for page</option></select></div></div><div class="col-md-4 col-lg-3" style="padding-top: 10px"><div><div><div class="input-group date" id="showcasesDateRange" ng-click="vm.openDatePicker()"><input id="dateRangeInput" style="float: right; background-color: #fffefe" date-range-picker class="form-control date-picker ng-pristine ng-valid ng-isolate-scope ng-touched" readonly="readonly" placeholder="dd/mm/yyyy - dd/mm/yyyy" ng-model="vm.dateRange" options="vm.dateRangeOptions" required=""> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div></div></div></div></div><div align="center" ng-show="vm.showcases.length == 0"><span data-translate="showcases.messages.empty-showcases"></span></div><div class="row"><!--\n                         infinite-scroll="vm.loadShowcases(vm.page + 1)"\n                         infinite-scroll-disabled="!vm.hasNextPage || vm.busy"\n                         infinite-scroll-immediate-check="false"\n                        infinite-scroll-distance=\'1\'> --><div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" has-plan="ESCALA,IMPULSO,SHOWKASE"><div class="showcase-box showcase-item-box showcase-align-icon-center"><div class="showcase-flex-item" ui-sref="showcases.new"><span id="btnCreateOtherShowcase" class="icon-ksc-createshowcase showcase-new-icon"></span><p class="showcase-new-text" data-translate="showcases.messages.create.button">Create new showcase</p></div></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="showcase in vm.showcases"><div class="ibox"><div class="ibox-content product-box showcase-box" ng-if="!item.flyer"><div class="showcase-box-checkbox form-group"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfShowcaseSelected(showcase.id)" ng-click="vm.updateShowcasesToRemove(showcase.id)" checked="checked"> <span class="checkbox-material"><span class="check"></span></span></label></div></div><div class="showcase-box-image"><img ng-src="{{vm.getImageSrc(showcase.showcaseTemplateId)}}"><div style="margin: 20px"><h2 style="font-size: 2vh !important">{{showcase.name}}</h2><p><span class="icon-ksc-showcaseviews showcase-box-icon"></span> <span>{{showcase.numberOfVisualizations}}</span> <span style="float: right" ng-show="vm.checkIfShowcasePublished(showcase.published)"><span class="icon-ksc-showcasepublished" style="color: green"></span> <span data-translate="showcases.home.buttons.published">Published</span></span></p></div></div><div class="showcase-box-hover"><button id="btnEditShowcase" style="min-width:200px" has-authority="STORE_UPDATE_SHOWCASE" class="btn btn-lg showcase-box-transparent-button" type="button" ng-click="vm.getEditPage(showcase.id)"><span class="icon-ksc-edit"></span> <span data-translate="showcases.home.buttons.edit">Edit</span></button> <button ng-if="false" style="min-width:200px" class="btn btn-lg showcase-box-transparent-button" type="button" ng-click="vm.getPreviewURL(showcase.id)"><span class="icon-ksc-showcaseviews"></span> <span data-translate="showcases.home.buttons.preview">View</span></button> <button style="min-width:200px" class="btn btn-lg showcase-box-transparent-button" type="button" ng-click="vm.generateTabloid(showcase)"><span style="margin-right: 5px" class="fa fa-print"></span> <span data-translate="showcases.home.buttons.generateCatalog">Generate Tabloid</span></button> <button ladda="vm.isPublishing" style="min-width:200px" has-authority="STORE_UPDATE_SHOWCASE" class="btn btn-lg showcase-box-transparent-button" type="button" ng-click="vm.openModalConfirmCatalogChange(showcase.id)" ng-show="!vm.checkIfShowcasePublished(showcase.published)"><span class="icon-ksc-showcasepublished"></span> <span data-translate="showcases.home.buttons.publish">Publish</span></button> <button style="min-width:200px" class="btn btn-lg showcase-box-transparent-button" type="button" ng-click="vm.getShowcaseURL()" ng-show="vm.checkIfShowcasePublished(showcase.published)"><span class="icon-ksc-showcaseviews"></span> <span data-translate="showcases.home.buttons.goToShowcase">Go to showcase</span></button></div></div></div></div></div><div align="center" style="padding-bottom: 30px; margin-bottom: 10px"><uib-pagination ng-model="vm.currentPage" total-items="vm.totalBags" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.refreshPage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistry}}\', of: \'{{vm.endRegistry}}\', total: \'{{vm.totalBags}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalBags }}</p></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/team-management/team-management-dialog.html','<form name="editForm" role="form" ng-submit="vm.save(editForm)" ng-init="vm.initDateTimePicker()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="{{!vm.team.id ? \'team-management.home.createTitle\' : \'team-management.home.editTitle\' }}">Create or edit a Team</h4></div><div class="modal-body"><div class="container-fluid"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label class="control-label required" data-translate="team-management.name">Team Name</label><input type="text" class="form-control" name="teamName" ng-model="vm.team.name" ng-maxlength="50" ng-disabled="(vm.team.id && vm.storeId !== 0)" required><div class="help-block-div" ng-if="editForm.teamName.$invalid && editForm.$submitted"><p class="help-block form-invalid-field" ng-if="editForm.teamName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-if="editForm.teamName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><div class="invoice-list"><div class="tab-content"><div id="tab-1" class="tab-pane active" style="margin-bottom: 10px"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th><span data-translate="team-management.name">Name</span></th><th><span data-translate="team-management.email">Email</span></th><th><span data-translate="team-management.profiles">Profiles</span></th><th><span data-translate="team-management.select">Select</span></th></tr></thead><tbody ng-if="!vm.loadingUsers"><tr ng-if="vm.users.length == 0"><td colspan="12" style="text-align:center"><span data-translate="team-management.noContent">No data available</span></td></tr><tr ng-if="vm.users.length > 0" ng-repeat="user in vm.users"><td><span>{{user.firstName + \' \' + user.lastName}}</span></td><td><span ng-bind="user.email"></span></td><td style="width: auto"><span ng-repeat="profile in user.userProfiles" class="label label-info ng-binding ng-scope">{{profile.profileId != 2 ? profile.profileName : (\'team-management.storeOwner\' | translate) }}</span></td><td><div style="margin-left: 40%; margin-top: -5px" class="btn-group"><div class="checkbox" style="margin-top: 0px; margin-bottom: 0px"><label tooltip-placement="top-left" uib-tooltip="{{\'team-management.selectUser\' | translate}}"><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.selectUnselectUser(user)" ng-checked="vm.isUserSelected(user)"> <span class="checkbox-material"><span class="check"></span></span></label></div></div></td></tr></tbody></table></div></div></div><div ng-if="vm.loadingInvoices" class="tab-content" style="height: 602px; display: flex;\n                                    align-items: center;\n                                    justify-content: center"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div></div></div></div></div></div></div></div><div class="modal-footer"><button ladda="vm.isSaving" type="submit" formnovalidate ng-disabled="(editForm.$invalid && editForm.$submitted)" class="btn btn-primary" data-style="slide-left"><span class="fa fa-user-plus"></span>&nbsp; <span ng-show="!vm.team.id" data-translate="team-management.home.createLabel">Create new team</span> <span ng-show="vm.team.id" data-translate="team-management.home.editLabel">Edit Team</span></button></div></form>');
$templateCache.put('app/admin/team-management/team-management.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-title"><p class="sc-default-title-font" data-translate="team-management.home.title">Teams</p></div><div class="ibox-content"><div class="row"><div class="col-xs-12 col-sm-4" align="left"><div class="inner-addon left-addon"><i class="glyphicon glyphicon-search"></i> <input type="text" class="form-control" ng-model="vm.filterFields[vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].name]" ng-change="vm.filterField(vm.filterFields[vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].name], vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].name)" placeholder="{{\'global.table.search\' | translate }}{{vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].displayName | translate | lowercase}}"></div></div><div class="col-xs-12 col-sm-4" align="left"><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"><span class="dropdown-text">{{vm.gridTableOptions.paginationPageSize}}</span></button><ul class="dropdown-menu pull-right" role="menu"><li ng-repeat="size in vm.pagesSize" ng-class="{\'active\': vm.gridTableOptions.paginationPageSize === size}" ng-click="vm.changePageSize(size)" ng-if="size != 0"><a class="dropdown-item dropdown-item-button">{{size}}</a></li><li aria-selected="false" ng-click="vm.changePageSize(vm.totalItems)"><a class="dropdown-item dropdown-item-button">All</a></li></ul><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span class="glyphicon glyphicon-th"></span></button><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)"><li ng-repeat="column in vm.gridTableOptions.columnDefs track by $index"><div class="form-group"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.changeColumnView($index)" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{column.displayName | translate}}</label></div></div></li></ul></div><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span class="glyphicon glyphicon-filter"></span></button><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)"><li ng-repeat="column in vm.gridTableOptions.columnDefs | limitTo:vm.gridTableOptions.columnDefs.length-2:1"><div class="form-group input-group"><input type="text" ng-model="vm.filterFields[column.name]" class="form-control input-size" ng-change="vm.reloadTeams()" placeholder="Search by {{column.displayName | translate | lowercase}}"></div></li></ul></div></div></div><div class="col-xs-12 col-sm-4" align="right"><button class="btn btn-primary btn-large" ng-click="vm.addUser()" has-any-authority="ADMIN_UPDATE_USER, STORE_READ_USER"><span class="icon-ksc-adduser" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span><span data-translate="team-anagement.home.createLabel">Create new Team</span></button></div></div><div class="row"><div class="col-xs-12"><div ui-grid="vm.gridTableOptions" ui-grid-pagination ui-grid-exporter class="profile-table" style="margin-top: 15px"></div></div></div><div class="row"><div class="col-xs-12 col-sm-2" align="left"><i class="fa fa-file-pdf-o" ng-click="vm.exporterTable(\'pdf\')" aria-hidden="true"></i> <i class="fa fa-file-excel-o" ng-click="vm.exporterTable(\'csv\')" aria-hidden="true"></i> <i class="fa fa-print" aria-hidden="true"></i></div><div class="col-xs-12 col-sm-4 panel-entries-text" align="right"><p data-translate="global.table.pagination" translate-values="{start: \'{{vm.startRegistry}}\', end: \'{{vm.endRegistry}}\', total: \'{{vm.gridTableOptions.data.length}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.gridTableOptions.data.length }}</p></div><div class="col-xs-12 col-sm-6" align="right"><ul class="pagination"><li class="page-item" ng-class="{\'disabled\' : vm.checkIsFirstPage}" ng-disabled="vm.checkIsFirstPage"><a class="page-link" ng-click="vm.gridTableApi.pagination.seek(1)">&lt;&lt;</a></li><li class="page-item" ng-class="{\'disabled\' : vm.checkIsFirstPage}" ng-disabled="vm.checkIsFirstPage"><a class="page-link" ng-click="vm.gridTableApi.pagination.previousPage()">&lt;</a></li><li class="page-item" ng-repeat="page in vm.arrayPagination" ng-class="{\'active\': vm.gridTableApi.pagination.getPage() === page}"><a class="page-link" ng-click="vm.gridTableApi.pagination.seek(page)">{{page}}</a></li><li class="page-item" ng-class="{\'disabled\' : vm.checkIsLastPage}" ng-disabled="vm.checkIsLastPage"><a class="page-link" ng-disabled="vm.checkLastPage" ng-click="vm.gridTableApi.pagination.nextPage()">&gt;</a></li><li class="page-item" ng-class="{\'disabled\' : vm.checkIsLastPage}" ng-disabled="vm.checkIsLastPage"><a class="page-link" ng-click="vm.gridTableApi.pagination.seek(vm.gridTableApi.pagination.getTotalPages())">&gt;&gt;</a></li></ul></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/term-of-use/term-of-use.html','<div><div class="term-modal-header"><i class="fa fa-lock" aria-hidden="true" style="color: #e2e3e3; font-size: 10rem"></i><h1 class="modal-title">Termos de Uso e Pol\xEDtica de Privacidade</h1><label>Plataforma de Vendas</label></div><div class="term-modal-body"><div class="container-fluid"><div class="term"><p>O uso da plataforma est\xE1 condicionado \xE0 aceita\xE7\xE3o e ao cumprimento dos Termos de Uso e Pol\xEDtica de Privacidade descrito nos links abaixo. Para fazer uso da plataforma \xE9 preciso ler atentamente e concordar com os termos descritos nos documentos abaixo.</p><p>Desta forma, concorda que leu, entendeu e aceitou todos os termos, regras e condi\xE7\xF5es apresentadas nos documentos.</p><p>A empresa gestora da plataforma se reserva ao direito de modificar a qualquer momento a apresenta\xE7\xE3o, configura\xE7\xE3o e disponibiliza\xE7\xE3o da solu\xE7\xE3o. O mesmo se aplica a estes termos e condi\xE7\xF5es de uso, estabelecidos como condi\xE7\xE3o fundamental para a utiliza\xE7\xE3o do servi\xE7o</p><br><br><a ng-href="{{vm.hub.termsOfUseAdmin}}" target="_blank">Termos de Uso</a> <a ng-href="{{vm.hub.privacyPolicyAdmin}}" target="_blank" style="margin-left: 20px">Pol\xEDtica de Privacidade</a></div></div></div><div class="modal-footer"><div class="col-xs-12 col-md-6 term-btn-footer"><div class="checkbox" style="margin: 0 !important"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.checkAcceptTerms()" ng-model="vm.acceptTermsMarkersChecked"> <span class="checkbox-material"><span class="check"></span> </span><span>Li e aceito os Termos e a Pol\xEDtica</span></label></div></div><div class="col-xs-12 col-md-6"><button ng-click="vm.save()" ng-disabled="vm.disableButtonSave()" type="button" class="btn btn-primary mr-auto term-btn-continue-footer">Aceitar</button></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" ng-submit="vm.save(editForm)" ng-init="vm.initDateTimePicker()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="{{!vm.userLogin ? \'userManagement.home.createTitle\' : \'userManagement.home.editTitle\' }}">Create or edit a User</h4></div><div class="modal-body"><div class="container-fluid"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label class="control-label required" data-translate="userManagement.email">Email</label><input type="email" autocomplete="off" class="form-control" name="email" typeahead-select-on-blur="false" ng-model="vm.user.email" uib-typeahead="user as vm.userDescription(user) for user in vm.users($viewValue)" placeholder="Regular Placeholder" translate translate-attr-placeholder="userManagement.findByEmail" ng-disabled="(vm.user.id && vm.storeId !== 0)" ng-pattern=\'/^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$/i\' required ng-maxlength="100" ng-minlength="5"><div class="help-block-div" ng-show="editForm.email.$invalid && editForm.$submitted"><p class="help-block form-invalid-field" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block form-invalid-field" ng-show="editForm.email.$error.pattern" data-translate="global.messages.validate.email.invalid">Please input a valid mail.</p></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><!--ng-show="(vm.user.email && editForm.email.$valid && editForm.email.$dirty && editForm.email.$touched) || vm.registeredUser"--><label class="control-label required" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50" ng-disabled="(vm.user.id && vm.storeId !== 0)" ng-readonly="vm.registeredUser" required><div class="help-block-div" ng-show="editForm.firstName.$invalid && editForm.$submitted"><p class="help-block form-invalid-field" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><!--ng-show="(vm.user.email && editForm.email.$valid && editForm.email.$dirty && editForm.email.$touched) || vm.registeredUser"--><label data-translate="userManagement.lastName" class="control-label required">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50" ng-disabled="(vm.user.id && vm.storeId !== 0)" ng-readonly="vm.registeredUser" required><div class="help-block-div" ng-show="editForm.lastName.$invalid && editForm.$submitted"><p class="help-block form-invalid-field" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><label data-translate="userManagement.dateOfBirth" class="control-label required">Date of birth</label><div class="input-group date" id="dateOfBirth"><input type="text" name="dateOfBirth" class="form-control inputDate external-control" ng-model="vm.user.dateOfBirth" ui-mask-placeholder ui-mask="{{vm.maskLocale}}" name="dateOfBirth" placeholder="{{\'global.form.dateOfBirth\' | translate}}" ng-required="true" autocomplete="off" ng-disabled="(vm.user.id && vm.storeId !== 0)"> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><div class="help-block-div" ng-show="editForm.dateOfBirth.$invalid && editForm.$submitted"><p class="help-block form-invalid-field" ng-show="editForm.dateOfBirth.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><label data-translate="userManagement.phone" class="control-label">Phone</label><input type="tel" name="phone" id="phone" class="form-control" ng-model="vm.user.phone" intl-tel-input ng-disabled="(vm.user.id && vm.storeId !== 0)"><div class="help-block-div" ng-show="editForm.phone.$invalid && editForm.$submitted"><p class="help-block form-invalid-field" ng-show="editForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="editForm.phone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label class="control-label required" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-readonly="vm.registeredUser" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" ng-disabled="(vm.user.id && vm.storeId !== 0)"><div class="help-block-div" ng-show="editForm.login.$invalid && editForm.$submitted"><p class="help-block form-invalid-field" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block form-invalid-field" ng-show="editForm.login.$error.minlength" data-translate="entity.validation.minlength" translate-value-max="1">This field cannot be longer than 1 characters.</p><p class="help-block form-invalid-field" ng-show="editForm.login.$error.pattern" data-translate="userManagement.messages.validate.login.pattern">Your username can only contain letters and digits.</p></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><label for="gender" data-translate="userManagement.messages.gender.label" class="control-label required">Gender</label><select ng-disabled="(vm.user.id && vm.storeId !== 0)" class="form-control" name="gender" id="gender" ng-model="vm.user.gender" ng-options="vm.getGenderKey(value) | translate for (key, value) in vm.genders" required><option value="">{{ \'userManagement.messages.select\' | translate }}</option></select><div class="help-block-div" ng-show="editForm.gender.$invalid && editForm.$submitted"><p class="help-block form-invalid-field" ng-show="editForm.gender.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-xs-12 col-md-6 form-group" ng-if="vm.storeId === 0"><label for="profileType" class="control-label required" data-translate="userManagement.profileName">Profile</label><select class="form-control" ng-model="vm.user.profileType" id="profileType" name="profileType" ng-required="vm.storeId === 0"><option value="1">Administrator</option><option value="2">Store Manager</option></select><div class="help-block-div" ng-show="editForm.profileType.$invalid && editForm.$submitted"><p class="help-block form-invalid-field" ng-show="editForm.profileType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-xs-12 col-md-6 form-group" ng-if="vm.storeId != 0 && !vm.hasProfileSupport(vm.user)"><label for="storeProfile" data-translate="userManagement.profile" class="control-label required">User profile</label><select class="form-control" name="storeProfile" id="storeProfile" ng-options="profile.id as profile.name for profile in vm.profiles" ng-model="vm.user.userProfiles[0].profileId" required><option value="">{{ \'userManagement.messages.select\' | translate }}</option></select><div class="help-block-div" ng-show="editForm.storeProfile.$invalid && editForm.$submitted"><p class="help-block form-invalid-field" ng-show="editForm.storeProfile.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row" ng-if="vm.storeId != 0 && !vm.hasProfileSupport(vm.user)"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><label for="commission-percentage" data-translate="userManagement.commission-percentage" class="control-label">Commission Percentage</label><input id="commission-percentage" name="commission-percentage" class="form-control" type="text" min="0" numbers-only ng-model="vm.user.userProfiles[0].commissionPercentage"></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><label class="control-label" data-translate="userManagement.referral-code">Referral Code</label><input type="text" class="form-control" name="referral-code" ng-model="vm.user.userProfiles[0].referralCode"></div></div></div></div><div class="modal-footer"><button ladda="vm.isSaving" type="submit" ng-disabled="(editForm.$invalid && editForm.$submitted)" class="btn btn-primary" data-style="slide-left"><span class="fa fa-user-plus"></span>&nbsp; <span ng-show="!vm.user.id || (vm.user.id && vm.registeredUser)" data-translate="userManagement.home.createLabel">Create new profile</span> <span ng-show="vm.user.id && !vm.registeredUser" data-translate="userManagement.home.editLabel">Edit User</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-title"><p class="sc-default-title-font" data-translate="userManagement.home.title">Customers user</p></div><div class="ibox-content"><div class="row"><div class="col-xs-12 col-sm-4" align="left"><div class="inner-addon left-addon"><i class="glyphicon glyphicon-search"></i> <input type="text" class="form-control" ng-model="vm.filterFields[vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].name]" ng-change="vm.filterField(vm.filterFields[vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].name], vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].name)" placeholder="{{\'global.table.search\' | translate }}{{vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].displayName | translate | lowercase}}"></div></div><div class="col-xs-12 col-sm-4" align="left"><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"><span class="dropdown-text">{{vm.gridTableOptions.paginationPageSize}}</span></button><ul class="dropdown-menu pull-right" role="menu"><li ng-repeat="size in vm.pagesSize" ng-class="{\'active\': vm.gridTableOptions.paginationPageSize === size}" ng-click="vm.changePageSize(size)" ng-if="size != 0"><a class="dropdown-item dropdown-item-button">{{size}}</a></li><li aria-selected="false" ng-click="vm.changePageSize(vm.totalItems)"><a class="dropdown-item dropdown-item-button">All</a></li></ul><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span class="glyphicon glyphicon-th"></span></button><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)"><li ng-repeat="column in vm.gridTableOptions.columnDefs track by $index"><div class="form-group"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.changeColumnView($index)" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{column.displayName | translate}}</label></div></div></li></ul></div><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span class="glyphicon glyphicon-filter"></span></button><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)"><li ng-repeat="column in vm.gridTableOptions.columnDefs | limitTo:vm.gridTableOptions.columnDefs.length-2:1"><div class="form-group input-group"><input type="text" ng-model="vm.filterFields[column.name]" class="form-control input-size" ng-change="vm.reloadUsers()" placeholder="Search by {{column.displayName | translate | lowercase}}"></div></li></ul></div></div></div><div class="col-xs-12 col-sm-4" align="right"><button class="btn btn-primary btn-large" ng-click="vm.addUser()" has-any-authority="ADMIN_UPDATE_USER, STORE_READ_USER"><span class="icon-ksc-adduser" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span><span data-translate="userManagement.home.createLabel">Create new user</span></button></div></div><div class="row"><div class="col-xs-12"><div ui-grid="vm.gridTableOptions" ui-grid-pagination ui-grid-exporter class="profile-table" style="margin-top: 15px"></div></div></div><div class="row"><div class="col-xs-12 col-sm-2" align="left"><i class="fa fa-file-pdf-o" ng-click="vm.exporterTable(\'pdf\')" aria-hidden="true"></i> <i class="fa fa-file-excel-o" ng-click="vm.exporterTable(\'csv\')" aria-hidden="true"></i> <i class="fa fa-print" aria-hidden="true"></i></div><div class="col-xs-12 col-sm-4 panel-entries-text" align="right"><p data-translate="global.table.pagination" translate-values="{start: \'{{vm.startRegistry}}\', end: \'{{vm.endRegistry}}\', total: \'{{vm.gridTableOptions.data.length}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.gridTableOptions.data.length }}</p></div><div class="col-xs-12 col-sm-6" align="right"><ul class="pagination"><li class="page-item" ng-class="{\'disabled\' : vm.checkIsFirstPage}" ng-disabled="vm.checkIsFirstPage"><a class="page-link" ng-click="vm.gridTableApi.pagination.seek(1)">&lt;&lt;</a></li><li class="page-item" ng-class="{\'disabled\' : vm.checkIsFirstPage}" ng-disabled="vm.checkIsFirstPage"><a class="page-link" ng-click="vm.gridTableApi.pagination.previousPage()">&lt;</a></li><li class="page-item" ng-repeat="page in vm.arrayPagination" ng-class="{\'active\': vm.gridTableApi.pagination.getPage() === page}"><a class="page-link" ng-click="vm.gridTableApi.pagination.seek(page)">{{page}}</a></li><li class="page-item" ng-class="{\'disabled\' : vm.checkIsLastPage}" ng-disabled="vm.checkIsLastPage"><a class="page-link" ng-disabled="vm.checkLastPage" ng-click="vm.gridTableApi.pagination.nextPage()">&gt;</a></li><li class="page-item" ng-class="{\'disabled\' : vm.checkIsLastPage}" ng-disabled="vm.checkIsLastPage"><a class="page-link" ng-click="vm.gridTableApi.pagination.seek(vm.gridTableApi.pagination.getTotalPages())">&gt;&gt;</a></li></ul></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/wati/wati.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-store-font ng-scope">Configure sua conta do Wati</h1><p class="ng-scope">\xC9 importante configurar uma conta de Whatsapp para se relacionar melhor com seus clientes.</p></div></div><hr><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-store-font ng-scope">URL para o Wati comunicar-se com a plataforma Showkase</h1><p class="ng-scope">Copie a URL abaixo e adicione nas configura\xE7\xF5es de webhook na plataforma do Wati.</p><a class="ng-scope" style="font-weight: bold" copy-to-clipboard="{{vm.webhook}}">Copiar link <i class="fa fa-files-o" aria-hidden="true"></i></a></div></div><hr><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-store-font ng-scope">Configura\xE7\xE3o de Seguran\xE7a</h1><p class="ng-scope">Garanta que a troca de mensagens entre a plataforma Showkase vai ser realizada de forma segura. Adicione as informa\xE7\xF5es de Token de Acesso e URL dispon\xEDveis no Wati.</p></div><form name="vm.watiAccountDataForm" novalidate><div class="form-group col-xs-12 col-md-6"><label class="required" for="watiToken">Token de Acesso do Wati</label><input id="watiToken" name="watiToken" ng-model="vm.watiAccountData.watiToken" type="text" class="form-control" required placeholder="Ex: Bearer 1WJHS..."><div ng-show="vm.watiAccountDataForm.watiToken.$invalid && vm.watiAccountDataForm.watiToken.$touched"><p class="help-block form-invalid-field" ng-show="vm.watiAccountDataForm.watiToken.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-xs-12 col-md-6"><label class="required" for="watiUri">URL da API</label><input id="watiUri" name="watiUri" ng-model="vm.watiAccountData.watiUri" type="text" class="form-control" required placeholder="Ex: https://live-server-5658.whats.com"><div ng-show="vm.watiAccountDataForm.watiUri.$invalid && vm.watiAccountDataForm.watiUri.$touched"><p class="help-block form-invalid-field" ng-show="vm.watiAccountDataForm.watiUri.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-xs-12 col-md-12"><button ng-click="vm.saveOrUpdate()" id="btnCreateWatiConfig" ladda="vm.isSaving" class="btn btn-primary btn-large pull-right" data-style="slide-left"><span data-translate="global.form.save"></span> <span class="fa fa-sign-in m-l-xs" style="font-size: 1.3em" aria-hidden="true"></span></button></div></form></div></div></div></div></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" id="authenticationError" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile><a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/components/util/loading.html','<div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div>');
$templateCache.put('app/entities/profile/profile-management-detail.html','<form name="editProfileForm" role="form"><div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-title"><h4 data-translate="showcaseApp.profile.home.title">Profile Management</h4></div><div class="ibox-content"><div class="row"><div class="col-xs-12 col-sm-7"><div class="form-group"><label class="control-label required" data-translate="showcaseApp.profile.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.profile.name" required ng-minlength="4" ng-maxlength="128"><div ng-show="editProfileForm.name.$invalid && editProfileForm.name.$dirty"><p class="help-block form-invalid-field" ng-show="editProfileForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="editProfileForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 25 characters.</p><p class="help-block form-invalid-field" ng-show="editProfileForm.name.$error.minlength" data-translate="entity.validation.maxlength" translate-value-max="4">This field cannot be longer than 25 characters.</p></div></div><div class="form-group" ng-if="vm.profile.profileOwner == \'0\'"><label class="control-label required" data-translate="showcaseApp.profile.type" for="field_type">Type</label><select class="form-control" ng-model="vm.profile.type" name="type" required><option ng-repeat="type in vm.profileTypes" ng-selected="type === ADMIN_PROFILE" data-translate="{{\'showcaseApp.profile.types.\'+type}}"></option></select><div ng-show="editForm.type.$invalid && editForm.type.$dirty"><p class="help-block form-invalid-field" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label required" data-translate="showcaseApp.profile.description" for="field_description">Description</label><textarea type="text" class="form-control" name="description" id="field_description" rows="7" ng-model="vm.profile.description"></textarea></div></div><div class="col-xs-12 col-sm-5"><div id="{{authoritie.authority}}_PERMISSION_ID" ng-disabled="{{authoritie.authority == \'STORE_READ\'}}" class="form-group" ng-repeat="authoritie in vm.authoritiesWithHierarchy track by $index"><div class="checkbox" ng-if="authoritie.authority == \'STORE_READ\'"><label tooltip-placement="top-left" uib-tooltip="{{\'showcaseApp.profile.messages.tooltips.defaultPermission\' | translate}}"><input type="checkbox" ng-disabled="{{authoritie.authority == \'STORE_READ\'}}" class="dropdown-item-checkbox" ng-change="vm.isAuthorityDependenciesChecked($index)" ng-model="vm.authoritiesCheck[$index]"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="{{\'showcaseApp.profile.authoritiesList.\'+authoritie.authority}}"></span></label></div><div class="checkbox" ng-if="vm.profileId == 9 && (authoritie.authority == \'HUB_STORES\' \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t|| authoritie.authority == \'HUB_PRODUCTS\' \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t|| authoritie.authority == \'HUB_SHOWKASE\' \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t|| authoritie.authority == \'HUB_CAMPAIGNS\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t|| authoritie.authority == \'HUB_FILE_MANAGER\')"><label><input type="checkbox" ng-disabled="{{authoritie.authority == \'STORE_READ\'}}" class="dropdown-item-checkbox" ng-change="vm.isAuthorityDependenciesChecked($index)" ng-model="vm.authoritiesCheck[$index]"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="{{\'showcaseApp.profile.authoritiesList.\'+authoritie.authority}}"></span></label></div><div class="checkbox" ng-if="authoritie.authority != \'STORE_READ\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& authoritie.authority != \'HUB_STORES\' \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& authoritie.authority != \'HUB_PRODUCTS\' \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& authoritie.authority != \'HUB_SHOWKASE\' \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& authoritie.authority != \'HUB_CAMPAIGNS\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&& authoritie.authority != \'HUB_FILE_MANAGER\'"><label><input type="checkbox" ng-disabled="{{authoritie.authority == \'STORE_READ\'}}" class="dropdown-item-checkbox" ng-change="vm.isAuthorityDependenciesChecked($index)" ng-model="vm.authoritiesCheck[$index]"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="{{\'showcaseApp.profile.authoritiesList.\'+authoritie.authority}}"></span></label></div></div></div></div><div class="row"><div class="col-xs-12" align="right"><button ladda="vm.isSaving" class="btn btn-primary btn-large" ng-disabled="editProfileForm.$invalid || vm.authoritiesCheck.indexOf(true) == \'-1\'" ng-click="vm.save()" align="left" data-style="slide-left"><span class="fa fa-user-plus" aria-hidden="true"></span>&nbsp;<span ng-show="vm.isNewProfile" data-translate="showcaseApp.profile.home.createLabel">Create profile</span><span ng-show="!vm.isNewProfile" data-translate="showcaseApp.profile.home.editLabel">Edit a profile</span></button></div></div></div></div></div></div></div></form>');
$templateCache.put('app/entities/profile/profile-management.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-title"><p class="sc-default-title-font" data-translate="showcaseApp.profile.home.title">Customers profile</p></div><div class="ibox-content"><div class="row"><div class="col-xs-12 col-sm-4" align="left"><div class="inner-addon left-addon"><i class="glyphicon glyphicon-search"></i> <input type="text" class="form-control" ng-model="vm.filterFields[vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].name]" ng-change="vm.reloadProfiles()" placeholder="{{\'global.table.search\' | translate }}{{vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].displayName | translate | lowercase}}"></div></div><div class="col-xs-12 col-sm-4" align="left"><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"><span class="dropdown-text">{{vm.gridTableOptions.paginationPageSize}}</span></button><ul class="dropdown-menu pull-right" role="menu"><li ng-repeat="size in vm.pagesSize" ng-class="{\'active\': vm.gridTableOptions.paginationPageSize === size}" ng-click="vm.changePageSize(size)" ng-if="size != 0"><a class="dropdown-item dropdown-item-button">{{size}}</a></li><li aria-selected="false" ng-click="vm.changePageSize(vm.totalItems)"><a class="dropdown-item dropdown-item-button">All</a></li></ul><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span class="glyphicon glyphicon-th"></span></button><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)"><li ng-repeat="column in vm.gridTableOptions.columnDefs track by $index"><div class="form-group"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.changeColumnView($index)" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{column.displayName | translate}}</label></div></div></li></ul></div><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span class="glyphicon glyphicon-filter"></span></button><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)"><li ng-repeat="column in vm.gridTableOptions.columnDefs | limitTo:2:1"><div class="form-group input-group"><input type="text" ng-model="vm.filterFields[column.name]" class="form-control input-size" ng-change="vm.reloadProfiles()" placeholder="Search by {{column.displayName | translate | lowercase}}"></div></li></ul></div></div></div><div class="col-xs-12 col-sm-4" align="right"><a ui-sref="profile-detail({\'storeId\': 0})"><button class="btn btn-primary btn-large" has-any-authority="ADMIN_MANAGE_PROFILE, STORE_READ_PROFILE"><span class="icon-ksc-adduser" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span><span data-translate="showcaseApp.profile.home.createLabel">Create new profile</span></button></a></div></div><div class="row"><div class="col-xs-12"><div ui-grid="vm.gridTableOptions" ui-grid-auto-resize ui-grid-pagination ui-grid-exporter class="profile-table" style="margin-top: 15px"></div></div></div><div class="row"><div class="col-xs-12 col-sm-2" align="left"><i class="fa fa-file-pdf-o" ng-click="vm.exporterTable(\'pdf\')" aria-hidden="true"></i> <i class="fa fa-file-excel-o" ng-click="vm.exporterTable(\'csv\')" aria-hidden="true"></i> <i class="fa fa-print" aria-hidden="true"></i></div><div class="col-xs-12 col-sm-4 panel-entries-text" align="right"><p data-translate="global.table.pagination" translate-values="{start: \'{{vm.startRegistry}}\', end: \'{{vm.endRegistry}}\', total: \'{{vm.totalItems}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalItems }}</p></div><div class="col-xs-12 col-sm-6" align="right"><ul class="pagination"><li class="page-item" ng-class="{\'disabled\' : vm.checkIsFirstPage}" ng-disabled="vm.checkIsFirstPage"><a class="page-link" ng-click="vm.gridTableApi.pagination.seek(1)">&lt;&lt;</a></li><li class="page-item" ng-class="{\'disabled\' : vm.checkIsFirstPage}" ng-disabled="vm.checkIsFirstPage"><a class="page-link" ng-click="vm.gridTableApi.pagination.previousPage()">&lt;</a></li><li class="page-item" ng-repeat="page in vm.arrayPagination" ng-class="{\'active\': vm.gridTableApi.pagination.getPage() === page}"><a class="page-link" ng-click="vm.gridTableApi.pagination.seek(page)">{{page}}</a></li><li class="page-item" ng-class="{\'disabled\' : vm.checkIsLastPage}" ng-disabled="vm.checkIsLastPage"><a class="page-link" ng-disabled="vm.checkLastPage" ng-click="vm.gridTableApi.pagination.nextPage()">&gt;</a></li><li class="page-item" ng-class="{\'disabled\' : vm.checkIsLastPage}" ng-disabled="vm.checkIsLastPage"><a class="page-link" ng-click="vm.gridTableApi.pagination.seek(vm.gridTableApi.pagination.getTotalPages())">&gt;&gt;</a></li></ul></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/store-management/store-management-detail.html','<div class="wrapper wrapper-content"><div class="row row-eq-height"><div class="col-xs-12 col-md-4"><div class="ibox" style="height: 100%; background-color: #FFFFFF"><div class="ibox-title"><h5 class="sc-default-title-font" data-translate="store-management.detail.title">Store Details</h5><span class="fa fa-pencil-square-o store-detail-button" tooltip-placement="top-right" uib-tooltip="{{\'store-management.detail.buttons.info\' | translate}}" has-authority="STORE_UPDATE" ng-click="vm.getEditStorePage()"></span></div><img class="store-img-shadow" style="width: 100%" ng-src="{{vm.store.image}}" on-error-src="content/images/defaultShowcaseImage.png"><div class="ibox-content"><div class="label-loading-detail" ng-show="vm.isLoading"><div class="loading-row" style="height: 200px !important"></div><div class="loading-row"></div><div class="loading-row"></div><div class="loading-row"></div></div><p class="sc-default-title-font store-item-name" ng-show="!vm.isLoading" style="width: 100%; padding-bottom: 3px">{{vm.store.name}}</p><p class="store-item-category">{{vm.store.categoryName}}</p><p class="sc-default-subtitle-font" style="font-size: 0.95em !important; font-weight: bold" ng-show="!vm.isLoading" data-translate="store-management.detail.contact">Contato</p><span class="store-item-contact">{{vm.store.contactPhone}}<br ng-if="vm.store.email && vm.store.contactPhone">{{vm.store.email}}</span></div><div class="store-flyer-info"><hr id="store-flyer-info-line"><p style="text-align: center; font-size: 1.2em"><span class="fa fa-tag coupon-text-color" style="font-size: 1.4em"></span> {{vm.store.numberOfFlyers}} <span data-translate=""></span><span data-translate="flyers.home.title"></span></p></div></div></div><div class="col-xs-12 col-md-8"><div class="ibox" style="height: 100%; background-color: #FFFFFF"><div class="ibox-title"><h5 class="sc-default-title-font" data-translate="store-management.detail.location">Location</h5><br></div><div class="ibox-content"><p data-translate="store-management.detail.map">View on the map the locations where coupons can be used</p><div class="loading-map-detail" ng-show="vm.isLoading"></div><ui-gmap-google-map ng-if="vm.showMap" center="vm.mainMap.center" zoom="vm.mainMap.zoom" options="vm.options" control="vm.mainMap.controls" style="height: 400px"><ui-gmap-markers models="vm.mainMap.markers" coords="\'self\'" idkey="\'id\'" options="\'options\'" events="vm.mainMap.markerEvents" fit="\'true\'"></ui-gmap-markers><ui-gmap-window show="vm.mainMap.window.show" coords="vm.mainMap.window.model" options="vm.mainMap.window.options" templateparameter="vm.mainMap.window.model" closeclick="vm.mainMap.window.closeClick()" ng-cloak></ui-gmap-window></ui-gmap-google-map><div align="right" style="margin-top: 15px"><span has-authority="STORE_UPDATE" class="store-upload-button" style="font-size: 1.2em" ng-click="vm.addSalesPoint()"><span data-translate="store-management.detail.salespoint">Add Sales Point </span><i style="margin-left: 5px; font-size: 2em" class="fa icon-ksc-addstore" aria-hidden="true"></i></span></div></div></div></div></div><div class="row" style="margin-top: 30px"><div class="col-xs-12"><div class="ibox"><div class="ibox-title"><h5 data-translate="store-management.detail.users">Accounts Configuration</h5></div><div class="ibox-content"><div class="row"><div class="col-xs-12 col-sm-4" align="left"><div class="inner-addon left-addon"><i class="glyphicon glyphicon-search"></i> <input type="text" class="form-control" ng-model="vm.filterFields[vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].name]" ng-change="vm.checkColumnFilter(vm.filterFields[vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].name], 0)" ng-change="vm.reloadUsers()" placeholder="{{\'global.table.search\' | translate }}{{vm.gridTableOptions.columnDefs[vm.defaultSearchIndex].displayName | translate | lowercase}}"></div></div><div class="col-xs-12 col-sm-4" align="left"><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"><span class="dropdown-text">{{vm.gridTableOptions.paginationPageSize}}</span></button><ul class="dropdown-menu pull-right" role="menu"><li ng-repeat="size in vm.pagesSize" ng-class="{\'active\': vm.gridTableOptions.paginationPageSize === size}" ng-click="vm.changePageSize(size)" ng-if="size != 0"><a class="dropdown-item dropdown-item-button">{{size}}</a></li><li aria-selected="false" ng-click="vm.changePageSize(vm.totalItems)"><a class="dropdown-item dropdown-item-button">All</a></li></ul><div class="dropdown dropdown-table btn-group"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span class="glyphicon glyphicon-th"></span></button><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)"><li ng-repeat="column in vm.gridTableOptions.columnDefs track by $index"><div class="form-group"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.changeColumnView($index)" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{column.displayName | translate}}</label></div></div></li></ul></div><div class="dropdown dropdown-table btn-group" ng-if="vm.usersTable"><button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"><span class="glyphicon glyphicon-filter"></span></button><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)"><li ng-repeat="column in vm.gridTableOptions.columnDefs | limitTo:vm.gridTableOptions.columnDefs.length - 2:1 track by $index"><div class="form-group input-group"><input type="text" ng-model="vm.filterFields[column.name]" ng-change="vm.checkColumnFilter(vm.filterFields[column.name], $index+1)" class="form-control store-filterinput-size" ng-change="vm.reloadUsers()" placeholder="{{\'store-management.detail.searchBy\' | translate}} {{column.displayName | translate | lowercase}}"></div></li></ul></div></div></div><div class="col-xs-12 col-sm-4" align="right"><a ui-sref="store-profile-detail({\'storeId\': vm.store.id})" ng-if="vm.profilesTable"><button class="btn btn-primary btn-large" has-any-authority="ADMIN_MANAGE_PROFILE, STORE_CREATE_PROFILE"><span class="icon-ksc-adduser" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="showcaseApp.profile.home.createLabel">Create new profile</span></button> </a><button class="btn btn-primary btn-large" ng-if="vm.usersTable" ng-click="vm.addUserStore()" has-authority="STORE_CREATE_USER"><span class="icon-ksc-adduser" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="userManagement.home.createLabel">Create new user</span></button> <button class="btn btn-primary btn-large" ng-if="vm.teamsTable" ng-click="vm.addTeamStore()" has-authority="STORE_CREATE_USER"><span class="icon-ksc-adduser" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="team-management.home.createLabel">Create new team</span></button></div></div><div class="row"><div class="col-xs-12"><uib-tabset active="0" style="margin-top: 20px"><uib-tab index="0" heading="{{\'userManagement.title\' | translate}}" ng-click="vm.changeTab(\'Users\')"><div class="col-xs-12" style="margin-top: 20px"><div ng-if="vm.usersTable" ui-grid="vm.gridTableOptions" ui-grid-pagination ui-grid-exporter></div></div></uib-tab><uib-tab index="1" heading="{{\'userManagement.profiles\' | translate}}" ng-click="vm.changeTab(\'Profiles\')"><div class="col-xs-12" style="margin-top: 20px"><div ng-if="vm.profilesTable" ui-grid="vm.gridTableOptions" ui-grid-pagination ui-grid-exporter></div></div></uib-tab><uib-tab index="2" heading="{{\'team-management.title\' | translate}}" ng-click="vm.changeTab(\'Teams\')"><div class="col-xs-12" style="margin-top: 20px"><div ng-if="vm.teamsTable" ui-grid="vm.gridTableOptions" ui-grid-pagination ui-grid-exporter></div></div></uib-tab></uib-tabset></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/store-management/store-management-edit-image.html','<form name="salesPointEditForm" role="form" novalidate ng-submit="vm.save()" ng-init="vm.initModal()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" data-translate="store-management.home.editStoreImage">Edit a store image</h4></div><div class="modal-body"><div class="container-fluid"><div class="row"><div class="col-xs-12"><div class="col-xs-12 col-sm-6 store-img-right"><input accept="image/x-png,image/gif,image/jpeg" type="file" id="fileInput" style="display: none"> <span class="store-upload-button" ng-click="vm.openInput($event)"><span data-translate="store-management.new.form.chooseimage">Choose Image</span><i style="margin-left: 5px" class="fa fa-upload" aria-hidden="true"></i></span><div class="cropArea" ng-if="vm.imageCroppedActive"><img-crop ng-if="vm.imageCroppedActive && vm.imageUpload" area-type="square" image="vm.imageUpload" result-image-size="vm.imageSize" result-image="vm.croppedImage" result-image-quality="1.0"></img-crop><p ng-if="!vm.imageUpload" id="noimg-icon" class="icon-ksc-storelogo"></p></div></div><div class="col-xs-12 col-sm-6 store-img-nopadding"><p ng-if="vm.imageCroppedActive"><strong data-translate="store-management.new.form.previewimage">Preview Image:</strong></p><div><img class="img-responsive" ng-src="{{vm.croppedImage}}"></div></div></div></div></div></div><div class="modal-footer"><button ladda="vm.isSaving" type="submit" class="btn btn-primary" data-style="slide-left"><span class="fa icon-ksc-addstore"></span>&nbsp;<span data-translate="store-management.home.editStoreImage">Atualizar imagem da loja</span></button></div></form>');
$templateCache.put('app/admin/store-management/store-management-edit.html','<style>.custom-btn {\n        white-space: normal !important;\n        white-space: normal !important;\n        padding-bottom: 6px;\n        border: 1px solid rgb(180, 179, 179);\n        background-color: white;\n\n    >span {\n        color: rgb(136, 136, 136, 1);\n    }\n    }\n\n    .with-out-image {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        color: #a2a3a4;\n\n    >i {\n        font-size: 20px;\n    }\n    }\n\n    .box-with-out-image {\n        border: 2px dotted #a2a3a4;\n    }\n\n    .custom-box-image {\n        background-color: #f4f4f5;\n        border-radius: 10px;\n    }\n\n    .custom-image {\n        border-radius: 10px;\n    }</style><form name="vm.storeEditForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" data-translate="store-management.home.editStoreInformation">Edit a store</h4></div><div class="modal-body"><div class="tabs-container"><ul class="nav nav-tabs store-information-tabs"><li ng-class="{\'active\' : vm.tab == 1}"><a ng-click="vm.tab = 1" ng-init="vm.tab = 1"><i class="fa fa-info"></i> <span data-translate="store-management.tab.title.info"></span></a></li><li ng-class="{\'active\' : vm.tab == 2}"><a ng-click="vm.tab = 2"><i class="icon-ksc-image-solid"></i> <span data-translate="store-management.tab.title.brand"></span></a></li><li ng-class="{\'active\' : vm.tab == 3}"><a ng-click="vm.tab = 3"><i class="fa fa-file"></i> <span data-translate="store-management.tab.title.description"></span></a></li><li ng-class="{\'active\' : vm.tab == 4}"><a ng-click="vm.tab = 4"><i class="fa fa-globe"></i> <span data-translate="store-management.tab.title.social"></span></a></li><li ng-class="{\'active\' : vm.tab == 5}"><a ng-click="vm.tab = 5"><i class="fa fa-search"></i> <span data-translate="store-management.tab.title.seo"></span></a></li></ul><div class="tab-content"><div id="tab-1" class="tab-pane active" ng-show="vm.tab == 1"><div class="panel-body"><div class="row"><div class="col-md-6 form-group"><label for="nickname" class="required" data-translate="store-management.new.form.nickname">Nickname</label><input id="nickname" name="nickname" type="text" class="form-control" ng-model="vm.store.nickname" ng-change="vm.verifyNicknameIsAvailable(vm.storeEditForm)" ng-maxlength="40" ng-minlength="4" required pattern="[a-zA-Z0-9]+"><div ng-show="vm.storeEditForm.nickname.$invalid && vm.storeEditForm.$submitted"><p class="help-xblock form-invalid-field" ng-show="vm.storeEditForm.nickname.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.nickname.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.nickname.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="40">This field cannot be longer than 40 characters.</p><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.nickname.$error.nicknameIsUnavailable" data-translate="entity.validation.nickname.unavailable">This nickname is unavailable.</p><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.nickname.$error.pattern" data-translate="entity.validation.nickname.pattern">Only letter and number.</p></div></div><div class="col-md-6 form-group"><p class="store-new-domaintext"><span data-translate="store-management.messages.create.yourDomain">Your domain will be:</span><br><span>{{(vm.store.nickname | lowercase) + vm.domainSufix}}</span></p></div></div><div class="row"><div class="col-md-12 form-group"><label for="name" class="required" data-translate="store-management.new.form.name">Store name</label><input type="text" id="name" class="form-control" name="name" ng-model="vm.store.name" ng-minlength="4" required><div ng-show="vm.storeEditForm.name.$invalid && vm.storeEditForm.$submitted"><p class="help-xblock form-invalid-field" ng-show="vm.storeEditForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p></div></div></div><div class="row"><div class="col-md-6 form-group"><label for="category" class="required" data-translate="store-management.new.form.category">Category:</label><select class="form-control" name="category" id="category" ng-options="c.key as c.title for c in vm.categories" ng-model="vm.store.categoryKey" required></select><div ng-show="vm.storeEditForm.category.$invalid && vm.storeEditForm.$submitted"><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.category.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6 form-group"><label for="currency" class="required" data-translate="store-management.new.form.currency">Currency:</label><select class="form-control" name="currency" id="currency" ng-options="c.key as c.text for c in vm.currencyList" ng-model="vm.store.currency" required></select><div ng-show="vm.storeEditForm.currency.$invalid && vm.storeEditForm.$submitted"><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.currency.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><div class="col-md-12 form-group"><label for="email" class="required" data-translate="store-management.new.form.email">E-mail</label><input id="email" type="email" name="email" class="form-control" ng-model="vm.store.email" ng-maxlength="50" ng-pattern=\'/^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$/i\' required><div ng-show="vm.storeEditForm.email.$invalid && vm.storeEditForm.$submitted"><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.email.$error.pattern" data-translate="global.messages.validate.email.invalid">Please input a valid mail.</p><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row"><div class="col-md-6 form-group"><label for="cnpj">CNPJ</label><input id="cnpj" type="text" name="cnpj" class="form-control" ng-model="vm.store.cnpj" ng-cnpj ui-mask="99.999.999/9999-99"><div class="help-block-div" ng-show="vm.storeEditForm.cnpj.$invalid && vm.storeEditForm.$submitted"><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.cnpj.$invalid" data-translate="entity.validation.cnpj">This field CNPJ is invalid.</p></div></div><div class="col-md-6 form-group"><label class="required" for="celphone" data-translate="store-management.new.form.celphone">Cel phone</label><input type="tel" name="contactPhone" id="celphone" class="form-control" ng-model="vm.store.contactPhone" intl-tel-input required><div ng-show="vm.storeEditForm.contactPhone.$invalid && vm.storeEditForm.$submitted"><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.contactPhone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.contactPhone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div></div></div><div id="tab-2" class="tab-pane active" ng-show="vm.tab == 2"><div style="display: flex; flex-direction: column; justify-content: space-between; gap: 30px"><div class="panel-body"><div class="col-md-12 col-xs-12"><!-- Logo --><div style="display: flex;gap: 20px;padding: 30px; align-items: center" class="col-md-7 col-xs-12" ng-style="{\'flex-direction\': vm.isMobile ? \'column\' : \'row\', \'align-items\': vm.isMobile ? \'center\' : \'flex-start\'}"><div><input type="file" id="fileInputLogo" style="display: none" accept="image/x-png,image/jpeg,image/png"><div class="custom-box-image" style="width: 130px; height: 130px" ng-class="{\'box-with-out-image\': (!vm.logoImage) }" ng-click="vm.openInput($event, \'fileInputLogo\', \'600\', \'600\')"><div ng-if="!vm.logoImage" class="with-out-image" style="margin-top: 42px"><i class="icon-ksc-addimage"></i><p>Selecionar imagem</p></div><div ng-if="vm.logoImage" style="width: 130px; height: 130px"><img id="imgFileInputLogo" class="custom-image" style="width: 130px; height: 130px" ng-src="{{vm.logoImage}}"></div></div></div><div style="display: flex; flex-direction: column; align-items: start"><label data-translate="store-management.tab.logo" style="color: #5b5b5b">Logo para o sobre a loja</label><label data-translate="store-management.tab.imagePropertiesLogo" style="color: #a2a3a4"></label><div ng-if="vm.imagesErrors.fileInputLogo" class="d-flex" style="color: red"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> <span data-translate="store-management.tab.imageError"></span></div><div ng-if="vm.logoImage" style="display: flex; gap: 20px; padding-top: 10px"><button type="button" class="btn custom-btn" ng-click="vm.openInput($event, \'fileInputLogo\', \'600\', \'600\')"><span>Atualizar</span></button> <button type="button" class="btn custom-btn" ng-click="vm.logoImage=null; vm.store.logo=null;vm.imagesErrors.fileInputLogo=false"><span>Remover</span></button></div></div></div><!-- Favicon --><div style="display: flex; gap: 20px; padding: 30px; align-items: center" class="col-md-5 col-xs-12" ng-style="{\'flex-direction\': vm.isMobile ? \'column\' : \'row\', \'align-items\': vm.isMobile ? \'center\' : \'flex-start\'}"><div><input type="file" id="fileInputFavicon" style="display: none" accept="image/x-png,image/jpeg,image/png"><div class="custom-box-image" style="width: 48px; height: 48px" ng-class="{\'box-with-out-image\': (!vm.faviconImage) }" ng-click="vm.openInput($event, \'fileInputFavicon\', \'48\', \'48\')"><div ng-if="!vm.faviconImage" class="with-out-image" style="padding-left: 7px;\n                                            padding-top: 13px"><i class="icon-ksc-addimage"></i></div><div ng-if="vm.faviconImage" style="width: 48px; height: 48px"><img id="imgFileInputFavicon" class="custom-image" style="width: 48px; height: 48px" ng-src="{{vm.faviconImage}}"></div></div></div><div style="display: flex; flex-direction: column; align-items: start"><label data-translate="store-management.tab.favicon" style="color: #5b5b5b">Favicon</label><label data-translate="store-management.tab.imagePropertiesFavicon" style="color: #a2a3a4"></label><div ng-if="vm.imagesErrors.fileInputFavicon" class="d-flex" style="color: red"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> <span data-translate="store-management.tab.imageError"></span></div><div ng-if="vm.faviconImage" style="display: flex; gap: 20px; padding-top: 10px"><button type="button" class="btn custom-btn" ng-click="vm.openInput($event, \'fileInputFavicon\', \'48\', \'48\')"><span>Atualizar</span></button> <button type="button" class="btn custom-btn" ng-click="vm.faviconImage=null; vm.store.favicon=null;vm.imagesErrors.fileInputFavicon=false"><span>Remover</span></button></div></div></div></div><!-- Public logo --><div class="col-md-12 col-xs-12" ng-style="{\'flex-direction\': vm.isMobile ? \'column\' : \'row\', \'align-items\': vm.isMobile ? \'center\' : \'flex-start\'}" style="display: flex;gap: 20px;padding: 30px;justify-content: center; align-items: center"><div class="custom-box-image" style="width: 180px; height: 68px" ng-class="{\'box-with-out-image\': (!vm.publicLogoImage) }" ng-click="vm.openInput($event, \'fileInputPublicLogo\', \'180\', \'68\')"><div ng-if="!vm.publicLogoImage" class="with-out-image" style="padding-left: 8px; padding-top: 13px"><i class="icon-ksc-addimage"></i><p>Selecionar imagem</p></div><div ng-if="vm.publicLogoImage" style="width: 180px; height: 68px"><img id="imgfileInputPublicLogo" class="custom-image" style="width: 180px; height: 68px" ng-src="{{vm.publicLogoImage}}"></div></div><div style="display: flex; flex-direction: column; align-items: start"><label data-translate="store-management.tab.publicLogo" style="color: #5b5b5b">Logo</label><label data-translate="store-management.tab.imagePropertiesPublicLogo" style="color: #a2a3a4"></label><div ng-if="vm.imagesErrors.fileInputPublicLogo" class="d-flex" style="color: red"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> <span data-translate="store-management.tab.imageError"></span></div><div ng-if="vm.publicLogoImage" style="display: flex; gap: 20px; padding-top: 10px"><button type="button" class="btn custom-btn" ng-click="vm.openInput($event, \'fileInputPublicLogo\', \'180\', \'68\')"><span>Atualizar</span></button> <button type="button" class="btn custom-btn" ng-click="vm.publicLogoImage=null; vm.store.publicLogo=null;vm.imagesErrors.fileInputPublicLogo=false"><span>Remover</span></button></div></div><input type="file" id="fileInputPublicLogo" style="display: none" accept="image/x-png,image/jpeg,image/png"></div></div></div></div><div id="tab-3" class="tab-pane active" ng-show="vm.tab == 3"><div class="panel-body"><div class="row"><div class="col-md-12 form-group"><label for="description" data-translate="store-management.new.form.description">Description</label><textarea id="description" name="description" class="form-control" ng-model="vm.store.description" style="resize: none" rows="5">\n                                </textarea></div></div></div></div><div id="tab-4" class="tab-pane active" ng-show="vm.tab == 4"><div class="panel-body"><div class="row"><div class="col-md-6 col-xs-12"><i class="fa fa-facebook-square"></i><label for="facebook">Facebook</label><div class="input-group m-b"><span class="input-group-addon" style="background: #ededed; color:#818181">https://facebook.com/</span> <input type="text" id="facebook" class="form-control" name="facebook" ng-model="vm.store.social.facebook"></div></div><div class="col-md-6 col-xs-12"><i class="fa fa-instagram"></i><label for="instagram">Instagram</label><div class="input-group m-b"><span class="input-group-addon" style="background: #ededed; color:#818181">https://instagram.com/</span> <input id="instagram" name="instagram" type="text" class="form-control" ng-model="vm.store.social.instagram"></div></div></div><div class="row"><div class="col-md-6 col-xs-12"><i class="fa fa-youtube"></i><label for="youtube">Youtube</label><div class="input-group m-b"><span class="input-group-addon" style="background: #ededed; color:#818181">https://youtube.com/</span> <input id="twitter" type="text" name="twitter" class="form-control" ng-model="vm.store.social.twitter"></div></div><div class="col-md-6 col-xs-12"><i class="icon-ksc-tiktok-solid"></i><label for="tiktok">TikTok</label><div class="input-group m-b"><span class="input-group-addon" style="background: #ededed; color:#818181">https://tiktok.com/@</span> <input id="tiktok" type="text" name="tiktok" class="form-control" ng-model="vm.store.social.tiktok"></div></div></div><div class="row"><div class="col-xs-6"><i class="fa fa-whatsapp"></i><label for="whatsApp">WhatsApp</label><input type="tel" name="contactPhone" id="whatsApp" class="form-control" ng-model="vm.store.social.whatsApp" intl-tel-input><div class="help-block-div" ng-show="vm.storeEditForm.contactPhone.$invalid && vm.storeEditForm.$submitted"><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.contactPhone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div></div></div><div id="tab-5" class="tab-pane active" ng-show="vm.tab == 5"><div class="panel-body"><div class="row"><div class="col-md-12 form-group"><label for="title" data-translate="store-management.form.seo.title">Tag Title</label><i class="fa fa-info-circle" tooltip-placement="bottom-right" uib-tooltip="{{\'store-management.form.seo.info-title\' | translate}}"></i> <input id="title" name="title" type="text" class="form-control" ng-model="vm.store.seo.title" ng-maxlength="55"><div ng-show="vm.storeEditForm.title.$invalid && vm.storeEditForm.$submitted"><p class="help-block form-invalid-field" ng-show="vm.storeEditForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="55"></p></div></div><div class="col-md-12 form-group"><label for="description" data-translate="store-management.form.seo.description">Tag Description</label><i class="fa fa-info-circle" tooltip-placement="bottom-right" uib-tooltip="{{\'store-management.form.seo.info-description\' | translate}}"></i><textarea maxlength="150" id="description" name="description" class="form-control" ng-model="vm.store.seo.description" style="resize: none" rows="5">\n                                </textarea><span class="pull-right">{{vm.store.seo.description.length}}/150</span></div></div></div></div></div></div><div class="modal-footer"><button id="btnUpdateStore" ladda="vm.isSaving" type="submit" class="btn btn-primary" ng-disabled="vm.storeEditForm.$invalid && vm.storeEditForm.$submitted" data-style="slide-left"><span class="fa icon-ksc-addstore"></span>&nbsp; <span data-translate="store-management.detail.buttons.save">Salvar informa\xE7\xF5es da loja</span></button></div></div></form>');
$templateCache.put('app/admin/store-management/store-management-marker.tpl.html','<div class="sales-point" ng-controller="StoreMarkerController as vm" style="width: 300px; overflow-y: hidden !important"><div class="container-fluid" style="overflow: hidden !important"><div class="row"><div class="hidden-xs col-sm-5" align="right"><span class="fa icon-ksc-salesponitss fa-3x" style="font-size: 5em; vertical-align: middle"></span></div><div class="col-xs-7"><p class="sales-point-name" style="font-size: 2vh; margin: 0; padding: 0">{{parameter.pointlocation.name}}</p><p ng-show="parameter.pointlocation.address || parameter.pointlocation.number" style="font-size: 1.5vh; margin: 0; padding: 0">{{parameter.pointlocation.address}},{{parameter.pointlocation.number}}</p><p ng-show="parameter.pointlocation.city || parameter.pointlocation.state" style="font-size: 1.5vh; margin: 0; padding: 0">{{parameter.pointlocation.city}}/{{parameter.pointlocation.state}}</p><p style="line-height: 20px; font-size: 1.5vh; margin: 0; padding: 0">{{parameter.pointlocation.contactPhone}}</p></div></div><div class="row" ng-if="!vm.checkIfIsFlyersPage()" has-authority="STORE_UPDATE"><div class="col-xs-12 store-marker-button" align="right"><button class="btn btn-sm sales-point-edit-button" ng-click="vm.addSalesPoint()"><span class="fa fa-pencil-square-o"></span> <span data-translate="store-management.salespoint.buttons.edit">Edit</span></button> <button class="btn btn-sm btn-primary" ng-click="vm.removeSalesPoint()"><span class="fa fa-trash"></span> <span data-translate="store-management.salespoint.buttons.remove">Remove</span></button></div></div></div></div>');
$templateCache.put('app/admin/store-management/store-management-new.html','<div class="wrapper wrapper-content animated fadeIn"><div class="row"><div class="col-xs-12"><div class="tabs-container"><uib-tabset active="vm.actualTab"><uib-tab index="0" heading="{{ \'store-management.new.tab.first.header\' | translate}}"><div class="panel-body"><div class="container-fluid"><div class="row"><div class="col-xs-12 col-sm-12 col-md-8 col-lg-8"><h1 class="sc-default-title-store-font" data-translate="store-management.new.tab.first.header">Store Information</h1><p data-translate="store-management.new.tab.first.firstInfo">Lorem ipsum dolor ipsum dolor ipsum dolor ipsum dolor ipsum dolor</p><p data-translate="store-management.new.tab.first.secondInfo">Lorem ipsum dolor</p><form name="vm.storeInfosForm"><div class="row"><div class="col-md-6 form-group" ng-class="{\'col-sm-12 col-xs-12 col-lg-6 col-md-6\': vm.store.nickname, \'col-sm-12 col-xs-12 col-lg-12 col-md-12\': !vm.store.nickname}"><label for="nickname" class="required" data-translate="store-management.new.form.nickname">Nickname</label><input id="nickname" name="nickname" type="text" class="form-control" ng-model="vm.store.nickname" ng-minlength="4" ng-maxlength="40" autocomplete="off" required alphanumeric-only ng-change="vm.verifyNicknameIsAvailable(vm.storeInfosForm)"><div class="help-block-div" ng-show="vm.storeInfosForm.nickname.$invalid && vm.storesInfoSubmitted"><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.nickname.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.nickname.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.nickname.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="40">This field cannot be longer than 40 characters.</p><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.nickname.$error.nicknameIsUnavailable" data-translate="entity.validation.nickname.unavailable">This nickname is unavailable.</p></div></div><div class="col-md-6 animated fadeInRight form-group" ng-show="vm.store.nickname"><p class="store-new-domaintext"><span data-translate="store-management.messages.create.yourDomain">Your domain will be:</span><br><span>{{(vm.store.nickname | lowercase) + vm.domainSufix}}</span></p></div></div><div class="row"><div class="col-lg-12 col-xs-12 col-md-12 col-sm-12 form-group"><label for="storeName" class="control-label required" data-translate="store-management.new.form.name">Name</label><input id="storeName" name="storeName" type="text" class="form-control" ng-model="vm.store.name" ng-maxlength="128" ng-minlength="4" required><div class="help-block-div" ng-show="vm.storeInfosForm.storeName.$invalid && vm.storesInfoSubmitted"><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.storeName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.storeName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block" ng-show="vm.storeInfosForm.storeName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128">This field cannot be longer than 128 characters.</p></div></div></div><div class="row"><div class="col-lg-12 col-xs-12 col-md-12 col-sm-12 form-group"><label for="category" class="required" data-translate="store-management.new.form.category">Category:</label><select class="form-control" name="category" id="category" ng-model="vm.store.categoryId" required><option ng-repeat="category in vm.categories" value="{{category.id}}">{{category.title}}</option></select><div class="help-block-div" ng-show="vm.storeInfosForm.category.$invalid && vm.storesInfoSubmitted"><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.category.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><div class="col-xs-12 form-group"><label for="email" class="required" data-translate="store-management.new.form.email">E-mail</label><input id="email" name="email" type="email" class="form-control" ng-model="vm.store.email" ng-maxlength="50" autocomplete="off" ng-pattern=\'/^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$/i\' required><div class="help-block-div" ng-show="vm.storeInfosForm.email.$invalid && vm.storesInfoSubmitted"><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.email.$error.pattern" data-translate="global.messages.validate.email.invalid">Please input a valid mail.</p><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label for="cnpj">CNPJ</label><input id="cnpj" name="cnpj" type="text" class="form-control" ng-model="vm.store.cnpj" ng-cnpj ui-mask="99.999.999/9999-99"><div class="help-block-div" ng-show="vm.storeInfosForm.cnpj.$invalid && vm.storesInfoSubmitted"><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.cnpj.$invalid" data-translate="entity.validation.cnpj">This field CNPJ is invalid.</p></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label class="required" for="contactPhone" data-translate="store-management.new.form.celphone">Cel phone</label><input type="tel" name="contactPhone" id="contactPhone" class="form-control" ng-model="vm.store.contactPhone" ng-maxlength="30" ng-minlength="4" intl-tel-input required><div ng-show="vm.storeInfosForm.contactPhone.$invalid && vm.storesInfoSubmitted"><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.contactPhone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.storeInfosForm.contactPhone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div></form></div><div class="hidden-xs hidden-sm col-md-4 col-lg-4" style="color: #c4c4c4; margin-top: 12%; text-align:center; align-content: center; vertical-align: middle"><i class="fa fa-sign-in" style="font-size: 14em" aria-hidden="true"></i></div></div><div class="row"><div class="col-xs-12" align="right"><button id="btnNextPage1" class="btn btn-primary btn-large" ng-click="vm.changeToTab(1)"><span data-translate="store-management.new.form.button">Next</span><span class="fa fa-sign-in" style="margin-left: 7px; font-size: 1.5em" aria-hidden="true"></span></button></div></div></div></div></uib-tab><uib-tab index="1" heading="{{ \'store-management.new.tab.second.header\' | translate}}" ng-click="vm.activeImageCrop()" disable="!vm.tabsState[1].active"><div class="panel-body" ng-init="vm.initTabLogoNewStore()"><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-font" data-translate="store-management.new.tab.second.header">Store Information - Logo upload</h1><p data-translate="store-management.new.tab.second.firstInfo">Lorem ipsum dolor ipsum dolor ipsum dolor ipsum dolor ipsum dolor</p></div><div class="col-xs-12 col-sm-6 store-img-right"><input type="file" id="fileInput" style="display: none" required> <span class="store-upload-button" ng-click="vm.openInput($event)"><span data-translate="store-management.new.form.chooseimage">Choose Image</span><i style="margin-left: 5px" class="fa fa-upload" aria-hidden="true"></i></span><div class="cropArea"><img-crop ng-if="vm.imageCroppedActive && vm.imageUpload" area-type="square" image="vm.imageUpload" result-image-size="vm.imageSize" on-load-begin="vm.imageChanged = true" result-image="vm.store.image" result-image-quality="1.0"></img-crop><p ng-if="!vm.imageUpload" id="noimg-icon" class="icon-ksc-storelogo"></p></div></div><div class="col-xs-12 col-sm-6 store-img-nopadding"><p><strong data-translate="store-management.new.form.previewimage">Preview Image:</strong></p><div><img ng-src="{{vm.store.image}}"></div></div></div><div class="row"><div class="col-xs-12" align="right"><button id="btnNextPage2" class="btn btn-primary btn-large" ng-click="vm.changeToTab(2)"><span data-translate="store-management.new.form.button">Next</span><span class="fa fa-sign-in" style="margin-left: 7px; font-size: 1.5em" aria-hidden="true"></span></button></div></div></div></uib-tab><uib-tab index="2" heading="{{ \'store-management.new.tab.third.header\' | translate}}" ng-click="vm.initMap()" disable="!vm.tabsState[2].active"><div class="panel-body"><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-6"><h1 class="sc-default-title-font" data-translate="store-management.new.tab.third.header">Store Location</h1><p class="" data-translate="store-management.new.tab.third.firstInfo">Lorem ipsum dolor ipsum dolor ipsum dolor ipsum dolor ipsum dolor</p><p class="" data-translate="store-management.new.tab.third.secondInfo">Lorem ipsum dolor</p><form name="vm.locationStoreForm" ng-show="vm.mapLoaded"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"><label class="required" for="name" data-translate="store-management.new.form.location.name">Nome da loja</label><input id="name" name="name" ng-model="vm.store.location.name" type="text" class="form-control" ng-maxlength="25" ng-minlength="4" required><div class="help-block-div" ng-show="vm.locationStoreForm.name.$invalid && vm.locationStoreForm.name.$touched && vm.locationStoreForm.name.$dirty"><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="25">This field cannot be longer than 25 characters.</p></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"><label for="contactNumber" class="required" data-translate="store-management.new.form.contactnumber">Telefone</label><input id="contactNumber" name="contactNumber" ng-model="vm.store.location.contactPhone" type="tel" class="form-control" ng-maxlength="50" intl-tel-input required><div class="help-block-div" ng-show="vm.locationStoreForm.contactNumber.$invalid && vm.locationStoreForm.contactNumber.$touched && vm.locationStoreForm.contactNumber.$dirty"><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.contactNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.contactNumber.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"><label for="postalCode" class="required" data-translate="store-management.new.form.location.zipcode">Zip Code</label><input id="postalCode" name="postalCode" type="text" class="form-control" ng-model="vm.store.location.postalCode" ng-change="vm.checkCEP()" ng-maxlength="50" required><div class="help-block-div" ng-show="vm.locationStoreForm.postalCode.$invalid && vm.locationStoreForm.postalCode.$touched && vm.locationStoreForm.postalCode.$dirty"><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.postalCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.postalCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"><label for="country" class="required" data-translate="store-management.new.form.location.country">Country:</label><select class="form-control" id="country" name="country" ng-model="vm.store.location.country" ng-change="vm.refreshMapWithAddress()" ng-model-options="{debounce: 1000}"><option ng-repeat="country in vm.countrys" value="{{country.key}}">{{country.value}}</option></select><div class="help-block-div" ng-show="vm.locationStoreForm.country.$invalid && vm.locationStoreForm.country.$touched && vm.locationStoreForm.country.$dirty"><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.country.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"><label for="city" class="required" data-translate="store-management.new.form.location.city">City</label><input id="city" name="city" type="text" class="form-control" ng-model="vm.store.location.city" ng-change="vm.refreshMapWithAddress()" ng-model-options="{debounce: 1000}" ng-maxlength="50" required><div class="help-block-div" ng-show="vm.locationStoreForm.city.$invalid && vm.locationStoreForm.city.$touched"><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.city.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"><label for="state" class="required" data-translate="store-management.new.form.location.state">State</label><select id="state" class="form-control" name="state" ng-model="vm.store.location.state" ng-if="vm.store.location.country === \'BRASIL\'" ng-change="vm.refreshMapWithAddress()" ng-model-options="{debounce: 1000}" required><option ng-repeat="state in vm.states" value="{{state.key}}">{{state.value}}</option></select><input type="text" class="form-control" name="state" ng-model="vm.store.location.state" ng-if="vm.store.location.country != \'BRASIL\'" ng-maxlength="30" required><div class="help-block-div" ng-show="vm.locationStoreForm.state.$invalid && vm.locationStoreForm.state.$touched && vm.locationStoreForm.state.$dirty"><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.state.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-9 form-group"><label for="address" class="required" data-translate="store-management.new.form.location.address">Address</label><input id="address" name="address" type="text" class="form-control" ng-model="vm.store.location.address" ng-change="vm.refreshMapWithAddress()" ng-model-options="{debounce: 1000}" ng-maxlength="50" required><div class="help-block-div" ng-show="vm.locationStoreForm.address.$invalid && vm.locationStoreForm.address.$touched && vm.locationStoreForm.address.$dirty"><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.address.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.address.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 form-group"><label for="number" data-translate="store-management.new.form.location.number">N\xFAmero</label><input id="number" name="number" type="text" class="form-control" ng-model="vm.store.location.number" ng-change="vm.refreshMapWithAddress()" ng-model-options="{debounce: 1000}" ng-maxlength="12"><div ng-show="vm.locationStoreForm.number.$invalid"><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.number.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="12">This field cannot be longer than 12 characters.</p></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-5 form-group"><label class="required" for="neighborhood" data-translate="store-management.new.form.location.neighborhood">Bairro</label><input id="neighborhood" name="neighborhood" ng-model="vm.store.location.neighborhood" type="text" ng-change="vm.refreshMapWithAddress()" ng-model-options="{debounce: 1000}" class="form-control" ng-maxlength="50" required><div ng-show="vm.locationStoreForm.neighborhood.$invalid && vm.locationStoreForm.neighborhood.$touched && vm.locationStoreForm.neighborhood.$dirty"><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.neighborhood.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.locationStoreForm.neighborhood.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-5 form-group" style="margin-top: 15px"><button id="btnCreateStorePoint" class="btn-primary-outline store-upload-button" style="padding: 5px; font-size: 1.2em; background-color: #F0F0F1 !important; border: none !important; box-shadow: none !important" ng-click="vm.setMarkerAsAdded()" ng-disabled="vm.locationStoreForm.$invalid"><span data-translate="store-management.new.salespoint">Create Sales Point </span><i style="font-size: 2em" class="fa icon-ksc-addstore" aria-hidden="true"></i></button></div></div><div ng-if="vm.actualMarkerIndex <= 0 && vm.saveSubmit"><p class="help-block form-invalid-field">Voc\xEA deve adicionar pelo menos um ponto de venda.</p></div></form></div><div class="hidden-xs col-md-6 store-new-icon" align="center"><div class="row"><ui-gmap-google-map ng-if="vm.showMap" center="vm.mainMap.center" zoom="vm.mainMap.zoom" control="vm.mainMap.controls" options="vm.options" style="height: 400px"><ui-gmap-markers models="vm.mainMap.markers" coords="\'self\'" idkey="\'id\'" options="\'options\'" events="vm.mainMap.markerEvents" fit="\'true\'"></ui-gmap-markers><ui-gmap-window show="vm.mainMap.window.show" coords="vm.mainMap.window.model" options="vm.mainMap.window.options" templateurl="\'app/admin/store-management/store-management-marker.tpl.html\'" templateparameter="vm.mainMap.window.model" closeclick="vm.mainMap.window.closeClick()" ng-cloak></ui-gmap-window></ui-gmap-google-map></div></div></div><div class="row"><div class="col-xs-12" align="right"><button id="btnSaveStore" ladda="vm.isSaving" class="btn btn-primary btn-large" ng-click="vm.saveStore()" data-style="slide-left"><span class="icon-ksc-store" style="font-size: 1.5em; margin-top: -10px" aria-hidden="true">&nbsp;</span><span data-translate="store-management.home.buttons.new">Salvar</span></button></div></div></div></div></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/admin/store-management/store-management-newsalespoint.html','<form name="vm.salesPointForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" data-translate="store-management.salespoint.title">Store Location</h4><small data-translate="store-management.salespoint.subtitle">Add a sales point</small></div><div class="modal-body"><div class="container-fluid"><div class="row"><div class="col-xs-6 col-md-6 col-lg-6"><div class="row form-group"><div class="col-xs-12 col-lg-12 col-sm-12 col-md-12"><label class="required" data-translate="store-management.new.form.location.name">Sales point name</label><input type="text" class="form-control" name="name" ng-model="vm.salespoint.pointlocation.name" ng-required="vm.user.id == null" ng-maxlength="25" ng-minlength="4"><div class="help-block-div" ng-show="vm.salesPointForm.name.$invalid && vm.salesPointFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="25">This field cannot be longer than 25 characters.</p><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p></div></div></div><div class="row form-group"><div class="col-xs-6"><label for="zipcode" class="required" data-translate="store-management.new.form.location.zipcode">Zip code</label><input id="zipcode" type="text" class="form-control" name="zipcode" ui-mask="99999-999" ng-model="vm.salespoint.pointlocation.postalCode" ng-change="vm.checkCEP()" required><div class="help-block-div" ng-show="vm.salesPointForm.zipcode.$invalid && vm.salesPointFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.zipcode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.zipcode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 50 characters.</p></div></div><div class="col-xs-6" ng-if="!vm.user.id"><label for="country" class="required" data-translate="store-management.new.form.location.country">Country</label><select class="form-control" id="country" name="country" ng-model="vm.salespoint.pointlocation.country" ng-blur="vm.refreshMapWithAddress()" required><option ng-repeat="country in vm.countrys" value="{{country.key}}">{{country.value}}</option></select><div class="help-block-div" ng-show="vm.salesPointForm.country.$invalid && vm.salesPointFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.country.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row form-group"><div class="col-xs-6 col-md-6"><label for="state" class="required" data-translate="store-management.new.form.location.state">State</label><select id="state" class="form-control" name="state" ng-model="vm.salespoint.pointlocation.state" ng-if="vm.salespoint.pointlocation.country === \'BRASIL\'" required><option ng-repeat="state in vm.states" value="{{state.key}}">{{state.value}}</option></select><input type="text" class="form-control" name="state" ng-model="vm.salespoint.pointlocation.state" ng-if="vm.salespoint.pointlocation.country != \'BRASIL\'" ng-maxlength="30" required><div class="help-block-div" ng-show="vm.salesPointForm.state.$invalid && vm.salesPointFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.state.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-xs-6 col-md-6"><label for="city" class="required" data-translate="store-management.new.form.location.city">City</label><input id="city" type="text" class="form-control" name="city" ng-model="vm.salespoint.pointlocation.city" ng-blur="vm.refreshMapWithAddress()" ng-maxlength="50" required><div class="help-block-div" ng-show="vm.salesPointForm.city.$invalid && vm.salesPointFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.city.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.city.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row form-group"><div class="col-xs-12"><label class="required" data-translate="store-management.new.form.location.address">Address</label><input type="text" class="form-control" name="address" ng-maxlength="50" ng-model="vm.salespoint.pointlocation.address" ng-blur="vm.refreshMapWithAddress()" ng-maxlength="50" required><div class="help-block-div" ng-show="vm.salesPointForm.address.$invalid && vm.salesPointFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.address.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.address.$error.maxlength" data-translate="entity.validation.maxlength" ranslate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row form-group"><div class="col-xs-12"><label for="neighborhood" data-translate="store-management.new.form.location.neighborhood">Neighborhood</label><input id="neighborhood" type="text" class="form-control" name="neighborhood" ng-model="vm.salespoint.pointlocation.neighborhood" ng-blur="vm.refreshMapWithAddress()" ng-maxlength="50"><div class="help-block-div" ng-show="vm.salesPointForm.neighborhood.$invalid && vm.salesPointFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.neighborhood.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="row form-group"><div class="col-xs-5 col-md-5 col-lg-5 col-sm-5"><label for="number" data-translate="store-management.new.form.location.number">N\xFAmero</label><input id="number" maxlength="8" numbers-only type="text" class="form-control" name="number" ng-model="vm.salespoint.pointlocation.number" ng-blur="vm.refreshMapWithAddress()"></div><div class="col-xs-7 col-md-7 col-sm-7 col-lg-7"><label for="contactnumber" class="required" data-translate="store-management.new.form.contactnumber">Contact number</label><input id="contactnumber" type="text" class="form-control" name="contactNumber" intl-tel-input ng-model="vm.salespoint.pointlocation.contactPhone" ng-blur="vm.refreshMapWithAddress()" required><div class="help-block-div" ng-show="vm.salesPointForm.contactNumber.$invalid && vm.salesPointFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.contactNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.salesPointForm.contactNumber.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div></div><div class="col-xs-6 col-md-6 col-lg-6"><ui-gmap-google-map ng-if="vm.showMap" center="vm.mainMap.center" zoom="vm.mainMap.zoom" control="vm.mainMap.control" options="vm.options" style="height: 400px"><ui-gmap-marker coords="vm.salespoint" idkey="vm.salespoint.id" options="vm.mainMap.markerOptions" events="vm.mainMap.markerEvents"></ui-gmap-marker></ui-gmap-google-map></div></div></div></div><div class="modal-footer"><button ladda="vm.isSaving" class="btn btn-primary" ng-disabled="salesPointForm.$invalid" ng-click="vm.updatePointLocation()" data-style="slide-left"><span class="fa icon-ksc-addstore"></span>&nbsp;<span data-translate="store-management.salespoint.subtitle">Atualizar ponto de venda</span></button></div></form>');
$templateCache.put('app/admin/store-management/store-management.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-xs-6 col-sm-4 col-md-5"><div class="inner-addon left-addon"><i class="glyphicon glyphicon-search"></i> <input type="text" class="form-control" ng-model="vm.searchFilter.name" placeholder="{{\'global.table.search\' | translate }}{{\'store-management.home.searchName\' | translate | lowercase}}" ng-change="vm.reloadStores(null, true)" ng-model-options="{debounce: 1000}"></div></div><div class="col-xs-6 col-sm-4 col-md-3"><select class="form-control" ng-model="vm.searchFilter.categoryKey" ng-change="vm.reloadStores(null, true)"><option value="" selected="selected" data-translate="store-management.home.listAll">All</option><option ng-repeat="category in vm.categories" value="{{category.key}}">{{category.title}}</option></select></div><div style="pointer-events: none" ng-disabled="true" class="col-xs-6 col-sm-2 col-md-2"><a ng-disabled="true" ui-sref="store-management.new"><button ng-disabled="true" id="btnCreateStore" class="btn btn-primary btn-block" style="white-space: normal !important" has-authority="STORE_CREATE"><span class="icon-ksc-store" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span><span data-translate="store-management.home.buttons.new">Create store</span></button></a></div><div class="col-xs-6 col-sm-2 col-md-2" align="center"><div class="col-xs-6 col-sm-12 col-md-6"><a id="removeStoreBtn" class="coupon-menu-button" ng-click="vm.removeStores()" has-authority="STORE_DELETE" tooltip-placement="top-right" uib-tooltip="{{\'store-management.home.buttons.remove\' | translate}}"><span class="coupon-menu-button icon-ksc-trash fa-2x" ng-class="{\'coupon-text-color\': vm.storesToRemove >= 1}"></span><span ng-if="vm.storesToRemove >= 1" class="label flyer-label-color">{{vm.storesToRemove}}</span></a></div><div class="col-xs-6 col-sm-12 col-md-6"><a class="coupon-menu-button" ng-click="vm.changeType()" tooltip-placement="top-right" uib-tooltip="{{(vm.displayType == \'Table\' ? \'store-management.home.buttons.view.grid\': \'store-management.home.buttons.view.list\') | translate}}"><span class="coupon-text-color" style="font-size: 2.3em" ng-class="{\'fa fa-th-large fa-2x\': vm.checkDisplayType(\'Cards\'), \'fa fa-th-list fa-2x\': vm.checkDisplayType(\'Table\')}"></span></a></div></div></div></div></div></div></div><div class="row"><div class="col-xs-6" ng-repeat="loading in vm.loadingArray track by $index" ng-if="vm.isLoading"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-xs-3"><div class="store-item-thumbnail-container"><div class="store-item-thumbnail"></div></div></div><div class="col-xs-7"><div class="label-loading"><div class="loading-row"></div><div class="loading-row"></div><div class="loading-row"></div></div></div></div></div></div></div><div class="col-xs-12" ng-if="vm.storesData.length <= 0 && !vm.isLoading"><div class="ibox"><div class="ibox-title"><p style="text-align: center" data-translate="store-management.home.noStores">You don\'t have stores.</p></div></div></div><div class="col-xs-12" ng-if="vm.storesData.length > 0" infinite-scroll="vm.reloadStores(vm.page + 1)" infinite-scroll-disabled="!vm.hasNextPage || vm.busy" infinite-scroll-immediate-check="false"><div ng-repeat="store in vm.storesDataFiltered track by $index" ng-if="vm.checkDisplayType(\'Table\')" ng-click="vm.checkStoreClickAction(store.id)"><div class="ibox-content store-table-box"><div class="table-responsive"><table class="table shoping-cart-table"><tbody><tr width="100%"><td width="8%"><div class="store-table-img"><img class="img-responsive" ng-src="{{store.image}}" err-src="content/images/defaultShowcaseImage.png"></div></td><td class="desc" width="72%"><p class="store-item-name sc-default-title-font sc-default-title-capitalize">{{store.name | lowercase}}</p><div class="m-t-sm"><span class="icon-ksc-salesponitss" style="font-size: 1.1em"><span class="store-item-location sc-default-subtitle-font store-card-space">{{store.numberOfPoints}} <span data-translate="store-management.home.salespoint">sales points</span> </span></span><span class="fa fa-tag coupon-text-color">{{store.numberOfFlyers}} <span class="sc-default-subtitle-font sc-default-title-capitalize" data-translate="flyers.home.title">panfletos</span></span></div></td><td width="20%" has-authority="STORE_DELETE"><div class="checkbox flyer-checkbox-remove-margin" ng-click="$event.stopPropagation()"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.storesDataFiltered[$index].checked" ng-change="vm.checkStoresToRemove()"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div></td></tr></tbody></table><hr class="store-line"></div></div></div><div ng-repeat="store in vm.storesDataFiltered track by $index" ng-if="vm.checkDisplayType(\'Cards\')" ng-class="{\'col-xs-12 col-sm-4\': vm.checkDisplayType(\'Cards\'), \'store-item-margin-right\': !vm.isEven($index+1), \'store-item-margin-left\': vm.isEven($index+1)}"><div class="ibox"><div class="ibox-content store-card-box" ng-click="vm.checkStoreClickAction(store.id)"><div class="row"><div class="col-xs-3 col-md-5 col-lg-3"><div style="width: 100%; height: 15vh; font-size: 64.5%; display: table-cell; vertical-align: middle" align="center"><img class="img-responsive" style="width: 100%; max-height: 15vh" ng-if="store.image" ng-src="{{store.image}}" err-src="content/images/defaultShowcaseImage.png"><div ng-if="!store.image" class="sk-container" style="padding-top: 40%"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1" style="background-color: #B9B9BB"></div><div class="sk-rect2" style="background-color: #B9B9BB"></div><div class="sk-rect3" style="background-color: #B9B9BB"></div><div class="sk-rect4" style="background-color: #B9B9BB"></div><div class="sk-rect5" style="background-color: #B9B9BB"></div></div></div></div></div><div class="col-xs-7 col-md-5 col-lg-7"><p class="store-item-category sc-default-subtitle-font">{{store.categoryName}}</p><p class="store-item-name sc-default-title-font sc-default-title-capitalize">{{store.name | lowercase}}</p><p class="store-item-contact sc-default-subtitle-font">{{store.contactPhone}}<br>{{store.email}}</p><p class="store-item-location sc-default-subtitle-font"><span class="icon-ksc-salesponitss" style="font-size: 1.6em"></span> {{store.numberOfPoints}} <span class="store-card-space" data-translate="store-management.home.salespoint">sales points</span> <span class="fa fa-tag coupon-text-color" style="font-size: 1.6em"></span><span class="store-card-space coupon-text-color"><span>{{store.numberOfFlyers}} </span><span data-translate="flyers.home.title">panfletos</span></span></p></div><div class="col-xs-2" align="right" has-authority="STORE_DELETE"><div class="form-group"><div class="checkbox store-checkbox-remove-margin" ng-click="$event.stopPropagation()"><label><input type="checkbox" class="dropdown-item-checkbox" ng-change="vm.checkStoresToRemove()" ng-model="vm.storesDataFiltered[$index].checked"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/integrations/facebook-business/facebook-my-business-tab.html','<style>.disable-span{\n    color: #E6E6E6;\n    cursor: not-allowed;\n}</style><div ng-if="(!vm.loadingFacebookCamps && vm.facebookCampaigns && vm.facebookCampaigns.length === 0)" class="col-sm-12" style="text-align: center; padding: 6% 2%"><div class="row"><div class="col-md-12 ksc-no-content-box"><img style="padding: 20px" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/catalog-facebook-1-g.png" alt=""><h1 data-translate="integrations.facebookCampain.mainDescription">Create your first showcase.</h1><p data-translate="integrations.facebookCampain.mainSubDescription" class="ksc-sub-title" style="width: 40% !important">Lorem ipsum dolor sit amet consectetur</p></div></div><button ng-if="!vm.facebook.connected" class="btn btn-primary btn-large" ng-click="vm.facebookAuth()"><span class="fa fa-facebook" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="integrations.facebookCampain.buttons.connectFacebook">Connect Facebook campain</span></button> <button ng-if="vm.facebook.connected && !(vm.facebook.data && vm.facebook.data.business && vm.facebook.data.business.adsAccount)" class="btn btn-primary btn-large" ng-click="vm.createCampain()"><span class="fa fa-facebook" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span>Criar conta de an\xFAncios</span></button><br><button ng-if="vm.facebook.connected && vm.facebook.data.business && vm.facebook.data.business.adsAccount" class="btn btn-primary btn-large" ng-click="vm.createCampain()"><span class="fa fa-facebook" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="integrations.facebookCampain.buttons.createCampaign">Create campain</span></button></div><div class="ibox-content" ng-if="(!vm.loadingFacebookCamps && vm.facebookCampaigns && vm.facebookCampaigns.length > 0)" style="height: 721px"><div class="ibox-title" style="padding-top: 2% 0 0 0"><div class="row"><div class="col-md-6" style="padding: 0"><div ng-show="false" style="width: 80%" class="input-group form-group"><input ng-keyup="$event.keyCode == 13 && vm.searchWaJobsByFilter()" type="text" placeholder="{{ \'integrations.whatsapp.whatsappJobResumeTable.searchCampaign\' | translate }}" class="input form-control" ng-model="vm.filterFbCampaigns.campaignName"> <span class="input-group-btn"><button ng-click="vm.searchWaJobsByFilter()" class="btn btn btn-primary"><i class="fa fa-search"></i> <span data-translate="customer.button.search">Search</span></button></span></div></div><div class="col-md-6" style="padding: 0"><button ng-if="vm.facebook.connected" ng-click="vm.createCampain()" class="btn btn-primary btn-large pull-right"><span style="font-size: 1.2em"></span><i class="fa fa-plus"></i>&nbsp; <span data-translate="integrations.facebookBusiness.buttons.createCampaign">Create campain</span></button> <button ng-if="!vm.facebook.connected" class="btn btn-primary btn-large pull-right" ng-click="vm.facebookAuth()"><span class="fa fa-facebook" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="integrations.facebookBusiness.buttons.connectFacebook">Connect Facebook campain</span></button></div></div></div><div class="clients-list"><div class="tab-content"><div id="tab-1" class="tab-pane active" style="height: 520px; margin-bottom: 10px"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th style="width: 45%"><span data-translate="integrations.facebookBusiness.grid.campaign">Campaign</span></th><th ng-show="true" style="width: 10%"><span data-translate="integrations.facebookBusiness.grid.days">Dias</span></th><th style="width: 20%"><span data-translate="integrations.facebookBusiness.grid.status">Status</span></th></tr></thead><tbody><tr ng-repeat="resume in vm.facebookCampaigns"><td class="client-avatar" style="width: 45%"><span style="padding-left: 10px">{{ resume.name }}</span></td><td style="width: 10%"><span>{{resume.days}}</span></td><td style="width: 20%"><span class="{{ vm.getResumeFBStatusClass(resume.transaction) }}">Ativo</span></td><td style="width: 20%"><i class="fa fa-bar-chart" style="color: #05A19C" tooltip-placement="bottom" tooltip-append-to-body="true" uib-tooltip="Ver relat\xF3rio detalhado" ng-click="vm.getCampaignInsights(resume)"></i></td></tr></tbody></table></div></div><div align="center" style="padding-bottom:  20px"><uib-pagination ng-model="vm.currentPageFbCampaigns" total-items="vm.totalFBCampaigns" max-size="vm.maxSizeFbCampaign" items-per-page="vm.numPerPageFbCampaigns" boundary-links="true" ng-change="vm.changePageFacebookCampaign()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistryFbCampaigns}}\', of: \'{{vm.endRegistryFbCampaigns}}\', total: \'{{vm.totalFBCampaigns}}\'}">Showing {{ vm.startRegistryFbCampaigns }} to {{ vm.endRegistryFbCampaigns }} of {{ vm.totalFBCampaigns }}</p></div></div></div></div></div><div ng-if="vm.loadingFacebookCamps || vm.isLoadingFB" class="tab-content" style="height: 450px; display: flex;\n        align-items: center;\n        justify-content: center"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div>');
$templateCache.put('app/integrations/facebook-business/facebook-tab.html','<div ng-if="!vm.isLoadingFB"><div class="col-sm-12" ng-if="!vm.facebook.connected" style="text-align: center; padding: 6% 2%"><div class="row"><div class="col-md-12 ksc-no-content-box"><img style="padding: 20px" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/catalog-facebook-1-g.png" alt=""><h1 data-translate="integrations.facebookBusiness.mainDescription">Create your first showcase.</h1><p data-translate="integrations.facebookBusiness.mainSubDescription" class="ksc-sub-title" style="width: 40% !important">Lorem ipsum dolor sit amet consectetur</p></div></div><button ng-if="!vm.facebook.connected" class="btn btn-primary btn-large" ng-click="vm.facebookAuth()"><span class="fa fa-facebook" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="integrations.facebookBusiness.buttons.connectFacebook">Connect Facebook campain</span></button></div><div ng-if="vm.facebook.connected"><!-- CARREGANDO INSIGHTS FACEBOOK --><div ng-if="vm.isLoadingFBInsights"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div><div ng-if="!vm.isLoadingFBInsights"><!-- FACEBOOK INSIGHTS --><div class="col-sm-12" ng-if="vm.fbAccountMediaInsightsList.length > 0"><div class="col-sm-12"><div class="col-sm-12" style="text-align: left"><div class="wrapper wrapper-content"><div class="row" style="margin-bottom: 10px"><div class="col-md-12 ig-profile"><div class="ig-profile-image"><i class="fa fa-facebook-square" style="color: #95d5df; font-size: 4em"></i></div><div class="ig-profile-info"><div class=""><h2 class="no-margins">{{vm.facebook.data.page.name}}</h2><a href="#" ng-click="vm.facebookDisconnect()" data-translate="integrations.googleMyBusiness.buttons.signOut">Sign Out</a></div></div></div></div><div class="row"><div class="col-md-6 one"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-md-12"><i class="fa fa-users box-first-icon" style="color: #95d5df"></i><br><h5 class="no-margins" data-translate="integrations.instagramBusiness.insights.totalFollowers">Total followers</h5><i class="fa fa-question-circle" style="color: #95d5df" uib-tooltip="{{\'integrations.instagramBusiness.insights.description.dataTime\' | translate}}"></i><h1 class="no-margins">{{vm.fbAccountInsights.followersCount || 0}}</h1></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr class="h-divider" style="border-top-color: #95d5df"></div></div></div><div class="ibox-content"><div class="row"><div class="col-md-6"><h1 class="no-margins">{{vm.fbFollowersMale || 0}}</h1><div class="font-bold text-muted" data-translate="integrations.instagramBusiness.insights.men"><small>men</small></div></div><div class="col-md-6"><h1 class="no-margins">{{vm.fbFollowersFemale || 0}}</h1><div class="font-bold text-muted" data-translate="integrations.instagramBusiness.insights.women"><small>women</small></div></div></div></div></div></div><div class="col-md-6 col-chart"><div class="ibox"><div class="ibox-title"><h5 class="no-margins" data-translate="integrations.instagramBusiness.insights.age">Age range</h5><i class="fa fa-question-circle" style="color: #fe398b" uib-tooltip="{{\'integrations.instagramBusiness.insights.description.dataTime\' | translate}}"></i></div><div class="ibox-content"><div class="row"><div class="col-md-12"><canvas ng-if="vm.fbAudienceAgeData && vm.fbAudienceAgeData.length > 0" class="chart chart-bar" chart-data="vm.fbAudienceAgeData" chart-labels="vm.audienceAgeLabels" chart-options="vm.barChartOptions"></canvas><h5 ng-if="!vm.fbAudienceAgeData || vm.fbAudienceAgeData.length === 0" data-translate="integrations.instagramBusiness.insights.noDataInTime" class="text-center">No data</h5></div></div></div></div></div><div class="col-md-6 col-chart"><div class="ibox"><div class="ibox-title"><h5 class="no-margins" data-translate="integrations.instagramBusiness.insights.topLocations">Top locations</h5><i class="fa fa-question-circle" style="color: #fe398b" uib-tooltip="{{\'integrations.instagramBusiness.insights.description.dataTime\' | translate}}"></i></div><div class="ibox-content"><div class="row"><div class="col-md-12"><canvas ng-if="vm.fbAudienceLocationData && vm.fbAudienceLocationData.length > 0" class="chart chart-horizontal-bar" chart-data="vm.fbAudienceLocationData" chart-labels="vm.fbAudienceLocationLabels" chart-options="vm.barChartOptions"></canvas><h5 ng-if="!vm.fbAudienceLocationData || vm.fbAudienceLocationData.length === 0" data-translate="integrations.instagramBusiness.insights.noDataInTime" class="text-center">No data</h5></div></div></div></div></div><div class="col-md-6 col-chart"><div class="ibox"><div class="ibox-title"><h5 class="no-margins" data-translate="integrations.instagramBusiness.insights.follow">Follow</h5><i class="fa fa-question-circle" style="color: #fe398b" uib-tooltip="{{\'integrations.instagramBusiness.insights.description.dataTime\' | translate}}"></i></div><div class="ibox-content"><div class="row"><div class="col-md-12"><canvas ng-if="vm.fbFollowersLabels && vm.fbFollowersLabels.length > 0" class="chart chart-line" chart-data="vm.fbFollowersData" chart-labels="vm.fbFollowersLabels" chart-options="vm.lineChartOptions" chart-colors="vm.colors"></canvas><h5 ng-if="!vm.fbFollowersLabels || vm.fbFollowersLabels.length === 0" data-translate="integrations.instagramBusiness.insights.noDataInTime" class="text-center">No data</h5></div></div></div></div></div></div></div></div></div></div><!-- SEM INSIGHTS COLETADOS && vm.isFistLoadSocialContent --><div ng-if="vm.fbAccountMediaInsightsList.length === 0" style="text-align: center; padding: 6% 2%"><div class="row"><div class="col-md-12 ksc-no-content-box"><img style="padding: 20px" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/catalog-facebook-1-g.png" alt=""><h1 ng-if="!vm.isFistLoadSocialContent" data-translate="integrations.instagramBusiness.insights.noDataInTime">no data</h1><h1 ng-if="vm.isFistLoadSocialContent" data-translate="integrations.instagramBusiness.insights.canTakeFewMinutes">no data</h1></div><button ng-if="vm.facebook.connected" class="btn btn-primary btn-large" ng-click="vm.facebookDisconnect()"><span class="fa fa-facebook" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="integrations.googleMyBusiness.buttons.signOut">Sign Out campain</span></button></div></div></div></div></div><div ng-if="vm.isLoadingFB" class="tab-content" style="height: 450px; display: flex;\n        align-items: center;\n        justify-content: center"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div>');
$templateCache.put('app/integrations/google-my-business/gmb-select-gmb-configurations-modal.html','<div class="modal-body" style="text-align: center; padding: 3%"><div class="col-md-12" style="text-align: center; padding-bottom: 3%"><h2 class="modal-title" ng-if="vm.step == 0" data-translate="integrations.googleMyBusiness.modalSelectConfigurations.accounts.title"></h2><h2 class="modal-title" ng-if="vm.step == 1" data-translate="integrations.googleMyBusiness.modalSelectConfigurations.locations.title"></h2><h2 class="modal-title" ng-if="vm.step == 2" data-translate="integrations.googleMyBusiness.modalSelectConfigurations.categories.title"></h2></div><div class="row" style="min-height: 235px; background-color: white !important; padding: 12% 4% 0% 4%"><div ng-if="vm.step == 0" class="col-md-12 md-whiteframe-6dp" style="max-height: 225px; overflow: auto; padding: 0px"><!-- SELECTING THE GOOGLE ACCOUNTS --><md-list style="padding: 0px"><md-list-item ng-repeat="account in vm.googleAccounts" ng-click="vm.selectAccount(account)" class="noright"><img alt="{{ account.name }}" ng-src="{{ account.profilePhotoUrl }}" class="md-avatar"><p>{{ account.accountName }}</p><div class="checkbox flyer-checkbox-remove-margin" style="top: 10px"><label><span ng-if="vm.selectedAccount == account"><i class="fa fa-check" style="font-size: 1.5em; color: #A60708"></i></span></label></div><md-divider ng-if="!$last"></md-divider></md-list-item></md-list></div><div class="row"><div ng-if="vm.step == 1" class="col-md-12"><div class="col-md-12" style="text-align: center"><div class="sk-container" align="center" style="height: 10px; padding-top: 15%" ng-if="vm.processing"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><md-content layout-xs="row" layout="row" ng-if="!vm.processing" style="background-color: white !important; overflow-x: auto"><!-- SELECTING THE GOOGLE LOCATIONS --><div flex-xs flex-gt-xs="35" layout="column" class="ksc-card-selection" ng-click="vm.createANewLocation()" style="padding: 2%"><md-card class="md-whiteframe-6dp" style="height: 225px; width: 155px"><md-card-header style="padding-top: 0"><md-card-avatar style="padding-top: 14px; width: 100%; margin-right: 0"><span ng-if="vm.selectedLocation == location" style="float: right"><i class="fa fa-check" style="font-size: 1.5em; color: #A60708"></i></span></md-card-avatar></md-card-header><md-card-title style="padding-top: 0"><md-card-title-text><i class="fa fa-plus-circle" style="font-size: 3.4em; color: #cacace"></i> <span class="md-subhead" data-translate="integrations.googleMyBusiness.modalSelectConfigurations.locations.newLocationLabel"></span></md-card-title-text></md-card-title></md-card></div><div ng-repeat="location in vm.gmbLocations" flex-xs flex-gt-xs="35" layout="column" class="ksc-card-selection" ng-click="vm.selectLocation(location)" style="padding: 2%"><md-card class="md-whiteframe-6dp" style="height: 225px; width: 155px"><md-card-header style="padding-top: 0"><md-card-avatar style="padding-top: 14px; width: 100%; margin-right: 0"><span ng-if="vm.selectedLocation == location" style="float: right"><i class="fa fa-check" style="font-size: 1.5em; color: #A60708"></i></span></md-card-avatar></md-card-header><md-card-title style="padding-top: 0"><md-card-title-text><img ng-src="chttps://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/GMB-logo.png" height="100" width="100%"> <span class="md-subhead">{{ location.locationName | capitalize }}</span></md-card-title-text></md-card-title></md-card></div></md-content></div></div></div><div ng-if="vm.step == 2 && !vm.processing" class="col-md-12" style="height: 100%"><div class="col-md-12"><md-content class="md-padding" style="background-color: white !important"><md-autocomplete md-input-name="autocompleteField" md-no-cache="true" md-selected-item="vm.selectedCategory" md-search-text="vm.searchTerm" md-items="category in vm.searchCategory()" md-item-text="category.displayName" md-min-length="4" md-menu-class="autocomplete-custom-template" placeholder="{{ \'integrations.googleMyBusiness.modalSelectConfigurations.categories.placeholderInputSearch\' | translate }}" class="md-whiteframe-6dp ksc-md-search-input"><md-item-template><!-- <md-icon class="fa fa-search" aria-label="Home"></md-icon> --> <span md-highlight-text="vm.searchTerm" md-highlight-flags="^i">{{category.displayName}}</span></md-item-template><md-not-found>No states matching "{{vm.searchTerm}}" were found.</md-not-found></md-autocomplete></md-content></div></div></div></div><div class="modal-footer" style="border: 0px !important; text-align: center; padding-top: 0%"><div resizable class="first-steps-home-screen row scaled" aling="center" ng-if="!vm.processing"><ul style="padding: 0"><li class="progress-step"><div ng-class="{\'active-progress-step\': (vm.step >= 0 && vm.selectedAccount), \'inactive-progress-step\': vm.step == 0 }"></div></li><li class="progress-step"><div ng-class="{\'active-progress-step\':( vm.step >= 1), \'inactive-progress-step\': vm.step <= 1 }"></div></li><li class="progress-step" ng-if="vm.isToSelectCategory()"><div ng-class="{\'active-progress-step\': ( vm.step >= 2 ) , \'inactive-progress-step\': vm.step <= 2 }"></div></li></ul></div><button type="button" class="btn btn-primary ksc-btn-next-padding" ng-click="vm.nextStep()" ng-disabled="!vm.verifyConditions()" ladda="vm.processing"><span data-translate="{{ vm.step < 2 && vm.isToSelectCategory() ? \'integrations.googleMyBusiness.modalSelectConfigurations.buttons.next\' : \'integrations.googleMyBusiness.modalSelectConfigurations.buttons.finish\' }}"></span></button><div class="col-md-12" style="padding-top: 2%"><a ng-click="vm.doBackwardAction()" ng-if="!vm.processing"><span data-translate="{{ vm.step == 0 ? \'integrations.googleMyBusiness.modalSelectConfigurations.buttons.cancel\' : \'integrations.googleMyBusiness.modalSelectConfigurations.buttons.back\' }}"></span></a></div></div>');
$templateCache.put('app/integrations/google-my-business/google-my-business-tab.html','<div class="col-sm-12" style="text-align: center"><div class="row" ng-hide="vm.isGoogleMyBusinessConnected || vm.isLoadingGMB" style="padding: 6% 2% 0 2%"><div class="col-md-12 ksc-no-content-box"><img style="padding: 20px" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/GMB-main-img.png" alt=""><h1 data-translate="integrations.googleMyBusiness.mainDescription">Create your first showcase.</h1><p data-translate="integrations.googleMyBusiness.mainSubDescription" class="ksc-sub-title" style="width: 37% !important">Lorem ipsum dolor sit amet consectetur</p></div></div><div ng-if="vm.isLoadingGMB" class="tab-content" style="display: flex; align-items: center; justify-content: center; padding: 6%"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div><button id="authorize_google_my_business" class="btn btn-primary btn-large" ng-click="vm.authorizeGMB()" ng-show="!vm.isLoadingGMB && !vm.isGoogleMyBusinessConnected" ladda="vm.isLoadingGMB" style="margin: 2%"><span style="font-size: 1.2em"></span><i class="fa fa-google"></i>&nbsp; <span data-translate="integrations.googleMyBusiness.buttons.authorizeShowkase">Authorize Google My Business</span></button><div class="col-sm-12" ng-show="!vm.isLoadingGMB && vm.isGoogleMyBusinessConnected"><div class="col-sm-12" style="text-align: left"><div class="wrapper wrapper-content"><div class="row m-b-lg m-t-lg"><div class="col-md-5"><div class="profile-image"><img src="https://seeklogo.com/images/G/google-my-bussines-logo-554E98BE88-seeklogo.com.png" class="m-b-md" style="width: 96px"></div><div class="profile-info"><div class=""><h2 class="no-margins">{{vm.gmbInsights.storeName}}</h2><h4>Loja de {{vm.gmbInsights.category}}</h4><a id="disconnect_google_my_business" href="#" ng-click="vm.signOutGMB()" data-translate="integrations.googleMyBusiness.buttons.signOut">Sign Out</a></div></div></div><div class="col-md-3"><table class="table small m-b-xs"><tbody><tr><td><strong><i class="fa fa-map-marker"></i> {{vm.gmbInsights.drivingActionsQuartely || 0 }}</strong> Solicita\xE7\xF5es de rota (Trimestre)</td></tr><tr><td><strong><i class="fa fa-phone"></i> {{vm.gmbInsights.phoneActionsQuartely || 0 }}</strong> Liga\xE7\xF5es para sua empresa (Trimestre)</td></tr><tr><td><strong><i class="fa fa-globe"></i> {{vm.gmbInsights.websiteActionsQuartely || 0}}</strong> Visitas no site (Trimestre)</td></tr></tbody></table></div><div class="col-md-4"><div class="block m-b-sm"><h1 class="no-margin">{{vm.gmbInsights.queriesQuartely || 0 }} pessoas</h1><p class="no-margin">Encontraram sua empresa nos \xFAltimos 3 meses</p></div><div class="block"><h1 class="no-margin">{{vm.gmbInsights.drivingActionsQuartely + vm.gmbInsights.phoneActionsQuartely + vm.gmbInsights.websiteActionsQuartely}} pessoas</h1><p class="no-margin">Interagiram com sua empresa nos \xFAltimos 3 meses</p></div></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-lg-2"><div class="ibox"><div class="ibox-title"><div class="ibox-tools"><span class="label label-success pull-right">Mensal</span></div><h5>Buscas</h5></div><div class="ibox-content"><div class="row"><div class="col-md-12"><h1 class="no-margins">{{vm.gmbInsights.directQueries + vm.gmbInsights.indirectQueries + vm.gmbInsights.chainQueries}}</h1><div class="font-bold text-muted"><small>Total de Buscas</small></div></div></div></div></div></div><div class="col-lg-2"><div class="ibox"><div class="ibox-title"><div class="ibox-tools"><span class="label label-success pull-right">Mensal</span></div><h5>Visitas</h5></div><div class="ibox-content"><div class="row"><div class="col-md-12"><h1 class="no-margins">{{vm.gmbInsights.websiteActions}}</h1><div class="font-bold text-muted"><small>Visitas ao site</small></div></div></div></div></div></div><div class="col-lg-4"><div class="ibox"><div class="ibox-title"><div class="ibox-tools"><span class="label label-success pull-right">Mensal</span></div><h5>Visualiza\xE7\xF5es</h5></div><div class="ibox-content"><div class="row"><div class="col-md-6"><h1 class="no-margins">{{vm.gmbInsights.searchViews}}</h1><div class="font-bold text-muted"><small>Google</small></div></div><div class="col-md-6"><h1 class="no-margins">{{vm.gmbInsights.mapViews}}</h1><div class="font-bold text-muted"><small>Google Maps</small></div></div></div></div></div></div><div class="col-lg-4"><div class="ibox"><div class="ibox-title"><div class="ibox-tools"><span class="label label-success pull-right">Mensal</span></div><h5>A\xE7\xF5es</h5></div><div class="ibox-content"><div class="row"><div class="col-md-6"><h1 class="no-margins">{{vm.gmbInsights.phoneActions}}</h1><div class="font-bold text-muted"><small>Liga\xE7\xF5es</small></div></div><div class="col-md-6"><h1 class="no-margins">{{vm.gmbInsights.drivingActions}}</h1><div class="font-bold text-muted"><small>Rotas para empresa</small></div></div></div></div></div></div></div><div class="row"><div class="col-xs-12 col-md-8"><div class="ibox" ng-style="{\'min-height\' : (vm.totalGMBQuestions === 0) ? \'240px\' : \'364px\' }"><div class="ibox-title"><h5>Perguntas</h5></div><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="tab-content" ng-if="!vm.loadingGMBQuestions"><div id="tab-1" class="tab-pane active"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th><span>Consumidor</span></th><th><span>Pergunta</span></th><th><span>Data</span></th><th class="text-center"><span>A\xE7\xE3o</span></th></tr></thead><tbody><td class="text-center" colspan="12" ng-if="vm.totalGMBQuestions === 0"><strong>Nenhuma pergunta foi encontrada</strong></td><tr ng-repeat="question in vm.gmbQuestions"><td><span ng-bind="question.customer"></span></td><td><span ng-bind="question.text"></span></td><td><span ng-bind="question.createdAt | date: \'short\'"></span></td><td class="text-center"><a ng-href="{{question.link}}" target="_blank"><i class="fa fa-reply"></i> Responder</a></td></tr></tbody></table></div></div><div align="center" ng-if="vm.totalGMBQuestions !== 0"><uib-pagination ng-model="vm.currentPageGMB" total-items="vm.totalGMBQuestions" max-size="vm.maxSizeGMB" items-per-page="vm.numPerPageGMB" boundary-links="true" ng-change="vm.changePageGMB()"></uib-pagination><div class="col-xs-12 col-sm-12"><p class="no-margin" data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistryGMB}}\', of: \'{{vm.endRegistryGMB}}\', total: \'{{vm.totalGMBQuestions}}\'}">Showing {{ vm.startRegistryGMB }} to {{ vm.endRegistryGMB }} of {{ vm.totalGMBQuestions }}</p></div></div></div><div ng-if="vm.loadingGMBQuestions" class="tab-content" style="height: 220px; display: flex; align-items: center; justify-content: center"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div></div></div></div></div></div><div class="col-xs-12 col-md-4"><div class="ibox" ng-style="{\'min-height\' : (vm.totalGMBQuestions === 0) ? \'240px\' : \'364px\' }"><div class="ibox-title"><h5>Atividades</h5></div><div class="ibox-content"><div class="row"><div class="col-xs-12 col-md-6 m-b-xl"><p class="m-b-xs">Buscas indiretas</p><h4 class="no-margin">{{vm.gmbInsights.directQueries}}</h4></div><div class="col-xs-12 col-md-6 m-b-xl"><p class="m-b-xs">Buscas indiretas</p><h4 class="no-margin">{{vm.gmbInsights.indirectQueries}}</h4></div><div class="col-xs-12 col-md-6 m-t-md"><p class="m-b-xs">Visualiza\xE7\xF5es de fotos</p><h4 class="no-margin">{{vm.gmbInsights.photoViewsCustomer}} <span class="text-muted" style="font-size: 12px; font-weight: 400">(Por consumidores)</span></h4></div><div class="col-xs-12 col-md-6 m-t-md"><p class="m-b-xs">Visualiza\xE7\xF5es de fotos</p><h4 class="no-margin">{{vm.gmbInsights.photoViewsMerchant}} <span class="text-muted" style="font-size: 12px; font-weight: 400">(Por empres\xE1rios)</span></h4></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/integrations/instagram-business/instagram-business-tab.html','<style>.md-skin .ibox {\n       min-height: 240px;\n    }\n\n    .ranges li.active, .ranges li:hover, .ranges .applyBtn {\n        background-color: #05A19C;\n        border: 1px solid #05A19C;\n    }\n\n    .daterangepicker td.active {\n        background-color: #05A19C;\n    }\n\n    .ranges li {\n        color: inherit;\n    }\n\n    .summary-text {\n        margin-left: 5px;\n    }\n\n    .fa-question-circle {\n        margin-left: 5px;\n    }\n\n    .box-first-icon {\n        margin-bottom: 28px;\n        font-size: 2.3em;\n        width: 27px;\n    }\n\n    .box-second-icon {\n        color: #fe398b;\n        fill: #fe398b;\n        font-size: 1.5em;\n        width: 23px;\n        margin-right: 5px;\n    }\n\n    .h-divider {\n        width: 20%;\n        float: left;\n        border-top: 3px solid #eeeeee;\n        margin: 10px 0;\n    }\n\n    .h-divider-rate {\n        width: 20%;\n        float: left;\n        border-top: 3px solid #eeeeee;\n        margin: 18px 0 12px 0;\n    }\n\n    .v-divider {\n        border-left: 1px solid #f3ecec;\n        height: 50px;\n    }\n\n    .summary {\n        padding: 5px;\n        display: flex;\n        align-content: center;\n        align-items: center;\n    }\n\n    .date-picker {\n        width: 180px;\n        border-radius: 8px;\n    }\n\n    .ig-profile {\n        display: flex;\n        align-items: center;\n    }\n\n    .ig-profile-image {\n        width: 57px;\n        float: left;\n    }\n\n    .ig-profile-info {\n        /* margin-left: 83px; */\n    }\n\n    @media screen and (min-width: 1501px) {\n        .one {\n            width: 20%;\n        }\n\n        .two {\n            width: 40%;\n        }\n\n        .col-chart {\n            width: 26.66%;\n        }\n\n    }</style><div ng-if="!vm.isLoadingFB"><div class="col-sm-12" ng-if="!vm.igAccountConnected" style="text-align: center; padding: 6% 2%"><div class="row"><div class="col-md-12 ksc-no-content-box"><img style="padding: 20px" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/catalog-instagram-1-g.png" alt=""><h1 data-translate="integrations.instagramBusiness.mainDescription">Create your first showcase.</h1><p data-translate="integrations.instagramBusiness.mainSubDescription" class="ksc-sub-title" style="width: 40% !important">Lorem ipsum dolor sit amet consectetur</p></div></div><button ng-if="!vm.facebook.connected" class="btn btn-primary btn-large" ng-click="vm.facebookAuth()"><span class="fa fa-instagram" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="integrations.facebookBusiness.buttons.connectFacebook">Connect Facebook campain</span></button></div><!-- SEM INSIGHTS COLETADOS && vm.isFistLoadSocialContent --><div ng-if="vm.igAccountConnected && !vm.igHasContent()" style="text-align: center; padding: 6% 2%"><div class="row"><div class="col-md-12 ksc-no-content-box"><img style="padding: 20px" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/catalog-facebook-1-g.png" alt=""><h1 ng-if="!vm.isFistLoadSocialContent" data-translate="integrations.instagramBusiness.insights.noDataInTime">no data</h1><h1 ng-if="vm.isFistLoadSocialContent" data-translate="integrations.instagramBusiness.insights.canTakeFewMinutes">no data</h1></div><button ng-if="vm.facebook.connected" class="btn btn-primary btn-large" ng-click="vm.facebookDisconnect()"><span class="fa fa-facebook" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="integrations.googleMyBusiness.buttons.signOut">Sign Out campain</span></button></div></div><div ng-if="vm.igAccountConnected && vm.igHasContent()"><!-- CARREGANDO INSIGHTS INSTAGRAM --><div ng-if="vm.isLoadingIg"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div><div ng-if="!vm.isLoadingIg"><!-- INSTAGRAM CONECTADO --><div class="col-sm-12" ng-if="vm.igAccountConnected && vm.igAccountMediaInsightsList.length > 0"><div class="col-sm-12"><div class="col-sm-12" style="text-align: left"><div class="wrapper wrapper-content"><div class="row" style="margin-bottom: 10px"><div class="col-md-12 ig-profile"><div class="ig-profile-image"><i class="fa fa-instagram" style="color: #95d5df; font-size: 4em"></i></div><div class="ig-profile-info"><div class=""><h2 class="no-margins">{{vm.igAccountData.name}}</h2><a href="#" ng-click="vm.facebookDisconnect()" data-translate="integrations.googleMyBusiness.buttons.signOut">Sign Out</a></div></div></div></div><div class="row"><div class="col-md-6 one"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-md-12"><i class="fa fa-eye box-first-icon" style="color: #95d5df"></i><br><h5 class="no-margins" data-translate="integrations.instagramBusiness.insights.impressions">Impressions</h5><i class="fa fa-question-circle" style="color: #95d5df" uib-tooltip="{{\'integrations.instagramBusiness.insights.description.impressions\' | translate}}"></i><h1 class="no-margins">{{(vm.igAccountMediaInsights.postImpressions + vm.igAccountMediaInsights.storyImpressions) || 0}}</h1></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr class="h-divider" style="border-top-color: #95d5df"></div></div></div><div class="ibox-content"><div class="row"><div class="col-md-6"><h1 class="no-margins">{{vm.getFormattedValue(vm.igAccountMediaInsights.postImpressions || 0)}}</h1><div class="font-bold text-muted" data-translate="integrations.instagramBusiness.insights.posts"><small>posts</small></div></div><div class="col-md-6"><h1 class="no-margins">{{vm.getFormattedValue(vm.igAccountMediaInsights.storyImpressions || 0)}}</h1><div class="font-bold text-muted" data-translate="integrations.instagramBusiness.insights.stories"><small>stories</small></div></div></div></div></div></div><div class="col-md-6 one"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-md-12"><i class="fa fa-bullhorn box-first-icon" style="color: #ead544"></i><br><h5 class="no-margins" data-translate="integrations.instagramBusiness.insights.reach" class="box-first-label">Reach</h5><i class="fa fa-question-circle" style="color: #ead544" uib-tooltip="{{\'integrations.instagramBusiness.insights.description.reach\' | translate}}"></i><h1 class="no-margins">{{(vm.igAccountMediaInsights.postReach + vm.igAccountMediaInsights.storyReach) || 0}}</h1></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr class="h-divider" style="border-top-color: #ead544"></div></div></div><div class="ibox-content"><div class="row"><div class="col-md-6"><h1 class="no-margins">{{vm.getFormattedValue(vm.igAccountMediaInsights.postReach || 0)}}</h1><div class="font-bold text-muted" data-translate="integrations.instagramBusiness.insights.posts"><small>posts</small></div></div><div class="col-md-6"><h1 class="no-margins">{{vm.getFormattedValue(vm.igAccountMediaInsights.storyReach || 0)}}</h1><div class="font-bold text-muted" data-translate="integrations.instagramBusiness.insights.stories"><small>stories</small></div></div></div></div></div></div><div class="col-md-6 two"><div class="ibox"><div class="row"><div class="col-md-6"><div class="ibox-title"><div class="row"><div class="col-md-12"><svg class="box-first-icon" style="fill: #fe398b" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">Font Awesome Free 5.15.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)<path d="M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"/></svg><br><h5 class="no-margins" data-translate="integrations.instagramBusiness.insights.engagement" class="box-first-label">Engagement</h5><i class="fa fa-question-circle" style="color: #fe398b" uib-tooltip="{{\'integrations.instagramBusiness.insights.description.engagement\' | translate}}"></i><h1 class="no-margins">{{(vm.igAccountMediaInsights.postEngagement + vm.igAccountMediaInsights.storyEngagement) || 0}}</h1></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr class="h-divider" style="border-top-color: #fe398b"></div></div></div><div class="ibox-content"><div class="row"><div class="col-md-6"><h1 class="no-margins">{{vm.getFormattedValue(vm.igAccountMediaInsights.postEngagement || 0)}}</h1><div class="font-bold text-muted" data-translate="integrations.instagramBusiness.insights.posts"><small>posts</small></div></div><div class="col-md-6"><h1 class="no-margins">{{vm.getFormattedValue(vm.igAccountMediaInsights.storyEngagement || 0)}}</h1><div class="font-bold text-muted" data-translate="integrations.instagramBusiness.insights.stories"><small>stories</small></div></div></div></div></div><div class="col-md-6"><div class="ibox-content" style="margin-top: 10px"><div class="row"><div class="col-md-12"><div class="summary"><i class="fa fa-heart box-second-icon"></i><h2 class="no-margins">{{vm.igAccountMediaInsights.likeCount || 0}}</h2><div class="font-bold text-muted summary-text" data-translate="integrations.instagramBusiness.insights.likes"><small>Likes</small></div></div><div class="summary"><i class="fa fa-comment box-second-icon"></i><h2 class="no-margins">{{vm.igAccountMediaInsights.commentsCount || 0}}</h2><div class="font-bold text-muted summary-text" data-translate="integrations.instagramBusiness.insights.comments"><small>Comments</small></div></div><div class="summary"><i class="fa fa-bookmark box-second-icon"></i><h2 class="no-margins">{{vm.igAccountMediaInsights.saved || 0}}</h2><div class="font-bold text-muted summary-text" data-translate="integrations.instagramBusiness.insights.saved"><small>Saved Posts</small></div></div><div class="summary"><i class="fa fa-reply box-second-icon"></i><h2 class="no-margins">{{vm.igAccountMediaInsights.replies || 0}}</h2><div class="font-bold text-muted summary-text" data-translate="integrations.instagramBusiness.insights.replies"><small>Stories Replies</small></div></div><div class="summary"><svg class="box-second-icon" style="margin: 0 3px -4px 0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!-- Font Awesome Free 5.15.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"/></svg><h2 class="no-margins">{{vm.igAccountMediaInsights.tapsBack || 0}}</h2><div class="font-bold text-muted summary-text" data-translate="integrations.instagramBusiness.insights.tapsBack"><small>Taps Back</small></div></div></div></div></div></div></div></div></div><div class="col-md-6 one"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-md-12"><svg class="box-first-icon" style="fill: #fe398b; width: 22px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!-- Font Awesome Free 5.15.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"/></svg><br><h5 class="no-margins">Taxa de</h5><br><h5 class="no-margins">Engajamento</h5><i class="fa fa-question-circle" style="color: #fe398b" uib-tooltip="{{\'integrations.instagramBusiness.insights.description.engagementRate\' | translate}}"></i></div></div><div class="row" style="margin-top: 9px"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr class="h-divider" style="border-top-color: #fe398b; margin-top: 9px"></div></div></div><div class="ibox-content"><div class="row"><div class="col-md-6"><h1 class="no-margins">{{vm.igAccountMediaInsights.postEngagementRate || 0}}</h1><div class="font-bold text-muted" data-translate="integrations.instagramBusiness.insights.posts"><small>posts</small></div></div><div class="col-md-6"><h1 class="no-margins">{{vm.igAccountMediaInsights.storyEngagementRate || 0}}</h1><div class="font-bold text-muted" data-translate="integrations.instagramBusiness.insights.stories"><small>stories</small></div></div></div></div></div></div></div><div class="row"><div class="col-md-6 one"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-md-12"><i class="fa fa-users box-first-icon" style="color: #95d5df"></i><br><h5 class="no-margins" data-translate="integrations.instagramBusiness.insights.totalFollowers">Total followers</h5><i class="fa fa-question-circle" style="color: #95d5df" uib-tooltip="{{\'integrations.instagramBusiness.insights.description.dataTime\' | translate}}"></i><h1 class="no-margins">{{vm.igAccountInsights.followersCount || 0}}</h1></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr class="h-divider" style="border-top-color: #95d5df"></div></div></div><div class="ibox-content"><div class="row"><div class="col-md-6"><h1 class="no-margins">{{vm.followersMale || 0}}</h1><div class="font-bold text-muted" data-translate="integrations.instagramBusiness.insights.men"><small>men</small></div></div><div class="col-md-6"><h1 class="no-margins">{{vm.followersFemale || 0}}</h1><div class="font-bold text-muted" data-translate="integrations.instagramBusiness.insights.women"><small>women</small></div></div></div></div></div></div><div class="col-md-6 col-chart"><div class="ibox"><div class="ibox-title"><h5 class="no-margins" data-translate="integrations.instagramBusiness.insights.age">Age range</h5><i class="fa fa-question-circle" style="color: #fe398b" uib-tooltip="{{\'integrations.instagramBusiness.insights.description.dataTime\' | translate}}"></i></div><div class="ibox-content"><div class="row"><div class="col-md-12"><canvas ng-if="vm.audienceAgeData && vm.audienceAgeData.length > 0" class="chart chart-bar" chart-data="vm.audienceAgeData" chart-labels="vm.audienceAgeLabels" chart-options="vm.barChartOptions"></canvas><h5 ng-if="!vm.audienceAgeData || vm.audienceAgeData.length === 0" data-translate="integrations.instagramBusiness.insights.noDataInTime" class="text-center">No data</h5></div></div></div></div></div><div class="col-md-6 col-chart"><div class="ibox"><div class="ibox-title"><h5 class="no-margins" data-translate="integrations.instagramBusiness.insights.topLocations">Top locations</h5><i class="fa fa-question-circle" style="color: #fe398b" uib-tooltip="{{\'integrations.instagramBusiness.insights.description.dataTime\' | translate}}"></i></div><div class="ibox-content"><div class="row"><div class="col-md-12"><canvas ng-if="vm.audienceLocationData && vm.audienceLocationData.length > 0" class="chart chart-horizontal-bar" chart-data="vm.audienceLocationData" chart-labels="vm.audienceLocationLabels" chart-options="vm.barChartOptions"></canvas><h5 ng-if="!vm.audienceLocationData || vm.audienceLocationData.length === 0" data-translate="integrations.instagramBusiness.insights.noDataInTime" class="text-center">No data</h5></div></div></div></div></div><div class="col-md-6 col-chart"><div class="ibox"><div class="ibox-title"><h5 class="no-margins" data-translate="integrations.instagramBusiness.insights.follow">Follow</h5><i class="fa fa-question-circle" style="color: #fe398b" uib-tooltip="{{\'integrations.instagramBusiness.insights.description.dataTime\' | translate}}"></i></div><div class="ibox-content"><div class="row"><div class="col-md-12"><canvas ng-if="vm.followersLabels && vm.followersLabels.length > 0" class="chart chart-line" chart-data="vm.followersData" chart-labels="vm.followersLabels" chart-options="vm.lineChartOptions" chart-colors="vm.colors"></canvas><h5 ng-if="!vm.followersLabels || vm.followersLabels.length === 0" data-translate="integrations.instagramBusiness.insights.noDataInTime" class="text-center">No data</h5></div></div></div></div></div></div></div></div></div></div><!-- SEM INSIGHTS COLETADOS --><div ng-if="vm.igAccountConnected && vm.igAccountMediaInsightsList.length === 0" style="text-align: center; padding: 6% 2%"><div class="row"><div class="col-md-12 ksc-no-content-box"><img style="padding: 20px" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/catalog-facebook-1-g.png" alt=""><h1 data-translate="integrations.instagramBusiness.insights.noData">no data</h1></div></div></div><!-- INSTAGRAM NAO CONECTADO --><div class="col-sm-12" ng-if="!vm.igAccountConnected" style="text-align: center; padding: 6% 2%"><div class="row"><div class="col-md-12 ksc-no-content-box"><img style="padding: 20px" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/catalog-facebook-1-g.png" alt=""><h1 data-translate="integrations.instagramBusiness.insights.instagramNotConnected">Voc\xEA ainda n\xE3o tem conta do instagram em seu neg\xF3cio.</h1><p class="ksc-sub-title" style="width: 40% !important"><span data-translate="integrations.instagramBusiness.insights.instagramAccountConfig">Para configurar uma conta acesse: </span><a target="_blank" href="https://business.instagram.com/getting-started">https://business.instagram.com/getting-started</a></p></div></div></div></div></div></div><div ng-if="vm.isLoadingFB" class="tab-content" style="height: 450px; display: flex;\n        align-items: center;\n        justify-content: center"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div>');
$templateCache.put('app/integrations/whatsapp/whatsapp-campaing.html','<div class="tab-content" ng-if="!vm.loadingWhatsappJobResumes && vm.whatsappJobResumes && vm.whatsappJobResumes.length == 0 && !vm.thereIsWhatsappJob" style="text-align: center; padding: 6% 2%"><div class="row"><div class="col-md-12 ksc-no-content-box"><img style="padding: 20px" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/campaign-whatsapp-g.png" alt=""><h1 data-translate="integrations.whatsapp.mainDescription">Create your first campaign</h1><p data-translate="integrations.whatsapp.mainSubDescription" class="ksc-sub-title" style="width: 37% !important"></p></div></div><button ng-click="vm.openWhatsappCampaingModal()" class="btn btn-primary btn-large"><span style="font-size: 1.2em"></span><i class="fa fa-whatsapp"></i>&nbsp; <span data-translate="integrations.whatsapp.buttons.createCampaign">Create Campaign</span></button></div><div class="ibox-content" ng-if="(!vm.loadingWhatsappJobResumes && vm.whatsappJobResumes && vm.whatsappJobResumes.length > 0) || vm.thereIsWhatsappJob" style="height: 721px"><div class="ibox-title" style="padding-top: 2% 0 0 0"><div class="row"><div class="col-md-6" style="padding: 0"><div style="width: 80%" class="input-group form-group"><input ng-keyup="$event.keyCode == 13 && vm.searchWaJobsByFilter()" type="text" placeholder="{{ \'integrations.whatsapp.whatsappJobResumeTable.searchCampaign\' | translate }}" class="input form-control" ng-model="vm.filterWhatsappJob.campaignName"> <span class="input-group-btn"><button ng-click="vm.searchWaJobsByFilter()" class="btn btn btn-primary"><i class="fa fa-search"></i> <span data-translate="customer.button.search">Search</span></button></span></div></div><div class="col-md-6" style="padding: 0"><button ng-click="vm.openWhatsappCampaingModal()" class="btn btn-primary btn-large pull-right"><span style="font-size: 1.2em"></span><i class="fa fa-plus"></i>&nbsp; <span data-translate="integrations.whatsapp.buttons.newCampaign">New Campaign</span></button></div></div></div><div class="clients-list"><div class="tab-content"><div id="tab-1" class="tab-pane active" style="height: 520px; margin-bottom: 10px"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th style="width: 45%"><span data-translate="integrations.whatsapp.whatsappJobResumeTable.titles.campaign">Campaign</span></th><th style="width: 20%"><span data-translate="integrations.whatsapp.whatsappJobResumeTable.titles.status">Status</span></th><th style="width: 25%"><span data-translate="integrations.whatsapp.whatsappJobResumeTable.titles.progress">Progress</span></th><th ng-show="true" style="width: 10%"><span data-translate="integrations.whatsapp.whatsappJobResumeTable.titles.actions">Actions</span></th></tr></thead><tbody><tr ng-repeat="resume in vm.whatsappJobResumes"><td class="client-avatar" style="width: 45%"><span style="padding-left: 10px">{{ resume.campaingName }}</span></td><td style="width: 20%"><span class="{{ vm.getResumeStatusClass(resume) }}">{{ (\'integrations.whatsapp.whatsappJobResumeTable.status.\' + resume.status) | translate }}</span></td><td style="width: 25%"><small>{{ \'integrations.whatsapp.whatsappJobResumeTable.titles.completed\' | translate: \'{ "progress": \' + vm.getTotalPercentage(resume) + \'}\' }}</small><div class="progress progress-mini" tooltip-placement="top" uib-tooltip="{{vm.getToolTip(resume)}}" style="margin-bottom: 0px !important; width: 95%"><div class="progress-bar progress-bar-animated" ng-style="{\'width\':  (vm.getSentPercentage(resume) + \'%\') }" style="background-color: #1ab394 !important"></div><div class="progress-bar" ng-style="{\'width\': (vm.getFailedPercentage(resume) + \'%\') }" style="background-color: #1ab394 !important"></div><div class="progress-bar" ng-style="{\'width\': (vm.getPendingPercentage(resume) + \'%\') }" style="background-color: #e9ecef !important"></div></div></td><td style="width: 10%"><div style="padding: 0px" class="col-lg-12"><span ng-show="false" style="padding: 5% 5% 5% 0; font-size: 1.2em" ng-click="vm.removeWhatsappJob(resume)"><i class="fa fa-trash" tooltip-placement="top" uib-tooltip="{{\'integrations.whatsapp.whatsappJobResumeTable.actions.tooltip.delete\' | translate}}"></i> </span><span style="padding: 5%; font-size: 1.2em; outline: none" ng-click="vm.resumeWhatsappJob(resume)" ng-show="![\'PROCESSING\', \'DONE\'].includes(resume.status)"><i ng-if="!vm.isRetrying && vm.selectedResume.token !== resume.token" class="fa fa-play-circle" tooltip-placement="top"></i> <i ng-if="vm.isRetrying && vm.selectedResume.token === resume.token" class="fa fa-spinner fa-spin" tooltip-placement="top"></i> </span><span ng-show="false" style="padding: 5%; font-size: 1.2em" ng-click="vm.detailWhatsappJob(resume)"><i class="fa fa-eye" tooltip-placement="top" uib-tooltip="{{\'integrations.whatsapp.whatsappJobResumeTable.actions.tooltip.detail\' | translate}}"></i></span></div></td></tr></tbody></table></div></div><div align="center" style="padding-bottom:  20px"><uib-pagination ng-model="vm.currentPageWhatsappJob" total-items="vm.totalWhatsappJob" max-size="vm.maxSizeWhatsappJob" items-per-page="vm.numPerPageWhatsappJob" boundary-links="true" ng-change="vm.changePageWhatsappJob()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistryWhatsappJob}}\', of: \'{{vm.endRegistryWhatsappJob}}\', total: \'{{vm.totalWhatsappJob}}\'}">Showing {{ vm.startRegistryWhatsappJob }} to {{ vm.endRegistryWhatsappJob }} of {{ vm.totalWhatsappJob }}</p></div></div></div></div></div><div ng-if="vm.loadingWhatsappJobResumes" class="tab-content" style="height: 450px; display: flex;\n        align-items: center;\n        justify-content: center"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div>');
$templateCache.put('app/integrations/whatsapp/whatsapp-clients.html','<div class="ibox-title row" style="padding: 0px"><div class="col-md-12"><div style="width: 100%" class="input-group form-group"><input style="width: 95%" ng-keyup="vm.searchByFilter()" type="text" placeholder="Buscar Cliente" class="input form-control" ng-model="vm.filter.fullName"> <span class="input-group-btn"><i ng-if="!vm.isClietFormVisible" ng-click="vm.showClientForm()" style="font-size: 30px; color: lightgray; outline: none" class="fa fa-user-plus"></i> <i ng-if="vm.isClietFormVisible" ng-click="vm.showClientForm()" style="font-size: 30px; outline: none" class="fa fa-user-plus primary-color"></i></span></div></div></div><div ng-if="vm.isClietFormVisible" class="row"><hr style="margin-left: 15px; margin-right: 15px"><form name="customerForm" novalidate><div class="col-md-5 col-sm-5 col-xs-12 form-group"><label for="fullName" class="required" data-translate="global.form.fullName">Full name</label><input id="fullName" name="fullName" type="text" class="form-control" ng-model="vm.customer.fullName" ng-maxlength="100" ng-minlength="4" required><div class="help-block-div" ng-show="vm.formAddEditCustomer.fullName.$invalid && vm.formAddEditCustomer.$submitted"><p class="help-xblock form-invalid-field" ng-show="vm.formAddEditCustomer.fullName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.fullName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.fullName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-4 col-xs-12 form-group"><label id="phone" for="phone" class="required" data-translate="customer.label.phoneAndWhatsapp">Phone/Whatsapp</label><input type="tel" name="phone" id="phone" class="form-control" ng-model="vm.customer.phone" intl-tel-input required><div class="help-block-div" ng-show="vm.formAddEditCustomer.phone.$invalid && vm.formAddEditCustomer.$submitted"><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.phone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div><div class="col-md-3 form-group"><button ng-click="vm.cancelCustomer()" class="btn btn-link" ng-disabled="vm.isSaving" style="margin-top: 24px"><span>cancelar</span></button> <button ng-disabled="customerForm.$invalid || vm.isSaving" ng-click="vm.createNewClient()" class="btn btn btn-primary pull-right" style="margin-top: 24px"><span>Salvar</span></button></div></form></div><div class="clients-list"><div class="tab-content" ng-if="!vm.loadingCustomers && vm.customers.length == 0" style="height: 300px; display: flex;\n                align-items: center;\n                justify-content: center" data-translate="integrations.whatsapp.clientsViewer.noClients">There\'s no clients yet</div><div class="tab-content" ng-if="!vm.loadingCustomers && vm.customers && vm.customers.length > 0"><div id="tab-1" class="tab-pane active" style="height: 260px; margin-bottom: 10px"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th style="width: 3%"><div class="checkbox flyer-checkbox-remove-margin" style="top: 10px" ng-click="vm.selectAllCustomers()"><label><span><i class="fa fa-check" style="font-size: 1.5em; color: #A60708; padding-left: 25px"></i></span></label></div></th><th style="width: 50%"><span data-translate="global.form.fullName">Full Name</span></th><th style="width: 47%"><span data-translate="global.form.phone">Phone</span></th></tr></thead><tbody><tr style="outline:none" ng-repeat="customer in vm.customers" ng-click="vm.selectCustomer(customer)"><td style="width: 3%"><div class="checkbox flyer-checkbox-remove-margin" style="top: 10px"><label><span ng-if="customer.selected"><i class="fa fa-check" style="font-size: 1.5em; color: #A60708; padding-left: 25px"></i> </span><span ng-if="!customer.selected"><i class="fa fa-check" style="font-size: 1.5em; color: lightgray; padding-left: 25px"></i></span></label></div></td><td class="client-avatar" style="width: 50%"><img alt="image" src="/content/images/profile_small.png"> <span class="client-link" ng-bind="customer.fullName" style="padding-left: 10px"></span></td><td style="width: 47%"><i class="fa fa-phone contact-type"></i> <span ng-bind="customer.phone"></span></td></tr></tbody></table></div></div><div><div class="row" style="padding-top: 10px"><div class="col-xs-6 col-sm-6 col-md-6"><p class="pull-left" data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistry}}\', of: \'{{vm.endRegistry}}\', total: \'{{vm.totalCustomers}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalCustomers }}</p></div><div class="col-xs-6 col-sm-6 col-md-6"><uib-pagination class="pull-right" ng-model="vm.currentPage" total-items="vm.totalCustomers" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePageCustomer()"></uib-pagination></div></div></div></div><div ng-if="vm.loadingCustomers" class="tab-content" style="height: 260px; display: flex;\n                align-items: center;\n                justify-content: center"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div></div>');
$templateCache.put('app/integrations/whatsapp/whatsapp-job-modal.html','<div class="modal-body" style="text-align: center; padding: 3%"><div><i class="fa fa-check" style="font-size: 10em; color: #9aca5b"></i></div><div style="font-size: 1.4em" data-translate="integrations.whatsapp.messages.confirmationMessageTitle"></div><div style="font-size: 1.1em" data-translate="integrations.whatsapp.messages.confirmationMessageSubtitle"></div></div><div class="modal-footer" style="border: 0px !important; text-align: center; padding-top: 0%"><button style="margin-top: 2%; padding: 6px 40px" class="btn btn-primary" ng-click="vm.closeModalSuccessfully()">OK</button></div>');
$templateCache.put('app/integrations/whatsapp/whatsapp-message.html','<div class="row"><div class="col-md-6 col-lg-6 col-xs-12"><form name="wappForm"><md-content style="background-color: white" class="md-padding" layout="column"><div style="width: 50%" class="form-group"><label for="campaingName" data-translate="integrations.whatsapp.qrCodeWa.stepTwo.campName">Dados da campanha</label><input required name="campaingName" class="form-control" ng-model="vm.wappDTO.campaingName"></div></md-content><md-content style="background-color: white; padding-top: 4px" class="md-padding" layout="column"><div style="width: 100%" class="form-group"><label for="messageWapp" data-translate="integrations.whatsapp.qrCodeWa.stepTwo.campMsg">Mensagem da campanha</label><textarea required name="messageWapp" max-rows="5" style="resize: none" class="form-control" ng-model="vm.wappDTO.message" maxlength="400" rows="5"></textarea><div ng-messages="wappForm.messageWapp.$error" ng-show="wappForm.messageWapp.$dirty" role="alert"><div style="color: red" ng-message="required">{{ \'entity.validation.required\' | translate }}</div><div style="color: red" ng-message="maxlength">{{ \'entity.validation.maxlength\' | translate:\'{ max: "400" }\' }}</div></div></div></md-content></form></div><div class="col-md-6 col-lg-6 col-xs-12"><div class="row" style="padding: 16px"><label data-translate="integrations.whatsapp.qrCodeWa.stepTwo.fileUpload"></label><h3 data-translate="integrations.whatsapp.qrCodeWa.stepTwo.fileUploadDesc" style="color: #606062; font-size: 1em; font-family: Humanst521 Lt BT"></h3><div class="col-md-4"><button ladda="vm.isUploading" class="btn btn-primary" style="outline: none; cursor: pointer; margin-left: -15px" ngf-select="vm.uploadFile($file, $invalidFiles)" type="file" ngf-accept="\'image/*, video/mp4, video/mov\'" ngf-max-size="64MB"><span>Escolher arquivo</span></button></div><div class="col-md-8"><span class="col-lg-6 col-sm-6 col-md-6 col-xs-6 center" style="padding: 0px; color: #606062; font-size: 1em; font-family: Humanst521 Lt BT">{{ vm.imageUpload ? vm.imageUpload.name : ( \'integrations.whatsapp.qrCodeWa.stepTwo.noFile\' | translate ) }} <i ng-if="vm.imageUpload" class="fa fa-trash primary-color" ng-click="vm.excludeImageUploaded()"></i></span></div></div></div></div>');
$templateCache.put('app/integrations/whatsapp/whatsapp-qrcode-viewer.html','<style>._2eNdO {\n        font-size: 18px;\n        line-height: 28px;\n    }\n\n    @media screen and (max-width: 960px) {\n        ._2eNdO {\n            font-size: 16px;\n            line-height: 25px;\n        }\n    }\n\n    @media screen and (max-width: 660px) {\n        ._2eNdO {\n            font-size: 16px;\n            line-height: 24px;\n        }\n    }\n\n    *::-webkit-scrollbar {\n        width: 6px !important;\n        height: 6px !important;\n        width: 6px !important;\n        height: 6px !important;\n    }\n\n    *::-webkit-scrollbar-thumb {\n        background-color: rgba(0, 0, 0, 0.2);\n    }\n\n    *::-webkit-scrollbar-track {\n        background: rgba(255, 255, 255, 0.08);\n    }\n\n    .qr-box {\n        width: 194px;\n        height: 194px;\n        display: block;\n        position: relative;\n    }\n\n    .qr-box .qr-overlay {\n        background: white;\n        height: 100%;\n        width: 100%;\n        opacity: 0;\n        top: 0;\n        left: 0;\n        opacity: .9;\n        transition: opacity .5s;\n        position: absolute;\n        padding: 0;\n    }\n\n    /* line 25, ../sass/style.scss */\n    .qr-box .qr-overlay p {\n        color: #fff;\n        line-height: 150px;\n        font-family: \'arial\';\n        text-align: center;\n    }\n\n    .qr-box img {\n        width: 194px;\n        height: auto;\n    }\n\n    .landing-title {\n        color: #55636B;\n        font-size: 28px;\n        font-weight: normal;\n        margin-bottom: 52px;\n        line-height: normal;\n    }</style><div class="modal-body" style="min-height: 450px"><div class="col-md-12" style="text-align: center; padding-bottom: 3%"><div ng-if="vm.currentStep == 0"><h2 data-translate="integrations.whatsapp.qrCodeWa.useShowkase">Adicionar novo cliente</h2></div><h2 class="modal-title" ng-if="vm.currentStep == 1" data-translate="integrations.whatsapp.qrCodeWa.stepTwo.title"></h2><h2 class="modal-title" ng-if="vm.currentStep == 2" data-translate="integrations.whatsapp.qrCodeWa.stepThree.title"></h2><div ng-if="vm.currentStep == 3"><h2 class="modal-title" data-translate="integrations.whatsapp.qrCodeWa.confirmation.title">Importante para o funcionamento correto da campanha</h2></div></div><div ng-if="vm.currentStep === 0" id="tab-pages" class="active"><div class="row"><div class="col-md-8"><ol class="_3oE3H"><li class="_2eNdO" data-translate="integrations.whatsapp.qrCodeWa.instruction1">Abra o WhatsApp em seu telefone</li><li class="_2eNdO" style="margin-top: 18px"><span dir="ltr" class="selectable-text invisible-space copyable-text"><span data-translate="integrations.whatsapp.qrCodeWa.instruction2">Toque em</span><strong> <span dir="ltr" class="selectable-text invisible-space copyable-text"><span data-translate="integrations.whatsapp.qrCodeWa.instruction3">Menu</span> <span class="_3CSsZ"><svg style="margin-bottom: -8px" height="24px" viewBox="0 0 24 24" width="24px"><rect fill="#f2f2f2" height="24" rx="3" width="24"></rect><path d="m12 15.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5.675-1.5 1.5-1.5zm0-2c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5 1.5.675 1.5 1.5-.675 1.5-1.5 1.5zm0-5c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5 1.5.675 1.5 1.5-.675 1.5-1.5 1.5z" fill="#818b90"></path></svg></span></span></strong><span data-translate="integrations.whatsapp.qrCodeWa.instruction4">ou </span><strong><span dir="ltr" class="selectable-text invisible-space copyable-text"><span data-translate="integrations.whatsapp.qrCodeWa.instruction5">Configura\xE7\xF5es </span><span class="_3CSsZ"><svg style="margin-bottom: -8px" width="24" height="24" viewBox="0 0 24 24"><rect fill="#F2F2F2" width="24" height="24" rx="3"></rect><path d="M9.34 8.694a4.164 4.164 0 0 0-1.606 3.289c0 1.338.63 2.528 1.61 3.292l-1.46 2.527a7.065 7.065 0 0 1-3.052-5.82c0-2.41 1.206-4.54 3.048-5.816l1.46 2.528zm6.713 2.859c-.217-2.079-1.992-3.739-4.148-3.739-.578 0-1.128.116-1.628.329L8.819 5.617a7.042 7.042 0 0 1 3.086-.704c3.76 0 6.834 2.958 7.059 6.64h-2.91zm-1.065.43a3.083 3.083 0 1 1-6.166 0 3.083 3.083 0 0 1 6.166 0zm-6.164 6.364l1.458-2.523a4.153 4.153 0 0 0 1.623.322 4.154 4.154 0 0 0 4.12-3.524h2.922a7.062 7.062 0 0 1-7.042 6.426c-1.105 0-2.15-.25-3.081-.7zm11.197-7.21a7.88 7.88 0 0 0-.404-1.824l.286-.12a.527.527 0 0 0-.403-.973l-.29.12a8.176 8.176 0 0 0-1.197-1.77l.231-.23a.526.526 0 1 0-.744-.744l-.234.234a8.17 8.17 0 0 0-1.775-1.18l.13-.31a.526.526 0 1 0-.972-.403l-.12.313a8.463 8.463 0 0 0-1.995-.405v-.35A.533.533 0 0 0 12 2.97a.533.533 0 0 0-.535.526v.338a8.02 8.02 0 0 0-2.173.416l-.13-.313a.526.526 0 0 0-.972.402l.129.311a8.171 8.171 0 0 0-1.775 1.18l-.235-.235a.526.526 0 0 0-.743.744l.23.231A8.175 8.175 0 0 0 4.6 8.34l-.29-.12a.526.526 0 0 0-.403.971l.285.122a7.882 7.882 0 0 0-.404 1.824h-.322a.533.533 0 0 0-.526.534c0 .29.235.535.526.535h.28c.02.831.166 1.624.418 2.378l-.257.1a.523.523 0 1 0 .402.968l.252-.105a8.17 8.17 0 0 0 1.191 1.797l-.187.187a.526.526 0 1 0 .744.743l.184-.183a8.173 8.173 0 0 0 1.792 1.208l-.096.231a.526.526 0 1 0 .972.403l.096-.23c.698.24 1.436.387 2.208.428v.243c0 .29.244.526.535.526.29 0 .534-.235.534-.526v-.253a8.012 8.012 0 0 0 2.03-.417l.09.229a.523.523 0 1 0 .967-.403l-.096-.231a8.172 8.172 0 0 0 1.792-1.208l.184.183a.526.526 0 1 0 .743-.744l-.187-.186a8.174 8.174 0 0 0 1.191-1.798l.252.104a.526.526 0 1 0 .403-.971l-.257-.095a8.074 8.074 0 0 0 .417-2.378h.281c.29 0 .526-.244.526-.535a.533.533 0 0 0-.526-.534h-.323z" fill="#818B90"></path></svg></span></span></strong><span data-translate="integrations.whatsapp.qrCodeWa.instruction6">e selecione</span> <strong data-translate="integrations.whatsapp.qrCodeWa.instruction7">WhatsApp Web</strong></span></li><li class="_2eNdO" style="margin-top: 18px" data-translate="integrations.whatsapp.qrCodeWa.instruction8">Aponte seu telefone para esta tela para capturar o c\xF3digo</li></ol></div><div class="col-md-4"><div class="qr-box"><img src="{{vm.whatsappModalConf.whatsappQRCode}}" alt=""><div ng-if="!vm.isLoading && vm.whatsappModalConf && vm.whatsappModalConf.whatsappWaitTooLong" class="qr-overlay"></div><div align="center" ng-if="vm.isLoading && (!vm.whatsappModalConf.whatsappWaitTooLong && !vm.whatsappModalConf.whatsappQRCode)" style="padding-top: 25%"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div><div ng-if="!vm.isLoading && vm.whatsappModalConf && vm.whatsappModalConf.whatsappWaitTooLong" ng-click="vm.refreshWhatsappQrCode()" style="background-color: #53BCA6; position: inherit;  border-radius: 50%; width: 194px;\n                height: 194px;   margin-top: -194px; outline:0"><span><svg style="margin-top: 40px;\n                        margin-left: 75px" width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="ic_refresh_black_24px" fill="#FFF" fill-rule="nonzero"><path d="M35.3 12.7C32.4 9.8 28.42 8 24 8 15.16 8 8.02 15.16 8.02 24S15.16 40 24 40c7.46 0 13.68-5.1 15.46-12H35.3c-1.64 4.66-6.08 8-11.3 8-6.62 0-12-5.38-12-12s5.38-12 12-12c3.32 0 6.28 1.38 8.44 3.56L26 22h14V8l-4.7 4.7z" id="Shape"></path></g></g></svg><p style="text-align: center; color: white; font-size: larger" data-translate="integrations.whatsapp.qrCodeWa.tooLong">Clique para carregar o c\xF3digo QR novamente</p></span></div></div></div><div class="row" style="margin-top: 20px"><div class="col-md-12" style="height: 40px"><a style="padding: 0px 0px 0 20px; color: #009688" href="https://faq.whatsapp.com/faq/web/28080003/" class="_1rQYj" target="_blank" data-translate="integrations.whatsapp.qrCodeWa.helpToStart">Precisa de ajuda para come\xE7ar?</a></div></div><div ng-show="false" class="row"><div class="col-md-12 justify-content-center" style="text-align: center"><video autoplay="" style="width: 30% !important" controls="" controlslist="nodownload"><source src="../../../content/images/wa-steps.mp4" type="video/mp4"></video></div></div></div><div ng-if="vm.currentStep === 1" id="tab-pages" class="active"><div ng-include="\'app/integrations/whatsapp/whatsapp-message.html\'"></div></div><div ng-if="vm.currentStep === 2" id="tab-pages" class="active"><div ng-include="\'app/integrations/whatsapp/whatsapp-clients.html\'"></div></div><div ng-if="vm.currentStep === 3" id="tab-pages" class="active"><div class="col-md-8"><ol class="_3oE3H"><li class="_2eNdO" data-translate="integrations.whatsapp.qrCodeWa.confirmation.instruction1">N\xE3o desconecte o celular da internet</li><li class="_2eNdO" style="margin-top: 18px" data-translate="integrations.whatsapp.qrCodeWa.confirmation.instruction2">N\xE3o inicie o WhatsApp em outro lugar que n\xE3o sej\xE1 o aplicativo do WhatsApp</li><li class="_2eNdO" style="margin-top: 18px" data-translate="integrations.whatsapp.qrCodeWa.confirmation.instruction3">N\xE3o finilizar a sess\xE3o do WhatsApp que aparecer\xE1 no seu celular</li></ol></div></div></div><div class="modal-footer" style="border: 0px !important; text-align: center; padding-top: 0%"><div class="first-steps-home-screen row" aling="center" id="steps-fb"><div class="col-lg-12 scaled" style="margin-top: -55px"><ul><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 0}"></div></li><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 1 || vm.selectedBusinessPage, \'inactive-progress-step\': vm.currentStep < 1 }"></div></li><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 2 || vm.facebook.catalog.id, \'inactive-progress-step\': vm.currentStep < 2 }"></div></li><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 3 || vm.facebook.catalog.id, \'inactive-progress-step\':vm.currentStep < 3 }"></div></li></ul></div></div><button type="button" id="btnConfirm" data-translate="integrations.facebookBusiness.buttons.next" class="btn btn-primary ksc-btn-next-padding" ng-click="vm.next()" ng-show="vm.currentStep < 3" ng-disabled="vm.nextDisabled()">Pr\xF3ximo</button> <button type="button" id="btnConfirm" data-translate="integrations.facebookBusiness.buttons.finalize" class="btn btn-primary ksc-btn-next-padding" ladda="vm.isSending" ng-click="vm.sendMessage()" ng-show="vm.currentStep === 3">Criar Campanha</button><div class="col-md-12" style="padding-top: 2%"><a ng-show="vm.previousDisabled()" ng-click="vm.previous()"><span data-translate="integrations.facebookBusiness.buttons.previous"></span></a></div></div>');
$templateCache.put('app/integrations/whatsapp/whatsapp-resume-detail.html','<div class="modal-body" style="min-height: 450px"><div class="row"><div class="col-md-12" style="text-align: center; padding-bottom: 3%"><h2>{{ \'integrations.whatsapp.relogin\' | translate }}</h2></div></div><div class="row"><div class="col-md-12" style="text-align: center"><img src="{{vm.whatsappModalConf.whatsappQRCode}}" alt=""><div ng-if="!vm.isLoading && vm.whatsappModalConf && vm.whatsappModalConf.whatsappWaitTooLong" class="qr-overlay"></div><div ng-if="vm.isLoading && (!vm.whatsappModalConf.whatsappWaitTooLong && !vm.whatsappModalConf.whatsappQRCode)" style="padding-top: 25%"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div></div></div><div class="modal-footer" style="border: 0px !important; text-align: center; padding-top: 0%"><button type="button" id="btnConfirm" data-translate="integrations.facebookBusiness.buttons.next" class="btn btn-primary ksc-btn-next-padding" ng-click="vm.next()" ng-show="vm.currentStep < 3" ng-disabled="vm.nextDisabled()">Prox\xEDmo</button></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div class="middle-box text-center loginscreen animated fadeInDown"><div class="col-xs-12" style="margin-left: 5px; margin-bottom: 30px"><img class="img-responsive" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/showkase-plans-m.png"></div><div class="col-md-12"><h1 data-translate="error.title" style="font-size: 20px !important">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div><a class="btn btn-sm btn-primary btn-block" ui-sref="home">Back to home</a></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/error/get-support-contact.html','<div class="middle-box text-center loginscreen animated fadeInDown" style="margin-top: 50px"><div class="col-xs-12" style="margin-left: 5px; margin-bottom: 30px"><img class="img-responsive" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/logo-login.png"></div><div class="col-md-12"><h1 data-translate="error.title" style="font-size: 20px !important">Error Page!</h1><div class="alert alert-danger" data-translate="error.expiredAccount" ng-if="vm.hasMoipPlanAndIsExpired()"></div><div class="alert alert-danger" data-translate="error.paymentInAnaliyse" ng-if="vm.statusPaymentIsAnalyzing()"></div><div class="alert alert-danger" data-translate="error.403" ng-if="!vm.statusPaymentIsAnalyzing() && !vm.hasMoipPlanAndIsExpired()"></div><a class="btn btn-sm btn-primary btn-block" ui-sref="home" ng-if="!vm.statusPaymentIsAnalyzing() && !vm.hasMoipPlanAndIsExpired()">Back to home</a></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-jhipster.png" alt="logo"> <span data-translate="global.title">Showcase</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="authority" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.authority">Authority</span></a></li><li ui-sref-active="active"><a ui-sref="profile" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.profile">Profile</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="USER_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="gateway" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-road"></span>&nbsp; <span data-translate="global.menu.admin.gateway">Gateway</span></a></li><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/store/components/content-form.html','<div class="form-header hidden-xs"><div class="app-container"><div class="sub-header"><h1 data-translate="store-management.first.header.title">Create Store</h1><span><a data-translate="store-management.first.header.home"></a>/<a data-translate="store-management.first.header.login"></a>/<a data-translate="store-management.first.header.store-create"></a></span></div><div class="icon-badcrum"><div class="store-info-step"><div class="store-info-step-icons"><div class="step1"><div class="icon-step1"><span style="width: 100%; height: 3px; color: transparent"></span> <img ng-show="$state.current.name == \'store-info\'" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/current-step-information.png"> <img ng-show="$state.current.name !== \'store-info\'" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/completed-step-information.png"> <span style="width: 100%; height: 3px" ng-class="$state.current.name ==\'store-info\' ? \'line-not-fill\' : \'line-fill\'"></span></div><span class="info page-external-font"><span data-translate="store-management.first.header.first-step" style="font-size: 0.9em; font-family: Roboto !important">Information</span></span></div><span style="width: 90px; height: 3px; margin-top: 18.5px" ng-class="$state.current.name ==\'store-info\' ? \'line-not-fill\' : \'line-fill\'"></span> <span style="width: 90px; height: 3px; margin-top: 18.5px" ng-class="$state.current.name ==\'store-logo\' ||  $state.current.name ==\'store-info\'? \'line-not-fill\' : \'line-fill\'"></span><div class="step3"><div class="icon-step3"><span style="width: 100%; height: 3px" ng-class="$state.current.name !== \'store-point\' ? \'line-not-fill\' : \'line-fill\'"></span> <img ng-show="$state.current.name !== \'store-point\'" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/initial-step-points.png"> <img ng-show="$state.current.name == \'store-point\'" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/current-step-points.png"> <span style="width: 100%; height: 3px; color: transparent"></span></div><span class="points page-external-font"><span data-translate="store-management.first.header.third-step" style="font-size: 0.9em; font-family: Roboto !important">Store points</span></span></div></div></div></div></div></div><!-- Main view  --><div ng-if="$state.current.name == \'store-info\' && !isMobile" class="info-item info-title"><div class="app-container"><h1 data-translate="store-management.first.title">Criar uma loja nunca foi t\xE3o simples</h1></div></div><div class="form-content form-content-steps-mobile" ui-view="content" ng-cloak><div class="app-container"><div class="row no-margin form-group" style="padding-top: 5px"><div class="col-lg-6" style="margin-top: 20px"><div ui-view="form-info" ng-cloak></div></div><div class="col-lg-6"><form name="storeForm" novalidate style="padding: 10px 10px"><div ui-view="form-views" ng-cloak></div></form></div></div><div class="row no-margin form-group" id="forward-buttons"><div class="col-xs-12 col-md-4 btn-steps-content-form-group"><a ng-if="$state.current.name == \'store-point\'" ui-sref="store-info" class="btn-steps-back-form-mobile pull-left red-color-information forward-step-button"><i class="icon-ksc-back"></i><span data-translate="store-management.first.button.buttonBack">Back</span></a></div><div class="col-xs-12 col-md-4 col-md-offset-4 form-group btn-steps-content-form-group"><button type="submit" ng-if="$state.current.name == \'store-info\'" ng-click="goToStorePoint(storeForm)" class="pull-right red-color-information btn-primary btn btn-steps-content-form-mobile" style="color:#FFFFFF"><span data-translate="store-management.first.button.buttonNext">Next</span><i class="icon-ksc-next"></i></button> <button ladda="isSaving" data-style="slide-left" ng-disabled="submitted && markers.length == 0" ng-click="saveStore(storeForm)" ng-disabled="storeForm.$invalid" ng-if="$state.current.name == \'store-point\'" class="btn btn-primary pull-right btn-steps-content-form-mobile"><span data-translate="store-management.first.header.store-create">Create Store</span><i class="icon-ksc-store" style="font-size: 1.1em" aria-hidden="true">&nbsp;</i></button></div></div></div></div>');
$templateCache.put('app/account/checkout/default/content.html','<div class="container-fluid" style="padding: 0px"><!-- topnavbar header --><div class="app-header" ng-include="\'app/account/checkout/default/topnavbar.html\'"></div><!-- Main view  --><div class="ibox float-e-margins" ui-view="content" ng-cloak></div></div>');
$templateCache.put('app/account/checkout/default/footer.html','<div class="flex-footer-copyright"><strong>Copyright</strong>&nbsp;{{hubNameUpper}} &copy; 2022</div><div class="flex-footer-version"><strong>&nbsp;{{VERSION}}</strong>.</div>');
$templateCache.put('app/account/checkout/default/topnavbar.html','<div class="app-container" style="height: 80px" ng-style="{\'background-color\': \'{{hubStyle.data.mainColor}}\'}"><div class="logo"><img class="img-responsive" style="width: 180px" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/logo.png"></div><div uib-dropdown ng-controller="TopNavbarController as vm"><a id="logout" title="Options"><i uib-dropdown-toggle="" class="glyphicon glyphicon-option-vertical" style="color: white; font-size: 2.2em"></i><ul uib-dropdown-menu class="animated flipInX m-t-xs"><li><a ng-click="vm.giftCardCheckout()" data-translate="global.menu.account.showkaseCard">ShowKase Card</a></li><li><a ng-click="vm.logout()" data-translate="global.menu.account.logout">Logout</a></li></ul></a></div></div>');
$templateCache.put('app/account/checkout/gift-card/gift-card-checkout.html','<div class="wrapper wrapper-content ng-scope"><div class="row"><div class="col-xs-12" style="text-align: center; margin-bottom: 25px"><h2><span>Tenha acessos completo a sua nova experi\xEAncia digital com a Showkase</span></h2><p><span>Utilize o c\xF3digo do seu Showkase Card e aproveite todos os benef\xEDcios exclusivos da plataforma com acesso completo</span></p></div></div><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content showcase-box-content"><div class="row"><div class="col-xs-6 b-r"><form class="" ng-submit="vm.validateGiftCard()" id="vm.formGiftValidate" name="vm.formGiftValidate" novalidate role="form"><div><div class="panel-body"><div class="row"><div class="col-md-12 col-sm-12 col-xs-12 form-group"><label class="required" for="cnpj">CNPJ</label><input id="cnpj" type="text" name="cnpj" class="form-control" ng-model="vm.giftCard.cnpj" ng-cnpj ui-mask="99.999.999/9999-99" required><div class="help-block-div" ng-show="vm.formGiftValidate.cnpj.$invalid && vm.formGiftValidate.cnpj.$touched"><p class="help-block form-invalid-field" ng-show="vm.formGiftValidate.cnpj.$invalid && !vm.formGiftValidate.cnpj.$error.required" data-translate="entity.validation.cnpj">This field CNPJ is invalid.</p><p class="help-xblock form-invalid-field" ng-show="vm.formGiftValidate.cnpj.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><div class="col-md-12 col-sm-12 col-xs-12 form-group"><label class="required" for="token" data-translate="gift-card.gift-code">Token</label><input id="token" name="token" type="text" class="form-control" ng-model="vm.giftCard.token" ng-maxlength="6" ng-minlength="6" required><div class="help-block-div" ng-show="vm.formGiftValidate.token.$invalid && vm.formGiftValidate.token.$touched"><p class="help-xblock form-invalid-field" ng-show="vm.formGiftValidate.token.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formGiftValidate.token.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="6">This field cannot be longer than 6 characters.</p><p class="help-block form-invalid-field" ng-show="vm.formGiftValidate.token.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6">This field cannot be longer than 6 characters.</p></div></div></div></div></div><div class="row"><div class="col-xs-3"></div><div class="col-xs-6"><button ladda="vm.isSending" type="submit" class="btn btn-primary btn-block ng-binding" data-style="slide-left"><span data-translate="gift-card.apply">Apply</span></button></div><div class="col-xs-3"></div></div></form></div><div class="col-xs-6"><div class="col-xs-12 showcase-box-noflyer m-t-md" style="color: lightgrey"><i class="fa fa-gift" style="font-size: 12em; margin-top: 0px"></i><h1 data-translate="gift-card.validate-data" class="ng-scope"></h1></div></div></div></div></div></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div class="container-fluid" style="padding-left: 0px; padding-right: 0px"><div ng-include="\'app/inspinia/components/common/topheader.html\'"></div><div class="first-step middle-box loginscreen animated fadeInDown"><div class="row" style="margin-top: 30%" ng-show="vm.success" align="center"><div class="col-xs-12"><span class="icon-ok page-external-top-icon" style="color: #388E3C!important"></span><h2 class="page-external-font" data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</h2></div></div><div class="row" style="margin-top: 30%" ng-show="vm.error" align="center"><div class="col-xs-12"><span class="fa fa-times page-external-top-icon" style="color: red !important; font-size: 10em !important"></span><h2 class="page-external-font" data-translate="reset.finish.messages.error" translate-compile>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</h2></div></div><div class="row" style="margin-top: 30%" ng-show="!vm.success && !vm.error"><div class="col-xs-12 col-md-12 col-sm-12 col-lg-12 text-center"><span class="fa fa-key" style="color: #A7AAAD; font-size: 12em"></span><h2 data-translate="reset.finish.title" class="page-external-font page-external-header">Reset password</h2></div><div class="col-xs-12"><div class="alert alert-danger text-center" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success && !vm.error" name="form" role="form" novalidate ng-submit="vm.finishReset()"><div class="row"><div class="col-xs-12 col-md-12 col-sm-12 col-lg-12 form-group"><input type="password" class="form-control page-external-input-2 external-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div class="help-block-div" ng-show="form.password.$dirty && form.password.$touched && form.password.$invalid && !form.password.$pristine"><p class="help-block form-invalid-field" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block form-invalid-field" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block form-invalid-field" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div></div><div class="col-xs-12 col-md-12 col-sm-12 col-lg-12 form-group"><input type="password" class="form-control page-external-input-2 external-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div class="help-block-div" ng-show="form.confirmPassword.$dirty && form.confirmPassword.$touched && form.confirmPassword.$invalid && !form.confirmPassword.$pristine"><p class="help-block form-invalid-field" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block form-invalid-field" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block form-invalid-field" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div><div class="help-block-div" ng-show="!form.confirmPassword.$pristine && !form.confirmPassword.$invalid && (vm.password != vm.confirmPassword) && form.$submitted"><p class="help-block form-invalid-field" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</p></div></div><div class="col-xs-12 col-md-12 col-sm-12 col-lg-12 form-group text-center"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary page-external-button" data-translate="reset.finish.form.button">Reset Password</button></div></div></form></div></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="container-fluid registration-container" style="padding-left: 0px; padding-right: 0px"><div ng-include="\'app/inspinia/components/common/topheader.html\'"></div><div class="first-step middle-box text-center loginscreen animated fadeInDown"><div class="row" style="margin-top: 20%" ng-hide="vm.success"><div class="col-xs-12 email-reset-request-content text-reset-request" aling="center"><span class="icon-reset-request-admin icon-ksc-finaluser-send page-external-top-icon" style="color: #A7AAAD; font-size: 12em"></span><h2 class="page-external-font page-external-header" data-translate="reset.request.title" style="font-size: 3.8em; font-family: \'Roboto\'">Forgot your password?</h2><p class="page-external-font" style="font-size: 1.2em" data-translate="reset.request.messages.info">Enter your e-mail address and press the button to continue.</p><form ng-show="!vm.success" name="resetForm" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><div class="input-group"><input type="email" class="form-control page-external-input-2 external-control reset-request-input-style" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" required> <span class="input-group-btn" style="font-size: unset; line-height: 1"><button class="btn btn-primary page-external-button" ng-disabled="resetForm.$invalid" style="padding: 10px 30px 9px 30px; height: 40px !important; line-height: 1"><span data-translate="reset.request.form.button" style="line-height: 1">Send</span></button></span></div><div ng-show="vm.errorEmailNotExists" class="pull-left"><p class="help-block form-invalid-field" data-translate="reset.request.messages.notfound"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</p></div></div></form></div></div><div class="row" style="margin-top: 20%" ng-show="vm.success"><div class="col-xs-12 email-reset-request-content text-reset-request"><span class="icon-reset-request-admin icon-ok page-external-top-icon" style="color: #9aca5b !important"></span><h2 class="page-external-font page-external-header" data-translate="reset.request.messages.check-email" style="font-size: 2.8em; font-family: \'Roboto\'">Sent! Check your e-mail.</h2><p class="page-external-font" style="font-size: 1.2em" data-translate="reset.request.messages.success">Check your email soon to access the password reset link.</p></div><div class="col-xs-12"><button class="btn btn-primary page-external-button" style="padding: 7px 50px" ui-sref="home"><span>OK</span></button></div></div></div></div>');
$templateCache.put('app/account/settings/settings-tabs/analytics.html','<div class="col-sm-12" style="padding: 0px 0px 0px 15px"><h2 data-translate="settings.form.analytics" style="font-size: 20px; margin-top: 0px"></h2><br></div><div class="col-sm-12"><div class="full-height-scroll" full-scroll><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th><span data-translate="settings.analytics.storeNameTitle">Store</span></th><th><span data-translate="settings.analytics.contentName">Analytics</span></th></tr></thead><tbody><tr ng-repeat="store in vm.stores"><td class="col-sm-4"><i class="icon-ksc-store"></i> <span ng-bind="store.nickname"></span></td><td class="col-sm-8"><div class="col-sm-6"><div class="input-group m-b"><span class="input-group-addon" style="background: #ededed; color:#818181"><i class="fa fa-facebook-square" aria-hidden="true"></i> - Pixel </span><input id="fbPixel" type="text" name="fbPixel" class="form-control" ng-model="store.fbPixel"></div></div><div class="col-sm-6"><div class="input-group m-b"><span class="input-group-addon" style="background: #ededed; color:#818181"><i class="fa fa-google" aria-hidden="true"></i> - ID </span><input id="glAnalytics" type="text" name="glAnalytics" class="form-control" ng-model="store.glAnalytics"></div></div></td></tr></tbody></table></div></div></div><div class="col-xs-12"><button type="submit" ladda="vm.isSaving" data-ng-disabled="vm.islocked" ng-disabled="vm.isSaving || !analyticsDataForm.$valid" class="btn btn-primary pull-right" ng-click="vm.saveAnalyticsData()" data-translate="settings.form.button">Save</button></div>');
$templateCache.put('app/account/settings/settings-tabs/my-hosts.html','<div class="col-sm-12" style="padding: 0px 0px 0px 15px"><h2 data-translate="settings.form.myHosts" style="font-size: 20px; margin-top: 0px"></h2><br></div><div class="col-sm-12"><div class="full-height-scroll" full-scroll><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th><span data-translate="settings.myHosts.storeNameTitle">Store</span></th><th><i tooltip-placement="bottom" uib-tooltip="{{ \'settings.myHosts.redirectQuestionMark\' | translate}}" class="fa fa-question-circle"></i> <span data-translate="settings.myHosts.storeDomainTitle">Dom\xEDnio</span></th><th><i tooltip-placement="bottom" uib-tooltip="{{ \'settings.myHosts.fbActivation\' | translate}}" class="fa fa-question-circle"></i> <span data-translate="settings.myHosts.storeFbActivation">Compras no Instagram</span></th></tr></thead><tbody><tr ng-repeat="store in vm.stores"><td class="col-sm-4"><i class="icon-ksc-store"></i> <span ng-bind="store.nickname"></span></td><td class="col-sm-5"><div class="input-group m-b"><span class="input-group-addon" style="background: #ededed; color:#818181">https://www.</span> <input id="redirectURL" type="text" name="redirectURL" class="form-control" ng-model="store.redirectURL"></div></td><td class="col-sm-3"><div class="input-group" style="width: 100%"><input id="fbActivation" type="text" name="fbActivation" class="form-control" ng-model="store.fbActivation"></div></td></tr></tbody></table></div></div></div><div class="col-xs-12"><button type="submit" ladda="vm.isSaving" data-ng-disabled="vm.islocked" ng-disabled="vm.isSaving || !urlRedirectDomainDataForm.$valid" class="btn btn-primary pull-right" ng-click="vm.saveURLRedirectDomainsData()" data-translate="settings.form.button">Save</button></div>');
$templateCache.put('app/account/settings/settings-tabs/notifications.html','<div class="col-sm-12" style="padding: 0px 0px 0px 15px"><h2 data-translate="settings.tabs.notifications" style="font-size: 20px; margin-top: 0px"></h2><br></div><div class="col-sm-12"><div class="full-height-scroll" full-scroll><div class="table-responsive"><div class="col-sm-12 col-md-6"><md-switch ng-model="vm.webNotifications" ng-change="vm.changeWebNotifications()"><span>{{\'settings.notifications.sound\' | translate}}</span></md-switch><md-switch ng-model="vm.systemNotifications" ng-change="vm.changeSystemNotifications()"><span>{{\'settings.notifications.system\' | translate}}</span></md-switch><md-switch ng-model="vm.emailNotifications" ng-change="vm.changeEmailNotifications()"><span>{{\'settings.notifications.email\' | translate}}</span></md-switch></div></div></div></div>');
$templateCache.put('app/account/settings/settings-tabs/personal-data.html','<div class="col-sm-12" style="padding: 0px 0px 0px 15px"><h2 data-translate="settings.form.person-information" style="font-size: 20px; margin-top: 0px"></h2><br></div><div class="form-group col-sm-3"><label class="control-label required" for="login" data-translate="settings.form.login">Login</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'settings.form.login.placeholder\' | translate}}" ng-model="vm.settingsAccount.login" ng-minlength="1" ng-maxlength="50" required maxlength="50"></div><div class="form-group col-sm-3"><label class="control-label required" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="personalDataForm.$submitted && personalDataForm.firstName.$invalid"><p class="help-block" ng-show="personalDataForm.firstName.$error.required" data-translate="settings.store.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="personalDataForm.firstName.$error.minlength" data-translate="settings.store.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="personalDataForm.firstName.$error.maxlength" data-translate="settings.store.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group col-sm-3"><label class="control-label required" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="personalDataForm.$submitted && personalDataForm.lastName.$invalid"><p class="help-block" ng-show="personalDataForm.lastName.$error.required" data-translate="settings.store.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="personalDataForm.lastName.$error.minlength" data-translate="settings.store.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="personalDataForm.lastName.$error.maxlength" data-translate="settings.store.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group col-sm-3"><label class="control-label required" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="personalDataForm.$submitted && personalDataForm.email.$invalid"><p class="help-block" ng-show="personalDataForm.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="personalDataForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="personalDataForm.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="personalDataForm.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group col-sm-4"><label class="control-label required" for="dateOfBirth" data-translate="settings.form.dateOfBirth">Date of birth</label><div class="input-group date" id="dateOfBirth"><input type="text" name="dateOfBirth" class="form-control inputDate external-control" autocomplete="off" ng-model="vm.settingsAccount.dateOfBirth" ui-mask-placeholder ui-mask="{{vm.maskLocale}}" placeholder="{{\'global.form.dateOfBirth\' | translate}}"> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><div class="help-block-div" ng-show="personalDataForm.dateOfBirth.$invalid && personalDataForm.$submitted"><p class="help-block form-invalid-field" ng-show="personalDataForm.dateOfBirth.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-sm-4"><label class="control-label required" for="phone" data-translate="settings.form.phone">Phone</label><input type="tel" name="phone" id="phone" class="form-control" ng-model="vm.settingsAccount.phone" intl-tel-input required><div class="help-block-div" ng-show="personalDataForm.phone.$invalid && personalDataForm.$submitted"><p class="help-block form-invalid-field" ng-show="personalDataForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="personalDataForm.phone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div><div class="form-group col-sm-4"><label for="langKey required" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><div class="col-sm-12"><div class="full-height-scroll" full-scroll><div class="table-responsive"><div class="col-sm-12 col-md-6"><md-switch ng-model="vm.settingsAccount.twoFactorAuth"><span>{{\'settings.personalData.twoFactorAuth\' | translate}}</span></md-switch></div></div></div></div><div class="col-xs-12"><button ladda="vm.isSaving" ng-disabled="vm.isSaving || !personalDataForm.$valid" class="btn btn-primary pull-right" ng-click="vm.savePersonalData(personalDataForm)" data-translate="settings.form.button">Save</button></div>');
$templateCache.put('app/account/settings/settings-tabs/shipping-settings.html','<div class="col-sm-12" style="padding: 0px 0px 0px 15px"><h2 data-translate="settings.shipping.title" style="font-size: 20px; margin-top: 0px"></h2><br></div><div class="col-sm-6"><div class="col-sm-12" style="padding-bottom: 4%"><a href="https://melhorenvio.com.br/p/Q2fsSCvKcz/" target="_blank"><img src="/content/images/melhor_envio.png" border="0" width="150px" height="100%"></a></div><h3 data-translate="settings.shipping.stepTitle"></h3><p data-translate="settings.shipping.step1"></p><p data-translate="settings.shipping.step2"></p><p data-translate="settings.shipping.step3"></p><p data-translate="settings.shipping.step4"></p><p data-translate="settings.shipping.step5"></p><div class="col-sm-12" style="padding-bottom: 4%; padding-left: 0px"><a type="button" ng-href="{{vm.links.createAccountLink}}" class="btn btn-primary" target="_blank" ng-hide="vm.hasShipping" style="margin-right: 3%">{{ \'settings.shipping.createButtonTitle\' | translate }} </a><a type="button" ng-click="vm.authShipping()" class="btn btn-primary" ng-hide="!vm.hasShipping">{{ \'settings.shipping.connectButtonTitle\' | translate }} </a><a class="btn btn-primary" disabled="disabled" ng-hide="vm.hasShipping">Conectado</a></div></div><div class="col-sm-6"><h3 data-translate="settings.shipping.melhorEnvioTitle" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.shipping.melhorEnvioDescription"></p><!-- <p style="font-size: 15px; margin-bottom: 2%;" data-translate="settings.paymentConfiguration.wirecardDescription2"></p> --> <a ng-href="https://melhorenvio.com.br/p/Q2fsSCvKcz/" target="_blank">{{ \'settings.store.payments.tabs.wirecard.knowMore\' | translate }}</a></div></div><div class="col-sm-12" style="text-align: center; padding-bottom: 2%; padding-top: 2%"><!-- <h4 data-translate="settings.paymentConfiguration.showkaseDescription"></h4> --></div>');
$templateCache.put('app/admin/bag/modal-filter-bag/bag-filter-modal.html','<style>.sub-title {\n        font-size: 1.0em;\n    }\n\n    md-select-menu md-content {\n        -webkit-overflow-scrolling: fixed !important;\n    }\n\n    .md-select-menu-container {\n        z-index: 3000 !important;\n    }\n\n    .custom-md-input md-input-container {\n        display: inherit;\n        margin: unset;\n        border: 0;\n    }\n\n    .custom-md-input md-select.md-default-theme .md-select-value,\n    md-select .md-select-value {\n        border-color: rgba(0, 0, 0, 0.12) !important;\n        border: 1px;\n        border-style: solid;\n        padding-left: 8px;\n    }\n\n    .custom-select[multiple] .md-select-value span:first-child {\n        visibility: collapse;\n    }\n\n    .custom-select[multiple] .md-select-value .md-text {\n        display: inline-block !important;\n        visibility: visible;\n        background-color: rgb(224, 224, 224);\n        border-radius: 6px;\n        padding: 3px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected],\n    md-select-menu md-content md-option[selected] {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .md-select-value {\n        padding: 5px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected]:focus,\n    md-select-menu md-content md-option[selected]:focus {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-checkbox-enabled.md-default-theme[selected] .md-icon,\n    .md-checkbox-enabled[selected] .md-icon {\n        background-color: var(--main-color) !important;\n    }\n\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\n    md-select-menu md-content md-option:not([disabled]):focus,\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\n    md-select-menu md-content md-option:not([disabled]):hover {\n        background: none;\n    }\n\n    .highlight {\n        background: #f3f3f4;\n        padding: 5px;\n        display: inline-block;\n        color: var(--main-color-dark);\n        border-radius: 10px;\n        padding-bottom: 2px;\n        padding-top: 2px;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    md-select-menu {\n        margin-top: 50px;\n        width: 150.674px !important;\n        margin-left: 39px;\n    }\n\n    .remove-dropdown {\n        display: none !important;\n    }\n\n    .empty-list md-select-menu {\n        margin-top: 42px;\n        width: 192.674px !important;\n        margin-left: -1px;\n    }\n\n    md-select.md-default-theme[disabled] .md-select-value,\n    md-select[disabled] .md-select-value {\n        background-image: none !important;\n    }\n\n    .modal-options-body {\n        position: relative;\n        padding: 15px;\n    }\n\n    .modal-header {\n        border-bottom: 0;\n    }\n\n    .md-select-value {\n        border-bottom-width: 1px !important;\n        padding-bottom: 5px !important;\n    }</style><div id="modal" class="main-modal"><div id="filter-flyer-modal" class="modal-header"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h1 class="modal-title">{{\'bag.filters.modalTitle\' | translate}}</h1><span class="sub-title">{{\'bag.filters.modalSubTitle\' | translate}}</span></div><div class="modal-options-body"><div class="row"><div class="col-md-12"><div class="col-md-12"><div class="form-group col-md-4 col-sm-12"><span data-translate="flyers.home.categories">Categories</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select ng-if="vm.categories.length" class="custom-select-value" ng-model="vm.filters.categories" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.categories)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="category in vm.categories" ng-value="category">{{category.title}}</md-option></div></md-select><md-select ng-if="!vm.categories.length" class="custom-select-value" ng-model="vm.filters.categories" disabled="disabled" placeholder="{{ \'bag.form.messages.empty-filter-list\' | translate }}"></md-select></md-input-container></div></div><div class="form-group col-md-4 col-sm-12"><span data-translate="global.menu.admin.customers">Customers</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select ng-if="vm.customers.length" class="custom-select-value" ng-model="vm.filters.customers" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.customers)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="customer in vm.customers" ng-value="customer">{{ customer.label }}</md-option></div></md-select><md-select ng-if="!vm.customers.length" class="custom-select-value" ng-model="vm.filters.customers" disabled="disabled" placeholder="{{ \'bag.form.messages.empty-filter-list\' | translate }}"></md-select></md-input-container></div></div><div class="form-group col-md-4 col-sm-12"><span data-translate="flyers.home.colors">Colors</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select ng-if="vm.colors.length" class="custom-select-value" ng-model="vm.filters.colors" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.colors)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="color in vm.colors" ng-value="color">{{color.label}}</md-option></div></md-select><md-select col-md-3 ng-if="!vm.colors.length" class="custom-select-value" ng-model="vm.filters.colors" disabled="disabled" placeholder="{{ \'bag.form.messages.empty-filter-list\' | translate }}"></md-select></md-input-container></div></div></div><div class="col-md-12"><div class="form-group col-md-4 col-sm-12"><span data-translate="flyers.home.brands">Brands</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select ng-if="vm.brands.length" class="custom-select-value" ng-model="vm.filters.brands" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.brands)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="brand in vm.brands | orderBy:\'name\'" ng-value="brand">{{brand.name}}</md-option></div></md-select><md-select ng-if="!vm.brands.length" class="custom-select-value" ng-model="vm.filters.brands" disabled="disabled" placeholder="{{ \'bag.form.messages.empty-filter-list\' | translate }}"></md-select></md-input-container></div></div><div class="form-group col-md-4 col-sm-12"><span data-translate="flyers.new.form.gender.title">Gender</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select ng-if="vm.genders.length" class="custom-select-value" ng-model="vm.filters.genders" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.genders)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="gender in vm.genders" ng-value="gender">{{( gender.label )| translate}}</md-option></div></md-select><md-select ng-if="!vm.genders.length" class="custom-select-value" ng-model="vm.filters.genders" disabled="disabled" placeholder="{{ \'bag.form.messages.empty-filter-list\' | translate }}"></md-select></md-input-container></div></div><div class="form-group col-md-4 col-sm-12"><span>{{ vm.storeCategory == FASHION ? \'flyers.home.sizes\' : \'flyers.home.variations\' | translate }}</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select ng-if="vm.sizes.length" class="custom-select-value" ng-model="vm.filters.sizes" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.sizes)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="size in vm.sizes" ng-value="size">{{size.label}}</md-option></div></md-select><md-select ng-if="!vm.sizes.length" class="custom-select-value" ng-model="vm.filters.sizes" disabled="disabled" placeholder="{{ \'bag.form.messages.empty-filter-list\' | translate }}"></md-select></md-input-container></div></div></div><div class="col-md-12"><div class="form-group col-md-4 col-sm-12" ng-if="vm.isBagFilter"><span data-translate="flyers.new.form.tags.title">Tags</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select class="custom-select-value" ng-model="vm.filters.tags" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.tags)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="tag in vm.tags" ng-value="tag">{{ tag.label }}</md-option></div></md-select></md-input-container></div></div></div></div><div class="col-md-12"><div class="row"><div class="col-md-12"><button type="button" class="clear-btn" ng-click="vm.clearFilters()"><i class="fa fa-times"></i> {{\'bag.filters.clearAll\' | translate}}</button></div></div></div></div></div><div id="footer-new-conversation" class="modal-footer"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.closeModal()"><span>{{\'bag.form.buttons.cancel\' | translate}}</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.applyFilters()"><span>{{\'bag.filters.apply\' | translate}}</span></button></div></div>');
$templateCache.put('app/admin/communication/bag-chat-modal/bag-chat.html','<style>.sub-title {\n        font-size: 1.0em;\n    }\n\n    md-select-menu md-content {\n        -webkit-overflow-scrolling: fixed !important;\n    }\n\n    .md-select-menu-container {\n        z-index: 3000 !important;\n    }\n\n    .custom-md-input md-input-container {\n        display: inherit;\n        margin: unset;\n    }\n\n    .custom-md-input md-select.md-default-theme .md-select-value,\n    md-select .md-select-value {\n        border-color: rgba(0, 0, 0, 0.12) !important;\n        border: 1px;\n        border-style: solid;\n    }\n\n    .custom-select[multiple] .md-select-value span:first-child {\n        visibility: collapse;\n    }\n\n    .custom-select[multiple] .md-select-value .md-text {\n        display: inline-block !important;\n        visibility: visible;\n        background-color: rgb(224, 224, 224);\n        border-radius: 6px;\n        padding: 3px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected],\n    md-select-menu md-content md-option[selected] {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected]:focus,\n    md-select-menu md-content md-option[selected]:focus {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-checkbox-enabled.md-default-theme[selected] .md-icon,\n    .md-checkbox-enabled[selected] .md-icon {\n        background-color: var(--main-color) !important;\n    }\n\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\n    md-select-menu md-content md-option:not([disabled]):focus,\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\n    md-select-menu md-content md-option:not([disabled]):hover {\n        background: none;\n    }\n\n    .highlight {\n        background: #f3f3f4;\n        padding: 5px;\n        display: inline-block;\n        color: #5E5E5E;\n        border-radius: 10px;\n        padding-bottom: 2px;\n        padding-top: 2px;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    md-select-menu {\n        margin-top: 50px;\n        width: 150.674px !important;\n        margin-left: 39px;\n    }\n\n    .remove-dropdown {\n        display: none !important;\n    }\n\n    .empty-list md-select-menu {\n        margin-top: 42px;\n        width: 192.674px !important;\n        margin-left: -1px;\n    }\n\n    md-select.md-default-theme[disabled] .md-select-value, md-select[disabled] .md-select-value {\n        background-image: none !important;\n    }\n\n    .form-control:focus, tags-input .tags:focus, .single-line:focus {\n        border-color: #E5E6E7;\n    }</style><div id="modal" ng-click="vm.closeDropDown($event)" style="cursor: default"><div class="modal-header" style="border-bottom: none"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h1 class="modal-title" style="margin-left: 15px">Nova mala</h1><span class="sub-title" style="margin-left: 15px">Selecione os produtos que ir\xE3o surpreender e encatar o seu cliente</span></div><div class="modal-body single-products-modal"><div class="row"><div class="col-md-12 form-group"><label for="bagName" class="ng-scope required" style="color: #717476 !important">Nome da Mala</label><div class="display-flex"><input id="bagName" name="bagName" class="form-control ng-pristine ng-valid ng-empty ng-touched" ng-model="vm.showcase.name" style="resize: none; margin-right: 15px" aria-invalid="false" placeholder="Ex: Promo\xE7\xE3o semanal..."><div class="btn-group preferences"><button style="box-shadow:none; box-shadow:none;padding-top: 6px;padding-bottom: 6px" type="button" class="btn-dropdown-status dropdown-toggle preferences display-flex" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ng-click="vm.changeActive()"><span style="padding-right: 5px">Prefer\xEAncias </span><span class="numberCircle" style="margin-top: 0px !important">{{vm.filtersLen}}</span> <span id="preferences-arrow" class="bag-chat-arrow fa arrow" ng-class="{\'active\': vm.isActive}"><!-- <i class="fa fa-angle-down"></i> --></span></button><div class="dropdown-menu dropdown-menu-right-custom bag-chat-dropdown bag-chat-filter" ng-click="$event.stopPropagation();" style="color: black;cursor: default"><div class="row"><div class="col-md-12"><div class="row"><!-- category --><div class="form-group col-md-6 col-sm-12"><label for="size" data-translate="flyers.new.form.category">Categories</label><div class="dropdown custom-md-input"><md-input-container ng-if="vm.categories.length" class="category-select"><md-select class="custom-select-value" ng-model="vm.filters.categories" multiple="multiple" disableoptioncentering md-selected-html="vm.getSelectedTextCategory(vm.filters.categories)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="category in vm.categories" ng-value="category.key">{{category.title}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.categories.length" class="category-select"><md-select class="custom-select-value" ng-model="vm.filters.categories" multiple="multiple" disableoptioncentering disabled="!vm.categories.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><!-- gender --><div class="form-group col-md-6 col-sm-12"><label for="gender" data-translate="flyers.new.form.gender.title">Gender</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container ng-if="vm.genders.length" class="gender-select"><md-select class="custom-select-value" ng-model="vm.filters.genders" multiple="multiple" md-selected-html="vm.getSelectedTextGender(vm.filters.genders)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="gender in vm.genders" ng-value="gender">{{vm.getTranslateGenders(gender) | translate}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.genders.length" class="gender-select"><md-select class="custom-select-value" ng-model="vm.filters.genders" multiple="multiple" disabled="!vm.genders.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div></div></div><div class="col-md-12"><div class="row"><!-- size --><div class="form-group col-md-6 col-sm-12"><label for="size">{{ vm.storeCategory == FASHION ? \'flyers.new.form.size.title\' : \'flyers.new.form.variation\' | translate }}</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container ng-if="vm.sizes.length" class="size-select"><md-select class="custom-select-value" ng-model="vm.filters.sizes" multiple="multiple" md-selected-html="vm.getSelectedText(vm.filters.sizes)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="size in vm.sizes" ng-value="size">{{size}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.sizes.length" class="size-select"><md-select class="custom-select-value" ng-model="vm.filters.sizes" multiple="multiple" disabled="!vm.sizes.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><!-- etiqueta --><div class="form-group col-md-6 col-sm-12"><label for="size" data-translate="flyers.new.form.tags.title">Tags</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container ng-if="vm.tags.length" class="tag-select"><md-select class="custom-select-value" ng-model="vm.filters.tags" multiple="multiple" md-selected-html="vm.getSelectedText(vm.filters.tags)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="tag in vm.tags" ng-value="tag">{{tag}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.tags.length" class="tag-select"><md-select class="custom-select-value" ng-model="vm.filters.tags" multiple="multiple" disabled="!vm.tags.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div></div></div><div class="col-md-12"><div class="row"><!-- brand --><div class="form-group col-md-6 col-sm-12"><label for="brand" data-translate="flyers.new.form.brand">Brand</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select class="custom-select-value" ng-model="vm.filters.brands" multiple="multiple" md-selected-html="vm.getSelectedText(vm.filters.brands)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="brand in vm.brands" ng-value="brand">{{brand}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.brands.length" class="brand-select"><md-select class="custom-select-value" ng-model="vm.filters.brands" multiple="multiple" disabled="!vm.brands.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><!-- color --><div class="form-group col-md-6 col-sm-12"><label for="color" data-translate="flyers.new.form.color">Color</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container ng-if="vm.colors.length" class="color-select"><md-select class="custom-select-value" ng-model="vm.filters.colors" multiple="multiple" md-selected-html="vm.getSelectedText(vm.filters.colors)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="color in vm.colors" ng-value="color">{{color}}</md-option></div></md-select></md-input-container><md-input-container ng-if="!vm.colors.length" class="color-select"><md-select class="custom-select-value" ng-model="vm.filters.colors" multiple="multiple" disabled="!vm.colors.length" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div></div></div></div><div style="text-align: right"><button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.filterFlyers();"><span>Aplicar</span></button></div></div></div></div><!-- </button> --><p class="help-block form-invalid-field" ng-show="vm.showcase.name === undefined" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.showcase.name.length > 50" data-translate="entity.validation.maxlength" translate-value-max="50"></p><p class="help-block form-invalid-field" ng-show="vm.showcase.name.length < 4" data-translate="entity.validation.minlength" translate-value-min="4"></p></div><div class="input-group" style="margin-left:15px"><span class="input-group-addon" style="padding-right:0px"><span class="fa fa-search"></span> </span><input type="text" name="inputSearch" class="form-control bag-chat-input-search" style="border-left: 0px; width: 97%" ng-change="vm.filterFlyers()" placeholder="Buscar Produtos por nome ou c\xF3digo de refer\xEAncia" ng-model="vm.filters.text" ng-model-options="{ debounce: 500 }"></div><div class="row" style="float: left" ng-if="vm.flyersFiltered.length > 0"><p style="margin-left: 40px; margin-top: 15px; color: #a3a3a3">{{vm.totalFlyers}}/{{vm.totalAvailableFlyers}} Selecionados</p></div><div class="row" style="float: right; margin-top: 15px" ng-if="vm.flyersFiltered.length > 0"><div style="margin-right: 65px !important" class="checkbox flyer-checkbox-remove-margin"><label><label style="margin-right: 10px; margin-top: 3px; color: #a3a3a3 !important" class="ng-binding">Selecionar todos da p\xE1gina</label><span ng-click="vm.onSelectAll()"><md-checkbox md-no-ink class="dynamic-color-checkbox check-template" ng-checked="vm.allSelected"></md-checkbox></span></label></div></div><div ng-include="\'app/admin/communication/bag-chat-modal/flyers-view-structure.html\'" ng-if="vm.flyersFiltered.length > 0"></div><div class="col-xs-12 showcase-box-noflyer" ng-if="vm.flyersFiltered === undefined || vm.flyersFiltered.length == 0" style="margin-top: 100px"><img src="./assets/images/product-not-found.png"><h4 class="ng-scope" style="color: #a3a3a3; margin-bottom: 1px">Nenhum produto encontrado</h4><h4 class="ng-scope" style="color: #a3a3a3; margin-top: 0px">com essa combina\xE7\xE3o de prefer\xEAncias.</h4></div></div></div><div class="modal-footer display-horizontally-inline" style="border-top: none; width: 100%; justify-content: space-between"><uib-pagination ng-model="vm.currentPage" total-items="vm.totalAvailableFlyers" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.loadFlyers()"></uib-pagination><div><button class="btn btn-default btn-lg cancel-button" data-style="slide-left" ng-click="vm.closeModal()"><span>Cancelar</span></button> <button class="btn btn-primary btn-lg" ng-disabled="vm.showcase.name.length < 4 || vm.showcase.name.length > 50 || vm.loadingImage" data-style="slide-left" ng-click="vm.createBagWithProducts()"><span ng-if="!vm.loadingImage">Criar Mala</span><div class="sk-spinner sk-spinner-circle" ng-show="vm.loadingImage"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></button></div></div></div>');
$templateCache.put('app/admin/communication/bag-chat-modal/flyers-view-structure.html','<script>var mainColor = getComputedStyle(document.documentElement).getPropertyValue(\'--main-color-light\');\n    var interaction = document.getElementById("interaction");\n    if (interaction) {\n        interaction.style.backgroundColor = mainColor + \'31\';\n        interaction.style.color = mainColor;\n    }\n    var purchase = document.getElementById("purchase");\n    if (purchase) {\n        purchase.style.backgroundColor = mainColor + \'31\';\n        purchase.style.color = mainColor;\n    }</script><div class="ibox-content pl-0 pr-0 pt-0 pb-0"><div class="row"><div class="col-lg-12"><div class="sk-container" ng-if="vm.loadingUserOfferEngagements" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingUserOfferEngagements && (!vm.flyersFiltered || vm.flyersFiltered.length > 0)"><div class="engagements-list" id="scroll-div"><div class="row engagement-product-card display-flex" ng-repeat="flyer in vm.flyersFiltered" style="margin-bottom: 10px"><!-- foto --><div class="col-md-4 col-xs-4 pl-0 pr-0"><div class="cart-product-imitation flyer-table-img" ng-style="{\'background-image\': \'url(/flyer/api/{{flyer.id}}/picture)\'}" style="background-size: 100% 100%; padding-top: 50px !important"></div></div><!-- informa\xE7\xF5es gerais --><div class="col-md-7 col-xs-7 pl-0"><div class="row"><div class="col-md-12"><h3 style="margin-top: -5px !important"><span class="text-navy"><div><p class="text-ellipsis-two-lines" style="font-size: 14px;\n                                                                color: #676a6c;\n                                                                margin: 4px 0 5px 0; word-wrap: break-word">{{flyer.name}}</p></div></span></h3></div><div class="col-md-12"><div><span class="product-info-price flyer-table-price" ng-if="flyer.discountedValue" style="font-size: 16px"><span class="flyer-prices-remove-margin">{{vm.getCurrencyPrefix(flyer)}} </span>{{flyer.discountedValue | number: 2}}</span> <span class="product-info-price flyer-table-price" ng-if="!flyer.discountedValue && flyer.purchaseValue" style="font-size: 16px"><span class="flyer-prices-remove-margin">{{vm.getCurrencyPrefix(flyer)}} </span>{{flyer.purchaseValue | number: 2}}</span> <span class="product-info-price-normal" ng-if="flyer.purchaseValue && flyer.discountedValue" style="white-space: nowrap; color: #9f9f9f; font-weight: bold"><span class="flyer-prices-remove-margin">{{vm.getCurrencyPrefix(flyer)}} </span><span class="coupon-desactived-decoration" style="white-space: nowrap">{{flyer.purchaseValue | number : 2}}</span></span></div></div><div class="col-md-12" ng-if="flyer.productReference" style="margin-top: 5px"><div><span class="tag-info" style="color: #9f9f9f; font-size: 12px"><span class="">Cod: {{ flyer.productReference }}</span></span></div></div><div class="col-md-12 pr-0" style="margin-top: 5px"><div><label class="label label-primary" id="interaction" ng-class="item.inventory === 0 ? \'out-of-stock\' : \'cancel-button\'" ng-if="flyer.details.length > 0" ng-repeat="item in flyer.details" style="border-radius: 10px; padding: 3px 10px; display: inline-block; margin: 3px 3px; font-size: 9px">{{item.size}}: {{item.inventory != null ? item.inventory : \'Ilimitado\' }}</label></div></div></div></div><div class="col-md-1 col-xs-1 pl-0"><div class="checkbox flyer-checkbox-remove-margin" ng-click="$event.stopPropagation()" style="margin-top: 10px !important"><label><span ng-click="vm.refreshSelectedFlyers(flyer)"><md-checkbox class="dynamic-color-checkbox check-template" md-no-ink ng-checked="vm.checkIfFlyerSelected(flyer.id)"></md-checkbox></span></label></div></div></div><hr class="flyer-table-line"></div></div></div></div></div>');
$templateCache.put('app/admin/communication/broadcast-list-modal/broadcast-list-modal.html','<style>.main-modal {\n        padding: 0 15px;\n    }\n\n    .close {\n        font-size: 30px;\n        font-weight: normal;\n        opacity: 1;\n    }\n\n    /* width */\n    ::-webkit-scrollbar {\n        width: 6px !important;\n    }\n\n    /* Track */\n    ::-webkit-scrollbar-track {\n        background: #f1f1f1;\n    }\n\n    /* Handle */\n    ::-webkit-scrollbar-thumb {\n        background: #888;\n        border-radius: 5px;\n    }\n\n    /* Handle on hover */\n    ::-webkit-scrollbar-thumb:hover {\n        background: #555;\n    }</style><div id="modal" class="main-modal"><div class="modal-header"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal(false)">&times;</button><h3>{{\'communication.broadcast-list-modal.title\' | translate}}</h3></div><div class="modal-body"><div class="row" ng-if="vm.currentStep === 1" ng-include="\'app/admin/communication/broadcast-list-modal/steps-new-broadcast-list/new-broadcast-list.html\'"></div><div class="row" ng-if="vm.currentStep === 2" ng-include="\'app/admin/communication/broadcast-list-modal/steps-new-broadcast-list/select-contacts.html\'"></div></div></div>');
$templateCache.put('app/admin/communication/directives/message-options.html','<div class="dropdown open" on-toggle="toggled(open)" uib-dropdown is-open="isOpen || message.holdMessage"><a class="message-options" ng-if="!isMobile && (message.showOptions || isOpen)" aria-expanded="true" aria-haspopup="true" data-toggle="dropdown" uib-dropdown-toggle><i class="fa fa-angle-down message-options-icon" aria-hidden="true"></i></a><ul class="m-t-md ng-scope dropdown-menu dropdown-menu-center-custom" uib-dropdown-menu=""><li ng-if="!message.failedToSend && !message.loadingDownload" ng-click="callApplyOption({option: \'REPLY\', message: message})"><a class="ng-scope"><i class="fa fa-reply" aria-hidden="true" style="margin-right: 5px"></i> {{\'communication.reply-message\' | translate}}</a></li><li ng-if="!message.failedToSend && !message.loadingDownload" ng-click="callApplyOption({option: \'FORWARD\', message: message})"><a class="ng-scope"><i class="fa fa-share" aria-hidden="true" style="margin-right: 5px"></i> {{\'communication.forward-message\' | translate}}</a></li><li ng-if="isMobile && message.text && !message.failedToSend && !message.loadingDownload" ng-click="callApplyOption({option: \'COPY_MESSAGE\', message: message})"><a class="ng-scope"><i class="fa fa-files-o" aria-hidden="true" style="margin-right: 5px"></i> {{\'communication.copy-message\' | translate}}</a></li><li ng-if="message.failedToSend && !message.loadingDownload" ng-click="callApplyOption({option: \'DELETE_MESSAGE\', message: message})"><a class="ng-scope"><i class="fa fa-files-o" aria-hidden="true" style="margin-right: 5px"></i> {{\'communication.delete-message\' | translate}}</a></li></ul></div><style>.dropdown-menu-center-custom {\n        left: auto !important;\n        right: -55px !important;\n    }</style>');
$templateCache.put('app/admin/communication/engagements/habits.html','<div class=""><div class="ibox-title pl-0 pr-0"><h5 style="font-weight: bold">Principais categorias</h5></div><div class="ibox-content pl-0 pr-0"><div class="row" style="min-height: 105px"><div class="col-lg-12"><div ng-if="vm.loadingUserCategoryStatistics" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingUserCategoryStatistics" ng-repeat="category in vm.categoryStatistics" class="localizacoes-texto"><span>{{category.category}} &nbsp;&nbsp; <span style="font-size:12px">{{category.count}}/{{vm.totalBrand}}</span> </span><span class="pull-right">{{$index + 1}}\xBA</span><div class="progress progress-small" style="margin-top: 2px!important; height: 6px!important"><div ng-style="{\'width\': (category.count/vm.totalBrand * 100) + \'%\'};" class="progress-bar"></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/communication/engagements/history.html','<script>var mainColor = getComputedStyle(document.documentElement).getPropertyValue(\'--main-color-light\');\n    var interaction = document.getElementById("interaction");\n    if (interaction) {\n        interaction.style.backgroundColor = mainColor + \'31\';\n        interaction.style.color = mainColor;\n    }\n    var purchase = document.getElementById("purchase");\n    if (purchase) {\n        purchase.style.backgroundColor = mainColor + \'31\';\n        purchase.style.color = mainColor;\n    }</script><div><div><div class="ibox-title pl-0 pr-0"><h5 style="font-weight: bold">Produtos relacionados</h5><div ibox-tools></div></div><div class="ibox-content pl-0 pr-0 pt-0"><div class="row" style="min-height: 390px"><div class="col-lg-12"><div ng-if="vm.loadingUserOfferEngagements" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingUserOfferEngagements && (!vm.offers || vm.offers.length > 0)"><div><p style="color: #afafaf">{{ vm.totalElements + (vm.totalElements == 1 ? \' Produto\' : \' Produtos\') }}</p></div><div class="engagements-list"><div style="margin-bottom: 10px" class="row engagement-product-card" ng-repeat="item in vm.offers track by $index"><!-- foto --><div class="col-md-4 col-xs-4 pl-0 pr-0"><div class="cart-product-imitation flyer-table-img" style="background-size: 100% 100%; padding-top: 50px !important" ng-style="{\'background-image\': \'url(/flyer/api/{{item.flyer.id}}/picture)\'}"></div></div><!-- informa\xE7\xF5es gerais --><div class="col-md-8 col-xs-8 pl-0"><div class="row"><div class="col-md-12"><h3 style="margin-top: -5px !important"><span class="text-navy"><div><p class="text-ellipsis-two-lines" style="font-size: 14px;\n                                                                color: #676a6c;\n                                                                margin: 4px 0 5px 0; word-wrap: break-word">{{item.flyer.name}}</p></div></span></h3></div><div class="col-md-12"><div><span class="product-info-price flyer-table-price" ng-if="item.flyer.discountValue" style="font-size: 16px"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(item.flyer.currency)}} </span>{{item.flyer.discountedValue | number : 2}}</span> <span class="product-info-price flyer-table-price" ng-if="!item.flyer.discountValue && item.flyer.purchaseValue" style="font-size: 16px"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(item.flyer.currency)}} </span>{{item.flyer.purchaseValue | number : 2}}</span> <span class="product-info-price-normal" style="white-space: nowrap; color: #9f9f9f; font-weight: bold" ng-if="item.flyer.purchaseValue && item.flyer.discountValue"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(item.flyer.currency)}} </span><span class="coupon-desactived-decoration" style="white-space: nowrap">{{item.flyer.purchaseValue | number : 2}}</span></span></div></div><div ng-if="item.flyer.productReference" class="col-md-12" style="margin-top: 5px"><div><span class="tag-info" style="color: #9f9f9f; font-size: 12px"><span class="">Cod: {{ item.flyer.productReference }}</span></span></div></div><div class="col-md-12 pr-0" style="margin-top: 5px"><div><label id="interaction" style="border-radius: 10px; padding: 5px 15px; display: inline-block" class="label label-primary" data-translate="reports.engagement.user.messages.interaction" translate-values="{quantity: \'{{item.count}}\'}"></label><label id="purchase" style="border-radius: 10px; padding: 5px 15px; display: inline-block" class="label label-primary" data-translate="reports.engagement.user.messages.purchase" translate-values="{quantity: \'{{item.totalPurchases}}\'}"></label></div></div></div></div></div><hr class="flyer-table-line"></div><div align="center" style="padding:  20px 0 20px 0" ng-if="!vm.loadingUserOfferEngagements && (vm.offers && vm.offers.length > 0)"><uib-pagination ng-model="vm.currentPage" rotate="false" total-items="vm.totalElements" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startElement}}\', of: \'{{vm.ofQuantityElements}}\', total: \'{{vm.totalElements}}\'}">Showing {{ vm.startElement }} to {{ vm.ofQuantityElements }} of {{ vm.totalElements }}</p></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/communication/filters-conversation-modal/filters-conversation-modal.html','<style>.sub-title {\n        font-size: 1.0em;\n    }\n\n    md-select-menu md-content {\n        -webkit-overflow-scrolling: fixed !important;\n    }\n\n    .md-select-menu-container {\n        z-index: 3000 !important;\n    }\n\n    .custom-md-input md-input-container {\n        display: inherit;\n        margin: unset;\n    }\n\n    .custom-md-input md-select.md-default-theme .md-select-value,\n    md-select .md-select-value {\n        border-color: rgba(0, 0, 0, 0.12) !important;\n        border: 1px;\n        border-style: solid;\n        padding-left: 8px;\n    }\n\n    .custom-select[multiple] .md-select-value span:first-child {\n        visibility: collapse;\n    }\n\n    .custom-select[multiple] .md-select-value .md-text {\n        display: inline-block !important;\n        visibility: visible;\n        background-color: rgb(224, 224, 224);\n        border-radius: 6px;\n        padding: 3px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected],\n    md-select-menu md-content md-option[selected] {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected]:focus,\n    md-select-menu md-content md-option[selected]:focus {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-checkbox-enabled.md-default-theme[selected] .md-icon,\n    .md-checkbox-enabled[selected] .md-icon {\n        background-color: var(--main-color) !important;\n    }\n\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\n    md-select-menu md-content md-option:not([disabled]):focus,\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\n    md-select-menu md-content md-option:not([disabled]):hover {\n        background: none;\n    }\n\n    .highlight {\n        background: #f3f3f4;\n        padding: 5px;\n        display: inline-block;\n        color: #5E5E5E;\n        border-radius: 10px;\n        padding-bottom: 2px;\n        padding-top: 2px;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    md-select-menu {\n        margin-top: 50px;\n        width: 150.674px !important;\n        margin-left: 39px;\n    }\n\n    .remove-dropdown {\n        display: none !important;\n    }\n\n    .empty-list md-select-menu {\n        margin-top: 42px;\n        width: 192.674px !important;\n        margin-left: -1px;\n    }\n\n    md-select.md-default-theme[disabled] .md-select-value,\n    md-select[disabled] .md-select-value {\n        background-image: none !important;\n    }</style><div id="modal" class="main-modal"><div id="header-new-conversation" class="modal-header"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h1 class="modal-title">Filtros personalizados</h1><span class="sub-title">Preencha os campos abaixo para personalizar a sua visualiza\xE7\xE3o das conversas</span></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="row"><!-- status --><div class="form-group col-md-6 col-sm-12"><label for="status">Status da conversa</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select class="custom-select-value" ng-model="vm.filters.status" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.status)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="status in vm.status" ng-value="status">{{status.label}}</md-option></div></md-select></md-input-container></div></div><!-- Ordenar por --><div class="form-group col-md-6 col-sm-12"><label for="ordering">Ordenar por</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="gender-select"><md-select class="custom-select-value" ng-model="vm.filters.order" ng-model-options="{trackBy: \'$value.id\'}"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="field in vm.orderFields" ng-value="field">{{field.label}}</md-option></div></md-select></md-input-container></div></div></div></div><div class="col-md-12"><div class="row"><!-- Atribuido --><div class="form-group col-md-6 col-sm-12"><label for="attendants">Atr\xEDbuido a</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="size-select"><md-select class="custom-select-value" ng-model="vm.filters.attendants" multiple="multiple" ng-model-options="{trackBy: \'$value.value\'}" md-selected-html="vm.getSelectedText(vm.filters.attendants)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="attendant in vm.attendants" ng-value="attendant">{{attendant.label}}</md-option></div></md-select></md-input-container></div></div></div></div><div class="col-md-12"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="periodo">Per\xEDodo</label><div class="input-group date" id="insigthsDateRange"><span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span> </span><input id="periodo" style="float: right; background-color: #fffefe" date-range-picker class="form-control date-picker ng-pristine ng-valid ng-isolate-scope ng-touched" ng-model="vm.filters.rangeDate" options="vm.dateRangeOptions" max="vm.maxDate" required=""></div></div></div></div><div class="col-md-12"><div class="row"><div class="col-md-12"><button type="button" class="clear-btn" ng-click="vm.clearFilters()"><i class="fa fa-times"></i> Limpar filtros</button></div></div></div></div></div><div id="footer-new-conversation" class="modal-footer"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.closeModal()"><span>{{\'communication.new-conversation.cancel\' | translate}}</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.apllyFilters()"><span>Aplicar</span></button></div></div>');
$templateCache.put('app/admin/communication/location-chat-modal/location-chat.html','<style>.sub-title {\n        font-size: 1.0em;\n    }\n\n    .location-modal {\n        overflow-y: auto;\n        padding-bottom: 10px !important;\n        padding: 10px 10px 10px 10px;\n    }\n\n    .sheet-icon-item {\n        font-size: 45px;\n        color: #969b9f;\n    }</style><div id="modal" ng-click="vm.closeDropDown($event)" style="cursor: default"><div class="modal-header" style="border-bottom: none"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><div style="margin-left: 15px"><h1 class="modal-title">Compartilhar localiza\xE7\xE3o</h1><span class="sub-title">Selecione o endere\xE7o do ponto de venda que deseja compartilhar</span></div></div><div class="modal-body location-modal"><div class="ibox-content pl-0 pr-0 pt-0 pb-0"><div class="location-list col-lg-12" detect-scroll-to-bottom="vm.flyerScrollToBottom" id="scroll-div"><div class="row location-card display-flex" ng-repeat="point in vm.salesPoint" style="margin-bottom: 10px"><di><i class="icon-ksc-finaluser-location sheet-icon-item"></i></di><div class="col-md-12" style="overflow: hidden"><h3 style="font-size: 17px; color: #676a6c; word-wrap: break-word">{{point.name}}</h3><p style="font-size: 12px; color: #676a6c; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{point.address}}, {{point.number ? point.number + \',\' : \'\'}} {{point.neighborhood ? point.neighborhood + \',\' : \'\'}} {{point.city}}/{{point.state}}, {{vm.zipCodeMask(point.postalCode)}}</p></div><div class="col-md-1 col-xs-1 pl-0 checkbox flyer-checkbox-remove-margin" ng-click="$event.stopPropagation(); vm.selectPoint(point)" style="margin-top: 10px !important"><md-checkbox class="dynamic-color-checkbox check-template" md-no-ink ng-checked="point.selected"></md-checkbox></div></div></div></div></div><div class="modal-footer button-location-modal" style="border-top: none"><button class="btn btn-default btn-lg cancel-button" data-style="slide-left" ng-click="vm.closeModal()"><span>Cancelar</span></button> <button class="btn btn-primary btn-lg" ng-disabled="!vm.pointSelected" data-style="slide-left" ng-click="vm.addPoint()"><span>Compartilhar</span></button></div></div>');
$templateCache.put('app/admin/communication/logout-modal/logout.html','<div class="container-modal-connect" id="modal"><h1 class="modal-title" style="margin: 80px 50px 50px 50px"><div style="display: flex; flex-direction: row"><i class="fa fa-warning" style="color: #fdbe2d; font-size: 7vh"></i><p style="font-size: 23px; margin-left: 20px">{{\'communication.logout-modal.question\' | translate}}<bold style="font-weight: 500">{{vm.logoutSocialMediaText}}</bold>?</p></div></h1><div class="modal-footer" style="border-top: none; padding: 35px"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.closeModal({isLogginOut: false})"><span>{{ \'entity.action.cancel\' | translate }}</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.socialMedia == \'WATI\' ? vm.logoutOfWhatsapp() : vm.facebookDisconnect()" style="width: 81px"><span>{{ \'communication.logout-modal.logout\' | translate }}</span></button></div></div>');
$templateCache.put('app/admin/communication/magic-modal/flyers-view-structure.html','<style>.badge-details {\n        color: #5E5E5E;\n        font-family: \'Roboto\';\n        font-size: 11px;\n        font-weight: 600;\n        padding: 6px 7px;\n        text-shadow: none;\n        margin-right: 6px;\n        margin-bottom: 6px;\n        border-radius: 0px;\n        font-weight: normal;\n    }\n\n    .with-stock {\n        background-color: #eaeaea;\n    }\n\n    .out-of-stock {\n        background-color: rgb(249 203 203);\n    }\n\n    .tag-info {\n        font-size: 12px; font-weight: 500; word-wrap: break-word;\n    }</style><div class="ibox" ng-show="vm.recommendedFlyers.length > 0" style="margin: 0px 20px"><div class="ibox-content" style="min-height: 600px"><div class="row"><div class="ibox-content flyer-table-box" ng-repeat="flyer in vm.recommendedFlyers"><div class="table-responsive"><table class="table shoping-cart-table"><tbody><tr width="100%"><td width="10%"><div class="cart-product-imitation flyer-table-img" style="background-size: 100% 100%; padding-top: 50px !important" ng-style="{\'background-image\': \'url(/flyer/api/{{flyer.id}}/picture)\'}"></div></td><td class="desc" width="60%"><h3 style="margin-top: -5px !important"><a class="text-navy"><small class="text-muted coupon-text-color product-category">{{flyer.category}}</small><p class="product-name" style="word-wrap: break-word">{{flyer.name}}</p></a></h3><div><span uib-tooltip="{{flyer.inventory == 0 ? \'Estoque esgotado\' : \'\'}}" ng-if="flyer.details.length == 0" class="badge badge-details with-stock" ng-class="{\'out-of-stock\': flyer.inventory == 0 }">Estoque: {{flyer.inventory != null ? flyer.inventory : \'Ilimitado\' }} </span><span uib-tooltip="{{item.inventory <= 0 && item.inventory != null ? \'Estoque esgotado\' : \'\'}}" ng-if="flyer.details.length > 0" ng-repeat="item in flyer.details" class="badge badge-details with-stock" ng-class="{\'out-of-stock\': item.inventory <= 0 && item.inventory != null }">{{ vm.storeCategory == FASHION ? \'Tam\' : \'Var\'}} {{item.size}}: {{item.inventory != null ? item.inventory : \'Ilimitado\' }}</span></div><span ng-repeat="tag in flyer.tags" class="badge badge-secondary badge-tag-flyer">{{tag}}</span><div style="margin-top: 6px"><!-- <span class="fa fa-tag" ng-class="{\'ksc-tag-active\': flyer.status == \'ACTIVATED\', \'ksc-tag-inactive\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}"></span>\n                                        <span class="flyer-table-info" ng-class="{\'flyer-active\': flyer.status == \'ACTIVATED\', \'flyer-disabled\': (flyer.status == \'DEACTIVATED\' || flyer.status == \'EXPIRED\')}">{{(flyer.status == \'ACTIVATED\' ? \'flyers.offer.active\' : \'flyers.offer.disabled\') | translate}}</span> --> <span class="tag-info" ng-if="flyer.productReference" style="color: #676a6c; font-size: 10px">{{\'Cod: \' + flyer.productReference }} </span><span class="tag-info" ng-show="flyer.expirationDate" style="margin-left: 15px" tooltip-placement="bottom-left" uib-tooltip="{{\'flyers.new.form.expirationDate\' | translate}}"><span class="fa fa-clock-o product-date">{{flyer.expirationDate | date: "dd/MM/yyyy"}}</span></span></div></td><td width="30%" style="padding-top: 0px"><div style="margin-top: 10px !important" class="checkbox flyer-checkbox-remove-margin" ng-click="$event.stopPropagation()"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfFlyerSelected(flyer.id)" ng-click="vm.refreshSelectedFlyers(flyer)"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div><div class="col-xs-12" style="margin-top: 24px"><span class="product-info-price-normal" style="white-space: nowrap" ng-if="flyer.purchaseValue && flyer.discountedValue"><span class="coupon-desactived-decoration" style="white-space: nowrap">{{vm.getCurrencyPrefix(flyer)}}{{flyer.purchaseValue | number : 2}}</span></span><br><span class="product-info-price flyer-table-price" ng-if="flyer.discountedValue">{{vm.getCurrencyPrefix(flyer)}}{{flyer.discountedValue | number : 2}} </span><span class="product-info-price flyer-table-price" ng-if="!flyer.discountedValue && flyer.purchaseValue">{{vm.getCurrencyPrefix(flyer)}}{{flyer.purchaseValue | number : 2}}</span></div></td></tr></tbody></table></div><hr class="flyer-table-line"></div></div></div></div>');
$templateCache.put('app/admin/communication/magic-modal/magic-modal.html','<style>.sub-title {\n        font-size: 1.0em;\n    }\n\n    .modal-header {\n        border-bottom: none;\n        padding-bottom: 0px;\n    }\n\n    #slides {\n        padding-top: 0px;\n    }</style><div id="modal"><div class="modal-header" ng-if="vm.currentStep == 1"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h1 class="modal-title">Recomenda\xE7\xE3o de Produtos</h1><span class="sub-title">Abaixo, selecione recomenda\xE7\xF5es que ir\xE3o surpreender seus clientes.</span></div><div class="modal-header" ng-if="vm.currentStep == 2"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h1 class="modal-title">Sele\xE7\xE3o de Produtos</h1><span class="sub-title">Selecione os produtos relevantes com base nas nossas recomenda\xE7\xF5es.</span></div><div class="modal-header" ng-if="vm.currentStep == 3"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h1 class="modal-title">Envio da Mala</h1><span class="sub-title">D\xEA um nome a sua mala.</span></div><div class="modal-header" id="slides"><div class="slide-container"><div class="slide-dot" ng-class="{\'dot-activated\': vm.currentStep === 1}"></div><div class="slide-dot" ng-class="{\'dot-activated\': vm.currentStep === 2}"></div><div class="slide-dot" ng-class="{\'dot-activated\': vm.currentStep === 3}"></div></div></div><div class="modal-body" ng-if="vm.currentStep == 1"><div class="shadow p-1 mb-5 bg-white rounded"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-not-empty" aria-invalid="false" ng-model="vm.trendRec"> <span id="checkEnableSchedules" class="checkbox-material"><span class="check"></span></span> <span class="ng-scope">Recomenda\xE7\xE3o por Tendencias</span></label></div></div><div class="shadow p-1 mb-5 bg-white rounded" style="margin-top: 15px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-not-empty" aria-invalid="false" ng-model="vm.clusterRec"> <span id="checkEnableSchedules" class="checkbox-material"><span class="check"></span></span> <span class="ng-scope">Clientes similares</span></label></div></div><div class="shadow p-1 mb-5 bg-white rounded" style="margin-top: 15px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-not-empty" aria-invalid="false" ng-model="vm.SVDRec"> <span id="checkEnableSchedules" class="checkbox-material"><span class="check"></span></span> <span class="ng-scope">Por matriz</span></label></div></div></div><div class="modal-body" ng-if="vm.currentStep == 2" style="overflow-y: auto; height: 500px"><div class="row"><div class="row" style="float: right"><div style="margin-right: 65px !important" class="checkbox flyer-checkbox-remove-margin"><label><label style="margin-right: 10px" class="ng-binding">Selecionar todos</label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="!vm.hasSome(vm.excludes, vm.recommendIds)" ng-click="vm.onSelectAll()"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div></div><div ng-include="\'app/admin/communication/recommendation-modal/flyers-view-structure.html\'" ng-if="vm.recommendedFlyers.length > 0"></div></div></div><div class="modal-body" ng-if="vm.currentStep == 3"><div class="form-group"><label for="bagName" class="ng-scope required">Nome da Mala</label><input id="bagName" name="bagName" class="form-control ng-pristine ng-valid ng-empty ng-touched" ng-model="vm.bagName" style="resize: none" aria-invalid="false"><p class="help-block form-invalid-field" ng-show="vm.bagName === undefined" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.bagName.length > 50" data-translate="entity.validation.maxlength" translate-value-max="50"></p><p class="help-block form-invalid-field" ng-show="vm.bagName.length < 4" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div><div class="modal-footer"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.backStep()"><span ng-if="vm.currentStep !== 1">Voltar</span> <span ng-if="vm.currentStep === 1">Cancelar</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.nextStep()" ng-if="vm.currentStep != 3"><span>Continuar</span></button> <button class="btn btn-primary btn-md" ng-disabled="vm.bagName.length < 4 && !vm.isCarousel" data-style="slide-left" ng-click="vm.createBagByRecommendation()" ng-if="vm.currentStep == 3"><span>Gerar Mala</span></button></div></div>');
$templateCache.put('app/admin/communication/modal-audio/modal-audio.modal.html','<div class="modal-header" style="border: none !important"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="margin-top: -2px; font-size: 3.5em; font-weight: lighter" ng-click="vm.closeModal()">&times;</button></div><div class="modal-body" style="text-align: center"><i class="fa fa-warning col-xs-12 col-md-2" style="font-size: 5.4em; text-align: center; min-height: 12vh; color: #fdbe2d; margin-top: -15px"></i><p style="font-size: 2em; margin-bottom: 5px" ng-style="vm.fontSizeMessage">Sua mensagem n\xE3o foi enviada</p></div><div class="modal-footer" style="border-top: none !important"><button type="button" class="btn" ng-click="vm.exclude()">Excluir</button> <button type="button" class="btn btn-primary" ng-click="vm.confirm()">Tentar novamente</button></div>');
$templateCache.put('app/admin/communication/modal-file/modal-file.html','<div id="modal"><div class="modal-header"><h1 class="modal-title">Visualiza\xE7\xE3o de Arquivo</h1></div><div class="modal-body"><object ng-if="vm.file.type !== \'image\'" data="{{vm.file.blob}}#toolbar=0&navpanes=0&scrollbar=0" style="width: 100%; height: 50vh; object-fit: contain"></object><img ng-if="vm.file.type === \'image\'" src="{{vm.file.blob}}" alt="" style="width: 100%; height: 50vh; object-fit: contain"><hr><div ng-if="vm.conversation.source === \'WATI\'" class="form-group" style="margin-top: 10px"><label for="caption" class="ng-scope">Descri\xE7\xE3o</label><textarea id="caption" name="caption" class="form-control ng-pristine ng-valid ng-empty ng-touched" ng-model="vm.file.caption" style="resize: none" aria-invalid="false"></textarea></div></div><div class="modal-footer"><button class="btn btn-default btn-md cancel-button" data-style="slide-left" ng-click="vm.dismiss()"><span>Cancelar</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.closeAndSendFile()"><span>Enviar</span></button></div></div>');
$templateCache.put('app/admin/communication/new-conversation-modal/first-step.html','<div class="container-new-conversation"><div class="input-group-whatsapp" ng-if="vm.isConnectedToWati"><label>{{\'communication.new-conversation.newCustomer\' | translate}}</label><div class="wati-group"><span class="input-group-addon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17" style="height: 13px"><path fill="currentColor" d="M12.976 10.092c-.208-.104-1.227-.603-1.417-.672-.19-.069-.329-.103-.467.103-.138.207-.535.672-.656.81-.121.137-.242.155-.45.051-.207-.103-.875-.32-1.667-1.024-.617-.547-1.033-1.223-1.154-1.43-.12-.206-.012-.318.091-.42.094-.093.208-.242.311-.362.104-.12.139-.207.208-.344.069-.138.034-.259-.018-.362-.051-.103-.466-1.119-.639-1.532-.168-.403-.34-.348-.466-.354a8.356 8.356 0 0 0-.398-.008.763.763 0 0 0-.553.258c-.19.207-.725.706-.725 1.722s.743 1.997.846 2.135c.104.137 1.462 2.222 3.542 3.116.495.212.881.34 1.182.434.497.157.95.135 1.306.082.399-.06 1.227-.499 1.4-.981.173-.482.173-.895.12-.981-.05-.086-.19-.138-.396-.241m-3.784 5.14H9.19a6.912 6.912 0 0 1-3.51-.956l-.252-.149-2.61.682.696-2.533-.164-.26a6.824 6.824 0 0 1-1.054-3.653c.001-3.785 3.095-6.864 6.9-6.864 1.842 0 3.574.715 4.876 2.013a6.807 6.807 0 0 1 2.019 4.856c-.002 3.785-3.096 6.865-6.898 6.865m5.87-12.707A8.264 8.264 0 0 0 9.192.104C4.618.104.895 3.809.894 8.362A8.2221 8.2221 0 0 0 2 12.492L.824 16.77l4.4-1.149a8.323 8.323 0 0 0 3.965 1.005h.003c4.574 0 8.297-3.705 8.299-8.258a8.19 8.19 0 0 0-2.429-5.843"></path></svg> <span>{{\'communication.new-conversation.whatsapp\' | translate}}</span> </span><input type="tel" name="phone" ng-model="vm.phone" class="form-control page-external-input-2 external-control mobile-input-style" intl-tel-input></div></div><br><div ng-if="vm.isConnectedToWati"><span><span>{{\'communication.new-conversation.or\' | translate}}</span></span></div><br><angucomplete-alt id="customer" placeholder="{{ \'bag.form.placeholder.name-client\' | translate }}" text-no-results="{{ \'bag.form.placeholder.no-results\' | translate }}" text-searching="{{ \'bag.form.placeholder.searching\' | translate }}" pause="400" input-changed="vm.changeCustomer" selected-object="vm.selectedCustomer" remote-url-request-formatter="vm.requestParams" remote-url="/admin/api/customers" title-field="fullName" minlength="1" match-class="highlight" description-field="phone" clear-selected="true" input-class="form-control form-control-small" style="width: 100%"></div>');
$templateCache.put('app/admin/communication/new-conversation-modal/new-conversation-modal.html','<div id="modal" class="main-modal"><div id="header-new-conversation" class="modal-header"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><div ng-if="vm.step === 0"><h1 class="modal-title">{{\'communication.new-conversation.modal.titles.firstTitle\' | translate}}</h1><span>{{\'communication.new-conversation.modal.titles.firstSubtitle\' | translate}}</span></div><div ng-if="vm.step === 1"><h1 class="modal-title">{{\'communication.new-conversation.modal.titles.secondTitle\' | translate}}</h1><span>{{\'communication.new-conversation.modal.titles.secondSubtitle\' | translate}}</span></div><div ng-if="vm.step === 2 && !vm.isFb"><h1 class="modal-title">{{\'communication.new-conversation.modal.titles.thirdTitle\' | translate}}</h1><span>{{\'communication.new-conversation.modal.titles.thirdSubtitle\' | translate}}</span></div><div ng-if="vm.step === 2 && vm.isFb"><h1 class="modal-title">{{\'communication.new-conversation.modal.titles.fbTitle\' | translate}}</h1><span>{{\'communication.new-conversation.modal.titles.fbSubtitle\' | translate}}</span></div><div class="slide-container"><div class="slide-dot" ng-class="{\'dot-activated\': vm.step === 0}"></div><div class="slide-dot" ng-class="{\'dot-activated\': vm.step === 1}"></div><div class="slide-dot" ng-class="{\'dot-activated\': vm.step === 2}"></div></div></div><div class="modal-body"><div class="main-modal-body"><div ng-if="vm.step === 0" ng-include="\'app/admin/communication/new-conversation-modal/first-step.html\'"></div></div><div ng-if="vm.step === 1" ng-include="\'app/admin/communication/new-conversation-modal/second-step.html\'"></div><div ng-if="vm.step === 2" ng-include="\'app/admin/communication/new-conversation-modal/third-step.html\'"></div></div><div id="footer-new-conversation" class="modal-footer"><button ng-if="vm.step === 0" class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.closeModal()"><span>{{\'communication.new-conversation.cancel\' | translate}}</span></button> <button ng-if="vm.step !== 0" class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.previousStep()"><span>{{\'communication.new-conversation.back\' | translate}}</span></button> <button ng-if="vm.step !== 2" class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.nextStep()" ng-disabled="(vm.step == 0 && !vm.phone.length) || (vm.step == 1 && !vm.currentTemplate)"><span>{{\'communication.new-conversation.continue\' | translate}}</span></button> <button ng-if="vm.step === 2" class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.sendTemplate()"><span>{{\'communication.new-conversation.send\' | translate}}</span></button></div></div>');
$templateCache.put('app/admin/communication/new-conversation-modal/second-step.html','<div class="sk-circle" ng-if="vm.loadingTemplates"><div class="sk-circle1 sk-child"></div><div class="sk-circle2 sk-child"></div><div class="sk-circle3 sk-child"></div><div class="sk-circle4 sk-child"></div><div class="sk-circle5 sk-child"></div><div class="sk-circle6 sk-child"></div><div class="sk-circle7 sk-child"></div><div class="sk-circle8 sk-child"></div><div class="sk-circle9 sk-child"></div><div class="sk-circle10 sk-child"></div><div class="sk-circle11 sk-child"></div><div class="sk-circle12 sk-child"></div></div><div ng-if="!vm.loadingTemplates"><div class="row"><div class="input-group"><span class="input-group-addon"><i class="fa fa-search" aria-hidden="true"></i> </span><input type="text" class="form-control" ng-model="vm.search" ng-change="vm.localSearch()" placeholder="{{\'communication.new-conversation.searchTemplateMessage\' | translate}}"></div></div><br><div class="row" style="height: 350px; overflow: auto" ng-if="vm.templates.length"><div ng-repeat="template in vm.templates" class="box-shadow-template-message"><div style="display: flex; justify-content: space-between"><h5>{{template.elementName}}</h5><span ng-click="vm.onSelectTemplate(template)"><md-checkbox md-no-ink class="dynamic-color-checkbox check-template" ng-checked="template.id === vm.currentTemplate.id"></md-checkbox></span></div><p class="c-gray">{{template.bodyOriginal}}</p><button ng-if="template.buttons" ng-repeat="button in template.buttons" class="btn btn-second c-gray btn-template-message mr-2" disabled="disabled">{{button.parameter.text}}</button></div></div><div ng-if="!vm.templates.length" style="text-align: center; font-size: 1.1em; color: #6a6a6a">{{\'communication.new-conversation.templates-not-found\' | translate}}</div></div>');
$templateCache.put('app/admin/communication/new-conversation-modal/third-step.html','<div ng-if="!vm.isFb"><div class="row"><div class="box-shadow-template-message"><p class="c-gray">{{vm.currentTemplate.bodyOriginal}}</p><button ng-if="vm.currentTemplate.buttons" ng-repeat="button in vm.currentTemplate.buttons" class="btn btn-second c-gray btn-template-message mr-2" disabled="disabled">{{button.parameter.text}}</button></div><br><div class="form-group" ng-repeat="param in vm.currentTemplate.customParams"><label class="c-gray">{{\'communication.new-conversation.customField\' | translate}} {{vm.makeParamNameWithKeys(param.paramName)}}</label><input type="text" class="form-control" ng-change="vm.changeParamValue(param.paramName)" ng-model="vm.params[vm.makeParamNameWithKeys(param.paramName)].value" placeholder="{{vm.makeParamNameWithKeys(param.paramName)}}"></div></div></div><div ng-if="vm.isFb"><div class="row"><div class="col-xs-12"><label for="message" class="c-gray">{{\'communication.new-conversation.message\' | translate}}</label><textarea rows="5" class="form-control" name="message" id="message" ng-model="vm.tagMessage" type="text"></textarea></div></div></div>');
$templateCache.put('app/admin/communication/recommendation-modal/flyers-view-structure.html','<style>.badge-details {\n        color: #5E5E5E;\n        font-family: \'Roboto\';\n        font-size: 11px;\n        font-weight: 600;\n        padding: 6px 7px;\n        text-shadow: none;\n        margin-right: 6px;\n        margin-bottom: 6px;\n        border-radius: 0px;\n        font-weight: normal;\n    }\n\n    .with-stock {\n        background-color: #eaeaea;\n    }\n\n    .out-of-stock {\n        background-color: rgb(249 203 203);\n    }\n\n    .tag-info {\n        font-size: 12px; font-weight: 500; word-wrap: break-word;\n    }</style><div class="ibox" ng-show="vm.recommendedFlyers.length > 0" style="margin: 0px 20px"><div class="ibox-content" style="min-height: 600px"><div class="row"><div class="ibox-content flyer-table-box" ng-repeat="flyer in vm.recommendedFlyers"><div class="table-responsive"><table class="table shoping-cart-table"><tbody><tr width="100%"><td width="10%"><div class="cart-product-imitation flyer-table-img" style="background-size: 100% 100%; padding-top: 50px !important" ng-style="{\'background-image\': \'url(/flyer/api/{{flyer.id}}/picture)\'}"></div></td><td class="desc" width="60%"><h3 style="margin-top: -5px !important"><a class="text-navy"><small class="text-muted coupon-text-color product-category">{{flyer.category}}</small><p class="product-name" style="word-wrap: break-word">{{flyer.name}}</p></a></h3><div><span uib-tooltip="{{flyer.inventory == 0 ? \'Estoque esgotado\' : \'\'}}" ng-if="flyer.details.length == 0" class="badge badge-details with-stock" ng-class="{\'out-of-stock\': flyer.inventory == 0 }">Estoque: {{flyer.inventory != null ? flyer.inventory : \'Ilimitado\' }} </span><span uib-tooltip="{{item.inventory <= 0 && item.inventory != null ? \'Estoque esgotado\' : \'\'}}" ng-if="flyer.details.length > 0" ng-repeat="item in flyer.details" class="badge badge-details with-stock" ng-class="{\'out-of-stock\': item.inventory <= 0 && item.inventory != null }">{{ vm.storeCategory == FASHION ? \'Tam\' : \'Var\'}} {{item.size}}: {{item.inventory != null ? item.inventory : \'Ilimitado\' }}</span></div><span ng-repeat="tag in flyer.tags" class="badge badge-secondary badge-tag-flyer">{{tag}}</span><div style="margin-top: 6px"><!-- <span class="fa fa-tag" ng-class="{\'ksc-tag-active\': flyer.status == \'ACTIVATED\', \'ksc-tag-inactive\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}"></span>\n                                        <span class="flyer-table-info" ng-class="{\'flyer-active\': flyer.status == \'ACTIVATED\', \'flyer-disabled\': (flyer.status == \'DEACTIVATED\' || flyer.status == \'EXPIRED\')}">{{(flyer.status == \'ACTIVATED\' ? \'flyers.offer.active\' : \'flyers.offer.disabled\') | translate}}</span> --> <span class="tag-info" ng-if="flyer.productReference" style="color: #676a6c; font-size: 10px">{{\'Cod: \' + flyer.productReference }} </span><span class="tag-info" ng-show="flyer.expirationDate" style="margin-left: 15px" tooltip-placement="bottom-left" uib-tooltip="{{\'flyers.new.form.expirationDate\' | translate}}"><span class="fa fa-clock-o product-date">{{flyer.expirationDate | date: "dd/MM/yyyy"}}</span></span></div></td><td width="30%" style="padding-top: 0px"><div style="margin-top: 10px !important" class="checkbox flyer-checkbox-remove-margin" ng-click="$event.stopPropagation()"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfFlyerSelected(flyer.id)" ng-click="vm.refreshSelectedFlyers(flyer)"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div><div class="col-xs-12" style="margin-top: 24px"><span class="product-info-price-normal" style="white-space: nowrap" ng-if="flyer.purchaseValue && flyer.discountedValue"><span class="flyer-prices-remove-margin">{{flyer.currencyInstance.prefix}} </span><span class="coupon-desactived-decoration" style="white-space: nowrap">{{flyer.purchaseValue | number : 2}}</span></span><br><span class="product-info-price flyer-table-price" ng-if="flyer.discountedValue"><span class="flyer-prices-remove-margin">{{flyer.currencyInstance.prefix}} </span>{{flyer.discountedValue | number : 2}} </span><span class="product-info-price flyer-table-price" ng-if="!flyer.discountedValue && flyer.purchaseValue"><span class="flyer-prices-remove-margin">{{flyer.currencyInstance.prefix}} </span>{{flyer.purchaseValue | number : 2}}</span></div></td></tr></tbody></table></div><hr class="flyer-table-line"></div></div></div></div>');
$templateCache.put('app/admin/communication/recommendation-modal/recommendation.html','<style>.sub-title {\n        font-size: 1.0em;\n    }</style><div id="modal"><div class="modal-header" ng-if="vm.currentStep == 0"><h1 class="modal-title">Selecione Produtos</h1><span class="sub-title">Abaixo, selecione alguns produtos para seus clientes.</span></div><div class="modal-header" ng-if="vm.currentStep == 1"><h1 class="modal-title">Recomenda\xE7\xE3o de Produtos</h1><span class="sub-title">Abaixo, selecione recomenda\xE7\xF5es que ir\xE3o surpreender seus clientes.</span></div><div class="modal-header" ng-if="vm.currentStep == 2"><h1 class="modal-title">Sele\xE7\xE3o de Produtos</h1><span class="sub-title">Selecione os produtos relevantes com base nas nossas recomenda\xE7\xF5es.</span></div><div class="modal-header" ng-if="vm.currentStep == 3"><h1 class="modal-title">Envio da Mala</h1><span class="sub-title">D\xEA um nome a sua mala.</span></div><div class="modal-body" ng-if="vm.currentStep == 0" style="overflow-y: auto; height: 500px"><div class="row"><input type="text" name="inputSearch" class="form-control" style="margin: 19px; width: 93%" ng-change="vm.loadFlyers()" placeholder="Buscar Produtos" ng-model="vm.listFilter.text" ng-model-options="{ debounce: 500 }"><div class="row" style="float: right"><div style="margin-right: 65px !important" class="checkbox flyer-checkbox-remove-margin"><label><label style="margin-right: 10px" class="ng-binding">Selecionar todos</label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="!vm.hasSome(vm.excludes, vm.recommendIds)" ng-click="vm.onSelectAll()"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div></div><div ng-include="\'app/admin/communication/recommendation-modal/flyers-view-structure.html\'" ng-if="vm.recommendedFlyers.length > 0"></div><div class="col-xs-12 showcase-box-noflyer" ng-if="vm.recommendedFlyers.length == 0" style="margin-top: 10px"><img ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/showkase/download-panfletos.png" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/showkase/download-panfletos.png"><h1 class="ng-scope">Nenhum produto encontrado</h1></div></div></div><div class="modal-body" ng-if="vm.currentStep == 1"><div class="shadow p-1 mb-5 bg-white rounded"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-not-empty" aria-invalid="false" ng-model="vm.trendRec"> <span id="checkEnableSchedules" class="checkbox-material"><span class="check"></span></span> <span class="ng-scope">Recomenda\xE7\xE3o por Tendencias</span></label></div></div><div class="shadow p-1 mb-5 bg-white rounded" style="margin-top: 15px" ng-if="vm.trendRec"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-not-empty" aria-invalid="false" ng-model="vm.boughtTogetherRec"> <span id="checkEnableSchedules" class="checkbox-material"><span class="check"></span></span> <span class="ng-scope">Itens comprados juntos</span></label></div></div><div class="shadow p-1 mb-5 bg-white rounded" style="margin-top: 15px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-not-empty" aria-invalid="false" ng-model="vm.clusterRec"> <span id="checkEnableSchedules" class="checkbox-material"><span class="check"></span></span> <span class="ng-scope">Clientes similares</span></label></div></div><div class="shadow p-1 mb-5 bg-white rounded" style="margin-top: 15px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-not-empty" aria-invalid="false" ng-model="vm.SVDRec"> <span id="checkEnableSchedules" class="checkbox-material"><span class="check"></span></span> <span class="ng-scope">Por matriz</span></label></div></div></div><div class="modal-body" ng-if="vm.currentStep == 2" style="overflow-y: auto; height: 500px"><div class="row"><div ng-include="\'app/admin/communication/recommendation-modal/flyers-view-structure.html\'" ng-if="vm.recommendedFlyers.length > 0"></div></div></div><div class="modal-body" ng-if="vm.currentStep == 3"><div class="checkbox" ng-if="!vm.isWati"><label><input type="checkbox" class="dropdown-item-checkbox ng-pristine ng-untouched ng-valid ng-not-empty" aria-invalid="false" ng-model="vm.isCarousel"> <span id="checkEnableSchedules" class="checkbox-material"><span class="check"></span></span> <span class="ng-scope">Enviar como Carrousel</span></label></div><div class="form-group" ng-if="!vm.isCarousel"><label for="bagName" class="ng-scope required">Nome da Mala</label><input id="bagName" name="bagName" class="form-control ng-pristine ng-valid ng-empty ng-touched" ng-model="vm.bagName" style="resize: none" aria-invalid="false"><p class="help-block form-invalid-field" ng-show="vm.bagName === undefined" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.bagName.length > 50" data-translate="entity.validation.maxlength" translate-value-max="50"></p><p class="help-block form-invalid-field" ng-show="vm.bagName.length < 4" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div><div class="modal-footer"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.backStep()"><span ng-if="vm.currentStep !== 0">Voltar</span> <span ng-if="vm.currentStep === 0">Cancelar</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.nextStep()" ng-if="vm.currentStep != 3"><span>Continuar</span></button> <button class="btn btn-primary btn-md" ng-disabled="vm.bagName.length < 4 && !vm.isCarousel" data-style="slide-left" ng-click="vm.createBagByRecommendation()" ng-if="vm.currentStep == 3"><span>Gerar Mala</span></button></div></div>');
$templateCache.put('app/admin/communication/select-contacts-modal/select-contacts-modal.html','<style>.main-modal {\n        padding: 0 15px;\n    }\n\n    .close {\n        font-weight: normal;\n        opacity: 1;\n        margin-right: -15px;\n    }\n\n    /* width */\n    ::-webkit-scrollbar {\n        width: 6px !important;\n    }\n\n    /* Track */\n    ::-webkit-scrollbar-track {\n        background: #f1f1f1;\n    }\n\n    /* Handle */\n    ::-webkit-scrollbar-thumb {\n        background: #888;\n        border-radius: 5px;\n    }\n\n    /* Handle on hover */\n    ::-webkit-scrollbar-thumb:hover {\n        background: #555;\n    }\n\n    .contact-list {\n        height: 100%;\n        border-radius: 5px;\n        overflow-y: auto;\n    }\n\n    .input-group {\n        margin-bottom: 20px;\n    }\n\n    .input, .input-group-addon {\n        background-color: #f5f6fa;\n        border: none;\n        border-bottom-left-radius: 5px;\n        border-top-left-radius: 5px;\n    }\n\n    .input-group-addon {\n        color: #c6c6ca;\n    }\n\n    .search-trace {\n        border-right: 1px solid #c6c6ca;\n        height: 50%;\n        display: block;\n        width: 18px;\n        position: absolute;\n        top: 8px;\n        left: 19px;\n    }\n\n    .check {\n        background-color: white;\n    }\n\n    .select-contacts-content {\n        display: flex;\n        height: 100%;\n        flex-direction: column;\n        margin-top: 15px;\n    }\n\n    .input, .input-group-addon {\n        background-color: #FFFFFF;\n        border: 1px solid #e5e6e7;\n    }\n\n    .buttons-content {\n        margin-top: 15px;\n        margin-bottom: 15px;\n    }\n\n    .no-contacts-found {\n        text-align: center;\n        margin: 15px;\n        font-size: 15px;\n    }\n\n    .modal-body {\n        padding: 0;\n    }\n\n    .contact-cell {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        padding: 15px 10px;\n        border-bottom: 2px solid #e7eaec;\n        outline: none;\n    }\n\n    .checkbox {\n        margin-right: 15px;\n    }\n\n    .contact-picture-content {\n        position: relative;\n        margin-right: 5px;\n    }\n\n    .contact-social-icon {\n        position: absolute;\n        bottom: -5px;\n        left: 50%;\n    }\n\n    .contact-social-icon img {\n        width: 22px;\n    }\n\n    .user-name {\n        white-space: normal;\n    }\n\n    .badge-ticket {\n        float: right;\n    }\n\n    .contact-name-content {\n        align-items: flex-start;\n        display: flex;\n        flex-direction: column;\n        margin-right: 10px;\n        min-width: 0px;\n    }\n\n    .contact-phone {\n        font-size: 13px;\n        color: #636363;\n        margin-right: 10px;\n        overflow: hidden;\n        display: block;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n\n    .alert-warning {\n        padding: 15px;\n    }\n\n    .dropdown-item-checkbox .checkbox .checkbox-material .check {\n        border: 2px solid #9a9a9a;\n    }</style><div class="main-modal" id="modal"><div class="modal-header"><button aria-hidden="true" class="close main-modal-btn-close" data-dismiss="modal" ng-click="vm.closeModal(false)" type="button">&times;</button><h3>{{\'communication.forward-messages-modal.title\' | translate}}</h3></div><div class="modal-body" ng-style="{\'height\': vm.isMobile ? \'calc(100vh - 130px)\' : \'calc(100vh - 245px)\'}"><div class="select-contacts-content"><div class="input-group form-group col-md-12"><span class="input-group-addon"><i class="fa fa-search"></i> </span><input class="input form-control" ng-change="vm.refreshContacts()" ng-model="vm.filters.searchString" ng-model-options="{ debounce: 500 }" placeholder="{{\'communication.forward-messages-modal.search-contact\' | translate}}" type="text"></div><div class="alert alert-warning alert-dismissable error-message-center" ng-if="vm.selectedContacts.length >= 5"><i class="fa fa-exclamation-triangle messages-amount-warning" aria-hidden="true"></i> <span class="messages-amount-warning-label" ng-style="{\'font-size\': !vm.isMobile ? \'14px\' : \'11px\'}">Voc\xEA s\xF3 pode compartilhar com at\xE9 5 pessoas.</span></div><div class="contact-list" id="contact-list" detect-scroll-to-bottom="vm.conversationsScrolledToBottom"><div class="contact-cell" ng-repeat="contact in vm.contacts" ng-click="vm.selectOne(contact)"><div class="checkbox" ng-click="$event.stopPropagation()"><label><input class="dropdown-item-checkbox" ng-disabled="(!vm.checkIfContactSelected(contact) && vm.selectedContacts.length >= 5) || vm.loadingForwardMessages" ng-checked="vm.checkIfContactSelected(contact)" ng-click="vm.selectOne(contact)" type="checkbox"> <span class="checkbox-material"><span class="check m-0"></span></span></label></div><div class="contact-picture-content"><img class="profile-pic" ng-src="./assets/images/avatar.png"><div class="contact-social-icon"><img alt="" src="/content/images/icon-whatsapp.png"></div></div><div class="user-cell"><div class="contact-name-content w-100"><div class="user-name">{{contact.name}}</div><span class="contact-phone w-100">{{contact.chatUserId}} <span class="badge-ticket" ng-class="{\n                                                \'bg-green\': contact.status == \'NEW\',\n                                                \'bg-red\': contact.status == \'OPENED\',\n                                                \'bg-blue\': contact.status == \'PENDING\',\n                                                \'bg-grey\': contact.status == \'RESOLVED\',\n                                                \'bg-purple\': contact.status == \'EXPIRED\'}">{{ vm.status[contact.status] }}</span></span></div></div></div><div class="no-contacts-found" ng-if="vm.contacts.length === 0 && !vm.loadingContacts && vm.filters.searchString.trim() !== \'\'"><p>{{\'communication.forward-messages-modal.no-contact-found\' | translate}}</p></div><div class="no-contacts-found" ng-if="vm.labelNoContactsAvailable()"><p>{{\'communication.forward-messages-modal.no-contact-available\' | translate}}</p></div><div class="sk-container" ng-if="vm.loadingContacts" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div><div class="buttons-content" ng-class="{\'ml-auto\': !vm.isMobile}"><button class="btn btn-primary btn-md" style="min-width: 7vw" ng-click="vm.sendMessages()" ng-class="{\'w-100\': vm.isMobile}" ng-disabled="!vm.selectContactsValidation() || vm.loadingForwardMessages"><span ng-if="!vm.loadingForwardMessages">{{"communication.forward-messages-modal.forward-messages" | translate }}</span><div class="sk-container" ng-if="vm.loadingForwardMessages"><div class="sk-spinner sk-spinner-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div></button></div></div></div></div>');
$templateCache.put('app/admin/communication/single-products/flyers-view-structure.html','<style>.engagements-list {\n        height: 450px;\n        max-height: 450px !important;\n    }</style><script>var mainColor = getComputedStyle(document.documentElement).getPropertyValue(\'--main-color-light\');\n    var interaction = document.getElementById("interaction");\n    if (interaction) {\n        interaction.style.backgroundColor = mainColor + \'31\';\n        interaction.style.color = mainColor;\n    }\n    var purchase = document.getElementById("purchase");\n    if (purchase) {\n        purchase.style.backgroundColor = mainColor + \'31\';\n        purchase.style.color = mainColor;\n    }</script><div><div><div class="ibox-content pl-0 pr-0 pt-0"><div class="row"><div class="col-lg-12"><div ng-if="vm.loadingUserOfferEngagements" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingUserOfferEngagements && (!vm.flyersFiltered || vm.flyersFiltered.length > 0)"><div class="engagements-list" detect-scroll-to-bottom="vm.flyerScrollToBottom" id="scroll-div" ng-style="{\'height\': vm.isMobile ? \'calc(100vh - 305px)\' : \'calc(100vh - 245px)\'}"><div style="margin-bottom: 10px" class="row engagement-product-card display-flex" ng-repeat="flyer in vm.flyersFiltered"><!-- foto --><div class="col-md-4 col-xs-4 pl-0 pr-0"><div class="cart-product-imitation flyer-table-img" style="background-size: 100% 100%; padding-top: 50px !important" ng-style="{\'background-image\': \'url(/flyer/api/{{flyer.id}}/picture)\'}"></div></div><!-- informa\xE7\xF5es gerais --><div class="col-md-7 col-xs-7 pl-0"><div class="row"><div class="col-md-12"><h3 style="margin-top: -5px !important"><span class="text-navy"><div><p class="text-ellipsis-two-lines" style="font-size: 14px;\n                                                                color: #676a6c;\n                                                                margin: 4px 0 5px 0; word-wrap: break-word">{{flyer.name}}</p></div></span></h3></div><div class="col-md-12"><div><span class="product-info-price flyer-table-price" ng-if="flyer.discountedValue" style="font-size: 16px"><span class="flyer-prices-remove-margin">{{vm.getCurrencyPrefix(flyer)}} </span>{{flyer.discountedValue | number : 2}}</span> <span class="product-info-price flyer-table-price" ng-if="!flyer.discountedValue && flyer.purchaseValue" style="font-size: 16px"><span class="flyer-prices-remove-margin">{{vm.getCurrencyPrefix(flyer)}} </span>{{flyer.purchaseValue | number : 2}}</span> <span class="product-info-price-normal" style="white-space: nowrap; color: #9f9f9f; font-weight: bold" ng-if="flyer.purchaseValue && flyer.discountedValue"><span class="flyer-prices-remove-margin">{{vm.getCurrencyPrefix(flyer)}} </span><span class="coupon-desactived-decoration" style="white-space: nowrap">{{flyer.purchaseValue | number : 2}}</span></span></div></div><div ng-if="flyer.productReference" class="col-md-12" style="margin-top: 5px"><div><span class="tag-info" style="color: #9f9f9f; font-size: 12px"><span class="">Cod: {{ flyer.productReference }}</span></span></div></div><div class="col-md-12 pr-0" style="margin-top: 5px"><div><label id="interaction" style="border-radius: 10px; padding: 3px 10px; display: inline-block; margin: 3px 3px; font-size: 9px" ng-if="flyer.details.length > 0" ng-repeat="item in flyer.details" class="label label-primary" ng-class="item.inventory === 0 ? \'out-of-stock\' : \'cancel-button\'">{{item.size}}: {{item.inventory != null ? item.inventory : \'Ilimitado\' }}</label></div></div></div></div><div class="col-md-1 col-xs-1 pl-0" ng-class="{\'not-allowed-cursor\': !vm.checkIfFlyerSelected(flyer.id) && vm.selectedProductsLen() >= 10}"><div style="margin-top: 10px !important" class="checkbox flyer-checkbox-remove-margin" ng-click="$event.stopPropagation()"><label><span ng-click="vm.refreshSelectedFlyers(flyer)"><md-checkbox md-no-ink class="dynamic-color-checkbox check-template" ng-disabled="(!vm.checkIfFlyerSelected(flyer.id) && vm.selectedProductsLen() >= 10) || vm.isSendingMessage" ng-class="{\'not-allowed-cursor\': (!vm.checkIfFlyerSelected(flyer.id) && vm.selectedProductsLen() >= 10) || vm.isSendingMessage}" ng-checked="vm.checkIfFlyerSelected(flyer.id)"></md-checkbox></span></label></div></div></div><hr class="flyer-table-line"></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/communication/single-products/single-products.html','<style>.sub-title {\n        font-size: 1.0em;\n    }\n\n    md-select-menu md-content {\n        -webkit-overflow-scrolling: fixed !important;\n    }\n\n    .md-select-menu-container {\n        z-index: 3000 !important;\n    }\n\n    .custom-md-input md-input-container {\n        display: inherit;\n        margin: unset;\n    }\n\n    .custom-md-input md-select.md-default-theme .md-select-value,\n    md-select .md-select-value {\n        border-color: rgba(0, 0, 0, 0.12) !important;\n        border: 1px;\n        border-style: solid;\n    }\n\n    .custom-select[multiple] .md-select-value span:first-child {\n        visibility: collapse;\n    }\n\n    .custom-select[multiple] .md-select-value .md-text {\n        display: inline-block !important;\n        visibility: visible;\n        background-color: rgb(224, 224, 224);\n        border-radius: 6px;\n        padding: 3px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected],\n    md-select-menu md-content md-option[selected] {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected]:focus,\n    md-select-menu md-content md-option[selected]:focus {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-checkbox-enabled.md-default-theme[selected] .md-icon,\n    .md-checkbox-enabled[selected] .md-icon {\n        background-color: var(--main-color) !important;\n    }\n\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\n    md-select-menu md-content md-option:not([disabled]):focus,\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\n    md-select-menu md-content md-option:not([disabled]):hover {\n        background: none;\n    }\n\n    .highlight {\n        background: #f3f3f4;\n        padding: 5px;\n        display: inline-block;\n        color: #5E5E5E;\n        border-radius: 10px;\n        padding-bottom: 2px;\n        padding-top: 2px;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    md-select-menu {\n        margin-top: 50px;\n        width: 150.674px !important;\n        margin-left: 39px;\n    }\n\n    .remove-dropdown {\n        display: none !important;\n    }\n\n    .empty-list md-select-menu {\n        margin-top: 42px;\n        width: 192.674px !important;\n        margin-left: -1px;\n    }\n\n    md-select.md-default-theme[disabled] .md-select-value, md-select[disabled] .md-select-value {\n        background-image: none !important;\n    }</style><div id="modal" ng-click="vm.closeDropDown($event)" style="cursor: default"><div class="modal-header" style="border-bottom: none"><button aria-hidden="true" class="close main-modal-btn-close" data-dismiss="modal" ng-click="vm.closeModal()" type="button">&times;</button><h1 class="modal-title" style="margin-left: 15px">Envio de produtos</h1><span class="sub-title" style="margin-left: 15px">Selecione at\xE9 10 produtos relevantes para o envio.</span></div><div class="modal-body single-products-modal"><div class="row"><div class="col-md-12 form-group"><div class="display-flex"><!-- <div class="input-group"> --> <span class="input-group-addon" style="padding: 9px 20px 9px 10px"><span class="fa fa-search"></span> </span><input class="form-control bag-chat-input-search" name="inputSearch" ng-change="vm.searchFlyers()" ng-model="vm.filters.text" ng-disabled="vm.isSendingMessage" ng-model-options="{ debounce: 500 }" placeholder="Buscar Produtos por nome ou c\xF3digo de refer\xEAncia" style="border-left: 0px; width: 97%; padding-left: 0px; margin-right: 20px" type="text"><!-- </div> --><div class="btn-group preferences"><button aria-expanded="false" ng-disabled="vm.isSendingMessage" aria-haspopup="true" class="btn-dropdown-status dropdown-toggle preferences display-flex" data-toggle="dropdown" ng-click="vm.changeActive()" style="box-shadow:none; box-shadow:none;padding-top: 6px;padding-bottom: 6px" type="button"><span style="padding-right: 5px">Filtros </span><span class="numberCircle" style="margin-top: 0px !important">{{vm.filtersLen}}</span> <span class="bag-chat-arrow fa arrow" id="preferences-arrow" ng-class="{\'active\': vm.isActive}"></span></button><div class="dropdown-menu dropdown-menu-right-custom bag-chat-dropdown bag-chat-filter" ng-click="$event.stopPropagation();" style="color: black;cursor: default"><div class="row"><div class="col-md-12"><div class="row"><!-- category --><div class="form-group col-md-6 col-sm-12"><label data-translate="flyers.new.form.category" for="size">Categories</label><div class="dropdown custom-md-input"><md-input-container class="category-select" ng-if="vm.categories.length"><md-select class="custom-select-value" disableoptioncentering md-selected-html="vm.getSelectedTextCategory(vm.filters.categories)" multiple="multiple" ng-model="vm.filters.categories"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="category in vm.categories" ng-value="category.key">{{category.title}}</md-option></div></md-select></md-input-container><md-input-container class="category-select" ng-if="!vm.categories.length"><md-select class="custom-select-value" disableoptioncentering disabled="!vm.categories.length" multiple="multiple" ng-model="vm.filters.categories" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><!-- gender --><div class="form-group col-md-6 col-sm-12"><label data-translate="flyers.new.form.gender.title" for="gender">Gender</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="gender-select" ng-if="vm.genders.length"><md-select class="custom-select-value" md-selected-html="vm.getSelectedTextGender(vm.filters.genders)" multiple="multiple" ng-model="vm.filters.genders"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="gender in vm.genders" ng-value="gender">{{vm.getTranslateGenders(gender) | translate}}</md-option></div></md-select></md-input-container><md-input-container class="gender-select" ng-if="!vm.genders.length"><md-select class="custom-select-value" disabled="!vm.genders.length" multiple="multiple" ng-model="vm.filters.genders" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div></div></div><div class="col-md-12"><div class="row"><!-- size --><div class="form-group col-md-6 col-sm-12"><label for="size">{{ vm.storeCategory == FASHION ? \'flyers.new.form.size.title\' : \'flyers.new.form.variation\' | translate }}</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="size-select" ng-if="vm.sizes.length"><md-select class="custom-select-value" md-selected-html="vm.getSelectedText(vm.filters.sizes)" multiple="multiple" ng-model="vm.filters.sizes"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="size in vm.sizes" ng-value="size">{{size}}</md-option></div></md-select></md-input-container><md-input-container class="size-select" ng-if="!vm.sizes.length"><md-select class="custom-select-value" disabled="!vm.sizes.length" multiple="multiple" ng-model="vm.filters.sizes" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><!-- etiqueta --><div class="form-group col-md-6 col-sm-12"><label data-translate="flyers.new.form.tags.title" for="size">Tags</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="tag-select" ng-if="vm.tags.length"><md-select class="custom-select-value" md-selected-html="vm.getSelectedText(vm.filters.tags)" multiple="multiple" ng-model="vm.filters.tags"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="tag in vm.tags" ng-value="tag">{{tag}}</md-option></div></md-select></md-input-container><md-input-container class="tag-select" ng-if="!vm.tags.length"><md-select class="custom-select-value" disabled="!vm.tags.length" multiple="multiple" ng-model="vm.filters.tags" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div></div></div><div class="col-md-12"><div class="row"><!-- brand --><div class="form-group col-md-6 col-sm-12"><label data-translate="flyers.new.form.brand" for="brand">Brand</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select class="custom-select-value" md-selected-html="vm.getSelectedText(vm.filters.brands)" multiple="multiple" ng-model="vm.filters.brands"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="brand in vm.brands" ng-value="brand">{{brand}}</md-option></div></md-select></md-input-container><md-input-container class="brand-select" ng-if="!vm.brands.length"><md-select class="custom-select-value" disabled="!vm.brands.length" multiple="multiple" ng-model="vm.filters.brands" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><!-- color --><div class="form-group col-md-6 col-sm-12"><label data-translate="flyers.new.form.color" for="color">Color</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="color-select" ng-if="vm.colors.length"><md-select class="custom-select-value" md-selected-html="vm.getSelectedText(vm.filters.colors)" multiple="multiple" ng-model="vm.filters.colors"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="color in vm.colors" ng-value="color">{{color}}</md-option></div></md-select></md-input-container><md-input-container class="color-select" ng-if="!vm.colors.length"><md-select class="custom-select-value" disabled="!vm.colors.length" multiple="multiple" ng-model="vm.filters.colors" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div></div></div></div><div style="text-align: right"><button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.filterFlyers();"><span>Aplicar</span></button></div></div></div></div></div><div ng-if="vm.flyersFiltered.length > 0" ng-include="\'app/admin/communication/single-products/flyers-view-structure.html\'"></div><div class="col-xs-12 showcase-box-noflyer" ng-if="vm.flyersFiltered === undefined || vm.flyersFiltered.length == 0" style="margin-top: 100px"><img src="./assets/images/product-not-found.png"><h4 class="ng-scope" style="color: #a3a3a3; margin-bottom: 1px">Nenhum produto encontrado</h4><h4 class="ng-scope" style="color: #a3a3a3; margin-top: 0px">com essa combina\xE7\xE3o de prefer\xEAncias.</h4></div></div></div><div class="modal-footer" style="border-top: none; padding-top: 20px !important"><div class="row" ng-if="vm.flyersFiltered.length > 0" style="float: left"><p style="margin-left: 20px; color: #a3a3a3">{{vm.totalFlyers}}/10 Selecionados</p></div><button class="btn btn-default btn-lg cancel-button" data-style="slide-left" ng-click="vm.closeModal()"><span>Cancelar</span></button> <button class="btn btn-primary btn-lg" data-style="slide-left" style="min-width: 90px" ng-click="vm.sendProducts()" ng-disabled="vm.selectedProductsLen() === 0 || vm.isSendingMessage"><span ng-show="!vm.isSendingMessage">Enviar</span><div class="sk-spinner sk-spinner-circle" ng-show="vm.isSendingMessage"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></button></div></div>');
$templateCache.put('app/admin/communication/social-networks-connect/first-step.html','<script>var mainColor = getComputedStyle(document.documentElement).getPropertyValue(\'--main-color-light\');\n    var alert = document.getElementById("alert");\n    alert.style.backgroundColor = mainColor + \'61\';</script><div class="row"><div class="col-md-6"><div class="card-connection"><md-checkbox md-no-ink class="dynamic-color-checkbox chk-social-network-connect custom-checkbox" ng-model="vm.faceinsta" id="chkSocialNetworkConnect" ng-change="vm.selectSocialNetwork(vm.SOCIAL_NETWORKS.FACE_INSTA)"></md-checkbox><div class="card-connection-body"><img id="facebook-instagram" src="content/images/icon-messenger-instagram.png" alt=""><h4>Facebook e Instagram</h4></div></div></div><div class="col-md-6"><div class="card-connection"><md-checkbox md-no-ink class="dynamic-color-checkbox chk-social-network-connect custom-checkbox" ng-model="vm.whatsapp" id="chkSocialNetworkConnect" ng-change="vm.selectSocialNetwork(vm.SOCIAL_NETWORKS.WHATSAPP)"></md-checkbox><div class="card-connection-body"><img id="whatsapp" src="content/images/icon-whatsapp-connection.png" alt=""><h4>WhatsApp Bussiness API</h4></div></div></div></div><div class="row" style="margin-top: 60px"><div class="col-md-12"><div ng-if="vm.faceinsta || vm.whatsapp" id="alert" uib-alert class="alert-purple"><div style="display: flex; justify-content: flex-start; align-items: center"><i class="fa fa-info-circle" style="font-size: 45px; margin-right: 15px"></i> <span ng-if="vm.whatsapp" style="font-size: 18px" data-translate="communication.connect-modal.whatsapp-alert"></span> <span ng-if="vm.faceinsta" style="font-size: 18px" data-translate="communication.connect-modal.facebook-alert"></span></div></div></div></div>');
$templateCache.put('app/admin/communication/social-networks-connect/second-step.html','<div class="row"><div class="col-md-8 col-md-offset-2"><div style="text-align: center"><h2 data-translate="communication.connect-modal.wati-copy-link-title"></h2><div class="copy-link-container"><i class="fa-rotate-270 fa fa-link"></i> <span>{{ vm.webhook }}</span><div uib-popover="Copiado!" popover-is-open="{{vm.popoverIsOpen}}" ng-click="vm.changeTextPopover()"><a href="#" copy-to-clipboard="{{vm.webhook}}">{{ \'communication.connect-modal.wati-copy-link-button\' | translate }}</a></div></div></div></div></div>');
$templateCache.put('app/admin/communication/social-networks-connect/social-networks-connect.html','<style>.progress-bar-success {\n        background-color: var(--main-color) !important;\n    }</style><div class="container-modal-connect" id="modal"><div class="modal-header" style="border-bottom: none; padding: 35px !important"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><div ng-if="vm.step === 0"><h1 class="modal-title">{{ \'communication.connect-modal.first-step.title\' | translate }}</h1><span class="sub-title">{{ \'communication.connect-modal.first-step.subtitle\' | translate }}</span></div><div ng-if="vm.step === 1"><h1 class="modal-title">{{ \'communication.connect-modal.second-step.title\' | translate }}</h1><span class="sub-title">{{ \'communication.connect-modal.second-step.subtitle\' | translate }}</span></div><div ng-if="vm.step === 2"><h1 class="modal-title">{{ \'communication.connect-modal.third-step.title\' | translate }}</h1><span class="sub-title">{{ \'communication.connect-modal.third-step.subtitle\' | translate }}</span></div><div class="slide-container"><div class="slide-dot" ng-class="{\'dot-activated\': vm.step === 0}"></div><div class="slide-dot" ng-class="{\'dot-activated\': vm.step === 1}"></div><div class="slide-dot" ng-class="{\'dot-activated\': vm.step === 2}"></div></div></div><div class="modal-body" style="padding: 0 35px"><div ng-if="vm.step === 0" ng-include="\'app/admin/communication/social-networks-connect/first-step.html\'"></div><div ng-if="vm.step === 1" ng-include="\'app/admin/communication/social-networks-connect/second-step.html\'"></div><div ng-if="vm.step === 2" ng-include="\'app/admin/communication/social-networks-connect/third-step.html\'"></div></div><div class="col-md-10 col-md-offset-1 m-t-md m-b-md" ng-show="vm.isSaving"><span class="h5">Estamos sincronizando as conversas do Whatsapp, aguarde...</span><uib-progressbar class="progress-striped active" value="vm.syncProgress" type="success">{{vm.syncProgress}}%</uib-progressbar></div><div class="modal-footer" style="border-top: none; padding: 35px"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.previousStep()"><span>{{ \'entity.action.cancel\' | translate }}</span></button> <button ng-disabled="!vm.whatsapp && !vm.faceinsta" class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.nextStep()" ng-if="vm.step != 2"><span>{{ \'communication.connect-modal.buttons.continue\' | translate }}</span></button> <button ng-disabled="vm.isSaving || vm.watiAccountData.$invalid" ladda="vm.isSaving" class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.saveSetting()" ng-if="vm.step == 2"><span>{{ \'communication.connect-modal.buttons.connect\' | translate }}</span></button></div></div>');
$templateCache.put('app/admin/communication/social-networks-connect/third-step.html','<div class="row"><div class="col-md-10 col-md-offset-1"><div class=""><form name="vm.watiAccountDataForm" novalidate><div class="form-group col-xs-12 col-md-12"><label class="required" for="watiToken" style="color: #626262; font-size: 14px">{{ \'communication.connect-modal.wati-access-token\' | translate }}</label><input id="watiToken" name="watiToken" ng-model="vm.watiAccountData.watiToken" type="text" class="form-control" required placeholder="Ex: Bearer 1WJHS..."><div ng-show="vm.watiAccountDataForm.watiToken.$invalid && vm.watiAccountDataForm.watiToken.$touched"><p class="help-block form-invalid-field" ng-show="vm.watiAccountDataForm.watiToken.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-xs-12 col-md-12"><label class="required" for="watiUri" style="color: #626262; font-size: 14px">{{ \'communication.connect-modal.wati-url-api\' | translate }}</label><input id="watiUri" name="watiUri" ng-model="vm.watiAccountData.watiUri" type="text" class="form-control" required placeholder="Ex: https://live-server-5658.whats.com"><div ng-show="vm.watiAccountDataForm.watiUri.$invalid && vm.watiAccountDataForm.watiUri.$touched"><p class="help-block form-invalid-field" ng-show="vm.watiAccountDataForm.watiUri.$error.required" data-translate="entity.validation.required"></p></div></div></form></div></div></div>');
$templateCache.put('app/admin/communication/template-message/_modal_delete_template_message.html','<div style="z-index: 2500 !important"><div class="modal-body"><span style="font-size: 1.3em" class="modal-title" data-translate="customer.label.delete" translate-value-name="{{vm.template.template}}"></span></div><div class="modal-footer"><button ng-click="vm.cancel()" class="btn btn-default btn-md" data-style="slide-left"><span>Cancel</span></button> <button ng-click="vm.ok()" class="btn btn-primary btn-md" data-style="slide-left"><span>Deletar</span></button></div></div>');
$templateCache.put('app/admin/communication/template-message/template-message.html','<div id="modal" ng-class="{\'modal-oppacity\': vm.removeModalActive}"><div class="modal-header"><h1 class="modal-title">Mensagens R\xE1pidas</h1></div><div class="modal-body"><div class="row" style="display: flex; justify-content: space-between; margin-left: -32px"><div class="col-md-9"><div class="form-group"><label for="template" class="ng-scope">Salvar Mensagem</label><input id="template" name="template" class="form-control ng-pristine ng-valid ng-empty ng-touched" ng-model="vm.template" ng-change="vm.checkIfIsBlank()" style="resize: none" aria-invalid="false"></div></div><div class="col-md-2"><button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.addTemplate()" style="margin-top: 23px"><span>Salvar</span></button></div></div><div ng-if="vm.templates.length === 0" style="text-align: center; margin-top: 30px"><p>N\xE3o h\xE1 nenhuma mensagem r\xE1pida cadastrada.</p></div><table class="table table-striped"><thead><tr><th ng-if="vm.templates.length > 0">Mensagem</th><th ng-if="vm.templates.length > 0" class="pull-right">A\xE7\xF5es</th></tr></thead><tbody><tr ng-repeat="template in vm.templates"><td class="store-col-center">{{template.template}}</td><td><span class="pull-right actions-buttons" style="margin-top: 3px"><span class="fa fa-paper-plane-o store-detail-button" ng-click="vm.sendTemplate(template)" data-toggle="tooltip" data-placement="top" title="Enviar Template" role="button" style="padding-right: 9px; color: #676a6cd6" tabindex="0"></span> <span class="fa fa-pencil-square-o store-detail-button" ng-click="vm.onSelectTemplate(template)" data-toggle="tooltip" data-placement="top" title="Atualizar Template" role="button" style="padding-right: 9px; color: #676a6cd6" tabindex="0"></span> <span class="fa fa-trash store-detail-button" ng-click="vm.remove(template)" data-toggle="tooltip" data-placement="top" title="Deletar Template" role="button" style="color: #676a6cd6" tabindex="0"></span></span></td></tr></tbody></table></div><div class="modal-footer"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.dismiss()"><span>Cancelar</span></button></div></div>');
$templateCache.put('app/admin/communication/view-chat-order-modal/view-chat-order-modal.html','<div id="modal" class="main-modal"><div class="modal-header"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal(false)">&times;</button><h3>{{\'communication.view-chat-order.title\' | translate}}</h3></div><div class="modal-body"><div class="scrollable-orders-container"><div ng-repeat="order in vm.ordersList"><div class="order-container"><img class="order-image" ng-src="{{order.imageUrl ? order.imageUrl : \'content/images/default-product-image.png\'}}" alt="image"><div class="w-100 order-info-content"><span class="font-weight-bold">{{order.name ? order.name : \'-\'}}</span><div class="display-flex order-value"><span>&times; {{order.quantity}}</span> <span class="font-weight-bold order-price">R$ {{order.price.toFixed(2)}}</span></div></div></div></div></div></div></div><style>.scrollable-orders-container {\n        max-height: 50vh;\n        overflow-y: auto;\n    }\n\n    .order-container {\n        display: flex;\n        background-color: #f6f6f6;\n        margin-bottom: 10px;\n        border-radius: 8px;\n    }\n\n    .order-info-content {\n        margin: auto 25px;\n        font-size: 17px;\n    }\n\n    .order-value {\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .order-image {\n        height: 80px;\n        width: 80px;\n        min-width: 80px;\n        min-height: 80px;\n        object-fit: cover;\n        background: white;\n        border-radius: 5px 0px 0px 5px;\n    }\n\n    .order-price {\n        color: var(--main-color);\n    }</style>');
$templateCache.put('app/admin/components/balloon/informative-balloon.html','<style>.cost-box {\n        display: flex;\n        align-items: center;\n        color: var(--main-color-light);\n        background-color: #dfd7ed;\n        border-radius: 5px;\n    }\n\n    .cost-text {\n        font-size: 12px;\n        text-align: justify;\n        opacity: 1;\n        padding: 10px;\n        font-weight: 400;\n    }\n\n    .cost-icon {\n        font-size: xx-large;\n        -moz-transform: scale(-1, 1);\n        -webkit-transform: scale(-1, 1);\n        -o-transform: scale(-1, 1);\n        -ms-transform: scale(-1, 1);\n        transform: scale(-1, 1);\n    }</style><div class="col-sm-12 cost-box"><i class="icon-ksc-comment-exclamation-regular cost-icon" aria-hidden="true"></i><p class="m-0 cost-text" data-translate="{{messageId}}"></p></div>');
$templateCache.put('app/admin/components/balloon/warning-balloon.html','<style>.cost-box {\n        display: flex;\n        align-items: center;\n        color: var(--main-color-light);\n        background-color: #dfd7ed;\n        border-radius: 5px;\n    }\n\n    .cost-text {\n        font-size: 12px;\n        text-align: justify;\n        opacity: 1;\n        padding: 10px;\n        font-weight: 400;\n    }\n\n    .cost-icon {\n        font-size: xx-large;\n        -moz-transform: scale(-1, 1);\n        -webkit-transform: scale(-1, 1);\n        -o-transform: scale(-1, 1);\n        -ms-transform: scale(-1, 1);\n        transform: scale(-1, 1);\n    }</style><div class="col-sm-12 display-horizontally-inline alert alert-warning no-templates-box" style="padding-top: 0px; padding-bottom: 0px"><i class="fa fa-warning cost-icon" style="color: #fdbe2d" aria-hidden="true"></i><p class="m-0 cost-text ng-scope" data-translate="{{messageId}}"></p></div>');
$templateCache.put('app/admin/customer/import/customers-import.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-sm-12"><div class="ibox"><div class="ibox-content"><div class="row" style="margin-top: 10px"><div class="col-md-6" has-authority="STORE_CREATE_CUSTOMER"><button class="btn btn-primary" type="file" ngf-select="vm.uploadFile($file, $invalidFiles)" ngf-accept="\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\'" ngf-pattern="\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\'"><i class="fa fa-cloud-upload"></i> <span data-translate="customer.button.upload">Upload</span></button> <a target="_self" ng-href="{{ vm.getDownloadLinkToTemplate() }}" class="btn btn-primary"><i class="fa fa-cloud-download"></i> <span data-translate="customer.button.downloadTemplate">Download Template</span></a></div><div ng-show="!vm.isUploading && vm.customersImported.length == 0" class="col-sm-12" style="margin-top: 15px; margin-left: 10px"><p data-translate="customer.import.steps.one"></p><p data-translate="customer.import.steps.two"></p><p data-translate="customer.import.steps.three"></p><p data-translate="customer.import.steps.four"></p><p data-translate="customer.import.steps.five"></p></div></div><div class="row" ng-include="\'app/admin/customer/import/customers-table-preview.html\'"></div><div class="row"><div class="col-sm-12"><div class="hr-line-dashed"></div></div><div class="pull-right" has-authority="STORE_CREATE_CUSTOMER" style="padding-right: 1%"><button ng-click="vm.cancel()" class="btn btn-default"><span data-translate="customer.button.cancel">Cancel</span></button> <button ladda="vm.isSaving" ng-click="vm.save()" ng-disabled="!vm.allStatusOk" class="btn btn-primary"><span data-translate="customer.button.save">Save</span></button></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/customer/import/customers-table-preview.html','<div ng-show="!vm.isUploading" class="tab-content" ng-if="vm.customersImported.length > 0" style="margin: 12px"><div id="tab-1" class="tab-pane active"><div class="full-height-scroll" full-scroll><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th width="35%"><span data-translate="global.form.customerName">Full Name</span></th><th width="15%"><span data-translate="global.form.phone">Phone</span></th><th width="25%"><span data-translate="global.form.email">Email</span></th><th width="5%"><span data-translate="customer.import.status">Status</span></th><th width="20%"><span data-translate="customer.import.statusDescription">Description</span></th></tr></thead><tbody><tr ng-repeat="customer in vm.filteredCustomers"><td class="client-avatar" style="width: auto"><img alt="image" src="/content/images/profile_small.png"> <span class="client-link" ng-bind="customer.fullName" style="padding-left: 10px"></span></td><td><i class="fa fa-phone contact-type"></i> <span ng-bind="customer.phone"></span></td><td><i class="fa fa-envelope contact-type"></i> <span ng-bind="customer.email"></span></td><td style="text-align: center"><i ng-if="customer.errors.length == 0" class="fa fa-check" ng-style="{\'color\' : \'#00ce0a\', \'padding-right\' : \'10px\'}"></i> <i ng-if="customer.errors.length > 0" class="fa fa-times" ng-style="{\'color\' : \'#ff0000\', \'padding-right\' : \'10px\'}"></i></td><td ng-if="customer.errors.length > 0"><div ng-repeat="error in customer.errors"><span data-translate="customer.import.error.{{error}}"></span></div></td><td ng-if="customer.errors.length == 0"><span data-translate="customer.import.statusSuccessfulDescription"></span></td></tr></tbody></table></div></div><div class="col-sm-12" align="center"><uib-pagination ng-model="vm.currentPage" total-items="vm.customersImported.length" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{start: \'{{vm.startRegistry}}\', end: \'{{vm.endRegistry}}\', total: \'{{vm.customersImported.length}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.customersImported.length }}</p></div></div></div></div><div ng-if="vm.isUploading" class="tab-content" style="height: 602px; display: flex;\n                            align-items: center;\n                            justify-content: center"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div>');
$templateCache.put('app/admin/digital-poster/components/digital-poster.form.html','<form name="vm.posterEditForm" style="min-height: 640px"><div class="row"><div class="col-xs-12" style="padding-bottom: 10px"><h3 data-translate="digitalPoster.creater.title" style="color: #606062; font-size: 1.4em; font-family: Humanst521 Lt BT"></h3></div><div class="col-xs-12"><label style="color: #606062; font-size: 1.0em" for="pageSize" class="required" data-translate="digitalPoster.creater.fields.pageSize">Page size:</label><select class="form-control" name="pageSize" id="pageSize" ng-options="p.key as p.title for p in vm.pagesTypes" ng-model="vm.poster.pageSize" required></select><div ng-show="vm.posterEditForm.pageSize.$invalid && vm.posterEditForm.pageSize.$dirty"><p class="help-block form-invalid-field" ng-show="vm.posterEditForm.pageSize.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row" style="padding-top: 15px"><div class="col-xs-12"><label style="color: #606062; font-size: 1.0em" for="campaign" class="required" data-translate="digitalPoster.creater.fields.campaign">Campaign:</label><select class="form-control" name="campaign" id="campaign" ng-options="c.key as c.title for c in vm.campaignTypes" ng-model="vm.poster.campaign" required></select><div ng-show="vm.posterEditForm.campaign.$invalid && vm.posterEditForm.campaign.$dirty"><p class="help-block form-invalid-field" ng-show="vm.posterEditForm.campaign.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row" style="padding-top: 15px"><div class="col-xs-12"><label style="color: #606062; font-size: 1.0em" for="campaign" data-translate="digitalPoster.creater.fields.productName" class="required">Product Name:</label><input class="form-control" required name="productName" id="productName" ng-model="vm.poster.productName"></div><div class="col-xs-12" ng-show="vm.poster.productName.length > vm.productNameSize"><p class="help-block form-invalid-field" data-translate="entity.validation.max" translate-value-max="{{vm.productNameSize}}">MAX</p></div></div><div class="row" style="padding-top: 15px"><div class="col-xs-12"><label style="color: #606062; font-size: 1.0em" for="description" data-translate="digitalPoster.creater.fields.productDescription">Product Description:</label><textarea class="form-control" name="description" id="description" ng-model="vm.poster.description" type="text"></textarea></div><div class="col-xs-12" ng-show="vm.poster.description.length > vm.descriptionSize"><p class="help-block form-invalid-field" data-translate="entity.validation.max" translate-value-max="{{vm.descriptionSize}}">MAX</p></div></div><div class="row" style="padding-top: 15px"><div class="col-xs-12"><label style="color: #606062; font-size: 1.0em" for="productCode" data-translate="digitalPoster.creater.fields.productCode">Product Code:</label><input class="form-control" name="productCode" id="productCode" ng-model="vm.poster.code"></div><div class="col-xs-12" ng-show="vm.poster.code.length > vm.productCodeSize"><p class="help-block form-invalid-field" data-translate="entity.validation.max" translate-value-max="{{vm.productCodeSize}}">MAX</p></div></div><div class="row" style="padding-top: 10px"><div class="col-xs-12" style="padding-bottom: 10px"><h3 data-translate="digitalPoster.creater.secondTitle" style="color: #606062; font-size: 1.4em; font-family: Humanst521 Lt BT"></h3></div><div class="col-xs-6"><label style="color: #606062; font-size: 1.0em" for="currency" class="required" data-translate="digitalPoster.creater.fields.currency">Currency:</label><select id="currency" name="currency" type="text" class="form-control" ng-model="vm.poster.currencyInstance" ng-options="value as value.text for (key, value) in vm.currencyConfigurations" required></select></div><div class="col-xs-6" style="padding-left: 0"><label style="color: #606062; font-size: 1.0em" for="productValue" class="required" data-translate="digitalPoster.creater.fields.productValue">Product value:</label><div class="input-group"><span class="input-group-addon">{{vm.poster.currencyInstance.prefix}}</span> <input id="productValue" name="value" ng-model="vm.poster.purchaseValue" type="text" class="form-control" placeholder="{{ vm.poster.currencyInstance.placeHolder }}" required ng-change="vm.checkMaxAndMinDiscountValue()" price price-decimal-separator="{{ vm.poster.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.poster.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.poster.currencyInstance.key" price-activated="true"></div></div></div><div class="row" style="padding-top: 15px"><div class="col-xs-6"><label style="color: #606062; font-size: 1.0em" for="discountType" class="required" data-translate="digitalPoster.creater.fields.discountType">Discount Type:</label><select id="currency" name="currency" type="text" class="form-control" ng-change="vm.checkMaxAndMinDiscountValue()" ng-model="vm.poster.discountType" required><option value="DISCOUNT_PERCENTAGE">{{\'digitalPoster.creater.fields.discount.percentage\' | translate}}</option><option value="DISCOUNT_FIXED">{{\'digitalPoster.creater.fields.discount.price\' | translate}}</option></select></div><div class="col-xs-6" style="padding-left: 0"><label style="color: #606062; font-size: 1.0em" for="discountValue" class="required" data-translate="digitalPoster.creater.fields.discountValue">Discount value:</label><div class="input-group" ng-if="vm.isToDisplayMe(\'DISCOUNT_FIXED\')"><span class="input-group-addon">{{ vm.poster.currencyInstance.prefix }}</span> <input id="discountValuePrice" name="discountValue" class="form-control" ng-disabled="!vm.poster.purchaseValue" ng-model="vm.poster.discountValue" ng-change="vm.checkMaxAndMinDiscountValue()" placeholder="{{ vm.poster.currencyInstance.placeHolder }}" price price-decimal-separator="{{ vm.poster.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.poster.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.poster.currencyInstance.key" price-activated="true"></div><div ng-show="vm.posterEditForm.discountValue.$invalid && vm.isToDisplayMe(\'DISCOUNT_FIXED\')"><p class="help-block form-invalid-field" ng-show="vm.posterEditForm.discountValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.posterEditForm.discountValue.$error.discountGreaterThanValue" data-translate="digitalPoster.messages.error.discountBiggerThan">The discount amount cannot be bigger than the value of the poster.</p><p class="help-block form-invalid-field" ng-show="vm.posterEditForm.discountValue.$error.maxlength" data-translate="entity.validation.max" translate-value-max="{{ vm.poster.purchaseValue }}">MAX</p></div><div class="input-group" ng-if="vm.isToDisplayMe(\'DISCOUNT_PERCENTAGE\')"><span class="input-group-addon">%</span> <input id="discountValuePercentage" name="discountValuePercentage" class="form-control" type="number" ng-model="vm.poster.discountValuePercentage" min="0.0" ng-change="vm.checkMaxAndMinDiscountValue()" max="100.0" placeholder="0.00"></div><div ng-show="vm.posterEditForm.discountValuePercentage.$invalid && vm.isToDisplayMe(\'DISCOUNT_PERCENTAGE\')"><p class="help-block form-invalid-field" ng-show="vm.posterEditForm.discountValuePercentage.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.posterEditForm.discountValuePercentage.$error.discountGreaterThanValue" data-translate="entity.validation.discountGreatThanValue">The discount amount cannot be greater than the value of the flyer.</p><p class="help-block form-invalid-field" ng-show="vm.posterEditForm.discountValuePercentage.$error.max" data-translate="entity.validation.max" translate-value-max="100.00">MAX</p><p class="help-block form-invalid-field" ng-show="vm.posterEditForm.discountValuePercentage.$error.min" data-translate="entity.validation.min" translate-value-min="0.00">MIN</p></div></div></div><div class="row" style="padding-top: 15px"><div class="col-xs-6"><label style="color: #606062; font-size: 1.0em" for="unityType" class="required" data-translate="digitalPoster.creater.fields.unity.title">Unit Type:</label><select id="unityType" ng-init="vm.poster.unitType = \'UNITY_UNITY\'" name="unityType" type="text" class="form-control" ng-change="" ng-model="vm.poster.unitType" required><option value="UNITY_UNITY">{{\'digitalPoster.creater.fields.unity.units.unity\' | translate}}</option><option value="UNITY_LIB">{{\'digitalPoster.creater.fields.unity.units.lib\' | translate}}</option><option value="UNITY_METER">{{\'digitalPoster.creater.fields.unity.units.meter\' | translate}}</option><option value="UNITY_PACKAGE">{{\'digitalPoster.creater.fields.unity.units.package\' | translate}}</option></select></div></div></form>');
$templateCache.put('app/admin/digital-poster/components/digital-poster.preview.html','<div class="row" style="padding: 0% 2%"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="padding: 0"><div class="row" style="padding-left: 3%"><h3 data-translate="digitalPoster.preview.title" style="color: #606062; font-size: 1.4em; font-family: Humanst521 Lt BT"></h3></div><div class="row" style="padding-left: 3%; padding-right: 7%"><h3 data-translate="digitalPoster.preview.titleDescription" style="color: #606062; font-size: 1.2em; font-family: Humanst521 Lt BT"></h3></div><div class="row poster-templates-icon"><ul class="poster-templates-icon-list"><li ng-repeat="(key, value) in vm.templatesTypes" ng-click="vm.selectTemplate(value)" style="outline: none !important"><div class="ksc-poster-icon-dimension"><div class="checkbox flyer-checkbox-remove-margin" style="position: relative; float:right; top: 48px; right: 2px"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.poster.selectedTemplate.key == value.key" onclick="return false" onkeydown="return false"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div><img src="{{ value.iconImg }}"></div></li></ul></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="padding: 0;  margin-bottom: -190px" ng-include="\'app/admin/digital-poster/components/posters/poster-1x1.html\'"></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><p align="center" class="cartaz-size-leg" style="padding-top: 10px" data-translate="digitalPoster.preview.posterDescription" translate-value-configuration="{{ vm.getPageConfiguration() }}">Page: A4 (210mm X 297mm)</p></div></div></div>');
$templateCache.put('app/admin/flyers/apply-discount-modal/apply-discount.modal.html','<style>button.close {\n        font-size: 3.5em;\n        font-weight: lighter;\n    }\n\n    .modal-header {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: flex-start;\n    }\n\n    .modal-subtitle {\n        margin-top: 5px;\n    }\n\n    .modal-body {\n        padding: 20px 70px 20px 70px;\n    }\n\n    .modal-header {\n        border: none;\n        padding: 25px;\n    }\n\n    .modal-header .close {\n        margin-top: -8px;\n    }\n\n    .modal-footer {\n        border: none;\n        padding: 30px;\n    }\n\n    .modal-title {\n        margin-right: auto;\n        font-weight: 400;\n    }\n\n    .modal-title h1 {\n        font-weight: 400;\n        margin: 0;\n    }\n\n    .modal-input-footer {\n        margin: 5px 0px 10px;\n        color: #999999;\n    }</style><div class="modal-header"><div class="modal-title"><h1 data-translate>{{ vm.modalTitle }}</h1><p class="text-muted modal-subtitle">{{ vm.modalSubtitle }}</p></div><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button></div><div class="modal-body"><form name="vm.form" novalidate><label class="required" for="discountValue" data-translate>{{ vm.inputLabel }}</label><input type="number" id="discountValue" name="discountValue" class="form-control" max="100" min="0" placeholder="{{\'flyers.selection-actions.modals.discount-modal.discount-value\' | translate}}" required ng-model="vm.discountValue"><div ng-show="vm.form.discountValue.$invalid"><p class="help-block form-invalid-field" ng-show="vm.form.discountValue.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.form.discountValue.$error.max" data-translate="entity.validation.max-equal" translate-value-max="100%"></p><p class="help-block form-invalid-field" ng-show="vm.form.discountValue.$error.min" data-translate="entity.validation.min" translate-value-min="0%"></p></div><p class="modal-input-footer" data-translate>{{ vm.inputFooter }}</p></form></div><div class="modal-footer"><button type="button" class="btn btn-primary col-xs-12 col-md-5 pull-right" style="margin-top: 2%; margin-left: 2%; padding: 6px 40px" ng-disabled="vm.form.discountValue.$invalid" ng-click="vm.buttonConfirmAction()"><span>{{ vm.buttonConfirmText }}</span></button> <button id="btnOk" ng-show="vm.buttonCancelText" type="button" class="btn btn-default col-xs-12 col-md-3 pull-right" style="margin-top: 2%; padding: 6px 40px" ng-click="vm.closeModal()"><span>{{ vm.buttonCancelText }}</span></button></div>');
$templateCache.put('app/admin/flyers/category-flyer/category-flyer-list.html','<style>.tree-node {\n    border: 2px solid #f9f9f9;\n    background: #f9f9f9;\n    color: inherit;\n    height: 30px;\n    border-radius: 2px;\n    font-weight: 400;\n  }\n\n  .nodrop {\n    background-color: #f2dede;\n  }\n\n  .tree-node-content {\n    margin: 10px;\n  }\n\n  .tree-handle {\n    padding: 10px;\n    background: #aeb1b3;\n    color: #FFF;\n    margin-right: 10px;\n  }\n\n  .angular-ui-tree-placeholder {\n    background: #f0f9ff;\n    border: 2px dashed #bed2db;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n  }</style><div class="ibox float-e-margins"><div class="ibox-content"><div class="row" style="margin-top: 40px"><div class="col-md-6"><div class="input-group form-group"><span class="input-group-addon"><i class="fa fa-search"></i> </span><input type="text" placeholder="{{\'categorys.search-category\' | translate}}" class="input form-control" ng-model="vm.search" ng-change="vm.querySearchCategory()"></div></div><div class="col-md-6" has-authority="STORE_CREATE_FLYER"><button ng-click="vm.showModalAddCategory()" class="btn btn-primary pull-right"><i class="fa fa-user-plus"></i> <span data-translate="categorys.createCategory">Create Category</span></button> <button ng-click="expandAll()" class="btn btn-primary pull-right" style="margin-right: 1%; border: 1px solid rgb(180, 179, 179); background-color: white"><i style="color: rgb(179, 175, 175)" class="fa fa-chevron-down"></i> <span style="color: rgb(136, 136, 136, 1)" data-translate="categorys.expand-all">Expand All</span></button> <button ng-click="collapseAll()" class="btn btn-primary pull-right" style="margin-right: 1%;  border: 1px solid rgb(180, 179, 179); background-color: white"><i style="color: rgb(179, 175, 175)" class="fa fa-chevron-right"></i> <span style="color: rgb(136, 136, 136, 1)" data-translate="categorys.collapse-all">Collapse All</span></button></div><span ng-if="!vm.categorys.length && !vm.loadingList" style="text-align: center; padding-top: 1%; padding-bottom: 1%" class="col-md-12"><strong>{{\'categorys.messages.not-found\' | translate}}</strong></span></div><div ng-if="vm.loadingList" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content">\n      <div style="margin-left: 3px; margin-top: 5px;">\n      <span ng-if="node.children && node.children.length > 0" data-nodrag ng-click="vm.toggle(this)" \n        style="color: #676a6cd6; font-size: 12px;"\n          ng-class="{\n            \'fa fa-chevron-right\': collapsed,\n            \'fa fa-chevron-down\': !collapsed\n          }"></span>\n      {{node.title}}\n          <span class="pull-right fa fa-trash"  style="margin-right: 8px; color: #676a6cd6; margin-top: 2px;" data-nodrag ng-click="vm.removeCategory(node)"></span>\n          <span class="pull-right fa fa-pencil-square-o" style="margin-right: 8px; color: #676a6cd6; margin-top: 2px;" data-nodrag ng-click="vm.showModalEditcategory(node)"></span>\n        </div>\n    </div>\n    <ol ui-tree-nodes="" ng-model="node.children" ng-class="{hidden: collapsed}">\n      <li ng-repeat="node in node.children" ui-tree-node ng-include="\'nodes_renderer.html\'">\n      </li>\n    </ol></script><div class="row" ng-if="!vm.loadingList && vm.categorys.length"><div class="col-sm-12"><div ui-tree id="tree-root"><ol ui-tree-nodes ng-model="vm.categorys"><li ng-repeat="node in vm.categorys" ui-tree-node data-nodrag ng-include="\'nodes_renderer.html\'"></li></ol></div></div></div></div></div>');
$templateCache.put('app/admin/flyers/category-flyer/category-flyer.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-sm-12"><div ui-view="category-list"></div></div></div></div>');
$templateCache.put('app/admin/flyers/category-flyer/category-flyer.modal.html','<style>.border-select-modal {\n        border-color: var(--main-color) !important;\n    }</style><form name="vm.categoryForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header" style="border-bottom: none; padding: 15px 35px 0px"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><div ng-if="!vm.category.id"><h2 class="modal-title">{{\'categorys.new.title-modal\' | translate}}</h2><p>{{\'categorys.new.subtitle-modal\' | translate}}</p></div><div ng-if="vm.category.id"><h2 class="modal-title">{{\'categorys.edit.title-modal\' | translate}}</h2><p>{{\'categorys.edit.subtitle-modal\' | translate}}</p></div></div><div class="modal-body"><div class="container-fluid"><div class="dragzone"><div class="form-group col-xs-12"><label for="parent" class="required" data-translate="categorys.parent-category">parent category</label><select id="parent" name="parent" type="text" class="form-control" ng-model="vm.category.categoryId" required><option value="0">Raiz</option><option ng-repeat="category in vm.categorys" value="{{category.id}}">{{category.title}}</option></select><div ng-show="vm.categoryForm.parent.$invalid && vm.categoryForm.parent.$touched"><p class="help-block form-invalid-field" ng-show="vm.categoryForm.parent.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-xs-8"><label class="required" for="name" data-translate="categorys.category-name">Category name</label><input id="name" name="name" ng-model="vm.category.title" type="text" class="form-control" ng-maxlength="50" ng-minlength="4" required><div ng-show="vm.categoryForm.name.$invalid && vm.categoryForm.name.$touched"><p class="help-block form-invalid-field" ng-show="vm.categoryForm.name.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.categoryForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50"></p><p class="help-block form-invalid-field" ng-show="vm.categoryForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div><div class="form-group col-xs-4"><label for="position" data-translate="categorys.category-position">Category Position</label><input id="position" name="position" ng-model="vm.category.index" type="text" class="form-control" required></div></div></div></div><div class="modal-footer" style="display: flex; justify-content: center; border: none; padding-top: 0px"><button class="btn btn-primary btn-large" ng-click="vm.close()" ng-disabled="!vm.categoryForm.$valid"><span style="padding-left: 50px; padding-right: 50px" data-translate="global.form.done">Feito!</span></button></div></form>');
$templateCache.put('app/admin/flyers/import/flyer-import.html','<style>.steps {\n        margin-top: 30px;\n    }\n    .steps > .nav > li.active > a {\n        color: white;\n        margin: 0 5px;\n        background: #2f137e;\n    }\n    .steps > .nav > li > a {\n        color: #aaa;\n        margin: 0 5px;\n        background: #eee;\n    }\n    .steps > .nav > li.active {\n        border-left: none;\n        border-right: none;\n        background: none !important;\n    }\n    .import-loading-spinner {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n    }\n    .import-loading-text {\n        margin-top: 20px; \n        font-size: 16px\n    }\n    .column-header {\n        background: #c4c4c4;\n    }\n    .step-header {\n        padding: 15px 50px;\n    }\n    .step-content {\n        height: 440px;\n        min-height: 440px;\n    }\n    .mapping-errors {\n        background: #fee2df;\n        padding: 15px 50px;\n    }</style><div class="wrapper wrapper-content"><div class="row"><div class="col-sm-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-9" has-authority="STORE_CREATE_FLYER"><h2 data-translate="flyers.import.subtitle"></h2><p data-translate="flyers.import.description"></p><div class="steps"><ul class="nav nav-pills steps"><li ng-class="{\'active\': vm.currentStep === 1}"><a ng-click="vm.gotoStep(1)">{{ \'flyers.import.steps.one\' | translate }}</a></li><li ng-class="{\'active\': vm.currentStep === 2}"><a ng-click="vm.gotoStep(2)">{{ \'flyers.import.steps.two\' | translate }}</a></li><li ng-class="{\'active\': vm.currentStep === 3}"><a ng-click="vm.gotoStep(3)">{{ \'flyers.import.steps.three\' | translate }}</a></li></ul></div></div><div class="col-sm-12"><div class="hr-line-dashed"></div></div></div><div ng-if="vm.isUploading || vm.isLoading" class="step-content import-loading-spinner"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><span ng-if="vm.isUploading" data-translate="flyers.import.validating" class="import-loading-text"></span> <span ng-if="vm.isLoading" data-translate="flyers.import.loadingFile" class="import-loading-text"></span></div><div ng-show="!vm.isUploading && !vm.isLoading" class="step-content"><div ng-show="vm.currentStep === 1" class="row" ng-include="\'app/admin/flyers/import/step1.html\'"></div><div ng-show="vm.currentStep === 2" class="row" ng-include="\'app/admin/flyers/import/step2.html\'"></div><div ng-show="vm.currentStep === 3" class="row" ng-include="\'app/admin/flyers/import/step3.html\'"></div></div><div class="row"><div class="col-sm-12"><div class="hr-line-dashed"></div></div><div class="pull-right" has-authority="STORE_CREATE_FLYER" style="padding-right: 1%"><button ng-disabled="vm.currentStep <= 1" ng-click="vm.gotoStep(vm.currentStep - 1)" class="btn btn-default"><span data-translate="flyers.button.back">Back</span></button> <button ng-show="vm.currentStep < 3" ng-click="vm.gotoStep(vm.currentStep + 1)" ng-disabled="!vm.file" class="btn btn-primary"><span data-translate="flyers.button.next">Next</span></button> <button ng-if="vm.currentStep === 3" ladda="vm.isUploading" ng-disabled="!vm.file || vm.errorSummary" ng-click="vm.uploadFile()" has-authority="STORE_CREATE_FLYER" class="btn btn-primary"><span data-translate="flyers.button.startImport">Start</span></button></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/flyers/import/sortOptionsSelect.html','<div class="row"><div class="w-100"><select id="sort" name="sort" type="text" class="form-control btn-filters-modal filter-label" ng-model="vm.selectedSortByOption" style="text-align-last:center" ng-options="item as item.label for item in vm.sortOptions track by item.id" ng-change="vm.onSelectedSortOption()"><option value="" disabled="disabled" selected="selected">{{ \'flyers.home.orderBy\' | translate}}</option></select></div></div>');
$templateCache.put('app/admin/flyers/import/step1.html','<div class="col-sm-6"><div style="padding: 5px 50px"><div><h2>{{\'flyers.import.steps.step1.title\' | translate}}</h2><h3>{{\'flyers.import.steps.step1.subtitle1\' | translate}}</h3><p>{{\'flyers.import.steps.step1.description1\' | translate}}</p><i class="fa fa-download"></i> <a target="_self" ng-href="{{ vm.getDownloadLinkToTemplate() }}">{{\'flyers.import.steps.step1.template-button\' | translate}}</a></div><div style="margin-top: 20px"><h3>{{\'flyers.import.steps.step1.subtitle2\' | translate}}</h3><p ng-bind-html="vm.descriptonStep1"></p></div></div></div><div class="col-sm-6" ngf-drop="vm.loadFile($file, $invalidFiles)" class="drop-box" style="padding-right: 65px" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-pattern="\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\'"><div class="col-sm-12" style="border-style: dashed; border-width: 2px; border-color: #cecece; padding: 173px 65px; text-align: center; background-color: #f7f7f7"><button class="btn btn-primary" type="file" ng-disabled="vm.isUploading" ngf-select="vm.loadFile($file, $invalidFiles)" ngf-accept="\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\'" ngf-pattern="\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\'"><i class="fa fa-cloud-upload"></i> <span data-translate="flyers.button.selectFile">Select file</span></button><p style="margin-top: 10px" data-translate="flyers.import.fileSelectText"></p></div></div>');
$templateCache.put('app/admin/flyers/import/step2.html','<div class="col-sm-12 step-header"><h4 data-translate="flyers.import.mappingTitle"></h4><p data-translate="flyers.import.mappingDescription"></p></div><div class="col-sm-12"><div class="tab-content" style="margin: 0px 36px"><div id="tab-1" class="tab-pane active"><div><div class="table-responsive" style="height: 350px"><table class="table table-striped table-hover"><thead><tr><th width="33.33%"><span data-translate="flyers.import.fileColumn">Column</span></th><th width="33.33%"><span data-translate="flyers.import.fileColumnName">Spreadsheet</span></th><th width="33.33%"><span data-translate="flyers.import.mappingColumn">Mapping</span></th></tr></thead><tbody><tr ng-repeat="item in vm.headers"><td><span><b>{{ item.column }}</b></span></td><td><span>{{ item.key }}</span></td><td><select class="form-control" name="att" ng-model="item.value" ng-change="vm.changeHeaderValue(item)"><option value="" ng-if="item.value !== \'NULL\'"></option><option ng-repeat="att in vm.flyerAttributes" value="{{att}}" data-translate="flyers.import.column.{{att}}"></option></select></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/admin/flyers/import/step3.html','<div ng-if="vm.errorSummary" class="col-sm-12 step-header mapping-errors"><h4 data-translate="flyers.import.importErrorTitle"></h4><div ng-repeat="error in vm.errorSummary"><i class="fa fa-exclamation-triangle"></i> <span style="margin-left: 5px" data-translate="flyers.import.error.{{error}}"></span><br></div><p data-translate="flyers.import.importErrorDescription" style="margin-top: 15px"></p><button charset="utf-8" class="btn btn-primary" ng-click="vm.getXlsxResult()" data-translate="flyers.button.downloadResult">Download Result</button></div><div class="col-sm-12 step-header"><h4 data-translate="flyers.import.importPreviewTitle"></h4><p data-translate="flyers.import.importPreviewDescription"></p></div><div class="col-sm-12"><div class="tab-content" style="margin: 0px 36px"><div id="tab-1" class="tab-pane active"><div><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th ng-repeat="item in vm.importPreview.headers"><span>{{ item }}</span></th></tr></thead><tbody><tr ng-repeat="item in vm.importPreview.data"><td ng-repeat="value in item track by $index"><span>{{ value }}</span></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/admin/flyers/modal-filter-flyer/flyer-filter-modal.html','<style>.sub-title {\n        font-size: 1.0em;\n    }\n\n    md-select-menu md-content {\n        -webkit-overflow-scrolling: fixed !important;\n    }\n\n    .md-select-menu-container {\n        z-index: 3000 !important;\n    }\n\n    .custom-md-input md-input-container {\n        display: inherit;\n        margin: unset;\n        border: 0;\n    }\n\n    .custom-md-input md-select.md-default-theme .md-select-value,\n    md-select .md-select-value {\n        border-color: rgba(0, 0, 0, 0.12) !important;\n        border: 1px;\n        border-style: solid;\n        padding-left: 8px;\n    }\n\n    .custom-select[multiple] .md-select-value span:first-child {\n        visibility: collapse;\n    }\n\n    .custom-select[multiple] .md-select-value .md-text {\n        display: inline-block !important;\n        visibility: visible;\n        background-color: rgb(224, 224, 224);\n        border-radius: 6px;\n        padding: 3px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected],\n    md-select-menu md-content md-option[selected] {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .md-select-value {\n        padding: 5px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected]:focus,\n    md-select-menu md-content md-option[selected]:focus {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-checkbox-enabled.md-default-theme[selected] .md-icon,\n    .md-checkbox-enabled[selected] .md-icon {\n        background-color: var(--main-color) !important;\n    }\n\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\n    md-select-menu md-content md-option:not([disabled]):focus,\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\n    md-select-menu md-content md-option:not([disabled]):hover {\n        background: none;\n    }\n\n    .highlight {\n        background: #f3f3f4;\n        padding: 5px;\n        display: inline-block;\n        color: var(--main-color-dark);\n        border-radius: 10px;\n        padding-bottom: 2px;\n        padding-top: 2px;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    md-select-menu {\n        margin-top: 50px;\n        width: 150.674px !important;\n        margin-left: 39px;\n    }\n\n    .remove-dropdown {\n        display: none !important;\n    }\n\n    .empty-list md-select-menu {\n        margin-top: 42px;\n        width: 192.674px !important;\n        margin-left: -1px;\n    }\n\n    md-select.md-default-theme[disabled] .md-select-value,\n    md-select[disabled] .md-select-value {\n        background-image: none !important;\n    }\n\n    .modal-options-body {\n        position: relative;\n        padding: 15px;\n    }\n\n    .modal-header {\n        border-bottom: 0;\n    }\n\n    .md-select-value {\n        border-bottom-width: 1px !important;\n        padding-bottom: 5px !important;\n    }</style><div id="modal" class="main-modal"><div id="filter-flyer-modal" class="modal-header"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h1 class="modal-title">{{\'flyers.filters.modalTitle\' | translate}}</h1><span class="sub-title">{{\'flyers.filters.modalSubTitle\' | translate}}</span></div><div class="modal-options-body"><div class="row"><div class="col-md-12"><div class="col-md-12"><div class="form-group col-md-4 col-sm-12"><span data-translate="flyers.home.categories">Categories</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select ng-if="vm.categories.length" class="custom-select-value" ng-model="vm.filters.categories" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.categories)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="category in vm.categories" ng-value="category">{{category.title}}</md-option></div></md-select><md-select ng-if="!vm.categories.length" class="custom-select-value" ng-model="vm.filters.categories" disabled="disabled" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><div class="form-group col-md-4 col-sm-12"><span data-translate="flyers.home.brands">Brands</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select ng-if="vm.brands.length" class="custom-select-value" ng-model="vm.filters.brands" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.brands)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="brand in vm.brands | orderBy:\'name\'" ng-value="brand">{{brand.name}}</md-option></div></md-select><md-select ng-if="!vm.brands.length" class="custom-select-value" ng-model="vm.filters.brands" disabled="disabled" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><div class="form-group col-md-4 col-sm-12"><span data-translate="flyers.home.colors">Colors</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select ng-if="vm.colors.length" class="custom-select-value" ng-model="vm.filters.colors" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.colors)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="color in vm.colors" ng-value="color">{{color.label}}</md-option></div></md-select><md-select col-md-3 ng-if="!vm.colors.length" class="custom-select-value" ng-model="vm.filters.colors" disabled="disabled" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div></div><div class="col-md-12"><div class="form-group col-md-4 col-sm-12"><span>{{ vm.storeCategory == \'FASHION\' ? \'flyers.home.sizes\' : \'flyers.home.variations\' | translate }}</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select ng-if="vm.sizes.length" class="custom-select-value" ng-model="vm.filters.sizes" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.sizes)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="size in vm.sizes" ng-value="size">{{size.label}}</md-option></div></md-select><md-select ng-if="!vm.sizes.length" class="custom-select-value" ng-model="vm.filters.sizes" disabled="disabled" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><div class="form-group col-md-4 col-sm-12"><span data-translate="flyers.new.form.gender.title">Gender</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select ng-if="vm.genders.length" class="custom-select-value" ng-model="vm.filters.genders" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.genders)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="gender in vm.genders" ng-value="gender">{{( gender.label )| translate}}</md-option></div></md-select><md-select ng-if="!vm.genders.length" class="custom-select-value" ng-model="vm.filters.genders" disabled="disabled" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div><div class="form-group col-md-4 col-sm-12"><span data-translate="flyers.new.form.configurations.title">Configurations</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select ng-if="vm.configurations.length" class="custom-select-value" ng-model="vm.filters.configurations" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.configurations)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="configuration in vm.configurations" ng-value="configuration">{{ configuration.label | translate }}</md-option></div></md-select><md-select ng-if="!vm.configurations.length" class="custom-select-value" ng-model="vm.filters.configurations" disabled="disabled" placeholder="{{ \'flyers.new.form.empty-list\' | translate }}"></md-select></md-input-container></div></div></div><div class="col-md-12"><div class="form-group col-md-4 col-sm-12" ng-if="vm.isBagFilter"><span data-translate="flyers.new.form.tags.title">Tags</span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select class="custom-select-value" ng-model="vm.filters.tags" multiple="multiple" ng-model-options="{trackBy: \'$value.id\'}" md-selected-html="vm.getSelectedText(vm.filters.tags)"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="tag in vm.tags" ng-value="tag">{{ tag.label }}</md-option></div></md-select></md-input-container></div></div><div class="form-group col-md-4 col-sm-12"><span data-translate="flyers.filters.orderBy"></span><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select class="custom-select-value" ng-model="vm.filters.sortSelected" ng-model-options="{trackBy: \'$value.id\'}"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="sortBy in vm.sortOptions" ng-value="sortBy">{{ sortBy.label }}</md-option></div></md-select></md-input-container></div></div></div></div><div class="row col-md-12" style="margin-bottom: 15px" ng-if="!vm.isBagFilter"><div class="col-sm-12 col-md-6"><md-switch ng-model="vm.hasInventory"><span>{{\'flyers.filters.onlyWithStock\' | translate}}</span></md-switch></div><div class="col-sm-12 col-md-6" ng-if="vm.canChangeView"><div class="brand-category toggle-brand-category"><span class="hidden-xs hidden-sm" style="padding-right: 8px">{{\'flyers.filters.showByBrands\' | translate}}</span><md-switch ng-model="vm.viewByCategories"><span>{{\'flyers.filters.showByCategories\' | translate}}</span></md-switch></div></div></div><div class="col-md-12"><div class="row"><div class="col-md-12"><button type="button" class="clear-btn" ng-click="vm.clearFilters()"><i class="fa fa-times"></i> {{\'flyers.filters.clearAll\' | translate}}</button></div></div></div></div></div><div id="footer-new-conversation" class="modal-footer"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.closeModal()"><span>{{\'flyers.button.cancel\' | translate}}</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.applyFilters()"><span>{{\'flyers.filters.apply\' | translate}}</span></button></div></div>');
$templateCache.put('app/admin/flyers/sync-with-hub-modal/sync-with-hub.html','<style>button.close {\n        font-size: 3.5em;\n        font-weight: lighter;\n    }\n\n    .modal-header, .modal-footer {\n        border: none;\n    }\n\n    .modal-header {\n        padding-top: 5px;\n    }\n\n    .modal-body {\n        padding: 5px 30px 5px 30px;\n    }</style><div class="container-modal-connect" id="modal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button></div><div class="modal-body row"><i class="fa fa-warning col-xs-12 col-md-2" style="color: #fdbe2d; font-size: 5.4em; text-align: center; min-height: 12vh"></i> <span class="col-xs-12 col-md-8" style="font-size: 1.5em; margin-bottom: 5px"><p data-translate>{{ vm.modalMessage }}</p><p style="font-size: 12px; padding-top: 10px" class="text-muted">{{vm.smallText}}</p><p style="font-size: 12px; padding-top: 10px" class="text-muted">{{vm.warningText}}</p></span><div ng-if="vm.checkBoxes && vm.checkBoxes.length > 0" class="col-xs-12 col-md-12"><div class="hidden-xs col-md-2"></div><div class="col-xs-12 col-md-10 display-horizontally-inline" style="padding-left: 5px; padding-right: 5px"><div class="col-xs-4 col-md-4" style="padding-left: 5px; padding-right: 5px" ng-repeat="attribute in vm.checkBoxes"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="attribute.value"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="{{attribute.translateId}}"></span></label></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary col-xs-12 col-md-auto pull-right" style="margin-top: 2%; margin-left: 2%; padding: 6px 40px" ng-disabled="!vm.isConfirmButtonEnabled()" ng-click="vm.buttonConfirmAction()"><span>{{ vm.buttonConfirmText }}</span></button> <button id="btnOk" ng-show="vm.buttonCancelText" type="button" class="btn btn-default col-xs-12 col-md-auto pull-right" style="margin-top: 2%; padding: 6px 40px" ng-click="vm.closeModal()"><span>{{ vm.buttonCancelText }}</span></button></div></div>');
$templateCache.put('app/admin/hub-management/campaign/_modal_add_showcase.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" style="text-transform: uppercase" data-translate="campaign.form.showcase.add"></h4></div><div class="modal-body"><p data-translate="campaign.form.showcase.add-hint"></p><div class="row"><div class="col-xs-4" ng-repeat="showcase in vm.showcases" style="padding: 0 10px"><div class="checkbox" style="background: whitesmoke; border-radius: 2px;padding: 5px 5px 3px 5px"><label style="display: inline-flex"><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.check(showcase, $event)" ng-checked="vm.isChecked(showcase)"> <span id="{{showcase.id}}" class="checkbox-material" style="top: 2px; margin-right: 10px"><span class="check"></span> </span><span class="text-ellipsis" style="margin-top: 3px">{{showcase.name}}</span></label></div></div></div></div><div class="modal-footer"><button class="btn btn-primary" data-style="slide-left" ng-click="vm.ok()">OK</button></div>');
$templateCache.put('app/admin/hub-management/campaign/hub-campaign-distribute.html','<div class="wrapper wrapper-content"><div class="ibox float-e-margins"><div class="ibox-content"><div class="col-xs-12 no-padding"><h1 class="sc-default-title-store-font ng-scope" data-translate="store-management.home.title"></h1><p data-translate="campaign.distribute.hint"></p></div><div class="row" style="margin-top: 10px"><div class="form-group col-md-7"><label class="control-label">Nome</label><input id="search-hub-fler" ng-model="vm.storeName" ng-change="vm.onChangeStoreName()" ng-model-options="{ debounce: 500 }" placeholder="{{\'global.table.search\' | translate }}{{\'store-management.home.searchName\' | translate | lowercase}}" type="text" class="form-control"></div><div class="col-md-5 form-group"><label class="control-label">Tipo</label><select class="form-control" ng-model="vm.storeTypeId" ng-change="vm.markAllStoreType()"><option value="" selected="selected">Nenhum(a)</option><option value="all" selected="selected">Todos(as)</option><option ng-repeat="type in vm.storeTypes" ng-value="type.id">{{type.name}}</option></select></div></div><hr class="flyer-table-line" style="padding-bottom: 10px"><div class="row"><div class="col-xs-12"><div class="showcase-flyer-table"><div class="table-responsive" style="overflow: hidden !important"><table class="table shoping-cart-table"><tbody><tr width="100%" ng-repeat="store in vm.stores track by $index"><td width="4%" style="padding: 0 !important"><div class="checkbox" ng-click="$event.stopPropagation()" style="padding: 0 !important"><label><input type="checkbox" ng-disabled="vm.storeTypeId" class="dropdown-item-checkbox" ng-checked="vm.checkStoreIsSelected(store.storeId)" ng-click="vm.changeStoreSelected(store)"> <span class="checkbox-material"><span class="check showcase-flyer-table-checkbox"></span></span></label></div></td><td width="96%" style="text-align: left; padding-top: 16px"><label>{{store.storeName}}</label></td></tr></tbody></table><hr class="showcase-table-flyer-line"></div></div></div></div><div class="row m-t-lg"><div class="col-xs-12"><button id="btnCreateCampaign" ladda="vm.submitting" class="btn btn-primary btn-large pull-right m-l-sm" ng-click="vm.distribute()" data-style="slide-left"><span data-translate="campaign.actions.distribute"></span></button></div></div></div></div></div>');
$templateCache.put('app/admin/hub-management/campaign/hub-campaign-form.html','<div class="wrapper wrapper-content animated fadeIn" id="content"><div class="ibox float-e-margins"><div class="ibox-content"><div ng-if="vm.loading" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><form name="vm.campaignForm" ng-if="!vm.loading"><div class="col-xs-12 no-padding"><h1 class="sc-default-title-store-font ng-scope" data-translate="campaign.form.data"></h1><p data-translate="campaign.form.data-hint"></p></div><div class="row"><div class="form-group col-xs-12 col-md-6"><div class="row"><div class="col-xs-12 form-group"><label class="required" for="name" data-translate="campaign.form.name">Name</label><input id="name" name="name" ng-model="vm.campaign.name" type="text" class="form-control" ng-maxlength="150" ng-minlength="4" required><div ng-show="vm.campaignForm.name.$invalid && vm.campaignForm.name.$touched"><p class="help-block form-invalid-field" ng-show="vm.campaignForm.name.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.campaignForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150"></p><p class="help-block form-invalid-field" ng-show="vm.campaignForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div></div><div class="row"><div class="col-xs-12 form-group" style="margin-top: 3px"><label>Tags</label><tags-input replace-spaces-with-dashes="false" ng-model="vm.campaign.tags" display-property="name" placeholder="Insira tags da campanha"><auto-complete source="vm.searchTags($query)"></auto-complete></tags-input></div></div></div><div class="col-xs-12 col-md-6"><div class="row"><div class="col-xs-12"><label for="description" data-translate="campaign.form.description">Description</label><textarea id="description" name="description" class="form-control" ng-model="vm.campaign.description" style="resize: none" rows="5">\n                        </textarea></div></div></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-store-font ng-scope" data-translate="campaign.form.showcase.title"></h1><p data-translate="campaign.form.showcase.hint"></p></div><div class="col-xs-12"><span class="store-upload-button pointer" ng-click="vm.addShowcase()" role="button" tabindex="0"><i style="margin-right: 5px" class="fa fa-plus"></i> <span data-translate="campaign.form.showcase.add"></span></span></div><div ng-repeat="showcase in vm.campaign.showcases track by $index" class="col-xs-12 col-md-4 m-t-md"><div class="ibox pointer"><div class="ibox-content" style="padding: 10px 10px 3px 10px"><div class="row"><div class="col-sm-2 col-md-1 no-padding-right"><img style="width: 20px; height: 21px" src="content/images/templates/1.png"></div><div class="col-sm-9 col-md-10"><p class="product-name text-ellipsis" style="word-wrap: break-word">{{showcase.name}}</p></div><div class="col-xs-1 no-padding-left"><i class="fa fa-trash pointer" ng-click="vm.removeShowcase($index)" style="font-size: 18px; margin-top: 2px; float: right"></i></div></div></div></div></div></div><div class="row m-t-md"><div class="col-xs-12"><button id="btnCreateCampaign" ladda="vm.submitting" class="btn btn-primary btn-large pull-right m-l-sm" ng-click="vm.save()" data-style="slide-left" ng-disabled="vm.campaignForm.$invalid"><span data-translate="global.form.save"></span> <span class="fa fa-sign-in m-l-xs" style="font-size: 1.3em" aria-hidden="true"></span></button></div></div></form></div></div></div>');
$templateCache.put('app/admin/hub-management/campaign/hub-campaign.html','<div class="wrapper wrapper-content"><div class="row" ng-if="!vm.loading && vm.campaigns.length"><div class="col-xs-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-xs-12 col-md-6"><div class="inner-addon left-addon"><i class="glyphicon glyphicon-search"></i> <input type="text" class="form-control" ng-model="vm.filter.name" ng-change="vm.listCampaigns()" ng-model-options="{ debounce: 500 }" placeholder="{{\'global.table.search\' | translate }}{{\'store-management.home.searchName\' | translate | lowercase}}"></div></div></div></div></div></div></div><div class="row"><div ng-if="vm.loading" class="tab-content"><div class="sk-container"><div class="sk-spinner sk-spinner-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div></div><div ng-if="!vm.loading && !vm.campaigns.length && !vm.filter.name.length" class="tab-content text-center"><i class="fa fa-bullhorn text-muted" style="font-size: 12em; margin-top: 70px"></i><h1 data-translate="campaign.empty.title"></h1><p class="text-muted" data-translate="campaign.empty.hint"></p><button class="btn btn-primary" ui-sref="hub-campaigns.new"><i class="fa fa-bullhorn"></i> <span data-translate="campaign.actions.create"></span></button></div><div class="col-lg-12" ng-if="(!vm.loading && vm.campaigns.length)  || vm.filter.name.length"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-3"><div class="showcase-box showcase-item-box showcase-align-icon-center"><div class="showcase-flex-item text-center" ui-sref="hub-campaigns.new" style="margin-bottom: 60px"><i class="fa fa-bullhorn text-muted" style="font-size: 80px; margin-bottom: 15px"></i><p class="showcase-new-text" data-translate="campaign.actions.create"></p></div></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="campaign in vm.campaigns track by $index"><div class="ibox"><div class="ibox-content product-box showcase-box"><div class="showcase-box-image text-center" style="margin-top: 90px"><i class="fa fa-bullhorn" style="font-size: 80px; color: lightgrey"></i><div style="margin: 20px"><h2 style="font-size: 2vh !important">{{campaign.name}}</h2></div><div class="row no-margins"><span ng-repeat="tag in campaign.tags" class="badge badge-secondary badge-tag-flyer">{{tag.name}}</span></div></div><div class="showcase-box-hover"><button id="btnEdit" style="min-width:200px" has-authority="ADMIN_HUB" class="btn btn-lg showcase-box-transparent-button" type="button" ui-sref="hub-campaigns.edit({id: campaign.id})"><span class="icon-ksc-edit"></span> <span data-translate="showcases.home.buttons.edit">Edit</span></button> <button id="btnDistribute" style="min-width:200px" has-authority="ADMIN_HUB" class="btn btn-lg showcase-box-transparent-button" type="button" ui-sref="hub-campaigns.distribute({id: campaign.id})"><span class="fa fa-code-fork"></span> <span data-translate="campaign.actions.distribute"></span></button></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/hub-management/confirm-publish/confirm-publish.modal.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" data-translate="flyers.hub.distribute.modal.title"></h4></div><div class="modal-body"><p data-translate="flyers.hub.distribute.modal.info"></p></div><div class="modal-footer"><button type="button" id="btnConfirm" class="btn btn-primary" ng-click="vm.confirm()" data-translate="global.messages.remove.confirm">Remover</button> <button type="button" id="btnCancel" class="btn btn-default" ng-click="vm.closeModal()" data-translate="global.messages.remove.cancel">Cancelar</button></div>');
$templateCache.put('app/admin/hub-management/file-manager/_modal_add_edit_folder.html','<div id="add-edit-folder-modal"><div class="modal-header"><span style="font-size: 1.3em" class="modal-title" ng-if="!vm.folder.id">Adicionar Pasta </span><span style="font-size: 1.3em" class="modal-title" ng-if="vm.folder.id">Renomear Pasta</span></div><div class="modal-body"><form name="vm.formFolder" novalidate role="form"><div class="row"><div class="form-group col-xs-12"><label for="name" class="required" data-translate="file-manager.form.folder.name">Name</label><input id="name" name="name" type="text" class="form-control" ng-model="vm.folder.name" ng-maxlength="100" ng-minlength="4" required><div class="help-block-div" ng-show="vm.formFolder.name.$invalid && vm.formFolder.name.$touched"><p class="help-xblock form-invalid-field" ng-show="vm.formFolder.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formFolder.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="vm.formFolder.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div></form></div><div class="modal-footer"><button ng-click="vm.cancel()" class="btn btn-default btn-md" data-style="slide-left"><span>Cancel</span></button> <button ladda="vm.submitting" ng-click="vm.save()" class="btn btn-primary btn-md" data-style="slide-left"><span>Salvar</span></button></div></div>');
$templateCache.put('app/admin/hub-management/file-manager/_modal_delete_confirmation.html','<div id="add-edit-folder-modal"><div class="modal-header"><span style="font-size: 1.3em" class="modal-title" ng-if="vm.isFolder">{{\'file-manager.action.delete\' | translate}} {{\'file-manager.folder.title.singular\' | translate}} </span><span style="font-size: 1.3em" class="modal-title" ng-if="!vm.isFolder">{{\'file-manager.action.delete\' | translate}} {{\'file-manager.file.title.singular\' | translate}}</span></div><div class="modal-body"><h3 class="no-margin">Realmente deseja apagar: {{vm.objectName}}?</h3></div><div class="modal-footer"><button ng-click="vm.confirm(false)" class="btn btn-default btn-md" data-style="slide-left"><span>{{\'file-manager.action.cancel\' | translate}}</span></button> <button ng-click="vm.confirm(true)" class="btn btn-primary btn-md" data-style="slide-left"><span>{{\'file-manager.action.delete\' | translate}}</span></button></div></div>');
$templateCache.put('app/admin/hub-management/file-manager/_modal_edit_file.html','<div id="add-edit-file-modal"><div class="modal-header"><span style="font-size: 1.3em" class="modal-title">Editar Arquivo</span></div><div class="modal-body"><form name="vm.formFile" novalidate role="form"><div class="row m-b-md"><div class="form-group col-xs-12"><label for="name" class="required" data-translate="file-manager.form.file.name">Name</label><input id="name" name="name" type="text" class="form-control" ng-model="vm.file.name" ng-maxlength="100" ng-minlength="4" required><div class="help-block-div" ng-show="vm.formFile.name.$invalid && vm.formFile.name.$touched"><p class="help-xblock form-invalid-field" ng-show="vm.formFile.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formFile.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="vm.formFile.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="row upload-tags"><div class="col-xs-12 form-group"><label class="control-label">Tags</label><tags-input replace-spaces-with-dashes="false" ng-model="vm.file.tags" display-property="name" placeholder="Insira tags para facilitar as buscar dos seus arquivos"><auto-complete source="vm.searchTags($query)"></auto-complete></tags-input></div></div></form></div><div class="modal-footer"><button ng-click="vm.cancel()" class="btn btn-default btn-md" data-style="slide-left"><span>Cancel</span></button> <button ladda="vm.submitting" ng-click="vm.save()" class="btn btn-primary btn-md" data-style="slide-left"><span>Salvar</span></button></div></div>');
$templateCache.put('app/admin/hub-management/file-manager/_modal_upload_files.html','<div id="add-edit-folder-modal"><div class="modal-header"><span style="font-size: 1.3em" class="modal-title">Upload de Arquivos</span></div><div class="modal-body"><div class="row upload-tags"><div class="col-xs-12"><label class="control-label">Tags</label><tags-input replace-spaces-with-dashes="false" ng-model="vm.tags" display-property="name" placeholder="Insira tags para facilitar as buscar dos seus arquivos"><auto-complete source="vm.searchTags($query)"></auto-complete></tags-input></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-12 file-upload"><input id="file" type="file" ng-file-model="vm.files" multiple="multiple"><label for="file" class="btn-upload">Selecione os arquivos</label><strong class="m-l-xs">{{vm.files.length}} arquivo(s) selecionado(s)</strong></div></div><div class="hr-line-dashed"></div><div class="temp-file-list"><div ng-repeat="file in vm.files" style="padding: 10px 0; border-bottom: 1px solid #EFEFEF"><strong>{{file.name}}</strong><div class="pull-right m-r-xs"><i class="fa fa-trash" ng-click="vm.remove($index)" tooltip-placement="left" uib-tooltip="Descartar"></i></div><div class="pull-right m-r-xs" ng-if="file.status"><i class="fa fa-check success" ng-if="file.status === \'SUCCESS\'" tooltip-placement="left" uib-tooltip="Arquivo enviado com sucesso!"></i> <i class="fa fa-times-circle error" ng-if="file.status === \'ERROR\'" tooltip-placement="left" uib-tooltip="Falha ao enviar o arquivo!"></i> <i class="fa fa-refresh fa-spin in-progress" ng-if="file.status === \'IN_PROGRESS\'" tooltip-placement="left" uib-tooltip="Enviando arquivo..."></i></div></div></div></div><div class="modal-footer"><button ng-click="vm.cancel()" class="btn btn-default btn-md" data-style="slide-left"><span>Cancel</span></button> <button ladda="vm.submitting" ng-click="vm.upload()" class="btn btn-primary btn-md" data-style="slide-left" ng-disabled="!vm.files || vm.files.length === 0"><span>Salvar</span></button></div></div>');
$templateCache.put('app/admin/hub-management/file-manager/file-manager.html','<div class="wrapper wrapper-content"><div class="row" style="margin-bottom: 64px"><div class="col-lg-3"><div class="ibox"><div class="ibox-content" style="padding: 15px 20px; min-height: 520px"><div class="file-manager"><div class="col-xs-12 no-padding"><button class="btn btn-primary btn-block" ng-click="vm.createEditFolder({})"><i class="fa fa-folder"></i> {{\'file-manager.action.add-folder\' | translate}}</button></div><br><br><div class="hr-line-dashed"></div><h5>Pastas</h5><div class="text-muted m-2" ng-if="!vm.loadingChildren"><span ng-if="vm.currentFolder.id === -1 && !vm.children.length">{{\'file-manager.folder.no-folder\' | translate}} </span><span ng-if="vm.currentFolder.id !== -1 && !vm.children.length">{{\'file-manager.folder.empty-children\' | translate}}</span></div><div ng-if="vm.loadingChildren" class="tab-content"><div class="sk-container"><div class="sk-spinner sk-spinner-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div></div><ul class="folder-list no-padding" ng-if="!vm.loadingChildren && vm.children.length"><li ng-repeat="child in vm.children" class="folder"><a class="col-xs-11 no-padding" ng-click="vm.enterInFolder(child)"><i class="fa fa-folder"></i> {{child.name}}</a><div class="col-xs-1 no-padding"><a class="dropdown-toggle no-padding pull-right" data-toggle="dropdown" href="#" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a><ul class="dropdown-menu" data-flip="false"><!--<li ng-click="vm.createEditFolder(child)">\n                                                <a href="#" class="dropdown-item" style="padding-left: 10px !important;">{{\'file-manager.action.rename\' | translate}}</a>\n                                            </li>--><li ng-click="vm.deleteConfirmation(true, child, vm.deleteFolder)"><a href="#" class="dropdown-item" style="padding-left: 10px !important">{{\'file-manager.action.delete\' | translate}}</a></li></ul></div></li></ul><div class="hr-line-dashed"></div><h5>{{\'file-manager.form.filter\' | translate}} <i class="fa fa-question-circle" uib-tooltip="{{\'file-manager.form.filter-hint\' | translate}}"></i></h5><div class="m-b-md"><input class="form-control" placeholder="{{\'file-manager.form.filter-name\' | translate}}" ng-model="vm.filterName" ng-change="vm.filterByName()" ng-model-options="{ debounce: 300 }"></div><div ng-if="vm.loadingTags" class="tab-content"><div class="sk-container"><div class="sk-spinner sk-spinner-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div></div><ul class="tag-list" style="padding: 0"><li ng-repeat="tag in vm.tags" ng-click="vm.filterByTag(tag)"><a href="" style="display: inline-block !important" ng-class="{\'active\': tag.selected}">{{tag.name}}</a></li></ul><div class="clearfix"></div></div></div></div></div><div class="col-lg-9 animated fadeInRight"><div class="ibox"><div class="ibox-content" style="padding: 15px 20px"><div class="row"><div class="col-xs-12 col-sm-10 no-padding" ng-if="!vm.filtring"><label class="no-margin" style="padding: 8px 15px" ng-if="vm.breadcrumbs.length <= 1  && !vm.loadingBreadcrumb">In\xEDcio</label><ol class="breadcrumb no-margin" ng-show="vm.breadcrumbs.length > 1 && !vm.loadingBreadcrumb"><li class="breadcrumb-item" ng-repeat="crumb in vm.breadcrumbs" ng-class="{ active: $last }"><a ng-if="!$last" ng-click="vm.enterInFolder(crumb)">{{ crumb.name }}</a> <strong ng-if="$last">{{ crumb.name }}</strong></li></ol><div ng-if="vm.loadingBreadcrumb"><div class="sk-container"><div class="sk-spinner sk-spinner-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div></div></div><div class="col-xs-12 col-sm-10 no-padding" ng-if="vm.filtring"><label class="no-margin" style="padding: 8px 15px">{{\'file-manager.form.filter-result\' | translate}}</label></div><div class="col-xs-12 col-sm-2"><button class="btn btn-primary pull-right m-l-xs" ng-click="vm.uploadFiles()"><i class="fa fa-file"></i> {{\'file-manager.action.add-file\' | translate}}</button></div></div></div></div><div ng-if="vm.loadingFiles" class="tab-content"><div class="sk-container"><div class="sk-spinner sk-spinner-circle"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div></div><div class="col-xs-12 showcase-box-noflyer m-t-md" ng-if="!vm.loadingFiles && !vm.files.length"><img ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/picture-icon-logo.png"><h1 data-translate="file-manager.message.no-file-title" class="ng-scope"></h1><p ng-if="!vm.filtring" class="ksc-sub-title ng-scope" data-translate="file-manager.message.no-file-subtitle"></p><p ng-if="vm.filtring" class="ksc-sub-title ng-scope" data-translate="file-manager.form.filter-no-result"></p></div><div class="row" ng-if="!vm.loadingFiles"><div class="col-lg-12 file-grid"><div class="file-box" ng-repeat="file in vm.files"><div class="file pointer"><div class="image" ng-if="vm.getFileType(file.type) === \'IMAGE\'"><img alt="image" class="img-fluid" ng-src="{{file.link}}"></div><div class="icon" ng-if="vm.getFileType(file.type) === \'VIDEO\'"><i class="fa fa-film"></i></div><div class="icon" ng-if="vm.getFileType(file.type) === \'OTHER\'"><i class="fa fa-file"></i></div><div class="file-name"><div class="row"><div class="col-xs-10 no-padding-right" tooltip-placement="bottom" uib-tooltip="{{file.name}}">{{vm.getFileName(file.name)}}</div><div class="col-xs-1"><a class="dropdown-toggle no-padding pull-right" data-toggle="dropdown" href="#" aria-expanded="false"><i class="fa fa-ellipsis-v" style="font-size: 15px"></i></a><ul class="dropdown-menu" data-flip="false"><li><a target="_self" ng-href="{{file.link}}" download="{{file.name}}" class="dropdown-item" style="padding-left: 10px !important">{{\'file-manager.action.download\' | translate}}</a></li><li ng-click="vm.editFile(file)"><a href="#" class="dropdown-item" style="padding-left: 10px !important">{{\'file-manager.action.edit\' | translate}}</a></li><li ng-click="vm.deleteConfirmation(false, file, vm.deleteFile)"><a href="#" class="dropdown-item" style="padding-left: 10px !important">{{\'file-manager.action.delete\' | translate}}</a></li></ul></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/hub-management/flyers/flyers-add-size-variation.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" style="text-transform: uppercase" data-translate="flyers.new.form.price-inventory.add-variation"></h4></div><div class="modal-body"><p data-translate="flyers.new.form.price-inventory.add-variation-hint"></p><ul class="nav nav-tabs"><li ng-class="{\'active\' : vm.tab === \'classic\'}" class="ksc-tab active"><a ng-click="vm.changeTab(\'classic\')"><span data-translate="flyers.new.form.size.classic">Classicos</span></a></li><li ng-class="{\'active\' : vm.tab === \'juvenileChild\'}" class="ksc-tab"><a ng-click="vm.changeTab(\'juvenileChild\')"><span data-translate="flyers.new.form.size.juvenile-child">Infanto Juvenil</span></a></li><li ng-class="{\'active\' : vm.tab === \'shorts\'}" class="ksc-tab"><a ng-click="vm.changeTab(\'shorts\')"><span data-translate="flyers.new.form.size.shorts">Shorts, Bermudas e Cal\xE7as</span></a></li><li ng-class="{\'active\' : vm.tab === \'plusSize\'}" class="ksc-tab"><a ng-click="vm.changeTab(\'plusSize\')"><span data-translate="flyers.new.form.size.plus-size">Plus Size</span></a></li><li ng-class="{\'active\' : vm.tab === \'others\'}" class="ksc-tab"><a ng-click="vm.changeTab(\'others\')"><span data-translate="flyers.new.form.size.others">Outros</span></a></li></ul><div class="tab-content" style="border: 1px solid #efefef; border-top: 0"><div class="row no-margin"><div class="col-xs-2" ng-repeat="size in vm.sizes" style="padding: 0 10px"><div class="checkbox" style="background: whitesmoke; border-radius: 2px;padding: 5px; max-width: 75px"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.checkSize(size, $event)" ng-checked="vm.isChecked(size)"> <span id="{{size}}" class="checkbox-material"><span class="check"></span></span> <span>{{size}}</span></label></div></div></div></div></div><div class="modal-footer"><button class="btn btn-primary" data-style="slide-left" ng-click="vm.ok()">OK</button></div>');
$templateCache.put('app/admin/hub-management/flyers/flyers-description-modal.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" style="text-transform: uppercase" data-translate="flyers.detail.about">Flyer About</h4></div><div class="modal-body"><div slim-scroll max-height="425px" style="text-align: justify;\n    text-justify: inter-word"><span style="word-wrap: break-word" g-bind="vm.flyerDescription">{{vm.flyerDescription}}</span></div></div><div class="modal-footer"><button class="btn btn-primary" data-style="slide-left" ng-click="vm.ok()">OK</button></div>');
$templateCache.put('app/admin/hub-management/flyers/flyers-detail.html','<div class="wrapper wrapper-content"><div class="row row-eq-height"><div class="col-xs-12 col-md-4"><div class="ibox flyer-detail-box" style="background-color: #FFFFFF"><div class="ibox-title"><h5 class="sc-default-title-font"><span data-translate="flyers.detail.title">Flyer Details</span></h5><span class="fa fa-file-text-o flyer-detail-button" style="padding-left: 5px" tooltip-placement="top-right" has-authority="STORE_UPDATE_FLYER" uib-tooltip="{{\'flyers.detail.buttons.social\' | translate}}" ng-click="vm.getEditFlyerInfo()"></span> <span tooltip-placement="top-right" uib-tooltip="{{\'flyers.detail.buttons.info\' | translate}}" class="fa fa-pencil-square-o flyer-detail-button" has-authority="STORE_UPDATE_FLYER" ng-click="vm.getEditFlyer()"></span> <span class="fa fa-picture-o flyer-detail-button" style="padding-right: 5px" tooltip-placement="top-right" uib-tooltip="{{\'flyers.detail.buttons.image\' | translate}}" has-authority="STORE_UPDATE_FLYER" ng-click="vm.getEditFlyerImage()"></span></div><div style="background-color: #EAEAEA; height: 40%" ng-show="!vm.flyer" align="center"><span style="color: #FFFFFF; font-size: 12em; text-align: center" class="icon-ksc-storelogo"></span></div><div></div><img style="width: 100%" ng-if="vm.flyer && !vm.loadingImage" ng-src="{{vm.imagePath}}"><div ng-if="vm.loadingImage" class="sk-container" style="padding-top: 40%; height: 329px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><hr class="flyer-line" ng-if="!vm.isLoading" tooltip-placement="bottom-right" uib-tooltip="{{vm.getFlyerTooltip(vm.flyer.status) | translate}}" ng-class="{\'flyer-line-activated-{{ vm.flyer.type }}\': vm.flyer.status == \'ACTIVATED\', \'flyer-line-deactivated-{{ vm.flyer.type }}\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(vm.flyer.status))}"><div class="ibox-content"><div class="row"><div class="col-xs-12" style="word-wrap: break-word; margin-top: 15px"><span class="store-item-category product-category">{{vm.flyer.category}}</span><p class="sc-default-title-font store-item-name" ng-show="!vm.isLoading" style="width: 100%">{{vm.flyer.name}}</p><p class="sc-default-subtitle-font flyer-item-contact" ng-show="!vm.isLoading" data-translate="flyers.detail.about">About the flyer</p><p flyers-description-collapse flyers-description-collapse-max-length="140" flyers-description-collapse-text="{{ vm.flyer.description }}"></p></div><div class="col-xs-12" style="display: table"><div style="display: table-cell; vertical-align: bottom; padding-bottom: 5px"><span ng-show="vm.flyer.expirationDate" tooltip-placement="bottom-left" uib-tooltip="{{\'flyers.new.form.expirationDate\' | translate}}"><i class="fa fa-clock-o product-date-icon"></i><span class="flyer-table-info product-date">{{vm.flyer.expirationDate | date: "dd/MM/yyyy"}}</span></span></div><div style="display: table-cell; text-align: right"><p class="product-info-price-normal flyer-prices-remove-margin" ng-if="vm.flyer.discountedValue && vm.flyer.discountValue"><span>{{vm.getFlyerCurrency(vm.flyer.currency)}} </span><span class="coupon-desactived-decoration">{{vm.flyer.purchaseValue | number : 2}}</span></p><p class="product-info-price flyer-prices-remove-margin" ng-if="vm.flyer.discountedValue"><span>{{vm.getFlyerCurrency(vm.flyer.currency)}} </span>{{vm.flyer.discountedValue | number : 2}}</p><p class="product-info-price flyer-prices-remove-margin" ng-if="!vm.flyer.discountedValue && vm.flyer.purchaseValue"><span>{{vm.getFlyerCurrency(vm.flyer.currency)}} </span>{{vm.flyer.purchaseValue | number : 2}}</p></div></div></div></div></div></div><div class="col-xs-12 col-md-8" style="padding-left: 0"><div class="ibox" style="height: 95.5%; background-color: #FFFFFF"><div class="ibox-title"><h5 class="sc-default-title-font" data-translate="flyers.detail.location">Location</h5><br></div><div class="ibox-content"><div class="col-xs-12" style="margin: 0 !important; padding: 0 !important" align="left"><div class="col-md-8" style="margin: 0 !important; padding: 0 0 0 0"><p data-translate="flyers.detail.map">View on the map the locations where coupons can be used</p></div><div class="col-md-4" style="margin: 0 !important; padding: 0 0 10px 0" align="right"><div class="checkbox" style="margin: 0 !important"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.checkAllMarkers()" ng-model="vm.allMarkersChecked"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="flyers.messages.global.checkAll">Marcar todos</span></label></div></div></div><div class="col-xs-12 loading-map-detail" ng-show="vm.isLoading"></div></div></div></div></div></div>');
$templateCache.put('app/admin/hub-management/flyers/flyers-edit-image.html','<form name="flyerEditImageForm" role="form" novalidate ng-submit="vm.save()" ng-init="vm.initFlyerImageModal()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" data-translate="flyers.edit-image.title">Edit a Flyer Image</h4></div><div class="modal-body"><div class="container-fluid"><div class="row"><div class="col-xs-12"><input type="file" id="fileInput" style="display: none" accept="image/x-png,image/gif,image/jpeg"> <span class="store-upload-button" ng-click="vm.openInput($event)"><span data-translate="flyers.new.form.chooseimage">Choose Image</span><i style="margin-left: 5px" class="fa fa-upload" aria-hidden="true"></i></span> <span class="store-upload-button pull-right"><span data-translate="flyers.edit-image.editImageAlternative">Crie o seu design com o </span><a href="https://www.canva.com/pt_br/modelos/" target="_blank">Canva</a></span><div ng-show="flyerSecondForm.image.$invalid && flyerSecondForm.image.$dirty"><p class="help-block form-invalid-field" ng-show="flyerSecondForm.image.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="flyerSecondForm.image.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field is required.</p></div></div><div class="col-xs-12" style="margin-top: 15px" align="center"><div class="cropArea"><img-crop area-type="square" ng-if="vm.imageUpload" image="vm.imageUpload" result-image-size="vm.imageSize" on-load-begin="vm.imageChanged = true" result-image="vm.flyerImage" result-image-quality="1.0"></img-crop><span ng-if="!vm.imageUpload" style="color: #FFFFFF; font-size: 12em; text-align: center; position: relative; top: 90px" class="icon-ksc-storelogo"></span></div></div></div><div class="row" align="right" style="margin-top: 10px"><button id="btnSaveImageFlyer" ladda="vm.isSaving" type="submit" class="btn btn-primary" ng-disabled="flyerEditForm.$invalid" ng-click="vm.saveFlyer()" data-style="slide-left"><span data-translate="flyers.edit-image.button">Atualizar informa\xE7\xF5es do flyer</span></button></div></div></div></form>');
$templateCache.put('app/admin/hub-management/flyers/flyers-edit-info.html','<form name="flyerEditForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" data-translate="flyers.edit.title">Edit a Flyer Information</h4></div><div class="modal-body" style="overflow-y: auto !important; max-height: calc(100vh - 180px)"><div class="container-fluid"><jhi-alert-error></jhi-alert-error><div class="row" style="margin: 0 !important"><label for="description" data-translate="flyers.new.form.description">Description</label><textarea id="description" name="description" class="form-control" style="min-height: 145px" ng-model="vm.flyer.description">\n                </textarea></div><div class="row" style="margin: 0 !important" ng-if="vm.flyer.type === \'COUPON\'"><label for="rules">Regras do Panfleto</label><textarea id="rules" name="rules" class="form-control" ng-model="vm.flyer.rulesForUse" style="min-height: 145px">\n                </textarea></div></div></div><div class="modal-footer"><div class="col-xs-12"><div class="row"><button ladda="vm.isSaving" type="submit" class="btn btn-primary" ng-disabled="flyerEditForm.$invalid" ng-click="vm.saveFlyer()" data-style="slide-left"><span class="fa fa-tag"></span>&nbsp;<span data-translate="flyers.edit.button">Atualizar informa\xE7\xF5es do flyer</span></button></div></div></div></form>');
$templateCache.put('app/admin/hub-management/flyers/flyers-edit.html','<form name="vm.flyerEditForm" role="form" novalidate ng-submit="vm.saveFlyer()" ng-init="vm.init()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" data-translate="flyers.edit.title">Edit a Flyer</h4></div><div class="modal-body" style="overflow-y: auto !important; max-height: calc(100vh - 180px)"><div class="container-fluid"><div class="row"><div class="row" style="margin: 0 !important"><div class="form-group col-xs-8 store-input-nopadding"><label class="required" for="name" data-translate="flyers.new.form.name">Name</label><input id="name" name="name" ng-model="vm.flyer.name" type="text" class="form-control" ng-maxlength="150" ng-minlength="4" required><div ng-show="vm.flyerEditForm.name.$invalid &&  (vm.flyerEditForm.$submitted || vm.flyerEditForm.name.$error.maxlength)"><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 25 characters.</p></div></div><div class="form-group col-xs-4 store-input-nopadding"><label for="name" data-translate="flyers.new.form.productReference">Product Reference</label><input id="productReference" name="productReference" ng-model="vm.flyer.productReference" type="text" class="form-control"></div></div><div class="row" style="margin: 0 !important"><div class="form-group col-xs-6 store-input-nopadding"><label for="category" class="required" data-translate="flyers.new.form.category">Category</label><select id="category" name="category" type="text" class="form-control" ng-model="vm.flyer.categoryKey" required><option ng-repeat="category in vm.categories" value="{{category.key}}">{{category.title}}</option></select><div ng-show="vm.flyerEditForm.category.$invalid &&  vm.flyerEditForm.$submitted"><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.category.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group store-input-nopadding" ng-class="vm.fullCategory.ownerKey === \'FASHION\' ? \'col-md-3\' : \'col-md-6\'" ng-show="vm.fullCategory.ownerKey === \'FASHION\'" style="padding-right: 10px"><label for="gender" class="required" data-translate="flyers.new.form.gender.title">Gender</label><select id="gender" name="gender" type="text" class="form-control" ng-model="vm.flyer.gender" ng-required="vm.fullCategory.ownerKey === \'FASHION\'"><option value="1" data-translate="flyers.new.form.gender.male">Male</option><option value="2" data-translate="flyers.new.form.gender.female">Female</option><option value="3" data-translate="flyers.new.form.gender.both">Both</option></select><div ng-show="vm.flyerFirstForm.type.$invalid && vm.firstFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="store-input-nopadding" ng-class="vm.fullCategory.ownerKey == \'FASHION\' ? \'col-md-3\' : \'col-md-6\'" ng-show="vm.fullCategory.ownerKey === \'FASHION\'"><label for="type" class="required" data-translate="flyers.new.form.type">Type</label><select id="type" name="type" type="text" class="form-control" ng-model="vm.flyer.type" ng-change="vm.typeChanged()" required><option value="COUPON" data-translate="flyers.new.form.userInteract.types.coupon">Coupon</option><option value="CONTACT" data-translate="flyers.new.form.userInteract.types.contact">Contact</option><option value="RENT" data-translate="flyers.new.form.userInteract.types.rent">Rent</option><option value="SALE" data-translate="flyers.new.form.userInteract.types.sale">Sale</option></select><div ng-show="vm.flyerFirstForm.type.$invalid && vm.firstFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row" style="margin: 0 !important; margin-bottom: 15px !important"><div class="col-xs-12 col-md-3 store-input-nopadding" ng-show="vm.brands.length !== 0"><label for="brand" class="required" data-translate="flyers.new.form.brand">Brand</label><select id="brand" name="brand" type="text" class="form-control" ng-model="vm.flyer.brand" ng-required="vm.brands.length !== 0 && vm.fullCategory.ownerKey === \'FASHION\'"><option ng-repeat="brand in vm.brands" value="{{brand.name}}">{{brand.name}}</option></select><div ng-show="vm.flyerFirstForm.brand.$invalid && vm.firstFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.brand.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-xs-12 store-input-nopadding" style="padding-right: 10px" ng-class="vm.brands.length !== 0 ? \'col-md-3\' : \'col-md-6\'"><label for="color" data-translate="flyers.new.form.color">Color</label><select id="color" name="color" type="text" class="form-control" ng-model="vm.flyer.color"><option ng-repeat="color in vm.colors" value="{{color}}">{{color}}</option></select></div><div class="col-xs-12 store-input-nopadding" style="padding-right: 10px" ng-class="vm.brands.length !== 0 ? \'col-md-3\' : \'col-md-6\'"><label for="size">{{ vm.storeCategory == \'FASHION\' ? \'flyers.new.form.size.title\' : \'flyers.new.form.variation\' | translate }}</label><div class="dropdown"><button class="btn btn-select-size dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{\'flyers.new.form.size.label-select\' | translate}} <i class="fa fa-caret-down"></i></button><div class="dropdown-menu" aria-labelledby="dropdownMenuButton" ng-click="$event.stopPropagation()" style="max-height: 25vh; overflow: auto"><div class="checkbox dropdown-item" style="margin-top: 10px" ng-repeat="size in vm.sizes"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfSizeSelected(size)" ng-click="vm.updateSizeOrRemove(size)" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{size}}</label></div></div></div></div><div class="col-xs-12 store-input-nopadding col-md-3"><label for="dropdownMenuButtonOpt" data-translate="flyers.new.form.configurations.title">Configura\xE7\xF5es</label><div class="dropdown"><button class="btn btn-select-size dropdown-toggle" type="button" id="dropdownMenuButtonOpt" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{\'flyers.new.form.configurations.label-select\' | translate}} <i class="fa fa-caret-down"></i></button><div class="dropdown-menu" aria-labelledby="dropdownMenuButtonOpt" ng-click="$event.stopPropagation()" style="max-height: 25vh; overflow: auto"><div class="checkbox dropdown-item" style="margin-top: 10px; margin-bottom: 10px"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfLaunchSelected()" ng-click="vm.updateLaunchOrRemove()" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{\'flyers.new.form.configurations.launch\' | translate}}</label></div><div class="checkbox dropdown-item" style="margin-top: 10px; margin-bottom: 10px"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfBasicSelected()" ng-click="vm.updateBasicOrRemove()" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{\'flyers.new.form.configurations.basic\' | translate}}</label></div></div></div></div></div><div class="row" style="margin: 0 !important"><div class="form-group col-md-6 store-input-nopadding"><label for="currency" class="required" data-translate="flyers.new.form.currency">Currency</label><select id="currency" name="currency" type="text" class="form-control" ng-model="vm.flyer.currencyInstance" ng-options="value as value.text for (key, value) in vm.currencyConfigurations" ng-disabled="vm.disabledCurrency" required></select><div ng-show="vm.flyerEditForm.currency.$invalid &&  vm.flyerEditForm.$submitted"><p class="help-block form-invalid-field" ng-show="flyerEditForm.currency.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-6 store-input-nopadding"><label for="value" ng-class="{ \'required\' : ([\'RENT\', \'COUPON\', \'SALE\'].includes(vm.flyer.type) ) }" data-translate="flyers.new.form.value">Value</label><div class="input-group"><span class="input-group-addon">{{ vm.flyer.currencyInstance.prefix }}</span> <input id="value" name="value" ng-model="vm.flyer.purchaseValue" class="form-control" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true" ng-required="vm.flyer.discountValue || ([\'RENT\', \'COUPON\', \'SALE\'].includes(vm.flyer.type))" ng-change="vm.checkDiscountType()"></div><div ng-show="vm.flyerEditForm.value.$invalid"><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.value.$error.required && vm.flyer.type !== \'RENT\'" data-translate="entity.validation.requiredPrice">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.flyer.type === \'RENT\'" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row" style="margin: 0 !important"><div class="form-group col-md-6 store-input-nopadding"><label for="discountType" data-translate="flyers.new.form.discount.title">Discount Type</label><select id="discountType" name="discountType" type="text" class="form-control" ng-model="vm.flyer.discountType"><option value="DISCOUNT_PERCENTAGE">{{\'flyers.new.form.discount.percent\' | translate}}</option><option value="DISCOUNT_FIXED">{{\'flyers.new.form.discount.price\' | translate}}</option></select><div ng-show="vm.flyerEditForm.discountType.$invalid &&  vm.flyerEditForm.$submitted"><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.discountType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-6 store-input-nopadding"><label for="discountValue" data-translate="flyers.new.form.discount.value">Discount Value</label><div class="input-group" ng-if="vm.isToDisplayMe(\'DISCOUNT_FIXED\')"><span class="input-group-addon">{{ vm.flyer.currencyInstance.prefix }}</span> <input id="discountValuePrice" name="discountValue" class="form-control" type="text" ng-model="vm.flyer.discountValue" min="0" max="{{ vm.flyer.purchaseValue }}" ng-change="vm.checkDiscountType()" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true"></div><div ng-show="vm.flyerEditForm.discountValue.$invalid && vm.isToDisplayMe(\'DISCOUNT_FIXED\')"><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.discountValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.discountValue.$error.discountGreaterThanValue" data-translate="entity.validation.discountGreatThanValue">The discount amount cannot be greater than the value of the flyer.</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.discountValue.$error.max" data-translate="entity.validation.max" translate-value-max="{{ vm.flyer.purchaseValue }}">MAX</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.discountValue.$error.min" data-translate="entity.validation.min" translate-value-min="{{ vm.flyer.purchaseValue }}">MIN</p></div><div class="input-group" ng-if="vm.isToDisplayMe(\'DISCOUNT_PERCENTAGE\')"><span class="input-group-addon">%</span> <input id="discountValuePercentage" name="discountValuePercentage" class="form-control" type="number" ng-model="vm.flyer.discountPercentageValue" min="0.0" max="100.0" placeholder="0.00"></div><div ng-show="vm.flyerEditForm.discountValuePercentage.$invalid && vm.isToDisplayMe(\'DISCOUNT_PERCENTAGE\')"><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.discountValuePercentage.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.discountValuePercentage.$error.discountGreaterThanValue" data-translate="entity.validation.discountGreatThanValue">The discount amount cannot be greater than the value of the flyer.</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.discountValuePercentage.$error.max" data-translate="entity.validation.max" translate-value-max="100.00">MAX</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.discountValuePercentage.$error.min" data-translate="entity.validation.min" translate-value-min="0.00">MIN</p></div></div></div><div class="row" style="margin: 0 !important"><div class="form-group"><div class="col-xs-12 col-md-12 store-input-nopadding no-padding-right"><label for="tag" data-translate="flyers.new.form.tags.title">Tags</label><div class="dropdown"><tags-input replace-spaces-with-dashes="false" placeholder="{{ \'flyers.new.form.tags.placeholder\' | translate }}" ng-model="vm.flyer.tags"></tags-input></div></div></div></div><div ng-if="vm.flyer.type === \'SALE\'" class="row" style="margin: 0 !important"><div class="form-group col-md-6 store-input-nopadding"><label for="bulkQuantity" data-translate="flyers.new.bulkPieces">Atacado minimo de pe\xE7as</label><input id="bulkQuantity" name="bulkQuantity" class="form-control" type="number" min="0" ng-model="vm.flyer.bulkQuantity" min="0" placeholder="0"></div><div class="form-group col-md-6 store-input-nopadding"><label for="bulkDiscount" data-translate="flyers.new.bulkDiscount">Atacado desconto</label><div class="input-group"><span class="input-group-addon">%</span> <input id="bulkDiscount" name="bulkDiscount" class="form-control" type="number" ng-model="vm.flyer.discountBulkPercentage" min="0.0" max="100.0" placeholder="0.00"></div><div><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.bulkDiscount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.bulkDiscount.$error.discountGreaterThanValue" data-translate="entity.validation.discountGreatThanValue">The discount amount cannot be greater than the value of the flyer.</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.bulkDiscount.$error.max" data-translate="entity.validation.max" translate-value-max="100.00">MAX</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.bulkDiscount.$error.min" data-translate="entity.validation.min" translate-value-min="0.00">MIN</p></div></div></div><!-- <div class="row" style="margin: 0 !important; padding: 0 !important;">\n                    <div class="form-group col-md-12 store-input-detail-nopadding">\n                        <div class="form-group" style="margin-top: 5px; margin-bottom: 5px;">\n                            <label for="startDate" class="required" data-translate="flyers.new.form.startDate">Start Date</label>\n                            <div class=\'input-group date\' id=\'startDateTime\'>\n                                <input name="startDate" type=\'text\' id="startDate" class="form-control inputDate" readonly="readonly" ng-disabled="vm.checkFlyerHasCouponGenerated()" ng-required="true" autocomplete="off" ng-model="vm.flyer.startDate"/>\n                                <span class="input-group-addon">\n                                    <span class="glyphicon glyphicon-calendar"></span>\n                                </span>\n                            </div>\n                            <div class="help-block-div" ng-show="vm.flyerEditForm.startDate.$invalid &&  vm.flyerEditForm.$submitted">\n                                <p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.startDate.$error.required" data-translate="entity.validation.required">This field is required.</p>\n                                <p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.startDate.$error.minDate" data-translate="flyers.new.error.startDateGreaterOrEqualNow">Start date must be greater than or equal to current date.</p>\n                            </div>\n                        </div>\n                    </div>\n                </div> --><!-- <div class="row" style="margin: 0 !important;" ng-show="vm.flyer.type !== \'RENT\'">\n                    <div class="col-xs-12 form-group store-input-detail-nopadding" style="margin-top: 10px;">\n                        <div class="form-group" style="margin-top: 5px; margin-bottom: 5px;">\n                            <label for="expirationDate" data-translate="flyers.new.form.expirationDate">Expiration Date</label>\n                            <div class="input-group date" id="expirationDateTime">\n                                <input id="expirationDate" class="form-control inputDate" readonly="readonly" ng-required="!vm.checks.validityTypeDate" name="expirationDate" ng-disabled="vm.checks.validityTypeDate" ng-model="vm.flyer.expirationDate" />\n                                <span class="input-group-addon">\n                                    <span class="glyphicon glyphicon-calendar"></span>\n                                </span>\n                            </div>\n                            <div class="help-block-div" ng-show="vm.flyerEditForm.expirationDate.$invalid && vm.flyerEditForm.$submitted">\n                                <p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.expirationDate.$error.required" data-translate="entity.validation.required">This field is required.</p>\n                            </div>\n                        </div>\n                        <div class="col-xs-12 form-group store-input-detail-nopadding" style="padding-top: 0 !important; padding-bottom: 0 !important; margin-top: 0 !important; margin-bottom: 0 !important;">\n                            <div class="checkbox" style="margin-top: 2px;">\n                                <label>\n                                    <input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.checks.validityTypeDate" checked ng-change="vm.onValidityTypeDateChange(vm.checks.validityTypeDate)" />\n                                    <span class="checkbox-material">\n                                        <span class="check">\n                                        </span>\n                                    </span>\n                                    <span data-translate="flyers.new.form.disabled">Active</span>\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                </div> --><!-- <div class="row" style="margin: 0 !important; padding: 0 !important;" ng-if="[\'COUPON\', \'SALE\'].includes(vm.flyer.type)">\n                    <div class="col-xs-12" style="margin: 0 !important; padding: 0 !important;">\n                        <div class="col-xs-6 form-group" style="margin: 0 !important; padding: 0 5px 0 0 !important;">\n                            <label for="maxUsage" data-translate="flyers.new.form.maxUsage">Max flyer usage</label>\n                            <input id="maxUsage" name="maxUsage" ng-model="vm.flyer.maxUsages" type="number" class="form-control" ng-disabled="vm.checks.validityTypeNumber" ng-maxlength=25 min=0 oninput="validity.valid||(value=\'\');" />\n                            <div ng-show="vm.flyerEditForm.maxUsage.$invalid &&  vm.flyerEditForm.$submitted">\n                                <p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.maxUsage.$error.required" data-translate="entity.validation.required">This field is required.</p>\n                                <p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.maxUsage.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="25">This field cannot be longer than 25 characters.</p>\n                            </div>\n                            <div class="checkbox" style="margin-top: 2px;">\n                                <label>\n                                    <input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.checks.validityTypeNumber" checked/>\n                                    <span class="checkbox-material">\n                                        <span class="check">\n                                        </span>\n                                    </span>\n                                    <span data-translate="flyers.new.form.disabled">Active</span>\n                                </label>\n                            </div>\n                        </div>\n                        <div class="col-xs-6 form-group" style="margin: 0 !important; padding: 0 0 0 5px !important;" ng-if="[\'COUPON\'].includes(vm.flyer.type)">\n                            <label for="maxUsageByUser" data-translate="flyers.new.form.maxUsageByUser">Max flyer usage by user</label>\n                            <input id="maxUsageByUser" name="maxUsageByUser" ng-model="vm.flyer.maxUsageByUser" type="number" class="form-control" ng-disabled="vm.checks.usageLimitByUser" ng-maxlength=50 min=0 oninput="validity.valid||(value=\'\');" />\n                            <div ng-show="vm.flyerEditForm.maxUsageByUser.$invalid && vm.flyerEditForm.$submitted">\n                                <p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.maxUsageByUser.$error.required" data-translate="entity.validation.required">This field is required.</p>\n                                <p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.maxUsageByUser.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field is required.</p>\n                            </div>\n                            <div class="checkbox" style="margin-top: 2px;">\n                                <label>\n                                    <input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.checks.usageLimitByUser" ng-change="vm.changeStatusFilterToActive()" checked/>\n                                    <span class="checkbox-material">\n                                        <span class="check">\n                                        </span>\n                                    </span>\n                                    <span data-translate="flyers.new.form.disabled">Active</span>\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                </div> --></div></div></div><div class="modal-footer"><div class="col-xs-12"><div class="row"><button id="btnSaveEditFlyer" ladda="vm.isSaving" type="submit" class="btn btn-primary" data-style="slide-left" ng-disabled="vm.flyerEditForm.$invalid"><span class="fa fa-tag"></span>&nbsp; <span data-translate="flyers.edit.button">Atualizar informa\xE7\xF5es do flyer</span></button></div></div></div></form>');
$templateCache.put('app/admin/hub-management/flyers/flyers-form.html','<div class="wrapper wrapper-content animated fadeIn" id="content"><style>md-autocomplete-wrap {\n            height: 34px !important;\n            box-shadow: none !important;\n            border: 1px solid #e5e6e7;\n            border-radius: 1px;\n            height: 0px;\n        }\n        .md-virtual-repeat-container.md-autocomplete-suggestions-container {\n            width: 250px !important;\n        }\n\n        html.no-js.ng-scope {\n            overflow: auto !important;\n        }\n\n        .md-autocomplete-suggestions-container{\n            position: fixed !important;\n        }\n\n        md-switch .md-thumb {\n            background-color: darkgrey;\n        }\n\n        md-switch .md-bar {\n            background-color: lightgray;\n        }\n\n        md-switch:last-of-type {\n            margin: 0px;\n        }\n\n        .border-img-default {\n            border: dotted !important; border-width: 2px !important; border-color: #b9b9b9 !important;\n        }\n\n        .border-zero {\n            border: 0px !important;\n        }\n\n\t\t.ui-sortable-placeholder {\n\t\t  width: 50%;\n\t\t}\n\n\n\t\t.dragzone .product-card {\n\t\t  max-width: 100%;\n\t\t  margin: 0px;\n\t\t  padding: 5px;\n\t\t}\n\n\t\t.dragzone .product-card .product-image img {\n\t\t  width: 100%;\n\t\t}\n\n\t\t@media (min-width: 1550px) {\n\t\t  .col-lgg-1, .col-lgg-2, .col-lgg-3, .col-lgg-4, .col-lgg-5, .col-lgg-6, .col-lgg-7, .col-lgg-8, .col-lgg-9, .col-lgg-10, .col-lgg-11, .col-lgg-12 {\n\t\t    float: left; }\n\t\t  .col-lgg-1 {\n\t\t    width: 8.33333%; }\n\t\t  .col-lgg-2 {\n\t\t    width: 16.66667%; }\n\t\t  .col-lgg-3 {\n\t\t    width: 25%; }\n\t\t  .col-lgg-4 {\n\t\t    width: 33.33333%; }\n\t\t  .col-lgg-5 {\n\t\t    width: 41.66667%; }\n\t\t  .col-lgg-6 {\n\t\t    width: 50%; }\n\t\t  .col-lgg-7 {\n\t\t    width: 58.33333%; }\n\t\t  .col-lgg-8 {\n\t\t    width: 66.66667%; }\n\t\t  .col-lgg-9 {\n\t\t    width: 75%; }\n\t\t  .col-lgg-10 {\n\t\t    width: 83.33333%; }\n\t\t  .col-lgg-11 {\n\t\t    width: 91.66667%; }\n\t\t  .col-lgg-12 {\n\t\t    width: 100%; }\n\t\t  .col-lgg-pull-0 {\n\t\t    right: auto; }\n\t\t  .col-lgg-pull-1 {\n\t\t    right: 8.33333%; }\n\t\t  .col-lgg-pull-2 {\n\t\t    right: 16.66667%; }\n\t\t  .col-lgg-pull-3 {\n\t\t    right: 25%; }\n\t\t  .col-lgg-pull-4 {\n\t\t    right: 33.33333%; }\n\t\t  .col-lgg-pull-5 {\n\t\t    right: 41.66667%; }\n\t\t  .col-lgg-pull-6 {\n\t\t    right: 50%; }\n\t\t  .col-lgg-pull-7 {\n\t\t    right: 58.33333%; }\n\t\t  .col-lgg-pull-8 {\n\t\t    right: 66.66667%; }\n\t\t  .col-lgg-pull-9 {\n\t\t    right: 75%; }\n\t\t  .col-lgg-pull-10 {\n\t\t    right: 83.33333%; }\n\t\t  .col-lgg-pull-11 {\n\t\t    right: 91.66667%; }\n\t\t  .col-lgg-pull-12 {\n\t\t    right: 100%; }\n\t\t  .col-lgg-push-0 {\n\t\t    left: auto; }\n\t\t  .col-lgg-push-1 {\n\t\t    left: 8.33333%; }\n\t\t  .col-lgg-push-2 {\n\t\t    left: 16.66667%; }\n\t\t  .col-lgg-push-3 {\n\t\t    left: 25%; }\n\t\t  .col-lgg-push-4 {\n\t\t    left: 33.33333%; }\n\t\t  .col-lgg-push-5 {\n\t\t    left: 41.66667%; }\n\t\t  .col-lgg-push-6 {\n\t\t    left: 50%; }\n\t\t  .col-lgg-push-7 {\n\t\t    left: 58.33333%; }\n\t\t  .col-lgg-push-8 {\n\t\t    left: 66.66667%; }\n\t\t  .col-lgg-push-9 {\n\t\t    left: 75%; }\n\t\t  .col-lgg-push-10 {\n\t\t    left: 83.33333%; }\n\t\t  .col-lgg-push-11 {\n\t\t    left: 91.66667%; }\n\t\t  .col-lgg-push-12 {\n\t\t    left: 100%; }\n\t\t  .col-lgg-offset-0 {\n\t\t    margin-left: 0%; }\n\t\t  .col-lgg-offset-1 {\n\t\t    margin-left: 8.33333%; }\n\t\t  .col-lgg-offset-2 {\n\t\t    margin-left: 16.66667%; }\n\t\t  .col-lgg-offset-3 {\n\t\t    margin-left: 25%; }\n\t\t  .col-lgg-offset-4 {\n\t\t    margin-left: 33.33333%; }\n\t\t  .col-lgg-offset-5 {\n\t\t    margin-left: 41.66667%; }\n\t\t  .col-lgg-offset-6 {\n\t\t    margin-left: 50%; }\n\t\t  .col-lgg-offset-7 {\n\t\t    margin-left: 58.33333%; }\n\t\t  .col-lgg-offset-8 {\n\t\t    margin-left: 66.66667%; }\n\t\t  .col-lgg-offset-9 {\n\t\t    margin-left: 75%; }\n\t\t  .col-lgg-offset-10 {\n\t\t    margin-left: 83.33333%; }\n\t\t  .col-lgg-offset-11 {\n\t\t    margin-left: 91.66667%; }\n\t\t  .col-lgg-offset-12 {\n\t\t    margin-left: 100%; } }\n\n\n\t\t@media (min-width: 1880px) {\n\t\t  .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12 {\n\t\t    float: left; }\n\t\t  .col-xl-1 {\n\t\t    width: 8.33333%; }\n\t\t  .col-xl-2 {\n\t\t    width: 16.66667%; }\n\t\t  .col-xl-3 {\n\t\t    width: 25%; }\n\t\t  .col-xl-4 {\n\t\t    width: 33.33333%; }\n\t\t  .col-xl-5 {\n\t\t    width: 41.66667%; }\n\t\t  .col-xl-6 {\n\t\t    width: 50%; }\n\t\t  .col-xl-7 {\n\t\t    width: 58.33333%; }\n\t\t  .col-xl-8 {\n\t\t    width: 66.66667%; }\n\t\t  .col-xl-9 {\n\t\t    width: 75%; }\n\t\t  .col-xl-10 {\n\t\t    width: 83.33333%; }\n\t\t  .col-xl-11 {\n\t\t    width: 91.66667%; }\n\t\t  .col-xl-12 {\n\t\t    width: 100%; }\n\t\t  .col-xl-pull-0 {\n\t\t    right: auto; }\n\t\t  .col-xl-pull-1 {\n\t\t    right: 8.33333%; }\n\t\t  .col-xl-pull-2 {\n\t\t    right: 16.66667%; }\n\t\t  .col-xl-pull-3 {\n\t\t    right: 25%; }\n\t\t  .col-xl-pull-4 {\n\t\t    right: 33.33333%; }\n\t\t  .col-xl-pull-5 {\n\t\t    right: 41.66667%; }\n\t\t  .col-xl-pull-6 {\n\t\t    right: 50%; }\n\t\t  .col-xl-pull-7 {\n\t\t    right: 58.33333%; }\n\t\t  .col-xl-pull-8 {\n\t\t    right: 66.66667%; }\n\t\t  .col-xl-pull-9 {\n\t\t    right: 75%; }\n\t\t  .col-xl-pull-10 {\n\t\t    right: 83.33333%; }\n\t\t  .col-xl-pull-11 {\n\t\t    right: 91.66667%; }\n\t\t  .col-xl-pull-12 {\n\t\t    right: 100%; }\n\t\t  .col-xl-push-0 {\n\t\t    left: auto; }\n\t\t  .col-xl-push-1 {\n\t\t    left: 8.33333%; }\n\t\t  .col-xl-push-2 {\n\t\t    left: 16.66667%; }\n\t\t  .col-xl-push-3 {\n\t\t    left: 25%; }\n\t\t  .col-xl-push-4 {\n\t\t    left: 33.33333%; }\n\t\t  .col-xl-push-5 {\n\t\t    left: 41.66667%; }\n\t\t  .col-xl-push-6 {\n\t\t    left: 50%; }\n\t\t  .col-xl-push-7 {\n\t\t    left: 58.33333%; }\n\t\t  .col-xl-push-8 {\n\t\t    left: 66.66667%; }\n\t\t  .col-xl-push-9 {\n\t\t    left: 75%; }\n\t\t  .col-xl-push-10 {\n\t\t    left: 83.33333%; }\n\t\t  .col-xl-push-11 {\n\t\t    left: 91.66667%; }\n\t\t  .col-xl-push-12 {\n\t\t    left: 100%; }\n\t\t  .col-xl-offset-0 {\n\t\t    margin-left: 0%; }\n\t\t  .col-xl-offset-1 {\n\t\t    margin-left: 8.33333%; }\n\t\t  .col-xl-offset-2 {\n\t\t    margin-left: 16.66667%; }\n\t\t  .col-xl-offset-3 {\n\t\t    margin-left: 25%; }\n\t\t  .col-xl-offset-4 {\n\t\t    margin-left: 33.33333%; }\n\t\t  .col-xl-offset-5 {\n\t\t    margin-left: 41.66667%; }\n\t\t  .col-xl-offset-6 {\n\t\t    margin-left: 50%; }\n\t\t  .col-xl-offset-7 {\n\t\t    margin-left: 58.33333%; }\n\t\t  .col-xl-offset-8 {\n\t\t    margin-left: 66.66667%; }\n\t\t  .col-xl-offset-9 {\n\t\t    margin-left: 75%; }\n\t\t  .col-xl-offset-10 {\n\t\t    margin-left: 83.33333%; }\n\t\t  .col-xl-offset-11 {\n\t\t    margin-left: 91.66667%; }\n\t\t  .col-xl-offset-12 {\n\t\t    margin-left: 100%; } }</style><div class="ibox float-e-margins"><div class="ibox-content"><div ng-if="vm.isLoading" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><form name="vm.flyerForm" ng-if="!vm.isLoading" novalidate><!-- Product Info --><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.product-info.title"></h1><p data-translate="flyers.new.form.product-info.subtitle"></p></div></div><div class="row m-t-sm"><div class="col-md-12 col-sm-12 col-xs-12 col-lg-6 col-lgg-6 col-xl-6"><div class="row"><div class="form-group col-xs-12 col-md-8"><label class="required" for="name" data-translate="flyers.new.form.name">Name</label><input id="name" name="name" ng-model="vm.flyer.name" type="text" class="form-control" ng-maxlength="150" ng-minlength="4" required><div ng-show="vm.flyerForm.name.$invalid && vm.flyerForm.name.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.name.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div><div class="form-group col-xs-12 col-md-4"><label for="productReference" data-translate="flyers.new.form.productReference">Product Reference</label><input id="productReference" name="productReference" ng-model="vm.flyer.productReference" type="text" class="form-control" placeholder="Ex: 120921212"></div></div><div class="row"><div class="form-group col-xs-12" ng-class="vm.fullCategory.ownerKey === \'FASHION\' ? \'col-md-4\' : \'col-md-6\'"><label for="category" class="required" data-translate="flyers.new.form.category">Category</label><select id="category" name="category" type="text" class="form-control" ng-model="vm.flyer.categoryKey" ng-change="vm.onChangeCategory()" required><option ng-repeat="category in vm.categories" value="{{category.key}}">{{category.title}}</option></select><div ng-show="vm.flyerForm.category.$invalid && vm.flyerForm.category.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.category.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-xs-12 col-md-4" ng-show="vm.fullCategory.ownerKey === \'FASHION\'"><label for="gender" class="required" data-translate="flyers.new.form.gender.title">Gender</label><select id="gender" name="gender" type="text" class="form-control" ng-model="vm.flyer.gender" ng-required="vm.fullCategory.ownerKey === \'FASHION\'"><option value="1" data-translate="flyers.new.form.gender.male">Male</option><option value="2" data-translate="flyers.new.form.gender.female">Female</option><option value="3" data-translate="flyers.new.form.gender.both">Both</option></select><div ng-show="vm.flyerForm.gender.$invalid && vm.flyerForm.gender.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.gender.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-xs-12" ng-class="vm.fullCategory.ownerKey === \'FASHION\' ? \'col-md-4\' : \'col-md-6\'"><label for="type" class="required" data-translate="flyers.new.form.type">Type</label><select id="type" name="type" type="text" class="form-control" ng-model="vm.flyer.type" ng-change="vm.typeChanged()" required><option value="COUPON" data-translate="flyers.new.form.userInteract.types.coupon">Coupon</option><option value="SALE" data-translate="flyers.new.form.userInteract.types.sale">Sale</option></select><div ng-show="vm.flyerForm.type.$invalid && vm.flyerForm.type.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.type.$error.required" data-translate="entity.validation.required"></p></div></div></div><div class="row"><div class="form-group" ng-class="vm.fullCategory.ownerKey === \'FASHION\' ? \'col-md-4\' : \'col-md-6\'"><label for="brand" class="required" data-translate="flyers.new.form.brand">Brand</label><md-autocomplete id="brand" md-no-cache="false" md-search-text="vm.searchText" id="brand" name="brand" md-selected-item="vm.flyer.brand" md-selected-item-change="vm.selectedBrandChange(item)" md-items="item in vm.querySearchBrand(vm.searchText)" md-item-text="item.name" md-min-length="0" md-escape-options="clear" placeholder="Ex. {{hubNameUpper}}" input-aria-labelledby="favoriteStateLabel" md-input-name="autocompleteField" md-item-text="item.name"><md-item-template><span md-highlight-text="vm.searchText" md-highlight-flags="^">{{item.name}}</span></md-item-template><md-not-found><span data-translate="brand.brandDoesNotExist">This is brand does not exist</span></md-not-found></md-autocomplete></div><div class="form-group col-md-4" ng-show="vm.fullCategory.ownerKey === \'FASHION\'"><label for="color" data-translate="flyers.new.form.color">Color</label><input id="color" name="color" ng-model="vm.flyer.color" type="text" class="form-control" ng-maxlength="50" ng-minlength="0" style="text-transform:capitalize"></div><div class="form-group" ng-class="vm.fullCategory.ownerKey === \'FASHION\' ? \'col-md-4\' : \'col-md-6\'"><label for="dropdownMenuButtonOpt" data-translate="flyers.new.form.configurations.title">Configura\xE7\xF5es</label><div class="dropdown"><button style="text-align: left" class="btn btn-select-size dropdown-toggle" type="button" id="dropdownMenuButtonOpt" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{\'flyers.new.form.configurations.label-select\' | translate}} <i class="fa fa-caret-down"></i></button><div class="dropdown-menu" aria-labelledby="dropdownMenuButtonOpt" ng-click="$event.stopPropagation()" style="max-height: 25vh"><div class="checkbox dropdown-item" style="margin-top: 10px; margin-bottom: 10px"><label><input type="checkbox" class="dropdown-item-checkbox" checked="checked" ng-checked="vm.checkIfLaunchSelected()" ng-click="vm.updateLaunchOrRemove()"> <span class="checkbox-material"><span class="check"></span></span> {{\'flyers.new.form.configurations.launch\' | translate}}</label></div><div class="checkbox dropdown-item" style="margin-top: 10px; margin-bottom: 10px"><label><input type="checkbox" class="dropdown-item-checkbox" checked="checked" ng-checked="vm.checkIfBasicSelected()" ng-click="vm.updateBasicOrRemove()"> <span class="checkbox-material"><span class="check"></span></span> {{\'flyers.new.form.configurations.basic\' | translate}}</label></div></div></div></div></div><div class="row"><div class="col-xs-12"><label for="description" data-translate="flyers.new.form.description">Description</label><textarea id="description" name="description" class="form-control" ng-model="vm.flyer.description" style="resize: both" rows="8">\n                                </textarea></div></div></div><div class="col-md-12 col-sm-12 col-xs-12 col-lg-6 col-lgg-6 col-xl-6" style="padding-left: 15px; padding-right: 15px; text-align: -webkit-center"><div class="row" style="justify-content: center"><div style="width: 100%; display: flex; justify-content: space-between; padding-left: 15px; padding-right: 15px"><span data-translate="flyers.edit-image.minSize" style="font-size: 11px">Recommended minimum size 600px X 600px</span> <span class="store-upload-button" style="font-size: 11px"><span data-translate="flyers.edit-image.editImageAlternative">Crie o seu design com o </span><a href="https://www.canva.com/pt_br/modelos/" target="_blank">Canva</a></span></div></div><div class="row" style="justify-content: center"><div class="dragzone" style="width: 100%; max-width: 100%"><ul ui-sortable="sortableOptions" style="margin-top: -6px; width: 100%" ng-model="vm.imgsFlyers" class="products"><li ng-repeat="imgFlyer in vm.imgsFlyers" tooltip-placement="top" uib-tooltip="{{\'flyers.edit-image.tooltip\' | translate}}" class="product-card" style="width: 50%"><div class="ibox no-margins border-img-default" style="width: 100%" ng-class="{\'border-img-default\': (imgFlyer.isDefault)}" ng-click="vm.openInputImage($event, imgFlyer.id)"><div class="product-image" style="height: 185px; text-align: initial; position: relative; background-color: #f4f4f5"><div ng-click="$event.stopPropagation()"><span class="fa fa-star flyer-detail-button" ng-if="imgFlyer.isThumbnail" style="padding-top: 5px; padding-left: 5px; position: initial; position: absolute; z-index: 2; color: #fec105"></span><div ng-if="!imgFlyer.isDefault"><span class="fa fa-trash flyer-detail-button" style="padding-top: 5px; padding-right: 5px; position: relative; z-index: 2" ng-click="vm.removeImgFlyer(imgFlyer.id)"></span></div></div><img style="max-height: 100%; max-width: 100%; object-fit: contain; position: absolute" ng-style="{\'object-fit\' : imgFlyer.isDefault ? \'contain\' : \'contain\'}" id="picture{{imgFlyer.id}}" ng-src="{{imgFlyer.src}}"></div></div></li></ul></div></div><div class="row" style="justify-content: center"><div style="justify-content: center"><p data-translate="flyers.edit-image.dragImages">Click and drag to sort the photos</p></div></div><!-- Inputs hidden --> <input id="imgInput1" style="display: none" type="file" accept="image/x-png,image/gif,image/jpeg" onchange="angular.element(this).scope().SelectFile(event, \'1\')"> <input id="imgInput2" style="display: none" type="file" accept="image/x-png,image/gif,image/jpeg" onchange="angular.element(this).scope().SelectFile(event, \'2\')"> <input id="imgInput3" style="display: none" type="file" accept="image/x-png,image/gif,image/jpeg" onchange="angular.element(this).scope().SelectFile(event, \'3\')"> <input id="imgInput4" style="display: none" type="file" accept="image/x-png,image/gif,image/jpeg" onchange="angular.element(this).scope().SelectFile(event, \'4\')"></div></div><!-- Demo Video --><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.demo-video.title">Demo Video</h1><p data-translate="flyers.new.form.demo-video.subtitle"></p></div><div class="col-xs-3"><div class="checkbox pull-right"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableDemoVideo" ng-click="vm.changeDemoVideo()"> <span id="checkEnableTags" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.demo-video.enable"></span></label></div></div></div><div class="row" ng-show="vm.enableDemoVideo"><div class="col-xs-6"><label for="purchaseValue" class="required" data-translate="flyers.new.form.demo-video.title-input">Link to your product video directly from Youtube</label><input class="form-control" ng-model="vm.flyer.demoVideo" placeholder="{{\'flyers.new.form.demo-video.placeholder\' | translate }}"></div></div><!-- Product Price --><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-6"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.price-inventory.title">Tags</h1><p data-translate="flyers.new.form.price-inventory.subtitle"></p></div><div class="col-xs-6"><div class="checkbox pull-right"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.changeIndividualPrice()" ng-checked="!vm.enableIndiviualPrice"> <span id="checkEnableIndividualPrice" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.price-inventory.disable"></span></label></div><div class="checkbox pull-right" style="margin-top: 10px; margin-right: 15px"><label><input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.changeIndividualPrice()" ng-checked="vm.enableIndiviualPrice"> <span id="checkDisableIndividualPrice" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.price-inventory.enable"></span></label></div></div></div><div class="row" ng-if="vm.enableIndiviualPrice"><div class="col-xs-12 col-md-2"><label for="purchaseValue" class="required" data-translate="flyers.new.form.purchase-value">Value</label><div class="input-group"><span class="input-group-addon">{{vm.flyer.currencyInstance.prefix }}</span> <input id="purchaseValue" name="purchaseValue" ng-model="vm.flyer.purchaseValue" type="text" class="form-control" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price ng-change="vm.checkDiscountedValue()" price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true" required></div><div ng-show="vm.flyerForm.purchaseValue.$invalid && vm.flyerForm.purchaseValue.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.purchaseValue.$error.required" data-translate="entity.validation.required"></p></div></div><div class="col-xs-12 col-md-2"><label for="discountedValue" data-translate="flyers.new.form.discounted-value">Value</label><div class="input-group"><span class="input-group-addon">{{vm.flyer.currencyInstance.prefix }}</span> <input id="discountedValue" name="discountedValue" ng-model="vm.flyer.discountedValue" type="text" class="form-control" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price ng-change="vm.checkDiscountedValue()" price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true"></div><div ng-show="vm.flyerForm.discountedValue.$invalid && vm.flyerForm.discountedValue.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.discountedValue.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.discountedValue.$error.discountGreaterThanValue" data-translate="entity.validation.discountGreatThanValue"></p></div></div><div class="col-xs-12 col-md-2"><label for="inventory" data-translate="flyers.new.form.inventory"></label><input id="inventory" name="inventory" class="form-control" type="number" min="0" ng-model="vm.flyer.inventory" placeholder="\u221E"><div ng-show="vm.flyerForm.inventory.$invalid && vm.flyerForm.inventory.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.inventory.$error.min" data-translate="entity.validation.min" translate-value-min="0"></p></div></div><div class="col-xs-12 col-md-2"><label for="ean" data-translate="flyers.new.form.ean">EAN</label><input id="ean" name="ean" ng-model="vm.flyer.ean" type="text" class="form-control" placeholder="Ex: 120921212"></div><div class="col-xs-12 col-md-4" ng-style="vm.flyer.discountedValue && {\'margin-top\': \'-10px\'}"><div class="col-xs-12" ng-if="vm.flyer.purchaseValue && vm.flyer.discountedValue"><h1 class="product-new-price no-margins pull-right" style="color: rgb(146, 146, 148)"><span data-fittext data-fittext-min="15" data-fittext-max="20" data-ng-bind="vm.flyer.currencyInstance.prefix"></span> <span class="coupon-desactived-decoration" data-fittext data-fittext-min="15" data-fittext-max="20" data-ng-bind="vm.formatMoney(vm.flyer.purchaseValue)"></span></h1></div><div class="col-xs-12" ng-if="vm.flyer.purchaseValue"><h1 id="newPrice" class="product-new-price no-margins pull-right"><span data-fittext data-fittext-min="30" data-fittext-max="40" data-ng-bind="vm.flyer.currencyInstance.prefix"></span> <span class="product-new-price-value" data-fittext data-fittext-min="40" data-fittext-max="40" ng-if="vm.flyer.discountedValue" data-ng-bind="vm.formatMoney(vm.flyer.discountedValue)"></span> <span class="product-new-price-value" data-fittext data-fittext-min="40" data-fittext-max="40" ng-if="!vm.flyer.discountedValue" data-ng-bind="vm.formatMoney(vm.flyer.purchaseValue)"></span></h1></div><div class="col-xs-12" ng-if="vm.flyer.purchaseValue"><p style="text-align: end" data-translate="flyers.new.form.discount.description"></p></div></div></div><div class="row" ng-if="!vm.enableIndiviualPrice"><div class="col-xs-12"><span class="store-upload-button pointer" ng-click="vm.addVariation()"><i style="margin-right: 5px" class="fa fa-plus" aria-hidden="true"></i> <span data-translate="flyers.new.form.price-inventory.add-variation"></span></span></div><div class="col-xs-12"><div class="tab-content" ng-if="vm.flyer.details.length > 0"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th class="col-xs-1"><label data-translate="flyers.new.form.Photograph"></label></th><th class="col-xs-1"><label>{{ vm.storeCategory == \'FASHION\' ? \'flyers.new.form.size.title\' : \'flyers.new.form.variation\' | translate }}</label></th><th class="col-xs-1"><label data-translate="flyers.new.form.inventory"></label></th><th class="col-xs-2"><label class="required" data-translate="flyers.new.form.purchase-value"></label></th><th class="col-xs-2"><label data-translate="flyers.new.form.discounted-value"></label></th><th class="col-xs-1"><span data-translate="flyers.new.form.quantity-by-person"></span></th><th class="col-xs-3"><label data-translate="flyers.new.form.ean"></label></th><th class="col-xs-1"></th></tr></thead><tbody><tr ng-repeat="variation in vm.flyer.details track by $index"><td style="vertical-align: middle"><div class="form-group no-margin" style="max-width: 43px; text-align: center" ng-class="{\'has-error\': (vm.flyerForm[\'varQuantityByPerson\' + $index].$invalid\n                                                     && vm.flyerForm[\'varQuantityByPerson\' + $index].$touched)}"><img ng-if="variation.imgFlyerId != null" ng-src="{{ vm.imgsFlyers[vm.getIndexImageById(variation.imgFlyerId)].src }}" alt="testimg" style="max-height: 43px; max-width: 43px" ng-click="vm.flyersSelectImageDetailModal(variation, $index)"> <img ng-if="variation.imgFlyerId == null" ng-src="{{ vm.srcImgDetailDefault }}" alt="testimg" style="max-height: 43px; max-width: 43px; border-width: 1px !important;" class="ibox no-margins border-img-default" ng-click="vm.flyersSelectImageDetailModal(variation, $index)"></div></td><td style="vertical-align: middle"><div class="form-group no-margin" ng-class="{\'has-error\': ((vm.flyerForm[\'varSize\' + $index].$invalid\n                                                     && vm.flyerForm[\'varSize\' + $index].$touched) || vm.onChangeSize(variation, $index))}"><input name="varSize{{$index}}" class="form-control" ng-change="vm.onChangeSize(variation, $index)" type="text" ng-model="variation.size" placeholder="" required></div></td><td style="vertical-align: middle"><div class="form-group no-margin" ng-class="{\'has-error\': (vm.flyerForm[\'varInventory\' + $index].$invalid\n                                                     && vm.flyerForm[\'varInventory\' + $index].$touched)}"><input name="varInventory{{$index}}" class="form-control" type="number" min="0" ng-model="variation.inventory" placeholder="\u221E"></div></td><td style="vertical-align: middle"><div class="form-group no-margin" ng-class="{\'has-error\': (vm.flyerForm[\'varPurchaseValue\' + $index].$invalid\n                                                     && vm.flyerForm[\'varPurchaseValue\' + $index].$touched)}"><div class="input-group"><span class="input-group-addon">{{vm.flyer.currencyInstance.prefix }}</span> <input name="varPurchaseValue{{$index}}" ng-model="variation.purchaseValue" type="text" class="form-control" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true" required></div></div></td><td style="vertical-align: middle"><div class="form-group no-margin" ng-class="{\'has-error\': (vm.flyerForm[\'varDiscountedValue\' + $index].$invalid\n                                                     && vm.flyerForm[\'varDiscountedValue\' + $index].$touched)}"><div class="input-group"><span class="input-group-addon">{{vm.flyer.currencyInstance.prefix }}</span> <input name="varDiscountedValue{{$index}}" ng-model="variation.discountedValue" type="text" class="form-control" price placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true"></div></div></td><td style="vertical-align: middle"><div class="form-group no-margin" ng-class="{\'has-error\': (vm.flyerForm[\'varQuantityByPerson\' + $index].$invalid\n                                                     && vm.flyerForm[\'varQuantityByPerson\' + $index].$touched)}"><input name="varQuantityByPerson{{$index}}" class="form-control" type="number" min="1" ng-model="variation.quantityByPerson" placeholder="\u221E"></div></td><td style="vertical-align: middle"><div class="form-group no-margin" ng-class="{\'has-error\': (vm.onChangeEan(variation, $index))}"><input id="ean" name="ean" ng-change="vm.onChangeEan(variation, $index)" ng-model="variation.ean" type="text" class="form-control" placeholder="Ex: 120921212"></div></td><td class="text-center" style="vertical-align: middle"><i class="fa fa-trash pointer" ng-click="vm.removeVariation($index)" style="font-size: 22px; margin-top: 4px"></i></td></tr></tbody></table></div></div></div></div><!-- flyers measuares --><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.measures.title">Measures</h1><p data-translate="flyers.new.form.measures.subtitle"></p></div><div class="col-xs-3"><div class="checkbox pull-right"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableMeasure" ng-click="vm.changeMeasure()"> <span id="checkEnableTags" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.measures.enable-measure"></span></label></div></div></div><div class="row" ng-if="vm.enableMeasure"><div class="col-xs-12 nopadding"><div class="tab-content" ng-if="vm.flyer.details.length > 0 || vm.flyer.measureList.length"><div class="table-responsive col-xs-10" style="width: auto; max-width: 86%"><table class="table table-striped table-hover" style="table-layout: auto; display: table-cell"><thead><tr><th ng-if="!vm.enableIndiviualPrice" class="col-xs-1"><label data-translate="flyers.new.form.measures.variations"></label></th><th ng-repeat="measure in vm.measureList track by $index"><div class="form-group no-margin col-xs-12"><div class="col-xs-12 nopadding"><div class="input-group"><div ng-class="{\'has-error\': (vm.flyerForm[\'varMeasureName\' + $index].$invalid && vm.flyerForm[\'varMeasureName\' + $index].$touched)}"><input name="varMeasureName{{$index}}" required ng-model="measure.name" type="text" class="form-control" placeholder="{{\'flyers.new.form.measures.height\' | translate}}"></div><span class="input-group-addon" style="border: 0px"><i class="fa fa-trash pointer" style="font-size: 22px; margin-top: 0px" ng-disabled="vm.measureList.length == 1" ng-click="vm.removeMeasure($index)" ng-style="vm.measureList.length == 1 && {\'color\': \'#676a6c\', \'cursor\': \'not-allowed\'}"></i></span></div><div ng-show="vm.flyerForm[\'varMeasureName\' + $index].$invalid && vm.flyerForm[\'varMeasureName\' + $index].$touched" ng-class="{\'has-error\': (vm.flyerForm[\'varMeasureName\' + $index].$invalid && vm.flyerForm[\'varMeasureName\' + $index].$touched)}"><p class="help-block form-invalid-field" ng-show="vm.flyerForm[\'varMeasureName\' + $index].$error.required" data-translate="entity.validation.required"></p></div></div></div></th></tr></thead><tbody><tr ng-if="vm.flyer.details.length" ng-repeat="variation in vm.flyer.details track by $index"><td><label style="font-size: 16px; margin-top: 6px">{{variation.size}}</label></td><td ng-repeat="measure in variation.measureList track by $index"><div class="form-group no-margin col-xs-12"><div class="input-group"><input name="varMeasureValue{{$index}}" ng-model="measure.value" min="1" type="text" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'varMeasureValue\' + $index].$invalid && vm.flyerForm[\'varMeasureValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'varMeasureValue\' + $index].$error.min" data-translate="entity.validation.min" translate-value-min="0"></p><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'varMeasureValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div></td></tr><tr ng-if="!vm.flyer.details.length"><td ng-repeat="measure in vm.flyer.measureList track by $index"><div class="form-group no-margin col-xs-12"><div class="input-group"><input name="varMeasureValue{{$index}}" ng-model="measure.value" min="1" type="text" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'varMeasureValue\' + $index].$invalid && vm.flyerForm[\'varMeasureValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'varMeasureValue\' + $index].$error.min" data-translate="entity.validation.min" translate-value-min="0"></p><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'varMeasureValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div></td></tr></tbody></table></div><div class="col-xs-2" style="width: 13%; padding-top: 12px" uib-tooltip="{{vm.measureList.length == 5 ? \'N\xE3o \xE9 poss\xEDvel adicionar mais de 5 medidas\' : \'\'}}" style="padding-top: 13px; padding-left: 0px"><button ng-disabled="vm.measureList.length > 4" class="store-upload-button pointer" ng-click="vm.addMeasures()" style="background-color: white; border: none" ng-style="vm.measureList.length == 5 && {\'color\': \'#676a6c\', \'cursor\': \'not-allowed\'}"><i style="margin-right: 5px" class="fa fa-plus" aria-hidden="true"></i> <span data-translate="flyers.new.form.measures.add-measures"></span></button></div></div></div></div><!-- flyers dimensions --><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.weight-dimensions.title">Dimensions</h1><p data-translate="flyers.new.form.weight-dimensions.subtitle"></p><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.flyer.hasLimitedShipping" ng-click="vm.changeDimension()"> <span id="checkhasLimitedShipping" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.has-limited-shipping"></span></label></div></div><div class="col-xs-3"><div class="checkbox pull-right"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableDimension" ng-click="vm.changeDimension()"> <span id="checkEnableTags" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.tags.dimension"></span></label></div></div></div><div class="row" ng-if="vm.enableIndiviualPrice && vm.enableDimension"><div class="col-xs-12 col-md-2"><label for="weight" data-translate="flyers.new.form.weight-dimensions.weight">Value</label><div class="input-group"><input id="weightValue" name="weightValue{{$index}}" ng-model="vm.flyer.dimension.weight" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">kg</span></div><div ng-show="vm.flyerForm[\'weightValue\' + $index].$invalid && vm.flyerForm[\'weightValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'weightValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div><div class="col-xs-12 col-md-2"><label for="height" data-translate="flyers.new.form.weight-dimensions.height">Value</label><div class="input-group"><input id="heightValue" name="heightValue{{$index}}" ng-model="vm.flyer.dimension.height" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'heightValue\' + $index].$invalid && vm.flyerForm[\'heightValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'heightValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div><div class="col-xs-12 col-md-2"><label for="width" data-translate="flyers.new.form.weight-dimensions.width">Value</label><div class="input-group"><input id="widthValue" name="widthValue{{$index}}" ng-model="vm.flyer.dimension.width" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'widthValue\' + $index].$invalid && vm.flyerForm[\'widthValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'widthValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div><div class="col-xs-12 col-md-2"><label for="length" data-translate="flyers.new.form.weight-dimensions.length">Value</label><div class="input-group"><input id="lengthValue" name="lengthValue{{$index}}" ng-model="vm.flyer.dimension.length" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'lengthValue\' + $index].$invalid && vm.flyerForm[\'lengthValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'lengthValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div><div class="col-xs-12 col-md-2"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/icon-send.png" style="max-width: 180px; margin-top: -70px"></div></div><div class="row" ng-if="!vm.enableIndiviualPrice && vm.enableDimension"><div class="col-xs-8"><div class="tab-content" ng-if="vm.flyer.details.length > 0"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th class="col-xs-1"><label data-translate="flyers.new.form.variation"></label></th><th class="col-xs-1"><label for="weight" data-translate="flyers.new.form.weight-dimensions.weight">Value</label></th><th class="col-xs-1"><label for="height" data-translate="flyers.new.form.weight-dimensions.height">Value</label></th><th class="col-xs-1"><label for="width" data-translate="flyers.new.form.weight-dimensions.width">Value</label></th><th class="col-xs-1"><label for="length" data-translate="flyers.new.form.weight-dimensions.length">Value</label></th></tr></thead><tbody><tr ng-repeat="variation in vm.flyer.details track by $index"><td><label style="font-size: 16px; margin-top: 6px">{{variation.size}}</label></td><td><div class="form-group no-margin"><div class="input-group"><input name="weightValue{{$index}}" ng-model="variation.dimension.weight" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">kg</span></div><div ng-show="vm.flyerForm[\'weightValue\' + $index].$invalid && vm.flyerForm[\'weightValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'weightValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div></td><td><div class="form-group no-margin"><div class="input-group"><input name="heightValue{{$index}}" ng-model="variation.dimension.height" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'heightValue\' + $index].$invalid && vm.flyerForm[\'heightValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'heightValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div></td><td><div class="form-group no-margin"><div class="input-group"><input name="widthValue{{$index}}" ng-model="variation.dimension.width" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'widthValue\' + $index].$invalid && vm.flyerForm[\'widthValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'widthValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div></td><td><div class="form-group no-margin"><div class="input-group"><input name="lengthValue{{$index}}" ng-model="variation.dimension.length" min="0" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">cm</span></div><div ng-show="vm.flyerForm[\'lengthValue\' + $index].$invalid && vm.flyerForm[\'lengthValue\' + $index].$touched"><p class="help-block form-invalid-field" style="font-weight: bold; font-size: 12px" ng-show="vm.flyerForm[\'lengthValue\' + $index].$error.required" data-translate="entity.validation.required"></p><p></p></div></div></td></tr></tbody></table></div></div></div><div class="col-xs-4" ng-show="vm.flyer.details.length > 0"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/icon-send.png" style="max-width: 200px"></div></div><!-- Tag --><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.tags.title">Tags</h1><p data-translate="flyers.new.form.tags.subtitle"></p></div><div class="col-xs-3"><div class="checkbox pull-right"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableTags" ng-click="vm.changeTags()"> <span id="checkEnableTags" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.tags.enable"></span></label></div></div></div><div class="row" ng-show="vm.enableTags"><div class="col-xs-12"><tags-input replace-spaces-with-dashes="false" ng-model="vm.flyer.tags" placeholder="{{\'flyers.new.form.tags.placeholder\' | translate }}"></div></div><!-- Schedules --><div class="hr-line-dashed"></div><div class="row"><div class="col-xs-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.schedules.title"></h1><p data-translate="flyers.new.form.schedules.subtitle"></p></div><div class="col-xs-3"><div class="checkbox pull-right"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableSchedules" ng-click="vm.changeSchedules()"> <span id="checkEnableSchedules" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.schedules.enable"></span></label></div></div></div><div class="row" ng-if="vm.enableSchedules"><div class="col-xs-12 col-md-6"><div class="form-group"><label for="startDate" data-translate="flyers.new.form.startDate" class="required"></label><div class="input-group date" id="startDateTime"><input name="startDate" type="text" id="startDate" class="form-control inputDate" readonly="readonly" autocomplete="off" ng-model="vm.flyer.startDate" required> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><div class="help-block-div" ng-show="vm.flyerForm.startDate.$invalid && vm.flyerForm.startDate.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.startDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.startDate.$error.minDate" data-translate="flyers.new.error.startDateGreaterOrEqualNow"></p></div></div></div><div class="col-xs-12 col-md-6"><div class="form-group"><label for="expirationDate" data-translate="flyers.new.form.expirationDate"></label><div class="input-group date" id="expirationDateTime"><input id="expirationDate" class="form-control inputDate" readonly="readonly" name="expirationDate" ng-model="vm.flyer.expirationDate"> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div><div class="help-block-div" ng-show="vm.flyerForm.expirationDate.$invalid && vm.flyerForm.expirationDate.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.expirationDate.$error.required" data-translate="entity.validation.required"></p></div></div></div></div><!-- Batch Sale --><div class="hr-line-dashed" ng-if="vm.flyer.type === \'SALE\'"></div><div class="row" ng-if="vm.flyer.type === \'SALE\'"><div class="col-xs-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.batch-sale.title">Batch Sale</h1><p data-translate="flyers.new.form.batch-sale.subtitle"></p></div><div class="col-xs-3"><div class="checkbox pull-right"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableBatchSale" ng-click="vm.changeBatchSale()"> <span id="checkBatchSale" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.batch-sale.enable"></span></label></div></div></div><div class="row" ng-if="vm.enableBatchSale && vm.flyer.type === \'SALE\'"><div class="col-xs-12 col-md-6"><div class="form-group"><label for="bulkQuantity" class="required" data-translate="flyers.new.form.batch-sale.quantity"></label><input id="bulkQuantity" name="bulkQuantity" class="form-control" type="number" min="1" required ng-model="vm.flyer.bulkQuantity" placeholder="1"><div ng-show="vm.flyerForm.bulkQuantity.$invalid && vm.flyerForm.bulkQuantity.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.bulkQuantity.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.bulkQuantity.$error.min" data-translate="entity.validation.min" translate-value-min="0"></p></div></div></div><div class="col-xs-12 col-md-6"><div class="form-group"><label for="bulkDiscount" class="required" data-translate="flyers.new.form.batch-sale.discount"></label><div class="input-group"><span class="input-group-addon">%</span> <input id="bulkDiscount" name="discountBulkPercentage" class="form-control" type="number" required ng-model="vm.flyer.discountBulkPercentage" min="0.1" max="99.9" placeholder="5"></div><div ng-show="vm.flyerForm.discountBulkPercentage.$invalid && vm.flyerForm.discountBulkPercentage.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.discountBulkPercentage.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.discountBulkPercentage.$error.max" data-translate="entity.validation.max" translate-value-max="99.9"></p><p class="help-block form-invalid-field" ng-show="vm.flyerForm.discountBulkPercentage.$error.min" data-translate="entity.validation.min" translate-value-min="0"></p></div></div></div></div><!-- Rules for Use --><div class="hr-line-dashed" ng-if="vm.flyer.type === \'COUPON\'"></div><div class="row" ng-if="vm.flyer.type === \'COUPON\'"><div class="col-xs-9"><h1 class="sc-default-title-store-font" data-translate="flyers.new.form.rules-for-use.title"></h1><p data-translate="flyers.new.form.rules-for-use.subtitle"></p></div><div class="col-xs-3"><div class="checkbox pull-right"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.enableRules" ng-click="vm.changeRulesForUse()"> <span id="checkBoxRules" class="checkbox-material"><span class="check"></span></span> <span data-translate="flyers.new.form.rules-for-use.enable"></span></label></div></div></div><div class="row" ng-if="vm.enableRules && vm.flyer.type === \'COUPON\'"><div class="col-xs-12"><textarea id="rules" name="rulesForUse" class="form-control" ng-model="vm.flyer.rulesForUse" style="resize: none" rows="3" placeholder="" required>\n                        </textarea><div class="help-block-div m-t-xs" ng-show="vm.flyerForm.rulesForUse.$invalid && vm.flyerForm.rulesForUse.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerForm.rulesForUse.$error.required" data-translate="entity.validation.required"></p></div></div></div></form><div class="row m-t-md"><div class="col-xs-12"><button id="btnCreateFlyer" ladda="vm.isSaving" class="btn btn-primary btn-large pull-right" ng-click="vm.uploadImage()" data-style="slide-left"><span data-translate="global.form.save"></span> <span class="fa fa-sign-in m-l-xs" style="font-size: 1.3em" aria-hidden="true"></span></button></div></div></div></div></div>');
$templateCache.put('app/admin/hub-management/flyers/flyers-marker.tpl.html','<div class="sales-point" ng-controller="StoreMarkerController as vm" style="width: 300px; overflow-y: hidden !important"><div class="container-fluid" style="overflow: hidden !important"><div class="row"><div class="col-xs-12"><h1 class="sales-point-page-title" style="padding-left: 16px">Store point information</h1><hr style="margin-top: -5px !important; margin-bottom: 4px !important"></div></div><div class="row"><div class="col-xs-5" align="right"><span class="fa icon-ksc-salesponitss fa-3x" style="font-size: 5em; vertical-align: middle"></span></div><div class="col-xs-7"><p class="sales-point-name" style="font-size: 2vh; margin: 0; padding: 0">{{parameter.pointlocation.name}}</p><p ng-show="parameter.pointlocation.address || parameter.pointlocation.number" style="font-size: 1.5vh; margin: 0; padding: 0">{{parameter.pointlocation.address}},{{parameter.pointlocation.number}}</p><p ng-show="parameter.pointlocation.city || parameter.pointlocation.state" style="font-size: 1.5vh; margin: 0; padding: 0">{{parameter.pointlocation.city}}/{{parameter.pointlocation.state}}</p><p style="font-size: 1.5vh; margin: 0; padding: 0">{{parameter.pointlocation.contactPhone}}</p></div></div></div></div>');
$templateCache.put('app/admin/hub-management/flyers/flyers-new.html','<div class="wrapper wrapper-content animated fadeIn"><div class="row"><div class="col-xs-12"><div class="tabs-container"><jhi-alert-error></jhi-alert-error><uib-tabset active="vm.actualTab"><uib-tab index="0" heading="{{ \'flyers.new.tab.first.name\' | translate}}"><div class="panel-body"><div class="row"><div class="col-md-6"><h1 class="sc-default-title-store-font" data-translate="flyers.new.tab.first.header">Flyer Informations</h1><p data-translate="flyers.new.tab.first.firstInfo">Lorem ipsum dolor ipsum dolor ipsum dolor ipsum dolor ipsum dolor</p><p data-translate="flyers.new.tab.first.secondInfo">Lorem ipsum dolor</p></div></div><div class="row"><div class="col-xs-6"><form name="vm.flyerFirstForm"><div class="row flyer-form-row"><div class="form-group"><div class="col-xs-12 col-md-8 store-input-nopadding"><label class="required" for="name" data-translate="flyers.new.form.name">Name</label><input id="name" name="name" ng-model="vm.flyer.name" type="text" class="form-control" ng-maxlength="150" ng-minlength="4" required ng-blur="focus=false"><div ng-show="vm.flyerFirstForm.name.$invalid && vm.flyerFirstForm.name.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 25 characters.</p><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 25 characters.</p></div></div><div class="col-xs-12 col-md-4 store-input-nopadding"><label for="productReference" data-translate="flyers.new.form.productReference">Product Reference</label><input id="productReference" name="productReference" ng-model="vm.flyer.productReference" type="text" class="form-control"></div></div></div><div class="row flyer-form-row"><div class="form-group"><div class="col-xs-12 col-md-6 store-input-nopadding"><label for="category" class="required" data-translate="flyers.new.form.category">Category</label><select id="category" name="category" type="text" class="form-control" ng-model="vm.flyer.categoryKey" ng-change="vm.onChangeCategory()" required><option ng-repeat="category in vm.categories" value="{{category.key}}">{{category.title}}</option></select><div ng-show="vm.flyerFirstForm.category.$invalid && vm.flyerFirstForm.category.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.category.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-xs-12 store-input-nopadding" ng-class="vm.fullCategory.ownerKey === \'FASHION\' ? \'col-md-3\' : \'col-md-6\'" ng-show="vm.fullCategory.ownerKey === \'FASHION\'" style="padding-right: 10px"><label for="gender" class="required" data-translate="flyers.new.form.gender.title">Gender</label><select id="gender" name="gender" type="text" class="form-control" ng-model="vm.flyer.gender" ng-required="vm.fullCategory.ownerKey === \'FASHION\'"><option value="1" data-translate="flyers.new.form.gender.male">Male</option><option value="2" data-translate="flyers.new.form.gender.female">Female</option><option value="3" data-translate="flyers.new.form.gender.both">Both</option></select><div ng-show="vm.flyerFirstForm.gender.$invalid && vm.flyerFirstForm.gender.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-xs-12 store-input-nopadding" ng-class="vm.fullCategory.ownerKey === \'FASHION\' ? \'col-md-3\' : \'col-md-6\'"><label for="type" class="required" data-translate="flyers.new.form.type">Type</label><select id="type" name="type" type="text" class="form-control" ng-model="vm.flyer.type" ng-change="vm.typeChanged()" required><option value="COUPON" data-translate="flyers.new.form.userInteract.types.coupon">Coupon</option><option value="SALE" data-translate="flyers.new.form.userInteract.types.sale">Sale</option></select><div ng-show="vm.flyerFirstForm.type.$invalid && vm.flyerFirstForm.type.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row flyer-form-row"><div class="form-group"><div class="col-xs-12 col-md-3 store-input-nopadding" ng-show="vm.brands.length !== 0"><label for="brand" class="required" data-translate="flyers.new.form.brand">Brand</label><select id="brand" name="brand" type="text" class="form-control" ng-model="vm.flyer.brand" ng-required="vm.brands.length !== 0 && vm.fullCategory.ownerKey === \'FASHION\'"><option ng-repeat="brand in vm.brands" value="{{brand.name}}">{{brand.name}}</option></select><div ng-show="vm.flyerFirstForm.brand.$invalid && vm.flyerFirstForm.brand.$touched"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.brand.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-xs-12 store-input-nopadding" style="padding-right: 10px" ng-class="vm.brands.length !== 0 ? \'col-md-3\' : \'col-md-6\'"><label for="color" data-translate="flyers.new.form.color">Color</label><select id="color" name="color" type="text" class="form-control" ng-model="vm.flyer.color"><option ng-repeat="color in vm.colors" value="{{color}}">{{color}}</option></select></div><div class="col-xs-12 store-input-nopadding" style="padding-right: 10px" ng-class="vm.brands.length !== 0 ? \'col-md-3\' : \'col-md-6\'"><label for="size">{{ vm.categoryKey == \'FASHION\' ? \'flyers.new.form.size.title\' : \'flyers.new.form.variation\' | translate }}</label><div class="dropdown"><button class="btn btn-select-size dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ng-click="vm.sizesTouched = true">{{\'flyers.new.form.size.label-select\' | translate}} <i class="fa fa-caret-down"></i></button><div class="dropdown-menu" aria-labelledby="dropdownMenuButton" ng-click="$event.stopPropagation()" style="max-height: 25vh; overflow: auto"><div class="checkbox dropdown-item" style="margin-top: 10px" ng-repeat="size in vm.sizes"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfSizeSelected(size)" ng-click="vm.updateSizeOrRemove(size)" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{size}}</label></div></div></div></div><div class="col-xs-12 store-input-nopadding col-md-3"><label for="size" data-translate="flyers.new.form.configurations.title">Configura\xE7\xF5es</label><div class="dropdown"><button class="btn btn-select-size dropdown-toggle" type="button" id="dropdownMenuButtonOpt" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ng-click="vm.sizesTouched = true">{{\'flyers.new.form.configurations.label-select\' | translate}} <i class="fa fa-caret-down"></i></button><div class="dropdown-menu" aria-labelledby="dropdownMenuButtonOpt" ng-click="$event.stopPropagation()" style="max-height: 25vh; overflow: auto"><div class="checkbox dropdown-item" style="margin-top: 10px; margin-bottom: 10px"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfLaunchSelected()" ng-click="vm.updateLaunchOrRemove()" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{\'flyers.new.form.configurations.launch\' | translate}}</label></div><div class="checkbox dropdown-item" style="margin-top: 10px; margin-bottom: 10px"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfBasicSelected()" ng-click="vm.updateBasicOrRemove()" checked="checked"> <span class="checkbox-material"><span class="check"></span> </span>{{\'flyers.new.form.configurations.basic\' | translate}}</label></div></div></div></div></div></div><div class="row flyer-form-row"><div class="form-group"><div class="col-md-6 store-input-nopadding"><label for="currency" class="required" data-translate="flyers.new.form.currency">Currency</label><select id="currency" name="currency" ng-disabled="vm.disabledCurrency" type="text" class="form-control" ng-model="vm.flyer.currencyInstance" ng-options="value as value.text for (key, value) in vm.currencyConfigurations" required></select><div ng-show="vm.flyerFirstForm.currency.$invalid && vm.firstFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.currency.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6 store-input-nopadding"><label for="value" data-translate="flyers.new.form.value" ng-class="{ \'required\' : ([\'RENT\', \'COUPON\', \'SALE\'].includes(vm.flyer.type) ) }">Value</label><div class="input-group"><span class="input-group-addon">{{vm.flyer.currencyInstance.prefix }}</span> <input id="value" name="value" ng-model="vm.flyer.purchaseValue" type="text" class="form-control" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true" ng-change="vm.checkDiscountType()" ng-required="(vm.flyer.discountValue || ([\'RENT\', \'COUPON\', \'SALE\'].includes(vm.flyer.type)))"></div><div ng-show="vm.flyerFirstForm.value.$invalid && vm.firstFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.value.$error.required && ([\'RENT\', \'COUPON\', \'SALE\'].includes(vm.flyer.type))" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row flyer-form-row"><div class="col-xs-12 col-md-6 store-input-nopadding"><label for="discountType" data-translate="flyers.new.form.discount.title">Discount Type</label><select id="discountType" name="discountType" type="text" class="form-control" ng-model="vm.flyer.discountType" ng-change="vm.checkDiscountType()"><option value="DISCOUNT_PERCENTAGE">{{\'flyers.new.form.discount.percent\' | translate}}</option><option value="DISCOUNT_FIXED">{{\'flyers.new.form.discount.price\' | translate}}</option></select><div ng-show="vm.flyerFirstForm.discountType.$invalid && vm.firstFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.discountType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-xs-12 col-md-6 store-input-nopadding"><label for="discountValue" data-translate="flyers.new.form.discount.value">Discount Value</label><div class="input-group" ng-if="vm.isToDisplayMe(\'DISCOUNT_FIXED\')"><span class="input-group-addon">{{ vm.flyer.currencyInstance.prefix }}</span> <input id="discountValuePrice" name="discountValue" class="form-control" type="text" ng-model="vm.flyer.discountValue" ng-change="vm.checkDiscountType()" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true"></div><div ng-show="vm.flyerFirstForm.discountValue.$invalid && vm.isToDisplayMe(\'DISCOUNT_FIXED\')"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.discountValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.discountValue.$error.discountGreaterThanValue" data-translate="entity.validation.discountGreatThanValue">The discount amount cannot be greater than the value of the flyer.</p><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.discountValue.$error.max" data-translate="entity.validation.max" translate-value-max="{{ vm.flyer.purchaseValue }}">MAX</p><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.discountValue.$error.min" data-translate="entity.validation.min" translate-value-min="{{ vm.flyer.purchaseValue }}">MIN</p></div><div class="input-group" ng-if="vm.isToDisplayMe(\'DISCOUNT_PERCENTAGE\')"><span class="input-group-addon">%</span> <input id="discountValuePercentage" ng-change="vm.checkDiscountType()" name="discountValuePercentage" class="form-control" type="number" ng-model="vm.flyer.discountPercentageValue" min="0.0" max="100.0" placeholder="0.00"></div><div ng-show="vm.flyerFirstForm.discountValuePercentage.$invalid && vm.isToDisplayMe(\'DISCOUNT_PERCENTAGE\')"><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.discountValuePercentage.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.discountValuePercentage.$error.discountGreaterThanValue" data-translate="entity.validation.discountGreatThanValue">The discount amount cannot be greater than the value of the flyer.</p><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.discountValuePercentage.$error.max" data-translate="entity.validation.max" translate-value-max="100.00">MAX</p><p class="help-block form-invalid-field" ng-show="vm.flyerFirstForm.discountValuePercentage.$error.min" data-translate="entity.validation.min" translate-value-min="0.00">MIN</p></div></div></div><div ng-if="vm.flyer.type === \'SALE\'" class="row" style="margin: 0 !important;     padding-top: 10px"><div class="form-group col-md-6 store-input-nopadding"><label for="bulkQuantity" data-translate="flyers.new.bulkPieces">Atacado minimo de pe\xE7as</label><input id="bulkQuantity" name="bulkQuantity" class="form-control" type="number" min="0" ng-model="vm.flyer.bulkQuantity" min="0" placeholder="0"></div><div class="form-group col-md-6 store-input-nopadding"><label for="bulkDiscount" data-translate="flyers.new.bulkDiscount">Atacado desconto</label><div class="input-group"><span class="input-group-addon">%</span> <input id="bulkDiscount" name="bulkDiscount" class="form-control" type="number" ng-model="vm.flyer.discountBulkPercentage" min="0.0" max="100.0" placeholder="0.00"></div><div><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.bulkDiscount.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.bulkDiscount.$error.discountGreaterThanValue" data-translate="entity.validation.discountGreatThanValue">The discount amount cannot be greater than the value of the flyer.</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.bulkDiscount.$error.max" data-translate="entity.validation.max" translate-value-max="100.00">MAX</p><p class="help-block form-invalid-field" ng-show="vm.flyerEditForm.bulkDiscount.$error.min" data-translate="entity.validation.min" translate-value-min="0.00">MIN</p></div></div></div><div class="row flyer-form-row"><div class="form-group"><div class="col-xs-12 col-md-12 store-input-nopadding no-padding-right"><label for="tag" data-translate="flyers.new.form.tags.title">Tags</label><div class="dropdown"><tags-input replace-spaces-with-dashes="false" placeholder="{{ \'flyers.new.form.tags.placeholder\' | translate }}" ng-model="vm.flyer.tags"></div></div></div></div><div class="row flyer-form-row"><div class="form-group"><label for="description" data-translate="flyers.new.form.description">Description</label><textarea id="description" name="description" class="form-control" ng-model="vm.flyer.description" style="resize: none" rows="3">\n                                                </textarea></div></div></form></div><div class="col-md-6 col-sm-6 store-input-nopadding"><input type="file" name="fileInput" id="fileInput" ng-model="vm.flyer.imageTest" accept="image/x-png,image/gif,image/jpeg" style="display: none" required><div ng-show="vm.flyerSecondForm.fileInput.$invalid && vm.secondFormSubmitted"><p class="help-block form-invalid-field" ng-show="vm.flyerSecondForm.fileInput.$error.required" data-translate="entity.validation.required">This field is required.</p></div><span class="store-upload-button" ng-click="vm.openInput($event)"><span data-translate="flyers.new.form.chooseimage">Choose Image</span> <i style="margin-left: 5px" class="fa fa-upload" aria-hidden="true"></i> </span><span class="store-upload-button pull-right"><span data-translate="flyers.edit-image.editImageAlternative">Crie o seu design com o </span><a href="https://www.canva.com/pt_br/modelos/" target="_blank">Canva</a></span><div class="cropAreaFlyer"><img-crop area-type="square" ng-if="vm.imageUpload" image="vm.imageUpload" result-image-size="vm.imageSize" on-load-begin="vm.imageChanged = true" result-image="vm.flyerImage" result-image-quality="1.0"></img-crop><p ng-if="!vm.imageUpload" id="noimg-icon" class="icon-ksc-storelogo"></p></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="hub-flyer-new-lib"><div class="col-xs-12" align="right" style="max-width: 400px" ng-if="vm.flyer.purchaseValue && (vm.flyer.discountPercentageValue || vm.flyer.discountValue)"><h1 class="product-new-price" style="color: rgb(146, 146, 148)"><span data-fittext data-fittext-min="10" data-fittext-max="30" data-ng-bind="vm.flyer.currencyInstance.prefix"></span> <span class="coupon-desactived-decoration" data-fittext-min="10" data-fittext-max="30" data-ng-bind="vm.formatMoney(vm.flyer.purchaseValue)"></span></h1></div><div class="col-xs-12" align="right" style="max-width: 400px" ng-if="vm.flyer.purchaseValue"><h1 id="newPrice" class="product-new-price" stye=""><span data-fittext data-fittext-min="50" data-fittext-max="70" data-ng-bind="vm.flyer.currencyInstance.prefix"></span> <span class="product-new-price-value" data-fittext data-fittext-min="30" data-fittext-max="100" data-ng-bind="vm.formatMoney(vm.getDiscountedValueByDiscountType(vm.flyer.purchaseValue, vm.flyer.discountType))"></span></h1><p ng-if="(vm.flyer.discountPercentageValue || vm.flyer.discountValue)" style="color: #676A6C">{{ vm.getHowMuchIsSaving() }}% <span data-translate="flyers.new.form.discount.info">save</span></p></div><div class="col-xs-12" align="center" ng-if="vm.flyer.purchaseValue"><p data-translate="flyers.new.form.discount.description"></p></div></div></div></div><div style="padding-top: 30px" class="row"><div class="col-xs-12" align="right"><button id="btnCreateFlyer" ladda="vm.isSaving" class="btn btn-primary btn-large" ng-disabled="(storeInfosForm.$invalid || vm.flyerFirstForm.$invalid || !vm.flyerImage)" ng-click="vm.saveFlyer()" data-style="slide-left"><span class="fa fa-tags" style="margin-left: 7px; font-size: 1.5em" aria-hidden="true"></span> <span data-translate="flyers.new.tab.third.button">Create Flyer</span></button></div></div></div></uib-tab><!-- <uib-tab index="1" heading="{{ \'flyers.new.tab.second.name\' | translate}}" disable="!vm.tabsState[1].active || vm.flyerFirstForm.$invalid" ng-click="vm.activeImageCrop()">\n                        <div class="panel-body" ng-init="vm.initSecondTab()">\n                            <div class="row">\n                                <div class="col-xs-12">\n                                    <h1 class="sc-default-title-store-font" data-translate="flyers.new.tab.second.header">Flyer Information</h1>\n                                    <p data-translate="flyers.new.tab.second.firstInfo">Lorem ipsum dolor ipsum dolor ipsum dolor ipsum dolor ipsum dolor</p>\n                                    <p data-translate="flyers.new.tab.second.secondInfo">Lorem ipsum dolor</p>\n                                </div>\n                                <div class="col-sm-6">\n                                    <form name="vm.flyerSecondForm">\n                                        <div class="row">\n                                            <div class="col-xs-12" style="margin-top: 10px;">\n                                                <p style="font-weight: bold;" data-translate="flyers.new.tab.second.validaty">Flyer Validaty</p>\n                                                <div class="col-xs-12 form-group" style="margin-top: 5px; margin-bottom: 5px;">\n                                                    <label for="startDate" ng-class="{\'required\': !vm.checks.immediateAvailability}" data-translate="flyers.new.form.startDate">Start Date</label>\n                                                    <div class=\'input-group date\' id=\'startDateTime\'>\n                                                        <input name="startDate" type=\'text\' id="startDate" class="form-control inputDate" readonly="readonly" ng-required="!vm.checks.immediateAvailability" autocomplete="off" ng-model="vm.flyer.startDate" ng-disabled="vm.checks.immediateAvailability"/>\n                                                        <span class="input-group-addon">\n                                                            <span class="glyphicon glyphicon-calendar"></span>\n                                                        </span>\n                                                    </div>\n                                                    <div class="help-block-div" ng-show="vm.flyerSecondForm.startDate.$invalid && vm.secondFormSubmitted">\n                                                        <p class="help-block form-invalid-field" ng-show="vm.flyerSecondForm.startDate.$error.required" data-translate="entity.validation.required">This field is required.</p>\n                                                        <p class="help-block form-invalid-field" ng-show="vm.flyerSecondForm.startDate.$error.minDate" data-translate="flyers.new.error.startDateGreaterOrEqualNow">Start date must be greater than or equal to current date.</p>\n                                                    </div>\n                                                </div>\n                                                <div class="col-xs-12" style="padding-top: 0 !important; padding-bottom: 0 !important; margin-top: 0 !important; margin-bottom: 0 !important;">\n                                                    <div class="checkbox" style="margin-top: 2px;">\n                                                        <label>\n                                                                <input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.checks.immediateAvailability" checked ng-change="vm.onImmediateAvailability()"/>\n                                                                <span class="checkbox-material">\n                                                                    <span class="check">\n                                                                    </span>\n                                                                </span>\n                                                                <span data-translate="flyers.new.form.immediate-availability">Active</span>\n                                                            </label>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class="row">\n                                            <div class="col-xs-12" style="margin-top: 10px;" ng-show="vm.flyer.type != \'RENT\'">\n                                                <div class="col-xs-12 form-group" style="margin-top: 5px; margin-bottom: 5px;">\n                                                    <label for="expirationDate" data-translate="flyers.new.form.expirationDate">Expiration Date</label>\n                                                    <div class="input-group date" id="expirationDateTime">\n                                                        <input id="expirationDate" class="form-control inputDate" readonly="readonly" ng-required="!vm.checks[\'validityTypeDate\']" name="expirationDate" ng-disabled="vm.checks[\'validityTypeDate\']" ng-model="vm.flyer.expirationDate" />\n                                                        <span class="input-group-addon">\n                                                            <span class="glyphicon glyphicon-calendar"></span>\n                                                        </span>\n                                                    </div>\n                                                    <div class="help-block-div" ng-show="vm.flyerSecondForm.expirationDate.$invalid && vm.secondFormSubmitted">\n                                                        <p class="help-block form-invalid-field" ng-show="vm.flyerSecondForm.expirationDate.$error.required" data-translate="entity.validation.required">This field is required.</p>\n                                                    </div>\n                                                </div>\n                                                <div class="col-xs-12" style="padding-top: 0 !important; padding-bottom: 0 !important; margin-top: 0 !important; margin-bottom: 0 !important;">\n                                                    <div class="checkbox" style="margin-top: 2px;">\n                                                        <label>\n                                                            <input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.checks[\'validityTypeDate\']" checked ng-change="vm.onValidityTypeDateChange(vm.checks[\'validityTypeDate\'])" />\n                                                            <span class="checkbox-material">\n                                                                <span class="check">\n                                                                </span>\n                                                            </span>\n                                                            <span data-translate="flyers.new.form.disabled">Active</span>\n                                                        </label>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class="row" ng-if="[\'COUPON\', \'SALE\'].includes(vm.flyer.type)">\n                                            <div class="col-xs-12" style="margin-top: 10px;">\n                                                <p style="font-weight: bold;" data-translate="flyers.new.tab.second.restrictions">Restrictions and limitation of use</p>\n                                                <div class="col-xs-6 form-group" style="margin-top: 5px;">\n                                                    <label for="maxUsage" data-translate="flyers.new.form.maxUsage">Max flyer usage</label>\n                                                    <input id="maxUsage" name="maxUsage" ng-model="vm.flyer.maxUsages" type="number" class="form-control" ng-disabled="vm.checks[\'validityTypeNumber\']" ng-required="!vm.checks[\'validityTypeNumber\']" ng-maxlength=25 min=0 oninput="validity.valid||(value=\'\');" />\n                                                    <div class="checkbox" style="margin-top: 2px;">\n                                                        <label>\n                                                            <input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.checks[\'validityTypeNumber\']" checked/>\n                                                            <span class="checkbox-material">\n                                                                <span class="check">\n                                                                </span>\n                                                            </span>\n                                                            <span data-translate="flyers.new.form.disabled">Active</span>\n                                                        </label>\n                                                    </div>\n                                                    <div ng-show="vm.flyerSecondForm.maxUsage.$invalid && vm.secondFormSubmitted">\n                                                        <p class="help-block form-invalid-field" ng-show="vm.flyerSecondForm.maxUsage.$error.required" data-translate="entity.validation.required">This field is required.</p>\n                                                        <p class="help-block form-invalid-field" ng-show="vm.flyerSecondForm.maxUsage.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="25">This field cannot be longer than 25 characters.</p>\n                                                    </div>\n                                                </div>\n                                                <div class="col-xs-6 form-group" style="margin-top: 5px;" ng-if="[\'COUPON\'].includes(vm.flyer.type)">\n                                                    <label for="maxUsageByUser" data-translate="flyers.new.form.maxUsageByUser">Max flyer usage by user</label>\n                                                    <input id="maxUsageByUser" name="maxUsageByUser" ng-model="vm.flyer.maxUsageByUser" type="number" class="form-control" ng-disabled="vm.checks[\'usageLimitByUser\']" ng-required="!vm.checks[\'usageLimitByUser\']" min=0 max="{{vm.flyer.maxUsages ? vm.flyer.maxUsages : Infinity}}" oninput="validity.valid||(value=\'\');" />\n                                                    <div class="checkbox" style="margin-top: 2px;">\n                                                        <label>\n                                                            <input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.checks[\'usageLimitByUser\']" ng-change="vm.changeStatusFilterToActive()" checked/>\n                                                            <span class="checkbox-material">\n                                                                <span class="check">\n                                                                </span>\n                                                            </span>\n                                                            <span data-translate="flyers.new.form.disabled">Active</span>\n                                                        </label>\n                                                    </div>\n                                                    <div ng-show="vm.flyerSecondForm.maxUsageByUser.$invalid && vm.secondFormSubmitted">\n                                                        <p class="help-block form-invalid-field" ng-show="vm.flyerSecondForm.maxUsageByUser.$error.required" data-translate="entity.validation.required">This field is required.</p>\n                                                        <p class="help-block form-invalid-field" ng-show="vm.flyerSecondForm.maxUsageByUser.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field is required.</p>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </form>\n                                </div>\n                                <div class="col-xs-12 col-sm-6 store-input-nopadding">\n                                    <input type="file" name="fileInput" id="fileInput" ng-model="vm.flyer.imageTest" accept="image/x-png,image/gif,image/jpeg" style="display: none;" required>\n                                    <div ng-show="vm.flyerSecondForm.fileInput.$invalid && vm.secondFormSubmitted">\n                                        <p class="help-block form-invalid-field" ng-show="vm.flyerSecondForm.fileInput.$error.required" data-translate="entity.validation.required">This field is required.</p>\n                                    </div>\n                                    <span class="store-upload-button" ng-click="vm.openInput($event)">\n                                        <span data-translate="flyers.new.form.chooseimage">Choose Image</span>\n                                        <i style="margin-left: 5px;" class="fa fa-upload" aria-hidden="true"></i>\n                                    </span>\n                                    <span class="store-upload-button pull-right">\n                                        <span data-translate="flyers.edit-image.editImageAlternative">Crie o seu design com o </span> <a href="https://www.canva.com/pt_br/modelos/" target="_blank">Canva</a>\n                                    </span>\n                                    <div class="cropAreaFlyer">\n                                        <img-crop area-type="square" ng-if="vm.imageUpload" image="vm.imageUpload" result-image-size="vm.imageSize" on-load-begin="vm.imageChanged = true"\n                                                    result-image="vm.flyerImage" result-image-quality="1.0">\n                                        </img-crop>\n                                        <p ng-if="!vm.imageUpload" id="noimg-icon" class="icon-ksc-storelogo"></p>\n                                    </div>\n                                </div>\n                                </form>\n                            </div>\n                            <div class="row">\n                                <div class="col-xs-12" align="right">\n                                    <button id="btnCreateFlyer" ladda="vm.isSaving" class="btn btn-primary btn-large" ng-disabled="storeInfosForm.$invalid" ng-click="vm.saveFlyer()" data-style="slide-left">\n                                        <span data-translate="flyers.new.tab.third.button">Create Flyer</span>\n                                        <span class="fa fa-sign-in" style="margin-left: 7px; font-size: 1.5em;" aria-hidden="true"></span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </uib-tab> --><!-- <uib-tab index="2" heading="{{ \'flyers.new.tab.third.header\' | translate}}" disable="!vm.tabsState[2].active || vm.flyerSecondForm.$invalid  || vm.flyerFirstForm.$invalid">\n                        <div class="panel-body">\n                            <div class="row">\n                                <div class="col-xs-12">\n                                    <h1 class="sc-default-title-store-font" data-translate="flyers.new.tab.third.header">Flyer Sales Point</h1>\n                                    <p data-translate="flyers.new.tab.third.info">Lorem ipsum dolor ipsum dolor ipsum dolor ipsum dolor ipsum dolor</p>\n                                </div>\n                                <div class="col-xs-12" align="right">\n                                    <div class="checkbox">\n                                        <label>\n                                            <input type="checkbox" class="dropdown-item-checkbox" ng-click="vm.checkAllMarkers()" ng-model="vm.allMarkersChecked" />\n                                            <span id="checkBoxSalesPoint" class="checkbox-material">\n                                                <span class="check">\n                                                </span>\n                                            </span>\n                                            <span data-translate="flyers.messages.global.checkAll">Marcar todos</span>\n                                        </label>\n                                    </div>\n                                </div>\n                                <div class="col-xs-12">\n                                    <ui-gmap-google-map ng-if="vm.showMap" center=\'vm.mainMap.center\' zoom=\'vm.mainMap.zoom\' control=\'vm.mainMap.controls\' options="vm.options" style="height: 400px;">\n                                        <ui-gmap-markers models="vm.mainMap.markers" coords="\'self\'" idkey="\'id\'" options="\'options\'" events="vm.mainMap.markerEvents" fit="\'true\'">\n                                        </ui-gmap-markers>\n                                        <ui-gmap-window show="vm.mainMap.window.show" coords="vm.mainMap.window.model" options="vm.mainMap.window.options" templateUrl="\'app/admin/flyers/flyers-marker.tpl.html\'" templateParameter="vm.mainMap.window.model" closeClick="vm.mainMap.window.closeClick()" x>\n                                        </ui-gmap-window>\n                                    </ui-gmap-google-map>\n                                </div>\n                            </div>\n                            <div class="row" style="margin-top: 10px;">\n                                <div class="col-xs-12" align="right">\n                                    <button id="btnCreateFlyer" ladda="vm.isSaving" class="btn btn-primary btn-large" ng-disabled="storeInfosForm.$invalid" ng-click="vm.saveFlyer()" data-style="slide-left">\n                                        <span data-translate="flyers.new.tab.third.button">Create Flyer</span>\n                                        <span class="fa fa-sign-in" style="margin-left: 7px; font-size: 1.5em;" aria-hidden="true"></span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </uib-tab> --></uib-tabset></div></div></div></div>');
$templateCache.put('app/admin/hub-management/flyers/flyers-view-structure.html','<style>.badge-details {\n        color: #5E5E5E;\n        font-family: \'Roboto\';\n        font-size: 11px;\n        font-weight: 600;\n        padding: 6px 7px;\n        text-shadow: none;\n        margin-right: 6px;\n        margin-bottom: 6px;\n        border-radius: 0px;\n        font-weight: normal;\n    }\n\n    .with-stock {\n        background-color: #eaeaea;\n    }\n\n    .out-of-stock {\n        background-color: rgb(249 203 203);\n    }\n\n    .tag-info {\n        font-size: 12px; font-weight: 500; word-wrap: break-word;\n    }</style><div class="ibox" ng-show="vm.flyersFiltered.length > 0"><div class="ibox-content" style="min-height: 600px" infinite-scroll="vm.loadFlyers(vm.page + 1)" infinite-scroll-disabled="!vm.hasNextPage || vm.busy" infinite-scroll-immediate-check="false" infinite-scroll-distance="1"><div class="row"><div class="ibox-content flyer-table-box" ng-if="vm.checkDisplayType(\'Table\')" ng-repeat="flyer in vm.flyersFiltered" ng-click="vm.flyerDetailPage(flyer.id)"><div class="table-responsive"><table class="table shoping-cart-table"><tbody><tr width="100%"><td width="10%"><div class="cart-product-imitation flyer-table-img" style="background-size: 100% 100%; padding-top: 50px !important" back-img="https://{{bucket}}.s3-sa-east-1.amazonaws.com/hub/{{vm.hubId}}/flyer/400x400/{{flyer.id}}.jpg{{vm.time_stamp_to_image}}"></div></td><td class="desc" width="60%"><h3 style="margin-top: -5px !important"><a class="text-navy"><small class="text-muted coupon-text-color product-category">{{flyer.categoryKey}}</small><p class="product-name" style="word-wrap: break-word">{{flyer.name}}</p></a></h3><div><span uib-tooltip="{{flyer.inventory == 0 ? \'Estoque esgotado\' : \'\'}}" ng-if="flyer.details.length == 0" class="badge badge-details with-stock" ng-class="{\'out-of-stock\': flyer.inventory == 0 }">Estoque: {{flyer.inventory != null ? flyer.inventory : \'Ilimitado\' }} </span><span uib-tooltip="{{item.inventory <= 0 && item.inventory != null ? \'Estoque esgotado\' : \'\'}}" ng-if="flyer.details.length > 0" ng-repeat="item in flyer.details" class="badge badge-details with-stock" ng-class="{\'out-of-stock\': item.inventory <= 0 && item.inventory != null }">{{ $localStorage.defaultStore.category == FASHION ? \'Tam\' : \'Var\'}} {{item.size}}: {{item.inventory != null ? item.inventory : \'Ilimitado\' }}</span></div><span ng-repeat="tag in flyer.tags" class="badge badge-secondary badge-tag-flyer">{{tag}}</span><div style="margin-top: 6px"><span class="tag-info" ng-if="flyer.productReference" style="color: #676a6c; font-size: 10px">{{\'Cod: \' + flyer.productReference }} </span><span ng-show="flyer.expirationDate" style="margin-left: 15px" tooltip-placement="bottom-left" uib-tooltip="{{\'flyers.new.form.expirationDate\' | translate}}"><span class="fa fa-clock-o product-date">{{flyer.expirationDate | date: "dd/MM/yyyy"}}</span></span></div></td><td width="30%" style="padding-top: 0px"><div style="margin-top: 10px !important" class="checkbox flyer-checkbox-remove-margin" ng-click="$event.stopPropagation()"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfFlyerSelected(flyer.id)" ng-click="vm.refreshSelectedFlyers(flyer)"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div><div class="col-xs-12" style="margin-top: 24px"><span class="product-info-price-normal" style="white-space: nowrap" ng-if="flyer.purchaseValue && flyer.discountedValue"><span class="flyer-prices-remove-margin">{{flyer.currencyInstance.prefix}} </span><span class="coupon-desactived-decoration" style="white-space: nowrap">{{flyer.purchaseValue | number : 2}}</span></span><br><span class="product-info-price flyer-table-price" ng-if="flyer.discountedValue"><span class="flyer-prices-remove-margin">{{flyer.currencyInstance.prefix}} </span>{{flyer.discountedValue | number : 2}} </span><span class="product-info-price flyer-table-price" ng-if="!flyer.discountedValue && flyer.purchaseValue"><span class="flyer-prices-remove-margin">{{flyer.currencyInstance.prefix}} </span>{{flyer.purchaseValue | number : 2}}</span></div></td></tr></tbody></table></div><hr class="flyer-table-line"></div><div ng-repeat="flyer in vm.flyersFiltered" ng-if="vm.listFlyers && vm.checkDisplayType(\'Cards\')" ng-class="{\'col-xs-12 col-sm-4 col-md-3\': vm.checkDisplayType(\'Cards\')}" ng-click="vm.flyerDetailPage(flyer.id)" style="padding-left: 9px; padding-right: 9px; margin-bottom: -8px"><div class="ibox"><div class="ibox-content product-box flyer-box"><div class="product-imitation flyer-card-background" ng-style="{\'background-image\': \'url(/flyer/api/{{flyer.id}}/hub-picture)\', \'padding-top\' : \'100% !important\'}"><div class="checkbox coupon-checkbox" ng-click="$event.stopPropagation()"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="flyer.isRemove" ng-click="vm.refreshSelectedFlyers(flyer)"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div></div><hr class="flyer-line" tooltip-placement="bottom-right" uib-tooltip="{{vm.getFlyerTooltip(flyer.status) | translate}}" ng-class="{\'flyer-line-activated-{{ flyer.type }}\': flyer.status == \'ACTIVATED\', \'flyer-line-deactivated-{{ flyer.type }}\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}"><div class="product-desc" style="padding: 17px !important"><small class="text-muted coupon-text-color product-category">{{flyer.category}}</small><div class="flyer-card-name"><p class="product-name" style="word-wrap: break-word">{{flyer.name}}</p></div><div class="row"><div class="col-xs-12 store-input-nopadding"><div class="col-xs-5" style="margin-top: 20px; height: 3vh" align="left"><span ng-show="flyer.expirationDate" tooltip-placement="bottom-left" uib-tooltip="{{\'flyers.new.form.expirationDate\' | translate}}" data-fittext data-fittext-min="1" data-fittext-max="15" style="white-space: nowrap"><i class="fa fa-clock-o product-date-icon"></i> <span class="product-date flyer-card-space" data-ng-bind="flyer.expirationDate | date: \'dd/MM/yyyy\'"></span></span></div><div class="col-xs-7 store-input-nopadding" align="right"><span class="product-info-price-normal flyer-prices-remove-margin" style="white-space: nowrap" ng-if="flyer.purchaseValue && flyer.discountValue"><span>{{flyer.currencyInstance.prefix}} </span><span class="coupon-desactived-decoration" style="white-space: nowrap" ng-if="flyer.purchaseValue && flyer.discountValue">{{flyer.purchaseValue | number : 2}}</span></span><br><span class="product-info-price flyer-prices-remove-margin" ng-if="flyer.discountValue"><span>{{flyer.currencyInstance.prefix}} </span>{{flyer.discountedValue | number : 2}} </span><span class="product-info-price flyer-prices-remove-margin" ng-if="!flyer.discountValue && flyer.purchaseValue"><span>{{flyer.currencyInstance.prefix}} </span>{{flyer.purchaseValue | number : 2}}</span></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/hub-management/flyers/flyers.html','<style>div.scrollmenu {\n        background-color: transparent;\n        overflow: auto;\n        white-space: nowrap;\n    }\n\n    div.scrollmenu a {\n        display: inline-block;\n        color: white;\n        text-align: center;\n        padding: 14px;\n        text-decoration: none;\n    }\n\n    div.scrollmenu a:hover {\n        background-color: #e6e6e6;\n        border-top-left-radius: 5px;\n        border-top-right-radius: 5px;\n    }\n\n    .brand-select {\n        background-color: white;\n        border: 1px solid #dad6d6;\n        border-bottom: 1px solid #fff;\n        border-top-left-radius: 3px;\n        border-top-right-radius: 3px;\n    }\n\n    md-switch .md-thumb {\n        background-color: darkgrey;\n    }\n\n    md-switch .md-bar {\n        background-color: lightgray;\n    }\n\n    md-switch:last-of-type {\n        margin: 0px;\n    }\n\n    md-checkbox[disabled].custom-check .md-icon {\n        border-color: #F3F3F4;\n        top: 2px;\n        left: 0px;\n        width: 16px;\n        height: 16px;\n        border-radius: 0px;\n\n    }\n\n    md-checkbox[disabled].md-checked.color.custom-check .md-icon {\n        background-color: var(--main-color) !important;\n        border-color: var(--main-color) !important;\n    }\n\n    md-checkbox[disabled].md-indeterminate.color.custom-check .md-icon {\n        background-color: var(--main-color) !important;\n        color: white !important;\n        border-color: var(--main-color) !important;\n    }\n\n    md-checkbox[disabled].md-checked.custom-check .md-icon:after {\n        width: 5px !important;\n        height: 9px !important;\n        left: 3.66667px !important;\n    }\n\n    md-checkbox[disabled].md-indeterminate.custom-check .md-icon:after {\n        width: 10px !important;\n        top: 54% !important;\n    }\n\n    md-checkbox[disabled].custom-check .md-icon:after {\n        border-color: white !important;\n    }\n\n    .checkbox .checkbox-material .custom-check.check.md-indeterminate {\n        border-color: var(--main-color) !important;\n    }\n\n    .checkbox .checkbox-material .custom-check.check.md-checked {\n        border-color: var(--main-color) !important;\n    }\n\n    .brand-select {\n        background-color: white;\n        border: 1px solid #dad6d6;\n        border-bottom: 1px solid #fff;\n        border-top-left-radius: 3px;\n        border-top-right-radius: 3px;\n    }</style><div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content" style="padding: 20px 25px 10px 25px"><div class="col-xs-12 col-md-7" style="padding-top: 7px; display: flex; justify-content: flex-start"><a ui-sref="hub-flyers.new" class="btn btn-primary btn-block" style="white-space: normal !important; max-width: 158px; margin-right: 10px"><span class="fa fa-tags" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span data-translate="flyers.home.buttons.new">Create flyer</span></a><div has-authority="STORE_CREATE_FLYER" style="margin-right: 10px"><a ui-sref="hub-flyers.import"><button id="btnImportlyer" class="btn btn-primary btn-block" style="white-space: normal !important; white-space: normal !important; padding-bottom: 6px; border: 1px solid rgb(180, 179, 179); background-color: white"><span class="fa fa-cloud-upload" style="font-size: 1.2em; color: rgb(179, 175, 175)" aria-hidden="true">&nbsp;</span> <span data-translate="flyers.import.subtitle" style="color: rgb(136, 136, 136, 1)">Import</span></button></a></div><div ng-if="false" has-authority="STORE_CREATE_FLYER"><a ng-click="vm.importFromVtex()"><button id="btnImportHub" class="btn btn-primary btn-block" style="white-space: normal !important; white-space: normal !important; padding-bottom: 6px; border: 1px solid rgb(180, 179, 179); background-color: white"><span class="fa fa-cloud-download" style="font-size: 1.2em; color: rgb(179, 175, 175)" aria-hidden="true">&nbsp;</span> <span data-translate="flyers.import.vtex" style="color: rgb(136, 136, 136, 1)">Import</span></button></a></div></div><div class="row" style="padding-top: 7px; display: flex; justify-content: flex-end"><div class="col-xs-12 col-md-2"><div class="dropdown dropdown-table btn-group" style="text-align: center; padding-left: 13px"><a style="color: #676a66" class="showcase-menu-button" ng-class="vm.hasStoreSelected() || vm.storesSelected.length > 0 ? \'flyer-label-color\' : \'\'" data-toggle="dropdown" aria-expanded="false" tooltip-placement="bottom-right" uib-tooltip="{{\'global.hub.store\' | translate}}"><i class="icon-ksc-store" style="font-size: 2.5em !important; background-color: white"></i> <span ng-if="vm.hasStoreSelected()" class="label flyer-label-color ng-binding ng-scope" style="position: absolute">{{vm.quantStoresSelected}}</span> <span ng-if="!vm.hasStoreSelected() && vm.storesSelected.length > 0" class="label flyer-label-color ng-binding ng-scope" style="position: absolute">{{vm.storesSelected.length}}</span><p style="margin-top: 2px;  margin-bottom: 0px">{{\'global.hub.store\' | translate}}</p></a><ul class="dropdown-menu pull-right" role="menu" style="min-width: 400px !important; padding-bottom: 0px"><div class="row" style="margin-top: 10px"><div class="col-md-7"><input id="search-hub-fler" ng-model="vm.storeName" ng-change="vm.onChangeStoreName()" ng-model-options="{ debounce: 500 }" placeholder="Pesquisar" type="text" class="form-control"></div><div class="col-md-5"><div class="form-group" ng-click="$event.stopPropagation();"><select name="status" id="status" class="form-control" ng-model="vm.storeTypeId" ng-change="vm.markAllStoreType()"><option value="" selected="selected">Nenhum(a)</option><option ng-repeat="type in vm.storeTypes" ng-value="type.id">{{type.name}}</option></select></div></div></div><hr class="flyer-table-line" style="padding-bottom: 10px"><div class="row"><div class="col-xs-12"><div class="showcase-flyer-table"><div class="table-responsive" style="overflow: hidden !important"><table class="table shoping-cart-table"><tbody><tr ng-if="!store.hubOwner" width="100%" ng-repeat="store in vm.stores track by $index"><td width="10%" style="padding: 0 !important"><div class="checkbox" ng-click="$event.stopPropagation()" style="padding: 0 !important"><label><input type="checkbox" ng-disabled="vm.hasStoreSelected()" class="dropdown-item-checkbox" ng-checked="vm.checkStoreIsSelected(store.storeId)" ng-click="vm.changeStoreSelected(store)"> <span class="checkbox-material"><span class="check showcase-flyer-table-checkbox"></span></span></label></div></td><td width="90%" style="text-align: left; padding-top: 13px"><label>{{store.storeName}}</label></td></tr></tbody></table><hr class="showcase-table-flyer-line"></div></div></div></div></ul></div></div><div class="col-xs-12 col-md-3" style="max-width: 188px; margin-right: 13px"><button id="btnDistributeFlyer" ladda="vm.isAvailable" ng-disabled="vm.isAvailable || !vm.existsSelectedItems()" class="btn btn-primary btn-block" style="white-space: normal !important; max-width: 158px" ng-click="vm.migrateFlyers()"><span class="icon-ksc-showcasepublished" style="font-size: 1.2em" aria-hidden="true">&nbsp;</span> <span>Distribuir</span></button></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="clients-list" style="margin-top: -10px"><div class="column"><div style="display: flex; justify-content: flex-end"><div class="dropdown dropdown-table btn-group" tooltip-placement="top-right" uib-tooltip="{{\'flyers.home.buttons.advancedFilter\' | translate}}" style="margin-top: 13px"><a class="coupon-menu-button" data-toggle="dropdown" aria-expanded="false" style="background: transparent"><span class="fa-2x glyphicon glyphicon-filter text-primary" style="font-size: 21px" ng-class="{\'coupon-text-color\': vm.listFilter.categoryKey || vm.listFilter.color}"></span></a><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)" style="width: 400px"><li><div class="form-group"><div class="inner-addon left-addon"><i class="glyphicon glyphicon-search"></i> <input type="text" name="inputSearch" class="form-control" ng-change="vm.onChangeFlyerName()" placeholder="{{\'flyers.home.search-hint\' | translate}}" ng-model="vm.listFilter.text" ng-model-options="{ debounce: 500 }"></div></div></li><li><div class="form-group"><span data-translate="flyers.home.categories">Categories</span><select class="form-control" ng-model="vm.listFilter.categoryKey" ng-change="vm.loadFlyers(null,true)"><option value="" selected="selected" data-translate="flyers.home.listAll">All</option><option ng-repeat="category in vm.categories" value="{{category.key}}">{{category.title}}</option></select></div></li><li><div class="form-group"><span>Cores</span><select id="color" name="color" type="text" class="form-control" ng-model="vm.listFilter.color" ng-change="vm.loadFlyers(null,true)"><option value="" selected="selected" data-translate="flyers.home.listAll">All</option><option ng-repeat="color in vm.colors" value="{{color}}">{{color}}</option></select></div></li><li><div class="form-group"><span data-translate="flyers.home.types">Types</span><select class="form-control" ng-model="vm.listFilter.type" ng-change="vm.loadFlyers(null,true)"><option value="" selected="selected" data-translate="flyers.home.listAll">All</option><option ng-repeat="type in vm.flyersTypes" value="{{type.code}}">{{( \'flyers.userInteract.types.\' + type.name )| translate}}</option></select></div></li></ul></div><a class="coupon-menu-button" ng-click="vm.removeFlyers()" aria-hidden="true" tooltip-placement="top-right" uib-tooltip="{{\'flyers.home.buttons.remove\' | translate}}" has-authority="STORE_DELETE_FLYER" style="margin-top: 10px"><div class="col-xs-12"><span class="icon-ksc-trash fa-2x" style="font-size: 23px" ng-class="{\'coupon-text-color\': vm.existsSelectedItems()}"></span> <span ng-if="vm.existsSelectedItems()" class="label flyer-label-color" style="line-height: 9px">{{vm.selectedFlyers.length}}</span></div></a><a class="coupon-menu-button" style="margin: 10px 8px; margin-right: 0px"><div class="checkbox no-margins" ng-click="$event.stopPropagation()"><label><span class="checkbox-material"><md-checkbox class="check coupon-checkbox custom-check color" aria-label="filter checkbox" ng-style="(vm.selectedAllHub || vm.brandGroups[vm.listFilter.brand].selectedAllPage === true ||\n                                    vm.brandGroups[vm.listFilter.brand].selectedAllBrand === true) && {\'background-color\': \'{{hubStyle.data.mainColor}}\' }" style="height: 20px; width: 20px; padding: 3px; margin-bottom: 0px !important;\n                                    margin-right: 10px !important" md-indeterminate="vm.brandGroups[vm.listFilter.brand].selectedAllPage === true ||\n                                    vm.brandGroups[vm.listFilter.brand].selectedAllBrand === true" ng-checked="vm.selectedAllHub" ng-disabled="true"></md-checkbox></span></label></div></a><div class="dropdown dropdown-table btn-group" style="margin-top: 14px"><a class="coupon-menu-button" data-toggle="dropdown" aria-expanded="false" style="background: transparent"><div class="col-xs-12" style="width:120%; margin-left: -14px"><span ng-if="(vm.selectedFlyers.length === 0 || (vm.selectedFlyers.length > 0 && !vm.selectedAllHub))\n                                && !vm.brandGroups[vm.listFilter.brand].selectedAllPage && !vm.brandGroups[vm.listFilter.brand].selectedAllBrand\n                                && !vm.selectedAllHub" style="font-weight: 400; margin: 0px; color: #676a6c">{{\'flyers.offerList.select\' | translate}} </span><span ng-if="vm.brandGroups[vm.listFilter.brand].selectedAllPage" style="font-weight: 400; margin: 0px; color: #676a6c">{{\'flyers.offerList.selectAllPage\' | translate}} </span><span ng-if=" vm.brandGroups[vm.listFilter.brand].selectedAllBrand" style="font-weight: 400; margin: 0px; color: #676a6c">{{\'flyers.offerList.selectAllTab\' | translate}} </span><span ng-if="vm.selectedAllHub" style="font-weight: 400; margin: 0px; color: #676a6c">{{\'flyers.offerList.selectAllHub\' | translate}} </span><span class="caret text-primary"></span></div></a><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)" style="padding: unset; min-width: 100%"><li ng-click="vm.selectAllPage()"><a data-translate="flyers.offerList.selectAllPage"></a></li><li ng-click="vm.selectAllItemsAllBrand()"><a data-translate="flyers.offerList.selectAllTab"></a></li><li ng-click="vm.selectAllItemsAllHub()"><a data-translate="flyers.offerList.selectAllHub"></a></li><li ng-click="vm.cleanSelection()"><a data-translate="flyers.offerList.selectNone"></a></li></ul></div></div><div class="scrollmenu"><a ng-click="vm.tabClick(brand)" ng-repeat="brand in vm.brands track by brand.id" ng-class="{\'brand-select\' : vm.listFilter.brand == brand.name}"><span style="color: #676a6c">{{brand.name}}</span> <span ng-if="vm.getCountSelectedByBrand(brand.name) > 0" class="label flyer-label-color">{{vm.getCountSelectedByBrand(brand.name)}}</span></a></div></div><div class="tab-content" style="background-color: white; min-height: 600px"><div ng-attr-id="{{\'tab-\' + brand.name}}" class="active" ng-if="vm.listFilter.brand == brand.name" ng-repeat="brand in vm.brands"><div ng-if="vm.loadingTab" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingTab" ng-include="\'app/admin/hub-management/flyers/flyers-view-structure.html\'" ng-if="vm.flyersFiltered.length > 0"></div><div ng-if="!vm.loadingTab" align="center" style="padding-bottom:  20px" ng-if="vm.flyersFiltered.length > 0"><uib-pagination ng-model="vm.currentPage" total-items="vm.totalFlyers" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistry}}\', of: \'{{vm.endRegistry}}\', total: \'{{vm.totalFlyers}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalFlyers }}</p></div></div><div class="wrapper wrapper-content container-fluid" ng-if="vm.zeroOffers"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/download-panfletos.png"><h1 data-translate="flyers.new.firstOffer">Create your first offer.</h1><p class="ksc-sub-title" data-translate="flyers.messages.global.noFlyers">The store don\'t have any flyers.</p><button id="btnCreateFirstFlyer" has-authority="STORE_CREATE_FLYER" class="btn btn-primary btn-large" ui-sref="hub-flyers.new"><span class="fa fa-tags"></span> <span data-translate="flyers.home.buttons.new">Create new offer</span></button></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/hub-management/showcases/hub-showcases-detail.html','<div class="wrapper wrapper-content" ng-init="vm.initShowcase()"><div class="row"><div class="col-xs-12"><div class="ibox float-e-margins"><div class="ibox-content" style="padding: 15px"><div class="row"><div class="col-lg-12" style="margin: 0 !important" class="showcase-align-center"><div class="col-xs-12 col-sm-12 col-md-4" style="margin: 0 !important; padding: 0 !important; display: flex; align-items: center"><div class="inner-addon left-addon"><input id="inputNameShowcase" type="text" class="form-control input-lg showcase-input-hidden-border showcase-input-fontsize showcase-input-placeholder" placeholder="Nome da sua vitrine" ng-model="vm.showcase.name"><div class="showcase-input-icon-box"><i class="glyphicon glyphicon-pencil showcase-input-icon"></i></div></div></div><div class="col-xs-12 col-sm-12 col-md-4" class="showcase-align-center"><div class="col-xs-4"><div class="dropdown btn-group" style="text-align: center"><a style="color: #676a66" class="showcase-menu-button" data-toggle="dropdown" aria-expanded="false" tooltip-placement="bottom-right" uib-tooltip="{{\'showcases.home.buttons.color\' | translate}}"><i class="icon-ksc-colorselection" style="font-size: 2.5em !important" ng-style="vm.showcase.backgroundColor && {\'color\': vm.showcase.backgroundColor}"></i><p style="margin-top: 2px; margin-bottom: 0px" data-translate="showcases.detail.userInteract.options.color">Color</p></a><ul class="dropdown-menu pull-right" role="menu" ng-click="vm.stopPropagation($event)" style="min-width: 190px !important"><h1 style="font-size: 23px !important" data-translate="showcases.detail.color">Choose a color</h1><div style="font-size: 0 !important; line-height: 0 !important"><li class="showcase-item-color" ng-repeat="item in vm.showcaseColors[0]" ng-click="vm.setBackgroundColor(item.color)" ng-style="{\'background-color\': item.color, \'border\': item.border}"></li></div><div style="margin-top: 5px"><li class="showcase-item-color" ng-repeat="item in vm.showcaseColors[1]" ng-click="vm.setBackgroundColor(item.color)" ng-style="{\'background-color\': item.color, \'border\': item.border}"></li></div></ul></div></div><div class="col-xs-4"><div class="dropdown dropdown-table btn-group" style="text-align: center"><a ng-click="vm.goToFlyerByShowcase()" style="color: #676a66" class="showcase-menu-button" data-toggle="dropdown" aria-expanded="false" tooltip-placement="bottom-right" uib-tooltip="{{\'showcases.home.buttons.flyers.flyers\' | translate}}"><i class="icon-ksc-addflyer" style="font-size: 2.5em !important"></i><p style="margin-top: 2px;  margin-bottom: 0px" data-translate="showcases.detail.userInteract.options.offer">Offser</p></a></div></div><div class="col-xs-4"><div class="btn-group" style="text-align: center"><a ng-click="vm.openShowcaseModalType()" style="color: #676a66"><i ng-class="{\'fa fa-comment\': vm.showcase.userInteract === \'CONTACT\',\n                                            \'icon-ksc-activecoupon\': vm.showcase.userInteract === \'COUPON\',\n                                            \'fa fa-calendar-check-o\': vm.showcase.userInteract === \'RENT\',\n                                            \'icon-ksc-admin-type-sale\': vm.showcase.userInteract === \'SALE\'}" style="font-size: 2.5em"></i><p ng-if="vm.showcase.userInteract === \'CONTACT\'" style="margin-top: 2px" data-translate="showcases.detail.userInteract.options.contact"></p><p ng-if="vm.showcase.userInteract === \'COUPON\'" style="margin-top: 2px" data-translate="showcases.detail.userInteract.options.coupon"></p><p ng-if="vm.showcase.userInteract === \'RENT\'" style="margin-top: 2px" data-translate="showcases.detail.userInteract.options.rent"></p><p ng-if="vm.showcase.userInteract === \'SALE\'" style="margin-top: 2px" data-translate="showcases.detail.userInteract.options.sale"></p></a></div></div></div><div class="col-xs-12 col-sm-12 col-md-4 showcase-align-center"><div class="btn-group pull-right" role="group" aria-label="..." style="display: flex; align-items: center; right: -7px; padding-top: 9px"><button id="btnSaveShowcase" ladda="vm.isSaving" class="btn btn-md btn-default" ng-click="vm.preSaveFlyer()" style="padding: 7px 20px 5px 20px"><span class="glyphicon glyphicon-floppy-disk pull-left showcase-home-button"></span> <span class="showcase-home-button-margin" data-translate="showcases.home.buttons.save">Save</span></button></div></div></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content showcase-box-content"><div class="row" style="margin-left: 0px !important; margin-right: 0px !important"><div class="col-xs-12 showcase-logo-box" style="margin: 0 !important; padding: 0 !important"><input type="file" id="fileInput" style="display: none" accept="image/x-png,image/gif,image/jpeg"><div class="showcase-logo-box-texts" ng-if="vm.coverEdit" style="height: 200px; margin-top: 60px"><h1 data-translate="showcases.detail.cover.title">Customize your cover</h1><p data-translate="showcases.detail.cover.info">Lorem ipsum Lorem ipsum Lorem ipsum Lorem Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum<br>Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum</p><button class="btn btn-primary btn-large" ng-click="vm.openInput($event)"><span class="glyphicon glyphicon-picture pull-left"></span> <span class="showcase-home-button-margin" data-translate="showcases.detail.cover.new">Add Cover</span></button><!-- <input type="file" onchange="angular.element(this).scope().handleFileSelect(event)"> --></div><div><img id="cover_image_id" ng-show="!vm.coverEdit"></div><div class="cover-buttons" align="center" ng-if="!vm.coverEdit" style="margin-bottom: 20px"><button class="btn btn-primary btn-large" ng-click="vm.openInput($event)"><span class="glyphicon glyphicon-refresh"></span> <span class="showcase-home-button-margin">Mudar Imagem</span></button></div></div></div><div class="row" style="margin-top: 20px"><div ng-if="!vm.showcase.flyers.length" class="text-center"><div class="text-center"><h2 data-translate="showcases.detail.select-title">Selecione um ou mais produtos</h2><span class="text-muted" data-translate="showcases.detail.select-desc">Clique nas op\xE7\xF5es abaixo para adicionar produtos e organizar a vitrine do seu jeito.</span></div><div class="m-t-lg" style="display: table; width: 100%; height: 100%"><div style="position: relative; display: table-cell; height: 100%; cursor: pointer" class="col-xs-12 col-sm-4" ng-repeat="item in [1, 2, 3]" ng-click="vm.goToFlyerByShowcase()"><div class="ibox post-block showcase-border-box"><div class="flyer-box"><div class="flyer-box-img"><img class="img-responsive" ng-src="https://showkase-prod.s3.sa-east-1.amazonaws.com/marketing-objects/default-flyer-image.png"></div></div></div></div></div></div><div class="dragzone"><ul ui-sortable ng-model="vm.showcase.flyers" class="products"><li ng-repeat="flyer in vm.showcase.flyers" tooltip-placement="top" uib-tooltip="{{\'showcases.detail.image-tooltip\' | translate}}" class="product-card"><div class="ibox no-margins"><div class="product-image"><img ng-src="{{flyer.imagePath}}"></div><hr class="flyer-line" tooltip-placement="bottom-right" uib-tooltip="{{(flyer.status == \'ACTIVATED\' ? \'flyers.offer.active\' : \'flyers.offer.disabled\') | translate}}" ng-class="{\'flyer-line-activated-{{ flyer.type }}\': flyer.status == \'ACTIVATED\', \'flyer-line-deactivated-{{ flyer.type }}\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}"><div class="product-info"><h5><a class="product-name">{{flyer.name}}</a></h5><div class="row"><div class="col-xs-12 store-input-nopadding" align="right"><span class="product-info-price-normal flyer-prices-remove-margin" style="white-space: nowrap" ng-if="flyer.purchaseValue && flyer.discountedValue"><span>{{vm.getFlyerCurrency(flyer.currency)}} </span><span class="coupon-desactived-decoration" style="white-space: nowrap">{{flyer.purchaseValue | number: 2}}</span></span><br><span class="product-info-price flyer-prices-remove-margin" ng-if="flyer.discountedValue"><span>{{vm.getFlyerCurrency(item.flyer.currency)}} </span>{{flyer.discountedValue | number: 2}} </span><span class="product-info-price flyer-prices-remove-margin" ng-if="!flyer.discountedValue && flyer.purchaseValue"><span>{{vm.getFlyerCurrency(flyer.currency)}} </span>{{flyer.purchaseValue | number: 2}}</span></div></div></div></div></li></ul></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/hub-management/showcases/hub-showcases-flyers-item.html','<style>.badge-details {\n        color: #5E5E5E;\n        font-family: \'Roboto\';\n        font-size: 11px;\n        font-weight: 600;\n        padding: 6px 7px;\n        text-shadow: none;\n        margin-right: 6px;\n        margin-bottom: 6px;\n        border-radius: 0px;\n        font-weight: normal;\n    }\n\n    .with-stock {\n        background-color: #eaeaea;\n    }\n\n    .out-of-stock {\n        background-color: rgb(249 203 203);\n    }\n\n    .tag-info {\n        font-size: 12px; font-weight: 500; word-wrap: break-word;\n    }</style><div class="ibox-content flyer-table-box" ng-repeat="flyer in vm.flyersFiltered"><div class="table-responsive"><table class="table shoping-cart-table"><tbody><tr width="100%"><td width="5%" style="display: table-cell; vertical-align: middle"><div class="checkbox flyer-checkbox-remove-margin" ng-click="$event.stopPropagation()"><label style="padding-left: 20px !important"><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkFlyerIsSelected(flyer)" ng-click="vm.changeFlyerSelected(flyer)"> <span class="checkbox-material"><span class="check coupon-checkbox"></span></span></label></div></td><td width="10%" align="center" style="vertical-align:inherit"><div class="cart-product-imitation flyer-table-img" style="background-size: 100% 100%; padding-top: 50px !important" ng-style="{\'background-image\': \'url(/flyer/api/{{flyer.id}}/hub-picture)\'}"></div></td><td class="desc" width="50%"><h3><a class="text-navy"><small class="text-muted coupon-text-color product-category">{{flyer.category}}</small><p class="product-name" style="word-wrap: break-word">{{flyer.name}}</p></a></h3><div><span uib-tooltip="{{flyer.inventory == 0 ? \'Estoque esgotado\' : \'\'}}" ng-if="flyer.details.length == 0" class="badge badge-details with-stock" ng-class="{\'out-of-stock\': flyer.inventory == 0 }">Estoque: {{flyer.inventory != null ? flyer.inventory : \'Ilimitado\' }} </span><span uib-tooltip="{{item.inventory <= 0 && item.inventory != null ? \'Estoque esgotado\' : \'\'}}" ng-if="flyer.details.length > 0" ng-repeat="item in flyer.details" class="badge badge-details with-stock" ng-class="{\'out-of-stock\': item.inventory <= 0 && item.inventory != null }">{{ vm.storeCategory == \'FASHION\' ? \'Tam\' : \'Var\'}} {{item.size}}: {{item.inventory != null ? item.inventory : \'Ilimitado\' }}</span></div><span ng-repeat="tag in flyer.tags" class="badge badge-secondary badge-tag-flyer">{{tag}}</span><div style="margin-top: 6px"><!-- <span class="fa fa-tag" ng-class="{\'ksc-tag-active\': flyer.status == \'ACTIVATED\', \'ksc-tag-inactive\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}"></span>\n                            <span class="flyer-table-info" ng-class="{\'flyer-active\': flyer.status == \'ACTIVATED\', \'flyer-disabled\': (flyer.status == \'DEACTIVATED\' || flyer.status == \'EXPIRED\')}">{{(flyer.status == \'ACTIVATED\' ? \'flyers.offer.active\' : \'flyers.offer.disabled\') | translate}}</span> --> <span class="tag-info" ng-if="flyer.productReference" style="color: #676a6c; font-size: 10px">{{\'Cod: \' + flyer.productReference }} </span><span ng-show="flyer.expirationDate" style="margin-left: 15px" tooltip-placement="bottom-left" uib-tooltip="{{\'flyers.new.form.expirationDate\' | translate}}"><span class="fa fa-clock-o product-date">{{flyer.expirationDate | date: "dd/MM/yyyy"}}</span> </span><span class="tag-info no-margins" style="color: #339af0; margin-left: 10px" ng-if="vm.checkFlyerIsSelected(flyer)"><i class="fa fa-check-square"></i> Produto na vitrine</span></div></td><td width="30%" align="center" style="vertical-align:inherit"><div class="col-xs-12" style="margin-top: 24px" ng-if="flyer.purchaseValue && flyer.discountedValue"><span class="product-info-price-normal" style="white-space: nowrap"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(flyer.currency)}} </span><span class="coupon-desactived-decoration" style="white-space: nowrap">{{flyer.purchaseValue | number : 2}}</span></span><br><span class="product-info-price flyer-table-price" ng-if="flyer.discountedValue"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(flyer.currency)}} </span>{{flyer.discountedValue | number : 2}}</span></div><div class="col-xs-12" style="margin-top: 24px" ng-if="flyer.purchaseValue && !flyer.discountedValue"><br><span class="product-info-price flyer-table-price"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(flyer.currency)}} </span>{{flyer.purchaseValue | number : 2}}</span></div></td></tr></tbody></table></div><hr class="flyer-table-line"></div>');
$templateCache.put('app/admin/hub-management/showcases/hub-showcases-flyers.html','<style>div.scrollmenu {\n        background-color: transparent;\n        overflow: auto;\n        white-space: nowrap;\n    }\n\n    div.scrollmenu a {\n        display: inline-block;\n        color: white;\n        text-align: center;\n        padding: 14px;\n        text-decoration: none;\n    }\n\n    div.scrollmenu a:hover {\n        background-color: #e6e6e6;\n        border-top-left-radius: 5px;\n        border-top-right-radius: 5px;\n    }\n\n    .brand-select {\n        background-color: white;\n        border: 1px solid #dad6d6;\n        border-bottom: 1px solid #fff;\n        border-top-left-radius: 3px;\n        border-top-right-radius: 3px;\n    }\n\n    md-switch .md-thumb {\n        background-color: darkgrey;\n    }\n\n    md-switch .md-bar {\n        background-color: lightgray;\n    }\n\n    md-switch:last-of-type {\n        margin: 0px;\n    }</style><div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="form-group col-xs-12 col-md-6" style="margin-top: 18px"><div class="input-group date"><span class="input-group-addon"><i class="fa fa-search"></i> </span><input type="text" name="inputSearch" class="form-control" ng-change="vm.loadFlyers()" placeholder="{{\'flyers.home.search-hint\' | translate}}" ng-model="vm.listFilter.text" ng-model-options="{ debounce: 500 }"></div></div><div class="col-xs-12 col-md-2 coupons-menu-button" align="center"><div class="col-xs-4 store-input-nopadding m-t-xs"><div class="dropdown dropdown-table btn-group" tooltip-placement="top-right" uib-tooltip="{{\'flyers.home.buttons.advancedFilter\' | translate}}"><a class="coupon-menu-button" data-toggle="dropdown" aria-expanded="false"><span class="fa-2x glyphicon glyphicon-filter" ng-class="{\'coupon-text-color\': vm.hasActiveFilter()}"></span></a><ul class="dropdown-menu pull-right" role="menu" style="min-width: 200px" ng-click="vm.stopPropagation($event)"><li><div class="form-group"><span data-translate="flyers.home.categories">Categories</span><select class="form-control" ng-model="vm.listFilter.categoryKey" ng-change="vm.loadFlyers(null,true)"><option value="" selected="selected" data-translate="flyers.home.listAll">All</option><option ng-repeat="category in vm.categories" value="{{category.key}}">{{category.title}}</option></select></div></li><li><div class="form-group"><span data-translate="flyers.home.colors">Colors</span><select class="form-control" ng-model="vm.listFilter.color" ng-change="vm.loadFlyers(null,true)"><option value="" selected="selected" data-translate="flyers.home.listAll">All</option><option ng-repeat="color in vm.colors" value="{{color}}">{{color}}</option></select></div></li></ul></div></div></div><div class="col-xs-12 col-md-2 pull-right" style="margin-top: 12px"><button class="btn btn-block btn-primary" ng-click="vm.saveShowcase(true)"><span class="glyphicon glyphicon-ok"></span> <span data-translate="showcases.home.buttons.flyers.finish">Finish</span></button></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="clients-list" style="margin-top: -10px"><div class="scrollmenu"><a ng-click="vm.tabClick(brand)" ng-repeat="brand in vm.brands track by brand.id" ng-class="{\'brand-select\' : vm.listFilter.brand == brand.name}"><span style="color: #676a6c">{{brand.name}}</span> <span ng-if="vm.getCountSelectedByBrand(brand.name) > 0" class="label flyer-label-color">{{vm.getCountSelectedByBrand(brand.name)}}</span></a></div></div><div class="tab-content" style="background-color: white; min-height: 600px"><div ng-attr-id="{{\'tab-\' + brand.name}}" class="active" ng-if="vm.listFilter.brand == brand.name" ng-repeat="brand in vm.brands"><div ng-if="vm.busy" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-include="\'app/admin/hub-management/showcases/hub-showcases-flyers-item.html\'" ng-if="vm.flyersFiltered.length > 0"></div><div class="wrapper wrapper-content container-fluid" ng-if="vm.flyersFiltered.length <= 0 && !vm.busy"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/download-panfletos.png"><h1 data-translate="flyers.new.error.notFound">Create your first offer.</h1></div></div></div></div></div><div align="center" style="padding-bottom:  20px; margin-top: 20px" ng-if="vm.flyersFiltered.length > 0"><uib-pagination ng-model="vm.currentPage" total-items="vm.totalFlyers" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startRegistry}}\', of: \'{{vm.endRegistry}}\', total: \'{{vm.totalFlyers}}\'}">Showing {{ vm.startRegistry }} to {{ vm.endRegistry }} of {{ vm.totalFlyers }}</p></div></div></div></div></div>');
$templateCache.put('app/admin/hub-management/showcases/hub-showcases.html','<div class="wrapper wrapper-content container-fluid" ng-if="!vm.userHasShowcases && !vm.hasntStoreYet && !vm.isLoading && !vm.listFilter.name.length"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/noshowcases.png"><h1 data-translate="showcases.messages.create.title">Create your first showcase.</h1><p class="ksc-sub-title" data-translate="showcases.messages.create.info" style="width: 48% !important"></p><button id="btnCreateShowcase" class="btn btn-primary btn-large" ui-sref="hub-showcases.new"><span class="icon-ksc-showcases"></span> <span data-translate="showcases.messages.create.button">Create new showcase</span></button></div></div></div><div class="wrapper wrapper-content container-fluid" ng-if="vm.hasntStoreYet && !vm.isLoading"><div class="row" style="padding-top: 6%"><div class="col-xs-12 showcase-box-noflyer"><img src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/noshowcases.png"><h1 data-translate="showcases.messages.errors.noStore"></h1><p data-translate="showcases.messages.errors.subMessageNoStore"></p><button class="btn btn-primary btn-large" ui-sref="info"><span class="icon-ksc-store"></span> <span data-translate="store-management.home.buttons.new">Create new store</span></button></div></div></div><div class="wrapper wrapper-content" ng-if="vm.userHasShowcases || vm.listFilter.name.length"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row showcase-align-center"><div class="col-xs-11 col-sm-11"><div class="form-group"><span data-translate="showcases.home.search">Search by name</span><div class="inner-addon left-addon"><i class="glyphicon glyphicon-search"></i> <input type="text" class="form-control" ng-model="vm.listFilter.name" ng-change="vm.loadShowcases()"></div></div></div><div class="col-xs-1 col-sm-1 showcase-align-center"><div class="store-input-nopadding"><a class="coupon-menu-button" ng-click="vm.removeShowcases()" aria-hidden="true" style="width: 33.3%"><span id="btnDelete" class="icon-ksc-trash fa-2x" ng-class="{\'coupon-text-color\': vm.showcasesToRemove.length >= 1}"></span> <span ng-if="vm.showcasesToRemove.length >= 1" class="label flyer-label-color">{{vm.showcasesToRemove.length}}</span></a></div></div></div></div></div></div></div><div class="row" ng-show="!vm.isLoading"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-3"><div class="showcase-box showcase-item-box showcase-align-icon-center"><div class="showcase-flex-item" ui-sref="hub-showcases.new"><span id="btnCreateOtherShowcase" class="icon-ksc-createshowcase showcase-new-icon"></span><p class="showcase-new-text" data-translate="showcases.messages.create.button">Create new showcase</p></div></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" ng-repeat="showcase in vm.showcases"><div class="ibox"><div class="ibox-content product-box showcase-box" ng-if="!item.flyer"><div class="showcase-box-checkbox form-group"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.checkIfShowcaseSelected(showcase.id)" ng-click="vm.updateShowcasesToRemove(showcase.id)" checked="checked"> <span class="checkbox-material"><span class="check"></span></span></label></div></div><div class="showcase-box-image"><img src="content/images/templates/1.png"><div style="margin: 20px"><h2 style="font-size: 2vh !important">{{showcase.name}}</h2></div></div><div class="showcase-box-hover"><button id="btnEditShowcase" style="min-width:200px" has-authority="ADMIN_HUB" class="btn btn-lg showcase-box-transparent-button" type="button" ng-click="vm.getEditPage(showcase.id)"><span class="icon-ksc-edit"></span> <span data-translate="showcases.home.buttons.edit">Edit</span></button></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/hub-management/store-type/modal-add-edit-store-type.html','<div id="add-edit-customer-modal" ng-init="vm.init()"><div class="modal-header"><button id="btCloseModalAddCustomer" type="button" class="close" data-dismiss="modal" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" ng-if="!vm.storeType.id">Novo Tipo de Loja</h4><h4 class="modal-title" ng-if="vm.storeType.id">Editar Tipo de Loja</h4></div><form class="" ng-submit="vm.save()" id="formAddEditCustomer" name="vm.formAddEditCustomer" novalidate role="form"><div class="modal-body"><div class="panel-body"><div class="row"><div class="col-md-4 col-sm-4 col-xs-12 form-group"><label for="name" class="required">Nome</label><input id="name" name="name" type="text" class="form-control" ng-model="vm.storeType.name" ng-maxlength="100" ng-minlength="3" required><div class="help-block-div" ng-show="vm.formAddEditCustomer.fullName.$invalid && vm.formAddEditCustomer.$submitted"><p class="help-xblock form-invalid-field" ng-show="vm.formAddEditCustomer.fullName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.fullName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 4 characters.</p><p class="help-block form-invalid-field" ng-show="vm.formAddEditCustomer.fullName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div></div></div><div class="modal-footer"><button ladda="vm.isSaving" type="submit" ng-disabled="(vm.formAddEditCustomer.$invalid && vm.formAddEditCustomer.$submitted)" class="btn btn-primary btn-md" data-style="slide-left"><span data-translate="global.form.save">Save</span></button></div></form></div>');
$templateCache.put('app/admin/hub-management/store-type/store-type-list.html','<div class="ibox"><div class="ibox-content" style="height: 721px"><div class="row" style="margin-top: 40px"><div class="col-md-6"><!-- <div class="input-group form-group"> --><!-- <input type="text" placeholder="Search client" class="input form-control" ng-model="vm.filter.fullName" ng-change="vm.filterChange()">\n                    <span class="input-group-btn">\n                        <button class="btn btn btn-primary" ng-click="vm.searchByFilter()">\n                            <i class="fa fa-search"></i>\n                            <span data-translate="customer.button.search">Search</span>\n                        </button>\n                    </span> --><!-- </div> --></div><div class="col-md-6" has-authority="STORE_CREATE_CUSTOMER"><button ng-click="vm.showModalAddStoreType()" class="btn btn-primary pull-right"><i class="fa fa-user-plus"></i> <span>Criar tipo de loja</span></button></div></div><div class="clients-list"><div class="tab-content" ng-if="!vm.loadingStoreTypes"><div id="tab-1" class="tab-pane active" style="height: 520px; margin-bottom: 10px"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th><span>Nome</span></th><th><span>A\xE7\xF5es</span></th></tr></thead><tbody><tr ng-repeat="storeType in vm.storeTypes"><td class="client-avatar" style="width: auto"><img alt="image" src="/content/images/profile_small.png"> <span class="client-link" ng-bind="storeType.name" style="padding-left: 10px"></span></td><td><i class="fa fa-edit" ng-click="vm.selectStoreType(storeType)"></i></td></tr></tbody></table></div></div></div><div ng-if="vm.loadingStoreTypes" class="tab-content" style="height: 602px; display: flex;\n            align-items: center;\n            justify-content: center"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/invoices/chat/chat-invoice-new.html','<style>/* CIRCLE PROGRESS */\n    .circle-wrap {\n        margin: 20px 0;\n        width: 60px;\n        height: 60px;\n        background: #2f137e59;\n        border-radius: 50%;\n        border: 1px solid #cdcbd0;\n        padding: 0;\n    }\n\n    .circle-wrap .circle .mask,\n    .circle-wrap .circle .fill {\n        width: 60px;\n        height: 60px;\n        position: absolute;\n        border-radius: 50%;\n    }\n\n    .circle-wrap .circle .mask {\n        clip: rect(0px, 60px, 60px, 30px);\n    }\n\n    .circle-wrap .inside-circle {\n        width: 49px;\n        height: 49px;\n        border-radius: 50%;\n        background: white;\n        line-height: 48px;\n        text-align: center;\n        margin-top: 5px;\n        margin-left: 5px;\n        color: var(--main-color);\n        position: absolute;\n        z-index: 100;\n        font-weight: 700;\n        font-size: 1.2em;\n    }\n\n    /* color animation */\n\n    /* 3rd progress bar */\n    .mask .fill {\n        clip: rect(0px, 30px, 60px, 0px);\n        background-color: var(--main-color);\n    }\n\n    .mask.full, .circle .fill {\n        animation: fill ease-in-out 0.5s;\n        transform: rotate(15deg);\n    }\n\n    .badge-details {\n        color: #5E5E5E;\n        font-size: 14px;\n        font-weight: 400;\n        padding: 6px 7px;\n        text-shadow: none;\n        margin-right: 6px;\n        border-radius: 0;\n        height: 26px;\n    }\n\n    .angucomplete-image {\n        border-radius: 0 !important;\n        background: #EFEFEF;\n    }\n\n    .angucomplete-title {\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n\n\n    input::-webkit-outer-spin-button,\n\n    input::-webkit-inner-spin-button {\n\n        -webkit-appearance: none;\n        margin: 0;\n    }\n\n    input[type=number] {\n        -moz-appearance: textfield;\n        /* Firefox */\n    }\n\n    .md-autocomplete-suggestions-container .md-autocomplete-suggestions li {\n        line-height: inherit;\n        height: auto;\n        margin: 4px;\n    }\n\n    .md-autocomplete-suggestions-container.md-not-found .md-autocomplete-suggestions li {\n        line-height: 20px;\n        height: auto;\n        margin: 7px;\n        color: #acacac;\n    }\n\n    md-autocomplete-wrap {\n        height: 42px !important;\n        box-shadow: none !important;\n        border: 1px solid #e5e6e7;\n        border-radius: 4px;\n    }\n\n    .md-virtual-repeat-container.md-autocomplete-suggestions-container {\n        min-height: 42px !important;\n        width: 250px !important;\n    }\n\n    .md-virtual-repeat-container.md-autocomplete-suggestions-container.md-not-found {\n        min-height: 34px !important;\n        width: 250px !important;\n    }\n\n    md-autocomplete .md-autocomplete-input-container {\n        position: relative;\n    }\n\n    md-autocomplete .md-autocomplete-input-container::before {\n        content: \'\';\n        position: absolute;\n        top: 50%;\n        left: 10px;\n        transform: translateY(-50%);\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        background-color: red;\n    }\n\n    md-autocomplete input {\n        padding-left: 40px; /* Espa\xE7o para o c\xEDrculo */\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    .md-autocomplete-suggestions-container {\n        position: fixed !important;\n        height: 23vh !important;\n    }\n\n    .md-virtual-repeat-container .md-virtual-repeat-sizer {\n        height: 23vh !important;\n    }\n\n    .client-avatar {\n        width: 30px;\n        height: 30px;\n        margin-right: 10px;\n        border-radius: 50%;\n        align-items: center;\n        display: flex;\n        justify-content: center;\n    }\n\n    md-autocomplete-wrap:after {\n        display: block;\n        content: \'\\25BC\';\n        position: relative;\n        top: 5px;\n        speak: none;\n        font-size: 13px;\n        left: -10px;\n        color: rgba(0,0,0,0.38);\n        -webkit-transform: scaleY(.5) scaleX(1);\n        transform: scaleY(.5) scaleX(1);\n    }\n\n    .modal-header {\n        height: 70px;\n        background-image: linear-gradient(to bottom right, #00d8a6, #02a982);\n    }\n\n    .modal-dialog {\n        top: 0;\n        right: 0;\n        width: 520px;\n        position: fixed;\n        padding: 0px;\n        margin: 0px;\n        margin-top: 0 !important;\n    }\n\n    .modal-content {\n        top: 0;\n        margin-top: -1px !important;\n        width: 100% !important;\n        min-height: 100vh !important;\n        padding: 0px;\n        margin: 0px;\n    }\n\n    .modal-footer {\n        position: absolute;\n        bottom: 0px;\n        width:100%;\n        padding:2px !important;\n        height: 230px;\n        box-shadow: 0px -5px 8px -3px rgba(0,0,0,0.1);\n        background-color: #FFFFFF;\n        z-index: 10040;\n    }\n\n    .modal-body {\n        min-height: 300px;\n        max-height: calc(100vh - 285px);\n        overflow-y: auto;\n    }\n\n    .ios-mobile-padding {\n        padding-left: 0px;\n    }\n\n    @media (max-width: 800px) {\n        .modal-dialog {\n            width: 100% !important;\n        }\n\n        .modal-footer {\n            height: 280px;\n        }\n\n        .modal-body {\n            min-height: 190px;\n            max-height: calc(100vh - 330px);\n        }\n    }\n\n    /* CSS specific to iOS devices */\n    @supports (-webkit-overflow-scrolling: touch) {\n        /* Safari and Chrome */\n        .modal-footer {\n            height: 320px;\n        }\n        /* Safari and Chrome */\n        .modal-body {\n            min-height: 190px;\n            max-height: calc(100vh - 380px);\n        }\n\n        .ios-mobile-padding {\n            padding-left: 5px !important;\n        }\n    }\n\n    .modal-title {\n        font-size: 20px;\n        color: #fff;\n        font-weight: 500;\n        font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;\n    }\n\n    .content-title-nps {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n\n    .step-title {\n        font-size: 12px; \n        font-weight: 500;\n    }\n\n    .circle-button-icon {\n        border-radius: 50% !important;\n        border: 1px solid !important;\n        border-color: var(--main-color) !important;\n        color: var(--main-color) !important;\n        min-width: 34px !important;\n        min-height: 34px !important;\n        max-width: 34px !important;\n        max-height: 34px !important;\n    }\n\n    .qualification-content {\n        padding: 0 2% 5% 2%;\n    }</style><script type="text/ng-template" id="product-template"><div class="angucomplete-holder" ng-class="{\'angucomplete-dropdown-visible\': showDropdown}">\n        <input ng-model="searchStr"\n               ng-disabled="disableInput"\n               type="text"\n               placeholder="{{placeholder}}"\n               ng-focus="onFocusHandler()"\n               class="{{inputClass}}"\n               ng-focus="resetHideResults()"\n               ng-blur="hideResults($event)"\n               autocapitalize="off"\n               autocorrect="off"\n               autocomplete="off"\n               ng-change="inputChangeHandler(searchStr)"/>\n        <div class="angucomplete-dropdown" ng-show="showDropdown">\n            <div class="angucomplete-searching" ng-show="searching" ng-bind="textSearching"></div>\n            <div class="angucomplete-searching" ng-show="!searching && (!results || results.length == 0)" ng-bind="textNoResults"></div>\n            <div class="angucomplete-row" ng-repeat="result in results" ng-click="selectResult(result)" ng-mouseenter="hoverRow($index)" ng-class="{\'angucomplete-selected-row\': $index == currentIndex}">\n                <div class="angucomplete-image-holder">\n                    <img ng-src="flyer/api/{{result.originalObject.id}}/picture?type=small" class="angucomplete-image"\n                         onerror="this.src=\'https://showkase-prod.s3.sa-east-1.amazonaws.com/marketing-objects/default-flyer-image.png\'"/>\n                </div>\n                <div class="angucomplete-title" ng-if="matchClass" ng-bind-html="result.title"></div>\n                <div class="angucomplete-title" ng-if="!matchClass">{{ result.title }}</div>\n                <div ng-if="matchClass && result.description && result.description != \'\'" class="angucomplete-description" ng-bind-html="result.description"></div>\n                <div ng-if="!matchClass && result.description && result.description != \'\'" class="angucomplete-description">{{result.description}}</div>\n            </div>\n        </div>\n    </div></script><div class="modal-header"><div class="content-title-nps"><div class="row" style="height: 100%"><div class="col-xs-8" style="height: 100%"><p class="modal-title"><span>{{\'communication.modal-new-order.title\' | translate}}</span></p></div><div class="col-xs-4" style="height: 100%"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()" style="color: white; opacity: 0.8 !important">&times;</button></div></div></div></div><div class="modal-body qualification-content"><div class="row" style="width: 100%; height: 100%; margin-left: 0px; padding-top: 15px"><!-- ################### Separador da busca do flyer ################### --><div class="col-xs-12"><label class="control-label" translate>communication.modal-new-order.add-product</label><angucomplete-alt id="products" placeholder="{{\'communication.modal-new-order.product-search\' | translate}}" text-no-results="{{\'communication.modal-new-order.no-result-found\' | translate}}" text-searching="{{\'communication.modal-new-order.searching\' | translate}}" pause="300" selected-object="vm.selectedProduct" remote-url-request-formatter="vm.requestParams" remote-url="/flyer/api/flyer/search" title-field="name" description-field="productReference" search-fields="name,productReference" minlength="2" clear-selected="true" match-class="highlight" input-class="form-control form-control-small" template-url="product-template"></div><!-- ################### Separador do card dos produtos do carrinho ################### --><div class="col-xs-12 m-t-md"><div style="margin-bottom: 10px" class="display-flex" ng-repeat="item in vm.invoice.items"><div class="col-md-12 col-xs-12 pl-0 pr-0"><div class="row no-margin"><!-- foto --><div class="col-md-2 col-xs-3 pl-0 pr-0"><div class="cart-product-imitation" style="border-radius: 10%; background-size: 100% 100%; padding-top: 50px !important; height: 60px !important;\n                                    width: 60px !important" ng-style="{\'background-image\': \'url(/flyer/api/{{item.flyer.id}}/picture)\'}"></div></div><!-- informa\xE7\xF5es gerais --><div class="col-md-10 col-xs-9 pl-0 ios-mobile-padding"><div class="row"><div class="col-md-12 display-horizontally-inline" style="width: 100%; padding-right: 0px"><span class="text-navy" style="font-weight: 500; margin-top: -5px !important; width: 100%"><p class="text-ellipsis-two-lines" style="font-size: 14px;\n                                                color: #676a6c;\n                                                margin: 0 0 0 0; word-wrap: break-word">{{item.flyer.name}}</p></span><i class="fa fa-clone fa-1x" style="color: var(--main-color) !important" ng-click="vm.duplicateProduct(item.flyer)" tooltip-placement="top-right" uib-tooltip="Duplicar"></i></div><div class="col-md-12" style="line-height: 1"><div ng-if="!item.flyer.details.length"><span ng-if="item.flyer.discountedValue" style="font-size: 12px; color: var(--main-color); font-weight: bold">{{vm.currencyPrefix}} {{item.flyer.discountedValue | number : 2}} </span><span ng-if="!item.flyer.discountedValue" style="font-size: 12px; color: var(--main-color); font-weight: bold">{{vm.currencyPrefix}} {{item.flyer.purchaseValue | number : 2}} </span><span ng-if="item.flyer.discountedValue" style="font-size: 12px" class="coupon-desactived-decoration text-muted m-r-sm">{{vm.currencyPrefix}} {{item.flyer.purchaseValue | number : 2}}</span></div><div ng-if="item.flyer.details.length && item.detail"><span ng-if="item.detail.discountedValue" style="font-size: 12px; color: var(--main-color); font-weight: bold">{{vm.currencyPrefix}} {{item.detail.discountedValue | number : 2}} </span><span ng-if="!item.detail.discountedValue" style="font-size: 12px; color: var(--main-color); font-weight: bold">{{vm.currencyPrefix}} {{item.detail.purchaseValue | number : 2}} </span><span ng-if="item.detail.discountedValue" style="font-size: 12px" class="coupon-desactived-decoration text-muted m-r-sm">{{vm.currencyPrefix}} {{item.detail.purchaseValue | number : 2}}</span></div></div><div class="col-md-12" style="line-height: 1; padding-top: 2px"><div><div class="row no-margin" style="font-size: 12px" ng-if="!((item.flyer.details.length && item.detail) ||\n                                            (!item.flyer.details.length && (item.flyer.inventory >= 0 || item.flyer.inventory == null)))"><small ng-if="item.detail && item.detail.inventory">{{\' \'}}</small></div><div class="row no-margin" style="font-size: 12px" ng-if="(item.flyer.details.length && item.detail) ||\n                                            (!item.flyer.details.length && (item.flyer.inventory >= 0 || item.flyer.inventory == null))"><i ng-if="!((!item.detail && item.flyer.inventory == 0) || (item.detail && item.detail.inventory == 0))" class="fa fa-tag" ng-style="{\'color\' : \'#08b309\'}"></i> <i ng-if="(!item.detail && item.flyer.inventory == 0) || (item.detail && item.detail.inventory == 0)" class="fa fa-tag" ng-style="{\'color\' : \'#FD1414\'}"></i> <small ng-if="item.detail && item.detail.inventory">{{\'communication.modal-new-order.inventory-available\' | translate}}: <span ng-if="item.detail.inventory">{{item.detail.inventory}}</span> </small><small ng-if="item.detail && item.detail.inventory == null">{{\'communication.modal-new-order.inventory-available\' | translate}}: {{\'communication.modal-new-order.unlimited\' | translate}} </small><small ng-if="item.detail && item.detail.inventory == 0">{{\'communication.modal-new-order.inventory-unavailable\' | translate}} </small><small ng-if="!item.detail && item.flyer.inventory && item.flyer.inventory !== 0">{{\'communication.modal-new-order.inventory-available\' | translate}}: {{item.flyer.inventory}} </small><small ng-if="!item.detail && item.flyer.inventory == null">{{\'communication.modal-new-order.inventory-available\' | translate}}: {{\'communication.modal-new-order.unlimited\' | translate}} </small><small ng-if="!item.detail && item.flyer.inventory == 0">{{\'communication.modal-new-order.inventory-unavailable\' | translate}}</small></div></div></div><div class="col-md-7 col-xs-7 pr-0" style="line-height: 1"><span ng-if="item.flyer.productReference" class="tag-info" style="color: #9f9f9f; font-size: 8px">Cod: {{ item.flyer.productReference }} </span><span ng-if="!item.flyer.productReference" class="tag-info" style="color: #9f9f9f; font-size: 8px">{{ \' \' }}</span></div><div class="col-md-5 col-xs-5 pr-0" style="line-height: 1"><div><span ng-if="!item.flyer.details.length" style="height: 20px; font-size: 10px; float: right" class="badge badge-details with-stock">{{\'communication.modal-new-order.unique-size\' | translate}}</span><select class="form-control" ng-if="item.flyer.details.length" ng-model="item.detail" style="font-size: 10px; height: fit-content; float: right" ng-change="item.quantity = 1; vm.calculatePrice(); vm.checkIfVariationAlreadyExists(item, $index)" ng-options="detail as detail.size for detail in vm.filterSizes(item.flyer.details) track by detail.size"><option value="" disabled="disabled" selected="selected">{{vm.filterSizes(item.flyer.details).length ? (vm.storeCategory == \'FASHION\' ? \'communication.modal-new-order.size\' : \'communication.modal-new-order.variation\') : \'communication.modal-new-order.no-variation\' | translate}}</option></select></div></div></div></div></div><div class="row no-margin"><div class="col-md-6 col-xs-6 m-t-sm" style="padding-left: 0px; margin-top: 5px"><div class="input-group display-horizontally-inline" style="background-color: #fff; width: min-content; margin: 0 auto; column-gap: 0px"><button ng-if="!item.quantity || item.quantity == 1" class="input-group-addon circle-button-icon" ng-click="vm.changeQuantity(item, -1)" style="white-space: normal !important"><i class="icon-ksc-trash" style="font-size: 1em; display: flex; justify-content: center; align-items: center" ng-click="vm.deleteProduct($index)" tooltip-placement="top-right" uib-tooltip="Remover"></i></button> <button ng-if="item.quantity && item.quantity > 1" class="input-group-addon circle-button-icon" ng-click="vm.changeQuantity(item, -1)" style="white-space: normal !important"><span style="font-size: 1.5em; display: flex; justify-content: center; align-items: center" aria-hidden="true">-</span></button> <input class="form-control quant-input ng-pristine ng-valid ng-not-empty ng-touched" size="1" ng-model="item.quantity" ng-disabled="item.flyer.details.length && !item.detail" style="background-color: transparent; border: none; text-align: center; margin-top: 0; padding-right: 3px; padding-left: 3px; min-width: 50px" aria-invalid="false" type="number" min="0" oninput="this.value = Math.abs(this.value)" ng-change="vm.onChangeQuantity(item)"> <button class="input-group-addon circle-button-icon" ng-click="vm.changeQuantity(item, 1)" style="white-space: normal !important"><span style="font-size: 1.5em; display: flex; justify-content: center; align-items: center" aria-hidden="true">+</span></button></div></div><div class="col-md-6 col-xs-6 m-t-sm"><h3><span style="color: var(--main-color); float: right">{{vm.currencyPrefix}} {{vm.getItemSubtotal(item) | number : 2}}</span></h3></div></div><hr class="flyer-table-line"></div><hr class="flyer-table-line"></div></div><!-- ################### Separador dos dados do frete e desconto ################### --><div class="col-md-12 col-xs-12"><div class="hr-line-dashed"></div></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="col-md-6 col-xs-6" style="padding-left: 0px"><label class="control-label" translate>communication.modal-new-order.shipping</label><div class="input-group"><span class="input-group-addon" style="border-top-left-radius: 5px; border-bottom-left-radius: 5px">{{vm.currencyPrefix}}</span> <input id="purchaseValue" ng-model="vm.invoice.shippingValue" type="text" class="form-control" placeholder="0,00" price ng-change="vm.calculatePrice()" price-decimal-separator="," price-thousand-separator="." price-activated="true"></div></div><div class="col-md-6 col-xs-6" style="padding-left: 0px; padding-right: 0px"><label class="control-label" translate>communication.modal-new-order.discount-coupon</label><angucomplete-alt id="discount-coupon" style="padding-top: 2px" placeholder="{{\'communication.modal-new-order.coupon-search\' | translate}}" text-no-results="{{\'communication.modal-new-order.no-result-found\' | translate}}" text-searching="{{\'communication.modal-new-order.searching\' | translate}}" pause="400" input-changed="vm.changeDiscountCoupon" selected-object="vm.selectedDiscountCoupon" remote-url-request-formatter="vm.requestDiscountCouponParams" remote-url="/admin/api/discount-coupons" title-field="name" minlength="2" match-class="highlight" description-field="code" input-class="form-control form-control-small"></div><div ng-if="vm.selectedCoupon" class="col-md-6 col-xs-6" style="padding-top:2%; padding-left: 0px"></div><div ng-if="vm.selectedCoupon" class="col-md-6 col-xs-6" style="padding-top:2%; padding-left: 0px; padding-right: 0px"><label class="control-label" translate>communication.modal-new-order.coupon</label><div class="input-group"><span ng-if="vm.selectedCoupon.discountType == \'PERCENTAGE\'" class="input-group-addon" style="border-top-left-radius: 5px; border-bottom-left-radius: 5px">{{ \'communication.modal-new-order.percentage\' | translate}} </span><span ng-if="vm.selectedCoupon.discountType != \'PERCENTAGE\'" class="input-group-addon" style="border-top-left-radius: 5px; border-bottom-left-radius: 5px">{{ \'communication.modal-new-order.brl\' | translate}} </span><input id="purchaseValue" ng-if="vm.selectedCoupon.discountType != \'FREE_SHIPPING\'" ng-model="vm.selectedCoupon.discount" type="text" ng-disabled="true" class="form-control" placeholder="0,00" price price-decimal-separator="," price-thousand-separator="." price-activated="true"> <input id="purchaseValue" ng-if="vm.selectedCoupon.discountType == \'FREE_SHIPPING\'" ng-model="vm.invoice.shippingValue" type="text" ng-disabled="true" class="form-control" placeholder="0,00" price price-decimal-separator="," price-thousand-separator="." price-activated="true"></div></div></div><!-- ################### Separador dos dados do cliente ################### --><div class="col-md-12 col-xs-12"><div class="hr-line-dashed"></div></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="col-md-6 col-xs-6" style="padding-left: 0px"><label class="control-label" translate>communication.modal-new-order.customer-title</label><angucomplete-alt id="customer" placeholder="{{\'communication.modal-new-order.customer-search\' | translate}}" text-no-results="{{\'communication.modal-new-order.no-result-found\' | translate}}" text-searching="{{\'communication.modal-new-order.searching\' | translate}}" pause="400" input-changed="vm.changeCustomer" selected-object="vm.selectedCustomer" remote-url-request-formatter="vm.requestParams" remote-url="/admin/api/customers" title-field="fullName" minlength="2" match-class="highlight" initial-value="vm.invoice.customer.fullName" description-field="phone" input-class="form-control form-control-small"></div><div class="col-md-6 col-xs-6" style="margin-left: 0px !important; padding-left: 0px; padding-right: 0px"><label class="control-label" translate>communication.modal-new-order.phone</label><div style="margin-left: -25px !important; margin-right: 25px !important"><input style="margin-left: 0px !important" type="tel" name="phone" id="phone" class="form-control" ng-model="vm.invoice.customer.phone" ng-disabled="vm.invoice.customer.id" intl-tel-input required></div></div></div><!-- ################### Separador dos dados do vendedor ################### --><div class="col-md-12 col-xs-12"><div class="hr-line-dashed"></div></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><label class="control-label" translate>communication.modal-new-order.seller-label</label><md-autocomplete md-no-cache="true" class="custom-md-autocomplete" md-search-text="vm.searchTextSeller" name="seller" md-selected-item="vm.selectedSeller" md-items="item in vm.querySearchSellers(vm.searchTextSeller)" md-item-text="vm.getTreatedName(item)" md-min-length="0" placeholder="Buscar vendedor por nome" md-selected-item-change="vm.selectedSellerChange(item)" md-item-text="item.firstName" md-autofocus="true"><md-item-template><div class="row" style="display: flex; align-items: center"><div class="client-avatar" ng-style="{\'background-color\': item.userProfiles[0].colorCode}"><span style="color: white">{{item.firstName.charAt(0).toUpperCase()}}</span></div><div><div md-highlight-text="vm.searchTextSeller" md-highlight-flags="^">{{vm.getTreatedName(item)}}</div><div style="font-size: 10px; color: #676a6c">{{item.profilesName}}</div></div></div></md-item-template><md-not-found>{{\'communication.modal-new-order.no-result-found\' | translate}}</md-not-found></md-autocomplete></div><!-- ################### Separador dos dados da entrega ################### --><div class="col-md-12 col-xs-12"><div class="hr-line-dashed"></div></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><label class="control-label" translate>communication.modal-new-order.shipping-title</label><div class="row"><div class="col-md-6 col-xs-6"><label style="font-size: 14px"><input type="radio" name="radioShipping" ng-model="vm.invoice.shippingOption" ng-value="\'PICK_UP_IN_STORE\'"> {{\'communication.modal-new-order.pick-up-at-store\' | translate}}</label></div><div class="col-md-6 col-xs-6"><label style="font-size: 14px"><input type="radio" name="radioShipping" ng-model="vm.invoice.shippingOption" ng-value="\'RECEIVE_AT_HOME\'"> {{\'communication.modal-new-order.receive-at-home\' | translate}}</label></div></div></div><div class="row" ng-if="vm.invoice.shippingOption === \'RECEIVE_AT_HOME\'" style="margin-left: 0px; margin-right: 0px"><div class="col-md-12 col-xs-12" style="margin-top: 5px"><div ng-if="vm.isBrl" class="col-xs-6" style="padding-left: 0px"><label class="required" for="zipcode" data-translate="global.form.zipcode">Zipcode</label><input id="zipcode" name="zipcode" type="text" class="form-control" ng-maxlength="8" ng-model="vm.invoice.customer.zipcode" numbers-only ng-change="vm.checkCEP()"></div><div ng-if="!vm.isBrl" class="col-xs-6" style="padding-left: 0px"><label class="required" for="zipcode" data-translate="global.form.zipcode">Zipcode</label><input id="zipcode" name="zipcode" type="text" class="form-control" ng-model="vm.invoice.customer.zipcode" numbers-only></div><div class="col-xs-6" style="padding-left: 0px; padding-right: 0px"><label class="required" for="address" data-translate="global.form.address">Address</label><input id="address" name="address" type="text" class="form-control" ng-model="vm.invoice.customer.address" ng-maxlength="100"></div></div><div class="col-md-12 col-xs-12" style="margin-top: 5px"><div class="col-xs-6" style="padding-left: 0px"><label class="required" for="addressNumber" data-translate="global.form.number">Number</label><input id="addressNumber" name="addressNumber" type="text" class="form-control" ng-model="vm.invoice.customer.addressNumber" maxlength="10"></div><div class="col-xs-6" style="padding-left: 0px; padding-right: 0px"><label for="complement" data-translate="global.form.complement">Complement</label><input id="complement" name="complement" type="text" class="form-control" ng-model="vm.invoice.customer.complement" ng-maxlength="100"></div></div><div class="col-md-12 col-xs-12" style="margin-top: 5px"><div class="col-xs-6" style="padding-left: 0px"><label class="required" for="district" data-translate="global.form.district">District</label><input id="district" name="district" type="text" class="form-control" ng-model="vm.invoice.customer.district" ng-maxlength="100"></div><div class="col-xs-6" style="padding-left: 0px; padding-right: 0px"><label class="required" for="city" data-translate="global.form.city">City</label><input id="city" name="city" type="text" class="form-control" ng-model="vm.invoice.customer.city" ng-maxlength="50"></div></div><div class="col-md-12 col-xs-12" style="margin-top: 5px"><div ng-if="vm.isBrl" class="col-xs-6" style="padding-left: 0px"><label class="required" for="state" data-translate="global.form.state">State</label><select id="state" class="form-control" name="state" ng-model="vm.invoice.customer.state" required><option ng-selected="state.uf == vm.invoice.customer.state" ng-repeat="state in vm.states" ng-value="{{state.uf}}">{{state.uf}} - {{state.name}}</option></select></div><div ng-if="!vm.isBrl" class="col-xs-6" style="padding-left: 0px"><label class="required" for="state" data-translate="global.form.state">State</label><input id="state" name="state" type="text" class="form-control" ng-model="vm.invoice.customer.state" ng-maxlength="50"></div></div></div><!-- ################### Separador dos dados da FORMA DE PAGAMENTO ################### --><div class="col-md-12 col-xs-12"><div class="hr-line-dashed"></div></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><label class="control-label" translate>communication.modal-new-order.payment-method-title</label><div class="row"><div class="col-md-6 col-xs-6"><label style="font-size: 14px"><input type="radio" name="radioPayment" ng-model="vm.invoice.paymentCondition" ng-value="\'MONEY\'"> {{\'communication.modal-new-order.money\' | translate}}</label></div><div class="col-md-6 col-xs-6"><label style="font-size: 14px"><input type="radio" name="radioPayment" ng-model="vm.invoice.paymentCondition" ng-value="\'CREDIT_CARD\'"> {{\'communication.modal-new-order.credit-card\' | translate}}</label></div></div></div><!-- ################### Separador dos dados das NOTAS ################### --><div class="col-md-12 col-xs-12"><div class="hr-line-dashed"></div></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><label class="control-label" translate>communication.modal-new-order.notes-title</label><textarea class="form-control" rows="4" ng-model="vm.invoice.notes"></textarea><div ng-if="vm.invoice.notes.length > 1000"><div style="color: red">O limite maximo \xE9 de 1000 caracteres</div></div></div></div></div><div class="modal-footer"><div class="row" style="padding-top: 10px; margin-left: 0px; margin-right: 0px"><div class="col-md-12 col-xs-12"><div class="row col-md-12" style="padding: 5px 30px 5px 30px"><div class="col-md-5 col-xs-7" style="padding-left: 0px"><label class="control-label" style="float: left; font-weight: unset">{{\'communication.modal-new-order.subtotal\' | translate}} ({{vm.getProductCount()}} {{\'communication.modal-new-order.products\' | translate}})</label></div><div class="col-md-7 col-xs-5" style="padding-right: 0px"><label class="control-label" style="float: right; font-weight: unset">{{vm.currencyPrefix}} {{vm.invoice.subTotal || 0 | number : 2}}</label></div></div><div class="row col-md-12" style="padding: 5px 30px 5px 30px"><div class="col-md-5 col-xs-5" style="padding-left: 0px"><label class="control-label" style="float: left; font-weight: unset">{{\'communication.modal-new-order.shipping\' | translate}}</label></div><div class="col-md-7 col-xs-7" style="padding-right: 0px"><label class="control-label" style="float: right; font-weight: unset">{{vm.currencyPrefix}} {{vm.invoice.shippingValue || 0 | number : 2}}</label></div></div><div class="row col-md-12" style="padding: 5px 30px 5px 30px"><div class="col-md-5 col-xs-5" style="padding-left: 0px"><label class="control-label" style="float: left; font-weight: unset">{{\'communication.modal-new-order.discount\' | translate}}</label></div><div class="col-md-7 col-xs-7" style="padding-right: 0px"><label class="control-label" style="float: right; font-weight: unset">{{vm.currencyPrefix}} {{vm.invoice.subTotal && vm.invoice.subTotal > 0 ? (vm.invoice.discount || 0) : 0 | number : 2}}</label></div></div><div class="row col-md-12" style="padding-bottom: 5px; margin-top: -10px"><hr class="flyer-table-line"></div><div class="row col-md-12" style="padding: 5px 30px 5px 30px"><div class="col-md-5 col-xs-5" style="padding-left: 0px"><div class="row" style="margin-left: 0px; margin-right: 0px; line-height: 0.5; margin-top: 2px"><label class="control-label" style="float: left; font-weight: unset; font-size: 18px">{{\'communication.modal-new-order.total\' | translate}}</label></div><div class="row" style="margin-left: 0px; margin-right: 0px; line-height: 1"><label class="control-label" style="float: left; font-weight: unset; color: gray">{{\'communication.modal-new-order.subtotal-shipping\' | translate}}</label></div></div><div class="col-md-7 col-xs-7" style="padding-right: 0px"><label class="control-label" style="float: right; color: var(--main-color); font-size: 18px">{{vm.currencyPrefix}} {{vm.purchaseValue | number : 2}}</label></div></div></div><div class="col-md-12 col-xs-12" style="padding: 5px 30px 30px 30px"><button id="btnSave" ladda="vm.isSaving" class="btn btn-primary btn-large pull-right" style="width: 100%; background-color: #40AA60; border: none" ng-click="vm.save()" ng-disabled="vm.invoice.notes.length > 1000" data-style="slide-left"><span data-translate="communication.modal-new-order.save"></span></button></div></div></div>');
$templateCache.put('app/admin/invoices/refund/refund-magic-modal.html','<style>.sub-title {\n        font-size: 1.0em;\n    }\n\n    .modal-header {\n        border-bottom: none;\n        padding-bottom: 0px;\n    }\n\n    #slides {\n        padding-top: 0px;\n    }</style><div id="modal"><div class="modal-header" ng-if="vm.currentStep == 1"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h1 class="modal-title">Identifica\xE7\xE3o</h1><span class="sub-title">Por favor, verifique abaixo as informa\xE7\xF5es do cliente e forne\xE7a o valor a ser estornado.</span></div><div class="modal-header" ng-if="vm.currentStep == 2"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h1 class="modal-title">Confirma\xE7\xE3o</h1><span class="sub-title">Confirme abaixo as informa\xE7\xF5es do cliente e forne\xE7a o valor a ser estornado.</span></div><div class="modal-header" id="slides"><div class="slide-container"><div class="slide-dot" ng-class="{\'dot-activated\': vm.currentStep === 1}"></div><div class="slide-dot" ng-class="{\'dot-activated\': vm.currentStep === 2}"></div></div></div><div class="modal-body" ng-if="vm.currentStep == 1"><div class="row"><div class="col-xs-4"><p><span><strong data-translate="{{vm.getDocumentType() === \'CPF\' ? \'invoice.refund.title.name\' : \'invoice.refund.title.companyName\'}}"></strong><br>{{vm.invoice.fullName || "-"}}</span></p><p><span><strong>{{\'invoice.refund.title.nsu\' | translate}}:</strong><br>{{vm.invoice.nsu || "-"}}</span></p><p><span><strong>{{\'invoice.refund.title.brand\' | translate}}:</strong><br>{{ vm.invoice.brandCard || "-" }}</span></p></div><div class="col-xs-4"><p><span><strong>{{\'invoice.refund.title.email\' | translate}}:</strong><br>{{vm.invoice.customerEmail || "-"}}</span></p><p><span><strong>{{\'invoice.authorization-code\' | translate}}:</strong><br>{{vm.invoice.authorizationCode || "-"}}</span></p><p><span><strong>{{\'invoice.refund.title.installment\' | translate}}:</strong><br>{{ vm.invoice.installments ? \'(\' + vm.invoice.installments + \'x)\' : "-"}}</span></p></div><div class="col-xs-4"><p><strong>{{\'invoice.refund.title.orderNumber\' | translate}}:</strong><br><span>{{vm.invoice.id || "-"}}</span></p><p><strong>{{\'invoice.transaction-code\' | translate}}:</strong><br>{{vm.invoice.orderId || "-"}}</p><p><strong>{{\'invoice.refund.title.totalValue\' | translate}}:</strong><br>{{vm.invoice.totalCost + vm.getShippingValue() | currency}}</p></div></div><div class="row"><div class="col-xs-6"><strong>{{\'invoice.refund.title.refundValue\' | translate}}:</strong><br><span style="color: gray; font-size: 10px">O valor de estorno deve ser igual ao valor da compra.</span><br><input type="number" id="refundValue" name="refundValue" ng-model="vm.refundValue" class="form-control"></div></div></div><div class="modal-body" ng-if="vm.currentStep == 2"><div class="row"><div class="col-xs-4"><p><span><strong data-translate="{{vm.getDocumentType() === \'CPF\' ? \'invoice.refund.title.name\' : \'invoice.refund.title.companyName\'}}"></strong><br>{{vm.invoice.fullName || "-"}}</span></p><p><span><strong>{{\'invoice.refund.title.nsu\' | translate}}:</strong><br>{{vm.invoice.nsu || "-"}}</span></p><p><span><strong>{{\'invoice.refund.title.brand\' | translate}}:</strong><br>{{ vm.invoice.brandCard || "-" }}</span></p></div><div class="col-xs-4"><p><span><strong>{{\'invoice.refund.title.email\' | translate}}:</strong><br>{{vm.invoice.customerEmail || "-"}}</span></p><p><span><strong>{{\'invoice.authorization-code\' | translate}}:</strong><br>{{vm.invoice.authorizationCode || "-"}}</span></p><p><span><strong>{{\'invoice.refund.title.installment\' | translate}}:</strong><br>{{ vm.invoice.installments ? \'(\' + vm.invoice.installments + \'x)\' : "-"}}</span></p></div><div class="col-xs-4"><p><strong>{{\'invoice.refund.title.orderNumber\' | translate}}:</strong><br><span>{{vm.invoice.id || "-"}}</span></p><p><strong>{{\'invoice.transaction-code\' | translate}}:</strong><br>{{vm.invoice.orderId || "-"}}</p><p><strong>{{\'invoice.refund.title.totalValue\' | translate}}:</strong><br><span style="font-weight: bold; font-size: 16px">{{vm.invoice.totalCost + vm.getShippingValue() | currency}}</span></p></div></div><div class="row"><div class="col-xs-6"><strong>{{\'invoice.refund.title.refundValue\' | translate}}:</strong><br><span style="font-weight: bold; font-size: 16px">{{vm.refundValue | currency}}</span></div></div></div><div class="modal-footer"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.backStep()"><span ng-if="vm.currentStep !== 1">{{\'invoice.refund.buttons.back\' | translate}}</span> <span ng-if="vm.currentStep === 1">{{\'invoice.refund.buttons.cancel\' | translate}}</span></button> <button ng-disabled="!vm.isRefundValueEqualToTotal()" class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.nextStep()" ng-if="vm.currentStep == 1"><span>{{\'invoice.refund.buttons.continue\' | translate}}</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.refundTransaction()" ng-if="vm.currentStep == 2"><span>{{\'invoice.refund.buttons.refund\' | translate}}</span></button></div></div>');
$templateCache.put('app/admin/notification/modal/notificationList.html','<style>@media (max-width: 800px) {\n        .modal-dialog {\n            width: 100% !important;\n        }\n    }\n\n    @media (min-width: 800px) {\n        .modal-notifications-list {\n            margin-bottom: 130px;\n        }\n    }\n\n    .modal-dialog {\n        position: fixed;\n        margin: auto;\n        width: 520px;\n        min-height: 100%;\n        z-index: 10040;\n        overflow: auto;\n        overflow-y: auto;\n        right: 0;\n        top: 0;\n        margin-top: 0 !important;\n    }\n\n    .modal-content {\n        min-height: 100%;\n        margin-top: -1px !important;\n    }\n\n    #modalContent::-webkit-scrollbar {\n        width: 6px;\n        height: 3px;\n        background-color: #F5F5F5;\n    }\n\n    ::-webkit-scrollbar {\n        width: 0;\n        background: transparent;\n    }\n\n    #modalContent::-webkit-scrollbar-thumb {\n        border-radius: 6px;\n        -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);\n        background-color: #9a9a9a;\n    }\n\n    #modalContent::-webkit-scrollbar-track {\n        border-radius: 10px;\n        background-color: #F5F5F5;\n    }\n\n    .content-title-nps {\n        background-image: linear-gradient(to bottom right, #00d8a6, #02a982);\n        height: 69px;\n    }\n\n    .modal-title {\n        font-size: 20px;\n        color: #fff;\n        padding: 11px 0;\n        font-weight: 500;\n    }</style><div><div class="content-title-nps"><div class="row" style="height: 100%"><div class="col-xs-8" style="height: 100%"><p class="modal-title"><span>{{ \'notifications.title\' | translate }}</span></p></div><div class="col-xs-4" style="height: 100%"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()" style="padding: 8px 0; color: white; opacity: 0.8 !important">&times;</button></div></div></div><div class="modal-body qualification-content" ng-style="!vm.showObservation && { \'padding\':\'0 2% 5% 2%\' }"><div class="row"><div id="modalContent" class="tab-content" style="margin:0 5px; margin-bottom: 15px"><div ng-if="vm.loading" class="sk-container" style="padding-top: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div><div class="modal-notifications-list" detect-scroll-to-bottom="vm.nextPage" style="overflow: auto; scroll-behavior: auto; height:80vh"><div ng-repeat="notification in vm.notifications" ng-click="vm.goToMessage(notification)" style="outline: 0; min-height: 45px"><div class="store-top-nav-item" style="min-height: 90px; border: 1px solid #d9d9d9; border-radius: 10px; padding: 15px 10px; margin: 5px 5px"><div style="width: 100%"><div class="pull-left" style="padding: 0 10px; width: 100%"><img style="width: 16px; height: 16px; float:left" ng-src="{{notification.image}}"><p style="width:50%; float:left; margin-left: 5px; margin-top: -1px; color: gray">{{notification.origin}}</p><p style="width:30%; float:right; text-align: end">{{notification.updatedAt}}</p></div></div><div style="width: 100%"><div class="pull-left" style="padding: 0 10px; margin-top: -5px; width: 100%"><strong style="width: 80%; font-weight: 500">{{ notification.sender }}</strong><div style="width:20%; float:right; text-align: end"><p class="label" style="border-radius: 50px; background-color: #06d65e; color: white; padding: 0.2em 0.6em">{{notification.count}}</p></div></div></div><div style="width: 95%"><div class="pull-left" style="padding: 0 10px; width: 100%"><small class="text-muted" style="overflow: hidden; line-height: 1em;\n                                   max-height: 2em; display: -webkit-box;\n                                   -webkit-box-orient: vertical; -webkit-line-clamp: 1;\n                                   font-size: 13px; margin-top: 3px; color: gray">{{notification.message}}</small></div></div></div></div><div ng-if="vm.notifications.length == 0 && !vm.loading" style="text-align: center; font-size: 16px; margin-top: 15px">{{ \'notifications.empty\' | translate }}</div></div></div></div></div></div></div>');
$templateCache.put('app/admin/reports/performance/performance.html','<div ng-show="vm.loading" class="col-xs-12 m-t-xl"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div><iframe ng-if="!vm.loading" src="{{vm.dashboard}}" frameborder="0" width="100%" height="100%" allowtransparency style="margin-top: 30px; min-width: 100%; min-height: 99.4vh; border: none; background: white"></iframe>');
$templateCache.put('app/admin/reports/store-rating/store-rating.html','<div class="wrapper wrapper-content"><div class="row"><div ng-include="\'app/admin/reports/store-rating/widgets/store-qualify.html\'" class="col-xs-12 col-sm-12 col-md-5 col-lg-5" style="padding-right: 5px"></div><div ng-include="\'app/admin/reports/store-rating/widgets/static-store-data.html\'" class="col-xs-12 col-sm-12 col-md-7 col-lg-7" style="padding-left: 5px"></div><div ng-include="\'app/admin/reports/store-rating/widgets/store-user-xp.html\'" class="col-xs-12" style="padding-top: 5px"></div></div></div>');
$templateCache.put('app/admin/reports/tabs/contact.html','<div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-7 col-lg-7"><div class="row"><!--GENDERS--><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"><p class="report-table-title"><span data-translate="reports.tabs.contact.gender.title">Gender</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.contact.gender.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingUsersRegisteredByGender" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingUsersRegisteredByGender" ng-repeat="genderData in vm.genderData | orderBy: \'-gender\'"><div class="row"><div class="col-xs-4 col-ms-4 col-md-4 col-lg-4 public-consumer-gender-{{genderData.gender}}"><i class="fa fa-{{genderData.gender}} public-consumer-gender-icon public-consumer-gender-icon-{{genderData.gender}}"></i></div><div class="col-xs-8 col-ms-8 col-md-8 col-lg-8 public-consumer-gender-{{genderData.gender}} pull-right"><div class="public-consumer-gender-value pull-right"><div class="pull-right"><b>{{genderData.percentage}}</b> <span class="public-consumer-gender-percent-symbol">%</span></div></div><span class="public-consumer-gender-title-{{genderData.gender}} pull-right" data-translate="reports.tabs.contact.gender.{{genderData.gender}}"></span></div></div><div class="public-consumer-gender-line-bottom"></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"><div><p class="report-table-title"><span data-translate="reports.tabs.contact.consumptionHabits.title">Consumption habits</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.contact.consumptionHabits.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingMostLikedCategories" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingMostLikedCategories"><div ng-repeat="categoryData in vm.categoryData" class="localizacoes-texto"><span>{{categoryData.category}} &nbsp;&nbsp; <span style="font-size:9px">{{categoryData.count}}/{{vm.totalBrand}}</span> </span><span class="pull-right">{{$index + 1}}\xBA</span><div class="progress progress-small" style="margin-top: 2px!important; height: 6px!important"><div style="width: {{categoryData.count/vm.totalBrand * 100}}%" class="progress-bar"></div></div></div><div style="padding-top: 10px" ng-if="!vm.categoryData.length"><span class="insufficient-data" data-translate="reports.tabs.contact.insufficientData"><i>Insufficient data</i></span></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><p class="report-table-title number-customers-title"><span data-translate="reports.tabs.contact.numberUsers.title">Numbers Of Users</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.contact.numberUsers.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingListUserFirstInteraction" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingListUserFirstInteraction"><canvas id="line" class="chart chart-line" chart-data="vm.numberOfUsersData" chart-labels="vm.labels" chart-colors="vm.colors" chart-options="vm.chartOptions" chart-dataset-override="vm.datasetOverride"></canvas></div></div></div></div><div class="col-md-5 col-lg-5"><div class="row"><!--Top Contact Generators--><div class="col-md-12 col-lg-12 form-group"><p class="report-table-title"><span data-translate="reports.tabs.contact.potentialClients.title">Top Potential Clients</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.contact.potentialClients.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingListUsersGenerateMoreContact" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingListUsersGenerateMoreContact" style="width: 100%; padding: 0"><div class="row" style="width: 100% !important"><table class="table public-consumer-potential-clients-table" ng-if="vm.contactGeneratorData.length"><thead><tr><th width="35%" data-translate="reports.tabs.contact.potentialClients.customer">Customer</th><th width="65%" data-translate="reports.tabs.contact.potentialClients.email">Email</th></tr></thead><tbody><tr class="coupon-generator-users" ng-repeat="contactGeneratorData in vm.contactGeneratorData"><td class="text-left"><i style="padding-right:4%" class="fa fa-user public-consumer-gender-icon-{{contactGeneratorData.user.gender}}"></i>{{contactGeneratorData.user.name}}</td><td class="text-left">{{contactGeneratorData.user.email}}</td></tr></tbody></table><div style="padding: 10px" ng-if="!vm.contactGeneratorData.length"><span class="insufficient-data" style="margin-left: 15px" data-translate="reports.tabs.contact.insufficientData"><i>Insufficient data</i></span></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/reports/tabs/coupon.html','<div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-5 col-lg-5"><div class="row"><!--GENDERS--><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"><p class="report-table-title"><span data-translate="reports.tabs.coupon.gender.title">Gender</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.coupon.gender.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingUsersRegisteredByGender" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingUsersRegisteredByGender" ng-repeat="genderData in vm.genderData | orderBy: \'-gender\'"><div class="row"><div class="col-xs-4 col-ms-4 col-md-4 col-lg-4 public-consumer-gender-{{genderData.gender}}"><i class="fa fa-{{genderData.gender}} public-consumer-gender-icon public-consumer-gender-icon-{{genderData.gender}}"></i></div><div class="col-xs-8 col-ms-8 col-md-8 col-lg-8 public-consumer-gender-{{genderData.gender}} pull-right"><div class="public-consumer-gender-value pull-right"><div class="pull-right"><b>{{genderData.percentage}}</b><span class="public-consumer-gender-percent-symbol">%</span></div></div><span class="public-consumer-gender-title-{{genderData.gender}} pull-right" data-translate="reports.tabs.coupon.gender.{{genderData.gender}}"></span></div></div><div class="public-consumer-gender-line-bottom"></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"><div><p class="report-table-title"><span data-translate="reports.tabs.coupon.consumptionHabits.title">Consumption habits</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.coupon.consumptionHabits.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingMostLikedCategories" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingMostLikedCategories"><div ng-repeat="categoryData in vm.categoryData" class="localizacoes-texto"><span>{{categoryData.category}} &nbsp;&nbsp;<span style="font-size:9px">{{categoryData.count}}/{{vm.totalBrand}}</span></span><span class="pull-right">{{$index + 1}}\xBA</span><div class="progress progress-small" style="margin-top: 2px!important; height: 6px!important"><div style="width: {{categoryData.count/vm.totalBrand * 100}}%" class="progress-bar"></div></div></div><div style="padding-top: 10px" ng-if="!vm.categoryData.length"><span class="insufficient-data" data-translate="reports.tabs.coupon.insufficientData"><i>Insufficient data</i></span></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><p class="report-table-title number-customers-title"><span data-translate="reports.tabs.coupon.numberUsers.title">Numbers Of Users</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.coupon.numberUsers.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingListUserFirstInteraction" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingListUserFirstInteraction"><canvas id="line" class="chart chart-line" chart-data="vm.numberOfUsersData" chart-labels="vm.labels" chart-colors="vm.colors" chart-options="vm.chartOptions" chart-dataset-override="vm.datasetOverride"></canvas></div></div></div></div><div class="col-md-7 col-lg-7"><div class="row"><!--Top Coupons Generators--><div class="col-md-12 col-lg-5 form-group"><p class="report-table-title"><span data-translate="reports.tabs.coupon.potentialClients.title">Top Potential Clients</span> <span ng-if="vm.couponGeneratorData.length && !vm.loadingListUsersGenerateMoreCoupons">{{vm.couponGeneratorData.length}} / {{vm.couponGeneratorData[0].total}}</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.coupon.potentialClients.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingListUsersGenerateMoreCoupons" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingListUsersGenerateMoreCoupons" style="width: 100%; padding: 0"><div class="row" style="width: 100% !important"><table class="table public-consumer-potential-clients-table" ng-if="vm.couponGeneratorData.length"><thead><tr><th width="35%" data-translate="reports.tabs.coupon.potentialClients.customer">Customer</th><th width="65%" data-translate="reports.tabs.coupon.potentialClients.email">Email</th></tr></thead><tbody><tr class="coupon-generator-users" ng-repeat="couponGeneratorData in vm.couponGeneratorData"><td class="text-left"><i style="padding-right:4%" class="fa fa-user public-consumer-gender-icon-{{couponGeneratorData.user.gender}}"></i>{{couponGeneratorData.user.name}}</td><td class="text-left">{{couponGeneratorData.user.email}}</td></tr></tbody></table><div style="padding: 10px" ng-if="!vm.couponGeneratorData.length"><span class="insufficient-data" style="margin-left: 15px" data-translate="reports.tabs.coupon.insufficientData"><i>Insufficient data</i></span></div></div></div></div><div class="col-md-12 col-lg-7 form-group"><p class="report-table-title"><span data-translate="reports.tabs.coupon.moreActive.title">Main effective users</span> <span ng-if="vm.moreActiveData.length && !vm.loadingListUsersWithMoreCouponsRedeemed">{{vm.moreActiveData.length}} / {{vm.moreActiveData[0].total}}</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.coupon.moreActive.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingListUsersWithMoreCouponsRedeemed" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingListUsersWithMoreCouponsRedeemed" class="tabs-container"><div class="effective-customers" ng-repeat="moreActiveData in vm.moreActiveData | orderBy: \'-qtdRedeemed\'"><div><p class="pull-left effective-customers-number">{{$index+1}}\xBA</p><!--Foto do perfil--> <a class="pull-left"><img src="/content/images/profile_small.png" class="img-circle" alt="image" style="padding: 0 10px!important; width: 60px!important"></a></div><div class="media-body"><!--Linha de separa\xE7\xE3o--><div class="pull-left effective-customers-separation-line"></div><p class="pull-right" style="display: block"><span class="effective-customers-redeemed pull-right">{{moreActiveData.qtdRedeemed}}</span> <span class="text-effective-purchases" data-translate="reports.tabs.coupon.moreActive.effectivePurchases"></span></p><p class="effective-customers-name">{{moreActiveData.user.name}}</p><p class="effective-customers-email">{{moreActiveData.user.email}}</p></div><div style="height: 1px; background-color: #E0EEEE"></div></div><div style="padding: 10px" ng-if="!vm.moreActiveData.length"><span class="insufficient-data" data-translate="reports.tabs.coupon.insufficientData"><i>Insufficient data</i></span></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/reports/tabs/sale.html','<div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-7 col-lg-7"><div class="row"><!--GENDERS--><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"><p class="report-table-title"><span data-translate="reports.tabs.sale.gender.title">Gender</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.sale.gender.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingUsersRegisteredByGender" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingUsersRegisteredByGender" ng-repeat="genderData in vm.genderData | orderBy: \'-gender\'"><div class="row"><div class="col-xs-4 col-ms-4 col-md-4 col-lg-4 public-consumer-gender-{{genderData.gender}}"><i class="fa fa-{{genderData.gender}} public-consumer-gender-icon public-consumer-gender-icon-{{genderData.gender}}"></i></div><div class="col-xs-8 col-ms-8 col-md-8 col-lg-8 public-consumer-gender-{{genderData.gender}} pull-right"><div class="public-consumer-gender-value pull-right"><div class="pull-right"><b>{{genderData.percentage}}</b><span class="public-consumer-gender-percent-symbol">%</span></div></div><span class="public-consumer-gender-title-{{genderData.gender}} pull-right" data-translate="reports.tabs.sale.gender.{{genderData.gender}}"></span></div></div><div class="public-consumer-gender-line-bottom"></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group"><!--CONSUMPTION HABITS--><div><p class="report-table-title"><span data-translate="reports.tabs.sale.consumptionHabits.title">Consumption habits</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.sale.consumptionHabits.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingMostLikedCategories" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingMostLikedCategories"><div ng-repeat="categoryData in vm.categoryData" class="localizacoes-texto"><span>{{categoryData.category}} &nbsp;&nbsp;<span style="font-size:9px">{{categoryData.count}}/{{vm.totalBrand}}</span></span><span class="pull-right">{{$index + 1}}\xBA</span><div class="progress progress-small" style="margin-top: 2px!important; height: 6px!important"><div style="width: {{categoryData.count/vm.totalBrand * 100}}%" class="progress-bar"></div></div></div><div style="padding-top: 10px" ng-if="!vm.categoryData.length"><span class="insufficient-data" data-translate="reports.tabs.sale.insufficientData"><i>Insufficient data</i></span></div></div></div></div><!--NUMBERS OF USERS FIRST INTERACTION--><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><p class="report-table-title number-customers-title"><span data-translate="reports.tabs.sale.numberUsers.title">Numbers Of Users</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.sale.numberUsers.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingListUserFirstInteraction" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingListUserFirstInteraction"><canvas id="line" class="chart chart-line" chart-data="vm.numberOfUsersData" chart-labels="vm.labels" chart-colors="vm.colors" chart-options="vm.chartOptions" chart-dataset-override="vm.datasetOverride"></canvas></div></div></div></div><div class="col-md-5 col-lg-5"><div class="row"><!--MAIN EFFECTIVE CUSTOMERS--><div class="col-md-12 col-lg-12 form-group"><p class="report-table-title"><span data-translate="reports.tabs.sale.moreActive.title">Main effective users</span> <span ng-if="vm.saleTransactionData.length && !vm.loadingListUsersPerformMoreSalesTransactions">{{vm.saleTransactionData.length}} / {{vm.saleTransactionData[0].total}}</span> <span tooltip-placement="left" uib-tooltip="{{\'reports.tabs.sale.moreActive.tooltip\' | translate}}" class="fa fa-question-circle pull-right question-icon-color"></span></p><div ng-if="vm.loadingListUsersPerformMoreSalesTransactions" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingListUsersPerformMoreSalesTransactions" class="tabs-container"><div class="effective-customers" ng-repeat="saleTransactionData in vm.saleTransactionData | orderBy: \'-count\'"><div><p class="pull-left effective-customers-number">{{$index+1}}\xBA</p><!--Foto do perfil--> <a class="pull-left"><img src="/content/images/profile_small.png" class="img-circle" alt="image" style="padding: 0 10px!important; width: 60px!important"></a></div><div class="media-body"><!--Linha de separa\xE7\xE3o--><div class="pull-left effective-customers-separation-line"></div><p class="pull-right" style="display: block"><span class="effective-customers-redeemed pull-right">{{saleTransactionData.count}}</span> <span class="text-effective-purchases" data-translate="reports.tabs.sale.moreActive.effectivePurchases"></span></p><p class="effective-customers-name">{{saleTransactionData.user.name}}</p><p class="effective-customers-email">{{saleTransactionData.user.email}}</p></div><div style="height: 1px; background-color: #E0EEEE"></div></div><div style="padding: 10px" ng-if="!vm.saleTransactionData.length"><span class="insufficient-data" data-translate="reports.tabs.sale.insufficientData"><i>Insufficient data</i></span></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/reports/user/user.engagements.html','<div class="wrapper wrapper-content animated fadeInDown"><div class="row"><div class="col-lg-3" style="padding-right: 0"><div class="ibox float-e-margins" style="min-height: 260px"><div class="ibox-content"><div class="row"><div class="col-lg-12"><div ng-if="vm.loadingUserInfo" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="! vm.loadingUserInfo" class="text-center"><div class="m-b-sm"><img alt="image" class="img-circle" src="/content/images/profile_small.png" style="width: 32px"></div><h2 class="ng-binding">{{vm.user.firstName}} {{vm.user.lastName}}</h2></div><div style="padding: 10px 15px 0 0"><div><label><span data-translate="global.form.email">Email</span>:</label><span ng-bind="vm.user.email"></span></div><div ng-if="vm.user.dateOfBirth"><label><span data-translate="global.form.birthDate">Birthdate</span>:</label><span>{{vm.user.dateOfBirth | amDateFormat:\'DD/MM/YYYY\'}}</span></div><div><label><span data-translate="global.form.phone">Phone</span>:</label><span ng-bind="vm.user.phone"></span></div><div ng-if="vm.user.gender"><label><span data-translate="global.form.gender">Gender</span>:</label><span data-translate="reports.engagement.user.{{vm.user.gender}}">Male</span></div></div></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h5 data-translate="reports.engagement.user.habits.title">Habits of consume</h5></div><div class="ibox-content"><div class="row" style="min-height: 105px"><div class="col-lg-12"><div ng-if="vm.loadingUserCategoryStatistics" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingUserCategoryStatistics" ng-repeat="category in vm.categoryStatistics" class="localizacoes-texto"><span>{{category.category}} &nbsp;&nbsp; <span style="font-size:12px">{{category.count}}/{{vm.totalBrand}}</span> </span><span class="pull-right">{{$index + 1}}\xBA</span><div class="progress progress-small" style="margin-top: 2px!important; height: 6px!important"><div style="width: {{category.count/vm.totalBrand * 100}}%" class="progress-bar"></div></div></div><div style="padding-top: 10px" ng-if="!vm.categoryStatistics.length"><span class="insufficient-data" data-translate="reports.tabs.coupon.insufficientData"><i>Insufficient data</i></span></div></div></div></div></div></div><div class="col-lg-9"><div class="ibox float-e-margins"><div class="ibox float-e-margins"><div class="ibox-title"><h5 data-translate="reports.engagement.user.engagement.title">Engagements</h5><div ibox-tools></div></div><div class="ibox-content"><div class="row" style="min-height: 390px"><div class="col-lg-12"><div ng-if="vm.loadingUserOfferEngagements" class="sk-container" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="!vm.loadingUserOfferEngagements && (!vm.offers || vm.offers.length > 0)"><div ng-repeat="item in vm.offers track by $index"><div class="table-responsive"><table class="table shoping-cart-table"><tbody><tr width="100%"><td width="10%"><div class="cart-product-imitation flyer-table-img" style="background-size: 100% 100%; padding-top: 50px !important" ng-style="{\'background-image\': \'url(/flyer/api/{{item.flyer.id}}/picture)\'}"></div></td><td class="desc" width="60%"><h3 style="margin-top: -5px !important"><span class="text-navy"><small class="text-muted coupon-text-color product-category">{{item.flyer.category}}</small><div class="flyer-table-name"><p style="font-size: 16px;\n                                                                               \n                                                                                color: #676a6c;\n                                                                                display: block;\n                                                                                margin: 4px 0 5px 0; word-wrap: break-word">{{item.flyer.name}}</p></div></span></h3><div class="m-t-sm"><span class="fa fa-tag" ng-class="{\'ksc-tag-active\': item.flyer.status == \'ACTIVATED\', \'ksc-tag-inactive\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(item.flyer.status))}"></span> <span class="flyer-table-info" ng-class="{\'flyer-active\': item.flyer.status == \'ACTIVATED\', \'flyer-disabled\': (item.flyer.status == \'DEACTIVATED\' || item.flyer.status == \'EXPIRED\')}">{{(item.flyer.status == \'ACTIVATED\' ? \'reports.engagement.user.offer.active\' : \'reports.engagement.user.offer.disabled\') | translate}}</span> <span ng-show="flyer.expirationDate" style="margin-left: 15px" tooltip-placement="bottom-left" uib-tooltip="{{\'reports.engagement.user.offer.expiration\' | translate}}"><span class="fa fa-clock-o product-date">{{item.flyer.expirationDate | date: "dd/MM/yyyy"}}</span> </span><span style="margin-left: 5px; background-color: #1AB394" class="label label-primary" data-translate="reports.engagement.user.messages.interaction" translate-values="{quantity: \'{{item.count}}\'}"></span></div></td><td width="30%"><div class="col-xs-12" style="margin-top: 24px"><span class="product-info-price-normal" style="white-space: nowrap" ng-if="item.flyer.purchaseValue && item.flyer.discountValue"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(item.flyer.currency)}} </span><span class="coupon-desactived-decoration" style="white-space: nowrap">{{item.flyer.purchaseValue | number : 2}}</span></span><br><span class="product-info-price flyer-table-price" ng-if="item.flyer.discountValue"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(item.flyer.currency)}} </span>{{item.flyer.discountedValue | number : 2}}</span> <span class="product-info-price flyer-table-price" ng-if="!item.flyer.discountValue && item.flyer.purchaseValue"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(item.flyer.currency)}} </span>{{item.flyer.purchaseValue | number : 2}}</span></div></td></tr></tbody></table></div><hr class="flyer-table-line"></div><div align="center" style="padding:  20px 0 20px 0"><uib-pagination ng-model="vm.currentPage" rotate="false" total-items="vm.totalElements" max-size="vm.maxSize" items-per-page="vm.numPerPage" boundary-links="true" ng-change="vm.changePage()"></uib-pagination><div class="col-xs-12 col-sm-12"><p data-translate="global.table.pagination" translate-values="{show: \'{{vm.startElement}}\', of: \'{{vm.ofQuantityElements}}\', total: \'{{vm.totalElements}}\'}">Showing {{ vm.startElement }} to {{ vm.ofQuantityElements }} of {{ vm.totalElements }}</p></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" align="center"><div style="padding-top: 20%; text-align: center" ng-if="!vm.loadingUserOfferEngagements && (!vm.offers || vm.offers.length < 1)"><span class="insufficient-data" data-translate="reports.engagement.user.messages.noContent"><i>Insufficient data</i></span></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/settings/communication/chat-assignment-rule.html','<style>.no-templates-box {\n        display: flex;\n        align-items: center;\n        border-radius: 5px;\n    }\n\n    .cost-box {\n        display: flex;\n        align-items: center;\n        color: var(--main-color-light);\n        background-color: #dfd7ed;\n        border-radius: 5px;\n    }\n\n    .cost-text {\n        font-size: 12px;\n        text-align: justify;\n        opacity: 1;\n        padding: 10px;\n        font-weight: 400;\n    }\n\n    .cost-icon {\n        font-size: xx-large;\n        -moz-transform: scale(-1, 1);\n        -webkit-transform: scale(-1, 1);\n        -o-transform: scale(-1, 1);\n        -ms-transform: scale(-1, 1);\n        transform: scale(-1, 1);\n    }\n\n    .more-about {\n        color: var(--main-color-light);\n        font-weight: bold;\n        text-decoration: underline;\n    }\n\n    .more-about:hover {\n        color: var(--main-color);\n        font-weight: bold;\n        text-decoration: underline;\n    }\n\n    .notification-item {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 5px 15px 5px 15px;\n        border-radius: 10px;\n        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n    }\n\n    .credit-container {\n        display: flex;\n        justify-content: flex-end;\n    }\n\n    .credit-wallet-icon {\n        color: var(--main-color-light);\n        font-size: 3.5em\n    }\n\n    .credit-value {\n        font-weight: bold;\n    }\n\n    .btn-outline {\n        font-size: small;\n        color: var(--main-color-light);\n        border: 1px solid;\n        border-radius: 10px !important;\n        padding: 1px 25px;\n    }\n\n    .btn-outline:hover {\n        color: var(--main-color);\n    }</style><div class="col-sm-12"><h1 data-translate="settings.communication.chat-assignment-rule.rule-title"></h1><p data-translate="settings.communication.chat-assignment-rule.rule-subtitle" style="text-align: justify"></p></div><form name="vm.ruleForm" role="form" novalidate show-validation ng-submit="vm.createUpdateRule()"><div class="col-md-6 col-xs-12" ng-class="{\'p-0 m-b-md\': vm.isMobile}"><div class="col-md-12 m-b-lg" ng-class="{\'p-0\': vm.isMobile}"><div ng-repeat="rule in vm.rules track by $index" style="margin-top: 15px"><div class="notification-item"><div class="display-horizontally-inline" style="width: 80%; justify-content: flex-start"><md-switch ng-model="rule.isEnabled" md-no-ink="true" ng-change="vm.disableRule(rule)"></md-switch><div class="m-l-sm" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden"><b style="font-size: 14px">{{rule.name}}</b><div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden"><span>{{\'settings.communication.chat-assignment-rule.form.keyword\' | translate}}: {{rule.keyword}}</span></div></div></div><div style="display: flex; flex-direction: row"><span class="fa fa-pencil-square-o" style="margin-right: 14px; color: #676a6cd6; font-size: 15px" ng-click="vm.getRuleById(rule.id)"></span> <span class="fa fa-trash" style="margin-right: 8px; color: #676a6cd6; font-size: 15px" ng-click="vm.deleteRule(rule.id)"></span></div></div></div><div ng-if="!vm.activeForm && vm.rules.length" class="col-sm-12 m-t-md p-0"><button type="button" class="btn btn-primary pull-right" ng-click="vm.openCreateRuleForm()" data-translate="settings.communication.chat-assignment-rule.form.create-rule">Add</button></div></div><div class="col-sm-12 alert alert-warning no-templates-box" ng-if="!vm.rules.length"><i class="icon-ksc-finaluser-seller cost-icon" aria-hidden="true"></i><p class="m-0 cost-text ng-scope" data-translate="settings.communication.chat-assignment-rule.empty-list"></p></div><div id="abandoned-cart-form" class="col-md-12 p-0" ng-show="(vm.activeForm || !vm.rules.length)"><div class="form-group col-md-12 col-xs-12"><label class="control-label required" for="ruleName" data-translate="settings.communication.chat-assignment-rule.form.name"></label><input id="ruleName" type="text" name="ruleName" class="form-control minimal" ng-model="vm.form.name" placeholder="Ex.: Loja Jo\xE3o Pessoa" required></div><div class="form-group col-md-12 col-xs-12"><label class="control-label required" for="ruleKeyword" data-translate="settings.communication.chat-assignment-rule.form.keyword"></label><input id="ruleKeyword" type="text" name="ruleKeyword" class="form-control minimal" ng-model="vm.form.keyword" placeholder="Ex.: 1. Jo\xE3o Pessoa" required></div><div class="form-group col-md-12 col-xs-12"><label class="control-label required" for="team" data-translate="settings.communication.chat-assignment-rule.form.team"></label><select id="team" name="team" type="text" class="form-control minimal" ng-model="vm.form.team" ng-value="vm.form.team" ng-change="vm.selectTeam()" ng-options="item as item.name for item in vm.teams track by item.id" required></select></div><div ng-show="vm.ruleForm" class="col-sm-12" style="margin-top: 15px; margin-left: 14px"><button id="add-notification" ladda="vm.isSaving" type="submit" class="btn btn-primary pull-right" data-translate="global.form.save" ng-disabled="vm.ruleForm.$invalid">Add</button> <button ladda="vm.isSaving" type="button" class="btn btn-primary mr-2 btn btn-default btn-md cancel-button pull-right" ng-click="vm.cancelForm()" data-translate="global.messages.remove.cancel">Cancel</button></div></div></div><div class="col-md-6 col-xs-12"><h3 data-translate="settings.communication.chat-assignment-rule.about-title" style="padding-bottom: 2%"></h3><div class="col-sm-12 info-box" style="overflow: hidden"><p style="font-size: 15px; text-align: justify" data-translate="settings.communication.chat-assignment-rule.about-description"></p></div></div></form>');
$templateCache.put('app/admin/settings/communication/communication-settings.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-6"><p data-translate="settings.communication.home.description">Aqui voc\xEA configura as regras e automa\xE7\xF5es do atendimento via chat.</p></div></div><div class="clients-list"><ul class="nav nav-tabs"><li ng-class="{\'active\' : tab == 1}"><a class="Tab-title" ng-click="tab = 1" ng-init="tab = 1"><i class="fa fa-comments"></i> <span data-translate="settings.communication.home.tabTitle">Atribui\xE7\xF5es de equipes</span></a></li></ul><div class="tab-content"><div id="tab-1" class="tab-pane active" ng-show="tab == 1"><div class="panel-body" ng-include="\'app/admin/settings/communication/chat-assignment-rule.html\'"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/settings/erps/bling.html','<div class="col-sm-6"><div class="row col-sm-12" style="padding-bottom: 4%; padding-top: 4%"><img src="/content/images/bling.png" width="100px" height="100%"></div><div class="row" ng-show="!vm.bling && !vm.bling.id"><div class="row col-md-12"><h3 data-translate="settings.erps.bling.stepTitle"></h3><p data-translate="settings.erps.bling.step1"></p><p data-translate="settings.erps.bling.step2"></p><p data-translate="settings.erps.bling.step3"></p><p data-translate="settings.erps.bling.step4"></p><p data-translate="settings.erps.bling.step5"></p></div><div class="col-sm-12" style="padding-top: 4%; padding-bottom: 4%; padding-left: 0px"><a ladda="vm.loading" type="button" data-ng-disabled="vm.islocked" class="btn btn-primary" target="_blank" style="margin-right: 3%; margin-bottom: 4%" ng-href="https://www.bling.com.br/">{{ \'settings.erps.bling.createButtonTitle\' | translate }} </a><a ladda="vm.loading" type="button" ng-click="vm.authBling()" data-ng-disabled="vm.islocked" class="btn btn-primary" style="margin-bottom: 4%">{{ \'settings.erps.bling.connectButtonTitle\' | translate }}</a></div></div><div class="row" ng-if="vm.bling && vm.bling.id && (vm.bling.status == \'NEW\' || vm.bling.status == \'READY_TO_UPDATE\')"><div class="col-md-12"><h3 data-translate="settings.erps.bling.instructions.title"></h3><p data-translate="settings.erps.bling.instructions.step1"></p><div class="col-md-12" style="margin-bottom: 10px"><a ng-href="https://ajuda.bling.com.br/hc/pt-br/articles/360047145193-Integra%C3%A7%C3%A3o-API" target="_blank">{{ \'settings.erps.bling.instructions.tutorial\' | translate }}</a></div><div class="col-md-12" style="margin-bottom: 10px"><label class="control-label" for="callback-stock-url" data-translate="settings.erps.bling.instructions.stock">Callback de estoque</label><div class="row" style="line-height: 30px"><div class="col-md-10"><input type="text" style="background-color: #f3f3f4 !important" class="form-control" id="callback-stock-url" ng-disabled="true" name="callback-stock-url" ng-value="vm.getBlingStockCallbackUrl()"></div><div class="col-md-2" style="line-height: 30px; display: inline-block; vertical-align: middle" ng-click="vm.copiedToClipboard()"><a class="ng-scope" uib-tooltip="{{\'settings.erps.bling.instructions.tooltip\' | translate}}" copy-to-clipboard="{{vm.getBlingStockCallbackUrl()}}">{{ \'settings.erps.bling.instructions.copy\' | translate }} <i class="fa fa-files-o" aria-hidden="true"></i></a></div></div></div><div class="col-md-12" style="margin-bottom: 4%"><label class="control-label" for="callback-order-url" data-translate="settings.erps.bling.instructions.order">Callback de pedidos de venda</label><div class="row" style="line-height: 30px"><div class="col-md-10"><input type="text" style="background-color: #f3f3f4 !important" class="form-control" id="callback-order-url" ng-disabled="true" name="callback-order-url" ng-value="vm.getBlingOrderCallbackUrl()"></div><div class="col-md-2" style="line-height: 30px; display: inline-block; vertical-align: middle" ng-click="vm.copiedToClipboard()"><a class="ng-scope" uib-tooltip="{{\'settings.erps.bling.instructions.tooltip\' | translate}}" copy-to-clipboard="{{vm.getBlingOrderCallbackUrl()}}">{{ \'settings.erps.bling.instructions.copy\' | translate }} <i class="fa fa-files-o" aria-hidden="true"></i></a></div></div></div><p data-translate="settings.erps.bling.instructions.step2"></p><div class="form-group col-sm-12"><label class="control-label" for="blingStoreId" data-translate="settings.erps.bling.instructions.store">Store</label><input id="blingStoreId" name="blingStoreId" type="number" class="form-control" ng-model="vm.bling.blingStoreId"></div><p data-translate="settings.erps.bling.instructions.step3"></p><div class="row col-md-12 col-xs-12" style="margin-top: 5px; margin-left: 0px; margin-right: 0px; column-gap: unset"><label class="control-label" data-translate="settings.erps.bling.sync-params">Product Sync Params</label></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="col-md-3 col-xs-6" style="padding-left: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.bling.syncName"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.bling.name"></span></label></div></div><div class="col-md-3 col-xs-6" style="padding-left: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.bling.syncDescription"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.bling.description"></span></label></div></div><div class="col-md-3 col-xs-6" style="padding-left: 0px; padding-right: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.bling.syncBrand"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.bling.brand"></span></label></div></div><div class="col-md-3 col-xs-6" style="padding-left: 0px; padding-right: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.bling.syncCategory"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.bling.category"></span></label></div></div></div><div class="row col-md-12 col-xs-12" style="margin-top: 15px; margin-left: 0px; margin-right: 0px; column-gap: unset"><label class="control-label" data-translate="settings.erps.bling.sync-order-params">ID config</label></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="col-md-12 col-xs-12" style="padding-left: 0px; padding-right: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.bling.linkNumber"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.bling.link-number"></span></label></div></div></div><div ng-if="vm.bling.linkNumber" class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><informative-balloon message-id="\'settings.erps.bling.link-number-warning-1\'"></informative-balloon></div><div ng-if="!vm.bling.linkNumber" class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><informative-balloon message-id="\'settings.erps.bling.link-number-warning-2\'"></informative-balloon></div></div><div class="col-md-12 col-sm-12" style="padding-top: 4%; padding-bottom: 4%"><a ng-click="vm.openDisconnectBlingModal()" style="margin-right: 3%; margin-bottom: 4%" type="button" class="btn btn-secondary" ng-show="vm.bling && vm.bling.id"><span data-translate="settings.erps.bling.disconnectButtonTitle">Disconnect</span> </a><a ladda="vm.loading" type="button" ng-click="vm.updateBling()" data-ng-disabled="vm.islocked" class="btn btn-primary" style="margin-bottom: 4%" ng-show="vm.bling && vm.bling.id">{{ \'settings.form.button\' | translate }}</a></div></div><!-- STATUS = INVALID_TOKEN --><div class="row" ng-if="vm.bling && vm.bling.id && vm.bling.status == \'INVALID_TOKEN\'"><div class="col-md-12" style="color: #8a6d3b; background-color: #fcf8e3; border: 1px solid; border-color: #faebcc"><div class="display-horizontally-inline" style="margin-top: 10px"><i class="fa fa-warning" style="color: #8a6d3b"></i><h3 style="margin-top: 10px; color: #8a6d3b" data-translate="settings.erps.bling.instructions.invalid-token-title"></h3></div><p style="margin-top: 8px; color: #8a6d3b" data-translate="settings.erps.bling.instructions.invalid-token-step1"></p><p style="margin-top: 10px; color: #8a6d3b" data-translate="settings.erps.bling.instructions.invalid-token-step2"></p></div><div class="col-sm-12" style="padding-top: 4%; padding-bottom: 4%; padding-left: 0px"><a ng-click="vm.openDisconnectBlingModal()" style="margin-right: 3%; margin-bottom: 4%" type="button" class="btn btn-secondary"><span data-translate="settings.erps.bling.disconnectButtonTitle">Disconnect</span> </a><a ladda="vm.loading" type="button" ng-click="vm.refreshBlingToken()" class="btn btn-primary" style="margin-bottom: 4%">{{ \'settings.erps.bling.refreshTokenButtonTitle\' | translate }}</a></div></div><!-- STATUS = FAILED --><div class="row" ng-if="vm.bling && vm.bling.id && vm.bling.status == \'FAILED\'"><div class="col-md-12" style="color: #8a6d3b; background-color: #fcf8e3; border: 1px solid; border-color: #faebcc"><div class="display-horizontally-inline" style="margin-top: 10px"><i class="fa fa-warning" style="color: #8a6d3b"></i><h3 style="margin-top: 10px; color: #8a6d3b" data-translate="settings.erps.bling.instructions.failed-token-title"></h3></div><p style="margin-top: 8px; color: #8a6d3b" data-translate="settings.erps.bling.instructions.failed-token-step1"></p><p style="margin-top: 10px; color: #8a6d3b" data-translate="settings.erps.bling.instructions.failed-token-step2"></p></div><div class="col-sm-12" style="padding-top: 4%; padding-bottom: 4%; padding-left: 0px"><a ng-click="vm.openDisconnectBlingModal()" style="margin-right: 3%; margin-bottom: 4%" type="button" class="btn btn-secondary"><span data-translate="settings.erps.bling.disconnectButtonTitle">Disconnect</span> </a><a ladda="vm.loading" type="button" ng-click="vm.reconnectBling()" data-ng-disabled="vm.islocked" class="btn btn-primary" style="margin-bottom: 4%">{{ \'settings.erps.bling.reconnectButtonTitle\' | translate }}</a></div></div></div><div class="col-sm-6"><h3 data-translate="settings.erps.bling.blingTitle" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.erps.bling.blingDescription"></p><a ng-href="https://www.bling.com.br/" target="_blank">{{ \'settings.erps.bling.knowMore\' | translate }}</a></div></div><div class="col-sm-12" style="text-align: center; padding-bottom: 2%; padding-top: 2%"><!-- <h4 data-translate="settings.paymentConfiguration.showkaseDescription"></h4> --></div>');
$templateCache.put('app/admin/settings/erps/erps-settings.html','<style>.Tab-title {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        column-gap: 4px;\n    }</style><div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-6"><p data-translate="settings.erps.desc">Aqui voc\xEA configura a integra\xE7\xE3o com lojas.</p></div></div><div class="clients-list"><ul class="nav nav-tabs"><li ng-class="{\'active\' : tab == 1}"><a class="Tab-title" ng-click="tab = 1" ng-init="tab = 1"><i class="fa fa-laptop"></i> <span data-translate="settings.erps.online-retail.title">Varejo online</span></a></li><li ng-show="true" ng-class="{\'active\' : tab == 2}"><a class="Tab-title" ng-click="tab = 2"><i class="fa fa-laptop"></i> <span data-translate="settings.erps.nexaas.title">Nexaas</span></a></li><li ng-show="true" ng-class="{\'active\' : tab == 3}"><a class="Tab-title" ng-click="tab = 3"><i class="fa fa-laptop"></i> <span data-translate="settings.erps.bling.title">Bling</span></a></li><li ng-show="true" ng-class="{\'active\' : tab == 4}"><a class="Tab-title" ng-click="tab = 4"><i class="fa fa-laptop"></i> <span data-translate="settings.erps.softcom.title">Softcom</span></a></li></ul><div class="tab-content"><div id="tab-1" class="tab-pane active" ng-show="tab == 1"><div class="panel-body" ng-include="\'app/admin/settings/erps/online-retail.html\'"></div></div><div id="tab-2" class="tab-pane active" ng-show="tab == 2" style="height: 100%"><div class="panel-body" ng-include="\'app/admin/settings/erps/nexaas.html\'"></div></div><div id="tab-3" class="tab-pane active" ng-show="tab == 3" style="height: 100%"><div class="panel-body" ng-include="\'app/admin/settings/erps/bling.html\'"></div></div><div id="tab-4" class="tab-pane active" ng-show="tab == 4" style="height: 100%"><div class="panel-body" ng-include="\'app/admin/settings/erps/softcom.html\'"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/settings/erps/nexaas.html','<style>.sub-title {\n        font-size: 1.0em;\n    }\n\n    md-select-menu md-content {\n        -webkit-overflow-scrolling: fixed !important;\n    }\n\n    .md-select-menu-container {\n        z-index: 3000 !important;\n    }\n\n    .custom-md-input md-input-container {\n        display: inherit;\n        margin: unset;\n    }\n\n    .custom-md-input md-select.md-default-theme .md-select-value,\n    md-select .md-select-value {\n        padding-left: 8px;\n        border-radius: 5px;\n        height: 31px;\n        border: 1px solid #e5e6e7;\n\n    }\n\n    .custom-select[multiple] .md-select-value span:first-child {\n        visibility: collapse;\n    }\n\n    .custom-select[multiple] .md-select-value .md-text {\n        display: inline-block !important;\n        visibility: visible;\n        background-color: rgb(224, 224, 224);\n        border-radius: 6px;\n        padding: 3px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected],\n    md-select-menu md-content md-option[selected] {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected]:focus,\n    md-select-menu md-content md-option[selected]:focus {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-checkbox-enabled.md-default-theme[selected] .md-icon,\n    .md-checkbox-enabled[selected] .md-icon {\n        background-color: var(--main-color) !important;\n    }\n\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\n    md-select-menu md-content md-option:not([disabled]):focus,\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\n    md-select-menu md-content md-option:not([disabled]):hover {\n        background: none;\n        border-bottom-color: #e5e6e7 !important;\n    }\n\n    md-select:not([disabled]):focus .md-select-value {\n        border-bottom-color: #e5e6e7 !important;\n        border-bottom-width: 1px !important;\n        height: 31px;\n    }\n\n    md-select[disabled] {\n        cursor: not-allowed !important;\n    }\n\n    .highlight {\n        background: #f3f3f4;\n        padding: 5px;\n        display: inline-block;\n        color: #5E5E5E;\n        border-radius: 10px;\n        padding-bottom: 2px;\n        padding-top: 2px;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    md-select-menu {\n        margin-top: 50px;\n        margin-left: 39px;\n        max-width: 90%;\n    }\n\n    .remove-dropdown {\n        display: none !important;\n    }\n\n    .empty-list md-select-menu {\n        margin-top: 42px;\n        width: 192.674px !important;\n        margin-left: -1px;\n    }\n\n    md-select.md-default-theme[disabled] .md-select-value,\n    md-select[disabled] .md-select-value {\n        background-image: none !important;\n        border-bottom-color: #e5e6e7 !important;\n    }\n\n    .form-control[disabled] {\n        background-color: unset !important;\n        opacity: 1;\n    }\n\n    select.minimal {\n        background-image:\n            linear-gradient(45deg, transparent 50%, gray 50%),\n            linear-gradient(135deg, gray 50%, transparent 50%),\n            linear-gradient(to right, #ccc, #ccc);\n        background-position:\n            calc(100% - 14px) calc(1em + 2px),\n            calc(100% - 9px) calc(1em + 2px),\n            calc(100% - 2.5em) 0.5em;\n        background-size:\n            4px 3px,\n            5px 4px,\n            0px 1.5em;\n        background-repeat: no-repeat;\n    }\n\n    select {\n        /* reset */\n        margin: 0;\n        -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        box-sizing: border-box;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n    }</style><div class="col-sm-6" style="padding-top: 15px"><div class="col-sm-12" style="padding-bottom: 4%"><a href="https://www.nexaas.com/" target="_blank"><img src="content/images/logo_nexaas.png" border="0" width="150px" height="100%"></a></div><h3 data-translate="settings.erps.nexaas.stepTitle"></h3><p data-translate="settings.erps.nexaas.step1"></p><div class="form-group col-sm-12"><label class="control-label required" for="token" data-translate="settings.erps.nexaas.token">Token</label><input id="token" required type="text" class="form-control" id="token" name="token" ng-model="vm.nexaas.token" ng-change="vm.getAllOrganizationsByToken()" ng-model-options="{ debounce: 500 }"></div><p data-translate="settings.erps.nexaas.step2"></p><div class="form-group col-sm-12"><label class="control-label" for="organizations" data-translate="settings.erps.nexaas.organization">Organization</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select md-select-only-option class="custom-select-value" ng-model="vm.nexaasOrganization" md-no-asterisk="true" ng-disabled="!vm.nexaas.token || vm.nexaas.token === \'\' || !vm.nexaasOrganizationList.length" ng-model-options="{trackBy: \'$value.id\'}" ng-change="vm.getNexaasOrganizationStocksByToken()"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="organization in vm.nexaasOrganizationList" ng-value="organization">{{organization.name}}</md-option></div></md-select></md-input-container></div></div><p data-translate="settings.erps.nexaas.step3"></p><div class="form-group col-sm-12"><label class="control-label" for="stocks" data-translate="settings.erps.nexaas.stock">Stock</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select md-select-only-option class="custom-select-value" ng-model="vm.nexaasStock" md-no-asterisk="true" ng-disabled="!vm.nexaas.token || vm.nexaas.token === \'\' || !vm.nexaasStockList.length || !vm.nexaasOrganization" ng-model-options="{trackBy: \'$value.id\'}" ng-change="vm.getNexaasSaleChannels()"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="stock in vm.nexaasStockList" ng-value="stock">{{stock.name}}</md-option></div></md-select></md-input-container></div></div><p data-translate="settings.erps.nexaas.step4"></p><div class="form-group col-sm-12"><label class="control-label" for="sale-channel" data-translate="settings.erps.nexaas.saleChannel">Sale Channel</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select md-select-only-option class="custom-select-value" ng-model="vm.nexaasSaleChannel" md-no-asterisk="true" ng-disabled="!vm.nexaas.token || vm.nexaas.token === \'\' || !vm.nexaasSaleChannelList.length || !vm.nexaasStock" ng-model-options="{trackBy: \'$value.id\'}" ng-change="vm.getNexaasPriceTables()"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="saleChannel in vm.nexaasSaleChannelList" ng-value="saleChannel">{{saleChannel.name}}</md-option></div></md-select></md-input-container></div></div><p data-translate="settings.erps.nexaas.step5"></p><div class="form-group col-sm-12"><label class="control-label" for="organizations" data-translate="settings.erps.online-retail.price-table">Price table</label><div class="dropdown custom-md-input" ng-click="$event.stopPropagation();"><md-input-container class="brand-select"><md-select md-select-only-option class="custom-select-value" ng-model="vm.nexaasPriceTable" md-no-asterisk="true" ng-disabled="!vm.nexaas.token || vm.nexaas.token === \'\' || !vm.nexaasPriceTableList.length || !vm.nexaasSaleChannel" ng-model-options="{trackBy: \'$value.id\'}"><div ng-mouseleave="vm.closeDropDown($event, true)"><md-option ng-repeat="priceTable in vm.nexaasPriceTableList" ng-value="priceTable">{{priceTable.name}}</md-option></div></md-select></md-input-container></div></div><div class="col-sm-12" style="padding-bottom: 4%"><button type="button" class="btn btn-primary" style="margin-right: 3%" ng-click="vm.createUpdateNexaas()" class="btn btn-primary" ng-disabled="vm.isSaving || (!vm.nexaas.token || vm.nexaas.token === \'\') || !vm.nexaasOrganization || !vm.nexaasStock.id || !vm.nexaasSaleChannel.id || !vm.nexaasPriceTable.id">{{ \'settings.form.button\' | translate }}</button> <button ng-show="vm.nexaas && vm.nexaas.id" type="button" class="btn btn-secondary" ng-click="vm.openDisconnectNexaasModal()"><span data-translate="settings.form.disconnect">Disconnect</span></button></div></div><div class="col-sm-6" style="padding-top: 15px"><h3 data-translate="settings.erps.nexaas.question" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.erps.nexaas.description"></p><p style="font-size: 15px; margin-bottom: 2%" data-translate="settings.erps.nexaas.description2"></p><a ng-href="https://www.nexaas.com/" target="_blank">{{ \'settings.store.payments.tabs.picpay.knowMore\' | translate }}</a></div></div>');
$templateCache.put('app/admin/settings/erps/online-retail.html','<style>.sub-title {\n        font-size: 1.0em;\n    }\n\n    md-select-menu md-content {\n        -webkit-overflow-scrolling: fixed !important;\n    }\n\n    .md-select-menu-container {\n        z-index: 3000 !important;\n    }\n\n    .custom-md-input md-input-container {\n        display: inherit;\n        margin: unset;\n    }\n\n    .custom-md-input md-select.md-default-theme .md-select-value,\n    md-select .md-select-value {\n        padding-left: 8px;\n        border-radius: 5px;\n        height: 31px;\n        border: 1px solid #e5e6e7;\n\n    }\n\n    .custom-select[multiple] .md-select-value span:first-child {\n        visibility: collapse;\n    }\n\n    .custom-select[multiple] .md-select-value .md-text {\n        display: inline-block !important;\n        visibility: visible;\n        background-color: rgb(224, 224, 224);\n        border-radius: 6px;\n        padding: 3px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected],\n    md-select-menu md-content md-option[selected] {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected]:focus,\n    md-select-menu md-content md-option[selected]:focus {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-checkbox-enabled.md-default-theme[selected] .md-icon,\n    .md-checkbox-enabled[selected] .md-icon {\n        background-color: var(--main-color) !important;\n    }\n\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\n    md-select-menu md-content md-option:not([disabled]):focus,\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\n    md-select-menu md-content md-option:not([disabled]):hover {\n        background: none;\n        border-bottom-color: #e5e6e7 !important;\n    }\n\n    md-select:not([disabled]):focus .md-select-value {\n        border-bottom-color: #e5e6e7 !important;\n        border-bottom-width: 1px !important;\n        height: 31px;\n    }\n\n    md-select[disabled] {\n        cursor: not-allowed !important;\n    }\n\n    .highlight {\n        background: #f3f3f4;\n        padding: 5px;\n        display: inline-block;\n        color: #5E5E5E;\n        border-radius: 10px;\n        padding-bottom: 2px;\n        padding-top: 2px;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    md-select-menu {\n        margin-top: 50px;\n        margin-left: 39px;\n        max-width: 90%;\n    }\n\n    .remove-dropdown {\n        display: none !important;\n    }\n\n    .empty-list md-select-menu {\n        margin-top: 42px;\n        width: 192.674px !important;\n        margin-left: -1px;\n    }\n\n    md-select.md-default-theme[disabled] .md-select-value,\n    md-select[disabled] .md-select-value {\n        background-image: none !important;\n        border-bottom-color: #e5e6e7 !important;\n    }\n\n    .form-control[disabled] {\n        background-color: unset !important;\n        opacity: 1;\n    }\n\n    select.minimal {\n        background-image:\n            linear-gradient(45deg, transparent 50%, gray 50%),\n            linear-gradient(135deg, gray 50%, transparent 50%),\n            linear-gradient(to right, #ccc, #ccc);\n        background-position:\n            calc(100% - 14px) calc(1em + 2px),\n            calc(100% - 9px) calc(1em + 2px),\n            calc(100% - 2.5em) 0.5em;\n        background-size:\n            4px 3px,\n            5px 4px,\n            0px 1.5em;\n        background-repeat: no-repeat;\n    }\n\n    select {\n        /* reset */\n        margin: 0;\n        -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        box-sizing: border-box;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n    }\n\n    force-single-line {\n        min-width: max-content; \n        margin-right: 10px;\n    }</style><div class="col-sm-6" style="padding-top: 15px"><div class="col-sm-12" style="padding-bottom: 4%"><a href="https://www.varejonline.com.br" target="_blank"><img src="content/images/configuration-erp-retail-online.png" border="0" width="150px" height="100%"></a></div><h3 data-translate="settings.erps.online-retail.stepTitle"></h3><!-- ################### TOKEN ################### --><p data-translate="settings.erps.online-retail.step1"></p><div class="row col-md-12 col-xs-12" style="margin-top: 5px; margin-bottom: 5px; margin-left: 0px; margin-right: 0px; column-gap: unset"><label class="control-label required" for="token" data-translate="settings.erps.online-retail.token">Token</label><input id="token" required type="text" class="form-control" id="token" name="token" ng-change="vm.getAllEntitiesByToken(); vm.getPriceTablesByToken(); vm.getOnlineRetailCategoryLevelList();" ng-model="vm.onlineRetail.token" ng-model-options="{ debounce: 500 }"></div><!-- ################### ENTITY ################### --><p data-translate="settings.erps.online-retail.step2"></p><div class="row col-md-12 col-xs-12" style="margin-top: 5px; margin-bottom: 5px; margin-left: 0px; margin-right: 0px; column-gap: unset"><label class="control-label required" for="entities" data-translate="settings.erps.online-retail.entities">Entities</label><select id="entities" name="entities" type="text" class="form-control minimal" ng-model="vm.selectedEntity" ng-change="vm.getPriceTablesByToken(); vm.getOnlineRetailBankAccounts(); vm.getOnlineRetailSellers();" ng-disabled="!vm.onlineRetail.token || vm.onlineRetail.token === \'\' || !vm.entitiesList.length" ng-options="item as item.nome for item in vm.entitiesList track by item.id" required></select></div><!-- ################### PRICE TABLE ################### --><p data-translate="settings.erps.online-retail.step3"></p><div class="row col-md-12 col-xs-12" style="margin-top: 5px; margin-bottom: 5px; margin-left: 0px; margin-right: 0px; column-gap: unset"><label class="control-label required" for="price-table" data-translate="settings.erps.online-retail.price-table">Price table</label><select id="price-table" name="price-table" type="text" class="form-control minimal" ng-model="vm.priceTable" ng-disabled="!vm.onlineRetail.token || vm.onlineRetail.token === \'\'" ng-change="vm.changePriceTable();" ng-options="value as value.nome for value in vm.priceTableList" required></select></div><!-- ################### PROMOTIONAL PRICE TABLE ################### --><p data-translate="settings.erps.online-retail.step3-1"></p><div class="row col-md-12 col-xs-12" style="margin-top: 5px; margin-bottom: 5px; margin-left: 0px; margin-right: 0px; column-gap: unset"><label class="control-label" for="price-table" data-translate="settings.erps.online-retail.promotional-price-table">Promotional price table</label><select id="promotional-price-table" name="promotional-price-table" type="text" class="form-control minimal" ng-model="vm.promotionalPriceTable" ng-disabled="!vm.onlineRetail.token || vm.onlineRetail.token === \'\'" required ng-options="value as value.nome for value in vm.promotionalPriceTableList"></select></div><p data-translate="settings.erps.online-retail.step4" style="min-width: 160px"></p><div ng-if="vm.selectedBankAccount || vm.selectedSeller" class="row col-md-12 col-xs-12" style="margin-top: 5px; margin-bottom: 5px; margin-left: 0px; margin-right: 0px"><!-- ################### BANK ACCOUNT ################### --><div ng-if="vm.selectedBankAccount" class="col-md-6 col-xs-6" style="padding-left: 0px"><label class="control-label" for="bank-acounts" data-translate="settings.erps.online-retail.modal.order.bank-account">Bank Acounts</label><p id="bank-accounts" name="bank-accounts">{{ vm.selectedBankAccount.nome }}</p></div><!-- ################### DEFAULT SELLER ################### --><div ng-if="vm.selectedSeller" class="col-md-6 col-xs-6" style="padding-left: 0px; padding-right: 0px"><label class="control-label" for="seller" data-translate="settings.erps.online-retail.modal.order.default-seller">Default Seller</label><p id="useSimulation" name="useSimulation">{{ vm.selectedSeller.nome }}</p></div></div><!-- ################### USE SIMULATION ################### --><div ng-if="vm.selectedSeller" class="row col-md-12 col-xs-12" style="margin-top: 5px; margin-bottom: 10px; margin-left: 0px; margin-right: 0px; column-gap: unset"><label class="control-label" for="useSimulation" data-translate="settings.erps.online-retail.modal.order.use-simulation">Enviar pedido a combinar como or\xE7amento</label><p id="useSimulation" name="useSimulation">{{ vm.onlineRetail.useSimulation ? \'ATIVADO\' : \'DESATIVADO\'}}</p></div><!-- ################### USERS ASSOCIATION TABLE ################### --><div class="col-md-12 col-xs-12" ng-if="vm.userLinksView && vm.userLinksView.length > 0" style="margin-top: 5px; margin-bottom: 10px; margin-left: 0px; margin-right: 0px"><label class="control-label" data-translate="settings.erps.online-retail.modal.order.linked-users">Linked Users</label><table class="table caption-top table-striped"><thead><tr><th scope="col" data-translate="settings.erps.online-retail.modal.order.showkase-user">Showkase User</th><th scope="col"></th><th scope="col" data-translate="settings.erps.online-retail.modal.order.online-retail-user">ERP Users</th></tr></thead><tbody><tr ng-repeat="link in vm.userLinksView"><td>{{ link.showkaseName }}</td><td style="-webkit-transform: rotate(90deg); text-align: center; vertical-align: middle"><i class="icon-ksc-arrow-down-arrow-up-solid"></i></td><td>{{ link.onlineRetailName }}</td></tr></tbody></table></div><div class="col-md-12 col-xs-12"><div class="display-horizontally-inline alert alert-warning no-templates-box" style="column-gap: 10px"><i class="fa fa-warning cost-icon" style="color: #fdbe2d; font-size: 20px" aria-hidden="true"></i><p class="m-0 cost-text ng-scope" data-translate="settings.erps.online-retail.messages.order-settings-warning"></p></div></div><!-- ################### OPEN ORDER CONFIG MODAL ################### --><div class="form-group row col-md-12 col-sm-12"><button type="button" class="btn btn-secondary pull-right" class="col-xs-12" ng-click="vm.openOnlineRetailOrderConfigModal()"><span data-translate="settings.erps.online-retail.order-setting">Order Settings</span></button></div><p class="row col-md-12 col-sm-12" data-translate="settings.erps.online-retail.step6"></p><!-- ################### BASE CATEGORY KEY ################### --><div class="row col-md-12 col-xs-12" style="margin-top: 5px; margin-bottom: 10px; margin-left: 0px; margin-right: 0px; column-gap: unset"><label class="control-label required" for="baseCategoryKey" style="min-width: max-content; margin-right: 10px" data-translate="settings.erps.online-retail.base-category-key" required>Base Category Key</label><select id="category-level" name="category-level" type="text" class="form-control minimal" ng-model="vm.selectedCategoryLevel" ng-disabled="!vm.categoryLevelList.length" ng-options="item as item.nome for item in vm.categoryLevelList track by item.id" required></select></div><!-- ################### BASE BRAND KEY ################### --><div class="row col-md-12 col-xs-12" style="margin-top: 5px; margin-bottom: 10px; margin-left: 0px; margin-right: 0px; column-gap: unset"><label class="control-label" for="baseCategoryKey" style="min-width: max-content; margin-right: 10px" data-translate="settings.erps.online-retail.base-brand-key">Base Brand Key</label><select id="category-level" name="category-level" type="text" class="form-control minimal" ng-model="vm.selectedBrandLevel" ng-disabled="!vm.categoryLevelList.length" ng-options="item as item.nome for item in vm.categoryLevelList track by item.id"></select></div><div class="row col-md-12 col-xs-12" style="margin-top: 5px; margin-bottom: 10px; margin-left: 0px; margin-right: 0px; column-gap: unset"><label class="control-label" data-translate="settings.erps.online-retail.modal.product.sync-params">Product Sync Params</label></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.onlyEcommerce"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.online-retail.modal.product.ecommerceAvailability"></span></label></div></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="col-md-4 col-xs-4" style="padding-left: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.syncName"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.online-retail.modal.product.name"></span></label></div></div><div class="col-md-4 col-xs-4" style="padding-left: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.syncDescription"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.online-retail.modal.product.description"></span></label></div></div><div class="col-md-4 col-xs-4" style="padding-left: 0px; padding-right: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.roundPrice"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.online-retail.modal.product.round-price"></span></label></div></div></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="col-md-4 col-xs-4" style="padding-left: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.syncImage"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.online-retail.modal.product.image"></span></label></div></div><div class="col-md-4 col-xs-4" style="padding-left: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.syncBrand"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.online-retail.modal.product.brand"></span></label></div></div><div class="col-md-4 col-xs-4" style="padding-left: 0px; padding-right: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.syncCategory"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.online-retail.modal.product.category"></span></label></div></div></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="col-md-4 col-xs-4" style="padding-left: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.syncTags"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.online-retail.modal.product.tags"></span></label></div></div></div><p class="row col-md-12 col-sm-12" data-translate="settings.erps.online-retail.step7" style="margin-top: 15px"></p><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.inventoryThreshold"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.erps.online-retail.inventory-threshold-checkbox"></span></label></div></div><!-- ################### INVENTORY THRESHOLD ################### --><div ng-if="vm.inventoryThreshold" class="row col-md-12 col-xs-12" style="margin-top: 5px; margin-bottom: 10px; margin-left: 0px; margin-right: 0px; column-gap: unset"><label class="control-label" for="inventory-threashold" style="min-width: max-content; margin-right: 10px" data-translate="settings.erps.online-retail.inventory-threashold" required>Inventory Threshold</label><input id="inventory-threashold" name="inventory-threashold" type="text" class="form-control" numbers-only ng-model="vm.onlineRetail.inventoryThreshold"></div><div ng-if="vm.inventoryThreshold" class="col-md-12 col-xs-12"><div class="display-horizontally-inline alert alert-warning no-templates-box" style="column-gap: 10px; background-color: #d4eaf5; color: #3fafeb; border: solid 1px #3fafeb"><i class="fa fa-warning cost-icon" style="color: #3fafeb; font-size: 20px" aria-hidden="true"></i><p class="m-0 cost-text ng-scope" style="color: #3fafeb" data-translate="settings.erps.online-retail.inventory-threshold-warning"></p></div></div><div class="col-sm-12" style="margin-bottom: 4%"><button type="button" class="btn btn-primary" style="margin-right: 3%; margin-top: 4%" ng-disabled="(!vm.onlineRetail.token || vm.onlineRetail.token === \'\') || !vm.selectedEntity.id\n            || !vm.priceTable.id || vm.isLoadingPriceTable || !vm.selectedBankAccount || !vm.selectedSeller \n            || !vm.selectedCategoryLevel || vm.onlineRetail.integrationStartedAt" ng-click="vm.createUpdateOnlineRetail()">{{ \'settings.form.button\' | translate }}</button> <button ng-show="vm.onlineRetail && vm.onlineRetail.id" type="button" class="btn btn-secondary" style="margin-right: 3%; margin-top: 4%" ng-click="vm.openDisconnectOnlineRetailModal()"><span data-translate="settings.form.disconnect">Disconnect</span></button> <button ng-if="false" type="button" class="btn btn-secondary" style="margin-right: 3%; margin-top: 4%" ng-click="vm.openOnlineRetailOrderConfigModal()"><span data-translate="settings.form.reprocess">Reprocess</span></button></div><div class="col-sm-12 col-dm-12"><p ng-if="vm.onlineRetail.id && !vm.onlineRetail.integrationStartedAt && vm.onlineRetail.lastIntegrationDate" data-translate="settings.erps.online-retail.reprocess-date" translate-values="{date: \'{{vm.onlineRetail.lastIntegrationDate}}\'}" class="c-gray"></p><p ng-if="vm.onlineRetail.id && vm.onlineRetail.integrationStartedAt" data-translate="settings.erps.online-retail.loading" class="c-gray"></p><p ng-if="vm.onlineRetail.id && !vm.onlineRetail.integrationStartedAt\n            && !vm.onlineRetail.lastIntegrationDate && vm.onlineRetail.status === \'NEW\'" data-translate="settings.erps.online-retail.reprocess-queue" class="c-gray"></p></div></div><div class="col-sm-6" style="padding-top: 15px"><h3 data-translate="settings.erps.online-retail.question" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.erps.online-retail.description"></p><p style="font-size: 15px; margin-bottom: 2%" data-translate="settings.erps.online-retail.description2"></p><a ng-href="https://www.varejonline.com.br/" target="_blank">{{ \'settings.store.payments.tabs.picpay.knowMore\' | translate }}</a></div></div>');
$templateCache.put('app/admin/settings/erps/softcom.html','<div class="col-sm-6"><div class="row col-sm-12" style="padding-bottom: 4%"><img class="row" src="/content/images/softcom.png" width="300px" height="100%"></div><div class="row" ng-show="!vm.softcom && !vm.softcom.id"><div class="row col-md-12"><h3 data-translate="settings.erps.softcom.stepTitle"></h3><p data-translate="settings.erps.softcom.step1"></p></div><div class="col-sm-12" style="padding-top: 4%; padding-bottom: 4%; padding-left: 0px"><a ladda="vm.loading" type="button" ng-click="vm.createSoftcom()" data-ng-disabled="vm.islocked" class="btn btn-primary" style="margin-bottom: 4%">{{ \'settings.erps.softcom.requestToken\' | translate }}</a></div></div><div class="row" ng-if="vm.softcom && vm.softcom.id"><div class="col-md-12"><h3 data-translate="settings.erps.softcom.stepTitle"></h3><p data-translate="settings.erps.softcom.step1"></p><p data-translate="settings.erps.softcom.step2"></p><p data-translate="settings.erps.softcom.step3"></p><div ng-if="vm.store.storeId" class="col-md-12" style="margin-bottom: 10px"><label class="control-label" for="store-id" data-translate="settings.erps.softcom.storeId">Store ID</label><div class="row" style="line-height: 30px"><div class="col-md-10"><input type="text" style="background-color: #f3f3f4 !important" class="form-control" id="store-id" ng-disabled="true" name="store-id" ng-model="vm.store.storeId"></div><div class="col-md-2" style="line-height: 30px; display: inline-block; vertical-align: middle" ng-click="vm.copiedToClipboard()"><a class="ng-scope" uib-tooltip="{{\'settings.erps.softcom.tooltip\' | translate}}" copy-to-clipboard="{{vm.store.storeId}}">{{ \'settings.erps.softcom.copy\' | translate }} <i class="fa fa-files-o" aria-hidden="true"></i></a></div></div></div><div ng-if="vm.softcom.token" class="col-md-12" style="margin-bottom: 10px"><label class="control-label" for="integration-token" data-translate="settings.erps.softcom.integrationToken">Token de integra\xE7\xE3o</label><div class="row" style="line-height: 30px"><div class="col-md-10"><input type="text" style="background-color: #f3f3f4 !important" class="form-control" id="integration-token" ng-disabled="true" name="integration-token" ng-model="vm.softcom.token"></div><div class="col-md-2" style="line-height: 30px; display: inline-block; vertical-align: middle" ng-click="vm.copiedToClipboard()"><a class="ng-scope" uib-tooltip="{{\'settings.erps.softcom.tooltip\' | translate}}" copy-to-clipboard="{{vm.softcom.token}}">{{ \'settings.erps.softcom.copy\' | translate }} <i class="fa fa-files-o" aria-hidden="true"></i></a></div></div></div></div><div class="col-sm-12" style="padding-top: 4%; padding-bottom: 4%; padding-left: 0px"><a ng-click="vm.openDisconnectSoftcomModal()" style="margin-right: 3%; margin-bottom: 4%" type="button" class="btn btn-secondary" ng-show="vm.softcom && vm.softcom.id"><span data-translate="settings.erps.softcom.disconnectButtonTitle">Disconnect</span></a></div></div></div><div class="col-sm-6"><h3 data-translate="settings.erps.softcom.softcomTitle" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.erps.softcom.softcomDescription"></p><a ng-href="https://softcomtecnologia.com.br/" target="_blank">{{ \'settings.erps.softcom.knowMore\' | translate }}</a></div></div><div class="col-sm-12" style="text-align: center; padding-bottom: 2%; padding-top: 2%"><!-- <h4 data-translate="settings.paymentConfiguration.showkaseDescription"></h4> --></div>');
$templateCache.put('app/admin/settings/marketing/abandoned-cart.html','<style>.no-templates-box {\n        display: flex;\n        align-items: center;\n        border-radius: 5px;\n    }\n\n    .cost-box {\n        display: flex;\n        align-items: center;\n        color: var(--main-color-light);\n        background-color: #dfd7ed;\n        border-radius: 5px;\n    }\n\n    .cost-text {\n        font-size: 12px;\n        text-align: justify;\n        opacity: 1;\n        padding: 10px;\n        font-weight: 400;\n    }\n\n    .cost-icon {\n        font-size: xx-large;\n        -moz-transform: scale(-1, 1);\n        -webkit-transform: scale(-1, 1);\n        -o-transform: scale(-1, 1);\n        -ms-transform: scale(-1, 1);\n        transform: scale(-1, 1);\n    }\n\n    .more-about {\n        color: var(--main-color-light);\n        font-weight: bold;\n        text-decoration: underline;\n    }\n\n    .more-about:hover {\n        color: var(--main-color);\n        font-weight: bold;\n        text-decoration: underline;\n    }\n\n    .notification-item {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 5px 15px 5px 15px;\n        border-radius: 10px;\n        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n    }\n\n    .credit-container {\n        display: flex;\n        justify-content: flex-end;\n    }\n\n    .credit-wallet-icon {\n        color: var(--main-color-light);\n        font-size: 3.5em\n    }\n\n    .credit-value {\n        font-weight: bold;\n    }\n\n    .btn-outline {\n        font-size: small;\n        color: var(--main-color-light);\n        border: 1px solid;\n        border-radius: 10px !important;\n        padding: 1px 25px;\n    }\n\n    .btn-outline:hover {\n        color: var(--main-color);\n    }</style><div class="col-sm-12"><h1 data-translate="settings.marketing.abandoned-cart.notifications-title"></h1><p data-translate="settings.marketing.abandoned-cart.notifications-subtitle" style="text-align: justify"></p></div><form name="vm.abandonedCartNotifierForm" role="form" novalidate show-validation ng-submit="vm.createUpdateAbandonedCartNotifier()"><div class="col-md-6 col-xs-12" ng-class="{\'p-0 m-b-md\': vm.isMobile}"><div class="col-md-12 m-b-lg" ng-class="{\'p-0\': vm.isMobile}"><div class="col-sm-12 alert alert-warning no-templates-box" ng-if="!vm.isWATIConnected"><i class="fa fa-warning cost-icon" style="color: #fdbe2d" aria-hidden="true"></i><p class="m-0 cost-text ng-scope" data-translate="settings.marketing.abandoned-cart.wati-disconnected" translate-values="{ whatsappRedirect: vm.connectWATIMessage }"></p></div><div ng-repeat="notification in vm.notifications track by $index" style="margin-top: 15px"><div class="notification-item"><div style="display: flex; align-items: center"><md-switch ng-model="notification.isEnabled" md-no-ink="true" ng-disabled="!vm.isWATIConnected" ng-change="vm.disableNotification(notification)"></md-switch><div class="m-l-sm"><b style="font-size: 14px">Notifica\xE7\xE3o #{{$index + 1}}</b><div><span data-translate="settings.marketing.abandoned-cart.notification-item-subtitle" translate-value-time="{{notification.time}}" translate-value-unity="{{notification.unity}}"></span></div></div></div><div style="display: flex; flex-direction: row"><span class="fa fa-pencil-square-o" style="margin-right: 14px; color: #676a6cd6; font-size: 15px" ng-if="vm.templates.length" ng-click="vm.getNotificationById(notification.id)"></span> <span class="fa fa-trash" style="margin-right: 8px; color: #676a6cd6; font-size: 15px" ng-click="vm.deleteNotification(notification.id)"></span></div></div></div><div ng-if="!vm.activeForm && vm.notifications.length && vm.templates.length" class="col-sm-12 m-t-md p-0"><button type="button" class="btn btn-primary pull-right" ng-click="vm.openCreateNotificationForm()" data-translate="settings.marketing.abandoned-cart.form.create-notification">Add</button></div></div><div class="col-sm-12 alert alert-warning no-templates-box" ng-if="!vm.templates.length && !vm.loadingTemplates && vm.isWATIConnected"><i class="icon-ksc-finaluser-seller cost-icon" aria-hidden="true"></i><p class="m-0 cost-text ng-scope" data-translate="settings.marketing.abandoned-cart.empty-list"></p></div><div id="abandoned-cart-form" class="col-md-12 p-0" ng-show="(vm.activeForm || !vm.notifications.length) && vm.templates.length"><div class="form-group col-md-12 col-xs-12"><label class="control-label required" for="template" data-translate="settings.marketing.abandoned-cart.form.message-input"></label><select id="template" name="template" type="text" class="form-control minimal" ng-model="vm.form.template" ng-value="vm.form.template" ng-change="vm.selectTemplate()" ng-options="item as item.elementName for item in vm.templates track by item.id" required></select></div><div class="form-group col-md-12 col-xs-12" ng-if="vm.templateHasCoupon"><label class="control-label required" for="discountCoupon" data-translate="settings.marketing.abandoned-cart.form.discount-coupon"></label><input id="discountCoupon" type="text" name="discountCoupon" class="form-control minimal" ng-model="vm.form.discountCoupon" placeholder="Ex.: CUPOM50OFF" required></div><div class="form-group col-md-12 col-xs-12"><label class="control-label required" for="template" data-translate="settings.marketing.abandoned-cart.form.when-send-time"></label><select id="notifyTime" name="notifyTime" type="text" class="form-control minimal" ng-model="vm.form.notifyTime" required value="{{vm.form.notifyTime}}" ng-options="item as item.label for item in vm.notifyTimes track by item.code"><option ng-repeat="item in vm.notifyTimes track by $index" value="{{item.code}}">{{item.time}} {{\'settings.marketing.abandoned-cart.form.\' + item.unity.toLowerCase() | translate}}</option></select></div><div ng-show="vm.abandonedCartNotifierForm" class="col-sm-12" style="margin-top: 15px; margin-left: 14px"><button id="add-notification" ladda="vm.isSaving" type="submit" class="btn btn-primary pull-right" data-translate="global.form.save" ng-disabled="vm.abandonedCartNotifierForm.$invalid">Add</button> <button ladda="vm.isSaving" type="button" class="btn btn-primary mr-2 btn btn-default btn-md cancel-button pull-right" ng-click="vm.cancelForm()" data-translate="global.messages.remove.cancel">Cancel</button></div></div></div><div class="col-md-6 col-xs-12"><h3 data-translate="settings.marketing.abandoned-cart.about-title" style="padding-bottom: 2%"></h3><div class="col-sm-12 info-box" style="overflow: hidden"><p style="font-size: 15px; text-align: justify" data-translate="settings.marketing.abandoned-cart.about-description"></p><div class="col-sm-12 cost-box"><i class="icon-ksc-comment-exclamation-regular cost-icon" aria-hidden="true"></i><p class="m-0 cost-text" data-translate="settings.marketing.abandoned-cart.about-cost"></p></div><div class="col-sm-12 credit-container m-t-xl" ng-if="vm.WATICredits"><i class="icon-ksc-wallet-solid credit-wallet-icon"></i><div class="text-muted m-l-xs"><p class="m-0" data-translate="settings.marketing.abandoned-cart.wati-balance"></p><h2 class="credit-value m-0">$ {{vm.WATICredits}}</h2></div></div><a ng-if="vm.isWATIConnected" ng-href="{{vm.buyWATICreditsMessage}}" class="btn btn-outline m-t-xs pull-right" target="_blank" data-translate="settings.marketing.abandoned-cart.buy-credits"></a></div></div></form>');
$templateCache.put('app/admin/settings/marketing/marketing-settings.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-6"><p data-translate="settings.marketing.desc">Aqui voc\xEA configura o Marketing da loja.</p></div></div><div class="clients-list"><ul class="nav nav-tabs"><li ng-class="{\'active\' : tab == 1}"><a class="Tab-title" ng-click="tab = 1" ng-init="tab = 1"><i class="fa fa-shopping-cart"></i> <span data-translate="settings.marketing.abandoned-cart.title">Carrinho Abandonado</span></a></li></ul><div class="tab-content"><div id="tab-1" class="tab-pane active" ng-show="tab == 1"><div class="panel-body" ng-include="\'app/admin/settings/marketing/abandoned-cart.html\'"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/settings/payments/card-boleto.html','<div class="row" style="padding: 0px 15px"><h1 data-translate="settings.store.payments.tabs.pagarMe.main-title">Meios de pagamentos</h1><p data-translate="settings.store.payments.tabs.pagarMe.main-description">Utilize um meio de pagamento para cobrar e receber suas vendas.</p></div><div class="row"><div class="col-md-12 form-group"><md-radio-group ng-disabled="vm.pagarMeAccount.id" ng-model="vm.pagarMeIntegrationType" layout="row"><md-radio-button aria-label="Ativo" class="my-radio" ng-value="\'SHOWKASE_PAY\'"><span class="radio-label">Criar conta no Pagar.me</span></md-radio-button><md-radio-button aria-label="Inativo" class="my-radio" ng-value="\'V5\'"><span class="radio-label">Integrar com conta existente do Pagar.me</span></md-radio-button></md-radio-group></div></div><div ng-if="vm.pagarMeIntegrationType === \'SHOWKASE_PAY\'" class="row payment-tab-content" style="padding: 0 15px; justify-content: flex-start; margin-bottom: 20px"><!-- Card pagar_me --><div class="col-md-6 card-method-paymant" style="margin-bottom: 10px" ng-class="{\'card-method-paymant-selected\' : vm.checkoutMethod === \'PAGAR_ME\'}"><div style="display: flex; justify-content: space-between"><div><img style="height: 40px; margin-top: 15px" src="content/images/pagarme.png"></div><div style="display: flex; flex-direction: column; align-items: flex-end"><p class="tag-recommend"><span class="fa fa-star" style="color:#fdbe2d"></span> Recomendado</p><p style="margin: 0px; font-size: 11px">Taxas exclusivas para clientes Showkase</p><p style="font-size: 11px">e checkout transparente</p></div></div><!-- Line 1 --><div class="row"><p style="margin-left: 15px; margin-bottom: 6px"><span class="payment-icon"><i class="fa fa-credit-card-alt" aria-hidden="true"></i> </span>Cr\xE9dito (Visa e MasterCard)</p><div class="col-md-3"><p class="sub-title-info">Cr\xE9dito avista</p><h3 class="title-info-payment">3,38%<span class="subtitle-info-payment">(1x)</span></h3></div><div class="col-md-3"><p class="sub-title-info">Parcelado</p><h3 class="title-info-payment">3,70%<span class="subtitle-info-payment">(2x - 6x)</span></h3></div><div class="col-md-3"><p class="sub-title-info">Parcelado</p><h3 class="title-info-payment">3,97%<span class="subtitle-info-payment">(7x - 12x)</span></h3></div><div class="col-md-3"><p class="sub-title-info">Retire seu dinheiro</p><h3 class="title-info-payment">em 30 dias</h3></div></div><!-- Line 2 --><div class="row" style="margin-top: 15px; margin-bottom: 6px"><p style="margin-left: 15px; margin-bottom: 6px"><span class="payment-icon"><i class="fa fa-barcode" aria-hidden="true"></i> </span>Boleto</p><div class="col-md-3"><p class="sub-title-info">Pague</p><h3 class="title-info-payment">R$ 3,19</h3></div><div class="col-md-3"><p class="sub-title-info">Retire seu dinheiro</p><h3 class="title-info-payment">em 30 dias</h3></div><div class="col-md-6"></div></div><!-- Line 3 --><div class="row" style="margin-top: 15px; margin-bottom: 6px"><div class="row"><p class="col-md-6" style="margin-left: 15px; margin-bottom: 6px"><span class="payment-icon"><i class="fa fa-info-circle" aria-hidden="true"></i> </span>Taxas de servi\xE7os</p><div class="col-md-6"></div></div><div class="col-md-3"><p class="sub-title-info">Gateway</p><h3 class="title-info-payment">R$ 0,44</h3></div><div class="col-md-3"><p class="sub-title-info">Antifraude</p><h3 class="title-info-payment">R$ 0,55</h3></div><div class="col-md-3"><p class="sub-title-info">Taxa de Transfer\xEAncia</p><h3 class="title-info-payment">R$ 3,67</h3></div><div class="col-md-3" style="margin-top: 5px"><button id="btnCreateFlyer" class="btn btn-primary btn-large" style="width: 100%" ng-click="vm.changeMethodPaymant(\'PAGAR_ME\')" ng-if="!vm.pagarme" ng-disabled="vm.checkoutMethod === \'PAGAR_ME\'" data-style="slide-left"><span>Configurar</span></button></div></div><div class="row" style="min-height: 10px"></div></div><div class="col-md-6 col-sm-6" style="padding-top: 15px"><h3 style="padding-bottom: 2%" data-translate="settings.store.payments.tabs.pagarMe.pagarMeTitle">O que \xE9 o Pagar.me</h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.store.payments.tabs.pagarMe.pagarMeDescription"></p><p style="font-size: 15px; margin-bottom: 2%" data-translate="settings.store.payments.tabs.pagarMe.pagarMeDescription2"></p><a ng-href="https://pagar.me" target="_blank">{{ \'settings.store.payments.tabs.picpay.knowMore\' | translate }}</a></div></div></div><div ng-if="vm.pagarMeIntegrationType === \'V5\' || (vm.pagarMeAccount && vm.pagarMeAccount.apiVersion !== \'SHOWKASE_PAY\')"><div class="col-md-6 col-sm-6" style="margin-bottom: 10px"><h2 class="sc-default-title-store-font">Configura\xE7\xE3o do PagarMe</h2><div ng-if="vm.pagarMeAccount.accountId" class="display-horizontally-inline"><p style="margin-bottom: unset">Sua conta est\xE1 configurada via Token de integra\xE7\xE3o.</p><i class="fa fa-check-circle" style="font-size: 20px; color: #18a018"></i></div><div ng-if="vm.pagarMeAccount.accountId" class="display-horizontally-inline"><p style="margin-bottom: unset">Agora seus clientes podem utilizar o Cart\xE3o de Cr\xE9dito como forma de pagamento em sua loja.</p></div><div ng-if="vm.pagarMeAccount.accountId" class="col-md-12 col-sm-12" style="margin-top: 10px"><label class="control-label" for="account-id">ID da Conta</label><input type="text" class="form-control" id="account-id" ng-disabled="true" ng-model="vm.pagarMeAccount.accountId"></div><div ng-if="vm.pagarMeAccount.installId" class="col-md-12 col-sm-12" style="margin-top: 10px"><label class="control-label" for="install-id">ID da Instala\xE7\xE3o</label><input type="text" class="form-control" id="install-id" ng-disabled="true" ng-model="vm.pagarMeAccount.installId"></div><div ng-if="!vm.pagarMeAccount.installId" class="display-horizontally-inline"><p style="margin-bottom: unset">Integre sua conta Pagar.me \xE0 sua loja Showkase para processar pagamentos de forma segura e eficiente. Com a integra\xE7\xE3o, as taxas cobradas por transa\xE7\xE3o ser\xE3o exatamente as mesmas negociadas diretamente com o Pagar.me, sem necessidade de ajustes adicionais.</p></div><div ng-if="!vm.pagarMeAccount.installId" class="col-md-12 col-sm-12" style="margin-top: 10px"><button id="btnPagarMeIntegration" class="btn btn-primary btn-large" ng-click="vm.authorizePagarMe()" data-style="pull-right" style="min-width:150px"><span>Integrar com o Pagar.Me</span></button></div></div><div class="col-md-6 col-sm-6" style="padding-top: 15px"><h3 style="padding-bottom: 2%" data-translate="settings.store.payments.tabs.pagarMe.pagarMeTitle">O que \xE9 o Pagar.me</h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.store.payments.tabs.pagarMe.pagarMeDescription"></p><p style="font-size: 15px; margin-bottom: 2%" data-translate="settings.store.payments.tabs.pagarMe.pagarMeDescription2"></p><a ng-href="https://pagar.me" target="_blank">{{ \'settings.store.payments.tabs.picpay.knowMore\' | translate }}</a></div></div></div><div ng-if="vm.pagarMeIntegrationType === \'SHOWKASE_PAY\' && vm.pagarMeAccount.apiVersion === \'SHOWKASE_PAY\' && (vm.checkoutMethod === \'PAGAR_ME\' || vm.checkoutMethod === \'NONE\')"><div class="col-md-6 col-sm-6" style="padding-top: 15px"><form name="vm.pagarmeForm" ng-if="!vm.isLoading"><!-- Dados --><div class="row"><div class="col-md-12"><h1 class="sc-default-title-store-font" data-translate="settings.store.payments.tabs.pagarMe.form.identification-title">Identifica\xE7\xE3o</h1><p data-translate="settings.store.payments.tabs.pagarMe.form.identification-desc">Escolha o tipo de pessoa e preencha o documento</p></div></div><div ng-if="vm.pagarMeAccount" class="row"><div class="col-md-6 col-xs-12"><p><b data-translate="settings.store.payments.tabs.pagarMe.form.credit-card-active">Cart\xE3o de cr\xE9dito ativo?</b></p><md-switch ng-disabled="!vm.pagarMeAccount.id" ng-model="vm.pagarMeAccount.isCreditCardEnabled" ng-change="vm.activateDeactivatePayment(vm.pagarMeAccount.id, \'CREDIT_CARD\', vm.pagarMeAccount)"><span ng-if="vm.pagarMeAccount.isCreditCardEnabled" data-translate="settings.store.payments.tabs.pagarMe.form.yes">Sim </span><span ng-if="!vm.pagarMeAccount.isCreditCardEnabled" data-translate="settings.store.payments.tabs.pagarMe.form.no">N\xE3o</span></md-switch></div><div class="col-md-6 col-xs-12"><p><b data-translate="settings.store.payments.tabs.pagarMe.form.boleto-active">Boleto ativo?</b></p><md-switch ng-disabled="!vm.pagarMeAccount.id" ng-model="vm.pagarMeAccount.isBoletoEnabled" ng-change="vm.activateDeactivatePayment(vm.pagarMeAccount.id, \'BOLETO\', vm.pagarMeAccount)"><span ng-if="vm.pagarMeAccount.isBoletoEnabled" data-translate="settings.store.payments.tabs.pagarMe.form.yes">Sim </span><span ng-if="!vm.pagarMeAccount.isBoletoEnabled" data-translate="settings.store.payments.tabs.pagarMe.form.no">N\xE3o</span></md-switch></div></div><div class="row m-t-sm"><div class="col-md-12"><div class="row"><br><div class="form-group col-md-12"><md-radio-group ng-init="vm.pagarme.registerInformation.type = \'individual\'" ng-model="vm.pagarme.registerInformation.type" style="display: flex"><md-radio-button class="my-radio" aria-label="cpf" value="individual" ng-click="vm.updateBankAccountType()">{{\'settings.store.payments.tabs.pagarMe.form.individual\' | translate}}</md-radio-button><md-radio-button class="my-radio" style="margin-left: 30px" aria-label="cnpj" value="corporation" ng-click="vm.updateBankAccountType()">{{\'settings.store.payments.tabs.pagarMe.form.company\' | translate}}</md-radio-button></md-radio-group></div></div><div ng-if="vm.pagarme.registerInformation.type === \'individual\'"><!-- CPF, NAME, EMAIL --><div class="row"><div class="form-group col-md-7"><label class="required" for="legalName" data-translate="settings.store.payments.tabs.pagarMe.form.full-name">Nome Completo</label><input id="legalName" name="legalName" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.name" minlength="4" maxlength="128" required><div ng-show="vm.pagarmeForm.legalName.$invalid && vm.pagarmeForm.legalName.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.legalName.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.legalName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.legalName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div><div class="form-group col-md-5"><div><label class="required" for="cpf" data-translate="settings.store.payments.tabs.pagarMe.form.document">CPF</label><input id="cpf" type="text" name="documentNumber" class="form-control" ng-model="vm.pagarme.registerInformation.documentNumber" ng-cpf ui-mask="999.999.999-99"><div class="help-block-div" ng-show="vm.pagarmeForm.documentNumber.$invalid && vm.pagarmeForm.documentNumber.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.documentNumber.$invalid" data-translate="entity.validation.cpf">This field CPF is invalid.</p><p class="help-xblock form-invalid-field" ng-show="vm.pagarmeForm.documentNumber.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row"><div class="form-group col-md-7"><label class="required" for="email" data-translate="settings.store.payments.tabs.pagarMe.form.email">Email</label><input id="email" name="email" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.email" required><div ng-show="vm.pagarmeForm.email.$invalid && vm.pagarmeForm.email.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.email.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-md-5 col-sm-12 col-xs-12"><label class="required" for="phone" data-translate="settings.store.payments.tabs.pagarMe.form.phone">Phone Number</label><input type="tel" name="phone" id="phone" class="form-control" ng-model="vm.pagarme.registerInformation.phoneNumber" ng-maxlength="30" ng-minlength="4" intl-tel-input required><div ng-if="vm.pagarmeForm.phone.$invalid && vm.pagarmeForm.phone.$touched"><p class="help-block form-invalid-field" ng-if="vm.pagarmeForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-if="vm.pagarmeForm.phone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div><div class="row"><div class="form-group col-md-7"><label class="required" for="professionalOccupation" data-translate="settings.store.payments.tabs.pagarMe.form.professional-occupation">Professional Occupation</label><select id="professionalOccupation" name="professionalOccupation" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.professionalOccupation"><option ng-repeat="occupation in vm.occupations" ng-value="occupation">{{ occupation }}</option></select></div><div class="form-group col-md-5"><label class="required" for="monthlyIncome" data-translate="settings.store.payments.tabs.pagarMe.form.monthly-income">Monthly Income</label><input id="monthlyIncome" name="monthlyIncome" type="text" class="form-control" price price-decimal-separator="{{ \',\' }}" price-thousand-separator="{{ \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true" ng-model="vm.pagarme.registerInformation.monthlyIncome" required><div ng-if="vm.pagarmeForm.monthly_income.$invalid && vm.pagarmeForm.monthlyIncome.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.monthlyIncome.$error.required" data-translate="entity.validation.required"></p></div></div></div><div class="row"><div class="form-group col-md-7 col-sm-12 col-xs-12"><label for="mothersName" data-translate="settings.store.payments.tabs.pagarMe.form.mother-name">Mother\'s Name</label><input id="mothersName" name="mothersName" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.motherName"></div></div></div><div ng-if="vm.pagarme.registerInformation.type === \'corporation\'"><!-- CNPJ, RAZ\xC2O SOCIAL  --><div class="row"><div class="form-group col-md-7"><div><label class="required" for="companyName" data-translate="settings.store.payments.tabs.pagarMe.form.company-name">Raz\xE3o Social</label><input id="companyName" name="companyName" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.companyName" minlength="1" required><div ng-show="vm.pagarmeForm.companyName.$invalid && vm.pagarmeForm.companyName.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.companyName.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.companyName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.companyName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div></div><div class="form-group col-md-5"><div><label for="cnpj" class="required" data-translate="settings.store.payments.tabs.pagarMe.form.cnpj">CNPJ</label><input id="cnpj" type="text" name="documentNumber" class="form-control" ng-model="vm.pagarme.registerInformation.documentNumber" ng-cnpj ui-mask="99.999.999/9999-99" required><div class="help-block-div" ng-show="vm.pagarmeForm.documentNumber.$invalid && vm.pagarmeForm.documentNumber.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.documentNumber.$invalid && !vm.pagarmeForm.documentNumber.$error.required" data-translate="entity.validation.cnpj">This field CNPJ is invalid.</p><p class="help-xblock form-invalid-field" ng-show="vm.pagarmeForm.documentNumber.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="row"><div class="form-group col-md-7"><label class="required" for="tradingName" data-translate="settings.store.payments.tabs.pagarMe.form.trading-name">Nome Fantasia</label><input id="tradingName" name="tradingName" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.tradingName" minlength="1" required><div ng-show="vm.pagarmeForm.tradingName.$invalid && vm.pagarmeForm.tradingName.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.tradingName.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.tradingName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="150"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.tradingName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div><div class="form-group col-md-5"><label class="required" for="annualRevenue" data-translate="settings.store.payments.tabs.pagarMe.form.annual-revenue">Annual Revenue</label><input id="annualRevenue" name="annualRevenue" type="text" class="form-control" price price-decimal-separator="{{ \',\' }}" price-thousand-separator="{{ \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true" ng-model="vm.pagarme.registerInformation.annualRevenue" required><div ng-show="vm.pagarmeForm.annualRevenue.$invalid && vm.pagarmeForm.annualRevenue.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.annualRevenue.$error.required" data-translate="entity.validation.required"></p></div></div></div><div class="row"><div class="form-group col-md-7"><label class="required" for="email" data-translate="settings.store.payments.tabs.pagarMe.form.email">Email</label><input id="email" name="email" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.email" required><div ng-show="vm.pagarmeForm.email.$invalid && vm.pagarmeForm.email.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.email.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-md-5"><label class="required" for="foundingDate" data-translate="settings.store.payments.tabs.pagarMe.form.founding-date">founding date</label><input id="foundingDate" name="foundingDate" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.foundingDate" ui-mask="99/99/9999" model-view-value="true" required><div ng-show="vm.pagarmeForm.foundingDate.$invalid && vm.pagarmeForm.foundingDate.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.foundingDate.$error.required" data-translate="entity.validation.required"></p></div></div></div><div class="row"><div class="form-group col-md-7 col-sm-12 col-xs-12"><label class="required" for="phone" data-translate="settings.store.payments.tabs.pagarMe.form.phone">Phone Number</label><input type="tel" name="phone" id="phone" class="form-control" ng-model="vm.pagarme.registerInformation.phoneNumber" ng-maxlength="30" ng-minlength="4" intl-tel-input required><div ng-if="vm.pagarmeForm.phone.$invalid && vm.pagarmeForm.phone.$touched"><p class="help-block form-invalid-field" ng-if="vm.pagarmeForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-if="vm.pagarmeForm.phone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div></div><div class="hr-line-dashed"></div><!-- Address --><div class="row"><div class="form-group col-md-12"><h1 class="sc-default-title-store-font" ng-if="vm.pagarme.registerInformation.type === \'individual\'" data-translate="settings.store.payments.tabs.pagarMe.form.address.title">Endere\xE7o</h1><h1 class="sc-default-title-store-font" ng-if="vm.pagarme.registerInformation.type === \'corporation\'" data-translate="settings.store.payments.tabs.pagarMe.form.address.company-title">Endere\xE7o</h1><p data-translate="settings.store.payments.tabs.pagarMe.form.address.subtitle">Escolha o Endere\xE7o</p><label for="autocomplete" data-translate="settings.store.payments.tabs.pagarMe.form.address.search-address">Search Address</label><input id="autocomplete" type="text" class="form-control" placeholder="{{\'settings.store.payments.tabs.pagarMe.form.address.placeholder\' | translate}}"></div></div><div class="row"><div class="form-group col-md-7"><label class="required" for="street" data-translate="settings.store.payments.tabs.pagarMe.form.address.street">Street</label><input id="street" name="street" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.address.street" required></div><div class="form-group col-md-5"><label class="required" for="streetNumber" data-translate="settings.store.payments.tabs.pagarMe.form.address.street-number">Street Number</label><input id="streetNumber" name="streetNumber" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.address.streetNumber" required><div ng-show="vm.pagarmeForm.streetNumber.$invalid && vm.pagarmeForm.streetNumber.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.streetNumber.$error.required" data-translate="entity.validation.required"></p></div></div></div><div class="row"><div class="form-group col-md-7"><label class="required" for="neighborhood" data-translate="settings.store.payments.tabs.pagarMe.form.address.neighborhood">Neighborhood</label><input id="neighborhood" name="neighborhood" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.address.neighborhood" required></div><div class="form-group col-md-5"><label class="required" for="city" data-translate="settings.store.payments.tabs.pagarMe.form.address.city">City</label><input id="city" name="city" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.address.city" required></div></div><div class="row"><div class="form-group col-md-7"><label class="required" for="state" data-translate="settings.store.payments.tabs.pagarMe.form.address.state">State</label><input id="state" name="state" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.address.state" required></div><div class="form-group col-md-5"><label class="required" for="postalCode" data-translate="settings.store.payments.tabs.pagarMe.form.address.postal-code">Postal Code</label><input id="postalCode" name="postalCode" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.address.zipcode" required></div></div><div class="row"><div class="form-group col-md-7"><label class="required" for="referencePoint" data-translate="settings.store.payments.tabs.pagarMe.form.address.reference-point">Reference Point</label><input id="referencePoint" name="referencePoint" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.address.referencePoint" required><div ng-show="vm.pagarmeForm.referencePoint.$invalid && vm.pagarmeForm.referencePoint.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.referencePoint.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-md-5"><label class="required" for="complementary" data-translate="settings.store.payments.tabs.pagarMe.form.address.complementary">Complementary</label><input id="complementary" name="complementary" type="text" class="form-control" ng-model="vm.pagarme.registerInformation.address.complementary" required></div></div></div></div><div ng-if="vm.pagarme.registerInformation.type === \'corporation\'"><div class="hr-line-dashed"></div><!-- Conta Banc\xE1ria --><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-store-font" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.title">Managing Partner</h1><p data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.subtitle">Adicione um novo s\xF3cio administrador</p></div><div ng-if="!vm.pagarme.registerInformation.managingPartners" class="col-md-12 col-xs-12"><div class="display-horizontally-inline alert alert-warning no-templates-box" style="column-gap: 10px"><i class="fa fa-warning" style="color: #fdbe2d; font-size: 20px" aria-hidden="true"></i><p class="m-0 cost-text ng-scope" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.warning"></p></div></div></div><div class="row"><!-- ################### MANAGING PARTNERS TABLE ################### --><div class="col-md-12 col-xs-12" style="margin-top: 5px; margin-bottom: 10px; margin-left: 0px; margin-right: 0px"><table class="table caption-top table-striped"><thead><tr><th scope="col" style="text-align: center" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.table.name">Name</th><th scope="col" style="text-align: center" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.table.email">Email</th><th scope="col" style="text-align: center" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.table.phone">Phone</th><th scope="col" style="text-align: center" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.table.actions">Actions</th></tr></thead><tbody><tr ng-if="!vm.pagarme.registerInformation.managingPartners"><td colspan="4" style="text-align: center">{{ \'settings.store.payments.tabs.pagarMe.form.managing-partner.table.empty-list\' | translate }}</td></tr><tr ng-repeat="partner in vm.pagarme.registerInformation.managingPartners"><td>{{ partner.name }}</td><td>{{ partner.email }}</td><td>{{ partner.phoneNumber }}</td><td><span class="pull-right fa fa-trash" style="margin-right: 8px; color: #676a6cd6; font-size: 15px" ng-click="vm.removeManagingPartner($index, partner)"></span> <span class="pull-right fa fa-pencil-square-o" style="margin-right: 14px; color: #676a6cd6; font-size: 15px" ng-click="vm.updateManagingPartner($index, partner)"></span></td></tr></tbody></table></div><!-- ################### OPEN MANAGING PARTNER MODAL ################### --><div class="form-group row col-md-12 col-sm-12"><button type="button" class="btn btn-secondary pull-right" class="col-xs-12" ng-click="vm.openManagingPartnerModal()"><span data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.add-button">Add Partner</span></button></div></div></div><div class="hr-line-dashed"></div><!-- Conta Banc\xE1ria --><div class="row"><div class="col-xs-12"><h1 class="sc-default-title-store-font" data-translate="settings.store.payments.tabs.pagarMe.form.bank-account-title">Conta Banc\xE1ria</h1><p data-translate="settings.store.payments.tabs.pagarMe.form.bank-account-desc">Adicione uma nova conta banc\xE1ria</p></div></div><div class="row m-t-sm"><div class="col-xs-12"><div class="row"><div class="form-group col-md-12 col-xs-12"><div><label class="required" for="bankAccountName" data-translate="settings.store.payments.tabs.pagarMe.form.account-name">Nome da conta banc\xE1ria</label><input id="bankAccountName" name="bankAccountName" type="text" class="form-control" ng-model="vm.pagarme.bankAccount.holderName" minlength="1" maxlength="30" required><div ng-show="vm.pagarmeForm.bankAccountName.$invalid && vm.pagarmeForm.bankAccountName.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankAccountName.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankAccountName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankAccountName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div></div></div><div class="row"><div class="form-group col-xs-6"><label class="required" for="titularDocument" data-translate="settings.store.payments.tabs.pagarMe.form.bank">Banco</label><select id="titularDocument" name="titularDocument" type="text" class="form-control" ng-model="vm.pagarme.bankAccount.bankCode"><option ng-repeat="bank in vm.banks | filter:{ pagarme: true } | orderBy:\'code\'" ng-value="bank.code">{{ bank.code }} - {{ bank.label }}</option></select><div ng-show="vm.pagarmeForm.bankCode.$invalid && vm.pagarmeForm.bankCode.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankCode.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-xs-6"><label class="required" for="bankAccountType" data-translate="settings.store.payments.tabs.pagarMe.form.account-type">Tipo da conta banc\xE1ria</label><select id="bankAccountType" name="bankAccountType" type="text" class="form-control" ng-model="vm.pagarme.bankAccount.type"><option value="conta_corrente" data-translate="settings.store.payments.tabs.pagarMe.form.account-types.conta_corrente">Conta Corrente</option><option value="conta_poupanca" data-translate="settings.store.payments.tabs.pagarMe.form.account-types.conta_poupanca">Conta Poupan\xE7a</option><option value="conta_corrente_conjunta" data-translate="settings.store.payments.tabs.pagarMe.form.account-types.conta_corrente_conjunta">Conta Poupan\xE7a</option><option value="conta_poupanca_conjunta" data-translate="settings.store.payments.tabs.pagarMe.form.account-types.conta_poupanca_conjunta">Conta Poupan\xE7a</option></select><div ng-if="vm.pagarmeForm.bankAccountType.$invalid && vm.pagarmeForm.bankAccountType.$touched"><p class="help-block form-invalid-field" ng-if="vm.pagarmeForm.bankAccountType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><div class="form-group col-md-6 col-xs-6"><label class="required" for="bankAccount" data-translate="settings.store.payments.tabs.pagarMe.form.account">Conta</label><input id="bankAccount" numbers-only name="bankAccount" ng-model="vm.pagarme.bankAccount.accountNumber" type="text" class="form-control" maxlength="13" minlength="4" required><div ng-show="vm.pagarmeForm.bankAccount.$invalid && vm.pagarmeForm.bankAccount.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankAccount.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankAccount.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="13"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankAccount.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div><div class="form-group col-md-6 col-xs-6"><label for="bankAccountDigit" class="required" data-translate="settings.store.payments.tabs.pagarMe.form.digit">Digito</label><input id="bankAccountDigit" numbers-only name="bankAccountDigit" ng-model="vm.pagarme.bankAccount.accountCheckDigit" type="text" class="form-control" maxlength="2" minlength="1" required><div ng-show="vm.pagarmeForm.bankAccountDigit.$invalid && vm.pagarmeForm.bankAccountDigit.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankAccountDigit.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankAccountDigit.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankAccountDigit.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1"></p></div></div></div><div class="row"><div class="form-group col-md-6 col-xs-6"><label class="required" for="bankBranch" data-translate="settings.store.payments.tabs.pagarMe.form.agency">Ag\xEAncia</label><input id="bankBranch" numbers-only name="bankBranch" ng-model="vm.pagarme.bankAccount.branchNumber" type="text" class="form-control" maxlength="4" minlength="4" required><div ng-show="vm.pagarmeForm.bankBranch.$invalid && vm.pagarmeForm.bankBranch.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankBranch.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankBranch.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="4"></p><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankBranch.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div><div class="form-group col-md-6 col-xs-6"><label for="bankBranchDigit" data-translate="settings.store.payments.tabs.pagarMe.form.digit-optional">Digito (Opcional)</label><input id="bankBranchDigit" numbers-only name="bankBranchDigit" ng-model="vm.pagarme.bankAccount.branchCheckDigit" type="text" class="form-control" maxlength="1"><div ng-show="vm.pagarmeForm.bankBranch.$invalid && vm.pagarmeForm.bankBranch.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.bankBranch.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1"></p></div></div></div></div></div><div class="hr-line-dashed"></div><!-- Configura\xE7\xF5es de antecipa\xE7\xE3o --><div class="row"><div class="col-md-12"><h1 class="sc-default-title-store-font" data-translate="settings.store.payments.tabs.pagarMe.form.receiving-title">Configura\xE7\xF5es de Recebimento</h1><p data-translate="settings.store.payments.tabs.pagarMe.form.receiving-desc">Escolha abaixo o dia da transfer\xEAncia para a sua conta banc\xE1ria</p></div></div><div class="row m-t-sm"><div class="col-md-12"><div class="row"><div class="form-group col-xs-7"><label class="required" for="transferDay" data-translate="settings.store.payments.tabs.pagarMe.form.transfer-day">Selecionar dia da transfer\xEAncia</label><select id="transferDay" name="transferDay" type="text" class="form-control" ng-model="vm.pagarme.transferDay" ng-required="vm.pagarme.transferDay !== undefined"><option ng-repeat="day in vm.transferDaysTest" ng-value="day">{{ day }}</option></select><div ng-show="vm.pagarmeForm.transferDay.$invalid && vm.pagarmeForm.transferDay.$touched"><p class="help-block form-invalid-field" ng-show="vm.pagarmeForm.transferDay.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="hr-line-dashed"></div><div class="row m-t-sm" style="display: flex; justify-content: space-between"><button ng-if="vm.keyCheckoutMethod === \'PAGAR_ME\'" type="button" class="btn btn-secondary" ng-click="vm.openModalDisconnectPagarMe()"><span data-translate="settings.form.disconnect" data-translate="settings.store.payments.tabs.pagarMe.buttons.disconnect">Disconnect</span></button> <button id="btnCreateFlyer" class="btn btn-primary btn-large" ng-click="vm.saveMethodPagarMe()" data-style="pull-right" style="min-width:150px"><span ng-if="vm.pagarme.id === null">Ativar</span> <span ng-if="vm.pagarme.id !== null && vm.keyCheckoutMethod === \'PAGAR_ME\'" data-translate="settings.store.payments.tabs.pagarMe.buttons.update">Atualizar dados</span> <span ng-if="vm.pagarme.id !== null && vm.keyCheckoutMethod !== \'PAGAR_ME\'" data-translate="settings.store.payments.tabs.pagarMe.buttons.activate">Ativar</span></button></div></div></div></form></div></div><div ng-if="vm.checkoutMethod === \'WIRECARD\'"><div class="col-sm-6" style="padding-top: 15px"><div class="col-sm-12" style="padding-bottom: 4%"><a href="https://wirecard.com.br/" target="_blank"><img src="/content/images/logo-wirecard-p.png" border="0" width="150px" height="100%"></a></div><h3 data-translate="settings.store.payments.tabs.wirecard.stepTitle"></h3><p data-translate="settings.store.payments.tabs.wirecard.step1"></p><p data-translate="settings.store.payments.tabs.wirecard.step2"></p><p data-translate="settings.store.payments.tabs.wirecard.step3"></p><p data-translate="settings.store.payments.tabs.wirecard.step4"></p><p data-translate="settings.store.payments.tabs.wirecard.step5"></p><div class="col-sm-12" style="padding-bottom: 4%; padding-left: 0px"><a type="button" ng-href="{{vm.linksWirecard.createAccountLink}}" class="btn btn-primary" target="_blank" ng-hide="true" style="margin-right: 3%">{{ \'settings.store.payments.tabs.wirecard.createButtonTitle\' | translate }} </a><a type="button" ng-click="vm.connecttWirecard()" class="btn btn-primary" ng-hide="true">{{ \'settings.store.payments.tabs.wirecard.connectButtonTitle\' | translate }} </a><a type="button" ng-click="vm.openModalDisconnectWirecard()" class="btn btn-primary" ng-hide="!vm.moipInfo.moipLogin">{{ \'settings.store.payments.tabs.wirecard.disconnectButtonTitle\' | translate }}</a></div><p ng-hide="!vm.moipInfo.moipLogin" data-translate="settings.store.payments.tabs.wirecard.connectedWith" translate-value-logged="{{vm.moipInfo.moipLogin}}" style="text-align: center"></p></div><div class="col-sm-6" style="padding-top: 15px"><h3 data-translate="settings.store.payments.tabs.wirecard.wirecardTitle" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.store.payments.tabs.wirecard.wirecardDescription"></p><p style="font-size: 15px; margin-bottom: 2%" data-translate="settings.store.payments.tabs.wirecard.wirecardDescription2"></p><a ng-href="https://wirecard.com.br/" target="_blank">{{ \'settings.store.payments.tabs.wirecard.knowMore\' | translate }}</a></div></div><div class="col-sm-12" style="text-align: center; padding-bottom: 2%; padding-top: 2%"><h4 data-translate="settings.store.payments.tabs.wirecard.showkaseDescription"></h4></div></div>');
$templateCache.put('app/admin/settings/payments/dupay.html','<div class="col-sm-6" style="padding-top: 15px"><div class="col-sm-12" style="padding-bottom: 4%"><a href="https://www.dupay.com.br" target="_blank"><img src="content/images/logo-dupay.png" border="0" width="150px" height="100%" style="background-color: #484848"></a></div><div class="col-sm-12"><h3 data-translate="settings.store.payments.tabs.dupay.stepTitle"></h3><p data-translate="settings.store.payments.tabs.dupay.step1"></p></div><div class="form-group col-sm-12"><label class="control-label" for="dupay-token" data-translate="settings.store.payments.tabs.dupay.dupayToken">Dupay Token</label><input type="text" class="form-control" id="dupay-token" name="dupay-token" ng-model="vm.dupaySettings.dupayToken"></div><div class="col-sm-12" style="padding-bottom: 4%"><button type="button" class="btn btn-primary" ng-click="vm.saveDupaySettings()" class="btn btn-primary">{{ \'settings.form.button\' | translate }}</button></div></div><div class="col-sm-6" style="padding-top: 15px"><h3 data-translate="settings.store.payments.tabs.dupay.dupayTitle" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.store.payments.tabs.dupay.dupayDescription"></p><p style="font-size: 15px; margin-bottom: 2%" data-translate="settings.store.payments.tabs.dupay.dupayDescription2"></p><a ng-href="https://dupay.com.br" target="_blank">{{ \'settings.store.payments.tabs.dupay.knowMore\' | translate }}</a></div></div>');
$templateCache.put('app/admin/settings/payments/installments.html','<form name="vm.installmentForm" role="form" novalidate show-validation ng-submit="vm.saveInstallment()"><div class="col-sm-6" style="padding-top: 15px"><div class="col-sm-12" style="padding-left: 0px; padding: 0px 0px 0px 0px"><h2 data-translate="settings.store.payments.tabs.installment.title" style="font-size: 20px; margin-top: 0px"></h2><br></div><div class="panel-body"><div ng-repeat="installment in vm.installments track by $index"><div class="col-sm-12"><div class="col-sm-1 form-group" style="margin-top: 18px; padding-left: 0px"><md-switch ng-model="installment.allowInstallment" md-no-ink="true" uib-tooltip="{{ \'settings.store.payments.tabs.installment.active\' | translate}}"></md-switch></div><div class="col-sm-4 form-group" style="margin-top: 10px"><label for="installment" data-translate="settings.store.payments.tabs.installment.max-installments">Max installments</label><select id="noFee" name="noFee{{$index}}" type="text" class="form-control" ng-disabled="!installment.allowInstallment" ng-options="option as (option == 0 ? \'Nenhuma\': option ) disable when (option <= vm.installments[$index - 1].installment) for option in vm.installment" ng-model="installment.installment" ng-init="installment.installment" required><option value="" selected="selected" hidden></select><div ng-show="vm.installmentForm[\'noFee\' + $index].$invalid && vm.installmentForm[\'noFee\' + $index].$touched"><p class="help-block form-invalid-field" ng-show="vm.installmentForm[\'noFee\' + $index].$error.required" data-translate="entity.validation.required"></p></div></div><div class="col-sm-5 form-group" style="margin-top: 10px"><label for="minimumValue" data-translate="settings.store.payments.tabs.installment.min-value">Min value</label><div class="input-group"><span class="input-group-addon">{{vm.currencyPrefix}}</span> <input id="minimumValue" name="minimumValue{{$index}}" ng-model="installment.minimumValue" type="text" class="form-control" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price price-decimal-separator="," price-thousand-separator="." price-activated="true" required ng-disabled="!installment.allowInstallment"></div><div ng-show="vm.installmentForm[\'minimumValue\' + $index].$invalid && vm.installmentForm[\'minimumValue\' + $index].$touched"><p class="help-block form-invalid-field" ng-show="vm.installmentForm[\'minimumValue\' + $index].$error.required" data-translate="entity.validation.required"></p></div></div><i class="fa fa-trash pointer col-sm-2" ng-click="vm.removeInstallment($index)" style="font-size: 22px; margin-top: 38px"></i></div></div><div class="col-sm-12" style="margin-left: -21px; margin-bottom: 6px"><button class="store-upload-button pointer" type="button" ng-click="vm.addInstallment()" style="background-color: white; border: none"><i style="margin-right: 5px" class="fa fa-plus" aria-hidden="true"></i> <span data-translate="settings.store.payments.tabs.installment.add-button"></span></button></div><div class="col-sm-12" style="width: 89% !important; margin-top: 15px"><button ladda="vm.isSaving" type="submit" class="btn btn-primary pull-right" data-translate="settings.form.button" ng-disabled="(vm.installmentForm.$invalid)">Save</button></div></div></div></form>');
$templateCache.put('app/admin/settings/payments/payment-settings.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox" style="display: grid"><div class="ibox-content"><div class="row"><div class="col-md-6"><p data-translate="settings.store.payments.desc">Aqui voc\xEA configura os meios de pagamentos da sua loja.</p></div><div class="col-md-6" align="left"><div class="inner-addon left-addon"><div class="pull-right"><div class="dropdown dropdown-table btn-group"></div></div></div></div></div><div class="clients-list" ng-if="vm.store.hubId != 4"><ul class="nav nav-tabs"><li ng-class="{\'active\' : tab == 1}"><a ng-click="tab = 1" ng-init="tab = 1"><i class="fa fa-credit-card"></i> <span data-translate="settings.store.payments.tabs.credit-card.title">Cart\xE3o de credito e boleto</span></a></li><li ng-class="{\'active\' : tab == 2}"><a ng-click="tab = 2"><i class="fa fa-qrcode"></i> <span data-translate="settings.store.payments.tabs.pix.title">Pix</span></a></li><li ng-class="{\'active\' : tab == 3}"><a ng-click="tab = 3"><i class="fa fa-file-powerpoint-o"></i> <span data-translate="settings.store.payments.tabs.picpay.title">PicPay</span></a></li><li ng-class="{\'active\' : tab == 4}"><a ng-click="tab = 4"><i class="fa fa-cc"></i> <span data-translate="settings.store.payments.tabs.installment.installment">Parcelamento</span></a></li><li ng-class="{\'active\' : tab == 5}"><a ng-click="tab = 5"><i class="icon-ksc-admin-type-sale"></i> <span data-translate="settings.store.payments.tabs.toBeAgreed.title">A combinar</span></a></li></ul><div class="tab-content"><div id="tab-1" class="tab-pane active" ng-show="tab == 1"><div class="panel-body" ng-include="\'app/admin/settings/payments/card-boleto.html\'"></div></div><div id="tab-2" class="tab-pane active" ng-show="tab == 2"><div class="panel-body" ng-include="\'app/admin/settings/payments/pix.html\'"></div></div><div id="tab-3" class="tab-pane active" ng-show="tab == 3"><div class="panel-body" ng-include="\'app/admin/settings/payments/picpay.html\'"></div></div><div class="row" ng-show="tab == 4"><div class="col-sm-12"><div id="tab-4" class="tab-pane active" ng-show="tab == 4"><div class="panel-body" ng-include="\'app/admin/settings/payments/installments.html\'"></div></div></div></div><div class="row" ng-show="tab == 5"><div class="col-sm-12"><div id="tab-5" class="tab-pane active" ng-show="tab == 5"><div class="panel-body" ng-include="\'app/admin/settings/payments/to-be-agreed.html\'"></div></div></div></div></div></div><div class="clients-list" ng-if="vm.store.hubId == 4"><ul class="nav nav-tabs"><li ng-class="{\'active\' : tab == 1}"><a ng-click="tab = 1" ng-init="tab = 1"><i class="fa fa-credit-card"></i> <span data-translate="settings.store.payments.tabs.dupay.title">Dupay</span></a></li></ul><div class="tab-content"><div id="tab-1" class="tab-pane active" ng-show="tab == 1"><div class="panel-body" ng-include="\'app/admin/settings/payments/dupay.html\'"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/settings/payments/picpay.html','<div class="col-sm-6" style="padding-top: 15px"><div class="col-sm-12" style="padding-bottom: 4%"><a href="https://www.picpay.com" target="_blank"><img src="content/images/configuration-payment-pic-pay.png" border="0" width="150px" height="100%"></a></div><h3 data-translate="settings.store.payments.tabs.picpay.stepTitle"></h3><p ng-if="vm.hasPicPayPayment" data-translate="settings.store.payments.tabs.picpay.enabled"></p><md-switch ng-if="vm.hasPicPayPayment" ng-model="vm.picPaySettings.isEnabled" ng-change="vm.activateDeactivatePayment(vm.picPaySettings.id, \'PIC_PAY\', vm.picPaySettings)"><span ng-if="vm.picPaySettings.isEnabled">{{\'settings.store.payments.tabs.picpay.yes\' | translate}} </span><span ng-if="!vm.picPaySettings.isEnabled">{{\'settings.store.payments.tabs.picpay.no\' | translate}}</span></md-switch><p data-translate="settings.store.payments.tabs.picpay.step1"></p><p data-translate="settings.store.payments.tabs.picpay.step2"></p><div class="form-group col-sm-12"><label class="control-label" for="x-picpay-token" data-translate="settings.store.payments.tabs.picpay.picPayToken">PicPay Token</label><input type="text" class="form-control" id="x-picpay-token" ng-disabled="vm.hasPicPayPayment" name="x-picpay-token" ng-model="vm.picPaySettings.picPayToken"></div><div class="form-group col-sm-12"><label class="control-label" for="x-seller-token" data-translate="settings.store.payments.tabs.picpay.sellerToken">Seller Token</label><input type="text" class="form-control" id="x-seller-token" ng-disabled="vm.hasPicPayPayment" name="x-seller-token" ng-model="vm.picPaySettings.sellerToken"></div><div class="col-sm-12" style="padding-bottom: 4%"><a type="button" ng-if="!vm.hasPicPayPayment" ng-href="https://ecommerce.picpay.com/" class="btn btn-primary" target="_blank" style="margin-right: 3%">{{ \'settings.store.payments.tabs.picpay.createButtonTitle\' | translate }} </a><button ng-if="!vm.hasPicPayPayment" type="button" class="btn btn-primary" ng-click="vm.savePicPaySettings()" class="btn btn-primary">{{ \'settings.form.button\' | translate }}</button> <button ng-if="vm.hasPicPayPayment" type="button" class="btn btn-secondary" ng-click="vm.openDisconnectPicPayModal()"><span data-translate="settings.form.disconnect">Disconnect</span></button></div></div><div class="col-sm-6" style="padding-top: 15px"><h3 data-translate="settings.store.payments.tabs.picpay.picpayTitle" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.store.payments.tabs.picpay.picpayDescription"></p><p style="font-size: 15px; margin-bottom: 2%" data-translate="settings.store.payments.tabs.picpay.picpayDescription2"></p><a ng-href="https://picpay.com" target="_blank">{{ \'settings.store.payments.tabs.picpay.knowMore\' | translate }}</a></div></div>');
$templateCache.put('app/admin/settings/payments/pix.html','<style>.notification-item {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 5px 15px 5px 15px;\n        border-radius: 10px;\n        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n    }\n\n    .cost-box {\n        display: flex;\n        align-items: center;\n        color: var(--main-color-light);\n        background-color: #dfd7ed;\n        border-radius: 5px;\n    }\n\n    .cost-text {\n        font-size: 12px;\n        text-align: justify;\n        opacity: 1;\n        padding: 10px;\n        font-weight: 400;\n    }\n\n    .cost-icon {\n        font-size: xx-large;\n        -moz-transform: scale(-1, 1);\n        -webkit-transform: scale(-1, 1);\n        -o-transform: scale(-1, 1);\n        -ms-transform: scale(-1, 1);\n        transform: scale(-1, 1);\n    }</style><div class="col-sm-6" style="padding-top: 15px"><div class="col-sm-12" style="padding-bottom: 4%"><a href="https://www.bcb.gov.br/estabilidadefinanceira/pix" target="_blank" style="margin-right: 10px"><img src="content/images/logo-pix.png" width="70px" height="100%"> </a><a href="https://tbanks.com/" target="_blank"><img src="content/images/logo-tbanks.png" width="100px" height="100%"></a></div><form name="vm.tBanksForm" ng-if="!vm.tBanksSettings.status || vm.tBanksSettings.status === \'Rejeitada\' || vm.tBanksSettings.status === \'Criada\'"><h3 ng-if="!vm.tBanksSettings.status" data-translate="settings.store.payments.tabs.pix.stepTitle"></h3><div ng-if="vm.tBanksSettings.status === \'Rejeitada\'" class="row" style="margin-bottom: 15px"><div class="col-md-12"><h2 class="sc-default-title-store-font" data-translate="settings.store.payments.tabs.pix.configured-title">Title</h2><div class="display-horizontally-inline"><p data-translate="settings.store.payments.tabs.pix.refused-description-1" style="font-size: 14px; font-weight: bold; margin-bottom: unset">Description</p><i class="fa fa-exclamation-circle" style="font-size: 20px; color: #d41212"></i></div><p data-translate="settings.store.payments.tabs.pix.refused-description-2" style="margin-top: 5px">Description</p></div></div><!-- Dados --><div class="row"><div class="col-md-12"><h2 class="sc-default-title-store-font" data-translate="settings.store.payments.tabs.pix.company-title">Dados da Empresa</h2><p data-translate="settings.store.payments.tabs.pix.company-description">Insira os dados da empresa.</p></div></div><div class="row m-t-sm"><div class="col-md-12"><!-- NAME, CNPJ --><div class="row"><div class="form-group col-md-7"><div><label class="required" for="companyName" data-translate="settings.store.payments.tabs.pix.form.company-name">Raz\xE3o social</label><input id="companyName" name="companyName" type="text" class="form-control" ng-model="vm.tBanksSettings.companyName" minlength="4" maxlength="128" required><div ng-show="vm.tBanksForm.companyName.$invalid && vm.tBanksForm.companyName.$touched"><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.companyName.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.companyName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128"></p><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.companyName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div></div><div class="form-group col-md-5"><div><label class="required" for="companyDocument" data-translate="settings.store.payments.tabs.pix.form.cnpj">CNPJ</label><input id="companyDocument" type="text" name="companyDocument" class="form-control" ng-model="vm.tBanksSettings.companyDocument" ng-cnpj ui-mask="99.999.999/9999-99" model-view-value="true" required><div class="help-block-div" ng-show="vm.tBanksForm.companyDocument.$invalid && vm.tBanksForm.companyDocument.$touched"><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.companyDocument.$invalid && !vm.tBanksForm.companyDocument.$error.required" data-translate="entity.validation.cnpj">This field CNPJ is invalid.</p><p class="help-xblock form-invalid-field" ng-show="vm.tBanksForm.companyDocument.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div></div></div><div class="hr-line-dashed"></div><!-- Dados --><div class="row"><div class="col-md-12"><h2 class="sc-default-title-store-font" data-translate="settings.store.payments.tabs.pix.representative-title">Representante</h2><p data-translate="settings.store.payments.tabs.pix.representative-description">Insira os dados do respons\xE1vel legal pelo CNPJ da empresa. O CPF informado precisa estar vinculado ao contrato social da empresa.</p></div></div><div class="row m-t-sm"><div class="col-md-12"><!-- CPF, NAME --><div class="row"><div class="form-group col-md-7"><div><label class="required" for="representativeName" data-translate="settings.store.payments.tabs.pix.form.full-name">Nome Completo</label><input id="representativeName" name="representativeName" type="text" class="form-control" ng-model="vm.tBanksSettings.representativeName" minlength="4" maxlength="128" required><div ng-show="vm.tBanksForm.representativeName.$invalid && vm.tBanksForm.representativeName.$touched"><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.representativeName.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.representativeName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128"></p><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.representativeName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div></div><div class="form-group col-md-5"><div><label class="required" for="representativeDocument" data-translate="settings.store.payments.tabs.pix.form.cpf">CPF</label><input id="representativeDocument" type="text" name="representativeDocument" class="form-control" ng-model="vm.tBanksSettings.representativeDocument" ng-cpf ui-mask="999.999.999-99" model-view-value="true" required><div class="help-block-div" ng-show="vm.tBanksForm.representativeDocument.$invalid && vm.tBanksForm.representativeDocument.$touched"><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.representativeDocument.$invalid && !vm.tBanksForm.representativeDocument.$error.required" data-translate="entity.validation.cpf">This field CPF is invalid.</p><p class="help-xblock form-invalid-field" ng-show="vm.tBanksForm.representativeDocument.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div><!-- EMAIL, telephone --><div class="row"><div class="form-group col-md-7"><div><label class="required" for="email" data-translate="settings.store.payments.tabs.pix.form.email">E-mail</label><input id="email" name="email" type="text" class="form-control" ng-model="vm.tBanksSettings.email" minlength="4" maxlength="128" required><div ng-show="vm.tBanksForm.email.$invalid && vm.tBanksForm.email.$touched"><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.email.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128"></p><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.email.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div></div><div class="form-group col-md-5"><div><label class="required" for="phone" data-translate="settings.store.payments.tabs.pix.form.phone">Telefone</label><input id="phone" type="tel" name="phone" class="form-control" ng-model="vm.tBanksSettings.phone" intl-tel-input required model-view-value="true"><div ng-show="vm.tBanksForm.phone.$invalid && vm.tBanksForm.$submitted"><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.phone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.phone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div></div></div></div><div class="hr-line-dashed"></div><!-- Conta Banc\xE1ria --><div class="row"><div class="col-xs-12"><h2 class="sc-default-title-store-font" data-translate="settings.store.payments.tabs.pix.bank-account-title">Conta Banc\xE1ria</h2><p data-translate="settings.store.payments.tabs.pix.bank-account-description">Adicione uma conta corrente <b>PJ</b> para onde ser\xE3o transferidos os pagamentos recebidos via Pix. A conta precisa ser PJ e estar vinculada ao CNPJ informado.</p></div></div><div class="row m-t-sm"><div class="col-xs-12"><div class="row"><div class="form-group col-xs-7"><label class="required" for="bankCode" data-translate="settings.store.payments.tabs.pix.form.bank">Banco</label><select id="bankCode" name="bankCode" type="text" class="form-control" ng-model="vm.tBanksSettings.bankCode"><option ng-repeat="bank in vm.banks| orderBy:\'code\'" ng-value="bank.code">{{bank.code}} - {{ bank.label }}</option></select><div ng-show="vm.tBanksForm.bankCode.$invalid && vm.tBanksForm.bankCode.$touched"><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.bankCode.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><div class="form-group col-xs-7"><label class="required" for="bankBranch" data-translate="settings.store.payments.tabs.pix.form.agency">Ag\xEAncia (sem d\xEDgito)</label><input id="bankBranch" numbers-only name="bankBranch" ng-model="vm.tBanksSettings.bankBranch" type="text" class="form-control" maxlength="4" minlength="4" required><div ng-show="vm.tBanksForm.bankBranch.$invalid && vm.tBanksForm.bankBranch.$touched"><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.bankBranch.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.bankBranch.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="4"></p><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.bankBranch.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div></div><div class="row"><div class="form-group col-xs-7"><label class="required" for="bankAccount" data-translate="settings.store.payments.tabs.pix.form.account">Conta (com d\xEDgito)</label><input id="bankAccount" numbers-only name="bankAccount" ng-model="vm.tBanksSettings.bankAccount" type="text" class="form-control" maxlength="13" minlength="4" required><div ng-show="vm.tBanksForm.bankAccount.$invalid && vm.tBanksForm.bankAccount.$touched"><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.bankAccount.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.bankAccount.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="13"></p><p class="help-block form-invalid-field" ng-show="vm.tBanksForm.bankAccount.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div></div></div></div><div class="row"><div class="col-sm-12" style="padding-bottom: 4%"><button type="button" class="btn btn-primary" ng-click="vm.saveTBanksSettings()" ladda="vm.isSaving" ng-disabled="!vm.tBanksForm.$valid" class="btn btn-primary">{{ \'settings.form.button\' | translate }}</button></div></div></form><div class="row" ng-if="vm.tBanksSettings && vm.tBanksSettings.status === \'Aguardando\'"><div class="col-md-12"><h2 class="sc-default-title-store-font" data-translate="settings.store.payments.tabs.pix.configured-title">Title</h2><div class="display-horizontally-inline"><p data-translate="settings.store.payments.tabs.pix.waiting-description" style="margin-bottom: unset">Description</p><i class="fa fa-exclamation-circle" style="font-size: 20px; color: #fdbe2d"></i></div></div></div><div class="row" ng-if="vm.tBanksSettings && vm.tBanksSettings.status === \'Finalizada\'"><div class="col-md-12" style="margin-bottom: 10px"><h2 class="sc-default-title-store-font" data-translate="settings.store.payments.tabs.pix.configured-title">Configura\xE7\xE3o de Pix</h2><div class="display-horizontally-inline"><p data-translate="settings.store.payments.tabs.pix.configured-description" style="margin-bottom: unset">Agora seus clientes podem utilizar o Pix como forma de pagamento em sua loja.</p><i class="fa fa-check-circle" style="font-size: 20px; color: #18a018"></i></div></div><div class="col-md-12" style="margin-bottom: 10px"><p data-translate="settings.store.payments.tabs.pix.active">Pix ativo?</p><md-switch ng-model="vm.tBanksSettings.isEnabled" ng-change="vm.activateDeactivatePayment(vm.tBanksSettings.id, \'PIX\', vm.tBanksSettings)"><span ng-if="vm.tBanksSettings.isEnabled">Sim </span><span ng-if="!vm.tBanksSettings.isEnabled">N\xE3o</span></md-switch></div><div class="col-md-12"><label for="transactionKey" data-translate="settings.store.payments.tabs.pix.pix-key">Chave Pix:</label></div><div class="col-md-12" style="margin-bottom: 10px"><div class="col-md-10" style="padding-left: 0px"><input id="transactionKey" name="transactionKey" ng-value="vm.tBanksSettings.transactionKey" ng-disabled="true" type="text" class="form-control" maxlength="4" minlength="4/"></div><div class="col-md-2" style="line-height: 30px; display: inline-block; vertical-align: middle; padding-right: 0px" ng-click="vm.copiedToClipboard()"><a class="ng-scope" uib-tooltip="{{\'settings.store.payments.tabs.pix.tooltip\' | translate}}" copy-to-clipboard="{{ vm.tBanksSettings.transactionKey }}">{{ \'settings.store.payments.tabs.pix.copy\' | translate }} <i class="fa fa-files-o" aria-hidden="true"></i></a></div></div><div class="form-group col-xs-12 col-md-12"><label for="bankCodelbl" data-translate="settings.store.payments.tabs.pix.bank">Banco</label><select id="bankCodelbl" name="bankCodelbl" type="text" class="form-control" ng-model="vm.tBanksSettings.bankCode" ng-disabled="true"><option ng-repeat="bank in vm.banks| orderBy:\'code\'" ng-value="bank.code">{{bank.code}} - {{ bank.label }}</option></select></div><div class="form-group col-xs-6 col-md-6"><label for="bankBranchlbl" data-translate="settings.store.payments.tabs.pix.agency">Ag\xEAncia</label><input id="bankBranchlbl" name="bankBranchlbl" ng-model="vm.tBanksSettings.bankBranch" ng-disabled="true" type="text" class="form-control" maxlength="4" minlength="4/"></div><div class="form-group col-xs-6 col-md-6"><label for="bankAccountlbl" data-translate="settings.store.payments.tabs.pix.account">Conta</label><input id="bankAccountlbl" name="bankAccountlbl" ng-model="vm.tBanksSettings.bankAccount" ng-disabled="true" type="text" class="form-control" maxlength="13" minlength="4/"></div><div class="col-md-12 col-xs-12"><div class="hr-line-dashed"></div></div><div class="col-md-12 col-xs-12" style="margin-bottom: 10px"><h2 class="sc-default-title-store-font" data-translate="settings.store.payments.payment-discount.title">Configura\xE7\xF5es de Desconto</h2></div><div ng-if="!vm.pixPaymentDiscountList || vm.pixPaymentDiscountList.length == 0" class="col-md-12 col-xs-12" style="margin-bottom: 15px"><div class="cost-box"><i class="icon-ksc-comment-exclamation-regular cost-icon" aria-hidden="true"></i><p class="m-0 cost-text" data-translate="settings.store.payments.payment-discount.messages.create-warning"></p></div></div><!-- ################### PAYMENT DISCOUNT LIST ################### --><div class="col-md-12 col-xs-12" ng-repeat="paymentDiscount in vm.pixPaymentDiscountList track by $index" style="margin-bottom: 15px"><div class="notification-item"><div class="display-horizontally-inline" style="width: 80%; justify-content: flex-start"><md-switch ng-model="paymentDiscount.isEnabled" md-no-ink="true" ng-change="vm.disablePaymentDiscount(paymentDiscount)"></md-switch><div class="m-l-sm" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden"><div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden"><span ng-if="paymentDiscount.discountType == \'DISCOUNT_VALUE\'"><b style="font-size: 14px">Valor do desconto: </b>{{paymentDiscount.discountValue | currency}} </span><span ng-if="paymentDiscount.discountType == \'PERCENTAGE\'"><b style="font-size: 14px">Valor do desconto: </b>{{paymentDiscount.discountValue}}%</span></div><div ng-if="false" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden"><span><b style="font-size: 14px">Valor m\xEDnimo do pedido: </b>{{paymentDiscount.minValue | currency}}</span></div></div></div><div style="display: flex; flex-direction: row"><span class="fa fa-pencil-square-o" style="margin-right: 14px; color: #676a6cd6; font-size: 15px" ng-click="vm.openPaymentDiscountFormModal(\'PIX\', paymentDiscount)"></span> <span ng-if="false" class="fa fa-trash" style="margin-right: 8px; color: #676a6cd6; font-size: 15px" ng-click="vm.deletePaymentDiscount(paymentDiscount)"></span></div></div></div><!-- ################### OPEN CREATE DISCOUNT MODAL ################### --><div class="row col-md-12 col-sm-12"><button type="button" class="btn btn-secondary pull-right" ng-click="vm.openPaymentDiscountFormModal(\'PIX\', null)"><span data-translate="settings.store.payments.payment-discount.create-button">Create Discount</span></button></div><!-- ################### DISCONECT PIX ################### --><div class="col-md-12 col-sm-12" style="margin-top: 10px"><button ng-if="vm.tBanksSettings && vm.tBanksSettings.id" type="button" class="btn btn-secondary" ng-click="vm.openDisconnectTBanksModal()"><span data-translate="settings.form.disconnect">Disconnect</span></button></div></div></div><div class="col-sm-6" style="padding-top: 15px"><h3 data-translate="settings.store.payments.tabs.pix.pixTitle" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.store.payments.tabs.pix.tBanksDescription"></p><p style="font-size: 15px; margin-bottom: 2%" data-translate="settings.store.payments.tabs.pix.tBanksDescription2"></p><p style="font-size: 15px; margin-bottom: 2%" data-translate="settings.store.payments.tabs.pix.tBanksTaxTitle"></p><p style="font-size: 15px; margin-bottom: 2%" data-translate="settings.store.payments.tabs.pix.tBanksTaxDescription"></p><a ng-href="https://tbanks.com/" target="_blank">{{ \'settings.store.payments.tabs.pix.knowMore\' | translate }}</a></div></div>');
$templateCache.put('app/admin/settings/payments/to-be-agreed.html','<div class="col-sm-6" style="padding-top: 15px; padding-right: 10px"><div class="col-sm-12" style="padding: 0"><h2 data-translate="settings.store.payments.tabs.toBeAgreed.title" style="font-size: 20px; margin-top: 0"></h2><br></div><div class="col-sm-12" style="padding-left: 0px"><div class="col-sm-12 display-horizontally-inline" style="padding-bottom: 4%; justify-content: left; padding-left: 0px"><md-switch ng-change="vm.updateToBeAgreedHandler()" ng-model="vm.paymentSettings.toBeAgreed"></md-switch><span data-translate="settings.store.payments.tabs.toBeAgreed.switch"></span></div></div><div class="col-sm-12" style="padding-left: 0px"><div class="col-sm-12 display-horizontally-inline" style="padding-bottom: 4%; justify-content: left; padding-left: 0px"><md-switch ng-change="vm.updateRedirectToSellerHandler()" ng-model="vm.paymentSettings.redirectToSellerWhatsapp"></md-switch><span data-translate="settings.store.payments.tabs.toBeAgreed.redirect-seller-switch"></span></div></div></div><div class="col-sm-6" style="padding-top: 15px"><h3 data-translate="settings.store.payments.tabs.toBeAgreed.questionTitle" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.store.payments.tabs.toBeAgreed.description"></p></div></div>');
$templateCache.put('app/admin/settings/payments/wirecard.html','<div class="col-sm-6" style="padding-top: 15px"><div class="col-sm-12" style="padding-bottom: 4%"><a href="https://wirecard.com.br/" target="_blank"><img src="/content/images/logo-wirecard-p.png" border="0" width="150px" height="100%"></a></div><h3 data-translate="settings.store.payments.tabs.wirecard.stepTitle"></h3><p data-translate="settings.store.payments.tabs.wirecard.step1"></p><p data-translate="settings.store.payments.tabs.wirecard.step2"></p><p data-translate="settings.store.payments.tabs.wirecard.step3"></p><p data-translate="settings.store.payments.tabs.wirecard.step4"></p><p data-translate="settings.store.payments.tabs.wirecard.step5"></p><div class="col-sm-12" style="padding-bottom: 4%; padding-left: 0px"><a type="button" ng-href="{{vm.linksWirecard.createAccountLink}}" class="btn btn-primary" target="_blank" ng-hide="true" style="margin-right: 3%">{{ \'settings.store.payments.tabs.wirecard.createButtonTitle\' | translate }} </a><a type="button" ng-href="{{vm.linksWirecard.connectAccountLink}}" class="btn btn-primary" ng-hide="true">{{ \'settings.store.payments.tabs.wirecard.connectButtonTitle\' | translate }} </a><a type="button" ng-click="vm.disconnect()" class="btn btn-primary" ng-hide="!vm.moipInfo.moipLogin">{{ \'settings.store.payments.tabs.wirecard.disconnectButtonTitle\' | translate }}</a></div><p ng-hide="!vm.moipInfo.moipLogin" data-translate="settings.store.payments.tabs.wirecard.connectedWith" translate-value-logged="{{vm.moipInfo.moipLogin}}" style="text-align: center"></p></div><div class="col-sm-6" style="padding-top: 15px"><h3 data-translate="settings.store.payments.tabs.wirecard.wirecardTitle" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.store.payments.tabs.wirecard.wirecardDescription"></p><p style="font-size: 15px; margin-bottom: 2%" data-translate="settings.store.payments.tabs.wirecard.wirecardDescription2"></p><a ng-href="https://wirecard.com.br/" target="_blank">{{ \'settings.store.payments.tabs.wirecard.knowMore\' | translate }}</a></div></div><div class="col-sm-12" style="text-align: center; padding-bottom: 2%; padding-top: 2%"><h4 data-translate="settings.store.payments.tabs.wirecard.showkaseDescription"></h4></div>');
$templateCache.put('app/admin/settings/shippings/clique-retire.html','<div class="col-sm-12" style="padding: 0px 0px 0px 15px"><h2 data-translate="settings.clique-retire.name" style="font-size: 20px; margin-top: 0px"></h2><br></div><div class="col-sm-6"><div class="col-sm-12" style="padding-bottom: 4%"><md-switch ng-change="vm.updateStoreData()" ng-model="vm.fullStore.getOnStore"><span data-translate="settings.clique-retire.switch">Is published</span></md-switch></div></div><div class="col-sm-6"><h3 data-translate="settings.clique-retire.questionTitle" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.clique-retire.description"></p></div></div><div class="col-sm-12" style="text-align: center; padding-bottom: 2%; padding-top: 2%"><!-- <h4 data-translate="settings.paymentConfiguration.showkaseDescription"></h4> --></div>');
$templateCache.put('app/admin/settings/shippings/custom-shipping.html','<form name="vm.customShippingForm" role="form" novalidate show-validation ng-submit="vm.createUpdateCustomShipping()"><div class="col-sm-6" style="margin-top: -17px"><div ng-if="vm.customShippingList.length > 0"><div class="col-sm-12" style="padding-left: 0px; padding: 0px 0px 0px 0px"><h2 data-translate="settings.custom-shipping.title" style="font-size: 20px; margin-top: 0px"></h2><br></div><div ng-repeat="customShipping in vm.customShippingList track by $index" style="margin-top: 15px"><div class="ibox" style="margin-bottom: 0px"><div class="ibox-content" style="padding: 10px 15px 10px 15px"><md-switch ng-model="customShipping.isActive" md-no-ink="true" ng-change="vm.disableCustomShipping(customShipping)" style="height: 24px; width: 0; margin-bottom: -41px" uib-tooltip="{{ \'settings.custom-shipping.active\' | translate}}"></md-switch><span class="pull-right fa fa-trash" style="margin-right: 8px; color: #676a6cd6; margin-top: 22px; font-size: 15px" ng-click="vm.deleteCustomShipping(customShipping.id)"></span> <span class="pull-right fa fa-pencil-square-o" style="margin-right: 14px; color: #676a6cd6; margin-top: 23px; font-size: 15px" ng-click="vm.getCustomShippingById(customShipping.id)"></span> <b class="ng-scope" style="margin-left: 53px; font-size: 14px">{{customShipping.name}}</b><div class="ng-scope coupon-text-color" style="margin-left: 53px">{{vm.currencyPrefix}} {{vm.transformPrice(customShipping.price)}}</div><div class="ng-scope" style="margin-left: 53px">{{\'settings.custom-shipping.deadline-label\' | translate}} {{customShipping.deadline}} <span ng-if="customShipping.deadline == 1">{{\'settings.custom-shipping.day\' | translate}}</span> <span ng-if="customShipping.deadline > 1">{{\'settings.custom-shipping.days\' | translate}}</span></div><div style="margin-left: 53px"><span ng-repeat="zipCode in customShipping.zipCodes track by $index"><span ng-if="zipCode.initialZipCode" class="ng-scope">{{zipCode.initialZipCode.toString().substr(0,5) + "-" + zipCode.initialZipCode.toString().substr(5)}} </span>- <span ng-if="zipCode.finalZipCode" class="ng-scope">{{zipCode.finalZipCode.toString().substr(0,5) + "-" + zipCode.finalZipCode.toString().substr(5)}} </span><span ng-if="(customShipping.zipCodes.length - 1) !== $index">|</span></span></div></div></div></div><div ng-if="!vm.isViewForm" class="col-sm-12" style="margin-top: 15px; margin-left: 14px"><button ladda="vm.isSaving" type="button" class="btn btn-primary pull-right" data-translate="settings.custom-shipping.add-custom-shipping" ng-disabled="!vm.customShippingList.length" ng-click="vm.createCustomShipping()">Add</button></div></div><div ng-if="vm.isViewForm"><div class="hr-line-dashed" style="margin-right: 16px; margin-top: 70px"></div><div class="col-sm-12" style="padding-left: 0px; padding: 0px 0px 0px 0px"><h2 ng-if="!vm.customShipping.id" data-translate="settings.custom-shipping.create" style="font-size: 20px; margin-top: 0px"></h2><h2 ng-if="vm.customShipping.id" data-translate="settings.custom-shipping.edit" style="font-size: 20px; margin-top: 0px"></h2><br></div><div class="row" style="margin-left: 0px; margin-right: 0px"><div class="col-sm-12 form-group" style="padding-left: 0px"><label for="name" class="required" data-translate="settings.custom-shipping.name">Name</label><input ng-disabled="vm.customShipping && vm.customShipping.id && !vm.customShipping.isActive" id="name" name="name" type="text" class="form-control" ng-model="vm.customShipping.name" ng-maxlength="100" ng-minlength="4" required><div ng-show="vm.customShippingForm.name.$invalid && vm.customShippingForm.name.$touched"><p class="help-block form-invalid-field" ng-show="vm.customShippingForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.customShippingForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 25 characters.</p><p class="help-block form-invalid-field" ng-show="vm.customShippingForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field cannot be longer than 25 characters.</p></div></div></div><div class="row" style="margin-left: 0px; margin-right: 0px"><div class="col-sm-6 form-group" style="padding-left: 0px"><label for="price" class="required" data-translate="settings.custom-shipping.price">Value</label><div class="input-group"><span class="input-group-addon">{{vm.currencyPrefix}}</span> <input ng-disabled="vm.customShipping && vm.customShipping.id && !vm.customShipping.isActive" id="price" name="price" ng-model="vm.customShipping.price" type="text" class="form-control" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price price-decimal-separator="," price-thousand-separator="." price-activated="true" required><div ng-show="vm.customShippingForm.price.$invalid && vm.customShippingForm.price.$touched"><p class="help-block form-invalid-field" ng-show="vm.customShippingForm.price.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-sm-6 form-group"><label for="deadline" class="required" data-translate="settings.custom-shipping.deadline">Deadline</label><input ng-disabled="vm.customShipping && vm.customShipping.id && !vm.customShipping.isActive" id="deadline" name="deadline" type="number" class="form-control" ng-model="vm.customShipping.deadline" placeholder="{{ \'settings.custom-shipping.number-days\' | translate }}" min="1" max="9999" ng-pattern="/^[0-9]{1,7}$/" required><div ng-show="vm.customShippingForm.deadline.$invalid && vm.customShippingForm.deadline.$touched"><p class="help-block form-invalid-field" ng-show="vm.customShippingForm.deadline.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-show="vm.customShippingForm.deadline.$error.min" data-translate="entity.validation.min" translate-value-min="1"></p><p class="help-block form-invalid-field" ng-show="vm.customShippingForm.deadline.$error.max" data-translate="entity.validation.max" translate-value-max="9999"></p><p class="help-block form-invalid-field" ng-show="vm.customShippingForm.deadline.$error.pattern" data-translate="entity.validation.number-integer"></p></div></div></div><div class="hr-line-dashed" style="margin-right: 16px; margin-top: 0px"></div><div class="row" style="margin-left: 0px; margin-right: 0px"><div class="col-sm-12" style="padding-left: 0px"><label data-translate="settings.custom-shipping.zip-range" class="ng-scope"></label><span tooltip-placement="left" uib-tooltip="{{ \'settings.custom-shipping.zip-range-description\' | translate}}" class="fa fa-question-circle question-icon-color"></span> <a style="font-size: 12px; margin-left: 4px" target="_blank" href="https://buscacepinter.correios.com.br/app/faixa_cep_uf_localidade/index.php">{{\'settings.custom-shipping.consult-zip-code\' | translate}}</a></div><div ng-repeat="zipCode in vm.customShipping.zipCodes track by $index"><div class="col-sm-5 form-group" style="margin-top: 10px; padding-left: 0px"><label for="initialZipCode" data-translate="settings.custom-shipping.initial-zip">Initial zip</label><input ng-disabled="vm.customShipping && vm.customShipping.id && !vm.customShipping.isActive" id="initialZipCode" name="initialZipCode" type="text" class="form-control" ng-model="zipCode.initialZipCode" ui-mask="99999-999"><div ng-show="vm.customShippingForm.initialZipCode.$invalid && vm.customShippingForm.initialZipCode.$touched"><p class="help-block form-invalid-field" ng-show="vm.customShippingForm.initialZipCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 8 characters.</p></div></div><div class="col-sm-5 form-group" style="margin-top: 10px"><label for="finalZipCode" data-translate="settings.custom-shipping.final-zip">Final zip</label><input ng-disabled="vm.customShipping && vm.customShipping.id && !vm.customShipping.isActive" id="finalZipCode" name="finalZipCode" type="text" class="form-control" ng-model="zipCode.finalZipCode" ui-mask="99999-999"><div ng-show="vm.customShippingForm.finalZipCode.$invalid && vm.customShippingForm.finalZipCode.$touched"><p class="help-block form-invalid-field" ng-show="vm.customShippingForm.finalZipCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="8">This field cannot be longer than 8 characters.</p></div></div><i class="fa fa-trash pointer col-sm-2" ng-click="vm.removeZipCode($index)" style="font-size: 22px; margin-top: 38px" ng-style="!vm.customShipping.isActive && {\'cursor\': \'not-allowed\'}"></i></div><div class="col-sm-12" style="margin-left: -21px; margin-bottom: 6px"><button class="store-upload-button pointer" type="button" ng-click="vm.addZipCode()" style="background-color: white; border: none" ng-disabled="vm.customShipping && vm.customShipping.id && !vm.customShipping.isActive"><i style="margin-right: 5px" class="fa fa-plus" aria-hidden="true"></i> <span data-translate="settings.custom-shipping.new-zip-range"></span></button></div></div><div class="hr-line-dashed" style="margin-right: 16px; margin-top: 0px"></div><div class="row"><div class="col-sm-12"><label data-translate="settings.custom-shipping.title-limit" class="ng-scope"></label></div><div class="col-sm-6"><div class="checkbox"><label><input ng-disabled="vm.customShipping && vm.customShipping.id && !vm.customShipping.isActive" type="checkbox" class="dropdown-item-checkbox" ng-model="vm.customShipping.isActiveTotalWeight"> <span id="checkEnableTotalWeight" class="checkbox-material"><span class="check"></span></span> <span data-translate="settings.custom-shipping.total-weight"></span></label></div></div><div class="col-sm-6"><div class="checkbox" style="margin-left: -8px"><label><input ng-disabled="vm.customShipping && vm.customShipping.id && !vm.customShipping.isActive" type="checkbox" class="dropdown-item-checkbox" ng-model="vm.customShipping.isActiveTotalPurchase"> <span id="checkEnableTotalPurchase" class="checkbox-material"><span class="check"></span></span> <span data-translate="settings.custom-shipping.total-purchase"></span></label></div></div></div><div class="row" style="margin-right: 0px"><div ng-if="vm.customShipping.isActiveTotalWeight" class="col-sm-6 form-group"><label for="height" data-translate="settings.custom-shipping.maximum-weight">Value</label><div class="input-group"><input ng-disabled="vm.customShipping && vm.customShipping.id && !vm.customShipping.isActive" id="maximumWeight" name="maximumWeight" ng-model="vm.customShipping.totalWeight" min="1" type="number" class="form-control" placeholder="" required> <span class="input-group-addon">kg</span></div><div ng-show="vm.customShippingForm.maximumWeight.$invalid && vm.customShippingForm.maximumWeight.$touched"><p style="margin-bottom: -17px !important" class="help-block form-invalid-field" ng-show="vm.customShippingForm.maximumWeight.$error.required" data-translate="entity.validation.required">This field is required.</p><p style="margin-bottom: -17px !important" class="help-block form-invalid-field" ng-show="vm.customShippingForm.maximumWeight.$error.min" data-translate="entity.validation.min" translate-value-min="0">MIN</p></div></div><div class="col-sm-6 form-group" ng-if="vm.customShipping.isActiveTotalPurchase" ng-style="(vm.customShipping.isActiveTotalPurchase && !vm.customShipping.isActiveTotalWeight) && {\'margin-left\': \'50%\'}"><label for="height" data-translate="settings.custom-shipping.minimum-value">Value</label><div class="input-group"><span class="input-group-addon">{{vm.currencyPrefix}}</span> <input ng-disabled="vm.customShipping && vm.customShipping.id && !vm.customShipping.isActive" id="totalPurchase" name="totalPurchase" ng-model="vm.customShipping.totalPurchase" type="text" class="form-control" placeholder="{{ vm.flyer.currencyInstance.placeHolder }}" price price-decimal-separator="," price-thousand-separator="." price-activated="true" required></div><div ng-show="vm.customShippingForm.totalPurchase.$invalid && vm.customShippingForm.totalPurchase.$touched"><p style="margin-bottom: -17px !important" class="help-block form-invalid-field" ng-show="vm.customShippingForm.totalPurchase.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-sm-12" style="padding-left: 14px; margin-top: 15px"><button ladda="vm.isSaving" type="submit" class="btn btn-primary pull-right" data-translate="settings.form.button" ng-disabled="(vm.customShippingForm.$invalid) || (vm.customShipping.id && !vm.customShipping.isActive)">Save</button></div></div></div><div class="col-sm-6"><h3 data-translate="settings.custom-shipping.description-title" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%; text-align: justify" data-translate="settings.custom-shipping.description"></p></div></div></form>');
$templateCache.put('app/admin/settings/shippings/melhor-envio.html','<div class="col-sm-12" style="padding: 0px 0px 0px 15px"><h2 data-translate="settings.shipping.title" style="font-size: 20px; margin-top: 0px"></h2><br></div><div class="col-sm-6"><div class="col-sm-12" style="padding-bottom: 4%"><a><img src="/content/images/melhor_envio.png" border="0" width="150px" height="100%"></a></div><h3 data-translate="settings.shipping.stepTitle"></h3><p data-translate="settings.shipping.step1"></p><p data-translate="settings.shipping.step2"></p><p data-translate="settings.shipping.step3"></p><p data-translate="settings.shipping.step4"></p><p data-translate="settings.shipping.step5"></p><div class="col-sm-12" style="padding-bottom: 4%; padding-left: 0px"><a ladda="vm.loading" type="button" ng-href="{{vm.serviceUrl}}" data-ng-disabled="vm.islocked" class="btn btn-primary" target="_blank" ng-show="!vm.hasShipping" style="margin-right: 3%">{{ \'settings.shipping.createButtonTitle\' | translate }} </a><a ladda="vm.loading" type="button" ng-click="vm.authShipping()" data-ng-disabled="vm.islocked" class="btn btn-primary" ng-show="!vm.hasShipping">{{ \'settings.shipping.connectButtonTitle\' | translate }} </a><a ladda="vm.loading" class="btn btn-primary" ng-click="vm.disconect()" data-ng-disabled="vm.islocked" ng-show="vm.hasShipping">Desconectar</a></div></div><div class="col-sm-6"><h3 data-translate="settings.shipping.melhorEnvioTitle" style="padding-bottom: 2%"></h3><div class="col-sm-12" style="background-color: #f3f3f4; padding: 5%"><p style="font-size: 15px; margin-top: 2%" data-translate="settings.shipping.melhorEnvioDescription"></p><!-- <p style="font-size: 15px; margin-bottom: 2%;" data-translate="settings.paymentConfiguration.wirecardDescription2"></p> --> <a ng-href="{{vm.serviceUrl}}" target="_blank">{{ \'settings.shipping.knowMore\' | translate }}</a></div></div><div class="col-sm-12" style="text-align: center; padding-bottom: 2%; padding-top: 2%"><!-- <h4 data-translate="settings.paymentConfiguration.showkaseDescription"></h4> --></div>');
$templateCache.put('app/admin/settings/shippings/shipping-settings.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-6"><p>Aqui voc\xEA configura as formas de envio para sua loja.</p></div></div><div class="clients-list"><ul class="nav nav-tabs"><li ng-class="{\'active\' : tab == 2}"><a ng-click="tab = 2" ng-init="tab = 2"><i class="fa fa-motorcycle"></i> <span data-translate="settings.custom-shipping.menuTitle">Melhor Envio</span></a></li><li ng-class="{\'active\' : tab == 1}"><a ng-click="tab = 1" ng-hide="vm.islocked" ng-init="tab = 2"><i class="fa fa-truck"></i> <span data-translate="settings.shipping.menuTitle">Melhor Envio</span> </a><a ng-click="vm.openModal();" ng-hide="!vm.islocked" ng-init="tab = 2"><i class="fa fa-truck"></i> <span data-translate="settings.shipping.menuTitle">Melhor Envio</span> <span ng-if="vm.islocked" style="margin-left: 10px" class="navbar-float-right label label-primary">PRO</span></a></li><li ng-class="{\'active\' : tab == 3}"><a ng-click="tab = 3"><i class="icon-ksc-store"></i> <span data-translate="settings.clique-retire.menuTitle">Clique Retire</span></a></li></ul><div class="tab-content"><div id="tab-1" class="tab-pane active" ng-show="tab == 1"><div class="panel-body" ng-include="\'app/admin/settings/shippings/melhor-envio.html\'"></div></div><div class="row" ng-show="tab == 2"><div class="col-sm-12"><div id="tab-2" class="tab-pane active" ng-show="tab == 2"><div class="panel-body" has-authority="STORE_MENU_SETTINGS_SHIPPING" ng-include="\'app/admin/settings/shippings/custom-shipping.html\'"></div></div></div></div><div class="row" ng-show="tab == 3"><div class="col-sm-12"><div id="tab-3" class="tab-pane active" ng-show="tab == 3"><div class="panel-body" ng-include="\'app/admin/settings/shippings/clique-retire.html\'"></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/settings/showcase/showcase-settings.html','<div class="col-sm-6" style="padding-top: 15px"><div class="row col-md-12 col-xs-12" style="margin-top: 5px; margin-bottom: 10px; margin-left: 0px; margin-right: 0px; column-gap: unset"><label class="control-label" data-translate="settings.showcase.general.stepFilters">Filters</label></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="col-md-4 col-xs-4" style="padding-left: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.showcaseSettings.colorFilterEnabled"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.showcase.general.filter.color"></span></label></div></div><div class="col-md-4 col-xs-4" style="padding-left: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.showcaseSettings.priceFilterEnabled"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.showcase.general.filter.price"></span></label></div></div><div class="col-md-4 col-xs-4" style="padding-left: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.showcaseSettings.genderFilterEnabled"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.showcase.general.filter.gender"></span></label></div></div></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="col-md-4 col-xs-4" style="padding-left: 0px; padding-right: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.showcaseSettings.configurationFilterEnabled"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.showcase.general.filter.configuration"></span></label></div></div><div class="col-md-4 col-xs-4" style="padding-left: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.showcaseSettings.brandFilterEnabled"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.showcase.general.filter.brand"></span></label></div></div><div class="col-md-4 col-xs-4" style="padding-left: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.showcaseSettings.categoryFilterEnabled"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.showcase.general.filter.category"></span></label></div></div></div><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="col-md-4 col-xs-4" style="padding-left: 0px; padding-right: 0px"><div class="checkbox"><label><input type="checkbox" class="dropdown-item-checkbox" ng-model="vm.showcaseSettings.sizeFilterEnabled"> <span class="checkbox-material"><span class="check"></span> </span><span data-translate="settings.showcase.general.filter.size"></span></label></div></div></div><div class="col-sm-12" style="margin-bottom: 4%"><button type="button" class="btn btn-primary" style="margin-right: 3%; margin-top: 4%" ng-click="vm.updateSettings()">{{ \'settings.form.button\' | translate }}</button></div></div>');
$templateCache.put('app/admin/settings/showcase/showcase.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-6"><p data-translate="settings.showcase.desc">Aqui voc\xEA configura sua vitrine.</p></div></div><div class="clients-list"><ul class="nav nav-tabs"><li ng-class="{\'active\' : tab == 1}"><a class="Tab-title" ng-click="tab = 1" ng-init="tab = 1"><i class="fa icon-ksc-showcase-light"></i> <span data-translate="settings.showcase.general.title">General</span></a></li></ul><div class="tab-content"><div id="tab-1" class="tab-pane active" ng-show="tab == 1"><div class="panel-body" ng-include="\'app/admin/settings/showcase/showcase-settings.html\'"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/showcases/banner-modal/banners_modal.html','<style>.sub-title {\n        font-size: 1.0em;\n    }\n\n    md-select-menu md-content {\n        -webkit-overflow-scrolling: fixed !important;\n    }\n\n    .md-select-menu-container {\n        z-index: 3000 !important;\n    }\n\n    .custom-md-input md-input-container {\n        display: inherit;\n        margin: unset;\n        border: 0;\n    }\n\n    .custom-md-input md-select.md-default-theme .md-select-value,\n    md-select .md-select-value {\n        border-color: rgba(0, 0, 0, 0.12) !important;\n        border: 1px;\n        border-style: solid;\n        padding-left: 8px;\n    }\n\n    .custom-select[multiple] .md-select-value span:first-child {\n        visibility: collapse;\n    }\n\n    .custom-select[multiple] .md-select-value .md-text {\n        display: inline-block !important;\n        visibility: visible;\n        background-color: rgb(224, 224, 224);\n        border-radius: 6px;\n        padding: 3px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected],\n    md-select-menu md-content md-option[selected] {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .md-select-value {\n        padding: 5px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected]:focus,\n    md-select-menu md-content md-option[selected]:focus {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-checkbox-enabled.md-default-theme[selected] .md-icon,\n    .md-checkbox-enabled[selected] .md-icon {\n        background-color: var(--main-color) !important;\n    }\n\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\n    md-select-menu md-content md-option:not([disabled]):focus,\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\n    md-select-menu md-content md-option:not([disabled]):hover {\n        background: none;\n    }\n\n    .highlight {\n        background: #f3f3f4;\n        padding: 5px;\n        display: inline-block;\n        color: var(--main-color-dark);\n        border-radius: 10px;\n        padding-bottom: 2px;\n        padding-top: 2px;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    md-select-menu {\n        margin-top: 50px;\n        width: 150.674px !important;\n        margin-left: 39px;\n    }\n\n    .remove-dropdown {\n        display: none !important;\n    }\n\n    .empty-list md-select-menu {\n        margin-top: 42px;\n        width: 192.674px !important;\n        margin-left: -1px;\n    }\n\n    md-select.md-default-theme[disabled] .md-select-value,\n    md-select[disabled] .md-select-value {\n        background-image: none !important;\n    }\n\n    .modal-options-body {\n        position: relative;\n        padding: 5px;\n    }\n\n    .modal-header {\n        border-bottom: 0;\n    }\n\n    .md-select-value {\n        border-bottom-width: 1px !important;\n        padding-bottom: 5px !important;\n    }</style><div id="modal" class="main-modal"><div id="filter-flyer-modal" class="modal-header"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h1 class="modal-title">{{\'showcases.detail.banner.title\' | translate}}</h1><span class="sub-title">{{\'showcases.detail.banner.subTitle\' | translate}}</span></div><div class="modal-options-body"><div style="max-height: 500px; overflow-x: hidden"><div class="row" ng-repeat="banner in vm.banners"><div id="{{banner.id}}" class="row col-md-12"><div class="col-md-6"><label style="margin-left: 15px; font-size: 15px">{{\'showcases.detail.banner.banner\' | translate}} {{$index + 1}}</label></div><div class="col-md-6" ng-if="banner.id != vm.banners[0].id || banner.image != \'content/images/1-image-default-banner.png\' || banner.name != \'\' || banner.link != \'\'"><div style="text-align: end"><div style="display: inline-block" ng-click="vm.removeBanner($index);"><span class="fa fa-trash" style="font-size: 1.2em; color: #5b5b5b" aria-hidden="true">&nbsp;</span> <span style="color: #5b5b5b">{{\'showcases.detail.banner.remove\' | translate}}</span></div></div></div><div class="col-md-12"><div class="col-md-6 col-sm-12"><div class="form-group col-md-8 col-sm-12 col-xs-12 mb-0"><label class="required" for="bannerName" data-translate="showcases.detail.banner.web" style="color: #5b5b5b">Web</label><input type="file" id="fileInput{{$index}}" style="display: none" accept="image/x-png,image/jpeg,image/png"><div class="ibox showcase-logo-box no-margins" style="width: 100%; margin-bottom: 8px !important" ng-click="vm.selectImg($index)"><div class="product-image border-select-modal" style="height: 85px; text-align: initial; position: relative; background-color: #f4f4f5" ng-class="{\'border-zero\': (banner.image !== \'\') }"><div style="height: 100%; width: 100%"><img id="img{{$index}}" style="height: 100%; width: 100%; object-fit: cover" ng-src="{{banner.image}}"></div></div></div></div><div class="form-group col-md-4 col-sm-4 col-xs-5 mb-0" style="padding: 0 25px 0 15px"><label for="bannerName" data-translate="showcases.detail.banner.mobile" style="color: #5b5b5b">Mobile</label><input type="file" id="fileInputMobile{{$index}}" style="display: none" accept="image/x-png,image/jpeg,image/png"><div class="ibox showcase-logo-box no-margins" style="width: 100%; margin-bottom: 8px !important" ng-click="vm.selectImgMobile($index)"><div class="product-image border-select-modal" style="height: 85px; text-align: initial; position: relative; background-color: #f4f4f5" ng-class="{\'border-zero\': (banner.image !== \'\') }"><div style="height: 100%; width: 100%"><img id="imgMobile{{$index}}" ng-style="{\'object-fit\': banner.imageMobile === vm.DEFAULT_IMAGE ? \'cover\' : \'fill\'}" style="height: 100%; width: 100%" ng-src="{{banner.imageMobile}}"></div></div></div></div><span class="col-md-12 col-xs-12" data-translate="showcases.detail.banner.imagePropertiesTitle" style="color: #a2a3a4; margin-top: 5px"></span> <span class="col-md-12 col-xs-12 pr-0" data-translate="showcases.detail.banner.imagePropertiesSubitle" style="color: #a2a3a4; margin-top: 5px"></span></div><div class="form-group col-md-6 col-sm-12 col-xs-12" style="margin-top: 20px"><div class="form-group"><label for="bannerName" data-translate="showcases.detail.banner.name" style="color: #5b5b5b">Banner name</label><input id="bannerName" name="bannerName" ng-model="banner.name" type="text" class="form-control" placeholder="Ex: Campanha semanal"><label for="bannerLink" data-translate="showcases.detail.banner.link" style="color: #5b5b5b; margin-top: 15px">Link do banner</label><input id="bannerLink" name="bannerLink" ng-model="banner.link" type="text" class="form-control" placeholder="Ex: https://sualoja.showkase.com.br"></div></div></div></div></div></div><div class="row" style="margin-top: 10px"><div class="col-md-12" style="margin-left: 15px"><span class="fa fa-plus" style="font-size: 1.2em; color: var(--main-color-dark)" aria-hidden="true">&nbsp;</span> <span style="color: var(--main-color-dark); font-weight: 500" ng-click="vm.addNewBanner();">{{\'showcases.detail.banner.addNewBanner\' | translate}}</span></div></div></div><div id="footer-new-conversation" class="modal-footer"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.closeModal()"><span>{{\'flyers.button.cancel\' | translate}}</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.applyBanners()"><span>{{\'showcases.detail.banner.add\' | translate}}</span></button></div></div>');
$templateCache.put('app/admin/showcases/custom-html-modal/custom-html-modal.html','<style>.sub-title {\n        font-size: 1.0em;\n    }\n\n    md-select-menu md-content {\n        -webkit-overflow-scrolling: fixed !important;\n    }\n\n    .md-select-menu-container {\n        z-index: 3000 !important;\n    }\n\n    .custom-md-input md-input-container {\n        display: inherit;\n        margin: unset;\n        border: 0;\n    }\n\n    .custom-md-input md-select.md-default-theme .md-select-value,\n    md-select .md-select-value {\n        border-color: rgba(0, 0, 0, 0.12) !important;\n        border: 1px;\n        border-style: solid;\n        padding-left: 8px;\n    }\n\n    .custom-select[multiple] .md-select-value span:first-child {\n        visibility: collapse;\n    }\n\n    .custom-select[multiple] .md-select-value .md-text {\n        display: inline-block !important;\n        visibility: visible;\n        background-color: rgb(224, 224, 224);\n        border-radius: 6px;\n        padding: 3px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected],\n    md-select-menu md-content md-option[selected] {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .md-select-value {\n        padding: 5px;\n    }\n\n    .custom-select-value .md-select-menu.md-default-theme md-content md-option[selected]:focus,\n    md-select-menu md-content md-option[selected]:focus {\n        color: rgba(0, 0, 0, 0.84);\n    }\n\n    .custom-select-value .md-checkbox-enabled.md-default-theme[selected] .md-icon,\n    .md-checkbox-enabled[selected] .md-icon {\n        background-color: var(--main-color) !important;\n    }\n\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):focus,\n    md-select-menu md-content md-option:not([disabled]):focus,\n    md-select-menu.md-default-theme md-content md-option:not([disabled]):hover,\n    md-select-menu md-content md-option:not([disabled]):hover {\n        background: none;\n    }\n\n    .highlight {\n        background: #f3f3f4;\n        padding: 5px;\n        display: inline-block;\n        color: var(--main-color-dark);\n        border-radius: 10px;\n        padding-bottom: 2px;\n        padding-top: 2px;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    md-select-menu {\n        margin-top: 50px;\n        width: 150.674px !important;\n        margin-left: 39px;\n    }\n\n    .remove-dropdown {\n        display: none !important;\n    }\n\n    .empty-list md-select-menu {\n        margin-top: 42px;\n        width: 192.674px !important;\n        margin-left: -1px;\n    }\n\n    md-select.md-default-theme[disabled] .md-select-value,\n    md-select[disabled] .md-select-value {\n        background-image: none !important;\n    }\n\n    .modal-options-body {\n        position: relative;\n        padding: 5px;\n    }\n\n    .modal-header {\n        border-bottom: 0;\n    }\n\n    .md-select-value {\n        border-bottom-width: 1px !important;\n        padding-bottom: 5px !important;\n    }</style><div id="modal" class="main-modal"><div id="custom-html-modal" class="modal-header"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h1 class="modal-title">{{\'showcases.detail.customHtml.title\' | translate}}</h1><span class="sub-title">{{\'showcases.detail.customHtml.subTitle\' | translate}}</span></div><div class="col-md-12"><div class="form-group"><textarea id="customHtml" placeholder="{{\'showcases.detail.customHtml.placeholder\' | translate}}" name="customHtml" class="form-control" ng-model="vm.customHtml" rows="15">\n            </textarea></div></div><div id="footer-new-conversation" class="modal-footer"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.closeModal()"><span>{{\'flyers.button.cancel\' | translate}}</span></button> <button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.clear()"><span>Limpar</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.save()"><span>{{\'flyers.button.save\' | translate}}</span></button></div></div>');
$templateCache.put('app/admin/showcases/modal/_modal_user_interact.html','<div id="user-interact-modal"><div class="modal-header"><h2 class="modal-title" data-translate="showcases.detail.userInteract.options.title">Selecione o tipo da vitrine</h2></div><div class="modal-body"><div class="container-fluid"><div class="row" style="padding-bottom: 20px; text-align: center; padding-top: 20px"><p data-translate="showcases.detail.userInteract.options.info">O tipo da Vitrine representa a forma como voc\xEA vai disponibilizar os seus produtos ou servi\xE7os na Internet. Cada um deles tem uma caracter\xEDstica espec\xEDfica que vai ajudar na opera\xE7\xE3o dos seus neg\xF3cios.</p></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12"><a uib-tooltip="{{\'showcases.detail.userInteract.options.tooltip.coupon\' | translate}}" tooltip-trigger="mouseenter" ng-click="vm.selectIntentionType(\'COUPON\')"><div id="btnCoupon" ng-class="{\'box-user-interact-btn-selected\': vm.intentionType === \'COUPON\', \'box-user-interact-btn\': vm.intentionType !== \'COUPON\'}"><div style="text-align: center; padding-top: 20px"><i class="icon-ksc-activecoupon" style="font-size: 8em"></i><p class="user-interact-btn-text" data-translate="showcases.detail.userInteract.options.coupon">Coupon</p></div></div></a></div><div class="col-lg-6 col-md-6 col-sm-12"><a uib-tooltip="{{\'showcases.detail.userInteract.options.tooltip.sale\' | translate}}" tooltip-trigger="mouseenter" ng-click="vm.selectIntentionType(\'SALE\')"><div id="btnSale" ng-class="{\'box-user-interact-btn-selected\': vm.intentionType === \'SALE\', \'box-user-interact-btn\': vm.intentionType !== \'SALE\'}"><div style="text-align: center; padding-top: 20px"><i class="icon-ksc-admin-type-sale" style="font-size: 8em"></i><p class="user-interact-btn-text" data-translate="showcases.detail.userInteract.options.sale">Sale</p></div></div></a></div></div></div><div class="row" style="padding: 30px 0 0 0" ng-if="vm.intentionType === \'CONTACT\' && !vm.store.social.whatsApp"><div class="col-xs-12"><div class="alert alert-warning"><p>{{\'showcases.detail.userInteract.contactAlert\' | translate}} <a ng-click="vm.goToDetail()">{{ \'showcases.detail.userInteract.goToStoreDetail\' | translate }}</a></p></div></div></div><div class="row" style="padding: 30px 0 0 0" ng-if="vm.intentionType === \'RENT\' && !vm.storeOwnerHasMoipAccount" has-authority="BANK_CONFIG"><div class="col-xs-12"><div class="alert alert-warning"><p>{{ \'showcases.detail.userInteract.rentAlert\' | translate }} <a ng-click="vm.goToSettings()">{{ \'showcases.detail.userInteract.goToStoresSettings\' | translate }}</a></p></div></div></div><div class="row" style="padding: 30px 0 0 0" ng-if="vm.intentionType === \'SALE\' && !vm.storeOwnerHasMoipAccount" has-authority="BANK_CONFIG"><div class="col-xs-12" ng-if="!vm.store.social.whatsApp"><div class="alert alert-warning"><p>{{ \'showcases.detail.userInteract.saleWhatsAppAlert\' | translate }} <a ui-sref="store-detail({fromStep: true})">{{ \'showcases.detail.userInteract.goToStoreDetail\' | translate }}</a></p></div></div><div class="col-xs-12"><div class="alert alert-warning"><p>{{ \'showcases.detail.userInteract.saleAlert\' | translate }} <a ng-click="vm.goToSettings()">{{ \'showcases.detail.userInteract.goToStoresSettings\' | translate }}</a></p></div></div></div><div class="row" style="padding: 30px 0 0 0" ng-if="vm.intentionType === \'RENT\' && !vm.storeOwnerHasMoipAccount && !vm.isStoreOwner"><div class="col-xs-12"><div class="alert alert-warning"><p>{{ \'showcases.detail.userInteract.notOwnerRentAlert\' | translate }}</p></div></div></div><div class="row" style="padding: 30px 0 0 0" ng-if="vm.intentionType === \'SALE\' && !vm.storeOwnerHasMoipAccount && !vm.isStoreOwner"><div class="col-xs-12"><div class="alert alert-warning"><p>{{ \'showcases.detail.userInteract.notOwnerSaleAlert\' | translate }}</p></div></div></div></div><div class="modal-footer"><button id="btnBack" ng-click="vm.goBack()" class="btn btn-default btn-md" data-style="slide-left" ng-if="(vm.intentionType === undefined || vm.selectedType === undefined)"><span data-translate="showcases.detail.userInteract.back">Back</span></button> <button ng-click="vm.cancel()" class="btn btn-default btn-md" data-style="slide-left" ng-if="vm.selectedType !== undefined"><span data-translate="showcases.detail.userInteract.cancel">Cancel</span></button> <button id="btnNext" ng-click="vm.next()" class="btn btn-primary btn-md" data-style="slide-left" ng-disabled="!vm.intentionType"><span data-translate="showcases.detail.userInteract.next">Pr\xF3ximo</span></button></div></div>');
$templateCache.put('app/admin/showcases/select-colors-modal/select-colors-modal.html','<style>.color-content {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .pickr .pcr-button {\n        height: 7em !important;\n        width: 7em !important;\n        border-radius: 12px !important;\n        border: 1px solid rgb(190, 190, 190) !important;\n        display: block;\n        margin: auto;\n    }\n    .pickr .pcr-button::after, .pickr .pcr-button::before {\n        border-radius: 12px !important;\n    }\n\n    @media (min-width: 768px) {\n        .select-colors-container {\n            display: flex;\n            justify-content: center;\n        }\n    }\n\n    .color-info {\n        text-wrap: nowrap;\n    }\n\n    @media (min-width: 768px) {\n        .modal-dialog {\n            width: 725px;\n            margin: 30px auto;\n        }\n    }</style><div id="modal" class="main-modal"><div class="modal-header"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h1 class="modal-title" data-translate="showcases.detail.color-modal.title">Personalizar as cores da vitrine</h1></div><div class="modal-body"><div class="select-colors-container"><div class="color-content col-md-4 col-xs-12"><label class="required" data-translate="showcases.detail.color-modal.background-color" for="background-color-picker"></label><div class="background-color-picker" id="background-color-picker"></div><p class="color-info text-muted text-center m-t" data-translate="showcases.detail.color-modal.background-color-subtitle"></p></div><div class="color-content col-md-4 col-xs-12"><label data-translate="showcases.detail.color-modal.header-color" for="header-color-picker"></label><div class="header-color-picker" id="header-color-picker"></div><p class="color-info text-muted text-center m-t" data-translate="showcases.detail.color-modal.header-color-subtitle"></p></div><div class="color-content col-md-4 col-xs-12"><label data-translate="showcases.detail.color-modal.icons-color" for="icon-color-picker"></label><div class="icon-color-picker" id="icon-color-picker"></div><p class="color-info text-muted text-center m-t" data-translate="showcases.detail.color-modal.icons-color-subtitle"></p></div></div></div><div id="footer-new-conversation" class="modal-footer"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.closeModal()"><span>{{\'flyers.button.cancel\' | translate}}</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.save()"><span>{{\'flyers.button.save\' | translate}}</span></button></div></div>');
$templateCache.put('app/components/login/main-login/main-login.html','<style>.container-fluid{\n\tbackground-size: cover !important;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-attachment: fixed;\n}\n.input-two-factor{\n    width: 14%;\n    height: 60px;\n    font-size: 30px;\n    font-size-adjust: 0.4;\n    text-align: center;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    margin-right: 5px;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    /* display: none; <- Crashes Chrome on hover */\n    -webkit-appearance: none;\n    margin: 0; /* <-- Apparently some margin are still there even though it\'s hidden */\n}\n\ninput[type=number] {\n    -moz-appearance:textfield; /* Firefox */\n}</style><div class="container-fluid" style="padding-left: 0px; padding-right: 0px; width: 100%; height: 100%" ng-style="{\'background-image\': \'url(https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/background-login.png)\'}"><div class="middle-box text-center loginscreen animated fadeInDown" style="display: table; height: 100% ; min-width: 305px"><div style="display: table-cell; vertical-align: middle; height: 100%"><div class="col-xs-12" style="margin-bottom: 30px; padding-left: 0px; padding-right: 0px"><img class="img-responsive" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/logo-login.png" style="min-width: 100px"></div><div class="col-xs-12"><div id="authenticationError" class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div><div id="accountExpiredError" class="alert alert-danger" ng-show="vm.accountExpiredError" data-translate="login.messages.error.accountExpired"><strong>Account Expired!</strong> Regularize your account and try access again.</div></div><div ng-if="!vm.hasTwoFactorAuth"><a ui-sref="direct-register" class="page-external-font" style="color: #f0f0f0 !important; font-size: 1.5em; font-family: Roboto !important" ng-if="vm.isHubShowkase"><small data-translate="login.messages.newAccount"></small> <small class="page-external-navy" data-translate="login.messages.createAccount" style="color: #45CE84; font-family: Roboto !important">Sign up</small></a><form class="m-t" name="vm.loginForm" role="form" ng-submit="vm.login()" novalidate><div class="form-group"><input type="text" class="form-control page-external-input-2 external-control" id="usernameOrEmail" placeholder="{{\'global.form.usernameoremail\' | translate | lowercase}}" ng-model="vm.usernameOrEmail" required></div><div class="form-group"><input type="password" class="form-control page-external-input-2 external-control" id="password" placeholder="{{\'global.form.password\' | translate | lowercase}}" ng-model="vm.password" required></div><button style="background-color: #45CE84; border-color: #45CE84" ladda="vm.isAuthenticating" id="btn-login" type="submit" ng-disabled="vm.loginForm.$invalid" class="btn btn-primary block full-width m-b no-borders" ng-style="{\'background\': \'url(https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/image-backgroud-button.png) repeat\'}"><span data-translate="login.form.button">Login</span></button> <a ui-sref="requestReset" style="color: #f0f0f0 !important; font-family: Roboto" class="page-external-font" data-translate="login.messages.forgotPassword"><small style="font-family: Roboto !important">Forgot password?</small></a></form></div><div ng-if="vm.hasTwoFactorAuth"><a class="page-external-font" style="color: #f0f0f0 !important; font-size: 20px; font-family: Roboto !important"><small>Insira o c\xF3digo de confirma\xE7\xE3o que enviamos para <b>{{vm.authEmail}}</b> . </small><small ng-click="vm.resendCode()" class="page-external-navy" style="color: #45CE84; font-family: Roboto !important">Reenviar</small></a><form class="m-t" name="vm.twoAuthForm" role="form" ng-submit="vm.loginWithCode()" novalidate><div class="form-group"><input ng-paste="vm.applyValue($event)" id="code1" type="text" move-next-on-maxlength maxlength="1" class="input-two-factor" ng-model="vm.code1" required> <input ng-paste="vm.applyValue($event)" id="code2" type="text" move-next-on-maxlength maxlength="1" class="input-two-factor" ng-model="vm.code2" required> <input ng-paste="vm.applyValue($event)" id="code3" type="text" move-next-on-maxlength maxlength="1" class="input-two-factor" ng-model="vm.code3" required> <input ng-paste="vm.applyValue($event)" id="code4" type="text" move-next-on-maxlength maxlength="1" class="input-two-factor" ng-model="vm.code4" required> <input ng-paste="vm.applyValue($event)" id="code5" type="text" move-next-on-maxlength maxlength="1" class="input-two-factor" ng-model="vm.code5" required> <input ng-paste="vm.applyValue($event)" id="code6" type="text" move-next-on-maxlength maxlength="1" class="input-two-factor" ng-model="vm.code6" required></div><button id="submitbtn" style="background-color: #45CE84; border-color: #45CE84" ladda="vm.isAuthenticating" id="btn-login" type="submit" ng-disabled="vm.twoAuthForm.$invalid" class="btn btn-primary block full-width m-b no-borders selector" ng-style="{\'background\': \'url(https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/image-backgroud-button.png) repeat\'}"><span>Enviar</span></button> <a ng-click="vm.backToLogin()" style="color: #f0f0f0 !important; font-size: 15px; font-family: Roboto" class="page-external-font"><small style="font-family: Roboto !important"><b>Voltar</b></small></a></form></div></div></div></div>');
$templateCache.put('app/components/modal/instagram-login/instagram-login-modal.html','<div class="modal-header" style="background-image: linear-gradient(to right, #be3380, #ec5642)"><button type="button " class="close" data-dismiss="modal " aria-hidden="true " ng-click="vm.cancel()">&times;</button> <img class="logo" src="/content/images/insta_logo_white.png" width="80px"></div><div class="modal-body"><div ng-if="!vm.confirmAccessRequired" class="well login-box center-block" style="text-align: center; width: 370px; height: 380px; background-color: white; padding: 60px; margin-bottom: 0"><img class="logo" src="/content/images/instagram.png" style="height: 70px; margin-bottom: 20px"><p data-translate="socialMedia.fields.sections.instagramModalContent"></p><div style="margin-top: 20px"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><input type="text" class="form-control" id="username" placeholder="{{\'global.form.usernameoremail\' | translate}}" ng-model="vm.usernameOrEmail" required></div><div class="form-group"><input type="password" class="form-control" id="password" placeholder="{{\'global.form.password\' | translate}}" ng-model="vm.password" required></div><button ladda="vm.isAuthenticating" type="submit" class="btn btn-primary" data-translate="global.menu.account.login" style="width: 100%; font-size: 16px; background-color: #337ab7; border-radius: 4px !important">Sign in</button></form></div><div class="col-xs-12"><div id="authenticationError" ng-show="vm.authenticationError" data-translate="socialMedia.error.errorInstagramConnect.wrongPassword" style="color: #a94442"></div></div></div><div ng-if="vm.confirmAccessRequired" class="well login-box center-block" style="background-color: white; margin-bottom: 0"><p class="sc-default-title-font" data-translate="socialMedia.fields.sections.confirmAccess"></p><p class="sc-default-subtitle-font" data-translate="socialMedia.fields.sections.confirmAccessMessage"></p><div data-translate="socialMedia.fields.sections.confirmAccessSteps"></div><div style="text-align: center"><button type="button" class="btn btn-primary" style="padding: 6px 40px" ng-click="vm.cancel()"><span>OK</span></button></div></div></div>');
$templateCache.put('app/components/modal/select-offer/select-offer-modal.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h3 class="modal-title" style="color: #606062; font-size: 1.2em; font-family: Humanst521 Lt BT">{{ vm.title | translate }}</h3></div><div id="select-flyer-section" class="modal-body"><ul role="menu" ng-click="vm.stopPropagation($event)"><div class="showcase-flyer-table"><div class="table-responsive" ng-repeat="flyer in vm.offers track by $index" style="overflow: hidden !important"><table class="table shoping-cart-table"><tbody><tr width="100%"><td width="10%" style="padding: 0 !important"><div class="checkbox" ng-click="$event.stopPropagation()" style="padding: 0 !important"><label><input type="checkbox" class="dropdown-item-checkbox" ng-checked="vm.selectedFlyer.id == flyer.id" ng-click="vm.toggleSelection(flyer)"> <span class="checkbox-material"><span class="check showcase-flyer-table-checkbox"></span></span></label></div></td><td width="10%"><div class="cart-product-imitation showcase-flyer-table-img" style="background-size: 100% 100%; padding-top: 50px !important" ng-style="{\'background-image\': \'url(/flyer/api/{{flyer.id}}/picture?type=small)\'}"></div></td><td class="desc" width="80%"><div style="margin-top: -5px !important"><a class="text-navy"><div class="showcase-flyer-table-name"><p class="product-name showcase-flyer-table-name" style="word-wrap: break-word">{{flyer.name}}</p></div></a></div><span class="fa fa-tag" ng-class="{\'ksc-tag-active\': flyer.status == \'ACTIVATED\', \'ksc-tag-inactive\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}"></span> <span class="showcase-flyer-table-info" ng-class="{\'flyer-active\': flyer.status == \'ACTIVATED\', \'flyer-disabled\': ([\'DEACTIVATED\', \'EXPIRED\', \'CLOSED\'].includes(flyer.status))}">{{(flyer.status == \'ACTIVATED\' ? \'selectOfferModal.offer.button.active\' : \'selectOfferModal.offer.button.disabled\') | translate}} </span><span style="float: right; margin-top: -3px !important"><span class="showcase-product-info-price-normal" ng-if="flyer.discountedValue && flyer.purchaseValue" style="white-space: nowrap"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(flyer.currency)}} </span><span class="coupon-desactived-decoration" ng-if="flyer.discountedValue && flyer.purchaseValue" style="white-space: nowrap">{{flyer.purchaseValue | number : 2}}</span> <span class="showcase-flyer-table-price" ng-if="flyer.discountedValue"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(flyer.currency)}} </span>{{flyer.discountedValue | number : 2}}</span> </span><span class="showcase-flyer-table-price" ng-if="!flyer.discountedValue && flyer.purchaseValue"><span class="flyer-prices-remove-margin">{{vm.getFlyerCurrency(flyer.currency)}} </span>{{flyer.purchaseValue | number : 2}}</span></span></td></tr></tbody></table></div></div><div class="sk-container" align="center" style="height: 10px"><a class="store-upload-button ksc-non-decorated-a" ng-click="vm.loadlFlyers(vm.page + 1)" ng-if="vm.hasNextPage && !vm.busy"><span data-translate="selectOfferModal.button.loadMore">Load more ...</span></a><div class="sk-spinner sk-spinner-wave" ng-if="vm.busy"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></ul><div class="row"><div class="col-lg-12"><button id="button_do_post" ladda="vm.isSaving" class="btn btn btn-primary pull-right" ng-click="vm.confirm()" ng-disabled="vm.selectedFlyers.length <= 0"><span data-translate="selectOfferModal.button.confirm"></span></button></div></div></div>');
$templateCache.put('app/components/util/breadcrumb/uiBreadcrumbs.tpl.html','<div id="breadcrumb" ng-show="current != \'home.pageTitle\' && current != \'reports.home.title\'" class="row wrapper border-bottom white-bg page-heading page-heading-fixed"><div class="col-xs-12"><h2 style="display: inline; float: left">{{current | translate}}</h2><ol class="breadcrumb hidden-xs" style="display: inline; float: right"><li ng-repeat="crumb in breadcrumbs" ng-class="{ active: $last }"><a ui-sref="{{ crumb.route }}" ng-if="!$last">{{ crumb.displayName | translate }}&nbsp;</a> <span ng-show="$last">{{ crumb.displayName | translate }}</span></li></ol></div></div>');
$templateCache.put('app/inspinia/components/common/content.html','<!-- Wrapper--><div id="wrapper"><!-- Navigation --><div ng-include="\'app/inspinia/components/common/navigation.html\'"></div><!-- Page wraper --><!-- ng-class with current state name give you the ability to extended customization your view --><div id="page-wrapper" class="gray-bg {{$state.current.name}}"><!-- Page wrapper --><div ng-include="\'app/inspinia/components/common/topnavbar.html\'"></div><div id="cct" style="margin-top: 46px" ng-show="$state.current.name != \'communication\'"></div><!-- Main view  --><div id="content" class="clickOutsideMenu" ui-view="content" ng-cloak><script>$(\'.clickOutsideMenu\').click( function() {\n                    if ($("body").hasClass("body-small") && $("body").hasClass("mini-navbar")) {\n                        $("body").removeClass("mini-navbar");\n                    }\n                });</script></div><div ng-show="$state.current.name !== \'home\' && $state.current.parent !== \'reports\' && $state.current.name != \'communication\'"><ui-breadcrumbs displayname-property="data.pageTitle" [template-url="" ] [abstract-proxy-property="" ]></ui-breadcrumbs></div><!-- Footer --><div ng-include="\'app/inspinia/components/common/footer.html\'" ng-show="$state.current.name != \'communication\'"></div></div><!-- End page wrapper--></div><!-- End wrapper-->');
$templateCache.put('app/inspinia/components/common/footer.html','<div class="footer"><div class="pull-right"><strong>{{VERSION}}</strong></div><div><strong>Copyright</strong> {{hubNameUpper}} &copy; {{currentYear}}</div></div>');
$templateCache.put('app/inspinia/components/common/ibox_tools.html','<div class="ibox-tools" uib-dropdown><a ng-click="showhide()"><i class="fa fa-chevron-up"></i></a> <a uib-dropdown-toggle="" href><i class="fa fa-wrench"></i></a><ul uib-dropdown-menu><li><a href>Config option 1</a></li><li><a href>Config option 2</a></li></ul><a ng-click="closebox()"><i class="fa fa-times"></i></a></div>');
$templateCache.put('app/inspinia/components/common/navigation.html','<style>.navbar-float-right.label {\n        font-size: 8px;\n        padding: 3px;\n        font-weight: 600;\n        float: right;\n        line-height: 10px;\n    }</style><nav ng-controller="NavigationController as vm" ng-class="(vm.settingsAccount.remainingTime && vm.settingsAccount.remainingTime > 0 && vm.settingsAccount.remainingTime <= 7) ? \'is-trial-sidebar\' : \'\'" class="navbar-default navbar-static-side" role="navigation"><div id="nav-menu" ng-mouseover="vm.openMenu()" ng-mouseleave="vm.closeMenu()" class="sidebar-collapse ksc-navigation-icons"><ul side-navigation class="nav metismenu" id="side-menu"><li class="nav-header" ng-style="{\'background-image\': \'url(https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/header-profile.png)\'}"><div class="profile-element" uib-dropdown><img ng-if="vm.store" alt="image" class="img-circle" ng-src="{{vm.store.logo}}"> <a uib-dropdown-toggle="" href="#" style="text-align: center !important"><span style="min-width: 180px" class="clear"><span class="block m-t-xs text-ellipsis" style="width: 180px"><strong class="font-bold navigation-username">{{vm.store.name}}</strong> </span><span class="text-muted text-xs block navigation-email">{{vm.store.email}} <b class="caret"></b></span></span></a><ul uib-dropdown-menu class="animated flipInX m-t-xs"><li ng-if="vm.userProfile.profileId != 7" role="menuitem"><a ui-sref="store-detail" data-translate="global.menu.account.detail">Info</a></li><li role="menuitem"><a ng-click="vm.logout()" data-translate="global.menu.account.logout">Log out</a></li></ul><div style="text-align: center; margin-top: 5px"><button class="btn-access-store" ng-click="vm.getShowcaseURL()">{{\'global.menu.admin.store-access\' | translate}} <i class="fa fa-share-square-o"></i></button></div></div><div class="logo-element"><i class="icon-ksc-finaluser-showkase"></i></div></li><!-- ======================= PERFIL COM ID 7 \xC9 O PERFIL DE EMBAIXADOR ======================= --><!-- MENU DE IN\xCDCIO --><li ng-if="vm.userProfile.profileId == 7"><a ui-sref="home"><i class="fa fa-th-large"></i> <span class="nav-label" data-translate="global.menu.home">Home</span></a></li><!-- PEDIDOS --><li ng-if="vm.userProfile.profileId == 7" ui-sref-active="active" ng-class="{active: vm.$state.includes(\'invoices\')}" role="menuitem" has-any-authority="STORE_LIST_ORDER"><a ui-sref="invoices"><i class="fa fa-shopping-cart"></i> <span data-translate="global.menu.admin.orders">Pedidos</span></a></li><!-- MALAS --><li ng-if="vm.userProfile.profileId == 7" ui-sref-active="active" ng-class="{active: vm.$state.includes(\'bag\')}" role="menuitem" has-any-authority="STORE_READ_BAG"><a ui-sref="bag" href="#/app/bags"><i class="icon-icon-ksc-admin-bag showcase-new-icon"></i> <span data-translate="global.menu.admin.bags">Bags</span></a></li><!-- RELAT\xD3RIOS --><li ng-if="vm.userProfile.profileId == 7" ng-class="{active: vm.$state.includes(\'seller-individual-performance\')}"><a id="seller-reports"><i class="icon-ksc-reports"></i> <span data-translate="global.menu.admin.reports">Reports</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" id="seller-reports-ul" ng-class="{in: (vm.$state.includes(\'seller-individual-performance\'))}"><li ui-sref-active="active" ng-if="ADMIN_SYSTEM_ID !== vm.userProfile.storeId" ng-class="{active: vm.$state.includes(\'seller-individual-performance\')}"><a ui-sref="seller-individual-performance({report: \'seller-individual-performance\'})" ng-if="!vm.settingsAccount.isHubAdmin"><span style="width: 10px; overflow: hidden" class="nav-label" data-translate="global.menu.admin.seller-individual-performance">My Performance</span></a></li></ul></li><!-- ============================================================================================ --><!-- ======================= MENU LIBERADO PARA TODOS OS OUTROS PERFIS ======================= --><!-- MENU DE IN\xCDCIO --><li ng-if="vm.userProfile.profileId != 7" ng-class="{active: vm.$state.includes(\'home\')}"><a ui-sref="home"><i class="fa fa-th-large"></i> <span class="nav-label" data-translate="global.menu.home">Home</span></a></li><!--MENU ADMIN DE M\xC9TRICAS DOS SERVI\xC7OS --><li ng-if="vm.userProfile.profileId != 7" ng-class="{active: (vm.$state.includes(\'admin\'))}" has-authority="ADMIN_MANAGE_SYSTEM"><a id="admin-menu" href="#"><i class="icon-ksc-categorymetal"></i> <span class="nav-label" data-translate="global.menu.admin.main">Administration</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse"><li><a ui-sref="gateway" data-translate="global.menu.admin.gateway">Gateway</a></li><li><a ui-sref="jhi-tracker" data-translate="global.menu.admin.tracker">User tracker</a></li><li><a ui-sref="jhi-metrics" data-translate="global.menu.admin.metrics">Metrics</a></li><li><a ui-sref="jhi-health" data-translate="global.menu.admin.health">Health</a></li><li><a ui-sref="jhi-configuration" data-translate="global.menu.admin.configuration">Configuration</a></li><li><a ui-sref="audits" data-translate="global.menu.admin.audits">Audits</a></li><li><a ui-sref="logs" data-translate="global.menu.admin.logs">Logs</a></li><li ng-show="vm.swaggerEnabled"><a ui-sref="docs" data-translate="global.menu.admin.apidocs">API</a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><!--MENU ADMIN DE GEST\xC3O DE USU\xC1RIOS E PERFIS --><li ng-if="vm.userProfile.profileId != 7" has-authority="ADMIN_MANAGE_SYSTEM" ng-class="{active: (vm.$state.includes(\'user-management\') || vm.$state.includes(\'profile-management\'))}" has-any-authority="ADMIN_MANAGE_SYSTEM, ADMIN_MANAGE_PROFILE, ADMIN_READ_USER, STORE_READ_USER, STORE_READ_PROFILE"><a id="entity-menu" href="#"><i class="icon-ksc-finaluser-user"></i> <span class="nav-label" data-translate="global.menu.account.main">Account</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse"><li ui-sref-active="active"><a ui-sref="user-management" data-translate="global.menu.admin.userManagement">User management</a></li><li ui-sref-active="active"><a ui-sref="profile-management" data-translate="global.menu.admin.profileManagement">Profile management</a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><!--MENU DE GEST\xC3O DE LOJAS --><li ng-if="vm.userProfile.profileId != 7" has-authority="ADMIN_MANAGE_SYSTEM" ng-class="{active: vm.$state.includes(\'store-management\')}" has-any-authority="STORE_READ"><a ui-sref="store-management"><i class="icon-ksc-store"></i> <span data-translate="global.menu.admin.storeManagement">Store management</span></a></li><!--MENU DO HUB - LOJAS --><li ng-if="vm.userProfile.profileId != 7" ng-class="{active: vm.$state.includes(\'hub-management\')}" has-any-authority="HUB_STORES"><a ui-sref="hub-management"><i class="icon-ksc-store"></i> <span data-translate="global.hub.store">Stores</span></a></li><!--MENU DO HUB - PRODUTOS --><li ng-if="vm.userProfile.profileId != 7" ng-class="{active: vm.$state.includes(\'hub-flyers\') || vm.$state.includes(\'categorys-list\')}" has-any-authority="HUB_PRODUCTS"><a id="hub-flyers"><i class="fa fa-tags"></i> <span data-translate="global.hub.products">Products</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" ng-class="{in: vm.$state.includes(\'hub-flyers\') || vm.$state.includes(\'categorys-list\')}"><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'flyers\')}" role="menuitem" has-any-authority="STORE_READ_FLYER"><a ui-sref="hub-flyers"><span data-translate="global.menu.admin.flyersList">Flyers List</span></a></li><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'categorys-list\')}" role="menuitem" has-any-authority="STORE_READ_FLYER"><a ui-sref="categorys-list"><span data-translate="global.menu.admin.categorysList">categorys</span></a></li></ul></li><!--MENU DO HUB - SHOWKASE CARD --><li ng-if="vm.userProfile.profileId != 7" ng-class="{active: vm.$state.includes(\'gift-card\')}" has-any-authority="ADMIN_HUB"><a ui-sref="gift-card"><i class="fa fa-gift"></i> <span data-translate="global.hub.gift-card">Gift Card</span></a></li><!--MENU DO HUB - VITRINES --><li ng-if="vm.userProfile.profileId != 7" ng-class="{active: vm.$state.includes(\'hub-showcases\')}" has-any-authority="HUB_SHOWKASE"><a ui-sref="hub-showcases"><i class="icon-ksc-showcases"></i> <span data-translate="global.menu.admin.showcaseManagement">Showcases</span></a></li><!--MENU DO HUB - CAMPANHAS --><li ng-if="vm.userProfile.profileId != 7" ng-class="{active: vm.$state.includes(\'hub-campaigns\')}" has-any-authority="HUB_CAMPAIGNS"><a ui-sref="hub-campaigns"><i class="fa fa-bullhorn"></i> <span data-translate="global.hub.campaigns">Campaigns</span></a></li><!--MENU DO HUB - GESTOR DE CONTE\xDADO --><li ng-if="vm.userProfile.profileId != 7" ng-class="{active: vm.$state.includes(\'file-manager\')}" has-any-authority="HUB_FILE_MANAGER"><a ui-sref="file-manager"><i class="fa fa-folder"></i> <span data-translate="global.hub.file-manager">File Manager</span></a></li><!--MENU DA LOJA - PRODUTOS --><li ng-if="vm.userProfile.profileId != 7 && !vm.settingsAccount.isHubAdmin" ng-class="{active: vm.$state.includes(\'flyers\') || vm.$state.includes(\'categorys-list\')}" has-any-authority="STORE_READ_FLYER"><a id="admin-flyers"><i class="fa fa-tags"></i> <span data-translate="global.menu.admin.flyersManagement">Flyers</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" ng-class="{in: vm.$state.includes(\'flyers\') || vm.$state.includes(\'categorys-list\')}"><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'flyers\')}" role="menuitem" has-any-authority="STORE_READ_FLYER"><a ui-sref="flyers"><span data-translate="global.menu.admin.flyersList">Flyers List</span></a></li><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'categorys-list\')}" role="menuitem" has-any-authority="STORE_READ_FLYER"><a ui-sref="categorys-list"><span data-translate="global.menu.admin.categorysList">categorys</span></a></li></ul></li><!--MENU DA LOJA - VENDAS --><li ng-if="vm.userProfile.profileId != 7 && !vm.settingsAccount.isHubAdmin" ng-class="{active: vm.$state.includes(\'showcases\') || vm.$state.includes(\'invoices\') || vm.$state.includes(\'rent-invoices\')}" has-any-authority="STORE_READ_SHOWCASE"><a id="admin-sales"><i class="fa fa-shopping-cart"></i> <span data-translate="global.menu.admin.sales">Vendas</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" ng-class="{in: (vm.$state.includes(\'showcases\') || vm.$state.includes(\'invoices\') || vm.$state.includes(\'rent-invoices\') || vm.$state.includes(\'showcases\'))}"><!--MENU DA LOJA - PEDIDOS --><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'invoices\') || vm.$state.includes(\'rent-invoices\')}" role="menuitem" has-any-authority="STORE_LIST_ORDER"><a ui-sref="invoices"><span data-translate="global.menu.admin.orders">Pedidos</span></a></li><!--MENU DA LOJA - VITRINES --><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'showcases\')}" role="menuitem" has-any-authority="STORE_READ_SHOWCASE"><a ui-sref="showcases" href="#/app/showcases"><span data-translate="global.menu.admin.showcaseManagement">Showcases</span></a></li><!--MENU DA LOJA - MALA VIRTUAL --><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'bag\')}" role="menuitem" has-any-authority="STORE_READ_BAG"><a ui-sref="bag" href="#/app/bags"><span data-translate="global.menu.admin.bags">Bags</span> <span class="navbar-float-right label label-primary" has-plan="ESSENCIAL">SHOWKASE</span></a></li></ul></li><!--MENU DA LOJA - MARKETING --><li ng-if="vm.userProfile.profileId != 7 && !vm.settingsAccount.isHubAdmin" ng-class="{active: vm.$state.includes(\'discount-coupons\') || vm.$state.includes(\'store-file-manager\')}" has-any-authority="STORE_READ_COUPON, STORE_READ_FILE_MANAGER"><a id="admin-coupons"><i class="fa fa-bullhorn"></i> <span data-translate="global.menu.admin.marketing">Marketing</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" ng-class="{in: (vm.$state.includes(\'discount-coupons\') || vm.$state.includes(\'store-file-manager\'))}"><!--MENU DA LOJA - GESTOR DE CONTE\xDADO --><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'store-file-manager\')}" role="menuitem" ng-if="!vm.settingsAccount.isHubAdmin && vm.hubId" has-any-authority="STORE_READ_FILE_MANAGER"><a id="admin-file-manager" ui-sref="store-file-manager"><span data-translate="global.hub.file-manager">File Manager</span> <span ng-if="vm.isMoipPlanFree" class="navbar-float-right label label-primary">PRO</span></a></li><!--MENU DA LOJA - CUPONS DE DESCONTO --><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'discount-coupons\')}" role="menuitem" has-any-authority="STORE_READ_COUPON"><a id="list-order" ui-sref="discount-coupons"><span data-translate="global.menu.admin.cupons">Cupons de Desconto</span></a></li><!--MENU DE RELAT\xD3RIO DE CARRINHO ABANDONADO --><li ui-sref-active="active" ng-if="ADMIN_SYSTEM_ID !== vm.userProfile.storeId" ng-class="{active: vm.$state.includes(\'abandoned-cart-dashboard\')}"><a ui-sref="abandoned-cart-dashboard({report: \'abandoned-cart\'})" ng-if="!vm.settingsAccount.isHubAdmin"><span style="width: 10px; overflow: hidden" class="nav-label" data-translate="global.menu.admin.abandoned-cart-dashboard">Abandoned Cart</span></a></li></ul></li><!--MENU DA LOJA - ATENDIMENTO --><li ng-if="vm.userProfile.profileId != 7" ng-class="{active: vm.$state.includes(\'communication\')}" has-any-authority="SEND_MESSAGE_TO_WATI, SEND_MESSAGE_TO_FACEBOOK"><a ui-sref="communication" href="#/app/communication"><i class="fa fa-comments"></i> <span data-translate="global.menu.admin.communication"></span> <span class="navbar-float-right label label-primary" has-plan="ESSENCIAL,SHOWKASE,IMPULSO">ESCALA</span></a></li><!--MENU DA LOJA - RELACIONAMENTO --><li ng-if="vm.userProfile.profileId != 7 && !vm.settingsAccount.isHubAdmin && !vm.isMoipPlanFree" ng-class="{active: vm.$state.includes(\'customers\')}" has-any-authority="STORE_READ_CUSTOMER"><a id="admin-relationship"><i class="fa fa-users"></i> <span data-translate="global.menu.admin.relationship">Relacionamento</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" ng-class="{in: vm.$state.includes(\'customers\')}"><!--MENU DA LOJA - CLIENTES --><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'customers\')}" role="menuitem" has-any-authority="STORE_READ_CUSTOMER"><a id="admin-customers" ui-sref="customers"><span data-translate="global.menu.admin.customers">Customers</span> <span ng-if="vm.isMoipPlanStarter || vm.isMoipPlanFree" class="navbar-float-right label label-primary" has-plan="ESSENCIAL,SHOWKASE">IMPULSO</span></a></li><!--MENU DE RELAT\xD3RIO DE PERFORMANCE DO CHAT --><li ui-sref-active="active" ng-if="ADMIN_SYSTEM_ID !== vm.userProfile.storeId" ng-class="{active: vm.$state.includes(\'crm-dashboard\')}"><a ui-sref="crm-dashboard({report: \'crm\'})" ng-if="!vm.settingsAccount.isHubAdmin"><span style="width: 10px; overflow: hidden" class="nav-label" data-translate="global.menu.admin.crm-dashboard">CRM</span></a></li></ul></li><!--MENU DA LOJA - RELAT\xD3RIOS --><li ng-if="vm.userProfile.profileId != 7" ng-class="{active: vm.$state.includes(\'consumers\') || vm.$state.includes(\'engagements\') || vm.$state.includes(\'store-rating\')\n                    || vm.$state.includes(\'hub-performance\') || vm.$state.includes(\'hub-subscriptions\') || vm.$state.includes(\'store-performance\')\n                    || vm.$state.includes(\'chat-performance\') || vm.$state.includes(\'seller-performance\')}" has-any-authority="STORE_MANAGE_REPORT, ADMIN_HUB" id="list-reports-li"><a id="admin-reports"><i class="icon-ksc-reports"></i> <span data-translate="global.menu.admin.reports">Reports</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" id="list-reports-ul" ng-class="{in: (vm.$state.includes(\'consumers\') || vm.$state.includes(\'engagements\') || vm.$state.includes(\'store-rating\')\n                    || vm.$state.includes(\'hub-performance\') || vm.$state.includes(\'hub-subscriptions\') || vm.$state.includes(\'store-performance\')\n                    || vm.$state.includes(\'chat-performance\') || vm.$state.includes(\'seller-performance\'))}"><!--MENU DE RELAT\xD3RIO DE PERFORMANCE DA LOJA --><li ui-sref-active="active" ng-if="ADMIN_SYSTEM_ID !== vm.userProfile.storeId" has-any-authority="STORE_READ_PERFORMANCE" ng-class="{active: vm.$state.includes(\'store-performance\')}"><a ui-sref="store-performance" ng-if="!vm.settingsAccount.isHubAdmin"><!-- <span style="width: 10px; overflow: hidden" class="nav-label"\n                                    uib-tooltip="Performance da Loja"\n                                    data-translate="global.menu.admin.store-performance-ellipses" has-plan="ESSENCIAL,SHOWKASE">Store Performance</span> --> <span style="width: 10px; overflow: hidden" class="nav-label" data-translate="global.menu.admin.store-performance">Store Performance</span></a></li><!--MENU DE RELAT\xD3RIO DE PERFORMANCE DO CHAT --><li ui-sref-active="active" ng-if="ADMIN_SYSTEM_ID !== vm.userProfile.storeId" ng-class="{active: vm.$state.includes(\'chat-performance\')}"><a ui-sref="chat-performance({report: \'chat-performance\'})" ng-if="!vm.settingsAccount.isHubAdmin"><span style="width: 10px; overflow: hidden" class="nav-label" data-translate="global.menu.admin.chat-performance">Chat Performance</span></a></li><!--MENU DE RELAT\xD3RIO DE PERFORMANCE DO CHAT --><li ui-sref-active="active" ng-if="ADMIN_SYSTEM_ID !== vm.userProfile.storeId" ng-class="{active: vm.$state.includes(\'seller-performance\')}"><a ui-sref="seller-performance({report: \'seller-performance\'})" ng-if="!vm.settingsAccount.isHubAdmin"><span style="width: 10px; overflow: hidden" class="nav-label" data-translate="global.menu.admin.seller-performance">Seller Performance</span></a></li><!--MENU DE RELAT\xD3RIO DE CONSUMIDORES --><li ui-sref-active="active" ng-if="false" ng-class="{active: vm.$state.includes(\'consumers\')}" role="menuitem" has-any-authority="STORE_MANAGE_REPORT_CUSTOMER"><a ui-sref="consumers"><span data-translate="global.menu.admin.consumers">Consumers</span> <span ng-if="vm.isMoipPlanFree" class="navbar-float-right label label-primary">PRO</span></a></li><!--MENU DE RELAT\xD3RIO DE ENGAJAMENTO COM AS OFERTAS --><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'engagements\')}" role="menuitem" has-any-authority="STORE_MANAGE_REPORT_ENGAGEMENT_WITH_OFFERS"><a ui-sref="engagements"><span data-translate="global.menu.admin.engagementWithOffers">Engagement with offer</span> <span ng-if="vm.isMoipPlanFree" class="navbar-float-right label label-primary">PRO</span></a></li><!--MENU DE RELAT\xD3RIO DE AVALIA\xC7\xD5ES DA LOJA --><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'store-rating\')}" role="menuitem" has-any-authority="STORE_MANAGE_REPORT_STORE_RATING"><a ui-sref="store-rating"><!-- <span data-translate="global.menu.admin.storeRatingEllipses"\n                                uib-tooltip="Avalia\xE7\xF5es da Loja" has-plan="ESSENCIAL,SHOWKASE">Store Rating</span> --> <span data-translate="global.menu.admin.storeRating" uib-tooltip="Avalia\xE7\xF5es da Loja">Store Rating</span></a></li><!--MENU DE RELAT\xD3RIOS DO HUB --><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'hub-performance\')}" role="menuitem" has-any-authority="STORE_MANAGE_REPORT_HUB_PERFORMANCE"><a ui-sref="hub-performance({report: \'hub-performance\'})" data-translate="global.menu.admin.hub-performance">Hub Performance</a></li><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'hub-malwee-painel-multibrand\')}" role="menuitem" has-any-authority="STORE_MANAGE_REPORT_PAINEL_MULTIBRAND" ng-if="vm.hubId == 5"><a ui-sref="hub-malwee-painel-multibrand({report: \'malwee-panel-multibrand\'})" data-translate="global.menu.admin.hub-malwee-painel-multibrand">Hub Painel Multi Brand</a></li><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'hub-subscriptions\')}" role="menuitem" has-any-authority="STORE_MANAGE_REPORT_HUB_SUBSCRIPTIONS"><a ui-sref="hub-subscriptions({report: \'subscriptions\'})" data-translate="global.menu.admin.hub-subscriptions">Hub Subscriptions</a></li></ul></li><!--MENU DA LOJA - CANAIS DE COMUNICA\xC7\xC3O --><li ng-if="vm.userProfile.profileId != 7" ng-class="{active: vm.$state.includes(\'social-integrations\')}" has-any-authority="SOCIAL_INTEGRATIONS"><a ui-sref="social-integrations"><i class="fa fa-instagram"></i> <span data-translate="global.menu.admin.socialMedias">Redes Sociais</span></a></li><!--MENU DA LOJA - REDES SOCIAIS --><li ng-if="false" ng-class="{active: vm.$state.includes(\'social-medias\')}" has-any-authority="SOCIAL_MEDIA_POST, SOCIAL_MEDIA_LOGIN"><a ui-sref="social-medias"><i class="fa fa-comments"></i> <span data-translate="global.menu.admin.socialMedias">Social Medias</span> <span ng-if="vm.isMoipPlanStarter || vm.isMoipPlanFree" class="navbar-float-right label label-primary">PRO</span></a></li><hr style="margin-top: 10px; margin-bottom: 10px"><!--MENU DA LOJA - CONFIGURA\xC7\xD5ES --><li ng-if="vm.userProfile.profileId != 7" ng-class="{active: (vm.$state.includes(\'payments\') || vm.$state.includes(\'shippings\') || vm.$state.includes(\'erps\') || vm.$state.includes(\'marketing\') || vm.$state.includes(\'communication-settings\') || vm.$state.includes(\'showcase\'))}" has-authority="STORE_MENU_SETTINGS" id="list-settings-li"><a id="admin-settings"><i class="fa fa-gears"></i> <span data-translate="global.menu.admin.settings">Settings</span><!-- <span class="Badge Badge--news Badge--small">\n                        <i class="Badge-icon icon-star"\n                        tooltip-placement="top"\n                        uib-tooltip="Temos novidades">\n                        </i>\n                    </span> --> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" id="list-settings-payment-shipping" ng-class="{in: (vm.$state.includes(\'payments\') || vm.$state.includes(\'shippings\') || vm.$state.includes(\'erps\') || vm.$state.includes(\'marketing\') || vm.$state.includes(\'communication-settings\') || vm.$state.includes(\'showcase\'))}"><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'payments\')}" role="menuitem" has-any-authority="STORE_MENU_SETTINGS_PAYMENTS"><a ui-sref="payment-settings"><span data-translate="global.menu.admin.payments">Payments</span> <span ng-if="vm.isMoipPlanFree" class="navbar-float-right label label-primary">PRO</span></a></li><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'shippings\')}" role="menuitem" has-any-authority="STORE_MENU_SETTINGS_SHIPPING"><a ui-sref="shipping-settings"><span data-translate="global.menu.admin.shipping">Envios</span></a></li><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'marketing\')}" role="menuitem" has-any-authority="SEND_MESSAGE_TO_WATI, SEND_MESSAGE_TO_FACEBOOK"><a ui-sref="marketing-settings"><span data-translate="global.menu.admin.marketing">Marketing</span><!-- <span class="Badge Badge--news Badge--small">\n                                <i class="Badge-icon icon-star"></i>Novo\n                            </span> --><!-- <span class="navbar-float-right label label-primary" has-plan="ESSENCIAL,SHOWKASE,IMPULSO">ESCALA</span> --></a></li><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'communication-settings\')}" role="menuitem"><a ui-sref="communication-settings"><span data-translate="global.menu.admin.communication">Communication</span><!-- <span class="Badge Badge--news Badge--small">\n                                <i class="Badge-icon icon-star"></i>Novo\n                            </span> --><!-- <span class="navbar-float-right label label-primary" has-plan="ESSENCIAL">SHOWKASE</span> --></a></li><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'erps\')}" role="menuitem"><a ui-sref="erps-settings"><span data-translate="global.menu.admin.erp">ERP</span> <span class="navbar-float-right label label-primary" has-plan="ESSENCIAL">SHOWKASE</span></a></li><li ui-sref-active="active" ng-class="{active: vm.$state.includes(\'showcase\')}" role="menuitem"><a ui-sref="showcase-settings"><span data-translate="global.menu.admin.showcase">Showcase</span></a></li></ul></li><!--MENU DA LOJA - CARTAZISTA DIGITAL --><li ng-if="vm.userProfile.profileId != 7 && vm.storeCategory !== \'FASHION\'" ng-class="{active: vm.$state.includes(\'poster-create-new\')}" has-any-authority="POSTER_CREATE"><a ui-sref="poster-create-new"><i class="fa fa-paint-brush"></i> <span data-translate="global.menu.admin.digitalPoster">Digital Poster</span> <span ng-if="vm.isMoipPlanStarter || vm.isMoipPlanFree" class="navbar-float-right label label-primary">PRO</span></a></li><!-- ============================================================================================================================== --></ul></div></nav><script>function setScrollSize() {\n        $(".slimScrollShowkaseMenu").slimScroll({\n            height: $(window).height()\n        });\n    }\n\n    $(document).ready(function () {\n        setScrollSize()\n    });\n    $(window).on(\'resize\', function () {\n        setScrollSize()\n    });</script>');
$templateCache.put('app/inspinia/components/common/topheader.html','<div class="page-header-external" style="height: 80px" ng-style="{\'background-color\':\'{{hubStyle.data.mainColor}}\'}"><div class="container page-external-header-menu" style="height: 100%"><ul class="list-inline" style="height: 100%"><li class="col-xs-6 page-external-header-menu" style="margin: 0px !important; padding: 0px !important"><a ui-sref="main-login"><img class="img-responsive img-logo-topheader" style="width: 180px" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/logo.png"></a></li><li class="col-xs-6 page-external-header-menu" align="right"><ul class="list-inline" style="float: right"><li><a href="https://wa.me/558398931539" target="_blank" style="color: #fff">{{\'global.menu.help\' | translate}}</a></li></ul></li></ul></div></div>');
$templateCache.put('app/inspinia/components/common/topnavbar.html','<div ng-controller="TopNavbarController as vm" class="row border-bottom"><div class="trial-content" ng-if="vm.isTrial(vm.account)"><span><strong>{{vm.getTrialWarningMessage()}}</strong> <a ng-href="/checkout" data-translate="global.top-navbar.button.sign-now" style="margin-left: 10px" class="sign-now btn btn-sm btn-primary">Assinar Agora</a></span></div><div ng-if="vm.isIntegrationFailed() && vm.configuration.partnerId == 10" class="trial-content" style="background-color: #fff3cd; border: 1px solid; border-color: #faebcc"><span style="color: #8a6d3b"><strong>{{vm.getIntegrationTokenFailedWarningMessage()}} </strong><a ui-sref="erps-settings" data-translate="global.top-navbar.button.config-access" class="warning-app btn btn-sm btn-primary" style="margin-left: 10px">Acessar Configura\xE7\xF5es</a></span></div><div ng-if="vm.isIntegrationFailed() && (vm.configuration.partnerId == 8 || vm.configuration.partnerId == 9)" class="trial-content" style="background-color: #fff3cd; border: 1px solid; border-color: #faebcc"><span style="color: #8a6d3b"><strong>{{vm.getIntegrationUnexpectedWarningMessage()}} </strong><a ng-href="{{vm.getWhatsappIntegrationMessage()}}" data-translate="global.top-navbar.button.contact-support" target="_blank" class="warning-app btn btn-sm btn-primary" style="margin-left: 10px">Falar com Suporte</a></span></div><nav ng-class="(vm.isTrial(vm.account) || vm.isIntegrationFailed()) ? \'is-trial\' : \'not-trial\'" class="navbar navbar-fixed-top white-bg" role="navigation" style="margin-bottom: 0"><div class="navbar-header ksc-navbar-linkLeft"><span minimaliza-sidebar></span></div><ul class="nav navbar-top-links navbar-right ksc-navbar-top-links right-configuration-menu"><li style="display: inline-block" uib-dropdown ng-if="!vm.isAdminAccount && (vm.myStores && vm.myStores.length > 0)" has-authority="STORE_READ"><a uib-dropdown-toggle=""><div style="max-width:20ch; text-overflow: ellipsis;overflow: hidden; white-space: nowrap; display: inline-block; vertical-align: bottom"><strong class="sc-default-title-capitalize right-configuration-store-name" ng-bind="vm.store.name | lowercase"></strong></div><i id="BtnStoreLink" class="icon-ksc-store" style="font-size: 1.35em"></i></a><ul uib-dropdown-menu ng-if="!vm.myStoresLoading" class="dropdown-menu dropdown-messages right-configuration-menu-items"><div ng-repeat="store in vm.myStores" ng-click="vm.changeSession(store.id)" class="store-top-nav-item" style="outline: 0; min-height: 45px"><li style="min-height: 38px"><div class="dropdown-messages-box"><a class="pull-left"><img class="img-sm" ng-src="{{store.storeLogo}}" err-src="content/images/defaultShowcaseImage.png"></a><div class="media-body"><strong class="sc-default-title-capitalize">{{store.nickname | lowercase}}</strong>.<br><small class="text-muted">{{store.numberOfPoints}} <span data-translate="navigation.salespoint">sales points</span></small></div></div></li><li class="divider"></li></div><li ui-sref="store-management"><div class="text-center link-block"><a class="ksc-navbar-top-space-links"><i id="SeeAllStoresBtn" class="icon-ksc-store"></i> <strong data-translate="navigation.showAllStores">See all stores</strong></a></div></li></ul><ul ng-if="vm.myStoresLoading" class="dropdown-menu dropdown-messages"><li><div class="dropdown-messages-box"><div class="media-body"><strong data-translate="global.loading">Loading</strong><strong>...</strong></div></div></li></ul></li><li ng-if="false" uib-dropdown dropdown ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle ksc-navbar-top-space-links" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><i class="fa fa-globe"></i></a><ul class="m-t-xs ng-scope dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li><li ng-if="vm.userProfile.profileId != 7"><a class="count-info showNotificationsList" ng-click="vm.openNotificationsModal()"><p ng-if="vm.notificationsCount > 0" class="label" style="border-radius: 50px; background-color: crimson; color: white">{{vm.notificationsCount}}</p><i class="fa fa-bell"></i></a></li><li><a class="launchShowkaseBeamer count-info" href="#" aria-expanded="false"><i class="fa fa-bullhorn"></i></a></li><li has-plan="ESCALA"><a class="showCheckList" aria-expanded="false" ng-click="vm.openChecklistModal()"><i class="fa fa-tasks"></i></a></li><li uib-dropdown><a class="ksc-navbar-top-space-links"><i uib-dropdown-toggle class="glyphicon glyphicon-option-vertical"></i></a><ul uib-dropdown-menu class="m-t-xs ng-scope right-configuration-menu-items"><li><a ng-if="!vm.account.isHubAdmin && vm.hub.id != 4" ng-click="vm.changeState(\'gift-card-validate\')" data-translate="global.menu.account.showkaseCard">ShowKase Card</a></li><li><a ng-click="vm.changeState(\'settings\')" data-translate="global.menu.account.settings">Settings</a></li><li><a ng-click="vm.changeState(\'password\')" data-translate="global.menu.account.password">Password</a></li><li ng-click="vm.logout()"><a id="logoutBtn" data-translate="global.menu.account.logout">Logout</a></li></ul></li></ul></nav></div>');
$templateCache.put('app/integrations/facebook-business/auth-modal/fb-auth.modal.html','<style>.md-autocomplete-suggestions-container {\n        z-index: 2051 !important;\n    }\n\n    .progress-bar-success {\n        background-color: var(--main-color) !important;\n    }</style><div><div class="modal-header" style="border: 0px; padding: 0px; height: 100px"><div class="col-lg-12"><button id="btCloseModalAddCustomer" style="margin-top: 2%" type="button" class="close" data-dismiss="modal" ng-click="vm.closeModal()">&times;</button><div class="text-center m-t-lg"><h1>{{vm.modalTitle().title}}</h1><p>{{vm.modalTitle().subTitle}}</p></div></div></div><div class="modal-body" style="border: 0px"><div class="tab-content" style="min-height: 235px; background-color: white"><div class="sk-container" align="center" style="height: 10px; padding-top: 15%" ng-if="vm.processing"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-if="vm.currentStep === 0" ng-show="!vm.processing" id="tab-business" class="active"><div class="row"><div class="col-md-12" style="text-align: center"><button ng-if="!vm.facebook.connected" id="button_facebook" class="btn btn btn-facebook" style="color: white" ng-click="vm.fbLogin()"><span class="fa fa-facebook"></span> <span>|</span> <span data-translate="integrations.facebookBusiness.modal.step1.btn.login">Continuar com facebook</span></button> <button ng-if="vm.facebook.connected" id="button_facebook_logout" class="btn btn btn-facebook" style="color: white" ng-click="vm.fbLogout()"><span class="fa fa-facebook"></span> <span>|</span> <span data-translate="integrations.facebookBusiness.modal.step1.btn.logout">Sair</span></button></div></div><div class="row" style="margin-top: 35px"><div class="col-md-12" style="text-align: center"><md-radio-group ng-if="vm.userBusinesses.length && !vm.processing" ng-model="vm.selectedBusiness"><!-- <span style="font-weight: 600" ng-if="!vm.processing"\n                                data-translate="integrations.facebookBusiness.modal.step2.subTitle">\n                                Selecione um neg\xF3cio:\n                            </span> --><md-content class="md-padding" layout-xs="row" layout="row"><div ng-repeat="business in vm.userBusinesses" flex-xs flex-gt-xs="35" layout="column"><md-card style="width:  245px; height: 128px"><md-radio-button class="my-radio" aria-label="{{business.name}}" style="position: absolute; margin: 9px; float: right" flex ng-value="business"></md-radio-button><md-card-title><md-card-title-text style="overflow: auto"><span class="md-headline md-headline-size" style="text-transform:capitalize">{{business.name | limitTo:15}}</span> <span class="md-subhead md-subline-size">{{business.id}}</span></md-card-title-text><md-card-title-media><div class="md-media-sm card-media"><img class="store-img-shadow" ng-src="{{business.profile_picture_uri}}" err-src="content/images/defaultShowcaseImage.png"></div></md-card-title-media></md-card-title><md-card-actions layout="row" layout-align="end center"></md-card-actions></md-card></div></md-content></md-radio-group><span ng-if="!vm.userBusinesses.length && vm.facebook.connected && !vm.processing">Voc\xEA n\xE3o tem nenhum neg\xF3cio criado, Acesse: <a target="_blank" href="https://www.facebook.com/business">https://www.facebook.com/business</a> para criar o seu.</span></div></div></div><!-- STEP 1 --><div ng-if="vm.currentStep === 1" id="tab-pages" ng-show="!vm.processing" ng-init="vm.loadBusinessPages()" class="active"><div class="row"><div class="col-md-12" style="text-align: center"><md-radio-group ng-if="vm.userBusinessesPages.length && !vm.processing" ng-model="vm.selectedBusinessPage"><!-- <span style="font-weight: 600">\n                                Selecione sua pagina:\n                            </span> --><md-content class="md-padding" layout-xs="row" layout="row"><div ng-repeat="page in vm.userBusinessesPages" flex-xs flex-gt-xs="35" layout="column"><md-card style="width:  245px; height: 128px"><md-radio-button class="my-radio" aria-label="{{page.name}}" style="position: absolute; margin: 9px; float: right" flex ng-value="page"></md-radio-button><md-card-title><md-card-title-text style="overflow: auto"><span class="md-headline md-headline-size" style="text-transform:capitalize">{{page.name | limitTo:15}}</span> <span class="md-subhead md-subline-size">{{page.id}}</span></md-card-title-text><md-card-title-media><div class="md-media-sm card-media"><img class="store-img-shadow" ng-src="{{page.cover.source}}" err-src="content/images/defaultShowcaseImage.png"></div></md-card-title-media></md-card-title><md-card-actions layout="row" layout-align="end center"></md-card-actions></md-card></div></md-content></md-radio-group><span ng-if="!vm.userBusinessesPages.length && !vm.processing">Voc\xEA n\xE3o tem nenhuma pagina criada, Acesse: <a target="_blank" href="https://www.facebook.com/pages/creation">https://www.facebook.com/pages/creation</a> para criar o seu.</span></div></div></div><!-- STEP 1 --><!-- STEP 1 --><div ng-if="vm.currentStep === 2" id="tab-insta" ng-show="!vm.processing" ng-init="vm.loadBusinessInsta()" class="active"><div class="row"><div class="col-md-12" style="text-align: center"><md-radio-group ng-if="vm.userInstagramAccounts.length && !vm.processing" ng-model="vm.selectedInstagram"><md-content class="md-padding" layout-xs="row" layout="row"><div ng-repeat="instagram in vm.userInstagramAccounts" flex-xs flex-gt-xs="35" layout="column"><md-card style="width:  245px; height: 128px"><md-radio-button class="my-radio" aria-label="{{instagram.username}}" style="position: absolute; margin: 9px; float: right" flex ng-value="instagram"></md-radio-button><md-card-title><md-card-title-text style="overflow: auto"><span class="md-headline md-headline-size" style="text-transform:capitalize">{{instagram.username | limitTo:15}}</span> <span class="md-subhead md-subline-size">{{instagram.id}}</span></md-card-title-text><md-card-title-media><div class="md-media-sm card-media"><img class="store-img-shadow" ng-src="{{instagram.profile_picture_url}}" err-src="content/images/defaultShowcaseImage.png"></div></md-card-title-media></md-card-title><md-card-actions layout="row" layout-align="end center"></md-card-actions></md-card></div></md-content></md-radio-group><span ng-if="!vm.userInstagramAccounts.length && !vm.processing">Voc\xEA ainda n\xE3o tem conta do instagram em seu neg\xF3cio, Acesse: <a target="_blank" href="https://www.facebook.com/pages/creation">https://business.facebook.com/settings/instagram-accounts</a> para adicionar um instagram ao seu neg\xF3cio</span></div></div></div><div ng-if="vm.currentStep === 3" ng-init="vm.loadAdAcconunts()" ng-show="!vm.processing" id="tab-campaign" class="active"><div class="col-lg-12"><div class="container-fluid" style="background-color: white; padding: 7px 20px 50px 20px"><div ng-show="false" class="col-lg-12" style="padding: 0"><button ladda="vm.processing" type="button" id="btnConfirm" class="btn btn-primary pull-right" ng-click="vm.createAdAccount()" style="width: 200px; margin-top: 10px; margin-bottom: 10px">Criar nova conta de an\xFAncios</button></div><div class="row"><div class="col-md-12" style="text-align: center"><md-radio-group ng-if="vm.userAdAccounts.length && !vm.processing" ng-model="vm.selectedAdAccount"><md-content class="md-padding" layout-xs="row" layout="row"><div ng-repeat="adAccount in vm.userAdAccounts" flex-xs flex-gt-xs="35" layout="column"><md-card style="width:  245px; height: 128px"><md-radio-button class="my-radio" aria-label="{{adAccount.name}}" style="position: absolute; margin: 9px; float: right" flex ng-value="adAccount"></md-radio-button><md-card-title><md-card-title-text style="overflow: auto"><span class="md-headline md-headline-size" style="text-transform:capitalize">{{adAccount.name | limitTo:20}} {{adAccount.name.length > 20 ? \'...\': \'\' }}</span> <span style="padding-top: 0px; font-size: 10px; background-color: #f3f3f4; border-radius: 30px" class="md-subhead md-subline-size">{{adAccount.business_name}}</span> <span style="margin-top: 7px">{{adAccount.created_time | date : \'dd/MM/yyyy\' }}</span></md-card-title-text></md-card-title><md-card-actions layout="row" layout-align="end center"></md-card-actions></md-card></div></md-content></md-radio-group><div ng-if="!vm.userAdAccounts.length"><span>Identificamos que voc\xEA ainda n\xE3o possui uma conta de an\xFAncios no Facebook.</span><br><button ladda="vm.processing" type="button" id="btnConfirm" class="btn btn-primary" ng-click="vm.createAdAccount()" style="width: 200px; margin-top: 10px">Criar conta de an\xFAncios</button></div></div></div><div ng-if="vm.selectedAdAccount && !(vm.selectedAdAccount.funding_source && vm.selectedAdAccount.funding_source_details)"><div class="row"><div class="col-md-12" style="text-align: center"><span>A conta selecionada n\xE3o possui um meio de pagamento, selecione outra ou adicione um meio de pagamento em <a target="_blank" href="https://business.facebook.com/settings/payment-methods?business_id={{vm.selectedBusiness.id}}">https://business.facebook.com</a></span></div></div><div class="row"><div class="col-md-12" style="text-align: center"><span>Ou</span><br><button ladda="vm.processing" type="button" id="btnConfirm" class="btn btn-primary" ng-click="vm.addPaymentMethod()" style="width: 225px; margin-top: 10px; margin-bottom: 10px">Adicione clicando aqui!</button></div></div></div></div></div></div></div><div class="modal-footer" style="border: 0px"><div resizable class="first-steps-home-screen row scaled scaled-fb" aling="center" id="steps-fb"><div class="col-lg-12"><ul><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 0}"></div></li><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 1 || vm.selectedBusinessPage, \'inactive-progress-step\': vm.currentStep < 1 }"></div></li><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 2 || vm.selectedBusinessPage, \'inactive-progress-step\': vm.currentStep < 2 }"></div></li><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 3 || vm.facebook.catalog.id, \'inactive-progress-step\': vm.currentStep < 3 }"></div></li></ul></div></div><div class="col-md-10 col-md-offset-1 m-t-md m-b-md" ng-show="vm.isBuying" style="text-align: left"><span class="h5" ng-if="vm.isCommunication">{{\'communication.connect-modal.meta-sync-conversations\' | translate}}</span><uib-progressbar class="progress-striped active" value="vm.syncProgress" type="success">{{vm.syncProgress}}%</uib-progressbar></div><div class="row" style="text-align: center"><button ladda="vm.isBussy" type="button" id="btnConfirm" data-translate="integrations.facebookBusiness.buttons.next" class="btn btn-primary" ng-click="vm.next()" style="width: 120px" ng-show="vm.currentStep < 3" ng-disabled="vm.nextDisabled()">Pr\xF3ximo</button> <button ladda="vm.isBuying" type="button" id="btnConfirm" data-translate="integrations.facebookBusiness.buttons.finalize" class="btn btn-primary" ng-click="vm.connectFacebook()" style="width: 150px" ng-show="vm.currentStep === 3">Finalizar</button><div class="col-md-12" style="padding-top: 2%"><a ng-show="vm.currentStep > 0" ng-class="{\'disabled-link\': vm.facebook.catalog.id}" ng-if="vm.currentStep !== 0" ng-disable="vm.previousDisabled()" ng-click="vm.previous()"><span ng-disable="true" data-translate="integrations.facebookBusiness.buttons.previous"></span></a></div></div></div></div></div>');
$templateCache.put('app/integrations/facebook-business/campaign-insights-modal/campaign-insights.modal.html','<style>.box-summary {\n        min-height: 100px !important;\n    }\n\n    .chart-campaign {\n        min-height: 240px;\n        max-height: 240px;\n    }\n\n    .box-summary-icon {\n        color: #fe398b;\n        font-size: 1.1em;\n        margin-right: 5px;\n    }</style><div><div class="modal-header" style="border: 0px; padding: 0px"><div class="col-lg-12"><button id="btCloseModalAddCustomer" style="margin-top: 2%" type="button" class="close" data-dismiss="modal" ng-click="vm.closeModal()">&times;</button></div></div><div class="modal-body" style="border: 0px"><div class="tab-content" style="min-height: 235px; background-color: white"><div class="sk-container" align="center" style="height: 10px; padding-top: 15%" ng-if="vm.processing"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div ng-show="!vm.processing" id="tab-business"><div class="row"><div class="col-md-12"><div class="ibox box-summary"><div class="ibox-content"><div class="row"><div class="col-xs-3"><div class="summary"><div class="font-bold text-muted" data-translate="integrations.facebookBusiness.insights.impressions"><small>Impressions</small></div><i class="fa fa-question-circle box-summary-icon" uib-tooltip="{{\'integrations.facebookBusiness.insights.description.impressions\' | translate}}"></i></div><div class="summary"><h2 class="no-margins">{{vm.campaignInsights.impressions || 0}}</h2></div></div><div class="col-xs-3"><div class="summary"><div class="font-bold text-muted" data-translate="integrations.facebookBusiness.insights.reach"><small>Reach</small></div><i class="fa fa-question-circle box-summary-icon" uib-tooltip="{{\'integrations.facebookBusiness.insights.description.reach\' | translate}}"></i></div><div class="summary"><h2 class="no-margins">{{vm.campaignInsights.reach || 0}}</h2></div></div><div class="col-xs-3"><div class="summary"><div class="font-bold text-muted" data-translate="integrations.facebookBusiness.insights.clicks"><small>Clicks</small></div><i class="fa fa-question-circle box-summary-icon" uib-tooltip="{{\'integrations.facebookBusiness.insights.description.clicks\' | translate}}"></i></div><div class="summary"><h2 class="no-margins">{{vm.campaignInsights.clicks || 0}}</h2></div></div><div class="col-xs-3"><div class="summary"><div class="font-bold text-muted" data-translate="integrations.facebookBusiness.insights.frequency"><small>Frequency</small></div><i class="fa fa-question-circle box-summary-icon" uib-tooltip="{{\'integrations.facebookBusiness.insights.description.frequency\' | translate}}"></i></div><div class="summary"><h2 class="no-margins">{{vm.campaignInsights.frequency || 0}}</h2></div></div></div><div class="row" style="margin-top: 10px"><div class="col-xs-3"><div class="summary"><div class="font-bold text-muted">Cpc</div><i class="fa fa-question-circle box-summary-icon" uib-tooltip="{{\'integrations.facebookBusiness.insights.description.cpc\' | translate}}"></i></div><div class="summary"><h2 class="no-margins">{{vm.getCostValue(vm.campaignInsights.cpc)}}</h2></div></div><div class="col-xs-3"><div class="summary"><div class="font-bold text-muted">Cpm</div><i class="fa fa-question-circle box-summary-icon" uib-tooltip="{{\'integrations.facebookBusiness.insights.description.cpm\' | translate}}"></i></div><div class="summary"><h2 class="no-margins">{{vm.getCostValue(vm.campaignInsights.cpm)}}</h2></div></div><div class="col-xs-3"><div class="summary"><div class="font-bold text-muted">Cpp</div><i class="fa fa-question-circle box-summary-icon" uib-tooltip="{{\'integrations.facebookBusiness.insights.description.cpp\' | translate}}"></i></div><div class="summary"><h2 class="no-margins">{{vm.getCostValue(vm.campaignInsights.cpp)}}</h2></div></div><div class="col-xs-3"><div class="summary"><div class="font-bold text-muted">Ctr</div><i class="fa fa-question-circle box-summary-icon" uib-tooltip="{{\'integrations.facebookBusiness.insights.description.ctr\' | translate}}"></i></div><div class="summary"><h2 class="no-margins">{{vm.getRateValue(vm.campaignInsights.ctr)}}</h2></div></div></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="ibox chart-campaign"><div class="ibox-title"><h5 class="no-margins" data-translate="integrations.facebookBusiness.insights.age">Age range</h5></div><div class="ibox-content"><div class="row"><div class="col-md-12"><canvas ng-if="vm.audienceAgeValues && vm.audienceAgeValues.length > 0" class="chart chart-bar" chart-data="vm.audienceAgeValues" chart-labels="vm.audienceAgeLabels" chart-options="vm.barChartOptions"></canvas><h5 ng-if="!vm.audienceAgeValues || vm.audienceAgeValues.length === 0" data-translate="integrations.instagramBusiness.insights.noDataInTime" class="text-center">No data</h5></div></div></div></div></div><div class="col-md-6"><div class="ibox chart-campaign"><div class="ibox-title"><h5 class="no-margins" data-translate="integrations.facebookBusiness.insights.gender">Top locations</h5></div><div class="ibox-content"><div class="row"><div class="col-md-12"><canvas ng-if="vm.audienceGenderValues && vm.audienceGenderValues.length > 0" class="chart chart-pie" chart-data="vm.audienceGenderValues" chart-labels="vm.audienceGenderLabels" chart-options="vm.optionsPie"></canvas><h5 ng-if="!vm.audienceGenderValues || vm.audienceGenderValues.length === 0" data-translate="integrations.instagramBusiness.insights.noDataInTime" class="text-center">No data</h5></div></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="ibox chart-campaign"><div class="ibox-title"><h5 class="no-margins" data-translate="integrations.facebookBusiness.insights.region">Age range</h5></div><div class="ibox-content"><div class="row"><div class="col-md-12"><canvas ng-if="vm.audienceRegionValues && vm.audienceRegionValues.length > 0" class="chart chart-horizontal-bar" chart-data="vm.audienceRegionValues" chart-labels="vm.audienceRegionLabels" chart-options="vm.barChartOptions"></canvas><h5 ng-if="!vm.audienceRegionValues || vm.audienceRegionValues.length === 0" data-translate="integrations.instagramBusiness.insights.noDataInTime" class="text-center">No data</h5></div></div></div></div></div><div class="col-md-6"><div class="ibox chart-campaign"><div class="ibox-title"><h5 class="no-margins" data-translate="integrations.facebookBusiness.insights.platform">Top locations</h5></div><div class="ibox-content"><div class="row"><div class="col-md-12"><canvas ng-if="vm.audiencePlatformValues && vm.audiencePlatformValues.length > 0" class="chart chart-horizontal-bar" chart-data="vm.audiencePlatformValues" chart-labels="vm.audiencePlatformLabels" chart-options="vm.barChartOptions"></canvas><h5 ng-if="!vm.audiencePlatformValues || vm.audiencePlatformValues.length === 0" data-translate="integrations.instagramBusiness.insights.noDataInTime" class="text-center">No data</h5></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/integrations/facebook-business/campaign-modal/fb-campaign.modal.html','<style>.md-autocomplete-suggestions-container {\n        z-index: 2051 !important;\n    }</style><div><div class="modal-header" style="border: 0px; padding: 0px; height: 100px"><div class="col-lg-12"><button id="btCloseModalAddCustomer" style="margin-top: 2%" type="button" class="close" data-dismiss="modal" ng-click="vm.closeModal()">&times;</button><div class="text-center m-t-lg"><h1>{{vm.modalTitle().title}}</h1><p>{{vm.modalTitle().subTitle}}</p></div></div></div><div class="modal-body" style="border: 0px"><div class="tab-content" style="min-height: 235px; background-color: white"><div class="sk-container" align="center" style="height: 10px; padding-top: 15%" ng-if="vm.processing"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><!-- STEP 1 --><div ng-if="vm.currentStep === 0" ng-show="!vm.processing" id="tab-campaign" class="active"><form name="campaignForm"><md-content layout-padding><div class="row"><div class="col-md-4" style="text-align: center"><div style="text-align: initial"><label id="favoriteStateLabel">Selecione a cidade</label><md-autocomplete class="md-whiteframe-2dp ksc-md-search-input" md-input-name="autocompleteField" md-menu-class="autocomplete-custom-template" md-no-cache="true" md-selected-item="vm.selectedCity" md-search-text-change="vm.searchCity(vm.searchText)" md-search-text="vm.searchText" md-selected-item-change="vm.selectedCityChange(city)" md-items="city in vm.querySearch(vm.searchText)" md-item-text="city.name" md-min-length="1" input-aria-labelledby="Buscar cidade" input-aria-describedby="Buscar cidade"><md-item-template><span md-highlight-text="vm.searchText" md-highlight-flags="^i">{{city.name}} - {{city.region}}</span></md-item-template></md-autocomplete></div></div><div class="col-md-3" style="text-align: initial"><md-input-container class="md-block"><label>Valor di\xE1rio (R$)</label><input price-activated="true" price price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" required step="any" name="rate" min="3" ng-model="vm.project.value"><div ng-messages="campaignForm.rate.$error" md-auto-hide="false"><div ng-if="campaignForm.rate.$error.required">Informe o valor do investimento di\xE1rio.</div><div ng-if="vm.project.value < 3">Valor min\xEDmo 3 R$</div></div></md-input-container></div><div class="col-md-3" style="text-align: initial"><md-input-container class="md-block"><label>Quantidade de dias</label><input required type="number" step="any" name="days" min="0" ng-model="vm.project.days"><div ng-messages="campaignForm.days.$error" md-auto-hide="false"><div ng-if="campaignForm.days.$error.required">Informe a quantidade da campanha</div><div ng-if="vm.project.days < 8">Min\xEDmo de dias 8</div></div></md-input-container></div><div class="col-md-2" style="text-align: initial"><md-input-container class="md-block"><label>Total (R$)</label><input ng-disabled="true" type="text" step="any" ng-value="vm.project.total || 0 | currency:\'\':2"></md-input-container></div></div></md-content></form></div><!-- STEP 1v--><!-- STEP 2 --><div ng-if="vm.currentStep === 1" ng-show="!vm.processing" ng-init="vm.loadPreviewInfo()" id="tab-resume" class="active"><md-content class="md-padding" layout-xs="column" layout="row"><div class="col-md-12" style="text-align: center"><div c layout-xs="row" layout="row"><div flex-xs flex-gt-xs="35" layout="column"><span style="align-self: self-end; font-weight: 600" data-translate="integrations.facebookBusiness.modal.step3.businessSelected">Neg\xF3cio Selecionado:</span><md-card style="margin-left: 0px; width:  245px; height: 128px"><md-card-title><md-card-title-text style="overflow: auto"><span class="md-headline md-headline-size">{{vm.selectedBusiness.name | lowercase | limitTo:15}}</span> <span class="md-subhead md-subline-size">{{vm.selectedBusiness.id | lowercase | limitTo:15}}</span></md-card-title-text><md-card-title-media><div class="md-media-sm card-media"><img class="store-img-shadow" ng-src="{{vm.selectedBusiness.profile_picture_uri}}" err-src="content/images/defaultShowcaseImage.png"></div></md-card-title-media></md-card-title><md-card-actions layout="row" layout-align="end center"></md-card-actions></md-card></div><div flex-xs flex-gt-xs="35" layout="column"><span style="align-self: self-end; font-weight: 600">Pagina</span><md-card style="max-height: 128px" ng-if="vm.selectedBusinessPage" style="width:  245px; height: 128px"><md-card-title><md-card-title-text style="overflow: auto"><span class="md-headline md-headline-size">{{vm.selectedBusinessPage.name | lowercase | limitTo:15}}</span> <span class="md-subhead md-subline-size">{{vm.selectedBusinessPage.id | lowercase | limitTo:15}}</span></md-card-title-text><md-card-title-media><div class="md-media-sm card-media"><img class="store-img-shadow" ng-src="{{vm.selectedBusinessPage.picture.data.url}}" err-src="content/images/defaultShowcaseImage.png"></div></md-card-title-media></md-card-title><md-card-actions layout="row" layout-align="end center"></md-card-actions></md-card></div><div flex-xs flex-gt-xs="35" layout="column"><span style="align-self: self-end; font-weight: 600" data-translate="integrations.facebookBusiness.modal.step3.showcaseSelected">Vitrine</span><md-card ng-if="vm.showcase.name" style="width:  245px; height: 128px"><md-card-title><md-card-title-text style="overflow: auto"><span class="md-headline md-headline-size">{{vm.showcase.name | lowercase | limitTo:15}}</span> <span class="md-subhead md-subline-size">{{vm.showcase.userInteract}}</span></md-card-title-text><md-card-title-media><div class="md-media-sm card-media"><img class="store-img-shadow" ng-src="content/images/defaultShowcaseImage.png" err-src="content/images/defaultShowcaseImage.png"></div></md-card-title-media></md-card-title><md-card-actions layout="row" layout-align="end center"></md-card-actions></md-card></div></div><div class="row" style="padding-top: 25px"><div class="col-md-4" style="text-align: initial"><md-input-container class="md-block"><label>Cidade</label><input ng-disabled="true" ng-model="vm.selectedCity.name"></md-input-container></div><div class="col-md-3" style="text-align: initial"><md-input-container class="md-block"><label>Valor di\xE1rio (R$)</label><input ng-disabled="true" price-activated="true" price price-decimal-separator="{{ vm.flyer.currencyInstance.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.flyer.currencyInstance.thousandsSeparator || \'.\' }}" required step="any" name="rate" min="3" ng-model="vm.project.value"><div ng-messages="campaignForm.rate.$error" md-auto-hide="false"><div ng-if="campaignForm.rate.$error.required">Informe o valor do investimento di\xE1rio.</div><div ng-if="vm.project.value < 3">Valor min\xEDmo 3 R$</div></div></md-input-container></div><div class="col-md-3" style="text-align: initial"><md-input-container class="md-block"><label>Quantidade de dias</label><input ng-disabled="true" required type="number" step="any" name="days" min="0" ng-model="vm.project.days"><div ng-messages="campaignForm.days.$error" md-auto-hide="false"><div ng-if="campaignForm.days.$error.required">Informe a quantidade da campanha</div><div ng-if="vm.project.days < 8">Min\xEDmo de dias 8</div></div></md-input-container></div><div class="col-md-2" style="text-align: initial"><md-input-container class="md-block"><label>Total (R$)</label><input ng-disabled="true" type="text" step="any" ng-value="vm.project.total || 0 | currency:\'\':2"></md-input-container></div></div><div class="md-padding pull-left" layout-xs="row" layout="row"><span>Acesse <a target="_blank" href="https://www.facebook.com/products">www.facebook.com/products </a>para visualizar o cat\xE1logo de produtos.</span></div></div></md-content></div><!-- STEP 2 --><div ng-if="vm.currentStep === 2" ng-show="!vm.processing" id="tab-campaign" class="active"><div class="col-lg-12"><div class="container-fluid" style="background-color: white; padding: 7px 20px 50px 20px"><div ng-show="false" class="col-lg-12" style="padding: 0"><button ladda="vm.processing" type="button" id="btnConfirm" class="btn btn-primary pull-right" ng-click="vm.createAdAccount()" style="width: 200px; margin-top: 10px; margin-bottom: 10px">Criar nova conta de an\xFAncios</button></div><div class="row"><div class="col-md-12" style="text-align: center"><md-radio-group ng-if="vm.userAdAccounts.length && !vm.processing" ng-model="vm.selectedAdAccount"><md-content class="md-padding" layout-xs="row" layout="row"><div ng-repeat="adAccount in vm.userAdAccounts" flex-xs flex-gt-xs="35" layout="column"><md-card style="width:  245px; height: 128px"><md-radio-button class="my-radio" aria-label="{{adAccount.name}}" style="position: absolute; margin: 9px; float: right" flex ng-value="adAccount"></md-radio-button><md-card-title><md-card-title-text style="overflow: auto"><span class="md-headline md-headline-size" style="text-transform:capitalize">{{adAccount.name | limitTo:20}} {{adAccount.name.length > 20 ? \'...\': \'\' }}</span> <span style="padding-top: 0px; font-size: 10px; background-color: #f3f3f4; border-radius: 30px" class="md-subhead md-subline-size">{{adAccount.business_name}}</span> <span style="margin-top: 7px">{{adAccount.created_time | date : \'dd/MM/yyyy\' }}</span></md-card-title-text></md-card-title><md-card-actions layout="row" layout-align="end center"></md-card-actions></md-card></div></md-content></md-radio-group><div ng-if="!vm.userAdAccounts.length"><span>Identificamos que voc\xEA ainda n\xE3o possui uma conta de an\xFAncios no Facebook.</span><br><button ladda="vm.processing" type="button" id="btnConfirm" class="btn btn-primary" ng-click="vm.createAdAccount()" style="width: 200px; margin-top: 10px">Criar conta de an\xFAncios</button></div></div></div><div class="row" ng-if="vm.selectedAdAccount && !(vm.selectedAdAccount.funding_source && vm.selectedAdAccount.funding_source_details)"><div class="col-md-12" style="text-align: center"><span>A conta selecionada n\xE3o possui um meio de pagamento, selecione outra ou adicione um meio de pagamento em <a target="_blank" href="https://business.facebook.com/settings/payment-methods?business_id={{vm.selectedBusiness.id}}">https://business.facebook.com </a></span><!-- <button ladda="vm.processing" type="button" id="btnConfirm"\n                                    class="btn btn-primary " ng-click="vm.addPaymentMethod()"\n                                    style="width: 225px; margin-top: 10px; margin-bottom: 10px;">Adicionar meio de\n                                    pagamento</button> --></div></div></div></div></div></div><div class="modal-footer" style="border: 0px"><div resizable class="first-steps-home-screen row scaled scaled-fb" aling="center" id="steps-fb"><div class="col-lg-12"><ul><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 0}"></div></li><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 1 || vm.selectedBusinessPage, \'inactive-progress-step\': vm.currentStep < 1 }"></div></li><!-- <li class="progress-step">\n                            <div\n                                ng-class="{\'active-progress-step\': vm.currentStep >= 2 || vm.selectedBusinessPage, \'inactive-progress-step\': vm.currentStep < 2 }">\n                            </div>\n                        </li> --></ul></div></div><div class="row" style="text-align: center"><button ladda="vm.isBussy" type="button" id="btnConfirm" data-translate="integrations.facebookBusiness.buttons.next" class="btn btn-primary" ng-click="vm.next()" style="width: 120px" ng-show="vm.currentStep < 1" ng-disabled="vm.nextDisabled()">Pr\xF3ximo</button> <button ladda="vm.isBuying" type="button" id="btnConfirm" data-translate="integrations.facebookBusiness.buttons.finalize" class="btn btn-primary" ng-click="vm.createCampaign()" style="width: 150px" ng-disabled="vm.lockCreateCampaign()" ng-show="vm.currentStep === 1">Finalizar</button><div class="col-md-12" style="padding-top: 2%"><a ng-show="vm.currentStep > 0" ng-class="{\'disabled-link\': vm.facebook.catalog.id}" ng-if="vm.currentStep !== 0" ng-disable="vm.previousDisabled()" ng-click="vm.previous()"><span ng-disable="true" data-translate="integrations.facebookBusiness.buttons.previous"></span></a></div></div></div></div></div>');
$templateCache.put('app/integrations/instagram-business/steps-modal/insta-steps.modal.html','<style>.md-autocomplete-suggestions-container {\n        z-index: 2051 !important;\n        /* any number of choice > 1050*/\n    }\n\n    .disabled-link {\n        pointer-events: none;\n        cursor: default;\n        opacity: 0.6;\n    }</style><div><div class="modal-header" style="border: 0px; padding: 0px; height: 95px"><div class="col-lg-12"><button id="btCloseModalAddCustomer" style="margin-top: 2%" type="button" class="close" data-dismiss="modal" ng-click="vm.closeModal()">&times;</button><div class="text-center m-t-lg"><h1>{{vm.modalTitle().title}}</h1><p>{{vm.modalTitle().subTitle}}</p></div></div></div><div class="modal-body" style="border: 0px !important;  text-align: center"><div class="tab-content" style="min-height: 235px; background-color: white"><div ng-if="vm.currentStep === 0" id="tab-campaign" class="active"><div class="col-md-12" style="text-align: center"><div class="md-padding" layout-xs="row" layout="row"><span data-translate="integrations.instagramBusiness.modal.step1.fistLine">Ter um perfil comercial no Facebook e um perfil de empresa no Instagram.</span></div><div class="md-padding" layout-xs="row" layout="row"><span data-translate="integrations.instagramBusiness.modal.step1.secondLine">- Que a sua fanpage e o seu perfil do Instagram estejam cadastrados em uma categoria relacionada \xE0 venda de produtos f\xEDsicos.</span></div><div class="md-padding" layout-xs="row" layout="row"><span data-translate="integrations.instagramBusiness.modal.step1.thirdLine">- Ter uma vitrine publicada na plataforma.</span></div><div class="md-padding" layout-xs="row" layout="row"><span><strong data-translate="integrations.instagramBusiness.modal.step1.fourthLine">- No mais, a gente faz por voc\xEA.</strong></span></div></div></div><div ng-if="vm.currentStep === 1" id="tab-business" ng-init="vm.loadBusiness()" class="active"><div class="row"><div class="col-md-12"><button ng-if="!vm.facebook.connected" id="button_facebook" class="btn btn btn-facebook" style="color: white" ng-click="vm.fbLogin()"><span class="fa fa-facebook"></span> <span>|</span> <span data-translate="integrations.facebookBusiness.modal.step1.btn.login">Continuar com facebook</span></button> <button ng-if="vm.facebook.connected" id="button_facebook_logout" class="btn btn btn-facebook" style="color: white" ng-click="vm.fbLogout()"><span class="fa fa-facebook"></span> <span>|</span> <span data-translate="integrations.facebookBusiness.modal.step1.btn.logout">Sair</span></button></div></div><div class="row" style="margin-top: 35px"><div class="sk-container" align="center" style="height: 10px; padding-top: 10%" ng-if="vm.processing"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><div class="col-md-12" style="text-align: center"><md-radio-group ng-if="vm.userBusinesses.length && !vm.processing" ng-model="vm.selectedBusiness"><md-content class="md-padding" layout-xs="row" layout="row"><div ng-repeat="business in vm.userBusinesses" flex-xs flex-gt-xs="35" layout="column"><md-card style="width:  245px; height: 128px"><md-radio-button class="my-radio" aria-label="{{business.name}}" style="position: absolute; margin: 9px; float: right" flex ng-value="business"></md-radio-button><md-card-title><md-card-title-text style="overflow: auto"><span class="md-headline md-headline-size" style="text-transform:capitalize">{{business.name | limitTo:15}}</span> <span class="md-subhead md-subline-size">{{business.id}}</span></md-card-title-text><md-card-title-media><div class="md-media-sm card-media"><img class="store-img-shadow" ng-src="{{business.profile_picture_uri}}" err-src="content/images/defaultShowcaseImage.png"></div></md-card-title-media></md-card-title><md-card-actions layout="row" layout-align="end center"></md-card-actions></md-card></div></md-content></md-radio-group><span ng-if="vm.userBusinesses && !vm.userBusinesses.length && vm.facebook.connected && !vm.processing"><span data-translate="integrations.instagramBusiness.modal.step1.noBusiness">OPS! Parece que voc\xEA ainda n\xE3o tem um neg\xF3cio criado, Acesse para criar o seu:</span> <a target="_blank" href="https://www.facebook.com/business">https://www.facebook.com/business</a></span></div></div></div><div ng-if="vm.currentStep === 2" id="tab-catalog" class="active"><div class="row"><div class="col-md-12" style="text-align: center; top: 50px"><div flex-xs flex-gt-xs="100" layout-align="center center" layout="column"><div layout-gt-sm="row" layout-padding><div layout="column"><md-input-container style="text-align: initial"><label data-translate="integrations.instagramBusiness.modal.step3.inputCatalogName">Nome do cat\xE1logo</label><input style="width: 260px" ng-required="true" ng-disabled="vm.facebook.catalog.id || !vm.showcase.name" ng-init="vm.catalogName = \'\'" ng-model="vm.catalogName"><md-icon class="fa fa-check" ng-if="vm.facebook.catalog.id" style="display:inline-block; color: green"></md-icon></md-input-container></div><div flex-xs flex-gt-xs="50" layout="column"><button ladda="vm.isBussy" ng-disabled="(!vm.catalogName || vm.facebook.catalog.id) || !vm.showcase.name" ng-click="vm.generateCatalog()" style="margin-top: 17px" type="button" id="btnConfirm" class="btn btn-primary" data-translate="integrations.instagramBusiness.modal.step3.generateCatalogBtn">Gerar cat\xE1logo</button></div></div></div></div></div></div><div ng-if="vm.currentStep === 3" id="tab-campaign" class="active"><div class="col-md-12" style="text-align: center"><span><strong data-translate="integrations.instagramBusiness.modal.step4.title">Agora siga esses passos</strong></span><div class="md-padding" layout-xs="row" layout="row"><span data-translate="integrations.instagramBusiness.modal.step4.fistLine" translate-values="{showcaseName: vm.showcase.name}">Vitrine: {{vm.showcase.name}}</span></div><div class="md-padding" layout-xs="row" layout="row"><span data-translate="integrations.instagramBusiness.modal.step4.secondLine" translate-values="{businessName: vm.selectedBusiness.name}">Seu neg\xF3cio: {{vm.selectedBusiness.name}}</span></div><div class="md-padding" layout-xs="row" layout="row"><span><span data-translate="integrations.instagramBusiness.modal.step4.thirdLine">Veja seu cat\xE1logo: </span><a target="_blank" href="https://www.facebook.com/products">www.facebook.com/products</a></span></div><div class="md-padding" layout-xs="row" layout="row"><span data-translate="integrations.instagramBusiness.modal.step4.fourthLine">Agora \xE9 so aguardar</span></div></div></div><div ng-if="vm.currentStep === 5" id="tab-resume" class="active"><md-content class="md-padding" layout-xs="column" layout="row"></md-content></div></div><div class="modal-footer" style="border: 0px !important; text-align: center; padding-top: 0%"><div resizable class="first-steps-home-screen row scaled" aling="center"><ul style="padding: 0px"><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 0}"></div></li><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 1 || vm.selectedBusinessPage, \'inactive-progress-step\': vm.currentStep < 1 }"></div></li><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 2 || vm.selectedBusinessPage, \'inactive-progress-step\': vm.currentStep < 2 }"></div></li><li class="progress-step"><div ng-class="{\'active-progress-step\': vm.currentStep >= 3 || vm.facebook.catalog.id, \'inactive-progress-step\': vm.currentStep < 3 }"></div></li></ul></div><button type="button" id="btnConfirm" data-translate="integrations.facebookBusiness.buttons.next" class="btn btn-primary" ng-click="vm.next()" ng-show="vm.currentStep <= 2" ng-disabled="vm.nextDisabled()">Prox\xEDmo</button> <button id="btnConfirm" data-translate="integrations.facebookBusiness.buttons.finalize" class="btn btn-primary" ng-click="vm.closeModal()" ng-show="vm.currentStep === 3">Finalizar</button><div class="col-md-12" style="padding-top: 2%"><a ng-class="{\'disabled-link\': vm.facebook.catalog.id}" ng-if="vm.currentStep !== 0" ng-disable="true" ng-click="vm.previous()"><span ng-disable="true" data-translate="integrations.facebookBusiness.buttons.previous"></span></a></div></div></div></div>');
$templateCache.put('app/services/global/block-plan/block-plan.modal.html','<div><div class="modal-header" style="padding: 0px; height: 350px"><div class="col-lg-12"><button id="btCloseModalAddCustomer" style="margin-top: 2%" type="button" class="close" data-dismiss="modal" ng-click="vm.closeModal()">&times;</button><div class="row" style=""><div class="col-md-12" style="text-align: center; margin-top: -10px"><img style="width: 90px" ng-src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/icon-ksc-vendas.png" alt=""></div></div><div class="row" style="margin-top: -20px"><div class="col-md-12"><div class="text-center m-t-lg"><h1 data-translate="global.block-plan.header">Sua loja mais profissional</h1><p data-translate="global.block-plan.sub-header">Impulsione ainda mais as suas vendas com os nossos recursos exclusivos.</p></div></div></div><div class="modal-footer" style="border: 0px !important; text-align: center; padding-top: 3%"><button type="button" class="btn btn-primary ksc-btn-next-padding" ng-click="vm.goToPlan()" ladda="vm.processing"><span data-translate="global.block-plan.buttons.plans">Ver planos</span></button><div class="col-md-12" style="padding-top: 2%"><a ng-click="vm.closeModal()" ng-if="!vm.processing"><span data-translate="global.block-plan.buttons.cancel">Continuar no meu plano atual</span></a></div></div></div></div></div>');
$templateCache.put('app/services/global/change-state/change-state.modal.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" data-translate="global.messages.decline.title">Refuse order</h4></div><div class="modal-body"><p data-translate="global.messages.decline.message">Deseja remover esse item?</p></div><div class="modal-footer"><button type="button" id="btnConfirm" class="btn btn-primary" ng-click="vm.confirm()" data-translate="global.messages.decline.confirm">Remover</button> <button type="button" id="btnCancel" class="btn btn-default" ng-click="vm.closeModal()" data-translate="global.messages.decline.cancel">Cancelar</button></div>');
$templateCache.put('app/services/global/confirm-action/confirm-action.modal.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" data-translate="global.messages.confirm-action.title">Confirmar a\xE7\xE3o</h4></div><div class="modal-body"><span data-translate="global.messages.confirm-action.message">Deseja realmente realizar essa a\xE7\xE3o?</span></div><div class="modal-footer"><button type="button" id="btnConfirm" class="btn btn-primary" ng-click="vm.confirm()" data-translate="global.messages.confirm-action.confirm">Confirmar</button> <button type="button" id="btnCancel" class="btn btn-default" ng-click="vm.closeModal()" data-translate="global.messages.confirm-action.cancel">Cancelar</button></div>');
$templateCache.put('app/services/global/message/message.modal.html','<div class="modal-header" ng-if="vm.withHeader"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title">{{ vm.modalTitle }}</h4></div><div class="modal-body" style="text-align: center; padding: 7%"><i ng-if="vm.centralIcon" class="{{ vm.centralIcon }}" style="font-size: 10em; color: #9aca5b"></i> <img ng-if="vm.imageCentralIcon" ng-src="{{ vm.imageCentralIcon }}" style="{{ vm.imageStyle }}"><p style="padding-top: 5%; font-size: 2em; margin-bottom: 5px" ng-style="vm.fontSizeMessage">{{ vm.modalMessage | translate}}</p><p style="font-size: 1.1em">{{ vm.modalSubMessage | translate }}</p><p ng-if="vm.interactiveTranslate && vm.interactiveFunction && !vm.functionWaiter" style="font-size: 1.1em">{{ vm.interactiveTranslate | translate }} <a href="" ng-click="vm.interactiveFunction()"><b>{{ vm.functionTranslate | translate }}</b></a>.</p><div ng-if="vm.functionWaiter && vm.interactiveFunction" class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><button id="btnOk" ng-if="vm.buttonOk" type="button" class="btn btn-default" style="margin-top: 2%; padding: 6px 40px" ng-click="vm.closeModal()"><span>{{ vm.buttonOk }}</span></button> <button ng-if="vm.buttonBodyMessage" type="button" class="btn btn-primary" style="margin-top: 2%; margin-left: 2%; padding: 6px 40px" ng-click="vm.doAction()"><span>{{ vm.buttonBodyMessage }}</span></button></div><div class="modal-footer" ng-if="vm.withFooter"><button ng-if="!vm.buttonMessage" type="button" class="btn btn-primary" ng-click="vm.closeModal()" data-translate="global.messages.remove.cancel">Cancelar</button> <button ng-if="vm.buttonMessage" type="button" class="btn btn-primary" ng-click="vm.closeModal()">{{ vm.buttonMessage }}</button></div>');
$templateCache.put('app/services/global/message/message.modal.simple.html','<style>button.close {\n        font-size: 3.5em;\n        font-weight: lighter;\n        margin-top: -15px !important;\n    }\n\n    .modal-header, .modal-footer {\n        border: none;\n    }\n\n    .modal-header {\n        padding-top: 20px;\n    }\n\n    .modal-body {\n        padding: 5px 30px 5px 30px;\n    }</style><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title">{{ vm.modalTitle }}</h4></div><div class="modal-body" style="text-align: center"><p style="padding-top: 5%; font-size: 1.5em; margin-bottom: 5px">{{ vm.modalMessage }}</p></div><div class="modal-footer"><button id="btnOk" ng-show="vm.buttonCancelText" type="button" class="btn btn-default" style="margin-top: 2%; padding: 6px 40px" ng-click="vm.closeModal()"><span>{{ vm.buttonCancelText }}</span></button> <button type="button" class="btn btn-primary" style="margin-top: 2%; margin-left: 2%; padding: 6px 40px" ng-click="vm.buttonConfirmAction()"><span>{{ vm.buttonConfirmText }}</span></button></div>');
$templateCache.put('app/services/global/message/warning-modal.html','<style>button.close {\n        font-size: 3.5em;\n        font-weight: lighter;\n    }\n\n    .modal-header, .modal-footer {\n        border: none;\n    }\n\n    .modal-header {\n        padding-top: 5px;\n    }\n\n    .modal-body {\n        padding: 5px 30px 5px 30px;\n    }</style><div class="container-modal-connect" id="modal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button></div><div class="modal-body row"><i class="fa fa-warning col-xs-12 col-md-2" style="color: #fdbe2d; font-size: 5.4em; text-align: center; min-height: 12vh"></i> <span class="col-xs-12 col-md-8" style="font-size: 1.5em; margin-bottom: 5px"><p data-translate>{{ vm.modalMessage }}</p><p style="font-size: 12px; padding-top: 10px" class="text-muted">{{vm.smallText}}</p><p style="font-size: 12px" class="text-muted m-0">{{vm.warningText}}</p></span></div><div class="modal-footer"><button type="button" class="btn btn-primary col-xs-12 col-md-auto pull-right" style="margin-top: 2%; margin-left: 2%; padding: 6px 40px" ng-click="vm.buttonConfirmAction()"><span>{{ vm.buttonConfirmText }}</span></button> <button id="btnOk" ng-show="vm.buttonCancelText" type="button" class="btn btn-default col-xs-12 col-md-auto pull-right" style="margin-top: 2%; padding: 6px 40px" ng-click="vm.closeModal()"><span>{{ vm.buttonCancelText }}</span></button></div></div>');
$templateCache.put('app/services/global/remove/remove-coupon.modal.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" data-translate="global.messages.remove.title">Customers profile</h4></div><div class="modal-body" style="text-align: center; padding: 7%"><p style="padding-top: 5%; font-size: 1.5em; margin-bottom: 5px" data-translate="global.messages.remove.messageCoupon">Deseja remover esse coupon?</p></div><div class="modal-footer"><button type="button" id="btnConfirm" class="btn btn-primary" ng-click="vm.confirm()" data-translate="global.messages.remove.confirm">Remover</button> <button type="button" id="btnCancel" class="btn btn-default" ng-click="vm.closeModal()" data-translate="global.messages.remove.cancel">Cancelar</button></div>');
$templateCache.put('app/services/global/remove/remove.modal.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><h4 class="modal-title" data-translate="global.messages.remove.title">Customers profile</h4></div><div class="modal-body" style="text-align: center; padding: 7%"><p style="padding-top: 5%; font-size: 1.5em; margin-bottom: 5px" data-translate="global.messages.remove.message" translate-value-itens="{{vm.itens}}">Deseja remover esse item?</p></div><div class="modal-footer"><button type="button" id="btnConfirm" class="btn btn-primary" ng-click="vm.confirm()" data-translate="global.messages.remove.confirm">Remover</button> <button type="button" id="btnCancel" class="btn btn-default" ng-click="vm.closeModal()" data-translate="global.messages.remove.cancel">Cancelar</button></div>');
$templateCache.put('app/store/components/common/content.html','<div class="app-header" ng-include="\'app/store/components/common/topnavbar.html\'"></div><!-- Main view  --><div class="app-content" ui-view="content" ng-cloak></div><!-- Footer --><div class="app-footer" ng-include="\'app/store/components/common/footer.html\'"></div>');
$templateCache.put('app/store/components/common/footer.html','<div class="flex-footer-copyright footer-copyright-mobile"><strong>Copyright</strong>&nbsp;{{hubNameUpper}} &copy; 2022</div><div class="flex-footer-version footer-version-mobile"><span>Version</span><strong>&nbsp;v{{VERSION}}</strong>.</div>');
$templateCache.put('app/store/components/common/topnavbar.html','<!-- <div class="app-container">\n    <div class="logo">\n        <img class="img-responsive" style="padding: 10px 0; width: 280px" src="content/images/logoShowkase.png">\n    </div>\n    <div class="menu">\n        <ul>\n            <style>\n                .action:hover {color:white !important;\n                font-weight: bold !important;\n                font-size: 1.1em !important;}\n            </style>\n            <li><a title="Help" class="action">Help</a></li>\n            <span style="color: white">|</span>\n            <li><a title="Home" class="action">Content</a></li>\n        </ul>\n    </div>\n    <div uib-dropdown class="icon" ng-controller="TopNavbarController as vm">\n        <a  id="logout" title="Logout">\n            <i uib-dropdown-toggle="" class="icon-ksc-menu" style="color: white; font-size: 4em"></i>\n            </i>\n            <ul uib-dropdown-menu class="animated flipInX m-t-xs">\n                <li><a data-translate="global.menu.account.settings">Settings</a></li>\n                <li><a  ng-click="vm.logout()" data-translate="global.menu.account.logout">Logout</a></li>\n            </ul>\n        </a>\n    </div>\n</div> --><div class="page-header-external" style="height: 80px" ng-style="{\'background-color\': \'{{hubStyle.data.mainColor}}\'}"><div class="container page-external-header-menu" style="height: 100%"><ul class="list-inline" style="height: 100%"><li class="col-xs-6 page-external-header-menu" style="margin: 0px !important; padding: 0px !important"><a><img class="img-responsive" style="width: 180px" src="https://showkase-prod.s3-sa-east-1.amazonaws.com/hub/system-images/{{urlImage}}/logo.png"></a></li><li class="col-xs-6 page-external-header-menu" align="right"><ul class="list-inline" style="float: right"><li data-translate="global.menu.help" style="color: transparent">Help</li><li style="color: transparent">|</li><li data-translate="global.menu.contact" style="color: transparent">>Contact</li><li uib-dropdown class="icon" ng-controller="TopNavbarController as vm"><a id="logout" title="Logout"><i uib-dropdown-toggle="" class="glyphicon glyphicon-option-vertical" style="color: white; font-size: 2.2em"></i><ul uib-dropdown-menu class="animated flipInX m-t-xs right-configuration-menu-items" style="margin-top: 0"><li style="padding: 0"><a id="logoutBtn" ng-click="vm.logout()" data-translate="global.menu.account.logout" style="color: black; line-height: none;  margin: 0 4px; margin-top: 0; margin-bottom: 0">Logout</a></li></ul></a></li></ul></li></ul></div></div>');
$templateCache.put('app/admin/communication/broadcast-list-modal/steps-new-broadcast-list/new-broadcast-list.html','<style>.inputs-content {\n        flex: 1 1 100%;\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        padding-bottom: 15px;\n    }\n\n    .broadcast-input {\n        padding-bottom: 20px;\n        position: relative;\n    }\n\n    .broadcast-dashboard {\n        background-color: #f5f6fa;\n        overflow: auto;\n        max-height: 30vh;\n        margin-bottom: 35px;\n    }\n\n    .broadcast-dashboard-title {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n    }\n\n    .broadcast-dashboard-title p {\n        margin-left: 5px;\n        margin-bottom: 0;\n    }\n\n    .broadcast-dashboard table {\n        margin-bottom: 0;\n    }\n\n    th {\n        position: sticky;\n        top: 0;\n        background: #f5f6fa;\n        z-index: 2;\n        padding: 15px !important;\n    }\n\n    td {\n        padding: 8px 15px;\n    }\n\n    md-autocomplete-wrap {\n        height: 34px !important;\n        box-shadow: none !important;\n        border: 1px solid #e5e6e7;\n        border-radius: 1px;\n    }\n\n    md-autocomplete input:not(.md-input) {\n        height: 34px;\n    }\n\n    .sk-spinner-circle.sk-spinner {\n        top: 30px;\n        right: 9px;\n        position: absolute;\n    }\n\n    i.success {\n        font-size: 20px;\n        color: #23a455;\n    }\n\n    i.failed {\n        font-size: 20px;\n        color: red;\n    }\n\n    i.pending {\n        font-size: 20px;\n        color: #269cfe;\n    }\n\n    .add-new-template {\n        cursor: pointer;\n        color: #1c84c6;\n        float: right;\n        font-size: 1.1em;\n        font-weight: 500;\n    }\n\n    .add-new-template:hover {\n        color: #68a4cc;\n    }\n\n    .preview-content {\n        background-color: #f8f3ed;\n        padding: 1px 15px 15px;\n        min-height: 55vh;\n        overflow: auto;\n    }\n\n    .preview-text {\n        font-weight: 400;\n        font-size: 1.5em;\n        margin: 10px 0;\n    }\n\n    .message-template-content {\n        background-color: white;\n        padding: 15px;\n    }\n\n    .next-step {\n        position: relative;\n        margin-top: auto;\n        margin-left: auto;\n    }\n\n    .next-step-mobile {\n        width: 100%;\n    }\n\n    .button-content {\n        margin-top: -35px;\n    }\n\n    .button-in-mobile {\n        margin-top: 15px;\n    }\n\n    .btn-template-message {\n        margin-bottom: 10px;\n    }\n\n    .content-in-desktop {\n        position: relative;\n    }\n\n    .preview-in-desktop {\n        height: 100% !important;\n        min-height: auto !important;\n        position: absolute;\n        right: 0;\n    }</style><div class="row" ng-class="{\'content-in-desktop\': !vm.isMobile}"><div class="inputs-content col-md-8" id="inputs-content"><div class="broadcast-input"><label class="required" data-translate="communication.broadcast-list-modal.broadcast-list-name" for="broadcastListName"></label><input class="form-control" id="broadcastListName" name="broadcastListName" ng-model="vm.form.broadcastName" placeholder="{{\'communication.broadcast-list-modal.broadcast-list-name\' | translate}}" required type="text"></div><div class="broadcast-input"><label class="required" data-translate="communication.broadcast-list-modal.template-message-label" for="messageTemplate"></label><md-autocomplete id="messageTemplate" input-aria-labelledby="favoriteStateLabel" md-escape-options="clear" md-input-name="autocompleteFieldMessageTemplate" md-item-text="item.elementName" md-items="item in vm.querySearchTemplate(vm.searchMessageTemplate)" md-min-length="0" md-no-cache="true" md-search-text="vm.searchMessageTemplate" md-selected-item="vm.messageTemplate" md-selected-item-change="vm.selectMessageTemplate(item)" name="messageTemplate" ng-disabled="vm.loadingTemplates" placeholder="{{\'communication.broadcast-list-modal.template-message-select\' | translate}}" required><md-item-template><span md-highlight-flags="^" md-highlight-text="vm.searchMessageTemplate">{{item.elementName}}</span></md-item-template><md-not-found><span data-translate="communication.broadcast-list-modal.template-message-doesnt-exist"></span></md-not-found></md-autocomplete><div class="sk-spinner sk-spinner-circle" ng-if="vm.loadingTemplates"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div><div class="broadcast-dashboard-title" ng-if="!vm.isMobile"><h3 data-translate="communication.broadcast-list-modal.dashboard.broadcast-history"></h3><p data-translate="communication.broadcast-list-modal.dashboard.broadcast-history-days"></p></div><div class="broadcast-dashboard" ng-if="!vm.isMobile"><table class="table invoice-table"><thead><tr><th style="width: 3vw; text-align: center"><span data-translate="communication.broadcast-list-modal.dashboard.send-status"></span></th><th style="text-align: left !important; vertical-align: middle; width: 10vw"><span data-translate="communication.broadcast-list-modal.dashboard.list-name"></span></th><th style="text-align: left !important; vertical-align: middle; width: 10vw"><span data-translate="communication.broadcast-list-modal.dashboard.recipients"></span></th><th style="text-align: left !important; vertical-align: middle; width: 10vw"><span data-translate="communication.broadcast-list-modal.dashboard.failures"></span></th></tr></thead><tbody><tr ng-repeat="data in vm.broadcastDashboard"><td style="text-align: center; vertical-align: middle"><i class="fa" ng-class="{\n                            \'fa-check success\': data.status === \'COMPLETED\' && data.fail < data.recipients,\n                            \'fa-close failed\': data.fail === data.recipients,\n                            \'fa-clock-o pending\': data.status === \'PENDING\'\n                        }"></i></td><td class="custom-aling-td-invoice"><p>{{data.broadcastName}}</p><span>{{data.scheduledAt | date:\'dd/MM/yyyy HH:mm:ss\'}}</span></td><td class="custom-aling-td-invoice">{{data.recipients}}</td><td class="custom-aling-td-invoice">{{data.fail}}</td></tr></tbody></table><div class="sk-container" ng-if="vm.dashboardLoading" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div></div><div class="preview-content col-md-4" id="preview" ng-class="{\'preview-in-desktop\': !vm.isMobile}"><p class="preview-text" data-translate="communication.broadcast-list-modal.template-preview">Pr\xE9via</p><div class="message-template-content" ng-if="vm.messageTemplate"><div ng-if="vm.messageTemplate.data"><video ng-if="vm.messageTemplate.header && vm.messageTemplate.header.type === 3" controls><source src="{{vm.messageTemplate.data}}"></video><img ng-if="vm.messageTemplate.header && vm.messageTemplate.header.type === 2" class="w-100" ng-src="{{vm.messageTemplate.data}}"></div><p ng-bind-html="vm.formatWhatsAppMessage(vm.messageTemplate.bodyOriginal ? vm.messageTemplate.bodyOriginal : vm.messageTemplate.body)" style="word-wrap: break-word"></p><button class="btn btn-second c-gray btn-template-message mr-2" disabled="disabled" ng-if="vm.messageTemplate.buttons" ng-repeat="button in vm.messageTemplate.buttons">{{button.parameter.text}}</button></div></div><div class="col-md-8 button-content" id="next-step" ng-class="{\'button-in-mobile\': vm.isMobile}"><button class="btn btn-primary btn-md next-step pull-right" data-translate="communication.broadcast-list-modal.next-button" ng-class="{\'next-step-mobile\': vm.isMobile}" ng-click="vm.nextStep()" ng-disabled="!vm.selectTemplateValidation()"></button></div></div>');
$templateCache.put('app/admin/communication/broadcast-list-modal/steps-new-broadcast-list/select-contacts.html','<style>.contact-list {\n        background-color: #f5f6fa;\n        border-radius: 5px;\n        max-height: 32vh;\n        overflow-y: auto;\n    }\n\n    .contact-cell .custom-aling-td-invoice, .table > tbody > tr > td, .table > thead > tr > th {\n        padding: 0 8px !important;\n    }\n\n    .import-contacts-container {\n        display: flex;\n        -webkit-box-align: center;\n        align-items: center;\n        gap: 8px;\n        margin-bottom: 17px;\n    }\n\n    .download-template {\n        font-size: 1.1em;\n        text-decoration: underline;\n    }\n\n    .input-group {\n        margin-bottom: 20px;\n    }\n\n    .btn-import-contacts {\n        color: var(--main-color);\n        background-color: white;\n        height: 42px;\n        border-width: 1px;\n        border-color: var(--main-color);\n        border-style: dashed;\n        font-size: 13px;\n    }\n\n    .btn-primary.btn-import-contacts:hover,\n    .btn-primary.btn-import-contacts:focus,\n    .btn-primary.btn-import-contacts:active,\n    .btn-primary.btn-import-contacts.active,\n    .open .dropdown-toggle.btn-primary.btn-import-contacts,\n    .btn-primary.btn-import-contacts:active:focus,\n    .btn-primary.btn-import-contacts:active:hover, .btn-primary.btn-import-contacts.active:hover,\n    .btn-primary.btn-import-contacts.active:focus {\n        background-color: rgba(47, 19, 126, 0.26) !important;\n        color: var(--main-color);\n    }\n\n    .input, .input-group-addon {\n        background-color: #f5f6fa;\n        border: none;\n        border-bottom-left-radius: 5px;\n        border-top-left-radius: 5px;\n    }\n\n    .whatsapp-message-limit {\n        font-size: 15px;\n    }\n\n    .whatsapp-message-limit .info {\n        color: var(--main-color);\n        font-size: 20px;\n    }\n\n    .whatsapp-message-limit .info i {\n        overflow: hidden;\n        margin-bottom: -5px;\n    }\n\n    .table {\n        margin-bottom: 0;\n    }\n\n    th {\n        position: sticky;\n        top: 0;\n        background: #f5f6fa;\n        z-index: 2;\n    }\n\n    .header-sort-by {\n        font-size: 15px;\n        padding: 10px 0;\n    }\n\n    .input-group-addon {\n        color: #c6c6ca;\n    }\n\n    .search-trace {\n        border-right: 1px solid #c6c6ca;\n        height: 50%;\n        display: block;\n        width: 18px;\n        position: absolute;\n        top: 8px;\n        left: 19px;\n    }\n\n    .check {\n        background-color: white;\n    }\n\n    .pagination-content {\n        display: flex;\n        margin-top: 10px;\n        align-content: center;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: flex-end;\n    }\n\n    .pagination-in-mobile {\n        justify-content: center;\n    }\n\n    .lines-per-page {\n        font-size: 15px;\n    }\n\n    .select-lines-per-page {\n        padding: 5px !important;\n    }\n\n    .select-contacts-content {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .buttons-content {\n        margin-left: auto;\n    }\n\n    .back-step {\n        margin-right: 15px;\n    }\n\n    .allow-broadcast-value {\n        color: #23a455;\n        margin-left: 45px;\n        font-size: 20px;\n        text-transform: uppercase;\n    }\n\n    .not-allow-broadcast-value {\n        color: #A42323;\n        margin-left: 45px;\n        font-size: 20px;\n        text-transform: uppercase;\n    }\n\n    .allow-broadcast-label {\n        font-size: 14px;\n        font-weight: 500;\n    }\n\n    .selected-contacts {\n        color: var(--main-color);\n        font-weight: bold;\n    }\n\n    .radio-label {\n        font-size: 15px;\n    }\n\n    .when-send-container {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        margin-top: 10px;\n    }\n\n    .indeterminate-icon {\n        color: var(--main-color);\n        position: absolute;\n        top: 7px;\n        left: 5px;\n        z-index: 100;\n    }\n\n    .checkbox .checkbox-material .check.indeterminate-checkbox {\n        border-color: var(--main-color) !important;\n    }\n\n    .no-contacts-found {\n        text-align: center;\n        margin: 15px;\n        font-size: 15px;\n    }</style><div class="select-contacts-content"><div class="input-group form-group col-md-12"><span class="input-group-addon"><i class="fa fa-search"></i> </span><span class="search-trace"></span> <input class="input form-control" ng-change="vm.refreshContacts()" ng-model="vm.filters.searchString" ng-model-options="{ debounce: 500 }" placeholder="{{\'communication.broadcast-list-modal.search-contact\' | translate}}" type="text"></div><div class="import-contacts-container" ng-style="{\'flex-wrap\': vm.isMobile ? \'wrap\' : \'nowrap\'}"><input class="btn btn-primary btn-md btn-import-contacts" id="file-upload-sheet" ng-upload-change="vm.loadFile($event)" style="display: none" type="file"> <button class="btn btn-primary btn-md btn-import-contacts" ng-disabled="vm.isUploading" ngf-accept="\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\'" ngf-pattern="\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\'" ngf-select="vm.loadFile($file, $invalidFiles)" type="file"><span data-translate="communication.broadcast-list-modal.import-contacts" ng-if="!vm.loadingImportContacts"></span><div class="sk-spinner sk-spinner-circle" ng-if="vm.loadingImportContacts"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></button> <a class="download-template" ng-href="{{ vm.getDownloadLinkToTemplate() }}" target="_self"><span data-translate="communication.broadcast-list-modal.download-template"></span></a><div class="whatsapp-message-limit" ng-class="{\'ml-auto\': !vm.isMobile}" ng-style="{\'margin-top\': vm.isMobile ? \'10px\' : \'0\'}"><p class="mb-0" ng-style="{\'text-align\': vm.isMobile ? \'start\' : \'end\'}" data-translate="communication.broadcast-list-modal.whatsapp-broadcast-limit"></p><div><span data-translate="communication.broadcast-list-modal.whatsapp-broadcast-limit-label"></span> <a target="_blank" class="info" tooltip-placement="top-right" uib-tooltip="{{\'communication.broadcast-list-modal.whatsapp-broadcast-limit-tooltip\' | translate}}" href="https://developers.facebook.com/docs/whatsapp/api/rate-limits#quality-rating-and-messaging-limits"><i class="fa fa-info-circle"></i></a></div></div></div><div style="font-size: 15px; font-weight: bold"><label data-translate="communication.broadcast-list-modal.selected-contacts"></label><span class="selected-contacts">{{vm.totalSelected()}} {{vm.numberOfContactsLabel()}}</span></div><div class="contact-list" id="contact-list"><table class="table invoice-table"><thead><tr><th style="width: 3vw; text-align: center"><div class="checkbox" ng-click="$event.stopPropagation()"><label style="position: relative"><input class="dropdown-item-checkbox" ng-checked="vm.isAllSelected()" ng-click="vm.selectAll()" type="checkbox"> <i class="fa fa-minus indeterminate-icon" ng-if="vm.isIndeterminate()"></i> <span class="checkbox-material"><span class="check m-0" ng-class="{\'indeterminate-checkbox\': vm.isIndeterminate()}"></span></span></label></div></th><th style="text-align: left !important; vertical-align: middle; width: 15vw"><span class="header-sort-by" ng-click="vm.sortContactsBy(\'NAME\')"><span data-translate="communication.broadcast-list-modal.table-name"></span> <i aria-hidden="true" class="fa fa-chevron-{{vm.filters.orderBy === \'asc\' ? \'up\' : \'down\'}}" ng-if="vm.filters.sortBy === vm.SORTBY_VALUES[\'NAME\']"></i></span></th><th style="text-align: left !important; vertical-align: middle; width: 20vw"><span class="header-sort-by" ng-click="vm.sortContactsBy(\'PHONE\')"><span data-translate="communication.broadcast-list-modal.table-phone"></span> <i aria-hidden="true" class="fa fa-chevron-{{vm.filters.orderBy === \'asc\' ? \'up\' : \'down\'}}" ng-if="vm.filters.sortBy === vm.SORTBY_VALUES[\'PHONE\']"></i></span></th></tr></thead><tbody><tr ng-repeat="contact in vm.contacts" class="contact-cell"><td style="text-align: center"><div class="checkbox" ng-click="$event.stopPropagation()"><label><input class="dropdown-item-checkbox" ng-checked="vm.checkIfContactSelected(contact.id)" ng-click="vm.selectOne(contact)" type="checkbox"> <span class="checkbox-material"><span class="check m-0"></span></span></label></div></td><td class="custom-aling-td-invoice">{{contact.fullName}}</td><td class="custom-aling-td-invoice">{{contact.phone}}</td></tr></tbody></table><div ng-if="vm.contacts.length === 0 && !vm.loadingContacts" class="no-contacts-found"><p>{{\'communication.broadcast-list-modal.no-contact-found\' | translate}}</p></div><div class="sk-container" ng-if="vm.loadingContacts" style="padding: 100px"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div></div><div class="pagination-content" ng-class="{\'pagination-in-mobile\': vm.isMobile}"><div><span class="lines-per-page" data-translate="communication.broadcast-list-modal.lines-per-page"></span></div><div style="margin: 5px 15px"><select class="form-control select-lines-per-page" id="linesPerPage" name="linesPerPage" ng-change="vm.refreshContacts()" ng-model="vm.filters.pageSize" ng-options="number for number in vm.numberPerPage"></select></div><uib-pagination boundary-links="true" items-per-page="vm.filters.pageSize" max-size="vm.maxSize" ng-change="vm.refreshContacts()" ng-model="vm.filters.pageNumber" total-items="vm.totalItems"></uib-pagination></div><div class="when-send-container"><h3 data-translate="communication.broadcast-list-modal.when-send"></h3><div class="row"><div class="col-md-12 form-group mb-0"><md-radio-group layout="column" ng-model="vm.form.whenSend"><md-radio-button aria-label="Ativo" class="my-radio" ng-value="\'NOW\'"><span class="radio-label" data-translate="communication.broadcast-list-modal.send-now"></span></md-radio-button><md-radio-button aria-label="Inativo" class="my-radio" ng-value="\'SCHEDULE\'"><span class="radio-label" data-translate="communication.broadcast-list-modal.schedule-sending"></span></md-radio-button></md-radio-group></div></div><div ng-if="vm.form.whenSend === \'SCHEDULE\'" ng-init="vm.initDateTimePicker()"><div class="input-group date" id="scheduleDate"><input autocomplete="off" class="form-control inputDate external-control" name="scheduleDate" ng-model="vm.scheduledAt" ng-required="true" type="text" ui-mask="{{vm.maskLocale}}" ui-mask-placeholder> <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div></div></div><div class="buttons-content"><button class="btn btn-primary btn-md back-step" data-translate="communication.broadcast-list-modal.previous-button" ng-click="vm.previousStep()"></button> <button class="btn btn-primary btn-md" ng-click="vm.addBroadcastList()" ng-disabled="!vm.selectContactsValidation() || vm.loadingAddBroadcast  ">{{vm.isMobile ? "communication.broadcast-list-modal.add-broadcast-list-mobile" : "communication.broadcast-list-modal.add-broadcast-list" | translate }}</button></div></div>');
$templateCache.put('app/admin/communication/directives/audio-recording/recording-timer.html','<div class="display-horizontally-inline inline-end" style="height: 50px; width: 100%; resize: none; line-height: 35px; background: #eaeaea; border-radius: 25px"><span style="font-size: 18px; color: #2f137e">{{timer | formatTimer}}</span><div class="time-recording" ng-style="showRedLight && {\'opacity\': 1} || !showRedLight && {\'opacity\': 0}" style="margin-right: 10px; margin-left: 10px"><div style="height: 16px;\n                    width: 16px;\n                    background-color: rgba(255,0,0,0.37);\n                    border-radius: 50%;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center"><div style="height: 8px;\n                        width: 8px;\n                        background-color: red;\n                        border-radius: 50%;\n                        display: flex;\n                        justify-content: center;\n                        align-items: center"></div></div></div></div>');
$templateCache.put('app/admin/communication/directives/chat-skeleton/chat-contact-info-skeleton.html','<div class="row skeleton-animation" style="margin-top: 10px; width: 98%; height: 100%"><div class="row" style="width: 100%; height: 70px"><div class="col-md-4"><img class="profile-pic-bigger" ng-src="{{\'./assets/images/avatar.png\'}}"></div><div class="col-md-8" style="margin-top: 5px"><div class="row"><column class="two-third-left column-left"></column></div><div class="row"><column class="one-third-right column-right"></column><column class="one-third-right column-right"></column></div></div></div><div class="row" style="width: 100%; height: 100%"><div class="row" ng-repeat="card in [1,2,3,4,5,6,7,8]" style="width: 100%"><div class="col-md-4"></div><div class="col-md-8" style="margin-top: 5px"><div class="row" style="margin-top: 5px; margin-bottom: 5px"><column class="two-third-right column-right"></column></div><div class="row" style="margin-top: 5px; margin-bottom: 5px"><column class="one-third-right column-right"></column><column class="one-third-right column-right"></column><column class="one-third-right column-right"></column></div></div></div></div></div>');
$templateCache.put('app/admin/communication/directives/chat-skeleton/chat-contacts-skeleton.html','<div class="skeleton-animation" style="margin-top: 10px; width: 98%; height: 70vh;overflow: auto" ng-style="{\'max-height\': vm.conversationHeight - 175}"><div class="row" ng-repeat="card in vm.cards" style="padding-left: 15px; width: 100%; height: 70px; display: flex; justify-content: space-between"><img class="profile-pic-bigger" style="max-height: 50px" ng-src="{{\'./assets/images/avatar.png\'}}"><div class="row" style="margin-top: 5px; padding-left: 25px; width: 90%"><column class="two-thirds-left column-left"></column><column class="two-thirds-left column-left"></column></div></div></div>');
$templateCache.put('app/admin/communication/directives/chat-skeleton/chat-message-skeleton.html','<div ng-if="vm.side == \'left\'" class="row" style="margin-top: 15px; margin-bottom: 15px; padding-left: 15px; width: 100%; height: 70px; display: flex; justify-content: space-between"><img ng-if="vm.hasIcon" class="profile-pic-bigger" style="max-height: 50px; max-width: 50px" ng-src="{{\'./assets/images/avatar.png\'}}"><div class="row" style="margin-top: 5px; padding-left: 25px; width: 90%"><column class="one-half-left column-left"></column><column class="two-thirds-left column-left"></column><column class="two-thirds-left column-left"></column></div></div><div ng-if="vm.side == \'right\'" class="row" style="margin-top: 15px; margin-bottom: 15px; padding-right: 15px; width: 100%; height: 70px; display: flex; justify-content: space-between"><div class="row" style="margin-top: 5px; padding-right: 25px; width: 90%"><column class="one-half-right column-right"></column><column class="two-thirds-right column-right"></column><column class="two-thirds-right column-right"></column></div><img ng-if="vm.hasIcon" class="profile-pic-bigger" style="max-height: 50px; max-width: 50px" ng-src="{{\'./assets/images/avatar.png\'}}"></div>');
$templateCache.put('app/admin/communication/directives/chat-skeleton/chat-skeleton.html','<div class="skeleton-animation" style="height: 100%; width: 98%; align-items: center"><chat-message-skeleton side="\'left\'" has-icon="hasIcon"></chat-message-skeleton><chat-message-skeleton side="\'right\'" has-icon="hasIcon"></chat-message-skeleton><chat-message-skeleton side="\'left\'" has-icon="hasIcon"></chat-message-skeleton><chat-message-skeleton side="\'right\'" has-icon="hasIcon"></chat-message-skeleton><chat-message-skeleton side="\'left\'" has-icon="hasIcon"></chat-message-skeleton><chat-message-skeleton side="\'right\'" has-icon="hasIcon"></chat-message-skeleton><chat-message-skeleton side="\'left\'" has-icon="hasIcon"></chat-message-skeleton><chat-message-skeleton side="\'right\'" has-icon="hasIcon"></chat-message-skeleton></div>');
$templateCache.put('app/admin/communication/directives/message-contact/message-contact.html','<div ng-if="!message.owner"><div class="message-file-container" style="margin-bottom: 2px" ng-repeat="contact in message.contacts"><div class="display-horizontally-inline" style="border-bottom:1px solid #e7ebee; position:relative"><img class="profile-pic-smaller" ng-src="{{message.avatarUrl ? message.avatarUrl : \'./assets/images/avatar.png\'}}"><p style="float:left; display: inline-grid"><strong style="font-weight:600; font-size:15px">{{contact.name.formatted_name}}</strong> <span style="font-size:13px; font-weight:400" ng-repeat="email in contact.emails">{{email.email}}</span> <span style="font-size:13px; font-weight:400" ng-repeat="phone in contact.phones">{{phone.phone | tel}}</span></p></div></div><div class="bg-primary p-xs b-r-lg user mb-0"><div class="message-time-container"><span class="message-time-spacing"></span> <span class="message-time">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span></div></div></div><div ng-if="message.owner"><div class="message-file-container" ng-repeat="contact in message.contacts"><div class="display-horizontally-inline" style="border-bottom:1px solid #e7ebee; position:relative"><img class="profile-pic-smaller" ng-src="{{message.avatarUrl ? message.avatarUrl : \'./assets/images/avatar.png\'}}"><p style="float:left; display: inline-grid"><strong style="font-weight:600; font-size:15px">{{contact.name.formatted_name}}</strong> <span style="font-size:13px; font-weight:400" ng-repeat="email in contact.emails">{{email.email}}</span> <span style="font-size:13px; font-weight:400" ng-repeat="phone in contact.phones">{{phone.phone | tel}}</span></p></div></div><div class="bg-primary p-xs b-r-lg owner mb-0"><div class="message-time-container"><span class="message-time-spacing"></span> <span class="message-time">{{ message.created ? message.created : message.timestamp | date:\'HH:mm\'}}</span></div></div></div>');
$templateCache.put('app/admin/communication/directives/message-container/message-container.html','<div class="profile-message-container" ng-if="vm.message.type == \'story_mention\' || vm.message.type == \'story_reply\'"><img class="profile-pic-smaller" ng-if="!vm.message.owner" ng-src="{{vm.currentConversation.profilePic !== undefined ? vm.currentConversation.profilePic : \'./assets/images/avatar.png\'}}"><div ng-style="{\'display\': \'flex\', \'flex-direction\': \'column\', \'align-items\': vm.message.owner ? \'flex-end\' : \'flex-start\'}"><div class="story-content" ng-class="{\'story-reponse-image ml-0\': vm.message.data && vm.message.data !== \'\' && vm.message.storyType == \'image\',\n             \'story-reponse-video ml-0\': vm.message.data && vm.message.data !== \'\' && vm.message.storyType == \'video\' }"><span class="text-muted font-normal" data-translate="{{vm.getStoryLabel()}}"></span><div style="margin-left: auto; margin-right: 80px" class="sk-spinner sk-spinner-circle" ng-if="!vm.message.loadComplete"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div><video ng-if="vm.message.storyType === \'video\' && vm.message.data && vm.message.data !== \'\' && vm.message.loadComplete" style="border-radius: 15px; border: 2px rgb(217, 217, 217) solid" alt="" controls><source src="{{vm.message.data}}" type="video/mp4"></video><img class="w-100" ng-if="vm.message.storyType === \'image\' && vm.message.data && vm.message.data !== \'\'" style="border-radius: 15px" src="{{vm.message.data}}" alt=""></div><div class="bg-primary p-xs b-r-lg user" ng-if="vm.message.text && vm.message.text !== null && vm.message.text !== \'\' "><div><span class="message-text" ng-bind-html="vm.message.text | parseUrl"></span> <span class="message-time-spacing"></span></div><div class="message-time-container"><span class="message-time">{{ vm.message.created ? vm.message.created : vm.message.timestamp | date:\'HH:mm\'}}</span></div></div></div><img class="profile-pic-smaller" ng-if="vm.message.owner" ng-src="{{vm.currentConversation.profilePic !== undefined ? vm.currentConversation.profilePic : \'./assets/images/avatar.png\'}}"></div><div class="profile-message-container broadcast-message-container" ng-if="vm.message.owner && vm.message.type == \'broadcastMessage\'"><div><div class="bg-primary p-xs b-r-lg owner"><message-referral ng-if="vm.message.messageReferral" value="vm.message.messageReferral"></message-referral><div ng-if="vm.message.data" class="broadcast-media-container"><img ng-if="vm.message.template.header.type === 2" alt="" class="owner-img chat-image-owner" src="{{vm.message.data}}"><video ng-if="vm.message.template.header.type === 3" alt="" class="owner-img story-reponse-video broadcast-video-container" controls><source src="{{vm.message.data}}" type="video/mp4"></video><div ng-if="vm.message.template.header.type === 4" class="message-file-container broadcast-document-container"><i class="fa fa-file{{vm.message.data.split(\'.\')[1] === \'pdf\' ? \'-pdf-o\' : \'\'}} file-icon" aria-hidden="true"></i> <span class="mb-0">{{vm.message.data.split(\'data/documents/\')[1]}}</span><div ng-if="vm.message.loadingDownload" class="sk-container"><div class="sk-spinner sk-spinner-circle" style="width: 40px; height: 40px; margin: 5px"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div><button ng-if="!vm.message.loadingDownload" class="btn btn-primary btn-download-document" ng-click="vm.downloadDocument(vm.message)" style="margin: 5px" ng-disabled="vm.message.loadingDownload"><i class="fa fa-{{vm.message.downloadedData ? \'external-link\' : \'download\'}}" ng-if="!vm.message.loadingDownload"></i></button></div></div><div><span class="message-text broadcast-text" ng-bind-html="vm.message.text | parseUrl"></span><p class="message-footer-text text-muted" ng-if="vm.message.template.footer && vm.message.template.footer !== \'\'">{{vm.message.template.footer}}</p><span class="message-time-spacing"></span></div><div class="message-time-container display-horizontally-inline inline-end message-time-audio-container w-100"><span class="message-time">{{ vm.message.created ? vm.message.created : vm.message.timestamp | date:\'HH:mm\'}}</span></div></div><div ng-if="vm.message.template && vm.message.template.buttons"><div ng-repeat="button in vm.message.template.buttons" class="message-button-container b-r-lg"><div class="message-button">{{button.parameter.text}}</div></div></div></div><img class="profile-pic-smaller" ng-src="{{vm.currentConversation.profile_pic !== undefined ? vm.currentConversation.profile_pic : \'./assets/images/avatar.png\'}}"></div><div class="profile-message-container" ng-if="!vm.message.owner && vm.message.type == \'order\'" ng-style="{\'max-width\': vm.message.type === \'order\' ? \'90%\' : \'65%\'}"><img class="profile-pic-smaller" ng-src="{{vm.currentConversation.profile_pic !== undefined ? vm.currentConversation.profile_pic : \'./assets/images/avatar.png\'}}"><!-- please, don\'t break this line --><div class="bg-primary p-xs b-r-lg user"><div class="order-container"><img class="message-order-image" ng-src="{{vm.message.orderProducts.productItems[0].imageUrl\n                ? vm.message.orderProducts.productItems[0].imageUrl\n                : \'content/images/default-product-image.png\'}}" alt="image"><div class="general-order-info"><span class="font-weight-bold"><i class="fa fa-shopping-cart" aria-hidden="true"></i> {{vm.message.orderProducts ? vm.getOrderQuantity(vm.message.orderProducts.productItems) : 0}} Itens </span><span class="font-weight-bold text-muted">Subtotal: R$ {{vm.getOrderAmount(vm.message.orderProducts.productItems)}}</span></div></div><!-- <div class="message-time-container display-horizontally-inline inline-end w-100">\n            <span class="message-time">{{ vm.message.created ? vm.message.created : vm.message.timestamp | date:\'HH:mm\'}}</span>\n        </div> --><div style="border-bottom: 1px solid #bdbdbd"></div><button class="btn btn-link w-100 open-chat-order-cart" ng-click="vm.openCart()" data-translate="communication.view-chat-order.show-cart"></button></div></div>');
$templateCache.put('app/admin/communication/directives/message-loading/message-loading.html','<div class="sk-spinner sk-spinner-circle" style="width: {{size}}px; height: {{size}}px; float: {{alignSide}}; margin: {{margin}}px"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div>');
$templateCache.put('app/admin/communication/directives/message-referral/message-referral.html','<div class="message-referral"><a class="message-referral-container" ng-click="vm.openUrl()"><h4 style="max-width: 21vw">{{vm.value.headline}}</h4><div style="opacity: 0.75; margin-bottom: 5px">{{vm.value.body}}</div><span class="font-bold" style="max-width: 21vw">{{vm.value.url}}</span></a></div>');
$templateCache.put('app/admin/communication/directives/message-reply/message-reply.html','<style>.message-to-reply {\n        padding: 7px 12px 10px 11px;\n    }\n\n    .sender-name-container {\n        display: inline-flex;\n        max-width: 100%;\n        line-height: 22px;\n        font-weight: 500;\n    }\n\n    .reply-text-content {\n        display: -webkit-box;\n        max-height: 40px;\n        overflow: hidden;\n        line-height: 20px;\n        text-overflow: ellipsis;\n    }\n\n    .reply-text-content-desktop {\n        word-wrap: break-word;\n        white-space: pre-wrap;\n    }\n\n    .reply-video, .reply-image {\n        width: 65px !important;\n        height: 65px !important;\n        object-fit: cover;\n        border-radius: 5px;\n        display: block;\n        pointer-events: none;\n        position: absolute;\n        float: right;\n        right: 0;\n        top: 0;\n    }\n\n    video.reply-video::-webkit-media-controls-panel {\n        display: none !important;\n        opacity: 1 !important;}</style><div style="display: flex;align-items: center"><div ng-switch="vm.messageToReply.type" class="message-replied" style="margin: 10px 15px 5px; width: 100%" ng-style="{\'border-left-color\': vm.messageToReply.owner ? \'var(--main-color-light)\' : \'#585858\'}"><div ng-switch-when="text" class="message-to-reply"><div class="sender-name-container" ng-include="\'senderNameContainer.html\'"></div><div class="reply-text-content" ng-class="{\'reply-text-content-desktop\': !vm.isMobile}"><span ng-bind-html="vm.messageToReply.text | parseUrl"></span></div></div><div ng-switch-when="sticker" class="message-to-reply"><div class="sender-name-container" ng-include="\'senderNameContainer.html\'"></div><div class="reply-text-content" ng-class="{\'reply-text-content-desktop\': !vm.isMobile}" style="max-height: 60px"><img alt="" src="{{vm.messageToReply.api}}" style="width: 40px; height: 100%" class="m-sm"></div></div><div ng-switch-when="audio" class="message-to-reply"><div class="sender-name-container" ng-include="\'senderNameContainer.html\'"></div><div style="display: flex; align-items: center; color: rgb(88, 88, 88)"><i class="fa fa-microphone" aria-hidden="true"></i><p class="mb-0" style="margin-left: 5px">{{vm.messageToReply.duration}}</p></div></div><div ng-switch-when="video" class="message-to-reply" style="position: relative; min-height: 65px"><div class="sender-name-container" ng-include="\'senderNameContainer.html\'"></div><div class="reply-text-content" ng-class="{\'reply-text-content-desktop\': !vm.isMobile}"><span ng-if="vm.messageToReply.text" ng-bind-html="vm.messageToReply.text | parseUrl"></span><div ng-if="!vm.messageToReply.text" style="display: flex; align-items: center; color: rgb(88, 88, 88)"><i class="fa fa-video-camera fa-1" aria-hidden="true"></i><p class="mb-0" style="margin-left: 5px">{{vm.messageToReply.duration}}</p><p class="mb-0" style="margin-left: 5px">{{\'communication.video\' | translate}}</p></div></div><video alt="" class="reply-video" preload="metadata"><source src="{{vm.messageToReply.data}}" type="video/mp4"></video></div><div ng-switch-when="image" class="message-to-reply" style="position: relative; min-height: 65px"><div class="sender-name-container" ng-include="\'senderNameContainer.html\'"></div><div class="reply-text-content" ng-class="{\'reply-text-content-desktop\': !vm.isMobile}"><span ng-if="vm.messageToReply.text" ng-bind-html="vm.messageToReply.text | parseUrl"></span><div ng-if="!vm.messageToReply.text" style="display: flex; align-items: center; color: rgb(88, 88, 88)"><i class="fa fa-camera" aria-hidden="true"></i><p class="mb-0" style="margin-left: 5px">{{\'communication.photo\' | translate}}</p></div></div><img class="reply-image" src="{{vm.messageToReply.data}}"></div><div ng-switch-when="document" class="message-to-reply" style="position: relative; min-height: 65px"><div class="sender-name-container" ng-include="\'senderNameContainer.html\'"></div><div class="reply-text-content" ng-class="{\'reply-text-content-desktop\': !vm.isMobile}" style="color: rgb(88, 88, 88)"><i class="fa fa-file{{vm.messageToReply.data.split(\'.\')[1] === \'pdf\' ? \'-pdf-o\' : \'\'}}" aria-hidden="true"></i> <span class="mb-0" style="margin-left: 5px">{{vm.messageToReply.text ? vm.messageToReply.text : vm.messageToReply.data.split(\'/data/documents/\')[1]}}</span></div></div></div><i class="icon-ksc-close-light" style="font-size: 16px;margin-right: 10px" ng-click="vm.cancelReply()"></i></div><script type="text/ng-template" id="senderNameContainer.html"><span class="m-0" ng-style="{\'color\': vm.messageToReply.owner ? \'var(--main-color-light)\' : \'#585858\'}"\n          style="margin: 10px; font-weight: 500;">\n        {{(vm.messageToReply.owner ? \'communication.you\' : vm.messageOwnerName) | translate}}\n    </span></script>');
$templateCache.put('app/admin/communication/directives/quoted-message-container/quoted-message-container.html','<div class="message-replied" ng-style="{\'border-left-color\': vm.replySourceMessage.owner ? \'var(--main-color-light)\' : \'#585858\' }"><div ng-switch="vm.replySourceMessage.type"><div ng-switch-when="text"><span ng-include="\'senderName.html\'"></span><p class="message-text" style="padding: 10px" ng-bind-html="vm.replySourceMessage.text | parseUrl"></p></div><div ng-switch-when="sticker"><span ng-include="\'senderName.html\'"></span> <img alt="" src="{{vm.replySourceMessage.api}}" style="width: 58px; height: 100%" class="m-sm"></div><div ng-switch-when="audio"><span ng-include="\'senderName.html\'"></span><audio id="reply-{{vm.replySourceMessage.id}}" controls class="m-sm" controlslist="novolume"><source src="{{vm.replySourceMessage.data}}"></audio></div><div ng-switch-when="image"><div class="display-flex"><div class="m-b-sm"><span ng-include="\'senderName.html\'"></span> <span class="m-l-sm m-r-md"><i class="fa fa-camera" aria-hidden="true"></i> <span class="m-l-xs">Foto</span></span></div><div class="quoted-image-message" ng-style="{\'background-image\': \'url({{vm.replySourceMessage.data}})\'}"></div></div></div><div ng-switch-when="document"><span ng-include="\'senderName.html\'"></span><div class="message-file-container"><i class="fa fa-file{{vm.replySourceMessage.data.split(\'.\')[1] === \'pdf\' ? \'-pdf-o\' : \'\'}} file-icon" aria-hidden="true"></i> <span class="mb-0">{{vm.replySourceMessage.text ? vm.replySourceMessage.text : vm.replySourceMessage.data.split(\'/data/documents/\')[1]}}</span><div ng-if="vm.replySourceMessage.loadingDownload" class="sk-container"><div class="sk-spinner sk-spinner-circle" style="width: 40px; height: 40px; margin: 5px"><div class="sk-circle1 sk-circle"></div><div class="sk-circle2 sk-circle"></div><div class="sk-circle3 sk-circle"></div><div class="sk-circle4 sk-circle"></div><div class="sk-circle5 sk-circle"></div><div class="sk-circle6 sk-circle"></div><div class="sk-circle7 sk-circle"></div><div class="sk-circle8 sk-circle"></div><div class="sk-circle9 sk-circle"></div><div class="sk-circle10 sk-circle"></div><div class="sk-circle11 sk-circle"></div><div class="sk-circle12 sk-circle"></div></div></div><button ng-if="!vm.replySourceMessage.loadingDownload" class="btn btn-primary btn-download-document" ng-click="vm.downloadDocument(vm.replySourceMessage)" style="margin: 5px" ng-disabled="vm.replySourceMessage.loadingDownload"><i class="fa fa-{{vm.replySourceMessage.downloadedData ? \'external-link\' : \'download\'}}" ng-if="!vm.replySourceMessage.loadingDownload"></i></button></div></div><div ng-switch-when="video"><span ng-include="\'senderName.html\'"></span><video alt="" class="owner-img story-reponse-video" controls><source src="{{vm.replySourceMessage.data}}" type="video/mp4"></video></div></div></div><script type="text/ng-template" id="senderName.html"><p class="mb-0" ng-style="{\'color\': vm.replySourceMessage.owner ? \'var(--main-color-light)\' : \'#585858\'}"\n       style="margin: 10px; font-weight: 500;">\n        {{vm.replySourceMessage.owner ? \'Voc\xEA\' : vm.messageOwnerName}}\n    </p></script>');
$templateCache.put('app/admin/communication/modals/send-images-modal/send-images-modal.html','<style>.image-button {\n        width: 58px;\n        height: 58px;\n        object-fit: cover;\n    }\n\n    .image-button-container {\n        margin-right: 5px;\n        padding: 0;\n        border-radius: 8px;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .images-list {\n        display: flex;\n        overflow-x: scroll;\n        padding: 5px;\n    }\n\n    .images-list::-webkit-scrollbar-track {\n        border-radius: 10px;\n        background-color: #F5F5F5;\n    }\n\n    .images-list::-webkit-scrollbar {\n        width: 6px;\n        height: 6px;\n        background-color: #F5F5F5;\n    }\n\n    .images-list::-webkit-scrollbar-thumb {\n        border-radius: 6px;\n        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);\n        background-color: #9a9a9a;\n    }\n\n    .remove-button-container {\n        right: 1px;\n        transition: right 75ms ease-out,top 75ms ease-out;\n        position: absolute;\n        top: 1px;\n        z-index: 100;\n        color: white;\n        opacity: 0;\n        cursor: pointer;\n    }\n\n    .image-button-container:hover .remove-button-container {\n        opacity: 1\n    }\n\n    .image-button-container:hover .image-container:before {\n        opacity: 1\n    }\n\n    .image-container {\n        position: relative;\n        top: 0;\n        z-index: 2;\n        width: 58px;\n        height: 58px;\n    }\n\n    .image-container:before {\n        background: linear-gradient(10deg,transparent,transparent 45%,rgba(11,20,26,.18) 75%,rgba(11,20,26 ,.4));\n        position: absolute;\n        top: 0;\n        width: 100%;\n        height: 40px;\n        content: "";\n        opacity: 0;\n        transition: opacity .1s ease-out\n    }</style><div id="modal"><div class="modal-header"><h1 class="modal-title">Visualiza\xE7\xE3o de Fotos</h1></div><div class="modal-body"><div style="height: 340px"><img src="{{vm.selectedImage.blob}}" style="width: 100%; height: 100%; object-fit: contain"></div><hr><div ng-if="vm.conversation.source === \'WATI\'" class="form-group" style="margin-top: 10px"><label for="caption" class="ng-scope">Descri\xE7\xE3o</label><textarea id="caption" name="caption" class="form-control ng-pristine ng-valid ng-empty ng-touched" ng-model="vm.selectedImage.caption" style="resize: none" aria-invalid="false"></textarea></div><div style="display: flex"><div class="images-list"><div ng-repeat="imageItem in vm.imagesToSend"><button class="image-button-container" ng-style="{\'border\': imageItem.index === vm.selectedImage.index ? \'3px solid var(--main-color-light)\' : \'3px solid transparent\'}"><div class="remove-button-container"><i class="icon-ksc-close-light" ng-click="vm.removeImage(imageItem.index)" aria-hidden="true"></i></div><div class="image-container" ng-click="vm.selectedImage = imageItem"><img src="{{imageItem.fullBase64}}" class="image-button"></div></button></div></div><input class="d-none file-button" id="more-image-upload-sheet" ng-upload-change="vm.addMoreImages($event)" style="display: none" accept="{{vm.supportedImagesType}}" type="file"> <button class="image-button-container" style="margin: 10px; border: 3px solid transparent; min-width: 58px; min-height: 58px" ng-click="vm.openImageSelect($event)"><i class="fa fa-plus-square-o text-muted" style="font-size: 23px" aria-hidden="true"></i></button></div></div><div class="modal-footer"><button class="btn btn-default btn-md cancel-button" data-style="slide-left" ng-click="vm.dismiss()"><span>Cancelar</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.closeAndSendFile()"><span>Enviar</span></button></div></div>');
$templateCache.put('app/admin/communication/social-networks-connect/wati-settings-modal/wati-settings-modal.html','<style>.progress-bar-success {\n        background-color: var(--main-color) !important;\n    }</style><div class="container-modal-connect" id="modal"><div class="modal-header" style="border-bottom: none; padding: 35px !important"><button type="button" class="close main-modal-btn-close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeModal()">&times;</button><div ng-if="vm.step === 0"><h1 class="modal-title">{{ \'communication.connect-modal.second-step.title\' | translate }}</h1><span class="sub-title">{{ \'communication.connect-modal.second-step.subtitle\' | translate }}</span></div><div ng-if="vm.step === 1"><h1 class="modal-title">{{ \'communication.connect-modal.third-step.title\' | translate }}</h1><span class="sub-title">{{ \'communication.connect-modal.third-step.subtitle\' | translate }}</span></div><div class="slide-container"><div class="slide-dot" ng-class="{\'dot-activated\': vm.step === 0}"></div><div class="slide-dot" ng-class="{\'dot-activated\': vm.step === 1}"></div></div></div><div class="modal-body" style="padding: 0 35px"><div ng-if="vm.step === 0" ng-include="\'app/admin/communication/social-networks-connect/second-step.html\'"></div><div ng-if="vm.step === 1" ng-include="\'app/admin/communication/social-networks-connect/third-step.html\'"></div></div><div class="col-md-10 col-md-offset-1 m-t-md m-b-md" ng-show="vm.isSaving"><span class="h5">{{\'communication.connect-modal.wati-sync-conversations\' | translate}}</span><uib-progressbar class="progress-striped active" value="vm.syncProgress" type="success">{{vm.syncProgress}}%</uib-progressbar></div><div class="modal-footer" style="border-top: none; padding: 35px"><button class="btn btn-default btn-md" data-style="slide-left" ng-click="vm.previousStep()"><span>{{ \'entity.action.cancel\' | translate }}</span></button> <button class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.nextStep()" ng-if="vm.step != 1"><span>{{ \'communication.connect-modal.buttons.continue\' | translate }}</span></button> <button ng-disabled="vm.isSaving || vm.watiAccountData.$invalid" ladda="vm.isSaving" class="btn btn-primary btn-md" data-style="slide-left" ng-click="vm.saveSetting()" ng-if="vm.step == 1"><span>{{ \'communication.connect-modal.buttons.connect\' | translate }}</span></button></div></div>');
$templateCache.put('app/admin/digital-poster/components/posters/poster-1x1.html','<div resizable class="col-xs-12 col-sm-12 col-md-12 col-lg-12 ksc-poster very-specific-design" id="very-specific-design"><div class="poster-header" align="center"><p>Oferta</p></div><div class="poster-color-yellow"><div class="ksc-poster-product-name"><p>{{ vm.poster.productName.substr(0,vm.productNameSize) || (\'digitalPoster.preview.model1.productName\' | translate) }}</p></div><div class="ksc-poster-product-description"><p>{{ vm.poster.description.substr(0,vm.descriptionSize) || (\'digitalPoster.preview.model1.productDescription\' | translate) }}</p></div><div class="ksc-poster-product-code"><p>{{ vm.poster.code.substr(0,vm.productCodeSize) || \' \' }}</p></div><div class="ksc-poster-product-old-price"><p>{{ vm.getModeOldPrefix() || (\'digitalPoster.preview.model1.from\' | translate) }}<span>{{ vm.formatMoney(vm.poster.purchaseValue) || (\'digitalPoster.preview.model1.oldPrice\' | translate) }}</span></p></div><div class="ksc-poster-product-new-price"><p>{{ vm.getModeNewPrefix() || (\'digitalPoster.preview.model1.to\' | translate)}}</p></div><div class="ksc-poster-product-currency"><p class="ksc-paragraph-price-digit-{{vm.getIntegerCount()}}"><span class="ksc-symbol-currency ksc-symbol-currency-digit-{{vm.getIntegerCount()}}">{{ vm.poster.currencyInstance.prefix }}</span> <span class="ksc-integer-price ksc-integer-price-digit-{{vm.getIntegerCount()}}">{{ vm.preview.integerDiscounted || (\'digitalPoster.preview.model1.newPriceInteger\' | translate) }}</span> <span class="ksc-cents-price ksc-cents-price-digit-{{vm.getIntegerCount()}}">{{ vm.preview.centsDiscounted || (\'digitalPoster.preview.model1.newPriceCents\' | translate) }}</span> <span class="ksc-unit-symbol-{{vm.getIntegerCount()}}">{{ vm.getUnitType() }}</span></p></div><div class="ksc-poster-economy-result ksc-poster-economy-result-digit-{{vm.getIntegerCount()}}"><p class="ksc-economy-price ksc-economy-price-digit-{{vm.getIntegerCount()}}">{{ vm.formatMoney(vm.preview.discountValue) || (\'digitalPoster.preview.model1.economyPrice\' | translate) }}<br><span style="font-size: 0.6em">{{vm.poster.currencyInstance.prefix }}</span></p><img src="content/images/economy-result.png"></div></div><div style="background-color: #C00F11; padding-top: 4.5%"></div></div>');
$templateCache.put('app/admin/digital-poster/components/posters/poster-1x2.html','');
$templateCache.put('app/admin/digital-poster/components/posters/poster-1x4.html','');
$templateCache.put('app/admin/hub-management/flyers/import/hub-flyer-import.html','<style>.steps {\n        margin-top: 30px;\n    }\n    .steps > .nav > li.active > a {\n        color: white;\n        margin: 0 5px;\n        background: #2f137e;\n    }\n    .steps > .nav > li > a {\n        color: #aaa;\n        margin: 0 5px;\n        background: #eee;\n    }\n    .steps > .nav > li.active {\n        border-left: none;\n        border-right: none;\n        background: none !important;\n    }\n    .import-loading-spinner {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n    }\n    .import-loading-text {\n        margin-top: 20px; \n        font-size: 16px\n    }\n    .column-header {\n        background: #c4c4c4;\n    }\n    .step-header {\n        padding: 15px 50px;\n    }\n    .step-content {\n        height: 440px;\n        min-height: 440px;\n    }\n    .mapping-errors {\n        background: #fee2df;\n        padding: 15px 50px;\n    }</style><div class="wrapper wrapper-content"><div class="row"><div class="col-sm-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-9" has-authority="STORE_CREATE_FLYER"><h2 data-translate="flyers.import.subtitle"></h2><p data-translate="flyers.import.description"></p><div class="steps"><ul class="nav nav-pills steps"><li ng-class="{\'active\': vm.currentStep === 1}"><a ng-click="vm.gotoStep(1)">{{ \'flyers.import.steps.one\' | translate }}</a></li><li ng-class="{\'active\': vm.currentStep === 2}"><a ng-click="vm.gotoStep(2)">{{ \'flyers.import.steps.two\' | translate }}</a></li><li ng-class="{\'active\': vm.currentStep === 3}"><a ng-click="vm.gotoStep(3)">{{ \'flyers.import.steps.three\' | translate }}</a></li></ul></div></div><div class="col-sm-12"><div class="hr-line-dashed"></div></div></div><div ng-if="vm.isUploading || vm.isLoading" class="step-content import-loading-spinner"><div class="sk-container"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><span ng-if="vm.isUploading" data-translate="flyers.import.validating" class="import-loading-text"></span> <span ng-if="vm.isLoading" data-translate="flyers.import.loadingFile" class="import-loading-text"></span></div><div ng-show="!vm.isUploading && !vm.isLoading" class="step-content"><div ng-show="vm.currentStep === 1" class="row" ng-include="\'app/admin/hub-management/flyers/import/hub-flyer-table-preview.html\'"></div><div ng-show="vm.currentStep === 1" class="row" ng-include="\'app/admin/hub-management/flyers/import/step1.html\'"></div><div ng-show="vm.currentStep === 2" class="row" ng-include="\'app/admin/hub-management/flyers/import/step2.html\'"></div><div ng-show="vm.currentStep === 3" class="row" ng-include="\'app/admin/hub-management/flyers/import/step3.html\'"></div></div><div class="row"><div class="col-sm-12"><div class="hr-line-dashed"></div></div><div class="pull-right" has-authority="STORE_CREATE_FLYER" style="padding-right: 1%"><button ng-disabled="vm.currentStep <= 1" ng-click="vm.gotoStep(vm.currentStep - 1)" class="btn btn-default"><span data-translate="flyers.button.back">Back</span></button> <button ng-show="vm.currentStep < 3" ng-click="vm.gotoStep(vm.currentStep + 1)" ng-disabled="!vm.file" class="btn btn-primary"><span data-translate="flyers.button.next">Next</span></button> <button ng-if="vm.currentStep === 3" ladda="vm.isUploading" ng-disabled="!vm.file || vm.errorSummary" ng-click="vm.uploadFile()" has-authority="STORE_CREATE_FLYER" class="btn btn-primary"><span data-translate="flyers.button.startImport">Start</span></button></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/hub-management/flyers/import/step1.html','<div class="col-sm-6"><div style="padding: 5px 50px"><div><h2>Antes de fazer upload de seu arquivo</h2><h3>Conhe\xE7a a estrutura de dados da Showkase</h3><p>Fa\xE7a o download do arquivo de template de importa\xE7\xE3o para ver como os dados dos produtos s\xE3o organizados.</p><i class="fa fa-download"></i> <a target="_self" ng-href="{{ vm.getDownloadLinkToTemplate() }}">Baixar template .xlsx</a></div><div style="margin-top: 20px"><h3>Preencha os campos obrigat\xF3rios</h3><p>Alguns campos precisam ser preenchidos para que sua importa\xE7\xE3o seja bem sucedida.<br>\xC9 <strong>obrigat\xF3rio</strong> informar o campo <strong><i>Refer\xEAncia do Produto</i></strong> ou o <strong><i>EAN</i></strong>, seja para criar um novo produto ou para fazer uma atualiza\xE7\xE3o.<br>Para novos produtos, os campos <strong><i>Nome</i></strong>, <strong><i>Marca</i></strong>, <strong><i>Categoria</i></strong> e <strong><i>Pre\xE7o do Produto</i></strong> s\xE3o <strong>obrigat\xF3rios</strong>.</p></div></div></div><div class="col-sm-6" ngf-drop="vm.loadFile($file, $invalidFiles)" class="drop-box" style="padding-right: 65px" ngf-drag-over-class="\'dragover\'" ngf-multiple="false" ngf-pattern="\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\'"><div class="col-sm-12" style="border-style: dashed; border-width: 2px; border-color: #cecece; padding: 173px 65px; text-align: center; background-color: #f7f7f7"><button class="btn btn-primary" type="file" ng-disabled="vm.isUploading" ngf-select="vm.loadFile($file, $invalidFiles)" ngf-accept="\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\'" ngf-pattern="\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\'"><i class="fa fa-cloud-upload"></i> <span data-translate="flyers.button.selectFile">Select file</span></button><p style="margin-top: 10px" data-translate="flyers.import.fileSelectText"></p></div></div>');
$templateCache.put('app/admin/hub-management/flyers/import/step2.html','<div class="col-sm-12 step-header"><h4 data-translate="flyers.import.mappingTitle"></h4><p data-translate="flyers.import.mappingDescription"></p></div><div class="col-sm-12"><div class="tab-content" style="margin: 0px 36px"><div id="tab-1" class="tab-pane active"><div><div class="table-responsive" style="height: 350px"><table class="table table-striped table-hover"><thead><tr><th width="33.33%"><span data-translate="flyers.import.fileColumn">Column</span></th><th width="33.33%"><span data-translate="flyers.import.fileColumnName">Spreadsheet</span></th><th width="33.33%"><span data-translate="flyers.import.mappingColumn">Mapping</span></th></tr></thead><tbody><tr ng-repeat="item in vm.headers"><td><span><b>{{ item.column }}</b></span></td><td><span>{{ item.key }}</span></td><td><select class="form-control" name="att" ng-model="item.value" ng-change="vm.changeHeaderValue(item)"><option value="" ng-if="item.value !== \'NULL\'"></option><option ng-repeat="att in vm.flyerAttributes" value="{{att}}" data-translate="flyers.import.column.{{att}}"></option></select></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/admin/hub-management/flyers/import/step3.html','<div ng-if="vm.errorSummary" class="col-sm-12 step-header mapping-errors"><h4 data-translate="flyers.import.importErrorTitle"></h4><div ng-repeat="error in vm.errorSummary"><i class="fa fa-exclamation-triangle"></i> <span style="margin-left: 5px" data-translate="flyers.import.error.{{error}}"></span><br></div><p data-translate="flyers.import.importErrorDescription" style="margin-top: 15px"></p><button charset="utf-8" class="btn btn-primary" ng-click="vm.getXlsxResult()" data-translate="flyers.button.downloadResult">Download Result</button></div><div class="col-sm-12 step-header"><h4 data-translate="flyers.import.importPreviewTitle"></h4><p data-translate="flyers.import.importPreviewDescription"></p></div><div class="col-sm-12"><div class="tab-content" style="margin: 0px 36px"><div id="tab-1" class="tab-pane active"><div><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th ng-repeat="item in vm.importPreview.headers"><span>{{ item }}</span></th></tr></thead><tbody><tr ng-repeat="item in vm.importPreview.data"><td ng-repeat="value in item track by $index"><span>{{ value }}</span></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/admin/reports/store-rating/widgets/static-store-data.html','<div id="staticStoreData" class="ibox ibox-content" style="margin: 5px 5px 5px 0px; min-height: 230px"><div class="ibox-title"><h5 data-translate="storeRating.staticStoreData.title" class="title-color"></h5><i class="fa fa-question-circle question-icon-color pull-right"></i></div><div class="float-e-margins"><div class="ibox-content"><div class="row"><div ng-if="vm.staticStoreData && vm.staticStoreData.views"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="row"><p style="font-family: Humanst521 Lt BT; font-size: 3.0em; color: gray" align="center"><i class="fa fa-eye primary-color" style="font-size: 1.5em; padding-top: 12px; margin-right: 5%"></i><b>{{vm.staticStoreData.views || 0}}</b></p></div><div class="row" align="center"><p data-translate="storeRating.staticStoreData.views" style="font-size: 1.2em; color: #808080"></p></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="row"><p style="font-family: Humanst521 Lt BT; font-size: 3.0em; color: gray" align="center"><i class="fa icon-heart primary-color" style="font-size: 1.5em; padding-top: 12px"></i><b>{{vm.staticStoreData.followers || 0}}</b></p></div><div class="row" align="center"><p data-translate="storeRating.staticStoreData.followers" align="center" style="font-size: 1.2em; color: #808080"></p></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="row"><p style="font-family: Humanst521 Lt BT; font-size: 3.0em;  color: gray" align="center"><i class="fa fa-users primary-color" style="font-size: 1.5em; padding-top: 12px; margin-right: 5%"></i><b>{{vm.staticStoreData.clients || 0}}</b></p></div><div class="row" align="center"><p data-translate="storeRating.staticStoreData.clients" align="center" style="font-size: 1.2em; color: #808080"></p></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" align="center"><div style="padding-top: 50px; text-align: center" ng-if="!vm.staticStoreData || !vm.staticStoreData.views"><span class="insufficient-data" data-translate="storeRating.error.noStaticData"><i>Insufficient data</i></span></div></div></div></div></div></div>');
$templateCache.put('app/admin/reports/store-rating/widgets/store-qualify.html','<div id="storeQualify" class="ibox ibox-content" style="margin: 5px 0px 5px 5px; min-height: 230px"><div class="ibox-title"><h5 data-translate="storeRating.storeQualify.title" class="title-color"></h5><i class="fa fa-question-circle question-icon-color pull-right"></i></div><div class="float-e-margins"><div class="ibox-content"><div class="row"><div ng-if="vm.storeQualify && vm.storeQualify.rateAvg > 0"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><h3 style="text-align: center; font-size: 4em" align="center" ng-if="vm.storeQualify">{{vm.storeQualify.rateAvg}}</h3><div class="flyer-stars" style="margin-top: 10px; text-align: center" align="center" ng-if="vm.storeQualify"><star-rating-comp id="\'ksc-stars\'" rating="vm.storeQualify.rateAvg" star-type="\'svg\'" size="\'large\'" show-half-stars="true" read-only="true"></star-rating-comp></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" align="center" style="padding-top: 2%"><span data-translate="storeRating.storeQualify.averageOf" translate-value-average="{{ vm.amountOfOpnions }}" style="color: #333333">Average of x reviews</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div ng-repeat="item in vm.storeQualify.storeQualifyRatingOptions" class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="margin-bottom: 2%"><h2 class="small pull-right ksc-table-total-indicator">{{item.allQuantity}}</h2><i class="pull-left ksc-table-prefix-symbol {{item.icon}}"></i> <span class="pull-left ksc-table-prefix-value" align="center">{{item.prefixValue}}</span><div class="progress progress-small ksc-progress-bar-position"><div style="width: {{item.percentage}}; background-color: {{item.color}}" class="progress-bar"></div></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" align="center" ng-if="!vm.storeQualify.rateAvg"><div style="padding-top: 50px; text-align: center"><span class="insufficient-data" data-translate="storeRating.error.noRating"><i>Insufficient data</i></span></div></div></div></div></div></div>');
$templateCache.put('app/admin/reports/store-rating/widgets/store-user-xp.html','<div id="storeUserXP" class="ibox ibox-content" style="margin: 5px; min-height: 260px"><div class="ibox-title"><h5 data-translate="storeRating.userXP.title" class="title-color"></h5><i class="fa fa-question-circle question-icon-color pull-right"></i></div><div class="float-e-margins"><div class="ibox-content"><div class="row" style="padding: 10px 5px 20px 19px"><div class="col-xs-12 col-sm-7 col-md-7 col-lg-7" ng-if="vm.userXP && (vm.userXP.recommendationResult.recommends + vm.userXP.recommendationResult.notRecommends) > 0"><div class="tabs-container"><div class="tabs-left ng-isolate-scope"><ul class="nav nav-tabs" ng-class="{\'nav-stacked\': vertical, \'nav-justified\': justified}"><li ng-class="{ active: tab.active }" ng-repeat="tab in vm.uxpTabs" class="uib-tab" heading="{{ tab.name | translate }}"><a ng-click="vm.selectTab(tab)">{{ tab.name | translate }}</a></li></ul><div class="tab-content"><!-- Courtecy begin --><div class="tab-pane" ng-repeat="tab in vm.uxpTabs" ng-class="{active: tab.active}"><div class="panel-body" style="min-height: 325px"><canvas id="flot-bar" class="chart chart-bar" chart-data="tab.data.result" chart-labels="tab.data.labels" chart-colors="[ vm.showkaseColors,\n                                                                                vm.showkaseColors,\n                                                                                vm.showkaseColors,\n                                                                                vm.showkaseColors,\n                                                                                vm.showkaseColors,\n                                                                                vm.showkaseColors,\n                                                                                vm.showkaseColors,\n                                                                                vm.showkaseColors,\n                                                                                vm.showkaseColors,\n                                                                                vm.showkaseColors]" chart-options="vm.barChartOptions" style="margin-top: 4%"></canvas></div></div></div></div></div></div><div class="col-xs-12 col-sm-5 col-md-5 col-lg-5" ng-if="vm.userXP && (vm.userXP.recommendationResult.recommends + vm.userXP.recommendationResult.notRecommends) > 0"><div class="row"><div donut-chart donut-data="vm.showUpRecommendation" donut-label-color=\'"#000000"\' style="height: 220px" donut-background-color=\'"#ffffff"\' donut-resize="true" donut-colors=\'["#2F0E7F","#bebec1"]\'></div></div><div class="row" style="padding-top: 10%"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="row"><p style="font-family: Humanst521 Lt BT; font-size: 2.0em" align="center"><i class="fa fa-file-text-o primary-color" style="font-size: 1.2em"></i> {{ (vm.userXP.recommendationResult.recommends + vm.userXP.recommendationResult.notRecommends) }}</p></div><div class="row" align="center"><p data-translate="storeRating.userXP.opnionsReceived" align="center" style="font-size: 0.8em; color: #808080; text-align: center"></p></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="row"><p style="font-family: Humanst521 Lt BT; font-size: 2.0em" align="center"><i class="fa fa-male" style="font-size: 1.4em; color: rgb(84, 84, 254)"></i> {{(vm.userXP.malePercentage || 0) | number : 2}}%</p></div><div class="row" align="center"><p data-translate="storeRating.userXP.maleOpnion" align="center" style="font-size: 0.8em; color: #808080; text-align: center"></p></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="row"><p style="font-family: Humanst521 Lt BT; font-size: 2.0em" align="center"><i class="fa fa-female" style="font-size: 1.4em; color: rgb(223, 0, 223)"></i> {{(vm.userXP.femalePercentage || 0 | number : 2)}}%</p></div><div class="row" align="center"><p data-translate="storeRating.userXP.femaleOpnion" align="center" style="font-size: 0.8em; color: #808080; text-align: center"></p></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" align="center"><div style="padding-top: 50px; text-align: center" ng-if="!vm.userXP || (vm.userXP.recommendationResult.recommends + vm.userXP.recommendationResult.notRecommends) == 0"><span class="insufficient-data" data-translate="storeRating.error.noForms"><i>Insufficient data</i></span></div></div></div></div></div></div>');
$templateCache.put('app/admin/settings/payments/component/payment-discount-form-modal.html','<style>.card-item {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 5px 15px 5px 15px;\n        border-radius: 10px;\n        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n    }\n\n    /* CIRCLE PROGRESS */\n    .circle-wrap {\n        margin: 20px 0;\n        width: 60px;\n        height: 60px;\n        background: #2f137e59;\n        border-radius: 50%;\n        border: 1px solid #cdcbd0;\n        padding: 0;\n    }\n\n    .circle-wrap .circle .mask,\n    .circle-wrap .circle .fill {\n        width: 60px;\n        height: 60px;\n        position: absolute;\n        border-radius: 50%;\n    }\n\n    .circle-wrap .circle .mask {\n        clip: rect(0px, 60px, 60px, 30px);\n    }\n\n    .circle-wrap .inside-circle {\n        width: 49px;\n        height: 49px;\n        border-radius: 50%;\n        background: white;\n        line-height: 48px;\n        text-align: center;\n        margin-top: 5px;\n        margin-left: 5px;\n        color: var(--main-color);\n        position: absolute;\n        z-index: 100;\n        font-weight: 700;\n        font-size: 1.2em;\n    }\n\n    /* color animation */\n\n    /* 3rd progress bar */\n    .mask .fill {\n        clip: rect(0px, 30px, 60px, 0px);\n        background-color: var(--main-color);\n    }\n\n    .mask.full, .circle .fill {\n        animation: fill ease-in-out 0.5s;\n        transform: rotate(15deg);\n    }\n\n    .badge-details {\n        color: #5E5E5E;\n        font-size: 14px;\n        font-weight: 400;\n        padding: 6px 7px;\n        text-shadow: none;\n        margin-right: 6px;\n        border-radius: 0;\n        height: 26px;\n    }\n\n    input::-webkit-outer-spin-button,\n\n    input::-webkit-inner-spin-button {\n\n        -webkit-appearance: none;\n        margin: 0;\n    }\n\n    input[type=number] {\n        -moz-appearance: textfield;\n        /* Firefox */\n    }\n\n    .md-virtual-repeat-container.md-autocomplete-suggestions-container {\n        min-height: 42px !important;\n        width: 250px !important;\n    }\n\n    .md-virtual-repeat-container.md-autocomplete-suggestions-container.md-not-found {\n        min-height: 34px !important;\n        width: 250px !important;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    .md-virtual-repeat-container .md-virtual-repeat-sizer {\n        height: 23vh !important;\n    }\n\n    .modal-header {\n        height: 70px;\n        background-image: linear-gradient(to bottom right, #00d8a6, #02a982);\n    }\n\n    .modal-dialog {\n        top: 0;\n        right: 0;\n        width: 520px;\n        position: fixed;\n        padding: 0px;\n        margin: 0px;\n        margin-top: 0 !important;\n    }\n\n    .modal-content {\n        top: 0;\n        margin-top: -1px !important;\n        width: 100% !important;\n        min-height: 100vh !important;\n        padding: 0px;\n        margin: 0px;\n    }\n\n    .modal-footer {\n        position: absolute;\n        bottom: 0px;\n        width:100%;\n        padding:2px !important;\n        height: 100px;\n        box-shadow: 0px -5px 8px -3px rgba(0,0,0,0.1);\n        background-color: #FFFFFF;\n        z-index: 10040;\n    }\n\n    .modal-body {\n        min-height: 100px;\n        max-height: calc(100vh - 150px);\n        overflow-y: auto;\n        width: 100%;\n    }\n\n    .ios-mobile-padding {\n        padding-left: 0px;\n    }\n\n    @media (max-width: 800px) {\n        .modal-dialog {\n            width: 100% !important;\n        }\n\n        .modal-footer {\n            height: 100px;\n        }\n\n        .modal-body {\n            min-height: 100px;\n            max-height: calc(100vh - 170px);\n        }\n    }\n\n    /* CSS specific to iOS devices */\n    @supports (-webkit-overflow-scrolling: touch) {\n        /* Safari and Chrome */\n        .modal-footer {\n            height: 100px;\n        }\n        /* Safari and Chrome */\n        .modal-body {\n            min-height: 190px;\n            max-height: calc(100vh - 170px);\n        }\n\n        .ios-mobile-padding {\n            padding-left: 5px !important;\n        }\n    }\n\n    .modal-title {\n        font-size: 19px;\n        color: #fff;\n        font-weight: 500;\n        font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;\n    }\n\n    .content-title-nps {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n\n    .step-title {\n        font-size: 12px; \n        font-weight: 500;\n    }\n\n    .circle-button-icon {\n        border-radius: 50% !important;\n        border: 1px solid !important;\n        border-color: var(--main-color) !important;\n        color: var(--main-color) !important;\n        min-width: 34px !important;\n        min-height: 34px !important;\n        max-width: 34px !important;\n        max-height: 34px !important;\n    }\n\n    .qualification-content {\n        padding: 0 2% 5% 2%;\n    }\n\n    .cost-box {\n        display: flex;\n        align-items: center;\n        color: var(--main-color-light);\n        background-color: #dfd7ed;\n        border-radius: 5px;\n    }\n\n    .cost-text {\n        font-size: 12px;\n        text-align: justify;\n        opacity: 1;\n        padding: 10px;\n        font-weight: 400;\n    }\n\n    .cost-icon {\n        font-size: xx-large;\n        -moz-transform: scale(-1, 1);\n        -webkit-transform: scale(-1, 1);\n        -o-transform: scale(-1, 1);\n        -ms-transform: scale(-1, 1);\n        transform: scale(-1, 1);\n    }</style><div class="modal-header"><div class="content-title-nps"><div class="row" style="height: 100%"><div class="col-xs-8" style="height: 100%"><p class="modal-title"><span ng-if="!vm.paymentDiscount.id">{{\'settings.store.payments.payment-discount.create-title\' | translate}} </span><span ng-if="vm.paymentDiscount.id">{{\'settings.store.payments.payment-discount.update-title\' | translate}}</span></p></div><div class="col-xs-4" style="height: 100%"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()" style="color: white; opacity: 0.8 !important">&times;</button></div></div></div></div><div class="modal-body qualification-content"><form class="" ng-submit="vm.save()" id="formPaymentDiscount" name="vm.formPaymentDiscount" novalidate role="form"><div class="row" style="width: 100%; height: 100%; margin-left: 0px; padding-top: 15px"><div class="col-md-12 col-xs-12"><div class="cost-box"><i class="icon-ksc-comment-exclamation-regular cost-icon" aria-hidden="true"></i><p class="m-0 cost-text" data-translate="settings.store.payments.payment-discount.min-value-warning"></p></div></div><!-- ################### MIN VALUE ################### --><div ng-if="false" class="row col-md-12 col-xs-12" style="margin-top: 15px; margin-left: 0px; margin-right: 0px"><label for="purchaseValue" data-translate="settings.store.payments.payment-discount.min-value">Valor m\xEDnimo do pedido</label><div class="input-group"><span class="input-group-addon">{{vm.configutaionsPrice.prefix}}</span> <input id="discount" name="discount" ng-model="vm.paymentDiscount.minValue" type="text" class="form-control" placeholder="{{ vm.configutaionsPrice.placeHolder }}" price ng-pattern="vm.regexForValueZero" price-decimal-separator="{{ vm.configutaionsPrice.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.configutaionsPrice.thousandsSeparator || \'.\' }}" price-currency-type="vm.configutaionsPrice.key" price-activated="true" min="0"></div><p class="sub-title-info" style="padding-top: 5px" data-translate="settings.store.payments.payment-discount.min-value-description">Description</p></div><!-- ################### BANK ACCOUNT AND DEFAULT SELLER ################### --><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px; padding-top: 15px"><label class="control-label required" for="bank-acounts" data-translate="settings.store.payments.payment-discount.discount-type">Discount Type</label><select id="bank-accounts" name="bank-account" type="text" class="form-control minimal" ng-model="vm.selectedDiscountType" ng-options="item as item.name for item in vm.discountTypes track by item.key" required></select><p class="sub-title-info" style="padding-top: 5px" data-translate="settings.store.payments.payment-discount.discount-type-description">Description</p></div><!-- ################### DISCOUNT_VALUE ################### --><div class="row col-md-12 col-xs-12" ng-if="vm.selectedDiscountType.key == \'DISCOUNT_VALUE\'" style="margin-left: 0px; margin-right: 0px; padding-top: 15px"><label for="purchaseValue" class="required" data-translate="settings.store.payments.payment-discount.discount-value">Valor do desconto</label><div class="input-group"><span class="input-group-addon">{{vm.configutaionsPrice.prefix }}</span> <input id="discount" name="discount" ng-model="vm.paymentDiscount.discountValue" type="text" class="form-control" placeholder="{{ vm.configutaionsPrice.placeHolder }}" min="0.0" price ng-pattern="vm.regexForValueZero" price-decimal-separator="{{ vm.configutaionsPrice.centsSeparator || \',\' }}" price-thousand-separator="{{ vm.configutaionsPrice.thousandsSeparator || \'.\' }}" price-currency-type="vm.configutaionsPrice.key" price-activated="true" required></div><p class="sub-title-info" style="padding-top: 5px" data-translate="settings.store.payments.payment-discount.discount-value-description">Description</p><div ng-show="vm.formPaymentDiscount.discount.$invalid && vm.formPaymentDiscount.$submitted"><p class="help-block form-invalid-field" ng-show="vm.formPaymentDiscount.discount.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.formPaymentDiscount.discount.$error.pattern" data-translate="entity.validation.min" translate-value-min="0"></p></div></div><!-- ################### PERCENTAGE ################### --><div class="row col-md-12 col-xs-12" ng-if="vm.selectedDiscountType.key == \'PERCENTAGE\'" style="margin-left: 0px; margin-right: 0px; padding-top: 15px"><label for="discount" class="required" data-translate="settings.store.payments.payment-discount.discount-value">Valor do desconto</label><div class="input-group"><input id="discount" name="discount" class="form-control" type="number" required ng-model="vm.paymentDiscount.discountValue" min="0.0" max="100" placeholder="Ex.: 10"> <span class="input-group-addon">%</span></div><p class="sub-title-info" data-translate="settings.store.payments.payment-discount.discount-value-description">Description</p><div ng-show="vm.formPaymentDiscount.discount.$invalid && vm.formPaymentDiscount.$submitted"><p class="help-block form-invalid-field" ng-show="vm.formPaymentDiscount.discount.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.formPaymentDiscount.discount.$error.max" data-translate="entity.validation.max" translate-value-max="100"></p><p class="help-block form-invalid-field" ng-show="vm.formPaymentDiscount.discount.$error.min" data-translate="entity.validation.min" translate-value-min="0"></p></div></div><div class="col-md-12 col-xs-12"><div class="hr-line-dashed"></div></div></div></form></div><div class="modal-footer"><div class="row" style="padding-top: 10px; margin-left: 0px; margin-right: 0px"><div class="col-md-12 col-xs-12" style="padding: 5px 30px 30px 30px"><button id="btnSave" ladda="vm.isSaving" class="btn btn-primary btn-large pull-right" style="width: 100%; background-color: #40AA60; border: none" ng-click="vm.save()" ng-disabled="vm.invoice.notes.length > 1000" data-style="slide-left"><span data-translate="settings.form.button"></span></button></div></div></div>');
$templateCache.put('app/admin/settings/erps/online-retail/modal/online-retail-order-config.html','<style>.card-item {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 5px 15px 5px 15px;\n        border-radius: 10px;\n        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n    }\n\n    /* CIRCLE PROGRESS */\n    .circle-wrap {\n        margin: 20px 0;\n        width: 60px;\n        height: 60px;\n        background: #2f137e59;\n        border-radius: 50%;\n        border: 1px solid #cdcbd0;\n        padding: 0;\n    }\n\n    .circle-wrap .circle .mask,\n    .circle-wrap .circle .fill {\n        width: 60px;\n        height: 60px;\n        position: absolute;\n        border-radius: 50%;\n    }\n\n    .circle-wrap .circle .mask {\n        clip: rect(0px, 60px, 60px, 30px);\n    }\n\n    .circle-wrap .inside-circle {\n        width: 49px;\n        height: 49px;\n        border-radius: 50%;\n        background: white;\n        line-height: 48px;\n        text-align: center;\n        margin-top: 5px;\n        margin-left: 5px;\n        color: var(--main-color);\n        position: absolute;\n        z-index: 100;\n        font-weight: 700;\n        font-size: 1.2em;\n    }\n\n    /* color animation */\n\n    /* 3rd progress bar */\n    .mask .fill {\n        clip: rect(0px, 30px, 60px, 0px);\n        background-color: var(--main-color);\n    }\n\n    .mask.full, .circle .fill {\n        animation: fill ease-in-out 0.5s;\n        transform: rotate(15deg);\n    }\n\n    .badge-details {\n        color: #5E5E5E;\n        font-size: 14px;\n        font-weight: 400;\n        padding: 6px 7px;\n        text-shadow: none;\n        margin-right: 6px;\n        border-radius: 0;\n        height: 26px;\n    }\n\n    input::-webkit-outer-spin-button,\n\n    input::-webkit-inner-spin-button {\n\n        -webkit-appearance: none;\n        margin: 0;\n    }\n\n    input[type=number] {\n        -moz-appearance: textfield;\n        /* Firefox */\n    }\n\n    .md-virtual-repeat-container.md-autocomplete-suggestions-container {\n        min-height: 42px !important;\n        width: 250px !important;\n    }\n\n    .md-virtual-repeat-container.md-autocomplete-suggestions-container.md-not-found {\n        min-height: 34px !important;\n        width: 250px !important;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    .md-virtual-repeat-container .md-virtual-repeat-sizer {\n        height: 23vh !important;\n    }\n\n    .modal-header {\n        height: 70px;\n        background-image: linear-gradient(to bottom right, #00d8a6, #02a982);\n    }\n\n    .modal-dialog {\n        top: 0;\n        right: 0;\n        width: 520px;\n        position: fixed;\n        padding: 0px;\n        margin: 0px;\n        margin-top: 0 !important;\n    }\n\n    .modal-content {\n        top: 0;\n        margin-top: -1px !important;\n        width: 100% !important;\n        min-height: 100vh !important;\n        padding: 0px;\n        margin: 0px;\n    }\n\n    .modal-footer {\n        position: absolute;\n        bottom: 0px;\n        width:100%;\n        padding:2px !important;\n        height: 100px;\n        box-shadow: 0px -5px 8px -3px rgba(0,0,0,0.1);\n        background-color: #FFFFFF;\n        z-index: 10040;\n    }\n\n    .modal-body {\n        min-height: 100px;\n        max-height: calc(100vh - 150px);\n        overflow-y: auto;\n        width: 100%;\n    }\n\n    .ios-mobile-padding {\n        padding-left: 0px;\n    }\n\n    @media (max-width: 800px) {\n        .modal-dialog {\n            width: 100% !important;\n        }\n\n        .modal-footer {\n            height: 100px;\n        }\n\n        .modal-body {\n            min-height: 100px;\n            max-height: calc(100vh - 170px);\n        }\n    }\n\n    /* CSS specific to iOS devices */\n    @supports (-webkit-overflow-scrolling: touch) {\n        /* Safari and Chrome */\n        .modal-footer {\n            height: 100px;\n        }\n        /* Safari and Chrome */\n        .modal-body {\n            min-height: 190px;\n            max-height: calc(100vh - 170px);\n        }\n\n        .ios-mobile-padding {\n            padding-left: 5px !important;\n        }\n    }\n\n    .modal-title {\n        font-size: 19px;\n        color: #fff;\n        font-weight: 500;\n        font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;\n    }\n\n    .content-title-nps {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n\n    .step-title {\n        font-size: 12px; \n        font-weight: 500;\n    }\n\n    .circle-button-icon {\n        border-radius: 50% !important;\n        border: 1px solid !important;\n        border-color: var(--main-color) !important;\n        color: var(--main-color) !important;\n        min-width: 34px !important;\n        min-height: 34px !important;\n        max-width: 34px !important;\n        max-height: 34px !important;\n    }\n\n    .qualification-content {\n        padding: 0 2% 5% 2%;\n    }</style><div class="modal-header"><div class="content-title-nps"><div class="row" style="height: 100%"><div class="col-xs-8" style="height: 100%"><p class="modal-title"><span>{{\'settings.erps.online-retail.modal.order.title\' | translate}}</span></p></div><div class="col-xs-4" style="height: 100%"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()" style="color: white; opacity: 0.8 !important">&times;</button></div></div></div></div><div class="modal-body qualification-content"><div class="row" style="width: 100%; height: 100%; margin-left: 0px; padding-top: 15px"><!-- ################### BANK ACCOUNT AND DEFAULT SELLER ################### --><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><div class="col-md-6 col-xs-6" style="padding-left: 0px"><label class="control-label required" for="bank-acounts" data-translate="settings.erps.online-retail.modal.order.bank-account">Bank Acounts</label><select id="bank-accounts" name="bank-account" type="text" class="form-control minimal" ng-model="vm.selectedBankAccount" ng-disabled="!vm.bankAccounts.length" ng-options="item as item.nome for item in vm.bankAccounts track by item.codigo" required></select></div><div class="col-md-6 col-xs-6" style="padding-left: 0px; padding-right: 0px"><label class="control-label required" for="seller" data-translate="settings.erps.online-retail.modal.order.default-seller">Default Seller</label><select id="seller" name="seller" type="text" class="form-control minimal" ng-model="vm.selectedSeller" ng-disabled="!vm.onlineRetailUsers.length" ng-options="item as item.nome for item in vm.onlineRetailUsers track by item.id" required></select></div></div><div class="col-md-12 col-xs-12"><div class="hr-line-dashed"></div></div><!-- ################### USE SIMULATION ################### --><div class="row col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><label class="control-label" data-translate="settings.erps.online-retail.modal.order.use-simulation" for="useSimulation">Enviar pedido a combinar como or\xE7amento</label><md-switch name="useSimulation" style="margin: 5px 0px 5px 0px; height: 25px" ng-model="vm.config.useSimulation"><span style="line-height: 35px; vertical-align:middle">{{ vm.config.useSimulation ? \'Ativado\' : \'Desativado\'}}</span></md-switch></div><div class="col-md-12 col-xs-12"><div class="hr-line-dashed"></div></div><!-- ################### USER LINK LIST ################### --><div class="col-md-12 col-xs-12"><label class="control-label" for="online-retail-user" data-translate="settings.erps.online-retail.modal.order.step1">Configure Seller Link</label></div><div ng-repeat="userLink in vm.userLinksView track by $index" class="col-md-12 col-xs-12" style="margin-top: 10px; margin-bottom: 10px"><div class="card-item"><div class="col-md-6 col-xs-6" style="padding-left: 0px"><label class="control-label" for="showkase-user" data-translate="settings.erps.online-retail.modal.order.showkase-user">Showkase User</label><input id="showkase-user" name="showkase-user" type="text" class="form-control" ng-disabled="true" ng-model="userLink.showkaseName"></div><div class="col-md-6 col-xs-6" style="padding-left: 0px"><label class="control-label" for="online-retail-user" data-translate="settings.erps.online-retail.modal.order.online-retail-user">Varejo Online User</label><input id="online-retail-user" name="online-retail-user" type="text" class="form-control" ng-disabled="true" ng-model="userLink.onlineRetailName"></div><div style="display: flex; flex-direction: row"><span class="fa fa-trash" style="margin-right: 8px; color: #676a6cd6; font-size: 15px" ng-click="vm.deleteLink(userLink)"></span></div></div></div><!-- ################### USER LINK FORM ################### --><div id="user-link-form" class="col-md-12 col-xs-12" style="margin-top: 10px"><div class="col-md-6 col-xs-6" style="padding-left: 0px"><label class="control-label required" for="showkase-user-select" data-translate="settings.erps.online-retail.modal.order.showkase-user">Showkase User</label><select id="showkase-user-select" name="showkase-user-select" type="text" class="form-control minimal" ng-model="vm.selectedShowkaseUser" ng-disabled="!vm.showkaseUsers.length" ng-options="item as item.fullName for item in vm.showkaseUsers track by item.id" required></select></div><div class="col-md-6 col-xs-6" style="padding-left: 0px; padding-right: 0px"><label class="control-label required" for="online-retail-user" data-translate="settings.erps.online-retail.modal.order.online-retail-user">Varejo Online User</label><select id="online-retail-user" name="online-retail-user" type="text" class="form-control minimal" ng-model="vm.selectedOnlineRetailUser" ng-disabled="!vm.onlineRetailUsers.length" ng-options="item as item.nome for item in vm.onlineRetailUsers track by item.id" required></select></div></div><div class="col-md-12 col-xs-12" style="margin-top: 10px"><button id="add-notification" ladda="vm.isSaving" type="submit" class="btn btn-secondary pull-right" data-translate="settings.erps.online-retail.modal.order.link-users" ng-click="vm.linkUsers()">Link Users</button></div></div></div><div class="modal-footer"><div class="row" style="padding-top: 10px; margin-left: 0px; margin-right: 0px"><div class="col-md-12 col-xs-12" style="padding: 5px 30px 30px 30px"><button id="btnSave" ladda="vm.isSaving" class="btn btn-primary btn-large pull-right" style="width: 100%; background-color: #40AA60; border: none" ng-click="vm.save()" ng-disabled="vm.invoice.notes.length > 1000" data-style="slide-left"><span data-translate="settings.form.button"></span></button></div></div></div>');
$templateCache.put('app/admin/settings/payments/pagarme/modal/add-managing-partner-modal.html','<style>.card-item {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 5px 15px 5px 15px;\n        border-radius: 10px;\n        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n    }\n\n    /* CIRCLE PROGRESS */\n    .circle-wrap {\n        margin: 20px 0;\n        width: 60px;\n        height: 60px;\n        background: #2f137e59;\n        border-radius: 50%;\n        border: 1px solid #cdcbd0;\n        padding: 0;\n    }\n\n    .circle-wrap .circle .mask,\n    .circle-wrap .circle .fill {\n        width: 60px;\n        height: 60px;\n        position: absolute;\n        border-radius: 50%;\n    }\n\n    .circle-wrap .circle .mask {\n        clip: rect(0px, 60px, 60px, 30px);\n    }\n\n    .circle-wrap .inside-circle {\n        width: 49px;\n        height: 49px;\n        border-radius: 50%;\n        background: white;\n        line-height: 48px;\n        text-align: center;\n        margin-top: 5px;\n        margin-left: 5px;\n        color: var(--main-color);\n        position: absolute;\n        z-index: 100;\n        font-weight: 700;\n        font-size: 1.2em;\n    }\n\n    /* color animation */\n\n    /* 3rd progress bar */\n    .mask .fill {\n        clip: rect(0px, 30px, 60px, 0px);\n        background-color: var(--main-color);\n    }\n\n    .mask.full, .circle .fill {\n        animation: fill ease-in-out 0.5s;\n        transform: rotate(15deg);\n    }\n\n    .badge-details {\n        color: #5E5E5E;\n        font-size: 14px;\n        font-weight: 400;\n        padding: 6px 7px;\n        text-shadow: none;\n        margin-right: 6px;\n        border-radius: 0;\n        height: 26px;\n    }\n\n    input::-webkit-outer-spin-button,\n\n    input::-webkit-inner-spin-button {\n\n        -webkit-appearance: none;\n        margin: 0;\n    }\n\n    input[type=number] {\n        -moz-appearance: textfield;\n        /* Firefox */\n    }\n\n    .md-virtual-repeat-container.md-autocomplete-suggestions-container {\n        min-height: 42px !important;\n        width: 250px !important;\n    }\n\n    .md-virtual-repeat-container.md-autocomplete-suggestions-container.md-not-found {\n        min-height: 34px !important;\n        width: 250px !important;\n    }\n\n    html.no-js.ng-scope {\n        overflow: auto !important;\n    }\n\n    .md-virtual-repeat-container .md-virtual-repeat-sizer {\n        height: 23vh !important;\n    }\n\n    .modal-header {\n        height: 70px;\n        background-image: linear-gradient(to bottom right, #00d8a6, #02a982);\n    }\n\n    .modal-dialog {\n        top: 0;\n        right: 0;\n        width: 520px;\n        position: fixed;\n        padding: 0px;\n        margin: 0px;\n        margin-top: 0 !important;\n    }\n\n    .modal-content {\n        top: 0;\n        margin-top: -1px !important;\n        width: 100% !important;\n        min-height: 100vh !important;\n        padding: 0px;\n        margin: 0px;\n    }\n\n    .modal-footer {\n        position: absolute;\n        bottom: 0px;\n        width:100%;\n        padding:2px !important;\n        height: 100px;\n        box-shadow: 0px -5px 8px -3px rgba(0,0,0,0.1);\n        background-color: #FFFFFF;\n        z-index: 10040;\n    }\n\n    .modal-body {\n        min-height: 100px;\n        max-height: calc(100vh - 150px);\n        overflow-y: auto;\n        width: 100%;\n    }\n\n    .ios-mobile-padding {\n        padding-left: 0px;\n    }\n\n    @media (max-width: 800px) {\n        .modal-dialog {\n            width: 100% !important;\n        }\n\n        .modal-footer {\n            height: 100px;\n        }\n\n        .modal-body {\n            min-height: 100px;\n            max-height: calc(100vh - 170px);\n        }\n    }\n\n    /* CSS specific to iOS devices */\n    @supports (-webkit-overflow-scrolling: touch) {\n        /* Safari and Chrome */\n        .modal-footer {\n            height: 100px;\n        }\n        /* Safari and Chrome */\n        .modal-body {\n            min-height: 190px;\n            max-height: calc(100vh - 170px);\n        }\n\n        .ios-mobile-padding {\n            padding-left: 5px !important;\n        }\n    }\n\n    .modal-title {\n        font-size: 19px;\n        color: #fff;\n        font-weight: 500;\n        font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;\n    }\n\n    .content-title-nps {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n\n    .step-title {\n        font-size: 12px; \n        font-weight: 500;\n    }\n\n    .circle-button-icon {\n        border-radius: 50% !important;\n        border: 1px solid !important;\n        border-color: var(--main-color) !important;\n        color: var(--main-color) !important;\n        min-width: 34px !important;\n        min-height: 34px !important;\n        max-width: 34px !important;\n        max-height: 34px !important;\n    }\n\n    .qualification-content {\n        padding: 0 2% 5% 2%;\n    }\n\n    .pac-container {\n        position: fixed !important;\n        z-index: 20 !important;\n    }\n\n    .modal{\n        z-index: 20;   \n    }\n\n    .modal-backdrop{\n        z-index: 10;        \n    }</style><div class="modal-header"><div class="content-title-nps"><div class="row" style="height: 100%"><div class="col-xs-8" style="height: 100%"><p class="modal-title"><span>{{\'settings.store.payments.tabs.pagarMe.form.managing-partner.modal.title\' | translate}}</span></p></div><div class="col-xs-4" style="height: 100%"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()" style="color: white; opacity: 0.8 !important">&times;</button></div></div></div></div><div><form name="vm.partnerForm" ng-if="!vm.isLoading"><div class="modal-body qualification-content"><div class="row" style="width: 100%; height: 100%; margin-left: 0px; padding-top: 15px"><!-- ################### MANAGING PARTNER INFO ################### --><div class="col-md-7 col-xs-12" style="margin-left: 0px; margin-right: 0px"><label class="required" for="partnerName" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.modal.name">Nome Completo</label><input id="partnerName" name="partnerName" type="text" class="form-control" ng-model="vm.partner.name" minlength="4" maxlength="128" required><div ng-show="vm.partnerForm.partnerName.$invalid && vm.partnerForm.partnerName.$touched"><p class="help-block form-invalid-field" ng-show="vm.partnerForm.partnerName.$error.required" data-translate="entity.validation.required"></p><p class="help-block form-invalid-field" ng-show="vm.partnerForm.partnerName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="128"></p><p class="help-block form-invalid-field" ng-show="vm.partnerForm.partnerName.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4"></p></div></div><div class="form-group col-md-5 col-xs-12" style="margin-left: 0px; margin-right: 0px"><label class="required" for="partnerDocument" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.modal.document">CPF</label><input id="partnerDocument" type="text" name="partnerDocument" class="form-control" ng-model="vm.partner.documentNumber" ng-cpf ui-mask="999.999.999-99"><div class="help-block-div" ng-show="vm.partnerForm.partnerDocument.$invalid && vm.partnerForm.partnerDocument.$touched"><p class="help-block form-invalid-field" ng-show="vm.partnerForm.partnerDocument.$invalid" data-translate="entity.validation.cpf">This field CPF is invalid.</p><p class="help-xblock form-invalid-field" ng-show="vm.partnerForm.partnerDocument.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row" style="width: 100%; height: 100%; margin-left: 0px; padding-top: 15px"><!-- ################### MANAGING PARTNER INFO ################### --><div class="col-md-7 col-xs-12" style="margin-left: 0px; margin-right: 0px"><label class="required" for="partnerEmail" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.modal.email">E-mail</label><input id="partnerEmail" name="partnerEmail" type="text" class="form-control" ng-model="vm.partner.email" minlength="4" maxlength="128" required><div ng-if="vm.partnerForm.partnerEmail.$invalid && vm.partnerForm.partnerEmail.$touched"><p class="help-block form-invalid-field" ng-if="vm.partnerForm.partnerEmail.$error.required" data-translate="entity.validation.required"></p></div></div><div class="col-md-5 col-xs-12" style="margin-left: 0px; margin-right: 0px"><label class="required" for="partnerBirthDate" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.modal.birth-date">Birth Date</label><input id="partnerBirthDate" name="partnerBirthDate" type="text" class="form-control" ng-model="vm.partner.birthdate" ui-mask="99/99/9999" model-view-value="true" required><div ng-show="vm.partnerForm.partnerBirthDate.$invalid && vm.partnerForm.partnerBirthDate.$touched"><p class="help-block form-invalid-field" ng-show="vm.partnerForm.partnerBirthDate.$error.required" data-translate="entity.validation.required"></p></div></div></div><div class="row" style="width: 100%; height: 100%; margin-left: 0px; padding-top: 15px"><div class="col-md-7 col-xs-12" style="margin-left: 0px; margin-right: 0px"><label class="required" for="partnerProfessionalOccupation" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.modal.professional-occupation">Professional Occupation</label><select id="partnerProfessionalOccupation" name="partnerProfessionalOccupation" type="text" class="form-control" ng-model="vm.partner.professionalOccupation"><option ng-repeat="occupation in vm.occupations" ng-value="occupation">{{ occupation }}</option></select></div><div class="col-md-5 col-xs-12" style="margin-left: 0px; margin-right: 0px"><label class="required" for="partnerMonthlyIncome" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.modal.monthly-income">Monthly Income</label><input id="partnerMonthlyIncome" name="partnerMonthlyIncome" type="text" class="form-control" price price-decimal-separator="{{ \',\' }}" price-thousand-separator="{{ \'.\' }}" price-currency-type="vm.flyer.currencyInstance.key" price-activated="true" ng-model="vm.partner.monthlyIncome" required><div ng-if="vm.partnerForm.partnerMonthlyIncome.$invalid && vm.partnerForm.partnerMonthlyIncome.$touched"><p class="help-block form-invalid-field" ng-show="vm.partnerForm.partnerMonthlyIncome.$error.required" data-translate="entity.validation.required"></p></div></div></div><div class="row" style="width: 100%; height: 100%; margin-left: 0px; padding-top: 15px"><div class="form-group col-md-7 col-sm-12 col-xs-12" style="margin-left: 0px; margin-right: 0px"><label for="mothersName" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.modal.mother-name">Mother\'s Name</label><input id="mothersName" name="mothersName" type="text" class="form-control" ng-model="vm.partner.motherName"></div><div class="form-group col-md-5 col-sm-12 col-xs-12"><label class="required" for="partnerPhone" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.modal.phone">Phone Number</label><input type="tel" name="partnerPhone" id="partnerPhone" class="form-control" ng-model="vm.partner.phoneNumber" ng-maxlength="30" ng-minlength="4" intl-tel-input required><div ng-if="vm.partnerForm.partnerPhone.$invalid && vm.partnerForm.partnerPhone.$touched"><p class="help-block form-invalid-field" ng-if="vm.partnerForm.partnerPhone.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block form-invalid-field" ng-if="vm.partnerForm.partnerPhone.$error.phoneNumber" data-translate="entity.validation.phoneNumber">Number invalid.</p></div></div></div><div class="col-md-12 col-xs-12"><div class="hr-line-dashed"></div></div><!-- <div class="row" style="width: 100%; height: 100%; margin-left: 0px; padding-top: 15px;">\n                <div class="col-md-12 col-xs-12" style="margin-left: 0px; margin-right: 0px;">\n                    <label for="autocomplete" \n                        data-translate="settings.store.payments.tabs.pagarMe.form.address.search-address">\n                        Search Address\n                    </label>\n                    <input id="autocomplete" name="autocomplete" type="text" class="form-control"\n                        placeholder="{{\'settings.store.payments.tabs.pagarMe.form.address.placeholder\' | translate}}" />\n                </div>\n            </div> --><div class="row" style="width: 100%; height: 100%; margin-left: 0px; padding-top: 15px"><div class="form-group col-md-7"><label class="required" for="partnerStreet" data-translate="settings.store.payments.tabs.pagarMe.form.address.street">Street</label><input id="partnerStreet" name="partnerStreet" type="text" class="form-control" ng-model="vm.partner.address.street" required><div ng-if="vm.partnerForm.partnerStreet.$invalid && vm.partnerForm.partnerStreet.$touched"><p class="help-block form-invalid-field" ng-show="vm.partnerForm.partnerStreet.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-md-5"><label class="required" for="partnerStreetNumber" data-translate="settings.store.payments.tabs.pagarMe.form.address.street-number">Street Number</label><input id="partnerStreetNumber" name="partnerStreetNumber" type="text" class="form-control" ng-model="vm.partner.address.streetNumber" required><div ng-if="vm.partnerForm.partnerStreetNumber.$invalid && vm.partnerForm.partnerStreetNumber.$touched"><p class="help-block form-invalid-field" ng-show="vm.partnerForm.partnerStreetNumber.$error.required" data-translate="entity.validation.required"></p></div></div></div><div class="row" style="width: 100%; height: 100%; margin-left: 0px; padding-top: 15px"><div class="form-group col-md-7"><label class="required" for="partnerNeighborhood" data-translate="settings.store.payments.tabs.pagarMe.form.address.neighborhood">Neighborhood</label><input id="partnerNeighborhood" name="partnerNeighborhood" type="text" class="form-control" ng-model="vm.partner.address.neighborhood" required><div ng-if="vm.partnerForm.partnerNeighborhood.$invalid && vm.partnerForm.partnerNeighborhood.$touched"><p class="help-block form-invalid-field" ng-if="vm.pagarmeForm.partnerNeighborhood.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-md-5"><label class="required" for="partnerCity" data-translate="settings.store.payments.tabs.pagarMe.form.address.city">City</label><input id="partnerCity" name="partnerCity" type="text" class="form-control" ng-model="vm.partner.address.city" required><div ng-if="vm.partnerForm.partnerCity.$invalid && vm.partnerForm.partnerCity.$touched"><p class="help-block form-invalid-field" ng-if="vm.pagarmeForm.partnerCity.$error.required" data-translate="entity.validation.required"></p></div></div></div><div class="row" style="width: 100%; height: 100%; margin-left: 0px; padding-top: 15px"><div class="form-group col-md-7"><label class="required" for="partnerState" data-translate="settings.store.payments.tabs.pagarMe.form.address.state">State</label><input id="partnerState" name="partnerState" type="text" class="form-control" ng-model="vm.partner.address.state" required><div ng-if="vm.partnerForm.partnerState.$invalid && vm.partnerForm.partnerState.$touched"><p class="help-block form-invalid-field" ng-if="vm.pagarmeForm.partnerState.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-md-5"><label class="required" for="partnerPostalCode" data-translate="settings.store.payments.tabs.pagarMe.form.address.postal-code">Postal Code</label><input id="partnerPostalCode" name="partnerPostalCode" type="text" class="form-control" ng-model="vm.partner.address.zipcode" required><div ng-if="vm.partnerForm.partnerPostalCode.$invalid && vm.partnerForm.partnerPostalCode.$touched"><p class="help-block form-invalid-field" ng-if="vm.pagarmeForm.partnerPostalCode.$error.required" data-translate="entity.validation.required"></p></div></div></div><div class="row" style="width: 100%; height: 100%; margin-left: 0px; padding-top: 15px"><div class="form-group col-md-7"><label class="required" for="partnerReferencePoint" data-translate="settings.store.payments.tabs.pagarMe.form.address.reference-point">Reference Point</label><input id="partnerReferencePoint" name="partnerReferencePoint" type="text" class="form-control" ng-model="vm.partner.address.referencePoint" required><div ng-if="vm.partnerForm.partnerReferencePoint.$invalid && vm.partnerForm.partnerReferencePoint.$touched"><p class="help-block form-invalid-field" ng-if="vm.pagarmeForm.partnerReferencePoint.$error.required" data-translate="entity.validation.required"></p></div></div><div class="form-group col-md-5"><label class="required" for="partnerComplementary" data-translate="settings.store.payments.tabs.pagarMe.form.address.complementary">Complementary</label><input id="partnerComplementary" name="partnerComplementary" type="text" class="form-control" ng-model="vm.partner.address.complementary" required><div ng-if="vm.partnerForm.partnerComplementary.$invalid && vm.partnerForm.partnerComplementary.$touched"><p class="help-block form-invalid-field" ng-if="vm.pagarmeForm.partnerComplementary.$error.required" data-translate="entity.validation.required"></p></div></div></div></div><div class="modal-footer"><div class="row" style="padding-top: 10px; margin-left: 0px; margin-right: 0px"><div class="col-md-12 col-xs-12" style="padding: 5px 30px 30px 30px"><button id="addPartner" ladda="vm.isSaving" class="btn btn-primary btn-large pull-right" style="width: 100%; background-color: #40AA60; border: none" ng-click="vm.addPartner()" ng-disabled="vm.partnerForm.$invalid" data-style="slide-left"><span ng-if="vm.isNew" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.modal.add-button"></span> <span ng-if="!vm.isNew" data-translate="settings.store.payments.tabs.pagarMe.form.managing-partner.modal.update-button"></span></button></div></div></div></form></div>');}]);})();